/* Reconstructed from tenant.zip:public/build/assets/app-CWh9yNuH.js
 * Original SHA-256: 13ca805099f7d0b5a0b78eb92d833910ac760d0469364ae9acd2d3104dbdd70c
 * Surviving compiled logic, formatted and relinked. Original templates/comments/names are not recovered.
 */
const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "assets/quill-Dw7DRXoa.js",
      "assets/chunk-CMxvf4Kt.js",
      "assets/dist-BHTm9mRt.js",
      "assets/dist-B86vIM39.js",
      "assets/dist-C7NILHbe.js",
      "assets/dist-BCGhswWy.js",
      "assets/dist-CgR59kzp.js",
      "assets/dist-BnExsOzA.js",
      "assets/dist-BPgSlZZh.js",
      "assets/dist-zKP_9Fpk.js",
      "assets/dist-C8ah73Ed.js",
      "assets/dist-DUBj8vdQ.js",
      "assets/dist-Dog7Phzw.js",
      "assets/dist-DFZKKcvO.js",
      "assets/dist-Cgaq9sOu.js",
      "assets/dist-DwP782HL.js",
      "assets/dist-DZAkyC3_.js",
      "assets/dist-DolrrU4k.js",
      "assets/dockerfile-BLkNEvjs.js",
      "assets/simple-mode-DRpGK0lJ.js",
      "assets/factor-D7LVTn2l.js",
      "assets/nsis-AQ_alPln.js",
      "assets/pug-DyBTKFx8.js",
      "assets/javascript-8HiN0ThV.js",
      "assets/dist-d0Z8CVh5.js",
      "assets/dist-DC_FRNuJ.js",
    ]),
) => i.map((i) => d[i]);
import {
  a as e,
  i as t,
  n,
  o as r,
  r as i,
  t as a,
} from "../recovered/app/assets/chunk-CMxvf4Kt.js";
import { t as o } from "../recovered/app/assets/utils-DEEYWRUN.js";
import {
  _ as s,
  a as c,
  c as l,
  d as u,
  f as d,
  h as f,
  i as p,
  l as m,
  m as h,
  o as g,
  p as v,
  r as y,
  s as b,
  t as x,
  u as S,
  v as C,
} from "../recovered/app/assets/stores-CB9UySvc.js";
import {
  $ as w,
  At as T,
  B as E,
  C as D,
  Ct as ee,
  D as te,
  Dt as O,
  E as k,
  F as ne,
  G as re,
  H as A,
  I as ie,
  J as j,
  K as ae,
  L as oe,
  M as se,
  N as ce,
  O as le,
  Ot as ue,
  P as de,
  Q as fe,
  R as pe,
  S as M,
  St as me,
  T as N,
  Tt as P,
  U as he,
  W as ge,
  X as _e,
  Y as ve,
  _ as ye,
  _t as F,
  a as be,
  at as I,
  b as L,
  bt as xe,
  c as Se,
  ct as Ce,
  d as we,
  et as Te,
  f as Ee,
  g as De,
  gt as Oe,
  h as ke,
  ht as Ae,
  i as je,
  it as Me,
  j as R,
  k as Ne,
  kt as Pe,
  m as Fe,
  mt as Ie,
  n as Le,
  ot as Re,
  p as ze,
  pt as Be,
  q as z,
  r as Ve,
  rt as He,
  s as Ue,
  st as We,
  t as B,
  tt as Ge,
  u as Ke,
  ut as qe,
  v as V,
  vt as Je,
  w as H,
  wt as Ye,
  x as U,
  xt as Xe,
  y as W,
  yt as Ze,
  z as Qe,
} from "../recovered/app/assets/vue.esm-bundler-B5vgcGJL.js";
import { n as $e } from "../recovered/app/assets/vuex.esm-bundler-DJRHx7fM.js";
import { t as et } from "../recovered/app/assets/array-FrBPf9mT.js";
import {
  $ as tt,
  A as nt,
  B as rt,
  C as it,
  Ct as at,
  D as ot,
  E as st,
  F as ct,
  G as lt,
  H as ut,
  I as dt,
  J as ft,
  K as pt,
  L as mt,
  M as ht,
  N as G,
  O as gt,
  P as _t,
  Q as vt,
  R as yt,
  S as bt,
  St as xt,
  T as St,
  Tt as Ct,
  U as wt,
  V as Tt,
  W as Et,
  X as Dt,
  Y as Ot,
  Z as kt,
  _ as At,
  _t as jt,
  a as Mt,
  at as Nt,
  b as Pt,
  bt as Ft,
  c as It,
  ct as Lt,
  d as Rt,
  dt as zt,
  et as Bt,
  f as Vt,
  ft as Ht,
  g as Ut,
  gt as Wt,
  h as Gt,
  ht as Kt,
  i as qt,
  it as Jt,
  j as Yt,
  k as Xt,
  l as Zt,
  lt as Qt,
  m as $t,
  mt as en,
  n as tn,
  nt as nn,
  o as rn,
  ot as an,
  p as on,
  pt as sn,
  q as cn,
  r as ln,
  rt as un,
  s as dn,
  st as fn,
  t as pn,
  tt as mn,
  u as hn,
  ut as gn,
  v as _n,
  vt as vn,
  w as yn,
  wt as bn,
  x as xn,
  xt as Sn,
  y as Cn,
  yt as wn,
  z as Tn,
} from "../recovered/app/assets/dist-B86vIM39.js";
var En = r(
  a((e, t) => {
    (function (n, r) {
      typeof e == `object` && typeof t == `object`
        ? (t.exports = r())
        : typeof define == `function` && define.amd
          ? define([], r)
          : typeof e == `object`
            ? (e.Pusher = r())
            : (n.Pusher = r());
    })(self, () =>
      (() => {
        var e = {
            594(e, t) {
              var n =
                (this && this.__extends) ||
                (function () {
                  var e = function (t, n) {
                    return (
                      (e =
                        Object.setPrototypeOf ||
                        ({
                          __proto__: [],
                        } instanceof Array &&
                          function (e, t) {
                            e.__proto__ = t;
                          }) ||
                        function (e, t) {
                          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                        }),
                      e(t, n)
                    );
                  };
                  return function (t, n) {
                    e(t, n);
                    function r() {
                      this.constructor = t;
                    }
                    t.prototype =
                      n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                  };
                })();
              Object.defineProperty(t, "__esModule", {
                value: !0,
              });
              var r = 256,
                i = (function () {
                  function e(e) {
                    (e === void 0 && (e = `=`), (this._paddingCharacter = e));
                  }
                  return (
                    (e.prototype.encodedLength = function (e) {
                      return this._paddingCharacter
                        ? (((e + 2) / 3) * 4) | 0
                        : ((e * 8 + 5) / 6) | 0;
                    }),
                    (e.prototype.encode = function (e) {
                      for (var t = ``, n = 0; n < e.length - 2; n += 3) {
                        var r = (e[n] << 16) | (e[n + 1] << 8) | e[n + 2];
                        ((t += this._encodeByte((r >>> 18) & 63)),
                          (t += this._encodeByte((r >>> 12) & 63)),
                          (t += this._encodeByte((r >>> 6) & 63)),
                          (t += this._encodeByte((r >>> 0) & 63)));
                      }
                      var i = e.length - n;
                      if (i > 0) {
                        var r = (e[n] << 16) | (i === 2 ? e[n + 1] << 8 : 0);
                        ((t += this._encodeByte((r >>> 18) & 63)),
                          (t += this._encodeByte((r >>> 12) & 63)),
                          i === 2
                            ? (t += this._encodeByte((r >>> 6) & 63))
                            : (t += this._paddingCharacter || ``),
                          (t += this._paddingCharacter || ``));
                      }
                      return t;
                    }),
                    (e.prototype.maxDecodedLength = function (e) {
                      return this._paddingCharacter ? ((e / 4) * 3) | 0 : ((e * 6 + 7) / 8) | 0;
                    }),
                    (e.prototype.decodedLength = function (e) {
                      return this.maxDecodedLength(e.length - this._getPaddingLength(e));
                    }),
                    (e.prototype.decode = function (e) {
                      if (e.length === 0) return new Uint8Array();
                      for (
                        var t = this._getPaddingLength(e),
                          n = e.length - t,
                          i = new Uint8Array(this.maxDecodedLength(n)),
                          a = 0,
                          o = 0,
                          s = 0,
                          c = 0,
                          l = 0,
                          u = 0,
                          d = 0;
                        o < n - 4;
                        o += 4
                      )
                        ((c = this._decodeChar(e.charCodeAt(o + 0))),
                          (l = this._decodeChar(e.charCodeAt(o + 1))),
                          (u = this._decodeChar(e.charCodeAt(o + 2))),
                          (d = this._decodeChar(e.charCodeAt(o + 3))),
                          (i[a++] = (c << 2) | (l >>> 4)),
                          (i[a++] = (l << 4) | (u >>> 2)),
                          (i[a++] = (u << 6) | d),
                          (s |= c & r),
                          (s |= l & r),
                          (s |= u & r),
                          (s |= d & r));
                      if (
                        (o < n - 1 &&
                          ((c = this._decodeChar(e.charCodeAt(o))),
                          (l = this._decodeChar(e.charCodeAt(o + 1))),
                          (i[a++] = (c << 2) | (l >>> 4)),
                          (s |= c & r),
                          (s |= l & r)),
                        o < n - 2 &&
                          ((u = this._decodeChar(e.charCodeAt(o + 2))),
                          (i[a++] = (l << 4) | (u >>> 2)),
                          (s |= u & r)),
                        o < n - 3 &&
                          ((d = this._decodeChar(e.charCodeAt(o + 3))),
                          (i[a++] = (u << 6) | d),
                          (s |= d & r)),
                        s !== 0)
                      )
                        throw Error(`Base64Coder: incorrect characters for decoding`);
                      return i;
                    }),
                    (e.prototype._encodeByte = function (e) {
                      var t = e;
                      return (
                        (t += 65),
                        (t += ((25 - e) >>> 8) & 6),
                        (t += ((51 - e) >>> 8) & -75),
                        (t += ((61 - e) >>> 8) & -15),
                        (t += ((62 - e) >>> 8) & 3),
                        String.fromCharCode(t)
                      );
                    }),
                    (e.prototype._decodeChar = function (e) {
                      var t = r;
                      return (
                        (t += (((42 - e) & (e - 44)) >>> 8) & (-r + e - 43 + 62)),
                        (t += (((46 - e) & (e - 48)) >>> 8) & (-r + e - 47 + 63)),
                        (t += (((47 - e) & (e - 58)) >>> 8) & (-r + e - 48 + 52)),
                        (t += (((64 - e) & (e - 91)) >>> 8) & (-r + e - 65 + 0)),
                        (t += (((96 - e) & (e - 123)) >>> 8) & (-r + e - 97 + 26)),
                        t
                      );
                    }),
                    (e.prototype._getPaddingLength = function (e) {
                      var t = 0;
                      if (this._paddingCharacter) {
                        for (var n = e.length - 1; n >= 0 && e[n] === this._paddingCharacter; n--)
                          t++;
                        if (e.length < 4 || t > 2) throw Error(`Base64Coder: incorrect padding`);
                      }
                      return t;
                    }),
                    e
                  );
                })();
              t.Coder = i;
              var a = new i();
              function o(e) {
                return a.encode(e);
              }
              t.encode = o;
              function s(e) {
                return a.decode(e);
              }
              t.decode = s;
              var c = (function (e) {
                n(t, e);
                function t() {
                  return (e !== null && e.apply(this, arguments)) || this;
                }
                return (
                  (t.prototype._encodeByte = function (e) {
                    var t = e;
                    return (
                      (t += 65),
                      (t += ((25 - e) >>> 8) & 6),
                      (t += ((51 - e) >>> 8) & -75),
                      (t += ((61 - e) >>> 8) & -13),
                      (t += ((62 - e) >>> 8) & 49),
                      String.fromCharCode(t)
                    );
                  }),
                  (t.prototype._decodeChar = function (e) {
                    var t = r;
                    return (
                      (t += (((44 - e) & (e - 46)) >>> 8) & (-r + e - 45 + 62)),
                      (t += (((94 - e) & (e - 96)) >>> 8) & (-r + e - 95 + 63)),
                      (t += (((47 - e) & (e - 58)) >>> 8) & (-r + e - 48 + 52)),
                      (t += (((64 - e) & (e - 91)) >>> 8) & (-r + e - 65 + 0)),
                      (t += (((96 - e) & (e - 123)) >>> 8) & (-r + e - 97 + 26)),
                      t
                    );
                  }),
                  t
                );
              })(i);
              t.URLSafeCoder = c;
              var l = new c();
              function u(e) {
                return l.encode(e);
              }
              t.encodeURLSafe = u;
              function d(e) {
                return l.decode(e);
              }
              ((t.decodeURLSafe = d),
                (t.encodedLength = function (e) {
                  return a.encodedLength(e);
                }),
                (t.maxDecodedLength = function (e) {
                  return a.maxDecodedLength(e);
                }),
                (t.decodedLength = function (e) {
                  return a.decodedLength(e);
                }));
            },
            978(e, t) {
              var n = `utf8: invalid source encoding`;
              function r(e) {
                for (var t = [], r = 0; r < e.length; r++) {
                  var i = e[r];
                  if (i & 128) {
                    var a = void 0;
                    if (i < 224) {
                      if (r >= e.length) throw Error(n);
                      var o = e[++r];
                      if ((o & 192) != 128) throw Error(n);
                      ((i = ((i & 31) << 6) | (o & 63)), (a = 128));
                    } else if (i < 240) {
                      if (r >= e.length - 1) throw Error(n);
                      var o = e[++r],
                        s = e[++r];
                      if ((o & 192) != 128 || (s & 192) != 128) throw Error(n);
                      ((i = ((i & 15) << 12) | ((o & 63) << 6) | (s & 63)), (a = 2048));
                    } else if (i < 248) {
                      if (r >= e.length - 2) throw Error(n);
                      var o = e[++r],
                        s = e[++r],
                        c = e[++r];
                      if ((o & 192) != 128 || (s & 192) != 128 || (c & 192) != 128) throw Error(n);
                      ((i = ((i & 15) << 18) | ((o & 63) << 12) | ((s & 63) << 6) | (c & 63)),
                        (a = 65536));
                    } else throw Error(n);
                    if (i < a || (i >= 55296 && i <= 57343)) throw Error(n);
                    if (i >= 65536) {
                      if (i > 1114111) throw Error(n);
                      ((i -= 65536),
                        t.push(String.fromCharCode(55296 | (i >> 10))),
                        (i = 56320 | (i & 1023)));
                    }
                  }
                  t.push(String.fromCharCode(i));
                }
                return t.join(``);
              }
              t.D4 = r;
            },
            721(e, t, n) {
              e.exports = n(207).default;
            },
            207(e, t, n) {
              n.d(t, {
                default: () => gn,
              });
              class r {
                constructor(e, t) {
                  ((this.lastId = 0), (this.prefix = e), (this.name = t));
                }
                create(e) {
                  this.lastId++;
                  var t = this.lastId,
                    n = this.prefix + t,
                    r = this.name + `[` + t + `]`,
                    i = !1,
                    a = function () {
                      i ||= (e.apply(null, arguments), !0);
                    };
                  return (
                    (this[t] = a),
                    {
                      number: t,
                      id: n,
                      name: r,
                      callback: a,
                    }
                  );
                }
                remove(e) {
                  delete this[e.number];
                }
              }
              var i = new r(`_pusher_script_`, `Pusher.ScriptReceivers`);
              let a = {
                VERSION: `8.5.0`,
                PROTOCOL: 7,
                wsPort: 80,
                wssPort: 443,
                wsPath: ``,
                httpHost: `sockjs.pusher.com`,
                httpPort: 80,
                httpsPort: 443,
                httpPath: `/pusher`,
                stats_host: `stats.pusher.com`,
                authEndpoint: `/pusher/auth`,
                authTransport: `ajax`,
                activityTimeout: 12e4,
                pongTimeout: 3e4,
                unavailableTimeout: 1e4,
                userAuthentication: {
                  endpoint: `/pusher/user-auth`,
                  transport: `ajax`,
                },
                channelAuthorization: {
                  endpoint: `/pusher/auth`,
                  transport: `ajax`,
                },
                cdn_http: `http://js.pusher.com`,
                cdn_https: `https://js.pusher.com`,
                dependency_suffix: ``,
              };
              class o {
                constructor(e) {
                  ((this.options = e), (this.receivers = e.receivers || i), (this.loading = {}));
                }
                load(e, t, n) {
                  var r = this;
                  if (r.loading[e] && r.loading[e].length > 0) r.loading[e].push(n);
                  else {
                    r.loading[e] = [n];
                    var i = zt.createScriptRequest(r.getPath(e, t)),
                      a = r.receivers.create(function (t) {
                        if ((r.receivers.remove(a), r.loading[e])) {
                          var n = r.loading[e];
                          delete r.loading[e];
                          for (
                            var o = function (e) {
                                e || i.cleanup();
                              },
                              s = 0;
                            s < n.length;
                            s++
                          )
                            n[s](t, o);
                        }
                      });
                    i.send(a);
                  }
                }
                getRoot(e) {
                  var t,
                    n = zt.getDocument().location.protocol;
                  return (
                    (t =
                      (e && e.useTLS) || n === `https:`
                        ? this.options.cdn_https
                        : this.options.cdn_http),
                    t.replace(/\/*$/, ``) + `/` + this.options.version
                  );
                }
                getPath(e, t) {
                  return this.getRoot(t) + `/` + e + this.options.suffix + `.js`;
                }
              }
              var s = new r(`_pusher_dependencies`, `Pusher.DependenciesReceivers`),
                c = new o({
                  cdn_http: a.cdn_http,
                  cdn_https: a.cdn_https,
                  version: a.VERSION,
                  suffix: a.dependency_suffix,
                  receivers: s,
                });
              let l = {
                  baseUrl: `https://pusher.com`,
                  urls: {
                    authenticationEndpoint: {
                      path: `/docs/channels/server_api/authenticating_users`,
                    },
                    authorizationEndpoint: {
                      path: `/docs/channels/server_api/authorizing-users/`,
                    },
                    javascriptQuickStart: {
                      path: `/docs/javascript_quick_start`,
                    },
                    triggeringClientEvents: {
                      path: `/docs/client_api_guide/client_events#trigger-events`,
                    },
                    encryptedChannelSupport: {
                      fullUrl: `https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support`,
                    },
                  },
                },
                u = {
                  buildLogSuffix: function (e) {
                    let t = l.urls[e];
                    if (!t) return ``;
                    let n;
                    return (
                      t.fullUrl ? (n = t.fullUrl) : t.path && (n = l.baseUrl + t.path),
                      n ? `See: ${n}` : ``
                    );
                  },
                };
              var d;
              (function (e) {
                ((e.UserAuthentication = `user-authentication`),
                  (e.ChannelAuthorization = `channel-authorization`));
              })((d ||= {}));
              class f extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class p extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class m extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class h extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class g extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class v extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class y extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class b extends Error {
                constructor(e) {
                  (super(e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              class x extends Error {
                constructor(e, t) {
                  (super(t), (this.status = e), Object.setPrototypeOf(this, new.target.prototype));
                }
              }
              let S = function (e, t, n, r, i) {
                let a = zt.createXHR();
                for (var o in (a.open(`POST`, n.endpoint, !0),
                a.setRequestHeader(`Content-Type`, `application/x-www-form-urlencoded`),
                n.headers))
                  a.setRequestHeader(o, n.headers[o]);
                if (n.headersProvider != null) {
                  let e = n.headersProvider();
                  for (var o in e) a.setRequestHeader(o, e[o]);
                }
                return (
                  (a.onreadystatechange = function () {
                    if (a.readyState === 4)
                      if (a.status === 200) {
                        let e,
                          t = !1;
                        try {
                          ((e = JSON.parse(a.responseText)), (t = !0));
                        } catch {
                          i(
                            new x(
                              200,
                              `JSON returned from ${r.toString()} endpoint was invalid, yet status code was 200. Data was: ${a.responseText}`,
                            ),
                            null,
                          );
                        }
                        t && i(null, e);
                      } else {
                        let e = ``;
                        switch (r) {
                          case d.UserAuthentication:
                            e = u.buildLogSuffix(`authenticationEndpoint`);
                            break;
                          case d.ChannelAuthorization:
                            e = `Clients must be authorized to join private or presence channels. ${u.buildLogSuffix(`authorizationEndpoint`)}`;
                            break;
                        }
                        i(
                          new x(
                            a.status,
                            `Unable to retrieve auth string from ${r.toString()} endpoint - received status: ${a.status} from ${n.endpoint}. ${e}`,
                          ),
                          null,
                        );
                      }
                  }),
                  a.send(t),
                  a
                );
              };
              function C(e) {
                return ne(O(e));
              }
              for (
                var w = String.fromCharCode,
                  T = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/`,
                  E = {},
                  D = 0,
                  ee = T.length;
                D < ee;
                D++
              )
                E[T.charAt(D)] = D;
              var te = function (e) {
                  var t = e.charCodeAt(0);
                  return t < 128
                    ? e
                    : t < 2048
                      ? w(192 | (t >>> 6)) + w(128 | (t & 63))
                      : w(224 | ((t >>> 12) & 15)) + w(128 | ((t >>> 6) & 63)) + w(128 | (t & 63));
                },
                O = function (e) {
                  return e.replace(/[^\x00-\x7F]/g, te);
                },
                k = function (e) {
                  var t = [0, 2, 1][e.length % 3],
                    n =
                      (e.charCodeAt(0) << 16) |
                      ((e.length > 1 ? e.charCodeAt(1) : 0) << 8) |
                      (e.length > 2 ? e.charCodeAt(2) : 0);
                  return [
                    T.charAt(n >>> 18),
                    T.charAt((n >>> 12) & 63),
                    t >= 2 ? `=` : T.charAt((n >>> 6) & 63),
                    t >= 1 ? `=` : T.charAt(n & 63),
                  ].join(``);
                },
                ne =
                  window.btoa ||
                  function (e) {
                    return e.replace(/[\s\S]{1,3}/g, k);
                  };
              class re {
                constructor(e, t, n, r) {
                  ((this.clear = t),
                    (this.timer = e(() => {
                      this.timer &&= r(this.timer);
                    }, n)));
                }
                isRunning() {
                  return this.timer !== null;
                }
                ensureAborted() {
                  this.timer &&= (this.clear(this.timer), null);
                }
              }
              let A = re;
              function ie(e) {
                window.clearTimeout(e);
              }
              function j(e) {
                window.clearInterval(e);
              }
              class ae extends A {
                constructor(e, t) {
                  super(setTimeout, ie, e, function (e) {
                    return (t(), null);
                  });
                }
              }
              class oe extends A {
                constructor(e, t) {
                  super(setInterval, j, e, function (e) {
                    return (t(), e);
                  });
                }
              }
              let se = {
                now() {
                  return Date.now ? Date.now() : new Date().valueOf();
                },
                defer(e) {
                  return new ae(0, e);
                },
                method(e, ...t) {
                  var n = Array.prototype.slice.call(arguments, 1);
                  return function (t) {
                    return t[e].apply(t, n.concat(arguments));
                  };
                },
              };
              function ce(e, ...t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  for (var i in r)
                    r[i] && r[i].constructor && r[i].constructor === Object
                      ? (e[i] = ce(e[i] || {}, r[i]))
                      : (e[i] = r[i]);
                }
                return e;
              }
              function le() {
                for (var e = [`Pusher`], t = 0; t < arguments.length; t++)
                  typeof arguments[t] == `string` ? e.push(arguments[t]) : e.push(I(arguments[t]));
                return e.join(` : `);
              }
              function ue(e, t) {
                var n = Array.prototype.indexOf;
                if (e === null) return -1;
                if (n && e.indexOf === n) return e.indexOf(t);
                for (var r = 0, i = e.length; r < i; r++) if (e[r] === t) return r;
                return -1;
              }
              function de(e, t) {
                for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t(e[n], n, e);
              }
              function fe(e) {
                var t = [];
                return (
                  de(e, function (e, n) {
                    t.push(n);
                  }),
                  t
                );
              }
              function pe(e) {
                var t = [];
                return (
                  de(e, function (e) {
                    t.push(e);
                  }),
                  t
                );
              }
              function M(e, t, n) {
                for (var r = 0; r < e.length; r++) t.call(n || window, e[r], r, e);
              }
              function me(e, t) {
                for (var n = [], r = 0; r < e.length; r++) n.push(t(e[r], r, e, n));
                return n;
              }
              function N(e, t) {
                var n = {};
                return (
                  de(e, function (e, r) {
                    n[r] = t(e);
                  }),
                  n
                );
              }
              function P(e, t) {
                t ||= function (e) {
                  return !!e;
                };
                for (var n = [], r = 0; r < e.length; r++) t(e[r], r, e, n) && n.push(e[r]);
                return n;
              }
              function he(e, t) {
                var n = {};
                return (
                  de(e, function (r, i) {
                    ((t && t(r, i, e, n)) || r) && (n[i] = r);
                  }),
                  n
                );
              }
              function ge(e) {
                var t = [];
                return (
                  de(e, function (e, n) {
                    t.push([n, e]);
                  }),
                  t
                );
              }
              function _e(e, t) {
                for (var n = 0; n < e.length; n++) if (t(e[n], n, e)) return !0;
                return !1;
              }
              function ve(e, t) {
                for (var n = 0; n < e.length; n++) if (!t(e[n], n, e)) return !1;
                return !0;
              }
              function ye(e) {
                return N(e, function (e) {
                  return (typeof e == `object` && (e = I(e)), encodeURIComponent(C(e.toString())));
                });
              }
              function F(e) {
                return me(
                  ge(
                    ye(
                      he(e, function (e) {
                        return e !== void 0;
                      }),
                    ),
                  ),
                  se.method(`join`, `=`),
                ).join(`&`);
              }
              function be(e) {
                var t = [],
                  n = [];
                return (function e(r, i) {
                  var a, o, s;
                  switch (typeof r) {
                    case `object`:
                      if (!r) return null;
                      for (a = 0; a < t.length; a += 1)
                        if (t[a] === r)
                          return {
                            $ref: n[a],
                          };
                      if (
                        (t.push(r),
                        n.push(i),
                        Object.prototype.toString.apply(r) === `[object Array]`)
                      )
                        for (s = [], a = 0; a < r.length; a += 1) s[a] = e(r[a], i + `[` + a + `]`);
                      else
                        for (o in ((s = {}), r))
                          Object.prototype.hasOwnProperty.call(r, o) &&
                            (s[o] = e(r[o], i + `[` + JSON.stringify(o) + `]`));
                      return s;
                    case `number`:
                    case `string`:
                    case `boolean`:
                      return r;
                  }
                })(e, `$`);
              }
              function I(e) {
                try {
                  return JSON.stringify(e);
                } catch {
                  return JSON.stringify(be(e));
                }
              }
              class L {
                constructor() {
                  this.globalLog = (e) => {
                    window.console && window.console.log && window.console.log(e);
                  };
                }
                debug(...e) {
                  this.log(this.globalLog, e);
                }
                warn(...e) {
                  this.log(this.globalLogWarn, e);
                }
                error(...e) {
                  this.log(this.globalLogError, e);
                }
                globalLogWarn(e) {
                  window.console && window.console.warn
                    ? window.console.warn(e)
                    : this.globalLog(e);
                }
                globalLogError(e) {
                  window.console && window.console.error
                    ? window.console.error(e)
                    : this.globalLogWarn(e);
                }
                log(e, ...t) {
                  var n = le.apply(this, arguments);
                  gn.log ? gn.log(n) : gn.logToConsole && e.bind(this)(n);
                }
              }
              let xe = new L(),
                Se = function (e, t, n, r, i) {
                  (n.headers !== void 0 || n.headersProvider != null) &&
                    xe.warn(
                      `To send headers with the ${r.toString()} request, you must use AJAX, rather than JSONP.`,
                    );
                  var a = e.nextAuthCallbackID.toString();
                  e.nextAuthCallbackID++;
                  var o = e.getDocument(),
                    s = o.createElement(`script`);
                  e.auth_callbacks[a] = function (e) {
                    i(null, e);
                  };
                  var c = `Pusher.auth_callbacks['` + a + `']`;
                  s.src = n.endpoint + `?callback=` + encodeURIComponent(c) + `&` + t;
                  var l = o.getElementsByTagName(`head`)[0] || o.documentElement;
                  l.insertBefore(s, l.firstChild);
                };
              class Ce {
                constructor(e) {
                  this.src = e;
                }
                send(e) {
                  var t = this,
                    n = `Error loading ` + t.src;
                  ((t.script = document.createElement(`script`)),
                    (t.script.id = e.id),
                    (t.script.src = t.src),
                    (t.script.type = `text/javascript`),
                    (t.script.charset = `UTF-8`),
                    t.script.addEventListener
                      ? ((t.script.onerror = function () {
                          e.callback(n);
                        }),
                        (t.script.onload = function () {
                          e.callback(null);
                        }))
                      : (t.script.onreadystatechange = function () {
                          (t.script.readyState === `loaded` ||
                            t.script.readyState === `complete`) &&
                            e.callback(null);
                        }),
                    t.script.async === void 0 &&
                    document.attachEvent &&
                    /opera/i.test(navigator.userAgent)
                      ? ((t.errorScript = document.createElement(`script`)),
                        (t.errorScript.id = e.id + `_error`),
                        (t.errorScript.text = e.name + `('` + n + `');`),
                        (t.script.async = t.errorScript.async = !1))
                      : (t.script.async = !0));
                  var r = document.getElementsByTagName(`head`)[0];
                  (r.insertBefore(t.script, r.firstChild),
                    t.errorScript && r.insertBefore(t.errorScript, t.script.nextSibling));
                }
                cleanup() {
                  (this.script &&
                    ((this.script.onload = this.script.onerror = null),
                    (this.script.onreadystatechange = null)),
                    this.script &&
                      this.script.parentNode &&
                      this.script.parentNode.removeChild(this.script),
                    this.errorScript &&
                      this.errorScript.parentNode &&
                      this.errorScript.parentNode.removeChild(this.errorScript),
                    (this.script = null),
                    (this.errorScript = null));
                }
              }
              class we {
                constructor(e, t) {
                  ((this.url = e), (this.data = t));
                }
                send(e) {
                  if (!this.request) {
                    var t = F(this.data),
                      n = this.url + `/` + e.number + `?` + t;
                    ((this.request = zt.createScriptRequest(n)), this.request.send(e));
                  }
                }
                cleanup() {
                  this.request && this.request.cleanup();
                }
              }
              let Te = {
                name: `jsonp`,
                getAgent: function (e, t) {
                  return function (n, r) {
                    var a =
                        `http` +
                        (t ? `s` : ``) +
                        `://` +
                        (e.host || e.options.host) +
                        e.options.path,
                      o = zt.createJSONPRequest(a, n),
                      s = zt.ScriptReceivers.create(function (t, n) {
                        (i.remove(s), o.cleanup(), n && n.host && (e.host = n.host), r && r(t, n));
                      });
                    o.send(s);
                  };
                },
              };
              function Ee(e, t, n) {
                var r = e + (t.useTLS ? `s` : ``),
                  i = t.useTLS ? t.hostTLS : t.hostNonTLS;
                return r + `://` + i + n;
              }
              function De(e, t) {
                return (
                  `/app/` +
                  e +
                  (`?protocol=` +
                    a.PROTOCOL +
                    `&client=js&version=` +
                    a.VERSION +
                    (t ? `&` + t : ``))
                );
              }
              var Oe = {
                  getInitial: function (e, t) {
                    return Ee(`ws`, t, (t.httpPath || ``) + De(e, `flash=false`));
                  },
                },
                ke = {
                  getInitial: function (e, t) {
                    return Ee(`http`, t, (t.httpPath || `/pusher`) + De(e));
                  },
                },
                Ae = {
                  getInitial: function (e, t) {
                    return Ee(`http`, t, t.httpPath || `/pusher`);
                  },
                  getPath: function (e, t) {
                    return De(e);
                  },
                };
              class je {
                constructor() {
                  this._callbacks = {};
                }
                get(e) {
                  return this._callbacks[Me(e)];
                }
                add(e, t, n) {
                  var r = Me(e);
                  ((this._callbacks[r] = this._callbacks[r] || []),
                    this._callbacks[r].push({
                      fn: t,
                      context: n,
                    }));
                }
                remove(e, t, n) {
                  if (!e && !t && !n) {
                    this._callbacks = {};
                    return;
                  }
                  var r = e ? [Me(e)] : fe(this._callbacks);
                  t || n ? this.removeCallback(r, t, n) : this.removeAllCallbacks(r);
                }
                removeCallback(e, t, n) {
                  M(
                    e,
                    function (e) {
                      ((this._callbacks[e] = P(this._callbacks[e] || [], function (e) {
                        return (t && t !== e.fn) || (n && n !== e.context);
                      })),
                        this._callbacks[e].length === 0 && delete this._callbacks[e]);
                    },
                    this,
                  );
                }
                removeAllCallbacks(e) {
                  M(
                    e,
                    function (e) {
                      delete this._callbacks[e];
                    },
                    this,
                  );
                }
              }
              function Me(e) {
                return `_` + e;
              }
              class R {
                constructor(e) {
                  ((this.callbacks = new je()),
                    (this.global_callbacks = []),
                    (this.failThrough = e));
                }
                bind(e, t, n) {
                  return (this.callbacks.add(e, t, n), this);
                }
                bind_global(e) {
                  return (this.global_callbacks.push(e), this);
                }
                unbind(e, t, n) {
                  return (this.callbacks.remove(e, t, n), this);
                }
                unbind_global(e) {
                  return e
                    ? ((this.global_callbacks = P(this.global_callbacks || [], (t) => t !== e)),
                      this)
                    : ((this.global_callbacks = []), this);
                }
                unbind_all() {
                  return (this.unbind(), this.unbind_global(), this);
                }
                emit(e, t, n) {
                  for (var r = 0; r < this.global_callbacks.length; r++)
                    this.global_callbacks[r](e, t);
                  var i = this.callbacks.get(e),
                    a = [];
                  if ((n ? a.push(t, n) : t && a.push(t), i && i.length > 0))
                    for (var r = 0; r < i.length; r++) i[r].fn.apply(i[r].context || window, a);
                  else this.failThrough && this.failThrough(e, t);
                  return this;
                }
              }
              class Ne extends R {
                constructor(e, t, n, r, i) {
                  (super(),
                    (this.initialize = zt.transportConnectionInitializer),
                    (this.hooks = e),
                    (this.name = t),
                    (this.priority = n),
                    (this.key = r),
                    (this.options = i),
                    (this.state = `new`),
                    (this.timeline = i.timeline),
                    (this.activityTimeout = i.activityTimeout),
                    (this.id = this.timeline.generateUniqueID()));
                }
                handlesActivityChecks() {
                  return !!this.hooks.handlesActivityChecks;
                }
                supportsPing() {
                  return !!this.hooks.supportsPing;
                }
                connect() {
                  if (this.socket || this.state !== `initialized`) return !1;
                  var e = this.hooks.urls.getInitial(this.key, this.options);
                  try {
                    this.socket = this.hooks.getSocket(e, this.options);
                  } catch (e) {
                    return (
                      se.defer(() => {
                        (this.onError(e), this.changeState(`closed`));
                      }),
                      !1
                    );
                  }
                  return (
                    this.bindListeners(),
                    xe.debug(`Connecting`, {
                      transport: this.name,
                      url: e,
                    }),
                    this.changeState(`connecting`),
                    !0
                  );
                }
                close() {
                  return this.socket ? (this.socket.close(), !0) : !1;
                }
                send(e) {
                  return this.state === `open`
                    ? (se.defer(() => {
                        this.socket && this.socket.send(e);
                      }),
                      !0)
                    : !1;
                }
                ping() {
                  this.state === `open` && this.supportsPing() && this.socket.ping();
                }
                onOpen() {
                  (this.hooks.beforeOpen &&
                    this.hooks.beforeOpen(
                      this.socket,
                      this.hooks.urls.getPath(this.key, this.options),
                    ),
                    this.changeState(`open`),
                    (this.socket.onopen = void 0));
                }
                onError(e) {
                  (this.emit(`error`, {
                    type: `WebSocketError`,
                    error: e,
                  }),
                    this.timeline.error(
                      this.buildTimelineMessage({
                        error: e.toString(),
                      }),
                    ));
                }
                onClose(e) {
                  (e
                    ? this.changeState(`closed`, {
                        code: e.code,
                        reason: e.reason,
                        wasClean: e.wasClean,
                      })
                    : this.changeState(`closed`),
                    this.unbindListeners(),
                    (this.socket = void 0));
                }
                onMessage(e) {
                  this.emit(`message`, e);
                }
                onActivity() {
                  this.emit(`activity`);
                }
                bindListeners() {
                  ((this.socket.onopen = () => {
                    this.onOpen();
                  }),
                    (this.socket.onerror = (e) => {
                      this.onError(e);
                    }),
                    (this.socket.onclose = (e) => {
                      this.onClose(e);
                    }),
                    (this.socket.onmessage = (e) => {
                      this.onMessage(e);
                    }),
                    this.supportsPing() &&
                      (this.socket.onactivity = () => {
                        this.onActivity();
                      }));
                }
                unbindListeners() {
                  this.socket &&
                    ((this.socket.onopen = void 0),
                    (this.socket.onerror = void 0),
                    (this.socket.onclose = void 0),
                    (this.socket.onmessage = void 0),
                    this.supportsPing() && (this.socket.onactivity = void 0));
                }
                changeState(e, t) {
                  ((this.state = e),
                    this.timeline.info(
                      this.buildTimelineMessage({
                        state: e,
                        params: t,
                      }),
                    ),
                    this.emit(e, t));
                }
                buildTimelineMessage(e) {
                  return ce(
                    {
                      cid: this.id,
                    },
                    e,
                  );
                }
              }
              class Pe {
                constructor(e) {
                  this.hooks = e;
                }
                isSupported(e) {
                  return this.hooks.isSupported(e);
                }
                createConnection(e, t, n, r) {
                  return new Ne(this.hooks, e, t, n, r);
                }
              }
              var Fe = new Pe({
                  urls: Oe,
                  handlesActivityChecks: !1,
                  supportsPing: !1,
                  isInitialized: function () {
                    return !!zt.getWebSocketAPI();
                  },
                  isSupported: function () {
                    return !!zt.getWebSocketAPI();
                  },
                  getSocket: function (e) {
                    return zt.createWebSocket(e);
                  },
                }),
                Ie = {
                  urls: ke,
                  handlesActivityChecks: !1,
                  supportsPing: !0,
                  isInitialized: function () {
                    return !0;
                  },
                },
                Le = ce(
                  {
                    getSocket: function (e) {
                      return zt.HTTPFactory.createStreamingSocket(e);
                    },
                  },
                  Ie,
                ),
                Re = ce(
                  {
                    getSocket: function (e) {
                      return zt.HTTPFactory.createPollingSocket(e);
                    },
                  },
                  Ie,
                ),
                ze = {
                  isSupported: function () {
                    return zt.isXHRSupported();
                  },
                };
              let Be = {
                ws: Fe,
                xhr_streaming: new Pe(ce({}, Le, ze)),
                xhr_polling: new Pe(ce({}, Re, ze)),
              };
              var z = new Pe({
                  file: `sockjs`,
                  urls: Ae,
                  handlesActivityChecks: !0,
                  supportsPing: !1,
                  isSupported: function () {
                    return !0;
                  },
                  isInitialized: function () {
                    return window.SockJS !== void 0;
                  },
                  getSocket: function (e, t) {
                    return new window.SockJS(e, null, {
                      js_path: c.getPath(`sockjs`, {
                        useTLS: t.useTLS,
                      }),
                      ignore_null_origin: t.ignoreNullOrigin,
                    });
                  },
                  beforeOpen: function (e, t) {
                    e.send(
                      JSON.stringify({
                        path: t,
                      }),
                    );
                  },
                }),
                Ve = {
                  isSupported: function (e) {
                    return zt.isXDRSupported(e.useTLS);
                  },
                },
                He = new Pe(ce({}, Le, Ve)),
                Ue = new Pe(ce({}, Re, Ve));
              ((Be.xdr_streaming = He), (Be.xdr_polling = Ue), (Be.sockjs = z));
              let We = Be;
              class B extends R {
                constructor() {
                  super();
                  var e = this;
                  window.addEventListener !== void 0 &&
                    (window.addEventListener(
                      `online`,
                      function () {
                        e.emit(`online`);
                      },
                      !1,
                    ),
                    window.addEventListener(
                      `offline`,
                      function () {
                        e.emit(`offline`);
                      },
                      !1,
                    ));
                }
                isOnline() {
                  return window.navigator.onLine === void 0 ? !0 : window.navigator.onLine;
                }
              }
              var Ge = new B();
              class Ke {
                constructor(e, t, n) {
                  ((this.manager = e),
                    (this.transport = t),
                    (this.minPingDelay = n.minPingDelay),
                    (this.maxPingDelay = n.maxPingDelay),
                    (this.pingDelay = void 0));
                }
                createConnection(e, t, n, r) {
                  r = ce({}, r, {
                    activityTimeout: this.pingDelay,
                  });
                  var i = this.transport.createConnection(e, t, n, r),
                    a = null,
                    o = function () {
                      (i.unbind(`open`, o), i.bind(`closed`, s), (a = se.now()));
                    },
                    s = (e) => {
                      if ((i.unbind(`closed`, s), e.code === 1002 || e.code === 1003))
                        this.manager.reportDeath();
                      else if (!e.wasClean && a) {
                        var t = se.now() - a;
                        t < 2 * this.maxPingDelay &&
                          (this.manager.reportDeath(),
                          (this.pingDelay = Math.max(t / 2, this.minPingDelay)));
                      }
                    };
                  return (i.bind(`open`, o), i);
                }
                isSupported(e) {
                  return this.manager.isAlive() && this.transport.isSupported(e);
                }
              }
              let qe = {
                  decodeMessage: function (e) {
                    try {
                      var t = JSON.parse(e.data),
                        n = t.data;
                      if (typeof n == `string`)
                        try {
                          n = JSON.parse(t.data);
                        } catch {}
                      var r = {
                        event: t.event,
                        channel: t.channel,
                        data: n,
                      };
                      return (t.user_id && (r.user_id = t.user_id), r);
                    } catch (t) {
                      throw {
                        type: `MessageParseError`,
                        error: t,
                        data: e.data,
                      };
                    }
                  },
                  encodeMessage: function (e) {
                    return JSON.stringify(e);
                  },
                  processHandshake: function (e) {
                    var t = qe.decodeMessage(e);
                    if (t.event === `pusher:connection_established`) {
                      if (!t.data.activity_timeout)
                        throw `No activity timeout specified in handshake`;
                      return {
                        action: `connected`,
                        id: t.data.socket_id,
                        activityTimeout: t.data.activity_timeout * 1e3,
                      };
                    } else if (t.event === `pusher:error`)
                      return {
                        action: this.getCloseAction(t.data),
                        error: this.getCloseError(t.data),
                      };
                    else throw `Invalid handshake`;
                  },
                  getCloseAction: function (e) {
                    return e.code < 4e3
                      ? e.code >= 1002 && e.code <= 1004
                        ? `backoff`
                        : null
                      : e.code === 4e3
                        ? `tls_only`
                        : e.code < 4100
                          ? `refused`
                          : e.code < 4200
                            ? `backoff`
                            : e.code < 4300
                              ? `retry`
                              : `refused`;
                  },
                  getCloseError: function (e) {
                    return e.code !== 1e3 && e.code !== 1001
                      ? {
                          type: `PusherError`,
                          data: {
                            code: e.code,
                            message: e.reason || e.message,
                          },
                        }
                      : null;
                  },
                },
                V = qe;
              class Je extends R {
                constructor(e, t) {
                  (super(),
                    (this.id = e),
                    (this.transport = t),
                    (this.activityTimeout = t.activityTimeout),
                    this.bindListeners());
                }
                handlesActivityChecks() {
                  return this.transport.handlesActivityChecks();
                }
                send(e) {
                  return this.transport.send(e);
                }
                send_event(e, t, n) {
                  var r = {
                    event: e,
                    data: t,
                  };
                  return (
                    n && (r.channel = n),
                    xe.debug(`Event sent`, r),
                    this.send(V.encodeMessage(r))
                  );
                }
                ping() {
                  this.transport.supportsPing()
                    ? this.transport.ping()
                    : this.send_event(`pusher:ping`, {});
                }
                close() {
                  this.transport.close();
                }
                bindListeners() {
                  var e = {
                      message: (e) => {
                        var t;
                        try {
                          t = V.decodeMessage(e);
                        } catch (t) {
                          this.emit(`error`, {
                            type: `MessageParseError`,
                            error: t,
                            data: e.data,
                          });
                        }
                        if (t !== void 0) {
                          switch ((xe.debug(`Event recd`, t), t.event)) {
                            case `pusher:error`:
                              this.emit(`error`, {
                                type: `PusherError`,
                                data: t.data,
                              });
                              break;
                            case `pusher:ping`:
                              this.emit(`ping`);
                              break;
                            case `pusher:pong`:
                              this.emit(`pong`);
                              break;
                          }
                          this.emit(`message`, t);
                        }
                      },
                      activity: () => {
                        this.emit(`activity`);
                      },
                      error: (e) => {
                        this.emit(`error`, e);
                      },
                      closed: (e) => {
                        (t(),
                          e && e.code && this.handleCloseEvent(e),
                          (this.transport = null),
                          this.emit(`closed`));
                      },
                    },
                    t = () => {
                      de(e, (e, t) => {
                        this.transport.unbind(t, e);
                      });
                    };
                  de(e, (e, t) => {
                    this.transport.bind(t, e);
                  });
                }
                handleCloseEvent(e) {
                  var t = V.getCloseAction(e),
                    n = V.getCloseError(e);
                  (n && this.emit(`error`, n),
                    t &&
                      this.emit(t, {
                        action: t,
                        error: n,
                      }));
                }
              }
              class H {
                constructor(e, t) {
                  ((this.transport = e), (this.callback = t), this.bindListeners());
                }
                close() {
                  (this.unbindListeners(), this.transport.close());
                }
                bindListeners() {
                  ((this.onMessage = (e) => {
                    this.unbindListeners();
                    var t;
                    try {
                      t = V.processHandshake(e);
                    } catch (e) {
                      (this.finish(`error`, {
                        error: e,
                      }),
                        this.transport.close());
                      return;
                    }
                    t.action === `connected`
                      ? this.finish(`connected`, {
                          connection: new Je(t.id, this.transport),
                          activityTimeout: t.activityTimeout,
                        })
                      : (this.finish(t.action, {
                          error: t.error,
                        }),
                        this.transport.close());
                  }),
                    (this.onClosed = (e) => {
                      this.unbindListeners();
                      var t = V.getCloseAction(e) || `backoff`,
                        n = V.getCloseError(e);
                      this.finish(t, {
                        error: n,
                      });
                    }),
                    this.transport.bind(`message`, this.onMessage),
                    this.transport.bind(`closed`, this.onClosed));
                }
                unbindListeners() {
                  (this.transport.unbind(`message`, this.onMessage),
                    this.transport.unbind(`closed`, this.onClosed));
                }
                finish(e, t) {
                  this.callback(
                    ce(
                      {
                        transport: this.transport,
                        action: e,
                      },
                      t,
                    ),
                  );
                }
              }
              class Ye {
                constructor(e, t) {
                  ((this.timeline = e), (this.options = t || {}));
                }
                send(e, t) {
                  this.timeline.isEmpty() ||
                    this.timeline.send(zt.TimelineTransport.getAgent(this, e), t);
                }
              }
              class U extends R {
                constructor(e, t) {
                  (super(function (t, n) {
                    xe.debug(`No callbacks on ` + e + ` for ` + t);
                  }),
                    (this.name = e),
                    (this.pusher = t),
                    (this.subscribed = !1),
                    (this.subscriptionPending = !1),
                    (this.subscriptionCancelled = !1));
                }
                authorize(e, t) {
                  return t(null, {
                    auth: ``,
                  });
                }
                trigger(e, t) {
                  if (e.indexOf(`client-`) !== 0)
                    throw new f(`Event '` + e + `' does not start with 'client-'`);
                  if (!this.subscribed) {
                    var n = u.buildLogSuffix(`triggeringClientEvents`);
                    xe.warn(
                      `Client event triggered before channel 'subscription_succeeded' event . ${n}`,
                    );
                  }
                  return this.pusher.send_event(e, t, this.name);
                }
                disconnect() {
                  ((this.subscribed = !1), (this.subscriptionPending = !1));
                }
                handleEvent(e) {
                  var t = e.event,
                    n = e.data;
                  t === `pusher_internal:subscription_succeeded`
                    ? this.handleSubscriptionSucceededEvent(e)
                    : t === `pusher_internal:subscription_count`
                      ? this.handleSubscriptionCountEvent(e)
                      : t.indexOf(`pusher_internal:`) !== 0 && this.emit(t, n, {});
                }
                handleSubscriptionSucceededEvent(e) {
                  ((this.subscriptionPending = !1),
                    (this.subscribed = !0),
                    this.subscriptionCancelled
                      ? this.pusher.unsubscribe(this.name)
                      : this.emit(`pusher:subscription_succeeded`, e.data));
                }
                handleSubscriptionCountEvent(e) {
                  (e.data.subscription_count &&
                    (this.subscriptionCount = e.data.subscription_count),
                    this.emit(`pusher:subscription_count`, e.data));
                }
                subscribe() {
                  this.subscribed ||
                    ((this.subscriptionPending = !0),
                    (this.subscriptionCancelled = !1),
                    this.authorize(this.pusher.connection.socket_id, (e, t) => {
                      e
                        ? ((this.subscriptionPending = !1),
                          xe.error(e.toString()),
                          this.emit(
                            `pusher:subscription_error`,
                            Object.assign(
                              {},
                              {
                                type: `AuthError`,
                                error: e.message,
                              },
                              e instanceof x
                                ? {
                                    status: e.status,
                                  }
                                : {},
                            ),
                          ))
                        : this.pusher.send_event(`pusher:subscribe`, {
                            auth: t.auth,
                            channel_data: t.channel_data,
                            channel: this.name,
                          });
                    }));
                }
                unsubscribe() {
                  ((this.subscribed = !1),
                    this.pusher.send_event(`pusher:unsubscribe`, {
                      channel: this.name,
                    }));
                }
                cancelSubscription() {
                  this.subscriptionCancelled = !0;
                }
                reinstateSubscription() {
                  this.subscriptionCancelled = !1;
                }
              }
              class Xe extends U {
                authorize(e, t) {
                  return this.pusher.config.channelAuthorizer(
                    {
                      channelName: this.name,
                      socketId: e,
                    },
                    t,
                  );
                }
              }
              class W {
                constructor() {
                  this.reset();
                }
                get(e) {
                  return Object.prototype.hasOwnProperty.call(this.members, e)
                    ? {
                        id: e,
                        info: this.members[e],
                      }
                    : null;
                }
                each(e) {
                  de(this.members, (t, n) => {
                    e(this.get(n));
                  });
                }
                setMyID(e) {
                  this.myID = e;
                }
                onSubscription(e) {
                  ((this.members = e.presence.hash),
                    (this.count = e.presence.count),
                    (this.me = this.get(this.myID)));
                }
                addMember(e) {
                  return (
                    this.get(e.user_id) === null && this.count++,
                    (this.members[e.user_id] = e.user_info),
                    this.get(e.user_id)
                  );
                }
                removeMember(e) {
                  var t = this.get(e.user_id);
                  return (t && (delete this.members[e.user_id], this.count--), t);
                }
                reset() {
                  ((this.members = {}), (this.count = 0), (this.myID = null), (this.me = null));
                }
              }
              var Ze = function (e, t, n, r) {
                function i(e) {
                  return e instanceof n
                    ? e
                    : new n(function (t) {
                        t(e);
                      });
                }
                return new (n ||= Promise)(function (n, a) {
                  function o(e) {
                    try {
                      c(r.next(e));
                    } catch (e) {
                      a(e);
                    }
                  }
                  function s(e) {
                    try {
                      c(r.throw(e));
                    } catch (e) {
                      a(e);
                    }
                  }
                  function c(e) {
                    e.done ? n(e.value) : i(e.value).then(o, s);
                  }
                  c((r = r.apply(e, t || [])).next());
                });
              };
              class Qe extends Xe {
                constructor(e, t) {
                  (super(e, t), (this.members = new W()));
                }
                authorize(e, t) {
                  super.authorize(e, (e, n) =>
                    Ze(this, void 0, void 0, function* () {
                      if (!e)
                        if (((n = n), n.channel_data != null)) {
                          var r = JSON.parse(n.channel_data);
                          this.members.setMyID(r.user_id);
                        } else if (
                          (yield this.pusher.user.signinDonePromise,
                          this.pusher.user.user_data != null)
                        )
                          this.members.setMyID(this.pusher.user.user_data.id);
                        else {
                          let e = u.buildLogSuffix(`authorizationEndpoint`);
                          (xe.error(
                            `Invalid auth response for channel '${this.name}', expected 'channel_data' field. ${e}, or the user should be signed in.`,
                          ),
                            t(`Invalid auth response`));
                          return;
                        }
                      t(e, n);
                    }),
                  );
                }
                handleEvent(e) {
                  var t = e.event;
                  if (t.indexOf(`pusher_internal:`) === 0) this.handleInternalEvent(e);
                  else {
                    var n = e.data,
                      r = {};
                    (e.user_id && (r.user_id = e.user_id), this.emit(t, n, r));
                  }
                }
                handleInternalEvent(e) {
                  var t = e.event,
                    n = e.data;
                  switch (t) {
                    case `pusher_internal:subscription_succeeded`:
                      this.handleSubscriptionSucceededEvent(e);
                      break;
                    case `pusher_internal:subscription_count`:
                      this.handleSubscriptionCountEvent(e);
                      break;
                    case `pusher_internal:member_added`:
                      var r = this.members.addMember(n);
                      this.emit(`pusher:member_added`, r);
                      break;
                    case `pusher_internal:member_removed`:
                      var i = this.members.removeMember(n);
                      i && this.emit(`pusher:member_removed`, i);
                      break;
                  }
                }
                handleSubscriptionSucceededEvent(e) {
                  ((this.subscriptionPending = !1),
                    (this.subscribed = !0),
                    this.subscriptionCancelled
                      ? this.pusher.unsubscribe(this.name)
                      : (this.members.onSubscription(e.data),
                        this.emit(`pusher:subscription_succeeded`, this.members)));
                }
                disconnect() {
                  (this.members.reset(), super.disconnect());
                }
              }
              var $e = n(978),
                et = n(594);
              class tt extends Xe {
                constructor(e, t, n) {
                  (super(e, t), (this.key = null), (this.nacl = n));
                }
                authorize(e, t) {
                  super.authorize(e, (e, n) => {
                    if (e) {
                      t(e, n);
                      return;
                    }
                    let r = n.shared_secret;
                    if (!r) {
                      t(
                        Error(
                          `No shared_secret key in auth payload for encrypted channel: ${this.name}`,
                        ),
                        null,
                      );
                      return;
                    }
                    ((this.key = (0, et.decode)(r)), delete n.shared_secret, t(null, n));
                  });
                }
                trigger(e, t) {
                  throw new v(`Client events are not currently supported for encrypted channels`);
                }
                handleEvent(e) {
                  var t = e.event,
                    n = e.data;
                  if (t.indexOf(`pusher_internal:`) === 0 || t.indexOf(`pusher:`) === 0) {
                    super.handleEvent(e);
                    return;
                  }
                  this.handleEncryptedEvent(t, n);
                }
                handleEncryptedEvent(e, t) {
                  if (!this.key) {
                    xe.debug(
                      `Received encrypted event before key has been retrieved from the authEndpoint`,
                    );
                    return;
                  }
                  if (!t.ciphertext || !t.nonce) {
                    xe.error(
                      "Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " +
                        t,
                    );
                    return;
                  }
                  let n = (0, et.decode)(t.ciphertext);
                  if (n.length < this.nacl.secretbox.overheadLength) {
                    xe.error(
                      `Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${n.length}`,
                    );
                    return;
                  }
                  let r = (0, et.decode)(t.nonce);
                  if (r.length < this.nacl.secretbox.nonceLength) {
                    xe.error(
                      `Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${r.length}`,
                    );
                    return;
                  }
                  let i = this.nacl.secretbox.open(n, r, this.key);
                  if (i === null) {
                    (xe.debug(
                      `Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...`,
                    ),
                      this.authorize(this.pusher.connection.socket_id, (t, a) => {
                        if (t) {
                          xe.error(
                            `Failed to make a request to the authEndpoint: ${a}. Unable to fetch new key, so dropping encrypted event`,
                          );
                          return;
                        }
                        if (((i = this.nacl.secretbox.open(n, r, this.key)), i === null)) {
                          xe.error(
                            `Failed to decrypt event with new key. Dropping encrypted event`,
                          );
                          return;
                        }
                        this.emit(e, this.getDataToEmit(i));
                      }));
                    return;
                  }
                  this.emit(e, this.getDataToEmit(i));
                }
                getDataToEmit(e) {
                  let t = (0, $e.D4)(e);
                  try {
                    return JSON.parse(t);
                  } catch {
                    return t;
                  }
                }
              }
              class nt extends R {
                constructor(e, t) {
                  (super(),
                    (this.state = `initialized`),
                    (this.connection = null),
                    (this.key = e),
                    (this.options = t),
                    (this.timeline = this.options.timeline),
                    (this.usingTLS = this.options.useTLS),
                    (this.errorCallbacks = this.buildErrorCallbacks()),
                    (this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks)),
                    (this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks)));
                  var n = zt.getNetwork();
                  (n.bind(`online`, () => {
                    (this.timeline.info({
                      netinfo: `online`,
                    }),
                      (this.state === `connecting` || this.state === `unavailable`) &&
                        this.retryIn(0));
                  }),
                    n.bind(`offline`, () => {
                      (this.timeline.info({
                        netinfo: `offline`,
                      }),
                        this.connection && this.sendActivityCheck());
                    }),
                    this.updateStrategy());
                }
                switchCluster(e) {
                  ((this.key = e), this.updateStrategy(), this.retryIn(0));
                }
                connect() {
                  if (!(this.connection || this.runner)) {
                    if (!this.strategy.isSupported()) {
                      this.updateState(`failed`);
                      return;
                    }
                    (this.updateState(`connecting`),
                      this.startConnecting(),
                      this.setUnavailableTimer());
                  }
                }
                send(e) {
                  return this.connection ? this.connection.send(e) : !1;
                }
                send_event(e, t, n) {
                  return this.connection ? this.connection.send_event(e, t, n) : !1;
                }
                disconnect() {
                  (this.disconnectInternally(), this.updateState(`disconnected`));
                }
                isUsingTLS() {
                  return this.usingTLS;
                }
                startConnecting() {
                  var e = (t, n) => {
                    t
                      ? (this.runner = this.strategy.connect(0, e))
                      : n.action === `error`
                        ? (this.emit(`error`, {
                            type: `HandshakeError`,
                            error: n.error,
                          }),
                          this.timeline.error({
                            handshakeError: n.error,
                          }))
                        : (this.abortConnecting(), this.handshakeCallbacks[n.action](n));
                  };
                  this.runner = this.strategy.connect(0, e);
                }
                abortConnecting() {
                  this.runner &&= (this.runner.abort(), null);
                }
                disconnectInternally() {
                  (this.abortConnecting(),
                    this.clearRetryTimer(),
                    this.clearUnavailableTimer(),
                    this.connection && this.abandonConnection().close());
                }
                updateStrategy() {
                  this.strategy = this.options.getStrategy({
                    key: this.key,
                    timeline: this.timeline,
                    useTLS: this.usingTLS,
                  });
                }
                retryIn(e) {
                  (this.timeline.info({
                    action: `retry`,
                    delay: e,
                  }),
                    e > 0 && this.emit(`connecting_in`, Math.round(e / 1e3)),
                    (this.retryTimer = new ae(e || 0, () => {
                      (this.disconnectInternally(), this.connect());
                    })));
                }
                clearRetryTimer() {
                  this.retryTimer &&= (this.retryTimer.ensureAborted(), null);
                }
                setUnavailableTimer() {
                  this.unavailableTimer = new ae(this.options.unavailableTimeout, () => {
                    this.updateState(`unavailable`);
                  });
                }
                clearUnavailableTimer() {
                  this.unavailableTimer && this.unavailableTimer.ensureAborted();
                }
                sendActivityCheck() {
                  (this.stopActivityCheck(),
                    this.connection.ping(),
                    (this.activityTimer = new ae(this.options.pongTimeout, () => {
                      (this.timeline.error({
                        pong_timed_out: this.options.pongTimeout,
                      }),
                        this.retryIn(0));
                    })));
                }
                resetActivityCheck() {
                  (this.stopActivityCheck(),
                    this.connection &&
                      !this.connection.handlesActivityChecks() &&
                      (this.activityTimer = new ae(this.activityTimeout, () => {
                        this.sendActivityCheck();
                      })));
                }
                stopActivityCheck() {
                  this.activityTimer && this.activityTimer.ensureAborted();
                }
                buildConnectionCallbacks(e) {
                  return ce({}, e, {
                    message: (e) => {
                      (this.resetActivityCheck(), this.emit(`message`, e));
                    },
                    ping: () => {
                      this.send_event(`pusher:pong`, {});
                    },
                    activity: () => {
                      this.resetActivityCheck();
                    },
                    error: (e) => {
                      this.emit(`error`, e);
                    },
                    closed: () => {
                      (this.abandonConnection(), this.shouldRetry() && this.retryIn(1e3));
                    },
                  });
                }
                buildHandshakeCallbacks(e) {
                  return ce({}, e, {
                    connected: (e) => {
                      ((this.activityTimeout = Math.min(
                        this.options.activityTimeout,
                        e.activityTimeout,
                        e.connection.activityTimeout || 1 / 0,
                      )),
                        this.clearUnavailableTimer(),
                        this.setConnection(e.connection),
                        (this.socket_id = this.connection.id),
                        this.updateState(`connected`, {
                          socket_id: this.socket_id,
                        }));
                    },
                  });
                }
                buildErrorCallbacks() {
                  let e = (e) => (t) => {
                    (t.error &&
                      this.emit(`error`, {
                        type: `WebSocketError`,
                        error: t.error,
                      }),
                      e(t));
                  };
                  return {
                    tls_only: e(() => {
                      ((this.usingTLS = !0), this.updateStrategy(), this.retryIn(0));
                    }),
                    refused: e(() => {
                      this.disconnect();
                    }),
                    backoff: e(() => {
                      this.retryIn(1e3);
                    }),
                    retry: e(() => {
                      this.retryIn(0);
                    }),
                  };
                }
                setConnection(e) {
                  for (var t in ((this.connection = e), this.connectionCallbacks))
                    this.connection.bind(t, this.connectionCallbacks[t]);
                  this.resetActivityCheck();
                }
                abandonConnection() {
                  if (this.connection) {
                    for (var e in (this.stopActivityCheck(), this.connectionCallbacks))
                      this.connection.unbind(e, this.connectionCallbacks[e]);
                    var t = this.connection;
                    return ((this.connection = null), t);
                  }
                }
                updateState(e, t) {
                  var n = this.state;
                  if (((this.state = e), n !== e)) {
                    var r = e;
                    (r === `connected` && (r += ` with new socket ID ` + t.socket_id),
                      xe.debug(`State changed`, n + ` -> ` + r),
                      this.timeline.info({
                        state: e,
                        params: t,
                      }),
                      this.emit(`state_change`, {
                        previous: n,
                        current: e,
                      }),
                      this.emit(e, t));
                  }
                }
                shouldRetry() {
                  return this.state === `connecting` || this.state === `connected`;
                }
              }
              class rt {
                constructor() {
                  this.channels = {};
                }
                add(e, t) {
                  return (this.channels[e] || (this.channels[e] = it(e, t)), this.channels[e]);
                }
                all() {
                  return pe(this.channels);
                }
                find(e) {
                  return this.channels[e];
                }
                remove(e) {
                  var t = this.channels[e];
                  return (delete this.channels[e], t);
                }
                disconnect() {
                  de(this.channels, function (e) {
                    e.disconnect();
                  });
                }
              }
              function it(e, t) {
                if (e.indexOf(`private-encrypted-`) === 0) {
                  if (t.config.nacl) return at.createEncryptedChannel(e, t, t.config.nacl);
                  throw new v(
                    `Tried to subscribe to a private-encrypted- channel but no nacl implementation available. ${u.buildLogSuffix(`encryptedChannelSupport`)}`,
                  );
                } else if (e.indexOf(`private-`) === 0) return at.createPrivateChannel(e, t);
                else if (e.indexOf(`presence-`) === 0) return at.createPresenceChannel(e, t);
                else if (e.indexOf(`#`) === 0)
                  throw new p(`Cannot create a channel with name "` + e + `".`);
                else return at.createChannel(e, t);
              }
              let at = {
                createChannels() {
                  return new rt();
                },
                createConnectionManager(e, t) {
                  return new nt(e, t);
                },
                createChannel(e, t) {
                  return new U(e, t);
                },
                createPrivateChannel(e, t) {
                  return new Xe(e, t);
                },
                createPresenceChannel(e, t) {
                  return new Qe(e, t);
                },
                createEncryptedChannel(e, t, n) {
                  return new tt(e, t, n);
                },
                createTimelineSender(e, t) {
                  return new Ye(e, t);
                },
                createHandshake(e, t) {
                  return new H(e, t);
                },
                createAssistantToTheTransportManager(e, t, n) {
                  return new Ke(e, t, n);
                },
              };
              class ot {
                constructor(e) {
                  ((this.options = e || {}), (this.livesLeft = this.options.lives || 1 / 0));
                }
                getAssistant(e) {
                  return at.createAssistantToTheTransportManager(this, e, {
                    minPingDelay: this.options.minPingDelay,
                    maxPingDelay: this.options.maxPingDelay,
                  });
                }
                isAlive() {
                  return this.livesLeft > 0;
                }
                reportDeath() {
                  --this.livesLeft;
                }
              }
              class st {
                constructor(e, t) {
                  ((this.strategies = e),
                    (this.loop = !!t.loop),
                    (this.failFast = !!t.failFast),
                    (this.timeout = t.timeout),
                    (this.timeoutLimit = t.timeoutLimit));
                }
                isSupported() {
                  return _e(this.strategies, se.method(`isSupported`));
                }
                connect(e, t) {
                  var n = this.strategies,
                    r = 0,
                    i = this.timeout,
                    a = null,
                    o = (s, c) => {
                      c
                        ? t(null, c)
                        : ((r += 1),
                          this.loop && (r %= n.length),
                          r < n.length
                            ? (i &&
                                ((i *= 2),
                                this.timeoutLimit && (i = Math.min(i, this.timeoutLimit))),
                              (a = this.tryStrategy(
                                n[r],
                                e,
                                {
                                  timeout: i,
                                  failFast: this.failFast,
                                },
                                o,
                              )))
                            : t(!0));
                    };
                  return (
                    (a = this.tryStrategy(
                      n[r],
                      e,
                      {
                        timeout: i,
                        failFast: this.failFast,
                      },
                      o,
                    )),
                    {
                      abort: function () {
                        a.abort();
                      },
                      forceMinPriority: function (t) {
                        ((e = t), a && a.forceMinPriority(t));
                      },
                    }
                  );
                }
                tryStrategy(e, t, n, r) {
                  var i = null,
                    a = null;
                  return (
                    n.timeout > 0 &&
                      (i = new ae(n.timeout, function () {
                        (a.abort(), r(!0));
                      })),
                    (a = e.connect(t, function (e, t) {
                      (e && i && i.isRunning() && !n.failFast) || (i && i.ensureAborted(), r(e, t));
                    })),
                    {
                      abort: function () {
                        (i && i.ensureAborted(), a.abort());
                      },
                      forceMinPriority: function (e) {
                        a.forceMinPriority(e);
                      },
                    }
                  );
                }
              }
              class ct {
                constructor(e) {
                  this.strategies = e;
                }
                isSupported() {
                  return _e(this.strategies, se.method(`isSupported`));
                }
                connect(e, t) {
                  return lt(this.strategies, e, function (e, n) {
                    return function (r, i) {
                      if (((n[e].error = r), r)) {
                        ut(n) && t(!0);
                        return;
                      }
                      (M(n, function (e) {
                        e.forceMinPriority(i.transport.priority);
                      }),
                        t(null, i));
                    };
                  });
                }
              }
              function lt(e, t, n) {
                var r = me(e, function (e, r, i, a) {
                  return e.connect(t, n(r, a));
                });
                return {
                  abort: function () {
                    M(r, dt);
                  },
                  forceMinPriority: function (e) {
                    M(r, function (t) {
                      t.forceMinPriority(e);
                    });
                  },
                };
              }
              function ut(e) {
                return ve(e, function (e) {
                  return !!e.error;
                });
              }
              function dt(e) {
                !e.error && !e.aborted && (e.abort(), (e.aborted = !0));
              }
              class ft {
                constructor(e, t, n) {
                  ((this.strategy = e),
                    (this.transports = t),
                    (this.ttl = n.ttl || 1800 * 1e3),
                    (this.usingTLS = n.useTLS),
                    (this.timeline = n.timeline));
                }
                isSupported() {
                  return this.strategy.isSupported();
                }
                connect(e, t) {
                  var n = this.usingTLS,
                    r = mt(n),
                    i = r && r.cacheSkipCount ? r.cacheSkipCount : 0,
                    a = [this.strategy];
                  if (r && r.timestamp + this.ttl >= se.now()) {
                    var o = this.transports[r.transport];
                    o &&
                      ([`ws`, `wss`].includes(r.transport) || i > 3
                        ? (this.timeline.info({
                            cached: !0,
                            transport: r.transport,
                            latency: r.latency,
                          }),
                          a.push(
                            new st([o], {
                              timeout: r.latency * 2 + 1e3,
                              failFast: !0,
                            }),
                          ))
                        : i++);
                  }
                  var s = se.now(),
                    c = a.pop().connect(e, function r(o, l) {
                      o
                        ? (G(n),
                          a.length > 0 ? ((s = se.now()), (c = a.pop().connect(e, r))) : t(o))
                        : (ht(n, l.transport.name, se.now() - s, i), t(null, l));
                    });
                  return {
                    abort: function () {
                      c.abort();
                    },
                    forceMinPriority: function (t) {
                      ((e = t), c && c.forceMinPriority(t));
                    },
                  };
                }
              }
              function pt(e) {
                return `pusherTransport` + (e ? `TLS` : `NonTLS`);
              }
              function mt(e) {
                var t = zt.getLocalStorage();
                if (t)
                  try {
                    var n = t[pt(e)];
                    if (n) return JSON.parse(n);
                  } catch {
                    G(e);
                  }
                return null;
              }
              function ht(e, t, n, r) {
                var i = zt.getLocalStorage();
                if (i)
                  try {
                    i[pt(e)] = I({
                      timestamp: se.now(),
                      transport: t,
                      latency: n,
                      cacheSkipCount: r,
                    });
                  } catch {}
              }
              function G(e) {
                var t = zt.getLocalStorage();
                if (t)
                  try {
                    delete t[pt(e)];
                  } catch {}
              }
              class gt {
                constructor(e, { delay: t }) {
                  ((this.strategy = e),
                    (this.options = {
                      delay: t,
                    }));
                }
                isSupported() {
                  return this.strategy.isSupported();
                }
                connect(e, t) {
                  var n = this.strategy,
                    r,
                    i = new ae(this.options.delay, function () {
                      r = n.connect(e, t);
                    });
                  return {
                    abort: function () {
                      (i.ensureAborted(), r && r.abort());
                    },
                    forceMinPriority: function (t) {
                      ((e = t), r && r.forceMinPriority(t));
                    },
                  };
                }
              }
              class _t {
                constructor(e, t, n) {
                  ((this.test = e), (this.trueBranch = t), (this.falseBranch = n));
                }
                isSupported() {
                  return (this.test() ? this.trueBranch : this.falseBranch).isSupported();
                }
                connect(e, t) {
                  return (this.test() ? this.trueBranch : this.falseBranch).connect(e, t);
                }
              }
              class vt {
                constructor(e) {
                  this.strategy = e;
                }
                isSupported() {
                  return this.strategy.isSupported();
                }
                connect(e, t) {
                  var n = this.strategy.connect(e, function (e, r) {
                    (r && n.abort(), t(e, r));
                  });
                  return n;
                }
              }
              function yt(e) {
                return function () {
                  return e.isSupported();
                };
              }
              let bt = function (e, t, n) {
                var r = {};
                function i(t, i, a, o, s) {
                  var c = n(e, t, i, a, o, s);
                  return ((r[t] = c), c);
                }
                var a = Object.assign({}, t, {
                    hostNonTLS: e.wsHost + `:` + e.wsPort,
                    hostTLS: e.wsHost + `:` + e.wssPort,
                    httpPath: e.wsPath,
                  }),
                  o = Object.assign({}, a, {
                    useTLS: !0,
                  }),
                  s = Object.assign({}, t, {
                    hostNonTLS: e.httpHost + `:` + e.httpPort,
                    hostTLS: e.httpHost + `:` + e.httpsPort,
                    httpPath: e.httpPath,
                  }),
                  c = {
                    loop: !0,
                    timeout: 15e3,
                    timeoutLimit: 6e4,
                  },
                  l = new ot({
                    minPingDelay: 1e4,
                    maxPingDelay: e.activityTimeout,
                  }),
                  u = new ot({
                    lives: 2,
                    minPingDelay: 1e4,
                    maxPingDelay: e.activityTimeout,
                  }),
                  d = i(`ws`, `ws`, 3, a, l),
                  f = i(`wss`, `ws`, 3, o, l),
                  p = i(`sockjs`, `sockjs`, 1, s),
                  m = i(`xhr_streaming`, `xhr_streaming`, 1, s, u),
                  h = i(`xdr_streaming`, `xdr_streaming`, 1, s, u),
                  g = i(`xhr_polling`, `xhr_polling`, 1, s),
                  v = i(`xdr_polling`, `xdr_polling`, 1, s),
                  y = new st([d], c),
                  b = new st([f], c),
                  x = new st([p], c),
                  S = new st([new _t(yt(m), m, h)], c),
                  C = new st([new _t(yt(g), g, v)], c),
                  w = new st(
                    [
                      new _t(
                        yt(S),
                        new ct([
                          S,
                          new gt(C, {
                            delay: 4e3,
                          }),
                        ]),
                        C,
                      ),
                    ],
                    c,
                  ),
                  T = new _t(yt(w), w, x),
                  E = t.useTLS
                    ? new ct([
                        y,
                        new gt(T, {
                          delay: 2e3,
                        }),
                      ])
                    : new ct([
                        y,
                        new gt(b, {
                          delay: 2e3,
                        }),
                        new gt(T, {
                          delay: 5e3,
                        }),
                      ]);
                return new ft(new vt(new _t(yt(d), E, T)), r, {
                  ttl: 18e5,
                  timeline: t.timeline,
                  useTLS: t.useTLS,
                });
              };
              function xt() {
                var e = this;
                (e.timeline.info(
                  e.buildTimelineMessage({
                    transport: e.name + (e.options.useTLS ? `s` : ``),
                  }),
                ),
                  e.hooks.isInitialized()
                    ? e.changeState(`initialized`)
                    : e.hooks.file
                      ? (e.changeState(`initializing`),
                        c.load(
                          e.hooks.file,
                          {
                            useTLS: e.options.useTLS,
                          },
                          function (t, n) {
                            e.hooks.isInitialized()
                              ? (e.changeState(`initialized`), n(!0))
                              : (t && e.onError(t), e.onClose(), n(!1));
                          },
                        ))
                      : e.onClose());
              }
              let St = {
                getRequest: function (e) {
                  var t = new window.XDomainRequest();
                  return (
                    (t.ontimeout = function () {
                      (e.emit(`error`, new m()), e.close());
                    }),
                    (t.onerror = function (t) {
                      (e.emit(`error`, t), e.close());
                    }),
                    (t.onprogress = function () {
                      t.responseText && t.responseText.length > 0 && e.onChunk(200, t.responseText);
                    }),
                    (t.onload = function () {
                      (t.responseText &&
                        t.responseText.length > 0 &&
                        e.onChunk(200, t.responseText),
                        e.emit(`finished`, 200),
                        e.close());
                    }),
                    t
                  );
                },
                abortRequest: function (e) {
                  ((e.ontimeout = e.onerror = e.onprogress = e.onload = null), e.abort());
                },
              };
              class Ct extends R {
                constructor(e, t, n) {
                  (super(), (this.hooks = e), (this.method = t), (this.url = n));
                }
                start(e) {
                  ((this.position = 0),
                    (this.xhr = this.hooks.getRequest(this)),
                    (this.unloader = () => {
                      this.close();
                    }),
                    zt.addUnloadListener(this.unloader),
                    this.xhr.open(this.method, this.url, !0),
                    this.xhr.setRequestHeader &&
                      this.xhr.setRequestHeader(`Content-Type`, `application/json`),
                    this.xhr.send(e));
                }
                close() {
                  ((this.unloader &&= (zt.removeUnloadListener(this.unloader), null)),
                    (this.xhr &&= (this.hooks.abortRequest(this.xhr), null)));
                }
                onChunk(e, t) {
                  for (;;) {
                    var n = this.advanceBuffer(t);
                    if (n)
                      this.emit(`chunk`, {
                        status: e,
                        data: n,
                      });
                    else break;
                  }
                  this.isBufferTooLong(t) && this.emit(`buffer_too_long`);
                }
                advanceBuffer(e) {
                  var t = e.slice(this.position),
                    n = t.indexOf(`
`);
                  return n === -1 ? null : ((this.position += n + 1), t.slice(0, n));
                }
                isBufferTooLong(e) {
                  return this.position === e.length && e.length > 262144;
                }
              }
              var wt;
              (function (e) {
                ((e[(e.CONNECTING = 0)] = `CONNECTING`),
                  (e[(e.OPEN = 1)] = `OPEN`),
                  (e[(e.CLOSED = 3)] = `CLOSED`));
              })((wt ||= {}));
              let Tt = wt;
              var Et = 1;
              class Dt {
                constructor(e, t) {
                  ((this.hooks = e),
                    (this.session = Mt(1e3) + `/` + Nt(8)),
                    (this.location = Ot(t)),
                    (this.readyState = Tt.CONNECTING),
                    this.openStream());
                }
                send(e) {
                  return this.sendRaw(JSON.stringify([e]));
                }
                ping() {
                  this.hooks.sendHeartbeat(this);
                }
                close(e, t) {
                  this.onClose(e, t, !0);
                }
                sendRaw(e) {
                  if (this.readyState === Tt.OPEN)
                    try {
                      return (
                        zt
                          .createSocketRequest(`POST`, At(kt(this.location, this.session)))
                          .start(e),
                        !0
                      );
                    } catch {
                      return !1;
                    }
                  else return !1;
                }
                reconnect() {
                  (this.closeStream(), this.openStream());
                }
                onClose(e, t, n) {
                  (this.closeStream(),
                    (this.readyState = Tt.CLOSED),
                    this.onclose &&
                      this.onclose({
                        code: e,
                        reason: t,
                        wasClean: n,
                      }));
                }
                onChunk(e) {
                  if (e.status === 200) {
                    this.readyState === Tt.OPEN && this.onActivity();
                    var t;
                    switch (e.data.slice(0, 1)) {
                      case `o`:
                        ((t = JSON.parse(e.data.slice(1) || `{}`)), this.onOpen(t));
                        break;
                      case `a`:
                        t = JSON.parse(e.data.slice(1) || `[]`);
                        for (var n = 0; n < t.length; n++) this.onEvent(t[n]);
                        break;
                      case `m`:
                        ((t = JSON.parse(e.data.slice(1) || `null`)), this.onEvent(t));
                        break;
                      case `h`:
                        this.hooks.onHeartbeat(this);
                        break;
                      case `c`:
                        ((t = JSON.parse(e.data.slice(1) || `[]`)), this.onClose(t[0], t[1], !0));
                        break;
                    }
                  }
                }
                onOpen(e) {
                  this.readyState === Tt.CONNECTING
                    ? (e && e.hostname && (this.location.base = jt(this.location.base, e.hostname)),
                      (this.readyState = Tt.OPEN),
                      this.onopen && this.onopen())
                    : this.onClose(1006, `Server lost session`, !0);
                }
                onEvent(e) {
                  this.readyState === Tt.OPEN &&
                    this.onmessage &&
                    this.onmessage({
                      data: e,
                    });
                }
                onActivity() {
                  this.onactivity && this.onactivity();
                }
                onError(e) {
                  this.onerror && this.onerror(e);
                }
                openStream() {
                  ((this.stream = zt.createSocketRequest(
                    `POST`,
                    At(this.hooks.getReceiveURL(this.location, this.session)),
                  )),
                    this.stream.bind(`chunk`, (e) => {
                      this.onChunk(e);
                    }),
                    this.stream.bind(`finished`, (e) => {
                      this.hooks.onFinished(this, e);
                    }),
                    this.stream.bind(`buffer_too_long`, () => {
                      this.reconnect();
                    }));
                  try {
                    this.stream.start();
                  } catch (e) {
                    se.defer(() => {
                      (this.onError(e), this.onClose(1006, `Could not start streaming`, !1));
                    });
                  }
                }
                closeStream() {
                  this.stream &&= (this.stream.unbind_all(), this.stream.close(), null);
                }
              }
              function Ot(e) {
                var t = /([^\?]*)\/*(\??.*)/.exec(e);
                return {
                  base: t[1],
                  queryString: t[2],
                };
              }
              function kt(e, t) {
                return e.base + `/` + t + `/xhr_send`;
              }
              function At(e) {
                return e + (e.indexOf(`?`) === -1 ? `?` : `&`) + `t=` + +new Date() + `&n=` + Et++;
              }
              function jt(e, t) {
                var n = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(e);
                return n[1] + t + n[3];
              }
              function Mt(e) {
                return zt.randomInt(e);
              }
              function Nt(e) {
                for (var t = [], n = 0; n < e; n++) t.push(Mt(32).toString(32));
                return t.join(``);
              }
              let Pt = Dt,
                Ft = {
                  getReceiveURL: function (e, t) {
                    return e.base + `/` + t + `/xhr_streaming` + e.queryString;
                  },
                  onHeartbeat: function (e) {
                    e.sendRaw(`[]`);
                  },
                  sendHeartbeat: function (e) {
                    e.sendRaw(`[]`);
                  },
                  onFinished: function (e, t) {
                    e.onClose(1006, `Connection interrupted (` + t + `)`, !1);
                  },
                },
                It = {
                  getReceiveURL: function (e, t) {
                    return e.base + `/` + t + `/xhr` + e.queryString;
                  },
                  onHeartbeat: function () {},
                  sendHeartbeat: function (e) {
                    e.sendRaw(`[]`);
                  },
                  onFinished: function (e, t) {
                    t === 200
                      ? e.reconnect()
                      : e.onClose(1006, `Connection interrupted (` + t + `)`, !1);
                  },
                },
                Lt = {
                  getRequest: function (e) {
                    var t = new (zt.getXHRAPI())();
                    return (
                      (t.onreadystatechange = t.onprogress =
                        function () {
                          switch (t.readyState) {
                            case 3:
                              t.responseText &&
                                t.responseText.length > 0 &&
                                e.onChunk(t.status, t.responseText);
                              break;
                            case 4:
                              (t.responseText &&
                                t.responseText.length > 0 &&
                                e.onChunk(t.status, t.responseText),
                                e.emit(`finished`, t.status),
                                e.close());
                              break;
                          }
                        }),
                      t
                    );
                  },
                  abortRequest: function (e) {
                    ((e.onreadystatechange = null), e.abort());
                  },
                },
                Rt = {
                  createStreamingSocket(e) {
                    return this.createSocket(Ft, e);
                  },
                  createPollingSocket(e) {
                    return this.createSocket(It, e);
                  },
                  createSocket(e, t) {
                    return new Pt(e, t);
                  },
                  createXHR(e, t) {
                    return this.createRequest(Lt, e, t);
                  },
                  createRequest(e, t, n) {
                    return new Ct(e, t, n);
                  },
                };
              Rt.createXDR = function (e, t) {
                return this.createRequest(St, e, t);
              };
              let zt = {
                nextAuthCallbackID: 1,
                auth_callbacks: {},
                ScriptReceivers: i,
                DependenciesReceivers: s,
                getDefaultStrategy: bt,
                Transports: We,
                transportConnectionInitializer: xt,
                HTTPFactory: Rt,
                TimelineTransport: Te,
                getXHRAPI() {
                  return window.XMLHttpRequest;
                },
                getWebSocketAPI() {
                  return window.WebSocket || window.MozWebSocket;
                },
                setup(e) {
                  window.Pusher = e;
                  var t = () => {
                    this.onDocumentBody(e.ready);
                  };
                  window.JSON ? t() : c.load(`json2`, {}, t);
                },
                getDocument() {
                  return document;
                },
                getProtocol() {
                  return this.getDocument().location.protocol;
                },
                getAuthorizers() {
                  return {
                    ajax: S,
                    jsonp: Se,
                  };
                },
                onDocumentBody(e) {
                  document.body
                    ? e()
                    : setTimeout(() => {
                        this.onDocumentBody(e);
                      }, 0);
                },
                createJSONPRequest(e, t) {
                  return new we(e, t);
                },
                createScriptRequest(e) {
                  return new Ce(e);
                },
                getLocalStorage() {
                  try {
                    return window.localStorage;
                  } catch {
                    return;
                  }
                },
                createXHR() {
                  return this.getXHRAPI() ? this.createXMLHttpRequest() : this.createMicrosoftXHR();
                },
                createXMLHttpRequest() {
                  return new (this.getXHRAPI())();
                },
                createMicrosoftXHR() {
                  return new ActiveXObject(`Microsoft.XMLHTTP`);
                },
                getNetwork() {
                  return Ge;
                },
                createWebSocket(e) {
                  return new (this.getWebSocketAPI())(e);
                },
                createSocketRequest(e, t) {
                  if (this.isXHRSupported()) return this.HTTPFactory.createXHR(e, t);
                  if (this.isXDRSupported(t.indexOf(`https:`) === 0))
                    return this.HTTPFactory.createXDR(e, t);
                  throw `Cross-origin HTTP requests are not supported`;
                },
                isXHRSupported() {
                  var e = this.getXHRAPI();
                  return !!e && new e().withCredentials !== void 0;
                },
                isXDRSupported(e) {
                  var t = e ? `https:` : `http:`,
                    n = this.getProtocol();
                  return !!window.XDomainRequest && n === t;
                },
                addUnloadListener(e) {
                  window.addEventListener === void 0
                    ? window.attachEvent !== void 0 && window.attachEvent(`onunload`, e)
                    : window.addEventListener(`unload`, e, !1);
                },
                removeUnloadListener(e) {
                  window.addEventListener === void 0
                    ? window.detachEvent !== void 0 && window.detachEvent(`onunload`, e)
                    : window.removeEventListener(`unload`, e, !1);
                },
                randomInt(e) {
                  return Math.floor(
                    (function () {
                      return (
                        (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] /
                        2 ** 32
                      );
                    })() * e,
                  );
                },
              };
              var Bt;
              (function (e) {
                ((e[(e.ERROR = 3)] = `ERROR`),
                  (e[(e.INFO = 6)] = `INFO`),
                  (e[(e.DEBUG = 7)] = `DEBUG`));
              })((Bt ||= {}));
              let Vt = Bt;
              class Ht {
                constructor(e, t, n) {
                  ((this.key = e),
                    (this.session = t),
                    (this.events = []),
                    (this.options = n || {}),
                    (this.sent = 0),
                    (this.uniqueID = 0));
                }
                log(e, t) {
                  e <= this.options.level &&
                    (this.events.push(
                      ce({}, t, {
                        timestamp: se.now(),
                      }),
                    ),
                    this.options.limit &&
                      this.events.length > this.options.limit &&
                      this.events.shift());
                }
                error(e) {
                  this.log(Vt.ERROR, e);
                }
                info(e) {
                  this.log(Vt.INFO, e);
                }
                debug(e) {
                  this.log(Vt.DEBUG, e);
                }
                isEmpty() {
                  return this.events.length === 0;
                }
                send(e, t) {
                  var n = ce(
                    {
                      session: this.session,
                      bundle: this.sent + 1,
                      key: this.key,
                      lib: `js`,
                      version: this.options.version,
                      cluster: this.options.cluster,
                      features: this.options.features,
                      timeline: this.events,
                    },
                    this.options.params,
                  );
                  return (
                    (this.events = []),
                    e(n, (e, n) => {
                      (e || this.sent++, t && t(e, n));
                    }),
                    !0
                  );
                }
                generateUniqueID() {
                  return (this.uniqueID++, this.uniqueID);
                }
              }
              class Ut {
                constructor(e, t, n, r) {
                  ((this.name = e),
                    (this.priority = t),
                    (this.transport = n),
                    (this.options = r || {}));
                }
                isSupported() {
                  return this.transport.isSupported({
                    useTLS: this.options.useTLS,
                  });
                }
                connect(e, t) {
                  if (!this.isSupported()) return Wt(new b(), t);
                  if (this.priority < e) return Wt(new h(), t);
                  var n = !1,
                    r = this.transport.createConnection(
                      this.name,
                      this.priority,
                      this.options.key,
                      this.options,
                    ),
                    i = null,
                    a = function () {
                      (r.unbind(`initialized`, a), r.connect());
                    },
                    o = function () {
                      i = at.createHandshake(r, function (e) {
                        ((n = !0), l(), t(null, e));
                      });
                    },
                    s = function (e) {
                      (l(), t(e));
                    },
                    c = function () {
                      (l(), t(new g(I(r))));
                    },
                    l = function () {
                      (r.unbind(`initialized`, a),
                        r.unbind(`open`, o),
                        r.unbind(`error`, s),
                        r.unbind(`closed`, c));
                    };
                  return (
                    r.bind(`initialized`, a),
                    r.bind(`open`, o),
                    r.bind(`error`, s),
                    r.bind(`closed`, c),
                    r.initialize(),
                    {
                      abort: () => {
                        n || (l(), i ? i.close() : r.close());
                      },
                      forceMinPriority: (e) => {
                        n || (this.priority < e && (i ? i.close() : r.close()));
                      },
                    }
                  );
                }
              }
              function Wt(e, t) {
                return (
                  se.defer(function () {
                    t(e);
                  }),
                  {
                    abort: function () {},
                    forceMinPriority: function () {},
                  }
                );
              }
              let { Transports: Gt } = zt;
              var Kt = function (e, t, n, r, i, a) {
                  var o = Gt[n];
                  if (!o) throw new y(n);
                  var s =
                      (!e.enabledTransports || ue(e.enabledTransports, t) !== -1) &&
                      (!e.disabledTransports || ue(e.disabledTransports, t) === -1),
                    c;
                  return (
                    s
                      ? ((i = Object.assign(
                          {
                            ignoreNullOrigin: e.ignoreNullOrigin,
                          },
                          i,
                        )),
                        (c = new Ut(t, r, a ? a.getAssistant(o) : o, i)))
                      : (c = qt),
                    c
                  );
                },
                qt = {
                  isSupported: function () {
                    return !1;
                  },
                  connect: function (e, t) {
                    var n = se.defer(function () {
                      t(new b());
                    });
                    return {
                      abort: function () {
                        n.ensureAborted();
                      },
                      forceMinPriority: function () {},
                    };
                  },
                };
              function Jt(e) {
                if (e == null) throw `You must pass an options object`;
                if (e.cluster == null) throw `Options object must provide a cluster`;
                `disableStats` in e &&
                  xe.warn(`The disableStats option is deprecated in favor of enableStats`);
              }
              let Yt = (e, t) => {
                  var n = `socket_id=` + encodeURIComponent(e.socketId);
                  for (var r in t.params)
                    n += `&` + encodeURIComponent(r) + `=` + encodeURIComponent(t.params[r]);
                  if (t.paramsProvider != null) {
                    let e = t.paramsProvider();
                    for (var r in e)
                      n += `&` + encodeURIComponent(r) + `=` + encodeURIComponent(e[r]);
                  }
                  return n;
                },
                Xt = (e) => {
                  if (zt.getAuthorizers()[e.transport] === void 0)
                    throw `'${e.transport}' is not a recognized auth transport`;
                  return (t, n) => {
                    let r = Yt(t, e);
                    zt.getAuthorizers()[e.transport](zt, r, e, d.UserAuthentication, n);
                  };
                },
                Zt = (e, t) => {
                  var n = `socket_id=` + encodeURIComponent(e.socketId);
                  for (var r in ((n += `&channel_name=` + encodeURIComponent(e.channelName)),
                  t.params))
                    n += `&` + encodeURIComponent(r) + `=` + encodeURIComponent(t.params[r]);
                  if (t.paramsProvider != null) {
                    let e = t.paramsProvider();
                    for (var r in e)
                      n += `&` + encodeURIComponent(r) + `=` + encodeURIComponent(e[r]);
                  }
                  return n;
                },
                Qt = (e) => {
                  if (zt.getAuthorizers()[e.transport] === void 0)
                    throw `'${e.transport}' is not a recognized auth transport`;
                  return (t, n) => {
                    let r = Zt(t, e);
                    zt.getAuthorizers()[e.transport](zt, r, e, d.ChannelAuthorization, n);
                  };
                },
                $t = (e, t, n) => {
                  let r = {
                    authTransport: t.transport,
                    authEndpoint: t.endpoint,
                    auth: {
                      params: t.params,
                      headers: t.headers,
                    },
                  };
                  return (t, i) => {
                    n(e.channel(t.channelName), r).authorize(t.socketId, i);
                  };
                };
              function en(e, t) {
                let n = {
                  activityTimeout: e.activityTimeout || a.activityTimeout,
                  cluster: e.cluster,
                  httpPath: e.httpPath || a.httpPath,
                  httpPort: e.httpPort || a.httpPort,
                  httpsPort: e.httpsPort || a.httpsPort,
                  pongTimeout: e.pongTimeout || a.pongTimeout,
                  statsHost: e.statsHost || a.stats_host,
                  unavailableTimeout: e.unavailableTimeout || a.unavailableTimeout,
                  wsPath: e.wsPath || a.wsPath,
                  wsPort: e.wsPort || a.wsPort,
                  wssPort: e.wssPort || a.wssPort,
                  enableStats: on(e),
                  httpHost: tn(e),
                  useTLS: an(e),
                  wsHost: nn(e),
                  userAuthenticator: cn(e),
                  channelAuthorizer: un(e, t),
                };
                return (
                  `disabledTransports` in e && (n.disabledTransports = e.disabledTransports),
                  `enabledTransports` in e && (n.enabledTransports = e.enabledTransports),
                  `ignoreNullOrigin` in e && (n.ignoreNullOrigin = e.ignoreNullOrigin),
                  `timelineParams` in e && (n.timelineParams = e.timelineParams),
                  `nacl` in e && (n.nacl = e.nacl),
                  n
                );
              }
              function tn(e) {
                return e.httpHost
                  ? e.httpHost
                  : e.cluster
                    ? `sockjs-${e.cluster}.pusher.com`
                    : a.httpHost;
              }
              function nn(e) {
                return e.wsHost ? e.wsHost : rn(e.cluster);
              }
              function rn(e) {
                return `ws-${e}.pusher.com`;
              }
              function an(e) {
                return zt.getProtocol() === `https:` ? !0 : e.forceTLS !== !1;
              }
              function on(e) {
                return `enableStats` in e
                  ? e.enableStats
                  : `disableStats` in e
                    ? !e.disableStats
                    : !1;
              }
              let sn = (e) => `customHandler` in e && e.customHandler != null;
              function cn(e) {
                let t = Object.assign(
                  Object.assign({}, a.userAuthentication),
                  e.userAuthentication,
                );
                return sn(t) ? t.customHandler : Xt(t);
              }
              function ln(e, t) {
                let n;
                if (`channelAuthorization` in e)
                  n = Object.assign(
                    Object.assign({}, a.channelAuthorization),
                    e.channelAuthorization,
                  );
                else if (
                  ((n = {
                    transport: e.authTransport || a.authTransport,
                    endpoint: e.authEndpoint || a.authEndpoint,
                  }),
                  `auth` in e &&
                    (`params` in e.auth && (n.params = e.auth.params),
                    `headers` in e.auth && (n.headers = e.auth.headers)),
                  `authorizer` in e)
                )
                  return {
                    customHandler: $t(t, n, e.authorizer),
                  };
                return n;
              }
              function un(e, t) {
                let n = ln(e, t);
                return sn(n) ? n.customHandler : Qt(n);
              }
              class dn extends R {
                constructor(e) {
                  (super(function (e, t) {
                    xe.debug(`No callbacks on watchlist events for ${e}`);
                  }),
                    (this.pusher = e),
                    this.bindWatchlistInternalEvent());
                }
                handleEvent(e) {
                  e.data.events.forEach((e) => {
                    this.emit(e.name, e);
                  });
                }
                bindWatchlistInternalEvent() {
                  this.pusher.connection.bind(`message`, (e) => {
                    e.event === `pusher_internal:watchlist_events` && this.handleEvent(e);
                  });
                }
              }
              function fn() {
                let e, t;
                return {
                  promise: new Promise((n, r) => {
                    ((e = n), (t = r));
                  }),
                  resolve: e,
                  reject: t,
                };
              }
              let pn = fn;
              class mn extends R {
                constructor(e) {
                  (super(function (e, t) {
                    xe.debug(`No callbacks on user for ` + e);
                  }),
                    (this.signin_requested = !1),
                    (this.user_data = null),
                    (this.serverToUserChannel = null),
                    (this.signinDonePromise = null),
                    (this._signinDoneResolve = null),
                    (this._onAuthorize = (e, t) => {
                      if (e) {
                        (xe.warn(`Error during signin: ${e}`), this._cleanup());
                        return;
                      }
                      this.pusher.send_event(`pusher:signin`, {
                        auth: t.auth,
                        user_data: t.user_data,
                      });
                    }),
                    (this.pusher = e),
                    this.pusher.connection.bind(`state_change`, ({ previous: e, current: t }) => {
                      (e !== `connected` && t === `connected` && this._signin(),
                        e === `connected` &&
                          t !== `connected` &&
                          (this._cleanup(), this._newSigninPromiseIfNeeded()));
                    }),
                    (this.watchlist = new dn(e)),
                    this.pusher.connection.bind(`message`, (e) => {
                      (e.event === `pusher:signin_success` && this._onSigninSuccess(e.data),
                        this.serverToUserChannel &&
                          this.serverToUserChannel.name === e.channel &&
                          this.serverToUserChannel.handleEvent(e));
                    }));
                }
                signin() {
                  this.signin_requested || ((this.signin_requested = !0), this._signin());
                }
                _signin() {
                  this.signin_requested &&
                    (this._newSigninPromiseIfNeeded(),
                    this.pusher.connection.state === `connected` &&
                      this.pusher.config.userAuthenticator(
                        {
                          socketId: this.pusher.connection.socket_id,
                        },
                        this._onAuthorize,
                      ));
                }
                _onSigninSuccess(e) {
                  try {
                    this.user_data = JSON.parse(e.user_data);
                  } catch {
                    (xe.error(`Failed parsing user data after signin: ${e.user_data}`),
                      this._cleanup());
                    return;
                  }
                  if (typeof this.user_data.id != `string` || this.user_data.id === ``) {
                    (xe.error(`user_data doesn't contain an id. user_data: ${this.user_data}`),
                      this._cleanup());
                    return;
                  }
                  (this._signinDoneResolve(), this._subscribeChannels());
                }
                _subscribeChannels() {
                  let e = (e) => {
                    e.subscriptionPending && e.subscriptionCancelled
                      ? e.reinstateSubscription()
                      : !e.subscriptionPending &&
                        this.pusher.connection.state === `connected` &&
                        e.subscribe();
                  };
                  ((this.serverToUserChannel = new U(
                    `#server-to-user-${this.user_data.id}`,
                    this.pusher,
                  )),
                    this.serverToUserChannel.bind_global((e, t) => {
                      e.indexOf(`pusher_internal:`) === 0 ||
                        e.indexOf(`pusher:`) === 0 ||
                        this.emit(e, t);
                    }),
                    e(this.serverToUserChannel));
                }
                _cleanup() {
                  ((this.user_data = null),
                    (this.serverToUserChannel &&=
                      (this.serverToUserChannel.unbind_all(),
                      this.serverToUserChannel.disconnect(),
                      null)),
                    this.signin_requested && this._signinDoneResolve());
                }
                _newSigninPromiseIfNeeded() {
                  if (
                    !this.signin_requested ||
                    (this.signinDonePromise && !this.signinDonePromise.done)
                  )
                    return;
                  let { promise: e, resolve: t, reject: n } = pn();
                  e.done = !1;
                  let r = () => {
                    e.done = !0;
                  };
                  (e.then(r).catch(r), (this.signinDonePromise = e), (this._signinDoneResolve = t));
                }
              }
              class hn {
                static ready() {
                  hn.isReady = !0;
                  for (var e = 0, t = hn.instances.length; e < t; e++) hn.instances[e].connect();
                }
                static getClientFeatures() {
                  return fe(
                    he(
                      {
                        ws: zt.Transports.ws,
                      },
                      function (e) {
                        return e.isSupported({});
                      },
                    ),
                  );
                }
                constructor(e, t) {
                  (_n(e),
                    Jt(t),
                    (this.key = e),
                    (this.options = t),
                    (this.config = en(this.options, this)),
                    (this.channels = at.createChannels()),
                    (this.global_emitter = new R()),
                    (this.sessionID = zt.randomInt(1e9)),
                    (this.timeline = new Ht(this.key, this.sessionID, {
                      cluster: this.config.cluster,
                      features: hn.getClientFeatures(),
                      params: this.config.timelineParams || {},
                      limit: 50,
                      level: Vt.INFO,
                      version: a.VERSION,
                    })),
                    this.config.enableStats &&
                      (this.timelineSender = at.createTimelineSender(this.timeline, {
                        host: this.config.statsHost,
                        path: `/timeline/v2/` + zt.TimelineTransport.name,
                      })));
                  var n = (e) => zt.getDefaultStrategy(this.config, e, Kt);
                  ((this.connection = at.createConnectionManager(this.key, {
                    getStrategy: n,
                    timeline: this.timeline,
                    activityTimeout: this.config.activityTimeout,
                    pongTimeout: this.config.pongTimeout,
                    unavailableTimeout: this.config.unavailableTimeout,
                    useTLS: !!this.config.useTLS,
                  })),
                    this.connection.bind(`connected`, () => {
                      (this.subscribeAll(),
                        this.timelineSender &&
                          this.timelineSender.send(this.connection.isUsingTLS()));
                    }),
                    this.connection.bind(`message`, (e) => {
                      var t = e.event.indexOf(`pusher_internal:`) === 0;
                      if (e.channel) {
                        var n = this.channel(e.channel);
                        n && n.handleEvent(e);
                      }
                      t || this.global_emitter.emit(e.event, e.data);
                    }),
                    this.connection.bind(`connecting`, () => {
                      this.channels.disconnect();
                    }),
                    this.connection.bind(`disconnected`, () => {
                      this.channels.disconnect();
                    }),
                    this.connection.bind(`error`, (e) => {
                      xe.warn(e);
                    }),
                    hn.instances.push(this),
                    this.timeline.info({
                      instances: hn.instances.length,
                    }),
                    (this.user = new mn(this)),
                    hn.isReady && this.connect());
                }
                switchCluster(e) {
                  let { appKey: t, cluster: n } = e;
                  ((this.key = t),
                    (this.options = Object.assign(Object.assign({}, this.options), {
                      cluster: n,
                    })),
                    (this.config = en(this.options, this)),
                    this.connection.switchCluster(this.key));
                }
                channel(e) {
                  return this.channels.find(e);
                }
                allChannels() {
                  return this.channels.all();
                }
                connect() {
                  if (
                    (this.connection.connect(), this.timelineSender && !this.timelineSenderTimer)
                  ) {
                    var e = this.connection.isUsingTLS(),
                      t = this.timelineSender;
                    this.timelineSenderTimer = new oe(6e4, function () {
                      t.send(e);
                    });
                  }
                }
                disconnect() {
                  (this.connection.disconnect(),
                    (this.timelineSenderTimer &&=
                      (this.timelineSenderTimer.ensureAborted(), null)));
                }
                bind(e, t, n) {
                  return (this.global_emitter.bind(e, t, n), this);
                }
                unbind(e, t, n) {
                  return (this.global_emitter.unbind(e, t, n), this);
                }
                bind_global(e) {
                  return (this.global_emitter.bind_global(e), this);
                }
                unbind_global(e) {
                  return (this.global_emitter.unbind_global(e), this);
                }
                unbind_all(e) {
                  return (this.global_emitter.unbind_all(), this);
                }
                subscribeAll() {
                  for (var e in this.channels.channels)
                    this.channels.channels.hasOwnProperty(e) && this.subscribe(e);
                }
                subscribe(e) {
                  var t = this.channels.add(e, this);
                  return (
                    t.subscriptionPending && t.subscriptionCancelled
                      ? t.reinstateSubscription()
                      : !t.subscriptionPending &&
                        this.connection.state === `connected` &&
                        t.subscribe(),
                    t
                  );
                }
                unsubscribe(e) {
                  var t = this.channels.find(e);
                  t && t.subscriptionPending
                    ? t.cancelSubscription()
                    : ((t = this.channels.remove(e)), t && t.subscribed && t.unsubscribe());
                }
                send_event(e, t, n) {
                  return this.connection.send_event(e, t, n);
                }
                shouldUseTLS() {
                  return this.config.useTLS;
                }
                signin() {
                  this.user.signin();
                }
              }
              ((hn.instances = []),
                (hn.isReady = !1),
                (hn.logToConsole = !1),
                (hn.Runtime = zt),
                (hn.ScriptReceivers = zt.ScriptReceivers),
                (hn.DependenciesReceivers = zt.DependenciesReceivers),
                (hn.auth_callbacks = zt.auth_callbacks));
              let gn = hn;
              function _n(e) {
                if (e == null) throw `You must pass your app key when you instantiate Pusher.`;
              }
              zt.setup(hn);
            },
          },
          t = {};
        function n(r) {
          var i = t[r];
          if (i !== void 0) return i.exports;
          var a = (t[r] = {
            exports: {},
          });
          return (e[r].call(a.exports, a, a.exports, n), a.exports);
        }
        return (
          (n.d = (e, t) => {
            for (var r in t)
              n.o(t, r) &&
                !n.o(e, r) &&
                Object.defineProperty(e, r, {
                  enumerable: !0,
                  get: t[r],
                });
          }),
          (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
          n(721)
        );
      })(),
    );
  })(),
  1,
);
window.Pusher = En.default;
var Dn = class e extends Error {
    constructor(t, n) {
      var r = `KaTeX parse error: ` + t,
        i,
        a,
        o = n && n.loc;
      if (o && o.start <= o.end) {
        var s = o.lexer.input;
        ((i = o.start),
          (a = o.end),
          i === s.length ? (r += ` at end of input: `) : (r += ` at position ` + (i + 1) + `: `));
        var c = s.slice(i, a).replace(/[^]/g, `$&̲`),
          l = i > 15 ? `…` + s.slice(i - 15, i) : s.slice(0, i),
          u = a + 15 < s.length ? s.slice(a, a + 15) + `…` : s.slice(a);
        r += l + c + u;
      }
      (super(r),
        (this.name = `ParseError`),
        (this.position = void 0),
        (this.length = void 0),
        (this.rawMessage = void 0),
        Object.setPrototypeOf(this, e.prototype),
        (this.position = i),
        i != null && a != null && (this.length = a - i),
        (this.rawMessage = t));
    }
  },
  On = /([A-Z])/g,
  kn = (e) => e.replace(On, `-$1`).toLowerCase(),
  An = {
    "&": `&amp;`,
    ">": `&gt;`,
    "<": `&lt;`,
    '"': `&quot;`,
    "'": `&#x27;`,
  },
  jn = /[&><"']/g,
  Mn = (e) => String(e).replace(jn, (e) => An[e]),
  Nn = (e) =>
    e.type === `ordgroup` || e.type === `color`
      ? e.body.length === 1
        ? Nn(e.body[0])
        : e
      : e.type === `font`
        ? Nn(e.body)
        : e,
  Pn = new Set([`mathord`, `textord`, `atom`]),
  Fn = (e) => Pn.has(Nn(e).type),
  In = (e) => {
    var t = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(e);
    return t
      ? t[2] !== `:` || !/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(t[1])
        ? null
        : t[1].toLowerCase()
      : `_relative`;
  },
  Ln = {
    displayMode: {
      type: `boolean`,
      description: `Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.`,
      cli: `-d, --display-mode`,
    },
    output: {
      type: {
        enum: [`htmlAndMathml`, `html`, `mathml`],
      },
      description: `Determines the markup language of the output.`,
      cli: `-F, --format <type>`,
    },
    leqno: {
      type: `boolean`,
      description: `Render display math in leqno style (left-justified tags).`,
    },
    fleqn: {
      type: `boolean`,
      description: `Render display math flush left.`,
    },
    throwOnError: {
      type: `boolean`,
      default: !0,
      cli: `-t, --no-throw-on-error`,
      cliDescription: `Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error.`,
    },
    errorColor: {
      type: `string`,
      default: `#cc0000`,
      cli: `-c, --error-color <color>`,
      cliDescription: `A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.`,
      cliProcessor: (e) => `#` + e,
    },
    macros: {
      type: `object`,
      cli: `-m, --macro <def>`,
      cliDescription: `Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).`,
      cliDefault: [],
      cliProcessor: (e, t) => (t.push(e), t),
    },
    minRuleThickness: {
      type: `number`,
      description:
        "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
      processor: (e) => Math.max(0, e),
      cli: `--min-rule-thickness <size>`,
      cliProcessor: parseFloat,
    },
    colorIsTextColor: {
      type: `boolean`,
      description: `Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.`,
      cli: `-b, --color-is-text-color`,
    },
    strict: {
      type: [
        {
          enum: [`warn`, `ignore`, `error`],
        },
        `boolean`,
        `function`,
      ],
      description: `Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.`,
      cli: `-S, --strict`,
      cliDefault: !1,
    },
    trust: {
      type: [`boolean`, `function`],
      description: `Trust the input, enabling all HTML features such as \\url.`,
      cli: `-T, --trust`,
    },
    maxSize: {
      type: `number`,
      default: 1 / 0,
      description: `If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large`,
      processor: (e) => Math.max(0, e),
      cli: `-s, --max-size <n>`,
      cliProcessor: parseInt,
    },
    maxExpand: {
      type: `number`,
      default: 1e3,
      description: `Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.`,
      processor: (e) => Math.max(0, e),
      cli: `-e, --max-expand <n>`,
      cliProcessor: (e) => (e === `Infinity` ? 1 / 0 : parseInt(e)),
    },
    globalGroup: {
      type: `boolean`,
      cli: !1,
    },
  };
function Rn(e) {
  if (typeof e != `string`) return e.enum[0];
  switch (e) {
    case `boolean`:
      return !1;
    case `string`:
      return ``;
    case `number`:
      return 0;
    case `object`:
      return {};
    default:
      throw Error(`Unexpected schema type; settings must declare an explicit default.`);
  }
}
function zn(e) {
  return e.default === void 0 ? Rn(Array.isArray(e.type) ? e.type[0] : e.type) : e.default;
}
function Bn(e, t, n, r) {
  var i = n[t];
  e[t] = i === void 0 ? zn(r) : r.processor ? r.processor(i) : i;
}
var Vn = class {
    constructor(e) {
      (e === void 0 && (e = {}),
        (this.displayMode = void 0),
        (this.output = void 0),
        (this.leqno = void 0),
        (this.fleqn = void 0),
        (this.throwOnError = void 0),
        (this.errorColor = void 0),
        (this.macros = void 0),
        (this.minRuleThickness = void 0),
        (this.colorIsTextColor = void 0),
        (this.strict = void 0),
        (this.trust = void 0),
        (this.maxSize = void 0),
        (this.maxExpand = void 0),
        (this.globalGroup = void 0),
        (e ||= {}));
      for (var t of Object.keys(Ln)) {
        var n = Ln[t];
        n && Bn(this, t, e, n);
      }
    }
    reportNonstrict(e, t, n) {
      var r = this.strict;
      if ((typeof r == `function` && (r = r(e, t, n)), !(!r || r === `ignore`))) {
        if (r === !0 || r === `error`)
          throw new Dn(
            `LaTeX-incompatible input and strict mode is set to 'error': ` + (t + ` [` + e + `]`),
            n,
          );
        r === `warn`
          ? typeof console < `u` &&
            console.warn(
              `LaTeX-incompatible input and strict mode is set to 'warn': ` + (t + ` [` + e + `]`),
            )
          : typeof console < `u` &&
            console.warn(
              `LaTeX-incompatible input and strict mode is set to ` +
                (`unrecognized '` + r + `': ` + t + ` [` + e + `]`),
            );
      }
    }
    useStrictBehavior(e, t, n) {
      var r = this.strict;
      if (typeof r == `function`)
        try {
          r = r(e, t, n);
        } catch {
          r = `error`;
        }
      return !r || r === `ignore`
        ? !1
        : r === !0 || r === `error`
          ? !0
          : r === `warn`
            ? (typeof console < `u` &&
                console.warn(
                  `LaTeX-incompatible input and strict mode is set to 'warn': ` +
                    (t + ` [` + e + `]`),
                ),
              !1)
            : (typeof console < `u` &&
                console.warn(
                  `LaTeX-incompatible input and strict mode is set to ` +
                    (`unrecognized '` + r + `': ` + t + ` [` + e + `]`),
                ),
              !1);
    }
    isTrusted(e) {
      if (`url` in e && e.url && !e.protocol) {
        var t = In(e.url);
        if (t == null) return !1;
        e.protocol = t;
      }
      return !!(typeof this.trust == `function` ? this.trust(e) : this.trust);
    }
  },
  Hn = class {
    constructor(e, t, n) {
      ((this.id = void 0),
        (this.size = void 0),
        (this.cramped = void 0),
        (this.id = e),
        (this.size = t),
        (this.cramped = n));
    }
    sup() {
      return Zn[Qn[this.id]];
    }
    sub() {
      return Zn[$n[this.id]];
    }
    fracNum() {
      return Zn[er[this.id]];
    }
    fracDen() {
      return Zn[tr[this.id]];
    }
    cramp() {
      return Zn[nr[this.id]];
    }
    text() {
      return Zn[rr[this.id]];
    }
    isTight() {
      return this.size >= 2;
    }
  },
  Un = 0,
  Wn = 1,
  Gn = 2,
  Kn = 3,
  qn = 4,
  Jn = 5,
  Yn = 6,
  Xn = 7,
  Zn = [
    new Hn(Un, 0, !1),
    new Hn(Wn, 0, !0),
    new Hn(Gn, 1, !1),
    new Hn(Kn, 1, !0),
    new Hn(qn, 2, !1),
    new Hn(Jn, 2, !0),
    new Hn(Yn, 3, !1),
    new Hn(Xn, 3, !0),
  ],
  Qn = [qn, Jn, qn, Jn, Yn, Xn, Yn, Xn],
  $n = [Jn, Jn, Jn, Jn, Xn, Xn, Xn, Xn],
  er = [Gn, Kn, qn, Jn, Yn, Xn, Yn, Xn],
  tr = [Kn, Kn, Jn, Jn, Xn, Xn, Xn, Xn],
  nr = [Wn, Wn, Kn, Kn, Jn, Jn, Xn, Xn],
  rr = [Un, Wn, Gn, Kn, Gn, Kn, Gn, Kn],
  ir = {
    DISPLAY: Zn[Un],
    TEXT: Zn[Gn],
    SCRIPT: Zn[qn],
    SCRIPTSCRIPT: Zn[Yn],
  },
  ar = [
    {
      name: `latin`,
      blocks: [
        [256, 591],
        [768, 879],
      ],
    },
    {
      name: `cyrillic`,
      blocks: [[1024, 1279]],
    },
    {
      name: `armenian`,
      blocks: [[1328, 1423]],
    },
    {
      name: `brahmic`,
      blocks: [[2304, 4255]],
    },
    {
      name: `georgian`,
      blocks: [[4256, 4351]],
    },
    {
      name: `cjk`,
      blocks: [
        [12288, 12543],
        [19968, 40879],
        [65280, 65376],
      ],
    },
    {
      name: `hangul`,
      blocks: [[44032, 55215]],
    },
  ];
function or(e) {
  for (var t = 0; t < ar.length; t++)
    for (var n = ar[t], r = 0; r < n.blocks.length; r++) {
      var i = n.blocks[r];
      if (e >= i[0] && e <= i[1]) return n.name;
    }
  return null;
}
var sr = [];
ar.forEach((e) => e.blocks.forEach((e) => sr.push(...e)));
function cr(e) {
  for (var t = 0; t < sr.length; t += 2) if (e >= sr[t] && e <= sr[t + 1]) return !0;
  return !1;
}
var lr = (e) => e + ` ` + e,
  ur = 80,
  dr = function (e, t) {
    return (
      `M95,` +
      (622 + e + t) +
      `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` +
      e / 2.075 +
      ` -` +
      e +
      `
c5.3,-9.3,12,-14,20,-14
H400000v` +
      (40 + e) +
      `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` +
      (834 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  fr = function (e, t) {
    return (
      `M263,` +
      (601 + e + t) +
      `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` +
      e / 2.084 +
      ` -` +
      e +
      `
c4.7,-7.3,11,-11,19,-11
H40000v` +
      (40 + e) +
      `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` +
      (1001 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  pr = function (e, t) {
    return (
      `M983 ` +
      (10 + e + t) +
      `
l` +
      e / 3.13 +
      ` -` +
      e +
      `
c4,-6.7,10,-10,18,-10 H400000v` +
      (40 + e) +
      `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` +
      (1001 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  mr = function (e, t) {
    return (
      `M424,` +
      (2398 + e + t) +
      `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` +
      e / 4.223 +
      ` -` +
      e +
      `c4,-6.7,10,-10,18,-10 H400000
v` +
      (40 + e) +
      `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` +
      (1001 + e) +
      ` ` +
      t +
      `
h400000v` +
      (40 + e) +
      `h-400000z`
    );
  },
  hr = function (e, t) {
    return (
      `M473,` +
      (2713 + e + t) +
      `
c339.3,-1799.3,509.3,-2700,510,-2702 l` +
      e / 5.298 +
      ` -` +
      e +
      `
c3.3,-7.3,9.3,-11,18,-11 H400000v` +
      (40 + e) +
      `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` +
      (1001 + e) +
      ` ` +
      t +
      `h400000v` +
      (40 + e) +
      `H1017.7z`
    );
  },
  gr = function (e) {
    var t = e / 2;
    return `M400000 ` + e + ` H0 L` + t + ` 0 l65 45 L145 ` + (e - 80) + ` H400000z`;
  },
  _r = function (e, t, n) {
    var r = n - 54 - t - e;
    return (
      `M702 ` +
      (e + t) +
      `H400000` +
      (40 + e) +
      `
H742v` +
      r +
      `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` +
      t +
      `H400000v` +
      (40 + e) +
      `H742z`
    );
  },
  vr = function (e, t, n) {
    t = 1e3 * t;
    var r = ``;
    switch (e) {
      case `sqrtMain`:
        r = dr(t, ur);
        break;
      case `sqrtSize1`:
        r = fr(t, ur);
        break;
      case `sqrtSize2`:
        r = pr(t, ur);
        break;
      case `sqrtSize3`:
        r = mr(t, ur);
        break;
      case `sqrtSize4`:
        r = hr(t, ur);
        break;
      case `sqrtTall`:
        r = _r(t, ur, n);
    }
    return r;
  },
  yr = function (e, t) {
    switch (e) {
      case `⎜`:
        return lr(`M291 0 H417 V` + t + ` H291z`);
      case `∣`:
        return lr(`M145 0 H188 V` + t + ` H145z`);
      case `∥`:
        return lr(`M145 0 H188 V` + t + ` H145z`) + lr(`M367 0 H410 V` + t + ` H367z`);
      case `⎟`:
        return lr(`M457 0 H583 V` + t + ` H457z`);
      case `⎢`:
        return lr(`M319 0 H403 V` + t + ` H319z`);
      case `⎥`:
        return lr(`M263 0 H347 V` + t + ` H263z`);
      case `⎪`:
        return lr(`M384 0 H504 V` + t + ` H384z`);
      case `⏐`:
        return lr(`M312 0 H355 V` + t + ` H312z`);
      case `‖`:
        return lr(`M257 0 H300 V` + t + ` H257z`) + lr(`M478 0 H521 V` + t + ` H478z`);
      default:
        return ``;
    }
  },
  br = {
    doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
    doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
    leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
    leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
    leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
    leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
    leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
    leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
    leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
    leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
    leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
    lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
    leftlinesegment: lr(`M40 281 V428 H0 V94 H40 V241 H400000 v40z`),
    leftbracketunder: lr(`M0 0 h120 V290 H399995 v120 H0z`),
    leftbracketover: lr(`M0 440 h120 V150 H399995 v-120 H0z`),
    leftmapsto: lr(`M40 281 V448H0V74H40V241H400000v40z`),
    leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
    longequal: lr(`M0 50 h400000 v40H0z m0 194h40000v40H0z`),
    midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
    midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
    oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
    oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
    oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
    oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
    rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
    rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
    rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
    rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
    rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
    rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
    rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
    rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
    rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
    righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
    rightlinesegment: lr(`M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`),
    rightbracketunder: lr(`M399995 0 h-120 V290 H0 v120 H400000z`),
    rightbracketover: lr(`M399995 440 h-120 V150 H0 v-120 H399995z`),
    rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
    twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
    twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
    tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
    tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
    tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
    tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
    vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
    widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
    widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
    widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
    widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
    widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
    widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
    widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
    widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
    baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
    rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
    baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
    rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
    shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
    shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`,
  },
  xr = function (e, t) {
    switch (e) {
      case `lbrack`:
        return (
          `M403 1759 V84 H666 V0 H319 V1759 v` +
          t +
          ` v1759 v84 h347 v-84
H403z M403 1759 V0 H319 V1759 v` +
          t +
          ` v1759 v84 h84z`
        );
      case `rbrack`:
        return (
          `M347 1759 V0 H0 V84 H263 V1759 v` +
          t +
          ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` +
          t +
          ` v1759 h84z`
        );
      case `vert`:
        return (
          `M145 15 v585 v` +
          t +
          ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` +
          -t +
          ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` +
          t +
          ` v585 h43z`
        );
      case `doublevert`:
        return (
          `M145 15 v585 v` +
          t +
          ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` +
          -t +
          ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` +
          t +
          ` v585 h43z
M367 15 v585 v` +
          t +
          ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` +
          -t +
          ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` +
          t +
          ` v585 h43z`
        );
      case `lfloor`:
        return (
          `M319 602 V0 H403 V602 v` +
          t +
          ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` +
          t +
          ` v1715 H319z`
        );
      case `rfloor`:
        return (
          `M319 602 V0 H403 V602 v` +
          t +
          ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` +
          t +
          ` v1715 H319z`
        );
      case `lceil`:
        return (
          `M403 1759 V84 H666 V0 H319 V1759 v` +
          t +
          ` v602 h84z
M403 1759 V0 H319 V1759 v` +
          t +
          ` v602 h84z`
        );
      case `rceil`:
        return (
          `M347 1759 V0 H0 V84 H263 V1759 v` +
          t +
          ` v602 h84z
M347 1759 V0 h-84 V1759 v` +
          t +
          ` v602 h84z`
        );
      case `lparen`:
        return (
          `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` +
          (t + 84) +
          `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` +
          (t + 92) +
          `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`
        );
      case `rparen`:
        return (
          `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` +
          (t + 9) +
          `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` +
          (t + 144) +
          `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`
        );
      default:
        throw Error(`Unknown stretchy delimiter.`);
    }
  };
function Sr(e) {
  return `toText` in e;
}
var Cr = class {
    constructor(e) {
      ((this.children = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        (this.children = e),
        (this.classes = []),
        (this.height = 0),
        (this.depth = 0),
        (this.maxFontSize = 0),
        (this.style = {}));
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      for (var e = document.createDocumentFragment(), t = 0; t < this.children.length; t++)
        e.appendChild(this.children[t].toNode());
      return e;
    }
    toMarkup() {
      for (var e = ``, t = 0; t < this.children.length; t++) e += this.children[t].toMarkup();
      return e;
    }
    toText() {
      return this.children
        .map((e) => {
          if (Sr(e)) return e.toText();
          throw Error(`Expected MathDomNode with toText, got ` + e.constructor.name);
        })
        .join(``);
    }
  },
  wr = {
    pt: 1,
    mm: 7227 / 2540,
    cm: 7227 / 254,
    in: 72.27,
    bp: 803 / 800,
    pc: 12,
    dd: 1238 / 1157,
    cc: 14856 / 1157,
    nd: 685 / 642,
    nc: 1370 / 107,
    sp: 1 / 65536,
    px: 803 / 800,
  },
  Tr = {
    ex: !0,
    em: !0,
    mu: !0,
  },
  Er = function (e) {
    return (typeof e != `string` && (e = e.unit), e in wr || e in Tr || e === `ex`);
  },
  Dr = function (e, t) {
    var n;
    if (e.unit in wr) n = wr[e.unit] / t.fontMetrics().ptPerEm / t.sizeMultiplier;
    else if (e.unit === `mu`) n = t.fontMetrics().cssEmPerMu;
    else {
      var r = t.style.isTight() ? t.havingStyle(t.style.text()) : t;
      if (e.unit === `ex`) n = r.fontMetrics().xHeight;
      else if (e.unit === `em`) n = r.fontMetrics().quad;
      else throw new Dn(`Invalid unit: '` + e.unit + `'`);
      r !== t && (n *= r.sizeMultiplier / t.sizeMultiplier);
    }
    return Math.min(e.number * n, t.maxSize);
  },
  Or = function (e) {
    return +e.toFixed(4) + `em`;
  },
  kr = function (e) {
    return e.filter((e) => e).join(` `);
  },
  Ar = function (e) {
    var t = ``;
    for (var n of Object.keys(e)) {
      var r = e[n];
      r !== void 0 && (t += kn(n) + `:` + r + `;`);
    }
    return t;
  },
  jr = function (e, t, n) {
    if (
      ((this.classes = e || []),
      (this.attributes = {}),
      (this.height = 0),
      (this.depth = 0),
      (this.maxFontSize = 0),
      (this.style = n || {}),
      t)
    ) {
      t.style.isTight() && this.classes.push(`mtight`);
      var r = t.getColor();
      r && (this.style.color = r);
    }
  },
  Mr = function (e) {
    var t = document.createElement(e);
    ((t.className = kr(this.classes)), Object.assign(t.style, this.style));
    for (var n of Object.keys(this.attributes)) t.setAttribute(n, this.attributes[n]);
    for (var r = 0; r < this.children.length; r++) t.appendChild(this.children[r].toNode());
    return t;
  },
  Nr = /[\s"'>/=\x00-\x1f]/,
  Pr = function (e) {
    var t = `<` + e;
    this.classes.length && (t += ` class="` + Mn(kr(this.classes)) + `"`);
    var n = Ar(this.style);
    n && (t += ` style="` + Mn(n) + `"`);
    for (var r of Object.keys(this.attributes)) {
      if (Nr.test(r)) throw new Dn(`Invalid attribute name '` + r + `'`);
      t += ` ` + r + `="` + Mn(this.attributes[r]) + `"`;
    }
    t += `>`;
    for (var i = 0; i < this.children.length; i++) t += this.children[i].toMarkup();
    return ((t += `</` + e + `>`), t);
  },
  Fr = class {
    constructor(e, t, n, r) {
      ((this.children = void 0),
        (this.attributes = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.width = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        (this.italic = void 0),
        jr.call(this, e, n, r),
        (this.children = t || []));
    }
    setAttribute(e, t) {
      this.attributes[e] = t;
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      return Mr.call(this, `span`);
    }
    toMarkup() {
      return Pr.call(this, `span`);
    }
  },
  Ir = class {
    constructor(e, t, n, r) {
      ((this.children = void 0),
        (this.attributes = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        jr.call(this, t, r),
        (this.children = n || []),
        this.setAttribute(`href`, e));
    }
    setAttribute(e, t) {
      this.attributes[e] = t;
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      return Mr.call(this, `a`);
    }
    toMarkup() {
      return Pr.call(this, `a`);
    }
  },
  Lr = class {
    constructor(e, t, n) {
      ((this.src = void 0),
        (this.alt = void 0),
        (this.classes = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.maxFontSize = void 0),
        (this.style = void 0),
        (this.alt = t),
        (this.src = e),
        (this.classes = [`mord`]),
        (this.height = 0),
        (this.depth = 0),
        (this.maxFontSize = 0),
        (this.style = n));
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      var e = document.createElement(`img`);
      return (
        (e.src = this.src),
        (e.alt = this.alt),
        (e.className = `mord`),
        Object.assign(e.style, this.style),
        e
      );
    }
    toMarkup() {
      var e = `<img src="` + Mn(this.src) + `"` + (` alt="` + Mn(this.alt) + `"`),
        t = Ar(this.style);
      return (t && (e += ` style="` + Mn(t) + `"`), (e += `'/>`), e);
    }
  },
  Rr = {
    î: `ı̂`,
    ï: `ı̈`,
    í: `ı́`,
    ì: `ı̀`,
  },
  zr = class {
    constructor(e, t, n, r, i, a, o, s) {
      ((this.text = void 0),
        (this.height = void 0),
        (this.depth = void 0),
        (this.italic = void 0),
        (this.skew = void 0),
        (this.width = void 0),
        (this.maxFontSize = void 0),
        (this.classes = void 0),
        (this.style = void 0),
        (this.text = e),
        (this.height = t || 0),
        (this.depth = n || 0),
        (this.italic = r || 0),
        (this.skew = i || 0),
        (this.width = a || 0),
        (this.classes = o || []),
        (this.style = s || {}),
        (this.maxFontSize = 0));
      var c = or(this.text.charCodeAt(0));
      (c && this.classes.push(c + `_fallback`),
        /[îïíì]/.test(this.text) && (this.text = Rr[this.text]));
    }
    hasClass(e) {
      return this.classes.includes(e);
    }
    toNode() {
      var e = document.createTextNode(this.text),
        t = null;
      return (
        this.italic > 0 &&
          ((t = document.createElement(`span`)), (t.style.marginRight = Or(this.italic))),
        this.classes.length > 0 &&
          ((t ||= document.createElement(`span`)), (t.className = kr(this.classes))),
        Object.keys(this.style).length > 0 &&
          ((t ||= document.createElement(`span`)), Object.assign(t.style, this.style)),
        t ? (t.appendChild(e), t) : e
      );
    }
    toMarkup() {
      var e = !1,
        t = `<span`;
      this.classes.length && ((e = !0), (t += ` class="`), (t += Mn(kr(this.classes))), (t += `"`));
      var n = ``;
      (this.italic > 0 && (n += `margin-right:` + Or(this.italic) + `;`),
        (n += Ar(this.style)),
        n && ((e = !0), (t += ` style="` + Mn(n) + `"`)));
      var r = Mn(this.text);
      return e ? ((t += `>`), (t += r), (t += `</span>`), t) : r;
    }
  },
  Br = class {
    constructor(e, t) {
      ((this.children = void 0),
        (this.attributes = void 0),
        (this.children = e || []),
        (this.attributes = t || {}));
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/2000/svg`, `svg`);
      for (var t of Object.keys(this.attributes)) e.setAttribute(t, this.attributes[t]);
      for (var n = 0; n < this.children.length; n++) e.appendChild(this.children[n].toNode());
      return e;
    }
    toMarkup() {
      var e = `<svg xmlns="http://www.w3.org/2000/svg"`;
      for (var t of Object.keys(this.attributes))
        e += ` ` + t + `="` + Mn(this.attributes[t]) + `"`;
      e += `>`;
      for (var n = 0; n < this.children.length; n++) e += this.children[n].toMarkup();
      return ((e += `</svg>`), e);
    }
  },
  Vr = class {
    constructor(e, t) {
      ((this.pathName = void 0),
        (this.alternate = void 0),
        (this.pathName = e),
        (this.alternate = t));
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/2000/svg`, `path`);
      return (
        this.alternate
          ? e.setAttribute(`d`, this.alternate)
          : e.setAttribute(`d`, br[this.pathName]),
        e
      );
    }
    toMarkup() {
      return this.alternate
        ? `<path d="` + Mn(this.alternate) + `"/>`
        : `<path d="` + Mn(br[this.pathName]) + `"/>`;
    }
  },
  Hr = class {
    constructor(e) {
      ((this.attributes = void 0), (this.attributes = e || {}));
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/2000/svg`, `line`);
      for (var t of Object.keys(this.attributes)) e.setAttribute(t, this.attributes[t]);
      return e;
    }
    toMarkup() {
      var e = `<line`;
      for (var t of Object.keys(this.attributes))
        e += ` ` + t + `="` + Mn(this.attributes[t]) + `"`;
      return ((e += `/>`), e);
    }
  };
function Ur(e) {
  if (e instanceof zr) return e;
  throw Error(`Expected symbolNode but got ` + String(e) + `.`);
}
function Wr(e) {
  if (e instanceof Fr) return e;
  throw Error(`Expected span<HtmlDomNode> but got ` + String(e) + `.`);
}
var Gr = (e) => e instanceof Fr || e instanceof Ir || e instanceof Cr,
  Kr = {
    "AMS-Regular": {
      32: [0, 0, 0, 0, 0.25],
      65: [0, 0.68889, 0, 0, 0.72222],
      66: [0, 0.68889, 0, 0, 0.66667],
      67: [0, 0.68889, 0, 0, 0.72222],
      68: [0, 0.68889, 0, 0, 0.72222],
      69: [0, 0.68889, 0, 0, 0.66667],
      70: [0, 0.68889, 0, 0, 0.61111],
      71: [0, 0.68889, 0, 0, 0.77778],
      72: [0, 0.68889, 0, 0, 0.77778],
      73: [0, 0.68889, 0, 0, 0.38889],
      74: [0.16667, 0.68889, 0, 0, 0.5],
      75: [0, 0.68889, 0, 0, 0.77778],
      76: [0, 0.68889, 0, 0, 0.66667],
      77: [0, 0.68889, 0, 0, 0.94445],
      78: [0, 0.68889, 0, 0, 0.72222],
      79: [0.16667, 0.68889, 0, 0, 0.77778],
      80: [0, 0.68889, 0, 0, 0.61111],
      81: [0.16667, 0.68889, 0, 0, 0.77778],
      82: [0, 0.68889, 0, 0, 0.72222],
      83: [0, 0.68889, 0, 0, 0.55556],
      84: [0, 0.68889, 0, 0, 0.66667],
      85: [0, 0.68889, 0, 0, 0.72222],
      86: [0, 0.68889, 0, 0, 0.72222],
      87: [0, 0.68889, 0, 0, 1],
      88: [0, 0.68889, 0, 0, 0.72222],
      89: [0, 0.68889, 0, 0, 0.72222],
      90: [0, 0.68889, 0, 0, 0.66667],
      107: [0, 0.68889, 0, 0, 0.55556],
      160: [0, 0, 0, 0, 0.25],
      165: [0, 0.675, 0.025, 0, 0.75],
      174: [0.15559, 0.69224, 0, 0, 0.94666],
      240: [0, 0.68889, 0, 0, 0.55556],
      295: [0, 0.68889, 0, 0, 0.54028],
      710: [0, 0.825, 0, 0, 2.33334],
      732: [0, 0.9, 0, 0, 2.33334],
      770: [0, 0.825, 0, 0, 2.33334],
      771: [0, 0.9, 0, 0, 2.33334],
      989: [0.08167, 0.58167, 0, 0, 0.77778],
      1008: [0, 0.43056, 0.04028, 0, 0.66667],
      8245: [0, 0.54986, 0, 0, 0.275],
      8463: [0, 0.68889, 0, 0, 0.54028],
      8487: [0, 0.68889, 0, 0, 0.72222],
      8498: [0, 0.68889, 0, 0, 0.55556],
      8502: [0, 0.68889, 0, 0, 0.66667],
      8503: [0, 0.68889, 0, 0, 0.44445],
      8504: [0, 0.68889, 0, 0, 0.66667],
      8513: [0, 0.68889, 0, 0, 0.63889],
      8592: [-0.03598, 0.46402, 0, 0, 0.5],
      8594: [-0.03598, 0.46402, 0, 0, 0.5],
      8602: [-0.13313, 0.36687, 0, 0, 1],
      8603: [-0.13313, 0.36687, 0, 0, 1],
      8606: [0.01354, 0.52239, 0, 0, 1],
      8608: [0.01354, 0.52239, 0, 0, 1],
      8610: [0.01354, 0.52239, 0, 0, 1.11111],
      8611: [0.01354, 0.52239, 0, 0, 1.11111],
      8619: [0, 0.54986, 0, 0, 1],
      8620: [0, 0.54986, 0, 0, 1],
      8621: [-0.13313, 0.37788, 0, 0, 1.38889],
      8622: [-0.13313, 0.36687, 0, 0, 1],
      8624: [0, 0.69224, 0, 0, 0.5],
      8625: [0, 0.69224, 0, 0, 0.5],
      8630: [0, 0.43056, 0, 0, 1],
      8631: [0, 0.43056, 0, 0, 1],
      8634: [0.08198, 0.58198, 0, 0, 0.77778],
      8635: [0.08198, 0.58198, 0, 0, 0.77778],
      8638: [0.19444, 0.69224, 0, 0, 0.41667],
      8639: [0.19444, 0.69224, 0, 0, 0.41667],
      8642: [0.19444, 0.69224, 0, 0, 0.41667],
      8643: [0.19444, 0.69224, 0, 0, 0.41667],
      8644: [0.1808, 0.675, 0, 0, 1],
      8646: [0.1808, 0.675, 0, 0, 1],
      8647: [0.1808, 0.675, 0, 0, 1],
      8648: [0.19444, 0.69224, 0, 0, 0.83334],
      8649: [0.1808, 0.675, 0, 0, 1],
      8650: [0.19444, 0.69224, 0, 0, 0.83334],
      8651: [0.01354, 0.52239, 0, 0, 1],
      8652: [0.01354, 0.52239, 0, 0, 1],
      8653: [-0.13313, 0.36687, 0, 0, 1],
      8654: [-0.13313, 0.36687, 0, 0, 1],
      8655: [-0.13313, 0.36687, 0, 0, 1],
      8666: [0.13667, 0.63667, 0, 0, 1],
      8667: [0.13667, 0.63667, 0, 0, 1],
      8669: [-0.13313, 0.37788, 0, 0, 1],
      8672: [-0.064, 0.437, 0, 0, 1.334],
      8674: [-0.064, 0.437, 0, 0, 1.334],
      8705: [0, 0.825, 0, 0, 0.5],
      8708: [0, 0.68889, 0, 0, 0.55556],
      8709: [0.08167, 0.58167, 0, 0, 0.77778],
      8717: [0, 0.43056, 0, 0, 0.42917],
      8722: [-0.03598, 0.46402, 0, 0, 0.5],
      8724: [0.08198, 0.69224, 0, 0, 0.77778],
      8726: [0.08167, 0.58167, 0, 0, 0.77778],
      8733: [0, 0.69224, 0, 0, 0.77778],
      8736: [0, 0.69224, 0, 0, 0.72222],
      8737: [0, 0.69224, 0, 0, 0.72222],
      8738: [0.03517, 0.52239, 0, 0, 0.72222],
      8739: [0.08167, 0.58167, 0, 0, 0.22222],
      8740: [0.25142, 0.74111, 0, 0, 0.27778],
      8741: [0.08167, 0.58167, 0, 0, 0.38889],
      8742: [0.25142, 0.74111, 0, 0, 0.5],
      8756: [0, 0.69224, 0, 0, 0.66667],
      8757: [0, 0.69224, 0, 0, 0.66667],
      8764: [-0.13313, 0.36687, 0, 0, 0.77778],
      8765: [-0.13313, 0.37788, 0, 0, 0.77778],
      8769: [-0.13313, 0.36687, 0, 0, 0.77778],
      8770: [-0.03625, 0.46375, 0, 0, 0.77778],
      8774: [0.30274, 0.79383, 0, 0, 0.77778],
      8776: [-0.01688, 0.48312, 0, 0, 0.77778],
      8778: [0.08167, 0.58167, 0, 0, 0.77778],
      8782: [0.06062, 0.54986, 0, 0, 0.77778],
      8783: [0.06062, 0.54986, 0, 0, 0.77778],
      8785: [0.08198, 0.58198, 0, 0, 0.77778],
      8786: [0.08198, 0.58198, 0, 0, 0.77778],
      8787: [0.08198, 0.58198, 0, 0, 0.77778],
      8790: [0, 0.69224, 0, 0, 0.77778],
      8791: [0.22958, 0.72958, 0, 0, 0.77778],
      8796: [0.08198, 0.91667, 0, 0, 0.77778],
      8806: [0.25583, 0.75583, 0, 0, 0.77778],
      8807: [0.25583, 0.75583, 0, 0, 0.77778],
      8808: [0.25142, 0.75726, 0, 0, 0.77778],
      8809: [0.25142, 0.75726, 0, 0, 0.77778],
      8812: [0.25583, 0.75583, 0, 0, 0.5],
      8814: [0.20576, 0.70576, 0, 0, 0.77778],
      8815: [0.20576, 0.70576, 0, 0, 0.77778],
      8816: [0.30274, 0.79383, 0, 0, 0.77778],
      8817: [0.30274, 0.79383, 0, 0, 0.77778],
      8818: [0.22958, 0.72958, 0, 0, 0.77778],
      8819: [0.22958, 0.72958, 0, 0, 0.77778],
      8822: [0.1808, 0.675, 0, 0, 0.77778],
      8823: [0.1808, 0.675, 0, 0, 0.77778],
      8828: [0.13667, 0.63667, 0, 0, 0.77778],
      8829: [0.13667, 0.63667, 0, 0, 0.77778],
      8830: [0.22958, 0.72958, 0, 0, 0.77778],
      8831: [0.22958, 0.72958, 0, 0, 0.77778],
      8832: [0.20576, 0.70576, 0, 0, 0.77778],
      8833: [0.20576, 0.70576, 0, 0, 0.77778],
      8840: [0.30274, 0.79383, 0, 0, 0.77778],
      8841: [0.30274, 0.79383, 0, 0, 0.77778],
      8842: [0.13597, 0.63597, 0, 0, 0.77778],
      8843: [0.13597, 0.63597, 0, 0, 0.77778],
      8847: [0.03517, 0.54986, 0, 0, 0.77778],
      8848: [0.03517, 0.54986, 0, 0, 0.77778],
      8858: [0.08198, 0.58198, 0, 0, 0.77778],
      8859: [0.08198, 0.58198, 0, 0, 0.77778],
      8861: [0.08198, 0.58198, 0, 0, 0.77778],
      8862: [0, 0.675, 0, 0, 0.77778],
      8863: [0, 0.675, 0, 0, 0.77778],
      8864: [0, 0.675, 0, 0, 0.77778],
      8865: [0, 0.675, 0, 0, 0.77778],
      8872: [0, 0.69224, 0, 0, 0.61111],
      8873: [0, 0.69224, 0, 0, 0.72222],
      8874: [0, 0.69224, 0, 0, 0.88889],
      8876: [0, 0.68889, 0, 0, 0.61111],
      8877: [0, 0.68889, 0, 0, 0.61111],
      8878: [0, 0.68889, 0, 0, 0.72222],
      8879: [0, 0.68889, 0, 0, 0.72222],
      8882: [0.03517, 0.54986, 0, 0, 0.77778],
      8883: [0.03517, 0.54986, 0, 0, 0.77778],
      8884: [0.13667, 0.63667, 0, 0, 0.77778],
      8885: [0.13667, 0.63667, 0, 0, 0.77778],
      8888: [0, 0.54986, 0, 0, 1.11111],
      8890: [0.19444, 0.43056, 0, 0, 0.55556],
      8891: [0.19444, 0.69224, 0, 0, 0.61111],
      8892: [0.19444, 0.69224, 0, 0, 0.61111],
      8901: [0, 0.54986, 0, 0, 0.27778],
      8903: [0.08167, 0.58167, 0, 0, 0.77778],
      8905: [0.08167, 0.58167, 0, 0, 0.77778],
      8906: [0.08167, 0.58167, 0, 0, 0.77778],
      8907: [0, 0.69224, 0, 0, 0.77778],
      8908: [0, 0.69224, 0, 0, 0.77778],
      8909: [-0.03598, 0.46402, 0, 0, 0.77778],
      8910: [0, 0.54986, 0, 0, 0.76042],
      8911: [0, 0.54986, 0, 0, 0.76042],
      8912: [0.03517, 0.54986, 0, 0, 0.77778],
      8913: [0.03517, 0.54986, 0, 0, 0.77778],
      8914: [0, 0.54986, 0, 0, 0.66667],
      8915: [0, 0.54986, 0, 0, 0.66667],
      8916: [0, 0.69224, 0, 0, 0.66667],
      8918: [0.0391, 0.5391, 0, 0, 0.77778],
      8919: [0.0391, 0.5391, 0, 0, 0.77778],
      8920: [0.03517, 0.54986, 0, 0, 1.33334],
      8921: [0.03517, 0.54986, 0, 0, 1.33334],
      8922: [0.38569, 0.88569, 0, 0, 0.77778],
      8923: [0.38569, 0.88569, 0, 0, 0.77778],
      8926: [0.13667, 0.63667, 0, 0, 0.77778],
      8927: [0.13667, 0.63667, 0, 0, 0.77778],
      8928: [0.30274, 0.79383, 0, 0, 0.77778],
      8929: [0.30274, 0.79383, 0, 0, 0.77778],
      8934: [0.23222, 0.74111, 0, 0, 0.77778],
      8935: [0.23222, 0.74111, 0, 0, 0.77778],
      8936: [0.23222, 0.74111, 0, 0, 0.77778],
      8937: [0.23222, 0.74111, 0, 0, 0.77778],
      8938: [0.20576, 0.70576, 0, 0, 0.77778],
      8939: [0.20576, 0.70576, 0, 0, 0.77778],
      8940: [0.30274, 0.79383, 0, 0, 0.77778],
      8941: [0.30274, 0.79383, 0, 0, 0.77778],
      8994: [0.19444, 0.69224, 0, 0, 0.77778],
      8995: [0.19444, 0.69224, 0, 0, 0.77778],
      9416: [0.15559, 0.69224, 0, 0, 0.90222],
      9484: [0, 0.69224, 0, 0, 0.5],
      9488: [0, 0.69224, 0, 0, 0.5],
      9492: [0, 0.37788, 0, 0, 0.5],
      9496: [0, 0.37788, 0, 0, 0.5],
      9585: [0.19444, 0.68889, 0, 0, 0.88889],
      9586: [0.19444, 0.74111, 0, 0, 0.88889],
      9632: [0, 0.675, 0, 0, 0.77778],
      9633: [0, 0.675, 0, 0, 0.77778],
      9650: [0, 0.54986, 0, 0, 0.72222],
      9651: [0, 0.54986, 0, 0, 0.72222],
      9654: [0.03517, 0.54986, 0, 0, 0.77778],
      9660: [0, 0.54986, 0, 0, 0.72222],
      9661: [0, 0.54986, 0, 0, 0.72222],
      9664: [0.03517, 0.54986, 0, 0, 0.77778],
      9674: [0.11111, 0.69224, 0, 0, 0.66667],
      9733: [0.19444, 0.69224, 0, 0, 0.94445],
      10003: [0, 0.69224, 0, 0, 0.83334],
      10016: [0, 0.69224, 0, 0, 0.83334],
      10731: [0.11111, 0.69224, 0, 0, 0.66667],
      10846: [0.19444, 0.75583, 0, 0, 0.61111],
      10877: [0.13667, 0.63667, 0, 0, 0.77778],
      10878: [0.13667, 0.63667, 0, 0, 0.77778],
      10885: [0.25583, 0.75583, 0, 0, 0.77778],
      10886: [0.25583, 0.75583, 0, 0, 0.77778],
      10887: [0.13597, 0.63597, 0, 0, 0.77778],
      10888: [0.13597, 0.63597, 0, 0, 0.77778],
      10889: [0.26167, 0.75726, 0, 0, 0.77778],
      10890: [0.26167, 0.75726, 0, 0, 0.77778],
      10891: [0.48256, 0.98256, 0, 0, 0.77778],
      10892: [0.48256, 0.98256, 0, 0, 0.77778],
      10901: [0.13667, 0.63667, 0, 0, 0.77778],
      10902: [0.13667, 0.63667, 0, 0, 0.77778],
      10933: [0.25142, 0.75726, 0, 0, 0.77778],
      10934: [0.25142, 0.75726, 0, 0, 0.77778],
      10935: [0.26167, 0.75726, 0, 0, 0.77778],
      10936: [0.26167, 0.75726, 0, 0, 0.77778],
      10937: [0.26167, 0.75726, 0, 0, 0.77778],
      10938: [0.26167, 0.75726, 0, 0, 0.77778],
      10949: [0.25583, 0.75583, 0, 0, 0.77778],
      10950: [0.25583, 0.75583, 0, 0, 0.77778],
      10955: [0.28481, 0.79383, 0, 0, 0.77778],
      10956: [0.28481, 0.79383, 0, 0, 0.77778],
      57350: [0.08167, 0.58167, 0, 0, 0.22222],
      57351: [0.08167, 0.58167, 0, 0, 0.38889],
      57352: [0.08167, 0.58167, 0, 0, 0.77778],
      57353: [0, 0.43056, 0.04028, 0, 0.66667],
      57356: [0.25142, 0.75726, 0, 0, 0.77778],
      57357: [0.25142, 0.75726, 0, 0, 0.77778],
      57358: [0.41951, 0.91951, 0, 0, 0.77778],
      57359: [0.30274, 0.79383, 0, 0, 0.77778],
      57360: [0.30274, 0.79383, 0, 0, 0.77778],
      57361: [0.41951, 0.91951, 0, 0, 0.77778],
      57366: [0.25142, 0.75726, 0, 0, 0.77778],
      57367: [0.25142, 0.75726, 0, 0, 0.77778],
      57368: [0.25142, 0.75726, 0, 0, 0.77778],
      57369: [0.25142, 0.75726, 0, 0, 0.77778],
      57370: [0.13597, 0.63597, 0, 0, 0.77778],
      57371: [0.13597, 0.63597, 0, 0, 0.77778],
    },
    "Caligraphic-Regular": {
      32: [0, 0, 0, 0, 0.25],
      65: [0, 0.68333, 0, 0.19445, 0.79847],
      66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
      67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
      68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
      69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
      70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
      71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
      72: [0, 0.68333, 0.00965, 0.11111, 0.84452],
      73: [0, 0.68333, 0.07382, 0, 0.54452],
      74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
      75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
      76: [0, 0.68333, 0, 0.13889, 0.68972],
      77: [0, 0.68333, 0, 0.13889, 1.2009],
      78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
      79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
      80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
      81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
      82: [0, 0.68333, 0, 0.08334, 0.8475],
      83: [0, 0.68333, 0.075, 0.13889, 0.60556],
      84: [0, 0.68333, 0.25417, 0, 0.54464],
      85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
      86: [0, 0.68333, 0.08222, 0, 0.61278],
      87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
      88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
      89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
      90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
      160: [0, 0, 0, 0, 0.25],
    },
    "Fraktur-Regular": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69141, 0, 0, 0.29574],
      34: [0, 0.69141, 0, 0, 0.21471],
      38: [0, 0.69141, 0, 0, 0.73786],
      39: [0, 0.69141, 0, 0, 0.21201],
      40: [0.24982, 0.74947, 0, 0, 0.38865],
      41: [0.24982, 0.74947, 0, 0, 0.38865],
      42: [0, 0.62119, 0, 0, 0.27764],
      43: [0.08319, 0.58283, 0, 0, 0.75623],
      44: [0, 0.10803, 0, 0, 0.27764],
      45: [0.08319, 0.58283, 0, 0, 0.75623],
      46: [0, 0.10803, 0, 0, 0.27764],
      47: [0.24982, 0.74947, 0, 0, 0.50181],
      48: [0, 0.47534, 0, 0, 0.50181],
      49: [0, 0.47534, 0, 0, 0.50181],
      50: [0, 0.47534, 0, 0, 0.50181],
      51: [0.18906, 0.47534, 0, 0, 0.50181],
      52: [0.18906, 0.47534, 0, 0, 0.50181],
      53: [0.18906, 0.47534, 0, 0, 0.50181],
      54: [0, 0.69141, 0, 0, 0.50181],
      55: [0.18906, 0.47534, 0, 0, 0.50181],
      56: [0, 0.69141, 0, 0, 0.50181],
      57: [0.18906, 0.47534, 0, 0, 0.50181],
      58: [0, 0.47534, 0, 0, 0.21606],
      59: [0.12604, 0.47534, 0, 0, 0.21606],
      61: [-0.13099, 0.36866, 0, 0, 0.75623],
      63: [0, 0.69141, 0, 0, 0.36245],
      65: [0, 0.69141, 0, 0, 0.7176],
      66: [0, 0.69141, 0, 0, 0.88397],
      67: [0, 0.69141, 0, 0, 0.61254],
      68: [0, 0.69141, 0, 0, 0.83158],
      69: [0, 0.69141, 0, 0, 0.66278],
      70: [0.12604, 0.69141, 0, 0, 0.61119],
      71: [0, 0.69141, 0, 0, 0.78539],
      72: [0.06302, 0.69141, 0, 0, 0.7203],
      73: [0, 0.69141, 0, 0, 0.55448],
      74: [0.12604, 0.69141, 0, 0, 0.55231],
      75: [0, 0.69141, 0, 0, 0.66845],
      76: [0, 0.69141, 0, 0, 0.66602],
      77: [0, 0.69141, 0, 0, 1.04953],
      78: [0, 0.69141, 0, 0, 0.83212],
      79: [0, 0.69141, 0, 0, 0.82699],
      80: [0.18906, 0.69141, 0, 0, 0.82753],
      81: [0.03781, 0.69141, 0, 0, 0.82699],
      82: [0, 0.69141, 0, 0, 0.82807],
      83: [0, 0.69141, 0, 0, 0.82861],
      84: [0, 0.69141, 0, 0, 0.66899],
      85: [0, 0.69141, 0, 0, 0.64576],
      86: [0, 0.69141, 0, 0, 0.83131],
      87: [0, 0.69141, 0, 0, 1.04602],
      88: [0, 0.69141, 0, 0, 0.71922],
      89: [0.18906, 0.69141, 0, 0, 0.83293],
      90: [0.12604, 0.69141, 0, 0, 0.60201],
      91: [0.24982, 0.74947, 0, 0, 0.27764],
      93: [0.24982, 0.74947, 0, 0, 0.27764],
      94: [0, 0.69141, 0, 0, 0.49965],
      97: [0, 0.47534, 0, 0, 0.50046],
      98: [0, 0.69141, 0, 0, 0.51315],
      99: [0, 0.47534, 0, 0, 0.38946],
      100: [0, 0.62119, 0, 0, 0.49857],
      101: [0, 0.47534, 0, 0, 0.40053],
      102: [0.18906, 0.69141, 0, 0, 0.32626],
      103: [0.18906, 0.47534, 0, 0, 0.5037],
      104: [0.18906, 0.69141, 0, 0, 0.52126],
      105: [0, 0.69141, 0, 0, 0.27899],
      106: [0, 0.69141, 0, 0, 0.28088],
      107: [0, 0.69141, 0, 0, 0.38946],
      108: [0, 0.69141, 0, 0, 0.27953],
      109: [0, 0.47534, 0, 0, 0.76676],
      110: [0, 0.47534, 0, 0, 0.52666],
      111: [0, 0.47534, 0, 0, 0.48885],
      112: [0.18906, 0.52396, 0, 0, 0.50046],
      113: [0.18906, 0.47534, 0, 0, 0.48912],
      114: [0, 0.47534, 0, 0, 0.38919],
      115: [0, 0.47534, 0, 0, 0.44266],
      116: [0, 0.62119, 0, 0, 0.33301],
      117: [0, 0.47534, 0, 0, 0.5172],
      118: [0, 0.52396, 0, 0, 0.5118],
      119: [0, 0.52396, 0, 0, 0.77351],
      120: [0.18906, 0.47534, 0, 0, 0.38865],
      121: [0.18906, 0.47534, 0, 0, 0.49884],
      122: [0.18906, 0.47534, 0, 0, 0.39054],
      160: [0, 0, 0, 0, 0.25],
      8216: [0, 0.69141, 0, 0, 0.21471],
      8217: [0, 0.69141, 0, 0, 0.21471],
      58112: [0, 0.62119, 0, 0, 0.49749],
      58113: [0, 0.62119, 0, 0, 0.4983],
      58114: [0.18906, 0.69141, 0, 0, 0.33328],
      58115: [0.18906, 0.69141, 0, 0, 0.32923],
      58116: [0.18906, 0.47534, 0, 0, 0.50343],
      58117: [0, 0.69141, 0, 0, 0.33301],
      58118: [0, 0.62119, 0, 0, 0.33409],
      58119: [0, 0.47534, 0, 0, 0.50073],
    },
    "Main-Bold": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.35],
      34: [0, 0.69444, 0, 0, 0.60278],
      35: [0.19444, 0.69444, 0, 0, 0.95833],
      36: [0.05556, 0.75, 0, 0, 0.575],
      37: [0.05556, 0.75, 0, 0, 0.95833],
      38: [0, 0.69444, 0, 0, 0.89444],
      39: [0, 0.69444, 0, 0, 0.31944],
      40: [0.25, 0.75, 0, 0, 0.44722],
      41: [0.25, 0.75, 0, 0, 0.44722],
      42: [0, 0.75, 0, 0, 0.575],
      43: [0.13333, 0.63333, 0, 0, 0.89444],
      44: [0.19444, 0.15556, 0, 0, 0.31944],
      45: [0, 0.44444, 0, 0, 0.38333],
      46: [0, 0.15556, 0, 0, 0.31944],
      47: [0.25, 0.75, 0, 0, 0.575],
      48: [0, 0.64444, 0, 0, 0.575],
      49: [0, 0.64444, 0, 0, 0.575],
      50: [0, 0.64444, 0, 0, 0.575],
      51: [0, 0.64444, 0, 0, 0.575],
      52: [0, 0.64444, 0, 0, 0.575],
      53: [0, 0.64444, 0, 0, 0.575],
      54: [0, 0.64444, 0, 0, 0.575],
      55: [0, 0.64444, 0, 0, 0.575],
      56: [0, 0.64444, 0, 0, 0.575],
      57: [0, 0.64444, 0, 0, 0.575],
      58: [0, 0.44444, 0, 0, 0.31944],
      59: [0.19444, 0.44444, 0, 0, 0.31944],
      60: [0.08556, 0.58556, 0, 0, 0.89444],
      61: [-0.10889, 0.39111, 0, 0, 0.89444],
      62: [0.08556, 0.58556, 0, 0, 0.89444],
      63: [0, 0.69444, 0, 0, 0.54305],
      64: [0, 0.69444, 0, 0, 0.89444],
      65: [0, 0.68611, 0, 0, 0.86944],
      66: [0, 0.68611, 0, 0, 0.81805],
      67: [0, 0.68611, 0, 0, 0.83055],
      68: [0, 0.68611, 0, 0, 0.88194],
      69: [0, 0.68611, 0, 0, 0.75555],
      70: [0, 0.68611, 0, 0, 0.72361],
      71: [0, 0.68611, 0, 0, 0.90416],
      72: [0, 0.68611, 0, 0, 0.9],
      73: [0, 0.68611, 0, 0, 0.43611],
      74: [0, 0.68611, 0, 0, 0.59444],
      75: [0, 0.68611, 0, 0, 0.90138],
      76: [0, 0.68611, 0, 0, 0.69166],
      77: [0, 0.68611, 0, 0, 1.09166],
      78: [0, 0.68611, 0, 0, 0.9],
      79: [0, 0.68611, 0, 0, 0.86388],
      80: [0, 0.68611, 0, 0, 0.78611],
      81: [0.19444, 0.68611, 0, 0, 0.86388],
      82: [0, 0.68611, 0, 0, 0.8625],
      83: [0, 0.68611, 0, 0, 0.63889],
      84: [0, 0.68611, 0, 0, 0.8],
      85: [0, 0.68611, 0, 0, 0.88472],
      86: [0, 0.68611, 0.01597, 0, 0.86944],
      87: [0, 0.68611, 0.01597, 0, 1.18888],
      88: [0, 0.68611, 0, 0, 0.86944],
      89: [0, 0.68611, 0.02875, 0, 0.86944],
      90: [0, 0.68611, 0, 0, 0.70277],
      91: [0.25, 0.75, 0, 0, 0.31944],
      92: [0.25, 0.75, 0, 0, 0.575],
      93: [0.25, 0.75, 0, 0, 0.31944],
      94: [0, 0.69444, 0, 0, 0.575],
      95: [0.31, 0.13444, 0.03194, 0, 0.575],
      97: [0, 0.44444, 0, 0, 0.55902],
      98: [0, 0.69444, 0, 0, 0.63889],
      99: [0, 0.44444, 0, 0, 0.51111],
      100: [0, 0.69444, 0, 0, 0.63889],
      101: [0, 0.44444, 0, 0, 0.52708],
      102: [0, 0.69444, 0.10903, 0, 0.35139],
      103: [0.19444, 0.44444, 0.01597, 0, 0.575],
      104: [0, 0.69444, 0, 0, 0.63889],
      105: [0, 0.69444, 0, 0, 0.31944],
      106: [0.19444, 0.69444, 0, 0, 0.35139],
      107: [0, 0.69444, 0, 0, 0.60694],
      108: [0, 0.69444, 0, 0, 0.31944],
      109: [0, 0.44444, 0, 0, 0.95833],
      110: [0, 0.44444, 0, 0, 0.63889],
      111: [0, 0.44444, 0, 0, 0.575],
      112: [0.19444, 0.44444, 0, 0, 0.63889],
      113: [0.19444, 0.44444, 0, 0, 0.60694],
      114: [0, 0.44444, 0, 0, 0.47361],
      115: [0, 0.44444, 0, 0, 0.45361],
      116: [0, 0.63492, 0, 0, 0.44722],
      117: [0, 0.44444, 0, 0, 0.63889],
      118: [0, 0.44444, 0.01597, 0, 0.60694],
      119: [0, 0.44444, 0.01597, 0, 0.83055],
      120: [0, 0.44444, 0, 0, 0.60694],
      121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
      122: [0, 0.44444, 0, 0, 0.51111],
      123: [0.25, 0.75, 0, 0, 0.575],
      124: [0.25, 0.75, 0, 0, 0.31944],
      125: [0.25, 0.75, 0, 0, 0.575],
      126: [0.35, 0.34444, 0, 0, 0.575],
      160: [0, 0, 0, 0, 0.25],
      163: [0, 0.69444, 0, 0, 0.86853],
      168: [0, 0.69444, 0, 0, 0.575],
      172: [0, 0.44444, 0, 0, 0.76666],
      176: [0, 0.69444, 0, 0, 0.86944],
      177: [0.13333, 0.63333, 0, 0, 0.89444],
      184: [0.17014, 0, 0, 0, 0.51111],
      198: [0, 0.68611, 0, 0, 1.04166],
      215: [0.13333, 0.63333, 0, 0, 0.89444],
      216: [0.04861, 0.73472, 0, 0, 0.89444],
      223: [0, 0.69444, 0, 0, 0.59722],
      230: [0, 0.44444, 0, 0, 0.83055],
      247: [0.13333, 0.63333, 0, 0, 0.89444],
      248: [0.09722, 0.54167, 0, 0, 0.575],
      305: [0, 0.44444, 0, 0, 0.31944],
      338: [0, 0.68611, 0, 0, 1.16944],
      339: [0, 0.44444, 0, 0, 0.89444],
      567: [0.19444, 0.44444, 0, 0, 0.35139],
      710: [0, 0.69444, 0, 0, 0.575],
      711: [0, 0.63194, 0, 0, 0.575],
      713: [0, 0.59611, 0, 0, 0.575],
      714: [0, 0.69444, 0, 0, 0.575],
      715: [0, 0.69444, 0, 0, 0.575],
      728: [0, 0.69444, 0, 0, 0.575],
      729: [0, 0.69444, 0, 0, 0.31944],
      730: [0, 0.69444, 0, 0, 0.86944],
      732: [0, 0.69444, 0, 0, 0.575],
      733: [0, 0.69444, 0, 0, 0.575],
      915: [0, 0.68611, 0, 0, 0.69166],
      916: [0, 0.68611, 0, 0, 0.95833],
      920: [0, 0.68611, 0, 0, 0.89444],
      923: [0, 0.68611, 0, 0, 0.80555],
      926: [0, 0.68611, 0, 0, 0.76666],
      928: [0, 0.68611, 0, 0, 0.9],
      931: [0, 0.68611, 0, 0, 0.83055],
      933: [0, 0.68611, 0, 0, 0.89444],
      934: [0, 0.68611, 0, 0, 0.83055],
      936: [0, 0.68611, 0, 0, 0.89444],
      937: [0, 0.68611, 0, 0, 0.83055],
      8211: [0, 0.44444, 0.03194, 0, 0.575],
      8212: [0, 0.44444, 0.03194, 0, 1.14999],
      8216: [0, 0.69444, 0, 0, 0.31944],
      8217: [0, 0.69444, 0, 0, 0.31944],
      8220: [0, 0.69444, 0, 0, 0.60278],
      8221: [0, 0.69444, 0, 0, 0.60278],
      8224: [0.19444, 0.69444, 0, 0, 0.51111],
      8225: [0.19444, 0.69444, 0, 0, 0.51111],
      8242: [0, 0.55556, 0, 0, 0.34444],
      8407: [0, 0.72444, 0.15486, 0, 0.575],
      8463: [0, 0.69444, 0, 0, 0.66759],
      8465: [0, 0.69444, 0, 0, 0.83055],
      8467: [0, 0.69444, 0, 0, 0.47361],
      8472: [0.19444, 0.44444, 0, 0, 0.74027],
      8476: [0, 0.69444, 0, 0, 0.83055],
      8501: [0, 0.69444, 0, 0, 0.70277],
      8592: [-0.10889, 0.39111, 0, 0, 1.14999],
      8593: [0.19444, 0.69444, 0, 0, 0.575],
      8594: [-0.10889, 0.39111, 0, 0, 1.14999],
      8595: [0.19444, 0.69444, 0, 0, 0.575],
      8596: [-0.10889, 0.39111, 0, 0, 1.14999],
      8597: [0.25, 0.75, 0, 0, 0.575],
      8598: [0.19444, 0.69444, 0, 0, 1.14999],
      8599: [0.19444, 0.69444, 0, 0, 1.14999],
      8600: [0.19444, 0.69444, 0, 0, 1.14999],
      8601: [0.19444, 0.69444, 0, 0, 1.14999],
      8636: [-0.10889, 0.39111, 0, 0, 1.14999],
      8637: [-0.10889, 0.39111, 0, 0, 1.14999],
      8640: [-0.10889, 0.39111, 0, 0, 1.14999],
      8641: [-0.10889, 0.39111, 0, 0, 1.14999],
      8656: [-0.10889, 0.39111, 0, 0, 1.14999],
      8657: [0.19444, 0.69444, 0, 0, 0.70277],
      8658: [-0.10889, 0.39111, 0, 0, 1.14999],
      8659: [0.19444, 0.69444, 0, 0, 0.70277],
      8660: [-0.10889, 0.39111, 0, 0, 1.14999],
      8661: [0.25, 0.75, 0, 0, 0.70277],
      8704: [0, 0.69444, 0, 0, 0.63889],
      8706: [0, 0.69444, 0.06389, 0, 0.62847],
      8707: [0, 0.69444, 0, 0, 0.63889],
      8709: [0.05556, 0.75, 0, 0, 0.575],
      8711: [0, 0.68611, 0, 0, 0.95833],
      8712: [0.08556, 0.58556, 0, 0, 0.76666],
      8715: [0.08556, 0.58556, 0, 0, 0.76666],
      8722: [0.13333, 0.63333, 0, 0, 0.89444],
      8723: [0.13333, 0.63333, 0, 0, 0.89444],
      8725: [0.25, 0.75, 0, 0, 0.575],
      8726: [0.25, 0.75, 0, 0, 0.575],
      8727: [-0.02778, 0.47222, 0, 0, 0.575],
      8728: [-0.02639, 0.47361, 0, 0, 0.575],
      8729: [-0.02639, 0.47361, 0, 0, 0.575],
      8730: [0.18, 0.82, 0, 0, 0.95833],
      8733: [0, 0.44444, 0, 0, 0.89444],
      8734: [0, 0.44444, 0, 0, 1.14999],
      8736: [0, 0.69224, 0, 0, 0.72222],
      8739: [0.25, 0.75, 0, 0, 0.31944],
      8741: [0.25, 0.75, 0, 0, 0.575],
      8743: [0, 0.55556, 0, 0, 0.76666],
      8744: [0, 0.55556, 0, 0, 0.76666],
      8745: [0, 0.55556, 0, 0, 0.76666],
      8746: [0, 0.55556, 0, 0, 0.76666],
      8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
      8764: [-0.10889, 0.39111, 0, 0, 0.89444],
      8768: [0.19444, 0.69444, 0, 0, 0.31944],
      8771: [0.00222, 0.50222, 0, 0, 0.89444],
      8773: [0.027, 0.638, 0, 0, 0.894],
      8776: [0.02444, 0.52444, 0, 0, 0.89444],
      8781: [0.00222, 0.50222, 0, 0, 0.89444],
      8801: [0.00222, 0.50222, 0, 0, 0.89444],
      8804: [0.19667, 0.69667, 0, 0, 0.89444],
      8805: [0.19667, 0.69667, 0, 0, 0.89444],
      8810: [0.08556, 0.58556, 0, 0, 1.14999],
      8811: [0.08556, 0.58556, 0, 0, 1.14999],
      8826: [0.08556, 0.58556, 0, 0, 0.89444],
      8827: [0.08556, 0.58556, 0, 0, 0.89444],
      8834: [0.08556, 0.58556, 0, 0, 0.89444],
      8835: [0.08556, 0.58556, 0, 0, 0.89444],
      8838: [0.19667, 0.69667, 0, 0, 0.89444],
      8839: [0.19667, 0.69667, 0, 0, 0.89444],
      8846: [0, 0.55556, 0, 0, 0.76666],
      8849: [0.19667, 0.69667, 0, 0, 0.89444],
      8850: [0.19667, 0.69667, 0, 0, 0.89444],
      8851: [0, 0.55556, 0, 0, 0.76666],
      8852: [0, 0.55556, 0, 0, 0.76666],
      8853: [0.13333, 0.63333, 0, 0, 0.89444],
      8854: [0.13333, 0.63333, 0, 0, 0.89444],
      8855: [0.13333, 0.63333, 0, 0, 0.89444],
      8856: [0.13333, 0.63333, 0, 0, 0.89444],
      8857: [0.13333, 0.63333, 0, 0, 0.89444],
      8866: [0, 0.69444, 0, 0, 0.70277],
      8867: [0, 0.69444, 0, 0, 0.70277],
      8868: [0, 0.69444, 0, 0, 0.89444],
      8869: [0, 0.69444, 0, 0, 0.89444],
      8900: [-0.02639, 0.47361, 0, 0, 0.575],
      8901: [-0.02639, 0.47361, 0, 0, 0.31944],
      8902: [-0.02778, 0.47222, 0, 0, 0.575],
      8968: [0.25, 0.75, 0, 0, 0.51111],
      8969: [0.25, 0.75, 0, 0, 0.51111],
      8970: [0.25, 0.75, 0, 0, 0.51111],
      8971: [0.25, 0.75, 0, 0, 0.51111],
      8994: [-0.13889, 0.36111, 0, 0, 1.14999],
      8995: [-0.13889, 0.36111, 0, 0, 1.14999],
      9651: [0.19444, 0.69444, 0, 0, 1.02222],
      9657: [-0.02778, 0.47222, 0, 0, 0.575],
      9661: [0.19444, 0.69444, 0, 0, 1.02222],
      9667: [-0.02778, 0.47222, 0, 0, 0.575],
      9711: [0.19444, 0.69444, 0, 0, 1.14999],
      9824: [0.12963, 0.69444, 0, 0, 0.89444],
      9825: [0.12963, 0.69444, 0, 0, 0.89444],
      9826: [0.12963, 0.69444, 0, 0, 0.89444],
      9827: [0.12963, 0.69444, 0, 0, 0.89444],
      9837: [0, 0.75, 0, 0, 0.44722],
      9838: [0.19444, 0.69444, 0, 0, 0.44722],
      9839: [0.19444, 0.69444, 0, 0, 0.44722],
      10216: [0.25, 0.75, 0, 0, 0.44722],
      10217: [0.25, 0.75, 0, 0, 0.44722],
      10815: [0, 0.68611, 0, 0, 0.9],
      10927: [0.19667, 0.69667, 0, 0, 0.89444],
      10928: [0.19667, 0.69667, 0, 0, 0.89444],
      57376: [0.19444, 0.69444, 0, 0, 0],
    },
    "Main-BoldItalic": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0.11417, 0, 0.38611],
      34: [0, 0.69444, 0.07939, 0, 0.62055],
      35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
      37: [0.05556, 0.75, 0.12861, 0, 0.94444],
      38: [0, 0.69444, 0.08528, 0, 0.88555],
      39: [0, 0.69444, 0.12945, 0, 0.35555],
      40: [0.25, 0.75, 0.15806, 0, 0.47333],
      41: [0.25, 0.75, 0.03306, 0, 0.47333],
      42: [0, 0.75, 0.14333, 0, 0.59111],
      43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
      44: [0.19444, 0.14722, 0, 0, 0.35555],
      45: [0, 0.44444, 0.02611, 0, 0.41444],
      46: [0, 0.14722, 0, 0, 0.35555],
      47: [0.25, 0.75, 0.15806, 0, 0.59111],
      48: [0, 0.64444, 0.13167, 0, 0.59111],
      49: [0, 0.64444, 0.13167, 0, 0.59111],
      50: [0, 0.64444, 0.13167, 0, 0.59111],
      51: [0, 0.64444, 0.13167, 0, 0.59111],
      52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
      53: [0, 0.64444, 0.13167, 0, 0.59111],
      54: [0, 0.64444, 0.13167, 0, 0.59111],
      55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
      56: [0, 0.64444, 0.13167, 0, 0.59111],
      57: [0, 0.64444, 0.13167, 0, 0.59111],
      58: [0, 0.44444, 0.06695, 0, 0.35555],
      59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
      61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
      63: [0, 0.69444, 0.11472, 0, 0.59111],
      64: [0, 0.69444, 0.09208, 0, 0.88555],
      65: [0, 0.68611, 0, 0, 0.86555],
      66: [0, 0.68611, 0.0992, 0, 0.81666],
      67: [0, 0.68611, 0.14208, 0, 0.82666],
      68: [0, 0.68611, 0.09062, 0, 0.87555],
      69: [0, 0.68611, 0.11431, 0, 0.75666],
      70: [0, 0.68611, 0.12903, 0, 0.72722],
      71: [0, 0.68611, 0.07347, 0, 0.89527],
      72: [0, 0.68611, 0.17208, 0, 0.8961],
      73: [0, 0.68611, 0.15681, 0, 0.47166],
      74: [0, 0.68611, 0.145, 0, 0.61055],
      75: [0, 0.68611, 0.14208, 0, 0.89499],
      76: [0, 0.68611, 0, 0, 0.69777],
      77: [0, 0.68611, 0.17208, 0, 1.07277],
      78: [0, 0.68611, 0.17208, 0, 0.8961],
      79: [0, 0.68611, 0.09062, 0, 0.85499],
      80: [0, 0.68611, 0.0992, 0, 0.78721],
      81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
      82: [0, 0.68611, 0.02559, 0, 0.85944],
      83: [0, 0.68611, 0.11264, 0, 0.64999],
      84: [0, 0.68611, 0.12903, 0, 0.7961],
      85: [0, 0.68611, 0.17208, 0, 0.88083],
      86: [0, 0.68611, 0.18625, 0, 0.86555],
      87: [0, 0.68611, 0.18625, 0, 1.15999],
      88: [0, 0.68611, 0.15681, 0, 0.86555],
      89: [0, 0.68611, 0.19803, 0, 0.86555],
      90: [0, 0.68611, 0.14208, 0, 0.70888],
      91: [0.25, 0.75, 0.1875, 0, 0.35611],
      93: [0.25, 0.75, 0.09972, 0, 0.35611],
      94: [0, 0.69444, 0.06709, 0, 0.59111],
      95: [0.31, 0.13444, 0.09811, 0, 0.59111],
      97: [0, 0.44444, 0.09426, 0, 0.59111],
      98: [0, 0.69444, 0.07861, 0, 0.53222],
      99: [0, 0.44444, 0.05222, 0, 0.53222],
      100: [0, 0.69444, 0.10861, 0, 0.59111],
      101: [0, 0.44444, 0.085, 0, 0.53222],
      102: [0.19444, 0.69444, 0.21778, 0, 0.4],
      103: [0.19444, 0.44444, 0.105, 0, 0.53222],
      104: [0, 0.69444, 0.09426, 0, 0.59111],
      105: [0, 0.69326, 0.11387, 0, 0.35555],
      106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
      107: [0, 0.69444, 0.11111, 0, 0.53222],
      108: [0, 0.69444, 0.10861, 0, 0.29666],
      109: [0, 0.44444, 0.09426, 0, 0.94444],
      110: [0, 0.44444, 0.09426, 0, 0.64999],
      111: [0, 0.44444, 0.07861, 0, 0.59111],
      112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
      113: [0.19444, 0.44444, 0.105, 0, 0.53222],
      114: [0, 0.44444, 0.11111, 0, 0.50167],
      115: [0, 0.44444, 0.08167, 0, 0.48694],
      116: [0, 0.63492, 0.09639, 0, 0.385],
      117: [0, 0.44444, 0.09426, 0, 0.62055],
      118: [0, 0.44444, 0.11111, 0, 0.53222],
      119: [0, 0.44444, 0.11111, 0, 0.76777],
      120: [0, 0.44444, 0.12583, 0, 0.56055],
      121: [0.19444, 0.44444, 0.105, 0, 0.56166],
      122: [0, 0.44444, 0.13889, 0, 0.49055],
      126: [0.35, 0.34444, 0.11472, 0, 0.59111],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.69444, 0.11473, 0, 0.59111],
      176: [0, 0.69444, 0, 0, 0.94888],
      184: [0.17014, 0, 0, 0, 0.53222],
      198: [0, 0.68611, 0.11431, 0, 1.02277],
      216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
      223: [0.19444, 0.69444, 0.09736, 0, 0.665],
      230: [0, 0.44444, 0.085, 0, 0.82666],
      248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
      305: [0, 0.44444, 0.09426, 0, 0.35555],
      338: [0, 0.68611, 0.11431, 0, 1.14054],
      339: [0, 0.44444, 0.085, 0, 0.82666],
      567: [0.19444, 0.44444, 0.04611, 0, 0.385],
      710: [0, 0.69444, 0.06709, 0, 0.59111],
      711: [0, 0.63194, 0.08271, 0, 0.59111],
      713: [0, 0.59444, 0.10444, 0, 0.59111],
      714: [0, 0.69444, 0.08528, 0, 0.59111],
      715: [0, 0.69444, 0, 0, 0.59111],
      728: [0, 0.69444, 0.10333, 0, 0.59111],
      729: [0, 0.69444, 0.12945, 0, 0.35555],
      730: [0, 0.69444, 0, 0, 0.94888],
      732: [0, 0.69444, 0.11472, 0, 0.59111],
      733: [0, 0.69444, 0.11472, 0, 0.59111],
      915: [0, 0.68611, 0.12903, 0, 0.69777],
      916: [0, 0.68611, 0, 0, 0.94444],
      920: [0, 0.68611, 0.09062, 0, 0.88555],
      923: [0, 0.68611, 0, 0, 0.80666],
      926: [0, 0.68611, 0.15092, 0, 0.76777],
      928: [0, 0.68611, 0.17208, 0, 0.8961],
      931: [0, 0.68611, 0.11431, 0, 0.82666],
      933: [0, 0.68611, 0.10778, 0, 0.88555],
      934: [0, 0.68611, 0.05632, 0, 0.82666],
      936: [0, 0.68611, 0.10778, 0, 0.88555],
      937: [0, 0.68611, 0.0992, 0, 0.82666],
      8211: [0, 0.44444, 0.09811, 0, 0.59111],
      8212: [0, 0.44444, 0.09811, 0, 1.18221],
      8216: [0, 0.69444, 0.12945, 0, 0.35555],
      8217: [0, 0.69444, 0.12945, 0, 0.35555],
      8220: [0, 0.69444, 0.16772, 0, 0.62055],
      8221: [0, 0.69444, 0.07939, 0, 0.62055],
    },
    "Main-Italic": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0.12417, 0, 0.30667],
      34: [0, 0.69444, 0.06961, 0, 0.51444],
      35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
      37: [0.05556, 0.75, 0.13639, 0, 0.81777],
      38: [0, 0.69444, 0.09694, 0, 0.76666],
      39: [0, 0.69444, 0.12417, 0, 0.30667],
      40: [0.25, 0.75, 0.16194, 0, 0.40889],
      41: [0.25, 0.75, 0.03694, 0, 0.40889],
      42: [0, 0.75, 0.14917, 0, 0.51111],
      43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
      44: [0.19444, 0.10556, 0, 0, 0.30667],
      45: [0, 0.43056, 0.02826, 0, 0.35778],
      46: [0, 0.10556, 0, 0, 0.30667],
      47: [0.25, 0.75, 0.16194, 0, 0.51111],
      48: [0, 0.64444, 0.13556, 0, 0.51111],
      49: [0, 0.64444, 0.13556, 0, 0.51111],
      50: [0, 0.64444, 0.13556, 0, 0.51111],
      51: [0, 0.64444, 0.13556, 0, 0.51111],
      52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
      53: [0, 0.64444, 0.13556, 0, 0.51111],
      54: [0, 0.64444, 0.13556, 0, 0.51111],
      55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
      56: [0, 0.64444, 0.13556, 0, 0.51111],
      57: [0, 0.64444, 0.13556, 0, 0.51111],
      58: [0, 0.43056, 0.0582, 0, 0.30667],
      59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
      61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
      63: [0, 0.69444, 0.1225, 0, 0.51111],
      64: [0, 0.69444, 0.09597, 0, 0.76666],
      65: [0, 0.68333, 0, 0, 0.74333],
      66: [0, 0.68333, 0.10257, 0, 0.70389],
      67: [0, 0.68333, 0.14528, 0, 0.71555],
      68: [0, 0.68333, 0.09403, 0, 0.755],
      69: [0, 0.68333, 0.12028, 0, 0.67833],
      70: [0, 0.68333, 0.13305, 0, 0.65277],
      71: [0, 0.68333, 0.08722, 0, 0.77361],
      72: [0, 0.68333, 0.16389, 0, 0.74333],
      73: [0, 0.68333, 0.15806, 0, 0.38555],
      74: [0, 0.68333, 0.14028, 0, 0.525],
      75: [0, 0.68333, 0.14528, 0, 0.76888],
      76: [0, 0.68333, 0, 0, 0.62722],
      77: [0, 0.68333, 0.16389, 0, 0.89666],
      78: [0, 0.68333, 0.16389, 0, 0.74333],
      79: [0, 0.68333, 0.09403, 0, 0.76666],
      80: [0, 0.68333, 0.10257, 0, 0.67833],
      81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
      82: [0, 0.68333, 0.03868, 0, 0.72944],
      83: [0, 0.68333, 0.11972, 0, 0.56222],
      84: [0, 0.68333, 0.13305, 0, 0.71555],
      85: [0, 0.68333, 0.16389, 0, 0.74333],
      86: [0, 0.68333, 0.18361, 0, 0.74333],
      87: [0, 0.68333, 0.18361, 0, 0.99888],
      88: [0, 0.68333, 0.15806, 0, 0.74333],
      89: [0, 0.68333, 0.19383, 0, 0.74333],
      90: [0, 0.68333, 0.14528, 0, 0.61333],
      91: [0.25, 0.75, 0.1875, 0, 0.30667],
      93: [0.25, 0.75, 0.10528, 0, 0.30667],
      94: [0, 0.69444, 0.06646, 0, 0.51111],
      95: [0.31, 0.12056, 0.09208, 0, 0.51111],
      97: [0, 0.43056, 0.07671, 0, 0.51111],
      98: [0, 0.69444, 0.06312, 0, 0.46],
      99: [0, 0.43056, 0.05653, 0, 0.46],
      100: [0, 0.69444, 0.10333, 0, 0.51111],
      101: [0, 0.43056, 0.07514, 0, 0.46],
      102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
      103: [0.19444, 0.43056, 0.08847, 0, 0.46],
      104: [0, 0.69444, 0.07671, 0, 0.51111],
      105: [0, 0.65536, 0.1019, 0, 0.30667],
      106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
      107: [0, 0.69444, 0.10764, 0, 0.46],
      108: [0, 0.69444, 0.10333, 0, 0.25555],
      109: [0, 0.43056, 0.07671, 0, 0.81777],
      110: [0, 0.43056, 0.07671, 0, 0.56222],
      111: [0, 0.43056, 0.06312, 0, 0.51111],
      112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
      113: [0.19444, 0.43056, 0.08847, 0, 0.46],
      114: [0, 0.43056, 0.10764, 0, 0.42166],
      115: [0, 0.43056, 0.08208, 0, 0.40889],
      116: [0, 0.61508, 0.09486, 0, 0.33222],
      117: [0, 0.43056, 0.07671, 0, 0.53666],
      118: [0, 0.43056, 0.10764, 0, 0.46],
      119: [0, 0.43056, 0.10764, 0, 0.66444],
      120: [0, 0.43056, 0.12042, 0, 0.46389],
      121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
      122: [0, 0.43056, 0.12292, 0, 0.40889],
      126: [0.35, 0.31786, 0.11585, 0, 0.51111],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.66786, 0.10474, 0, 0.51111],
      176: [0, 0.69444, 0, 0, 0.83129],
      184: [0.17014, 0, 0, 0, 0.46],
      198: [0, 0.68333, 0.12028, 0, 0.88277],
      216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
      223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
      230: [0, 0.43056, 0.07514, 0, 0.71555],
      248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
      338: [0, 0.68333, 0.12028, 0, 0.98499],
      339: [0, 0.43056, 0.07514, 0, 0.71555],
      710: [0, 0.69444, 0.06646, 0, 0.51111],
      711: [0, 0.62847, 0.08295, 0, 0.51111],
      713: [0, 0.56167, 0.10333, 0, 0.51111],
      714: [0, 0.69444, 0.09694, 0, 0.51111],
      715: [0, 0.69444, 0, 0, 0.51111],
      728: [0, 0.69444, 0.10806, 0, 0.51111],
      729: [0, 0.66786, 0.11752, 0, 0.30667],
      730: [0, 0.69444, 0, 0, 0.83129],
      732: [0, 0.66786, 0.11585, 0, 0.51111],
      733: [0, 0.69444, 0.1225, 0, 0.51111],
      915: [0, 0.68333, 0.13305, 0, 0.62722],
      916: [0, 0.68333, 0, 0, 0.81777],
      920: [0, 0.68333, 0.09403, 0, 0.76666],
      923: [0, 0.68333, 0, 0, 0.69222],
      926: [0, 0.68333, 0.15294, 0, 0.66444],
      928: [0, 0.68333, 0.16389, 0, 0.74333],
      931: [0, 0.68333, 0.12028, 0, 0.71555],
      933: [0, 0.68333, 0.11111, 0, 0.76666],
      934: [0, 0.68333, 0.05986, 0, 0.71555],
      936: [0, 0.68333, 0.11111, 0, 0.76666],
      937: [0, 0.68333, 0.10257, 0, 0.71555],
      8211: [0, 0.43056, 0.09208, 0, 0.51111],
      8212: [0, 0.43056, 0.09208, 0, 1.02222],
      8216: [0, 0.69444, 0.12417, 0, 0.30667],
      8217: [0, 0.69444, 0.12417, 0, 0.30667],
      8220: [0, 0.69444, 0.1685, 0, 0.51444],
      8221: [0, 0.69444, 0.06961, 0, 0.51444],
      8463: [0, 0.68889, 0, 0, 0.54028],
    },
    "Main-Regular": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.27778],
      34: [0, 0.69444, 0, 0, 0.5],
      35: [0.19444, 0.69444, 0, 0, 0.83334],
      36: [0.05556, 0.75, 0, 0, 0.5],
      37: [0.05556, 0.75, 0, 0, 0.83334],
      38: [0, 0.69444, 0, 0, 0.77778],
      39: [0, 0.69444, 0, 0, 0.27778],
      40: [0.25, 0.75, 0, 0, 0.38889],
      41: [0.25, 0.75, 0, 0, 0.38889],
      42: [0, 0.75, 0, 0, 0.5],
      43: [0.08333, 0.58333, 0, 0, 0.77778],
      44: [0.19444, 0.10556, 0, 0, 0.27778],
      45: [0, 0.43056, 0, 0, 0.33333],
      46: [0, 0.10556, 0, 0, 0.27778],
      47: [0.25, 0.75, 0, 0, 0.5],
      48: [0, 0.64444, 0, 0, 0.5],
      49: [0, 0.64444, 0, 0, 0.5],
      50: [0, 0.64444, 0, 0, 0.5],
      51: [0, 0.64444, 0, 0, 0.5],
      52: [0, 0.64444, 0, 0, 0.5],
      53: [0, 0.64444, 0, 0, 0.5],
      54: [0, 0.64444, 0, 0, 0.5],
      55: [0, 0.64444, 0, 0, 0.5],
      56: [0, 0.64444, 0, 0, 0.5],
      57: [0, 0.64444, 0, 0, 0.5],
      58: [0, 0.43056, 0, 0, 0.27778],
      59: [0.19444, 0.43056, 0, 0, 0.27778],
      60: [0.0391, 0.5391, 0, 0, 0.77778],
      61: [-0.13313, 0.36687, 0, 0, 0.77778],
      62: [0.0391, 0.5391, 0, 0, 0.77778],
      63: [0, 0.69444, 0, 0, 0.47222],
      64: [0, 0.69444, 0, 0, 0.77778],
      65: [0, 0.68333, 0, 0, 0.75],
      66: [0, 0.68333, 0, 0, 0.70834],
      67: [0, 0.68333, 0, 0, 0.72222],
      68: [0, 0.68333, 0, 0, 0.76389],
      69: [0, 0.68333, 0, 0, 0.68056],
      70: [0, 0.68333, 0, 0, 0.65278],
      71: [0, 0.68333, 0, 0, 0.78472],
      72: [0, 0.68333, 0, 0, 0.75],
      73: [0, 0.68333, 0, 0, 0.36111],
      74: [0, 0.68333, 0, 0, 0.51389],
      75: [0, 0.68333, 0, 0, 0.77778],
      76: [0, 0.68333, 0, 0, 0.625],
      77: [0, 0.68333, 0, 0, 0.91667],
      78: [0, 0.68333, 0, 0, 0.75],
      79: [0, 0.68333, 0, 0, 0.77778],
      80: [0, 0.68333, 0, 0, 0.68056],
      81: [0.19444, 0.68333, 0, 0, 0.77778],
      82: [0, 0.68333, 0, 0, 0.73611],
      83: [0, 0.68333, 0, 0, 0.55556],
      84: [0, 0.68333, 0, 0, 0.72222],
      85: [0, 0.68333, 0, 0, 0.75],
      86: [0, 0.68333, 0.01389, 0, 0.75],
      87: [0, 0.68333, 0.01389, 0, 1.02778],
      88: [0, 0.68333, 0, 0, 0.75],
      89: [0, 0.68333, 0.025, 0, 0.75],
      90: [0, 0.68333, 0, 0, 0.61111],
      91: [0.25, 0.75, 0, 0, 0.27778],
      92: [0.25, 0.75, 0, 0, 0.5],
      93: [0.25, 0.75, 0, 0, 0.27778],
      94: [0, 0.69444, 0, 0, 0.5],
      95: [0.31, 0.12056, 0.02778, 0, 0.5],
      97: [0, 0.43056, 0, 0, 0.5],
      98: [0, 0.69444, 0, 0, 0.55556],
      99: [0, 0.43056, 0, 0, 0.44445],
      100: [0, 0.69444, 0, 0, 0.55556],
      101: [0, 0.43056, 0, 0, 0.44445],
      102: [0, 0.69444, 0.07778, 0, 0.30556],
      103: [0.19444, 0.43056, 0.01389, 0, 0.5],
      104: [0, 0.69444, 0, 0, 0.55556],
      105: [0, 0.66786, 0, 0, 0.27778],
      106: [0.19444, 0.66786, 0, 0, 0.30556],
      107: [0, 0.69444, 0, 0, 0.52778],
      108: [0, 0.69444, 0, 0, 0.27778],
      109: [0, 0.43056, 0, 0, 0.83334],
      110: [0, 0.43056, 0, 0, 0.55556],
      111: [0, 0.43056, 0, 0, 0.5],
      112: [0.19444, 0.43056, 0, 0, 0.55556],
      113: [0.19444, 0.43056, 0, 0, 0.52778],
      114: [0, 0.43056, 0, 0, 0.39167],
      115: [0, 0.43056, 0, 0, 0.39445],
      116: [0, 0.61508, 0, 0, 0.38889],
      117: [0, 0.43056, 0, 0, 0.55556],
      118: [0, 0.43056, 0.01389, 0, 0.52778],
      119: [0, 0.43056, 0.01389, 0, 0.72222],
      120: [0, 0.43056, 0, 0, 0.52778],
      121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
      122: [0, 0.43056, 0, 0, 0.44445],
      123: [0.25, 0.75, 0, 0, 0.5],
      124: [0.25, 0.75, 0, 0, 0.27778],
      125: [0.25, 0.75, 0, 0, 0.5],
      126: [0.35, 0.31786, 0, 0, 0.5],
      160: [0, 0, 0, 0, 0.25],
      163: [0, 0.69444, 0, 0, 0.76909],
      167: [0.19444, 0.69444, 0, 0, 0.44445],
      168: [0, 0.66786, 0, 0, 0.5],
      172: [0, 0.43056, 0, 0, 0.66667],
      176: [0, 0.69444, 0, 0, 0.75],
      177: [0.08333, 0.58333, 0, 0, 0.77778],
      182: [0.19444, 0.69444, 0, 0, 0.61111],
      184: [0.17014, 0, 0, 0, 0.44445],
      198: [0, 0.68333, 0, 0, 0.90278],
      215: [0.08333, 0.58333, 0, 0, 0.77778],
      216: [0.04861, 0.73194, 0, 0, 0.77778],
      223: [0, 0.69444, 0, 0, 0.5],
      230: [0, 0.43056, 0, 0, 0.72222],
      247: [0.08333, 0.58333, 0, 0, 0.77778],
      248: [0.09722, 0.52778, 0, 0, 0.5],
      305: [0, 0.43056, 0, 0, 0.27778],
      338: [0, 0.68333, 0, 0, 1.01389],
      339: [0, 0.43056, 0, 0, 0.77778],
      567: [0.19444, 0.43056, 0, 0, 0.30556],
      710: [0, 0.69444, 0, 0, 0.5],
      711: [0, 0.62847, 0, 0, 0.5],
      713: [0, 0.56778, 0, 0, 0.5],
      714: [0, 0.69444, 0, 0, 0.5],
      715: [0, 0.69444, 0, 0, 0.5],
      728: [0, 0.69444, 0, 0, 0.5],
      729: [0, 0.66786, 0, 0, 0.27778],
      730: [0, 0.69444, 0, 0, 0.75],
      732: [0, 0.66786, 0, 0, 0.5],
      733: [0, 0.69444, 0, 0, 0.5],
      915: [0, 0.68333, 0, 0, 0.625],
      916: [0, 0.68333, 0, 0, 0.83334],
      920: [0, 0.68333, 0, 0, 0.77778],
      923: [0, 0.68333, 0, 0, 0.69445],
      926: [0, 0.68333, 0, 0, 0.66667],
      928: [0, 0.68333, 0, 0, 0.75],
      931: [0, 0.68333, 0, 0, 0.72222],
      933: [0, 0.68333, 0, 0, 0.77778],
      934: [0, 0.68333, 0, 0, 0.72222],
      936: [0, 0.68333, 0, 0, 0.77778],
      937: [0, 0.68333, 0, 0, 0.72222],
      8211: [0, 0.43056, 0.02778, 0, 0.5],
      8212: [0, 0.43056, 0.02778, 0, 1],
      8216: [0, 0.69444, 0, 0, 0.27778],
      8217: [0, 0.69444, 0, 0, 0.27778],
      8220: [0, 0.69444, 0, 0, 0.5],
      8221: [0, 0.69444, 0, 0, 0.5],
      8224: [0.19444, 0.69444, 0, 0, 0.44445],
      8225: [0.19444, 0.69444, 0, 0, 0.44445],
      8230: [0, 0.123, 0, 0, 1.172],
      8242: [0, 0.55556, 0, 0, 0.275],
      8407: [0, 0.71444, 0.15382, 0, 0.5],
      8463: [0, 0.68889, 0, 0, 0.54028],
      8465: [0, 0.69444, 0, 0, 0.72222],
      8467: [0, 0.69444, 0, 0.11111, 0.41667],
      8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
      8476: [0, 0.69444, 0, 0, 0.72222],
      8501: [0, 0.69444, 0, 0, 0.61111],
      8592: [-0.13313, 0.36687, 0, 0, 1],
      8593: [0.19444, 0.69444, 0, 0, 0.5],
      8594: [-0.13313, 0.36687, 0, 0, 1],
      8595: [0.19444, 0.69444, 0, 0, 0.5],
      8596: [-0.13313, 0.36687, 0, 0, 1],
      8597: [0.25, 0.75, 0, 0, 0.5],
      8598: [0.19444, 0.69444, 0, 0, 1],
      8599: [0.19444, 0.69444, 0, 0, 1],
      8600: [0.19444, 0.69444, 0, 0, 1],
      8601: [0.19444, 0.69444, 0, 0, 1],
      8614: [0.011, 0.511, 0, 0, 1],
      8617: [0.011, 0.511, 0, 0, 1.126],
      8618: [0.011, 0.511, 0, 0, 1.126],
      8636: [-0.13313, 0.36687, 0, 0, 1],
      8637: [-0.13313, 0.36687, 0, 0, 1],
      8640: [-0.13313, 0.36687, 0, 0, 1],
      8641: [-0.13313, 0.36687, 0, 0, 1],
      8652: [0.011, 0.671, 0, 0, 1],
      8656: [-0.13313, 0.36687, 0, 0, 1],
      8657: [0.19444, 0.69444, 0, 0, 0.61111],
      8658: [-0.13313, 0.36687, 0, 0, 1],
      8659: [0.19444, 0.69444, 0, 0, 0.61111],
      8660: [-0.13313, 0.36687, 0, 0, 1],
      8661: [0.25, 0.75, 0, 0, 0.61111],
      8704: [0, 0.69444, 0, 0, 0.55556],
      8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
      8707: [0, 0.69444, 0, 0, 0.55556],
      8709: [0.05556, 0.75, 0, 0, 0.5],
      8711: [0, 0.68333, 0, 0, 0.83334],
      8712: [0.0391, 0.5391, 0, 0, 0.66667],
      8715: [0.0391, 0.5391, 0, 0, 0.66667],
      8722: [0.08333, 0.58333, 0, 0, 0.77778],
      8723: [0.08333, 0.58333, 0, 0, 0.77778],
      8725: [0.25, 0.75, 0, 0, 0.5],
      8726: [0.25, 0.75, 0, 0, 0.5],
      8727: [-0.03472, 0.46528, 0, 0, 0.5],
      8728: [-0.05555, 0.44445, 0, 0, 0.5],
      8729: [-0.05555, 0.44445, 0, 0, 0.5],
      8730: [0.2, 0.8, 0, 0, 0.83334],
      8733: [0, 0.43056, 0, 0, 0.77778],
      8734: [0, 0.43056, 0, 0, 1],
      8736: [0, 0.69224, 0, 0, 0.72222],
      8739: [0.25, 0.75, 0, 0, 0.27778],
      8741: [0.25, 0.75, 0, 0, 0.5],
      8743: [0, 0.55556, 0, 0, 0.66667],
      8744: [0, 0.55556, 0, 0, 0.66667],
      8745: [0, 0.55556, 0, 0, 0.66667],
      8746: [0, 0.55556, 0, 0, 0.66667],
      8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
      8764: [-0.13313, 0.36687, 0, 0, 0.77778],
      8768: [0.19444, 0.69444, 0, 0, 0.27778],
      8771: [-0.03625, 0.46375, 0, 0, 0.77778],
      8773: [-0.022, 0.589, 0, 0, 0.778],
      8776: [-0.01688, 0.48312, 0, 0, 0.77778],
      8781: [-0.03625, 0.46375, 0, 0, 0.77778],
      8784: [-0.133, 0.673, 0, 0, 0.778],
      8801: [-0.03625, 0.46375, 0, 0, 0.77778],
      8804: [0.13597, 0.63597, 0, 0, 0.77778],
      8805: [0.13597, 0.63597, 0, 0, 0.77778],
      8810: [0.0391, 0.5391, 0, 0, 1],
      8811: [0.0391, 0.5391, 0, 0, 1],
      8826: [0.0391, 0.5391, 0, 0, 0.77778],
      8827: [0.0391, 0.5391, 0, 0, 0.77778],
      8834: [0.0391, 0.5391, 0, 0, 0.77778],
      8835: [0.0391, 0.5391, 0, 0, 0.77778],
      8838: [0.13597, 0.63597, 0, 0, 0.77778],
      8839: [0.13597, 0.63597, 0, 0, 0.77778],
      8846: [0, 0.55556, 0, 0, 0.66667],
      8849: [0.13597, 0.63597, 0, 0, 0.77778],
      8850: [0.13597, 0.63597, 0, 0, 0.77778],
      8851: [0, 0.55556, 0, 0, 0.66667],
      8852: [0, 0.55556, 0, 0, 0.66667],
      8853: [0.08333, 0.58333, 0, 0, 0.77778],
      8854: [0.08333, 0.58333, 0, 0, 0.77778],
      8855: [0.08333, 0.58333, 0, 0, 0.77778],
      8856: [0.08333, 0.58333, 0, 0, 0.77778],
      8857: [0.08333, 0.58333, 0, 0, 0.77778],
      8866: [0, 0.69444, 0, 0, 0.61111],
      8867: [0, 0.69444, 0, 0, 0.61111],
      8868: [0, 0.69444, 0, 0, 0.77778],
      8869: [0, 0.69444, 0, 0, 0.77778],
      8872: [0.249, 0.75, 0, 0, 0.867],
      8900: [-0.05555, 0.44445, 0, 0, 0.5],
      8901: [-0.05555, 0.44445, 0, 0, 0.27778],
      8902: [-0.03472, 0.46528, 0, 0, 0.5],
      8904: [0.005, 0.505, 0, 0, 0.9],
      8942: [0.03, 0.903, 0, 0, 0.278],
      8943: [-0.19, 0.313, 0, 0, 1.172],
      8945: [-0.1, 0.823, 0, 0, 1.282],
      8968: [0.25, 0.75, 0, 0, 0.44445],
      8969: [0.25, 0.75, 0, 0, 0.44445],
      8970: [0.25, 0.75, 0, 0, 0.44445],
      8971: [0.25, 0.75, 0, 0, 0.44445],
      8994: [-0.14236, 0.35764, 0, 0, 1],
      8995: [-0.14236, 0.35764, 0, 0, 1],
      9136: [0.244, 0.744, 0, 0, 0.412],
      9137: [0.244, 0.745, 0, 0, 0.412],
      9651: [0.19444, 0.69444, 0, 0, 0.88889],
      9657: [-0.03472, 0.46528, 0, 0, 0.5],
      9661: [0.19444, 0.69444, 0, 0, 0.88889],
      9667: [-0.03472, 0.46528, 0, 0, 0.5],
      9711: [0.19444, 0.69444, 0, 0, 1],
      9824: [0.12963, 0.69444, 0, 0, 0.77778],
      9825: [0.12963, 0.69444, 0, 0, 0.77778],
      9826: [0.12963, 0.69444, 0, 0, 0.77778],
      9827: [0.12963, 0.69444, 0, 0, 0.77778],
      9837: [0, 0.75, 0, 0, 0.38889],
      9838: [0.19444, 0.69444, 0, 0, 0.38889],
      9839: [0.19444, 0.69444, 0, 0, 0.38889],
      10216: [0.25, 0.75, 0, 0, 0.38889],
      10217: [0.25, 0.75, 0, 0, 0.38889],
      10222: [0.244, 0.744, 0, 0, 0.412],
      10223: [0.244, 0.745, 0, 0, 0.412],
      10229: [0.011, 0.511, 0, 0, 1.609],
      10230: [0.011, 0.511, 0, 0, 1.638],
      10231: [0.011, 0.511, 0, 0, 1.859],
      10232: [0.024, 0.525, 0, 0, 1.609],
      10233: [0.024, 0.525, 0, 0, 1.638],
      10234: [0.024, 0.525, 0, 0, 1.858],
      10236: [0.011, 0.511, 0, 0, 1.638],
      10815: [0, 0.68333, 0, 0, 0.75],
      10927: [0.13597, 0.63597, 0, 0, 0.77778],
      10928: [0.13597, 0.63597, 0, 0, 0.77778],
      57376: [0.19444, 0.69444, 0, 0, 0],
    },
    "Math-BoldItalic": {
      32: [0, 0, 0, 0, 0.25],
      48: [0, 0.44444, 0, 0, 0.575],
      49: [0, 0.44444, 0, 0, 0.575],
      50: [0, 0.44444, 0, 0, 0.575],
      51: [0.19444, 0.44444, 0, 0, 0.575],
      52: [0.19444, 0.44444, 0, 0, 0.575],
      53: [0.19444, 0.44444, 0, 0, 0.575],
      54: [0, 0.64444, 0, 0, 0.575],
      55: [0.19444, 0.44444, 0, 0, 0.575],
      56: [0, 0.64444, 0, 0, 0.575],
      57: [0.19444, 0.44444, 0, 0, 0.575],
      65: [0, 0.68611, 0, 0, 0.86944],
      66: [0, 0.68611, 0.04835, 0, 0.8664],
      67: [0, 0.68611, 0.06979, 0, 0.81694],
      68: [0, 0.68611, 0.03194, 0, 0.93812],
      69: [0, 0.68611, 0.05451, 0, 0.81007],
      70: [0, 0.68611, 0.15972, 0, 0.68889],
      71: [0, 0.68611, 0, 0, 0.88673],
      72: [0, 0.68611, 0.08229, 0, 0.98229],
      73: [0, 0.68611, 0.07778, 0, 0.51111],
      74: [0, 0.68611, 0.10069, 0, 0.63125],
      75: [0, 0.68611, 0.06979, 0, 0.97118],
      76: [0, 0.68611, 0, 0, 0.75555],
      77: [0, 0.68611, 0.11424, 0, 1.14201],
      78: [0, 0.68611, 0.11424, 0, 0.95034],
      79: [0, 0.68611, 0.03194, 0, 0.83666],
      80: [0, 0.68611, 0.15972, 0, 0.72309],
      81: [0.19444, 0.68611, 0, 0, 0.86861],
      82: [0, 0.68611, 0.00421, 0, 0.87235],
      83: [0, 0.68611, 0.05382, 0, 0.69271],
      84: [0, 0.68611, 0.15972, 0, 0.63663],
      85: [0, 0.68611, 0.11424, 0, 0.80027],
      86: [0, 0.68611, 0.25555, 0, 0.67778],
      87: [0, 0.68611, 0.15972, 0, 1.09305],
      88: [0, 0.68611, 0.07778, 0, 0.94722],
      89: [0, 0.68611, 0.25555, 0, 0.67458],
      90: [0, 0.68611, 0.06979, 0, 0.77257],
      97: [0, 0.44444, 0, 0, 0.63287],
      98: [0, 0.69444, 0, 0, 0.52083],
      99: [0, 0.44444, 0, 0, 0.51342],
      100: [0, 0.69444, 0, 0, 0.60972],
      101: [0, 0.44444, 0, 0, 0.55361],
      102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
      103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
      104: [0, 0.69444, 0, 0, 0.66759],
      105: [0, 0.69326, 0, 0, 0.4048],
      106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
      107: [0, 0.69444, 0.01852, 0, 0.6037],
      108: [0, 0.69444, 0.0088, 0, 0.34815],
      109: [0, 0.44444, 0, 0, 1.0324],
      110: [0, 0.44444, 0, 0, 0.71296],
      111: [0, 0.44444, 0, 0, 0.58472],
      112: [0.19444, 0.44444, 0, 0, 0.60092],
      113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
      114: [0, 0.44444, 0.03194, 0, 0.5287],
      115: [0, 0.44444, 0, 0, 0.53125],
      116: [0, 0.63492, 0, 0, 0.41528],
      117: [0, 0.44444, 0, 0, 0.68102],
      118: [0, 0.44444, 0.03704, 0, 0.56666],
      119: [0, 0.44444, 0.02778, 0, 0.83148],
      120: [0, 0.44444, 0, 0, 0.65903],
      121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
      122: [0, 0.44444, 0.04213, 0, 0.55509],
      160: [0, 0, 0, 0, 0.25],
      915: [0, 0.68611, 0.15972, 0, 0.65694],
      916: [0, 0.68611, 0, 0, 0.95833],
      920: [0, 0.68611, 0.03194, 0, 0.86722],
      923: [0, 0.68611, 0, 0, 0.80555],
      926: [0, 0.68611, 0.07458, 0, 0.84125],
      928: [0, 0.68611, 0.08229, 0, 0.98229],
      931: [0, 0.68611, 0.05451, 0, 0.88507],
      933: [0, 0.68611, 0.15972, 0, 0.67083],
      934: [0, 0.68611, 0, 0, 0.76666],
      936: [0, 0.68611, 0.11653, 0, 0.71402],
      937: [0, 0.68611, 0.04835, 0, 0.8789],
      945: [0, 0.44444, 0, 0, 0.76064],
      946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
      947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
      948: [0, 0.69444, 0.03819, 0, 0.52222],
      949: [0, 0.44444, 0, 0, 0.52882],
      950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
      951: [0.19444, 0.44444, 0.03704, 0, 0.6],
      952: [0, 0.69444, 0.03194, 0, 0.5618],
      953: [0, 0.44444, 0, 0, 0.41204],
      954: [0, 0.44444, 0, 0, 0.66759],
      955: [0, 0.69444, 0, 0, 0.67083],
      956: [0.19444, 0.44444, 0, 0, 0.70787],
      957: [0, 0.44444, 0.06898, 0, 0.57685],
      958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
      959: [0, 0.44444, 0, 0, 0.58472],
      960: [0, 0.44444, 0.03704, 0, 0.68241],
      961: [0.19444, 0.44444, 0, 0, 0.6118],
      962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
      963: [0, 0.44444, 0.03704, 0, 0.68588],
      964: [0, 0.44444, 0.13472, 0, 0.52083],
      965: [0, 0.44444, 0.03704, 0, 0.63055],
      966: [0.19444, 0.44444, 0, 0, 0.74722],
      967: [0.19444, 0.44444, 0, 0, 0.71805],
      968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
      969: [0, 0.44444, 0.03704, 0, 0.71782],
      977: [0, 0.69444, 0, 0, 0.69155],
      981: [0.19444, 0.69444, 0, 0, 0.7125],
      982: [0, 0.44444, 0.03194, 0, 0.975],
      1009: [0.19444, 0.44444, 0, 0, 0.6118],
      1013: [0, 0.44444, 0, 0, 0.48333],
      57649: [0, 0.44444, 0, 0, 0.39352],
      57911: [0.19444, 0.44444, 0, 0, 0.43889],
    },
    "Math-Italic": {
      32: [0, 0, 0, 0, 0.25],
      48: [0, 0.43056, 0, 0, 0.5],
      49: [0, 0.43056, 0, 0, 0.5],
      50: [0, 0.43056, 0, 0, 0.5],
      51: [0.19444, 0.43056, 0, 0, 0.5],
      52: [0.19444, 0.43056, 0, 0, 0.5],
      53: [0.19444, 0.43056, 0, 0, 0.5],
      54: [0, 0.64444, 0, 0, 0.5],
      55: [0.19444, 0.43056, 0, 0, 0.5],
      56: [0, 0.64444, 0, 0, 0.5],
      57: [0.19444, 0.43056, 0, 0, 0.5],
      65: [0, 0.68333, 0, 0.13889, 0.75],
      66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
      67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
      68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
      69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
      70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
      71: [0, 0.68333, 0, 0.08334, 0.78625],
      72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
      73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
      74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
      75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
      76: [0, 0.68333, 0, 0.02778, 0.68056],
      77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
      78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
      79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
      80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
      81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
      82: [0, 0.68333, 0.00773, 0.08334, 0.75929],
      83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
      84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
      85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
      86: [0, 0.68333, 0.22222, 0, 0.58333],
      87: [0, 0.68333, 0.13889, 0, 0.94445],
      88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
      89: [0, 0.68333, 0.22222, 0, 0.58056],
      90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
      97: [0, 0.43056, 0, 0, 0.52859],
      98: [0, 0.69444, 0, 0, 0.42917],
      99: [0, 0.43056, 0, 0.05556, 0.43276],
      100: [0, 0.69444, 0, 0.16667, 0.52049],
      101: [0, 0.43056, 0, 0.05556, 0.46563],
      102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
      103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
      104: [0, 0.69444, 0, 0, 0.57616],
      105: [0, 0.65952, 0, 0, 0.34451],
      106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
      107: [0, 0.69444, 0.03148, 0, 0.5206],
      108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
      109: [0, 0.43056, 0, 0, 0.87801],
      110: [0, 0.43056, 0, 0, 0.60023],
      111: [0, 0.43056, 0, 0.05556, 0.48472],
      112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
      113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
      114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
      115: [0, 0.43056, 0, 0.05556, 0.46875],
      116: [0, 0.61508, 0, 0.08334, 0.36111],
      117: [0, 0.43056, 0, 0.02778, 0.57246],
      118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
      119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
      120: [0, 0.43056, 0, 0.02778, 0.57153],
      121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
      122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
      160: [0, 0, 0, 0, 0.25],
      915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
      916: [0, 0.68333, 0, 0.16667, 0.83334],
      920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
      923: [0, 0.68333, 0, 0.16667, 0.69445],
      926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
      928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
      931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
      933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
      934: [0, 0.68333, 0, 0.08334, 0.66667],
      936: [0, 0.68333, 0.11, 0.05556, 0.61222],
      937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
      945: [0, 0.43056, 0.0037, 0.02778, 0.6397],
      946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
      947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
      948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
      949: [0, 0.43056, 0, 0.08334, 0.46632],
      950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
      951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
      952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
      953: [0, 0.43056, 0, 0.05556, 0.35394],
      954: [0, 0.43056, 0, 0, 0.57616],
      955: [0, 0.69444, 0, 0, 0.58334],
      956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
      957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
      958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
      959: [0, 0.43056, 0, 0.05556, 0.48472],
      960: [0, 0.43056, 0.03588, 0, 0.57003],
      961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
      962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
      963: [0, 0.43056, 0.03588, 0, 0.57141],
      964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
      965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
      966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
      967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
      968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
      969: [0, 0.43056, 0.03588, 0, 0.62245],
      977: [0, 0.69444, 0, 0.08334, 0.59144],
      981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
      982: [0, 0.43056, 0.02778, 0, 0.82813],
      1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
      1013: [0, 0.43056, 0, 0.05556, 0.4059],
      57649: [0, 0.43056, 0, 0.02778, 0.32246],
      57911: [0.19444, 0.43056, 0, 0.08334, 0.38403],
    },
    "SansSerif-Bold": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.36667],
      34: [0, 0.69444, 0, 0, 0.55834],
      35: [0.19444, 0.69444, 0, 0, 0.91667],
      36: [0.05556, 0.75, 0, 0, 0.55],
      37: [0.05556, 0.75, 0, 0, 1.02912],
      38: [0, 0.69444, 0, 0, 0.83056],
      39: [0, 0.69444, 0, 0, 0.30556],
      40: [0.25, 0.75, 0, 0, 0.42778],
      41: [0.25, 0.75, 0, 0, 0.42778],
      42: [0, 0.75, 0, 0, 0.55],
      43: [0.11667, 0.61667, 0, 0, 0.85556],
      44: [0.10556, 0.13056, 0, 0, 0.30556],
      45: [0, 0.45833, 0, 0, 0.36667],
      46: [0, 0.13056, 0, 0, 0.30556],
      47: [0.25, 0.75, 0, 0, 0.55],
      48: [0, 0.69444, 0, 0, 0.55],
      49: [0, 0.69444, 0, 0, 0.55],
      50: [0, 0.69444, 0, 0, 0.55],
      51: [0, 0.69444, 0, 0, 0.55],
      52: [0, 0.69444, 0, 0, 0.55],
      53: [0, 0.69444, 0, 0, 0.55],
      54: [0, 0.69444, 0, 0, 0.55],
      55: [0, 0.69444, 0, 0, 0.55],
      56: [0, 0.69444, 0, 0, 0.55],
      57: [0, 0.69444, 0, 0, 0.55],
      58: [0, 0.45833, 0, 0, 0.30556],
      59: [0.10556, 0.45833, 0, 0, 0.30556],
      61: [-0.09375, 0.40625, 0, 0, 0.85556],
      63: [0, 0.69444, 0, 0, 0.51945],
      64: [0, 0.69444, 0, 0, 0.73334],
      65: [0, 0.69444, 0, 0, 0.73334],
      66: [0, 0.69444, 0, 0, 0.73334],
      67: [0, 0.69444, 0, 0, 0.70278],
      68: [0, 0.69444, 0, 0, 0.79445],
      69: [0, 0.69444, 0, 0, 0.64167],
      70: [0, 0.69444, 0, 0, 0.61111],
      71: [0, 0.69444, 0, 0, 0.73334],
      72: [0, 0.69444, 0, 0, 0.79445],
      73: [0, 0.69444, 0, 0, 0.33056],
      74: [0, 0.69444, 0, 0, 0.51945],
      75: [0, 0.69444, 0, 0, 0.76389],
      76: [0, 0.69444, 0, 0, 0.58056],
      77: [0, 0.69444, 0, 0, 0.97778],
      78: [0, 0.69444, 0, 0, 0.79445],
      79: [0, 0.69444, 0, 0, 0.79445],
      80: [0, 0.69444, 0, 0, 0.70278],
      81: [0.10556, 0.69444, 0, 0, 0.79445],
      82: [0, 0.69444, 0, 0, 0.70278],
      83: [0, 0.69444, 0, 0, 0.61111],
      84: [0, 0.69444, 0, 0, 0.73334],
      85: [0, 0.69444, 0, 0, 0.76389],
      86: [0, 0.69444, 0.01528, 0, 0.73334],
      87: [0, 0.69444, 0.01528, 0, 1.03889],
      88: [0, 0.69444, 0, 0, 0.73334],
      89: [0, 0.69444, 0.0275, 0, 0.73334],
      90: [0, 0.69444, 0, 0, 0.67223],
      91: [0.25, 0.75, 0, 0, 0.34306],
      93: [0.25, 0.75, 0, 0, 0.34306],
      94: [0, 0.69444, 0, 0, 0.55],
      95: [0.35, 0.10833, 0.03056, 0, 0.55],
      97: [0, 0.45833, 0, 0, 0.525],
      98: [0, 0.69444, 0, 0, 0.56111],
      99: [0, 0.45833, 0, 0, 0.48889],
      100: [0, 0.69444, 0, 0, 0.56111],
      101: [0, 0.45833, 0, 0, 0.51111],
      102: [0, 0.69444, 0.07639, 0, 0.33611],
      103: [0.19444, 0.45833, 0.01528, 0, 0.55],
      104: [0, 0.69444, 0, 0, 0.56111],
      105: [0, 0.69444, 0, 0, 0.25556],
      106: [0.19444, 0.69444, 0, 0, 0.28611],
      107: [0, 0.69444, 0, 0, 0.53056],
      108: [0, 0.69444, 0, 0, 0.25556],
      109: [0, 0.45833, 0, 0, 0.86667],
      110: [0, 0.45833, 0, 0, 0.56111],
      111: [0, 0.45833, 0, 0, 0.55],
      112: [0.19444, 0.45833, 0, 0, 0.56111],
      113: [0.19444, 0.45833, 0, 0, 0.56111],
      114: [0, 0.45833, 0.01528, 0, 0.37222],
      115: [0, 0.45833, 0, 0, 0.42167],
      116: [0, 0.58929, 0, 0, 0.40417],
      117: [0, 0.45833, 0, 0, 0.56111],
      118: [0, 0.45833, 0.01528, 0, 0.5],
      119: [0, 0.45833, 0.01528, 0, 0.74445],
      120: [0, 0.45833, 0, 0, 0.5],
      121: [0.19444, 0.45833, 0.01528, 0, 0.5],
      122: [0, 0.45833, 0, 0, 0.47639],
      126: [0.35, 0.34444, 0, 0, 0.55],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.69444, 0, 0, 0.55],
      176: [0, 0.69444, 0, 0, 0.73334],
      180: [0, 0.69444, 0, 0, 0.55],
      184: [0.17014, 0, 0, 0, 0.48889],
      305: [0, 0.45833, 0, 0, 0.25556],
      567: [0.19444, 0.45833, 0, 0, 0.28611],
      710: [0, 0.69444, 0, 0, 0.55],
      711: [0, 0.63542, 0, 0, 0.55],
      713: [0, 0.63778, 0, 0, 0.55],
      728: [0, 0.69444, 0, 0, 0.55],
      729: [0, 0.69444, 0, 0, 0.30556],
      730: [0, 0.69444, 0, 0, 0.73334],
      732: [0, 0.69444, 0, 0, 0.55],
      733: [0, 0.69444, 0, 0, 0.55],
      915: [0, 0.69444, 0, 0, 0.58056],
      916: [0, 0.69444, 0, 0, 0.91667],
      920: [0, 0.69444, 0, 0, 0.85556],
      923: [0, 0.69444, 0, 0, 0.67223],
      926: [0, 0.69444, 0, 0, 0.73334],
      928: [0, 0.69444, 0, 0, 0.79445],
      931: [0, 0.69444, 0, 0, 0.79445],
      933: [0, 0.69444, 0, 0, 0.85556],
      934: [0, 0.69444, 0, 0, 0.79445],
      936: [0, 0.69444, 0, 0, 0.85556],
      937: [0, 0.69444, 0, 0, 0.79445],
      8211: [0, 0.45833, 0.03056, 0, 0.55],
      8212: [0, 0.45833, 0.03056, 0, 1.10001],
      8216: [0, 0.69444, 0, 0, 0.30556],
      8217: [0, 0.69444, 0, 0, 0.30556],
      8220: [0, 0.69444, 0, 0, 0.55834],
      8221: [0, 0.69444, 0, 0, 0.55834],
    },
    "SansSerif-Italic": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0.05733, 0, 0.31945],
      34: [0, 0.69444, 0.00316, 0, 0.5],
      35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
      36: [0.05556, 0.75, 0.11156, 0, 0.5],
      37: [0.05556, 0.75, 0.03126, 0, 0.83334],
      38: [0, 0.69444, 0.03058, 0, 0.75834],
      39: [0, 0.69444, 0.07816, 0, 0.27778],
      40: [0.25, 0.75, 0.13164, 0, 0.38889],
      41: [0.25, 0.75, 0.02536, 0, 0.38889],
      42: [0, 0.75, 0.11775, 0, 0.5],
      43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
      44: [0.125, 0.08333, 0, 0, 0.27778],
      45: [0, 0.44444, 0.01946, 0, 0.33333],
      46: [0, 0.08333, 0, 0, 0.27778],
      47: [0.25, 0.75, 0.13164, 0, 0.5],
      48: [0, 0.65556, 0.11156, 0, 0.5],
      49: [0, 0.65556, 0.11156, 0, 0.5],
      50: [0, 0.65556, 0.11156, 0, 0.5],
      51: [0, 0.65556, 0.11156, 0, 0.5],
      52: [0, 0.65556, 0.11156, 0, 0.5],
      53: [0, 0.65556, 0.11156, 0, 0.5],
      54: [0, 0.65556, 0.11156, 0, 0.5],
      55: [0, 0.65556, 0.11156, 0, 0.5],
      56: [0, 0.65556, 0.11156, 0, 0.5],
      57: [0, 0.65556, 0.11156, 0, 0.5],
      58: [0, 0.44444, 0.02502, 0, 0.27778],
      59: [0.125, 0.44444, 0.02502, 0, 0.27778],
      61: [-0.13, 0.37, 0.05087, 0, 0.77778],
      63: [0, 0.69444, 0.11809, 0, 0.47222],
      64: [0, 0.69444, 0.07555, 0, 0.66667],
      65: [0, 0.69444, 0, 0, 0.66667],
      66: [0, 0.69444, 0.08293, 0, 0.66667],
      67: [0, 0.69444, 0.11983, 0, 0.63889],
      68: [0, 0.69444, 0.07555, 0, 0.72223],
      69: [0, 0.69444, 0.11983, 0, 0.59722],
      70: [0, 0.69444, 0.13372, 0, 0.56945],
      71: [0, 0.69444, 0.11983, 0, 0.66667],
      72: [0, 0.69444, 0.08094, 0, 0.70834],
      73: [0, 0.69444, 0.13372, 0, 0.27778],
      74: [0, 0.69444, 0.08094, 0, 0.47222],
      75: [0, 0.69444, 0.11983, 0, 0.69445],
      76: [0, 0.69444, 0, 0, 0.54167],
      77: [0, 0.69444, 0.08094, 0, 0.875],
      78: [0, 0.69444, 0.08094, 0, 0.70834],
      79: [0, 0.69444, 0.07555, 0, 0.73611],
      80: [0, 0.69444, 0.08293, 0, 0.63889],
      81: [0.125, 0.69444, 0.07555, 0, 0.73611],
      82: [0, 0.69444, 0.08293, 0, 0.64584],
      83: [0, 0.69444, 0.09205, 0, 0.55556],
      84: [0, 0.69444, 0.13372, 0, 0.68056],
      85: [0, 0.69444, 0.08094, 0, 0.6875],
      86: [0, 0.69444, 0.1615, 0, 0.66667],
      87: [0, 0.69444, 0.1615, 0, 0.94445],
      88: [0, 0.69444, 0.13372, 0, 0.66667],
      89: [0, 0.69444, 0.17261, 0, 0.66667],
      90: [0, 0.69444, 0.11983, 0, 0.61111],
      91: [0.25, 0.75, 0.15942, 0, 0.28889],
      93: [0.25, 0.75, 0.08719, 0, 0.28889],
      94: [0, 0.69444, 0.0799, 0, 0.5],
      95: [0.35, 0.09444, 0.08616, 0, 0.5],
      97: [0, 0.44444, 0.00981, 0, 0.48056],
      98: [0, 0.69444, 0.03057, 0, 0.51667],
      99: [0, 0.44444, 0.08336, 0, 0.44445],
      100: [0, 0.69444, 0.09483, 0, 0.51667],
      101: [0, 0.44444, 0.06778, 0, 0.44445],
      102: [0, 0.69444, 0.21705, 0, 0.30556],
      103: [0.19444, 0.44444, 0.10836, 0, 0.5],
      104: [0, 0.69444, 0.01778, 0, 0.51667],
      105: [0, 0.67937, 0.09718, 0, 0.23889],
      106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
      107: [0, 0.69444, 0.08336, 0, 0.48889],
      108: [0, 0.69444, 0.09483, 0, 0.23889],
      109: [0, 0.44444, 0.01778, 0, 0.79445],
      110: [0, 0.44444, 0.01778, 0, 0.51667],
      111: [0, 0.44444, 0.06613, 0, 0.5],
      112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
      113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
      114: [0, 0.44444, 0.10836, 0, 0.34167],
      115: [0, 0.44444, 0.0778, 0, 0.38333],
      116: [0, 0.57143, 0.07225, 0, 0.36111],
      117: [0, 0.44444, 0.04169, 0, 0.51667],
      118: [0, 0.44444, 0.10836, 0, 0.46111],
      119: [0, 0.44444, 0.10836, 0, 0.68334],
      120: [0, 0.44444, 0.09169, 0, 0.46111],
      121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
      122: [0, 0.44444, 0.08752, 0, 0.43472],
      126: [0.35, 0.32659, 0.08826, 0, 0.5],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.67937, 0.06385, 0, 0.5],
      176: [0, 0.69444, 0, 0, 0.73752],
      184: [0.17014, 0, 0, 0, 0.44445],
      305: [0, 0.44444, 0.04169, 0, 0.23889],
      567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
      710: [0, 0.69444, 0.0799, 0, 0.5],
      711: [0, 0.63194, 0.08432, 0, 0.5],
      713: [0, 0.60889, 0.08776, 0, 0.5],
      714: [0, 0.69444, 0.09205, 0, 0.5],
      715: [0, 0.69444, 0, 0, 0.5],
      728: [0, 0.69444, 0.09483, 0, 0.5],
      729: [0, 0.67937, 0.07774, 0, 0.27778],
      730: [0, 0.69444, 0, 0, 0.73752],
      732: [0, 0.67659, 0.08826, 0, 0.5],
      733: [0, 0.69444, 0.09205, 0, 0.5],
      915: [0, 0.69444, 0.13372, 0, 0.54167],
      916: [0, 0.69444, 0, 0, 0.83334],
      920: [0, 0.69444, 0.07555, 0, 0.77778],
      923: [0, 0.69444, 0, 0, 0.61111],
      926: [0, 0.69444, 0.12816, 0, 0.66667],
      928: [0, 0.69444, 0.08094, 0, 0.70834],
      931: [0, 0.69444, 0.11983, 0, 0.72222],
      933: [0, 0.69444, 0.09031, 0, 0.77778],
      934: [0, 0.69444, 0.04603, 0, 0.72222],
      936: [0, 0.69444, 0.09031, 0, 0.77778],
      937: [0, 0.69444, 0.08293, 0, 0.72222],
      8211: [0, 0.44444, 0.08616, 0, 0.5],
      8212: [0, 0.44444, 0.08616, 0, 1],
      8216: [0, 0.69444, 0.07816, 0, 0.27778],
      8217: [0, 0.69444, 0.07816, 0, 0.27778],
      8220: [0, 0.69444, 0.14205, 0, 0.5],
      8221: [0, 0.69444, 0.00316, 0, 0.5],
    },
    "SansSerif-Regular": {
      32: [0, 0, 0, 0, 0.25],
      33: [0, 0.69444, 0, 0, 0.31945],
      34: [0, 0.69444, 0, 0, 0.5],
      35: [0.19444, 0.69444, 0, 0, 0.83334],
      36: [0.05556, 0.75, 0, 0, 0.5],
      37: [0.05556, 0.75, 0, 0, 0.83334],
      38: [0, 0.69444, 0, 0, 0.75834],
      39: [0, 0.69444, 0, 0, 0.27778],
      40: [0.25, 0.75, 0, 0, 0.38889],
      41: [0.25, 0.75, 0, 0, 0.38889],
      42: [0, 0.75, 0, 0, 0.5],
      43: [0.08333, 0.58333, 0, 0, 0.77778],
      44: [0.125, 0.08333, 0, 0, 0.27778],
      45: [0, 0.44444, 0, 0, 0.33333],
      46: [0, 0.08333, 0, 0, 0.27778],
      47: [0.25, 0.75, 0, 0, 0.5],
      48: [0, 0.65556, 0, 0, 0.5],
      49: [0, 0.65556, 0, 0, 0.5],
      50: [0, 0.65556, 0, 0, 0.5],
      51: [0, 0.65556, 0, 0, 0.5],
      52: [0, 0.65556, 0, 0, 0.5],
      53: [0, 0.65556, 0, 0, 0.5],
      54: [0, 0.65556, 0, 0, 0.5],
      55: [0, 0.65556, 0, 0, 0.5],
      56: [0, 0.65556, 0, 0, 0.5],
      57: [0, 0.65556, 0, 0, 0.5],
      58: [0, 0.44444, 0, 0, 0.27778],
      59: [0.125, 0.44444, 0, 0, 0.27778],
      61: [-0.13, 0.37, 0, 0, 0.77778],
      63: [0, 0.69444, 0, 0, 0.47222],
      64: [0, 0.69444, 0, 0, 0.66667],
      65: [0, 0.69444, 0, 0, 0.66667],
      66: [0, 0.69444, 0, 0, 0.66667],
      67: [0, 0.69444, 0, 0, 0.63889],
      68: [0, 0.69444, 0, 0, 0.72223],
      69: [0, 0.69444, 0, 0, 0.59722],
      70: [0, 0.69444, 0, 0, 0.56945],
      71: [0, 0.69444, 0, 0, 0.66667],
      72: [0, 0.69444, 0, 0, 0.70834],
      73: [0, 0.69444, 0, 0, 0.27778],
      74: [0, 0.69444, 0, 0, 0.47222],
      75: [0, 0.69444, 0, 0, 0.69445],
      76: [0, 0.69444, 0, 0, 0.54167],
      77: [0, 0.69444, 0, 0, 0.875],
      78: [0, 0.69444, 0, 0, 0.70834],
      79: [0, 0.69444, 0, 0, 0.73611],
      80: [0, 0.69444, 0, 0, 0.63889],
      81: [0.125, 0.69444, 0, 0, 0.73611],
      82: [0, 0.69444, 0, 0, 0.64584],
      83: [0, 0.69444, 0, 0, 0.55556],
      84: [0, 0.69444, 0, 0, 0.68056],
      85: [0, 0.69444, 0, 0, 0.6875],
      86: [0, 0.69444, 0.01389, 0, 0.66667],
      87: [0, 0.69444, 0.01389, 0, 0.94445],
      88: [0, 0.69444, 0, 0, 0.66667],
      89: [0, 0.69444, 0.025, 0, 0.66667],
      90: [0, 0.69444, 0, 0, 0.61111],
      91: [0.25, 0.75, 0, 0, 0.28889],
      93: [0.25, 0.75, 0, 0, 0.28889],
      94: [0, 0.69444, 0, 0, 0.5],
      95: [0.35, 0.09444, 0.02778, 0, 0.5],
      97: [0, 0.44444, 0, 0, 0.48056],
      98: [0, 0.69444, 0, 0, 0.51667],
      99: [0, 0.44444, 0, 0, 0.44445],
      100: [0, 0.69444, 0, 0, 0.51667],
      101: [0, 0.44444, 0, 0, 0.44445],
      102: [0, 0.69444, 0.06944, 0, 0.30556],
      103: [0.19444, 0.44444, 0.01389, 0, 0.5],
      104: [0, 0.69444, 0, 0, 0.51667],
      105: [0, 0.67937, 0, 0, 0.23889],
      106: [0.19444, 0.67937, 0, 0, 0.26667],
      107: [0, 0.69444, 0, 0, 0.48889],
      108: [0, 0.69444, 0, 0, 0.23889],
      109: [0, 0.44444, 0, 0, 0.79445],
      110: [0, 0.44444, 0, 0, 0.51667],
      111: [0, 0.44444, 0, 0, 0.5],
      112: [0.19444, 0.44444, 0, 0, 0.51667],
      113: [0.19444, 0.44444, 0, 0, 0.51667],
      114: [0, 0.44444, 0.01389, 0, 0.34167],
      115: [0, 0.44444, 0, 0, 0.38333],
      116: [0, 0.57143, 0, 0, 0.36111],
      117: [0, 0.44444, 0, 0, 0.51667],
      118: [0, 0.44444, 0.01389, 0, 0.46111],
      119: [0, 0.44444, 0.01389, 0, 0.68334],
      120: [0, 0.44444, 0, 0, 0.46111],
      121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
      122: [0, 0.44444, 0, 0, 0.43472],
      126: [0.35, 0.32659, 0, 0, 0.5],
      160: [0, 0, 0, 0, 0.25],
      168: [0, 0.67937, 0, 0, 0.5],
      176: [0, 0.69444, 0, 0, 0.66667],
      184: [0.17014, 0, 0, 0, 0.44445],
      305: [0, 0.44444, 0, 0, 0.23889],
      567: [0.19444, 0.44444, 0, 0, 0.26667],
      710: [0, 0.69444, 0, 0, 0.5],
      711: [0, 0.63194, 0, 0, 0.5],
      713: [0, 0.60889, 0, 0, 0.5],
      714: [0, 0.69444, 0, 0, 0.5],
      715: [0, 0.69444, 0, 0, 0.5],
      728: [0, 0.69444, 0, 0, 0.5],
      729: [0, 0.67937, 0, 0, 0.27778],
      730: [0, 0.69444, 0, 0, 0.66667],
      732: [0, 0.67659, 0, 0, 0.5],
      733: [0, 0.69444, 0, 0, 0.5],
      915: [0, 0.69444, 0, 0, 0.54167],
      916: [0, 0.69444, 0, 0, 0.83334],
      920: [0, 0.69444, 0, 0, 0.77778],
      923: [0, 0.69444, 0, 0, 0.61111],
      926: [0, 0.69444, 0, 0, 0.66667],
      928: [0, 0.69444, 0, 0, 0.70834],
      931: [0, 0.69444, 0, 0, 0.72222],
      933: [0, 0.69444, 0, 0, 0.77778],
      934: [0, 0.69444, 0, 0, 0.72222],
      936: [0, 0.69444, 0, 0, 0.77778],
      937: [0, 0.69444, 0, 0, 0.72222],
      8211: [0, 0.44444, 0.02778, 0, 0.5],
      8212: [0, 0.44444, 0.02778, 0, 1],
      8216: [0, 0.69444, 0, 0, 0.27778],
      8217: [0, 0.69444, 0, 0, 0.27778],
      8220: [0, 0.69444, 0, 0, 0.5],
      8221: [0, 0.69444, 0, 0, 0.5],
    },
    "Script-Regular": {
      32: [0, 0, 0, 0, 0.25],
      65: [0, 0.7, 0.22925, 0, 0.80253],
      66: [0, 0.7, 0.04087, 0, 0.90757],
      67: [0, 0.7, 0.1689, 0, 0.66619],
      68: [0, 0.7, 0.09371, 0, 0.77443],
      69: [0, 0.7, 0.18583, 0, 0.56162],
      70: [0, 0.7, 0.13634, 0, 0.89544],
      71: [0, 0.7, 0.17322, 0, 0.60961],
      72: [0, 0.7, 0.29694, 0, 0.96919],
      73: [0, 0.7, 0.19189, 0, 0.80907],
      74: [0.27778, 0.7, 0.19189, 0, 1.05159],
      75: [0, 0.7, 0.31259, 0, 0.91364],
      76: [0, 0.7, 0.19189, 0, 0.87373],
      77: [0, 0.7, 0.15981, 0, 1.08031],
      78: [0, 0.7, 0.3525, 0, 0.9015],
      79: [0, 0.7, 0.08078, 0, 0.73787],
      80: [0, 0.7, 0.08078, 0, 1.01262],
      81: [0, 0.7, 0.03305, 0, 0.88282],
      82: [0, 0.7, 0.06259, 0, 0.85],
      83: [0, 0.7, 0.19189, 0, 0.86767],
      84: [0, 0.7, 0.29087, 0, 0.74697],
      85: [0, 0.7, 0.25815, 0, 0.79996],
      86: [0, 0.7, 0.27523, 0, 0.62204],
      87: [0, 0.7, 0.27523, 0, 0.80532],
      88: [0, 0.7, 0.26006, 0, 0.94445],
      89: [0, 0.7, 0.2939, 0, 0.70961],
      90: [0, 0.7, 0.24037, 0, 0.8212],
      160: [0, 0, 0, 0, 0.25],
    },
    "Size1-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [0.35001, 0.85, 0, 0, 0.45834],
      41: [0.35001, 0.85, 0, 0, 0.45834],
      47: [0.35001, 0.85, 0, 0, 0.57778],
      91: [0.35001, 0.85, 0, 0, 0.41667],
      92: [0.35001, 0.85, 0, 0, 0.57778],
      93: [0.35001, 0.85, 0, 0, 0.41667],
      123: [0.35001, 0.85, 0, 0, 0.58334],
      125: [0.35001, 0.85, 0, 0, 0.58334],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.72222, 0, 0, 0.55556],
      732: [0, 0.72222, 0, 0, 0.55556],
      770: [0, 0.72222, 0, 0, 0.55556],
      771: [0, 0.72222, 0, 0, 0.55556],
      8214: [-99e-5, 0.601, 0, 0, 0.77778],
      8593: [1e-5, 0.6, 0, 0, 0.66667],
      8595: [1e-5, 0.6, 0, 0, 0.66667],
      8657: [1e-5, 0.6, 0, 0, 0.77778],
      8659: [1e-5, 0.6, 0, 0, 0.77778],
      8719: [0.25001, 0.75, 0, 0, 0.94445],
      8720: [0.25001, 0.75, 0, 0, 0.94445],
      8721: [0.25001, 0.75, 0, 0, 1.05556],
      8730: [0.35001, 0.85, 0, 0, 1],
      8739: [-0.00599, 0.606, 0, 0, 0.33333],
      8741: [-0.00599, 0.606, 0, 0, 0.55556],
      8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
      8748: [0.306, 0.805, 0.19445, 0, 0.47222],
      8749: [0.306, 0.805, 0.19445, 0, 0.47222],
      8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
      8896: [0.25001, 0.75, 0, 0, 0.83334],
      8897: [0.25001, 0.75, 0, 0, 0.83334],
      8898: [0.25001, 0.75, 0, 0, 0.83334],
      8899: [0.25001, 0.75, 0, 0, 0.83334],
      8968: [0.35001, 0.85, 0, 0, 0.47222],
      8969: [0.35001, 0.85, 0, 0, 0.47222],
      8970: [0.35001, 0.85, 0, 0, 0.47222],
      8971: [0.35001, 0.85, 0, 0, 0.47222],
      9168: [-99e-5, 0.601, 0, 0, 0.66667],
      10216: [0.35001, 0.85, 0, 0, 0.47222],
      10217: [0.35001, 0.85, 0, 0, 0.47222],
      10752: [0.25001, 0.75, 0, 0, 1.11111],
      10753: [0.25001, 0.75, 0, 0, 1.11111],
      10754: [0.25001, 0.75, 0, 0, 1.11111],
      10756: [0.25001, 0.75, 0, 0, 0.83334],
      10758: [0.25001, 0.75, 0, 0, 0.83334],
    },
    "Size2-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [0.65002, 1.15, 0, 0, 0.59722],
      41: [0.65002, 1.15, 0, 0, 0.59722],
      47: [0.65002, 1.15, 0, 0, 0.81111],
      91: [0.65002, 1.15, 0, 0, 0.47222],
      92: [0.65002, 1.15, 0, 0, 0.81111],
      93: [0.65002, 1.15, 0, 0, 0.47222],
      123: [0.65002, 1.15, 0, 0, 0.66667],
      125: [0.65002, 1.15, 0, 0, 0.66667],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.75, 0, 0, 1],
      732: [0, 0.75, 0, 0, 1],
      770: [0, 0.75, 0, 0, 1],
      771: [0, 0.75, 0, 0, 1],
      8719: [0.55001, 1.05, 0, 0, 1.27778],
      8720: [0.55001, 1.05, 0, 0, 1.27778],
      8721: [0.55001, 1.05, 0, 0, 1.44445],
      8730: [0.65002, 1.15, 0, 0, 1],
      8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
      8748: [0.862, 1.36, 0.44445, 0, 0.55556],
      8749: [0.862, 1.36, 0.44445, 0, 0.55556],
      8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
      8896: [0.55001, 1.05, 0, 0, 1.11111],
      8897: [0.55001, 1.05, 0, 0, 1.11111],
      8898: [0.55001, 1.05, 0, 0, 1.11111],
      8899: [0.55001, 1.05, 0, 0, 1.11111],
      8968: [0.65002, 1.15, 0, 0, 0.52778],
      8969: [0.65002, 1.15, 0, 0, 0.52778],
      8970: [0.65002, 1.15, 0, 0, 0.52778],
      8971: [0.65002, 1.15, 0, 0, 0.52778],
      10216: [0.65002, 1.15, 0, 0, 0.61111],
      10217: [0.65002, 1.15, 0, 0, 0.61111],
      10752: [0.55001, 1.05, 0, 0, 1.51112],
      10753: [0.55001, 1.05, 0, 0, 1.51112],
      10754: [0.55001, 1.05, 0, 0, 1.51112],
      10756: [0.55001, 1.05, 0, 0, 1.11111],
      10758: [0.55001, 1.05, 0, 0, 1.11111],
    },
    "Size3-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [0.95003, 1.45, 0, 0, 0.73611],
      41: [0.95003, 1.45, 0, 0, 0.73611],
      47: [0.95003, 1.45, 0, 0, 1.04445],
      91: [0.95003, 1.45, 0, 0, 0.52778],
      92: [0.95003, 1.45, 0, 0, 1.04445],
      93: [0.95003, 1.45, 0, 0, 0.52778],
      123: [0.95003, 1.45, 0, 0, 0.75],
      125: [0.95003, 1.45, 0, 0, 0.75],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.75, 0, 0, 1.44445],
      732: [0, 0.75, 0, 0, 1.44445],
      770: [0, 0.75, 0, 0, 1.44445],
      771: [0, 0.75, 0, 0, 1.44445],
      8730: [0.95003, 1.45, 0, 0, 1],
      8968: [0.95003, 1.45, 0, 0, 0.58334],
      8969: [0.95003, 1.45, 0, 0, 0.58334],
      8970: [0.95003, 1.45, 0, 0, 0.58334],
      8971: [0.95003, 1.45, 0, 0, 0.58334],
      10216: [0.95003, 1.45, 0, 0, 0.75],
      10217: [0.95003, 1.45, 0, 0, 0.75],
    },
    "Size4-Regular": {
      32: [0, 0, 0, 0, 0.25],
      40: [1.25003, 1.75, 0, 0, 0.79167],
      41: [1.25003, 1.75, 0, 0, 0.79167],
      47: [1.25003, 1.75, 0, 0, 1.27778],
      91: [1.25003, 1.75, 0, 0, 0.58334],
      92: [1.25003, 1.75, 0, 0, 1.27778],
      93: [1.25003, 1.75, 0, 0, 0.58334],
      123: [1.25003, 1.75, 0, 0, 0.80556],
      125: [1.25003, 1.75, 0, 0, 0.80556],
      160: [0, 0, 0, 0, 0.25],
      710: [0, 0.825, 0, 0, 1.8889],
      732: [0, 0.825, 0, 0, 1.8889],
      770: [0, 0.825, 0, 0, 1.8889],
      771: [0, 0.825, 0, 0, 1.8889],
      8730: [1.25003, 1.75, 0, 0, 1],
      8968: [1.25003, 1.75, 0, 0, 0.63889],
      8969: [1.25003, 1.75, 0, 0, 0.63889],
      8970: [1.25003, 1.75, 0, 0, 0.63889],
      8971: [1.25003, 1.75, 0, 0, 0.63889],
      9115: [0.64502, 1.155, 0, 0, 0.875],
      9116: [1e-5, 0.6, 0, 0, 0.875],
      9117: [0.64502, 1.155, 0, 0, 0.875],
      9118: [0.64502, 1.155, 0, 0, 0.875],
      9119: [1e-5, 0.6, 0, 0, 0.875],
      9120: [0.64502, 1.155, 0, 0, 0.875],
      9121: [0.64502, 1.155, 0, 0, 0.66667],
      9122: [-99e-5, 0.601, 0, 0, 0.66667],
      9123: [0.64502, 1.155, 0, 0, 0.66667],
      9124: [0.64502, 1.155, 0, 0, 0.66667],
      9125: [-99e-5, 0.601, 0, 0, 0.66667],
      9126: [0.64502, 1.155, 0, 0, 0.66667],
      9127: [1e-5, 0.9, 0, 0, 0.88889],
      9128: [0.65002, 1.15, 0, 0, 0.88889],
      9129: [0.90001, 0, 0, 0, 0.88889],
      9130: [0, 0.3, 0, 0, 0.88889],
      9131: [1e-5, 0.9, 0, 0, 0.88889],
      9132: [0.65002, 1.15, 0, 0, 0.88889],
      9133: [0.90001, 0, 0, 0, 0.88889],
      9143: [0.88502, 0.915, 0, 0, 1.05556],
      10216: [1.25003, 1.75, 0, 0, 0.80556],
      10217: [1.25003, 1.75, 0, 0, 0.80556],
      57344: [-0.00499, 0.605, 0, 0, 1.05556],
      57345: [-0.00499, 0.605, 0, 0, 1.05556],
      57680: [0, 0.12, 0, 0, 0.45],
      57681: [0, 0.12, 0, 0, 0.45],
      57682: [0, 0.12, 0, 0, 0.45],
      57683: [0, 0.12, 0, 0, 0.45],
    },
    "Typewriter-Regular": {
      32: [0, 0, 0, 0, 0.525],
      33: [0, 0.61111, 0, 0, 0.525],
      34: [0, 0.61111, 0, 0, 0.525],
      35: [0, 0.61111, 0, 0, 0.525],
      36: [0.08333, 0.69444, 0, 0, 0.525],
      37: [0.08333, 0.69444, 0, 0, 0.525],
      38: [0, 0.61111, 0, 0, 0.525],
      39: [0, 0.61111, 0, 0, 0.525],
      40: [0.08333, 0.69444, 0, 0, 0.525],
      41: [0.08333, 0.69444, 0, 0, 0.525],
      42: [0, 0.52083, 0, 0, 0.525],
      43: [-0.08056, 0.53055, 0, 0, 0.525],
      44: [0.13889, 0.125, 0, 0, 0.525],
      45: [-0.08056, 0.53055, 0, 0, 0.525],
      46: [0, 0.125, 0, 0, 0.525],
      47: [0.08333, 0.69444, 0, 0, 0.525],
      48: [0, 0.61111, 0, 0, 0.525],
      49: [0, 0.61111, 0, 0, 0.525],
      50: [0, 0.61111, 0, 0, 0.525],
      51: [0, 0.61111, 0, 0, 0.525],
      52: [0, 0.61111, 0, 0, 0.525],
      53: [0, 0.61111, 0, 0, 0.525],
      54: [0, 0.61111, 0, 0, 0.525],
      55: [0, 0.61111, 0, 0, 0.525],
      56: [0, 0.61111, 0, 0, 0.525],
      57: [0, 0.61111, 0, 0, 0.525],
      58: [0, 0.43056, 0, 0, 0.525],
      59: [0.13889, 0.43056, 0, 0, 0.525],
      60: [-0.05556, 0.55556, 0, 0, 0.525],
      61: [-0.19549, 0.41562, 0, 0, 0.525],
      62: [-0.05556, 0.55556, 0, 0, 0.525],
      63: [0, 0.61111, 0, 0, 0.525],
      64: [0, 0.61111, 0, 0, 0.525],
      65: [0, 0.61111, 0, 0, 0.525],
      66: [0, 0.61111, 0, 0, 0.525],
      67: [0, 0.61111, 0, 0, 0.525],
      68: [0, 0.61111, 0, 0, 0.525],
      69: [0, 0.61111, 0, 0, 0.525],
      70: [0, 0.61111, 0, 0, 0.525],
      71: [0, 0.61111, 0, 0, 0.525],
      72: [0, 0.61111, 0, 0, 0.525],
      73: [0, 0.61111, 0, 0, 0.525],
      74: [0, 0.61111, 0, 0, 0.525],
      75: [0, 0.61111, 0, 0, 0.525],
      76: [0, 0.61111, 0, 0, 0.525],
      77: [0, 0.61111, 0, 0, 0.525],
      78: [0, 0.61111, 0, 0, 0.525],
      79: [0, 0.61111, 0, 0, 0.525],
      80: [0, 0.61111, 0, 0, 0.525],
      81: [0.13889, 0.61111, 0, 0, 0.525],
      82: [0, 0.61111, 0, 0, 0.525],
      83: [0, 0.61111, 0, 0, 0.525],
      84: [0, 0.61111, 0, 0, 0.525],
      85: [0, 0.61111, 0, 0, 0.525],
      86: [0, 0.61111, 0, 0, 0.525],
      87: [0, 0.61111, 0, 0, 0.525],
      88: [0, 0.61111, 0, 0, 0.525],
      89: [0, 0.61111, 0, 0, 0.525],
      90: [0, 0.61111, 0, 0, 0.525],
      91: [0.08333, 0.69444, 0, 0, 0.525],
      92: [0.08333, 0.69444, 0, 0, 0.525],
      93: [0.08333, 0.69444, 0, 0, 0.525],
      94: [0, 0.61111, 0, 0, 0.525],
      95: [0.09514, 0, 0, 0, 0.525],
      96: [0, 0.61111, 0, 0, 0.525],
      97: [0, 0.43056, 0, 0, 0.525],
      98: [0, 0.61111, 0, 0, 0.525],
      99: [0, 0.43056, 0, 0, 0.525],
      100: [0, 0.61111, 0, 0, 0.525],
      101: [0, 0.43056, 0, 0, 0.525],
      102: [0, 0.61111, 0, 0, 0.525],
      103: [0.22222, 0.43056, 0, 0, 0.525],
      104: [0, 0.61111, 0, 0, 0.525],
      105: [0, 0.61111, 0, 0, 0.525],
      106: [0.22222, 0.61111, 0, 0, 0.525],
      107: [0, 0.61111, 0, 0, 0.525],
      108: [0, 0.61111, 0, 0, 0.525],
      109: [0, 0.43056, 0, 0, 0.525],
      110: [0, 0.43056, 0, 0, 0.525],
      111: [0, 0.43056, 0, 0, 0.525],
      112: [0.22222, 0.43056, 0, 0, 0.525],
      113: [0.22222, 0.43056, 0, 0, 0.525],
      114: [0, 0.43056, 0, 0, 0.525],
      115: [0, 0.43056, 0, 0, 0.525],
      116: [0, 0.55358, 0, 0, 0.525],
      117: [0, 0.43056, 0, 0, 0.525],
      118: [0, 0.43056, 0, 0, 0.525],
      119: [0, 0.43056, 0, 0, 0.525],
      120: [0, 0.43056, 0, 0, 0.525],
      121: [0.22222, 0.43056, 0, 0, 0.525],
      122: [0, 0.43056, 0, 0, 0.525],
      123: [0.08333, 0.69444, 0, 0, 0.525],
      124: [0.08333, 0.69444, 0, 0, 0.525],
      125: [0.08333, 0.69444, 0, 0, 0.525],
      126: [0, 0.61111, 0, 0, 0.525],
      127: [0, 0.61111, 0, 0, 0.525],
      160: [0, 0, 0, 0, 0.525],
      176: [0, 0.61111, 0, 0, 0.525],
      184: [0.19445, 0, 0, 0, 0.525],
      305: [0, 0.43056, 0, 0, 0.525],
      567: [0.22222, 0.43056, 0, 0, 0.525],
      711: [0, 0.56597, 0, 0, 0.525],
      713: [0, 0.56555, 0, 0, 0.525],
      714: [0, 0.61111, 0, 0, 0.525],
      715: [0, 0.61111, 0, 0, 0.525],
      728: [0, 0.61111, 0, 0, 0.525],
      730: [0, 0.61111, 0, 0, 0.525],
      770: [0, 0.61111, 0, 0, 0.525],
      771: [0, 0.61111, 0, 0, 0.525],
      776: [0, 0.61111, 0, 0, 0.525],
      915: [0, 0.61111, 0, 0, 0.525],
      916: [0, 0.61111, 0, 0, 0.525],
      920: [0, 0.61111, 0, 0, 0.525],
      923: [0, 0.61111, 0, 0, 0.525],
      926: [0, 0.61111, 0, 0, 0.525],
      928: [0, 0.61111, 0, 0, 0.525],
      931: [0, 0.61111, 0, 0, 0.525],
      933: [0, 0.61111, 0, 0, 0.525],
      934: [0, 0.61111, 0, 0, 0.525],
      936: [0, 0.61111, 0, 0, 0.525],
      937: [0, 0.61111, 0, 0, 0.525],
      8216: [0, 0.61111, 0, 0, 0.525],
      8217: [0, 0.61111, 0, 0, 0.525],
      8242: [0, 0.61111, 0, 0, 0.525],
      9251: [0.11111, 0.21944, 0, 0, 0.525],
    },
  },
  qr = {
    slant: [0.25, 0.25, 0.25],
    space: [0, 0, 0],
    stretch: [0, 0, 0],
    shrink: [0, 0, 0],
    xHeight: [0.431, 0.431, 0.431],
    quad: [1, 1.171, 1.472],
    extraSpace: [0, 0, 0],
    num1: [0.677, 0.732, 0.925],
    num2: [0.394, 0.384, 0.387],
    num3: [0.444, 0.471, 0.504],
    denom1: [0.686, 0.752, 1.025],
    denom2: [0.345, 0.344, 0.532],
    sup1: [0.413, 0.503, 0.504],
    sup2: [0.363, 0.431, 0.404],
    sup3: [0.289, 0.286, 0.294],
    sub1: [0.15, 0.143, 0.2],
    sub2: [0.247, 0.286, 0.4],
    supDrop: [0.386, 0.353, 0.494],
    subDrop: [0.05, 0.071, 0.1],
    delim1: [2.39, 1.7, 1.98],
    delim2: [1.01, 1.157, 1.42],
    axisHeight: [0.25, 0.25, 0.25],
    defaultRuleThickness: [0.04, 0.049, 0.049],
    bigOpSpacing1: [0.111, 0.111, 0.111],
    bigOpSpacing2: [0.166, 0.166, 0.166],
    bigOpSpacing3: [0.2, 0.2, 0.2],
    bigOpSpacing4: [0.6, 0.611, 0.611],
    bigOpSpacing5: [0.1, 0.143, 0.143],
    sqrtRuleThickness: [0.04, 0.04, 0.04],
    ptPerEm: [10, 10, 10],
    doubleRuleSep: [0.2, 0.2, 0.2],
    arrayRuleWidth: [0.04, 0.04, 0.04],
    fboxsep: [0.3, 0.3, 0.3],
    fboxrule: [0.04, 0.04, 0.04],
  },
  Jr = {
    Å: `A`,
    Ð: `D`,
    Þ: `o`,
    å: `a`,
    ð: `d`,
    þ: `o`,
    А: `A`,
    Б: `B`,
    В: `B`,
    Г: `F`,
    Д: `A`,
    Е: `E`,
    Ж: `K`,
    З: `3`,
    И: `N`,
    Й: `N`,
    К: `K`,
    Л: `N`,
    М: `M`,
    Н: `H`,
    О: `O`,
    П: `N`,
    Р: `P`,
    С: `C`,
    Т: `T`,
    У: `y`,
    Ф: `O`,
    Х: `X`,
    Ц: `U`,
    Ч: `h`,
    Ш: `W`,
    Щ: `W`,
    Ъ: `B`,
    Ы: `X`,
    Ь: `B`,
    Э: `3`,
    Ю: `X`,
    Я: `R`,
    а: `a`,
    б: `b`,
    в: `a`,
    г: `r`,
    д: `y`,
    е: `e`,
    ж: `m`,
    з: `e`,
    и: `n`,
    й: `n`,
    к: `n`,
    л: `n`,
    м: `m`,
    н: `n`,
    о: `o`,
    п: `n`,
    р: `p`,
    с: `c`,
    т: `o`,
    у: `y`,
    ф: `b`,
    х: `x`,
    ц: `n`,
    ч: `n`,
    ш: `w`,
    щ: `w`,
    ъ: `a`,
    ы: `m`,
    ь: `a`,
    э: `e`,
    ю: `m`,
    я: `r`,
  };
function Yr(e, t) {
  Kr[e] = t;
}
function Xr(e, t, n) {
  if (!Kr[t]) throw Error(`Font metrics not found for font: ` + t + `.`);
  var r = e.charCodeAt(0),
    i = Kr[t][r];
  if (
    (!i && e[0] in Jr && ((r = Jr[e[0]].charCodeAt(0)), (i = Kr[t][r])),
    !i && n === `text` && cr(r) && (i = Kr[t][77]),
    i)
  )
    return {
      depth: i[0],
      height: i[1],
      italic: i[2],
      skew: i[3],
      width: i[4],
    };
}
var Zr = {};
function Qr(e) {
  var t = e >= 5 ? 0 : e >= 3 ? 1 : 2;
  if (!Zr[t]) {
    var n = (Zr[t] = {
      cssEmPerMu: qr.quad[t] / 18,
    });
    for (var r in qr) qr.hasOwnProperty(r) && (n[r] = qr[r][t]);
  }
  return Zr[t];
}
var $r = {
  math: {},
  text: {},
};
function K(e, t, n, r, i, a) {
  (($r[e][i] = {
    font: t,
    group: n,
    replace: r,
  }),
    a && r && ($r[e][r] = $r[e][i]));
}
var q = `math`,
  ei = `text`,
  J = `main`,
  Y = `ams`,
  ti = `accent-token`,
  ni = `bin`,
  ri = `close`,
  ii = `inner`,
  ai = `mathord`,
  oi = `op-token`,
  si = `open`,
  ci = `punct`,
  X = `rel`,
  li = `spacing`,
  Z = `textord`;
(K(q, J, X, `≡`, `\\equiv`, !0),
  K(q, J, X, `≺`, `\\prec`, !0),
  K(q, J, X, `≻`, `\\succ`, !0),
  K(q, J, X, `∼`, `\\sim`, !0),
  K(q, J, X, `⊥`, `\\perp`),
  K(q, J, X, `⪯`, `\\preceq`, !0),
  K(q, J, X, `⪰`, `\\succeq`, !0),
  K(q, J, X, `≃`, `\\simeq`, !0),
  K(q, J, X, `∣`, `\\mid`, !0),
  K(q, J, X, `≪`, `\\ll`, !0),
  K(q, J, X, `≫`, `\\gg`, !0),
  K(q, J, X, `≍`, `\\asymp`, !0),
  K(q, J, X, `∥`, `\\parallel`),
  K(q, J, X, `⋈`, `\\bowtie`, !0),
  K(q, J, X, `⌣`, `\\smile`, !0),
  K(q, J, X, `⊑`, `\\sqsubseteq`, !0),
  K(q, J, X, `⊒`, `\\sqsupseteq`, !0),
  K(q, J, X, `≐`, `\\doteq`, !0),
  K(q, J, X, `⌢`, `\\frown`, !0),
  K(q, J, X, `∋`, `\\ni`, !0),
  K(q, J, X, `∝`, `\\propto`, !0),
  K(q, J, X, `⊢`, `\\vdash`, !0),
  K(q, J, X, `⊣`, `\\dashv`, !0),
  K(q, J, X, `∋`, `\\owns`),
  K(q, J, ci, `.`, `\\ldotp`),
  K(q, J, ci, `⋅`, `\\cdotp`),
  K(q, J, ci, `⋅`, `·`),
  K(ei, J, Z, `⋅`, `·`),
  K(q, J, Z, `#`, `\\#`),
  K(ei, J, Z, `#`, `\\#`),
  K(q, J, Z, `&`, `\\&`),
  K(ei, J, Z, `&`, `\\&`),
  K(q, J, Z, `ℵ`, `\\aleph`, !0),
  K(q, J, Z, `∀`, `\\forall`, !0),
  K(q, J, Z, `ℏ`, `\\hbar`, !0),
  K(q, J, Z, `∃`, `\\exists`, !0),
  K(q, J, Z, `∇`, `\\nabla`, !0),
  K(q, J, Z, `♭`, `\\flat`, !0),
  K(q, J, Z, `ℓ`, `\\ell`, !0),
  K(q, J, Z, `♮`, `\\natural`, !0),
  K(q, J, Z, `♣`, `\\clubsuit`, !0),
  K(q, J, Z, `℘`, `\\wp`, !0),
  K(q, J, Z, `♯`, `\\sharp`, !0),
  K(q, J, Z, `♢`, `\\diamondsuit`, !0),
  K(q, J, Z, `ℜ`, `\\Re`, !0),
  K(q, J, Z, `♡`, `\\heartsuit`, !0),
  K(q, J, Z, `ℑ`, `\\Im`, !0),
  K(q, J, Z, `♠`, `\\spadesuit`, !0),
  K(q, J, Z, `§`, `\\S`, !0),
  K(ei, J, Z, `§`, `\\S`),
  K(q, J, Z, `¶`, `\\P`, !0),
  K(ei, J, Z, `¶`, `\\P`),
  K(q, J, Z, `†`, `\\dag`),
  K(ei, J, Z, `†`, `\\dag`),
  K(ei, J, Z, `†`, `\\textdagger`),
  K(q, J, Z, `‡`, `\\ddag`),
  K(ei, J, Z, `‡`, `\\ddag`),
  K(ei, J, Z, `‡`, `\\textdaggerdbl`),
  K(q, J, ri, `⎱`, `\\rmoustache`, !0),
  K(q, J, si, `⎰`, `\\lmoustache`, !0),
  K(q, J, ri, `⟯`, `\\rgroup`, !0),
  K(q, J, si, `⟮`, `\\lgroup`, !0),
  K(q, J, ni, `∓`, `\\mp`, !0),
  K(q, J, ni, `⊖`, `\\ominus`, !0),
  K(q, J, ni, `⊎`, `\\uplus`, !0),
  K(q, J, ni, `⊓`, `\\sqcap`, !0),
  K(q, J, ni, `∗`, `\\ast`),
  K(q, J, ni, `⊔`, `\\sqcup`, !0),
  K(q, J, ni, `◯`, `\\bigcirc`, !0),
  K(q, J, ni, `∙`, `\\bullet`, !0),
  K(q, J, ni, `‡`, `\\ddagger`),
  K(q, J, ni, `≀`, `\\wr`, !0),
  K(q, J, ni, `⨿`, `\\amalg`),
  K(q, J, ni, `&`, `\\And`),
  K(q, J, X, `⟵`, `\\longleftarrow`, !0),
  K(q, J, X, `⇐`, `\\Leftarrow`, !0),
  K(q, J, X, `⟸`, `\\Longleftarrow`, !0),
  K(q, J, X, `⟶`, `\\longrightarrow`, !0),
  K(q, J, X, `⇒`, `\\Rightarrow`, !0),
  K(q, J, X, `⟹`, `\\Longrightarrow`, !0),
  K(q, J, X, `↔`, `\\leftrightarrow`, !0),
  K(q, J, X, `⟷`, `\\longleftrightarrow`, !0),
  K(q, J, X, `⇔`, `\\Leftrightarrow`, !0),
  K(q, J, X, `⟺`, `\\Longleftrightarrow`, !0),
  K(q, J, X, `↦`, `\\mapsto`, !0),
  K(q, J, X, `⟼`, `\\longmapsto`, !0),
  K(q, J, X, `↗`, `\\nearrow`, !0),
  K(q, J, X, `↩`, `\\hookleftarrow`, !0),
  K(q, J, X, `↪`, `\\hookrightarrow`, !0),
  K(q, J, X, `↘`, `\\searrow`, !0),
  K(q, J, X, `↼`, `\\leftharpoonup`, !0),
  K(q, J, X, `⇀`, `\\rightharpoonup`, !0),
  K(q, J, X, `↙`, `\\swarrow`, !0),
  K(q, J, X, `↽`, `\\leftharpoondown`, !0),
  K(q, J, X, `⇁`, `\\rightharpoondown`, !0),
  K(q, J, X, `↖`, `\\nwarrow`, !0),
  K(q, J, X, `⇌`, `\\rightleftharpoons`, !0),
  K(q, Y, X, `≮`, `\\nless`, !0),
  K(q, Y, X, ``, `\\@nleqslant`),
  K(q, Y, X, ``, `\\@nleqq`),
  K(q, Y, X, `⪇`, `\\lneq`, !0),
  K(q, Y, X, `≨`, `\\lneqq`, !0),
  K(q, Y, X, ``, `\\@lvertneqq`),
  K(q, Y, X, `⋦`, `\\lnsim`, !0),
  K(q, Y, X, `⪉`, `\\lnapprox`, !0),
  K(q, Y, X, `⊀`, `\\nprec`, !0),
  K(q, Y, X, `⋠`, `\\npreceq`, !0),
  K(q, Y, X, `⋨`, `\\precnsim`, !0),
  K(q, Y, X, `⪹`, `\\precnapprox`, !0),
  K(q, Y, X, `≁`, `\\nsim`, !0),
  K(q, Y, X, ``, `\\@nshortmid`),
  K(q, Y, X, `∤`, `\\nmid`, !0),
  K(q, Y, X, `⊬`, `\\nvdash`, !0),
  K(q, Y, X, `⊭`, `\\nvDash`, !0),
  K(q, Y, X, `⋪`, `\\ntriangleleft`),
  K(q, Y, X, `⋬`, `\\ntrianglelefteq`, !0),
  K(q, Y, X, `⊊`, `\\subsetneq`, !0),
  K(q, Y, X, ``, `\\@varsubsetneq`),
  K(q, Y, X, `⫋`, `\\subsetneqq`, !0),
  K(q, Y, X, ``, `\\@varsubsetneqq`),
  K(q, Y, X, `≯`, `\\ngtr`, !0),
  K(q, Y, X, ``, `\\@ngeqslant`),
  K(q, Y, X, ``, `\\@ngeqq`),
  K(q, Y, X, `⪈`, `\\gneq`, !0),
  K(q, Y, X, `≩`, `\\gneqq`, !0),
  K(q, Y, X, ``, `\\@gvertneqq`),
  K(q, Y, X, `⋧`, `\\gnsim`, !0),
  K(q, Y, X, `⪊`, `\\gnapprox`, !0),
  K(q, Y, X, `⊁`, `\\nsucc`, !0),
  K(q, Y, X, `⋡`, `\\nsucceq`, !0),
  K(q, Y, X, `⋩`, `\\succnsim`, !0),
  K(q, Y, X, `⪺`, `\\succnapprox`, !0),
  K(q, Y, X, `≆`, `\\ncong`, !0),
  K(q, Y, X, ``, `\\@nshortparallel`),
  K(q, Y, X, `∦`, `\\nparallel`, !0),
  K(q, Y, X, `⊯`, `\\nVDash`, !0),
  K(q, Y, X, `⋫`, `\\ntriangleright`),
  K(q, Y, X, `⋭`, `\\ntrianglerighteq`, !0),
  K(q, Y, X, ``, `\\@nsupseteqq`),
  K(q, Y, X, `⊋`, `\\supsetneq`, !0),
  K(q, Y, X, ``, `\\@varsupsetneq`),
  K(q, Y, X, `⫌`, `\\supsetneqq`, !0),
  K(q, Y, X, ``, `\\@varsupsetneqq`),
  K(q, Y, X, `⊮`, `\\nVdash`, !0),
  K(q, Y, X, `⪵`, `\\precneqq`, !0),
  K(q, Y, X, `⪶`, `\\succneqq`, !0),
  K(q, Y, X, ``, `\\@nsubseteqq`),
  K(q, Y, ni, `⊴`, `\\unlhd`),
  K(q, Y, ni, `⊵`, `\\unrhd`),
  K(q, Y, X, `↚`, `\\nleftarrow`, !0),
  K(q, Y, X, `↛`, `\\nrightarrow`, !0),
  K(q, Y, X, `⇍`, `\\nLeftarrow`, !0),
  K(q, Y, X, `⇏`, `\\nRightarrow`, !0),
  K(q, Y, X, `↮`, `\\nleftrightarrow`, !0),
  K(q, Y, X, `⇎`, `\\nLeftrightarrow`, !0),
  K(q, Y, X, `△`, `\\vartriangle`),
  K(q, Y, Z, `ℏ`, `\\hslash`),
  K(q, Y, Z, `▽`, `\\triangledown`),
  K(q, Y, Z, `◊`, `\\lozenge`),
  K(q, Y, Z, `Ⓢ`, `\\circledS`),
  K(q, Y, Z, `®`, `\\circledR`),
  K(ei, Y, Z, `®`, `\\circledR`),
  K(q, Y, Z, `∡`, `\\measuredangle`, !0),
  K(q, Y, Z, `∄`, `\\nexists`),
  K(q, Y, Z, `℧`, `\\mho`),
  K(q, Y, Z, `Ⅎ`, `\\Finv`, !0),
  K(q, Y, Z, `⅁`, `\\Game`, !0),
  K(q, Y, Z, `‵`, `\\backprime`),
  K(q, Y, Z, `▲`, `\\blacktriangle`),
  K(q, Y, Z, `▼`, `\\blacktriangledown`),
  K(q, Y, Z, `■`, `\\blacksquare`),
  K(q, Y, Z, `⧫`, `\\blacklozenge`),
  K(q, Y, Z, `★`, `\\bigstar`),
  K(q, Y, Z, `∢`, `\\sphericalangle`, !0),
  K(q, Y, Z, `∁`, `\\complement`, !0),
  K(q, Y, Z, `ð`, `\\eth`, !0),
  K(ei, J, Z, `ð`, `ð`),
  K(q, Y, Z, `╱`, `\\diagup`),
  K(q, Y, Z, `╲`, `\\diagdown`),
  K(q, Y, Z, `□`, `\\square`),
  K(q, Y, Z, `□`, `\\Box`),
  K(q, Y, Z, `◊`, `\\Diamond`),
  K(q, Y, Z, `¥`, `\\yen`, !0),
  K(ei, Y, Z, `¥`, `\\yen`, !0),
  K(q, Y, Z, `✓`, `\\checkmark`, !0),
  K(ei, Y, Z, `✓`, `\\checkmark`),
  K(q, Y, Z, `ℶ`, `\\beth`, !0),
  K(q, Y, Z, `ℸ`, `\\daleth`, !0),
  K(q, Y, Z, `ℷ`, `\\gimel`, !0),
  K(q, Y, Z, `ϝ`, `\\digamma`, !0),
  K(q, Y, Z, `ϰ`, `\\varkappa`),
  K(q, Y, si, `┌`, `\\@ulcorner`, !0),
  K(q, Y, ri, `┐`, `\\@urcorner`, !0),
  K(q, Y, si, `└`, `\\@llcorner`, !0),
  K(q, Y, ri, `┘`, `\\@lrcorner`, !0),
  K(q, Y, X, `≦`, `\\leqq`, !0),
  K(q, Y, X, `⩽`, `\\leqslant`, !0),
  K(q, Y, X, `⪕`, `\\eqslantless`, !0),
  K(q, Y, X, `≲`, `\\lesssim`, !0),
  K(q, Y, X, `⪅`, `\\lessapprox`, !0),
  K(q, Y, X, `≊`, `\\approxeq`, !0),
  K(q, Y, ni, `⋖`, `\\lessdot`),
  K(q, Y, X, `⋘`, `\\lll`, !0),
  K(q, Y, X, `≶`, `\\lessgtr`, !0),
  K(q, Y, X, `⋚`, `\\lesseqgtr`, !0),
  K(q, Y, X, `⪋`, `\\lesseqqgtr`, !0),
  K(q, Y, X, `≑`, `\\doteqdot`),
  K(q, Y, X, `≓`, `\\risingdotseq`, !0),
  K(q, Y, X, `≒`, `\\fallingdotseq`, !0),
  K(q, Y, X, `∽`, `\\backsim`, !0),
  K(q, Y, X, `⋍`, `\\backsimeq`, !0),
  K(q, Y, X, `⫅`, `\\subseteqq`, !0),
  K(q, Y, X, `⋐`, `\\Subset`, !0),
  K(q, Y, X, `⊏`, `\\sqsubset`, !0),
  K(q, Y, X, `≼`, `\\preccurlyeq`, !0),
  K(q, Y, X, `⋞`, `\\curlyeqprec`, !0),
  K(q, Y, X, `≾`, `\\precsim`, !0),
  K(q, Y, X, `⪷`, `\\precapprox`, !0),
  K(q, Y, X, `⊲`, `\\vartriangleleft`),
  K(q, Y, X, `⊴`, `\\trianglelefteq`),
  K(q, Y, X, `⊨`, `\\vDash`, !0),
  K(q, Y, X, `⊪`, `\\Vvdash`, !0),
  K(q, Y, X, `⌣`, `\\smallsmile`),
  K(q, Y, X, `⌢`, `\\smallfrown`),
  K(q, Y, X, `≏`, `\\bumpeq`, !0),
  K(q, Y, X, `≎`, `\\Bumpeq`, !0),
  K(q, Y, X, `≧`, `\\geqq`, !0),
  K(q, Y, X, `⩾`, `\\geqslant`, !0),
  K(q, Y, X, `⪖`, `\\eqslantgtr`, !0),
  K(q, Y, X, `≳`, `\\gtrsim`, !0),
  K(q, Y, X, `⪆`, `\\gtrapprox`, !0),
  K(q, Y, ni, `⋗`, `\\gtrdot`),
  K(q, Y, X, `⋙`, `\\ggg`, !0),
  K(q, Y, X, `≷`, `\\gtrless`, !0),
  K(q, Y, X, `⋛`, `\\gtreqless`, !0),
  K(q, Y, X, `⪌`, `\\gtreqqless`, !0),
  K(q, Y, X, `≖`, `\\eqcirc`, !0),
  K(q, Y, X, `≗`, `\\circeq`, !0),
  K(q, Y, X, `≜`, `\\triangleq`, !0),
  K(q, Y, X, `∼`, `\\thicksim`),
  K(q, Y, X, `≈`, `\\thickapprox`),
  K(q, Y, X, `⫆`, `\\supseteqq`, !0),
  K(q, Y, X, `⋑`, `\\Supset`, !0),
  K(q, Y, X, `⊐`, `\\sqsupset`, !0),
  K(q, Y, X, `≽`, `\\succcurlyeq`, !0),
  K(q, Y, X, `⋟`, `\\curlyeqsucc`, !0),
  K(q, Y, X, `≿`, `\\succsim`, !0),
  K(q, Y, X, `⪸`, `\\succapprox`, !0),
  K(q, Y, X, `⊳`, `\\vartriangleright`),
  K(q, Y, X, `⊵`, `\\trianglerighteq`),
  K(q, Y, X, `⊩`, `\\Vdash`, !0),
  K(q, Y, X, `∣`, `\\shortmid`),
  K(q, Y, X, `∥`, `\\shortparallel`),
  K(q, Y, X, `≬`, `\\between`, !0),
  K(q, Y, X, `⋔`, `\\pitchfork`, !0),
  K(q, Y, X, `∝`, `\\varpropto`),
  K(q, Y, X, `◀`, `\\blacktriangleleft`),
  K(q, Y, X, `∴`, `\\therefore`, !0),
  K(q, Y, X, `∍`, `\\backepsilon`),
  K(q, Y, X, `▶`, `\\blacktriangleright`),
  K(q, Y, X, `∵`, `\\because`, !0),
  K(q, Y, X, `⋘`, `\\llless`),
  K(q, Y, X, `⋙`, `\\gggtr`),
  K(q, Y, ni, `⊲`, `\\lhd`),
  K(q, Y, ni, `⊳`, `\\rhd`),
  K(q, Y, X, `≂`, `\\eqsim`, !0),
  K(q, J, X, `⋈`, `\\Join`),
  K(q, Y, X, `≑`, `\\Doteq`, !0),
  K(q, Y, ni, `∔`, `\\dotplus`, !0),
  K(q, Y, ni, `∖`, `\\smallsetminus`),
  K(q, Y, ni, `⋒`, `\\Cap`, !0),
  K(q, Y, ni, `⋓`, `\\Cup`, !0),
  K(q, Y, ni, `⩞`, `\\doublebarwedge`, !0),
  K(q, Y, ni, `⊟`, `\\boxminus`, !0),
  K(q, Y, ni, `⊞`, `\\boxplus`, !0),
  K(q, Y, ni, `⋇`, `\\divideontimes`, !0),
  K(q, Y, ni, `⋉`, `\\ltimes`, !0),
  K(q, Y, ni, `⋊`, `\\rtimes`, !0),
  K(q, Y, ni, `⋋`, `\\leftthreetimes`, !0),
  K(q, Y, ni, `⋌`, `\\rightthreetimes`, !0),
  K(q, Y, ni, `⋏`, `\\curlywedge`, !0),
  K(q, Y, ni, `⋎`, `\\curlyvee`, !0),
  K(q, Y, ni, `⊝`, `\\circleddash`, !0),
  K(q, Y, ni, `⊛`, `\\circledast`, !0),
  K(q, Y, ni, `⋅`, `\\centerdot`),
  K(q, Y, ni, `⊺`, `\\intercal`, !0),
  K(q, Y, ni, `⋒`, `\\doublecap`),
  K(q, Y, ni, `⋓`, `\\doublecup`),
  K(q, Y, ni, `⊠`, `\\boxtimes`, !0),
  K(q, Y, X, `⇢`, `\\dashrightarrow`, !0),
  K(q, Y, X, `⇠`, `\\dashleftarrow`, !0),
  K(q, Y, X, `⇇`, `\\leftleftarrows`, !0),
  K(q, Y, X, `⇆`, `\\leftrightarrows`, !0),
  K(q, Y, X, `⇚`, `\\Lleftarrow`, !0),
  K(q, Y, X, `↞`, `\\twoheadleftarrow`, !0),
  K(q, Y, X, `↢`, `\\leftarrowtail`, !0),
  K(q, Y, X, `↫`, `\\looparrowleft`, !0),
  K(q, Y, X, `⇋`, `\\leftrightharpoons`, !0),
  K(q, Y, X, `↶`, `\\curvearrowleft`, !0),
  K(q, Y, X, `↺`, `\\circlearrowleft`, !0),
  K(q, Y, X, `↰`, `\\Lsh`, !0),
  K(q, Y, X, `⇈`, `\\upuparrows`, !0),
  K(q, Y, X, `↿`, `\\upharpoonleft`, !0),
  K(q, Y, X, `⇃`, `\\downharpoonleft`, !0),
  K(q, J, X, `⊶`, `\\origof`, !0),
  K(q, J, X, `⊷`, `\\imageof`, !0),
  K(q, Y, X, `⊸`, `\\multimap`, !0),
  K(q, Y, X, `↭`, `\\leftrightsquigarrow`, !0),
  K(q, Y, X, `⇉`, `\\rightrightarrows`, !0),
  K(q, Y, X, `⇄`, `\\rightleftarrows`, !0),
  K(q, Y, X, `↠`, `\\twoheadrightarrow`, !0),
  K(q, Y, X, `↣`, `\\rightarrowtail`, !0),
  K(q, Y, X, `↬`, `\\looparrowright`, !0),
  K(q, Y, X, `↷`, `\\curvearrowright`, !0),
  K(q, Y, X, `↻`, `\\circlearrowright`, !0),
  K(q, Y, X, `↱`, `\\Rsh`, !0),
  K(q, Y, X, `⇊`, `\\downdownarrows`, !0),
  K(q, Y, X, `↾`, `\\upharpoonright`, !0),
  K(q, Y, X, `⇂`, `\\downharpoonright`, !0),
  K(q, Y, X, `⇝`, `\\rightsquigarrow`, !0),
  K(q, Y, X, `⇝`, `\\leadsto`),
  K(q, Y, X, `⇛`, `\\Rrightarrow`, !0),
  K(q, Y, X, `↾`, `\\restriction`),
  K(q, J, Z, `‘`, "`"),
  K(q, J, Z, `$`, `\\$`),
  K(ei, J, Z, `$`, `\\$`),
  K(ei, J, Z, `$`, `\\textdollar`),
  K(q, J, Z, `%`, `\\%`),
  K(ei, J, Z, `%`, `\\%`),
  K(q, J, Z, `_`, `\\_`),
  K(ei, J, Z, `_`, `\\_`),
  K(ei, J, Z, `_`, `\\textunderscore`),
  K(q, J, Z, `∠`, `\\angle`, !0),
  K(q, J, Z, `∞`, `\\infty`, !0),
  K(q, J, Z, `′`, `\\prime`),
  K(q, J, Z, `△`, `\\triangle`),
  K(q, J, Z, `Γ`, `\\Gamma`, !0),
  K(q, J, Z, `Δ`, `\\Delta`, !0),
  K(q, J, Z, `Θ`, `\\Theta`, !0),
  K(q, J, Z, `Λ`, `\\Lambda`, !0),
  K(q, J, Z, `Ξ`, `\\Xi`, !0),
  K(q, J, Z, `Π`, `\\Pi`, !0),
  K(q, J, Z, `Σ`, `\\Sigma`, !0),
  K(q, J, Z, `Υ`, `\\Upsilon`, !0),
  K(q, J, Z, `Φ`, `\\Phi`, !0),
  K(q, J, Z, `Ψ`, `\\Psi`, !0),
  K(q, J, Z, `Ω`, `\\Omega`, !0),
  K(q, J, Z, `A`, `Α`),
  K(q, J, Z, `B`, `Β`),
  K(q, J, Z, `E`, `Ε`),
  K(q, J, Z, `Z`, `Ζ`),
  K(q, J, Z, `H`, `Η`),
  K(q, J, Z, `I`, `Ι`),
  K(q, J, Z, `K`, `Κ`),
  K(q, J, Z, `M`, `Μ`),
  K(q, J, Z, `N`, `Ν`),
  K(q, J, Z, `O`, `Ο`),
  K(q, J, Z, `P`, `Ρ`),
  K(q, J, Z, `T`, `Τ`),
  K(q, J, Z, `X`, `Χ`),
  K(q, J, Z, `¬`, `\\neg`, !0),
  K(q, J, Z, `¬`, `\\lnot`),
  K(q, J, Z, `⊤`, `\\top`),
  K(q, J, Z, `⊥`, `\\bot`),
  K(q, J, Z, `∅`, `\\emptyset`),
  K(q, Y, Z, `∅`, `\\varnothing`),
  K(q, J, ai, `α`, `\\alpha`, !0),
  K(q, J, ai, `β`, `\\beta`, !0),
  K(q, J, ai, `γ`, `\\gamma`, !0),
  K(q, J, ai, `δ`, `\\delta`, !0),
  K(q, J, ai, `ϵ`, `\\epsilon`, !0),
  K(q, J, ai, `ζ`, `\\zeta`, !0),
  K(q, J, ai, `η`, `\\eta`, !0),
  K(q, J, ai, `θ`, `\\theta`, !0),
  K(q, J, ai, `ι`, `\\iota`, !0),
  K(q, J, ai, `κ`, `\\kappa`, !0),
  K(q, J, ai, `λ`, `\\lambda`, !0),
  K(q, J, ai, `μ`, `\\mu`, !0),
  K(q, J, ai, `ν`, `\\nu`, !0),
  K(q, J, ai, `ξ`, `\\xi`, !0),
  K(q, J, ai, `ο`, `\\omicron`, !0),
  K(q, J, ai, `π`, `\\pi`, !0),
  K(q, J, ai, `ρ`, `\\rho`, !0),
  K(q, J, ai, `σ`, `\\sigma`, !0),
  K(q, J, ai, `τ`, `\\tau`, !0),
  K(q, J, ai, `υ`, `\\upsilon`, !0),
  K(q, J, ai, `ϕ`, `\\phi`, !0),
  K(q, J, ai, `χ`, `\\chi`, !0),
  K(q, J, ai, `ψ`, `\\psi`, !0),
  K(q, J, ai, `ω`, `\\omega`, !0),
  K(q, J, ai, `ε`, `\\varepsilon`, !0),
  K(q, J, ai, `ϑ`, `\\vartheta`, !0),
  K(q, J, ai, `ϖ`, `\\varpi`, !0),
  K(q, J, ai, `ϱ`, `\\varrho`, !0),
  K(q, J, ai, `ς`, `\\varsigma`, !0),
  K(q, J, ai, `φ`, `\\varphi`, !0),
  K(q, J, ni, `∗`, `*`, !0),
  K(q, J, ni, `+`, `+`),
  K(q, J, ni, `−`, `-`, !0),
  K(q, J, ni, `⋅`, `\\cdot`, !0),
  K(q, J, ni, `∘`, `\\circ`, !0),
  K(q, J, ni, `÷`, `\\div`, !0),
  K(q, J, ni, `±`, `\\pm`, !0),
  K(q, J, ni, `×`, `\\times`, !0),
  K(q, J, ni, `∩`, `\\cap`, !0),
  K(q, J, ni, `∪`, `\\cup`, !0),
  K(q, J, ni, `∖`, `\\setminus`, !0),
  K(q, J, ni, `∧`, `\\land`),
  K(q, J, ni, `∨`, `\\lor`),
  K(q, J, ni, `∧`, `\\wedge`, !0),
  K(q, J, ni, `∨`, `\\vee`, !0),
  K(q, J, Z, `√`, `\\surd`),
  K(q, J, si, `⟨`, `\\langle`, !0),
  K(q, J, si, `∣`, `\\lvert`),
  K(q, J, si, `∥`, `\\lVert`),
  K(q, J, ri, `?`, `?`),
  K(q, J, ri, `!`, `!`),
  K(q, J, ri, `⟩`, `\\rangle`, !0),
  K(q, J, ri, `∣`, `\\rvert`),
  K(q, J, ri, `∥`, `\\rVert`),
  K(q, J, X, `=`, `=`),
  K(q, J, X, `:`, `:`),
  K(q, J, X, `≈`, `\\approx`, !0),
  K(q, J, X, `≅`, `\\cong`, !0),
  K(q, J, X, `≥`, `\\ge`),
  K(q, J, X, `≥`, `\\geq`, !0),
  K(q, J, X, `←`, `\\gets`),
  K(q, J, X, `>`, `\\gt`, !0),
  K(q, J, X, `∈`, `\\in`, !0),
  K(q, J, X, ``, `\\@not`),
  K(q, J, X, `⊂`, `\\subset`, !0),
  K(q, J, X, `⊃`, `\\supset`, !0),
  K(q, J, X, `⊆`, `\\subseteq`, !0),
  K(q, J, X, `⊇`, `\\supseteq`, !0),
  K(q, Y, X, `⊈`, `\\nsubseteq`, !0),
  K(q, Y, X, `⊉`, `\\nsupseteq`, !0),
  K(q, J, X, `⊨`, `\\models`),
  K(q, J, X, `←`, `\\leftarrow`, !0),
  K(q, J, X, `≤`, `\\le`),
  K(q, J, X, `≤`, `\\leq`, !0),
  K(q, J, X, `<`, `\\lt`, !0),
  K(q, J, X, `→`, `\\rightarrow`, !0),
  K(q, J, X, `→`, `\\to`),
  K(q, Y, X, `≱`, `\\ngeq`, !0),
  K(q, Y, X, `≰`, `\\nleq`, !0),
  K(q, J, li, `\xA0`, `\\ `),
  K(q, J, li, `\xA0`, `\\space`),
  K(q, J, li, `\xA0`, `\\nobreakspace`),
  K(ei, J, li, `\xA0`, `\\ `),
  K(ei, J, li, `\xA0`, ` `),
  K(ei, J, li, `\xA0`, `\\space`),
  K(ei, J, li, `\xA0`, `\\nobreakspace`),
  K(q, J, li, ``, `\\nobreak`),
  K(q, J, li, ``, `\\allowbreak`),
  K(q, J, ci, `,`, `,`),
  K(q, J, ci, `;`, `;`),
  K(q, Y, ni, `⊼`, `\\barwedge`, !0),
  K(q, Y, ni, `⊻`, `\\veebar`, !0),
  K(q, J, ni, `⊙`, `\\odot`, !0),
  K(q, J, ni, `⊕`, `\\oplus`, !0),
  K(q, J, ni, `⊗`, `\\otimes`, !0),
  K(q, J, Z, `∂`, `\\partial`, !0),
  K(q, J, ni, `⊘`, `\\oslash`, !0),
  K(q, Y, ni, `⊚`, `\\circledcirc`, !0),
  K(q, Y, ni, `⊡`, `\\boxdot`, !0),
  K(q, J, ni, `△`, `\\bigtriangleup`),
  K(q, J, ni, `▽`, `\\bigtriangledown`),
  K(q, J, ni, `†`, `\\dagger`),
  K(q, J, ni, `⋄`, `\\diamond`),
  K(q, J, ni, `⋆`, `\\star`),
  K(q, J, ni, `◃`, `\\triangleleft`),
  K(q, J, ni, `▹`, `\\triangleright`),
  K(q, J, si, `{`, `\\{`),
  K(ei, J, Z, `{`, `\\{`),
  K(ei, J, Z, `{`, `\\textbraceleft`),
  K(q, J, ri, `}`, `\\}`),
  K(ei, J, Z, `}`, `\\}`),
  K(ei, J, Z, `}`, `\\textbraceright`),
  K(q, J, si, `{`, `\\lbrace`),
  K(q, J, ri, `}`, `\\rbrace`),
  K(q, J, si, `[`, `\\lbrack`, !0),
  K(ei, J, Z, `[`, `\\lbrack`, !0),
  K(q, J, ri, `]`, `\\rbrack`, !0),
  K(ei, J, Z, `]`, `\\rbrack`, !0),
  K(q, J, si, `(`, `\\lparen`, !0),
  K(q, J, ri, `)`, `\\rparen`, !0),
  K(ei, J, Z, `<`, `\\textless`, !0),
  K(ei, J, Z, `>`, `\\textgreater`, !0),
  K(q, J, si, `⌊`, `\\lfloor`, !0),
  K(q, J, ri, `⌋`, `\\rfloor`, !0),
  K(q, J, si, `⌈`, `\\lceil`, !0),
  K(q, J, ri, `⌉`, `\\rceil`, !0),
  K(q, J, Z, `\\`, `\\backslash`),
  K(q, J, Z, `∣`, `|`),
  K(q, J, Z, `∣`, `\\vert`),
  K(ei, J, Z, `|`, `\\textbar`, !0),
  K(q, J, Z, `∥`, `\\|`),
  K(q, J, Z, `∥`, `\\Vert`),
  K(ei, J, Z, `∥`, `\\textbardbl`),
  K(ei, J, Z, `~`, `\\textasciitilde`),
  K(ei, J, Z, `\\`, `\\textbackslash`),
  K(ei, J, Z, `^`, `\\textasciicircum`),
  K(q, J, X, `↑`, `\\uparrow`, !0),
  K(q, J, X, `⇑`, `\\Uparrow`, !0),
  K(q, J, X, `↓`, `\\downarrow`, !0),
  K(q, J, X, `⇓`, `\\Downarrow`, !0),
  K(q, J, X, `↕`, `\\updownarrow`, !0),
  K(q, J, X, `⇕`, `\\Updownarrow`, !0),
  K(q, J, oi, `∐`, `\\coprod`),
  K(q, J, oi, `⋁`, `\\bigvee`),
  K(q, J, oi, `⋀`, `\\bigwedge`),
  K(q, J, oi, `⨄`, `\\biguplus`),
  K(q, J, oi, `⋂`, `\\bigcap`),
  K(q, J, oi, `⋃`, `\\bigcup`),
  K(q, J, oi, `∫`, `\\int`),
  K(q, J, oi, `∫`, `\\intop`),
  K(q, J, oi, `∬`, `\\iint`),
  K(q, J, oi, `∭`, `\\iiint`),
  K(q, J, oi, `∏`, `\\prod`),
  K(q, J, oi, `∑`, `\\sum`),
  K(q, J, oi, `⨂`, `\\bigotimes`),
  K(q, J, oi, `⨁`, `\\bigoplus`),
  K(q, J, oi, `⨀`, `\\bigodot`),
  K(q, J, oi, `∮`, `\\oint`),
  K(q, J, oi, `∯`, `\\oiint`),
  K(q, J, oi, `∰`, `\\oiiint`),
  K(q, J, oi, `⨆`, `\\bigsqcup`),
  K(q, J, oi, `∫`, `\\smallint`),
  K(ei, J, ii, `…`, `\\textellipsis`),
  K(q, J, ii, `…`, `\\mathellipsis`),
  K(ei, J, ii, `…`, `\\ldots`, !0),
  K(q, J, ii, `…`, `\\ldots`, !0),
  K(q, J, ii, `⋯`, `\\@cdots`, !0),
  K(q, J, ii, `⋱`, `\\ddots`, !0),
  K(q, J, Z, `⋮`, `\\varvdots`),
  K(ei, J, Z, `⋮`, `\\varvdots`),
  K(q, J, ti, `ˊ`, `\\acute`),
  K(q, J, ti, `ˋ`, `\\grave`),
  K(q, J, ti, `¨`, `\\ddot`),
  K(q, J, ti, `~`, `\\tilde`),
  K(q, J, ti, `ˉ`, `\\bar`),
  K(q, J, ti, `˘`, `\\breve`),
  K(q, J, ti, `ˇ`, `\\check`),
  K(q, J, ti, `^`, `\\hat`),
  K(q, J, ti, `⃗`, `\\vec`),
  K(q, J, ti, `˙`, `\\dot`),
  K(q, J, ti, `˚`, `\\mathring`),
  K(q, J, ai, ``, `\\@imath`),
  K(q, J, ai, ``, `\\@jmath`),
  K(q, J, Z, `ı`, `ı`),
  K(q, J, Z, `ȷ`, `ȷ`),
  K(ei, J, Z, `ı`, `\\i`, !0),
  K(ei, J, Z, `ȷ`, `\\j`, !0),
  K(ei, J, Z, `ß`, `\\ss`, !0),
  K(ei, J, Z, `æ`, `\\ae`, !0),
  K(ei, J, Z, `œ`, `\\oe`, !0),
  K(ei, J, Z, `ø`, `\\o`, !0),
  K(ei, J, Z, `Æ`, `\\AE`, !0),
  K(ei, J, Z, `Œ`, `\\OE`, !0),
  K(ei, J, Z, `Ø`, `\\O`, !0),
  K(ei, J, ti, `ˊ`, `\\'`),
  K(ei, J, ti, `ˋ`, "\\`"),
  K(ei, J, ti, `ˆ`, `\\^`),
  K(ei, J, ti, `˜`, `\\~`),
  K(ei, J, ti, `ˉ`, `\\=`),
  K(ei, J, ti, `˘`, `\\u`),
  K(ei, J, ti, `˙`, `\\.`),
  K(ei, J, ti, `¸`, `\\c`),
  K(ei, J, ti, `˚`, `\\r`),
  K(ei, J, ti, `ˇ`, `\\v`),
  K(ei, J, ti, `¨`, `\\"`),
  K(ei, J, ti, `˝`, `\\H`),
  K(ei, J, ti, `◯`, `\\textcircled`));
var ui = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0,
};
(K(ei, J, Z, `–`, `--`, !0),
  K(ei, J, Z, `–`, `\\textendash`),
  K(ei, J, Z, `—`, `---`, !0),
  K(ei, J, Z, `—`, `\\textemdash`),
  K(ei, J, Z, `‘`, "`", !0),
  K(ei, J, Z, `‘`, `\\textquoteleft`),
  K(ei, J, Z, `’`, `'`, !0),
  K(ei, J, Z, `’`, `\\textquoteright`),
  K(ei, J, Z, `“`, "``", !0),
  K(ei, J, Z, `“`, `\\textquotedblleft`),
  K(ei, J, Z, `”`, `''`, !0),
  K(ei, J, Z, `”`, `\\textquotedblright`),
  K(q, J, Z, `°`, `\\degree`, !0),
  K(ei, J, Z, `°`, `\\degree`),
  K(ei, J, Z, `°`, `\\textdegree`, !0),
  K(q, J, Z, `£`, `\\pounds`),
  K(q, J, Z, `£`, `\\mathsterling`, !0),
  K(ei, J, Z, `£`, `\\pounds`),
  K(ei, J, Z, `£`, `\\textsterling`, !0),
  K(q, Y, Z, `✠`, `\\maltese`),
  K(ei, Y, Z, `✠`, `\\maltese`));
for (var di = `0123456789/@."`, fi = 0; fi < di.length; fi++) {
  var pi = di.charAt(fi);
  K(q, J, Z, pi, pi);
}
for (var mi = `0123456789!@*()-=+";:?/.,`, hi = 0; hi < mi.length; hi++) {
  var gi = mi.charAt(hi);
  K(ei, J, Z, gi, gi);
}
for (
  var _i = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz`, vi = 0;
  vi < _i.length;
  vi++
) {
  var yi = _i.charAt(vi);
  (K(q, J, ai, yi, yi), K(ei, J, Z, yi, yi));
}
(K(q, Y, Z, `C`, `ℂ`),
  K(ei, Y, Z, `C`, `ℂ`),
  K(q, Y, Z, `H`, `ℍ`),
  K(ei, Y, Z, `H`, `ℍ`),
  K(q, Y, Z, `N`, `ℕ`),
  K(ei, Y, Z, `N`, `ℕ`),
  K(q, Y, Z, `P`, `ℙ`),
  K(ei, Y, Z, `P`, `ℙ`),
  K(q, Y, Z, `Q`, `ℚ`),
  K(ei, Y, Z, `Q`, `ℚ`),
  K(q, Y, Z, `R`, `ℝ`),
  K(ei, Y, Z, `R`, `ℝ`),
  K(q, Y, Z, `Z`, `ℤ`),
  K(ei, Y, Z, `Z`, `ℤ`),
  K(q, J, ai, `h`, `ℎ`),
  K(ei, J, ai, `h`, `ℎ`));
for (var bi, xi = 0; xi < _i.length; xi++) {
  var Si = _i.charAt(xi);
  ((bi = String.fromCharCode(55349, 56320 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56372 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56424 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56580 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56684 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56736 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56788 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56840 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    (bi = String.fromCharCode(55349, 56944 + xi)),
    K(q, J, ai, Si, bi),
    K(ei, J, Z, Si, bi),
    xi < 26 &&
      ((bi = String.fromCharCode(55349, 56632 + xi)),
      K(q, J, ai, Si, bi),
      K(ei, J, Z, Si, bi),
      (bi = String.fromCharCode(55349, 56476 + xi)),
      K(q, J, ai, Si, bi),
      K(ei, J, Z, Si, bi)));
}
((bi = String.fromCharCode(55349, 56668)), K(q, J, ai, `k`, bi), K(ei, J, Z, `k`, bi));
for (var Ci = 0; Ci < 10; Ci++) {
  var wi = Ci.toString();
  ((bi = String.fromCharCode(55349, 57294 + Ci)),
    K(q, J, ai, wi, bi),
    K(ei, J, Z, wi, bi),
    (bi = String.fromCharCode(55349, 57314 + Ci)),
    K(q, J, ai, wi, bi),
    K(ei, J, Z, wi, bi),
    (bi = String.fromCharCode(55349, 57324 + Ci)),
    K(q, J, ai, wi, bi),
    K(ei, J, Z, wi, bi),
    (bi = String.fromCharCode(55349, 57334 + Ci)),
    K(q, J, ai, wi, bi),
    K(ei, J, Z, wi, bi));
}
for (var Ti = `ÐÞþ`, Ei = 0; Ei < Ti.length; Ei++) {
  var Di = Ti.charAt(Ei);
  (K(q, J, ai, Di, Di), K(ei, J, Z, Di, Di));
}
var Oi = {
    mathClass: `mathbf`,
    textClass: `textbf`,
    font: `Main-Bold`,
  },
  ki = {
    mathClass: `mathnormal`,
    textClass: `textit`,
    font: `Math-Italic`,
  },
  Ai = {
    mathClass: `boldsymbol`,
    textClass: `boldsymbol`,
    font: `Main-BoldItalic`,
  },
  ji = {
    mathClass: `mathscr`,
    textClass: `textscr`,
    font: `Script-Regular`,
  },
  Mi = {
    mathClass: ``,
    textClass: ``,
    font: ``,
  },
  Ni = {
    mathClass: `mathfrak`,
    textClass: `textfrak`,
    font: `Fraktur-Regular`,
  },
  Pi = {
    mathClass: `mathbb`,
    textClass: `textbb`,
    font: `AMS-Regular`,
  },
  Fi = {
    mathClass: `mathboldfrak`,
    textClass: `textboldfrak`,
    font: `Fraktur-Regular`,
  },
  Ii = {
    mathClass: `mathsf`,
    textClass: `textsf`,
    font: `SansSerif-Regular`,
  },
  Li = {
    mathClass: `mathboldsf`,
    textClass: `textboldsf`,
    font: `SansSerif-Bold`,
  },
  Ri = {
    mathClass: `mathitsf`,
    textClass: `textitsf`,
    font: `SansSerif-Italic`,
  },
  zi = {
    mathClass: `mathtt`,
    textClass: `texttt`,
    font: `Typewriter-Regular`,
  },
  Bi = [
    Oi,
    Oi,
    ki,
    ki,
    Ai,
    Ai,
    ji,
    Mi,
    Mi,
    Mi,
    Ni,
    Ni,
    Pi,
    Pi,
    Fi,
    Fi,
    Ii,
    Ii,
    Li,
    Li,
    Ri,
    Ri,
    Mi,
    Mi,
    zi,
    zi,
  ],
  Vi = [Oi, Mi, Ii, Li, zi],
  Hi = (e) => {
    var t = e.charCodeAt(0),
      n = e.charCodeAt(1),
      r = (t - 55296) * 1024 + (n - 56320) + 65536;
    if (119808 <= r && r < 120484) return Bi[Math.floor((r - 119808) / 26)];
    if (120782 <= r && r <= 120831) return Vi[Math.floor((r - 120782) / 10)];
    if (r === 120485 || r === 120486) return Bi[0];
    if (120486 < r && r < 120782) return Mi;
    throw new Dn(`Unsupported character: ` + e);
  },
  Ui = function (e, t, n) {
    if ($r[n][e]) {
      var r = $r[n][e].replace;
      r && (e = r);
    }
    return {
      value: e,
      metrics: Xr(e, t, n),
    };
  },
  Wi = function (e, t, n, r, i) {
    var a = Ui(e, t, n),
      o = a.metrics;
    e = a.value;
    var s;
    if (o) {
      var c = o.italic;
      ((n === `text` || (r && r.font === `mathit`)) && (c = 0),
        (s = new zr(e, o.height, o.depth, c, o.skew, o.width, i)));
    } else
      (typeof console < `u` &&
        console.warn(
          `No character metrics ` + (`for '` + e + `' in style '` + t + `' and mode '` + n + `'`),
        ),
        (s = new zr(e, 0, 0, 0, 0, 0, i)));
    if (r) {
      ((s.maxFontSize = r.sizeMultiplier), r.style.isTight() && s.classes.push(`mtight`));
      var l = r.getColor();
      l && (s.style.color = l);
    }
    return s;
  },
  Gi = function (e, t, n, r) {
    return (
      r === void 0 && (r = []),
      n.font === `boldsymbol` && Ui(e, `Main-Bold`, t).metrics
        ? Wi(e, `Main-Bold`, t, n, r.concat([`mathbf`]))
        : e === `\\` || $r[t][e].font === `main`
          ? Wi(e, `Main-Regular`, t, n, r)
          : Wi(e, `AMS-Regular`, t, n, r.concat([`amsrm`]))
    );
  },
  Ki = function (e, t, n) {
    return n !== `textord` && Ui(e, `Math-BoldItalic`, t).metrics
      ? {
          fontName: `Math-BoldItalic`,
          fontClass: `boldsymbol`,
        }
      : {
          fontName: `Main-Bold`,
          fontClass: `mathbf`,
        };
  },
  qi = function (e, t) {
    var n = e.type === `mathord` ? `mathord` : `textord`,
      r = e.mode,
      i = e.text,
      a = [`mord`],
      { font: o, fontFamily: s, fontWeight: c, fontShape: l } = t,
      u = r === `math` || (r === `text` && !!o),
      d = u ? o : s,
      f = ``,
      p = ``;
    if (i.charCodeAt(0) === 55349) {
      var m = Hi(i);
      ((f = m.font), (p = m[r + `Class`]));
    }
    if (f) return Wi(i, f, r, t, a.concat(p));
    if (d) {
      var h, g;
      if (d === `boldsymbol`) {
        var v = Ki(i, r, n);
        ((h = v.fontName), (g = [v.fontClass]));
      } else u ? ((h = aa[o].fontName), (g = [o])) : ((h = ia(s, c, l)), (g = [s, c, l]));
      if (Ui(i, h, r).metrics) return Wi(i, h, r, t, a.concat(g));
      if (ui.hasOwnProperty(i) && h.slice(0, 10) === `Typewriter`) {
        for (var y = [], b = 0; b < i.length; b++) y.push(Wi(i[b], h, r, t, a.concat(g)));
        return ea(y);
      }
    }
    if (n === `mathord`) return Wi(i, `Math-Italic`, r, t, a.concat([`mathnormal`]));
    if (n === `textord`) {
      var x = $r[r][i] && $r[r][i].font;
      if (x === `ams`) return Wi(i, ia(`amsrm`, c, l), r, t, a.concat(`amsrm`, c, l));
      if (x === `main` || !x) return Wi(i, ia(`textrm`, c, l), r, t, a.concat(c, l));
      var S = ia(x, c, l);
      return Wi(i, S, r, t, a.concat(S, c, l));
    } else throw Error(`unexpected type: ` + n + ` in makeOrd`);
  },
  eee = (e, t) => {
    if (
      kr(e.classes) !== kr(t.classes) ||
      e.skew !== t.skew ||
      e.maxFontSize !== t.maxFontSize ||
      (e.italic !== 0 && e.hasClass(`mathnormal`))
    )
      return !1;
    if (e.classes.length === 1) {
      var n = e.classes[0];
      if (n === `mbin` || n === `mord`) return !1;
    }
    for (var r of Object.keys(e.style)) if (e.style[r] !== t.style[r]) return !1;
    for (var i of Object.keys(t.style)) if (e.style[i] !== t.style[i]) return !1;
    return !0;
  },
  Ji = (e) => {
    for (var t = 0; t < e.length - 1; t++) {
      var n = e[t],
        r = e[t + 1];
      n instanceof zr &&
        r instanceof zr &&
        eee(n, r) &&
        ((n.text += r.text),
        (n.height = Math.max(n.height, r.height)),
        (n.depth = Math.max(n.depth, r.depth)),
        (n.italic = r.italic),
        e.splice(t + 1, 1),
        t--);
    }
    return e;
  },
  Yi = function (e) {
    for (var t = 0, n = 0, r = 0, i = 0; i < e.children.length; i++) {
      var a = e.children[i];
      (a.height > t && (t = a.height),
        a.depth > n && (n = a.depth),
        a.maxFontSize > r && (r = a.maxFontSize));
    }
    ((e.height = t), (e.depth = n), (e.maxFontSize = r));
  },
  Xi = function (e, t, n, r) {
    var i = new Fr(e, t, n, r);
    return (Yi(i), i);
  },
  Zi = (e, t, n, r) => new Fr(e, t, n, r),
  Qi = function (e, t, n) {
    var r = Xi([e], [], t);
    return (
      (r.height = Math.max(n || t.fontMetrics().defaultRuleThickness, t.minRuleThickness)),
      (r.style.borderBottomWidth = Or(r.height)),
      (r.maxFontSize = 1),
      r
    );
  },
  $i = function (e, t, n, r) {
    var i = new Ir(e, t, n, r);
    return (Yi(i), i);
  },
  ea = function (e) {
    var t = new Cr(e);
    return (Yi(t), t);
  },
  ta = function (e, t) {
    return e instanceof Cr ? Xi([], [e], t) : e;
  },
  tee = function (e) {
    if (e.positionType === `individualShift`) {
      for (
        var t = e.children, n = [t[0]], r = -t[0].shift - t[0].elem.depth, i = r, a = 1;
        a < t.length;
        a++
      ) {
        var o = -t[a].shift - i - t[a].elem.depth,
          s = o - (t[a - 1].elem.height + t[a - 1].elem.depth);
        ((i += o),
          n.push({
            type: `kern`,
            size: s,
          }),
          n.push(t[a]));
      }
      return {
        children: n,
        depth: r,
      };
    }
    var c;
    if (e.positionType === `top`) {
      for (var l = e.positionData, u = 0; u < e.children.length; u++) {
        var d = e.children[u];
        l -= d.type === `kern` ? d.size : d.elem.height + d.elem.depth;
      }
      c = l;
    } else if (e.positionType === `bottom`) c = -e.positionData;
    else {
      var f = e.children[0];
      if (f.type !== `elem`) throw Error(`First child must have type "elem".`);
      if (e.positionType === `shift`) c = -f.elem.depth - e.positionData;
      else if (e.positionType === `firstBaseline`) c = -f.elem.depth;
      else throw Error(`Invalid positionType ` + e.positionType + `.`);
    }
    return {
      children: e.children,
      depth: c,
    };
  },
  na = function (e, t) {
    for (var { children: n, depth: r } = tee(e), i = 0, a = 0; a < n.length; a++) {
      var o = n[a];
      if (o.type === `elem`) {
        var s = o.elem;
        i = Math.max(i, s.maxFontSize, s.height);
      }
    }
    i += 2;
    var c = Xi([`pstrut`], []);
    c.style.height = Or(i);
    for (var l = [], u = r, d = r, f = r, p = 0; p < n.length; p++) {
      var m = n[p];
      if (m.type === `kern`) f += m.size;
      else {
        var h = m.elem,
          g = m.wrapperClasses || [],
          v = m.wrapperStyle || {},
          y = Xi(g, [c, h], void 0, v);
        ((y.style.top = Or(-i - f - h.depth)),
          m.marginLeft && (y.style.marginLeft = m.marginLeft),
          m.marginRight && (y.style.marginRight = m.marginRight),
          l.push(y),
          (f += h.height + h.depth));
      }
      ((u = Math.min(u, f)), (d = Math.max(d, f)));
    }
    var b = Xi([`vlist`], l);
    b.style.height = Or(d);
    var x;
    if (u < 0) {
      var S = Xi([`vlist`], [Xi([], [])]);
      ((S.style.height = Or(-u)),
        (x = [Xi([`vlist-r`], [b, Xi([`vlist-s`], [new zr(`​`)])]), Xi([`vlist-r`], [S])]));
    } else x = [Xi([`vlist-r`], [b])];
    var C = Xi([`vlist-t`], x);
    return (x.length === 2 && C.classes.push(`vlist-t2`), (C.height = d), (C.depth = -u), C);
  },
  ra = (e, t) => {
    var n = Xi([`mspace`], [], t),
      r = Dr(e, t);
    return ((n.style.marginRight = Or(r)), n);
  },
  ia = (e, t, n) => {
    var r, i;
    switch (e) {
      case `amsrm`:
        r = `AMS`;
        break;
      case `textrm`:
        r = `Main`;
        break;
      case `textsf`:
        r = `SansSerif`;
        break;
      case `texttt`:
        r = `Typewriter`;
        break;
      default:
        r = e;
    }
    return (
      (i =
        t === `textbf` && n === `textit`
          ? `BoldItalic`
          : t === `textbf`
            ? `Bold`
            : n === `textit`
              ? `Italic`
              : `Regular`),
      r + `-` + i
    );
  },
  aa = {
    mathbf: {
      variant: `bold`,
      fontName: `Main-Bold`,
    },
    mathrm: {
      variant: `normal`,
      fontName: `Main-Regular`,
    },
    textit: {
      variant: `italic`,
      fontName: `Main-Italic`,
    },
    mathit: {
      variant: `italic`,
      fontName: `Main-Italic`,
    },
    mathnormal: {
      variant: `italic`,
      fontName: `Math-Italic`,
    },
    mathsfit: {
      variant: `sans-serif-italic`,
      fontName: `SansSerif-Italic`,
    },
    mathbb: {
      variant: `double-struck`,
      fontName: `AMS-Regular`,
    },
    mathcal: {
      variant: `script`,
      fontName: `Caligraphic-Regular`,
    },
    mathfrak: {
      variant: `fraktur`,
      fontName: `Fraktur-Regular`,
    },
    mathscr: {
      variant: `script`,
      fontName: `Script-Regular`,
    },
    mathsf: {
      variant: `sans-serif`,
      fontName: `SansSerif-Regular`,
    },
    mathtt: {
      variant: `monospace`,
      fontName: `Typewriter-Regular`,
    },
  },
  oa = {
    vec: [`vec`, 0.471, 0.714],
    oiintSize1: [`oiintSize1`, 0.957, 0.499],
    oiintSize2: [`oiintSize2`, 1.472, 0.659],
    oiiintSize1: [`oiiintSize1`, 1.304, 0.499],
    oiiintSize2: [`oiiintSize2`, 1.98, 0.659],
  },
  sa = function (e, t) {
    var [n, r, i] = oa[e],
      a = Zi(
        [`overlay`],
        [
          new Br([new Vr(n)], {
            width: Or(r),
            height: Or(i),
            style: `width:` + Or(r),
            viewBox: `0 0 ` + 1e3 * r + ` ` + 1e3 * i,
            preserveAspectRatio: `xMinYMin`,
          }),
        ],
        t,
      );
    return ((a.height = i), (a.style.height = Or(i)), (a.style.width = Or(r)), a);
  },
  ca = {
    number: 3,
    unit: `mu`,
  },
  la = {
    number: 4,
    unit: `mu`,
  },
  ua = {
    number: 5,
    unit: `mu`,
  },
  nee = {
    mord: {
      mop: ca,
      mbin: la,
      mrel: ua,
      minner: ca,
    },
    mop: {
      mord: ca,
      mop: ca,
      mrel: ua,
      minner: ca,
    },
    mbin: {
      mord: la,
      mop: la,
      mopen: la,
      minner: la,
    },
    mrel: {
      mord: ua,
      mop: ua,
      mopen: ua,
      minner: ua,
    },
    mopen: {},
    mclose: {
      mop: ca,
      mbin: la,
      mrel: ua,
      minner: ca,
    },
    mpunct: {
      mord: ca,
      mop: ca,
      mrel: ua,
      mopen: ca,
      mclose: ca,
      mpunct: ca,
      minner: ca,
    },
    minner: {
      mord: ca,
      mop: ca,
      mbin: la,
      mrel: ua,
      mopen: ca,
      mpunct: ca,
      minner: ca,
    },
  },
  ree = {
    mord: {
      mop: ca,
    },
    mop: {
      mord: ca,
      mop: ca,
    },
    mbin: {},
    mrel: {},
    mopen: {},
    mclose: {
      mop: ca,
    },
    mpunct: {},
    minner: {
      mop: ca,
    },
  },
  da = {},
  fa = {},
  pa = {};
function ma(e) {
  for (var { type: t, names: n, htmlBuilder: r, mathmlBuilder: i } = e, a = 0; a < n.length; ++a)
    da[n[a]] = e;
  t && (r && (fa[t] = r), i && (pa[t] = i));
}
function ha(e) {
  var { type: t, htmlBuilder: n, mathmlBuilder: r } = e;
  (n && (fa[t] = n), r && (pa[t] = r));
}
var ga = function (e) {
    return e.type === `ordgroup` && e.body.length === 1 ? e.body[0] : e;
  },
  _a = function (e) {
    return e.type === `ordgroup` ? e.body : [e];
  },
  va = new Set([`leftmost`, `mbin`, `mopen`, `mrel`, `mop`, `mpunct`]),
  ya = new Set([`rightmost`, `mrel`, `mclose`, `mpunct`]),
  iee = {
    display: ir.DISPLAY,
    text: ir.TEXT,
    script: ir.SCRIPT,
    scriptscript: ir.SCRIPTSCRIPT,
  },
  aee = {
    mord: `mord`,
    mop: `mop`,
    mbin: `mbin`,
    mrel: `mrel`,
    mopen: `mopen`,
    mclose: `mclose`,
    mpunct: `mpunct`,
    minner: `minner`,
  },
  ba = function (e, t, n, r) {
    r === void 0 && (r = [null, null]);
    for (var i = [], a = 0; a < e.length; a++) {
      var o = Ea(e[a], t);
      if (o instanceof Cr) {
        var s = o.children;
        i.push(...s);
      } else i.push(o);
    }
    if ((Ji(i), !n)) return i;
    var c = t;
    if (e.length === 1) {
      var l = e[0];
      l.type === `sizing`
        ? (c = t.havingSize(l.size))
        : l.type === `styling` && (c = t.havingStyle(iee[l.style]));
    }
    var u = Xi([r[0] || `leftmost`], [], t),
      d = Xi([r[1] || `rightmost`], [], t),
      f = n === `root`;
    return (
      xa(
        i,
        (e, t) => {
          var n = t.classes[0],
            r = e.classes[0];
          n === `mbin` && ya.has(r)
            ? (t.classes[0] = `mord`)
            : r === `mbin` && va.has(n) && (e.classes[0] = `mord`);
        },
        {
          node: u,
        },
        d,
        f,
      ),
      xa(
        i,
        (e, t) => {
          var n = wa(t),
            r = wa(e),
            i = n && r ? (e.hasClass(`mtight`) ? ree[n]?.[r] : nee[n]?.[r]) : null;
          if (i) return ra(i, c);
        },
        {
          node: u,
        },
        d,
        f,
      ),
      i
    );
  },
  xa = function (e, t, n, r, i) {
    r && e.push(r);
    for (var a = 0; a < e.length; a++) {
      var o = e[a],
        s = Sa(o);
      if (s) {
        xa(s.children, t, n, null, i);
        continue;
      }
      var c = !o.hasClass(`mspace`);
      if (c) {
        var l = t(o, n.node);
        l && (n.insertAfter ? n.insertAfter(l) : (e.unshift(l), a++));
      }
      (c ? (n.node = o) : i && o.hasClass(`newline`) && (n.node = Xi([`leftmost`])),
        (n.insertAfter = ((t) => (n) => {
          (e.splice(t + 1, 0, n), a++);
        })(a)));
    }
    r && e.pop();
  },
  Sa = function (e) {
    return e instanceof Cr || e instanceof Ir || (e instanceof Fr && e.hasClass(`enclosing`))
      ? e
      : null;
  },
  Ca = function (e, t) {
    var n = Sa(e);
    if (n) {
      var r = n.children;
      if (r.length) {
        if (t === `right`) return Ca(r[r.length - 1], `right`);
        if (t === `left`) return Ca(r[0], `left`);
      }
    }
    return e;
  },
  wa = function (e, t) {
    return e ? (t && (e = Ca(e, t)), aee[e.classes[0]] || null) : null;
  },
  Ta = function (e, t) {
    var n = [`nulldelimiter`].concat(e.baseSizingClasses());
    return Xi(t.concat(n));
  },
  Ea = function (e, t, n) {
    if (!e) return Xi();
    if (fa[e.type]) {
      var r = fa[e.type](e, t);
      if (n && t.size !== n.size) {
        r = Xi(t.sizingClasses(n), [r], t);
        var i = t.sizeMultiplier / n.sizeMultiplier;
        ((r.height *= i), (r.depth *= i));
      }
      return r;
    } else throw new Dn(`Got group of unknown type: '` + e.type + `'`);
  };
function Da(e, t) {
  var n = Xi([`base`], e, t),
    r = Xi([`strut`]);
  return (
    (r.style.height = Or(n.height + n.depth)),
    n.depth && (r.style.verticalAlign = Or(-n.depth)),
    n.children.unshift(r),
    n
  );
}
function Oa(e, t) {
  var n = null;
  e.length === 1 && e[0].type === `tag` && ((n = e[0].tag), (e = e[0].body));
  var r = ba(e, t, `root`),
    i;
  r.length === 2 && r[1].hasClass(`tag`) && (i = r.pop());
  for (var a = [], o = [], s = 0; s < r.length; s++)
    if (
      (o.push(r[s]), r[s].hasClass(`mbin`) || r[s].hasClass(`mrel`) || r[s].hasClass(`allowbreak`))
    ) {
      for (
        var c = !1;
        s < r.length - 1 && r[s + 1].hasClass(`mspace`) && !r[s + 1].hasClass(`newline`);
      )
        (s++, o.push(r[s]), r[s].hasClass(`nobreak`) && (c = !0));
      c || (a.push(Da(o, t)), (o = []));
    } else
      r[s].hasClass(`newline`) &&
        (o.pop(), o.length > 0 && (a.push(Da(o, t)), (o = [])), a.push(r[s]));
  o.length > 0 && a.push(Da(o, t));
  var l;
  n ? ((l = Da(ba(n, t, !0), t)), (l.classes = [`tag`]), a.push(l)) : i && a.push(i);
  var u = Xi([`katex-html`], a);
  if ((u.setAttribute(`aria-hidden`, `true`), l)) {
    var d = l.children[0];
    ((d.style.height = Or(u.height + u.depth)), u.depth && (d.style.verticalAlign = Or(-u.depth)));
  }
  return u;
}
function ka(e) {
  return new Cr(e);
}
var Aa = class {
    constructor(e, t, n) {
      ((this.type = void 0),
        (this.attributes = void 0),
        (this.children = void 0),
        (this.classes = void 0),
        (this.type = e),
        (this.attributes = {}),
        (this.children = t || []),
        (this.classes = n || []));
    }
    setAttribute(e, t) {
      this.attributes[e] = t;
    }
    getAttribute(e) {
      return this.attributes[e];
    }
    toNode() {
      var e = document.createElementNS(`http://www.w3.org/1998/Math/MathML`, this.type);
      for (var t in this.attributes)
        Object.prototype.hasOwnProperty.call(this.attributes, t) &&
          e.setAttribute(t, this.attributes[t]);
      this.classes.length > 0 && (e.className = kr(this.classes));
      for (var n = 0; n < this.children.length; n++)
        if (this.children[n] instanceof ja && this.children[n + 1] instanceof ja) {
          for (
            var r = this.children[n].toText() + this.children[++n].toText();
            this.children[n + 1] instanceof ja;
          )
            r += this.children[++n].toText();
          e.appendChild(new ja(r).toNode());
        } else e.appendChild(this.children[n].toNode());
      return e;
    }
    toMarkup() {
      var e = `<` + this.type;
      for (var t in this.attributes)
        Object.prototype.hasOwnProperty.call(this.attributes, t) &&
          ((e += ` ` + t + `="`), (e += Mn(this.attributes[t])), (e += `"`));
      (this.classes.length > 0 && (e += ` class ="` + Mn(kr(this.classes)) + `"`), (e += `>`));
      for (var n = 0; n < this.children.length; n++) e += this.children[n].toMarkup();
      return ((e += `</` + this.type + `>`), e);
    }
    toText() {
      return this.children.map((e) => e.toText()).join(``);
    }
  },
  ja = class {
    constructor(e) {
      ((this.text = void 0), (this.text = e));
    }
    toNode() {
      return document.createTextNode(this.text);
    }
    toMarkup() {
      return Mn(this.toText());
    }
    toText() {
      return this.text;
    }
  },
  Ma = class {
    constructor(e) {
      ((this.width = void 0),
        (this.character = void 0),
        (this.width = e),
        e >= 0.05555 && e <= 0.05556
          ? (this.character = ` `)
          : e >= 0.1666 && e <= 0.1667
            ? (this.character = ` `)
            : e >= 0.2222 && e <= 0.2223
              ? (this.character = ` `)
              : e >= 0.2777 && e <= 0.2778
                ? (this.character = `  `)
                : e >= -0.05556 && e <= -0.05555
                  ? (this.character = ` ⁣`)
                  : e >= -0.1667 && e <= -0.1666
                    ? (this.character = ` ⁣`)
                    : e >= -0.2223 && e <= -0.2222
                      ? (this.character = ` ⁣`)
                      : e >= -0.2778 && e <= -0.2777
                        ? (this.character = ` ⁣`)
                        : (this.character = null));
    }
    toNode() {
      if (this.character) return document.createTextNode(this.character);
      var e = document.createElementNS(`http://www.w3.org/1998/Math/MathML`, `mspace`);
      return (e.setAttribute(`width`, Or(this.width)), e);
    }
    toMarkup() {
      return this.character
        ? `<mtext>` + this.character + `</mtext>`
        : `<mspace width="` + Or(this.width) + `"/>`;
    }
    toText() {
      return this.character ? this.character : ` `;
    }
  },
  oee = new Set([`\\imath`, `\\jmath`]),
  see = new Set([`mrow`, `mtable`]),
  Na = function (e, t, n) {
    return (
      $r[t][e] &&
        $r[t][e].replace &&
        e.charCodeAt(0) !== 55349 &&
        !(
          ui.hasOwnProperty(e) &&
          n &&
          ((n.fontFamily && n.fontFamily.slice(4, 6) === `tt`) ||
            (n.font && n.font.slice(4, 6) === `tt`))
        ) &&
        (e = $r[t][e].replace),
      new ja(e)
    );
  },
  Pa = function (e) {
    return e.length === 1 ? e[0] : new Aa(`mrow`, e);
  },
  cee = {
    mathit: `italic`,
    boldsymbol: (e) => (e.type === `textord` ? `bold` : `bold-italic`),
    mathbf: `bold`,
    mathbb: `double-struck`,
    mathsfit: `sans-serif-italic`,
    mathfrak: `fraktur`,
    mathscr: `script`,
    mathcal: `script`,
    mathsf: `sans-serif`,
    mathtt: `monospace`,
  },
  Fa = (e, t) => {
    if (e.mode === `text`) {
      if (t.fontFamily === `texttt`) return `monospace`;
      if (t.fontFamily === `textsf`)
        return t.fontShape === `textit` && t.fontWeight === `textbf`
          ? `sans-serif-bold-italic`
          : t.fontShape === `textit`
            ? `sans-serif-italic`
            : t.fontWeight === `textbf`
              ? `bold-sans-serif`
              : `sans-serif`;
      if (t.fontShape === `textit` && t.fontWeight === `textbf`) return `bold-italic`;
      if (t.fontShape === `textit`) return `italic`;
      if (t.fontWeight === `textbf`) return `bold`;
    }
    var n = t.font;
    if (!n || n === `mathnormal`) return null;
    var r = e.mode,
      i = cee[n];
    if (i) return typeof i == `function` ? i(e) : i;
    var a = e.text;
    if (oee.has(a)) return null;
    if ($r[r][a]) {
      var o = $r[r][a].replace;
      o && (a = o);
    }
    var s = aa[n].fontName;
    return Xr(a, s, r) ? aa[n].variant : null;
  };
function Ia(e) {
  if (!e) return !1;
  if (e.type === `mi` && e.children.length === 1) {
    var t = e.children[0];
    return t instanceof ja && t.text === `.`;
  } else if (
    e.type === `mo` &&
    e.children.length === 1 &&
    e.getAttribute(`separator`) === `true` &&
    e.getAttribute(`lspace`) === `0em` &&
    e.getAttribute(`rspace`) === `0em`
  ) {
    var n = e.children[0];
    return n instanceof ja && n.text === `,`;
  } else return !1;
}
var La = function (e, t, n) {
    if (e.length === 1) {
      var r = za(e[0], t);
      return (
        n &&
          r instanceof Aa &&
          r.type === `mo` &&
          (r.setAttribute(`lspace`, `0em`), r.setAttribute(`rspace`, `0em`)),
        [r]
      );
    }
    for (var i = [], a, o = 0; o < e.length; o++) {
      var s = za(e[o], t);
      if (s instanceof Aa && a instanceof Aa) {
        if (
          s.type === `mtext` &&
          a.type === `mtext` &&
          s.getAttribute(`mathvariant`) === a.getAttribute(`mathvariant`)
        ) {
          a.children.push(...s.children);
          continue;
        } else if (s.type === `mn` && a.type === `mn`) {
          a.children.push(...s.children);
          continue;
        } else if (Ia(s) && a.type === `mn`) {
          a.children.push(...s.children);
          continue;
        } else if (s.type === `mn` && Ia(a))
          ((s.children = [...a.children, ...s.children]), i.pop());
        else if (
          (s.type === `msup` || s.type === `msub`) &&
          s.children.length >= 1 &&
          (a.type === `mn` || Ia(a))
        ) {
          var c = s.children[0];
          c instanceof Aa &&
            c.type === `mn` &&
            ((c.children = [...a.children, ...c.children]), i.pop());
        } else if (a.type === `mi` && a.children.length === 1) {
          var l = a.children[0];
          if (
            l instanceof ja &&
            l.text === `̸` &&
            (s.type === `mo` || s.type === `mi` || s.type === `mn`)
          ) {
            var u = s.children[0];
            u instanceof ja &&
              u.text.length > 0 &&
              ((u.text = u.text.slice(0, 1) + `̸` + u.text.slice(1)), i.pop());
          }
        }
      }
      (i.push(s), (a = s));
    }
    return i;
  },
  Ra = function (e, t, n) {
    return Pa(La(e, t, n));
  },
  za = function (e, t) {
    if (!e) return new Aa(`mrow`);
    if (pa[e.type]) return pa[e.type](e, t);
    throw new Dn(`Got group of unknown type: '` + e.type + `'`);
  };
function Ba(e, t, n, r, i) {
  var a = La(e, n),
    o = a.length === 1 && a[0] instanceof Aa && see.has(a[0].type) ? a[0] : new Aa(`mrow`, a),
    s = new Aa(`annotation`, [new ja(t)]);
  s.setAttribute(`encoding`, `application/x-tex`);
  var c = new Aa(`math`, [new Aa(`semantics`, [o, s])]);
  return (
    c.setAttribute(`xmlns`, `http://www.w3.org/1998/Math/MathML`),
    r && c.setAttribute(`display`, `block`),
    Xi([i ? `katex` : `katex-mathml`], [c])
  );
}
var Va = [
    [1, 1, 1],
    [2, 1, 1],
    [3, 1, 1],
    [4, 2, 1],
    [5, 2, 1],
    [6, 3, 1],
    [7, 4, 2],
    [8, 6, 3],
    [9, 7, 6],
    [10, 8, 7],
    [11, 10, 9],
  ],
  Ha = [0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.2, 1.44, 1.728, 2.074, 2.488],
  Ua = function (e, t) {
    return t.size < 2 ? e : Va[e - 1][t.size - 1];
  },
  Wa = class e {
    constructor(t) {
      ((this.style = void 0),
        (this.color = void 0),
        (this.size = void 0),
        (this.textSize = void 0),
        (this.phantom = void 0),
        (this.font = void 0),
        (this.fontFamily = void 0),
        (this.fontWeight = void 0),
        (this.fontShape = void 0),
        (this.sizeMultiplier = void 0),
        (this.maxSize = void 0),
        (this.minRuleThickness = void 0),
        (this._fontMetrics = void 0),
        (this.style = t.style),
        (this.color = t.color),
        (this.size = t.size || e.BASESIZE),
        (this.textSize = t.textSize || this.size),
        (this.phantom = !!t.phantom),
        (this.font = t.font || ``),
        (this.fontFamily = t.fontFamily || ``),
        (this.fontWeight = t.fontWeight || ``),
        (this.fontShape = t.fontShape || ``),
        (this.sizeMultiplier = Ha[this.size - 1]),
        (this.maxSize = t.maxSize),
        (this.minRuleThickness = t.minRuleThickness),
        (this._fontMetrics = void 0));
    }
    extend(t) {
      var n = {
        style: this.style,
        size: this.size,
        textSize: this.textSize,
        color: this.color,
        phantom: this.phantom,
        font: this.font,
        fontFamily: this.fontFamily,
        fontWeight: this.fontWeight,
        fontShape: this.fontShape,
        maxSize: this.maxSize,
        minRuleThickness: this.minRuleThickness,
      };
      return (Object.assign(n, t), new e(n));
    }
    havingStyle(e) {
      return this.style === e
        ? this
        : this.extend({
            style: e,
            size: Ua(this.textSize, e),
          });
    }
    havingCrampedStyle() {
      return this.havingStyle(this.style.cramp());
    }
    havingSize(e) {
      return this.size === e && this.textSize === e
        ? this
        : this.extend({
            style: this.style.text(),
            size: e,
            textSize: e,
            sizeMultiplier: Ha[e - 1],
          });
    }
    havingBaseStyle(t) {
      t ||= this.style.text();
      var n = Ua(e.BASESIZE, t);
      return this.size === n && this.textSize === e.BASESIZE && this.style === t
        ? this
        : this.extend({
            style: t,
            size: n,
          });
    }
    havingBaseSizing() {
      var e;
      switch (this.style.id) {
        case 4:
        case 5:
          e = 3;
          break;
        case 6:
        case 7:
          e = 1;
          break;
        default:
          e = 6;
      }
      return this.extend({
        style: this.style.text(),
        size: e,
      });
    }
    withColor(e) {
      return this.extend({
        color: e,
      });
    }
    withPhantom() {
      return this.extend({
        phantom: !0,
      });
    }
    withFont(e) {
      return this.extend({
        font: e,
      });
    }
    withTextFontFamily(e) {
      return this.extend({
        fontFamily: e,
        font: ``,
      });
    }
    withTextFontWeight(e) {
      return this.extend({
        fontWeight: e,
        font: ``,
      });
    }
    withTextFontShape(e) {
      return this.extend({
        fontShape: e,
        font: ``,
      });
    }
    sizingClasses(e) {
      return e.size === this.size ? [] : [`sizing`, `reset-size` + e.size, `size` + this.size];
    }
    baseSizingClasses() {
      return this.size === e.BASESIZE
        ? []
        : [`sizing`, `reset-size` + this.size, `size` + e.BASESIZE];
    }
    fontMetrics() {
      return ((this._fontMetrics ||= Qr(this.size)), this._fontMetrics);
    }
    getColor() {
      return this.phantom ? `transparent` : this.color;
    }
  };
Wa.BASESIZE = 6;
var Ga = function (e) {
    return new Wa({
      style: e.displayMode ? ir.DISPLAY : ir.TEXT,
      maxSize: e.maxSize,
      minRuleThickness: e.minRuleThickness,
    });
  },
  Ka = function (e, t) {
    if (t.displayMode) {
      var n = [`katex-display`];
      (t.leqno && n.push(`leqno`), t.fleqn && n.push(`fleqn`), (e = Xi(n, [e])));
    }
    return e;
  },
  qa = function (e, t, n) {
    var r = Ga(n),
      i;
    return n.output === `mathml`
      ? Ba(e, t, r, n.displayMode, !0)
      : ((i =
          n.output === `html`
            ? Xi([`katex`], [Oa(e, r)])
            : Xi([`katex`], [Ba(e, t, r, n.displayMode, !1), Oa(e, r)])),
        Ka(i, n));
  },
  Ja = function (e, t, n) {
    return Ka(Xi([`katex`], [Oa(e, Ga(n))]), n);
  },
  Ya = {
    widehat: `^`,
    widecheck: `ˇ`,
    widetilde: `~`,
    utilde: `~`,
    overleftarrow: `←`,
    underleftarrow: `←`,
    xleftarrow: `←`,
    overrightarrow: `→`,
    underrightarrow: `→`,
    xrightarrow: `→`,
    underbrace: `⏟`,
    overbrace: `⏞`,
    underbracket: `⎵`,
    overbracket: `⎴`,
    overgroup: `⏠`,
    undergroup: `⏡`,
    overleftrightarrow: `↔`,
    underleftrightarrow: `↔`,
    xleftrightarrow: `↔`,
    Overrightarrow: `⇒`,
    xRightarrow: `⇒`,
    overleftharpoon: `↼`,
    xleftharpoonup: `↼`,
    overrightharpoon: `⇀`,
    xrightharpoonup: `⇀`,
    xLeftarrow: `⇐`,
    xLeftrightarrow: `⇔`,
    xhookleftarrow: `↩`,
    xhookrightarrow: `↪`,
    xmapsto: `↦`,
    xrightharpoondown: `⇁`,
    xleftharpoondown: `↽`,
    xrightleftharpoons: `⇌`,
    xleftrightharpoons: `⇋`,
    xtwoheadleftarrow: `↞`,
    xtwoheadrightarrow: `↠`,
    xlongequal: `=`,
    xtofrom: `⇄`,
    xrightleftarrows: `⇄`,
    xrightequilibrium: `⇌`,
    xleftequilibrium: `⇋`,
    "\\cdrightarrow": `→`,
    "\\cdleftarrow": `←`,
    "\\cdlongequal": `=`,
  },
  Xa = function (e) {
    var t = new Aa(`mo`, [new ja(Ya[e.replace(/^\\/, ``)])]);
    return (t.setAttribute(`stretchy`, `true`), t);
  },
  Za = {
    overrightarrow: [[`rightarrow`], 0.888, 522, `xMaxYMin`],
    overleftarrow: [[`leftarrow`], 0.888, 522, `xMinYMin`],
    underrightarrow: [[`rightarrow`], 0.888, 522, `xMaxYMin`],
    underleftarrow: [[`leftarrow`], 0.888, 522, `xMinYMin`],
    xrightarrow: [[`rightarrow`], 1.469, 522, `xMaxYMin`],
    "\\cdrightarrow": [[`rightarrow`], 3, 522, `xMaxYMin`],
    xleftarrow: [[`leftarrow`], 1.469, 522, `xMinYMin`],
    "\\cdleftarrow": [[`leftarrow`], 3, 522, `xMinYMin`],
    Overrightarrow: [[`doublerightarrow`], 0.888, 560, `xMaxYMin`],
    xRightarrow: [[`doublerightarrow`], 1.526, 560, `xMaxYMin`],
    xLeftarrow: [[`doubleleftarrow`], 1.526, 560, `xMinYMin`],
    overleftharpoon: [[`leftharpoon`], 0.888, 522, `xMinYMin`],
    xleftharpoonup: [[`leftharpoon`], 0.888, 522, `xMinYMin`],
    xleftharpoondown: [[`leftharpoondown`], 0.888, 522, `xMinYMin`],
    overrightharpoon: [[`rightharpoon`], 0.888, 522, `xMaxYMin`],
    xrightharpoonup: [[`rightharpoon`], 0.888, 522, `xMaxYMin`],
    xrightharpoondown: [[`rightharpoondown`], 0.888, 522, `xMaxYMin`],
    xlongequal: [[`longequal`], 0.888, 334, `xMinYMin`],
    "\\cdlongequal": [[`longequal`], 3, 334, `xMinYMin`],
    xtwoheadleftarrow: [[`twoheadleftarrow`], 0.888, 334, `xMinYMin`],
    xtwoheadrightarrow: [[`twoheadrightarrow`], 0.888, 334, `xMaxYMin`],
    overleftrightarrow: [[`leftarrow`, `rightarrow`], 0.888, 522],
    overbrace: [[`leftbrace`, `midbrace`, `rightbrace`], 1.6, 548],
    underbrace: [[`leftbraceunder`, `midbraceunder`, `rightbraceunder`], 1.6, 548],
    underleftrightarrow: [[`leftarrow`, `rightarrow`], 0.888, 522],
    xleftrightarrow: [[`leftarrow`, `rightarrow`], 1.75, 522],
    xLeftrightarrow: [[`doubleleftarrow`, `doublerightarrow`], 1.75, 560],
    xrightleftharpoons: [[`leftharpoondownplus`, `rightharpoonplus`], 1.75, 716],
    xleftrightharpoons: [[`leftharpoonplus`, `rightharpoondownplus`], 1.75, 716],
    xhookleftarrow: [[`leftarrow`, `righthook`], 1.08, 522],
    xhookrightarrow: [[`lefthook`, `rightarrow`], 1.08, 522],
    overlinesegment: [[`leftlinesegment`, `rightlinesegment`], 0.888, 522],
    underlinesegment: [[`leftlinesegment`, `rightlinesegment`], 0.888, 522],
    overbracket: [[`leftbracketover`, `rightbracketover`], 1.6, 440],
    underbracket: [[`leftbracketunder`, `rightbracketunder`], 1.6, 410],
    overgroup: [[`leftgroup`, `rightgroup`], 0.888, 342],
    undergroup: [[`leftgroupunder`, `rightgroupunder`], 0.888, 342],
    xmapsto: [[`leftmapsto`, `rightarrow`], 1.5, 522],
    xtofrom: [[`leftToFrom`, `rightToFrom`], 1.75, 528],
    xrightleftarrows: [[`baraboveleftarrow`, `rightarrowabovebar`], 1.75, 901],
    xrightequilibrium: [[`baraboveshortleftharpoon`, `rightharpoonaboveshortbar`], 1.75, 716],
    xleftequilibrium: [[`shortbaraboveleftharpoon`, `shortrightharpoonabovebar`], 1.75, 716],
  },
  Qa = new Set([`widehat`, `widecheck`, `widetilde`, `utilde`]),
  $a = function (e, t) {
    function n() {
      var n = 4e5,
        r = e.label.slice(1);
      if (Qa.has(r) && `base` in e) {
        var i = e.base.type === `ordgroup` ? e.base.body.length : 1,
          a,
          o,
          s;
        if (i > 5)
          r === `widehat` || r === `widecheck`
            ? ((a = 420), (n = 2364), (s = 0.42), (o = r + `4`))
            : ((a = 312), (n = 2340), (s = 0.34), (o = `tilde4`));
        else {
          var c = [1, 1, 2, 2, 3, 3][i];
          r === `widehat` || r === `widecheck`
            ? ((n = [0, 1062, 2364, 2364, 2364][c]),
              (a = [0, 239, 300, 360, 420][c]),
              (s = [0, 0.24, 0.3, 0.3, 0.36, 0.42][c]),
              (o = r + c))
            : ((n = [0, 600, 1033, 2339, 2340][c]),
              (a = [0, 260, 286, 306, 312][c]),
              (s = [0, 0.26, 0.286, 0.3, 0.306, 0.34][c]),
              (o = `tilde` + c));
        }
        return {
          span: Zi(
            [],
            [
              new Br([new Vr(o)], {
                width: `100%`,
                height: Or(s),
                viewBox: `0 0 ` + n + ` ` + a,
                preserveAspectRatio: `none`,
              }),
            ],
            t,
          ),
          minWidth: 0,
          height: s,
        };
      } else {
        var l = [],
          u = Za[r];
        if (!u) throw Error(`No SVG data for "` + r + `".`);
        var [d, f, p] = u,
          m = p / 1e3,
          h = d.length,
          g,
          v;
        if (h === 1) {
          if (u.length !== 4) throw Error(`Expected 4-tuple for single-path SVG data "` + r + `".`);
          ((g = [`hide-tail`]), (v = [u[3]]));
        } else if (h === 2)
          ((g = [`halfarrow-left`, `halfarrow-right`]), (v = [`xMinYMin`, `xMaxYMin`]));
        else if (h === 3)
          ((g = [`brace-left`, `brace-center`, `brace-right`]),
            (v = [`xMinYMin`, `xMidYMin`, `xMaxYMin`]));
        else
          throw Error(
            `Correct katexImagesData or update code here to support
                    ` +
              h +
              ` children.`,
          );
        for (var y = 0; y < h; y++) {
          var b = new Br([new Vr(d[y])], {
              width: `400em`,
              height: Or(m),
              viewBox: `0 0 ` + n + ` ` + p,
              preserveAspectRatio: v[y] + ` slice`,
            }),
            x = Zi([g[y]], [b], t);
          if (h === 1)
            return {
              span: x,
              minWidth: f,
              height: m,
            };
          ((x.style.height = Or(m)), l.push(x));
        }
        return {
          span: Xi([`stretchy`], l, t),
          minWidth: f,
          height: m,
        };
      }
    }
    var { span: r, minWidth: i, height: a } = n();
    return ((r.height = a), (r.style.height = Or(a)), i > 0 && (r.style.minWidth = Or(i)), r);
  },
  eo = function (e, t, n, r, i) {
    var a,
      o = e.height + e.depth + n + r;
    if (/fbox|color|angl/.test(t)) {
      if (((a = Xi([`stretchy`, t], [], i)), t === `fbox`)) {
        var s = i.color && i.getColor();
        s && (a.style.borderColor = s);
      }
    } else {
      var c = [];
      (/^[bx]cancel$/.test(t) &&
        c.push(
          new Hr({
            x1: `0`,
            y1: `0`,
            x2: `100%`,
            y2: `100%`,
            "stroke-width": `0.046em`,
          }),
        ),
        /^x?cancel$/.test(t) &&
          c.push(
            new Hr({
              x1: `0`,
              y1: `100%`,
              x2: `100%`,
              y2: `0`,
              "stroke-width": `0.046em`,
            }),
          ),
        (a = Zi(
          [],
          [
            new Br(c, {
              width: `100%`,
              height: Or(o),
            }),
          ],
          i,
        )));
    }
    return ((a.height = o), (a.style.height = Or(o)), a);
  },
  to = {
    bin: 1,
    close: 1,
    inner: 1,
    open: 1,
    punct: 1,
    rel: 1,
  },
  no = {
    "accent-token": 1,
    mathord: 1,
    "op-token": 1,
    spacing: 1,
    textord: 1,
  };
function ro(e) {
  return e in to;
}
function io(e, t) {
  if (!e || e.type !== t)
    throw Error(
      `Expected node of type ` + t + `, but got ` + (e ? `node of type ` + e.type : String(e)),
    );
  return e;
}
function ao(e) {
  var t = oo(e);
  if (!t)
    throw Error(
      `Expected node of symbol group type, but got ` + (e ? `node of type ` + e.type : String(e)),
    );
  return t;
}
function oo(e) {
  return e && (e.type === `atom` || no.hasOwnProperty(e.type)) ? e : null;
}
var so = (e) => {
    if (e instanceof zr) return e;
    if (Gr(e) && e.children.length === 1) return so(e.children[0]);
  },
  co = (e, t) => {
    var n, r, i;
    e && e.type === `supsub`
      ? ((r = io(e.base, `accent`)), (n = r.base), (e.base = n), (i = Wr(Ea(e, t))), (e.base = r))
      : ((r = io(e, `accent`)), (n = r.base));
    var a = Ea(n, t.havingCrampedStyle()),
      o = r.isShifty && Fn(n),
      s = 0;
    o && (s = so(a)?.skew ?? 0);
    var c = r.label === `\\c`,
      l = c ? a.height + a.depth : Math.min(a.height, t.fontMetrics().xHeight),
      u;
    if (r.isStretchy)
      ((u = $a(r, t)),
        (u = na({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: a,
            },
            {
              type: `elem`,
              elem: u,
              wrapperClasses: [`svg-align`],
              wrapperStyle:
                s > 0
                  ? {
                      width: `calc(100% - ` + Or(2 * s) + `)`,
                      marginLeft: Or(2 * s),
                    }
                  : void 0,
            },
          ],
        })));
    else {
      var d, f;
      (r.label === `\\vec`
        ? ((d = sa(`vec`, t)), (f = oa.vec[1]))
        : ((d = qi(
            {
              type: `textord`,
              mode: r.mode,
              text: r.label,
            },
            t,
          )),
          (d = Ur(d)),
          (d.italic = 0),
          (f = d.width),
          c && (l += d.depth)),
        (u = Xi([`accent-body`], [d])));
      var p = r.label === `\\textcircled`;
      p && (u.classes.push(`accent-full`), (l = a.height));
      var m = s;
      (p || (m -= f / 2),
        (u.style.left = Or(m)),
        r.label === `\\textcircled` && (u.style.top = `.2em`),
        (u = na({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: a,
            },
            {
              type: `kern`,
              size: -l,
            },
            {
              type: `elem`,
              elem: u,
            },
          ],
        })));
    }
    var h = Xi([`mord`, `accent`], [u], t);
    return i
      ? ((i.children[0] = h), (i.height = Math.max(h.height, i.height)), (i.classes[0] = `mord`), i)
      : h;
  },
  lee = (e, t) => {
    var n = e.isStretchy ? Xa(e.label) : new Aa(`mo`, [Na(e.label, e.mode)]),
      r = new Aa(`mover`, [za(e.base, t), n]);
    return (r.setAttribute(`accent`, `true`), r);
  },
  uee = new RegExp(
    [
      `\\acute`,
      `\\grave`,
      `\\ddot`,
      `\\tilde`,
      `\\bar`,
      `\\breve`,
      `\\check`,
      `\\hat`,
      `\\vec`,
      `\\dot`,
      `\\mathring`,
    ]
      .map((e) => `\\` + e)
      .join(`|`),
  );
(ma({
  type: `accent`,
  names: [
    `\\acute`,
    `\\grave`,
    `\\ddot`,
    `\\tilde`,
    `\\bar`,
    `\\breve`,
    `\\check`,
    `\\hat`,
    `\\vec`,
    `\\dot`,
    `\\mathring`,
    `\\widecheck`,
    `\\widehat`,
    `\\widetilde`,
    `\\overrightarrow`,
    `\\overleftarrow`,
    `\\Overrightarrow`,
    `\\overleftrightarrow`,
    `\\overgroup`,
    `\\overlinesegment`,
    `\\overleftharpoon`,
    `\\overrightharpoon`,
  ],
  numArgs: 1,
  handler: (e, t) => {
    var n = ga(t[0]),
      r = !uee.test(e.funcName),
      i =
        !r ||
        e.funcName === `\\widehat` ||
        e.funcName === `\\widetilde` ||
        e.funcName === `\\widecheck`;
    return {
      type: `accent`,
      mode: e.parser.mode,
      label: e.funcName,
      isStretchy: r,
      isShifty: i,
      base: n,
    };
  },
  htmlBuilder: co,
  mathmlBuilder: lee,
}),
  ma({
    type: `accent`,
    names: [
      `\\'`,
      "\\`",
      `\\^`,
      `\\~`,
      `\\=`,
      `\\u`,
      `\\.`,
      `\\"`,
      `\\c`,
      `\\r`,
      `\\H`,
      `\\v`,
      `\\textcircled`,
    ],
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: [`primitive`],
    handler: (e, t) => {
      var n = t[0],
        r = e.parser.mode;
      return (
        r === `math` &&
          (e.parser.settings.reportNonstrict(
            `mathVsTextAccents`,
            `LaTeX's accent ` + e.funcName + ` works only in text mode`,
          ),
          (r = `text`)),
        {
          type: `accent`,
          mode: r,
          label: e.funcName,
          isStretchy: !1,
          isShifty: !0,
          base: n,
        }
      );
    },
  }),
  ma({
    type: `accentUnder`,
    names: [
      `\\underleftarrow`,
      `\\underrightarrow`,
      `\\underleftrightarrow`,
      `\\undergroup`,
      `\\underlinesegment`,
      `\\utilde`,
    ],
    numArgs: 1,
    handler: (e, t) => {
      var { parser: n, funcName: r } = e,
        i = t[0];
      return {
        type: `accentUnder`,
        mode: n.mode,
        label: r,
        base: i,
      };
    },
    htmlBuilder: (e, t) => {
      var n = Ea(e.base, t),
        r = $a(e, t),
        i = e.label === `\\utilde` ? 0.12 : 0;
      return Xi(
        [`mord`, `accentunder`],
        [
          na({
            positionType: `top`,
            positionData: n.height,
            children: [
              {
                type: `elem`,
                elem: r,
                wrapperClasses: [`svg-align`],
              },
              {
                type: `kern`,
                size: i,
              },
              {
                type: `elem`,
                elem: n,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder: (e, t) => {
      var n = Xa(e.label),
        r = new Aa(`munder`, [za(e.base, t), n]);
      return (r.setAttribute(`accentunder`, `true`), r);
    },
  }));
var lo = (e) => {
  var t = new Aa(`mpadded`, e ? [e] : []);
  return (t.setAttribute(`width`, `+0.6em`), t.setAttribute(`lspace`, `0.3em`), t);
};
ma({
  type: `xArrow`,
  names: [
    `\\xleftarrow`,
    `\\xrightarrow`,
    `\\xLeftarrow`,
    `\\xRightarrow`,
    `\\xleftrightarrow`,
    `\\xLeftrightarrow`,
    `\\xhookleftarrow`,
    `\\xhookrightarrow`,
    `\\xmapsto`,
    `\\xrightharpoondown`,
    `\\xrightharpoonup`,
    `\\xleftharpoondown`,
    `\\xleftharpoonup`,
    `\\xrightleftharpoons`,
    `\\xleftrightharpoons`,
    `\\xlongequal`,
    `\\xtwoheadrightarrow`,
    `\\xtwoheadleftarrow`,
    `\\xtofrom`,
    `\\xrightleftarrows`,
    `\\xrightequilibrium`,
    `\\xleftequilibrium`,
    `\\\\cdrightarrow`,
    `\\\\cdleftarrow`,
    `\\\\cdlongequal`,
  ],
  numArgs: 1,
  numOptionalArgs: 1,
  handler(e, t, n) {
    var { parser: r, funcName: i } = e;
    return {
      type: `xArrow`,
      mode: r.mode,
      label: i,
      body: t[0],
      below: n[0],
    };
  },
  htmlBuilder(e, t) {
    var n = t.style,
      r = t.havingStyle(n.sup()),
      i = ta(Ea(e.body, r, t), t),
      a = e.label.slice(0, 2) === `\\x` ? `x` : `cd`;
    i.classes.push(a + `-arrow-pad`);
    var o;
    e.below &&
      ((r = t.havingStyle(n.sub())),
      (o = ta(Ea(e.below, r, t), t)),
      o.classes.push(a + `-arrow-pad`));
    var s = $a(e, t),
      c = -t.fontMetrics().axisHeight + 0.5 * s.height,
      l = -t.fontMetrics().axisHeight - 0.5 * s.height - 0.111;
    (i.depth > 0.25 || e.label === `\\xleftequilibrium`) && (l -= i.depth);
    var u;
    if (o) {
      var d = -t.fontMetrics().axisHeight + o.height + 0.5 * s.height + 0.111;
      u = na({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: i,
            shift: l,
          },
          {
            type: `elem`,
            elem: s,
            shift: c,
            wrapperClasses: [`svg-align`],
          },
          {
            type: `elem`,
            elem: o,
            shift: d,
          },
        ],
      });
    } else
      u = na({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: i,
            shift: l,
          },
          {
            type: `elem`,
            elem: s,
            shift: c,
            wrapperClasses: [`svg-align`],
          },
        ],
      });
    return Xi([`mrel`, `x-arrow`], [u], t);
  },
  mathmlBuilder(e, t) {
    var n = Xa(e.label);
    n.setAttribute(`minsize`, e.label.charAt(0) === `x` ? `1.75em` : `3.0em`);
    var r;
    if (e.body) {
      var i = lo(za(e.body, t));
      r = e.below ? new Aa(`munderover`, [n, lo(za(e.below, t)), i]) : new Aa(`mover`, [n, i]);
    } else
      e.below
        ? (r = new Aa(`munder`, [n, lo(za(e.below, t))]))
        : ((r = lo()), (r = new Aa(`mover`, [n, r])));
    return r;
  },
});
function dee(e, t) {
  var n = ba(e.body, t, !0);
  return Xi([e.mclass], n, t);
}
function fee(e, t) {
  var n,
    r = La(e.body, t);
  return (
    e.mclass === `minner`
      ? (n = new Aa(`mpadded`, r))
      : e.mclass === `mord`
        ? e.isCharacterBox
          ? ((n = r[0]), (n.type = `mi`))
          : (n = new Aa(`mi`, r))
        : (e.isCharacterBox ? ((n = r[0]), (n.type = `mo`)) : (n = new Aa(`mo`, r)),
          e.mclass === `mbin`
            ? ((n.attributes.lspace = `0.22em`), (n.attributes.rspace = `0.22em`))
            : e.mclass === `mpunct`
              ? ((n.attributes.lspace = `0em`), (n.attributes.rspace = `0.17em`))
              : (e.mclass === `mopen` || e.mclass === `mclose`) &&
                ((n.attributes.lspace = `0em`), (n.attributes.rspace = `0em`))),
    n
  );
}
ma({
  type: `mclass`,
  names: [
    `\\mathord`,
    `\\mathbin`,
    `\\mathrel`,
    `\\mathopen`,
    `\\mathclose`,
    `\\mathpunct`,
    `\\mathinner`,
  ],
  numArgs: 1,
  primitive: !0,
  handler(e, t) {
    var { parser: n, funcName: r } = e,
      i = t[0];
    return {
      type: `mclass`,
      mode: n.mode,
      mclass: `m` + r.slice(5),
      body: _a(i),
      isCharacterBox: Fn(i),
    };
  },
  htmlBuilder: dee,
  mathmlBuilder: fee,
});
var uo = (e) => {
  var t = e.type === `ordgroup` && e.body.length ? e.body[0] : e;
  return t.type === `atom` && (t.family === `bin` || t.family === `rel`) ? `m` + t.family : `mord`;
};
(ma({
  type: `mclass`,
  names: [`\\@binrel`],
  numArgs: 2,
  handler(e, t) {
    var { parser: n } = e;
    return {
      type: `mclass`,
      mode: n.mode,
      mclass: uo(t[0]),
      body: _a(t[1]),
      isCharacterBox: Fn(t[1]),
    };
  },
}),
  ma({
    type: `mclass`,
    names: [`\\stackrel`, `\\overset`, `\\underset`],
    numArgs: 2,
    handler(e, t) {
      var { parser: n, funcName: r } = e,
        i = t[1],
        a = t[0],
        o = r === `\\stackrel` ? `mrel` : uo(i),
        s = {
          type: `op`,
          mode: i.mode,
          limits: !0,
          alwaysHandleSupSub: !0,
          parentIsSupSub: !1,
          symbol: !1,
          suppressBaseShift: r !== `\\stackrel`,
          body: _a(i),
        },
        c =
          r === `\\underset`
            ? {
                type: `supsub`,
                mode: a.mode,
                base: s,
                sub: a,
              }
            : {
                type: `supsub`,
                mode: a.mode,
                base: s,
                sup: a,
              };
      return {
        type: `mclass`,
        mode: n.mode,
        mclass: o,
        body: [c],
        isCharacterBox: Fn(c),
      };
    },
  }),
  ma({
    type: `pmb`,
    names: [`\\pmb`],
    numArgs: 1,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `pmb`,
        mode: n.mode,
        mclass: uo(t[0]),
        body: _a(t[0]),
      };
    },
    htmlBuilder(e, t) {
      var n = ba(e.body, t, !0),
        r = Xi([e.mclass], n, t);
      return ((r.style.textShadow = `0.02em 0.01em 0.04px`), r);
    },
    mathmlBuilder(e, t) {
      var n = new Aa(`mstyle`, La(e.body, t));
      return (n.setAttribute(`style`, `text-shadow: 0.02em 0.01em 0.04px`), n);
    },
  }));
var pee = {
    ">": `\\\\cdrightarrow`,
    "<": `\\\\cdleftarrow`,
    "=": `\\\\cdlongequal`,
    A: `\\uparrow`,
    V: `\\downarrow`,
    "|": `\\Vert`,
    ".": `no arrow`,
  },
  fo = () => ({
    type: `styling`,
    body: [],
    mode: `math`,
    style: `display`,
    resetFont: !0,
  }),
  po = (e) => e.type === `textord` && e.text === `@`,
  mee = (e, t) => (e.type === `mathord` || e.type === `atom`) && e.text === t;
function hee(e, t, n) {
  var r = pee[e];
  switch (r) {
    case `\\\\cdrightarrow`:
    case `\\\\cdleftarrow`:
      return n.callFunction(r, [t[0]], [t[1]]);
    case `\\uparrow`:
    case `\\downarrow`:
      var i = n.callFunction(`\\\\cdleft`, [t[0]], []),
        a = {
          type: `atom`,
          text: r,
          mode: `math`,
          family: `rel`,
        },
        o = {
          type: `ordgroup`,
          mode: `math`,
          body: [i, n.callFunction(`\\Big`, [a], []), n.callFunction(`\\\\cdright`, [t[1]], [])],
        };
      return n.callFunction(`\\\\cdparent`, [o], []);
    case `\\\\cdlongequal`:
      return n.callFunction(`\\\\cdlongequal`, [], []);
    case `\\Vert`:
      return n.callFunction(
        `\\Big`,
        [
          {
            type: `textord`,
            text: `\\Vert`,
            mode: `math`,
          },
        ],
        [],
      );
    default:
      return {
        type: `textord`,
        text: ` `,
        mode: `math`,
      };
  }
}
function mo(e) {
  var t = [];
  for (
    e.gullet.beginGroup(), e.gullet.macros.set(`\\cr`, `\\\\\\relax`), e.gullet.beginGroup();
    ;
  ) {
    (t.push(e.parseExpression(!1, `\\\\`)), e.gullet.endGroup(), e.gullet.beginGroup());
    var n = e.fetch().text;
    if (n === `&` || n === `\\\\`) e.consume();
    else if (n === `\\end`) {
      t[t.length - 1].length === 0 && t.pop();
      break;
    } else throw new Dn(`Expected \\\\ or \\cr or \\end`, e.nextToken);
  }
  for (var r = [], i = [r], a = 0; a < t.length; a++) {
    for (var o = t[a], s = fo(), c = 0; c < o.length; c++)
      if (!po(o[c])) s.body.push(o[c]);
      else {
        (r.push(s), (c += 1));
        var l = ao(o[c]).text,
          u = [, ,];
        if (
          ((u[0] = {
            type: `ordgroup`,
            mode: `math`,
            body: [],
          }),
          (u[1] = {
            type: `ordgroup`,
            mode: `math`,
            body: [],
          }),
          !`=|.`.includes(l))
        )
          if (`<>AV`.includes(l))
            for (var d = 0; d < 2; d++) {
              for (var f = !0, p = c + 1; p < o.length; p++) {
                if (mee(o[p], l)) {
                  ((f = !1), (c = p));
                  break;
                }
                if (po(o[p]))
                  throw new Dn(`Missing a ` + l + ` character to complete a CD arrow.`, o[p]);
                u[d].body.push(o[p]);
              }
              if (f) throw new Dn(`Missing a ` + l + ` character to complete a CD arrow.`, o[c]);
            }
          else throw new Dn(`Expected one of "<>AV=|." after @`, o[c]);
        var m = {
          type: `styling`,
          body: [hee(l, u, e)],
          mode: `math`,
          style: `display`,
          resetFont: !0,
        };
        (r.push(m), (s = fo()));
      }
    (a % 2 == 0 ? r.push(s) : r.shift(), (r = []), i.push(r));
  }
  return (
    e.gullet.endGroup(),
    e.gullet.endGroup(),
    {
      type: `array`,
      mode: `math`,
      body: i,
      arraystretch: 1,
      addJot: !0,
      rowGaps: [null],
      cols: Array(i[0].length).fill({
        type: `align`,
        align: `c`,
        pregap: 0.25,
        postgap: 0.25,
      }),
      colSeparationType: `CD`,
      hLinesBeforeRow: Array(i.length + 1).fill([]),
    }
  );
}
(ma({
  type: `cdlabel`,
  names: [`\\\\cdleft`, `\\\\cdright`],
  numArgs: 1,
  handler(e, t) {
    var { parser: n, funcName: r } = e;
    return {
      type: `cdlabel`,
      mode: n.mode,
      side: r.slice(4),
      label: t[0],
    };
  },
  htmlBuilder(e, t) {
    var n = t.havingStyle(t.style.sup()),
      r = ta(Ea(e.label, n, t), t);
    return (
      r.classes.push(`cd-label-` + e.side),
      (r.style.bottom = Or(0.8 - r.depth)),
      (r.height = 0),
      (r.depth = 0),
      r
    );
  },
  mathmlBuilder(e, t) {
    var n = new Aa(`mrow`, [za(e.label, t)]);
    return (
      (n = new Aa(`mpadded`, [n])),
      n.setAttribute(`width`, `0`),
      e.side === `left` && n.setAttribute(`lspace`, `-1width`),
      n.setAttribute(`voffset`, `0.7em`),
      (n = new Aa(`mstyle`, [n])),
      n.setAttribute(`displaystyle`, `false`),
      n.setAttribute(`scriptlevel`, `1`),
      n
    );
  },
}),
  ma({
    type: `cdlabelparent`,
    names: [`\\\\cdparent`],
    numArgs: 1,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `cdlabelparent`,
        mode: n.mode,
        fragment: t[0],
      };
    },
    htmlBuilder(e, t) {
      var n = ta(Ea(e.fragment, t), t);
      return (n.classes.push(`cd-vert-arrow`), n);
    },
    mathmlBuilder(e, t) {
      return new Aa(`mrow`, [za(e.fragment, t)]);
    },
  }),
  ma({
    type: `textord`,
    names: [`\\@char`],
    numArgs: 1,
    allowedInText: !0,
    handler(e, t) {
      for (var { parser: n } = e, r = io(t[0], `ordgroup`).body, i = ``, a = 0; a < r.length; a++) {
        var o = io(r[a], `textord`);
        i += o.text;
      }
      var s = parseInt(i),
        c;
      if (isNaN(s)) throw new Dn(`\\@char has non-numeric argument ` + i);
      if (s < 0 || s >= 1114111) throw new Dn(`\\@char with invalid code point ` + i);
      return (
        s <= 65535
          ? (c = String.fromCharCode(s))
          : ((s -= 65536), (c = String.fromCharCode((s >> 10) + 55296, (s & 1023) + 56320))),
        {
          type: `textord`,
          mode: n.mode,
          text: c,
        }
      );
    },
  }),
  ma({
    type: `color`,
    names: [`\\textcolor`],
    numArgs: 2,
    allowedInText: !0,
    argTypes: [`color`, `original`],
    handler(e, t) {
      var { parser: n } = e,
        r = io(t[0], `color-token`).color,
        i = t[1];
      return {
        type: `color`,
        mode: n.mode,
        color: r,
        body: _a(i),
      };
    },
    htmlBuilder: (e, t) => ea(ba(e.body, t.withColor(e.color), !1)),
    mathmlBuilder: (e, t) => {
      var n = new Aa(`mstyle`, La(e.body, t.withColor(e.color)));
      return (n.setAttribute(`mathcolor`, e.color), n);
    },
  }),
  ma({
    type: `color`,
    names: [`\\color`],
    numArgs: 1,
    allowedInText: !0,
    argTypes: [`color`],
    handler(e, t) {
      var { parser: n, breakOnTokenText: r } = e,
        i = io(t[0], `color-token`).color;
      n.gullet.macros.set(`\\current@color`, i);
      var a = n.parseExpression(!0, r);
      return {
        type: `color`,
        mode: n.mode,
        color: i,
        body: a,
      };
    },
  }),
  ma({
    type: `cr`,
    names: [`\\\\`],
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0,
    handler(e, t, n) {
      var { parser: r } = e,
        i = r.gullet.future().text === `[` ? r.parseSizeGroup(!0) : null,
        a =
          !r.settings.displayMode ||
          !r.settings.useStrictBehavior(
            `newLineInDisplayMode`,
            `In LaTeX, \\\\ or \\newline does nothing in display mode`,
          );
      return {
        type: `cr`,
        mode: r.mode,
        newLine: a,
        size: i && io(i, `size`).value,
      };
    },
    htmlBuilder(e, t) {
      var n = Xi([`mspace`], [], t);
      return (
        e.newLine && (n.classes.push(`newline`), e.size && (n.style.marginTop = Or(Dr(e.size, t)))),
        n
      );
    },
    mathmlBuilder(e, t) {
      var n = new Aa(`mspace`);
      return (
        e.newLine &&
          (n.setAttribute(`linebreak`, `newline`),
          e.size && n.setAttribute(`height`, Or(Dr(e.size, t)))),
        n
      );
    },
  }));
var ho = {
    "\\global": `\\global`,
    "\\long": `\\\\globallong`,
    "\\\\globallong": `\\\\globallong`,
    "\\def": `\\gdef`,
    "\\gdef": `\\gdef`,
    "\\edef": `\\xdef`,
    "\\xdef": `\\xdef`,
    "\\let": `\\\\globallet`,
    "\\futurelet": `\\\\globalfuture`,
  },
  go = (e) => {
    var t = e.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(t)) throw new Dn(`Expected a control sequence`, e);
    return t;
  },
  _o = (e) => {
    var t = e.gullet.popToken();
    return (
      t.text === `=` && ((t = e.gullet.popToken()), t.text === ` ` && (t = e.gullet.popToken())),
      t
    );
  },
  vo = (e, t, n, r) => {
    var i = e.gullet.macros.get(n.text);
    ((i ??=
      ((n.noexpand = !0),
      {
        tokens: [n],
        numArgs: 0,
        unexpandable: !e.gullet.isExpandable(n.text),
      })),
      e.gullet.macros.set(t, i, r));
  };
(ma({
  type: `internal`,
  names: [`\\global`, `\\long`, `\\\\globallong`],
  numArgs: 0,
  allowedInText: !0,
  handler(e) {
    var { parser: t, funcName: n } = e;
    t.consumeSpaces();
    var r = t.fetch();
    if (ho[r.text])
      return (
        (n === `\\global` || n === `\\\\globallong`) && (r.text = ho[r.text]),
        io(t.parseFunction(), `internal`)
      );
    throw new Dn(`Invalid token after macro prefix`, r);
  },
}),
  ma({
    type: `internal`,
    names: [`\\def`, `\\gdef`, `\\edef`, `\\xdef`],
    numArgs: 0,
    allowedInText: !0,
    primitive: !0,
    handler(e) {
      var { parser: t, funcName: n } = e,
        r = t.gullet.popToken(),
        i = r.text;
      if (/^(?:[\\{}$&#^_]|EOF)$/.test(i)) throw new Dn(`Expected a control sequence`, r);
      for (var a = 0, o, s = [[]]; t.gullet.future().text !== `{`;)
        if (((r = t.gullet.popToken()), r.text === `#`)) {
          if (t.gullet.future().text === `{`) {
            ((o = t.gullet.future()), s[a].push(`{`));
            break;
          }
          if (((r = t.gullet.popToken()), !/^[1-9]$/.test(r.text)))
            throw new Dn(`Invalid argument number "` + r.text + `"`);
          if (parseInt(r.text) !== a + 1)
            throw new Dn(`Argument number "` + r.text + `" out of order`);
          (a++, s.push([]));
        } else if (r.text === `EOF`) throw new Dn(`Expected a macro definition`);
        else s[a].push(r.text);
      var { tokens: c } = t.gullet.consumeArg();
      return (
        o && c.unshift(o),
        (n === `\\edef` || n === `\\xdef`) && ((c = t.gullet.expandTokens(c)), c.reverse()),
        t.gullet.macros.set(
          i,
          {
            tokens: c,
            numArgs: a,
            delimiters: s,
          },
          n === ho[n],
        ),
        {
          type: `internal`,
          mode: t.mode,
        }
      );
    },
  }),
  ma({
    type: `internal`,
    names: [`\\let`, `\\\\globallet`],
    numArgs: 0,
    allowedInText: !0,
    primitive: !0,
    handler(e) {
      var { parser: t, funcName: n } = e,
        r = go(t.gullet.popToken());
      return (
        t.gullet.consumeSpaces(),
        vo(t, r, _o(t), n === `\\\\globallet`),
        {
          type: `internal`,
          mode: t.mode,
        }
      );
    },
  }),
  ma({
    type: `internal`,
    names: [`\\futurelet`, `\\\\globalfuture`],
    numArgs: 0,
    allowedInText: !0,
    primitive: !0,
    handler(e) {
      var { parser: t, funcName: n } = e,
        r = go(t.gullet.popToken()),
        i = t.gullet.popToken(),
        a = t.gullet.popToken();
      return (
        vo(t, r, a, n === `\\\\globalfuture`),
        t.gullet.pushToken(a),
        t.gullet.pushToken(i),
        {
          type: `internal`,
          mode: t.mode,
        }
      );
    },
  }));
var yo = function (e, t, n) {
    var r = Xr(($r.math[e] && $r.math[e].replace) || e, t, n);
    if (!r) throw Error(`Unsupported symbol ` + e + ` and font size ` + t + `.`);
    return r;
  },
  bo = function (e, t, n, r) {
    var i = n.havingBaseStyle(t),
      a = Xi(r.concat(i.sizingClasses(n)), [e], n),
      o = i.sizeMultiplier / n.sizeMultiplier;
    return ((a.height *= o), (a.depth *= o), (a.maxFontSize = i.sizeMultiplier), a);
  },
  xo = function (e, t, n) {
    var r = t.havingBaseStyle(n),
      i = (1 - t.sizeMultiplier / r.sizeMultiplier) * t.fontMetrics().axisHeight;
    (e.classes.push(`delimcenter`), (e.style.top = Or(i)), (e.height -= i), (e.depth += i));
  },
  So = function (e, t, n, r, i, a) {
    var o = bo(Wi(e, `Main-Regular`, i, r), t, r, a);
    return (n && xo(o, r, t), o);
  },
  Co = function (e, t, n, r) {
    return Wi(e, `Size` + t + `-Regular`, n, r);
  },
  wo = function (e, t, n, r, i, a) {
    var o = Co(e, t, i, r),
      s = bo(Xi([`delimsizing`, `size` + t], [o], r), ir.TEXT, r, a);
    return (n && xo(s, r, ir.TEXT), s);
  },
  To = function (e, t, n) {
    return {
      type: `elem`,
      elem: Xi(
        [`delimsizinginner`, t === `Size1-Regular` ? `delim-size1` : `delim-size4`],
        [Xi([], [Wi(e, t, n)])],
      ),
    };
  },
  Eo = function (e, t, n) {
    var r = Kr[`Size4-Regular`][e.charCodeAt(0)]
        ? Kr[`Size4-Regular`][e.charCodeAt(0)][4]
        : Kr[`Size1-Regular`][e.charCodeAt(0)][4],
      i = Zi(
        [],
        [
          new Br([new Vr(`inner`, yr(e, Math.round(1e3 * t)))], {
            width: Or(r),
            height: Or(t),
            style: `width:` + Or(r),
            viewBox: `0 0 ` + 1e3 * r + ` ` + Math.round(1e3 * t),
            preserveAspectRatio: `xMinYMin`,
          }),
        ],
        n,
      );
    return (
      (i.height = t),
      (i.style.height = Or(t)),
      (i.style.width = Or(r)),
      {
        type: `elem`,
        elem: i,
      }
    );
  },
  Do = 0.008,
  Oo = {
    type: `kern`,
    size: -1 * Do,
  },
  ko = new Set([`|`, `\\lvert`, `\\rvert`, `\\vert`]),
  Ao = new Set([`\\|`, `\\lVert`, `\\rVert`, `\\Vert`]),
  jo = function (e, t, n, r, i, a) {
    var o,
      s,
      c,
      l,
      u = ``,
      d = 0;
    ((o = c = l = e), (s = null));
    var f = `Size1-Regular`;
    e === `\\uparrow`
      ? (c = l = `⏐`)
      : e === `\\Uparrow`
        ? (c = l = `‖`)
        : e === `\\downarrow`
          ? (o = c = `⏐`)
          : e === `\\Downarrow`
            ? (o = c = `‖`)
            : e === `\\updownarrow`
              ? ((o = `\\uparrow`), (c = `⏐`), (l = `\\downarrow`))
              : e === `\\Updownarrow`
                ? ((o = `\\Uparrow`), (c = `‖`), (l = `\\Downarrow`))
                : ko.has(e)
                  ? ((c = `∣`), (u = `vert`), (d = 333))
                  : Ao.has(e)
                    ? ((c = `∥`), (u = `doublevert`), (d = 556))
                    : e === `[` || e === `\\lbrack`
                      ? ((o = `⎡`),
                        (c = `⎢`),
                        (l = `⎣`),
                        (f = `Size4-Regular`),
                        (u = `lbrack`),
                        (d = 667))
                      : e === `]` || e === `\\rbrack`
                        ? ((o = `⎤`),
                          (c = `⎥`),
                          (l = `⎦`),
                          (f = `Size4-Regular`),
                          (u = `rbrack`),
                          (d = 667))
                        : e === `\\lfloor` || e === `⌊`
                          ? ((c = o = `⎢`),
                            (l = `⎣`),
                            (f = `Size4-Regular`),
                            (u = `lfloor`),
                            (d = 667))
                          : e === `\\lceil` || e === `⌈`
                            ? ((o = `⎡`),
                              (c = l = `⎢`),
                              (f = `Size4-Regular`),
                              (u = `lceil`),
                              (d = 667))
                            : e === `\\rfloor` || e === `⌋`
                              ? ((c = o = `⎥`),
                                (l = `⎦`),
                                (f = `Size4-Regular`),
                                (u = `rfloor`),
                                (d = 667))
                              : e === `\\rceil` || e === `⌉`
                                ? ((o = `⎤`),
                                  (c = l = `⎥`),
                                  (f = `Size4-Regular`),
                                  (u = `rceil`),
                                  (d = 667))
                                : e === `(` || e === `\\lparen`
                                  ? ((o = `⎛`),
                                    (c = `⎜`),
                                    (l = `⎝`),
                                    (f = `Size4-Regular`),
                                    (u = `lparen`),
                                    (d = 875))
                                  : e === `)` || e === `\\rparen`
                                    ? ((o = `⎞`),
                                      (c = `⎟`),
                                      (l = `⎠`),
                                      (f = `Size4-Regular`),
                                      (u = `rparen`),
                                      (d = 875))
                                    : e === `\\{` || e === `\\lbrace`
                                      ? ((o = `⎧`),
                                        (s = `⎨`),
                                        (l = `⎩`),
                                        (c = `⎪`),
                                        (f = `Size4-Regular`))
                                      : e === `\\}` || e === `\\rbrace`
                                        ? ((o = `⎫`),
                                          (s = `⎬`),
                                          (l = `⎭`),
                                          (c = `⎪`),
                                          (f = `Size4-Regular`))
                                        : e === `\\lgroup` || e === `⟮`
                                          ? ((o = `⎧`), (l = `⎩`), (c = `⎪`), (f = `Size4-Regular`))
                                          : e === `\\rgroup` || e === `⟯`
                                            ? ((o = `⎫`),
                                              (l = `⎭`),
                                              (c = `⎪`),
                                              (f = `Size4-Regular`))
                                            : e === `\\lmoustache` || e === `⎰`
                                              ? ((o = `⎧`),
                                                (l = `⎭`),
                                                (c = `⎪`),
                                                (f = `Size4-Regular`))
                                              : (e === `\\rmoustache` || e === `⎱`) &&
                                                ((o = `⎫`),
                                                (l = `⎩`),
                                                (c = `⎪`),
                                                (f = `Size4-Regular`));
    var p = yo(o, f, i),
      m = p.height + p.depth,
      h = yo(c, f, i),
      g = h.height + h.depth,
      v = yo(l, f, i),
      y = v.height + v.depth,
      b = 0,
      x = 1;
    if (s !== null) {
      var S = yo(s, f, i);
      ((b = S.height + S.depth), (x = 2));
    }
    var C = m + y + b,
      w = C + Math.max(0, Math.ceil((t - C) / (x * g))) * x * g,
      T = r.fontMetrics().axisHeight;
    n && (T *= r.sizeMultiplier);
    var E = w / 2 - T,
      D = [];
    if (u.length > 0) {
      var ee = w - m - y,
        te = Math.round(w * 1e3),
        O = xr(u, Math.round(ee * 1e3)),
        k = new Vr(u, O),
        ne = Or(d / 1e3),
        re = Or(te / 1e3),
        A = Zi(
          [],
          [
            new Br([k], {
              width: ne,
              height: re,
              viewBox: `0 0 ` + d + ` ` + te,
            }),
          ],
          r,
        );
      ((A.height = te / 1e3),
        (A.style.width = ne),
        (A.style.height = re),
        D.push({
          type: `elem`,
          elem: A,
        }));
    } else {
      if ((D.push(To(l, f, i)), D.push(Oo), s === null)) {
        var ie = w - m - y + 2 * Do;
        D.push(Eo(c, ie, r));
      } else {
        var j = (w - m - y - b) / 2 + 2 * Do;
        (D.push(Eo(c, j, r)), D.push(Oo), D.push(To(s, f, i)), D.push(Oo), D.push(Eo(c, j, r)));
      }
      (D.push(Oo), D.push(To(o, f, i)));
    }
    var ae = r.havingBaseStyle(ir.TEXT);
    return bo(
      Xi(
        [`delimsizing`, `mult`],
        [
          na({
            positionType: `bottom`,
            positionData: E,
            children: D,
          }),
        ],
        ae,
      ),
      ir.TEXT,
      r,
      a,
    );
  },
  Mo = 80,
  No = 0.08,
  Po = function (e, t, n, r, i) {
    return Zi(
      [`hide-tail`],
      [
        new Br([new Vr(e, vr(e, r, n))], {
          width: `400em`,
          height: Or(t),
          viewBox: `0 0 400000 ` + n,
          preserveAspectRatio: `xMinYMin slice`,
        }),
      ],
      i,
    );
  },
  Fo = function (e, t) {
    var n = t.havingBaseSizing(),
      r = Ho(`\\surd`, e * n.sizeMultiplier, Vo, n),
      i = n.sizeMultiplier,
      a = Math.max(0, t.minRuleThickness - t.fontMetrics().sqrtRuleThickness),
      o,
      s,
      c,
      l,
      u;
    return (
      r.type === `small`
        ? ((l = 1e3 + 1e3 * a + Mo),
          e < 1 ? (i = 1) : e < 1.4 && (i = 0.7),
          (s = (1 + a + No) / i),
          (c = (1 + a) / i),
          (o = Po(`sqrtMain`, s, l, a, t)),
          (o.style.minWidth = `0.853em`),
          (u = 0.833 / i))
        : r.type === `large`
          ? ((l = (1e3 + Mo) * zo[r.size]),
            (c = (zo[r.size] + a) / i),
            (s = (zo[r.size] + a + No) / i),
            (o = Po(`sqrtSize` + r.size, s, l, a, t)),
            (o.style.minWidth = `1.02em`),
            (u = 1 / i))
          : ((s = e + a + No),
            (c = e + a),
            (l = Math.floor(1e3 * e + a) + Mo),
            (o = Po(`sqrtTall`, s, l, a, t)),
            (o.style.minWidth = `0.742em`),
            (u = 1.056)),
      (o.height = c),
      (o.style.height = Or(s)),
      {
        span: o,
        advanceWidth: u,
        ruleWidth: (t.fontMetrics().sqrtRuleThickness + a) * i,
      }
    );
  },
  Io = new Set([
    `(`,
    `\\lparen`,
    `)`,
    `\\rparen`,
    `[`,
    `\\lbrack`,
    `]`,
    `\\rbrack`,
    `\\{`,
    `\\lbrace`,
    `\\}`,
    `\\rbrace`,
    `\\lfloor`,
    `\\rfloor`,
    `⌊`,
    `⌋`,
    `\\lceil`,
    `\\rceil`,
    `⌈`,
    `⌉`,
    `\\surd`,
  ]),
  Lo = new Set([
    `\\uparrow`,
    `\\downarrow`,
    `\\updownarrow`,
    `\\Uparrow`,
    `\\Downarrow`,
    `\\Updownarrow`,
    `|`,
    `\\|`,
    `\\vert`,
    `\\Vert`,
    `\\lvert`,
    `\\rvert`,
    `\\lVert`,
    `\\rVert`,
    `\\lgroup`,
    `\\rgroup`,
    `⟮`,
    `⟯`,
    `\\lmoustache`,
    `\\rmoustache`,
    `⎰`,
    `⎱`,
  ]),
  Ro = new Set([`<`, `>`, `\\langle`, `\\rangle`, `/`, `\\backslash`, `\\lt`, `\\gt`]),
  zo = [0, 1.2, 1.8, 2.4, 3],
  Bo = function (e, t, n, r, i) {
    if (
      (e === `<` || e === `\\lt` || e === `⟨`
        ? (e = `\\langle`)
        : (e === `>` || e === `\\gt` || e === `⟩`) && (e = `\\rangle`),
      Io.has(e) || Ro.has(e))
    )
      return wo(e, t, !1, n, r, i);
    if (Lo.has(e)) return jo(e, zo[t], !1, n, r, i);
    throw new Dn(`Illegal delimiter: '` + e + `'`);
  },
  gee = [
    {
      type: `small`,
      style: ir.SCRIPTSCRIPT,
    },
    {
      type: `small`,
      style: ir.SCRIPT,
    },
    {
      type: `small`,
      style: ir.TEXT,
    },
    {
      type: `large`,
      size: 1,
    },
    {
      type: `large`,
      size: 2,
    },
    {
      type: `large`,
      size: 3,
    },
    {
      type: `large`,
      size: 4,
    },
  ],
  _ee = [
    {
      type: `small`,
      style: ir.SCRIPTSCRIPT,
    },
    {
      type: `small`,
      style: ir.SCRIPT,
    },
    {
      type: `small`,
      style: ir.TEXT,
    },
    {
      type: `stack`,
    },
  ],
  Vo = [
    {
      type: `small`,
      style: ir.SCRIPTSCRIPT,
    },
    {
      type: `small`,
      style: ir.SCRIPT,
    },
    {
      type: `small`,
      style: ir.TEXT,
    },
    {
      type: `large`,
      size: 1,
    },
    {
      type: `large`,
      size: 2,
    },
    {
      type: `large`,
      size: 3,
    },
    {
      type: `large`,
      size: 4,
    },
    {
      type: `stack`,
    },
  ],
  vee = function (e) {
    if (e.type === `small`) return `Main-Regular`;
    if (e.type === `large`) return `Size` + e.size + `-Regular`;
    if (e.type === `stack`) return `Size4-Regular`;
    var t = e.type;
    throw Error(`Add support for delim type '` + t + `' here.`);
  },
  Ho = function (e, t, n, r) {
    for (var i = Math.min(2, 3 - r.style.size); i < n.length; i++) {
      var a = n[i];
      if (a.type === `stack`) break;
      var o = yo(e, vee(a), `math`),
        s = o.height + o.depth;
      if (a.type === `small`) {
        var c = r.havingBaseStyle(a.style);
        s *= c.sizeMultiplier;
      }
      if (s > t) return a;
    }
    return n[n.length - 1];
  },
  Uo = function (e, t, n, r, i, a) {
    e === `<` || e === `\\lt` || e === `⟨`
      ? (e = `\\langle`)
      : (e === `>` || e === `\\gt` || e === `⟩`) && (e = `\\rangle`);
    var o = Ro.has(e) ? gee : Io.has(e) ? Vo : _ee,
      s = Ho(e, t, o, r);
    return s.type === `small`
      ? So(e, s.style, n, r, i, a)
      : s.type === `large`
        ? wo(e, s.size, n, r, i, a)
        : jo(e, t, n, r, i, a);
  },
  Wo = function (e, t, n, r, i, a) {
    var o = r.fontMetrics().axisHeight * r.sizeMultiplier,
      s = 901,
      c = 5 / r.fontMetrics().ptPerEm,
      l = Math.max(t - o, n + o);
    return Uo(e, Math.max((l / 500) * s, 2 * l - c), !0, r, i, a);
  },
  Go = {
    "\\bigl": {
      mclass: `mopen`,
      size: 1,
    },
    "\\Bigl": {
      mclass: `mopen`,
      size: 2,
    },
    "\\biggl": {
      mclass: `mopen`,
      size: 3,
    },
    "\\Biggl": {
      mclass: `mopen`,
      size: 4,
    },
    "\\bigr": {
      mclass: `mclose`,
      size: 1,
    },
    "\\Bigr": {
      mclass: `mclose`,
      size: 2,
    },
    "\\biggr": {
      mclass: `mclose`,
      size: 3,
    },
    "\\Biggr": {
      mclass: `mclose`,
      size: 4,
    },
    "\\bigm": {
      mclass: `mrel`,
      size: 1,
    },
    "\\Bigm": {
      mclass: `mrel`,
      size: 2,
    },
    "\\biggm": {
      mclass: `mrel`,
      size: 3,
    },
    "\\Biggm": {
      mclass: `mrel`,
      size: 4,
    },
    "\\big": {
      mclass: `mord`,
      size: 1,
    },
    "\\Big": {
      mclass: `mord`,
      size: 2,
    },
    "\\bigg": {
      mclass: `mord`,
      size: 3,
    },
    "\\Bigg": {
      mclass: `mord`,
      size: 4,
    },
  },
  yee = new Set(
    `(,\\lparen,),\\rparen,[,\\lbrack,],\\rbrack,\\{,\\lbrace,\\},\\rbrace,\\lfloor,\\rfloor,⌊,⌋,\\lceil,\\rceil,⌈,⌉,<,>,\\langle,⟨,\\rangle,⟩,\\lt,\\gt,\\lvert,\\rvert,\\lVert,\\rVert,\\lgroup,\\rgroup,⟮,⟯,\\lmoustache,\\rmoustache,⎰,⎱,/,\\backslash,|,\\vert,\\|,\\Vert,\\uparrow,\\Uparrow,\\downarrow,\\Downarrow,\\updownarrow,\\Updownarrow,.`.split(
      `,`,
    ),
  );
function Ko(e) {
  return `isMiddle` in e;
}
function qo(e, t) {
  var n = oo(e);
  if (n && yee.has(n.text)) return n;
  throw n
    ? new Dn(`Invalid delimiter '` + n.text + `' after '` + t.funcName + `'`, e)
    : new Dn(`Invalid delimiter type '` + e.type + `'`, e);
}
ma({
  type: `delimsizing`,
  names: [
    `\\bigl`,
    `\\Bigl`,
    `\\biggl`,
    `\\Biggl`,
    `\\bigr`,
    `\\Bigr`,
    `\\biggr`,
    `\\Biggr`,
    `\\bigm`,
    `\\Bigm`,
    `\\biggm`,
    `\\Biggm`,
    `\\big`,
    `\\Big`,
    `\\bigg`,
    `\\Bigg`,
  ],
  numArgs: 1,
  argTypes: [`primitive`],
  handler: (e, t) => {
    var n = qo(t[0], e);
    return {
      type: `delimsizing`,
      mode: e.parser.mode,
      size: Go[e.funcName].size,
      mclass: Go[e.funcName].mclass,
      delim: n.text,
    };
  },
  htmlBuilder: (e, t) =>
    e.delim === `.` ? Xi([e.mclass]) : Bo(e.delim, e.size, t, e.mode, [e.mclass]),
  mathmlBuilder: (e) => {
    var t = [];
    e.delim !== `.` && t.push(Na(e.delim, e.mode));
    var n = new Aa(`mo`, t);
    (e.mclass === `mopen` || e.mclass === `mclose`
      ? n.setAttribute(`fence`, `true`)
      : n.setAttribute(`fence`, `false`),
      n.setAttribute(`stretchy`, `true`));
    var r = Or(zo[e.size]);
    return (n.setAttribute(`minsize`, r), n.setAttribute(`maxsize`, r), n);
  },
});
function Jo(e) {
  if (!e.body) throw Error(`Bug: The leftright ParseNode wasn't fully parsed.`);
}
(ma({
  type: `leftright-right`,
  names: [`\\right`],
  numArgs: 1,
  primitive: !0,
  handler: (e, t) => {
    var n = e.parser.gullet.macros.get(`\\current@color`);
    if (n && typeof n != `string`) throw new Dn(`\\current@color set to non-string in \\right`);
    return {
      type: `leftright-right`,
      mode: e.parser.mode,
      delim: qo(t[0], e).text,
      color: n,
    };
  },
}),
  ma({
    type: `leftright`,
    names: [`\\left`],
    numArgs: 1,
    primitive: !0,
    handler: (e, t) => {
      var n = qo(t[0], e),
        r = e.parser;
      ++r.leftrightDepth;
      var i = r.parseExpression(!1);
      (--r.leftrightDepth, r.expect(`\\right`, !1));
      var a = io(r.parseFunction(), `leftright-right`);
      return {
        type: `leftright`,
        mode: r.mode,
        body: i,
        left: n.text,
        right: a.delim,
        rightColor: a.color,
      };
    },
    htmlBuilder: (e, t) => {
      Jo(e);
      for (
        var n = ba(e.body, t, !0, [`mopen`, `mclose`]), r = 0, i = 0, a = !1, o = 0;
        o < n.length;
        o++
      ) {
        var s = n[o];
        Ko(s) ? (a = !0) : ((r = Math.max(n[o].height, r)), (i = Math.max(n[o].depth, i)));
      }
      ((r *= t.sizeMultiplier), (i *= t.sizeMultiplier));
      var c = e.left === `.` ? Ta(t, [`mopen`]) : Wo(e.left, r, i, t, e.mode, [`mopen`]);
      if ((n.unshift(c), a))
        for (var l = 1; l < n.length; l++) {
          var u = n[l];
          if (Ko(u)) {
            var d = u.isMiddle;
            n[l] = Wo(d.delim, r, i, d.options, e.mode, []);
          }
        }
      var f;
      if (e.right === `.`) f = Ta(t, [`mclose`]);
      else {
        var p = e.rightColor ? t.withColor(e.rightColor) : t;
        f = Wo(e.right, r, i, p, e.mode, [`mclose`]);
      }
      return (n.push(f), Xi([`minner`], n, t));
    },
    mathmlBuilder: (e, t) => {
      Jo(e);
      var n = La(e.body, t);
      if (e.left !== `.`) {
        var r = new Aa(`mo`, [Na(e.left, e.mode)]);
        (r.setAttribute(`fence`, `true`), n.unshift(r));
      }
      if (e.right !== `.`) {
        var i = new Aa(`mo`, [Na(e.right, e.mode)]);
        (i.setAttribute(`fence`, `true`),
          e.rightColor && i.setAttribute(`mathcolor`, e.rightColor),
          n.push(i));
      }
      return Pa(n);
    },
  }),
  ma({
    type: `middle`,
    names: [`\\middle`],
    numArgs: 1,
    primitive: !0,
    handler: (e, t) => {
      var n = qo(t[0], e);
      if (!e.parser.leftrightDepth) throw new Dn(`\\middle without preceding \\left`, n);
      return {
        type: `middle`,
        mode: e.parser.mode,
        delim: n.text,
      };
    },
    htmlBuilder: (e, t) => {
      var n;
      return (
        e.delim === `.`
          ? (n = Ta(t, []))
          : ((n = Bo(e.delim, 1, t, e.mode, [])),
            (n.isMiddle = {
              delim: e.delim,
              options: t,
            })),
        n
      );
    },
    mathmlBuilder: (e, t) => {
      var n = new Aa(`mo`, [
        e.delim === `\\vert` || e.delim === `|` ? Na(`|`, `text`) : Na(e.delim, e.mode),
      ]);
      return (
        n.setAttribute(`fence`, `true`),
        n.setAttribute(`lspace`, `0.05em`),
        n.setAttribute(`rspace`, `0.05em`),
        n
      );
    },
  }),
  ma({
    type: `enclose`,
    names: [`\\colorbox`],
    numArgs: 2,
    allowedInText: !0,
    argTypes: [`color`, `hbox`],
    handler(e, t, n) {
      var { parser: r, funcName: i } = e,
        a = io(t[0], `color-token`).color,
        o = t[1];
      return {
        type: `enclose`,
        mode: r.mode,
        label: i,
        backgroundColor: a,
        body: o,
      };
    },
    htmlBuilder: (e, t) => {
      var n = ta(Ea(e.body, t), t),
        r = e.label.slice(1),
        i = t.sizeMultiplier,
        a,
        o,
        s = Fn(e.body);
      if (r === `sout`)
        ((a = Xi([`stretchy`, `sout`])),
          (a.height = t.fontMetrics().defaultRuleThickness / i),
          (o = -0.5 * t.fontMetrics().xHeight));
      else if (r === `phase`) {
        var c = Dr(
            {
              number: 0.6,
              unit: `pt`,
            },
            t,
          ),
          l = Dr(
            {
              number: 0.35,
              unit: `ex`,
            },
            t,
          ),
          u = t.havingBaseSizing();
        i /= u.sizeMultiplier;
        var d = n.height + n.depth + c + l;
        n.style.paddingLeft = Or(d / 2 + c);
        var f = Math.floor(1e3 * d * i);
        ((a = Zi(
          [`hide-tail`],
          [
            new Br([new Vr(`phase`, gr(f))], {
              width: `400em`,
              height: Or(f / 1e3),
              viewBox: `0 0 400000 ` + f,
              preserveAspectRatio: `xMinYMin slice`,
            }),
          ],
          t,
        )),
          (a.style.height = Or(d)),
          (o = n.depth + c + l));
      } else {
        /cancel/.test(r)
          ? s || n.classes.push(`cancel-pad`)
          : r === `angl`
            ? n.classes.push(`anglpad`)
            : n.classes.push(`boxpad`);
        var p,
          m,
          h = 0;
        (/box/.test(r)
          ? ((h = Math.max(t.fontMetrics().fboxrule, t.minRuleThickness)),
            (p = t.fontMetrics().fboxsep + (r === `colorbox` ? 0 : h)),
            (m = p))
          : r === `angl`
            ? ((h = Math.max(t.fontMetrics().defaultRuleThickness, t.minRuleThickness)),
              (p = 4 * h),
              (m = Math.max(0, 0.25 - n.depth)))
            : ((p = s ? 0.2 : 0), (m = p)),
          (a = eo(n, r, p, m, t)),
          /fbox|boxed|fcolorbox/.test(r)
            ? ((a.style.borderStyle = `solid`), (a.style.borderWidth = Or(h)))
            : r === `angl` &&
              h !== 0.049 &&
              ((a.style.borderTopWidth = Or(h)), (a.style.borderRightWidth = Or(h))),
          (o = n.depth + m),
          e.backgroundColor &&
            ((a.style.backgroundColor = e.backgroundColor),
            e.borderColor && (a.style.borderColor = e.borderColor)));
      }
      var g;
      if (e.backgroundColor)
        g = na({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: a,
              shift: o,
            },
            {
              type: `elem`,
              elem: n,
              shift: 0,
            },
          ],
        });
      else {
        var v = /cancel|phase/.test(r) ? [`svg-align`] : [];
        g = na({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: n,
              shift: 0,
            },
            {
              type: `elem`,
              elem: a,
              shift: o,
              wrapperClasses: v,
            },
          ],
        });
      }
      return (
        /cancel/.test(r) && ((g.height = n.height), (g.depth = n.depth)),
        /cancel/.test(r) && !s ? Xi([`mord`, `cancel-lap`], [g], t) : Xi([`mord`], [g], t)
      );
    },
    mathmlBuilder: (e, t) => {
      var n,
        r = new Aa(e.label.includes(`colorbox`) ? `mpadded` : `menclose`, [za(e.body, t)]);
      switch (e.label) {
        case `\\cancel`:
          r.setAttribute(`notation`, `updiagonalstrike`);
          break;
        case `\\bcancel`:
          r.setAttribute(`notation`, `downdiagonalstrike`);
          break;
        case `\\phase`:
          r.setAttribute(`notation`, `phasorangle`);
          break;
        case `\\sout`:
          r.setAttribute(`notation`, `horizontalstrike`);
          break;
        case `\\fbox`:
          r.setAttribute(`notation`, `box`);
          break;
        case `\\angl`:
          r.setAttribute(`notation`, `actuarial`);
          break;
        case `\\fcolorbox`:
        case `\\colorbox`:
          if (
            ((n = t.fontMetrics().fboxsep * t.fontMetrics().ptPerEm),
            r.setAttribute(`width`, `+` + 2 * n + `pt`),
            r.setAttribute(`height`, `+` + 2 * n + `pt`),
            r.setAttribute(`lspace`, n + `pt`),
            r.setAttribute(`voffset`, n + `pt`),
            e.label === `\\fcolorbox`)
          ) {
            var i = Math.max(t.fontMetrics().fboxrule, t.minRuleThickness);
            r.setAttribute(`style`, `border: ` + Or(i) + ` solid ` + e.borderColor);
          }
          break;
        case `\\xcancel`:
          r.setAttribute(`notation`, `updiagonalstrike downdiagonalstrike`);
          break;
      }
      return (e.backgroundColor && r.setAttribute(`mathbackground`, e.backgroundColor), r);
    },
  }),
  ma({
    type: `enclose`,
    names: [`\\fcolorbox`],
    numArgs: 3,
    allowedInText: !0,
    argTypes: [`color`, `color`, `hbox`],
    handler(e, t, n) {
      var { parser: r, funcName: i } = e,
        a = io(t[0], `color-token`).color,
        o = io(t[1], `color-token`).color,
        s = t[2];
      return {
        type: `enclose`,
        mode: r.mode,
        label: i,
        backgroundColor: o,
        borderColor: a,
        body: s,
      };
    },
  }),
  ma({
    type: `enclose`,
    names: [`\\fbox`],
    numArgs: 1,
    argTypes: [`hbox`],
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `enclose`,
        mode: n.mode,
        label: `\\fbox`,
        body: t[0],
      };
    },
  }),
  ma({
    type: `enclose`,
    names: [`\\cancel`, `\\bcancel`, `\\xcancel`, `\\phase`],
    numArgs: 1,
    handler(e, t) {
      var { parser: n, funcName: r } = e,
        i = t[0];
      return {
        type: `enclose`,
        mode: n.mode,
        label: r,
        body: i,
      };
    },
  }),
  ma({
    type: `enclose`,
    names: [`\\sout`],
    numArgs: 1,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n, funcName: r } = e;
      n.mode === `math` &&
        n.settings.reportNonstrict(`mathVsSout`, `LaTeX's \\sout works only in text mode`);
      var i = t[0];
      return {
        type: `enclose`,
        mode: n.mode,
        label: r,
        body: i,
      };
    },
  }),
  ma({
    type: `enclose`,
    names: [`\\angl`],
    numArgs: 1,
    argTypes: [`hbox`],
    allowedInText: !1,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `enclose`,
        mode: n.mode,
        label: `\\angl`,
        body: t[0],
      };
    },
  }));
var Yo = {};
function Xo(e) {
  for (
    var { type: t, names: n, props: r, handler: i, htmlBuilder: a, mathmlBuilder: o } = e,
      s = {
        type: t,
        numArgs: r.numArgs || 0,
        allowedInText: !1,
        numOptionalArgs: 0,
        handler: i,
      },
      c = 0;
    c < n.length;
    ++c
  )
    Yo[n[c]] = s;
  (a && (fa[t] = a), o && (pa[t] = o));
}
var Zo = {};
function Q(e, t) {
  Zo[e] = t;
}
var Qo = class e {
    constructor(e, t, n) {
      ((this.lexer = void 0),
        (this.start = void 0),
        (this.end = void 0),
        (this.lexer = e),
        (this.start = t),
        (this.end = n));
    }
    static range(t, n) {
      return n
        ? !t || !t.loc || !n.loc || t.loc.lexer !== n.loc.lexer
          ? null
          : new e(t.loc.lexer, t.loc.start, n.loc.end)
        : t && t.loc;
    }
  },
  $o = class e {
    constructor(e, t) {
      ((this.text = void 0),
        (this.loc = void 0),
        (this.noexpand = void 0),
        (this.treatAsRelax = void 0),
        (this.text = e),
        (this.loc = t));
    }
    range(t, n) {
      return new e(n, Qo.range(this, t));
    }
  };
function es(e) {
  var t = [];
  e.consumeSpaces();
  var n = e.fetch().text;
  for (
    n === `\\relax` && (e.consume(), e.consumeSpaces(), (n = e.fetch().text));
    n === `\\hline` || n === `\\hdashline`;
  )
    (e.consume(), t.push(n === `\\hdashline`), e.consumeSpaces(), (n = e.fetch().text));
  return t;
}
var ts = (e) => {
    if (!e.parser.settings.displayMode)
      throw new Dn(`{` + e.envName + `} can be used only in display mode.`);
  },
  ns = new Set([`gather`, `gather*`]);
function rs(e) {
  if (!e.includes(`ed`)) return !e.includes(`*`);
}
function is(e, t, n) {
  var {
    hskipBeforeAndAfter: r,
    addJot: i,
    cols: a,
    arraystretch: o,
    colSeparationType: s,
    autoTag: c,
    singleRow: l,
    emptySingleRow: u,
    maxNumCols: d,
    leqno: f,
  } = t;
  if ((e.gullet.beginGroup(), l || e.gullet.macros.set(`\\cr`, `\\\\\\relax`), !o)) {
    var p = e.gullet.expandMacroAsText(`\\arraystretch`);
    if (p == null) o = 1;
    else if (((o = parseFloat(p)), !o || o < 0)) throw new Dn(`Invalid \\arraystretch: ` + p);
  }
  e.gullet.beginGroup();
  var m = [],
    h = [m],
    g = [],
    v = [],
    y = c == null ? void 0 : [];
  function b() {
    c && e.gullet.macros.set(`\\@eqnsw`, `1`, !0);
  }
  function x() {
    y &&
      (e.gullet.macros.get(`\\df@tag`)
        ? (y.push(e.subparse([new $o(`\\df@tag`)])), e.gullet.macros.set(`\\df@tag`, void 0, !0))
        : y.push(!!c && e.gullet.macros.get(`\\@eqnsw`) === `1`));
  }
  for (b(), v.push(es(e)); ;) {
    var S = e.parseExpression(!1, l ? `\\end` : `\\\\`);
    (e.gullet.endGroup(), e.gullet.beginGroup());
    var C = {
      type: `ordgroup`,
      mode: e.mode,
      body: S,
    };
    (n &&
      (C = {
        type: `styling`,
        mode: e.mode,
        style: n,
        resetFont: !0,
        body: [C],
      }),
      m.push(C));
    var w = e.fetch().text;
    if (w === `&`) {
      if (d && m.length === d) {
        if (l || s) throw new Dn(`Too many tab characters: &`, e.nextToken);
        e.settings.reportNonstrict(
          `textEnv`,
          `Too few columns specified in the {array} column argument.`,
        );
      }
      e.consume();
    } else if (w === `\\end`) {
      (x(),
        m.length === 1 &&
          C.type === `styling` &&
          C.body.length === 1 &&
          C.body[0].type === `ordgroup` &&
          C.body[0].body.length === 0 &&
          (h.length > 1 || !u) &&
          h.pop(),
        v.length < h.length + 1 && v.push([]));
      break;
    } else if (w === `\\\\`) {
      e.consume();
      var T = void 0;
      (e.gullet.future().text !== ` ` && (T = e.parseSizeGroup(!0)),
        g.push(T ? T.value : null),
        x(),
        v.push(es(e)),
        (m = []),
        h.push(m),
        b());
    } else throw new Dn(`Expected & or \\\\ or \\cr or \\end`, e.nextToken);
  }
  return (
    e.gullet.endGroup(),
    e.gullet.endGroup(),
    {
      type: `array`,
      mode: e.mode,
      addJot: i,
      arraystretch: o,
      body: h,
      cols: a,
      rowGaps: g,
      hskipBeforeAndAfter: r,
      hLinesBeforeRow: v,
      colSeparationType: s,
      tags: y,
      leqno: f,
    }
  );
}
function as(e) {
  return e.slice(0, 1) === `d` ? `display` : `text`;
}
var os = function (e, t) {
    var n,
      r,
      i = e.body.length,
      a = e.hLinesBeforeRow,
      o = 0,
      s = Array(i),
      c = [],
      l = Math.max(t.fontMetrics().arrayRuleWidth, t.minRuleThickness),
      u = 1 / t.fontMetrics().ptPerEm,
      d = 5 * u;
    e.colSeparationType &&
      e.colSeparationType === `small` &&
      (d = 0.2778 * (t.havingStyle(ir.SCRIPT).sizeMultiplier / t.sizeMultiplier));
    var f =
        e.colSeparationType === `CD`
          ? Dr(
              {
                number: 3,
                unit: `ex`,
              },
              t,
            )
          : 12 * u,
      p = 3 * u,
      m = e.arraystretch * f,
      h = 0.7 * m,
      g = 0.3 * m,
      v = 0;
    function y(e) {
      for (var t = 0; t < e.length; ++t)
        (t > 0 && (v += 0.25),
          c.push({
            pos: v,
            isDashed: e[t],
          }));
    }
    for (y(a[0]), n = 0; n < e.body.length; ++n) {
      var b = e.body[n],
        x = h,
        S = g;
      o < b.length && (o = b.length);
      var C = {
        cells: Array(b.length),
        height: 0,
        depth: 0,
        pos: 0,
      };
      for (r = 0; r < b.length; ++r) {
        var w = Ea(b[r], t);
        (S < w.depth && (S = w.depth), x < w.height && (x = w.height), (C.cells[r] = w));
      }
      var T = e.rowGaps[n],
        E = 0;
      (T && ((E = Dr(T, t)), E > 0 && ((E += g), S < E && (S = E), (E = 0))),
        e.addJot && n < e.body.length - 1 && (S += p),
        (C.height = x),
        (C.depth = S),
        (v += x),
        (C.pos = v),
        (v += S + E),
        (s[n] = C),
        y(a[n + 1]));
    }
    var D = v / 2 + t.fontMetrics().axisHeight,
      ee = e.cols || [],
      te = [],
      O,
      k,
      ne = [];
    if (e.tags && e.tags.some((e) => e))
      for (n = 0; n < i; ++n) {
        var re = s[n],
          A = re.pos - D,
          ie = e.tags[n],
          j = void 0;
        ((j =
          ie === !0
            ? Xi([`eqn-num`], [], t)
            : ie === !1
              ? Xi([], [], t)
              : Xi([], ba(ie, t, !0), t)),
          (j.depth = re.depth),
          (j.height = re.height),
          ne.push({
            type: `elem`,
            elem: j,
            shift: A,
          }));
      }
    for (r = 0, k = 0; r < o || k < ee.length; ++r, ++k) {
      for (var ae = ee[k], oe = !0; (se = ae)?.type === `separator`;) {
        var se;
        if (
          (oe ||
            ((O = Xi([`arraycolsep`], [])),
            (O.style.width = Or(t.fontMetrics().doubleRuleSep)),
            te.push(O)),
          ae.separator === `|` || ae.separator === `:`)
        ) {
          var ce = ae.separator === `|` ? `solid` : `dashed`,
            le = Xi([`vertical-separator`], [], t);
          ((le.style.height = Or(v)),
            (le.style.borderRightWidth = Or(l)),
            (le.style.borderRightStyle = ce),
            (le.style.margin = `0 ` + Or(-l / 2)));
          var ue = v - D;
          (ue && (le.style.verticalAlign = Or(-ue)), te.push(le));
        } else throw new Dn(`Invalid separator type: ` + ae.separator);
        (k++, (ae = ee[k]), (oe = !1));
      }
      if (!(r >= o)) {
        var de = void 0;
        (r > 0 || e.hskipBeforeAndAfter) &&
          ((de = ae?.pregap ?? d),
          de !== 0 && ((O = Xi([`arraycolsep`], [])), (O.style.width = Or(de)), te.push(O)));
        var fe = [];
        for (n = 0; n < i; ++n) {
          var pe = s[n],
            M = pe.cells[r];
          if (M) {
            var me = pe.pos - D;
            ((M.depth = pe.depth),
              (M.height = pe.height),
              fe.push({
                type: `elem`,
                elem: M,
                shift: me,
              }));
          }
        }
        var N = na({
            positionType: `individualShift`,
            children: fe,
          }),
          P = Xi([`col-align-` + (ae?.align || `c`)], [N]);
        (te.push(P),
          (r < o - 1 || e.hskipBeforeAndAfter) &&
            ((de = ae?.postgap ?? d),
            de !== 0 && ((O = Xi([`arraycolsep`], [])), (O.style.width = Or(de)), te.push(O))));
      }
    }
    var he = Xi([`mtable`], te);
    if (c.length > 0) {
      for (
        var ge = Qi(`hline`, t, l),
          _e = Qi(`hdashline`, t, l),
          ve = [
            {
              type: `elem`,
              elem: he,
              shift: 0,
            },
          ];
        c.length > 0;
      ) {
        var ye = c.pop(),
          F = ye.pos - D;
        ye.isDashed
          ? ve.push({
              type: `elem`,
              elem: _e,
              shift: F,
            })
          : ve.push({
              type: `elem`,
              elem: ge,
              shift: F,
            });
      }
      he = na({
        positionType: `individualShift`,
        children: ve,
      });
    }
    if (ne.length === 0) return Xi([`mord`], [he], t);
    var be = Xi(
      [`tag`],
      [
        na({
          positionType: `individualShift`,
          children: ne,
        }),
      ],
      t,
    );
    return ea([he, be]);
  },
  ss = {
    c: `center `,
    l: `left `,
    r: `right `,
  },
  cs = function (e, t) {
    for (
      var n = [],
        r = new Aa(`mtd`, [], [`mtr-glue`]),
        i = new Aa(`mtd`, [], [`mml-eqn-num`]),
        a = 0;
      a < e.body.length;
      a++
    ) {
      for (var o = e.body[a], s = [], c = 0; c < o.length; c++)
        s.push(new Aa(`mtd`, [za(o[c], t)]));
      (e.tags && e.tags[a] && (s.unshift(r), s.push(r), e.leqno ? s.unshift(i) : s.push(i)),
        n.push(new Aa(`mtr`, s)));
    }
    var l = new Aa(`mtable`, n),
      u = e.arraystretch === 0.5 ? 0.1 : 0.16 + e.arraystretch - 1 + (e.addJot ? 0.09 : 0);
    l.setAttribute(`rowspacing`, Or(u));
    var d = ``,
      f = ``;
    if (e.cols && e.cols.length > 0) {
      var p = e.cols,
        m = ``,
        h = !1,
        g = 0,
        v = p.length;
      (p[0].type === `separator` && ((d += `top `), (g = 1)),
        p[p.length - 1].type === `separator` && ((d += `bottom `), --v));
      for (var y = g; y < v; y++) {
        var b = p[y];
        b.type === `align`
          ? ((f += ss[b.align]), h && (m += `none `), (h = !0))
          : b.type === `separator` &&
            (h &&= ((m += b.separator === `|` ? `solid ` : `dashed `), !1));
      }
      (l.setAttribute(`columnalign`, f.trim()),
        /[sd]/.test(m) && l.setAttribute(`columnlines`, m.trim()));
    }
    if (e.colSeparationType === `align`) {
      for (var x = e.cols || [], S = ``, C = 1; C < x.length; C++) S += C % 2 ? `0em ` : `1em `;
      l.setAttribute(`columnspacing`, S.trim());
    } else
      e.colSeparationType === `alignat` || e.colSeparationType === `gather`
        ? l.setAttribute(`columnspacing`, `0em`)
        : e.colSeparationType === `small`
          ? l.setAttribute(`columnspacing`, `0.2778em`)
          : e.colSeparationType === `CD`
            ? l.setAttribute(`columnspacing`, `0.5em`)
            : l.setAttribute(`columnspacing`, `1em`);
    var w = ``,
      T = e.hLinesBeforeRow;
    ((d += T[0].length > 0 ? `left ` : ``), (d += T[T.length - 1].length > 0 ? `right ` : ``));
    for (var E = 1; E < T.length - 1; E++)
      w += T[E].length === 0 ? `none ` : T[E][0] ? `dashed ` : `solid `;
    return (
      /[sd]/.test(w) && l.setAttribute(`rowlines`, w.trim()),
      d !== `` && ((l = new Aa(`menclose`, [l])), l.setAttribute(`notation`, d.trim())),
      e.arraystretch &&
        e.arraystretch < 1 &&
        ((l = new Aa(`mstyle`, [l])), l.setAttribute(`scriptlevel`, `1`)),
      l
    );
  },
  ls = function (e, t) {
    e.envName.includes(`ed`) || ts(e);
    var n = [],
      r = e.envName === `split`,
      i = is(
        e.parser,
        {
          cols: n,
          addJot: !0,
          autoTag: r ? void 0 : rs(e.envName),
          emptySingleRow: !0,
          colSeparationType: e.envName.includes(`at`) ? `alignat` : `align`,
          maxNumCols: r ? 2 : void 0,
          leqno: e.parser.settings.leqno,
        },
        `display`,
      ),
      a = 0,
      o = 0,
      s = {
        type: `ordgroup`,
        mode: e.mode,
        body: [],
      };
    if (t[0] && t[0].type === `ordgroup`) {
      for (var c = ``, l = 0; l < t[0].body.length; l++) {
        var u = io(t[0].body[l], `textord`);
        c += u.text;
      }
      ((a = Number(c)), (o = a * 2));
    }
    var d = !o;
    i.body.forEach(function (e) {
      for (var t = 1; t < e.length; t += 2)
        io(io(e[t], `styling`).body[0], `ordgroup`).body.unshift(s);
      if (d) o < e.length && (o = e.length);
      else {
        var n = e.length / 2;
        if (a < n)
          throw new Dn(`Too many math in a row: ` + (`expected ` + a + `, but got ` + n), e[0]);
      }
    });
    for (var f = 0; f < o; ++f) {
      var p = `r`,
        m = 0;
      (f % 2 == 1 ? (p = `l`) : f > 0 && d && (m = 1),
        (n[f] = {
          type: `align`,
          align: p,
          pregap: m,
          postgap: 0,
        }));
    }
    return ((i.colSeparationType = d ? `align` : `alignat`), i);
  };
(Xo({
  type: `array`,
  names: [`array`, `darray`],
  props: {
    numArgs: 1,
  },
  handler(e, t) {
    var n = (oo(t[0]) ? [t[0]] : io(t[0], `ordgroup`).body).map(function (e) {
        var t = ao(e).text;
        if (`lcr`.includes(t))
          return {
            type: `align`,
            align: t,
          };
        if (t === `|`)
          return {
            type: `separator`,
            separator: `|`,
          };
        if (t === `:`)
          return {
            type: `separator`,
            separator: `:`,
          };
        throw new Dn(`Unknown column alignment: ` + t, e);
      }),
      r = {
        cols: n,
        hskipBeforeAndAfter: !0,
        maxNumCols: n.length,
      };
    return is(e.parser, r, as(e.envName));
  },
  htmlBuilder: os,
  mathmlBuilder: cs,
}),
  Xo({
    type: `array`,
    names: [
      `matrix`,
      `pmatrix`,
      `bmatrix`,
      `Bmatrix`,
      `vmatrix`,
      `Vmatrix`,
      `matrix*`,
      `pmatrix*`,
      `bmatrix*`,
      `Bmatrix*`,
      `vmatrix*`,
      `Vmatrix*`,
    ],
    props: {
      numArgs: 0,
    },
    handler(e) {
      var t = {
          matrix: null,
          pmatrix: [`(`, `)`],
          bmatrix: [`[`, `]`],
          Bmatrix: [`\\{`, `\\}`],
          vmatrix: [`|`, `|`],
          Vmatrix: [`\\Vert`, `\\Vert`],
        }[e.envName.replace(`*`, ``)],
        n = `c`,
        r = {
          hskipBeforeAndAfter: !1,
          cols: [
            {
              type: `align`,
              align: n,
            },
          ],
        };
      if (e.envName.charAt(e.envName.length - 1) === `*`) {
        var i = e.parser;
        if ((i.consumeSpaces(), i.fetch().text === `[`)) {
          if ((i.consume(), i.consumeSpaces(), (n = i.fetch().text), !`lcr`.includes(n)))
            throw new Dn(`Expected l or c or r`, i.nextToken);
          (i.consume(),
            i.consumeSpaces(),
            i.expect(`]`),
            i.consume(),
            (r.cols = [
              {
                type: `align`,
                align: n,
              },
            ]));
        }
      }
      var a = is(e.parser, r, as(e.envName)),
        o = Math.max(0, ...a.body.map((e) => e.length));
      return (
        (a.cols = Array(o).fill({
          type: `align`,
          align: n,
        })),
        t
          ? {
              type: `leftright`,
              mode: e.mode,
              body: [a],
              left: t[0],
              right: t[1],
              rightColor: void 0,
            }
          : a
      );
    },
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`smallmatrix`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      var t = is(
        e.parser,
        {
          arraystretch: 0.5,
        },
        `script`,
      );
      return ((t.colSeparationType = `small`), t);
    },
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`subarray`],
    props: {
      numArgs: 1,
    },
    handler(e, t) {
      var n = (oo(t[0]) ? [t[0]] : io(t[0], `ordgroup`).body).map(function (e) {
        var t = ao(e).text;
        if (`lc`.includes(t))
          return {
            type: `align`,
            align: t,
          };
        throw new Dn(`Unknown column alignment: ` + t, e);
      });
      if (n.length > 1) throw new Dn(`{subarray} can contain only one column`);
      var r = {
          cols: n,
          hskipBeforeAndAfter: !1,
          arraystretch: 0.5,
        },
        i = is(e.parser, r, `script`);
      if (i.body.length > 0 && i.body[0].length > 1)
        throw new Dn(`{subarray} can contain only one column`);
      return i;
    },
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`cases`, `dcases`, `rcases`, `drcases`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      var t = is(
        e.parser,
        {
          arraystretch: 1.2,
          cols: [
            {
              type: `align`,
              align: `l`,
              pregap: 0,
              postgap: 1,
            },
            {
              type: `align`,
              align: `l`,
              pregap: 0,
              postgap: 0,
            },
          ],
        },
        as(e.envName),
      );
      return {
        type: `leftright`,
        mode: e.mode,
        body: [t],
        left: e.envName.includes(`r`) ? `.` : `\\{`,
        right: e.envName.includes(`r`) ? `\\}` : `.`,
        rightColor: void 0,
      };
    },
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`align`, `align*`, `aligned`, `split`],
    props: {
      numArgs: 0,
    },
    handler: ls,
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`gathered`, `gather`, `gather*`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      ns.has(e.envName) && ts(e);
      var t = {
        cols: [
          {
            type: `align`,
            align: `c`,
          },
        ],
        addJot: !0,
        colSeparationType: `gather`,
        autoTag: rs(e.envName),
        emptySingleRow: !0,
        leqno: e.parser.settings.leqno,
      };
      return is(e.parser, t, `display`);
    },
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`alignat`, `alignat*`, `alignedat`],
    props: {
      numArgs: 1,
    },
    handler: ls,
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`equation`, `equation*`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      ts(e);
      var t = {
        autoTag: rs(e.envName),
        emptySingleRow: !0,
        singleRow: !0,
        maxNumCols: 1,
        leqno: e.parser.settings.leqno,
      };
      return is(e.parser, t, `display`);
    },
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Xo({
    type: `array`,
    names: [`CD`],
    props: {
      numArgs: 0,
    },
    handler(e) {
      return (ts(e), mo(e.parser));
    },
    htmlBuilder: os,
    mathmlBuilder: cs,
  }),
  Q(`\\nonumber`, `\\gdef\\@eqnsw{0}`),
  Q(`\\notag`, `\\nonumber`),
  ma({
    type: `text`,
    names: [`\\hline`, `\\hdashline`],
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0,
    handler(e, t) {
      throw new Dn(e.funcName + ` valid only within array environment`);
    },
  }));
var us = Yo;
ma({
  type: `environment`,
  names: [`\\begin`, `\\end`],
  numArgs: 1,
  argTypes: [`text`],
  handler(e, t) {
    var { parser: n, funcName: r } = e,
      i = t[0];
    if (i.type !== `ordgroup`) throw new Dn(`Invalid environment name`, i);
    for (var a = ``, o = 0; o < i.body.length; ++o) a += io(i.body[o], `textord`).text;
    if (r === `\\begin`) {
      if (!us.hasOwnProperty(a)) throw new Dn(`No such environment: ` + a, i);
      var s = us[a],
        { args: c, optArgs: l } = n.parseArguments(`\\begin{` + a + `}`, s),
        u = {
          mode: n.mode,
          envName: a,
          parser: n,
        },
        d = s.handler(u, c, l);
      n.expect(`\\end`, !1);
      var f = n.nextToken,
        p = io(n.parseFunction(), `environment`);
      if (p.name !== a)
        throw new Dn(`Mismatch: \\begin{` + a + `} matched by \\end{` + p.name + `}`, f);
      return d;
    }
    return {
      type: `environment`,
      mode: n.mode,
      name: a,
      nameGroup: i,
    };
  },
});
var ds = (e, t) => {
    var n = e.font,
      r = t.withFont(n);
    return Ea(e.body, r);
  },
  fs = (e, t) => {
    var n = e.font,
      r = t.withFont(n);
    return za(e.body, r);
  },
  ps = {
    "\\Bbb": `\\mathbb`,
    "\\bold": `\\mathbf`,
    "\\frak": `\\mathfrak`,
  };
(ma({
  type: `font`,
  names: [
    `\\mathrm`,
    `\\mathit`,
    `\\mathbf`,
    `\\mathnormal`,
    `\\mathsfit`,
    `\\mathbb`,
    `\\mathcal`,
    `\\mathfrak`,
    `\\mathscr`,
    `\\mathsf`,
    `\\mathtt`,
    `\\Bbb`,
    `\\bold`,
    `\\frak`,
  ],
  numArgs: 1,
  allowedInArgument: !0,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = ga(t[0]),
      a = r in ps ? ps[r] : r;
    return {
      type: `font`,
      mode: n.mode,
      font: a.slice(1),
      body: i,
    };
  },
  htmlBuilder: ds,
  mathmlBuilder: fs,
}),
  ma({
    type: `mclass`,
    names: [`\\boldsymbol`, `\\bm`],
    numArgs: 1,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `mclass`,
        mode: n.mode,
        mclass: uo(r),
        body: [
          {
            type: `font`,
            mode: n.mode,
            font: `boldsymbol`,
            body: r,
          },
        ],
        isCharacterBox: Fn(r),
      };
    },
  }),
  ma({
    type: `font`,
    names: [`\\rm`, `\\sf`, `\\tt`, `\\bf`, `\\it`, `\\cal`],
    numArgs: 0,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n, funcName: r, breakOnTokenText: i } = e,
        { mode: a } = n,
        o = n.parseExpression(!0, i);
      return {
        type: `font`,
        mode: a,
        font: `math` + r.slice(1),
        body: {
          type: `ordgroup`,
          mode: n.mode,
          body: o,
        },
      };
    },
  }));
var ms = (e, t) => {
    var n = t.style,
      r = n.fracNum(),
      i = n.fracDen(),
      a = t.havingStyle(r),
      o = Ea(e.numer, a, t);
    if (e.continued) {
      var s = 8.5 / t.fontMetrics().ptPerEm,
        c = 3.5 / t.fontMetrics().ptPerEm;
      ((o.height = o.height < s ? s : o.height), (o.depth = o.depth < c ? c : o.depth));
    }
    a = t.havingStyle(i);
    var l = Ea(e.denom, a, t),
      u,
      d,
      f;
    e.hasBarLine
      ? (e.barSize
          ? ((d = Dr(e.barSize, t)), (u = Qi(`frac-line`, t, d)))
          : (u = Qi(`frac-line`, t)),
        (d = u.height),
        (f = u.height))
      : ((u = null), (d = 0), (f = t.fontMetrics().defaultRuleThickness));
    var p, m, h;
    n.size === ir.DISPLAY.size
      ? ((p = t.fontMetrics().num1), (m = d > 0 ? 3 * f : 7 * f), (h = t.fontMetrics().denom1))
      : (d > 0 ? ((p = t.fontMetrics().num2), (m = f)) : ((p = t.fontMetrics().num3), (m = 3 * f)),
        (h = t.fontMetrics().denom2));
    var g;
    if (u) {
      var v = t.fontMetrics().axisHeight;
      (p - o.depth - (v + 0.5 * d) < m && (p += m - (p - o.depth - (v + 0.5 * d))),
        v - 0.5 * d - (l.height - h) < m && (h += m - (v - 0.5 * d - (l.height - h))));
      var y = -(v - 0.5 * d);
      g = na({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: l,
            shift: h,
          },
          {
            type: `elem`,
            elem: u,
            shift: y,
          },
          {
            type: `elem`,
            elem: o,
            shift: -p,
          },
        ],
      });
    } else {
      var b = p - o.depth - (l.height - h);
      (b < m && ((p += 0.5 * (m - b)), (h += 0.5 * (m - b))),
        (g = na({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: l,
              shift: h,
            },
            {
              type: `elem`,
              elem: o,
              shift: -p,
            },
          ],
        })));
    }
    ((a = t.havingStyle(n)),
      (g.height *= a.sizeMultiplier / t.sizeMultiplier),
      (g.depth *= a.sizeMultiplier / t.sizeMultiplier));
    var x =
        n.size === ir.DISPLAY.size
          ? t.fontMetrics().delim1
          : n.size === ir.SCRIPTSCRIPT.size
            ? t.havingStyle(ir.SCRIPT).fontMetrics().delim2
            : t.fontMetrics().delim2,
      S =
        e.leftDelim == null
          ? Ta(t, [`mopen`])
          : Uo(e.leftDelim, x, !0, t.havingStyle(n), e.mode, [`mopen`]),
      C = e.continued
        ? Xi([])
        : e.rightDelim == null
          ? Ta(t, [`mclose`])
          : Uo(e.rightDelim, x, !0, t.havingStyle(n), e.mode, [`mclose`]);
    return Xi([`mord`].concat(a.sizingClasses(t)), [S, Xi([`mfrac`], [g]), C], t);
  },
  hs = (e, t) => {
    var n = new Aa(`mfrac`, [za(e.numer, t), za(e.denom, t)]);
    if (!e.hasBarLine) n.setAttribute(`linethickness`, `0px`);
    else if (e.barSize) {
      var r = Dr(e.barSize, t);
      n.setAttribute(`linethickness`, Or(r));
    }
    if (e.leftDelim != null || e.rightDelim != null) {
      var i = [];
      if (e.leftDelim != null) {
        var a = new Aa(`mo`, [new ja(e.leftDelim.replace(`\\`, ``))]);
        (a.setAttribute(`fence`, `true`), i.push(a));
      }
      if ((i.push(n), e.rightDelim != null)) {
        var o = new Aa(`mo`, [new ja(e.rightDelim.replace(`\\`, ``))]);
        (o.setAttribute(`fence`, `true`), i.push(o));
      }
      return Pa(i);
    }
    return n;
  },
  gs = (e, t) =>
    t
      ? {
          type: `styling`,
          mode: e.mode,
          style: t,
          body: [e],
        }
      : e;
(ma({
  type: `genfrac`,
  names: [
    `\\cfrac`,
    `\\dfrac`,
    `\\frac`,
    `\\tfrac`,
    `\\dbinom`,
    `\\binom`,
    `\\tbinom`,
    `\\\\atopfrac`,
    `\\\\bracefrac`,
    `\\\\brackfrac`,
  ],
  numArgs: 2,
  allowedInArgument: !0,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = t[0],
      a = t[1],
      o,
      s = null,
      c = null;
    switch (r) {
      case `\\cfrac`:
      case `\\dfrac`:
      case `\\frac`:
      case `\\tfrac`:
        o = !0;
        break;
      case `\\\\atopfrac`:
        o = !1;
        break;
      case `\\dbinom`:
      case `\\binom`:
      case `\\tbinom`:
        ((o = !1), (s = `(`), (c = `)`));
        break;
      case `\\\\bracefrac`:
        ((o = !1), (s = `\\{`), (c = `\\}`));
        break;
      case `\\\\brackfrac`:
        ((o = !1), (s = `[`), (c = `]`));
        break;
      default:
        throw Error(`Unrecognized genfrac command`);
    }
    var l = r === `\\cfrac`,
      u = null;
    return (
      l || r.startsWith(`\\d`) ? (u = `display`) : r.startsWith(`\\t`) && (u = `text`),
      gs(
        {
          type: `genfrac`,
          mode: n.mode,
          numer: i,
          denom: a,
          continued: l,
          hasBarLine: o,
          leftDelim: s,
          rightDelim: c,
          barSize: null,
        },
        u,
      )
    );
  },
  htmlBuilder: ms,
  mathmlBuilder: hs,
}),
  ma({
    type: `infix`,
    names: [`\\over`, `\\choose`, `\\atop`, `\\brace`, `\\brack`],
    numArgs: 0,
    infix: !0,
    handler(e) {
      var { parser: t, funcName: n, token: r } = e,
        i;
      switch (n) {
        case `\\over`:
          i = `\\frac`;
          break;
        case `\\choose`:
          i = `\\binom`;
          break;
        case `\\atop`:
          i = `\\\\atopfrac`;
          break;
        case `\\brace`:
          i = `\\\\bracefrac`;
          break;
        case `\\brack`:
          i = `\\\\brackfrac`;
          break;
        default:
          throw Error(`Unrecognized infix genfrac command`);
      }
      return {
        type: `infix`,
        mode: t.mode,
        replaceWith: i,
        token: r,
      };
    },
  }));
var _s = [`display`, `text`, `script`, `scriptscript`],
  vs = function (e) {
    var t = null;
    return (e.length > 0 && ((t = e), (t = t === `.` ? null : t)), t);
  };
(ma({
  type: `genfrac`,
  names: [`\\genfrac`],
  numArgs: 6,
  allowedInArgument: !0,
  argTypes: [`math`, `math`, `size`, `text`, `math`, `math`],
  handler(e, t) {
    var { parser: n } = e,
      r = t[4],
      i = t[5],
      a = ga(t[0]),
      o = a.type === `atom` && a.family === `open` ? vs(a.text) : null,
      s = ga(t[1]),
      c = s.type === `atom` && s.family === `close` ? vs(s.text) : null,
      l = io(t[2], `size`),
      u,
      d = null;
    l.isBlank ? (u = !0) : ((d = l.value), (u = d.number > 0));
    var f = null,
      p = t[3];
    if (p.type === `ordgroup`) {
      if (p.body.length > 0) {
        var m = io(p.body[0], `textord`);
        f = _s[Number(m.text)];
      }
    } else ((p = io(p, `textord`)), (f = _s[Number(p.text)]));
    return gs(
      {
        type: `genfrac`,
        mode: n.mode,
        numer: r,
        denom: i,
        continued: !1,
        hasBarLine: u,
        barSize: d,
        leftDelim: o,
        rightDelim: c,
      },
      f,
    );
  },
}),
  ma({
    type: `infix`,
    names: [`\\above`],
    numArgs: 1,
    argTypes: [`size`],
    infix: !0,
    handler(e, t) {
      var { parser: n, funcName: r, token: i } = e;
      return {
        type: `infix`,
        mode: n.mode,
        replaceWith: `\\\\abovefrac`,
        size: io(t[0], `size`).value,
        token: i,
      };
    },
  }),
  ma({
    type: `genfrac`,
    names: [`\\\\abovefrac`],
    numArgs: 3,
    argTypes: [`math`, `size`, `math`],
    handler: (e, t) => {
      var { parser: n, funcName: r } = e,
        i = t[0],
        a = io(t[1], `infix`).size;
      if (!a) throw Error(`\\\\abovefrac expected size, but got ` + String(a));
      var o = t[2],
        s = a.number > 0;
      return {
        type: `genfrac`,
        mode: n.mode,
        numer: i,
        denom: o,
        continued: !1,
        hasBarLine: s,
        barSize: a,
        leftDelim: null,
        rightDelim: null,
      };
    },
  }));
var ys = (e, t) => {
  var n = t.style,
    r,
    i;
  e.type === `supsub`
    ? ((r = e.sup ? Ea(e.sup, t.havingStyle(n.sup()), t) : Ea(e.sub, t.havingStyle(n.sub()), t)),
      (i = io(e.base, `horizBrace`)))
    : (i = io(e, `horizBrace`));
  var a = Ea(i.base, t.havingBaseStyle(ir.DISPLAY)),
    o = $a(i, t),
    s = i.isOver
      ? na({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: a,
            },
            {
              type: `kern`,
              size: 0.1,
            },
            {
              type: `elem`,
              elem: o,
              wrapperClasses: [`svg-align`],
            },
          ],
        })
      : na({
          positionType: `bottom`,
          positionData: a.depth + 0.1 + o.height,
          children: [
            {
              type: `elem`,
              elem: o,
              wrapperClasses: [`svg-align`],
            },
            {
              type: `kern`,
              size: 0.1,
            },
            {
              type: `elem`,
              elem: a,
            },
          ],
        });
  if (r) {
    var c = Xi([`minner`, i.isOver ? `mover` : `munder`], [s], t);
    s = i.isOver
      ? na({
          positionType: `firstBaseline`,
          children: [
            {
              type: `elem`,
              elem: c,
            },
            {
              type: `kern`,
              size: 0.2,
            },
            {
              type: `elem`,
              elem: r,
            },
          ],
        })
      : na({
          positionType: `bottom`,
          positionData: c.depth + 0.2 + r.height + r.depth,
          children: [
            {
              type: `elem`,
              elem: r,
            },
            {
              type: `kern`,
              size: 0.2,
            },
            {
              type: `elem`,
              elem: c,
            },
          ],
        });
  }
  return Xi([`minner`, i.isOver ? `mover` : `munder`], [s], t);
};
(ma({
  type: `horizBrace`,
  names: [`\\overbrace`, `\\underbrace`, `\\overbracket`, `\\underbracket`],
  numArgs: 1,
  handler(e, t) {
    var { parser: n, funcName: r } = e;
    return {
      type: `horizBrace`,
      mode: n.mode,
      label: r,
      isOver: r.includes(`\\over`),
      base: t[0],
    };
  },
  htmlBuilder: ys,
  mathmlBuilder: (e, t) => {
    var n = Xa(e.label);
    return new Aa(e.isOver ? `mover` : `munder`, [za(e.base, t), n]);
  },
}),
  ma({
    type: `href`,
    names: [`\\href`],
    numArgs: 2,
    argTypes: [`url`, `original`],
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[1],
        i = io(t[0], `url`).url;
      return n.settings.isTrusted({
        command: `\\href`,
        url: i,
      })
        ? {
            type: `href`,
            mode: n.mode,
            href: i,
            body: _a(r),
          }
        : n.formatUnsupportedCmd(`\\href`);
    },
    htmlBuilder: (e, t) => {
      var n = ba(e.body, t, !1);
      return $i(e.href, [], n, t);
    },
    mathmlBuilder: (e, t) => {
      var n = Ra(e.body, t);
      return (n instanceof Aa || (n = new Aa(`mrow`, [n])), n.setAttribute(`href`, e.href), n);
    },
  }),
  ma({
    type: `href`,
    names: [`\\url`],
    numArgs: 1,
    argTypes: [`url`],
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = io(t[0], `url`).url;
      if (
        !n.settings.isTrusted({
          command: `\\url`,
          url: r,
        })
      )
        return n.formatUnsupportedCmd(`\\url`);
      for (var i = [], a = 0; a < r.length; a++) {
        var o = r[a];
        (o === `~` && (o = `\\textasciitilde`),
          i.push({
            type: `textord`,
            mode: `text`,
            text: o,
          }));
      }
      var s = {
        type: `text`,
        mode: n.mode,
        font: `\\texttt`,
        body: i,
      };
      return {
        type: `href`,
        mode: n.mode,
        href: r,
        body: _a(s),
      };
    },
  }),
  ma({
    type: `hbox`,
    names: [`\\hbox`],
    numArgs: 1,
    argTypes: [`text`],
    allowedInText: !0,
    primitive: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `hbox`,
        mode: n.mode,
        body: _a(t[0]),
      };
    },
    htmlBuilder(e, t) {
      return ea(ba(e.body, t.withFont(``), !1));
    },
    mathmlBuilder(e, t) {
      return new Aa(`mrow`, La(e.body, t.withFont(``)));
    },
  }),
  ma({
    type: `html`,
    names: [`\\htmlClass`, `\\htmlId`, `\\htmlStyle`, `\\htmlData`],
    numArgs: 2,
    argTypes: [`raw`, `original`],
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n, funcName: r, token: i } = e,
        a = io(t[0], `raw`).string,
        o = t[1];
      n.settings.strict &&
        n.settings.reportNonstrict(`htmlExtension`, `HTML extension is disabled on strict mode`);
      var s,
        c = {};
      switch (r) {
        case `\\htmlClass`:
          ((c.class = a),
            (s = {
              command: `\\htmlClass`,
              class: a,
            }));
          break;
        case `\\htmlId`:
          ((c.id = a),
            (s = {
              command: `\\htmlId`,
              id: a,
            }));
          break;
        case `\\htmlStyle`:
          ((c.style = a),
            (s = {
              command: `\\htmlStyle`,
              style: a,
            }));
          break;
        case `\\htmlData`:
          for (var l = a.split(`,`), u = 0; u < l.length; u++) {
            var d = l[u],
              f = d.indexOf(`=`);
            if (f < 0) throw new Dn(`\\htmlData key/value '` + d + `' missing equals sign`);
            var p = d.slice(0, f),
              m = d.slice(f + 1);
            c[`data-` + p.trim()] = m;
          }
          s = {
            command: `\\htmlData`,
            attributes: c,
          };
          break;
        default:
          throw Error(`Unrecognized html command`);
      }
      return n.settings.isTrusted(s)
        ? {
            type: `html`,
            mode: n.mode,
            attributes: c,
            body: _a(o),
          }
        : n.formatUnsupportedCmd(r);
    },
    htmlBuilder: (e, t) => {
      var n = ba(e.body, t, !1),
        r = [`enclosing`];
      e.attributes.class && r.push(...e.attributes.class.trim().split(/\s+/));
      var i = Xi(r, n, t);
      for (var a in e.attributes)
        a !== `class` && e.attributes.hasOwnProperty(a) && i.setAttribute(a, e.attributes[a]);
      return i;
    },
    mathmlBuilder: (e, t) => Ra(e.body, t),
  }),
  ma({
    type: `htmlmathml`,
    names: [`\\html@mathml`],
    numArgs: 2,
    allowedInArgument: !0,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e;
      return {
        type: `htmlmathml`,
        mode: n.mode,
        html: _a(t[0]),
        mathml: _a(t[1]),
      };
    },
    htmlBuilder: (e, t) => ea(ba(e.html, t, !1)),
    mathmlBuilder: (e, t) => Ra(e.mathml, t),
  }));
var bs = function (e) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(e))
    return {
      number: +e,
      unit: `bp`,
    };
  var t = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(e);
  if (!t) throw new Dn(`Invalid size: '` + e + `' in \\includegraphics`);
  var n = {
    number: +(t[1] + t[2]),
    unit: t[3],
  };
  if (!Er(n)) throw new Dn(`Invalid unit: '` + n.unit + `' in \\includegraphics.`);
  return n;
};
(ma({
  type: `includegraphics`,
  names: [`\\includegraphics`],
  numArgs: 1,
  numOptionalArgs: 1,
  argTypes: [`raw`, `url`],
  allowedInText: !1,
  handler: (e, t, n) => {
    var { parser: r } = e,
      i = {
        number: 0,
        unit: `em`,
      },
      a = {
        number: 0.9,
        unit: `em`,
      },
      o = {
        number: 0,
        unit: `em`,
      },
      s = ``;
    if (n[0])
      for (var c = io(n[0], `raw`).string.split(`,`), l = 0; l < c.length; l++) {
        var u = c[l].split(`=`);
        if (u.length === 2) {
          var d = u[1].trim();
          switch (u[0].trim()) {
            case `alt`:
              s = d;
              break;
            case `width`:
              i = bs(d);
              break;
            case `height`:
              a = bs(d);
              break;
            case `totalheight`:
              o = bs(d);
              break;
            default:
              throw new Dn(`Invalid key: '` + u[0] + `' in \\includegraphics.`);
          }
        }
      }
    var f = io(t[0], `url`).url;
    return (
      s === `` &&
        ((s = f), (s = s.replace(/^.*[\\/]/, ``)), (s = s.substring(0, s.lastIndexOf(`.`)))),
      r.settings.isTrusted({
        command: `\\includegraphics`,
        url: f,
      })
        ? {
            type: `includegraphics`,
            mode: r.mode,
            alt: s,
            width: i,
            height: a,
            totalheight: o,
            src: f,
          }
        : r.formatUnsupportedCmd(`\\includegraphics`)
    );
  },
  htmlBuilder: (e, t) => {
    var n = Dr(e.height, t),
      r = 0;
    e.totalheight.number > 0 && (r = Dr(e.totalheight, t) - n);
    var i = 0;
    e.width.number > 0 && (i = Dr(e.width, t));
    var a = {
      height: Or(n + r),
    };
    (i > 0 && (a.width = Or(i)), r > 0 && (a.verticalAlign = Or(-r)));
    var o = new Lr(e.src, e.alt, a);
    return ((o.height = n), (o.depth = r), o);
  },
  mathmlBuilder: (e, t) => {
    var n = new Aa(`mglyph`, []);
    n.setAttribute(`alt`, e.alt);
    var r = Dr(e.height, t),
      i = 0;
    if (
      (e.totalheight.number > 0 &&
        ((i = Dr(e.totalheight, t) - r), n.setAttribute(`valign`, Or(-i))),
      n.setAttribute(`height`, Or(r + i)),
      e.width.number > 0)
    ) {
      var a = Dr(e.width, t);
      n.setAttribute(`width`, Or(a));
    }
    return (n.setAttribute(`src`, e.src), n);
  },
}),
  ma({
    type: `kern`,
    names: [`\\kern`, `\\mkern`, `\\hskip`, `\\mskip`],
    numArgs: 1,
    argTypes: [`size`],
    primitive: !0,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n, funcName: r } = e,
        i = io(t[0], `size`);
      if (n.settings.strict) {
        var a = r[1] === `m`,
          o = i.value.unit === `mu`;
        a
          ? (o ||
              n.settings.reportNonstrict(
                `mathVsTextUnits`,
                `LaTeX's ` + r + ` supports only mu units, ` + (`not ` + i.value.unit + ` units`),
              ),
            n.mode !== `math` &&
              n.settings.reportNonstrict(
                `mathVsTextUnits`,
                `LaTeX's ` + r + ` works only in math mode`,
              ))
          : o &&
            n.settings.reportNonstrict(
              `mathVsTextUnits`,
              `LaTeX's ` + r + ` doesn't support mu units`,
            );
      }
      return {
        type: `kern`,
        mode: n.mode,
        dimension: i.value,
      };
    },
    htmlBuilder(e, t) {
      return ra(e.dimension, t);
    },
    mathmlBuilder(e, t) {
      return new Ma(Dr(e.dimension, t));
    },
  }),
  ma({
    type: `lap`,
    names: [`\\mathllap`, `\\mathrlap`, `\\mathclap`],
    numArgs: 1,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n, funcName: r } = e,
        i = t[0];
      return {
        type: `lap`,
        mode: n.mode,
        alignment: r.slice(5),
        body: i,
      };
    },
    htmlBuilder: (e, t) => {
      var n;
      e.alignment === `clap`
        ? ((n = Xi([], [Ea(e.body, t)])), (n = Xi([`inner`], [n], t)))
        : (n = Xi([`inner`], [Ea(e.body, t)]));
      var r = Xi([`fix`], []),
        i = Xi([e.alignment], [n, r], t),
        a = Xi([`strut`]);
      return (
        (a.style.height = Or(i.height + i.depth)),
        i.depth && (a.style.verticalAlign = Or(-i.depth)),
        i.children.unshift(a),
        (i = Xi([`thinbox`], [i], t)),
        Xi([`mord`, `vbox`], [i], t)
      );
    },
    mathmlBuilder: (e, t) => {
      var n = new Aa(`mpadded`, [za(e.body, t)]);
      if (e.alignment !== `rlap`) {
        var r = e.alignment === `llap` ? `-1` : `-0.5`;
        n.setAttribute(`lspace`, r + `width`);
      }
      return (n.setAttribute(`width`, `0px`), n);
    },
  }),
  ma({
    type: `styling`,
    names: [`\\(`, `$`],
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1,
    handler(e, t) {
      var { funcName: n, parser: r } = e,
        i = r.mode;
      r.switchMode(`math`);
      var a = n === `\\(` ? `\\)` : `$`,
        o = r.parseExpression(!1, a);
      return (
        r.expect(a),
        r.switchMode(i),
        {
          type: `styling`,
          mode: r.mode,
          style: `text`,
          resetFont: !0,
          body: o,
        }
      );
    },
  }),
  ma({
    type: `text`,
    names: [`\\)`, `\\]`],
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1,
    handler(e, t) {
      throw new Dn(`Mismatched ` + e.funcName);
    },
  }));
var xs = (e, t) => {
  switch (t.style.size) {
    case ir.DISPLAY.size:
      return e.display;
    case ir.TEXT.size:
      return e.text;
    case ir.SCRIPT.size:
      return e.script;
    case ir.SCRIPTSCRIPT.size:
      return e.scriptscript;
    default:
      return e.text;
  }
};
ma({
  type: `mathchoice`,
  names: [`\\mathchoice`],
  numArgs: 4,
  primitive: !0,
  handler: (e, t) => {
    var { parser: n } = e;
    return {
      type: `mathchoice`,
      mode: n.mode,
      display: _a(t[0]),
      text: _a(t[1]),
      script: _a(t[2]),
      scriptscript: _a(t[3]),
    };
  },
  htmlBuilder: (e, t) => ea(ba(xs(e, t), t, !1)),
  mathmlBuilder: (e, t) => Ra(xs(e, t), t),
});
var Ss = (e, t, n, r, i, a, o) => {
    e = Xi([], [e]);
    var s = n && Fn(n),
      c,
      l;
    if (t) {
      var u = Ea(t, r.havingStyle(i.sup()), r);
      l = {
        elem: u,
        kern: Math.max(r.fontMetrics().bigOpSpacing1, r.fontMetrics().bigOpSpacing3 - u.depth),
      };
    }
    if (n) {
      var d = Ea(n, r.havingStyle(i.sub()), r);
      c = {
        elem: d,
        kern: Math.max(r.fontMetrics().bigOpSpacing2, r.fontMetrics().bigOpSpacing4 - d.height),
      };
    }
    var f;
    if (l && c)
      f = na({
        positionType: `bottom`,
        positionData:
          r.fontMetrics().bigOpSpacing5 + c.elem.height + c.elem.depth + c.kern + e.depth + o,
        children: [
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
          {
            type: `elem`,
            elem: c.elem,
            marginLeft: Or(-a),
          },
          {
            type: `kern`,
            size: c.kern,
          },
          {
            type: `elem`,
            elem: e,
          },
          {
            type: `kern`,
            size: l.kern,
          },
          {
            type: `elem`,
            elem: l.elem,
            marginLeft: Or(a),
          },
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
        ],
      });
    else if (c)
      f = na({
        positionType: `top`,
        positionData: e.height - o,
        children: [
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
          {
            type: `elem`,
            elem: c.elem,
            marginLeft: Or(-a),
          },
          {
            type: `kern`,
            size: c.kern,
          },
          {
            type: `elem`,
            elem: e,
          },
        ],
      });
    else if (l)
      f = na({
        positionType: `bottom`,
        positionData: e.depth + o,
        children: [
          {
            type: `elem`,
            elem: e,
          },
          {
            type: `kern`,
            size: l.kern,
          },
          {
            type: `elem`,
            elem: l.elem,
            marginLeft: Or(a),
          },
          {
            type: `kern`,
            size: r.fontMetrics().bigOpSpacing5,
          },
        ],
      });
    else return e;
    var p = [f];
    if (c && a !== 0 && !s) {
      var m = Xi([`mspace`], [], r);
      ((m.style.marginRight = Or(a)), p.unshift(m));
    }
    return Xi([`mop`, `op-limits`], p, r);
  },
  Cs = new Set([`\\smallint`]),
  ws = (e, t) => {
    var n,
      r,
      i = !1,
      a;
    e.type === `supsub`
      ? ((n = e.sup), (r = e.sub), (a = io(e.base, `op`)), (i = !0))
      : (a = io(e, `op`));
    var o = t.style,
      s = !1;
    o.size === ir.DISPLAY.size && a.symbol && !Cs.has(a.name) && (s = !0);
    var c, l;
    if (a.symbol) {
      var u = s ? `Size2-Regular` : `Size1-Regular`,
        d = ``;
      if (
        ((a.name === `\\oiint` || a.name === `\\oiiint`) &&
          ((d = a.name.slice(1)), (a.name = d === `oiint` ? `\\iint` : `\\iiint`)),
        (c = Wi(a.name, u, `math`, t, [`mop`, `op-symbol`, s ? `large-op` : `small-op`])),
        (l = c.italic),
        d.length > 0)
      ) {
        var f = sa(d + `Size` + (s ? `2` : `1`), t);
        ((c = na({
          positionType: `individualShift`,
          children: [
            {
              type: `elem`,
              elem: c,
              shift: 0,
            },
            {
              type: `elem`,
              elem: f,
              shift: s ? 0.08 : 0,
            },
          ],
        })),
          (a.name = `\\` + d),
          c.classes.unshift(`mop`),
          (c.italic = l));
      }
    } else if (a.body) {
      var p = ba(a.body, t, !0);
      p.length === 1 && p[0] instanceof zr
        ? ((c = p[0]), (c.classes[0] = `mop`))
        : (c = Xi([`mop`], p, t));
    } else {
      for (var m = [], h = 1; h < a.name.length; h++) m.push(Gi(a.name[h], a.mode, t));
      c = Xi([`mop`], m, t);
    }
    var g = 0,
      v = 0;
    return (
      (c instanceof zr || a.name === `\\oiint` || a.name === `\\oiiint`) &&
        !a.suppressBaseShift &&
        ((g = (c.height - c.depth) / 2 - t.fontMetrics().axisHeight), (v = c.italic ?? 0)),
      i
        ? Ss(c, n, r, t, o, v, g)
        : (g && ((c.style.position = `relative`), (c.style.top = Or(g))), c)
    );
  },
  Ts = (e, t) => {
    var n;
    if (e.symbol)
      ((n = new Aa(`mo`, [Na(e.name, e.mode)])),
        Cs.has(e.name) && n.setAttribute(`largeop`, `false`));
    else if (e.body) n = new Aa(`mo`, La(e.body, t));
    else {
      n = new Aa(`mi`, [new ja(e.name.slice(1))]);
      var r = new Aa(`mo`, [Na(`⁡`, `text`)]);
      n = e.parentIsSupSub ? new Aa(`mrow`, [n, r]) : ka([n, r]);
    }
    return n;
  },
  Es = {
    "∏": `\\prod`,
    "∐": `\\coprod`,
    "∑": `\\sum`,
    "⋀": `\\bigwedge`,
    "⋁": `\\bigvee`,
    "⋂": `\\bigcap`,
    "⋃": `\\bigcup`,
    "⨀": `\\bigodot`,
    "⨁": `\\bigoplus`,
    "⨂": `\\bigotimes`,
    "⨄": `\\biguplus`,
    "⨆": `\\bigsqcup`,
  };
(ma({
  type: `op`,
  names:
    `\\coprod.\\bigvee.\\bigwedge.\\biguplus.\\bigcap.\\bigcup.\\intop.\\prod.\\sum.\\bigotimes.\\bigoplus.\\bigodot.\\bigsqcup.\\smallint.∏.∐.∑.⋀.⋁.⋂.⋃.⨀.⨁.⨂.⨄.⨆`.split(
      `.`,
    ),
  numArgs: 0,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = r;
    return (
      i.length === 1 && (i = Es[i]),
      {
        type: `op`,
        mode: n.mode,
        limits: !0,
        parentIsSupSub: !1,
        symbol: !0,
        name: i,
      }
    );
  },
  htmlBuilder: ws,
  mathmlBuilder: Ts,
}),
  ma({
    type: `op`,
    names: [`\\mathop`],
    numArgs: 1,
    primitive: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `op`,
        mode: n.mode,
        limits: !1,
        parentIsSupSub: !1,
        symbol: !1,
        body: _a(r),
      };
    },
  }));
var Ds = {
  "∫": `\\int`,
  "∬": `\\iint`,
  "∭": `\\iiint`,
  "∮": `\\oint`,
  "∯": `\\oiint`,
  "∰": `\\oiiint`,
};
(ma({
  type: `op`,
  names:
    `\\arcsin.\\arccos.\\arctan.\\arctg.\\arcctg.\\arg.\\ch.\\cos.\\cosec.\\cosh.\\cot.\\cotg.\\coth.\\csc.\\ctg.\\cth.\\deg.\\dim.\\exp.\\hom.\\ker.\\lg.\\ln.\\log.\\sec.\\sin.\\sinh.\\sh.\\tan.\\tanh.\\tg.\\th`.split(
      `.`,
    ),
  numArgs: 0,
  handler(e) {
    var { parser: t, funcName: n } = e;
    return {
      type: `op`,
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: n,
    };
  },
}),
  ma({
    type: `op`,
    names: [`\\det`, `\\gcd`, `\\inf`, `\\lim`, `\\max`, `\\min`, `\\Pr`, `\\sup`],
    numArgs: 0,
    handler(e) {
      var { parser: t, funcName: n } = e;
      return {
        type: `op`,
        mode: t.mode,
        limits: !0,
        parentIsSupSub: !1,
        symbol: !1,
        name: n,
      };
    },
  }),
  ma({
    type: `op`,
    names: [
      `\\int`,
      `\\iint`,
      `\\iiint`,
      `\\oint`,
      `\\oiint`,
      `\\oiiint`,
      `∫`,
      `∬`,
      `∭`,
      `∮`,
      `∯`,
      `∰`,
    ],
    numArgs: 0,
    allowedInArgument: !0,
    handler(e) {
      var { parser: t, funcName: n } = e,
        r = n;
      return (
        r.length === 1 && (r = Ds[r]),
        {
          type: `op`,
          mode: t.mode,
          limits: !1,
          parentIsSupSub: !1,
          symbol: !0,
          name: r,
        }
      );
    },
  }));
var Os = (e, t) => {
  var n,
    r,
    i = !1,
    a;
  e.type === `supsub`
    ? ((n = e.sup), (r = e.sub), (a = io(e.base, `operatorname`)), (i = !0))
    : (a = io(e, `operatorname`));
  var o;
  if (a.body.length > 0) {
    for (
      var s = ba(
          a.body.map((e) => {
            var t = (`text` in e) ? e.text : void 0;
            return typeof t == `string`
              ? {
                  type: `textord`,
                  mode: e.mode,
                  text: t,
                }
              : e;
          }),
          t.withFont(`mathrm`),
          !0,
        ),
        c = 0;
      c < s.length;
      c++
    ) {
      var l = s[c];
      l instanceof zr && (l.text = l.text.replace(/\u2212/, `-`).replace(/\u2217/, `*`));
    }
    o = Xi([`mop`], s, t);
  } else o = Xi([`mop`], [], t);
  return i ? Ss(o, n, r, t, t.style, 0, 0) : o;
};
(ma({
  type: `operatorname`,
  names: [`\\operatorname@`, `\\operatornamewithlimits`],
  numArgs: 1,
  handler: (e, t) => {
    var { parser: n, funcName: r } = e,
      i = t[0];
    return {
      type: `operatorname`,
      mode: n.mode,
      body: _a(i),
      alwaysHandleSupSub: r === `\\operatornamewithlimits`,
      limits: !1,
      parentIsSupSub: !1,
    };
  },
  htmlBuilder: Os,
  mathmlBuilder: (e, t) => {
    for (var n = La(e.body, t.withFont(`mathrm`)), r = !0, i = 0; i < n.length; i++) {
      var a = n[i];
      if (!(a instanceof Ma))
        if (a instanceof Aa)
          switch (a.type) {
            case `mi`:
            case `mn`:
            case `mspace`:
            case `mtext`:
              break;
            case `mo`:
              var o = a.children[0];
              a.children.length === 1 && o instanceof ja
                ? (o.text = o.text.replace(/\u2212/, `-`).replace(/\u2217/, `*`))
                : (r = !1);
              break;
            default:
              r = !1;
          }
        else r = !1;
    }
    r && (n = [new ja(n.map((e) => e.toText()).join(``))]);
    var s = new Aa(`mi`, n);
    s.setAttribute(`mathvariant`, `normal`);
    var c = new Aa(`mo`, [Na(`⁡`, `text`)]);
    return e.parentIsSupSub ? new Aa(`mrow`, [s, c]) : ka([s, c]);
  },
}),
  Q(`\\operatorname`, `\\@ifstar\\operatornamewithlimits\\operatorname@`),
  ha({
    type: `ordgroup`,
    htmlBuilder(e, t) {
      return e.semisimple ? ea(ba(e.body, t, !1)) : Xi([`mord`], ba(e.body, t, !0), t);
    },
    mathmlBuilder(e, t) {
      return Ra(e.body, t, !0);
    },
  }),
  ma({
    type: `overline`,
    names: [`\\overline`],
    numArgs: 1,
    handler(e, t) {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `overline`,
        mode: n.mode,
        body: r,
      };
    },
    htmlBuilder(e, t) {
      var n = Ea(e.body, t.havingCrampedStyle()),
        r = Qi(`overline-line`, t),
        i = t.fontMetrics().defaultRuleThickness;
      return Xi(
        [`mord`, `overline`],
        [
          na({
            positionType: `firstBaseline`,
            children: [
              {
                type: `elem`,
                elem: n,
              },
              {
                type: `kern`,
                size: 3 * i,
              },
              {
                type: `elem`,
                elem: r,
              },
              {
                type: `kern`,
                size: i,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder(e, t) {
      var n = new Aa(`mo`, [new ja(`‾`)]);
      n.setAttribute(`stretchy`, `true`);
      var r = new Aa(`mover`, [za(e.body, t), n]);
      return (r.setAttribute(`accent`, `true`), r);
    },
  }),
  ma({
    type: `phantom`,
    names: [`\\phantom`],
    numArgs: 1,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `phantom`,
        mode: n.mode,
        body: _a(r),
      };
    },
    htmlBuilder: (e, t) => ea(ba(e.body, t.withPhantom(), !1)),
    mathmlBuilder: (e, t) => new Aa(`mphantom`, La(e.body, t)),
  }),
  Q(`\\hphantom`, `\\smash{\\phantom{#1}}`),
  ma({
    type: `vphantom`,
    names: [`\\vphantom`],
    numArgs: 1,
    allowedInText: !0,
    handler: (e, t) => {
      var { parser: n } = e,
        r = t[0];
      return {
        type: `vphantom`,
        mode: n.mode,
        body: r,
      };
    },
    htmlBuilder: (e, t) =>
      Xi([`mord`, `rlap`], [Xi([`inner`], [Ea(e.body, t.withPhantom())]), Xi([`fix`], [])], t),
    mathmlBuilder: (e, t) => {
      var n = new Aa(`mpadded`, [new Aa(`mphantom`, La(_a(e.body), t))]);
      return (n.setAttribute(`width`, `0px`), n);
    },
  }),
  ma({
    type: `raisebox`,
    names: [`\\raisebox`],
    numArgs: 2,
    argTypes: [`size`, `hbox`],
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e,
        r = io(t[0], `size`).value,
        i = t[1];
      return {
        type: `raisebox`,
        mode: n.mode,
        dy: r,
        body: i,
      };
    },
    htmlBuilder(e, t) {
      var n = Ea(e.body, t);
      return na({
        positionType: `shift`,
        positionData: -Dr(e.dy, t),
        children: [
          {
            type: `elem`,
            elem: n,
          },
        ],
      });
    },
    mathmlBuilder(e, t) {
      var n = new Aa(`mpadded`, [za(e.body, t)]),
        r = e.dy.number + e.dy.unit;
      return (n.setAttribute(`voffset`, r), n);
    },
  }),
  ma({
    type: `internal`,
    names: [`\\relax`],
    numArgs: 0,
    allowedInText: !0,
    allowedInArgument: !0,
    handler(e) {
      var { parser: t } = e;
      return {
        type: `internal`,
        mode: t.mode,
      };
    },
  }),
  ma({
    type: `rule`,
    names: [`\\rule`],
    numArgs: 2,
    numOptionalArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: [`size`, `size`, `size`],
    handler(e, t, n) {
      var { parser: r } = e,
        i = n[0],
        a = io(t[0], `size`),
        o = io(t[1], `size`);
      return {
        type: `rule`,
        mode: r.mode,
        shift: i && io(i, `size`).value,
        width: a.value,
        height: o.value,
      };
    },
    htmlBuilder(e, t) {
      var n = Xi([`mord`, `rule`], [], t),
        r = Dr(e.width, t),
        i = Dr(e.height, t),
        a = e.shift ? Dr(e.shift, t) : 0;
      return (
        (n.style.borderRightWidth = Or(r)),
        (n.style.borderTopWidth = Or(i)),
        (n.style.bottom = Or(a)),
        (n.width = r),
        (n.height = i + a),
        (n.depth = -a),
        (n.maxFontSize = i * 1.125 * t.sizeMultiplier),
        n
      );
    },
    mathmlBuilder(e, t) {
      var n = Dr(e.width, t),
        r = Dr(e.height, t),
        i = e.shift ? Dr(e.shift, t) : 0,
        a = (t.color && t.getColor()) || `black`,
        o = new Aa(`mspace`);
      (o.setAttribute(`mathbackground`, a),
        o.setAttribute(`width`, Or(n)),
        o.setAttribute(`height`, Or(r)));
      var s = new Aa(`mpadded`, [o]);
      return (
        i >= 0
          ? s.setAttribute(`height`, Or(i))
          : (s.setAttribute(`height`, Or(i)), s.setAttribute(`depth`, Or(-i))),
        s.setAttribute(`voffset`, Or(i)),
        s
      );
    },
  }));
function ks(e, t, n) {
  for (var r = ba(e, t, !1), i = t.sizeMultiplier / n.sizeMultiplier, a = 0; a < r.length; a++) {
    var o = r[a].classes.indexOf(`sizing`);
    (o < 0
      ? Array.prototype.push.apply(r[a].classes, t.sizingClasses(n))
      : r[a].classes[o + 1] === `reset-size` + t.size &&
        (r[a].classes[o + 1] = `reset-size` + n.size),
      (r[a].height *= i),
      (r[a].depth *= i));
  }
  return ea(r);
}
var As = [
  `\\tiny`,
  `\\sixptsize`,
  `\\scriptsize`,
  `\\footnotesize`,
  `\\small`,
  `\\normalsize`,
  `\\large`,
  `\\Large`,
  `\\LARGE`,
  `\\huge`,
  `\\Huge`,
];
(ma({
  type: `sizing`,
  names: As,
  numArgs: 0,
  allowedInText: !0,
  handler: (e, t) => {
    var { breakOnTokenText: n, funcName: r, parser: i } = e,
      a = i.parseExpression(!1, n);
    return {
      type: `sizing`,
      mode: i.mode,
      size: As.indexOf(r) + 1,
      body: a,
    };
  },
  htmlBuilder: (e, t) => {
    var n = t.havingSize(e.size);
    return ks(e.body, n, t);
  },
  mathmlBuilder: (e, t) => {
    var n = t.havingSize(e.size),
      r = new Aa(`mstyle`, La(e.body, n));
    return (r.setAttribute(`mathsize`, Or(n.sizeMultiplier)), r);
  },
}),
  ma({
    type: `smash`,
    names: [`\\smash`],
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0,
    handler: (e, t, n) => {
      var { parser: r } = e,
        i = !1,
        a = !1,
        o = n[0] && io(n[0], `ordgroup`);
      if (o)
        for (var s, c = 0; c < o.body.length; ++c) {
          var l = o.body[c];
          if (((s = ao(l).text), s === `t`)) i = !0;
          else if (s === `b`) a = !0;
          else {
            ((i = !1), (a = !1));
            break;
          }
        }
      else ((i = !0), (a = !0));
      var u = t[0];
      return {
        type: `smash`,
        mode: r.mode,
        body: u,
        smashHeight: i,
        smashDepth: a,
      };
    },
    htmlBuilder: (e, t) => {
      var n = Xi([], [Ea(e.body, t)]);
      if (!e.smashHeight && !e.smashDepth) return n;
      if (
        (e.smashHeight && (n.height = 0),
        e.smashDepth && (n.depth = 0),
        e.smashHeight && e.smashDepth)
      )
        return Xi([`mord`, `smash`], [n], t);
      if (n.children)
        for (var r = 0; r < n.children.length; r++)
          (e.smashHeight && (n.children[r].height = 0), e.smashDepth && (n.children[r].depth = 0));
      return Xi(
        [`mord`],
        [
          na({
            positionType: `firstBaseline`,
            children: [
              {
                type: `elem`,
                elem: n,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder: (e, t) => {
      var n = new Aa(`mpadded`, [za(e.body, t)]);
      return (
        e.smashHeight && n.setAttribute(`height`, `0px`),
        e.smashDepth && n.setAttribute(`depth`, `0px`),
        n
      );
    },
  }),
  ma({
    type: `sqrt`,
    names: [`\\sqrt`],
    numArgs: 1,
    numOptionalArgs: 1,
    handler(e, t, n) {
      var { parser: r } = e,
        i = n[0],
        a = t[0];
      return {
        type: `sqrt`,
        mode: r.mode,
        body: a,
        index: i,
      };
    },
    htmlBuilder(e, t) {
      var n = Ea(e.body, t.havingCrampedStyle());
      (n.height === 0 && (n.height = t.fontMetrics().xHeight), (n = ta(n, t)));
      var r = t.fontMetrics().defaultRuleThickness,
        i = r;
      t.style.id < ir.TEXT.id && (i = t.fontMetrics().xHeight);
      var a = r + i / 4,
        { span: o, ruleWidth: s, advanceWidth: c } = Fo(n.height + n.depth + a + r, t),
        l = o.height - s;
      l > n.height + n.depth + a && (a = (a + l - n.height - n.depth) / 2);
      var u = o.height - n.height - a - s;
      n.style.paddingLeft = Or(c);
      var d = na({
        positionType: `firstBaseline`,
        children: [
          {
            type: `elem`,
            elem: n,
            wrapperClasses: [`svg-align`],
          },
          {
            type: `kern`,
            size: -(n.height + u),
          },
          {
            type: `elem`,
            elem: o,
          },
          {
            type: `kern`,
            size: s,
          },
        ],
      });
      if (e.index) {
        var f = t.havingStyle(ir.SCRIPTSCRIPT),
          p = Ea(e.index, f, t);
        return Xi(
          [`mord`, `sqrt`],
          [
            Xi(
              [`root`],
              [
                na({
                  positionType: `shift`,
                  positionData: -(0.6 * (d.height - d.depth)),
                  children: [
                    {
                      type: `elem`,
                      elem: p,
                    },
                  ],
                }),
              ],
            ),
            d,
          ],
          t,
        );
      } else return Xi([`mord`, `sqrt`], [d], t);
    },
    mathmlBuilder(e, t) {
      var { body: n, index: r } = e;
      return r ? new Aa(`mroot`, [za(n, t), za(r, t)]) : new Aa(`msqrt`, [za(n, t)]);
    },
  }));
var js = {
  display: ir.DISPLAY,
  text: ir.TEXT,
  script: ir.SCRIPT,
  scriptscript: ir.SCRIPTSCRIPT,
};
function Ms(e) {
  return e in js;
}
ma({
  type: `styling`,
  names: [`\\displaystyle`, `\\textstyle`, `\\scriptstyle`, `\\scriptscriptstyle`],
  numArgs: 0,
  allowedInText: !0,
  primitive: !0,
  handler(e, t) {
    var { breakOnTokenText: n, funcName: r, parser: i } = e,
      a = i.parseExpression(!0, n),
      o = r.slice(1, r.length - 5);
    if (!Ms(o)) throw Error(`Unknown style: ` + o);
    return {
      type: `styling`,
      mode: i.mode,
      style: o,
      body: a,
    };
  },
  htmlBuilder(e, t) {
    var n = js[e.style],
      r = t.havingStyle(n);
    return (e.resetFont && (r = r.withFont(``)), ks(e.body, r, t));
  },
  mathmlBuilder(e, t) {
    var n = js[e.style],
      r = t.havingStyle(n);
    e.resetFont && (r = r.withFont(``));
    var i = new Aa(`mstyle`, La(e.body, r)),
      a = {
        display: [`0`, `true`],
        text: [`0`, `false`],
        script: [`1`, `false`],
        scriptscript: [`2`, `false`],
      }[e.style];
    return (i.setAttribute(`scriptlevel`, a[0]), i.setAttribute(`displaystyle`, a[1]), i);
  },
});
var Ns = function (e, t) {
  var n = e.base;
  return n
    ? n.type === `op`
      ? n.limits && (t.style.size === ir.DISPLAY.size || n.alwaysHandleSupSub)
        ? ws
        : null
      : n.type === `operatorname`
        ? n.alwaysHandleSupSub && (t.style.size === ir.DISPLAY.size || n.limits)
          ? Os
          : null
        : n.type === `accent`
          ? Fn(n.base)
            ? co
            : null
          : n.type === `horizBrace` && !e.sub === n.isOver
            ? ys
            : null
    : null;
};
(ha({
  type: `supsub`,
  htmlBuilder(e, t) {
    var n = Ns(e, t);
    if (n) return n(e, t);
    var { base: r, sup: i, sub: a } = e,
      o = Ea(r, t),
      s,
      c,
      l = t.fontMetrics(),
      u = 0,
      d = 0,
      f = r && Fn(r);
    if (i) {
      var p = t.havingStyle(t.style.sup());
      ((s = Ea(i, p, t)),
        f || (u = o.height - (p.fontMetrics().supDrop * p.sizeMultiplier) / t.sizeMultiplier));
    }
    if (a) {
      var m = t.havingStyle(t.style.sub());
      ((c = Ea(a, m, t)),
        f || (d = o.depth + (m.fontMetrics().subDrop * m.sizeMultiplier) / t.sizeMultiplier));
    }
    var h = t.style === ir.DISPLAY ? l.sup1 : t.style.cramped ? l.sup3 : l.sup2,
      g = t.sizeMultiplier,
      v = Or(0.5 / l.ptPerEm / g),
      y = null;
    if (c) {
      var b =
        e.base &&
        e.base.type === `op` &&
        e.base.name &&
        (e.base.name === `\\oiint` || e.base.name === `\\oiiint`);
      (o instanceof zr || b) && (y = Or(-(o.italic ?? 0)));
    }
    var x;
    if (s && c) {
      ((u = Math.max(u, h, s.depth + 0.25 * l.xHeight)), (d = Math.max(d, l.sub2)));
      var S = 4 * l.defaultRuleThickness;
      if (u - s.depth - (c.height - d) < S) {
        d = S - (u - s.depth) + c.height;
        var C = 0.8 * l.xHeight - (u - s.depth);
        C > 0 && ((u += C), (d -= C));
      }
      x = na({
        positionType: `individualShift`,
        children: [
          {
            type: `elem`,
            elem: c,
            shift: d,
            marginRight: v,
            marginLeft: y,
          },
          {
            type: `elem`,
            elem: s,
            shift: -u,
            marginRight: v,
          },
        ],
      });
    } else if (c)
      ((d = Math.max(d, l.sub1, c.height - 0.8 * l.xHeight)),
        (x = na({
          positionType: `shift`,
          positionData: d,
          children: [
            {
              type: `elem`,
              elem: c,
              marginLeft: y,
              marginRight: v,
            },
          ],
        })));
    else if (s)
      ((u = Math.max(u, h, s.depth + 0.25 * l.xHeight)),
        (x = na({
          positionType: `shift`,
          positionData: -u,
          children: [
            {
              type: `elem`,
              elem: s,
              marginRight: v,
            },
          ],
        })));
    else throw Error(`supsub must have either sup or sub.`);
    return Xi([wa(o, `right`) || `mord`], [o, Xi([`msupsub`], [x])], t);
  },
  mathmlBuilder(e, t) {
    var n = !1,
      r,
      i;
    (e.base &&
      e.base.type === `horizBrace` &&
      ((i = !!e.sup), i === e.base.isOver && ((n = !0), (r = e.base.isOver))),
      e.base &&
        (e.base.type === `op` || e.base.type === `operatorname`) &&
        (e.base.parentIsSupSub = !0));
    var a = [za(e.base, t)];
    (e.sub && a.push(za(e.sub, t)), e.sup && a.push(za(e.sup, t)));
    var o;
    if (n) o = r ? `mover` : `munder`;
    else if (!e.sub) {
      var s = e.base;
      o =
        (s && s.type === `op` && s.limits && (t.style === ir.DISPLAY || s.alwaysHandleSupSub)) ||
        (s &&
          s.type === `operatorname` &&
          s.alwaysHandleSupSub &&
          (s.limits || t.style === ir.DISPLAY))
          ? `mover`
          : `msup`;
    } else if (e.sup) {
      var c = e.base;
      o =
        (c && c.type === `op` && c.limits && t.style === ir.DISPLAY) ||
        (c &&
          c.type === `operatorname` &&
          c.alwaysHandleSupSub &&
          (t.style === ir.DISPLAY || c.limits))
          ? `munderover`
          : `msubsup`;
    } else {
      var l = e.base;
      o =
        (l && l.type === `op` && l.limits && (t.style === ir.DISPLAY || l.alwaysHandleSupSub)) ||
        (l &&
          l.type === `operatorname` &&
          l.alwaysHandleSupSub &&
          (l.limits || t.style === ir.DISPLAY))
          ? `munder`
          : `msub`;
    }
    return new Aa(o, a);
  },
}),
  ha({
    type: `atom`,
    htmlBuilder(e, t) {
      return Gi(e.text, e.mode, t, [`m` + e.family]);
    },
    mathmlBuilder(e, t) {
      var n = new Aa(`mo`, [Na(e.text, e.mode)]);
      if (e.family === `bin`) {
        var r = Fa(e, t);
        r === `bold-italic` && n.setAttribute(`mathvariant`, r);
      } else
        e.family === `punct`
          ? n.setAttribute(`separator`, `true`)
          : (e.family === `open` || e.family === `close`) && n.setAttribute(`stretchy`, `false`);
      return n;
    },
  }));
var Ps = {
  mi: `italic`,
  mn: `normal`,
  mtext: `normal`,
};
(ha({
  type: `mathord`,
  htmlBuilder(e, t) {
    return qi(e, t);
  },
  mathmlBuilder(e, t) {
    var n = new Aa(`mi`, [Na(e.text, e.mode, t)]),
      r = Fa(e, t) || `italic`;
    return (r !== Ps[n.type] && n.setAttribute(`mathvariant`, r), n);
  },
}),
  ha({
    type: `textord`,
    htmlBuilder(e, t) {
      return qi(e, t);
    },
    mathmlBuilder(e, t) {
      var n = Na(e.text, e.mode, t),
        r = Fa(e, t) || `normal`,
        i =
          e.mode === `text`
            ? new Aa(`mtext`, [n])
            : /[0-9]/.test(e.text)
              ? new Aa(`mn`, [n])
              : e.text === `\\prime`
                ? new Aa(`mo`, [n])
                : new Aa(`mi`, [n]);
      return (r !== Ps[i.type] && i.setAttribute(`mathvariant`, r), i);
    },
  }));
var Fs = {
    "\\nobreak": `nobreak`,
    "\\allowbreak": `allowbreak`,
  },
  Is = {
    " ": {},
    "\\ ": {},
    "~": {
      className: `nobreak`,
    },
    "\\space": {},
    "\\nobreakspace": {
      className: `nobreak`,
    },
  };
ha({
  type: `spacing`,
  htmlBuilder(e, t) {
    if (Is.hasOwnProperty(e.text)) {
      var n = Is[e.text].className || ``;
      if (e.mode === `text`) {
        var r = qi(e, t);
        return (r.classes.push(n), r);
      } else return Xi([`mspace`, n], [Gi(e.text, e.mode, t)], t);
    } else if (Fs.hasOwnProperty(e.text)) return Xi([`mspace`, Fs[e.text]], [], t);
    else throw new Dn(`Unknown type of space "` + e.text + `"`);
  },
  mathmlBuilder(e, t) {
    var n;
    if (Is.hasOwnProperty(e.text)) n = new Aa(`mtext`, [new ja(`\xA0`)]);
    else if (Fs.hasOwnProperty(e.text)) return new Aa(`mspace`);
    else throw new Dn(`Unknown type of space "` + e.text + `"`);
    return n;
  },
});
var Ls = () => {
  var e = new Aa(`mtd`, []);
  return (e.setAttribute(`width`, `50%`), e);
};
ha({
  type: `tag`,
  mathmlBuilder(e, t) {
    var n = new Aa(`mtable`, [
      new Aa(`mtr`, [Ls(), new Aa(`mtd`, [Ra(e.body, t)]), Ls(), new Aa(`mtd`, [Ra(e.tag, t)])]),
    ]);
    return (n.setAttribute(`width`, `100%`), n);
  },
});
var Rs = {
    "\\text": void 0,
    "\\textrm": `textrm`,
    "\\textsf": `textsf`,
    "\\texttt": `texttt`,
    "\\textnormal": `textrm`,
  },
  zs = {
    "\\textbf": `textbf`,
    "\\textmd": `textmd`,
  },
  Bs = {
    "\\textit": `textit`,
    "\\textup": `textup`,
  },
  Vs = (e, t) => {
    var n = e.font;
    return n
      ? Rs[n]
        ? t.withTextFontFamily(Rs[n])
        : zs[n]
          ? t.withTextFontWeight(zs[n])
          : n === `\\emph`
            ? t.fontShape === `textit`
              ? t.withTextFontShape(`textup`)
              : t.withTextFontShape(`textit`)
            : t.withTextFontShape(Bs[n])
      : t;
  };
(ma({
  type: `text`,
  names: [
    `\\text`,
    `\\textrm`,
    `\\textsf`,
    `\\texttt`,
    `\\textnormal`,
    `\\textbf`,
    `\\textmd`,
    `\\textit`,
    `\\textup`,
    `\\emph`,
  ],
  numArgs: 1,
  argTypes: [`text`],
  allowedInArgument: !0,
  allowedInText: !0,
  handler(e, t) {
    var { parser: n, funcName: r } = e,
      i = t[0];
    return {
      type: `text`,
      mode: n.mode,
      body: _a(i),
      font: r,
    };
  },
  htmlBuilder(e, t) {
    var n = Vs(e, t);
    return Xi([`mord`, `text`], ba(e.body, n, !0), n);
  },
  mathmlBuilder(e, t) {
    var n = Vs(e, t);
    return Ra(e.body, n);
  },
}),
  ma({
    type: `underline`,
    names: [`\\underline`],
    numArgs: 1,
    allowedInText: !0,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `underline`,
        mode: n.mode,
        body: t[0],
      };
    },
    htmlBuilder(e, t) {
      var n = Ea(e.body, t),
        r = Qi(`underline-line`, t),
        i = t.fontMetrics().defaultRuleThickness;
      return Xi(
        [`mord`, `underline`],
        [
          na({
            positionType: `top`,
            positionData: n.height,
            children: [
              {
                type: `kern`,
                size: i,
              },
              {
                type: `elem`,
                elem: r,
              },
              {
                type: `kern`,
                size: 3 * i,
              },
              {
                type: `elem`,
                elem: n,
              },
            ],
          }),
        ],
        t,
      );
    },
    mathmlBuilder(e, t) {
      var n = new Aa(`mo`, [new ja(`‾`)]);
      n.setAttribute(`stretchy`, `true`);
      var r = new Aa(`munder`, [za(e.body, t), n]);
      return (r.setAttribute(`accentunder`, `true`), r);
    },
  }),
  ma({
    type: `vcenter`,
    names: [`\\vcenter`],
    numArgs: 1,
    argTypes: [`original`],
    allowedInText: !1,
    handler(e, t) {
      var { parser: n } = e;
      return {
        type: `vcenter`,
        mode: n.mode,
        body: t[0],
      };
    },
    htmlBuilder(e, t) {
      var n = Ea(e.body, t),
        r = t.fontMetrics().axisHeight;
      return na({
        positionType: `shift`,
        positionData: 0.5 * (n.height - r - (n.depth + r)),
        children: [
          {
            type: `elem`,
            elem: n,
          },
        ],
      });
    },
    mathmlBuilder(e, t) {
      return new Aa(`mrow`, [new Aa(`mpadded`, [za(e.body, t)], [`vcenter`])]);
    },
  }),
  ma({
    type: `verb`,
    names: [`\\verb`],
    numArgs: 0,
    allowedInText: !0,
    handler(e, t, n) {
      throw new Dn(`\\verb ended by end of line instead of matching delimiter`);
    },
    htmlBuilder(e, t) {
      for (var n = Hs(e), r = [], i = t.havingStyle(t.style.text()), a = 0; a < n.length; a++) {
        var o = n[a];
        (o === `~` && (o = `\\textasciitilde`),
          r.push(Wi(o, `Typewriter-Regular`, e.mode, i, [`mord`, `texttt`])));
      }
      return Xi([`mord`, `text`].concat(i.sizingClasses(t)), Ji(r), i);
    },
    mathmlBuilder(e, t) {
      var n = new Aa(`mtext`, [new ja(Hs(e))]);
      return (n.setAttribute(`mathvariant`, `monospace`), n);
    },
  }));
var Hs = (e) => e.body.replace(/ /g, e.star ? `␣` : `\xA0`),
  Us = da,
  Ws = `[ \r
	]`,
  bee = `\\\\[a-zA-Z@]+`,
  xee = `\\\\[^\ud800-\udfff]`,
  See = `(` + bee + `)` + Ws + `*`,
  Cee = `\\\\(
|[ \r	]+
?)[ \r	]*`,
  Gs = `[̀-ͯ]`,
  wee = RegExp(Gs + `+$`),
  Tee =
    `(` +
    Ws +
    `+)|` +
    (Cee + `|`) +
    `([!-\\[\\]-‧‪-퟿豈-￿]` +
    (Gs + `*`) +
    `|[\ud800-\udbff][\udc00-\udfff]` +
    (Gs + `*`) +
    `|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5` +
    (`|` + See) +
    (`|` + xee + `)`),
  Ks = class {
    constructor(e, t) {
      ((this.input = void 0),
        (this.settings = void 0),
        (this.tokenRegex = void 0),
        (this.catcodes = void 0),
        (this.input = e),
        (this.settings = t),
        (this.tokenRegex = new RegExp(Tee, `g`)),
        (this.catcodes = {
          "%": 14,
          "~": 13,
        }));
    }
    setCatcode(e, t) {
      this.catcodes[e] = t;
    }
    lex() {
      var e = this.input,
        t = this.tokenRegex.lastIndex;
      if (t === e.length) return new $o(`EOF`, new Qo(this, t, t));
      var n = this.tokenRegex.exec(e);
      if (n === null || n.index !== t)
        throw new Dn(`Unexpected character: '` + e[t] + `'`, new $o(e[t], new Qo(this, t, t + 1)));
      var r = n[6] || n[3] || (n[2] ? `\\ ` : ` `);
      if (this.catcodes[r] === 14) {
        var i = e.indexOf(
          `
`,
          this.tokenRegex.lastIndex,
        );
        return (
          i === -1
            ? ((this.tokenRegex.lastIndex = e.length),
              this.settings.reportNonstrict(
                `commentAtEnd`,
                `% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)`,
              ))
            : (this.tokenRegex.lastIndex = i + 1),
          this.lex()
        );
      }
      return new $o(r, new Qo(this, t, this.tokenRegex.lastIndex));
    }
  },
  Eee = class {
    constructor(e, t) {
      (e === void 0 && (e = {}),
        t === void 0 && (t = {}),
        (this.current = void 0),
        (this.builtins = void 0),
        (this.undefStack = void 0),
        (this.current = t),
        (this.builtins = e),
        (this.undefStack = []));
    }
    beginGroup() {
      this.undefStack.push({});
    }
    endGroup() {
      if (this.undefStack.length === 0)
        throw new Dn(
          `Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug`,
        );
      var e = this.undefStack.pop();
      for (var t in e)
        e.hasOwnProperty(t) && (e[t] == null ? delete this.current[t] : (this.current[t] = e[t]));
    }
    endGroups() {
      for (; this.undefStack.length > 0;) this.endGroup();
    }
    has(e) {
      return this.current.hasOwnProperty(e) || this.builtins.hasOwnProperty(e);
    }
    get(e) {
      return this.current.hasOwnProperty(e) ? this.current[e] : this.builtins[e];
    }
    set(e, t, n) {
      if ((n === void 0 && (n = !1), n)) {
        for (var r = 0; r < this.undefStack.length; r++) delete this.undefStack[r][e];
        this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][e] = t);
      } else {
        var i = this.undefStack[this.undefStack.length - 1];
        i && !i.hasOwnProperty(e) && (i[e] = this.current[e]);
      }
      t == null ? delete this.current[e] : (this.current[e] = t);
    }
  },
  Dee = Zo;
(Q(`\\noexpand`, function (e) {
  var t = e.popToken();
  return (
    e.isExpandable(t.text) && ((t.noexpand = !0), (t.treatAsRelax = !0)),
    {
      tokens: [t],
      numArgs: 0,
    }
  );
}),
  Q(`\\expandafter`, function (e) {
    var t = e.popToken();
    return (
      e.expandOnce(!0),
      {
        tokens: [t],
        numArgs: 0,
      }
    );
  }),
  Q(`\\@firstoftwo`, function (e) {
    return {
      tokens: e.consumeArgs(2)[0],
      numArgs: 0,
    };
  }),
  Q(`\\@secondoftwo`, function (e) {
    return {
      tokens: e.consumeArgs(2)[1],
      numArgs: 0,
    };
  }),
  Q(`\\@ifnextchar`, function (e) {
    var t = e.consumeArgs(3);
    e.consumeSpaces();
    var n = e.future();
    return t[0].length === 1 && t[0][0].text === n.text
      ? {
          tokens: t[1],
          numArgs: 0,
        }
      : {
          tokens: t[2],
          numArgs: 0,
        };
  }),
  Q(`\\@ifstar`, `\\@ifnextchar *{\\@firstoftwo{#1}}`),
  Q(`\\TextOrMath`, function (e) {
    var t = e.consumeArgs(2);
    return e.mode === `text`
      ? {
          tokens: t[0],
          numArgs: 0,
        }
      : {
          tokens: t[1],
          numArgs: 0,
        };
  }));
var qs = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15,
};
Q(`\\char`, function (e) {
  var t = e.popToken(),
    n,
    r = 0;
  if (t.text === `'`) ((n = 8), (t = e.popToken()));
  else if (t.text === `"`) ((n = 16), (t = e.popToken()));
  else if (t.text === "`") {
    if (((t = e.popToken()), t.text[0] === `\\`)) r = t.text.charCodeAt(1);
    else if (t.text === `EOF`) throw new Dn("\\char` missing argument");
    else r = t.text.charCodeAt(0);
  } else n = 10;
  if (n) {
    if (((r = qs[t.text]), r == null || r >= n))
      throw new Dn(`Invalid base-` + n + ` digit ` + t.text);
    for (var i; (i = qs[e.future().text]) != null && i < n;) ((r *= n), (r += i), e.popToken());
  }
  return `\\@char{` + r + `}`;
});
var Js = (e, t, n, r) => {
  var i = e.consumeArg().tokens;
  if (i.length !== 1) throw new Dn(`\\newcommand's first argument must be a macro name`);
  var a = i[0].text,
    o = e.isDefined(a);
  if (o && !t)
    throw new Dn(`\\newcommand{` + a + `} attempting to redefine ` + (a + `; use \\renewcommand`));
  if (!o && !n)
    throw new Dn(
      `\\renewcommand{` + a + `} when command ` + a + ` does not yet exist; use \\newcommand`,
    );
  var s = 0;
  if (((i = e.consumeArg().tokens), i.length === 1 && i[0].text === `[`)) {
    for (var c = ``, l = e.expandNextToken(); l.text !== `]` && l.text !== `EOF`;)
      ((c += l.text), (l = e.expandNextToken()));
    if (!c.match(/^\s*[0-9]+\s*$/)) throw new Dn(`Invalid number of arguments: ` + c);
    ((s = parseInt(c)), (i = e.consumeArg().tokens));
  }
  return (
    (o && r) ||
      e.macros.set(a, {
        tokens: i,
        numArgs: s,
      }),
    ``
  );
};
(Q(`\\newcommand`, (e) => Js(e, !1, !0, !1)),
  Q(`\\renewcommand`, (e) => Js(e, !0, !1, !1)),
  Q(`\\providecommand`, (e) => Js(e, !0, !0, !0)),
  Q(`\\message`, (e) => {
    var t = e.consumeArgs(1)[0];
    return (
      console.log(
        t
          .reverse()
          .map((e) => e.text)
          .join(``),
      ),
      ``
    );
  }),
  Q(`\\errmessage`, (e) => {
    var t = e.consumeArgs(1)[0];
    return (
      console.error(
        t
          .reverse()
          .map((e) => e.text)
          .join(``),
      ),
      ``
    );
  }),
  Q(`\\show`, (e) => {
    var t = e.popToken(),
      n = t.text;
    return (console.log(t, e.macros.get(n), Us[n], $r.math[n], $r.text[n]), ``);
  }),
  Q(`\\bgroup`, `{`),
  Q(`\\egroup`, `}`),
  Q(`~`, `\\nobreakspace`),
  Q(`\\lq`, "`"),
  Q(`\\rq`, `'`),
  Q(`\\aa`, `\\r a`),
  Q(`\\AA`, `\\r A`),
  Q(`\\textcopyright`, "\\html@mathml{\\textcircled{c}}{\\char`©}"),
  Q(`\\copyright`, `\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}`),
  Q(`\\textregistered`, "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}"),
  Q(`ℬ`, `\\mathscr{B}`),
  Q(`ℰ`, `\\mathscr{E}`),
  Q(`ℱ`, `\\mathscr{F}`),
  Q(`ℋ`, `\\mathscr{H}`),
  Q(`ℐ`, `\\mathscr{I}`),
  Q(`ℒ`, `\\mathscr{L}`),
  Q(`ℳ`, `\\mathscr{M}`),
  Q(`ℛ`, `\\mathscr{R}`),
  Q(`ℭ`, `\\mathfrak{C}`),
  Q(`ℌ`, `\\mathfrak{H}`),
  Q(`ℨ`, `\\mathfrak{Z}`),
  Q(`\\Bbbk`, `\\Bbb{k}`),
  Q(`\\llap`, `\\mathllap{\\textrm{#1}}`),
  Q(`\\rlap`, `\\mathrlap{\\textrm{#1}}`),
  Q(`\\clap`, `\\mathclap{\\textrm{#1}}`),
  Q(`\\mathstrut`, `\\vphantom{(}`),
  Q(`\\underbar`, `\\underline{\\text{#1}}`),
  Q(`\\not`, `\\html@mathml{\\mathrel{\\mathrlap\\@not}\\nobreak}{\\char"338}`),
  Q(`\\neq`, "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}"),
  Q(`\\ne`, `\\neq`),
  Q(`≠`, `\\neq`),
  Q(`\\notin`, "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}"),
  Q(`∉`, `\\notin`),
  Q(
    `≘`,
    "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}",
  ),
  Q(`≙`, "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}"),
  Q(`≚`, "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}"),
  Q(`≛`, "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}"),
  Q(`≝`, "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}"),
  Q(`≞`, "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}"),
  Q(`≟`, "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}"),
  Q(`⟂`, `\\perp`),
  Q(`‼`, `\\mathclose{!\\mkern-0.8mu!}`),
  Q(`∌`, `\\notni`),
  Q(`⌜`, `\\ulcorner`),
  Q(`⌝`, `\\urcorner`),
  Q(`⌞`, `\\llcorner`),
  Q(`⌟`, `\\lrcorner`),
  Q(`©`, `\\copyright`),
  Q(`®`, `\\textregistered`),
  Q(`\\ulcorner`, `\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}`),
  Q(`\\urcorner`, `\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}`),
  Q(`\\llcorner`, `\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}`),
  Q(`\\lrcorner`, `\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}`),
  Q(`\\vdots`, `{\\varvdots\\rule{0pt}{15pt}}`),
  Q(`⋮`, `\\vdots`),
  Q(`\\varGamma`, `\\mathit{\\Gamma}`),
  Q(`\\varDelta`, `\\mathit{\\Delta}`),
  Q(`\\varTheta`, `\\mathit{\\Theta}`),
  Q(`\\varLambda`, `\\mathit{\\Lambda}`),
  Q(`\\varXi`, `\\mathit{\\Xi}`),
  Q(`\\varPi`, `\\mathit{\\Pi}`),
  Q(`\\varSigma`, `\\mathit{\\Sigma}`),
  Q(`\\varUpsilon`, `\\mathit{\\Upsilon}`),
  Q(`\\varPhi`, `\\mathit{\\Phi}`),
  Q(`\\varPsi`, `\\mathit{\\Psi}`),
  Q(`\\varOmega`, `\\mathit{\\Omega}`),
  Q(`\\substack`, `\\begin{subarray}{c}#1\\end{subarray}`),
  Q(
    `\\colon`,
    `\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax`,
  ),
  Q(`\\boxed`, `\\fbox{$\\displaystyle{#1}$}`),
  Q(`\\iff`, `\\DOTSB\\;\\Longleftrightarrow\\;`),
  Q(`\\implies`, `\\DOTSB\\;\\Longrightarrow\\;`),
  Q(`\\impliedby`, `\\DOTSB\\;\\Longleftarrow\\;`),
  Q(`\\dddot`, `{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}`),
  Q(`\\ddddot`, `{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}`));
var Ys = {
    ",": `\\dotsc`,
    "\\not": `\\dotsb`,
    "+": `\\dotsb`,
    "=": `\\dotsb`,
    "<": `\\dotsb`,
    ">": `\\dotsb`,
    "-": `\\dotsb`,
    "*": `\\dotsb`,
    ":": `\\dotsb`,
    "\\DOTSB": `\\dotsb`,
    "\\coprod": `\\dotsb`,
    "\\bigvee": `\\dotsb`,
    "\\bigwedge": `\\dotsb`,
    "\\biguplus": `\\dotsb`,
    "\\bigcap": `\\dotsb`,
    "\\bigcup": `\\dotsb`,
    "\\prod": `\\dotsb`,
    "\\sum": `\\dotsb`,
    "\\bigotimes": `\\dotsb`,
    "\\bigoplus": `\\dotsb`,
    "\\bigodot": `\\dotsb`,
    "\\bigsqcup": `\\dotsb`,
    "\\And": `\\dotsb`,
    "\\longrightarrow": `\\dotsb`,
    "\\Longrightarrow": `\\dotsb`,
    "\\longleftarrow": `\\dotsb`,
    "\\Longleftarrow": `\\dotsb`,
    "\\longleftrightarrow": `\\dotsb`,
    "\\Longleftrightarrow": `\\dotsb`,
    "\\mapsto": `\\dotsb`,
    "\\longmapsto": `\\dotsb`,
    "\\hookrightarrow": `\\dotsb`,
    "\\doteq": `\\dotsb`,
    "\\mathbin": `\\dotsb`,
    "\\mathrel": `\\dotsb`,
    "\\relbar": `\\dotsb`,
    "\\Relbar": `\\dotsb`,
    "\\xrightarrow": `\\dotsb`,
    "\\xleftarrow": `\\dotsb`,
    "\\DOTSI": `\\dotsi`,
    "\\int": `\\dotsi`,
    "\\oint": `\\dotsi`,
    "\\iint": `\\dotsi`,
    "\\iiint": `\\dotsi`,
    "\\iiiint": `\\dotsi`,
    "\\idotsint": `\\dotsi`,
    "\\DOTSX": `\\dotsx`,
  },
  Oee = new Set([`bin`, `rel`]);
Q(`\\dots`, function (e) {
  var t = `\\dotso`,
    n = e.expandAfterFuture().text;
  return (
    n in Ys
      ? (t = Ys[n])
      : (n.slice(0, 4) === `\\not` || (n in $r.math && Oee.has($r.math[n].group))) &&
        (t = `\\dotsb`),
    t
  );
});
var Xs = {
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  $: !0,
  ";": !0,
  ".": !0,
  ",": !0,
};
(Q(`\\dotso`, function (e) {
  return e.future().text in Xs ? `\\ldots\\,` : `\\ldots`;
}),
  Q(`\\dotsc`, function (e) {
    var t = e.future().text;
    return t in Xs && t !== `,` ? `\\ldots\\,` : `\\ldots`;
  }),
  Q(`\\cdots`, function (e) {
    return e.future().text in Xs ? `\\@cdots\\,` : `\\@cdots`;
  }),
  Q(`\\dotsb`, `\\cdots`),
  Q(`\\dotsm`, `\\cdots`),
  Q(`\\dotsi`, `\\!\\cdots`),
  Q(`\\dotsx`, `\\ldots\\,`),
  Q(`\\DOTSI`, `\\relax`),
  Q(`\\DOTSB`, `\\relax`),
  Q(`\\DOTSX`, `\\relax`),
  Q(`\\tmspace`, `\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax`),
  Q(`\\,`, `\\tmspace+{3mu}{.1667em}`),
  Q(`\\thinspace`, `\\,`),
  Q(`\\>`, `\\mskip{4mu}`),
  Q(`\\:`, `\\tmspace+{4mu}{.2222em}`),
  Q(`\\medspace`, `\\:`),
  Q(`\\;`, `\\tmspace+{5mu}{.2777em}`),
  Q(`\\thickspace`, `\\;`),
  Q(`\\!`, `\\tmspace-{3mu}{.1667em}`),
  Q(`\\negthinspace`, `\\!`),
  Q(`\\negmedspace`, `\\tmspace-{4mu}{.2222em}`),
  Q(`\\negthickspace`, `\\tmspace-{5mu}{.277em}`),
  Q(`\\enspace`, `\\kern.5em `),
  Q(`\\enskip`, `\\hskip.5em\\relax`),
  Q(`\\quad`, `\\hskip1em\\relax`),
  Q(`\\qquad`, `\\hskip2em\\relax`),
  Q(`\\tag`, `\\@ifstar\\tag@literal\\tag@paren`),
  Q(`\\tag@paren`, `\\tag@literal{({#1})}`),
  Q(`\\tag@literal`, (e) => {
    if (e.macros.get(`\\df@tag`)) throw new Dn(`Multiple \\tag`);
    return `\\gdef\\df@tag{\\text{#1}}`;
  }),
  Q(
    `\\bmod`,
    `\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}`,
  ),
  Q(`\\pod`, `\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)`),
  Q(`\\pmod`, `\\pod{{\\rm mod}\\mkern6mu#1}`),
  Q(
    `\\mod`,
    `\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1`,
  ),
  Q(`\\newline`, `\\\\\\relax`),
  Q(`\\TeX`, `\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}`));
var Zs = Or(Kr[`Main-Regular`][84][1] - 0.7 * Kr[`Main-Regular`][65][1]);
(Q(
  `\\LaTeX`,
  `\\textrm{\\html@mathml{` +
    (`L\\kern-.36em\\raisebox{` + Zs + `}{\\scriptstyle A}`) +
    `\\kern-.15em\\TeX}{LaTeX}}`,
),
  Q(
    `\\KaTeX`,
    `\\textrm{\\html@mathml{` +
      (`K\\kern-.17em\\raisebox{` + Zs + `}{\\scriptstyle A}`) +
      `\\kern-.15em\\TeX}{KaTeX}}`,
  ),
  Q(`\\hspace`, `\\@ifstar\\@hspacer\\@hspace`),
  Q(`\\@hspace`, `\\hskip #1\\relax`),
  Q(`\\@hspacer`, `\\rule{0pt}{0pt}\\hskip #1\\relax`),
  Q(`\\ordinarycolon`, `:`),
  Q(`\\vcentcolon`, `\\mathrel{\\mathop\\ordinarycolon}`),
  Q(
    `\\dblcolon`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}`,
  ),
  Q(
    `\\coloneqq`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}`,
  ),
  Q(
    `\\Coloneqq`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}`,
  ),
  Q(
    `\\coloneq`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}`,
  ),
  Q(
    `\\Coloneq`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}`,
  ),
  Q(
    `\\eqqcolon`,
    `\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}`,
  ),
  Q(
    `\\Eqqcolon`,
    `\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}`,
  ),
  Q(
    `\\eqcolon`,
    `\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}`,
  ),
  Q(
    `\\Eqcolon`,
    `\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}`,
  ),
  Q(
    `\\colonapprox`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}`,
  ),
  Q(
    `\\Colonapprox`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}`,
  ),
  Q(
    `\\colonsim`,
    `\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}`,
  ),
  Q(
    `\\Colonsim`,
    `\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}`,
  ),
  Q(`∷`, `\\dblcolon`),
  Q(`∹`, `\\eqcolon`),
  Q(`≔`, `\\coloneqq`),
  Q(`≕`, `\\eqqcolon`),
  Q(`⩴`, `\\Coloneqq`),
  Q(`\\ratio`, `\\vcentcolon`),
  Q(`\\coloncolon`, `\\dblcolon`),
  Q(`\\colonequals`, `\\coloneqq`),
  Q(`\\coloncolonequals`, `\\Coloneqq`),
  Q(`\\equalscolon`, `\\eqqcolon`),
  Q(`\\equalscoloncolon`, `\\Eqqcolon`),
  Q(`\\colonminus`, `\\coloneq`),
  Q(`\\coloncolonminus`, `\\Coloneq`),
  Q(`\\minuscolon`, `\\eqcolon`),
  Q(`\\minuscoloncolon`, `\\Eqcolon`),
  Q(`\\coloncolonapprox`, `\\Colonapprox`),
  Q(`\\coloncolonsim`, `\\Colonsim`),
  Q(`\\simcolon`, `\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}`),
  Q(`\\simcoloncolon`, `\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}`),
  Q(`\\approxcolon`, `\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}`),
  Q(`\\approxcoloncolon`, `\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}`),
  Q(`\\notni`, "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}"),
  Q(`\\limsup`, `\\DOTSB\\operatorname*{lim\\,sup}`),
  Q(`\\liminf`, `\\DOTSB\\operatorname*{lim\\,inf}`),
  Q(`\\injlim`, `\\DOTSB\\operatorname*{inj\\,lim}`),
  Q(`\\projlim`, `\\DOTSB\\operatorname*{proj\\,lim}`),
  Q(`\\varlimsup`, `\\DOTSB\\operatorname*{\\overline{lim}}`),
  Q(`\\varliminf`, `\\DOTSB\\operatorname*{\\underline{lim}}`),
  Q(`\\varinjlim`, `\\DOTSB\\operatorname*{\\underrightarrow{lim}}`),
  Q(`\\varprojlim`, `\\DOTSB\\operatorname*{\\underleftarrow{lim}}`),
  Q(`\\gvertneqq`, `\\html@mathml{\\@gvertneqq}{≩}`),
  Q(`\\lvertneqq`, `\\html@mathml{\\@lvertneqq}{≨}`),
  Q(`\\ngeqq`, `\\html@mathml{\\@ngeqq}{≱}`),
  Q(`\\ngeqslant`, `\\html@mathml{\\@ngeqslant}{≱}`),
  Q(`\\nleqq`, `\\html@mathml{\\@nleqq}{≰}`),
  Q(`\\nleqslant`, `\\html@mathml{\\@nleqslant}{≰}`),
  Q(`\\nshortmid`, `\\html@mathml{\\@nshortmid}{∤}`),
  Q(`\\nshortparallel`, `\\html@mathml{\\@nshortparallel}{∦}`),
  Q(`\\nsubseteqq`, `\\html@mathml{\\@nsubseteqq}{⊈}`),
  Q(`\\nsupseteqq`, `\\html@mathml{\\@nsupseteqq}{⊉}`),
  Q(`\\varsubsetneq`, `\\html@mathml{\\@varsubsetneq}{⊊}`),
  Q(`\\varsubsetneqq`, `\\html@mathml{\\@varsubsetneqq}{⫋}`),
  Q(`\\varsupsetneq`, `\\html@mathml{\\@varsupsetneq}{⊋}`),
  Q(`\\varsupsetneqq`, `\\html@mathml{\\@varsupsetneqq}{⫌}`),
  Q(`\\imath`, `\\html@mathml{\\@imath}{ı}`),
  Q(`\\jmath`, `\\html@mathml{\\@jmath}{ȷ}`),
  Q(`\\llbracket`, "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}"),
  Q(`\\rrbracket`, "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}"),
  Q(`⟦`, `\\llbracket`),
  Q(`⟧`, `\\rrbracket`),
  Q(`\\lBrace`, "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}"),
  Q(`\\rBrace`, "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}"),
  Q(`⦃`, `\\lBrace`),
  Q(`⦄`, `\\rBrace`),
  Q(
    `\\minuso`,
    "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}",
  ),
  Q(`⦵`, `\\minuso`),
  Q(`\\darr`, `\\downarrow`),
  Q(`\\dArr`, `\\Downarrow`),
  Q(`\\Darr`, `\\Downarrow`),
  Q(`\\lang`, `\\langle`),
  Q(`\\rang`, `\\rangle`),
  Q(`\\uarr`, `\\uparrow`),
  Q(`\\uArr`, `\\Uparrow`),
  Q(`\\Uarr`, `\\Uparrow`),
  Q(`\\N`, `\\mathbb{N}`),
  Q(`\\R`, `\\mathbb{R}`),
  Q(`\\Z`, `\\mathbb{Z}`),
  Q(`\\alef`, `\\aleph`),
  Q(`\\alefsym`, `\\aleph`),
  Q(`\\Alpha`, `\\mathrm{A}`),
  Q(`\\Beta`, `\\mathrm{B}`),
  Q(`\\bull`, `\\bullet`),
  Q(`\\Chi`, `\\mathrm{X}`),
  Q(`\\clubs`, `\\clubsuit`),
  Q(`\\cnums`, `\\mathbb{C}`),
  Q(`\\Complex`, `\\mathbb{C}`),
  Q(`\\Dagger`, `\\ddagger`),
  Q(`\\diamonds`, `\\diamondsuit`),
  Q(`\\empty`, `\\emptyset`),
  Q(`\\Epsilon`, `\\mathrm{E}`),
  Q(`\\Eta`, `\\mathrm{H}`),
  Q(`\\exist`, `\\exists`),
  Q(`\\harr`, `\\leftrightarrow`),
  Q(`\\hArr`, `\\Leftrightarrow`),
  Q(`\\Harr`, `\\Leftrightarrow`),
  Q(`\\hearts`, `\\heartsuit`),
  Q(`\\image`, `\\Im`),
  Q(`\\infin`, `\\infty`),
  Q(`\\Iota`, `\\mathrm{I}`),
  Q(`\\isin`, `\\in`),
  Q(`\\Kappa`, `\\mathrm{K}`),
  Q(`\\larr`, `\\leftarrow`),
  Q(`\\lArr`, `\\Leftarrow`),
  Q(`\\Larr`, `\\Leftarrow`),
  Q(`\\lrarr`, `\\leftrightarrow`),
  Q(`\\lrArr`, `\\Leftrightarrow`),
  Q(`\\Lrarr`, `\\Leftrightarrow`),
  Q(`\\Mu`, `\\mathrm{M}`),
  Q(`\\natnums`, `\\mathbb{N}`),
  Q(`\\Nu`, `\\mathrm{N}`),
  Q(`\\Omicron`, `\\mathrm{O}`),
  Q(`\\plusmn`, `\\pm`),
  Q(`\\rarr`, `\\rightarrow`),
  Q(`\\rArr`, `\\Rightarrow`),
  Q(`\\Rarr`, `\\Rightarrow`),
  Q(`\\real`, `\\Re`),
  Q(`\\reals`, `\\mathbb{R}`),
  Q(`\\Reals`, `\\mathbb{R}`),
  Q(`\\Rho`, `\\mathrm{P}`),
  Q(`\\sdot`, `\\cdot`),
  Q(`\\sect`, `\\S`),
  Q(`\\spades`, `\\spadesuit`),
  Q(`\\sub`, `\\subset`),
  Q(`\\sube`, `\\subseteq`),
  Q(`\\supe`, `\\supseteq`),
  Q(`\\Tau`, `\\mathrm{T}`),
  Q(`\\thetasym`, `\\vartheta`),
  Q(`\\weierp`, `\\wp`),
  Q(`\\Zeta`, `\\mathrm{Z}`),
  Q(`\\argmin`, `\\DOTSB\\operatorname*{arg\\,min}`),
  Q(`\\argmax`, `\\DOTSB\\operatorname*{arg\\,max}`),
  Q(`\\plim`, `\\DOTSB\\mathop{\\operatorname{plim}}\\limits`),
  Q(`\\bra`, `\\mathinner{\\langle{#1}|}`),
  Q(`\\ket`, `\\mathinner{|{#1}\\rangle}`),
  Q(`\\braket`, `\\mathinner{\\langle{#1}\\rangle}`),
  Q(`\\Bra`, `\\left\\langle#1\\right|`),
  Q(`\\Ket`, `\\left|#1\\right\\rangle`));
var Qs = (e) => (t) => {
  var n = t.consumeArg().tokens,
    r = t.consumeArg().tokens,
    i = t.consumeArg().tokens,
    a = t.consumeArg().tokens,
    o = t.macros.get(`|`),
    s = t.macros.get(`\\|`);
  t.macros.beginGroup();
  var c = (t) => (n) => {
    e && (n.macros.set(`|`, o), i.length && n.macros.set(`\\|`, s));
    var a = t;
    return (
      !t && i.length && n.future().text === `|` && (n.popToken(), (a = !0)),
      {
        tokens: a ? i : r,
        numArgs: 0,
      }
    );
  };
  (t.macros.set(`|`, c(!1)), i.length && t.macros.set(`\\|`, c(!0)));
  var l = t.consumeArg().tokens,
    u = t.expandTokens([...a, ...l, ...n]);
  return (
    t.macros.endGroup(),
    {
      tokens: u.reverse(),
      numArgs: 0,
    }
  );
};
(Q(`\\bra@ket`, Qs(!1)),
  Q(`\\bra@set`, Qs(!0)),
  Q(
    `\\Braket`,
    `\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}`,
  ),
  Q(`\\Set`, `\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}`),
  Q(`\\set`, `\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}`),
  Q(`\\angln`, `{\\angl n}`),
  Q(`\\blue`, `\\textcolor{##6495ed}{#1}`),
  Q(`\\orange`, `\\textcolor{##ffa500}{#1}`),
  Q(`\\pink`, `\\textcolor{##ff00af}{#1}`),
  Q(`\\red`, `\\textcolor{##df0030}{#1}`),
  Q(`\\green`, `\\textcolor{##28ae7b}{#1}`),
  Q(`\\gray`, `\\textcolor{gray}{#1}`),
  Q(`\\purple`, `\\textcolor{##9d38bd}{#1}`),
  Q(`\\blueA`, `\\textcolor{##ccfaff}{#1}`),
  Q(`\\blueB`, `\\textcolor{##80f6ff}{#1}`),
  Q(`\\blueC`, `\\textcolor{##63d9ea}{#1}`),
  Q(`\\blueD`, `\\textcolor{##11accd}{#1}`),
  Q(`\\blueE`, `\\textcolor{##0c7f99}{#1}`),
  Q(`\\tealA`, `\\textcolor{##94fff5}{#1}`),
  Q(`\\tealB`, `\\textcolor{##26edd5}{#1}`),
  Q(`\\tealC`, `\\textcolor{##01d1c1}{#1}`),
  Q(`\\tealD`, `\\textcolor{##01a995}{#1}`),
  Q(`\\tealE`, `\\textcolor{##208170}{#1}`),
  Q(`\\greenA`, `\\textcolor{##b6ffb0}{#1}`),
  Q(`\\greenB`, `\\textcolor{##8af281}{#1}`),
  Q(`\\greenC`, `\\textcolor{##74cf70}{#1}`),
  Q(`\\greenD`, `\\textcolor{##1fab54}{#1}`),
  Q(`\\greenE`, `\\textcolor{##0d923f}{#1}`),
  Q(`\\goldA`, `\\textcolor{##ffd0a9}{#1}`),
  Q(`\\goldB`, `\\textcolor{##ffbb71}{#1}`),
  Q(`\\goldC`, `\\textcolor{##ff9c39}{#1}`),
  Q(`\\goldD`, `\\textcolor{##e07d10}{#1}`),
  Q(`\\goldE`, `\\textcolor{##a75a05}{#1}`),
  Q(`\\redA`, `\\textcolor{##fca9a9}{#1}`),
  Q(`\\redB`, `\\textcolor{##ff8482}{#1}`),
  Q(`\\redC`, `\\textcolor{##f9685d}{#1}`),
  Q(`\\redD`, `\\textcolor{##e84d39}{#1}`),
  Q(`\\redE`, `\\textcolor{##bc2612}{#1}`),
  Q(`\\maroonA`, `\\textcolor{##ffbde0}{#1}`),
  Q(`\\maroonB`, `\\textcolor{##ff92c6}{#1}`),
  Q(`\\maroonC`, `\\textcolor{##ed5fa6}{#1}`),
  Q(`\\maroonD`, `\\textcolor{##ca337c}{#1}`),
  Q(`\\maroonE`, `\\textcolor{##9e034e}{#1}`),
  Q(`\\purpleA`, `\\textcolor{##ddd7ff}{#1}`),
  Q(`\\purpleB`, `\\textcolor{##c6b9fc}{#1}`),
  Q(`\\purpleC`, `\\textcolor{##aa87ff}{#1}`),
  Q(`\\purpleD`, `\\textcolor{##7854ab}{#1}`),
  Q(`\\purpleE`, `\\textcolor{##543b78}{#1}`),
  Q(`\\mintA`, `\\textcolor{##f5f9e8}{#1}`),
  Q(`\\mintB`, `\\textcolor{##edf2df}{#1}`),
  Q(`\\mintC`, `\\textcolor{##e0e5cc}{#1}`),
  Q(`\\grayA`, `\\textcolor{##f6f7f7}{#1}`),
  Q(`\\grayB`, `\\textcolor{##f0f1f2}{#1}`),
  Q(`\\grayC`, `\\textcolor{##e3e5e6}{#1}`),
  Q(`\\grayD`, `\\textcolor{##d6d8da}{#1}`),
  Q(`\\grayE`, `\\textcolor{##babec2}{#1}`),
  Q(`\\grayF`, `\\textcolor{##888d93}{#1}`),
  Q(`\\grayG`, `\\textcolor{##626569}{#1}`),
  Q(`\\grayH`, `\\textcolor{##3b3e40}{#1}`),
  Q(`\\grayI`, `\\textcolor{##21242c}{#1}`),
  Q(`\\kaBlue`, `\\textcolor{##314453}{#1}`),
  Q(`\\kaGreen`, `\\textcolor{##71B307}{#1}`));
var $s = {
    "^": !0,
    _: !0,
    "\\limits": !0,
    "\\nolimits": !0,
  },
  kee = class {
    constructor(e, t, n) {
      ((this.settings = void 0),
        (this.expansionCount = void 0),
        (this.lexer = void 0),
        (this.macros = void 0),
        (this.stack = void 0),
        (this.mode = void 0),
        (this.settings = t),
        (this.expansionCount = 0),
        this.feed(e),
        (this.macros = new Eee(Dee, t.macros)),
        (this.mode = n),
        (this.stack = []));
    }
    feed(e) {
      this.lexer = new Ks(e, this.settings);
    }
    switchMode(e) {
      this.mode = e;
    }
    beginGroup() {
      this.macros.beginGroup();
    }
    endGroup() {
      this.macros.endGroup();
    }
    endGroups() {
      this.macros.endGroups();
    }
    future() {
      return (
        this.stack.length === 0 && this.pushToken(this.lexer.lex()),
        this.stack[this.stack.length - 1]
      );
    }
    popToken() {
      return (this.future(), this.stack.pop());
    }
    pushToken(e) {
      this.stack.push(e);
    }
    pushTokens(e) {
      this.stack.push(...e);
    }
    scanArgument(e) {
      var t, n, r;
      if (e) {
        if ((this.consumeSpaces(), this.future().text !== `[`)) return null;
        ((t = this.popToken()), ({ tokens: r, end: n } = this.consumeArg([`]`])));
      } else ({ tokens: r, start: t, end: n } = this.consumeArg());
      return (this.pushToken(new $o(`EOF`, n.loc)), this.pushTokens(r), new $o(``, Qo.range(t, n)));
    }
    consumeSpaces() {
      for (; this.future().text === ` `;) this.stack.pop();
    }
    consumeArg(e) {
      var t = [],
        n = e && e.length > 0;
      n || this.consumeSpaces();
      var r = this.future(),
        i,
        a = 0,
        o = 0;
      do {
        if (((i = this.popToken()), t.push(i), i.text === `{`)) ++a;
        else if (i.text === `}`) {
          if ((--a, a === -1)) throw new Dn(`Extra }`, i);
        } else if (i.text === `EOF`)
          throw new Dn(
            `Unexpected end of input in a macro argument, expected '` + (e && n ? e[o] : `}`) + `'`,
            i,
          );
        if (e && n)
          if ((a === 0 || (a === 1 && e[o] === `{`)) && i.text === e[o]) {
            if ((++o, o === e.length)) {
              t.splice(-o, o);
              break;
            }
          } else o = 0;
      } while (a !== 0 || n);
      return (
        r.text === `{` && t[t.length - 1].text === `}` && (t.pop(), t.shift()),
        t.reverse(),
        {
          tokens: t,
          start: r,
          end: i,
        }
      );
    }
    consumeArgs(e, t) {
      if (t) {
        if (t.length !== e + 1)
          throw new Dn(`The length of delimiters doesn't match the number of args!`);
        for (var n = t[0], r = 0; r < n.length; r++) {
          var i = this.popToken();
          if (n[r] !== i.text) throw new Dn(`Use of the macro doesn't match its definition`, i);
        }
      }
      for (var a = [], o = 0; o < e; o++) a.push(this.consumeArg(t && t[o + 1]).tokens);
      return a;
    }
    countExpansion(e) {
      if (((this.expansionCount += e), this.expansionCount > this.settings.maxExpand))
        throw new Dn(`Too many expansions: infinite loop or need to increase maxExpand setting`);
    }
    expandOnce(e) {
      var t = this.popToken(),
        n = t.text,
        r = t.noexpand ? null : this._getExpansion(n);
      if (r == null || (e && r.unexpandable)) {
        if (e && r == null && n[0] === `\\` && !this.isDefined(n))
          throw new Dn(`Undefined control sequence: ` + n);
        return (this.pushToken(t), !1);
      }
      this.countExpansion(1);
      var i = r.tokens,
        a = this.consumeArgs(r.numArgs, r.delimiters);
      if (r.numArgs) {
        i = i.slice();
        for (var o = i.length - 1; o >= 0; --o) {
          var s = i[o];
          if (s.text === `#`) {
            if (o === 0) throw new Dn(`Incomplete placeholder at end of macro body`, s);
            if (((s = i[--o]), s.text === `#`)) i.splice(o + 1, 1);
            else if (/^[1-9]$/.test(s.text)) i.splice(o, 2, ...a[s.text - 1]);
            else throw new Dn(`Not a valid argument number`, s);
          }
        }
      }
      return (this.pushTokens(i), i.length);
    }
    expandAfterFuture() {
      return (this.expandOnce(), this.future());
    }
    expandNextToken() {
      for (;;)
        if (this.expandOnce() === !1) {
          var e = this.stack.pop();
          return (e.treatAsRelax && (e.text = `\\relax`), e);
        }
    }
    expandMacro(e) {
      return this.macros.has(e) ? this.expandTokens([new $o(e)]) : void 0;
    }
    expandTokens(e) {
      var t = [],
        n = this.stack.length;
      for (this.pushTokens(e); this.stack.length > n;)
        if (this.expandOnce(!0) === !1) {
          var r = this.stack.pop();
          ((r.treatAsRelax &&= ((r.noexpand = !1), !1)), t.push(r));
        }
      return (this.countExpansion(t.length), t);
    }
    expandMacroAsText(e) {
      var t = this.expandMacro(e);
      return t && t.map((e) => e.text).join(``);
    }
    _getExpansion(e) {
      var t = this.macros.get(e);
      if (t == null) return t;
      if (e.length === 1) {
        var n = this.lexer.catcodes[e];
        if (n != null && n !== 13) return;
      }
      var r = typeof t == `function` ? t(this) : t;
      if (typeof r == `string`) {
        var i = 0;
        if (r.includes(`#`)) for (var a = r.replace(/##/g, ``); a.includes(`#` + (i + 1));) ++i;
        for (var o = new Ks(r, this.settings), s = [], c = o.lex(); c.text !== `EOF`;)
          (s.push(c), (c = o.lex()));
        return (
          s.reverse(),
          {
            tokens: s,
            numArgs: i,
          }
        );
      }
      return r;
    }
    isDefined(e) {
      return (
        this.macros.has(e) ||
        Us.hasOwnProperty(e) ||
        $r.math.hasOwnProperty(e) ||
        $r.text.hasOwnProperty(e) ||
        $s.hasOwnProperty(e)
      );
    }
    isExpandable(e) {
      var t = this.macros.get(e);
      return t == null
        ? Us.hasOwnProperty(e) && !Us[e].primitive
        : typeof t == `string` || typeof t == `function` || !t.unexpandable;
    }
  },
  ec = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/,
  tc = Object.freeze({
    "₊": `+`,
    "₋": `-`,
    "₌": `=`,
    "₍": `(`,
    "₎": `)`,
    "₀": `0`,
    "₁": `1`,
    "₂": `2`,
    "₃": `3`,
    "₄": `4`,
    "₅": `5`,
    "₆": `6`,
    "₇": `7`,
    "₈": `8`,
    "₉": `9`,
    ₐ: `a`,
    ₑ: `e`,
    ₕ: `h`,
    ᵢ: `i`,
    ⱼ: `j`,
    ₖ: `k`,
    ₗ: `l`,
    ₘ: `m`,
    ₙ: `n`,
    ₒ: `o`,
    ₚ: `p`,
    ᵣ: `r`,
    ₛ: `s`,
    ₜ: `t`,
    ᵤ: `u`,
    ᵥ: `v`,
    ₓ: `x`,
    ᵦ: `β`,
    ᵧ: `γ`,
    ᵨ: `ρ`,
    ᵩ: `ϕ`,
    ᵪ: `χ`,
    "⁺": `+`,
    "⁻": `-`,
    "⁼": `=`,
    "⁽": `(`,
    "⁾": `)`,
    "⁰": `0`,
    "¹": `1`,
    "²": `2`,
    "³": `3`,
    "⁴": `4`,
    "⁵": `5`,
    "⁶": `6`,
    "⁷": `7`,
    "⁸": `8`,
    "⁹": `9`,
    ᴬ: `A`,
    ᴮ: `B`,
    ᴰ: `D`,
    ᴱ: `E`,
    ᴳ: `G`,
    ᴴ: `H`,
    ᴵ: `I`,
    ᴶ: `J`,
    ᴷ: `K`,
    ᴸ: `L`,
    ᴹ: `M`,
    ᴺ: `N`,
    ᴼ: `O`,
    ᴾ: `P`,
    ᴿ: `R`,
    ᵀ: `T`,
    ᵁ: `U`,
    ⱽ: `V`,
    ᵂ: `W`,
    ᵃ: `a`,
    ᵇ: `b`,
    ᶜ: `c`,
    ᵈ: `d`,
    ᵉ: `e`,
    ᶠ: `f`,
    ᵍ: `g`,
    ʰ: `h`,
    ⁱ: `i`,
    ʲ: `j`,
    ᵏ: `k`,
    ˡ: `l`,
    ᵐ: `m`,
    ⁿ: `n`,
    ᵒ: `o`,
    ᵖ: `p`,
    ʳ: `r`,
    ˢ: `s`,
    ᵗ: `t`,
    ᵘ: `u`,
    ᵛ: `v`,
    ʷ: `w`,
    ˣ: `x`,
    ʸ: `y`,
    ᶻ: `z`,
    ᵝ: `β`,
    ᵞ: `γ`,
    ᵟ: `δ`,
    ᵠ: `ϕ`,
    ᵡ: `χ`,
    ᶿ: `θ`,
  }),
  nc = {
    "́": {
      text: `\\'`,
      math: `\\acute`,
    },
    "̀": {
      text: "\\`",
      math: `\\grave`,
    },
    "̈": {
      text: `\\"`,
      math: `\\ddot`,
    },
    "̃": {
      text: `\\~`,
      math: `\\tilde`,
    },
    "̄": {
      text: `\\=`,
      math: `\\bar`,
    },
    "̆": {
      text: `\\u`,
      math: `\\breve`,
    },
    "̌": {
      text: `\\v`,
      math: `\\check`,
    },
    "̂": {
      text: `\\^`,
      math: `\\hat`,
    },
    "̇": {
      text: `\\.`,
      math: `\\dot`,
    },
    "̊": {
      text: `\\r`,
      math: `\\mathring`,
    },
    "̋": {
      text: `\\H`,
    },
    "̧": {
      text: `\\c`,
    },
  },
  rc = {
    á: `á`,
    à: `à`,
    ä: `ä`,
    ǟ: `ǟ`,
    ã: `ã`,
    ā: `ā`,
    ă: `ă`,
    ắ: `ắ`,
    ằ: `ằ`,
    ẵ: `ẵ`,
    ǎ: `ǎ`,
    â: `â`,
    ấ: `ấ`,
    ầ: `ầ`,
    ẫ: `ẫ`,
    ȧ: `ȧ`,
    ǡ: `ǡ`,
    å: `å`,
    ǻ: `ǻ`,
    ḃ: `ḃ`,
    ć: `ć`,
    ḉ: `ḉ`,
    č: `č`,
    ĉ: `ĉ`,
    ċ: `ċ`,
    ç: `ç`,
    ď: `ď`,
    ḋ: `ḋ`,
    ḑ: `ḑ`,
    é: `é`,
    è: `è`,
    ë: `ë`,
    ẽ: `ẽ`,
    ē: `ē`,
    ḗ: `ḗ`,
    ḕ: `ḕ`,
    ĕ: `ĕ`,
    ḝ: `ḝ`,
    ě: `ě`,
    ê: `ê`,
    ế: `ế`,
    ề: `ề`,
    ễ: `ễ`,
    ė: `ė`,
    ȩ: `ȩ`,
    ḟ: `ḟ`,
    ǵ: `ǵ`,
    ḡ: `ḡ`,
    ğ: `ğ`,
    ǧ: `ǧ`,
    ĝ: `ĝ`,
    ġ: `ġ`,
    ģ: `ģ`,
    ḧ: `ḧ`,
    ȟ: `ȟ`,
    ĥ: `ĥ`,
    ḣ: `ḣ`,
    ḩ: `ḩ`,
    í: `í`,
    ì: `ì`,
    ï: `ï`,
    ḯ: `ḯ`,
    ĩ: `ĩ`,
    ī: `ī`,
    ĭ: `ĭ`,
    ǐ: `ǐ`,
    î: `î`,
    ǰ: `ǰ`,
    ĵ: `ĵ`,
    ḱ: `ḱ`,
    ǩ: `ǩ`,
    ķ: `ķ`,
    ĺ: `ĺ`,
    ľ: `ľ`,
    ļ: `ļ`,
    ḿ: `ḿ`,
    ṁ: `ṁ`,
    ń: `ń`,
    ǹ: `ǹ`,
    ñ: `ñ`,
    ň: `ň`,
    ṅ: `ṅ`,
    ņ: `ņ`,
    ó: `ó`,
    ò: `ò`,
    ö: `ö`,
    ȫ: `ȫ`,
    õ: `õ`,
    ṍ: `ṍ`,
    ṏ: `ṏ`,
    ȭ: `ȭ`,
    ō: `ō`,
    ṓ: `ṓ`,
    ṑ: `ṑ`,
    ŏ: `ŏ`,
    ǒ: `ǒ`,
    ô: `ô`,
    ố: `ố`,
    ồ: `ồ`,
    ỗ: `ỗ`,
    ȯ: `ȯ`,
    ȱ: `ȱ`,
    ő: `ő`,
    ṕ: `ṕ`,
    ṗ: `ṗ`,
    ŕ: `ŕ`,
    ř: `ř`,
    ṙ: `ṙ`,
    ŗ: `ŗ`,
    ś: `ś`,
    ṥ: `ṥ`,
    š: `š`,
    ṧ: `ṧ`,
    ŝ: `ŝ`,
    ṡ: `ṡ`,
    ş: `ş`,
    ẗ: `ẗ`,
    ť: `ť`,
    ṫ: `ṫ`,
    ţ: `ţ`,
    ú: `ú`,
    ù: `ù`,
    ü: `ü`,
    ǘ: `ǘ`,
    ǜ: `ǜ`,
    ǖ: `ǖ`,
    ǚ: `ǚ`,
    ũ: `ũ`,
    ṹ: `ṹ`,
    ū: `ū`,
    ṻ: `ṻ`,
    ŭ: `ŭ`,
    ǔ: `ǔ`,
    û: `û`,
    ů: `ů`,
    ű: `ű`,
    ṽ: `ṽ`,
    ẃ: `ẃ`,
    ẁ: `ẁ`,
    ẅ: `ẅ`,
    ŵ: `ŵ`,
    ẇ: `ẇ`,
    ẘ: `ẘ`,
    ẍ: `ẍ`,
    ẋ: `ẋ`,
    ý: `ý`,
    ỳ: `ỳ`,
    ÿ: `ÿ`,
    ỹ: `ỹ`,
    ȳ: `ȳ`,
    ŷ: `ŷ`,
    ẏ: `ẏ`,
    ẙ: `ẙ`,
    ź: `ź`,
    ž: `ž`,
    ẑ: `ẑ`,
    ż: `ż`,
    Á: `Á`,
    À: `À`,
    Ä: `Ä`,
    Ǟ: `Ǟ`,
    Ã: `Ã`,
    Ā: `Ā`,
    Ă: `Ă`,
    Ắ: `Ắ`,
    Ằ: `Ằ`,
    Ẵ: `Ẵ`,
    Ǎ: `Ǎ`,
    Â: `Â`,
    Ấ: `Ấ`,
    Ầ: `Ầ`,
    Ẫ: `Ẫ`,
    Ȧ: `Ȧ`,
    Ǡ: `Ǡ`,
    Å: `Å`,
    Ǻ: `Ǻ`,
    Ḃ: `Ḃ`,
    Ć: `Ć`,
    Ḉ: `Ḉ`,
    Č: `Č`,
    Ĉ: `Ĉ`,
    Ċ: `Ċ`,
    Ç: `Ç`,
    Ď: `Ď`,
    Ḋ: `Ḋ`,
    Ḑ: `Ḑ`,
    É: `É`,
    È: `È`,
    Ë: `Ë`,
    Ẽ: `Ẽ`,
    Ē: `Ē`,
    Ḗ: `Ḗ`,
    Ḕ: `Ḕ`,
    Ĕ: `Ĕ`,
    Ḝ: `Ḝ`,
    Ě: `Ě`,
    Ê: `Ê`,
    Ế: `Ế`,
    Ề: `Ề`,
    Ễ: `Ễ`,
    Ė: `Ė`,
    Ȩ: `Ȩ`,
    Ḟ: `Ḟ`,
    Ǵ: `Ǵ`,
    Ḡ: `Ḡ`,
    Ğ: `Ğ`,
    Ǧ: `Ǧ`,
    Ĝ: `Ĝ`,
    Ġ: `Ġ`,
    Ģ: `Ģ`,
    Ḧ: `Ḧ`,
    Ȟ: `Ȟ`,
    Ĥ: `Ĥ`,
    Ḣ: `Ḣ`,
    Ḩ: `Ḩ`,
    Í: `Í`,
    Ì: `Ì`,
    Ï: `Ï`,
    Ḯ: `Ḯ`,
    Ĩ: `Ĩ`,
    Ī: `Ī`,
    Ĭ: `Ĭ`,
    Ǐ: `Ǐ`,
    Î: `Î`,
    İ: `İ`,
    Ĵ: `Ĵ`,
    Ḱ: `Ḱ`,
    Ǩ: `Ǩ`,
    Ķ: `Ķ`,
    Ĺ: `Ĺ`,
    Ľ: `Ľ`,
    Ļ: `Ļ`,
    Ḿ: `Ḿ`,
    Ṁ: `Ṁ`,
    Ń: `Ń`,
    Ǹ: `Ǹ`,
    Ñ: `Ñ`,
    Ň: `Ň`,
    Ṅ: `Ṅ`,
    Ņ: `Ņ`,
    Ó: `Ó`,
    Ò: `Ò`,
    Ö: `Ö`,
    Ȫ: `Ȫ`,
    Õ: `Õ`,
    Ṍ: `Ṍ`,
    Ṏ: `Ṏ`,
    Ȭ: `Ȭ`,
    Ō: `Ō`,
    Ṓ: `Ṓ`,
    Ṑ: `Ṑ`,
    Ŏ: `Ŏ`,
    Ǒ: `Ǒ`,
    Ô: `Ô`,
    Ố: `Ố`,
    Ồ: `Ồ`,
    Ỗ: `Ỗ`,
    Ȯ: `Ȯ`,
    Ȱ: `Ȱ`,
    Ő: `Ő`,
    Ṕ: `Ṕ`,
    Ṗ: `Ṗ`,
    Ŕ: `Ŕ`,
    Ř: `Ř`,
    Ṙ: `Ṙ`,
    Ŗ: `Ŗ`,
    Ś: `Ś`,
    Ṥ: `Ṥ`,
    Š: `Š`,
    Ṧ: `Ṧ`,
    Ŝ: `Ŝ`,
    Ṡ: `Ṡ`,
    Ş: `Ş`,
    Ť: `Ť`,
    Ṫ: `Ṫ`,
    Ţ: `Ţ`,
    Ú: `Ú`,
    Ù: `Ù`,
    Ü: `Ü`,
    Ǘ: `Ǘ`,
    Ǜ: `Ǜ`,
    Ǖ: `Ǖ`,
    Ǚ: `Ǚ`,
    Ũ: `Ũ`,
    Ṹ: `Ṹ`,
    Ū: `Ū`,
    Ṻ: `Ṻ`,
    Ŭ: `Ŭ`,
    Ǔ: `Ǔ`,
    Û: `Û`,
    Ů: `Ů`,
    Ű: `Ű`,
    Ṽ: `Ṽ`,
    Ẃ: `Ẃ`,
    Ẁ: `Ẁ`,
    Ẅ: `Ẅ`,
    Ŵ: `Ŵ`,
    Ẇ: `Ẇ`,
    Ẍ: `Ẍ`,
    Ẋ: `Ẋ`,
    Ý: `Ý`,
    Ỳ: `Ỳ`,
    Ÿ: `Ÿ`,
    Ỹ: `Ỹ`,
    Ȳ: `Ȳ`,
    Ŷ: `Ŷ`,
    Ẏ: `Ẏ`,
    Ź: `Ź`,
    Ž: `Ž`,
    Ẑ: `Ẑ`,
    Ż: `Ż`,
    ά: `ά`,
    ὰ: `ὰ`,
    ᾱ: `ᾱ`,
    ᾰ: `ᾰ`,
    έ: `έ`,
    ὲ: `ὲ`,
    ή: `ή`,
    ὴ: `ὴ`,
    ί: `ί`,
    ὶ: `ὶ`,
    ϊ: `ϊ`,
    ΐ: `ΐ`,
    ῒ: `ῒ`,
    ῑ: `ῑ`,
    ῐ: `ῐ`,
    ό: `ό`,
    ὸ: `ὸ`,
    ύ: `ύ`,
    ὺ: `ὺ`,
    ϋ: `ϋ`,
    ΰ: `ΰ`,
    ῢ: `ῢ`,
    ῡ: `ῡ`,
    ῠ: `ῠ`,
    ώ: `ώ`,
    ὼ: `ὼ`,
    Ύ: `Ύ`,
    Ὺ: `Ὺ`,
    Ϋ: `Ϋ`,
    Ῡ: `Ῡ`,
    Ῠ: `Ῠ`,
    Ώ: `Ώ`,
    Ὼ: `Ὼ`,
  },
  ic = class e {
    constructor(e, t) {
      ((this.mode = void 0),
        (this.gullet = void 0),
        (this.settings = void 0),
        (this.leftrightDepth = void 0),
        (this.nextToken = void 0),
        (this.mode = `math`),
        (this.gullet = new kee(e, t, this.mode)),
        (this.settings = t),
        (this.leftrightDepth = 0),
        (this.nextToken = null));
    }
    expect(e, t) {
      if ((t === void 0 && (t = !0), this.fetch().text !== e))
        throw new Dn(`Expected '` + e + `', got '` + this.fetch().text + `'`, this.fetch());
      t && this.consume();
    }
    consume() {
      this.nextToken = null;
    }
    fetch() {
      return ((this.nextToken ??= this.gullet.expandNextToken()), this.nextToken);
    }
    switchMode(e) {
      ((this.mode = e), this.gullet.switchMode(e));
    }
    parse() {
      (this.settings.globalGroup || this.gullet.beginGroup(),
        this.settings.colorIsTextColor && this.gullet.macros.set(`\\color`, `\\textcolor`));
      try {
        var e = this.parseExpression(!1);
        return (this.expect(`EOF`), this.settings.globalGroup || this.gullet.endGroup(), e);
      } finally {
        this.gullet.endGroups();
      }
    }
    subparse(e) {
      var t = this.nextToken;
      (this.consume(), this.gullet.pushToken(new $o(`}`)), this.gullet.pushTokens(e));
      var n = this.parseExpression(!1);
      return (this.expect(`}`), (this.nextToken = t), n);
    }
    parseExpression(t, n) {
      for (var r = []; ;) {
        this.mode === `math` && this.consumeSpaces();
        var i = this.fetch();
        if (
          e.endOfExpression.has(i.text) ||
          (n && i.text === n) ||
          (t && Us[i.text] && Us[i.text].infix)
        )
          break;
        var a = this.parseAtom(n);
        if (!a) break;
        a.type !== `internal` && r.push(a);
      }
      return (this.mode === `text` && this.formLigatures(r), this.handleInfixNodes(r));
    }
    handleInfixNodes(e) {
      for (var t = -1, n, r = 0; r < e.length; r++) {
        var i = e[r];
        if (i.type === `infix`) {
          if (t !== -1) throw new Dn(`only one infix operator per group`, i.token);
          ((t = r), (n = i.replaceWith));
        }
      }
      if (t !== -1 && n) {
        var a,
          o,
          s = e.slice(0, t),
          c = e.slice(t + 1);
        return (
          (a =
            s.length === 1 && s[0].type === `ordgroup`
              ? s[0]
              : {
                  type: `ordgroup`,
                  mode: this.mode,
                  body: s,
                }),
          (o =
            c.length === 1 && c[0].type === `ordgroup`
              ? c[0]
              : {
                  type: `ordgroup`,
                  mode: this.mode,
                  body: c,
                }),
          [
            n === `\\\\abovefrac`
              ? this.callFunction(n, [a, e[t], o], [])
              : this.callFunction(n, [a, o], []),
          ]
        );
      } else return e;
    }
    handleSupSubscript(e) {
      var t = this.fetch(),
        n = t.text;
      (this.consume(), this.consumeSpaces());
      var r;
      do r = this.parseGroup(e);
      while (r?.type === `internal`);
      if (!r) throw new Dn(`Expected group after '` + n + `'`, t);
      return r;
    }
    formatUnsupportedCmd(e) {
      for (var t = [], n = 0; n < e.length; n++)
        t.push({
          type: `textord`,
          mode: `text`,
          text: e[n],
        });
      var r = {
        type: `text`,
        mode: this.mode,
        body: t,
      };
      return {
        type: `color`,
        mode: this.mode,
        color: this.settings.errorColor,
        body: [r],
      };
    }
    parseAtom(e) {
      var t = this.parseGroup(`atom`, e);
      if (t?.type === `internal` || this.mode === `text`) return t;
      for (var n, r; ;) {
        this.consumeSpaces();
        var i = this.fetch();
        if (i.text === `\\limits` || i.text === `\\nolimits`) {
          if (t && t.type === `op`)
            ((t.limits = i.text === `\\limits`), (t.alwaysHandleSupSub = !0));
          else if (t && t.type === `operatorname`)
            t.alwaysHandleSupSub && (t.limits = i.text === `\\limits`);
          else throw new Dn(`Limit controls must follow a math operator`, i);
          this.consume();
        } else if (i.text === `^`) {
          if (n) throw new Dn(`Double superscript`, i);
          n = this.handleSupSubscript(`superscript`);
        } else if (i.text === `_`) {
          if (r) throw new Dn(`Double subscript`, i);
          r = this.handleSupSubscript(`subscript`);
        } else if (i.text === `'`) {
          if (n) throw new Dn(`Double superscript`, i);
          var a = {
              type: `textord`,
              mode: this.mode,
              text: `\\prime`,
            },
            o = [a];
          for (this.consume(); this.fetch().text === `'`;) (o.push(a), this.consume());
          (this.fetch().text === `^` && o.push(this.handleSupSubscript(`superscript`)),
            (n = {
              type: `ordgroup`,
              mode: this.mode,
              body: o,
            }));
        } else if (tc[i.text]) {
          var s = ec.test(i.text),
            c = [];
          for (c.push(new $o(tc[i.text])), this.consume(); ;) {
            var l = this.fetch().text;
            if (!tc[l] || ec.test(l) !== s) break;
            (c.unshift(new $o(tc[l])), this.consume());
          }
          var u = this.subparse(c);
          s
            ? (r = {
                type: `ordgroup`,
                mode: `math`,
                body: u,
              })
            : (n = {
                type: `ordgroup`,
                mode: `math`,
                body: u,
              });
        } else break;
      }
      return n && r
        ? {
            type: `supsub`,
            mode: this.mode,
            base: t,
            sup: n,
            sub: r,
          }
        : n
          ? {
              type: `supsub`,
              mode: this.mode,
              base: t,
              sup: n,
            }
          : r
            ? {
                type: `supsub`,
                mode: this.mode,
                base: t,
                sub: r,
              }
            : t;
    }
    parseFunction(e, t) {
      var n = this.fetch(),
        r = n.text,
        i = Us[r];
      if (!i) return null;
      if ((this.consume(), t && t !== `atom` && !i.allowedInArgument))
        throw new Dn(`Got function '` + r + `' with no arguments` + (t ? ` as ` + t : ``), n);
      if (this.mode === `text` && !i.allowedInText)
        throw new Dn(`Can't use function '` + r + `' in text mode`, n);
      if (this.mode === `math` && i.allowedInMath === !1)
        throw new Dn(`Can't use function '` + r + `' in math mode`, n);
      var { args: a, optArgs: o } = this.parseArguments(r, i);
      return this.callFunction(r, a, o, n, e);
    }
    callFunction(e, t, n, r, i) {
      var a = {
          funcName: e,
          parser: this,
          token: r,
          breakOnTokenText: i,
        },
        o = Us[e];
      if (o && o.handler) return o.handler(a, t, n);
      throw new Dn(`No function handler for ` + e);
    }
    parseArguments(e, t) {
      var n = t.numOptionalArgs ?? 0,
        r = t.numArgs + n;
      if (r === 0)
        return {
          args: [],
          optArgs: [],
        };
      for (var i = [], a = [], o = 0; o < r; o++) {
        var s = t.argTypes?.[o],
          c = o < n;
        ((`primitive` in t && t.primitive && s == null) ||
          (t.type === `sqrt` && o === 1 && a[0] == null)) &&
          (s = `primitive`);
        var l = this.parseGroupOfType(`argument to '` + e + `'`, s, c);
        if (c) a.push(l);
        else if (l != null) i.push(l);
        else throw new Dn(`Null argument, please report this as a bug`);
      }
      return {
        args: i,
        optArgs: a,
      };
    }
    parseGroupOfType(e, t, n) {
      switch (t) {
        case `color`:
          return this.parseColorGroup(n);
        case `size`:
          return this.parseSizeGroup(n);
        case `url`:
          return this.parseUrlGroup(n);
        case `math`:
        case `text`:
          return this.parseArgumentGroup(n, t);
        case `hbox`:
          var r = this.parseArgumentGroup(n, `text`);
          return r == null
            ? null
            : {
                type: `styling`,
                mode: r.mode,
                body: [r],
                style: `text`,
                resetFont: !0,
              };
        case `raw`:
          var i = this.parseStringGroup(n);
          return i == null
            ? null
            : {
                type: `raw`,
                mode: `text`,
                string: i.text,
              };
        case `primitive`:
          if (n) throw new Dn(`A primitive argument cannot be optional`);
          var a = this.parseGroup(e);
          if (a == null) throw new Dn(`Expected group as ` + e, this.fetch());
          return a;
        case `original`:
        case void 0:
          return this.parseArgumentGroup(n);
        default:
          throw new Dn(`Unknown group type as ` + e, this.fetch());
      }
    }
    consumeSpaces() {
      for (; this.fetch().text === ` `;) this.consume();
    }
    parseStringGroup(e) {
      var t = this.gullet.scanArgument(e);
      if (t == null) return null;
      for (var n = ``, r; (r = this.fetch()).text !== `EOF`;) ((n += r.text), this.consume());
      return (this.consume(), (t.text = n), t);
    }
    parseRegexGroup(e, t) {
      for (
        var n = this.fetch(), r = n, i = ``, a;
        (a = this.fetch()).text !== `EOF` && e.test(i + a.text);
      )
        ((r = a), (i += r.text), this.consume());
      if (i === ``) throw new Dn(`Invalid ` + t + `: '` + n.text + `'`, n);
      return n.range(r, i);
    }
    parseColorGroup(e) {
      var t = this.parseStringGroup(e);
      if (t == null) return null;
      var n = /^(#[a-f0-9]{3,4}|#[a-f0-9]{6}|#[a-f0-9]{8}|[a-f0-9]{6}|[a-z]+)$/i.exec(t.text);
      if (!n) throw new Dn(`Invalid color: '` + t.text + `'`, t);
      var r = n[0];
      return (
        /^[0-9a-f]{6}$/i.test(r) && (r = `#` + r),
        {
          type: `color-token`,
          mode: this.mode,
          color: r,
        }
      );
    }
    parseSizeGroup(e) {
      var t,
        n = !1;
      if (
        (this.gullet.consumeSpaces(),
        (t =
          !e && this.gullet.future().text !== `{`
            ? this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, `size`)
            : this.parseStringGroup(e)),
        !t)
      )
        return null;
      !e && t.text.length === 0 && ((t.text = `0pt`), (n = !0));
      var r = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(t.text);
      if (!r) throw new Dn(`Invalid size: '` + t.text + `'`, t);
      var i = {
        number: +(r[1] + r[2]),
        unit: r[3],
      };
      if (!Er(i)) throw new Dn(`Invalid unit: '` + i.unit + `'`, t);
      return {
        type: `size`,
        mode: this.mode,
        value: i,
        isBlank: n,
      };
    }
    parseUrlGroup(e) {
      (this.gullet.lexer.setCatcode(`%`, 13), this.gullet.lexer.setCatcode(`~`, 12));
      var t = this.parseStringGroup(e);
      if ((this.gullet.lexer.setCatcode(`%`, 14), this.gullet.lexer.setCatcode(`~`, 13), t == null))
        return null;
      var n = t.text.replace(/\\([#$%&~_^{}])/g, `$1`);
      return {
        type: `url`,
        mode: this.mode,
        url: n,
      };
    }
    parseArgumentGroup(e, t) {
      var n = this.gullet.scanArgument(e);
      if (n == null) return null;
      var r = this.mode;
      (t && this.switchMode(t), this.gullet.beginGroup());
      var i = this.parseExpression(!1, `EOF`);
      (this.expect(`EOF`), this.gullet.endGroup());
      var a = {
        type: `ordgroup`,
        mode: this.mode,
        loc: n.loc,
        body: i,
      };
      return (t && this.switchMode(r), a);
    }
    parseGroup(e, t) {
      var n = this.fetch(),
        r = n.text,
        i;
      if (r === `{` || r === `\\begingroup`) {
        this.consume();
        var a = r === `{` ? `}` : `\\endgroup`;
        this.gullet.beginGroup();
        var o = this.parseExpression(!1, a),
          s = this.fetch();
        (this.expect(a),
          this.gullet.endGroup(),
          (i = {
            type: `ordgroup`,
            mode: this.mode,
            loc: Qo.range(n, s),
            body: o,
            semisimple: r === `\\begingroup` || void 0,
          }));
      } else if (
        ((i = this.parseFunction(t, e) || this.parseSymbol()),
        i == null && r[0] === `\\` && !$s.hasOwnProperty(r))
      ) {
        if (this.settings.throwOnError) throw new Dn(`Undefined control sequence: ` + r, n);
        ((i = this.formatUnsupportedCmd(r)), this.consume());
      }
      return i;
    }
    formLigatures(e) {
      for (var t = e.length - 1, n = 0; n < t; ++n) {
        var r = e[n];
        if (r.type === `textord`) {
          var i = r.text,
            a = e[n + 1];
          if (!(!a || a.type !== `textord`)) {
            if (i === `-` && a.text === `-`) {
              var o = e[n + 2];
              n + 1 < t && o && o.type === `textord` && o.text === `-`
                ? (e.splice(n, 3, {
                    type: `textord`,
                    mode: `text`,
                    loc: Qo.range(r, o),
                    text: `---`,
                  }),
                  (t -= 2))
                : (e.splice(n, 2, {
                    type: `textord`,
                    mode: `text`,
                    loc: Qo.range(r, a),
                    text: `--`,
                  }),
                  --t);
            }
            (i === `'` || i === "`") &&
              a.text === i &&
              (e.splice(n, 2, {
                type: `textord`,
                mode: `text`,
                loc: Qo.range(r, a),
                text: i + i,
              }),
              --t);
          }
        }
      }
    }
    parseSymbol() {
      var e = this.fetch(),
        t = e.text;
      if (/^\\verb[^a-zA-Z]/.test(t)) {
        this.consume();
        var n = t.slice(5),
          r = n.charAt(0) === `*`;
        if ((r && (n = n.slice(1)), n.length < 2 || n.charAt(0) !== n.slice(-1)))
          throw new Dn(`\\verb assertion failed --
                    please report what input caused this bug`);
        return (
          (n = n.slice(1, -1)),
          {
            type: `verb`,
            mode: `text`,
            body: n,
            star: r,
          }
        );
      }
      rc.hasOwnProperty(t[0]) &&
        !$r[this.mode][t[0]] &&
        (this.settings.strict &&
          this.mode === `math` &&
          this.settings.reportNonstrict(
            `unicodeTextInMathMode`,
            `Accented Unicode text character "` + t[0] + `" used in math mode`,
            e,
          ),
        (t = rc[t[0]] + t.slice(1)));
      var i = wee.exec(t);
      i && ((t = t.substring(0, i.index)), t === `i` ? (t = `ı`) : t === `j` && (t = `ȷ`));
      var a;
      if ($r[this.mode][t]) {
        this.settings.strict &&
          this.mode === `math` &&
          Ti.includes(t) &&
          this.settings.reportNonstrict(
            `unicodeTextInMathMode`,
            `Latin-1/Unicode text character "` + t[0] + `" used in math mode`,
            e,
          );
        var o = $r[this.mode][t].group,
          s = Qo.range(e);
        a = ro(o)
          ? {
              type: `atom`,
              mode: this.mode,
              family: o,
              loc: s,
              text: t,
            }
          : {
              type: o,
              mode: this.mode,
              loc: s,
              text: t,
            };
      } else if (t.charCodeAt(0) >= 128)
        (this.settings.strict &&
          (cr(t.charCodeAt(0))
            ? this.mode === `math` &&
              this.settings.reportNonstrict(
                `unicodeTextInMathMode`,
                `Unicode text character "` + t[0] + `" used in math mode`,
                e,
              )
            : this.settings.reportNonstrict(
                `unknownSymbol`,
                `Unrecognized Unicode character "` + t[0] + `"` + (` (` + t.charCodeAt(0) + `)`),
                e,
              )),
          (a = {
            type: `textord`,
            mode: `text`,
            loc: Qo.range(e),
            text: t,
          }));
      else return null;
      if ((this.consume(), i))
        for (var c = 0; c < i[0].length; c++) {
          var l = i[0][c];
          if (!nc[l]) throw new Dn(`Unknown accent ' ` + l + `'`, e);
          var u = nc[l][this.mode] || nc[l].text;
          if (!u) throw new Dn(`Accent ` + l + ` unsupported in ` + this.mode + ` mode`, e);
          a = {
            type: `accent`,
            mode: this.mode,
            loc: Qo.range(e),
            label: u,
            isStretchy: !1,
            isShifty: !0,
            base: a,
          };
        }
      return a;
    }
  };
ic.endOfExpression = new Set([`}`, `\\endgroup`, `\\end`, `\\right`, `&`]);
var ac = function (e, t) {
    if (!(typeof e == `string` || e instanceof String))
      throw TypeError(`KaTeX can only parse string typed expression`);
    var n = new ic(e, t);
    delete n.gullet.macros.current[`\\df@tag`];
    var r = n.parse();
    if (
      (delete n.gullet.macros.current[`\\current@color`],
      delete n.gullet.macros.current[`\\color`],
      n.gullet.macros.get(`\\df@tag`))
    ) {
      if (!t.displayMode) throw new Dn(`\\tag works only in display equations`);
      r = [
        {
          type: `tag`,
          mode: `text`,
          body: r,
          tag: n.subparse([new $o(`\\df@tag`)]),
        },
      ];
    }
    return r;
  },
  oc = function (e, t, n) {
    t.textContent = ``;
    var r = lc(e, n).toNode();
    t.appendChild(r);
  };
typeof document < `u` &&
  document.compatMode !== `CSS1Compat` &&
  (typeof console < `u` &&
    console.warn(
      `Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype.`,
    ),
  (oc = function () {
    throw new Dn(`KaTeX doesn't work in quirks mode.`);
  }));
var Aee = function (e, t) {
    return lc(e, t).toMarkup();
  },
  sc = function (e, t) {
    return ac(e, new Vn(t));
  },
  cc = function (e, t, n) {
    if (n.throwOnError || !(e instanceof Dn)) throw e;
    var r = Xi([`katex-error`], [new zr(t)]);
    return (
      r.setAttribute(`title`, e.toString()),
      r.setAttribute(`style`, `color:` + n.errorColor),
      r
    );
  },
  lc = function (e, t) {
    var n = new Vn(t);
    try {
      return qa(ac(e, n), e, n);
    } catch (t) {
      return cc(t, e, n);
    }
  };
((window.katex = {
  version: `0.17.0`,
  render: oc,
  renderToString: Aee,
  ParseError: Dn,
  SETTINGS_SCHEMA: Ln,
  __parse: sc,
  __renderToDomTree: lc,
  __renderToHTMLTree: function (e, t) {
    var n = new Vn(t);
    try {
      return Ja(ac(e, n), e, n);
    } catch (t) {
      return cc(t, e, n);
    }
  },
  __setFontMetrics: Yr,
  __defineSymbol: K,
  __defineFunction: ma,
  __defineMacro: Q,
  __domTree: {
    Span: Fr,
    Anchor: Ir,
    SymbolNode: zr,
    SvgNode: Br,
    PathNode: Vr,
    LineNode: Hr,
  },
}),
  document.addEventListener(`DOMContentLoaded`, () => {
    window.katex &&
      document.querySelectorAll(`.math`).forEach((e) => {
        window.katex.render(e.dataset.katex, e, {
          throwOnError: !1,
        });
      });
  }),
  B());
var uc = typeof document < `u`;
function dc(e) {
  return typeof e == `object` || `displayName` in e || `props` in e || `__vccOpts` in e;
}
function fc(e) {
  return e.__esModule || e[Symbol.toStringTag] === `Module` || (e.default && dc(e.default));
}
var pc = Object.assign;
function mc(e, t) {
  let n = {};
  for (let r in t) {
    let i = t[r];
    n[r] = gc(i) ? i.map(e) : e(i);
  }
  return n;
}
var hc = () => {},
  gc = Array.isArray;
function _c(e, t) {
  let n = {};
  for (let r in e) n[r] = r in t ? t[r] : e[r];
  return n;
}
var vc = Symbol(``);
function yc(e, t) {
  return pc(
    Error(),
    {
      type: e,
      [vc]: !0,
    },
    t,
  );
}
function bc(e, t) {
  return e instanceof Error && vc in e && (t == null || !!(e.type & t));
}
var xc = Symbol(``),
  Sc = Symbol(``),
  Cc = Symbol(``),
  wc = Symbol(``),
  Tc = Symbol(``);
function Ec() {
  return R(Cc);
}
function Dc(e) {
  return R(wc);
}
B();
var Oc = /#/g,
  kc = /&/g,
  Ac = /\//g,
  jc = /=/g,
  Mc = /\?/g,
  Nc = /\+/g,
  Pc = /%5B/g,
  Fc = /%5D/g,
  Ic = /%5E/g,
  Lc = /%60/g,
  Rc = /%7B/g,
  zc = /%7C/g,
  Bc = /%7D/g,
  Vc = /%20/g;
function Hc(e) {
  return e == null
    ? ``
    : encodeURI(`` + e)
        .replace(zc, `|`)
        .replace(Pc, `[`)
        .replace(Fc, `]`);
}
function Uc(e) {
  return Hc(e).replace(Rc, `{`).replace(Bc, `}`).replace(Ic, `^`);
}
function Wc(e) {
  return Hc(e)
    .replace(Nc, `%2B`)
    .replace(Vc, `+`)
    .replace(Oc, `%23`)
    .replace(kc, `%26`)
    .replace(Lc, "`")
    .replace(Rc, `{`)
    .replace(Bc, `}`)
    .replace(Ic, `^`);
}
function Gc(e) {
  return Wc(e).replace(jc, `%3D`);
}
function Kc(e) {
  return Hc(e).replace(Oc, `%23`).replace(Mc, `%3F`);
}
function qc(e) {
  return Kc(e).replace(Ac, `%2F`);
}
function Jc(e) {
  if (e == null) return null;
  try {
    return decodeURIComponent(`` + e);
  } catch {}
  return `` + e;
}
var Yc = /\/$/,
  Xc = (e) => e.replace(Yc, ``);
function Zc(e, t, n = `/`) {
  let r,
    i = {},
    a = ``,
    o = ``,
    s = t.indexOf(`#`),
    c = t.indexOf(`?`);
  return (
    (c = s >= 0 && c > s ? -1 : c),
    c >= 0 && ((r = t.slice(0, c)), (a = t.slice(c, s > 0 ? s : t.length)), (i = e(a.slice(1)))),
    s >= 0 && ((r ||= t.slice(0, s)), (o = t.slice(s, t.length))),
    (r = al(r ?? t, n)),
    {
      fullPath: r + a + o,
      path: r,
      query: i,
      hash: Jc(o),
    }
  );
}
function Qc(e, t) {
  let n = t.query ? e(t.query) : ``;
  return t.path + (n && `?`) + n + (t.hash || ``);
}
function $c(e, t) {
  return !t || !e.toLowerCase().startsWith(t.toLowerCase()) ? e : e.slice(t.length) || `/`;
}
function el(e, t, n) {
  let r = t.matched.length - 1,
    i = n.matched.length - 1;
  return (
    r > -1 &&
    r === i &&
    tl(t.matched[r], n.matched[i]) &&
    nl(t.params, n.params) &&
    e(t.query) === e(n.query) &&
    t.hash === n.hash
  );
}
function tl(e, t) {
  return (e.aliasOf || e) === (t.aliasOf || t);
}
function nl(e, t) {
  if (Object.keys(e).length !== Object.keys(t).length) return !1;
  for (var n in e) if (!rl(e[n], t[n])) return !1;
  return !0;
}
function rl(e, t) {
  return gc(e) ? il(e, t) : gc(t) ? il(t, e) : (e && e.valueOf()) === (t && t.valueOf());
}
function il(e, t) {
  return gc(t)
    ? e.length === t.length && e.every((e, n) => e === t[n])
    : e.length === 1 && e[0] === t;
}
function al(e, t) {
  if (e.startsWith(`/`)) return e;
  if (!e) return t;
  let n = t.split(`/`),
    r = e.split(`/`),
    i = r[r.length - 1];
  (i === `..` || i === `.`) && r.push(``);
  let a = n.length - 1,
    o,
    s;
  for (o = 0; o < r.length; o++)
    if (((s = r[o]), s !== `.`))
      if (s === `..`) a > 1 && a--;
      else break;
  return n.slice(0, a).join(`/`) + `/` + r.slice(o).join(`/`);
}
var ol = {
  path: `/`,
  name: void 0,
  params: {},
  query: {},
  hash: ``,
  fullPath: `/`,
  matched: [],
  meta: {},
  redirectedFrom: void 0,
};
function sl(e) {
  if (!e)
    if (uc) {
      let t = document.querySelector(`base`);
      ((e = (t && t.getAttribute(`href`)) || `/`), (e = e.replace(/^\w+:\/\/[^/]+/, ``)));
    } else e = `/`;
  return (e[0] !== `/` && e[0] !== `#` && (e = `/` + e), Xc(e));
}
var cl = /^[^#]+#/;
function ll(e, t) {
  return e.replace(cl, `#`) + t;
}
function ul(e, t) {
  let n = document.documentElement.getBoundingClientRect(),
    r = e.getBoundingClientRect();
  return {
    behavior: t.behavior,
    left: r.left - n.left - (t.left || 0),
    top: r.top - n.top - (t.top || 0),
  };
}
var dl = () => ({
  left: window.scrollX,
  top: window.scrollY,
});
function fl(e) {
  let t;
  if (`el` in e) {
    let n = e.el,
      r = typeof n == `string` && n.startsWith(`#`),
      i =
        typeof n == `string`
          ? r
            ? document.getElementById(n.slice(1))
            : document.querySelector(n)
          : n;
    if (!i) return;
    t = ul(i, e);
  } else t = e;
  `scrollBehavior` in document.documentElement.style
    ? window.scrollTo(t)
    : window.scrollTo(
        t.left == null ? window.scrollX : t.left,
        t.top == null ? window.scrollY : t.top,
      );
}
function pl(e, t) {
  return (history.state ? history.state.position - t : -1) + e;
}
var ml = new Map();
function hl(e, t) {
  ml.set(e, t);
}
function gl(e) {
  let t = ml.get(e);
  return (ml.delete(e), t);
}
function _l(e) {
  return typeof e == `string` || (e && typeof e == `object`);
}
function vl(e) {
  return typeof e == `string` || typeof e == `symbol`;
}
function yl(e) {
  let t = {};
  if (e === `` || e === `?`) return t;
  let n = (e[0] === `?` ? e.slice(1) : e).split(`&`);
  for (let e = 0; e < n.length; ++e) {
    let r = n[e].replace(Nc, ` `),
      i = r.indexOf(`=`),
      a = Jc(i < 0 ? r : r.slice(0, i)),
      o = i < 0 ? null : Jc(r.slice(i + 1));
    if (a in t) {
      let e = t[a];
      (gc(e) || (e = t[a] = [e]), e.push(o));
    } else t[a] = o;
  }
  return t;
}
function bl(e) {
  let t = ``;
  for (let n in e) {
    let r = e[n];
    if (((n = Gc(n)), r == null)) {
      r !== void 0 && (t += (t.length ? `&` : ``) + n);
      continue;
    }
    (gc(r) ? r.map((e) => e && Wc(e)) : [r && Wc(r)]).forEach((e) => {
      e !== void 0 && ((t += (t.length ? `&` : ``) + n), e != null && (t += `=` + e));
    });
  }
  return t;
}
function xl(e) {
  let t = {};
  for (let n in e) {
    let r = e[n];
    r !== void 0 &&
      (t[n] = gc(r) ? r.map((e) => (e == null ? null : `` + e)) : r == null ? r : `` + r);
  }
  return t;
}
function Sl() {
  let e = [];
  function t(t) {
    return (
      e.push(t),
      () => {
        let n = e.indexOf(t);
        n > -1 && e.splice(n, 1);
      }
    );
  }
  function n() {
    e = [];
  }
  return {
    add: t,
    list: () => e.slice(),
    reset: n,
  };
}
function Cl(e, t, n) {
  let r = e.value;
  if (!r) return;
  let i = r,
    a = () => {
      i[t].delete(n);
    };
  (E(a),
    pe(a),
    ne(() => {
      let r = e.value;
      (r && (i = r), i[t].add(n));
    }),
    i[t].add(n));
}
function wl(e) {
  Cl(R(xc, {}), `leaveGuards`, e);
}
function Tl(e, t, n, r, i, a = (e) => e()) {
  let o = r && (r.enterCallbacks[i] = r.enterCallbacks[i] || []);
  return () =>
    new Promise((s, c) => {
      let l = (e) => {
          e === !1
            ? c(
                yc(4, {
                  from: n,
                  to: t,
                }),
              )
            : e instanceof Error
              ? c(e)
              : _l(e)
                ? c(
                    yc(2, {
                      from: t,
                      to: e,
                    }),
                  )
                : (o && r.enterCallbacks[i] === o && typeof e == `function` && o.push(e), s());
        },
        u = a(() => e.call(r && r.instances[i], t, n, l)),
        d = Promise.resolve(u);
      (e.length < 3 && (d = d.then(l)), d.catch((e) => c(e)));
    });
}
function El(e, t, n, r, i = (e) => e()) {
  let a = [];
  for (let o of e)
    for (let e in o.components) {
      let s = o.components[e];
      if (!(t !== `beforeRouteEnter` && !o.instances[e]))
        if (dc(s)) {
          let c = (s.__vccOpts || s)[t];
          c && a.push(Tl(c, n, r, o, e, i));
        } else {
          let c = s();
          a.push(() =>
            c.then((a) => {
              if (!a) throw Error(`Couldn't resolve component "${e}" at "${o.path}"`);
              let s = fc(a) ? a.default : a;
              ((o.mods[e] = a), (o.components[e] = s));
              let c = (s.__vccOpts || s)[t];
              return c && Tl(c, n, r, o, e, i)();
            }),
          );
        }
    }
  return a;
}
function jee(e, t) {
  let n = [],
    r = [],
    i = [],
    a = Math.max(t.matched.length, e.matched.length);
  for (let o = 0; o < a; o++) {
    let a = t.matched[o];
    a && (e.matched.find((e) => tl(e, a)) ? r.push(a) : n.push(a));
    let s = e.matched[o];
    s && (t.matched.find((e) => tl(e, s)) || i.push(s));
  }
  return [n, r, i];
}
B();
var Mee = () => location.protocol + `//` + location.host;
function Dl(e, t) {
  let { pathname: n, search: r, hash: i } = t,
    a = e.indexOf(`#`);
  if (a > -1) {
    let t = i.includes(e.slice(a)) ? e.slice(a).length : 1,
      n = i.slice(t);
    return (n[0] !== `/` && (n = `/` + n), $c(n, ``));
  }
  return $c(n, e) + r + i;
}
function Nee(e, t, n, r) {
  let i = [],
    a = [],
    o = null,
    s = ({ state: a }) => {
      let s = Dl(e, location),
        c = n.value,
        l = t.value,
        u = 0;
      if (a) {
        if (((n.value = s), (t.value = a), o && o === c)) {
          o = null;
          return;
        }
        u = l ? a.position - l.position : 0;
      } else r(s);
      i.forEach((e) => {
        e(n.value, c, {
          delta: u,
          type: `pop`,
          direction: u ? (u > 0 ? `forward` : `back`) : ``,
        });
      });
    };
  function c() {
    o = n.value;
  }
  function l(e) {
    i.push(e);
    let t = () => {
      let t = i.indexOf(e);
      t > -1 && i.splice(t, 1);
    };
    return (a.push(t), t);
  }
  function u() {
    if (document.visibilityState === `hidden`) {
      let { history: e } = window;
      if (!e.state) return;
      e.replaceState(
        pc({}, e.state, {
          scroll: dl(),
        }),
        ``,
      );
    }
  }
  function d() {
    for (let e of a) e();
    ((a = []),
      window.removeEventListener(`popstate`, s),
      window.removeEventListener(`pagehide`, u),
      document.removeEventListener(`visibilitychange`, u));
  }
  return (
    window.addEventListener(`popstate`, s),
    window.addEventListener(`pagehide`, u),
    document.addEventListener(`visibilitychange`, u),
    {
      pauseListeners: c,
      listen: l,
      destroy: d,
    }
  );
}
function Ol(e, t, n, r = !1, i = !1) {
  return {
    back: e,
    current: t,
    forward: n,
    replaced: r,
    position: window.history.length,
    scroll: i ? dl() : null,
  };
}
function Pee(e) {
  let { history: t, location: n } = window,
    r = {
      value: Dl(e, n),
    },
    i = {
      value: t.state,
    };
  i.value ||
    a(
      r.value,
      {
        back: null,
        current: r.value,
        forward: null,
        position: t.length - 1,
        replaced: !0,
        scroll: null,
      },
      !0,
    );
  function a(r, a, o) {
    let s = e.indexOf(`#`),
      c = s > -1 ? (n.host && document.querySelector(`base`) ? e : e.slice(s)) + r : Mee() + e + r;
    try {
      (t[o ? `replaceState` : `pushState`](a, ``, c), (i.value = a));
    } catch (e) {
      (console.error(e), n[o ? `replace` : `assign`](c));
    }
  }
  function o(e, n) {
    (a(
      e,
      pc({}, t.state, Ol(i.value.back, e, i.value.forward, !0), n, {
        position: i.value.position,
      }),
      !0,
    ),
      (r.value = e));
  }
  function s(e, n) {
    let o = pc({}, i.value, t.state, {
      forward: e,
      scroll: dl(),
    });
    (a(o.current, o, !0),
      a(
        e,
        pc(
          {},
          Ol(r.value, e, null),
          {
            position: o.position + 1,
          },
          n,
        ),
        !1,
      ),
      (r.value = e));
  }
  return {
    location: r,
    state: i,
    push: s,
    replace: o,
  };
}
function Fee(e) {
  e = sl(e);
  let t = Pee(e),
    n = Nee(e, t.state, t.location, t.replace);
  function r(e, t = !0) {
    (t || n.pauseListeners(), history.go(e));
  }
  let i = pc(
    {
      location: ``,
      base: e,
      go: r,
      createHref: ll.bind(null, e),
    },
    t,
    n,
  );
  return (
    Object.defineProperty(i, "location", {
      enumerable: !0,
      get: () => t.location.value,
    }),
    Object.defineProperty(i, "state", {
      enumerable: !0,
      get: () => t.state.value,
    }),
    i
  );
}
var Iee = {
    type: 0,
    value: ``,
  },
  Lee = /[a-zA-Z0-9_]/;
function Ree(e) {
  if (!e) return [[]];
  if (e === `/`) return [[Iee]];
  if (!e.startsWith(`/`)) throw Error(`Invalid path "${e}"`);
  function t(e) {
    throw Error(`ERR (${n})/"${l}": ${e}`);
  }
  let n = 0,
    r = n,
    i = [],
    a;
  function o() {
    (a && i.push(a), (a = []));
  }
  let s = 0,
    c,
    l = ``,
    u = ``;
  function d() {
    l &&=
      (n === 0
        ? a.push({
            type: 0,
            value: l,
          })
        : n === 1 || n === 2 || n === 3
          ? (a.length > 1 &&
              (c === `*` || c === `+`) &&
              t(`A repeatable param (${l}) must be alone in its segment. eg: '/:ids+.`),
            a.push({
              type: 1,
              value: l,
              regexp: u,
              repeatable: c === `*` || c === `+`,
              optional: c === `*` || c === `?`,
            }))
          : t(`Invalid state to consume buffer`),
      ``);
  }
  function f() {
    l += c;
  }
  for (; s < e.length;)
    switch (((c = e[s++]), n)) {
      case 0:
        c === `\\`
          ? ((r = n), (n = 4))
          : c === `/`
            ? (l && d(), o())
            : c === `:`
              ? (d(), (n = 1))
              : f();
        break;
      case 4:
        (f(), (n = r));
        break;
      case 1:
        c === `(`
          ? (n = 2)
          : Lee.test(c)
            ? f()
            : (d(), (n = 0), c !== `*` && c !== `?` && c !== `+` && s--);
        break;
      case 2:
        c === `)` ? (u[u.length - 1] == `\\` ? (u = u.slice(0, -1) + c) : (n = 3)) : (u += c);
        break;
      case 3:
        (d(), (n = 0), c !== `*` && c !== `?` && c !== `+` && s--, (u = ``));
        break;
      default:
        t(`Unknown state`);
        break;
    }
  return (n === 2 && t(`Unfinished custom RegExp for param "${l}"`), d(), o(), i);
}
var kl = `[^/]+?`,
  zee = {
    sensitive: !1,
    strict: !1,
    start: !0,
    end: !0,
  },
  Bee = /[.+*?^${}()[\]/\\]/g;
function Vee(e, t) {
  let n = pc({}, zee, t),
    r = [],
    i = n.start ? `^` : ``,
    a = [];
  for (let t of e) {
    let e = t.length ? [] : [90];
    n.strict && !t.length && (i += `/`);
    for (let r = 0; r < t.length; r++) {
      let o = t[r],
        s = 40 + (n.sensitive ? 0.25 : 0);
      if (o.type === 0) (r || (i += `/`), (i += o.value.replace(Bee, `\\$&`)), (s += 40));
      else if (o.type === 1) {
        let { value: e, repeatable: n, optional: c, regexp: l } = o;
        a.push({
          name: e,
          repeatable: n,
          optional: c,
        });
        let u = l || kl;
        if (u !== kl) {
          s += 10;
          try {
            RegExp(`(${u})`);
          } catch (t) {
            throw Error(`Invalid custom RegExp for param "${e}" (${u}): ` + t.message);
          }
        }
        let d = n ? `((?:${u})(?:/(?:${u}))*)` : `(${u})`;
        (r || (d = c && t.length < 2 ? `(?:/${d})` : `/` + d),
          c && (d += `?`),
          (i += d),
          (s += 20),
          c && (s += -8),
          n && (s += -20),
          u === `.*` && (s += -50));
      }
      e.push(s);
    }
    r.push(e);
  }
  if (n.strict && n.end) {
    let e = r.length - 1;
    r[e][r[e].length - 1] += 0.7000000000000001;
  }
  (n.strict || (i += `/?`), n.end ? (i += `$`) : n.strict && !i.endsWith(`/`) && (i += `(?:/|$)`));
  let o = new RegExp(i, n.sensitive ? `` : `i`);
  function s(e) {
    let t = e.match(o),
      n = {};
    if (!t) return null;
    for (let e = 1; e < t.length; e++) {
      let r = t[e] || ``,
        i = a[e - 1];
      n[i.name] = r && i.repeatable ? r.split(`/`) : r;
    }
    return n;
  }
  function c(t) {
    let n = ``,
      r = !1;
    for (let i of e) {
      ((!r || !n.endsWith(`/`)) && (n += `/`), (r = !1));
      for (let e of i)
        if (e.type === 0) n += e.value;
        else if (e.type === 1) {
          let { value: a, repeatable: o, optional: s } = e,
            c = a in t ? t[a] : ``;
          if (gc(c) && !o)
            throw Error(
              `Provided param "${a}" is an array but it is not repeatable (* or + modifiers)`,
            );
          let l = gc(c) ? c.join(`/`) : c;
          if (!l)
            if (s) i.length < 2 && (n.endsWith(`/`) ? (n = n.slice(0, -1)) : (r = !0));
            else throw Error(`Missing required param "${a}"`);
          n += l;
        }
    }
    return n || `/`;
  }
  return {
    re: o,
    score: r,
    keys: a,
    parse: s,
    stringify: c,
  };
}
function Hee(e, t) {
  let n = 0;
  for (; n < e.length && n < t.length;) {
    let r = t[n] - e[n];
    if (r) return r;
    n++;
  }
  return e.length < t.length
    ? e.length === 1 && e[0] === 80
      ? -1
      : 1
    : e.length > t.length
      ? t.length === 1 && t[0] === 80
        ? 1
        : -1
      : 0;
}
function Al(e, t) {
  let n = 0,
    r = e.score,
    i = t.score;
  for (; n < r.length && n < i.length;) {
    let e = Hee(r[n], i[n]);
    if (e) return e;
    n++;
  }
  if (Math.abs(i.length - r.length) === 1) {
    if (jl(r)) return 1;
    if (jl(i)) return -1;
  }
  return i.length - r.length;
}
function jl(e) {
  let t = e[e.length - 1];
  return e.length > 0 && t[t.length - 1] < 0;
}
var Uee = {
  strict: !1,
  end: !0,
  sensitive: !1,
};
function Wee(e, t, n) {
  let r = pc(Vee(Ree(e.path), n), {
    record: e,
    parent: t,
    children: [],
    alias: [],
  });
  return (t && !r.record.aliasOf == !t.record.aliasOf && t.children.push(r), r);
}
function Gee(e, t) {
  let n = [],
    r = new Map();
  t = _c(Uee, t);
  function i(e) {
    return r.get(e);
  }
  function a(e, n, r) {
    let i = !r,
      s = Nl(e);
    s.aliasOf = r && r.record;
    let l = _c(t, e),
      u = [s];
    if (`alias` in e) {
      let t = typeof e.alias == `string` ? [e.alias] : e.alias;
      for (let e of t)
        u.push(
          Nl(
            pc({}, s, {
              components: r ? r.record.components : s.components,
              path: e,
              aliasOf: r ? r.record : s,
            }),
          ),
        );
    }
    let d, f;
    for (let t of u) {
      let { path: u } = t;
      if (n && u[0] !== `/`) {
        let e = n.record.path,
          r = e[e.length - 1] === `/` ? `` : `/`;
        t.path = n.record.path + (u && r + u);
      }
      if (
        ((d = Wee(t, n, l)),
        r
          ? r.alias.push(d)
          : ((f ||= d), f !== d && f.alias.push(d), i && e.name && !Pl(d) && o(e.name)),
        Fl(d) && c(d),
        s.children)
      ) {
        let e = s.children;
        for (let t = 0; t < e.length; t++) a(e[t], d, r && r.children[t]);
      }
      r ||= d;
    }
    return f
      ? () => {
          o(f);
        }
      : hc;
  }
  function o(e) {
    if (vl(e)) {
      let t = r.get(e);
      t && (r.delete(e), n.splice(n.indexOf(t), 1), t.children.forEach(o), t.alias.forEach(o));
    } else {
      let t = n.indexOf(e);
      t > -1 &&
        (n.splice(t, 1),
        e.record.name && r.delete(e.record.name),
        e.children.forEach(o),
        e.alias.forEach(o));
    }
  }
  function s() {
    return n;
  }
  function c(e) {
    let t = Jee(e, n);
    (n.splice(t, 0, e), e.record.name && !Pl(e) && r.set(e.record.name, e));
  }
  function l(e, t) {
    let i,
      a = {},
      o,
      s;
    if (`name` in e && e.name) {
      if (((i = r.get(e.name)), !i))
        throw yc(1, {
          location: e,
        });
      ((s = i.record.name),
        (a = pc(
          Ml(
            t.params,
            i.keys
              .filter((e) => !e.optional)
              .concat(i.parent ? i.parent.keys.filter((e) => e.optional) : [])
              .map((e) => e.name),
          ),
          e.params &&
            Ml(
              e.params,
              i.keys.map((e) => e.name),
            ),
        )),
        (o = i.stringify(a)));
    } else if (e.path != null)
      ((o = e.path),
        (i = n.find((e) => e.re.test(o))),
        i &&
          ((a = i.parse(o)),
          (s = i.record.name),
          i.keys.forEach((e) => {
            e.optional && !a[e.name] && delete a[e.name];
          })));
    else {
      if (((i = t.name ? r.get(t.name) : n.find((e) => e.re.test(t.path))), !i))
        throw yc(1, {
          location: e,
          currentLocation: t,
        });
      ((s = i.record.name), (a = pc({}, t.params, e.params)), (o = i.stringify(a)));
    }
    let c = [],
      l = i;
    for (; l;) (c.unshift(l.record), (l = l.parent));
    return {
      name: s,
      path: o,
      params: a,
      matched: c,
      meta: qee(c),
    };
  }
  e.forEach((e) => a(e));
  function u() {
    ((n.length = 0), r.clear());
  }
  return {
    addRoute: a,
    resolve: l,
    removeRoute: o,
    clearRoutes: u,
    getRoutes: s,
    getRecordMatcher: i,
  };
}
function Ml(e, t) {
  let n = {};
  for (let r of t) r in e && (n[r] = e[r]);
  return n;
}
function Nl(e) {
  let t = {
    path: e.path,
    redirect: e.redirect,
    name: e.name,
    meta: e.meta || {},
    aliasOf: e.aliasOf,
    beforeEnter: e.beforeEnter,
    props: Kee(e),
    children: e.children || [],
    instances: {},
    leaveGuards: new Set(),
    updateGuards: new Set(),
    enterCallbacks: {},
    components:
      `components` in e
        ? e.components || null
        : e.component && {
            default: e.component,
          },
  };
  return (
    Object.defineProperty(t, "mods", {
      value: {},
    }),
    t
  );
}
function Kee(e) {
  let t = {},
    n = e.props || !1;
  if (`component` in e) t.default = n;
  else for (let r in e.components) t[r] = typeof n == `object` ? n[r] : n;
  return t;
}
function Pl(e) {
  for (; e;) {
    if (e.record.aliasOf) return !0;
    e = e.parent;
  }
  return !1;
}
function qee(e) {
  return e.reduce((e, t) => pc(e, t.meta), {});
}
function Jee(e, t) {
  let n = 0,
    r = t.length;
  for (; n !== r;) {
    let i = (n + r) >> 1;
    Al(e, t[i]) < 0 ? (r = i) : (n = i + 1);
  }
  let i = Yee(e);
  return (i && (r = t.lastIndexOf(i, r - 1)), r);
}
function Yee(e) {
  let t = e;
  for (; (t = t.parent);) if (Fl(t) && Al(e, t) === 0) return t;
}
function Fl({ record: e }) {
  return !!(e.name || (e.components && Object.keys(e.components).length) || e.redirect);
}
function Il(e) {
  let t = R(Cc),
    n = R(wc),
    r = V(() => {
      let n = P(e.to);
      return t.resolve(n);
    }),
    i = V(() => {
      let { matched: e } = r.value,
        { length: t } = e,
        i = e[t - 1],
        a = n.matched;
      if (!i || !a.length) return -1;
      let o = a.findIndex(tl.bind(null, i));
      if (o > -1) return o;
      let s = Ll(e[t - 2]);
      return t > 1 && Ll(i) === s && a[a.length - 1].path !== s
        ? a.findIndex(tl.bind(null, e[t - 2]))
        : o;
    }),
    a = V(() => i.value > -1 && $ee(n.params, r.value.params)),
    o = V(() => i.value > -1 && i.value === n.matched.length - 1 && nl(n.params, r.value.params));
  function s(n = {}) {
    if (Qee(n)) {
      let n = t[P(e.replace) ? `replace` : `push`](P(e.to)).catch(hc);
      return (
        e.viewTransition &&
          typeof document < `u` &&
          `startViewTransition` in document &&
          document.startViewTransition(() => n),
        n
      );
    }
    return Promise.resolve();
  }
  return {
    route: r,
    href: V(() => r.value.href),
    isActive: a,
    isExactActive: o,
    navigate: s,
  };
}
function Xee(e) {
  return e.length === 1 ? e[0] : e;
}
var Zee = k({
  name: `RouterLink`,
  compatConfig: {
    MODE: 3,
  },
  props: {
    to: {
      type: [String, Object],
      required: !0,
    },
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    custom: Boolean,
    ariaCurrentValue: {
      type: String,
      default: `page`,
    },
    viewTransition: Boolean,
  },
  useLink: Il,
  setup(e, { slots: t }) {
    let n = Ae(Il(e)),
      { options: r } = R(Cc),
      i = V(() => ({
        [Rl(e.activeClass, r.linkActiveClass, `router-link-active`)]: n.isActive,
        [Rl(e.exactActiveClass, r.linkExactActiveClass, `router-link-exact-active`)]:
          n.isExactActive,
      }));
    return () => {
      let r = t.default && Xee(t.default(n));
      return e.custom
        ? r
        : Ne(
            `a`,
            {
              "aria-current": n.isExactActive ? e.ariaCurrentValue : null,
              href: n.href,
              onClick: n.navigate,
              class: i.value,
            },
            r,
          );
    };
  },
});
function Qee(e) {
  if (
    !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) &&
    !e.defaultPrevented &&
    !(e.button !== void 0 && e.button !== 0)
  ) {
    if (e.currentTarget && e.currentTarget.getAttribute) {
      let t = e.currentTarget.getAttribute(`target`);
      if (/\b_blank\b/i.test(t)) return;
    }
    return (e.preventDefault && e.preventDefault(), !0);
  }
}
function $ee(e, t) {
  for (let n in t) {
    let r = t[n],
      i = e[n];
    if (typeof r == `string`) {
      if (r !== i) return !1;
    } else if (!gc(i) || i.length !== r.length || r.some((e, t) => e.valueOf() !== i[t].valueOf()))
      return !1;
  }
  return !0;
}
function Ll(e) {
  return e ? (e.aliasOf ? e.aliasOf.path : e.path) : ``;
}
var Rl = (e, t, n) => e ?? t ?? n,
  ete = k({
    name: `RouterView`,
    inheritAttrs: !1,
    props: {
      name: {
        type: String,
        default: `default`,
      },
      route: Object,
    },
    compatConfig: {
      MODE: 3,
    },
    setup(e, { attrs: t, slots: n }) {
      let r = R(Tc),
        i = V(() => e.route || r.value),
        a = R(Sc, 0),
        o = V(() => {
          let e = P(a),
            { matched: t } = i.value,
            n;
          for (; (n = t[e]) && !n.components;) e++;
          return e;
        }),
        s = V(() => i.value.matched[o.value]);
      (ge(
        Sc,
        V(() => o.value + 1),
      ),
        ge(xc, s),
        ge(Tc, i));
      let c = F();
      return (
        He(
          () => [c.value, s.value, e.name],
          ([e, t, n], [r, i, a]) => {
            (t &&
              ((t.instances[n] = e),
              i &&
                i !== t &&
                e &&
                e === r &&
                (t.leaveGuards.size || (t.leaveGuards = i.leaveGuards),
                t.updateGuards.size || (t.updateGuards = i.updateGuards))),
              e &&
                t &&
                (!i || !tl(t, i) || !r) &&
                (t.enterCallbacks[n] || []).forEach((t) => t(e)));
          },
          {
            flush: `post`,
          },
        ),
        () => {
          let r = i.value,
            a = e.name,
            o = s.value,
            l = o && o.components[a];
          if (!l)
            return zl(n.default, {
              Component: l,
              route: r,
            });
          let u = o.props[a],
            d = Ne(
              l,
              pc({}, u ? (u === !0 ? r.params : typeof u == `function` ? u(r) : u) : null, t, {
                onVnodeUnmounted: (e) => {
                  e.component.isUnmounted && (o.instances[a] = null);
                },
                ref: c,
              }),
            );
          return (
            zl(n.default, {
              Component: d,
              route: r,
            }) || d
          );
        }
      );
    },
  });
function zl(e, t) {
  if (!e) return null;
  let n = e(t);
  return n.length === 1 ? n[0] : n;
}
var tte = ete;
function nte(e) {
  let t = Gee(e.routes, e),
    n = e.parseQuery || yl,
    r = e.stringifyQuery || bl,
    i = e.history,
    a = Sl(),
    o = Sl(),
    s = Sl(),
    c = xe(ol),
    l = ol;
  uc &&
    e.scrollBehavior &&
    `scrollRestoration` in history &&
    (history.scrollRestoration = `manual`);
  let u = mc.bind(null, (e) => `` + e),
    d = mc.bind(null, qc),
    f = mc.bind(null, Jc);
  function p(e, n) {
    let r, i;
    return (vl(e) ? ((r = t.getRecordMatcher(e)), (i = n)) : (i = e), t.addRoute(i, r));
  }
  function m(e) {
    let n = t.getRecordMatcher(e);
    n && t.removeRoute(n);
  }
  function h() {
    return t.getRoutes().map((e) => e.record);
  }
  function g(e) {
    return !!t.getRecordMatcher(e);
  }
  function v(e, a) {
    if (((a = pc({}, a || c.value)), typeof e == `string`)) {
      let r = Zc(n, e, a.path),
        o = t.resolve(
          {
            path: r.path,
          },
          a,
        ),
        s = i.createHref(r.fullPath);
      return pc(r, o, {
        params: f(o.params),
        redirectedFrom: void 0,
        href: s,
      });
    }
    let o;
    if (e.path != null)
      o = pc({}, e, {
        path: Zc(n, e.path, a.path).path,
      });
    else {
      let t = pc({}, e.params);
      for (let e in t) t[e] ?? delete t[e];
      ((o = pc({}, e, {
        params: d(t),
      })),
        (a.params = d(a.params)));
    }
    let s = t.resolve(o, a),
      l = e.hash || ``;
    s.params = u(f(s.params));
    let p = Qc(
        r,
        pc({}, e, {
          hash: Uc(l),
          path: s.path,
        }),
      ),
      m = i.createHref(p);
    return pc(
      {
        fullPath: p,
        hash: l,
        query: r === bl ? xl(e.query) : e.query || {},
      },
      s,
      {
        redirectedFrom: void 0,
        href: m,
      },
    );
  }
  function y(e) {
    return typeof e == `string` ? Zc(n, e, c.value.path) : pc({}, e);
  }
  function b(e, t) {
    if (l !== e)
      return yc(8, {
        from: t,
        to: e,
      });
  }
  function x(e) {
    return w(e);
  }
  function S(e) {
    return x(
      pc(y(e), {
        replace: !0,
      }),
    );
  }
  function C(e, t) {
    let n = e.matched[e.matched.length - 1];
    if (n && n.redirect) {
      let { redirect: r } = n,
        i = typeof r == `function` ? r(e, t) : r;
      return (
        typeof i == `string` &&
          ((i =
            i.includes(`?`) || i.includes(`#`)
              ? (i = y(i))
              : {
                  path: i,
                }),
          (i.params = {})),
        pc(
          {
            query: e.query,
            hash: e.hash,
            params: i.path == null ? e.params : {},
          },
          i,
        )
      );
    }
  }
  function w(e, t) {
    let n = (l = v(e)),
      i = c.value,
      a = e.state,
      o = e.force,
      s = e.replace === !0,
      u = C(n, i);
    if (u)
      return w(
        pc(y(u), {
          state: typeof u == `object` ? pc({}, a, u.state) : a,
          force: o,
          replace: s,
        }),
        t || n,
      );
    let d = n;
    d.redirectedFrom = t;
    let f;
    return (
      !o &&
        el(r, i, n) &&
        ((f = yc(16, {
          to: d,
          from: i,
        })),
        oe(i, i, !0, !1)),
      (f ? Promise.resolve(f) : D(d, i))
        .catch((e) => (bc(e) ? (bc(e, 2) ? e : ae(e)) : ie(e, d, i)))
        .then((e) => {
          if (e) {
            if (bc(e, 2))
              return w(
                pc(
                  {
                    replace: s,
                  },
                  y(e.to),
                  {
                    state: typeof e.to == `object` ? pc({}, a, e.to.state) : a,
                    force: o,
                  },
                ),
                t || d,
              );
          } else e = te(d, i, !0, s, a);
          return (ee(d, i, e), e);
        })
    );
  }
  function T(e, t) {
    let n = b(e, t);
    return n ? Promise.reject(n) : Promise.resolve();
  }
  function E(e) {
    let t = le.values().next().value;
    return t && typeof t.runWithContext == `function` ? t.runWithContext(e) : e();
  }
  function D(e, t) {
    let n,
      [r, i, s] = jee(e, t);
    n = El(r.reverse(), `beforeRouteLeave`, e, t);
    for (let i of r)
      i.leaveGuards.forEach((r) => {
        n.push(Tl(r, e, t));
      });
    let c = T.bind(null, e, t);
    return (
      n.push(c),
      fe(n)
        .then(() => {
          n = [];
          for (let r of a.list()) n.push(Tl(r, e, t));
          return (n.push(c), fe(n));
        })
        .then(() => {
          n = El(i, `beforeRouteUpdate`, e, t);
          for (let r of i)
            r.updateGuards.forEach((r) => {
              n.push(Tl(r, e, t));
            });
          return (n.push(c), fe(n));
        })
        .then(() => {
          n = [];
          for (let r of s)
            if (r.beforeEnter)
              if (gc(r.beforeEnter)) for (let i of r.beforeEnter) n.push(Tl(i, e, t));
              else n.push(Tl(r.beforeEnter, e, t));
          return (n.push(c), fe(n));
        })
        .then(
          () => (
            e.matched.forEach((e) => (e.enterCallbacks = {})),
            (n = El(s, `beforeRouteEnter`, e, t, E)),
            n.push(c),
            fe(n)
          ),
        )
        .then(() => {
          n = [];
          for (let r of o.list()) n.push(Tl(r, e, t));
          return (n.push(c), fe(n));
        })
        .catch((e) => (bc(e, 8) ? e : Promise.reject(e)))
    );
  }
  function ee(e, t, n) {
    s.list().forEach((r) => E(() => r(e, t, n)));
  }
  function te(e, t, n, r, a) {
    let o = b(e, t);
    if (o) return o;
    let s = t === ol,
      l = uc ? history.state : {};
    (n &&
      (r || s
        ? i.replace(
            e.fullPath,
            pc(
              {
                scroll: s && l && l.scroll,
              },
              a,
            ),
          )
        : i.push(e.fullPath, a)),
      (c.value = e),
      oe(e, t, n, s),
      ae());
  }
  let O;
  function k() {
    O ||= i.listen((e, t, n) => {
      if (!ue.listening) return;
      let r = v(e),
        a = C(r, ue.currentRoute.value);
      if (a) {
        w(
          pc(a, {
            replace: !0,
            force: !0,
          }),
          r,
        ).catch(hc);
        return;
      }
      l = r;
      let o = c.value;
      (uc && hl(pl(o.fullPath, n.delta), dl()),
        D(r, o)
          .catch((e) =>
            bc(e, 12)
              ? e
              : bc(e, 2)
                ? (w(
                    pc(y(e.to), {
                      force: !0,
                    }),
                    r,
                  )
                    .then((e) => {
                      bc(e, 20) && !n.delta && n.type === `pop` && i.go(-1, !1);
                    })
                    .catch(hc),
                  Promise.reject())
                : (n.delta && i.go(-n.delta, !1), ie(e, r, o)),
          )
          .then((e) => {
            ((e ||= te(r, o, !1)),
              e &&
                (n.delta && !bc(e, 8)
                  ? i.go(-n.delta, !1)
                  : n.type === `pop` && bc(e, 20) && i.go(-1, !1)),
              ee(r, o, e));
          })
          .catch(hc));
    });
  }
  let ne = Sl(),
    re = Sl(),
    A;
  function ie(e, t, n) {
    ae(e);
    let r = re.list();
    return (r.length ? r.forEach((r) => r(e, t, n)) : console.error(e), Promise.reject(e));
  }
  function j() {
    return A && c.value !== ol
      ? Promise.resolve()
      : new Promise((e, t) => {
          ne.add([e, t]);
        });
  }
  function ae(e) {
    return (A || ((A = !e), k(), ne.list().forEach(([t, n]) => (e ? n(e) : t())), ne.reset()), e);
  }
  function oe(t, n, r, i) {
    let { scrollBehavior: a } = e;
    if (!uc || !a) return Promise.resolve();
    let o =
      (!r && gl(pl(t.fullPath, 0))) || ((i || !r) && history.state && history.state.scroll) || null;
    return de()
      .then(() => a(t, n, o))
      .then((e) => e && fl(e))
      .catch((e) => ie(e, t, n));
  }
  let se = (e) => i.go(e),
    ce,
    le = new Set(),
    ue = {
      currentRoute: c,
      listening: !0,
      addRoute: p,
      removeRoute: m,
      clearRoutes: t.clearRoutes,
      hasRoute: g,
      getRoutes: h,
      resolve: v,
      options: e,
      push: x,
      replace: S,
      go: se,
      back: () => se(-1),
      forward: () => se(1),
      beforeEach: a.add,
      beforeResolve: o.add,
      afterEach: s.add,
      onError: re.add,
      isReady: j,
      install(e) {
        (e.component(`RouterLink`, Zee),
          e.component(`RouterView`, tte),
          (e.config.globalProperties.$router = ue),
          Object.defineProperty(e.config.globalProperties, "$route", {
            enumerable: !0,
            get: () => P(c),
          }),
          uc && !ce && c.value === ol && ((ce = !0), x(i.location).catch((e) => {})));
        let t = {};
        for (let e in ol)
          Object.defineProperty(t, e, {
            get: () => c.value[e],
            enumerable: !0,
          });
        (e.provide(Cc, ue), e.provide(wc, Je(t)), e.provide(Tc, c));
        let n = e.unmount;
        (le.add(e),
          (e.unmount = function () {
            (le.delete(e),
              le.size < 1 && ((l = ol), O && O(), (O = null), (c.value = ol), (ce = !1), (A = !1)),
              n());
          }));
      },
    };
  function fe(e) {
    return e.reduce((e, t) => e.then(() => E(t)), Promise.resolve());
  }
  return ue;
}
var Bl = class {
    constructor() {
      this.notificationCreatedEvent = `.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated`;
    }
    listenForWhisper(e, t) {
      return this.listen(`.client-` + e, t);
    }
    notification(e) {
      return this.listen(this.notificationCreatedEvent, e);
    }
    stopListeningForNotification(e) {
      return this.stopListening(this.notificationCreatedEvent, e);
    }
    stopListeningForWhisper(e, t) {
      return this.stopListening(`.client-` + e, t);
    }
  },
  Vl = class {
    constructor(e) {
      this.namespace = e;
    }
    format(e) {
      return [`.`, `\\`].includes(e.charAt(0))
        ? e.substring(1)
        : (this.namespace && (e = this.namespace + `.` + e), e.replace(/\./g, `\\`));
    }
    setNamespace(e) {
      this.namespace = e;
    }
  };
function rte(e) {
  try {
    return (Reflect.construct(String, [], e), !0);
  } catch {
    return !1;
  }
}
var Hl = class extends Bl {
    constructor(e, t, n) {
      (super(),
        (this.name = t),
        (this.pusher = e),
        (this.options = n),
        (this.eventFormatter = new Vl(this.options.namespace)),
        this.subscribe());
    }
    subscribe() {
      this.subscription = this.pusher.subscribe(this.name);
    }
    unsubscribe() {
      this.pusher.unsubscribe(this.name);
    }
    listen(e, t) {
      return (this.on(this.eventFormatter.format(e), t), this);
    }
    listenToAll(e) {
      return (
        this.subscription.bind_global((t, n) => {
          if (t.startsWith(`pusher:`)) return;
          let r = String(this.options.namespace ?? ``).replace(/\./g, `\\`);
          e(t.startsWith(r) ? t.substring(r.length + 1) : `.` + t, n);
        }),
        this
      );
    }
    stopListening(e, t) {
      return (
        t
          ? this.subscription.unbind(this.eventFormatter.format(e), t)
          : this.subscription.unbind(this.eventFormatter.format(e)),
        this
      );
    }
    stopListeningToAll(e) {
      return (e ? this.subscription.unbind_global(e) : this.subscription.unbind_global(), this);
    }
    subscribed(e) {
      return (
        this.on(`pusher:subscription_succeeded`, () => {
          e();
        }),
        this
      );
    }
    error(e) {
      return (
        this.on(`pusher:subscription_error`, (t) => {
          e(t);
        }),
        this
      );
    }
    on(e, t) {
      return (this.subscription.bind(e, t), this);
    }
  },
  Ul = class extends Hl {
    whisper(e, t) {
      return (this.pusher.channels.channels[this.name].trigger(`client-${e}`, t), this);
    }
  },
  ite = class extends Hl {
    whisper(e, t) {
      return (this.pusher.channels.channels[this.name].trigger(`client-${e}`, t), this);
    }
  },
  ate = class extends Ul {
    here(e) {
      return (
        this.on(`pusher:subscription_succeeded`, (t) => {
          e(Object.keys(t.members).map((e) => t.members[e]));
        }),
        this
      );
    }
    joining(e) {
      return (
        this.on(`pusher:member_added`, (t) => {
          e(t.info);
        }),
        this
      );
    }
    whisper(e, t) {
      return (this.pusher.channels.channels[this.name].trigger(`client-${e}`, t), this);
    }
    leaving(e) {
      return (
        this.on(`pusher:member_removed`, (t) => {
          e(t.info);
        }),
        this
      );
    }
  },
  Wl = class extends Bl {
    constructor(e, t, n) {
      (super(),
        (this.events = {}),
        (this.listeners = {}),
        (this.name = t),
        (this.socket = e),
        (this.options = n),
        (this.eventFormatter = new Vl(this.options.namespace)),
        this.subscribe());
    }
    subscribe() {
      this.socket.emit(`subscribe`, {
        channel: this.name,
        auth: this.options.auth || {},
      });
    }
    unsubscribe() {
      (this.unbind(),
        this.socket.emit(`unsubscribe`, {
          channel: this.name,
          auth: this.options.auth || {},
        }));
    }
    listen(e, t) {
      return (this.on(this.eventFormatter.format(e), t), this);
    }
    stopListening(e, t) {
      return (this.unbindEvent(this.eventFormatter.format(e), t), this);
    }
    subscribed(e) {
      return (
        this.on(`connect`, (t) => {
          e(t);
        }),
        this
      );
    }
    error(e) {
      return this;
    }
    on(e, t) {
      return (
        (this.listeners[e] = this.listeners[e] || []),
        this.events[e] ||
          ((this.events[e] = (t, n) => {
            this.name === t && this.listeners[e] && this.listeners[e].forEach((e) => e(n));
          }),
          this.socket.on(e, this.events[e])),
        this.listeners[e].push(t),
        this
      );
    }
    unbind() {
      Object.keys(this.events).forEach((e) => {
        this.unbindEvent(e);
      });
    }
    unbindEvent(e, t) {
      ((this.listeners[e] = this.listeners[e] || []),
        t && (this.listeners[e] = this.listeners[e].filter((e) => e !== t)),
        (!t || this.listeners[e].length === 0) &&
          (this.events[e] && (this.socket.removeListener(e, this.events[e]), delete this.events[e]),
          delete this.listeners[e]));
    }
  },
  Gl = class extends Wl {
    whisper(e, t) {
      return (
        this.socket.emit(`client event`, {
          channel: this.name,
          event: `client-${e}`,
          data: t,
        }),
        this
      );
    }
  },
  ote = class extends Gl {
    here(e) {
      return (
        this.on(`presence:subscribed`, (t) => {
          e(t.map((e) => e.user_info));
        }),
        this
      );
    }
    joining(e) {
      return (this.on(`presence:joining`, (t) => e(t.user_info)), this);
    }
    whisper(e, t) {
      return (
        this.socket.emit(`client event`, {
          channel: this.name,
          event: `client-${e}`,
          data: t,
        }),
        this
      );
    }
    leaving(e) {
      return (this.on(`presence:leaving`, (t) => e(t.user_info)), this);
    }
  },
  Kl = class extends Bl {
    subscribe() {}
    unsubscribe() {}
    listen(e, t) {
      return this;
    }
    listenToAll(e) {
      return this;
    }
    stopListening(e, t) {
      return this;
    }
    subscribed(e) {
      return this;
    }
    error(e) {
      return this;
    }
    on(e, t) {
      return this;
    }
  },
  ql = class extends Kl {
    whisper(e, t) {
      return this;
    }
  },
  ste = class extends Kl {
    whisper(e, t) {
      return this;
    }
  },
  cte = class extends ql {
    here(e) {
      return this;
    }
    joining(e) {
      return this;
    }
    whisper(e, t) {
      return this;
    }
    leaving(e) {
      return this;
    }
  },
  Jl = class e {
    static {
      this._defaultOptions = {
        auth: {
          headers: {},
        },
        authEndpoint: `/broadcasting/auth`,
        userAuthentication: {
          endpoint: `/broadcasting/user-auth`,
          headers: {},
        },
        csrfToken: null,
        bearerToken: null,
        host: null,
        key: null,
        namespace: `App.Events`,
      };
    }
    constructor(e) {
      (this.setOptions(e), this.connect());
    }
    setOptions(t) {
      this.options = {
        ...e._defaultOptions,
        ...t,
        broadcaster: t.broadcaster,
      };
      let n = this.csrfToken();
      (n &&
        ((this.options.auth.headers[`X-CSRF-TOKEN`] = n),
        (this.options.userAuthentication.headers[`X-CSRF-TOKEN`] = n)),
        (n = this.options.bearerToken),
        n &&
          ((this.options.auth.headers.Authorization = `Bearer ` + n),
          (this.options.userAuthentication.headers.Authorization = `Bearer ` + n)));
    }
    csrfToken() {
      return typeof window < `u` && window.Laravel?.csrfToken
        ? window.Laravel.csrfToken
        : this.options.csrfToken
          ? this.options.csrfToken
          : typeof document < `u` && typeof document.querySelector == `function`
            ? (document.querySelector(`meta[name="csrf-token"]`)?.getAttribute(`content`) ?? null)
            : null;
    }
  },
  Yl = class extends Jl {
    constructor() {
      (super(...arguments), (this.channels = {}));
    }
    connect() {
      if (typeof this.options.client < `u`) this.pusher = this.options.client;
      else if (this.options.Pusher)
        this.pusher = new this.options.Pusher(this.options.key, this.options);
      else if (typeof window < `u` && typeof window.Pusher < `u`)
        this.pusher = new window.Pusher(this.options.key, this.options);
      else
        throw Error(
          `Pusher client not found. Should be globally available or passed via options.client`,
        );
    }
    signin() {
      this.pusher.signin();
    }
    listen(e, t, n) {
      return this.channel(e).listen(t, n);
    }
    channel(e) {
      return (
        this.channels[e] || (this.channels[e] = new Hl(this.pusher, e, this.options)),
        this.channels[e]
      );
    }
    privateChannel(e) {
      return (
        this.channels[`private-` + e] ||
          (this.channels[`private-` + e] = new Ul(this.pusher, `private-` + e, this.options)),
        this.channels[`private-` + e]
      );
    }
    encryptedPrivateChannel(e) {
      return (
        this.channels[`private-encrypted-` + e] ||
          (this.channels[`private-encrypted-` + e] = new ite(
            this.pusher,
            `private-encrypted-` + e,
            this.options,
          )),
        this.channels[`private-encrypted-` + e]
      );
    }
    presenceChannel(e) {
      return (
        this.channels[`presence-` + e] ||
          (this.channels[`presence-` + e] = new ate(this.pusher, `presence-` + e, this.options)),
        this.channels[`presence-` + e]
      );
    }
    leave(e) {
      [e, `private-` + e, `private-encrypted-` + e, `presence-` + e].forEach((e) => {
        this.leaveChannel(e);
      });
    }
    leaveChannel(e) {
      this.channels[e] && (this.channels[e].unsubscribe(), delete this.channels[e]);
    }
    socketId() {
      return this.pusher.connection.socket_id;
    }
    connectionStatus() {
      let e = this.pusher.connection.state;
      switch (e) {
        case `connected`:
        case `connecting`:
          return e;
        case `failed`:
        case `unavailable`:
          return `failed`;
        default:
          return `disconnected`;
      }
    }
    onConnectionChange(e) {
      let t = () => {
          e(this.connectionStatus());
        },
        n = [`state_change`, `connected`, `disconnected`];
      return (
        n.forEach((e) => {
          this.pusher.connection.bind(e, t);
        }),
        () => {
          n.forEach((e) => {
            this.pusher.connection.unbind(e, t);
          });
        }
      );
    }
    disconnect() {
      this.pusher.disconnect();
    }
  },
  lte = class extends Jl {
    constructor() {
      (super(...arguments), (this.channels = {}));
    }
    connect() {
      let e = this.getSocketIO();
      ((this.socket = e(this.options.host ?? void 0, this.options)),
        this.socket.io.on(`reconnect`, () => {
          Object.values(this.channels).forEach((e) => {
            e.subscribe();
          });
        }));
    }
    getSocketIO() {
      if (typeof this.options.client < `u`) return this.options.client;
      if (typeof window < `u` && typeof window.io < `u`) return window.io;
      throw Error(
        `Socket.io client not found. Should be globally available or passed via options.client`,
      );
    }
    listen(e, t, n) {
      return this.channel(e).listen(t, n);
    }
    channel(e) {
      return (
        this.channels[e] || (this.channels[e] = new Wl(this.socket, e, this.options)),
        this.channels[e]
      );
    }
    privateChannel(e) {
      return (
        this.channels[`private-` + e] ||
          (this.channels[`private-` + e] = new Gl(this.socket, `private-` + e, this.options)),
        this.channels[`private-` + e]
      );
    }
    presenceChannel(e) {
      return (
        this.channels[`presence-` + e] ||
          (this.channels[`presence-` + e] = new ote(this.socket, `presence-` + e, this.options)),
        this.channels[`presence-` + e]
      );
    }
    leave(e) {
      [e, `private-` + e, `presence-` + e].forEach((e) => {
        this.leaveChannel(e);
      });
    }
    leaveChannel(e) {
      this.channels[e] && (this.channels[e].unsubscribe(), delete this.channels[e]);
    }
    socketId() {
      return this.socket.id;
    }
    connectionStatus() {
      return this.socket.connected
        ? `connected`
        : this.socket.io._reconnecting
          ? `reconnecting`
          : this.socket.id === void 0
            ? `connecting`
            : `disconnected`;
    }
    onConnectionChange(e) {
      let t = () => {
          e(this.connectionStatus());
        },
        n = [
          `connect`,
          `disconnect`,
          `connect_error`,
          `reconnect_attempt`,
          `reconnect`,
          `reconnect_error`,
          `reconnect_failed`,
        ];
      return (
        n.forEach((e) => {
          this.socket.on(e, t);
        }),
        () => {
          n.forEach((e) => {
            this.socket.off(e, t);
          });
        }
      );
    }
    disconnect() {
      this.socket.disconnect();
    }
  },
  Xl = class extends Jl {
    constructor() {
      (super(...arguments), (this.channels = {}));
    }
    connect() {}
    listen(e, t, n) {
      return new Kl();
    }
    channel(e) {
      return new Kl();
    }
    privateChannel(e) {
      return new ql();
    }
    encryptedPrivateChannel(e) {
      return new ste();
    }
    presenceChannel(e) {
      return new cte();
    }
    leave(e) {}
    leaveChannel(e) {}
    socketId() {
      return `fake-socket-id`;
    }
    connectionStatus() {
      return `connected`;
    }
    onConnectionChange(e) {
      return () => {};
    }
    disconnect() {}
  },
  ute = class {
    constructor(e) {
      ((this.options = e),
        this.connect(),
        this.options.withoutInterceptors || this.registerInterceptors());
    }
    channel(e) {
      return this.connector.channel(e);
    }
    connect() {
      if (this.options.broadcaster === `reverb`)
        this.connector = new Yl({
          ...this.options,
          cluster: ``,
        });
      else if (this.options.broadcaster === `pusher`) this.connector = new Yl(this.options);
      else if (this.options.broadcaster === `ably`)
        this.connector = new Yl({
          ...this.options,
          cluster: ``,
          broadcaster: `pusher`,
        });
      else if (this.options.broadcaster === `socket.io`) this.connector = new lte(this.options);
      else if (this.options.broadcaster === `null`) this.connector = new Xl(this.options);
      else if (typeof this.options.broadcaster == `function` && rte(this.options.broadcaster))
        this.connector = new this.options.broadcaster(this.options);
      else
        throw Error(
          `Broadcaster ${typeof this.options.broadcaster} ${String(this.options.broadcaster)} is not supported.`,
        );
    }
    disconnect() {
      this.connector.disconnect();
    }
    join(e) {
      return this.connector.presenceChannel(e);
    }
    leave(e) {
      this.connector.leave(e);
    }
    leaveChannel(e) {
      this.connector.leaveChannel(e);
    }
    leaveAllChannels() {
      for (let e in this.connector.channels) this.leaveChannel(e);
    }
    listen(e, t, n) {
      return this.connector.listen(e, t, n);
    }
    private(e) {
      return this.connector.privateChannel(e);
    }
    encryptedPrivate(e) {
      if (this.connectorSupportsEncryptedPrivateChannels(this.connector))
        return this.connector.encryptedPrivateChannel(e);
      throw Error(
        `Broadcaster ${typeof this.options.broadcaster} ${String(this.options.broadcaster)} does not support encrypted private channels.`,
      );
    }
    connectorSupportsEncryptedPrivateChannels(e) {
      return e instanceof Yl || e instanceof Xl;
    }
    socketId() {
      return this.connector.socketId();
    }
    connectionStatus() {
      return this.connector.connectionStatus();
    }
    registerInterceptors() {
      (typeof Vue < `u` && Vue?.http && this.registerVueRequestInterceptor(),
        typeof axios == `function` && this.registerAxiosRequestInterceptor(),
        typeof jQuery == `function` && this.registerjQueryAjaxSetup(),
        typeof Turbo == `object` && this.registerTurboRequestInterceptor());
    }
    registerVueRequestInterceptor() {
      Vue.http.interceptors.push((e, t) => {
        (this.socketId() && e.headers.set(`X-Socket-ID`, this.socketId()), t());
      });
    }
    registerAxiosRequestInterceptor() {
      axios.interceptors.request.use(
        (e) => (this.socketId() && (e.headers[`X-Socket-Id`] = this.socketId()), e),
      );
    }
    registerjQueryAjaxSetup() {
      typeof jQuery.ajax < `u` &&
        jQuery.ajaxPrefilter((e, t, n) => {
          this.socketId() && n.setRequestHeader(`X-Socket-Id`, this.socketId());
        });
    }
    registerTurboRequestInterceptor() {
      document.addEventListener(`turbo:before-fetch-request`, (e) => {
        e.detail.fetchOptions.headers[`X-Socket-Id`] = this.socketId();
      });
    }
  },
  Zl = r(C(), 1),
  dte = u(),
  fte = `/app`;
x.dispatch(`config/setLoaded`, !1);
var Ql = nte({
  history: Fee(fte),
  routes: p,
});
(Ql.beforeEach((e, t, n) => {
  e.fullPath;
  let r = e.path;
  (Zl.default.start(),
    r === `/error`
      ? n()
      : mte()
          .then(() => {
            let i = e.matched.some((e) => e.meta.belongsTo)
              ? e.matched.find((e) => e.meta.belongsTo).meta.belongsTo
              : ``;
            if (e.meta.forceRedirect) n(e.meta.forceRedirect);
            else if ($l(`requiresInstall`) && r !== `/install`)
              n({
                name: `Install`,
              });
            else if (i === `auth`) pte(e, t, n);
            else if (i === `guest`) {
              if ($l(`authenticated`) === !0 && e.name !== `TwoFactorSecurity`) {
                let r =
                  e.query && e.query.ref
                    ? e.query.ref
                    : {
                        name: `Dashboard`,
                      };
                r.name === t.name ? (Zl.default.done(), n(!1)) : n(r);
              } else n();
            } else n();
          })
          .catch((t) => {
            n({
              name: `Error`,
              replace: !0,
              query: {
                ref: e.fullPath,
              },
            });
          }));
}),
  Ql.afterEach((e, t) => {
    Zl.default.done();
  }),
  Ql.onError(() => {
    Zl.default.done();
  }));
async function pte(e, t, n) {
  let r = e.fullPath,
    i = e.path;
  (t.path,
    e.matched.some((e) => e.meta.validate) && e.matched.find((e) => e.meta.validate).meta.validate);
  let a = $l(`tenant.availableModules`);
  if (e.meta.moduleName && !a.includes(e.meta.moduleName))
    return n({
      name: `Error404`,
    });
  let o = y($l(`module`)).find(
    (t) => t.name === e.name || t.name + `List` === e.name || t.name + `Index` === e.name,
  );
  if (o && !o.visibility)
    return n({
      name: `Error404`,
      replace: !0,
      query: {
        ref: r,
      },
    });
  if ($l(`authenticated`) !== !0)
    return (
      await x
        .dispatch(`auth/user/logout`)
        .then(() => {})
        .catch((e) => {}),
      n({
        name: `Login`,
        query: {
          ref: r,
        },
      })
    );
  if (x.getters[`auth/user/forceChangePassword`] && i !== `/user/force-change-password`)
    return n({
      name: `UserForceChangePassword`,
    });
  if ($l(`tenant.redirectOnExpiration`) && i != `/subscriptions` && i != `/dashboard`)
    return n({
      name: `Subscription`,
    });
  if (!x.getters[`auth/user/currentTeamId`] && i !== `/team/selection`)
    return n({
      name: `TeamSelection`,
      query: {
        ref: r,
      },
    });
  if (
    !x.getters[`auth/user/currentPeriodId`] &&
    i !== `/dashboard` &&
    !i.startsWith(`/license`) &&
    !i.startsWith(`/config`) &&
    !i.startsWith(`/user`) &&
    !i.startsWith(`/teams`) &&
    !i.startsWith(`/notifications`) &&
    !i.startsWith(`/academic/departments`) &&
    !i.startsWith(`/academic/program-types`) &&
    !i.startsWith(`/academic/programs`) &&
    !i.startsWith(`/academic/sessions`) &&
    !i.startsWith(`/academic/periods`) &&
    !i.startsWith(`/subscriptions`)
  )
    return (
      dte.info(g(`academic.period.choose_period_info`)),
      n({
        name: `Dashboard`,
        query: {
          ref: r,
        },
      })
    );
  let s = !1,
    c = !1;
  return e.meta.hasOwnProperty(`feature`) && !x.getters[`config/configs`].feature[e.meta.feature]
    ? n({
        name: `Error404`,
        replace: !0,
        query: {
          ref: r,
        },
      })
    : (e.meta.hasOwnProperty(`superAdmin`) &&
          e.meta.superAdmin &&
          !x.getters[`auth/user/isSuperAdmin`]) ||
        (e.meta.hasOwnProperty(`rolesExcept`) &&
          e.meta.rolesExcept.length &&
          x.getters[`auth/user/hasAnyRole`](e.meta.rolesExcept)) ||
        (e.meta.hasOwnProperty(`roles`) &&
          e.meta.roles.length &&
          ((s = x.getters[`auth/user/hasAnyRole`](e.meta.roles)), !s)) ||
        (e.meta.hasOwnProperty(`permissions`) &&
          e.meta.permissions.length &&
          ((c = e.meta.allPermissions
            ? x.getters[`auth/user/hasAllPermissions`](e.meta.permissions)
            : x.getters[`auth/user/hasAnyPermission`](e.meta.permissions)),
          !c))
      ? n({
          name: `Error403`,
          replace: !0,
          query: {
            ref: r,
          },
        })
      : n();
}
async function mte() {
  if (x.getters[`config/isLoaded`]) return !0;
  (await x.dispatch(`config/get`, !0),
    $l(`authenticated`) &&
      !x.getters[`auth/user/user`](`uuid`) &&
      (await x.dispatch(`auth/user/fetch`),
      await x.dispatch(`layout/setLayout`, x.getters[`auth/user/user`](`preference.layout`)),
      await x.dispatch(`navigation/setNavigation`)));
  let e = x.getters[`config/config`](`notification`);
  e?.enablePusherNotification &&
    (window.Echo = new ute({
      enabledTransports: [`ws`, `wss`],
      broadcaster: `pusher`,
      key: e?.pusherAppKey,
      cluster: e?.pusherAppCluster,
      forceTLS: !0,
    }));
}
function $l(e) {
  return x.getters[`config/config`](e);
}
var eu = `/app-sw.js`,
  hte = `/app/`,
  gte = [`scriptmint-app`, `workbox`, `google-fonts`];
function _te() {
  return document.head.querySelector(`meta[name="pwa-enabled"]`)?.content === `true`;
}
async function vte() {
  if (!(`serviceWorker` in navigator)) return;
  let e = (await navigator.serviceWorker.getRegistrations())
    .filter((e) => e.active?.scriptURL?.endsWith(eu))
    .map((e) => e.unregister());
  if ((await Promise.all(e), `caches` in window)) {
    let e = await caches.keys();
    await Promise.all(
      e.filter((e) => gte.some((t) => e.startsWith(t))).map((e) => caches.delete(e)),
    );
  }
}
async function yte() {
  if (`serviceWorker` in navigator) {
    if (!_te()) {
      await vte();
      return;
    }
    window.addEventListener(`load`, () => {
      navigator.serviceWorker
        .register(eu, {
          scope: hte,
        })
        .catch(() => {});
    });
  }
}
var tu = (e, t) => {
    let n = e.__vccOpts || e;
    for (let [e, r] of t) n[e] = r;
    return n;
  },
  bte = i({
    default: () => Ote,
  });
B();
var xte = {
    class: `flex justify-between`,
  },
  Ste = {
    key: 0,
    class: `ml-2`,
  },
  Cte = [`id`, `placeholder`, `type`, `step`, `value`],
  wte = [`for`],
  Tte = {
    key: 1,
    class: `absolute z-10 mt-1 w-full bg-white dark:bg-black rounded-md shadow-lg border border-gray-300 dark:border-gray-700`,
  },
  Ete = {
    class: `max-h-60 overflow-auto py-1`,
  },
  Dte = [`onMousedown`],
  Ote = tu(
    Object.assign(
      {
        name: `AutoSuggest`,
        inheritAttrs: !1,
      },
      {
        props: {
          label: {
            type: String,
            default: ``,
          },
          labelHint: {
            type: String,
            default: ``,
          },
          placeholder: {
            type: String,
            default: ``,
          },
          modelValue: {
            type: [String, Number],
            default: ``,
          },
          error: {
            type: String,
            default: ``,
          },
          rounded: {
            type: Boolean,
            default: !1,
          },
          invisible: {
            type: Boolean,
            default: !1,
          },
          align: {
            type: String,
            default: `left`,
          },
          textSize: {
            type: String,
            default: `sm`,
          },
          floatingLabel: {
            type: Boolean,
            default: !1,
          },
          url: {
            type: String,
            default: ``,
          },
        },
        emits: [`update:modelValue`, `update:error`, `change`],
        setup(e, { emit: t }) {
          let n = e,
            r = t,
            i = Ae({
              uniqueId: ``,
              focused: !1,
            }),
            a = F([]);
          Qe(() => {
            i.uniqueId = n.id || Math.random().toString(16).slice(2);
          });
          let o = () => {
              i.focused = !0;
            },
            s = () => {
              setTimeout(() => {
                i.focused = !1;
              }, 200);
            },
            c = _.debounce(async (e) => {
              if (!n.url || !e) {
                a.value = [];
                return;
              }
              await h(n.url, {
                query: e,
              })
                .then((e) => {
                  a.value = e.results || [];
                })
                .catch((e) => {
                  (console.error(`Error fetching suggestions:`, e), (a.value = []));
                });
            }, 300),
            l = (e) => {
              let t = e.target.value;
              (r(`update:modelValue`, t), r(`change`, t), r(`update:error`, ``), c(t));
            },
            u = (e) => {
              (r(`update:modelValue`, e), r(`change`, e), (a.value = []));
            };
          return (t, n) => {
            let r = j(`BaseLabel`),
              c = j(`FormError`),
              d = ve(`tooltip`);
            return (
              A(),
              M(`div`, null, [
                W(`div`, xte, [
                  e.label && !e.floatingLabel
                    ? (A(),
                      L(
                        r,
                        {
                          key: 0,
                          for: i.uniqueId,
                        },
                        {
                          default: I(() => [
                            H(T(e.label) + ` `, 1),
                            e.labelHint
                              ? Re(
                                  (A(),
                                  M(`span`, Ste, [
                                    ...(n[0] ||= [
                                      W(
                                        `i`,
                                        {
                                          class: `fas fa-question-circle`,
                                        },
                                        null,
                                        -1,
                                      ),
                                    ]),
                                  ])),
                                  [[d, e.labelHint]],
                                )
                              : U(``, !0),
                          ]),
                          _: 1,
                        },
                        8,
                        [`for`],
                      ))
                    : U(``, !0),
                  z(t.$slots, `additional-label`, {}, void 0, !0),
                ]),
                W(
                  `div`,
                  {
                    class: O([
                      `mt-1 relative`,
                      {
                        "floating-label-wrapper": e.floatingLabel,
                        "rounded-md shadow-xs": e.rounded,
                      },
                    ]),
                  },
                  [
                    W(
                      `input`,
                      ce(
                        {
                          id: i.uniqueId,
                        },
                        t.$attrs,
                        {
                          placeholder: e.floatingLabel ? ` ` : e.placeholder || e.label,
                          class: [
                            `focus:border-primary block w-full border-0 border-gray-300 bg-inherit focus:ring-0 disabled:bg-gray-200 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-200 dark:disabled:bg-gray-700`,
                            {
                              "text-sm": e.textSize == `sm`,
                              "text-lg": e.textSize == `lg`,
                              "text-xl": e.textSize == `xl`,
                              "text-2xl": e.textSize == `2xl`,
                              "text-right": e.align == `right`,
                              "text-center": e.align == `center`,
                              "border-b-2": !e.invisible,
                              "rounded-md": e.rounded,
                              "rounded-r-md": e.rounded,
                              "rounded-l-md": e.rounded,
                              "floating-label-input": e.floatingLabel,
                            },
                          ],
                          onFocus: o,
                          onBlur: s,
                          type: t.$attrs.type,
                          step: t.$attrs.step,
                          value: e.modelValue,
                          onInput: l,
                        },
                      ),
                      null,
                      16,
                      Cte,
                    ),
                    e.floatingLabel
                      ? (A(),
                        M(
                          `label`,
                          {
                            key: 0,
                            for: i.uniqueId,
                            class: O([
                              `floating-label`,
                              {
                                "floating-label-active": i.focused || e.modelValue,
                              },
                            ]),
                          },
                          T(e.label),
                          11,
                          wte,
                        ))
                      : U(``, !0),
                    a.value.length > 0 && i.focused
                      ? (A(),
                        M(`div`, Tte, [
                          W(`ul`, Ete, [
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                a.value,
                                (e, t) => (
                                  A(),
                                  M(
                                    `li`,
                                    {
                                      key: t,
                                      class: `px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer`,
                                      onMousedown: (t) => u(e),
                                    },
                                    T(e),
                                    41,
                                    Dte,
                                  )
                                ),
                              ),
                              128,
                            )),
                          ]),
                        ]))
                      : U(``, !0),
                  ],
                  2,
                ),
                N(
                  c,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ])
            );
          };
        },
      },
    ),
    [[`__scopeId`, `data-v-dfd16f10`]],
  ),
  kte = i({
    default: () => Fte,
  });
B();
var Ate = {
    class: `flex items-center`,
  },
  jte = [`id`, `checked`],
  Mte = [`for`],
  Nte = {
    class: `flex justify-between`,
  },
  Pte = {
    key: 0,
    class: `ltr:ml-2 rtl:mr-2`,
  },
  Fte = Object.assign(
    {
      name: `BaseArrayCheckbox`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        items: {
          type: Array,
          default: [],
        },
        value: {
          type: String,
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
      },
      emits: [`update:items`, `update:error`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = V(() => r.items.includes(r.value)),
          a = Ae({
            uniqueId: ``,
          }),
          o = (e) => {
            let t = [...r.items];
            (i.value ? t.splice(t.indexOf(r.value), 1) : t.push(r.value),
              n(`update:items`, t),
              n(`update:error`, ``));
          };
        return (
          Qe(() => {
            a.uniqueId = r.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`FormError`),
              s = ve(`tooltip`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  W(`div`, Ate, [
                    W(
                      `input`,
                      ce(
                        {
                          id: a.uniqueId,
                        },
                        t.$attrs,
                        {
                          checked: i.value,
                          onChange: o,
                          type: `checkbox`,
                          class: `text-primary dark:text-dark-body border-primary h-4 w-4 cursor-pointer rounded focus:ring-0 dark:border-gray-700`,
                        },
                      ),
                      null,
                      16,
                      jte,
                    ),
                    W(
                      `label`,
                      {
                        for: a.uniqueId,
                        class: `ltr:ml-2 rtl:mr-2 block text-sm text-gray-900 dark:text-gray-400`,
                      },
                      [
                        W(`div`, Nte, [
                          H(T(e.label) + ` `, 1),
                          e.labelHint
                            ? Re(
                                (A(),
                                M(`span`, Pte, [
                                  ...(n[0] ||= [
                                    W(
                                      `i`,
                                      {
                                        class: `fas fa-question-circle`,
                                      },
                                      null,
                                      -1,
                                    ),
                                  ]),
                                ])),
                                [[s, e.labelHint]],
                              )
                            : U(``, !0),
                        ]),
                      ],
                      8,
                      Mte,
                    ),
                  ]),
                  N(
                    r,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  Ite = i({
    default: () => Lte,
  });
B();
var Lte = Object.assign(
    {
      name: `BaseButton`,
    },
    {
      props: {
        as: {
          type: String,
          default: `button`,
        },
        size: {
          type: String,
          validator(e) {
            return [`xs`, `sm`, `md`, `lg`, `xl`].includes(e);
          },
          default: `md`,
        },
        roundedFull: Boolean,
        focusRing: Boolean,
        block: Boolean,
        design: {
          type: String,
          validator(e) {
            return [
              `primary`,
              `secondary`,
              `info`,
              `success`,
              `warning`,
              `danger`,
              `error`,
              `white`,
              `facebook`,
            ].includes(e);
          },
          default: `primary`,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          L(
            _e(e.as),
            {
              type: `button`,
              class: O([
                `relative z-0 inline-flex items-center justify-center overflow-hidden font-medium transition-all duration-300 before:absolute before:bottom-0 before:left-0 before:-z-10 before:h-full before:w-0 before:transition-all before:duration-300 before:content-[''] after:absolute after:bottom-0 after:left-0 after:-z-20 after:h-full after:w-full after:content-[''] hover:before:w-full`,
                {
                  "cursor-not-allowed": e.disabled,
                  "focus:outline-none focus:ring-2 focus:ring-offset-2": e.focusRing,
                  "border border-transparent": e.design !== `white` && e.design !== `secondary`,
                  "flex w-full justify-center": e.block === !0,
                  "inline-flex items-center": e.block === !1,
                  "px-2.5 py-1.5 text-xs": e.size === `xs`,
                  "px-3 py-2 text-sm leading-4": e.size === `sm`,
                  "px-4 py-2 text-sm": e.size === `md`,
                  "px-4 py-2 text-base": e.size === `lg`,
                  "px-6 py-3 text-base": e.size === `xl`,
                  "rounded-xl": !e.roundedFull,
                  "rounded-full": e.roundedFull,
                  "dark:after:bg-dark-header text-gray-600 before:bg-gray-100 after:bg-white focus:ring-white dark:text-gray-400 dark:before:bg-neutral-700":
                    e.design === `white`,
                  "after:bg-primary before:bg-dark-primary text-secondary focus:ring-primary dark:focus:ring-dark-header dark:text-gray-200 dark:before:bg-gray-500 dark:after:bg-gray-700":
                    e.design === `primary`,
                  "after:bg-secondary before:bg-dark-secondary dark:after:bg-dark-body text-primary focus:ring-secondary dark:focus:ring-dark-body dark:text-gray-400 dark:before:bg-neutral-700":
                    e.design === `secondary`,
                  "after:bg-success before:bg-dark-success text-secondary focus:ring-success":
                    e.design === `success`,
                  "text-white before:bg-[#1f4494] after:bg-[#3b5998] focus:ring-[#3b5998]":
                    e.design === `facebook`,
                  "after:bg-info before:bg-dark-info text-secondary focus:ring-info":
                    e.design === `info`,
                  "after:bg-warning before:bg-dark-warning text-secondary focus:ring-warning":
                    e.design === `warning`,
                  "after:bg-danger before:bg-dark-danger text-secondary focus:ring-danger":
                    e.design === `danger` || e.design === `error`,
                },
              ]),
            },
            {
              default: I(() => [z(t.$slots, `default`)]),
              _: 3,
            },
            8,
            [`class`],
          )
        );
      },
    },
  ),
  Rte = i({
    default: () => Wte,
  });
B();
var zte = {
    class: `flex items-center`,
  },
  Bte = [`id`, `checked`, `disabled`],
  Vte = [`for`],
  Hte = {
    class: `flex justify-between`,
  },
  Ute = {
    key: 0,
    class: `ltr:ml-2 rtl:mr-2`,
  },
  Wte = Object.assign(
    {
      name: `BaseCheckbox`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: Boolean,
          default: !1,
        },
        error: {
          type: String,
          default: ``,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:error`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = Ae({
            uniqueId: ``,
          }),
          a = (e) => {
            (n(`update:modelValue`, e.target.checked), n(`update:error`, ``));
          };
        return (
          Qe(() => {
            i.uniqueId = r.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`FormError`),
              o = ve(`tooltip`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  W(`div`, zte, [
                    W(
                      `input`,
                      ce(
                        {
                          id: i.uniqueId,
                        },
                        t.$attrs,
                        {
                          checked: e.modelValue,
                          onChange: a,
                          type: `checkbox`,
                          disabled: e.disabled,
                          class: [
                            `text-primary dark:text-dark-body border-primary h-4 w-4 rounded focus:ring-0 dark:border-gray-700`,
                            {
                              "cursor-pointer": !e.disabled,
                              "text-gray-400 dark:text-gray-500": e.disabled,
                            },
                          ],
                        },
                      ),
                      null,
                      16,
                      Bte,
                    ),
                    W(
                      `label`,
                      {
                        for: i.uniqueId,
                        class: O([
                          `ltr:ml-2 rtl:mr-2 block text-sm text-gray-900 dark:text-gray-400`,
                          {
                            "cursor-pointer": !e.disabled,
                          },
                        ]),
                      },
                      [
                        W(`div`, Hte, [
                          H(T(e.label) + ` `, 1),
                          e.labelHint
                            ? Re(
                                (A(),
                                M(`span`, Ute, [
                                  ...(n[0] ||= [
                                    W(
                                      `i`,
                                      {
                                        class: `fas fa-question-circle`,
                                      },
                                      null,
                                      -1,
                                    ),
                                  ]),
                                ])),
                                [[o, e.labelHint]],
                              )
                            : U(``, !0),
                        ]),
                      ],
                      10,
                      Vte,
                    ),
                  ]),
                  N(
                    r,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  Gte = i({
    default: () => hu,
  });
B();
var Kte = {
    class: `flex justify-between`,
  },
  qte = {
    key: 0,
    class: `ltr:ml-2 rtl:mr-2`,
  },
  Jte = {
    class: `mt-1 relative`,
  },
  nu = [`id`, `placeholder`, `value`],
  ru = [`for`],
  iu = {
    class: `mb-3`,
  },
  au = {
    class: `text-xs font-medium text-gray-700 dark:text-gray-300 mb-2`,
  },
  ou = {
    class: `grid grid-cols-8 gap-2`,
  },
  su = [`onClick`, `title`],
  cu = {
    key: 0,
    class: `mb-3`,
  },
  lu = {
    class: `text-xs font-medium text-gray-700 dark:text-gray-300 mb-2`,
  },
  uu = {
    class: `grid grid-cols-8 gap-2`,
  },
  du = [`onClick`, `title`],
  fu = {
    key: 1,
    class: `pt-3 border-t border-gray-200 dark:border-gray-700`,
  },
  pu = [`value`],
  mu = {
    key: 2,
    class: `pt-3 border-t border-gray-200 dark:border-gray-700 mt-3`,
  },
  hu = tu(
    Object.assign(
      {
        name: `BaseColorInput`,
        inheritAttrs: !1,
        methods: {
          updateInput(e) {
            let t = e.target.value;
            (t && !t.startsWith(`#`) && (t = `#` + t),
              (t === `` || /^#[0-9A-Fa-f]{0,6}$/.test(t)) &&
                (this.$emit(`update:modelValue`, t),
                this.$emit(`change`, t),
                this.$emit(`update:error`, ``)));
          },
        },
      },
      {
        props: {
          label: {
            type: String,
            default: ``,
          },
          labelHint: {
            type: String,
            default: ``,
          },
          placeholder: {
            type: String,
            default: ``,
          },
          modelValue: {
            type: String,
            default: ``,
          },
          error: {
            type: String,
            default: ``,
          },
          rounded: {
            type: Boolean,
            default: !0,
          },
          invisible: {
            type: Boolean,
            default: !1,
          },
          align: {
            type: String,
            default: `left`,
          },
          textSize: {
            type: String,
            default: `sm`,
          },
          floatingLabel: {
            type: Boolean,
            default: !1,
          },
          isRequired: {
            type: Boolean,
            default: !1,
          },
          presetColors: {
            type: Array,
            default: () => [
              `#000000`,
              `#FFFFFF`,
              `#EF4444`,
              `#F97316`,
              `#F59E0B`,
              `#EAB308`,
              `#84CC16`,
              `#22C55E`,
              `#10B981`,
              `#14B8A6`,
              `#06B6D4`,
              `#0EA5E9`,
              `#3B82F6`,
              `#6366F1`,
              `#8B5CF6`,
              `#A855F7`,
              `#D946EF`,
              `#EC4899`,
              `#F43F5E`,
              `#64748B`,
              `#6B7280`,
              `#71717A`,
              `#78716C`,
              `#57534E`,
            ],
          },
          customColors: {
            type: Array,
            default: () => [],
          },
          presetLabel: {
            type: String,
            default: ``,
          },
          customLabel: {
            type: String,
            default: ``,
          },
          clearLabel: {
            type: String,
            default: ``,
          },
          showNativePicker: {
            type: Boolean,
            default: !0,
          },
          showEyeDropper: {
            type: Boolean,
            default: !0,
          },
          clearable: {
            type: Boolean,
            default: !0,
          },
          alignRight: {
            type: Boolean,
            default: !1,
          },
        },
        emits: [`update:modelValue`, `change`, `update:error`],
        setup(e, { emit: t }) {
          let n = t,
            r = Ae({
              uniqueId: ``,
              focused: !1,
              showPalette: !1,
              supportsEyeDropper: !1,
            }),
            i = () => {
              r.showPalette = !r.showPalette;
            },
            a = () => {
              r.showPalette = !1;
            },
            o = (e) => {
              (n(`update:modelValue`, e), n(`change`, e), n(`update:error`, ``));
            },
            s = () => {
              (n(`update:modelValue`, ``), n(`change`, ``), n(`update:error`, ``), a());
            },
            c = async () => {
              if (window.EyeDropper)
                try {
                  o((await new window.EyeDropper().open()).sRGBHex);
                } catch (e) {
                  console.log(`Eye dropper cancelled or error:`, e);
                }
            };
          return (
            Qe(() => {
              ((r.uniqueId = Math.random().toString(16).slice(2)),
                (r.supportsEyeDropper = window.EyeDropper !== void 0));
            }),
            (t, n) => {
              let l = j(`IsRequired`),
                u = j(`BaseLabel`),
                d = j(`FormError`),
                f = ve(`tooltip`),
                p = ve(`click-outside`);
              return (
                A(),
                M(`div`, null, [
                  W(`div`, Kte, [
                    e.label && !e.floatingLabel
                      ? (A(),
                        L(
                          u,
                          {
                            key: 0,
                            for: r.uniqueId,
                          },
                          {
                            default: I(() => [
                              W(`span`, null, [
                                H(T(e.label) + ` `, 1),
                                N(
                                  l,
                                  {
                                    "is-required": e.isRequired,
                                  },
                                  null,
                                  8,
                                  [`is-required`],
                                ),
                              ]),
                              e.labelHint
                                ? Re(
                                    (A(),
                                    M(`span`, qte, [
                                      ...(n[4] ||= [
                                        W(
                                          `i`,
                                          {
                                            class: `fas fa-question-circle`,
                                          },
                                          null,
                                          -1,
                                        ),
                                      ]),
                                    ])),
                                    [[f, e.labelHint]],
                                  )
                                : U(``, !0),
                            ]),
                            _: 1,
                          },
                          8,
                          [`for`],
                        ))
                      : U(``, !0),
                    z(t.$slots, `additional-label`, {}, void 0, !0),
                  ]),
                  W(`div`, Jte, [
                    W(
                      `div`,
                      {
                        class: O([
                          `relative`,
                          {
                            "floating-label-wrapper": e.floatingLabel,
                            flex: !0,
                            "rounded-md shadow-xs": e.rounded,
                          },
                        ]),
                      },
                      [
                        W(
                          `button`,
                          {
                            type: `button`,
                            onClick: i,
                            class: O([
                              `inline-flex items-center border-gray-300 px-3 py-2 cursor-pointer transition-colors`,
                              {
                                "border-b-2": !e.invisible,
                                "rounded-l-md": e.rounded,
                                "border-r": !e.invisible,
                                "border-primary dark:border-gray-700": r.focused || r.showPalette,
                                "border-gray-300 dark:border-gray-700":
                                  !r.focused && !r.showPalette,
                              },
                            ]),
                          },
                          [
                            W(
                              `div`,
                              {
                                class: `w-6 h-6 rounded border-2 border-gray-300 dark:border-gray-600`,
                                style: Pe({
                                  backgroundColor: e.modelValue || `#ffffff`,
                                }),
                              },
                              null,
                              4,
                            ),
                          ],
                          2,
                        ),
                        W(
                          `input`,
                          ce(
                            {
                              id: r.uniqueId,
                            },
                            t.$attrs,
                            {
                              placeholder: e.floatingLabel
                                ? ` `
                                : e.placeholder || e.label || `#000000`,
                              class: [
                                `focus:border-primary block w-full border-0 border-gray-300 bg-inherit focus:ring-0 disabled:bg-gray-200 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-200 dark:disabled:bg-gray-700`,
                                {
                                  "text-sm": e.textSize == `sm`,
                                  "text-lg": e.textSize == `lg`,
                                  "text-xl": e.textSize == `xl`,
                                  "text-2xl": e.textSize == `2xl`,
                                  "text-right": e.align == `right`,
                                  "text-center": e.align == `center`,
                                  "border-b-2": !e.invisible,
                                  "pl-3": !0,
                                  "pr-10": e.showEyeDropper,
                                  "rounded-r-md": e.rounded,
                                  "floating-label-input": e.floatingLabel,
                                },
                              ],
                              onFocus: (n[0] ||= (e) => (r.focused = !0)),
                              onBlur: (n[1] ||= (e) => (r.focused = !1)),
                              type: `text`,
                              value: e.modelValue,
                              onInput: (n[2] ||= (...e) => t.updateInput && t.updateInput(...e)),
                              maxlength: `7`,
                            },
                          ),
                          null,
                          16,
                          nu,
                        ),
                        e.floatingLabel
                          ? (A(),
                            M(
                              `label`,
                              {
                                key: 0,
                                for: r.uniqueId,
                                class: O([
                                  `floating-label`,
                                  {
                                    "floating-label-active": r.focused || e.modelValue,
                                  },
                                ]),
                              },
                              T(e.label),
                              11,
                              ru,
                            ))
                          : U(``, !0),
                        e.showEyeDropper && r.supportsEyeDropper
                          ? (A(),
                            M(
                              `div`,
                              {
                                key: 1,
                                class: `absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3`,
                                onClick: c,
                                title: `Pick color from screen`,
                              },
                              [
                                ...(n[5] ||= [
                                  W(
                                    `i`,
                                    {
                                      class: `fas fa-eye-dropper text-gray-400 hover:text-gray-600 dark:hover:text-gray-300`,
                                    },
                                    null,
                                    -1,
                                  ),
                                ]),
                              ],
                            ))
                          : U(``, !0),
                      ],
                      2,
                    ),
                    N(
                      Ve,
                      {
                        name: `fade`,
                      },
                      {
                        default: I(() => [
                          r.showPalette
                            ? Re(
                                (A(),
                                M(
                                  `div`,
                                  {
                                    key: 0,
                                    class: O([
                                      `absolute z-50 mt-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-lg shadow-lg p-4`,
                                      {
                                        "ltr:left-0 rtl:right-0": !e.alignRight,
                                        "ltr:right-0 rtl:left-0": e.alignRight,
                                      },
                                    ]),
                                    style: {
                                      "min-width": `280px`,
                                    },
                                  },
                                  [
                                    W(`div`, iu, [
                                      W(`div`, au, T(e.presetLabel || `Preset Colors`), 1),
                                      W(`div`, ou, [
                                        (A(!0),
                                        M(
                                          ke,
                                          null,
                                          ae(
                                            e.presetColors,
                                            (t) => (
                                              A(),
                                              M(
                                                `button`,
                                                {
                                                  key: t,
                                                  type: `button`,
                                                  onClick: (e) => o(t),
                                                  class: O([
                                                    `w-8 h-8 rounded border-2 transition-transform hover:scale-110`,
                                                    {
                                                      "border-primary ring-2 ring-primary ring-offset-2":
                                                        e.modelValue === t,
                                                      "border-gray-300 dark:border-gray-600":
                                                        e.modelValue !== t,
                                                    },
                                                  ]),
                                                  style: Pe({
                                                    backgroundColor: t,
                                                  }),
                                                  title: t,
                                                },
                                                null,
                                                14,
                                                su,
                                              )
                                            ),
                                          ),
                                          128,
                                        )),
                                      ]),
                                    ]),
                                    e.customColors.length > 0
                                      ? (A(),
                                        M(`div`, cu, [
                                          W(`div`, lu, T(e.customLabel || `Custom Colors`), 1),
                                          W(`div`, uu, [
                                            (A(!0),
                                            M(
                                              ke,
                                              null,
                                              ae(
                                                e.customColors,
                                                (t) => (
                                                  A(),
                                                  M(
                                                    `button`,
                                                    {
                                                      key: t,
                                                      type: `button`,
                                                      onClick: (e) => o(t),
                                                      class: O([
                                                        `w-8 h-8 rounded border-2 transition-transform hover:scale-110`,
                                                        {
                                                          "border-primary ring-2 ring-primary ring-offset-2":
                                                            e.modelValue === t,
                                                          "border-gray-300 dark:border-gray-600":
                                                            e.modelValue !== t,
                                                        },
                                                      ]),
                                                      style: Pe({
                                                        backgroundColor: t,
                                                      }),
                                                      title: t,
                                                    },
                                                    null,
                                                    14,
                                                    du,
                                                  )
                                                ),
                                              ),
                                              128,
                                            )),
                                          ]),
                                        ]))
                                      : U(``, !0),
                                    e.showNativePicker
                                      ? (A(),
                                        M(`div`, fu, [
                                          (n[6] ||= W(
                                            `div`,
                                            {
                                              class: `text-xs font-medium text-gray-700 dark:text-gray-300 mb-2`,
                                            },
                                            ` Custom Color `,
                                            -1,
                                          )),
                                          W(
                                            `input`,
                                            {
                                              type: `color`,
                                              value: e.modelValue || `#000000`,
                                              onInput: (n[3] ||= (e) => o(e.target.value)),
                                              class: `w-full h-10 cursor-pointer rounded border border-gray-300 dark:border-gray-600`,
                                            },
                                            null,
                                            40,
                                            pu,
                                          ),
                                        ]))
                                      : U(``, !0),
                                    e.clearable
                                      ? (A(),
                                        M(`div`, mu, [
                                          W(
                                            `button`,
                                            {
                                              type: `button`,
                                              onClick: s,
                                              class: `w-full px-3 py-2 text-sm text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded transition-colors`,
                                            },
                                            [
                                              (n[7] ||= W(
                                                `i`,
                                                {
                                                  class: `fas fa-times ltr:mr-2 rtl:ml-2`,
                                                },
                                                null,
                                                -1,
                                              )),
                                              H(` ` + T(e.clearLabel || `Clear Color`), 1),
                                            ],
                                          ),
                                        ]))
                                      : U(``, !0),
                                  ],
                                  2,
                                )),
                                [[p, a]],
                              )
                            : U(``, !0),
                        ]),
                        _: 1,
                      },
                    ),
                  ]),
                  N(
                    d,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ])
              );
            }
          );
        },
      },
    ),
    [[`__scopeId`, `data-v-97f0eabb`]],
  ),
  gu = a((e, t) => {
    var n = -1,
      r = 1,
      i = 0;
    function a(e, t, n, r, a) {
      if (e === t) return e ? [[i, e]] : [];
      if (n != null) {
        var s = ee(e, t, n);
        if (s) return s;
      }
      var c = l(e, t),
        u = e.substring(0, c);
      ((e = e.substring(c)), (t = t.substring(c)), (c = d(e, t)));
      var f = e.substring(e.length - c);
      ((e = e.substring(0, e.length - c)), (t = t.substring(0, t.length - c)));
      var m = o(e, t);
      return (u && m.unshift([i, u]), f && m.push([i, f]), x(m, a), r && p(m), m);
    }
    function o(e, t) {
      var o;
      if (!e) return [[r, t]];
      if (!t) return [[n, e]];
      var c = e.length > t.length ? e : t,
        l = e.length > t.length ? t : e,
        u = c.indexOf(l);
      if (u !== -1)
        return (
          (o = [
            [r, c.substring(0, u)],
            [i, l],
            [r, c.substring(u + l.length)],
          ]),
          e.length > t.length && (o[0][0] = o[2][0] = n),
          o
        );
      if (l.length === 1)
        return [
          [n, e],
          [r, t],
        ];
      var d = f(e, t);
      if (d) {
        var p = d[0],
          m = d[1],
          h = d[2],
          g = d[3],
          v = d[4],
          y = a(p, h),
          b = a(m, g);
        return y.concat([[i, v]], b);
      }
      return s(e, t);
    }
    function s(e, t) {
      for (
        var i = e.length,
          a = t.length,
          o = Math.ceil((i + a) / 2),
          s = o,
          l = 2 * o,
          u = Array(l),
          d = Array(l),
          f = 0;
        f < l;
        f++
      )
        ((u[f] = -1), (d[f] = -1));
      ((u[s + 1] = 0), (d[s + 1] = 0));
      for (var p = i - a, m = p % 2 != 0, h = 0, g = 0, v = 0, y = 0, b = 0; b < o; b++) {
        for (var x = -b + h; x <= b - g; x += 2) {
          for (
            var S = s + x,
              C = x === -b || (x !== b && u[S - 1] < u[S + 1]) ? u[S + 1] : u[S - 1] + 1,
              w = C - x;
            C < i && w < a && e.charAt(C) === t.charAt(w);
          )
            (C++, w++);
          if (((u[S] = C), C > i)) g += 2;
          else if (w > a) h += 2;
          else if (m) {
            var T = s + p - x;
            if (T >= 0 && T < l && d[T] !== -1) {
              var E = i - d[T];
              if (C >= E) return c(e, t, C, w);
            }
          }
        }
        for (var D = -b + v; D <= b - y; D += 2) {
          for (
            var T = s + D,
              E = D === -b || (D !== b && d[T - 1] < d[T + 1]) ? d[T + 1] : d[T - 1] + 1,
              ee = E - D;
            E < i && ee < a && e.charAt(i - E - 1) === t.charAt(a - ee - 1);
          )
            (E++, ee++);
          if (((d[T] = E), E > i)) y += 2;
          else if (ee > a) v += 2;
          else if (!m) {
            var S = s + p - D;
            if (S >= 0 && S < l && u[S] !== -1) {
              var C = u[S],
                w = s + C - S;
              if (((E = i - E), C >= E)) return c(e, t, C, w);
            }
          }
        }
      }
      return [
        [n, e],
        [r, t],
      ];
    }
    function c(e, t, n, r) {
      var i = e.substring(0, n),
        o = t.substring(0, r),
        s = e.substring(n),
        c = t.substring(r),
        l = a(i, o),
        u = a(s, c);
      return l.concat(u);
    }
    function l(e, t) {
      if (!e || !t || e.charAt(0) !== t.charAt(0)) return 0;
      for (var n = 0, r = Math.min(e.length, t.length), i = r, a = 0; n < i;)
        (e.substring(a, i) == t.substring(a, i) ? ((n = i), (a = n)) : (r = i),
          (i = Math.floor((r - n) / 2 + n)));
      return (S(e.charCodeAt(i - 1)) && i--, i);
    }
    function u(e, t) {
      var n = e.length,
        r = t.length;
      if (n == 0 || r == 0) return 0;
      n > r ? (e = e.substring(n - r)) : n < r && (t = t.substring(0, n));
      var i = Math.min(n, r);
      if (e == t) return i;
      for (var a = 0, o = 1; ;) {
        var s = e.substring(i - o),
          c = t.indexOf(s);
        if (c == -1) return a;
        ((o += c), (c == 0 || e.substring(i - o) == t.substring(0, o)) && ((a = o), o++));
      }
    }
    function d(e, t) {
      if (!e || !t || e.slice(-1) !== t.slice(-1)) return 0;
      for (var n = 0, r = Math.min(e.length, t.length), i = r, a = 0; n < i;)
        (e.substring(e.length - i, e.length - a) == t.substring(t.length - i, t.length - a)
          ? ((n = i), (a = n))
          : (r = i),
          (i = Math.floor((r - n) / 2 + n)));
      return (C(e.charCodeAt(e.length - i)) && i--, i);
    }
    function f(e, t) {
      var n = e.length > t.length ? e : t,
        r = e.length > t.length ? t : e;
      if (n.length < 4 || r.length * 2 < n.length) return null;
      function i(e, t, n) {
        for (
          var r = e.substring(n, n + Math.floor(e.length / 4)), i = -1, a = ``, o, s, c, u;
          (i = t.indexOf(r, i + 1)) !== -1;
        ) {
          var f = l(e.substring(n), t.substring(i)),
            p = d(e.substring(0, n), t.substring(0, i));
          a.length < p + f &&
            ((a = t.substring(i - p, i) + t.substring(i, i + f)),
            (o = e.substring(0, n - p)),
            (s = e.substring(n + f)),
            (c = t.substring(0, i - p)),
            (u = t.substring(i + f)));
        }
        return a.length * 2 >= e.length ? [o, s, c, u, a] : null;
      }
      var a = i(n, r, Math.ceil(n.length / 4)),
        o = i(n, r, Math.ceil(n.length / 2)),
        s;
      if (!a && !o) return null;
      s = o ? (a && a[4].length > o[4].length ? a : o) : a;
      var c, u, f, p;
      e.length > t.length
        ? ((c = s[0]), (u = s[1]), (f = s[2]), (p = s[3]))
        : ((f = s[0]), (p = s[1]), (c = s[2]), (u = s[3]));
      var m = s[4];
      return [c, u, f, p, m];
    }
    function p(e) {
      for (var t = !1, a = [], o = 0, s = null, c = 0, l = 0, d = 0, f = 0, p = 0; c < e.length;)
        (e[c][0] == i
          ? ((a[o++] = c), (l = f), (d = p), (f = 0), (p = 0), (s = e[c][1]))
          : (e[c][0] == r ? (f += e[c][1].length) : (p += e[c][1].length),
            s &&
              s.length <= Math.max(l, d) &&
              s.length <= Math.max(f, p) &&
              (e.splice(a[o - 1], 0, [n, s]),
              (e[a[o - 1] + 1][0] = r),
              o--,
              o--,
              (c = o > 0 ? a[o - 1] : -1),
              (l = 0),
              (d = 0),
              (f = 0),
              (p = 0),
              (s = null),
              (t = !0))),
          c++);
      for (t && x(e), b(e), c = 1; c < e.length;) {
        if (e[c - 1][0] == n && e[c][0] == r) {
          var m = e[c - 1][1],
            h = e[c][1],
            g = u(m, h),
            v = u(h, m);
          (g >= v
            ? (g >= m.length / 2 || g >= h.length / 2) &&
              (e.splice(c, 0, [i, h.substring(0, g)]),
              (e[c - 1][1] = m.substring(0, m.length - g)),
              (e[c + 1][1] = h.substring(g)),
              c++)
            : (v >= m.length / 2 || v >= h.length / 2) &&
              (e.splice(c, 0, [i, m.substring(0, v)]),
              (e[c - 1][0] = r),
              (e[c - 1][1] = h.substring(0, h.length - v)),
              (e[c + 1][0] = n),
              (e[c + 1][1] = m.substring(v)),
              c++),
            c++);
        }
        c++;
      }
    }
    var m = /[^a-zA-Z0-9]/,
      h = /\s/,
      g = /[\r\n]/,
      v = /\n\r?\n$/,
      y = /^\r?\n\r?\n/;
    function b(e) {
      function t(e, t) {
        if (!e || !t) return 6;
        var n = e.charAt(e.length - 1),
          r = t.charAt(0),
          i = n.match(m),
          a = r.match(m),
          o = i && n.match(h),
          s = a && r.match(h),
          c = o && n.match(g),
          l = s && r.match(g),
          u = c && e.match(v),
          d = l && t.match(y);
        return u || d ? 5 : c || l ? 4 : i && !o && s ? 3 : o || s ? 2 : i || a ? 1 : 0;
      }
      for (var n = 1; n < e.length - 1;) {
        if (e[n - 1][0] == i && e[n + 1][0] == i) {
          var r = e[n - 1][1],
            a = e[n][1],
            o = e[n + 1][1],
            s = d(r, a);
          if (s) {
            var c = a.substring(a.length - s);
            ((r = r.substring(0, r.length - s)),
              (a = c + a.substring(0, a.length - s)),
              (o = c + o));
          }
          for (var l = r, u = a, f = o, p = t(r, a) + t(a, o); a.charAt(0) === o.charAt(0);) {
            ((r += a.charAt(0)), (a = a.substring(1) + o.charAt(0)), (o = o.substring(1)));
            var b = t(r, a) + t(a, o);
            b >= p && ((p = b), (l = r), (u = a), (f = o));
          }
          e[n - 1][1] != l &&
            (l ? (e[n - 1][1] = l) : (e.splice(n - 1, 1), n--),
            (e[n][1] = u),
            f ? (e[n + 1][1] = f) : (e.splice(n + 1, 1), n--));
        }
        n++;
      }
    }
    function x(e, t) {
      e.push([i, ``]);
      for (var a = 0, o = 0, s = 0, c = ``, u = ``, f; a < e.length;) {
        if (a < e.length - 1 && !e[a][1]) {
          e.splice(a, 1);
          continue;
        }
        switch (e[a][0]) {
          case r:
            (s++, (u += e[a][1]), a++);
            break;
          case n:
            (o++, (c += e[a][1]), a++);
            break;
          case i:
            var p = a - s - o - 1;
            if (t) {
              if (p >= 0 && T(e[p][1])) {
                var m = e[p][1].slice(-1);
                if (((e[p][1] = e[p][1].slice(0, -1)), (c = m + c), (u = m + u), !e[p][1])) {
                  (e.splice(p, 1), a--);
                  var h = p - 1;
                  (e[h] && e[h][0] === r && (s++, (u = e[h][1] + u), h--),
                    e[h] && e[h][0] === n && (o++, (c = e[h][1] + c), h--),
                    (p = h));
                }
              }
              if (w(e[a][1])) {
                var m = e[a][1].charAt(0);
                ((e[a][1] = e[a][1].slice(1)), (c += m), (u += m));
              }
            }
            if (a < e.length - 1 && !e[a][1]) {
              e.splice(a, 1);
              break;
            }
            if (c.length > 0 || u.length > 0) {
              c.length > 0 &&
                u.length > 0 &&
                ((f = l(u, c)),
                f !== 0 &&
                  (p >= 0
                    ? (e[p][1] += u.substring(0, f))
                    : (e.splice(0, 0, [i, u.substring(0, f)]), a++),
                  (u = u.substring(f)),
                  (c = c.substring(f))),
                (f = d(u, c)),
                f !== 0 &&
                  ((e[a][1] = u.substring(u.length - f) + e[a][1]),
                  (u = u.substring(0, u.length - f)),
                  (c = c.substring(0, c.length - f))));
              var g = s + o;
              c.length === 0 && u.length === 0
                ? (e.splice(a - g, g), (a -= g))
                : c.length === 0
                  ? (e.splice(a - g, g, [r, u]), (a = a - g + 1))
                  : u.length === 0
                    ? (e.splice(a - g, g, [n, c]), (a = a - g + 1))
                    : (e.splice(a - g, g, [n, c], [r, u]), (a = a - g + 2));
            }
            (a !== 0 && e[a - 1][0] === i ? ((e[a - 1][1] += e[a][1]), e.splice(a, 1)) : a++,
              (s = 0),
              (o = 0),
              (c = ``),
              (u = ``));
            break;
        }
      }
      e[e.length - 1][1] === `` && e.pop();
      var v = !1;
      for (a = 1; a < e.length - 1;)
        (e[a - 1][0] === i &&
          e[a + 1][0] === i &&
          (e[a][1].substring(e[a][1].length - e[a - 1][1].length) === e[a - 1][1]
            ? ((e[a][1] = e[a - 1][1] + e[a][1].substring(0, e[a][1].length - e[a - 1][1].length)),
              (e[a + 1][1] = e[a - 1][1] + e[a + 1][1]),
              e.splice(a - 1, 1),
              (v = !0))
            : e[a][1].substring(0, e[a + 1][1].length) == e[a + 1][1] &&
              ((e[a - 1][1] += e[a + 1][1]),
              (e[a][1] = e[a][1].substring(e[a + 1][1].length) + e[a + 1][1]),
              e.splice(a + 1, 1),
              (v = !0))),
          a++);
      v && x(e, t);
    }
    function S(e) {
      return e >= 55296 && e <= 56319;
    }
    function C(e) {
      return e >= 56320 && e <= 57343;
    }
    function w(e) {
      return C(e.charCodeAt(0));
    }
    function T(e) {
      return S(e.charCodeAt(e.length - 1));
    }
    function E(e) {
      for (var t = [], n = 0; n < e.length; n++) e[n][1].length > 0 && t.push(e[n]);
      return t;
    }
    function D(e, t, a, o) {
      return T(e) || w(o)
        ? null
        : E([
            [i, e],
            [n, t],
            [r, a],
            [i, o],
          ]);
    }
    function ee(e, t, n) {
      var r =
          typeof n == `number`
            ? {
                index: n,
                length: 0,
              }
            : n.oldRange,
        i = typeof n == `number` ? null : n.newRange,
        a = e.length,
        o = t.length;
      if (r.length === 0 && (i === null || i.length === 0)) {
        var s = r.index,
          c = e.slice(0, s),
          l = e.slice(s),
          u = i ? i.index : null;
        editBefore: {
          var d = s + o - a;
          if ((u !== null && u !== d) || d < 0 || d > o) break editBefore;
          var f = t.slice(0, d),
            p = t.slice(d);
          if (p !== l) break editBefore;
          var m = Math.min(s, d),
            h = c.slice(0, m),
            g = f.slice(0, m);
          if (h !== g) break editBefore;
          var v = c.slice(m),
            y = f.slice(m);
          return D(h, v, y, l);
        }
        editAfter: {
          if (u !== null && u !== s) break editAfter;
          var b = s,
            f = t.slice(0, b),
            p = t.slice(b);
          if (f !== c) break editAfter;
          var x = Math.min(a - b, o - b),
            S = l.slice(l.length - x),
            C = p.slice(p.length - x);
          if (S !== C) break editAfter;
          var v = l.slice(0, l.length - x),
            y = p.slice(0, p.length - x);
          return D(c, v, y, S);
        }
      }
      if (r.length > 0 && i && i.length === 0)
        replaceRange: {
          var h = e.slice(0, r.index),
            S = e.slice(r.index + r.length),
            m = h.length,
            x = S.length;
          if (o < m + x) break replaceRange;
          var g = t.slice(0, m),
            C = t.slice(o - x);
          if (h !== g || S !== C) break replaceRange;
          var v = e.slice(m, a - x),
            y = t.slice(m, o - x);
          return D(h, v, y, S);
        }
      return null;
    }
    function te(e, t, n, r) {
      return a(e, t, n, r, !0);
    }
    ((te.INSERT = r), (te.DELETE = n), (te.EQUAL = i), (t.exports = te));
  }),
  _u = a((e, t) => {
    var n = 200,
      r = `__lodash_hash_undefined__`,
      i = 9007199254740991,
      a = `[object Arguments]`,
      o = `[object Array]`,
      s = `[object Boolean]`,
      c = `[object Date]`,
      l = `[object Error]`,
      u = `[object Function]`,
      d = `[object GeneratorFunction]`,
      f = `[object Map]`,
      p = `[object Number]`,
      m = `[object Object]`,
      h = `[object Promise]`,
      g = `[object RegExp]`,
      v = `[object Set]`,
      y = `[object String]`,
      b = `[object Symbol]`,
      x = `[object WeakMap]`,
      S = `[object ArrayBuffer]`,
      C = `[object DataView]`,
      w = `[object Float32Array]`,
      T = `[object Float64Array]`,
      E = `[object Int8Array]`,
      D = `[object Int16Array]`,
      ee = `[object Int32Array]`,
      te = `[object Uint8Array]`,
      O = `[object Uint8ClampedArray]`,
      k = `[object Uint16Array]`,
      ne = `[object Uint32Array]`,
      re = /[\\^$.*+?()[\]{}|]/g,
      A = /\w*$/,
      ie = /^\[object .+?Constructor\]$/,
      j = /^(?:0|[1-9]\d*)$/,
      ae = {};
    ((ae[a] =
      ae[o] =
      ae[S] =
      ae[C] =
      ae[s] =
      ae[c] =
      ae[w] =
      ae[T] =
      ae[E] =
      ae[D] =
      ae[ee] =
      ae[f] =
      ae[p] =
      ae[m] =
      ae[g] =
      ae[v] =
      ae[y] =
      ae[b] =
      ae[te] =
      ae[O] =
      ae[k] =
      ae[ne] =
        !0),
      (ae[l] = ae[u] = ae[x] = !1));
    var oe = typeof global == `object` && global && global.Object === Object && global,
      se = typeof self == `object` && self && self.Object === Object && self,
      ce = oe || se || Function(`return this`)(),
      le = typeof e == `object` && e && !e.nodeType && e,
      ue = le && typeof t == `object` && t && !t.nodeType && t,
      de = ue && ue.exports === le;
    function fe(e, t) {
      return (e.set(t[0], t[1]), e);
    }
    function pe(e, t) {
      return (e.add(t), e);
    }
    function M(e, t) {
      for (var n = -1, r = e ? e.length : 0; ++n < r && t(e[n], n, e) !== !1;);
      return e;
    }
    function me(e, t) {
      for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
      return e;
    }
    function N(e, t, n, r) {
      var i = -1,
        a = e ? e.length : 0;
      for (r && a && (n = e[++i]); ++i < a;) n = t(n, e[i], i, e);
      return n;
    }
    function P(e, t) {
      for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
      return r;
    }
    function he(e, t) {
      return e?.[t];
    }
    function ge(e) {
      var t = !1;
      if (e != null && typeof e.toString != `function`)
        try {
          t = !!(e + ``);
        } catch {}
      return t;
    }
    function _e(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e, r) {
          n[++t] = [r, e];
        }),
        n
      );
    }
    function ve(e, t) {
      return function (n) {
        return e(t(n));
      };
    }
    function ye(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e) {
          n[++t] = e;
        }),
        n
      );
    }
    var F = Array.prototype,
      be = Function.prototype,
      I = Object.prototype,
      L = ce[`__core-js_shared__`],
      xe = (function () {
        var e = /[^.]+$/.exec((L && L.keys && L.keys.IE_PROTO) || ``);
        return e ? `Symbol(src)_1.` + e : ``;
      })(),
      Se = be.toString,
      Ce = I.hasOwnProperty,
      we = I.toString,
      Te = RegExp(
        `^` +
          Se.call(Ce)
            .replace(re, `\\$&`)
            .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, `$1.*?`) +
          `$`,
      ),
      Ee = de ? ce.Buffer : void 0,
      De = ce.Symbol,
      Oe = ce.Uint8Array,
      ke = ve(Object.getPrototypeOf, Object),
      Ae = Object.create,
      je = I.propertyIsEnumerable,
      Me = F.splice,
      R = Object.getOwnPropertySymbols,
      Ne = Ee ? Ee.isBuffer : void 0,
      Pe = ve(Object.keys, Object),
      Fe = Pt(ce, `DataView`),
      Ie = Pt(ce, `Map`),
      Le = Pt(ce, `Promise`),
      Re = Pt(ce, `Set`),
      ze = Pt(ce, `WeakMap`),
      Be = Pt(Object, `create`),
      z = Wt(Fe),
      Ve = Wt(Ie),
      He = Wt(Le),
      Ue = Wt(Re),
      We = Wt(ze),
      B = De ? De.prototype : void 0,
      Ge = B ? B.valueOf : void 0;
    function Ke(e) {
      var t = -1,
        n = e ? e.length : 0;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    function qe() {
      this.__data__ = Be ? Be(null) : {};
    }
    function V(e) {
      return this.has(e) && delete this.__data__[e];
    }
    function Je(e) {
      var t = this.__data__;
      if (Be) {
        var n = t[e];
        return n === r ? void 0 : n;
      }
      return Ce.call(t, e) ? t[e] : void 0;
    }
    function H(e) {
      var t = this.__data__;
      return Be ? t[e] !== void 0 : Ce.call(t, e);
    }
    function Ye(e, t) {
      var n = this.__data__;
      return ((n[e] = Be && t === void 0 ? r : t), this);
    }
    ((Ke.prototype.clear = qe),
      (Ke.prototype.delete = V),
      (Ke.prototype.get = Je),
      (Ke.prototype.has = H),
      (Ke.prototype.set = Ye));
    function U(e) {
      var t = -1,
        n = e ? e.length : 0;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    function Xe() {
      this.__data__ = [];
    }
    function W(e) {
      var t = this.__data__,
        n = mt(t, e);
      return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Me.call(t, n, 1), !0);
    }
    function Ze(e) {
      var t = this.__data__,
        n = mt(t, e);
      return n < 0 ? void 0 : t[n][1];
    }
    function Qe(e) {
      return mt(this.__data__, e) > -1;
    }
    function $e(e, t) {
      var n = this.__data__,
        r = mt(n, e);
      return (r < 0 ? n.push([e, t]) : (n[r][1] = t), this);
    }
    ((U.prototype.clear = Xe),
      (U.prototype.delete = W),
      (U.prototype.get = Ze),
      (U.prototype.has = Qe),
      (U.prototype.set = $e));
    function et(e) {
      var t = -1,
        n = e ? e.length : 0;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    function tt() {
      this.__data__ = {
        hash: new Ke(),
        map: new (Ie || U)(),
        string: new Ke(),
      };
    }
    function nt(e) {
      return Nt(this, e).delete(e);
    }
    function rt(e) {
      return Nt(this, e).get(e);
    }
    function it(e) {
      return Nt(this, e).has(e);
    }
    function at(e, t) {
      return (Nt(this, e).set(e, t), this);
    }
    ((et.prototype.clear = tt),
      (et.prototype.delete = nt),
      (et.prototype.get = rt),
      (et.prototype.has = it),
      (et.prototype.set = at));
    function ot(e) {
      this.__data__ = new U(e);
    }
    function st() {
      this.__data__ = new U();
    }
    function ct(e) {
      return this.__data__.delete(e);
    }
    function lt(e) {
      return this.__data__.get(e);
    }
    function ut(e) {
      return this.__data__.has(e);
    }
    function dt(e, t) {
      var r = this.__data__;
      if (r instanceof U) {
        var i = r.__data__;
        if (!Ie || i.length < n - 1) return (i.push([e, t]), this);
        r = this.__data__ = new et(i);
      }
      return (r.set(e, t), this);
    }
    ((ot.prototype.clear = st),
      (ot.prototype.delete = ct),
      (ot.prototype.get = lt),
      (ot.prototype.has = ut),
      (ot.prototype.set = dt));
    function ft(e, t) {
      var n = Jt(e) || qt(e) ? P(e.length, String) : [],
        r = n.length,
        i = !!r;
      for (var a in e) (t || Ce.call(e, a)) && !(i && (a == `length` || Bt(a, r))) && n.push(a);
      return n;
    }
    function pt(e, t, n) {
      var r = e[t];
      (!(Ce.call(e, t) && Kt(r, n)) || (n === void 0 && !(t in e))) && (e[t] = n);
    }
    function mt(e, t) {
      for (var n = e.length; n--;) if (Kt(e[n][0], t)) return n;
      return -1;
    }
    function ht(e, t) {
      return e && At(t, nn(t), e);
    }
    function G(e, t, n, r, i, o, s) {
      var c;
      if ((r && (c = o ? r(e, i, o, s) : r(e)), c !== void 0)) return c;
      if (!en(e)) return e;
      var l = Jt(e);
      if (l) {
        if (((c = Lt(e)), !t)) return kt(e, c);
      } else {
        var f = It(e),
          p = f == u || f == d;
        if (Zt(e)) return xt(e, t);
        if (f == m || f == a || (p && !o)) {
          if (ge(e)) return o ? e : {};
          if (((c = Rt(p ? {} : e)), !t)) return jt(e, ht(c, e));
        } else {
          if (!ae[f]) return o ? e : {};
          c = zt(e, f, G, t);
        }
      }
      s ||= new ot();
      var h = s.get(e);
      if (h) return h;
      if ((s.set(e, c), !l)) var g = n ? Mt(e) : nn(e);
      return (
        M(g || e, function (i, a) {
          (g && ((a = i), (i = e[a])), pt(c, a, G(i, t, n, r, a, e, s)));
        }),
        c
      );
    }
    function gt(e) {
      return en(e) ? Ae(e) : {};
    }
    function _t(e, t, n) {
      var r = t(e);
      return Jt(e) ? r : me(r, n(e));
    }
    function vt(e) {
      return we.call(e);
    }
    function yt(e) {
      return !en(e) || Ht(e) ? !1 : (Qt(e) || ge(e) ? Te : ie).test(Wt(e));
    }
    function bt(e) {
      if (!Ut(e)) return Pe(e);
      var t = [];
      for (var n in Object(e)) Ce.call(e, n) && n != `constructor` && t.push(n);
      return t;
    }
    function xt(e, t) {
      if (t) return e.slice();
      var n = new e.constructor(e.length);
      return (e.copy(n), n);
    }
    function St(e) {
      var t = new e.constructor(e.byteLength);
      return (new Oe(t).set(new Oe(e)), t);
    }
    function Ct(e, t) {
      var n = t ? St(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.byteLength);
    }
    function wt(e, t, n) {
      return N(t ? n(_e(e), !0) : _e(e), fe, new e.constructor());
    }
    function Tt(e) {
      var t = new e.constructor(e.source, A.exec(e));
      return ((t.lastIndex = e.lastIndex), t);
    }
    function Et(e, t, n) {
      return N(t ? n(ye(e), !0) : ye(e), pe, new e.constructor());
    }
    function Dt(e) {
      return Ge ? Object(Ge.call(e)) : {};
    }
    function Ot(e, t) {
      var n = t ? St(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.length);
    }
    function kt(e, t) {
      var n = -1,
        r = e.length;
      for (t ||= Array(r); ++n < r;) t[n] = e[n];
      return t;
    }
    function At(e, t, n, r) {
      n ||= {};
      for (var i = -1, a = t.length; ++i < a;) {
        var o = t[i],
          s = r ? r(n[o], e[o], o, n, e) : void 0;
        pt(n, o, s === void 0 ? e[o] : s);
      }
      return n;
    }
    function jt(e, t) {
      return At(e, Ft(e), t);
    }
    function Mt(e) {
      return _t(e, nn, Ft);
    }
    function Nt(e, t) {
      var n = e.__data__;
      return Vt(t) ? n[typeof t == `string` ? `string` : `hash`] : n.map;
    }
    function Pt(e, t) {
      var n = he(e, t);
      return yt(n) ? n : void 0;
    }
    var Ft = R ? ve(R, Object) : rn,
      It = vt;
    ((Fe && It(new Fe(new ArrayBuffer(1))) != C) ||
      (Ie && It(new Ie()) != f) ||
      (Le && It(Le.resolve()) != h) ||
      (Re && It(new Re()) != v) ||
      (ze && It(new ze()) != x)) &&
      (It = function (e) {
        var t = we.call(e),
          n = t == m ? e.constructor : void 0,
          r = n ? Wt(n) : void 0;
        if (r)
          switch (r) {
            case z:
              return C;
            case Ve:
              return f;
            case He:
              return h;
            case Ue:
              return v;
            case We:
              return x;
          }
        return t;
      });
    function Lt(e) {
      var t = e.length,
        n = e.constructor(t);
      return (
        t &&
          typeof e[0] == `string` &&
          Ce.call(e, `index`) &&
          ((n.index = e.index), (n.input = e.input)),
        n
      );
    }
    function Rt(e) {
      return typeof e.constructor == `function` && !Ut(e) ? gt(ke(e)) : {};
    }
    function zt(e, t, n, r) {
      var i = e.constructor;
      switch (t) {
        case S:
          return St(e);
        case s:
        case c:
          return new i(+e);
        case C:
          return Ct(e, r);
        case w:
        case T:
        case E:
        case D:
        case ee:
        case te:
        case O:
        case k:
        case ne:
          return Ot(e, r);
        case f:
          return wt(e, r, n);
        case p:
        case y:
          return new i(e);
        case g:
          return Tt(e);
        case v:
          return Et(e, r, n);
        case b:
          return Dt(e);
      }
    }
    function Bt(e, t) {
      return (
        (t ??= i),
        !!t && (typeof e == `number` || j.test(e)) && e > -1 && e % 1 == 0 && e < t
      );
    }
    function Vt(e) {
      var t = typeof e;
      return t == `string` || t == `number` || t == `symbol` || t == `boolean`
        ? e !== `__proto__`
        : e === null;
    }
    function Ht(e) {
      return !!xe && xe in e;
    }
    function Ut(e) {
      var t = e && e.constructor;
      return e === ((typeof t == `function` && t.prototype) || I);
    }
    function Wt(e) {
      if (e != null) {
        try {
          return Se.call(e);
        } catch {}
        try {
          return e + ``;
        } catch {}
      }
      return ``;
    }
    function Gt(e) {
      return G(e, !0, !0);
    }
    function Kt(e, t) {
      return e === t || (e !== e && t !== t);
    }
    function qt(e) {
      return Xt(e) && Ce.call(e, `callee`) && (!je.call(e, `callee`) || we.call(e) == a);
    }
    var Jt = Array.isArray;
    function Yt(e) {
      return e != null && $t(e.length) && !Qt(e);
    }
    function Xt(e) {
      return tn(e) && Yt(e);
    }
    var Zt = Ne || an;
    function Qt(e) {
      var t = en(e) ? we.call(e) : ``;
      return t == u || t == d;
    }
    function $t(e) {
      return typeof e == `number` && e > -1 && e % 1 == 0 && e <= i;
    }
    function en(e) {
      var t = typeof e;
      return !!e && (t == `object` || t == `function`);
    }
    function tn(e) {
      return !!e && typeof e == `object`;
    }
    function nn(e) {
      return Yt(e) ? ft(e) : bt(e);
    }
    function rn() {
      return [];
    }
    function an() {
      return !1;
    }
    t.exports = Gt;
  }),
  vu = a((e, t) => {
    var n = 200,
      r = `__lodash_hash_undefined__`,
      i = 1,
      a = 2,
      o = 9007199254740991,
      s = `[object Arguments]`,
      c = `[object Array]`,
      l = `[object AsyncFunction]`,
      u = `[object Boolean]`,
      d = `[object Date]`,
      f = `[object Error]`,
      p = `[object Function]`,
      m = `[object GeneratorFunction]`,
      h = `[object Map]`,
      g = `[object Number]`,
      v = `[object Null]`,
      y = `[object Object]`,
      b = `[object Promise]`,
      x = `[object Proxy]`,
      S = `[object RegExp]`,
      C = `[object Set]`,
      w = `[object String]`,
      T = `[object Symbol]`,
      E = `[object Undefined]`,
      D = `[object WeakMap]`,
      ee = `[object ArrayBuffer]`,
      te = `[object DataView]`,
      O = `[object Float32Array]`,
      k = `[object Float64Array]`,
      ne = `[object Int8Array]`,
      re = `[object Int16Array]`,
      A = `[object Int32Array]`,
      ie = `[object Uint8Array]`,
      j = `[object Uint8ClampedArray]`,
      ae = `[object Uint16Array]`,
      oe = `[object Uint32Array]`,
      se = /[\\^$.*+?()[\]{}|]/g,
      ce = /^\[object .+?Constructor\]$/,
      le = /^(?:0|[1-9]\d*)$/,
      ue = {};
    ((ue[O] = ue[k] = ue[ne] = ue[re] = ue[A] = ue[ie] = ue[j] = ue[ae] = ue[oe] = !0),
      (ue[s] =
        ue[c] =
        ue[ee] =
        ue[u] =
        ue[te] =
        ue[d] =
        ue[f] =
        ue[p] =
        ue[h] =
        ue[g] =
        ue[y] =
        ue[S] =
        ue[C] =
        ue[w] =
        ue[D] =
          !1));
    var de = typeof global == `object` && global && global.Object === Object && global,
      fe = typeof self == `object` && self && self.Object === Object && self,
      pe = de || fe || Function(`return this`)(),
      M = typeof e == `object` && e && !e.nodeType && e,
      me = M && typeof t == `object` && t && !t.nodeType && t,
      N = me && me.exports === M,
      P = N && de.process,
      he = (function () {
        try {
          return P && P.binding && P.binding(`util`);
        } catch {}
      })(),
      ge = he && he.isTypedArray;
    function _e(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
        var o = e[n];
        t(o, n, e) && (a[i++] = o);
      }
      return a;
    }
    function ve(e, t) {
      for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
      return e;
    }
    function ye(e, t) {
      for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
      return !1;
    }
    function F(e, t) {
      for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
      return r;
    }
    function be(e) {
      return function (t) {
        return e(t);
      };
    }
    function I(e, t) {
      return e.has(t);
    }
    function L(e, t) {
      return e?.[t];
    }
    function xe(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e, r) {
          n[++t] = [r, e];
        }),
        n
      );
    }
    function Se(e, t) {
      return function (n) {
        return e(t(n));
      };
    }
    function Ce(e) {
      var t = -1,
        n = Array(e.size);
      return (
        e.forEach(function (e) {
          n[++t] = e;
        }),
        n
      );
    }
    var we = Array.prototype,
      Te = Function.prototype,
      Ee = Object.prototype,
      De = pe[`__core-js_shared__`],
      Oe = Te.toString,
      ke = Ee.hasOwnProperty,
      Ae = (function () {
        var e = /[^.]+$/.exec((De && De.keys && De.keys.IE_PROTO) || ``);
        return e ? `Symbol(src)_1.` + e : ``;
      })(),
      je = Ee.toString,
      Me = RegExp(
        `^` +
          Oe.call(ke)
            .replace(se, `\\$&`)
            .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, `$1.*?`) +
          `$`,
      ),
      R = N ? pe.Buffer : void 0,
      Ne = pe.Symbol,
      Pe = pe.Uint8Array,
      Fe = Ee.propertyIsEnumerable,
      Ie = we.splice,
      Le = Ne ? Ne.toStringTag : void 0,
      Re = Object.getOwnPropertySymbols,
      ze = R ? R.isBuffer : void 0,
      Be = Se(Object.keys, Object),
      z = Ft(pe, `DataView`),
      Ve = Ft(pe, `Map`),
      He = Ft(pe, `Promise`),
      Ue = Ft(pe, `Set`),
      We = Ft(pe, `WeakMap`),
      B = Ft(Object, `create`),
      Ge = Wt(z),
      Ke = Wt(Ve),
      qe = Wt(He),
      V = Wt(Ue),
      Je = Wt(We),
      H = Ne ? Ne.prototype : void 0,
      Ye = H ? H.valueOf : void 0;
    function U(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    function Xe() {
      ((this.__data__ = B ? B(null) : {}), (this.size = 0));
    }
    function W(e) {
      var t = this.has(e) && delete this.__data__[e];
      return ((this.size -= +!!t), t);
    }
    function Ze(e) {
      var t = this.__data__;
      if (B) {
        var n = t[e];
        return n === r ? void 0 : n;
      }
      return ke.call(t, e) ? t[e] : void 0;
    }
    function Qe(e) {
      var t = this.__data__;
      return B ? t[e] !== void 0 : ke.call(t, e);
    }
    function $e(e, t) {
      var n = this.__data__;
      return ((this.size += +!this.has(e)), (n[e] = B && t === void 0 ? r : t), this);
    }
    ((U.prototype.clear = Xe),
      (U.prototype.delete = W),
      (U.prototype.get = Ze),
      (U.prototype.has = Qe),
      (U.prototype.set = $e));
    function et(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    function tt() {
      ((this.__data__ = []), (this.size = 0));
    }
    function nt(e) {
      var t = this.__data__,
        n = xt(t, e);
      return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Ie.call(t, n, 1), --this.size, !0);
    }
    function rt(e) {
      var t = this.__data__,
        n = xt(t, e);
      return n < 0 ? void 0 : t[n][1];
    }
    function it(e) {
      return xt(this.__data__, e) > -1;
    }
    function at(e, t) {
      var n = this.__data__,
        r = xt(n, e);
      return (r < 0 ? (++this.size, n.push([e, t])) : (n[r][1] = t), this);
    }
    ((et.prototype.clear = tt),
      (et.prototype.delete = nt),
      (et.prototype.get = rt),
      (et.prototype.has = it),
      (et.prototype.set = at));
    function ot(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }
    function st() {
      ((this.size = 0),
        (this.__data__ = {
          hash: new U(),
          map: new (Ve || et)(),
          string: new U(),
        }));
    }
    function ct(e) {
      var t = Pt(this, e).delete(e);
      return ((this.size -= +!!t), t);
    }
    function lt(e) {
      return Pt(this, e).get(e);
    }
    function ut(e) {
      return Pt(this, e).has(e);
    }
    function dt(e, t) {
      var n = Pt(this, e),
        r = n.size;
      return (n.set(e, t), (this.size += n.size == r ? 0 : 1), this);
    }
    ((ot.prototype.clear = st),
      (ot.prototype.delete = ct),
      (ot.prototype.get = lt),
      (ot.prototype.has = ut),
      (ot.prototype.set = dt));
    function ft(e) {
      var t = -1,
        n = e == null ? 0 : e.length;
      for (this.__data__ = new ot(); ++t < n;) this.add(e[t]);
    }
    function pt(e) {
      return (this.__data__.set(e, r), this);
    }
    function mt(e) {
      return this.__data__.has(e);
    }
    ((ft.prototype.add = ft.prototype.push = pt), (ft.prototype.has = mt));
    function ht(e) {
      var t = (this.__data__ = new et(e));
      this.size = t.size;
    }
    function G() {
      ((this.__data__ = new et()), (this.size = 0));
    }
    function gt(e) {
      var t = this.__data__,
        n = t.delete(e);
      return ((this.size = t.size), n);
    }
    function _t(e) {
      return this.__data__.get(e);
    }
    function vt(e) {
      return this.__data__.has(e);
    }
    function yt(e, t) {
      var r = this.__data__;
      if (r instanceof et) {
        var i = r.__data__;
        if (!Ve || i.length < n - 1) return (i.push([e, t]), (this.size = ++r.size), this);
        r = this.__data__ = new ot(i);
      }
      return (r.set(e, t), (this.size = r.size), this);
    }
    ((ht.prototype.clear = G),
      (ht.prototype.delete = gt),
      (ht.prototype.get = _t),
      (ht.prototype.has = vt),
      (ht.prototype.set = yt));
    function bt(e, t) {
      var n = qt(e),
        r = !n && Kt(e),
        i = !n && !r && Yt(e),
        a = !n && !r && !i && tn(e),
        o = n || r || i || a,
        s = o ? F(e.length, String) : [],
        c = s.length;
      for (var l in e)
        (t || ke.call(e, l)) &&
          !(
            o &&
            (l == `length` ||
              (i && (l == `offset` || l == `parent`)) ||
              (a && (l == `buffer` || l == `byteLength` || l == `byteOffset`)) ||
              zt(l, c))
          ) &&
          s.push(l);
      return s;
    }
    function xt(e, t) {
      for (var n = e.length; n--;) if (Gt(e[n][0], t)) return n;
      return -1;
    }
    function St(e, t, n) {
      var r = t(e);
      return qt(e) ? r : ve(r, n(e));
    }
    function Ct(e) {
      return e == null ? (e === void 0 ? E : v) : Le && Le in Object(e) ? It(e) : Ut(e);
    }
    function wt(e) {
      return en(e) && Ct(e) == s;
    }
    function Tt(e, t, n, r, i) {
      return e === t
        ? !0
        : e == null || t == null || (!en(e) && !en(t))
          ? e !== e && t !== t
          : Et(e, t, n, r, Tt, i);
    }
    function Et(e, t, n, r, a, o) {
      var l = qt(e),
        u = qt(t),
        d = l ? c : Rt(e),
        f = u ? c : Rt(t);
      ((d = d == s ? y : d), (f = f == s ? y : f));
      var p = d == y,
        m = f == y,
        h = d == f;
      if (h && Yt(e)) {
        if (!Yt(t)) return !1;
        ((l = !0), (p = !1));
      }
      if (h && !p)
        return ((o ||= new ht()), l || tn(e) ? At(e, t, n, r, a, o) : jt(e, t, d, n, r, a, o));
      if (!(n & i)) {
        var g = p && ke.call(e, `__wrapped__`),
          v = m && ke.call(t, `__wrapped__`);
        if (g || v) {
          var b = g ? e.value() : e,
            x = v ? t.value() : t;
          return ((o ||= new ht()), a(b, x, n, r, o));
        }
      }
      return h ? ((o ||= new ht()), Mt(e, t, n, r, a, o)) : !1;
    }
    function Dt(e) {
      return !$t(e) || Vt(e) ? !1 : (Zt(e) ? Me : ce).test(Wt(e));
    }
    function Ot(e) {
      return en(e) && Qt(e.length) && !!ue[Ct(e)];
    }
    function kt(e) {
      if (!Ht(e)) return Be(e);
      var t = [];
      for (var n in Object(e)) ke.call(e, n) && n != `constructor` && t.push(n);
      return t;
    }
    function At(e, t, n, r, o, s) {
      var c = n & i,
        l = e.length,
        u = t.length;
      if (l != u && !(c && u > l)) return !1;
      var d = s.get(e);
      if (d && s.get(t)) return d == t;
      var f = -1,
        p = !0,
        m = n & a ? new ft() : void 0;
      for (s.set(e, t), s.set(t, e); ++f < l;) {
        var h = e[f],
          g = t[f];
        if (r) var v = c ? r(g, h, f, t, e, s) : r(h, g, f, e, t, s);
        if (v !== void 0) {
          if (v) continue;
          p = !1;
          break;
        }
        if (m) {
          if (
            !ye(t, function (e, t) {
              if (!I(m, t) && (h === e || o(h, e, n, r, s))) return m.push(t);
            })
          ) {
            p = !1;
            break;
          }
        } else if (!(h === g || o(h, g, n, r, s))) {
          p = !1;
          break;
        }
      }
      return (s.delete(e), s.delete(t), p);
    }
    function jt(e, t, n, r, o, s, c) {
      switch (n) {
        case te:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          ((e = e.buffer), (t = t.buffer));
        case ee:
          return !(e.byteLength != t.byteLength || !s(new Pe(e), new Pe(t)));
        case u:
        case d:
        case g:
          return Gt(+e, +t);
        case f:
          return e.name == t.name && e.message == t.message;
        case S:
        case w:
          return e == t + ``;
        case h:
          var l = xe;
        case C:
          var p = r & i;
          if (((l ||= Ce), e.size != t.size && !p)) return !1;
          var m = c.get(e);
          if (m) return m == t;
          ((r |= a), c.set(e, t));
          var v = At(l(e), l(t), r, o, s, c);
          return (c.delete(e), v);
        case T:
          if (Ye) return Ye.call(e) == Ye.call(t);
      }
      return !1;
    }
    function Mt(e, t, n, r, a, o) {
      var s = n & i,
        c = Nt(e),
        l = c.length;
      if (l != Nt(t).length && !s) return !1;
      for (var u = l; u--;) {
        var d = c[u];
        if (!(s ? d in t : ke.call(t, d))) return !1;
      }
      var f = o.get(e);
      if (f && o.get(t)) return f == t;
      var p = !0;
      (o.set(e, t), o.set(t, e));
      for (var m = s; ++u < l;) {
        d = c[u];
        var h = e[d],
          g = t[d];
        if (r) var v = s ? r(g, h, d, t, e, o) : r(h, g, d, e, t, o);
        if (!(v === void 0 ? h === g || a(h, g, n, r, o) : v)) {
          p = !1;
          break;
        }
        m ||= d == `constructor`;
      }
      if (p && !m) {
        var y = e.constructor,
          b = t.constructor;
        y != b &&
          `constructor` in e &&
          `constructor` in t &&
          !(typeof y == `function` && y instanceof y && typeof b == `function` && b instanceof b) &&
          (p = !1);
      }
      return (o.delete(e), o.delete(t), p);
    }
    function Nt(e) {
      return St(e, nn, Lt);
    }
    function Pt(e, t) {
      var n = e.__data__;
      return Bt(t) ? n[typeof t == `string` ? `string` : `hash`] : n.map;
    }
    function Ft(e, t) {
      var n = L(e, t);
      return Dt(n) ? n : void 0;
    }
    function It(e) {
      var t = ke.call(e, Le),
        n = e[Le];
      try {
        e[Le] = void 0;
        var r = !0;
      } catch {}
      var i = je.call(e);
      return (r && (t ? (e[Le] = n) : delete e[Le]), i);
    }
    var Lt = Re
        ? function (e) {
            return e == null
              ? []
              : ((e = Object(e)),
                _e(Re(e), function (t) {
                  return Fe.call(e, t);
                }));
          }
        : rn,
      Rt = Ct;
    ((z && Rt(new z(new ArrayBuffer(1))) != te) ||
      (Ve && Rt(new Ve()) != h) ||
      (He && Rt(He.resolve()) != b) ||
      (Ue && Rt(new Ue()) != C) ||
      (We && Rt(new We()) != D)) &&
      (Rt = function (e) {
        var t = Ct(e),
          n = t == y ? e.constructor : void 0,
          r = n ? Wt(n) : ``;
        if (r)
          switch (r) {
            case Ge:
              return te;
            case Ke:
              return h;
            case qe:
              return b;
            case V:
              return C;
            case Je:
              return D;
          }
        return t;
      });
    function zt(e, t) {
      return (
        (t ??= o),
        !!t && (typeof e == `number` || le.test(e)) && e > -1 && e % 1 == 0 && e < t
      );
    }
    function Bt(e) {
      var t = typeof e;
      return t == `string` || t == `number` || t == `symbol` || t == `boolean`
        ? e !== `__proto__`
        : e === null;
    }
    function Vt(e) {
      return !!Ae && Ae in e;
    }
    function Ht(e) {
      var t = e && e.constructor;
      return e === ((typeof t == `function` && t.prototype) || Ee);
    }
    function Ut(e) {
      return je.call(e);
    }
    function Wt(e) {
      if (e != null) {
        try {
          return Oe.call(e);
        } catch {}
        try {
          return e + ``;
        } catch {}
      }
      return ``;
    }
    function Gt(e, t) {
      return e === t || (e !== e && t !== t);
    }
    var Kt = wt(
        (function () {
          return arguments;
        })(),
      )
        ? wt
        : function (e) {
            return en(e) && ke.call(e, `callee`) && !Fe.call(e, `callee`);
          },
      qt = Array.isArray;
    function Jt(e) {
      return e != null && Qt(e.length) && !Zt(e);
    }
    var Yt = ze || an;
    function Xt(e, t) {
      return Tt(e, t);
    }
    function Zt(e) {
      if (!$t(e)) return !1;
      var t = Ct(e);
      return t == p || t == m || t == l || t == x;
    }
    function Qt(e) {
      return typeof e == `number` && e > -1 && e % 1 == 0 && e <= o;
    }
    function $t(e) {
      var t = typeof e;
      return e != null && (t == `object` || t == `function`);
    }
    function en(e) {
      return typeof e == `object` && !!e;
    }
    var tn = ge ? be(ge) : Ot;
    function nn(e) {
      return Jt(e) ? bt(e) : kt(e);
    }
    function rn() {
      return [];
    }
    function an() {
      return !1;
    }
    t.exports = Xt;
  }),
  yu = a((e) => {
    Object.defineProperty(e, "__esModule", {
      value: !0,
    });
    var t = _u(),
      n = vu(),
      r;
    ((function (e) {
      function r(e = {}, n = {}, r = !1) {
        (typeof e != `object` && (e = {}), typeof n != `object` && (n = {}));
        let i = t(n);
        r || (i = Object.keys(i).reduce((e, t) => (i[t] != null && (e[t] = i[t]), e), {}));
        for (let t in e) e[t] !== void 0 && n[t] === void 0 && (i[t] = e[t]);
        return Object.keys(i).length > 0 ? i : void 0;
      }
      e.compose = r;
      function i(e = {}, t = {}) {
        (typeof e != `object` && (e = {}), typeof t != `object` && (t = {}));
        let r = Object.keys(e)
          .concat(Object.keys(t))
          .reduce((r, i) => (n(e[i], t[i]) || (r[i] = t[i] === void 0 ? null : t[i]), r), {});
        return Object.keys(r).length > 0 ? r : void 0;
      }
      e.diff = i;
      function a(e = {}, t = {}) {
        e ||= {};
        let n = Object.keys(t).reduce(
          (n, r) => (t[r] !== e[r] && e[r] !== void 0 && (n[r] = t[r]), n),
          {},
        );
        return Object.keys(e).reduce(
          (n, r) => (e[r] !== t[r] && t[r] === void 0 && (n[r] = null), n),
          n,
        );
      }
      e.invert = a;
      function o(e, t, n = !1) {
        if (typeof e != `object`) return t;
        if (typeof t != `object`) return;
        if (!n) return t;
        let r = Object.keys(t).reduce((n, r) => (e[r] === void 0 && (n[r] = t[r]), n), {});
        return Object.keys(r).length > 0 ? r : void 0;
      }
      e.transform = o;
    })((r ||= {})),
      (e.default = r));
  }),
  bu = a((e) => {
    Object.defineProperty(e, "__esModule", {
      value: !0,
    });
    var t;
    ((function (e) {
      function t(e) {
        return typeof e.delete == `number`
          ? e.delete
          : typeof e.retain == `number`
            ? e.retain
            : typeof e.retain == `object` && e.retain !== null
              ? 1
              : typeof e.insert == `string`
                ? e.insert.length
                : 1;
      }
      e.length = t;
    })((t ||= {})),
      (e.default = t));
  }),
  xu = a((e) => {
    Object.defineProperty(e, "__esModule", {
      value: !0,
    });
    var t = bu();
    e.default = class {
      constructor(e) {
        ((this.ops = e), (this.index = 0), (this.offset = 0));
      }
      hasNext() {
        return this.peekLength() < 1 / 0;
      }
      next(e) {
        e ||= 1 / 0;
        let n = this.ops[this.index];
        if (n) {
          let r = this.offset,
            i = t.default.length(n);
          if (
            (e >= i - r ? ((e = i - r), (this.index += 1), (this.offset = 0)) : (this.offset += e),
            typeof n.delete == `number`)
          )
            return {
              delete: e,
            };
          {
            let t = {};
            return (
              n.attributes && (t.attributes = n.attributes),
              typeof n.retain == `number`
                ? (t.retain = e)
                : typeof n.retain == `object` && n.retain !== null
                  ? (t.retain = n.retain)
                  : typeof n.insert == `string`
                    ? (t.insert = n.insert.substr(r, e))
                    : (t.insert = n.insert),
              t
            );
          }
        } else
          return {
            retain: 1 / 0,
          };
      }
      peek() {
        return this.ops[this.index];
      }
      peekLength() {
        return this.ops[this.index] ? t.default.length(this.ops[this.index]) - this.offset : 1 / 0;
      }
      peekType() {
        let e = this.ops[this.index];
        return e
          ? typeof e.delete == `number`
            ? `delete`
            : typeof e.retain == `number` || (typeof e.retain == `object` && e.retain !== null)
              ? `retain`
              : `insert`
          : `retain`;
      }
      rest() {
        if (!this.hasNext()) return [];
        if (this.offset === 0) return this.ops.slice(this.index);
        {
          let e = this.offset,
            t = this.index,
            n = this.next(),
            r = this.ops.slice(this.index);
          return ((this.offset = e), (this.index = t), [n].concat(r));
        }
      }
    };
  }),
  Su = a((e, t) => {
    (Object.defineProperty(e, "__esModule", {
      value: !0,
    }),
      (e.AttributeMap = e.OpIterator = e.Op = void 0));
    var n = gu(),
      r = _u(),
      i = vu(),
      a = yu();
    e.AttributeMap = a.default;
    var o = bu();
    e.Op = o.default;
    var s = xu();
    e.OpIterator = s.default;
    var c = `\0`,
      l = (e, t) => {
        if (typeof e != `object` || !e) throw Error(`cannot retain a ${typeof e}`);
        if (typeof t != `object` || !t) throw Error(`cannot retain a ${typeof t}`);
        let n = Object.keys(e)[0];
        if (!n || n !== Object.keys(t)[0])
          throw Error(`embed types not matched: ${n} != ${Object.keys(t)[0]}`);
        return [n, e[n], t[n]];
      },
      u = class e {
        constructor(e) {
          Array.isArray(e)
            ? (this.ops = e)
            : e != null && Array.isArray(e.ops)
              ? (this.ops = e.ops)
              : (this.ops = []);
        }
        static registerEmbed(e, t) {
          this.handlers[e] = t;
        }
        static unregisterEmbed(e) {
          delete this.handlers[e];
        }
        static getHandler(e) {
          let t = this.handlers[e];
          if (!t) throw Error(`no handlers for embed type "${e}"`);
          return t;
        }
        insert(e, t) {
          let n = {};
          return typeof e == `string` && e.length === 0
            ? this
            : ((n.insert = e),
              typeof t == `object` && t && Object.keys(t).length > 0 && (n.attributes = t),
              this.push(n));
        }
        delete(e) {
          return e <= 0
            ? this
            : this.push({
                delete: e,
              });
        }
        retain(e, t) {
          if (typeof e == `number` && e <= 0) return this;
          let n = {
            retain: e,
          };
          return (
            typeof t == `object` && t && Object.keys(t).length > 0 && (n.attributes = t),
            this.push(n)
          );
        }
        push(e) {
          let t = this.ops.length,
            n = this.ops[t - 1];
          if (((e = r(e)), typeof n == `object`)) {
            if (typeof e.delete == `number` && typeof n.delete == `number`)
              return (
                (this.ops[t - 1] = {
                  delete: n.delete + e.delete,
                }),
                this
              );
            if (
              typeof n.delete == `number` &&
              e.insert != null &&
              (--t, (n = this.ops[t - 1]), typeof n != `object`)
            )
              return (this.ops.unshift(e), this);
            if (i(e.attributes, n.attributes)) {
              if (typeof e.insert == `string` && typeof n.insert == `string`)
                return (
                  (this.ops[t - 1] = {
                    insert: n.insert + e.insert,
                  }),
                  typeof e.attributes == `object` && (this.ops[t - 1].attributes = e.attributes),
                  this
                );
              if (typeof e.retain == `number` && typeof n.retain == `number`)
                return (
                  (this.ops[t - 1] = {
                    retain: n.retain + e.retain,
                  }),
                  typeof e.attributes == `object` && (this.ops[t - 1].attributes = e.attributes),
                  this
                );
            }
          }
          return (t === this.ops.length ? this.ops.push(e) : this.ops.splice(t, 0, e), this);
        }
        chop() {
          let e = this.ops[this.ops.length - 1];
          return (e && typeof e.retain == `number` && !e.attributes && this.ops.pop(), this);
        }
        filter(e) {
          return this.ops.filter(e);
        }
        forEach(e) {
          this.ops.forEach(e);
        }
        map(e) {
          return this.ops.map(e);
        }
        partition(e) {
          let t = [],
            n = [];
          return (
            this.forEach((r) => {
              (e(r) ? t : n).push(r);
            }),
            [t, n]
          );
        }
        reduce(e, t) {
          return this.ops.reduce(e, t);
        }
        changeLength() {
          return this.reduce(
            (e, t) => (t.insert ? e + o.default.length(t) : t.delete ? e - t.delete : e),
            0,
          );
        }
        length() {
          return this.reduce((e, t) => e + o.default.length(t), 0);
        }
        slice(t = 0, n = 1 / 0) {
          let r = [],
            i = new s.default(this.ops),
            a = 0;
          for (; a < n && i.hasNext();) {
            let e;
            (a < t ? (e = i.next(t - a)) : ((e = i.next(n - a)), r.push(e)),
              (a += o.default.length(e)));
          }
          return new e(r);
        }
        compose(t) {
          let n = new s.default(this.ops),
            r = new s.default(t.ops),
            o = [],
            c = r.peek();
          if (c != null && typeof c.retain == `number` && c.attributes == null) {
            let e = c.retain;
            for (; n.peekType() === `insert` && n.peekLength() <= e;)
              ((e -= n.peekLength()), o.push(n.next()));
            c.retain - e > 0 && r.next(c.retain - e);
          }
          let u = new e(o);
          for (; n.hasNext() || r.hasNext();)
            if (r.peekType() === `insert`) u.push(r.next());
            else if (n.peekType() === `delete`) u.push(n.next());
            else {
              let t = Math.min(n.peekLength(), r.peekLength()),
                o = n.next(t),
                s = r.next(t);
              if (s.retain) {
                let c = {};
                if (typeof o.retain == `number`)
                  c.retain = typeof s.retain == `number` ? t : s.retain;
                else if (typeof s.retain == `number`)
                  o.retain == null ? (c.insert = o.insert) : (c.retain = o.retain);
                else {
                  let t = o.retain == null ? `insert` : `retain`,
                    [n, r, i] = l(o[t], s.retain),
                    a = e.getHandler(n);
                  c[t] = {
                    [n]: a.compose(r, i, t === `retain`),
                  };
                }
                let d = a.default.compose(o.attributes, s.attributes, typeof o.retain == `number`);
                if (
                  (d && (c.attributes = d),
                  u.push(c),
                  !r.hasNext() && i(u.ops[u.ops.length - 1], c))
                ) {
                  let t = new e(n.rest());
                  return u.concat(t).chop();
                }
              } else
                typeof s.delete == `number` &&
                  (typeof o.retain == `number` ||
                    (typeof o.retain == `object` && o.retain !== null)) &&
                  u.push(s);
            }
          return u.chop();
        }
        concat(t) {
          let n = new e(this.ops.slice());
          return (
            t.ops.length > 0 && (n.push(t.ops[0]), (n.ops = n.ops.concat(t.ops.slice(1)))),
            n
          );
        }
        diff(t, r) {
          if (this.ops === t.ops) return new e();
          let o = [this, t].map((e) =>
              e
                .map((n) => {
                  if (n.insert != null) return typeof n.insert == `string` ? n.insert : c;
                  throw Error(`diff() called ` + (e === t ? `on` : `with`) + ` non-document`);
                })
                .join(``),
            ),
            l = new e(),
            u = n(o[0], o[1], r, !0),
            d = new s.default(this.ops),
            f = new s.default(t.ops);
          return (
            u.forEach((e) => {
              let t = e[1].length;
              for (; t > 0;) {
                let r = 0;
                switch (e[0]) {
                  case n.INSERT:
                    ((r = Math.min(f.peekLength(), t)), l.push(f.next(r)));
                    break;
                  case n.DELETE:
                    ((r = Math.min(t, d.peekLength())), d.next(r), l.delete(r));
                    break;
                  case n.EQUAL:
                    r = Math.min(d.peekLength(), f.peekLength(), t);
                    let e = d.next(r),
                      o = f.next(r);
                    i(e.insert, o.insert)
                      ? l.retain(r, a.default.diff(e.attributes, o.attributes))
                      : l.push(o).delete(r);
                    break;
                }
                t -= r;
              }
            }),
            l.chop()
          );
        }
        eachLine(
          t,
          n = `
`,
        ) {
          let r = new s.default(this.ops),
            i = new e(),
            a = 0;
          for (; r.hasNext();) {
            if (r.peekType() !== `insert`) return;
            let s = r.peek(),
              c = o.default.length(s) - r.peekLength(),
              l = typeof s.insert == `string` ? s.insert.indexOf(n, c) - c : -1;
            if (l < 0) i.push(r.next());
            else if (l > 0) i.push(r.next(l));
            else {
              if (t(i, r.next(1).attributes || {}, a) === !1) return;
              ((a += 1), (i = new e()));
            }
          }
          i.length() > 0 && t(i, {}, a);
        }
        invert(t) {
          let n = new e();
          return (
            this.reduce((r, i) => {
              if (i.insert) n.delete(o.default.length(i));
              else if (typeof i.retain == `number` && i.attributes == null)
                return (n.retain(i.retain), r + i.retain);
              else if (i.delete || typeof i.retain == `number`) {
                let e = i.delete || i.retain;
                return (
                  t.slice(r, r + e).forEach((e) => {
                    i.delete
                      ? n.push(e)
                      : i.retain &&
                        i.attributes &&
                        n.retain(o.default.length(e), a.default.invert(i.attributes, e.attributes));
                  }),
                  r + e
                );
              } else if (typeof i.retain == `object` && i.retain !== null) {
                let o = t.slice(r, r + 1),
                  c = new s.default(o.ops).next(),
                  [u, d, f] = l(i.retain, c.insert),
                  p = e.getHandler(u);
                return (
                  n.retain(
                    {
                      [u]: p.invert(d, f),
                    },
                    a.default.invert(i.attributes, c.attributes),
                  ),
                  r + 1
                );
              }
              return r;
            }, 0),
            n.chop()
          );
        }
        transform(t, n = !1) {
          if (((n = !!n), typeof t == `number`)) return this.transformPosition(t, n);
          let r = t,
            i = new s.default(this.ops),
            c = new s.default(r.ops),
            l = new e();
          for (; i.hasNext() || c.hasNext();)
            if (i.peekType() === `insert` && (n || c.peekType() !== `insert`))
              l.retain(o.default.length(i.next()));
            else if (c.peekType() === `insert`) l.push(c.next());
            else {
              let t = Math.min(i.peekLength(), c.peekLength()),
                r = i.next(t),
                o = c.next(t);
              if (r.delete) continue;
              if (o.delete) l.push(o);
              else {
                let i = r.retain,
                  s = o.retain,
                  c = typeof s == `object` && s ? s : t;
                if (typeof i == `object` && i && typeof s == `object` && s) {
                  let t = Object.keys(i)[0];
                  if (t === Object.keys(s)[0]) {
                    let r = e.getHandler(t);
                    r &&
                      (c = {
                        [t]: r.transform(i[t], s[t], n),
                      });
                  }
                }
                l.retain(c, a.default.transform(r.attributes, o.attributes, n));
              }
            }
          return l.chop();
        }
        transformPosition(e, t = !1) {
          t = !!t;
          let n = new s.default(this.ops),
            r = 0;
          for (; n.hasNext() && r <= e;) {
            let i = n.peekLength(),
              a = n.peekType();
            if ((n.next(), a === `delete`)) {
              e -= Math.min(i, e - r);
              continue;
            } else a === `insert` && (r < e || !t) && (e += i);
            r += i;
          }
          return e;
        }
      };
    ((u.Op = o.default),
      (u.OpIterator = s.default),
      (u.AttributeMap = a.default),
      (u.handlers = {}),
      (e.default = u),
      typeof t == `object` && ((t.exports = u), (t.exports.default = u)));
  }),
  Cu = r(Su());
B();
var wu = {
    essential: [
      [
        {
          header: [1, 2, 3, 4, 5, 6, !1],
        },
      ],
      [`bold`, `italic`, `underline`],
      [
        {
          list: `ordered`,
        },
        {
          list: `bullet`,
        },
        {
          align: [],
        },
      ],
      [`blockquote`, `code-block`, `link`],
      [
        {
          color: [],
        },
        `clean`,
      ],
    ],
    minimal: [
      [
        {
          header: 1,
        },
        {
          header: 2,
        },
      ],
      [`bold`, `italic`, `underline`],
      [
        {
          list: `ordered`,
        },
        {
          list: `bullet`,
        },
        {
          align: [],
        },
      ],
    ],
    full: [
      [`bold`, `italic`, `underline`, `strike`],
      [`blockquote`, `code-block`],
      [
        {
          header: 1,
        },
        {
          header: 2,
        },
      ],
      [
        {
          list: `ordered`,
        },
        {
          list: `bullet`,
        },
      ],
      [
        {
          script: `sub`,
        },
        {
          script: `super`,
        },
      ],
      [
        {
          indent: `-1`,
        },
        {
          indent: `+1`,
        },
      ],
      [
        {
          direction: `rtl`,
        },
      ],
      [
        {
          size: [`small`, !1, `large`, `huge`],
        },
      ],
      [
        {
          header: [1, 2, 3, 4, 5, 6, !1],
        },
      ],
      [
        {
          color: [],
        },
        {
          background: [],
        },
      ],
      [
        {
          font: [],
        },
      ],
      [
        {
          align: [],
        },
      ],
      [`link`, `video`, `image`],
      [`clean`],
    ],
  },
  Tu,
  Eu,
  Du = [],
  Ou = () => typeof document < `u`,
  ku = (e) => {
    let t = Du;
    Du = [];
    for (let n of t) e.register(...n);
  },
  Au = async () => {
    if (Tu) return Tu;
    if (!Ou()) throw Error(`@vueup/vue-quill: Quill can only be loaded in a browser environment.`);
    return (
      (Eu ??= b(
        async () => {
          let { default: e } = await import(`../recovered/app/assets/quill-Dw7DRXoa.js`);
          return {
            default: e,
          };
        },
        __vite__mapDeps([0, 1]),
      ).then(({ default: e }) => ((Tu = e), ku(e), e))),
      Eu
    );
  },
  ju = () => {
    if (Tu) return Tu;
    throw Error(
      `@vueup/vue-quill: Quill is not loaded yet. Use loadQuill() in a browser-only lifecycle hook, or access the Quill instance from the ready event.`,
    );
  };
new Proxy(function () {}, {
  get(e, t) {
    if (t === `register`)
      return (...e) => {
        if (Tu) return Tu.register(...e);
        (Du.push(e), Ou() && Au());
      };
    let n = ju(),
      r = n[t];
    return typeof r == `function` ? r.bind(n) : r;
  },
  construct(e, t) {
    return new (ju())(...t);
  },
});
var Mu = new Set([`attributors`, `blots`, `formats`, `modules`, `themes`, `ui`]),
  Nu = (e) => {
    let [t] = e.split(`/`);
    return Mu.has(t);
  },
  Pu = (e) => (Nu(e) ? e : `modules/${e}`),
  Fu = (e) => {
    let t = Pu(e);
    return t.startsWith(`modules/`) ? t.slice(8) : void 0;
  },
  Iu = new Set([`attributors`, `blots`, `formats`]),
  Lu = (e) => {
    let [t] = e.split(`/`);
    return Iu.has(t);
  },
  Ru = (e) => {
    let t = {},
      n = Array.isArray(e) ? e : [e];
    for (let e of n) {
      let n = Fu(e.name);
      n && (t[n] = e.options ?? {});
    }
    return Object.keys(t).length > 0 ? t : void 0;
  },
  zu = (e, t, n) => {
    let r = Pu(t.name),
      i = e.imports;
    ((!i || !(r in i)) && e.register(r, t.module), n && Lu(r) && n.register(t.module));
  },
  Bu = k({
    name: `QuillEditor`,
    inheritAttrs: !1,
    props: {
      content: {
        type: [String, Object],
      },
      contentType: {
        type: String,
        default: `delta`,
        validator: (e) => [`delta`, `html`, `text`].includes(e),
      },
      enable: {
        type: Boolean,
        default: !0,
      },
      readOnly: {
        type: Boolean,
        default: !1,
      },
      placeholder: {
        type: String,
        required: !1,
      },
      theme: {
        type: String,
        default: `snow`,
        validator: (e) => [`snow`, `bubble`, ``].includes(e),
      },
      toolbar: {
        type: [String, Array, Object, Boolean],
        required: !1,
        default: void 0,
        validator: (e) =>
          typeof e == `boolean`
            ? e === !1
            : typeof e == `string` && e !== ``
              ? e.charAt(0) === `#`
                ? !0
                : Object.keys(wu).indexOf(e) !== -1
              : !0,
      },
      modules: {
        type: Object,
        required: !1,
      },
      options: {
        type: Object,
        required: !1,
      },
      globalOptions: {
        type: Object,
        required: !1,
      },
    },
    emits: [
      `textChange`,
      `selectionChange`,
      `editorChange`,
      `update:content`,
      `focus`,
      `blur`,
      `ready`,
    ],
    setup: (e, t) => {
      (Qe(() => {
        ((n = !1), o());
      }),
        oe(() => {
          ((r = null), (n = !0));
        }));
      let n = !1,
        r,
        i,
        a = F(),
        o = async () => {
          var o;
          if (!a.value) return;
          let c = a.value,
            u = await Au();
          if (!(n || !a.value || a.value !== c)) {
            if (((i = s()), e.modules))
              if (Array.isArray(e.modules)) for (let t of e.modules) zu(u, t, i.registry);
              else zu(u, e.modules, i.registry);
            ((r = new u(a.value, i)),
              S(e.content),
              r.on(`text-change`, p),
              r.on(`selection-change`, h),
              r.on(`editor-change`, g),
              e.theme !== `bubble` && a.value.classList.remove(`ql-bubble`),
              e.theme !== `snow` && a.value.classList.remove(`ql-snow`),
              (o = l()?.container) == null ||
                o.addEventListener(`mousedown`, (e) => {
                  e.preventDefault();
                }),
              t.emit(`ready`, r));
          }
        },
        s = () => {
          let t = {};
          if (
            (e.theme !== `` && (t.theme = e.theme),
            e.readOnly && (t.readOnly = e.readOnly),
            e.placeholder && (t.placeholder = e.placeholder),
            e.toolbar === !1
              ? (t.modules = {
                  toolbar: !1,
                })
              : e.toolbar &&
                e.toolbar !== `` &&
                (t.modules = {
                  toolbar: (() => {
                    if (typeof e.toolbar == `object`) return e.toolbar;
                    if (typeof e.toolbar == `string`)
                      return e.toolbar.charAt(0) === `#` ? e.toolbar : wu[e.toolbar];
                  })(),
                }),
            e.modules)
          ) {
            let n = Ru(e.modules);
            n && (t.modules = Object.assign({}, t.modules, n));
          }
          return Object.assign({}, e.globalOptions, e.options, t);
        },
        c = (e) => (typeof e == `object` && e ? e.slice() : e),
        l = () => r?.getModule(`toolbar`),
        u = (e) => Object.values(e.ops).some((e) => !e.retain || Object.keys(e).length !== 1),
        d,
        f = (e) => {
          if (typeof d == typeof e) {
            if (e === d) return !0;
            if (typeof e == `object` && e && typeof d == `object` && d) return !u(d.diff(e));
          }
          return !1;
        },
        p = (n, r, i) => {
          ((d = c(x())),
            f(e.content) || t.emit(`update:content`, d),
            t.emit(`textChange`, {
              delta: n,
              oldContents: r,
              source: i,
            }));
        },
        m = F(),
        h = (e, n, i) => {
          ((m.value = !!r?.hasFocus()),
            t.emit(`selectionChange`, {
              range: e,
              oldRange: n,
              source: i,
            }));
        };
      He(m, (e) => {
        e ? t.emit(`focus`, a) : t.emit(`blur`, a);
      });
      let g = (...e) => {
          (e[0] === `text-change` &&
            t.emit(`editorChange`, {
              name: e[0],
              delta: e[1],
              oldContents: e[2],
              source: e[3],
            }),
            e[0] === `selection-change` &&
              t.emit(`editorChange`, {
                name: e[0],
                range: e[1],
                oldRange: e[2],
                source: e[3],
              }));
        },
        v = () => a.value,
        y = () => l()?.container,
        b = () => {
          if (r) return r;
          throw `The quill editor hasn't been instantiated yet,
                  make sure to call this method when the editor ready
                  or use v-on:ready="onReady(quill)" event instead.`;
        },
        x = (t, n) =>
          e.contentType === `html`
            ? T()
            : e.contentType === `text`
              ? C(t, n)
              : r?.getContents(t, n),
        S = (t, n = `api`) => {
          let i = t || (e.contentType === `delta` ? new Cu.default() : ``);
          (e.contentType === `html`
            ? E(i)
            : e.contentType === `text`
              ? w(i, n)
              : r?.setContents(i, n),
            (d = c(i)));
        },
        C = (e, t) => r?.getText(e, t) ?? ``,
        w = (e, t = `api`) => {
          r?.setText(e, t);
        },
        T = () => r?.root.innerHTML ?? ``,
        E = (e) => {
          r && (r.root.innerHTML = e);
        };
      return (
        He(
          () => e.content,
          (e) => {
            if (!r || !e || f(e)) return;
            let t = r.getSelection();
            (t && de(() => r?.setSelection(t)), S(e));
          },
          {
            deep: !0,
          },
        ),
        He(
          () => e.enable,
          (e) => {
            r && r.enable(e);
          },
        ),
        {
          editor: a,
          getEditor: v,
          getToolbar: y,
          getQuill: b,
          getContents: x,
          setContents: S,
          getHTML: T,
          setHTML: E,
          pasteHTML: (e, t = `api`) => {
            let n = r?.clipboard.convert({
              html: e,
            });
            n && r?.setContents(n, t);
          },
          focus: () => {
            r?.focus();
          },
          getText: C,
          setText: w,
          reinit: () => {
            de(() => {
              var e;
              (!t.slots.toolbar && r && ((e = l()?.container) == null || e.remove()), o());
            });
          },
        }
      );
    },
    render() {
      var e;
      return [
        (e = this.$slots).toolbar?.call(e),
        Ne(`div`, {
          ref: `editor`,
          ...this.$attrs,
        }),
      ];
    },
  }),
  Vu = r(
    a((e, t) => {
      (function (n, r) {
        typeof e == `object` && typeof t == `object`
          ? (t.exports = r())
          : typeof define == `function` && define.amd
            ? define([], r)
            : typeof e == `object`
              ? (e.Quill = r())
              : (n.Quill = r());
      })(typeof self < `u` ? self : e, function () {
        return (function (e) {
          var t = {};
          function n(r) {
            if (t[r]) return t[r].exports;
            var i = (t[r] = {
              i: r,
              l: !1,
              exports: {},
            });
            return (e[r].call(i.exports, i, i.exports, n), (i.l = !0), i.exports);
          }
          return (
            (n.m = e),
            (n.c = t),
            (n.d = function (e, t, r) {
              n.o(e, t) ||
                Object.defineProperty(e, t, {
                  configurable: !1,
                  enumerable: !0,
                  get: r,
                });
            }),
            (n.n = function (e) {
              var t =
                e && e.__esModule
                  ? function () {
                      return e.default;
                    }
                  : function () {
                      return e;
                    };
              return (n.d(t, `a`, t), t);
            }),
            (n.o = function (e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }),
            (n.p = ``),
            n((n.s = 109))
          );
        })([
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = n(17),
              i = n(18),
              a = n(19),
              o = n(45),
              s = n(46),
              c = n(47),
              l = n(48),
              u = n(49),
              d = n(12),
              f = n(32),
              p = n(33),
              m = n(31),
              h = n(1);
            t.default = {
              Scope: h.Scope,
              create: h.create,
              find: h.find,
              query: h.query,
              register: h.register,
              Container: r.default,
              Format: i.default,
              Leaf: a.default,
              Embed: l.default,
              Scroll: o.default,
              Block: c.default,
              Inline: s.default,
              Text: u.default,
              Attributor: {
                Attribute: d.default,
                Class: f.default,
                Style: p.default,
                Store: m.default,
              },
            };
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = (function (e) {
              r(t, e);
              function t(t) {
                var n = this;
                return (
                  (t = `[Parchment] ` + t),
                  (n = e.call(this, t) || this),
                  (n.message = t),
                  (n.name = n.constructor.name),
                  n
                );
              }
              return t;
            })(Error);
            t.ParchmentError = i;
            var a = {},
              o = {},
              s = {},
              c = {};
            t.DATA_KEY = `__blot`;
            var l;
            (function (e) {
              ((e[(e.TYPE = 3)] = `TYPE`),
                (e[(e.LEVEL = 12)] = `LEVEL`),
                (e[(e.ATTRIBUTE = 13)] = `ATTRIBUTE`),
                (e[(e.BLOT = 14)] = `BLOT`),
                (e[(e.INLINE = 7)] = `INLINE`),
                (e[(e.BLOCK = 11)] = `BLOCK`),
                (e[(e.BLOCK_BLOT = 10)] = `BLOCK_BLOT`),
                (e[(e.INLINE_BLOT = 6)] = `INLINE_BLOT`),
                (e[(e.BLOCK_ATTRIBUTE = 9)] = `BLOCK_ATTRIBUTE`),
                (e[(e.INLINE_ATTRIBUTE = 5)] = `INLINE_ATTRIBUTE`),
                (e[(e.ANY = 15)] = `ANY`));
            })((l = t.Scope ||= {}));
            function u(e, t) {
              var n = f(e);
              if (n == null) throw new i(`Unable to create ` + e + ` blot`);
              var r = n;
              return new r(e instanceof Node || e.nodeType === Node.TEXT_NODE ? e : r.create(t), t);
            }
            t.create = u;
            function d(e, n) {
              return (
                n === void 0 && (n = !1),
                e == null
                  ? null
                  : e[t.DATA_KEY] == null
                    ? n
                      ? d(e.parentNode, n)
                      : null
                    : e[t.DATA_KEY].blot
              );
            }
            t.find = d;
            function f(e, t) {
              t === void 0 && (t = l.ANY);
              var n;
              if (typeof e == `string`) n = c[e] || a[e];
              else if (e instanceof Text || e.nodeType === Node.TEXT_NODE) n = c.text;
              else if (typeof e == `number`)
                e & l.LEVEL & l.BLOCK ? (n = c.block) : e & l.LEVEL & l.INLINE && (n = c.inline);
              else if (e instanceof HTMLElement) {
                var r = (e.getAttribute(`class`) || ``).split(/\s+/);
                for (var i in r) if (((n = o[r[i]]), n)) break;
                n ||= s[e.tagName];
              }
              return n == null ? null : t & l.LEVEL & n.scope && t & l.TYPE & n.scope ? n : null;
            }
            t.query = f;
            function p() {
              var e = [...arguments];
              if (e.length > 1)
                return e.map(function (e) {
                  return p(e);
                });
              var t = e[0];
              if (typeof t.blotName != `string` && typeof t.attrName != `string`)
                throw new i(`Invalid definition`);
              if (t.blotName === `abstract`) throw new i(`Cannot register abstract class`);
              return (
                (c[t.blotName || t.attrName] = t),
                typeof t.keyName == `string`
                  ? (a[t.keyName] = t)
                  : (t.className != null && (o[t.className] = t),
                    t.tagName != null &&
                      (Array.isArray(t.tagName)
                        ? (t.tagName = t.tagName.map(function (e) {
                            return e.toUpperCase();
                          }))
                        : (t.tagName = t.tagName.toUpperCase()),
                      (Array.isArray(t.tagName) ? t.tagName : [t.tagName]).forEach(function (e) {
                        (s[e] == null || t.className == null) && (s[e] = t);
                      }))),
                t
              );
            }
            t.register = p;
          },
          function (e, t, n) {
            var r = n(51),
              i = n(11),
              a = n(3),
              o = n(20),
              s = `\0`,
              c = function (e) {
                Array.isArray(e)
                  ? (this.ops = e)
                  : e != null && Array.isArray(e.ops)
                    ? (this.ops = e.ops)
                    : (this.ops = []);
              };
            ((c.prototype.insert = function (e, t) {
              var n = {};
              return e.length === 0
                ? this
                : ((n.insert = e),
                  typeof t == `object` && t && Object.keys(t).length > 0 && (n.attributes = t),
                  this.push(n));
            }),
              (c.prototype.delete = function (e) {
                return e <= 0
                  ? this
                  : this.push({
                      delete: e,
                    });
              }),
              (c.prototype.retain = function (e, t) {
                if (e <= 0) return this;
                var n = {
                  retain: e,
                };
                return (
                  typeof t == `object` && t && Object.keys(t).length > 0 && (n.attributes = t),
                  this.push(n)
                );
              }),
              (c.prototype.push = function (e) {
                var t = this.ops.length,
                  n = this.ops[t - 1];
                if (((e = a(!0, {}, e)), typeof n == `object`)) {
                  if (typeof e.delete == `number` && typeof n.delete == `number`)
                    return (
                      (this.ops[t - 1] = {
                        delete: n.delete + e.delete,
                      }),
                      this
                    );
                  if (
                    typeof n.delete == `number` &&
                    e.insert != null &&
                    (--t, (n = this.ops[t - 1]), typeof n != `object`)
                  )
                    return (this.ops.unshift(e), this);
                  if (i(e.attributes, n.attributes)) {
                    if (typeof e.insert == `string` && typeof n.insert == `string`)
                      return (
                        (this.ops[t - 1] = {
                          insert: n.insert + e.insert,
                        }),
                        typeof e.attributes == `object` &&
                          (this.ops[t - 1].attributes = e.attributes),
                        this
                      );
                    if (typeof e.retain == `number` && typeof n.retain == `number`)
                      return (
                        (this.ops[t - 1] = {
                          retain: n.retain + e.retain,
                        }),
                        typeof e.attributes == `object` &&
                          (this.ops[t - 1].attributes = e.attributes),
                        this
                      );
                  }
                }
                return (t === this.ops.length ? this.ops.push(e) : this.ops.splice(t, 0, e), this);
              }),
              (c.prototype.chop = function () {
                var e = this.ops[this.ops.length - 1];
                return (e && e.retain && !e.attributes && this.ops.pop(), this);
              }),
              (c.prototype.filter = function (e) {
                return this.ops.filter(e);
              }),
              (c.prototype.forEach = function (e) {
                this.ops.forEach(e);
              }),
              (c.prototype.map = function (e) {
                return this.ops.map(e);
              }),
              (c.prototype.partition = function (e) {
                var t = [],
                  n = [];
                return (
                  this.forEach(function (r) {
                    (e(r) ? t : n).push(r);
                  }),
                  [t, n]
                );
              }),
              (c.prototype.reduce = function (e, t) {
                return this.ops.reduce(e, t);
              }),
              (c.prototype.changeLength = function () {
                return this.reduce(function (e, t) {
                  return t.insert ? e + o.length(t) : t.delete ? e - t.delete : e;
                }, 0);
              }),
              (c.prototype.length = function () {
                return this.reduce(function (e, t) {
                  return e + o.length(t);
                }, 0);
              }),
              (c.prototype.slice = function (e, t) {
                ((e ||= 0), typeof t != `number` && (t = 1 / 0));
                for (var n = [], r = o.iterator(this.ops), i = 0; i < t && r.hasNext();) {
                  var a;
                  (i < e ? (a = r.next(e - i)) : ((a = r.next(t - i)), n.push(a)),
                    (i += o.length(a)));
                }
                return new c(n);
              }),
              (c.prototype.compose = function (e) {
                var t = o.iterator(this.ops),
                  n = o.iterator(e.ops),
                  r = [],
                  a = n.peek();
                if (a != null && typeof a.retain == `number` && a.attributes == null) {
                  for (var s = a.retain; t.peekType() === `insert` && t.peekLength() <= s;)
                    ((s -= t.peekLength()), r.push(t.next()));
                  a.retain - s > 0 && n.next(a.retain - s);
                }
                for (var l = new c(r); t.hasNext() || n.hasNext();)
                  if (n.peekType() === `insert`) l.push(n.next());
                  else if (t.peekType() === `delete`) l.push(t.next());
                  else {
                    var u = Math.min(t.peekLength(), n.peekLength()),
                      d = t.next(u),
                      f = n.next(u);
                    if (typeof f.retain == `number`) {
                      var p = {};
                      typeof d.retain == `number` ? (p.retain = u) : (p.insert = d.insert);
                      var m = o.attributes.compose(
                        d.attributes,
                        f.attributes,
                        typeof d.retain == `number`,
                      );
                      if (
                        (m && (p.attributes = m),
                        l.push(p),
                        !n.hasNext() && i(l.ops[l.ops.length - 1], p))
                      ) {
                        var h = new c(t.rest());
                        return l.concat(h).chop();
                      }
                    } else typeof f.delete == `number` && typeof d.retain == `number` && l.push(f);
                  }
                return l.chop();
              }),
              (c.prototype.concat = function (e) {
                var t = new c(this.ops.slice());
                return (
                  e.ops.length > 0 && (t.push(e.ops[0]), (t.ops = t.ops.concat(e.ops.slice(1)))),
                  t
                );
              }),
              (c.prototype.diff = function (e, t) {
                if (this.ops === e.ops) return new c();
                var n = [this, e].map(function (t) {
                    return t
                      .map(function (n) {
                        if (n.insert != null) return typeof n.insert == `string` ? n.insert : s;
                        throw Error(`diff() called ` + (t === e ? `on` : `with`) + ` non-document`);
                      })
                      .join(``);
                  }),
                  a = new c(),
                  l = r(n[0], n[1], t),
                  u = o.iterator(this.ops),
                  d = o.iterator(e.ops);
                return (
                  l.forEach(function (e) {
                    for (var t = e[1].length; t > 0;) {
                      var n = 0;
                      switch (e[0]) {
                        case r.INSERT:
                          ((n = Math.min(d.peekLength(), t)), a.push(d.next(n)));
                          break;
                        case r.DELETE:
                          ((n = Math.min(t, u.peekLength())), u.next(n), a.delete(n));
                          break;
                        case r.EQUAL:
                          n = Math.min(u.peekLength(), d.peekLength(), t);
                          var s = u.next(n),
                            c = d.next(n);
                          i(s.insert, c.insert)
                            ? a.retain(n, o.attributes.diff(s.attributes, c.attributes))
                            : a.push(c).delete(n);
                          break;
                      }
                      t -= n;
                    }
                  }),
                  a.chop()
                );
              }),
              (c.prototype.eachLine = function (e, t) {
                t ||= `
`;
                for (var n = o.iterator(this.ops), r = new c(), i = 0; n.hasNext();) {
                  if (n.peekType() !== `insert`) return;
                  var a = n.peek(),
                    s = o.length(a) - n.peekLength(),
                    l = typeof a.insert == `string` ? a.insert.indexOf(t, s) - s : -1;
                  if (l < 0) r.push(n.next());
                  else if (l > 0) r.push(n.next(l));
                  else {
                    if (e(r, n.next(1).attributes || {}, i) === !1) return;
                    ((i += 1), (r = new c()));
                  }
                }
                r.length() > 0 && e(r, {}, i);
              }),
              (c.prototype.transform = function (e, t) {
                if (((t = !!t), typeof e == `number`)) return this.transformPosition(e, t);
                for (
                  var n = o.iterator(this.ops), r = o.iterator(e.ops), i = new c();
                  n.hasNext() || r.hasNext();
                )
                  if (n.peekType() === `insert` && (t || r.peekType() !== `insert`))
                    i.retain(o.length(n.next()));
                  else if (r.peekType() === `insert`) i.push(r.next());
                  else {
                    var a = Math.min(n.peekLength(), r.peekLength()),
                      s = n.next(a),
                      l = r.next(a);
                    if (s.delete) continue;
                    l.delete
                      ? i.push(l)
                      : i.retain(a, o.attributes.transform(s.attributes, l.attributes, t));
                  }
                return i.chop();
              }),
              (c.prototype.transformPosition = function (e, t) {
                t = !!t;
                for (var n = o.iterator(this.ops), r = 0; n.hasNext() && r <= e;) {
                  var i = n.peekLength(),
                    a = n.peekType();
                  if ((n.next(), a === `delete`)) {
                    e -= Math.min(i, e - r);
                    continue;
                  } else a === `insert` && (r < e || !t) && (e += i);
                  r += i;
                }
                return e;
              }),
              (e.exports = c));
          },
          function (e, t) {
            var n = Object.prototype.hasOwnProperty,
              r = Object.prototype.toString,
              i = Object.defineProperty,
              a = Object.getOwnPropertyDescriptor,
              o = function (e) {
                return typeof Array.isArray == `function`
                  ? Array.isArray(e)
                  : r.call(e) === `[object Array]`;
              },
              s = function (e) {
                if (!e || r.call(e) !== `[object Object]`) return !1;
                var t = n.call(e, `constructor`),
                  i =
                    e.constructor &&
                    e.constructor.prototype &&
                    n.call(e.constructor.prototype, `isPrototypeOf`);
                if (e.constructor && !t && !i) return !1;
                for (var a in e);
                return a === void 0 || n.call(e, a);
              },
              c = function (e, t) {
                i && t.name === `__proto__`
                  ? i(e, t.name, {
                      enumerable: !0,
                      configurable: !0,
                      value: t.newValue,
                      writable: !0,
                    })
                  : (e[t.name] = t.newValue);
              },
              l = function (e, t) {
                if (t === `__proto__`) {
                  if (!n.call(e, t)) return;
                  if (a) return a(e, t).value;
                }
                return e[t];
              };
            e.exports = function e() {
              var t,
                n,
                r,
                i,
                a,
                u,
                d = arguments[0],
                f = 1,
                p = arguments.length,
                m = !1;
              for (
                typeof d == `boolean` && ((m = d), (d = arguments[1] || {}), (f = 2)),
                  (d == null || (typeof d != `object` && typeof d != `function`)) && (d = {});
                f < p;
                ++f
              )
                if (((t = arguments[f]), t != null))
                  for (n in t)
                    ((r = l(d, n)),
                      (i = l(t, n)),
                      d !== i &&
                        (m && i && (s(i) || (a = o(i)))
                          ? (a ? ((a = !1), (u = r && o(r) ? r : [])) : (u = r && s(r) ? r : {}),
                            c(d, {
                              name: n,
                              newValue: e(m, u, i),
                            }))
                          : i !== void 0 &&
                            c(d, {
                              name: n,
                              newValue: i,
                            })));
              return d;
            };
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.BlockEmbed = t.bubbleFormats = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = d(n(3)),
              o = d(n(2)),
              s = d(n(0)),
              c = d(n(16)),
              l = d(n(6)),
              u = d(n(7));
            function d(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function f(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function p(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function m(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var h = 1,
              g = (function (e) {
                m(t, e);
                function t() {
                  return (
                    f(this, t),
                    p(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                  );
                }
                return (
                  r(t, [
                    {
                      key: `attach`,
                      value: function () {
                        (i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `attach`,
                          this,
                        ).call(this),
                          (this.attributes = new s.default.Attributor.Store(this.domNode)));
                      },
                    },
                    {
                      key: `delta`,
                      value: function () {
                        return new o.default().insert(
                          this.value(),
                          (0, a.default)(this.formats(), this.attributes.values()),
                        );
                      },
                    },
                    {
                      key: `format`,
                      value: function (e, t) {
                        var n = s.default.query(e, s.default.Scope.BLOCK_ATTRIBUTE);
                        n != null && this.attributes.attribute(n, t);
                      },
                    },
                    {
                      key: `formatAt`,
                      value: function (e, t, n, r) {
                        this.format(n, r);
                      },
                    },
                    {
                      key: `insertAt`,
                      value: function (e, n, r) {
                        if (
                          typeof n == `string` &&
                          n.endsWith(`
`)
                        ) {
                          var a = s.default.create(v.blotName);
                          (this.parent.insertBefore(a, e === 0 ? this : this.next),
                            a.insertAt(0, n.slice(0, -1)));
                        } else
                          i(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `insertAt`,
                            this,
                          ).call(this, e, n, r);
                      },
                    },
                  ]),
                  t
                );
              })(s.default.Embed);
            g.scope = s.default.Scope.BLOCK_BLOT;
            var v = (function (e) {
              m(t, e);
              function t(e) {
                f(this, t);
                var n = p(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return ((n.cache = {}), n);
              }
              return (
                r(t, [
                  {
                    key: `delta`,
                    value: function () {
                      return (
                        this.cache.delta ??
                          (this.cache.delta = this.descendants(s.default.Leaf)
                            .reduce(function (e, t) {
                              return t.length() === 0 ? e : e.insert(t.value(), y(t));
                            }, new o.default())
                            .insert(
                              `
`,
                              y(this),
                            )),
                        this.cache.delta
                      );
                    },
                  },
                  {
                    key: `deleteAt`,
                    value: function (e, n) {
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `deleteAt`,
                        this,
                      ).call(this, e, n),
                        (this.cache = {}));
                    },
                  },
                  {
                    key: `formatAt`,
                    value: function (e, n, r, a) {
                      n <= 0 ||
                        (s.default.query(r, s.default.Scope.BLOCK)
                          ? e + n === this.length() && this.format(r, a)
                          : i(
                              t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                              `formatAt`,
                              this,
                            ).call(this, e, Math.min(n, this.length() - e - 1), r, a),
                        (this.cache = {}));
                    },
                  },
                  {
                    key: `insertAt`,
                    value: function (e, n, r) {
                      if (r != null)
                        return i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `insertAt`,
                          this,
                        ).call(this, e, n, r);
                      if (n.length !== 0) {
                        var a = n.split(`
`),
                          o = a.shift();
                        o.length > 0 &&
                          (e < this.length() - 1 || this.children.tail == null
                            ? i(
                                t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                                `insertAt`,
                                this,
                              ).call(this, Math.min(e, this.length() - 1), o)
                            : this.children.tail.insertAt(this.children.tail.length(), o),
                          (this.cache = {}));
                        var s = this;
                        a.reduce(function (e, t) {
                          return ((s = s.split(e, !0)), s.insertAt(0, t), t.length);
                        }, e + o.length);
                      }
                    },
                  },
                  {
                    key: `insertBefore`,
                    value: function (e, n) {
                      var r = this.children.head;
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `insertBefore`,
                        this,
                      ).call(this, e, n),
                        r instanceof c.default && r.remove(),
                        (this.cache = {}));
                    },
                  },
                  {
                    key: `length`,
                    value: function () {
                      return (
                        this.cache.length ??
                          (this.cache.length =
                            i(
                              t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                              `length`,
                              this,
                            ).call(this) + h),
                        this.cache.length
                      );
                    },
                  },
                  {
                    key: `moveChildren`,
                    value: function (e, n) {
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `moveChildren`,
                        this,
                      ).call(this, e, n),
                        (this.cache = {}));
                    },
                  },
                  {
                    key: `optimize`,
                    value: function (e) {
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `optimize`,
                        this,
                      ).call(this, e),
                        (this.cache = {}));
                    },
                  },
                  {
                    key: `path`,
                    value: function (e) {
                      return i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `path`,
                        this,
                      ).call(this, e, !0);
                    },
                  },
                  {
                    key: `removeChild`,
                    value: function (e) {
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `removeChild`,
                        this,
                      ).call(this, e),
                        (this.cache = {}));
                    },
                  },
                  {
                    key: `split`,
                    value: function (e) {
                      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                      if (n && (e === 0 || e >= this.length() - h)) {
                        var r = this.clone();
                        return e === 0
                          ? (this.parent.insertBefore(r, this), this)
                          : (this.parent.insertBefore(r, this.next), r);
                      } else {
                        var a = i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `split`,
                          this,
                        ).call(this, e, n);
                        return ((this.cache = {}), a);
                      }
                    },
                  },
                ]),
                t
              );
            })(s.default.Block);
            ((v.blotName = `block`),
              (v.tagName = `P`),
              (v.defaultChild = `break`),
              (v.allowedChildren = [l.default, s.default.Embed, u.default]));
            function y(e) {
              var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              return e == null ||
                (typeof e.formats == `function` && (t = (0, a.default)(t, e.formats())),
                e.parent == null ||
                  e.parent.blotName == `scroll` ||
                  e.parent.statics.scope !== e.statics.scope)
                ? t
                : y(e.parent, t);
            }
            ((t.bubbleFormats = y), (t.BlockEmbed = g), (t.default = v));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.overload = t.expandConfig = void 0));
            var r =
                typeof Symbol == `function` && typeof Symbol.iterator == `symbol`
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        typeof Symbol == `function` &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? `symbol`
                        : typeof e;
                    },
              i = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              a = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })();
            n(50);
            var o = g(n(2)),
              s = g(n(14)),
              c = g(n(8)),
              l = g(n(9)),
              u = g(n(0)),
              d = n(15),
              f = g(d),
              p = g(n(3)),
              m = g(n(10)),
              h = g(n(34));
            function g(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function v(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function y(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            var b = (0, m.default)(`quill`),
              x = (function () {
                a(e, null, [
                  {
                    key: `debug`,
                    value: function (e) {
                      (e === !0 && (e = `log`), m.default.level(e));
                    },
                  },
                  {
                    key: `find`,
                    value: function (e) {
                      return e.__quill || u.default.find(e);
                    },
                  },
                  {
                    key: `import`,
                    value: function (e) {
                      return (
                        this.imports[e] ??
                          b.error(`Cannot import ` + e + `. Are you sure it was registered?`),
                        this.imports[e]
                      );
                    },
                  },
                  {
                    key: `register`,
                    value: function (e, t) {
                      var n = this,
                        r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                      if (typeof e != `string`) {
                        var i = e.attrName || e.blotName;
                        typeof i == `string`
                          ? this.register(`formats/` + i, e, t)
                          : Object.keys(e).forEach(function (r) {
                              n.register(r, e[r], t);
                            });
                      } else
                        (this.imports[e] != null && !r && b.warn(`Overwriting ` + e + ` with`, t),
                          (this.imports[e] = t),
                          (e.startsWith(`blots/`) || e.startsWith(`formats/`)) &&
                          t.blotName !== `abstract`
                            ? u.default.register(t)
                            : e.startsWith(`modules`) &&
                              typeof t.register == `function` &&
                              t.register());
                    },
                  },
                ]);
                function e(t) {
                  var n = this,
                    r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                  if (
                    (y(this, e),
                    (this.options = S(t, r)),
                    (this.container = this.options.container),
                    this.container == null)
                  )
                    return b.error(`Invalid Quill container`, t);
                  this.options.debug && e.debug(this.options.debug);
                  var i = this.container.innerHTML.trim();
                  (this.container.classList.add(`ql-container`),
                    (this.container.innerHTML = ``),
                    (this.container.__quill = this),
                    (this.root = this.addContainer(`ql-editor`)),
                    this.root.classList.add(`ql-blank`),
                    this.root.setAttribute(`data-gramm`, !1),
                    (this.scrollingContainer = this.options.scrollingContainer || this.root),
                    (this.emitter = new c.default()),
                    (this.scroll = u.default.create(this.root, {
                      emitter: this.emitter,
                      whitelist: this.options.formats,
                    })),
                    (this.editor = new s.default(this.scroll)),
                    (this.selection = new f.default(this.scroll, this.emitter)),
                    (this.theme = new this.options.theme(this, this.options)),
                    (this.keyboard = this.theme.addModule(`keyboard`)),
                    (this.clipboard = this.theme.addModule(`clipboard`)),
                    (this.history = this.theme.addModule(`history`)),
                    this.theme.init(),
                    this.emitter.on(c.default.events.EDITOR_CHANGE, function (e) {
                      e === c.default.events.TEXT_CHANGE &&
                        n.root.classList.toggle(`ql-blank`, n.editor.isBlank());
                    }),
                    this.emitter.on(c.default.events.SCROLL_UPDATE, function (e, t) {
                      var r = n.selection.lastRange,
                        i = r && r.length === 0 ? r.index : void 0;
                      C.call(
                        n,
                        function () {
                          return n.editor.update(null, t, i);
                        },
                        e,
                      );
                    }));
                  var a = this.clipboard.convert(
                    `<div class='ql-editor' style="white-space: normal;">` +
                      i +
                      `<p><br></p></div>`,
                  );
                  (this.setContents(a),
                    this.history.clear(),
                    this.options.placeholder &&
                      this.root.setAttribute(`data-placeholder`, this.options.placeholder),
                    this.options.readOnly && this.disable());
                }
                return (
                  a(e, [
                    {
                      key: `addContainer`,
                      value: function (e) {
                        var t =
                          arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                        if (typeof e == `string`) {
                          var n = e;
                          ((e = document.createElement(`div`)), e.classList.add(n));
                        }
                        return (this.container.insertBefore(e, t), e);
                      },
                    },
                    {
                      key: `blur`,
                      value: function () {
                        this.selection.setRange(null);
                      },
                    },
                    {
                      key: `deleteText`,
                      value: function (e, t, n) {
                        var r = this,
                          a = i(w(e, t, n), 4);
                        return (
                          (e = a[0]),
                          (t = a[1]),
                          (n = a[3]),
                          C.call(
                            this,
                            function () {
                              return r.editor.deleteText(e, t);
                            },
                            n,
                            e,
                            -1 * t,
                          )
                        );
                      },
                    },
                    {
                      key: `disable`,
                      value: function () {
                        this.enable(!1);
                      },
                    },
                    {
                      key: `enable`,
                      value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                        (this.scroll.enable(e), this.container.classList.toggle(`ql-disabled`, !e));
                      },
                    },
                    {
                      key: `focus`,
                      value: function () {
                        var e = this.scrollingContainer.scrollTop;
                        (this.selection.focus(),
                          (this.scrollingContainer.scrollTop = e),
                          this.scrollIntoView());
                      },
                    },
                    {
                      key: `format`,
                      value: function (e, t) {
                        var n = this,
                          r =
                            arguments.length > 2 && arguments[2] !== void 0
                              ? arguments[2]
                              : c.default.sources.API;
                        return C.call(
                          this,
                          function () {
                            var r = n.getSelection(!0),
                              i = new o.default();
                            if (r == null) return i;
                            if (u.default.query(e, u.default.Scope.BLOCK))
                              i = n.editor.formatLine(r.index, r.length, v({}, e, t));
                            else if (r.length === 0) return (n.selection.format(e, t), i);
                            else i = n.editor.formatText(r.index, r.length, v({}, e, t));
                            return (n.setSelection(r, c.default.sources.SILENT), i);
                          },
                          r,
                        );
                      },
                    },
                    {
                      key: `formatLine`,
                      value: function (e, t, n, r, a) {
                        var o = this,
                          s = void 0,
                          c = i(w(e, t, n, r, a), 4);
                        return (
                          (e = c[0]),
                          (t = c[1]),
                          (s = c[2]),
                          (a = c[3]),
                          C.call(
                            this,
                            function () {
                              return o.editor.formatLine(e, t, s);
                            },
                            a,
                            e,
                            0,
                          )
                        );
                      },
                    },
                    {
                      key: `formatText`,
                      value: function (e, t, n, r, a) {
                        var o = this,
                          s = void 0,
                          c = i(w(e, t, n, r, a), 4);
                        return (
                          (e = c[0]),
                          (t = c[1]),
                          (s = c[2]),
                          (a = c[3]),
                          C.call(
                            this,
                            function () {
                              return o.editor.formatText(e, t, s);
                            },
                            a,
                            e,
                            0,
                          )
                        );
                      },
                    },
                    {
                      key: `getBounds`,
                      value: function (e) {
                        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0,
                          n = void 0;
                        n =
                          typeof e == `number`
                            ? this.selection.getBounds(e, t)
                            : this.selection.getBounds(e.index, e.length);
                        var r = this.container.getBoundingClientRect();
                        return {
                          bottom: n.bottom - r.top,
                          height: n.height,
                          left: n.left - r.left,
                          right: n.right - r.left,
                          top: n.top - r.top,
                          width: n.width,
                        };
                      },
                    },
                    {
                      key: `getContents`,
                      value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0,
                          t =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : this.getLength() - e,
                          n = i(w(e, t), 2);
                        return ((e = n[0]), (t = n[1]), this.editor.getContents(e, t));
                      },
                    },
                    {
                      key: `getFormat`,
                      value: function () {
                        var e =
                            arguments.length > 0 && arguments[0] !== void 0
                              ? arguments[0]
                              : this.getSelection(!0),
                          t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                        return typeof e == `number`
                          ? this.editor.getFormat(e, t)
                          : this.editor.getFormat(e.index, e.length);
                      },
                    },
                    {
                      key: `getIndex`,
                      value: function (e) {
                        return e.offset(this.scroll);
                      },
                    },
                    {
                      key: `getLength`,
                      value: function () {
                        return this.scroll.length();
                      },
                    },
                    {
                      key: `getLeaf`,
                      value: function (e) {
                        return this.scroll.leaf(e);
                      },
                    },
                    {
                      key: `getLine`,
                      value: function (e) {
                        return this.scroll.line(e);
                      },
                    },
                    {
                      key: `getLines`,
                      value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0,
                          t =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : Number.MAX_VALUE;
                        return typeof e == `number`
                          ? this.scroll.lines(e, t)
                          : this.scroll.lines(e.index, e.length);
                      },
                    },
                    {
                      key: `getModule`,
                      value: function (e) {
                        return this.theme.modules[e];
                      },
                    },
                    {
                      key: `getSelection`,
                      value: function () {
                        return (
                          arguments.length > 0 &&
                            arguments[0] !== void 0 &&
                            arguments[0] &&
                            this.focus(),
                          this.update(),
                          this.selection.getRange()[0]
                        );
                      },
                    },
                    {
                      key: `getText`,
                      value: function () {
                        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0,
                          t =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : this.getLength() - e,
                          n = i(w(e, t), 2);
                        return ((e = n[0]), (t = n[1]), this.editor.getText(e, t));
                      },
                    },
                    {
                      key: `hasFocus`,
                      value: function () {
                        return this.selection.hasFocus();
                      },
                    },
                    {
                      key: `insertEmbed`,
                      value: function (t, n, r) {
                        var i = this,
                          a =
                            arguments.length > 3 && arguments[3] !== void 0
                              ? arguments[3]
                              : e.sources.API;
                        return C.call(
                          this,
                          function () {
                            return i.editor.insertEmbed(t, n, r);
                          },
                          a,
                          t,
                        );
                      },
                    },
                    {
                      key: `insertText`,
                      value: function (e, t, n, r, a) {
                        var o = this,
                          s = void 0,
                          c = i(w(e, 0, n, r, a), 4);
                        return (
                          (e = c[0]),
                          (s = c[2]),
                          (a = c[3]),
                          C.call(
                            this,
                            function () {
                              return o.editor.insertText(e, t, s);
                            },
                            a,
                            e,
                            t.length,
                          )
                        );
                      },
                    },
                    {
                      key: `isEnabled`,
                      value: function () {
                        return !this.container.classList.contains(`ql-disabled`);
                      },
                    },
                    {
                      key: `off`,
                      value: function () {
                        return this.emitter.off.apply(this.emitter, arguments);
                      },
                    },
                    {
                      key: `on`,
                      value: function () {
                        return this.emitter.on.apply(this.emitter, arguments);
                      },
                    },
                    {
                      key: `once`,
                      value: function () {
                        return this.emitter.once.apply(this.emitter, arguments);
                      },
                    },
                    {
                      key: `pasteHTML`,
                      value: function (e, t, n) {
                        this.clipboard.dangerouslyPasteHTML(e, t, n);
                      },
                    },
                    {
                      key: `removeFormat`,
                      value: function (e, t, n) {
                        var r = this,
                          a = i(w(e, t, n), 4);
                        return (
                          (e = a[0]),
                          (t = a[1]),
                          (n = a[3]),
                          C.call(
                            this,
                            function () {
                              return r.editor.removeFormat(e, t);
                            },
                            n,
                            e,
                          )
                        );
                      },
                    },
                    {
                      key: `scrollIntoView`,
                      value: function () {
                        this.selection.scrollIntoView(this.scrollingContainer);
                      },
                    },
                    {
                      key: `setContents`,
                      value: function (e) {
                        var t = this,
                          n =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : c.default.sources.API;
                        return C.call(
                          this,
                          function () {
                            e = new o.default(e);
                            var n = t.getLength(),
                              r = t.editor.deleteText(0, n),
                              i = t.editor.applyDelta(e),
                              a = i.ops[i.ops.length - 1];
                            return (
                              a != null &&
                                typeof a.insert == `string` &&
                                a.insert[a.insert.length - 1] ===
                                  `
` &&
                                (t.editor.deleteText(t.getLength() - 1, 1), i.delete(1)),
                              r.compose(i)
                            );
                          },
                          n,
                        );
                      },
                    },
                    {
                      key: `setSelection`,
                      value: function (t, n, r) {
                        if (t == null) this.selection.setRange(null, n || e.sources.API);
                        else {
                          var a = i(w(t, n, r), 4);
                          ((t = a[0]),
                            (n = a[1]),
                            (r = a[3]),
                            this.selection.setRange(new d.Range(t, n), r),
                            r !== c.default.sources.SILENT &&
                              this.selection.scrollIntoView(this.scrollingContainer));
                        }
                      },
                    },
                    {
                      key: `setText`,
                      value: function (e) {
                        var t =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : c.default.sources.API,
                          n = new o.default().insert(e);
                        return this.setContents(n, t);
                      },
                    },
                    {
                      key: `update`,
                      value: function () {
                        var e =
                            arguments.length > 0 && arguments[0] !== void 0
                              ? arguments[0]
                              : c.default.sources.USER,
                          t = this.scroll.update(e);
                        return (this.selection.update(e), t);
                      },
                    },
                    {
                      key: `updateContents`,
                      value: function (e) {
                        var t = this,
                          n =
                            arguments.length > 1 && arguments[1] !== void 0
                              ? arguments[1]
                              : c.default.sources.API;
                        return C.call(
                          this,
                          function () {
                            return ((e = new o.default(e)), t.editor.applyDelta(e, n));
                          },
                          n,
                          !0,
                        );
                      },
                    },
                  ]),
                  e
                );
              })();
            ((x.DEFAULTS = {
              bounds: null,
              formats: null,
              modules: {},
              placeholder: ``,
              readOnly: !1,
              scrollingContainer: null,
              strict: !0,
              theme: `default`,
            }),
              (x.events = c.default.events),
              (x.sources = c.default.sources),
              (x.version = `1.3.7`),
              (x.imports = {
                delta: o.default,
                parchment: u.default,
                "core/module": l.default,
                "core/theme": h.default,
              }));
            function S(e, t) {
              if (
                ((t = (0, p.default)(
                  !0,
                  {
                    container: e,
                    modules: {
                      clipboard: !0,
                      keyboard: !0,
                      history: !0,
                    },
                  },
                  t,
                )),
                !t.theme || t.theme === x.DEFAULTS.theme)
              )
                t.theme = h.default;
              else if (((t.theme = x.import(`themes/` + t.theme)), t.theme == null))
                throw Error(`Invalid theme ` + t.theme + `. Did you register it?`);
              var n = (0, p.default)(!0, {}, t.theme.DEFAULTS);
              [n, t].forEach(function (e) {
                ((e.modules = e.modules || {}),
                  Object.keys(e.modules).forEach(function (t) {
                    e.modules[t] === !0 && (e.modules[t] = {});
                  }));
              });
              var r = Object.keys(n.modules)
                .concat(Object.keys(t.modules))
                .reduce(function (e, t) {
                  var n = x.import(`modules/` + t);
                  return (
                    n == null
                      ? b.error(`Cannot load ` + t + ` module. Are you sure you registered it?`)
                      : (e[t] = n.DEFAULTS || {}),
                    e
                  );
                }, {});
              return (
                t.modules != null &&
                  t.modules.toolbar &&
                  t.modules.toolbar.constructor !== Object &&
                  (t.modules.toolbar = {
                    container: t.modules.toolbar,
                  }),
                (t = (0, p.default)(
                  !0,
                  {},
                  x.DEFAULTS,
                  {
                    modules: r,
                  },
                  n,
                  t,
                )),
                [`bounds`, `container`, `scrollingContainer`].forEach(function (e) {
                  typeof t[e] == `string` && (t[e] = document.querySelector(t[e]));
                }),
                (t.modules = Object.keys(t.modules).reduce(function (e, n) {
                  return (t.modules[n] && (e[n] = t.modules[n]), e);
                }, {})),
                t
              );
            }
            function C(e, t, n, r) {
              if (this.options.strict && !this.isEnabled() && t === c.default.sources.USER)
                return new o.default();
              var i = n == null ? null : this.getSelection(),
                a = this.editor.delta,
                s = e();
              if (
                (i != null &&
                  (n === !0 && (n = i.index),
                  r == null ? (i = T(i, s, t)) : r !== 0 && (i = T(i, n, r, t)),
                  this.setSelection(i, c.default.sources.SILENT)),
                s.length() > 0)
              ) {
                var l,
                  u = [c.default.events.TEXT_CHANGE, s, a, t];
                if (
                  ((l = this.emitter).emit.apply(l, [c.default.events.EDITOR_CHANGE].concat(u)),
                  t !== c.default.sources.SILENT)
                ) {
                  var d;
                  (d = this.emitter).emit.apply(d, u);
                }
              }
              return s;
            }
            function w(e, t, n, i, a) {
              var o = {};
              return (
                typeof e.index == `number` && typeof e.length == `number`
                  ? typeof t == `number`
                    ? ((t = e.length), (e = e.index))
                    : ((a = i), (i = n), (n = t), (t = e.length), (e = e.index))
                  : typeof t != `number` && ((a = i), (i = n), (n = t), (t = 0)),
                (n === void 0 ? `undefined` : r(n)) === `object`
                  ? ((o = n), (a = i))
                  : typeof n == `string` && (i == null ? (a = n) : (o[n] = i)),
                (a ||= c.default.sources.API),
                [e, t, o, a]
              );
            }
            function T(e, t, n, r) {
              if (e == null) return null;
              var a = void 0,
                s = void 0;
              if (t instanceof o.default) {
                var l = i(
                  [e.index, e.index + e.length].map(function (e) {
                    return t.transformPosition(e, r !== c.default.sources.USER);
                  }),
                  2,
                );
                ((a = l[0]), (s = l[1]));
              } else {
                var u = i(
                  [e.index, e.index + e.length].map(function (e) {
                    return e < t || (e === t && r === c.default.sources.USER)
                      ? e
                      : n >= 0
                        ? e + n
                        : Math.max(t, e + n);
                  }),
                  2,
                );
                ((a = u[0]), (s = u[1]));
              }
              return new d.Range(a, s - a);
            }
            ((t.expandConfig = S), (t.overload = w), (t.default = x));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = s(n(7)),
              o = s(n(0));
            function s(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function c(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function l(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function u(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var d = (function (e) {
              u(t, e);
              function t() {
                return (
                  c(this, t),
                  l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(
                  t,
                  [
                    {
                      key: `formatAt`,
                      value: function (e, n, r, a) {
                        if (
                          t.compare(this.statics.blotName, r) < 0 &&
                          o.default.query(r, o.default.Scope.BLOT)
                        ) {
                          var s = this.isolate(e, n);
                          a && s.wrap(r, a);
                        } else
                          i(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `formatAt`,
                            this,
                          ).call(this, e, n, r, a);
                      },
                    },
                    {
                      key: `optimize`,
                      value: function (e) {
                        if (
                          (i(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `optimize`,
                            this,
                          ).call(this, e),
                          this.parent instanceof t &&
                            t.compare(this.statics.blotName, this.parent.statics.blotName) > 0)
                        ) {
                          var n = this.parent.isolate(this.offset(), this.length());
                          (this.moveChildren(n), n.wrap(this));
                        }
                      },
                    },
                  ],
                  [
                    {
                      key: `compare`,
                      value: function (e, n) {
                        var r = t.order.indexOf(e),
                          i = t.order.indexOf(n);
                        return r >= 0 || i >= 0 ? r - i : e === n ? 0 : e < n ? -1 : 1;
                      },
                    },
                  ],
                ),
                t
              );
            })(o.default.Inline);
            ((d.allowedChildren = [d, o.default.Embed, a.default]),
              (d.order = [
                `cursor`,
                `inline`,
                `underline`,
                `strike`,
                `italic`,
                `bold`,
                `script`,
                `link`,
                `code`,
              ]),
              (t.default = d));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = i(n(0));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function a(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function o(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function s(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            t.default = (function (e) {
              s(t, e);
              function t() {
                return (
                  a(this, t),
                  o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return t;
            })(r.default.Text);
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = s(n(54)),
              o = s(n(10));
            function s(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function c(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function l(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function u(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var d = (0, o.default)(`quill:events`);
            [`selectionchange`, `mousedown`, `mouseup`, `click`].forEach(function (e) {
              document.addEventListener(e, function () {
                var e = [...arguments];
                [].slice.call(document.querySelectorAll(`.ql-container`)).forEach(function (t) {
                  if (t.__quill && t.__quill.emitter) {
                    var n;
                    (n = t.__quill.emitter).handleDOM.apply(n, e);
                  }
                });
              });
            });
            var f = (function (e) {
              u(t, e);
              function t() {
                c(this, t);
                var e = l(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                return ((e.listeners = {}), e.on(`error`, d.error), e);
              }
              return (
                r(t, [
                  {
                    key: `emit`,
                    value: function () {
                      (d.log.apply(d, arguments),
                        i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `emit`,
                          this,
                        ).apply(this, arguments));
                    },
                  },
                  {
                    key: `handleDOM`,
                    value: function (e) {
                      var t = [...arguments].slice(1);
                      (this.listeners[e.type] || []).forEach(function (n) {
                        var r = n.node,
                          i = n.handler;
                        (e.target === r || r.contains(e.target)) && i.apply(void 0, [e].concat(t));
                      });
                    },
                  },
                  {
                    key: `listenDOM`,
                    value: function (e, t, n) {
                      (this.listeners[e] || (this.listeners[e] = []),
                        this.listeners[e].push({
                          node: t,
                          handler: n,
                        }));
                    },
                  },
                ]),
                t
              );
            })(a.default);
            ((f.events = {
              EDITOR_CHANGE: `editor-change`,
              SCROLL_BEFORE_UPDATE: `scroll-before-update`,
              SCROLL_OPTIMIZE: `scroll-optimize`,
              SCROLL_UPDATE: `scroll-update`,
              SELECTION_CHANGE: `selection-change`,
              TEXT_CHANGE: `text-change`,
            }),
              (f.sources = {
                API: `api`,
                SILENT: `silent`,
                USER: `user`,
              }),
              (t.default = f));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            function r(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            var i = function e(t) {
              var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              (r(this, e), (this.quill = t), (this.options = n));
            };
            ((i.DEFAULTS = {}), (t.default = i));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = [`error`, `warn`, `log`, `info`],
              i = `warn`;
            function a(e) {
              if (r.indexOf(e) <= r.indexOf(i)) {
                var t,
                  n = [...arguments].slice(1);
                (t = console)[e].apply(t, n);
              }
            }
            function o(e) {
              return r.reduce(function (t, n) {
                return ((t[n] = a.bind(console, n, e)), t);
              }, {});
            }
            ((a.level = o.level =
              function (e) {
                i = e;
              }),
              (t.default = o));
          },
          function (e, t, n) {
            var r = Array.prototype.slice,
              i = n(52),
              a = n(53),
              o = (e.exports = function (e, t, n) {
                return (
                  (n ||= {}),
                  e === t
                    ? !0
                    : e instanceof Date && t instanceof Date
                      ? e.getTime() === t.getTime()
                      : !e || !t || (typeof e != `object` && typeof t != `object`)
                        ? n.strict
                          ? e === t
                          : e == t
                        : l(e, t, n)
                );
              });
            function s(e) {
              return e == null;
            }
            function c(e) {
              return !(
                !e ||
                typeof e != `object` ||
                typeof e.length != `number` ||
                typeof e.copy != `function` ||
                typeof e.slice != `function` ||
                (e.length > 0 && typeof e[0] != `number`)
              );
            }
            function l(e, t, n) {
              var l, u;
              if (s(e) || s(t) || e.prototype !== t.prototype) return !1;
              if (a(e)) return a(t) ? ((e = r.call(e)), (t = r.call(t)), o(e, t, n)) : !1;
              if (c(e)) {
                if (!c(t) || e.length !== t.length) return !1;
                for (l = 0; l < e.length; l++) if (e[l] !== t[l]) return !1;
                return !0;
              }
              try {
                var d = i(e),
                  f = i(t);
              } catch {
                return !1;
              }
              if (d.length != f.length) return !1;
              for (d.sort(), f.sort(), l = d.length - 1; l >= 0; l--) if (d[l] != f[l]) return !1;
              for (l = d.length - 1; l >= 0; l--) if (((u = d[l]), !o(e[u], t[u], n))) return !1;
              return typeof e == typeof t;
            }
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = n(1);
            t.default = (function () {
              function e(e, t, n) {
                (n === void 0 && (n = {}), (this.attrName = e), (this.keyName = t));
                var i = r.Scope.TYPE & r.Scope.ATTRIBUTE;
                (n.scope == null
                  ? (this.scope = r.Scope.ATTRIBUTE)
                  : (this.scope = (n.scope & r.Scope.LEVEL) | i),
                  n.whitelist != null && (this.whitelist = n.whitelist));
              }
              return (
                (e.keys = function (e) {
                  return [].map.call(e.attributes, function (e) {
                    return e.name;
                  });
                }),
                (e.prototype.add = function (e, t) {
                  return this.canAdd(e, t) ? (e.setAttribute(this.keyName, t), !0) : !1;
                }),
                (e.prototype.canAdd = function (e, t) {
                  return r.query(e, r.Scope.BLOT & (this.scope | r.Scope.TYPE)) == null
                    ? !1
                    : this.whitelist == null
                      ? !0
                      : typeof t == `string`
                        ? this.whitelist.indexOf(t.replace(/["']/g, ``)) > -1
                        : this.whitelist.indexOf(t) > -1;
                }),
                (e.prototype.remove = function (e) {
                  e.removeAttribute(this.keyName);
                }),
                (e.prototype.value = function (e) {
                  var t = e.getAttribute(this.keyName);
                  return this.canAdd(e, t) && t ? t : ``;
                }),
                e
              );
            })();
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.Code = void 0));
            var r = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              i = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              a = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              o = d(n(2)),
              s = d(n(0)),
              c = d(n(4)),
              l = d(n(6)),
              u = d(n(7));
            function d(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function f(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function p(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function m(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var h = (function (e) {
              m(t, e);
              function t() {
                return (
                  f(this, t),
                  p(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return t;
            })(l.default);
            ((h.blotName = `code`), (h.tagName = `CODE`));
            var g = (function (e) {
              m(t, e);
              function t() {
                return (
                  f(this, t),
                  p(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                i(
                  t,
                  [
                    {
                      key: `delta`,
                      value: function () {
                        var e = this,
                          t = this.domNode.textContent;
                        return (
                          t.endsWith(`
`) && (t = t.slice(0, -1)),
                          t
                            .split(
                              `
`,
                            )
                            .reduce(function (t, n) {
                              return t.insert(n).insert(
                                `
`,
                                e.formats(),
                              );
                            }, new o.default())
                        );
                      },
                    },
                    {
                      key: `format`,
                      value: function (e, n) {
                        if (!(e === this.statics.blotName && n)) {
                          var i = r(this.descendant(u.default, this.length() - 1), 1)[0];
                          (i?.deleteAt(i.length() - 1, 1),
                            a(
                              t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                              `format`,
                              this,
                            ).call(this, e, n));
                        }
                      },
                    },
                    {
                      key: `formatAt`,
                      value: function (e, n, r, i) {
                        if (
                          n !== 0 &&
                          !(
                            s.default.query(r, s.default.Scope.BLOCK) == null ||
                            (r === this.statics.blotName &&
                              i === this.statics.formats(this.domNode))
                          )
                        ) {
                          var a = this.newlineIndex(e);
                          if (!(a < 0 || a >= e + n)) {
                            var o = this.newlineIndex(e, !0) + 1,
                              c = a - o + 1,
                              l = this.isolate(o, c),
                              u = l.next;
                            (l.format(r, i), u instanceof t && u.formatAt(0, e - o + n - c, r, i));
                          }
                        }
                      },
                    },
                    {
                      key: `insertAt`,
                      value: function (e, t, n) {
                        if (n == null) {
                          var i = r(this.descendant(u.default, e), 2),
                            a = i[0],
                            o = i[1];
                          a.insertAt(o, t);
                        }
                      },
                    },
                    {
                      key: `length`,
                      value: function () {
                        var e = this.domNode.textContent.length;
                        return this.domNode.textContent.endsWith(`
`)
                          ? e
                          : e + 1;
                      },
                    },
                    {
                      key: `newlineIndex`,
                      value: function (e) {
                        if (arguments.length > 1 && arguments[1] !== void 0 && arguments[1])
                          return this.domNode.textContent.slice(0, e).lastIndexOf(`
`);
                        var t = this.domNode.textContent.slice(e).indexOf(`
`);
                        return t > -1 ? e + t : -1;
                      },
                    },
                    {
                      key: `optimize`,
                      value: function (e) {
                        (this.domNode.textContent.endsWith(`
`) ||
                          this.appendChild(
                            s.default.create(
                              `text`,
                              `
`,
                            ),
                          ),
                          a(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `optimize`,
                            this,
                          ).call(this, e));
                        var n = this.next;
                        n != null &&
                          n.prev === this &&
                          n.statics.blotName === this.statics.blotName &&
                          this.statics.formats(this.domNode) === n.statics.formats(n.domNode) &&
                          (n.optimize(e), n.moveChildren(this), n.remove());
                      },
                    },
                    {
                      key: `replace`,
                      value: function (e) {
                        (a(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `replace`,
                          this,
                        ).call(this, e),
                          [].slice.call(this.domNode.querySelectorAll(`*`)).forEach(function (e) {
                            var t = s.default.find(e);
                            t == null
                              ? e.parentNode.removeChild(e)
                              : t instanceof s.default.Embed
                                ? t.remove()
                                : t.unwrap();
                          }));
                      },
                    },
                  ],
                  [
                    {
                      key: `create`,
                      value: function (e) {
                        var n = a(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                          this,
                          e,
                        );
                        return (n.setAttribute(`spellcheck`, !1), n);
                      },
                    },
                    {
                      key: `formats`,
                      value: function () {
                        return !0;
                      },
                    },
                  ],
                ),
                t
              );
            })(c.default);
            ((g.blotName = `code-block`),
              (g.tagName = `PRE`),
              (g.TAB = `  `),
              (t.Code = h),
              (t.default = g));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r =
                typeof Symbol == `function` && typeof Symbol.iterator == `symbol`
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        typeof Symbol == `function` &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? `symbol`
                        : typeof e;
                    },
              i = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              a = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              o = v(n(2)),
              s = v(n(20)),
              c = v(n(0)),
              l = v(n(13)),
              u = v(n(24)),
              d = n(4),
              f = v(d),
              p = v(n(16)),
              m = v(n(21)),
              h = v(n(11)),
              g = v(n(3));
            function v(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function y(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function b(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            var x = /^[ -~]*$/,
              S = (function () {
                function e(t) {
                  (b(this, e), (this.scroll = t), (this.delta = this.getDelta()));
                }
                return (
                  a(e, [
                    {
                      key: `applyDelta`,
                      value: function (e) {
                        var t = this,
                          n = !1;
                        this.scroll.update();
                        var a = this.scroll.length();
                        return (
                          this.scroll.batchStart(),
                          (e = w(e)),
                          e.reduce(function (e, o) {
                            var l = o.retain || o.delete || o.insert.length || 1,
                              u = o.attributes || {};
                            if (o.insert != null) {
                              if (typeof o.insert == `string`) {
                                var p = o.insert;
                                (p.endsWith(`
`) &&
                                  n &&
                                  ((n = !1), (p = p.slice(0, -1))),
                                  e >= a &&
                                    !p.endsWith(`
`) &&
                                    (n = !0),
                                  t.scroll.insertAt(e, p));
                                var m = i(t.scroll.line(e), 2),
                                  h = m[0],
                                  v = m[1],
                                  y = (0, g.default)({}, (0, d.bubbleFormats)(h));
                                if (h instanceof f.default) {
                                  var b = i(h.descendant(c.default.Leaf, v), 1)[0];
                                  y = (0, g.default)(y, (0, d.bubbleFormats)(b));
                                }
                                u = s.default.attributes.diff(y, u) || {};
                              } else if (r(o.insert) === `object`) {
                                var x = Object.keys(o.insert)[0];
                                if (x == null) return e;
                                t.scroll.insertAt(e, x, o.insert[x]);
                              }
                              a += l;
                            }
                            return (
                              Object.keys(u).forEach(function (n) {
                                t.scroll.formatAt(e, l, n, u[n]);
                              }),
                              e + l
                            );
                          }, 0),
                          e.reduce(function (e, n) {
                            return typeof n.delete == `number`
                              ? (t.scroll.deleteAt(e, n.delete), e)
                              : e + (n.retain || n.insert.length || 1);
                          }, 0),
                          this.scroll.batchEnd(),
                          this.update(e)
                        );
                      },
                    },
                    {
                      key: `deleteText`,
                      value: function (e, t) {
                        return (
                          this.scroll.deleteAt(e, t),
                          this.update(new o.default().retain(e).delete(t))
                        );
                      },
                    },
                    {
                      key: `formatLine`,
                      value: function (e, t) {
                        var n = this,
                          r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        return (
                          this.scroll.update(),
                          Object.keys(r).forEach(function (i) {
                            if (!(n.scroll.whitelist != null && !n.scroll.whitelist[i])) {
                              var a = n.scroll.lines(e, Math.max(t, 1)),
                                o = t;
                              a.forEach(function (t) {
                                var a = t.length();
                                if (!(t instanceof l.default)) t.format(i, r[i]);
                                else {
                                  var s = e - t.offset(n.scroll),
                                    c = t.newlineIndex(s + o) - s + 1;
                                  t.formatAt(s, c, i, r[i]);
                                }
                                o -= a;
                              });
                            }
                          }),
                          this.scroll.optimize(),
                          this.update(new o.default().retain(e).retain(t, (0, m.default)(r)))
                        );
                      },
                    },
                    {
                      key: `formatText`,
                      value: function (e, t) {
                        var n = this,
                          r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        return (
                          Object.keys(r).forEach(function (i) {
                            n.scroll.formatAt(e, t, i, r[i]);
                          }),
                          this.update(new o.default().retain(e).retain(t, (0, m.default)(r)))
                        );
                      },
                    },
                    {
                      key: `getContents`,
                      value: function (e, t) {
                        return this.delta.slice(e, e + t);
                      },
                    },
                    {
                      key: `getDelta`,
                      value: function () {
                        return this.scroll.lines().reduce(function (e, t) {
                          return e.concat(t.delta());
                        }, new o.default());
                      },
                    },
                    {
                      key: `getFormat`,
                      value: function (e) {
                        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0,
                          n = [],
                          r = [];
                        t === 0
                          ? this.scroll.path(e).forEach(function (e) {
                              var t = i(e, 1)[0];
                              t instanceof f.default
                                ? n.push(t)
                                : t instanceof c.default.Leaf && r.push(t);
                            })
                          : ((n = this.scroll.lines(e, t)),
                            (r = this.scroll.descendants(c.default.Leaf, e, t)));
                        var a = [n, r].map(function (e) {
                          if (e.length === 0) return {};
                          for (
                            var t = (0, d.bubbleFormats)(e.shift());
                            Object.keys(t).length > 0;
                          ) {
                            var n = e.shift();
                            if (n == null) return t;
                            t = C((0, d.bubbleFormats)(n), t);
                          }
                          return t;
                        });
                        return g.default.apply(g.default, a);
                      },
                    },
                    {
                      key: `getText`,
                      value: function (e, t) {
                        return this.getContents(e, t)
                          .filter(function (e) {
                            return typeof e.insert == `string`;
                          })
                          .map(function (e) {
                            return e.insert;
                          })
                          .join(``);
                      },
                    },
                    {
                      key: `insertEmbed`,
                      value: function (e, t, n) {
                        return (
                          this.scroll.insertAt(e, t, n),
                          this.update(new o.default().retain(e).insert(y({}, t, n)))
                        );
                      },
                    },
                    {
                      key: `insertText`,
                      value: function (e, t) {
                        var n = this,
                          r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        return (
                          (t = t
                            .replace(
                              /\r\n/g,
                              `
`,
                            )
                            .replace(
                              /\r/g,
                              `
`,
                            )),
                          this.scroll.insertAt(e, t),
                          Object.keys(r).forEach(function (i) {
                            n.scroll.formatAt(e, t.length, i, r[i]);
                          }),
                          this.update(new o.default().retain(e).insert(t, (0, m.default)(r)))
                        );
                      },
                    },
                    {
                      key: `isBlank`,
                      value: function () {
                        if (this.scroll.children.length == 0) return !0;
                        if (this.scroll.children.length > 1) return !1;
                        var e = this.scroll.children.head;
                        return e.statics.blotName !== f.default.blotName || e.children.length > 1
                          ? !1
                          : e.children.head instanceof p.default;
                      },
                    },
                    {
                      key: `removeFormat`,
                      value: function (e, t) {
                        var n = this.getText(e, t),
                          r = i(this.scroll.line(e + t), 2),
                          a = r[0],
                          s = r[1],
                          c = 0,
                          u = new o.default();
                        a != null &&
                          ((c =
                            a instanceof l.default ? a.newlineIndex(s) - s + 1 : a.length() - s),
                          (u = a.delta().slice(s, s + c - 1).insert(`
`)));
                        var d = this.getContents(e, t + c).diff(
                            new o.default().insert(n).concat(u),
                          ),
                          f = new o.default().retain(e).concat(d);
                        return this.applyDelta(f);
                      },
                    },
                    {
                      key: `update`,
                      value: function (e) {
                        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [],
                          n =
                            arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0,
                          r = this.delta;
                        if (
                          t.length === 1 &&
                          t[0].type === `characterData` &&
                          t[0].target.data.match(x) &&
                          c.default.find(t[0].target)
                        ) {
                          var i = c.default.find(t[0].target),
                            a = (0, d.bubbleFormats)(i),
                            s = i.offset(this.scroll),
                            l = t[0].oldValue.replace(u.default.CONTENTS, ``),
                            f = new o.default().insert(l),
                            p = new o.default().insert(i.value());
                          ((e = new o.default()
                            .retain(s)
                            .concat(f.diff(p, n))
                            .reduce(function (e, t) {
                              return t.insert ? e.insert(t.insert, a) : e.push(t);
                            }, new o.default())),
                            (this.delta = r.compose(e)));
                        } else
                          ((this.delta = this.getDelta()),
                            (!e || !(0, h.default)(r.compose(e), this.delta)) &&
                              (e = r.diff(this.delta, n)));
                        return e;
                      },
                    },
                  ]),
                  e
                );
              })();
            function C(e, t) {
              return Object.keys(t).reduce(function (n, r) {
                return (
                  e[r] == null ||
                    (t[r] === e[r]
                      ? (n[r] = t[r])
                      : Array.isArray(t[r])
                        ? t[r].indexOf(e[r]) < 0 && (n[r] = t[r].concat([e[r]]))
                        : (n[r] = [t[r], e[r]])),
                  n
                );
              }, {});
            }
            function w(e) {
              return e.reduce(function (e, t) {
                if (t.insert === 1) {
                  var n = (0, m.default)(t.attributes);
                  return (
                    delete n.image,
                    e.insert(
                      {
                        image: t.attributes.image,
                      },
                      n,
                    )
                  );
                }
                if (
                  (t.attributes != null &&
                    (t.attributes.list === !0 || t.attributes.bullet === !0) &&
                    ((t = (0, m.default)(t)),
                    t.attributes.list
                      ? (t.attributes.list = `ordered`)
                      : ((t.attributes.list = `bullet`), delete t.attributes.bullet)),
                  typeof t.insert == `string`)
                ) {
                  var r = t.insert
                    .replace(
                      /\r\n/g,
                      `
`,
                    )
                    .replace(
                      /\r/g,
                      `
`,
                    );
                  return e.insert(r, t.attributes);
                }
                return e.push(t);
              }, new o.default());
            }
            t.default = S;
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.Range = void 0));
            var r = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              i = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              a = u(n(0)),
              o = u(n(21)),
              s = u(n(11)),
              c = u(n(8)),
              l = u(n(10));
            function u(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function d(e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
                return n;
              } else return Array.from(e);
            }
            function f(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            var p = (0, l.default)(`quill:selection`),
              m = function e(t) {
                var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                (f(this, e), (this.index = t), (this.length = n));
              },
              h = (function () {
                function e(t, n) {
                  var r = this;
                  (f(this, e),
                    (this.emitter = n),
                    (this.scroll = t),
                    (this.composing = !1),
                    (this.mouseDown = !1),
                    (this.root = this.scroll.domNode),
                    (this.cursor = a.default.create(`cursor`, this)),
                    (this.lastRange = this.savedRange = new m(0, 0)),
                    this.handleComposition(),
                    this.handleDragging(),
                    this.emitter.listenDOM(`selectionchange`, document, function () {
                      r.mouseDown || setTimeout(r.update.bind(r, c.default.sources.USER), 1);
                    }),
                    this.emitter.on(c.default.events.EDITOR_CHANGE, function (e, t) {
                      e === c.default.events.TEXT_CHANGE &&
                        t.length() > 0 &&
                        r.update(c.default.sources.SILENT);
                    }),
                    this.emitter.on(c.default.events.SCROLL_BEFORE_UPDATE, function () {
                      if (r.hasFocus()) {
                        var e = r.getNativeRange();
                        e != null &&
                          e.start.node !== r.cursor.textNode &&
                          r.emitter.once(c.default.events.SCROLL_UPDATE, function () {
                            try {
                              r.setNativeRange(
                                e.start.node,
                                e.start.offset,
                                e.end.node,
                                e.end.offset,
                              );
                            } catch {}
                          });
                      }
                    }),
                    this.emitter.on(c.default.events.SCROLL_OPTIMIZE, function (e, t) {
                      if (t.range) {
                        var n = t.range,
                          i = n.startNode,
                          a = n.startOffset,
                          o = n.endNode,
                          s = n.endOffset;
                        r.setNativeRange(i, a, o, s);
                      }
                    }),
                    this.update(c.default.sources.SILENT));
                }
                return (
                  i(e, [
                    {
                      key: `handleComposition`,
                      value: function () {
                        var e = this;
                        (this.root.addEventListener(`compositionstart`, function () {
                          e.composing = !0;
                        }),
                          this.root.addEventListener(`compositionend`, function () {
                            if (((e.composing = !1), e.cursor.parent)) {
                              var t = e.cursor.restore();
                              if (!t) return;
                              setTimeout(function () {
                                e.setNativeRange(
                                  t.startNode,
                                  t.startOffset,
                                  t.endNode,
                                  t.endOffset,
                                );
                              }, 1);
                            }
                          }));
                      },
                    },
                    {
                      key: `handleDragging`,
                      value: function () {
                        var e = this;
                        (this.emitter.listenDOM(`mousedown`, document.body, function () {
                          e.mouseDown = !0;
                        }),
                          this.emitter.listenDOM(`mouseup`, document.body, function () {
                            ((e.mouseDown = !1), e.update(c.default.sources.USER));
                          }));
                      },
                    },
                    {
                      key: `focus`,
                      value: function () {
                        this.hasFocus() || (this.root.focus(), this.setRange(this.savedRange));
                      },
                    },
                    {
                      key: `format`,
                      value: function (e, t) {
                        if (!(this.scroll.whitelist != null && !this.scroll.whitelist[e])) {
                          this.scroll.update();
                          var n = this.getNativeRange();
                          if (!(
                            n == null ||
                            !n.native.collapsed ||
                            a.default.query(e, a.default.Scope.BLOCK)
                          )) {
                            if (n.start.node !== this.cursor.textNode) {
                              var r = a.default.find(n.start.node, !1);
                              if (r == null) return;
                              if (r instanceof a.default.Leaf) {
                                var i = r.split(n.start.offset);
                                r.parent.insertBefore(this.cursor, i);
                              } else r.insertBefore(this.cursor, n.start.node);
                              this.cursor.attach();
                            }
                            (this.cursor.format(e, t),
                              this.scroll.optimize(),
                              this.setNativeRange(
                                this.cursor.textNode,
                                this.cursor.textNode.data.length,
                              ),
                              this.update());
                          }
                        }
                      },
                    },
                    {
                      key: `getBounds`,
                      value: function (e) {
                        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0,
                          n = this.scroll.length();
                        ((e = Math.min(e, n - 1)), (t = Math.min(e + t, n - 1) - e));
                        var i = void 0,
                          a = r(this.scroll.leaf(e), 2),
                          o = a[0],
                          s = a[1];
                        if (o == null) return null;
                        var c = r(o.position(s, !0), 2);
                        ((i = c[0]), (s = c[1]));
                        var l = document.createRange();
                        if (t > 0) {
                          l.setStart(i, s);
                          var u = r(this.scroll.leaf(e + t), 2);
                          if (((o = u[0]), (s = u[1]), o == null)) return null;
                          var d = r(o.position(s, !0), 2);
                          return (
                            (i = d[0]),
                            (s = d[1]),
                            l.setEnd(i, s),
                            l.getBoundingClientRect()
                          );
                        } else {
                          var f = `left`,
                            p = void 0;
                          return (
                            i instanceof Text
                              ? (s < i.data.length
                                  ? (l.setStart(i, s), l.setEnd(i, s + 1))
                                  : (l.setStart(i, s - 1), l.setEnd(i, s), (f = `right`)),
                                (p = l.getBoundingClientRect()))
                              : ((p = o.domNode.getBoundingClientRect()), s > 0 && (f = `right`)),
                            {
                              bottom: p.top + p.height,
                              height: p.height,
                              left: p[f],
                              right: p[f],
                              top: p.top,
                              width: 0,
                            }
                          );
                        }
                      },
                    },
                    {
                      key: `getNativeRange`,
                      value: function () {
                        var e = document.getSelection();
                        if (e == null || e.rangeCount <= 0) return null;
                        var t = e.getRangeAt(0);
                        if (t == null) return null;
                        var n = this.normalizeNative(t);
                        return (p.info(`getNativeRange`, n), n);
                      },
                    },
                    {
                      key: `getRange`,
                      value: function () {
                        var e = this.getNativeRange();
                        return e == null ? [null, null] : [this.normalizedToRange(e), e];
                      },
                    },
                    {
                      key: `hasFocus`,
                      value: function () {
                        return document.activeElement === this.root;
                      },
                    },
                    {
                      key: `normalizedToRange`,
                      value: function (e) {
                        var t = this,
                          n = [[e.start.node, e.start.offset]];
                        e.native.collapsed || n.push([e.end.node, e.end.offset]);
                        var i = n.map(function (e) {
                            var n = r(e, 2),
                              i = n[0],
                              o = n[1],
                              s = a.default.find(i, !0),
                              c = s.offset(t.scroll);
                            return o === 0
                              ? c
                              : s instanceof a.default.Container
                                ? c + s.length()
                                : c + s.index(i, o);
                          }),
                          o = Math.min(Math.max.apply(Math, d(i)), this.scroll.length() - 1),
                          s = Math.min.apply(Math, [o].concat(d(i)));
                        return new m(s, o - s);
                      },
                    },
                    {
                      key: `normalizeNative`,
                      value: function (e) {
                        if (
                          !g(this.root, e.startContainer) ||
                          (!e.collapsed && !g(this.root, e.endContainer))
                        )
                          return null;
                        var t = {
                          start: {
                            node: e.startContainer,
                            offset: e.startOffset,
                          },
                          end: {
                            node: e.endContainer,
                            offset: e.endOffset,
                          },
                          native: e,
                        };
                        return (
                          [t.start, t.end].forEach(function (e) {
                            for (
                              var t = e.node, n = e.offset;
                              !(t instanceof Text) && t.childNodes.length > 0;
                            )
                              if (t.childNodes.length > n) ((t = t.childNodes[n]), (n = 0));
                              else if (t.childNodes.length === n)
                                ((t = t.lastChild),
                                  (n =
                                    t instanceof Text ? t.data.length : t.childNodes.length + 1));
                              else break;
                            ((e.node = t), (e.offset = n));
                          }),
                          t
                        );
                      },
                    },
                    {
                      key: `rangeToNative`,
                      value: function (e) {
                        var t = this,
                          n = e.collapsed ? [e.index] : [e.index, e.index + e.length],
                          i = [],
                          a = this.scroll.length();
                        return (
                          n.forEach(function (e, n) {
                            e = Math.min(a - 1, e);
                            var o = void 0,
                              s = r(t.scroll.leaf(e), 2),
                              c = s[0],
                              l = s[1],
                              u = r(c.position(l, n !== 0), 2);
                            ((o = u[0]), (l = u[1]), i.push(o, l));
                          }),
                          i.length < 2 && (i = i.concat(i)),
                          i
                        );
                      },
                    },
                    {
                      key: `scrollIntoView`,
                      value: function (e) {
                        var t = this.lastRange;
                        if (t != null) {
                          var n = this.getBounds(t.index, t.length);
                          if (n != null) {
                            var i = this.scroll.length() - 1,
                              a = r(this.scroll.line(Math.min(t.index, i)), 1)[0],
                              o = a;
                            if (
                              (t.length > 0 &&
                                (o = r(this.scroll.line(Math.min(t.index + t.length, i)), 1)[0]),
                              !(a == null || o == null))
                            ) {
                              var s = e.getBoundingClientRect();
                              n.top < s.top
                                ? (e.scrollTop -= s.top - n.top)
                                : n.bottom > s.bottom && (e.scrollTop += n.bottom - s.bottom);
                            }
                          }
                        }
                      },
                    },
                    {
                      key: `setNativeRange`,
                      value: function (e, t) {
                        var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e,
                          r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t,
                          i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
                        if (
                          (p.info(`setNativeRange`, e, t, n, r),
                          !(
                            e != null &&
                            (this.root.parentNode == null ||
                              e.parentNode == null ||
                              n.parentNode == null)
                          ))
                        ) {
                          var a = document.getSelection();
                          if (a != null)
                            if (e != null) {
                              this.hasFocus() || this.root.focus();
                              var o = (this.getNativeRange() || {}).native;
                              if (
                                o == null ||
                                i ||
                                e !== o.startContainer ||
                                t !== o.startOffset ||
                                n !== o.endContainer ||
                                r !== o.endOffset
                              ) {
                                (e.tagName == `BR` &&
                                  ((t = [].indexOf.call(e.parentNode.childNodes, e)),
                                  (e = e.parentNode)),
                                  n.tagName == `BR` &&
                                    ((r = [].indexOf.call(n.parentNode.childNodes, n)),
                                    (n = n.parentNode)));
                                var s = document.createRange();
                                (s.setStart(e, t),
                                  s.setEnd(n, r),
                                  a.removeAllRanges(),
                                  a.addRange(s));
                              }
                            } else (a.removeAllRanges(), this.root.blur(), document.body.focus());
                        }
                      },
                    },
                    {
                      key: `setRange`,
                      value: function (e) {
                        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1,
                          n =
                            arguments.length > 2 && arguments[2] !== void 0
                              ? arguments[2]
                              : c.default.sources.API;
                        if (
                          (typeof t == `string` && ((n = t), (t = !1)),
                          p.info(`setRange`, e),
                          e != null)
                        ) {
                          var r = this.rangeToNative(e);
                          this.setNativeRange.apply(this, d(r).concat([t]));
                        } else this.setNativeRange(null);
                        this.update(n);
                      },
                    },
                    {
                      key: `update`,
                      value: function () {
                        var e =
                            arguments.length > 0 && arguments[0] !== void 0
                              ? arguments[0]
                              : c.default.sources.USER,
                          t = this.lastRange,
                          n = r(this.getRange(), 2),
                          i = n[0],
                          a = n[1];
                        if (
                          ((this.lastRange = i),
                          this.lastRange != null && (this.savedRange = this.lastRange),
                          !(0, s.default)(t, this.lastRange))
                        ) {
                          var l;
                          !this.composing &&
                            a != null &&
                            a.native.collapsed &&
                            a.start.node !== this.cursor.textNode &&
                            this.cursor.restore();
                          var u = [
                            c.default.events.SELECTION_CHANGE,
                            (0, o.default)(this.lastRange),
                            (0, o.default)(t),
                            e,
                          ];
                          if (
                            ((l = this.emitter).emit.apply(
                              l,
                              [c.default.events.EDITOR_CHANGE].concat(u),
                            ),
                            e !== c.default.sources.SILENT)
                          ) {
                            var d;
                            (d = this.emitter).emit.apply(d, u);
                          }
                        }
                      },
                    },
                  ]),
                  e
                );
              })();
            function g(e, t) {
              try {
                t.parentNode;
              } catch {
                return !1;
              }
              return (t instanceof Text && (t = t.parentNode), e.contains(t));
            }
            ((t.Range = m), (t.default = h));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(0));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var u = (function (e) {
              l(t, e);
              function t() {
                return (
                  s(this, t),
                  c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(
                  t,
                  [
                    {
                      key: `insertInto`,
                      value: function (e, n) {
                        e.children.length === 0
                          ? i(
                              t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                              `insertInto`,
                              this,
                            ).call(this, e, n)
                          : this.remove();
                      },
                    },
                    {
                      key: `length`,
                      value: function () {
                        return 0;
                      },
                    },
                    {
                      key: `value`,
                      value: function () {
                        return ``;
                      },
                    },
                  ],
                  [
                    {
                      key: `value`,
                      value: function () {},
                    },
                  ],
                ),
                t
              );
            })(a.default.Embed);
            ((u.blotName = `break`), (u.tagName = `BR`), (t.default = u));
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(44),
              a = n(30),
              o = n(1),
              s = (function (e) {
                r(t, e);
                function t(t) {
                  var n = e.call(this, t) || this;
                  return (n.build(), n);
                }
                return (
                  (t.prototype.appendChild = function (e) {
                    this.insertBefore(e);
                  }),
                  (t.prototype.attach = function () {
                    (e.prototype.attach.call(this),
                      this.children.forEach(function (e) {
                        e.attach();
                      }));
                  }),
                  (t.prototype.build = function () {
                    var e = this;
                    ((this.children = new i.default()),
                      [].slice
                        .call(this.domNode.childNodes)
                        .reverse()
                        .forEach(function (t) {
                          try {
                            var n = c(t);
                            e.insertBefore(n, e.children.head || void 0);
                          } catch (e) {
                            if (e instanceof o.ParchmentError) return;
                            throw e;
                          }
                        }));
                  }),
                  (t.prototype.deleteAt = function (e, t) {
                    if (e === 0 && t === this.length()) return this.remove();
                    this.children.forEachAt(e, t, function (e, t, n) {
                      e.deleteAt(t, n);
                    });
                  }),
                  (t.prototype.descendant = function (e, n) {
                    var r = this.children.find(n),
                      i = r[0],
                      a = r[1];
                    return (e.blotName == null && e(i)) || (e.blotName != null && i instanceof e)
                      ? [i, a]
                      : i instanceof t
                        ? i.descendant(e, a)
                        : [null, -1];
                  }),
                  (t.prototype.descendants = function (e, n, r) {
                    (n === void 0 && (n = 0), r === void 0 && (r = Number.MAX_VALUE));
                    var i = [],
                      a = r;
                    return (
                      this.children.forEachAt(n, r, function (n, r, o) {
                        (((e.blotName == null && e(n)) || (e.blotName != null && n instanceof e)) &&
                          i.push(n),
                          n instanceof t && (i = i.concat(n.descendants(e, r, a))),
                          (a -= o));
                      }),
                      i
                    );
                  }),
                  (t.prototype.detach = function () {
                    (this.children.forEach(function (e) {
                      e.detach();
                    }),
                      e.prototype.detach.call(this));
                  }),
                  (t.prototype.formatAt = function (e, t, n, r) {
                    this.children.forEachAt(e, t, function (e, t, i) {
                      e.formatAt(t, i, n, r);
                    });
                  }),
                  (t.prototype.insertAt = function (e, t, n) {
                    var r = this.children.find(e),
                      i = r[0],
                      a = r[1];
                    if (i) i.insertAt(a, t, n);
                    else {
                      var s = n == null ? o.create(`text`, t) : o.create(t, n);
                      this.appendChild(s);
                    }
                  }),
                  (t.prototype.insertBefore = function (e, t) {
                    if (
                      this.statics.allowedChildren != null &&
                      !this.statics.allowedChildren.some(function (t) {
                        return e instanceof t;
                      })
                    )
                      throw new o.ParchmentError(
                        `Cannot insert ` + e.statics.blotName + ` into ` + this.statics.blotName,
                      );
                    e.insertInto(this, t);
                  }),
                  (t.prototype.length = function () {
                    return this.children.reduce(function (e, t) {
                      return e + t.length();
                    }, 0);
                  }),
                  (t.prototype.moveChildren = function (e, t) {
                    this.children.forEach(function (n) {
                      e.insertBefore(n, t);
                    });
                  }),
                  (t.prototype.optimize = function (t) {
                    if ((e.prototype.optimize.call(this, t), this.children.length === 0))
                      if (this.statics.defaultChild != null) {
                        var n = o.create(this.statics.defaultChild);
                        (this.appendChild(n), n.optimize(t));
                      } else this.remove();
                  }),
                  (t.prototype.path = function (e, n) {
                    n === void 0 && (n = !1);
                    var r = this.children.find(e, n),
                      i = r[0],
                      a = r[1],
                      o = [[this, e]];
                    return i instanceof t
                      ? o.concat(i.path(a, n))
                      : (i != null && o.push([i, a]), o);
                  }),
                  (t.prototype.removeChild = function (e) {
                    this.children.remove(e);
                  }),
                  (t.prototype.replace = function (n) {
                    (n instanceof t && n.moveChildren(this), e.prototype.replace.call(this, n));
                  }),
                  (t.prototype.split = function (e, t) {
                    if ((t === void 0 && (t = !1), !t)) {
                      if (e === 0) return this;
                      if (e === this.length()) return this.next;
                    }
                    var n = this.clone();
                    return (
                      this.parent.insertBefore(n, this.next),
                      this.children.forEachAt(e, this.length(), function (e, r, i) {
                        ((e = e.split(r, t)), n.appendChild(e));
                      }),
                      n
                    );
                  }),
                  (t.prototype.unwrap = function () {
                    (this.moveChildren(this.parent, this.next), this.remove());
                  }),
                  (t.prototype.update = function (e, t) {
                    var n = this,
                      r = [],
                      i = [];
                    (e.forEach(function (e) {
                      e.target === n.domNode &&
                        e.type === `childList` &&
                        (r.push.apply(r, e.addedNodes), i.push.apply(i, e.removedNodes));
                    }),
                      i.forEach(function (e) {
                        if (!(
                          e.parentNode != null &&
                          e.tagName !== `IFRAME` &&
                          document.body.compareDocumentPosition(e) &
                            Node.DOCUMENT_POSITION_CONTAINED_BY
                        )) {
                          var t = o.find(e);
                          t != null &&
                            (t.domNode.parentNode == null || t.domNode.parentNode === n.domNode) &&
                            t.detach();
                        }
                      }),
                      r
                        .filter(function (e) {
                          return e.parentNode == n.domNode;
                        })
                        .sort(function (e, t) {
                          return e === t
                            ? 0
                            : e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING
                              ? 1
                              : -1;
                        })
                        .forEach(function (e) {
                          var t = null;
                          e.nextSibling != null && (t = o.find(e.nextSibling));
                          var r = c(e);
                          (r.next != t || r.next == null) &&
                            (r.parent != null && r.parent.removeChild(n),
                            n.insertBefore(r, t || void 0));
                        }));
                  }),
                  t
                );
              })(a.default);
            function c(e) {
              var t = o.find(e);
              if (t == null)
                try {
                  t = o.create(e);
                } catch {
                  ((t = o.create(o.Scope.INLINE)),
                    [].slice.call(e.childNodes).forEach(function (e) {
                      t.domNode.appendChild(e);
                    }),
                    e.parentNode && e.parentNode.replaceChild(t.domNode, e),
                    t.attach());
                }
              return t;
            }
            t.default = s;
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(12),
              a = n(31),
              o = n(17),
              s = n(1);
            t.default = (function (e) {
              r(t, e);
              function t(t) {
                var n = e.call(this, t) || this;
                return ((n.attributes = new a.default(n.domNode)), n);
              }
              return (
                (t.formats = function (e) {
                  if (typeof this.tagName == `string`) return !0;
                  if (Array.isArray(this.tagName)) return e.tagName.toLowerCase();
                }),
                (t.prototype.format = function (e, t) {
                  var n = s.query(e);
                  n instanceof i.default
                    ? this.attributes.attribute(n, t)
                    : t &&
                      n != null &&
                      (e !== this.statics.blotName || this.formats()[e] !== t) &&
                      this.replaceWith(e, t);
                }),
                (t.prototype.formats = function () {
                  var e = this.attributes.values(),
                    t = this.statics.formats(this.domNode);
                  return (t != null && (e[this.statics.blotName] = t), e);
                }),
                (t.prototype.replaceWith = function (t, n) {
                  var r = e.prototype.replaceWith.call(this, t, n);
                  return (this.attributes.copy(r), r);
                }),
                (t.prototype.update = function (t, n) {
                  var r = this;
                  (e.prototype.update.call(this, t, n),
                    t.some(function (e) {
                      return e.target === r.domNode && e.type === `attributes`;
                    }) && this.attributes.build());
                }),
                (t.prototype.wrap = function (n, r) {
                  var i = e.prototype.wrap.call(this, n, r);
                  return (
                    i instanceof t &&
                      i.statics.scope === this.statics.scope &&
                      this.attributes.move(i),
                    i
                  );
                }),
                t
              );
            })(o.default);
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(30),
              a = n(1);
            t.default = (function (e) {
              r(t, e);
              function t() {
                return (e !== null && e.apply(this, arguments)) || this;
              }
              return (
                (t.value = function (e) {
                  return !0;
                }),
                (t.prototype.index = function (e, t) {
                  return this.domNode === e ||
                    this.domNode.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_CONTAINED_BY
                    ? Math.min(t, 1)
                    : -1;
                }),
                (t.prototype.position = function (e, t) {
                  var n = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                  return (e > 0 && (n += 1), [this.parent.domNode, n]);
                }),
                (t.prototype.value = function () {
                  var e;
                  return (
                    (e = {}),
                    (e[this.statics.blotName] = this.statics.value(this.domNode) || !0),
                    e
                  );
                }),
                (t.scope = a.Scope.INLINE_BLOT),
                t
              );
            })(i.default);
          },
          function (e, t, n) {
            var r = n(11),
              i = n(3),
              a = {
                attributes: {
                  compose: function (e, t, n) {
                    (typeof e != `object` && (e = {}), typeof t != `object` && (t = {}));
                    var r = i(!0, {}, t);
                    for (var a in (n ||
                      (r = Object.keys(r).reduce(function (e, t) {
                        return (r[t] != null && (e[t] = r[t]), e);
                      }, {})),
                    e))
                      e[a] !== void 0 && t[a] === void 0 && (r[a] = e[a]);
                    return Object.keys(r).length > 0 ? r : void 0;
                  },
                  diff: function (e, t) {
                    (typeof e != `object` && (e = {}), typeof t != `object` && (t = {}));
                    var n = Object.keys(e)
                      .concat(Object.keys(t))
                      .reduce(function (n, i) {
                        return (r(e[i], t[i]) || (n[i] = t[i] === void 0 ? null : t[i]), n);
                      }, {});
                    return Object.keys(n).length > 0 ? n : void 0;
                  },
                  transform: function (e, t, n) {
                    if (typeof e != `object`) return t;
                    if (typeof t == `object`) {
                      if (!n) return t;
                      var r = Object.keys(t).reduce(function (n, r) {
                        return (e[r] === void 0 && (n[r] = t[r]), n);
                      }, {});
                      return Object.keys(r).length > 0 ? r : void 0;
                    }
                  },
                },
                iterator: function (e) {
                  return new o(e);
                },
                length: function (e) {
                  return typeof e.delete == `number`
                    ? e.delete
                    : typeof e.retain == `number`
                      ? e.retain
                      : typeof e.insert == `string`
                        ? e.insert.length
                        : 1;
                },
              };
            function o(e) {
              ((this.ops = e), (this.index = 0), (this.offset = 0));
            }
            ((o.prototype.hasNext = function () {
              return this.peekLength() < 1 / 0;
            }),
              (o.prototype.next = function (e) {
                e ||= 1 / 0;
                var t = this.ops[this.index];
                if (t) {
                  var n = this.offset,
                    r = a.length(t);
                  if (
                    (e >= r - n
                      ? ((e = r - n), (this.index += 1), (this.offset = 0))
                      : (this.offset += e),
                    typeof t.delete == `number`)
                  )
                    return {
                      delete: e,
                    };
                  var i = {};
                  return (
                    t.attributes && (i.attributes = t.attributes),
                    typeof t.retain == `number`
                      ? (i.retain = e)
                      : typeof t.insert == `string`
                        ? (i.insert = t.insert.substr(n, e))
                        : (i.insert = t.insert),
                    i
                  );
                } else
                  return {
                    retain: 1 / 0,
                  };
              }),
              (o.prototype.peek = function () {
                return this.ops[this.index];
              }),
              (o.prototype.peekLength = function () {
                return this.ops[this.index] ? a.length(this.ops[this.index]) - this.offset : 1 / 0;
              }),
              (o.prototype.peekType = function () {
                return this.ops[this.index]
                  ? typeof this.ops[this.index].delete == `number`
                    ? `delete`
                    : typeof this.ops[this.index].retain == `number`
                      ? `retain`
                      : `insert`
                  : `retain`;
              }),
              (o.prototype.rest = function () {
                if (!this.hasNext()) return [];
                if (this.offset === 0) return this.ops.slice(this.index);
                var e = this.offset,
                  t = this.index,
                  n = this.next(),
                  r = this.ops.slice(this.index);
                return ((this.offset = e), (this.index = t), [n].concat(r));
              }),
              (e.exports = a));
          },
          function (e, t) {
            var n = (function () {
              function e(e, t) {
                return t != null && e instanceof t;
              }
              var t;
              try {
                t = Map;
              } catch {
                t = function () {};
              }
              var n;
              try {
                n = Set;
              } catch {
                n = function () {};
              }
              var r;
              try {
                r = Promise;
              } catch {
                r = function () {};
              }
              function i(a, o, s, c, u) {
                typeof o == `object` &&
                  ((s = o.depth),
                  (c = o.prototype),
                  (u = o.includeNonEnumerable),
                  (o = o.circular));
                var d = [],
                  f = [],
                  p = typeof Buffer < `u`;
                (o === void 0 && (o = !0), s === void 0 && (s = 1 / 0));
                function m(a, s) {
                  if (a === null) return null;
                  if (s === 0) return a;
                  var h, g;
                  if (typeof a != `object`) return a;
                  if (e(a, t)) h = new t();
                  else if (e(a, n)) h = new n();
                  else if (e(a, r))
                    h = new r(function (e, t) {
                      a.then(
                        function (t) {
                          e(m(t, s - 1));
                        },
                        function (e) {
                          t(m(e, s - 1));
                        },
                      );
                    });
                  else if (i.__isArray(a)) h = [];
                  else if (i.__isRegExp(a))
                    ((h = new RegExp(a.source, l(a))), a.lastIndex && (h.lastIndex = a.lastIndex));
                  else if (i.__isDate(a)) h = new Date(a.getTime());
                  else if (p && Buffer.isBuffer(a))
                    return (
                      (h = Buffer.allocUnsafe
                        ? Buffer.allocUnsafe(a.length)
                        : new Buffer(a.length)),
                      a.copy(h),
                      h
                    );
                  else
                    e(a, Error)
                      ? (h = Object.create(a))
                      : c === void 0
                        ? ((g = Object.getPrototypeOf(a)), (h = Object.create(g)))
                        : ((h = Object.create(c)), (g = c));
                  if (o) {
                    var v = d.indexOf(a);
                    if (v != -1) return f[v];
                    (d.push(a), f.push(h));
                  }
                  for (var y in (e(a, t) &&
                    a.forEach(function (e, t) {
                      var n = m(t, s - 1),
                        r = m(e, s - 1);
                      h.set(n, r);
                    }),
                  e(a, n) &&
                    a.forEach(function (e) {
                      var t = m(e, s - 1);
                      h.add(t);
                    }),
                  a)) {
                    var b;
                    (g && (b = Object.getOwnPropertyDescriptor(g, y)),
                      !(b && b.set == null) && (h[y] = m(a[y], s - 1)));
                  }
                  if (Object.getOwnPropertySymbols)
                    for (var x = Object.getOwnPropertySymbols(a), y = 0; y < x.length; y++) {
                      var S = x[y],
                        C = Object.getOwnPropertyDescriptor(a, S);
                      (C && !C.enumerable && !u) ||
                        ((h[S] = m(a[S], s - 1)),
                        C.enumerable ||
                          Object.defineProperty(h, S, {
                            enumerable: !1,
                          }));
                    }
                  if (u)
                    for (var w = Object.getOwnPropertyNames(a), y = 0; y < w.length; y++) {
                      var T = w[y],
                        C = Object.getOwnPropertyDescriptor(a, T);
                      (C && C.enumerable) ||
                        ((h[T] = m(a[T], s - 1)),
                        Object.defineProperty(h, T, {
                          enumerable: !1,
                        }));
                    }
                  return h;
                }
                return m(a, s);
              }
              i.clonePrototype = function (e) {
                if (e === null) return null;
                var t = function () {};
                return ((t.prototype = e), new t());
              };
              function a(e) {
                return Object.prototype.toString.call(e);
              }
              i.__objToStr = a;
              function o(e) {
                return typeof e == `object` && a(e) === `[object Date]`;
              }
              i.__isDate = o;
              function s(e) {
                return typeof e == `object` && a(e) === `[object Array]`;
              }
              i.__isArray = s;
              function c(e) {
                return typeof e == `object` && a(e) === `[object RegExp]`;
              }
              i.__isRegExp = c;
              function l(e) {
                var t = ``;
                return (
                  e.global && (t += `g`),
                  e.ignoreCase && (t += `i`),
                  e.multiline && (t += `m`),
                  t
                );
              }
              return ((i.__getRegExpFlags = l), i);
            })();
            typeof e == `object` && e.exports && (e.exports = n);
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              i = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              a = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              o = p(n(0)),
              s = p(n(8)),
              c = n(4),
              l = p(c),
              u = p(n(16)),
              d = p(n(13)),
              f = p(n(25));
            function p(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function m(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function h(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function g(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            function v(e) {
              return e instanceof l.default || e instanceof c.BlockEmbed;
            }
            var y = (function (e) {
              g(t, e);
              function t(e, n) {
                m(this, t);
                var r = h(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return (
                  (r.emitter = n.emitter),
                  Array.isArray(n.whitelist) &&
                    (r.whitelist = n.whitelist.reduce(function (e, t) {
                      return ((e[t] = !0), e);
                    }, {})),
                  r.domNode.addEventListener(`DOMNodeInserted`, function () {}),
                  r.optimize(),
                  r.enable(),
                  r
                );
              }
              return (
                i(t, [
                  {
                    key: `batchStart`,
                    value: function () {
                      this.batch = !0;
                    },
                  },
                  {
                    key: `batchEnd`,
                    value: function () {
                      ((this.batch = !1), this.optimize());
                    },
                  },
                  {
                    key: `deleteAt`,
                    value: function (e, n) {
                      var i = r(this.line(e), 2),
                        o = i[0],
                        s = i[1],
                        l = r(this.line(e + n), 1)[0];
                      if (
                        (a(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `deleteAt`,
                          this,
                        ).call(this, e, n),
                        l != null && o !== l && s > 0)
                      ) {
                        if (o instanceof c.BlockEmbed || l instanceof c.BlockEmbed) {
                          this.optimize();
                          return;
                        }
                        if (o instanceof d.default) {
                          var f = o.newlineIndex(o.length(), !0);
                          if (f > -1 && ((o = o.split(f + 1)), o === l)) {
                            this.optimize();
                            return;
                          }
                        } else if (l instanceof d.default) {
                          var p = l.newlineIndex(0);
                          p > -1 && l.split(p + 1);
                        }
                        var m = l.children.head instanceof u.default ? null : l.children.head;
                        (o.moveChildren(l, m), o.remove());
                      }
                      this.optimize();
                    },
                  },
                  {
                    key: `enable`,
                    value: function () {
                      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                      this.domNode.setAttribute(`contenteditable`, e);
                    },
                  },
                  {
                    key: `formatAt`,
                    value: function (e, n, r, i) {
                      (this.whitelist != null && !this.whitelist[r]) ||
                        (a(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `formatAt`,
                          this,
                        ).call(this, e, n, r, i),
                        this.optimize());
                    },
                  },
                  {
                    key: `insertAt`,
                    value: function (e, n, r) {
                      if (!(r != null && this.whitelist != null && !this.whitelist[n])) {
                        if (e >= this.length()) {
                          if (r == null || o.default.query(n, o.default.Scope.BLOCK) == null) {
                            var i = o.default.create(this.statics.defaultChild);
                            (this.appendChild(i),
                              r == null &&
                                n.endsWith(`
`) &&
                                (n = n.slice(0, -1)),
                              i.insertAt(0, n, r));
                          } else {
                            var s = o.default.create(n, r);
                            this.appendChild(s);
                          }
                        } else
                          a(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `insertAt`,
                            this,
                          ).call(this, e, n, r);
                        this.optimize();
                      }
                    },
                  },
                  {
                    key: `insertBefore`,
                    value: function (e, n) {
                      if (e.statics.scope === o.default.Scope.INLINE_BLOT) {
                        var r = o.default.create(this.statics.defaultChild);
                        (r.appendChild(e), (e = r));
                      }
                      a(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `insertBefore`,
                        this,
                      ).call(this, e, n);
                    },
                  },
                  {
                    key: `leaf`,
                    value: function (e) {
                      return this.path(e).pop() || [null, -1];
                    },
                  },
                  {
                    key: `line`,
                    value: function (e) {
                      return e === this.length() ? this.line(e - 1) : this.descendant(v, e);
                    },
                  },
                  {
                    key: `lines`,
                    value: function () {
                      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0,
                        t =
                          arguments.length > 1 && arguments[1] !== void 0
                            ? arguments[1]
                            : Number.MAX_VALUE;
                      return (function e(t, n, r) {
                        var i = [],
                          a = r;
                        return (
                          t.children.forEachAt(n, r, function (t, n, r) {
                            (v(t)
                              ? i.push(t)
                              : t instanceof o.default.Container && (i = i.concat(e(t, n, a))),
                              (a -= r));
                          }),
                          i
                        );
                      })(this, e, t);
                    },
                  },
                  {
                    key: `optimize`,
                    value: function () {
                      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [],
                        n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                      this.batch !== !0 &&
                        (a(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `optimize`,
                          this,
                        ).call(this, e, n),
                        e.length > 0 && this.emitter.emit(s.default.events.SCROLL_OPTIMIZE, e, n));
                    },
                  },
                  {
                    key: `path`,
                    value: function (e) {
                      return a(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `path`,
                        this,
                      )
                        .call(this, e)
                        .slice(1);
                    },
                  },
                  {
                    key: `update`,
                    value: function (e) {
                      if (this.batch !== !0) {
                        var n = s.default.sources.USER;
                        (typeof e == `string` && (n = e),
                          Array.isArray(e) || (e = this.observer.takeRecords()),
                          e.length > 0 &&
                            this.emitter.emit(s.default.events.SCROLL_BEFORE_UPDATE, n, e),
                          a(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `update`,
                            this,
                          ).call(this, e.concat([])),
                          e.length > 0 && this.emitter.emit(s.default.events.SCROLL_UPDATE, n, e));
                      }
                    },
                  },
                ]),
                t
              );
            })(o.default.Scroll);
            ((y.blotName = `scroll`),
              (y.className = `ql-editor`),
              (y.tagName = `DIV`),
              (y.defaultChild = `block`),
              (y.allowedChildren = [l.default, c.BlockEmbed, f.default]),
              (t.default = y));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.SHORTKEY = t.default = void 0));
            var r =
                typeof Symbol == `function` && typeof Symbol.iterator == `symbol`
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        typeof Symbol == `function` &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? `symbol`
                        : typeof e;
                    },
              i = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              a = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              o = h(n(21)),
              s = h(n(11)),
              c = h(n(3)),
              l = h(n(2)),
              u = h(n(20)),
              d = h(n(0)),
              f = h(n(5)),
              p = h(n(10)),
              m = h(n(9));
            function h(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function g(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function v(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function y(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function b(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var x = (0, p.default)(`quill:keyboard`),
              S = /Mac/i.test(navigator.platform) ? `metaKey` : `ctrlKey`,
              C = (function (e) {
                (b(t, e),
                  a(t, null, [
                    {
                      key: `match`,
                      value: function (e, t) {
                        return (
                          (t = k(t)),
                          [`altKey`, `ctrlKey`, `metaKey`, `shiftKey`].some(function (n) {
                            return !!t[n] !== e[n] && t[n] !== null;
                          })
                            ? !1
                            : t.key === (e.which || e.keyCode)
                        );
                      },
                    },
                  ]));
                function t(e, n) {
                  v(this, t);
                  var r = y(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                  return (
                    (r.bindings = {}),
                    Object.keys(r.options.bindings).forEach(function (t) {
                      (t === `list autofill` &&
                        e.scroll.whitelist != null &&
                        !e.scroll.whitelist.list) ||
                        (r.options.bindings[t] && r.addBinding(r.options.bindings[t]));
                    }),
                    r.addBinding(
                      {
                        key: t.keys.ENTER,
                        shiftKey: null,
                      },
                      ee,
                    ),
                    r.addBinding(
                      {
                        key: t.keys.ENTER,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null,
                      },
                      function () {},
                    ),
                    /Firefox/i.test(navigator.userAgent)
                      ? (r.addBinding(
                          {
                            key: t.keys.BACKSPACE,
                          },
                          {
                            collapsed: !0,
                          },
                          T,
                        ),
                        r.addBinding(
                          {
                            key: t.keys.DELETE,
                          },
                          {
                            collapsed: !0,
                          },
                          E,
                        ))
                      : (r.addBinding(
                          {
                            key: t.keys.BACKSPACE,
                          },
                          {
                            collapsed: !0,
                            prefix: /^.?$/,
                          },
                          T,
                        ),
                        r.addBinding(
                          {
                            key: t.keys.DELETE,
                          },
                          {
                            collapsed: !0,
                            suffix: /^.?$/,
                          },
                          E,
                        )),
                    r.addBinding(
                      {
                        key: t.keys.BACKSPACE,
                      },
                      {
                        collapsed: !1,
                      },
                      D,
                    ),
                    r.addBinding(
                      {
                        key: t.keys.DELETE,
                      },
                      {
                        collapsed: !1,
                      },
                      D,
                    ),
                    r.addBinding(
                      {
                        key: t.keys.BACKSPACE,
                        altKey: null,
                        ctrlKey: null,
                        metaKey: null,
                        shiftKey: null,
                      },
                      {
                        collapsed: !0,
                        offset: 0,
                      },
                      T,
                    ),
                    r.listen(),
                    r
                  );
                }
                return (
                  a(t, [
                    {
                      key: `addBinding`,
                      value: function (e) {
                        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                          n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
                          r = k(e);
                        if (r == null || r.key == null)
                          return x.warn(`Attempted to add invalid keyboard binding`, r);
                        (typeof t == `function` &&
                          (t = {
                            handler: t,
                          }),
                          typeof n == `function` &&
                            (n = {
                              handler: n,
                            }),
                          (r = (0, c.default)(r, t, n)),
                          (this.bindings[r.key] = this.bindings[r.key] || []),
                          this.bindings[r.key].push(r));
                      },
                    },
                    {
                      key: `listen`,
                      value: function () {
                        var e = this;
                        this.quill.root.addEventListener(`keydown`, function (n) {
                          if (!n.defaultPrevented) {
                            var a = n.which || n.keyCode,
                              o = (e.bindings[a] || []).filter(function (e) {
                                return t.match(n, e);
                              });
                            if (o.length !== 0) {
                              var c = e.quill.getSelection();
                              if (!(c == null || !e.quill.hasFocus())) {
                                var l = i(e.quill.getLine(c.index), 2),
                                  u = l[0],
                                  f = l[1],
                                  p = i(e.quill.getLeaf(c.index), 2),
                                  m = p[0],
                                  h = p[1],
                                  g = i(
                                    c.length === 0 ? [m, h] : e.quill.getLeaf(c.index + c.length),
                                    2,
                                  ),
                                  v = g[0],
                                  y = g[1],
                                  b = m instanceof d.default.Text ? m.value().slice(0, h) : ``,
                                  x = v instanceof d.default.Text ? v.value().slice(y) : ``,
                                  S = {
                                    collapsed: c.length === 0,
                                    empty: c.length === 0 && u.length() <= 1,
                                    format: e.quill.getFormat(c),
                                    offset: f,
                                    prefix: b,
                                    suffix: x,
                                  };
                                o.some(function (t) {
                                  if (
                                    (t.collapsed != null && t.collapsed !== S.collapsed) ||
                                    (t.empty != null && t.empty !== S.empty) ||
                                    (t.offset != null && t.offset !== S.offset)
                                  )
                                    return !1;
                                  if (Array.isArray(t.format)) {
                                    if (
                                      t.format.every(function (e) {
                                        return S.format[e] == null;
                                      })
                                    )
                                      return !1;
                                  } else if (
                                    r(t.format) === `object` &&
                                    !Object.keys(t.format).every(function (e) {
                                      return t.format[e] === !0
                                        ? S.format[e] != null
                                        : t.format[e] === !1
                                          ? S.format[e] == null
                                          : (0, s.default)(t.format[e], S.format[e]);
                                    })
                                  )
                                    return !1;
                                  return (t.prefix != null && !t.prefix.test(S.prefix)) ||
                                    (t.suffix != null && !t.suffix.test(S.suffix))
                                    ? !1
                                    : t.handler.call(e, c, S) !== !0;
                                }) && n.preventDefault();
                              }
                            }
                          }
                        });
                      },
                    },
                  ]),
                  t
                );
              })(m.default);
            ((C.keys = {
              BACKSPACE: 8,
              TAB: 9,
              ENTER: 13,
              ESCAPE: 27,
              LEFT: 37,
              UP: 38,
              RIGHT: 39,
              DOWN: 40,
              DELETE: 46,
            }),
              (C.DEFAULTS = {
                bindings: {
                  bold: O(`bold`),
                  italic: O(`italic`),
                  underline: O(`underline`),
                  indent: {
                    key: C.keys.TAB,
                    format: [`blockquote`, `indent`, `list`],
                    handler: function (e, t) {
                      if (t.collapsed && t.offset !== 0) return !0;
                      this.quill.format(`indent`, `+1`, f.default.sources.USER);
                    },
                  },
                  outdent: {
                    key: C.keys.TAB,
                    shiftKey: !0,
                    format: [`blockquote`, `indent`, `list`],
                    handler: function (e, t) {
                      if (t.collapsed && t.offset !== 0) return !0;
                      this.quill.format(`indent`, `-1`, f.default.sources.USER);
                    },
                  },
                  "outdent backspace": {
                    key: C.keys.BACKSPACE,
                    collapsed: !0,
                    shiftKey: null,
                    metaKey: null,
                    ctrlKey: null,
                    altKey: null,
                    format: [`indent`, `list`],
                    offset: 0,
                    handler: function (e, t) {
                      t.format.indent == null
                        ? t.format.list != null &&
                          this.quill.format(`list`, !1, f.default.sources.USER)
                        : this.quill.format(`indent`, `-1`, f.default.sources.USER);
                    },
                  },
                  "indent code-block": te(!0),
                  "outdent code-block": te(!1),
                  "remove tab": {
                    key: C.keys.TAB,
                    shiftKey: !0,
                    collapsed: !0,
                    prefix: /\t$/,
                    handler: function (e) {
                      this.quill.deleteText(e.index - 1, 1, f.default.sources.USER);
                    },
                  },
                  tab: {
                    key: C.keys.TAB,
                    handler: function (e) {
                      this.quill.history.cutoff();
                      var t = new l.default().retain(e.index).delete(e.length).insert(`	`);
                      (this.quill.updateContents(t, f.default.sources.USER),
                        this.quill.history.cutoff(),
                        this.quill.setSelection(e.index + 1, f.default.sources.SILENT));
                    },
                  },
                  "list empty enter": {
                    key: C.keys.ENTER,
                    collapsed: !0,
                    format: [`list`],
                    empty: !0,
                    handler: function (e, t) {
                      (this.quill.format(`list`, !1, f.default.sources.USER),
                        t.format.indent && this.quill.format(`indent`, !1, f.default.sources.USER));
                    },
                  },
                  "checklist enter": {
                    key: C.keys.ENTER,
                    collapsed: !0,
                    format: {
                      list: `checked`,
                    },
                    handler: function (e) {
                      var t = i(this.quill.getLine(e.index), 2),
                        n = t[0],
                        r = t[1],
                        a = (0, c.default)({}, n.formats(), {
                          list: `checked`,
                        }),
                        o = new l.default()
                          .retain(e.index)
                          .insert(
                            `
`,
                            a,
                          )
                          .retain(n.length() - r - 1)
                          .retain(1, {
                            list: `unchecked`,
                          });
                      (this.quill.updateContents(o, f.default.sources.USER),
                        this.quill.setSelection(e.index + 1, f.default.sources.SILENT),
                        this.quill.scrollIntoView());
                    },
                  },
                  "header enter": {
                    key: C.keys.ENTER,
                    collapsed: !0,
                    format: [`header`],
                    suffix: /^$/,
                    handler: function (e, t) {
                      var n = i(this.quill.getLine(e.index), 2),
                        r = n[0],
                        a = n[1],
                        o = new l.default()
                          .retain(e.index)
                          .insert(
                            `
`,
                            t.format,
                          )
                          .retain(r.length() - a - 1)
                          .retain(1, {
                            header: null,
                          });
                      (this.quill.updateContents(o, f.default.sources.USER),
                        this.quill.setSelection(e.index + 1, f.default.sources.SILENT),
                        this.quill.scrollIntoView());
                    },
                  },
                  "list autofill": {
                    key: ` `,
                    collapsed: !0,
                    format: {
                      list: !1,
                    },
                    prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                    handler: function (e, t) {
                      var n = t.prefix.length,
                        r = i(this.quill.getLine(e.index), 2),
                        a = r[0],
                        o = r[1];
                      if (o > n) return !0;
                      var s = void 0;
                      switch (t.prefix.trim()) {
                        case `[]`:
                        case `[ ]`:
                          s = `unchecked`;
                          break;
                        case `[x]`:
                          s = `checked`;
                          break;
                        case `-`:
                        case `*`:
                          s = `bullet`;
                          break;
                        default:
                          s = `ordered`;
                      }
                      (this.quill.insertText(e.index, ` `, f.default.sources.USER),
                        this.quill.history.cutoff());
                      var c = new l.default()
                        .retain(e.index - o)
                        .delete(n + 1)
                        .retain(a.length() - 2 - o)
                        .retain(1, {
                          list: s,
                        });
                      (this.quill.updateContents(c, f.default.sources.USER),
                        this.quill.history.cutoff(),
                        this.quill.setSelection(e.index - n, f.default.sources.SILENT));
                    },
                  },
                  "code exit": {
                    key: C.keys.ENTER,
                    collapsed: !0,
                    format: [`code-block`],
                    prefix: /\n\n$/,
                    suffix: /^\s+$/,
                    handler: function (e) {
                      var t = i(this.quill.getLine(e.index), 2),
                        n = t[0],
                        r = t[1],
                        a = new l.default()
                          .retain(e.index + n.length() - r - 2)
                          .retain(1, {
                            "code-block": null,
                          })
                          .delete(1);
                      this.quill.updateContents(a, f.default.sources.USER);
                    },
                  },
                  "embed left": w(C.keys.LEFT, !1),
                  "embed left shift": w(C.keys.LEFT, !0),
                  "embed right": w(C.keys.RIGHT, !1),
                  "embed right shift": w(C.keys.RIGHT, !0),
                },
              }));
            function w(e, t) {
              var n,
                r = e === C.keys.LEFT ? `prefix` : `suffix`;
              return (
                (n = {
                  key: e,
                  shiftKey: t,
                  altKey: null,
                }),
                g(n, r, /^$/),
                g(n, `handler`, function (n) {
                  var r = n.index;
                  return (
                    e === C.keys.RIGHT && (r += n.length + 1),
                    i(this.quill.getLeaf(r), 1)[0] instanceof d.default.Embed
                      ? (e === C.keys.LEFT
                          ? t
                            ? this.quill.setSelection(
                                n.index - 1,
                                n.length + 1,
                                f.default.sources.USER,
                              )
                            : this.quill.setSelection(n.index - 1, f.default.sources.USER)
                          : t
                            ? this.quill.setSelection(n.index, n.length + 1, f.default.sources.USER)
                            : this.quill.setSelection(
                                n.index + n.length + 1,
                                f.default.sources.USER,
                              ),
                        !1)
                      : !0
                  );
                }),
                n
              );
            }
            function T(e, t) {
              if (!(e.index === 0 || this.quill.getLength() <= 1)) {
                var n = i(this.quill.getLine(e.index), 1)[0],
                  r = {};
                if (t.offset === 0) {
                  var a = i(this.quill.getLine(e.index - 1), 1)[0];
                  if (a != null && a.length() > 1) {
                    var o = n.formats(),
                      s = this.quill.getFormat(e.index - 1, 1);
                    r = u.default.attributes.diff(o, s) || {};
                  }
                }
                var c = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(t.prefix) ? 2 : 1;
                (this.quill.deleteText(e.index - c, c, f.default.sources.USER),
                  Object.keys(r).length > 0 &&
                    this.quill.formatLine(e.index - c, c, r, f.default.sources.USER),
                  this.quill.focus());
              }
            }
            function E(e, t) {
              var n = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(t.suffix) ? 2 : 1;
              if (!(e.index >= this.quill.getLength() - n)) {
                var r = {},
                  a = 0,
                  o = i(this.quill.getLine(e.index), 1)[0];
                if (t.offset >= o.length() - 1) {
                  var s = i(this.quill.getLine(e.index + 1), 1)[0];
                  if (s) {
                    var c = o.formats(),
                      l = this.quill.getFormat(e.index, 1);
                    ((r = u.default.attributes.diff(c, l) || {}), (a = s.length()));
                  }
                }
                (this.quill.deleteText(e.index, n, f.default.sources.USER),
                  Object.keys(r).length > 0 &&
                    this.quill.formatLine(e.index + a - 1, n, r, f.default.sources.USER));
              }
            }
            function D(e) {
              var t = this.quill.getLines(e),
                n = {};
              if (t.length > 1) {
                var r = t[0].formats(),
                  i = t[t.length - 1].formats();
                n = u.default.attributes.diff(i, r) || {};
              }
              (this.quill.deleteText(e, f.default.sources.USER),
                Object.keys(n).length > 0 &&
                  this.quill.formatLine(e.index, 1, n, f.default.sources.USER),
                this.quill.setSelection(e.index, f.default.sources.SILENT),
                this.quill.focus());
            }
            function ee(e, t) {
              var n = this;
              e.length > 0 && this.quill.scroll.deleteAt(e.index, e.length);
              var r = Object.keys(t.format).reduce(function (e, n) {
                return (
                  d.default.query(n, d.default.Scope.BLOCK) &&
                    !Array.isArray(t.format[n]) &&
                    (e[n] = t.format[n]),
                  e
                );
              }, {});
              (this.quill.insertText(
                e.index,
                `
`,
                r,
                f.default.sources.USER,
              ),
                this.quill.setSelection(e.index + 1, f.default.sources.SILENT),
                this.quill.focus(),
                Object.keys(t.format).forEach(function (e) {
                  r[e] ??
                    (Array.isArray(t.format[e]) ||
                      (e !== `link` && n.quill.format(e, t.format[e], f.default.sources.USER)));
                }));
            }
            function te(e) {
              return {
                key: C.keys.TAB,
                shiftKey: !e,
                format: {
                  "code-block": !0,
                },
                handler: function (t) {
                  var n = d.default.query(`code-block`),
                    r = t.index,
                    a = t.length,
                    o = i(this.quill.scroll.descendant(n, r), 2),
                    s = o[0],
                    c = o[1];
                  if (s != null) {
                    var l = this.quill.getIndex(s),
                      u = s.newlineIndex(c, !0) + 1,
                      p = s.newlineIndex(l + c + a),
                      m = s.domNode.textContent.slice(u, p).split(`
`);
                    ((c = 0),
                      m.forEach(function (t, i) {
                        (e
                          ? (s.insertAt(u + c, n.TAB),
                            (c += n.TAB.length),
                            i === 0 ? (r += n.TAB.length) : (a += n.TAB.length))
                          : t.startsWith(n.TAB) &&
                            (s.deleteAt(u + c, n.TAB.length),
                            (c -= n.TAB.length),
                            i === 0 ? (r -= n.TAB.length) : (a -= n.TAB.length)),
                          (c += t.length + 1));
                      }),
                      this.quill.update(f.default.sources.USER),
                      this.quill.setSelection(r, a, f.default.sources.SILENT));
                  }
                },
              };
            }
            function O(e) {
              return {
                key: e[0].toUpperCase(),
                shortKey: !0,
                handler: function (t, n) {
                  this.quill.format(e, !n.format[e], f.default.sources.USER);
                },
              };
            }
            function k(e) {
              if (typeof e == `string` || typeof e == `number`)
                return k({
                  key: e,
                });
              if (
                ((e === void 0 ? `undefined` : r(e)) === `object` && (e = (0, o.default)(e, !1)),
                typeof e.key == `string`)
              )
                if (C.keys[e.key.toUpperCase()] != null) e.key = C.keys[e.key.toUpperCase()];
                else if (e.key.length === 1) e.key = e.key.toUpperCase().charCodeAt(0);
                else return null;
              return (e.shortKey && ((e[S] = e.shortKey), delete e.shortKey), e);
            }
            ((t.default = C), (t.SHORTKEY = S));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              o = c(n(0)),
              s = c(n(7));
            function c(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function l(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function u(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function d(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var f = (function (e) {
              (d(t, e),
                a(t, null, [
                  {
                    key: `value`,
                    value: function () {},
                  },
                ]));
              function t(e, n) {
                l(this, t);
                var r = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return (
                  (r.selection = n),
                  (r.textNode = document.createTextNode(t.CONTENTS)),
                  r.domNode.appendChild(r.textNode),
                  (r._length = 0),
                  r
                );
              }
              return (
                a(t, [
                  {
                    key: `detach`,
                    value: function () {
                      this.parent != null && this.parent.removeChild(this);
                    },
                  },
                  {
                    key: `format`,
                    value: function (e, n) {
                      if (this._length !== 0)
                        return i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `format`,
                          this,
                        ).call(this, e, n);
                      for (
                        var r = this, a = 0;
                        r != null && r.statics.scope !== o.default.Scope.BLOCK_BLOT;
                      )
                        ((a += r.offset(r.parent)), (r = r.parent));
                      r != null &&
                        ((this._length = t.CONTENTS.length),
                        r.optimize(),
                        r.formatAt(a, t.CONTENTS.length, e, n),
                        (this._length = 0));
                    },
                  },
                  {
                    key: `index`,
                    value: function (e, n) {
                      return e === this.textNode
                        ? 0
                        : i(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `index`,
                            this,
                          ).call(this, e, n);
                    },
                  },
                  {
                    key: `length`,
                    value: function () {
                      return this._length;
                    },
                  },
                  {
                    key: `position`,
                    value: function () {
                      return [this.textNode, this.textNode.data.length];
                    },
                  },
                  {
                    key: `remove`,
                    value: function () {
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `remove`,
                        this,
                      ).call(this),
                        (this.parent = null));
                    },
                  },
                  {
                    key: `restore`,
                    value: function () {
                      if (!(this.selection.composing || this.parent == null)) {
                        var e = this.textNode,
                          n = this.selection.getNativeRange(),
                          i = void 0,
                          a = void 0,
                          c = void 0;
                        if (n != null && n.start.node === e && n.end.node === e) {
                          var l = [e, n.start.offset, n.end.offset];
                          ((i = l[0]), (a = l[1]), (c = l[2]));
                        }
                        for (
                          ;
                          this.domNode.lastChild != null &&
                          this.domNode.lastChild !== this.textNode;
                        )
                          this.domNode.parentNode.insertBefore(
                            this.domNode.lastChild,
                            this.domNode,
                          );
                        if (this.textNode.data !== t.CONTENTS) {
                          var u = this.textNode.data.split(t.CONTENTS).join(``);
                          this.next instanceof s.default
                            ? ((i = this.next.domNode),
                              this.next.insertAt(0, u),
                              (this.textNode.data = t.CONTENTS))
                            : ((this.textNode.data = u),
                              this.parent.insertBefore(o.default.create(this.textNode), this),
                              (this.textNode = document.createTextNode(t.CONTENTS)),
                              this.domNode.appendChild(this.textNode));
                        }
                        if ((this.remove(), a != null)) {
                          var d = r(
                            [a, c].map(function (e) {
                              return Math.max(0, Math.min(i.data.length, e - 1));
                            }),
                            2,
                          );
                          return (
                            (a = d[0]),
                            (c = d[1]),
                            {
                              startNode: i,
                              startOffset: a,
                              endNode: i,
                              endOffset: c,
                            }
                          );
                        }
                      }
                    },
                  },
                  {
                    key: `update`,
                    value: function (e, t) {
                      var n = this;
                      if (
                        e.some(function (e) {
                          return e.type === `characterData` && e.target === n.textNode;
                        })
                      ) {
                        var r = this.restore();
                        r && (t.range = r);
                      }
                    },
                  },
                  {
                    key: `value`,
                    value: function () {
                      return ``;
                    },
                  },
                ]),
                t
              );
            })(o.default.Embed);
            ((f.blotName = `cursor`),
              (f.className = `ql-cursor`),
              (f.tagName = `span`),
              (f.CONTENTS = `﻿`),
              (t.default = f));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = o(n(0)),
              i = n(4),
              a = o(i);
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var u = (function (e) {
              l(t, e);
              function t() {
                return (
                  s(this, t),
                  c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return t;
            })(r.default.Container);
            ((u.allowedChildren = [a.default, i.BlockEmbed, u]), (t.default = u));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.ColorStyle = t.ColorClass = t.ColorAttributor = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(0));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var u = (function (e) {
                l(t, e);
                function t() {
                  return (
                    s(this, t),
                    c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                  );
                }
                return (
                  r(t, [
                    {
                      key: `value`,
                      value: function (e) {
                        var n = i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `value`,
                          this,
                        ).call(this, e);
                        return n.startsWith(`rgb(`)
                          ? ((n = n.replace(/^[^\d]+/, ``).replace(/[^\d]+$/, ``)),
                            `#` +
                              n
                                .split(`,`)
                                .map(function (e) {
                                  return (`00` + parseInt(e).toString(16)).slice(-2);
                                })
                                .join(``))
                          : n;
                      },
                    },
                  ]),
                  t
                );
              })(a.default.Attributor.Style),
              d = new a.default.Attributor.Class(`color`, `ql-color`, {
                scope: a.default.Scope.INLINE,
              }),
              f = new u(`color`, `color`, {
                scope: a.default.Scope.INLINE,
              });
            ((t.ColorAttributor = u), (t.ColorClass = d), (t.ColorStyle = f));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.sanitize = t.default = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(6));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var u = (function (e) {
              l(t, e);
              function t() {
                return (
                  s(this, t),
                  c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(
                  t,
                  [
                    {
                      key: `format`,
                      value: function (e, n) {
                        if (e !== this.statics.blotName || !n)
                          return i(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `format`,
                            this,
                          ).call(this, e, n);
                        ((n = this.constructor.sanitize(n)), this.domNode.setAttribute(`href`, n));
                      },
                    },
                  ],
                  [
                    {
                      key: `create`,
                      value: function (e) {
                        var n = i(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                          this,
                          e,
                        );
                        return (
                          (e = this.sanitize(e)),
                          n.setAttribute(`href`, e),
                          n.setAttribute(`rel`, `noopener noreferrer`),
                          n.setAttribute(`target`, `_blank`),
                          n
                        );
                      },
                    },
                    {
                      key: `formats`,
                      value: function (e) {
                        return e.getAttribute(`href`);
                      },
                    },
                    {
                      key: `sanitize`,
                      value: function (e) {
                        return d(e, this.PROTOCOL_WHITELIST) ? e : this.SANITIZED_URL;
                      },
                    },
                  ],
                ),
                t
              );
            })(a.default);
            ((u.blotName = `link`),
              (u.tagName = `A`),
              (u.SANITIZED_URL = `about:blank`),
              (u.PROTOCOL_WHITELIST = [`http`, `https`, `mailto`, `tel`]));
            function d(e, t) {
              var n = document.createElement(`a`);
              n.href = e;
              var r = n.href.slice(0, n.href.indexOf(`:`));
              return t.indexOf(r) > -1;
            }
            ((t.default = u), (t.sanitize = d));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r =
                typeof Symbol == `function` && typeof Symbol.iterator == `symbol`
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        typeof Symbol == `function` &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? `symbol`
                        : typeof e;
                    },
              i = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              a = s(n(23)),
              o = s(n(107));
            function s(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function c(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            var l = 0;
            function u(e, t) {
              e.setAttribute(t, e.getAttribute(t) !== `true`);
            }
            t.default = (function () {
              function e(t) {
                var n = this;
                (c(this, e),
                  (this.select = t),
                  (this.container = document.createElement(`span`)),
                  this.buildPicker(),
                  (this.select.style.display = `none`),
                  this.select.parentNode.insertBefore(this.container, this.select),
                  this.label.addEventListener(`mousedown`, function () {
                    n.togglePicker();
                  }),
                  this.label.addEventListener(`keydown`, function (e) {
                    switch (e.keyCode) {
                      case a.default.keys.ENTER:
                        n.togglePicker();
                        break;
                      case a.default.keys.ESCAPE:
                        (n.escape(), e.preventDefault());
                        break;
                      default:
                    }
                  }),
                  this.select.addEventListener(`change`, this.update.bind(this)));
              }
              return (
                i(e, [
                  {
                    key: `togglePicker`,
                    value: function () {
                      (this.container.classList.toggle(`ql-expanded`),
                        u(this.label, `aria-expanded`),
                        u(this.options, `aria-hidden`));
                    },
                  },
                  {
                    key: `buildItem`,
                    value: function (e) {
                      var t = this,
                        n = document.createElement(`span`);
                      return (
                        (n.tabIndex = `0`),
                        n.setAttribute(`role`, `button`),
                        n.classList.add(`ql-picker-item`),
                        e.hasAttribute(`value`) &&
                          n.setAttribute(`data-value`, e.getAttribute(`value`)),
                        e.textContent && n.setAttribute(`data-label`, e.textContent),
                        n.addEventListener(`click`, function () {
                          t.selectItem(n, !0);
                        }),
                        n.addEventListener(`keydown`, function (e) {
                          switch (e.keyCode) {
                            case a.default.keys.ENTER:
                              (t.selectItem(n, !0), e.preventDefault());
                              break;
                            case a.default.keys.ESCAPE:
                              (t.escape(), e.preventDefault());
                              break;
                            default:
                          }
                        }),
                        n
                      );
                    },
                  },
                  {
                    key: `buildLabel`,
                    value: function () {
                      var e = document.createElement(`span`);
                      return (
                        e.classList.add(`ql-picker-label`),
                        (e.innerHTML = o.default),
                        (e.tabIndex = `0`),
                        e.setAttribute(`role`, `button`),
                        e.setAttribute(`aria-expanded`, `false`),
                        this.container.appendChild(e),
                        e
                      );
                    },
                  },
                  {
                    key: `buildOptions`,
                    value: function () {
                      var e = this,
                        t = document.createElement(`span`);
                      (t.classList.add(`ql-picker-options`),
                        t.setAttribute(`aria-hidden`, `true`),
                        (t.tabIndex = `-1`),
                        (t.id = `ql-picker-options-` + l),
                        (l += 1),
                        this.label.setAttribute(`aria-controls`, t.id),
                        (this.options = t),
                        [].slice.call(this.select.options).forEach(function (n) {
                          var r = e.buildItem(n);
                          (t.appendChild(r), n.selected === !0 && e.selectItem(r));
                        }),
                        this.container.appendChild(t));
                    },
                  },
                  {
                    key: `buildPicker`,
                    value: function () {
                      var e = this;
                      ([].slice.call(this.select.attributes).forEach(function (t) {
                        e.container.setAttribute(t.name, t.value);
                      }),
                        this.container.classList.add(`ql-picker`),
                        (this.label = this.buildLabel()),
                        this.buildOptions());
                    },
                  },
                  {
                    key: `escape`,
                    value: function () {
                      var e = this;
                      (this.close(),
                        setTimeout(function () {
                          return e.label.focus();
                        }, 1));
                    },
                  },
                  {
                    key: `close`,
                    value: function () {
                      (this.container.classList.remove(`ql-expanded`),
                        this.label.setAttribute(`aria-expanded`, `false`),
                        this.options.setAttribute(`aria-hidden`, `true`));
                    },
                  },
                  {
                    key: `selectItem`,
                    value: function (e) {
                      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1,
                        n = this.container.querySelector(`.ql-selected`);
                      if (
                        e !== n &&
                        (n?.classList.remove(`ql-selected`),
                        e != null &&
                          (e.classList.add(`ql-selected`),
                          (this.select.selectedIndex = [].indexOf.call(e.parentNode.children, e)),
                          e.hasAttribute(`data-value`)
                            ? this.label.setAttribute(`data-value`, e.getAttribute(`data-value`))
                            : this.label.removeAttribute(`data-value`),
                          e.hasAttribute(`data-label`)
                            ? this.label.setAttribute(`data-label`, e.getAttribute(`data-label`))
                            : this.label.removeAttribute(`data-label`),
                          t))
                      ) {
                        if (typeof Event == `function`)
                          this.select.dispatchEvent(new Event(`change`));
                        else if ((typeof Event > `u` ? `undefined` : r(Event)) === `object`) {
                          var i = document.createEvent(`Event`);
                          (i.initEvent(`change`, !0, !0), this.select.dispatchEvent(i));
                        }
                        this.close();
                      }
                    },
                  },
                  {
                    key: `update`,
                    value: function () {
                      var e = void 0;
                      if (this.select.selectedIndex > -1) {
                        var t =
                          this.container.querySelector(`.ql-picker-options`).children[
                            this.select.selectedIndex
                          ];
                        ((e = this.select.options[this.select.selectedIndex]), this.selectItem(t));
                      } else this.selectItem(null);
                      var n = e != null && e !== this.select.querySelector(`option[selected]`);
                      this.label.classList.toggle(`ql-active`, n);
                    },
                  },
                ]),
                e
              );
            })();
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = v(n(0)),
              i = v(n(5)),
              a = n(4),
              o = v(a),
              s = v(n(16)),
              c = v(n(25)),
              l = v(n(24)),
              u = v(n(35)),
              d = v(n(6)),
              f = v(n(22)),
              p = v(n(7)),
              m = v(n(55)),
              h = v(n(42)),
              g = v(n(23));
            function v(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            (i.default.register({
              "blots/block": o.default,
              "blots/block/embed": a.BlockEmbed,
              "blots/break": s.default,
              "blots/container": c.default,
              "blots/cursor": l.default,
              "blots/embed": u.default,
              "blots/inline": d.default,
              "blots/scroll": f.default,
              "blots/text": p.default,
              "modules/clipboard": m.default,
              "modules/history": h.default,
              "modules/keyboard": g.default,
            }),
              r.default.register(o.default, s.default, l.default, d.default, f.default, p.default),
              (t.default = i.default));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = n(1);
            t.default = (function () {
              function e(e) {
                ((this.domNode = e),
                  (this.domNode[r.DATA_KEY] = {
                    blot: this,
                  }));
              }
              return (
                Object.defineProperty(e.prototype, "statics", {
                  get: function () {
                    return this.constructor;
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                (e.create = function (e) {
                  if (this.tagName == null)
                    throw new r.ParchmentError(`Blot definition missing tagName`);
                  var t;
                  return (
                    Array.isArray(this.tagName)
                      ? (typeof e == `string` &&
                          ((e = e.toUpperCase()),
                          parseInt(e).toString() === e && (e = parseInt(e))),
                        (t =
                          typeof e == `number`
                            ? document.createElement(this.tagName[e - 1])
                            : this.tagName.indexOf(e) > -1
                              ? document.createElement(e)
                              : document.createElement(this.tagName[0])))
                      : (t = document.createElement(this.tagName)),
                    this.className && t.classList.add(this.className),
                    t
                  );
                }),
                (e.prototype.attach = function () {
                  this.parent != null && (this.scroll = this.parent.scroll);
                }),
                (e.prototype.clone = function () {
                  var e = this.domNode.cloneNode(!1);
                  return r.create(e);
                }),
                (e.prototype.detach = function () {
                  (this.parent != null && this.parent.removeChild(this),
                    delete this.domNode[r.DATA_KEY]);
                }),
                (e.prototype.deleteAt = function (e, t) {
                  this.isolate(e, t).remove();
                }),
                (e.prototype.formatAt = function (e, t, n, i) {
                  var a = this.isolate(e, t);
                  if (r.query(n, r.Scope.BLOT) != null && i) a.wrap(n, i);
                  else if (r.query(n, r.Scope.ATTRIBUTE) != null) {
                    var o = r.create(this.statics.scope);
                    (a.wrap(o), o.format(n, i));
                  }
                }),
                (e.prototype.insertAt = function (e, t, n) {
                  var i = n == null ? r.create(`text`, t) : r.create(t, n),
                    a = this.split(e);
                  this.parent.insertBefore(i, a);
                }),
                (e.prototype.insertInto = function (e, t) {
                  (t === void 0 && (t = null),
                    this.parent != null && this.parent.children.remove(this));
                  var n = null;
                  (e.children.insertBefore(this, t),
                    t != null && (n = t.domNode),
                    (this.domNode.parentNode != e.domNode || this.domNode.nextSibling != n) &&
                      e.domNode.insertBefore(this.domNode, n),
                    (this.parent = e),
                    this.attach());
                }),
                (e.prototype.isolate = function (e, t) {
                  var n = this.split(e);
                  return (n.split(t), n);
                }),
                (e.prototype.length = function () {
                  return 1;
                }),
                (e.prototype.offset = function (e) {
                  return (
                    e === void 0 && (e = this.parent),
                    this.parent == null || this == e
                      ? 0
                      : this.parent.children.offset(this) + this.parent.offset(e)
                  );
                }),
                (e.prototype.optimize = function (e) {
                  this.domNode[r.DATA_KEY] != null && delete this.domNode[r.DATA_KEY].mutations;
                }),
                (e.prototype.remove = function () {
                  (this.domNode.parentNode != null &&
                    this.domNode.parentNode.removeChild(this.domNode),
                    this.detach());
                }),
                (e.prototype.replace = function (e) {
                  e.parent != null && (e.parent.insertBefore(this, e.next), e.remove());
                }),
                (e.prototype.replaceWith = function (e, t) {
                  var n = typeof e == `string` ? r.create(e, t) : e;
                  return (n.replace(this), n);
                }),
                (e.prototype.split = function (e, t) {
                  return e === 0 ? this : this.next;
                }),
                (e.prototype.update = function (e, t) {}),
                (e.prototype.wrap = function (e, t) {
                  var n = typeof e == `string` ? r.create(e, t) : e;
                  return (
                    this.parent != null && this.parent.insertBefore(n, this.next),
                    n.appendChild(this),
                    n
                  );
                }),
                (e.blotName = `abstract`),
                e
              );
            })();
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = n(12),
              i = n(32),
              a = n(33),
              o = n(1);
            t.default = (function () {
              function e(e) {
                ((this.attributes = {}), (this.domNode = e), this.build());
              }
              return (
                (e.prototype.attribute = function (e, t) {
                  t
                    ? e.add(this.domNode, t) &&
                      (e.value(this.domNode) == null
                        ? delete this.attributes[e.attrName]
                        : (this.attributes[e.attrName] = e))
                    : (e.remove(this.domNode), delete this.attributes[e.attrName]);
                }),
                (e.prototype.build = function () {
                  var e = this;
                  this.attributes = {};
                  var t = r.default.keys(this.domNode),
                    n = i.default.keys(this.domNode),
                    s = a.default.keys(this.domNode);
                  t.concat(n)
                    .concat(s)
                    .forEach(function (t) {
                      var n = o.query(t, o.Scope.ATTRIBUTE);
                      n instanceof r.default && (e.attributes[n.attrName] = n);
                    });
                }),
                (e.prototype.copy = function (e) {
                  var t = this;
                  Object.keys(this.attributes).forEach(function (n) {
                    var r = t.attributes[n].value(t.domNode);
                    e.format(n, r);
                  });
                }),
                (e.prototype.move = function (e) {
                  var t = this;
                  (this.copy(e),
                    Object.keys(this.attributes).forEach(function (e) {
                      t.attributes[e].remove(t.domNode);
                    }),
                    (this.attributes = {}));
                }),
                (e.prototype.values = function () {
                  var e = this;
                  return Object.keys(this.attributes).reduce(function (t, n) {
                    return ((t[n] = e.attributes[n].value(e.domNode)), t);
                  }, {});
                }),
                e
              );
            })();
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(12);
            function a(e, t) {
              return (e.getAttribute(`class`) || ``).split(/\s+/).filter(function (e) {
                return e.indexOf(t + `-`) === 0;
              });
            }
            t.default = (function (e) {
              r(t, e);
              function t() {
                return (e !== null && e.apply(this, arguments)) || this;
              }
              return (
                (t.keys = function (e) {
                  return (e.getAttribute(`class`) || ``).split(/\s+/).map(function (e) {
                    return e.split(`-`).slice(0, -1).join(`-`);
                  });
                }),
                (t.prototype.add = function (e, t) {
                  return this.canAdd(e, t)
                    ? (this.remove(e), e.classList.add(this.keyName + `-` + t), !0)
                    : !1;
                }),
                (t.prototype.remove = function (e) {
                  (a(e, this.keyName).forEach(function (t) {
                    e.classList.remove(t);
                  }),
                    e.classList.length === 0 && e.removeAttribute(`class`));
                }),
                (t.prototype.value = function (e) {
                  var t = (a(e, this.keyName)[0] || ``).slice(this.keyName.length + 1);
                  return this.canAdd(e, t) ? t : ``;
                }),
                t
              );
            })(i.default);
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(12);
            function a(e) {
              var t = e.split(`-`),
                n = t
                  .slice(1)
                  .map(function (e) {
                    return e[0].toUpperCase() + e.slice(1);
                  })
                  .join(``);
              return t[0] + n;
            }
            t.default = (function (e) {
              r(t, e);
              function t() {
                return (e !== null && e.apply(this, arguments)) || this;
              }
              return (
                (t.keys = function (e) {
                  return (e.getAttribute(`style`) || ``).split(`;`).map(function (e) {
                    return e.split(`:`)[0].trim();
                  });
                }),
                (t.prototype.add = function (e, t) {
                  return this.canAdd(e, t) ? ((e.style[a(this.keyName)] = t), !0) : !1;
                }),
                (t.prototype.remove = function (e) {
                  ((e.style[a(this.keyName)] = ``),
                    e.getAttribute(`style`) || e.removeAttribute(`style`));
                }),
                (t.prototype.value = function (e) {
                  var t = e.style[a(this.keyName)];
                  return this.canAdd(e, t) ? t : ``;
                }),
                t
              );
            })(i.default);
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  ((r.enumerable = r.enumerable || !1),
                    (r.configurable = !0),
                    `value` in r && (r.writable = !0),
                    Object.defineProperty(e, r.key, r));
                }
              }
              return function (t, n, r) {
                return (n && e(t.prototype, n), r && e(t, r), t);
              };
            })();
            function i(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            var a = (function () {
              function e(t, n) {
                (i(this, e), (this.quill = t), (this.options = n), (this.modules = {}));
              }
              return (
                r(e, [
                  {
                    key: `init`,
                    value: function () {
                      var e = this;
                      Object.keys(this.options.modules).forEach(function (t) {
                        e.modules[t] ?? e.addModule(t);
                      });
                    },
                  },
                  {
                    key: `addModule`,
                    value: function (e) {
                      var t = this.quill.constructor.import(`modules/` + e);
                      return (
                        (this.modules[e] = new t(this.quill, this.options.modules[e] || {})),
                        this.modules[e]
                      );
                    },
                  },
                ]),
                e
              );
            })();
            ((a.DEFAULTS = {
              modules: {},
            }),
              (a.themes = {
                default: a,
              }),
              (t.default = a));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = s(n(0)),
              o = s(n(7));
            function s(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function c(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function l(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function u(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var d = `﻿`;
            t.default = (function (e) {
              u(t, e);
              function t(e) {
                c(this, t);
                var n = l(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return (
                  (n.contentNode = document.createElement(`span`)),
                  n.contentNode.setAttribute(`contenteditable`, !1),
                  [].slice.call(n.domNode.childNodes).forEach(function (e) {
                    n.contentNode.appendChild(e);
                  }),
                  (n.leftGuard = document.createTextNode(d)),
                  (n.rightGuard = document.createTextNode(d)),
                  n.domNode.appendChild(n.leftGuard),
                  n.domNode.appendChild(n.contentNode),
                  n.domNode.appendChild(n.rightGuard),
                  n
                );
              }
              return (
                r(t, [
                  {
                    key: `index`,
                    value: function (e, n) {
                      return e === this.leftGuard
                        ? 0
                        : e === this.rightGuard
                          ? 1
                          : i(
                              t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                              `index`,
                              this,
                            ).call(this, e, n);
                    },
                  },
                  {
                    key: `restore`,
                    value: function (e) {
                      var t = void 0,
                        n = void 0,
                        r = e.data.split(d).join(``);
                      if (e === this.leftGuard) {
                        if (this.prev instanceof o.default) {
                          var i = this.prev.length();
                          (this.prev.insertAt(i, r),
                            (t = {
                              startNode: this.prev.domNode,
                              startOffset: i + r.length,
                            }));
                        } else
                          ((n = document.createTextNode(r)),
                            this.parent.insertBefore(a.default.create(n), this),
                            (t = {
                              startNode: n,
                              startOffset: r.length,
                            }));
                      } else
                        e === this.rightGuard &&
                          (this.next instanceof o.default
                            ? (this.next.insertAt(0, r),
                              (t = {
                                startNode: this.next.domNode,
                                startOffset: r.length,
                              }))
                            : ((n = document.createTextNode(r)),
                              this.parent.insertBefore(a.default.create(n), this.next),
                              (t = {
                                startNode: n,
                                startOffset: r.length,
                              })));
                      return ((e.data = d), t);
                    },
                  },
                  {
                    key: `update`,
                    value: function (e, t) {
                      var n = this;
                      e.forEach(function (e) {
                        if (
                          e.type === `characterData` &&
                          (e.target === n.leftGuard || e.target === n.rightGuard)
                        ) {
                          var r = n.restore(e.target);
                          r && (t.range = r);
                        }
                      });
                    },
                  },
                ]),
                t
              );
            })(a.default.Embed);
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.AlignStyle = t.AlignClass = t.AlignAttribute = void 0));
            var r = i(n(0));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            var a = {
                scope: r.default.Scope.BLOCK,
                whitelist: [`right`, `center`, `justify`],
              },
              o = new r.default.Attributor.Attribute(`align`, `align`, a),
              s = new r.default.Attributor.Class(`align`, `ql-align`, a),
              c = new r.default.Attributor.Style(`align`, `text-align`, a);
            ((t.AlignAttribute = o), (t.AlignClass = s), (t.AlignStyle = c));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.BackgroundStyle = t.BackgroundClass = void 0));
            var r = a(n(0)),
              i = n(26);
            function a(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            var o = new r.default.Attributor.Class(`background`, `ql-bg`, {
                scope: r.default.Scope.INLINE,
              }),
              s = new i.ColorAttributor(`background`, `background-color`, {
                scope: r.default.Scope.INLINE,
              });
            ((t.BackgroundClass = o), (t.BackgroundStyle = s));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.DirectionStyle = t.DirectionClass = t.DirectionAttribute = void 0));
            var r = i(n(0));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            var a = {
                scope: r.default.Scope.BLOCK,
                whitelist: [`rtl`],
              },
              o = new r.default.Attributor.Attribute(`direction`, `dir`, a),
              s = new r.default.Attributor.Class(`direction`, `ql-direction`, a),
              c = new r.default.Attributor.Style(`direction`, `direction`, a);
            ((t.DirectionAttribute = o), (t.DirectionClass = s), (t.DirectionStyle = c));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.FontClass = t.FontStyle = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(0));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var u = {
                scope: a.default.Scope.INLINE,
                whitelist: [`serif`, `monospace`],
              },
              d = new a.default.Attributor.Class(`font`, `ql-font`, u);
            ((t.FontStyle = new ((function (e) {
              l(t, e);
              function t() {
                return (
                  s(this, t),
                  c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(t, [
                  {
                    key: `value`,
                    value: function (e) {
                      return i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `value`,
                        this,
                      )
                        .call(this, e)
                        .replace(/["']/g, ``);
                    },
                  },
                ]),
                t
              );
            })(a.default.Attributor.Style))(`font`, `font-family`, u)),
              (t.FontClass = d));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.SizeStyle = t.SizeClass = void 0));
            var r = i(n(0));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            var a = new r.default.Attributor.Class(`size`, `ql-size`, {
                scope: r.default.Scope.INLINE,
                whitelist: [`small`, `large`, `huge`],
              }),
              o = new r.default.Attributor.Style(`size`, `font-size`, {
                scope: r.default.Scope.INLINE,
                whitelist: [`10px`, `18px`, `32px`],
              });
            ((t.SizeClass = a), (t.SizeStyle = o));
          },
          function (e, t, n) {
            e.exports = {
              align: {
                "": n(76),
                center: n(77),
                right: n(78),
                justify: n(79),
              },
              background: n(80),
              blockquote: n(81),
              bold: n(82),
              clean: n(83),
              code: n(58),
              "code-block": n(58),
              color: n(84),
              direction: {
                "": n(85),
                rtl: n(86),
              },
              float: {
                center: n(87),
                full: n(88),
                left: n(89),
                right: n(90),
              },
              formula: n(91),
              header: {
                1: n(92),
                2: n(93),
              },
              italic: n(94),
              image: n(95),
              indent: {
                "+1": n(96),
                "-1": n(97),
              },
              link: n(98),
              list: {
                ordered: n(99),
                bullet: n(100),
                check: n(101),
              },
              script: {
                sub: n(102),
                super: n(103),
              },
              strike: n(104),
              underline: n(105),
              video: n(106),
            };
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.getLastChangeIndex = t.default = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = s(n(0)),
              a = s(n(5)),
              o = s(n(9));
            function s(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function c(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function l(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function u(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var d = (function (e) {
              u(t, e);
              function t(e, n) {
                c(this, t);
                var r = l(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                return (
                  (r.lastRecorded = 0),
                  (r.ignoreChange = !1),
                  r.clear(),
                  r.quill.on(a.default.events.EDITOR_CHANGE, function (e, t, n, i) {
                    e !== a.default.events.TEXT_CHANGE ||
                      r.ignoreChange ||
                      (!r.options.userOnly || i === a.default.sources.USER
                        ? r.record(t, n)
                        : r.transform(t));
                  }),
                  r.quill.keyboard.addBinding(
                    {
                      key: `Z`,
                      shortKey: !0,
                    },
                    r.undo.bind(r),
                  ),
                  r.quill.keyboard.addBinding(
                    {
                      key: `Z`,
                      shortKey: !0,
                      shiftKey: !0,
                    },
                    r.redo.bind(r),
                  ),
                  /Win/i.test(navigator.platform) &&
                    r.quill.keyboard.addBinding(
                      {
                        key: `Y`,
                        shortKey: !0,
                      },
                      r.redo.bind(r),
                    ),
                  r
                );
              }
              return (
                r(t, [
                  {
                    key: `change`,
                    value: function (e, t) {
                      if (this.stack[e].length !== 0) {
                        var n = this.stack[e].pop();
                        (this.stack[t].push(n),
                          (this.lastRecorded = 0),
                          (this.ignoreChange = !0),
                          this.quill.updateContents(n[e], a.default.sources.USER),
                          (this.ignoreChange = !1));
                        var r = p(n[e]);
                        this.quill.setSelection(r);
                      }
                    },
                  },
                  {
                    key: `clear`,
                    value: function () {
                      this.stack = {
                        undo: [],
                        redo: [],
                      };
                    },
                  },
                  {
                    key: `cutoff`,
                    value: function () {
                      this.lastRecorded = 0;
                    },
                  },
                  {
                    key: `record`,
                    value: function (e, t) {
                      if (e.ops.length !== 0) {
                        this.stack.redo = [];
                        var n = this.quill.getContents().diff(t),
                          r = Date.now();
                        if (
                          this.lastRecorded + this.options.delay > r &&
                          this.stack.undo.length > 0
                        ) {
                          var i = this.stack.undo.pop();
                          ((n = n.compose(i.undo)), (e = i.redo.compose(e)));
                        } else this.lastRecorded = r;
                        (this.stack.undo.push({
                          redo: e,
                          undo: n,
                        }),
                          this.stack.undo.length > this.options.maxStack &&
                            this.stack.undo.shift());
                      }
                    },
                  },
                  {
                    key: `redo`,
                    value: function () {
                      this.change(`redo`, `undo`);
                    },
                  },
                  {
                    key: `transform`,
                    value: function (e) {
                      (this.stack.undo.forEach(function (t) {
                        ((t.undo = e.transform(t.undo, !0)), (t.redo = e.transform(t.redo, !0)));
                      }),
                        this.stack.redo.forEach(function (t) {
                          ((t.undo = e.transform(t.undo, !0)), (t.redo = e.transform(t.redo, !0)));
                        }));
                    },
                  },
                  {
                    key: `undo`,
                    value: function () {
                      this.change(`undo`, `redo`);
                    },
                  },
                ]),
                t
              );
            })(o.default);
            d.DEFAULTS = {
              delay: 1e3,
              maxStack: 100,
              userOnly: !1,
            };
            function f(e) {
              var t = e.ops[e.ops.length - 1];
              return t == null
                ? !1
                : t.insert == null
                  ? t.attributes == null
                    ? !1
                    : Object.keys(t.attributes).some(function (e) {
                        return i.default.query(e, i.default.Scope.BLOCK) != null;
                      })
                  : typeof t.insert == `string` &&
                    t.insert.endsWith(`
`);
            }
            function p(e) {
              var t = e.reduce(function (e, t) {
                  return ((e += t.delete || 0), e);
                }, 0),
                n = e.length() - t;
              return (f(e) && --n, n);
            }
            ((t.default = d), (t.getLastChangeIndex = p));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.BaseTooltip = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = m(n(3)),
              o = m(n(2)),
              s = m(n(8)),
              c = m(n(23)),
              l = m(n(34)),
              u = m(n(59)),
              d = m(n(60)),
              f = m(n(28)),
              p = m(n(61));
            function m(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function h(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function g(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function v(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var y = [!1, `center`, `right`, `justify`],
              b =
                `#000000.#e60000.#ff9900.#ffff00.#008a00.#0066cc.#9933ff.#ffffff.#facccc.#ffebcc.#ffffcc.#cce8cc.#cce0f5.#ebd6ff.#bbbbbb.#f06666.#ffc266.#ffff66.#66b966.#66a3e0.#c285ff.#888888.#a10000.#b26b00.#b2b200.#006100.#0047b2.#6b24b2.#444444.#5c0000.#663d00.#666600.#003700.#002966.#3d1466`.split(
                  `.`,
                ),
              x = [!1, `serif`, `monospace`],
              S = [`1`, `2`, `3`, !1],
              C = [`small`, !1, `large`, `huge`],
              w = (function (e) {
                v(t, e);
                function t(e, n) {
                  h(this, t);
                  var r = g(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                  return (
                    e.emitter.listenDOM(`click`, document.body, function t(n) {
                      if (!document.body.contains(e.root))
                        return document.body.removeEventListener(`click`, t);
                      (r.tooltip != null &&
                        !r.tooltip.root.contains(n.target) &&
                        document.activeElement !== r.tooltip.textbox &&
                        !r.quill.hasFocus() &&
                        r.tooltip.hide(),
                        r.pickers != null &&
                          r.pickers.forEach(function (e) {
                            e.container.contains(n.target) || e.close();
                          }));
                    }),
                    r
                  );
                }
                return (
                  r(t, [
                    {
                      key: `addModule`,
                      value: function (e) {
                        var n = i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `addModule`,
                          this,
                        ).call(this, e);
                        return (e === `toolbar` && this.extendToolbar(n), n);
                      },
                    },
                    {
                      key: `buildButtons`,
                      value: function (e, t) {
                        e.forEach(function (e) {
                          (e.getAttribute(`class`) || ``).split(/\s+/).forEach(function (n) {
                            if (n.startsWith(`ql-`) && ((n = n.slice(3)), t[n] != null))
                              if (n === `direction`) e.innerHTML = t[n][``] + t[n].rtl;
                              else if (typeof t[n] == `string`) e.innerHTML = t[n];
                              else {
                                var r = e.value || ``;
                                r != null && t[n][r] && (e.innerHTML = t[n][r]);
                              }
                          });
                        });
                      },
                    },
                    {
                      key: `buildPickers`,
                      value: function (e, t) {
                        var n = this;
                        ((this.pickers = e.map(function (e) {
                          if (e.classList.contains(`ql-align`))
                            return (
                              e.querySelector(`option`) ?? D(e, y),
                              new d.default(e, t.align)
                            );
                          if (
                            e.classList.contains(`ql-background`) ||
                            e.classList.contains(`ql-color`)
                          ) {
                            var n = e.classList.contains(`ql-background`) ? `background` : `color`;
                            return (
                              e.querySelector(`option`) ??
                                D(e, b, n === `background` ? `#ffffff` : `#000000`),
                              new u.default(e, t[n])
                            );
                          } else
                            return (
                              e.querySelector(`option`) ??
                                (e.classList.contains(`ql-font`)
                                  ? D(e, x)
                                  : e.classList.contains(`ql-header`)
                                    ? D(e, S)
                                    : e.classList.contains(`ql-size`) && D(e, C)),
                              new f.default(e)
                            );
                        })),
                          this.quill.on(s.default.events.EDITOR_CHANGE, function () {
                            n.pickers.forEach(function (e) {
                              e.update();
                            });
                          }));
                      },
                    },
                  ]),
                  t
                );
              })(l.default);
            w.DEFAULTS = (0, a.default)(!0, {}, l.default.DEFAULTS, {
              modules: {
                toolbar: {
                  handlers: {
                    formula: function () {
                      this.quill.theme.tooltip.edit(`formula`);
                    },
                    image: function () {
                      var e = this,
                        t = this.container.querySelector(`input.ql-image[type=file]`);
                      (t ??
                        ((t = document.createElement(`input`)),
                        t.setAttribute(`type`, `file`),
                        t.setAttribute(
                          `accept`,
                          `image/png, image/gif, image/jpeg, image/bmp, image/x-icon`,
                        ),
                        t.classList.add(`ql-image`),
                        t.addEventListener(`change`, function () {
                          if (t.files != null && t.files[0] != null) {
                            var n = new FileReader();
                            ((n.onload = function (n) {
                              var r = e.quill.getSelection(!0);
                              (e.quill.updateContents(
                                new o.default().retain(r.index).delete(r.length).insert({
                                  image: n.target.result,
                                }),
                                s.default.sources.USER,
                              ),
                                e.quill.setSelection(r.index + 1, s.default.sources.SILENT),
                                (t.value = ``));
                            }),
                              n.readAsDataURL(t.files[0]));
                          }
                        }),
                        this.container.appendChild(t)),
                        t.click());
                    },
                    video: function () {
                      this.quill.theme.tooltip.edit(`video`);
                    },
                  },
                },
              },
            });
            var T = (function (e) {
              v(t, e);
              function t(e, n) {
                h(this, t);
                var r = g(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                return ((r.textbox = r.root.querySelector(`input[type="text"]`)), r.listen(), r);
              }
              return (
                r(t, [
                  {
                    key: `listen`,
                    value: function () {
                      var e = this;
                      this.textbox.addEventListener(`keydown`, function (t) {
                        c.default.match(t, `enter`)
                          ? (e.save(), t.preventDefault())
                          : c.default.match(t, `escape`) && (e.cancel(), t.preventDefault());
                      });
                    },
                  },
                  {
                    key: `cancel`,
                    value: function () {
                      this.hide();
                    },
                  },
                  {
                    key: `edit`,
                    value: function () {
                      var e =
                          arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : `link`,
                        t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                      (this.root.classList.remove(`ql-hidden`),
                        this.root.classList.add(`ql-editing`),
                        t == null
                          ? e !== this.root.getAttribute(`data-mode`) && (this.textbox.value = ``)
                          : (this.textbox.value = t),
                        this.position(this.quill.getBounds(this.quill.selection.savedRange)),
                        this.textbox.select(),
                        this.textbox.setAttribute(
                          `placeholder`,
                          this.textbox.getAttribute(`data-` + e) || ``,
                        ),
                        this.root.setAttribute(`data-mode`, e));
                    },
                  },
                  {
                    key: `restoreFocus`,
                    value: function () {
                      var e = this.quill.scrollingContainer.scrollTop;
                      (this.quill.focus(), (this.quill.scrollingContainer.scrollTop = e));
                    },
                  },
                  {
                    key: `save`,
                    value: function () {
                      var e = this.textbox.value;
                      switch (this.root.getAttribute(`data-mode`)) {
                        case `link`:
                          var t = this.quill.root.scrollTop;
                          (this.linkRange
                            ? (this.quill.formatText(
                                this.linkRange,
                                `link`,
                                e,
                                s.default.sources.USER,
                              ),
                              delete this.linkRange)
                            : (this.restoreFocus(),
                              this.quill.format(`link`, e, s.default.sources.USER)),
                            (this.quill.root.scrollTop = t));
                          break;
                        case `video`:
                          e = E(e);
                        case `formula`:
                          if (!e) break;
                          var n = this.quill.getSelection(!0);
                          if (n != null) {
                            var r = n.index + n.length;
                            (this.quill.insertEmbed(
                              r,
                              this.root.getAttribute(`data-mode`),
                              e,
                              s.default.sources.USER,
                            ),
                              this.root.getAttribute(`data-mode`) === `formula` &&
                                this.quill.insertText(r + 1, ` `, s.default.sources.USER),
                              this.quill.setSelection(r + 2, s.default.sources.USER));
                          }
                          break;
                        default:
                      }
                      ((this.textbox.value = ``), this.hide());
                    },
                  },
                ]),
                t
              );
            })(p.default);
            function E(e) {
              var t =
                e.match(
                  /^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/,
                ) || e.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
              return t
                ? (t[1] || `https`) + `://www.youtube.com/embed/` + t[2] + `?showinfo=0`
                : (t = e.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/))
                  ? (t[1] || `https`) + `://player.vimeo.com/video/` + t[2] + `/`
                  : e;
            }
            function D(e, t) {
              var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
              t.forEach(function (t) {
                var r = document.createElement(`option`);
                (t === n ? r.setAttribute(`selected`, `selected`) : r.setAttribute(`value`, t),
                  e.appendChild(r));
              });
            }
            ((t.BaseTooltip = T), (t.default = w));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = (function () {
                function e() {
                  ((this.head = this.tail = null), (this.length = 0));
                }
                return (
                  (e.prototype.append = function () {
                    var e = [...arguments];
                    (this.insertBefore(e[0], null),
                      e.length > 1 && this.append.apply(this, e.slice(1)));
                  }),
                  (e.prototype.contains = function (e) {
                    for (var t, n = this.iterator(); (t = n());) if (t === e) return !0;
                    return !1;
                  }),
                  (e.prototype.insertBefore = function (e, t) {
                    e &&
                      ((e.next = t),
                      t == null
                        ? this.tail == null
                          ? ((e.prev = null), (this.head = this.tail = e))
                          : ((this.tail.next = e), (e.prev = this.tail), (this.tail = e))
                        : ((e.prev = t.prev),
                          t.prev != null && (t.prev.next = e),
                          (t.prev = e),
                          t === this.head && (this.head = e)),
                      (this.length += 1));
                  }),
                  (e.prototype.offset = function (e) {
                    for (var t = 0, n = this.head; n != null;) {
                      if (n === e) return t;
                      ((t += n.length()), (n = n.next));
                    }
                    return -1;
                  }),
                  (e.prototype.remove = function (e) {
                    this.contains(e) &&
                      (e.prev != null && (e.prev.next = e.next),
                      e.next != null && (e.next.prev = e.prev),
                      e === this.head && (this.head = e.next),
                      e === this.tail && (this.tail = e.prev),
                      --this.length);
                  }),
                  (e.prototype.iterator = function (e) {
                    return (
                      e === void 0 && (e = this.head),
                      function () {
                        var t = e;
                        return (e != null && (e = e.next), t);
                      }
                    );
                  }),
                  (e.prototype.find = function (e, t) {
                    t === void 0 && (t = !1);
                    for (var n, r = this.iterator(); (n = r());) {
                      var i = n.length();
                      if (e < i || (t && e === i && (n.next == null || n.next.length() !== 0)))
                        return [n, e];
                      e -= i;
                    }
                    return [null, 0];
                  }),
                  (e.prototype.forEach = function (e) {
                    for (var t, n = this.iterator(); (t = n());) e(t);
                  }),
                  (e.prototype.forEachAt = function (e, t, n) {
                    if (!(t <= 0))
                      for (
                        var r = this.find(e),
                          i = r[0],
                          a = r[1],
                          o,
                          s = e - a,
                          c = this.iterator(i);
                        (o = c()) && s < e + t;
                      ) {
                        var l = o.length();
                        (e > s
                          ? n(o, e - s, Math.min(t, s + l - e))
                          : n(o, 0, Math.min(l, e + t - s)),
                          (s += l));
                      }
                  }),
                  (e.prototype.map = function (e) {
                    return this.reduce(function (t, n) {
                      return (t.push(e(n)), t);
                    }, []);
                  }),
                  (e.prototype.reduce = function (e, t) {
                    for (var n, r = this.iterator(); (n = r());) t = e(t, n);
                    return t;
                  }),
                  e
                );
              })()));
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(17),
              a = n(1),
              o = {
                attributes: !0,
                characterData: !0,
                characterDataOldValue: !0,
                childList: !0,
                subtree: !0,
              },
              s = 100;
            t.default = (function (e) {
              r(t, e);
              function t(t) {
                var n = e.call(this, t) || this;
                return (
                  (n.scroll = n),
                  (n.observer = new MutationObserver(function (e) {
                    n.update(e);
                  })),
                  n.observer.observe(n.domNode, o),
                  n.attach(),
                  n
                );
              }
              return (
                (t.prototype.detach = function () {
                  (e.prototype.detach.call(this), this.observer.disconnect());
                }),
                (t.prototype.deleteAt = function (t, n) {
                  (this.update(),
                    t === 0 && n === this.length()
                      ? this.children.forEach(function (e) {
                          e.remove();
                        })
                      : e.prototype.deleteAt.call(this, t, n));
                }),
                (t.prototype.formatAt = function (t, n, r, i) {
                  (this.update(), e.prototype.formatAt.call(this, t, n, r, i));
                }),
                (t.prototype.insertAt = function (t, n, r) {
                  (this.update(), e.prototype.insertAt.call(this, t, n, r));
                }),
                (t.prototype.optimize = function (t, n) {
                  var r = this;
                  (t === void 0 && (t = []),
                    n === void 0 && (n = {}),
                    e.prototype.optimize.call(this, n));
                  for (var o = [].slice.call(this.observer.takeRecords()); o.length > 0;)
                    t.push(o.pop());
                  for (
                    var c = function (e, t) {
                        (t === void 0 && (t = !0),
                          !(e == null || e === r) &&
                            e.domNode.parentNode != null &&
                            (e.domNode[a.DATA_KEY].mutations ??
                              (e.domNode[a.DATA_KEY].mutations = []),
                            t && c(e.parent)));
                      },
                      l = function (e) {
                        e.domNode[a.DATA_KEY] == null ||
                          e.domNode[a.DATA_KEY].mutations == null ||
                          (e instanceof i.default && e.children.forEach(l), e.optimize(n));
                      },
                      u = t,
                      d = 0;
                    u.length > 0;
                    d += 1
                  ) {
                    if (d >= s) throw Error(`[Parchment] Maximum optimize iterations reached`);
                    for (
                      u.forEach(function (e) {
                        var t = a.find(e.target, !0);
                        t != null &&
                          (t.domNode === e.target &&
                            (e.type === `childList`
                              ? (c(a.find(e.previousSibling, !1)),
                                [].forEach.call(e.addedNodes, function (e) {
                                  var t = a.find(e, !1);
                                  (c(t, !1),
                                    t instanceof i.default &&
                                      t.children.forEach(function (e) {
                                        c(e, !1);
                                      }));
                                }))
                              : e.type === `attributes` && c(t.prev)),
                          c(t));
                      }),
                        this.children.forEach(l),
                        u = [].slice.call(this.observer.takeRecords()),
                        o = u.slice();
                      o.length > 0;
                    )
                      t.push(o.pop());
                  }
                }),
                (t.prototype.update = function (t, n) {
                  var r = this;
                  (n === void 0 && (n = {}),
                    (t ||= this.observer.takeRecords()),
                    t
                      .map(function (e) {
                        var t = a.find(e.target, !0);
                        return t == null
                          ? null
                          : t.domNode[a.DATA_KEY].mutations == null
                            ? ((t.domNode[a.DATA_KEY].mutations = [e]), t)
                            : (t.domNode[a.DATA_KEY].mutations.push(e), null);
                      })
                      .forEach(function (e) {
                        e == null ||
                          e === r ||
                          e.domNode[a.DATA_KEY] == null ||
                          e.update(e.domNode[a.DATA_KEY].mutations || [], n);
                      }),
                    this.domNode[a.DATA_KEY].mutations != null &&
                      e.prototype.update.call(this, this.domNode[a.DATA_KEY].mutations, n),
                    this.optimize(t, n));
                }),
                (t.blotName = `scroll`),
                (t.defaultChild = `block`),
                (t.scope = a.Scope.BLOCK_BLOT),
                (t.tagName = `DIV`),
                t
              );
            })(i.default);
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(18),
              a = n(1);
            function o(e, t) {
              if (Object.keys(e).length !== Object.keys(t).length) return !1;
              for (var n in e) if (e[n] !== t[n]) return !1;
              return !0;
            }
            t.default = (function (e) {
              r(t, e);
              function t() {
                return (e !== null && e.apply(this, arguments)) || this;
              }
              return (
                (t.formats = function (n) {
                  if (n.tagName !== t.tagName) return e.formats.call(this, n);
                }),
                (t.prototype.format = function (n, r) {
                  var a = this;
                  n === this.statics.blotName && !r
                    ? (this.children.forEach(function (e) {
                        (e instanceof i.default || (e = e.wrap(t.blotName, !0)),
                          a.attributes.copy(e));
                      }),
                      this.unwrap())
                    : e.prototype.format.call(this, n, r);
                }),
                (t.prototype.formatAt = function (t, n, r, i) {
                  this.formats()[r] != null || a.query(r, a.Scope.ATTRIBUTE)
                    ? this.isolate(t, n).format(r, i)
                    : e.prototype.formatAt.call(this, t, n, r, i);
                }),
                (t.prototype.optimize = function (n) {
                  e.prototype.optimize.call(this, n);
                  var r = this.formats();
                  if (Object.keys(r).length === 0) return this.unwrap();
                  var i = this.next;
                  i instanceof t &&
                    i.prev === this &&
                    o(r, i.formats()) &&
                    (i.moveChildren(this), i.remove());
                }),
                (t.blotName = `inline`),
                (t.scope = a.Scope.INLINE_BLOT),
                (t.tagName = `SPAN`),
                t
              );
            })(i.default);
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(18),
              a = n(1);
            t.default = (function (e) {
              r(t, e);
              function t() {
                return (e !== null && e.apply(this, arguments)) || this;
              }
              return (
                (t.formats = function (n) {
                  var r = a.query(t.blotName).tagName;
                  if (n.tagName !== r) return e.formats.call(this, n);
                }),
                (t.prototype.format = function (n, r) {
                  a.query(n, a.Scope.BLOCK) != null &&
                    (n === this.statics.blotName && !r
                      ? this.replaceWith(t.blotName)
                      : e.prototype.format.call(this, n, r));
                }),
                (t.prototype.formatAt = function (t, n, r, i) {
                  a.query(r, a.Scope.BLOCK) == null
                    ? e.prototype.formatAt.call(this, t, n, r, i)
                    : this.format(r, i);
                }),
                (t.prototype.insertAt = function (t, n, r) {
                  if (r == null || a.query(n, a.Scope.INLINE) != null)
                    e.prototype.insertAt.call(this, t, n, r);
                  else {
                    var i = this.split(t),
                      o = a.create(n, r);
                    i.parent.insertBefore(o, i);
                  }
                }),
                (t.prototype.update = function (t, n) {
                  navigator.userAgent.match(/Trident/)
                    ? this.build()
                    : e.prototype.update.call(this, t, n);
                }),
                (t.blotName = `block`),
                (t.scope = a.Scope.BLOCK_BLOT),
                (t.tagName = `P`),
                t
              );
            })(i.default);
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = (function (e) {
                r(t, e);
                function t() {
                  return (e !== null && e.apply(this, arguments)) || this;
                }
                return (
                  (t.formats = function (e) {}),
                  (t.prototype.format = function (t, n) {
                    e.prototype.formatAt.call(this, 0, this.length(), t, n);
                  }),
                  (t.prototype.formatAt = function (t, n, r, i) {
                    t === 0 && n === this.length()
                      ? this.format(r, i)
                      : e.prototype.formatAt.call(this, t, n, r, i);
                  }),
                  (t.prototype.formats = function () {
                    return this.statics.formats(this.domNode);
                  }),
                  t
                );
              })(n(19).default)));
          },
          function (e, t, n) {
            var r =
              (this && this.__extends) ||
              (function () {
                var e =
                  Object.setPrototypeOf ||
                  ({
                    __proto__: [],
                  } instanceof Array &&
                    function (e, t) {
                      e.__proto__ = t;
                    }) ||
                  function (e, t) {
                    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                  };
                return function (t, n) {
                  e(t, n);
                  function r() {
                    this.constructor = t;
                  }
                  t.prototype =
                    n === null ? Object.create(n) : ((r.prototype = n.prototype), new r());
                };
              })();
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var i = n(19),
              a = n(1);
            t.default = (function (e) {
              r(t, e);
              function t(t) {
                var n = e.call(this, t) || this;
                return ((n.text = n.statics.value(n.domNode)), n);
              }
              return (
                (t.create = function (e) {
                  return document.createTextNode(e);
                }),
                (t.value = function (e) {
                  var t = e.data;
                  return (t.normalize && (t = t.normalize()), t);
                }),
                (t.prototype.deleteAt = function (e, t) {
                  this.domNode.data = this.text = this.text.slice(0, e) + this.text.slice(e + t);
                }),
                (t.prototype.index = function (e, t) {
                  return this.domNode === e ? t : -1;
                }),
                (t.prototype.insertAt = function (t, n, r) {
                  r == null
                    ? ((this.text = this.text.slice(0, t) + n + this.text.slice(t)),
                      (this.domNode.data = this.text))
                    : e.prototype.insertAt.call(this, t, n, r);
                }),
                (t.prototype.length = function () {
                  return this.text.length;
                }),
                (t.prototype.optimize = function (n) {
                  (e.prototype.optimize.call(this, n),
                    (this.text = this.statics.value(this.domNode)),
                    this.text.length === 0
                      ? this.remove()
                      : this.next instanceof t &&
                        this.next.prev === this &&
                        (this.insertAt(this.length(), this.next.value()), this.next.remove()));
                }),
                (t.prototype.position = function (e, t) {
                  return (t === void 0 && (t = !1), [this.domNode, e]);
                }),
                (t.prototype.split = function (e, t) {
                  if ((t === void 0 && (t = !1), !t)) {
                    if (e === 0) return this;
                    if (e === this.length()) return this.next;
                  }
                  var n = a.create(this.domNode.splitText(e));
                  return (
                    this.parent.insertBefore(n, this.next),
                    (this.text = this.statics.value(this.domNode)),
                    n
                  );
                }),
                (t.prototype.update = function (e, t) {
                  var n = this;
                  e.some(function (e) {
                    return e.type === `characterData` && e.target === n.domNode;
                  }) && (this.text = this.statics.value(this.domNode));
                }),
                (t.prototype.value = function () {
                  return this.text;
                }),
                (t.blotName = `text`),
                (t.scope = a.Scope.INLINE_BLOT),
                t
              );
            })(i.default);
          },
          function (e, t, n) {
            var r = document.createElement(`div`);
            if ((r.classList.toggle(`test-class`, !1), r.classList.contains(`test-class`))) {
              var i = DOMTokenList.prototype.toggle;
              DOMTokenList.prototype.toggle = function (e, t) {
                return arguments.length > 1 && !this.contains(e) == !t ? t : i.call(this, e);
              };
            }
            (String.prototype.startsWith ||
              (String.prototype.startsWith = function (e, t) {
                return ((t ||= 0), this.substr(t, e.length) === e);
              }),
              String.prototype.endsWith ||
                (String.prototype.endsWith = function (e, t) {
                  var n = this.toString();
                  ((typeof t != `number` || !isFinite(t) || Math.floor(t) !== t || t > n.length) &&
                    (t = n.length),
                    (t -= e.length));
                  var r = n.indexOf(e, t);
                  return r !== -1 && r === t;
                }),
              Array.prototype.find ||
                Object.defineProperty(Array.prototype, "find", {
                  value: function (e) {
                    if (this === null)
                      throw TypeError(`Array.prototype.find called on null or undefined`);
                    if (typeof e != `function`) throw TypeError(`predicate must be a function`);
                    for (
                      var t = Object(this), n = t.length >>> 0, r = arguments[1], i, a = 0;
                      a < n;
                      a++
                    )
                      if (((i = t[a]), e.call(r, i, a, t))) return i;
                  },
                }),
              document.addEventListener(`DOMContentLoaded`, function () {
                (document.execCommand(`enableObjectResizing`, !1, !1),
                  document.execCommand(`autoUrlDetect`, !1, !1));
              }));
          },
          function (e, t) {
            var n = -1,
              r = 1,
              i = 0;
            function a(e, t, n) {
              if (e == t) return e ? [[i, e]] : [];
              (n < 0 || e.length < n) && (n = null);
              var r = l(e, t),
                a = e.substring(0, r);
              ((e = e.substring(r)), (t = t.substring(r)), (r = u(e, t)));
              var s = e.substring(e.length - r);
              ((e = e.substring(0, e.length - r)), (t = t.substring(0, t.length - r)));
              var c = o(e, t);
              return (
                a && c.unshift([i, a]),
                s && c.push([i, s]),
                f(c),
                n != null && (c = h(c, n)),
                (c = g(c)),
                c
              );
            }
            function o(e, t) {
              var o;
              if (!e) return [[r, t]];
              if (!t) return [[n, e]];
              var c = e.length > t.length ? e : t,
                l = e.length > t.length ? t : e,
                u = c.indexOf(l);
              if (u != -1)
                return (
                  (o = [
                    [r, c.substring(0, u)],
                    [i, l],
                    [r, c.substring(u + l.length)],
                  ]),
                  e.length > t.length && (o[0][0] = o[2][0] = n),
                  o
                );
              if (l.length == 1)
                return [
                  [n, e],
                  [r, t],
                ];
              var f = d(e, t);
              if (f) {
                var p = f[0],
                  m = f[1],
                  h = f[2],
                  g = f[3],
                  v = f[4],
                  y = a(p, h),
                  b = a(m, g);
                return y.concat([[i, v]], b);
              }
              return s(e, t);
            }
            function s(e, t) {
              for (
                var i = e.length,
                  a = t.length,
                  o = Math.ceil((i + a) / 2),
                  s = o,
                  l = 2 * o,
                  u = Array(l),
                  d = Array(l),
                  f = 0;
                f < l;
                f++
              )
                ((u[f] = -1), (d[f] = -1));
              ((u[s + 1] = 0), (d[s + 1] = 0));
              for (var p = i - a, m = p % 2 != 0, h = 0, g = 0, v = 0, y = 0, b = 0; b < o; b++) {
                for (var x = -b + h; x <= b - g; x += 2) {
                  for (
                    var S = s + x,
                      C = x == -b || (x != b && u[S - 1] < u[S + 1]) ? u[S + 1] : u[S - 1] + 1,
                      w = C - x;
                    C < i && w < a && e.charAt(C) == t.charAt(w);
                  )
                    (C++, w++);
                  if (((u[S] = C), C > i)) g += 2;
                  else if (w > a) h += 2;
                  else if (m) {
                    var T = s + p - x;
                    if (T >= 0 && T < l && d[T] != -1) {
                      var E = i - d[T];
                      if (C >= E) return c(e, t, C, w);
                    }
                  }
                }
                for (var D = -b + v; D <= b - y; D += 2) {
                  for (
                    var T = s + D,
                      E = D == -b || (D != b && d[T - 1] < d[T + 1]) ? d[T + 1] : d[T - 1] + 1,
                      ee = E - D;
                    E < i && ee < a && e.charAt(i - E - 1) == t.charAt(a - ee - 1);
                  )
                    (E++, ee++);
                  if (((d[T] = E), E > i)) y += 2;
                  else if (ee > a) v += 2;
                  else if (!m) {
                    var S = s + p - D;
                    if (S >= 0 && S < l && u[S] != -1) {
                      var C = u[S],
                        w = s + C - S;
                      if (((E = i - E), C >= E)) return c(e, t, C, w);
                    }
                  }
                }
              }
              return [
                [n, e],
                [r, t],
              ];
            }
            function c(e, t, n, r) {
              var i = e.substring(0, n),
                o = t.substring(0, r),
                s = e.substring(n),
                c = t.substring(r),
                l = a(i, o),
                u = a(s, c);
              return l.concat(u);
            }
            function l(e, t) {
              if (!e || !t || e.charAt(0) != t.charAt(0)) return 0;
              for (var n = 0, r = Math.min(e.length, t.length), i = r, a = 0; n < i;)
                (e.substring(a, i) == t.substring(a, i) ? ((n = i), (a = n)) : (r = i),
                  (i = Math.floor((r - n) / 2 + n)));
              return i;
            }
            function u(e, t) {
              if (!e || !t || e.charAt(e.length - 1) != t.charAt(t.length - 1)) return 0;
              for (var n = 0, r = Math.min(e.length, t.length), i = r, a = 0; n < i;)
                (e.substring(e.length - i, e.length - a) == t.substring(t.length - i, t.length - a)
                  ? ((n = i), (a = n))
                  : (r = i),
                  (i = Math.floor((r - n) / 2 + n)));
              return i;
            }
            function d(e, t) {
              var n = e.length > t.length ? e : t,
                r = e.length > t.length ? t : e;
              if (n.length < 4 || r.length * 2 < n.length) return null;
              function i(e, t, n) {
                for (
                  var r = e.substring(n, n + Math.floor(e.length / 4)), i = -1, a = ``, o, s, c, d;
                  (i = t.indexOf(r, i + 1)) != -1;
                ) {
                  var f = l(e.substring(n), t.substring(i)),
                    p = u(e.substring(0, n), t.substring(0, i));
                  a.length < p + f &&
                    ((a = t.substring(i - p, i) + t.substring(i, i + f)),
                    (o = e.substring(0, n - p)),
                    (s = e.substring(n + f)),
                    (c = t.substring(0, i - p)),
                    (d = t.substring(i + f)));
                }
                return a.length * 2 >= e.length ? [o, s, c, d, a] : null;
              }
              var a = i(n, r, Math.ceil(n.length / 4)),
                o = i(n, r, Math.ceil(n.length / 2)),
                s;
              if (!a && !o) return null;
              s = o ? (a && a[4].length > o[4].length ? a : o) : a;
              var c, d, f, p;
              e.length > t.length
                ? ((c = s[0]), (d = s[1]), (f = s[2]), (p = s[3]))
                : ((f = s[0]), (p = s[1]), (c = s[2]), (d = s[3]));
              var m = s[4];
              return [c, d, f, p, m];
            }
            function f(e) {
              e.push([i, ``]);
              for (var t = 0, a = 0, o = 0, s = ``, c = ``, d; t < e.length;)
                switch (e[t][0]) {
                  case r:
                    (o++, (c += e[t][1]), t++);
                    break;
                  case n:
                    (a++, (s += e[t][1]), t++);
                    break;
                  case i:
                    (a + o > 1
                      ? (a !== 0 &&
                          o !== 0 &&
                          ((d = l(c, s)),
                          d !== 0 &&
                            (t - a - o > 0 && e[t - a - o - 1][0] == i
                              ? (e[t - a - o - 1][1] += c.substring(0, d))
                              : (e.splice(0, 0, [i, c.substring(0, d)]), t++),
                            (c = c.substring(d)),
                            (s = s.substring(d))),
                          (d = u(c, s)),
                          d !== 0 &&
                            ((e[t][1] = c.substring(c.length - d) + e[t][1]),
                            (c = c.substring(0, c.length - d)),
                            (s = s.substring(0, s.length - d)))),
                        a === 0
                          ? e.splice(t - o, a + o, [r, c])
                          : o === 0
                            ? e.splice(t - a, a + o, [n, s])
                            : e.splice(t - a - o, a + o, [n, s], [r, c]),
                        (t = t - a - o + +!!a + +!!o + 1))
                      : t !== 0 && e[t - 1][0] == i
                        ? ((e[t - 1][1] += e[t][1]), e.splice(t, 1))
                        : t++,
                      (o = 0),
                      (a = 0),
                      (s = ``),
                      (c = ``));
                    break;
                }
              e[e.length - 1][1] === `` && e.pop();
              var p = !1;
              for (t = 1; t < e.length - 1;)
                (e[t - 1][0] == i &&
                  e[t + 1][0] == i &&
                  (e[t][1].substring(e[t][1].length - e[t - 1][1].length) == e[t - 1][1]
                    ? ((e[t][1] =
                        e[t - 1][1] + e[t][1].substring(0, e[t][1].length - e[t - 1][1].length)),
                      (e[t + 1][1] = e[t - 1][1] + e[t + 1][1]),
                      e.splice(t - 1, 1),
                      (p = !0))
                    : e[t][1].substring(0, e[t + 1][1].length) == e[t + 1][1] &&
                      ((e[t - 1][1] += e[t + 1][1]),
                      (e[t][1] = e[t][1].substring(e[t + 1][1].length) + e[t + 1][1]),
                      e.splice(t + 1, 1),
                      (p = !0))),
                  t++);
              p && f(e);
            }
            var p = a;
            ((p.INSERT = r), (p.DELETE = n), (p.EQUAL = i), (e.exports = p));
            function m(e, t) {
              if (t === 0) return [i, e];
              for (var r = 0, a = 0; a < e.length; a++) {
                var o = e[a];
                if (o[0] === n || o[0] === i) {
                  var s = r + o[1].length;
                  if (t === s) return [a + 1, e];
                  if (t < s) {
                    e = e.slice();
                    var c = t - r,
                      l = [o[0], o[1].slice(0, c)],
                      u = [o[0], o[1].slice(c)];
                    return (e.splice(a, 1, l, u), [a + 1, e]);
                  } else r = s;
                }
              }
              throw Error(`cursor_pos is out of bounds!`);
            }
            function h(e, t) {
              var n = m(e, t),
                r = n[1],
                a = n[0],
                o = r[a],
                s = r[a + 1];
              if (o == null || o[0] !== i) return e;
              if (s != null && o[1] + s[1] === s[1] + o[1])
                return (r.splice(a, 2, s, o), v(r, a, 2));
              if (s != null && s[1].indexOf(o[1]) === 0) {
                r.splice(a, 2, [s[0], o[1]], [0, o[1]]);
                var c = s[1].slice(o[1].length);
                return (c.length > 0 && r.splice(a + 2, 0, [s[0], c]), v(r, a, 3));
              } else return e;
            }
            function g(e) {
              for (
                var t = !1,
                  a = function (e) {
                    return e.charCodeAt(0) >= 56320 && e.charCodeAt(0) <= 57343;
                  },
                  o = function (e) {
                    return (
                      e.charCodeAt(e.length - 1) >= 55296 && e.charCodeAt(e.length - 1) <= 56319
                    );
                  },
                  s = 2;
                s < e.length;
                s += 1
              )
                e[s - 2][0] === i &&
                  o(e[s - 2][1]) &&
                  e[s - 1][0] === n &&
                  a(e[s - 1][1]) &&
                  e[s][0] === r &&
                  a(e[s][1]) &&
                  ((t = !0),
                  (e[s - 1][1] = e[s - 2][1].slice(-1) + e[s - 1][1]),
                  (e[s][1] = e[s - 2][1].slice(-1) + e[s][1]),
                  (e[s - 2][1] = e[s - 2][1].slice(0, -1)));
              if (!t) return e;
              for (var c = [], s = 0; s < e.length; s += 1) e[s][1].length > 0 && c.push(e[s]);
              return c;
            }
            function v(e, t, n) {
              for (var r = t + n - 1; r >= 0 && r >= t - 1; r--)
                if (r + 1 < e.length) {
                  var i = e[r],
                    a = e[r + 1];
                  i[0] === a[1] && e.splice(r, 2, [i[0], i[1] + a[1]]);
                }
              return e;
            }
          },
          function (e, t) {
            ((t = e.exports = typeof Object.keys == `function` ? Object.keys : n), (t.shim = n));
            function n(e) {
              var t = [];
              for (var n in e) t.push(n);
              return t;
            }
          },
          function (e, t) {
            ((t = e.exports =
              (function () {
                return Object.prototype.toString.call(arguments);
              })() == `[object Arguments]`
                ? n
                : r),
              (t.supported = n));
            function n(e) {
              return Object.prototype.toString.call(e) == `[object Arguments]`;
            }
            t.unsupported = r;
            function r(e) {
              return (
                (e &&
                  typeof e == `object` &&
                  typeof e.length == `number` &&
                  Object.prototype.hasOwnProperty.call(e, `callee`) &&
                  !Object.prototype.propertyIsEnumerable.call(e, `callee`)) ||
                !1
              );
            }
          },
          function (e, t) {
            var n = Object.prototype.hasOwnProperty,
              r = `~`;
            function i() {}
            Object.create && ((i.prototype = Object.create(null)), new i().__proto__ || (r = !1));
            function a(e, t, n) {
              ((this.fn = e), (this.context = t), (this.once = n || !1));
            }
            function o() {
              ((this._events = new i()), (this._eventsCount = 0));
            }
            ((o.prototype.eventNames = function () {
              var e = [],
                t,
                i;
              if (this._eventsCount === 0) return e;
              for (i in (t = this._events)) n.call(t, i) && e.push(r ? i.slice(1) : i);
              return Object.getOwnPropertySymbols ? e.concat(Object.getOwnPropertySymbols(t)) : e;
            }),
              (o.prototype.listeners = function (e, t) {
                var n = r ? r + e : e,
                  i = this._events[n];
                if (t) return !!i;
                if (!i) return [];
                if (i.fn) return [i.fn];
                for (var a = 0, o = i.length, s = Array(o); a < o; a++) s[a] = i[a].fn;
                return s;
              }),
              (o.prototype.emit = function (e, t, n, i, a, o) {
                var s = r ? r + e : e;
                if (!this._events[s]) return !1;
                var c = this._events[s],
                  l = arguments.length,
                  u,
                  d;
                if (c.fn) {
                  switch ((c.once && this.removeListener(e, c.fn, void 0, !0), l)) {
                    case 1:
                      return (c.fn.call(c.context), !0);
                    case 2:
                      return (c.fn.call(c.context, t), !0);
                    case 3:
                      return (c.fn.call(c.context, t, n), !0);
                    case 4:
                      return (c.fn.call(c.context, t, n, i), !0);
                    case 5:
                      return (c.fn.call(c.context, t, n, i, a), !0);
                    case 6:
                      return (c.fn.call(c.context, t, n, i, a, o), !0);
                  }
                  for (d = 1, u = Array(l - 1); d < l; d++) u[d - 1] = arguments[d];
                  c.fn.apply(c.context, u);
                } else {
                  var f = c.length,
                    p;
                  for (d = 0; d < f; d++)
                    switch ((c[d].once && this.removeListener(e, c[d].fn, void 0, !0), l)) {
                      case 1:
                        c[d].fn.call(c[d].context);
                        break;
                      case 2:
                        c[d].fn.call(c[d].context, t);
                        break;
                      case 3:
                        c[d].fn.call(c[d].context, t, n);
                        break;
                      case 4:
                        c[d].fn.call(c[d].context, t, n, i);
                        break;
                      default:
                        if (!u) for (p = 1, u = Array(l - 1); p < l; p++) u[p - 1] = arguments[p];
                        c[d].fn.apply(c[d].context, u);
                    }
                }
                return !0;
              }),
              (o.prototype.on = function (e, t, n) {
                var i = new a(t, n || this),
                  o = r ? r + e : e;
                return (
                  this._events[o]
                    ? this._events[o].fn
                      ? (this._events[o] = [this._events[o], i])
                      : this._events[o].push(i)
                    : ((this._events[o] = i), this._eventsCount++),
                  this
                );
              }),
              (o.prototype.once = function (e, t, n) {
                var i = new a(t, n || this, !0),
                  o = r ? r + e : e;
                return (
                  this._events[o]
                    ? this._events[o].fn
                      ? (this._events[o] = [this._events[o], i])
                      : this._events[o].push(i)
                    : ((this._events[o] = i), this._eventsCount++),
                  this
                );
              }),
              (o.prototype.removeListener = function (e, t, n, a) {
                var o = r ? r + e : e;
                if (!this._events[o]) return this;
                if (!t)
                  return (
                    --this._eventsCount === 0 ? (this._events = new i()) : delete this._events[o],
                    this
                  );
                var s = this._events[o];
                if (s.fn)
                  s.fn === t &&
                    (!a || s.once) &&
                    (!n || s.context === n) &&
                    (--this._eventsCount === 0 ? (this._events = new i()) : delete this._events[o]);
                else {
                  for (var c = 0, l = [], u = s.length; c < u; c++)
                    (s[c].fn !== t || (a && !s[c].once) || (n && s[c].context !== n)) &&
                      l.push(s[c]);
                  l.length
                    ? (this._events[o] = l.length === 1 ? l[0] : l)
                    : --this._eventsCount === 0
                      ? (this._events = new i())
                      : delete this._events[o];
                }
                return this;
              }),
              (o.prototype.removeAllListeners = function (e) {
                var t;
                return (
                  e
                    ? ((t = r ? r + e : e),
                      this._events[t] &&
                        (--this._eventsCount === 0
                          ? (this._events = new i())
                          : delete this._events[t]))
                    : ((this._events = new i()), (this._eventsCount = 0)),
                  this
                );
              }),
              (o.prototype.off = o.prototype.removeListener),
              (o.prototype.addListener = o.prototype.on),
              (o.prototype.setMaxListeners = function () {
                return this;
              }),
              (o.prefixed = r),
              (o.EventEmitter = o),
              e !== void 0 && (e.exports = o));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.matchText =
                t.matchSpacing =
                t.matchNewline =
                t.matchBlot =
                t.matchAttributor =
                t.default =
                  void 0));
            var r =
                typeof Symbol == `function` && typeof Symbol.iterator == `symbol`
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e &&
                        typeof Symbol == `function` &&
                        e.constructor === Symbol &&
                        e !== Symbol.prototype
                        ? `symbol`
                        : typeof e;
                    },
              i = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              a = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              o = b(n(3)),
              s = b(n(2)),
              c = b(n(0)),
              l = b(n(5)),
              u = b(n(10)),
              d = b(n(9)),
              f = n(36),
              p = n(37),
              m = b(n(13)),
              h = n(26),
              g = n(38),
              v = n(39),
              y = n(40);
            function b(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function x(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function S(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function C(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function w(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var T = (0, u.default)(`quill:clipboard`),
              E = `__ql-matcher`,
              D = [
                [Node.TEXT_NODE, pe],
                [Node.TEXT_NODE, ue],
                [`br`, se],
                [Node.ELEMENT_NODE, ue],
                [Node.ELEMENT_NODE, oe],
                [Node.ELEMENT_NODE, de],
                [Node.ELEMENT_NODE, ae],
                [Node.ELEMENT_NODE, fe],
                [`li`, le],
                [`b`, j.bind(j, `bold`)],
                [`i`, j.bind(j, `italic`)],
                [`style`, ce],
              ],
              ee = [f.AlignAttribute, g.DirectionAttribute].reduce(function (e, t) {
                return ((e[t.keyName] = t), e);
              }, {}),
              te = [
                f.AlignStyle,
                p.BackgroundStyle,
                h.ColorStyle,
                g.DirectionStyle,
                v.FontStyle,
                y.SizeStyle,
              ].reduce(function (e, t) {
                return ((e[t.keyName] = t), e);
              }, {}),
              O = (function (e) {
                w(t, e);
                function t(e, n) {
                  S(this, t);
                  var r = C(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                  return (
                    r.quill.root.addEventListener(`paste`, r.onPaste.bind(r)),
                    (r.container = r.quill.addContainer(`ql-clipboard`)),
                    r.container.setAttribute(`contenteditable`, !0),
                    r.container.setAttribute(`tabindex`, -1),
                    (r.matchers = []),
                    D.concat(r.options.matchers).forEach(function (e) {
                      var t = i(e, 2),
                        a = t[0],
                        o = t[1];
                      (!n.matchVisual && o === de) || r.addMatcher(a, o);
                    }),
                    r
                  );
                }
                return (
                  a(t, [
                    {
                      key: `addMatcher`,
                      value: function (e, t) {
                        this.matchers.push([e, t]);
                      },
                    },
                    {
                      key: `convert`,
                      value: function (e) {
                        if (typeof e == `string`)
                          return (
                            (this.container.innerHTML = e.replace(/\>\r?\n +\</g, `><`)),
                            this.convert()
                          );
                        var t = this.quill.getFormat(this.quill.selection.savedRange.index);
                        if (t[m.default.blotName]) {
                          var n = this.container.innerText;
                          return (
                            (this.container.innerHTML = ``),
                            new s.default().insert(
                              n,
                              x({}, m.default.blotName, t[m.default.blotName]),
                            )
                          );
                        }
                        var r = i(this.prepareMatching(), 2),
                          a = r[0],
                          o = r[1],
                          c = ie(this.container, a, o);
                        return (
                          re(
                            c,
                            `
`,
                          ) &&
                            c.ops[c.ops.length - 1].attributes == null &&
                            (c = c.compose(new s.default().retain(c.length() - 1).delete(1))),
                          T.log(`convert`, this.container.innerHTML, c),
                          (this.container.innerHTML = ``),
                          c
                        );
                      },
                    },
                    {
                      key: `dangerouslyPasteHTML`,
                      value: function (e, t) {
                        var n =
                          arguments.length > 2 && arguments[2] !== void 0
                            ? arguments[2]
                            : l.default.sources.API;
                        if (typeof e == `string`)
                          (this.quill.setContents(this.convert(e), t),
                            this.quill.setSelection(0, l.default.sources.SILENT));
                        else {
                          var r = this.convert(t);
                          (this.quill.updateContents(new s.default().retain(e).concat(r), n),
                            this.quill.setSelection(e + r.length(), l.default.sources.SILENT));
                        }
                      },
                    },
                    {
                      key: `onPaste`,
                      value: function (e) {
                        var t = this;
                        if (!(e.defaultPrevented || !this.quill.isEnabled())) {
                          var n = this.quill.getSelection(),
                            r = new s.default().retain(n.index),
                            i = this.quill.scrollingContainer.scrollTop;
                          (this.container.focus(),
                            this.quill.selection.update(l.default.sources.SILENT),
                            setTimeout(function () {
                              ((r = r.concat(t.convert()).delete(n.length)),
                                t.quill.updateContents(r, l.default.sources.USER),
                                t.quill.setSelection(
                                  r.length() - n.length,
                                  l.default.sources.SILENT,
                                ),
                                (t.quill.scrollingContainer.scrollTop = i),
                                t.quill.focus());
                            }, 1));
                        }
                      },
                    },
                    {
                      key: `prepareMatching`,
                      value: function () {
                        var e = this,
                          t = [],
                          n = [];
                        return (
                          this.matchers.forEach(function (r) {
                            var a = i(r, 2),
                              o = a[0],
                              s = a[1];
                            switch (o) {
                              case Node.TEXT_NODE:
                                n.push(s);
                                break;
                              case Node.ELEMENT_NODE:
                                t.push(s);
                                break;
                              default:
                                [].forEach.call(e.container.querySelectorAll(o), function (e) {
                                  ((e[E] = e[E] || []), e[E].push(s));
                                });
                                break;
                            }
                          }),
                          [t, n]
                        );
                      },
                    },
                  ]),
                  t
                );
              })(d.default);
            O.DEFAULTS = {
              matchers: [],
              matchVisual: !0,
            };
            function k(e, t, n) {
              return (t === void 0 ? `undefined` : r(t)) === `object`
                ? Object.keys(t).reduce(function (e, n) {
                    return k(e, n, t[n]);
                  }, e)
                : e.reduce(function (e, r) {
                    return r.attributes && r.attributes[t]
                      ? e.push(r)
                      : e.insert(r.insert, (0, o.default)({}, x({}, t, n), r.attributes));
                  }, new s.default());
            }
            function ne(e) {
              if (e.nodeType !== Node.ELEMENT_NODE) return {};
              var t = `__ql-computed-style`;
              return e[t] || (e[t] = window.getComputedStyle(e));
            }
            function re(e, t) {
              for (var n = ``, r = e.ops.length - 1; r >= 0 && n.length < t.length; --r) {
                var i = e.ops[r];
                if (typeof i.insert != `string`) break;
                n = i.insert + n;
              }
              return n.slice(-1 * t.length) === t;
            }
            function A(e) {
              if (e.childNodes.length === 0) return !1;
              var t = ne(e);
              return [`block`, `list-item`].indexOf(t.display) > -1;
            }
            function ie(e, t, n) {
              return e.nodeType === e.TEXT_NODE
                ? n.reduce(function (t, n) {
                    return n(e, t);
                  }, new s.default())
                : e.nodeType === e.ELEMENT_NODE
                  ? [].reduce.call(
                      e.childNodes || [],
                      function (r, i) {
                        var a = ie(i, t, n);
                        return (
                          i.nodeType === e.ELEMENT_NODE &&
                            ((a = t.reduce(function (e, t) {
                              return t(i, e);
                            }, a)),
                            (a = (i[E] || []).reduce(function (e, t) {
                              return t(i, e);
                            }, a))),
                          r.concat(a)
                        );
                      },
                      new s.default(),
                    )
                  : new s.default();
            }
            function j(e, t, n) {
              return k(n, e, !0);
            }
            function ae(e, t) {
              var n = c.default.Attributor.Attribute.keys(e),
                r = c.default.Attributor.Class.keys(e),
                i = c.default.Attributor.Style.keys(e),
                a = {};
              return (
                n
                  .concat(r)
                  .concat(i)
                  .forEach(function (t) {
                    var n = c.default.query(t, c.default.Scope.ATTRIBUTE);
                    (n != null && ((a[n.attrName] = n.value(e)), a[n.attrName])) ||
                      ((n = ee[t]),
                      n != null &&
                        (n.attrName === t || n.keyName === t) &&
                        (a[n.attrName] = n.value(e) || void 0),
                      (n = te[t]),
                      n != null &&
                        (n.attrName === t || n.keyName === t) &&
                        ((n = te[t]), (a[n.attrName] = n.value(e) || void 0)));
                  }),
                Object.keys(a).length > 0 && (t = k(t, a)),
                t
              );
            }
            function oe(e, t) {
              var n = c.default.query(e);
              if (n == null) return t;
              if (n.prototype instanceof c.default.Embed) {
                var r = {},
                  i = n.value(e);
                i != null && ((r[n.blotName] = i), (t = new s.default().insert(r, n.formats(e))));
              } else typeof n.formats == `function` && (t = k(t, n.blotName, n.formats(e)));
              return t;
            }
            function se(e, t) {
              return (
                re(
                  t,
                  `
`,
                ) ||
                  t.insert(`
`),
                t
              );
            }
            function ce() {
              return new s.default();
            }
            function le(e, t) {
              var n = c.default.query(e);
              if (
                n == null ||
                n.blotName !== `list-item` ||
                !re(
                  t,
                  `
`,
                )
              )
                return t;
              for (var r = -1, i = e.parentNode; !i.classList.contains(`ql-clipboard`);)
                ((c.default.query(i) || {}).blotName === `list` && (r += 1), (i = i.parentNode));
              return r <= 0
                ? t
                : t.compose(
                    new s.default().retain(t.length() - 1).retain(1, {
                      indent: r,
                    }),
                  );
            }
            function ue(e, t) {
              return (
                re(
                  t,
                  `
`,
                ) ||
                  ((A(e) || (t.length() > 0 && e.nextSibling && A(e.nextSibling))) &&
                    t.insert(`
`)),
                t
              );
            }
            function de(e, t) {
              if (
                A(e) &&
                e.nextElementSibling != null &&
                !re(
                  t,
                  `

`,
                )
              ) {
                var n =
                  e.offsetHeight + parseFloat(ne(e).marginTop) + parseFloat(ne(e).marginBottom);
                e.nextElementSibling.offsetTop > e.offsetTop + n * 1.5 &&
                  t.insert(`
`);
              }
              return t;
            }
            function fe(e, t) {
              var n = {},
                r = e.style || {};
              return (
                r.fontStyle && ne(e).fontStyle === `italic` && (n.italic = !0),
                r.fontWeight &&
                  (ne(e).fontWeight.startsWith(`bold`) || parseInt(ne(e).fontWeight) >= 700) &&
                  (n.bold = !0),
                Object.keys(n).length > 0 && (t = k(t, n)),
                parseFloat(r.textIndent || 0) > 0 && (t = new s.default().insert(`	`).concat(t)),
                t
              );
            }
            function pe(e, t) {
              var n = e.data;
              if (e.parentNode.tagName === `O:P`) return t.insert(n.trim());
              if (n.trim().length === 0 && e.parentNode.classList.contains(`ql-clipboard`))
                return t;
              if (!ne(e.parentNode).whiteSpace.startsWith(`pre`)) {
                var r = function (e, t) {
                  return ((t = t.replace(/[^\u00a0]/g, ``)), t.length < 1 && e ? ` ` : t);
                };
                ((n = n.replace(/\r\n/g, ` `).replace(/\n/g, ` `)),
                  (n = n.replace(/\s\s+/g, r.bind(r, !0))),
                  ((e.previousSibling == null && A(e.parentNode)) ||
                    (e.previousSibling != null && A(e.previousSibling))) &&
                    (n = n.replace(/^\s+/, r.bind(r, !1))),
                  ((e.nextSibling == null && A(e.parentNode)) ||
                    (e.nextSibling != null && A(e.nextSibling))) &&
                    (n = n.replace(/\s+$/, r.bind(r, !1))));
              }
              return t.insert(n);
            }
            ((t.default = O),
              (t.matchAttributor = ae),
              (t.matchBlot = oe),
              (t.matchNewline = ue),
              (t.matchSpacing = de),
              (t.matchText = pe));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(6));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var u = (function (e) {
              l(t, e);
              function t() {
                return (
                  s(this, t),
                  c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(
                  t,
                  [
                    {
                      key: `optimize`,
                      value: function (e) {
                        (i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `optimize`,
                          this,
                        ).call(this, e),
                          this.domNode.tagName !== this.statics.tagName[0] &&
                            this.replaceWith(this.statics.blotName));
                      },
                    },
                  ],
                  [
                    {
                      key: `create`,
                      value: function () {
                        return i(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                          this,
                        );
                      },
                    },
                    {
                      key: `formats`,
                      value: function () {
                        return !0;
                      },
                    },
                  ],
                ),
                t
              );
            })(a.default);
            ((u.blotName = `bold`), (u.tagName = [`STRONG`, `B`]), (t.default = u));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.addControls = t.default = void 0));
            var r = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              i = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              a = u(n(2)),
              o = u(n(0)),
              s = u(n(5)),
              c = u(n(10)),
              l = u(n(9));
            function u(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function d(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function f(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function p(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function m(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var h = (0, c.default)(`quill:toolbar`),
              g = (function (e) {
                m(t, e);
                function t(e, n) {
                  f(this, t);
                  var i = p(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                  if (Array.isArray(i.options.container)) {
                    var a = document.createElement(`div`);
                    (y(a, i.options.container),
                      e.container.parentNode.insertBefore(a, e.container),
                      (i.container = a));
                  } else
                    typeof i.options.container == `string`
                      ? (i.container = document.querySelector(i.options.container))
                      : (i.container = i.options.container);
                  if (!(i.container instanceof HTMLElement)) {
                    var o;
                    return ((o = h.error(`Container required for toolbar`, i.options)), p(i, o));
                  }
                  return (
                    i.container.classList.add(`ql-toolbar`),
                    (i.controls = []),
                    (i.handlers = {}),
                    Object.keys(i.options.handlers).forEach(function (e) {
                      i.addHandler(e, i.options.handlers[e]);
                    }),
                    [].forEach.call(i.container.querySelectorAll(`button, select`), function (e) {
                      i.attach(e);
                    }),
                    i.quill.on(s.default.events.EDITOR_CHANGE, function (e, t) {
                      e === s.default.events.SELECTION_CHANGE && i.update(t);
                    }),
                    i.quill.on(s.default.events.SCROLL_OPTIMIZE, function () {
                      var e = r(i.quill.selection.getRange(), 1)[0];
                      i.update(e);
                    }),
                    i
                  );
                }
                return (
                  i(t, [
                    {
                      key: `addHandler`,
                      value: function (e, t) {
                        this.handlers[e] = t;
                      },
                    },
                    {
                      key: `attach`,
                      value: function (e) {
                        var t = this,
                          n = [].find.call(e.classList, function (e) {
                            return e.indexOf(`ql-`) === 0;
                          });
                        if (n) {
                          if (
                            ((n = n.slice(3)),
                            e.tagName === `BUTTON` && e.setAttribute(`type`, `button`),
                            this.handlers[n] == null)
                          ) {
                            if (
                              this.quill.scroll.whitelist != null &&
                              this.quill.scroll.whitelist[n] == null
                            ) {
                              h.warn(`ignoring attaching to disabled format`, n, e);
                              return;
                            }
                            if (o.default.query(n) == null) {
                              h.warn(`ignoring attaching to nonexistent format`, n, e);
                              return;
                            }
                          }
                          var i = e.tagName === `SELECT` ? `change` : `click`;
                          (e.addEventListener(i, function (i) {
                            var c = void 0;
                            if (e.tagName === `SELECT`) {
                              if (e.selectedIndex < 0) return;
                              var l = e.options[e.selectedIndex];
                              c = l.hasAttribute(`selected`) ? !1 : l.value || !1;
                            } else
                              ((c = e.classList.contains(`ql-active`)
                                ? !1
                                : e.value || !e.hasAttribute(`value`)),
                                i.preventDefault());
                            t.quill.focus();
                            var u = r(t.quill.selection.getRange(), 1)[0];
                            if (t.handlers[n] != null) t.handlers[n].call(t, c);
                            else if (o.default.query(n).prototype instanceof o.default.Embed) {
                              if (((c = prompt(`Enter ` + n)), !c)) return;
                              t.quill.updateContents(
                                new a.default()
                                  .retain(u.index)
                                  .delete(u.length)
                                  .insert(d({}, n, c)),
                                s.default.sources.USER,
                              );
                            } else t.quill.format(n, c, s.default.sources.USER);
                            t.update(u);
                          }),
                            this.controls.push([n, e]));
                        }
                      },
                    },
                    {
                      key: `update`,
                      value: function (e) {
                        var t = e == null ? {} : this.quill.getFormat(e);
                        this.controls.forEach(function (n) {
                          var i = r(n, 2),
                            a = i[0],
                            o = i[1];
                          if (o.tagName === `SELECT`) {
                            var s = void 0;
                            if (e == null) s = null;
                            else if (t[a] == null) s = o.querySelector(`option[selected]`);
                            else if (!Array.isArray(t[a])) {
                              var c = t[a];
                              (typeof c == `string` && (c = c.replace(/\"/g, `\\"`)),
                                (s = o.querySelector(`option[value="` + c + `"]`)));
                            }
                            s == null
                              ? ((o.value = ``), (o.selectedIndex = -1))
                              : (s.selected = !0);
                          } else if (e == null) o.classList.remove(`ql-active`);
                          else if (o.hasAttribute(`value`)) {
                            var l =
                              t[a] === o.getAttribute(`value`) ||
                              (t[a] != null && t[a].toString() === o.getAttribute(`value`)) ||
                              (t[a] == null && !o.getAttribute(`value`));
                            o.classList.toggle(`ql-active`, l);
                          } else o.classList.toggle(`ql-active`, t[a] != null);
                        });
                      },
                    },
                  ]),
                  t
                );
              })(l.default);
            g.DEFAULTS = {};
            function v(e, t, n) {
              var r = document.createElement(`button`);
              (r.setAttribute(`type`, `button`),
                r.classList.add(`ql-` + t),
                n != null && (r.value = n),
                e.appendChild(r));
            }
            function y(e, t) {
              (Array.isArray(t[0]) || (t = [t]),
                t.forEach(function (t) {
                  var n = document.createElement(`span`);
                  (n.classList.add(`ql-formats`),
                    t.forEach(function (e) {
                      if (typeof e == `string`) v(n, e);
                      else {
                        var t = Object.keys(e)[0],
                          r = e[t];
                        Array.isArray(r) ? b(n, t, r) : v(n, t, r);
                      }
                    }),
                    e.appendChild(n));
                }));
            }
            function b(e, t, n) {
              var r = document.createElement(`select`);
              (r.classList.add(`ql-` + t),
                n.forEach(function (e) {
                  var t = document.createElement(`option`);
                  (e === !1 ? t.setAttribute(`selected`, `selected`) : t.setAttribute(`value`, e),
                    r.appendChild(t));
                }),
                e.appendChild(r));
            }
            ((g.DEFAULTS = {
              container: null,
              handlers: {
                clean: function () {
                  var e = this,
                    t = this.quill.getSelection();
                  if (t != null)
                    if (t.length == 0) {
                      var n = this.quill.getFormat();
                      Object.keys(n).forEach(function (t) {
                        o.default.query(t, o.default.Scope.INLINE) != null && e.quill.format(t, !1);
                      });
                    } else this.quill.removeFormat(t, s.default.sources.USER);
                },
                direction: function (e) {
                  var t = this.quill.getFormat().align;
                  (e === `rtl` && t == null
                    ? this.quill.format(`align`, `right`, s.default.sources.USER)
                    : !e && t === `right` && this.quill.format(`align`, !1, s.default.sources.USER),
                    this.quill.format(`direction`, e, s.default.sources.USER));
                },
                indent: function (e) {
                  var t = this.quill.getSelection(),
                    n = this.quill.getFormat(t),
                    r = parseInt(n.indent || 0);
                  if (e === `+1` || e === `-1`) {
                    var i = e === `+1` ? 1 : -1;
                    (n.direction === `rtl` && (i *= -1),
                      this.quill.format(`indent`, r + i, s.default.sources.USER));
                  }
                },
                link: function (e) {
                  (e === !0 && (e = prompt(`Enter link URL:`)),
                    this.quill.format(`link`, e, s.default.sources.USER));
                },
                list: function (e) {
                  var t = this.quill.getSelection(),
                    n = this.quill.getFormat(t);
                  e === `check`
                    ? n.list === `checked` || n.list === `unchecked`
                      ? this.quill.format(`list`, !1, s.default.sources.USER)
                      : this.quill.format(`list`, `unchecked`, s.default.sources.USER)
                    : this.quill.format(`list`, e, s.default.sources.USER);
                },
              },
            }),
              (t.default = g),
              (t.addControls = y));
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>`;
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(28));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            t.default = (function (e) {
              l(t, e);
              function t(e, n) {
                s(this, t);
                var r = c(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return (
                  (r.label.innerHTML = n),
                  r.container.classList.add(`ql-color-picker`),
                  [].slice
                    .call(r.container.querySelectorAll(`.ql-picker-item`), 0, 7)
                    .forEach(function (e) {
                      e.classList.add(`ql-primary`);
                    }),
                  r
                );
              }
              return (
                r(t, [
                  {
                    key: `buildItem`,
                    value: function (e) {
                      var n = i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `buildItem`,
                        this,
                      ).call(this, e);
                      return ((n.style.backgroundColor = e.getAttribute(`value`) || ``), n);
                    },
                  },
                  {
                    key: `selectItem`,
                    value: function (e, n) {
                      i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `selectItem`,
                        this,
                      ).call(this, e, n);
                      var r = this.label.querySelector(`.ql-color-label`),
                        a = (e && e.getAttribute(`data-value`)) || ``;
                      r && (r.tagName === `line` ? (r.style.stroke = a) : (r.style.fill = a));
                    },
                  },
                ]),
                t
              );
            })(a.default);
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(28));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            t.default = (function (e) {
              l(t, e);
              function t(e, n) {
                s(this, t);
                var r = c(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                return (
                  r.container.classList.add(`ql-icon-picker`),
                  [].forEach.call(r.container.querySelectorAll(`.ql-picker-item`), function (e) {
                    e.innerHTML = n[e.getAttribute(`data-value`) || ``];
                  }),
                  (r.defaultItem = r.container.querySelector(`.ql-selected`)),
                  r.selectItem(r.defaultItem),
                  r
                );
              }
              return (
                r(t, [
                  {
                    key: `selectItem`,
                    value: function (e, n) {
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `selectItem`,
                        this,
                      ).call(this, e, n),
                        (e ||= this.defaultItem),
                        (this.label.innerHTML = e.innerHTML));
                    },
                  },
                ]),
                t
              );
            })(a.default);
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var r = t[n];
                  ((r.enumerable = r.enumerable || !1),
                    (r.configurable = !0),
                    `value` in r && (r.writable = !0),
                    Object.defineProperty(e, r.key, r));
                }
              }
              return function (t, n, r) {
                return (n && e(t.prototype, n), r && e(t, r), t);
              };
            })();
            function i(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            t.default = (function () {
              function e(t, n) {
                var r = this;
                (i(this, e),
                  (this.quill = t),
                  (this.boundsContainer = n || document.body),
                  (this.root = t.addContainer(`ql-tooltip`)),
                  (this.root.innerHTML = this.constructor.TEMPLATE),
                  this.quill.root === this.quill.scrollingContainer &&
                    this.quill.root.addEventListener(`scroll`, function () {
                      r.root.style.marginTop = -1 * r.quill.root.scrollTop + `px`;
                    }),
                  this.hide());
              }
              return (
                r(e, [
                  {
                    key: `hide`,
                    value: function () {
                      this.root.classList.add(`ql-hidden`);
                    },
                  },
                  {
                    key: `position`,
                    value: function (e) {
                      var t = e.left + e.width / 2 - this.root.offsetWidth / 2,
                        n = e.bottom + this.quill.root.scrollTop;
                      ((this.root.style.left = t + `px`),
                        (this.root.style.top = n + `px`),
                        this.root.classList.remove(`ql-flip`));
                      var r = this.boundsContainer.getBoundingClientRect(),
                        i = this.root.getBoundingClientRect(),
                        a = 0;
                      if (
                        (i.right > r.right &&
                          ((a = r.right - i.right), (this.root.style.left = t + a + `px`)),
                        i.left < r.left &&
                          ((a = r.left - i.left), (this.root.style.left = t + a + `px`)),
                        i.bottom > r.bottom)
                      ) {
                        var o = i.bottom - i.top,
                          s = e.bottom - e.top + o;
                        ((this.root.style.top = n - s + `px`), this.root.classList.add(`ql-flip`));
                      }
                      return a;
                    },
                  },
                  {
                    key: `show`,
                    value: function () {
                      (this.root.classList.remove(`ql-editing`),
                        this.root.classList.remove(`ql-hidden`));
                    },
                  },
                ]),
                e
              );
            })();
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  var n = [],
                    r = !0,
                    i = !1,
                    a = void 0;
                  try {
                    for (
                      var o = e[Symbol.iterator](), s;
                      !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t));
                      r = !0
                    );
                  } catch (e) {
                    ((i = !0), (a = e));
                  } finally {
                    try {
                      !r && o.return && o.return();
                    } finally {
                      if (i) throw a;
                    }
                  }
                  return n;
                }
                return function (t, n) {
                  if (Array.isArray(t)) return t;
                  if (Symbol.iterator in Object(t)) return e(t, n);
                  throw TypeError(`Invalid attempt to destructure non-iterable instance`);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              o = p(n(3)),
              s = p(n(8)),
              c = n(43),
              l = p(c),
              u = p(n(27)),
              d = n(15),
              f = p(n(41));
            function p(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function m(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function h(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function g(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var v = [
                [
                  {
                    header: [`1`, `2`, `3`, !1],
                  },
                ],
                [`bold`, `italic`, `underline`, `link`],
                [
                  {
                    list: `ordered`,
                  },
                  {
                    list: `bullet`,
                  },
                ],
                [`clean`],
              ],
              y = (function (e) {
                g(t, e);
                function t(e, n) {
                  (m(this, t),
                    n.modules.toolbar != null &&
                      n.modules.toolbar.container == null &&
                      (n.modules.toolbar.container = v));
                  var r = h(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                  return (r.quill.container.classList.add(`ql-snow`), r);
                }
                return (
                  a(t, [
                    {
                      key: `extendToolbar`,
                      value: function (e) {
                        (e.container.classList.add(`ql-snow`),
                          this.buildButtons(
                            [].slice.call(e.container.querySelectorAll(`button`)),
                            f.default,
                          ),
                          this.buildPickers(
                            [].slice.call(e.container.querySelectorAll(`select`)),
                            f.default,
                          ),
                          (this.tooltip = new b(this.quill, this.options.bounds)),
                          e.container.querySelector(`.ql-link`) &&
                            this.quill.keyboard.addBinding(
                              {
                                key: `K`,
                                shortKey: !0,
                              },
                              function (t, n) {
                                e.handlers.link.call(e, !n.format.link);
                              },
                            ));
                      },
                    },
                  ]),
                  t
                );
              })(l.default);
            y.DEFAULTS = (0, o.default)(!0, {}, l.default.DEFAULTS, {
              modules: {
                toolbar: {
                  handlers: {
                    link: function (e) {
                      if (e) {
                        var t = this.quill.getSelection();
                        if (t == null || t.length == 0) return;
                        var n = this.quill.getText(t);
                        (/^\S+@\S+\.\S+$/.test(n) &&
                          n.indexOf(`mailto:`) !== 0 &&
                          (n = `mailto:` + n),
                          this.quill.theme.tooltip.edit(`link`, n));
                      } else this.quill.format(`link`, !1);
                    },
                  },
                },
              },
            });
            var b = (function (e) {
              g(t, e);
              function t(e, n) {
                m(this, t);
                var r = h(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                return ((r.preview = r.root.querySelector(`a.ql-preview`)), r);
              }
              return (
                a(t, [
                  {
                    key: `listen`,
                    value: function () {
                      var e = this;
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `listen`,
                        this,
                      ).call(this),
                        this.root
                          .querySelector(`a.ql-action`)
                          .addEventListener(`click`, function (t) {
                            (e.root.classList.contains(`ql-editing`)
                              ? e.save()
                              : e.edit(`link`, e.preview.textContent),
                              t.preventDefault());
                          }),
                        this.root
                          .querySelector(`a.ql-remove`)
                          .addEventListener(`click`, function (t) {
                            if (e.linkRange != null) {
                              var n = e.linkRange;
                              (e.restoreFocus(),
                                e.quill.formatText(n, `link`, !1, s.default.sources.USER),
                                delete e.linkRange);
                            }
                            (t.preventDefault(), e.hide());
                          }),
                        this.quill.on(s.default.events.SELECTION_CHANGE, function (t, n, i) {
                          if (t != null) {
                            if (t.length === 0 && i === s.default.sources.USER) {
                              var a = r(e.quill.scroll.descendant(u.default, t.index), 2),
                                o = a[0],
                                c = a[1];
                              if (o != null) {
                                e.linkRange = new d.Range(t.index - c, o.length());
                                var l = u.default.formats(o.domNode);
                                ((e.preview.textContent = l),
                                  e.preview.setAttribute(`href`, l),
                                  e.show(),
                                  e.position(e.quill.getBounds(e.linkRange)));
                                return;
                              }
                            } else delete e.linkRange;
                            e.hide();
                          }
                        }));
                    },
                  },
                  {
                    key: `show`,
                    value: function () {
                      (i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `show`,
                        this,
                      ).call(this),
                        this.root.removeAttribute(`data-mode`));
                    },
                  },
                ]),
                t
              );
            })(c.BaseTooltip);
            ((b.TEMPLATE = [
              `<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>`,
              `<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">`,
              `<a class="ql-action"></a>`,
              `<a class="ql-remove"></a>`,
            ].join(``)),
              (t.default = y));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = j(n(29)),
              i = n(36),
              a = n(38),
              o = n(64),
              s = j(n(65)),
              c = j(n(66)),
              l = n(67),
              u = j(l),
              d = n(37),
              f = n(26),
              p = n(39),
              m = n(40),
              h = j(n(56)),
              g = j(n(68)),
              v = j(n(27)),
              y = j(n(69)),
              b = j(n(70)),
              x = j(n(71)),
              S = j(n(72)),
              C = j(n(73)),
              w = n(13),
              T = j(w),
              E = j(n(74)),
              D = j(n(75)),
              ee = j(n(57)),
              te = j(n(41)),
              O = j(n(28)),
              k = j(n(59)),
              ne = j(n(60)),
              re = j(n(61)),
              A = j(n(108)),
              ie = j(n(62));
            function j(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            (r.default.register(
              {
                "attributors/attribute/direction": a.DirectionAttribute,
                "attributors/class/align": i.AlignClass,
                "attributors/class/background": d.BackgroundClass,
                "attributors/class/color": f.ColorClass,
                "attributors/class/direction": a.DirectionClass,
                "attributors/class/font": p.FontClass,
                "attributors/class/size": m.SizeClass,
                "attributors/style/align": i.AlignStyle,
                "attributors/style/background": d.BackgroundStyle,
                "attributors/style/color": f.ColorStyle,
                "attributors/style/direction": a.DirectionStyle,
                "attributors/style/font": p.FontStyle,
                "attributors/style/size": m.SizeStyle,
              },
              !0,
            ),
              r.default.register(
                {
                  "formats/align": i.AlignClass,
                  "formats/direction": a.DirectionClass,
                  "formats/indent": o.IndentClass,
                  "formats/background": d.BackgroundStyle,
                  "formats/color": f.ColorStyle,
                  "formats/font": p.FontClass,
                  "formats/size": m.SizeClass,
                  "formats/blockquote": s.default,
                  "formats/code-block": T.default,
                  "formats/header": c.default,
                  "formats/list": u.default,
                  "formats/bold": h.default,
                  "formats/code": w.Code,
                  "formats/italic": g.default,
                  "formats/link": v.default,
                  "formats/script": y.default,
                  "formats/strike": b.default,
                  "formats/underline": x.default,
                  "formats/image": S.default,
                  "formats/video": C.default,
                  "formats/list/item": l.ListItem,
                  "modules/formula": E.default,
                  "modules/syntax": D.default,
                  "modules/toolbar": ee.default,
                  "themes/bubble": A.default,
                  "themes/snow": ie.default,
                  "ui/icons": te.default,
                  "ui/picker": O.default,
                  "ui/icon-picker": ne.default,
                  "ui/color-picker": k.default,
                  "ui/tooltip": re.default,
                },
                !0,
              ),
              (t.default = r.default));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.IndentClass = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(0));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            t.IndentClass = new ((function (e) {
              l(t, e);
              function t() {
                return (
                  s(this, t),
                  c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(t, [
                  {
                    key: `add`,
                    value: function (e, n) {
                      if (n === `+1` || n === `-1`) {
                        var r = this.value(e) || 0;
                        n = n === `+1` ? r + 1 : r - 1;
                      }
                      return n === 0
                        ? (this.remove(e), !0)
                        : i(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `add`,
                            this,
                          ).call(this, e, n);
                    },
                  },
                  {
                    key: `canAdd`,
                    value: function (e, n) {
                      return (
                        i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `canAdd`,
                          this,
                        ).call(this, e, n) ||
                        i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `canAdd`,
                          this,
                        ).call(this, e, parseInt(n))
                      );
                    },
                  },
                  {
                    key: `value`,
                    value: function (e) {
                      return (
                        parseInt(
                          i(
                            t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                            `value`,
                            this,
                          ).call(this, e),
                        ) || void 0
                      );
                    },
                  },
                ]),
                t
              );
            })(a.default.Attributor.Class))(`indent`, `ql-indent`, {
              scope: a.default.Scope.BLOCK,
              whitelist: [1, 2, 3, 4, 5, 6, 7, 8],
            });
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = i(n(4));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function a(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function o(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function s(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var c = (function (e) {
              s(t, e);
              function t() {
                return (
                  a(this, t),
                  o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return t;
            })(r.default);
            ((c.blotName = `blockquote`), (c.tagName = `blockquote`), (t.default = c));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = a(n(4));
            function a(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function o(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function s(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function c(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var l = (function (e) {
              c(t, e);
              function t() {
                return (
                  o(this, t),
                  s(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(t, null, [
                  {
                    key: `formats`,
                    value: function (e) {
                      return this.tagName.indexOf(e.tagName) + 1;
                    },
                  },
                ]),
                t
              );
            })(i.default);
            ((l.blotName = `header`),
              (l.tagName = [`H1`, `H2`, `H3`, `H4`, `H5`, `H6`]),
              (t.default = l));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.ListItem = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = c(n(0)),
              o = c(n(4)),
              s = c(n(25));
            function c(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function l(e, t, n) {
              return (
                t in e
                  ? Object.defineProperty(e, t, {
                      value: n,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (e[t] = n),
                e
              );
            }
            function u(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function d(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function f(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var p = (function (e) {
              f(t, e);
              function t() {
                return (
                  u(this, t),
                  d(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(
                  t,
                  [
                    {
                      key: `format`,
                      value: function (e, n) {
                        e === m.blotName && !n
                          ? this.replaceWith(a.default.create(this.statics.scope))
                          : i(
                              t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                              `format`,
                              this,
                            ).call(this, e, n);
                      },
                    },
                    {
                      key: `remove`,
                      value: function () {
                        this.prev == null && this.next == null
                          ? this.parent.remove()
                          : i(
                              t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                              `remove`,
                              this,
                            ).call(this);
                      },
                    },
                    {
                      key: `replaceWith`,
                      value: function (e, n) {
                        return (
                          this.parent.isolate(this.offset(this.parent), this.length()),
                          e === this.parent.statics.blotName
                            ? (this.parent.replaceWith(e, n), this)
                            : (this.parent.unwrap(),
                              i(
                                t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                                `replaceWith`,
                                this,
                              ).call(this, e, n))
                        );
                      },
                    },
                  ],
                  [
                    {
                      key: `formats`,
                      value: function (e) {
                        return e.tagName === this.tagName
                          ? void 0
                          : i(t.__proto__ || Object.getPrototypeOf(t), `formats`, this).call(
                              this,
                              e,
                            );
                      },
                    },
                  ],
                ),
                t
              );
            })(o.default);
            ((p.blotName = `list-item`), (p.tagName = `LI`));
            var m = (function (e) {
              (f(t, e),
                r(t, null, [
                  {
                    key: `create`,
                    value: function (e) {
                      var n = e === `ordered` ? `OL` : `UL`,
                        r = i(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                          this,
                          n,
                        );
                      return (
                        (e === `checked` || e === `unchecked`) &&
                          r.setAttribute(`data-checked`, e === `checked`),
                        r
                      );
                    },
                  },
                  {
                    key: `formats`,
                    value: function (e) {
                      if (e.tagName === `OL`) return `ordered`;
                      if (e.tagName === `UL`)
                        return e.hasAttribute(`data-checked`)
                          ? e.getAttribute(`data-checked`) === `true`
                            ? `checked`
                            : `unchecked`
                          : `bullet`;
                    },
                  },
                ]));
              function t(e) {
                u(this, t);
                var n = d(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
                  r = function (t) {
                    if (t.target.parentNode === e) {
                      var r = n.statics.formats(e),
                        i = a.default.find(t.target);
                      r === `checked`
                        ? i.format(`list`, `unchecked`)
                        : r === `unchecked` && i.format(`list`, `checked`);
                    }
                  };
                return (e.addEventListener(`touchstart`, r), e.addEventListener(`mousedown`, r), n);
              }
              return (
                r(t, [
                  {
                    key: `format`,
                    value: function (e, t) {
                      this.children.length > 0 && this.children.tail.format(e, t);
                    },
                  },
                  {
                    key: `formats`,
                    value: function () {
                      return l({}, this.statics.blotName, this.statics.formats(this.domNode));
                    },
                  },
                  {
                    key: `insertBefore`,
                    value: function (e, n) {
                      if (e instanceof p)
                        i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `insertBefore`,
                          this,
                        ).call(this, e, n);
                      else {
                        var r = n == null ? this.length() : n.offset(this),
                          a = this.split(r);
                        a.parent.insertBefore(e, a);
                      }
                    },
                  },
                  {
                    key: `optimize`,
                    value: function (e) {
                      i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `optimize`,
                        this,
                      ).call(this, e);
                      var n = this.next;
                      n != null &&
                        n.prev === this &&
                        n.statics.blotName === this.statics.blotName &&
                        n.domNode.tagName === this.domNode.tagName &&
                        n.domNode.getAttribute(`data-checked`) ===
                          this.domNode.getAttribute(`data-checked`) &&
                        (n.moveChildren(this), n.remove());
                    },
                  },
                  {
                    key: `replace`,
                    value: function (e) {
                      if (e.statics.blotName !== this.statics.blotName) {
                        var n = a.default.create(this.statics.defaultChild);
                        (e.moveChildren(n), this.appendChild(n));
                      }
                      i(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `replace`,
                        this,
                      ).call(this, e);
                    },
                  },
                ]),
                t
              );
            })(s.default);
            ((m.blotName = `list`),
              (m.scope = a.default.Scope.BLOCK_BLOT),
              (m.tagName = [`OL`, `UL`]),
              (m.defaultChild = `list-item`),
              (m.allowedChildren = [p]),
              (t.ListItem = p),
              (t.default = m));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = i(n(56));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function a(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function o(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function s(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var c = (function (e) {
              s(t, e);
              function t() {
                return (
                  a(this, t),
                  o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return t;
            })(r.default);
            ((c.blotName = `italic`), (c.tagName = [`EM`, `I`]), (t.default = c));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = o(n(6));
            function o(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function s(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function c(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function l(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var u = (function (e) {
              l(t, e);
              function t() {
                return (
                  s(this, t),
                  c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(t, null, [
                  {
                    key: `create`,
                    value: function (e) {
                      return e === `super`
                        ? document.createElement(`sup`)
                        : e === `sub`
                          ? document.createElement(`sub`)
                          : i(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                              this,
                              e,
                            );
                    },
                  },
                  {
                    key: `formats`,
                    value: function (e) {
                      if (e.tagName === `SUB`) return `sub`;
                      if (e.tagName === `SUP`) return `super`;
                    },
                  },
                ]),
                t
              );
            })(a.default);
            ((u.blotName = `script`), (u.tagName = [`SUB`, `SUP`]), (t.default = u));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = i(n(6));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function a(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function o(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function s(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var c = (function (e) {
              s(t, e);
              function t() {
                return (
                  a(this, t),
                  o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return t;
            })(r.default);
            ((c.blotName = `strike`), (c.tagName = `S`), (t.default = c));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = i(n(6));
            function i(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function a(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function o(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function s(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var c = (function (e) {
              s(t, e);
              function t() {
                return (
                  a(this, t),
                  o(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return t;
            })(r.default);
            ((c.blotName = `underline`), (c.tagName = `U`), (t.default = c));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = s(n(0)),
              o = n(27);
            function s(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function c(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function l(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function u(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var d = [`alt`, `height`, `width`],
              f = (function (e) {
                u(t, e);
                function t() {
                  return (
                    c(this, t),
                    l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                  );
                }
                return (
                  r(
                    t,
                    [
                      {
                        key: `format`,
                        value: function (e, n) {
                          d.indexOf(e) > -1
                            ? n
                              ? this.domNode.setAttribute(e, n)
                              : this.domNode.removeAttribute(e)
                            : i(
                                t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                                `format`,
                                this,
                              ).call(this, e, n);
                        },
                      },
                    ],
                    [
                      {
                        key: `create`,
                        value: function (e) {
                          var n = i(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                            this,
                            e,
                          );
                          return (
                            typeof e == `string` && n.setAttribute(`src`, this.sanitize(e)),
                            n
                          );
                        },
                      },
                      {
                        key: `formats`,
                        value: function (e) {
                          return d.reduce(function (t, n) {
                            return (e.hasAttribute(n) && (t[n] = e.getAttribute(n)), t);
                          }, {});
                        },
                      },
                      {
                        key: `match`,
                        value: function (e) {
                          return /\.(jpe?g|gif|png)$/.test(e) || /^data:image\/.+;base64/.test(e);
                        },
                      },
                      {
                        key: `sanitize`,
                        value: function (e) {
                          return (0, o.sanitize)(e, [`http`, `https`, `data`]) ? e : `//:0`;
                        },
                      },
                      {
                        key: `value`,
                        value: function (e) {
                          return e.getAttribute(`src`);
                        },
                      },
                    ],
                  ),
                  t
                );
              })(a.default.Embed);
            ((f.blotName = `image`), (f.tagName = `IMG`), (t.default = f));
          },
          function (e, t, n) {
            Object.defineProperty(t, "__esModule", {
              value: !0,
            });
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = n(4),
              o = s(n(27));
            function s(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function c(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function l(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function u(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var d = [`height`, `width`],
              f = (function (e) {
                u(t, e);
                function t() {
                  return (
                    c(this, t),
                    l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                  );
                }
                return (
                  r(
                    t,
                    [
                      {
                        key: `format`,
                        value: function (e, n) {
                          d.indexOf(e) > -1
                            ? n
                              ? this.domNode.setAttribute(e, n)
                              : this.domNode.removeAttribute(e)
                            : i(
                                t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                                `format`,
                                this,
                              ).call(this, e, n);
                        },
                      },
                    ],
                    [
                      {
                        key: `create`,
                        value: function (e) {
                          var n = i(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                            this,
                            e,
                          );
                          return (
                            n.setAttribute(`frameborder`, `0`),
                            n.setAttribute(`allowfullscreen`, !0),
                            n.setAttribute(`src`, this.sanitize(e)),
                            n
                          );
                        },
                      },
                      {
                        key: `formats`,
                        value: function (e) {
                          return d.reduce(function (t, n) {
                            return (e.hasAttribute(n) && (t[n] = e.getAttribute(n)), t);
                          }, {});
                        },
                      },
                      {
                        key: `sanitize`,
                        value: function (e) {
                          return o.default.sanitize(e);
                        },
                      },
                      {
                        key: `value`,
                        value: function (e) {
                          return e.getAttribute(`src`);
                        },
                      },
                    ],
                  ),
                  t
                );
              })(a.BlockEmbed);
            ((f.blotName = `video`),
              (f.className = `ql-video`),
              (f.tagName = `IFRAME`),
              (t.default = f));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.FormulaBlot = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = c(n(35)),
              o = c(n(5)),
              s = c(n(9));
            function c(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function l(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function u(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function d(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var f = (function (e) {
              d(t, e);
              function t() {
                return (
                  l(this, t),
                  u(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(t, null, [
                  {
                    key: `create`,
                    value: function (e) {
                      var n = i(t.__proto__ || Object.getPrototypeOf(t), `create`, this).call(
                        this,
                        e,
                      );
                      return (
                        typeof e == `string` &&
                          (window.katex.render(e, n, {
                            throwOnError: !1,
                            errorColor: `#f00`,
                          }),
                          n.setAttribute(`data-value`, e)),
                        n
                      );
                    },
                  },
                  {
                    key: `value`,
                    value: function (e) {
                      return e.getAttribute(`data-value`);
                    },
                  },
                ]),
                t
              );
            })(a.default);
            ((f.blotName = `formula`), (f.className = `ql-formula`), (f.tagName = `SPAN`));
            var p = (function (e) {
              (d(t, e),
                r(t, null, [
                  {
                    key: `register`,
                    value: function () {
                      o.default.register(f, !0);
                    },
                  },
                ]));
              function t() {
                l(this, t);
                var e = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                if (window.katex == null) throw Error(`Formula module requires KaTeX.`);
                return e;
              }
              return t;
            })(s.default);
            ((t.FormulaBlot = f), (t.default = p));
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.CodeToken = t.CodeBlock = void 0));
            var r = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              i = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              a = l(n(0)),
              o = l(n(5)),
              s = l(n(9)),
              c = l(n(13));
            function l(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function u(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function d(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function f(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var p = (function (e) {
              f(t, e);
              function t() {
                return (
                  u(this, t),
                  d(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                );
              }
              return (
                r(t, [
                  {
                    key: `replaceWith`,
                    value: function (e) {
                      ((this.domNode.textContent = this.domNode.textContent),
                        this.attach(),
                        i(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `replaceWith`,
                          this,
                        ).call(this, e));
                    },
                  },
                  {
                    key: `highlight`,
                    value: function (e) {
                      var t = this.domNode.textContent;
                      this.cachedText !== t &&
                        ((t.trim().length > 0 || this.cachedText == null) &&
                          ((this.domNode.innerHTML = e(t)),
                          this.domNode.normalize(),
                          this.attach()),
                        (this.cachedText = t));
                    },
                  },
                ]),
                t
              );
            })(c.default);
            p.className = `ql-syntax`;
            var m = new a.default.Attributor.Class(`token`, `hljs`, {
                scope: a.default.Scope.INLINE,
              }),
              h = (function (e) {
                (f(t, e),
                  r(t, null, [
                    {
                      key: `register`,
                      value: function () {
                        (o.default.register(m, !0), o.default.register(p, !0));
                      },
                    },
                  ]));
                function t(e, n) {
                  u(this, t);
                  var r = d(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                  if (typeof r.options.highlight != `function`)
                    throw Error(
                      `Syntax module requires highlight.js. Please include the library on the page before Quill.`,
                    );
                  var i = null;
                  return (
                    r.quill.on(o.default.events.SCROLL_OPTIMIZE, function () {
                      (clearTimeout(i),
                        (i = setTimeout(function () {
                          (r.highlight(), (i = null));
                        }, r.options.interval)));
                    }),
                    r.highlight(),
                    r
                  );
                }
                return (
                  r(t, [
                    {
                      key: `highlight`,
                      value: function () {
                        var e = this;
                        if (!this.quill.selection.composing) {
                          this.quill.update(o.default.sources.USER);
                          var t = this.quill.getSelection();
                          (this.quill.scroll.descendants(p).forEach(function (t) {
                            t.highlight(e.options.highlight);
                          }),
                            this.quill.update(o.default.sources.SILENT),
                            t != null && this.quill.setSelection(t, o.default.sources.SILENT));
                        }
                      },
                    },
                  ]),
                  t
                );
              })(s.default);
            ((h.DEFAULTS = {
              highlight: (function () {
                return window.hljs == null
                  ? null
                  : function (e) {
                      return window.hljs.highlightAuto(e).value;
                    };
              })(),
              interval: 1e3,
            }),
              (t.CodeBlock = p),
              (t.CodeToken = m),
              (t.default = h));
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>`;
          },
          function (e, t) {
            e.exports = `<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>`;
          },
          function (e, t, n) {
            (Object.defineProperty(t, "__esModule", {
              value: !0,
            }),
              (t.default = t.BubbleTooltip = void 0));
            var r = function e(t, n, r) {
                t === null && (t = Function.prototype);
                var i = Object.getOwnPropertyDescriptor(t, n);
                if (i === void 0) {
                  var a = Object.getPrototypeOf(t);
                  return a === null ? void 0 : e(a, n, r);
                } else if (`value` in i) return i.value;
                else {
                  var o = i.get;
                  return o === void 0 ? void 0 : o.call(r);
                }
              },
              i = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    ((r.enumerable = r.enumerable || !1),
                      (r.configurable = !0),
                      `value` in r && (r.writable = !0),
                      Object.defineProperty(e, r.key, r));
                  }
                }
                return function (t, n, r) {
                  return (n && e(t.prototype, n), r && e(t, r), t);
                };
              })(),
              a = d(n(3)),
              o = d(n(8)),
              s = n(43),
              c = d(s),
              l = n(15),
              u = d(n(41));
            function d(e) {
              return e && e.__esModule
                ? e
                : {
                    default: e,
                  };
            }
            function f(e, t) {
              if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
            }
            function p(e, t) {
              if (!e)
                throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
              return t && (typeof t == `object` || typeof t == `function`) ? t : e;
            }
            function m(e, t) {
              if (typeof t != `function` && t !== null)
                throw TypeError(
                  `Super expression must either be null or a function, not ` + typeof t,
                );
              ((e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t)));
            }
            var h = [
                [`bold`, `italic`, `link`],
                [
                  {
                    header: 1,
                  },
                  {
                    header: 2,
                  },
                  `blockquote`,
                ],
              ],
              g = (function (e) {
                m(t, e);
                function t(e, n) {
                  (f(this, t),
                    n.modules.toolbar != null &&
                      n.modules.toolbar.container == null &&
                      (n.modules.toolbar.container = h));
                  var r = p(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                  return (r.quill.container.classList.add(`ql-bubble`), r);
                }
                return (
                  i(t, [
                    {
                      key: `extendToolbar`,
                      value: function (e) {
                        ((this.tooltip = new v(this.quill, this.options.bounds)),
                          this.tooltip.root.appendChild(e.container),
                          this.buildButtons(
                            [].slice.call(e.container.querySelectorAll(`button`)),
                            u.default,
                          ),
                          this.buildPickers(
                            [].slice.call(e.container.querySelectorAll(`select`)),
                            u.default,
                          ));
                      },
                    },
                  ]),
                  t
                );
              })(c.default);
            g.DEFAULTS = (0, a.default)(!0, {}, c.default.DEFAULTS, {
              modules: {
                toolbar: {
                  handlers: {
                    link: function (e) {
                      e ? this.quill.theme.tooltip.edit() : this.quill.format(`link`, !1);
                    },
                  },
                },
              },
            });
            var v = (function (e) {
              m(t, e);
              function t(e, n) {
                f(this, t);
                var r = p(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                return (
                  r.quill.on(o.default.events.EDITOR_CHANGE, function (e, t, n, i) {
                    if (e === o.default.events.SELECTION_CHANGE)
                      if (t != null && t.length > 0 && i === o.default.sources.USER) {
                        (r.show(),
                          (r.root.style.left = `0px`),
                          (r.root.style.width = ``),
                          (r.root.style.width = r.root.offsetWidth + `px`));
                        var a = r.quill.getLines(t.index, t.length);
                        if (a.length === 1) r.position(r.quill.getBounds(t));
                        else {
                          var s = a[a.length - 1],
                            c = r.quill.getIndex(s),
                            u = Math.min(s.length() - 1, t.index + t.length - c),
                            d = r.quill.getBounds(new l.Range(c, u));
                          r.position(d);
                        }
                      } else document.activeElement !== r.textbox && r.quill.hasFocus() && r.hide();
                  }),
                  r
                );
              }
              return (
                i(t, [
                  {
                    key: `listen`,
                    value: function () {
                      var e = this;
                      (r(
                        t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                        `listen`,
                        this,
                      ).call(this),
                        this.root.querySelector(`.ql-close`).addEventListener(`click`, function () {
                          e.root.classList.remove(`ql-editing`);
                        }),
                        this.quill.on(o.default.events.SCROLL_OPTIMIZE, function () {
                          setTimeout(function () {
                            if (!e.root.classList.contains(`ql-hidden`)) {
                              var t = e.quill.getSelection();
                              t != null && e.position(e.quill.getBounds(t));
                            }
                          }, 1);
                        }));
                    },
                  },
                  {
                    key: `cancel`,
                    value: function () {
                      this.show();
                    },
                  },
                  {
                    key: `position`,
                    value: function (e) {
                      var n = r(
                          t.prototype.__proto__ || Object.getPrototypeOf(t.prototype),
                          `position`,
                          this,
                        ).call(this, e),
                        i = this.root.querySelector(`.ql-tooltip-arrow`);
                      if (((i.style.marginLeft = ``), n === 0)) return n;
                      i.style.marginLeft = -1 * n - i.offsetWidth / 2 + `px`;
                    },
                  },
                ]),
                t
              );
            })(s.BaseTooltip);
            ((v.TEMPLATE = [
              `<span class="ql-tooltip-arrow"></span>`,
              `<div class="ql-tooltip-editor">`,
              `<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">`,
              `<a class="ql-close"></a>`,
              `</div>`,
            ].join(``)),
              (t.BubbleTooltip = v),
              (t.default = g));
          },
          function (e, t, n) {
            e.exports = n(63);
          },
        ]).default;
      });
    })(),
  ),
  Hu = Vu.default.import(`blots/block`),
  Uu = class extends Hu {
    static create(e) {
      let t = super.create(e);
      if (e === !0) return t;
      let n = document.createElement(`img`);
      return (n.setAttribute(`src`, e), t.appendChild(n), t);
    }
    deleteAt(e, t) {
      (super.deleteAt(e, t), (this.cache = {}));
    }
    static value(e) {
      let { src: t, custom: n } = e.dataset;
      return {
        src: t,
        custom: n,
      };
    }
  };
((Uu.blotName = `imageBlot`),
  (Uu.className = `image-uploading`),
  (Uu.tagName = `span`),
  Vu.default.register({
    "formats/imageBlot": Uu,
  }));
var Wu = class {
  constructor(e, t) {
    ((this.quill = e),
      (this.options = t),
      (this.range = null),
      (this.placeholderDelta = null),
      typeof this.options.upload != `function` &&
        console.warn(`[Missing config] upload function that returns a promise is required`));
    var n = this.quill.getModule(`toolbar`);
    (n && n.addHandler(`image`, this.selectLocalImage.bind(this)),
      (this.handleDrop = this.handleDrop.bind(this)),
      (this.handlePaste = this.handlePaste.bind(this)),
      this.quill.root.addEventListener(`drop`, this.handleDrop, !1),
      this.quill.root.addEventListener(`paste`, this.handlePaste, !1));
  }
  selectLocalImage() {
    (this.quill.focus(),
      (this.range = this.quill.getSelection()),
      (this.fileHolder = document.createElement(`input`)),
      this.fileHolder.setAttribute(`type`, `file`),
      this.fileHolder.setAttribute(`accept`, `image/*`),
      this.fileHolder.setAttribute(`style`, `visibility:hidden`),
      (this.fileHolder.onchange = this.fileChanged.bind(this)),
      document.body.appendChild(this.fileHolder),
      this.fileHolder.click(),
      window.requestAnimationFrame(() => {
        document.body.removeChild(this.fileHolder);
      }));
  }
  handleDrop(e) {
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
      if ((e.stopPropagation(), e.preventDefault(), document.caretRangeFromPoint)) {
        let t = document.getSelection(),
          n = document.caretRangeFromPoint(e.clientX, e.clientY);
        t &&
          n &&
          t.setBaseAndExtent(n.startContainer, n.startOffset, n.startContainer, n.startOffset);
      } else {
        let t = document.getSelection(),
          n = document.caretPositionFromPoint(e.clientX, e.clientY);
        t && n && t.setBaseAndExtent(n.offsetNode, n.offset, n.offsetNode, n.offset);
      }
      (this.quill.focus(), (this.range = this.quill.getSelection()));
      let t = e.dataTransfer.files[0];
      setTimeout(() => {
        (this.quill.focus(), (this.range = this.quill.getSelection()), this.readAndUploadFile(t));
      }, 0);
    }
  }
  handlePaste(e) {
    let t = e.clipboardData || window.clipboardData;
    if (t && (t.items || t.files)) {
      let n = t.items || t.files,
        r = /^image\/(jpe?g|gif|png|svg|webp)$/i;
      for (let t = 0; t < n.length; t++)
        if (r.test(n[t].type)) {
          let r = n[t].getAsFile ? n[t].getAsFile() : n[t];
          r &&
            (this.quill.focus(),
            (this.range = this.quill.getSelection()),
            e.preventDefault(),
            setTimeout(() => {
              (this.quill.focus(),
                (this.range = this.quill.getSelection()),
                this.readAndUploadFile(r));
            }, 0));
        }
    }
  }
  readAndUploadFile(e) {
    let t = !1,
      n = new FileReader();
    (n.addEventListener(
      `load`,
      () => {
        if (!t) {
          let e = n.result;
          this.insertBase64Image(e);
        }
      },
      !1,
    ),
      e && n.readAsDataURL(e),
      this.options.upload(e).then(
        (e) => {
          this.insertToEditor(e);
        },
        (e) => {
          ((t = !0), this.removeBase64Image(), console.warn(e));
        },
      ));
  }
  fileChanged() {
    let e = this.fileHolder.files[0];
    this.readAndUploadFile(e);
  }
  insertBase64Image(e) {
    let t = this.range;
    this.placeholderDelta = this.quill.insertEmbed(t.index, Uu.blotName, `${e}`, `user`);
  }
  insertToEditor(e) {
    let t = this.range,
      n = this.calculatePlaceholderInsertLength();
    (this.quill.deleteText(t.index, n, `user`),
      this.quill.insertEmbed(t.index, `image`, `${e}`, `user`),
      t.index++,
      this.quill.setSelection(t, `user`));
  }
  calculatePlaceholderInsertLength() {
    return this.placeholderDelta.ops.reduce((e, t) => (t.hasOwnProperty(`insert`) && e++, e), 0);
  }
  removeBase64Image() {
    let e = this.range,
      t = this.calculatePlaceholderInsertLength();
    this.quill.deleteText(e.index, t, `user`);
  }
};
window.ImageUploader = Wu;
var Gu = i({
  default: () => Ju,
});
B();
var Ku = {
    key: 0,
    class: `ml-2`,
  },
  qu = {
    class: `mt-1`,
  },
  Ju = Object.assign(
    {
      name: `BaseEditor`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        placeholder: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [String, Number],
          default: ``,
        },
        toolbar: {
          type: [String, Array],
          default() {
            return [
              [
                {
                  header: [1, 2, 3, 4, 5, 6, !1],
                },
              ],
              [`bold`, `italic`, `underline`],
              [
                {
                  list: `ordered`,
                },
                {
                  list: `bullet`,
                },
                {
                  align: [],
                },
              ],
              [`blockquote`, `code-block`, `link`, `image`],
              [
                {
                  color: [],
                },
                `clean`,
              ],
            ];
          },
        },
        error: {
          type: String,
          default: ``,
        },
        edit: {
          type: Boolean,
          default: !1,
        },
        height: {
          type: [String, Number],
          default: `200px`,
        },
      },
      emits: [`update:modelValue`, `update:error`],
      setup(e, { emit: t }) {
        let n = $e(),
          r = t,
          i = e,
          a = {
            name: `imageUploader`,
            module: Wu,
            options: {
              upload: async (e) => {
                let t = new FormData();
                return (
                  t.append(`image`, e),
                  await n
                    .dispatch(`image/upload`, {
                      path: `images/upload`,
                      data: t,
                    })
                    .then((e) => e.url)
                    .catch((e) => {})
                );
              },
            },
            clipboard: {
              matchVisual: !1,
              matchers: [
                [`img`, () => new Cu.default()],
                [`IMG`, () => new Cu.default()],
              ],
            },
          },
          o = F(),
          s = Ae({
            uniqueId: ``,
            input: i.modelValue,
            set: !1,
          }),
          c = (e) => {
            (r(`update:modelValue`, s.input), r(`update:error`, ``));
          };
        return (
          He(
            () => i.modelValue,
            (e) => {
              e !== s.input &&
                (i.edit && s.set === !1 && e
                  ? ((s.input = e), (s.set = !0))
                  : !i.edit && s.set === !1 && !e && (s.input = e));
            },
          ),
          Qe(async () => {
            if (((s.uniqueId = i.id || Math.random().toString(16).slice(2)), o.value)) {
              let e = o.value.getQuill();
              e.container.addEventListener(
                `paste`,
                (t) => {
                  (t.preventDefault(), t.stopPropagation());
                  let n = t.clipboardData.getData(`text/html`) || t.clipboardData.getData(`text`);
                  n.trim() || (n = window.getSelection().toString());
                  let r = n
                    .replace(/<img[^>]*>/g, ``)
                    .replace(/src="[^"]*"/g, ``)
                    .replace(/data-src="[^"]*"/g, ``);
                  if (r.trim()) {
                    let t = e.getSelection(!0);
                    t &&
                      (e.deleteText(t.index, t.length),
                      e.clipboard.dangerouslyPasteHTML(t.index, r));
                  }
                  return !1;
                },
                !0,
              );
            }
          }),
          (t, n) => {
            let r = j(`BaseLabel`),
              l = j(`FormError`),
              u = ve(`tooltip`);
            return (
              A(),
              M(`div`, null, [
                N(
                  r,
                  {
                    for: s.uniqueId,
                  },
                  {
                    default: I(() => [
                      H(T(e.label) + ` `, 1),
                      e.labelHint
                        ? Re(
                            (A(),
                            M(`span`, Ku, [
                              ...(n[1] ||= [
                                W(
                                  `i`,
                                  {
                                    class: `fas fa-question-circle`,
                                  },
                                  null,
                                  -1,
                                ),
                              ]),
                            ])),
                            [[u, e.labelHint]],
                          )
                        : U(``, !0),
                    ]),
                    _: 1,
                  },
                  8,
                  [`for`],
                ),
                W(`div`, qu, [
                  N(
                    P(Bu),
                    {
                      ref_key: `quillEditor`,
                      ref: o,
                      theme: `snow`,
                      toolbar: e.toolbar,
                      content: s.input,
                      "onUpdate:content": [(n[0] ||= (e) => (s.input = e)), c],
                      "content-type": `html`,
                      modules: a,
                      style: Pe({
                        height: typeof i.height == `number` ? `${i.height}px` : i.height,
                      }),
                    },
                    null,
                    8,
                    [`toolbar`, `content`, `style`],
                  ),
                ]),
                N(
                  l,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ])
            );
          }
        );
      },
    },
  ),
  Yu = i({
    default: () => od,
  });
B();
var Xu = {
    class: `flex justify-between`,
  },
  Zu = {
    key: 0,
    class: `ltr:ml-2 rtl:mr-2`,
  },
  Qu = {
    key: 1,
    class: `pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3`,
  },
  $u = [`id`, `placeholder`, `type`, `step`, `value`],
  ed = [`for`],
  td = {
    key: 3,
    class: `absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3`,
  },
  nd = {
    key: 1,
    class: `border-gray-300 text-gray-500 sm:text-sm`,
  },
  rd = {
    key: 2,
    class: `border-gray-300 text-gray-500 sm:text-sm`,
  },
  id = {
    key: 3,
    class: `border-gray-300 text-gray-500 sm:text-sm`,
  },
  ad = {
    key: 0,
    class: `mt-1 text-xs text-gray-500 dark:text-gray-400`,
  },
  od = tu(
    Object.assign(
      {
        name: `BaseInput`,
        inheritAttrs: !1,
        methods: {
          updateInput(e) {
            (this.$emit(`update:modelValue`, e.target.value),
              this.$emit(`change`, e.target.value),
              this.$emit(`update:error`, ``));
          },
        },
      },
      {
        props: {
          label: {
            type: String,
            default: ``,
          },
          currency: {
            type: Boolean,
            default: !1,
          },
          currencyName: {
            type: String,
            default: ``,
          },
          labelHint: {
            type: String,
            default: ``,
          },
          placeholder: {
            type: String,
            default: ``,
          },
          modelValue: {
            type: [String, Number],
            default: ``,
          },
          error: {
            type: String,
            default: ``,
          },
          rounded: {
            type: Boolean,
            default: !1,
          },
          leadingIcon: {
            type: String,
            default: ``,
          },
          trailingIcon: {
            type: String,
            default: ``,
          },
          leadingText: {
            type: String,
            default: ``,
          },
          trailingText: {
            type: String,
            default: ``,
          },
          percentage: {
            type: Boolean,
            default: !1,
          },
          adjacentLeft: {
            type: Boolean,
            default: !1,
          },
          adjacentCenter: {
            type: Boolean,
            default: !1,
          },
          adjacentRight: {
            type: Boolean,
            default: !1,
          },
          invisible: {
            type: Boolean,
            default: !1,
          },
          align: {
            type: String,
            default: `left`,
          },
          textSize: {
            type: String,
            default: `sm`,
          },
          floatingLabel: {
            type: Boolean,
            default: !1,
          },
          isRequired: {
            type: Boolean,
            default: !1,
          },
          showCharCount: {
            type: Boolean,
            default: !1,
          },
        },
        setup(e) {
          let t = $e(),
            n = fe(),
            r = e,
            i = V(() => t.getters[`config/config`](`system.currency`)),
            a = V(() => {
              let e;
              return (
                r.currencyName &&
                  (e = t.getters[`config/config`](`system.currencies`).find(
                    (e) => e.name == r.currencyName,
                  )),
                e === void 0 ? i.value : e
              );
            }),
            o = Ae({
              uniqueId: ``,
              focused: !1,
              showPassword: !1,
            }),
            s = Ae({
              leadingText: ``,
              trailingText: ``,
              step: 2,
            }),
            c = V(() =>
              n.type === `password`
                ? o.showPassword
                  ? `text`
                  : `password`
                : r.currency || r.percentage
                  ? `number`
                  : n.type,
            ),
            l = () => {
              r.currency &&
                (a.value.position == `prefix`
                  ? (s.leadingText = a.value.symbol)
                  : (s.trailingText = a.value.symbol),
                (s.step = 1 / 10 ** a.value.decimal));
            };
          He(
            () => r.currencyName,
            () => {
              l();
            },
          );
          let u = V(() => String(r.modelValue).length);
          return (
            Qe(() => {
              ((o.uniqueId = r.id || Math.random().toString(16).slice(2)), l());
            }),
            (t, n) => {
              let r = j(`IsRequired`),
                i = j(`BaseLabel`),
                a = j(`FormError`),
                l = ve(`tooltip`);
              return (
                A(),
                M(`div`, null, [
                  W(`div`, Xu, [
                    e.label && !e.floatingLabel
                      ? (A(),
                        L(
                          i,
                          {
                            key: 0,
                            for: o.uniqueId,
                          },
                          {
                            default: I(() => [
                              W(`span`, null, [
                                H(T(e.label) + ` `, 1),
                                N(
                                  r,
                                  {
                                    "is-required": e.isRequired,
                                  },
                                  null,
                                  8,
                                  [`is-required`],
                                ),
                              ]),
                              e.labelHint
                                ? Re(
                                    (A(),
                                    M(`span`, Zu, [
                                      ...(n[4] ||= [
                                        W(
                                          `i`,
                                          {
                                            class: `fas fa-question-circle`,
                                          },
                                          null,
                                          -1,
                                        ),
                                      ]),
                                    ])),
                                    [[l, e.labelHint]],
                                  )
                                : U(``, !0),
                            ]),
                            _: 1,
                          },
                          8,
                          [`for`],
                        ))
                      : U(``, !0),
                    z(t.$slots, `additional-label`, {}, void 0, !0),
                  ]),
                  W(
                    `div`,
                    {
                      class: O([
                        `mt-1 relative`,
                        {
                          "floating-label-wrapper": e.floatingLabel,
                          relative:
                            e.leadingIcon ||
                            e.trailingIcon ||
                            e.trailingText ||
                            s.trailingText ||
                            e.percentage,
                          flex: e.leadingText || s.leadingText,
                          "rounded-md shadow-xs": e.rounded,
                        },
                      ]),
                    },
                    [
                      e.leadingText || s.leadingText
                        ? (A(),
                          M(
                            `span`,
                            {
                              key: 0,
                              class: O([
                                `inline-flex items-center border-gray-300 px-3 text-gray-500 sm:text-sm`,
                                {
                                  "pl-10": e.leadingIcon,
                                  "border-b-2": !e.invisible,
                                  "rounded-l-md": e.rounded,
                                  "border-r": !e.invisible && e.leadingText,
                                  "border-primary dark:border-gray-700": o.focused,
                                  "border-gray-300 dark:border-gray-700": !o.focused,
                                },
                              ]),
                            },
                            T(e.leadingText || s.leadingText),
                            3,
                          ))
                        : U(``, !0),
                      e.leadingIcon
                        ? (A(),
                          M(`div`, Qu, [
                            W(
                              `i`,
                              {
                                class: O([`text-gray-400`, e.leadingIcon]),
                                "aria-hidden": `true`,
                              },
                              null,
                              2,
                            ),
                          ]))
                        : U(``, !0),
                      W(
                        `input`,
                        ce(
                          {
                            id: o.uniqueId,
                          },
                          t.$attrs,
                          {
                            placeholder: e.floatingLabel ? ` ` : e.placeholder || e.label,
                            class: [
                              `focus:border-primary block w-full border-0 border-gray-300 bg-inherit focus:ring-0 disabled:bg-gray-200 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-200 dark:disabled:bg-gray-700`,
                              {
                                "text-sm": e.textSize == `sm`,
                                "text-lg": e.textSize == `lg`,
                                "text-xl": e.textSize == `xl`,
                                "text-2xl": e.textSize == `2xl`,
                                "text-right": e.align == `right`,
                                "text-center": e.align == `center`,
                                "border-b-2": !e.invisible,
                                "pr-12": e.align == `right` && e.trailingText,
                                "pl-10": e.leadingIcon,
                                "pr-10":
                                  e.trailingIcon ||
                                  s.trailingText ||
                                  e.percentage ||
                                  t.$attrs.type === `password`,
                                "rounded-md":
                                  e.rounded &&
                                  !e.leadingText &&
                                  !s.leadingText &&
                                  !e.adjacentLeft &&
                                  !e.adjacentRight &&
                                  !e.adjacentCenter,
                                "rounded-r-md":
                                  e.rounded && (e.leadingText || s.leadingText || e.adjacentRight),
                                "rounded-l-md": e.rounded && e.adjacentLeft,
                                "floating-label-input": e.floatingLabel,
                              },
                            ],
                            onFocus: (n[0] ||= (e) => (o.focused = !0)),
                            onBlur: (n[1] ||= (e) => (o.focused = !1)),
                            type: c.value,
                            step: e.currency ? s.step : e.percentage ? 0.01 : t.$attrs.step,
                            value: e.modelValue,
                            onInput: (n[2] ||= (...e) => t.updateInput && t.updateInput(...e)),
                          },
                        ),
                        null,
                        16,
                        $u,
                      ),
                      e.floatingLabel
                        ? (A(),
                          M(
                            `label`,
                            {
                              key: 2,
                              for: o.uniqueId,
                              class: O([
                                `floating-label`,
                                {
                                  "floating-label-active": o.focused || e.modelValue,
                                },
                              ]),
                            },
                            T(e.label),
                            11,
                            ed,
                          ))
                        : U(``, !0),
                      e.trailingIcon || e.trailingText || s.trailingText || e.percentage
                        ? (A(),
                          M(`div`, td, [
                            e.trailingIcon
                              ? (A(),
                                M(
                                  `i`,
                                  {
                                    key: 0,
                                    class: O([`text-gray-400`, e.trailingIcon]),
                                    "aria-hidden": `true`,
                                  },
                                  null,
                                  2,
                                ))
                              : U(``, !0),
                            s.trailingText ? (A(), M(`span`, nd, T(s.trailingText), 1)) : U(``, !0),
                            e.trailingText ? (A(), M(`span`, rd, T(e.trailingText), 1)) : U(``, !0),
                            e.percentage ? (A(), M(`span`, id, ` % `)) : U(``, !0),
                          ]))
                        : U(``, !0),
                      t.$attrs.type === `password`
                        ? (A(),
                          M(
                            `div`,
                            {
                              key: 4,
                              class: `absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3`,
                              onClick: (n[3] ||= (e) => (o.showPassword = !o.showPassword)),
                            },
                            [
                              W(
                                `i`,
                                {
                                  class: O([
                                    `text-gray-400`,
                                    o.showPassword ? `fas fa-eye` : `fas fa-eye-slash`,
                                  ]),
                                  "aria-hidden": `true`,
                                },
                                null,
                                2,
                              ),
                            ],
                          ))
                        : U(``, !0),
                    ],
                    2,
                  ),
                  e.showCharCount ? (A(), M(`div`, ad, T(u.value) + ` characters `, 1)) : U(``, !0),
                  N(
                    a,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ])
              );
            }
          );
        },
      },
    ),
    [[`__scopeId`, `data-v-c83a98c6`]],
  ),
  sd = i({
    default: () => ld,
  });
B();
var cd = [`for`],
  ld = Object.assign(
    {
      name: `BaseLabel`,
    },
    {
      props: {
        for: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `label`,
            {
              for: e.for,
              class: `text-label block truncate text-sm font-medium dark:text-gray-400`,
            },
            [
              W(
                `div`,
                {
                  class: O([`flex justify-between`, t.$attrs.class]),
                },
                [z(t.$slots, `default`)],
                2,
              ),
            ],
            8,
            cd,
          )
        );
      },
    },
  ),
  ud = i({
    default: () => gd,
  });
B();
var dd = {
    class: `flex items-center`,
  },
  fd = [`id`, `checked`, `onChange`, `disabled`],
  pd = [`for`],
  md = {
    class: `flex justify-between`,
  },
  hd = {
    key: 0,
    class: `ml-2`,
  },
  gd = {
    __name: `BaseMultiCheckbox`,
    props: {
      label: {
        type: String,
        default: ``,
      },
      options: {
        type: Array,
        default: () => [],
      },
      modelValue: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: !1,
      },
      error: {
        type: String,
        default: ``,
      },
      horizontal: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [`update:modelValue`, `update:error`],
    setup(e, { emit: t }) {
      let n = t,
        r = e,
        i = Ae({
          uniqueIds: [],
        }),
        a = (e) => i.uniqueIds[e] || ``,
        o = (e) => r.modelValue.includes(e),
        s = (e) => {
          (n(
            `update:modelValue`,
            o(e) ? r.modelValue.filter((t) => t !== e) : [...r.modelValue, e],
          ),
            n(`update:error`, ``));
        };
      return (
        Qe(() => {
          i.uniqueIds = Object.fromEntries(
            r.options.map((e) => [e.value, e.id || Math.random().toString(16).slice(2)]),
          );
        }),
        (t, n) => {
          let r = j(`BaseLabel`),
            i = j(`FormError`),
            c = ve(`tooltip`);
          return (
            A(),
            M(`div`, null, [
              e.label
                ? (A(),
                  L(
                    r,
                    {
                      key: 0,
                    },
                    {
                      default: I(() => [H(T(e.label), 1)]),
                      _: 1,
                    },
                  ))
                : U(``, !0),
              W(
                `div`,
                {
                  class: O([
                    `flex`,
                    {
                      "space-x-2": e.horizontal,
                      "flex-col space-y-1": !e.horizontal,
                      "mt-4": e.label,
                    },
                  ]),
                },
                [
                  (A(!0),
                  M(
                    ke,
                    null,
                    ae(
                      e.options,
                      (r) => (
                        A(),
                        M(
                          `div`,
                          {
                            key: r.value,
                          },
                          [
                            W(`div`, dd, [
                              W(
                                `input`,
                                ce(
                                  {
                                    id: a(r.value),
                                  },
                                  {
                                    ref_for: !0,
                                  },
                                  t.$attrs,
                                  {
                                    checked: o(r.value),
                                    onChange: (e) => s(r.value),
                                    type: `checkbox`,
                                    disabled: e.disabled,
                                    class: [
                                      `text-primary dark:text-dark-body border-primary h-4 w-4 rounded focus:ring-0 dark:border-gray-700`,
                                      {
                                        "cursor-pointer": !e.disabled,
                                        "text-gray-400 dark:text-gray-500": e.disabled,
                                      },
                                    ],
                                  },
                                ),
                                null,
                                16,
                                fd,
                              ),
                              W(
                                `label`,
                                {
                                  for: a(r.value),
                                  class: O([
                                    `ml-2 block text-sm text-gray-900 dark:text-gray-400`,
                                    {
                                      "cursor-pointer": !e.disabled,
                                    },
                                  ]),
                                },
                                [
                                  W(`div`, md, [
                                    H(T(r.label) + ` `, 1),
                                    r.labelHint
                                      ? Re(
                                          (A(),
                                          M(`span`, hd, [
                                            ...(n[0] ||= [
                                              W(
                                                `i`,
                                                {
                                                  class: `fas fa-question-circle`,
                                                },
                                                null,
                                                -1,
                                              ),
                                            ]),
                                          ])),
                                          [[c, r.labelHint]],
                                        )
                                      : U(``, !0),
                                  ]),
                                ],
                                10,
                                pd,
                              ),
                            ]),
                          ],
                        )
                      ),
                    ),
                    128,
                  )),
                ],
                2,
              ),
              N(
                i,
                {
                  error: e.error,
                },
                null,
                8,
                [`error`],
              ),
            ])
          );
        }
      );
    },
  },
  _d = i({
    default: () => Cd,
  });
B();
var vd = {
    class: `flex items-center`,
  },
  yd = [`id`, `checked`, `value`],
  bd = [`for`],
  xd = {
    class: `flex justify-between`,
  },
  Sd = {
    key: 0,
    class: `ltr:ml-2 rtl:mr-2`,
  },
  Cd = Object.assign(
    {
      name: `BaseRadio`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [String, Number, Boolean],
          default: ``,
        },
        value: {
          type: [String, Number, Boolean],
          required: !0,
        },
      },
      emits: [`update:modelValue`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = Ae({
            uniqueId: ``,
          }),
          a = (e) => {
            n(`update:modelValue`, e.target.value);
          };
        return (
          Qe(() => {
            i.uniqueId = r.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = ve(`tooltip`);
            return (
              A(),
              M(`div`, vd, [
                W(
                  `input`,
                  ce(
                    {
                      id: i.uniqueId,
                    },
                    t.$attrs,
                    {
                      checked: e.modelValue === e.value,
                      onChange: a,
                      value: e.value,
                      type: `radio`,
                      class: `text-primary dark:text-dark-body h-4 w-4 border-gray-300 focus:ring-0 dark:border-gray-700`,
                    },
                  ),
                  null,
                  16,
                  yd,
                ),
                W(
                  `label`,
                  {
                    for: i.uniqueId,
                    class: `ltr:ml-2 rtl:mr-2 block text-sm text-gray-900 dark:text-gray-400`,
                  },
                  [
                    W(`div`, xd, [
                      H(T(e.label) + ` `, 1),
                      e.labelHint
                        ? Re(
                            (A(),
                            M(`span`, Sd, [
                              ...(n[0] ||= [
                                W(
                                  `i`,
                                  {
                                    class: `fas fa-question-circle`,
                                  },
                                  null,
                                  -1,
                                ),
                              ]),
                            ])),
                            [[r, e.labelHint]],
                          )
                        : U(``, !0),
                    ]),
                  ],
                  8,
                  bd,
                ),
              ])
            );
          }
        );
      },
    },
  ),
  wd = i({
    default: () => Td,
  });
B();
var Td = Object.assign(
  {
    name: `BaseRadioGroup`,
    inheritAttrs: !1,
  },
  {
    props: {
      label: {
        type: String,
        default: ``,
      },
      options: {
        type: Array,
        required: !1,
        default: [],
      },
      name: {
        type: String,
        required: !0,
      },
      modelValue: {
        type: [String, Number, Boolean],
        required: !0,
      },
      error: {
        type: String,
        default: ``,
      },
      horizontal: {
        type: Boolean,
        default: !1,
      },
      topMargin: {
        type: Boolean,
        default: !1,
      },
      doubleTopMargin: {
        type: Boolean,
        default: !1,
      },
      disabled: {
        type: Boolean,
        default: !1,
      },
      predefinedOption: {
        type: String,
        default: ``,
      },
      isRequired: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [`update:modelValue`, `update:error`, `change`],
    setup(e, { emit: t }) {
      let n = t,
        r = e,
        i = R(`$trans`),
        a = {
          yes_no: [
            {
              label: i(`general.yes`),
              value: 1,
            },
            {
              label: i(`general.no`),
              value: 0,
            },
          ],
        },
        o = V(() => (r.predefinedOption ? a[r.predefinedOption] : r.options)),
        s = (e) => {
          (n(`update:modelValue`, e), n(`update:error`, ``), n(`change`));
        };
      return (t, n) => {
        let r = j(`IsRequired`),
          i = j(`BaseLabel`),
          a = j(`BaseRadio`),
          c = j(`FormError`);
        return (
          A(),
          M(`div`, null, [
            e.label
              ? (A(),
                L(
                  i,
                  {
                    key: 0,
                  },
                  {
                    default: I(() => [
                      W(`span`, null, [
                        H(T(e.label) + ` `, 1),
                        N(
                          r,
                          {
                            "is-required": e.isRequired,
                          },
                          null,
                          8,
                          [`is-required`],
                        ),
                      ]),
                    ]),
                    _: 1,
                  },
                ))
              : U(``, !0),
            W(
              `div`,
              {
                class: O({
                  "flex space-x-4": e.horizontal,
                  "mt-4": e.topMargin,
                  "mt-8": e.doubleTopMargin,
                }),
              },
              [
                (A(!0),
                M(
                  ke,
                  null,
                  ae(
                    o.value,
                    (t) => (
                      A(),
                      L(
                        a,
                        {
                          disabled: e.disabled,
                          key: t.value,
                          label: t.label,
                          value: t.value,
                          name: e.name,
                          modelValue: e.modelValue,
                          "onUpdate:modelValue": s,
                        },
                        null,
                        8,
                        [`disabled`, `label`, `value`, `name`, `modelValue`],
                      )
                    ),
                  ),
                  128,
                )),
              ],
              2,
            ),
            N(
              c,
              {
                error: e.error,
              },
              null,
              8,
              [`error`],
            ),
          ])
        );
      };
    },
  },
);
B();
function Ed(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function Dd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, `default`) ? e.default : e;
}
function Od(e) {
  var t = {
    exports: {},
  };
  return (e(t, t.exports), t.exports);
}
var kd = Od(function (e, t) {
    e.exports = (function () {
      var e = [
        `decimals`,
        `thousand`,
        `mark`,
        `prefix`,
        `suffix`,
        `encoder`,
        `decoder`,
        `negativeBefore`,
        `negative`,
        `edit`,
        `undo`,
      ];
      function t(e) {
        return e.split(``).reverse().join(``);
      }
      function n(e, t) {
        return e.substring(0, t.length) === t;
      }
      function r(e, t) {
        return e.slice(-1 * t.length) === t;
      }
      function i(e, t, n) {
        if ((e[t] || e[n]) && e[t] === e[n]) throw Error(t);
      }
      function a(e) {
        return typeof e == `number` && isFinite(e);
      }
      function o(e, t) {
        return (
          (e = e.toString().split(`e`)),
          (+(
            (e = (e = Math.round(+(e[0] + `e` + (e[1] ? +e[1] + t : t))))
              .toString()
              .split(`e`))[0] +
            `e` +
            (e[1] ? +e[1] - t : -t)
          )).toFixed(t)
        );
      }
      function s(e, n, r, i, s, c, l, u, d, f, p, m) {
        var h,
          g,
          v,
          y = m,
          b = ``,
          x = ``;
        return (
          c && (m = c(m)),
          !!a(m) &&
            (!1 !== e && parseFloat(m.toFixed(e)) === 0 && (m = 0),
            m < 0 && ((h = !0), (m = Math.abs(m))),
            !1 !== e && (m = o(m, e)),
            (m = m.toString()).indexOf(`.`) === -1
              ? (v = m)
              : ((v = (g = m.split(`.`))[0]), r && (b = r + g[1])),
            n && ((v = t(v).match(/.{1,3}/g)), (v = t(v.join(t(n))))),
            h && u && (x += u),
            i && (x += i),
            h && d && (x += d),
            (x += v),
            (x += b),
            s && (x += s),
            f && (x = f(x, y)),
            x)
        );
      }
      function c(e, t, i, o, s, c, l, u, d, f, p, m) {
        var h,
          g = ``;
        return (
          p && (m = p(m)),
          !(!m || typeof m != `string`) &&
            (u && n(m, u) && ((m = m.replace(u, ``)), (h = !0)),
            o && n(m, o) && (m = m.replace(o, ``)),
            d && n(m, d) && ((m = m.replace(d, ``)), (h = !0)),
            s && r(m, s) && (m = m.slice(0, -1 * s.length)),
            t && (m = m.split(t).join(``)),
            i && (m = m.replace(i, `.`)),
            h && (g += `-`),
            (g = (g += m).replace(/[^0-9\.\-.]/g, ``)) !== `` &&
              ((g = Number(g)), l && (g = l(g)), !!a(g) && g))
        );
      }
      function l(t) {
        var n,
          r,
          a,
          o = {};
        for (t.suffix === void 0 && (t.suffix = t.postfix), n = 0; n < e.length; n += 1)
          if ((a = t[(r = e[n])]) === void 0)
            r !== `negative` || o.negativeBefore
              ? r === `mark` && o.thousand !== `.`
                ? (o[r] = `.`)
                : (o[r] = !1)
              : (o[r] = `-`);
          else if (r === `decimals`) {
            if (!(a >= 0 && a < 8)) throw Error(r);
            o[r] = a;
          } else if (r === `encoder` || r === `decoder` || r === `edit` || r === `undo`) {
            if (typeof a != `function`) throw Error(r);
            o[r] = a;
          } else {
            if (typeof a != `string`) throw Error(r);
            o[r] = a;
          }
        return (
          i(o, `mark`, `thousand`),
          i(o, `prefix`, `negative`),
          i(o, `prefix`, `negativeBefore`),
          o
        );
      }
      function u(t, n, r) {
        var i,
          a = [];
        for (i = 0; i < e.length; i += 1) a.push(t[e[i]]);
        return (a.push(r), n.apply(``, a));
      }
      function d(e) {
        if (!(this instanceof d)) return new d(e);
        typeof e == `object` &&
          ((e = l(e)),
          (this.to = function (t) {
            return u(e, s, t);
          }),
          (this.from = function (t) {
            return u(e, c, t);
          }));
      }
      return d;
    })();
  }),
  Ad = Dd(
    Od(function (e, t) {
      (function (e) {
        function t(e) {
          return n(e) && typeof e.from == `function`;
        }
        function n(e) {
          return typeof e == `object` && typeof e.to == `function`;
        }
        function r(e) {
          e.parentElement.removeChild(e);
        }
        function i(e) {
          return e != null;
        }
        function a(e) {
          e.preventDefault();
        }
        function o(e) {
          return e.filter(function (e) {
            return !this[e] && (this[e] = !0);
          }, {});
        }
        function s(e, t) {
          return Math.round(e / t) * t;
        }
        function c(e, t) {
          var n = e.getBoundingClientRect(),
            r = e.ownerDocument,
            i = r.documentElement,
            a = v(r);
          return (
            /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (a.x = 0),
            t ? n.top + a.y - i.clientTop : n.left + a.x - i.clientLeft
          );
        }
        function l(e) {
          return typeof e == `number` && !isNaN(e) && isFinite(e);
        }
        function u(e, t, n) {
          n > 0 &&
            (m(e, t),
            setTimeout(function () {
              h(e, t);
            }, n));
        }
        function d(e) {
          return Math.max(Math.min(e, 100), 0);
        }
        function f(e) {
          return Array.isArray(e) ? e : [e];
        }
        function p(e) {
          var t = (e = String(e)).split(`.`);
          return t.length > 1 ? t[1].length : 0;
        }
        function m(e, t) {
          e.classList && !/\s/.test(t) ? e.classList.add(t) : (e.className += ` ` + t);
        }
        function h(e, t) {
          e.classList && !/\s/.test(t)
            ? e.classList.remove(t)
            : (e.className = e.className.replace(
                RegExp(`(^|\\b)` + t.split(` `).join(`|`) + `(\\b|$)`, `gi`),
                ` `,
              ));
        }
        function g(e, t) {
          return e.classList
            ? e.classList.contains(t)
            : RegExp(`\\b` + t + `\\b`).test(e.className);
        }
        function v(e) {
          var t = window.pageXOffset !== void 0,
            n = (e.compatMode || ``) === `CSS1Compat`;
          return {
            x: t ? window.pageXOffset : n ? e.documentElement.scrollLeft : e.body.scrollLeft,
            y: t ? window.pageYOffset : n ? e.documentElement.scrollTop : e.body.scrollTop,
          };
        }
        function y() {
          return window.navigator.pointerEnabled
            ? {
                start: `pointerdown`,
                move: `pointermove`,
                end: `pointerup`,
              }
            : window.navigator.msPointerEnabled
              ? {
                  start: `MSPointerDown`,
                  move: `MSPointerMove`,
                  end: `MSPointerUp`,
                }
              : {
                  start: `mousedown touchstart`,
                  move: `mousemove touchmove`,
                  end: `mouseup touchend`,
                };
        }
        function b() {
          var e = !1;
          try {
            var t = Object.defineProperty({}, "passive", {
              get: function () {
                e = !0;
              },
            });
            window.addEventListener(`test`, null, t);
          } catch {}
          return e;
        }
        function x() {
          return window.CSS && CSS.supports && CSS.supports(`touch-action`, `none`);
        }
        function S(e, t) {
          return 100 / (t - e);
        }
        function C(e, t, n) {
          return (100 * t) / (e[n + 1] - e[n]);
        }
        function w(e, t) {
          return C(e, e[0] < 0 ? t + Math.abs(e[0]) : t - e[0], 0);
        }
        function T(e, t) {
          return (t * (e[1] - e[0])) / 100 + e[0];
        }
        function E(e, t) {
          for (var n = 1; e >= t[n];) n += 1;
          return n;
        }
        function D(e, t, n) {
          if (n >= e.slice(-1)[0]) return 100;
          var r = E(n, e),
            i = e[r - 1],
            a = e[r],
            o = t[r - 1],
            s = t[r];
          return o + w([i, a], n) / S(o, s);
        }
        function ee(e, t, n) {
          if (n >= 100) return e.slice(-1)[0];
          var r = E(n, t),
            i = e[r - 1],
            a = e[r],
            o = t[r - 1];
          return T([i, a], (n - o) * S(o, t[r]));
        }
        function te(e, t, n, r) {
          if (r === 100) return r;
          var i = E(r, e),
            a = e[i - 1],
            o = e[i];
          return n
            ? r - a > (o - a) / 2
              ? o
              : a
            : t[i - 1]
              ? e[i - 1] + s(r - e[i - 1], t[i - 1])
              : r;
        }
        var O, k;
        ((e.PipsMode = void 0),
          ((k = e.PipsMode ||= {}).Range = `range`),
          (k.Steps = `steps`),
          (k.Positions = `positions`),
          (k.Count = `count`),
          (k.Values = `values`),
          (e.PipsType = void 0),
          ((O = e.PipsType ||= {})[(O.None = -1)] = `None`),
          (O[(O.NoValue = 0)] = `NoValue`),
          (O[(O.LargeValue = 1)] = `LargeValue`),
          (O[(O.SmallValue = 2)] = `SmallValue`));
        var ne = (function () {
            function e(e, t, n) {
              var r;
              ((this.xPct = []),
                (this.xVal = []),
                (this.xSteps = []),
                (this.xNumSteps = []),
                (this.xHighestCompleteStep = []),
                (this.xSteps = [n || !1]),
                (this.xNumSteps = [!1]),
                (this.snap = t));
              var i = [];
              for (
                Object.keys(e).forEach(function (t) {
                  i.push([f(e[t]), t]);
                }),
                  i.sort(function (e, t) {
                    return e[0][0] - t[0][0];
                  }),
                  r = 0;
                r < i.length;
                r++
              )
                this.handleEntryPoint(i[r][1], i[r][0]);
              for (this.xNumSteps = this.xSteps.slice(0), r = 0; r < this.xNumSteps.length; r++)
                this.handleStepPoint(r, this.xNumSteps[r]);
            }
            return (
              (e.prototype.getDistance = function (e) {
                for (var t = [], n = 0; n < this.xNumSteps.length - 1; n++)
                  t[n] = C(this.xVal, e, n);
                return t;
              }),
              (e.prototype.getAbsoluteDistance = function (e, t, n) {
                var r,
                  i = 0;
                if (e < this.xPct[this.xPct.length - 1]) for (; e > this.xPct[i + 1];) i++;
                else e === this.xPct[this.xPct.length - 1] && (i = this.xPct.length - 2);
                (n || e !== this.xPct[i + 1] || i++, t === null && (t = []));
                var a = 1,
                  o = t[i],
                  s = 0,
                  c = 0,
                  l = 0,
                  u = 0;
                for (
                  r = n
                    ? (e - this.xPct[i]) / (this.xPct[i + 1] - this.xPct[i])
                    : (this.xPct[i + 1] - e) / (this.xPct[i + 1] - this.xPct[i]);
                  o > 0;
                )
                  ((s = this.xPct[i + 1 + u] - this.xPct[i + u]),
                    t[i + u] * a + 100 - 100 * r > 100
                      ? ((c = s * r), (a = (o - 100 * r) / t[i + u]), (r = 1))
                      : ((c = ((t[i + u] * s) / 100) * a), (a = 0)),
                    n
                      ? ((l -= c), this.xPct.length + u >= 1 && u--)
                      : ((l += c), this.xPct.length - u >= 1 && u++),
                    (o = t[i + u] * a));
                return e + l;
              }),
              (e.prototype.toStepping = function (e) {
                return (e = D(this.xVal, this.xPct, e));
              }),
              (e.prototype.fromStepping = function (e) {
                return ee(this.xVal, this.xPct, e);
              }),
              (e.prototype.getStep = function (e) {
                return (e = te(this.xPct, this.xSteps, this.snap, e));
              }),
              (e.prototype.getDefaultStep = function (e, t, n) {
                var r = E(e, this.xPct);
                return (
                  (e === 100 || (t && e === this.xPct[r - 1])) && (r = Math.max(r - 1, 1)),
                  (this.xVal[r] - this.xVal[r - 1]) / n
                );
              }),
              (e.prototype.getNearbySteps = function (e) {
                var t = E(e, this.xPct);
                return {
                  stepBefore: {
                    startValue: this.xVal[t - 2],
                    step: this.xNumSteps[t - 2],
                    highestStep: this.xHighestCompleteStep[t - 2],
                  },
                  thisStep: {
                    startValue: this.xVal[t - 1],
                    step: this.xNumSteps[t - 1],
                    highestStep: this.xHighestCompleteStep[t - 1],
                  },
                  stepAfter: {
                    startValue: this.xVal[t],
                    step: this.xNumSteps[t],
                    highestStep: this.xHighestCompleteStep[t],
                  },
                };
              }),
              (e.prototype.countStepDecimals = function () {
                var e = this.xNumSteps.map(p);
                return Math.max.apply(null, e);
              }),
              (e.prototype.hasNoSize = function () {
                return this.xVal[0] === this.xVal[this.xVal.length - 1];
              }),
              (e.prototype.convert = function (e) {
                return this.getStep(this.toStepping(e));
              }),
              (e.prototype.handleEntryPoint = function (e, t) {
                var n;
                if (!l((n = e === `min` ? 0 : e === `max` ? 100 : parseFloat(e))) || !l(t[0]))
                  throw Error(`noUiSlider: 'range' value isn't numeric.`);
                (this.xPct.push(n), this.xVal.push(t[0]));
                var r = Number(t[1]);
                (n ? this.xSteps.push(!isNaN(r) && r) : isNaN(r) || (this.xSteps[0] = r),
                  this.xHighestCompleteStep.push(0));
              }),
              (e.prototype.handleStepPoint = function (e, t) {
                if (t)
                  if (this.xVal[e] !== this.xVal[e + 1]) {
                    this.xSteps[e] =
                      C([this.xVal[e], this.xVal[e + 1]], t, 0) / S(this.xPct[e], this.xPct[e + 1]);
                    var n = (this.xVal[e + 1] - this.xVal[e]) / this.xNumSteps[e],
                      r = Math.ceil(Number(n.toFixed(3)) - 1),
                      i = this.xVal[e] + this.xNumSteps[e] * r;
                    this.xHighestCompleteStep[e] = i;
                  } else this.xSteps[e] = this.xHighestCompleteStep[e] = this.xVal[e];
              }),
              e
            );
          })(),
          re = {
            to: function (e) {
              return e === void 0 ? `` : e.toFixed(2);
            },
            from: Number,
          },
          A = {
            target: `target`,
            base: `base`,
            origin: `origin`,
            handle: `handle`,
            handleLower: `handle-lower`,
            handleUpper: `handle-upper`,
            touchArea: `touch-area`,
            horizontal: `horizontal`,
            vertical: `vertical`,
            background: `background`,
            connect: `connect`,
            connects: `connects`,
            ltr: `ltr`,
            rtl: `rtl`,
            textDirectionLtr: `txt-dir-ltr`,
            textDirectionRtl: `txt-dir-rtl`,
            draggable: `draggable`,
            drag: `state-drag`,
            tap: `state-tap`,
            active: `active`,
            tooltip: `tooltip`,
            pips: `pips`,
            pipsHorizontal: `pips-horizontal`,
            pipsVertical: `pips-vertical`,
            marker: `marker`,
            markerHorizontal: `marker-horizontal`,
            markerVertical: `marker-vertical`,
            markerNormal: `marker-normal`,
            markerLarge: `marker-large`,
            markerSub: `marker-sub`,
            value: `value`,
            valueHorizontal: `value-horizontal`,
            valueVertical: `value-vertical`,
            valueNormal: `value-normal`,
            valueLarge: `value-large`,
            valueSub: `value-sub`,
          },
          ie = {
            tooltips: `.__tooltips`,
            aria: `.__aria`,
          };
        function j(e, t) {
          if (!l(t)) throw Error(`noUiSlider: 'step' is not numeric.`);
          e.singleStep = t;
        }
        function ae(e, t) {
          if (!l(t)) throw Error(`noUiSlider: 'keyboardPageMultiplier' is not numeric.`);
          e.keyboardPageMultiplier = t;
        }
        function oe(e, t) {
          if (!l(t)) throw Error(`noUiSlider: 'keyboardMultiplier' is not numeric.`);
          e.keyboardMultiplier = t;
        }
        function se(e, t) {
          if (!l(t)) throw Error(`noUiSlider: 'keyboardDefaultStep' is not numeric.`);
          e.keyboardDefaultStep = t;
        }
        function ce(e, t) {
          if (typeof t != `object` || Array.isArray(t))
            throw Error(`noUiSlider: 'range' is not an object.`);
          if (t.min === void 0 || t.max === void 0)
            throw Error(`noUiSlider: Missing 'min' or 'max' in 'range'.`);
          e.spectrum = new ne(t, e.snap || !1, e.singleStep);
        }
        function le(e, t) {
          if (((t = f(t)), !Array.isArray(t) || !t.length))
            throw Error(`noUiSlider: 'start' option is incorrect.`);
          ((e.handles = t.length), (e.start = t));
        }
        function ue(e, t) {
          if (typeof t != `boolean`) throw Error(`noUiSlider: 'snap' option must be a boolean.`);
          e.snap = t;
        }
        function de(e, t) {
          if (typeof t != `boolean`) throw Error(`noUiSlider: 'animate' option must be a boolean.`);
          e.animate = t;
        }
        function fe(e, t) {
          if (typeof t != `number`)
            throw Error(`noUiSlider: 'animationDuration' option must be a number.`);
          e.animationDuration = t;
        }
        function pe(e, t) {
          var n,
            r = [!1];
          if (
            (t === `lower` ? (t = [!0, !1]) : t === `upper` && (t = [!1, !0]), !0 === t || !1 === t)
          ) {
            for (n = 1; n < e.handles; n++) r.push(t);
            r.push(!1);
          } else {
            if (!Array.isArray(t) || !t.length || t.length !== e.handles + 1)
              throw Error(`noUiSlider: 'connect' option doesn't match handle count.`);
            r = t;
          }
          e.connect = r;
        }
        function M(e, t) {
          switch (t) {
            case `horizontal`:
              e.ort = 0;
              break;
            case `vertical`:
              e.ort = 1;
              break;
            default:
              throw Error(`noUiSlider: 'orientation' option is invalid.`);
          }
        }
        function me(e, t) {
          if (!l(t)) throw Error(`noUiSlider: 'margin' option must be numeric.`);
          t !== 0 && (e.margin = e.spectrum.getDistance(t));
        }
        function N(e, t) {
          if (!l(t)) throw Error(`noUiSlider: 'limit' option must be numeric.`);
          if (((e.limit = e.spectrum.getDistance(t)), !e.limit || e.handles < 2))
            throw Error(
              `noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.`,
            );
        }
        function P(e, t) {
          var n;
          if (
            (!l(t) && !Array.isArray(t)) ||
            (Array.isArray(t) && t.length !== 2 && !l(t[0]) && !l(t[1]))
          )
            throw Error(
              `noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.`,
            );
          if (t !== 0) {
            for (
              Array.isArray(t) || (t = [t, t]),
                e.padding = [e.spectrum.getDistance(t[0]), e.spectrum.getDistance(t[1])],
                n = 0;
              n < e.spectrum.xNumSteps.length - 1;
              n++
            )
              if (e.padding[0][n] < 0 || e.padding[1][n] < 0)
                throw Error(`noUiSlider: 'padding' option must be a positive number(s).`);
            var r = t[0] + t[1],
              i = e.spectrum.xVal[0];
            if (r / (e.spectrum.xVal[e.spectrum.xVal.length - 1] - i) > 1)
              throw Error(`noUiSlider: 'padding' option must not exceed 100% of the range.`);
          }
        }
        function he(e, t) {
          switch (t) {
            case `ltr`:
              e.dir = 0;
              break;
            case `rtl`:
              e.dir = 1;
              break;
            default:
              throw Error(`noUiSlider: 'direction' option was not recognized.`);
          }
        }
        function ge(e, t) {
          if (typeof t != `string`)
            throw Error(`noUiSlider: 'behaviour' must be a string containing options.`);
          var n = t.indexOf(`tap`) >= 0,
            r = t.indexOf(`drag`) >= 0,
            i = t.indexOf(`fixed`) >= 0,
            a = t.indexOf(`snap`) >= 0,
            o = t.indexOf(`hover`) >= 0,
            s = t.indexOf(`unconstrained`) >= 0,
            c = t.indexOf(`drag-all`) >= 0,
            l = t.indexOf(`smooth-steps`) >= 0;
          if (i) {
            if (e.handles !== 2)
              throw Error(`noUiSlider: 'fixed' behaviour must be used with 2 handles`);
            me(e, e.start[1] - e.start[0]);
          }
          if (s && (e.margin || e.limit))
            throw Error(
              `noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit`,
            );
          e.events = {
            tap: n || a,
            drag: r,
            dragAll: c,
            smoothSteps: l,
            fixed: i,
            snap: a,
            hover: o,
            unconstrained: s,
          };
        }
        function _e(e, t) {
          if (!1 !== t)
            if (!0 === t || n(t)) {
              e.tooltips = [];
              for (var r = 0; r < e.handles; r++) e.tooltips.push(t);
            } else {
              if ((t = f(t)).length !== e.handles)
                throw Error(`noUiSlider: must pass a formatter for all handles.`);
              (t.forEach(function (e) {
                if (typeof e != `boolean` && !n(e))
                  throw Error(`noUiSlider: 'tooltips' must be passed a formatter or 'false'.`);
              }),
                (e.tooltips = t));
            }
        }
        function ve(e, t) {
          if (t.length !== e.handles)
            throw Error(`noUiSlider: must pass a attributes for all handles.`);
          e.handleAttributes = t;
        }
        function ye(e, t) {
          if (!n(t)) throw Error(`noUiSlider: 'ariaFormat' requires 'to' method.`);
          e.ariaFormat = t;
        }
        function F(e, n) {
          if (!t(n)) throw Error(`noUiSlider: 'format' requires 'to' and 'from' methods.`);
          e.format = n;
        }
        function be(e, t) {
          if (typeof t != `boolean`)
            throw Error(`noUiSlider: 'keyboardSupport' option must be a boolean.`);
          e.keyboardSupport = t;
        }
        function I(e, t) {
          e.documentElement = t;
        }
        function L(e, t) {
          if (typeof t != `string` && !1 !== t)
            throw Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
          e.cssPrefix = t;
        }
        function xe(e, t) {
          if (typeof t != `object`) throw Error(`noUiSlider: 'cssClasses' must be an object.`);
          typeof e.cssPrefix == `string`
            ? ((e.cssClasses = {}),
              Object.keys(t).forEach(function (n) {
                e.cssClasses[n] = e.cssPrefix + t[n];
              }))
            : (e.cssClasses = t);
        }
        function Se(e) {
          var t = {
              margin: null,
              limit: null,
              padding: null,
              animate: !0,
              animationDuration: 300,
              ariaFormat: re,
              format: re,
            },
            n = {
              step: {
                r: !1,
                t: j,
              },
              keyboardPageMultiplier: {
                r: !1,
                t: ae,
              },
              keyboardMultiplier: {
                r: !1,
                t: oe,
              },
              keyboardDefaultStep: {
                r: !1,
                t: se,
              },
              start: {
                r: !0,
                t: le,
              },
              connect: {
                r: !0,
                t: pe,
              },
              direction: {
                r: !0,
                t: he,
              },
              snap: {
                r: !1,
                t: ue,
              },
              animate: {
                r: !1,
                t: de,
              },
              animationDuration: {
                r: !1,
                t: fe,
              },
              range: {
                r: !0,
                t: ce,
              },
              orientation: {
                r: !1,
                t: M,
              },
              margin: {
                r: !1,
                t: me,
              },
              limit: {
                r: !1,
                t: N,
              },
              padding: {
                r: !1,
                t: P,
              },
              behaviour: {
                r: !0,
                t: ge,
              },
              ariaFormat: {
                r: !1,
                t: ye,
              },
              format: {
                r: !1,
                t: F,
              },
              tooltips: {
                r: !1,
                t: _e,
              },
              keyboardSupport: {
                r: !0,
                t: be,
              },
              documentElement: {
                r: !1,
                t: I,
              },
              cssPrefix: {
                r: !0,
                t: L,
              },
              cssClasses: {
                r: !0,
                t: xe,
              },
              handleAttributes: {
                r: !1,
                t: ve,
              },
            },
            r = {
              connect: !1,
              direction: `ltr`,
              behaviour: `tap`,
              orientation: `horizontal`,
              keyboardSupport: !0,
              cssPrefix: `noUi-`,
              cssClasses: A,
              keyboardPageMultiplier: 5,
              keyboardMultiplier: 1,
              keyboardDefaultStep: 10,
            };
          (e.format && !e.ariaFormat && (e.ariaFormat = e.format),
            Object.keys(n).forEach(function (a) {
              if (i(e[a]) || r[a] !== void 0) n[a].t(t, i(e[a]) ? e[a] : r[a]);
              else if (n[a].r) throw Error(`noUiSlider: '` + a + `' is required.`);
            }),
            (t.pips = e.pips));
          var a = document.createElement(`div`),
            o = a.style.msTransform !== void 0;
          return (
            (t.transformRule =
              a.style.transform === void 0 ? (o ? `msTransform` : `webkitTransform`) : `transform`),
            (t.style = [
              [`left`, `top`],
              [`right`, `bottom`],
            ][t.dir][t.ort]),
            t
          );
        }
        function Ce(t, n, s) {
          var l,
            p,
            S,
            C,
            w,
            T = y(),
            E = x() && b(),
            D = t,
            ee = n.spectrum,
            te = [],
            O = [],
            k = [],
            ne = 0,
            re = {},
            A = t.ownerDocument,
            j = n.documentElement || A.documentElement,
            ae = A.body,
            oe = A.dir === `rtl` || n.ort === 1 ? 0 : 100;
          function se(e, t) {
            var n = A.createElement(`div`);
            return (t && m(n, t), e.appendChild(n), n);
          }
          function ce(e, t) {
            var r = se(e, n.cssClasses.origin),
              i = se(r, n.cssClasses.handle);
            if (
              (se(i, n.cssClasses.touchArea),
              i.setAttribute(`data-handle`, String(t)),
              n.keyboardSupport &&
                (i.setAttribute(`tabindex`, `0`),
                i.addEventListener(`keydown`, function (e) {
                  return Ae(e, t);
                })),
              n.handleAttributes !== void 0)
            ) {
              var a = n.handleAttributes[t];
              Object.keys(a).forEach(function (e) {
                i.setAttribute(e, a[e]);
              });
            }
            return (
              i.setAttribute(`role`, `slider`),
              i.setAttribute(`aria-orientation`, n.ort ? `vertical` : `horizontal`),
              t === 0
                ? m(i, n.cssClasses.handleLower)
                : t === n.handles - 1 && m(i, n.cssClasses.handleUpper),
              r
            );
          }
          function le(e, t) {
            return !!t && se(e, n.cssClasses.connect);
          }
          function ue(e, t) {
            var r = se(t, n.cssClasses.connects);
            ((p = []), (S = []).push(le(r, e[0])));
            for (var i = 0; i < n.handles; i++)
              (p.push(ce(t, i)), (k[i] = i), S.push(le(r, e[i + 1])));
          }
          function de(e) {
            return (
              m(e, n.cssClasses.target),
              n.dir === 0 ? m(e, n.cssClasses.ltr) : m(e, n.cssClasses.rtl),
              n.ort === 0 ? m(e, n.cssClasses.horizontal) : m(e, n.cssClasses.vertical),
              m(
                e,
                getComputedStyle(e).direction === `rtl`
                  ? n.cssClasses.textDirectionRtl
                  : n.cssClasses.textDirectionLtr,
              ),
              se(e, n.cssClasses.base)
            );
          }
          function fe(e, t) {
            return !(!n.tooltips || !n.tooltips[t]) && se(e.firstChild, n.cssClasses.tooltip);
          }
          function pe() {
            return D.hasAttribute(`disabled`);
          }
          function M(e) {
            return p[e].hasAttribute(`disabled`);
          }
          function me() {
            w &&=
              (Ne(`update` + ie.tooltips),
              w.forEach(function (e) {
                e && r(e);
              }),
              null);
          }
          function N() {
            (me(),
              (w = p.map(fe)),
              Me(`update` + ie.tooltips, function (e, t, r) {
                if (w && n.tooltips && !1 !== w[t]) {
                  var i = e[t];
                  (!0 !== n.tooltips[t] && (i = n.tooltips[t].to(r[t])), (w[t].innerHTML = i));
                }
              }));
          }
          function P() {
            (Ne(`update` + ie.aria),
              Me(`update` + ie.aria, function (e, t, r, i, a) {
                k.forEach(function (e) {
                  var t = p[e],
                    i = Fe(O, e, 0, !0, !0, !0),
                    o = Fe(O, e, 100, !0, !0, !0),
                    s = a[e],
                    c = String(n.ariaFormat.to(r[e]));
                  ((i = ee.fromStepping(i).toFixed(1)),
                    (o = ee.fromStepping(o).toFixed(1)),
                    (s = ee.fromStepping(s).toFixed(1)),
                    t.children[0].setAttribute(`aria-valuemin`, i),
                    t.children[0].setAttribute(`aria-valuemax`, o),
                    t.children[0].setAttribute(`aria-valuenow`, s),
                    t.children[0].setAttribute(`aria-valuetext`, c));
                });
              }));
          }
          function he(t) {
            if (t.mode === e.PipsMode.Range || t.mode === e.PipsMode.Steps) return ee.xVal;
            if (t.mode === e.PipsMode.Count) {
              if (t.values < 2)
                throw Error(`noUiSlider: 'values' (>= 2) required for mode 'count'.`);
              for (var n = t.values - 1, r = 100 / n, i = []; n--;) i[n] = n * r;
              return (i.push(100), ge(i, t.stepped));
            }
            return t.mode === e.PipsMode.Positions
              ? ge(t.values, t.stepped)
              : t.mode === e.PipsMode.Values
                ? t.stepped
                  ? t.values.map(function (e) {
                      return ee.fromStepping(ee.getStep(ee.toStepping(e)));
                    })
                  : t.values
                : [];
          }
          function ge(e, t) {
            return e.map(function (e) {
              return ee.fromStepping(t ? ee.getStep(e) : e);
            });
          }
          function _e(t) {
            function n(e, t) {
              return Number((e + t).toFixed(7));
            }
            var r = he(t),
              i = {},
              a = ee.xVal[0],
              s = ee.xVal[ee.xVal.length - 1],
              c = !1,
              l = !1,
              u = 0;
            return (
              (r = o(
                r.slice().sort(function (e, t) {
                  return e - t;
                }),
              ))[0] !== a && (r.unshift(a), (c = !0)),
              r[r.length - 1] !== s && (r.push(s), (l = !0)),
              r.forEach(function (a, o) {
                var s,
                  d,
                  f,
                  p,
                  m,
                  h,
                  g,
                  v,
                  y,
                  b,
                  x = a,
                  S = r[o + 1],
                  C = t.mode === e.PipsMode.Steps;
                for (
                  C && (s = ee.xNumSteps[o]),
                    s ||= S - x,
                    S === void 0 && (S = x),
                    s = Math.max(s, 1e-7),
                    d = x;
                  d <= S;
                  d = n(d, s)
                ) {
                  for (
                    v = (m = (p = ee.toStepping(d)) - u) / (t.density || 1),
                      b = m / (y = Math.round(v)),
                      f = 1;
                    f <= y;
                    f += 1
                  )
                    i[(h = u + f * b).toFixed(5)] = [ee.fromStepping(h), 0];
                  ((g =
                    r.indexOf(d) > -1
                      ? e.PipsType.LargeValue
                      : C
                        ? e.PipsType.SmallValue
                        : e.PipsType.NoValue),
                    !o && c && d !== S && (g = 0),
                    (d === S && l) || (i[p.toFixed(5)] = [d, g]),
                    (u = p));
                }
              }),
              i
            );
          }
          function ve(t, r, i) {
            var a,
              o,
              s = A.createElement(`div`),
              c =
                (((a = {})[e.PipsType.None] = ``),
                (a[e.PipsType.NoValue] = n.cssClasses.valueNormal),
                (a[e.PipsType.LargeValue] = n.cssClasses.valueLarge),
                (a[e.PipsType.SmallValue] = n.cssClasses.valueSub),
                a),
              l =
                (((o = {})[e.PipsType.None] = ``),
                (o[e.PipsType.NoValue] = n.cssClasses.markerNormal),
                (o[e.PipsType.LargeValue] = n.cssClasses.markerLarge),
                (o[e.PipsType.SmallValue] = n.cssClasses.markerSub),
                o),
              u = [n.cssClasses.valueHorizontal, n.cssClasses.valueVertical],
              d = [n.cssClasses.markerHorizontal, n.cssClasses.markerVertical];
            function f(e, t) {
              var r = t === n.cssClasses.value,
                i = r ? c : l;
              return t + ` ` + (r ? u : d)[n.ort] + ` ` + i[e];
            }
            function p(t, a, o) {
              if ((o = r ? r(a, o) : o) !== e.PipsType.None) {
                var c = se(s, !1);
                ((c.className = f(o, n.cssClasses.marker)),
                  (c.style[n.style] = t + `%`),
                  o > e.PipsType.NoValue &&
                    (((c = se(s, !1)).className = f(o, n.cssClasses.value)),
                    c.setAttribute(`data-value`, String(a)),
                    (c.style[n.style] = t + `%`),
                    (c.innerHTML = String(i.to(a)))));
              }
            }
            return (
              m(s, n.cssClasses.pips),
              m(s, n.ort === 0 ? n.cssClasses.pipsHorizontal : n.cssClasses.pipsVertical),
              Object.keys(t).forEach(function (e) {
                p(e, t[e][0], t[e][1]);
              }),
              s
            );
          }
          function ye() {
            C &&= (r(C), null);
          }
          function F(e) {
            ye();
            var t = _e(e),
              n = e.filter,
              r = e.format || {
                to: function (e) {
                  return String(Math.round(e));
                },
              };
            return (C = D.appendChild(ve(t, n, r)));
          }
          function be() {
            var e = l.getBoundingClientRect(),
              t = `offset` + [`Width`, `Height`][n.ort];
            return n.ort === 0 ? e.width || l[t] : e.height || l[t];
          }
          function I(e, t, r, i) {
            var a = function (a) {
                var o = L(a, i.pageOffset, i.target || t);
                return (
                  !!o &&
                  !(pe() && !i.doNotReject) &&
                  !(g(D, n.cssClasses.tap) && !i.doNotReject) &&
                  !(e === T.start && o.buttons !== void 0 && o.buttons > 1) &&
                  (!i.hover || !o.buttons) &&
                  (E || o.preventDefault(), (o.calcPoint = o.points[n.ort]), void r(o, i))
                );
              },
              o = [];
            return (
              e.split(` `).forEach(function (e) {
                (t.addEventListener(
                  e,
                  a,
                  !!E && {
                    passive: !0,
                  },
                ),
                  o.push([e, a]));
              }),
              o
            );
          }
          function L(e, t, n) {
            var r = e.type.indexOf(`touch`) === 0,
              i = e.type.indexOf(`mouse`) === 0,
              a = e.type.indexOf(`pointer`) === 0,
              o = 0,
              s = 0;
            if (
              (e.type.indexOf(`MSPointer`) === 0 && (a = !0),
              e.type === `mousedown` && !e.buttons && !e.touches)
            )
              return !1;
            if (r) {
              var c = function (t) {
                var r = t.target;
                return r === n || n.contains(r) || (e.composed && e.composedPath().shift() === n);
              };
              if (e.type === `touchstart`) {
                var l = Array.prototype.filter.call(e.touches, c);
                if (l.length > 1) return !1;
                ((o = l[0].pageX), (s = l[0].pageY));
              } else {
                var u = Array.prototype.find.call(e.changedTouches, c);
                if (!u) return !1;
                ((o = u.pageX), (s = u.pageY));
              }
            }
            return (
              (t ||= v(A)),
              (i || a) && ((o = e.clientX + t.x), (s = e.clientY + t.y)),
              (e.pageOffset = t),
              (e.points = [o, s]),
              (e.cursor = i || a),
              e
            );
          }
          function xe(e) {
            var t = (100 * (e - c(l, n.ort))) / be();
            return ((t = d(t)), n.dir ? 100 - t : t);
          }
          function Ce(e) {
            var t = 100,
              n = !1;
            return (
              p.forEach(function (r, i) {
                if (!M(i)) {
                  var a = O[i],
                    o = Math.abs(a - e);
                  (o < t || (o <= t && e > a) || (o === 100 && t === 100)) && ((n = i), (t = o));
                }
              }),
              n
            );
          }
          function we(e, t) {
            e.type === `mouseout` &&
              e.target.nodeName === `HTML` &&
              e.relatedTarget === null &&
              Ee(e, t);
          }
          function Te(e, t) {
            if (
              navigator.appVersion.indexOf(`MSIE 9`) === -1 &&
              e.buttons === 0 &&
              t.buttonsProperty !== 0
            )
              return Ee(e, t);
            var r = (n.dir ? -1 : 1) * (e.calcPoint - t.startCalcPoint);
            Le(r > 0, (100 * r) / t.baseSize, t.locations, t.handleNumbers, t.connect);
          }
          function Ee(e, t) {
            (t.handle && (h(t.handle, n.cssClasses.active), --ne),
              t.listeners.forEach(function (e) {
                j.removeEventListener(e[0], e[1]);
              }),
              ne === 0 &&
                (h(D, n.cssClasses.drag),
                Be(),
                e.cursor && ((ae.style.cursor = ``), ae.removeEventListener(`selectstart`, a))),
              n.events.smoothSteps &&
                (t.handleNumbers.forEach(function (e) {
                  z(e, O[e], !0, !0, !1, !1);
                }),
                t.handleNumbers.forEach(function (e) {
                  Pe(`update`, e);
                })),
              t.handleNumbers.forEach(function (e) {
                (Pe(`change`, e), Pe(`set`, e), Pe(`end`, e));
              }));
          }
          function De(e, t) {
            if (!t.handleNumbers.some(M)) {
              var r;
              (t.handleNumbers.length === 1 &&
                ((r = p[t.handleNumbers[0]].children[0]), (ne += 1), m(r, n.cssClasses.active)),
                e.stopPropagation());
              var i = [],
                o = I(T.move, j, Te, {
                  target: e.target,
                  handle: r,
                  connect: t.connect,
                  listeners: i,
                  startCalcPoint: e.calcPoint,
                  baseSize: be(),
                  pageOffset: e.pageOffset,
                  handleNumbers: t.handleNumbers,
                  buttonsProperty: e.buttons,
                  locations: O.slice(),
                }),
                s = I(T.end, j, Ee, {
                  target: e.target,
                  handle: r,
                  listeners: i,
                  doNotReject: !0,
                  handleNumbers: t.handleNumbers,
                }),
                c = I(`mouseout`, j, we, {
                  target: e.target,
                  handle: r,
                  listeners: i,
                  doNotReject: !0,
                  handleNumbers: t.handleNumbers,
                });
              (i.push.apply(i, o.concat(s, c)),
                e.cursor &&
                  ((ae.style.cursor = getComputedStyle(e.target).cursor),
                  p.length > 1 && m(D, n.cssClasses.drag),
                  ae.addEventListener(`selectstart`, a, !1)),
                t.handleNumbers.forEach(function (e) {
                  Pe(`start`, e);
                }));
            }
          }
          function Oe(e) {
            e.stopPropagation();
            var t = xe(e.calcPoint),
              r = Ce(t);
            !1 !== r &&
              (n.events.snap || u(D, n.cssClasses.tap, n.animationDuration),
              z(r, t, !0, !0),
              Be(),
              Pe(`slide`, r, !0),
              Pe(`update`, r, !0),
              n.events.snap
                ? De(e, {
                    handleNumbers: [r],
                  })
                : (Pe(`change`, r, !0), Pe(`set`, r, !0)));
          }
          function ke(e) {
            var t = xe(e.calcPoint),
              n = ee.getStep(t),
              r = ee.fromStepping(n);
            Object.keys(re).forEach(function (e) {
              e.split(`.`)[0] === `hover` &&
                re[e].forEach(function (e) {
                  e.call(Ye, r);
                });
            });
          }
          function Ae(e, t) {
            if (pe() || M(t)) return !1;
            var r = [`Left`, `Right`],
              i = [`Down`, `Up`],
              a = [`PageDown`, `PageUp`],
              o = [`Home`, `End`];
            n.dir && !n.ort ? r.reverse() : n.ort && !n.dir && (i.reverse(), a.reverse());
            var s,
              c = e.key.replace(`Arrow`, ``),
              l = c === a[0],
              u = c === a[1],
              d = c === i[0] || c === r[0] || l,
              f = c === i[1] || c === r[1] || u,
              p = c === o[0],
              m = c === o[1];
            if (!(d || f || p || m)) return !0;
            if ((e.preventDefault(), f || d)) {
              var h = +!d,
                g = qe(t)[h];
              if (g === null) return !1;
              (!1 === g && (g = ee.getDefaultStep(O[t], d, n.keyboardDefaultStep)),
                (g *= u || l ? n.keyboardPageMultiplier : n.keyboardMultiplier),
                (g = Math.max(g, 1e-7)),
                (g *= d ? -1 : 1),
                (s = te[t] + g));
            } else s = m ? n.spectrum.xVal[n.spectrum.xVal.length - 1] : n.spectrum.xVal[0];
            return (
              z(t, ee.toStepping(s), !0, !0),
              Pe(`slide`, t),
              Pe(`update`, t),
              Pe(`change`, t),
              Pe(`set`, t),
              !1
            );
          }
          function je(e) {
            (e.fixed ||
              p.forEach(function (e, t) {
                I(T.start, e.children[0], De, {
                  handleNumbers: [t],
                });
              }),
              e.tap && I(T.start, l, Oe, {}),
              e.hover &&
                I(T.move, l, ke, {
                  hover: !0,
                }),
              e.drag &&
                S.forEach(function (t, r) {
                  if (!1 !== t && r !== 0 && r !== S.length - 1) {
                    var i = p[r - 1],
                      a = p[r],
                      o = [t],
                      s = [i, a],
                      c = [r - 1, r];
                    (m(t, n.cssClasses.draggable),
                      e.fixed && (o.push(i.children[0]), o.push(a.children[0])),
                      e.dragAll && ((s = p), (c = k)),
                      o.forEach(function (e) {
                        I(T.start, e, De, {
                          handles: s,
                          handleNumbers: c,
                          connect: t,
                        });
                      }));
                  }
                }));
          }
          function Me(e, t) {
            ((re[e] = re[e] || []),
              re[e].push(t),
              e.split(`.`)[0] === `update` &&
                p.forEach(function (e, t) {
                  Pe(`update`, t);
                }));
          }
          function R(e) {
            return e === ie.aria || e === ie.tooltips;
          }
          function Ne(e) {
            var t = e && e.split(`.`)[0],
              n = t ? e.substring(t.length) : e;
            Object.keys(re).forEach(function (e) {
              var r = e.split(`.`)[0],
                i = e.substring(r.length);
              (t && t !== r) || (n && n !== i) || (R(i) && n !== i) || delete re[e];
            });
          }
          function Pe(e, t, r) {
            Object.keys(re).forEach(function (i) {
              e === i.split(`.`)[0] &&
                re[i].forEach(function (e) {
                  e.call(Ye, te.map(n.format.to), t, te.slice(), r || !1, O.slice(), Ye);
                });
            });
          }
          function Fe(e, t, r, i, a, o, s) {
            var c;
            return (
              p.length > 1 &&
                !n.events.unconstrained &&
                (i &&
                  t > 0 &&
                  ((c = ee.getAbsoluteDistance(e[t - 1], n.margin, !1)), (r = Math.max(r, c))),
                a &&
                  t < p.length - 1 &&
                  ((c = ee.getAbsoluteDistance(e[t + 1], n.margin, !0)), (r = Math.min(r, c)))),
              p.length > 1 &&
                n.limit &&
                (i &&
                  t > 0 &&
                  ((c = ee.getAbsoluteDistance(e[t - 1], n.limit, !1)), (r = Math.min(r, c))),
                a &&
                  t < p.length - 1 &&
                  ((c = ee.getAbsoluteDistance(e[t + 1], n.limit, !0)), (r = Math.max(r, c)))),
              n.padding &&
                (t === 0 &&
                  ((c = ee.getAbsoluteDistance(0, n.padding[0], !1)), (r = Math.max(r, c))),
                t === p.length - 1 &&
                  ((c = ee.getAbsoluteDistance(100, n.padding[1], !0)), (r = Math.min(r, c)))),
              s || (r = ee.getStep(r)),
              !((r = d(r)) === e[t] && !o) && r
            );
          }
          function Ie(e, t) {
            var r = n.ort;
            return (r ? t : e) + `, ` + (r ? e : t);
          }
          function Le(e, t, r, i, a) {
            var o = r.slice(),
              s = i[0],
              c = n.events.smoothSteps,
              l = [!e, e],
              u = [e, !e];
            ((i = i.slice()),
              e && i.reverse(),
              i.length > 1
                ? i.forEach(function (e, n) {
                    var r = Fe(o, e, o[e] + t, l[n], u[n], !1, c);
                    !1 === r ? (t = 0) : ((t = r - o[e]), (o[e] = r));
                  })
                : (l = u = [!0]));
            var d = !1;
            (i.forEach(function (e, n) {
              d = z(e, r[e] + t, l[n], u[n], !1, c) || d;
            }),
              d &&
                (i.forEach(function (e) {
                  (Pe(`update`, e), Pe(`slide`, e));
                }),
                a != null && Pe(`drag`, s)));
          }
          function Re(e, t) {
            return n.dir ? 100 - e - t : e;
          }
          function ze(e, t) {
            ((O[e] = t), (te[e] = ee.fromStepping(t)));
            var r = `translate(` + Ie(Re(t, 0) - oe + `%`, `0`) + `)`;
            ((p[e].style[n.transformRule] = r), Ve(e), Ve(e + 1));
          }
          function Be() {
            k.forEach(function (e) {
              var t = O[e] > 50 ? -1 : 1,
                n = 3 + (p.length + t * e);
              p[e].style.zIndex = String(n);
            });
          }
          function z(e, t, n, r, i, a) {
            return (i || (t = Fe(O, e, t, n, r, !1, a)), !1 !== t && (ze(e, t), !0));
          }
          function Ve(e) {
            if (S[e]) {
              var t = 0,
                r = 100;
              (e !== 0 && (t = O[e - 1]), e !== S.length - 1 && (r = O[e]));
              var i = r - t,
                a = `translate(` + Ie(Re(t, i) + `%`, `0`) + `)`,
                o = `scale(` + Ie(i / 100, `1`) + `)`;
              S[e].style[n.transformRule] = a + ` ` + o;
            }
          }
          function He(e, t) {
            return e === null || !1 === e || e === void 0
              ? O[t]
              : (typeof e == `number` && (e = String(e)),
                !1 !== (e = n.format.from(e)) && (e = ee.toStepping(e)),
                !1 === e || isNaN(e) ? O[t] : e);
          }
          function Ue(e, t, r) {
            var i = f(e),
              a = O[0] === void 0;
            ((t = t === void 0 || t),
              n.animate && !a && u(D, n.cssClasses.tap, n.animationDuration),
              k.forEach(function (e) {
                z(e, He(i[e], e), !0, !1, r);
              }));
            var o = k.length === 1 ? 0 : 1;
            if (a && ee.hasNoSize() && ((r = !0), (O[0] = 0), k.length > 1)) {
              var s = 100 / (k.length - 1);
              k.forEach(function (e) {
                O[e] = e * s;
              });
            }
            for (; o < k.length; ++o)
              k.forEach(function (e) {
                z(e, O[e], !0, !0, r);
              });
            (Be(),
              k.forEach(function (e) {
                (Pe(`update`, e), i[e] !== null && t && Pe(`set`, e));
              }));
          }
          function We(e) {
            Ue(n.start, e);
          }
          function B(e, t, n, r) {
            if (!((e = Number(e)) >= 0 && e < k.length))
              throw Error(`noUiSlider: invalid handle number, got: ` + e);
            (z(e, He(t, e), !0, !0, r), Pe(`update`, e), n && Pe(`set`, e));
          }
          function Ge(e) {
            if ((e === void 0 && (e = !1), e)) return te.length === 1 ? te[0] : te.slice(0);
            var t = te.map(n.format.to);
            return t.length === 1 ? t[0] : t;
          }
          function Ke() {
            for (
              Ne(ie.aria),
                Ne(ie.tooltips),
                Object.keys(n.cssClasses).forEach(function (e) {
                  h(D, n.cssClasses[e]);
                });
              D.firstChild;
            )
              D.removeChild(D.firstChild);
            delete D.noUiSlider;
          }
          function qe(e) {
            var t = O[e],
              r = ee.getNearbySteps(t),
              i = te[e],
              a = r.thisStep.step,
              o = null;
            if (n.snap)
              return [i - r.stepBefore.startValue || null, r.stepAfter.startValue - i || null];
            (!1 !== a && i + a > r.stepAfter.startValue && (a = r.stepAfter.startValue - i),
              (o =
                i > r.thisStep.startValue
                  ? r.thisStep.step
                  : !1 !== r.stepBefore.step && i - r.stepBefore.highestStep),
              t === 100 ? (a = null) : t === 0 && (o = null));
            var s = ee.countStepDecimals();
            return (
              a !== null && !1 !== a && (a = Number(a.toFixed(s))),
              o !== null && !1 !== o && (o = Number(o.toFixed(s))),
              [o, a]
            );
          }
          function V() {
            return k.map(qe);
          }
          function Je(e, t) {
            var r = Ge(),
              a = [
                `margin`,
                `limit`,
                `padding`,
                `range`,
                `animate`,
                `snap`,
                `step`,
                `format`,
                `pips`,
                `tooltips`,
              ];
            a.forEach(function (t) {
              e[t] !== void 0 && (s[t] = e[t]);
            });
            var o = Se(s);
            (a.forEach(function (t) {
              e[t] !== void 0 && (n[t] = o[t]);
            }),
              (ee = o.spectrum),
              (n.margin = o.margin),
              (n.limit = o.limit),
              (n.padding = o.padding),
              n.pips ? F(n.pips) : ye(),
              n.tooltips ? N() : me(),
              (O = []),
              Ue(i(e.start) ? e.start : r, t));
          }
          function H() {
            ((l = de(D)),
              ue(n.connect, l),
              je(n.events),
              Ue(n.start),
              n.pips && F(n.pips),
              n.tooltips && N(),
              P());
          }
          H();
          var Ye = {
            destroy: Ke,
            steps: V,
            on: Me,
            off: Ne,
            get: Ge,
            set: Ue,
            setHandle: B,
            reset: We,
            __moveHandles: function (e, t, n) {
              Le(e, t, O, n);
            },
            options: s,
            updateOptions: Je,
            target: D,
            removePips: ye,
            removeTooltips: me,
            getPositions: function () {
              return O.slice();
            },
            getTooltips: function () {
              return w;
            },
            getOrigins: function () {
              return p;
            },
            pips: F,
          };
          return Ye;
        }
        function we(e, t) {
          if (!e || !e.nodeName)
            throw Error(`noUiSlider: create requires a single element, got: ` + e);
          if (e.noUiSlider) throw Error(`noUiSlider: Slider was already initialized.`);
          var n = Ce(e, Se(t), t);
          return ((e.noUiSlider = n), n);
        }
        var Te = {
          __spectrum: ne,
          cssClasses: A,
          create: we,
        };
        ((e.create = we),
          (e.cssClasses = A),
          (e.default = Te),
          Object.defineProperty(e, "__esModule", {
            value: !0,
          }));
      })(t);
    }),
  );
function jd(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  let n = t.slice().sort();
  return (
    e.length === t.length &&
    e
      .slice()
      .sort()
      .every(function (e, t) {
        return e === n[t];
      })
  );
}
var Md = {
  name: `Slider`,
  emits: [`input`, `update:modelValue`, `start`, `slide`, `drag`, `update`, `change`, `set`, `end`],
  props: {
    value: {
      validator: function (e) {
        return (e) => typeof e == `number` || e instanceof Array || e == null || !1 === e;
      },
      required: !1,
    },
    modelValue: {
      validator: function (e) {
        return (e) => typeof e == `number` || e instanceof Array || e == null || !1 === e;
      },
      required: !1,
    },
    id: {
      type: [String, Number],
      required: !1,
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1,
    },
    min: {
      type: Number,
      required: !1,
      default: 0,
    },
    max: {
      type: Number,
      required: !1,
      default: 100,
    },
    step: {
      type: Number,
      required: !1,
      default: 1,
    },
    orientation: {
      type: String,
      required: !1,
      default: `horizontal`,
    },
    direction: {
      type: String,
      required: !1,
      default: `ltr`,
    },
    tooltips: {
      type: Boolean,
      required: !1,
      default: !0,
    },
    options: {
      type: Object,
      required: !1,
      default: () => ({}),
    },
    merge: {
      type: Number,
      required: !1,
      default: -1,
    },
    format: {
      type: [Object, Function, Boolean],
      required: !1,
      default: null,
    },
    classes: {
      type: Object,
      required: !1,
      default: () => ({}),
    },
    showTooltip: {
      type: String,
      required: !1,
      default: `always`,
    },
    tooltipPosition: {
      type: String,
      required: !1,
      default: null,
    },
    lazy: {
      type: Boolean,
      required: !1,
      default: !0,
    },
    ariaLabelledby: {
      type: String,
      required: !1,
      default: void 0,
    },
    aria: {
      required: !1,
      type: Object,
      default: () => ({}),
    },
  },
  setup(e, t) {
    let n = (function (e, t, n) {
        let { value: r, modelValue: i, min: a } = ee(e),
          o = i && i.value !== void 0 ? i : r,
          s = F(o.value);
        if ((Ed(o.value) && (o = F(a.value)), Array.isArray(o.value) && o.value.length == 0))
          throw Error(`Slider v-model must not be an empty array`);
        return {
          value: o,
          initialValue: s,
        };
      })(e),
      r = (function (e, t, n) {
        let { classes: r, showTooltip: i, tooltipPosition: a, orientation: o } = ee(e),
          s = V(() => ({
            target: `slider-target`,
            focused: `slider-focused`,
            tooltipFocus: `slider-tooltip-focus`,
            tooltipDrag: `slider-tooltip-drag`,
            ltr: `slider-ltr`,
            rtl: `slider-rtl`,
            horizontal: `slider-horizontal`,
            vertical: `slider-vertical`,
            textDirectionRtl: `slider-txt-dir-rtl`,
            textDirectionLtr: `slider-txt-dir-ltr`,
            base: `slider-base`,
            connects: `slider-connects`,
            connect: `slider-connect`,
            origin: `slider-origin`,
            handle: `slider-handle`,
            handleLower: `slider-handle-lower`,
            handleUpper: `slider-handle-upper`,
            touchArea: `slider-touch-area`,
            tooltip: `slider-tooltip`,
            tooltipTop: `slider-tooltip-top`,
            tooltipBottom: `slider-tooltip-bottom`,
            tooltipLeft: `slider-tooltip-left`,
            tooltipRight: `slider-tooltip-right`,
            tooltipHidden: `slider-tooltip-hidden`,
            active: `slider-active`,
            draggable: `slider-draggable`,
            tap: `slider-state-tap`,
            drag: `slider-state-drag`,
            pips: `slider-pips`,
            pipsHorizontal: `slider-pips-horizontal`,
            pipsVertical: `slider-pips-vertical`,
            marker: `slider-marker`,
            markerHorizontal: `slider-marker-horizontal`,
            markerVertical: `slider-marker-vertical`,
            markerNormal: `slider-marker-normal`,
            markerLarge: `slider-marker-large`,
            markerSub: `slider-marker-sub`,
            value: `slider-value`,
            valueHorizontal: `slider-value-horizontal`,
            valueVertical: `slider-value-vertical`,
            valueNormal: `slider-value-normal`,
            valueLarge: `slider-value-large`,
            valueSub: `slider-value-sub`,
            ...r.value,
          }));
        return {
          classList: V(() => {
            let e = {
              ...s.value,
            };
            return (
              Object.keys(e).forEach((t) => {
                e[t] = Array.isArray(e[t]) ? e[t].filter((e) => e !== null).join(` `) : e[t];
              }),
              i.value !== `always` &&
                (e.target += ` ${i.value === `drag` ? e.tooltipDrag : e.tooltipFocus}`),
              o.value === `horizontal` &&
                (e.tooltip += a.value === `bottom` ? ` ${e.tooltipBottom}` : ` ${e.tooltipTop}`),
              o.value === `vertical` &&
                (e.tooltip += a.value === `right` ? ` ${e.tooltipRight}` : ` ${e.tooltipLeft}`),
              e
            );
          }),
        };
      })(e),
      i = (function (e, t, n) {
        let { format: r, step: i } = ee(e),
          a = n.value,
          o = n.classList,
          s = V(() =>
            r && r.value
              ? typeof r.value == `function`
                ? {
                    to: r.value,
                  }
                : kd({
                    ...r.value,
                  })
              : kd({
                  decimals: i.value >= 0 ? 0 : 2,
                }),
          );
        return {
          tooltipFormat: s,
          tooltipsFormat: V(() => (Array.isArray(a.value) ? a.value.map((e) => s.value) : s.value)),
          tooltipsMerge: (e, t, n) => {
            var r = getComputedStyle(e).direction === `rtl`,
              i = e.noUiSlider.options.direction === `rtl`,
              a = e.noUiSlider.options.orientation === `vertical`,
              c = e.noUiSlider.getTooltips(),
              l = e.noUiSlider.getOrigins();
            (c.forEach(function (e, t) {
              e && l[t].appendChild(e);
            }),
              e.noUiSlider.on(`update`, function (e, l, u, d, f) {
                var p = [[]],
                  m = [[]],
                  h = [[]],
                  g = 0;
                c[0] && ((p[0][0] = 0), (m[0][0] = f[0]), (h[0][0] = s.value.to(parseFloat(e[0]))));
                for (var v = 1; v < e.length; v++)
                  ((!c[v] || e[v] - e[v - 1] > t) && ((p[++g] = []), (h[g] = []), (m[g] = [])),
                    c[v] &&
                      (p[g].push(v), h[g].push(s.value.to(parseFloat(e[v]))), m[g].push(f[v])));
                p.forEach(function (e, t) {
                  for (var s = e.length, l = 0; l < s; l++) {
                    var u = e[l];
                    if (l === s - 1) {
                      var d = 0;
                      m[t].forEach(function (e) {
                        d += 1e3 - e;
                      });
                      var f = a ? `bottom` : `right`,
                        p = i ? 0 : s - 1,
                        g = 1e3 - m[t][p];
                      ((d = (r && !a ? 100 : 0) + d / s - g),
                        (c[u].innerHTML = h[t].join(n)),
                        (c[u].style.display = `block`),
                        (c[u].style[f] = d + `%`),
                        o.value.tooltipHidden.split(` `).forEach((e) => {
                          c[u].classList.contains(e) && c[u].classList.remove(e);
                        }));
                    } else
                      ((c[u].style.display = `none`),
                        o.value.tooltipHidden.split(` `).forEach((e) => {
                          c[u].classList.add(e);
                        }));
                  }
                });
              }));
          },
        };
      })(e, 0, {
        value: n.value,
        classList: r.classList,
      }),
      a = (function (e, t, n) {
        let {
            orientation: r,
            direction: i,
            tooltips: a,
            step: o,
            min: s,
            max: c,
            merge: l,
            id: u,
            disabled: d,
            options: f,
            classes: p,
            format: m,
            lazy: h,
            ariaLabelledby: g,
            aria: v,
          } = ee(e),
          y = n.value,
          b = n.initialValue,
          x = n.tooltipsFormat,
          S = n.tooltipsMerge,
          C = n.tooltipFormat,
          w = n.classList,
          T = F(null),
          D = F(null),
          te = F(!1),
          O = V(() => {
            let e = {
              cssPrefix: ``,
              cssClasses: w.value,
              orientation: r.value,
              direction: i.value,
              tooltips: !!a.value && x.value,
              connect: `lower`,
              start: Ed(y.value) ? s.value : y.value,
              range: {
                min: s.value,
                max: c.value,
              },
            };
            return (
              o.value > 0 && (e.step = o.value),
              Array.isArray(y.value) && (e.connect = !0),
              ((g && g.value) || (v && Object.keys(v.value).length)) &&
                (e.handleAttributes = (Array.isArray(y.value) ? y.value : [y.value]).map((e) =>
                  Object.assign(
                    {},
                    v.value,
                    g && g.value
                      ? {
                          "aria-labelledby": g.value,
                        }
                      : {},
                  ),
                )),
              m.value && (e.ariaFormat = C.value),
              e
            );
          }),
          k = V(() => {
            let e = {
              id: u && u.value ? u.value : void 0,
            };
            return (d.value && (e.disabled = !0), e);
          }),
          ne = V(() => Array.isArray(y.value)),
          re = () => {
            let e = D.value.get();
            return Array.isArray(e) ? e.map((e) => parseFloat(e)) : parseFloat(e);
          },
          A = function (e) {
            let t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
            D.value.set(e, t);
          },
          ie = (e) => {
            (t.emit(`input`, e), t.emit(`update:modelValue`, e), t.emit(`update`, e));
          },
          j = () => {
            ((D.value = Ad.create(T.value, Object.assign({}, O.value, f.value))),
              a.value && ne.value && l.value >= 0 && S(T.value, l.value, ` - `),
              D.value.on(`set`, () => {
                let e = re();
                (t.emit(`change`, e), t.emit(`set`, e), h.value && ie(e));
              }),
              D.value.on(`update`, () => {
                if (!te.value) return;
                let e = re();
                (ne.value && jd(y.value, e)) || (!ne.value && y.value == e)
                  ? t.emit(`update`, e)
                  : h.value || ie(e);
              }),
              D.value.on(`start`, () => {
                t.emit(`start`, re());
              }),
              D.value.on(`end`, () => {
                t.emit(`end`, re());
              }),
              D.value.on(`slide`, () => {
                t.emit(`slide`, re());
              }),
              D.value.on(`drag`, () => {
                t.emit(`drag`, re());
              }),
              T.value.querySelectorAll(`[data-handle]`).forEach((e) => {
                ((e.onblur = () => {
                  T.value &&
                    w.value.focused.split(` `).forEach((e) => {
                      T.value.classList.remove(e);
                    });
                }),
                  (e.onfocus = () => {
                    w.value.focused.split(` `).forEach((e) => {
                      T.value.classList.add(e);
                    });
                  }));
              }),
              (te.value = !0));
          },
          ae = () => {
            (D.value.off(), D.value.destroy(), (D.value = null));
          },
          oe = (e, t) => {
            ((te.value = !1), ae(), j());
          };
        return (
          Qe(j),
          E(ae),
          He(ne, oe, {
            immediate: !1,
          }),
          He(s, oe, {
            immediate: !1,
          }),
          He(c, oe, {
            immediate: !1,
          }),
          He(o, oe, {
            immediate: !1,
          }),
          He(r, oe, {
            immediate: !1,
          }),
          He(i, oe, {
            immediate: !1,
          }),
          He(a, oe, {
            immediate: !1,
          }),
          He(l, oe, {
            immediate: !1,
          }),
          He(m, oe, {
            immediate: !1,
            deep: !0,
          }),
          He(f, oe, {
            immediate: !1,
            deep: !0,
          }),
          He(p, oe, {
            immediate: !1,
            deep: !0,
          }),
          He(
            y,
            (e, t) => {
              t &&
                ((typeof t == `object` &&
                  typeof e == `object` &&
                  e &&
                  Object.keys(t) > Object.keys(e)) ||
                  (typeof t == `object` && typeof e != `object`) ||
                  Ed(e)) &&
                oe();
            },
            {
              immediate: !1,
            },
          ),
          He(
            y,
            (e) => {
              if (Ed(e)) return void A(s.value, !1);
              let t = re();
              (ne.value && !Array.isArray(t) && (t = [t]),
                ((ne.value && !jd(e, t)) || (!ne.value && e != t)) && A(e, !1));
            },
            {
              deep: !0,
            },
          ),
          {
            slider: T,
            slider$: D,
            isRange: ne,
            sliderProps: k,
            init: j,
            destroy: ae,
            refresh: oe,
            update: A,
            reset: () => {
              ie(b.value);
            },
          }
        );
      })(e, t, {
        value: n.value,
        initialValue: n.initialValue,
        tooltipFormat: i.tooltipFormat,
        tooltipsFormat: i.tooltipsFormat,
        tooltipsMerge: i.tooltipsMerge,
        classList: r.classList,
      });
    return {
      ...r,
      ...i,
      ...a,
    };
  },
};
((Md.render = function (e, t, n, r, i, a) {
  return (
    A(),
    M(
      `div`,
      ce(e.sliderProps, {
        ref: `slider`,
      }),
      null,
      16,
    )
  );
}),
  (Md.__file = `src/Slider.vue`));
var Nd = i({
  default: () => Ld,
});
B();
var Pd = {
    class: `flex justify-between`,
  },
  Fd = {
    key: 0,
    class: `ml-2`,
  },
  Id = {
    class: `mt-1`,
  },
  Ld = Object.assign(
    {
      name: `BaseRangeInput`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [String, Number, Array],
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
        invisible: {
          type: Boolean,
          default: !1,
        },
        isRequired: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:error`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = Ae({
            uniqueId: ``,
            input: r.modelValue,
          }),
          a = (e) => {
            (n(`update:modelValue`, e), n(`update:error`, ``));
          };
        return (
          He(
            () => r.modelValue,
            (e) => {
              i.input = e;
            },
          ),
          Qe(() => {
            i.uniqueId = r.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`IsRequired`),
              o = j(`BaseLabel`),
              s = j(`FormError`),
              c = ve(`tooltip`);
            return (
              A(),
              M(`div`, null, [
                W(`div`, Pd, [
                  e.label
                    ? (A(),
                      L(
                        o,
                        {
                          key: 0,
                          for: i.uniqueId,
                        },
                        {
                          default: I(() => [
                            W(`span`, null, [
                              H(T(e.label) + ` `, 1),
                              N(
                                r,
                                {
                                  "is-required": e.isRequired,
                                },
                                null,
                                8,
                                [`is-required`],
                              ),
                            ]),
                            e.labelHint
                              ? Re(
                                  (A(),
                                  M(`span`, Fd, [
                                    ...(n[1] ||= [
                                      W(
                                        `i`,
                                        {
                                          class: `fas fa-question-circle`,
                                        },
                                        null,
                                        -1,
                                      ),
                                    ]),
                                  ])),
                                  [[c, e.labelHint]],
                                )
                              : U(``, !0),
                          ]),
                          _: 1,
                        },
                        8,
                        [`for`],
                      ))
                    : U(``, !0),
                  z(t.$slots, `additional-label`),
                ]),
                W(`div`, Id, [
                  N(
                    P(Md),
                    ce(
                      {
                        id: i.uniqueId,
                      },
                      t.$attrs,
                      {
                        modelValue: i.input,
                        "onUpdate:modelValue": [(n[0] ||= (e) => (i.input = e)), a],
                        class: {
                          "border-b-2": !e.invisible,
                        },
                      },
                    ),
                    null,
                    16,
                    [`id`, `modelValue`, `class`],
                  ),
                ]),
                N(
                  s,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ])
            );
          }
        );
      },
    },
  );
B();
function Rd(e) {
  return e == null;
}
function zd(e, t, n) {
  let { object: r, valueProp: i, mode: a } = ee(e),
    o = te().proxy,
    s = n.iv,
    c = (e, n = !0) => {
      s.value = u(e);
      let r = l(e);
      (t.emit(`change`, r, o), n && (t.emit(`input`, r), t.emit(`update:modelValue`, r)));
    },
    l = (e) => (r.value || Rd(e) ? e : Array.isArray(e) ? e.map((e) => e[i.value]) : e[i.value]),
    u = (e) => (Rd(e) ? (a.value === `single` ? {} : []) : e);
  return {
    update: c,
  };
}
function Bd(e) {
  return Ce(() => ({
    get: e,
    set: () => {},
  }));
}
function Vd(e, t) {
  let { value: n, modelValue: r, mode: i, valueProp: a } = ee(e),
    o = F(i.value === `single` ? {} : []),
    s = Bd(() => (r.value === void 0 ? n.value : r.value)),
    c = V(() => (i.value === `single` ? o.value[a.value] : o.value.map((e) => e[a.value])));
  return {
    iv: o,
    internalValue: o,
    ev: s,
    externalValue: s,
    textValue: Bd(() =>
      i.value === `single` ? o.value[a.value] : o.value.map((e) => e[a.value]).join(`,`),
    ),
    plainValue: c,
  };
}
function Hd(e, t, n) {
  let { regex: r } = ee(e),
    i = te().proxy,
    a = n.isOpen,
    o = n.open,
    s = F(null);
  return (
    He(s, (e) => {
      (!a.value && e && o(), t.emit(`search-change`, e, i));
    }),
    {
      search: s,
      clearSearch: () => {
        s.value = ``;
      },
      handleSearchInput: (e) => {
        s.value = e.target.value;
      },
      handleKeypress: (e) => {
        if (r.value) {
          let t = r.value;
          (typeof t == `string` && (t = new RegExp(t)), e.key.match(t) || e.preventDefault());
        }
      },
      handlePaste: (e) => {
        if (r.value) {
          let t = (e.clipboardData || window.clipboardData).getData(`Text`),
            n = r.value;
          (typeof n == `string` && (n = new RegExp(n)),
            t.split(``).every((e) => !!e.match(n)) || e.preventDefault());
        }
        t.emit(`paste`, e, i);
      },
    }
  );
}
function Ud(e, t, n) {
  let { groupSelect: r, mode: i, groups: a, disabledProp: o } = ee(e),
    s = F(null),
    c = (e) => {
      e === void 0 ||
        (e !== null && e[o.value]) ||
        (a.value && e && e.group && (i.value === `single` || !r.value)) ||
        (s.value = e);
    };
  return {
    pointer: s,
    setPointer: c,
    clearPointer: () => {
      c(null);
    },
  };
}
function Wd(e, t = !0) {
  return t
    ? String(e).toLowerCase().trim()
    : String(e)
        .toLowerCase()
        .normalize(`NFD`)
        .trim()
        .replace(/æ/g, `ae`)
        .replace(/œ/g, `oe`)
        .replace(/ø/g, `o`)
        .replace(/\p{Diacritic}/gu, ``);
}
function Gd(e) {
  return Object.prototype.toString.call(e) === `[object Object]`;
}
function Kd(e, t) {
  if (e.length !== t.length) return !1;
  let n = t.slice().sort();
  return e
    .slice()
    .sort()
    .every(function (e, t) {
      return e === n[t];
    });
}
var qd = (e, t) => {
  if (e === t) return !0;
  if (typeof e != `object` || !e || typeof t != `object` || !t) return !1;
  let n = Object.keys(e),
    r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let i of n) if (!r.includes(i) || !qd(e[i], t[i])) return !1;
  return !0;
};
function Jd(e, t, n) {
  let {
      options: r,
      mode: i,
      trackBy: a,
      limit: o,
      hideSelected: s,
      createTag: c,
      createOption: l,
      label: u,
      appendNewTag: d,
      appendNewOption: f,
      multipleLabel: p,
      object: m,
      loading: h,
      delay: g,
      resolveOnLoad: v,
      minChars: y,
      filterResults: b,
      clearOnSearch: x,
      clearOnSelect: S,
      valueProp: C,
      allowAbsent: w,
      groupLabel: T,
      canDeselect: E,
      max: D,
      strict: O,
      closeOnSelect: k,
      closeOnDeselect: ne,
      groups: re,
      reverse: A,
      infinite: ie,
      groupOptions: j,
      groupHideEmpty: ae,
      groupSelect: oe,
      onCreate: se,
      disabledProp: ce,
      searchStart: le,
      searchFilter: ue,
    } = ee(e),
    de = te().proxy,
    fe = n.iv,
    pe = n.ev,
    M = n.search,
    me = n.clearSearch,
    N = n.update,
    P = n.pointer,
    he = n.setPointer,
    ge = n.clearPointer,
    _e = n.focus,
    ve = n.deactivate,
    ye = n.close,
    be = n.localize,
    I = F([]),
    L = F([]),
    xe = F(!1),
    Se = F(null),
    Ce = F(ie.value && o.value === -1 ? 10 : o.value),
    we = V({
      get: () => L.value,
      set: (e) => (L.value = e),
    }),
    Te = Bd(() => c.value || l.value || !1),
    Ee = Bd(() => (d.value === void 0 ? (f.value === void 0 ? !0 : f.value) : d.value)),
    De = V(() => {
      if (re.value) {
        let e = Ae.value || [],
          t = [];
        return (
          e.forEach((e) => {
            it(e[j.value]).forEach((n) => {
              t.push(
                Object.assign(
                  {},
                  n,
                  e[ce.value]
                    ? {
                        [ce.value]: !0,
                      }
                    : {},
                ),
              );
            });
          }),
          t
        );
      } else {
        let e = it(L.value || []);
        return (I.value.length && (e = e.concat(I.value)), e);
      }
    }),
    Oe = V(() => {
      let e = De.value;
      return (A.value && (e = e.reverse()), Ie.value.length && (e = Ie.value.concat(e)), rt(e));
    }),
    ke = V(() => {
      let e = Oe.value;
      return (Ce.value > 0 && (e = e.slice(0, Ce.value)), e);
    }),
    Ae = V(() => {
      if (!re.value) return [];
      let e = [],
        t = L.value || [];
      return (
        I.value.length &&
          e.push({
            [T.value]: ` `,
            [j.value]: [...I.value],
            __CREATE__: !0,
          }),
        e.concat(t)
      );
    }),
    je = V(() => {
      let e = [...Ae.value].map((e) => ({
        ...e,
      }));
      return (
        Ie.value.length &&
          (e[0] && e[0].__CREATE__
            ? (e[0][j.value] = [...Ie.value, ...e[0][j.value]])
            : (e = [
                {
                  [T.value]: ` `,
                  [j.value]: [...Ie.value],
                  __CREATE__: !0,
                },
              ].concat(e))),
        e
      );
    }),
    Me = V(() => {
      if (!re.value) return [];
      let e = je.value;
      return nt(
        (e || []).map((e, t) => {
          let n = it(e[j.value]);
          return {
            ...e,
            index: t,
            group: !0,
            [j.value]: rt(n, !1).map((t) =>
              Object.assign(
                {},
                t,
                e[ce.value]
                  ? {
                      [ce.value]: !0,
                    }
                  : {},
              ),
            ),
            __VISIBLE__: rt(n).map((t) =>
              Object.assign(
                {},
                t,
                e[ce.value]
                  ? {
                      [ce.value]: !0,
                    }
                  : {},
              ),
            ),
          };
        }),
      );
    }),
    R = V(() => {
      switch (i.value) {
        case `single`:
          return !Rd(fe.value[C.value]);
        case `multiple`:
        case `tags`:
          return !Rd(fe.value) && fe.value.length > 0;
      }
    }),
    Ne = V(() =>
      p.value === void 0
        ? fe.value && fe.value.length > 1
          ? `${fe.value.length} options selected`
          : `1 option selected`
        : p.value(fe.value, de),
    ),
    Pe = Bd(() => !De.value.length && !xe.value && !Ie.value.length),
    Fe = Bd(
      () => De.value.length > 0 && ke.value.length == 0 && ((M.value && re.value) || !re.value),
    ),
    Ie = V(() =>
      Te.value === !1 || !M.value || $e(M.value) !== -1
        ? []
        : [
            {
              [C.value]: M.value,
              [Le.value[0]]: M.value,
              [u.value]: M.value,
              __CREATE__: !0,
            },
          ],
    ),
    Le = V(() => (a.value ? (Array.isArray(a.value) ? a.value : [a.value]) : [u.value])),
    Re = Bd(() => {
      switch (i.value) {
        case `single`:
          return null;
        case `multiple`:
        case `tags`:
          return [];
      }
    }),
    ze = Bd(() => h.value || xe.value),
    Be = (e) => {
      switch ((typeof e != `object` && (e = Qe(e)), i.value)) {
        case `single`:
          N(e);
          break;
        case `multiple`:
        case `tags`:
          N(fe.value.concat(e));
          break;
      }
      t.emit(`select`, Ve(e), e, de);
    },
    z = (e) => {
      switch ((typeof e != `object` && (e = Qe(e)), i.value)) {
        case `single`:
          B();
          break;
        case `tags`:
        case `multiple`:
          N(
            Array.isArray(e)
              ? fe.value.filter((t) => e.map((e) => e[C.value]).indexOf(t[C.value]) === -1)
              : fe.value.filter((t) => t[C.value] != e[C.value]),
          );
          break;
      }
      t.emit(`deselect`, Ve(e), e, de);
    },
    Ve = (e) => (m.value ? e : e[C.value]),
    Ue = (e) => {
      z(e);
    },
    We = (e, t) => {
      if (t.button !== 0) {
        t.preventDefault();
        return;
      }
      Ue(e);
    },
    B = () => {
      (N(Re.value), t.emit(`clear`, de));
    },
    Ge = (e) => {
      if (e.group !== void 0)
        return i.value === `single` ? !1 : Ze(e[j.value]) && e[j.value].length;
      switch (i.value) {
        case `single`:
          return (
            !Rd(fe.value) &&
            (fe.value[C.value] == e[C.value] ||
              (typeof fe.value[C.value] == `object` &&
                typeof e[C.value] == `object` &&
                qd(fe.value[C.value], e[C.value])))
          );
        case `tags`:
        case `multiple`:
          return !Rd(fe.value) && fe.value.map((e) => e[C.value]).indexOf(e[C.value]) !== -1;
      }
    },
    Ke = (e) => e[ce.value] === !0,
    qe = () =>
      D === void 0 || D.value === -1 || (!R.value && D.value > 0) ? !1 : fe.value.length >= D.value,
    Je = (e) => {
      if (!Ke(e)) {
        if (
          se.value &&
          !Ge(e) &&
          e.__CREATE__ &&
          ((e = {
            ...e,
          }),
          delete e.__CREATE__,
          (e = se.value(e, de)),
          e instanceof Promise)
        ) {
          ((xe.value = !0),
            e.then((e) => {
              ((xe.value = !1), H(e));
            }));
          return;
        }
        H(e);
      }
    },
    H = (e) => {
      switch (
        (e.__CREATE__ &&
          ((e = {
            ...e,
          }),
          delete e.__CREATE__),
        i.value)
      ) {
        case `single`:
          if (e && Ge(e)) {
            (E.value && z(e), ne.value && (ge(), ye()));
            return;
          }
          (e && U(e), S.value && me(), k.value && (ge(), ye()), e && Be(e));
          break;
        case `multiple`:
          if (e && Ge(e)) {
            (z(e), ne.value && (ge(), ye()));
            return;
          }
          if (qe()) {
            t.emit(`max`, de);
            return;
          }
          (e && (U(e), Be(e)), S.value && me(), s.value && ge(), k.value && ye());
          break;
        case `tags`:
          if (e && Ge(e)) {
            (z(e), ne.value && (ge(), ye()));
            return;
          }
          if (qe()) {
            t.emit(`max`, de);
            return;
          }
          (e && U(e), S.value && me(), e && Be(e), s.value && ge(), k.value && ye());
          break;
      }
      k.value || _e();
    },
    Ye = (e) => {
      if (!(Ke(e) || i.value === `single` || !oe.value)) {
        switch (i.value) {
          case `multiple`:
          case `tags`:
            (W(e[j.value])
              ? z(e[j.value])
              : Be(
                  e[j.value]
                    .filter((e) => fe.value.map((e) => e[C.value]).indexOf(e[C.value]) === -1)
                    .filter((e) => !e[ce.value])
                    .filter((e, t) => fe.value.length + 1 + t <= D.value || D.value === -1),
                ),
              s.value && P.value && he(Me.value.filter((e) => !e[ce.value])[P.value.index]));
            break;
        }
        k.value && ve();
      }
    },
    U = (e) => {
      Qe(e[C.value]) === void 0 &&
        Te.value &&
        (t.emit(`tag`, e[C.value], de),
        t.emit(`option`, e[C.value], de),
        t.emit(`create`, e[C.value], de),
        Ee.value && tt(e),
        me());
    },
    Xe = () => {
      i.value !== `single` && Be(ke.value.filter((e) => !e.disabled && !Ge(e)));
    },
    W = (e) => e.find((e) => !Ge(e) && !e[ce.value]) === void 0,
    Ze = (e) => e.find((e) => !Ge(e)) === void 0,
    Qe = (e) => De.value[De.value.map((e) => String(e[C.value])).indexOf(String(e))],
    $e = (e) =>
      De.value.findIndex((t) =>
        Le.value.some(
          (n) =>
            (parseInt(t[n]) == t[n] ? parseInt(t[n]) : t[n]) ===
            (parseInt(e) == e ? parseInt(e) : e),
        ),
      ),
    et = (e) => [`tags`, `multiple`].indexOf(i.value) !== -1 && s.value && Ge(e),
    tt = (e) => {
      I.value.push(e);
    },
    nt = (e) =>
      ae.value
        ? e.filter((e) => (M.value ? e.__VISIBLE__.length : e[j.value].length))
        : e.filter((e) => (M.value ? e.__VISIBLE__.length : !0)),
    rt = (e, t = !0) => {
      let n = e;
      if (M.value && b.value) {
        let e = ue.value;
        ((e ||= (e, t, n) =>
          Le.value.some((n) => {
            let r = Wd(be(e[n]), O.value);
            return le.value ? r.startsWith(Wd(t, O.value)) : r.indexOf(Wd(t, O.value)) !== -1;
          })),
          (n = n.filter((t) => e(t, M.value, de))));
      }
      return (s.value && t && (n = n.filter((e) => !et(e))), n);
    },
    it = (e) => {
      let t = e;
      return (
        Gd(t) &&
          (t = Object.keys(t).map((e) => {
            let n = t[e];
            return {
              [C.value]: e,
              [Le.value[0]]: n,
              [u.value]: n,
            };
          })),
        (t =
          t && Array.isArray(t)
            ? t.map((e) =>
                typeof e == `object`
                  ? e
                  : {
                      [C.value]: e,
                      [Le.value[0]]: e,
                      [u.value]: e,
                    },
              )
            : []),
        t
      );
    },
    at = () => {
      Rd(pe.value) || (fe.value = lt(pe.value));
    },
    ot = (e) => (
      (xe.value = !0),
      new Promise((t, n) => {
        r.value(M.value, de)
          .then((t) => {
            ((L.value = t || []), typeof e == `function` && e(t), (xe.value = !1));
          })
          .catch((e) => {
            (console.error(e), (L.value = []), (xe.value = !1));
          })
          .finally(() => {
            t();
          });
      })
    ),
    st = () => {
      if (R.value)
        if (i.value === `single`) {
          let e = Qe(fe.value[C.value]);
          if (e !== void 0) {
            let t = e[u.value];
            ((fe.value[u.value] = t), m.value && (pe.value[u.value] = t));
          }
        } else
          fe.value.forEach((e, t) => {
            let n = Qe(fe.value[t][C.value]);
            if (n !== void 0) {
              let e = n[u.value];
              ((fe.value[t][u.value] = e), m.value && (pe.value[t][u.value] = e));
            }
          });
    },
    ct = (e) => {
      ot(e);
    },
    lt = (e) =>
      Rd(e)
        ? i.value === `single`
          ? {}
          : []
        : m.value
          ? e
          : i.value === `single`
            ? Qe(e) ||
              (w.value
                ? {
                    [u.value]: e,
                    [C.value]: e,
                    [Le.value[0]]: e,
                  }
                : {})
            : e
                .filter((e) => !!Qe(e) || w.value)
                .map(
                  (e) =>
                    Qe(e) || {
                      [u.value]: e,
                      [C.value]: e,
                      [Le.value[0]]: e,
                    },
                ),
    ut = () => {
      Se.value = He(
        M,
        (e) => {
          e.length < y.value ||
            (!e && y.value !== 0) ||
            ((xe.value = !0),
            x.value && (L.value = []),
            setTimeout(() => {
              e == M.value &&
                r
                  .value(M.value, de)
                  .then((t) => {
                    (e == M.value || !M.value) &&
                      ((L.value = t),
                      (P.value = ke.value.filter((e) => e[ce.value] !== !0)[0] || null),
                      (xe.value = !1));
                  })
                  .catch((e) => {
                    console.error(e);
                  });
            }, g.value));
        },
        {
          flush: `sync`,
        },
      );
    };
  if (i.value !== `single` && !Rd(pe.value) && !Array.isArray(pe.value))
    throw Error(`v-model must be an array when using "${i.value}" mode`);
  return (
    r && typeof r.value == `function`
      ? v.value
        ? ot(at)
        : m.value == 1 && at()
      : ((L.value = r.value), at()),
    g.value > -1 && ut(),
    He(g, (e, t) => {
      (Se.value && Se.value(), e >= 0 && ut());
    }),
    He(
      pe,
      (e) => {
        if (Rd(e)) {
          N(lt(e), !1);
          return;
        }
        switch (i.value) {
          case `single`:
            (m.value ? e[C.value] != fe.value[C.value] : e != fe.value[C.value]) && N(lt(e), !1);
            break;
          case `multiple`:
          case `tags`:
            Kd(
              m.value ? e.map((e) => e[C.value]) : e,
              fe.value.map((e) => e[C.value]),
            ) || N(lt(e), !1);
            break;
        }
      },
      {
        deep: !0,
      },
    ),
    He(r, (t, n) => {
      typeof e.options == `function`
        ? v.value && (!n || (t && t.toString() !== n.toString())) && ot()
        : ((L.value = e.options), Object.keys(fe.value).length || at(), st());
    }),
    He(u, st),
    He(o, (e, t) => {
      Ce.value = ie.value && e === -1 ? 10 : e;
    }),
    {
      resolvedOptions: we,
      pfo: Oe,
      fo: ke,
      filteredOptions: ke,
      hasSelected: R,
      multipleLabelText: Ne,
      eo: De,
      extendedOptions: De,
      eg: Ae,
      extendedGroups: Ae,
      fg: Me,
      filteredGroups: Me,
      noOptions: Pe,
      noResults: Fe,
      resolving: xe,
      busy: ze,
      offset: Ce,
      select: Be,
      deselect: z,
      remove: Ue,
      selectAll: Xe,
      clear: B,
      isSelected: Ge,
      isDisabled: Ke,
      isMax: qe,
      getOption: Qe,
      handleOptionClick: Je,
      handleGroupClick: Ye,
      handleTagRemove: We,
      refreshOptions: ct,
      resolveOptions: ot,
      refreshLabels: st,
    }
  );
}
function Yd(e, t, n) {
  let {
      valueProp: r,
      showOptions: i,
      searchable: a,
      groupLabel: o,
      groups: s,
      mode: c,
      groupSelect: l,
      disabledProp: u,
      groupOptions: d,
    } = ee(e),
    f = n.fo,
    p = n.fg,
    m = n.handleOptionClick,
    h = n.handleGroupClick,
    g = n.search,
    v = n.pointer,
    y = n.setPointer,
    b = n.clearPointer,
    x = n.multiselect,
    S = n.isOpen,
    C = V(() => f.value.filter((e) => !e[u.value])),
    w = V(() => p.value.filter((e) => !e[u.value])),
    T = Bd(() => c.value !== `single` && l.value),
    E = Bd(() => v.value && v.value.group),
    D = V(() => ue(v.value)),
    te = V(() => {
      let e = E.value ? v.value : ue(v.value),
        t = w.value.map((e) => e[o.value]).indexOf(e[o.value]),
        n = w.value[t - 1];
      return (n === void 0 && (n = k.value), n);
    }),
    O = V(() => {
      let e =
        w.value.map((e) => e.label).indexOf(E.value ? v.value[o.value] : ue(v.value)[o.value]) + 1;
      return (w.value.length <= e && (e = 0), w.value[e]);
    }),
    k = V(() => [...w.value].slice(-1)[0]),
    ne = V(() => v.value.__VISIBLE__.filter((e) => !e[u.value])[0]),
    re = V(() => {
      let e = D.value.__VISIBLE__.filter((e) => !e[u.value]);
      return e[e.map((e) => e[r.value]).indexOf(v.value[r.value]) - 1];
    }),
    A = V(() => {
      let e = ue(v.value).__VISIBLE__.filter((e) => !e[u.value]);
      return e[e.map((e) => e[r.value]).indexOf(v.value[r.value]) + 1];
    }),
    ie = V(() => [...te.value.__VISIBLE__.filter((e) => !e[u.value])].slice(-1)[0]),
    j = V(() => [...k.value.__VISIBLE__.filter((e) => !e[u.value])].slice(-1)[0]),
    ae = (e) =>
      v.value &&
      ((!e.group && v.value[r.value] === e[r.value]) ||
        (e.group !== void 0 && v.value[o.value] === e[o.value]))
        ? !0
        : void 0,
    oe = () => {
      y(C.value[0] || null);
    },
    se = () => {
      !v.value || v.value[u.value] === !0 || (E.value ? h(v.value) : m(v.value));
    },
    ce = () => {
      if (v.value === null)
        y(
          (s.value && T.value ? (w.value[0].__CREATE__ ? C.value[0] : w.value[0]) : C.value[0]) ||
            null,
        );
      else if (s.value && T.value) {
        let e = E.value ? ne.value : A.value;
        (e === void 0 && ((e = O.value), e.__CREATE__ && (e = e[d.value][0])), y(e || null));
      } else {
        let e = C.value.map((e) => e[r.value]).indexOf(v.value[r.value]) + 1;
        (C.value.length <= e && (e = 0), y(C.value[e] || null));
      }
      de(() => {
        fe();
      });
    },
    le = () => {
      if (v.value === null) {
        let e = C.value[C.value.length - 1];
        (s.value && T.value && ((e = j.value), e === void 0 && (e = k.value)), y(e || null));
      } else if (s.value && T.value) {
        let e = E.value ? ie.value : re.value;
        (e === void 0 &&
          ((e = E.value ? te.value : D.value),
          e.__CREATE__ && ((e = ie.value), e === void 0 && (e = te.value))),
          y(e || null));
      } else {
        let e = C.value.map((e) => e[r.value]).indexOf(v.value[r.value]) - 1;
        (e < 0 && (e = C.value.length - 1), y(C.value[e] || null));
      }
      de(() => {
        fe();
      });
    },
    ue = (e) =>
      w.value.find((t) => t.__VISIBLE__.map((e) => e[r.value]).indexOf(e[r.value]) !== -1),
    fe = () => {
      let e = x.value.querySelector(`[data-pointed]`);
      if (!e) return;
      let t = e.parentElement.parentElement;
      (s.value &&
        (t = E.value
          ? e.parentElement.parentElement.parentElement
          : e.parentElement.parentElement.parentElement.parentElement),
        e.offsetTop + e.offsetHeight > t.clientHeight + t.scrollTop &&
          (t.scrollTop = e.offsetTop + e.offsetHeight - t.clientHeight),
        e.offsetTop < t.scrollTop && (t.scrollTop = e.offsetTop));
    };
  return (
    He(g, (e) => {
      a.value && (e.length && i.value ? oe() : b());
    }),
    He(S, (e) => {
      if (e && x && x.value) {
        let e = x.value.querySelectorAll(`[data-selected]`)[0];
        if (!e) return;
        let t = e.parentElement.parentElement;
        de(() => {
          t.scrollTop = e.offsetTop;
        });
      }
    }),
    {
      pointer: v,
      canPointGroups: T,
      isPointed: ae,
      setPointerFirst: oe,
      selectPointer: se,
      forwardPointer: ce,
      backwardPointer: le,
    }
  );
}
function Xd(e) {
  if (e == null) return window;
  if (e.toString() !== `[object Window]`) {
    var t = e.ownerDocument;
    return (t && t.defaultView) || window;
  }
  return e;
}
function Zd(e) {
  return e instanceof Xd(e).Element || e instanceof Element;
}
function Qd(e) {
  return e instanceof Xd(e).HTMLElement || e instanceof HTMLElement;
}
function $d(e) {
  return typeof ShadowRoot > `u` ? !1 : e instanceof Xd(e).ShadowRoot || e instanceof ShadowRoot;
}
var ef = Math.max,
  tf = Math.min,
  nf = Math.round;
function rf() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands)
    ? e.brands
        .map(function (e) {
          return e.brand + `/` + e.version;
        })
        .join(` `)
    : navigator.userAgent;
}
function af() {
  return !/^((?!chrome|android).)*safari/i.test(rf());
}
function of(e, t, n) {
  (t === void 0 && (t = !1), n === void 0 && (n = !1));
  var r = e.getBoundingClientRect(),
    i = 1,
    a = 1;
  t &&
    Qd(e) &&
    ((i = (e.offsetWidth > 0 && nf(r.width) / e.offsetWidth) || 1),
    (a = (e.offsetHeight > 0 && nf(r.height) / e.offsetHeight) || 1));
  var o = (Zd(e) ? Xd(e) : window).visualViewport,
    s = !af() && n,
    c = (r.left + (s && o ? o.offsetLeft : 0)) / i,
    l = (r.top + (s && o ? o.offsetTop : 0)) / a,
    u = r.width / i,
    d = r.height / a;
  return {
    width: u,
    height: d,
    top: l,
    right: c + u,
    bottom: l + d,
    left: c,
    x: c,
    y: l,
  };
}
function sf(e) {
  var t = Xd(e);
  return {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset,
  };
}
function cf(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop,
  };
}
function lf(e) {
  return e === Xd(e) || !Qd(e) ? sf(e) : cf(e);
}
function uf(e) {
  return e ? (e.nodeName || ``).toLowerCase() : null;
}
function df(e) {
  return ((Zd(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function ff(e) {
  return of(df(e)).left + sf(e).scrollLeft;
}
function pf(e) {
  return Xd(e).getComputedStyle(e);
}
function mf(e) {
  var t = pf(e),
    n = t.overflow,
    r = t.overflowX,
    i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function hf(e) {
  var t = e.getBoundingClientRect(),
    n = nf(t.width) / e.offsetWidth || 1,
    r = nf(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function gf(e, t, n) {
  n === void 0 && (n = !1);
  var r = Qd(t),
    i = Qd(t) && hf(t),
    a = df(t),
    o = of(e, i, n),
    s = {
      scrollLeft: 0,
      scrollTop: 0,
    },
    c = {
      x: 0,
      y: 0,
    };
  return (
    (r || (!r && !n)) &&
      ((uf(t) !== `body` || mf(a)) && (s = lf(t)),
      Qd(t) ? ((c = of(t, !0)), (c.x += t.clientLeft), (c.y += t.clientTop)) : a && (c.x = ff(a))),
    {
      x: o.left + s.scrollLeft - c.x,
      y: o.top + s.scrollTop - c.y,
      width: o.width,
      height: o.height,
    }
  );
}
function _f(e) {
  var t = of(e),
    n = e.offsetWidth,
    r = e.offsetHeight;
  return (
    Math.abs(t.width - n) <= 1 && (n = t.width),
    Math.abs(t.height - r) <= 1 && (r = t.height),
    {
      x: e.offsetLeft,
      y: e.offsetTop,
      width: n,
      height: r,
    }
  );
}
function vf(e) {
  return uf(e) === `html` ? e : e.assignedSlot || e.parentNode || ($d(e) ? e.host : null) || df(e);
}
function yf(e) {
  return [`html`, `body`, `#document`].indexOf(uf(e)) >= 0
    ? e.ownerDocument.body
    : Qd(e) && mf(e)
      ? e
      : yf(vf(e));
}
function bf(e, t) {
  t === void 0 && (t = []);
  var n = yf(e),
    r = n === e.ownerDocument?.body,
    i = Xd(n),
    a = r ? [i].concat(i.visualViewport || [], mf(n) ? n : []) : n,
    o = t.concat(a);
  return r ? o : o.concat(bf(vf(a)));
}
function xf(e) {
  return [`table`, `td`, `th`].indexOf(uf(e)) >= 0;
}
function Sf(e) {
  return !Qd(e) || pf(e).position === `fixed` ? null : e.offsetParent;
}
function Cf(e) {
  var t = /firefox/i.test(rf());
  if (/Trident/i.test(rf()) && Qd(e) && pf(e).position === `fixed`) return null;
  var n = vf(e);
  for ($d(n) && (n = n.host); Qd(n) && [`html`, `body`].indexOf(uf(n)) < 0;) {
    var r = pf(n);
    if (
      r.transform !== `none` ||
      r.perspective !== `none` ||
      r.contain === `paint` ||
      [`transform`, `perspective`].indexOf(r.willChange) !== -1 ||
      (t && r.willChange === `filter`) ||
      (t && r.filter && r.filter !== `none`)
    )
      return n;
    n = n.parentNode;
  }
  return null;
}
function wf(e) {
  for (var t = Xd(e), n = Sf(e); n && xf(n) && pf(n).position === `static`;) n = Sf(n);
  return n && (uf(n) === `html` || (uf(n) === `body` && pf(n).position === `static`))
    ? t
    : n || Cf(e) || t;
}
var Tf = `top`,
  Ef = `bottom`,
  Df = `right`,
  Of = `left`,
  kf = `auto`,
  Af = [Tf, Ef, Df, Of],
  jf = `start`,
  Mf = `end`,
  Nf = `clippingParents`,
  Pf = `viewport`,
  Ff = `popper`,
  If = `reference`,
  Lf = Af.reduce(function (e, t) {
    return e.concat([t + `-` + jf, t + `-` + Mf]);
  }, []),
  Rf = [].concat(Af, [kf]).reduce(function (e, t) {
    return e.concat([t, t + `-` + jf, t + `-` + Mf]);
  }, []),
  zf = [
    `beforeRead`,
    `read`,
    `afterRead`,
    `beforeMain`,
    `main`,
    `afterMain`,
    `beforeWrite`,
    `write`,
    `afterWrite`,
  ];
function Bf(e) {
  var t = new Map(),
    n = new Set(),
    r = [];
  e.forEach(function (e) {
    t.set(e.name, e);
  });
  function i(e) {
    (n.add(e.name),
      [].concat(e.requires || [], e.requiresIfExists || []).forEach(function (e) {
        if (!n.has(e)) {
          var r = t.get(e);
          r && i(r);
        }
      }),
      r.push(e));
  }
  return (
    e.forEach(function (e) {
      n.has(e.name) || i(e);
    }),
    r
  );
}
function Vf(e) {
  var t = Bf(e);
  return zf.reduce(function (e, n) {
    return e.concat(
      t.filter(function (e) {
        return e.phase === n;
      }),
    );
  }, []);
}
function Hf(e) {
  var t;
  return function () {
    return (
      (t ||= new Promise(function (n) {
        Promise.resolve().then(function () {
          ((t = void 0), n(e()));
        });
      })),
      t
    );
  };
}
function Uf(e) {
  var t = e.reduce(function (e, t) {
    var n = e[t.name];
    return (
      (e[t.name] = n
        ? Object.assign({}, n, t, {
            options: Object.assign({}, n.options, t.options),
            data: Object.assign({}, n.data, t.data),
          })
        : t),
      e
    );
  }, {});
  return Object.keys(t).map(function (e) {
    return t[e];
  });
}
function Wf(e, t) {
  var n = Xd(e),
    r = df(e),
    i = n.visualViewport,
    a = r.clientWidth,
    o = r.clientHeight,
    s = 0,
    c = 0;
  if (i) {
    ((a = i.width), (o = i.height));
    var l = af();
    (l || (!l && t === `fixed`)) && ((s = i.offsetLeft), (c = i.offsetTop));
  }
  return {
    width: a,
    height: o,
    x: s + ff(e),
    y: c,
  };
}
function Gf(e) {
  var t = df(e),
    n = sf(e),
    r = e.ownerDocument?.body,
    i = ef(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0),
    a = ef(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0),
    o = -n.scrollLeft + ff(e),
    s = -n.scrollTop;
  return (
    pf(r || t).direction === `rtl` && (o += ef(t.clientWidth, r ? r.clientWidth : 0) - i),
    {
      width: i,
      height: a,
      x: o,
      y: s,
    }
  );
}
function Kf(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t)) return !0;
  if (n && $d(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r)) return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function qf(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height,
  });
}
function Jf(e, t) {
  var n = of(e, !1, t === `fixed`);
  return (
    (n.top += e.clientTop),
    (n.left += e.clientLeft),
    (n.bottom = n.top + e.clientHeight),
    (n.right = n.left + e.clientWidth),
    (n.width = e.clientWidth),
    (n.height = e.clientHeight),
    (n.x = n.left),
    (n.y = n.top),
    n
  );
}
function Yf(e, t, n) {
  return t === Pf ? qf(Wf(e, n)) : Zd(t) ? Jf(t, n) : qf(Gf(df(e)));
}
function Xf(e) {
  var t = bf(vf(e)),
    n = [`absolute`, `fixed`].indexOf(pf(e).position) >= 0 && Qd(e) ? wf(e) : e;
  return Zd(n)
    ? t.filter(function (e) {
        return Zd(e) && Kf(e, n) && uf(e) !== `body`;
      })
    : [];
}
function Zf(e, t, n, r) {
  var i = t === `clippingParents` ? Xf(e) : [].concat(t),
    a = [].concat(i, [n]),
    o = a[0],
    s = a.reduce(
      function (t, n) {
        var i = Yf(e, n, r);
        return (
          (t.top = ef(i.top, t.top)),
          (t.right = tf(i.right, t.right)),
          (t.bottom = tf(i.bottom, t.bottom)),
          (t.left = ef(i.left, t.left)),
          t
        );
      },
      Yf(e, o, r),
    );
  return (
    (s.width = s.right - s.left),
    (s.height = s.bottom - s.top),
    (s.x = s.left),
    (s.y = s.top),
    s
  );
}
function Qf(e) {
  return e.split(`-`)[0];
}
function $f(e) {
  return e.split(`-`)[1];
}
function ep(e) {
  return [`top`, `bottom`].indexOf(e) >= 0 ? `x` : `y`;
}
function tp(e) {
  var t = e.reference,
    n = e.element,
    r = e.placement,
    i = r ? Qf(r) : null,
    a = r ? $f(r) : null,
    o = t.x + t.width / 2 - n.width / 2,
    s = t.y + t.height / 2 - n.height / 2,
    c;
  switch (i) {
    case Tf:
      c = {
        x: o,
        y: t.y - n.height,
      };
      break;
    case Ef:
      c = {
        x: o,
        y: t.y + t.height,
      };
      break;
    case Df:
      c = {
        x: t.x + t.width,
        y: s,
      };
      break;
    case Of:
      c = {
        x: t.x - n.width,
        y: s,
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y,
      };
  }
  var l = i ? ep(i) : null;
  if (l != null) {
    var u = l === `y` ? `height` : `width`;
    switch (a) {
      case jf:
        c[l] = c[l] - (t[u] / 2 - n[u] / 2);
        break;
      case Mf:
        c[l] = c[l] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return c;
}
function np() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
}
function rp(e) {
  return Object.assign({}, np(), e);
}
function ip(e, t) {
  return t.reduce(function (t, n) {
    return ((t[n] = e), t);
  }, {});
}
function ap(e, t) {
  t === void 0 && (t = {});
  var n = t,
    r = n.placement,
    i = r === void 0 ? e.placement : r,
    a = n.strategy,
    o = a === void 0 ? e.strategy : a,
    s = n.boundary,
    c = s === void 0 ? Nf : s,
    l = n.rootBoundary,
    u = l === void 0 ? Pf : l,
    d = n.elementContext,
    f = d === void 0 ? Ff : d,
    p = n.altBoundary,
    m = p === void 0 ? !1 : p,
    h = n.padding,
    g = h === void 0 ? 0 : h,
    v = rp(typeof g == `number` ? ip(g, Af) : g),
    y = f === Ff ? If : Ff,
    b = e.rects.popper,
    x = e.elements[m ? y : f],
    S = Zf(Zd(x) ? x : x.contextElement || df(e.elements.popper), c, u, o),
    C = of(e.elements.reference),
    w = tp({
      reference: C,
      element: b,
      strategy: `absolute`,
      placement: i,
    }),
    T = qf(Object.assign({}, b, w)),
    E = f === Ff ? T : C,
    D = {
      top: S.top - E.top + v.top,
      bottom: E.bottom - S.bottom + v.bottom,
      left: S.left - E.left + v.left,
      right: E.right - S.right + v.right,
    },
    ee = e.modifiersData.offset;
  if (f === Ff && ee) {
    var te = ee[i];
    Object.keys(D).forEach(function (e) {
      var t = [Df, Ef].indexOf(e) >= 0 ? 1 : -1,
        n = [Tf, Ef].indexOf(e) >= 0 ? `y` : `x`;
      D[e] += te[n] * t;
    });
  }
  return D;
}
var op = {
  placement: `bottom`,
  modifiers: [],
  strategy: `absolute`,
};
function sp() {
  return ![...arguments].some(function (e) {
    return !(e && typeof e.getBoundingClientRect == `function`);
  });
}
function cp(e) {
  e === void 0 && (e = {});
  var t = e,
    n = t.defaultModifiers,
    r = n === void 0 ? [] : n,
    i = t.defaultOptions,
    a = i === void 0 ? op : i;
  return function (e, t, n) {
    n === void 0 && (n = a);
    var i = {
        placement: `bottom`,
        orderedModifiers: [],
        options: Object.assign({}, op, a),
        modifiersData: {},
        elements: {
          reference: e,
          popper: t,
        },
        attributes: {},
        styles: {},
      },
      o = [],
      s = !1,
      c = {
        state: i,
        setOptions: function (n) {
          var o = typeof n == `function` ? n(i.options) : n;
          (u(),
            (i.options = Object.assign({}, a, i.options, o)),
            (i.scrollParents = {
              reference: Zd(e) ? bf(e) : e.contextElement ? bf(e.contextElement) : [],
              popper: bf(t),
            }));
          var s = Vf(Uf([].concat(r, i.options.modifiers)));
          return (
            (i.orderedModifiers = s.filter(function (e) {
              return e.enabled;
            })),
            l(),
            c.update()
          );
        },
        forceUpdate: function () {
          if (!s) {
            var e = i.elements,
              t = e.reference,
              n = e.popper;
            if (sp(t, n)) {
              ((i.rects = {
                reference: gf(t, wf(n), i.options.strategy === `fixed`),
                popper: _f(n),
              }),
                (i.reset = !1),
                (i.placement = i.options.placement),
                i.orderedModifiers.forEach(function (e) {
                  return (i.modifiersData[e.name] = Object.assign({}, e.data));
                }));
              for (var r = 0; r < i.orderedModifiers.length; r++) {
                if (i.reset === !0) {
                  ((i.reset = !1), (r = -1));
                  continue;
                }
                var a = i.orderedModifiers[r],
                  o = a.fn,
                  l = a.options,
                  u = l === void 0 ? {} : l,
                  d = a.name;
                typeof o == `function` &&
                  (i =
                    o({
                      state: i,
                      options: u,
                      name: d,
                      instance: c,
                    }) || i);
              }
            }
          }
        },
        update: Hf(function () {
          return new Promise(function (e) {
            (c.forceUpdate(), e(i));
          });
        }),
        destroy: function () {
          (u(), (s = !0));
        },
      };
    if (!sp(e, t)) return c;
    c.setOptions(n).then(function (e) {
      !s && n.onFirstUpdate && n.onFirstUpdate(e);
    });
    function l() {
      i.orderedModifiers.forEach(function (e) {
        var t = e.name,
          n = e.options,
          r = n === void 0 ? {} : n,
          a = e.effect;
        if (typeof a == `function`) {
          var s = a({
            state: i,
            name: t,
            instance: c,
            options: r,
          });
          o.push(s || function () {});
        }
      });
    }
    function u() {
      (o.forEach(function (e) {
        return e();
      }),
        (o = []));
    }
    return c;
  };
}
var lp = {
  passive: !0,
};
function up(e) {
  var t = e.state,
    n = e.instance,
    r = e.options,
    i = r.scroll,
    a = i === void 0 ? !0 : i,
    o = r.resize,
    s = o === void 0 ? !0 : o,
    c = Xd(t.elements.popper),
    l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return (
    a &&
      l.forEach(function (e) {
        e.addEventListener(`scroll`, n.update, lp);
      }),
    s && c.addEventListener(`resize`, n.update, lp),
    function () {
      (a &&
        l.forEach(function (e) {
          e.removeEventListener(`scroll`, n.update, lp);
        }),
        s && c.removeEventListener(`resize`, n.update, lp));
    }
  );
}
var dp = {
  name: `eventListeners`,
  enabled: !0,
  phase: `write`,
  fn: function () {},
  effect: up,
  data: {},
};
function fp(e) {
  var t = e.state,
    n = e.name;
  t.modifiersData[n] = tp({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: `absolute`,
    placement: t.placement,
  });
}
var pp = {
    name: `popperOffsets`,
    enabled: !0,
    phase: `read`,
    fn: fp,
    data: {},
  },
  mp = {
    top: `auto`,
    right: `auto`,
    bottom: `auto`,
    left: `auto`,
  };
function hp(e, t) {
  var n = e.x,
    r = e.y,
    i = t.devicePixelRatio || 1;
  return {
    x: nf(n * i) / i || 0,
    y: nf(r * i) / i || 0,
  };
}
function gp(e) {
  var t,
    n = e.popper,
    r = e.popperRect,
    i = e.placement,
    a = e.variation,
    o = e.offsets,
    s = e.position,
    c = e.gpuAcceleration,
    l = e.adaptive,
    u = e.roundOffsets,
    d = e.isFixed,
    f = o.x,
    p = f === void 0 ? 0 : f,
    m = o.y,
    h = m === void 0 ? 0 : m,
    g =
      typeof u == `function`
        ? u({
            x: p,
            y: h,
          })
        : {
            x: p,
            y: h,
          };
  ((p = g.x), (h = g.y));
  var v = o.hasOwnProperty(`x`),
    y = o.hasOwnProperty(`y`),
    b = Of,
    x = Tf,
    S = window;
  if (l) {
    var C = wf(n),
      w = `clientHeight`,
      T = `clientWidth`;
    if (
      (C === Xd(n) &&
        ((C = df(n)),
        pf(C).position !== `static` &&
          s === `absolute` &&
          ((w = `scrollHeight`), (T = `scrollWidth`))),
      (C = C),
      i === Tf || ((i === Of || i === Df) && a === Mf))
    ) {
      x = Ef;
      var E = d && C === S && S.visualViewport ? S.visualViewport.height : C[w];
      ((h -= E - r.height), (h *= c ? 1 : -1));
    }
    if (i === Of || ((i === Tf || i === Ef) && a === Mf)) {
      b = Df;
      var D = d && C === S && S.visualViewport ? S.visualViewport.width : C[T];
      ((p -= D - r.width), (p *= c ? 1 : -1));
    }
  }
  var ee = Object.assign(
      {
        position: s,
      },
      l && mp,
    ),
    te =
      u === !0
        ? hp(
            {
              x: p,
              y: h,
            },
            Xd(n),
          )
        : {
            x: p,
            y: h,
          };
  if (((p = te.x), (h = te.y), c)) {
    var O;
    return Object.assign(
      {},
      ee,
      ((O = {}),
      (O[x] = y ? `0` : ``),
      (O[b] = v ? `0` : ``),
      (O.transform =
        (S.devicePixelRatio || 1) <= 1
          ? `translate(` + p + `px, ` + h + `px)`
          : `translate3d(` + p + `px, ` + h + `px, 0)`),
      O),
    );
  }
  return Object.assign(
    {},
    ee,
    ((t = {}), (t[x] = y ? h + `px` : ``), (t[b] = v ? p + `px` : ``), (t.transform = ``), t),
  );
}
function _p(e) {
  var t = e.state,
    n = e.options,
    r = n.gpuAcceleration,
    i = r === void 0 ? !0 : r,
    a = n.adaptive,
    o = a === void 0 ? !0 : a,
    s = n.roundOffsets,
    c = s === void 0 ? !0 : s,
    l = {
      placement: Qf(t.placement),
      variation: $f(t.placement),
      popper: t.elements.popper,
      popperRect: t.rects.popper,
      gpuAcceleration: i,
      isFixed: t.options.strategy === `fixed`,
    };
  (t.modifiersData.popperOffsets != null &&
    (t.styles.popper = Object.assign(
      {},
      t.styles.popper,
      gp(
        Object.assign({}, l, {
          offsets: t.modifiersData.popperOffsets,
          position: t.options.strategy,
          adaptive: o,
          roundOffsets: c,
        }),
      ),
    )),
    t.modifiersData.arrow != null &&
      (t.styles.arrow = Object.assign(
        {},
        t.styles.arrow,
        gp(
          Object.assign({}, l, {
            offsets: t.modifiersData.arrow,
            position: `absolute`,
            adaptive: !1,
            roundOffsets: c,
          }),
        ),
      )),
    (t.attributes.popper = Object.assign({}, t.attributes.popper, {
      "data-popper-placement": t.placement,
    })));
}
var vp = {
  name: `computeStyles`,
  enabled: !0,
  phase: `beforeWrite`,
  fn: _p,
  data: {},
};
function yp(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function (e) {
    var n = t.styles[e] || {},
      r = t.attributes[e] || {},
      i = t.elements[e];
    !Qd(i) ||
      !uf(i) ||
      (Object.assign(i.style, n),
      Object.keys(r).forEach(function (e) {
        var t = r[e];
        t === !1 ? i.removeAttribute(e) : i.setAttribute(e, t === !0 ? `` : t);
      }));
  });
}
function bp(e) {
  var t = e.state,
    n = {
      popper: {
        position: t.options.strategy,
        left: `0`,
        top: `0`,
        margin: `0`,
      },
      arrow: {
        position: `absolute`,
      },
      reference: {},
    };
  return (
    Object.assign(t.elements.popper.style, n.popper),
    (t.styles = n),
    t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow),
    function () {
      Object.keys(t.elements).forEach(function (e) {
        var r = t.elements[e],
          i = t.attributes[e] || {},
          a = Object.keys(t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]).reduce(function (e, t) {
            return ((e[t] = ``), e);
          }, {});
        !Qd(r) ||
          !uf(r) ||
          (Object.assign(r.style, a),
          Object.keys(i).forEach(function (e) {
            r.removeAttribute(e);
          }));
      });
    }
  );
}
var xp = cp({
  defaultModifiers: [
    dp,
    pp,
    vp,
    {
      name: `applyStyles`,
      enabled: !0,
      phase: `write`,
      fn: yp,
      effect: bp,
      requires: [`computeStyles`],
    },
  ],
});
function Sp(e) {
  return e === `x` ? `y` : `x`;
}
function Cp(e, t, n) {
  return ef(e, tf(t, n));
}
function wp(e, t, n) {
  var r = Cp(e, t, n);
  return r > n ? n : r;
}
function Tp(e) {
  var t = e.state,
    n = e.options,
    r = e.name,
    i = n.mainAxis,
    a = i === void 0 ? !0 : i,
    o = n.altAxis,
    s = o === void 0 ? !1 : o,
    c = n.boundary,
    l = n.rootBoundary,
    u = n.altBoundary,
    d = n.padding,
    f = n.tether,
    p = f === void 0 ? !0 : f,
    m = n.tetherOffset,
    h = m === void 0 ? 0 : m,
    g = ap(t, {
      boundary: c,
      rootBoundary: l,
      padding: d,
      altBoundary: u,
    }),
    v = Qf(t.placement),
    y = $f(t.placement),
    b = !y,
    x = ep(v),
    S = Sp(x),
    C = t.modifiersData.popperOffsets,
    w = t.rects.reference,
    T = t.rects.popper,
    E =
      typeof h == `function`
        ? h(
            Object.assign({}, t.rects, {
              placement: t.placement,
            }),
          )
        : h,
    D =
      typeof E == `number`
        ? {
            mainAxis: E,
            altAxis: E,
          }
        : Object.assign(
            {
              mainAxis: 0,
              altAxis: 0,
            },
            E,
          ),
    ee = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
    te = {
      x: 0,
      y: 0,
    };
  if (C) {
    if (a) {
      var O = x === `y` ? Tf : Of,
        k = x === `y` ? Ef : Df,
        ne = x === `y` ? `height` : `width`,
        re = C[x],
        A = re + g[O],
        ie = re - g[k],
        j = p ? -T[ne] / 2 : 0,
        ae = y === jf ? w[ne] : T[ne],
        oe = y === jf ? -T[ne] : -w[ne],
        se = t.elements.arrow,
        ce =
          p && se
            ? _f(se)
            : {
                width: 0,
                height: 0,
              },
        le = t.modifiersData[`arrow#persistent`]
          ? t.modifiersData[`arrow#persistent`].padding
          : np(),
        ue = le[O],
        de = le[k],
        fe = Cp(0, w[ne], ce[ne]),
        pe = b ? w[ne] / 2 - j - fe - ue - D.mainAxis : ae - fe - ue - D.mainAxis,
        M = b ? -w[ne] / 2 + j + fe + de + D.mainAxis : oe + fe + de + D.mainAxis,
        me = t.elements.arrow && wf(t.elements.arrow),
        N = me ? (x === `y` ? me.clientTop || 0 : me.clientLeft || 0) : 0,
        P = ee?.[x] ?? 0,
        he = re + pe - P - N,
        ge = re + M - P,
        _e = Cp(p ? tf(A, he) : A, re, p ? ef(ie, ge) : ie);
      ((C[x] = _e), (te[x] = _e - re));
    }
    if (s) {
      var ve = x === `x` ? Tf : Of,
        ye = x === `x` ? Ef : Df,
        F = C[S],
        be = S === `y` ? `height` : `width`,
        I = F + g[ve],
        L = F - g[ye],
        xe = [Tf, Of].indexOf(v) !== -1,
        Se = ee?.[S] ?? 0,
        Ce = xe ? I : F - w[be] - T[be] - Se + D.altAxis,
        we = xe ? F + w[be] + T[be] - Se - D.altAxis : L,
        Te = p && xe ? wp(Ce, F, we) : Cp(p ? Ce : I, F, p ? we : L);
      ((C[S] = Te), (te[S] = Te - F));
    }
    t.modifiersData[r] = te;
  }
}
var Ep = {
    name: `preventOverflow`,
    enabled: !0,
    phase: `main`,
    fn: Tp,
    requiresIfExists: [`offset`],
  },
  Yte = {
    left: `right`,
    right: `left`,
    bottom: `top`,
    top: `bottom`,
  };
function Dp(e) {
  return e.replace(/left|right|bottom|top/g, function (e) {
    return Yte[e];
  });
}
var Xte = {
  start: `end`,
  end: `start`,
};
function Op(e) {
  return e.replace(/start|end/g, function (e) {
    return Xte[e];
  });
}
function Zte(e, t) {
  t === void 0 && (t = {});
  var n = t,
    r = n.placement,
    i = n.boundary,
    a = n.rootBoundary,
    o = n.padding,
    s = n.flipVariations,
    c = n.allowedAutoPlacements,
    l = c === void 0 ? Rf : c,
    u = $f(r),
    d = u
      ? s
        ? Lf
        : Lf.filter(function (e) {
            return $f(e) === u;
          })
      : Af,
    f = d.filter(function (e) {
      return l.indexOf(e) >= 0;
    });
  f.length === 0 && (f = d);
  var p = f.reduce(function (t, n) {
    return (
      (t[n] = ap(e, {
        placement: n,
        boundary: i,
        rootBoundary: a,
        padding: o,
      })[Qf(n)]),
      t
    );
  }, {});
  return Object.keys(p).sort(function (e, t) {
    return p[e] - p[t];
  });
}
function Qte(e) {
  if (Qf(e) === kf) return [];
  var t = Dp(e);
  return [Op(e), t, Op(t)];
}
function $te(e) {
  var t = e.state,
    n = e.options,
    r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (
      var i = n.mainAxis,
        a = i === void 0 ? !0 : i,
        o = n.altAxis,
        s = o === void 0 ? !0 : o,
        c = n.fallbackPlacements,
        l = n.padding,
        u = n.boundary,
        d = n.rootBoundary,
        f = n.altBoundary,
        p = n.flipVariations,
        m = p === void 0 ? !0 : p,
        h = n.allowedAutoPlacements,
        g = t.options.placement,
        v = Qf(g) === g,
        y = c || (v || !m ? [Dp(g)] : Qte(g)),
        b = [g].concat(y).reduce(function (e, n) {
          return e.concat(
            Qf(n) === kf
              ? Zte(t, {
                  placement: n,
                  boundary: u,
                  rootBoundary: d,
                  padding: l,
                  flipVariations: m,
                  allowedAutoPlacements: h,
                })
              : n,
          );
        }, []),
        x = t.rects.reference,
        S = t.rects.popper,
        C = new Map(),
        w = !0,
        T = b[0],
        E = 0;
      E < b.length;
      E++
    ) {
      var D = b[E],
        ee = Qf(D),
        te = $f(D) === jf,
        O = [Tf, Ef].indexOf(ee) >= 0,
        k = O ? `width` : `height`,
        ne = ap(t, {
          placement: D,
          boundary: u,
          rootBoundary: d,
          altBoundary: f,
          padding: l,
        }),
        re = O ? (te ? Df : Of) : te ? Ef : Tf;
      x[k] > S[k] && (re = Dp(re));
      var A = Dp(re),
        ie = [];
      if (
        (a && ie.push(ne[ee] <= 0),
        s && ie.push(ne[re] <= 0, ne[A] <= 0),
        ie.every(function (e) {
          return e;
        }))
      ) {
        ((T = D), (w = !1));
        break;
      }
      C.set(D, ie);
    }
    if (w)
      for (
        var j = m ? 3 : 1,
          ae = function (e) {
            var t = b.find(function (t) {
              var n = C.get(t);
              if (n)
                return n.slice(0, e).every(function (e) {
                  return e;
                });
            });
            if (t) return ((T = t), `break`);
          },
          oe = j;
        oe > 0 && ae(oe) !== `break`;
        oe--
      );
    t.placement !== T && ((t.modifiersData[r]._skip = !0), (t.placement = T), (t.reset = !0));
  }
}
var ene = {
  name: `flip`,
  enabled: !0,
  phase: `main`,
  fn: $te,
  requiresIfExists: [`offset`],
  data: {
    _skip: !1,
  },
};
function tne(e, t, n) {
  let { disabled: r, appendTo: i, appendToBody: a, openDirection: o } = ee(e),
    s = te().proxy,
    c = n.multiselect,
    l = n.dropdown,
    u = F(!1),
    d = F(null),
    f = F(null),
    p = Bd(() => i.value || a.value),
    m = Bd(() =>
      (o.value === `top` && f.value === `bottom`) || (o.value === `bottom` && f.value !== `top`)
        ? `bottom`
        : `top`,
    ),
    h = () => {
      u.value ||
        r.value ||
        ((u.value = !0),
        t.emit(`open`, s),
        p.value &&
          de(() => {
            v();
          }));
    },
    g = () => {
      u.value && ((u.value = !1), t.emit(`close`, s));
    },
    v = () => {
      if (!d.value) return;
      let e = parseInt(window.getComputedStyle(l.value).borderTopWidth.replace(`px`, ``)),
        t = parseInt(window.getComputedStyle(l.value).borderBottomWidth.replace(`px`, ``));
      (d.value.setOptions((n) => ({
        ...n,
        modifiers: [
          ...n.modifiers,
          {
            name: `offset`,
            options: {
              offset: [0, (m.value === `top` ? e : t) * -1],
            },
          },
        ],
      })),
        d.value.update());
    },
    y = (e) => {
      for (; e && e !== document.body;) {
        if (getComputedStyle(e).position === `fixed`) return !0;
        e = e.parentElement;
      }
      return !1;
    };
  return (
    Qe(() => {
      p.value &&
        (d.value = xp(c.value, l.value, {
          strategy: y(c.value) ? `fixed` : void 0,
          placement: o.value,
          modifiers: [
            Ep,
            ene,
            {
              name: `sameWidth`,
              enabled: !0,
              phase: `beforeWrite`,
              requires: [`computeStyles`],
              fn: ({ state: e }) => {
                e.styles.popper.width = `${e.rects.reference.width}px`;
              },
              effect: ({ state: e }) => {
                e.elements.popper.style.width = `${e.elements.reference.offsetWidth}px`;
              },
            },
            {
              name: `toggleClass`,
              enabled: !0,
              phase: `write`,
              fn({ state: e }) {
                f.value = e.placement;
              },
            },
          ],
        }));
    }),
    oe(() => {
      !p.value || !d.value || (d.value.destroy(), (d.value = null));
    }),
    {
      popper: d,
      isOpen: u,
      open: h,
      close: g,
      placement: m,
      updatePopper: v,
    }
  );
}
function nne(e, t, n) {
  let { searchable: r, disabled: i, clearOnBlur: a } = ee(e),
    o = n.input,
    s = n.open,
    c = n.close,
    l = n.clearSearch,
    u = n.isOpen,
    d = n.wrapper,
    f = n.tags,
    p = F(!1),
    m = F(!1),
    h = Bd(() => (r.value || i.value ? -1 : 0)),
    g = () => {
      (r.value && o.value.blur(), d.value.blur());
    },
    v = () => {
      r.value && !i.value && o.value.focus();
    },
    y = (e = !0) => {
      i.value || ((p.value = !0), e && s());
    },
    b = () => {
      ((p.value = !1),
        setTimeout(() => {
          p.value || (c(), a.value && l());
        }, 1));
    };
  return {
    tabindex: h,
    isActive: p,
    mouseClicked: m,
    blur: g,
    focus: v,
    activate: y,
    deactivate: b,
    handleFocusIn: (e) => {
      (e.target.closest(`[data-tags]`) && e.target.nodeName !== `INPUT`) ||
        e.target.closest(`[data-clear]`) ||
        y(m.value);
    },
    handleFocusOut: () => {
      b();
    },
    handleCaretClick: () => {
      (b(), g());
    },
    handleMousedown: (e) => {
      ((m.value = !0),
        u.value && (e.target.isEqualNode(d.value) || e.target.isEqualNode(f.value))
          ? setTimeout(() => {
              b();
            }, 0)
          : !u.value &&
            (document.activeElement.isEqualNode(d.value) ||
              document.activeElement.isEqualNode(o.value)) &&
            y(),
        setTimeout(() => {
          m.value = !1;
        }, 0));
    },
  };
}
function rne(e, t, n) {
  let {
      mode: r,
      addTagOn: i,
      openDirection: a,
      searchable: o,
      showOptions: s,
      valueProp: c,
      groups: l,
      addOptionOn: u,
      createTag: d,
      createOption: f,
      reverse: p,
    } = ee(e),
    m = te().proxy,
    h = n.iv,
    g = n.update,
    v = n.deselect,
    y = n.search,
    b = n.setPointer,
    x = n.selectPointer,
    S = n.backwardPointer,
    C = n.forwardPointer,
    w = n.multiselect,
    T = n.wrapper,
    E = n.tags,
    D = n.isOpen,
    O = n.open,
    k = n.blur,
    ne = n.fo,
    re = Bd(() => d.value || f.value || !1),
    A = Bd(() => (i.value === void 0 ? (u.value === void 0 ? [`enter`] : u.value) : i.value)),
    ie = () => {
      r.value === `tags` &&
        !s.value &&
        re.value &&
        o.value &&
        !l.value &&
        b(ne.value[ne.value.map((e) => e[c.value]).indexOf(y.value)]);
    };
  return {
    handleKeydown: (e) => {
      t.emit(`keydown`, e, m);
      let n, i;
      switch (
        ([`ArrowLeft`, `ArrowRight`, `Enter`].indexOf(e.key) !== -1 &&
          r.value === `tags` &&
          ((n = [...w.value.querySelectorAll(`[data-tags] > *`)].filter((e) => e !== E.value)),
          (i = n.findIndex((e) => e === document.activeElement))),
        e.key)
      ) {
        case `Backspace`:
          if (
            r.value === `single` ||
            (o.value && [null, ``].indexOf(y.value) === -1) ||
            h.value.length === 0
          )
            return;
          let t = h.value.filter((e) => !e.disabled && e.remove !== !1);
          t.length && v(t[t.length - 1]);
          break;
        case `Enter`:
          if ((e.preventDefault(), e.keyCode === 229)) return;
          if (i !== -1 && i !== void 0) {
            (g([...h.value].filter((e, t) => t !== i)),
              i === n.length - 1 &&
                (n.length - 1
                  ? n[n.length - 2].focus()
                  : o.value
                    ? E.value.querySelector(`input`).focus()
                    : T.value.focus()));
            return;
          }
          if (A.value.indexOf(`enter`) === -1 && re.value) return;
          (ie(), x());
          break;
        case ` `:
          if (!re.value && !o.value) {
            (e.preventDefault(), ie(), x());
            return;
          }
          if (!re.value) return !1;
          if (A.value.indexOf(`space`) === -1 && re.value) return;
          (e.preventDefault(), ie(), x());
          break;
        case `Tab`:
        case `;`:
        case `,`:
          if (A.value.indexOf(e.key.toLowerCase()) === -1 || !re.value) return;
          (ie(), x(), e.preventDefault());
          break;
        case `Escape`:
          k();
          break;
        case `ArrowUp`:
          if ((e.preventDefault(), !s.value)) return;
          (D.value || O(), S());
          break;
        case `ArrowDown`:
          if ((e.preventDefault(), !s.value)) return;
          (D.value || O(), C());
          break;
        case `ArrowLeft`:
          if (
            (o.value && E.value && E.value.querySelector(`input`).selectionStart) ||
            e.shiftKey ||
            r.value !== `tags` ||
            !h.value ||
            !h.value.length
          )
            return;
          (e.preventDefault(), i === -1 ? n[n.length - 1].focus() : i > 0 && n[i - 1].focus());
          break;
        case `ArrowRight`:
          if (i === -1 || e.shiftKey || r.value !== `tags` || !h.value || !h.value.length) return;
          (e.preventDefault(),
            n.length > i + 1
              ? n[i + 1].focus()
              : o.value
                ? E.value.querySelector(`input`).focus()
                : o.value || T.value.focus());
          break;
      }
    },
    handleKeyup: (e) => {
      t.emit(`keyup`, e, m);
    },
    preparePointer: ie,
  };
}
function ine(e, t, n) {
  let { classes: r, disabled: i, showOptions: a, breakTags: o } = ee(e),
    s = n.isOpen,
    c = n.isPointed,
    l = n.isSelected,
    u = n.isDisabled,
    d = n.isActive,
    f = n.canPointGroups,
    p = n.resolving,
    m = n.fo,
    h = n.placement,
    g = Bd(() => ({
      container: `multiselect`,
      containerDisabled: `is-disabled`,
      containerOpen: `is-open`,
      containerOpenTop: `is-open-top`,
      containerActive: `is-active`,
      wrapper: `multiselect-wrapper`,
      singleLabel: `multiselect-single-label`,
      singleLabelText: `multiselect-single-label-text`,
      multipleLabel: `multiselect-multiple-label`,
      search: `multiselect-search`,
      tags: `multiselect-tags`,
      tag: `multiselect-tag`,
      tagWrapper: `multiselect-tag-wrapper`,
      tagWrapperBreak: `multiselect-tag-wrapper-break`,
      tagDisabled: `is-disabled`,
      tagRemove: `multiselect-tag-remove`,
      tagRemoveIcon: `multiselect-tag-remove-icon`,
      tagsSearchWrapper: `multiselect-tags-search-wrapper`,
      tagsSearch: `multiselect-tags-search`,
      tagsSearchCopy: `multiselect-tags-search-copy`,
      placeholder: `multiselect-placeholder`,
      caret: `multiselect-caret`,
      caretOpen: `is-open`,
      clear: `multiselect-clear`,
      clearIcon: `multiselect-clear-icon`,
      spinner: `multiselect-spinner`,
      inifinite: `multiselect-inifite`,
      inifiniteSpinner: `multiselect-inifite-spinner`,
      dropdown: `multiselect-dropdown`,
      dropdownTop: `is-top`,
      dropdownHidden: `is-hidden`,
      options: `multiselect-options`,
      optionsTop: `is-top`,
      group: `multiselect-group`,
      groupLabel: `multiselect-group-label`,
      groupLabelPointable: `is-pointable`,
      groupLabelPointed: `is-pointed`,
      groupLabelSelected: `is-selected`,
      groupLabelDisabled: `is-disabled`,
      groupLabelSelectedPointed: `is-selected is-pointed`,
      groupLabelSelectedDisabled: `is-selected is-disabled`,
      groupOptions: `multiselect-group-options`,
      option: `multiselect-option`,
      optionPointed: `is-pointed`,
      optionSelected: `is-selected`,
      optionDisabled: `is-disabled`,
      optionSelectedPointed: `is-selected is-pointed`,
      optionSelectedDisabled: `is-selected is-disabled`,
      noOptions: `multiselect-no-options`,
      noResults: `multiselect-no-results`,
      fakeInput: `multiselect-fake-input`,
      assist: `multiselect-assistive-text`,
      spacer: `multiselect-spacer`,
      ...r.value,
    })),
    v = Bd(() => !!(s.value && a.value && (!p.value || (p.value && m.value.length))));
  return {
    classList: V(() => {
      let e = g.value;
      return {
        container: [e.container].concat(
          i.value ? e.containerDisabled : [],
          v.value && h.value === `top` ? e.containerOpenTop : [],
          v.value && h.value !== `top` ? e.containerOpen : [],
          d.value ? e.containerActive : [],
        ),
        wrapper: e.wrapper,
        spacer: e.spacer,
        singleLabel: e.singleLabel,
        singleLabelText: e.singleLabelText,
        multipleLabel: e.multipleLabel,
        search: e.search,
        tags: e.tags,
        tag: [e.tag].concat(i.value ? e.tagDisabled : []),
        tagWrapper: [e.tagWrapper, o.value ? e.tagWrapperBreak : null],
        tagDisabled: e.tagDisabled,
        tagRemove: e.tagRemove,
        tagRemoveIcon: e.tagRemoveIcon,
        tagsSearchWrapper: e.tagsSearchWrapper,
        tagsSearch: e.tagsSearch,
        tagsSearchCopy: e.tagsSearchCopy,
        placeholder: e.placeholder,
        caret: [e.caret].concat(s.value ? e.caretOpen : []),
        clear: e.clear,
        clearIcon: e.clearIcon,
        spinner: e.spinner,
        inifinite: e.inifinite,
        inifiniteSpinner: e.inifiniteSpinner,
        dropdown: [e.dropdown].concat(
          h.value === `top` ? e.dropdownTop : [],
          !s.value || !a.value || !v.value ? e.dropdownHidden : [],
        ),
        options: [e.options].concat(h.value === `top` ? e.optionsTop : []),
        group: e.group,
        groupLabel: (t) => {
          let n = [e.groupLabel];
          return (
            c(t)
              ? n.push(l(t) ? e.groupLabelSelectedPointed : e.groupLabelPointed)
              : l(t) && f.value
                ? n.push(u(t) ? e.groupLabelSelectedDisabled : e.groupLabelSelected)
                : u(t) && n.push(e.groupLabelDisabled),
            f.value && n.push(e.groupLabelPointable),
            n
          );
        },
        groupOptions: e.groupOptions,
        option: (t, n) => {
          let r = [e.option];
          return (
            c(t)
              ? r.push(l(t) ? e.optionSelectedPointed : e.optionPointed)
              : l(t)
                ? r.push(u(t) ? e.optionSelectedDisabled : e.optionSelected)
                : (u(t) || (n && u(n))) && r.push(e.optionDisabled),
            r
          );
        },
        noOptions: e.noOptions,
        noResults: e.noResults,
        assist: e.assist,
        fakeInput: e.fakeInput,
      };
    }),
    showDropdown: v,
  };
}
function ane(e, t, n) {
  let { limit: r, infinite: i } = ee(e),
    a = n.isOpen,
    o = n.offset,
    s = n.search,
    c = n.pfo,
    l = n.eo,
    u = F(null),
    d = xe(null),
    f = Bd(() => o.value < c.value.length),
    p = (e) => {
      let { isIntersecting: t, target: n } = e[0];
      if (t) {
        let e = n.offsetParent,
          t = e.scrollTop;
        ((o.value += r.value == -1 ? 10 : r.value),
          de(() => {
            e.scrollTop = t;
          }));
      }
    },
    m = () => {
      a.value && o.value < c.value.length
        ? u.value.observe(d.value)
        : !a.value && u.value && u.value.disconnect();
    };
  return (
    He(a, () => {
      i.value && m();
    }),
    He(
      s,
      () => {
        i.value && ((o.value = r.value), m());
      },
      {
        flush: `post`,
      },
    ),
    He(
      l,
      () => {
        i.value && m();
      },
      {
        immediate: !1,
        flush: `post`,
      },
    ),
    Qe(() => {
      window && window.IntersectionObserver && (u.value = new IntersectionObserver(p));
    }),
    {
      hasMore: f,
      infiniteLoader: d,
    }
  );
}
function one(e, t, n) {
  let {
      placeholder: r,
      id: i,
      valueProp: a,
      label: o,
      mode: s,
      groupLabel: c,
      aria: l,
      searchable: u,
    } = ee(e),
    d = n.pointer,
    f = n.iv,
    p = n.hasSelected,
    m = n.multipleLabelText,
    h = F(null),
    g = Bd(() => `${i.value ? i.value + `-` : ``}assist`),
    v = Bd(() => `${i.value ? i.value + `-` : ``}multiselect-options`),
    y = Bd(() => {
      if (d.value) {
        let e = i.value ? `${i.value}-` : ``;
        return (
          (e += `${d.value.group ? `multiselect-group` : `multiselect-option`}-`),
          (e += d.value.group ? d.value.index : d.value[a.value]),
          e
        );
      }
    }),
    b = Bd(() => r.value),
    x = Bd(() => s.value !== `single`),
    S = V(() =>
      s.value === `single` && p.value
        ? f.value[o.value]
        : s.value === `multiple` && p.value
          ? m.value
          : s.value === `tags` && p.value
            ? f.value.map((e) => e[o.value]).join(`, `)
            : ``,
    ),
    C = V(() => {
      let e = {
        ...l.value,
      };
      return (
        u.value &&
          ((e[`aria-labelledby`] = e[`aria-labelledby`]
            ? `${g.value} ${e[`aria-labelledby`]}`
            : g.value),
          S.value && e[`aria-label`] && (e[`aria-label`] = `${S.value}, ${e[`aria-label`]}`)),
        e
      );
    });
  return (
    Qe(() => {
      if (i.value && document && document.querySelector) {
        let e = document.querySelector(`[for="${i.value}"]`);
        h.value = e ? e.innerText : null;
      }
    }),
    {
      arias: C,
      ariaLabel: S,
      ariaAssist: g,
      ariaControls: v,
      ariaPlaceholder: b,
      ariaMultiselectable: x,
      ariaActiveDescendant: y,
      ariaOptionId: (e) => `${i.value ? i.value + `-` : ``}multiselect-option-${e[a.value]}`,
      ariaOptionLabel: (e) => `${e}`,
      ariaGroupId: (e) => `${i.value ? i.value + `-` : ``}multiselect-group-${e.index}`,
      ariaGroupLabel: (e) => `${e}`,
      ariaTagLabel: (e) => `${e} ❎`,
    }
  );
}
function sne(e, t, n) {
  let { locale: r, fallbackLocale: i } = ee(e);
  return {
    localize: (e) =>
      !e || typeof e != `object`
        ? e
        : e && e[r.value]
          ? e[r.value]
          : e && r.value && e[r.value.toUpperCase()]
            ? e[r.value.toUpperCase()]
            : e && e[i.value]
              ? e[i.value]
              : e && i.value && e[i.value.toUpperCase()]
                ? e[i.value.toUpperCase()]
                : e && Object.keys(e)[0]
                  ? e[Object.keys(e)[0]]
                  : ``,
  };
}
function cne(e, t, n) {
  return {
    multiselect: xe(null),
    wrapper: xe(null),
    tags: xe(null),
    input: xe(null),
    dropdown: xe(null),
  };
}
function lne(e, t, n, r = {}) {
  return (
    n.forEach((n) => {
      r = {
        ...r,
        ...n(e, t, r),
      };
    }),
    r
  );
}
var kp = {
    name: `Multiselect`,
    emits: [
      `paste`,
      `open`,
      `close`,
      `select`,
      `deselect`,
      `input`,
      `search-change`,
      `tag`,
      `option`,
      `update:modelValue`,
      `change`,
      `clear`,
      `keydown`,
      `keyup`,
      `max`,
      `create`,
    ],
    props: {
      value: {
        required: !1,
      },
      modelValue: {
        required: !1,
      },
      options: {
        type: [Array, Object, Function],
        required: !1,
        default: () => [],
      },
      id: {
        type: [String, Number],
        required: !1,
        default: void 0,
      },
      name: {
        type: [String, Number],
        required: !1,
        default: `multiselect`,
      },
      disabled: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      label: {
        type: String,
        required: !1,
        default: `label`,
      },
      trackBy: {
        type: [String, Array],
        required: !1,
        default: void 0,
      },
      valueProp: {
        type: String,
        required: !1,
        default: `value`,
      },
      placeholder: {
        type: String,
        required: !1,
        default: null,
      },
      mode: {
        type: String,
        required: !1,
        default: `single`,
      },
      searchable: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      limit: {
        type: Number,
        required: !1,
        default: -1,
      },
      hideSelected: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      createTag: {
        type: Boolean,
        required: !1,
        default: void 0,
      },
      createOption: {
        type: Boolean,
        required: !1,
        default: void 0,
      },
      appendNewTag: {
        type: Boolean,
        required: !1,
        default: void 0,
      },
      appendNewOption: {
        type: Boolean,
        required: !1,
        default: void 0,
      },
      addTagOn: {
        type: Array,
        required: !1,
        default: void 0,
      },
      addOptionOn: {
        type: Array,
        required: !1,
        default: void 0,
      },
      caret: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      loading: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      noOptionsText: {
        type: [String, Object],
        required: !1,
        default: `The list is empty`,
      },
      noResultsText: {
        type: [String, Object],
        required: !1,
        default: `No results found`,
      },
      multipleLabel: {
        type: Function,
        required: !1,
        default: void 0,
      },
      object: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      delay: {
        type: Number,
        required: !1,
        default: -1,
      },
      minChars: {
        type: Number,
        required: !1,
        default: 0,
      },
      resolveOnLoad: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      filterResults: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      clearOnSearch: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      clearOnSelect: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      canDeselect: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      canClear: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      max: {
        type: Number,
        required: !1,
        default: -1,
      },
      showOptions: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      required: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      openDirection: {
        type: String,
        required: !1,
        default: `bottom`,
      },
      nativeSupport: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      classes: {
        type: Object,
        required: !1,
        default: () => ({}),
      },
      strict: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      closeOnSelect: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      closeOnDeselect: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      autocomplete: {
        type: String,
        required: !1,
        default: void 0,
      },
      groups: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      groupLabel: {
        type: String,
        required: !1,
        default: `label`,
      },
      groupOptions: {
        type: String,
        required: !1,
        default: `options`,
      },
      groupHideEmpty: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      groupSelect: {
        type: Boolean,
        required: !1,
        default: !0,
      },
      inputType: {
        type: String,
        required: !1,
        default: `text`,
      },
      attrs: {
        required: !1,
        type: Object,
        default: () => ({}),
      },
      onCreate: {
        required: !1,
        type: Function,
        default: void 0,
      },
      disabledProp: {
        type: String,
        required: !1,
        default: `disabled`,
      },
      searchStart: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      reverse: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      regex: {
        type: [Object, String, RegExp],
        required: !1,
        default: void 0,
      },
      rtl: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      infinite: {
        type: Boolean,
        required: !1,
        default: !1,
      },
      aria: {
        required: !1,
        type: Object,
        default: () => ({}),
      },
      clearOnBlur: {
        required: !1,
        type: Boolean,
        default: !0,
      },
      locale: {
        required: !1,
        type: String,
        default: null,
      },
      fallbackLocale: {
        required: !1,
        type: String,
        default: `en`,
      },
      searchFilter: {
        required: !1,
        type: Function,
        default: null,
      },
      allowAbsent: {
        required: !1,
        type: Boolean,
        default: !1,
      },
      appendToBody: {
        required: !1,
        type: Boolean,
        default: !1,
      },
      closeOnScroll: {
        required: !1,
        type: Boolean,
        default: !1,
      },
      breakTags: {
        required: !1,
        type: Boolean,
        default: !1,
      },
      appendTo: {
        required: !1,
        type: String,
        default: void 0,
      },
    },
    setup(e, t) {
      return lne(e, t, [cne, sne, Vd, Ud, tne, Hd, zd, nne, Jd, ane, Yd, rne, ine, one]);
    },
    beforeMount() {
      ((this.$root.constructor &&
        this.$root.constructor.version &&
        this.$root.constructor.version.match(/^2\./)) ||
        this.vueVersionMs === 2) &&
        (this.$options.components.Teleport ||
          (this.$options.components.Teleport = {
            render() {
              return this.$slots.default ? this.$slots.default[0] : null;
            },
          }));
    },
  },
  une = [`id`, `dir`],
  dne = [
    `tabindex`,
    `aria-controls`,
    `aria-placeholder`,
    `aria-expanded`,
    `aria-activedescendant`,
    `aria-multiselectable`,
    `role`,
  ],
  fne = [
    `type`,
    `modelValue`,
    `value`,
    `autocomplete`,
    `id`,
    `aria-controls`,
    `aria-placeholder`,
    `aria-expanded`,
    `aria-activedescendant`,
    `aria-multiselectable`,
  ],
  pne = [`onKeyup`, `aria-label`],
  mne = [`onClick`],
  hne = [
    `type`,
    `modelValue`,
    `value`,
    `id`,
    `autocomplete`,
    `aria-controls`,
    `aria-placeholder`,
    `aria-expanded`,
    `aria-activedescendant`,
    `aria-multiselectable`,
  ],
  gne = [`innerHTML`],
  _ne = [`id`],
  vne = [`id`],
  yne = [`id`, `aria-label`, `aria-selected`],
  bne = [`data-pointed`, `onMouseenter`, `onClick`],
  xne = [`innerHTML`],
  Sne = [`aria-label`],
  Cne = [
    `data-pointed`,
    `data-selected`,
    `onMouseenter`,
    `onClick`,
    `id`,
    `aria-selected`,
    `aria-label`,
  ],
  wne = [
    `data-pointed`,
    `data-selected`,
    `onMouseenter`,
    `onClick`,
    `id`,
    `aria-selected`,
    `aria-label`,
  ],
  Tne = [`innerHTML`],
  Ene = [`innerHTML`],
  Dne = [`value`],
  One = [`name`, `value`],
  kne = [`name`, `value`],
  Ane = [`id`];
function jne(e, t, n, r, i, a) {
  return (
    A(),
    M(
      `div`,
      {
        ref: `multiselect`,
        class: O(e.classList.container),
        id: n.searchable ? void 0 : n.id,
        dir: n.rtl ? `rtl` : void 0,
        onFocusin: (t[12] ||= (...t) => e.handleFocusIn && e.handleFocusIn(...t)),
        onFocusout: (t[13] ||= (...t) => e.handleFocusOut && e.handleFocusOut(...t)),
        onKeyup: (t[14] ||= (...t) => e.handleKeyup && e.handleKeyup(...t)),
        onKeydown: (t[15] ||= (...t) => e.handleKeydown && e.handleKeydown(...t)),
      },
      [
        W(
          `div`,
          ce(
            {
              class: e.classList.wrapper,
              onMousedown: (t[9] ||= (...t) => e.handleMousedown && e.handleMousedown(...t)),
              ref: `wrapper`,
              tabindex: e.tabindex,
              "aria-controls": n.searchable ? void 0 : e.ariaControls,
              "aria-placeholder": n.searchable ? void 0 : e.ariaPlaceholder,
              "aria-expanded": n.searchable ? void 0 : e.isOpen,
              "aria-activedescendant": n.searchable ? void 0 : e.ariaActiveDescendant,
              "aria-multiselectable": n.searchable ? void 0 : e.ariaMultiselectable,
              role: n.searchable ? void 0 : `combobox`,
            },
            n.searchable ? {} : e.arias,
          ),
          [
            U(` Search `),
            n.mode !== `tags` && n.searchable && !n.disabled
              ? (A(),
                M(
                  `input`,
                  ce(
                    {
                      key: 0,
                      type: n.inputType,
                      modelValue: e.search,
                      value: e.search,
                      class: e.classList.search,
                      autocomplete: n.autocomplete,
                      id: n.searchable ? n.id : void 0,
                      onInput: (t[0] ||= (...t) =>
                        e.handleSearchInput && e.handleSearchInput(...t)),
                      onKeypress: (t[1] ||= (...t) => e.handleKeypress && e.handleKeypress(...t)),
                      onPaste: (t[2] ||= Fe(
                        (...t) => e.handlePaste && e.handlePaste(...t),
                        [`stop`],
                      )),
                      ref: `input`,
                      "aria-controls": e.ariaControls,
                      "aria-placeholder": e.ariaPlaceholder,
                      "aria-expanded": e.isOpen,
                      "aria-activedescendant": e.ariaActiveDescendant,
                      "aria-multiselectable": e.ariaMultiselectable,
                      role: `combobox`,
                    },
                    {
                      ...n.attrs,
                      ...e.arias,
                    },
                  ),
                  null,
                  16,
                  fne,
                ))
              : U(`v-if`, !0),
            U(` Tags (with search) `),
            n.mode == `tags`
              ? (A(),
                M(
                  `div`,
                  {
                    key: 1,
                    class: O(e.classList.tags),
                    "data-tags": ``,
                  },
                  [
                    (A(!0),
                    M(
                      ke,
                      null,
                      ae(e.iv, (t, r, i) =>
                        z(
                          e.$slots,
                          `tag`,
                          {
                            option: t,
                            handleTagRemove: e.handleTagRemove,
                            disabled: n.disabled,
                          },
                          () => [
                            (A(),
                            M(
                              `span`,
                              {
                                class: O([
                                  e.classList.tag,
                                  t.disabled ? e.classList.tagDisabled : null,
                                ]),
                                tabindex: `-1`,
                                onKeyup: ze((n) => e.handleTagRemove(t, n), [`enter`]),
                                key: i,
                                "aria-label": e.ariaTagLabel(e.localize(t[n.label])),
                              },
                              [
                                W(
                                  `span`,
                                  {
                                    class: O(e.classList.tagWrapper),
                                  },
                                  T(e.localize(t[n.label])),
                                  3,
                                ),
                                !n.disabled && !t.disabled
                                  ? (A(),
                                    M(
                                      `span`,
                                      {
                                        key: 0,
                                        class: O(e.classList.tagRemove),
                                        onClick: Fe((n) => e.handleTagRemove(t, n), [`stop`]),
                                      },
                                      [
                                        W(
                                          `span`,
                                          {
                                            class: O(e.classList.tagRemoveIcon),
                                          },
                                          null,
                                          2,
                                        ),
                                      ],
                                      10,
                                      mne,
                                    ))
                                  : U(`v-if`, !0),
                              ],
                              42,
                              pne,
                            )),
                          ],
                        ),
                      ),
                      256,
                    )),
                    W(
                      `div`,
                      {
                        class: O(e.classList.tagsSearchWrapper),
                        ref: `tags`,
                      },
                      [
                        U(` Used for measuring search width `),
                        W(
                          `span`,
                          {
                            class: O(e.classList.tagsSearchCopy),
                          },
                          T(e.search),
                          3,
                        ),
                        U(` Actual search input `),
                        n.searchable && !n.disabled
                          ? (A(),
                            M(
                              `input`,
                              ce(
                                {
                                  key: 0,
                                  type: n.inputType,
                                  modelValue: e.search,
                                  value: e.search,
                                  class: e.classList.tagsSearch,
                                  id: n.searchable ? n.id : void 0,
                                  autocomplete: n.autocomplete,
                                  onInput: (t[3] ||= (...t) =>
                                    e.handleSearchInput && e.handleSearchInput(...t)),
                                  onKeypress: (t[4] ||= (...t) =>
                                    e.handleKeypress && e.handleKeypress(...t)),
                                  onPaste: (t[5] ||= Fe(
                                    (...t) => e.handlePaste && e.handlePaste(...t),
                                    [`stop`],
                                  )),
                                  ref: `input`,
                                  "aria-controls": e.ariaControls,
                                  "aria-placeholder": e.ariaPlaceholder,
                                  "aria-expanded": e.isOpen,
                                  "aria-activedescendant": e.ariaActiveDescendant,
                                  "aria-multiselectable": e.ariaMultiselectable,
                                  role: `combobox`,
                                },
                                {
                                  ...n.attrs,
                                  ...e.arias,
                                },
                              ),
                              null,
                              16,
                              hne,
                            ))
                          : U(`v-if`, !0),
                      ],
                      2,
                    ),
                  ],
                  2,
                ))
              : U(`v-if`, !0),
            U(` Single label `),
            n.mode == `single` && e.hasSelected && !e.search && e.iv
              ? z(
                  e.$slots,
                  `singlelabel`,
                  {
                    key: 2,
                    value: e.iv,
                  },
                  () => [
                    W(
                      `div`,
                      {
                        class: O(e.classList.singleLabel),
                      },
                      [
                        W(
                          `span`,
                          {
                            class: O(e.classList.singleLabelText),
                          },
                          T(e.localize(e.iv[n.label])),
                          3,
                        ),
                      ],
                      2,
                    ),
                  ],
                )
              : U(`v-if`, !0),
            U(` Multiple label `),
            n.mode == `multiple` && e.hasSelected && !e.search
              ? z(
                  e.$slots,
                  `multiplelabel`,
                  {
                    key: 3,
                    values: e.iv,
                  },
                  () => [
                    W(
                      `div`,
                      {
                        class: O(e.classList.multipleLabel),
                        innerHTML: e.multipleLabelText,
                      },
                      null,
                      10,
                      gne,
                    ),
                  ],
                )
              : U(`v-if`, !0),
            U(` Placeholder `),
            n.placeholder && !e.hasSelected && !e.search
              ? z(
                  e.$slots,
                  `placeholder`,
                  {
                    key: 4,
                  },
                  () => [
                    W(
                      `div`,
                      {
                        class: O(e.classList.placeholder),
                        "aria-hidden": `true`,
                      },
                      T(n.placeholder),
                      3,
                    ),
                  ],
                )
              : U(`v-if`, !0),
            U(` Spinner `),
            n.loading || e.resolving
              ? z(
                  e.$slots,
                  `spinner`,
                  {
                    key: 5,
                  },
                  () => [
                    W(
                      `span`,
                      {
                        class: O(e.classList.spinner),
                        "aria-hidden": `true`,
                      },
                      null,
                      2,
                    ),
                  ],
                )
              : U(`v-if`, !0),
            U(` Clear `),
            e.hasSelected && !n.disabled && n.canClear && !e.busy
              ? z(
                  e.$slots,
                  `clear`,
                  {
                    key: 6,
                    clear: e.clear,
                  },
                  () => [
                    W(
                      `span`,
                      {
                        "aria-hidden": `true`,
                        tabindex: `0`,
                        role: `button`,
                        "data-clear": ``,
                        "aria-roledescription": `❎`,
                        class: O(e.classList.clear),
                        onClick: (t[6] ||= (...t) => e.clear && e.clear(...t)),
                        onKeyup: (t[7] ||= ze((...t) => e.clear && e.clear(...t), [`enter`])),
                      },
                      [
                        W(
                          `span`,
                          {
                            class: O(e.classList.clearIcon),
                          },
                          null,
                          2,
                        ),
                      ],
                      34,
                    ),
                  ],
                )
              : U(`v-if`, !0),
            U(` Caret `),
            n.caret && n.showOptions
              ? z(
                  e.$slots,
                  `caret`,
                  {
                    key: 7,
                    handleCaretClick: e.handleCaretClick,
                    isOpen: e.isOpen,
                  },
                  () => [
                    W(
                      `span`,
                      {
                        class: O(e.classList.caret),
                        onClick: (t[8] ||= (...t) =>
                          e.handleCaretClick && e.handleCaretClick(...t)),
                        "aria-hidden": `true`,
                      },
                      null,
                      2,
                    ),
                  ],
                )
              : U(`v-if`, !0),
          ],
          16,
          dne,
        ),
        U(` Options `),
        (A(),
        L(
          De,
          {
            to: n.appendTo || `body`,
            disabled: !n.appendToBody && !n.appendTo,
          },
          [
            W(
              `div`,
              {
                id: n.id ? `${n.id}-dropdown` : void 0,
                class: O(e.classList.dropdown),
                tabindex: `-1`,
                ref: `dropdown`,
                onFocusin: (t[10] ||= (...t) => e.handleFocusIn && e.handleFocusIn(...t)),
                onFocusout: (t[11] ||= (...t) => e.handleFocusOut && e.handleFocusOut(...t)),
              },
              [
                z(e.$slots, `beforelist`, {
                  options: e.fo,
                }),
                W(
                  `ul`,
                  {
                    class: O(e.classList.options),
                    id: e.ariaControls,
                    role: `listbox`,
                  },
                  [
                    n.groups
                      ? (A(!0),
                        M(
                          ke,
                          {
                            key: 0,
                          },
                          ae(
                            e.fg,
                            (t, r, i) => (
                              A(),
                              M(
                                `li`,
                                {
                                  class: O(e.classList.group),
                                  key: i,
                                  id: e.ariaGroupId(t),
                                  "aria-label": e.ariaGroupLabel(e.localize(t[n.groupLabel])),
                                  "aria-selected": e.isSelected(t),
                                  role: `option`,
                                },
                                [
                                  t.__CREATE__
                                    ? U(`v-if`, !0)
                                    : (A(),
                                      M(
                                        `div`,
                                        {
                                          key: 0,
                                          class: O(e.classList.groupLabel(t)),
                                          "data-pointed": e.isPointed(t),
                                          onMouseenter: (n) => e.setPointer(t, r),
                                          onClick: (n) => e.handleGroupClick(t),
                                        },
                                        [
                                          z(
                                            e.$slots,
                                            `grouplabel`,
                                            {
                                              group: t,
                                              isSelected: e.isSelected,
                                              isPointed: e.isPointed,
                                            },
                                            () => [
                                              W(
                                                `span`,
                                                {
                                                  innerHTML: e.localize(t[n.groupLabel]),
                                                },
                                                null,
                                                8,
                                                xne,
                                              ),
                                            ],
                                          ),
                                        ],
                                        42,
                                        bne,
                                      )),
                                  W(
                                    `ul`,
                                    {
                                      class: O(e.classList.groupOptions),
                                      "aria-label": e.ariaGroupLabel(e.localize(t[n.groupLabel])),
                                      role: `group`,
                                    },
                                    [
                                      (A(!0),
                                      M(
                                        ke,
                                        null,
                                        ae(
                                          t.__VISIBLE__,
                                          (r, i, a) => (
                                            A(),
                                            M(
                                              `li`,
                                              {
                                                class: O(e.classList.option(r, t)),
                                                "data-pointed": e.isPointed(r),
                                                "data-selected": e.isSelected(r) || void 0,
                                                key: a,
                                                onMouseenter: (t) => e.setPointer(r),
                                                onClick: (t) => e.handleOptionClick(r),
                                                id: e.ariaOptionId(r),
                                                "aria-selected": e.isSelected(r),
                                                "aria-label": e.ariaOptionLabel(
                                                  e.localize(r[n.label]),
                                                ),
                                                role: `option`,
                                              },
                                              [
                                                z(
                                                  e.$slots,
                                                  `option`,
                                                  {
                                                    option: r,
                                                    isSelected: e.isSelected,
                                                    isPointed: e.isPointed,
                                                    search: e.search,
                                                  },
                                                  () => [
                                                    W(`span`, null, T(e.localize(r[n.label])), 1),
                                                  ],
                                                ),
                                              ],
                                              42,
                                              Cne,
                                            )
                                          ),
                                        ),
                                        128,
                                      )),
                                    ],
                                    10,
                                    Sne,
                                  ),
                                ],
                                10,
                                yne,
                              )
                            ),
                          ),
                          128,
                        ))
                      : (A(!0),
                        M(
                          ke,
                          {
                            key: 1,
                          },
                          ae(
                            e.fo,
                            (t, r, i) => (
                              A(),
                              M(
                                `li`,
                                {
                                  class: O(e.classList.option(t)),
                                  "data-pointed": e.isPointed(t),
                                  "data-selected": e.isSelected(t) || void 0,
                                  key: i,
                                  onMouseenter: (n) => e.setPointer(t),
                                  onClick: (n) => e.handleOptionClick(t),
                                  id: e.ariaOptionId(t),
                                  "aria-selected": e.isSelected(t),
                                  "aria-label": e.ariaOptionLabel(e.localize(t[n.label])),
                                  role: `option`,
                                },
                                [
                                  z(
                                    e.$slots,
                                    `option`,
                                    {
                                      option: t,
                                      isSelected: e.isSelected,
                                      isPointed: e.isPointed,
                                      search: e.search,
                                    },
                                    () => [W(`span`, null, T(e.localize(t[n.label])), 1)],
                                  ),
                                ],
                                42,
                                wne,
                              )
                            ),
                          ),
                          128,
                        )),
                  ],
                  10,
                  vne,
                ),
                e.noOptions
                  ? z(
                      e.$slots,
                      `nooptions`,
                      {
                        key: 0,
                      },
                      () => [
                        W(
                          `div`,
                          {
                            class: O(e.classList.noOptions),
                            innerHTML: e.localize(n.noOptionsText),
                          },
                          null,
                          10,
                          Tne,
                        ),
                      ],
                    )
                  : U(`v-if`, !0),
                e.noResults
                  ? z(
                      e.$slots,
                      `noresults`,
                      {
                        key: 1,
                      },
                      () => [
                        W(
                          `div`,
                          {
                            class: O(e.classList.noResults),
                            innerHTML: e.localize(n.noResultsText),
                          },
                          null,
                          10,
                          Ene,
                        ),
                      ],
                    )
                  : U(`v-if`, !0),
                n.infinite && e.hasMore
                  ? (A(),
                    M(
                      `div`,
                      {
                        key: 2,
                        class: O(e.classList.inifinite),
                        ref: `infiniteLoader`,
                      },
                      [
                        z(e.$slots, `infinite`, {}, () => [
                          W(
                            `span`,
                            {
                              class: O(e.classList.inifiniteSpinner),
                            },
                            null,
                            2,
                          ),
                        ]),
                      ],
                      2,
                    ))
                  : U(`v-if`, !0),
                z(e.$slots, `afterlist`, {
                  options: e.fo,
                }),
              ],
              42,
              _ne,
            ),
          ],
          8,
          [`to`, `disabled`],
        )),
        U(` Hacky input element to show HTML5 required warning `),
        n.required
          ? (A(),
            M(
              `input`,
              {
                key: 0,
                class: O(e.classList.fakeInput),
                tabindex: `-1`,
                value: e.textValue,
                required: ``,
              },
              null,
              10,
              Dne,
            ))
          : U(`v-if`, !0),
        U(` Native input support `),
        n.nativeSupport
          ? (A(),
            M(
              ke,
              {
                key: 1,
              },
              [
                n.mode == `single`
                  ? (A(),
                    M(
                      `input`,
                      {
                        key: 0,
                        type: `hidden`,
                        name: n.name,
                        value: e.plainValue === void 0 ? `` : e.plainValue,
                      },
                      null,
                      8,
                      One,
                    ))
                  : (A(!0),
                    M(
                      ke,
                      {
                        key: 1,
                      },
                      ae(
                        e.plainValue,
                        (e, t) => (
                          A(),
                          M(
                            `input`,
                            {
                              type: `hidden`,
                              name: `${n.name}[]`,
                              value: e,
                              key: t,
                            },
                            null,
                            8,
                            kne,
                          )
                        ),
                      ),
                      128,
                    )),
              ],
              64,
            ))
          : U(`v-if`, !0),
        U(` Screen reader assistive text `),
        n.searchable && e.hasSelected
          ? (A(),
            M(
              `div`,
              {
                key: 2,
                class: O(e.classList.assist),
                id: e.ariaAssist,
                "aria-hidden": `true`,
              },
              T(e.ariaLabel),
              11,
              Ane,
            ))
          : U(`v-if`, !0),
        U(` Create height for empty input `),
        W(
          `div`,
          {
            class: O(e.classList.spacer),
          },
          null,
          2,
        ),
      ],
      42,
      une,
    )
  );
}
((kp.render = jne), (kp.__file = `src/Multiselect.vue`));
var Mne = i({
  default: () => Ine,
});
B();
var Nne = {
    class: `flex justify-between`,
  },
  Pne = {
    key: 0,
    class: `ml-2`,
  },
  Fne = {
    key: 0,
    class: `pointer-events-none absolute ltr:left-0 rtl:right-0 top-0 flex h-full items-center bg-transparent ltr:pl-3.5 rtl:pr-3.5 leading-snug`,
  },
  Ine = Object.assign(
    {
      name: `BaseSelect`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        placeholder: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [String, Object, Number, Boolean, Array],
          default: ``,
        },
        options: {
          type: [Array, Function],
          default: [],
        },
        error: {
          type: String,
          default: ``,
        },
        searchable: {
          type: Boolean,
          default: !0,
        },
        labelProp: {
          type: String,
          default: `label`,
        },
        valueProp: {
          type: String,
          default: `value`,
        },
        objectProp: {
          type: Boolean,
          default: !1,
        },
        multiple: {
          type: Boolean,
          default: !1,
        },
        tags: {
          type: Boolean,
          default: !1,
        },
        minWidth: {
          type: Boolean,
          default: !1,
        },
        invisible: {
          type: Boolean,
          default: !1,
        },
        isRequired: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:error`, `selected`, `removed`, `cleared`],
      setup(e, { emit: t }) {
        let n = t,
          r = e;
        Te();
        let i = Ae({
            uniqueId: ``,
            input: r.modelValue,
          }),
          a = (e) => {
            (n(`update:modelValue`, e), n(`update:error`, ``));
          },
          o = (e, t) => {
            n(`selected`, t);
          },
          s = (e, t) => {
            n(`removed`, t);
          },
          c = (e, t) => {
            n(`cleared`, t);
          },
          l = V(() => (r.multiple ? `multiple` : r.tags ? `tags` : `single`));
        return (
          He(
            () => r.modelValue,
            (e) => {
              i.input = e;
            },
          ),
          Qe(() => {
            i.uniqueId = r.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`IsRequired`),
              u = j(`BaseLabel`),
              d = j(`FormError`),
              f = ve(`tooltip`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  W(`div`, Nne, [
                    e.label
                      ? (A(),
                        L(
                          u,
                          {
                            key: 0,
                            for: i.uniqueId,
                          },
                          {
                            default: I(() => [
                              W(`span`, null, [
                                H(T(e.label) + ` `, 1),
                                N(
                                  r,
                                  {
                                    "is-required": e.isRequired,
                                  },
                                  null,
                                  8,
                                  [`is-required`],
                                ),
                              ]),
                              e.labelHint
                                ? Re(
                                    (A(),
                                    M(`span`, Pne, [
                                      ...(n[1] ||= [
                                        W(
                                          `i`,
                                          {
                                            class: `fas fa-question-circle`,
                                          },
                                          null,
                                          -1,
                                        ),
                                      ]),
                                    ])),
                                    [[f, e.labelHint]],
                                  )
                                : U(``, !0),
                            ]),
                            _: 1,
                          },
                          8,
                          [`for`],
                        ))
                      : U(``, !0),
                    z(t.$slots, `additional-label`),
                  ]),
                  W(
                    `div`,
                    {
                      class: O([
                        `relative rounded-md shadow-xs`,
                        {
                          "mt-1": e.label,
                        },
                      ]),
                    },
                    [
                      N(
                        P(kp),
                        ce(
                          {
                            mode: l.value,
                            id: i.uniqueId,
                          },
                          t.$attrs,
                          {
                            closeOnSelect: l.value == `single`,
                            "create-option": l.value == `tags`,
                            placeholder: e.placeholder || e.label,
                            modelValue: i.input,
                            "onUpdate:modelValue": (n[0] ||= (e) => (i.input = e)),
                            label: e.labelProp,
                            valueProp: e.valueProp,
                            searchable: e.searchable,
                            hideSelected: !1,
                            options: e.options,
                            object: e.objectProp,
                            onChange: a,
                            onSelect: o,
                            onDeselect: s,
                            onClear: c,
                            noOptionsText: Array.isArray(e.options)
                              ? t.$trans(`general.select_no_option`)
                              : t.$trans(`general.select_no_option_text`),
                            noResultsText: t.$trans(`general.select_no_result_text`),
                            classes: {
                              container:
                                `relative mx-auto w-full flex items-center justify-end box-border cursor-pointer border-0 border-gray-300 dark:border-gray-700 dark:text-gray-200 bg-transparent text-sm leading-snug outline-none focus:ring-0 ` +
                                (e.invisible ? `` : ` border-b-2 `) +
                                (e.minWidth ? ` w-48 min-w-full` : ` w-full `),
                              containerDisabled: `cursor-default bg-transparent dark:bg-gray-800`,
                              containerOpen: `rounded-b-none`,
                              containerOpenTop: `rounded-t-none`,
                              containerActive: `outline-none focus:ring-0`,
                              wrapper: `relative mx-auto w-full flex items-center justify-end box-border cursor-pointer outline-none`,
                              singleLabel: `flex items-center h-full max-w-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 pr-16 box-border rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5 text-sm`,
                              singleLabelText: `text-ellipsis overflow-hidden block whitespace-nowrap max-w-full text-sm`,
                              multipleLabel: `flex items-center h-full max-w-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5 text-sm`,
                              search: `w-full absolute inset-0 outline-none appearance-none box-border border-0 text-sm font-sans bg-transparent rounded pl-3.5 focus:ring-0 rtl:pl-0 rtl:pr-3.5`,
                              tags: `flex-grow flex-shrink flex flex-wrap items-center mt-1 pl-2 min-w-0 rtl:pl-0 rtl:pr-2`,
                              tag: `bg-green-500 text-white text-sm font-semibold py-0.5 pl-2 rounded mr-1 mb-1 flex items-center whitespace-nowrap min-w-0 rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1`,
                              tagDisabled: `pr-2 !bg-gray-400 text-white opacity-50 rtl:pl-2`,
                              tagWrapper: `whitespace-nowrap overflow-hidden text-ellipsis`,
                              tagWrapperBreak: `whitespace-normal break-all`,
                              tagRemove: `flex items-center justify-center p-1 mx-0.5 rounded-sm hover:bg-black hover:bg-black/10 group`,
                              tagRemoveIcon: `bg-multiselect-remove bg-center bg-no-repeat opacity-30 inline-block w-3 h-3 group-hover:opacity-60`,
                              tagsSearchWrapper: `inline-block relative mx-1 mb-1 flex-grow flex-shrink h-full`,
                              tagsSearch: `absolute inset-0 border-0 outline-none focus:ring-0 appearance-none p-0 text-sm bg-transparent font-sans box-border w-full`,
                              tagsSearchCopy: `invisible whitespace-pre-wrap inline-block h-px`,
                              placeholder: `flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 text-gray-500 rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5`,
                              caret: `bg-multiselect-caret bg-center bg-no-repeat w-2.5 h-4 py-px box-content mr-3.5 relative z-10 opacity-40 shrink-0 grow-0 transition-transform transform pointer-events-none rtl:mr-0 rtl:ml-3.5`,
                              caretOpen: `rotate-180 pointer-events-auto`,
                              clear: `pr-3.5 relative z-10 opacity-40 transition duration-300 shrink-0 grow-0 flex hover:opacity-80 rtl:pr-0 rtl:pl-3.5`,
                              clearIcon: `bg-multiselect-remove bg-center bg-no-repeat w-2.5 h-4 py-px box-content inline-block`,
                              spinner: `bg-multiselect-spinner bg-center bg-no-repeat w-4 h-4 z-10 mr-3.5 animate-spin shrink-0 grow-0 rtl:mr-0 rtl:ml-3.5`,
                              infinite: `flex items-center justify-center w-full`,
                              infiniteSpinner: `bg-multiselect-spinner bg-center bg-no-repeat w-4 h-4 z-10 animate-spin shrink-0 grow-0 m-3.5`,
                              dropdown: `max-h-60 absolute -left-px -right-px bottom-0 transform translate-y-full border border-gray-300 dark:border-gray-700 -mt-px overflow-y-scroll z-50 bg-white dark:bg-dark-header flex flex-col rounded-b`,
                              dropdownTop: `-translate-y-full top-px bottom-auto rounded-b-none rounded-t`,
                              dropdownHidden: `hidden`,
                              options: `flex flex-col p-0 m-0 list-none dark:text-gray-400`,
                              optionsTop: ``,
                              group: `p-0 m-0`,
                              groupLabel: `flex text-sm box-border items-center justify-start text-left py-1 px-3 font-semibold bg-gray-200 dark:bg-gray-700 cursor-default leading-normal`,
                              groupLabelPointable: `cursor-pointer`,
                              groupLabelPointed: `bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-400`,
                              groupLabelSelected: `bg-green-500 text-white`,
                              groupLabelDisabled: `bg-gray-100 dark:bg-gray-800 text-gray-300 dark:text-gray-500 cursor-not-allowed`,
                              groupLabelSelectedPointed: `bg-green-600 text-white opacity-90`,
                              groupLabelSelectedDisabled: `text-green-100 bg-green-600 bg-black/50 cursor-not-allowed`,
                              groupOptions: `p-0 m-0`,
                              option: `flex items-center justify-start box-border text-left cursor-pointer text-sm dark:text-gray-400 leading-snug py-2 px-3`,
                              optionPointed: `text-gray-800 dark:text-gray-400 bg-gray-100 dark:bg-dark-body`,
                              optionSelected: `text-white dark:text-gray-400 bg-primary dark:bg-black`,
                              optionDisabled: `text-gray-300 dark:text-gray-400 cursor-not-allowed`,
                              optionSelectedPointed: `text-white dark:text-gray-400 bg-dark-primary dark:bg-black opacity-90`,
                              optionSelectedDisabled: `text-green-100 bg-green-500 bg-black/50 cursor-not-allowed`,
                              noOptions: `py-2 px-3 text-gray-600 dark:text-gray-400 bg-white dark:bg-dark-body text-left rtl:text-right`,
                              noResults: `py-2 px-3 text-gray-600 dark:text-gray-400 bg-white dark:bg-dark-body text-left rtl:text-right`,
                              fakeInput: `bg-transparent absolute left-0 right-0 -bottom-px w-full h-px border-0 p-0 appearance-none outline-none text-transparent focus:ring-0`,
                              assist: `absolute -m-px w-px h-px overflow-hidden`,
                              spacer: `h-9 py-px box-content`,
                            },
                          },
                        ),
                        {
                          singlelabel: I(({ value: e }) => [
                            t.$slots.selectedOption
                              ? (A(),
                                M(`div`, Fne, [
                                  z(t.$slots, `selectedOption`, {
                                    value: e,
                                  }),
                                ]))
                              : U(``, !0),
                          ]),
                          option: I(({ option: e }) => [
                            z(t.$slots, `listOption`, {
                              option: e,
                            }),
                          ]),
                          _: 3,
                        },
                        16,
                        [
                          `mode`,
                          `id`,
                          `closeOnSelect`,
                          `create-option`,
                          `placeholder`,
                          `modelValue`,
                          `label`,
                          `valueProp`,
                          `searchable`,
                          `options`,
                          `object`,
                          `noOptionsText`,
                          `noResultsText`,
                          `classes`,
                        ],
                      ),
                    ],
                    2,
                  ),
                  N(
                    d,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  Lne = i({
    default: () => Rne,
  });
B();
var Rne = Object.assign(
  {
    name: `BaseSelectSearch`,
  },
  {
    props: {
      modelValue: {
        type: [String, Number, Array, Object],
        default: ``,
      },
      multiple: {
        type: Boolean,
        default: !1,
      },
      tags: {
        type: Boolean,
        default: !1,
      },
      error: {
        type: String,
        default: ``,
      },
      labelProp: {
        type: String,
        default: `name`,
      },
      valueProp: {
        type: String,
        default: `uuid`,
      },
      searchAction: {
        type: String,
        required: !0,
      },
      searchKey: {
        type: String,
        default: `name`,
      },
      additionalSearchQuery: {
        type: Object,
        default() {
          return {};
        },
      },
      initSearch: {
        type: [String, Number, Array],
        default: ``,
      },
      initSearchKey: {
        type: String,
        default: `uuid`,
      },
    },
    emits: [`update:modelValue`, `update:error`, `selected`, `removed`, `cleared`],
    setup(e, { emit: t }) {
      let n = $e();
      Te();
      let r = t,
        i = e,
        a = Ae({
          initSearchLoaded: !1,
          input: i.modelValue,
          error: i.error,
        }),
        o = (e) => {
          (r(`update:modelValue`, e), r(`update:error`, ``));
        },
        s = () => (Array.isArray(i.initSearch) ? i.initSearch.length > 0 : !!i.initSearch),
        c = async (e) => {
          let t = {},
            r;
          for (let [e, n] of Object.entries(i.additionalSearchQuery))
            (e == `uuid` && (r = n), (t[e] = n));
          if (!_.isEmpty(i.initSearch) && !a.initSearchLoaded) {
            if (((t[i.initSearchKey] = i.initSearch), !t[i.initSearchKey])) return [];
          } else if (((t[i.searchKey] = e), !t[i.searchKey])) return [];
          let o = {
            params: t,
          };
          return (
            r && (o.uuid = r),
            await n
              .dispatch(i.searchAction, o)
              .then(
                (e) => (
                  (a.initSearchLoaded = !0),
                  Array.isArray(e.data) &&
                    e.data.forEach((e) => {
                      e.group && ((e.optgroup = e.group), delete e.group);
                    }),
                  e.data
                ),
              )
              .catch((e) => {})
          );
        },
        l = (e) => {
          r(`selected`, e);
        },
        u = (e) => {
          r(`removed`, e);
        },
        d = (e) => {
          r(`cleared`, e);
        };
      return (
        He(
          () => [i.modelValue, i.error],
          (e) => {
            ((a.input = e[0]), (a.error = e[1]));
          },
        ),
        (t, n) => {
          let r = j(`BaseSelect`);
          return (
            A(),
            L(
              r,
              ce(
                {
                  multiple: e.multiple,
                  tags: e.tags,
                },
                t.$attrs,
                {
                  modelValue: a.input,
                  "onUpdate:modelValue": (n[0] ||= (e) => (a.input = e)),
                  filterResults: !1,
                  minChars: 1,
                  resolveOnLoad: s(),
                  delay: 500,
                  "label-prop": i.labelProp,
                  "value-prop": i.valueProp,
                  options: async function (e) {
                    return await c(e);
                  },
                  onChange: o,
                  onSelected: l,
                  onRemoved: u,
                  onCleared: d,
                  error: a.error,
                  "onUpdate:error": (n[1] ||= (e) => (a.error = e)),
                },
              ),
              {
                selectedOption: I(({ value: e }) => [
                  z(
                    t.$slots,
                    `selectedOption`,
                    {
                      value: e,
                    },
                    () => [H(T(e.name), 1)],
                  ),
                ]),
                listOption: I(({ option: e }) => [
                  z(t.$slots, `listOption`, {
                    option: e,
                  }),
                ]),
                "additional-label": I(() => [z(t.$slots, `additional-label`)]),
                _: 3,
              },
              16,
              [
                `multiple`,
                `tags`,
                `modelValue`,
                `resolveOnLoad`,
                `label-prop`,
                `value-prop`,
                `options`,
                `error`,
              ],
            )
          );
        }
      );
    },
  },
);
function Ap(e) {
  for (
    var t = ``,
      n = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789`,
      r = n.length,
      i = 0;
    i < e;
    i++
  )
    t += n.charAt(Math.floor(Math.random() * r));
  return t;
}
function zne(e) {
  for (var t = ``, n = 0; n < e; n++) t += Math.floor(Math.random() * 10);
  return t;
}
function Bne(e) {
  var t = `abcdefghijklmnopqrstuvwxyz`,
    n = `ABCDEFGHIJKLMNOPQRSTUVWXYZ`,
    r = `0123456789`,
    i = "!@#$%^&*()_+~`|}{[]:;?><,./-=",
    a = ``;
  ((a += t[Math.floor(Math.random() * t.length)]),
    (a += n[Math.floor(Math.random() * n.length)]),
    (a += r[Math.floor(Math.random() * r.length)]),
    (a += i[Math.floor(Math.random() * i.length)]));
  for (var o = e - 4, s = t + n + r + i, c = 0; c < o; c++)
    a += s[Math.floor(Math.random() * s.length)];
  return (
    (a = a
      .split(``)
      .sort(function () {
        return 0.5 - Math.random();
      })
      .join(``)),
    a
  );
}
function jp(e) {
  return typeof e == `number`
    ? !!e
    : typeof e == `string`
      ? e
        ? e.toLowerCase() !== `false`
        : !1
      : e;
}
function Vne(e, t, n) {
  var r = n ? `<br />` : `<br>`,
    i = t ? `$1` + r : `$1` + r + `$2`;
  return (e + ``).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, i);
}
B();
function Hne(e, t, n) {
  let r = F(n?.value),
    i = V(() => e.value !== void 0);
  return [
    V(() => (i.value ? e.value : r.value)),
    function (e) {
      return (i.value || (r.value = e), t?.(e));
    },
  ];
}
function Mp(e) {
  typeof queueMicrotask == `function`
    ? queueMicrotask(e)
    : Promise.resolve()
        .then(e)
        .catch((e) =>
          setTimeout(() => {
            throw e;
          }),
        );
}
function Np() {
  let e = [],
    t = {
      addEventListener(e, n, r, i) {
        return (e.addEventListener(n, r, i), t.add(() => e.removeEventListener(n, r, i)));
      },
      requestAnimationFrame(...e) {
        let n = requestAnimationFrame(...e);
        t.add(() => cancelAnimationFrame(n));
      },
      nextFrame(...e) {
        t.requestAnimationFrame(() => {
          t.requestAnimationFrame(...e);
        });
      },
      setTimeout(...e) {
        let n = setTimeout(...e);
        t.add(() => clearTimeout(n));
      },
      microTask(...e) {
        let n = {
          current: !0,
        };
        return (
          Mp(() => {
            n.current && e[0]();
          }),
          t.add(() => {
            n.current = !1;
          })
        );
      },
      style(e, t, n) {
        let r = e.style.getPropertyValue(t);
        return (
          Object.assign(e.style, {
            [t]: n,
          }),
          this.add(() => {
            Object.assign(e.style, {
              [t]: r,
            });
          })
        );
      },
      group(e) {
        let t = Np();
        return (e(t), this.add(() => t.dispose()));
      },
      add(t) {
        return (
          e.push(t),
          () => {
            let n = e.indexOf(t);
            if (n >= 0) for (let t of e.splice(n, 1)) t();
          }
        );
      },
      dispose() {
        for (let t of e.splice(0)) t();
      },
    };
  return t;
}
B();
var Une = Symbol(`headlessui.useid`),
  Wne = 0,
  Pp =
    w ??
    function () {
      return R(Une, () => `${++Wne}`)();
    };
function Fp(e) {
  if (e == null || e.value == null) return null;
  let t = e.value.$el ?? e.value;
  return t instanceof Node ? t : null;
}
function Ip(e, t, ...n) {
  if (e in t) {
    let r = t[e];
    return typeof r == `function` ? r(...n) : r;
  }
  let r = Error(
    `Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(
      t,
    )
      .map((e) => `"${e}"`)
      .join(`, `)}.`,
  );
  throw (Error.captureStackTrace && Error.captureStackTrace(r, Ip), r);
}
var Gne = Object.defineProperty,
  Kne = (e, t, n) =>
    t in e
      ? Gne(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: n,
        })
      : (e[t] = n),
  Lp = (e, t, n) => (Kne(e, typeof t == `symbol` ? t : t + ``, n), n),
  Rp = new (class {
    constructor() {
      (Lp(this, `current`, this.detect()), Lp(this, `currentId`, 0));
    }
    set(e) {
      this.current !== e && ((this.currentId = 0), (this.current = e));
    }
    reset() {
      this.set(this.detect());
    }
    nextId() {
      return ++this.currentId;
    }
    get isServer() {
      return this.current === `server`;
    }
    get isClient() {
      return this.current === `client`;
    }
    detect() {
      return typeof window > `u` || typeof document > `u` ? `server` : `client`;
    }
  })();
function zp(e) {
  if (Rp.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty(`value`)) {
    let t = Fp(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
B();
var Bp = [
    `[contentEditable=true]`,
    `[tabindex]`,
    `a[href]`,
    `area[href]`,
    `button:not([disabled])`,
    `iframe`,
    `input:not([disabled])`,
    `select:not([disabled])`,
    `textarea:not([disabled])`,
  ]
    .map((e) => `${e}:not([tabindex='-1'])`)
    .join(`,`),
  Vp = ((e) => (
    (e[(e.First = 1)] = `First`),
    (e[(e.Previous = 2)] = `Previous`),
    (e[(e.Next = 4)] = `Next`),
    (e[(e.Last = 8)] = `Last`),
    (e[(e.WrapAround = 16)] = `WrapAround`),
    (e[(e.NoScroll = 32)] = `NoScroll`),
    e
  ))(Vp || {}),
  Hp = ((e) => (
    (e[(e.Error = 0)] = `Error`),
    (e[(e.Overflow = 1)] = `Overflow`),
    (e[(e.Success = 2)] = `Success`),
    (e[(e.Underflow = 3)] = `Underflow`),
    e
  ))(Hp || {}),
  qne = ((e) => ((e[(e.Previous = -1)] = `Previous`), (e[(e.Next = 1)] = `Next`), e))(qne || {});
function Up(e = document.body) {
  return e == null
    ? []
    : Array.from(e.querySelectorAll(Bp)).sort((e, t) =>
        Math.sign((e.tabIndex || 2 ** 53 - 1) - (t.tabIndex || 2 ** 53 - 1)),
      );
}
var Wp = ((e) => ((e[(e.Strict = 0)] = `Strict`), (e[(e.Loose = 1)] = `Loose`), e))(Wp || {});
function Gp(e, t = 0) {
  return e === zp(e)?.body
    ? !1
    : Ip(t, {
        0() {
          return e.matches(Bp);
        },
        1() {
          let t = e;
          for (; t !== null;) {
            if (t.matches(Bp)) return !0;
            t = t.parentElement;
          }
          return !1;
        },
      });
}
function Kp(e) {
  let t = zp(e);
  de(() => {
    t && !Gp(t.activeElement, 0) && qp(e);
  });
}
var Jne = ((e) => ((e[(e.Keyboard = 0)] = `Keyboard`), (e[(e.Mouse = 1)] = `Mouse`), e))(Jne || {});
typeof window < `u` &&
  typeof document < `u` &&
  (document.addEventListener(
    `keydown`,
    (e) => {
      e.metaKey ||
        e.altKey ||
        e.ctrlKey ||
        (document.documentElement.dataset.headlessuiFocusVisible = ``);
    },
    !0,
  ),
  document.addEventListener(
    `click`,
    (e) => {
      e.detail === 1
        ? delete document.documentElement.dataset.headlessuiFocusVisible
        : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = ``);
    },
    !0,
  ));
function qp(e) {
  e?.focus({
    preventScroll: !0,
  });
}
var Yne = [`textarea`, `input`].join(`,`);
function Xne(e) {
  return e?.matches?.call(e, Yne) ?? !1;
}
function Jp(e, t = (e) => e) {
  return e.slice().sort((e, n) => {
    let r = t(e),
      i = t(n);
    if (r === null || i === null) return 0;
    let a = r.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Zne(e, t) {
  return Yp(Up(), t, {
    relativeTo: e,
  });
}
function Yp(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: i = [] } = {}) {
  let a =
      (Array.isArray(e) ? (e.length > 0 ? e[0].ownerDocument : document) : e?.ownerDocument) ??
      document,
    o = Array.isArray(e) ? (n ? Jp(e) : e) : Up(e);
  (i.length > 0 && o.length > 1 && (o = o.filter((e) => !i.includes(e))), (r ??= a.activeElement));
  let s = (() => {
      if (t & 5) return 1;
      if (t & 10) return -1;
      throw Error(`Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last`);
    })(),
    c = (() => {
      if (t & 1) return 0;
      if (t & 2) return Math.max(0, o.indexOf(r)) - 1;
      if (t & 4) return Math.max(0, o.indexOf(r)) + 1;
      if (t & 8) return o.length - 1;
      throw Error(`Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last`);
    })(),
    l =
      t & 32
        ? {
            preventScroll: !0,
          }
        : {},
    u = 0,
    d = o.length,
    f;
  do {
    if (u >= d || u + d <= 0) return 0;
    let e = c + u;
    if (t & 16) e = (e + d) % d;
    else {
      if (e < 0) return 3;
      if (e >= d) return 1;
    }
    ((f = o[e]), f?.focus(l), (u += s));
  } while (f !== a.activeElement);
  return (t & 6 && Xne(f) && f.select(), 2);
}
function Xp() {
  return (
    /iPhone/gi.test(window.navigator.platform) ||
    (/Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0)
  );
}
function Qne() {
  return /Android/gi.test(window.navigator.userAgent);
}
function $ne() {
  return Xp() || Qne();
}
B();
function Zp(e, t, n) {
  Rp.isServer ||
    Me((r) => {
      (document.addEventListener(e, t, n), r(() => document.removeEventListener(e, t, n)));
    });
}
B();
function Qp(e, t, n) {
  Rp.isServer ||
    Me((r) => {
      (window.addEventListener(e, t, n), r(() => window.removeEventListener(e, t, n)));
    });
}
B();
function $p(e, t, n = V(() => !0)) {
  function r(r, i) {
    if (!n.value || r.defaultPrevented) return;
    let a = i(r);
    if (a === null || !a.getRootNode().contains(a)) return;
    let o = (function e(t) {
      return typeof t == `function` ? e(t()) : Array.isArray(t) || t instanceof Set ? t : [t];
    })(e);
    for (let e of o) {
      if (e === null) continue;
      let t = e instanceof HTMLElement ? e : Fp(e);
      if ((t != null && t.contains(a)) || (r.composed && r.composedPath().includes(t))) return;
    }
    return (!Gp(a, Wp.Loose) && a.tabIndex !== -1 && r.preventDefault(), t(r, a));
  }
  let i = F(null);
  (Zp(
    `pointerdown`,
    (e) => {
      n.value && (i.value = e.composedPath?.call(e)?.[0] || e.target);
    },
    !0,
  ),
    Zp(
      `mousedown`,
      (e) => {
        n.value && (i.value = e.composedPath?.call(e)?.[0] || e.target);
      },
      !0,
    ),
    Zp(
      `click`,
      (e) => {
        $ne() || (i.value &&= (r(e, () => i.value), null));
      },
      !0,
    ),
    Zp(`touchend`, (e) => r(e, () => (e.target instanceof HTMLElement ? e.target : null)), !0),
    Qp(
      `blur`,
      (e) =>
        r(e, () =>
          window.document.activeElement instanceof HTMLIFrameElement
            ? window.document.activeElement
            : null,
        ),
      !0,
    ));
}
B();
function em(e, t) {
  if (e) return e;
  let n = t ?? `button`;
  if (typeof n == `string` && n.toLowerCase() === `button`) return `button`;
}
function tm(e, t) {
  let n = F(em(e.value.type, e.value.as));
  return (
    Qe(() => {
      n.value = em(e.value.type, e.value.as);
    }),
    Me(() => {
      var e;
      n.value ||
        (Fp(t) &&
          Fp(t) instanceof HTMLButtonElement &&
          !((e = Fp(t)) != null && e.hasAttribute(`type`)) &&
          (n.value = `button`));
    }),
    n
  );
}
B();
function nm(e) {
  return [e.screenX, e.screenY];
}
function ere() {
  let e = F([-1, -1]);
  return {
    wasMoved(t) {
      let n = nm(t);
      return e.value[0] === n[0] && e.value[1] === n[1] ? !1 : ((e.value = n), !0);
    },
    update(t) {
      e.value = nm(t);
    },
  };
}
B();
function tre({ container: e, accept: t, walk: n, enabled: r }) {
  Me(() => {
    let i = e.value;
    if (!i || (r !== void 0 && !r.value)) return;
    let a = zp(e);
    if (!a) return;
    let o = Object.assign((e) => t(e), {
        acceptNode: t,
      }),
      s = a.createTreeWalker(i, NodeFilter.SHOW_ELEMENT, o, !1);
    for (; s.nextNode();) n(s.currentNode);
  });
}
B();
var rm = ((e) => (
    (e[(e.None = 0)] = `None`),
    (e[(e.RenderStrategy = 1)] = `RenderStrategy`),
    (e[(e.Static = 2)] = `Static`),
    e
  ))(rm || {}),
  im = ((e) => ((e[(e.Unmount = 0)] = `Unmount`), (e[(e.Hidden = 1)] = `Hidden`), e))(im || {});
function am({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...i }) {
  var a;
  let o = cm(r, n),
    s = Object.assign(i, {
      props: o,
    });
  return e || (t & 2 && o.static)
    ? om(s)
    : t & 1
      ? Ip((a = o.unmount) == null || a ? 0 : 1, {
          0() {
            return null;
          },
          1() {
            return om({
              ...i,
              props: {
                ...o,
                hidden: !0,
                style: {
                  display: `none`,
                },
              },
            });
          },
        })
      : om(s);
}
function om({ props: e, attrs: t, slots: n, slot: r, name: i }) {
  let { as: a, ...o } = lm(e, [`unmount`, `static`]),
    s = n.default?.call(n, r),
    c = {};
  if (r) {
    let e = !1,
      t = [];
    for (let [n, i] of Object.entries(r))
      (typeof i == `boolean` && (e = !0), i === !0 && t.push(n));
    e && (c[`data-headlessui-state`] = t.join(` `));
  }
  if (a === `template`) {
    if (((s = sm(s ?? [])), Object.keys(o).length > 0 || Object.keys(t).length > 0)) {
      let [e, ...n] = s ?? [];
      if (!rre(e) || n.length > 0)
        throw Error(
          [
            `Passing props on "template"!`,
            ``,
            `The current component <${i} /> is rendering a "template".`,
            `However we need to passthrough the following props:`,
            Object.keys(o)
              .concat(Object.keys(t))
              .map((e) => e.trim())
              .filter((e, t, n) => n.indexOf(e) === t)
              .sort((e, t) => e.localeCompare(t))
              .map((e) => `  - ${e}`).join(`
`),
            ``,
            `You can apply a few solutions:`,
            [
              'Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".',
              `Render a single element as the child so that we can forward the props onto that element.`,
            ].map((e) => `  - ${e}`).join(`
`),
          ].join(`
`),
        );
      let r = cm(e.props ?? {}, o, c),
        a = ye(e, r, !0);
      for (let e in r) e.startsWith(`on`) && ((a.props ||= {}), (a.props[e] = r[e]));
      return a;
    }
    return Array.isArray(s) && s.length === 1 ? s[0] : s;
  }
  return Ne(a, Object.assign({}, o, c), {
    default: () => s,
  });
}
function sm(e) {
  return e.flatMap((e) => (e.type === ke ? sm(e.children) : [e]));
}
function cm(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {},
    n = {};
  for (let r of e)
    for (let e in r)
      e.startsWith(`on`) && typeof r[e] == `function`
        ? (n[e] ?? (n[e] = []), n[e].push(r[e]))
        : (t[e] = r[e]);
  if (t.disabled || t[`aria-disabled`])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((e) => [e, void 0])));
  for (let e in n)
    Object.assign(t, {
      [e](t, ...r) {
        let i = n[e];
        for (let e of i) {
          if (t instanceof Event && t.defaultPrevented) return;
          e(t, ...r);
        }
      },
    });
  return t;
}
function nre(e) {
  let t = Object.assign({}, e);
  for (let e in t) t[e] === void 0 && delete t[e];
  return t;
}
function lm(e, t = []) {
  let n = Object.assign({}, e);
  for (let e of t) e in n && delete n[e];
  return n;
}
function rre(e) {
  return e == null
    ? !1
    : typeof e.type == `string` || typeof e.type == `object` || typeof e.type == `function`;
}
B();
var um = ((e) => (
    (e[(e.None = 1)] = `None`),
    (e[(e.Focusable = 2)] = `Focusable`),
    (e[(e.Hidden = 4)] = `Hidden`),
    e
  ))(um || {}),
  dm = k({
    name: `Hidden`,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
      features: {
        type: Number,
        default: 1,
      },
    },
    setup(e, { slots: t, attrs: n }) {
      return () => {
        let { features: r, ...i } = e;
        return am({
          ourProps: {
            "aria-hidden": (r & 2) == 2 ? !0 : (i[`aria-hidden`] ?? void 0),
            hidden: (r & 4) == 4 ? !0 : void 0,
            style: {
              position: `fixed`,
              top: 1,
              left: 1,
              width: 1,
              height: 0,
              padding: 0,
              margin: -1,
              overflow: `hidden`,
              clip: `rect(0, 0, 0, 0)`,
              whiteSpace: `nowrap`,
              borderWidth: `0`,
              ...((r & 4) == 4 &&
                (r & 2) != 2 && {
                  display: `none`,
                }),
            },
          },
          theirProps: i,
          slot: {},
          attrs: n,
          slots: t,
          name: `Hidden`,
        });
      };
    },
  });
B();
var fm = Symbol(`Context`),
  pm = ((e) => (
    (e[(e.Open = 1)] = `Open`),
    (e[(e.Closed = 2)] = `Closed`),
    (e[(e.Closing = 4)] = `Closing`),
    (e[(e.Opening = 8)] = `Opening`),
    e
  ))(pm || {});
function ire() {
  return mm() !== null;
}
function mm() {
  return R(fm, null);
}
function hm(e) {
  ge(fm, e);
}
var gm = ((e) => (
  (e.Space = ` `),
  (e.Enter = `Enter`),
  (e.Escape = `Escape`),
  (e.Backspace = `Backspace`),
  (e.Delete = `Delete`),
  (e.ArrowLeft = `ArrowLeft`),
  (e.ArrowUp = `ArrowUp`),
  (e.ArrowRight = `ArrowRight`),
  (e.ArrowDown = `ArrowDown`),
  (e.Home = `Home`),
  (e.End = `End`),
  (e.PageUp = `PageUp`),
  (e.PageDown = `PageDown`),
  (e.Tab = `Tab`),
  e
))(gm || {});
function are(e) {
  function t() {
    document.readyState !== `loading` && (e(), document.removeEventListener(`DOMContentLoaded`, t));
  }
  typeof window < `u` &&
    typeof document < `u` &&
    (document.addEventListener(`DOMContentLoaded`, t), t());
}
var _m = [];
are(() => {
  function e(e) {
    e.target instanceof HTMLElement &&
      e.target !== document.body &&
      _m[0] !== e.target &&
      (_m.unshift(e.target), (_m = _m.filter((e) => e != null && e.isConnected)), _m.splice(10));
  }
  (window.addEventListener(`click`, e, {
    capture: !0,
  }),
    window.addEventListener(`mousedown`, e, {
      capture: !0,
    }),
    window.addEventListener(`focus`, e, {
      capture: !0,
    }),
    document.body.addEventListener(`click`, e, {
      capture: !0,
    }),
    document.body.addEventListener(`mousedown`, e, {
      capture: !0,
    }),
    document.body.addEventListener(`focus`, e, {
      capture: !0,
    }));
});
function ore(e) {
  throw Error(`Unexpected object: ` + e);
}
var vm = ((e) => (
  (e[(e.First = 0)] = `First`),
  (e[(e.Previous = 1)] = `Previous`),
  (e[(e.Next = 2)] = `Next`),
  (e[(e.Last = 3)] = `Last`),
  (e[(e.Specific = 4)] = `Specific`),
  (e[(e.Nothing = 5)] = `Nothing`),
  e
))(vm || {});
function sre(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0) return null;
  let r = t.resolveActiveIndex(),
    i = r ?? -1;
  switch (e.focus) {
    case 0:
      for (let e = 0; e < n.length; ++e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 1:
      i === -1 && (i = n.length);
      for (let e = i - 1; e >= 0; --e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 2:
      for (let e = i + 1; e < n.length; ++e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 3:
      for (let e = n.length - 1; e >= 0; --e) if (!t.resolveDisabled(n[e], e, n)) return e;
      return r;
    case 4:
      for (let r = 0; r < n.length; ++r) if (t.resolveId(n[r], r, n) === e.id) return r;
      return r;
    case 5:
      return null;
    default:
      ore(e);
  }
}
function cre(e) {
  var t;
  let n = e?.form ?? e.closest(`form`);
  if (n) {
    for (let t of n.elements)
      if (
        t !== e &&
        ((t.tagName === `INPUT` && t.type === `submit`) ||
          (t.tagName === `BUTTON` && t.type === `submit`) ||
          (t.nodeName === `INPUT` && t.type === `image`))
      ) {
        t.click();
        return;
      }
    (t = n.requestSubmit) == null || t.call(n);
  }
}
B();
function ym(e, t, n, r) {
  Rp.isServer ||
    Me((i) => {
      ((e ??= window), e.addEventListener(t, n, r), i(() => e.removeEventListener(t, n, r)));
    });
}
B();
var bm = ((e) => ((e[(e.Forwards = 0)] = `Forwards`), (e[(e.Backwards = 1)] = `Backwards`), e))(
  bm || {},
);
function xm() {
  let e = F(0);
  return (
    Qp(`keydown`, (t) => {
      t.key === `Tab` && (e.value = +!!t.shiftKey);
    }),
    e
  );
}
B();
function Sm(e) {
  if (!e) return new Set();
  if (typeof e == `function`) return new Set(e());
  let t = new Set();
  for (let n of e.value) {
    let e = Fp(n);
    e instanceof HTMLElement && t.add(e);
  }
  return t;
}
var Cm = ((e) => (
    (e[(e.None = 1)] = `None`),
    (e[(e.InitialFocus = 2)] = `InitialFocus`),
    (e[(e.TabLock = 4)] = `TabLock`),
    (e[(e.FocusLock = 8)] = `FocusLock`),
    (e[(e.RestoreFocus = 16)] = `RestoreFocus`),
    (e[(e.All = 30)] = `All`),
    e
  ))(Cm || {}),
  wm = Object.assign(
    k({
      name: `FocusTrap`,
      props: {
        as: {
          type: [Object, String],
          default: `div`,
        },
        initialFocus: {
          type: Object,
          default: null,
        },
        features: {
          type: Number,
          default: 30,
        },
        containers: {
          type: [Object, Function],
          default: F(new Set()),
        },
      },
      inheritAttrs: !1,
      setup(e, { attrs: t, slots: n, expose: r }) {
        let i = F(null);
        r({
          el: i,
          $el: i,
        });
        let a = V(() => zp(i)),
          o = F(!1);
        (Qe(() => (o.value = !0)),
          E(() => (o.value = !1)),
          ure(
            {
              ownerDocument: a,
            },
            V(() => o.value && !!(e.features & 16)),
          ));
        let s = dre(
          {
            ownerDocument: a,
            container: i,
            initialFocus: V(() => e.initialFocus),
          },
          V(() => o.value && !!(e.features & 2)),
        );
        fre(
          {
            ownerDocument: a,
            container: i,
            containers: e.containers,
            previousActiveElement: s,
          },
          V(() => o.value && !!(e.features & 8)),
        );
        let c = xm();
        function l(e) {
          let t = Fp(i);
          t &&
            ((e) => e())(() => {
              Ip(c.value, {
                [bm.Forwards]: () => {
                  Yp(t, Vp.First, {
                    skipElements: [e.relatedTarget],
                  });
                },
                [bm.Backwards]: () => {
                  Yp(t, Vp.Last, {
                    skipElements: [e.relatedTarget],
                  });
                },
              });
            });
        }
        let u = F(!1);
        function d(e) {
          e.key === `Tab` &&
            ((u.value = !0),
            requestAnimationFrame(() => {
              u.value = !1;
            }));
        }
        function f(t) {
          if (!o.value) return;
          let n = Sm(e.containers);
          Fp(i) instanceof HTMLElement && n.add(Fp(i));
          let r = t.relatedTarget;
          r instanceof HTMLElement &&
            r.dataset.headlessuiFocusGuard !== `true` &&
            (Tm(n, r) ||
              (u.value
                ? Yp(
                    Fp(i),
                    Ip(c.value, {
                      [bm.Forwards]: () => Vp.Next,
                      [bm.Backwards]: () => Vp.Previous,
                    }) | Vp.WrapAround,
                    {
                      relativeTo: t.target,
                    },
                  )
                : t.target instanceof HTMLElement && qp(t.target)));
        }
        return () => {
          let r = {},
            a = {
              ref: i,
              onKeydown: d,
              onFocusout: f,
            },
            { features: o, initialFocus: s, containers: c, ...u } = e;
          return Ne(ke, [
            !!(o & 4) &&
              Ne(dm, {
                as: `button`,
                type: `button`,
                "data-headlessui-focus-guard": !0,
                onFocus: l,
                features: um.Focusable,
              }),
            am({
              ourProps: a,
              theirProps: {
                ...t,
                ...u,
              },
              slot: r,
              attrs: t,
              slots: n,
              name: `FocusTrap`,
            }),
            !!(o & 4) &&
              Ne(dm, {
                as: `button`,
                type: `button`,
                "data-headlessui-focus-guard": !0,
                onFocus: l,
                features: um.Focusable,
              }),
          ]);
        };
      },
    }),
    {
      features: Cm,
    },
  );
function lre(e) {
  let t = F(_m.slice());
  return (
    He(
      [e],
      ([e], [n]) => {
        n === !0 && e === !1
          ? Mp(() => {
              t.value.splice(0);
            })
          : n === !1 && e === !0 && (t.value = _m.slice());
      },
      {
        flush: `post`,
      },
    ),
    () => t.value.find((e) => e != null && e.isConnected) ?? null
  );
}
function ure({ ownerDocument: e }, t) {
  let n = lre(t);
  (Qe(() => {
    Me(
      () => {
        t.value || (e.value?.activeElement === e.value?.body && qp(n()));
      },
      {
        flush: `post`,
      },
    );
  }),
    E(() => {
      t.value && qp(n());
    }));
}
function dre({ ownerDocument: e, container: t, initialFocus: n }, r) {
  let i = F(null),
    a = F(!1);
  return (
    Qe(() => (a.value = !0)),
    E(() => (a.value = !1)),
    Qe(() => {
      He(
        [t, n, r],
        (o, s) => {
          if (o.every((e, t) => s?.[t] === e) || !r.value) return;
          let c = Fp(t);
          c &&
            Mp(() => {
              if (!a.value) return;
              let t = Fp(n),
                r = e.value?.activeElement;
              if (t) {
                if (t === r) {
                  i.value = r;
                  return;
                }
              } else if (c.contains(r)) {
                i.value = r;
                return;
              }
              (t
                ? qp(t)
                : Yp(c, Vp.First | Vp.NoScroll) === Hp.Error &&
                  console.warn(`There are no focusable elements inside the <FocusTrap />`),
                (i.value = e.value?.activeElement));
            });
        },
        {
          immediate: !0,
          flush: `post`,
        },
      );
    }),
    i
  );
}
function fre({ ownerDocument: e, container: t, containers: n, previousActiveElement: r }, i) {
  ym(
    e.value?.defaultView,
    `focus`,
    (e) => {
      if (!i.value) return;
      let a = Sm(n);
      Fp(t) instanceof HTMLElement && a.add(Fp(t));
      let o = r.value;
      if (!o) return;
      let s = e.target;
      s && s instanceof HTMLElement
        ? Tm(a, s)
          ? ((r.value = s), qp(s))
          : (e.preventDefault(), e.stopPropagation(), qp(o))
        : qp(r.value);
    },
    !0,
  );
}
function Tm(e, t) {
  for (let n of e) if (n.contains(t)) return !0;
  return !1;
}
B();
function pre(e) {
  let t = xe(e.getSnapshot());
  return (
    E(
      e.subscribe(() => {
        t.value = e.getSnapshot();
      }),
    ),
    t
  );
}
function mre(e, t) {
  let n = e(),
    r = new Set();
  return {
    getSnapshot() {
      return n;
    },
    subscribe(e) {
      return (r.add(e), () => r.delete(e));
    },
    dispatch(e, ...i) {
      let a = t[e].call(n, ...i);
      a && ((n = a), r.forEach((e) => e()));
    },
  };
}
function hre() {
  let e;
  return {
    before({ doc: t }) {
      let n = t.documentElement;
      e = (t.defaultView ?? window).innerWidth - n.clientWidth;
    },
    after({ doc: t, d: n }) {
      let r = t.documentElement,
        i = r.clientWidth - r.offsetWidth,
        a = e - i;
      n.style(r, `paddingRight`, `${a}px`);
    },
  };
}
function gre() {
  return Xp()
    ? {
        before({ doc: e, d: t, meta: n }) {
          function r(e) {
            return n.containers.flatMap((e) => e()).some((t) => t.contains(e));
          }
          t.microTask(() => {
            if (window.getComputedStyle(e.documentElement).scrollBehavior !== `auto`) {
              let n = Np();
              (n.style(e.documentElement, `scrollBehavior`, `auto`),
                t.add(() => t.microTask(() => n.dispose())));
            }
            let n = window.scrollY ?? window.pageYOffset,
              i = null;
            (t.addEventListener(
              e,
              `click`,
              (t) => {
                if (t.target instanceof HTMLElement)
                  try {
                    let n = t.target.closest(`a`);
                    if (!n) return;
                    let { hash: a } = new URL(n.href),
                      o = e.querySelector(a);
                    o && !r(o) && (i = o);
                  } catch {}
              },
              !0,
            ),
              t.addEventListener(e, `touchstart`, (e) => {
                if (e.target instanceof HTMLElement)
                  if (r(e.target)) {
                    let n = e.target;
                    for (; n.parentElement && r(n.parentElement);) n = n.parentElement;
                    t.style(n, `overscrollBehavior`, `contain`);
                  } else t.style(e.target, `touchAction`, `none`);
              }),
              t.addEventListener(
                e,
                `touchmove`,
                (e) => {
                  if (e.target instanceof HTMLElement) {
                    if (e.target.tagName === `INPUT`) return;
                    if (r(e.target)) {
                      let t = e.target;
                      for (
                        ;
                        t.parentElement &&
                        t.dataset.headlessuiPortal !== `` &&
                        !(t.scrollHeight > t.clientHeight || t.scrollWidth > t.clientWidth);
                      )
                        t = t.parentElement;
                      t.dataset.headlessuiPortal === `` && e.preventDefault();
                    } else e.preventDefault();
                  }
                },
                {
                  passive: !1,
                },
              ),
              t.add(() => {
                (n !== (window.scrollY ?? window.pageYOffset) && window.scrollTo(0, n),
                  i &&
                    i.isConnected &&
                    (i.scrollIntoView({
                      block: `nearest`,
                    }),
                    (i = null)));
              }));
          });
        },
      }
    : {};
}
function _re() {
  return {
    before({ doc: e, d: t }) {
      t.style(e.documentElement, `overflow`, `hidden`);
    },
  };
}
function vre(e) {
  let t = {};
  for (let n of e) Object.assign(t, n(t));
  return t;
}
var Em = mre(() => new Map(), {
  PUSH(e, t) {
    let n = this.get(e) ?? {
      doc: e,
      count: 0,
      d: Np(),
      meta: new Set(),
    };
    return (n.count++, n.meta.add(t), this.set(e, n), this);
  },
  POP(e, t) {
    let n = this.get(e);
    return (n && (n.count--, n.meta.delete(t)), this);
  },
  SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
    let r = {
        doc: e,
        d: t,
        meta: vre(n),
      },
      i = [gre(), hre(), _re()];
    (i.forEach(({ before: e }) => e?.(r)), i.forEach(({ after: e }) => e?.(r)));
  },
  SCROLL_ALLOW({ d: e }) {
    e.dispose();
  },
  TEARDOWN({ doc: e }) {
    this.delete(e);
  },
});
(Em.subscribe(() => {
  let e = Em.getSnapshot(),
    t = new Map();
  for (let [n] of e) t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let e = t.get(n.doc) === `hidden`,
      r = n.count !== 0;
    (((r && !e) || (!r && e)) && Em.dispatch(n.count > 0 ? `SCROLL_PREVENT` : `SCROLL_ALLOW`, n),
      n.count === 0 && Em.dispatch(`TEARDOWN`, n));
  }
}),
  B());
function yre(e, t, n) {
  let r = pre(Em),
    i = V(() => {
      let t = e.value ? r.value.get(e.value) : void 0;
      return t ? t.count > 0 : !1;
    });
  return (
    He(
      [e, t],
      ([e, t], [r], i) => {
        if (!e || !t) return;
        Em.dispatch(`PUSH`, e, n);
        let a = !1;
        i(() => {
          a ||= (Em.dispatch(`POP`, r ?? e, n), !0);
        });
      },
      {
        immediate: !0,
      },
    ),
    i
  );
}
B();
var Dm = new Map(),
  Om = new Map();
function km(e, t = F(!0)) {
  Me((n) => {
    if (!t.value) return;
    let r = Fp(e);
    if (!r) return;
    n(function () {
      if (!r) return;
      let e = Om.get(r) ?? 1;
      if ((e === 1 ? Om.delete(r) : Om.set(r, e - 1), e !== 1)) return;
      let t = Dm.get(r);
      t &&
        (t[`aria-hidden`] === null
          ? r.removeAttribute(`aria-hidden`)
          : r.setAttribute(`aria-hidden`, t[`aria-hidden`]),
        (r.inert = t.inert),
        Dm.delete(r));
    });
    let i = Om.get(r) ?? 0;
    (Om.set(r, i + 1),
      i === 0 &&
        (Dm.set(r, {
          "aria-hidden": r.getAttribute(`aria-hidden`),
          inert: r.inert,
        }),
        r.setAttribute(`aria-hidden`, `true`),
        (r.inert = !0)));
  });
}
B();
function Am({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  let r = F(null),
    i = zp(r);
  function a() {
    let n = [];
    for (let t of e)
      t !== null &&
        (t instanceof HTMLElement
          ? n.push(t)
          : `value` in t && t.value instanceof HTMLElement && n.push(t.value));
    if (t != null && t.value) for (let e of t.value) n.push(e);
    for (let e of i?.querySelectorAll(`html > *, body > *`) ?? [])
      e !== document.body &&
        e !== document.head &&
        e instanceof HTMLElement &&
        e.id !== `headlessui-portal-root` &&
        (e.contains(Fp(r)) ||
          e.contains(Fp(r)?.getRootNode()?.host) ||
          n.some((t) => e.contains(t)) ||
          n.push(e));
    return n;
  }
  return {
    resolveContainers: a,
    contains(e) {
      return a().some((t) => t.contains(e));
    },
    mainTreeNodeRef: r,
    MainTreeNode() {
      return n == null
        ? Ne(dm, {
            features: um.Hidden,
            ref: r,
          })
        : null;
    },
  };
}
function bre() {
  let e = F(null);
  return {
    mainTreeNodeRef: e,
    MainTreeNode() {
      return Ne(dm, {
        features: um.Hidden,
        ref: e,
      });
    },
  };
}
B();
var jm = Symbol(`ForcePortalRootContext`);
function xre() {
  return R(jm, !1);
}
var Mm = k({
  name: `ForcePortalRoot`,
  props: {
    as: {
      type: [Object, String],
      default: `template`,
    },
    force: {
      type: Boolean,
      default: !1,
    },
  },
  setup(e, { slots: t, attrs: n }) {
    return (
      ge(jm, e.force),
      () => {
        let { force: r, ...i } = e;
        return am({
          theirProps: i,
          ourProps: {},
          slot: {},
          slots: t,
          attrs: n,
          name: `ForcePortalRoot`,
        });
      }
    );
  },
});
B();
var Nm = Symbol(`StackContext`),
  Pm = ((e) => ((e[(e.Add = 0)] = `Add`), (e[(e.Remove = 1)] = `Remove`), e))(Pm || {});
function Sre() {
  return R(Nm, () => {});
}
function Cre({ type: e, enabled: t, element: n, onUpdate: r }) {
  let i = Sre();
  function a(...e) {
    (r?.(...e), i(...e));
  }
  (Qe(() => {
    He(
      t,
      (t, r) => {
        t ? a(0, e, n) : r === !0 && a(1, e, n);
      },
      {
        immediate: !0,
        flush: `sync`,
      },
    );
  }),
    E(() => {
      t.value && a(1, e, n);
    }),
    ge(Nm, a));
}
B();
var Fm = Symbol(`DescriptionContext`);
function wre() {
  let e = R(Fm, null);
  if (e === null) throw Error(`Missing parent`);
  return e;
}
function Im({ slot: e = F({}), name: t = `Description`, props: n = {} } = {}) {
  let r = F([]);
  function i(e) {
    return (
      r.value.push(e),
      () => {
        let t = r.value.indexOf(e);
        t !== -1 && r.value.splice(t, 1);
      }
    );
  }
  return (
    ge(Fm, {
      register: i,
      slot: e,
      name: t,
      props: n,
    }),
    V(() => (r.value.length > 0 ? r.value.join(` `) : void 0))
  );
}
var Tre = k({
  name: `Description`,
  props: {
    as: {
      type: [Object, String],
      default: `p`,
    },
    id: {
      type: String,
      default: null,
    },
  },
  setup(e, { attrs: t, slots: n }) {
    let r = e.id ?? `headlessui-description-${Pp()}`,
      i = wre();
    return (
      Qe(() => E(i.register(r))),
      () => {
        let { name: a = `Description`, slot: o = F({}), props: s = {} } = i,
          { ...c } = e;
        return am({
          ourProps: {
            ...Object.entries(s).reduce(
              (e, [t, n]) =>
                Object.assign(e, {
                  [t]: P(n),
                }),
              {},
            ),
            id: r,
          },
          theirProps: c,
          slot: o.value,
          attrs: t,
          slots: n,
          name: a,
        });
      }
    );
  },
});
B();
function Ere(e) {
  let t = zp(e);
  if (!t) {
    if (e === null) return null;
    throw Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let n = t.getElementById(`headlessui-portal-root`);
  if (n) return n;
  let r = t.createElement(`div`);
  return (r.setAttribute(`id`, `headlessui-portal-root`), t.body.appendChild(r));
}
var Lm = new WeakMap();
function Dre(e) {
  return Lm.get(e) ?? 0;
}
function Rm(e, t) {
  let n = t(Dre(e));
  return (n <= 0 ? Lm.delete(e) : Lm.set(e, n), n);
}
var zm = k({
    name: `Portal`,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
    },
    setup(e, { slots: t, attrs: n }) {
      let r = F(null),
        i = V(() => zp(r)),
        a = xre(),
        o = R(Hm, null),
        s = F(a === !0 || o == null ? Ere(r.value) : o.resolveTarget());
      s.value && Rm(s.value, (e) => e + 1);
      let c = F(!1);
      (Qe(() => {
        c.value = !0;
      }),
        Me(() => {
          a || (o != null && (s.value = o.resolveTarget()));
        }));
      let l = R(Bm, null),
        u = !1,
        d = te();
      return (
        He(r, () => {
          if (u || !l) return;
          let e = Fp(r);
          e && (E(l.register(e), d), (u = !0));
        }),
        E(() => {
          var e;
          let t = i.value?.getElementById(`headlessui-portal-root`);
          !t ||
            s.value !== t ||
            Rm(s.value, (e) => e - 1) ||
            s.value.children.length > 0 ||
            (e = s.value.parentElement) == null ||
            e.removeChild(s.value);
        }),
        () => {
          if (!c.value || s.value === null) return null;
          let i = {
            ref: r,
            "data-headlessui-portal": ``,
          };
          return Ne(
            De,
            {
              to: s.value,
            },
            am({
              ourProps: i,
              theirProps: e,
              slot: {},
              attrs: n,
              slots: t,
              name: `Portal`,
            }),
          );
        }
      );
    },
  }),
  Bm = Symbol(`PortalParentContext`);
function Vm() {
  let e = R(Bm, null),
    t = F([]);
  function n(n) {
    return (t.value.push(n), e && e.register(n), () => r(n));
  }
  function r(n) {
    let r = t.value.indexOf(n);
    (r !== -1 && t.value.splice(r, 1), e && e.unregister(n));
  }
  let i = {
    register: n,
    unregister: r,
    portals: t,
  };
  return [
    t,
    k({
      name: `PortalWrapper`,
      setup(e, { slots: t }) {
        return (ge(Bm, i), () => t.default?.call(t));
      },
    }),
  ];
}
var Hm = Symbol(`PortalGroupContext`),
  Ore = k({
    name: `PortalGroup`,
    props: {
      as: {
        type: [Object, String],
        default: `template`,
      },
      target: {
        type: Object,
        default: null,
      },
    },
    setup(e, { attrs: t, slots: n }) {
      return (
        ge(
          Hm,
          Ae({
            resolveTarget() {
              return e.target;
            },
          }),
        ),
        () => {
          let { target: r, ...i } = e;
          return am({
            theirProps: i,
            ourProps: {},
            slot: {},
            attrs: t,
            slots: n,
            name: `PortalGroup`,
          });
        }
      );
    },
  });
B();
var kre = ((e) => ((e[(e.Open = 0)] = `Open`), (e[(e.Closed = 1)] = `Closed`), e))(kre || {}),
  Um = Symbol(`DialogContext`);
function Wm(e) {
  let t = R(Um, null);
  if (t === null) {
    let t = Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw (Error.captureStackTrace && Error.captureStackTrace(t, Wm), t);
  }
  return t;
}
var Gm = `DC8F892D-2EBD-447C-A4C8-A03058436FF4`,
  Are = k({
    name: `Dialog`,
    inheritAttrs: !1,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
      static: {
        type: Boolean,
        default: !1,
      },
      unmount: {
        type: Boolean,
        default: !0,
      },
      open: {
        type: [Boolean, String],
        default: Gm,
      },
      initialFocus: {
        type: Object,
        default: null,
      },
      id: {
        type: String,
        default: null,
      },
      role: {
        type: String,
        default: `dialog`,
      },
    },
    emits: {
      close: (e) => !0,
    },
    setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
      let a = e.id ?? `headlessui-dialog-${Pp()}`,
        o = F(!1);
      Qe(() => {
        o.value = !0;
      });
      let s = !1,
        c = V(() =>
          e.role === `dialog` || e.role === `alertdialog`
            ? e.role
            : (s ||
                ((s = !0),
                console.warn(
                  `Invalid role [${c}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`,
                )),
              `dialog`),
        ),
        l = F(0),
        u = mm(),
        d = V(() => (e.open === Gm && u !== null ? (u.value & pm.Open) === pm.Open : e.open)),
        f = F(null),
        p = V(() => zp(f));
      if (
        (i({
          el: f,
          $el: f,
        }),
        !(e.open !== Gm || u !== null))
      )
        throw Error("You forgot to provide an `open` prop to the `Dialog`.");
      if (typeof d.value != `boolean`)
        throw Error(
          `You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${d.value === Gm ? void 0 : e.open}`,
        );
      let m = V(() => (o.value && d.value ? 0 : 1)),
        h = V(() => m.value === 0),
        g = V(() => l.value > 1),
        v = R(Um, null) !== null,
        [y, b] = Vm(),
        {
          resolveContainers: x,
          mainTreeNodeRef: S,
          MainTreeNode: C,
        } = Am({
          portals: y,
          defaultContainers: [V(() => O.panelRef.value ?? f.value)],
        }),
        w = V(() => (g.value ? `parent` : `leaf`)),
        T = V(() => (u === null ? !1 : (u.value & pm.Closing) === pm.Closing)),
        E = V(() => (v || T.value ? !1 : h.value));
      km(
        V(
          () =>
            Array.from(p.value?.querySelectorAll(`body > *`) ?? []).find((e) =>
              e.id === `headlessui-portal-root`
                ? !1
                : e.contains(Fp(S)) && e instanceof HTMLElement,
            ) ?? null,
        ),
        E,
      );
      let D = V(() => (g.value ? !0 : h.value));
      (km(
        V(
          () =>
            Array.from(p.value?.querySelectorAll(`[data-headlessui-portal]`) ?? []).find(
              (e) => e.contains(Fp(S)) && e instanceof HTMLElement,
            ) ?? null,
        ),
        D,
      ),
        Cre({
          type: `Dialog`,
          enabled: V(() => m.value === 0),
          element: f,
          onUpdate: (e, t) => {
            if (t === `Dialog`)
              return Ip(e, {
                [Pm.Add]: () => (l.value += 1),
                [Pm.Remove]: () => --l.value,
              });
          },
        }));
      let ee = Im({
          name: `DialogDescription`,
          slot: V(() => ({
            open: d.value,
          })),
        }),
        te = F(null),
        O = {
          titleId: te,
          panelRef: F(null),
          dialogState: m,
          setTitleId(e) {
            te.value !== e && (te.value = e);
          },
          close() {
            t(`close`, !1);
          },
        };
      (ge(Um, O),
        $p(
          x,
          (e, t) => {
            (e.preventDefault(), O.close(), de(() => t?.focus()));
          },
          V(() => !(!h.value || g.value)),
        ));
      let k = V(() => !(g.value || m.value !== 0));
      return (
        ym(p.value?.defaultView, `keydown`, (e) => {
          k.value &&
            (e.defaultPrevented ||
              (e.key === gm.Escape && (e.preventDefault(), e.stopPropagation(), O.close())));
        }),
        yre(
          p,
          V(() => !(T.value || m.value !== 0 || v)),
          (e) => ({
            containers: [...(e.containers ?? []), x],
          }),
        ),
        Me((e) => {
          if (m.value !== 0) return;
          let t = Fp(f);
          if (!t) return;
          let n = new ResizeObserver((e) => {
            for (let t of e) {
              let e = t.target.getBoundingClientRect();
              e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && O.close();
            }
          });
          (n.observe(t), e(() => n.disconnect()));
        }),
        () => {
          let { open: t, initialFocus: i, ...o } = e,
            s = {
              ...n,
              ref: f,
              id: a,
              role: c.value,
              "aria-modal": m.value === 0 ? !0 : void 0,
              "aria-labelledby": te.value,
              "aria-describedby": ee.value,
            },
            l = {
              open: m.value === 0,
            };
          return Ne(
            Mm,
            {
              force: !0,
            },
            () => [
              Ne(zm, () =>
                Ne(
                  Ore,
                  {
                    target: f.value,
                  },
                  () =>
                    Ne(
                      Mm,
                      {
                        force: !1,
                      },
                      () =>
                        Ne(
                          wm,
                          {
                            initialFocus: i,
                            containers: x,
                            features: h.value
                              ? Ip(w.value, {
                                  parent: wm.features.RestoreFocus,
                                  leaf: wm.features.All & ~wm.features.FocusLock,
                                })
                              : wm.features.None,
                          },
                          () =>
                            Ne(b, {}, () =>
                              am({
                                ourProps: s,
                                theirProps: {
                                  ...o,
                                  ...n,
                                },
                                slot: l,
                                attrs: n,
                                slots: r,
                                visible: m.value === 0,
                                features: rm.RenderStrategy | rm.Static,
                                name: `Dialog`,
                              }),
                            ),
                        ),
                    ),
                ),
              ),
              Ne(C),
            ],
          );
        }
      );
    },
  }),
  jre = k({
    name: `DialogOverlay`,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
      id: {
        type: String,
        default: null,
      },
    },
    setup(e, { attrs: t, slots: n }) {
      let r = e.id ?? `headlessui-dialog-overlay-${Pp()}`,
        i = Wm(`DialogOverlay`);
      function a(e) {
        e.target === e.currentTarget && (e.preventDefault(), e.stopPropagation(), i.close());
      }
      return () => {
        let { ...o } = e;
        return am({
          ourProps: {
            id: r,
            "aria-hidden": !0,
            onClick: a,
          },
          theirProps: o,
          slot: {
            open: i.dialogState.value === 0,
          },
          attrs: t,
          slots: n,
          name: `DialogOverlay`,
        });
      };
    },
  });
(k({
  name: `DialogBackdrop`,
  props: {
    as: {
      type: [Object, String],
      default: `div`,
    },
    id: {
      type: String,
      default: null,
    },
  },
  inheritAttrs: !1,
  setup(e, { attrs: t, slots: n, expose: r }) {
    let i = e.id ?? `headlessui-dialog-backdrop-${Pp()}`,
      a = Wm(`DialogBackdrop`),
      o = F(null);
    return (
      r({
        el: o,
        $el: o,
      }),
      Qe(() => {
        if (a.panelRef.value === null)
          throw Error(
            `A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.`,
          );
      }),
      () => {
        let { ...r } = e,
          s = {
            id: i,
            ref: o,
            "aria-hidden": !0,
          };
        return Ne(
          Mm,
          {
            force: !0,
          },
          () =>
            Ne(zm, () =>
              am({
                ourProps: s,
                theirProps: {
                  ...t,
                  ...r,
                },
                slot: {
                  open: a.dialogState.value === 0,
                },
                attrs: t,
                slots: n,
                name: `DialogBackdrop`,
              }),
            ),
        );
      }
    );
  },
}),
  k({
    name: `DialogPanel`,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
      id: {
        type: String,
        default: null,
      },
    },
    setup(e, { attrs: t, slots: n, expose: r }) {
      let i = e.id ?? `headlessui-dialog-panel-${Pp()}`,
        a = Wm(`DialogPanel`);
      r({
        el: a.panelRef,
        $el: a.panelRef,
      });
      function o(e) {
        e.stopPropagation();
      }
      return () => {
        let { ...r } = e;
        return am({
          ourProps: {
            id: i,
            ref: a.panelRef,
            onClick: o,
          },
          theirProps: r,
          slot: {
            open: a.dialogState.value === 0,
          },
          attrs: t,
          slots: n,
          name: `DialogPanel`,
        });
      };
    },
  }),
  k({
    name: `DialogTitle`,
    props: {
      as: {
        type: [Object, String],
        default: `h2`,
      },
      id: {
        type: String,
        default: null,
      },
    },
    setup(e, { attrs: t, slots: n }) {
      let r = e.id ?? `headlessui-dialog-title-${Pp()}`,
        i = Wm(`DialogTitle`);
      return (
        Qe(() => {
          (i.setTitleId(r), E(() => i.setTitleId(null)));
        }),
        () => {
          let { ...a } = e;
          return am({
            ourProps: {
              id: r,
            },
            theirProps: a,
            slot: {
              open: i.dialogState.value === 0,
            },
            attrs: t,
            slots: n,
            name: `DialogTitle`,
          });
        }
      );
    },
  }));
var Km =
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function qm(e) {
  let t = e.innerText ?? ``,
    n = e.cloneNode(!0);
  if (!(n instanceof HTMLElement)) return t;
  let r = !1;
  for (let e of n.querySelectorAll(`[hidden],[aria-hidden],[role="img"]`)) (e.remove(), (r = !0));
  let i = r ? (n.innerText ?? ``) : t;
  return (Km.test(i) && (i = i.replace(Km, ``)), i);
}
function Mre(e) {
  let t = e.getAttribute(`aria-label`);
  if (typeof t == `string`) return t.trim();
  let n = e.getAttribute(`aria-labelledby`);
  if (n) {
    let e = n
      .split(` `)
      .map((e) => {
        let t = document.getElementById(e);
        if (t) {
          let e = t.getAttribute(`aria-label`);
          return typeof e == `string` ? e.trim() : qm(t).trim();
        }
        return null;
      })
      .filter(Boolean);
    if (e.length > 0) return e.join(`, `);
  }
  return qm(e).trim();
}
B();
function Nre(e) {
  let t = F(``),
    n = F(``);
  return () => {
    let r = Fp(e);
    if (!r) return ``;
    let i = r.innerText;
    if (t.value === i) return n.value;
    let a = Mre(r).trim().toLowerCase();
    return ((t.value = i), (n.value = a), a);
  };
}
B();
var Pre = ((e) => ((e[(e.Open = 0)] = `Open`), (e[(e.Closed = 1)] = `Closed`), e))(Pre || {}),
  Fre = ((e) => ((e[(e.Pointer = 0)] = `Pointer`), (e[(e.Other = 1)] = `Other`), e))(Fre || {});
function Ire(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
var Jm = Symbol(`MenuContext`);
function Ym(e) {
  let t = R(Jm, null);
  if (t === null) {
    let t = Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw (Error.captureStackTrace && Error.captureStackTrace(t, Ym), t);
  }
  return t;
}
var Xm = k({
    name: `Menu`,
    props: {
      as: {
        type: [Object, String],
        default: `template`,
      },
    },
    setup(e, { slots: t, attrs: n }) {
      let r = F(1),
        i = F(null),
        a = F(null),
        o = F([]),
        s = F(``),
        c = F(null),
        l = F(1);
      function u(e = (e) => e) {
        let t = c.value === null ? null : o.value[c.value],
          n = Jp(e(o.value.slice()), (e) => Fp(e.dataRef.domRef)),
          r = t ? n.indexOf(t) : null;
        return (
          r === -1 && (r = null),
          {
            items: n,
            activeItemIndex: r,
          }
        );
      }
      let d = {
        menuState: r,
        buttonRef: i,
        itemsRef: a,
        items: o,
        searchQuery: s,
        activeItemIndex: c,
        activationTrigger: l,
        closeMenu: () => {
          ((r.value = 1), (c.value = null));
        },
        openMenu: () => (r.value = 0),
        goToItem(e, t, n) {
          let r = u(),
            i = sre(
              e === vm.Specific
                ? {
                    focus: vm.Specific,
                    id: t,
                  }
                : {
                    focus: e,
                  },
              {
                resolveItems: () => r.items,
                resolveActiveIndex: () => r.activeItemIndex,
                resolveId: (e) => e.id,
                resolveDisabled: (e) => e.dataRef.disabled,
              },
            );
          ((s.value = ``), (c.value = i), (l.value = n ?? 1), (o.value = r.items));
        },
        search(e) {
          let t = +(s.value === ``);
          s.value += e.toLowerCase();
          let n = (
              c.value === null
                ? o.value
                : o.value.slice(c.value + t).concat(o.value.slice(0, c.value + t))
            ).find((e) => e.dataRef.textValue.startsWith(s.value) && !e.dataRef.disabled),
            r = n ? o.value.indexOf(n) : -1;
          r === -1 || r === c.value || ((c.value = r), (l.value = 1));
        },
        clearSearch() {
          s.value = ``;
        },
        registerItem(e, t) {
          let n = u((n) => [
            ...n,
            {
              id: e,
              dataRef: t,
            },
          ]);
          ((o.value = n.items), (c.value = n.activeItemIndex), (l.value = 1));
        },
        unregisterItem(e) {
          let t = u((t) => {
            let n = t.findIndex((t) => t.id === e);
            return (n !== -1 && t.splice(n, 1), t);
          });
          ((o.value = t.items), (c.value = t.activeItemIndex), (l.value = 1));
        },
      };
      return (
        $p(
          [i, a],
          (e, t) => {
            var n;
            (d.closeMenu(),
              Gp(t, Wp.Loose) || (e.preventDefault(), (n = Fp(i)) == null || n.focus()));
          },
          V(() => r.value === 0),
        ),
        ge(Jm, d),
        hm(
          V(() =>
            Ip(r.value, {
              0: pm.Open,
              1: pm.Closed,
            }),
          ),
        ),
        () =>
          am({
            ourProps: {},
            theirProps: e,
            slot: {
              open: r.value === 0,
              close: d.closeMenu,
            },
            slots: t,
            attrs: n,
            name: `Menu`,
          })
      );
    },
  }),
  Zm = k({
    name: `MenuButton`,
    props: {
      disabled: {
        type: Boolean,
        default: !1,
      },
      as: {
        type: [Object, String],
        default: `button`,
      },
      id: {
        type: String,
        default: null,
      },
    },
    setup(e, { attrs: t, slots: n, expose: r }) {
      let i = e.id ?? `headlessui-menu-button-${Pp()}`,
        a = Ym(`MenuButton`);
      r({
        el: a.buttonRef,
        $el: a.buttonRef,
      });
      function o(e) {
        switch (e.key) {
          case gm.Space:
          case gm.Enter:
          case gm.ArrowDown:
            (e.preventDefault(),
              e.stopPropagation(),
              a.openMenu(),
              de(() => {
                var e;
                ((e = Fp(a.itemsRef)) == null ||
                  e.focus({
                    preventScroll: !0,
                  }),
                  a.goToItem(vm.First));
              }));
            break;
          case gm.ArrowUp:
            (e.preventDefault(),
              e.stopPropagation(),
              a.openMenu(),
              de(() => {
                var e;
                ((e = Fp(a.itemsRef)) == null ||
                  e.focus({
                    preventScroll: !0,
                  }),
                  a.goToItem(vm.Last));
              }));
            break;
        }
      }
      function s(e) {
        switch (e.key) {
          case gm.Space:
            e.preventDefault();
            break;
        }
      }
      function c(t) {
        e.disabled ||
          (a.menuState.value === 0
            ? (a.closeMenu(),
              de(() =>
                Fp(a.buttonRef)?.focus({
                  preventScroll: !0,
                }),
              ))
            : (t.preventDefault(),
              a.openMenu(),
              Ire(() =>
                Fp(a.itemsRef)?.focus({
                  preventScroll: !0,
                }),
              )));
      }
      let l = tm(
        V(() => ({
          as: e.as,
          type: t.type,
        })),
        a.buttonRef,
      );
      return () => {
        let r = {
            open: a.menuState.value === 0,
          },
          { ...u } = e;
        return am({
          ourProps: {
            ref: a.buttonRef,
            id: i,
            type: l.value,
            "aria-haspopup": `menu`,
            "aria-controls": Fp(a.itemsRef)?.id,
            "aria-expanded": a.menuState.value === 0,
            onKeydown: o,
            onKeyup: s,
            onClick: c,
          },
          theirProps: u,
          slot: r,
          attrs: t,
          slots: n,
          name: `MenuButton`,
        });
      };
    },
  }),
  Qm = k({
    name: `MenuItems`,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
      static: {
        type: Boolean,
        default: !1,
      },
      unmount: {
        type: Boolean,
        default: !0,
      },
      id: {
        type: String,
        default: null,
      },
    },
    setup(e, { attrs: t, slots: n, expose: r }) {
      let i = e.id ?? `headlessui-menu-items-${Pp()}`,
        a = Ym(`MenuItems`),
        o = F(null);
      (r({
        el: a.itemsRef,
        $el: a.itemsRef,
      }),
        tre({
          container: V(() => Fp(a.itemsRef)),
          enabled: V(() => a.menuState.value === 0),
          accept(e) {
            return e.getAttribute(`role`) === `menuitem`
              ? NodeFilter.FILTER_REJECT
              : e.hasAttribute(`role`)
                ? NodeFilter.FILTER_SKIP
                : NodeFilter.FILTER_ACCEPT;
          },
          walk(e) {
            e.setAttribute(`role`, `none`);
          },
        }));
      function s(e) {
        var t;
        switch ((o.value && clearTimeout(o.value), e.key)) {
          case gm.Space:
            if (a.searchQuery.value !== ``)
              return (e.preventDefault(), e.stopPropagation(), a.search(e.key));
          case gm.Enter:
            if ((e.preventDefault(), e.stopPropagation(), a.activeItemIndex.value !== null)) {
              let e = a.items.value[a.activeItemIndex.value];
              (t = Fp(e.dataRef.domRef)) == null || t.click();
            }
            (a.closeMenu(), Kp(Fp(a.buttonRef)));
            break;
          case gm.ArrowDown:
            return (e.preventDefault(), e.stopPropagation(), a.goToItem(vm.Next));
          case gm.ArrowUp:
            return (e.preventDefault(), e.stopPropagation(), a.goToItem(vm.Previous));
          case gm.Home:
          case gm.PageUp:
            return (e.preventDefault(), e.stopPropagation(), a.goToItem(vm.First));
          case gm.End:
          case gm.PageDown:
            return (e.preventDefault(), e.stopPropagation(), a.goToItem(vm.Last));
          case gm.Escape:
            (e.preventDefault(),
              e.stopPropagation(),
              a.closeMenu(),
              de(() =>
                Fp(a.buttonRef)?.focus({
                  preventScroll: !0,
                }),
              ));
            break;
          case gm.Tab:
            (e.preventDefault(),
              e.stopPropagation(),
              a.closeMenu(),
              de(() => Zne(Fp(a.buttonRef), e.shiftKey ? Vp.Previous : Vp.Next)));
            break;
          default:
            e.key.length === 1 &&
              (a.search(e.key), (o.value = setTimeout(() => a.clearSearch(), 350)));
            break;
        }
      }
      function c(e) {
        switch (e.key) {
          case gm.Space:
            e.preventDefault();
            break;
        }
      }
      let l = mm(),
        u = V(() => (l === null ? a.menuState.value === 0 : (l.value & pm.Open) === pm.Open));
      return () => {
        var r;
        let o = {
            open: a.menuState.value === 0,
          },
          { ...l } = e;
        return am({
          ourProps: {
            "aria-activedescendant":
              a.activeItemIndex.value === null ||
              (r = a.items.value[a.activeItemIndex.value]) == null
                ? void 0
                : r.id,
            "aria-labelledby": Fp(a.buttonRef)?.id,
            id: i,
            onKeydown: s,
            onKeyup: c,
            role: `menu`,
            tabIndex: 0,
            ref: a.itemsRef,
          },
          theirProps: l,
          slot: o,
          attrs: t,
          slots: n,
          features: rm.RenderStrategy | rm.Static,
          visible: u.value,
          name: `MenuItems`,
        });
      };
    },
  }),
  $m = k({
    name: `MenuItem`,
    inheritAttrs: !1,
    props: {
      as: {
        type: [Object, String],
        default: `template`,
      },
      disabled: {
        type: Boolean,
        default: !1,
      },
      id: {
        type: String,
        default: null,
      },
    },
    setup(e, { slots: t, attrs: n, expose: r }) {
      let i = e.id ?? `headlessui-menu-item-${Pp()}`,
        a = Ym(`MenuItem`),
        o = F(null);
      r({
        el: o,
        $el: o,
      });
      let s = V(() =>
          a.activeItemIndex.value === null ? !1 : a.items.value[a.activeItemIndex.value].id === i,
        ),
        c = Nre(o),
        l = V(() => ({
          disabled: e.disabled,
          get textValue() {
            return c();
          },
          domRef: o,
        }));
      (Qe(() => a.registerItem(i, l)),
        E(() => a.unregisterItem(i)),
        Me(() => {
          a.menuState.value === 0 &&
            s.value &&
            a.activationTrigger.value !== 0 &&
            de(() => {
              var e;
              return (e = Fp(o))?.scrollIntoView?.call(e, {
                block: `nearest`,
              });
            });
        }));
      function u(t) {
        if (e.disabled) return t.preventDefault();
        (a.closeMenu(), Kp(Fp(a.buttonRef)));
      }
      function d() {
        if (e.disabled) return a.goToItem(vm.Nothing);
        a.goToItem(vm.Specific, i);
      }
      let f = ere();
      function p(e) {
        f.update(e);
      }
      function m(t) {
        f.wasMoved(t) && (e.disabled || s.value || a.goToItem(vm.Specific, i, 0));
      }
      function h(t) {
        f.wasMoved(t) && (e.disabled || (s.value && a.goToItem(vm.Nothing)));
      }
      return () => {
        let { disabled: r, ...c } = e,
          l = {
            active: s.value,
            disabled: r,
            close: a.closeMenu,
          };
        return am({
          ourProps: {
            id: i,
            ref: o,
            role: `menuitem`,
            tabIndex: r === !0 ? void 0 : -1,
            "aria-disabled": r === !0 ? !0 : void 0,
            onClick: u,
            onFocus: d,
            onPointerenter: p,
            onMouseenter: p,
            onPointermove: m,
            onMousemove: m,
            onPointerleave: h,
            onMouseleave: h,
          },
          theirProps: {
            ...n,
            ...c,
          },
          slot: l,
          attrs: n,
          slots: t,
          name: `MenuItem`,
        });
      };
    },
  });
B();
var Lre = ((e) => ((e[(e.Open = 0)] = `Open`), (e[(e.Closed = 1)] = `Closed`), e))(Lre || {}),
  eh = Symbol(`PopoverContext`);
function th(e) {
  let t = R(eh, null);
  if (t === null) {
    let t = Error(`<${e} /> is missing a parent <${ah.name} /> component.`);
    throw (Error.captureStackTrace && Error.captureStackTrace(t, th), t);
  }
  return t;
}
var nh = Symbol(`PopoverGroupContext`);
function rh() {
  return R(nh, null);
}
var ih = Symbol(`PopoverPanelContext`);
function Rre() {
  return R(ih, null);
}
var ah = k({
    name: `Popover`,
    inheritAttrs: !1,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
    },
    setup(e, { slots: t, attrs: n, expose: r }) {
      let i = F(null);
      r({
        el: i,
        $el: i,
      });
      let a = F(1),
        o = F(null),
        s = F(null),
        c = F(null),
        l = F(null),
        u = V(() => zp(i)),
        d = V(() => {
          var e, t;
          if (!Fp(o) || !Fp(l)) return !1;
          for (let e of document.querySelectorAll(`body > *`))
            if (Number(e?.contains(Fp(o))) ^ Number(e?.contains(Fp(l)))) return !0;
          let n = Up(),
            r = n.indexOf(Fp(o)),
            i = (r + n.length - 1) % n.length,
            a = (r + 1) % n.length,
            s = n[i],
            c = n[a];
          return !((e = Fp(l)) != null && e.contains(s)) && !((t = Fp(l)) != null && t.contains(c));
        }),
        f = {
          popoverState: a,
          buttonId: F(null),
          panelId: F(null),
          panel: l,
          button: o,
          isPortalled: d,
          beforePanelSentinel: s,
          afterPanelSentinel: c,
          togglePopover() {
            a.value = Ip(a.value, {
              0: 1,
              1: 0,
            });
          },
          closePopover() {
            a.value !== 1 && (a.value = 1);
          },
          close(e) {
            (f.closePopover(),
              (e
                ? e instanceof HTMLElement
                  ? e
                  : e.value instanceof HTMLElement
                    ? Fp(e)
                    : Fp(f.button)
                : Fp(f.button)
              )?.focus());
          },
        };
      (ge(eh, f),
        hm(
          V(() =>
            Ip(a.value, {
              0: pm.Open,
              1: pm.Closed,
            }),
          ),
        ));
      let p = {
          buttonId: f.buttonId,
          panelId: f.panelId,
          close() {
            f.closePopover();
          },
        },
        m = rh(),
        h = m?.registerPopover,
        [g, v] = Vm(),
        y = Am({
          mainTreeNodeRef: m?.mainTreeNodeRef,
          portals: g,
          defaultContainers: [o, l],
        });
      function b() {
        return (
          m?.isFocusWithinPopoverGroup() ??
          (u.value?.activeElement &&
            (Fp(o)?.contains(u.value.activeElement) || Fp(l)?.contains(u.value.activeElement)))
        );
      }
      return (
        Me(() => h?.(p)),
        ym(
          u.value?.defaultView,
          `focus`,
          (e) => {
            var t, n;
            e.target !== window &&
              e.target instanceof HTMLElement &&
              a.value === 0 &&
              (b() ||
                (o &&
                  l &&
                  (y.contains(e.target) ||
                    ((t = Fp(f.beforePanelSentinel)) != null && t.contains(e.target)) ||
                    ((n = Fp(f.afterPanelSentinel)) != null && n.contains(e.target)) ||
                    f.closePopover())));
          },
          !0,
        ),
        $p(
          y.resolveContainers,
          (e, t) => {
            var n;
            (f.closePopover(),
              Gp(t, Wp.Loose) || (e.preventDefault(), (n = Fp(o)) == null || n.focus()));
          },
          V(() => a.value === 0),
        ),
        () => {
          let r = {
            open: a.value === 0,
            close: f.close,
          };
          return Ne(ke, [
            Ne(v, {}, () =>
              am({
                theirProps: {
                  ...e,
                  ...n,
                },
                ourProps: {
                  ref: i,
                },
                slot: r,
                slots: t,
                attrs: n,
                name: `Popover`,
              }),
            ),
            Ne(y.MainTreeNode),
          ]);
        }
      );
    },
  }),
  zre = k({
    name: `PopoverButton`,
    props: {
      as: {
        type: [Object, String],
        default: `button`,
      },
      disabled: {
        type: [Boolean],
        default: !1,
      },
      id: {
        type: String,
        default: null,
      },
    },
    inheritAttrs: !1,
    setup(e, { attrs: t, slots: n, expose: r }) {
      let i = e.id ?? `headlessui-popover-button-${Pp()}`,
        a = th(`PopoverButton`),
        o = V(() => zp(a.button));
      (r({
        el: a.button,
        $el: a.button,
      }),
        Qe(() => {
          a.buttonId.value = i;
        }),
        E(() => {
          a.buttonId.value = null;
        }));
      let s = rh()?.closeOthers,
        c = Rre(),
        l = V(() => (c === null ? !1 : c.value === a.panelId.value)),
        u = F(null),
        d = `headlessui-focus-sentinel-${Pp()}`;
      l.value ||
        Me(() => {
          a.button.value = Fp(u);
        });
      let f = tm(
        V(() => ({
          as: e.as,
          type: t.type,
        })),
        u,
      );
      function p(e) {
        var t, n, r, i, c;
        if (l.value) {
          if (a.popoverState.value === 1) return;
          switch (e.key) {
            case gm.Space:
            case gm.Enter:
              (e.preventDefault(),
                (n = (t = e.target).click) == null || n.call(t),
                a.closePopover(),
                (r = Fp(a.button)) == null || r.focus());
              break;
          }
        } else
          switch (e.key) {
            case gm.Space:
            case gm.Enter:
              (e.preventDefault(),
                e.stopPropagation(),
                a.popoverState.value === 1 && s?.(a.buttonId.value),
                a.togglePopover());
              break;
            case gm.Escape:
              if (a.popoverState.value !== 0) return s?.(a.buttonId.value);
              if (
                !Fp(a.button) ||
                ((i = o.value) != null &&
                  i.activeElement &&
                  !((c = Fp(a.button)) != null && c.contains(o.value.activeElement)))
              )
                return;
              (e.preventDefault(), e.stopPropagation(), a.closePopover());
              break;
          }
      }
      function m(e) {
        l.value || (e.key === gm.Space && e.preventDefault());
      }
      function h(t) {
        var n, r;
        e.disabled ||
          (l.value
            ? (a.closePopover(), (n = Fp(a.button)) == null || n.focus())
            : (t.preventDefault(),
              t.stopPropagation(),
              a.popoverState.value === 1 && s?.(a.buttonId.value),
              a.togglePopover(),
              (r = Fp(a.button)) == null || r.focus()));
      }
      function g(e) {
        (e.preventDefault(), e.stopPropagation());
      }
      let v = xm();
      function y() {
        let e = Fp(a.panel);
        if (!e) return;
        function t() {
          Ip(v.value, {
            [bm.Forwards]: () => Yp(e, Vp.First),
            [bm.Backwards]: () => Yp(e, Vp.Last),
          }) === Hp.Error &&
            Yp(
              Up().filter((e) => e.dataset.headlessuiFocusGuard !== `true`),
              Ip(v.value, {
                [bm.Forwards]: Vp.Next,
                [bm.Backwards]: Vp.Previous,
              }),
              {
                relativeTo: Fp(a.button),
              },
            );
        }
        t();
      }
      return () => {
        let r = a.popoverState.value === 0,
          o = {
            open: r,
          },
          { ...s } = e;
        return Ne(ke, [
          am({
            ourProps: l.value
              ? {
                  ref: u,
                  type: f.value,
                  onKeydown: p,
                  onClick: h,
                }
              : {
                  ref: u,
                  id: i,
                  type: f.value,
                  "aria-expanded": a.popoverState.value === 0,
                  "aria-controls": Fp(a.panel) ? a.panelId.value : void 0,
                  disabled: e.disabled ? !0 : void 0,
                  onKeydown: p,
                  onKeyup: m,
                  onClick: h,
                  onMousedown: g,
                },
            theirProps: {
              ...t,
              ...s,
            },
            slot: o,
            attrs: t,
            slots: n,
            name: `PopoverButton`,
          }),
          r &&
            !l.value &&
            a.isPortalled.value &&
            Ne(dm, {
              id: d,
              features: um.Focusable,
              "data-headlessui-focus-guard": !0,
              as: `button`,
              type: `button`,
              onFocus: y,
            }),
        ]);
      };
    },
  });
k({
  name: `PopoverOverlay`,
  props: {
    as: {
      type: [Object, String],
      default: `div`,
    },
    static: {
      type: Boolean,
      default: !1,
    },
    unmount: {
      type: Boolean,
      default: !0,
    },
  },
  setup(e, { attrs: t, slots: n }) {
    let r = th(`PopoverOverlay`),
      i = `headlessui-popover-overlay-${Pp()}`,
      a = mm(),
      o = V(() => (a === null ? r.popoverState.value === 0 : (a.value & pm.Open) === pm.Open));
    function s() {
      r.closePopover();
    }
    return () => {
      let a = {
        open: r.popoverState.value === 0,
      };
      return am({
        ourProps: {
          id: i,
          "aria-hidden": !0,
          onClick: s,
        },
        theirProps: e,
        slot: a,
        attrs: t,
        slots: n,
        features: rm.RenderStrategy | rm.Static,
        visible: o.value,
        name: `PopoverOverlay`,
      });
    };
  },
});
var Bre = k({
  name: `PopoverPanel`,
  props: {
    as: {
      type: [Object, String],
      default: `div`,
    },
    static: {
      type: Boolean,
      default: !1,
    },
    unmount: {
      type: Boolean,
      default: !0,
    },
    focus: {
      type: Boolean,
      default: !1,
    },
    id: {
      type: String,
      default: null,
    },
  },
  inheritAttrs: !1,
  setup(e, { attrs: t, slots: n, expose: r }) {
    let i = e.id ?? `headlessui-popover-panel-${Pp()}`,
      { focus: a } = e,
      o = th(`PopoverPanel`),
      s = V(() => zp(o.panel)),
      c = `headlessui-focus-sentinel-before-${Pp()}`,
      l = `headlessui-focus-sentinel-after-${Pp()}`;
    (r({
      el: o.panel,
      $el: o.panel,
    }),
      Qe(() => {
        o.panelId.value = i;
      }),
      E(() => {
        o.panelId.value = null;
      }),
      ge(ih, o.panelId),
      Me(() => {
        var e;
        if (!a || o.popoverState.value !== 0 || !o.panel) return;
        let t = s.value?.activeElement;
        ((e = Fp(o.panel)) != null && e.contains(t)) || Yp(Fp(o.panel), Vp.First);
      }));
    let u = mm(),
      d = V(() => (u === null ? o.popoverState.value === 0 : (u.value & pm.Open) === pm.Open));
    function f(e) {
      var t, n;
      switch (e.key) {
        case gm.Escape:
          if (
            o.popoverState.value !== 0 ||
            !Fp(o.panel) ||
            (s.value && !((t = Fp(o.panel)) != null && t.contains(s.value.activeElement)))
          )
            return;
          (e.preventDefault(),
            e.stopPropagation(),
            o.closePopover(),
            (n = Fp(o.button)) == null || n.focus());
          break;
      }
    }
    function p(e) {
      var t, n, r, i, a;
      let s = e.relatedTarget;
      s &&
        Fp(o.panel) &&
        (((t = Fp(o.panel)) != null && t.contains(s)) ||
          (o.closePopover(),
          (((r = (n = Fp(o.beforePanelSentinel))?.contains) != null && r.call(n, s)) ||
            ((a = (i = Fp(o.afterPanelSentinel))?.contains) != null && a.call(i, s))) &&
            s.focus({
              preventScroll: !0,
            })));
    }
    let m = xm();
    function h() {
      let e = Fp(o.panel);
      if (!e) return;
      function t() {
        Ip(m.value, {
          [bm.Forwards]: () => {
            var t;
            Yp(e, Vp.First) === Hp.Error && ((t = Fp(o.afterPanelSentinel)) == null || t.focus());
          },
          [bm.Backwards]: () => {
            var e;
            (e = Fp(o.button)) == null ||
              e.focus({
                preventScroll: !0,
              });
          },
        });
      }
      t();
    }
    function g() {
      let e = Fp(o.panel);
      if (!e) return;
      function t() {
        Ip(m.value, {
          [bm.Forwards]: () => {
            let e = Fp(o.button),
              t = Fp(o.panel);
            if (!e) return;
            let n = Up(),
              r = n.indexOf(e),
              i = n.slice(0, r + 1),
              a = [...n.slice(r + 1), ...i];
            for (let e of a.slice())
              if (e.dataset.headlessuiFocusGuard === `true` || (t != null && t.contains(e))) {
                let t = a.indexOf(e);
                t !== -1 && a.splice(t, 1);
              }
            Yp(a, Vp.First, {
              sorted: !1,
            });
          },
          [bm.Backwards]: () => {
            var t;
            Yp(e, Vp.Previous) === Hp.Error && ((t = Fp(o.button)) == null || t.focus());
          },
        });
      }
      t();
    }
    return () => {
      let r = {
          open: o.popoverState.value === 0,
          close: o.close,
        },
        { focus: s, ...u } = e;
      return am({
        ourProps: {
          ref: o.panel,
          id: i,
          onKeydown: f,
          onFocusout: a && o.popoverState.value === 0 ? p : void 0,
          tabIndex: -1,
        },
        theirProps: {
          ...t,
          ...u,
        },
        attrs: t,
        slot: r,
        slots: {
          ...n,
          default: (...e) => [
            Ne(ke, [
              d.value &&
                o.isPortalled.value &&
                Ne(dm, {
                  id: c,
                  ref: o.beforePanelSentinel,
                  features: um.Focusable,
                  "data-headlessui-focus-guard": !0,
                  as: `button`,
                  type: `button`,
                  onFocus: h,
                }),
              n.default?.call(n, ...e),
              d.value &&
                o.isPortalled.value &&
                Ne(dm, {
                  id: l,
                  ref: o.afterPanelSentinel,
                  features: um.Focusable,
                  "data-headlessui-focus-guard": !0,
                  as: `button`,
                  type: `button`,
                  onFocus: g,
                }),
            ]),
          ],
        },
        features: rm.RenderStrategy | rm.Static,
        visible: d.value,
        name: `PopoverPanel`,
      });
    };
  },
});
(k({
  name: `PopoverGroup`,
  inheritAttrs: !1,
  props: {
    as: {
      type: [Object, String],
      default: `div`,
    },
  },
  setup(e, { attrs: t, slots: n, expose: r }) {
    let i = F(null),
      a = xe([]),
      o = V(() => zp(i)),
      s = bre();
    r({
      el: i,
      $el: i,
    });
    function c(e) {
      let t = a.value.indexOf(e);
      t !== -1 && a.value.splice(t, 1);
    }
    function l(e) {
      return (
        a.value.push(e),
        () => {
          c(e);
        }
      );
    }
    function u() {
      var e;
      let t = o.value;
      if (!t) return !1;
      let n = t.activeElement;
      return (e = Fp(i)) != null && e.contains(n)
        ? !0
        : a.value.some(
            (e) =>
              t.getElementById(e.buttonId.value)?.contains(n) ||
              t.getElementById(e.panelId.value)?.contains(n),
          );
    }
    function d(e) {
      for (let t of a.value) t.buttonId.value !== e && t.close();
    }
    return (
      ge(nh, {
        registerPopover: l,
        unregisterPopover: c,
        isFocusWithinPopoverGroup: u,
        closeOthers: d,
        mainTreeNodeRef: s.mainTreeNodeRef,
      }),
      () =>
        Ne(ke, [
          am({
            ourProps: {
              ref: i,
            },
            theirProps: {
              ...e,
              ...t,
            },
            slot: {},
            attrs: t,
            slots: n,
            name: `PopoverGroup`,
          }),
          Ne(s.MainTreeNode),
        ])
    );
  },
}),
  B());
var oh = Symbol(`LabelContext`);
function sh() {
  let e = R(oh, null);
  if (e === null) {
    let e = Error(`You used a <Label /> component, but it is not inside a parent.`);
    throw (Error.captureStackTrace && Error.captureStackTrace(e, sh), e);
  }
  return e;
}
function Vre({ slot: e = {}, name: t = `Label`, props: n = {} } = {}) {
  let r = F([]);
  function i(e) {
    return (
      r.value.push(e),
      () => {
        let t = r.value.indexOf(e);
        t !== -1 && r.value.splice(t, 1);
      }
    );
  }
  return (
    ge(oh, {
      register: i,
      slot: e,
      name: t,
      props: n,
    }),
    V(() => (r.value.length > 0 ? r.value.join(` `) : void 0))
  );
}
var Hre = k({
  name: `Label`,
  props: {
    as: {
      type: [Object, String],
      default: `label`,
    },
    passive: {
      type: [Boolean],
      default: !1,
    },
    id: {
      type: String,
      default: null,
    },
  },
  setup(e, { slots: t, attrs: n }) {
    let r = e.id ?? `headlessui-label-${Pp()}`,
      i = sh();
    return (
      Qe(() => E(i.register(r))),
      () => {
        let { name: a = `Label`, slot: o = {}, props: s = {} } = i,
          { passive: c, ...l } = e,
          u = {
            ...Object.entries(s).reduce(
              (e, [t, n]) =>
                Object.assign(e, {
                  [t]: P(n),
                }),
              {},
            ),
            id: r,
          };
        return (
          c && (delete u.onClick, delete u.htmlFor, delete l.onClick),
          am({
            ourProps: u,
            theirProps: l,
            slot: o,
            attrs: n,
            slots: t,
            name: a,
          })
        );
      }
    );
  },
});
B();
var ch = Symbol(`GroupContext`),
  Ure = k({
    name: `SwitchGroup`,
    props: {
      as: {
        type: [Object, String],
        default: `template`,
      },
    },
    setup(e, { slots: t, attrs: n }) {
      let r = F(null);
      return (
        ge(ch, {
          switchRef: r,
          labelledby: Vre({
            name: `SwitchLabel`,
            props: {
              htmlFor: V(() => r.value?.id),
              onClick(e) {
                r.value &&
                  (e.currentTarget.tagName === `LABEL` && e.preventDefault(),
                  r.value.click(),
                  r.value.focus({
                    preventScroll: !0,
                  }));
              },
            },
          }),
          describedby: Im({
            name: `SwitchDescription`,
          }),
        }),
        () =>
          am({
            theirProps: e,
            ourProps: {},
            slot: {},
            slots: t,
            attrs: n,
            name: `SwitchGroup`,
          })
      );
    },
  }),
  Wre = k({
    name: `Switch`,
    emits: {
      "update:modelValue": (e) => !0,
    },
    props: {
      as: {
        type: [Object, String],
        default: `button`,
      },
      modelValue: {
        type: Boolean,
        default: void 0,
      },
      defaultChecked: {
        type: Boolean,
        optional: !0,
      },
      form: {
        type: String,
        optional: !0,
      },
      name: {
        type: String,
        optional: !0,
      },
      value: {
        type: String,
        optional: !0,
      },
      id: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: !1,
      },
      tabIndex: {
        type: Number,
        default: 0,
      },
    },
    inheritAttrs: !1,
    setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
      let a = e.id ?? `headlessui-switch-${Pp()}`,
        o = R(ch, null),
        [s, c] = Hne(
          V(() => e.modelValue),
          (e) => t(`update:modelValue`, e),
          V(() => e.defaultChecked),
        );
      function l() {
        c(!s.value);
      }
      let u = F(null),
        d = o === null ? u : o.switchRef,
        f = tm(
          V(() => ({
            as: e.as,
            type: n.type,
          })),
          d,
        );
      i({
        el: d,
        $el: d,
      });
      function p(e) {
        (e.preventDefault(), l());
      }
      function m(e) {
        e.key === gm.Space ? (e.preventDefault(), l()) : e.key === gm.Enter && cre(e.currentTarget);
      }
      function h(e) {
        e.preventDefault();
      }
      let g = V(() => {
        var e;
        return (e = Fp(d))?.closest?.call(e, `form`);
      });
      return (
        Qe(() => {
          He(
            [g],
            () => {
              if (!g.value || e.defaultChecked === void 0) return;
              function t() {
                c(e.defaultChecked);
              }
              return (
                g.value.addEventListener(`reset`, t),
                () => {
                  var e;
                  (e = g.value) == null || e.removeEventListener(`reset`, t);
                }
              );
            },
            {
              immediate: !0,
            },
          );
        }),
        () => {
          let { name: t, value: i, form: c, tabIndex: l, ...u } = e,
            g = {
              checked: s.value,
            },
            v = {
              id: a,
              ref: d,
              role: `switch`,
              type: f.value,
              tabIndex: l === -1 ? 0 : l,
              "aria-checked": s.value,
              "aria-labelledby": o?.labelledby.value,
              "aria-describedby": o?.describedby.value,
              onClick: p,
              onKeyup: m,
              onKeypress: h,
            };
          return Ne(ke, [
            t != null && s.value != null
              ? Ne(
                  dm,
                  nre({
                    features: um.Hidden,
                    as: `input`,
                    type: `checkbox`,
                    hidden: !0,
                    readOnly: !0,
                    checked: s.value,
                    form: c,
                    disabled: u.disabled,
                    name: t,
                    value: i,
                  }),
                )
              : null,
            am({
              ourProps: v,
              theirProps: {
                ...n,
                ...lm(u, [`modelValue`, `defaultChecked`]),
              },
              slot: g,
              attrs: n,
              slots: r,
              name: `Switch`,
            }),
          ]);
        }
      );
    },
  }),
  lh = Hre,
  Gre = Tre;
function Kre(e) {
  let t = {
    called: !1,
  };
  return (...n) => {
    if (!t.called) return ((t.called = !0), e(...n));
  };
}
function uh(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function dh(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var fh = ((e) => ((e.Finished = `finished`), (e.Cancelled = `cancelled`), e))(fh || {});
function qre(e, t) {
  let n = Np();
  if (!e) return n.dispose;
  let { transitionDuration: r, transitionDelay: i } = getComputedStyle(e),
    [a, o] = [r, i].map((e) => {
      let [t = 0] = e
        .split(`,`)
        .filter(Boolean)
        .map((e) => (e.includes(`ms`) ? parseFloat(e) : parseFloat(e) * 1e3))
        .sort((e, t) => t - e);
      return t;
    });
  return (
    a === 0 ? t(`finished`) : n.setTimeout(() => t(`finished`), a + o),
    n.add(() => t(`cancelled`)),
    n.dispose
  );
}
function ph(e, t, n, r, i, a) {
  let o = Np(),
    s = a === void 0 ? () => {} : Kre(a);
  return (
    dh(e, ...i),
    uh(e, ...t, ...n),
    o.nextFrame(() => {
      (dh(e, ...n), uh(e, ...r), o.add(qre(e, (n) => (dh(e, ...r, ...t), uh(e, ...i), s(n)))));
    }),
    o.add(() => dh(e, ...t, ...n, ...r, ...i)),
    o.add(() => s(`cancelled`)),
    o.dispose
  );
}
B();
function mh(e = ``) {
  return e.split(/\s+/).filter((e) => e.length > 1);
}
var hh = Symbol(`TransitionContext`),
  Jre = ((e) => ((e.Visible = `visible`), (e.Hidden = `hidden`), e))(Jre || {});
function Yre() {
  return R(hh, null) !== null;
}
function Xre() {
  let e = R(hh, null);
  if (e === null)
    throw Error(`A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.`);
  return e;
}
function Zre() {
  let e = R(gh, null);
  if (e === null)
    throw Error(`A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.`);
  return e;
}
var gh = Symbol(`NestingContext`);
function _h(e) {
  return `children` in e
    ? _h(e.children)
    : e.value.filter(({ state: e }) => e === `visible`).length > 0;
}
function vh(e) {
  let t = F([]),
    n = F(!1);
  (Qe(() => (n.value = !0)), E(() => (n.value = !1)));
  function r(r, i = im.Hidden) {
    let a = t.value.findIndex(({ id: e }) => e === r);
    a !== -1 &&
      (Ip(i, {
        [im.Unmount]() {
          t.value.splice(a, 1);
        },
        [im.Hidden]() {
          t.value[a].state = `hidden`;
        },
      }),
      !_h(t) && n.value && e?.());
  }
  function i(e) {
    let n = t.value.find(({ id: t }) => t === e);
    return (
      n
        ? n.state !== `visible` && (n.state = `visible`)
        : t.value.push({
            id: e,
            state: `visible`,
          }),
      () => r(e, im.Unmount)
    );
  }
  return {
    children: t,
    register: i,
    unregister: r,
  };
}
var yh = rm.RenderStrategy,
  bh = k({
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
      show: {
        type: [Boolean],
        default: null,
      },
      unmount: {
        type: [Boolean],
        default: !0,
      },
      appear: {
        type: [Boolean],
        default: !1,
      },
      enter: {
        type: [String],
        default: ``,
      },
      enterFrom: {
        type: [String],
        default: ``,
      },
      enterTo: {
        type: [String],
        default: ``,
      },
      entered: {
        type: [String],
        default: ``,
      },
      leave: {
        type: [String],
        default: ``,
      },
      leaveFrom: {
        type: [String],
        default: ``,
      },
      leaveTo: {
        type: [String],
        default: ``,
      },
    },
    emits: {
      beforeEnter: () => !0,
      afterEnter: () => !0,
      beforeLeave: () => !0,
      afterLeave: () => !0,
    },
    setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
      let a = F(0);
      function o() {
        ((a.value |= pm.Opening), t(`beforeEnter`));
      }
      function s() {
        ((a.value &= ~pm.Opening), t(`afterEnter`));
      }
      function c() {
        ((a.value |= pm.Closing), t(`beforeLeave`));
      }
      function l() {
        ((a.value &= ~pm.Closing), t(`afterLeave`));
      }
      if (!Yre() && ire())
        return () =>
          Ne(
            xh,
            {
              ...e,
              onBeforeEnter: o,
              onAfterEnter: s,
              onBeforeLeave: c,
              onAfterLeave: l,
            },
            r,
          );
      let u = F(null),
        d = V(() => (e.unmount ? im.Unmount : im.Hidden));
      i({
        el: u,
        $el: u,
      });
      let { show: f, appear: p } = Xre(),
        { register: m, unregister: h } = Zre(),
        g = F(f.value ? `visible` : `hidden`),
        v = {
          value: !0,
        },
        y = Pp(),
        b = {
          value: !1,
        },
        x = vh(() => {
          !b.value && g.value !== `hidden` && ((g.value = `hidden`), h(y), l());
        });
      (Qe(() => {
        E(m(y));
      }),
        Me(() => {
          if (d.value === im.Hidden && y) {
            if (f.value && g.value !== `visible`) {
              g.value = `visible`;
              return;
            }
            Ip(g.value, {
              hidden: () => h(y),
              visible: () => m(y),
            });
          }
        }));
      let S = mh(e.enter),
        C = mh(e.enterFrom),
        w = mh(e.enterTo),
        T = mh(e.entered),
        D = mh(e.leave),
        ee = mh(e.leaveFrom),
        te = mh(e.leaveTo);
      Qe(() => {
        Me(() => {
          if (g.value === `visible`) {
            let e = Fp(u);
            if (e instanceof Comment && e.data === ``)
              throw Error("Did you forget to passthrough the `ref` to the actual DOM node?");
          }
        });
      });
      function k(e) {
        let t = v.value && !p.value,
          n = Fp(u);
        !n ||
          !(n instanceof HTMLElement) ||
          t ||
          ((b.value = !0),
          f.value && o(),
          f.value || c(),
          e(
            f.value
              ? ph(n, S, C, w, T, (e) => {
                  ((b.value = !1), e === fh.Finished && s());
                })
              : ph(n, D, ee, te, T, (e) => {
                  ((b.value = !1),
                    e === fh.Finished && (_h(x) || ((g.value = `hidden`), h(y), l())));
                }),
          ));
      }
      return (
        Qe(() => {
          He(
            [f],
            (e, t, n) => {
              (k(n), (v.value = !1));
            },
            {
              immediate: !0,
            },
          );
        }),
        ge(gh, x),
        hm(
          V(
            () =>
              Ip(g.value, {
                visible: pm.Open,
                hidden: pm.Closed,
              }) | a.value,
          ),
        ),
        () => {
          let {
              appear: t,
              show: i,
              enter: a,
              enterFrom: o,
              enterTo: s,
              entered: c,
              leave: l,
              leaveFrom: d,
              leaveTo: m,
              ...h
            } = e,
            v = {
              ref: u,
            };
          return am({
            theirProps: {
              ...h,
              ...(p.value && f.value && Rp.isServer
                ? {
                    class: O([n.class, h.class, ...S, ...C]),
                  }
                : {}),
            },
            ourProps: v,
            slot: {},
            slots: r,
            attrs: n,
            features: yh,
            visible: g.value === `visible`,
            name: `TransitionChild`,
          });
        }
      );
    },
  }),
  Qre = bh,
  xh = k({
    inheritAttrs: !1,
    props: {
      as: {
        type: [Object, String],
        default: `div`,
      },
      show: {
        type: [Boolean],
        default: null,
      },
      unmount: {
        type: [Boolean],
        default: !0,
      },
      appear: {
        type: [Boolean],
        default: !1,
      },
      enter: {
        type: [String],
        default: ``,
      },
      enterFrom: {
        type: [String],
        default: ``,
      },
      enterTo: {
        type: [String],
        default: ``,
      },
      entered: {
        type: [String],
        default: ``,
      },
      leave: {
        type: [String],
        default: ``,
      },
      leaveFrom: {
        type: [String],
        default: ``,
      },
      leaveTo: {
        type: [String],
        default: ``,
      },
    },
    emits: {
      beforeEnter: () => !0,
      afterEnter: () => !0,
      beforeLeave: () => !0,
      afterLeave: () => !0,
    },
    setup(e, { emit: t, attrs: n, slots: r }) {
      let i = mm(),
        a = V(() => (e.show === null && i !== null ? (i.value & pm.Open) === pm.Open : e.show));
      Me(() => {
        if (![!0, !1].includes(a.value))
          throw Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
      });
      let o = F(a.value ? `visible` : `hidden`),
        s = vh(() => {
          o.value = `hidden`;
        }),
        c = F(!0),
        l = {
          show: a,
          appear: V(() => e.appear || !c.value),
        };
      return (
        Qe(() => {
          Me(() => {
            ((c.value = !1), a.value ? (o.value = `visible`) : _h(s) || (o.value = `hidden`));
          });
        }),
        ge(gh, s),
        ge(hh, l),
        () => {
          let i = lm(e, [
              `show`,
              `appear`,
              `unmount`,
              `onBeforeEnter`,
              `onBeforeLeave`,
              `onAfterEnter`,
              `onAfterLeave`,
            ]),
            a = {
              unmount: e.unmount,
            };
          return am({
            ourProps: {
              ...a,
              as: `template`,
            },
            theirProps: {},
            slot: {},
            slots: {
              ...r,
              default: () => [
                Ne(
                  Qre,
                  {
                    onBeforeEnter: () => t(`beforeEnter`),
                    onAfterEnter: () => t(`afterEnter`),
                    onBeforeLeave: () => t(`beforeLeave`),
                    onAfterLeave: () => t(`afterLeave`),
                    ...n,
                    ...a,
                    ...i,
                  },
                  r.default,
                ),
              ],
            },
            attrs: {},
            features: yh,
            visible: o.value === `visible`,
            name: `Transition`,
          });
        }
      );
    },
  }),
  $re = i({
    default: () => nie,
  });
B();
var eie = {
    key: 0,
    class: `flex flex-col`,
  },
  tie = {
    key: 1,
    class: `flex flex-col`,
  },
  nie = Object.assign(
    {},
    {
      __name: `BaseSwitch`,
      props: {
        name: {
          type: String,
          default: ``,
          required: !0,
        },
        label: {
          type: String,
          default: ``,
        },
        description: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [Boolean, String, Number],
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
        reverse: {
          type: Boolean,
          default: !1,
        },
        vertical: {
          type: Boolean,
          default: !1,
        },
        topMargin: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:error`, `change`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = Ae({
            uniqueId: ``,
            input: r.modelValue,
          }),
          a = (e) => {
            (n(`update:modelValue`, jp(i.input)), n(`change`, jp(i.input)), n(`update:error`, ``));
          };
        return (
          He(
            () => r.modelValue,
            (e) => {
              i.input = jp(e);
            },
          ),
          Qe(() => {
            i.uniqueId = r.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`FormError`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  N(
                    P(Ure),
                    {
                      as: `div`,
                      class: O([
                        ``,
                        {
                          "flex items-center": !e.vertical,
                          "mt-8": e.topMargin,
                          "gap-4": e.reverse,
                          "justify-between": !e.reverse,
                        },
                      ]),
                    },
                    {
                      default: I(() => [
                        e.reverse
                          ? U(``, !0)
                          : (A(),
                            M(`span`, eie, [
                              N(
                                P(lh),
                                {
                                  as: `span`,
                                  class: `text-sm font-medium text-gray-900 dark:text-gray-400`,
                                  passive: ``,
                                },
                                {
                                  default: I(() => [H(T(e.label), 1)]),
                                  _: 1,
                                },
                              ),
                              e.description
                                ? (A(),
                                  L(
                                    P(Gre),
                                    {
                                      key: 0,
                                      as: `span`,
                                      class: `text-sm text-gray-500`,
                                    },
                                    {
                                      default: I(() => [H(T(e.description), 1)]),
                                      _: 1,
                                    },
                                  ))
                                : U(``, !0),
                            ])),
                        N(
                          P(Wre),
                          {
                            as: `span`,
                            modelValue: i.input,
                            "onUpdate:modelValue": [(n[0] ||= (e) => (i.input = e)), a],
                            name: e.name,
                            class: O([
                              P(jp)(i.input)
                                ? `bg-primary dark:bg-dark-body dark:border-gray-700`
                                : `dark:border-dark-body bg-gray-200 dark:bg-gray-700`,
                              e.vertical ? `mt-4` : ``,
                              `relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none`,
                            ]),
                          },
                          {
                            default: I(() => [
                              W(
                                `span`,
                                {
                                  "aria-hidden": `true`,
                                  class: O([
                                    P(jp)(i.input)
                                      ? `ltr:translate-x-5 rtl:-translate-x-5`
                                      : `translate-x-0`,
                                    `pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`,
                                  ]),
                                },
                                null,
                                2,
                              ),
                            ]),
                            _: 1,
                          },
                          8,
                          [`modelValue`, `name`, `class`],
                        ),
                        e.reverse
                          ? (A(),
                            M(`span`, tie, [
                              N(
                                P(lh),
                                {
                                  as: `span`,
                                  class: `text-sm font-medium text-gray-900 dark:text-gray-400`,
                                  passive: ``,
                                },
                                {
                                  default: I(() => [H(T(e.label), 1)]),
                                  _: 1,
                                },
                              ),
                            ]))
                          : U(``, !0),
                      ]),
                      _: 1,
                    },
                    8,
                    [`class`],
                  ),
                  N(
                    r,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  rie = i({
    default: () => lie,
  });
B();
var iie = {
    key: 0,
    class: `ml-2`,
  },
  aie = {
    class: `flex items-start gap-2`,
  },
  oie = {
    key: 0,
    class: `pt-2 text-right text-xs leading-5 text-gray-400 select-none dark:text-gray-500`,
  },
  sie = [`id`, `placeholder`, `rows`, `value`],
  cie = {
    key: 1,
    class: `mt-1 text-xs text-gray-500 dark:text-gray-400`,
  },
  lie = Object.assign(
    {
      name: `BaseTextarea`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        rows: {
          type: Number,
          default: 3,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        placeholder: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [String, Number],
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
        invisible: {
          type: Boolean,
          default: !1,
        },
        showCharCount: {
          type: Boolean,
          default: !1,
        },
        showLineNumbers: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:error`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = F(null),
          a = Ae({
            uniqueId: ``,
          }),
          o = V(() => String(r.modelValue).length),
          s = V(() => {
            let e = Math.max(
              1,
              String(r.modelValue ?? ``).split(`
`).length,
            );
            return Array.from(
              {
                length: e,
              },
              (e, t) => t + 1,
            );
          }),
          c = (e) => {
            (l(), n(`update:modelValue`, e.target.value), n(`update:error`, ``));
          },
          l = () => {
            i.value &&
              ((i.value.style.height = `20px`),
              (i.value.style.height = i.value.scrollHeight + `px`));
          };
        return (
          Qe(() => {
            ((a.uniqueId = r.id || Math.random().toString(16).slice(2)), de(l));
          }),
          He(
            () => r.modelValue,
            () => de(l),
          ),
          (t, n) => {
            let r = j(`BaseLabel`),
              l = j(`FormError`),
              u = ve(`tooltip`);
            return (
              A(),
              M(`div`, null, [
                e.label
                  ? (A(),
                    L(
                      r,
                      {
                        key: 0,
                        for: a.uniqueId,
                      },
                      {
                        default: I(() => [
                          H(T(e.label) + ` `, 1),
                          e.labelHint
                            ? Re(
                                (A(),
                                M(`span`, iie, [
                                  ...(n[0] ||= [
                                    W(
                                      `i`,
                                      {
                                        class: `fas fa-question-circle`,
                                      },
                                      null,
                                      -1,
                                    ),
                                  ]),
                                ])),
                                [[u, e.labelHint]],
                              )
                            : U(``, !0),
                        ]),
                        _: 1,
                      },
                      8,
                      [`for`],
                    ))
                  : U(``, !0),
                W(
                  `div`,
                  {
                    class: O({
                      "mt-1": e.label,
                    }),
                  },
                  [
                    W(`div`, aie, [
                      e.showLineNumbers
                        ? (A(),
                          M(`div`, oie, [
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                s.value,
                                (e) => (
                                  A(),
                                  M(
                                    `div`,
                                    {
                                      key: `line-${e}`,
                                    },
                                    T(e),
                                    1,
                                  )
                                ),
                              ),
                              128,
                            )),
                          ]))
                        : U(``, !0),
                      W(
                        `textarea`,
                        ce(
                          {
                            ref_key: `textarea`,
                            ref: i,
                            id: a.uniqueId,
                          },
                          t.$attrs,
                          {
                            placeholder: e.placeholder || e.label,
                            rows: e.rows,
                            class: [
                              `focus:border-primary block w-full border-0 border-gray-300 bg-inherit pt-2 text-sm leading-5 shadow-xs focus:ring-0 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-200 dark:focus:ring-gray-700`,
                              {
                                "border-b-2": !e.invisible,
                              },
                            ],
                            onInput: c,
                            value: e.modelValue,
                          },
                        ),
                        null,
                        16,
                        sie,
                      ),
                    ]),
                  ],
                  2,
                ),
                e.showCharCount ? (A(), M(`div`, cie, T(o.value) + ` characters `, 1)) : U(``, !0),
                N(
                  l,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ])
            );
          }
        );
      },
    },
  ),
  uie = i({
    default: () => Dh,
  });
B();
var die = {
    key: 0,
    class: `ml-2`,
  },
  fie = {
    key: 1,
    class: `mb-1 flex space-x-2`,
  },
  pie = [`disabled`],
  mie = [`disabled`],
  hie = {
    class: `mt-1 flex flex-wrap gap-2`,
  },
  gie = [`onClick`],
  Sh = {
    class: `flex h-full items-center justify-between align-middle`,
  },
  Ch = {
    class: `break-words`,
  },
  wh = {
    key: 0,
  },
  Th = {
    key: 1,
  },
  Eh = {
    key: 0,
    class: `ml-1`,
  },
  Dh = Object.assign(
    {
      name: `CustomCheckbox`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [String, Number, Array],
          default: ``,
        },
        size: {
          type: String,
          default: `sm`,
        },
        limit: {
          type: Number,
          default: -1,
        },
        error: {
          type: String,
          default: ``,
        },
        options: {
          type: Array,
          default: [],
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
        design: {
          type: String,
          validator(e) {
            return [
              `primary`,
              `secondary`,
              `info`,
              `success`,
              `warning`,
              `danger`,
              `error`,
              `custom`,
            ].includes(e);
          },
          default: `primary`,
        },
        color: {
          type: String,
          default: ``,
        },
        clearable: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:error`, `changed`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = R(`$trans`),
          a = Ae({
            uniqueId: ``,
          }),
          o = (e) => (Array.isArray(r.modelValue) ? r.modelValue.includes(e) : r.modelValue == e),
          s = (e) => {
            if (!r.disabled) {
              if (Array.isArray(r.modelValue)) {
                let t = [...r.modelValue];
                if (r.modelValue.includes(e)) {
                  if (!r.clearable) {
                    n(`update:error`, ``);
                    return;
                  }
                  t = t.filter((t) => t != e);
                } else {
                  if (r.limit > 0 && t.length >= r.limit) {
                    n(
                      `update:error`,
                      i(`global.max_select_limit`, {
                        max: r.limit,
                      }),
                    );
                    return;
                  }
                  t.push(e);
                }
                (n(`update:modelValue`, t), n(`changed`, t));
              } else {
                let t = r.modelValue == e && r.clearable ? `` : e;
                (n(`update:modelValue`, t), n(`changed`, t));
              }
              n(`update:error`, ``);
            }
          },
          c = V(
            () =>
              Array.isArray(r.modelValue) &&
              (r.limit > 1 || r.limit === -1) &&
              r.options.length > 1,
          ),
          l = () => {
            if (r.disabled) return;
            let e = r.options.map((e) => e.value);
            r.limit > 1
              ? (n(`update:modelValue`, e.slice(0, r.limit)),
                e.length > r.limit
                  ? n(
                      `update:error`,
                      i(`global.max_select_limit`, {
                        max: r.limit,
                      }),
                    )
                  : n(`update:error`, ``))
              : (n(`update:modelValue`, e), n(`update:error`, ``));
          },
          u = () => {
            r.disabled || (n(`update:modelValue`, []), n(`update:error`, ``));
          };
        return (
          Qe(() => {
            a.uniqueId = r.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`BaseLabel`),
              d = j(`FormError`),
              f = ve(`tooltip`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  e.label
                    ? (A(),
                      L(
                        r,
                        {
                          key: 0,
                          for: a.uniqueId,
                        },
                        {
                          default: I(() => [
                            H(T(e.label) + ` `, 1),
                            e.labelHint
                              ? Re(
                                  (A(),
                                  M(`span`, die, [
                                    ...(n[0] ||= [
                                      W(
                                        `i`,
                                        {
                                          class: `fas fa-question-circle`,
                                        },
                                        null,
                                        -1,
                                      ),
                                    ]),
                                  ])),
                                  [[f, e.labelHint]],
                                )
                              : U(``, !0),
                          ]),
                          _: 1,
                        },
                        8,
                        [`for`],
                      ))
                    : U(``, !0),
                  c.value
                    ? (A(),
                      M(`div`, fie, [
                        W(
                          `span`,
                          {
                            class: `text-xs text-primary hover:text-primary-dark dark:text-site-primary cursor-pointer`,
                            onClick: l,
                            disabled: e.disabled,
                          },
                          T(P(i)(`general.select_all`)),
                          9,
                          pie,
                        ),
                        W(
                          `span`,
                          {
                            class: `text-xs text-primary hover:text-primary-dark dark:text-site-primary cursor-pointer`,
                            onClick: u,
                            disabled: e.disabled,
                          },
                          T(P(i)(`general.unselect_all`)),
                          9,
                          mie,
                        ),
                      ]))
                    : U(``, !0),
                  W(`div`, hie, [
                    (A(!0),
                    M(
                      ke,
                      null,
                      ae(
                        e.options,
                        (t) => (
                          A(),
                          M(
                            `div`,
                            {
                              class: O([
                                `cursor-pointer rounded-lg border-2`,
                                {
                                  "text-xs px-2 py-1": e.size == `xs`,
                                  "text-sm px-3 py-2": e.size == `sm`,
                                  "text-base px-4 py-3": e.size == `md`,
                                  "border-primary bg-primary text-white dark:border-site-primary dark:bg-site-primary":
                                    o(t.value) && e.design === `primary`,
                                  "border-secondary bg-secondary text-primary":
                                    o(t.value) && e.design === `secondary`,
                                  "border-success bg-success text-white":
                                    o(t.value) && e.design === `success`,
                                  "border-info bg-info text-white":
                                    o(t.value) && e.design === `info`,
                                  "border-warning bg-warning text-white":
                                    o(t.value) && e.design === `warning`,
                                  "border-danger bg-danger text-white":
                                    o(t.value) && e.design === `danger`,
                                  "border-primary dark:border-site-primary":
                                    !o(t.value) && e.design === `primary`,
                                  "border-secondary": !o(t.value) && e.design === `secondary`,
                                  "border-success": !o(t.value) && e.design === `success`,
                                  "border-info": !o(t.value) && e.design === `info`,
                                  "border-warning": !o(t.value) && e.design === `warning`,
                                  "border-danger": !o(t.value) && e.design === `danger`,
                                  "text-gray-800 dark:text-gray-400": !o(t.value),
                                },
                              ]),
                              style: Pe(
                                e.design === `custom` && e.color
                                  ? {
                                      borderColor: e.color,
                                      backgroundColor: o(t.value) ? e.color : `transparent`,
                                      color: o(t.value) ? `#fff` : `inherit`,
                                    }
                                  : {},
                              ),
                              onClick: (e) => s(t.value),
                            },
                            [
                              W(`div`, Sh, [
                                W(`div`, Ch, [
                                  t.icon
                                    ? (A(),
                                      M(`span`, wh, [
                                        W(
                                          `i`,
                                          {
                                            class: O([`mr-2`, t.icon]),
                                          },
                                          null,
                                          2,
                                        ),
                                      ]))
                                    : U(``, !0),
                                  H(` ` + T(t.label) + ` `, 1),
                                  t.detail
                                    ? (A(),
                                      M(`div`, Th, [
                                        W(
                                          `span`,
                                          {
                                            class: O([
                                              `text-xs`,
                                              {
                                                "text-gray-500 dark:text-gray-400": !o(t.value),
                                                "text-gray-300 dark:text-gray-200": o(t.value),
                                              },
                                            ]),
                                          },
                                          T(t.detail),
                                          3,
                                        ),
                                      ]))
                                    : U(``, !0),
                                ]),
                                o(t.value)
                                  ? (A(),
                                    M(`span`, Eh, [
                                      ...(n[1] ||= [
                                        W(
                                          `i`,
                                          {
                                            class: `fas fa-check-circle`,
                                          },
                                          null,
                                          -1,
                                        ),
                                      ]),
                                    ]))
                                  : U(``, !0),
                              ]),
                            ],
                            14,
                            gie,
                          )
                        ),
                      ),
                      256,
                    )),
                  ]),
                  N(
                    d,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  Oh = i({
    default: () => Nh,
  });
B();
var kh = {
    key: 0,
    class: `ltr:mr-2 rtl:ml-2`,
  },
  Ah = {
    key: 0,
    class: `origin-top-right absolute ltr:left-0 rtl:right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-10`,
  },
  jh = {
    class: `py-1`,
  },
  Mh = [`onClick`],
  Nh = {
    __name: `CustomDropdown`,
    props: {
      options: {
        type: Array,
        required: !0,
      },
      modelValue: {
        type: [String, Number, Object],
        default: null,
      },
      placeholder: {
        type: String,
        default: ``,
      },
      optionValue: {
        type: String,
        default: `value`,
      },
      optionLabel: {
        type: String,
        default: `label`,
      },
      optionIcon: {
        type: String,
        default: `icon`,
      },
    },
    emits: [`update:modelValue`],
    setup(e, { emit: t }) {
      let n = e,
        r = t,
        i = F(!1),
        a = F(null),
        o = `dropdown-` + Math.random().toString(36).substr(2, 9),
        s = V(() =>
          n.options.find((e) =>
            typeof n.modelValue == `object`
              ? e[n.optionValue] === n.modelValue[n.optionValue]
              : e[n.optionValue] === n.modelValue,
          ),
        );
      function c() {
        i.value = !i.value;
      }
      function l(e) {
        (r(`update:modelValue`, e[n.optionValue]), (i.value = !1));
      }
      function u(e) {
        a.value && !a.value.contains(e.target) && (i.value = !1);
      }
      return (
        Qe(() => {
          document.addEventListener(`mousedown`, u);
        }),
        oe(() => {
          document.removeEventListener(`mousedown`, u);
        }),
        (t, n) => (
          A(),
          M(
            `div`,
            {
              class: `relative inline-block text-left`,
              ref_key: `dropdownRef`,
              ref: a,
            },
            [
              W(
                `button`,
                {
                  onClick: c,
                  type: `button`,
                  class: `inline-flex justify-center items-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white dark:bg-gray-800 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 focus:outline-none`,
                  id: o,
                  "aria-haspopup": `true`,
                  "aria-expanded": `dropdownOpen`,
                },
                [
                  s.value && s.value.icon
                    ? (A(),
                      M(`span`, kh, [
                        W(
                          `i`,
                          {
                            class: O(s.value.icon),
                          },
                          null,
                          2,
                        ),
                      ]))
                    : U(``, !0),
                  H(` ` + T(s.value ? s.value.label : e.placeholder) + ` `, 1),
                  (n[0] ||= W(
                    `svg`,
                    {
                      class: `ltr:ml-2 rtl:mr-2 h-4 w-4`,
                      fill: `none`,
                      stroke: `currentColor`,
                      viewBox: `0 0 24 24`,
                    },
                    [
                      W(`path`, {
                        "stroke-linecap": `round`,
                        "stroke-linejoin": `round`,
                        "stroke-width": `2`,
                        d: `M19 9l-7 7-7-7`,
                      }),
                    ],
                    -1,
                  )),
                ],
              ),
              i.value
                ? (A(),
                  M(`div`, Ah, [
                    W(`div`, jh, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          e.options,
                          (e) => (
                            A(),
                            M(
                              `button`,
                              {
                                key: e.value,
                                onClick: (t) => l(e),
                                class: `w-full flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700`,
                              },
                              [
                                e.icon
                                  ? (A(),
                                    M(
                                      `i`,
                                      {
                                        key: 0,
                                        class: O(e.icon + ` ltr:mr-2 rtl:ml-2`),
                                      },
                                      null,
                                      2,
                                    ))
                                  : U(``, !0),
                                H(` ` + T(e.label), 1),
                              ],
                              8,
                              Mh,
                            )
                          ),
                        ),
                        128,
                      )),
                    ]),
                  ]))
                : U(``, !0),
            ],
            512,
          )
        )
      );
    },
  },
  Ph = function (e, t, n) {
    return n.months[t ? `shorthand` : `longhand`][e];
  };
function Fh(e) {
  for (; e.firstChild;) e.removeChild(e.firstChild);
}
function Ih(e) {
  try {
    return typeof e.composedPath == `function` ? e.composedPath()[0] : e.target;
  } catch {
    return e.target;
  }
}
var Lh = function () {
    return (
      (Lh =
        Object.assign ||
        function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++)
            for (var i in ((t = arguments[n]), t))
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }),
      Lh.apply(this, arguments)
    );
  },
  Rh = {
    shorthand: !1,
    dateFormat: `F Y`,
    altFormat: `F Y`,
    theme: `light`,
  };
function zh(e) {
  var t = Lh(Lh({}, Rh), e);
  return function (e) {
    ((e.config.dateFormat = t.dateFormat), (e.config.altFormat = t.altFormat));
    var n = {
      monthsContainer: null,
    };
    function r() {
      if (e.rContainer) {
        Fh(e.rContainer);
        for (var t = 0; t < e.monthElements.length; t++) {
          var n = e.monthElements[t];
          n.parentNode && n.parentNode.removeChild(n);
        }
      }
    }
    function i() {
      e.rContainer &&
        ((n.monthsContainer = e._createElement(`div`, `flatpickr-monthSelect-months`)),
        (n.monthsContainer.tabIndex = -1),
        a(),
        e.rContainer.appendChild(n.monthsContainer),
        e.calendarContainer.classList.add(`flatpickr-monthSelect-theme-` + t.theme));
    }
    function a() {
      if (n.monthsContainer) {
        Fh(n.monthsContainer);
        for (var r = document.createDocumentFragment(), i = 0; i < 12; i++) {
          var a = e.createDay(`flatpickr-monthSelect-month`, new Date(e.currentYear, i), 0, i);
          (a.dateObj.getMonth() === new Date().getMonth() &&
            a.dateObj.getFullYear() === new Date().getFullYear() &&
            a.classList.add(`today`),
            (a.textContent = Ph(i, t.shorthand, e.l10n)),
            a.addEventListener(`click`, l),
            r.appendChild(a));
        }
        (n.monthsContainer.appendChild(r),
          e.config.minDate && e.currentYear === e.config.minDate.getFullYear()
            ? e.prevMonthNav.classList.add(`flatpickr-disabled`)
            : e.prevMonthNav.classList.remove(`flatpickr-disabled`),
          e.config.maxDate && e.currentYear === e.config.maxDate.getFullYear()
            ? e.nextMonthNav.classList.add(`flatpickr-disabled`)
            : e.nextMonthNav.classList.remove(`flatpickr-disabled`));
      }
    }
    function o() {
      (e._bind(e.prevMonthNav, `click`, function (t) {
        (t.preventDefault(), t.stopPropagation(), e.changeYear(e.currentYear - 1), c(), a());
      }),
        e._bind(e.nextMonthNav, `click`, function (t) {
          (t.preventDefault(), t.stopPropagation(), e.changeYear(e.currentYear + 1), c(), a());
        }),
        e._bind(n.monthsContainer, `mouseover`, function (t) {
          e.config.mode === `range` && e.onMouseOver(Ih(t), `flatpickr-monthSelect-month`);
        }));
    }
    function s() {
      if (e.rContainer && e.selectedDates.length) {
        for (
          var t = e.rContainer.querySelectorAll(`.flatpickr-monthSelect-month.selected`), n = 0;
          n < t.length;
          n++
        )
          t[n].classList.remove(`selected`);
        var r = e.selectedDates[0].getMonth(),
          i = e.rContainer.querySelector(`.flatpickr-monthSelect-month:nth-child(` + (r + 1) + `)`);
        i && i.classList.add(`selected`);
      }
    }
    function c() {
      var t = e.selectedDates[0];
      (t &&
        ((t = new Date(t)),
        t.setFullYear(e.currentYear),
        e.config.minDate && t < e.config.minDate && (t = e.config.minDate),
        e.config.maxDate && t > e.config.maxDate && (t = e.config.maxDate),
        (e.currentYear = t.getFullYear())),
        (e.currentYearElement.value = String(e.currentYear)),
        e.rContainer &&
          e.rContainer.querySelectorAll(`.flatpickr-monthSelect-month`).forEach(function (t) {
            (t.dateObj.setFullYear(e.currentYear),
              (e.config.minDate && t.dateObj < e.config.minDate) ||
              (e.config.maxDate && t.dateObj > e.config.maxDate)
                ? t.classList.add(`flatpickr-disabled`)
                : t.classList.remove(`flatpickr-disabled`));
          }),
        s());
    }
    function l(t) {
      (t.preventDefault(), t.stopPropagation());
      var n = Ih(t);
      if (
        n instanceof Element &&
        !n.classList.contains(`flatpickr-disabled`) &&
        !n.classList.contains(`notAllowed`) &&
        (u(n.dateObj), e.config.closeOnSelect)
      ) {
        var r = e.config.mode === `single`,
          i = e.config.mode === `range` && e.selectedDates.length === 2;
        (r || i) && e.close();
      }
    }
    function u(t) {
      var n = new Date(e.currentYear, t.getMonth(), t.getDate()),
        r = [];
      switch (e.config.mode) {
        case `single`:
          r = [n];
          break;
        case `multiple`:
          r.push(n);
          break;
        case `range`:
          e.selectedDates.length === 2
            ? (r = [n])
            : ((r = e.selectedDates.concat([n])),
              r.sort(function (e, t) {
                return e.getTime() - t.getTime();
              }));
          break;
      }
      (e.setDate(r, !0), s());
    }
    var d = {
      37: -1,
      39: 1,
      40: 3,
      38: -3,
    };
    function f(t, r, i, a) {
      var o = d[a.keyCode] !== void 0;
      if (!(!o && a.keyCode !== 13) && !(!e.rContainer || !n.monthsContainer)) {
        var s = e.rContainer.querySelector(`.flatpickr-monthSelect-month.selected`),
          c = Array.prototype.indexOf.call(n.monthsContainer.children, document.activeElement);
        if (c === -1) {
          var l = s || n.monthsContainer.firstElementChild;
          (l.focus(), (c = l.$i));
        }
        o
          ? n.monthsContainer.children[(12 + c + d[a.keyCode]) % 12].focus()
          : a.keyCode === 13 &&
            n.monthsContainer.contains(document.activeElement) &&
            u(document.activeElement.dateObj);
      }
    }
    function p() {
      (e.config?.mode === `range` && e.selectedDates.length === 1 && e.clear(!1),
        e.selectedDates.length || a());
    }
    function m() {
      ((t._stubbedCurrentMonth = e._initialDate.getMonth()),
        e._initialDate.setMonth(t._stubbedCurrentMonth),
        (e.currentMonth = t._stubbedCurrentMonth));
    }
    function h() {
      t._stubbedCurrentMonth &&
        (e._initialDate.setMonth(t._stubbedCurrentMonth),
        (e.currentMonth = t._stubbedCurrentMonth),
        delete t._stubbedCurrentMonth);
    }
    function g() {
      if (n.monthsContainer !== null)
        for (
          var e = n.monthsContainer.querySelectorAll(`.flatpickr-monthSelect-month`), t = 0;
          t < e.length;
          t++
        )
          e[t].removeEventListener(`click`, l);
    }
    return {
      onParseConfig: function () {
        e.config.enableTime = !1;
      },
      onValueUpdate: s,
      onKeyDown: f,
      onReady: [
        m,
        r,
        i,
        o,
        s,
        function () {
          (e.config.onClose.push(p), e.loadedPlugins.push(`monthSelect`));
        },
      ],
      onDestroy: [
        h,
        g,
        function () {
          e.config.onClose = e.config.onClose.filter(function (e) {
            return e !== p;
          });
        },
      ],
    };
  };
}
B();
function Bh(e) {
  return V(() => x.getters[e + `getFormErrors`]);
}
function Vh(e) {
  return V(() => x.getters[`config/config`](e));
}
function Hh(e) {
  return V(() => x.getters[`auth/user/user`](e));
}
function Uh(e) {
  return V(() => x.getters[`auth/user/isSuperAdmin`]);
}
function Wh(e, t = null) {
  return t == `any`
    ? x.getters[`auth/user/hasAnyPermission`](e)
    : t == `all`
      ? x.getters[`auth/user/hasAllPermissions`](e)
      : x.getters[`auth/user/hasPermission`](e);
}
function Gh(e, t = null) {
  return t == `any`
    ? x.getters[`auth/user/hasAnyRole`](e)
    : t == `all`
      ? x.getters[`auth/user/hasAllRoles`](e)
      : x.getters[`auth/user/hasRole`](e);
}
B();
function Kh() {
  let e = Vh(`system.direction`);
  return {
    direction: e,
    isRtl: V(() => e.value === `rtl`),
    isLtr: V(() => e.value === `ltr`),
  };
}
var qh = i({
  default: () => Zh,
});
B();
var Jh = {
    key: 0,
    class: `gap-2`,
  },
  Yh = {
    key: 0,
    class: `fas fa-calendar text-gray-400`,
    "aria-hidden": `true`,
  },
  Xh = {
    key: 1,
    class: `fas fa-clock text-gray-400`,
    "aria-hidden": `true`,
  },
  Zh = Object.assign(
    {
      name: `DatePicker`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        placeholder: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: String,
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
        start: {
          type: String,
          default: ``,
        },
        end: {
          type: String,
          default: ``,
        },
        config: {
          type: Object,
          default: {},
        },
        as: {
          type: String,
          validator(e) {
            return [`date`, `multiple`, `datetime`, `time`, `range`, `month`, `dayMonth`].includes(
              e,
            );
          },
          default: `date`,
        },
        noClear: {
          type: Boolean,
          default: !1,
        },
        slim: {
          type: Boolean,
          default: !1,
        },
        isRequired: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:start`, `update:end`, `update:error`, `change`],
      setup(e, { emit: t }) {
        let { isRtl: n } = Kh(),
          r = t,
          i = e,
          a = V(() => {
            let e = {
              position: n.value ? `auto right` : `auto left`,
            };
            return i.as === `date`
              ? Object.assign({}, l, e, i.config)
              : i.as === `multiple`
                ? Object.assign({}, u, e, i.config)
                : i.as === `datetime`
                  ? Object.assign({}, h, e, i.config)
                  : i.as === `time`
                    ? Object.assign({}, m, e, i.config)
                    : i.as === `range`
                      ? Object.assign({}, p, e, i.config)
                      : i.as === `month`
                        ? Object.assign({}, d, e, i.config)
                        : i.as === `dayMonth`
                          ? Object.assign({}, f, e, i.config)
                          : Object.assign({}, e, i.config);
          }),
          o = Ae({
            uniqueId: ``,
            input: i.modelValue,
          }),
          s = (e, t) => {
            if ((r(`update:error`, ``), i.as === `range`)) {
              let e = t.split(` - `);
              e.length > 1
                ? (r(`update:start`, e[0]), r(`update:end`, e[1]))
                : (r(`update:start`, e[0]), r(`update:end`, e[0]));
            } else r(`update:modelValue`, t);
            r(`change`, t);
          },
          c = () => {
            ((o.input = ``),
              i.as != `range` && r(`update:modelValue`, ``),
              r(`update:error`, ``),
              i.as === `range` && (r(`update:start`, ``), r(`update:end`, ``)));
          };
        (He(
          () => [i.modelValue, i.start, i.end],
          (e) => {
            let t = e[0],
              n = e[1],
              r = e[2];
            (i.as === `range` && !n && !r
              ? (o.input = ``)
              : i.as === `range` && !o.input && (o.input = n + ` - ` + r),
              i.as != `range` && (o.input = t));
          },
        ),
          Qe(() => {
            o.uniqueId = i.id || Math.random().toString(16).slice(2);
          }));
        let l = {
            wrap: !0,
            allowInput: !1,
            dateFormat: `Y-m-d`,
            altInput: !0,
            altFormat: `M j Y`,
            locale: {
              firstDayOfWeek: 1,
            },
            disableMobile: `true`,
          },
          u = {
            wrap: !0,
            mode: `multiple`,
            allowInput: !1,
            dateFormat: `Y-m-d`,
            altInput: !0,
            altFormat: `M j Y`,
            locale: {
              firstDayOfWeek: 1,
            },
            disableMobile: `true`,
          },
          d = {
            plugins: [
              new zh({
                shorthand: !0,
                dateFormat: `Y-m`,
              }),
            ],
            disableMobile: `true`,
          },
          f = {
            wrap: !0,
            allowInput: !1,
            dateFormat: `Y-m-d`,
            altInput: !0,
            altFormat: `M j`,
            locale: {
              firstDayOfWeek: 1,
            },
            disableMobile: `true`,
          },
          p = {
            wrap: !0,
            mode: `range`,
            allowInput: !1,
            dateFormat: `Y-m-d`,
            altInput: !0,
            altFormat: `M j Y`,
            locale: {
              firstDayOfWeek: 1,
              rangeSeparator: ` - `,
            },
            disableMobile: `true`,
          },
          m = {
            enableTime: !0,
            noCalendar: !0,
            altFormat: `h:i K`,
            dateFormat: `H:i:S`,
            time_24hr: !1,
            wrap: !0,
            allowInput: !1,
            altInput: !0,
            disableMobile: `true`,
          },
          h = {
            enableTime: !0,
            wrap: !0,
            allowInput: !1,
            altFormat: `M j Y h:i K`,
            dateFormat: `Y-m-d H:i:S`,
            time_24hr: !1,
            altInput: !0,
            locale: {
              firstDayOfWeek: 1,
            },
            disableMobile: `true`,
          };
        return (t, r) => {
          let i = j(`IsRequired`),
            l = j(`BaseLabel`),
            u = j(`flat-pickr`),
            d = j(`FormError`),
            f = ve(`tooltip`);
          return (
            A(),
            M(
              ke,
              null,
              [
                e.label
                  ? (A(),
                    L(
                      l,
                      {
                        key: 0,
                        for: o.uniqueId,
                      },
                      {
                        default: I(() => [
                          W(`span`, null, [
                            H(T(e.label) + ` `, 1),
                            N(
                              i,
                              {
                                "is-required": e.isRequired,
                              },
                              null,
                              8,
                              [`is-required`],
                            ),
                          ]),
                          e.labelHint
                            ? Re(
                                (A(),
                                M(`span`, Jh, [
                                  ...(r[1] ||= [
                                    W(
                                      `i`,
                                      {
                                        class: `fas fa-question-circle`,
                                      },
                                      null,
                                      -1,
                                    ),
                                  ]),
                                ])),
                                [[f, e.labelHint]],
                              )
                            : U(``, !0),
                        ]),
                        _: 1,
                      },
                      8,
                      [`for`],
                    ))
                  : U(``, !0),
                W(
                  `div`,
                  {
                    class: O([
                      `relative`,
                      {
                        "mt-1": e.label,
                      },
                    ]),
                  },
                  [
                    W(
                      `div`,
                      {
                        class: O([
                          `pointer-events-none absolute inset-y-0 flex items-center`,
                          P(n) ? `right-0 pr-3` : `left-0 pl-3`,
                        ]),
                      },
                      [e.as === `time` ? (A(), M(`i`, Xh)) : (A(), M(`i`, Yh))],
                      2,
                    ),
                    N(
                      u,
                      ce(
                        {
                          id: o.uniqueId,
                        },
                        t.$attrs,
                        {
                          placeholder: e.placeholder || e.label,
                          class: [
                            `focus:border-primary block w-full border-0 border-gray-300 bg-transparent text-sm focus:ring-0 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-200`,
                            P(n) ? `pr-10` : `pl-10`,
                            {
                              "pl-10": !e.noClear && !P(n),
                              "pr-10": !e.noClear && P(n),
                              "border-b-2 shadow-xs": !e.slim,
                              "py-0 text-xs": e.slim,
                            },
                          ],
                          config: a.value,
                          modelValue: o.input,
                          "onUpdate:modelValue": (r[0] ||= (e) => (o.input = e)),
                          onOnValueUpdate: s,
                          events: [
                            `onValueUpdate`,
                            `onChange`,
                            `onClose`,
                            `onOpen`,
                            `onMonthChange`,
                            `onYearChange`,
                          ],
                        },
                      ),
                      null,
                      16,
                      [`id`, `placeholder`, `class`, `config`, `modelValue`],
                    ),
                    !e.noClear && o.input
                      ? (A(),
                        M(
                          `div`,
                          {
                            key: 0,
                            class: O([
                              `absolute inset-y-0 flex cursor-pointer items-center`,
                              P(n) ? `left-0 pl-3` : `right-0 pr-3`,
                            ]),
                            onClick: c,
                          },
                          [
                            ...(r[2] ||= [
                              W(
                                `i`,
                                {
                                  class: `fas fa-times text-gray-400`,
                                  "aria-hidden": `true`,
                                },
                                null,
                                -1,
                              ),
                            ]),
                          ],
                          2,
                        ))
                      : U(``, !0),
                  ],
                  2,
                ),
                N(
                  d,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ],
              64,
            )
          );
        };
      },
    },
  );
B();
var Qh = `https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64`,
  $h = {
    recent: `Recently used`,
    smileys_people: `Smiles & People`,
    animals_nature: `Animals & Nature`,
    food_drink: `Food & Drink`,
    activities: `Activities`,
    travel_places: `Travel places`,
    objects: `Objects`,
    symbols: `Symbols`,
    flags: `Flags`,
  },
  eg = `u`,
  tg = `n`,
  ng = `v`,
  rg = `r`,
  ig = {
    [tg]: [`grinning face`, `grinning`],
    [eg]: `1f600`,
    [rg]: `1f600`,
  },
  ag = `neutral`,
  og = [ag, `1f3fb`, `1f3fc`, `1f3fd`, `1f3fe`, `1f3ff`],
  sg = {
    placeholder: `Search emoji`,
    skinTone: `Skin tone`,
  },
  cg = [`light`, `dark`, `auto`],
  lg = {
    smileys_people: [
      {
        n: [`grinning face`, `grinning`],
        u: `1f600`,
      },
      {
        n: [`grinning face with smiling eyes`, `grin`],
        u: `1f601`,
      },
      {
        n: [`face with tears of joy`, `joy`],
        u: `1f602`,
      },
      {
        n: [`rolling on the floor laughing`, `rolling_on_the_floor_laughing`],
        u: `1f923`,
      },
      {
        n: [`smiling face with open mouth`, `smiley`],
        u: `1f603`,
      },
      {
        n: [`smiling face with open mouth and smiling eyes`, `smile`],
        u: `1f604`,
      },
      {
        n: [`smiling face with open mouth and cold sweat`, `sweat_smile`],
        u: `1f605`,
      },
      {
        n: [`smiling face with open mouth and tightly-closed eyes`, `laughing`, `satisfied`],
        u: `1f606`,
      },
      {
        n: [`winking face`, `wink`],
        u: `1f609`,
      },
      {
        n: [`smiling face with smiling eyes`, `blush`],
        u: `1f60a`,
      },
      {
        n: [`face savouring delicious food`, `yum`],
        u: `1f60b`,
      },
      {
        n: [`smiling face with sunglasses`, `sunglasses`],
        u: `1f60e`,
      },
      {
        n: [`smiling face with heart-shaped eyes`, `heart_eyes`],
        u: `1f60d`,
      },
      {
        n: [`face throwing a kiss`, `kissing_heart`],
        u: `1f618`,
      },
      {
        n: [`kissing face`, `kissing`],
        u: `1f617`,
      },
      {
        n: [`kissing face with smiling eyes`, `kissing_smiling_eyes`],
        u: `1f619`,
      },
      {
        n: [`kissing face with closed eyes`, `kissing_closed_eyes`],
        u: `1f61a`,
      },
      {
        n: [`white smiling face`, `relaxed`],
        u: `263a-fe0f`,
      },
      {
        n: [`slightly smiling face`, `slightly_smiling_face`],
        u: `1f642`,
      },
      {
        n: [`hugging face`, `hugging_face`],
        u: `1f917`,
      },
      {
        n: [`grinning face with star eyes`, `star-struck`, `grinning_face_with_star_eyes`],
        u: `1f929`,
      },
      {
        n: [`thinking face`, `thinking_face`],
        u: `1f914`,
      },
      {
        n: [
          `face with one eyebrow raised`,
          `face_with_raised_eyebrow`,
          `face_with_one_eyebrow_raised`,
        ],
        u: `1f928`,
      },
      {
        n: [`neutral face`, `neutral_face`],
        u: `1f610`,
      },
      {
        n: [`expressionless face`, `expressionless`],
        u: `1f611`,
      },
      {
        n: [`face without mouth`, `no_mouth`],
        u: `1f636`,
      },
      {
        n: [`face with rolling eyes`, `face_with_rolling_eyes`],
        u: `1f644`,
      },
      {
        n: [`smirking face`, `smirk`],
        u: `1f60f`,
      },
      {
        n: [`persevering face`, `persevere`],
        u: `1f623`,
      },
      {
        n: [`disappointed but relieved face`, `disappointed_relieved`],
        u: `1f625`,
      },
      {
        n: [`face with open mouth`, `open_mouth`],
        u: `1f62e`,
      },
      {
        n: [`zipper-mouth face`, `zipper_mouth_face`],
        u: `1f910`,
      },
      {
        n: [`hushed face`, `hushed`],
        u: `1f62f`,
      },
      {
        n: [`sleepy face`, `sleepy`],
        u: `1f62a`,
      },
      {
        n: [`tired face`, `tired_face`],
        u: `1f62b`,
      },
      {
        n: [`sleeping face`, `sleeping`],
        u: `1f634`,
      },
      {
        n: [`relieved face`, `relieved`],
        u: `1f60c`,
      },
      {
        n: [`face with stuck-out tongue`, `stuck_out_tongue`],
        u: `1f61b`,
      },
      {
        n: [`face with stuck-out tongue and winking eye`, `stuck_out_tongue_winking_eye`],
        u: `1f61c`,
      },
      {
        n: [`face with stuck-out tongue and tightly-closed eyes`, `stuck_out_tongue_closed_eyes`],
        u: `1f61d`,
      },
      {
        n: [`drooling face`, `drooling_face`],
        u: `1f924`,
      },
      {
        n: [`unamused face`, `unamused`],
        u: `1f612`,
      },
      {
        n: [`face with cold sweat`, `sweat`],
        u: `1f613`,
      },
      {
        n: [`pensive face`, `pensive`],
        u: `1f614`,
      },
      {
        n: [`confused face`, `confused`],
        u: `1f615`,
      },
      {
        n: [`upside-down face`, `upside_down_face`],
        u: `1f643`,
      },
      {
        n: [`money-mouth face`, `money_mouth_face`],
        u: `1f911`,
      },
      {
        n: [`astonished face`, `astonished`],
        u: `1f632`,
      },
      {
        n: [`white_frowning_face`],
        u: `2639-fe0f`,
      },
      {
        n: [`slightly frowning face`, `slightly_frowning_face`],
        u: `1f641`,
      },
      {
        n: [`confounded face`, `confounded`],
        u: `1f616`,
      },
      {
        n: [`disappointed face`, `disappointed`],
        u: `1f61e`,
      },
      {
        n: [`worried face`, `worried`],
        u: `1f61f`,
      },
      {
        n: [`face with look of triumph`, `triumph`],
        u: `1f624`,
      },
      {
        n: [`crying face`, `cry`],
        u: `1f622`,
      },
      {
        n: [`loudly crying face`, `sob`],
        u: `1f62d`,
      },
      {
        n: [`frowning face with open mouth`, `frowning`],
        u: `1f626`,
      },
      {
        n: [`anguished face`, `anguished`],
        u: `1f627`,
      },
      {
        n: [`fearful face`, `fearful`],
        u: `1f628`,
      },
      {
        n: [`weary face`, `weary`],
        u: `1f629`,
      },
      {
        n: [
          `shocked face with exploding head`,
          `exploding_head`,
          `shocked_face_with_exploding_head`,
        ],
        u: `1f92f`,
      },
      {
        n: [`grimacing face`, `grimacing`],
        u: `1f62c`,
      },
      {
        n: [`face with open mouth and cold sweat`, `cold_sweat`],
        u: `1f630`,
      },
      {
        n: [`face screaming in fear`, `scream`],
        u: `1f631`,
      },
      {
        n: [`flushed face`, `flushed`],
        u: `1f633`,
      },
      {
        n: [
          `grinning face with one large and one small eye`,
          `zany_face`,
          `grinning_face_with_one_large_and_one_small_eye`,
        ],
        u: `1f92a`,
      },
      {
        n: [`dizzy face`, `dizzy_face`],
        u: `1f635`,
      },
      {
        n: [`pouting face`, `rage`],
        u: `1f621`,
      },
      {
        n: [`angry face`, `angry`],
        u: `1f620`,
      },
      {
        n: [
          `serious face with symbols covering mouth`,
          `face_with_symbols_on_mouth`,
          `serious_face_with_symbols_covering_mouth`,
        ],
        u: `1f92c`,
      },
      {
        n: [`face with medical mask`, `mask`],
        u: `1f637`,
      },
      {
        n: [`face with thermometer`, `face_with_thermometer`],
        u: `1f912`,
      },
      {
        n: [`face with head-bandage`, `face_with_head_bandage`],
        u: `1f915`,
      },
      {
        n: [`nauseated face`, `nauseated_face`],
        u: `1f922`,
      },
      {
        n: [`face with open mouth vomiting`, `face_vomiting`, `face_with_open_mouth_vomiting`],
        u: `1f92e`,
      },
      {
        n: [`sneezing face`, `sneezing_face`],
        u: `1f927`,
      },
      {
        n: [`smiling face with halo`, `innocent`],
        u: `1f607`,
      },
      {
        n: [`face with cowboy hat`, `face_with_cowboy_hat`],
        u: `1f920`,
      },
      {
        n: [`clown face`, `clown_face`],
        u: `1f921`,
      },
      {
        n: [`lying face`, `lying_face`],
        u: `1f925`,
      },
      {
        n: [
          `face with finger covering closed lips`,
          `shushing_face`,
          `face_with_finger_covering_closed_lips`,
        ],
        u: `1f92b`,
      },
      {
        n: [
          `smiling face with smiling eyes and hand covering mouth`,
          `face_with_hand_over_mouth`,
          `smiling_face_with_smiling_eyes_and_hand_covering_mouth`,
        ],
        u: `1f92d`,
      },
      {
        n: [`face with monocle`, `face_with_monocle`],
        u: `1f9d0`,
      },
      {
        n: [`nerd face`, `nerd_face`],
        u: `1f913`,
      },
      {
        n: [`smiling face with horns`, `smiling_imp`],
        u: `1f608`,
      },
      {
        n: [`imp`],
        u: `1f47f`,
      },
      {
        n: [`japanese ogre`, `japanese_ogre`],
        u: `1f479`,
      },
      {
        n: [`japanese goblin`, `japanese_goblin`],
        u: `1f47a`,
      },
      {
        n: [`skull`],
        u: `1f480`,
      },
      {
        n: [`skull_and_crossbones`],
        u: `2620-fe0f`,
      },
      {
        n: [`ghost`],
        u: `1f47b`,
      },
      {
        n: [`extraterrestrial alien`, `alien`],
        u: `1f47d`,
      },
      {
        n: [`alien monster`, `space_invader`],
        u: `1f47e`,
      },
      {
        n: [`robot face`, `robot_face`],
        u: `1f916`,
      },
      {
        n: [`pile of poo`, `hankey`, `poop`, `shit`],
        u: `1f4a9`,
      },
      {
        n: [`smiling cat face with open mouth`, `smiley_cat`],
        u: `1f63a`,
      },
      {
        n: [`grinning cat face with smiling eyes`, `smile_cat`],
        u: `1f638`,
      },
      {
        n: [`cat face with tears of joy`, `joy_cat`],
        u: `1f639`,
      },
      {
        n: [`smiling cat face with heart-shaped eyes`, `heart_eyes_cat`],
        u: `1f63b`,
      },
      {
        n: [`cat face with wry smile`, `smirk_cat`],
        u: `1f63c`,
      },
      {
        n: [`kissing cat face with closed eyes`, `kissing_cat`],
        u: `1f63d`,
      },
      {
        n: [`weary cat face`, `scream_cat`],
        u: `1f640`,
      },
      {
        n: [`crying cat face`, `crying_cat_face`],
        u: `1f63f`,
      },
      {
        n: [`pouting cat face`, `pouting_cat`],
        u: `1f63e`,
      },
      {
        n: [`see-no-evil monkey`, `see_no_evil`],
        u: `1f648`,
      },
      {
        n: [`hear-no-evil monkey`, `hear_no_evil`],
        u: `1f649`,
      },
      {
        n: [`speak-no-evil monkey`, `speak_no_evil`],
        u: `1f64a`,
      },
      {
        n: [`baby`],
        u: `1f476`,
        v: [`1f476-1f3fb`, `1f476-1f3fc`, `1f476-1f3fd`, `1f476-1f3fe`, `1f476-1f3ff`],
      },
      {
        n: [`child`],
        u: `1f9d2`,
        v: [`1f9d2-1f3fb`, `1f9d2-1f3fc`, `1f9d2-1f3fd`, `1f9d2-1f3fe`, `1f9d2-1f3ff`],
      },
      {
        n: [`boy`],
        u: `1f466`,
        v: [`1f466-1f3fb`, `1f466-1f3fc`, `1f466-1f3fd`, `1f466-1f3fe`, `1f466-1f3ff`],
      },
      {
        n: [`girl`],
        u: `1f467`,
        v: [`1f467-1f3fb`, `1f467-1f3fc`, `1f467-1f3fd`, `1f467-1f3fe`, `1f467-1f3ff`],
      },
      {
        n: [`adult`],
        u: `1f9d1`,
        v: [`1f9d1-1f3fb`, `1f9d1-1f3fc`, `1f9d1-1f3fd`, `1f9d1-1f3fe`, `1f9d1-1f3ff`],
      },
      {
        n: [`man`],
        u: `1f468`,
        v: [`1f468-1f3fb`, `1f468-1f3fc`, `1f468-1f3fd`, `1f468-1f3fe`, `1f468-1f3ff`],
      },
      {
        n: [`woman`],
        u: `1f469`,
        v: [`1f469-1f3fb`, `1f469-1f3fc`, `1f469-1f3fd`, `1f469-1f3fe`, `1f469-1f3ff`],
      },
      {
        n: [`older adult`, `older_adult`],
        u: `1f9d3`,
        v: [`1f9d3-1f3fb`, `1f9d3-1f3fc`, `1f9d3-1f3fd`, `1f9d3-1f3fe`, `1f9d3-1f3ff`],
      },
      {
        n: [`older man`, `older_man`],
        u: `1f474`,
        v: [`1f474-1f3fb`, `1f474-1f3fc`, `1f474-1f3fd`, `1f474-1f3fe`, `1f474-1f3ff`],
      },
      {
        n: [`older woman`, `older_woman`],
        u: `1f475`,
        v: [`1f475-1f3fb`, `1f475-1f3fc`, `1f475-1f3fd`, `1f475-1f3fe`, `1f475-1f3ff`],
      },
      {
        n: [`male-doctor`],
        u: `1f468-200d-2695-fe0f`,
        v: [
          `1f468-1f3fb-200d-2695-fe0f`,
          `1f468-1f3fc-200d-2695-fe0f`,
          `1f468-1f3fd-200d-2695-fe0f`,
          `1f468-1f3fe-200d-2695-fe0f`,
          `1f468-1f3ff-200d-2695-fe0f`,
        ],
      },
      {
        n: [`female-doctor`],
        u: `1f469-200d-2695-fe0f`,
        v: [
          `1f469-1f3fb-200d-2695-fe0f`,
          `1f469-1f3fc-200d-2695-fe0f`,
          `1f469-1f3fd-200d-2695-fe0f`,
          `1f469-1f3fe-200d-2695-fe0f`,
          `1f469-1f3ff-200d-2695-fe0f`,
        ],
      },
      {
        n: [`male-student`],
        u: `1f468-200d-1f393`,
        v: [
          `1f468-1f3fb-200d-1f393`,
          `1f468-1f3fc-200d-1f393`,
          `1f468-1f3fd-200d-1f393`,
          `1f468-1f3fe-200d-1f393`,
          `1f468-1f3ff-200d-1f393`,
        ],
      },
      {
        n: [`female-student`],
        u: `1f469-200d-1f393`,
        v: [
          `1f469-1f3fb-200d-1f393`,
          `1f469-1f3fc-200d-1f393`,
          `1f469-1f3fd-200d-1f393`,
          `1f469-1f3fe-200d-1f393`,
          `1f469-1f3ff-200d-1f393`,
        ],
      },
      {
        n: [`male-teacher`],
        u: `1f468-200d-1f3eb`,
        v: [
          `1f468-1f3fb-200d-1f3eb`,
          `1f468-1f3fc-200d-1f3eb`,
          `1f468-1f3fd-200d-1f3eb`,
          `1f468-1f3fe-200d-1f3eb`,
          `1f468-1f3ff-200d-1f3eb`,
        ],
      },
      {
        n: [`female-teacher`],
        u: `1f469-200d-1f3eb`,
        v: [
          `1f469-1f3fb-200d-1f3eb`,
          `1f469-1f3fc-200d-1f3eb`,
          `1f469-1f3fd-200d-1f3eb`,
          `1f469-1f3fe-200d-1f3eb`,
          `1f469-1f3ff-200d-1f3eb`,
        ],
      },
      {
        n: [`male-judge`],
        u: `1f468-200d-2696-fe0f`,
        v: [
          `1f468-1f3fb-200d-2696-fe0f`,
          `1f468-1f3fc-200d-2696-fe0f`,
          `1f468-1f3fd-200d-2696-fe0f`,
          `1f468-1f3fe-200d-2696-fe0f`,
          `1f468-1f3ff-200d-2696-fe0f`,
        ],
      },
      {
        n: [`female-judge`],
        u: `1f469-200d-2696-fe0f`,
        v: [
          `1f469-1f3fb-200d-2696-fe0f`,
          `1f469-1f3fc-200d-2696-fe0f`,
          `1f469-1f3fd-200d-2696-fe0f`,
          `1f469-1f3fe-200d-2696-fe0f`,
          `1f469-1f3ff-200d-2696-fe0f`,
        ],
      },
      {
        n: [`male-farmer`],
        u: `1f468-200d-1f33e`,
        v: [
          `1f468-1f3fb-200d-1f33e`,
          `1f468-1f3fc-200d-1f33e`,
          `1f468-1f3fd-200d-1f33e`,
          `1f468-1f3fe-200d-1f33e`,
          `1f468-1f3ff-200d-1f33e`,
        ],
      },
      {
        n: [`female-farmer`],
        u: `1f469-200d-1f33e`,
        v: [
          `1f469-1f3fb-200d-1f33e`,
          `1f469-1f3fc-200d-1f33e`,
          `1f469-1f3fd-200d-1f33e`,
          `1f469-1f3fe-200d-1f33e`,
          `1f469-1f3ff-200d-1f33e`,
        ],
      },
      {
        n: [`male-cook`],
        u: `1f468-200d-1f373`,
        v: [
          `1f468-1f3fb-200d-1f373`,
          `1f468-1f3fc-200d-1f373`,
          `1f468-1f3fd-200d-1f373`,
          `1f468-1f3fe-200d-1f373`,
          `1f468-1f3ff-200d-1f373`,
        ],
      },
      {
        n: [`female-cook`],
        u: `1f469-200d-1f373`,
        v: [
          `1f469-1f3fb-200d-1f373`,
          `1f469-1f3fc-200d-1f373`,
          `1f469-1f3fd-200d-1f373`,
          `1f469-1f3fe-200d-1f373`,
          `1f469-1f3ff-200d-1f373`,
        ],
      },
      {
        n: [`male-mechanic`],
        u: `1f468-200d-1f527`,
        v: [
          `1f468-1f3fb-200d-1f527`,
          `1f468-1f3fc-200d-1f527`,
          `1f468-1f3fd-200d-1f527`,
          `1f468-1f3fe-200d-1f527`,
          `1f468-1f3ff-200d-1f527`,
        ],
      },
      {
        n: [`female-mechanic`],
        u: `1f469-200d-1f527`,
        v: [
          `1f469-1f3fb-200d-1f527`,
          `1f469-1f3fc-200d-1f527`,
          `1f469-1f3fd-200d-1f527`,
          `1f469-1f3fe-200d-1f527`,
          `1f469-1f3ff-200d-1f527`,
        ],
      },
      {
        n: [`male-factory-worker`],
        u: `1f468-200d-1f3ed`,
        v: [
          `1f468-1f3fb-200d-1f3ed`,
          `1f468-1f3fc-200d-1f3ed`,
          `1f468-1f3fd-200d-1f3ed`,
          `1f468-1f3fe-200d-1f3ed`,
          `1f468-1f3ff-200d-1f3ed`,
        ],
      },
      {
        n: [`female-factory-worker`],
        u: `1f469-200d-1f3ed`,
        v: [
          `1f469-1f3fb-200d-1f3ed`,
          `1f469-1f3fc-200d-1f3ed`,
          `1f469-1f3fd-200d-1f3ed`,
          `1f469-1f3fe-200d-1f3ed`,
          `1f469-1f3ff-200d-1f3ed`,
        ],
      },
      {
        n: [`male-office-worker`],
        u: `1f468-200d-1f4bc`,
        v: [
          `1f468-1f3fb-200d-1f4bc`,
          `1f468-1f3fc-200d-1f4bc`,
          `1f468-1f3fd-200d-1f4bc`,
          `1f468-1f3fe-200d-1f4bc`,
          `1f468-1f3ff-200d-1f4bc`,
        ],
      },
      {
        n: [`female-office-worker`],
        u: `1f469-200d-1f4bc`,
        v: [
          `1f469-1f3fb-200d-1f4bc`,
          `1f469-1f3fc-200d-1f4bc`,
          `1f469-1f3fd-200d-1f4bc`,
          `1f469-1f3fe-200d-1f4bc`,
          `1f469-1f3ff-200d-1f4bc`,
        ],
      },
      {
        n: [`male-scientist`],
        u: `1f468-200d-1f52c`,
        v: [
          `1f468-1f3fb-200d-1f52c`,
          `1f468-1f3fc-200d-1f52c`,
          `1f468-1f3fd-200d-1f52c`,
          `1f468-1f3fe-200d-1f52c`,
          `1f468-1f3ff-200d-1f52c`,
        ],
      },
      {
        n: [`female-scientist`],
        u: `1f469-200d-1f52c`,
        v: [
          `1f469-1f3fb-200d-1f52c`,
          `1f469-1f3fc-200d-1f52c`,
          `1f469-1f3fd-200d-1f52c`,
          `1f469-1f3fe-200d-1f52c`,
          `1f469-1f3ff-200d-1f52c`,
        ],
      },
      {
        n: [`male-technologist`],
        u: `1f468-200d-1f4bb`,
        v: [
          `1f468-1f3fb-200d-1f4bb`,
          `1f468-1f3fc-200d-1f4bb`,
          `1f468-1f3fd-200d-1f4bb`,
          `1f468-1f3fe-200d-1f4bb`,
          `1f468-1f3ff-200d-1f4bb`,
        ],
      },
      {
        n: [`female-technologist`],
        u: `1f469-200d-1f4bb`,
        v: [
          `1f469-1f3fb-200d-1f4bb`,
          `1f469-1f3fc-200d-1f4bb`,
          `1f469-1f3fd-200d-1f4bb`,
          `1f469-1f3fe-200d-1f4bb`,
          `1f469-1f3ff-200d-1f4bb`,
        ],
      },
      {
        n: [`male-singer`],
        u: `1f468-200d-1f3a4`,
        v: [
          `1f468-1f3fb-200d-1f3a4`,
          `1f468-1f3fc-200d-1f3a4`,
          `1f468-1f3fd-200d-1f3a4`,
          `1f468-1f3fe-200d-1f3a4`,
          `1f468-1f3ff-200d-1f3a4`,
        ],
      },
      {
        n: [`female-singer`],
        u: `1f469-200d-1f3a4`,
        v: [
          `1f469-1f3fb-200d-1f3a4`,
          `1f469-1f3fc-200d-1f3a4`,
          `1f469-1f3fd-200d-1f3a4`,
          `1f469-1f3fe-200d-1f3a4`,
          `1f469-1f3ff-200d-1f3a4`,
        ],
      },
      {
        n: [`male-artist`],
        u: `1f468-200d-1f3a8`,
        v: [
          `1f468-1f3fb-200d-1f3a8`,
          `1f468-1f3fc-200d-1f3a8`,
          `1f468-1f3fd-200d-1f3a8`,
          `1f468-1f3fe-200d-1f3a8`,
          `1f468-1f3ff-200d-1f3a8`,
        ],
      },
      {
        n: [`female-artist`],
        u: `1f469-200d-1f3a8`,
        v: [
          `1f469-1f3fb-200d-1f3a8`,
          `1f469-1f3fc-200d-1f3a8`,
          `1f469-1f3fd-200d-1f3a8`,
          `1f469-1f3fe-200d-1f3a8`,
          `1f469-1f3ff-200d-1f3a8`,
        ],
      },
      {
        n: [`male-pilot`],
        u: `1f468-200d-2708-fe0f`,
        v: [
          `1f468-1f3fb-200d-2708-fe0f`,
          `1f468-1f3fc-200d-2708-fe0f`,
          `1f468-1f3fd-200d-2708-fe0f`,
          `1f468-1f3fe-200d-2708-fe0f`,
          `1f468-1f3ff-200d-2708-fe0f`,
        ],
      },
      {
        n: [`female-pilot`],
        u: `1f469-200d-2708-fe0f`,
        v: [
          `1f469-1f3fb-200d-2708-fe0f`,
          `1f469-1f3fc-200d-2708-fe0f`,
          `1f469-1f3fd-200d-2708-fe0f`,
          `1f469-1f3fe-200d-2708-fe0f`,
          `1f469-1f3ff-200d-2708-fe0f`,
        ],
      },
      {
        n: [`male-astronaut`],
        u: `1f468-200d-1f680`,
        v: [
          `1f468-1f3fb-200d-1f680`,
          `1f468-1f3fc-200d-1f680`,
          `1f468-1f3fd-200d-1f680`,
          `1f468-1f3fe-200d-1f680`,
          `1f468-1f3ff-200d-1f680`,
        ],
      },
      {
        n: [`female-astronaut`],
        u: `1f469-200d-1f680`,
        v: [
          `1f469-1f3fb-200d-1f680`,
          `1f469-1f3fc-200d-1f680`,
          `1f469-1f3fd-200d-1f680`,
          `1f469-1f3fe-200d-1f680`,
          `1f469-1f3ff-200d-1f680`,
        ],
      },
      {
        n: [`male-firefighter`],
        u: `1f468-200d-1f692`,
        v: [
          `1f468-1f3fb-200d-1f692`,
          `1f468-1f3fc-200d-1f692`,
          `1f468-1f3fd-200d-1f692`,
          `1f468-1f3fe-200d-1f692`,
          `1f468-1f3ff-200d-1f692`,
        ],
      },
      {
        n: [`female-firefighter`],
        u: `1f469-200d-1f692`,
        v: [
          `1f469-1f3fb-200d-1f692`,
          `1f469-1f3fc-200d-1f692`,
          `1f469-1f3fd-200d-1f692`,
          `1f469-1f3fe-200d-1f692`,
          `1f469-1f3ff-200d-1f692`,
        ],
      },
      {
        n: [`police officer`, `cop`],
        u: `1f46e`,
        v: [`1f46e-1f3fb`, `1f46e-1f3fc`, `1f46e-1f3fd`, `1f46e-1f3fe`, `1f46e-1f3ff`],
      },
      {
        n: [`male-police-officer`],
        u: `1f46e-200d-2642-fe0f`,
        v: [
          `1f46e-1f3fb-200d-2642-fe0f`,
          `1f46e-1f3fc-200d-2642-fe0f`,
          `1f46e-1f3fd-200d-2642-fe0f`,
          `1f46e-1f3fe-200d-2642-fe0f`,
          `1f46e-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`female-police-officer`],
        u: `1f46e-200d-2640-fe0f`,
        v: [
          `1f46e-1f3fb-200d-2640-fe0f`,
          `1f46e-1f3fc-200d-2640-fe0f`,
          `1f46e-1f3fd-200d-2640-fe0f`,
          `1f46e-1f3fe-200d-2640-fe0f`,
          `1f46e-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`sleuth_or_spy`],
        u: `1f575-fe0f`,
        v: [`1f575-1f3fb`, `1f575-1f3fc`, `1f575-1f3fd`, `1f575-1f3fe`, `1f575-1f3ff`],
      },
      {
        n: [`male-detective`],
        u: `1f575-fe0f-200d-2642-fe0f`,
        v: [
          `1f575-1f3fb-200d-2642-fe0f`,
          `1f575-1f3fc-200d-2642-fe0f`,
          `1f575-1f3fd-200d-2642-fe0f`,
          `1f575-1f3fe-200d-2642-fe0f`,
          `1f575-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`female-detective`],
        u: `1f575-fe0f-200d-2640-fe0f`,
        v: [
          `1f575-1f3fb-200d-2640-fe0f`,
          `1f575-1f3fc-200d-2640-fe0f`,
          `1f575-1f3fd-200d-2640-fe0f`,
          `1f575-1f3fe-200d-2640-fe0f`,
          `1f575-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`guardsman`],
        u: `1f482`,
        v: [`1f482-1f3fb`, `1f482-1f3fc`, `1f482-1f3fd`, `1f482-1f3fe`, `1f482-1f3ff`],
      },
      {
        n: [`male-guard`],
        u: `1f482-200d-2642-fe0f`,
        v: [
          `1f482-1f3fb-200d-2642-fe0f`,
          `1f482-1f3fc-200d-2642-fe0f`,
          `1f482-1f3fd-200d-2642-fe0f`,
          `1f482-1f3fe-200d-2642-fe0f`,
          `1f482-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`female-guard`],
        u: `1f482-200d-2640-fe0f`,
        v: [
          `1f482-1f3fb-200d-2640-fe0f`,
          `1f482-1f3fc-200d-2640-fe0f`,
          `1f482-1f3fd-200d-2640-fe0f`,
          `1f482-1f3fe-200d-2640-fe0f`,
          `1f482-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`construction worker`, `construction_worker`],
        u: `1f477`,
        v: [`1f477-1f3fb`, `1f477-1f3fc`, `1f477-1f3fd`, `1f477-1f3fe`, `1f477-1f3ff`],
      },
      {
        n: [`male-construction-worker`],
        u: `1f477-200d-2642-fe0f`,
        v: [
          `1f477-1f3fb-200d-2642-fe0f`,
          `1f477-1f3fc-200d-2642-fe0f`,
          `1f477-1f3fd-200d-2642-fe0f`,
          `1f477-1f3fe-200d-2642-fe0f`,
          `1f477-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`female-construction-worker`],
        u: `1f477-200d-2640-fe0f`,
        v: [
          `1f477-1f3fb-200d-2640-fe0f`,
          `1f477-1f3fc-200d-2640-fe0f`,
          `1f477-1f3fd-200d-2640-fe0f`,
          `1f477-1f3fe-200d-2640-fe0f`,
          `1f477-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`prince`],
        u: `1f934`,
        v: [`1f934-1f3fb`, `1f934-1f3fc`, `1f934-1f3fd`, `1f934-1f3fe`, `1f934-1f3ff`],
      },
      {
        n: [`princess`],
        u: `1f478`,
        v: [`1f478-1f3fb`, `1f478-1f3fc`, `1f478-1f3fd`, `1f478-1f3fe`, `1f478-1f3ff`],
      },
      {
        n: [`man with turban`, `man_with_turban`],
        u: `1f473`,
        v: [`1f473-1f3fb`, `1f473-1f3fc`, `1f473-1f3fd`, `1f473-1f3fe`, `1f473-1f3ff`],
      },
      {
        n: [`man-wearing-turban`],
        u: `1f473-200d-2642-fe0f`,
        v: [
          `1f473-1f3fb-200d-2642-fe0f`,
          `1f473-1f3fc-200d-2642-fe0f`,
          `1f473-1f3fd-200d-2642-fe0f`,
          `1f473-1f3fe-200d-2642-fe0f`,
          `1f473-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-wearing-turban`],
        u: `1f473-200d-2640-fe0f`,
        v: [
          `1f473-1f3fb-200d-2640-fe0f`,
          `1f473-1f3fc-200d-2640-fe0f`,
          `1f473-1f3fd-200d-2640-fe0f`,
          `1f473-1f3fe-200d-2640-fe0f`,
          `1f473-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`man with gua pi mao`, `man_with_gua_pi_mao`],
        u: `1f472`,
        v: [`1f472-1f3fb`, `1f472-1f3fc`, `1f472-1f3fd`, `1f472-1f3fe`, `1f472-1f3ff`],
      },
      {
        n: [`person with headscarf`, `person_with_headscarf`],
        u: `1f9d5`,
        v: [`1f9d5-1f3fb`, `1f9d5-1f3fc`, `1f9d5-1f3fd`, `1f9d5-1f3fe`, `1f9d5-1f3ff`],
      },
      {
        n: [`bearded person`, `bearded_person`],
        u: `1f9d4`,
        v: [`1f9d4-1f3fb`, `1f9d4-1f3fc`, `1f9d4-1f3fd`, `1f9d4-1f3fe`, `1f9d4-1f3ff`],
      },
      {
        n: [`person with blond hair`, `person_with_blond_hair`],
        u: `1f471`,
        v: [`1f471-1f3fb`, `1f471-1f3fc`, `1f471-1f3fd`, `1f471-1f3fe`, `1f471-1f3ff`],
      },
      {
        n: [`blond-haired-man`],
        u: `1f471-200d-2642-fe0f`,
        v: [
          `1f471-1f3fb-200d-2642-fe0f`,
          `1f471-1f3fc-200d-2642-fe0f`,
          `1f471-1f3fd-200d-2642-fe0f`,
          `1f471-1f3fe-200d-2642-fe0f`,
          `1f471-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`blond-haired-woman`],
        u: `1f471-200d-2640-fe0f`,
        v: [
          `1f471-1f3fb-200d-2640-fe0f`,
          `1f471-1f3fc-200d-2640-fe0f`,
          `1f471-1f3fd-200d-2640-fe0f`,
          `1f471-1f3fe-200d-2640-fe0f`,
          `1f471-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`man in tuxedo`, `man_in_tuxedo`],
        u: `1f935`,
        v: [`1f935-1f3fb`, `1f935-1f3fc`, `1f935-1f3fd`, `1f935-1f3fe`, `1f935-1f3ff`],
      },
      {
        n: [`bride with veil`, `bride_with_veil`],
        u: `1f470`,
        v: [`1f470-1f3fb`, `1f470-1f3fc`, `1f470-1f3fd`, `1f470-1f3fe`, `1f470-1f3ff`],
      },
      {
        n: [`pregnant woman`, `pregnant_woman`],
        u: `1f930`,
        v: [`1f930-1f3fb`, `1f930-1f3fc`, `1f930-1f3fd`, `1f930-1f3fe`, `1f930-1f3ff`],
      },
      {
        n: [`breast-feeding`],
        u: `1f931`,
        v: [`1f931-1f3fb`, `1f931-1f3fc`, `1f931-1f3fd`, `1f931-1f3fe`, `1f931-1f3ff`],
      },
      {
        n: [`baby angel`, `angel`],
        u: `1f47c`,
        v: [`1f47c-1f3fb`, `1f47c-1f3fc`, `1f47c-1f3fd`, `1f47c-1f3fe`, `1f47c-1f3ff`],
      },
      {
        n: [`father christmas`, `santa`],
        u: `1f385`,
        v: [`1f385-1f3fb`, `1f385-1f3fc`, `1f385-1f3fd`, `1f385-1f3fe`, `1f385-1f3ff`],
      },
      {
        n: [`mother christmas`, `mrs_claus`, `mother_christmas`],
        u: `1f936`,
        v: [`1f936-1f3fb`, `1f936-1f3fc`, `1f936-1f3fd`, `1f936-1f3fe`, `1f936-1f3ff`],
      },
      {
        n: [`mage`],
        u: `1f9d9`,
        v: [`1f9d9-1f3fb`, `1f9d9-1f3fc`, `1f9d9-1f3fd`, `1f9d9-1f3fe`, `1f9d9-1f3ff`],
      },
      {
        n: [`female_mage`],
        u: `1f9d9-200d-2640-fe0f`,
        v: [
          `1f9d9-1f3fb-200d-2640-fe0f`,
          `1f9d9-1f3fc-200d-2640-fe0f`,
          `1f9d9-1f3fd-200d-2640-fe0f`,
          `1f9d9-1f3fe-200d-2640-fe0f`,
          `1f9d9-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`male_mage`],
        u: `1f9d9-200d-2642-fe0f`,
        v: [
          `1f9d9-1f3fb-200d-2642-fe0f`,
          `1f9d9-1f3fc-200d-2642-fe0f`,
          `1f9d9-1f3fd-200d-2642-fe0f`,
          `1f9d9-1f3fe-200d-2642-fe0f`,
          `1f9d9-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`fairy`],
        u: `1f9da`,
        v: [`1f9da-1f3fb`, `1f9da-1f3fc`, `1f9da-1f3fd`, `1f9da-1f3fe`, `1f9da-1f3ff`],
      },
      {
        n: [`female_fairy`],
        u: `1f9da-200d-2640-fe0f`,
        v: [
          `1f9da-1f3fb-200d-2640-fe0f`,
          `1f9da-1f3fc-200d-2640-fe0f`,
          `1f9da-1f3fd-200d-2640-fe0f`,
          `1f9da-1f3fe-200d-2640-fe0f`,
          `1f9da-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`male_fairy`],
        u: `1f9da-200d-2642-fe0f`,
        v: [
          `1f9da-1f3fb-200d-2642-fe0f`,
          `1f9da-1f3fc-200d-2642-fe0f`,
          `1f9da-1f3fd-200d-2642-fe0f`,
          `1f9da-1f3fe-200d-2642-fe0f`,
          `1f9da-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`vampire`],
        u: `1f9db`,
        v: [`1f9db-1f3fb`, `1f9db-1f3fc`, `1f9db-1f3fd`, `1f9db-1f3fe`, `1f9db-1f3ff`],
      },
      {
        n: [`female_vampire`],
        u: `1f9db-200d-2640-fe0f`,
        v: [
          `1f9db-1f3fb-200d-2640-fe0f`,
          `1f9db-1f3fc-200d-2640-fe0f`,
          `1f9db-1f3fd-200d-2640-fe0f`,
          `1f9db-1f3fe-200d-2640-fe0f`,
          `1f9db-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`male_vampire`],
        u: `1f9db-200d-2642-fe0f`,
        v: [
          `1f9db-1f3fb-200d-2642-fe0f`,
          `1f9db-1f3fc-200d-2642-fe0f`,
          `1f9db-1f3fd-200d-2642-fe0f`,
          `1f9db-1f3fe-200d-2642-fe0f`,
          `1f9db-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`merperson`],
        u: `1f9dc`,
        v: [`1f9dc-1f3fb`, `1f9dc-1f3fc`, `1f9dc-1f3fd`, `1f9dc-1f3fe`, `1f9dc-1f3ff`],
      },
      {
        n: [`mermaid`],
        u: `1f9dc-200d-2640-fe0f`,
        v: [
          `1f9dc-1f3fb-200d-2640-fe0f`,
          `1f9dc-1f3fc-200d-2640-fe0f`,
          `1f9dc-1f3fd-200d-2640-fe0f`,
          `1f9dc-1f3fe-200d-2640-fe0f`,
          `1f9dc-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`merman`],
        u: `1f9dc-200d-2642-fe0f`,
        v: [
          `1f9dc-1f3fb-200d-2642-fe0f`,
          `1f9dc-1f3fc-200d-2642-fe0f`,
          `1f9dc-1f3fd-200d-2642-fe0f`,
          `1f9dc-1f3fe-200d-2642-fe0f`,
          `1f9dc-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`elf`],
        u: `1f9dd`,
        v: [`1f9dd-1f3fb`, `1f9dd-1f3fc`, `1f9dd-1f3fd`, `1f9dd-1f3fe`, `1f9dd-1f3ff`],
      },
      {
        n: [`female_elf`],
        u: `1f9dd-200d-2640-fe0f`,
        v: [
          `1f9dd-1f3fb-200d-2640-fe0f`,
          `1f9dd-1f3fc-200d-2640-fe0f`,
          `1f9dd-1f3fd-200d-2640-fe0f`,
          `1f9dd-1f3fe-200d-2640-fe0f`,
          `1f9dd-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`male_elf`],
        u: `1f9dd-200d-2642-fe0f`,
        v: [
          `1f9dd-1f3fb-200d-2642-fe0f`,
          `1f9dd-1f3fc-200d-2642-fe0f`,
          `1f9dd-1f3fd-200d-2642-fe0f`,
          `1f9dd-1f3fe-200d-2642-fe0f`,
          `1f9dd-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`genie`],
        u: `1f9de`,
      },
      {
        n: [`female_genie`],
        u: `1f9de-200d-2640-fe0f`,
      },
      {
        n: [`male_genie`],
        u: `1f9de-200d-2642-fe0f`,
      },
      {
        n: [`zombie`],
        u: `1f9df`,
      },
      {
        n: [`female_zombie`],
        u: `1f9df-200d-2640-fe0f`,
      },
      {
        n: [`male_zombie`],
        u: `1f9df-200d-2642-fe0f`,
      },
      {
        n: [`person frowning`, `person_frowning`],
        u: `1f64d`,
        v: [`1f64d-1f3fb`, `1f64d-1f3fc`, `1f64d-1f3fd`, `1f64d-1f3fe`, `1f64d-1f3ff`],
      },
      {
        n: [`man-frowning`],
        u: `1f64d-200d-2642-fe0f`,
        v: [
          `1f64d-1f3fb-200d-2642-fe0f`,
          `1f64d-1f3fc-200d-2642-fe0f`,
          `1f64d-1f3fd-200d-2642-fe0f`,
          `1f64d-1f3fe-200d-2642-fe0f`,
          `1f64d-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-frowning`],
        u: `1f64d-200d-2640-fe0f`,
        v: [
          `1f64d-1f3fb-200d-2640-fe0f`,
          `1f64d-1f3fc-200d-2640-fe0f`,
          `1f64d-1f3fd-200d-2640-fe0f`,
          `1f64d-1f3fe-200d-2640-fe0f`,
          `1f64d-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`person with pouting face`, `person_with_pouting_face`],
        u: `1f64e`,
        v: [`1f64e-1f3fb`, `1f64e-1f3fc`, `1f64e-1f3fd`, `1f64e-1f3fe`, `1f64e-1f3ff`],
      },
      {
        n: [`man-pouting`],
        u: `1f64e-200d-2642-fe0f`,
        v: [
          `1f64e-1f3fb-200d-2642-fe0f`,
          `1f64e-1f3fc-200d-2642-fe0f`,
          `1f64e-1f3fd-200d-2642-fe0f`,
          `1f64e-1f3fe-200d-2642-fe0f`,
          `1f64e-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-pouting`],
        u: `1f64e-200d-2640-fe0f`,
        v: [
          `1f64e-1f3fb-200d-2640-fe0f`,
          `1f64e-1f3fc-200d-2640-fe0f`,
          `1f64e-1f3fd-200d-2640-fe0f`,
          `1f64e-1f3fe-200d-2640-fe0f`,
          `1f64e-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`face with no good gesture`, `no_good`],
        u: `1f645`,
        v: [`1f645-1f3fb`, `1f645-1f3fc`, `1f645-1f3fd`, `1f645-1f3fe`, `1f645-1f3ff`],
      },
      {
        n: [`man-gesturing-no`],
        u: `1f645-200d-2642-fe0f`,
        v: [
          `1f645-1f3fb-200d-2642-fe0f`,
          `1f645-1f3fc-200d-2642-fe0f`,
          `1f645-1f3fd-200d-2642-fe0f`,
          `1f645-1f3fe-200d-2642-fe0f`,
          `1f645-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-gesturing-no`],
        u: `1f645-200d-2640-fe0f`,
        v: [
          `1f645-1f3fb-200d-2640-fe0f`,
          `1f645-1f3fc-200d-2640-fe0f`,
          `1f645-1f3fd-200d-2640-fe0f`,
          `1f645-1f3fe-200d-2640-fe0f`,
          `1f645-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`face with ok gesture`, `ok_woman`],
        u: `1f646`,
        v: [`1f646-1f3fb`, `1f646-1f3fc`, `1f646-1f3fd`, `1f646-1f3fe`, `1f646-1f3ff`],
      },
      {
        n: [`man-gesturing-ok`],
        u: `1f646-200d-2642-fe0f`,
        v: [
          `1f646-1f3fb-200d-2642-fe0f`,
          `1f646-1f3fc-200d-2642-fe0f`,
          `1f646-1f3fd-200d-2642-fe0f`,
          `1f646-1f3fe-200d-2642-fe0f`,
          `1f646-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-gesturing-ok`],
        u: `1f646-200d-2640-fe0f`,
        v: [
          `1f646-1f3fb-200d-2640-fe0f`,
          `1f646-1f3fc-200d-2640-fe0f`,
          `1f646-1f3fd-200d-2640-fe0f`,
          `1f646-1f3fe-200d-2640-fe0f`,
          `1f646-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`information desk person`, `information_desk_person`],
        u: `1f481`,
        v: [`1f481-1f3fb`, `1f481-1f3fc`, `1f481-1f3fd`, `1f481-1f3fe`, `1f481-1f3ff`],
      },
      {
        n: [`man-tipping-hand`],
        u: `1f481-200d-2642-fe0f`,
        v: [
          `1f481-1f3fb-200d-2642-fe0f`,
          `1f481-1f3fc-200d-2642-fe0f`,
          `1f481-1f3fd-200d-2642-fe0f`,
          `1f481-1f3fe-200d-2642-fe0f`,
          `1f481-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-tipping-hand`],
        u: `1f481-200d-2640-fe0f`,
        v: [
          `1f481-1f3fb-200d-2640-fe0f`,
          `1f481-1f3fc-200d-2640-fe0f`,
          `1f481-1f3fd-200d-2640-fe0f`,
          `1f481-1f3fe-200d-2640-fe0f`,
          `1f481-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`happy person raising one hand`, `raising_hand`],
        u: `1f64b`,
        v: [`1f64b-1f3fb`, `1f64b-1f3fc`, `1f64b-1f3fd`, `1f64b-1f3fe`, `1f64b-1f3ff`],
      },
      {
        n: [`man-raising-hand`],
        u: `1f64b-200d-2642-fe0f`,
        v: [
          `1f64b-1f3fb-200d-2642-fe0f`,
          `1f64b-1f3fc-200d-2642-fe0f`,
          `1f64b-1f3fd-200d-2642-fe0f`,
          `1f64b-1f3fe-200d-2642-fe0f`,
          `1f64b-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-raising-hand`],
        u: `1f64b-200d-2640-fe0f`,
        v: [
          `1f64b-1f3fb-200d-2640-fe0f`,
          `1f64b-1f3fc-200d-2640-fe0f`,
          `1f64b-1f3fd-200d-2640-fe0f`,
          `1f64b-1f3fe-200d-2640-fe0f`,
          `1f64b-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`person bowing deeply`, `bow`],
        u: `1f647`,
        v: [`1f647-1f3fb`, `1f647-1f3fc`, `1f647-1f3fd`, `1f647-1f3fe`, `1f647-1f3ff`],
      },
      {
        n: [`man-bowing`],
        u: `1f647-200d-2642-fe0f`,
        v: [
          `1f647-1f3fb-200d-2642-fe0f`,
          `1f647-1f3fc-200d-2642-fe0f`,
          `1f647-1f3fd-200d-2642-fe0f`,
          `1f647-1f3fe-200d-2642-fe0f`,
          `1f647-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-bowing`],
        u: `1f647-200d-2640-fe0f`,
        v: [
          `1f647-1f3fb-200d-2640-fe0f`,
          `1f647-1f3fc-200d-2640-fe0f`,
          `1f647-1f3fd-200d-2640-fe0f`,
          `1f647-1f3fe-200d-2640-fe0f`,
          `1f647-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`face palm`, `face_palm`],
        u: `1f926`,
        v: [`1f926-1f3fb`, `1f926-1f3fc`, `1f926-1f3fd`, `1f926-1f3fe`, `1f926-1f3ff`],
      },
      {
        n: [`man-facepalming`],
        u: `1f926-200d-2642-fe0f`,
        v: [
          `1f926-1f3fb-200d-2642-fe0f`,
          `1f926-1f3fc-200d-2642-fe0f`,
          `1f926-1f3fd-200d-2642-fe0f`,
          `1f926-1f3fe-200d-2642-fe0f`,
          `1f926-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-facepalming`],
        u: `1f926-200d-2640-fe0f`,
        v: [
          `1f926-1f3fb-200d-2640-fe0f`,
          `1f926-1f3fc-200d-2640-fe0f`,
          `1f926-1f3fd-200d-2640-fe0f`,
          `1f926-1f3fe-200d-2640-fe0f`,
          `1f926-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`shrug`],
        u: `1f937`,
        v: [`1f937-1f3fb`, `1f937-1f3fc`, `1f937-1f3fd`, `1f937-1f3fe`, `1f937-1f3ff`],
      },
      {
        n: [`man-shrugging`],
        u: `1f937-200d-2642-fe0f`,
        v: [
          `1f937-1f3fb-200d-2642-fe0f`,
          `1f937-1f3fc-200d-2642-fe0f`,
          `1f937-1f3fd-200d-2642-fe0f`,
          `1f937-1f3fe-200d-2642-fe0f`,
          `1f937-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-shrugging`],
        u: `1f937-200d-2640-fe0f`,
        v: [
          `1f937-1f3fb-200d-2640-fe0f`,
          `1f937-1f3fc-200d-2640-fe0f`,
          `1f937-1f3fd-200d-2640-fe0f`,
          `1f937-1f3fe-200d-2640-fe0f`,
          `1f937-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`face massage`, `massage`],
        u: `1f486`,
        v: [`1f486-1f3fb`, `1f486-1f3fc`, `1f486-1f3fd`, `1f486-1f3fe`, `1f486-1f3ff`],
      },
      {
        n: [`man-getting-massage`],
        u: `1f486-200d-2642-fe0f`,
        v: [
          `1f486-1f3fb-200d-2642-fe0f`,
          `1f486-1f3fc-200d-2642-fe0f`,
          `1f486-1f3fd-200d-2642-fe0f`,
          `1f486-1f3fe-200d-2642-fe0f`,
          `1f486-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-getting-massage`],
        u: `1f486-200d-2640-fe0f`,
        v: [
          `1f486-1f3fb-200d-2640-fe0f`,
          `1f486-1f3fc-200d-2640-fe0f`,
          `1f486-1f3fd-200d-2640-fe0f`,
          `1f486-1f3fe-200d-2640-fe0f`,
          `1f486-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`haircut`],
        u: `1f487`,
        v: [`1f487-1f3fb`, `1f487-1f3fc`, `1f487-1f3fd`, `1f487-1f3fe`, `1f487-1f3ff`],
      },
      {
        n: [`man-getting-haircut`],
        u: `1f487-200d-2642-fe0f`,
        v: [
          `1f487-1f3fb-200d-2642-fe0f`,
          `1f487-1f3fc-200d-2642-fe0f`,
          `1f487-1f3fd-200d-2642-fe0f`,
          `1f487-1f3fe-200d-2642-fe0f`,
          `1f487-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-getting-haircut`],
        u: `1f487-200d-2640-fe0f`,
        v: [
          `1f487-1f3fb-200d-2640-fe0f`,
          `1f487-1f3fc-200d-2640-fe0f`,
          `1f487-1f3fd-200d-2640-fe0f`,
          `1f487-1f3fe-200d-2640-fe0f`,
          `1f487-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`pedestrian`, `walking`],
        u: `1f6b6`,
        v: [`1f6b6-1f3fb`, `1f6b6-1f3fc`, `1f6b6-1f3fd`, `1f6b6-1f3fe`, `1f6b6-1f3ff`],
      },
      {
        n: [`man-walking`],
        u: `1f6b6-200d-2642-fe0f`,
        v: [
          `1f6b6-1f3fb-200d-2642-fe0f`,
          `1f6b6-1f3fc-200d-2642-fe0f`,
          `1f6b6-1f3fd-200d-2642-fe0f`,
          `1f6b6-1f3fe-200d-2642-fe0f`,
          `1f6b6-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-walking`],
        u: `1f6b6-200d-2640-fe0f`,
        v: [
          `1f6b6-1f3fb-200d-2640-fe0f`,
          `1f6b6-1f3fc-200d-2640-fe0f`,
          `1f6b6-1f3fd-200d-2640-fe0f`,
          `1f6b6-1f3fe-200d-2640-fe0f`,
          `1f6b6-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`runner`, `running`],
        u: `1f3c3`,
        v: [`1f3c3-1f3fb`, `1f3c3-1f3fc`, `1f3c3-1f3fd`, `1f3c3-1f3fe`, `1f3c3-1f3ff`],
      },
      {
        n: [`man-running`],
        u: `1f3c3-200d-2642-fe0f`,
        v: [
          `1f3c3-1f3fb-200d-2642-fe0f`,
          `1f3c3-1f3fc-200d-2642-fe0f`,
          `1f3c3-1f3fd-200d-2642-fe0f`,
          `1f3c3-1f3fe-200d-2642-fe0f`,
          `1f3c3-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-running`],
        u: `1f3c3-200d-2640-fe0f`,
        v: [
          `1f3c3-1f3fb-200d-2640-fe0f`,
          `1f3c3-1f3fc-200d-2640-fe0f`,
          `1f3c3-1f3fd-200d-2640-fe0f`,
          `1f3c3-1f3fe-200d-2640-fe0f`,
          `1f3c3-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`dancer`],
        u: `1f483`,
        v: [`1f483-1f3fb`, `1f483-1f3fc`, `1f483-1f3fd`, `1f483-1f3fe`, `1f483-1f3ff`],
      },
      {
        n: [`man dancing`, `man_dancing`],
        u: `1f57a`,
        v: [`1f57a-1f3fb`, `1f57a-1f3fc`, `1f57a-1f3fd`, `1f57a-1f3fe`, `1f57a-1f3ff`],
      },
      {
        n: [`woman with bunny ears`, `dancers`],
        u: `1f46f`,
      },
      {
        n: [`man-with-bunny-ears-partying`],
        u: `1f46f-200d-2642-fe0f`,
      },
      {
        n: [`woman-with-bunny-ears-partying`],
        u: `1f46f-200d-2640-fe0f`,
      },
      {
        n: [`person in steamy room`, `person_in_steamy_room`],
        u: `1f9d6`,
        v: [`1f9d6-1f3fb`, `1f9d6-1f3fc`, `1f9d6-1f3fd`, `1f9d6-1f3fe`, `1f9d6-1f3ff`],
      },
      {
        n: [`woman_in_steamy_room`],
        u: `1f9d6-200d-2640-fe0f`,
        v: [
          `1f9d6-1f3fb-200d-2640-fe0f`,
          `1f9d6-1f3fc-200d-2640-fe0f`,
          `1f9d6-1f3fd-200d-2640-fe0f`,
          `1f9d6-1f3fe-200d-2640-fe0f`,
          `1f9d6-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`man_in_steamy_room`],
        u: `1f9d6-200d-2642-fe0f`,
        v: [
          `1f9d6-1f3fb-200d-2642-fe0f`,
          `1f9d6-1f3fc-200d-2642-fe0f`,
          `1f9d6-1f3fd-200d-2642-fe0f`,
          `1f9d6-1f3fe-200d-2642-fe0f`,
          `1f9d6-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`person climbing`, `person_climbing`],
        u: `1f9d7`,
        v: [`1f9d7-1f3fb`, `1f9d7-1f3fc`, `1f9d7-1f3fd`, `1f9d7-1f3fe`, `1f9d7-1f3ff`],
      },
      {
        n: [`woman_climbing`],
        u: `1f9d7-200d-2640-fe0f`,
        v: [
          `1f9d7-1f3fb-200d-2640-fe0f`,
          `1f9d7-1f3fc-200d-2640-fe0f`,
          `1f9d7-1f3fd-200d-2640-fe0f`,
          `1f9d7-1f3fe-200d-2640-fe0f`,
          `1f9d7-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`man_climbing`],
        u: `1f9d7-200d-2642-fe0f`,
        v: [
          `1f9d7-1f3fb-200d-2642-fe0f`,
          `1f9d7-1f3fc-200d-2642-fe0f`,
          `1f9d7-1f3fd-200d-2642-fe0f`,
          `1f9d7-1f3fe-200d-2642-fe0f`,
          `1f9d7-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`person in lotus position`, `person_in_lotus_position`],
        u: `1f9d8`,
        v: [`1f9d8-1f3fb`, `1f9d8-1f3fc`, `1f9d8-1f3fd`, `1f9d8-1f3fe`, `1f9d8-1f3ff`],
      },
      {
        n: [`woman_in_lotus_position`],
        u: `1f9d8-200d-2640-fe0f`,
        v: [
          `1f9d8-1f3fb-200d-2640-fe0f`,
          `1f9d8-1f3fc-200d-2640-fe0f`,
          `1f9d8-1f3fd-200d-2640-fe0f`,
          `1f9d8-1f3fe-200d-2640-fe0f`,
          `1f9d8-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`man_in_lotus_position`],
        u: `1f9d8-200d-2642-fe0f`,
        v: [
          `1f9d8-1f3fb-200d-2642-fe0f`,
          `1f9d8-1f3fc-200d-2642-fe0f`,
          `1f9d8-1f3fd-200d-2642-fe0f`,
          `1f9d8-1f3fe-200d-2642-fe0f`,
          `1f9d8-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`bath`],
        u: `1f6c0`,
        v: [`1f6c0-1f3fb`, `1f6c0-1f3fc`, `1f6c0-1f3fd`, `1f6c0-1f3fe`, `1f6c0-1f3ff`],
      },
      {
        n: [`sleeping accommodation`, `sleeping_accommodation`],
        u: `1f6cc`,
        v: [`1f6cc-1f3fb`, `1f6cc-1f3fc`, `1f6cc-1f3fd`, `1f6cc-1f3fe`, `1f6cc-1f3ff`],
      },
      {
        n: [`man_in_business_suit_levitating`],
        u: `1f574-fe0f`,
        v: [`1f574-1f3fb`, `1f574-1f3fc`, `1f574-1f3fd`, `1f574-1f3fe`, `1f574-1f3ff`],
      },
      {
        n: [`speaking_head_in_silhouette`],
        u: `1f5e3-fe0f`,
      },
      {
        n: [`bust in silhouette`, `bust_in_silhouette`],
        u: `1f464`,
      },
      {
        n: [`busts in silhouette`, `busts_in_silhouette`],
        u: `1f465`,
      },
      {
        n: [`fencer`],
        u: `1f93a`,
      },
      {
        n: [`horse racing`, `horse_racing`],
        u: `1f3c7`,
        v: [`1f3c7-1f3fb`, `1f3c7-1f3fc`, `1f3c7-1f3fd`, `1f3c7-1f3fe`, `1f3c7-1f3ff`],
      },
      {
        n: [`skier`],
        u: `26f7-fe0f`,
      },
      {
        n: [`snowboarder`],
        u: `1f3c2`,
        v: [`1f3c2-1f3fb`, `1f3c2-1f3fc`, `1f3c2-1f3fd`, `1f3c2-1f3fe`, `1f3c2-1f3ff`],
      },
      {
        n: [`golfer`],
        u: `1f3cc-fe0f`,
        v: [`1f3cc-1f3fb`, `1f3cc-1f3fc`, `1f3cc-1f3fd`, `1f3cc-1f3fe`, `1f3cc-1f3ff`],
      },
      {
        n: [`man-golfing`],
        u: `1f3cc-fe0f-200d-2642-fe0f`,
        v: [
          `1f3cc-1f3fb-200d-2642-fe0f`,
          `1f3cc-1f3fc-200d-2642-fe0f`,
          `1f3cc-1f3fd-200d-2642-fe0f`,
          `1f3cc-1f3fe-200d-2642-fe0f`,
          `1f3cc-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-golfing`],
        u: `1f3cc-fe0f-200d-2640-fe0f`,
        v: [
          `1f3cc-1f3fb-200d-2640-fe0f`,
          `1f3cc-1f3fc-200d-2640-fe0f`,
          `1f3cc-1f3fd-200d-2640-fe0f`,
          `1f3cc-1f3fe-200d-2640-fe0f`,
          `1f3cc-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`surfer`],
        u: `1f3c4`,
        v: [`1f3c4-1f3fb`, `1f3c4-1f3fc`, `1f3c4-1f3fd`, `1f3c4-1f3fe`, `1f3c4-1f3ff`],
      },
      {
        n: [`man-surfing`],
        u: `1f3c4-200d-2642-fe0f`,
        v: [
          `1f3c4-1f3fb-200d-2642-fe0f`,
          `1f3c4-1f3fc-200d-2642-fe0f`,
          `1f3c4-1f3fd-200d-2642-fe0f`,
          `1f3c4-1f3fe-200d-2642-fe0f`,
          `1f3c4-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-surfing`],
        u: `1f3c4-200d-2640-fe0f`,
        v: [
          `1f3c4-1f3fb-200d-2640-fe0f`,
          `1f3c4-1f3fc-200d-2640-fe0f`,
          `1f3c4-1f3fd-200d-2640-fe0f`,
          `1f3c4-1f3fe-200d-2640-fe0f`,
          `1f3c4-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`rowboat`],
        u: `1f6a3`,
        v: [`1f6a3-1f3fb`, `1f6a3-1f3fc`, `1f6a3-1f3fd`, `1f6a3-1f3fe`, `1f6a3-1f3ff`],
      },
      {
        n: [`man-rowing-boat`],
        u: `1f6a3-200d-2642-fe0f`,
        v: [
          `1f6a3-1f3fb-200d-2642-fe0f`,
          `1f6a3-1f3fc-200d-2642-fe0f`,
          `1f6a3-1f3fd-200d-2642-fe0f`,
          `1f6a3-1f3fe-200d-2642-fe0f`,
          `1f6a3-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-rowing-boat`],
        u: `1f6a3-200d-2640-fe0f`,
        v: [
          `1f6a3-1f3fb-200d-2640-fe0f`,
          `1f6a3-1f3fc-200d-2640-fe0f`,
          `1f6a3-1f3fd-200d-2640-fe0f`,
          `1f6a3-1f3fe-200d-2640-fe0f`,
          `1f6a3-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`swimmer`],
        u: `1f3ca`,
        v: [`1f3ca-1f3fb`, `1f3ca-1f3fc`, `1f3ca-1f3fd`, `1f3ca-1f3fe`, `1f3ca-1f3ff`],
      },
      {
        n: [`man-swimming`],
        u: `1f3ca-200d-2642-fe0f`,
        v: [
          `1f3ca-1f3fb-200d-2642-fe0f`,
          `1f3ca-1f3fc-200d-2642-fe0f`,
          `1f3ca-1f3fd-200d-2642-fe0f`,
          `1f3ca-1f3fe-200d-2642-fe0f`,
          `1f3ca-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-swimming`],
        u: `1f3ca-200d-2640-fe0f`,
        v: [
          `1f3ca-1f3fb-200d-2640-fe0f`,
          `1f3ca-1f3fc-200d-2640-fe0f`,
          `1f3ca-1f3fd-200d-2640-fe0f`,
          `1f3ca-1f3fe-200d-2640-fe0f`,
          `1f3ca-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`person_with_ball`],
        u: `26f9-fe0f`,
        v: [`26f9-1f3fb`, `26f9-1f3fc`, `26f9-1f3fd`, `26f9-1f3fe`, `26f9-1f3ff`],
      },
      {
        n: [`man-bouncing-ball`],
        u: `26f9-fe0f-200d-2642-fe0f`,
        v: [
          `26f9-1f3fb-200d-2642-fe0f`,
          `26f9-1f3fc-200d-2642-fe0f`,
          `26f9-1f3fd-200d-2642-fe0f`,
          `26f9-1f3fe-200d-2642-fe0f`,
          `26f9-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-bouncing-ball`],
        u: `26f9-fe0f-200d-2640-fe0f`,
        v: [
          `26f9-1f3fb-200d-2640-fe0f`,
          `26f9-1f3fc-200d-2640-fe0f`,
          `26f9-1f3fd-200d-2640-fe0f`,
          `26f9-1f3fe-200d-2640-fe0f`,
          `26f9-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`weight_lifter`],
        u: `1f3cb-fe0f`,
        v: [`1f3cb-1f3fb`, `1f3cb-1f3fc`, `1f3cb-1f3fd`, `1f3cb-1f3fe`, `1f3cb-1f3ff`],
      },
      {
        n: [`man-lifting-weights`],
        u: `1f3cb-fe0f-200d-2642-fe0f`,
        v: [
          `1f3cb-1f3fb-200d-2642-fe0f`,
          `1f3cb-1f3fc-200d-2642-fe0f`,
          `1f3cb-1f3fd-200d-2642-fe0f`,
          `1f3cb-1f3fe-200d-2642-fe0f`,
          `1f3cb-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-lifting-weights`],
        u: `1f3cb-fe0f-200d-2640-fe0f`,
        v: [
          `1f3cb-1f3fb-200d-2640-fe0f`,
          `1f3cb-1f3fc-200d-2640-fe0f`,
          `1f3cb-1f3fd-200d-2640-fe0f`,
          `1f3cb-1f3fe-200d-2640-fe0f`,
          `1f3cb-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`bicyclist`],
        u: `1f6b4`,
        v: [`1f6b4-1f3fb`, `1f6b4-1f3fc`, `1f6b4-1f3fd`, `1f6b4-1f3fe`, `1f6b4-1f3ff`],
      },
      {
        n: [`man-biking`],
        u: `1f6b4-200d-2642-fe0f`,
        v: [
          `1f6b4-1f3fb-200d-2642-fe0f`,
          `1f6b4-1f3fc-200d-2642-fe0f`,
          `1f6b4-1f3fd-200d-2642-fe0f`,
          `1f6b4-1f3fe-200d-2642-fe0f`,
          `1f6b4-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-biking`],
        u: `1f6b4-200d-2640-fe0f`,
        v: [
          `1f6b4-1f3fb-200d-2640-fe0f`,
          `1f6b4-1f3fc-200d-2640-fe0f`,
          `1f6b4-1f3fd-200d-2640-fe0f`,
          `1f6b4-1f3fe-200d-2640-fe0f`,
          `1f6b4-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`mountain bicyclist`, `mountain_bicyclist`],
        u: `1f6b5`,
        v: [`1f6b5-1f3fb`, `1f6b5-1f3fc`, `1f6b5-1f3fd`, `1f6b5-1f3fe`, `1f6b5-1f3ff`],
      },
      {
        n: [`man-mountain-biking`],
        u: `1f6b5-200d-2642-fe0f`,
        v: [
          `1f6b5-1f3fb-200d-2642-fe0f`,
          `1f6b5-1f3fc-200d-2642-fe0f`,
          `1f6b5-1f3fd-200d-2642-fe0f`,
          `1f6b5-1f3fe-200d-2642-fe0f`,
          `1f6b5-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-mountain-biking`],
        u: `1f6b5-200d-2640-fe0f`,
        v: [
          `1f6b5-1f3fb-200d-2640-fe0f`,
          `1f6b5-1f3fc-200d-2640-fe0f`,
          `1f6b5-1f3fd-200d-2640-fe0f`,
          `1f6b5-1f3fe-200d-2640-fe0f`,
          `1f6b5-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`racing_car`],
        u: `1f3ce-fe0f`,
      },
      {
        n: [`racing_motorcycle`],
        u: `1f3cd-fe0f`,
      },
      {
        n: [`person doing cartwheel`, `person_doing_cartwheel`],
        u: `1f938`,
        v: [`1f938-1f3fb`, `1f938-1f3fc`, `1f938-1f3fd`, `1f938-1f3fe`, `1f938-1f3ff`],
      },
      {
        n: [`man-cartwheeling`],
        u: `1f938-200d-2642-fe0f`,
        v: [
          `1f938-1f3fb-200d-2642-fe0f`,
          `1f938-1f3fc-200d-2642-fe0f`,
          `1f938-1f3fd-200d-2642-fe0f`,
          `1f938-1f3fe-200d-2642-fe0f`,
          `1f938-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-cartwheeling`],
        u: `1f938-200d-2640-fe0f`,
        v: [
          `1f938-1f3fb-200d-2640-fe0f`,
          `1f938-1f3fc-200d-2640-fe0f`,
          `1f938-1f3fd-200d-2640-fe0f`,
          `1f938-1f3fe-200d-2640-fe0f`,
          `1f938-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`wrestlers`],
        u: `1f93c`,
      },
      {
        n: [`man-wrestling`],
        u: `1f93c-200d-2642-fe0f`,
      },
      {
        n: [`woman-wrestling`],
        u: `1f93c-200d-2640-fe0f`,
      },
      {
        n: [`water polo`, `water_polo`],
        u: `1f93d`,
        v: [`1f93d-1f3fb`, `1f93d-1f3fc`, `1f93d-1f3fd`, `1f93d-1f3fe`, `1f93d-1f3ff`],
      },
      {
        n: [`man-playing-water-polo`],
        u: `1f93d-200d-2642-fe0f`,
        v: [
          `1f93d-1f3fb-200d-2642-fe0f`,
          `1f93d-1f3fc-200d-2642-fe0f`,
          `1f93d-1f3fd-200d-2642-fe0f`,
          `1f93d-1f3fe-200d-2642-fe0f`,
          `1f93d-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-playing-water-polo`],
        u: `1f93d-200d-2640-fe0f`,
        v: [
          `1f93d-1f3fb-200d-2640-fe0f`,
          `1f93d-1f3fc-200d-2640-fe0f`,
          `1f93d-1f3fd-200d-2640-fe0f`,
          `1f93d-1f3fe-200d-2640-fe0f`,
          `1f93d-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`handball`],
        u: `1f93e`,
        v: [`1f93e-1f3fb`, `1f93e-1f3fc`, `1f93e-1f3fd`, `1f93e-1f3fe`, `1f93e-1f3ff`],
      },
      {
        n: [`man-playing-handball`],
        u: `1f93e-200d-2642-fe0f`,
        v: [
          `1f93e-1f3fb-200d-2642-fe0f`,
          `1f93e-1f3fc-200d-2642-fe0f`,
          `1f93e-1f3fd-200d-2642-fe0f`,
          `1f93e-1f3fe-200d-2642-fe0f`,
          `1f93e-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-playing-handball`],
        u: `1f93e-200d-2640-fe0f`,
        v: [
          `1f93e-1f3fb-200d-2640-fe0f`,
          `1f93e-1f3fc-200d-2640-fe0f`,
          `1f93e-1f3fd-200d-2640-fe0f`,
          `1f93e-1f3fe-200d-2640-fe0f`,
          `1f93e-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`juggling`],
        u: `1f939`,
        v: [`1f939-1f3fb`, `1f939-1f3fc`, `1f939-1f3fd`, `1f939-1f3fe`, `1f939-1f3ff`],
      },
      {
        n: [`man-juggling`],
        u: `1f939-200d-2642-fe0f`,
        v: [
          `1f939-1f3fb-200d-2642-fe0f`,
          `1f939-1f3fc-200d-2642-fe0f`,
          `1f939-1f3fd-200d-2642-fe0f`,
          `1f939-1f3fe-200d-2642-fe0f`,
          `1f939-1f3ff-200d-2642-fe0f`,
        ],
      },
      {
        n: [`woman-juggling`],
        u: `1f939-200d-2640-fe0f`,
        v: [
          `1f939-1f3fb-200d-2640-fe0f`,
          `1f939-1f3fc-200d-2640-fe0f`,
          `1f939-1f3fd-200d-2640-fe0f`,
          `1f939-1f3fe-200d-2640-fe0f`,
          `1f939-1f3ff-200d-2640-fe0f`,
        ],
      },
      {
        n: [`man and woman holding hands`, `couple`, `man_and_woman_holding_hands`],
        u: `1f46b`,
      },
      {
        n: [`two men holding hands`, `two_men_holding_hands`],
        u: `1f46c`,
      },
      {
        n: [`two women holding hands`, `two_women_holding_hands`],
        u: `1f46d`,
      },
      {
        n: [`kiss`, `couplekiss`],
        u: `1f48f`,
      },
      {
        n: [`woman-kiss-man`],
        u: `1f469-200d-2764-fe0f-200d-1f48b-200d-1f468`,
      },
      {
        n: [`man-kiss-man`],
        u: `1f468-200d-2764-fe0f-200d-1f48b-200d-1f468`,
      },
      {
        n: [`woman-kiss-woman`],
        u: `1f469-200d-2764-fe0f-200d-1f48b-200d-1f469`,
      },
      {
        n: [`couple with heart`, `couple_with_heart`],
        u: `1f491`,
      },
      {
        n: [`woman-heart-man`],
        u: `1f469-200d-2764-fe0f-200d-1f468`,
      },
      {
        n: [`man-heart-man`],
        u: `1f468-200d-2764-fe0f-200d-1f468`,
      },
      {
        n: [`woman-heart-woman`],
        u: `1f469-200d-2764-fe0f-200d-1f469`,
      },
      {
        n: [`family`, `man-woman-boy`],
        u: `1f46a`,
      },
      {
        n: [`man-woman-boy`, `family`],
        u: `1f468-200d-1f469-200d-1f466`,
      },
      {
        n: [`man-woman-girl`],
        u: `1f468-200d-1f469-200d-1f467`,
      },
      {
        n: [`man-woman-girl-boy`],
        u: `1f468-200d-1f469-200d-1f467-200d-1f466`,
      },
      {
        n: [`man-woman-boy-boy`],
        u: `1f468-200d-1f469-200d-1f466-200d-1f466`,
      },
      {
        n: [`man-woman-girl-girl`],
        u: `1f468-200d-1f469-200d-1f467-200d-1f467`,
      },
      {
        n: [`man-man-boy`],
        u: `1f468-200d-1f468-200d-1f466`,
      },
      {
        n: [`man-man-girl`],
        u: `1f468-200d-1f468-200d-1f467`,
      },
      {
        n: [`man-man-girl-boy`],
        u: `1f468-200d-1f468-200d-1f467-200d-1f466`,
      },
      {
        n: [`man-man-boy-boy`],
        u: `1f468-200d-1f468-200d-1f466-200d-1f466`,
      },
      {
        n: [`man-man-girl-girl`],
        u: `1f468-200d-1f468-200d-1f467-200d-1f467`,
      },
      {
        n: [`woman-woman-boy`],
        u: `1f469-200d-1f469-200d-1f466`,
      },
      {
        n: [`woman-woman-girl`],
        u: `1f469-200d-1f469-200d-1f467`,
      },
      {
        n: [`woman-woman-girl-boy`],
        u: `1f469-200d-1f469-200d-1f467-200d-1f466`,
      },
      {
        n: [`woman-woman-boy-boy`],
        u: `1f469-200d-1f469-200d-1f466-200d-1f466`,
      },
      {
        n: [`woman-woman-girl-girl`],
        u: `1f469-200d-1f469-200d-1f467-200d-1f467`,
      },
      {
        n: [`man-boy`],
        u: `1f468-200d-1f466`,
      },
      {
        n: [`man-boy-boy`],
        u: `1f468-200d-1f466-200d-1f466`,
      },
      {
        n: [`man-girl`],
        u: `1f468-200d-1f467`,
      },
      {
        n: [`man-girl-boy`],
        u: `1f468-200d-1f467-200d-1f466`,
      },
      {
        n: [`man-girl-girl`],
        u: `1f468-200d-1f467-200d-1f467`,
      },
      {
        n: [`woman-boy`],
        u: `1f469-200d-1f466`,
      },
      {
        n: [`woman-boy-boy`],
        u: `1f469-200d-1f466-200d-1f466`,
      },
      {
        n: [`woman-girl`],
        u: `1f469-200d-1f467`,
      },
      {
        n: [`woman-girl-boy`],
        u: `1f469-200d-1f467-200d-1f466`,
      },
      {
        n: [`woman-girl-girl`],
        u: `1f469-200d-1f467-200d-1f467`,
      },
      {
        n: [`selfie`],
        u: `1f933`,
        v: [`1f933-1f3fb`, `1f933-1f3fc`, `1f933-1f3fd`, `1f933-1f3fe`, `1f933-1f3ff`],
      },
      {
        n: [`flexed biceps`, `muscle`],
        u: `1f4aa`,
        v: [`1f4aa-1f3fb`, `1f4aa-1f3fc`, `1f4aa-1f3fd`, `1f4aa-1f3fe`, `1f4aa-1f3ff`],
      },
      {
        n: [`white left pointing backhand index`, `point_left`],
        u: `1f448`,
        v: [`1f448-1f3fb`, `1f448-1f3fc`, `1f448-1f3fd`, `1f448-1f3fe`, `1f448-1f3ff`],
      },
      {
        n: [`white right pointing backhand index`, `point_right`],
        u: `1f449`,
        v: [`1f449-1f3fb`, `1f449-1f3fc`, `1f449-1f3fd`, `1f449-1f3fe`, `1f449-1f3ff`],
      },
      {
        n: [`white up pointing index`, `point_up`],
        u: `261d-fe0f`,
        v: [`261d-1f3fb`, `261d-1f3fc`, `261d-1f3fd`, `261d-1f3fe`, `261d-1f3ff`],
      },
      {
        n: [`white up pointing backhand index`, `point_up_2`],
        u: `1f446`,
        v: [`1f446-1f3fb`, `1f446-1f3fc`, `1f446-1f3fd`, `1f446-1f3fe`, `1f446-1f3ff`],
      },
      {
        n: [
          `reversed hand with middle finger extended`,
          `middle_finger`,
          `reversed_hand_with_middle_finger_extended`,
        ],
        u: `1f595`,
        v: [`1f595-1f3fb`, `1f595-1f3fc`, `1f595-1f3fd`, `1f595-1f3fe`, `1f595-1f3ff`],
      },
      {
        n: [`white down pointing backhand index`, `point_down`],
        u: `1f447`,
        v: [`1f447-1f3fb`, `1f447-1f3fc`, `1f447-1f3fd`, `1f447-1f3fe`, `1f447-1f3ff`],
      },
      {
        n: [`victory hand`, `v`],
        u: `270c-fe0f`,
        v: [`270c-1f3fb`, `270c-1f3fc`, `270c-1f3fd`, `270c-1f3fe`, `270c-1f3ff`],
      },
      {
        n: [
          `hand with index and middle fingers crossed`,
          `crossed_fingers`,
          `hand_with_index_and_middle_fingers_crossed`,
        ],
        u: `1f91e`,
        v: [`1f91e-1f3fb`, `1f91e-1f3fc`, `1f91e-1f3fd`, `1f91e-1f3fe`, `1f91e-1f3ff`],
      },
      {
        n: [`raised hand with part between middle and ring fingers`, `spock-hand`],
        u: `1f596`,
        v: [`1f596-1f3fb`, `1f596-1f3fc`, `1f596-1f3fd`, `1f596-1f3fe`, `1f596-1f3ff`],
      },
      {
        n: [`sign of the horns`, `the_horns`, `sign_of_the_horns`],
        u: `1f918`,
        v: [`1f918-1f3fb`, `1f918-1f3fc`, `1f918-1f3fd`, `1f918-1f3fe`, `1f918-1f3ff`],
      },
      {
        n: [`call me hand`, `call_me_hand`],
        u: `1f919`,
        v: [`1f919-1f3fb`, `1f919-1f3fc`, `1f919-1f3fd`, `1f919-1f3fe`, `1f919-1f3ff`],
      },
      {
        n: [`raised_hand_with_fingers_splayed`],
        u: `1f590-fe0f`,
        v: [`1f590-1f3fb`, `1f590-1f3fc`, `1f590-1f3fd`, `1f590-1f3fe`, `1f590-1f3ff`],
      },
      {
        n: [`raised hand`, `hand`, `raised_hand`],
        u: `270b`,
        v: [`270b-1f3fb`, `270b-1f3fc`, `270b-1f3fd`, `270b-1f3fe`, `270b-1f3ff`],
      },
      {
        n: [`ok hand sign`, `ok_hand`],
        u: `1f44c`,
        v: [`1f44c-1f3fb`, `1f44c-1f3fc`, `1f44c-1f3fd`, `1f44c-1f3fe`, `1f44c-1f3ff`],
      },
      {
        n: [`thumbs up sign`, `+1`, `thumbsup`],
        u: `1f44d`,
        v: [`1f44d-1f3fb`, `1f44d-1f3fc`, `1f44d-1f3fd`, `1f44d-1f3fe`, `1f44d-1f3ff`],
      },
      {
        n: [`thumbs down sign`, `-1`, `thumbsdown`],
        u: `1f44e`,
        v: [`1f44e-1f3fb`, `1f44e-1f3fc`, `1f44e-1f3fd`, `1f44e-1f3fe`, `1f44e-1f3ff`],
      },
      {
        n: [`raised fist`, `fist`],
        u: `270a`,
        v: [`270a-1f3fb`, `270a-1f3fc`, `270a-1f3fd`, `270a-1f3fe`, `270a-1f3ff`],
      },
      {
        n: [`fisted hand sign`, `facepunch`, `punch`],
        u: `1f44a`,
        v: [`1f44a-1f3fb`, `1f44a-1f3fc`, `1f44a-1f3fd`, `1f44a-1f3fe`, `1f44a-1f3ff`],
      },
      {
        n: [`left-facing fist`, `left-facing_fist`],
        u: `1f91b`,
        v: [`1f91b-1f3fb`, `1f91b-1f3fc`, `1f91b-1f3fd`, `1f91b-1f3fe`, `1f91b-1f3ff`],
      },
      {
        n: [`right-facing fist`, `right-facing_fist`],
        u: `1f91c`,
        v: [`1f91c-1f3fb`, `1f91c-1f3fc`, `1f91c-1f3fd`, `1f91c-1f3fe`, `1f91c-1f3ff`],
      },
      {
        n: [`raised back of hand`, `raised_back_of_hand`],
        u: `1f91a`,
        v: [`1f91a-1f3fb`, `1f91a-1f3fc`, `1f91a-1f3fd`, `1f91a-1f3fe`, `1f91a-1f3ff`],
      },
      {
        n: [`waving hand sign`, `wave`],
        u: `1f44b`,
        v: [`1f44b-1f3fb`, `1f44b-1f3fc`, `1f44b-1f3fd`, `1f44b-1f3fe`, `1f44b-1f3ff`],
      },
      {
        n: [`i love you hand sign`, `i_love_you_hand_sign`],
        u: `1f91f`,
        v: [`1f91f-1f3fb`, `1f91f-1f3fc`, `1f91f-1f3fd`, `1f91f-1f3fe`, `1f91f-1f3ff`],
      },
      {
        n: [`writing_hand`],
        u: `270d-fe0f`,
        v: [`270d-1f3fb`, `270d-1f3fc`, `270d-1f3fd`, `270d-1f3fe`, `270d-1f3ff`],
      },
      {
        n: [`clapping hands sign`, `clap`],
        u: `1f44f`,
        v: [`1f44f-1f3fb`, `1f44f-1f3fc`, `1f44f-1f3fd`, `1f44f-1f3fe`, `1f44f-1f3ff`],
      },
      {
        n: [`open hands sign`, `open_hands`],
        u: `1f450`,
        v: [`1f450-1f3fb`, `1f450-1f3fc`, `1f450-1f3fd`, `1f450-1f3fe`, `1f450-1f3ff`],
      },
      {
        n: [`person raising both hands in celebration`, `raised_hands`],
        u: `1f64c`,
        v: [`1f64c-1f3fb`, `1f64c-1f3fc`, `1f64c-1f3fd`, `1f64c-1f3fe`, `1f64c-1f3ff`],
      },
      {
        n: [`palms up together`, `palms_up_together`],
        u: `1f932`,
        v: [`1f932-1f3fb`, `1f932-1f3fc`, `1f932-1f3fd`, `1f932-1f3fe`, `1f932-1f3ff`],
      },
      {
        n: [`person with folded hands`, `pray`],
        u: `1f64f`,
        v: [`1f64f-1f3fb`, `1f64f-1f3fc`, `1f64f-1f3fd`, `1f64f-1f3fe`, `1f64f-1f3ff`],
      },
      {
        n: [`handshake`],
        u: `1f91d`,
      },
      {
        n: [`nail polish`, `nail_care`],
        u: `1f485`,
        v: [`1f485-1f3fb`, `1f485-1f3fc`, `1f485-1f3fd`, `1f485-1f3fe`, `1f485-1f3ff`],
      },
      {
        n: [`ear`],
        u: `1f442`,
        v: [`1f442-1f3fb`, `1f442-1f3fc`, `1f442-1f3fd`, `1f442-1f3fe`, `1f442-1f3ff`],
      },
      {
        n: [`nose`],
        u: `1f443`,
        v: [`1f443-1f3fb`, `1f443-1f3fc`, `1f443-1f3fd`, `1f443-1f3fe`, `1f443-1f3ff`],
      },
      {
        n: [`footprints`],
        u: `1f463`,
      },
      {
        n: [`eyes`],
        u: `1f440`,
      },
      {
        n: [`eye`],
        u: `1f441-fe0f`,
      },
      {
        n: [`eye-in-speech-bubble`],
        u: `1f441-fe0f-200d-1f5e8-fe0f`,
      },
      {
        n: [`brain`],
        u: `1f9e0`,
      },
      {
        n: [`tongue`],
        u: `1f445`,
      },
      {
        n: [`mouth`, `lips`],
        u: `1f444`,
      },
      {
        n: [`kiss mark`, `kiss`],
        u: `1f48b`,
      },
      {
        n: [`heart with arrow`, `cupid`],
        u: `1f498`,
      },
      {
        n: [`heavy black heart`, `heart`],
        u: `2764-fe0f`,
      },
      {
        n: [`beating heart`, `heartbeat`],
        u: `1f493`,
      },
      {
        n: [`broken heart`, `broken_heart`],
        u: `1f494`,
      },
      {
        n: [`two hearts`, `two_hearts`],
        u: `1f495`,
      },
      {
        n: [`sparkling heart`, `sparkling_heart`],
        u: `1f496`,
      },
      {
        n: [`growing heart`, `heartpulse`],
        u: `1f497`,
      },
      {
        n: [`blue heart`, `blue_heart`],
        u: `1f499`,
      },
      {
        n: [`green heart`, `green_heart`],
        u: `1f49a`,
      },
      {
        n: [`yellow heart`, `yellow_heart`],
        u: `1f49b`,
      },
      {
        n: [`orange heart`, `orange_heart`],
        u: `1f9e1`,
      },
      {
        n: [`purple heart`, `purple_heart`],
        u: `1f49c`,
      },
      {
        n: [`black heart`, `black_heart`],
        u: `1f5a4`,
      },
      {
        n: [`heart with ribbon`, `gift_heart`],
        u: `1f49d`,
      },
      {
        n: [`revolving hearts`, `revolving_hearts`],
        u: `1f49e`,
      },
      {
        n: [`heart decoration`, `heart_decoration`],
        u: `1f49f`,
      },
      {
        n: [`heavy_heart_exclamation_mark_ornament`],
        u: `2763-fe0f`,
      },
      {
        n: [`love letter`, `love_letter`],
        u: `1f48c`,
      },
      {
        n: [`sleeping symbol`, `zzz`],
        u: `1f4a4`,
      },
      {
        n: [`anger symbol`, `anger`],
        u: `1f4a2`,
      },
      {
        n: [`bomb`],
        u: `1f4a3`,
      },
      {
        n: [`collision symbol`, `boom`, `collision`],
        u: `1f4a5`,
      },
      {
        n: [`splashing sweat symbol`, `sweat_drops`],
        u: `1f4a6`,
      },
      {
        n: [`dash symbol`, `dash`],
        u: `1f4a8`,
      },
      {
        n: [`dizzy symbol`, `dizzy`],
        u: `1f4ab`,
      },
      {
        n: [`speech balloon`, `speech_balloon`],
        u: `1f4ac`,
      },
      {
        n: [`left_speech_bubble`],
        u: `1f5e8-fe0f`,
      },
      {
        n: [`right_anger_bubble`],
        u: `1f5ef-fe0f`,
      },
      {
        n: [`thought balloon`, `thought_balloon`],
        u: `1f4ad`,
      },
      {
        n: [`hole`],
        u: `1f573-fe0f`,
      },
      {
        n: [`eyeglasses`],
        u: `1f453`,
      },
      {
        n: [`dark_sunglasses`],
        u: `1f576-fe0f`,
      },
      {
        n: [`necktie`],
        u: `1f454`,
      },
      {
        n: [`t-shirt`, `shirt`, `tshirt`],
        u: `1f455`,
      },
      {
        n: [`jeans`],
        u: `1f456`,
      },
      {
        n: [`scarf`],
        u: `1f9e3`,
      },
      {
        n: [`gloves`],
        u: `1f9e4`,
      },
      {
        n: [`coat`],
        u: `1f9e5`,
      },
      {
        n: [`socks`],
        u: `1f9e6`,
      },
      {
        n: [`dress`],
        u: `1f457`,
      },
      {
        n: [`kimono`],
        u: `1f458`,
      },
      {
        n: [`bikini`],
        u: `1f459`,
      },
      {
        n: [`womans clothes`, `womans_clothes`],
        u: `1f45a`,
      },
      {
        n: [`purse`],
        u: `1f45b`,
      },
      {
        n: [`handbag`],
        u: `1f45c`,
      },
      {
        n: [`pouch`],
        u: `1f45d`,
      },
      {
        n: [`shopping_bags`],
        u: `1f6cd-fe0f`,
      },
      {
        n: [`school satchel`, `school_satchel`],
        u: `1f392`,
      },
      {
        n: [`mans shoe`, `mans_shoe`, `shoe`],
        u: `1f45e`,
      },
      {
        n: [`athletic shoe`, `athletic_shoe`],
        u: `1f45f`,
      },
      {
        n: [`high-heeled shoe`, `high_heel`],
        u: `1f460`,
      },
      {
        n: [`womans sandal`, `sandal`],
        u: `1f461`,
      },
      {
        n: [`womans boots`, `boot`],
        u: `1f462`,
      },
      {
        n: [`crown`],
        u: `1f451`,
      },
      {
        n: [`womans hat`, `womans_hat`],
        u: `1f452`,
      },
      {
        n: [`top hat`, `tophat`],
        u: `1f3a9`,
      },
      {
        n: [`graduation cap`, `mortar_board`],
        u: `1f393`,
      },
      {
        n: [`billed cap`, `billed_cap`],
        u: `1f9e2`,
      },
      {
        n: [`helmet_with_white_cross`],
        u: `26d1-fe0f`,
      },
      {
        n: [`prayer beads`, `prayer_beads`],
        u: `1f4ff`,
      },
      {
        n: [`lipstick`],
        u: `1f484`,
      },
      {
        n: [`ring`],
        u: `1f48d`,
      },
      {
        n: [`gem stone`, `gem`],
        u: `1f48e`,
      },
    ],
    animals_nature: [
      {
        n: [`monkey face`, `monkey_face`],
        u: `1f435`,
      },
      {
        n: [`monkey`],
        u: `1f412`,
      },
      {
        n: [`gorilla`],
        u: `1f98d`,
      },
      {
        n: [`dog face`, `dog`],
        u: `1f436`,
      },
      {
        n: [`dog`, `dog2`],
        u: `1f415`,
      },
      {
        n: [`poodle`],
        u: `1f429`,
      },
      {
        n: [`wolf face`, `wolf`],
        u: `1f43a`,
      },
      {
        n: [`fox face`, `fox_face`],
        u: `1f98a`,
      },
      {
        n: [`cat face`, `cat`],
        u: `1f431`,
      },
      {
        n: [`cat`, `cat2`],
        u: `1f408`,
      },
      {
        n: [`lion face`, `lion_face`],
        u: `1f981`,
      },
      {
        n: [`tiger face`, `tiger`],
        u: `1f42f`,
      },
      {
        n: [`tiger`, `tiger2`],
        u: `1f405`,
      },
      {
        n: [`leopard`],
        u: `1f406`,
      },
      {
        n: [`horse face`, `horse`],
        u: `1f434`,
      },
      {
        n: [`horse`, `racehorse`],
        u: `1f40e`,
      },
      {
        n: [`unicorn face`, `unicorn_face`],
        u: `1f984`,
      },
      {
        n: [`zebra face`, `zebra_face`],
        u: `1f993`,
      },
      {
        n: [`deer`],
        u: `1f98c`,
      },
      {
        n: [`cow face`, `cow`],
        u: `1f42e`,
      },
      {
        n: [`ox`],
        u: `1f402`,
      },
      {
        n: [`water buffalo`, `water_buffalo`],
        u: `1f403`,
      },
      {
        n: [`cow`, `cow2`],
        u: `1f404`,
      },
      {
        n: [`pig face`, `pig`],
        u: `1f437`,
      },
      {
        n: [`pig`, `pig2`],
        u: `1f416`,
      },
      {
        n: [`boar`],
        u: `1f417`,
      },
      {
        n: [`pig nose`, `pig_nose`],
        u: `1f43d`,
      },
      {
        n: [`ram`],
        u: `1f40f`,
      },
      {
        n: [`sheep`],
        u: `1f411`,
      },
      {
        n: [`goat`],
        u: `1f410`,
      },
      {
        n: [`dromedary camel`, `dromedary_camel`],
        u: `1f42a`,
      },
      {
        n: [`bactrian camel`, `camel`],
        u: `1f42b`,
      },
      {
        n: [`giraffe face`, `giraffe_face`],
        u: `1f992`,
      },
      {
        n: [`elephant`],
        u: `1f418`,
      },
      {
        n: [`rhinoceros`],
        u: `1f98f`,
      },
      {
        n: [`mouse face`, `mouse`],
        u: `1f42d`,
      },
      {
        n: [`mouse`, `mouse2`],
        u: `1f401`,
      },
      {
        n: [`rat`],
        u: `1f400`,
      },
      {
        n: [`hamster face`, `hamster`],
        u: `1f439`,
      },
      {
        n: [`rabbit face`, `rabbit`],
        u: `1f430`,
      },
      {
        n: [`rabbit`, `rabbit2`],
        u: `1f407`,
      },
      {
        n: [`chipmunk`],
        u: `1f43f-fe0f`,
      },
      {
        n: [`hedgehog`],
        u: `1f994`,
      },
      {
        n: [`bat`],
        u: `1f987`,
      },
      {
        n: [`bear face`, `bear`],
        u: `1f43b`,
      },
      {
        n: [`koala`],
        u: `1f428`,
      },
      {
        n: [`panda face`, `panda_face`],
        u: `1f43c`,
      },
      {
        n: [`paw prints`, `feet`, `paw_prints`],
        u: `1f43e`,
      },
      {
        n: [`turkey`],
        u: `1f983`,
      },
      {
        n: [`chicken`],
        u: `1f414`,
      },
      {
        n: [`rooster`],
        u: `1f413`,
      },
      {
        n: [`hatching chick`, `hatching_chick`],
        u: `1f423`,
      },
      {
        n: [`baby chick`, `baby_chick`],
        u: `1f424`,
      },
      {
        n: [`front-facing baby chick`, `hatched_chick`],
        u: `1f425`,
      },
      {
        n: [`bird`],
        u: `1f426`,
      },
      {
        n: [`penguin`],
        u: `1f427`,
      },
      {
        n: [`dove_of_peace`],
        u: `1f54a-fe0f`,
      },
      {
        n: [`eagle`],
        u: `1f985`,
      },
      {
        n: [`duck`],
        u: `1f986`,
      },
      {
        n: [`owl`],
        u: `1f989`,
      },
      {
        n: [`frog face`, `frog`],
        u: `1f438`,
      },
      {
        n: [`crocodile`],
        u: `1f40a`,
      },
      {
        n: [`turtle`],
        u: `1f422`,
      },
      {
        n: [`lizard`],
        u: `1f98e`,
      },
      {
        n: [`snake`],
        u: `1f40d`,
      },
      {
        n: [`dragon face`, `dragon_face`],
        u: `1f432`,
      },
      {
        n: [`dragon`],
        u: `1f409`,
      },
      {
        n: [`sauropod`],
        u: `1f995`,
      },
      {
        n: [`t-rex`],
        u: `1f996`,
      },
      {
        n: [`spouting whale`, `whale`],
        u: `1f433`,
      },
      {
        n: [`whale`, `whale2`],
        u: `1f40b`,
      },
      {
        n: [`dolphin`, `flipper`],
        u: `1f42c`,
      },
      {
        n: [`fish`],
        u: `1f41f`,
      },
      {
        n: [`tropical fish`, `tropical_fish`],
        u: `1f420`,
      },
      {
        n: [`blowfish`],
        u: `1f421`,
      },
      {
        n: [`shark`],
        u: `1f988`,
      },
      {
        n: [`octopus`],
        u: `1f419`,
      },
      {
        n: [`spiral shell`, `shell`],
        u: `1f41a`,
      },
      {
        n: [`crab`],
        u: `1f980`,
      },
      {
        n: [`shrimp`],
        u: `1f990`,
      },
      {
        n: [`squid`],
        u: `1f991`,
      },
      {
        n: [`snail`],
        u: `1f40c`,
      },
      {
        n: [`butterfly`],
        u: `1f98b`,
      },
      {
        n: [`bug`],
        u: `1f41b`,
      },
      {
        n: [`ant`],
        u: `1f41c`,
      },
      {
        n: [`honeybee`, `bee`],
        u: `1f41d`,
      },
      {
        n: [`lady beetle`, `beetle`],
        u: `1f41e`,
      },
      {
        n: [`cricket`],
        u: `1f997`,
      },
      {
        n: [`spider`],
        u: `1f577-fe0f`,
      },
      {
        n: [`spider_web`],
        u: `1f578-fe0f`,
      },
      {
        n: [`scorpion`],
        u: `1f982`,
      },
      {
        n: [`bouquet`],
        u: `1f490`,
      },
      {
        n: [`cherry blossom`, `cherry_blossom`],
        u: `1f338`,
      },
      {
        n: [`white flower`, `white_flower`],
        u: `1f4ae`,
      },
      {
        n: [`rosette`],
        u: `1f3f5-fe0f`,
      },
      {
        n: [`rose`],
        u: `1f339`,
      },
      {
        n: [`wilted flower`, `wilted_flower`],
        u: `1f940`,
      },
      {
        n: [`hibiscus`],
        u: `1f33a`,
      },
      {
        n: [`sunflower`],
        u: `1f33b`,
      },
      {
        n: [`blossom`],
        u: `1f33c`,
      },
      {
        n: [`tulip`],
        u: `1f337`,
      },
      {
        n: [`seedling`],
        u: `1f331`,
      },
      {
        n: [`evergreen tree`, `evergreen_tree`],
        u: `1f332`,
      },
      {
        n: [`deciduous tree`, `deciduous_tree`],
        u: `1f333`,
      },
      {
        n: [`palm tree`, `palm_tree`],
        u: `1f334`,
      },
      {
        n: [`cactus`],
        u: `1f335`,
      },
      {
        n: [`ear of rice`, `ear_of_rice`],
        u: `1f33e`,
      },
      {
        n: [`herb`],
        u: `1f33f`,
      },
      {
        n: [`shamrock`],
        u: `2618-fe0f`,
      },
      {
        n: [`four leaf clover`, `four_leaf_clover`],
        u: `1f340`,
      },
      {
        n: [`maple leaf`, `maple_leaf`],
        u: `1f341`,
      },
      {
        n: [`fallen leaf`, `fallen_leaf`],
        u: `1f342`,
      },
      {
        n: [`leaf fluttering in wind`, `leaves`],
        u: `1f343`,
      },
    ],
    food_drink: [
      {
        n: [`grapes`],
        u: `1f347`,
      },
      {
        n: [`melon`],
        u: `1f348`,
      },
      {
        n: [`watermelon`],
        u: `1f349`,
      },
      {
        n: [`tangerine`],
        u: `1f34a`,
      },
      {
        n: [`lemon`],
        u: `1f34b`,
      },
      {
        n: [`banana`],
        u: `1f34c`,
      },
      {
        n: [`pineapple`],
        u: `1f34d`,
      },
      {
        n: [`red apple`, `apple`],
        u: `1f34e`,
      },
      {
        n: [`green apple`, `green_apple`],
        u: `1f34f`,
      },
      {
        n: [`pear`],
        u: `1f350`,
      },
      {
        n: [`peach`],
        u: `1f351`,
      },
      {
        n: [`cherries`],
        u: `1f352`,
      },
      {
        n: [`strawberry`],
        u: `1f353`,
      },
      {
        n: [`kiwifruit`],
        u: `1f95d`,
      },
      {
        n: [`tomato`],
        u: `1f345`,
      },
      {
        n: [`coconut`],
        u: `1f965`,
      },
      {
        n: [`avocado`],
        u: `1f951`,
      },
      {
        n: [`aubergine`, `eggplant`],
        u: `1f346`,
      },
      {
        n: [`potato`],
        u: `1f954`,
      },
      {
        n: [`carrot`],
        u: `1f955`,
      },
      {
        n: [`ear of maize`, `corn`],
        u: `1f33d`,
      },
      {
        n: [`hot_pepper`],
        u: `1f336-fe0f`,
      },
      {
        n: [`cucumber`],
        u: `1f952`,
      },
      {
        n: [`broccoli`],
        u: `1f966`,
      },
      {
        n: [`mushroom`],
        u: `1f344`,
      },
      {
        n: [`peanuts`],
        u: `1f95c`,
      },
      {
        n: [`chestnut`],
        u: `1f330`,
      },
      {
        n: [`bread`],
        u: `1f35e`,
      },
      {
        n: [`croissant`],
        u: `1f950`,
      },
      {
        n: [`baguette bread`, `baguette_bread`],
        u: `1f956`,
      },
      {
        n: [`pretzel`],
        u: `1f968`,
      },
      {
        n: [`pancakes`],
        u: `1f95e`,
      },
      {
        n: [`cheese wedge`, `cheese_wedge`],
        u: `1f9c0`,
      },
      {
        n: [`meat on bone`, `meat_on_bone`],
        u: `1f356`,
      },
      {
        n: [`poultry leg`, `poultry_leg`],
        u: `1f357`,
      },
      {
        n: [`cut of meat`, `cut_of_meat`],
        u: `1f969`,
      },
      {
        n: [`bacon`],
        u: `1f953`,
      },
      {
        n: [`hamburger`],
        u: `1f354`,
      },
      {
        n: [`french fries`, `fries`],
        u: `1f35f`,
      },
      {
        n: [`slice of pizza`, `pizza`],
        u: `1f355`,
      },
      {
        n: [`hot dog`, `hotdog`],
        u: `1f32d`,
      },
      {
        n: [`sandwich`],
        u: `1f96a`,
      },
      {
        n: [`taco`],
        u: `1f32e`,
      },
      {
        n: [`burrito`],
        u: `1f32f`,
      },
      {
        n: [`stuffed flatbread`, `stuffed_flatbread`],
        u: `1f959`,
      },
      {
        n: [`egg`],
        u: `1f95a`,
      },
      {
        n: [`cooking`, `fried_egg`],
        u: `1f373`,
      },
      {
        n: [`shallow pan of food`, `shallow_pan_of_food`],
        u: `1f958`,
      },
      {
        n: [`pot of food`, `stew`],
        u: `1f372`,
      },
      {
        n: [`bowl with spoon`, `bowl_with_spoon`],
        u: `1f963`,
      },
      {
        n: [`green salad`, `green_salad`],
        u: `1f957`,
      },
      {
        n: [`popcorn`],
        u: `1f37f`,
      },
      {
        n: [`canned food`, `canned_food`],
        u: `1f96b`,
      },
      {
        n: [`bento box`, `bento`],
        u: `1f371`,
      },
      {
        n: [`rice cracker`, `rice_cracker`],
        u: `1f358`,
      },
      {
        n: [`rice ball`, `rice_ball`],
        u: `1f359`,
      },
      {
        n: [`cooked rice`, `rice`],
        u: `1f35a`,
      },
      {
        n: [`curry and rice`, `curry`],
        u: `1f35b`,
      },
      {
        n: [`steaming bowl`, `ramen`],
        u: `1f35c`,
      },
      {
        n: [`spaghetti`],
        u: `1f35d`,
      },
      {
        n: [`roasted sweet potato`, `sweet_potato`],
        u: `1f360`,
      },
      {
        n: [`oden`],
        u: `1f362`,
      },
      {
        n: [`sushi`],
        u: `1f363`,
      },
      {
        n: [`fried shrimp`, `fried_shrimp`],
        u: `1f364`,
      },
      {
        n: [`fish cake with swirl design`, `fish_cake`],
        u: `1f365`,
      },
      {
        n: [`dango`],
        u: `1f361`,
      },
      {
        n: [`dumpling`],
        u: `1f95f`,
      },
      {
        n: [`fortune cookie`, `fortune_cookie`],
        u: `1f960`,
      },
      {
        n: [`takeout box`, `takeout_box`],
        u: `1f961`,
      },
      {
        n: [`soft ice cream`, `icecream`],
        u: `1f366`,
      },
      {
        n: [`shaved ice`, `shaved_ice`],
        u: `1f367`,
      },
      {
        n: [`ice cream`, `ice_cream`],
        u: `1f368`,
      },
      {
        n: [`doughnut`],
        u: `1f369`,
      },
      {
        n: [`cookie`],
        u: `1f36a`,
      },
      {
        n: [`birthday cake`, `birthday`],
        u: `1f382`,
      },
      {
        n: [`shortcake`, `cake`],
        u: `1f370`,
      },
      {
        n: [`pie`],
        u: `1f967`,
      },
      {
        n: [`chocolate bar`, `chocolate_bar`],
        u: `1f36b`,
      },
      {
        n: [`candy`],
        u: `1f36c`,
      },
      {
        n: [`lollipop`],
        u: `1f36d`,
      },
      {
        n: [`custard`],
        u: `1f36e`,
      },
      {
        n: [`honey pot`, `honey_pot`],
        u: `1f36f`,
      },
      {
        n: [`baby bottle`, `baby_bottle`],
        u: `1f37c`,
      },
      {
        n: [`glass of milk`, `glass_of_milk`],
        u: `1f95b`,
      },
      {
        n: [`hot beverage`, `coffee`],
        u: `2615`,
      },
      {
        n: [`teacup without handle`, `tea`],
        u: `1f375`,
      },
      {
        n: [`sake bottle and cup`, `sake`],
        u: `1f376`,
      },
      {
        n: [`bottle with popping cork`, `champagne`],
        u: `1f37e`,
      },
      {
        n: [`wine glass`, `wine_glass`],
        u: `1f377`,
      },
      {
        n: [`cocktail glass`, `cocktail`],
        u: `1f378`,
      },
      {
        n: [`tropical drink`, `tropical_drink`],
        u: `1f379`,
      },
      {
        n: [`beer mug`, `beer`],
        u: `1f37a`,
      },
      {
        n: [`clinking beer mugs`, `beers`],
        u: `1f37b`,
      },
      {
        n: [`clinking glasses`, `clinking_glasses`],
        u: `1f942`,
      },
      {
        n: [`tumbler glass`, `tumbler_glass`],
        u: `1f943`,
      },
      {
        n: [`cup with straw`, `cup_with_straw`],
        u: `1f964`,
      },
      {
        n: [`chopsticks`],
        u: `1f962`,
      },
      {
        n: [`knife_fork_plate`],
        u: `1f37d-fe0f`,
      },
      {
        n: [`fork and knife`, `fork_and_knife`],
        u: `1f374`,
      },
      {
        n: [`spoon`],
        u: `1f944`,
      },
      {
        n: [`hocho`, `knife`],
        u: `1f52a`,
      },
      {
        n: [`amphora`],
        u: `1f3fa`,
      },
    ],
    activities: [
      {
        n: [`jack-o-lantern`, `jack_o_lantern`],
        u: `1f383`,
      },
      {
        n: [`christmas tree`, `christmas_tree`],
        u: `1f384`,
      },
      {
        n: [`fireworks`],
        u: `1f386`,
      },
      {
        n: [`firework sparkler`, `sparkler`],
        u: `1f387`,
      },
      {
        n: [`sparkles`],
        u: `2728`,
      },
      {
        n: [`balloon`],
        u: `1f388`,
      },
      {
        n: [`party popper`, `tada`],
        u: `1f389`,
      },
      {
        n: [`confetti ball`, `confetti_ball`],
        u: `1f38a`,
      },
      {
        n: [`tanabata tree`, `tanabata_tree`],
        u: `1f38b`,
      },
      {
        n: [`pine decoration`, `bamboo`],
        u: `1f38d`,
      },
      {
        n: [`japanese dolls`, `dolls`],
        u: `1f38e`,
      },
      {
        n: [`carp streamer`, `flags`],
        u: `1f38f`,
      },
      {
        n: [`wind chime`, `wind_chime`],
        u: `1f390`,
      },
      {
        n: [`moon viewing ceremony`, `rice_scene`],
        u: `1f391`,
      },
      {
        n: [`ribbon`],
        u: `1f380`,
      },
      {
        n: [`wrapped present`, `gift`],
        u: `1f381`,
      },
      {
        n: [`reminder_ribbon`],
        u: `1f397-fe0f`,
      },
      {
        n: [`admission_tickets`],
        u: `1f39f-fe0f`,
      },
      {
        n: [`ticket`],
        u: `1f3ab`,
      },
      {
        n: [`medal`],
        u: `1f396-fe0f`,
      },
      {
        n: [`trophy`],
        u: `1f3c6`,
      },
      {
        n: [`sports medal`, `sports_medal`],
        u: `1f3c5`,
      },
      {
        n: [`first place medal`, `first_place_medal`],
        u: `1f947`,
      },
      {
        n: [`second place medal`, `second_place_medal`],
        u: `1f948`,
      },
      {
        n: [`third place medal`, `third_place_medal`],
        u: `1f949`,
      },
      {
        n: [`soccer ball`, `soccer`],
        u: `26bd`,
      },
      {
        n: [`baseball`],
        u: `26be`,
      },
      {
        n: [`basketball and hoop`, `basketball`],
        u: `1f3c0`,
      },
      {
        n: [`volleyball`],
        u: `1f3d0`,
      },
      {
        n: [`american football`, `football`],
        u: `1f3c8`,
      },
      {
        n: [`rugby football`, `rugby_football`],
        u: `1f3c9`,
      },
      {
        n: [`tennis racquet and ball`, `tennis`],
        u: `1f3be`,
      },
      {
        n: [`billiards`, `8ball`],
        u: `1f3b1`,
      },
      {
        n: [`bowling`],
        u: `1f3b3`,
      },
      {
        n: [`cricket bat and ball`, `cricket_bat_and_ball`],
        u: `1f3cf`,
      },
      {
        n: [`field hockey stick and ball`, `field_hockey_stick_and_ball`],
        u: `1f3d1`,
      },
      {
        n: [`ice hockey stick and puck`, `ice_hockey_stick_and_puck`],
        u: `1f3d2`,
      },
      {
        n: [`table tennis paddle and ball`, `table_tennis_paddle_and_ball`],
        u: `1f3d3`,
      },
      {
        n: [`badminton racquet and shuttlecock`, `badminton_racquet_and_shuttlecock`],
        u: `1f3f8`,
      },
      {
        n: [`boxing glove`, `boxing_glove`],
        u: `1f94a`,
      },
      {
        n: [`martial arts uniform`, `martial_arts_uniform`],
        u: `1f94b`,
      },
      {
        n: [`goal net`, `goal_net`],
        u: `1f945`,
      },
      {
        n: [`direct hit`, `dart`],
        u: `1f3af`,
      },
      {
        n: [`flag in hole`, `golf`],
        u: `26f3`,
      },
      {
        n: [`ice_skate`],
        u: `26f8-fe0f`,
      },
      {
        n: [`fishing pole and fish`, `fishing_pole_and_fish`],
        u: `1f3a3`,
      },
      {
        n: [`running shirt with sash`, `running_shirt_with_sash`],
        u: `1f3bd`,
      },
      {
        n: [`ski and ski boot`, `ski`],
        u: `1f3bf`,
      },
      {
        n: [`sled`],
        u: `1f6f7`,
      },
      {
        n: [`curling stone`, `curling_stone`],
        u: `1f94c`,
      },
      {
        n: [`video game`, `video_game`],
        u: `1f3ae`,
      },
      {
        n: [`joystick`],
        u: `1f579-fe0f`,
      },
      {
        n: [`game die`, `game_die`],
        u: `1f3b2`,
      },
      {
        n: [`black spade suit`, `spades`],
        u: `2660-fe0f`,
      },
      {
        n: [`black heart suit`, `hearts`],
        u: `2665-fe0f`,
      },
      {
        n: [`black diamond suit`, `diamonds`],
        u: `2666-fe0f`,
      },
      {
        n: [`black club suit`, `clubs`],
        u: `2663-fe0f`,
      },
      {
        n: [`playing card black joker`, `black_joker`],
        u: `1f0cf`,
      },
      {
        n: [`mahjong tile red dragon`, `mahjong`],
        u: `1f004`,
      },
      {
        n: [`flower playing cards`, `flower_playing_cards`],
        u: `1f3b4`,
      },
    ],
    travel_places: [
      {
        n: [`earth globe europe-africa`, `earth_africa`],
        u: `1f30d`,
      },
      {
        n: [`earth globe americas`, `earth_americas`],
        u: `1f30e`,
      },
      {
        n: [`earth globe asia-australia`, `earth_asia`],
        u: `1f30f`,
      },
      {
        n: [`globe with meridians`, `globe_with_meridians`],
        u: `1f310`,
      },
      {
        n: [`world_map`],
        u: `1f5fa-fe0f`,
      },
      {
        n: [`silhouette of japan`, `japan`],
        u: `1f5fe`,
      },
      {
        n: [`snow_capped_mountain`],
        u: `1f3d4-fe0f`,
      },
      {
        n: [`mountain`],
        u: `26f0-fe0f`,
      },
      {
        n: [`volcano`],
        u: `1f30b`,
      },
      {
        n: [`mount fuji`, `mount_fuji`],
        u: `1f5fb`,
      },
      {
        n: [`camping`],
        u: `1f3d5-fe0f`,
      },
      {
        n: [`beach_with_umbrella`],
        u: `1f3d6-fe0f`,
      },
      {
        n: [`desert`],
        u: `1f3dc-fe0f`,
      },
      {
        n: [`desert_island`],
        u: `1f3dd-fe0f`,
      },
      {
        n: [`national_park`],
        u: `1f3de-fe0f`,
      },
      {
        n: [`stadium`],
        u: `1f3df-fe0f`,
      },
      {
        n: [`classical_building`],
        u: `1f3db-fe0f`,
      },
      {
        n: [`building_construction`],
        u: `1f3d7-fe0f`,
      },
      {
        n: [`house_buildings`],
        u: `1f3d8-fe0f`,
      },
      {
        n: [`cityscape`],
        u: `1f3d9-fe0f`,
      },
      {
        n: [`derelict_house_building`],
        u: `1f3da-fe0f`,
      },
      {
        n: [`house building`, `house`],
        u: `1f3e0`,
      },
      {
        n: [`house with garden`, `house_with_garden`],
        u: `1f3e1`,
      },
      {
        n: [`office building`, `office`],
        u: `1f3e2`,
      },
      {
        n: [`japanese post office`, `post_office`],
        u: `1f3e3`,
      },
      {
        n: [`european post office`, `european_post_office`],
        u: `1f3e4`,
      },
      {
        n: [`hospital`],
        u: `1f3e5`,
      },
      {
        n: [`bank`],
        u: `1f3e6`,
      },
      {
        n: [`hotel`],
        u: `1f3e8`,
      },
      {
        n: [`love hotel`, `love_hotel`],
        u: `1f3e9`,
      },
      {
        n: [`convenience store`, `convenience_store`],
        u: `1f3ea`,
      },
      {
        n: [`school`],
        u: `1f3eb`,
      },
      {
        n: [`department store`, `department_store`],
        u: `1f3ec`,
      },
      {
        n: [`factory`],
        u: `1f3ed`,
      },
      {
        n: [`japanese castle`, `japanese_castle`],
        u: `1f3ef`,
      },
      {
        n: [`european castle`, `european_castle`],
        u: `1f3f0`,
      },
      {
        n: [`wedding`],
        u: `1f492`,
      },
      {
        n: [`tokyo tower`, `tokyo_tower`],
        u: `1f5fc`,
      },
      {
        n: [`statue of liberty`, `statue_of_liberty`],
        u: `1f5fd`,
      },
      {
        n: [`church`],
        u: `26ea`,
      },
      {
        n: [`mosque`],
        u: `1f54c`,
      },
      {
        n: [`synagogue`],
        u: `1f54d`,
      },
      {
        n: [`shinto_shrine`],
        u: `26e9-fe0f`,
      },
      {
        n: [`kaaba`],
        u: `1f54b`,
      },
      {
        n: [`fountain`],
        u: `26f2`,
      },
      {
        n: [`tent`],
        u: `26fa`,
      },
      {
        n: [`foggy`],
        u: `1f301`,
      },
      {
        n: [`night with stars`, `night_with_stars`],
        u: `1f303`,
      },
      {
        n: [`sunrise over mountains`, `sunrise_over_mountains`],
        u: `1f304`,
      },
      {
        n: [`sunrise`],
        u: `1f305`,
      },
      {
        n: [`cityscape at dusk`, `city_sunset`],
        u: `1f306`,
      },
      {
        n: [`sunset over buildings`, `city_sunrise`],
        u: `1f307`,
      },
      {
        n: [`bridge at night`, `bridge_at_night`],
        u: `1f309`,
      },
      {
        n: [`hot springs`, `hotsprings`],
        u: `2668-fe0f`,
      },
      {
        n: [`milky way`, `milky_way`],
        u: `1f30c`,
      },
      {
        n: [`carousel horse`, `carousel_horse`],
        u: `1f3a0`,
      },
      {
        n: [`ferris wheel`, `ferris_wheel`],
        u: `1f3a1`,
      },
      {
        n: [`roller coaster`, `roller_coaster`],
        u: `1f3a2`,
      },
      {
        n: [`barber pole`, `barber`],
        u: `1f488`,
      },
      {
        n: [`circus tent`, `circus_tent`],
        u: `1f3aa`,
      },
      {
        n: [`performing arts`, `performing_arts`],
        u: `1f3ad`,
      },
      {
        n: [`frame_with_picture`],
        u: `1f5bc-fe0f`,
      },
      {
        n: [`artist palette`, `art`],
        u: `1f3a8`,
      },
      {
        n: [`slot machine`, `slot_machine`],
        u: `1f3b0`,
      },
      {
        n: [`steam locomotive`, `steam_locomotive`],
        u: `1f682`,
      },
      {
        n: [`railway car`, `railway_car`],
        u: `1f683`,
      },
      {
        n: [`high-speed train`, `bullettrain_side`],
        u: `1f684`,
      },
      {
        n: [`high-speed train with bullet nose`, `bullettrain_front`],
        u: `1f685`,
      },
      {
        n: [`train`, `train2`],
        u: `1f686`,
      },
      {
        n: [`metro`],
        u: `1f687`,
      },
      {
        n: [`light rail`, `light_rail`],
        u: `1f688`,
      },
      {
        n: [`station`],
        u: `1f689`,
      },
      {
        n: [`tram`],
        u: `1f68a`,
      },
      {
        n: [`monorail`],
        u: `1f69d`,
      },
      {
        n: [`mountain railway`, `mountain_railway`],
        u: `1f69e`,
      },
      {
        n: [`tram car`, `train`],
        u: `1f68b`,
      },
      {
        n: [`bus`],
        u: `1f68c`,
      },
      {
        n: [`oncoming bus`, `oncoming_bus`],
        u: `1f68d`,
      },
      {
        n: [`trolleybus`],
        u: `1f68e`,
      },
      {
        n: [`minibus`],
        u: `1f690`,
      },
      {
        n: [`ambulance`],
        u: `1f691`,
      },
      {
        n: [`fire engine`, `fire_engine`],
        u: `1f692`,
      },
      {
        n: [`police car`, `police_car`],
        u: `1f693`,
      },
      {
        n: [`oncoming police car`, `oncoming_police_car`],
        u: `1f694`,
      },
      {
        n: [`taxi`],
        u: `1f695`,
      },
      {
        n: [`oncoming taxi`, `oncoming_taxi`],
        u: `1f696`,
      },
      {
        n: [`automobile`, `car`, `red_car`],
        u: `1f697`,
      },
      {
        n: [`oncoming automobile`, `oncoming_automobile`],
        u: `1f698`,
      },
      {
        n: [`recreational vehicle`, `blue_car`],
        u: `1f699`,
      },
      {
        n: [`delivery truck`, `truck`],
        u: `1f69a`,
      },
      {
        n: [`articulated lorry`, `articulated_lorry`],
        u: `1f69b`,
      },
      {
        n: [`tractor`],
        u: `1f69c`,
      },
      {
        n: [`bicycle`, `bike`],
        u: `1f6b2`,
      },
      {
        n: [`scooter`],
        u: `1f6f4`,
      },
      {
        n: [`motor scooter`, `motor_scooter`],
        u: `1f6f5`,
      },
      {
        n: [`bus stop`, `busstop`],
        u: `1f68f`,
      },
      {
        n: [`motorway`],
        u: `1f6e3-fe0f`,
      },
      {
        n: [`railway_track`],
        u: `1f6e4-fe0f`,
      },
      {
        n: [`fuel pump`, `fuelpump`],
        u: `26fd`,
      },
      {
        n: [`police cars revolving light`, `rotating_light`],
        u: `1f6a8`,
      },
      {
        n: [`horizontal traffic light`, `traffic_light`],
        u: `1f6a5`,
      },
      {
        n: [`vertical traffic light`, `vertical_traffic_light`],
        u: `1f6a6`,
      },
      {
        n: [`construction sign`, `construction`],
        u: `1f6a7`,
      },
      {
        n: [`octagonal sign`, `octagonal_sign`],
        u: `1f6d1`,
      },
      {
        n: [`anchor`],
        u: `2693`,
      },
      {
        n: [`sailboat`, `boat`],
        u: `26f5`,
      },
      {
        n: [`canoe`],
        u: `1f6f6`,
      },
      {
        n: [`speedboat`],
        u: `1f6a4`,
      },
      {
        n: [`passenger_ship`],
        u: `1f6f3-fe0f`,
      },
      {
        n: [`ferry`],
        u: `26f4-fe0f`,
      },
      {
        n: [`motor_boat`],
        u: `1f6e5-fe0f`,
      },
      {
        n: [`ship`],
        u: `1f6a2`,
      },
      {
        n: [`airplane`],
        u: `2708-fe0f`,
      },
      {
        n: [`small_airplane`],
        u: `1f6e9-fe0f`,
      },
      {
        n: [`airplane departure`, `airplane_departure`],
        u: `1f6eb`,
      },
      {
        n: [`airplane arriving`, `airplane_arriving`],
        u: `1f6ec`,
      },
      {
        n: [`seat`],
        u: `1f4ba`,
      },
      {
        n: [`helicopter`],
        u: `1f681`,
      },
      {
        n: [`suspension railway`, `suspension_railway`],
        u: `1f69f`,
      },
      {
        n: [`mountain cableway`, `mountain_cableway`],
        u: `1f6a0`,
      },
      {
        n: [`aerial tramway`, `aerial_tramway`],
        u: `1f6a1`,
      },
      {
        n: [`satellite`],
        u: `1f6f0-fe0f`,
      },
      {
        n: [`rocket`],
        u: `1f680`,
      },
      {
        n: [`flying saucer`, `flying_saucer`],
        u: `1f6f8`,
      },
      {
        n: [`bellhop_bell`],
        u: `1f6ce-fe0f`,
      },
      {
        n: [`door`],
        u: `1f6aa`,
      },
      {
        n: [`bed`],
        u: `1f6cf-fe0f`,
      },
      {
        n: [`couch_and_lamp`],
        u: `1f6cb-fe0f`,
      },
      {
        n: [`toilet`],
        u: `1f6bd`,
      },
      {
        n: [`shower`],
        u: `1f6bf`,
      },
      {
        n: [`bathtub`],
        u: `1f6c1`,
      },
      {
        n: [`hourglass`],
        u: `231b`,
      },
      {
        n: [`hourglass with flowing sand`, `hourglass_flowing_sand`],
        u: `23f3`,
      },
      {
        n: [`watch`],
        u: `231a`,
      },
      {
        n: [`alarm clock`, `alarm_clock`],
        u: `23f0`,
      },
      {
        n: [`stopwatch`],
        u: `23f1-fe0f`,
      },
      {
        n: [`timer_clock`],
        u: `23f2-fe0f`,
      },
      {
        n: [`mantelpiece_clock`],
        u: `1f570-fe0f`,
      },
      {
        n: [`clock face twelve oclock`, `clock12`],
        u: `1f55b`,
      },
      {
        n: [`clock face twelve-thirty`, `clock1230`],
        u: `1f567`,
      },
      {
        n: [`clock face one oclock`, `clock1`],
        u: `1f550`,
      },
      {
        n: [`clock face one-thirty`, `clock130`],
        u: `1f55c`,
      },
      {
        n: [`clock face two oclock`, `clock2`],
        u: `1f551`,
      },
      {
        n: [`clock face two-thirty`, `clock230`],
        u: `1f55d`,
      },
      {
        n: [`clock face three oclock`, `clock3`],
        u: `1f552`,
      },
      {
        n: [`clock face three-thirty`, `clock330`],
        u: `1f55e`,
      },
      {
        n: [`clock face four oclock`, `clock4`],
        u: `1f553`,
      },
      {
        n: [`clock face four-thirty`, `clock430`],
        u: `1f55f`,
      },
      {
        n: [`clock face five oclock`, `clock5`],
        u: `1f554`,
      },
      {
        n: [`clock face five-thirty`, `clock530`],
        u: `1f560`,
      },
      {
        n: [`clock face six oclock`, `clock6`],
        u: `1f555`,
      },
      {
        n: [`clock face six-thirty`, `clock630`],
        u: `1f561`,
      },
      {
        n: [`clock face seven oclock`, `clock7`],
        u: `1f556`,
      },
      {
        n: [`clock face seven-thirty`, `clock730`],
        u: `1f562`,
      },
      {
        n: [`clock face eight oclock`, `clock8`],
        u: `1f557`,
      },
      {
        n: [`clock face eight-thirty`, `clock830`],
        u: `1f563`,
      },
      {
        n: [`clock face nine oclock`, `clock9`],
        u: `1f558`,
      },
      {
        n: [`clock face nine-thirty`, `clock930`],
        u: `1f564`,
      },
      {
        n: [`clock face ten oclock`, `clock10`],
        u: `1f559`,
      },
      {
        n: [`clock face ten-thirty`, `clock1030`],
        u: `1f565`,
      },
      {
        n: [`clock face eleven oclock`, `clock11`],
        u: `1f55a`,
      },
      {
        n: [`clock face eleven-thirty`, `clock1130`],
        u: `1f566`,
      },
      {
        n: [`new moon symbol`, `new_moon`],
        u: `1f311`,
      },
      {
        n: [`waxing crescent moon symbol`, `waxing_crescent_moon`],
        u: `1f312`,
      },
      {
        n: [`first quarter moon symbol`, `first_quarter_moon`],
        u: `1f313`,
      },
      {
        n: [`waxing gibbous moon symbol`, `moon`, `waxing_gibbous_moon`],
        u: `1f314`,
      },
      {
        n: [`full moon symbol`, `full_moon`],
        u: `1f315`,
      },
      {
        n: [`waning gibbous moon symbol`, `waning_gibbous_moon`],
        u: `1f316`,
      },
      {
        n: [`last quarter moon symbol`, `last_quarter_moon`],
        u: `1f317`,
      },
      {
        n: [`waning crescent moon symbol`, `waning_crescent_moon`],
        u: `1f318`,
      },
      {
        n: [`crescent moon`, `crescent_moon`],
        u: `1f319`,
      },
      {
        n: [`new moon with face`, `new_moon_with_face`],
        u: `1f31a`,
      },
      {
        n: [`first quarter moon with face`, `first_quarter_moon_with_face`],
        u: `1f31b`,
      },
      {
        n: [`last quarter moon with face`, `last_quarter_moon_with_face`],
        u: `1f31c`,
      },
      {
        n: [`thermometer`],
        u: `1f321-fe0f`,
      },
      {
        n: [`black sun with rays`, `sunny`],
        u: `2600-fe0f`,
      },
      {
        n: [`full moon with face`, `full_moon_with_face`],
        u: `1f31d`,
      },
      {
        n: [`sun with face`, `sun_with_face`],
        u: `1f31e`,
      },
      {
        n: [`white medium star`, `star`],
        u: `2b50`,
      },
      {
        n: [`glowing star`, `star2`],
        u: `1f31f`,
      },
      {
        n: [`shooting star`, `stars`],
        u: `1f320`,
      },
      {
        n: [`cloud`],
        u: `2601-fe0f`,
      },
      {
        n: [`sun behind cloud`, `partly_sunny`],
        u: `26c5`,
      },
      {
        n: [`thunder_cloud_and_rain`],
        u: `26c8-fe0f`,
      },
      {
        n: [`mostly_sunny`, `sun_small_cloud`],
        u: `1f324-fe0f`,
      },
      {
        n: [`barely_sunny`, `sun_behind_cloud`],
        u: `1f325-fe0f`,
      },
      {
        n: [`partly_sunny_rain`, `sun_behind_rain_cloud`],
        u: `1f326-fe0f`,
      },
      {
        n: [`rain_cloud`],
        u: `1f327-fe0f`,
      },
      {
        n: [`snow_cloud`],
        u: `1f328-fe0f`,
      },
      {
        n: [`lightning`, `lightning_cloud`],
        u: `1f329-fe0f`,
      },
      {
        n: [`tornado`, `tornado_cloud`],
        u: `1f32a-fe0f`,
      },
      {
        n: [`fog`],
        u: `1f32b-fe0f`,
      },
      {
        n: [`wind_blowing_face`],
        u: `1f32c-fe0f`,
      },
      {
        n: [`cyclone`],
        u: `1f300`,
      },
      {
        n: [`rainbow`],
        u: `1f308`,
      },
      {
        n: [`closed umbrella`, `closed_umbrella`],
        u: `1f302`,
      },
      {
        n: [`umbrella`],
        u: `2602-fe0f`,
      },
      {
        n: [`umbrella with rain drops`, `umbrella_with_rain_drops`],
        u: `2614`,
      },
      {
        n: [`umbrella_on_ground`],
        u: `26f1-fe0f`,
      },
      {
        n: [`high voltage sign`, `zap`],
        u: `26a1`,
      },
      {
        n: [`snowflake`],
        u: `2744-fe0f`,
      },
      {
        n: [`snowman`],
        u: `2603-fe0f`,
      },
      {
        n: [`snowman without snow`, `snowman_without_snow`],
        u: `26c4`,
      },
      {
        n: [`comet`],
        u: `2604-fe0f`,
      },
      {
        n: [`fire`],
        u: `1f525`,
      },
      {
        n: [`droplet`],
        u: `1f4a7`,
      },
      {
        n: [`water wave`, `ocean`],
        u: `1f30a`,
      },
    ],
    objects: [
      {
        n: [`speaker with cancellation stroke`, `mute`],
        u: `1f507`,
      },
      {
        n: [`speaker`],
        u: `1f508`,
      },
      {
        n: [`speaker with one sound wave`, `sound`],
        u: `1f509`,
      },
      {
        n: [`speaker with three sound waves`, `loud_sound`],
        u: `1f50a`,
      },
      {
        n: [`public address loudspeaker`, `loudspeaker`],
        u: `1f4e2`,
      },
      {
        n: [`cheering megaphone`, `mega`],
        u: `1f4e3`,
      },
      {
        n: [`postal horn`, `postal_horn`],
        u: `1f4ef`,
      },
      {
        n: [`bell`],
        u: `1f514`,
      },
      {
        n: [`bell with cancellation stroke`, `no_bell`],
        u: `1f515`,
      },
      {
        n: [`musical score`, `musical_score`],
        u: `1f3bc`,
      },
      {
        n: [`musical note`, `musical_note`],
        u: `1f3b5`,
      },
      {
        n: [`multiple musical notes`, `notes`],
        u: `1f3b6`,
      },
      {
        n: [`studio_microphone`],
        u: `1f399-fe0f`,
      },
      {
        n: [`level_slider`],
        u: `1f39a-fe0f`,
      },
      {
        n: [`control_knobs`],
        u: `1f39b-fe0f`,
      },
      {
        n: [`microphone`],
        u: `1f3a4`,
      },
      {
        n: [`headphone`, `headphones`],
        u: `1f3a7`,
      },
      {
        n: [`radio`],
        u: `1f4fb`,
      },
      {
        n: [`saxophone`],
        u: `1f3b7`,
      },
      {
        n: [`guitar`],
        u: `1f3b8`,
      },
      {
        n: [`musical keyboard`, `musical_keyboard`],
        u: `1f3b9`,
      },
      {
        n: [`trumpet`],
        u: `1f3ba`,
      },
      {
        n: [`violin`],
        u: `1f3bb`,
      },
      {
        n: [`drum with drumsticks`, `drum_with_drumsticks`],
        u: `1f941`,
      },
      {
        n: [`mobile phone`, `iphone`],
        u: `1f4f1`,
      },
      {
        n: [`mobile phone with rightwards arrow at left`, `calling`],
        u: `1f4f2`,
      },
      {
        n: [`black telephone`, `phone`, `telephone`],
        u: `260e-fe0f`,
      },
      {
        n: [`telephone receiver`, `telephone_receiver`],
        u: `1f4de`,
      },
      {
        n: [`pager`],
        u: `1f4df`,
      },
      {
        n: [`fax machine`, `fax`],
        u: `1f4e0`,
      },
      {
        n: [`battery`],
        u: `1f50b`,
      },
      {
        n: [`electric plug`, `electric_plug`],
        u: `1f50c`,
      },
      {
        n: [`personal computer`, `computer`],
        u: `1f4bb`,
      },
      {
        n: [`desktop_computer`],
        u: `1f5a5-fe0f`,
      },
      {
        n: [`printer`],
        u: `1f5a8-fe0f`,
      },
      {
        n: [`keyboard`],
        u: `2328-fe0f`,
      },
      {
        n: [`three_button_mouse`],
        u: `1f5b1-fe0f`,
      },
      {
        n: [`trackball`],
        u: `1f5b2-fe0f`,
      },
      {
        n: [`minidisc`],
        u: `1f4bd`,
      },
      {
        n: [`floppy disk`, `floppy_disk`],
        u: `1f4be`,
      },
      {
        n: [`optical disc`, `cd`],
        u: `1f4bf`,
      },
      {
        n: [`dvd`],
        u: `1f4c0`,
      },
      {
        n: [`movie camera`, `movie_camera`],
        u: `1f3a5`,
      },
      {
        n: [`film_frames`],
        u: `1f39e-fe0f`,
      },
      {
        n: [`film_projector`],
        u: `1f4fd-fe0f`,
      },
      {
        n: [`clapper board`, `clapper`],
        u: `1f3ac`,
      },
      {
        n: [`television`, `tv`],
        u: `1f4fa`,
      },
      {
        n: [`camera`],
        u: `1f4f7`,
      },
      {
        n: [`camera with flash`, `camera_with_flash`],
        u: `1f4f8`,
      },
      {
        n: [`video camera`, `video_camera`],
        u: `1f4f9`,
      },
      {
        n: [`videocassette`, `vhs`],
        u: `1f4fc`,
      },
      {
        n: [`left-pointing magnifying glass`, `mag`],
        u: `1f50d`,
      },
      {
        n: [`right-pointing magnifying glass`, `mag_right`],
        u: `1f50e`,
      },
      {
        n: [`microscope`],
        u: `1f52c`,
      },
      {
        n: [`telescope`],
        u: `1f52d`,
      },
      {
        n: [`satellite antenna`, `satellite_antenna`],
        u: `1f4e1`,
      },
      {
        n: [`candle`],
        u: `1f56f-fe0f`,
      },
      {
        n: [`electric light bulb`, `bulb`],
        u: `1f4a1`,
      },
      {
        n: [`electric torch`, `flashlight`],
        u: `1f526`,
      },
      {
        n: [`izakaya lantern`, `izakaya_lantern`, `lantern`],
        u: `1f3ee`,
      },
      {
        n: [`notebook with decorative cover`, `notebook_with_decorative_cover`],
        u: `1f4d4`,
      },
      {
        n: [`closed book`, `closed_book`],
        u: `1f4d5`,
      },
      {
        n: [`open book`, `book`, `open_book`],
        u: `1f4d6`,
      },
      {
        n: [`green book`, `green_book`],
        u: `1f4d7`,
      },
      {
        n: [`blue book`, `blue_book`],
        u: `1f4d8`,
      },
      {
        n: [`orange book`, `orange_book`],
        u: `1f4d9`,
      },
      {
        n: [`books`],
        u: `1f4da`,
      },
      {
        n: [`notebook`],
        u: `1f4d3`,
      },
      {
        n: [`ledger`],
        u: `1f4d2`,
      },
      {
        n: [`page with curl`, `page_with_curl`],
        u: `1f4c3`,
      },
      {
        n: [`scroll`],
        u: `1f4dc`,
      },
      {
        n: [`page facing up`, `page_facing_up`],
        u: `1f4c4`,
      },
      {
        n: [`newspaper`],
        u: `1f4f0`,
      },
      {
        n: [`rolled_up_newspaper`],
        u: `1f5de-fe0f`,
      },
      {
        n: [`bookmark tabs`, `bookmark_tabs`],
        u: `1f4d1`,
      },
      {
        n: [`bookmark`],
        u: `1f516`,
      },
      {
        n: [`label`],
        u: `1f3f7-fe0f`,
      },
      {
        n: [`money bag`, `moneybag`],
        u: `1f4b0`,
      },
      {
        n: [`banknote with yen sign`, `yen`],
        u: `1f4b4`,
      },
      {
        n: [`banknote with dollar sign`, `dollar`],
        u: `1f4b5`,
      },
      {
        n: [`banknote with euro sign`, `euro`],
        u: `1f4b6`,
      },
      {
        n: [`banknote with pound sign`, `pound`],
        u: `1f4b7`,
      },
      {
        n: [`money with wings`, `money_with_wings`],
        u: `1f4b8`,
      },
      {
        n: [`credit card`, `credit_card`],
        u: `1f4b3`,
      },
      {
        n: [`chart with upwards trend and yen sign`, `chart`],
        u: `1f4b9`,
      },
      {
        n: [`currency exchange`, `currency_exchange`],
        u: `1f4b1`,
      },
      {
        n: [`heavy dollar sign`, `heavy_dollar_sign`],
        u: `1f4b2`,
      },
      {
        n: [`envelope`, `email`],
        u: `2709-fe0f`,
      },
      {
        n: [`e-mail symbol`, `e-mail`],
        u: `1f4e7`,
      },
      {
        n: [`incoming envelope`, `incoming_envelope`],
        u: `1f4e8`,
      },
      {
        n: [`envelope with downwards arrow above`, `envelope_with_arrow`],
        u: `1f4e9`,
      },
      {
        n: [`outbox tray`, `outbox_tray`],
        u: `1f4e4`,
      },
      {
        n: [`inbox tray`, `inbox_tray`],
        u: `1f4e5`,
      },
      {
        n: [`package`],
        u: `1f4e6`,
      },
      {
        n: [`closed mailbox with raised flag`, `mailbox`],
        u: `1f4eb`,
      },
      {
        n: [`closed mailbox with lowered flag`, `mailbox_closed`],
        u: `1f4ea`,
      },
      {
        n: [`open mailbox with raised flag`, `mailbox_with_mail`],
        u: `1f4ec`,
      },
      {
        n: [`open mailbox with lowered flag`, `mailbox_with_no_mail`],
        u: `1f4ed`,
      },
      {
        n: [`postbox`],
        u: `1f4ee`,
      },
      {
        n: [`ballot_box_with_ballot`],
        u: `1f5f3-fe0f`,
      },
      {
        n: [`pencil`, `pencil2`],
        u: `270f-fe0f`,
      },
      {
        n: [`black nib`, `black_nib`],
        u: `2712-fe0f`,
      },
      {
        n: [`lower_left_fountain_pen`],
        u: `1f58b-fe0f`,
      },
      {
        n: [`lower_left_ballpoint_pen`],
        u: `1f58a-fe0f`,
      },
      {
        n: [`lower_left_paintbrush`],
        u: `1f58c-fe0f`,
      },
      {
        n: [`lower_left_crayon`],
        u: `1f58d-fe0f`,
      },
      {
        n: [`memo`, `pencil`],
        u: `1f4dd`,
      },
      {
        n: [`briefcase`],
        u: `1f4bc`,
      },
      {
        n: [`file folder`, `file_folder`],
        u: `1f4c1`,
      },
      {
        n: [`open file folder`, `open_file_folder`],
        u: `1f4c2`,
      },
      {
        n: [`card_index_dividers`],
        u: `1f5c2-fe0f`,
      },
      {
        n: [`calendar`, `date`],
        u: `1f4c5`,
      },
      {
        n: [`tear-off calendar`, `calendar`],
        u: `1f4c6`,
      },
      {
        n: [`spiral_note_pad`],
        u: `1f5d2-fe0f`,
      },
      {
        n: [`spiral_calendar_pad`],
        u: `1f5d3-fe0f`,
      },
      {
        n: [`card index`, `card_index`],
        u: `1f4c7`,
      },
      {
        n: [`chart with upwards trend`, `chart_with_upwards_trend`],
        u: `1f4c8`,
      },
      {
        n: [`chart with downwards trend`, `chart_with_downwards_trend`],
        u: `1f4c9`,
      },
      {
        n: [`bar chart`, `bar_chart`],
        u: `1f4ca`,
      },
      {
        n: [`clipboard`],
        u: `1f4cb`,
      },
      {
        n: [`pushpin`],
        u: `1f4cc`,
      },
      {
        n: [`round pushpin`, `round_pushpin`],
        u: `1f4cd`,
      },
      {
        n: [`paperclip`],
        u: `1f4ce`,
      },
      {
        n: [`linked_paperclips`],
        u: `1f587-fe0f`,
      },
      {
        n: [`straight ruler`, `straight_ruler`],
        u: `1f4cf`,
      },
      {
        n: [`triangular ruler`, `triangular_ruler`],
        u: `1f4d0`,
      },
      {
        n: [`black scissors`, `scissors`],
        u: `2702-fe0f`,
      },
      {
        n: [`card_file_box`],
        u: `1f5c3-fe0f`,
      },
      {
        n: [`file_cabinet`],
        u: `1f5c4-fe0f`,
      },
      {
        n: [`wastebasket`],
        u: `1f5d1-fe0f`,
      },
      {
        n: [`lock`],
        u: `1f512`,
      },
      {
        n: [`open lock`, `unlock`],
        u: `1f513`,
      },
      {
        n: [`lock with ink pen`, `lock_with_ink_pen`],
        u: `1f50f`,
      },
      {
        n: [`closed lock with key`, `closed_lock_with_key`],
        u: `1f510`,
      },
      {
        n: [`key`],
        u: `1f511`,
      },
      {
        n: [`old_key`],
        u: `1f5dd-fe0f`,
      },
      {
        n: [`hammer`],
        u: `1f528`,
      },
      {
        n: [`pick`],
        u: `26cf-fe0f`,
      },
      {
        n: [`hammer_and_pick`],
        u: `2692-fe0f`,
      },
      {
        n: [`hammer_and_wrench`],
        u: `1f6e0-fe0f`,
      },
      {
        n: [`dagger_knife`],
        u: `1f5e1-fe0f`,
      },
      {
        n: [`crossed_swords`],
        u: `2694-fe0f`,
      },
      {
        n: [`pistol`, `gun`],
        u: `1f52b`,
      },
      {
        n: [`bow and arrow`, `bow_and_arrow`],
        u: `1f3f9`,
      },
      {
        n: [`shield`],
        u: `1f6e1-fe0f`,
      },
      {
        n: [`wrench`],
        u: `1f527`,
      },
      {
        n: [`nut and bolt`, `nut_and_bolt`],
        u: `1f529`,
      },
      {
        n: [`gear`],
        u: `2699-fe0f`,
      },
      {
        n: [`compression`],
        u: `1f5dc-fe0f`,
      },
      {
        n: [`alembic`],
        u: `2697-fe0f`,
      },
      {
        n: [`scales`],
        u: `2696-fe0f`,
      },
      {
        n: [`link symbol`, `link`],
        u: `1f517`,
      },
      {
        n: [`chains`],
        u: `26d3-fe0f`,
      },
      {
        n: [`syringe`],
        u: `1f489`,
      },
      {
        n: [`pill`],
        u: `1f48a`,
      },
      {
        n: [`smoking symbol`, `smoking`],
        u: `1f6ac`,
      },
      {
        n: [`coffin`],
        u: `26b0-fe0f`,
      },
      {
        n: [`funeral_urn`],
        u: `26b1-fe0f`,
      },
      {
        n: [`moyai`],
        u: `1f5ff`,
      },
      {
        n: [`oil_drum`],
        u: `1f6e2-fe0f`,
      },
      {
        n: [`crystal ball`, `crystal_ball`],
        u: `1f52e`,
      },
      {
        n: [`shopping trolley`, `shopping_trolley`],
        u: `1f6d2`,
      },
    ],
    symbols: [
      {
        n: [`automated teller machine`, `atm`],
        u: `1f3e7`,
      },
      {
        n: [`put litter in its place symbol`, `put_litter_in_its_place`],
        u: `1f6ae`,
      },
      {
        n: [`potable water symbol`, `potable_water`],
        u: `1f6b0`,
      },
      {
        n: [`wheelchair symbol`, `wheelchair`],
        u: `267f`,
      },
      {
        n: [`mens symbol`, `mens`],
        u: `1f6b9`,
      },
      {
        n: [`womens symbol`, `womens`],
        u: `1f6ba`,
      },
      {
        n: [`restroom`],
        u: `1f6bb`,
      },
      {
        n: [`baby symbol`, `baby_symbol`],
        u: `1f6bc`,
      },
      {
        n: [`water closet`, `wc`],
        u: `1f6be`,
      },
      {
        n: [`passport control`, `passport_control`],
        u: `1f6c2`,
      },
      {
        n: [`customs`],
        u: `1f6c3`,
      },
      {
        n: [`baggage claim`, `baggage_claim`],
        u: `1f6c4`,
      },
      {
        n: [`left luggage`, `left_luggage`],
        u: `1f6c5`,
      },
      {
        n: [`warning sign`, `warning`],
        u: `26a0-fe0f`,
      },
      {
        n: [`children crossing`, `children_crossing`],
        u: `1f6b8`,
      },
      {
        n: [`no entry`, `no_entry`],
        u: `26d4`,
      },
      {
        n: [`no entry sign`, `no_entry_sign`],
        u: `1f6ab`,
      },
      {
        n: [`no bicycles`, `no_bicycles`],
        u: `1f6b3`,
      },
      {
        n: [`no smoking symbol`, `no_smoking`],
        u: `1f6ad`,
      },
      {
        n: [`do not litter symbol`, `do_not_litter`],
        u: `1f6af`,
      },
      {
        n: [`non-potable water symbol`, `non-potable_water`],
        u: `1f6b1`,
      },
      {
        n: [`no pedestrians`, `no_pedestrians`],
        u: `1f6b7`,
      },
      {
        n: [`no mobile phones`, `no_mobile_phones`],
        u: `1f4f5`,
      },
      {
        n: [`no one under eighteen symbol`, `underage`],
        u: `1f51e`,
      },
      {
        n: [`radioactive_sign`],
        u: `2622-fe0f`,
      },
      {
        n: [`biohazard_sign`],
        u: `2623-fe0f`,
      },
      {
        n: [`upwards black arrow`, `arrow_up`],
        u: `2b06-fe0f`,
      },
      {
        n: [`north east arrow`, `arrow_upper_right`],
        u: `2197-fe0f`,
      },
      {
        n: [`black rightwards arrow`, `arrow_right`],
        u: `27a1-fe0f`,
      },
      {
        n: [`south east arrow`, `arrow_lower_right`],
        u: `2198-fe0f`,
      },
      {
        n: [`downwards black arrow`, `arrow_down`],
        u: `2b07-fe0f`,
      },
      {
        n: [`south west arrow`, `arrow_lower_left`],
        u: `2199-fe0f`,
      },
      {
        n: [`leftwards black arrow`, `arrow_left`],
        u: `2b05-fe0f`,
      },
      {
        n: [`north west arrow`, `arrow_upper_left`],
        u: `2196-fe0f`,
      },
      {
        n: [`up down arrow`, `arrow_up_down`],
        u: `2195-fe0f`,
      },
      {
        n: [`left right arrow`, `left_right_arrow`],
        u: `2194-fe0f`,
      },
      {
        n: [`leftwards arrow with hook`, `leftwards_arrow_with_hook`],
        u: `21a9-fe0f`,
      },
      {
        n: [`rightwards arrow with hook`, `arrow_right_hook`],
        u: `21aa-fe0f`,
      },
      {
        n: [`arrow pointing rightwards then curving upwards`, `arrow_heading_up`],
        u: `2934-fe0f`,
      },
      {
        n: [`arrow pointing rightwards then curving downwards`, `arrow_heading_down`],
        u: `2935-fe0f`,
      },
      {
        n: [`clockwise downwards and upwards open circle arrows`, `arrows_clockwise`],
        u: `1f503`,
      },
      {
        n: [`anticlockwise downwards and upwards open circle arrows`, `arrows_counterclockwise`],
        u: `1f504`,
      },
      {
        n: [`back with leftwards arrow above`, `back`],
        u: `1f519`,
      },
      {
        n: [`end with leftwards arrow above`, `end`],
        u: `1f51a`,
      },
      {
        n: [`on with exclamation mark with left right arrow above`, `on`],
        u: `1f51b`,
      },
      {
        n: [`soon with rightwards arrow above`, `soon`],
        u: `1f51c`,
      },
      {
        n: [`top with upwards arrow above`, `top`],
        u: `1f51d`,
      },
      {
        n: [`place of worship`, `place_of_worship`],
        u: `1f6d0`,
      },
      {
        n: [`atom_symbol`],
        u: `269b-fe0f`,
      },
      {
        n: [`om_symbol`],
        u: `1f549-fe0f`,
      },
      {
        n: [`star_of_david`],
        u: `2721-fe0f`,
      },
      {
        n: [`wheel_of_dharma`],
        u: `2638-fe0f`,
      },
      {
        n: [`yin_yang`],
        u: `262f-fe0f`,
      },
      {
        n: [`latin_cross`],
        u: `271d-fe0f`,
      },
      {
        n: [`orthodox_cross`],
        u: `2626-fe0f`,
      },
      {
        n: [`star_and_crescent`],
        u: `262a-fe0f`,
      },
      {
        n: [`peace_symbol`],
        u: `262e-fe0f`,
      },
      {
        n: [`menorah with nine branches`, `menorah_with_nine_branches`],
        u: `1f54e`,
      },
      {
        n: [`six pointed star with middle dot`, `six_pointed_star`],
        u: `1f52f`,
      },
      {
        n: [`aries`],
        u: `2648`,
      },
      {
        n: [`taurus`],
        u: `2649`,
      },
      {
        n: [`gemini`],
        u: `264a`,
      },
      {
        n: [`cancer`],
        u: `264b`,
      },
      {
        n: [`leo`],
        u: `264c`,
      },
      {
        n: [`virgo`],
        u: `264d`,
      },
      {
        n: [`libra`],
        u: `264e`,
      },
      {
        n: [`scorpius`],
        u: `264f`,
      },
      {
        n: [`sagittarius`],
        u: `2650`,
      },
      {
        n: [`capricorn`],
        u: `2651`,
      },
      {
        n: [`aquarius`],
        u: `2652`,
      },
      {
        n: [`pisces`],
        u: `2653`,
      },
      {
        n: [`ophiuchus`],
        u: `26ce`,
      },
      {
        n: [`twisted rightwards arrows`, `twisted_rightwards_arrows`],
        u: `1f500`,
      },
      {
        n: [`clockwise rightwards and leftwards open circle arrows`, `repeat`],
        u: `1f501`,
      },
      {
        n: [
          `clockwise rightwards and leftwards open circle arrows with circled one overlay`,
          `repeat_one`,
        ],
        u: `1f502`,
      },
      {
        n: [`black right-pointing triangle`, `arrow_forward`],
        u: `25b6-fe0f`,
      },
      {
        n: [`black right-pointing double triangle`, `fast_forward`],
        u: `23e9`,
      },
      {
        n: [`black_right_pointing_double_triangle_with_vertical_bar`],
        u: `23ed-fe0f`,
      },
      {
        n: [`black_right_pointing_triangle_with_double_vertical_bar`],
        u: `23ef-fe0f`,
      },
      {
        n: [`black left-pointing triangle`, `arrow_backward`],
        u: `25c0-fe0f`,
      },
      {
        n: [`black left-pointing double triangle`, `rewind`],
        u: `23ea`,
      },
      {
        n: [`black_left_pointing_double_triangle_with_vertical_bar`],
        u: `23ee-fe0f`,
      },
      {
        n: [`up-pointing small red triangle`, `arrow_up_small`],
        u: `1f53c`,
      },
      {
        n: [`black up-pointing double triangle`, `arrow_double_up`],
        u: `23eb`,
      },
      {
        n: [`down-pointing small red triangle`, `arrow_down_small`],
        u: `1f53d`,
      },
      {
        n: [`black down-pointing double triangle`, `arrow_double_down`],
        u: `23ec`,
      },
      {
        n: [`double_vertical_bar`],
        u: `23f8-fe0f`,
      },
      {
        n: [`black_square_for_stop`],
        u: `23f9-fe0f`,
      },
      {
        n: [`black_circle_for_record`],
        u: `23fa-fe0f`,
      },
      {
        n: [`eject`],
        u: `23cf-fe0f`,
      },
      {
        n: [`cinema`],
        u: `1f3a6`,
      },
      {
        n: [`low brightness symbol`, `low_brightness`],
        u: `1f505`,
      },
      {
        n: [`high brightness symbol`, `high_brightness`],
        u: `1f506`,
      },
      {
        n: [`antenna with bars`, `signal_strength`],
        u: `1f4f6`,
      },
      {
        n: [`vibration mode`, `vibration_mode`],
        u: `1f4f3`,
      },
      {
        n: [`mobile phone off`, `mobile_phone_off`],
        u: `1f4f4`,
      },
      {
        n: [`female_sign`],
        u: `2640-fe0f`,
      },
      {
        n: [`male_sign`],
        u: `2642-fe0f`,
      },
      {
        n: [`medical_symbol`, `staff_of_aesculapius`],
        u: `2695-fe0f`,
      },
      {
        n: [`black universal recycling symbol`, `recycle`],
        u: `267b-fe0f`,
      },
      {
        n: [`fleur_de_lis`],
        u: `269c-fe0f`,
      },
      {
        n: [`trident emblem`, `trident`],
        u: `1f531`,
      },
      {
        n: [`name badge`, `name_badge`],
        u: `1f4db`,
      },
      {
        n: [`japanese symbol for beginner`, `beginner`],
        u: `1f530`,
      },
      {
        n: [`heavy large circle`, `o`],
        u: `2b55`,
      },
      {
        n: [`white heavy check mark`, `white_check_mark`],
        u: `2705`,
      },
      {
        n: [`ballot box with check`, `ballot_box_with_check`],
        u: `2611-fe0f`,
      },
      {
        n: [`heavy check mark`, `heavy_check_mark`],
        u: `2714-fe0f`,
      },
      {
        n: [`heavy multiplication x`, `heavy_multiplication_x`],
        u: `2716-fe0f`,
      },
      {
        n: [`cross mark`, `x`],
        u: `274c`,
      },
      {
        n: [`negative squared cross mark`, `negative_squared_cross_mark`],
        u: `274e`,
      },
      {
        n: [`heavy plus sign`, `heavy_plus_sign`],
        u: `2795`,
      },
      {
        n: [`heavy minus sign`, `heavy_minus_sign`],
        u: `2796`,
      },
      {
        n: [`heavy division sign`, `heavy_division_sign`],
        u: `2797`,
      },
      {
        n: [`curly loop`, `curly_loop`],
        u: `27b0`,
      },
      {
        n: [`double curly loop`, `loop`],
        u: `27bf`,
      },
      {
        n: [`part alternation mark`, `part_alternation_mark`],
        u: `303d-fe0f`,
      },
      {
        n: [`eight spoked asterisk`, `eight_spoked_asterisk`],
        u: `2733-fe0f`,
      },
      {
        n: [`eight pointed black star`, `eight_pointed_black_star`],
        u: `2734-fe0f`,
      },
      {
        n: [`sparkle`],
        u: `2747-fe0f`,
      },
      {
        n: [`double exclamation mark`, `bangbang`],
        u: `203c-fe0f`,
      },
      {
        n: [`exclamation question mark`, `interrobang`],
        u: `2049-fe0f`,
      },
      {
        n: [`black question mark ornament`, `question`],
        u: `2753`,
      },
      {
        n: [`white question mark ornament`, `grey_question`],
        u: `2754`,
      },
      {
        n: [`white exclamation mark ornament`, `grey_exclamation`],
        u: `2755`,
      },
      {
        n: [`heavy exclamation mark symbol`, `exclamation`, `heavy_exclamation_mark`],
        u: `2757`,
      },
      {
        n: [`wavy dash`, `wavy_dash`],
        u: `3030-fe0f`,
      },
      {
        n: [`copyright sign`, `copyright`],
        u: `00a9-fe0f`,
      },
      {
        n: [`registered sign`, `registered`],
        u: `00ae-fe0f`,
      },
      {
        n: [`trade mark sign`, `tm`],
        u: `2122-fe0f`,
      },
      {
        n: [`hash key`, `hash`],
        u: `0023-fe0f-20e3`,
      },
      {
        n: [`keycap_star`],
        u: `002a-fe0f-20e3`,
      },
      {
        n: [`keycap 0`, `zero`],
        u: `0030-fe0f-20e3`,
      },
      {
        n: [`keycap 1`, `one`],
        u: `0031-fe0f-20e3`,
      },
      {
        n: [`keycap 2`, `two`],
        u: `0032-fe0f-20e3`,
      },
      {
        n: [`keycap 3`, `three`],
        u: `0033-fe0f-20e3`,
      },
      {
        n: [`keycap 4`, `four`],
        u: `0034-fe0f-20e3`,
      },
      {
        n: [`keycap 5`, `five`],
        u: `0035-fe0f-20e3`,
      },
      {
        n: [`keycap 6`, `six`],
        u: `0036-fe0f-20e3`,
      },
      {
        n: [`keycap 7`, `seven`],
        u: `0037-fe0f-20e3`,
      },
      {
        n: [`keycap 8`, `eight`],
        u: `0038-fe0f-20e3`,
      },
      {
        n: [`keycap 9`, `nine`],
        u: `0039-fe0f-20e3`,
      },
      {
        n: [`keycap ten`, `keycap_ten`],
        u: `1f51f`,
      },
      {
        n: [`hundred points symbol`, `100`],
        u: `1f4af`,
      },
      {
        n: [`input symbol for latin capital letters`, `capital_abcd`],
        u: `1f520`,
      },
      {
        n: [`input symbol for latin small letters`, `abcd`],
        u: `1f521`,
      },
      {
        n: [`input symbol for numbers`, `1234`],
        u: `1f522`,
      },
      {
        n: [`input symbol for symbols`, `symbols`],
        u: `1f523`,
      },
      {
        n: [`input symbol for latin letters`, `abc`],
        u: `1f524`,
      },
      {
        n: [`negative squared latin capital letter a`, `a`],
        u: `1f170-fe0f`,
      },
      {
        n: [`negative squared ab`, `ab`],
        u: `1f18e`,
      },
      {
        n: [`negative squared latin capital letter b`, `b`],
        u: `1f171-fe0f`,
      },
      {
        n: [`squared cl`, `cl`],
        u: `1f191`,
      },
      {
        n: [`squared cool`, `cool`],
        u: `1f192`,
      },
      {
        n: [`squared free`, `free`],
        u: `1f193`,
      },
      {
        n: [`information source`, `information_source`],
        u: `2139-fe0f`,
      },
      {
        n: [`squared id`, `id`],
        u: `1f194`,
      },
      {
        n: [`circled latin capital letter m`, `m`],
        u: `24c2-fe0f`,
      },
      {
        n: [`squared new`, `new`],
        u: `1f195`,
      },
      {
        n: [`squared ng`, `ng`],
        u: `1f196`,
      },
      {
        n: [`negative squared latin capital letter o`, `o2`],
        u: `1f17e-fe0f`,
      },
      {
        n: [`squared ok`, `ok`],
        u: `1f197`,
      },
      {
        n: [`negative squared latin capital letter p`, `parking`],
        u: `1f17f-fe0f`,
      },
      {
        n: [`squared sos`, `sos`],
        u: `1f198`,
      },
      {
        n: [`squared up with exclamation mark`, `up`],
        u: `1f199`,
      },
      {
        n: [`squared vs`, `vs`],
        u: `1f19a`,
      },
      {
        n: [`squared katakana koko`, `koko`],
        u: `1f201`,
      },
      {
        n: [`squared katakana sa`, `sa`],
        u: `1f202-fe0f`,
      },
      {
        n: [`squared cjk unified ideograph-6708`, `u6708`],
        u: `1f237-fe0f`,
      },
      {
        n: [`squared cjk unified ideograph-6709`, `u6709`],
        u: `1f236`,
      },
      {
        n: [`squared cjk unified ideograph-6307`, `u6307`],
        u: `1f22f`,
      },
      {
        n: [`circled ideograph advantage`, `ideograph_advantage`],
        u: `1f250`,
      },
      {
        n: [`squared cjk unified ideograph-5272`, `u5272`],
        u: `1f239`,
      },
      {
        n: [`squared cjk unified ideograph-7121`, `u7121`],
        u: `1f21a`,
      },
      {
        n: [`squared cjk unified ideograph-7981`, `u7981`],
        u: `1f232`,
      },
      {
        n: [`circled ideograph accept`, `accept`],
        u: `1f251`,
      },
      {
        n: [`squared cjk unified ideograph-7533`, `u7533`],
        u: `1f238`,
      },
      {
        n: [`squared cjk unified ideograph-5408`, `u5408`],
        u: `1f234`,
      },
      {
        n: [`squared cjk unified ideograph-7a7a`, `u7a7a`],
        u: `1f233`,
      },
      {
        n: [`circled ideograph congratulation`, `congratulations`],
        u: `3297-fe0f`,
      },
      {
        n: [`circled ideograph secret`, `secret`],
        u: `3299-fe0f`,
      },
      {
        n: [`squared cjk unified ideograph-55b6`, `u55b6`],
        u: `1f23a`,
      },
      {
        n: [`squared cjk unified ideograph-6e80`, `u6e80`],
        u: `1f235`,
      },
      {
        n: [`black small square`, `black_small_square`],
        u: `25aa-fe0f`,
      },
      {
        n: [`white small square`, `white_small_square`],
        u: `25ab-fe0f`,
      },
      {
        n: [`white medium square`, `white_medium_square`],
        u: `25fb-fe0f`,
      },
      {
        n: [`black medium square`, `black_medium_square`],
        u: `25fc-fe0f`,
      },
      {
        n: [`white medium small square`, `white_medium_small_square`],
        u: `25fd`,
      },
      {
        n: [`black medium small square`, `black_medium_small_square`],
        u: `25fe`,
      },
      {
        n: [`black large square`, `black_large_square`],
        u: `2b1b`,
      },
      {
        n: [`white large square`, `white_large_square`],
        u: `2b1c`,
      },
      {
        n: [`large orange diamond`, `large_orange_diamond`],
        u: `1f536`,
      },
      {
        n: [`large blue diamond`, `large_blue_diamond`],
        u: `1f537`,
      },
      {
        n: [`small orange diamond`, `small_orange_diamond`],
        u: `1f538`,
      },
      {
        n: [`small blue diamond`, `small_blue_diamond`],
        u: `1f539`,
      },
      {
        n: [`up-pointing red triangle`, `small_red_triangle`],
        u: `1f53a`,
      },
      {
        n: [`down-pointing red triangle`, `small_red_triangle_down`],
        u: `1f53b`,
      },
      {
        n: [`diamond shape with a dot inside`, `diamond_shape_with_a_dot_inside`],
        u: `1f4a0`,
      },
      {
        n: [`radio button`, `radio_button`],
        u: `1f518`,
      },
      {
        n: [`black square button`, `black_square_button`],
        u: `1f532`,
      },
      {
        n: [`white square button`, `white_square_button`],
        u: `1f533`,
      },
      {
        n: [`medium white circle`, `white_circle`],
        u: `26aa`,
      },
      {
        n: [`medium black circle`, `black_circle`],
        u: `26ab`,
      },
      {
        n: [`large red circle`, `red_circle`],
        u: `1f534`,
      },
      {
        n: [`large blue circle`, `large_blue_circle`],
        u: `1f535`,
      },
    ],
    flags: [
      {
        n: [`chequered flag`, `checkered_flag`],
        u: `1f3c1`,
      },
      {
        n: [`triangular flag on post`, `triangular_flag_on_post`],
        u: `1f6a9`,
      },
      {
        n: [`crossed flags`, `crossed_flags`],
        u: `1f38c`,
      },
      {
        n: [`waving black flag`, `waving_black_flag`],
        u: `1f3f4`,
      },
      {
        n: [`waving_white_flag`],
        u: `1f3f3-fe0f`,
      },
      {
        n: [`rainbow-flag`],
        u: `1f3f3-fe0f-200d-1f308`,
      },
      {
        n: [`ascension island flag`, `flag-ac`],
        u: `1f1e6-1f1e8`,
      },
      {
        n: [`andorra flag`, `flag-ad`],
        u: `1f1e6-1f1e9`,
      },
      {
        n: [`united arab emirates flag`, `flag-ae`],
        u: `1f1e6-1f1ea`,
      },
      {
        n: [`afghanistan flag`, `flag-af`],
        u: `1f1e6-1f1eb`,
      },
      {
        n: [`antigua & barbuda flag`, `flag-ag`],
        u: `1f1e6-1f1ec`,
      },
      {
        n: [`anguilla flag`, `flag-ai`],
        u: `1f1e6-1f1ee`,
      },
      {
        n: [`albania flag`, `flag-al`],
        u: `1f1e6-1f1f1`,
      },
      {
        n: [`armenia flag`, `flag-am`],
        u: `1f1e6-1f1f2`,
      },
      {
        n: [`angola flag`, `flag-ao`],
        u: `1f1e6-1f1f4`,
      },
      {
        n: [`antarctica flag`, `flag-aq`],
        u: `1f1e6-1f1f6`,
      },
      {
        n: [`argentina flag`, `flag-ar`],
        u: `1f1e6-1f1f7`,
      },
      {
        n: [`american samoa flag`, `flag-as`],
        u: `1f1e6-1f1f8`,
      },
      {
        n: [`austria flag`, `flag-at`],
        u: `1f1e6-1f1f9`,
      },
      {
        n: [`australia flag`, `flag-au`],
        u: `1f1e6-1f1fa`,
      },
      {
        n: [`aruba flag`, `flag-aw`],
        u: `1f1e6-1f1fc`,
      },
      {
        n: [`åland islands flag`, `flag-ax`],
        u: `1f1e6-1f1fd`,
      },
      {
        n: [`azerbaijan flag`, `flag-az`],
        u: `1f1e6-1f1ff`,
      },
      {
        n: [`bosnia & herzegovina flag`, `flag-ba`],
        u: `1f1e7-1f1e6`,
      },
      {
        n: [`barbados flag`, `flag-bb`],
        u: `1f1e7-1f1e7`,
      },
      {
        n: [`bangladesh flag`, `flag-bd`],
        u: `1f1e7-1f1e9`,
      },
      {
        n: [`belgium flag`, `flag-be`],
        u: `1f1e7-1f1ea`,
      },
      {
        n: [`burkina faso flag`, `flag-bf`],
        u: `1f1e7-1f1eb`,
      },
      {
        n: [`bulgaria flag`, `flag-bg`],
        u: `1f1e7-1f1ec`,
      },
      {
        n: [`bahrain flag`, `flag-bh`],
        u: `1f1e7-1f1ed`,
      },
      {
        n: [`burundi flag`, `flag-bi`],
        u: `1f1e7-1f1ee`,
      },
      {
        n: [`benin flag`, `flag-bj`],
        u: `1f1e7-1f1ef`,
      },
      {
        n: [`st. barthélemy flag`, `flag-bl`],
        u: `1f1e7-1f1f1`,
      },
      {
        n: [`bermuda flag`, `flag-bm`],
        u: `1f1e7-1f1f2`,
      },
      {
        n: [`brunei flag`, `flag-bn`],
        u: `1f1e7-1f1f3`,
      },
      {
        n: [`bolivia flag`, `flag-bo`],
        u: `1f1e7-1f1f4`,
      },
      {
        n: [`caribbean netherlands flag`, `flag-bq`],
        u: `1f1e7-1f1f6`,
      },
      {
        n: [`brazil flag`, `flag-br`],
        u: `1f1e7-1f1f7`,
      },
      {
        n: [`bahamas flag`, `flag-bs`],
        u: `1f1e7-1f1f8`,
      },
      {
        n: [`bhutan flag`, `flag-bt`],
        u: `1f1e7-1f1f9`,
      },
      {
        n: [`bouvet island flag`, `flag-bv`],
        u: `1f1e7-1f1fb`,
      },
      {
        n: [`botswana flag`, `flag-bw`],
        u: `1f1e7-1f1fc`,
      },
      {
        n: [`belarus flag`, `flag-by`],
        u: `1f1e7-1f1fe`,
      },
      {
        n: [`belize flag`, `flag-bz`],
        u: `1f1e7-1f1ff`,
      },
      {
        n: [`canada flag`, `flag-ca`],
        u: `1f1e8-1f1e6`,
      },
      {
        n: [`cocos (keeling) islands flag`, `flag-cc`],
        u: `1f1e8-1f1e8`,
      },
      {
        n: [`congo - kinshasa flag`, `flag-cd`],
        u: `1f1e8-1f1e9`,
      },
      {
        n: [`central african republic flag`, `flag-cf`],
        u: `1f1e8-1f1eb`,
      },
      {
        n: [`congo - brazzaville flag`, `flag-cg`],
        u: `1f1e8-1f1ec`,
      },
      {
        n: [`switzerland flag`, `flag-ch`],
        u: `1f1e8-1f1ed`,
      },
      {
        n: [`côte d’ivoire flag`, `flag-ci`],
        u: `1f1e8-1f1ee`,
      },
      {
        n: [`cook islands flag`, `flag-ck`],
        u: `1f1e8-1f1f0`,
      },
      {
        n: [`chile flag`, `flag-cl`],
        u: `1f1e8-1f1f1`,
      },
      {
        n: [`cameroon flag`, `flag-cm`],
        u: `1f1e8-1f1f2`,
      },
      {
        n: [`china flag`, `cn`, `flag-cn`],
        u: `1f1e8-1f1f3`,
      },
      {
        n: [`colombia flag`, `flag-co`],
        u: `1f1e8-1f1f4`,
      },
      {
        n: [`clipperton island flag`, `flag-cp`],
        u: `1f1e8-1f1f5`,
      },
      {
        n: [`costa rica flag`, `flag-cr`],
        u: `1f1e8-1f1f7`,
      },
      {
        n: [`cuba flag`, `flag-cu`],
        u: `1f1e8-1f1fa`,
      },
      {
        n: [`cape verde flag`, `flag-cv`],
        u: `1f1e8-1f1fb`,
      },
      {
        n: [`curaçao flag`, `flag-cw`],
        u: `1f1e8-1f1fc`,
      },
      {
        n: [`christmas island flag`, `flag-cx`],
        u: `1f1e8-1f1fd`,
      },
      {
        n: [`cyprus flag`, `flag-cy`],
        u: `1f1e8-1f1fe`,
      },
      {
        n: [`czechia flag`, `flag-cz`],
        u: `1f1e8-1f1ff`,
      },
      {
        n: [`germany flag`, `de`, `flag-de`],
        u: `1f1e9-1f1ea`,
      },
      {
        n: [`diego garcia flag`, `flag-dg`],
        u: `1f1e9-1f1ec`,
      },
      {
        n: [`djibouti flag`, `flag-dj`],
        u: `1f1e9-1f1ef`,
      },
      {
        n: [`denmark flag`, `flag-dk`],
        u: `1f1e9-1f1f0`,
      },
      {
        n: [`dominica flag`, `flag-dm`],
        u: `1f1e9-1f1f2`,
      },
      {
        n: [`dominican republic flag`, `flag-do`],
        u: `1f1e9-1f1f4`,
      },
      {
        n: [`algeria flag`, `flag-dz`],
        u: `1f1e9-1f1ff`,
      },
      {
        n: [`ceuta & melilla flag`, `flag-ea`],
        u: `1f1ea-1f1e6`,
      },
      {
        n: [`ecuador flag`, `flag-ec`],
        u: `1f1ea-1f1e8`,
      },
      {
        n: [`estonia flag`, `flag-ee`],
        u: `1f1ea-1f1ea`,
      },
      {
        n: [`egypt flag`, `flag-eg`],
        u: `1f1ea-1f1ec`,
      },
      {
        n: [`western sahara flag`, `flag-eh`],
        u: `1f1ea-1f1ed`,
      },
      {
        n: [`eritrea flag`, `flag-er`],
        u: `1f1ea-1f1f7`,
      },
      {
        n: [`spain flag`, `es`, `flag-es`],
        u: `1f1ea-1f1f8`,
      },
      {
        n: [`ethiopia flag`, `flag-et`],
        u: `1f1ea-1f1f9`,
      },
      {
        n: [`european union flag`, `flag-eu`],
        u: `1f1ea-1f1fa`,
      },
      {
        n: [`finland flag`, `flag-fi`],
        u: `1f1eb-1f1ee`,
      },
      {
        n: [`fiji flag`, `flag-fj`],
        u: `1f1eb-1f1ef`,
      },
      {
        n: [`falkland islands flag`, `flag-fk`],
        u: `1f1eb-1f1f0`,
      },
      {
        n: [`micronesia flag`, `flag-fm`],
        u: `1f1eb-1f1f2`,
      },
      {
        n: [`faroe islands flag`, `flag-fo`],
        u: `1f1eb-1f1f4`,
      },
      {
        n: [`france flag`, `fr`, `flag-fr`],
        u: `1f1eb-1f1f7`,
      },
      {
        n: [`gabon flag`, `flag-ga`],
        u: `1f1ec-1f1e6`,
      },
      {
        n: [`united kingdom flag`, `gb`, `uk`, `flag-gb`],
        u: `1f1ec-1f1e7`,
      },
      {
        n: [`grenada flag`, `flag-gd`],
        u: `1f1ec-1f1e9`,
      },
      {
        n: [`georgia flag`, `flag-ge`],
        u: `1f1ec-1f1ea`,
      },
      {
        n: [`french guiana flag`, `flag-gf`],
        u: `1f1ec-1f1eb`,
      },
      {
        n: [`guernsey flag`, `flag-gg`],
        u: `1f1ec-1f1ec`,
      },
      {
        n: [`ghana flag`, `flag-gh`],
        u: `1f1ec-1f1ed`,
      },
      {
        n: [`gibraltar flag`, `flag-gi`],
        u: `1f1ec-1f1ee`,
      },
      {
        n: [`greenland flag`, `flag-gl`],
        u: `1f1ec-1f1f1`,
      },
      {
        n: [`gambia flag`, `flag-gm`],
        u: `1f1ec-1f1f2`,
      },
      {
        n: [`guinea flag`, `flag-gn`],
        u: `1f1ec-1f1f3`,
      },
      {
        n: [`guadeloupe flag`, `flag-gp`],
        u: `1f1ec-1f1f5`,
      },
      {
        n: [`equatorial guinea flag`, `flag-gq`],
        u: `1f1ec-1f1f6`,
      },
      {
        n: [`greece flag`, `flag-gr`],
        u: `1f1ec-1f1f7`,
      },
      {
        n: [`south georgia & south sandwich islands flag`, `flag-gs`],
        u: `1f1ec-1f1f8`,
      },
      {
        n: [`guatemala flag`, `flag-gt`],
        u: `1f1ec-1f1f9`,
      },
      {
        n: [`guam flag`, `flag-gu`],
        u: `1f1ec-1f1fa`,
      },
      {
        n: [`guinea-bissau flag`, `flag-gw`],
        u: `1f1ec-1f1fc`,
      },
      {
        n: [`guyana flag`, `flag-gy`],
        u: `1f1ec-1f1fe`,
      },
      {
        n: [`hong kong sar china flag`, `flag-hk`],
        u: `1f1ed-1f1f0`,
      },
      {
        n: [`heard & mcdonald islands flag`, `flag-hm`],
        u: `1f1ed-1f1f2`,
      },
      {
        n: [`honduras flag`, `flag-hn`],
        u: `1f1ed-1f1f3`,
      },
      {
        n: [`croatia flag`, `flag-hr`],
        u: `1f1ed-1f1f7`,
      },
      {
        n: [`haiti flag`, `flag-ht`],
        u: `1f1ed-1f1f9`,
      },
      {
        n: [`hungary flag`, `flag-hu`],
        u: `1f1ed-1f1fa`,
      },
      {
        n: [`canary islands flag`, `flag-ic`],
        u: `1f1ee-1f1e8`,
      },
      {
        n: [`indonesia flag`, `flag-id`],
        u: `1f1ee-1f1e9`,
      },
      {
        n: [`ireland flag`, `flag-ie`],
        u: `1f1ee-1f1ea`,
      },
      {
        n: [`israel flag`, `flag-il`],
        u: `1f1ee-1f1f1`,
      },
      {
        n: [`isle of man flag`, `flag-im`],
        u: `1f1ee-1f1f2`,
      },
      {
        n: [`india flag`, `flag-in`],
        u: `1f1ee-1f1f3`,
      },
      {
        n: [`british indian ocean territory flag`, `flag-io`],
        u: `1f1ee-1f1f4`,
      },
      {
        n: [`iraq flag`, `flag-iq`],
        u: `1f1ee-1f1f6`,
      },
      {
        n: [`iran flag`, `flag-ir`],
        u: `1f1ee-1f1f7`,
      },
      {
        n: [`iceland flag`, `flag-is`],
        u: `1f1ee-1f1f8`,
      },
      {
        n: [`italy flag`, `it`, `flag-it`],
        u: `1f1ee-1f1f9`,
      },
      {
        n: [`jersey flag`, `flag-je`],
        u: `1f1ef-1f1ea`,
      },
      {
        n: [`jamaica flag`, `flag-jm`],
        u: `1f1ef-1f1f2`,
      },
      {
        n: [`jordan flag`, `flag-jo`],
        u: `1f1ef-1f1f4`,
      },
      {
        n: [`japan flag`, `jp`, `flag-jp`],
        u: `1f1ef-1f1f5`,
      },
      {
        n: [`kenya flag`, `flag-ke`],
        u: `1f1f0-1f1ea`,
      },
      {
        n: [`kyrgyzstan flag`, `flag-kg`],
        u: `1f1f0-1f1ec`,
      },
      {
        n: [`cambodia flag`, `flag-kh`],
        u: `1f1f0-1f1ed`,
      },
      {
        n: [`kiribati flag`, `flag-ki`],
        u: `1f1f0-1f1ee`,
      },
      {
        n: [`comoros flag`, `flag-km`],
        u: `1f1f0-1f1f2`,
      },
      {
        n: [`st. kitts & nevis flag`, `flag-kn`],
        u: `1f1f0-1f1f3`,
      },
      {
        n: [`north korea flag`, `flag-kp`],
        u: `1f1f0-1f1f5`,
      },
      {
        n: [`south korea flag`, `kr`, `flag-kr`],
        u: `1f1f0-1f1f7`,
      },
      {
        n: [`kuwait flag`, `flag-kw`],
        u: `1f1f0-1f1fc`,
      },
      {
        n: [`cayman islands flag`, `flag-ky`],
        u: `1f1f0-1f1fe`,
      },
      {
        n: [`kazakhstan flag`, `flag-kz`],
        u: `1f1f0-1f1ff`,
      },
      {
        n: [`laos flag`, `flag-la`],
        u: `1f1f1-1f1e6`,
      },
      {
        n: [`lebanon flag`, `flag-lb`],
        u: `1f1f1-1f1e7`,
      },
      {
        n: [`st. lucia flag`, `flag-lc`],
        u: `1f1f1-1f1e8`,
      },
      {
        n: [`liechtenstein flag`, `flag-li`],
        u: `1f1f1-1f1ee`,
      },
      {
        n: [`sri lanka flag`, `flag-lk`],
        u: `1f1f1-1f1f0`,
      },
      {
        n: [`liberia flag`, `flag-lr`],
        u: `1f1f1-1f1f7`,
      },
      {
        n: [`lesotho flag`, `flag-ls`],
        u: `1f1f1-1f1f8`,
      },
      {
        n: [`lithuania flag`, `flag-lt`],
        u: `1f1f1-1f1f9`,
      },
      {
        n: [`luxembourg flag`, `flag-lu`],
        u: `1f1f1-1f1fa`,
      },
      {
        n: [`latvia flag`, `flag-lv`],
        u: `1f1f1-1f1fb`,
      },
      {
        n: [`libya flag`, `flag-ly`],
        u: `1f1f1-1f1fe`,
      },
      {
        n: [`morocco flag`, `flag-ma`],
        u: `1f1f2-1f1e6`,
      },
      {
        n: [`monaco flag`, `flag-mc`],
        u: `1f1f2-1f1e8`,
      },
      {
        n: [`moldova flag`, `flag-md`],
        u: `1f1f2-1f1e9`,
      },
      {
        n: [`montenegro flag`, `flag-me`],
        u: `1f1f2-1f1ea`,
      },
      {
        n: [`st. martin flag`, `flag-mf`],
        u: `1f1f2-1f1eb`,
      },
      {
        n: [`madagascar flag`, `flag-mg`],
        u: `1f1f2-1f1ec`,
      },
      {
        n: [`marshall islands flag`, `flag-mh`],
        u: `1f1f2-1f1ed`,
      },
      {
        n: [`macedonia flag`, `flag-mk`],
        u: `1f1f2-1f1f0`,
      },
      {
        n: [`mali flag`, `flag-ml`],
        u: `1f1f2-1f1f1`,
      },
      {
        n: [`myanmar (burma) flag`, `flag-mm`],
        u: `1f1f2-1f1f2`,
      },
      {
        n: [`mongolia flag`, `flag-mn`],
        u: `1f1f2-1f1f3`,
      },
      {
        n: [`macau sar china flag`, `flag-mo`],
        u: `1f1f2-1f1f4`,
      },
      {
        n: [`northern mariana islands flag`, `flag-mp`],
        u: `1f1f2-1f1f5`,
      },
      {
        n: [`martinique flag`, `flag-mq`],
        u: `1f1f2-1f1f6`,
      },
      {
        n: [`mauritania flag`, `flag-mr`],
        u: `1f1f2-1f1f7`,
      },
      {
        n: [`montserrat flag`, `flag-ms`],
        u: `1f1f2-1f1f8`,
      },
      {
        n: [`malta flag`, `flag-mt`],
        u: `1f1f2-1f1f9`,
      },
      {
        n: [`mauritius flag`, `flag-mu`],
        u: `1f1f2-1f1fa`,
      },
      {
        n: [`maldives flag`, `flag-mv`],
        u: `1f1f2-1f1fb`,
      },
      {
        n: [`malawi flag`, `flag-mw`],
        u: `1f1f2-1f1fc`,
      },
      {
        n: [`mexico flag`, `flag-mx`],
        u: `1f1f2-1f1fd`,
      },
      {
        n: [`malaysia flag`, `flag-my`],
        u: `1f1f2-1f1fe`,
      },
      {
        n: [`mozambique flag`, `flag-mz`],
        u: `1f1f2-1f1ff`,
      },
      {
        n: [`namibia flag`, `flag-na`],
        u: `1f1f3-1f1e6`,
      },
      {
        n: [`new caledonia flag`, `flag-nc`],
        u: `1f1f3-1f1e8`,
      },
      {
        n: [`niger flag`, `flag-ne`],
        u: `1f1f3-1f1ea`,
      },
      {
        n: [`norfolk island flag`, `flag-nf`],
        u: `1f1f3-1f1eb`,
      },
      {
        n: [`nigeria flag`, `flag-ng`],
        u: `1f1f3-1f1ec`,
      },
      {
        n: [`nicaragua flag`, `flag-ni`],
        u: `1f1f3-1f1ee`,
      },
      {
        n: [`netherlands flag`, `flag-nl`],
        u: `1f1f3-1f1f1`,
      },
      {
        n: [`norway flag`, `flag-no`],
        u: `1f1f3-1f1f4`,
      },
      {
        n: [`nepal flag`, `flag-np`],
        u: `1f1f3-1f1f5`,
      },
      {
        n: [`nauru flag`, `flag-nr`],
        u: `1f1f3-1f1f7`,
      },
      {
        n: [`niue flag`, `flag-nu`],
        u: `1f1f3-1f1fa`,
      },
      {
        n: [`new zealand flag`, `flag-nz`],
        u: `1f1f3-1f1ff`,
      },
      {
        n: [`oman flag`, `flag-om`],
        u: `1f1f4-1f1f2`,
      },
      {
        n: [`panama flag`, `flag-pa`],
        u: `1f1f5-1f1e6`,
      },
      {
        n: [`peru flag`, `flag-pe`],
        u: `1f1f5-1f1ea`,
      },
      {
        n: [`french polynesia flag`, `flag-pf`],
        u: `1f1f5-1f1eb`,
      },
      {
        n: [`papua new guinea flag`, `flag-pg`],
        u: `1f1f5-1f1ec`,
      },
      {
        n: [`philippines flag`, `flag-ph`],
        u: `1f1f5-1f1ed`,
      },
      {
        n: [`pakistan flag`, `flag-pk`],
        u: `1f1f5-1f1f0`,
      },
      {
        n: [`poland flag`, `flag-pl`],
        u: `1f1f5-1f1f1`,
      },
      {
        n: [`st. pierre & miquelon flag`, `flag-pm`],
        u: `1f1f5-1f1f2`,
      },
      {
        n: [`pitcairn islands flag`, `flag-pn`],
        u: `1f1f5-1f1f3`,
      },
      {
        n: [`puerto rico flag`, `flag-pr`],
        u: `1f1f5-1f1f7`,
      },
      {
        n: [`palestinian territories flag`, `flag-ps`],
        u: `1f1f5-1f1f8`,
      },
      {
        n: [`portugal flag`, `flag-pt`],
        u: `1f1f5-1f1f9`,
      },
      {
        n: [`palau flag`, `flag-pw`],
        u: `1f1f5-1f1fc`,
      },
      {
        n: [`paraguay flag`, `flag-py`],
        u: `1f1f5-1f1fe`,
      },
      {
        n: [`qatar flag`, `flag-qa`],
        u: `1f1f6-1f1e6`,
      },
      {
        n: [`réunion flag`, `flag-re`],
        u: `1f1f7-1f1ea`,
      },
      {
        n: [`romania flag`, `flag-ro`],
        u: `1f1f7-1f1f4`,
      },
      {
        n: [`serbia flag`, `flag-rs`],
        u: `1f1f7-1f1f8`,
      },
      {
        n: [`russia flag`, `ru`, `flag-ru`],
        u: `1f1f7-1f1fa`,
      },
      {
        n: [`rwanda flag`, `flag-rw`],
        u: `1f1f7-1f1fc`,
      },
      {
        n: [`saudi arabia flag`, `flag-sa`],
        u: `1f1f8-1f1e6`,
      },
      {
        n: [`solomon islands flag`, `flag-sb`],
        u: `1f1f8-1f1e7`,
      },
      {
        n: [`seychelles flag`, `flag-sc`],
        u: `1f1f8-1f1e8`,
      },
      {
        n: [`sudan flag`, `flag-sd`],
        u: `1f1f8-1f1e9`,
      },
      {
        n: [`sweden flag`, `flag-se`],
        u: `1f1f8-1f1ea`,
      },
      {
        n: [`singapore flag`, `flag-sg`],
        u: `1f1f8-1f1ec`,
      },
      {
        n: [`st. helena flag`, `flag-sh`],
        u: `1f1f8-1f1ed`,
      },
      {
        n: [`slovenia flag`, `flag-si`],
        u: `1f1f8-1f1ee`,
      },
      {
        n: [`svalbard & jan mayen flag`, `flag-sj`],
        u: `1f1f8-1f1ef`,
      },
      {
        n: [`slovakia flag`, `flag-sk`],
        u: `1f1f8-1f1f0`,
      },
      {
        n: [`sierra leone flag`, `flag-sl`],
        u: `1f1f8-1f1f1`,
      },
      {
        n: [`san marino flag`, `flag-sm`],
        u: `1f1f8-1f1f2`,
      },
      {
        n: [`senegal flag`, `flag-sn`],
        u: `1f1f8-1f1f3`,
      },
      {
        n: [`somalia flag`, `flag-so`],
        u: `1f1f8-1f1f4`,
      },
      {
        n: [`suriname flag`, `flag-sr`],
        u: `1f1f8-1f1f7`,
      },
      {
        n: [`south sudan flag`, `flag-ss`],
        u: `1f1f8-1f1f8`,
      },
      {
        n: [`são tomé & príncipe flag`, `flag-st`],
        u: `1f1f8-1f1f9`,
      },
      {
        n: [`el salvador flag`, `flag-sv`],
        u: `1f1f8-1f1fb`,
      },
      {
        n: [`sint maarten flag`, `flag-sx`],
        u: `1f1f8-1f1fd`,
      },
      {
        n: [`syria flag`, `flag-sy`],
        u: `1f1f8-1f1fe`,
      },
      {
        n: [`swaziland flag`, `flag-sz`],
        u: `1f1f8-1f1ff`,
      },
      {
        n: [`tristan da cunha flag`, `flag-ta`],
        u: `1f1f9-1f1e6`,
      },
      {
        n: [`turks & caicos islands flag`, `flag-tc`],
        u: `1f1f9-1f1e8`,
      },
      {
        n: [`chad flag`, `flag-td`],
        u: `1f1f9-1f1e9`,
      },
      {
        n: [`french southern territories flag`, `flag-tf`],
        u: `1f1f9-1f1eb`,
      },
      {
        n: [`togo flag`, `flag-tg`],
        u: `1f1f9-1f1ec`,
      },
      {
        n: [`thailand flag`, `flag-th`],
        u: `1f1f9-1f1ed`,
      },
      {
        n: [`tajikistan flag`, `flag-tj`],
        u: `1f1f9-1f1ef`,
      },
      {
        n: [`tokelau flag`, `flag-tk`],
        u: `1f1f9-1f1f0`,
      },
      {
        n: [`timor-leste flag`, `flag-tl`],
        u: `1f1f9-1f1f1`,
      },
      {
        n: [`turkmenistan flag`, `flag-tm`],
        u: `1f1f9-1f1f2`,
      },
      {
        n: [`tunisia flag`, `flag-tn`],
        u: `1f1f9-1f1f3`,
      },
      {
        n: [`tonga flag`, `flag-to`],
        u: `1f1f9-1f1f4`,
      },
      {
        n: [`turkey flag`, `flag-tr`],
        u: `1f1f9-1f1f7`,
      },
      {
        n: [`trinidad & tobago flag`, `flag-tt`],
        u: `1f1f9-1f1f9`,
      },
      {
        n: [`tuvalu flag`, `flag-tv`],
        u: `1f1f9-1f1fb`,
      },
      {
        n: [`taiwan flag`, `flag-tw`],
        u: `1f1f9-1f1fc`,
      },
      {
        n: [`tanzania flag`, `flag-tz`],
        u: `1f1f9-1f1ff`,
      },
      {
        n: [`ukraine flag`, `flag-ua`],
        u: `1f1fa-1f1e6`,
      },
      {
        n: [`uganda flag`, `flag-ug`],
        u: `1f1fa-1f1ec`,
      },
      {
        n: [`u.s. outlying islands flag`, `flag-um`],
        u: `1f1fa-1f1f2`,
      },
      {
        n: [`united nations flag`, `flag-un`],
        u: `1f1fa-1f1f3`,
      },
      {
        n: [`united states flag`, `us`, `flag-us`],
        u: `1f1fa-1f1f8`,
      },
      {
        n: [`uruguay flag`, `flag-uy`],
        u: `1f1fa-1f1fe`,
      },
      {
        n: [`uzbekistan flag`, `flag-uz`],
        u: `1f1fa-1f1ff`,
      },
      {
        n: [`vatican city flag`, `flag-va`],
        u: `1f1fb-1f1e6`,
      },
      {
        n: [`st. vincent & grenadines flag`, `flag-vc`],
        u: `1f1fb-1f1e8`,
      },
      {
        n: [`venezuela flag`, `flag-ve`],
        u: `1f1fb-1f1ea`,
      },
      {
        n: [`british virgin islands flag`, `flag-vg`],
        u: `1f1fb-1f1ec`,
      },
      {
        n: [`u.s. virgin islands flag`, `flag-vi`],
        u: `1f1fb-1f1ee`,
      },
      {
        n: [`vietnam flag`, `flag-vn`],
        u: `1f1fb-1f1f3`,
      },
      {
        n: [`vanuatu flag`, `flag-vu`],
        u: `1f1fb-1f1fa`,
      },
      {
        n: [`wallis & futuna flag`, `flag-wf`],
        u: `1f1fc-1f1eb`,
      },
      {
        n: [`samoa flag`, `flag-ws`],
        u: `1f1fc-1f1f8`,
      },
      {
        n: [`kosovo flag`, `flag-xk`],
        u: `1f1fd-1f1f0`,
      },
      {
        n: [`yemen flag`, `flag-ye`],
        u: `1f1fe-1f1ea`,
      },
      {
        n: [`mayotte flag`, `flag-yt`],
        u: `1f1fe-1f1f9`,
      },
      {
        n: [`south africa flag`, `flag-za`],
        u: `1f1ff-1f1e6`,
      },
      {
        n: [`zambia flag`, `flag-zm`],
        u: `1f1ff-1f1f2`,
      },
      {
        n: [`zimbabwe flag`, `flag-zw`],
        u: `1f1ff-1f1fc`,
      },
      {
        n: [`england flag`, `flag-england`],
        u: `1f3f4-e0067-e0062-e0065-e006e-e0067-e007f`,
      },
      {
        n: [`scotland flag`, `flag-scotland`],
        u: `1f3f4-e0067-e0062-e0073-e0063-e0074-e007f`,
      },
      {
        n: [`wales flag`, `flag-wales`],
        u: `1f3f4-e0067-e0062-e0077-e006c-e0073-e007f`,
      },
    ],
  },
  ug = [
    {
      key: `recent`,
      title: `Recently Used`,
      u: `1f551`,
    },
    {
      key: `smileys_people`,
      title: `Smiles & People`,
      u: `1f600`,
    },
    {
      key: `animals_nature`,
      title: `Animals & Nature`,
      u: `1F431`,
    },
    {
      key: `food_drink`,
      title: `Food & Drink`,
      u: `2615`,
    },
    {
      key: `activities`,
      title: `Activities`,
      u: `26BD`,
    },
    {
      key: `travel_places`,
      title: `Travel & Places`,
      u: `1F697`,
    },
    {
      key: `objects`,
      title: `Objects`,
      u: `1F4A1`,
    },
    {
      key: `symbols`,
      title: `Symbols`,
      u: `1f4af`,
    },
    {
      key: `flags`,
      title: `Flags`,
      u: `1f3f3-fe0f`,
    },
  ],
  dg = (e, t) => t.some((t) => e instanceof t),
  fg,
  pg;
function mg() {
  return (fg ||= [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction]);
}
function hg() {
  return (pg ||= [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey,
  ]);
}
var gg = new WeakMap(),
  _g = new WeakMap(),
  vg = new WeakMap(),
  yg = new WeakMap(),
  bg = new WeakMap();
function xg(e) {
  let t = new Promise((t, n) => {
    let r = () => {
        (e.removeEventListener(`success`, i), e.removeEventListener(`error`, a));
      },
      i = () => {
        (t(Dg(e.result)), r());
      },
      a = () => {
        (n(e.error), r());
      };
    (e.addEventListener(`success`, i), e.addEventListener(`error`, a));
  });
  return (
    t
      .then((t) => {
        t instanceof IDBCursor && gg.set(t, e);
      })
      .catch(() => {}),
    bg.set(t, e),
    t
  );
}
function Sg(e) {
  if (_g.has(e)) return;
  let t = new Promise((t, n) => {
    let r = () => {
        (e.removeEventListener(`complete`, i),
          e.removeEventListener(`error`, a),
          e.removeEventListener(`abort`, a));
      },
      i = () => {
        (t(), r());
      },
      a = () => {
        (n(e.error || new DOMException(`AbortError`, `AbortError`)), r());
      };
    (e.addEventListener(`complete`, i),
      e.addEventListener(`error`, a),
      e.addEventListener(`abort`, a));
  });
  _g.set(e, t);
}
var Cg = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === `done`) return _g.get(e);
      if (t === `objectStoreNames`) return e.objectStoreNames || vg.get(e);
      if (t === `store`)
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Dg(e[t]);
  },
  set(e, t, n) {
    return ((e[t] = n), !0);
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === `done` || t === `store`) ? !0 : t in e;
  },
};
function wg(e) {
  Cg = e(Cg);
}
function Tg(e) {
  return e === IDBDatabase.prototype.transaction &&
    !(`objectStoreNames` in IDBTransaction.prototype)
    ? function (t, ...n) {
        let r = e.call(Og(this), t, ...n);
        return (vg.set(r, t.sort ? t.sort() : [t]), Dg(r));
      }
    : hg().includes(e)
      ? function (...t) {
          return (e.apply(Og(this), t), Dg(gg.get(this)));
        }
      : function (...t) {
          return Dg(e.apply(Og(this), t));
        };
}
function Eg(e) {
  return typeof e == `function`
    ? Tg(e)
    : (e instanceof IDBTransaction && Sg(e), dg(e, mg()) ? new Proxy(e, Cg) : e);
}
function Dg(e) {
  if (e instanceof IDBRequest) return xg(e);
  if (yg.has(e)) return yg.get(e);
  let t = Eg(e);
  return (t !== e && (yg.set(e, t), bg.set(t, e)), t);
}
var Og = (e) => bg.get(e);
function kg(e, t, { blocked: n, upgrade: r, blocking: i, terminated: a } = {}) {
  let o = indexedDB.open(e, t),
    s = Dg(o);
  return (
    r &&
      o.addEventListener(`upgradeneeded`, (e) => {
        r(Dg(o.result), e.oldVersion, e.newVersion, Dg(o.transaction), e);
      }),
    n && o.addEventListener(`blocked`, (e) => n(e.oldVersion, e.newVersion, e)),
    s
      .then((e) => {
        (a && e.addEventListener(`close`, () => a()),
          i && e.addEventListener(`versionchange`, (e) => i(e.oldVersion, e.newVersion, e)));
      })
      .catch(() => {}),
    s
  );
}
var Ag = [`get`, `getKey`, `getAll`, `getAllKeys`, `count`],
  jg = [`put`, `add`, `delete`, `clear`],
  Mg = new Map();
function Ng(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == `string`)) return;
  if (Mg.get(t)) return Mg.get(t);
  let n = t.replace(/FromIndex$/, ``),
    r = t !== n,
    i = jg.includes(n);
  if (!(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || Ag.includes(n))) return;
  let a = async function (e, ...t) {
    let a = this.transaction(e, i ? `readwrite` : `readonly`),
      o = a.store;
    return (r && (o = o.index(t.shift())), (await Promise.all([o[n](...t), i && a.done]))[0]);
  };
  return (Mg.set(t, a), a);
}
wg((e) => ({
  ...e,
  get: (t, n, r) => Ng(t, n) || e.get(t, n, r),
  has: (t, n) => !!Ng(t, n) || e.has(t, n),
}));
var Pg = `EMJ`,
  Fg = `emojis`,
  Ig = 3;
async function Lg() {
  (
    await kg(Pg, Ig, {
      upgrade(e, t) {
        e.objectStoreNames.contains(Fg) ||
          e
            .createObjectStore(Fg, {
              keyPath: `id`,
              autoIncrement: !0,
            })
            .createIndex(`id`, `id`, {
              unique: !0,
            });
      },
    })
  ).close();
}
Lg();
var Rg = {
  native: !1,
  hideSearch: !0,
  hideGroupIcons: !1,
  hideGroupNames: !1,
  staticTexts: {},
  disabledGroups: [],
  groupNames: {},
  displayRecent: !1,
  additionalGroups: {},
  groupOrder: [],
  groupIcons: {},
};
async function zg() {
  return await (await kg(Pg, Ig)).transaction(Fg, `readonly`).objectStore(Fg).getAll();
}
function Bg() {
  let e = Ae({
    search: ``,
    emoji: ig,
    activeGroup: ``,
    skinTone: ag,
    options: Rg,
    additionalGroups: {},
    recent: [],
    get emojis() {
      return {
        recent: this.recent,
        ...this.options.additionalGroups,
        ...lg,
      };
    },
    get disabled() {
      let e = Array.isArray(this.options.disabledGroups) ? this.options.disabledGroups : [];
      return (this.options.displayRecent || (e = [`recent`, ...e]), e);
    },
    get groups() {
      return ug.filter((e) => !this.disabled.includes(e.key));
    },
    get orderedGroupKeys() {
      let e = [
        ...this.options.groupOrder,
        ...Object.keys(this.options.additionalGroups),
        ...ug.map((e) => e.key),
      ];
      return [...new Set(e)].filter((e) => !this.disabled.includes(e));
    },
  });
  function t() {
    e.options.displayRecent && r();
  }
  async function n() {
    let e = await zg();
    return ((e = Array.isArray(e) && e.length ? JSON.parse(e[0]?.value || ``) : []), e);
  }
  function r() {
    n().then((t) => {
      ((e.recent = t), l());
    });
  }
  let i = (t) => {
      e.search = t;
    },
    a = (t) => {
      e.emoji = t;
    },
    o = (t) => {
      e.activeGroup = t;
    },
    s = (t = ag) => {
      e.skinTone = t;
    },
    c = (n) => {
      ((e.options = Object.assign({}, e.options, n)), t());
    };
  async function l() {
    (await kg(Pg, Ig))
      .transaction(Fg, `readwrite`)
      .objectStore(Fg)
      .put({
        id: 0,
        value: JSON.stringify(e.recent),
      });
  }
  return {
    state: Oe(e),
    updateSearch: i,
    updateEmoji: a,
    updateActiveGroup: o,
    updateSkinTone: s,
    updateOptions: c,
    updateSelect: (t) => {
      if (e.options.displayRecent !== !0) return;
      let n = e.recent.findIndex((e) => e.u === t.u);
      (n > 0 && e.recent.splice(n, 1),
        n !== 0 &&
          ((e.recent = [
            {
              u: t.u,
              n: Xe(t.n),
            },
            ...e.recent,
          ]),
          e.recent.length > 24 && (e.recent.length = 24),
          l()));
    },
  };
}
var Vg = `top`,
  Hg = `bottom`,
  Ug = `right`,
  Wg = `left`,
  Gg = `auto`,
  Kg = [Vg, Hg, Ug, Wg],
  qg = `start`,
  Jg = `end`,
  Yg = `clippingParents`,
  Xg = `viewport`,
  Zg = `popper`,
  Qg = `reference`,
  $g = Kg.reduce(function (e, t) {
    return e.concat([t + `-` + qg, t + `-` + Jg]);
  }, []),
  e_ = [].concat(Kg, [Gg]).reduce(function (e, t) {
    return e.concat([t, t + `-` + qg, t + `-` + Jg]);
  }, []),
  t_ = [
    `beforeRead`,
    `read`,
    `afterRead`,
    `beforeMain`,
    `main`,
    `afterMain`,
    `beforeWrite`,
    `write`,
    `afterWrite`,
  ];
function n_(e) {
  return e ? (e.nodeName || ``).toLowerCase() : null;
}
function r_(e) {
  if (e == null) return window;
  if (e.toString() !== `[object Window]`) {
    var t = e.ownerDocument;
    return (t && t.defaultView) || window;
  }
  return e;
}
function i_(e) {
  return e instanceof r_(e).Element || e instanceof Element;
}
function a_(e) {
  return e instanceof r_(e).HTMLElement || e instanceof HTMLElement;
}
function o_(e) {
  return typeof ShadowRoot > `u` ? !1 : e instanceof r_(e).ShadowRoot || e instanceof ShadowRoot;
}
function s_(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function (e) {
    var n = t.styles[e] || {},
      r = t.attributes[e] || {},
      i = t.elements[e];
    !a_(i) ||
      !n_(i) ||
      (Object.assign(i.style, n),
      Object.keys(r).forEach(function (e) {
        var t = r[e];
        t === !1 ? i.removeAttribute(e) : i.setAttribute(e, t === !0 ? `` : t);
      }));
  });
}
function c_(e) {
  var t = e.state,
    n = {
      popper: {
        position: t.options.strategy,
        left: `0`,
        top: `0`,
        margin: `0`,
      },
      arrow: {
        position: `absolute`,
      },
      reference: {},
    };
  return (
    Object.assign(t.elements.popper.style, n.popper),
    (t.styles = n),
    t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow),
    function () {
      Object.keys(t.elements).forEach(function (e) {
        var r = t.elements[e],
          i = t.attributes[e] || {},
          a = Object.keys(t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]).reduce(function (e, t) {
            return ((e[t] = ``), e);
          }, {});
        !a_(r) ||
          !n_(r) ||
          (Object.assign(r.style, a),
          Object.keys(i).forEach(function (e) {
            r.removeAttribute(e);
          }));
      });
    }
  );
}
var l_ = {
  name: `applyStyles`,
  enabled: !0,
  phase: `write`,
  fn: s_,
  effect: c_,
  requires: [`computeStyles`],
};
function u_(e) {
  return e.split(`-`)[0];
}
var d_ = Math.max,
  f_ = Math.min,
  p_ = Math.round;
function m_(e, t) {
  t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(),
    r = 1,
    i = 1;
  if (a_(e) && t) {
    var a = e.offsetHeight,
      o = e.offsetWidth;
    (o > 0 && (r = p_(n.width) / o || 1), a > 0 && (i = p_(n.height) / a || 1));
  }
  return {
    width: n.width / r,
    height: n.height / i,
    top: n.top / i,
    right: n.right / r,
    bottom: n.bottom / i,
    left: n.left / r,
    x: n.left / r,
    y: n.top / i,
  };
}
function h_(e) {
  var t = m_(e),
    n = e.offsetWidth,
    r = e.offsetHeight;
  return (
    Math.abs(t.width - n) <= 1 && (n = t.width),
    Math.abs(t.height - r) <= 1 && (r = t.height),
    {
      x: e.offsetLeft,
      y: e.offsetTop,
      width: n,
      height: r,
    }
  );
}
function g_(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t)) return !0;
  if (n && o_(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r)) return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function __(e) {
  return r_(e).getComputedStyle(e);
}
function v_(e) {
  return [`table`, `td`, `th`].indexOf(n_(e)) >= 0;
}
function y_(e) {
  return ((i_(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function b_(e) {
  return n_(e) === `html` ? e : e.assignedSlot || e.parentNode || (o_(e) ? e.host : null) || y_(e);
}
function x_(e) {
  return !a_(e) || __(e).position === `fixed` ? null : e.offsetParent;
}
function S_(e) {
  var t = navigator.userAgent.toLowerCase().indexOf(`firefox`) !== -1;
  if (navigator.userAgent.indexOf(`Trident`) !== -1 && a_(e) && __(e).position === `fixed`)
    return null;
  for (var n = b_(e); a_(n) && [`html`, `body`].indexOf(n_(n)) < 0;) {
    var r = __(n);
    if (
      r.transform !== `none` ||
      r.perspective !== `none` ||
      r.contain === `paint` ||
      [`transform`, `perspective`].indexOf(r.willChange) !== -1 ||
      (t && r.willChange === `filter`) ||
      (t && r.filter && r.filter !== `none`)
    )
      return n;
    n = n.parentNode;
  }
  return null;
}
function C_(e) {
  for (var t = r_(e), n = x_(e); n && v_(n) && __(n).position === `static`;) n = x_(n);
  return n && (n_(n) === `html` || (n_(n) === `body` && __(n).position === `static`))
    ? t
    : n || S_(e) || t;
}
function w_(e) {
  return [`top`, `bottom`].indexOf(e) >= 0 ? `x` : `y`;
}
function T_(e, t, n) {
  return d_(e, f_(t, n));
}
function E_(e, t, n) {
  var r = T_(e, t, n);
  return r > n ? n : r;
}
function D_() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
}
function O_(e) {
  return Object.assign({}, D_(), e);
}
function k_(e, t) {
  return t.reduce(function (t, n) {
    return ((t[n] = e), t);
  }, {});
}
var A_ = function (e, t) {
  return (
    (e =
      typeof e == `function`
        ? e(
            Object.assign({}, t.rects, {
              placement: t.placement,
            }),
          )
        : e),
    O_(typeof e == `number` ? k_(e, Kg) : e)
  );
};
function j_(e) {
  var t,
    n = e.state,
    r = e.name,
    i = e.options,
    a = n.elements.arrow,
    o = n.modifiersData.popperOffsets,
    s = u_(n.placement),
    c = w_(s),
    l = [Wg, Ug].indexOf(s) >= 0 ? `height` : `width`;
  if (!(!a || !o)) {
    var u = A_(i.padding, n),
      d = h_(a),
      f = c === `y` ? Vg : Wg,
      p = c === `y` ? Hg : Ug,
      m = n.rects.reference[l] + n.rects.reference[c] - o[c] - n.rects.popper[l],
      h = o[c] - n.rects.reference[c],
      g = C_(a),
      v = g ? (c === `y` ? g.clientHeight || 0 : g.clientWidth || 0) : 0,
      y = m / 2 - h / 2,
      b = u[f],
      x = v - d[l] - u[p],
      S = v / 2 - d[l] / 2 + y,
      C = T_(b, S, x),
      w = c;
    n.modifiersData[r] = ((t = {}), (t[w] = C), (t.centerOffset = C - S), t);
  }
}
function M_(e) {
  var t = e.state,
    n = e.options.element,
    r = n === void 0 ? `[data-popper-arrow]` : n;
  r != null &&
    ((typeof r == `string` && ((r = t.elements.popper.querySelector(r)), !r)) ||
      (g_(t.elements.popper, r) && (t.elements.arrow = r)));
}
var N_ = {
  name: `arrow`,
  enabled: !0,
  phase: `main`,
  fn: j_,
  effect: M_,
  requires: [`popperOffsets`],
  requiresIfExists: [`preventOverflow`],
};
function P_(e) {
  return e.split(`-`)[1];
}
var F_ = {
  top: `auto`,
  right: `auto`,
  bottom: `auto`,
  left: `auto`,
};
function I_(e) {
  var t = e.x,
    n = e.y,
    r = window.devicePixelRatio || 1;
  return {
    x: p_(t * r) / r || 0,
    y: p_(n * r) / r || 0,
  };
}
function L_(e) {
  var t,
    n = e.popper,
    r = e.popperRect,
    i = e.placement,
    a = e.variation,
    o = e.offsets,
    s = e.position,
    c = e.gpuAcceleration,
    l = e.adaptive,
    u = e.roundOffsets,
    d = e.isFixed,
    f = u === !0 ? I_(o) : typeof u == `function` ? u(o) : o,
    p = f.x,
    m = p === void 0 ? 0 : p,
    h = f.y,
    g = h === void 0 ? 0 : h,
    v = o.hasOwnProperty(`x`),
    y = o.hasOwnProperty(`y`),
    b = Wg,
    x = Vg,
    S = window;
  if (l) {
    var C = C_(n),
      w = `clientHeight`,
      T = `clientWidth`;
    if (
      (C === r_(n) &&
        ((C = y_(n)),
        __(C).position !== `static` &&
          s === `absolute` &&
          ((w = `scrollHeight`), (T = `scrollWidth`))),
      (C = C),
      i === Vg || ((i === Wg || i === Ug) && a === Jg))
    ) {
      x = Hg;
      var E = d && S.visualViewport ? S.visualViewport.height : C[w];
      ((g -= E - r.height), (g *= c ? 1 : -1));
    }
    if (i === Wg || ((i === Vg || i === Hg) && a === Jg)) {
      b = Ug;
      var D = d && S.visualViewport ? S.visualViewport.width : C[T];
      ((m -= D - r.width), (m *= c ? 1 : -1));
    }
  }
  var ee = Object.assign(
    {
      position: s,
    },
    l && F_,
  );
  if (c) {
    var te;
    return Object.assign(
      {},
      ee,
      ((te = {}),
      (te[x] = y ? `0` : ``),
      (te[b] = v ? `0` : ``),
      (te.transform =
        (S.devicePixelRatio || 1) <= 1
          ? `translate(` + m + `px, ` + g + `px)`
          : `translate3d(` + m + `px, ` + g + `px, 0)`),
      te),
    );
  }
  return Object.assign(
    {},
    ee,
    ((t = {}), (t[x] = y ? g + `px` : ``), (t[b] = v ? m + `px` : ``), (t.transform = ``), t),
  );
}
function R_(e) {
  var t = e.state,
    n = e.options,
    r = n.gpuAcceleration,
    i = r === void 0 ? !0 : r,
    a = n.adaptive,
    o = a === void 0 ? !0 : a,
    s = n.roundOffsets,
    c = s === void 0 ? !0 : s,
    l = {
      placement: u_(t.placement),
      variation: P_(t.placement),
      popper: t.elements.popper,
      popperRect: t.rects.popper,
      gpuAcceleration: i,
      isFixed: t.options.strategy === `fixed`,
    };
  (t.modifiersData.popperOffsets != null &&
    (t.styles.popper = Object.assign(
      {},
      t.styles.popper,
      L_(
        Object.assign({}, l, {
          offsets: t.modifiersData.popperOffsets,
          position: t.options.strategy,
          adaptive: o,
          roundOffsets: c,
        }),
      ),
    )),
    t.modifiersData.arrow != null &&
      (t.styles.arrow = Object.assign(
        {},
        t.styles.arrow,
        L_(
          Object.assign({}, l, {
            offsets: t.modifiersData.arrow,
            position: `absolute`,
            adaptive: !1,
            roundOffsets: c,
          }),
        ),
      )),
    (t.attributes.popper = Object.assign({}, t.attributes.popper, {
      "data-popper-placement": t.placement,
    })));
}
var z_ = {
    name: `computeStyles`,
    enabled: !0,
    phase: `beforeWrite`,
    fn: R_,
    data: {},
  },
  B_ = {
    passive: !0,
  };
function V_(e) {
  var t = e.state,
    n = e.instance,
    r = e.options,
    i = r.scroll,
    a = i === void 0 ? !0 : i,
    o = r.resize,
    s = o === void 0 ? !0 : o,
    c = r_(t.elements.popper),
    l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return (
    a &&
      l.forEach(function (e) {
        e.addEventListener(`scroll`, n.update, B_);
      }),
    s && c.addEventListener(`resize`, n.update, B_),
    function () {
      (a &&
        l.forEach(function (e) {
          e.removeEventListener(`scroll`, n.update, B_);
        }),
        s && c.removeEventListener(`resize`, n.update, B_));
    }
  );
}
var H_ = {
    name: `eventListeners`,
    enabled: !0,
    phase: `write`,
    fn: function () {},
    effect: V_,
    data: {},
  },
  U_ = {
    left: `right`,
    right: `left`,
    bottom: `top`,
    top: `bottom`,
  };
function W_(e) {
  return e.replace(/left|right|bottom|top/g, function (e) {
    return U_[e];
  });
}
var G_ = {
  start: `end`,
  end: `start`,
};
function K_(e) {
  return e.replace(/start|end/g, function (e) {
    return G_[e];
  });
}
function q_(e) {
  var t = r_(e);
  return {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset,
  };
}
function J_(e) {
  return m_(y_(e)).left + q_(e).scrollLeft;
}
function Y_(e) {
  var t = r_(e),
    n = y_(e),
    r = t.visualViewport,
    i = n.clientWidth,
    a = n.clientHeight,
    o = 0,
    s = 0;
  return (
    r &&
      ((i = r.width),
      (a = r.height),
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
        ((o = r.offsetLeft), (s = r.offsetTop))),
    {
      width: i,
      height: a,
      x: o + J_(e),
      y: s,
    }
  );
}
function X_(e) {
  var t = y_(e),
    n = q_(e),
    r = e.ownerDocument?.body,
    i = d_(t.scrollWidth, t.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0),
    a = d_(t.scrollHeight, t.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0),
    o = -n.scrollLeft + J_(e),
    s = -n.scrollTop;
  return (
    __(r || t).direction === `rtl` && (o += d_(t.clientWidth, r ? r.clientWidth : 0) - i),
    {
      width: i,
      height: a,
      x: o,
      y: s,
    }
  );
}
function Z_(e) {
  var t = __(e),
    n = t.overflow,
    r = t.overflowX,
    i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function Q_(e) {
  return [`html`, `body`, `#document`].indexOf(n_(e)) >= 0
    ? e.ownerDocument.body
    : a_(e) && Z_(e)
      ? e
      : Q_(b_(e));
}
function $_(e, t) {
  t === void 0 && (t = []);
  var n = Q_(e),
    r = n === e.ownerDocument?.body,
    i = r_(n),
    a = r ? [i].concat(i.visualViewport || [], Z_(n) ? n : []) : n,
    o = t.concat(a);
  return r ? o : o.concat($_(b_(a)));
}
function ev(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height,
  });
}
function tv(e) {
  var t = m_(e);
  return (
    (t.top += e.clientTop),
    (t.left += e.clientLeft),
    (t.bottom = t.top + e.clientHeight),
    (t.right = t.left + e.clientWidth),
    (t.width = e.clientWidth),
    (t.height = e.clientHeight),
    (t.x = t.left),
    (t.y = t.top),
    t
  );
}
function nv(e, t) {
  return t === Xg ? ev(Y_(e)) : i_(t) ? tv(t) : ev(X_(y_(e)));
}
function rv(e) {
  var t = $_(b_(e)),
    n = [`absolute`, `fixed`].indexOf(__(e).position) >= 0,
    r = n && a_(e) ? C_(e) : e;
  return i_(r)
    ? t.filter(function (e) {
        return i_(e) && g_(e, r) && n_(e) !== `body` && (n ? __(e).position !== `static` : !0);
      })
    : [];
}
function iv(e, t, n) {
  var r = t === `clippingParents` ? rv(e) : [].concat(t),
    i = [].concat(r, [n]),
    a = i[0],
    o = i.reduce(
      function (t, n) {
        var r = nv(e, n);
        return (
          (t.top = d_(r.top, t.top)),
          (t.right = f_(r.right, t.right)),
          (t.bottom = f_(r.bottom, t.bottom)),
          (t.left = d_(r.left, t.left)),
          t
        );
      },
      nv(e, a),
    );
  return (
    (o.width = o.right - o.left),
    (o.height = o.bottom - o.top),
    (o.x = o.left),
    (o.y = o.top),
    o
  );
}
function av(e) {
  var t = e.reference,
    n = e.element,
    r = e.placement,
    i = r ? u_(r) : null,
    a = r ? P_(r) : null,
    o = t.x + t.width / 2 - n.width / 2,
    s = t.y + t.height / 2 - n.height / 2,
    c;
  switch (i) {
    case Vg:
      c = {
        x: o,
        y: t.y - n.height,
      };
      break;
    case Hg:
      c = {
        x: o,
        y: t.y + t.height,
      };
      break;
    case Ug:
      c = {
        x: t.x + t.width,
        y: s,
      };
      break;
    case Wg:
      c = {
        x: t.x - n.width,
        y: s,
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y,
      };
  }
  var l = i ? w_(i) : null;
  if (l != null) {
    var u = l === `y` ? `height` : `width`;
    switch (a) {
      case qg:
        c[l] = c[l] - (t[u] / 2 - n[u] / 2);
        break;
      case Jg:
        c[l] = c[l] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return c;
}
function ov(e, t) {
  t === void 0 && (t = {});
  var n = t,
    r = n.placement,
    i = r === void 0 ? e.placement : r,
    a = n.boundary,
    o = a === void 0 ? Yg : a,
    s = n.rootBoundary,
    c = s === void 0 ? Xg : s,
    l = n.elementContext,
    u = l === void 0 ? Zg : l,
    d = n.altBoundary,
    f = d === void 0 ? !1 : d,
    p = n.padding,
    m = p === void 0 ? 0 : p,
    h = O_(typeof m == `number` ? k_(m, Kg) : m),
    g = u === Zg ? Qg : Zg,
    v = e.rects.popper,
    y = e.elements[f ? g : u],
    b = iv(i_(y) ? y : y.contextElement || y_(e.elements.popper), o, c),
    x = m_(e.elements.reference),
    S = av({
      reference: x,
      element: v,
      strategy: `absolute`,
      placement: i,
    }),
    C = ev(Object.assign({}, v, S)),
    w = u === Zg ? C : x,
    T = {
      top: b.top - w.top + h.top,
      bottom: w.bottom - b.bottom + h.bottom,
      left: b.left - w.left + h.left,
      right: w.right - b.right + h.right,
    },
    E = e.modifiersData.offset;
  if (u === Zg && E) {
    var D = E[i];
    Object.keys(T).forEach(function (e) {
      var t = [Ug, Hg].indexOf(e) >= 0 ? 1 : -1,
        n = [Vg, Hg].indexOf(e) >= 0 ? `y` : `x`;
      T[e] += D[n] * t;
    });
  }
  return T;
}
function sv(e, t) {
  t === void 0 && (t = {});
  var n = t,
    r = n.placement,
    i = n.boundary,
    a = n.rootBoundary,
    o = n.padding,
    s = n.flipVariations,
    c = n.allowedAutoPlacements,
    l = c === void 0 ? e_ : c,
    u = P_(r),
    d = u
      ? s
        ? $g
        : $g.filter(function (e) {
            return P_(e) === u;
          })
      : Kg,
    f = d.filter(function (e) {
      return l.indexOf(e) >= 0;
    });
  f.length === 0 && (f = d);
  var p = f.reduce(function (t, n) {
    return (
      (t[n] = ov(e, {
        placement: n,
        boundary: i,
        rootBoundary: a,
        padding: o,
      })[u_(n)]),
      t
    );
  }, {});
  return Object.keys(p).sort(function (e, t) {
    return p[e] - p[t];
  });
}
function cv(e) {
  if (u_(e) === Gg) return [];
  var t = W_(e);
  return [K_(e), t, K_(t)];
}
function lv(e) {
  var t = e.state,
    n = e.options,
    r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (
      var i = n.mainAxis,
        a = i === void 0 ? !0 : i,
        o = n.altAxis,
        s = o === void 0 ? !0 : o,
        c = n.fallbackPlacements,
        l = n.padding,
        u = n.boundary,
        d = n.rootBoundary,
        f = n.altBoundary,
        p = n.flipVariations,
        m = p === void 0 ? !0 : p,
        h = n.allowedAutoPlacements,
        g = t.options.placement,
        v = u_(g) === g,
        y = c || (v || !m ? [W_(g)] : cv(g)),
        b = [g].concat(y).reduce(function (e, n) {
          return e.concat(
            u_(n) === Gg
              ? sv(t, {
                  placement: n,
                  boundary: u,
                  rootBoundary: d,
                  padding: l,
                  flipVariations: m,
                  allowedAutoPlacements: h,
                })
              : n,
          );
        }, []),
        x = t.rects.reference,
        S = t.rects.popper,
        C = new Map(),
        w = !0,
        T = b[0],
        E = 0;
      E < b.length;
      E++
    ) {
      var D = b[E],
        ee = u_(D),
        te = P_(D) === qg,
        O = [Vg, Hg].indexOf(ee) >= 0,
        k = O ? `width` : `height`,
        ne = ov(t, {
          placement: D,
          boundary: u,
          rootBoundary: d,
          altBoundary: f,
          padding: l,
        }),
        re = O ? (te ? Ug : Wg) : te ? Hg : Vg;
      x[k] > S[k] && (re = W_(re));
      var A = W_(re),
        ie = [];
      if (
        (a && ie.push(ne[ee] <= 0),
        s && ie.push(ne[re] <= 0, ne[A] <= 0),
        ie.every(function (e) {
          return e;
        }))
      ) {
        ((T = D), (w = !1));
        break;
      }
      C.set(D, ie);
    }
    if (w)
      for (
        var j = m ? 3 : 1,
          ae = function (e) {
            var t = b.find(function (t) {
              var n = C.get(t);
              if (n)
                return n.slice(0, e).every(function (e) {
                  return e;
                });
            });
            if (t) return ((T = t), `break`);
          },
          oe = j;
        oe > 0 && ae(oe) !== `break`;
        oe--
      );
    t.placement !== T && ((t.modifiersData[r]._skip = !0), (t.placement = T), (t.reset = !0));
  }
}
var uv = {
  name: `flip`,
  enabled: !0,
  phase: `main`,
  fn: lv,
  requiresIfExists: [`offset`],
  data: {
    _skip: !1,
  },
};
function dv(e, t, n) {
  return (
    n === void 0 &&
      (n = {
        x: 0,
        y: 0,
      }),
    {
      top: e.top - t.height - n.y,
      right: e.right - t.width + n.x,
      bottom: e.bottom - t.height + n.y,
      left: e.left - t.width - n.x,
    }
  );
}
function fv(e) {
  return [Vg, Ug, Hg, Wg].some(function (t) {
    return e[t] >= 0;
  });
}
function pv(e) {
  var t = e.state,
    n = e.name,
    r = t.rects.reference,
    i = t.rects.popper,
    a = t.modifiersData.preventOverflow,
    o = ov(t, {
      elementContext: `reference`,
    }),
    s = ov(t, {
      altBoundary: !0,
    }),
    c = dv(o, r),
    l = dv(s, i, a),
    u = fv(c),
    d = fv(l);
  ((t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: d,
  }),
    (t.attributes.popper = Object.assign({}, t.attributes.popper, {
      "data-popper-reference-hidden": u,
      "data-popper-escaped": d,
    })));
}
var mv = {
  name: `hide`,
  enabled: !0,
  phase: `main`,
  requiresIfExists: [`preventOverflow`],
  fn: pv,
};
function hv(e, t, n) {
  var r = u_(e),
    i = [Wg, Vg].indexOf(r) >= 0 ? -1 : 1,
    a =
      typeof n == `function`
        ? n(
            Object.assign({}, t, {
              placement: e,
            }),
          )
        : n,
    o = a[0],
    s = a[1];
  return (
    (o ||= 0),
    (s = (s || 0) * i),
    [Wg, Ug].indexOf(r) >= 0
      ? {
          x: s,
          y: o,
        }
      : {
          x: o,
          y: s,
        }
  );
}
function gv(e) {
  var t = e.state,
    n = e.options,
    r = e.name,
    i = n.offset,
    a = i === void 0 ? [0, 0] : i,
    o = e_.reduce(function (e, n) {
      return ((e[n] = hv(n, t.rects, a)), e);
    }, {}),
    s = o[t.placement],
    c = s.x,
    l = s.y;
  (t.modifiersData.popperOffsets != null &&
    ((t.modifiersData.popperOffsets.x += c), (t.modifiersData.popperOffsets.y += l)),
    (t.modifiersData[r] = o));
}
var _v = {
  name: `offset`,
  enabled: !0,
  phase: `main`,
  requires: [`popperOffsets`],
  fn: gv,
};
function vv(e) {
  var t = e.state,
    n = e.name;
  t.modifiersData[n] = av({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: `absolute`,
    placement: t.placement,
  });
}
var yv = {
  name: `popperOffsets`,
  enabled: !0,
  phase: `read`,
  fn: vv,
  data: {},
};
function bv(e) {
  return e === `x` ? `y` : `x`;
}
function xv(e) {
  var t = e.state,
    n = e.options,
    r = e.name,
    i = n.mainAxis,
    a = i === void 0 ? !0 : i,
    o = n.altAxis,
    s = o === void 0 ? !1 : o,
    c = n.boundary,
    l = n.rootBoundary,
    u = n.altBoundary,
    d = n.padding,
    f = n.tether,
    p = f === void 0 ? !0 : f,
    m = n.tetherOffset,
    h = m === void 0 ? 0 : m,
    g = ov(t, {
      boundary: c,
      rootBoundary: l,
      padding: d,
      altBoundary: u,
    }),
    v = u_(t.placement),
    y = P_(t.placement),
    b = !y,
    x = w_(v),
    S = bv(x),
    C = t.modifiersData.popperOffsets,
    w = t.rects.reference,
    T = t.rects.popper,
    E =
      typeof h == `function`
        ? h(
            Object.assign({}, t.rects, {
              placement: t.placement,
            }),
          )
        : h,
    D =
      typeof E == `number`
        ? {
            mainAxis: E,
            altAxis: E,
          }
        : Object.assign(
            {
              mainAxis: 0,
              altAxis: 0,
            },
            E,
          ),
    ee = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
    te = {
      x: 0,
      y: 0,
    };
  if (C) {
    if (a) {
      var O = x === `y` ? Vg : Wg,
        k = x === `y` ? Hg : Ug,
        ne = x === `y` ? `height` : `width`,
        re = C[x],
        A = re + g[O],
        ie = re - g[k],
        j = p ? -T[ne] / 2 : 0,
        ae = y === qg ? w[ne] : T[ne],
        oe = y === qg ? -T[ne] : -w[ne],
        se = t.elements.arrow,
        ce =
          p && se
            ? h_(se)
            : {
                width: 0,
                height: 0,
              },
        le = t.modifiersData[`arrow#persistent`]
          ? t.modifiersData[`arrow#persistent`].padding
          : D_(),
        ue = le[O],
        de = le[k],
        fe = T_(0, w[ne], ce[ne]),
        pe = b ? w[ne] / 2 - j - fe - ue - D.mainAxis : ae - fe - ue - D.mainAxis,
        M = b ? -w[ne] / 2 + j + fe + de + D.mainAxis : oe + fe + de + D.mainAxis,
        me = t.elements.arrow && C_(t.elements.arrow),
        N = me ? (x === `y` ? me.clientTop || 0 : me.clientLeft || 0) : 0,
        P = ee?.[x] ?? 0,
        he = re + pe - P - N,
        ge = re + M - P,
        _e = T_(p ? f_(A, he) : A, re, p ? d_(ie, ge) : ie);
      ((C[x] = _e), (te[x] = _e - re));
    }
    if (s) {
      var ve = x === `x` ? Vg : Wg,
        ye = x === `x` ? Hg : Ug,
        F = C[S],
        be = S === `y` ? `height` : `width`,
        I = F + g[ve],
        L = F - g[ye],
        xe = [Vg, Wg].indexOf(v) !== -1,
        Se = ee?.[S] ?? 0,
        Ce = xe ? I : F - w[be] - T[be] - Se + D.altAxis,
        we = xe ? F + w[be] + T[be] - Se - D.altAxis : L,
        Te = p && xe ? E_(Ce, F, we) : T_(p ? Ce : I, F, p ? we : L);
      ((C[S] = Te), (te[S] = Te - F));
    }
    t.modifiersData[r] = te;
  }
}
var Sv = {
  name: `preventOverflow`,
  enabled: !0,
  phase: `main`,
  fn: xv,
  requiresIfExists: [`offset`],
};
function Cv(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop,
  };
}
function wv(e) {
  return e === r_(e) || !a_(e) ? q_(e) : Cv(e);
}
function Tv(e) {
  var t = e.getBoundingClientRect(),
    n = p_(t.width) / e.offsetWidth || 1,
    r = p_(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Ev(e, t, n) {
  n === void 0 && (n = !1);
  var r = a_(t),
    i = a_(t) && Tv(t),
    a = y_(t),
    o = m_(e, i),
    s = {
      scrollLeft: 0,
      scrollTop: 0,
    },
    c = {
      x: 0,
      y: 0,
    };
  return (
    (r || (!r && !n)) &&
      ((n_(t) !== `body` || Z_(a)) && (s = wv(t)),
      a_(t) ? ((c = m_(t, !0)), (c.x += t.clientLeft), (c.y += t.clientTop)) : a && (c.x = J_(a))),
    {
      x: o.left + s.scrollLeft - c.x,
      y: o.top + s.scrollTop - c.y,
      width: o.width,
      height: o.height,
    }
  );
}
function Dv(e) {
  var t = new Map(),
    n = new Set(),
    r = [];
  e.forEach(function (e) {
    t.set(e.name, e);
  });
  function i(e) {
    (n.add(e.name),
      [].concat(e.requires || [], e.requiresIfExists || []).forEach(function (e) {
        if (!n.has(e)) {
          var r = t.get(e);
          r && i(r);
        }
      }),
      r.push(e));
  }
  return (
    e.forEach(function (e) {
      n.has(e.name) || i(e);
    }),
    r
  );
}
function Ov(e) {
  var t = Dv(e);
  return t_.reduce(function (e, n) {
    return e.concat(
      t.filter(function (e) {
        return e.phase === n;
      }),
    );
  }, []);
}
function kv(e) {
  var t;
  return function () {
    return (
      (t ||= new Promise(function (n) {
        Promise.resolve().then(function () {
          ((t = void 0), n(e()));
        });
      })),
      t
    );
  };
}
function Av(e) {
  var t = e.reduce(function (e, t) {
    var n = e[t.name];
    return (
      (e[t.name] = n
        ? Object.assign({}, n, t, {
            options: Object.assign({}, n.options, t.options),
            data: Object.assign({}, n.data, t.data),
          })
        : t),
      e
    );
  }, {});
  return Object.keys(t).map(function (e) {
    return t[e];
  });
}
var jv = {
  placement: `bottom`,
  modifiers: [],
  strategy: `absolute`,
};
function Mv() {
  return ![...arguments].some(function (e) {
    return !(e && typeof e.getBoundingClientRect == `function`);
  });
}
function Nv(e) {
  e === void 0 && (e = {});
  var t = e,
    n = t.defaultModifiers,
    r = n === void 0 ? [] : n,
    i = t.defaultOptions,
    a = i === void 0 ? jv : i;
  return function (e, t, n) {
    n === void 0 && (n = a);
    var i = {
        placement: `bottom`,
        orderedModifiers: [],
        options: Object.assign({}, jv, a),
        modifiersData: {},
        elements: {
          reference: e,
          popper: t,
        },
        attributes: {},
        styles: {},
      },
      o = [],
      s = !1,
      c = {
        state: i,
        setOptions: function (n) {
          var o = typeof n == `function` ? n(i.options) : n;
          (u(),
            (i.options = Object.assign({}, a, i.options, o)),
            (i.scrollParents = {
              reference: i_(e) ? $_(e) : e.contextElement ? $_(e.contextElement) : [],
              popper: $_(t),
            }));
          var s = Ov(Av([].concat(r, i.options.modifiers)));
          return (
            (i.orderedModifiers = s.filter(function (e) {
              return e.enabled;
            })),
            l(),
            c.update()
          );
        },
        forceUpdate: function () {
          if (!s) {
            var e = i.elements,
              t = e.reference,
              n = e.popper;
            if (Mv(t, n)) {
              ((i.rects = {
                reference: Ev(t, C_(n), i.options.strategy === `fixed`),
                popper: h_(n),
              }),
                (i.reset = !1),
                (i.placement = i.options.placement),
                i.orderedModifiers.forEach(function (e) {
                  return (i.modifiersData[e.name] = Object.assign({}, e.data));
                }));
              for (var r = 0; r < i.orderedModifiers.length; r++) {
                if (i.reset === !0) {
                  ((i.reset = !1), (r = -1));
                  continue;
                }
                var a = i.orderedModifiers[r],
                  o = a.fn,
                  l = a.options,
                  u = l === void 0 ? {} : l,
                  d = a.name;
                typeof o == `function` &&
                  (i =
                    o({
                      state: i,
                      options: u,
                      name: d,
                      instance: c,
                    }) || i);
              }
            }
          }
        },
        update: kv(function () {
          return new Promise(function (e) {
            (c.forceUpdate(), e(i));
          });
        }),
        destroy: function () {
          (u(), (s = !0));
        },
      };
    if (!Mv(e, t)) return c;
    c.setOptions(n).then(function (e) {
      !s && n.onFirstUpdate && n.onFirstUpdate(e);
    });
    function l() {
      i.orderedModifiers.forEach(function (e) {
        var t = e.name,
          n = e.options,
          r = n === void 0 ? {} : n,
          a = e.effect;
        if (typeof a == `function`) {
          var s = a({
            state: i,
            name: t,
            instance: c,
            options: r,
          });
          o.push(s || function () {});
        }
      });
    }
    function u() {
      (o.forEach(function (e) {
        return e();
      }),
        (o = []));
    }
    return c;
  };
}
var Pv = Nv({
    defaultModifiers: [H_, yv, z_, l_, _v, uv, Sv, N_, mv],
  }),
  Fv = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZD0iTSAxNiA0IEMgOS4zODI4MTMgNCA0IDkuMzgyODEzIDQgMTYgQyA0IDIyLjYxNzE4OCA5LjM4MjgxMyAyOCAxNiAyOCBDIDIyLjYxNzE4OCAyOCAyOCAyMi42MTcxODggMjggMTYgQyAyOCA5LjM4MjgxMyAyMi42MTcxODggNCAxNiA0IFogTSAxNiA2IEMgMjEuNTM1MTU2IDYgMjYgMTAuNDY0ODQ0IDI2IDE2IEMgMjYgMjEuNTM1MTU2IDIxLjUzNTE1NiAyNiAxNiAyNiBDIDEwLjQ2NDg0NCAyNiA2IDIxLjUzNTE1NiA2IDE2IEMgNiAxMC40NjQ4NDQgMTAuNDY0ODQ0IDYgMTYgNiBaIE0gMTEuNSAxMiBDIDEwLjY3MTg3NSAxMiAxMCAxMi42NzE4NzUgMTAgMTMuNSBDIDEwIDE0LjMyODEyNSAxMC42NzE4NzUgMTUgMTEuNSAxNSBDIDEyLjMyODEyNSAxNSAxMyAxNC4zMjgxMjUgMTMgMTMuNSBDIDEzIDEyLjY3MTg3NSAxMi4zMjgxMjUgMTIgMTEuNSAxMiBaIE0gMjAuNSAxMiBDIDE5LjY3MTg3NSAxMiAxOSAxMi42NzE4NzUgMTkgMTMuNSBDIDE5IDE0LjMyODEyNSAxOS42NzE4NzUgMTUgMjAuNSAxNSBDIDIxLjMyODEyNSAxNSAyMiAxNC4zMjgxMjUgMjIgMTMuNSBDIDIyIDEyLjY3MTg3NSAyMS4zMjgxMjUgMTIgMjAuNSAxMiBaIE0gMTAuODEyNSAxOSBMIDkuMDkzNzUgMjAgQyAxMC40NzY1NjMgMjIuMzg2NzE5IDEzLjA0Njg3NSAyNCAxNiAyNCBDIDE4Ljk1MzEyNSAyNCAyMS41MjM0MzggMjIuMzg2NzE5IDIyLjkwNjI1IDIwIEwgMjEuMTg3NSAxOSBDIDIwLjE0ODQzOCAyMC43OTI5NjkgMTguMjI2NTYzIDIyIDE2IDIyIEMgMTMuNzczNDM4IDIyIDExLjg1MTU2MyAyMC43OTI5NjkgMTAuODEyNSAxOSBaIi8+PC9zdmc+`;
function Iv(e) {
  return e
    .split(`-`)
    .map((e) => parseInt(e, 16))
    .map((e) => String.fromCodePoint(e))
    .join(``);
}
function Lv(e, t, n, r = []) {
  let i = {};
  return (
    Object.keys(e).forEach((a) => {
      if (r.includes(a)) return;
      let o = [];
      (e[a].forEach((e) => {
        if (e[tg][0].includes(t.toLocaleLowerCase())) {
          let t = e[eg];
          if (n !== ag && Array.isArray(e[ng])) {
            let r = e[ng]?.findIndex((e) => e.includes(n)) || -1;
            r !== -1 && e[ng] && (t = e[ng][r]);
          }
          return o.push({
            ...e,
            [rg]: t,
          });
        }
      }),
        o.length && (i[a] = o));
    }),
    i
  );
}
function Rv() {
  return (
    (
      (navigator == null ? void 0 : navigator.userAgentData)?.platform ||
      (navigator == null ? void 0 : navigator.platform) ||
      `unknown`
    )
      .toUpperCase()
      .indexOf(`MAC`) !== -1
  );
}
function zv(e) {
  return e.replace(/^_*(.)|_+(.)/g, (e, t, n) => (t ? t.toUpperCase() : ` ` + n.toUpperCase()));
}
var Bv = (e, t) => {
    let n = e.__vccOpts || e;
    for (let [e, r] of t) n[e] = r;
    return n;
  },
  Vv = k({
    name: `Body`,
    emits: {
      select: (e) => !0,
    },
    setup() {
      let { state: e, updateEmoji: t, updateSelect: n } = R(`store`),
        r = F(null),
        i = V(() => Lv(e.emojis, e.search, e.skinTone, e.options.disabledGroups)),
        a = te(),
        o = V(() => !e.options.hideGroupNames),
        s = V(() => !e.options.disableStickyGroupNames),
        c = Xe(e.options.groupNames),
        l = e.orderedGroupKeys;
      e.options.additionalGroups &&
        Object.keys(e.options.additionalGroups).map((t) => {
          e.options.groupNames[t] ? (c[t] = e.options.groupNames[t]) : (c[t] = zv(t));
        });
      let u = Rv() ? `is-mac` : ``;
      function d(e) {
        t(e);
      }
      function f(t) {
        (n(t),
          a?.emit(`select`, {
            ...t,
            t: e.skinTone,
            i: Iv(t.r),
          }));
      }
      function p(e, t) {
        let n = e?.target?.closest(`button`);
        n && (n.innerHTML = `<span>${Iv(t)}</span>`);
      }
      return (
        He(
          () => e.activeGroup,
          () => {
            let t = r.value?.querySelector(`#` + e.activeGroup);
            t && (t.parentNode.scrollTop = t.offsetTop - t.parentNode.offsetTop);
          },
        ),
        {
          emojis: i,
          bodyInner: r,
          EMOJI_REMOTE_SRC: Qh,
          GROUP_NAMES: $h,
          handleClick: f,
          handleError: p,
          handleMouseEnter: d,
          native: e.options.native,
          unicodeToEmoji: Iv,
          EMOJI_RESULT_KEY: rg,
          EMOJI_NAME_KEY: tg,
          hasGroupNames: o,
          isSticky: s,
          platform: u,
          groupNames: c,
          orderedKeys: l,
        }
      );
    },
  }),
  Hv = {
    class: `v3-body`,
  },
  Uv = [`id`],
  Wv = {
    class: `v3-emojis`,
  },
  Gv = [`onMouseenter`, `onClick`],
  Kv = {
    key: 0,
  },
  qv = [`src`, `alt`, `onError`],
  Jv = {
    key: 1,
    class: `v3-no-result`,
  };
function Yv(e, t, n, r, i, a) {
  return (
    A(),
    M(`div`, Hv, [
      W(
        `div`,
        {
          ref: `bodyInner`,
          class: O([e.platform, `v3-body-inner`]),
        },
        [
          e.orderedKeys.length
            ? (A(!0),
              M(
                ke,
                {
                  key: 0,
                },
                ae(
                  e.orderedKeys,
                  (t) => (
                    A(),
                    M(
                      `div`,
                      {
                        id: t,
                        key: t,
                        class: `v3-group`,
                      },
                      [
                        e.hasGroupNames
                          ? Re(
                              (A(),
                              M(
                                `h5`,
                                {
                                  key: 0,
                                  class: O(e.isSticky ? `v3-sticky` : ``),
                                },
                                T(e.groupNames[t]),
                                3,
                              )),
                              [[Ee, e.emojis[t]]],
                            )
                          : U(``, !0),
                        Re(
                          W(
                            `div`,
                            Wv,
                            [
                              (A(!0),
                              M(
                                ke,
                                null,
                                ae(
                                  e.emojis[t],
                                  (t) => (
                                    A(),
                                    M(
                                      `button`,
                                      {
                                        key: t.r,
                                        type: `button`,
                                        onMouseenter: (n) => e.handleMouseEnter(t),
                                        onClick: (n) => e.handleClick(t),
                                      },
                                      [
                                        e.native
                                          ? (A(), M(`span`, Kv, T(e.unicodeToEmoji(t.r)), 1))
                                          : (A(),
                                            M(
                                              `img`,
                                              {
                                                key: 1,
                                                src: e.EMOJI_REMOTE_SRC + `/${t.r}.png`,
                                                alt: t.n[0],
                                                onError: (n) => e.handleError(n, t.r),
                                              },
                                              null,
                                              40,
                                              qv,
                                            )),
                                      ],
                                      40,
                                      Gv,
                                    )
                                  ),
                                ),
                                128,
                              )),
                            ],
                            512,
                          ),
                          [[Ee, e.emojis[t]]],
                        ),
                      ],
                      8,
                      Uv,
                    )
                  ),
                ),
                128,
              ))
            : (A(), M(`span`, Jv, ` No emoji has been found! `)),
        ],
        2,
      ),
    ])
  );
}
var Xv = Bv(Vv, [[`render`, Yv]]),
  Zv = `data:image/svg+xml;base64,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`,
  Qv = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZD0iTSAxMSAzIEwgMTEgNyBMIDEzIDcgTCAxMyAzIFogTSAxNSA0IEwgMTUgNyBMIDE3IDcgTCAxNyA0IFogTSA0Ljg3NSA4IEwgNSA5LjA5Mzc1IEwgNi44MTI1IDI2LjMxMjUgQyA2Ljk3MjY1NiAyNy44MzIwMzEgOC4yODUxNTYgMjkgOS44MTI1IDI5IEwgMTkuMTg3NSAyOSBDIDIwLjcxNDg0NCAyOSAyMi4wMjczNDQgMjcuODMyMDMxIDIyLjE4NzUgMjYuMzEyNSBMIDIyLjY1NjI1IDIyIEwgMjUgMjIgQyAyNi42NDQ1MzEgMjIgMjggMjAuNjQ0NTMxIDI4IDE5IEwgMjggMTYgQyAyOCAxNC4zNTU0NjkgMjYuNjQ0NTMxIDEzIDI1IDEzIEwgMjMuNTkzNzUgMTMgTCAyNCA5LjA5Mzc1IEwgMjQuMTI1IDggWiBNIDcuMTI1IDEwIEwgMjEuODc1IDEwIEwgMjAuMTg3NSAyNi4wOTM3NSBDIDIwLjEzMjgxMyAyNi42MTMyODEgMTkuNzA3MDMxIDI3IDE5LjE4NzUgMjcgTCA5LjgxMjUgMjcgQyA5LjI5Mjk2OSAyNyA4Ljg2NzE4OCAyNi42MTMyODEgOC44MTI1IDI2LjA5Mzc1IFogTSAyMy4zNzUgMTUgTCAyNSAxNSBDIDI1LjU2NjQwNiAxNSAyNiAxNS40MzM1OTQgMjYgMTYgTCAyNiAxOSBDIDI2IDE5LjU2NjQwNiAyNS41NjY0MDYgMjAgMjUgMjAgTCAyMi44NDM3NSAyMCBaIi8+PC9zdmc+`,
  $v = `data:image/svg+xml;base64,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`,
  ey = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZD0iTSA5LjUgNiBDIDguMTc5Njg4IDYgNy4wMDM5MDYgNi44NTkzNzUgNi42MjUgOC4xMjUgTCA1LjI1IDEyLjcxODc1IEwgMy4zMTI1IDEyLjA2MjUgTCAyLjY4NzUgMTMuOTM3NSBMIDQuNjU2MjUgMTQuNTkzNzUgTCA0LjAzMTI1IDE2LjcxODc1IEMgNC4wMDc4MTMgMTYuODA4NTk0IDMuOTk2MDk0IDE2LjkwNjI1IDQgMTcgTCA0IDI0IEMgNCAyNC4wMzEyNSA0IDI0LjA2MjUgNCAyNC4wOTM3NSBMIDQgMjUgQyA0IDI1LjU1MDc4MSA0LjQ0OTIxOSAyNiA1IDI2IEwgOCAyNiBMIDguMzQzNzUgMjUgTCAyMy42NTYyNSAyNSBMIDI0IDI2IEwgMjcgMjYgQyAyNy41NTA3ODEgMjYgMjggMjUuNTUwNzgxIDI4IDI1IEwgMjggMjQuMTU2MjUgQyAyOC4wMDM5MDYgMjQuMTA1NDY5IDI4LjAwMzkwNiAyNC4wNTA3ODEgMjggMjQgTCAyOCAxNyBDIDI4LjAwMzkwNiAxNi45MDYyNSAyNy45OTIxODggMTYuODA4NTk0IDI3Ljk2ODc1IDE2LjcxODc1IEwgMjcuMzQzNzUgMTQuNTkzNzUgTCAyOS4zMTI1IDEzLjkzNzUgTCAyOC42ODc1IDEyLjA2MjUgTCAyNi43NSAxMi43MTg3NSBMIDI1LjM3NSA4LjEyNSBDIDI0Ljk5NjA5NCA2Ljg1OTM3NSAyMy44MjAzMTMgNiAyMi41IDYgWiBNIDkuNSA4IEwgMjIuNSA4IEMgMjIuOTQ1MzEzIDggMjMuMzM5ODQ0IDguMjkyOTY5IDIzLjQ2ODc1IDguNzE4NzUgTCAyNC43NSAxMyBMIDcuMjUgMTMgTCA4LjUzMTI1IDguNzE4NzUgQyA4LjY2MDE1NiA4LjI4OTA2MyA5LjA1NDY4OCA4IDkuNSA4IFogTSA2LjY1NjI1IDE1IEwgMjUuMzQzNzUgMTUgTCAyNiAxNy4xODc1IEwgMjYgMjMgTCA2IDIzIEwgNiAxNy4xODc1IFogTSA4LjUgMTYgQyA3LjY3MTg3NSAxNiA3IDE2LjY3MTg3NSA3IDE3LjUgQyA3IDE4LjMyODEyNSA3LjY3MTg3NSAxOSA4LjUgMTkgQyA5LjMyODEyNSAxOSAxMCAxOC4zMjgxMjUgMTAgMTcuNSBDIDEwIDE2LjY3MTg3NSA5LjMyODEyNSAxNiA4LjUgMTYgWiBNIDIzLjUgMTYgQyAyMi42NzE4NzUgMTYgMjIgMTYuNjcxODc1IDIyIDE3LjUgQyAyMiAxOC4zMjgxMjUgMjIuNjcxODc1IDE5IDIzLjUgMTkgQyAyNC4zMjgxMjUgMTkgMjUgMTguMzI4MTI1IDI1IDE3LjUgQyAyNSAxNi42NzE4NzUgMjQuMzI4MTI1IDE2IDIzLjUgMTYgWiBNIDEyIDE5IEwgMTAuNzUgMjIgTCAxMi45MDYyNSAyMiBMIDEzLjM0Mzc1IDIxIEwgMTguNjU2MjUgMjEgTCAxOS4wOTM3NSAyMiBMIDIxLjI1IDIyIEwgMjAgMTkgWiIvPjwvc3ZnPg==`,
  ty = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZD0iTSAxNiA0IEMgMTEuMDQyOTY5IDQgNyA4LjA0Mjk2OSA3IDEzIEMgNyAxNC45MTc5NjkgNy44NDM3NSAxNi45MDYyNSA5IDE4LjY4NzUgQyA5Ljg1OTM3NSAyMC4wMTE3MTkgMTAuODg2NzE5IDIxLjIzMDQ2OSAxMiAyMi4xNTYyNSBMIDEyIDI1IEMgMTIgMjYuMDkzNzUgMTIuOTA2MjUgMjcgMTQgMjcgTCAxNSAyOCBMIDE3IDI4IEwgMTggMjcgQyAxOS4wOTM3NSAyNyAyMCAyNi4wOTM3NSAyMCAyNSBMIDIwIDIyLjE1NjI1IEMgMjEuMTEzMjgxIDIxLjIzMDQ2OSAyMi4xNDA2MjUgMjAuMDExNzE5IDIzIDE4LjY4NzUgQyAyNC4xNTYyNSAxNi45MDYyNSAyNSAxNC45MTc5NjkgMjUgMTMgQyAyNSA4LjA0Mjk2OSAyMC45NTcwMzEgNCAxNiA0IFogTSAxNiA2IEMgMTkuODc4OTA2IDYgMjMgOS4xMjEwOTQgMjMgMTMgQyAyMyAxNC4zMDg1OTQgMjIuMzU1NDY5IDE2LjAzNTE1NiAyMS4zNDM3NSAxNy41OTM3NSBDIDIwLjQ0MTQwNiAxOC45ODQzNzUgMTkuMjUzOTA2IDIwLjIyMjY1NiAxOC4xNTYyNSAyMSBMIDEzLjg0Mzc1IDIxIEMgMTIuNzQ2MDk0IDIwLjIyMjY1NiAxMS41NTg1OTQgMTguOTg0Mzc1IDEwLjY1NjI1IDE3LjU5Mzc1IEMgOS42NDQ1MzEgMTYuMDM1MTU2IDkgMTQuMzA4NTk0IDkgMTMgQyA5IDkuMTIxMDk0IDEyLjEyMTA5NCA2IDE2IDYgWiBNIDE0LjI1IDIzIEwgMTcuNzUgMjMgQyAxNy44MjgxMjUgMjMuMDU0Njg4IDE3LjkxMDE1NiAyMy4wOTM3NSAxOCAyMy4xMjUgTCAxOCAyNSBMIDE0IDI1IEwgMTQgMjMuMTI1IEMgMTQuMDg5ODQ0IDIzLjA5Mzc1IDE0LjE3MTg3NSAyMy4wNTQ2ODggMTQuMjUgMjMgWiIvPjwvc3ZnPg==`,
  ny = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZD0iTSAxMSA1IEwgMTEgMTEgTCA1IDExIEwgNSAxMyBMIDExIDEzIEwgMTEgMTkgTCA1IDE5IEwgNSAyMSBMIDExIDIxIEwgMTEgMjcgTCAxMyAyNyBMIDEzIDIxIEwgMTkgMjEgTCAxOSAyNyBMIDIxIDI3IEwgMjEgMjEgTCAyNyAyMSBMIDI3IDE5IEwgMjEgMTkgTCAyMSAxMyBMIDI3IDEzIEwgMjcgMTEgTCAyMSAxMSBMIDIxIDUgTCAxOSA1IEwgMTkgMTEgTCAxMyAxMSBMIDEzIDUgWiBNIDEzIDEzIEwgMTkgMTMgTCAxOSAxOSBMIDEzIDE5IFoiLz48L3N2Zz4=`,
  ry = `data:image/svg+xml;base64,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`,
  iy = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZD0iTSAxNiA0IEMgMTEuODMyMDMxIDQgOC4xNTIzNDQgNi4xMTMyODEgNiA5LjM0Mzc1IEwgNiA2IEwgNCA2IEwgNCAxMyBMIDExIDEzIEwgMTEgMTEgTCA3LjM3NSAxMSBDIDkuMTAxNTYzIDguMDE5NTMxIDEyLjI5Njg3NSA2IDE2IDYgQyAyMS41MzUxNTYgNiAyNiAxMC40NjQ4NDQgMjYgMTYgQyAyNiAyMS41MzUxNTYgMjEuNTM1MTU2IDI2IDE2IDI2IEMgMTAuNDY0ODQ0IDI2IDYgMjEuNTM1MTU2IDYgMTYgTCA0IDE2IEMgNCAyMi42MTcxODggOS4zODI4MTMgMjggMTYgMjggQyAyMi42MTcxODggMjggMjggMjIuNjE3MTg4IDI4IDE2IEMgMjggOS4zODI4MTMgMjIuNjE3MTg4IDQgMTYgNCBaIE0gMTUgOCBMIDE1IDE3IEwgMjIgMTcgTCAyMiAxNSBMIDE3IDE1IEwgMTcgOCBaIi8+PC9zdmc+Cg==`,
  ay = k({
    name: `Header`,
    setup(e) {
      let { state: t, updateSearch: n, updateActiveGroup: r } = R(`store`),
        i = V(() => !t.options.hideSearch),
        a = V(() => !t.options.hideGroupIcons),
        o = JSON.parse(JSON.stringify(t.orderedGroupKeys)),
        s = V(() => t.options.staticTexts.placeholder || ``),
        c = V({
          get: () => t.search,
          set: (e) => n(e),
        }),
        l = [
          ...t.groups,
          ...Object.keys(t.options.additionalGroups).map((e) => ({
            key: e,
            title: t.options.groupNames[e] ? t.options.groupNames[e] : zv(e),
          })),
        ],
        u = [];
      return (
        o.forEach((e) => {
          let t = l.findIndex((t) => t.key === e);
          t !== -1 && (u.push(l[t]), l.splice(t, 1));
        }),
        {
          orderedGroups: u,
          orderedKeys: o,
          searchValue: c,
          updateActiveGroup: r,
          hasSearch: i,
          hasGroupIcons: a,
          placeholder: s,
          icons: {
            smileys_people: Fv,
            animals_nature: Zv,
            food_drink: Qv,
            activities: $v,
            travel_places: ey,
            objects: ty,
            symbols: ny,
            flags: ry,
            ...t.options.groupIcons,
            recent: iy,
          },
        }
      );
    },
  }),
  oy = {
    key: 0,
    class: `v3-header`,
  },
  sy = {
    key: 0,
    class: `v3-groups`,
  },
  cy = [`onClick`],
  ly = [`title`],
  uy = [`src`],
  dy = {
    key: 1,
    class: `v3-spacing`,
  },
  fy = {
    key: 2,
    class: `v3-search`,
  },
  py = [`placeholder`];
function my(e, t, n, r, i, a) {
  return e.hasGroupIcons || e.hasSearch
    ? (A(),
      M(`div`, oy, [
        e.hasGroupIcons
          ? (A(),
            M(`div`, sy, [
              (A(!0),
              M(
                ke,
                null,
                ae(
                  e.orderedGroups,
                  (t) => (
                    A(),
                    M(
                      `button`,
                      {
                        key: t.key,
                        type: `button`,
                        class: O([
                          `v3-group`,
                          {
                            "v3-is-hidden": !e.icons[t.key],
                          },
                        ]),
                        onClick: (n) => e.updateActiveGroup(t.key),
                      },
                      [
                        W(
                          `span`,
                          {
                            title: t.title,
                            class: `v3-icon`,
                          },
                          [
                            W(
                              `img`,
                              {
                                src: e.icons[t.key],
                                alt: ``,
                              },
                              null,
                              8,
                              uy,
                            ),
                          ],
                          8,
                          ly,
                        ),
                      ],
                      10,
                      cy,
                    )
                  ),
                ),
                128,
              )),
            ]))
          : U(``, !0),
        e.hasGroupIcons && e.hasSearch ? (A(), M(`div`, dy)) : U(``, !0),
        e.hasSearch
          ? (A(),
            M(`div`, fy, [
              Re(
                W(
                  `input`,
                  {
                    "onUpdate:modelValue": (t[0] ||= (t) => (e.searchValue = t)),
                    type: `text`,
                    placeholder: e.placeholder,
                  },
                  null,
                  8,
                  py,
                ),
                [[we, e.searchValue]],
              ),
            ]))
          : U(``, !0),
      ]))
    : U(``, !0);
}
var hy = Bv(ay, [[`render`, my]]),
  gy = k({
    name: `Header`,
    setup() {
      let { state: e, updateSkinTone: t } = R(`store`),
        n = F(!1),
        r = F(!1),
        i = V(() => e.skinTone),
        a = V(() => e.options.staticTexts.skinTone || `Skin tone`),
        o = V(() => !e.options.disableSkinTones),
        s = Rv() ? `is-mac` : ``,
        c = V(() => ({
          ...e.emoji,
          src:
            `https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/` +
            e.emoji[rg] +
            `.png`,
        }));
      function l(e = !0) {
        n.value = e;
      }
      function u() {
        n.value = !n.value;
      }
      function d(e) {
        (t(e), l(!1));
      }
      return (
        He(
          () => e.emoji,
          () => {
            r.value = !1;
          },
        ),
        {
          emoji: c,
          SKIN_TONES: og,
          updateSkinToneState: l,
          skinTone: n,
          stateSkinTone: i,
          selectSkinTone: d,
          toggleSkinToneState: u,
          EMOJI_RESULT_KEY: rg,
          EMOJI_NAME_KEY: tg,
          skinToneText: a,
          hasSkinTones: o,
          native: e.options.native,
          unicodeToEmoji: Iv,
          platform: s,
          hasError: r,
        }
      );
    },
  }),
  _y = {
    class: `v3-foot-left`,
  },
  vy = {
    key: 0,
  },
  yy = [`alt`, `src`],
  by = {
    class: `v3-text`,
  },
  xy = {
    class: `v3-text`,
  },
  Sy = [`onClick`];
function Cy(e, t, n, r, i, a) {
  return (
    A(),
    M(
      `div`,
      {
        class: `v3-footer`,
        onMouseleave: (t[2] ||= (t) => e.updateSkinToneState(!1)),
      },
      [
        W(`div`, _y, [
          W(
            `span`,
            {
              class: O([e.platform, `v3-icon`]),
            },
            [
              e.native || e.hasError
                ? (A(), M(`span`, vy, T(e.unicodeToEmoji(e.emoji.r)), 1))
                : (A(),
                  M(
                    `img`,
                    {
                      key: 1,
                      alt: e.unicodeToEmoji(e.emoji.r),
                      src: e.emoji.src,
                      onError: (t[0] ||= (t) => (e.hasError = !0)),
                    },
                    null,
                    40,
                    yy,
                  )),
            ],
            2,
          ),
          W(
            `span`,
            by,
            ` :` + T(e.emoji[e.EMOJI_NAME_KEY][1] || e.emoji[e.EMOJI_NAME_KEY][0]) + `: `,
            1,
          ),
        ]),
        e.hasSkinTones
          ? (A(),
            M(
              ke,
              {
                key: 0,
              },
              [
                W(
                  `button`,
                  {
                    type: `button`,
                    class: `v3-tone`,
                    onClick: (t[1] ||= (...t) =>
                      e.toggleSkinToneState && e.toggleSkinToneState(...t)),
                  },
                  [
                    W(`span`, xy, T(e.skinToneText), 1),
                    W(
                      `span`,
                      {
                        class: O(`v3-icon v3-tone-${e.stateSkinTone}`),
                      },
                      null,
                      2,
                    ),
                  ],
                ),
                W(
                  `div`,
                  {
                    class: O([e.skinTone ? `v3-is-open` : ``, `v3-skin-tones`]),
                  },
                  [
                    (A(!0),
                    M(
                      ke,
                      null,
                      ae(
                        e.SKIN_TONES,
                        (t) => (
                          A(),
                          M(
                            `button`,
                            {
                              key: t,
                              type: `button`,
                              class: O([`v3-skin-tone-` + t, `v3-skin-tone`]),
                              onClick: (n) => e.selectSkinTone(t),
                            },
                            null,
                            10,
                            Sy,
                          )
                        ),
                      ),
                      128,
                    )),
                  ],
                  2,
                ),
              ],
              64,
            ))
          : U(``, !0),
      ],
      32,
    )
  );
}
var wy = k({
    name: `PickerRoot`,
    components: {
      Header: hy,
      Body: Xv,
      Footer: Bv(gy, [[`render`, Cy]]),
    },
    props: {
      type: {
        type: String,
        default: ``,
      },
      text: {
        type: String,
        default: ``,
      },
      additionalGroups: {
        type: Object,
        default: () => ({}),
      },
      groupOrder: {
        type: Array,
        default: () => [],
      },
      groupIcons: {
        type: Object,
        default: () => ({}),
      },
      groupNames: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: {
      select: (e) => !0,
      "update:text": (e) => !0,
    },
    setup(e, { emit: t }) {
      let n = F(),
        r = F(),
        i = F(),
        a = F(!1),
        o = F(e.text),
        s = e.type === `input` || e.type === `textarea`,
        c = -1,
        { state: l } = R(`store`),
        u = V(() => l.options.colorTheme);
      function d(e) {
        if (s) {
          let n = l.options.mode;
          (n === `prepend`
            ? (o.value = e.i + o.value)
            : n === `insert` && c !== -1
              ? ((o.value = `${o.value.slice(0, c)}${e.i}${o.value.slice(c)}`), (c += e.i.length))
              : (o.value += e.i),
            t(`update:text`, o.value));
        }
        t(`select`, e);
      }
      function f() {
        n.value && (c = n.value?.selectionEnd || -1);
      }
      function p(e) {
        !e.target?.closest(`.v3-input-picker-wrap`) && a.value && (a.value = !1);
      }
      function m() {
        if (r.value && i.value && s) {
          let e = l.options.offset;
          (typeof e != `number` && (e = 6),
            Pv(r.value, i.value, {
              placement: `bottom-end`,
              modifiers: [
                {
                  name: `offset`,
                  options: {
                    offset: [0, e],
                  },
                },
              ],
            }),
            document.body.addEventListener(`click`, p));
        }
      }
      function h(e) {
        ((o.value = e.target.value || ``), t(`update:text`, o.value));
      }
      return (
        Qe(() => {
          m();
        }),
        oe(() => {
          document.body.removeEventListener(`click`, p);
        }),
        {
          face: Fv,
          open: a,
          onSelect: d,
          input: o,
          elem: n,
          updateCursor: f,
          button: r,
          picker: i,
          isInputType: s,
          onChangeText: h,
          colorTheme: u,
        }
      );
    },
  }),
  Ty = {
    key: 0,
    class: `v3-input-emoji-picker`,
  },
  Ey = {
    class: `v3-input-picker-root`,
  },
  Dy = [`value`],
  Oy = [`value`],
  ky = [`src`];
function Ay(e, t, n, r, i, a) {
  let o = j(`Header`),
    s = j(`Body`),
    c = j(`Footer`);
  return e.isInputType
    ? (A(),
      M(`div`, Ty, [
        W(`div`, Ey, [
          e.type === `input`
            ? (A(),
              M(
                `input`,
                {
                  key: 0,
                  ref: `elem`,
                  value: e.input,
                  type: `text`,
                  class: `v3-emoji-picker-input`,
                  onInput: (t[0] ||= (...t) => e.onChangeText && e.onChangeText(...t)),
                  onBlur: (t[1] ||= (...t) => e.updateCursor && e.updateCursor(...t)),
                },
                null,
                40,
                Dy,
              ))
            : (A(),
              M(
                `textarea`,
                {
                  key: 1,
                  ref: `elem`,
                  value: e.input,
                  class: `v3-emoji-picker-textarea`,
                  onInput: (t[2] ||= (...t) => e.onChangeText && e.onChangeText(...t)),
                  onBlur: (t[3] ||= (...t) => e.updateCursor && e.updateCursor(...t)),
                },
                null,
                40,
                Oy,
              )),
          W(
            `div`,
            {
              class: O([`v3-input-picker-wrap`, e.open ? `v3-picker-is-open` : ``]),
            },
            [
              W(
                `button`,
                {
                  ref: `button`,
                  type: `button`,
                  class: `v3-input-picker-icon`,
                  onClick: (t[4] ||= (t) => (e.open = !e.open)),
                },
                [
                  W(
                    `img`,
                    {
                      src: e.face,
                      alt: ``,
                    },
                    null,
                    8,
                    ky,
                  ),
                ],
                512,
              ),
              W(
                `div`,
                {
                  ref: `picker`,
                  class: O([`v3-emoji-picker`, `v3-color-theme-` + e.colorTheme]),
                },
                [
                  N(o),
                  N(
                    s,
                    {
                      onSelect: e.onSelect,
                    },
                    null,
                    8,
                    [`onSelect`],
                  ),
                  N(c),
                ],
                2,
              ),
            ],
            2,
          ),
        ]),
      ]))
    : (A(),
      M(
        `div`,
        {
          key: 1,
          class: O([`v3-emoji-picker`, `v3-color-theme-` + e.colorTheme]),
        },
        [
          N(o),
          N(
            s,
            {
              onSelect: e.onSelect,
            },
            null,
            8,
            [`onSelect`],
          ),
          N(c),
        ],
        2,
      ));
}
var jy = k({
  name: `Picker`,
  components: {
    PickerRoot: Bv(wy, [[`render`, Ay]]),
  },
  props: {
    native: {
      type: Boolean,
      default: !1,
    },
    hideSearch: {
      type: Boolean,
      default: !1,
    },
    hideGroupIcons: {
      type: Boolean,
      default: !1,
    },
    hideGroupNames: {
      type: Boolean,
      default: !1,
    },
    staticTexts: {
      type: Object,
      default: () => ({}),
    },
    disableStickyGroupNames: {
      type: Boolean,
      default: !1,
    },
    disabledGroups: {
      type: Array,
      default: () => [],
    },
    groupNames: {
      type: Object,
      default: () => ({}),
    },
    disableSkinTones: {
      type: Boolean,
      default: !1,
    },
    text: {
      type: String,
      default: ``,
    },
    mode: {
      type: String,
      default: `insert`,
    },
    offset: {
      type: Number,
      default: 6,
    },
    additionalGroups: {
      type: Object,
      default: () => ({}),
    },
    groupOrder: {
      type: Array,
      default: () => [],
    },
    groupIcons: {
      type: Object,
      default: () => ({}),
    },
    pickerType: {
      type: String,
      default: ``,
    },
    displayRecent: {
      type: Boolean,
      default: !1,
    },
    theme: {
      type: String,
      default: `light`,
    },
  },
  emits: {
    "update:text": (e) => !0,
    select: (e) => !0,
  },
  setup(e, { emit: t }) {
    let n = F(e.text);
    function r(e) {
      ((n.value = e || ``), t(`update:text`, n.value));
    }
    let i = Bg();
    return (
      i.updateOptions({
        native: e.native,
        hideSearch: e.hideSearch,
        hideGroupIcons: e.hideGroupIcons,
        hideGroupNames: e.hideGroupNames,
        staticTexts: {
          ...sg,
          ...e.staticTexts,
        },
        disableStickyGroupNames: e.disableStickyGroupNames,
        disabledGroups: e.disabledGroups,
        groupNames: {
          ...$h,
          ...e.groupNames,
        },
        disableSkinTones: e.disableSkinTones,
        displayRecent: e.displayRecent,
        additionalGroups: e.additionalGroups,
        mode: e.mode,
        offset: e.offset,
        groupOrder: e.groupOrder,
        groupIcons: e.groupIcons,
        colorTheme: cg.includes(e.theme) ? e.theme : `light`,
      }),
      ge(`store`, i),
      {
        type: e.pickerType,
        input: n,
        onChangeText: r,
      }
    );
  },
});
function My(e, t, n, r, i, a) {
  let o = j(`picker-root`);
  return (
    A(),
    L(
      o,
      {
        type: e.type,
        text: e.input,
        onSelect: (t[0] ||= (t) => e.$emit(`select`, t)),
        "onUpdate:text": e.onChangeText,
      },
      null,
      8,
      [`type`, `text`, `onUpdate:text`],
    )
  );
}
var Ny = Bv(jy, [[`render`, My]]),
  Py = i({
    default: () => Iy,
  });
B();
var Fy = {
    class: `relative inline-block`,
  },
  Iy = {
    __name: `EmojiPicker`,
    props: {
      bordered: {
        type: Boolean,
        default: !0,
      },
      placement: {
        type: String,
        default: `bottom`,
        validator: (e) => [`top`, `bottom`].includes(e),
      },
      horizontalPlacement: {
        type: String,
        default: `right`,
        validator: (e) => [`left`, `right`].includes(e),
      },
    },
    emits: [`emojiSelected`],
    setup(e, { emit: t }) {
      let n = t,
        r = F(!1),
        i = F(null);
      function a() {
        r.value = !r.value;
      }
      function o(e) {
        (n(`emojiSelected`, e.i), (r.value = !1));
      }
      function s(e) {
        i.value && !i.value.contains(e.target) && (r.value = !1);
      }
      return (
        Qe(() => {
          document.addEventListener(`click`, s);
        }),
        oe(() => {
          document.removeEventListener(`click`, s);
        }),
        (t, n) => (
          A(),
          M(`div`, Fy, [
            W(
              `button`,
              {
                type: `button`,
                onClick: Fe(a, [`stop`]),
                class: O([
                  `text-sm p-2 hover:bg-gray-100 dark:hover:bg-gray-700 border-gray-300 rounded-md`,
                  {
                    border: e.bordered,
                    "border-0": !e.bordered,
                  },
                ]),
              },
              [
                ...(n[0] ||= [
                  W(
                    `i`,
                    {
                      class: `fa-regular fa-face-smile dark:text-gray-400`,
                    },
                    null,
                    -1,
                  ),
                ]),
              ],
              2,
            ),
            r.value
              ? (A(),
                M(
                  `div`,
                  {
                    key: 0,
                    class: O([
                      `absolute z-50`,
                      e.placement === `top` ? `bottom-full mb-2` : `top-full mt-2`,
                      e.horizontalPlacement === `left` ? `left-0` : `right-0`,
                    ]),
                    ref_key: `pickerContainer`,
                    ref: i,
                  },
                  [
                    N(P(Ny), {
                      onSelect: o,
                      native: !0,
                      class: `shadow-xl border border-gray-300 rounded-lg bg-white dark:bg-dark-header`,
                    }),
                  ],
                  2,
                ))
              : U(``, !0),
          ])
        )
      );
    },
  };
B();
function Ly(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Ry(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function zy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function By(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Vy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Hy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Uy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-13a.75.75 0 0 0-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5h-3.25V5Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Wy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          d: `M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z`,
        }),
      ],
    )
  );
}
B();
function Gy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Ky(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function qy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          d: `m5.433 13.917 1.262-3.155A4 4 0 0 1 7.58 9.42l6.92-6.918a2.121 2.121 0 0 1 3 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 0 1-.65-.65Z`,
        }),
        W(`path`, {
          d: `M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0 0 10 3H4.75A2.75 2.75 0 0 0 2 5.75v9.5A2.75 2.75 0 0 0 4.75 18h9.5A2.75 2.75 0 0 0 17 15.25V10a.75.75 0 0 0-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5Z`,
        }),
      ],
    )
  );
}
B();
function Jy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          d: `M2 4.25A2.25 2.25 0 0 1 4.25 2h6.5A2.25 2.25 0 0 1 13 4.25V5.5H9.25A3.75 3.75 0 0 0 5.5 9.25V13H4.25A2.25 2.25 0 0 1 2 10.75v-6.5Z`,
        }),
        W(`path`, {
          d: `M9.25 7A2.25 2.25 0 0 0 7 9.25v6.5A2.25 2.25 0 0 0 9.25 18h6.5A2.25 2.25 0 0 0 18 15.75v-6.5A2.25 2.25 0 0 0 15.75 7h-6.5Z`,
        }),
      ],
    )
  );
}
B();
function Yy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Xy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          d: `M10 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM1.615 16.428a1.224 1.224 0 0 1-.569-1.175 6.002 6.002 0 0 1 11.908 0c.058.467-.172.92-.57 1.174A9.953 9.953 0 0 1 7 18a9.953 9.953 0 0 1-5.385-1.572ZM16.25 5.75a.75.75 0 0 0-1.5 0v2h-2a.75.75 0 0 0 0 1.5h2v2a.75.75 0 0 0 1.5 0v-2h2a.75.75 0 0 0 0-1.5h-2v-2Z`,
        }),
      ],
    )
  );
}
B();
function Zy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "fill-rule": `evenodd`,
          d: `M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z`,
          "clip-rule": `evenodd`,
        }),
      ],
    )
  );
}
B();
function Qy(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        viewBox: `0 0 20 20`,
        fill: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          d: `M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z`,
        }),
      ],
    )
  );
}
var $y = i({
  default: () => ib,
});
B();
var eb = {
    key: 1,
    class: `relative inline-flex`,
  },
  tb = [`aria-expanded`],
  nb = {
    key: 0,
    class: `absolute right-0 top-full mt-2 w-44 origin-top-right rounded-md bg-white dark:bg-dark-header shadow-lg ring-1 ring-black/5 z-50`,
  },
  rb = {
    class: `py-1`,
  },
  ib = Object.assign(
    {
      name: `FilterButton`,
    },
    {
      props: {
        size: {
          type: String,
          validator(e) {
            return [`xs`, `sm`, `md`, `lg`, `xl`].includes(e);
          },
          default: `md`,
        },
        design: {
          type: String,
          validator(e) {
            return [
              `primary`,
              `secondary`,
              `info`,
              `success`,
              `warning`,
              `danger`,
              `error`,
              `white`,
            ].includes(e);
          },
          default: `primary`,
        },
        filterText: {
          type: String,
          default: ``,
        },
        showHide: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`filter`, `hide`],
      setup(e, { emit: t }) {
        let n = R(`$trans`),
          r = t,
          i = F(!1),
          a = () => {
            ((i.value = !1), r(`hide`));
          },
          o = e,
          s = V(() => o.filterText || n(`general.filter`)),
          c = V(
            () =>
              ({
                primary: `bg-primary dark:bg-gray-700`,
                secondary: `bg-secondary dark:bg-dark-body border border-gray-200 dark:border-gray-600`,
                info: `bg-info`,
                success: `bg-success`,
                warning: `bg-warning`,
                danger: `bg-danger`,
                error: `bg-danger`,
                white: `bg-white dark:bg-dark-header border border-gray-300 dark:border-gray-700`,
              })[o.design],
          ),
          l = V(() => [
            `inline-flex items-center justify-center font-medium transition-colors duration-200`,
            `bg-transparent hover:bg-black/10 dark:hover:bg-white/10`,
            {
              primary: `text-secondary dark:text-gray-200`,
              secondary: `text-primary dark:text-gray-400`,
              info: `text-secondary`,
              success: `text-secondary`,
              warning: `text-secondary`,
              danger: `text-secondary`,
              error: `text-secondary`,
              white: `text-gray-600 dark:text-gray-400`,
            }[o.design],
          ]),
          u = V(
            () =>
              ({
                xs: `px-2.5 py-1.5 text-xs`,
                sm: `px-3 py-2 text-sm leading-4`,
                md: `px-4 py-2 text-sm`,
                lg: `px-4 py-2 text-base`,
                xl: `px-6 py-3 text-base`,
              })[o.size],
          ),
          d = V(
            () =>
              ({
                xs: `px-1.5 py-1.5 text-xs`,
                sm: `px-2 py-2 text-sm`,
                md: `px-2.5 py-2 text-sm`,
                lg: `px-2.5 py-2 text-base`,
                xl: `px-3 py-3 text-base`,
              })[o.size],
          ),
          f = V(
            () =>
              ({
                primary: `after:bg-primary before:bg-dark-primary text-secondary focus:ring-primary dark:focus:ring-dark-header dark:text-gray-200 dark:before:bg-gray-500 dark:after:bg-gray-700`,
                secondary: `after:bg-secondary before:bg-dark-secondary dark:after:bg-dark-body text-primary focus:ring-secondary dark:focus:ring-dark-body dark:text-gray-400 dark:before:bg-neutral-700`,
                info: `after:bg-info before:bg-dark-info text-secondary focus:ring-info`,
                success: `after:bg-success before:bg-dark-success text-secondary focus:ring-success`,
                warning: `after:bg-warning before:bg-dark-warning text-secondary focus:ring-warning`,
                danger: `after:bg-danger before:bg-dark-danger text-secondary focus:ring-danger`,
                error: `after:bg-danger before:bg-dark-danger text-secondary focus:ring-danger`,
                white: `dark:after:bg-dark-header text-gray-600 before:bg-gray-100 after:bg-white focus:ring-white dark:text-gray-400 dark:before:bg-neutral-700`,
              })[o.design],
          ),
          p = V(() => [
            `relative z-0 inline-flex items-center justify-center overflow-hidden font-medium transition-all duration-300 border border-transparent`,
            `before:absolute before:bottom-0 before:left-0 before:-z-10 before:h-full before:w-0 before:transition-all before:duration-300 before:content-['']`,
            `after:absolute after:bottom-0 after:left-0 after:-z-20 after:h-full after:w-full after:content-['']`,
            `hover:before:w-full`,
            u.value,
            f.value,
          ]);
        return (t, o) => {
          let f = ve(`click-outside`);
          return e.showHide
            ? Re(
                (A(),
                M(`span`, eb, [
                  W(
                    `span`,
                    {
                      class: O([c.value, `inline-flex rounded-xl overflow-hidden`]),
                    },
                    [
                      W(
                        `button`,
                        {
                          type: `button`,
                          onClick: (o[1] ||= (e) => r(`filter`)),
                          class: O([l.value, u.value]),
                        },
                        [z(t.$slots, `default`, {}, () => [H(T(s.value), 1)])],
                        2,
                      ),
                      (o[3] ||= W(
                        `span`,
                        {
                          class: `w-px self-stretch shrink-0 bg-white/20 dark:bg-white/10`,
                        },
                        null,
                        -1,
                      )),
                      W(
                        `button`,
                        {
                          type: `button`,
                          onClick: (o[2] ||= (e) => (i.value = !i.value)),
                          class: O([l.value, d.value]),
                          "aria-expanded": i.value,
                        },
                        [
                          N(
                            P(zy),
                            {
                              class: O([
                                `h-4 w-4 transition-transform duration-200`,
                                {
                                  "rotate-180": i.value,
                                },
                              ]),
                            },
                            null,
                            8,
                            [`class`],
                          ),
                        ],
                        10,
                        tb,
                      ),
                    ],
                    2,
                  ),
                  N(
                    Ve,
                    {
                      "enter-active-class": `transition duration-100 ease-out`,
                      "enter-from-class": `transform scale-95 opacity-0`,
                      "enter-to-class": `transform scale-100 opacity-100`,
                      "leave-active-class": `transition duration-75 ease-in`,
                      "leave-from-class": `transform scale-100 opacity-100`,
                      "leave-to-class": `transform scale-95 opacity-0`,
                    },
                    {
                      default: I(() => [
                        i.value
                          ? (A(),
                            M(`div`, nb, [
                              W(`div`, rb, [
                                W(
                                  `span`,
                                  {
                                    onClick: a,
                                    class: `flex cursor-pointer items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-400 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-dark-body dark:hover:text-gray-300`,
                                  },
                                  [
                                    (o[4] ||= W(
                                      `i`,
                                      {
                                        class: `fas fa-eye-slash ltr:mr-2 rtl:ml-2 text-gray-400`,
                                      },
                                      null,
                                      -1,
                                    )),
                                    H(` ` + T(P(n)(`general.filter_hide`)), 1),
                                  ],
                                ),
                              ]),
                            ]))
                          : U(``, !0),
                      ]),
                      _: 1,
                    },
                  ),
                ])),
                [[f, () => (i.value = !1)]],
              )
            : (A(),
              M(
                `button`,
                {
                  key: 0,
                  type: `button`,
                  onClick: (o[0] ||= (e) => r(`filter`)),
                  class: O([p.value, `rounded-xl`]),
                },
                [z(t.$slots, `default`, {}, () => [H(T(s.value), 1)])],
                2,
              ));
        };
      },
    },
  ),
  ab = i({
    default: () => sb,
  });
B();
var ob = {
    class: `flex justify-end items-center gap-2`,
  },
  sb = Object.assign(
    {
      name: `FilterForm`,
    },
    {
      props: {
        form: {
          type: Object,
          default() {
            return {};
          },
        },
        initForm: {
          type: Object,
          default() {
            return {};
          },
        },
        multiple: {
          type: Array,
          default: [],
        },
        isLoading: {
          type: Boolean,
          default: !1,
        },
        filterText: {
          type: String,
          default: ``,
        },
        showMore: {
          type: Boolean,
          default: !1,
        },
        showMoreButton: {
          type: Boolean,
          default: !1,
        },
        noActionOnCancel: {
          type: Boolean,
          default: !1,
        },
        clearQueryOnCancel: {
          type: Boolean,
          default: !1,
        },
        showHide: {
          type: Boolean,
          default: !0,
        },
        hideOnCancel: {
          type: Boolean,
          default: !0,
        },
      },
      emits: [`hide`, `cancel`, `afterFilter`, `showMore`],
      setup(e, { emit: t }) {
        let n = Dc(),
          r = Ec(),
          i = R(`emitter`),
          a = t,
          s = e,
          c = async () => {
            (Object.assign(s.form, s.initForm),
              s.noActionOnCancel ||
                (s.clearQueryOnCancel
                  ? (await r.push({
                      name: n.name,
                      query: {},
                    }),
                    a(`afterFilter`),
                    i.emit(`listItems`))
                  : l()),
              a(`cancel`),
              s.hideOnCancel && a(`hide`));
          },
          l = async () => {
            let e = {};
            Object.assign(e, o(n.query), o(s.form));
            let t = [];
            (Object.entries(e).forEach(([e, n]) => {
              n !== `` && n !== null && (t[e] = Array.isArray(n) ? n.join(`,`) : n);
            }),
              await r.push({
                name: n.name,
                query: {
                  ...t,
                },
              }),
              a(`afterFilter`),
              i.emit(`listItems`));
          },
          u = async () => {
            (await l(), a(`hide`));
          };
        return (
          Qe(async () => {
            i.on(`resetFilter`, () => {
              c();
            });
            let e = [];
            (Object.entries(n.query).forEach(([t, n]) => {
              s.multiple.includes(t)
                ? Array.isArray(n)
                  ? (e[t] = n)
                  : (e[t] = n ? n.split(`,`) : [])
                : (e[t] = n);
            }),
              Object.assign(s.form, {
                ...e,
              }));
          }),
          oe(() => {
            i.all.delete(`resetFilter`);
          }),
          (t, n) => {
            let r = j(`BaseLink`),
              i = j(`BaseButton`),
              o = j(`FilterButton`),
              s = j(`BaseCard`);
            return (
              A(),
              L(
                s,
                {
                  "is-loading": e.isLoading,
                },
                {
                  footer: I(() => [
                    W(`div`, ob, [
                      e.showMoreButton && !e.showMore
                        ? (A(),
                          L(
                            r,
                            {
                              key: 0,
                              onClick: (n[0] ||= (e) => a(`showMore`, !0)),
                            },
                            {
                              default: I(() => [H(T(t.$trans(`general.show_more`)), 1)]),
                              _: 1,
                            },
                          ))
                        : U(``, !0),
                      e.showMoreButton && e.showMore
                        ? (A(),
                          L(
                            r,
                            {
                              key: 1,
                              onClick: (n[1] ||= (e) => a(`showMore`, !1)),
                            },
                            {
                              default: I(() => [H(T(t.$trans(`general.show_less`)), 1)]),
                              _: 1,
                            },
                          ))
                        : U(``, !0),
                      W(`div`, null, [
                        N(
                          i,
                          {
                            design: `error`,
                            class: `mr-4`,
                            onClick: c,
                          },
                          {
                            default: I(() => [H(T(t.$trans(`general.cancel`)), 1)]),
                            _: 1,
                          },
                        ),
                        N(
                          o,
                          {
                            "filter-text": e.filterText,
                            "show-hide": e.showHide,
                            onFilter: l,
                            onHide: u,
                          },
                          null,
                          8,
                          [`filter-text`, `show-hide`],
                        ),
                      ]),
                    ]),
                  ]),
                  default: I(() => [z(t.$slots, `default`)]),
                  _: 3,
                },
                8,
                [`is-loading`],
              )
            );
          }
        );
      },
    },
  ),
  cb = r(
    a((e, t) => {
      ((function (n, r) {
        typeof e == `object` && t !== void 0
          ? (t.exports = r())
          : typeof define == `function` && define.amd
            ? define(r)
            : ((n ||= self), (n.Sweetalert2 = r()));
      })(e, function () {
        let e = `SweetAlert2:`,
          t = (e) => {
            let t = [];
            for (let n = 0; n < e.length; n++) t.indexOf(e[n]) === -1 && t.push(e[n]);
            return t;
          },
          n = (e) => e.charAt(0).toUpperCase() + e.slice(1),
          r = (e) => Array.prototype.slice.call(e),
          i = (t) => {
            console.warn(`${e} ${typeof t == `object` ? t.join(` `) : t}`);
          },
          a = (t) => {
            console.error(`${e} ${t}`);
          },
          o = [],
          s = (e) => {
            o.includes(e) || (o.push(e), i(e));
          },
          c = (e, t) => {
            s(
              `"${e}" is deprecated and will be removed in the next major release. Please use "${t}" instead.`,
            );
          },
          l = (e) => (typeof e == `function` ? e() : e),
          u = (e) => e && typeof e.toPromise == `function`,
          d = (e) => (u(e) ? e.toPromise() : Promise.resolve(e)),
          f = (e) => e && Promise.resolve(e) === e,
          p = {
            title: ``,
            titleText: ``,
            text: ``,
            html: ``,
            footer: ``,
            icon: void 0,
            iconColor: void 0,
            iconHtml: void 0,
            template: void 0,
            toast: !1,
            showClass: {
              popup: `swal2-show`,
              backdrop: `swal2-backdrop-show`,
              icon: `swal2-icon-show`,
            },
            hideClass: {
              popup: `swal2-hide`,
              backdrop: `swal2-backdrop-hide`,
              icon: `swal2-icon-hide`,
            },
            customClass: {},
            target: `body`,
            color: void 0,
            backdrop: !0,
            heightAuto: !0,
            allowOutsideClick: !0,
            allowEscapeKey: !0,
            allowEnterKey: !0,
            stopKeydownPropagation: !0,
            keydownListenerCapture: !1,
            showConfirmButton: !0,
            showDenyButton: !1,
            showCancelButton: !1,
            preConfirm: void 0,
            preDeny: void 0,
            confirmButtonText: `OK`,
            confirmButtonAriaLabel: ``,
            confirmButtonColor: void 0,
            denyButtonText: `No`,
            denyButtonAriaLabel: ``,
            denyButtonColor: void 0,
            cancelButtonText: `Cancel`,
            cancelButtonAriaLabel: ``,
            cancelButtonColor: void 0,
            buttonsStyling: !0,
            reverseButtons: !1,
            focusConfirm: !0,
            focusDeny: !1,
            focusCancel: !1,
            returnFocus: !0,
            showCloseButton: !1,
            closeButtonHtml: `&times;`,
            closeButtonAriaLabel: `Close this dialog`,
            loaderHtml: ``,
            showLoaderOnConfirm: !1,
            showLoaderOnDeny: !1,
            imageUrl: void 0,
            imageWidth: void 0,
            imageHeight: void 0,
            imageAlt: ``,
            timer: void 0,
            timerProgressBar: !1,
            width: void 0,
            padding: void 0,
            background: void 0,
            input: void 0,
            inputPlaceholder: ``,
            inputLabel: ``,
            inputValue: ``,
            inputOptions: {},
            inputAutoTrim: !0,
            inputAttributes: {},
            inputValidator: void 0,
            returnInputValueOnDeny: !1,
            validationMessage: void 0,
            grow: !1,
            position: `center`,
            progressSteps: [],
            currentProgressStep: void 0,
            progressStepsDistance: void 0,
            willOpen: void 0,
            didOpen: void 0,
            didRender: void 0,
            willClose: void 0,
            didClose: void 0,
            didDestroy: void 0,
            scrollbarPadding: !0,
          },
          m =
            `allowEscapeKey.allowOutsideClick.background.buttonsStyling.cancelButtonAriaLabel.cancelButtonColor.cancelButtonText.closeButtonAriaLabel.closeButtonHtml.color.confirmButtonAriaLabel.confirmButtonColor.confirmButtonText.currentProgressStep.customClass.denyButtonAriaLabel.denyButtonColor.denyButtonText.didClose.didDestroy.footer.hideClass.html.icon.iconColor.iconHtml.imageAlt.imageHeight.imageUrl.imageWidth.preConfirm.preDeny.progressSteps.returnFocus.reverseButtons.showCancelButton.showCloseButton.showConfirmButton.showDenyButton.text.title.titleText.willClose`.split(
              `.`,
            ),
          h = {},
          g = [
            `allowOutsideClick`,
            `allowEnterKey`,
            `backdrop`,
            `focusConfirm`,
            `focusDeny`,
            `focusCancel`,
            `returnFocus`,
            `heightAuto`,
            `keydownListenerCapture`,
          ],
          v = (e) => Object.prototype.hasOwnProperty.call(p, e),
          y = (e) => m.indexOf(e) !== -1,
          b = (e) => h[e],
          x = (e) => {
            v(e) || i(`Unknown parameter "${e}"`);
          },
          S = (e) => {
            g.includes(e) && i(`The parameter "${e}" is incompatible with toasts`);
          },
          C = (e) => {
            b(e) && c(e, b(e));
          },
          w = (e) => {
            !e.backdrop &&
              e.allowOutsideClick &&
              i('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
            for (let t in e) (x(t), e.toast && S(t), C(t));
          },
          T = (e) => {
            let t = {};
            for (let n in e) t[e[n]] = `swal2-` + e[n];
            return t;
          },
          E = T(
            `container.shown.height-auto.iosfix.popup.modal.no-backdrop.no-transition.toast.toast-shown.show.hide.close.title.html-container.actions.confirm.deny.cancel.default-outline.footer.icon.icon-content.image.input.file.range.select.radio.checkbox.label.textarea.inputerror.input-label.validation-message.progress-steps.active-progress-step.progress-step.progress-step-line.loader.loading.styled.top.top-start.top-end.top-left.top-right.center.center-start.center-end.center-left.center-right.bottom.bottom-start.bottom-end.bottom-left.bottom-right.grow-row.grow-column.grow-fullscreen.rtl.timer-progress-bar.timer-progress-bar-container.scrollbar-measure.icon-success.icon-warning.icon-info.icon-question.icon-error`.split(
              `.`,
            ),
          ),
          D = T([`success`, `warning`, `info`, `question`, `error`]),
          ee = () => document.body.querySelector(`.${E.container}`),
          te = (e) => {
            let t = ee();
            return t ? t.querySelector(e) : null;
          },
          O = (e) => te(`.${e}`),
          k = () => O(E.popup),
          ne = () => O(E.icon),
          re = () => O(E.title),
          A = () => O(E[`html-container`]),
          ie = () => O(E.image),
          j = () => O(E[`progress-steps`]),
          ae = () => O(E[`validation-message`]),
          oe = () => te(`.${E.actions} .${E.confirm}`),
          se = () => te(`.${E.actions} .${E.deny}`),
          ce = () => O(E[`input-label`]),
          le = () => te(`.${E.loader}`),
          ue = () => te(`.${E.actions} .${E.cancel}`),
          de = () => O(E.actions),
          fe = () => O(E.footer),
          pe = () => O(E[`timer-progress-bar`]),
          M = () => O(E.close),
          me = () => {
            let e = r(
                k().querySelectorAll(`[tabindex]:not([tabindex="-1"]):not([tabindex="0"])`),
              ).sort((e, t) => {
                let n = parseInt(e.getAttribute(`tabindex`)),
                  r = parseInt(t.getAttribute(`tabindex`));
                return n > r ? 1 : n < r ? -1 : 0;
              }),
              n = r(
                k().querySelectorAll(`
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`),
              ).filter((e) => e.getAttribute(`tabindex`) !== `-1`);
            return t(e.concat(n)).filter((e) => ke(e));
          },
          N = () =>
            ve(document.body, E.shown) &&
            !ve(document.body, E[`toast-shown`]) &&
            !ve(document.body, E[`no-backdrop`]),
          P = () => k() && ve(k(), E.toast),
          he = () => k().hasAttribute(`data-loading`),
          ge = {
            previousBodyPadding: null,
          },
          _e = (e, t) => {
            if (((e.textContent = ``), t)) {
              let n = new DOMParser().parseFromString(t, `text/html`);
              (r(n.querySelector(`head`).childNodes).forEach((t) => {
                e.appendChild(t);
              }),
                r(n.querySelector(`body`).childNodes).forEach((t) => {
                  e.appendChild(t);
                }));
            }
          },
          ve = (e, t) => {
            if (!t) return !1;
            let n = t.split(/\s+/);
            for (let t = 0; t < n.length; t++) if (!e.classList.contains(n[t])) return !1;
            return !0;
          },
          ye = (e, t) => {
            r(e.classList).forEach((n) => {
              !Object.values(E).includes(n) &&
                !Object.values(D).includes(n) &&
                !Object.values(t.showClass).includes(n) &&
                e.classList.remove(n);
            });
          },
          F = (e, t, n) => {
            if ((ye(e, t), t.customClass && t.customClass[n])) {
              if (typeof t.customClass[n] != `string` && !t.customClass[n].forEach)
                return i(
                  `Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof t.customClass[n]}"`,
                );
              xe(e, t.customClass[n]);
            }
          },
          be = (e, t) => {
            if (!t) return null;
            switch (t) {
              case `select`:
              case `textarea`:
              case `file`:
                return e.querySelector(`.${E.popup} > .${E[t]}`);
              case `checkbox`:
                return e.querySelector(`.${E.popup} > .${E.checkbox} input`);
              case `radio`:
                return (
                  e.querySelector(`.${E.popup} > .${E.radio} input:checked`) ||
                  e.querySelector(`.${E.popup} > .${E.radio} input:first-child`)
                );
              case `range`:
                return e.querySelector(`.${E.popup} > .${E.range} input`);
              default:
                return e.querySelector(`.${E.popup} > .${E.input}`);
            }
          },
          I = (e) => {
            if ((e.focus(), e.type !== `file`)) {
              let t = e.value;
              ((e.value = ``), (e.value = t));
            }
          },
          L = (e, t, n) => {
            !e ||
              !t ||
              (typeof t == `string` && (t = t.split(/\s+/).filter(Boolean)),
              t.forEach((t) => {
                Array.isArray(e)
                  ? e.forEach((e) => {
                      n ? e.classList.add(t) : e.classList.remove(t);
                    })
                  : n
                    ? e.classList.add(t)
                    : e.classList.remove(t);
              }));
          },
          xe = (e, t) => {
            L(e, t, !0);
          },
          Se = (e, t) => {
            L(e, t, !1);
          },
          Ce = (e, t) => {
            let n = r(e.childNodes);
            for (let e = 0; e < n.length; e++) if (ve(n[e], t)) return n[e];
          },
          we = (e, t, n) => {
            (n === `${parseInt(n)}` && (n = parseInt(n)),
              n || parseInt(n) === 0
                ? (e.style[t] = typeof n == `number` ? `${n}px` : n)
                : e.style.removeProperty(t));
          },
          Te = function (e) {
            let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `flex`;
            e.style.display = t;
          },
          Ee = (e) => {
            e.style.display = `none`;
          },
          De = (e, t, n, r) => {
            let i = e.querySelector(t);
            i && (i.style[n] = r);
          },
          Oe = (e, t, n) => {
            t ? Te(e, n) : Ee(e);
          },
          ke = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)),
          Ae = () => !ke(oe()) && !ke(se()) && !ke(ue()),
          je = (e) => e.scrollHeight > e.clientHeight,
          Me = (e) => {
            let t = window.getComputedStyle(e),
              n = parseFloat(t.getPropertyValue(`animation-duration`) || `0`),
              r = parseFloat(t.getPropertyValue(`transition-duration`) || `0`);
            return n > 0 || r > 0;
          },
          R = function (e) {
            let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1,
              n = pe();
            ke(n) &&
              (t && ((n.style.transition = `none`), (n.style.width = `100%`)),
              setTimeout(() => {
                ((n.style.transition = `width ${e / 1e3}s linear`), (n.style.width = `0%`));
              }, 10));
          },
          Ne = () => {
            let e = pe(),
              t = parseInt(window.getComputedStyle(e).width);
            (e.style.removeProperty(`transition`), (e.style.width = `100%`));
            let n = (t / parseInt(window.getComputedStyle(e).width)) * 100;
            (e.style.removeProperty(`transition`), (e.style.width = `${n}%`));
          },
          Pe = () => typeof window > `u` || typeof document > `u`,
          Fe = {},
          Ie = () => {
            Fe.previousActiveElement && Fe.previousActiveElement.focus
              ? (Fe.previousActiveElement.focus(), (Fe.previousActiveElement = null))
              : document.body && document.body.focus();
          },
          Le = (e) =>
            new Promise((t) => {
              if (!e) return t();
              let n = window.scrollX,
                r = window.scrollY;
              ((Fe.restoreFocusTimeout = setTimeout(() => {
                (Ie(), t());
              }, 100)),
                window.scrollTo(n, r));
            }),
          Re = `
 <div aria-labelledby="${E.title}" aria-describedby="${E[`html-container`]}" class="${E.popup}" tabindex="-1">
   <button type="button" class="${E.close}"></button>
   <ul class="${E[`progress-steps`]}"></ul>
   <div class="${E.icon}"></div>
   <img class="${E.image}" />
   <h2 class="${E.title}" id="${E.title}"></h2>
   <div class="${E[`html-container`]}" id="${E[`html-container`]}"></div>
   <input class="${E.input}" />
   <input type="file" class="${E.file}" />
   <div class="${E.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${E.select}"></select>
   <div class="${E.radio}"></div>
   <label for="${E.checkbox}" class="${E.checkbox}">
     <input type="checkbox" />
     <span class="${E.label}"></span>
   </label>
   <textarea class="${E.textarea}"></textarea>
   <div class="${E[`validation-message`]}" id="${E[`validation-message`]}"></div>
   <div class="${E.actions}">
     <div class="${E.loader}"></div>
     <button type="button" class="${E.confirm}"></button>
     <button type="button" class="${E.deny}"></button>
     <button type="button" class="${E.cancel}"></button>
   </div>
   <div class="${E.footer}"></div>
   <div class="${E[`timer-progress-bar-container`]}">
     <div class="${E[`timer-progress-bar`]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ``),
          ze = () => {
            let e = ee();
            return e
              ? (e.remove(),
                Se(
                  [document.documentElement, document.body],
                  [E[`no-backdrop`], E[`toast-shown`], E[`has-column`]],
                ),
                !0)
              : !1;
          },
          Be = () => {
            Fe.currentInstance.resetValidationMessage();
          },
          z = () => {
            let e = k(),
              t = Ce(e, E.input),
              n = Ce(e, E.file),
              r = e.querySelector(`.${E.range} input`),
              i = e.querySelector(`.${E.range} output`),
              a = Ce(e, E.select),
              o = e.querySelector(`.${E.checkbox} input`),
              s = Ce(e, E.textarea);
            ((t.oninput = Be),
              (n.onchange = Be),
              (a.onchange = Be),
              (o.onchange = Be),
              (s.oninput = Be),
              (r.oninput = () => {
                (Be(), (i.value = r.value));
              }),
              (r.onchange = () => {
                (Be(), (r.nextSibling.value = r.value));
              }));
          },
          Ve = (e) => (typeof e == `string` ? document.querySelector(e) : e),
          He = (e) => {
            let t = k();
            (t.setAttribute(`role`, e.toast ? `alert` : `dialog`),
              t.setAttribute(`aria-live`, e.toast ? `polite` : `assertive`),
              e.toast || t.setAttribute(`aria-modal`, `true`));
          },
          Ue = (e) => {
            window.getComputedStyle(e).direction === `rtl` && xe(ee(), E.rtl);
          },
          We = (e) => {
            let t = ze();
            if (Pe()) {
              a(`SweetAlert2 requires document to initialize`);
              return;
            }
            let n = document.createElement(`div`);
            ((n.className = E.container), t && xe(n, E[`no-transition`]), _e(n, Re));
            let r = Ve(e.target);
            (r.appendChild(n), He(e), Ue(r), z());
          },
          B = (e, t) => {
            e instanceof HTMLElement
              ? t.appendChild(e)
              : typeof e == `object`
                ? Ge(e, t)
                : e && _e(t, e);
          },
          Ge = (e, t) => {
            e.jquery ? Ke(t, e) : _e(t, e.toString());
          },
          Ke = (e, t) => {
            if (((e.textContent = ``), 0 in t))
              for (let n = 0; n in t; n++) e.appendChild(t[n].cloneNode(!0));
            else e.appendChild(t.cloneNode(!0));
          },
          qe = (() => {
            if (Pe()) return !1;
            let e = document.createElement(`div`),
              t = {
                WebkitAnimation: `webkitAnimationEnd`,
                animation: `animationend`,
              };
            for (let n in t)
              if (Object.prototype.hasOwnProperty.call(t, n) && e.style[n] !== void 0) return t[n];
            return !1;
          })(),
          V = () => {
            let e = document.createElement(`div`);
            ((e.className = E[`scrollbar-measure`]), document.body.appendChild(e));
            let t = e.getBoundingClientRect().width - e.clientWidth;
            return (document.body.removeChild(e), t);
          },
          Je = (e, t) => {
            let n = de(),
              r = le();
            (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Ee(n) : Te(n),
              F(n, t, `actions`),
              H(n, r, t),
              _e(r, t.loaderHtml),
              F(r, t, `loader`));
          };
        function H(e, t, n) {
          let r = oe(),
            i = se(),
            a = ue();
          (U(r, `confirm`, n),
            U(i, `deny`, n),
            U(a, `cancel`, n),
            Ye(r, i, a, n),
            n.reverseButtons &&
              (n.toast
                ? (e.insertBefore(a, r), e.insertBefore(i, r))
                : (e.insertBefore(a, t), e.insertBefore(i, t), e.insertBefore(r, t))));
        }
        function Ye(e, t, n, r) {
          if (!r.buttonsStyling) return Se([e, t, n], E.styled);
          (xe([e, t, n], E.styled),
            r.confirmButtonColor &&
              ((e.style.backgroundColor = r.confirmButtonColor), xe(e, E[`default-outline`])),
            r.denyButtonColor &&
              ((t.style.backgroundColor = r.denyButtonColor), xe(t, E[`default-outline`])),
            r.cancelButtonColor &&
              ((n.style.backgroundColor = r.cancelButtonColor), xe(n, E[`default-outline`])));
        }
        function U(e, t, r) {
          (Oe(e, r[`show${n(t)}Button`], `inline-block`),
            _e(e, r[`${t}ButtonText`]),
            e.setAttribute(`aria-label`, r[`${t}ButtonAriaLabel`]),
            (e.className = E[t]),
            F(e, r, `${t}Button`),
            xe(e, r[`${t}ButtonClass`]));
        }
        function Xe(e, t) {
          typeof t == `string`
            ? (e.style.background = t)
            : t || xe([document.documentElement, document.body], E[`no-backdrop`]);
        }
        function W(e, t) {
          t in E
            ? xe(e, E[t])
            : (i(`The "position" parameter is not valid, defaulting to "center"`), xe(e, E.center));
        }
        function Ze(e, t) {
          if (t && typeof t == `string`) {
            let n = `grow-${t}`;
            n in E && xe(e, E[n]);
          }
        }
        let Qe = (e, t) => {
          let n = ee();
          n && (Xe(n, t.backdrop), W(n, t.position), Ze(n, t.grow), F(n, t, `container`));
        };
        var $e = {
          awaitingPromise: new WeakMap(),
          promise: new WeakMap(),
          innerParams: new WeakMap(),
          domCache: new WeakMap(),
        };
        let et = [`input`, `file`, `range`, `select`, `radio`, `checkbox`, `textarea`],
          tt = (e, t) => {
            let n = k(),
              r = $e.innerParams.get(e),
              i = !r || t.input !== r.input;
            (et.forEach((e) => {
              let r = E[e],
                a = Ce(n, r);
              (it(e, t.inputAttributes), (a.className = r), i && Ee(a));
            }),
              t.input && (i && nt(t), at(t)));
          },
          nt = (e) => {
            if (!lt[e.input])
              return a(
                `Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "${e.input}"`,
              );
            let t = ct(e.input),
              n = lt[e.input](t, e);
            (Te(n),
              setTimeout(() => {
                I(n);
              }));
          },
          rt = (e) => {
            for (let t = 0; t < e.attributes.length; t++) {
              let n = e.attributes[t].name;
              [`type`, `value`, `style`].includes(n) || e.removeAttribute(n);
            }
          },
          it = (e, t) => {
            let n = be(k(), e);
            if (n) {
              rt(n);
              for (let e in t) n.setAttribute(e, t[e]);
            }
          },
          at = (e) => {
            let t = ct(e.input);
            e.customClass && xe(t, e.customClass.input);
          },
          ot = (e, t) => {
            (!e.placeholder || t.inputPlaceholder) && (e.placeholder = t.inputPlaceholder);
          },
          st = (e, t, n) => {
            if (n.inputLabel) {
              e.id = E.input;
              let r = document.createElement(`label`),
                i = E[`input-label`];
              (r.setAttribute(`for`, e.id),
                (r.className = i),
                xe(r, n.customClass.inputLabel),
                (r.innerText = n.inputLabel),
                t.insertAdjacentElement(`beforebegin`, r));
            }
          },
          ct = (e) => {
            let t = E[e] ? E[e] : E.input;
            return Ce(k(), t);
          },
          lt = {};
        ((lt.text =
          lt.email =
          lt.password =
          lt.number =
          lt.tel =
          lt.url =
            (e, t) => (
              typeof t.inputValue == `string` || typeof t.inputValue == `number`
                ? (e.value = t.inputValue)
                : f(t.inputValue) ||
                  i(
                    `Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t.inputValue}"`,
                  ),
              st(e, e, t),
              ot(e, t),
              (e.type = t.input),
              e
            )),
          (lt.file = (e, t) => (st(e, e, t), ot(e, t), e)),
          (lt.range = (e, t) => {
            let n = e.querySelector(`input`),
              r = e.querySelector(`output`);
            return (
              (n.value = t.inputValue),
              (n.type = t.input),
              (r.value = t.inputValue),
              st(n, e, t),
              e
            );
          }),
          (lt.select = (e, t) => {
            if (((e.textContent = ``), t.inputPlaceholder)) {
              let n = document.createElement(`option`);
              (_e(n, t.inputPlaceholder),
                (n.value = ``),
                (n.disabled = !0),
                (n.selected = !0),
                e.appendChild(n));
            }
            return (st(e, e, t), e);
          }),
          (lt.radio = (e) => ((e.textContent = ``), e)),
          (lt.checkbox = (e, t) => {
            let n = be(k(), `checkbox`);
            return (
              (n.value = `1`),
              (n.id = E.checkbox),
              (n.checked = !!t.inputValue),
              _e(e.querySelector(`span`), t.inputPlaceholder),
              e
            );
          }),
          (lt.textarea = (e, t) => {
            ((e.value = t.inputValue), ot(e, t), st(e, e, t));
            let n = (e) =>
              parseInt(window.getComputedStyle(e).marginLeft) +
              parseInt(window.getComputedStyle(e).marginRight);
            return (
              setTimeout(() => {
                if (`MutationObserver` in window) {
                  let t = parseInt(window.getComputedStyle(k()).width);
                  new MutationObserver(() => {
                    let r = e.offsetWidth + n(e);
                    r > t ? (k().style.width = `${r}px`) : (k().style.width = null);
                  }).observe(e, {
                    attributes: !0,
                    attributeFilter: [`style`],
                  });
                }
              }),
              e
            );
          }));
        let ut = (e, t) => {
            let n = A();
            (F(n, t, `htmlContainer`),
              t.html
                ? (B(t.html, n), Te(n, `block`))
                : t.text
                  ? ((n.textContent = t.text), Te(n, `block`))
                  : Ee(n),
              tt(e, t));
          },
          dt = (e, t) => {
            let n = fe();
            (Oe(n, t.footer), t.footer && B(t.footer, n), F(n, t, `footer`));
          },
          ft = (e, t) => {
            let n = M();
            (_e(n, t.closeButtonHtml),
              F(n, t, `closeButton`),
              Oe(n, t.showCloseButton),
              n.setAttribute(`aria-label`, t.closeButtonAriaLabel));
          },
          pt = (e, t) => {
            let n = $e.innerParams.get(e),
              r = ne();
            if (n && t.icon === n.icon) {
              (G(r, t), mt(r, t));
              return;
            }
            if (!t.icon && !t.iconHtml) return Ee(r);
            if (t.icon && Object.keys(D).indexOf(t.icon) === -1)
              return (
                a(
                  `Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`,
                ),
                Ee(r)
              );
            (Te(r), G(r, t), mt(r, t), xe(r, t.showClass.icon));
          },
          mt = (e, t) => {
            for (let n in D) t.icon !== n && Se(e, D[n]);
            (xe(e, D[t.icon]), gt(e, t), ht(), F(e, t, `icon`));
          },
          ht = () => {
            let e = k(),
              t = window.getComputedStyle(e).getPropertyValue(`background-color`),
              n = e.querySelectorAll(`[class^=swal2-success-circular-line], .swal2-success-fix`);
            for (let e = 0; e < n.length; e++) n[e].style.backgroundColor = t;
          },
          G = (e, t) => {
            ((e.textContent = ``),
              t.iconHtml
                ? _e(e, _t(t.iconHtml))
                : t.icon === `success`
                  ? _e(
                      e,
                      `
  <div class="swal2-success-circular-line-left"></div>
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>
  <div class="swal2-success-circular-line-right"></div>
`,
                    )
                  : t.icon === `error`
                    ? _e(
                        e,
                        `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`,
                      )
                    : _e(
                        e,
                        _t(
                          {
                            question: `?`,
                            warning: `!`,
                            info: `i`,
                          }[t.icon],
                        ),
                      ));
          },
          gt = (e, t) => {
            if (t.iconColor) {
              ((e.style.color = t.iconColor), (e.style.borderColor = t.iconColor));
              for (let n of [
                `.swal2-success-line-tip`,
                `.swal2-success-line-long`,
                `.swal2-x-mark-line-left`,
                `.swal2-x-mark-line-right`,
              ])
                De(e, n, `backgroundColor`, t.iconColor);
              De(e, `.swal2-success-ring`, `borderColor`, t.iconColor);
            }
          },
          _t = (e) => `<div class="${E[`icon-content`]}">${e}</div>`,
          vt = (e, t) => {
            let n = ie();
            if (!t.imageUrl) return Ee(n);
            (Te(n, ``),
              n.setAttribute(`src`, t.imageUrl),
              n.setAttribute(`alt`, t.imageAlt),
              we(n, `width`, t.imageWidth),
              we(n, `height`, t.imageHeight),
              (n.className = E.image),
              F(n, t, `image`));
          },
          yt = (e) => {
            let t = document.createElement(`li`);
            return (xe(t, E[`progress-step`]), _e(t, e), t);
          },
          bt = (e) => {
            let t = document.createElement(`li`);
            return (
              xe(t, E[`progress-step-line`]),
              e.progressStepsDistance && (t.style.width = e.progressStepsDistance),
              t
            );
          },
          xt = (e, t) => {
            let n = j();
            if (!t.progressSteps || t.progressSteps.length === 0) return Ee(n);
            (Te(n),
              (n.textContent = ``),
              t.currentProgressStep >= t.progressSteps.length &&
                i(
                  `Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)`,
                ),
              t.progressSteps.forEach((e, r) => {
                let i = yt(e);
                if (
                  (n.appendChild(i),
                  r === t.currentProgressStep && xe(i, E[`active-progress-step`]),
                  r !== t.progressSteps.length - 1)
                ) {
                  let e = bt(t);
                  n.appendChild(e);
                }
              }));
          },
          St = (e, t) => {
            let n = re();
            (Oe(n, t.title || t.titleText, `block`),
              t.title && B(t.title, n),
              t.titleText && (n.innerText = t.titleText),
              F(n, t, `title`));
          },
          Ct = (e, t) => {
            let n = ee(),
              r = k();
            (t.toast
              ? (we(n, `width`, t.width), (r.style.width = `100%`), r.insertBefore(le(), ne()))
              : we(r, `width`, t.width),
              we(r, `padding`, t.padding),
              t.color && (r.style.color = t.color),
              t.background && (r.style.background = t.background),
              Ee(ae()),
              wt(r, t));
          },
          wt = (e, t) => {
            ((e.className = `${E.popup} ${ke(e) ? t.showClass.popup : ``}`),
              t.toast
                ? (xe([document.documentElement, document.body], E[`toast-shown`]), xe(e, E.toast))
                : xe(e, E.modal),
              F(e, t, `popup`),
              typeof t.customClass == `string` && xe(e, t.customClass),
              t.icon && xe(e, E[`icon-${t.icon}`]));
          },
          Tt = (e, t) => {
            (Ct(e, t),
              Qe(e, t),
              xt(e, t),
              pt(e, t),
              vt(e, t),
              St(e, t),
              ft(e, t),
              ut(e, t),
              Je(e, t),
              dt(e, t),
              typeof t.didRender == `function` && t.didRender(k()));
          },
          Et = Object.freeze({
            cancel: `cancel`,
            backdrop: `backdrop`,
            close: `close`,
            esc: `esc`,
            timer: `timer`,
          }),
          Dt = () => {
            r(document.body.children).forEach((e) => {
              e === ee() ||
                e.contains(ee()) ||
                (e.hasAttribute(`aria-hidden`) &&
                  e.setAttribute(`data-previous-aria-hidden`, e.getAttribute(`aria-hidden`)),
                e.setAttribute(`aria-hidden`, `true`));
            });
          },
          Ot = () => {
            r(document.body.children).forEach((e) => {
              e.hasAttribute(`data-previous-aria-hidden`)
                ? (e.setAttribute(`aria-hidden`, e.getAttribute(`data-previous-aria-hidden`)),
                  e.removeAttribute(`data-previous-aria-hidden`))
                : e.removeAttribute(`aria-hidden`);
            });
          },
          kt = [`swal-title`, `swal-html`, `swal-footer`],
          At = (e) => {
            let t = typeof e.template == `string` ? document.querySelector(e.template) : e.template;
            if (!t) return {};
            let n = t.content;
            return (Lt(n), Object.assign(jt(n), Mt(n), Nt(n), Pt(n), Ft(n), It(n, kt)));
          },
          jt = (e) => {
            let t = {};
            return (
              r(e.querySelectorAll(`swal-param`)).forEach((e) => {
                Rt(e, [`name`, `value`]);
                let n = e.getAttribute(`name`),
                  r = e.getAttribute(`value`);
                (typeof p[n] == `boolean` && r === `false` && (t[n] = !1),
                  typeof p[n] == `object` && (t[n] = JSON.parse(r)));
              }),
              t
            );
          },
          Mt = (e) => {
            let t = {};
            return (
              r(e.querySelectorAll(`swal-button`)).forEach((e) => {
                Rt(e, [`type`, `color`, `aria-label`]);
                let r = e.getAttribute(`type`);
                ((t[`${r}ButtonText`] = e.innerHTML),
                  (t[`show${n(r)}Button`] = !0),
                  e.hasAttribute(`color`) && (t[`${r}ButtonColor`] = e.getAttribute(`color`)),
                  e.hasAttribute(`aria-label`) &&
                    (t[`${r}ButtonAriaLabel`] = e.getAttribute(`aria-label`)));
              }),
              t
            );
          },
          Nt = (e) => {
            let t = {},
              n = e.querySelector(`swal-image`);
            return (
              n &&
                (Rt(n, [`src`, `width`, `height`, `alt`]),
                n.hasAttribute(`src`) && (t.imageUrl = n.getAttribute(`src`)),
                n.hasAttribute(`width`) && (t.imageWidth = n.getAttribute(`width`)),
                n.hasAttribute(`height`) && (t.imageHeight = n.getAttribute(`height`)),
                n.hasAttribute(`alt`) && (t.imageAlt = n.getAttribute(`alt`))),
              t
            );
          },
          Pt = (e) => {
            let t = {},
              n = e.querySelector(`swal-icon`);
            return (
              n &&
                (Rt(n, [`type`, `color`]),
                n.hasAttribute(`type`) && (t.icon = n.getAttribute(`type`)),
                n.hasAttribute(`color`) && (t.iconColor = n.getAttribute(`color`)),
                (t.iconHtml = n.innerHTML)),
              t
            );
          },
          Ft = (e) => {
            let t = {},
              n = e.querySelector(`swal-input`);
            n &&
              (Rt(n, [`type`, `label`, `placeholder`, `value`]),
              (t.input = n.getAttribute(`type`) || `text`),
              n.hasAttribute(`label`) && (t.inputLabel = n.getAttribute(`label`)),
              n.hasAttribute(`placeholder`) && (t.inputPlaceholder = n.getAttribute(`placeholder`)),
              n.hasAttribute(`value`) && (t.inputValue = n.getAttribute(`value`)));
            let i = e.querySelectorAll(`swal-input-option`);
            return (
              i.length &&
                ((t.inputOptions = {}),
                r(i).forEach((e) => {
                  Rt(e, [`value`]);
                  let n = e.getAttribute(`value`),
                    r = e.innerHTML;
                  t.inputOptions[n] = r;
                })),
              t
            );
          },
          It = (e, t) => {
            let n = {};
            for (let r in t) {
              let i = t[r],
                a = e.querySelector(i);
              a && (Rt(a, []), (n[i.replace(/^swal-/, ``)] = a.innerHTML.trim()));
            }
            return n;
          },
          Lt = (e) => {
            let t = kt.concat([
              `swal-param`,
              `swal-button`,
              `swal-image`,
              `swal-icon`,
              `swal-input`,
              `swal-input-option`,
            ]);
            r(e.children).forEach((e) => {
              let n = e.tagName.toLowerCase();
              t.indexOf(n) === -1 && i(`Unrecognized element <${n}>`);
            });
          },
          Rt = (e, t) => {
            r(e.attributes).forEach((n) => {
              t.indexOf(n.name) === -1 &&
                i([
                  `Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`,
                  `${t.length ? `Allowed attributes are: ${t.join(`, `)}` : `To set the value, use HTML within the element.`}`,
                ]);
            });
          };
        var zt = {
          email: (e, t) =>
            /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(e)
              ? Promise.resolve()
              : Promise.resolve(t || `Invalid email address`),
          url: (e, t) =>
            /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(
              e,
            )
              ? Promise.resolve()
              : Promise.resolve(t || `Invalid URL`),
        };
        function Bt(e) {
          e.inputValidator ||
            Object.keys(zt).forEach((t) => {
              e.input === t && (e.inputValidator = zt[t]);
            });
        }
        function Vt(e) {
          (!e.target ||
            (typeof e.target == `string` && !document.querySelector(e.target)) ||
            (typeof e.target != `string` && !e.target.appendChild)) &&
            (i(`Target parameter is not valid, defaulting to "body"`), (e.target = `body`));
        }
        function Ht(e) {
          (Bt(e),
            e.showLoaderOnConfirm &&
              !e.preConfirm &&
              i(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`),
            Vt(e),
            typeof e.title == `string` &&
              (e.title = e.title
                .split(
                  `
`,
                )
                .join(`<br />`)),
            We(e));
        }
        class Ut {
          constructor(e, t) {
            ((this.callback = e), (this.remaining = t), (this.running = !1), this.start());
          }
          start() {
            return (
              this.running ||
                ((this.running = !0),
                (this.started = new Date()),
                (this.id = setTimeout(this.callback, this.remaining))),
              this.remaining
            );
          }
          stop() {
            return (
              this.running &&
                ((this.running = !1),
                clearTimeout(this.id),
                (this.remaining -= new Date().getTime() - this.started.getTime())),
              this.remaining
            );
          }
          increase(e) {
            let t = this.running;
            return (t && this.stop(), (this.remaining += e), t && this.start(), this.remaining);
          }
          getTimerLeft() {
            return (this.running && (this.stop(), this.start()), this.remaining);
          }
          isRunning() {
            return this.running;
          }
        }
        let Wt = () => {
            ge.previousBodyPadding === null &&
              document.body.scrollHeight > window.innerHeight &&
              ((ge.previousBodyPadding = parseInt(
                window.getComputedStyle(document.body).getPropertyValue(`padding-right`),
              )),
              (document.body.style.paddingRight = `${ge.previousBodyPadding + V()}px`));
          },
          Gt = () => {
            ge.previousBodyPadding !== null &&
              ((document.body.style.paddingRight = `${ge.previousBodyPadding}px`),
              (ge.previousBodyPadding = null));
          },
          Kt = () => {
            if (
              ((/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) ||
                (navigator.platform === `MacIntel` && navigator.maxTouchPoints > 1)) &&
              !ve(document.body, E.iosfix)
            ) {
              let e = document.body.scrollTop;
              ((document.body.style.top = `${e * -1}px`), xe(document.body, E.iosfix), Jt(), qt());
            }
          },
          qt = () => {
            let e = navigator.userAgent,
              t = !!e.match(/iPad/i) || !!e.match(/iPhone/i),
              n = !!e.match(/WebKit/i);
            t &&
              n &&
              !e.match(/CriOS/i) &&
              k().scrollHeight > window.innerHeight - 44 &&
              (ee().style.paddingBottom = `44px`);
          },
          Jt = () => {
            let e = ee(),
              t;
            ((e.ontouchstart = (e) => {
              t = Yt(e);
            }),
              (e.ontouchmove = (e) => {
                t && (e.preventDefault(), e.stopPropagation());
              }));
          },
          Yt = (e) => {
            let t = e.target,
              n = ee();
            return Xt(e) || Zt(e)
              ? !1
              : t === n ||
                  (!je(n) &&
                    t.tagName !== `INPUT` &&
                    t.tagName !== `TEXTAREA` &&
                    !(je(A()) && A().contains(t)));
          },
          Xt = (e) => e.touches && e.touches.length && e.touches[0].touchType === `stylus`,
          Zt = (e) => e.touches && e.touches.length > 1,
          Qt = () => {
            if (ve(document.body, E.iosfix)) {
              let e = parseInt(document.body.style.top, 10);
              (Se(document.body, E.iosfix),
                (document.body.style.top = ``),
                (document.body.scrollTop = e * -1));
            }
          },
          $t = (e) => {
            let t = ee(),
              n = k();
            typeof e.willOpen == `function` && e.willOpen(n);
            let r = window.getComputedStyle(document.body).overflowY;
            (rn(t, n, e),
              setTimeout(() => {
                tn(t, n);
              }, 10),
              N() && (nn(t, e.scrollbarPadding, r), Dt()),
              !P() &&
                !Fe.previousActiveElement &&
                (Fe.previousActiveElement = document.activeElement),
              typeof e.didOpen == `function` && setTimeout(() => e.didOpen(n)),
              Se(t, E[`no-transition`]));
          },
          en = (e) => {
            let t = k();
            if (e.target !== t) return;
            let n = ee();
            (t.removeEventListener(qe, en), (n.style.overflowY = `auto`));
          },
          tn = (e, t) => {
            qe && Me(t)
              ? ((e.style.overflowY = `hidden`), t.addEventListener(qe, en))
              : (e.style.overflowY = `auto`);
          },
          nn = (e, t, n) => {
            (Kt(),
              t && n !== `hidden` && Wt(),
              setTimeout(() => {
                e.scrollTop = 0;
              }));
          },
          rn = (e, t, n) => {
            (xe(e, n.showClass.backdrop),
              t.style.setProperty(`opacity`, `0`, `important`),
              Te(t, `grid`),
              setTimeout(() => {
                (xe(t, n.showClass.popup), t.style.removeProperty(`opacity`));
              }, 10),
              xe([document.documentElement, document.body], E.shown),
              n.heightAuto &&
                n.backdrop &&
                !n.toast &&
                xe([document.documentElement, document.body], E[`height-auto`]));
          },
          an = (e) => {
            let t = k();
            (t || new Jr(), (t = k()));
            let n = le();
            (P() ? Ee(ne()) : on(t, e),
              Te(n),
              t.setAttribute(`data-loading`, !0),
              t.setAttribute(`aria-busy`, !0),
              t.focus());
          },
          on = (e, t) => {
            let n = de(),
              r = le();
            (!t && ke(oe()) && (t = oe()),
              Te(n),
              t && (Ee(t), r.setAttribute(`data-button-to-replace`, t.className)),
              r.parentNode.insertBefore(r, t),
              xe([e, n], E.loading));
          },
          sn = (e, t) => {
            t.input === `select` || t.input === `radio`
              ? fn(e, t)
              : [`text`, `email`, `number`, `tel`, `textarea`].includes(t.input) &&
                (u(t.inputValue) || f(t.inputValue)) &&
                (an(oe()), pn(e, t));
          },
          cn = (e, t) => {
            let n = e.getInput();
            if (!n) return null;
            switch (t.input) {
              case `checkbox`:
                return ln(n);
              case `radio`:
                return un(n);
              case `file`:
                return dn(n);
              default:
                return t.inputAutoTrim ? n.value.trim() : n.value;
            }
          },
          ln = (e) => +!!e.checked,
          un = (e) => (e.checked ? e.value : null),
          dn = (e) =>
            e.files.length ? (e.getAttribute(`multiple`) === null ? e.files[0] : e.files) : null,
          fn = (e, t) => {
            let n = k(),
              r = (e) => mn[t.input](n, hn(e), t);
            u(t.inputOptions) || f(t.inputOptions)
              ? (an(oe()),
                d(t.inputOptions).then((t) => {
                  (e.hideLoading(), r(t));
                }))
              : typeof t.inputOptions == `object`
                ? r(t.inputOptions)
                : a(
                    `Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`,
                  );
          },
          pn = (e, t) => {
            let n = e.getInput();
            (Ee(n),
              d(t.inputValue)
                .then((r) => {
                  ((n.value = t.input === `number` ? parseFloat(r) || 0 : `${r}`),
                    Te(n),
                    n.focus(),
                    e.hideLoading());
                })
                .catch((t) => {
                  (a(`Error in inputValue promise: ${t}`),
                    (n.value = ``),
                    Te(n),
                    n.focus(),
                    e.hideLoading());
                }));
          },
          mn = {
            select: (e, t, n) => {
              let r = Ce(e, E.select),
                i = (e, t, r) => {
                  let i = document.createElement(`option`);
                  ((i.value = r), _e(i, t), (i.selected = gn(r, n.inputValue)), e.appendChild(i));
                };
              (t.forEach((e) => {
                let t = e[0],
                  n = e[1];
                if (Array.isArray(n)) {
                  let e = document.createElement(`optgroup`);
                  ((e.label = t),
                    (e.disabled = !1),
                    r.appendChild(e),
                    n.forEach((t) => i(e, t[1], t[0])));
                } else i(r, n, t);
              }),
                r.focus());
            },
            radio: (e, t, n) => {
              let r = Ce(e, E.radio);
              t.forEach((e) => {
                let t = e[0],
                  i = e[1],
                  a = document.createElement(`input`),
                  o = document.createElement(`label`);
                ((a.type = `radio`),
                  (a.name = E.radio),
                  (a.value = t),
                  gn(t, n.inputValue) && (a.checked = !0));
                let s = document.createElement(`span`);
                (_e(s, i),
                  (s.className = E.label),
                  o.appendChild(a),
                  o.appendChild(s),
                  r.appendChild(o));
              });
              let i = r.querySelectorAll(`input`);
              i.length && i[0].focus();
            },
          },
          hn = (e) => {
            let t = [];
            return (
              typeof Map < `u` && e instanceof Map
                ? e.forEach((e, n) => {
                    let r = e;
                    (typeof r == `object` && (r = hn(r)), t.push([n, r]));
                  })
                : Object.keys(e).forEach((n) => {
                    let r = e[n];
                    (typeof r == `object` && (r = hn(r)), t.push([n, r]));
                  }),
              t
            );
          },
          gn = (e, t) => t && t.toString() === e.toString();
        function _n() {
          let e = $e.innerParams.get(this);
          if (!e) return;
          let t = $e.domCache.get(this);
          (Ee(t.loader),
            P() ? e.icon && Te(ne()) : vn(t),
            Se([t.popup, t.actions], E.loading),
            t.popup.removeAttribute(`aria-busy`),
            t.popup.removeAttribute(`data-loading`),
            (t.confirmButton.disabled = !1),
            (t.denyButton.disabled = !1),
            (t.cancelButton.disabled = !1));
        }
        let vn = (e) => {
          let t = e.popup.getElementsByClassName(e.loader.getAttribute(`data-button-to-replace`));
          t.length ? Te(t[0], `inline-block`) : Ae() && Ee(e.actions);
        };
        function yn(e) {
          let t = $e.innerParams.get(e || this),
            n = $e.domCache.get(e || this);
          return n ? be(n.popup, t.input) : null;
        }
        var bn = {
          swalPromiseResolve: new WeakMap(),
          swalPromiseReject: new WeakMap(),
        };
        function xn(e, t, n, r) {
          (P()
            ? jn(e, r)
            : (Le(n).then(() => jn(e, r)),
              Fe.keydownTarget.removeEventListener(`keydown`, Fe.keydownHandler, {
                capture: Fe.keydownListenerCapture,
              }),
              (Fe.keydownHandlerAdded = !1)),
            /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
              ? (t.setAttribute(`style`, `display:none !important`),
                t.removeAttribute(`class`),
                (t.innerHTML = ``))
              : t.remove(),
            N() && (Gt(), Qt(), Ot()),
            Sn());
        }
        function Sn() {
          Se(
            [document.documentElement, document.body],
            [E.shown, E[`height-auto`], E[`no-backdrop`], E[`toast-shown`]],
          );
        }
        function Cn(e) {
          e = On(e);
          let t = bn.swalPromiseResolve.get(this),
            n = Tn(this);
          this.isAwaitingPromise() ? e.isDismissed || (Dn(this), t(e)) : n && t(e);
        }
        function wn() {
          return !!$e.awaitingPromise.get(this);
        }
        let Tn = (e) => {
          let t = k();
          if (!t) return !1;
          let n = $e.innerParams.get(e);
          if (!n || ve(t, n.hideClass.popup)) return !1;
          (Se(t, n.showClass.popup), xe(t, n.hideClass.popup));
          let r = ee();
          return (Se(r, n.showClass.backdrop), xe(r, n.hideClass.backdrop), kn(e, t, n), !0);
        };
        function En(e) {
          let t = bn.swalPromiseReject.get(this);
          (Dn(this), t && t(e));
        }
        let Dn = (e) => {
            e.isAwaitingPromise() &&
              ($e.awaitingPromise.delete(e), $e.innerParams.get(e) || e._destroy());
          },
          On = (e) =>
            e === void 0
              ? {
                  isConfirmed: !1,
                  isDenied: !1,
                  isDismissed: !0,
                }
              : Object.assign(
                  {
                    isConfirmed: !1,
                    isDenied: !1,
                    isDismissed: !1,
                  },
                  e,
                ),
          kn = (e, t, n) => {
            let r = ee(),
              i = qe && Me(t);
            (typeof n.willClose == `function` && n.willClose(t),
              i ? An(e, t, r, n.returnFocus, n.didClose) : xn(e, r, n.returnFocus, n.didClose));
          },
          An = (e, t, n, r, i) => {
            ((Fe.swalCloseEventFinishedCallback = xn.bind(null, e, n, r, i)),
              t.addEventListener(qe, function (e) {
                e.target === t &&
                  (Fe.swalCloseEventFinishedCallback(), delete Fe.swalCloseEventFinishedCallback);
              }));
          },
          jn = (e, t) => {
            setTimeout(() => {
              (typeof t == `function` && t.bind(e.params)(), e._destroy());
            });
          };
        function Mn(e, t, n) {
          let r = $e.domCache.get(e);
          t.forEach((e) => {
            r[e].disabled = n;
          });
        }
        function Nn(e, t) {
          if (!e) return !1;
          if (e.type === `radio`) {
            let n = e.parentNode.parentNode.querySelectorAll(`input`);
            for (let e = 0; e < n.length; e++) n[e].disabled = t;
          } else e.disabled = t;
        }
        function Pn() {
          Mn(this, [`confirmButton`, `denyButton`, `cancelButton`], !1);
        }
        function Fn() {
          Mn(this, [`confirmButton`, `denyButton`, `cancelButton`], !0);
        }
        function In() {
          return Nn(this.getInput(), !1);
        }
        function Ln() {
          return Nn(this.getInput(), !0);
        }
        function Rn(e) {
          let t = $e.domCache.get(this),
            n = $e.innerParams.get(this);
          (_e(t.validationMessage, e),
            (t.validationMessage.className = E[`validation-message`]),
            n.customClass &&
              n.customClass.validationMessage &&
              xe(t.validationMessage, n.customClass.validationMessage),
            Te(t.validationMessage));
          let r = this.getInput();
          r &&
            (r.setAttribute(`aria-invalid`, !0),
            r.setAttribute(`aria-describedby`, E[`validation-message`]),
            I(r),
            xe(r, E.inputerror));
        }
        function zn() {
          let e = $e.domCache.get(this);
          e.validationMessage && Ee(e.validationMessage);
          let t = this.getInput();
          t &&
            (t.removeAttribute(`aria-invalid`),
            t.removeAttribute(`aria-describedby`),
            Se(t, E.inputerror));
        }
        function Bn() {
          return $e.domCache.get(this).progressSteps;
        }
        function Vn(e) {
          let t = k(),
            n = $e.innerParams.get(this);
          if (!t || ve(t, n.hideClass.popup))
            return i(
              `You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`,
            );
          let r = Hn(e),
            a = Object.assign({}, n, r);
          (Tt(this, a),
            $e.innerParams.set(this, a),
            Object.defineProperties(this, {
              params: {
                value: Object.assign({}, this.params, e),
                writable: !1,
                enumerable: !0,
              },
            }));
        }
        let Hn = (e) => {
          let t = {};
          return (
            Object.keys(e).forEach((n) => {
              y(n)
                ? (t[n] = e[n])
                : i(`Invalid parameter to update: "${n}". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js

If you think this parameter should be updatable, request it here: https://github.com/sweetalert2/sweetalert2/issues/new?template=02_feature_request.md`);
            }),
            t
          );
        };
        function Un() {
          let e = $e.domCache.get(this),
            t = $e.innerParams.get(this);
          if (!t) {
            Gn(this);
            return;
          }
          (e.popup &&
            Fe.swalCloseEventFinishedCallback &&
            (Fe.swalCloseEventFinishedCallback(), delete Fe.swalCloseEventFinishedCallback),
            Fe.deferDisposalTimer &&
              (clearTimeout(Fe.deferDisposalTimer), delete Fe.deferDisposalTimer),
            typeof t.didDestroy == `function` && t.didDestroy(),
            Wn(this));
        }
        let Wn = (e) => {
            (Gn(e),
              delete e.params,
              delete Fe.keydownHandler,
              delete Fe.keydownTarget,
              delete Fe.currentInstance);
          },
          Gn = (e) => {
            e.isAwaitingPromise()
              ? (Kn($e, e), $e.awaitingPromise.set(e, !0))
              : (Kn(bn, e), Kn($e, e));
          },
          Kn = (e, t) => {
            for (let n in e) e[n].delete(t);
          };
        var qn = Object.freeze({
          hideLoading: _n,
          disableLoading: _n,
          getInput: yn,
          close: Cn,
          isAwaitingPromise: wn,
          rejectPromise: En,
          handleAwaitingPromise: Dn,
          closePopup: Cn,
          closeModal: Cn,
          closeToast: Cn,
          enableButtons: Pn,
          disableButtons: Fn,
          enableInput: In,
          disableInput: Ln,
          showValidationMessage: Rn,
          resetValidationMessage: zn,
          getProgressSteps: Bn,
          update: Vn,
          _destroy: Un,
        });
        let Jn = (e) => {
            let t = $e.innerParams.get(e);
            (e.disableButtons(), t.input ? Zn(e, `confirm`) : nr(e, !0));
          },
          Yn = (e) => {
            let t = $e.innerParams.get(e);
            (e.disableButtons(), t.returnInputValueOnDeny ? Zn(e, `deny`) : $n(e, !1));
          },
          Xn = (e, t) => {
            (e.disableButtons(), t(Et.cancel));
          },
          Zn = (e, t) => {
            let r = $e.innerParams.get(e);
            if (!r.input)
              return a(
                `The "input" parameter is needed to be set when using returnInputValueOn${n(t)}`,
              );
            let i = cn(e, r);
            r.inputValidator
              ? Qn(e, i, t)
              : e.getInput().checkValidity()
                ? t === `deny`
                  ? $n(e, i)
                  : nr(e, i)
                : (e.enableButtons(), e.showValidationMessage(r.validationMessage));
          },
          Qn = (e, t, n) => {
            let r = $e.innerParams.get(e);
            (e.disableInput(),
              Promise.resolve()
                .then(() => d(r.inputValidator(t, r.validationMessage)))
                .then((r) => {
                  (e.enableButtons(),
                    e.enableInput(),
                    r ? e.showValidationMessage(r) : n === `deny` ? $n(e, t) : nr(e, t));
                }));
          },
          $n = (e, t) => {
            let n = $e.innerParams.get(e || void 0);
            (n.showLoaderOnDeny && an(se()),
              n.preDeny
                ? ($e.awaitingPromise.set(e || void 0, !0),
                  Promise.resolve()
                    .then(() => d(n.preDeny(t, n.validationMessage)))
                    .then((n) => {
                      n === !1
                        ? (e.hideLoading(), Dn(e))
                        : e.closePopup({
                            isDenied: !0,
                            value: n === void 0 ? t : n,
                          });
                    })
                    .catch((t) => tr(e || void 0, t)))
                : e.closePopup({
                    isDenied: !0,
                    value: t,
                  }));
          },
          er = (e, t) => {
            e.closePopup({
              isConfirmed: !0,
              value: t,
            });
          },
          tr = (e, t) => {
            e.rejectPromise(t);
          },
          nr = (e, t) => {
            let n = $e.innerParams.get(e || void 0);
            (n.showLoaderOnConfirm && an(),
              n.preConfirm
                ? (e.resetValidationMessage(),
                  $e.awaitingPromise.set(e || void 0, !0),
                  Promise.resolve()
                    .then(() => d(n.preConfirm(t, n.validationMessage)))
                    .then((n) => {
                      ke(ae()) || n === !1 ? (e.hideLoading(), Dn(e)) : er(e, n === void 0 ? t : n);
                    })
                    .catch((t) => tr(e || void 0, t)))
                : er(e, t));
          },
          rr = (e, t, n) => {
            $e.innerParams.get(e).toast ? ir(e, t, n) : (sr(t), cr(t), lr(e, t, n));
          },
          ir = (e, t, n) => {
            t.popup.onclick = () => {
              let t = $e.innerParams.get(e);
              (t && (ar(t) || t.timer || t.input)) || n(Et.close);
            };
          },
          ar = (e) =>
            e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton,
          or = !1,
          sr = (e) => {
            e.popup.onmousedown = () => {
              e.container.onmouseup = function (t) {
                ((e.container.onmouseup = void 0), t.target === e.container && (or = !0));
              };
            };
          },
          cr = (e) => {
            e.container.onmousedown = () => {
              e.popup.onmouseup = function (t) {
                ((e.popup.onmouseup = void 0),
                  (t.target === e.popup || e.popup.contains(t.target)) && (or = !0));
              };
            };
          },
          lr = (e, t, n) => {
            t.container.onclick = (r) => {
              let i = $e.innerParams.get(e);
              if (or) {
                or = !1;
                return;
              }
              r.target === t.container && l(i.allowOutsideClick) && n(Et.backdrop);
            };
          },
          ur = () => ke(k()),
          dr = () => oe() && oe().click(),
          fr = () => se() && se().click(),
          pr = () => ue() && ue().click(),
          mr = (e, t, n, r) => {
            (t.keydownTarget &&
              t.keydownHandlerAdded &&
              (t.keydownTarget.removeEventListener(`keydown`, t.keydownHandler, {
                capture: t.keydownListenerCapture,
              }),
              (t.keydownHandlerAdded = !1)),
              n.toast ||
                ((t.keydownHandler = (t) => vr(e, t, r)),
                (t.keydownTarget = n.keydownListenerCapture ? window : k()),
                (t.keydownListenerCapture = n.keydownListenerCapture),
                t.keydownTarget.addEventListener(`keydown`, t.keydownHandler, {
                  capture: t.keydownListenerCapture,
                }),
                (t.keydownHandlerAdded = !0)));
          },
          hr = (e, t, n) => {
            let r = me();
            if (r.length)
              return (
                (t += n),
                t === r.length ? (t = 0) : t === -1 && (t = r.length - 1),
                r[t].focus()
              );
            k().focus();
          },
          gr = [`ArrowRight`, `ArrowDown`],
          _r = [`ArrowLeft`, `ArrowUp`],
          vr = (e, t, n) => {
            let r = $e.innerParams.get(e);
            r &&
              (t.isComposing ||
                t.keyCode === 229 ||
                (r.stopKeydownPropagation && t.stopPropagation(),
                t.key === `Enter`
                  ? yr(e, t, r)
                  : t.key === `Tab`
                    ? br(t, r)
                    : [...gr, ..._r].includes(t.key)
                      ? xr(t.key)
                      : t.key === `Escape` && Sr(t, r, n)));
          },
          yr = (e, t, n) => {
            if (
              l(n.allowEnterKey) &&
              t.target &&
              e.getInput() &&
              t.target.outerHTML === e.getInput().outerHTML
            ) {
              if ([`textarea`, `file`].includes(n.input)) return;
              (dr(), t.preventDefault());
            }
          },
          br = (e, t) => {
            let n = e.target,
              r = me(),
              i = -1;
            for (let e = 0; e < r.length; e++)
              if (n === r[e]) {
                i = e;
                break;
              }
            (e.shiftKey ? hr(t, i, -1) : hr(t, i, 1), e.stopPropagation(), e.preventDefault());
          },
          xr = (e) => {
            if (![oe(), se(), ue()].includes(document.activeElement)) return;
            let t = gr.includes(e) ? `nextElementSibling` : `previousElementSibling`,
              n = document.activeElement;
            for (let e = 0; e < de().children.length; e++) {
              if (((n = n[t]), !n)) return;
              if (ke(n) && n instanceof HTMLButtonElement) break;
            }
            n instanceof HTMLButtonElement && n.focus();
          },
          Sr = (e, t, n) => {
            l(t.allowEscapeKey) && (e.preventDefault(), n(Et.esc));
          },
          Cr = (e) => typeof e == `object` && e.jquery,
          wr = (e) => e instanceof Element || Cr(e),
          Tr = (e) => {
            let t = {};
            return (
              typeof e[0] == `object` && !wr(e[0])
                ? Object.assign(t, e[0])
                : [`title`, `html`, `icon`].forEach((n, r) => {
                    let i = e[r];
                    typeof i == `string` || wr(i)
                      ? (t[n] = i)
                      : i !== void 0 &&
                        a(
                          `Unexpected type of ${n}! Expected "string" or "Element", got ${typeof i}`,
                        );
                  }),
              t
            );
          };
        function Er() {
          return new this(...arguments);
        }
        function Dr(e) {
          class t extends this {
            _main(t, n) {
              return super._main(t, Object.assign({}, e, n));
            }
          }
          return t;
        }
        let Or = () => Fe.timeout && Fe.timeout.getTimerLeft(),
          kr = () => {
            if (Fe.timeout) return (Ne(), Fe.timeout.stop());
          },
          Ar = () => {
            if (Fe.timeout) {
              let e = Fe.timeout.start();
              return (R(e), e);
            }
          },
          jr = () => {
            let e = Fe.timeout;
            return e && (e.running ? kr() : Ar());
          },
          Mr = (e) => {
            if (Fe.timeout) {
              let t = Fe.timeout.increase(e);
              return (R(t, !0), t);
            }
          },
          Nr = () => Fe.timeout && Fe.timeout.isRunning(),
          Pr = !1,
          Fr = {};
        function Ir() {
          let e =
            arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : `data-swal-template`;
          ((Fr[e] = this), (Pr ||= (document.body.addEventListener(`click`, Lr), !0)));
        }
        let Lr = (e) => {
          for (let t = e.target; t && t !== document; t = t.parentNode)
            for (let e in Fr) {
              let n = t.getAttribute(e);
              if (n) {
                Fr[e].fire({
                  template: n,
                });
                return;
              }
            }
        };
        var Rr = Object.freeze({
          isValidParameter: v,
          isUpdatableParameter: y,
          isDeprecatedParameter: b,
          argsToParams: Tr,
          isVisible: ur,
          clickConfirm: dr,
          clickDeny: fr,
          clickCancel: pr,
          getContainer: ee,
          getPopup: k,
          getTitle: re,
          getHtmlContainer: A,
          getImage: ie,
          getIcon: ne,
          getInputLabel: ce,
          getCloseButton: M,
          getActions: de,
          getConfirmButton: oe,
          getDenyButton: se,
          getCancelButton: ue,
          getLoader: le,
          getFooter: fe,
          getTimerProgressBar: pe,
          getFocusableElements: me,
          getValidationMessage: ae,
          isLoading: he,
          fire: Er,
          mixin: Dr,
          showLoading: an,
          enableLoading: an,
          getTimerLeft: Or,
          stopTimer: kr,
          resumeTimer: Ar,
          toggleTimer: jr,
          increaseTimer: Mr,
          isTimerRunning: Nr,
          bindClickHandler: Ir,
        });
        let zr;
        class Br {
          constructor() {
            if (typeof window > `u`) return;
            zr = this;
            var e = [...arguments];
            let t = Object.freeze(this.constructor.argsToParams(e));
            Object.defineProperties(this, {
              params: {
                value: t,
                writable: !1,
                enumerable: !0,
                configurable: !0,
              },
            });
            let n = this._main(this.params);
            $e.promise.set(this, n);
          }
          _main(e) {
            let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            (w(Object.assign({}, t, e)),
              Fe.currentInstance && (Fe.currentInstance._destroy(), N() && Ot()),
              (Fe.currentInstance = this));
            let n = Hr(e, t);
            (Ht(n),
              Object.freeze(n),
              Fe.timeout && (Fe.timeout.stop(), delete Fe.timeout),
              clearTimeout(Fe.restoreFocusTimeout));
            let r = Ur(this);
            return (Tt(this, n), $e.innerParams.set(this, n), Vr(this, r, n));
          }
          then(e) {
            return $e.promise.get(this).then(e);
          }
          finally(e) {
            return $e.promise.get(this).finally(e);
          }
        }
        let Vr = (e, t, n) =>
            new Promise((r, i) => {
              let a = (t) => {
                e.closePopup({
                  isDismissed: !0,
                  dismiss: t,
                });
              };
              (bn.swalPromiseResolve.set(e, r),
                bn.swalPromiseReject.set(e, i),
                (t.confirmButton.onclick = () => Jn(e)),
                (t.denyButton.onclick = () => Yn(e)),
                (t.cancelButton.onclick = () => Xn(e, a)),
                (t.closeButton.onclick = () => a(Et.close)),
                rr(e, t, a),
                mr(e, Fe, n, a),
                sn(e, n),
                $t(n),
                Wr(Fe, n, a),
                Gr(t, n),
                setTimeout(() => {
                  t.container.scrollTop = 0;
                }));
            }),
          Hr = (e, t) => {
            let n = At(e),
              r = Object.assign({}, p, t, n, e);
            return (
              (r.showClass = Object.assign({}, p.showClass, r.showClass)),
              (r.hideClass = Object.assign({}, p.hideClass, r.hideClass)),
              r
            );
          },
          Ur = (e) => {
            let t = {
              popup: k(),
              container: ee(),
              actions: de(),
              confirmButton: oe(),
              denyButton: se(),
              cancelButton: ue(),
              loader: le(),
              closeButton: M(),
              validationMessage: ae(),
              progressSteps: j(),
            };
            return ($e.domCache.set(e, t), t);
          },
          Wr = (e, t, n) => {
            let r = pe();
            (Ee(r),
              t.timer &&
                ((e.timeout = new Ut(() => {
                  (n(`timer`), delete e.timeout);
                }, t.timer)),
                t.timerProgressBar &&
                  (Te(r),
                  F(r, t, `timerProgressBar`),
                  setTimeout(() => {
                    e.timeout && e.timeout.running && R(t.timer);
                  }))));
          },
          Gr = (e, t) => {
            if (!t.toast) {
              if (!l(t.allowEnterKey)) return qr();
              Kr(e, t) || hr(t, -1, 1);
            }
          },
          Kr = (e, t) =>
            t.focusDeny && ke(e.denyButton)
              ? (e.denyButton.focus(), !0)
              : t.focusCancel && ke(e.cancelButton)
                ? (e.cancelButton.focus(), !0)
                : t.focusConfirm && ke(e.confirmButton)
                  ? (e.confirmButton.focus(), !0)
                  : !1,
          qr = () => {
            document.activeElement instanceof HTMLElement &&
              typeof document.activeElement.blur == `function` &&
              document.activeElement.blur();
          };
        (Object.assign(Br.prototype, qn),
          Object.assign(Br, Rr),
          Object.keys(qn).forEach((e) => {
            Br[e] = function () {
              if (zr) return zr[e](...arguments);
            };
          }),
          (Br.DismissReason = Et),
          (Br.version = `11.4.4`));
        let Jr = Br;
        return ((Jr.default = Jr), Jr);
      }),
        e !== void 0 &&
          e.Sweetalert2 &&
          (e.swal = e.sweetAlert = e.Swal = e.SweetAlert = e.Sweetalert2),
        typeof document < `u` &&
          (function (e, t) {
            var n = e.createElement(`style`);
            if ((e.getElementsByTagName(`head`)[0].appendChild(n), n.styleSheet))
              n.styleSheet.disabled || (n.styleSheet.cssText = t);
            else
              try {
                n.innerHTML = t;
              } catch {
                n.innerText = t;
              }
          })(
            document,
            `.swal2-popup.swal2-toast{box-sizing:border-box;grid-column:1/4!important;grid-row:1/4!important;grid-template-columns:1fr 99fr 1fr;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-popup.swal2-toast>*{grid-column:2}.swal2-popup.swal2-toast .swal2-title{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.5em;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-popup.swal2-toast .swal2-html-container{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-popup.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:700}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-popup.swal2-toast .swal2-styled{margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.8em;left:-.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-toast-animate-success-line-tip .75s;animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-toast-animate-success-line-long .75s;animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:swal2-toast-show .5s;animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:swal2-toast-hide .1s forwards;animation:swal2-toast-hide .1s forwards}.swal2-container{display:grid;position:fixed;z-index:1060;top:0;right:0;bottom:0;left:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(-webkit-min-content,auto) minmax(-webkit-min-content,auto) minmax(-webkit-min-content,auto);grid-template-rows:minmax(min-content,auto) minmax(min-content,auto) minmax(min-content,auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}.swal2-container.swal2-backdrop-show,.swal2-container.swal2-noanimation{background:rgba(0,0,0,.4)}.swal2-container.swal2-backdrop-hide{background:0 0!important}.swal2-container.swal2-bottom-start,.swal2-container.swal2-center-start,.swal2-container.swal2-top-start{grid-template-columns:minmax(0,1fr) auto auto}.swal2-container.swal2-bottom,.swal2-container.swal2-center,.swal2-container.swal2-top{grid-template-columns:auto minmax(0,1fr) auto}.swal2-container.swal2-bottom-end,.swal2-container.swal2-center-end,.swal2-container.swal2-top-end{grid-template-columns:auto auto minmax(0,1fr)}.swal2-container.swal2-top-start>.swal2-popup{align-self:start}.swal2-container.swal2-top>.swal2-popup{grid-column:2;align-self:start;justify-self:center}.swal2-container.swal2-top-end>.swal2-popup,.swal2-container.swal2-top-right>.swal2-popup{grid-column:3;align-self:start;justify-self:end}.swal2-container.swal2-center-left>.swal2-popup,.swal2-container.swal2-center-start>.swal2-popup{grid-row:2;align-self:center}.swal2-container.swal2-center>.swal2-popup{grid-column:2;grid-row:2;align-self:center;justify-self:center}.swal2-container.swal2-center-end>.swal2-popup,.swal2-container.swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;align-self:center;justify-self:end}.swal2-container.swal2-bottom-left>.swal2-popup,.swal2-container.swal2-bottom-start>.swal2-popup{grid-column:1;grid-row:3;align-self:end}.swal2-container.swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;justify-self:center;align-self:end}.swal2-container.swal2-bottom-end>.swal2-popup,.swal2-container.swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;align-self:end;justify-self:end}.swal2-container.swal2-grow-fullscreen>.swal2-popup,.swal2-container.swal2-grow-row>.swal2-popup{grid-column:1/4;width:100%}.swal2-container.swal2-grow-column>.swal2-popup,.swal2-container.swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}.swal2-container.swal2-no-transition{transition:none!important}.swal2-popup{display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0,100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-title{position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-actions{display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}.swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-loader{display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 transparent #2778c4 transparent}.swal2-styled{margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px transparent;font-weight:500}.swal2-styled:not([disabled]){cursor:pointer}.swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}.swal2-styled.swal2-confirm:focus{box-shadow:0 0 0 3px rgba(112,102,224,.5)}.swal2-styled.swal2-deny{border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}.swal2-styled.swal2-deny:focus{box-shadow:0 0 0 3px rgba(220,55,65,.5)}.swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}.swal2-styled.swal2-cancel:focus{box-shadow:0 0 0 3px rgba(110,120,129,.5)}.swal2-styled.swal2-default-outline:focus{box-shadow:0 0 0 3px rgba(100,150,200,.5)}.swal2-styled:focus{outline:0}.swal2-styled::-moz-focus-inner{border:0}.swal2-footer{justify-content:center;margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em}.swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto!important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}.swal2-timer-progress-bar{width:100%;height:.25em;background:rgba(0,0,0,.2)}.swal2-image{max-width:100%;margin:2em auto 1em}.swal2-close{z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:0 0;color:#ccc;font-family:serif;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}.swal2-close:hover{transform:none;background:0 0;color:#f27474}.swal2-close:focus{outline:0;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}.swal2-close::-moz-focus-inner{border:0}.swal2-html-container{z-index:1;justify-content:center;margin:1em 1.6em .3em;padding:0;overflow:auto;color:inherit;font-size:1.125em;font-weight:400;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word}.swal2-checkbox,.swal2-file,.swal2-input,.swal2-radio,.swal2-select,.swal2-textarea{margin:1em 2em 3px}.swal2-file,.swal2-input,.swal2-textarea{box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:inherit;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px transparent;color:inherit;font-size:1.125em}.swal2-file.swal2-inputerror,.swal2-input.swal2-inputerror,.swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-file:focus,.swal2-input:focus,.swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}.swal2-file::-moz-placeholder,.swal2-input::-moz-placeholder,.swal2-textarea::-moz-placeholder{color:#ccc}.swal2-file:-ms-input-placeholder,.swal2-input:-ms-input-placeholder,.swal2-textarea:-ms-input-placeholder{color:#ccc}.swal2-file::placeholder,.swal2-input::placeholder,.swal2-textarea::placeholder{color:#ccc}.swal2-range{margin:1em 2em 3px;background:#fff}.swal2-range input{width:80%}.swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}.swal2-range input,.swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-input{height:2.625em;padding:0 .75em}.swal2-file{width:75%;margin-right:auto;margin-left:auto;background:inherit;font-size:1.125em}.swal2-textarea{height:6.75em;padding:.75em}.swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:inherit;color:inherit;font-size:1.125em}.swal2-checkbox,.swal2-radio{align-items:center;justify-content:center;background:#fff;color:inherit}.swal2-checkbox label,.swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-checkbox input,.swal2-radio input{flex-shrink:0;margin:0 .4em}.swal2-input-label{display:flex;justify-content:center;margin:1em auto 0}.swal2-validation-message{align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}.swal2-validation-message::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}.swal2-icon{position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:.25em solid transparent;border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474;color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}.swal2-icon.swal2-error.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-warning.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-warning.swal2-icon-show .swal2-icon-content{-webkit-animation:swal2-animate-i-mark .5s;animation:swal2-animate-i-mark .5s}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-info.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-info.swal2-icon-show .swal2-icon-content{-webkit-animation:swal2-animate-i-mark .8s;animation:swal2-animate-i-mark .8s}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-question.swal2-icon-show{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-icon.swal2-question.swal2-icon-show .swal2-icon-content{-webkit-animation:swal2-animate-question-mark .8s;animation:swal2-animate-question-mark .8s}.swal2-icon.swal2-success{border-color:#a5dc86;color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-.25em;left:-.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:inherit;font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@-webkit-keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@keyframes swal2-toast-show{0%{transform:translateY(-.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0)}}@-webkit-keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@-webkit-keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@-webkit-keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@keyframes swal2-show{0%{transform:scale(.7)}45%{transform:scale(1.05)}80%{transform:scale(.95)}100%{transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(.4);opacity:0}50%{margin-top:1.625em;transform:scale(.4);opacity:0}80%{margin-top:-.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0);opacity:1}}@-webkit-keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes swal2-rotate-loading{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@-webkit-keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@-webkit-keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-container{background-color:transparent!important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static!important}}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:transparent;pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}`,
          ));
    })(),
    1,
  );
async function lb(e = ``) {
  return cb.default
    .fire({
      icon: `warning`,
      title: g(`general.alerts.title`),
      text: e || g(`general.alerts.delete_description`),
      showCancelButton: !0,
      confirmButtonColor: `#3085d6`,
      cancelButtonColor: `#d33`,
    })
    .then((e) => !!e.isConfirmed);
}
async function ub(e = ``) {
  return cb.default
    .fire({
      icon: `warning`,
      title: g(`general.alerts.title`),
      text: e || g(`general.alerts.description`),
      showCancelButton: !0,
      confirmButtonColor: `#3085d6`,
      cancelButtonColor: `#d33`,
    })
    .then((e) => !!e.isConfirmed);
}
async function db(e = ``) {
  return cb.default
    .fire({
      icon: `warning`,
      title: g(`general.alerts.title`),
      input: `password`,
      text: e || g(`general.alerts.description_with_password`),
      showCancelButton: !0,
      confirmButtonColor: `#3085d6`,
      cancelButtonColor: `#d33`,
      preConfirm: async (e) =>
        await x
          .dispatch(`auth/user/confirmPassword`, {
            password: e,
          })
          .then((e) => !0)
          .catch((e) => !1),
    })
    .then((e) => !!e.isConfirmed);
}
async function fb(e = ``) {
  return cb.default
    .fire({
      icon: `warning`,
      title: g(`general.alerts.title`),
      text: e || g(`general.alerts.reset_description`),
      showCancelButton: !0,
      confirmButtonColor: `#3085d6`,
      cancelButtonColor: `#d33`,
    })
    .then((e) => !!e.isConfirmed);
}
async function pb(e = ``) {
  return cb.default.fire({
    icon: `error`,
    title: g(`general.alerts.error_title`),
    text: e || g(`general.alerts.error_description`),
    confirmButtonText: g(`general.ok`),
    confirmButtonColor: `#b91c1c`,
  });
}
var mb = i({
  default: () => hb,
});
B();
var hb = Object.assign(
    {
      name: `FormAction`,
    },
    {
      props: {
        noCard: {
          type: Boolean,
          default: !1,
        },
        initUrl: {
          type: String,
          default: ``,
          required: !0,
        },
        uuid: {
          type: String,
          default: ``,
        },
        moduleUuid: {
          type: String,
          default: ``,
        },
        preRequisites: {
          type: [Boolean, String, Object],
          default: !1,
        },
        preRequisiteUrl: {
          type: String,
          default: ``,
        },
        preRequisiteCustomUrl: {
          type: String,
          default: ``,
        },
        preRequisiteHasAdditionalParams: {
          type: Boolean,
          default: !1,
        },
        preRequisiteAdditionalParams: {
          type: Object,
          default: () => ({}),
        },
        noDataFetch: {
          type: Boolean,
          default: !1,
        },
        dataFetch: {
          type: String,
          default: ``,
        },
        form: {
          type: Object,
          default() {
            return {};
          },
        },
        initForm: {
          type: Object,
          default() {
            return {};
          },
        },
        redirect: {
          type: [String, Object],
          default: ``,
        },
        action: {
          type: String,
          default: ``,
        },
        noActionButton: {
          type: Boolean,
          default: !1,
        },
        resetForm: {
          type: Boolean,
          default: !0,
        },
        resetFormError: {
          type: Boolean,
          default: !0,
        },
        beforeSubmit: {
          type: Function,
          default() {
            return {};
          },
        },
        afterSubmit: {
          type: Function,
          default() {
            return {};
          },
        },
        afterReset: {
          type: Function,
          default() {
            return {};
          },
        },
        setForm: {
          type: Function,
          default() {
            return {};
          },
        },
        afterSet: {
          type: Function,
          default() {
            return {};
          },
        },
        stayOn: {
          type: Boolean,
          deafult: !1,
        },
        keepAdding: {
          type: Boolean,
          default: !0,
        },
        validateUnchanged: {
          type: Boolean,
          default: !0,
        },
        confirmation: {
          type: Boolean,
          default: !1,
        },
        confirmationWithPassword: {
          type: Boolean,
          default: !1,
        },
        isModal: {
          type: Boolean,
          default: !1,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
        submitText: {
          type: String,
          default: ``,
        },
        lessPadding: {
          type: Boolean,
          default: !1,
        },
        buttonPadding: {
          type: Boolean,
          default: !1,
        },
        sideover: {
          type: Boolean,
          default: !1,
        },
        cancelAction: {
          type: Boolean,
          default: !1,
        },
        hasSetupWizard: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [
        `setPreRequisites`,
        `redirectTo`,
        `resetForm`,
        `submitted`,
        `completed`,
        `end`,
        `resetMediaFiles`,
        `cancelled`,
        `preRequisiteFailed`,
      ],
      setup(e, { emit: t }) {
        let n = Dc(),
          r = Ec(),
          i = $e(),
          a = u(),
          s = R(`emitter`),
          c = R(`$trans`),
          l = t,
          d = e,
          f = V(() => (d.stayOn || d.sideover ? !1 : d.keepAdding)),
          p = F(!1),
          m = Ae({
            keepAdding: !1,
          }),
          h = async () => {
            p.value = !0;
            let e = d.preRequisites;
            (typeof d.preRequisites == `string`
              ? (e = {
                  data: d.preRequisites,
                })
              : typeof d.preRequisites == `boolean` && d.preRequisiteHasAdditionalParams
                ? (e = {
                    data: d.preRequisiteAdditionalParams,
                  })
                : n.params.uuid &&
                  (e =
                    typeof d.preRequisites == `object`
                      ? {
                          ...d.preRequisites,
                          uuid: n.params.uuid,
                        }
                      : {
                          uuid: n.params.uuid,
                        }),
              await i
                .dispatch(
                  (d.preRequisiteUrl || d.initUrl) + (d.preRequisiteCustomUrl || `preRequisite`),
                  {
                    ...e,
                    routeParams: n.params,
                  },
                )
                .then((e) => {
                  ((p.value = !1), l(`setPreRequisites`, e));
                })
                .catch((e) => {
                  ((p.value = !1), l(`preRequisiteFailed`, e));
                }));
          },
          g = async () => {
            ((p.value = !0),
              await i
                .dispatch(d.initUrl + `fetch`, {
                  type: d.dataFetch,
                })
                .then((e) => {
                  ((p.value = !1), b(e));
                })
                .catch((e) => {
                  ((p.value = !1), x());
                }));
          },
          v = async () => {
            ((p.value = !0),
              await i
                .dispatch(d.initUrl + `get`, {
                  uuid: n.params.uuid,
                  moduleUuid: d.moduleUuid,
                  queryType: n.meta.queryType,
                  routeParams: n.params,
                })
                .then((e) => {
                  ((p.value = !1), b(e));
                })
                .catch((e) => {
                  ((p.value = !1), x());
                }));
          },
          y = async () => {
            if (p.value) return;
            let e = [`mediaHash`, `mediaToken`];
            if (d.validateUnchanged && _.isEqual(_.omit(d.form, e), _.omit(d.initForm, e))) {
              a.info(c(`general.infos.nothing_to_submit`));
              return;
            }
            if ((d.confirmation && !(await ub())) || (d.confirmationWithPassword && !(await db())))
              return;
            C(d.beforeSubmit) && d.beforeSubmit();
            let t = d.initUrl + (d.action || n.meta.action);
            ((p.value = !0),
              await i
                .dispatch(t, {
                  form: d.form,
                  moduleUuid: d.moduleUuid,
                  uuid: d.uuid || n.params.uuid,
                  queryType: n.meta.queryType,
                  routeQuery: n.query,
                  routeParams: n.params,
                })
                .then((e) => {
                  if (
                    ((p.value = !1),
                    d.hasSetupWizard && s.emit(`refreshSetupWizard`),
                    d.isModal ||
                      (d.stayOn
                        ? Object.assign(d.initForm, o(d.form))
                        : Object.assign(d.form, o(d.initForm))),
                    (!d.stayOn || d.keepAdding) && (l(`resetMediaFiles`), s.emit(`resetFiles`)),
                    C(d.afterSubmit))
                  ) {
                    d.afterSubmit(e);
                    return;
                  }
                  (l(`submitted`, e),
                    !d.sideover && !m.keepAdding && !d.stayOn
                      ? x()
                      : (l(`completed`, e), d.sideover && !m.keepAdding && l(`end`, e)));
                })
                .catch((e) => {
                  p.value = !1;
                }));
          },
          b = (e) => {
            (i.dispatch(d.initUrl + `resetFormErrors`),
              C(d.setForm)
                ? (d.setForm(e),
                  e?.hasOwnProperty(`mediaToken`) && s.emit(`setMediaToken`, e.mediaToken))
                : (n.meta.type == `duplicate` && (e.media = []),
                  Object.assign(d.initForm, o(e)),
                  Object.assign(d.form, o(e)),
                  d.form.hasOwnProperty(`mediaToken`) && s.emit(`setMediaToken`, d.form.mediaToken),
                  C(d.afterSet) && d.afterSet(e)));
          },
          x = () => {
            !d.redirect && !d.isModal
              ? r.go(-1)
              : d.redirect && typeof d.redirect == `string`
                ? r.push({
                    name: d.redirect,
                  })
                : d.redirect && typeof d.redirect == `object`
                  ? r.push(d.redirect)
                  : l(`redirectTo`);
          },
          S = () => {
            d.resetFormError && i.dispatch(d.initUrl + `resetFormErrors`);
          };
        Qe(async () => {
          (s.on(`redirect`, () => {
            x();
          }),
            s.on(`keepAdding`, (e) => {
              m.keepAdding = e;
            }),
            d.preRequisites &&
              s.on(`refreshPreRequisites`, (e) => {
                h();
              }),
            s.on(`resetForm`, () => {
              (Object.assign(d.form, o(d.initForm)),
                l(`resetMediaFiles`),
                s.emit(`resetFiles`),
                S(),
                C(d.afterReset) && d.afterReset());
            }),
            s.on(`submitForm`, () => {
              y();
            }),
            d.preRequisites && (await h()),
            !d.noDataFetch && n.params.uuid && (await v()),
            n.params.muuid && (await v()),
            d.dataFetch && (await g()));
        });
        let C = (e) => e.name !== `_default` && e.name !== "default";
        return (
          wl((e, t) => {
            S();
          }),
          oe(() => {
            (s.all.delete(`redirect`),
              s.all.delete(`keepAdding`),
              s.all.delete(`resetForm`),
              s.all.delete(`submitForm`),
              s.all.delete(`refreshPreRequisites`));
          }),
          (t, n) => {
            let r = j(`FormActionButton`),
              i = j(`BaseCard`),
              a = j(`BaseLoader`);
            return (
              A(),
              M(
                `form`,
                {
                  onSubmit: Fe(y, [`prevent`]),
                },
                [
                  N(
                    a,
                    {
                      "is-loading": p.value,
                    },
                    {
                      default: I(() => [
                        e.noCard || e.sideover
                          ? (A(),
                            M(
                              ke,
                              {
                                key: 0,
                              },
                              [
                                z(t.$slots, `default`),
                                e.noActionButton
                                  ? U(``, !0)
                                  : (A(),
                                    L(
                                      r,
                                      {
                                        key: 0,
                                        class: `mt-6`,
                                        sideover: e.sideover,
                                        disabled: e.disabled,
                                        "submit-text": e.submitText,
                                        "is-modal": e.isModal,
                                        "cancel-action": e.cancelAction,
                                        redirect: e.redirect,
                                        "keep-adding": f.value,
                                        "button-padding": e.buttonPadding,
                                        onCancelled: (n[0] ||= (e) => l(`cancelled`)),
                                      },
                                      {
                                        default: I(() => [z(t.$slots, `additionalButton`)]),
                                        _: 3,
                                      },
                                      8,
                                      [
                                        `sideover`,
                                        `disabled`,
                                        `submit-text`,
                                        `is-modal`,
                                        `cancel-action`,
                                        `redirect`,
                                        `keep-adding`,
                                        `button-padding`,
                                      ],
                                    )),
                                z(t.$slots, `additionalAction`),
                                z(t.$slots, `footer`),
                              ],
                              64,
                            ))
                          : (A(),
                            L(
                              i,
                              {
                                key: 1,
                                "less-padding": e.lessPadding,
                              },
                              {
                                footer: I(() => [
                                  e.noActionButton
                                    ? U(``, !0)
                                    : (A(),
                                      L(
                                        r,
                                        {
                                          key: 0,
                                          sideover: e.sideover,
                                          disabled: e.disabled,
                                          "submit-text": e.submitText,
                                          "is-modal": e.isModal,
                                          "cancel-action": e.cancelAction,
                                          redirect: e.redirect,
                                          "keep-adding": f.value,
                                          "button-padding": e.buttonPadding,
                                          onCancelled: (n[1] ||= (e) => l(`cancelled`)),
                                        },
                                        {
                                          default: I(() => [z(t.$slots, `additionalButton`)]),
                                          _: 3,
                                        },
                                        8,
                                        [
                                          `sideover`,
                                          `disabled`,
                                          `submit-text`,
                                          `is-modal`,
                                          `cancel-action`,
                                          `redirect`,
                                          `keep-adding`,
                                          `button-padding`,
                                        ],
                                      )),
                                ]),
                                default: I(() => [
                                  z(t.$slots, `default`),
                                  z(t.$slots, `additionalAction`),
                                  z(t.$slots, `footer`),
                                ]),
                                _: 3,
                              },
                              8,
                              [`less-padding`],
                            )),
                      ]),
                      _: 3,
                    },
                    8,
                    [`is-loading`],
                  ),
                ],
                32,
              )
            );
          }
        );
      },
    },
  ),
  gb = i({
    default: () => vb,
  });
B();
var _b = {
    key: 0,
    class: `text-danger mt-1 text-sm`,
  },
  vb = Object.assign(
    {
      name: `FormError`,
    },
    {
      props: {
        error: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        return (t, n) => (e.error ? (A(), M(`div`, _b, T(e.error), 1)) : U(``, !0));
      },
    },
  ),
  yb = i({
    default: () => xb,
  });
B();
var bb = [`id`],
  xb = {
    __name: `FormInfo`,
    props: {
      id: {
        type: String,
        required: !1,
      },
    },
    setup(e) {
      return (t, n) => (
        A(),
        M(
          `div`,
          {
            class: `text-primary mt-1 text-xs`,
            id: e.id,
          },
          [z(t.$slots, `default`)],
          8,
          bb,
        )
      );
    },
  },
  Sb = i({
    default: () => Xb,
  });
B();
var Cb = {
    class: `py-4`,
  },
  wb = {
    class: `mx-auto`,
    "aria-label": `Progress`,
  },
  Tb = {
    role: `list`,
    class: `lg:border-dark-secondary overflow-hidden rounded-md lg:flex lg:rounded-none`,
  },
  Eb = [`onClick`],
  Db = {
    key: 0,
    class: `group`,
  },
  Ob = {
    class: `shrink-0`,
  },
  kb = {
    class: `bg-primary flex h-10 w-10 items-center justify-center`,
  },
  Ab = {
    class: `ltr:ml-4 rtl:mr-4 mt-0.5 flex min-w-0 flex-col`,
  },
  jb = {
    class: `text-xs font-semibold uppercase tracking-wide dark:text-gray-400`,
  },
  Mb = {
    key: 0,
    class: `text-darken-primary text-sm font-medium dark:text-gray-400`,
  },
  Nb = {
    key: 1,
    "aria-current": `step`,
  },
  Pb = {
    class: `shrink-0`,
  },
  Fb = {
    class: `text-white`,
  },
  Ib = {
    class: `ltr:ml-4 rtl:mr-4 mt-0.5 flex min-w-0 flex-col`,
  },
  Lb = {
    key: 2,
    class: `group`,
  },
  Rb = {
    class: `shrink-0`,
  },
  zb = {
    class: `border-dark-secondary flex h-10 w-10 items-center justify-center border-2`,
  },
  Bb = {
    class: `text-darken-primary dark:text-gray-400`,
  },
  Vb = {
    class: `ltr:ml-4 rtl:mr-4 mt-0.5 flex min-w-0 flex-col justify-items-center`,
  },
  Hb = {
    class: `text-darken-primary text-xs font-semibold uppercase tracking-wide dark:text-gray-400`,
  },
  Ub = {
    key: 0,
    class: `text-darken-primary text-sm font-medium dark:text-gray-400`,
  },
  Wb = {
    key: 3,
    class: `absolute inset-0 left-0 top-0 hidden w-3 lg:block`,
    "aria-hidden": `true`,
  },
  Gb = {
    class: `py-4`,
  },
  Kb = {
    class: `py-4`,
  },
  qb = {
    class: `flex justify-between pt-8`,
  },
  Jb = {
    key: 0,
  },
  Yb = {
    key: 1,
  },
  Xb = Object.assign(
    {
      name: `FormWizard`,
    },
    {
      props: {
        nextButtonText: {
          type: String,
          default: `Next`,
        },
        previousButtonText: {
          type: String,
          default: `Previous`,
        },
        finishButtonText: {
          type: String,
          default: `Finish`,
        },
      },
      emits: [`complete`],
      setup(e, { emit: t }) {
        let n = Te(),
          r = t,
          i = Ae({
            selectedIndex: 0,
            selectedTabError: !1,
            tabs: [],
            count: 0,
          });
        (ge(`TabsProvider`, i),
          ie(() => {
            n.default && (i.tabs = n.default().filter((e) => e.type.name === `TabContent`));
          }),
          Qe(() => {
            let e = i.tabs.findIndex((e) => e.props.hasOwnProperty(`is-selected`));
            i.selectedIndex = e === -1 ? 0 : e;
          }));
        let a = () => {
            i.selectedIndex !== 0 && ((i.selectedTabError = !1), --i.selectedIndex);
          },
          o = () => {
            l();
          },
          s = (e) => {
            if (e === !1) {
              i.selectedTabError = !0;
              return;
            }
            if (((i.selectedTabError = !1), i.selectedIndex === i.tabs.length - 1)) {
              r(`complete`);
              return;
            }
            (i.selectedIndex++, u());
          },
          c = (e) => {
            e !== i.selectedIndex && (e < i.selectedIndex ? a() : o());
          },
          l = () => {
            let e = i.tabs[i.selectedIndex].props;
            (e.hasOwnProperty(`before-change`) || s(!0),
              typeof e[`before-change`] != `function` && s(!0));
            let t = e[`before-change`]();
            f(t) ? t.then((e) => s(e)) : typeof t == `boolean` && s(t);
          },
          u = () => {
            let e = i.tabs[i.selectedIndex],
              t = e.props;
            t.hasOwnProperty(`after-load`) &&
              typeof t[`after-load`] == `function` &&
              e.props[`after-load`]();
          };
        return (t, n) => {
          let r = j(`BaseButton`),
            s = j(`ParentTransition`);
          return (
            A(),
            L(
              s,
              {
                appear: ``,
                visibility: !0,
              },
              {
                default: I(() => [
                  W(`div`, Cb, [z(t.$slots, `header`)]),
                  W(`div`, null, [
                    W(`nav`, wb, [
                      W(`ol`, Tb, [
                        (A(!0),
                        M(
                          ke,
                          null,
                          ae(
                            i.tabs,
                            (e, t) => (
                              A(),
                              M(
                                `li`,
                                {
                                  key: t,
                                  onClick: (e) => c(t),
                                  class: `relative cursor-pointer overflow-hidden lg:flex-1`,
                                },
                                [
                                  W(
                                    `div`,
                                    {
                                      class: O([
                                        t === 0 ? `rounded-t-md` : ``,
                                        t === i.tabs.length - 1 ? `rounded-b-md` : ``,
                                        `border-dark-secondary overflow-hidden`,
                                      ]),
                                    },
                                    [
                                      t < i.selectedIndex
                                        ? (A(),
                                          M(`a`, Db, [
                                            (n[0] ||= W(
                                              `span`,
                                              {
                                                class: `group-hover:bg-dark-secondary absolute left-0 top-0 h-full w-1 bg-transparent lg:bottom-0 lg:top-auto lg:h-1 lg:w-full`,
                                                "aria-hidden": `true`,
                                              },
                                              null,
                                              -1,
                                            )),
                                            W(
                                              `span`,
                                              {
                                                class: O([
                                                  t === 0 ? `` : `ltr:lg:pl-9 rtl:lg:pr-9`,
                                                  `flex items-start px-6 py-5 text-sm font-medium`,
                                                ]),
                                              },
                                              [
                                                W(`span`, Ob, [
                                                  W(`span`, kb, [
                                                    N(P(Ry), {
                                                      class: `h-6 w-6 text-white`,
                                                      "aria-hidden": `true`,
                                                    }),
                                                  ]),
                                                ]),
                                                W(`span`, Ab, [
                                                  W(`span`, jb, T(e.props.title), 1),
                                                  e.props.description
                                                    ? (A(),
                                                      M(`span`, Mb, T(e.props.description), 1))
                                                    : U(``, !0),
                                                ]),
                                              ],
                                              2,
                                            ),
                                          ]))
                                        : t === i.selectedIndex
                                          ? (A(),
                                            M(`a`, Nb, [
                                              W(
                                                `span`,
                                                {
                                                  class: O([
                                                    `bg-primary absolute left-0 top-0 h-full w-1 lg:bottom-0 lg:top-auto lg:h-1 lg:w-full`,
                                                    {
                                                      "bg-primary": !i.selectedTabError,
                                                      "bg-danger": i.selectedTabError,
                                                    },
                                                  ]),
                                                  "aria-hidden": `true`,
                                                },
                                                null,
                                                2,
                                              ),
                                              W(
                                                `span`,
                                                {
                                                  class: O([
                                                    t === 0 ? `` : `ltr:lg:pl-9 rtl:lg:pr-9`,
                                                    `flex items-start px-6 py-5 text-sm font-medium`,
                                                  ]),
                                                },
                                                [
                                                  W(`span`, Pb, [
                                                    W(
                                                      `span`,
                                                      {
                                                        class: O([
                                                          `flex h-10 w-10 items-center justify-center border-2`,
                                                          {
                                                            "border-primary bg-primary":
                                                              !i.selectedTabError,
                                                            "border-danger bg-danger":
                                                              i.selectedTabError,
                                                          },
                                                        ]),
                                                      },
                                                      [W(`span`, Fb, T(e.props.step || t + 1), 1)],
                                                      2,
                                                    ),
                                                  ]),
                                                  W(`span`, Ib, [
                                                    W(
                                                      `span`,
                                                      {
                                                        class: O([
                                                          `text-xs font-semibold uppercase tracking-wide`,
                                                          {
                                                            "text-primary dark:text-gray-400":
                                                              !i.selectedTabError,
                                                            "text-danger": i.selectedTabError,
                                                          },
                                                        ]),
                                                      },
                                                      T(e.props.title),
                                                      3,
                                                    ),
                                                    e.props.description
                                                      ? (A(),
                                                        M(
                                                          `span`,
                                                          {
                                                            key: 0,
                                                            class: O([
                                                              `text-sm font-medium`,
                                                              {
                                                                "text-darken-primary dark:text-gray-400":
                                                                  !i.selectedTabError,
                                                                "text-danger": i.selectedTabError,
                                                              },
                                                            ]),
                                                          },
                                                          T(e.props.description),
                                                          3,
                                                        ))
                                                      : U(``, !0),
                                                  ]),
                                                ],
                                                2,
                                              ),
                                            ]))
                                          : (A(),
                                            M(`a`, Lb, [
                                              (n[1] ||= W(
                                                `span`,
                                                {
                                                  class: `group-hover:bg-dark-secondary absolute left-0 top-0 h-full w-1 bg-transparent lg:bottom-0 lg:top-auto lg:h-1 lg:w-full`,
                                                  "aria-hidden": `true`,
                                                },
                                                null,
                                                -1,
                                              )),
                                              W(
                                                `span`,
                                                {
                                                  class: O([
                                                    t === 0 ? `` : `ltr:lg:pl-9 rtl:lg:pr-9`,
                                                    `flex items-start px-6 py-5 text-sm font-medium`,
                                                  ]),
                                                },
                                                [
                                                  W(`span`, Rb, [
                                                    W(`span`, zb, [
                                                      W(`span`, Bb, T(e.props.step || t + 1), 1),
                                                    ]),
                                                  ]),
                                                  W(`span`, Vb, [
                                                    W(`span`, Hb, T(e.props.title), 1),
                                                    e.props.description
                                                      ? (A(),
                                                        M(`span`, Ub, T(e.props.description), 1))
                                                      : U(``, !0),
                                                  ]),
                                                ],
                                                2,
                                              ),
                                            ])),
                                      t === 0 ? U(``, !0) : (A(), M(`div`, Wb)),
                                    ],
                                    2,
                                  ),
                                ],
                                8,
                                Eb,
                              )
                            ),
                          ),
                          128,
                        )),
                      ]),
                    ]),
                    W(`div`, Gb, [z(t.$slots, `default`)]),
                  ]),
                  W(`div`, Kb, [z(t.$slots, `footer`)]),
                  W(`div`, qb, [
                    W(`div`, null, [
                      i.selectedIndex > 0
                        ? (A(),
                          L(
                            r,
                            {
                              key: 0,
                              onClick: a,
                            },
                            {
                              default: I(() => [H(T(e.previousButtonText), 1)]),
                              _: 1,
                            },
                          ))
                        : U(``, !0),
                    ]),
                    W(`div`, null, [
                      N(
                        r,
                        {
                          onClick: o,
                        },
                        {
                          default: I(() => [
                            i.selectedIndex < i.tabs.length - 1
                              ? (A(), M(`span`, Jb, T(e.nextButtonText), 1))
                              : U(``, !0),
                            i.selectedIndex == i.tabs.length - 1
                              ? (A(), M(`span`, Yb, T(e.finishButtonText), 1))
                              : U(``, !0),
                          ]),
                          _: 1,
                        },
                      ),
                    ]),
                  ]),
                ]),
                _: 3,
              },
            )
          );
        };
      },
    },
  ),
  Zb = i({
    default: () => lx,
  });
B();
var Qb = [`src`],
  $b = {
    class: `flex justify-center space-x-4`,
  },
  ex = [`name`, `id`],
  tx = {
    key: 0,
    class: `flex justify-center space-x-4`,
  },
  nx = {
    class: `flex space-x-2`,
  },
  rx = {
    class: `flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-gray-800 opacity-50`,
  },
  ix = [`name`, `id`],
  ax = {
    key: 0,
    class: `fas fa-times text-gray-200`,
  },
  ox = {
    key: 0,
    class: `flex space-x-2`,
  },
  sx = {
    key: 0,
    class: `italic`,
  },
  cx = [`src`],
  lx = Object.assign(
    {
      name: `ImageUpload`,
    },
    {
      props: {
        design: {
          type: String,
          default: `traditional`,
        },
        shape: {
          type: String,
          default: `rectangle`,
        },
        objectFit: {
          type: Boolean,
          default: !0,
        },
        label: {
          type: String,
          default: `Image`,
        },
        showLabel: {
          type: Boolean,
          default: !1,
        },
        src: {
          type: String,
          default: ``,
        },
        dark: {
          type: Boolean,
          default: !1,
        },
        uploadPath: {
          type: String,
          required: !0,
        },
        removePath: {
          type: String,
          default: ``,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
        recommendedSize: {
          type: String,
          default: ``,
        },
        headers: {
          type: Object,
          default: () => ({}),
        },
      },
      emits: [`uploaded`, `removed`],
      setup(e, { emit: t }) {
        let n = $e(),
          r = u(),
          i = R(`$trans`),
          a = t,
          o = e,
          s = V(() => n.getters[`config/config`](`system.postMaxSize`)),
          c = Ae({
            source: null,
            uniqueId: ``,
          }),
          l = F([]),
          d = F(!1);
        F(!1);
        let f = (e) => {
            let t = e.target.files || e.dataTransfer.files;
            if (!/(\.jpg|\.jpeg|\.webp|\.png|\.gif)$/i.exec(t[0].name)) {
              r.error(i(`general.errors.file_not_supported`));
              return;
            }
            t.length && p(t[0]);
          },
          p = (e) => {
            let t = new FileReader();
            ((t.onload = (e) => {
              c.source = e.target.result;
            }),
              t.readAsDataURL(e));
          },
          m = () => {
            ((l.value = []), (c.source = null));
          },
          h = async () => {
            if (l.value.files[0].size > s.value) {
              r.error(i(`general.errors.file_too_large`));
              return;
            }
            d.value = !0;
            let e = new FormData();
            (e.append(`image`, l.value.files[0]),
              await n
                .dispatch(`image/upload`, {
                  path: o.uploadPath,
                  data: e,
                  headers: o.headers,
                })
                .then((e) => {
                  ((d.value = !1), (c.source = null), a(`uploaded`, e.image));
                })
                .catch((e) => {
                  d.value = !1;
                }));
          },
          g = async () => {
            ((d.value = !0),
              await n
                .dispatch(`image/remove`, {
                  path: o.removePath,
                  headers: o.headers,
                })
                .then((e) => {
                  ((d.value = !1), a(`removed`, e.image));
                })
                .catch((e) => {
                  d.value = !1;
                }));
          };
        return (
          Qe(() => {
            c.uniqueId = o.id || Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`BaseButton`),
              a = j(`ImageLabel`),
              o = j(`BaseLoader`),
              s = ve(`tooltip`);
            return (
              A(),
              L(
                o,
                {
                  "is-loading": d.value,
                },
                {
                  default: I(() => [
                    e.design == `traditional`
                      ? (A(),
                        M(
                          ke,
                          {
                            key: 0,
                          },
                          [
                            W(
                              `div`,
                              {
                                class: O([
                                  `flex h-64 w-full justify-center rounded-lg border border-gray-100 p-4 dark:border-gray-700`,
                                  {
                                    "bg-gray-800": e.dark,
                                  },
                                ]),
                              },
                              [
                                c.source || e.src
                                  ? (A(),
                                    M(
                                      `img`,
                                      {
                                        key: 0,
                                        src: c.source || e.src,
                                        class: `object-scale-down`,
                                      },
                                      null,
                                      8,
                                      Qb,
                                    ))
                                  : U(``, !0),
                              ],
                              2,
                            ),
                            Re(
                              W(
                                `div`,
                                $b,
                                [
                                  N(
                                    r,
                                    {
                                      as: `label`,
                                    },
                                    {
                                      default: I(() => [
                                        (n[1] ||= W(
                                          `i`,
                                          {
                                            class: `fas fa-upload mr-2`,
                                          },
                                          null,
                                          -1,
                                        )),
                                        H(
                                          ` ` +
                                            T(
                                              e.src
                                                ? P(i)(`global.change`, {
                                                    attribute: e.label,
                                                  })
                                                : P(i)(`general.upload`),
                                            ) +
                                            ` `,
                                          1,
                                        ),
                                        W(
                                          `input`,
                                          {
                                            ref_key: `file`,
                                            ref: l,
                                            type: `file`,
                                            onChange: f,
                                            name: c.uniqueId,
                                            id: c.uniqueId,
                                            class: `hidden`,
                                          },
                                          null,
                                          40,
                                          ex,
                                        ),
                                      ]),
                                      _: 1,
                                    },
                                  ),
                                  e.src
                                    ? (A(),
                                      L(
                                        r,
                                        {
                                          key: 0,
                                          design: `danger`,
                                          onClick: g,
                                        },
                                        {
                                          default: I(() => [H(T(P(i)(`general.remove`)), 1)]),
                                          _: 1,
                                        },
                                      ))
                                    : U(``, !0),
                                ],
                                512,
                              ),
                              [[Ee, !e.disabled && !c.source]],
                            ),
                            c.source
                              ? (A(),
                                M(`div`, tx, [
                                  N(
                                    r,
                                    {
                                      onClick: h,
                                    },
                                    {
                                      default: I(() => [
                                        H(
                                          T(
                                            P(i)(`global.upload`, {
                                              attribute: e.label || P(i)(`general.image`),
                                            }),
                                          ),
                                          1,
                                        ),
                                      ]),
                                      _: 1,
                                    },
                                  ),
                                  N(
                                    r,
                                    {
                                      design: `danger`,
                                      onClick: m,
                                    },
                                    {
                                      default: I(() => [H(T(P(i)(`general.cancel`)), 1)]),
                                      _: 1,
                                    },
                                  ),
                                ]))
                              : U(``, !0),
                          ],
                          64,
                        ))
                      : U(``, !0),
                    e.design == `modern`
                      ? (A(),
                        M(
                          ke,
                          {
                            key: 1,
                          },
                          [
                            e.showLabel
                              ? (A(),
                                L(
                                  a,
                                  {
                                    key: 0,
                                    label: e.label,
                                    size: e.recommendedSize,
                                  },
                                  null,
                                  8,
                                  [`label`, `size`],
                                ))
                              : U(``, !0),
                            W(
                              `div`,
                              {
                                class: O([
                                  `group relative flex w-full items-center justify-center border border-gray-200 dark:border-gray-700`,
                                  {
                                    "aspect-square": e.shape == `circle`,
                                    "aspect-video": e.shape == `rectangle`,
                                    "h-full": e.objectFit == 1 || e.shape == `circle`,
                                    "h-64 px-2 py-4": e.objectFit == 0 && e.shape != `circle`,
                                    "rounded-xl": e.objectFit == 0,
                                    "rounded-full": e.shape == `circle`,
                                    "bg-gray-800": e.dark,
                                  },
                                ]),
                              },
                              [
                                W(
                                  `div`,
                                  {
                                    class: O([
                                      `absolute z-10 opacity-0 group-hover:opacity-100`,
                                      {
                                        "inset-0 flex h-full w-full items-center justify-center":
                                          e.shape == `circle`,
                                        "right-3 top-2": e.shape == `rectangle`,
                                      },
                                    ]),
                                  },
                                  [
                                    Re(
                                      W(
                                        `div`,
                                        nx,
                                        [
                                          Re(
                                            (A(),
                                            M(`label`, rx, [
                                              W(
                                                `input`,
                                                {
                                                  ref_key: `file`,
                                                  ref: l,
                                                  type: `file`,
                                                  onChange: f,
                                                  name: c.uniqueId,
                                                  id: c.uniqueId,
                                                  class: `hidden`,
                                                },
                                                null,
                                                40,
                                                ix,
                                              ),
                                              (n[2] ||= W(
                                                `i`,
                                                {
                                                  class: `fas fa-edit text-gray-200`,
                                                },
                                                null,
                                                -1,
                                              )),
                                            ])),
                                            [
                                              [
                                                s,
                                                e.src
                                                  ? P(i)(`global.change`, {
                                                      attribute: e.label,
                                                    })
                                                  : P(i)(`general.upload`),
                                              ],
                                            ],
                                          ),
                                          Re(
                                            (A(),
                                            M(
                                              `div`,
                                              {
                                                class: `flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-gray-800 opacity-50`,
                                                onClick: g,
                                              },
                                              [e.src ? (A(), M(`i`, ax)) : U(``, !0)],
                                            )),
                                            [[s, P(i)(`general.remove`)]],
                                          ),
                                        ],
                                        512,
                                      ),
                                      [[Ee, !e.disabled && !c.source]],
                                    ),
                                    c.source
                                      ? (A(),
                                        M(`div`, ox, [
                                          Re(
                                            (A(),
                                            M(
                                              `div`,
                                              {
                                                class: `flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-gray-800 opacity-50`,
                                                onClick: h,
                                              },
                                              [
                                                ...(n[3] ||= [
                                                  W(
                                                    `i`,
                                                    {
                                                      class: `fas fa-save text-gray-200`,
                                                    },
                                                    null,
                                                    -1,
                                                  ),
                                                ]),
                                              ],
                                            )),
                                            [
                                              [
                                                s,
                                                P(i)(`global.save`, {
                                                  attribute: e.label,
                                                }),
                                              ],
                                            ],
                                          ),
                                          Re(
                                            (A(),
                                            M(
                                              `div`,
                                              {
                                                class: `flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-gray-800 opacity-50`,
                                                onClick: (n[0] ||= (...e) =>
                                                  t.cancel && t.cancel(...e)),
                                              },
                                              [
                                                ...(n[4] ||= [
                                                  W(
                                                    `i`,
                                                    {
                                                      class: `fas fa-times text-gray-200`,
                                                    },
                                                    null,
                                                    -1,
                                                  ),
                                                ]),
                                              ],
                                            )),
                                            [[s, P(i)(`general.cancel`)]],
                                          ),
                                        ]))
                                      : U(``, !0),
                                  ],
                                  2,
                                ),
                                !c.source && !e.src
                                  ? (A(),
                                    M(
                                      `div`,
                                      sx,
                                      T(
                                        P(i)(`global.upload`, {
                                          attribute: e.label || P(i)(`general.image`),
                                        }),
                                      ),
                                      1,
                                    ))
                                  : U(``, !0),
                                c.source || e.src
                                  ? (A(),
                                    M(
                                      `img`,
                                      {
                                        key: 1,
                                        src: c.source || e.src,
                                        class: O([`max-h-full object-contain`, t.$attrs.class]),
                                      },
                                      null,
                                      10,
                                      cx,
                                    ))
                                  : U(``, !0),
                              ],
                              2,
                            ),
                          ],
                          64,
                        ))
                      : U(``, !0),
                  ]),
                  _: 1,
                },
                8,
                [`is-loading`],
              )
            );
          }
        );
      },
    },
  ),
  ux = i({
    default: () => dx,
  });
function dx() {
  return aT.apply(null, arguments);
}
function fx(e) {
  aT = e;
}
function px(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === `[object Array]`;
}
function mx(e) {
  return e != null && Object.prototype.toString.call(e) === `[object Object]`;
}
function hx(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function gx(e) {
  if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(e).length === 0;
  for (var t in e) if (hx(e, t)) return !1;
  return !0;
}
function _x(e) {
  return e === void 0;
}
function vx(e) {
  return typeof e == `number` || Object.prototype.toString.call(e) === `[object Number]`;
}
function yx(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === `[object Date]`;
}
function bx(e, t) {
  var n = [],
    r,
    i = e.length;
  for (r = 0; r < i; ++r) n.push(t(e[r], r));
  return n;
}
function xx(e, t) {
  for (var n in t) hx(t, n) && (e[n] = t[n]);
  return (
    hx(t, `toString`) && (e.toString = t.toString),
    hx(t, `valueOf`) && (e.valueOf = t.valueOf),
    e
  );
}
function Sx(e, t, n, r) {
  return FC(e, t, n, r, !0).utc();
}
function Cx() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1,
  };
}
function wx(e) {
  return ((e._pf ??= Cx()), e._pf);
}
function Tx(e) {
  var t = null,
    n = !1,
    r = e._d && !isNaN(e._d.getTime());
  if (
    (r &&
      ((t = wx(e)),
      (n = oT.call(t.parsedDateParts, function (e) {
        return e != null;
      })),
      (r =
        t.overflow < 0 &&
        !t.empty &&
        !t.invalidEra &&
        !t.invalidMonth &&
        !t.invalidWeekday &&
        !t.weekdayMismatch &&
        !t.nullInput &&
        !t.invalidFormat &&
        !t.userInvalidated &&
        (!t.meridiem || (t.meridiem && n))),
      e._strict &&
        (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)),
    Object.isFrozen == null || !Object.isFrozen(e))
  )
    e._isValid = r;
  else return r;
  return e._isValid;
}
function Ex(e) {
  var t = Sx(NaN);
  return (e == null ? (wx(t).userInvalidated = !0) : xx(wx(t), e), t);
}
function Dx(e, t) {
  var n,
    r,
    i,
    a = sT.length;
  if (
    (_x(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject),
    _x(t._i) || (e._i = t._i),
    _x(t._f) || (e._f = t._f),
    _x(t._l) || (e._l = t._l),
    _x(t._strict) || (e._strict = t._strict),
    _x(t._tzm) || (e._tzm = t._tzm),
    _x(t._isUTC) || (e._isUTC = t._isUTC),
    _x(t._offset) || (e._offset = t._offset),
    _x(t._pf) || (e._pf = wx(t)),
    _x(t._locale) || (e._locale = t._locale),
    a > 0)
  )
    for (n = 0; n < a; n++) ((r = sT[n]), (i = t[r]), _x(i) || (e[r] = i));
  return e;
}
function Ox(e) {
  (Dx(this, e),
    (this._d = new Date(e._d == null ? NaN : e._d.getTime())),
    this.isValid() || (this._d = new Date(NaN)),
    cT === !1 && ((cT = !0), dx.updateOffset(this), (cT = !1)));
}
function kx(e) {
  return e instanceof Ox || (e != null && e._isAMomentObject != null);
}
function Ax(e) {
  dx.suppressDeprecationWarnings === !1 &&
    typeof console < `u` &&
    console.warn &&
    console.warn(`Deprecation warning: ` + e);
}
function jx(e, t) {
  var n = !0;
  return xx(function () {
    if ((dx.deprecationHandler != null && dx.deprecationHandler(null, e), n)) {
      var r = [],
        i,
        a,
        o,
        s = arguments.length;
      for (a = 0; a < s; a++) {
        if (((i = ``), typeof arguments[a] == `object`)) {
          for (o in ((i +=
            `
[` +
            a +
            `] `),
          arguments[0]))
            hx(arguments[0], o) && (i += o + `: ` + arguments[0][o] + `, `);
          i = i.slice(0, -2);
        } else i = arguments[a];
        r.push(i);
      }
      (Ax(
        e +
          `
Arguments: ` +
          Array.prototype.slice.call(r).join(``) +
          `
` +
          Error().stack,
      ),
        (n = !1));
    }
    return t.apply(this, arguments);
  }, t);
}
function Mx(e, t) {
  (dx.deprecationHandler != null && dx.deprecationHandler(e, t), lT[e] || (Ax(t), (lT[e] = !0)));
}
function Nx(e) {
  return (
    (typeof Function < `u` && e instanceof Function) ||
    Object.prototype.toString.call(e) === `[object Function]`
  );
}
function Px(e) {
  var t, n;
  for (n in e) hx(e, n) && ((t = e[n]), Nx(t) ? (this[n] = t) : (this[`_` + n] = t));
  ((this._config = e),
    (this._dayOfMonthOrdinalParseLenient = RegExp(
      (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + `|\\d{1,2}`,
    )));
}
function Fx(e, t) {
  var n = xx({}, e),
    r;
  for (r in t)
    hx(t, r) &&
      (mx(e[r]) && mx(t[r])
        ? ((n[r] = {}), xx(n[r], e[r]), xx(n[r], t[r]))
        : t[r] == null
          ? delete n[r]
          : (n[r] = t[r]));
  for (r in e) hx(e, r) && !hx(t, r) && mx(e[r]) && (n[r] = xx({}, n[r]));
  return n;
}
function Ix(e) {
  e != null && this.set(e);
}
function Lx(e, t, n) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return Nx(r) ? r.call(t, n) : r;
}
function Rx(e, t, n) {
  var r = `` + Math.abs(e),
    i = t - r.length;
  return (e >= 0 ? (n ? `+` : ``) : `-`) + (10 ** Math.max(0, i)).toString().substr(1) + r;
}
function zx(e, t, n, r) {
  var i = r;
  (typeof r == `string` &&
    (i = function () {
      return this[r]();
    }),
    e && (hT[e] = i),
    t &&
      (hT[t[0]] = function () {
        return Rx(i.apply(this, arguments), t[1], t[2]);
      }),
    n &&
      (hT[n] = function () {
        return this.localeData().ordinal(i.apply(this, arguments), e);
      }));
}
function Bx(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, ``) : e.replace(/\\/g, ``);
}
function Vx(e) {
  var t = e.match(fT),
    n,
    r;
  for (n = 0, r = t.length; n < r; n++) hT[t[n]] ? (t[n] = hT[t[n]]) : (t[n] = Bx(t[n]));
  return function (n) {
    var i = ``,
      a;
    for (a = 0; a < r; a++) i += Nx(t[a]) ? t[a].call(n, e) : t[a];
    return i;
  };
}
function Hx(e, t) {
  return e.isValid()
    ? ((t = Ux(t, e.localeData())), (mT[t] = mT[t] || Vx(t)), mT[t](e))
    : e.localeData().invalidDate();
}
function Ux(e, t) {
  var n = 5;
  function r(e) {
    return t.longDateFormat(e) || e;
  }
  for (pT.lastIndex = 0; n >= 0 && pT.test(e);) ((e = e.replace(pT, r)), (pT.lastIndex = 0), --n);
  return e;
}
function Wx(e) {
  var t = this._longDateFormat[e],
    n = this._longDateFormat[e.toUpperCase()];
  return t || !n
    ? t
    : ((this._longDateFormat[e] = n
        .match(fT)
        .map(function (e) {
          return e === `MMMM` || e === `MM` || e === `DD` || e === `dddd` ? e.slice(1) : e;
        })
        .join(``)),
      this._longDateFormat[e]);
}
function Gx() {
  return this._invalidDate;
}
function Kx(e) {
  return this._ordinal.replace(`%d`, e);
}
function qx(e, t, n, r) {
  var i = this._relativeTime[n];
  return Nx(i) ? i(e, t, n, r) : i.replace(/%d/i, e);
}
function Jx(e, t) {
  var n = this._relativeTime[e > 0 ? `future` : `past`];
  return Nx(n) ? n(t) : n.replace(/%s/i, t);
}
function Yx(e) {
  return typeof e == `string` ? xT[e] || xT[e.toLowerCase()] : void 0;
}
function Xx(e) {
  var t = {},
    n,
    r;
  for (r in e) hx(e, r) && ((n = Yx(r)), n && (t[n] = e[r]));
  return t;
}
function Zx(e) {
  var t = [],
    n;
  for (n in e)
    hx(e, n) &&
      t.push({
        unit: n,
        priority: ST[n],
      });
  return (
    t.sort(function (e, t) {
      return e.priority - t.priority;
    }),
    t
  );
}
function Qx(e, t, n) {
  HT[e] = Nx(t)
    ? t
    : function (e, r) {
        return e && n ? n : t;
      };
}
function $x(e, t) {
  return hx(HT, e) ? HT[e](t._strict, t._locale) : new RegExp(eS(e));
}
function eS(e) {
  return tS(
    e.replace(`\\`, ``).replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, r, i) {
      return t || n || r || i;
    }),
  );
}
function tS(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, `\\$&`);
}
function nS(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function rS(e) {
  var t = +e,
    n = 0;
  return (t !== 0 && isFinite(t) && (n = nS(t)), n);
}
function iS(e, t) {
  var n,
    r = t,
    i;
  for (
    typeof e == `string` && (e = [e]),
      vx(t) &&
        (r = function (e, n) {
          n[t] = rS(e);
        }),
      i = e.length,
      n = 0;
    n < i;
    n++
  )
    UT[e[n]] = r;
}
function aS(e, t) {
  iS(e, function (e, n, r, i) {
    ((r._w = r._w || {}), t(e, r._w, r, i));
  });
}
function oS(e, t, n) {
  t != null && hx(UT, e) && UT[e](t, n._a, n, e);
}
function sS(e) {
  return (e % 4 == 0 && e % 100 != 0) || e % 400 == 0;
}
function cS(e) {
  return sS(e) ? 366 : 365;
}
function lS() {
  return sS(this.year());
}
function uS(e, t) {
  return function (n) {
    return n == null ? dS(this, e) : (fS(this, e, n), dx.updateOffset(this, t), this);
  };
}
function dS(e, t) {
  if (!e.isValid()) return NaN;
  var n = e._d,
    r = e._isUTC;
  switch (t) {
    case `Milliseconds`:
      return r ? n.getUTCMilliseconds() : n.getMilliseconds();
    case `Seconds`:
      return r ? n.getUTCSeconds() : n.getSeconds();
    case `Minutes`:
      return r ? n.getUTCMinutes() : n.getMinutes();
    case `Hours`:
      return r ? n.getUTCHours() : n.getHours();
    case `Date`:
      return r ? n.getUTCDate() : n.getDate();
    case `Day`:
      return r ? n.getUTCDay() : n.getDay();
    case `Month`:
      return r ? n.getUTCMonth() : n.getMonth();
    case `FullYear`:
      return r ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function fS(e, t, n) {
  var r, i, a, o, s;
  if (!(!e.isValid() || isNaN(n))) {
    switch (((r = e._d), (i = e._isUTC), t)) {
      case `Milliseconds`:
        i ? r.setUTCMilliseconds(n) : r.setMilliseconds(n);
        return;
      case `Seconds`:
        i ? r.setUTCSeconds(n) : r.setSeconds(n);
        return;
      case `Minutes`:
        i ? r.setUTCMinutes(n) : r.setMinutes(n);
        return;
      case `Hours`:
        i ? r.setUTCHours(n) : r.setHours(n);
        return;
      case `Date`:
        i ? r.setUTCDate(n) : r.setDate(n);
        return;
      case `FullYear`:
        break;
      default:
        return;
    }
    ((a = n),
      (o = e.month()),
      (s = e.date()),
      (s = s === 29 && o === 1 && !sS(a) ? 28 : s),
      i ? r.setUTCFullYear(a, o, s) : r.setFullYear(a, o, s));
  }
}
function pS(e) {
  return ((e = Yx(e)), Nx(this[e]) ? this[e]() : this);
}
function mS(e, t) {
  if (typeof e == `object`) {
    e = Xx(e);
    var n = Zx(e),
      r,
      i = n.length;
    for (r = 0; r < i; r++) this[n[r].unit](e[n[r].unit]);
  } else if (((e = Yx(e)), Nx(this[e]))) return this[e](t);
  return this;
}
function hS(e, t) {
  return ((e % t) + t) % t;
}
function gS(e, t) {
  if (isNaN(e) || isNaN(t)) return NaN;
  var n = hS(t, 12);
  return ((e += (t - n) / 12), n === 1 ? (sS(e) ? 29 : 28) : 31 - ((n % 7) % 2));
}
function _S(e, t) {
  return e
    ? px(this._months)
      ? this._months[e.month()]
      : this._months[(this._months.isFormat || rE).test(t) ? `format` : `standalone`][e.month()]
    : px(this._months)
      ? this._months
      : this._months.standalone;
}
function vS(e, t) {
  return e
    ? px(this._monthsShort)
      ? this._monthsShort[e.month()]
      : this._monthsShort[rE.test(t) ? `format` : `standalone`][e.month()]
    : px(this._monthsShort)
      ? this._monthsShort
      : this._monthsShort.standalone;
}
function yS(e, t, n) {
  var r,
    i,
    a,
    o = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (
      this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0;
      r < 12;
      ++r
    )
      ((a = Sx([2e3, r])),
        (this._shortMonthsParse[r] = this.monthsShort(a, ``).toLocaleLowerCase()),
        (this._longMonthsParse[r] = this.months(a, ``).toLocaleLowerCase()));
  return n
    ? t === `MMM`
      ? ((i = eE.call(this._shortMonthsParse, o)), i === -1 ? null : i)
      : ((i = eE.call(this._longMonthsParse, o)), i === -1 ? null : i)
    : t === `MMM`
      ? ((i = eE.call(this._shortMonthsParse, o)),
        i === -1 ? ((i = eE.call(this._longMonthsParse, o)), i === -1 ? null : i) : i)
      : ((i = eE.call(this._longMonthsParse, o)),
        i === -1 ? ((i = eE.call(this._shortMonthsParse, o)), i === -1 ? null : i) : i);
}
function bS(e, t, n) {
  var r, i, a;
  if (this._monthsParseExact) return yS.call(this, e, t, n);
  for (
    this._monthsParse ||
      ((this._monthsParse = []), (this._longMonthsParse = []), (this._shortMonthsParse = [])),
      r = 0;
    r < 12;
    r++
  )
    if (
      ((i = Sx([2e3, r])),
      n &&
        !this._longMonthsParse[r] &&
        ((this._longMonthsParse[r] = RegExp(`^` + this.months(i, ``).replace(`.`, ``) + `$`, `i`)),
        (this._shortMonthsParse[r] = RegExp(
          `^` + this.monthsShort(i, ``).replace(`.`, ``) + `$`,
          `i`,
        ))),
      !n &&
        !this._monthsParse[r] &&
        ((a = `^` + this.months(i, ``) + `|^` + this.monthsShort(i, ``)),
        (this._monthsParse[r] = new RegExp(a.replace(`.`, ``), `i`))),
      (n && t === `MMMM` && this._longMonthsParse[r].test(e)) ||
        (n && t === `MMM` && this._shortMonthsParse[r].test(e)) ||
        (!n && this._monthsParse[r].test(e)))
    )
      return r;
}
function xS(e, t) {
  if (!e.isValid()) return e;
  if (typeof t == `string`) {
    if (/^\d+$/.test(t)) t = rS(t);
    else if (((t = e.localeData().monthsParse(t)), !vx(t))) return e;
  }
  var n = t,
    r = e.date();
  return (
    (r = r < 29 ? r : Math.min(r, gS(e.year(), n))),
    e._isUTC ? e._d.setUTCMonth(n, r) : e._d.setMonth(n, r),
    e
  );
}
function SS(e) {
  return e == null ? dS(this, `Month`) : (xS(this, e), dx.updateOffset(this, !0), this);
}
function CS() {
  return gS(this.year(), this.month());
}
function wS(e) {
  return this._monthsParseExact
    ? (hx(this, `_monthsRegex`) || ES.call(this),
      e ? this._monthsShortStrictRegex : this._monthsShortRegex)
    : (hx(this, `_monthsShortRegex`) || (this._monthsShortRegex = iE),
      this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function TS(e) {
  return this._monthsParseExact
    ? (hx(this, `_monthsRegex`) || ES.call(this), e ? this._monthsStrictRegex : this._monthsRegex)
    : (hx(this, `_monthsRegex`) || (this._monthsRegex = aE),
      this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function ES() {
  function e(e, t) {
    return t.length - e.length;
  }
  var t = [],
    n = [],
    r = [],
    i,
    a,
    o,
    s;
  for (i = 0; i < 12; i++)
    ((a = Sx([2e3, i])),
      (o = tS(this.monthsShort(a, ``))),
      (s = tS(this.months(a, ``))),
      t.push(o),
      n.push(s),
      r.push(s),
      r.push(o));
  (t.sort(e),
    n.sort(e),
    r.sort(e),
    (this._monthsRegex = RegExp(`^(` + r.join(`|`) + `)`, `i`)),
    (this._monthsShortRegex = this._monthsRegex),
    (this._monthsStrictRegex = RegExp(`^(` + n.join(`|`) + `)`, `i`)),
    (this._monthsShortStrictRegex = RegExp(`^(` + t.join(`|`) + `)`, `i`)));
}
function DS(e, t, n, r, i, a, o) {
  var s;
  return (
    e < 100 && e >= 0
      ? ((s = new Date(e + 400, t, n, r, i, a, o)), isFinite(s.getFullYear()) && s.setFullYear(e))
      : (s = new Date(e, t, n, r, i, a, o)),
    s
  );
}
function OS(e) {
  var t, n;
  return (
    e < 100 && e >= 0
      ? ((n = Array.prototype.slice.call(arguments)),
        (n[0] = e + 400),
        (t = new Date(Date.UTC.apply(null, n))),
        isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e))
      : (t = new Date(Date.UTC.apply(null, arguments))),
    t
  );
}
function kS(e, t, n) {
  var r = 7 + t - n;
  return -((7 + OS(e, 0, r).getUTCDay() - t) % 7) + r - 1;
}
function AS(e, t, n, r, i) {
  var a = (7 + n - r) % 7,
    o = kS(e, r, i),
    s = 1 + 7 * (t - 1) + a + o,
    c,
    l;
  return (
    s <= 0
      ? ((c = e - 1), (l = cS(c) + s))
      : s > cS(e)
        ? ((c = e + 1), (l = s - cS(e)))
        : ((c = e), (l = s)),
    {
      year: c,
      dayOfYear: l,
    }
  );
}
function jS(e, t, n) {
  var r = kS(e.year(), t, n),
    i = Math.floor((e.dayOfYear() - r - 1) / 7) + 1,
    a,
    o;
  return (
    i < 1
      ? ((o = e.year() - 1), (a = i + MS(o, t, n)))
      : i > MS(e.year(), t, n)
        ? ((a = i - MS(e.year(), t, n)), (o = e.year() + 1))
        : ((o = e.year()), (a = i)),
    {
      week: a,
      year: o,
    }
  );
}
function MS(e, t, n) {
  var r = kS(e, t, n),
    i = kS(e + 1, t, n);
  return (cS(e) - r + i) / 7;
}
function NS(e) {
  return jS(e, this._week.dow, this._week.doy).week;
}
function PS() {
  return this._week.dow;
}
function FS() {
  return this._week.doy;
}
function IS(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, `d`);
}
function LS(e) {
  var t = jS(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, `d`);
}
function RS(e, t) {
  return typeof e == `string`
    ? isNaN(e)
      ? ((e = t.weekdaysParse(e)), typeof e == `number` ? e : null)
      : parseInt(e, 10)
    : e;
}
function zS(e, t) {
  return typeof e == `string` ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function BS(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
function VS(e, t) {
  var n = px(this._weekdays)
    ? this._weekdays
    : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? `format` : `standalone`];
  return e === !0 ? BS(n, this._week.dow) : e ? n[e.day()] : n;
}
function HS(e) {
  return e === !0
    ? BS(this._weekdaysShort, this._week.dow)
    : e
      ? this._weekdaysShort[e.day()]
      : this._weekdaysShort;
}
function US(e) {
  return e === !0
    ? BS(this._weekdaysMin, this._week.dow)
    : e
      ? this._weekdaysMin[e.day()]
      : this._weekdaysMin;
}
function WS(e, t, n) {
  var r,
    i,
    a,
    o = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (
      this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0;
      r < 7;
      ++r
    )
      ((a = Sx([2e3, 1]).day(r)),
        (this._minWeekdaysParse[r] = this.weekdaysMin(a, ``).toLocaleLowerCase()),
        (this._shortWeekdaysParse[r] = this.weekdaysShort(a, ``).toLocaleLowerCase()),
        (this._weekdaysParse[r] = this.weekdays(a, ``).toLocaleLowerCase()));
  return n
    ? t === `dddd`
      ? ((i = eE.call(this._weekdaysParse, o)), i === -1 ? null : i)
      : t === `ddd`
        ? ((i = eE.call(this._shortWeekdaysParse, o)), i === -1 ? null : i)
        : ((i = eE.call(this._minWeekdaysParse, o)), i === -1 ? null : i)
    : t === `dddd`
      ? ((i = eE.call(this._weekdaysParse, o)),
        i !== -1 || ((i = eE.call(this._shortWeekdaysParse, o)), i !== -1)
          ? i
          : ((i = eE.call(this._minWeekdaysParse, o)), i === -1 ? null : i))
      : t === `ddd`
        ? ((i = eE.call(this._shortWeekdaysParse, o)),
          i !== -1 || ((i = eE.call(this._weekdaysParse, o)), i !== -1)
            ? i
            : ((i = eE.call(this._minWeekdaysParse, o)), i === -1 ? null : i))
        : ((i = eE.call(this._minWeekdaysParse, o)),
          i !== -1 || ((i = eE.call(this._weekdaysParse, o)), i !== -1)
            ? i
            : ((i = eE.call(this._shortWeekdaysParse, o)), i === -1 ? null : i));
}
function GS(e, t, n) {
  var r, i, a;
  if (this._weekdaysParseExact) return WS.call(this, e, t, n);
  for (
    this._weekdaysParse ||
      ((this._weekdaysParse = []),
      (this._minWeekdaysParse = []),
      (this._shortWeekdaysParse = []),
      (this._fullWeekdaysParse = [])),
      r = 0;
    r < 7;
    r++
  )
    if (
      ((i = Sx([2e3, 1]).day(r)),
      n &&
        !this._fullWeekdaysParse[r] &&
        ((this._fullWeekdaysParse[r] = RegExp(
          `^` + this.weekdays(i, ``).replace(`.`, `\\.?`) + `$`,
          `i`,
        )),
        (this._shortWeekdaysParse[r] = RegExp(
          `^` + this.weekdaysShort(i, ``).replace(`.`, `\\.?`) + `$`,
          `i`,
        )),
        (this._minWeekdaysParse[r] = RegExp(
          `^` + this.weekdaysMin(i, ``).replace(`.`, `\\.?`) + `$`,
          `i`,
        ))),
      this._weekdaysParse[r] ||
        ((a =
          `^` +
          this.weekdays(i, ``) +
          `|^` +
          this.weekdaysShort(i, ``) +
          `|^` +
          this.weekdaysMin(i, ``)),
        (this._weekdaysParse[r] = new RegExp(a.replace(`.`, ``), `i`))),
      (n && t === `dddd` && this._fullWeekdaysParse[r].test(e)) ||
        (n && t === `ddd` && this._shortWeekdaysParse[r].test(e)) ||
        (n && t === `dd` && this._minWeekdaysParse[r].test(e)) ||
        (!n && this._weekdaysParse[r].test(e)))
    )
      return r;
}
function KS(e) {
  if (!this.isValid()) return e == null ? NaN : this;
  var t = dS(this, `Day`);
  return e == null ? t : ((e = RS(e, this.localeData())), this.add(e - t, `d`));
}
function qS(e) {
  if (!this.isValid()) return e == null ? NaN : this;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, `d`);
}
function JS(e) {
  if (!this.isValid()) return e == null ? NaN : this;
  if (e != null) {
    var t = zS(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else return this.day() || 7;
}
function YS(e) {
  return this._weekdaysParseExact
    ? (hx(this, `_weekdaysRegex`) || QS.call(this),
      e ? this._weekdaysStrictRegex : this._weekdaysRegex)
    : (hx(this, `_weekdaysRegex`) || (this._weekdaysRegex = uE),
      this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function XS(e) {
  return this._weekdaysParseExact
    ? (hx(this, `_weekdaysRegex`) || QS.call(this),
      e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
    : (hx(this, `_weekdaysShortRegex`) || (this._weekdaysShortRegex = dE),
      this._weekdaysShortStrictRegex && e
        ? this._weekdaysShortStrictRegex
        : this._weekdaysShortRegex);
}
function ZS(e) {
  return this._weekdaysParseExact
    ? (hx(this, `_weekdaysRegex`) || QS.call(this),
      e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
    : (hx(this, `_weekdaysMinRegex`) || (this._weekdaysMinRegex = fE),
      this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function QS() {
  function e(e, t) {
    return t.length - e.length;
  }
  var t = [],
    n = [],
    r = [],
    i = [],
    a,
    o,
    s,
    c,
    l;
  for (a = 0; a < 7; a++)
    ((o = Sx([2e3, 1]).day(a)),
      (s = tS(this.weekdaysMin(o, ``))),
      (c = tS(this.weekdaysShort(o, ``))),
      (l = tS(this.weekdays(o, ``))),
      t.push(s),
      n.push(c),
      r.push(l),
      i.push(s),
      i.push(c),
      i.push(l));
  (t.sort(e),
    n.sort(e),
    r.sort(e),
    i.sort(e),
    (this._weekdaysRegex = RegExp(`^(` + i.join(`|`) + `)`, `i`)),
    (this._weekdaysShortRegex = this._weekdaysRegex),
    (this._weekdaysMinRegex = this._weekdaysRegex),
    (this._weekdaysStrictRegex = RegExp(`^(` + r.join(`|`) + `)`, `i`)),
    (this._weekdaysShortStrictRegex = RegExp(`^(` + n.join(`|`) + `)`, `i`)),
    (this._weekdaysMinStrictRegex = RegExp(`^(` + t.join(`|`) + `)`, `i`)));
}
function $S() {
  return this.hours() % 12 || 12;
}
function eC() {
  return this.hours() || 24;
}
function tC(e, t) {
  zx(e, 0, 0, function () {
    return this.localeData().meridiem(this.hours(), this.minutes(), t);
  });
}
function nC(e, t) {
  return t._meridiemParse;
}
function rC(e) {
  return (e + ``).toLowerCase().charAt(0) === `p`;
}
function iC(e, t, n) {
  return e > 11 ? (n ? `pm` : `PM`) : n ? `am` : `AM`;
}
function aC(e, t) {
  var n,
    r = Math.min(e.length, t.length);
  for (n = 0; n < r; n += 1) if (e[n] !== t[n]) return n;
  return r;
}
function oC(e) {
  return e && e.toLowerCase().replace(`_`, `-`);
}
function sC(e) {
  for (var t = 0, n, r, i, a; t < e.length;) {
    for (
      a = oC(e[t]).split(`-`), n = a.length, r = oC(e[t + 1]), r = r ? r.split(`-`) : null;
      n > 0;
    ) {
      if (((i = lC(a.slice(0, n).join(`-`))), i)) return i;
      if (r && r.length >= n && aC(a, r) >= n - 1) break;
      n--;
    }
    t++;
  }
  return vE;
}
function cC(e) {
  return !!(e && e.match(`^[^/\\\\]*$`));
}
function lC(e) {
  var n = null,
    r;
  if (gE[e] === void 0 && typeof module < `u` && module && module.exports && cC(e))
    try {
      ((n = vE._abbr), (r = t), r(`./locale/` + e), uC(n));
    } catch {
      gE[e] = null;
    }
  return gE[e];
}
function uC(e, t) {
  var n;
  return (
    e &&
      ((n = _x(t) ? pC(e) : dC(e, t)),
      n
        ? (vE = n)
        : typeof console < `u` &&
          console.warn &&
          console.warn(`Locale ` + e + ` not found. Did you forget to load it?`)),
    vE._abbr
  );
}
function dC(e, t) {
  if (t !== null) {
    var n,
      r = hE;
    if (((t.abbr = e), gE[e] != null))
      (Mx(
        `defineLocaleOverride`,
        `use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.`,
      ),
        (r = gE[e]._config));
    else if (t.parentLocale != null)
      if (gE[t.parentLocale] != null) r = gE[t.parentLocale]._config;
      else if (((n = lC(t.parentLocale)), n != null)) r = n._config;
      else
        return (
          _E[t.parentLocale] || (_E[t.parentLocale] = []),
          _E[t.parentLocale].push({
            name: e,
            config: t,
          }),
          null
        );
    return (
      (gE[e] = new Ix(Fx(r, t))),
      _E[e] &&
        _E[e].forEach(function (e) {
          dC(e.name, e.config);
        }),
      uC(e),
      gE[e]
    );
  } else return (delete gE[e], null);
}
function fC(e, t) {
  if (t != null) {
    var n,
      r,
      i = hE;
    (gE[e] != null && gE[e].parentLocale != null
      ? gE[e].set(Fx(gE[e]._config, t))
      : ((r = lC(e)),
        r != null && (i = r._config),
        (t = Fx(i, t)),
        r ?? (t.abbr = e),
        (n = new Ix(t)),
        (n.parentLocale = gE[e]),
        (gE[e] = n)),
      uC(e));
  } else
    gE[e] != null &&
      (gE[e].parentLocale == null
        ? gE[e] != null && delete gE[e]
        : ((gE[e] = gE[e].parentLocale), e === uC() && uC(e)));
  return gE[e];
}
function pC(e) {
  var t;
  if ((e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)) return vE;
  if (!px(e)) {
    if (((t = lC(e)), t)) return t;
    e = [e];
  }
  return sC(e);
}
function mC() {
  return uT(gE);
}
function hC(e) {
  var t,
    n = e._a;
  return (
    n &&
      wx(e).overflow === -2 &&
      ((t =
        n[GT] < 0 || n[GT] > 11
          ? GT
          : n[KT] < 1 || n[KT] > gS(n[WT], n[GT])
            ? KT
            : n[qT] < 0 ||
                n[qT] > 24 ||
                (n[qT] === 24 && (n[JT] !== 0 || n[YT] !== 0 || n[XT] !== 0))
              ? qT
              : n[JT] < 0 || n[JT] > 59
                ? JT
                : n[YT] < 0 || n[YT] > 59
                  ? YT
                  : n[XT] < 0 || n[XT] > 999
                    ? XT
                    : -1),
      wx(e)._overflowDayOfYear && (t < WT || t > KT) && (t = KT),
      wx(e)._overflowWeeks && t === -1 && (t = ZT),
      wx(e)._overflowWeekday && t === -1 && (t = QT),
      (wx(e).overflow = t)),
    e
  );
}
function gC(e) {
  var t,
    n,
    r = e._i,
    i = yE.exec(r) || bE.exec(r),
    a,
    o,
    s,
    c,
    l = SE.length,
    u = CE.length;
  if (i) {
    for (wx(e).iso = !0, t = 0, n = l; t < n; t++)
      if (SE[t][1].exec(i[1])) {
        ((o = SE[t][0]), (a = SE[t][2] !== !1));
        break;
      }
    if (o == null) {
      e._isValid = !1;
      return;
    }
    if (i[3]) {
      for (t = 0, n = u; t < n; t++)
        if (CE[t][1].exec(i[3])) {
          s = (i[2] || ` `) + CE[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (i[4])
      if (xE.exec(i[4])) c = `Z`;
      else {
        e._isValid = !1;
        return;
      }
    ((e._f = o + (s || ``) + (c || ``)), OC(e));
  } else e._isValid = !1;
}
function _C(e, t, n, r, i, a) {
  var o = [vC(e), nE.indexOf(t), parseInt(n, 10), parseInt(r, 10), parseInt(i, 10)];
  return (a && o.push(parseInt(a, 10)), o);
}
function vC(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function yC(e) {
  return e
    .replace(/\([^()]*\)|[\n\t]/g, ` `)
    .replace(/(\s\s+)/g, ` `)
    .replace(/^\s\s*/, ``)
    .replace(/\s\s*$/, ``);
}
function bC(e, t, n) {
  return e && cE.indexOf(e) !== new Date(t[0], t[1], t[2]).getDay()
    ? ((wx(n).weekdayMismatch = !0), (n._isValid = !1), !1)
    : !0;
}
function xC(e, t, n) {
  if (e) return EE[e];
  if (t) return 0;
  var r = parseInt(n, 10),
    i = r % 100;
  return ((r - i) / 100) * 60 + i;
}
function SC(e) {
  var t = TE.exec(yC(e._i)),
    n;
  if (t) {
    if (((n = _C(t[4], t[3], t[2], t[5], t[6], t[7])), !bC(t[1], n, e))) return;
    ((e._a = n),
      (e._tzm = xC(t[8], t[9], t[10])),
      (e._d = OS.apply(null, e._a)),
      e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
      (wx(e).rfc2822 = !0));
  } else e._isValid = !1;
}
function CC(e) {
  var t = wE.exec(e._i);
  if (t !== null) {
    e._d = new Date(+t[1]);
    return;
  }
  if ((gC(e), e._isValid === !1)) delete e._isValid;
  else return;
  if ((SC(e), e._isValid === !1)) delete e._isValid;
  else return;
  e._strict ? (e._isValid = !1) : dx.createFromInputFallback(e);
}
function wC(e, t, n) {
  return e ?? t ?? n;
}
function TC(e) {
  var t = new Date(dx.now());
  return e._useUTC
    ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()]
    : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function EC(e) {
  var t,
    n,
    r = [],
    i,
    a,
    o;
  if (!e._d) {
    for (
      i = TC(e),
        e._w && e._a[KT] == null && e._a[GT] == null && DC(e),
        e._dayOfYear != null &&
          ((o = wC(e._a[WT], i[WT])),
          (e._dayOfYear > cS(o) || e._dayOfYear === 0) && (wx(e)._overflowDayOfYear = !0),
          (n = OS(o, 0, e._dayOfYear)),
          (e._a[GT] = n.getUTCMonth()),
          (e._a[KT] = n.getUTCDate())),
        t = 0;
      t < 3 && e._a[t] == null;
      ++t
    )
      e._a[t] = r[t] = i[t];
    for (; t < 7; t++) e._a[t] = r[t] = e._a[t] == null ? +(t === 2) : e._a[t];
    (e._a[qT] === 24 &&
      e._a[JT] === 0 &&
      e._a[YT] === 0 &&
      e._a[XT] === 0 &&
      ((e._nextDay = !0), (e._a[qT] = 0)),
      (e._d = (e._useUTC ? OS : DS).apply(null, r)),
      (a = e._useUTC ? e._d.getUTCDay() : e._d.getDay()),
      e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
      e._nextDay && (e._a[qT] = 24),
      e._w && e._w.d !== void 0 && e._w.d !== a && (wx(e).weekdayMismatch = !0));
  }
}
function DC(e) {
  var t = e._w,
    n,
    r,
    i,
    a,
    o,
    s,
    c,
    l;
  (t.GG != null || t.W != null || t.E != null
    ? ((a = 1),
      (o = 4),
      (n = wC(t.GG, e._a[WT], jS(IC(), 1, 4).year)),
      (r = wC(t.W, 1)),
      (i = wC(t.E, 1)),
      (i < 1 || i > 7) && (c = !0))
    : ((a = e._locale._week.dow),
      (o = e._locale._week.doy),
      (l = jS(IC(), a, o)),
      (n = wC(t.gg, e._a[WT], l.year)),
      (r = wC(t.w, l.week)),
      t.d == null
        ? t.e == null
          ? (i = a)
          : ((i = t.e + a), (t.e < 0 || t.e > 6) && (c = !0))
        : ((i = t.d), (i < 0 || i > 6) && (c = !0))),
    r < 1 || r > MS(n, a, o)
      ? (wx(e)._overflowWeeks = !0)
      : c == null
        ? ((s = AS(n, r, i, a, o)), (e._a[WT] = s.year), (e._dayOfYear = s.dayOfYear))
        : (wx(e)._overflowWeekday = !0));
}
function OC(e) {
  if (e._f === dx.ISO_8601) {
    gC(e);
    return;
  }
  if (e._f === dx.RFC_2822) {
    SC(e);
    return;
  }
  ((e._a = []), (wx(e).empty = !0));
  var t = `` + e._i,
    n,
    r,
    i,
    a,
    o,
    s = t.length,
    c = 0,
    l,
    u;
  for (i = Ux(e._f, e._locale).match(fT) || [], u = i.length, n = 0; n < u; n++)
    ((a = i[n]),
      (r = (t.match($x(a, e)) || [])[0]),
      r &&
        ((o = t.substr(0, t.indexOf(r))),
        o.length > 0 && wx(e).unusedInput.push(o),
        (t = t.slice(t.indexOf(r) + r.length)),
        (c += r.length)),
      hT[a]
        ? (r ? (wx(e).empty = !1) : wx(e).unusedTokens.push(a), oS(a, r, e))
        : e._strict && !r && wx(e).unusedTokens.push(a));
  ((wx(e).charsLeftOver = s - c),
    t.length > 0 && wx(e).unusedInput.push(t),
    e._a[qT] <= 12 && wx(e).bigHour === !0 && e._a[qT] > 0 && (wx(e).bigHour = void 0),
    (wx(e).parsedDateParts = e._a.slice(0)),
    (wx(e).meridiem = e._meridiem),
    (e._a[qT] = kC(e._locale, e._a[qT], e._meridiem)),
    (l = wx(e).era),
    l !== null && (e._a[WT] = e._locale.erasConvertYear(l, e._a[WT])),
    EC(e),
    hC(e));
}
function kC(e, t, n) {
  var r;
  return n == null
    ? t
    : e.meridiemHour == null
      ? e.isPM == null
        ? t
        : ((r = e.isPM(n)), r && t < 12 && (t += 12), !r && t === 12 && (t = 0), t)
      : e.meridiemHour(t, n);
}
function AC(e) {
  var t,
    n,
    r,
    i,
    a,
    o,
    s = !1,
    c = e._f.length;
  if (c === 0) {
    ((wx(e).invalidFormat = !0), (e._d = new Date(NaN)));
    return;
  }
  for (i = 0; i < c; i++)
    ((a = 0),
      (o = !1),
      (t = Dx({}, e)),
      e._useUTC != null && (t._useUTC = e._useUTC),
      (t._f = e._f[i]),
      OC(t),
      Tx(t) && (o = !0),
      (a += wx(t).charsLeftOver),
      (a += wx(t).unusedTokens.length * 10),
      (wx(t).score = a),
      s
        ? a < r && ((r = a), (n = t))
        : (r == null || a < r || o) && ((r = a), (n = t), o && (s = !0)));
  xx(e, n || t);
}
function jC(e) {
  if (!e._d) {
    var t = Xx(e._i),
      n = t.day === void 0 ? t.date : t.day;
    ((e._a = bx([t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond], function (e) {
      return e && parseInt(e, 10);
    })),
      EC(e));
  }
}
function MC(e) {
  var t = new Ox(hC(NC(e)));
  return ((t._nextDay &&= (t.add(1, `d`), void 0)), t);
}
function NC(e) {
  var t = e._i,
    n = e._f;
  return (
    (e._locale = e._locale || pC(e._l)),
    t === null || (n === void 0 && t === ``)
      ? Ex({
          nullInput: !0,
        })
      : (typeof t == `string` && (e._i = t = e._locale.preparse(t)),
        kx(t)
          ? new Ox(hC(t))
          : (yx(t) ? (e._d = t) : px(n) ? AC(e) : n ? OC(e) : PC(e), Tx(e) || (e._d = null), e))
  );
}
function PC(e) {
  var t = e._i;
  _x(t)
    ? (e._d = new Date(dx.now()))
    : yx(t)
      ? (e._d = new Date(t.valueOf()))
      : typeof t == `string`
        ? CC(e)
        : px(t)
          ? ((e._a = bx(t.slice(0), function (e) {
              return parseInt(e, 10);
            })),
            EC(e))
          : mx(t)
            ? jC(e)
            : vx(t)
              ? (e._d = new Date(t))
              : dx.createFromInputFallback(e);
}
function FC(e, t, n, r, i) {
  var a = {};
  return (
    (t === !0 || t === !1) && ((r = t), (t = void 0)),
    (n === !0 || n === !1) && ((r = n), (n = void 0)),
    ((mx(e) && gx(e)) || (px(e) && e.length === 0)) && (e = void 0),
    (a._isAMomentObject = !0),
    (a._useUTC = a._isUTC = i),
    (a._l = n),
    (a._i = e),
    (a._f = t),
    (a._strict = r),
    MC(a)
  );
}
function IC(e, t, n, r) {
  return FC(e, t, n, r, !1);
}
function LC(e, t) {
  var n, r;
  if ((t.length === 1 && px(t[0]) && (t = t[0]), !t.length)) return IC();
  for (n = t[0], r = 1; r < t.length; ++r) (!t[r].isValid() || t[r][e](n)) && (n = t[r]);
  return n;
}
function RC() {
  return LC(`isBefore`, [].slice.call(arguments, 0));
}
function zC() {
  return LC(`isAfter`, [].slice.call(arguments, 0));
}
function BC(e) {
  var t,
    n = !1,
    r,
    i = AE.length;
  for (t in e)
    if (hx(e, t) && !(eE.call(AE, t) !== -1 && (e[t] == null || !isNaN(e[t])))) return !1;
  for (r = 0; r < i; ++r)
    if (e[AE[r]]) {
      if (n) return !1;
      parseFloat(e[AE[r]]) !== rS(e[AE[r]]) && (n = !0);
    }
  return !0;
}
function VC() {
  return this._isValid;
}
function HC() {
  return cw(NaN);
}
function UC(e) {
  var t = Xx(e),
    n = t.year || 0,
    r = t.quarter || 0,
    i = t.month || 0,
    a = t.week || t.isoWeek || 0,
    o = t.day || 0,
    s = t.hour || 0,
    c = t.minute || 0,
    l = t.second || 0,
    u = t.millisecond || 0;
  ((this._isValid = BC(t)),
    (this._milliseconds = +u + l * 1e3 + c * 6e4 + s * 1e3 * 60 * 60),
    (this._days = +o + a * 7),
    (this._months = +i + r * 3 + n * 12),
    (this._data = {}),
    (this._locale = pC()),
    this._bubble());
}
function WC(e) {
  return e instanceof UC;
}
function GC(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function KC(e, t, n) {
  var r = Math.min(e.length, t.length),
    i = Math.abs(e.length - t.length),
    a = 0,
    o;
  for (o = 0; o < r; o++) ((n && e[o] !== t[o]) || (!n && rS(e[o]) !== rS(t[o]))) && a++;
  return a + i;
}
function qC(e, t) {
  zx(e, 0, 0, function () {
    var e = this.utcOffset(),
      n = `+`;
    return (e < 0 && ((e = -e), (n = `-`)), n + Rx(~~(e / 60), 2) + t + Rx(~~e % 60, 2));
  });
}
function JC(e, t) {
  var n = (t || ``).match(e),
    r,
    i,
    a;
  return n === null
    ? null
    : ((r = n[n.length - 1] || []),
      (i = (r + ``).match(jE) || [`-`, 0, 0]),
      (a = +(i[1] * 60) + rS(i[2])),
      a === 0 ? 0 : i[0] === `+` ? a : -a);
}
function YC(e, t) {
  var n, r;
  return t._isUTC
    ? ((n = t.clone()),
      (r = (kx(e) || yx(e) ? e.valueOf() : IC(e).valueOf()) - n.valueOf()),
      n._d.setTime(n._d.valueOf() + r),
      dx.updateOffset(n, !1),
      n)
    : IC(e).local();
}
function XC(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
function ZC(e, t, n) {
  var r = this._offset || 0,
    i;
  if (!this.isValid()) return e == null ? NaN : this;
  if (e != null) {
    if (typeof e == `string`) {
      if (((e = JC(LT, e)), e === null)) return this;
    } else Math.abs(e) < 16 && !n && (e *= 60);
    return (
      !this._isUTC && t && (i = XC(this)),
      (this._offset = e),
      (this._isUTC = !0),
      i != null && this.add(i, `m`),
      r !== e &&
        (!t || this._changeInProgress
          ? pw(this, cw(e - r, `m`), 1, !1)
          : (this._changeInProgress ||=
              ((this._changeInProgress = !0), dx.updateOffset(this, !0), null))),
      this
    );
  } else return this._isUTC ? r : XC(this);
}
function QC(e, t) {
  return e == null
    ? -this.utcOffset()
    : (typeof e != `string` && (e = -e), this.utcOffset(e, t), this);
}
function $C(e) {
  return this.utcOffset(0, e);
}
function ew(e) {
  return (
    this._isUTC && (this.utcOffset(0, e), (this._isUTC = !1), e && this.subtract(XC(this), `m`)),
    this
  );
}
function tw() {
  if (this._tzm != null) this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == `string`) {
    var e = JC(IT, this._i);
    e == null ? this.utcOffset(0, !0) : this.utcOffset(e);
  }
  return this;
}
function nw(e) {
  return this.isValid() ? ((e = e ? IC(e).utcOffset() : 0), (this.utcOffset() - e) % 60 == 0) : !1;
}
function rw() {
  return (
    this.utcOffset() > this.clone().month(0).utcOffset() ||
    this.utcOffset() > this.clone().month(5).utcOffset()
  );
}
function iw() {
  if (!_x(this._isDSTShifted)) return this._isDSTShifted;
  var e = {},
    t;
  return (
    Dx(e, this),
    (e = NC(e)),
    e._a
      ? ((t = e._isUTC ? Sx(e._a) : IC(e._a)),
        (this._isDSTShifted = this.isValid() && KC(e._a, t.toArray()) > 0))
      : (this._isDSTShifted = !1),
    this._isDSTShifted
  );
}
function aw() {
  return this.isValid() ? !this._isUTC : !1;
}
function ow() {
  return this.isValid() ? this._isUTC : !1;
}
function sw() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
function cw(e, t) {
  var n = e,
    r = null,
    i,
    a,
    o;
  return (
    WC(e)
      ? (n = {
          ms: e._milliseconds,
          d: e._days,
          M: e._months,
        })
      : vx(e) || !isNaN(+e)
        ? ((n = {}), t ? (n[t] = +e) : (n.milliseconds = +e))
        : (r = ME.exec(e))
          ? ((i = r[1] === `-` ? -1 : 1),
            (n = {
              y: 0,
              d: rS(r[KT]) * i,
              h: rS(r[qT]) * i,
              m: rS(r[JT]) * i,
              s: rS(r[YT]) * i,
              ms: rS(GC(r[XT] * 1e3)) * i,
            }))
          : (r = NE.exec(e))
            ? ((i = r[1] === `-` ? -1 : 1),
              (n = {
                y: lw(r[2], i),
                M: lw(r[3], i),
                w: lw(r[4], i),
                d: lw(r[5], i),
                h: lw(r[6], i),
                m: lw(r[7], i),
                s: lw(r[8], i),
              }))
            : n == null
              ? (n = {})
              : typeof n == `object` &&
                (`from` in n || `to` in n) &&
                ((o = dw(IC(n.from), IC(n.to))),
                (n = {}),
                (n.ms = o.milliseconds),
                (n.M = o.months)),
    (a = new UC(n)),
    WC(e) && hx(e, `_locale`) && (a._locale = e._locale),
    WC(e) && hx(e, `_isValid`) && (a._isValid = e._isValid),
    a
  );
}
function lw(e, t) {
  var n = e && parseFloat(e.replace(`,`, `.`));
  return (isNaN(n) ? 0 : n) * t;
}
function uw(e, t) {
  var n = {};
  return (
    (n.months = t.month() - e.month() + (t.year() - e.year()) * 12),
    e.clone().add(n.months, `M`).isAfter(t) && --n.months,
    (n.milliseconds = t - +e.clone().add(n.months, `M`)),
    n
  );
}
function dw(e, t) {
  var n;
  return e.isValid() && t.isValid()
    ? ((t = YC(t, e)),
      e.isBefore(t)
        ? (n = uw(e, t))
        : ((n = uw(t, e)), (n.milliseconds = -n.milliseconds), (n.months = -n.months)),
      n)
    : {
        milliseconds: 0,
        months: 0,
      };
}
function fw(e, t) {
  return function (n, r) {
    var i, a;
    return (
      r !== null &&
        !isNaN(+r) &&
        (Mx(
          t,
          `moment().` +
            t +
            `(period, number) is deprecated. Please use moment().` +
            t +
            `(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.`,
        ),
        (a = n),
        (n = r),
        (r = a)),
      (i = cw(n, r)),
      pw(this, i, e),
      this
    );
  };
}
function pw(e, t, n, r) {
  var i = t._milliseconds,
    a = GC(t._days),
    o = GC(t._months);
  e.isValid() &&
    ((r ??= !0),
    o && xS(e, dS(e, `Month`) + o * n),
    a && fS(e, `Date`, dS(e, `Date`) + a * n),
    i && e._d.setTime(e._d.valueOf() + i * n),
    r && dx.updateOffset(e, a || o));
}
function mw(e) {
  return typeof e == `string` || e instanceof String;
}
function hw(e) {
  return kx(e) || yx(e) || mw(e) || vx(e) || _w(e) || gw(e) || e == null;
}
function gw(e) {
  var t = mx(e) && !gx(e),
    n = !1,
    r = [
      `years`,
      `year`,
      `y`,
      `months`,
      `month`,
      `M`,
      `days`,
      `day`,
      `d`,
      `dates`,
      `date`,
      `D`,
      `hours`,
      `hour`,
      `h`,
      `minutes`,
      `minute`,
      `m`,
      `seconds`,
      `second`,
      `s`,
      `milliseconds`,
      `millisecond`,
      `ms`,
    ],
    i,
    a,
    o = r.length;
  for (i = 0; i < o; i += 1) ((a = r[i]), (n ||= hx(e, a)));
  return t && n;
}
function _w(e) {
  var t = px(e),
    n = !1;
  return (
    t &&
      (n =
        e.filter(function (t) {
          return !vx(t) && mw(e);
        }).length === 0),
    t && n
  );
}
function vw(e) {
  var t = mx(e) && !gx(e),
    n = !1,
    r = [`sameDay`, `nextDay`, `lastDay`, `nextWeek`, `lastWeek`, `sameElse`],
    i,
    a;
  for (i = 0; i < r.length; i += 1) ((a = r[i]), (n ||= hx(e, a)));
  return t && n;
}
function yw(e, t) {
  var n = e.diff(t, `days`, !0);
  return n < -6
    ? `sameElse`
    : n < -1
      ? `lastWeek`
      : n < 0
        ? `lastDay`
        : n < 1
          ? `sameDay`
          : n < 2
            ? `nextDay`
            : n < 7
              ? `nextWeek`
              : `sameElse`;
}
function bw(e, t) {
  arguments.length === 1 &&
    (arguments[0]
      ? hw(arguments[0])
        ? ((e = arguments[0]), (t = void 0))
        : vw(arguments[0]) && ((t = arguments[0]), (e = void 0))
      : ((e = void 0), (t = void 0)));
  var n = e || IC(),
    r = YC(n, this).startOf(`day`),
    i = dx.calendarFormat(this, r) || `sameElse`,
    a = t && (Nx(t[i]) ? t[i].call(this, n) : t[i]);
  return this.format(a || this.localeData().calendar(i, this, IC(n)));
}
function xw() {
  return new Ox(this);
}
function Sw(e, t) {
  var n = kx(e) ? e : IC(e);
  return this.isValid() && n.isValid()
    ? ((t = Yx(t) || `millisecond`),
      t === `millisecond`
        ? this.valueOf() > n.valueOf()
        : n.valueOf() < this.clone().startOf(t).valueOf())
    : !1;
}
function Cw(e, t) {
  var n = kx(e) ? e : IC(e);
  return this.isValid() && n.isValid()
    ? ((t = Yx(t) || `millisecond`),
      t === `millisecond`
        ? this.valueOf() < n.valueOf()
        : this.clone().endOf(t).valueOf() < n.valueOf())
    : !1;
}
function ww(e, t, n, r) {
  var i = kx(e) ? e : IC(e),
    a = kx(t) ? t : IC(t);
  return this.isValid() && i.isValid() && a.isValid()
    ? ((r ||= `()`),
      (r[0] === `(` ? this.isAfter(i, n) : !this.isBefore(i, n)) &&
        (r[1] === `)` ? this.isBefore(a, n) : !this.isAfter(a, n)))
    : !1;
}
function Tw(e, t) {
  var n = kx(e) ? e : IC(e),
    r;
  return this.isValid() && n.isValid()
    ? ((t = Yx(t) || `millisecond`),
      t === `millisecond`
        ? this.valueOf() === n.valueOf()
        : ((r = n.valueOf()),
          this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf()))
    : !1;
}
function Ew(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function Dw(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function Ow(e, t, n) {
  var r, i, a;
  if (!this.isValid() || ((r = YC(e, this)), !r.isValid())) return NaN;
  switch (((i = (r.utcOffset() - this.utcOffset()) * 6e4), (t = Yx(t)), t)) {
    case `year`:
      a = kw(this, r) / 12;
      break;
    case `month`:
      a = kw(this, r);
      break;
    case `quarter`:
      a = kw(this, r) / 3;
      break;
    case `second`:
      a = (this - r) / 1e3;
      break;
    case `minute`:
      a = (this - r) / 6e4;
      break;
    case `hour`:
      a = (this - r) / 36e5;
      break;
    case `day`:
      a = (this - r - i) / 864e5;
      break;
    case `week`:
      a = (this - r - i) / 6048e5;
      break;
    default:
      a = this - r;
  }
  return n ? a : nS(a);
}
function kw(e, t) {
  if (e.date() < t.date()) return -kw(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()),
    r = e.clone().add(n, `months`),
    i,
    a;
  return (
    t - r < 0
      ? ((i = e.clone().add(n - 1, `months`)), (a = (t - r) / (r - i)))
      : ((i = e.clone().add(n + 1, `months`)), (a = (t - r) / (i - r))),
    -(n + a) || 0
  );
}
function Aw() {
  return this.clone().locale(`en`).format(`ddd MMM DD YYYY HH:mm:ss [GMT]ZZ`);
}
function jw(e) {
  if (!this.isValid()) return null;
  var t = e !== !0,
    n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999
    ? Hx(n, t ? `YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]` : `YYYYYY-MM-DD[T]HH:mm:ss.SSSZ`)
    : Nx(Date.prototype.toISOString)
      ? t
        ? this.toDate().toISOString()
        : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3)
            .toISOString()
            .replace(`Z`, Hx(n, `Z`))
      : Hx(n, t ? `YYYY-MM-DD[T]HH:mm:ss.SSS[Z]` : `YYYY-MM-DD[T]HH:mm:ss.SSSZ`);
}
function Mw() {
  if (!this.isValid()) return `moment.invalid(/* ` + this._i + ` */)`;
  var e = `moment`,
    t = ``,
    n,
    r,
    i,
    a;
  return (
    this.isLocal() || ((e = this.utcOffset() === 0 ? `moment.utc` : `moment.parseZone`), (t = `Z`)),
    (n = `[` + e + `("]`),
    (r = 0 <= this.year() && this.year() <= 9999 ? `YYYY` : `YYYYYY`),
    (i = `-MM-DD[T]HH:mm:ss.SSS`),
    (a = t + `[")]`),
    this.format(n + r + i + a)
  );
}
function Nw(e) {
  e ||= this.isUtc() ? dx.defaultFormatUtc : dx.defaultFormat;
  var t = Hx(this, e);
  return this.localeData().postformat(t);
}
function Pw(e, t) {
  return this.isValid() && ((kx(e) && e.isValid()) || IC(e).isValid())
    ? cw({
        to: this,
        from: e,
      })
        .locale(this.locale())
        .humanize(!t)
    : this.localeData().invalidDate();
}
function Fw(e) {
  return this.from(IC(), e);
}
function Iw(e, t) {
  return this.isValid() && ((kx(e) && e.isValid()) || IC(e).isValid())
    ? cw({
        from: this,
        to: e,
      })
        .locale(this.locale())
        .humanize(!t)
    : this.localeData().invalidDate();
}
function Lw(e) {
  return this.to(IC(), e);
}
function Rw(e) {
  var t;
  return e === void 0 ? this._locale._abbr : ((t = pC(e)), t != null && (this._locale = t), this);
}
function zw() {
  return this._locale;
}
function Bw(e, t) {
  return ((e % t) + t) % t;
}
function Vw(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - BE : new Date(e, t, n).valueOf();
}
function Hw(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - BE : Date.UTC(e, t, n);
}
function _ie(e) {
  var t, n;
  if (((e = Yx(e)), e === void 0 || e === `millisecond` || !this.isValid())) return this;
  switch (((n = this._isUTC ? Hw : Vw), e)) {
    case `year`:
      t = n(this.year(), 0, 1);
      break;
    case `quarter`:
      t = n(this.year(), this.month() - (this.month() % 3), 1);
      break;
    case `month`:
      t = n(this.year(), this.month(), 1);
      break;
    case `week`:
      t = n(this.year(), this.month(), this.date() - this.weekday());
      break;
    case `isoWeek`:
      t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
      break;
    case `day`:
    case `date`:
      t = n(this.year(), this.month(), this.date());
      break;
    case `hour`:
      ((t = this._d.valueOf()), (t -= Bw(t + (this._isUTC ? 0 : this.utcOffset() * RE), zE)));
      break;
    case `minute`:
      ((t = this._d.valueOf()), (t -= Bw(t, RE)));
      break;
    case `second`:
      ((t = this._d.valueOf()), (t -= Bw(t, LE)));
      break;
  }
  return (this._d.setTime(t), dx.updateOffset(this, !0), this);
}
function vie(e) {
  var t, n;
  if (((e = Yx(e)), e === void 0 || e === `millisecond` || !this.isValid())) return this;
  switch (((n = this._isUTC ? Hw : Vw), e)) {
    case `year`:
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case `quarter`:
      t = n(this.year(), this.month() - (this.month() % 3) + 3, 1) - 1;
      break;
    case `month`:
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case `week`:
      t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
      break;
    case `isoWeek`:
      t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
      break;
    case `day`:
    case `date`:
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case `hour`:
      ((t = this._d.valueOf()),
        (t += zE - Bw(t + (this._isUTC ? 0 : this.utcOffset() * RE), zE) - 1));
      break;
    case `minute`:
      ((t = this._d.valueOf()), (t += RE - Bw(t, RE) - 1));
      break;
    case `second`:
      ((t = this._d.valueOf()), (t += LE - Bw(t, LE) - 1));
      break;
  }
  return (this._d.setTime(t), dx.updateOffset(this, !0), this);
}
function yie() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function bie() {
  return Math.floor(this.valueOf() / 1e3);
}
function xie() {
  return new Date(this.valueOf());
}
function Sie() {
  var e = this;
  return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
}
function Cie() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds(),
  };
}
function wie() {
  return this.isValid() ? this.toISOString() : null;
}
function Tie() {
  return Tx(this);
}
function Eie() {
  return xx({}, wx(this));
}
function Die() {
  return wx(this).overflow;
}
function Oie() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict,
  };
}
function kie(e, t) {
  var n,
    r,
    i,
    a = this._eras || pC(`en`)._eras;
  for (n = 0, r = a.length; n < r; ++n) {
    switch (typeof a[n].since) {
      case `string`:
        ((i = dx(a[n].since).startOf(`day`)), (a[n].since = i.valueOf()));
        break;
    }
    switch (typeof a[n].until) {
      case `undefined`:
        a[n].until = 1 / 0;
        break;
      case `string`:
        ((i = dx(a[n].until).startOf(`day`).valueOf()), (a[n].until = i.valueOf()));
        break;
    }
  }
  return a;
}
function Aie(e, t, n) {
  var r,
    i,
    a = this.eras(),
    o,
    s,
    c;
  for (e = e.toUpperCase(), r = 0, i = a.length; r < i; ++r)
    if (
      ((o = a[r].name.toUpperCase()),
      (s = a[r].abbr.toUpperCase()),
      (c = a[r].narrow.toUpperCase()),
      n)
    )
      switch (t) {
        case `N`:
        case `NN`:
        case `NNN`:
          if (s === e) return a[r];
          break;
        case `NNNN`:
          if (o === e) return a[r];
          break;
        case `NNNNN`:
          if (c === e) return a[r];
          break;
      }
    else if ([o, s, c].indexOf(e) >= 0) return a[r];
}
function jie(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? dx(e.since).year() : dx(e.since).year() + (t - e.offset) * n;
}
function Mie() {
  var e,
    t,
    n,
    r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (
      ((n = this.clone().startOf(`day`).valueOf()),
      (r[e].since <= n && n <= r[e].until) || (r[e].until <= n && n <= r[e].since))
    )
      return r[e].name;
  return ``;
}
function Nie() {
  var e,
    t,
    n,
    r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (
      ((n = this.clone().startOf(`day`).valueOf()),
      (r[e].since <= n && n <= r[e].until) || (r[e].until <= n && n <= r[e].since))
    )
      return r[e].narrow;
  return ``;
}
function Pie() {
  var e,
    t,
    n,
    r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (
      ((n = this.clone().startOf(`day`).valueOf()),
      (r[e].since <= n && n <= r[e].until) || (r[e].until <= n && n <= r[e].since))
    )
      return r[e].abbr;
  return ``;
}
function Fie() {
  var e,
    t,
    n,
    r,
    i = this.localeData().eras();
  for (e = 0, t = i.length; e < t; ++e)
    if (
      ((n = i[e].since <= i[e].until ? 1 : -1),
      (r = this.clone().startOf(`day`).valueOf()),
      (i[e].since <= r && r <= i[e].until) || (i[e].until <= r && r <= i[e].since))
    )
      return (this.year() - dx(i[e].since).year()) * n + i[e].offset;
  return this.year();
}
function Iie(e) {
  return (hx(this, `_erasNameRegex`) || Ww.call(this), e ? this._erasNameRegex : this._erasRegex);
}
function Lie(e) {
  return (hx(this, `_erasAbbrRegex`) || Ww.call(this), e ? this._erasAbbrRegex : this._erasRegex);
}
function Rie(e) {
  return (
    hx(this, `_erasNarrowRegex`) || Ww.call(this),
    e ? this._erasNarrowRegex : this._erasRegex
  );
}
function Uw(e, t) {
  return t.erasAbbrRegex(e);
}
function zie(e, t) {
  return t.erasNameRegex(e);
}
function Bie(e, t) {
  return t.erasNarrowRegex(e);
}
function Vie(e, t) {
  return t._eraYearOrdinalRegex || PT;
}
function Ww() {
  var e = [],
    t = [],
    n = [],
    r = [],
    i,
    a,
    o,
    s,
    c,
    l = this.eras();
  for (i = 0, a = l.length; i < a; ++i)
    ((o = tS(l[i].name)),
      (s = tS(l[i].abbr)),
      (c = tS(l[i].narrow)),
      t.push(o),
      e.push(s),
      n.push(c),
      r.push(o),
      r.push(s),
      r.push(c));
  ((this._erasRegex = RegExp(`^(` + r.join(`|`) + `)`, `i`)),
    (this._erasNameRegex = RegExp(`^(` + t.join(`|`) + `)`, `i`)),
    (this._erasAbbrRegex = RegExp(`^(` + e.join(`|`) + `)`, `i`)),
    (this._erasNarrowRegex = RegExp(`^(` + n.join(`|`) + `)`, `i`)));
}
function Gw(e, t) {
  zx(0, [e, e.length], 0, t);
}
function Hie(e) {
  return Kw.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy,
  );
}
function Uie(e) {
  return Kw.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
}
function Wie() {
  return MS(this.year(), 1, 4);
}
function Gie() {
  return MS(this.isoWeekYear(), 1, 4);
}
function Kie() {
  var e = this.localeData()._week;
  return MS(this.year(), e.dow, e.doy);
}
function qie() {
  var e = this.localeData()._week;
  return MS(this.weekYear(), e.dow, e.doy);
}
function Kw(e, t, n, r, i) {
  var a;
  return e == null
    ? jS(this, r, i).year
    : ((a = MS(e, r, i)), t > a && (t = a), Jie.call(this, e, t, n, r, i));
}
function Jie(e, t, n, r, i) {
  var a = AS(e, t, n, r, i),
    o = OS(a.year, 0, a.dayOfYear);
  return (
    this.year(o.getUTCFullYear()),
    this.month(o.getUTCMonth()),
    this.date(o.getUTCDate()),
    this
  );
}
function Yie(e) {
  return e == null
    ? Math.ceil((this.month() + 1) / 3)
    : this.month((e - 1) * 3 + (this.month() % 3));
}
function Xie(e) {
  var t = Math.round((this.clone().startOf(`day`) - this.clone().startOf(`year`)) / 864e5) + 1;
  return e == null ? t : this.add(e - t, `d`);
}
function Zie(e, t) {
  t[XT] = rS((`0.` + e) * 1e3);
}
function Qie() {
  return this._isUTC ? `UTC` : ``;
}
function $ie() {
  return this._isUTC ? `Coordinated Universal Time` : ``;
}
function eae(e) {
  return IC(e * 1e3);
}
function tae() {
  return IC.apply(null, arguments).parseZone();
}
function qw(e) {
  return e;
}
function Jw(e, t, n, r) {
  var i = pC(),
    a = Sx().set(r, t);
  return i[n](a, e);
}
function Yw(e, t, n) {
  if ((vx(e) && ((t = e), (e = void 0)), (e ||= ``), t != null)) return Jw(e, t, n, `month`);
  var r,
    i = [];
  for (r = 0; r < 12; r++) i[r] = Jw(e, r, n, `month`);
  return i;
}
function Xw(e, t, n, r) {
  typeof e == `boolean`
    ? (vx(t) && ((n = t), (t = void 0)), (t ||= ``))
    : ((t = e), (n = t), (e = !1), vx(t) && ((n = t), (t = void 0)), (t ||= ``));
  var i = pC(),
    a = e ? i._week.dow : 0,
    o,
    s = [];
  if (n != null) return Jw(t, (n + a) % 7, r, `day`);
  for (o = 0; o < 7; o++) s[o] = Jw(t, (o + a) % 7, r, `day`);
  return s;
}
function nae(e, t) {
  return Yw(e, t, `months`);
}
function rae(e, t) {
  return Yw(e, t, `monthsShort`);
}
function iae(e, t, n) {
  return Xw(e, t, n, `weekdays`);
}
function aae(e, t, n) {
  return Xw(e, t, n, `weekdaysShort`);
}
function oae(e, t, n) {
  return Xw(e, t, n, `weekdaysMin`);
}
function sae() {
  var e = this._data;
  return (
    (this._milliseconds = JE(this._milliseconds)),
    (this._days = JE(this._days)),
    (this._months = JE(this._months)),
    (e.milliseconds = JE(e.milliseconds)),
    (e.seconds = JE(e.seconds)),
    (e.minutes = JE(e.minutes)),
    (e.hours = JE(e.hours)),
    (e.months = JE(e.months)),
    (e.years = JE(e.years)),
    this
  );
}
function Zw(e, t, n, r) {
  var i = cw(t, n);
  return (
    (e._milliseconds += r * i._milliseconds),
    (e._days += r * i._days),
    (e._months += r * i._months),
    e._bubble()
  );
}
function cae(e, t) {
  return Zw(this, e, t, 1);
}
function lae(e, t) {
  return Zw(this, e, t, -1);
}
function Qw(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function uae() {
  var e = this._milliseconds,
    t = this._days,
    n = this._months,
    r = this._data,
    i,
    a,
    o,
    s,
    c;
  return (
    (e >= 0 && t >= 0 && n >= 0) ||
      (e <= 0 && t <= 0 && n <= 0) ||
      ((e += Qw(eT(n) + t) * 864e5), (t = 0), (n = 0)),
    (r.milliseconds = e % 1e3),
    (i = nS(e / 1e3)),
    (r.seconds = i % 60),
    (a = nS(i / 60)),
    (r.minutes = a % 60),
    (o = nS(a / 60)),
    (r.hours = o % 24),
    (t += nS(o / 24)),
    (c = nS($w(t))),
    (n += c),
    (t -= Qw(eT(c))),
    (s = nS(n / 12)),
    (n %= 12),
    (r.days = t),
    (r.months = n),
    (r.years = s),
    this
  );
}
function $w(e) {
  return (e * 4800) / 146097;
}
function eT(e) {
  return (e * 146097) / 4800;
}
function dae(e) {
  if (!this.isValid()) return NaN;
  var t,
    n,
    r = this._milliseconds;
  if (((e = Yx(e)), e === `month` || e === `quarter` || e === `year`))
    switch (((t = this._days + r / 864e5), (n = this._months + $w(t)), e)) {
      case `month`:
        return n;
      case `quarter`:
        return n / 3;
      case `year`:
        return n / 12;
    }
  else
    switch (((t = this._days + Math.round(eT(this._months))), e)) {
      case `week`:
        return t / 7 + r / 6048e5;
      case `day`:
        return t + r / 864e5;
      case `hour`:
        return t * 24 + r / 36e5;
      case `minute`:
        return t * 1440 + r / 6e4;
      case `second`:
        return t * 86400 + r / 1e3;
      case `millisecond`:
        return Math.floor(t * 864e5) + r;
      default:
        throw Error(`Unknown unit ` + e);
    }
}
function tT(e) {
  return function () {
    return this.as(e);
  };
}
function fae() {
  return cw(this);
}
function pae(e) {
  return ((e = Yx(e)), this.isValid() ? this[e + `s`]() : NaN);
}
function nT(e) {
  return function () {
    return this.isValid() ? this._data[e] : NaN;
  };
}
function mae() {
  return nS(this.days() / 7);
}
function hae(e, t, n, r, i) {
  return i.relativeTime(t || 1, !!n, e, r);
}
function gae(e, t, n, r) {
  var i = cw(e).abs(),
    a = fD(i.as(`s`)),
    o = fD(i.as(`m`)),
    s = fD(i.as(`h`)),
    c = fD(i.as(`d`)),
    l = fD(i.as(`M`)),
    u = fD(i.as(`w`)),
    d = fD(i.as(`y`)),
    f =
      (a <= n.ss && [`s`, a]) ||
      (a < n.s && [`ss`, a]) ||
      (o <= 1 && [`m`]) ||
      (o < n.m && [`mm`, o]) ||
      (s <= 1 && [`h`]) ||
      (s < n.h && [`hh`, s]) ||
      (c <= 1 && [`d`]) ||
      (c < n.d && [`dd`, c]);
  return (
    n.w != null && (f = f || (u <= 1 && [`w`]) || (u < n.w && [`ww`, u])),
    (f = f || (l <= 1 && [`M`]) || (l < n.M && [`MM`, l]) || (d <= 1 && [`y`]) || [`yy`, d]),
    (f[2] = t),
    (f[3] = +e > 0),
    (f[4] = r),
    hae.apply(null, f)
  );
}
function _ae(e) {
  return e === void 0 ? fD : typeof e == `function` ? ((fD = e), !0) : !1;
}
function vae(e, t) {
  return pD[e] === void 0
    ? !1
    : t === void 0
      ? pD[e]
      : ((pD[e] = t), e === `s` && (pD.ss = t - 1), !0);
}
function yae(e, t) {
  if (!this.isValid()) return this.localeData().invalidDate();
  var n = !1,
    r = pD,
    i,
    a;
  return (
    typeof e == `object` && ((t = e), (e = !1)),
    typeof e == `boolean` && (n = e),
    typeof t == `object` &&
      ((r = Object.assign({}, pD, t)), t.s != null && t.ss == null && (r.ss = t.s - 1)),
    (i = this.localeData()),
    (a = gae(this, !n, r, i)),
    n && (a = i.pastFuture(+this, a)),
    i.postformat(a)
  );
}
function rT(e) {
  return (e > 0) - (e < 0) || +e;
}
function iT() {
  if (!this.isValid()) return this.localeData().invalidDate();
  var e = mD(this._milliseconds) / 1e3,
    t = mD(this._days),
    n = mD(this._months),
    r,
    i,
    a,
    o,
    s = this.asSeconds(),
    c,
    l,
    u,
    d;
  return s
    ? ((r = nS(e / 60)),
      (i = nS(r / 60)),
      (e %= 60),
      (r %= 60),
      (a = nS(n / 12)),
      (n %= 12),
      (o = e ? e.toFixed(3).replace(/\.?0+$/, ``) : ``),
      (c = s < 0 ? `-` : ``),
      (l = rT(this._months) === rT(s) ? `` : `-`),
      (u = rT(this._days) === rT(s) ? `` : `-`),
      (d = rT(this._milliseconds) === rT(s) ? `` : `-`),
      c +
        `P` +
        (a ? l + a + `Y` : ``) +
        (n ? l + n + `M` : ``) +
        (t ? u + t + `D` : ``) +
        (i || r || e ? `T` : ``) +
        (i ? d + i + `H` : ``) +
        (r ? d + r + `M` : ``) +
        (e ? d + o + `S` : ``))
    : `P0D`;
}
var aT,
  oT,
  sT,
  cT,
  lT,
  uT,
  dT,
  fT,
  pT,
  mT,
  hT,
  gT,
  _T,
  vT,
  yT,
  bT,
  xT,
  ST,
  CT,
  wT,
  TT,
  ET,
  DT,
  OT,
  kT,
  AT,
  jT,
  MT,
  NT,
  PT,
  FT,
  IT,
  LT,
  RT,
  zT,
  BT,
  VT,
  HT,
  UT,
  WT,
  GT,
  KT,
  qT,
  JT,
  YT,
  XT,
  ZT,
  QT,
  $T,
  eE,
  tE,
  nE,
  rE,
  iE,
  aE,
  oE,
  sE,
  cE,
  lE,
  uE,
  dE,
  fE,
  pE,
  mE,
  hE,
  gE,
  _E,
  vE,
  yE,
  bE,
  xE,
  SE,
  CE,
  wE,
  TE,
  EE,
  DE,
  OE,
  kE,
  AE,
  jE,
  ME,
  NE,
  PE,
  FE,
  IE,
  LE,
  RE,
  zE,
  BE,
  VE,
  HE,
  UE,
  WE,
  GE,
  KE,
  qE,
  JE,
  YE,
  XE,
  ZE,
  QE,
  $E,
  eD,
  tD,
  nD,
  rD,
  iD,
  aD,
  oD,
  sD,
  cD,
  lD,
  uD,
  dD,
  fD,
  pD,
  mD,
  hD,
  gD = n(() => {
    for (
      oT = Array.prototype.some
        ? Array.prototype.some
        : function (e) {
            var t = Object(this),
              n = t.length >>> 0,
              r;
            for (r = 0; r < n; r++) if ((r in t) && e.call(this, t[r], r, t)) return !0;
            return !1;
          },
        sT = dx.momentProperties = [],
        cT = !1,
        lT = {},
        dx.suppressDeprecationWarnings = !1,
        dx.deprecationHandler = null,
        uT = Object.keys
          ? Object.keys
          : function (e) {
              var t,
                n = [];
              for (t in e) hx(e, t) && n.push(t);
              return n;
            },
        dT = {
          sameDay: `[Today at] LT`,
          nextDay: `[Tomorrow at] LT`,
          nextWeek: `dddd [at] LT`,
          lastDay: `[Yesterday at] LT`,
          lastWeek: `[Last] dddd [at] LT`,
          sameElse: `L`,
        },
        fT =
          /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        pT = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        mT = {},
        hT = {},
        gT = {
          LTS: `h:mm:ss A`,
          LT: `h:mm A`,
          L: `MM/DD/YYYY`,
          LL: `MMMM D, YYYY`,
          LLL: `MMMM D, YYYY h:mm A`,
          LLLL: `dddd, MMMM D, YYYY h:mm A`,
        },
        _T = `Invalid date`,
        vT = `%d`,
        yT = /\d{1,2}/,
        bT = {
          future: `in %s`,
          past: `%s ago`,
          s: `a few seconds`,
          ss: `%d seconds`,
          m: `a minute`,
          mm: `%d minutes`,
          h: `an hour`,
          hh: `%d hours`,
          d: `a day`,
          dd: `%d days`,
          w: `a week`,
          ww: `%d weeks`,
          M: `a month`,
          MM: `%d months`,
          y: `a year`,
          yy: `%d years`,
        },
        xT = {
          D: `date`,
          dates: `date`,
          date: `date`,
          d: `day`,
          days: `day`,
          day: `day`,
          e: `weekday`,
          weekdays: `weekday`,
          weekday: `weekday`,
          E: `isoWeekday`,
          isoweekdays: `isoWeekday`,
          isoweekday: `isoWeekday`,
          DDD: `dayOfYear`,
          dayofyears: `dayOfYear`,
          dayofyear: `dayOfYear`,
          h: `hour`,
          hours: `hour`,
          hour: `hour`,
          ms: `millisecond`,
          milliseconds: `millisecond`,
          millisecond: `millisecond`,
          m: `minute`,
          minutes: `minute`,
          minute: `minute`,
          M: `month`,
          months: `month`,
          month: `month`,
          Q: `quarter`,
          quarters: `quarter`,
          quarter: `quarter`,
          s: `second`,
          seconds: `second`,
          second: `second`,
          gg: `weekYear`,
          weekyears: `weekYear`,
          weekyear: `weekYear`,
          GG: `isoWeekYear`,
          isoweekyears: `isoWeekYear`,
          isoweekyear: `isoWeekYear`,
          w: `week`,
          weeks: `week`,
          week: `week`,
          W: `isoWeek`,
          isoweeks: `isoWeek`,
          isoweek: `isoWeek`,
          y: `year`,
          years: `year`,
          year: `year`,
        },
        ST = {
          date: 9,
          day: 11,
          weekday: 11,
          isoWeekday: 11,
          dayOfYear: 4,
          hour: 13,
          millisecond: 16,
          minute: 14,
          month: 8,
          quarter: 7,
          second: 15,
          weekYear: 1,
          isoWeekYear: 1,
          week: 5,
          isoWeek: 5,
          year: 1,
        },
        CT = /\d/,
        wT = /\d\d/,
        TT = /\d{3}/,
        ET = /\d{4}/,
        DT = /[+-]?\d{6}/,
        OT = /\d\d?/,
        kT = /\d\d\d\d?/,
        AT = /\d\d\d\d\d\d?/,
        jT = /\d{1,3}/,
        MT = /\d{1,4}/,
        NT = /[+-]?\d{1,6}/,
        PT = /\d+/,
        FT = /[+-]?\d+/,
        IT = /Z|[+-]\d\d:?\d\d/gi,
        LT = /Z|[+-]\d\d(?::?\d\d)?/gi,
        RT = /[+-]?\d+(\.\d{1,3})?/,
        zT =
          /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        BT = /^[1-9]\d?/,
        VT = /^([1-9]\d|\d)/,
        HT = {},
        UT = {},
        WT = 0,
        GT = 1,
        KT = 2,
        qT = 3,
        JT = 4,
        YT = 5,
        XT = 6,
        ZT = 7,
        QT = 8,
        zx(`Y`, 0, 0, function () {
          var e = this.year();
          return e <= 9999 ? Rx(e, 4) : `+` + e;
        }),
        zx(0, [`YY`, 2], 0, function () {
          return this.year() % 100;
        }),
        zx(0, [`YYYY`, 4], 0, `year`),
        zx(0, [`YYYYY`, 5], 0, `year`),
        zx(0, [`YYYYYY`, 6, !0], 0, `year`),
        Qx(`Y`, FT),
        Qx(`YY`, OT, wT),
        Qx(`YYYY`, MT, ET),
        Qx(`YYYYY`, NT, DT),
        Qx(`YYYYYY`, NT, DT),
        iS([`YYYYY`, `YYYYYY`], WT),
        iS(`YYYY`, function (e, t) {
          t[WT] = e.length === 2 ? dx.parseTwoDigitYear(e) : rS(e);
        }),
        iS(`YY`, function (e, t) {
          t[WT] = dx.parseTwoDigitYear(e);
        }),
        iS(`Y`, function (e, t) {
          t[WT] = parseInt(e, 10);
        }),
        dx.parseTwoDigitYear = function (e) {
          return rS(e) + (rS(e) > 68 ? 1900 : 2e3);
        },
        $T = uS(`FullYear`, !0),
        eE = Array.prototype.indexOf
          ? Array.prototype.indexOf
          : function (e) {
              var t;
              for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
              return -1;
            },
        zx(`M`, [`MM`, 2], `Mo`, function () {
          return this.month() + 1;
        }),
        zx(`MMM`, 0, 0, function (e) {
          return this.localeData().monthsShort(this, e);
        }),
        zx(`MMMM`, 0, 0, function (e) {
          return this.localeData().months(this, e);
        }),
        Qx(`M`, OT, BT),
        Qx(`MM`, OT, wT),
        Qx(`MMM`, function (e, t) {
          return t.monthsShortRegex(e);
        }),
        Qx(`MMMM`, function (e, t) {
          return t.monthsRegex(e);
        }),
        iS([`M`, `MM`], function (e, t) {
          t[GT] = rS(e) - 1;
        }),
        iS([`MMM`, `MMMM`], function (e, t, n, r) {
          var i = n._locale.monthsParse(e, r, n._strict);
          i == null ? (wx(n).invalidMonth = e) : (t[GT] = i);
        }),
        tE =
          `January_February_March_April_May_June_July_August_September_October_November_December`.split(
            `_`,
          ),
        nE = `Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec`.split(`_`),
        rE = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        iE = zT,
        aE = zT,
        zx(`w`, [`ww`, 2], `wo`, `week`),
        zx(`W`, [`WW`, 2], `Wo`, `isoWeek`),
        Qx(`w`, OT, BT),
        Qx(`ww`, OT, wT),
        Qx(`W`, OT, BT),
        Qx(`WW`, OT, wT),
        aS([`w`, `ww`, `W`, `WW`], function (e, t, n, r) {
          t[r.substr(0, 1)] = rS(e);
        }),
        oE = {
          dow: 0,
          doy: 6,
        },
        zx(`d`, 0, `do`, `day`),
        zx(`dd`, 0, 0, function (e) {
          return this.localeData().weekdaysMin(this, e);
        }),
        zx(`ddd`, 0, 0, function (e) {
          return this.localeData().weekdaysShort(this, e);
        }),
        zx(`dddd`, 0, 0, function (e) {
          return this.localeData().weekdays(this, e);
        }),
        zx(`e`, 0, 0, `weekday`),
        zx(`E`, 0, 0, `isoWeekday`),
        Qx(`d`, OT),
        Qx(`e`, OT),
        Qx(`E`, OT),
        Qx(`dd`, function (e, t) {
          return t.weekdaysMinRegex(e);
        }),
        Qx(`ddd`, function (e, t) {
          return t.weekdaysShortRegex(e);
        }),
        Qx(`dddd`, function (e, t) {
          return t.weekdaysRegex(e);
        }),
        aS([`dd`, `ddd`, `dddd`], function (e, t, n, r) {
          var i = n._locale.weekdaysParse(e, r, n._strict);
          i == null ? (wx(n).invalidWeekday = e) : (t.d = i);
        }),
        aS([`d`, `e`, `E`], function (e, t, n, r) {
          t[r] = rS(e);
        }),
        sE = `Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday`.split(`_`),
        cE = `Sun_Mon_Tue_Wed_Thu_Fri_Sat`.split(`_`),
        lE = `Su_Mo_Tu_We_Th_Fr_Sa`.split(`_`),
        uE = zT,
        dE = zT,
        fE = zT,
        zx(`H`, [`HH`, 2], 0, `hour`),
        zx(`h`, [`hh`, 2], 0, $S),
        zx(`k`, [`kk`, 2], 0, eC),
        zx(`hmm`, 0, 0, function () {
          return `` + $S.apply(this) + Rx(this.minutes(), 2);
        }),
        zx(`hmmss`, 0, 0, function () {
          return `` + $S.apply(this) + Rx(this.minutes(), 2) + Rx(this.seconds(), 2);
        }),
        zx(`Hmm`, 0, 0, function () {
          return `` + this.hours() + Rx(this.minutes(), 2);
        }),
        zx(`Hmmss`, 0, 0, function () {
          return `` + this.hours() + Rx(this.minutes(), 2) + Rx(this.seconds(), 2);
        }),
        tC(`a`, !0),
        tC(`A`, !1),
        Qx(`a`, nC),
        Qx(`A`, nC),
        Qx(`H`, OT, VT),
        Qx(`h`, OT, BT),
        Qx(`k`, OT, BT),
        Qx(`HH`, OT, wT),
        Qx(`hh`, OT, wT),
        Qx(`kk`, OT, wT),
        Qx(`hmm`, kT),
        Qx(`hmmss`, AT),
        Qx(`Hmm`, kT),
        Qx(`Hmmss`, AT),
        iS([`H`, `HH`], qT),
        iS([`k`, `kk`], function (e, t, n) {
          var r = rS(e);
          t[qT] = r === 24 ? 0 : r;
        }),
        iS([`a`, `A`], function (e, t, n) {
          ((n._isPm = n._locale.isPM(e)), (n._meridiem = e));
        }),
        iS([`h`, `hh`], function (e, t, n) {
          ((t[qT] = rS(e)), (wx(n).bigHour = !0));
        }),
        iS(`hmm`, function (e, t, n) {
          var r = e.length - 2;
          ((t[qT] = rS(e.substr(0, r))), (t[JT] = rS(e.substr(r))), (wx(n).bigHour = !0));
        }),
        iS(`hmmss`, function (e, t, n) {
          var r = e.length - 4,
            i = e.length - 2;
          ((t[qT] = rS(e.substr(0, r))),
            (t[JT] = rS(e.substr(r, 2))),
            (t[YT] = rS(e.substr(i))),
            (wx(n).bigHour = !0));
        }),
        iS(`Hmm`, function (e, t, n) {
          var r = e.length - 2;
          ((t[qT] = rS(e.substr(0, r))), (t[JT] = rS(e.substr(r))));
        }),
        iS(`Hmmss`, function (e, t, n) {
          var r = e.length - 4,
            i = e.length - 2;
          ((t[qT] = rS(e.substr(0, r))), (t[JT] = rS(e.substr(r, 2))), (t[YT] = rS(e.substr(i))));
        }),
        pE = /[ap]\.?m?\.?/i,
        mE = uS(`Hours`, !0),
        hE = {
          calendar: dT,
          longDateFormat: gT,
          invalidDate: _T,
          ordinal: vT,
          dayOfMonthOrdinalParse: yT,
          relativeTime: bT,
          months: tE,
          monthsShort: nE,
          week: oE,
          weekdays: sE,
          weekdaysMin: lE,
          weekdaysShort: cE,
          meridiemParse: pE,
        },
        gE = {},
        _E = {},
        yE =
          /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        bE =
          /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        xE = /Z|[+-]\d\d(?::?\d\d)?/,
        SE = [
          [`YYYYYY-MM-DD`, /[+-]\d{6}-\d\d-\d\d/],
          [`YYYY-MM-DD`, /\d{4}-\d\d-\d\d/],
          [`GGGG-[W]WW-E`, /\d{4}-W\d\d-\d/],
          [`GGGG-[W]WW`, /\d{4}-W\d\d/, !1],
          [`YYYY-DDD`, /\d{4}-\d{3}/],
          [`YYYY-MM`, /\d{4}-\d\d/, !1],
          [`YYYYYYMMDD`, /[+-]\d{10}/],
          [`YYYYMMDD`, /\d{8}/],
          [`GGGG[W]WWE`, /\d{4}W\d{3}/],
          [`GGGG[W]WW`, /\d{4}W\d{2}/, !1],
          [`YYYYDDD`, /\d{7}/],
          [`YYYYMM`, /\d{6}/, !1],
          [`YYYY`, /\d{4}/, !1],
        ],
        CE = [
          [`HH:mm:ss.SSSS`, /\d\d:\d\d:\d\d\.\d+/],
          [`HH:mm:ss,SSSS`, /\d\d:\d\d:\d\d,\d+/],
          [`HH:mm:ss`, /\d\d:\d\d:\d\d/],
          [`HH:mm`, /\d\d:\d\d/],
          [`HHmmss.SSSS`, /\d\d\d\d\d\d\.\d+/],
          [`HHmmss,SSSS`, /\d\d\d\d\d\d,\d+/],
          [`HHmmss`, /\d\d\d\d\d\d/],
          [`HHmm`, /\d\d\d\d/],
          [`HH`, /\d\d/],
        ],
        wE = /^\/?Date\((-?\d+)/i,
        TE =
          /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        EE = {
          UT: 0,
          GMT: 0,
          EDT: -240,
          EST: -300,
          CDT: -300,
          CST: -360,
          MDT: -360,
          MST: -420,
          PDT: -420,
          PST: -480,
        },
        dx.createFromInputFallback = jx(
          `value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.`,
          function (e) {
            e._d = new Date(e._i + (e._useUTC ? ` UTC` : ``));
          },
        ),
        dx.ISO_8601 = function () {},
        dx.RFC_2822 = function () {},
        DE = jx(
          `moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/`,
          function () {
            var e = IC.apply(null, arguments);
            return this.isValid() && e.isValid() ? (e < this ? this : e) : Ex();
          },
        ),
        OE = jx(
          `moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/`,
          function () {
            var e = IC.apply(null, arguments);
            return this.isValid() && e.isValid() ? (e > this ? this : e) : Ex();
          },
        ),
        kE = function () {
          return Date.now ? Date.now() : +new Date();
        },
        AE = [`year`, `quarter`, `month`, `week`, `day`, `hour`, `minute`, `second`, `millisecond`],
        qC(`Z`, `:`),
        qC(`ZZ`, ``),
        Qx(`Z`, LT),
        Qx(`ZZ`, LT),
        iS([`Z`, `ZZ`], function (e, t, n) {
          ((n._useUTC = !0), (n._tzm = JC(LT, e)));
        }),
        jE = /([\+\-]|\d\d)/gi,
        dx.updateOffset = function () {},
        ME = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        NE =
          /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,
        cw.fn = UC.prototype,
        cw.invalid = HC,
        PE = fw(1, `add`),
        FE = fw(-1, `subtract`),
        dx.defaultFormat = `YYYY-MM-DDTHH:mm:ssZ`,
        dx.defaultFormatUtc = `YYYY-MM-DDTHH:mm:ss[Z]`,
        IE = jx(
          `moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.`,
          function (e) {
            return e === void 0 ? this.localeData() : this.locale(e);
          },
        ),
        LE = 1e3,
        RE = 60 * LE,
        zE = 60 * RE,
        BE = 146097 * 24 * zE,
        zx(`N`, 0, 0, `eraAbbr`),
        zx(`NN`, 0, 0, `eraAbbr`),
        zx(`NNN`, 0, 0, `eraAbbr`),
        zx(`NNNN`, 0, 0, `eraName`),
        zx(`NNNNN`, 0, 0, `eraNarrow`),
        zx(`y`, [`y`, 1], `yo`, `eraYear`),
        zx(`y`, [`yy`, 2], 0, `eraYear`),
        zx(`y`, [`yyy`, 3], 0, `eraYear`),
        zx(`y`, [`yyyy`, 4], 0, `eraYear`),
        Qx(`N`, Uw),
        Qx(`NN`, Uw),
        Qx(`NNN`, Uw),
        Qx(`NNNN`, zie),
        Qx(`NNNNN`, Bie),
        iS([`N`, `NN`, `NNN`, `NNNN`, `NNNNN`], function (e, t, n, r) {
          var i = n._locale.erasParse(e, r, n._strict);
          i ? (wx(n).era = i) : (wx(n).invalidEra = e);
        }),
        Qx(`y`, PT),
        Qx(`yy`, PT),
        Qx(`yyy`, PT),
        Qx(`yyyy`, PT),
        Qx(`yo`, Vie),
        iS([`y`, `yy`, `yyy`, `yyyy`], WT),
        iS([`yo`], function (e, t, n, r) {
          var i;
          (n._locale._eraYearOrdinalRegex && (i = e.match(n._locale._eraYearOrdinalRegex)),
            n._locale.eraYearOrdinalParse
              ? (t[WT] = n._locale.eraYearOrdinalParse(e, i))
              : (t[WT] = parseInt(e, 10)));
        }),
        zx(0, [`gg`, 2], 0, function () {
          return this.weekYear() % 100;
        }),
        zx(0, [`GG`, 2], 0, function () {
          return this.isoWeekYear() % 100;
        }),
        Gw(`gggg`, `weekYear`),
        Gw(`ggggg`, `weekYear`),
        Gw(`GGGG`, `isoWeekYear`),
        Gw(`GGGGG`, `isoWeekYear`),
        Qx(`G`, FT),
        Qx(`g`, FT),
        Qx(`GG`, OT, wT),
        Qx(`gg`, OT, wT),
        Qx(`GGGG`, MT, ET),
        Qx(`gggg`, MT, ET),
        Qx(`GGGGG`, NT, DT),
        Qx(`ggggg`, NT, DT),
        aS([`gggg`, `ggggg`, `GGGG`, `GGGGG`], function (e, t, n, r) {
          t[r.substr(0, 2)] = rS(e);
        }),
        aS([`gg`, `GG`], function (e, t, n, r) {
          t[r] = dx.parseTwoDigitYear(e);
        }),
        zx(`Q`, 0, `Qo`, `quarter`),
        Qx(`Q`, CT),
        iS(`Q`, function (e, t) {
          t[GT] = (rS(e) - 1) * 3;
        }),
        zx(`D`, [`DD`, 2], `Do`, `date`),
        Qx(`D`, OT, BT),
        Qx(`DD`, OT, wT),
        Qx(`Do`, function (e, t) {
          return e
            ? t._dayOfMonthOrdinalParse || t._ordinalParse
            : t._dayOfMonthOrdinalParseLenient;
        }),
        iS([`D`, `DD`], KT),
        iS(`Do`, function (e, t) {
          t[KT] = rS(e.match(OT)[0]);
        }),
        VE = uS(`Date`, !0),
        zx(`DDD`, [`DDDD`, 3], `DDDo`, `dayOfYear`),
        Qx(`DDD`, jT),
        Qx(`DDDD`, TT),
        iS([`DDD`, `DDDD`], function (e, t, n) {
          n._dayOfYear = rS(e);
        }),
        zx(`m`, [`mm`, 2], 0, `minute`),
        Qx(`m`, OT, VT),
        Qx(`mm`, OT, wT),
        iS([`m`, `mm`], JT),
        HE = uS(`Minutes`, !1),
        zx(`s`, [`ss`, 2], 0, `second`),
        Qx(`s`, OT, VT),
        Qx(`ss`, OT, wT),
        iS([`s`, `ss`], YT),
        UE = uS(`Seconds`, !1),
        zx(`S`, 0, 0, function () {
          return ~~(this.millisecond() / 100);
        }),
        zx(0, [`SS`, 2], 0, function () {
          return ~~(this.millisecond() / 10);
        }),
        zx(0, [`SSS`, 3], 0, `millisecond`),
        zx(0, [`SSSS`, 4], 0, function () {
          return this.millisecond() * 10;
        }),
        zx(0, [`SSSSS`, 5], 0, function () {
          return this.millisecond() * 100;
        }),
        zx(0, [`SSSSSS`, 6], 0, function () {
          return this.millisecond() * 1e3;
        }),
        zx(0, [`SSSSSSS`, 7], 0, function () {
          return this.millisecond() * 1e4;
        }),
        zx(0, [`SSSSSSSS`, 8], 0, function () {
          return this.millisecond() * 1e5;
        }),
        zx(0, [`SSSSSSSSS`, 9], 0, function () {
          return this.millisecond() * 1e6;
        }),
        Qx(`S`, jT, CT),
        Qx(`SS`, jT, wT),
        Qx(`SSS`, jT, TT),
        WE = `SSSS`;
      WE.length <= 9;
      WE += `S`
    )
      Qx(WE, PT);
    for (WE = `S`; WE.length <= 9; WE += `S`) iS(WE, Zie);
    ((GE = uS(`Milliseconds`, !1)),
      zx(`z`, 0, 0, `zoneAbbr`),
      zx(`zz`, 0, 0, `zoneName`),
      (KE = Ox.prototype),
      (KE.add = PE),
      (KE.calendar = bw),
      (KE.clone = xw),
      (KE.diff = Ow),
      (KE.endOf = vie),
      (KE.format = Nw),
      (KE.from = Pw),
      (KE.fromNow = Fw),
      (KE.to = Iw),
      (KE.toNow = Lw),
      (KE.get = pS),
      (KE.invalidAt = Die),
      (KE.isAfter = Sw),
      (KE.isBefore = Cw),
      (KE.isBetween = ww),
      (KE.isSame = Tw),
      (KE.isSameOrAfter = Ew),
      (KE.isSameOrBefore = Dw),
      (KE.isValid = Tie),
      (KE.lang = IE),
      (KE.locale = Rw),
      (KE.localeData = zw),
      (KE.max = OE),
      (KE.min = DE),
      (KE.parsingFlags = Eie),
      (KE.set = mS),
      (KE.startOf = _ie),
      (KE.subtract = FE),
      (KE.toArray = Sie),
      (KE.toObject = Cie),
      (KE.toDate = xie),
      (KE.toISOString = jw),
      (KE.inspect = Mw),
      typeof Symbol < `u` &&
        Symbol.for != null &&
        (KE[Symbol.for(`nodejs.util.inspect.custom`)] = function () {
          return `Moment<` + this.format() + `>`;
        }),
      (KE.toJSON = wie),
      (KE.toString = Aw),
      (KE.unix = bie),
      (KE.valueOf = yie),
      (KE.creationData = Oie),
      (KE.eraName = Mie),
      (KE.eraNarrow = Nie),
      (KE.eraAbbr = Pie),
      (KE.eraYear = Fie),
      (KE.year = $T),
      (KE.isLeapYear = lS),
      (KE.weekYear = Hie),
      (KE.isoWeekYear = Uie),
      (KE.quarter = KE.quarters = Yie),
      (KE.month = SS),
      (KE.daysInMonth = CS),
      (KE.week = KE.weeks = IS),
      (KE.isoWeek = KE.isoWeeks = LS),
      (KE.weeksInYear = Kie),
      (KE.weeksInWeekYear = qie),
      (KE.isoWeeksInYear = Wie),
      (KE.isoWeeksInISOWeekYear = Gie),
      (KE.date = VE),
      (KE.day = KE.days = KS),
      (KE.weekday = qS),
      (KE.isoWeekday = JS),
      (KE.dayOfYear = Xie),
      (KE.hour = KE.hours = mE),
      (KE.minute = KE.minutes = HE),
      (KE.second = KE.seconds = UE),
      (KE.millisecond = KE.milliseconds = GE),
      (KE.utcOffset = ZC),
      (KE.utc = $C),
      (KE.local = ew),
      (KE.parseZone = tw),
      (KE.hasAlignedHourOffset = nw),
      (KE.isDST = rw),
      (KE.isLocal = aw),
      (KE.isUtcOffset = ow),
      (KE.isUtc = sw),
      (KE.isUTC = sw),
      (KE.zoneAbbr = Qie),
      (KE.zoneName = $ie),
      (KE.dates = jx(`dates accessor is deprecated. Use date instead.`, VE)),
      (KE.months = jx(`months accessor is deprecated. Use month instead`, SS)),
      (KE.years = jx(`years accessor is deprecated. Use year instead`, $T)),
      (KE.zone = jx(
        `moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/`,
        QC,
      )),
      (KE.isDSTShifted = jx(
        `isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information`,
        iw,
      )),
      (qE = Ix.prototype),
      (qE.calendar = Lx),
      (qE.longDateFormat = Wx),
      (qE.invalidDate = Gx),
      (qE.ordinal = Kx),
      (qE.preparse = qw),
      (qE.postformat = qw),
      (qE.relativeTime = qx),
      (qE.pastFuture = Jx),
      (qE.set = Px),
      (qE.eras = kie),
      (qE.erasParse = Aie),
      (qE.erasConvertYear = jie),
      (qE.erasAbbrRegex = Lie),
      (qE.erasNameRegex = Iie),
      (qE.erasNarrowRegex = Rie),
      (qE.months = _S),
      (qE.monthsShort = vS),
      (qE.monthsParse = bS),
      (qE.monthsRegex = TS),
      (qE.monthsShortRegex = wS),
      (qE.week = NS),
      (qE.firstDayOfYear = FS),
      (qE.firstDayOfWeek = PS),
      (qE.weekdays = VS),
      (qE.weekdaysMin = US),
      (qE.weekdaysShort = HS),
      (qE.weekdaysParse = GS),
      (qE.weekdaysRegex = YS),
      (qE.weekdaysShortRegex = XS),
      (qE.weekdaysMinRegex = ZS),
      (qE.isPM = rC),
      (qE.meridiem = iC),
      uC(`en`, {
        eras: [
          {
            since: `0001-01-01`,
            until: 1 / 0,
            offset: 1,
            name: `Anno Domini`,
            narrow: `AD`,
            abbr: `AD`,
          },
          {
            since: `0000-12-31`,
            until: -1 / 0,
            offset: 1,
            name: `Before Christ`,
            narrow: `BC`,
            abbr: `BC`,
          },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (e) {
          var t = e % 10;
          return (
            e +
            (rS((e % 100) / 10) === 1
              ? `th`
              : t === 1
                ? `st`
                : t === 2
                  ? `nd`
                  : t === 3
                    ? `rd`
                    : `th`)
          );
        },
      }),
      (dx.lang = jx(`moment.lang is deprecated. Use moment.locale instead.`, uC)),
      (dx.langData = jx(`moment.langData is deprecated. Use moment.localeData instead.`, pC)),
      (JE = Math.abs),
      (YE = tT(`ms`)),
      (XE = tT(`s`)),
      (ZE = tT(`m`)),
      (QE = tT(`h`)),
      ($E = tT(`d`)),
      (eD = tT(`w`)),
      (tD = tT(`M`)),
      (nD = tT(`Q`)),
      (rD = tT(`y`)),
      (iD = YE),
      (aD = nT(`milliseconds`)),
      (oD = nT(`seconds`)),
      (sD = nT(`minutes`)),
      (cD = nT(`hours`)),
      (lD = nT(`days`)),
      (uD = nT(`months`)),
      (dD = nT(`years`)),
      (fD = Math.round),
      (pD = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11,
      }),
      (mD = Math.abs),
      (hD = UC.prototype),
      (hD.isValid = VC),
      (hD.abs = sae),
      (hD.add = cae),
      (hD.subtract = lae),
      (hD.as = dae),
      (hD.asMilliseconds = YE),
      (hD.asSeconds = XE),
      (hD.asMinutes = ZE),
      (hD.asHours = QE),
      (hD.asDays = $E),
      (hD.asWeeks = eD),
      (hD.asMonths = tD),
      (hD.asQuarters = nD),
      (hD.asYears = rD),
      (hD.valueOf = iD),
      (hD._bubble = uae),
      (hD.clone = fae),
      (hD.get = pae),
      (hD.milliseconds = aD),
      (hD.seconds = oD),
      (hD.minutes = sD),
      (hD.hours = cD),
      (hD.days = lD),
      (hD.weeks = mae),
      (hD.months = uD),
      (hD.years = dD),
      (hD.humanize = yae),
      (hD.toISOString = iT),
      (hD.toString = iT),
      (hD.toJSON = iT),
      (hD.locale = Rw),
      (hD.localeData = zw),
      (hD.toIsoString = jx(
        `toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)`,
        iT,
      )),
      (hD.lang = IE),
      zx(`X`, 0, 0, `unix`),
      zx(`x`, 0, 0, `valueOf`),
      Qx(`x`, FT),
      Qx(`X`, RT),
      iS(`X`, function (e, t, n) {
        n._d = new Date(parseFloat(e) * 1e3);
      }),
      iS(`x`, function (e, t, n) {
        n._d = new Date(rS(e));
      }),
      (dx.version = `2.30.1`),
      fx(IC),
      (dx.fn = KE),
      (dx.min = RC),
      (dx.max = zC),
      (dx.now = kE),
      (dx.utc = Sx),
      (dx.unix = eae),
      (dx.months = nae),
      (dx.isDate = yx),
      (dx.locale = uC),
      (dx.invalid = Ex),
      (dx.duration = cw),
      (dx.isMoment = kx),
      (dx.weekdays = iae),
      (dx.parseZone = tae),
      (dx.localeData = pC),
      (dx.isDuration = WC),
      (dx.monthsShort = rae),
      (dx.weekdaysMin = oae),
      (dx.defineLocale = dC),
      (dx.updateLocale = fC),
      (dx.locales = mC),
      (dx.weekdaysShort = aae),
      (dx.normalizeUnits = Yx),
      (dx.relativeTimeRounding = _ae),
      (dx.relativeTimeThreshold = vae),
      (dx.calendarFormat = yw),
      (dx.prototype = KE),
      (dx.HTML5_FMT = {
        DATETIME_LOCAL: `YYYY-MM-DDTHH:mm`,
        DATETIME_LOCAL_SECONDS: `YYYY-MM-DDTHH:mm:ss`,
        DATETIME_LOCAL_MS: `YYYY-MM-DDTHH:mm:ss.SSS`,
        DATE: `YYYY-MM-DD`,
        TIME: `HH:mm`,
        TIME_SECONDS: `HH:mm:ss`,
        TIME_MS: `HH:mm:ss.SSS`,
        WEEK: `GGGG-[W]WW`,
        MONTH: `YYYY-MM`,
      }));
  }),
  bae = i({
    default: () => Cae,
  });
(B(), gD());
var xae = {
    key: 0,
    class: `gap-2`,
  },
  Sae = [`id`, `placeholder`, `value`],
  Cae = Object.assign(
    {
      name: `InputDatePicker`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        placeholder: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: String,
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
        noClear: {
          type: Boolean,
          default: !1,
        },
        slim: {
          type: Boolean,
          default: !1,
        },
        isRequired: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`update:modelValue`, `update:error`, `change`],
      setup(e, { emit: t }) {
        let { isRtl: n } = Kh(),
          r = e,
          i = t,
          a = Vh(`system`),
          o = V(() => {
            let e =
              a.value?.inputDateFormat ||
              a.value?.inputDatePicker ||
              a.value?.input_date_format ||
              `YYYY-MM-DD`;
            return String(e).toUpperCase();
          }),
          s = V(() => o.value.match(/(YYYY|YY|MM|DD)/g) || []),
          c = V(() => {
            let e = o.value.match(/[^A-Z]/);
            return e ? e[0] : `-`;
          }),
          l = V(() => o.value),
          u = V(() => [
            `focus:border-primary block w-full border-0 border-gray-300 bg-transparent text-sm focus:ring-0 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-200`,
            n.value ? `pr-10` : `pl-10`,
            {
              "pl-10": !r.noClear && !n.value,
              "pr-10": !r.noClear && n.value,
              "border-b-2 shadow-xs": !r.slim,
              "py-0 text-xs": r.slim,
            },
          ]),
          d = Ae({
            uniqueId: Math.random().toString(16).slice(2),
            manualInput: ``,
          }),
          f = (e) => {
            let t = (e || ``).replace(/\D/g, ``),
              n = 0;
            return s.value
              .map((e) => {
                let r = e.length,
                  i = t.slice(n, n + r);
                return ((n += r), i);
              })
              .filter(Boolean)
              .join(c.value);
          },
          p = (e) => {
            let t = s.value.reduce((e, t) => e + t.length, 0);
            if ((e || ``).replace(/\D/g, ``).length !== t) return ``;
            let n = dx(e, o.value, !0);
            return n.isValid() ? n.format(`YYYY-MM-DD`) : ``;
          },
          m = (e) => {
            let t = dx(e, [`YYYY-MM-DD`, o.value], !0);
            return t.isValid() ? t.format(o.value) : ``;
          },
          h = (e) => {
            d.manualInput = dx(e, [`YYYY-MM-DD`, o.value], !0).isValid() ? m(e) : ``;
          },
          g = (e) => {
            i(`update:error`, ``);
            let t = f(e.target.value);
            d.manualInput = t;
            let n = p(t);
            (i(`update:modelValue`, n), i(`change`, n));
          },
          v = () => {
            ((d.manualInput = ``),
              i(`update:error`, ``),
              i(`update:modelValue`, ``),
              i(`change`, ``));
          };
        return (
          He(
            () => r.modelValue,
            (e) => {
              h(e);
            },
            {
              immediate: !0,
            },
          ),
          (t, r) => {
            let i = j(`IsRequired`),
              a = j(`BaseLabel`),
              o = j(`FormError`),
              s = ve(`tooltip`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  e.label
                    ? (A(),
                      L(
                        a,
                        {
                          key: 0,
                          for: d.uniqueId,
                        },
                        {
                          default: I(() => [
                            W(`span`, null, [
                              H(T(e.label) + ` `, 1),
                              N(
                                i,
                                {
                                  "is-required": e.isRequired,
                                },
                                null,
                                8,
                                [`is-required`],
                              ),
                            ]),
                            e.labelHint
                              ? Re(
                                  (A(),
                                  M(`span`, xae, [
                                    ...(r[0] ||= [
                                      W(
                                        `i`,
                                        {
                                          class: `fas fa-question-circle`,
                                        },
                                        null,
                                        -1,
                                      ),
                                    ]),
                                  ])),
                                  [[s, e.labelHint]],
                                )
                              : U(``, !0),
                          ]),
                          _: 1,
                        },
                        8,
                        [`for`],
                      ))
                    : U(``, !0),
                  W(
                    `div`,
                    {
                      class: O([
                        `relative`,
                        {
                          "mt-1": e.label,
                        },
                      ]),
                    },
                    [
                      W(
                        `div`,
                        {
                          class: O([
                            `pointer-events-none absolute inset-y-0 z-10 flex items-center`,
                            P(n) ? `right-0 pr-3` : `left-0 pl-3`,
                          ]),
                        },
                        [
                          ...(r[1] ||= [
                            W(
                              `i`,
                              {
                                class: `fas fa-calendar text-gray-400`,
                                "aria-hidden": `true`,
                              },
                              null,
                              -1,
                            ),
                          ]),
                        ],
                        2,
                      ),
                      W(
                        `input`,
                        ce(
                          {
                            id: d.uniqueId,
                          },
                          t.$attrs,
                          {
                            type: `text`,
                            inputmode: `numeric`,
                            autocomplete: `off`,
                            placeholder: l.value,
                            value: d.manualInput,
                            class: u.value,
                            onInput: g,
                          },
                        ),
                        null,
                        16,
                        Sae,
                      ),
                      !e.noClear && d.manualInput
                        ? (A(),
                          M(
                            `div`,
                            {
                              key: 0,
                              class: O([
                                `absolute inset-y-0 z-10 flex cursor-pointer items-center`,
                                P(n) ? `left-0 pl-3` : `right-0 pr-3`,
                              ]),
                              onClick: v,
                            },
                            [
                              ...(r[2] ||= [
                                W(
                                  `i`,
                                  {
                                    class: `fas fa-times text-gray-400`,
                                    "aria-hidden": `true`,
                                  },
                                  null,
                                  -1,
                                ),
                              ]),
                            ],
                            2,
                          ))
                        : U(``, !0),
                    ],
                    2,
                  ),
                  N(
                    o,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  wae = i({
    default: () => Eae,
  });
B();
var Tae = {
    key: 0,
    class: `ml-1`,
  },
  Eae = {
    __name: `IsRequired`,
    props: {
      isRequired: {
        type: Boolean,
        default: !1,
      },
    },
    setup(e) {
      return (t, n) =>
        e.isRequired
          ? (A(),
            M(`span`, Tae, [
              ...(n[0] ||= [
                W(
                  `i`,
                  {
                    class: `fas fa-asterisk text-red-500 fa-2xs`,
                  },
                  null,
                  -1,
                ),
              ]),
            ]))
          : U(``, !0);
    },
  },
  Dae = (e) => {
    let t = typeof e;
    return (t !== `function` && t !== `object`) || e === null;
  },
  Oae = (e) => {
    let t = e.flags === `` ? void 0 : e.flags;
    return new RegExp(e.source, t);
  },
  _D = (e, t = new WeakMap()) => {
    if (e === null || Dae(e)) return e;
    if (t.has(e)) return t.get(e);
    if (e instanceof RegExp) return Oae(e);
    if (e instanceof Date) return new Date(e.getTime());
    if (e instanceof Function) return e;
    if (e instanceof Map) {
      let n = new Map();
      return (
        t.set(e, n),
        e.forEach((e, r) => {
          n.set(r, _D(e, t));
        }),
        n
      );
    }
    if (e instanceof Set) {
      let n = new Set();
      t.set(e, n);
      for (let r of e) n.add(_D(r, t));
      return n;
    }
    if (Array.isArray(e)) {
      let n = [];
      return (
        t.set(e, n),
        e.forEach((e) => {
          n.push(_D(e, t));
        }),
        n
      );
    }
    let n = {};
    t.set(e, n);
    for (let r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = _D(e[r], t));
    return n;
  },
  vD = (e, t = 200) => {
    let n = 0;
    return (...r) =>
      new Promise((i) => {
        (n && (clearTimeout(n), i(`cancel`)),
          (n = window.setTimeout(() => {
            (e.apply(void 0, r), (n = 0), i(`done`));
          }, t)));
      });
  },
  kae = (
    e,
    t = {
      _blank: !0,
      nofollow: !0,
    },
  ) => {
    let n = document.createElement(`a`);
    ((n.href = e),
      t._blank && (n.target = `_blank`),
      t.nofollow && (n.rel = `noopener noreferrer`),
      n.click());
  },
  yD = () => {
    let e = -1;
    return (t, n, r, i = 100) => {
      let a = () => {
        r && (typeof i == `number` ? setTimeout(r, i) : r());
      };
      e !== -1 && (cancelAnimationFrame(e), a());
      let o = t.scrollTop,
        s = () => {
          e = -1;
          let r = n - o;
          ((o += r / 5),
            Math.abs(r) < 1
              ? (t.scrollTo(0, n), a())
              : (t.scrollTo(0, o), (e = requestAnimationFrame(s))));
        };
      e = requestAnimationFrame(s);
    };
  },
  Aae = (e, t = 200) => {
    let n = 0,
      r = null,
      i = (a) => {
        (n === 0 && (n = a),
          a - n >= t ? (e.apply(void 0, r), (r = null), (n = 0)) : window.requestAnimationFrame(i));
      };
    return (...e) => {
      (r === null && window.requestAnimationFrame(i), (r = e));
    };
  },
  jae = (e) => {
    let t = (t) => {
      let {
          scrollHeight: n,
          scrollWidth: r,
          offsetHeight: i,
          offsetWidth: a,
          scrollLeft: o,
          scrollTop: s,
        } = e,
        c = t.x,
        l = t.y,
        u = (t) => {
          let u = s + l - t.y,
            d = o + c - t.x,
            f = n - i,
            p = r - a,
            m = {};
          (d >= 0 && d <= p && (m.left = d), u >= 0 && u <= f && (m.top = u), e.scroll(m));
        };
      document.addEventListener(`mousemove`, u);
      let d = () => {
        (document.removeEventListener(`mousemove`, u), document.removeEventListener(`mouseup`, d));
      };
      document.addEventListener(`mouseup`, d);
    };
    return (
      e.addEventListener(`mousedown`, t),
      () => {
        e.removeEventListener(`mousedown`, t);
      }
    );
  },
  bD = () => `${Date.now().toString(36)}${Math.random().toString(36).substring(2)}`,
  xD = (e) => typeof e == `object` && !!e && !Array.isArray(e),
  Mae = new Set([`__proto__`, `constructor`, `prototype`]),
  Nae = (e) => !Mae.has(e),
  SD = (e, t, n = {}) => {
    if (Array.isArray(e) && Array.isArray(t)) return CD(e, t, n);
    let { excludeKeys: r } = n,
      i = e,
      a = t;
    for (let e of Object.keys(a)) {
      if (!Nae(e)) continue;
      let t = a[e],
        o = i[e];
      r && r(e)
        ? (i[e] = t)
        : Array.isArray(t) && Array.isArray(o)
          ? (i[e] = CD(o, t, n))
          : xD(t) && xD(o)
            ? (i[e] = SD(o, t, n))
            : (i[e] = t);
    }
    return e;
  },
  CD = (e, t, n) => {
    let r = e.slice();
    return (
      t.forEach((e, t) => {
        let i = r[t];
        Array.isArray(e) && Array.isArray(i)
          ? (r[t] = CD(i, e, n))
          : xD(e) && xD(i)
            ? (r[t] = SD(i, e, n))
            : (r[t] = e);
      }),
      r
    );
  },
  $ = `md-editor`,
  Pae = `MdEditor`,
  wD = `https://unpkg.com`,
  Fae = `${wD}/@highlightjs/cdn-assets@11.11.1/highlight.min.js`,
  TD = {
    main: `${wD}/prettier@3.8.1/standalone.js`,
    markdown: `${wD}/prettier@3.8.1/plugins/markdown.js`,
  },
  Iae = {
    css: `${wD}/cropperjs@1.6.2/dist/cropper.min.css`,
    js: `${wD}/cropperjs@1.6.2/dist/cropper.min.js`,
  },
  Lae = `${wD}/screenfull@5.2.0/dist/screenfull.js`,
  Rae = `${wD}/mermaid@11.12.3/dist/mermaid.min.js`,
  zae = {
    js: `${wD}/katex@0.16.33/dist/katex.min.js`,
    css: `${wD}/katex@0.16.33/dist/katex.min.css`,
  },
  ED = {
    a11y: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/a11y-light.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/a11y-dark.min.css`,
    },
    atom: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/atom-one-light.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/atom-one-dark.min.css`,
    },
    github: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/github.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/github-dark.min.css`,
    },
    gradient: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/gradient-light.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/gradient-dark.min.css`,
    },
    kimbie: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/kimbie-light.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/kimbie-dark.min.css`,
    },
    paraiso: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/paraiso-light.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/paraiso-dark.min.css`,
    },
    qtcreator: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/qtcreator-light.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/qtcreator-dark.min.css`,
    },
    stackoverflow: {
      light: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/stackoverflow-light.min.css`,
      dark: `${wD}/@highlightjs/cdn-assets@11.11.1/styles/stackoverflow-dark.min.css`,
    },
  },
  Bae = `${wD}/echarts@6.0.0/dist/echarts.min.js`,
  DD =
    `bold.underline.italic.strikeThrough.-.title.sub.sup.quote.unorderedList.orderedList.task.-.codeRow.code.link.image.table.mermaid.katex.-.revoke.next.save.=.prettier.pageFullscreen.fullscreen.preview.previewOnly.htmlPreview.catalog.github`.split(
      `.`,
    ),
  OD = [`markdownTotal`, `=`, `scrollSwitch`],
  kD = {
    "zh-CN": {
      toolbarTips: {
        bold: `加粗`,
        underline: `下划线`,
        italic: `斜体`,
        strikeThrough: `删除线`,
        title: `标题`,
        sub: `下标`,
        sup: `上标`,
        quote: `引用`,
        unorderedList: `无序列表`,
        orderedList: `有序列表`,
        task: `任务列表`,
        codeRow: `行内代码`,
        code: `块级代码`,
        link: `链接`,
        image: `图片`,
        table: `表格`,
        mermaid: `mermaid图`,
        katex: `katex公式`,
        revoke: `后退`,
        next: `前进`,
        save: `保存`,
        prettier: `美化`,
        pageFullscreen: `浏览器全屏`,
        fullscreen: `屏幕全屏`,
        preview: `预览`,
        previewOnly: `仅预览`,
        htmlPreview: `html代码预览`,
        catalog: `目录`,
        github: `源码地址`,
      },
      titleItem: {
        h1: `一级标题`,
        h2: `二级标题`,
        h3: `三级标题`,
        h4: `四级标题`,
        h5: `五级标题`,
        h6: `六级标题`,
      },
      imgTitleItem: {
        link: `添加链接`,
        upload: `上传图片`,
        clip2upload: `裁剪上传`,
      },
      linkModalTips: {
        linkTitle: `添加链接`,
        imageTitle: `添加图片`,
        descLabel: `链接描述：`,
        descLabelPlaceHolder: `请输入描述...`,
        urlLabel: `链接地址：`,
        urlLabelPlaceHolder: `请输入链接...`,
        buttonOK: `确定`,
      },
      clipModalTips: {
        title: `裁剪图片上传`,
        buttonUpload: `上传`,
      },
      copyCode: {
        text: `复制代码`,
        successTips: `已复制！`,
        failTips: `复制失败！`,
      },
      mermaid: {
        flow: `流程图`,
        sequence: `时序图`,
        gantt: `甘特图`,
        class: `类图`,
        state: `状态图`,
        pie: `饼图`,
        relationship: `关系图`,
        journey: `旅程图`,
      },
      katex: {
        inline: `行内公式`,
        block: `块级公式`,
      },
      footer: {
        markdownTotal: `字数`,
        scrollAuto: `同步滚动`,
      },
    },
    "en-US": {
      toolbarTips: {
        bold: `bold`,
        underline: `underline`,
        italic: `italic`,
        strikeThrough: `strikeThrough`,
        title: `title`,
        sub: `subscript`,
        sup: `superscript`,
        quote: `quote`,
        unorderedList: `unordered list`,
        orderedList: `ordered list`,
        task: `task list`,
        codeRow: `inline code`,
        code: `block-level code`,
        link: `link`,
        image: `image`,
        table: `table`,
        mermaid: `mermaid`,
        katex: `formula`,
        revoke: `revoke`,
        next: `undo revoke`,
        save: `save`,
        prettier: `prettier`,
        pageFullscreen: `fullscreen in page`,
        fullscreen: `fullscreen`,
        preview: `preview`,
        previewOnly: `preview only`,
        htmlPreview: `html preview`,
        catalog: `catalog`,
        github: `source code`,
      },
      titleItem: {
        h1: `Lv1 Heading`,
        h2: `Lv2 Heading`,
        h3: `Lv3 Heading`,
        h4: `Lv4 Heading`,
        h5: `Lv5 Heading`,
        h6: `Lv6 Heading`,
      },
      imgTitleItem: {
        link: `Add Image Link`,
        upload: `Upload Images`,
        clip2upload: `Crop And Upload`,
      },
      linkModalTips: {
        linkTitle: `Add Link`,
        imageTitle: `Add Image`,
        descLabel: `Desc:`,
        descLabelPlaceHolder: `Enter a description...`,
        urlLabel: `Link:`,
        urlLabelPlaceHolder: `Enter a link...`,
        buttonOK: `OK`,
      },
      clipModalTips: {
        title: `Crop Image`,
        buttonUpload: `Upload`,
      },
      copyCode: {
        text: `Copy`,
        successTips: `Copied!`,
        failTips: `Copy failed!`,
      },
      mermaid: {
        flow: `flow`,
        sequence: `sequence`,
        gantt: `gantt`,
        class: `class`,
        state: `state`,
        pie: `pie`,
        relationship: `relationship`,
        journey: `journey`,
      },
      katex: {
        inline: `inline`,
        block: `block`,
      },
      footer: {
        markdownTotal: `Character Count`,
        scrollAuto: `Scroll Auto`,
      },
    },
  },
  AD = {
    editorExtensions: {
      highlight: {
        js: Fae,
        css: ED,
      },
      prettier: {
        standaloneJs: TD.main,
        parserMarkdownJs: TD.markdown,
      },
      cropper: {
        ...Iae,
      },
      screenfull: {
        js: Lae,
      },
      mermaid: {
        js: Rae,
        enableZoom: !0,
      },
      katex: {
        ...zae,
      },
      echarts: {
        js: Bae,
        parseOption: (e) => Function(`return ${e}`)(),
      },
    },
    editorExtensionsAttrs: {},
    editorConfig: {
      languageUserDefined: {},
      mermaidTemplate: {},
      renderDelay: 500,
      zIndex: 2e4,
    },
    codeMirrorExtensions: (e) => e,
    markdownItConfig: () => {},
    markdownItPlugins: (e) => e,
    mermaidConfig: (e) => e,
    katexConfig: (e) => e,
    echartsConfig: (e) => e,
  },
  Vae = 0.1,
  jD = ({ instance: e, ctx: t, props: n = {} }, r = `default`) => {
    let i = e?.$slots[r] || t?.slots[r];
    return (i ? i(e) : ``) || n[r];
  };
B();
var Hae = {
    overlay: {
      type: [String, Object],
      default: ``,
    },
    visible: {
      type: Boolean,
      default: !1,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    relative: {
      type: String,
      default: `html`,
    },
    disabled: {
      type: Boolean,
      default: void 0,
    },
  },
  MD = k({
    name: `${$}-dropdown`,
    props: Hae,
    setup(e, t) {
      let n = `${$}-dropdown-hidden`,
        r = Ae({
          overlayClass: [n],
          overlayStyle: {},
          triggerHover: !1,
          overlayHover: !1,
        }),
        i = F(),
        a = F(),
        o = () => {
          if (e.disabled) return !1;
          r.triggerHover = !0;
          let t = i.value,
            n = a.value;
          if (!t || !n) return;
          let o = t.getBoundingClientRect(),
            s = t.offsetTop,
            c = t.offsetLeft,
            l = o.height,
            u = o.width,
            d = t.getRootNode(),
            f = d.querySelector(e.relative)?.scrollLeft || 0,
            p = d.querySelector(e.relative)?.clientWidth || 0,
            m = c - n.offsetWidth / 2 + u / 2 - f;
          (m + n.offsetWidth > f + p && (m = f + p - n.offsetWidth),
            m < 0 && (m = 0),
            (r.overlayStyle = {
              ...r.overlayStyle,
              insetBlockStart: s + l + `px`,
              insetInlineStart: m + `px`,
            }),
            e.onChange(!0));
        },
        s = () => {
          if (e.disabled) return !1;
          r.overlayHover = !0;
        };
      He(
        () => e.visible,
        (e) => {
          e ? (r.overlayClass = r.overlayClass.filter((e) => e !== n)) : r.overlayClass.push(n);
        },
      );
      let c = -1,
        l = (t) => {
          (i.value === t.target ? (r.triggerHover = !1) : (r.overlayHover = !1),
            clearTimeout(c),
            (c = window.setTimeout(() => {
              !r.overlayHover && !r.triggerHover && e.onChange(!1);
            }, 10)));
        };
      return (
        Qe(() => {
          (i.value.addEventListener(`mouseenter`, o),
            i.value.addEventListener(`mouseleave`, l),
            a.value.addEventListener(`mouseenter`, s),
            a.value.addEventListener(`mouseleave`, l));
        }),
        oe(() => {
          (i.value.removeEventListener(`mouseenter`, o),
            i.value.removeEventListener(`mouseleave`, l),
            a.value.removeEventListener(`mouseenter`, s),
            a.value.removeEventListener(`mouseleave`, l));
        }),
        () => {
          let n = jD({
              ctx: t,
            }),
            o = jD(
              {
                props: e,
                ctx: t,
              },
              `overlay`,
            );
          return [
            ye(n instanceof Array ? n[0] : n, {
              ref: i,
              key: `cloned-dropdown-trigger`,
            }),
            N(
              `div`,
              {
                class: [`${$}-dropdown`, r.overlayClass],
                style: r.overlayStyle,
                ref: a,
              },
              [
                N(
                  `div`,
                  {
                    class: `${$}-dropdown-overlay`,
                  },
                  [o instanceof Array ? o[0] : o],
                ),
              ],
            ),
          ];
        }
      );
    },
  }),
  ND = k({
    name: `DropdownToolbar`,
    props: {
      title: {
        type: String,
        default: ``,
      },
      visible: {
        type: Boolean,
        default: void 0,
      },
      trigger: {
        type: [String, Object],
        default: void 0,
      },
      onChange: {
        type: Function,
        default: void 0,
      },
      overlay: {
        type: [String, Object],
        default: void 0,
      },
      insert: {
        type: Function,
        default: void 0,
      },
      language: {
        type: String,
        default: void 0,
      },
      theme: {
        type: String,
        default: void 0,
      },
      previewTheme: {
        type: String,
        default: void 0,
      },
      codeTheme: {
        type: String,
        default: void 0,
      },
      disabled: {
        type: Boolean,
        default: void 0,
      },
      showToolbarName: {
        type: Boolean,
        default: void 0,
      },
    },
    emits: [`onChange`],
    setup(e, t) {
      let n = R(`editorId`),
        r = (n) => {
          (e.onChange?.(n), t.emit(`onChange`, n));
        };
      return () => {
        let i = jD(
            {
              props: e,
              ctx: t,
            },
            `trigger`,
          ),
          a = jD(
            {
              props: e,
              ctx: t,
            },
            `overlay`,
          ),
          o = jD({
            props: e,
            ctx: t,
          });
        return N(
          MD,
          {
            relative: `#${n}-toolbar-wrapper`,
            visible: e.visible,
            onChange: r,
            overlay: a,
            disabled: e.disabled,
          },
          {
            default: () => [
              N(
                `button`,
                {
                  class: [`${$}-toolbar-item`, e.disabled && `md-editor-disabled`],
                  title: e.title || ``,
                  disabled: e.disabled,
                  type: `button`,
                },
                [o || i],
              ),
            ],
          },
        );
      };
    },
  });
ND.install = (e) => (e.component(ND.name, ND), e);
var PD = `onSave`,
  FD = `changeCatalogVisible`,
  ID = `changeFullscreen`,
  LD = `pageFullscreenChanged`,
  RD = `fullscreenChanged`,
  zD = `previewChanged`,
  BD = `previewOnlyChanged`,
  VD = `htmlPreviewChanged`,
  HD = `catalogVisibleChanged`,
  UD = `buildFinished`,
  WD = `errorCatcher`,
  GD = `replace`,
  KD = `uploadImage`,
  qD = `ctrlZ`,
  JD = `ctrlShiftZ`,
  YD = `catalogChanged`,
  XD = `pushCatalog`,
  ZD = `rerender`,
  QD = `eventListener`,
  $D = `taskStateChanged`,
  eO = `sendEditorView`,
  tO = `getEditorView`,
  nO = new (class {
    pools = {};
    remove(e, t, n) {
      let r = this.pools[e] && this.pools[e][t];
      r && (this.pools[e][t] = r.filter((e) => e !== n));
    }
    clear(e) {
      this.pools[e] = {};
    }
    on(e, t) {
      return (
        this.pools[e] || (this.pools[e] = {}),
        this.pools[e][t.name] || (this.pools[e][t.name] = []),
        this.pools[e][t.name].push(t.callback),
        this.pools[e][t.name].includes(t.callback)
      );
    }
    emit(e, t, ...n) {
      this.pools[e] || (this.pools[e] = {});
      let r = this.pools[e][t];
      r &&
        r.forEach((e) => {
          try {
            e(...n);
          } catch (e) {
            console.error(`${t} monitor event exception！`, e);
          }
        });
    }
  })(),
  Uae = (e, t = `image.png`) => {
    let n = e.split(`,`),
      r = n[0].match(/:(.*?);/);
    if (r) {
      let e = r[1],
        i = atob(n[1]),
        a = i.length,
        o = new Uint8Array(a);
      for (; a--;) o[a] = i.charCodeAt(a);
      return new File([o], t, {
        type: e,
      });
    }
    return null;
  },
  Wae = (e, t) => {
    if (!e) return e;
    let n = t.split(`
`),
      r = [`<span rn-wrapper aria-hidden="true">`];
    return (
      n.forEach(() => {
        r.push(`<span></span>`);
      }),
      r.push(`</span>`),
      `<span class="${$}-code-block">${e}</span>${r.join(``)}`
    );
  },
  Gae = (e, t) => {
    if (!e || !t) return 0;
    let n = e?.getBoundingClientRect();
    if (t === document.documentElement) return n.top - t.clientTop;
    let r = t?.getBoundingClientRect();
    return n.top - r.top;
  },
  rO = (() => {
    let e = 0;
    return () => ++e;
  })();
B();
var Kae = `.${$}-preview > [data-line]`,
  iO = (e, t) => +getComputedStyle(e).getPropertyValue(t).replace(`px`, ``),
  qae = (e, t) => {
    let n = vD(() => {
        (e.removeEventListener(`scroll`, r),
          e.addEventListener(`scroll`, r),
          t.removeEventListener(`scroll`, r),
          t.addEventListener(`scroll`, r));
      }, 50),
      r = (i) => {
        let a = e.clientHeight,
          o = t.clientHeight,
          s = e.scrollHeight,
          c = t.scrollHeight,
          l = (s - a) / (c - o);
        i.target === e
          ? (t.removeEventListener(`scroll`, r),
            t.scrollTo({
              top: e.scrollTop / l,
            }),
            n())
          : (e.removeEventListener(`scroll`, r),
            e.scrollTo({
              top: t.scrollTop * l,
            }),
            n());
      };
    return [
      () => {
        n().finally(() => {
          e.dispatchEvent(new Event(`scroll`));
        });
      },
      () => {
        (e.removeEventListener(`scroll`, r), t.removeEventListener(`scroll`, r));
      },
    ];
  },
  Jae = (e, t, n) => {
    let { view: r } = n,
      i = yD(),
      a = (e) => r.lineBlockAt(r.state.doc.line(e + 1).from).top,
      o = (e) => r.lineBlockAt(r.state.doc.line(e + 1).from).bottom,
      s = [],
      c = [],
      l = [],
      u = () => {
        ((s = []),
          (c = Array.from(t.querySelectorAll(Kae))),
          (l = c.map((e) => Number(e.dataset.line))));
        let e = [...l],
          { lines: n } = r.state.doc,
          i = e.shift() || 0,
          a = e.shift() || n;
        for (let t = 0; t < n; t++)
          (t === a && ((i = t), (a = e.shift() || n)),
            s.push({
              start: i,
              end: a - 1,
            }));
      },
      d = (e, t) => {
        let n = 1;
        for (let e = c.length - 1; e - 1 >= 0; e--) {
          let r = c[e],
            i = c[e - 1];
          if (r.offsetTop + r.offsetHeight > t && i.offsetTop < t) {
            n = Number(i.dataset.line);
            break;
          }
        }
        for (let t = s.length - 1; t >= 0; t--) {
          let r = o(s[t].end),
            i = a(s[t].start);
          if (r > e && i <= e) {
            n = n < s[t].start ? n : s[t].start;
            break;
          }
        }
        return n;
      },
      f = 0,
      p = 0,
      m = () => {
        if (p !== 0) return !1;
        f++;
        let { scrollDOM: e, contentHeight: n } = r,
          c = iO(t, `padding-block-start`),
          l = r.lineBlockAtHeight(e.scrollTop),
          { number: u } = r.state.doc.lineAt(l.from),
          m = s[u - 1];
        if (!m) return !1;
        let h = 1,
          g = t.querySelector(`[data-line="${m.start}"]`) || t.firstElementChild?.firstElementChild,
          v = t.querySelector(`[data-line="${m.end + 1}"]`) || t.lastElementChild?.lastElementChild,
          y = e.scrollHeight - e.clientHeight,
          b = t.scrollHeight - t.clientHeight,
          x = a(m.start),
          S = o(m.end),
          C = g.offsetTop,
          w = v.offsetTop - C;
        (x === 0 &&
          ((C = 0), g === v ? ((c = 0), (S = n - e.offsetHeight), (w = b)) : (w = v.offsetTop)),
          (h = (e.scrollTop - x) / (S - x)));
        let T =
          v == t.lastElementChild?.lastElementChild ? v.offsetTop + v.clientHeight : v.offsetTop;
        if (S >= y || T > b) {
          let n = d(y, b);
          ((x = a(n)), (h = (e.scrollTop - x) / (y - x)));
          let r = t.querySelector(`[data-line="${n}"]`);
          (x > 0 && r && (C = r.offsetTop), (w = b - C + iO(t, `padding-block-start`)));
        }
        i(t, C - c + w * h, () => {
          f--;
        });
      },
      h = () => {
        if (f !== 0) return;
        p++;
        let { scrollDOM: n } = r,
          o = t.scrollTop,
          u = t.scrollHeight,
          m = n.scrollHeight - n.clientHeight,
          h = t.scrollHeight - t.clientHeight,
          g = t.firstElementChild?.firstElementChild,
          v = t.firstElementChild?.lastElementChild;
        if (l.length > 0) {
          let e = Math.ceil(l[l.length - 1] * (o / u)),
            n = l.findLastIndex((t) => t <= e);
          ((n = n === -1 ? 0 : n), (e = l[n]));
          for (let t = n; t >= 0 && t < l.length;)
            if (c[t].offsetTop > o) {
              if (t - 1 >= 0) {
                t--;
                continue;
              }
              ((e = -1), (n = t));
              break;
            } else {
              if (t + 1 < l.length && c[t + 1].offsetTop < o) {
                t++;
                continue;
              }
              ((e = l[t]), (n = t));
              break;
            }
          switch (n) {
            case -1:
              ((g = t.firstElementChild?.firstElementChild), (v = c[n]));
              break;
            case l.length - 1:
              ((g = c[n]), (v = t.firstElementChild?.lastElementChild));
              break;
            default:
              ((g = c[n]), (v = c[n + 1 === c.length ? n : n + 1]));
          }
        }
        let y =
            g === t.firstElementChild?.firstElementChild
              ? 0
              : g.offsetTop - iO(g, `margin-block-start`),
          b = v.offsetTop,
          x = 0,
          { start: S, end: C } = s[Number(g.dataset.line || 0)],
          w = a(S),
          T = a(C + 1 === r.state.doc.lines ? C : C + 1),
          E = 0;
        if (T > m || v.offsetTop + v.offsetHeight > h) {
          let e = d(m, h),
            n = t.querySelector(`[data-line="${e}"]`);
          ((y = n ? n.offsetTop - iO(n, `margin-block-start`) : y),
            (w = a(e)),
            (x = (o - y) / (h - y)),
            (E = m - w));
        } else
          g === t.firstElementChild?.firstElementChild
            ? (g === v && (b = v.offsetTop + v.offsetHeight + iO(v, `margin-block-end`)),
              (E = T),
              (x = Math.max(o / b, 0)))
            : ((x = Math.max((o - y) / (b - y), 0)), (E = T - w));
        i(e, w + E * x, () => {
          p--;
        });
      },
      g = (n) => {
        let { scrollDOM: i, contentHeight: a } = r;
        if (
          a <= i.clientHeight ||
          t.firstElementChild.clientHeight <= t.clientHeight ||
          r.state.doc.lines <= s[s.length - 1]?.end
        )
          return !1;
        n.target === e ? m() : h();
      };
    return [
      () => {
        (u(),
          e.addEventListener(`scroll`, g),
          t.addEventListener(`scroll`, g),
          e.dispatchEvent(new Event(`scroll`)));
      },
      () => {
        (e.removeEventListener(`scroll`, g), t.removeEventListener(`scroll`, g));
      },
    ];
  },
  aO = k({
    props: {
      tocItem: {
        type: Object,
        default: () => ({}),
      },
      mdHeadingId: {
        type: Function,
        default: () => {},
      },
      onActive: {
        type: Function,
        default: () => {},
      },
      onClick: {
        type: Function,
        default: () => {},
      },
      scrollElementOffsetTop: {
        type: Number,
        default: 0,
      },
    },
    setup(e) {
      let t = R(`scrollElementRef`),
        n = R(`roorNodeRef`),
        r = F();
      (He(
        () => e.tocItem.active,
        (t) => {
          t && e.onActive(e.tocItem, r.value);
        },
      ),
        Qe(() => {
          e.tocItem.active && e.onActive(e.tocItem, r.value);
        }));
      let i = (r) => {
        if ((r.stopPropagation(), e.onClick(r, e.tocItem), r.defaultPrevented)) return;
        let i = e.mdHeadingId({
            text: e.tocItem.text,
            level: e.tocItem.level,
            index: e.tocItem.index,
            currentToken: e.tocItem.currentToken,
            nextToken: e.tocItem.nextToken,
          }),
          a = n.value.getElementById(i),
          o = t.value;
        if (a && o) {
          let t = a.offsetParent,
            n = a.offsetTop;
          if (o.contains(t)) for (; t && o != t;) ((n += t?.offsetTop), (t = t?.offsetParent));
          let r = a.previousElementSibling,
            i = 0;
          (r || (i = iO(a, `margin-block-start`)),
            o?.scrollTo({
              top: n - e.scrollElementOffsetTop - i,
              behavior: `smooth`,
            }));
        }
      };
      return () =>
        N(
          `div`,
          {
            ref: r,
            class: [`${$}-catalog-link`, e.tocItem.active && `md-editor-catalog-active`],
            onClick: i,
          },
          [
            N(
              `span`,
              {
                title: e.tocItem.text,
              },
              [e.tocItem.text],
            ),
            e.tocItem.children &&
              e.tocItem.children.length > 0 &&
              N(
                `div`,
                {
                  class: `md-editor-catalog-wrapper`,
                },
                [
                  e.tocItem.children.map((t) =>
                    N(
                      aO,
                      {
                        mdHeadingId: e.mdHeadingId,
                        key: `${e.tocItem.text}-link-${t.level}-${t.text}`,
                        tocItem: t,
                        onActive: e.onActive,
                        onClick: e.onClick,
                        scrollElementOffsetTop: e.scrollElementOffsetTop,
                      },
                      null,
                    ),
                  ),
                ],
              ),
          ],
        );
    },
  }),
  oO = k({
    name: `MdCatalog`,
    props: {
      editorId: {
        type: String,
        default: void 0,
      },
      class: {
        type: String,
        default: ``,
      },
      mdHeadingId: {
        type: Function,
        default: ({ text: e }) => e,
      },
      scrollElement: {
        type: [String, Object],
        default: void 0,
      },
      theme: {
        type: String,
        default: `light`,
      },
      offsetTop: {
        type: Number,
        default: 20,
      },
      scrollElementOffsetTop: {
        type: Number,
        default: 0,
      },
      onClick: {
        type: Function,
        default: void 0,
      },
      onActive: {
        type: Function,
        default: void 0,
      },
      isScrollElementInShadow: {
        type: Boolean,
        default: !1,
      },
      syncWith: {
        type: String,
        default: `preview`,
      },
      catalogMaxDepth: {
        type: Number,
        default: void 0,
      },
    },
    emits: [`onClick`, `onActive`],
    setup(e, t) {
      let n = e.editorId,
        r = `#${n}-preview-wrapper`,
        i = Ae({
          list: [],
          show: !1,
          scrollElement: e.scrollElement || r,
        }),
        a = xe(),
        o = F(),
        s = F(),
        c = F(),
        l = F(),
        u = xe(),
        d = F({});
      (ge(`scrollElementRef`, s), ge(`roorNodeRef`, l));
      let f = V(() => {
          let t = [];
          return (
            i.list.forEach((n, r) => {
              if (e.catalogMaxDepth && n.level > e.catalogMaxDepth) return;
              let { text: i, level: o, line: s } = n,
                c = {
                  level: o,
                  text: i,
                  line: s,
                  index: r + 1,
                  active: a.value === n,
                };
              if (t.length === 0) t.push(c);
              else {
                let e = t[t.length - 1];
                if (c.level > e.level)
                  for (let t = e.level + 1; t <= 6; t++) {
                    let { children: t } = e;
                    if (!t) {
                      e.children = [c];
                      break;
                    }
                    if (((e = t[t.length - 1]), c.level <= e.level)) {
                      t.push(c);
                      break;
                    }
                  }
                else t.push(c);
              }
            }),
            t
          );
        }),
        p = () => {
          if (i.scrollElement instanceof HTMLElement) return i.scrollElement;
          let t = document;
          return (
            (i.scrollElement === r || e.isScrollElementInShadow) && (t = o.value?.getRootNode()),
            t.querySelector(i.scrollElement)
          );
        },
        m = (t) => {
          if (t.length === 0) return ((a.value = void 0), (i.list = []), !1);
          let { activeHead: n, activeIndex: r } = t.reduce(
              (t, n, r) => {
                let i = 0;
                if (e.syncWith === `preview`) {
                  let t = l.value?.getElementById(
                    e.mdHeadingId({
                      text: n.text,
                      level: n.level,
                      index: r + 1,
                      currentToken: n.currentToken,
                      nextToken: n.nextToken,
                    }),
                  );
                  t instanceof HTMLElement && (i = Gae(t, s.value));
                } else {
                  let e = u.value;
                  e &&
                    (i =
                      e.lineBlockAt(e.state.doc.line(n.line + 1).from).top - e.scrollDOM.scrollTop);
                }
                return i < e.offsetTop && i > t.minTop
                  ? {
                      activeHead: n,
                      activeIndex: r,
                      minTop: i,
                    }
                  : t;
              },
              {
                activeHead: t[0],
                activeIndex: 0,
                minTop: -(2 ** 53 - 1),
              },
            ),
            o = n,
            { catalogMaxDepth: c } = e;
          if (c && o.level > c) {
            for (let e = r; e >= 0; e--) {
              let n = t[e];
              if (n.level <= c) {
                o = n;
                break;
              }
            }
            if (o.level > c) {
              let e = t.find((e) => e.level <= c);
              e && (o = e);
            }
          }
          ((a.value = o), (i.list = t));
        },
        h = (n, r) => {
          ((d.value.top = r.offsetTop + iO(r, `padding-block-start`) + `px`),
            e.onActive?.(n, r),
            t.emit(`onActive`, n, r));
        },
        g = () => {
          m(i.list);
        },
        v = (t) => {
          if ((c.value?.removeEventListener(`scroll`, g), e.syncWith === `editor`))
            c.value = u.value?.scrollDOM;
          else {
            let e = p();
            ((s.value = e), (c.value = e === document.documentElement ? document : e));
          }
          (m(t), c.value?.addEventListener(`scroll`, g));
        },
        y = (e) => {
          u.value = e;
        };
      (He([() => e.syncWith, u, () => e.catalogMaxDepth], () => {
        v(i.list);
      }),
        Qe(() => {
          ((l.value = o.value.getRootNode()),
            nO.on(n, {
              name: YD,
              callback: v,
            }),
            nO.on(n, {
              name: tO,
              callback: y,
            }),
            nO.emit(n, XD),
            nO.emit(n, eO));
        }),
        oe(() => {
          (nO.remove(n, YD, v), nO.remove(n, tO, y), c.value?.removeEventListener(`scroll`, g));
        }));
      let b = (n, r) => {
        (e.onClick?.(n, r), t.emit(`onClick`, n, r));
      };
      return () =>
        N(
          `div`,
          {
            class: [`${$}-catalog`, e.theme === `dark` && `md-editor-catalog-dark`, e.class || ``],
            ref: o,
          },
          [
            f.value.length > 0 &&
              N(ke, null, [
                N(
                  `div`,
                  {
                    class: `md-editor-catalog-indicator`,
                    style: d.value,
                  },
                  null,
                ),
                N(
                  `div`,
                  {
                    class: `md-editor-catalog-container`,
                  },
                  [
                    f.value.map((t) =>
                      N(
                        aO,
                        {
                          mdHeadingId: e.mdHeadingId,
                          tocItem: t,
                          key: `link-${t.level}-${t.text}`,
                          onActive: h,
                          onClick: b,
                          scrollElementOffsetTop: e.scrollElementOffsetTop,
                        },
                        null,
                      ),
                    ),
                  ],
                ),
              ]),
          ],
        );
    },
  });
oO.install = (e) => (e.component(oO.name, oO), e);
async function sO(e) {
  if (typeof e == `string`) {
    if (window.isSecureContext && navigator.clipboard)
      return await navigator.clipboard.writeText(e);
    {
      let t = document.createElement(`textarea`),
        n = !1;
      if (
        ((t.value = e),
        (t.style.position = `fixed`),
        (t.style.opacity = 0),
        (t.style.zIndex = `-10000`),
        (t.style.top = `-10000`),
        document.body.appendChild(t),
        t.select(),
        (n = document.execCommand(`copy`)),
        document.body.removeChild(t),
        n)
      )
        return;
      throw Error(`Failed to copy content via "execCommand"!`);
    }
  }
}
var Yae = {
    copy: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy ${$}-icon"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>`,
    "collapse-tips": `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-chevron-left ${$}-icon"><circle cx="12" cy="12" r="10"/><path d="m14 16-4-4 4-4"/></svg>`,
    pin: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pin ${$}-icon"><path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/></svg>`,
    "pin-off": `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pin-off ${$}-icon"><path d="M12 17v5"/><path d="M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89"/><path d="m2 2 20 20"/><path d="M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11"/></svg>`,
    check: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check ${$}-icon"><path d="M20 6 9 17l-5-5"/></svg>`,
  },
  cO = (e, t) => (typeof t[e] == `string` ? t[e] : Yae[e]),
  lO = (e, t) => {
    let n = (n) => {
      let r = e.parentElement || document.body,
        i = r.offsetWidth,
        a = r.offsetHeight,
        { clientWidth: o, clientHeight: s } = document.documentElement,
        c = n.offsetX,
        l = n.offsetY,
        u = (e) => {
          let n = e.x + document.body.scrollLeft - document.body.clientLeft - c,
            u = e.y + document.body.scrollTop - document.body.clientTop - l;
          ((n = n < 1 ? 1 : n < o - i - 1 ? n : o - i - 1),
            (u = u < 1 ? 1 : u < s - a - 1 ? u : s - a - 1),
            t ? t(n, u) : ((r.style.left = `${n}px`), (r.style.top = `${u}px`)));
        };
      document.addEventListener(`mousemove`, u);
      let d = () => {
        (document.removeEventListener(`mousemove`, u), document.removeEventListener(`mouseup`, d));
      };
      document.addEventListener(`mouseup`, d);
    };
    return (
      e.addEventListener(`mousedown`, n),
      () => {
        e.removeEventListener(`mousedown`, n);
      }
    );
  },
  uO = (e, t, n = ``) => {
    let r = document.getElementById(t.id);
    if (r)
      n !== `` &&
        (Reflect.get(window, n)
          ? t.onload?.call(r, new Event(`load`))
          : t.onload && r.addEventListener(`load`, t.onload));
    else {
      let n = {
        ...t,
      };
      n.onload = null;
      let r = Zae(e, n);
      (t.onload && r.addEventListener(`load`, t.onload), document.head.appendChild(r));
    }
  },
  Xae = (e, t) => {
    (document.getElementById(t.id)?.remove(), uO(e, t));
  },
  Zae = (e, t) => {
    let n = document.createElement(e);
    return (
      Object.keys(t).forEach((e) => {
        t[e] !== void 0 && (n[e] = t[e]);
      }),
      n
    );
  },
  Qae = (e, t) => {
    let n = new Map();
    return (
      e?.forEach((e) => {
        let r = e.querySelector(`.${$}-mermaid-action`);
        r
          ? r.querySelector(`.md-editor-mermaid-copy`) ||
            r.insertAdjacentHTML(
              `beforeend`,
              `<span class="md-editor-mermaid-copy">${cO(`copy`, t.customIcon)}</span>`,
            )
          : (e.insertAdjacentHTML(
              `beforeend`,
              `<div class="${$}-mermaid-action"><span class="${$}-mermaid-copy">${cO(`copy`, t.customIcon)}</span></div>`,
            ),
            (r = e.querySelector(`.${$}-mermaid-action`)));
        let i = r.querySelector(`.${$}-mermaid-copy`),
          a = -1,
          o = () => {
            (clearTimeout(a),
              sO(e.dataset.content || ``)
                .then(() => {
                  i.innerHTML = cO(`check`, t.customIcon);
                })
                .catch(() => {
                  i.innerHTML = cO(`copy`, t.customIcon);
                })
                .finally(() => {
                  a = window.setTimeout(() => {
                    i.innerHTML = cO(`copy`, t.customIcon);
                  }, 1500);
                }));
          };
        (i.addEventListener(`click`, o),
          n.set(e, {
            removeClick: () => {
              i.removeEventListener(`click`, o);
            },
          }));
      }),
      () => {
        (n.forEach(({ removeClick: e }) => {
          e?.();
        }),
          n.clear());
      }
    );
  },
  $ae = (() => {
    let e = (e) => {
      if (!e) return () => {};
      let t = e.firstChild,
        n = 1,
        r = 0,
        i = 0,
        a = !1,
        o,
        s,
        c,
        l = 1,
        u = () => {
          t.style.transform = `translate(${r}px, ${i}px) scale(${n})`;
        },
        d = (e) => {
          e.touches.length === 1
            ? ((a = !0), (o = e.touches[0].clientX - r), (s = e.touches[0].clientY - i))
            : e.touches.length === 2 &&
              ((c = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY,
              )),
              (l = n));
        },
        f = (e) => {
          if ((e.preventDefault(), a && e.touches.length === 1))
            ((r = e.touches[0].clientX - o), (i = e.touches[0].clientY - s), u());
          else if (e.touches.length === 2) {
            let a =
                Math.hypot(
                  e.touches[0].clientX - e.touches[1].clientX,
                  e.touches[0].clientY - e.touches[1].clientY,
                ) / c,
              o = n;
            n = l * (1 + (a - 1));
            let s = (e.touches[0].clientX + e.touches[1].clientX) / 2,
              d = (e.touches[0].clientY + e.touches[1].clientY) / 2,
              f = t.getBoundingClientRect(),
              p = (s - f.left) / o,
              m = (d - f.top) / o;
            ((r -= p * (n - o)), (i -= m * (n - o)), u());
          }
        },
        p = () => {
          a = !1;
        },
        m = (e) => {
          e.preventDefault();
          let a = 0.02,
            o = n;
          e.deltaY < 0 ? (n += a) : (n = Math.max(0.1, n - a));
          let s = t.getBoundingClientRect(),
            c = e.clientX - s.left,
            l = e.clientY - s.top;
          ((r -= (c / o) * (n - o)), (i -= (l / o) * (n - o)), u());
        },
        h = (e) => {
          ((a = !0), (o = e.clientX - r), (s = e.clientY - i));
        },
        g = (e) => {
          a && ((r = e.clientX - o), (i = e.clientY - s), u());
        },
        v = () => {
          a = !1;
        },
        y = () => {
          a = !1;
        };
      return (
        e.addEventListener(`touchstart`, d, {
          passive: !1,
        }),
        e.addEventListener(`touchmove`, f, {
          passive: !1,
        }),
        e.addEventListener(`touchend`, p),
        e.addEventListener(`wheel`, m, {
          passive: !1,
        }),
        e.addEventListener(`mousedown`, h),
        e.addEventListener(`mousemove`, g),
        e.addEventListener(`mouseup`, v),
        e.addEventListener(`mouseleave`, y),
        () => {
          (e.removeEventListener(`touchstart`, d),
            e.removeEventListener(`touchmove`, f),
            e.removeEventListener(`touchend`, p),
            e.removeEventListener(`wheel`, m),
            e.removeEventListener(`mousedown`, h),
            e.removeEventListener(`mousemove`, g),
            e.removeEventListener(`mouseup`, v),
            e.removeEventListener(`mouseleave`, y));
        }
      );
    };
    return (t, n) => {
      let r = new Map();
      return (
        t?.forEach((t) => {
          let i = t.querySelector(`.${$}-mermaid-action`);
          i
            ? i.querySelector(`.md-editor-mermaid-zoom`) ||
              i.insertAdjacentHTML(
                `beforeend`,
                `<span class="md-editor-mermaid-zoom">${cO(`pin-off`, n.customIcon)}</span>`,
              )
            : (t.insertAdjacentHTML(
                `beforeend`,
                `<div class="${$}-mermaid-action"><span class="${$}-mermaid-zoom">${cO(`pin-off`, n.customIcon)}</span></div>`,
              ),
              (i = t.querySelector(`.${$}-mermaid-action`)));
          let a = i.querySelector(`.${$}-mermaid-zoom`),
            o = () => {
              let i = r.get(t);
              if (i?.removeEvent)
                (i.removeEvent(),
                  t.removeAttribute(`data-grab`),
                  r.set(t, {
                    removeClick: i.removeClick,
                  }),
                  (a.innerHTML = cO(`pin-off`, n.customIcon)));
              else {
                let o = e(t);
                (t.setAttribute(`data-grab`, ``),
                  r.set(t, {
                    removeEvent: o,
                    removeClick: i?.removeClick,
                  }),
                  (a.innerHTML = cO(`pin`, n.customIcon)));
              }
            };
          (a.addEventListener(`click`, o),
            r.set(t, {
              removeClick: () => a.removeEventListener(`click`, o),
            }));
        }),
        () => {
          (r.forEach(({ removeEvent: e, removeClick: t }) => {
            (e?.(), t?.());
          }),
            r.clear());
        }
      );
    };
  })(),
  dO = {};
function eoe(e) {
  let t = dO[e];
  if (t) return t;
  t = dO[e] = [];
  for (let e = 0; e < 128; e++) {
    let n = String.fromCharCode(e);
    t.push(n);
  }
  for (let n = 0; n < e.length; n++) {
    let r = e.charCodeAt(n);
    t[r] = `%` + (`0` + r.toString(16).toUpperCase()).slice(-2);
  }
  return t;
}
function fO(e, t) {
  typeof t != `string` && (t = fO.defaultChars);
  let n = eoe(t);
  return e.replace(/(%[a-f0-9]{2})+/gi, function (e) {
    let t = ``;
    for (let r = 0, i = e.length; r < i; r += 3) {
      let a = parseInt(e.slice(r + 1, r + 3), 16);
      if (a < 128) {
        t += n[a];
        continue;
      }
      if ((a & 224) == 192 && r + 3 < i) {
        let n = parseInt(e.slice(r + 4, r + 6), 16);
        if ((n & 192) == 128) {
          let e = ((a << 6) & 1984) | (n & 63);
          (e < 128 ? (t += `��`) : (t += String.fromCharCode(e)), (r += 3));
          continue;
        }
      }
      if ((a & 240) == 224 && r + 6 < i) {
        let n = parseInt(e.slice(r + 4, r + 6), 16),
          i = parseInt(e.slice(r + 7, r + 9), 16);
        if ((n & 192) == 128 && (i & 192) == 128) {
          let e = ((a << 12) & 61440) | ((n << 6) & 4032) | (i & 63);
          (e < 2048 || (e >= 55296 && e <= 57343) ? (t += `���`) : (t += String.fromCharCode(e)),
            (r += 6));
          continue;
        }
      }
      if ((a & 248) == 240 && r + 9 < i) {
        let n = parseInt(e.slice(r + 4, r + 6), 16),
          i = parseInt(e.slice(r + 7, r + 9), 16),
          o = parseInt(e.slice(r + 10, r + 12), 16);
        if ((n & 192) == 128 && (i & 192) == 128 && (o & 192) == 128) {
          let e = ((a << 18) & 1835008) | ((n << 12) & 258048) | ((i << 6) & 4032) | (o & 63);
          (e < 65536 || e > 1114111
            ? (t += `����`)
            : ((e -= 65536), (t += String.fromCharCode(55296 + (e >> 10), 56320 + (e & 1023)))),
            (r += 9));
          continue;
        }
      }
      t += `�`;
    }
    return t;
  });
}
((fO.defaultChars = `;/?:@&=+$,#`), (fO.componentChars = ``));
var pO = {};
function toe(e) {
  let t = pO[e];
  if (t) return t;
  t = pO[e] = [];
  for (let e = 0; e < 128; e++) {
    let n = String.fromCharCode(e);
    /^[0-9a-z]$/i.test(n)
      ? t.push(n)
      : t.push(`%` + (`0` + e.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < e.length; n++) t[e.charCodeAt(n)] = e[n];
  return t;
}
function mO(e, t, n) {
  (typeof t != `string` && ((n = t), (t = mO.defaultChars)), n === void 0 && (n = !0));
  let r = toe(t),
    i = ``;
  for (let t = 0, a = e.length; t < a; t++) {
    let o = e.charCodeAt(t);
    if (n && o === 37 && t + 2 < a && /^[0-9a-f]{2}$/i.test(e.slice(t + 1, t + 3))) {
      ((i += e.slice(t, t + 3)), (t += 2));
      continue;
    }
    if (o < 128) {
      i += r[o];
      continue;
    }
    if (o >= 55296 && o <= 57343) {
      if (o >= 55296 && o <= 56319 && t + 1 < a) {
        let n = e.charCodeAt(t + 1);
        if (n >= 56320 && n <= 57343) {
          ((i += encodeURIComponent(e[t] + e[t + 1])), t++);
          continue;
        }
      }
      i += `%EF%BF%BD`;
      continue;
    }
    i += encodeURIComponent(e[t]);
  }
  return i;
}
((mO.defaultChars = `;/?:@&=+$,-_.!~*'()#`), (mO.componentChars = `-_.!~*'()`));
function hO(e) {
  let t = ``;
  return (
    (t += e.protocol || ``),
    (t += e.slashes ? `//` : ``),
    (t += e.auth ? e.auth + `@` : ``),
    e.hostname && e.hostname.indexOf(`:`) !== -1
      ? (t += `[` + e.hostname + `]`)
      : (t += e.hostname || ``),
    (t += e.port ? `:` + e.port : ``),
    (t += e.pathname || ``),
    (t += e.search || ``),
    (t += e.hash || ``),
    t
  );
}
function gO() {
  ((this.protocol = null),
    (this.slashes = null),
    (this.auth = null),
    (this.port = null),
    (this.hostname = null),
    (this.hash = null),
    (this.search = null),
    (this.pathname = null));
}
var noe = /^([a-z0-9.+-]+:)/i,
  roe = /:[0-9]*$/,
  ioe = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
  _O = [
    `%`,
    `/`,
    `?`,
    `;`,
    `#`,
    `'`,
    `{`,
    `}`,
    `|`,
    `\\`,
    `^`,
    "`",
    `<`,
    `>`,
    `"`,
    "`",
    ` `,
    `\r`,
    `
`,
    `	`,
  ],
  vO = [`/`, `?`, `#`],
  aoe = 255,
  yO = /^[+a-z0-9A-Z_-]{0,63}$/,
  ooe = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  bO = {
    javascript: !0,
    "javascript:": !0,
  },
  xO = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0,
  };
function SO(e, t) {
  if (e && e instanceof gO) return e;
  let n = new gO();
  return (n.parse(e, t), n);
}
((gO.prototype.parse = function (e, t) {
  let n,
    r,
    i,
    a = e;
  if (((a = a.trim()), !t && e.split(`#`).length === 1)) {
    let e = ioe.exec(a);
    if (e) return ((this.pathname = e[1]), e[2] && (this.search = e[2]), this);
  }
  let o = noe.exec(a);
  if (
    (o && ((o = o[0]), (n = o.toLowerCase()), (this.protocol = o), (a = a.substr(o.length))),
    (t || o || a.match(/^\/\/[^@\/]+@[^@\/]+/)) &&
      ((i = a.substr(0, 2) === `//`),
      i && !(o && bO[o]) && ((a = a.substr(2)), (this.slashes = !0))),
    !bO[o] && (i || (o && !xO[o])))
  ) {
    let e = -1;
    for (let t = 0; t < vO.length; t++)
      ((r = a.indexOf(vO[t])), r !== -1 && (e === -1 || r < e) && (e = r));
    let t, n;
    ((n = e === -1 ? a.lastIndexOf(`@`) : a.lastIndexOf(`@`, e)),
      n !== -1 && ((t = a.slice(0, n)), (a = a.slice(n + 1)), (this.auth = t)),
      (e = -1));
    for (let t = 0; t < _O.length; t++)
      ((r = a.indexOf(_O[t])), r !== -1 && (e === -1 || r < e) && (e = r));
    (e === -1 && (e = a.length), a[e - 1] === `:` && e--);
    let i = a.slice(0, e);
    ((a = a.slice(e)), this.parseHost(i), (this.hostname = this.hostname || ``));
    let o = this.hostname[0] === `[` && this.hostname[this.hostname.length - 1] === `]`;
    if (!o) {
      let e = this.hostname.split(/\./);
      for (let t = 0, n = e.length; t < n; t++) {
        let n = e[t];
        if (n && !n.match(yO)) {
          let r = ``;
          for (let e = 0, t = n.length; e < t; e++)
            n.charCodeAt(e) > 127 ? (r += `x`) : (r += n[e]);
          if (!r.match(yO)) {
            let r = e.slice(0, t),
              i = e.slice(t + 1),
              o = n.match(ooe);
            (o && (r.push(o[1]), i.unshift(o[2])),
              i.length && (a = i.join(`.`) + a),
              (this.hostname = r.join(`.`)));
            break;
          }
        }
      }
    }
    (this.hostname.length > aoe && (this.hostname = ``),
      o && (this.hostname = this.hostname.substr(1, this.hostname.length - 2)));
  }
  let s = a.indexOf(`#`);
  s !== -1 && ((this.hash = a.substr(s)), (a = a.slice(0, s)));
  let c = a.indexOf(`?`);
  return (
    c !== -1 && ((this.search = a.substr(c)), (a = a.slice(0, c))),
    a && (this.pathname = a),
    xO[n] && this.hostname && !this.pathname && (this.pathname = ``),
    this
  );
}),
  (gO.prototype.parseHost = function (e) {
    let t = roe.exec(e);
    (t &&
      ((t = t[0]), t !== `:` && (this.port = t.substr(1)), (e = e.substr(0, e.length - t.length))),
      e && (this.hostname = e));
  }));
var soe = i({
    decode: () => fO,
    encode: () => mO,
    format: () => hO,
    parse: () => SO,
  }),
  CO =
    /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/,
  wO = /[\0-\x1F\x7F-\x9F]/,
  coe =
    /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/,
  TO =
    /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/,
  EO =
    /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/,
  DO = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/,
  loe = i({
    Any: () => CO,
    Cc: () => wO,
    Cf: () => coe,
    P: () => TO,
    S: () => EO,
    Z: () => DO,
  }),
  uoe = new Uint16Array(
    `ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻\xA0ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌`
      .split(``)
      .map((e) => e.charCodeAt(0)),
  ),
  doe = new Uint16Array(
    `Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢`.split(``).map((e) => e.charCodeAt(0)),
  ),
  foe = new Map([
    [0, 65533],
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376],
  ]),
  poe =
    String.fromCodePoint ??
    function (e) {
      let t = ``;
      return (
        e > 65535 &&
          ((e -= 65536),
          (t += String.fromCharCode(((e >>> 10) & 1023) | 55296)),
          (e = 56320 | (e & 1023))),
        (t += String.fromCharCode(e)),
        t
      );
    };
function moe(e) {
  return (e >= 55296 && e <= 57343) || e > 1114111 ? 65533 : (foe.get(e) ?? e);
}
var OO;
(function (e) {
  ((e[(e.NUM = 35)] = `NUM`),
    (e[(e.SEMI = 59)] = `SEMI`),
    (e[(e.EQUALS = 61)] = `EQUALS`),
    (e[(e.ZERO = 48)] = `ZERO`),
    (e[(e.NINE = 57)] = `NINE`),
    (e[(e.LOWER_A = 97)] = `LOWER_A`),
    (e[(e.LOWER_F = 102)] = `LOWER_F`),
    (e[(e.LOWER_X = 120)] = `LOWER_X`),
    (e[(e.LOWER_Z = 122)] = `LOWER_Z`),
    (e[(e.UPPER_A = 65)] = `UPPER_A`),
    (e[(e.UPPER_F = 70)] = `UPPER_F`),
    (e[(e.UPPER_Z = 90)] = `UPPER_Z`));
})((OO ||= {}));
var hoe = 32,
  kO;
(function (e) {
  ((e[(e.VALUE_LENGTH = 49152)] = `VALUE_LENGTH`),
    (e[(e.BRANCH_LENGTH = 16256)] = `BRANCH_LENGTH`),
    (e[(e.JUMP_TABLE = 127)] = `JUMP_TABLE`));
})((kO ||= {}));
function AO(e) {
  return e >= OO.ZERO && e <= OO.NINE;
}
function goe(e) {
  return (e >= OO.UPPER_A && e <= OO.UPPER_F) || (e >= OO.LOWER_A && e <= OO.LOWER_F);
}
function _oe(e) {
  return (e >= OO.UPPER_A && e <= OO.UPPER_Z) || (e >= OO.LOWER_A && e <= OO.LOWER_Z) || AO(e);
}
function voe(e) {
  return e === OO.EQUALS || _oe(e);
}
var jO;
(function (e) {
  ((e[(e.EntityStart = 0)] = `EntityStart`),
    (e[(e.NumericStart = 1)] = `NumericStart`),
    (e[(e.NumericDecimal = 2)] = `NumericDecimal`),
    (e[(e.NumericHex = 3)] = `NumericHex`),
    (e[(e.NamedEntity = 4)] = `NamedEntity`));
})((jO ||= {}));
var MO;
(function (e) {
  ((e[(e.Legacy = 0)] = `Legacy`),
    (e[(e.Strict = 1)] = `Strict`),
    (e[(e.Attribute = 2)] = `Attribute`));
})((MO ||= {}));
var yoe = class {
  constructor(e, t, n) {
    ((this.decodeTree = e),
      (this.emitCodePoint = t),
      (this.errors = n),
      (this.state = jO.EntityStart),
      (this.consumed = 1),
      (this.result = 0),
      (this.treeIndex = 0),
      (this.excess = 1),
      (this.decodeMode = MO.Strict));
  }
  startEntity(e) {
    ((this.decodeMode = e),
      (this.state = jO.EntityStart),
      (this.result = 0),
      (this.treeIndex = 0),
      (this.excess = 1),
      (this.consumed = 1));
  }
  write(e, t) {
    switch (this.state) {
      case jO.EntityStart:
        return e.charCodeAt(t) === OO.NUM
          ? ((this.state = jO.NumericStart), (this.consumed += 1), this.stateNumericStart(e, t + 1))
          : ((this.state = jO.NamedEntity), this.stateNamedEntity(e, t));
      case jO.NumericStart:
        return this.stateNumericStart(e, t);
      case jO.NumericDecimal:
        return this.stateNumericDecimal(e, t);
      case jO.NumericHex:
        return this.stateNumericHex(e, t);
      case jO.NamedEntity:
        return this.stateNamedEntity(e, t);
    }
  }
  stateNumericStart(e, t) {
    return t >= e.length
      ? -1
      : (e.charCodeAt(t) | hoe) === OO.LOWER_X
        ? ((this.state = jO.NumericHex), (this.consumed += 1), this.stateNumericHex(e, t + 1))
        : ((this.state = jO.NumericDecimal), this.stateNumericDecimal(e, t));
  }
  addToNumericResult(e, t, n, r) {
    if (t !== n) {
      let i = n - t;
      ((this.result = this.result * r ** +i + parseInt(e.substr(t, i), r)), (this.consumed += i));
    }
  }
  stateNumericHex(e, t) {
    let n = t;
    for (; t < e.length;) {
      let r = e.charCodeAt(t);
      if (AO(r) || goe(r)) t += 1;
      else return (this.addToNumericResult(e, n, t, 16), this.emitNumericEntity(r, 3));
    }
    return (this.addToNumericResult(e, n, t, 16), -1);
  }
  stateNumericDecimal(e, t) {
    let n = t;
    for (; t < e.length;) {
      let r = e.charCodeAt(t);
      if (AO(r)) t += 1;
      else return (this.addToNumericResult(e, n, t, 10), this.emitNumericEntity(r, 2));
    }
    return (this.addToNumericResult(e, n, t, 10), -1);
  }
  emitNumericEntity(e, t) {
    var n;
    if (this.consumed <= t)
      return (
        (n = this.errors) == null || n.absenceOfDigitsInNumericCharacterReference(this.consumed),
        0
      );
    if (e === OO.SEMI) this.consumed += 1;
    else if (this.decodeMode === MO.Strict) return 0;
    return (
      this.emitCodePoint(moe(this.result), this.consumed),
      this.errors &&
        (e !== OO.SEMI && this.errors.missingSemicolonAfterCharacterReference(),
        this.errors.validateNumericCharacterReference(this.result)),
      this.consumed
    );
  }
  stateNamedEntity(e, t) {
    let { decodeTree: n } = this,
      r = n[this.treeIndex],
      i = (r & kO.VALUE_LENGTH) >> 14;
    for (; t < e.length; t++, this.excess++) {
      let a = e.charCodeAt(t);
      if (((this.treeIndex = boe(n, r, this.treeIndex + Math.max(1, i), a)), this.treeIndex < 0))
        return this.result === 0 || (this.decodeMode === MO.Attribute && (i === 0 || voe(a)))
          ? 0
          : this.emitNotTerminatedNamedEntity();
      if (((r = n[this.treeIndex]), (i = (r & kO.VALUE_LENGTH) >> 14), i !== 0)) {
        if (a === OO.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== MO.Strict &&
          ((this.result = this.treeIndex), (this.consumed += this.excess), (this.excess = 0));
      }
    }
    return -1;
  }
  emitNotTerminatedNamedEntity() {
    var e;
    let { result: t, decodeTree: n } = this,
      r = (n[t] & kO.VALUE_LENGTH) >> 14;
    return (
      this.emitNamedEntityData(t, r, this.consumed),
      (e = this.errors) == null || e.missingSemicolonAfterCharacterReference(),
      this.consumed
    );
  }
  emitNamedEntityData(e, t, n) {
    let { decodeTree: r } = this;
    return (
      this.emitCodePoint(t === 1 ? r[e] & ~kO.VALUE_LENGTH : r[e + 1], n),
      t === 3 && this.emitCodePoint(r[e + 2], n),
      n
    );
  }
  end() {
    var e;
    switch (this.state) {
      case jO.NamedEntity:
        return this.result !== 0 &&
          (this.decodeMode !== MO.Attribute || this.result === this.treeIndex)
          ? this.emitNotTerminatedNamedEntity()
          : 0;
      case jO.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case jO.NumericHex:
        return this.emitNumericEntity(0, 3);
      case jO.NumericStart:
        return (
          (e = this.errors) == null || e.absenceOfDigitsInNumericCharacterReference(this.consumed),
          0
        );
      case jO.EntityStart:
        return 0;
    }
  }
};
function NO(e) {
  let t = ``,
    n = new yoe(e, (e) => (t += poe(e)));
  return function (e, r) {
    let i = 0,
      a = 0;
    for (; (a = e.indexOf(`&`, a)) >= 0;) {
      ((t += e.slice(i, a)), n.startEntity(r));
      let o = n.write(e, a + 1);
      if (o < 0) {
        i = a + n.end();
        break;
      }
      ((i = a + o), (a = o === 0 ? i + 1 : i));
    }
    let o = t + e.slice(i);
    return ((t = ``), o);
  };
}
function boe(e, t, n, r) {
  let i = (t & kO.BRANCH_LENGTH) >> 7,
    a = t & kO.JUMP_TABLE;
  if (i === 0) return a !== 0 && r === a ? n : -1;
  if (a) {
    let t = r - a;
    return t < 0 || t >= i ? -1 : e[n + t] - 1;
  }
  let o = n,
    s = o + i - 1;
  for (; o <= s;) {
    let t = (o + s) >>> 1,
      n = e[t];
    if (n < r) o = t + 1;
    else if (n > r) s = t - 1;
    else return e[t + i];
  }
  return -1;
}
var PO = NO(uoe);
NO(doe);
function xoe(e, t = MO.Legacy) {
  return PO(e, t);
}
function Soe(e) {
  return PO(e, MO.Strict);
}
var Coe = i({
  arrayReplaceAt: () => LO,
  asciiTrim: () => XO,
  assign: () => IO,
  escapeHtml: () => HO,
  escapeRE: () => Ioe,
  fromCodePoint: () => zO,
  has: () => Eoe,
  isMdAsciiPunct: () => qO,
  isPunctChar: () => GO,
  isPunctCharCode: () => KO,
  isSpace: () => UO,
  isString: () => FO,
  isValidEntityCode: () => RO,
  isWhiteSpace: () => WO,
  lib: () => Loe,
  normalizeReference: () => JO,
  unescapeAll: () => VO,
  unescapeMd: () => Aoe,
});
function woe(e) {
  return Object.prototype.toString.call(e);
}
function FO(e) {
  return woe(e) === `[object String]`;
}
var Toe = Object.prototype.hasOwnProperty;
function Eoe(e, t) {
  return Toe.call(e, t);
}
function IO(e) {
  return (
    Array.prototype.slice.call(arguments, 1).forEach(function (t) {
      if (t) {
        if (typeof t != `object`) throw TypeError(t + `must be object`);
        Object.keys(t).forEach(function (n) {
          e[n] = t[n];
        });
      }
    }),
    e
  );
}
function LO(e, t, n) {
  return [].concat(e.slice(0, t), n, e.slice(t + 1));
}
function RO(e) {
  return !(
    (e >= 55296 && e <= 57343) ||
    (e >= 64976 && e <= 65007) ||
    (e & 65535) == 65535 ||
    (e & 65535) == 65534 ||
    (e >= 0 && e <= 8) ||
    e === 11 ||
    (e >= 14 && e <= 31) ||
    (e >= 127 && e <= 159) ||
    e > 1114111
  );
}
function zO(e) {
  if (e > 65535) {
    e -= 65536;
    let t = 55296 + (e >> 10),
      n = 56320 + (e & 1023);
    return String.fromCharCode(t, n);
  }
  return String.fromCharCode(e);
}
var BO = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g,
  Doe = RegExp(BO.source + `|&([a-z#][a-z0-9]{1,31});`, `gi`),
  Ooe = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function koe(e, t) {
  if (t.charCodeAt(0) === 35 && Ooe.test(t)) {
    let n = t[1].toLowerCase() === `x` ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
    return RO(n) ? zO(n) : e;
  }
  let n = xoe(e);
  return n === e ? e : n;
}
function Aoe(e) {
  return e.indexOf(`\\`) < 0 ? e : e.replace(BO, `$1`);
}
function VO(e) {
  return e.indexOf(`\\`) < 0 && e.indexOf(`&`) < 0
    ? e
    : e.replace(Doe, function (e, t, n) {
        return t || koe(e, n);
      });
}
var joe = /[&<>"]/,
  Moe = /[&<>"]/g,
  Noe = {
    "&": `&amp;`,
    "<": `&lt;`,
    ">": `&gt;`,
    '"': `&quot;`,
  };
function Poe(e) {
  return Noe[e];
}
function HO(e) {
  return joe.test(e) ? e.replace(Moe, Poe) : e;
}
var Foe = /[.?*+^$[\]\\(){}|-]/g;
function Ioe(e) {
  return e.replace(Foe, `\\$&`);
}
function UO(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function WO(e) {
  if (e >= 8192 && e <= 8202) return !0;
  switch (e) {
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function GO(e) {
  return TO.test(e) || EO.test(e);
}
function KO(e) {
  return GO(zO(e));
}
function qO(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function JO(e) {
  return ((e = e.trim().replace(/\s+/g, ` `)), e.toLowerCase().toUpperCase());
}
function YO(e) {
  return e === 32 || e === 9 || e === 10 || e === 13;
}
function XO(e) {
  let t = 0;
  for (; t < e.length && YO(e.charCodeAt(t)); t++);
  let n = e.length - 1;
  for (; n >= t && YO(e.charCodeAt(n)); n--);
  return e.slice(t, n + 1);
}
var Loe = {
  mdurl: soe,
  ucmicro: loe,
};
function Roe(e, t, n) {
  let r,
    i,
    a,
    o,
    s = e.posMax,
    c = e.pos;
  for (e.pos = t + 1, r = 1; e.pos < s;) {
    if (((a = e.src.charCodeAt(e.pos)), a === 93 && (r--, r === 0))) {
      i = !0;
      break;
    }
    if (((o = e.pos), e.md.inline.skipToken(e), a === 91)) {
      if (o === e.pos - 1) r++;
      else if (n) return ((e.pos = c), -1);
    }
  }
  let l = -1;
  return (i && (l = e.pos), (e.pos = c), l);
}
function zoe(e, t, n) {
  let r,
    i = t,
    a = {
      ok: !1,
      pos: 0,
      str: ``,
    };
  if (e.charCodeAt(i) === 60) {
    for (i++; i < n;) {
      if (((r = e.charCodeAt(i)), r === 10 || r === 60)) return a;
      if (r === 62) return ((a.pos = i + 1), (a.str = VO(e.slice(t + 1, i))), (a.ok = !0), a);
      if (r === 92 && i + 1 < n) {
        i += 2;
        continue;
      }
      i++;
    }
    return a;
  }
  let o = 0;
  for (; i < n && ((r = e.charCodeAt(i)), !(r === 32 || r < 32 || r === 127));) {
    if (r === 92 && i + 1 < n) {
      if (e.charCodeAt(i + 1) === 32) break;
      i += 2;
      continue;
    }
    if (r === 40 && (o++, o > 32)) return a;
    if (r === 41) {
      if (o === 0) break;
      o--;
    }
    i++;
  }
  return t === i || o !== 0 ? a : ((a.str = VO(e.slice(t, i))), (a.pos = i), (a.ok = !0), a);
}
function Boe(e, t, n, r) {
  let i,
    a = t,
    o = {
      ok: !1,
      can_continue: !1,
      pos: 0,
      str: ``,
      marker: 0,
    };
  if (r) ((o.str = r.str), (o.marker = r.marker));
  else {
    if (a >= n) return o;
    let r = e.charCodeAt(a);
    if (r !== 34 && r !== 39 && r !== 40) return o;
    (t++, a++, r === 40 && (r = 41), (o.marker = r));
  }
  for (; a < n;) {
    if (((i = e.charCodeAt(a)), i === o.marker))
      return ((o.pos = a + 1), (o.str += VO(e.slice(t, a))), (o.ok = !0), o);
    if (i === 40 && o.marker === 41) return o;
    (i === 92 && a + 1 < n && a++, a++);
  }
  return ((o.can_continue = !0), (o.str += VO(e.slice(t, a))), o);
}
var Voe = i({
    parseLinkDestination: () => zoe,
    parseLinkLabel: () => Roe,
    parseLinkTitle: () => Boe,
  }),
  ZO = {};
((ZO.code_inline = function (e, t, n, r, i) {
  let a = e[t];
  return `<code` + i.renderAttrs(a) + `>` + HO(a.content) + `</code>`;
}),
  (ZO.code_block = function (e, t, n, r, i) {
    let a = e[t];
    return (
      `<pre` +
      i.renderAttrs(a) +
      `><code>` +
      HO(e[t].content) +
      `</code></pre>
`
    );
  }),
  (ZO.fence = function (e, t, n, r, i) {
    let a = e[t],
      o = a.info ? VO(a.info).trim() : ``,
      s = ``,
      c = ``;
    if (o) {
      let e = o.split(/(\s+)/g);
      ((s = e[0]), (c = e.slice(2).join(``)));
    }
    let l;
    if (
      ((l = (n.highlight && n.highlight(a.content, s, c)) || HO(a.content)),
      l.indexOf(`<pre`) === 0)
    )
      return (
        l +
        `
`
      );
    if (o) {
      let e = a.attrIndex(`class`),
        t = a.attrs ? a.attrs.slice() : [];
      e < 0
        ? t.push([`class`, n.langPrefix + s])
        : ((t[e] = t[e].slice()), (t[e][1] += ` ` + n.langPrefix + s));
      let r = {
        attrs: t,
      };
      return `<pre><code${i.renderAttrs(r)}>${l}</code></pre>\n`;
    }
    return `<pre><code${i.renderAttrs(a)}>${l}</code></pre>\n`;
  }),
  (ZO.image = function (e, t, n, r, i) {
    let a = e[t];
    return (
      (a.attrs[a.attrIndex(`alt`)][1] = i.renderInlineAsText(a.children, n, r)),
      i.renderToken(e, t, n)
    );
  }),
  (ZO.hardbreak = function (e, t, n) {
    return n.xhtmlOut
      ? `<br />
`
      : `<br>
`;
  }),
  (ZO.softbreak = function (e, t, n) {
    return n.breaks
      ? n.xhtmlOut
        ? `<br />
`
        : `<br>
`
      : `
`;
  }),
  (ZO.text = function (e, t) {
    return HO(e[t].content);
  }),
  (ZO.html_block = function (e, t) {
    return e[t].content;
  }),
  (ZO.html_inline = function (e, t) {
    return e[t].content;
  }));
function QO() {
  this.rules = IO({}, ZO);
}
((QO.prototype.renderAttrs = function (e) {
  let t, n, r;
  if (!e.attrs) return ``;
  for (r = ``, t = 0, n = e.attrs.length; t < n; t++)
    r += ` ` + HO(e.attrs[t][0]) + `="` + HO(e.attrs[t][1]) + `"`;
  return r;
}),
  (QO.prototype.renderToken = function (e, t, n) {
    let r = e[t],
      i = ``;
    if (r.hidden) return ``;
    (r.block &&
      r.nesting !== -1 &&
      t &&
      e[t - 1].hidden &&
      (i += `
`),
      (i += (r.nesting === -1 ? `</` : `<`) + r.tag),
      (i += this.renderAttrs(r)),
      r.nesting === 0 && n.xhtmlOut && (i += ` /`));
    let a = !1;
    if (r.block && ((a = !0), r.nesting === 1 && t + 1 < e.length)) {
      let n = e[t + 1];
      (n.type === `inline` || n.hidden || (n.nesting === -1 && n.tag === r.tag)) && (a = !1);
    }
    return (
      (i += a
        ? `>
`
        : `>`),
      i
    );
  }),
  (QO.prototype.renderInline = function (e, t, n) {
    let r = ``,
      i = this.rules;
    for (let a = 0, o = e.length; a < o; a++) {
      let o = e[a].type;
      i[o] === void 0 ? (r += this.renderToken(e, a, t)) : (r += i[o](e, a, t, n, this));
    }
    return r;
  }),
  (QO.prototype.renderInlineAsText = function (e, t, n) {
    let r = ``;
    for (let i = 0, a = e.length; i < a; i++)
      switch (e[i].type) {
        case `text`:
          r += e[i].content;
          break;
        case `image`:
          r += this.renderInlineAsText(e[i].children, t, n);
          break;
        case `html_inline`:
        case `html_block`:
          r += e[i].content;
          break;
        case `softbreak`:
        case `hardbreak`:
          r += `
`;
          break;
        default:
      }
    return r;
  }),
  (QO.prototype.render = function (e, t, n) {
    let r = ``,
      i = this.rules;
    for (let a = 0, o = e.length; a < o; a++) {
      let o = e[a].type;
      o === `inline`
        ? (r += this.renderInline(e[a].children, t, n))
        : i[o] === void 0
          ? (r += this.renderToken(e, a, t, n))
          : (r += i[o](e, a, t, n, this));
    }
    return r;
  }));
function $O() {
  ((this.__rules__ = []), (this.__cache__ = null));
}
(($O.prototype.__find__ = function (e) {
  for (let t = 0; t < this.__rules__.length; t++) if (this.__rules__[t].name === e) return t;
  return -1;
}),
  ($O.prototype.__compile__ = function () {
    let e = this,
      t = [``];
    (e.__rules__.forEach(function (e) {
      e.enabled &&
        e.alt.forEach(function (e) {
          t.indexOf(e) < 0 && t.push(e);
        });
    }),
      (e.__cache__ = {}),
      t.forEach(function (t) {
        ((e.__cache__[t] = []),
          e.__rules__.forEach(function (n) {
            n.enabled && ((t && n.alt.indexOf(t) < 0) || e.__cache__[t].push(n.fn));
          }));
      }));
  }),
  ($O.prototype.at = function (e, t, n) {
    let r = this.__find__(e),
      i = n || {};
    if (r === -1) throw Error(`Parser rule not found: ` + e);
    ((this.__rules__[r].fn = t), (this.__rules__[r].alt = i.alt || []), (this.__cache__ = null));
  }),
  ($O.prototype.before = function (e, t, n, r) {
    let i = this.__find__(e),
      a = r || {};
    if (i === -1) throw Error(`Parser rule not found: ` + e);
    (this.__rules__.splice(i, 0, {
      name: t,
      enabled: !0,
      fn: n,
      alt: a.alt || [],
    }),
      (this.__cache__ = null));
  }),
  ($O.prototype.after = function (e, t, n, r) {
    let i = this.__find__(e),
      a = r || {};
    if (i === -1) throw Error(`Parser rule not found: ` + e);
    (this.__rules__.splice(i + 1, 0, {
      name: t,
      enabled: !0,
      fn: n,
      alt: a.alt || [],
    }),
      (this.__cache__ = null));
  }),
  ($O.prototype.push = function (e, t, n) {
    let r = n || {};
    (this.__rules__.push({
      name: e,
      enabled: !0,
      fn: t,
      alt: r.alt || [],
    }),
      (this.__cache__ = null));
  }),
  ($O.prototype.enable = function (e, t) {
    Array.isArray(e) || (e = [e]);
    let n = [];
    return (
      e.forEach(function (e) {
        let r = this.__find__(e);
        if (r < 0) {
          if (t) return;
          throw Error(`Rules manager: invalid rule name ` + e);
        }
        ((this.__rules__[r].enabled = !0), n.push(e));
      }, this),
      (this.__cache__ = null),
      n
    );
  }),
  ($O.prototype.enableOnly = function (e, t) {
    (Array.isArray(e) || (e = [e]),
      this.__rules__.forEach(function (e) {
        e.enabled = !1;
      }),
      this.enable(e, t));
  }),
  ($O.prototype.disable = function (e, t) {
    Array.isArray(e) || (e = [e]);
    let n = [];
    return (
      e.forEach(function (e) {
        let r = this.__find__(e);
        if (r < 0) {
          if (t) return;
          throw Error(`Rules manager: invalid rule name ` + e);
        }
        ((this.__rules__[r].enabled = !1), n.push(e));
      }, this),
      (this.__cache__ = null),
      n
    );
  }),
  ($O.prototype.getRules = function (e) {
    return (this.__cache__ === null && this.__compile__(), this.__cache__[e] || []);
  }));
function ek(e, t, n) {
  ((this.type = e),
    (this.tag = t),
    (this.attrs = null),
    (this.map = null),
    (this.nesting = n),
    (this.level = 0),
    (this.children = null),
    (this.content = ``),
    (this.markup = ``),
    (this.info = ``),
    (this.meta = null),
    (this.block = !1),
    (this.hidden = !1));
}
((ek.prototype.attrIndex = function (e) {
  if (!this.attrs) return -1;
  let t = this.attrs;
  for (let n = 0, r = t.length; n < r; n++) if (t[n][0] === e) return n;
  return -1;
}),
  (ek.prototype.attrPush = function (e) {
    this.attrs ? this.attrs.push(e) : (this.attrs = [e]);
  }),
  (ek.prototype.attrSet = function (e, t) {
    let n = this.attrIndex(e),
      r = [e, t];
    n < 0 ? this.attrPush(r) : (this.attrs[n] = r);
  }),
  (ek.prototype.attrGet = function (e) {
    let t = this.attrIndex(e),
      n = null;
    return (t >= 0 && (n = this.attrs[t][1]), n);
  }),
  (ek.prototype.attrJoin = function (e, t) {
    let n = this.attrIndex(e);
    n < 0 ? this.attrPush([e, t]) : (this.attrs[n][1] = this.attrs[n][1] + ` ` + t);
  }));
function tk(e, t, n) {
  ((this.src = e), (this.env = n), (this.tokens = []), (this.inlineMode = !1), (this.md = t));
}
tk.prototype.Token = ek;
var Hoe = /\r\n?|\n/g,
  Uoe = /\0/g;
function Woe(e) {
  let t;
  ((t = e.src.replace(
    Hoe,
    `
`,
  )),
    (t = t.replace(Uoe, `�`)),
    (e.src = t));
}
function Goe(e) {
  let t;
  e.inlineMode
    ? ((t = new e.Token(`inline`, ``, 0)),
      (t.content = e.src),
      (t.map = [0, 1]),
      (t.children = []),
      e.tokens.push(t))
    : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function Koe(e) {
  let t = e.tokens;
  for (let n = 0, r = t.length; n < r; n++) {
    let r = t[n];
    r.type === `inline` && e.md.inline.parse(r.content, e.md, e.env, r.children);
  }
}
function qoe(e) {
  return /^<a[>\s]/i.test(e);
}
function Joe(e) {
  return /^<\/a\s*>/i.test(e);
}
function Yoe(e) {
  let t = e.tokens;
  if (e.md.options.linkify)
    for (let n = 0, r = t.length; n < r; n++) {
      if (t[n].type !== `inline` || !e.md.linkify.pretest(t[n].content)) continue;
      let r = t[n].children,
        i = 0;
      for (let a = r.length - 1; a >= 0; a--) {
        let o = r[a];
        if (o.type === `link_close`) {
          for (a--; r[a].level !== o.level && r[a].type !== `link_open`;) a--;
          continue;
        }
        if (
          (o.type === `html_inline` && (qoe(o.content) && i > 0 && i--, Joe(o.content) && i++),
          !(i > 0) && o.type === `text` && e.md.linkify.test(o.content))
        ) {
          let i = o.content,
            s = e.md.linkify.match(i),
            c = [],
            l = o.level,
            u = 0;
          s.length > 0 &&
            s[0].index === 0 &&
            a > 0 &&
            r[a - 1].type === `text_special` &&
            (s = s.slice(1));
          for (let t = 0; t < s.length; t++) {
            let n = s[t].url,
              r = e.md.normalizeLink(n);
            if (!e.md.validateLink(r)) continue;
            let a = s[t].text;
            a = s[t].schema
              ? s[t].schema === `mailto:` && !/^mailto:/i.test(a)
                ? e.md.normalizeLinkText(`mailto:` + a).replace(/^mailto:/, ``)
                : e.md.normalizeLinkText(a)
              : e.md.normalizeLinkText(`http://` + a).replace(/^http:\/\//, ``);
            let o = s[t].index;
            if (o > u) {
              let t = new e.Token(`text`, ``, 0);
              ((t.content = i.slice(u, o)), (t.level = l), c.push(t));
            }
            let d = new e.Token(`link_open`, `a`, 1);
            ((d.attrs = [[`href`, r]]),
              (d.level = l++),
              (d.markup = `linkify`),
              (d.info = `auto`),
              c.push(d));
            let f = new e.Token(`text`, ``, 0);
            ((f.content = a), (f.level = l), c.push(f));
            let p = new e.Token(`link_close`, `a`, -1);
            ((p.level = --l),
              (p.markup = `linkify`),
              (p.info = `auto`),
              c.push(p),
              (u = s[t].lastIndex));
          }
          if (u < i.length) {
            let t = new e.Token(`text`, ``, 0);
            ((t.content = i.slice(u)), (t.level = l), c.push(t));
          }
          t[n].children = r = LO(r, a, c);
        }
      }
    }
}
var nk = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/,
  Xoe = /\((c|tm|r)\)/i,
  Zoe = /\((c|tm|r)\)/gi,
  Qoe = {
    c: `©`,
    r: `®`,
    tm: `™`,
  };
function $oe(e, t) {
  return Qoe[t.toLowerCase()];
}
function ese(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    let r = e[n];
    (r.type === `text` && !t && (r.content = r.content.replace(Zoe, $oe)),
      r.type === `link_open` && r.info === `auto` && t--,
      r.type === `link_close` && r.info === `auto` && t++);
  }
}
function tse(e) {
  let t = 0;
  for (let n = e.length - 1; n >= 0; n--) {
    let r = e[n];
    (r.type === `text` &&
      !t &&
      nk.test(r.content) &&
      (r.content = r.content
        .replace(/\+-/g, `±`)
        .replace(/\.{2,}/g, `…`)
        .replace(/([?!])…/g, `$1..`)
        .replace(/([?!]){4,}/g, `$1$1$1`)
        .replace(/,{2,}/g, `,`)
        .replace(/(^|[^-])---(?=[^-]|$)/gm, `$1—`)
        .replace(/(^|\s)--(?=\s|$)/gm, `$1–`)
        .replace(/(^|[^-\s])--(?=[^-\s]|$)/gm, `$1–`)),
      r.type === `link_open` && r.info === `auto` && t--,
      r.type === `link_close` && r.info === `auto` && t++);
  }
}
function nse(e) {
  let t;
  if (e.md.options.typographer)
    for (t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type === `inline` &&
        (Xoe.test(e.tokens[t].content) && ese(e.tokens[t].children),
        nk.test(e.tokens[t].content) && tse(e.tokens[t].children));
}
var rse = /['"]/,
  rk = /['"]/g,
  ik = `’`;
function ak(e, t, n, r) {
  (e[t] || (e[t] = []),
    e[t].push({
      pos: n,
      ch: r,
    }));
}
function ok(e, t) {
  let n = ``,
    r = 0;
  t.sort((e, t) => e.pos - t.pos);
  for (let i = 0; i < t.length; i++) {
    let a = t[i];
    ((n += e.slice(r, a.pos) + a.ch), (r = a.pos + 1));
  }
  return n + e.slice(r);
}
function sk(e, t) {
  let n,
    r = [],
    i = {};
  for (let a = 0; a < e.length; a++) {
    let o = e[a],
      s = e[a].level;
    for (n = r.length - 1; n >= 0 && !(r[n].level <= s); n--);
    if (((r.length = n + 1), o.type !== `text`)) continue;
    let c = o.content,
      l = 0,
      u = c.length;
    OUTER: for (; l < u;) {
      rk.lastIndex = l;
      let o = rk.exec(c);
      if (!o) break;
      let d = !0,
        f = !0;
      l = o.index + 1;
      let p = o[0] === `'`,
        m = 32;
      if (o.index - 1 >= 0) m = c.charCodeAt(o.index - 1);
      else
        for (n = a - 1; n >= 0 && !(e[n].type === `softbreak` || e[n].type === `hardbreak`); n--)
          if (e[n].content) {
            m = e[n].content.charCodeAt(e[n].content.length - 1);
            break;
          }
      let h = 32;
      if (l < u) h = c.charCodeAt(l);
      else
        for (
          n = a + 1;
          n < e.length && !(e[n].type === `softbreak` || e[n].type === `hardbreak`);
          n++
        )
          if (e[n].content) {
            h = e[n].content.charCodeAt(0);
            break;
          }
      let g = qO(m) || KO(m),
        v = qO(h) || KO(h),
        y = WO(m),
        b = WO(h);
      if (
        (b ? (d = !1) : v && (y || g || (d = !1)),
        y ? (f = !1) : g && (b || v || (f = !1)),
        h === 34 && o[0] === `"` && m >= 48 && m <= 57 && (f = d = !1),
        d && f && ((d = g), (f = v)),
        !d && !f)
      ) {
        p && ak(i, a, o.index, ik);
        continue;
      }
      if (f)
        for (n = r.length - 1; n >= 0; n--) {
          let e = r[n];
          if (r[n].level < s) break;
          if (e.single === p && r[n].level === s) {
            e = r[n];
            let s, c;
            (p
              ? ((s = t.md.options.quotes[2]), (c = t.md.options.quotes[3]))
              : ((s = t.md.options.quotes[0]), (c = t.md.options.quotes[1])),
              ak(i, a, o.index, c),
              ak(i, e.token, e.pos, s),
              (r.length = n));
            continue OUTER;
          }
        }
      d
        ? r.push({
            token: a,
            pos: o.index,
            single: p,
            level: s,
          })
        : f && p && ak(i, a, o.index, ik);
    }
  }
  Object.keys(i).forEach(function (t) {
    e[t].content = ok(e[t].content, i[t]);
  });
}
function ck(e) {
  if (e.md.options.typographer)
    for (let t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type !== `inline` ||
        !rse.test(e.tokens[t].content) ||
        sk(e.tokens[t].children, e);
}
function lk(e) {
  let t,
    n,
    r = e.tokens,
    i = r.length;
  for (let e = 0; e < i; e++) {
    if (r[e].type !== `inline`) continue;
    let i = r[e].children,
      a = i.length;
    for (t = 0; t < a; t++) i[t].type === `text_special` && (i[t].type = `text`);
    for (t = n = 0; t < a; t++)
      i[t].type === `text` && t + 1 < a && i[t + 1].type === `text`
        ? (i[t + 1].content = i[t].content + i[t + 1].content)
        : (t !== n && (i[n] = i[t]), n++);
    t !== n && (i.length = n);
  }
}
var uk = [
  [`normalize`, Woe],
  [`block`, Goe],
  [`inline`, Koe],
  [`linkify`, Yoe],
  [`replacements`, nse],
  [`smartquotes`, ck],
  [`text_join`, lk],
];
function dk() {
  this.ruler = new $O();
  for (let e = 0; e < uk.length; e++) this.ruler.push(uk[e][0], uk[e][1]);
}
((dk.prototype.process = function (e) {
  let t = this.ruler.getRules(``);
  for (let n = 0, r = t.length; n < r; n++) t[n](e);
}),
  (dk.prototype.State = tk));
function fk(e, t, n, r) {
  ((this.src = e),
    (this.md = t),
    (this.env = n),
    (this.tokens = r),
    (this.bMarks = []),
    (this.eMarks = []),
    (this.tShift = []),
    (this.sCount = []),
    (this.bsCount = []),
    (this.blkIndent = 0),
    (this.line = 0),
    (this.lineMax = 0),
    (this.tight = !1),
    (this.ddIndent = -1),
    (this.listIndent = -1),
    (this.parentType = `root`),
    (this.level = 0));
  let i = this.src;
  for (let e = 0, t = 0, n = 0, r = 0, a = i.length, o = !1; t < a; t++) {
    let s = i.charCodeAt(t);
    if (!o)
      if (UO(s)) {
        (n++, s === 9 ? (r += 4 - (r % 4)) : r++);
        continue;
      } else o = !0;
    (s === 10 || t === a - 1) &&
      (s !== 10 && t++,
      this.bMarks.push(e),
      this.eMarks.push(t),
      this.tShift.push(n),
      this.sCount.push(r),
      this.bsCount.push(0),
      (o = !1),
      (n = 0),
      (r = 0),
      (e = t + 1));
  }
  (this.bMarks.push(i.length),
    this.eMarks.push(i.length),
    this.tShift.push(0),
    this.sCount.push(0),
    this.bsCount.push(0),
    (this.lineMax = this.bMarks.length - 1));
}
((fk.prototype.push = function (e, t, n) {
  let r = new ek(e, t, n);
  return (
    (r.block = !0),
    n < 0 && this.level--,
    (r.level = this.level),
    n > 0 && this.level++,
    this.tokens.push(r),
    r
  );
}),
  (fk.prototype.isEmpty = function (e) {
    return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
  }),
  (fk.prototype.skipEmptyLines = function (e) {
    for (let t = this.lineMax; e < t && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++);
    return e;
  }),
  (fk.prototype.skipSpaces = function (e) {
    for (let t = this.src.length; e < t && UO(this.src.charCodeAt(e)); e++);
    return e;
  }),
  (fk.prototype.skipSpacesBack = function (e, t) {
    if (e <= t) return e;
    for (; e > t;) if (!UO(this.src.charCodeAt(--e))) return e + 1;
    return e;
  }),
  (fk.prototype.skipChars = function (e, t) {
    for (let n = this.src.length; e < n && this.src.charCodeAt(e) === t; e++);
    return e;
  }),
  (fk.prototype.skipCharsBack = function (e, t, n) {
    if (e <= n) return e;
    for (; e > n;) if (t !== this.src.charCodeAt(--e)) return e + 1;
    return e;
  }),
  (fk.prototype.getLines = function (e, t, n, r) {
    if (e >= t) return ``;
    let i = Array(t - e);
    for (let a = 0, o = e; o < t; o++, a++) {
      let e = 0,
        s = this.bMarks[o],
        c = s,
        l;
      for (l = o + 1 < t || r ? this.eMarks[o] + 1 : this.eMarks[o]; c < l && e < n;) {
        let t = this.src.charCodeAt(c);
        if (UO(t)) t === 9 ? (e += 4 - ((e + this.bsCount[o]) % 4)) : e++;
        else if (c - s < this.tShift[o]) e++;
        else break;
        c++;
      }
      e > n
        ? (i[a] = Array(e - n + 1).join(` `) + this.src.slice(c, l))
        : (i[a] = this.src.slice(c, l));
    }
    return i.join(``);
  }),
  (fk.prototype.Token = ek));
var pk = 65536;
function mk(e, t) {
  let n = e.bMarks[t] + e.tShift[t],
    r = e.eMarks[t];
  return e.src.slice(n, r);
}
function hk(e) {
  let t = [],
    n = e.length,
    r = 0,
    i = e.charCodeAt(r),
    a = !1,
    o = 0,
    s = ``;
  for (; r < n;)
    (i === 124 &&
      (a
        ? ((s += e.substring(o, r - 1)), (o = r))
        : (t.push(s + e.substring(o, r)), (s = ``), (o = r + 1))),
      (a = i === 92),
      r++,
      (i = e.charCodeAt(r)));
  return (t.push(s + e.substring(o)), t);
}
function gk(e, t, n, r) {
  if (t + 2 > n) return !1;
  let i = t + 1;
  if (e.sCount[i] < e.blkIndent || e.sCount[i] - e.blkIndent >= 4) return !1;
  let a = e.bMarks[i] + e.tShift[i];
  if (a >= e.eMarks[i]) return !1;
  let o = e.src.charCodeAt(a++);
  if ((o !== 124 && o !== 45 && o !== 58) || a >= e.eMarks[i]) return !1;
  let s = e.src.charCodeAt(a++);
  if ((s !== 124 && s !== 45 && s !== 58 && !UO(s)) || (o === 45 && UO(s))) return !1;
  for (; a < e.eMarks[i];) {
    let t = e.src.charCodeAt(a);
    if (t !== 124 && t !== 45 && t !== 58 && !UO(t)) return !1;
    a++;
  }
  let c = mk(e, t + 1),
    l = c.split(`|`),
    u = [];
  for (let e = 0; e < l.length; e++) {
    let t = l[e].trim();
    if (!t) {
      if (e === 0 || e === l.length - 1) continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(t)) return !1;
    t.charCodeAt(t.length - 1) === 58
      ? u.push(t.charCodeAt(0) === 58 ? `center` : `right`)
      : t.charCodeAt(0) === 58
        ? u.push(`left`)
        : u.push(``);
  }
  if (((c = mk(e, t).trim()), c.indexOf(`|`) === -1 || e.sCount[t] - e.blkIndent >= 4)) return !1;
  ((l = hk(c)),
    l.length && l[0] === `` && l.shift(),
    l.length && l[l.length - 1] === `` && l.pop());
  let d = l.length;
  if (d === 0 || d !== u.length) return !1;
  if (r) return !0;
  let f = e.parentType;
  e.parentType = `table`;
  let p = e.md.block.ruler.getRules(`blockquote`),
    m = e.push(`table_open`, `table`, 1),
    h = [t, 0];
  m.map = h;
  let g = e.push(`thead_open`, `thead`, 1);
  g.map = [t, t + 1];
  let v = e.push(`tr_open`, `tr`, 1);
  v.map = [t, t + 1];
  for (let t = 0; t < l.length; t++) {
    let n = e.push(`th_open`, `th`, 1);
    u[t] && (n.attrs = [[`style`, `text-align:` + u[t]]]);
    let r = e.push(`inline`, ``, 0);
    ((r.content = l[t].trim()), (r.children = []), e.push(`th_close`, `th`, -1));
  }
  (e.push(`tr_close`, `tr`, -1), e.push(`thead_close`, `thead`, -1));
  let y,
    b = 0;
  for (i = t + 2; i < n && !(e.sCount[i] < e.blkIndent); i++) {
    let r = !1;
    for (let t = 0, a = p.length; t < a; t++)
      if (p[t](e, i, n, !0)) {
        r = !0;
        break;
      }
    if (
      r ||
      ((c = mk(e, i).trim()), !c) ||
      e.sCount[i] - e.blkIndent >= 4 ||
      ((l = hk(c)),
      l.length && l[0] === `` && l.shift(),
      l.length && l[l.length - 1] === `` && l.pop(),
      (b += d - l.length),
      b > pk)
    )
      break;
    if (i === t + 2) {
      let n = e.push(`tbody_open`, `tbody`, 1);
      n.map = y = [t + 2, 0];
    }
    let a = e.push(`tr_open`, `tr`, 1);
    a.map = [i, i + 1];
    for (let t = 0; t < d; t++) {
      let n = e.push(`td_open`, `td`, 1);
      u[t] && (n.attrs = [[`style`, `text-align:` + u[t]]]);
      let r = e.push(`inline`, ``, 0);
      ((r.content = l[t] ? l[t].trim() : ``), (r.children = []), e.push(`td_close`, `td`, -1));
    }
    e.push(`tr_close`, `tr`, -1);
  }
  return (
    y && (e.push(`tbody_close`, `tbody`, -1), (y[1] = i)),
    e.push(`table_close`, `table`, -1),
    (h[1] = i),
    (e.parentType = f),
    (e.line = i),
    !0
  );
}
function _k(e, t, n) {
  if (e.sCount[t] - e.blkIndent < 4) return !1;
  let r = t + 1,
    i = r;
  for (; r < n;) {
    if (e.isEmpty(r)) {
      r++;
      continue;
    }
    if (e.sCount[r] - e.blkIndent >= 4) {
      (r++, (i = r));
      continue;
    }
    break;
  }
  e.line = i;
  let a = e.push(`code_block`, `code`, 0);
  return (
    (a.content =
      e.getLines(t, i, 4 + e.blkIndent, !1) +
      `
`),
    (a.map = [t, e.line]),
    !0
  );
}
function vk(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t],
    a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || i + 3 > a) return !1;
  let o = e.src.charCodeAt(i);
  if (o !== 126 && o !== 96) return !1;
  let s = i;
  i = e.skipChars(i, o);
  let c = i - s;
  if (c < 3) return !1;
  let l = e.src.slice(s, i),
    u = e.src.slice(i, a);
  if (o === 96 && u.indexOf(String.fromCharCode(o)) >= 0) return !1;
  if (r) return !0;
  let d = t,
    f = !1;
  for (
    ;
    d++,
      !(
        d >= n ||
        ((i = s = e.bMarks[d] + e.tShift[d]), (a = e.eMarks[d]), i < a && e.sCount[d] < e.blkIndent)
      );
  )
    if (
      e.src.charCodeAt(i) === o &&
      !(e.sCount[d] - e.blkIndent >= 4) &&
      ((i = e.skipChars(i, o)), !(i - s < c) && ((i = e.skipSpaces(i)), !(i < a)))
    ) {
      f = !0;
      break;
    }
  ((c = e.sCount[t]), (e.line = d + +!!f));
  let p = e.push(`fence`, `code`, 0);
  return (
    (p.info = u),
    (p.content = e.getLines(t + 1, d, c, !0)),
    (p.markup = l),
    (p.map = [t, e.line]),
    !0
  );
}
function yk(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t],
    a = e.eMarks[t],
    o = e.lineMax;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 62) return !1;
  if (r) return !0;
  let s = [],
    c = [],
    l = [],
    u = [],
    d = e.md.block.ruler.getRules(`blockquote`),
    f = e.parentType;
  e.parentType = `blockquote`;
  let p = !1,
    m;
  for (m = t; m < n; m++) {
    let t = e.sCount[m] < e.blkIndent;
    if (((i = e.bMarks[m] + e.tShift[m]), (a = e.eMarks[m]), i >= a)) break;
    if (e.src.charCodeAt(i++) === 62 && !t) {
      let t = e.sCount[m] + 1,
        n,
        r;
      e.src.charCodeAt(i) === 32
        ? (i++, t++, (r = !1), (n = !0))
        : e.src.charCodeAt(i) === 9
          ? ((n = !0), (e.bsCount[m] + t) % 4 == 3 ? (i++, t++, (r = !1)) : (r = !0))
          : (n = !1);
      let o = t;
      for (s.push(e.bMarks[m]), e.bMarks[m] = i; i < a;) {
        let t = e.src.charCodeAt(i);
        if (UO(t)) t === 9 ? (o += 4 - ((o + e.bsCount[m] + +!!r) % 4)) : o++;
        else break;
        i++;
      }
      ((p = i >= a),
        c.push(e.bsCount[m]),
        (e.bsCount[m] = e.sCount[m] + 1 + +!!n),
        l.push(e.sCount[m]),
        (e.sCount[m] = o - t),
        u.push(e.tShift[m]),
        (e.tShift[m] = i - e.bMarks[m]));
      continue;
    }
    if (p) break;
    let r = !1;
    for (let t = 0, i = d.length; t < i; t++)
      if (d[t](e, m, n, !0)) {
        r = !0;
        break;
      }
    if (r) {
      ((e.lineMax = m),
        e.blkIndent !== 0 &&
          (s.push(e.bMarks[m]),
          c.push(e.bsCount[m]),
          u.push(e.tShift[m]),
          l.push(e.sCount[m]),
          (e.sCount[m] -= e.blkIndent)));
      break;
    }
    (s.push(e.bMarks[m]),
      c.push(e.bsCount[m]),
      u.push(e.tShift[m]),
      l.push(e.sCount[m]),
      (e.sCount[m] = -1));
  }
  let h = e.blkIndent;
  e.blkIndent = 0;
  let g = e.push(`blockquote_open`, `blockquote`, 1);
  g.markup = `>`;
  let v = [t, 0];
  ((g.map = v), e.md.block.tokenize(e, t, m));
  let y = e.push(`blockquote_close`, `blockquote`, -1);
  ((y.markup = `>`), (e.lineMax = o), (e.parentType = f), (v[1] = e.line));
  for (let n = 0; n < u.length; n++)
    ((e.bMarks[n + t] = s[n]),
      (e.tShift[n + t] = u[n]),
      (e.sCount[n + t] = l[n]),
      (e.bsCount[n + t] = c[n]));
  return ((e.blkIndent = h), !0);
}
function bk(e, t, n, r) {
  let i = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4) return !1;
  let a = e.bMarks[t] + e.tShift[t],
    o = e.src.charCodeAt(a++);
  if (o !== 42 && o !== 45 && o !== 95) return !1;
  let s = 1;
  for (; a < i;) {
    let t = e.src.charCodeAt(a++);
    if (t !== o && !UO(t)) return !1;
    t === o && s++;
  }
  if (s < 3) return !1;
  if (r) return !0;
  e.line = t + 1;
  let c = e.push(`hr`, `hr`, 0);
  return ((c.map = [t, e.line]), (c.markup = Array(s + 1).join(String.fromCharCode(o))), !0);
}
function xk(e, t) {
  let n = e.eMarks[t],
    r = e.bMarks[t] + e.tShift[t],
    i = e.src.charCodeAt(r++);
  return (i !== 42 && i !== 45 && i !== 43) || (r < n && !UO(e.src.charCodeAt(r))) ? -1 : r;
}
function Sk(e, t) {
  let n = e.bMarks[t] + e.tShift[t],
    r = e.eMarks[t],
    i = n;
  if (i + 1 >= r) return -1;
  let a = e.src.charCodeAt(i++);
  if (a < 48 || a > 57) return -1;
  for (;;) {
    if (i >= r) return -1;
    if (((a = e.src.charCodeAt(i++)), a >= 48 && a <= 57)) {
      if (i - n >= 10) return -1;
      continue;
    }
    if (a === 41 || a === 46) break;
    return -1;
  }
  return i < r && ((a = e.src.charCodeAt(i)), !UO(a)) ? -1 : i;
}
function Ck(e, t) {
  let n = e.level + 2;
  for (let r = t + 2, i = e.tokens.length - 2; r < i; r++)
    e.tokens[r].level === n &&
      e.tokens[r].type === `paragraph_open` &&
      ((e.tokens[r + 2].hidden = !0), (e.tokens[r].hidden = !0), (r += 2));
}
function wk(e, t, n, r) {
  let i,
    a,
    o,
    s,
    c = t,
    l = !0;
  if (
    e.sCount[c] - e.blkIndent >= 4 ||
    (e.listIndent >= 0 && e.sCount[c] - e.listIndent >= 4 && e.sCount[c] < e.blkIndent)
  )
    return !1;
  let u = !1;
  r && e.parentType === `paragraph` && e.sCount[c] >= e.blkIndent && (u = !0);
  let d, f, p;
  if ((p = Sk(e, c)) >= 0) {
    if (
      ((d = !0), (o = e.bMarks[c] + e.tShift[c]), (f = Number(e.src.slice(o, p - 1))), u && f !== 1)
    )
      return !1;
  } else if ((p = xk(e, c)) >= 0) d = !1;
  else return !1;
  if (u && e.skipSpaces(p) >= e.eMarks[c]) return !1;
  if (r) return !0;
  let m = e.src.charCodeAt(p - 1),
    h = e.tokens.length;
  d
    ? ((s = e.push(`ordered_list_open`, `ol`, 1)), f !== 1 && (s.attrs = [[`start`, f]]))
    : (s = e.push(`bullet_list_open`, `ul`, 1));
  let g = [c, 0];
  ((s.map = g), (s.markup = String.fromCharCode(m)));
  let v = !1,
    y = e.md.block.ruler.getRules(`list`),
    b = e.parentType;
  for (e.parentType = `list`; c < n;) {
    ((a = p), (i = e.eMarks[c]));
    let t = e.sCount[c] + p - (e.bMarks[c] + e.tShift[c]),
      r = t;
    for (; a < i;) {
      let t = e.src.charCodeAt(a);
      if (t === 9) r += 4 - ((r + e.bsCount[c]) % 4);
      else if (t === 32) r++;
      else break;
      a++;
    }
    let u = a,
      f;
    ((f = u >= i ? 1 : r - t), f > 4 && (f = 1));
    let h = t + f;
    ((s = e.push(`list_item_open`, `li`, 1)), (s.markup = String.fromCharCode(m)));
    let g = [c, 0];
    ((s.map = g), d && (s.info = e.src.slice(o, p - 1)));
    let b = e.tight,
      x = e.tShift[c],
      S = e.sCount[c],
      C = e.listIndent;
    if (
      ((e.listIndent = e.blkIndent),
      (e.blkIndent = h),
      (e.tight = !0),
      (e.tShift[c] = u - e.bMarks[c]),
      (e.sCount[c] = r),
      u >= i && e.isEmpty(c + 1)
        ? (e.line = Math.min(e.line + 2, n))
        : e.md.block.tokenize(e, c, n, !0),
      (!e.tight || v) && (l = !1),
      (v = e.line - c > 1 && e.isEmpty(e.line - 1)),
      (e.blkIndent = e.listIndent),
      (e.listIndent = C),
      (e.tShift[c] = x),
      (e.sCount[c] = S),
      (e.tight = b),
      (s = e.push(`list_item_close`, `li`, -1)),
      (s.markup = String.fromCharCode(m)),
      (c = e.line),
      (g[1] = c),
      c >= n || e.sCount[c] < e.blkIndent || e.sCount[c] - e.blkIndent >= 4)
    )
      break;
    let w = !1;
    for (let t = 0, r = y.length; t < r; t++)
      if (y[t](e, c, n, !0)) {
        w = !0;
        break;
      }
    if (w) break;
    if (d) {
      if (((p = Sk(e, c)), p < 0)) break;
      o = e.bMarks[c] + e.tShift[c];
    } else if (((p = xk(e, c)), p < 0)) break;
    if (m !== e.src.charCodeAt(p - 1)) break;
  }
  return (
    (s = d ? e.push(`ordered_list_close`, `ol`, -1) : e.push(`bullet_list_close`, `ul`, -1)),
    (s.markup = String.fromCharCode(m)),
    (g[1] = c),
    (e.line = c),
    (e.parentType = b),
    l && Ck(e, h),
    !0
  );
}
function Tk(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t],
    a = e.eMarks[t],
    o = t + 1;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(i) !== 91) return !1;
  function s(t) {
    let n = e.lineMax;
    if (t >= n || e.isEmpty(t)) return null;
    let r = !1;
    if ((e.sCount[t] - e.blkIndent > 3 && (r = !0), e.sCount[t] < 0 && (r = !0), !r)) {
      let r = e.md.block.ruler.getRules(`reference`),
        i = e.parentType;
      e.parentType = `reference`;
      let a = !1;
      for (let i = 0, o = r.length; i < o; i++)
        if (r[i](e, t, n, !0)) {
          a = !0;
          break;
        }
      if (((e.parentType = i), a)) return null;
    }
    let i = e.bMarks[t] + e.tShift[t],
      a = e.eMarks[t];
    return e.src.slice(i, a + 1);
  }
  let c = e.src.slice(i, a + 1);
  a = c.length;
  let l = -1;
  for (i = 1; i < a; i++) {
    let e = c.charCodeAt(i);
    if (e === 91) return !1;
    if (e === 93) {
      l = i;
      break;
    } else if (e === 10) {
      let e = s(o);
      e !== null && ((c += e), (a = c.length), o++);
    } else if (e === 92 && (i++, i < a && c.charCodeAt(i) === 10)) {
      let e = s(o);
      e !== null && ((c += e), (a = c.length), o++);
    }
  }
  if (l < 0 || c.charCodeAt(l + 1) !== 58) return !1;
  for (i = l + 2; i < a; i++) {
    let e = c.charCodeAt(i);
    if (e === 10) {
      let e = s(o);
      e !== null && ((c += e), (a = c.length), o++);
    } else if (!UO(e)) break;
  }
  let u = e.md.helpers.parseLinkDestination(c, i, a);
  if (!u.ok) return !1;
  let d = e.md.normalizeLink(u.str);
  if (!e.md.validateLink(d)) return !1;
  i = u.pos;
  let f = i,
    p = o,
    m = i;
  for (; i < a; i++) {
    let e = c.charCodeAt(i);
    if (e === 10) {
      let e = s(o);
      e !== null && ((c += e), (a = c.length), o++);
    } else if (!UO(e)) break;
  }
  let h = e.md.helpers.parseLinkTitle(c, i, a);
  for (; h.can_continue;) {
    let t = s(o);
    if (t === null) break;
    ((c += t), (i = a), (a = c.length), o++, (h = e.md.helpers.parseLinkTitle(c, i, a, h)));
  }
  let g;
  for (
    i < a && m !== i && h.ok ? ((g = h.str), (i = h.pos)) : ((g = ``), (i = f), (o = p));
    i < a && UO(c.charCodeAt(i));
  )
    i++;
  if (i < a && c.charCodeAt(i) !== 10 && g)
    for (g = ``, i = f, o = p; i < a && UO(c.charCodeAt(i));) i++;
  if (i < a && c.charCodeAt(i) !== 10) return !1;
  let v = JO(c.slice(1, l));
  return v
    ? r
      ? !0
      : (e.env.references === void 0 && (e.env.references = {}),
        e.env.references[v] === void 0 &&
          (e.env.references[v] = {
            title: g,
            href: d,
          }),
        (e.line = o),
        !0)
    : !1;
}
var Ek =
    `address.article.aside.base.basefont.blockquote.body.caption.center.col.colgroup.dd.details.dialog.dir.div.dl.dt.fieldset.figcaption.figure.footer.form.frame.frameset.h1.h2.h3.h4.h5.h6.head.header.hr.html.iframe.legend.li.link.main.menu.menuitem.nav.noframes.ol.optgroup.option.p.param.search.section.summary.table.tbody.td.tfoot.th.thead.title.tr.track.ul`.split(
      `.`,
    ),
  Dk = RegExp(
    `^(?:<[A-Za-z][A-Za-z0-9\\-]*(?:\\s+[a-zA-Z_:][a-zA-Z0-9:._-]*(?:\\s*=\\s*(?:[^"'=<>\`\\x00-\\x20]+|'[^']*'|"[^"]*"))?)*\\s*\\/?>|<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>|<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->|<[?][\\s\\S]*?[?]>|<![A-Za-z][^>]*>|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>)`,
  ),
  Ok = RegExp(
    `^(?:<[A-Za-z][A-Za-z0-9\\-]*(?:\\s+[a-zA-Z_:][a-zA-Z0-9:._-]*(?:\\s*=\\s*(?:[^"'=<>\`\\x00-\\x20]+|'[^']*'|"[^"]*"))?)*\\s*\\/?>|<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>)`,
  ),
  kk = [
    [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
    [/^<!--/, /-->/, !0],
    [/^<\?/, /\?>/, !0],
    [/^<![A-Z]/, />/, !0],
    [/^<!\[CDATA\[/, /\]\]>/, !0],
    [RegExp(`^</?(` + Ek.join(`|`) + `)(?=(\\s|/?>|$))`, `i`), /^$/, !0],
    [RegExp(Ok.source + `\\s*$`), /^$/, !1],
  ];
function Ak(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t],
    a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(i) !== 60) return !1;
  let o = e.src.slice(i, a),
    s = 0;
  for (; s < kk.length && !kk[s][0].test(o); s++);
  if (s === kk.length) return !1;
  if (r) return kk[s][2];
  let c = t + 1,
    l = kk[s][1].test(``);
  if (!kk[s][1].test(o)) {
    for (; c < n && !(e.sCount[c] < e.blkIndent && (l || !e.isEmpty(c))); c++)
      if (
        ((i = e.bMarks[c] + e.tShift[c]),
        (a = e.eMarks[c]),
        (o = e.src.slice(i, a)),
        kk[s][1].test(o))
      ) {
        o.length !== 0 && c++;
        break;
      }
  }
  e.line = c;
  let u = e.push(`html_block`, ``, 0);
  return ((u.map = [t, c]), (u.content = e.getLines(t, c, e.blkIndent, !0)), !0);
}
function jk(e, t, n, r) {
  let i = e.bMarks[t] + e.tShift[t],
    a = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4) return !1;
  let o = e.src.charCodeAt(i);
  if (o !== 35 || i >= a) return !1;
  let s = 1;
  for (o = e.src.charCodeAt(++i); o === 35 && i < a && s <= 6;) (s++, (o = e.src.charCodeAt(++i)));
  if (s > 6 || (i < a && !UO(o))) return !1;
  if (r) return !0;
  a = e.skipSpacesBack(a, i);
  let c = e.skipCharsBack(a, 35, i);
  (c > i && UO(e.src.charCodeAt(c - 1)) && (a = c), (e.line = t + 1));
  let l = e.push(`heading_open`, `h` + String(s), 1);
  ((l.markup = `########`.slice(0, s)), (l.map = [t, e.line]));
  let u = e.push(`inline`, ``, 0);
  ((u.content = XO(e.src.slice(i, a))), (u.map = [t, e.line]), (u.children = []));
  let d = e.push(`heading_close`, `h` + String(s), -1);
  return ((d.markup = `########`.slice(0, s)), !0);
}
function Mk(e, t, n) {
  let r = e.md.block.ruler.getRules(`paragraph`);
  if (e.sCount[t] - e.blkIndent >= 4) return !1;
  let i = e.parentType;
  e.parentType = `paragraph`;
  let a = 0,
    o,
    s = t + 1;
  for (; s < n && !e.isEmpty(s); s++) {
    if (e.sCount[s] - e.blkIndent > 3) continue;
    if (e.sCount[s] >= e.blkIndent) {
      let t = e.bMarks[s] + e.tShift[s],
        n = e.eMarks[s];
      if (
        t < n &&
        ((o = e.src.charCodeAt(t)),
        (o === 45 || o === 61) && ((t = e.skipChars(t, o)), (t = e.skipSpaces(t)), t >= n))
      ) {
        a = o === 61 ? 1 : 2;
        break;
      }
    }
    if (e.sCount[s] < 0) continue;
    let t = !1;
    for (let i = 0, a = r.length; i < a; i++)
      if (r[i](e, s, n, !0)) {
        t = !0;
        break;
      }
    if (t) break;
  }
  if (!a) return ((e.parentType = i), !1);
  let c = XO(e.getLines(t, s, e.blkIndent, !1));
  e.line = s + 1;
  let l = e.push(`heading_open`, `h` + String(a), 1);
  ((l.markup = String.fromCharCode(o)), (l.map = [t, e.line]));
  let u = e.push(`inline`, ``, 0);
  ((u.content = c), (u.map = [t, e.line - 1]), (u.children = []));
  let d = e.push(`heading_close`, `h` + String(a), -1);
  return ((d.markup = String.fromCharCode(o)), (e.parentType = i), !0);
}
function Nk(e, t, n) {
  let r = e.md.block.ruler.getRules(`paragraph`),
    i = e.parentType,
    a = t + 1;
  for (e.parentType = `paragraph`; a < n && !e.isEmpty(a); a++) {
    if (e.sCount[a] - e.blkIndent > 3 || e.sCount[a] < 0) continue;
    let t = !1;
    for (let i = 0, o = r.length; i < o; i++)
      if (r[i](e, a, n, !0)) {
        t = !0;
        break;
      }
    if (t) break;
  }
  let o = XO(e.getLines(t, a, e.blkIndent, !1));
  e.line = a;
  let s = e.push(`paragraph_open`, `p`, 1);
  s.map = [t, e.line];
  let c = e.push(`inline`, ``, 0);
  return (
    (c.content = o),
    (c.map = [t, e.line]),
    (c.children = []),
    e.push(`paragraph_close`, `p`, -1),
    (e.parentType = i),
    !0
  );
}
var Pk = [
  [`table`, gk, [`paragraph`, `reference`]],
  [`code`, _k],
  [`fence`, vk, [`paragraph`, `reference`, `blockquote`, `list`]],
  [`blockquote`, yk, [`paragraph`, `reference`, `blockquote`, `list`]],
  [`hr`, bk, [`paragraph`, `reference`, `blockquote`, `list`]],
  [`list`, wk, [`paragraph`, `reference`, `blockquote`]],
  [`reference`, Tk],
  [`html_block`, Ak, [`paragraph`, `reference`, `blockquote`]],
  [`heading`, jk, [`paragraph`, `reference`, `blockquote`]],
  [`lheading`, Mk],
  [`paragraph`, Nk],
];
function Fk() {
  this.ruler = new $O();
  for (let e = 0; e < Pk.length; e++)
    this.ruler.push(Pk[e][0], Pk[e][1], {
      alt: (Pk[e][2] || []).slice(),
    });
}
((Fk.prototype.tokenize = function (e, t, n) {
  let r = this.ruler.getRules(``),
    i = r.length,
    a = e.md.options.maxNesting,
    o = t,
    s = !1;
  for (; o < n && ((e.line = o = e.skipEmptyLines(o)), !(o >= n || e.sCount[o] < e.blkIndent));) {
    if (e.level >= a) {
      e.line = n;
      break;
    }
    let t = e.line,
      c = !1;
    for (let a = 0; a < i; a++)
      if (((c = r[a](e, o, n, !1)), c)) {
        if (t >= e.line) throw Error(`block rule didn't increment state.line`);
        break;
      }
    if (!c) throw Error(`none of the block rules matched`);
    ((e.tight = !s),
      e.isEmpty(e.line - 1) && (s = !0),
      (o = e.line),
      o < n && e.isEmpty(o) && ((s = !0), o++, (e.line = o)));
  }
}),
  (Fk.prototype.parse = function (e, t, n, r) {
    if (!e) return;
    let i = new this.State(e, t, n, r);
    this.tokenize(i, i.line, i.lineMax);
  }),
  (Fk.prototype.State = fk));
function Ik(e, t, n, r) {
  ((this.src = e),
    (this.env = n),
    (this.md = t),
    (this.tokens = r),
    (this.tokens_meta = Array(r.length)),
    (this.pos = 0),
    (this.posMax = this.src.length),
    (this.level = 0),
    (this.pending = ``),
    (this.pendingLevel = 0),
    (this.cache = {}),
    (this.delimiters = []),
    (this._prev_delimiters = []),
    (this.backticks = {}),
    (this.backticksScanned = !1),
    (this.linkLevel = 0));
}
((Ik.prototype.pushPending = function () {
  let e = new ek(`text`, ``, 0);
  return (
    (e.content = this.pending),
    (e.level = this.pendingLevel),
    this.tokens.push(e),
    (this.pending = ``),
    e
  );
}),
  (Ik.prototype.push = function (e, t, n) {
    this.pending && this.pushPending();
    let r = new ek(e, t, n),
      i = null;
    return (
      n < 0 && (this.level--, (this.delimiters = this._prev_delimiters.pop())),
      (r.level = this.level),
      n > 0 &&
        (this.level++,
        this._prev_delimiters.push(this.delimiters),
        (this.delimiters = []),
        (i = {
          delimiters: this.delimiters,
        })),
      (this.pendingLevel = this.level),
      this.tokens.push(r),
      this.tokens_meta.push(i),
      r
    );
  }),
  (Ik.prototype.scanDelims = function (e, t) {
    let n = this.posMax,
      r = this.src.charCodeAt(e),
      i;
    if (e === 0) i = 32;
    else if (e === 1) ((i = this.src.charCodeAt(0)), (i & 63488) == 55296 && (i = 65533));
    else if (((i = this.src.charCodeAt(e - 1)), (i & 64512) == 56320)) {
      let t = this.src.charCodeAt(e - 2);
      i = (t & 64512) == 55296 ? 65536 + ((t - 55296) << 10) + (i - 56320) : 65533;
    } else (i & 64512) == 55296 && (i = 65533);
    let a = e;
    for (; a < n && this.src.charCodeAt(a) === r;) a++;
    let o = a - e,
      s = a < n ? this.src.charCodeAt(a) : 32;
    if ((s & 64512) == 55296) {
      let e = this.src.charCodeAt(a + 1);
      s = (e & 64512) == 56320 ? 65536 + ((s - 55296) << 10) + (e - 56320) : 65533;
    } else (s & 64512) == 56320 && (s = 65533);
    let c = qO(i) || KO(i),
      l = qO(s) || KO(s),
      u = WO(i),
      d = WO(s),
      f = !d && (!l || u || c),
      p = !u && (!c || d || l);
    return {
      can_open: f && (t || !p || c),
      can_close: p && (t || !f || l),
      length: o,
    };
  }),
  (Ik.prototype.Token = ek));
function Lk(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function Rk(e, t) {
  let n = e.pos;
  for (; n < e.posMax && !Lk(e.src.charCodeAt(n));) n++;
  return n === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, n)), (e.pos = n), !0);
}
var zk = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function Bk(e, t) {
  if (!e.md.options.linkify || e.linkLevel > 0) return !1;
  let n = e.pos,
    r = e.posMax;
  if (
    n + 3 > r ||
    e.src.charCodeAt(n) !== 58 ||
    e.src.charCodeAt(n + 1) !== 47 ||
    e.src.charCodeAt(n + 2) !== 47
  )
    return !1;
  let i = e.pending.match(zk);
  if (!i) return !1;
  let a = i[1],
    o = e.md.linkify.matchAtStart(e.src.slice(n - a.length));
  if (!o) return !1;
  let s = o.url;
  if (s.length <= a.length) return !1;
  let c = s.length;
  for (; c > 0 && s.charCodeAt(c - 1) === 42;) c--;
  c !== s.length && (s = s.slice(0, c));
  let l = e.md.normalizeLink(s);
  if (!e.md.validateLink(l)) return !1;
  if (!t) {
    e.pending = e.pending.slice(0, -a.length);
    let t = e.push(`link_open`, `a`, 1);
    ((t.attrs = [[`href`, l]]), (t.markup = `linkify`), (t.info = `auto`));
    let n = e.push(`text`, ``, 0);
    n.content = e.md.normalizeLinkText(s);
    let r = e.push(`link_close`, `a`, -1);
    ((r.markup = `linkify`), (r.info = `auto`));
  }
  return ((e.pos += s.length - a.length), !0);
}
function Vk(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 10) return !1;
  let r = e.pending.length - 1,
    i = e.posMax;
  if (!t)
    if (r >= 0 && e.pending.charCodeAt(r) === 32) {
      if (r >= 1 && e.pending.charCodeAt(r - 1) === 32) {
        let t = r - 1;
        for (; t >= 1 && e.pending.charCodeAt(t - 1) === 32;) t--;
        ((e.pending = e.pending.slice(0, t)), e.push(`hardbreak`, `br`, 0));
      } else ((e.pending = e.pending.slice(0, -1)), e.push(`softbreak`, `br`, 0));
    } else e.push(`softbreak`, `br`, 0);
  for (n++; n < i && UO(e.src.charCodeAt(n));) n++;
  return ((e.pos = n), !0);
}
var Hk = [];
for (let e = 0; e < 256; e++) Hk.push(0);
`\\!"#$%&'()*+,./:;<=>?@[]^_\`{|}~-`.split(``).forEach(function (e) {
  Hk[e.charCodeAt(0)] = 1;
});
function Uk(e, t) {
  let n = e.pos,
    r = e.posMax;
  if (e.src.charCodeAt(n) !== 92 || (n++, n >= r)) return !1;
  let i = e.src.charCodeAt(n);
  if (i === 10) {
    for (t || e.push(`hardbreak`, `br`, 0), n++; n < r && ((i = e.src.charCodeAt(n)), UO(i));) n++;
    return ((e.pos = n), !0);
  }
  let a = e.src[n];
  if (i >= 55296 && i <= 56319 && n + 1 < r) {
    let t = e.src.charCodeAt(n + 1);
    t >= 56320 && t <= 57343 && ((a += e.src[n + 1]), n++);
  }
  let o = `\\` + a;
  if (!t) {
    let t = e.push(`text_special`, ``, 0);
    (i < 256 && Hk[i] !== 0 ? (t.content = a) : (t.content = o),
      (t.markup = o),
      (t.info = `escape`));
  }
  return ((e.pos = n + 1), !0);
}
function Wk(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 96) return !1;
  let r = n;
  n++;
  let i = e.posMax;
  for (; n < i && e.src.charCodeAt(n) === 96;) n++;
  let a = e.src.slice(r, n),
    o = a.length;
  if (e.backticksScanned && (e.backticks[o] || 0) <= r)
    return (t || (e.pending += a), (e.pos += o), !0);
  let s = n,
    c;
  for (; (c = e.src.indexOf("`", s)) !== -1;) {
    for (s = c + 1; s < i && e.src.charCodeAt(s) === 96;) s++;
    let r = s - c;
    if (r === o) {
      if (!t) {
        let t = e.push(`code_inline`, `code`, 0);
        ((t.markup = a),
          (t.content = e.src
            .slice(n, c)
            .replace(/\n/g, ` `)
            .replace(/^ (.+) $/, `$1`)));
      }
      return ((e.pos = s), !0);
    }
    e.backticks[r] = c;
  }
  return ((e.backticksScanned = !0), t || (e.pending += a), (e.pos += o), !0);
}
function Gk(e, t) {
  let n = e.pos,
    r = e.src.charCodeAt(n);
  if (t || r !== 126) return !1;
  let i = e.scanDelims(e.pos, !0),
    a = i.length,
    o = String.fromCharCode(r);
  if (a < 2) return !1;
  let s;
  a % 2 && ((s = e.push(`text`, ``, 0)), (s.content = o), a--);
  for (let t = 0; t < a; t += 2)
    ((s = e.push(`text`, ``, 0)),
      (s.content = o + o),
      e.delimiters.push({
        marker: r,
        length: 0,
        token: e.tokens.length - 1,
        end: -1,
        open: i.can_open,
        close: i.can_close,
      }));
  return ((e.pos += i.length), !0);
}
function Kk(e, t) {
  let n,
    r = [],
    i = t.length;
  for (let a = 0; a < i; a++) {
    let i = t[a];
    if (i.marker !== 126 || i.end === -1) continue;
    let o = t[i.end];
    ((n = e.tokens[i.token]),
      (n.type = `s_open`),
      (n.tag = `s`),
      (n.nesting = 1),
      (n.markup = `~~`),
      (n.content = ``),
      (n = e.tokens[o.token]),
      (n.type = `s_close`),
      (n.tag = `s`),
      (n.nesting = -1),
      (n.markup = `~~`),
      (n.content = ``),
      e.tokens[o.token - 1].type === `text` &&
        e.tokens[o.token - 1].content === `~` &&
        r.push(o.token - 1));
  }
  for (; r.length;) {
    let t = r.pop(),
      i = t + 1;
    for (; i < e.tokens.length && e.tokens[i].type === `s_close`;) i++;
    (i--, t !== i && ((n = e.tokens[i]), (e.tokens[i] = e.tokens[t]), (e.tokens[t] = n)));
  }
}
function qk(e) {
  let t = e.tokens_meta,
    n = e.tokens_meta.length;
  Kk(e, e.delimiters);
  for (let r = 0; r < n; r++) t[r] && t[r].delimiters && Kk(e, t[r].delimiters);
}
var Jk = {
  tokenize: Gk,
  postProcess: qk,
};
function Yk(e, t) {
  let n = e.pos,
    r = e.src.charCodeAt(n);
  if (t || (r !== 95 && r !== 42)) return !1;
  let i = e.scanDelims(e.pos, r === 42);
  for (let t = 0; t < i.length; t++) {
    let t = e.push(`text`, ``, 0);
    ((t.content = String.fromCharCode(r)),
      e.delimiters.push({
        marker: r,
        length: i.length,
        token: e.tokens.length - 1,
        end: -1,
        open: i.can_open,
        close: i.can_close,
      }));
  }
  return ((e.pos += i.length), !0);
}
function Xk(e, t) {
  let n = t.length;
  for (let r = n - 1; r >= 0; r--) {
    let n = t[r];
    if ((n.marker !== 95 && n.marker !== 42) || n.end === -1) continue;
    let i = t[n.end],
      a =
        r > 0 &&
        t[r - 1].end === n.end + 1 &&
        t[r - 1].marker === n.marker &&
        t[r - 1].token === n.token - 1 &&
        t[n.end + 1].token === i.token + 1,
      o = String.fromCharCode(n.marker),
      s = e.tokens[n.token];
    ((s.type = a ? `strong_open` : `em_open`),
      (s.tag = a ? `strong` : `em`),
      (s.nesting = 1),
      (s.markup = a ? o + o : o),
      (s.content = ``));
    let c = e.tokens[i.token];
    ((c.type = a ? `strong_close` : `em_close`),
      (c.tag = a ? `strong` : `em`),
      (c.nesting = -1),
      (c.markup = a ? o + o : o),
      (c.content = ``),
      a &&
        ((e.tokens[t[r - 1].token].content = ``),
        (e.tokens[t[n.end + 1].token].content = ``),
        r--));
  }
}
function Zk(e) {
  let t = e.tokens_meta,
    n = e.tokens_meta.length;
  Xk(e, e.delimiters);
  for (let r = 0; r < n; r++) t[r] && t[r].delimiters && Xk(e, t[r].delimiters);
}
var Qk = {
  tokenize: Yk,
  postProcess: Zk,
};
function $k(e, t) {
  let n,
    r,
    i,
    a,
    o = ``,
    s = ``,
    c = e.pos,
    l = !0;
  if (e.src.charCodeAt(e.pos) !== 91) return !1;
  let u = e.pos,
    d = e.posMax,
    f = e.pos + 1,
    p = e.md.helpers.parseLinkLabel(e, e.pos, !0);
  if (p < 0) return !1;
  let m = p + 1;
  if (m < d && e.src.charCodeAt(m) === 40) {
    for (l = !1, m++; m < d && ((n = e.src.charCodeAt(m)), !(!UO(n) && n !== 10)); m++);
    if (m >= d) return !1;
    if (((c = m), (i = e.md.helpers.parseLinkDestination(e.src, m, e.posMax)), i.ok)) {
      for (
        o = e.md.normalizeLink(i.str), e.md.validateLink(o) ? (m = i.pos) : (o = ``), c = m;
        m < d && ((n = e.src.charCodeAt(m)), !(!UO(n) && n !== 10));
        m++
      );
      if (((i = e.md.helpers.parseLinkTitle(e.src, m, e.posMax)), m < d && c !== m && i.ok))
        for (
          s = i.str, m = i.pos;
          m < d && ((n = e.src.charCodeAt(m)), !(!UO(n) && n !== 10));
          m++
        );
    }
    ((m >= d || e.src.charCodeAt(m) !== 41) && (l = !0), m++);
  }
  if (l) {
    if (e.env.references === void 0) return !1;
    if (
      (m < d && e.src.charCodeAt(m) === 91
        ? ((c = m + 1),
          (m = e.md.helpers.parseLinkLabel(e, m)),
          m >= 0 ? (r = e.src.slice(c, m++)) : (m = p + 1))
        : (m = p + 1),
      (r ||= e.src.slice(f, p)),
      (a = e.env.references[JO(r)]),
      !a)
    )
      return ((e.pos = u), !1);
    ((o = a.href), (s = a.title));
  }
  if (!t) {
    ((e.pos = f), (e.posMax = p));
    let t = e.push(`link_open`, `a`, 1),
      n = [[`href`, o]];
    ((t.attrs = n),
      s && n.push([`title`, s]),
      e.linkLevel++,
      e.md.inline.tokenize(e),
      e.linkLevel--,
      e.push(`link_close`, `a`, -1));
  }
  return ((e.pos = m), (e.posMax = d), !0);
}
function eA(e, t) {
  let n,
    r,
    i,
    a,
    o,
    s,
    c,
    l,
    u = ``,
    d = e.pos,
    f = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91) return !1;
  let p = e.pos + 2,
    m = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
  if (m < 0) return !1;
  if (((a = m + 1), a < f && e.src.charCodeAt(a) === 40)) {
    for (a++; a < f && ((n = e.src.charCodeAt(a)), !(!UO(n) && n !== 10)); a++);
    if (a >= f) return !1;
    for (
      l = a,
        s = e.md.helpers.parseLinkDestination(e.src, a, e.posMax),
        s.ok && ((u = e.md.normalizeLink(s.str)), e.md.validateLink(u) ? (a = s.pos) : (u = ``)),
        l = a;
      a < f && ((n = e.src.charCodeAt(a)), !(!UO(n) && n !== 10));
      a++
    );
    if (((s = e.md.helpers.parseLinkTitle(e.src, a, e.posMax)), a < f && l !== a && s.ok))
      for (c = s.str, a = s.pos; a < f && ((n = e.src.charCodeAt(a)), !(!UO(n) && n !== 10)); a++);
    else c = ``;
    if (a >= f || e.src.charCodeAt(a) !== 41) return ((e.pos = d), !1);
    a++;
  } else {
    if (e.env.references === void 0) return !1;
    if (
      (a < f && e.src.charCodeAt(a) === 91
        ? ((l = a + 1),
          (a = e.md.helpers.parseLinkLabel(e, a)),
          a >= 0 ? (i = e.src.slice(l, a++)) : (a = m + 1))
        : (a = m + 1),
      (i ||= e.src.slice(p, m)),
      (o = e.env.references[JO(i)]),
      !o)
    )
      return ((e.pos = d), !1);
    ((u = o.href), (c = o.title));
  }
  if (!t) {
    r = e.src.slice(p, m);
    let t = [];
    e.md.inline.parse(r, e.md, e.env, t);
    let n = e.push(`image`, `img`, 0),
      i = [
        [`src`, u],
        [`alt`, ``],
      ];
    ((n.attrs = i), (n.children = t), (n.content = r), c && i.push([`title`, c]));
  }
  return ((e.pos = a), (e.posMax = f), !0);
}
var tA =
    /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/,
  nA = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function rA(e, t) {
  let n = e.pos;
  if (e.src.charCodeAt(n) !== 60) return !1;
  let r = e.pos,
    i = e.posMax;
  for (;;) {
    if (++n >= i) return !1;
    let t = e.src.charCodeAt(n);
    if (t === 60) return !1;
    if (t === 62) break;
  }
  let a = e.src.slice(r + 1, n);
  if (nA.test(a)) {
    let n = e.md.normalizeLink(a);
    if (!e.md.validateLink(n)) return !1;
    if (!t) {
      let t = e.push(`link_open`, `a`, 1);
      ((t.attrs = [[`href`, n]]), (t.markup = `autolink`), (t.info = `auto`));
      let r = e.push(`text`, ``, 0);
      r.content = e.md.normalizeLinkText(a);
      let i = e.push(`link_close`, `a`, -1);
      ((i.markup = `autolink`), (i.info = `auto`));
    }
    return ((e.pos += a.length + 2), !0);
  }
  if (tA.test(a)) {
    let n = e.md.normalizeLink(`mailto:` + a);
    if (!e.md.validateLink(n)) return !1;
    if (!t) {
      let t = e.push(`link_open`, `a`, 1);
      ((t.attrs = [[`href`, n]]), (t.markup = `autolink`), (t.info = `auto`));
      let r = e.push(`text`, ``, 0);
      r.content = e.md.normalizeLinkText(a);
      let i = e.push(`link_close`, `a`, -1);
      ((i.markup = `autolink`), (i.info = `auto`));
    }
    return ((e.pos += a.length + 2), !0);
  }
  return !1;
}
function iA(e) {
  return /^<a[>\s]/i.test(e);
}
function aA(e) {
  return /^<\/a\s*>/i.test(e);
}
function oA(e) {
  let t = e | 32;
  return t >= 97 && t <= 122;
}
function sA(e, t) {
  if (!e.md.options.html) return !1;
  let n = e.posMax,
    r = e.pos;
  if (e.src.charCodeAt(r) !== 60 || r + 2 >= n) return !1;
  let i = e.src.charCodeAt(r + 1);
  if (i !== 33 && i !== 63 && i !== 47 && !oA(i)) return !1;
  let a = e.src.slice(r).match(Dk);
  if (!a) return !1;
  if (!t) {
    let t = e.push(`html_inline`, ``, 0);
    ((t.content = a[0]), iA(t.content) && e.linkLevel++, aA(t.content) && e.linkLevel--);
  }
  return ((e.pos += a[0].length), !0);
}
var cA = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i,
  lA = /^&([a-z][a-z0-9]{1,31});/i;
function uA(e, t) {
  let n = e.pos,
    r = e.posMax;
  if (e.src.charCodeAt(n) !== 38 || n + 1 >= r) return !1;
  if (e.src.charCodeAt(n + 1) === 35) {
    let r = e.src.slice(n).match(cA);
    if (r) {
      if (!t) {
        let t = r[1][0].toLowerCase() === `x` ? parseInt(r[1].slice(1), 16) : parseInt(r[1], 10),
          n = e.push(`text_special`, ``, 0);
        ((n.content = RO(t) ? zO(t) : zO(65533)), (n.markup = r[0]), (n.info = `entity`));
      }
      return ((e.pos += r[0].length), !0);
    }
  } else {
    let r = e.src.slice(n).match(lA);
    if (r) {
      let n = Soe(r[0]);
      if (n !== r[0]) {
        if (!t) {
          let t = e.push(`text_special`, ``, 0);
          ((t.content = n), (t.markup = r[0]), (t.info = `entity`));
        }
        return ((e.pos += r[0].length), !0);
      }
    }
  }
  return !1;
}
function dA(e) {
  let t = {},
    n = e.length;
  if (!n) return;
  let r = 0,
    i = -2,
    a = [];
  for (let o = 0; o < n; o++) {
    let n = e[o];
    if (
      (a.push(0),
      (e[r].marker !== n.marker || i !== n.token - 1) && (r = o),
      (i = n.token),
      (n.length = n.length || 0),
      !n.close)
    )
      continue;
    t.hasOwnProperty(n.marker) || (t[n.marker] = [-1, -1, -1, -1, -1, -1]);
    let s = t[n.marker][(n.open ? 3 : 0) + (n.length % 3)],
      c = r - a[r] - 1,
      l = c;
    for (; c > s; c -= a[c] + 1) {
      let t = e[c];
      if (t.marker === n.marker && t.open && t.end < 0) {
        let r = !1;
        if (
          ((t.close || n.open) &&
            (t.length + n.length) % 3 == 0 &&
            (t.length % 3 != 0 || n.length % 3 != 0) &&
            (r = !0),
          !r)
        ) {
          let r = c > 0 && !e[c - 1].open ? a[c - 1] + 1 : 0;
          ((a[o] = o - c + r),
            (a[c] = r),
            (n.open = !1),
            (t.end = o),
            (t.close = !1),
            (l = -1),
            (i = -2));
          break;
        }
      }
    }
    l !== -1 && (t[n.marker][(n.open ? 3 : 0) + ((n.length || 0) % 3)] = l);
  }
}
function fA(e) {
  let t = e.tokens_meta,
    n = e.tokens_meta.length;
  dA(e.delimiters);
  for (let e = 0; e < n; e++) t[e] && t[e].delimiters && dA(t[e].delimiters);
}
function pA(e) {
  let t,
    n,
    r = 0,
    i = e.tokens,
    a = e.tokens.length;
  for (t = n = 0; t < a; t++)
    (i[t].nesting < 0 && r--,
      (i[t].level = r),
      i[t].nesting > 0 && r++,
      i[t].type === `text` && t + 1 < a && i[t + 1].type === `text`
        ? (i[t + 1].content = i[t].content + i[t + 1].content)
        : (t !== n && (i[n] = i[t]), n++));
  t !== n && (i.length = n);
}
var mA = [
    [`text`, Rk],
    [`linkify`, Bk],
    [`newline`, Vk],
    [`escape`, Uk],
    [`backticks`, Wk],
    [`strikethrough`, Jk.tokenize],
    [`emphasis`, Qk.tokenize],
    [`link`, $k],
    [`image`, eA],
    [`autolink`, rA],
    [`html_inline`, sA],
    [`entity`, uA],
  ],
  hA = [
    [`balance_pairs`, fA],
    [`strikethrough`, Jk.postProcess],
    [`emphasis`, Qk.postProcess],
    [`fragments_join`, pA],
  ];
function gA() {
  this.ruler = new $O();
  for (let e = 0; e < mA.length; e++) this.ruler.push(mA[e][0], mA[e][1]);
  this.ruler2 = new $O();
  for (let e = 0; e < hA.length; e++) this.ruler2.push(hA[e][0], hA[e][1]);
}
((gA.prototype.skipToken = function (e) {
  let t = e.pos,
    n = this.ruler.getRules(``),
    r = n.length,
    i = e.md.options.maxNesting,
    a = e.cache;
  if (a[t] !== void 0) {
    e.pos = a[t];
    return;
  }
  let o = !1;
  if (e.level < i) {
    for (let i = 0; i < r; i++)
      if ((e.level++, (o = n[i](e, !0)), e.level--, o)) {
        if (t >= e.pos) throw Error(`inline rule didn't increment state.pos`);
        break;
      }
  } else e.pos = e.posMax;
  (o || e.pos++, (a[t] = e.pos));
}),
  (gA.prototype.tokenize = function (e) {
    let t = this.ruler.getRules(``),
      n = t.length,
      r = e.posMax,
      i = e.md.options.maxNesting;
    for (; e.pos < r;) {
      let a = e.pos,
        o = !1;
      if (e.level < i) {
        for (let r = 0; r < n; r++)
          if (((o = t[r](e, !1)), o)) {
            if (a >= e.pos) throw Error(`inline rule didn't increment state.pos`);
            break;
          }
      }
      if (o) {
        if (e.pos >= r) break;
        continue;
      }
      e.pending += e.src[e.pos++];
    }
    e.pending && e.pushPending();
  }),
  (gA.prototype.parse = function (e, t, n, r) {
    let i = new this.State(e, t, n, r);
    this.tokenize(i);
    let a = this.ruler2.getRules(``),
      o = a.length;
    for (let e = 0; e < o; e++) a[e](i);
  }),
  (gA.prototype.State = Ik));
function _A(e) {
  let t = {};
  return (
    (e ||= {}),
    (t.src_Any = CO.source),
    (t.src_Cc = wO.source),
    (t.src_Z = DO.source),
    (t.src_P = TO.source),
    (t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join(`|`)),
    (t.src_ZCc = [t.src_Z, t.src_Cc].join(`|`)),
    (t.src_pseudo_letter = `(?:(?![><｜]|` + t.src_ZPCc + `)` + t.src_Any + `)`),
    (t.src_ip4 = `(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)`),
    (t.src_auth = `(?:(?:(?!` + t.src_ZCc + `|[@/\\[\\]()]).)+@)?`),
    (t.src_port = `(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?`),
    (t.src_host_terminator =
      `(?=$|[><｜]|` +
      t.src_ZPCc +
      `)(?!` +
      (e[`---`] ? `-(?!--)|` : `-|`) +
      `_|:\\d|\\.-|\\.(?!$|` +
      t.src_ZPCc +
      `))`),
    (t.src_path =
      `(?:[/?#](?:(?!` +
      t.src_ZCc +
      `|[><｜]|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` +
      t.src_ZCc +
      `|\\]).)*\\]|\\((?:(?!` +
      t.src_ZCc +
      `|[)]).)*\\)|\\{(?:(?!` +
      t.src_ZCc +
      `|[}]).)*\\}|\\"(?:(?!` +
      t.src_ZCc +
      `|["]).)+\\"|\\'(?:(?!` +
      t.src_ZCc +
      `|[']).)+\\'|\\'(?=` +
      t.src_pseudo_letter +
      `|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!` +
      t.src_ZCc +
      `|[.]|$)|` +
      (e[`---`] ? `\\-(?!--(?:[^-]|$))(?:-*)|` : `\\-+|`) +
      `,(?!` +
      t.src_ZCc +
      `|$)|;(?!` +
      t.src_ZCc +
      `|$)|\\!+(?!` +
      t.src_ZCc +
      `|[!]|$)|\\?(?!` +
      t.src_ZCc +
      `|[?]|$))+|\\/)?`),
    (t.src_email_name = `[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*`),
    (t.src_xn = `xn--[a-z0-9\\-]{1,59}`),
    (t.src_domain_root = `(?:` + t.src_xn + `|` + t.src_pseudo_letter + `{1,63})`),
    (t.src_domain =
      `(?:` +
      t.src_xn +
      `|(?:` +
      t.src_pseudo_letter +
      `)|(?:` +
      t.src_pseudo_letter +
      `(?:-|` +
      t.src_pseudo_letter +
      `){0,61}` +
      t.src_pseudo_letter +
      `))`),
    (t.src_host = `(?:(?:(?:(?:` + t.src_domain + `)\\.)*` + t.src_domain + `))`),
    (t.tpl_host_fuzzy = `(?:` + t.src_ip4 + `|(?:(?:(?:` + t.src_domain + `)\\.)+(?:%TLDS%)))`),
    (t.tpl_host_no_ip_fuzzy = `(?:(?:(?:` + t.src_domain + `)\\.)+(?:%TLDS%))`),
    (t.src_host_strict = t.src_host + t.src_host_terminator),
    (t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator),
    (t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator),
    (t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator),
    (t.tpl_host_port_no_ip_fuzzy_strict =
      t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator),
    (t.tpl_host_fuzzy_test =
      `localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:` + t.src_ZPCc + `|>|$))`),
    (t.tpl_email_fuzzy =
      `(^|[><｜]|"|\\(|` +
      t.src_ZCc +
      `)(` +
      t.src_email_name +
      `@` +
      t.tpl_host_fuzzy_strict +
      `)`),
    (t.tpl_link_fuzzy =
      "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" +
      t.src_ZPCc +
      "))((?![$+<=>^`|｜])" +
      t.tpl_host_port_fuzzy_strict +
      t.src_path +
      `)`),
    (t.tpl_link_no_ip_fuzzy =
      "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" +
      t.src_ZPCc +
      "))((?![$+<=>^`|｜])" +
      t.tpl_host_port_no_ip_fuzzy_strict +
      t.src_path +
      `)`),
    t
  );
}
function vA(e) {
  return (
    Array.prototype.slice.call(arguments, 1).forEach(function (t) {
      t &&
        Object.keys(t).forEach(function (n) {
          e[n] = t[n];
        });
    }),
    e
  );
}
function yA(e) {
  return Object.prototype.toString.call(e);
}
function bA(e) {
  return yA(e) === `[object String]`;
}
function xA(e) {
  return yA(e) === `[object Object]`;
}
function SA(e) {
  return yA(e) === `[object RegExp]`;
}
function CA(e) {
  return yA(e) === `[object Function]`;
}
function wA(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, `\\$&`);
}
var TA = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1,
};
function EA(e) {
  return Object.keys(e || {}).reduce(function (e, t) {
    return e || TA.hasOwnProperty(t);
  }, !1);
}
var DA = {
    "http:": {
      validate: function (e, t, n) {
        let r = e.slice(t);
        return (
          n.re.http ||
            (n.re.http = RegExp(
              `^\\/\\/` + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
              `i`,
            )),
          n.re.http.test(r) ? r.match(n.re.http)[0].length : 0
        );
      },
    },
    "https:": `http:`,
    "ftp:": `http:`,
    "//": {
      validate: function (e, t, n) {
        let r = e.slice(t);
        return (
          n.re.no_http ||
            (n.re.no_http = RegExp(
              `^` +
                n.re.src_auth +
                `(?:localhost|(?:(?:` +
                n.re.src_domain +
                `)\\.)+` +
                n.re.src_domain_root +
                `)` +
                n.re.src_port +
                n.re.src_host_terminator +
                n.re.src_path,
              `i`,
            )),
          n.re.no_http.test(r)
            ? (t >= 3 && e[t - 3] === `:`) || (t >= 3 && e[t - 3] === `/`)
              ? 0
              : r.match(n.re.no_http)[0].length
            : 0
        );
      },
    },
    "mailto:": {
      validate: function (e, t, n) {
        let r = e.slice(t);
        return (
          n.re.mailto ||
            (n.re.mailto = RegExp(`^` + n.re.src_email_name + `@` + n.re.src_host_strict, `i`)),
          n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0
        );
      },
    },
  },
  OA = `a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]`,
  kA = `biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф`.split(`|`);
function AA(e) {
  return function (t, n) {
    let r = t.slice(n);
    return e.test(r) ? r.match(e)[0].length : 0;
  };
}
function jA() {
  return function (e, t) {
    t.normalize(e);
  };
}
function MA(e) {
  let t = (e.re = _A(e.__opts__)),
    n = e.__tlds__.slice();
  (e.onCompile(), e.__tlds_replaced__ || n.push(OA), n.push(t.src_xn), (t.src_tlds = n.join(`|`)));
  function r(e) {
    return e.replace(`%TLDS%`, t.src_tlds);
  }
  ((t.email_fuzzy = RegExp(r(t.tpl_email_fuzzy), `i`)),
    (t.email_fuzzy_global = RegExp(r(t.tpl_email_fuzzy), `ig`)),
    (t.link_fuzzy = RegExp(r(t.tpl_link_fuzzy), `i`)),
    (t.link_fuzzy_global = RegExp(r(t.tpl_link_fuzzy), `ig`)),
    (t.link_no_ip_fuzzy = RegExp(r(t.tpl_link_no_ip_fuzzy), `i`)),
    (t.link_no_ip_fuzzy_global = RegExp(r(t.tpl_link_no_ip_fuzzy), `ig`)),
    (t.host_fuzzy_test = RegExp(r(t.tpl_host_fuzzy_test), `i`)));
  let i = [];
  e.__compiled__ = {};
  function a(e, t) {
    throw Error(`(LinkifyIt) Invalid schema "` + e + `": ` + t);
  }
  (Object.keys(e.__schemas__).forEach(function (t) {
    let n = e.__schemas__[t];
    if (n === null) return;
    let r = {
      validate: null,
      link: null,
    };
    if (((e.__compiled__[t] = r), xA(n))) {
      (SA(n.validate)
        ? (r.validate = AA(n.validate))
        : CA(n.validate)
          ? (r.validate = n.validate)
          : a(t, n),
        CA(n.normalize)
          ? (r.normalize = n.normalize)
          : n.normalize
            ? a(t, n)
            : (r.normalize = jA()));
      return;
    }
    if (bA(n)) {
      i.push(t);
      return;
    }
    a(t, n);
  }),
    i.forEach(function (t) {
      e.__compiled__[e.__schemas__[t]] &&
        ((e.__compiled__[t].validate = e.__compiled__[e.__schemas__[t]].validate),
        (e.__compiled__[t].normalize = e.__compiled__[e.__schemas__[t]].normalize));
    }),
    (e.__compiled__[``] = {
      validate: null,
      normalize: jA(),
    }));
  let o = Object.keys(e.__compiled__)
    .filter(function (t) {
      return t.length > 0 && e.__compiled__[t];
    })
    .map(wA)
    .join(`|`);
  ((e.re.schema_test = RegExp(`(^|(?!_)(?:[><｜]|` + t.src_ZPCc + `))(` + o + `)`, `i`)),
    (e.re.schema_search = RegExp(`(^|(?!_)(?:[><｜]|` + t.src_ZPCc + `))(` + o + `)`, `ig`)),
    (e.re.schema_at_start = RegExp(`^` + e.re.schema_search.source, `i`)),
    (e.re.pretest = RegExp(
      `(` + e.re.schema_test.source + `)|(` + e.re.host_fuzzy_test.source + `)|@`,
      `i`,
    )));
}
function NA(e, t, n, r) {
  let i = e.slice(n, r);
  ((this.schema = t.toLowerCase()),
    (this.index = n),
    (this.lastIndex = r),
    (this.raw = i),
    (this.text = i),
    (this.url = i));
}
function PA(e, t) {
  if (!(this instanceof PA)) return new PA(e, t);
  (t || (EA(e) && ((t = e), (e = {}))),
    (this.__opts__ = vA({}, TA, t)),
    (this.__schemas__ = vA({}, DA, e)),
    (this.__compiled__ = {}),
    (this.__tlds__ = kA),
    (this.__tlds_replaced__ = !1),
    (this.re = {}),
    MA(this));
}
((PA.prototype.add = function (e, t) {
  return ((this.__schemas__[e] = t), MA(this), this);
}),
  (PA.prototype.set = function (e) {
    return ((this.__opts__ = vA(this.__opts__, e)), this);
  }),
  (PA.prototype.test = function (e) {
    if (!e.length) return !1;
    let t, n;
    if (this.re.schema_test.test(e)) {
      for (n = this.re.schema_search, n.lastIndex = 0; (t = n.exec(e)) !== null;)
        if (this.testSchemaAt(e, t[2], n.lastIndex)) return !0;
    }
    return !!(
      (this.__opts__.fuzzyLink &&
        this.__compiled__[`http:`] &&
        e.search(this.re.host_fuzzy_test) >= 0 &&
        e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null) ||
      (this.__opts__.fuzzyEmail &&
        this.__compiled__[`mailto:`] &&
        e.indexOf(`@`) >= 0 &&
        e.match(this.re.email_fuzzy) !== null)
    );
  }),
  (PA.prototype.pretest = function (e) {
    return this.re.pretest.test(e);
  }),
  (PA.prototype.testSchemaAt = function (e, t, n) {
    return this.__compiled__[t.toLowerCase()]
      ? this.__compiled__[t.toLowerCase()].validate(e, n, this)
      : 0;
  }),
  (PA.prototype.match = function (e) {
    let t = [],
      n = [],
      r = [],
      i = [],
      a,
      o,
      s;
    function c(e, t) {
      return e
        ? t
          ? e.index === t.index
            ? e.lastIndex >= t.lastIndex
              ? e
              : t
            : e.index < t.index
              ? e
              : t
          : e
        : t;
    }
    if (!e.length) return null;
    if (this.re.schema_test.test(e))
      for (s = this.re.schema_search, s.lastIndex = 0; (a = s.exec(e)) !== null;)
        ((o = this.testSchemaAt(e, a[2], s.lastIndex)),
          o &&
            n.push({
              schema: a[2],
              index: a.index + a[1].length,
              lastIndex: a.index + a[0].length + o,
            }));
    if (this.__opts__.fuzzyLink && this.__compiled__[`http:`])
      for (
        s = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global,
          s.lastIndex = 0;
        (a = s.exec(e)) !== null;
      )
        r.push({
          schema: ``,
          index: a.index + a[1].length,
          lastIndex: a.index + a[0].length,
        });
    if (this.__opts__.fuzzyEmail && this.__compiled__[`mailto:`])
      for (s = this.re.email_fuzzy_global, s.lastIndex = 0; (a = s.exec(e)) !== null;)
        i.push({
          schema: `mailto:`,
          index: a.index + a[1].length,
          lastIndex: a.index + a[0].length,
        });
    let l = [0, 0, 0],
      u = 0;
    for (;;) {
      let a = [n[l[0]], i[l[1]], r[l[2]]],
        o = c(c(a[0], a[1]), a[2]);
      if (!o) break;
      if ((o === a[0] ? l[0]++ : o === a[1] ? l[1]++ : l[2]++, o.index < u)) continue;
      let s = new NA(e, o.schema, o.index, o.lastIndex);
      (this.__compiled__[s.schema].normalize(s, this), t.push(s), (u = o.lastIndex));
    }
    return t.length ? t : null;
  }),
  (PA.prototype.matchAtStart = function (e) {
    if (!e.length) return null;
    let t = this.re.schema_at_start.exec(e);
    if (!t) return null;
    let n = this.testSchemaAt(e, t[2], t[0].length);
    if (!n) return null;
    let r = new NA(e, t[2], t.index + t[1].length, t.index + t[0].length + n);
    return (this.__compiled__[r.schema].normalize(r, this), r);
  }),
  (PA.prototype.tlds = function (e, t) {
    return (
      (e = Array.isArray(e) ? e : [e]),
      t
        ? ((this.__tlds__ = this.__tlds__
            .concat(e)
            .sort()
            .filter(function (e, t, n) {
              return e !== n[t - 1];
            })
            .reverse()),
          MA(this),
          this)
        : ((this.__tlds__ = e.slice()), (this.__tlds_replaced__ = !0), MA(this), this)
    );
  }),
  (PA.prototype.normalize = function (e) {
    (e.schema || (e.url = `http://` + e.url),
      e.schema === `mailto:` && !/^mailto:/i.test(e.url) && (e.url = `mailto:` + e.url));
  }),
  (PA.prototype.onCompile = function () {}));
var FA = 2147483647,
  IA = 36,
  LA = 1,
  RA = 26,
  zA = 38,
  BA = 700,
  VA = 72,
  HA = 128,
  UA = `-`,
  WA = /^xn--/,
  GA = /[^\0-\x7F]/,
  KA = /[\x2E\u3002\uFF0E\uFF61]/g,
  qA = {
    overflow: `Overflow: input needs wider integers to process`,
    "not-basic": `Illegal input >= 0x80 (not a basic code point)`,
    "invalid-input": `Invalid input`,
  },
  JA = IA - LA,
  YA = Math.floor,
  XA = String.fromCharCode;
function ZA(e) {
  throw RangeError(qA[e]);
}
function QA(e, t) {
  let n = [],
    r = e.length;
  for (; r--;) n[r] = t(e[r]);
  return n;
}
function $A(e, t) {
  let n = e.split(`@`),
    r = ``;
  (n.length > 1 && ((r = n[0] + `@`), (e = n[1])), (e = e.replace(KA, `.`)));
  let i = QA(e.split(`.`), t).join(`.`);
  return r + i;
}
function ej(e) {
  let t = [],
    n = 0,
    r = e.length;
  for (; n < r;) {
    let i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      let r = e.charCodeAt(n++);
      (r & 64512) == 56320 ? t.push(((i & 1023) << 10) + (r & 1023) + 65536) : (t.push(i), n--);
    } else t.push(i);
  }
  return t;
}
var tj = (e) => String.fromCodePoint(...e),
  nj = function (e) {
    return e >= 48 && e < 58
      ? 26 + (e - 48)
      : e >= 65 && e < 91
        ? e - 65
        : e >= 97 && e < 123
          ? e - 97
          : IA;
  },
  rj = function (e, t) {
    return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
  },
  ij = function (e, t, n) {
    let r = 0;
    for (e = n ? YA(e / BA) : e >> 1, e += YA(e / t); e > 455; r += IA) e = YA(e / JA);
    return YA(r + (36 * e) / (e + zA));
  },
  aj = function (e) {
    let t = [],
      n = e.length,
      r = 0,
      i = HA,
      a = VA,
      o = e.lastIndexOf(UA);
    o < 0 && (o = 0);
    for (let n = 0; n < o; ++n)
      (e.charCodeAt(n) >= 128 && ZA(`not-basic`), t.push(e.charCodeAt(n)));
    for (let s = o > 0 ? o + 1 : 0; s < n;) {
      let o = r;
      for (let t = 1, i = IA; ; i += IA) {
        s >= n && ZA(`invalid-input`);
        let o = nj(e.charCodeAt(s++));
        (o >= IA && ZA(`invalid-input`), o > YA((FA - r) / t) && ZA(`overflow`), (r += o * t));
        let c = i <= a ? LA : i >= a + RA ? RA : i - a;
        if (o < c) break;
        let l = IA - c;
        (t > YA(FA / l) && ZA(`overflow`), (t *= l));
      }
      let c = t.length + 1;
      ((a = ij(r - o, c, o == 0)),
        YA(r / c) > FA - i && ZA(`overflow`),
        (i += YA(r / c)),
        (r %= c),
        t.splice(r++, 0, i));
    }
    return String.fromCodePoint(...t);
  },
  oj = function (e) {
    let t = [];
    e = ej(e);
    let n = e.length,
      r = HA,
      i = 0,
      a = VA;
    for (let n of e) n < 128 && t.push(XA(n));
    let o = t.length,
      s = o;
    for (o && t.push(UA); s < n;) {
      let n = FA;
      for (let t of e) t >= r && t < n && (n = t);
      let c = s + 1;
      (n - r > YA((FA - i) / c) && ZA(`overflow`), (i += (n - r) * c), (r = n));
      for (let n of e)
        if ((n < r && ++i > FA && ZA(`overflow`), n === r)) {
          let e = i;
          for (let n = IA; ; n += IA) {
            let r = n <= a ? LA : n >= a + RA ? RA : n - a;
            if (e < r) break;
            let i = e - r,
              o = IA - r;
            (t.push(XA(rj(r + (i % o), 0))), (e = YA(i / o)));
          }
          (t.push(XA(rj(e, 0))), (a = ij(i, c, s === o)), (i = 0), ++s);
        }
      (++i, ++r);
    }
    return t.join(``);
  },
  sj = {
    version: `2.3.1`,
    ucs2: {
      decode: ej,
      encode: tj,
    },
    decode: aj,
    encode: oj,
    toASCII: function (e) {
      return $A(e, function (e) {
        return GA.test(e) ? `xn--` + oj(e) : e;
      });
    },
    toUnicode: function (e) {
      return $A(e, function (e) {
        return WA.test(e) ? aj(e.slice(4).toLowerCase()) : e;
      });
    },
  },
  cj = {
    default: {
      options: {
        html: !1,
        xhtmlOut: !1,
        breaks: !1,
        langPrefix: `language-`,
        linkify: !1,
        typographer: !1,
        quotes: `“”‘’`,
        highlight: null,
        maxNesting: 100,
      },
      components: {
        core: {},
        block: {},
        inline: {},
      },
    },
    zero: {
      options: {
        html: !1,
        xhtmlOut: !1,
        breaks: !1,
        langPrefix: `language-`,
        linkify: !1,
        typographer: !1,
        quotes: `“”‘’`,
        highlight: null,
        maxNesting: 20,
      },
      components: {
        core: {
          rules: [`normalize`, `block`, `inline`, `text_join`],
        },
        block: {
          rules: [`paragraph`],
        },
        inline: {
          rules: [`text`],
          rules2: [`balance_pairs`, `fragments_join`],
        },
      },
    },
    commonmark: {
      options: {
        html: !0,
        xhtmlOut: !0,
        breaks: !1,
        langPrefix: `language-`,
        linkify: !1,
        typographer: !1,
        quotes: `“”‘’`,
        highlight: null,
        maxNesting: 20,
      },
      components: {
        core: {
          rules: [`normalize`, `block`, `inline`, `text_join`],
        },
        block: {
          rules: [
            `blockquote`,
            `code`,
            `fence`,
            `heading`,
            `hr`,
            `html_block`,
            `lheading`,
            `list`,
            `reference`,
            `paragraph`,
          ],
        },
        inline: {
          rules: [
            `autolink`,
            `backticks`,
            `emphasis`,
            `entity`,
            `escape`,
            `html_inline`,
            `image`,
            `link`,
            `newline`,
            `text`,
          ],
          rules2: [`balance_pairs`, `emphasis`, `fragments_join`],
        },
      },
    },
  },
  lj = /^(vbscript|javascript|file|data):/,
  uj = /^data:image\/(gif|png|jpeg|webp);/;
function dj(e) {
  let t = e.trim().toLowerCase();
  return lj.test(t) ? uj.test(t) : !0;
}
var fj = [`http:`, `https:`, `mailto:`];
function pj(e) {
  let t = SO(e, !0);
  if (t.hostname && (!t.protocol || fj.indexOf(t.protocol) >= 0))
    try {
      t.hostname = sj.toASCII(t.hostname);
    } catch {}
  return mO(hO(t));
}
function mj(e) {
  let t = SO(e, !0);
  if (t.hostname && (!t.protocol || fj.indexOf(t.protocol) >= 0))
    try {
      t.hostname = sj.toUnicode(t.hostname);
    } catch {}
  return fO(hO(t), fO.defaultChars + `%`);
}
function hj(e, t) {
  if (!(this instanceof hj)) return new hj(e, t);
  (t || FO(e) || ((t = e || {}), (e = `default`)),
    (this.inline = new gA()),
    (this.block = new Fk()),
    (this.core = new dk()),
    (this.renderer = new QO()),
    (this.linkify = new PA()),
    (this.validateLink = dj),
    (this.normalizeLink = pj),
    (this.normalizeLinkText = mj),
    (this.utils = Coe),
    (this.helpers = IO({}, Voe)),
    (this.options = {}),
    this.configure(e),
    t && this.set(t));
}
((hj.prototype.set = function (e) {
  return (IO(this.options, e), this);
}),
  (hj.prototype.configure = function (e) {
    let t = this;
    if (FO(e)) {
      let t = e;
      if (((e = cj[t]), !e)) throw Error('Wrong `markdown-it` preset "' + t + `", check name`);
    }
    if (!e) throw Error("Wrong `markdown-it` preset, can't be empty");
    return (
      e.options && t.set(e.options),
      e.components &&
        Object.keys(e.components).forEach(function (n) {
          (e.components[n].rules && t[n].ruler.enableOnly(e.components[n].rules),
            e.components[n].rules2 && t[n].ruler2.enableOnly(e.components[n].rules2));
        }),
      this
    );
  }),
  (hj.prototype.enable = function (e, t) {
    let n = [];
    (Array.isArray(e) || (e = [e]),
      [`core`, `block`, `inline`].forEach(function (t) {
        n = n.concat(this[t].ruler.enable(e, !0));
      }, this),
      (n = n.concat(this.inline.ruler2.enable(e, !0))));
    let r = e.filter(function (e) {
      return n.indexOf(e) < 0;
    });
    if (r.length && !t) throw Error(`MarkdownIt. Failed to enable unknown rule(s): ` + r);
    return this;
  }),
  (hj.prototype.disable = function (e, t) {
    let n = [];
    (Array.isArray(e) || (e = [e]),
      [`core`, `block`, `inline`].forEach(function (t) {
        n = n.concat(this[t].ruler.disable(e, !0));
      }, this),
      (n = n.concat(this.inline.ruler2.disable(e, !0))));
    let r = e.filter(function (e) {
      return n.indexOf(e) < 0;
    });
    if (r.length && !t) throw Error(`MarkdownIt. Failed to disable unknown rule(s): ` + r);
    return this;
  }),
  (hj.prototype.use = function (e) {
    let t = [this].concat(Array.prototype.slice.call(arguments, 1));
    return (e.apply(e, t), this);
  }),
  (hj.prototype.parse = function (e, t) {
    if (typeof e != `string`) throw Error(`Input data should be a String`);
    let n = new this.core.State(e, this, t);
    return (this.core.process(n), n.tokens);
  }),
  (hj.prototype.render = function (e, t) {
    return ((t ||= {}), this.renderer.render(this.parse(e, t), this.options, t));
  }),
  (hj.prototype.parseInline = function (e, t) {
    let n = new this.core.State(e, this, t);
    return ((n.inlineMode = !0), this.core.process(n), n.tokens);
  }),
  (hj.prototype.renderInline = function (e, t) {
    return ((t ||= {}), this.renderer.render(this.parseInline(e, t), this.options, t));
  }));
var gj = new Set([!0, !1, `alt`, `title`]);
function _j(e, t) {
  return (Array.isArray(e) ? e : []).filter(([e]) => e !== t);
}
function vj(e, t) {
  e && e.attrs && (e.attrs = _j(e.attrs, t));
}
function yj(e, t) {
  if (!gj.has(e)) throw TypeError(`figcaption must be one of: ${[...gj]}.`);
  if (e === `alt`) return t.content;
  let n = t.attrs.find(([e]) => e === `title`);
  return Array.isArray(n) && n[1] ? (vj(t, `title`), n[1]) : void 0;
}
function bj(e, t) {
  ((t ||= {}),
    e.core.ruler.before(`linkify`, `image_figures`, function (n) {
      let r = 1;
      for (let i = 1, a = n.tokens.length; i < a - 1; ++i) {
        let o = n.tokens[i];
        if (
          o.type !== `inline` ||
          !o.children ||
          (o.children.length !== 1 && o.children.length !== 3) ||
          (o.children.length === 1 && o.children[0].type !== `image`)
        )
          continue;
        if (o.children.length === 3) {
          let [e, t, n] = o.children;
          if (e.type !== `link_open` || t.type !== `image` || n.type !== `link_close`) continue;
        }
        if (
          (i !== 0 && n.tokens[i - 1].type !== `paragraph_open`) ||
          (i !== a - 1 && n.tokens[i + 1].type !== `paragraph_close`)
        )
          continue;
        let s = n.tokens[i - 1],
          c;
        if (
          ((s.type = `figure_open`),
          (s.tag = `figure`),
          (n.tokens[i + 1].type = `figure_close`),
          (n.tokens[i + 1].tag = `figure`),
          t.dataType && n.tokens[i - 1].attrPush([`data-type`, `image`]),
          t.link && o.children.length === 1)
        ) {
          [c] = o.children;
          let e = new n.Token(`link_open`, `a`, 1);
          (e.attrPush([`href`, c.attrGet(`src`)]),
            o.children.unshift(e),
            o.children.push(new n.Token(`link_close`, `a`, -1)));
        }
        if (((c = o.children.length === 1 ? o.children[0] : o.children[1]), t.figcaption)) {
          let r = yj(t.figcaption, c);
          if (r) {
            let [t] = e.parseInline(r, n.env);
            (o.children.push(new n.Token(`figcaption_open`, `figcaption`, 1)),
              o.children.push(...t.children),
              o.children.push(new n.Token(`figcaption_close`, `figcaption`, -1)),
              (c.attrs &&= _j(c.attrs, `title`)));
          }
        }
        if (t.copyAttrs && c.attrs) {
          let e = !0 === t.copyAttrs ? `` : t.copyAttrs;
          s.attrs = c.attrs.filter(([t]) => t.match(e)).map((e) => Array.from(e));
        }
        if (
          (t.tabindex && (n.tokens[i - 1].attrPush([`tabindex`, r]), r++),
          t.lazy && (c.attrs.some(([e]) => e === `loading`) || c.attrs.push([`loading`, `lazy`])),
          t.async &&
            (c.attrs.some(([e]) => e === `decoding`) || c.attrs.push([`decoding`, `async`])),
          t.classes && typeof t.classes == `string`)
        ) {
          let e = !1;
          for (let n = 0, r = c.attrs.length; n < r && !e; n++) {
            let r = c.attrs[n];
            r[0] === `class` && ((r[1] = `${r[1]} ${t.classes}`), (e = !0));
          }
          e || c.attrs.push([`class`, t.classes]);
        }
        if (t.removeSrc) {
          let e = c.attrs.find(([e]) => e === `src`);
          (c.attrs.push([`data-src`, e[1]]), vj(c, `src`));
        }
      }
    }));
}
var xj = /\\([ \\!"#$%&'()*+,./:;<=>?@[\]^_`{|}~-])/g;
function Sj(e, t) {
  let n = e.posMax,
    r = e.pos;
  if (e.src.charCodeAt(r) !== 126 || t || r + 2 >= n) return !1;
  e.pos = r + 1;
  let i = !1;
  for (; e.pos < n;) {
    if (e.src.charCodeAt(e.pos) === 126) {
      i = !0;
      break;
    }
    e.md.inline.skipToken(e);
  }
  if (!i || r + 1 === e.pos) return ((e.pos = r), !1);
  let a = e.src.slice(r + 1, e.pos);
  if (a.match(/(^|[^\\])(\\\\)*\s/)) return ((e.pos = r), !1);
  ((e.posMax = e.pos), (e.pos = r + 1));
  let o = e.push(`sub_open`, `sub`, 1);
  o.markup = `~`;
  let s = e.push(`text`, ``, 0);
  s.content = a.replace(xj, `$1`);
  let c = e.push(`sub_close`, `sub`, -1);
  return ((c.markup = `~`), (e.pos = e.posMax + 1), (e.posMax = n), !0);
}
function Cj(e) {
  e.inline.ruler.after(`emphasis`, `sub`, Sj);
}
var wj = /\\([ \\!"#$%&'()*+,./:;<=>?@[\]^_`{|}~-])/g;
function Tj(e, t) {
  let n = e.posMax,
    r = e.pos;
  if (e.src.charCodeAt(r) !== 94 || t || r + 2 >= n) return !1;
  e.pos = r + 1;
  let i = !1;
  for (; e.pos < n;) {
    if (e.src.charCodeAt(e.pos) === 94) {
      i = !0;
      break;
    }
    e.md.inline.skipToken(e);
  }
  if (!i || r + 1 === e.pos) return ((e.pos = r), !1);
  let a = e.src.slice(r + 1, e.pos);
  if (a.match(/(^|[^\\])(\\\\)*\s/)) return ((e.pos = r), !1);
  ((e.posMax = e.pos), (e.pos = r + 1));
  let o = e.push(`sup_open`, `sup`, 1);
  o.markup = `^`;
  let s = e.push(`text`, ``, 0);
  s.content = a.replace(wj, `$1`);
  let c = e.push(`sup_close`, `sup`, -1);
  return ((c.markup = `^`), (e.pos = e.posMax + 1), (e.posMax = n), !0);
}
function Ej(e) {
  e.inline.ruler.after(`emphasis`, `sup`, Tj);
}
var Dj =
    Object.assign ||
    function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    },
  Oj = function (e) {
    return e.tagName === `IMG`;
  },
  kj = function (e) {
    return NodeList.prototype.isPrototypeOf(e);
  },
  Aj = function (e) {
    return e && e.nodeType === 1;
  },
  jj = function (e) {
    return (e.currentSrc || e.src).substr(-4).toLowerCase() === `.svg`;
  },
  Mj = function (e) {
    try {
      return Array.isArray(e)
        ? e.filter(Oj)
        : kj(e)
          ? [].slice.call(e).filter(Oj)
          : Aj(e)
            ? [e].filter(Oj)
            : typeof e == `string`
              ? [].slice.call(document.querySelectorAll(e)).filter(Oj)
              : [];
    } catch {
      throw TypeError(`The provided selector is invalid.
Expects a CSS selector, a Node element, a NodeList or an array.
See: https://github.com/francoischalifour/medium-zoom`);
    }
  },
  Nj = function (e) {
    var t = document.createElement(`div`);
    return (t.classList.add(`medium-zoom-overlay`), (t.style.background = e), t);
  },
  Pj = function (e) {
    var t = e.getBoundingClientRect(),
      n = t.top,
      r = t.left,
      i = t.width,
      a = t.height,
      o = e.cloneNode(),
      s = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
      c =
        window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    return (
      o.removeAttribute(`id`),
      (o.style.position = `absolute`),
      (o.style.top = n + s + `px`),
      (o.style.left = r + c + `px`),
      (o.style.width = i + `px`),
      (o.style.height = a + `px`),
      (o.style.transform = ``),
      o
    );
  },
  Fj = function (e, t) {
    var n = Dj(
      {
        bubbles: !1,
        cancelable: !1,
        detail: void 0,
      },
      t,
    );
    if (typeof window.CustomEvent == `function`) return new CustomEvent(e, n);
    var r = document.createEvent(`CustomEvent`);
    return (r.initCustomEvent(e, n.bubbles, n.cancelable, n.detail), r);
  },
  Ij = function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      r =
        window.Promise ||
        function (e) {
          function t() {}
          e(t, t);
        },
      i = function (e) {
        var t = e.target;
        if (t === E) {
          m();
          return;
        }
        b.indexOf(t) !== -1 &&
          h({
            target: t,
          });
      },
      a = function () {
        if (!(S || !T.original)) {
          var e =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
          Math.abs(C - e) > w.scrollOffset && setTimeout(m, 150);
        }
      },
      o = function (e) {
        var t = e.key || e.keyCode;
        (t === `Escape` || t === `Esc` || t === 27) && m();
      },
      s = function () {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          t = e;
        return (
          e.background && (E.style.background = e.background),
          e.container &&
            e.container instanceof Object &&
            (t.container = Dj({}, w.container, e.container)),
          e.template &&
            (t.template = Aj(e.template) ? e.template : document.querySelector(e.template)),
          (w = Dj({}, w, t)),
          b.forEach(function (e) {
            e.dispatchEvent(
              Fj(`medium-zoom:update`, {
                detail: {
                  zoom: D,
                },
              }),
            );
          }),
          D
        );
      },
      c = function () {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return e(Dj({}, w, t));
      },
      l = function () {
        var e = [...arguments].reduce(function (e, t) {
          return [].concat(e, Mj(t));
        }, []);
        return (
          e
            .filter(function (e) {
              return b.indexOf(e) === -1;
            })
            .forEach(function (e) {
              (b.push(e), e.classList.add(`medium-zoom-image`));
            }),
          x.forEach(function (t) {
            var n = t.type,
              r = t.listener,
              i = t.options;
            e.forEach(function (e) {
              e.addEventListener(n, r, i);
            });
          }),
          D
        );
      },
      u = function () {
        var e = [...arguments];
        T.zoomed && m();
        var t =
          e.length > 0
            ? e.reduce(function (e, t) {
                return [].concat(e, Mj(t));
              }, [])
            : b;
        return (
          t.forEach(function (e) {
            (e.classList.remove(`medium-zoom-image`),
              e.dispatchEvent(
                Fj(`medium-zoom:detach`, {
                  detail: {
                    zoom: D,
                  },
                }),
              ));
          }),
          (b = b.filter(function (e) {
            return t.indexOf(e) === -1;
          })),
          D
        );
      },
      d = function (e, t) {
        var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return (
          b.forEach(function (r) {
            r.addEventListener(`medium-zoom:` + e, t, n);
          }),
          x.push({
            type: `medium-zoom:` + e,
            listener: t,
            options: n,
          }),
          D
        );
      },
      f = function (e, t) {
        var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return (
          b.forEach(function (r) {
            r.removeEventListener(`medium-zoom:` + e, t, n);
          }),
          (x = x.filter(function (n) {
            return !(n.type === `medium-zoom:` + e && n.listener.toString() === t.toString());
          })),
          D
        );
      },
      p = function () {
        var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).target,
          t = function () {
            var e = {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
              },
              t = void 0,
              n = void 0;
            if (w.container)
              if (w.container instanceof Object)
                ((e = Dj({}, e, w.container)),
                  (t = e.width - e.left - e.right - w.margin * 2),
                  (n = e.height - e.top - e.bottom - w.margin * 2));
              else {
                var r = (
                    Aj(w.container) ? w.container : document.querySelector(w.container)
                  ).getBoundingClientRect(),
                  i = r.width,
                  a = r.height,
                  o = r.left,
                  s = r.top;
                e = Dj({}, e, {
                  width: i,
                  height: a,
                  left: o,
                  top: s,
                });
              }
            ((t ||= e.width - w.margin * 2), (n ||= e.height - w.margin * 2));
            var c = T.zoomedHd || T.original,
              l = jj(c) ? t : c.naturalWidth || t,
              u = jj(c) ? n : c.naturalHeight || n,
              d = c.getBoundingClientRect(),
              f = d.top,
              p = d.left,
              m = d.width,
              h = d.height,
              g = Math.min(Math.max(m, l), t) / m,
              v = Math.min(Math.max(h, u), n) / h,
              y = Math.min(g, v),
              b = (-p + (t - m) / 2 + w.margin + e.left) / y,
              x = (-f + (n - h) / 2 + w.margin + e.top) / y,
              S = `scale(` + y + `) translate3d(` + b + `px, ` + x + `px, 0)`;
            ((T.zoomed.style.transform = S), T.zoomedHd && (T.zoomedHd.style.transform = S));
          };
        return new r(function (n) {
          if (e && b.indexOf(e) === -1) {
            n(D);
            return;
          }
          var r = function e() {
            ((S = !1),
              T.zoomed.removeEventListener(`transitionend`, e),
              T.original.dispatchEvent(
                Fj(`medium-zoom:opened`, {
                  detail: {
                    zoom: D,
                  },
                }),
              ),
              n(D));
          };
          if (T.zoomed) {
            n(D);
            return;
          }
          if (e) T.original = e;
          else if (b.length > 0) T.original = b[0];
          else {
            n(D);
            return;
          }
          if (
            (T.original.dispatchEvent(
              Fj(`medium-zoom:open`, {
                detail: {
                  zoom: D,
                },
              }),
            ),
            (C =
              window.pageYOffset ||
              document.documentElement.scrollTop ||
              document.body.scrollTop ||
              0),
            (S = !0),
            (T.zoomed = Pj(T.original)),
            document.body.appendChild(E),
            w.template)
          ) {
            var i = Aj(w.template) ? w.template : document.querySelector(w.template);
            ((T.template = document.createElement(`div`)),
              T.template.appendChild(i.content.cloneNode(!0)),
              document.body.appendChild(T.template));
          }
          if (
            (T.original.parentElement &&
              T.original.parentElement.tagName === `PICTURE` &&
              T.original.currentSrc &&
              (T.zoomed.src = T.original.currentSrc),
            document.body.appendChild(T.zoomed),
            window.requestAnimationFrame(function () {
              document.body.classList.add(`medium-zoom--opened`);
            }),
            T.original.classList.add(`medium-zoom-image--hidden`),
            T.zoomed.classList.add(`medium-zoom-image--opened`),
            T.zoomed.addEventListener(`click`, m),
            T.zoomed.addEventListener(`transitionend`, r),
            T.original.getAttribute(`data-zoom-src`))
          ) {
            ((T.zoomedHd = T.zoomed.cloneNode()),
              T.zoomedHd.removeAttribute(`srcset`),
              T.zoomedHd.removeAttribute(`sizes`),
              T.zoomedHd.removeAttribute(`loading`),
              (T.zoomedHd.src = T.zoomed.getAttribute(`data-zoom-src`)),
              (T.zoomedHd.onerror = function () {
                (clearInterval(a),
                  console.warn(`Unable to reach the zoom image target ` + T.zoomedHd.src),
                  (T.zoomedHd = null),
                  t());
              }));
            var a = setInterval(function () {
              T.zoomedHd.complete &&
                (clearInterval(a),
                T.zoomedHd.classList.add(`medium-zoom-image--opened`),
                T.zoomedHd.addEventListener(`click`, m),
                document.body.appendChild(T.zoomedHd),
                t());
            }, 10);
          } else if (T.original.hasAttribute(`srcset`)) {
            ((T.zoomedHd = T.zoomed.cloneNode()),
              T.zoomedHd.removeAttribute(`sizes`),
              T.zoomedHd.removeAttribute(`loading`));
            var o = T.zoomedHd.addEventListener(`load`, function () {
              (T.zoomedHd.removeEventListener(`load`, o),
                T.zoomedHd.classList.add(`medium-zoom-image--opened`),
                T.zoomedHd.addEventListener(`click`, m),
                document.body.appendChild(T.zoomedHd),
                t());
            });
          } else t();
        });
      },
      m = function () {
        return new r(function (e) {
          if (S || !T.original) {
            e(D);
            return;
          }
          var t = function t() {
            (T.original.classList.remove(`medium-zoom-image--hidden`),
              document.body.removeChild(T.zoomed),
              T.zoomedHd && document.body.removeChild(T.zoomedHd),
              document.body.removeChild(E),
              T.zoomed.classList.remove(`medium-zoom-image--opened`),
              T.template && document.body.removeChild(T.template),
              (S = !1),
              T.zoomed.removeEventListener(`transitionend`, t),
              T.original.dispatchEvent(
                Fj(`medium-zoom:closed`, {
                  detail: {
                    zoom: D,
                  },
                }),
              ),
              (T.original = null),
              (T.zoomed = null),
              (T.zoomedHd = null),
              (T.template = null),
              e(D));
          };
          ((S = !0),
            document.body.classList.remove(`medium-zoom--opened`),
            (T.zoomed.style.transform = ``),
            T.zoomedHd && (T.zoomedHd.style.transform = ``),
            T.template &&
              ((T.template.style.transition = `opacity 150ms`), (T.template.style.opacity = 0)),
            T.original.dispatchEvent(
              Fj(`medium-zoom:close`, {
                detail: {
                  zoom: D,
                },
              }),
            ),
            T.zoomed.addEventListener(`transitionend`, t));
        });
      },
      h = function () {
        var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).target;
        return T.original
          ? m()
          : p({
              target: e,
            });
      },
      g = function () {
        return w;
      },
      v = function () {
        return b;
      },
      y = function () {
        return T.original;
      },
      b = [],
      x = [],
      S = !1,
      C = 0,
      w = n,
      T = {
        original: null,
        zoomed: null,
        zoomedHd: null,
        template: null,
      };
    (Object.prototype.toString.call(t) === `[object Object]`
      ? (w = t)
      : (t || typeof t == `string`) && l(t),
      (w = Dj(
        {
          margin: 0,
          background: `#fff`,
          scrollOffset: 40,
          container: null,
          template: null,
        },
        w,
      )));
    var E = Nj(w.background);
    (document.addEventListener(`click`, i),
      document.addEventListener(`keyup`, o),
      document.addEventListener(`scroll`, a),
      window.addEventListener(`resize`, m));
    var D = {
      open: p,
      close: m,
      toggle: h,
      update: s,
      clone: c,
      attach: l,
      detach: u,
      on: d,
      off: f,
      getOptions: g,
      getImages: v,
      getZoomedImage: y,
    };
    return D;
  };
function Lj(e, t) {
  t === void 0 && (t = {});
  var n = t.insertAt;
  if (!(!e || typeof document > `u`)) {
    var r = document.head || document.getElementsByTagName(`head`)[0],
      i = document.createElement(`style`);
    ((i.type = `text/css`),
      n === `top` && r.firstChild ? r.insertBefore(i, r.firstChild) : r.appendChild(i),
      i.styleSheet ? (i.styleSheet.cssText = e) : i.appendChild(document.createTextNode(e)));
  }
}
(Lj(
  `.medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)!important}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}`,
),
  B());
var Rj = {
    hljs: `${$}-hljs`,
    hlcss: `${$}-hlCss`,
    prettier: `${$}-prettier`,
    prettierMD: `${$}-prettierMD`,
    cropperjs: `${$}-cropper`,
    croppercss: `${$}-cropperCss`,
    screenfull: `${$}-screenfull`,
    mermaidM: `${$}-mermaid-m`,
    mermaid: `${$}-mermaid`,
    katexjs: `${$}-katex`,
    katexcss: `${$}-katexCss`,
    echarts: `${$}-echarts`,
  },
  zj = (e, t, n) => {
    let { editorId: r } = n,
      i = Ae({
        buildFinished: !1,
        html: ``,
      });
    (He(
      () => e.modelValue,
      () => {
        i.buildFinished = !1;
      },
    ),
      Qe(() => {
        (nO.on(r, {
          name: UD,
          callback(e) {
            ((i.buildFinished = !0), (i.html = e));
          },
        }),
          nO.on(r, {
            name: PD,
            callback() {
              let n = new Promise((e) => {
                if (i.buildFinished) e(i.html);
                else {
                  let t = (n) => {
                    (e(n), nO.remove(r, UD, t));
                  };
                  nO.on(r, {
                    name: UD,
                    callback: t,
                  });
                }
              });
              e.onSave ? e.onSave(e.modelValue, n) : t.emit(`onSave`, e.modelValue, n);
            },
          }));
      }));
  },
  Bj = (e, { editorId: t, rootRef: n, setting: r }) => {
    let i = AD.editorExtensions.highlight,
      a = AD.editorExtensionsAttrs.highlight;
    return (
      ge(`editorId`, t),
      ge(`rootRef`, n),
      ge(
        `theme`,
        V(() => e.theme),
      ),
      ge(
        `language`,
        V(() => e.language),
      ),
      ge(
        `highlight`,
        V(() => {
          let { js: t } = i,
            n = {
              ...ED,
              ...i.css,
            },
            { js: r, css: o = {} } = a || {},
            s =
              e.codeStyleReverse && e.codeStyleReverseList.includes(e.previewTheme)
                ? `dark`
                : e.theme,
            c = n[e.codeTheme] ? n[e.codeTheme][s] : ED.atom[s],
            l = n[e.codeTheme] && o[e.codeTheme] ? o[e.codeTheme][s] : o.atom ? o.atom[s] : {};
          return {
            js: {
              src: t,
              ...r,
            },
            css: {
              href: c,
              ...l,
            },
          };
        }),
      ),
      ge(`showCodeRowNumber`, e.showCodeRowNumber),
      ge(
        `usedLanguageText`,
        V(() => {
          let t = {
            ...kD,
            ...AD.editorConfig.languageUserDefined,
          };
          return SD(_D(kD[`en-US`]), t[e.language] || {});
        }),
      ),
      ge(
        `previewTheme`,
        V(() => e.previewTheme),
      ),
      ge(
        `customIcon`,
        V(() => e.customIcon),
      ),
      ge(
        `setting`,
        V(() =>
          r
            ? {
                ...r,
              }
            : {
                preview: !0,
                htmlPreview: !1,
                previewOnly: !1,
                pageFullscreen: !1,
                fullscreen: !1,
              },
        ),
      ),
      {
        editorId: t,
      }
    );
  },
  Vj = (e, t) => (
    ge(`tabWidth`, e.tabWidth),
    ge(
      `disabled`,
      V(() => e.disabled),
    ),
    ge(
      `showToolbarName`,
      V(() => e.showToolbarName),
    ),
    ge(`noUploadImg`, e.noUploadImg),
    ge(
      `tableShape`,
      V(() => e.tableShape),
    ),
    ge(`noPrettier`, e.noPrettier),
    ge(
      `codeTheme`,
      V(() => e.codeTheme),
    ),
    ge(`updateSetting`, t.updateSetting),
    ge(
      `catalogVisible`,
      V(() => t.catalogVisible.value),
    ),
    ge(`defToolbars`, t.defToolbars),
    ge(
      `floatingToolbars`,
      V(() => e.floatingToolbars),
    ),
    Bj(e, t)
  ),
  Hj = (e) => {
    let { noPrettier: t, noUploadImg: n } = e,
      { editorExtensions: r, editorExtensionsAttrs: i } = AD,
      a = t || r.prettier.prettierInstance,
      o = t || r.prettier.parserMarkdownInstance,
      s = n || r.cropper.instance;
    Qe(() => {
      if (!s) {
        let { js: e = {}, css: t = {} } = i.cropper || {};
        (uO(`link`, {
          ...t,
          rel: `stylesheet`,
          href: r.cropper.css,
          id: Rj.croppercss,
        }),
          uO(`script`, {
            ...e,
            src: r.cropper.js,
            id: Rj.cropperjs,
          }));
      }
      if (!a) {
        let { standaloneJs: e = {} } = i.prettier || {};
        uO(`script`, {
          ...e,
          src: r.prettier.standaloneJs,
          id: Rj.prettier,
        });
      }
      if (!o) {
        let { parserMarkdownJs: e = {} } = i.prettier || {};
        uO(`script`, {
          ...e,
          src: r.prettier.parserMarkdownJs,
          id: Rj.prettierMD,
        });
      }
    });
  },
  Uj = (e, t, n) => {
    let { editorId: r } = n;
    Qe(() => {
      nO.on(r, {
        name: WD,
        callback: (n) => {
          (e.onError?.(n), t.emit(`onError`, n));
        },
      });
    });
  },
  Wj = (e, t, n) => {
    let { editorId: r } = n,
      i = Ae({
        pageFullscreen: e.pageFullscreen,
        fullscreen: !1,
        preview: e.preview,
        htmlPreview: e.preview ? !1 : e.htmlPreview,
        previewOnly: !1,
      }),
      a = Ae({
        ...i,
      }),
      o = (e, t) => {
        let n = t === void 0 ? !i[e] : t;
        switch (e) {
          case `preview`:
            ((i.htmlPreview = !1), (i.previewOnly = !1));
            break;
          case `htmlPreview`:
            ((i.preview = !1), (i.previewOnly = !1));
            break;
          case `previewOnly`:
            n
              ? !i.preview && !i.htmlPreview && (i.preview = !0)
              : (a.preview || (i.preview = !1), a.htmlPreview || (i.htmlPreview = !1));
            break;
        }
        ((a[e] = n), (i[e] = n));
      },
      s = ``,
      c = () => {
        i.pageFullscreen || i.fullscreen
          ? (document.body.style.overflow = `hidden`)
          : (document.body.style.overflow = s);
      };
    return (
      He(() => [i.pageFullscreen, i.fullscreen], c),
      Qe(() => {
        (nO.on(r, {
          name: KD,
          callback(n, i) {
            let a = (e) => {
              (nO.emit(r, GD, `image`, {
                desc: ``,
                urls: e,
              }),
                i?.());
            };
            e.onUploadImg ? e.onUploadImg(n, a) : t.emit(`onUploadImg`, n, a);
          },
        }),
          (s = document.body.style.overflow),
          c());
      }),
      [i, o]
    );
  },
  Gj = (e, t) => {
    let { editorId: n } = t,
      r = F(!1);
    return (
      Qe(() => {
        nO.on(n, {
          name: FD,
          callback: (e) => {
            e === void 0 ? (r.value = !r.value) : (r.value = e);
          },
        });
      }),
      r
    );
  },
  Kj = (e, t, n) => {
    let { editorId: r, catalogVisible: i, setting: a, updateSetting: o, codeRef: s } = n;
    (He(
      () => a.pageFullscreen,
      (e) => {
        nO.emit(r, LD, e);
      },
    ),
      He(
        () => a.fullscreen,
        (e) => {
          nO.emit(r, RD, e);
        },
      ),
      He(
        () => a.preview,
        (e) => {
          nO.emit(r, zD, e);
        },
      ),
      He(
        () => a.previewOnly,
        (e) => {
          nO.emit(r, BD, e);
        },
      ),
      He(
        () => a.htmlPreview,
        (e) => {
          nO.emit(r, VD, e);
        },
      ),
      He(i, (e) => {
        nO.emit(r, HD, e);
      }),
      t.expose({
        on(e, t) {
          switch (e) {
            case `pageFullscreen`:
              nO.on(r, {
                name: LD,
                callback(e) {
                  t(e);
                },
              });
              break;
            case `fullscreen`:
              nO.on(r, {
                name: RD,
                callback(e) {
                  t(e);
                },
              });
              break;
            case `preview`:
              nO.on(r, {
                name: zD,
                callback(e) {
                  t(e);
                },
              });
              break;
            case `previewOnly`:
              nO.on(r, {
                name: BD,
                callback(e) {
                  t(e);
                },
              });
              break;
            case `htmlPreview`:
              nO.on(r, {
                name: VD,
                callback(e) {
                  t(e);
                },
              });
              break;
            case `catalog`:
              nO.on(r, {
                name: HD,
                callback(e) {
                  t(e);
                },
              });
              break;
          }
        },
        togglePageFullscreen(e) {
          o(`pageFullscreen`, e);
        },
        toggleFullscreen(e) {
          nO.emit(r, ID, e);
        },
        togglePreview(e) {
          o(`preview`, e);
        },
        togglePreviewOnly(e) {
          o(`previewOnly`, e);
        },
        toggleHtmlPreview(e) {
          o(`htmlPreview`, e);
        },
        toggleCatalog(e) {
          nO.emit(r, FD, e);
        },
        triggerSave() {
          nO.emit(r, PD);
        },
        insert(e) {
          nO.emit(r, GD, `universal`, {
            generate: e,
          });
        },
        focus(e) {
          s.value?.focus(e);
        },
        rerender() {
          nO.emit(r, ZD);
        },
        getSelectedText() {
          return s.value?.getSelectedText();
        },
        resetHistory() {
          s.value?.resetHistory();
        },
        domEventHandlers(e) {
          nO.emit(r, QD, e);
        },
        execCommand(e) {
          nO.emit(r, GD, e);
        },
        getEditorView() {
          return s.value?.getEditorView();
        },
      }));
  },
  qj = (e) => {
    let t = w();
    return e.id || e.editorId || `md-editor-${t}`;
  },
  Jj = (e, t, n) => {
    let r = R(`editorId`),
      i = R(`rootRef`),
      a = R(`usedLanguageText`),
      o = R(`setting`),
      s = () => {
        i.value.querySelectorAll(`#${r} .${$}-preview .${$}-code`).forEach((t) => {
          let n = -1,
            r = t.querySelector(`.${$}-copy-button:not([data-processed])`);
          r &&
            ((r.onclick = (i) => {
              (i.preventDefault(), clearTimeout(n));
              let o = (t.querySelector(`input:checked + pre code`) || t.querySelector(`pre code`))
                  .textContent,
                { text: s, successTips: c, failTips: l } = a.value.copyCode,
                u = c;
              sO(e.formatCopiedText(o || ``))
                .catch(() => {
                  u = l;
                })
                .finally(() => {
                  (r.dataset.isIcon ? (r.dataset.tips = u) : (r.innerHTML = u),
                    (n = window.setTimeout(() => {
                      r.dataset.isIcon ? (r.dataset.tips = s) : (r.innerHTML = s);
                    }, 1500)));
                });
            }),
            r.setAttribute(`data-processed`, `true`));
        });
      },
      c = () => {
        de(s);
      },
      l = (e) => {
        e && de(s);
      };
    (He([t, n], c), He(() => o.value.preview, l), He(() => o.value.htmlPreview, l), Qe(s));
  },
  Yj = (e) => {
    let t = R(`editorId`),
      n = R(`theme`),
      r = R(`rootRef`),
      { editorExtensions: i, editorExtensionsAttrs: a, echartsConfig: o } = AD,
      s = i.echarts.instance,
      c = xe(-1),
      l = () => {
        !e.noEcharts && s && (c.value += 1);
      };
    (He(
      () => n.value,
      () => {
        l();
      },
    ),
      Qe(() => {
        if (e.noEcharts || s) return;
        let t = i.echarts.js;
        uO(
          `script`,
          {
            ...a.echarts?.js,
            src: t,
            id: Rj.echarts,
            onload() {
              ((s = window.echarts), l());
            },
          },
          `echarts`,
        );
      }));
    let u = [],
      d = [],
      f = [],
      p = (e = !1) => {
        if (!u.length) {
          e &&
            (d.forEach((e) => {
              e.dispose?.();
            }),
            f.forEach((e) => {
              e.disconnect?.();
            }),
            (d = []),
            (f = []));
          return;
        }
        let t = [],
          n = [],
          i = [];
        (u.forEach((a, o) => {
          let s = d[o],
            c = f[o];
          if (e || !a || !a.isConnected || (r?.value && !r.value.contains(a))) {
            (s?.dispose?.(), c?.disconnect?.());
            return;
          }
          (t.push(a), s && n.push(s), c && i.push(c));
        }),
          (u = t),
          (d = n),
          (f = i));
      };
    return (
      oe(() => {
        p(!0);
      }),
      {
        reRenderEcharts: c,
        replaceEcharts: () => {
          (p(),
            !e.noEcharts &&
              s &&
              Array.from(
                r.value.querySelectorAll(`#${t} div.md-editor-echarts:not([data-processed])`),
              ).forEach((e) => {
                if (e.dataset.closed === `false`) return !1;
                try {
                  let r = o(
                      i.echarts.parseOption(e.innerText, {
                        editorId: t,
                        element: e,
                      }),
                    ),
                    a = s.init(e, n.value);
                  (a.setOption(r), e.setAttribute(`data-processed`, ``), u.push(e), d.push(a));
                  let c = new ResizeObserver(() => {
                    a.resize();
                  });
                  (c.observe(e), f.push(c));
                } catch (e) {
                  nO.emit(t, `errorCatcher`, {
                    name: `echarts`,
                    message: e?.message,
                    error: e,
                  });
                }
              }));
        },
      }
    );
  },
  Xj = (e) => {
    let t = R(`highlight`),
      n = xe(AD.editorExtensions.highlight.instance);
    return (
      Qe(() => {
        e.noHighlight ||
          n.value ||
          (uO(`link`, {
            ...t.value.css,
            rel: `stylesheet`,
            id: Rj.hlcss,
          }),
          uO(
            `script`,
            {
              ...t.value.js,
              id: Rj.hljs,
              onload() {
                n.value = window.hljs;
              },
            },
            `hljs`,
          ));
      }),
      He(
        () => t.value.css,
        () => {
          e.noHighlight ||
            AD.editorExtensions.highlight.instance ||
            Xae(`link`, {
              ...t.value.css,
              rel: `stylesheet`,
              id: Rj.hlcss,
            });
        },
      ),
      n
    );
  },
  Zj = (e) => {
    let t = xe(AD.editorExtensions.katex.instance);
    return (
      Qe(() => {
        if (e.noKatex || t.value) return;
        let { editorExtensions: n, editorExtensionsAttrs: r } = AD;
        (uO(
          `script`,
          {
            ...r.katex?.js,
            src: n.katex.js,
            id: Rj.katexjs,
            onload() {
              t.value = window.katex;
            },
          },
          `katex`,
        ),
          uO(`link`, {
            ...r.katex?.css,
            rel: `stylesheet`,
            href: n.katex.css,
            id: Rj.katexcss,
          }));
      }),
      t
    );
  },
  Qj = new (class {
    constructor(e) {
      this.options = e;
    }
    cache = new Map();
    isExpired(e) {
      return e.expiresAt <= Date.now();
    }
    deleteExpired(e, t) {
      let n = t ?? this.cache.get(e);
      return !n || !this.isExpired(n) ? !1 : (this.cache.delete(e), !0);
    }
    trim() {
      for (let [e, t] of this.cache) if (!this.deleteExpired(e, t)) break;
      for (; this.cache.size > this.options.max;) {
        let e = this.cache.keys().next().value;
        if (e === void 0) break;
        this.cache.delete(e);
      }
    }
    get(e) {
      let t = this.cache.get(e);
      if (!(!t || this.deleteExpired(e, t)))
        return (this.cache.delete(e), this.cache.set(e, t), t.value);
    }
    set(e, t) {
      (this.cache.delete(e),
        this.cache.set(e, {
          value: t,
          expiresAt: Date.now() + this.options.ttl,
        }),
        this.trim());
    }
    clear() {
      this.cache.clear();
    }
  })({
    max: 1e3,
    ttl: 6e5,
  }),
  $j = (e) => {
    let t = R(`editorId`),
      n = R(`theme`),
      r = R(`rootRef`),
      { editorExtensions: i, editorExtensionsAttrs: a, mermaidConfig: o } = AD,
      s = i.mermaid.instance,
      c = xe(-1),
      l = () => {
        if (!e.noMermaid && s) {
          let e =
            n.value === `dark`
              ? {
                  startOnLoad: !1,
                  theme: `dark`,
                }
              : {
                  startOnLoad: !1,
                  theme: `base`,
                  themeVariables: {
                    background: `#ffffff`,
                    primaryColor: `#ffffff`,
                    primaryTextColor: `#1f2329`,
                    primaryBorderColor: `#b7c0cc`,
                    secondaryColor: `#f7f8fa`,
                    tertiaryColor: `#f7f8fa`,
                    lineColor: `#596273`,
                    edgeLabelBackground: `#ffffff`,
                    clusterBkg: `#ffffff`,
                    clusterBorder: `#b7c0cc`,
                  },
                };
          (s.initialize(o(e)), (c.value += 1));
        }
      };
    return (
      He(
        () => n.value,
        () => {
          (Qj.clear(), l());
        },
      ),
      Qe(() => {
        if (e.noMermaid || s) return;
        let n = i.mermaid.js;
        /\.mjs/.test(n)
          ? (uO(`link`, {
              ...a.mermaid?.js,
              rel: `modulepreload`,
              href: n,
              id: Rj.mermaidM,
            }),
            b(
              () =>
                import(n).then((e) => {
                  ((s = e.default), l());
                }),
              [],
            ).catch((e) => {
              nO.emit(t, WD, {
                name: `mermaid`,
                message: `Failed to load mermaid module: ${e.message}`,
                error: e,
              });
            }))
          : uO(
              `script`,
              {
                ...a.mermaid?.js,
                src: n,
                id: Rj.mermaid,
                onload() {
                  ((s = window.mermaid), l());
                },
              },
              `mermaid`,
            );
      }),
      {
        reRenderRef: c,
        replaceMermaid: async () => {
          if (!e.noMermaid && s) {
            let n = r.value.querySelectorAll(`div.${$}-mermaid`),
              i = document.createElement(`div`),
              a = document.body.offsetWidth > 1366 ? document.body.offsetWidth : 1366,
              o = document.body.offsetHeight > 768 ? document.body.offsetHeight : 768;
            ((i.style.width = a + `px`),
              (i.style.height = o + `px`),
              (i.style.position = `fixed`),
              (i.style.zIndex = `-10000`),
              (i.style.top = `-10000`));
            let c = n.length;
            (c > 0 && document.body.appendChild(i),
              await Promise.allSettled(
                Array.from(n).map((n) =>
                  (async (n) => {
                    if (n.dataset.closed === `false`) return !1;
                    let r = n.innerText,
                      a = Qj.get(r);
                    if (!a) {
                      let o = bD(),
                        l = {
                          svg: ``,
                        };
                      try {
                        ((l = await s.render(o, r, i)), (a = await e.sanitizeMermaid(l.svg)));
                        let t = document.createElement(`p`);
                        ((t.className = `${$}-mermaid`),
                          t.setAttribute(`data-processed`, ``),
                          t.setAttribute(`data-content`, r),
                          (t.innerHTML = a),
                          t.children[0]?.removeAttribute(`height`),
                          Qj.set(r, t.innerHTML),
                          n.dataset.line !== void 0 && (t.dataset.line = n.dataset.line),
                          n.replaceWith(t));
                      } catch (e) {
                        nO.emit(t, WD, {
                          name: `mermaid`,
                          message: e.message,
                          error: e,
                        });
                      }
                      --c === 0 && i.remove();
                    }
                  })(n),
                ),
              ));
          }
        },
      }
    );
  },
  eM = (e, t) => {
    t ||= {};
    let n = t.marker || `!`,
      r = n.charCodeAt(0),
      i = n.length,
      a = ``,
      o = ``,
      s = (e, t, n, r, i) => {
        let a = e[t];
        return (
          a.type === `admonition_open`
            ? e[t].attrPush([`class`, `${$}-admonition ${$}-admonition-${a.info}`])
            : a.type === `admonition_title_open` &&
              e[t].attrPush([`class`, `md-editor-admonition-title`]),
          i.renderToken(e, t, n)
        );
      },
      c = (e) => {
        let t = e.trim().split(` `, 2);
        ((o = ``), (a = t[0]), t.length > 1 && (o = e.substring(a.length + 2)));
      };
    (e.block.ruler.before(
      `code`,
      `admonition`,
      (e, t, s, l) => {
        let u,
          d,
          f,
          p = !1,
          m = e.bMarks[t] + e.tShift[t],
          h = e.eMarks[t];
        if (r !== e.src.charCodeAt(m)) return !1;
        for (u = m + 1; u <= h && n[(u - m) % i] === e.src[u]; u++);
        let g = Math.floor((u - m) / i);
        if (g !== 3) return !1;
        u -= (u - m) % i;
        let v = e.src.slice(m, u);
        if ((c(e.src.slice(u, h)), l)) return !0;
        for (
          d = t;
          d++,
            !(
              d >= s ||
              ((m = e.bMarks[d] + e.tShift[d]),
              (h = e.eMarks[d]),
              m < h && e.sCount[d] < e.blkIndent)
            );
        )
          if (r === e.src.charCodeAt(m) && !(e.sCount[d] - e.blkIndent >= 4)) {
            for (u = m + 1; u <= h && n[(u - m) % i] === e.src[u]; u++);
            if (
              !(Math.floor((u - m) / i) < g) &&
              ((u -= (u - m) % i), (u = e.skipSpaces(u)), !(u < h))
            ) {
              p = !0;
              break;
            }
          }
        let y = e.parentType,
          b = e.lineMax;
        return (
          (e.parentType = `root`),
          (e.lineMax = d),
          (f = e.push(`admonition_open`, `div`, 1)),
          (f.markup = v),
          (f.block = !0),
          (f.info = a),
          (f.map = [t, d]),
          o &&
            ((f = e.push(`admonition_title_open`, `p`, 1)),
            (f.markup = v + ` ` + a),
            (f.map = [t, d]),
            (f = e.push(`inline`, ``, 0)),
            (f.content = o),
            (f.map = [t, e.line - 1]),
            (f.children = []),
            (f = e.push(`admonition_title_close`, `p`, -1)),
            (f.markup = v + ` ` + a)),
          e.md.block.tokenize(e, t + 1, d),
          (f = e.push(`admonition_close`, `div`, -1)),
          (f.markup = e.src.slice(m, u)),
          (f.block = !0),
          (e.parentType = y),
          (e.lineMax = b),
          (e.line = d + +!!p),
          !0
        );
      },
      {
        alt: [`paragraph`, `reference`, `blockquote`, `list`],
      },
    ),
      (e.renderer.rules.admonition_open = s),
      (e.renderer.rules.admonition_title_open = s),
      (e.renderer.rules.admonition_title_close = s),
      (e.renderer.rules.admonition_close = s));
  },
  tM = (e, t) => {
    let n = e.attrs ? e.attrs.slice() : [];
    return (
      t.forEach((t) => {
        let r = e.attrIndex(t[0]);
        r < 0 ? n.push(t) : ((n[r] = n[r].slice()), (n[r][1] += ` ${t[1]}`));
      }),
      n
    );
  },
  nM = (e, t) => {
    let n = e.renderer.rules.fence,
      r = e.utils.unescapeAll,
      i = /\[(\w*)(?::([\w ]*))?\]/,
      a = /::(open|close)/,
      o = (e) => (e.info ? r(e.info).trim() : ``),
      s = (e) => {
        let t = o(e),
          [n = null, r = ``] = (i.exec(t) || []).slice(1);
        return [n, r];
      },
      c = (e) => {
        let t = o(e);
        return t ? t.split(/(\s+)/g)[0] : ``;
      },
      l = (e) => {
        let n = e.info.match(a) || [];
        return {
          open:
            n[1] === `open` ||
            (n[1] !== `close` &&
              t.codeFoldable &&
              e.content.trim().split(`
`).length < t.autoFoldThreshold),
          tagContainer: n[1] || t.codeFoldable ? `details` : `div`,
          tagHeader: n[1] || t.codeFoldable ? `summary` : `div`,
        };
      },
      u = (r, o, u, d, f) => {
        if (r[o].hidden) return ``;
        let p = t.usedLanguageTextRef.value?.copyCode.text,
          m = t.customIconRef.value.copy || p,
          h = !!t.customIconRef.value.copy,
          g = `<span class="${$}-collapse-tips">${cO(`collapse-tips`, t.customIconRef.value)}</span>`,
          [v] = s(r[o]);
        if (v === null) {
          let { open: i, tagContainer: s, tagHeader: c } = l(r[o]),
            v = [[`class`, `${$}-code`]];
          i && v.push([`open`, ``]);
          let y = {
            attrs: tM(r[o], v),
          };
          r[o].info = r[o].info.replace(a, ``);
          let b = n(r, o, u, d, f);
          return `
        <${s} ${f.renderAttrs(y)}>
          <${c} class="${$}-code-head">
            <div class="${$}-code-flag"><span></span><span></span><span></span></div>
            <div class="${$}-code-action">
              <span class="${$}-code-lang">${e.utils.escapeHtml(r[o].info.trim())}</span>
              <span class="${$}-copy-button" data-tips="${p}"${h ? ` data-is-icon=true` : ``}>${m}</span>
              ${
                t.extraTools instanceof Function
                  ? t.extraTools({
                      lang: r[o].info.trim(),
                    })
                  : t.extraTools || ``
              }
              ${s === `details` ? g : ``}
            </div>
          </${c}>
          ${b}
        </${s}>
      `;
        }
        let y,
          b,
          x,
          S,
          C = ``,
          w = ``,
          T = ``,
          { open: E, tagContainer: D, tagHeader: ee } = l(r[o]),
          te = [[`class`, `${$}-code`]];
        E && te.push([`open`, ``]);
        let O = {
          attrs: tM(r[o], te),
        };
        for (let l = o; l < r.length && ((y = r[l]), ([b, x] = s(y)), b === v); l++) {
          ((y.info = y.info.replace(i, ``).replace(a, ``)), (y.hidden = !0));
          let s = `${$}-codetab-${t.editorId}-${o}-${l - o}`;
          ((S = l - o > 0 ? `` : `checked`),
            (C += `
        <li>
          <input
            type="radio"
            id="label-${$}-codetab-label-1-${t.editorId}-${o}-${l - o}"
            name="${$}-codetab-label-${t.editorId}-${o}"
            class="${s}"
            ${S}
          >
          <label
            for="label-${$}-codetab-label-1-${t.editorId}-${o}-${l - o}"
            onclick="this.getRootNode().querySelectorAll('.${s}').forEach(e => e.click())"
          >
            ${e.utils.escapeHtml(x || c(y))}
          </label>
        </li>`),
            (w += `
        <div role="tabpanel">
          <input
            type="radio"
            name="${$}-codetab-pre-${t.editorId}-${o}"
            class="${s}"
            ${S}
            role="presentation">
          ${n(r, l, u, d, f)}
        </div>`),
            (T += `
        <input
          type="radio"
          name="${$}-codetab-lang-${t.editorId}-${o}"
          class="${s}"
          ${S}
          role="presentation">
        <span class=${$}-code-lang role="note">${e.utils.escapeHtml(c(y))}</span>`));
        }
        return `
      <${D} ${f.renderAttrs(O)}>
        <${ee} class="${$}-code-head">
          <div class="${$}-code-flag">
            <ul class="${$}-codetab-label" role="tablist">${C}</ul>
          </div>
          <div class="${$}-code-action">
            <span class="${$}-codetab-lang">${T}</span>
            <span class="${$}-copy-button" data-tips="${p}"${h ? ` data-is-icon=true` : ``}>${m}</span>
            ${
              t.extraTools instanceof Function
                ? t.extraTools({
                    lang: r[o].info.trim(),
                  })
                : t.extraTools || ``
            }
            ${D === `details` ? g : ``}
          </div>
        </${ee}>
        ${w}
      </${D}>
    `;
      };
    ((e.renderer.rules.fence = u), (e.renderer.rules.code_block = u));
  },
  rM = (e, t) => {
    let n = e.renderer.rules.fence.bind(e.renderer.rules);
    e.renderer.rules.fence = (r, i, a, o, s) => {
      let c = r[i],
        l = c.content.trim();
      if (c.info === `echarts`) {
        if (
          (c.attrSet(`class`, `md-editor-echarts`),
          c.attrSet(`data-echarts-theme`, t.themeRef.value),
          c.map && c.level === 0)
        ) {
          let e = c.map[1] - 1,
            t = !!o.srcLines[e]?.trim()?.startsWith("```");
          (c.attrSet(`data-closed`, `${t}`), c.attrSet(`data-line`, String(c.map[0])));
        }
        return `<div ${s.renderAttrs(c)} style="width: 100%; aspect-ratio: 4 / 3;">${e.utils.escapeHtml(l)}</div>`;
      }
      return n(r, i, a, o, s);
    };
  },
  iM = (e, t) => {
    ((e.renderer.rules.heading_open = (n, r) => {
      let i = n[r],
        a =
          n[r + 1].children?.reduce(
            (e, t) =>
              e + (([`text`, `code_inline`, `math_inline`].includes(t.type) && t.content) || ``),
            ``,
          ) || ``,
        o = i.markup.length;
      return (
        t.headsRef.value.push({
          text: a,
          level: o,
          line: i.map[0],
          currentToken: i,
          nextToken: n[r + 1],
        }),
        i.map &&
          i.level === 0 &&
          i.attrSet(
            `id`,
            t.mdHeadingId({
              text: a,
              level: o,
              index: t.headsRef.value.length,
              currentToken: i,
              nextToken: n[r + 1],
            }),
          ),
        e.renderer.renderToken(n, r, t)
      );
    }),
      (e.renderer.rules.heading_close = (e, t, n, r, i) => i.renderToken(e, t, n)));
  },
  aM = {
    block: [
      {
        open: `$$`,
        close: `$$`,
      },
      {
        open: `\\[`,
        close: `\\]`,
      },
    ],
    inline: [
      {
        open: `$$`,
        close: `$$`,
      },
      {
        open: `$`,
        close: `$`,
      },
      {
        open: `\\[`,
        close: `\\]`,
      },
      {
        open: `\\(`,
        close: `\\)`,
      },
    ],
  },
  oM = (e) => (t, n) => {
    let r = e.delimiters;
    for (let e of r) {
      if (!t.src.startsWith(e.open, t.pos)) continue;
      let r = t.pos + e.open.length,
        i = r;
      for (; (i = t.src.indexOf(e.close, i)) !== -1;) {
        let n = 0,
          r = i - 1;
        for (; r >= 0 && t.src[r] === `\\`;) (n++, r--);
        if (n % 2 == 0) break;
        i += e.close.length;
      }
      if (i !== -1) {
        if (i - r === 0)
          return (n || (t.pending += e.open + e.close), (t.pos = i + e.close.length), !0);
        if (!n) {
          let n = t.push(`math_inline`, `math`, 0);
          ((n.markup = e.open), (n.content = t.src.slice(r, i)));
        }
        return ((t.pos = i + e.close.length), !0);
      }
    }
    return !1;
  },
  sM = (e) => (t, n, r, i) => {
    let a = e.delimiters,
      o = t.bMarks[n] + t.tShift[n],
      s = t.eMarks[n],
      c = (e, r, i) => {
        t.line = r;
        let a = t.push(`math_block`, `math`, 0);
        return ((a.block = !0), (a.content = e), (a.map = [n, t.line]), (a.markup = i), !0);
      };
    for (let e of a) {
      let a = o;
      if (t.src.slice(a, a + e.open.length) !== e.open) continue;
      let l = a + e.open.length,
        u = t.src.slice(l, s).trim(),
        d = u === ``,
        f = u === e.close,
        p = u.endsWith(e.close);
      if (!d && !f && !p) continue;
      if (i) return !0;
      if (f) return c(``, n + 1, e.open);
      if (!d && p) return c(u.slice(0, -e.close.length), n + 1, e.open);
      let m = n + 1,
        h = !1,
        g = ``;
      for (; m < r; m++) {
        let n = t.bMarks[m] + t.tShift[m],
          r = t.eMarks[m];
        if (n < r && t.tShift[m] < t.blkIndent) break;
        if (t.src.slice(n, r).trim().endsWith(e.close)) {
          let i = t.src.slice(0, r).lastIndexOf(e.close);
          ((g = t.src.slice(n, i)), (h = !0));
          break;
        }
      }
      if (h) return c(t.getLines(n + 1, m, t.tShift[n], !0) + (g.trim() ? g : ``), m + 1, e.open);
    }
    return !1;
  },
  cM = (e, { katexRef: t, inlineDelimiters: n, blockDelimiters: r }) => {
    let i = (e, n, r, i, a = !1) => {
        let o = {
            attrs: tM(e, [[`class`, n]]),
          },
          s = i.renderAttrs(o);
        return t.value
          ? `<${r} ${s} data-processed>${t.value.renderToString(
              e.content,
              AD.katexConfig({
                throwOnError: !1,
                displayMode: a,
              }),
            )}</${r}>`
          : `<${r} ${s}>${e.content}</${r}>`;
      },
      a = (e, t, n, r, a) => i(e[t], `${$}-katex-inline`, `span`, a),
      o = (e, t, n, r, a) => i(e[t], `${$}-katex-block`, `p`, a, !0);
    (e.inline.ruler.before(
      `escape`,
      `math_inline`,
      oM({
        delimiters: n || aM.inline,
      }),
    ),
      e.block.ruler.after(
        `blockquote`,
        `math_block`,
        sM({
          delimiters: r || aM.block,
        }),
        {
          alt: [`paragraph`, `reference`, `blockquote`, `list`],
        },
      ),
      (e.renderer.rules.math_inline = a),
      (e.renderer.rules.math_block = o));
  },
  lM = (e, t) => {
    let n = e.renderer.rules.fence.bind(e.renderer.rules);
    e.renderer.rules.fence = (r, i, a, o, s) => {
      let c = r[i],
        l = c.content.trim();
      if (c.info === `mermaid`) {
        if (
          (c.attrSet(`class`, `md-editor-mermaid`),
          c.attrSet(`data-mermaid-theme`, t.themeRef.value),
          c.map && c.level === 0)
        ) {
          let e = c.map[1] - 1,
            t = !!o.srcLines[e]?.trim()?.startsWith("```");
          (c.attrSet(`data-closed`, `${t}`), c.attrSet(`data-line`, String(c.map[0])));
        }
        let n = Qj.get(l);
        return n
          ? (c.attrSet(`data-processed`, ``),
            c.attrSet(`data-content`, l),
            `<p ${s.renderAttrs(c)}>${n}</p>`)
          : `<div ${s.renderAttrs(c)}>${e.utils.escapeHtml(l)}</div>`;
      }
      return n(r, i, a, o, s);
    };
  },
  uM = (e, t, n) => {
    let r = e.attrIndex(t),
      i = [t, n];
    r < 0 ? e.attrPush(i) : ((e.attrs = e.attrs || []), (e.attrs[r] = i));
  },
  dM = (e) => e.type === `inline`,
  fM = (e) => e.type === `paragraph_open`,
  pM = (e) => e.type === `list_item_open`,
  mM = (e) =>
    e.content.indexOf(`[ ] `) === 0 ||
    e.content.indexOf(`[x] `) === 0 ||
    e.content.indexOf(`[X] `) === 0,
  hM = (e, t) => dM(e[t]) && fM(e[t - 1]) && pM(e[t - 2]) && mM(e[t]),
  gM = (e, t) => {
    let n = e[t].level - 1;
    for (let r = t - 1; r >= 0; r--) if (e[r].level === n) return r;
    return -1;
  },
  _M = (e) => {
    let t = new e(`html_inline`, ``, 0);
    return ((t.content = `<label>`), t);
  },
  vM = (e) => {
    let t = new e(`html_inline`, ``, 0);
    return ((t.content = `</label>`), t);
  },
  yM = (e, t, n) => {
    let r = new n(`html_inline`, ``, 0);
    return (
      (r.content = `<label class="task-list-item-label" for="` + t + `">` + e + `</label>`),
      (r.attrs = [[`for`, t]]),
      r
    );
  },
  bM = (e, t, n) => {
    let r = new t(`html_inline`, ``, 0),
      i = n.enabled ? ` ` : ` disabled="" `;
    return (
      e.content.indexOf(`[ ] `) === 0
        ? (r.content = `<input class="task-list-item-checkbox"` + i + `type="checkbox">`)
        : (e.content.indexOf(`[x] `) === 0 || e.content.indexOf(`[X] `) === 0) &&
          (r.content =
            `<input class="task-list-item-checkbox" checked=""` + i + `type="checkbox">`),
      r
    );
  },
  xM = (e, t, n) => {
    if (
      ((e.children = e.children || []),
      e.children.unshift(bM(e, t, n)),
      (e.children[1].content = e.children[1].content.slice(3)),
      (e.content = e.content.slice(3)),
      n.label)
    )
      if (n.labelAfter) {
        e.children.pop();
        let n = `task-item-` + Math.ceil(1e4 * 1e3 * Math.random() - 1e3);
        ((e.children[0].content = e.children[0].content.slice(0, -1) + ` id="` + n + `">`),
          e.children.push(yM(e.content, n, t)));
      } else (e.children.unshift(_M(t)), e.children.push(vM(t)));
  },
  SM = (e, t = {}) => {
    e.core.ruler.after(`inline`, `github-task-lists`, (e) => {
      let n = e.tokens;
      for (let r = 2; r < n.length; r++)
        hM(n, r) &&
          (xM(n[r], e.Token, t),
          uM(n[r - 2], `class`, `task-list-item` + (t.enabled ? ` enabled` : ` `)),
          uM(n[gM(n, r - 2)], `class`, `contains-task-list`));
    });
  },
  CM = (e) => {
    e.core.ruler.push(
      `init-line-number`,
      (e) => (
        e.tokens.forEach((e) => {
          e.map && ((e.attrs ||= []), e.attrs.push([`data-line`, e.map[0].toString()]));
        }),
        !0
      ),
    );
  },
  wM = (e, t) => {
    let { editorConfig: n, markdownItConfig: r, markdownItPlugins: i, editorExtensions: a } = AD,
      o = R(`editorId`),
      s = R(`language`),
      c = R(`usedLanguageText`),
      l = R(`showCodeRowNumber`),
      u = R(`theme`),
      d = R(`customIcon`),
      f = R(`rootRef`),
      p = R(`setting`),
      m = F([]),
      h = Xj(e),
      g = Zj(e),
      { reRenderRef: v, replaceMermaid: y } = $j(e),
      { reRenderEcharts: b, replaceEcharts: x } = Yj(e),
      S = hj({
        html: !0,
        breaks: !0,
        linkify: !0,
      });
    r(S, {
      editorId: o,
    });
    let C = [
      {
        type: `image`,
        plugin: bj,
        options: {
          figcaption: !0,
          classes: `md-zoom`,
        },
      },
      {
        type: `admonition`,
        plugin: eM,
        options: {},
      },
      {
        type: `taskList`,
        plugin: SM,
        options: {},
      },
      {
        type: `heading`,
        plugin: iM,
        options: {
          mdHeadingId: e.mdHeadingId,
          headsRef: m,
        },
      },
      {
        type: `code`,
        plugin: nM,
        options: {
          editorId: o,
          usedLanguageTextRef: c,
          codeFoldable: e.codeFoldable,
          autoFoldThreshold: e.autoFoldThreshold,
          customIconRef: d,
        },
      },
      {
        type: `sub`,
        plugin: Cj,
        options: {},
      },
      {
        type: `sup`,
        plugin: Ej,
        options: {},
      },
    ];
    (e.noKatex ||
      C.push({
        type: `katex`,
        plugin: cM,
        options: {
          katexRef: g,
        },
      }),
      e.noMermaid ||
        C.push({
          type: `mermaid`,
          plugin: lM,
          options: {
            themeRef: u,
          },
        }),
      e.noEcharts ||
        C.push({
          type: `echarts`,
          plugin: rM,
          options: {
            themeRef: u,
          },
        }),
      i(C, {
        editorId: o,
      }).forEach((e) => {
        S.use(e.plugin, e.options);
      }));
    let w = S.options.highlight;
    (S.set({
      highlight: (t, n, r) => {
        if (w) {
          let e = w(t, n, r);
          if (e) return e;
        }
        let i;
        return (
          (i =
            !e.noHighlight && h.value
              ? h.value.getLanguage(n)
                ? h.value.highlight(t, {
                    language: n,
                    ignoreIllegals: !0,
                  }).value
                : h.value.highlightAuto(t).value
              : S.utils.escapeHtml(t)),
          `<pre><code class="language-${n}" language=${n}>${l ? Wae(i.replace(/^\n+|\n+$/g, ``), t.replace(/^\n+|\n+$/g, ``)) : `<span class="${$}-code-block">${i.replace(/^\n+|\n+$/g, ``)}</span>`}</code></pre>`
        );
      },
    }),
      CM(S));
    let T = F(`_article-key_${bD()}`),
      E = F(
        e.sanitize(
          S.render(e.modelValue, {
            srcLines: e.modelValue.split(`
`),
          }),
        ),
      ),
      D = () => {},
      ee = () => {},
      te = () => {
        let e = f.value?.querySelectorAll(`#${o} p.${$}-mermaid:not([data-closed=false])`);
        (ee(),
          (ee = Qae(e, {
            customIcon: d.value,
          })),
          a.mermaid?.enableZoom &&
            (D(),
            (D = $ae(e, {
              customIcon: d.value,
            }))));
      },
      O = () => {
        (nO.emit(o, UD, E.value),
          e.onHtmlChanged(E.value),
          e.onGetCatalog(m.value),
          nO.emit(o, YD, m.value),
          de(() => {
            (y().then(te), x());
          }));
      },
      k = () => {
        ((m.value = []),
          (E.value = e.sanitize(
            S.render(e.modelValue, {
              srcLines: e.modelValue.split(`
`),
            }),
          )));
      },
      ne = V(() => (e.noKatex || !!g.value) && (e.noHighlight || !!h.value)),
      re = -1;
    return (
      He([me(e, `modelValue`), ne, v, s], () => {
        re = window.setTimeout(
          () => {
            k();
          },
          t ? 0 : n.renderDelay,
        );
      }),
      He(
        () => p.value.preview,
        () => {
          p.value.preview &&
            de(() => {
              (y().then(te), x(), nO.emit(o, `catalogChanged`, m.value));
            });
        },
      ),
      He([E, b], () => {
        O();
      }),
      Qe(O),
      Qe(() => {
        (nO.on(o, {
          name: XD,
          callback() {
            nO.emit(o, YD, m.value);
          },
        }),
          nO.on(o, {
            name: ZD,
            callback: () => {
              ((T.value = `_article-key_${bD()}`), k());
            },
          }));
      }),
      oe(() => {
        (D(), ee(), clearTimeout(re));
      }),
      {
        html: E,
        key: T,
      }
    );
  },
  TM = (e, t) => {
    let n = R(`editorId`),
      r = R(`setting`),
      { noImgZoomIn: i } = e,
      a = vD(() => {
        let e = document.querySelectorAll(
          `#${n}-preview img:not(.not-zoom):not(.medium-zoom-image)`,
        );
        e.length !== 0 &&
          Ij(e, {
            background: `#00000073`,
          });
      });
    (Qe(async () => {
      !i && r.value.preview && (await a());
    }),
      He([t, () => r.value.preview], async () => {
        !i && r.value.preview && (await a());
      }));
  },
  EM = {
    checked: {
      regexp: /- \[x\]/,
      value: `- [ ]`,
    },
    unChecked: {
      regexp: /- \[\s\]/,
      value: `- [x]`,
    },
  },
  DM = (e, t) => {
    let n = R(`editorId`),
      r = R(`rootRef`),
      i = () => {},
      a = () => {
        if (!r.value) return !1;
        let t = r.value.querySelectorAll(`.task-list-item.enabled`),
          a = (t) => {
            t.preventDefault();
            let r = t.target.checked ? `unChecked` : `checked`,
              i = t.target.parentElement?.dataset.line;
            if (!i) return;
            let a = Number(i),
              o = e.modelValue.split(`
`),
              s = o[Number(a)].replace(EM[r].regexp, EM[r].value);
            e.previewOnly
              ? ((o[Number(a)] = s),
                e.onChange(
                  o.join(`
`),
                ))
              : nO.emit(n, $D, a + 1, s);
          };
        (t.forEach((e) => {
          e.addEventListener(`click`, a);
        }),
          (i = () => {
            t.forEach((e) => {
              e.removeEventListener(`click`, a);
            });
          }));
      };
    (oe(() => {
      i();
    }),
      He(
        [t],
        () => {
          (i(), de(a));
        },
        {
          immediate: !0,
        },
      ));
  },
  OM = (e, t, n) => {
    let r = R(`setting`),
      i = () => {
        de(() => {
          e.onRemount?.();
        });
      },
      a = (e) => {
        e && i();
      };
    (He([t, n], i), He(() => r.value.preview, a), He(() => r.value.htmlPreview, a), Qe(i));
  },
  kM = {
    modelValue: {
      type: String,
      default: ``,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onHtmlChanged: {
      type: Function,
      default: () => {},
    },
    onGetCatalog: {
      type: Function,
      default: () => {},
    },
    mdHeadingId: {
      type: Function,
      default: () => ``,
    },
    noMermaid: {
      type: Boolean,
      default: !1,
    },
    sanitize: {
      type: Function,
      default: (e) => e,
    },
    noKatex: {
      type: Boolean,
      default: !1,
    },
    formatCopiedText: {
      type: Function,
      default: (e) => e,
    },
    noHighlight: {
      type: Boolean,
      default: !1,
    },
    previewOnly: {
      type: Boolean,
      default: !1,
    },
    noImgZoomIn: {
      type: Boolean,
    },
    sanitizeMermaid: {
      type: Function,
    },
    codeFoldable: {
      type: Boolean,
    },
    autoFoldThreshold: {
      type: Number,
    },
    onRemount: {
      type: Function,
    },
    noEcharts: {
      type: Boolean,
    },
    previewComponent: {
      type: [Object, Function],
      default: void 0,
    },
  },
  AM = {
    ...kM,
    updateModelValue: {
      type: Function,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: ``,
    },
    scrollAuto: {
      type: Boolean,
    },
    autofocus: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    maxlength: {
      type: Number,
    },
    autoDetectCode: {
      type: Boolean,
    },
    onBlur: {
      type: Function,
      default: () => {},
    },
    onFocus: {
      type: Function,
      default: () => {},
    },
    completions: {
      type: Array,
    },
    onInput: {
      type: Function,
    },
    onDrop: {
      type: Function,
      default: () => {},
    },
    inputBoxWidth: {
      type: String,
    },
    oninputBoxWidthChange: {
      type: Function,
    },
    transformImgUrl: {
      type: Function,
      default: (e) => e,
    },
    catalogLayout: {
      type: String,
    },
    catalogMaxDepth: {
      type: Number,
    },
  },
  jM = (e) => {
    let t = new DOMParser().parseFromString(e, `text/html`);
    return Array.from(t.body.childNodes);
  },
  MM = (e, t) =>
    e.nodeType === t.nodeType
      ? e.nodeType === Node.TEXT_NODE || e.nodeType === Node.COMMENT_NODE
        ? e.textContent === t.textContent
        : e.nodeType === Node.ELEMENT_NODE
          ? e.outerHTML === t.outerHTML
          : e.isEqualNode
            ? e.isEqualNode(t)
            : !1
      : !1,
  NM = k({
    name: `UpdateOnDemand`,
    props: {
      id: {
        type: String,
        required: !0,
      },
      class: {
        type: [String, Array, Object],
        required: !0,
      },
      html: {
        type: String,
        required: !0,
      },
    },
    setup(e) {
      let t = F(),
        n = e.html,
        r = (e, n) => {
          if (!t.value) return;
          let r = t.value,
            i = Array.from(r.childNodes),
            a = Math.min(e.length, n.length),
            o = -1;
          for (let t = 0; t < a; t++)
            if (!MM(e[t], n[t])) {
              o = t;
              break;
            }
          if (o === -1)
            if (n.length > e.length) o = e.length;
            else if (e.length > n.length) o = n.length;
            else return;
          let s = Math.min(o, i.length);
          for (let e = i.length - 1; e >= s; e--) i[e].remove();
          for (let t = o; t < e.length; t++) r.appendChild(e[t].cloneNode(!0));
        };
      return (
        He(
          () => e.html,
          (e, t) => {
            r(jM(e), jM(t || ``));
          },
        ),
        () =>
          N(
            `div`,
            {
              id: e.id,
              class: e.class,
              innerHTML: n,
              ref: t,
            },
            null,
          )
      );
    },
  }),
  PM = k({
    name: `ContentPreview`,
    props: kM,
    setup(e) {
      let t = R(`editorId`),
        n = R(`setting`),
        r = R(`previewTheme`),
        i = R(`showCodeRowNumber`),
        { html: a, key: o } = wM(e, e.previewOnly);
      (Jj(e, a, o), TM(e, a), DM(e, a), OM(e, a, o));
      let s = V(() => [`${$}-preview`, `${r?.value}-theme`, i && `md-editor-scrn`].filter(Boolean)),
        c = () => {
          let n = `${t}-preview`;
          return e.previewComponent
            ? Ne(e.previewComponent, {
                key: o.value,
                html: a.value,
                id: n,
                class: s.value,
              })
            : N(
                NM,
                {
                  key: o.value,
                  html: a.value,
                  id: n,
                  class: s.value,
                },
                null,
              );
        };
      return () =>
        N(ke, null, [
          n.value.preview &&
            (e.previewOnly
              ? c()
              : N(
                  `div`,
                  {
                    id: `${t}-preview-wrapper`,
                    class: `md-editor-preview-wrapper`,
                    key: `content-preview-wrapper`,
                  },
                  [c()],
                )),
          n.value.htmlPreview &&
            N(
              `div`,
              {
                id: `${t}-html-wrapper`,
                class: `md-editor-preview-wrapper`,
                key: `html-preview-wrapper`,
              },
              [
                N(
                  `div`,
                  {
                    class: `md-editor-html`,
                  },
                  [a.value],
                ),
              ],
            ),
        ]);
    },
  }),
  FM = {
    modelValue: {
      type: String,
      default: ``,
    },
    onChange: {
      type: Function,
      default: void 0,
    },
    theme: {
      type: String,
      default: `light`,
    },
    class: {
      type: String,
      default: ``,
    },
    language: {
      type: String,
      default: `zh-CN`,
    },
    onHtmlChanged: {
      type: Function,
      default: void 0,
    },
    onGetCatalog: {
      type: Function,
      default: void 0,
    },
    editorId: {
      type: String,
      default: void 0,
    },
    id: {
      type: String,
      default: void 0,
    },
    showCodeRowNumber: {
      type: Boolean,
      default: !0,
    },
    previewTheme: {
      type: String,
      default: `default`,
    },
    style: {
      type: Object,
      default: () => ({}),
    },
    mdHeadingId: {
      type: Function,
      default: ({ text: e }) => e,
    },
    sanitize: {
      type: Function,
      default: (e) => e,
    },
    noMermaid: {
      type: Boolean,
      default: !1,
    },
    noKatex: {
      type: Boolean,
      default: !1,
    },
    codeTheme: {
      type: String,
      default: `atom`,
    },
    formatCopiedText: {
      type: Function,
      default: (e) => e,
    },
    codeStyleReverse: {
      type: Boolean,
      default: !0,
    },
    codeStyleReverseList: {
      type: Array,
      default: [`default`, `mk-cute`],
    },
    noHighlight: {
      type: Boolean,
      default: !1,
    },
    noImgZoomIn: {
      type: Boolean,
      default: !1,
    },
    customIcon: {
      type: Object,
      default: {},
    },
    sanitizeMermaid: {
      type: Function,
      default: (e) => Promise.resolve(e),
    },
    codeFoldable: {
      type: Boolean,
      default: !0,
    },
    autoFoldThreshold: {
      type: Number,
      default: 30,
    },
    onRemount: {
      type: Function,
      default: void 0,
    },
    noEcharts: {
      type: Boolean,
      default: !1,
    },
    previewComponent: {
      type: [Object, Function],
      default: void 0,
    },
  },
  IM = {
    ...FM,
    onSave: {
      type: Function,
      default: void 0,
    },
    onUploadImg: {
      type: Function,
      default: void 0,
    },
    pageFullscreen: {
      type: Boolean,
      default: !1,
    },
    preview: {
      type: Boolean,
      default: !0,
    },
    htmlPreview: {
      type: Boolean,
      default: !1,
    },
    toolbars: {
      type: Array,
      default: DD,
    },
    floatingToolbars: {
      type: Array,
      default: [],
    },
    toolbarsExclude: {
      type: Array,
      default: [],
    },
    noPrettier: {
      type: Boolean,
      default: !1,
    },
    tabWidth: {
      type: Number,
      default: 2,
    },
    tableShape: {
      type: Array,
      default: [6, 4],
    },
    placeholder: {
      type: String,
      default: ``,
    },
    defToolbars: {
      type: [String, Object],
      default: void 0,
    },
    onError: {
      type: Function,
      default: void 0,
    },
    footers: {
      type: Array,
      default: OD,
    },
    scrollAuto: {
      type: Boolean,
      default: !0,
    },
    defFooters: {
      type: [String, Object],
      default: void 0,
    },
    noUploadImg: {
      type: Boolean,
      default: !1,
    },
    autoFocus: {
      type: Boolean,
      default: !1,
    },
    disabled: {
      type: Boolean,
      default: !1,
    },
    readOnly: {
      type: Boolean,
      default: !1,
    },
    maxLength: {
      type: Number,
      default: void 0,
    },
    autoDetectCode: {
      type: Boolean,
      default: !1,
    },
    onBlur: {
      type: Function,
      default: void 0,
    },
    onFocus: {
      type: Function,
      default: void 0,
    },
    completions: {
      type: Array,
      default: void 0,
    },
    showToolbarName: {
      type: Boolean,
      default: !1,
    },
    onInput: {
      type: Function,
      default: void 0,
    },
    onDrop: {
      type: Function,
      default: void 0,
    },
    inputBoxWidth: {
      type: String,
      default: `50%`,
    },
    oninputBoxWidthChange: {
      type: Function,
      default: void 0,
    },
    transformImgUrl: {
      type: Function,
      default: (e) => e,
    },
    catalogLayout: {
      type: String,
      default: `fixed`,
    },
    catalogMaxDepth: {
      type: Number,
      default: void 0,
    },
  },
  LM = [`onHtmlChanged`, `onGetCatalog`, `onChange`, `onRemount`, `update:modelValue`],
  RM = [
    ...LM,
    `onSave`,
    `onUploadImg`,
    `onError`,
    `onBlur`,
    `onFocus`,
    `onInput`,
    `onDrop`,
    `oninputBoxWidthChange`,
  ],
  zM = (e, t, n) => {
    let { editorId: r } = n;
    t.expose({
      rerender() {
        nO.emit(r, ZD);
      },
    });
  },
  BM = k({
    name: `MdPreview`,
    props: FM,
    emits: LM,
    setup(e, t) {
      let { noKatex: n, noMermaid: r, noHighlight: i } = e,
        a = F(),
        o = qj(e);
      (Bj(e, {
        rootRef: a,
        editorId: o,
      }),
        zM(e, t, {
          editorId: o,
        }),
        oe(() => {
          nO.clear(o);
        }));
      let s = (n) => {
          (e.onChange?.(n), t.emit(`onChange`, n), t.emit(`update:modelValue`, n));
        },
        c = (n) => {
          (e.onHtmlChanged?.(n), t.emit(`onHtmlChanged`, n));
        },
        l = (n) => {
          (e.onGetCatalog?.(n), t.emit(`onGetCatalog`, n));
        },
        u = () => {
          (e.onRemount?.(), t.emit(`onRemount`));
        };
      return () =>
        N(
          `div`,
          {
            id: o,
            class: [$, e.class, e.theme === `dark` && `md-editor-dark`, `${$}-previewOnly`],
            style: e.style,
            ref: a,
          },
          [
            N(
              PM,
              {
                modelValue: e.modelValue,
                onChange: s,
                onHtmlChanged: c,
                onGetCatalog: l,
                mdHeadingId: e.mdHeadingId,
                noMermaid: r,
                sanitize: e.sanitize,
                noKatex: n,
                formatCopiedText: e.formatCopiedText,
                noHighlight: i,
                noImgZoomIn: e.noImgZoomIn,
                previewOnly: !0,
                sanitizeMermaid: e.sanitizeMermaid,
                codeFoldable: e.codeFoldable,
                autoFoldThreshold: e.autoFoldThreshold,
                onRemount: u,
                noEcharts: e.noEcharts,
                previewComponent: e.previewComponent,
              },
              null,
            ),
          ],
        );
    },
  });
BM.install = (e) => (e.component(BM.name, BM), e);
var VM = (e) => e === ``,
  HM = (...e) =>
    e
      .filter((e, t, n) => !!e && e.trim() !== `` && n.indexOf(e) === t)
      .join(` `)
      .trim(),
  UM = (e) => e.replace(/([a-z0-9])([A-Z])/g, `$1-$2`).toLowerCase(),
  WM = (e) =>
    e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => (n ? n.toUpperCase() : t.toLowerCase())),
  GM = (e) => {
    let t = WM(e);
    return t.charAt(0).toUpperCase() + t.slice(1);
  },
  KM = {
    xmlns: `http://www.w3.org/2000/svg`,
    width: 24,
    height: 24,
    viewBox: `0 0 24 24`,
    fill: `none`,
    stroke: `currentColor`,
    "stroke-width": 2,
    "stroke-linecap": `round`,
    "stroke-linejoin": `round`,
  };
B();
var qM = Symbol(`lucide-icons`);
function JM() {
  return R(qM, {});
}
B();
var YM = (
  {
    name: e,
    iconNode: t,
    absoluteStrokeWidth: n,
    "absolute-stroke-width": r,
    strokeWidth: i,
    "stroke-width": a,
    size: o,
    color: s,
    ...c
  },
  { slots: l },
) => {
  let { size: u, color: d, strokeWidth: f = 2, absoluteStrokeWidth: p = !1, class: m = `` } = JM(),
    h = V(() => {
      let e = VM(n) || VM(r) || n === !0 || r === !0 || p === !0,
        t = i || a || f || KM[`stroke-width`];
      return e ? (Number(t) * 24) / Number(o ?? u ?? KM.width) : t;
    });
  return Ne(
    `svg`,
    {
      ...KM,
      ...c,
      width: o ?? u ?? KM.width,
      height: o ?? u ?? KM.height,
      stroke: s ?? d ?? KM.stroke,
      "stroke-width": h.value,
      class: HM(
        `lucide`,
        m,
        ...(e ? [`lucide-${UM(GM(e))}-icon`, `lucide-${UM(e)}`] : [`lucide-icon`]),
      ),
    },
    [...t.map((e) => Ne(...e)), ...(l.default ? [l.default()] : [])],
  );
};
B();
var XM =
    (e, t) =>
    (n, { slots: r, attrs: i }) =>
      Ne(
        YM,
        {
          ...i,
          ...n,
          iconNode: t,
          name: e,
        },
        r.default
          ? {
              default: r.default,
            }
          : void 0,
      ),
  ZM = XM(`bold`, [
    [
      `path`,
      {
        d: `M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8`,
        key: `mg9rjx`,
      },
    ],
  ]),
  QM = XM(`chart-area`, [
    [
      `path`,
      {
        d: `M3 3v16a2 2 0 0 0 2 2h16`,
        key: `c24i48`,
      },
    ],
    [
      `path`,
      {
        d: `M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z`,
        key: `q0gr47`,
      },
    ],
  ]),
  $M = XM(`code`, [
    [
      `path`,
      {
        d: `m16 18 6-6-6-6`,
        key: `eg8j8`,
      },
    ],
    [
      `path`,
      {
        d: `m8 6-6 6 6 6`,
        key: `ppft3o`,
      },
    ],
  ]),
  eN = XM(`code-xml`, [
    [
      `path`,
      {
        d: `m18 16 4-4-4-4`,
        key: `1inbqp`,
      },
    ],
    [
      `path`,
      {
        d: `m6 8-4 4 4 4`,
        key: `15zrgr`,
      },
    ],
    [
      `path`,
      {
        d: `m14.5 4-5 16`,
        key: `e7oirm`,
      },
    ],
  ]),
  tN = XM(`expand`, [
    [
      `path`,
      {
        d: `m15 15 6 6`,
        key: `1s409w`,
      },
    ],
    [
      `path`,
      {
        d: `m15 9 6-6`,
        key: `ko1vev`,
      },
    ],
    [
      `path`,
      {
        d: `M21 16v5h-5`,
        key: `1ck2sf`,
      },
    ],
    [
      `path`,
      {
        d: `M21 8V3h-5`,
        key: `1qoq8a`,
      },
    ],
    [
      `path`,
      {
        d: `M3 16v5h5`,
        key: `1t08am`,
      },
    ],
    [
      `path`,
      {
        d: `m3 21 6-6`,
        key: `wwnumi`,
      },
    ],
    [
      `path`,
      {
        d: `M3 8V3h5`,
        key: `1ln10m`,
      },
    ],
    [
      `path`,
      {
        d: `M9 9 3 3`,
        key: `v551iv`,
      },
    ],
  ]),
  nN = XM(`eye`, [
    [
      `path`,
      {
        d: `M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0`,
        key: `1nclc0`,
      },
    ],
    [
      `circle`,
      {
        cx: `12`,
        cy: `12`,
        r: `3`,
        key: `1v7zrd`,
      },
    ],
  ]),
  rN = XM(`forward`, [
    [
      `path`,
      {
        d: `m15 17 5-5-5-5`,
        key: `nf172w`,
      },
    ],
    [
      `path`,
      {
        d: `M4 18v-2a4 4 0 0 1 4-4h12`,
        key: `jmiej9`,
      },
    ],
  ]),
  iN = XM(`heading`, [
    [
      `path`,
      {
        d: `M6 12h12`,
        key: `8npq4p`,
      },
    ],
    [
      `path`,
      {
        d: `M6 20V4`,
        key: `1w1bmo`,
      },
    ],
    [
      `path`,
      {
        d: `M18 20V4`,
        key: `o2hl4u`,
      },
    ],
  ]),
  aN = XM(`image`, [
    [
      `rect`,
      {
        width: `18`,
        height: `18`,
        x: `3`,
        y: `3`,
        rx: `2`,
        ry: `2`,
        key: `1m3agn`,
      },
    ],
    [
      `circle`,
      {
        cx: `9`,
        cy: `9`,
        r: `2`,
        key: `af1f0g`,
      },
    ],
    [
      `path`,
      {
        d: `m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21`,
        key: `1xmnt7`,
      },
    ],
  ]),
  oN = XM(`italic`, [
    [
      `line`,
      {
        x1: `19`,
        x2: `10`,
        y1: `4`,
        y2: `4`,
        key: `15jd3p`,
      },
    ],
    [
      `line`,
      {
        x1: `14`,
        x2: `5`,
        y1: `20`,
        y2: `20`,
        key: `bu0au3`,
      },
    ],
    [
      `line`,
      {
        x1: `15`,
        x2: `9`,
        y1: `4`,
        y2: `20`,
        key: `uljnxc`,
      },
    ],
  ]),
  sN = XM(`link`, [
    [
      `path`,
      {
        d: `M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71`,
        key: `1cjeqo`,
      },
    ],
    [
      `path`,
      {
        d: `M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71`,
        key: `19qd67`,
      },
    ],
  ]),
  cN = XM(`list-ordered`, [
    [
      `path`,
      {
        d: `M11 5h10`,
        key: `1cz7ny`,
      },
    ],
    [
      `path`,
      {
        d: `M11 12h10`,
        key: `1438ji`,
      },
    ],
    [
      `path`,
      {
        d: `M11 19h10`,
        key: `11t30w`,
      },
    ],
    [
      `path`,
      {
        d: `M4 4h1v5`,
        key: `10yrso`,
      },
    ],
    [
      `path`,
      {
        d: `M4 9h2`,
        key: `r1h2o0`,
      },
    ],
    [
      `path`,
      {
        d: `M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02`,
        key: `xtkcd5`,
      },
    ],
  ]),
  lN = XM(`list-todo`, [
    [
      `path`,
      {
        d: `M13 5h8`,
        key: `a7qcls`,
      },
    ],
    [
      `path`,
      {
        d: `M13 12h8`,
        key: `h98zly`,
      },
    ],
    [
      `path`,
      {
        d: `M13 19h8`,
        key: `c3s6r1`,
      },
    ],
    [
      `path`,
      {
        d: `m3 17 2 2 4-4`,
        key: `1jhpwq`,
      },
    ],
    [
      `rect`,
      {
        x: `3`,
        y: `4`,
        width: `6`,
        height: `6`,
        rx: `1`,
        key: `cif1o7`,
      },
    ],
  ]),
  uN = XM(`list-tree`, [
    [
      `path`,
      {
        d: `M8 5h13`,
        key: `1pao27`,
      },
    ],
    [
      `path`,
      {
        d: `M13 12h8`,
        key: `h98zly`,
      },
    ],
    [
      `path`,
      {
        d: `M13 19h8`,
        key: `c3s6r1`,
      },
    ],
    [
      `path`,
      {
        d: `M3 10a2 2 0 0 0 2 2h3`,
        key: `1npucw`,
      },
    ],
    [
      `path`,
      {
        d: `M3 5v12a2 2 0 0 0 2 2h3`,
        key: `x1gjn2`,
      },
    ],
  ]),
  dN = XM(`list`, [
    [
      `path`,
      {
        d: `M3 5h.01`,
        key: `18ugdj`,
      },
    ],
    [
      `path`,
      {
        d: `M3 12h.01`,
        key: `nlz23k`,
      },
    ],
    [
      `path`,
      {
        d: `M3 19h.01`,
        key: `noohij`,
      },
    ],
    [
      `path`,
      {
        d: `M8 5h13`,
        key: `1pao27`,
      },
    ],
    [
      `path`,
      {
        d: `M8 12h13`,
        key: `1za7za`,
      },
    ],
    [
      `path`,
      {
        d: `M8 19h13`,
        key: `m83p4d`,
      },
    ],
  ]),
  fN = XM(`maximize-2`, [
    [
      `path`,
      {
        d: `M15 3h6v6`,
        key: `1q9fwt`,
      },
    ],
    [
      `path`,
      {
        d: `m21 3-7 7`,
        key: `1l2asr`,
      },
    ],
    [
      `path`,
      {
        d: `m3 21 7-7`,
        key: `tjx5ai`,
      },
    ],
    [
      `path`,
      {
        d: `M9 21H3v-6`,
        key: `wtvkvv`,
      },
    ],
  ]),
  pN = XM(`minimize-2`, [
    [
      `path`,
      {
        d: `m14 10 7-7`,
        key: `oa77jy`,
      },
    ],
    [
      `path`,
      {
        d: `M20 10h-6V4`,
        key: `mjg0md`,
      },
    ],
    [
      `path`,
      {
        d: `m3 21 7-7`,
        key: `tjx5ai`,
      },
    ],
    [
      `path`,
      {
        d: `M4 14h6v6`,
        key: `rmj7iw`,
      },
    ],
  ]),
  mN = XM(`quote`, [
    [
      `path`,
      {
        d: `M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z`,
        key: `rib7q0`,
      },
    ],
    [
      `path`,
      {
        d: `M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z`,
        key: `1ymkrd`,
      },
    ],
  ]),
  hN = XM(`reply`, [
    [
      `path`,
      {
        d: `M20 18v-2a4 4 0 0 0-4-4H4`,
        key: `5vmcpk`,
      },
    ],
    [
      `path`,
      {
        d: `m9 17-5-5 5-5`,
        key: `nvlc11`,
      },
    ],
  ]),
  gN = XM(`save`, [
    [
      `path`,
      {
        d: `M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z`,
        key: `1c8476`,
      },
    ],
    [
      `path`,
      {
        d: `M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7`,
        key: `1ydtos`,
      },
    ],
    [
      `path`,
      {
        d: `M7 3v4a1 1 0 0 0 1 1h7`,
        key: `t51u73`,
      },
    ],
  ]),
  _N = XM(`shrink`, [
    [
      `path`,
      {
        d: `m15 15 6 6m-6-6v4.8m0-4.8h4.8`,
        key: `17vawe`,
      },
    ],
    [
      `path`,
      {
        d: `M9 19.8V15m0 0H4.2M9 15l-6 6`,
        key: `chjx8e`,
      },
    ],
    [
      `path`,
      {
        d: `M15 4.2V9m0 0h4.8M15 9l6-6`,
        key: `lav6yq`,
      },
    ],
    [
      `path`,
      {
        d: `M9 4.2V9m0 0H4.2M9 9 3 3`,
        key: `1pxi2q`,
      },
    ],
  ]),
  vN = XM(`square-code`, [
    [
      `path`,
      {
        d: `m10 9-3 3 3 3`,
        key: `1oro0q`,
      },
    ],
    [
      `path`,
      {
        d: `m14 15 3-3-3-3`,
        key: `bz13h7`,
      },
    ],
    [
      `rect`,
      {
        x: `3`,
        y: `3`,
        width: `18`,
        height: `18`,
        rx: `2`,
        key: `h1oib`,
      },
    ],
  ]),
  yN = XM(`square-sigma`, [
    [
      `rect`,
      {
        width: `18`,
        height: `18`,
        x: `3`,
        y: `3`,
        rx: `2`,
        key: `afitv7`,
      },
    ],
    [
      `path`,
      {
        d: `M16 8.9V7H8l4 5-4 5h8v-1.9`,
        key: `9nih0i`,
      },
    ],
  ]),
  bN = XM(`strikethrough`, [
    [
      `path`,
      {
        d: `M16 4H9a3 3 0 0 0-2.83 4`,
        key: `43sutm`,
      },
    ],
    [
      `path`,
      {
        d: `M14 12a4 4 0 0 1 0 8H6`,
        key: `nlfj13`,
      },
    ],
    [
      `line`,
      {
        x1: `4`,
        x2: `20`,
        y1: `12`,
        y2: `12`,
        key: `1e0a9i`,
      },
    ],
  ]),
  xN = XM(`subscript`, [
    [
      `path`,
      {
        d: `m4 5 8 8`,
        key: `1eunvl`,
      },
    ],
    [
      `path`,
      {
        d: `m12 5-8 8`,
        key: `1ah0jp`,
      },
    ],
    [
      `path`,
      {
        d: `M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07`,
        key: `e8ta8j`,
      },
    ],
  ]),
  SN = XM(`superscript`, [
    [
      `path`,
      {
        d: `m4 19 8-8`,
        key: `hr47gm`,
      },
    ],
    [
      `path`,
      {
        d: `m12 19-8-8`,
        key: `1dhhmo`,
      },
    ],
    [
      `path`,
      {
        d: `M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06`,
        key: `1dfcux`,
      },
    ],
  ]),
  CN = XM(`table`, [
    [
      `path`,
      {
        d: `M12 3v18`,
        key: `108xh3`,
      },
    ],
    [
      `rect`,
      {
        width: `18`,
        height: `18`,
        x: `3`,
        y: `3`,
        rx: `2`,
        key: `afitv7`,
      },
    ],
    [
      `path`,
      {
        d: `M3 9h18`,
        key: `1pudct`,
      },
    ],
    [
      `path`,
      {
        d: `M3 15h18`,
        key: `5xshup`,
      },
    ],
  ]),
  wN = XM(`trash-2`, [
    [
      `path`,
      {
        d: `M10 11v6`,
        key: `nco0om`,
      },
    ],
    [
      `path`,
      {
        d: `M14 11v6`,
        key: `outv1u`,
      },
    ],
    [
      `path`,
      {
        d: `M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6`,
        key: `miytrc`,
      },
    ],
    [
      `path`,
      {
        d: `M3 6h18`,
        key: `d0wm0j`,
      },
    ],
    [
      `path`,
      {
        d: `M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2`,
        key: `e791ji`,
      },
    ],
  ]),
  TN = XM(`underline`, [
    [
      `path`,
      {
        d: `M6 4v6a6 6 0 0 0 12 0V4`,
        key: `9kb039`,
      },
    ],
    [
      `line`,
      {
        x1: `4`,
        x2: `20`,
        y1: `20`,
        y2: `20`,
        key: `nun2al`,
      },
    ],
  ]),
  EN = XM(`upload`, [
    [
      `path`,
      {
        d: `M12 3v12`,
        key: `1x0j5s`,
      },
    ],
    [
      `path`,
      {
        d: `m17 8-5-5-5 5`,
        key: `7q97r8`,
      },
    ],
    [
      `path`,
      {
        d: `M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4`,
        key: `ih7n3h`,
      },
    ],
  ]),
  DN = XM(`view`, [
    [
      `path`,
      {
        d: `M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2`,
        key: `mrq65r`,
      },
    ],
    [
      `path`,
      {
        d: `M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2`,
        key: `be3xqs`,
      },
    ],
    [
      `circle`,
      {
        cx: `12`,
        cy: `12`,
        r: `1`,
        key: `41hilf`,
      },
    ],
    [
      `path`,
      {
        d: `M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0`,
        key: `11ak4c`,
      },
    ],
  ]),
  ON = XM(`x`, [
    [
      `path`,
      {
        d: `M18 6 6 18`,
        key: `1bl5f8`,
      },
    ],
    [
      `path`,
      {
        d: `m6 6 12 12`,
        key: `d8bk6v`,
      },
    ],
  ]);
B();
var kN = {
    bold: ZM,
    underline: TN,
    italic: oN,
    "strike-through": bN,
    title: iN,
    sub: xN,
    sup: SN,
    quote: mN,
    "unordered-list": dN,
    "ordered-list": cN,
    task: lN,
    "code-row": $M,
    code: vN,
    link: sN,
    image: aN,
    table: CN,
    revoke: hN,
    next: rN,
    save: gN,
    prettier: vN,
    minimize: pN,
    maximize: fN,
    "fullscreen-exit": _N,
    fullscreen: tN,
    "preview-only": DN,
    preview: nN,
    "preview-html": eN,
    catalog: uN,
    github: () =>
      N(
        `svg`,
        {
          xmlns: `http://www.w3.org/2000/svg`,
          viewBox: `0 0 24 24`,
          fill: `none`,
          stroke: `currentColor`,
          "stroke-width": `2`,
          "stroke-linecap": `round`,
          "stroke-linejoin": `round`,
          class: `lucide lucide-github-icon`,
        },
        [
          N(
            `path`,
            {
              d: `M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4`,
            },
            null,
          ),
          N(
            `path`,
            {
              d: `M9 18c-4.51 2-5-2-7-2`,
            },
            null,
          ),
        ],
      ),
    mermaid: QM,
    formula: yN,
    close: ON,
    delete: wN,
    upload: EN,
  },
  AN = k({
    name: `${$}-icon-set`,
    props: {
      name: {
        type: String,
        default: ``,
      },
    },
    setup(e) {
      return () =>
        Ne(kN[e.name], {
          class: `${$}-icon`,
        });
    },
  }),
  jN = k({
    name: `${$}-icon`,
    props: {
      name: {
        type: String,
        default: ``,
      },
    },
    setup(e) {
      let t = R(`customIcon`);
      return () => {
        let n = t.value[e.name];
        return typeof n == `object`
          ? typeof n.component == `object`
            ? Ne(n.component, n.props)
            : N(
                `span`,
                {
                  innerHTML: n.component,
                },
                null,
              )
          : N(
              AN,
              {
                name: e.name,
              },
              null,
            );
      };
    },
  }),
  MN = k({
    name: `MdModal`,
    props: {
      title: {
        type: [String, Object],
        default: ``,
      },
      visible: {
        type: Boolean,
        default: !1,
      },
      width: {
        type: String,
        default: `auto`,
      },
      height: {
        type: String,
        default: `auto`,
      },
      onClose: {
        type: Function,
      },
      showAdjust: {
        type: Boolean,
        default: !1,
      },
      isFullscreen: {
        type: Boolean,
        default: !1,
      },
      onAdjust: {
        type: Function,
        default: () => {},
      },
      class: {
        type: String,
        default: void 0,
      },
      style: {
        type: [Object, String],
        default: () => ({}),
      },
      showMask: {
        type: Boolean,
        default: !0,
      },
    },
    emits: [`onClose`],
    setup(e, t) {
      let n = R(`theme`),
        r = R(`rootRef`),
        i = F(e.visible),
        a = F([`${$}-modal`]),
        o = F(),
        s = F(),
        c = F(),
        l = xe(),
        u = () => {},
        d = Ae({
          maskStyle: {
            zIndex: -1,
          },
          modalStyle: {
            zIndex: -1,
          },
          initPos: {
            insetInlineStart: `0px`,
            insetBlockStart: `0px`,
          },
          historyPos: {
            insetInlineStart: `0px`,
            insetBlockStart: `0px`,
          },
        }),
        f = V(() =>
          e.isFullscreen
            ? {
                width: `100%`,
                height: `100%`,
              }
            : {
                width: e.width,
                height: e.height,
              },
        );
      (He(
        () => e.isFullscreen,
        (e) => {
          e
            ? u()
            : de(() => {
                u = lO(s.value, (e, t) => {
                  ((d.initPos.insetInlineStart = e + `px`), (d.initPos.insetBlockStart = t + `px`));
                });
              });
        },
      ),
        He(
          () => e.visible,
          (t) => {
            t
              ? ((d.maskStyle.zIndex = AD.editorConfig.zIndex + rO()),
                (d.modalStyle.zIndex = AD.editorConfig.zIndex + rO()),
                a.value.push(`zoom-in`),
                (i.value = t),
                de(() => {
                  let t = o.value.offsetWidth / 2,
                    n = o.value.offsetHeight / 2,
                    r = document.documentElement.clientWidth / 2,
                    i = document.documentElement.clientHeight / 2;
                  ((d.initPos.insetInlineStart = r - t + `px`),
                    (d.initPos.insetBlockStart = i - n + `px`),
                    e.isFullscreen ||
                      (u = lO(s.value, (e, t) => {
                        ((d.initPos.insetInlineStart = e + `px`),
                          (d.initPos.insetBlockStart = t + `px`));
                      })));
                }),
                setTimeout(() => {
                  a.value = a.value.filter((e) => e !== `zoom-in`);
                }, 140))
              : (a.value.push(`zoom-out`),
                u(),
                setTimeout(() => {
                  ((a.value = a.value.filter((e) => e !== `zoom-out`)), (i.value = t));
                }, 130));
          },
        ));
      let p = V(() => ({
          display: i.value ? `block` : `none`,
        })),
        m = V(() => {
          if (typeof e.style == `string`) {
            let t = Object.entries(p.value)
              .map(([e, t]) => `${e}: ${t}`)
              .join(`; `);
            return [e.style, t].join(`; `);
          } else
            return e.style instanceof Object
              ? {
                  ...p.value,
                  ...e.style,
                }
              : p.value;
        });
      return (
        Qe(() => {
          let e = r.value?.getRootNode();
          c.value = e instanceof Document ? document.body : e;
        }),
        () => {
          let r = jD({
              ctx: t,
            }),
            i = jD(
              {
                props: e,
                ctx: t,
              },
              `title`,
            );
          return c.value
            ? N(
                De,
                {
                  to: c.value,
                },
                {
                  default: () => [
                    N(
                      `div`,
                      {
                        ref: l,
                        class: `${$}-modal-container`,
                        "data-theme": n.value,
                      },
                      [
                        N(
                          `div`,
                          {
                            class: e.class,
                            style: m.value,
                          },
                          [
                            e.showMask &&
                              N(
                                `div`,
                                {
                                  class: `md-editor-modal-mask`,
                                  style: d.maskStyle,
                                  onClick: () => {
                                    (e.onClose?.(), t.emit(`onClose`));
                                  },
                                },
                                null,
                              ),
                            N(
                              `div`,
                              {
                                class: a.value,
                                style: {
                                  ...d.modalStyle,
                                  ...d.initPos,
                                  ...f.value,
                                },
                                ref: o,
                              },
                              [
                                N(
                                  `div`,
                                  {
                                    class: `${$}-modal-header`,
                                    ref: s,
                                  },
                                  [i || ``],
                                ),
                                N(
                                  `div`,
                                  {
                                    class: `${$}-modal-body`,
                                  },
                                  [r],
                                ),
                                N(
                                  `div`,
                                  {
                                    class: `${$}-modal-func`,
                                  },
                                  [
                                    e.showAdjust &&
                                      N(
                                        `div`,
                                        {
                                          class: `md-editor-modal-adjust`,
                                          onClick: (t) => {
                                            (t.stopPropagation(),
                                              e.isFullscreen
                                                ? (d.initPos = d.historyPos)
                                                : ((d.historyPos = d.initPos),
                                                  (d.initPos = {
                                                    insetInlineStart: `0`,
                                                    insetBlockStart: `0`,
                                                  })),
                                              e.onAdjust(!e.isFullscreen));
                                          },
                                        },
                                        [
                                          N(
                                            jN,
                                            {
                                              name: e.isFullscreen ? `minimize` : `maximize`,
                                            },
                                            null,
                                          ),
                                        ],
                                      ),
                                    N(
                                      `div`,
                                      {
                                        class: `${$}-modal-close`,
                                        onClick: (n) => {
                                          (n.stopPropagation(), e.onClose?.(), t.emit(`onClose`));
                                        },
                                      },
                                      [
                                        N(
                                          jN,
                                          {
                                            name: `close`,
                                          },
                                          null,
                                        ),
                                      ],
                                    ),
                                  ],
                                ),
                              ],
                            ),
                          ],
                        ),
                      ],
                    ),
                  ],
                },
              )
            : ``;
        }
      );
    },
  });
((MN.install = (e) => (e.component(MN.name, MN), e)), B());
function NN(e) {
  return (
    typeof e == `function` || (Object.prototype.toString.call(e) === `[object Object]` && !se(e))
  );
}
var PN = k({
  name: `ModalToolbar`,
  props: {
    title: {
      type: String,
      default: ``,
    },
    modalTitle: {
      type: [String, Object],
      default: ``,
    },
    visible: {
      type: Boolean,
      default: void 0,
    },
    width: {
      type: String,
      default: `auto`,
    },
    height: {
      type: String,
      default: `auto`,
    },
    trigger: {
      type: [String, Object],
      default: void 0,
    },
    onClick: {
      type: Function,
      default: void 0,
    },
    onClose: {
      type: Function,
      default: void 0,
    },
    showAdjust: {
      type: Boolean,
      default: !1,
    },
    isFullscreen: {
      type: Boolean,
      default: !1,
    },
    onAdjust: {
      type: Function,
      default: void 0,
    },
    class: {
      type: String,
      default: void 0,
    },
    style: {
      type: [Object, String],
      default: void 0,
    },
    showMask: {
      type: Boolean,
      default: !0,
    },
    insert: {
      type: Function,
      default: void 0,
    },
    language: {
      type: String,
      default: void 0,
    },
    theme: {
      type: String,
      default: void 0,
    },
    previewTheme: {
      type: String,
      default: void 0,
    },
    codeTheme: {
      type: String,
      default: void 0,
    },
    disabled: {
      type: Boolean,
      default: void 0,
    },
    showToolbarName: {
      type: Boolean,
      default: void 0,
    },
  },
  emits: [`onClick`, `onClose`, `onAdjust`],
  setup(e, t) {
    let n = () => {
        (e.onClose?.(), t.emit(`onClose`));
      },
      r = (n) => {
        (e.onAdjust?.(n), t.emit(`onAdjust`, n));
      };
    return () => {
      let i = jD(
          {
            props: e,
            ctx: t,
          },
          `trigger`,
        ),
        a = jD(
          {
            props: e,
            ctx: t,
          },
          `modalTitle`,
        ),
        o = jD({
          props: e,
          ctx: t,
        });
      return N(ke, null, [
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, e.disabled && `md-editor-disabled`],
            title: e.title,
            disabled: e.disabled,
            onClick: () => {
              (e.onClick?.(), t.emit(`onClick`));
            },
            type: `button`,
          },
          [i],
        ),
        N(
          MN,
          {
            style: e.style,
            class: e.class,
            width: e.width,
            height: e.height,
            title: a,
            visible: e.visible,
            showMask: e.showMask,
            onClose: n,
            showAdjust: e.showAdjust,
            isFullscreen: e.isFullscreen,
            onAdjust: r,
          },
          NN(o)
            ? o
            : {
                default: () => [o],
              },
        ),
      ]);
    };
  },
});
((PN.install = (e) => (e.component(PN.name, PN), e)), B());
var FN = k({
  name: `NormalToolbar`,
  props: {
    title: {
      type: String,
      default: ``,
    },
    trigger: {
      type: [String, Object],
      default: void 0,
    },
    onClick: {
      type: Function,
      default: void 0,
    },
    insert: {
      type: Function,
      default: void 0,
    },
    language: {
      type: String,
      default: void 0,
    },
    theme: {
      type: String,
      default: void 0,
    },
    previewTheme: {
      type: String,
      default: void 0,
    },
    codeTheme: {
      type: String,
      default: void 0,
    },
    disabled: {
      type: Boolean,
      default: void 0,
    },
    showToolbarName: {
      type: Boolean,
      default: void 0,
    },
  },
  emits: [`onClick`],
  setup(e, t) {
    return () => {
      let n = jD(
          {
            props: e,
            ctx: t,
          },
          `trigger`,
        ),
        r = jD({
          props: e,
          ctx: t,
        });
      return N(
        `button`,
        {
          class: [`${$}-toolbar-item`, e.disabled && `md-editor-disabled`],
          title: e.title,
          disabled: e.disabled,
          onClick: (n) => {
            (e.onClick?.(n), t.emit(`onClick`, n));
          },
          type: `button`,
        },
        [r || n],
      );
    };
  },
});
FN.install = (e) => (e.component(FN.name, FN), e);
var IN = (e) => {
  let { state: t } = e,
    n = t.doc.lineAt(t.selection.main.from),
    r = VN(e.state, n.from);
  return r.line ? RN(e) : r.block ? BN(e) : !1;
};
function LN(e, t) {
  return ({ state: n, dispatch: r }) => {
    if (n.readOnly) return !1;
    let i = e(t, n);
    return i ? (r(n.update(i)), !0) : !1;
  };
}
var RN = LN(KN, 0),
  zN = LN(GN, 0),
  BN = LN((e, t) => GN(e, t, WN(t)), 0);
function VN(e, t) {
  let n = e.languageDataAt(`commentTokens`, t, 1);
  return n.length ? n[0] : {};
}
var HN = 50;
function UN(e, { open: t, close: n }, r, i) {
  let a = e.sliceDoc(r - HN, r),
    o = e.sliceDoc(i, i + HN),
    s = /\s*$/.exec(a)[0].length,
    c = /^\s*/.exec(o)[0].length,
    l = a.length - s;
  if (a.slice(l - t.length, l) == t && o.slice(c, c + n.length) == n)
    return {
      open: {
        pos: r - s,
        margin: s && 1,
      },
      close: {
        pos: i + c,
        margin: c && 1,
      },
    };
  let u, d;
  i - r <= 2 * HN
    ? (u = d = e.sliceDoc(r, i))
    : ((u = e.sliceDoc(r, r + HN)), (d = e.sliceDoc(i - HN, i)));
  let f = /^\s*/.exec(u)[0].length,
    p = /\s*$/.exec(d)[0].length,
    m = d.length - p - n.length;
  return u.slice(f, f + t.length) == t && d.slice(m, m + n.length) == n
    ? {
        open: {
          pos: r + f + t.length,
          margin: +!!/\s/.test(u.charAt(f + t.length)),
        },
        close: {
          pos: i - p - n.length,
          margin: +!!/\s/.test(d.charAt(m - 1)),
        },
      }
    : null;
}
function WN(e) {
  let t = [];
  for (let n of e.selection.ranges) {
    let r = e.doc.lineAt(n.from),
      i = n.to <= r.to ? r : e.doc.lineAt(n.to);
    i.from > r.from && i.from == n.to && (i = n.to == r.to + 1 ? r : e.doc.lineAt(n.to - 1));
    let a = t.length - 1;
    a >= 0 && t[a].to > r.from
      ? (t[a].to = i.to)
      : t.push({
          from: r.from + /^\s*/.exec(r.text)[0].length,
          to: i.to,
        });
  }
  return t;
}
function GN(e, t, n = t.selection.ranges) {
  let r = n.map((e) => VN(t, e.from).block);
  if (!r.every((e) => e)) return null;
  let i = n.map((e, n) => UN(t, r[n], e.from, e.to));
  if (e != 2 && !i.every((e) => e))
    return {
      changes: t.changes(
        n.map((e, t) =>
          i[t]
            ? []
            : [
                {
                  from: e.from,
                  insert: r[t].open + ` `,
                },
                {
                  from: e.to,
                  insert: ` ` + r[t].close,
                },
              ],
        ),
      ),
    };
  if (e != 1 && i.some((e) => e)) {
    let e = [];
    for (let t = 0, n; t < i.length; t++)
      if ((n = i[t])) {
        let i = r[t],
          { open: a, close: o } = n;
        e.push(
          {
            from: a.pos - i.open.length,
            to: a.pos + a.margin,
          },
          {
            from: o.pos - o.margin,
            to: o.pos + i.close.length,
          },
        );
      }
    return {
      changes: e,
    };
  }
  return null;
}
function KN(e, t, n = t.selection.ranges) {
  let r = [],
    i = -1;
  ranges: for (let { from: e, to: a } of n) {
    let n = r.length,
      o = 1e9,
      s;
    for (let n = e; n <= a;) {
      let c = t.doc.lineAt(n);
      if (s == null && ((s = VN(t, c.from).line), !s)) continue ranges;
      if (c.from > i && (e == a || a > c.from)) {
        i = c.from;
        let e = /^\s*/.exec(c.text)[0].length,
          t = e == c.length,
          n = c.text.slice(e, e + s.length) == s ? e : -1;
        (e < c.text.length && e < o && (o = e),
          r.push({
            line: c,
            comment: n,
            token: s,
            indent: e,
            empty: t,
            single: !1,
          }));
      }
      n = c.to + 1;
    }
    if (o < 1e9)
      for (let e = n; e < r.length; e++) r[e].indent < r[e].line.text.length && (r[e].indent = o);
    r.length == n + 1 && (r[n].single = !0);
  }
  if (e != 2 && r.some((e) => e.comment < 0 && (!e.empty || e.single))) {
    let e = [];
    for (let { line: t, token: n, indent: i, empty: a, single: o } of r)
      (o || !a) &&
        e.push({
          from: t.from + i,
          insert: n + ` `,
        });
    let n = t.changes(e);
    return {
      changes: n,
      selection: t.selection.map(n, 1),
    };
  } else if (e != 1 && r.some((e) => e.comment >= 0)) {
    let e = [];
    for (let { line: t, comment: n, token: i } of r)
      if (n >= 0) {
        let r = t.from + n,
          a = r + i.length;
        (t.text[a - t.from] == ` ` && a++,
          e.push({
            from: r,
            to: a,
          }));
      }
    return {
      changes: e,
    };
  }
  return null;
}
var qN = Jt.define(),
  JN = Jt.define(),
  YN = zt.define(),
  XN = zt.define({
    combine(e) {
      return xt(
        e,
        {
          minDepth: 100,
          newGroupDelay: 500,
          joinToEvent: (e, t) => t,
        },
        {
          minDepth: Math.max,
          newGroupDelay: Math.min,
          joinToEvent: (e, t) => (n, r) => e(n, r) || t(n, r),
        },
      );
    },
  }),
  ZN = jt.define({
    create() {
      return gP.empty;
    },
    update(e, t) {
      let n = t.state.facet(XN),
        r = t.annotation(qN);
      if (r) {
        let i = iP.fromTransaction(t, r.selection),
          a = r.side,
          o = a == 0 ? e.undone : e.done;
        return (
          (o = i ? aP(o, o.length, n.minDepth, i) : dP(o, t.startState.selection)),
          new gP(a == 0 ? r.rest : o, a == 0 ? o : r.rest)
        );
      }
      let i = t.annotation(JN);
      if (
        ((i == `full` || i == `before`) && (e = e.isolate()), t.annotation(wn.addToHistory) === !1)
      )
        return t.changes.empty ? e : e.addMapping(t.changes.desc);
      let a = iP.fromTransaction(t),
        o = t.annotation(wn.time),
        s = t.annotation(wn.userEvent);
      return (
        a
          ? (e = e.addChanges(a, o, s, n, t))
          : t.selection && (e = e.addSelection(t.startState.selection, o, s, n.newGroupDelay)),
        (i == `full` || i == `after`) && (e = e.isolate()),
        e
      );
    },
    toJSON(e) {
      return {
        done: e.done.map((e) => e.toJSON()),
        undone: e.undone.map((e) => e.toJSON()),
      };
    },
    fromJSON(e) {
      return new gP(e.done.map(iP.fromJSON), e.undone.map(iP.fromJSON));
    },
  });
function QN(e = {}) {
  return [
    ZN,
    XN.of(e),
    Et.domEventHandlers({
      beforeinput(e, t) {
        let n = e.inputType == `historyUndo` ? eP : e.inputType == `historyRedo` ? tP : null;
        return n ? (e.preventDefault(), n(t)) : !1;
      },
    }),
  ];
}
function $N(e, t) {
  return function ({ state: n, dispatch: r }) {
    if (!t && n.readOnly) return !1;
    let i = n.field(ZN, !1);
    if (!i) return !1;
    let a = i.pop(e, n, t);
    return a ? (r(a), !0) : !1;
  };
}
var eP = $N(0, !1),
  tP = $N(1, !1),
  nP = $N(0, !0),
  rP = $N(1, !0),
  iP = class e {
    constructor(e, t, n, r, i) {
      ((this.changes = e),
        (this.effects = t),
        (this.mapped = n),
        (this.startSelection = r),
        (this.selectionsAfter = i));
    }
    setSelAfter(t) {
      return new e(this.changes, this.effects, this.mapped, this.startSelection, t);
    }
    toJSON() {
      return {
        changes: this.changes?.toJSON(),
        mapped: this.mapped?.toJSON(),
        startSelection: this.startSelection?.toJSON(),
        selectionsAfter: this.selectionsAfter.map((e) => e.toJSON()),
      };
    }
    static fromJSON(t) {
      return new e(
        t.changes && an.fromJSON(t.changes),
        [],
        t.mapped && Nt.fromJSON(t.mapped),
        t.startSelection && Qt.fromJSON(t.startSelection),
        t.selectionsAfter.map(Qt.fromJSON),
      );
    }
    static fromTransaction(t, n) {
      let r = lP;
      for (let e of t.startState.facet(YN)) {
        let n = e(t);
        n.length && (r = r.concat(n));
      }
      return !r.length && t.changes.empty
        ? null
        : new e(t.changes.invert(t.startState.doc), r, void 0, n || t.startState.selection, lP);
    }
    static selection(t) {
      return new e(void 0, lP, void 0, void 0, t);
    }
  };
function aP(e, t, n, r) {
  let i = t + 1 > n + 20 ? t - n - 1 : 0,
    a = e.slice(i, t);
  return (a.push(r), a);
}
function oP(e, t) {
  let n = [],
    r = !1;
  return (
    e.iterChangedRanges((e, t) => n.push(e, t)),
    t.iterChangedRanges((e, t, i, a) => {
      for (let e = 0; e < n.length;) {
        let t = n[e++],
          o = n[e++];
        a >= t && i <= o && (r = !0);
      }
    }),
    r
  );
}
function sP(e, t) {
  return (
    e.ranges.length == t.ranges.length &&
    e.ranges.filter((e, n) => e.empty != t.ranges[n].empty).length === 0
  );
}
function cP(e, t) {
  return e.length ? (t.length ? e.concat(t) : e) : t;
}
var lP = [],
  uP = 200;
function dP(e, t) {
  if (e.length) {
    let n = e[e.length - 1],
      r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - uP));
    return r.length && r[r.length - 1].eq(t)
      ? e
      : (r.push(t), aP(e, e.length - 1, 1e9, n.setSelAfter(r)));
  } else return [iP.selection([t])];
}
function fP(e) {
  let t = e[e.length - 1],
    n = e.slice();
  return (
    (n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1))),
    n
  );
}
function pP(e, t) {
  if (!e.length) return e;
  let n = e.length,
    r = lP;
  for (; n;) {
    let i = mP(e[n - 1], t, r);
    if ((i.changes && !i.changes.empty) || i.effects.length) {
      let t = e.slice(0, n);
      return ((t[n - 1] = i), t);
    } else ((t = i.mapped), n--, (r = i.selectionsAfter));
  }
  return r.length ? [iP.selection(r)] : lP;
}
function mP(e, t, n) {
  let r = cP(e.selectionsAfter.length ? e.selectionsAfter.map((e) => e.map(t)) : lP, n);
  if (!e.changes) return iP.selection(r);
  let i = e.changes.map(t),
    a = t.mapDesc(e.changes, !0),
    o = e.mapped ? e.mapped.composeDesc(a) : a;
  return new iP(i, Wt.mapEffects(e.effects, t), o, e.startSelection.map(a), r);
}
var hP = /^(input\.type|delete)($|\.)/,
  gP = class e {
    constructor(e, t, n = 0, r = void 0) {
      ((this.done = e), (this.undone = t), (this.prevTime = n), (this.prevUserEvent = r));
    }
    isolate() {
      return this.prevTime ? new e(this.done, this.undone) : this;
    }
    addChanges(t, n, r, i, a) {
      let o = this.done,
        s = o[o.length - 1];
      return (
        (o =
          s &&
          s.changes &&
          !s.changes.empty &&
          t.changes &&
          (!r || hP.test(r)) &&
          ((!s.selectionsAfter.length &&
            n - this.prevTime < i.newGroupDelay &&
            i.joinToEvent(a, oP(s.changes, t.changes))) ||
            r == `input.type.compose`)
            ? aP(
                o,
                o.length - 1,
                i.minDepth,
                new iP(
                  t.changes.compose(s.changes),
                  cP(Wt.mapEffects(t.effects, s.changes), s.effects),
                  s.mapped,
                  s.startSelection,
                  lP,
                ),
              )
            : aP(o, o.length, i.minDepth, t)),
        new e(o, lP, n, r)
      );
    }
    addSelection(t, n, r, i) {
      let a = this.done.length ? this.done[this.done.length - 1].selectionsAfter : lP;
      return a.length > 0 &&
        n - this.prevTime < i &&
        r == this.prevUserEvent &&
        r &&
        /^select($|\.)/.test(r) &&
        sP(a[a.length - 1], t)
        ? this
        : new e(dP(this.done, t), this.undone, n, r);
    }
    addMapping(t) {
      return new e(pP(this.done, t), pP(this.undone, t), this.prevTime, this.prevUserEvent);
    }
    pop(e, t, n) {
      let r = e == 0 ? this.done : this.undone;
      if (r.length == 0) return null;
      let i = r[r.length - 1],
        a =
          i.selectionsAfter[0] ||
          (i.startSelection ? i.startSelection.map(i.changes.invertedDesc, 1) : t.selection);
      if (n && i.selectionsAfter.length)
        return t.update({
          selection: i.selectionsAfter[i.selectionsAfter.length - 1],
          annotations: qN.of({
            side: e,
            rest: fP(r),
            selection: a,
          }),
          userEvent: e == 0 ? `select.undo` : `select.redo`,
          scrollIntoView: !0,
        });
      if (i.changes) {
        let n = r.length == 1 ? lP : r.slice(0, r.length - 1);
        return (
          i.mapped && (n = pP(n, i.mapped)),
          t.update({
            changes: i.changes,
            selection: i.startSelection,
            effects: i.effects,
            annotations: qN.of({
              side: e,
              rest: n,
              selection: a,
            }),
            filter: !1,
            userEvent: e == 0 ? `undo` : `redo`,
            scrollIntoView: !0,
          })
        );
      } else return null;
    }
  };
gP.empty = new gP(lP, lP);
var _P = [
  {
    key: `Mod-z`,
    run: eP,
    preventDefault: !0,
  },
  {
    key: `Mod-y`,
    mac: `Mod-Shift-z`,
    run: tP,
    preventDefault: !0,
  },
  {
    linux: `Ctrl-Shift-z`,
    run: tP,
    preventDefault: !0,
  },
  {
    key: `Mod-u`,
    run: nP,
    preventDefault: !0,
  },
  {
    key: `Alt-u`,
    mac: `Mod-Shift-u`,
    run: rP,
    preventDefault: !0,
  },
];
function vP(e, t) {
  return Qt.create(e.ranges.map(t), e.mainIndex);
}
function yP(e, t) {
  return e.update({
    selection: t,
    scrollIntoView: !0,
    userEvent: `select`,
  });
}
function bP({ state: e, dispatch: t }, n) {
  let r = vP(e.selection, n);
  return r.eq(e.selection, !0) ? !1 : (t(yP(e, r)), !0);
}
function xP(e, t) {
  return Qt.cursor(t ? e.to : e.from);
}
function SP(e, t) {
  return bP(e, (n) => (n.empty ? e.moveByChar(n, t) : xP(n, t)));
}
function CP(e) {
  return e.textDirectionAt(e.state.selection.main.head) == wt.LTR;
}
var wP = (e) => SP(e, !CP(e)),
  TP = (e) => SP(e, CP(e));
function EP(e, t) {
  return bP(e, (n) => (n.empty ? e.moveByGroup(n, t) : xP(n, t)));
}
var DP = (e) => EP(e, !CP(e)),
  OP = (e) => EP(e, CP(e));
typeof Intl < `u` && Intl.Segmenter;
function kP(e, t, n) {
  if (t.type.prop(n)) return !0;
  let r = t.to - t.from;
  return (r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to)))) || t.firstChild;
}
function AP(e, t, n) {
  let r = nt(e).resolveInner(t.head),
    i = n ? ct.closedBy : ct.openedBy;
  for (let a = t.head; ;) {
    let t = n ? r.childAfter(a) : r.childBefore(a);
    if (!t) break;
    kP(e, t, i) ? (r = t) : (a = n ? t.to : t.from);
  }
  let a = r.type.prop(i),
    o,
    s;
  return (
    (s =
      a && (o = n ? ot(e, r.from, 1) : ot(e, r.to, -1)) && o.matched
        ? n
          ? o.end.to
          : o.end.from
        : n
          ? r.to
          : r.from),
    Qt.cursor(s, n ? -1 : 1)
  );
}
var jP = (e) => bP(e, (t) => AP(e.state, t, !CP(e))),
  MP = (e) => bP(e, (t) => AP(e.state, t, CP(e)));
function NP(e, t) {
  return bP(e, (n) => {
    if (!n.empty) return xP(n, t);
    let r = e.moveVertically(n, t);
    return r.head == n.head ? e.moveToLineBoundary(n, t) : r;
  });
}
var PP = (e) => NP(e, !1),
  FP = (e) => NP(e, !0);
function IP(e) {
  let t = e.scrollDOM.clientHeight < e.scrollDOM.scrollHeight - 2,
    n = 0,
    r = 0,
    i;
  if (t) {
    for (let t of e.state.facet(Et.scrollMargins)) {
      let i = t(e);
      (i?.top && (n = Math.max(i?.top, n)), i?.bottom && (r = Math.max(i?.bottom, r)));
    }
    i = e.scrollDOM.clientHeight - n - r;
  } else i = (e.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: n,
    marginBottom: r,
    selfScroll: t,
    height: Math.max(e.defaultLineHeight, i - 5),
  };
}
function LP(e, t) {
  let n = IP(e),
    { state: r } = e,
    i = vP(r.selection, (r) => (r.empty ? e.moveVertically(r, t, n.height) : xP(r, t)));
  if (i.eq(r.selection)) return !1;
  let a;
  if (n.selfScroll) {
    let t = e.coordsAtPos(r.selection.main.head),
      o = e.scrollDOM.getBoundingClientRect(),
      s = o.top + n.marginTop,
      c = o.bottom - n.marginBottom;
    t &&
      t.top > s &&
      t.bottom < c &&
      (a = Et.scrollIntoView(i.main.head, {
        y: `start`,
        yMargin: t.top - s,
      }));
  }
  return (
    e.dispatch(yP(r, i), {
      effects: a,
    }),
    !0
  );
}
var RP = (e) => LP(e, !1),
  zP = (e) => LP(e, !0);
function BP(e, t, n) {
  let r = e.lineBlockAt(t.head),
    i = e.moveToLineBoundary(t, n);
  if (
    (i.head == t.head && i.head != (n ? r.to : r.from) && (i = e.moveToLineBoundary(t, n, !1)),
    !n && i.head == r.from && r.length)
  ) {
    let n = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    n && t.head != r.from + n && (i = Qt.cursor(r.from + n));
  }
  return i;
}
var VP = (e) => bP(e, (t) => BP(e, t, !0)),
  HP = (e) => bP(e, (t) => BP(e, t, !1)),
  UP = (e) => bP(e, (t) => BP(e, t, !CP(e))),
  WP = (e) => bP(e, (t) => BP(e, t, CP(e))),
  GP = (e) => bP(e, (t) => Qt.cursor(e.lineBlockAt(t.head).from, 1)),
  KP = (e) => bP(e, (t) => Qt.cursor(e.lineBlockAt(t.head).to, -1));
function qP(e, t, n) {
  let r = !1,
    i = vP(e.selection, (t) => {
      let i =
        ot(e, t.head, -1) ||
        ot(e, t.head, 1) ||
        (t.head > 0 && ot(e, t.head - 1, 1)) ||
        (t.head < e.doc.length && ot(e, t.head + 1, -1));
      if (!i || !i.end) return t;
      r = !0;
      let a = i.start.from == t.head ? i.end.to : i.end.from;
      return n ? Qt.range(t.anchor, a) : Qt.cursor(a);
    });
  return r ? (t(yP(e, i)), !0) : !1;
}
var JP = ({ state: e, dispatch: t }) => qP(e, t, !1);
function YP(e, t) {
  let n = vP(e.state.selection, (e) => {
    let n = t(e);
    return Qt.range(e.anchor, n.head, n.goalColumn, n.bidiLevel || void 0, n.assoc);
  });
  return n.eq(e.state.selection) ? !1 : (e.dispatch(yP(e.state, n)), !0);
}
function XP(e, t) {
  return YP(e, (n) => e.moveByChar(n, t));
}
var ZP = (e) => XP(e, !CP(e)),
  QP = (e) => XP(e, CP(e));
function $P(e, t) {
  return YP(e, (n) => e.moveByGroup(n, t));
}
var eF = (e) => $P(e, !CP(e)),
  tF = (e) => $P(e, CP(e)),
  nF = (e) => YP(e, (t) => AP(e.state, t, !CP(e))),
  rF = (e) => YP(e, (t) => AP(e.state, t, CP(e)));
function iF(e, t) {
  return YP(e, (n) => e.moveVertically(n, t));
}
var aF = (e) => iF(e, !1),
  oF = (e) => iF(e, !0);
function sF(e, t) {
  return YP(e, (n) => e.moveVertically(n, t, IP(e).height));
}
var cF = (e) => sF(e, !1),
  lF = (e) => sF(e, !0),
  uF = (e) => YP(e, (t) => BP(e, t, !0)),
  dF = (e) => YP(e, (t) => BP(e, t, !1)),
  fF = (e) => YP(e, (t) => BP(e, t, !CP(e))),
  pF = (e) => YP(e, (t) => BP(e, t, CP(e))),
  mF = (e) => YP(e, (t) => Qt.cursor(e.lineBlockAt(t.head).from)),
  hF = (e) => YP(e, (t) => Qt.cursor(e.lineBlockAt(t.head).to)),
  gF = ({ state: e, dispatch: t }) => (
    t(
      yP(e, {
        anchor: 0,
      }),
    ),
    !0
  ),
  _F = ({ state: e, dispatch: t }) => (
    t(
      yP(e, {
        anchor: e.doc.length,
      }),
    ),
    !0
  ),
  vF = ({ state: e, dispatch: t }) => (
    t(
      yP(e, {
        anchor: e.selection.main.anchor,
        head: 0,
      }),
    ),
    !0
  ),
  yF = ({ state: e, dispatch: t }) => (
    t(
      yP(e, {
        anchor: e.selection.main.anchor,
        head: e.doc.length,
      }),
    ),
    !0
  ),
  bF = ({ state: e, dispatch: t }) => (
    t(
      e.update({
        selection: {
          anchor: 0,
          head: e.doc.length,
        },
        userEvent: `select`,
      }),
    ),
    !0
  ),
  xF = ({ state: e, dispatch: t }) => {
    let n = BF(e).map(({ from: t, to: n }) => Qt.range(t, Math.min(n + 1, e.doc.length)));
    return (
      t(
        e.update({
          selection: Qt.create(n),
          userEvent: `select`,
        }),
      ),
      !0
    );
  },
  SF = ({ state: e, dispatch: t }) => {
    let n = vP(e.selection, (t) => {
      let n = nt(e),
        r = n.resolveStack(t.from, 1);
      if (t.empty) {
        let e = n.resolveStack(t.from, -1);
        e.node.from >= r.node.from && e.node.to <= r.node.to && (r = e);
      }
      for (let e = r; e; e = e.next) {
        let { node: n } = e;
        if (((n.from < t.from && n.to >= t.to) || (n.to > t.to && n.from <= t.from)) && e.next)
          return Qt.range(n.to, n.from);
      }
      return t;
    });
    return n.eq(e.selection) ? !1 : (t(yP(e, n)), !0);
  };
function CF(e, t) {
  let { state: n } = e,
    r = n.selection,
    i = n.selection.ranges.slice();
  for (let r of n.selection.ranges) {
    let a = n.doc.lineAt(r.head);
    if (t ? a.to < e.state.doc.length : a.from > 0)
      for (let n = r; ;) {
        let r = e.moveVertically(n, t);
        if (r.head < a.from || r.head > a.to) {
          i.some((e) => e.head == r.head) || i.push(r);
          break;
        } else if (r.head == n.head) break;
        else n = r;
      }
  }
  return i.length == r.ranges.length ? !1 : (e.dispatch(yP(n, Qt.create(i, i.length - 1))), !0);
}
var wF = (e) => CF(e, !1),
  TF = (e) => CF(e, !0),
  EF = ({ state: e, dispatch: t }) => {
    let n = e.selection,
      r = null;
    return (
      n.ranges.length > 1
        ? (r = Qt.create([n.main]))
        : n.main.empty || (r = Qt.create([Qt.cursor(n.main.head)])),
      r ? (t(yP(e, r)), !0) : !1
    );
  };
function DF(e, t) {
  if (e.state.readOnly) return !1;
  let n = `delete.selection`,
    { state: r } = e,
    i = r.changeByRange((r) => {
      let { from: i, to: a } = r;
      if (i == a) {
        let o = t(r);
        (o < i
          ? ((n = `delete.backward`), (o = OF(e, o, !1)))
          : o > i && ((n = `delete.forward`), (o = OF(e, o, !0))),
          (i = Math.min(i, o)),
          (a = Math.max(a, o)));
      } else ((i = OF(e, i, !1)), (a = OF(e, a, !0)));
      return i == a
        ? {
            range: r,
          }
        : {
            changes: {
              from: i,
              to: a,
            },
            range: Qt.cursor(i, i < r.head ? -1 : 1),
          };
    });
  return i.changes.empty
    ? !1
    : (e.dispatch(
        r.update(i, {
          scrollIntoView: !0,
          userEvent: n,
          effects: n == `delete.selection` ? Et.announce.of(r.phrase(`Selection deleted`)) : void 0,
        }),
      ),
      !0);
}
function OF(e, t, n) {
  if (e instanceof Et)
    for (let r of e.state.facet(Et.atomicRanges).map((t) => t(e)))
      r.between(t, t, (e, r) => {
        e < t && r > t && (t = n ? r : e);
      });
  return t;
}
var kF = (e, t, n) =>
    DF(e, (r) => {
      let i = r.from,
        { state: a } = e,
        o = a.doc.lineAt(i),
        s,
        c;
      if (
        n &&
        !t &&
        i > o.from &&
        i < o.from + 200 &&
        !/[^ \t]/.test((s = o.text.slice(0, i - o.from)))
      ) {
        if (s[s.length - 1] == `	`) return i - 1;
        let e = at(s, a.tabSize) % xn(a) || xn(a);
        for (let t = 0; t < e && s[s.length - 1 - t] == ` `; t++) i--;
        c = i;
      } else
        ((c = bn(o.text, i - o.from, t, t) + o.from),
          c == i && o.number != (t ? a.doc.lines : 1)
            ? (c += t ? 1 : -1)
            : !t &&
              /[\ufe00-\ufe0f]/.test(o.text.slice(c - o.from, i - o.from)) &&
              (c = bn(o.text, c - o.from, !1, !1) + o.from));
      return c;
    }),
  AF = (e) => kF(e, !1, !0),
  jF = (e) => kF(e, !0, !1),
  MF = (e, t) =>
    DF(e, (n) => {
      let r = n.head,
        { state: i } = e,
        a = i.doc.lineAt(r),
        o = i.charCategorizer(r);
      for (let e = null; ;) {
        if (r == (t ? a.to : a.from)) {
          r == n.head && a.number != (t ? i.doc.lines : 1) && (r += t ? 1 : -1);
          break;
        }
        let s = bn(a.text, r - a.from, t) + a.from,
          c = a.text.slice(Math.min(r, s) - a.from, Math.max(r, s) - a.from),
          l = o(c);
        if (e != null && l != e) break;
        ((c != ` ` || r != n.head) && (e = l), (r = s));
      }
      return r;
    }),
  NF = (e) => MF(e, !1),
  PF = (e) => MF(e, !0),
  FF = (e) =>
    DF(e, (t) => {
      let n = e.lineBlockAt(t.head).to;
      return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
    }),
  IF = (e) =>
    DF(e, (t) => {
      let n = e.moveToLineBoundary(t, !1).head;
      return t.head > n ? n : Math.max(0, t.head - 1);
    }),
  LF = (e) =>
    DF(e, (t) => {
      let n = e.moveToLineBoundary(t, !0).head;
      return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
    }),
  RF = ({ state: e, dispatch: t }) => {
    if (e.readOnly) return !1;
    let n = e.changeByRange((e) => ({
      changes: {
        from: e.from,
        to: e.to,
        insert: vn.of([``, ``]),
      },
      range: Qt.cursor(e.from),
    }));
    return (
      t(
        e.update(n, {
          scrollIntoView: !0,
          userEvent: `input`,
        }),
      ),
      !0
    );
  },
  zF = ({ state: e, dispatch: t }) => {
    if (e.readOnly) return !1;
    let n = e.changeByRange((t) => {
      if (!t.empty || t.from == 0 || t.from == e.doc.length)
        return {
          range: t,
        };
      let n = t.from,
        r = e.doc.lineAt(n),
        i = n == r.from ? n - 1 : bn(r.text, n - r.from, !1) + r.from,
        a = n == r.to ? n + 1 : bn(r.text, n - r.from, !0) + r.from;
      return {
        changes: {
          from: i,
          to: a,
          insert: e.doc.slice(n, a).append(e.doc.slice(i, n)),
        },
        range: Qt.cursor(a),
      };
    });
    return n.changes.empty
      ? !1
      : (t(
          e.update(n, {
            scrollIntoView: !0,
            userEvent: `move.character`,
          }),
        ),
        !0);
  };
function BF(e) {
  let t = [],
    n = -1;
  for (let r of e.selection.ranges) {
    let i = e.doc.lineAt(r.from),
      a = e.doc.lineAt(r.to);
    if ((!r.empty && r.to == a.from && (a = e.doc.lineAt(r.to - 1)), n >= i.number)) {
      let e = t[t.length - 1];
      ((e.to = a.to), e.ranges.push(r));
    } else
      t.push({
        from: i.from,
        to: a.to,
        ranges: [r],
      });
    n = a.number + 1;
  }
  return t;
}
function VF(e, t, n) {
  if (e.readOnly) return !1;
  let r = [],
    i = [];
  for (let t of BF(e)) {
    if (n ? t.to == e.doc.length : t.from == 0) continue;
    let a = e.doc.lineAt(n ? t.to + 1 : t.from - 1),
      o = a.length + 1;
    if (n) {
      r.push(
        {
          from: t.to,
          to: a.to,
        },
        {
          from: t.from,
          insert: a.text + e.lineBreak,
        },
      );
      for (let n of t.ranges)
        i.push(Qt.range(Math.min(e.doc.length, n.anchor + o), Math.min(e.doc.length, n.head + o)));
    } else {
      r.push(
        {
          from: a.from,
          to: t.from,
        },
        {
          from: t.to,
          insert: e.lineBreak + a.text,
        },
      );
      for (let e of t.ranges) i.push(Qt.range(e.anchor - o, e.head - o));
    }
  }
  return r.length
    ? (t(
        e.update({
          changes: r,
          scrollIntoView: !0,
          selection: Qt.create(i, e.selection.mainIndex),
          userEvent: `move.line`,
        }),
      ),
      !0)
    : !1;
}
var HF = ({ state: e, dispatch: t }) => VF(e, t, !1),
  UF = ({ state: e, dispatch: t }) => VF(e, t, !0);
function WF(e, t, n) {
  if (e.readOnly) return !1;
  let r = [];
  for (let t of BF(e))
    n
      ? r.push({
          from: t.from,
          insert: e.doc.slice(t.from, t.to) + e.lineBreak,
        })
      : r.push({
          from: t.to,
          insert: e.lineBreak + e.doc.slice(t.from, t.to),
        });
  let i = e.changes(r);
  return (
    t(
      e.update({
        changes: i,
        selection: e.selection.map(i, n ? 1 : -1),
        scrollIntoView: !0,
        userEvent: `input.copyline`,
      }),
    ),
    !0
  );
}
var GF = ({ state: e, dispatch: t }) => WF(e, t, !1),
  KF = ({ state: e, dispatch: t }) => WF(e, t, !0),
  qF = (e) => {
    if (e.state.readOnly) return !1;
    let { state: t } = e,
      n = t.changes(
        BF(t).map(
          ({ from: e, to: n }) => (
            e > 0 ? e-- : n < t.doc.length && n++,
            {
              from: e,
              to: n,
            }
          ),
        ),
      ),
      r = vP(t.selection, (t) => {
        let n;
        if (e.lineWrapping) {
          let r = e.lineBlockAt(t.head),
            i = e.coordsAtPos(t.head, t.assoc || 1);
          i && (n = r.bottom + e.documentTop - i.bottom + e.defaultLineHeight / 2);
        }
        return e.moveVertically(t, !0, n);
      }).map(n);
    return (
      e.dispatch({
        changes: n,
        selection: r,
        scrollIntoView: !0,
        userEvent: `delete.line`,
      }),
      !0
    );
  };
function JF(e, t) {
  if (/\(\)|\[\]|\{\}/.test(e.sliceDoc(t - 1, t + 1)))
    return {
      from: t,
      to: t,
    };
  let n = nt(e).resolveInner(t),
    r = n.childBefore(t),
    i = n.childAfter(t),
    a;
  return r &&
    i &&
    r.to <= t &&
    i.from >= t &&
    (a = r.type.prop(ct.closedBy)) &&
    a.indexOf(i.name) > -1 &&
    e.doc.lineAt(r.to).from == e.doc.lineAt(i.from).from &&
    !/\S/.test(e.sliceDoc(r.to, i.from))
    ? {
        from: r.to,
        to: i.from,
      }
    : null;
}
var YF = ZF(!1),
  XF = ZF(!0);
function ZF(e) {
  return ({ state: t, dispatch: n }) => {
    if (t.readOnly) return !1;
    let r = t.changeByRange((n) => {
      let { from: r, to: i } = n,
        a = t.doc.lineAt(r),
        o = !e && r == i && JF(t, r);
      e && (r = i = (i <= a.to ? a : t.doc.lineAt(i)).to);
      let s = new rn(t, {
          simulateBreak: r,
          simulateDoubleBreak: !!o,
        }),
        c = bt(s, r);
      for (
        c ??= at(/^\s*/.exec(t.doc.lineAt(r).text)[0], t.tabSize);
        i < a.to && /\s/.test(a.text[i - a.from]);
      )
        i++;
      o
        ? ({ from: r, to: i } = o)
        : r > a.from && r < a.from + 100 && !/\S/.test(a.text.slice(0, r)) && (r = a.from);
      let l = [``, yn(t, c)];
      return (
        o && l.push(yn(t, s.lineIndent(a.from, -1))),
        {
          changes: {
            from: r,
            to: i,
            insert: vn.of(l),
          },
          range: Qt.cursor(r + 1 + l[1].length),
        }
      );
    });
    return (
      n(
        t.update(r, {
          scrollIntoView: !0,
          userEvent: `input`,
        }),
      ),
      !0
    );
  };
}
function QF(e, t) {
  let n = -1;
  return e.changeByRange((r) => {
    let i = [];
    for (let a = r.from; a <= r.to;) {
      let o = e.doc.lineAt(a);
      (o.number > n && (r.empty || r.to > o.from) && (t(o, i, r), (n = o.number)), (a = o.to + 1));
    }
    let a = e.changes(i);
    return {
      changes: i,
      range: Qt.range(a.mapPos(r.anchor, 1), a.mapPos(r.head, 1)),
    };
  });
}
var $F = ({ state: e, dispatch: t }) => {
    if (e.readOnly) return !1;
    let n = Object.create(null),
      r = new rn(e, {
        overrideIndentation: (e) => n[e] ?? -1,
      }),
      i = QF(e, (t, i, a) => {
        let o = bt(r, t.from);
        if (o == null) return;
        /\S/.test(t.text) || (o = 0);
        let s = /^\s*/.exec(t.text)[0],
          c = yn(e, o);
        (s != c || a.from < t.from + s.length) &&
          ((n[t.from] = o),
          i.push({
            from: t.from,
            to: t.from + s.length,
            insert: c,
          }));
      });
    return (
      i.changes.empty ||
        t(
          e.update(i, {
            userEvent: `indent`,
          }),
        ),
      !0
    );
  },
  eI = ({ state: e, dispatch: t }) =>
    e.readOnly
      ? !1
      : (t(
          e.update(
            QF(e, (t, n) => {
              n.push({
                from: t.from,
                insert: e.facet(St),
              });
            }),
            {
              userEvent: `input.indent`,
            },
          ),
        ),
        !0),
  tI = ({ state: e, dispatch: t }) =>
    e.readOnly
      ? !1
      : (t(
          e.update(
            QF(e, (t, n) => {
              let r = /^\s*/.exec(t.text)[0];
              if (!r) return;
              let i = at(r, e.tabSize),
                a = 0,
                o = yn(e, Math.max(0, i - xn(e)));
              for (; a < r.length && a < o.length && r.charCodeAt(a) == o.charCodeAt(a);) a++;
              n.push({
                from: t.from + a,
                to: t.from + r.length,
                insert: o.slice(a),
              });
            }),
            {
              userEvent: `delete.dedent`,
            },
          ),
        ),
        !0),
  nI = (e) => (e.setTabFocusMode(), !0),
  rI = [
    {
      key: `Ctrl-b`,
      run: wP,
      shift: ZP,
      preventDefault: !0,
    },
    {
      key: `Ctrl-f`,
      run: TP,
      shift: QP,
    },
    {
      key: `Ctrl-p`,
      run: PP,
      shift: aF,
    },
    {
      key: `Ctrl-n`,
      run: FP,
      shift: oF,
    },
    {
      key: `Ctrl-a`,
      run: GP,
      shift: mF,
    },
    {
      key: `Ctrl-e`,
      run: KP,
      shift: hF,
    },
    {
      key: `Ctrl-d`,
      run: jF,
    },
    {
      key: `Ctrl-h`,
      run: AF,
    },
    {
      key: `Ctrl-k`,
      run: FF,
    },
    {
      key: `Ctrl-Alt-h`,
      run: NF,
    },
    {
      key: `Ctrl-o`,
      run: RF,
    },
    {
      key: `Ctrl-t`,
      run: zF,
    },
    {
      key: `Ctrl-v`,
      run: zP,
    },
  ],
  iI = [
    {
      key: `ArrowLeft`,
      run: wP,
      shift: ZP,
      preventDefault: !0,
    },
    {
      key: `Mod-ArrowLeft`,
      mac: `Alt-ArrowLeft`,
      run: DP,
      shift: eF,
      preventDefault: !0,
    },
    {
      mac: `Cmd-ArrowLeft`,
      run: UP,
      shift: fF,
      preventDefault: !0,
    },
    {
      key: `ArrowRight`,
      run: TP,
      shift: QP,
      preventDefault: !0,
    },
    {
      key: `Mod-ArrowRight`,
      mac: `Alt-ArrowRight`,
      run: OP,
      shift: tF,
      preventDefault: !0,
    },
    {
      mac: `Cmd-ArrowRight`,
      run: WP,
      shift: pF,
      preventDefault: !0,
    },
    {
      key: `ArrowUp`,
      run: PP,
      shift: aF,
      preventDefault: !0,
    },
    {
      mac: `Cmd-ArrowUp`,
      run: gF,
      shift: vF,
    },
    {
      mac: `Ctrl-ArrowUp`,
      run: RP,
      shift: cF,
    },
    {
      key: `ArrowDown`,
      run: FP,
      shift: oF,
      preventDefault: !0,
    },
    {
      mac: `Cmd-ArrowDown`,
      run: _F,
      shift: yF,
    },
    {
      mac: `Ctrl-ArrowDown`,
      run: zP,
      shift: lF,
    },
    {
      key: `PageUp`,
      run: RP,
      shift: cF,
    },
    {
      key: `PageDown`,
      run: zP,
      shift: lF,
    },
    {
      key: `Home`,
      run: HP,
      shift: dF,
      preventDefault: !0,
    },
    {
      key: `Mod-Home`,
      run: gF,
      shift: vF,
    },
    {
      key: `End`,
      run: VP,
      shift: uF,
      preventDefault: !0,
    },
    {
      key: `Mod-End`,
      run: _F,
      shift: yF,
    },
    {
      key: `Enter`,
      run: YF,
      shift: YF,
    },
    {
      key: `Mod-a`,
      run: bF,
    },
    {
      key: `Backspace`,
      run: AF,
      shift: AF,
      preventDefault: !0,
    },
    {
      key: `Delete`,
      run: jF,
      preventDefault: !0,
    },
    {
      key: `Mod-Backspace`,
      mac: `Alt-Backspace`,
      run: NF,
      preventDefault: !0,
    },
    {
      key: `Mod-Delete`,
      mac: `Alt-Delete`,
      run: PF,
      preventDefault: !0,
    },
    {
      mac: `Mod-Backspace`,
      run: IF,
      preventDefault: !0,
    },
    {
      mac: `Mod-Delete`,
      run: LF,
      preventDefault: !0,
    },
  ].concat(
    rI.map((e) => ({
      mac: e.key,
      run: e.run,
      shift: e.shift,
    })),
  ),
  aI = [
    {
      key: `Alt-ArrowLeft`,
      mac: `Ctrl-ArrowLeft`,
      run: jP,
      shift: nF,
    },
    {
      key: `Alt-ArrowRight`,
      mac: `Ctrl-ArrowRight`,
      run: MP,
      shift: rF,
    },
    {
      key: `Alt-ArrowUp`,
      run: HF,
    },
    {
      key: `Shift-Alt-ArrowUp`,
      run: GF,
    },
    {
      key: `Alt-ArrowDown`,
      run: UF,
    },
    {
      key: `Shift-Alt-ArrowDown`,
      run: KF,
    },
    {
      key: `Mod-Alt-ArrowUp`,
      run: wF,
    },
    {
      key: `Mod-Alt-ArrowDown`,
      run: TF,
    },
    {
      key: `Escape`,
      run: EF,
    },
    {
      key: `Mod-Enter`,
      run: XF,
    },
    {
      key: `Alt-l`,
      mac: `Ctrl-l`,
      run: xF,
    },
    {
      key: `Mod-i`,
      run: SF,
      preventDefault: !0,
    },
    {
      key: `Mod-[`,
      run: tI,
    },
    {
      key: `Mod-]`,
      run: eI,
    },
    {
      key: `Mod-Alt-\\`,
      run: $F,
    },
    {
      key: `Shift-Mod-k`,
      run: qF,
    },
    {
      key: `Shift-Mod-\\`,
      run: JP,
    },
    {
      key: `Mod-/`,
      run: IN,
    },
    {
      key: `Alt-A`,
      run: zN,
    },
    {
      key: `Ctrl-m`,
      mac: `Shift-Alt-m`,
      run: nI,
    },
  ].concat(iI),
  oI = {
    key: `Tab`,
    run: eI,
    shift: tI,
  },
  sI = class {
    constructor(e, t, n, r) {
      ((this.state = e),
        (this.pos = t),
        (this.explicit = n),
        (this.view = r),
        (this.abortListeners = []),
        (this.abortOnDocChange = !1));
    }
    tokenBefore(e) {
      let t = nt(this.state).resolveInner(this.pos, -1);
      for (; t && e.indexOf(t.name) < 0;) t = t.parent;
      return t
        ? {
            from: t.from,
            to: this.pos,
            text: this.state.sliceDoc(t.from, this.pos),
            type: t.type,
          }
        : null;
    }
    matchBefore(e) {
      let t = this.state.doc.lineAt(this.pos),
        n = Math.max(t.from, this.pos - 250),
        r = t.text.slice(n - t.from, this.pos - t.from),
        i = r.search(mI(e, !1));
      return i < 0
        ? null
        : {
            from: n + i,
            to: this.pos,
            text: r.slice(i),
          };
    }
    get aborted() {
      return this.abortListeners == null;
    }
    addEventListener(e, t, n) {
      e == `abort` &&
        this.abortListeners &&
        (this.abortListeners.push(t), n && n.onDocChange && (this.abortOnDocChange = !0));
    }
  };
function cI(e) {
  let t = Object.keys(e).join(``),
    n = /\w/.test(t);
  return (n && (t = t.replace(/\w/g, ``)), `[${n ? `\\w` : ``}${t.replace(/[^\w\s]/g, `\\$&`)}]`);
}
function lI(e) {
  let t = Object.create(null),
    n = Object.create(null);
  for (let { label: r } of e) {
    t[r[0]] = !0;
    for (let e = 1; e < r.length; e++) n[r[e]] = !0;
  }
  let r = cI(t) + cI(n) + `*$`;
  return [RegExp(`^` + r), new RegExp(r)];
}
function uI(e) {
  let t = e.map((e) =>
      typeof e == `string`
        ? {
            label: e,
          }
        : e,
    ),
    [n, r] = t.every((e) => /^\w+$/.test(e.label)) ? [/\w*$/, /\w+$/] : lI(t);
  return (e) => {
    let i = e.matchBefore(r);
    return i || e.explicit
      ? {
          from: i ? i.from : e.pos,
          options: t,
          validFor: n,
        }
      : null;
  };
}
function dI(e, t) {
  return (n) => {
    for (let t = nt(n.state).resolveInner(n.pos, -1); t; t = t.parent) {
      if (e.indexOf(t.name) > -1) return null;
      if (t.type.isTop) break;
    }
    return t(n);
  };
}
var fI = class {
  constructor(e, t, n, r) {
    ((this.completion = e), (this.source = t), (this.match = n), (this.score = r));
  }
};
function pI(e) {
  return e.selection.main.from;
}
function mI(e, t) {
  let { source: n } = e,
    r = t && n[0] != `^`,
    i = n[n.length - 1] != `$`;
  return !r && !i
    ? e
    : RegExp(`${r ? `^` : ``}(?:${n})${i ? `$` : ``}`, e.flags ?? (e.ignoreCase ? `i` : ``));
}
var hI = Jt.define();
function gI(e, t, n, r) {
  let { main: i } = e.selection,
    a = n - i.from,
    o = r - i.from;
  return {
    ...e.changeByRange((s) => {
      if (s != i && n != r && e.sliceDoc(s.from + a, s.from + o) != e.sliceDoc(n, r))
        return {
          range: s,
        };
      let c = e.toText(t);
      return {
        changes: {
          from: s.from + a,
          to: r == i.from ? s.to : s.from + o,
          insert: c,
        },
        range: Qt.cursor(s.from + a + c.length),
      };
    }),
    scrollIntoView: !0,
    userEvent: `input.complete`,
  };
}
var _I = new WeakMap();
function vI(e) {
  if (!Array.isArray(e)) return e;
  let t = _I.get(e);
  return (t || _I.set(e, (t = uI(e))), t);
}
var yI = Wt.define(),
  bI = Wt.define(),
  xI = class {
    constructor(e) {
      ((this.pattern = e),
        (this.chars = []),
        (this.folded = []),
        (this.any = []),
        (this.precise = []),
        (this.byWord = []),
        (this.score = 0),
        (this.matched = []));
      for (let t = 0; t < e.length;) {
        let n = Ft(e, t),
          r = Sn(n);
        this.chars.push(n);
        let i = e.slice(t, t + r),
          a = i.toUpperCase();
        (this.folded.push(Ft(a == i ? i.toLowerCase() : a, 0)), (t += r));
      }
      this.astral = e.length != this.chars.length;
    }
    ret(e, t) {
      return ((this.score = e), (this.matched = t), this);
    }
    match(e) {
      if (this.pattern.length == 0) return this.ret(-100, []);
      if (e.length < this.pattern.length) return null;
      let { chars: t, folded: n, any: r, precise: i, byWord: a } = this;
      if (t.length == 1) {
        let r = Ft(e, 0),
          i = Sn(r),
          a = i == e.length ? 0 : -100;
        if (r != t[0])
          if (r == n[0]) a += -200;
          else return null;
        return this.ret(a, [0, i]);
      }
      let o = e.indexOf(this.pattern);
      if (o == 0)
        return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
      let s = t.length,
        c = 0;
      if (o < 0) {
        for (let i = 0, a = Math.min(e.length, 200); i < a && c < s;) {
          let a = Ft(e, i);
          ((a == t[c] || a == n[c]) && (r[c++] = i), (i += Sn(a)));
        }
        if (c < s) return null;
      }
      let l = 0,
        u = 0,
        d = !1,
        f = 0,
        p = -1,
        m = -1,
        h = /[a-z]/.test(e),
        g = !0;
      for (let r = 0, c = Math.min(e.length, 200), v = 0; r < c && u < s;) {
        let c = Ft(e, r);
        o < 0 &&
          (l < s && c == t[l] && (i[l++] = r),
          f < s && (c == t[f] || c == n[f] ? (f == 0 && (p = r), (m = r + 1), f++) : (f = 0)));
        let y,
          b =
            c < 255
              ? (c >= 48 && c <= 57) || (c >= 97 && c <= 122)
                ? 2
                : +(c >= 65 && c <= 90)
              : (y = Ct(c)) == y.toLowerCase()
                ? y == y.toUpperCase()
                  ? 0
                  : 2
                : 1;
        ((!r || (b == 1 && h) || (v == 0 && b != 0)) &&
          (t[u] == c || (n[u] == c && (d = !0)) ? (a[u++] = r) : a.length && (g = !1)),
          (v = b),
          (r += Sn(c)));
      }
      return u == s && a[0] == 0 && g
        ? this.result(-100 + (d ? -200 : 0), a, e)
        : f == s && p == 0
          ? this.ret(-200 - e.length + (m == e.length ? 0 : -100), [0, m])
          : o > -1
            ? this.ret(-700 - e.length, [o, o + this.pattern.length])
            : f == s
              ? this.ret(-900 - e.length, [p, m])
              : u == s
                ? this.result(-100 + (d ? -200 : 0) + -700 + (g ? 0 : -1100), a, e)
                : t.length == 2
                  ? null
                  : this.result((r[0] ? -700 : 0) + -200 + -1100, r, e);
    }
    result(e, t, n) {
      let r = [],
        i = 0;
      for (let e of t) {
        let t = e + (this.astral ? Sn(Ft(n, e)) : 1);
        i && r[i - 1] == e ? (r[i - 1] = t) : ((r[i++] = e), (r[i++] = t));
      }
      return this.ret(e - n.length, r);
    }
  },
  SI = class {
    constructor(e) {
      ((this.pattern = e), (this.matched = []), (this.score = 0), (this.folded = e.toLowerCase()));
    }
    match(e) {
      if (e.length < this.pattern.length) return null;
      let t = e.slice(0, this.pattern.length),
        n = t == this.pattern ? 0 : t.toLowerCase() == this.folded ? -200 : null;
      return n == null
        ? null
        : ((this.matched = [0, t.length]),
          (this.score = n + (e.length == this.pattern.length ? 0 : -100)),
          this);
    }
  },
  CI = zt.define({
    combine(e) {
      return xt(
        e,
        {
          activateOnTyping: !0,
          activateOnCompletion: () => !1,
          activateOnTypingDelay: 100,
          selectOnOpen: !0,
          override: null,
          closeOnBlur: !0,
          maxRenderedOptions: 100,
          defaultKeymap: !0,
          tooltipClass: () => ``,
          optionClass: () => ``,
          aboveCursor: !1,
          icons: !0,
          addToOptions: [],
          positionInfo: TI,
          filterStrict: !1,
          compareCompletions: (e, t) =>
            (e.sortText || e.label).localeCompare(t.sortText || t.label),
          interactionDelay: 75,
          updateSyncTime: 100,
        },
        {
          defaultKeymap: (e, t) => e && t,
          closeOnBlur: (e, t) => e && t,
          icons: (e, t) => e && t,
          tooltipClass: (e, t) => (n) => wI(e(n), t(n)),
          optionClass: (e, t) => (n) => wI(e(n), t(n)),
          addToOptions: (e, t) => e.concat(t),
          filterStrict: (e, t) => e || t,
        },
      );
    },
  });
function wI(e, t) {
  return e ? (t ? e + ` ` + t : e) : t;
}
function TI(e, t, n, r, i, a) {
  let o = e.textDirection == wt.RTL,
    s = o,
    c = !1,
    l = `top`,
    u,
    d,
    f = t.left - i.left,
    p = i.right - t.right,
    m = r.right - r.left,
    h = r.bottom - r.top;
  if ((s && f < Math.min(m, p) ? (s = !1) : !s && p < Math.min(m, f) && (s = !0), m <= (s ? f : p)))
    ((u = Math.max(i.top, Math.min(n.top, i.bottom - h)) - t.top), (d = Math.min(400, s ? f : p)));
  else {
    ((c = !0), (d = Math.min(400, (o ? t.right : i.right - t.left) - 30)));
    let e = i.bottom - t.bottom;
    e >= h || e > t.top ? (u = n.bottom - t.top) : ((l = `bottom`), (u = t.bottom - n.top));
  }
  let g = (t.bottom - t.top) / a.offsetHeight,
    v = (t.right - t.left) / a.offsetWidth;
  return {
    style: `${l}: ${u / g}px; max-width: ${d / v}px`,
    class: `cm-completionInfo-` + (c ? (o ? `left-narrow` : `right-narrow`) : s ? `left` : `right`),
  };
}
var EI = Wt.define();
function DI(e) {
  let t = e.addToOptions.slice();
  return (
    e.icons &&
      t.push({
        render(e) {
          let t = document.createElement(`div`);
          return (
            t.classList.add(`cm-completionIcon`),
            e.type && t.classList.add(...e.type.split(/\s+/g).map((e) => `cm-completionIcon-` + e)),
            t.setAttribute(`aria-hidden`, `true`),
            t
          );
        },
        position: 20,
      }),
    t.push(
      {
        render(e, t, n, r) {
          let i = document.createElement(`span`);
          i.className = `cm-completionLabel`;
          let a = e.displayLabel || e.label,
            o = 0;
          for (let e = 0; e < r.length;) {
            let t = r[e++],
              n = r[e++];
            t > o && i.appendChild(document.createTextNode(a.slice(o, t)));
            let s = i.appendChild(document.createElement(`span`));
            (s.appendChild(document.createTextNode(a.slice(t, n))),
              (s.className = `cm-completionMatchedText`),
              (o = n));
          }
          return (o < a.length && i.appendChild(document.createTextNode(a.slice(o))), i);
        },
        position: 50,
      },
      {
        render(e) {
          if (!e.detail) return null;
          let t = document.createElement(`span`);
          return ((t.className = `cm-completionDetail`), (t.textContent = e.detail), t);
        },
        position: 80,
      },
    ),
    t.sort((e, t) => e.position - t.position).map((e) => e.render)
  );
}
function OI(e, t, n) {
  if (e <= n)
    return {
      from: 0,
      to: e,
    };
  if ((t < 0 && (t = 0), t <= e >> 1)) {
    let e = Math.floor(t / n);
    return {
      from: e * n,
      to: (e + 1) * n,
    };
  }
  let r = Math.ceil((e - t) / n);
  return {
    from: e - r * n,
    to: e - (r - 1) * n,
  };
}
var kI = class {
  constructor(e, t, n) {
    ((this.view = e),
      (this.stateField = t),
      (this.applyCompletion = n),
      (this.info = null),
      (this.infoDestroy = null),
      (this.placeInfoReq = {
        read: () => this.measureInfo(),
        write: (e) => this.placeInfo(e),
        key: this,
      }),
      (this.space = null),
      (this.currentClass = ``));
    let r = e.state.field(t),
      { options: i, selected: a } = r.open,
      o = e.state.facet(CI);
    ((this.optionContent = DI(o)),
      (this.optionClass = o.optionClass),
      (this.tooltipClass = o.tooltipClass),
      (this.range = OI(i.length, a, o.maxRenderedOptions)),
      (this.dom = document.createElement(`div`)),
      (this.dom.className = `cm-tooltip-autocomplete`),
      this.updateTooltipClass(e.state),
      this.dom.addEventListener(`mousedown`, (n) => {
        let { options: r } = e.state.field(t).open;
        for (let t = n.target, i; t && t != this.dom; t = t.parentNode)
          if (t.nodeName == `LI` && (i = /-(\d+)$/.exec(t.id)) && +i[1] < r.length) {
            (this.applyCompletion(e, r[+i[1]]), n.preventDefault());
            return;
          }
        if (n.target == this.list) {
          let t =
            this.list.classList.contains(`cm-completionListIncompleteTop`) &&
            n.clientY < this.list.firstChild.getBoundingClientRect().top
              ? this.range.from - 1
              : this.list.classList.contains(`cm-completionListIncompleteBottom`) &&
                  n.clientY > this.list.lastChild.getBoundingClientRect().bottom
                ? this.range.to
                : null;
          t != null &&
            (e.dispatch({
              effects: EI.of(t),
            }),
            n.preventDefault());
        }
      }),
      this.dom.addEventListener(`focusout`, (t) => {
        let n = e.state.field(this.stateField, !1);
        n &&
          n.tooltip &&
          e.state.facet(CI).closeOnBlur &&
          t.relatedTarget != e.contentDOM &&
          e.dispatch({
            effects: bI.of(null),
          });
      }),
      this.showOptions(i, r.id));
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, t) {
    (this.list && this.list.remove(),
      (this.list = this.dom.appendChild(this.createListBox(e, t, this.range))),
      this.list.addEventListener(`scroll`, () => {
        this.info && this.view.requestMeasure(this.placeInfoReq);
      }));
  }
  update(e) {
    let t = e.state.field(this.stateField),
      n = e.startState.field(this.stateField);
    if ((this.updateTooltipClass(e.state), t != n)) {
      let { options: r, selected: i, disabled: a } = t.open;
      ((!n.open || n.open.options != r) &&
        ((this.range = OI(r.length, i, e.state.facet(CI).maxRenderedOptions)),
        this.showOptions(r, t.id)),
        this.updateSel(),
        a != n.open?.disabled &&
          this.dom.classList.toggle(`cm-tooltip-autocomplete-disabled`, !!a));
    }
  }
  updateTooltipClass(e) {
    let t = this.tooltipClass(e);
    if (t != this.currentClass) {
      for (let e of this.currentClass.split(` `)) e && this.dom.classList.remove(e);
      for (let e of t.split(` `)) e && this.dom.classList.add(e);
      this.currentClass = t;
    }
  }
  positioned(e) {
    ((this.space = e), this.info && this.view.requestMeasure(this.placeInfoReq));
  }
  updateSel() {
    let e = this.view.state.field(this.stateField),
      t = e.open;
    ((t.selected > -1 && t.selected < this.range.from) || t.selected >= this.range.to) &&
      ((this.range = OI(
        t.options.length,
        t.selected,
        this.view.state.facet(CI).maxRenderedOptions,
      )),
      this.showOptions(t.options, e.id));
    let n = this.updateSelectedOption(t.selected);
    if (n) {
      this.destroyInfo();
      let { completion: r } = t.options[t.selected],
        { info: i } = r;
      if (!i) return;
      let a = typeof i == `string` ? document.createTextNode(i) : i(r);
      if (!a) return;
      `then` in a
        ? a
            .then((t) => {
              t && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(t, r);
            })
            .catch((e) => kt(this.view.state, e, `completion info`))
        : (this.addInfoPane(a, r), n.setAttribute(`aria-describedby`, this.info.id));
    }
  }
  addInfoPane(e, t) {
    this.destroyInfo();
    let n = (this.info = document.createElement(`div`));
    if (
      ((n.className = `cm-tooltip cm-completionInfo`),
      (n.id = `cm-completionInfo-` + Math.floor(Math.random() * 65535).toString(16)),
      e.nodeType != null)
    )
      (n.appendChild(e), (this.infoDestroy = null));
    else {
      let { dom: t, destroy: r } = e;
      (n.appendChild(t), (this.infoDestroy = r || null));
    }
    (this.dom.appendChild(n), this.view.requestMeasure(this.placeInfoReq));
  }
  updateSelectedOption(e) {
    let t = null;
    for (let n = this.list.firstChild, r = this.range.from; n; n = n.nextSibling, r++)
      n.nodeName != `LI` || !n.id
        ? r--
        : r == e
          ? n.hasAttribute(`aria-selected`) || (n.setAttribute(`aria-selected`, `true`), (t = n))
          : n.hasAttribute(`aria-selected`) &&
            (n.removeAttribute(`aria-selected`), n.removeAttribute(`aria-describedby`));
    return (t && jI(this.list, t), t);
  }
  measureInfo() {
    let e = this.dom.querySelector(`[aria-selected]`);
    if (!e || !this.info) return null;
    let t = this.dom.getBoundingClientRect(),
      n = this.info.getBoundingClientRect(),
      r = e.getBoundingClientRect(),
      i = this.space;
    if (!i) {
      let e = this.dom.ownerDocument.documentElement;
      i = {
        left: 0,
        top: 0,
        right: e.clientWidth,
        bottom: e.clientHeight,
      };
    }
    return r.top > Math.min(i.bottom, t.bottom) - 10 || r.bottom < Math.max(i.top, t.top) + 10
      ? null
      : this.view.state.facet(CI).positionInfo(this.view, t, r, n, i, this.dom);
  }
  placeInfo(e) {
    this.info &&
      (e
        ? (e.style && (this.info.style.cssText = e.style),
          (this.info.className = `cm-tooltip cm-completionInfo ` + (e.class || ``)))
        : (this.info.style.cssText = `top: -1e6px`));
  }
  createListBox(e, t, n) {
    let r = document.createElement(`ul`);
    ((r.id = t),
      r.setAttribute(`role`, `listbox`),
      r.setAttribute(`aria-expanded`, `true`),
      r.setAttribute(`aria-label`, this.view.state.phrase(`Completions`)),
      r.addEventListener(`mousedown`, (e) => {
        e.target == r && e.preventDefault();
      }));
    let i = null;
    for (let a = n.from; a < n.to; a++) {
      let { completion: o, match: s } = e[a],
        { section: c } = o;
      if (c) {
        let e = typeof c == `string` ? c : c.name;
        if (e != i && (a > n.from || n.from == 0))
          if (((i = e), typeof c != `string` && c.header)) r.appendChild(c.header(c));
          else {
            let t = r.appendChild(document.createElement(`completion-section`));
            t.textContent = e;
          }
      }
      let l = r.appendChild(document.createElement(`li`));
      ((l.id = t + `-` + a), l.setAttribute(`role`, `option`));
      let u = this.optionClass(o);
      u && (l.className = u);
      for (let e of this.optionContent) {
        let t = e(o, this.view.state, this.view, s);
        t && l.appendChild(t);
      }
    }
    return (
      n.from && r.classList.add(`cm-completionListIncompleteTop`),
      n.to < e.length && r.classList.add(`cm-completionListIncompleteBottom`),
      r
    );
  }
  destroyInfo() {
    this.info &&= (this.infoDestroy && this.infoDestroy(), this.info.remove(), null);
  }
  destroy() {
    this.destroyInfo();
  }
};
function AI(e, t) {
  return (n) => new kI(n, e, t);
}
function jI(e, t) {
  let n = e.getBoundingClientRect(),
    r = t.getBoundingClientRect(),
    i = n.height / e.offsetHeight;
  r.top < n.top
    ? (e.scrollTop -= (n.top - r.top) / i)
    : r.bottom > n.bottom && (e.scrollTop += (r.bottom - n.bottom) / i);
}
function MI(e) {
  return (e.boost || 0) * 100 + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + +!!e.type;
}
function NI(e, t) {
  let n = [],
    r = null,
    i = null,
    a = (e) => {
      n.push(e);
      let { section: t } = e.completion;
      if (t) {
        r ||= [];
        let e = typeof t == `string` ? t : t.name;
        r.some((t) => t.name == e) ||
          r.push(
            typeof t == `string`
              ? {
                  name: e,
                }
              : t,
          );
      }
    },
    o = t.facet(CI);
  for (let r of e)
    if (r.hasResult()) {
      let e = r.result.getMatch;
      if (r.result.filter === !1)
        for (let t of r.result.options) a(new fI(t, r.source, e ? e(t) : [], 1e9 - n.length));
      else {
        let n = t.sliceDoc(r.from, r.to),
          s,
          c = o.filterStrict ? new SI(n) : new xI(n);
        for (let t of r.result.options)
          if ((s = c.match(t.label))) {
            let n = t.displayLabel ? (e ? e(t, s.matched) : []) : s.matched,
              o = s.score + (t.boost || 0);
            if (
              (a(new fI(t, r.source, n, o)),
              typeof t.section == `object` && t.section.rank === `dynamic`)
            ) {
              let { name: e } = t.section;
              ((i ||= Object.create(null)), (i[e] = Math.max(o, i[e] || -1e9)));
            }
          }
      }
    }
  if (r) {
    let e = Object.create(null),
      t = 0,
      a = (e, t) =>
        (e.rank === `dynamic` && t.rank === `dynamic` ? i[t.name] - i[e.name] : 0) ||
        (typeof e.rank == `number` ? e.rank : 1e9) - (typeof t.rank == `number` ? t.rank : 1e9) ||
        (e.name < t.name ? -1 : 1);
    for (let n of r.sort(a)) ((t -= 1e5), (e[n.name] = t));
    for (let t of n) {
      let { section: n } = t.completion;
      n && (t.score += e[typeof n == `string` ? n : n.name]);
    }
  }
  let s = [],
    c = null,
    l = o.compareCompletions;
  for (let e of n.sort((e, t) => t.score - e.score || l(e.completion, t.completion))) {
    let t = e.completion;
    (!c ||
    c.label != t.label ||
    c.detail != t.detail ||
    (c.type != null && t.type != null && c.type != t.type) ||
    c.apply != t.apply ||
    c.boost != t.boost
      ? s.push(e)
      : MI(e.completion) > MI(c) && (s[s.length - 1] = e),
      (c = e.completion));
  }
  return s;
}
var PI = class e {
    constructor(e, t, n, r, i, a) {
      ((this.options = e),
        (this.attrs = t),
        (this.tooltip = n),
        (this.timestamp = r),
        (this.selected = i),
        (this.disabled = a));
    }
    setSelected(t, n) {
      return t == this.selected || t >= this.options.length
        ? this
        : new e(this.options, zI(n, t), this.tooltip, this.timestamp, t, this.disabled);
    }
    static build(t, n, r, i, a, o) {
      if (i && !o && t.some((e) => e.isPending)) return i.setDisabled();
      let s = NI(t, n);
      if (!s.length) return i && t.some((e) => e.isPending) ? i.setDisabled() : null;
      let c = n.facet(CI).selectOnOpen ? 0 : -1;
      if (i && i.selected != c && i.selected != -1) {
        let e = i.options[i.selected].completion;
        for (let t = 0; t < s.length; t++)
          if (s[t].completion == e) {
            c = t;
            break;
          }
      }
      return new e(
        s,
        zI(r, c),
        {
          pos: t.reduce((e, t) => (t.hasResult() ? Math.min(e, t.from) : e), 1e8),
          create: JI,
          above: a.aboveCursor,
        },
        i ? i.timestamp : Date.now(),
        c,
        !1,
      );
    }
    map(t) {
      return new e(
        this.options,
        this.attrs,
        {
          ...this.tooltip,
          pos: t.mapPos(this.tooltip.pos),
        },
        this.timestamp,
        this.selected,
        this.disabled,
      );
    }
    setDisabled() {
      return new e(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
    }
  },
  FI = class e {
    constructor(e, t, n) {
      ((this.active = e), (this.id = t), (this.open = n));
    }
    static start() {
      return new e(BI, `cm-ac-` + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(t) {
      let { state: n } = t,
        r = n.facet(CI),
        i = (r.override || n.languageDataAt(`autocomplete`, pI(n)).map(vI)).map((e) =>
          (
            this.active.find((t) => t.source == e) ||
            new HI(e, +!!this.active.some((e) => e.state != 0))
          ).update(t, r),
        );
      i.length == this.active.length && i.every((e, t) => e == this.active[t]) && (i = this.active);
      let a = this.open,
        o = t.effects.some((e) => e.is(GI));
      (a && t.docChanged && (a = a.map(t.changes)),
        t.selection ||
        i.some((e) => e.hasResult() && t.changes.touchesRange(e.from, e.to)) ||
        !II(i, this.active) ||
        o
          ? (a = PI.build(i, n, this.id, a, r, o))
          : a && a.disabled && !i.some((e) => e.isPending) && (a = null),
        !a &&
          i.every((e) => !e.isPending) &&
          i.some((e) => e.hasResult()) &&
          (i = i.map((e) => (e.hasResult() ? new HI(e.source, 0) : e))));
      for (let e of t.effects) e.is(EI) && (a &&= a.setSelected(e.value, this.id));
      return i == this.active && a == this.open ? this : new e(i, this.id, a);
    }
    get tooltip() {
      return this.open ? this.open.tooltip : null;
    }
    get attrs() {
      return this.open ? this.open.attrs : this.active.length ? LI : RI;
    }
  };
function II(e, t) {
  if (e == t) return !0;
  for (let n = 0, r = 0; ;) {
    for (; n < e.length && !e[n].hasResult();) n++;
    for (; r < t.length && !t[r].hasResult();) r++;
    let i = n == e.length,
      a = r == t.length;
    if (i || a) return i == a;
    if (e[n++].result != t[r++].result) return !1;
  }
}
var LI = {
    "aria-autocomplete": `list`,
  },
  RI = {};
function zI(e, t) {
  let n = {
    "aria-autocomplete": `list`,
    "aria-haspopup": `listbox`,
    "aria-controls": e,
  };
  return (t > -1 && (n[`aria-activedescendant`] = e + `-` + t), n);
}
var BI = [];
function VI(e, t) {
  if (e.isUserEvent(`input.complete`)) {
    let n = e.annotation(hI);
    if (n && t.activateOnCompletion(n)) return 12;
  }
  let n = e.isUserEvent(`input.type`);
  return n && t.activateOnTyping
    ? 5
    : n
      ? 1
      : e.isUserEvent(`delete.backward`)
        ? 2
        : e.selection
          ? 8
          : e.docChanged
            ? 16
            : 0;
}
var HI = class e {
    constructor(e, t, n = !1) {
      ((this.source = e), (this.state = t), (this.explicit = n));
    }
    hasResult() {
      return !1;
    }
    get isPending() {
      return this.state == 1;
    }
    update(t, n) {
      let r = VI(t, n),
        i = this;
      ((r & 8 || (r & 16 && this.touches(t))) && (i = new e(i.source, 0)),
        r & 4 && i.state == 0 && (i = new e(this.source, 1)),
        (i = i.updateFor(t, r)));
      for (let n of t.effects)
        if (n.is(yI)) i = new e(i.source, 1, n.value);
        else if (n.is(bI)) i = new e(i.source, 0);
        else if (n.is(GI)) for (let e of n.value) e.source == i.source && (i = e);
      return i;
    }
    updateFor(e, t) {
      return this.map(e.changes);
    }
    map(e) {
      return this;
    }
    touches(e) {
      return e.changes.touchesRange(pI(e.state));
    }
  },
  UI = class e extends HI {
    constructor(e, t, n, r, i, a) {
      (super(e, 3, t), (this.limit = n), (this.result = r), (this.from = i), (this.to = a));
    }
    hasResult() {
      return !0;
    }
    updateFor(t, n) {
      if (!(n & 3)) return this.map(t.changes);
      let r = this.result;
      r.map && !t.changes.empty && (r = r.map(r, t.changes));
      let i = t.changes.mapPos(this.from),
        a = t.changes.mapPos(this.to, 1),
        o = pI(t.state);
      if (o > a || !r || (n & 2 && (pI(t.startState) == this.from || o < this.limit)))
        return new HI(this.source, n & 4 ? 1 : 0);
      let s = t.changes.mapPos(this.limit);
      return WI(r.validFor, t.state, i, a)
        ? new e(this.source, this.explicit, s, r, i, a)
        : r.update && (r = r.update(r, i, a, new sI(t.state, o, !1)))
          ? new e(this.source, this.explicit, s, r, r.from, r.to ?? pI(t.state))
          : new HI(this.source, 1, this.explicit);
    }
    map(t) {
      if (t.empty) return this;
      let n = this.result.map ? this.result.map(this.result, t) : this.result;
      return n
        ? new e(
            this.source,
            this.explicit,
            t.mapPos(this.limit),
            n,
            t.mapPos(this.from),
            t.mapPos(this.to, 1),
          )
        : new HI(this.source, 0);
    }
    touches(e) {
      return e.changes.touchesRange(this.from, this.to);
    }
  };
function WI(e, t, n, r) {
  if (!e) return !1;
  let i = t.sliceDoc(n, r);
  return typeof e == `function` ? e(i, n, r, t) : mI(e, !0).test(i);
}
var GI = Wt.define({
    map(e, t) {
      return e.map((e) => e.map(t));
    },
  }),
  KI = jt.define({
    create() {
      return FI.start();
    },
    update(e, t) {
      return e.update(t);
    },
    provide: (e) => [nn.from(e, (e) => e.tooltip), Et.contentAttributes.from(e, (e) => e.attrs)],
  });
function qI(e, t) {
  let n = t.completion.apply || t.completion.label,
    r = e.state.field(KI).active.find((e) => e.source == t.source);
  return r instanceof UI
    ? (typeof n == `string`
        ? e.dispatch({
            ...gI(e.state, n, r.from, r.to),
            annotations: hI.of(t.completion),
          })
        : n(e, t.completion, r.from, r.to),
      !0)
    : !1;
}
var JI = AI(KI, qI);
function YI(e, t = `option`) {
  return (n) => {
    let r = n.state.field(KI, !1);
    if (
      !r ||
      !r.open ||
      r.open.disabled ||
      Date.now() - r.open.timestamp < n.state.facet(CI).interactionDelay
    )
      return !1;
    let i = 1,
      a;
    t == `page` &&
      (a = Ot(n, r.open.tooltip)) &&
      (i = Math.max(
        2,
        Math.floor(a.dom.offsetHeight / a.dom.querySelector(`li`).offsetHeight) - 1,
      ));
    let { length: o } = r.open.options,
      s = r.open.selected > -1 ? r.open.selected + i * (e ? 1 : -1) : e ? 0 : o - 1;
    return (
      s < 0 ? (s = t == `page` ? 0 : o - 1) : s >= o && (s = t == `page` ? o - 1 : 0),
      n.dispatch({
        effects: EI.of(s),
      }),
      !0
    );
  };
}
var XI = (e) => {
    let t = e.state.field(KI, !1);
    return e.state.readOnly ||
      !t ||
      !t.open ||
      t.open.selected < 0 ||
      t.open.disabled ||
      Date.now() - t.open.timestamp < e.state.facet(CI).interactionDelay
      ? !1
      : qI(e, t.open.options[t.open.selected]);
  },
  ZI = (e) =>
    e.state.field(KI, !1)
      ? (e.dispatch({
          effects: yI.of(!0),
        }),
        !0)
      : !1,
  QI = (e) => {
    let t = e.state.field(KI, !1);
    return !t || !t.active.some((e) => e.state != 0)
      ? !1
      : (e.dispatch({
          effects: bI.of(null),
        }),
        !0);
  },
  $I = class {
    constructor(e, t) {
      ((this.active = e),
        (this.context = t),
        (this.time = Date.now()),
        (this.updates = []),
        (this.done = void 0));
    }
  },
  eL = 50,
  tL = 1e3,
  nL = lt.fromClass(
    class {
      constructor(e) {
        ((this.view = e),
          (this.debounceUpdate = -1),
          (this.running = []),
          (this.debounceAccept = -1),
          (this.pendingStart = !1),
          (this.composing = 0));
        for (let t of e.state.field(KI).active) t.isPending && this.startQuery(t);
      }
      update(e) {
        let t = e.state.field(KI),
          n = e.state.facet(CI);
        if (!e.selectionSet && !e.docChanged && e.startState.field(KI) == t) return;
        let r = e.transactions.some((e) => {
          let t = VI(e, n);
          return t & 8 || ((e.selection || e.docChanged) && !(t & 3));
        });
        for (let t = 0; t < this.running.length; t++) {
          let n = this.running[t];
          if (
            r ||
            (n.context.abortOnDocChange && e.docChanged) ||
            (n.updates.length + e.transactions.length > eL && Date.now() - n.time > tL)
          ) {
            for (let e of n.context.abortListeners)
              try {
                e();
              } catch (e) {
                kt(this.view.state, e);
              }
            ((n.context.abortListeners = null), this.running.splice(t--, 1));
          } else n.updates.push(...e.transactions);
        }
        (this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate),
          e.transactions.some((e) => e.effects.some((e) => e.is(yI))) && (this.pendingStart = !0));
        let i = this.pendingStart ? 50 : n.activateOnTypingDelay;
        if (
          ((this.debounceUpdate = t.active.some(
            (e) => e.isPending && !this.running.some((t) => t.active.source == e.source),
          )
            ? setTimeout(() => this.startUpdate(), i)
            : -1),
          this.composing != 0)
        )
          for (let t of e.transactions)
            t.isUserEvent(`input.type`)
              ? (this.composing = 2)
              : this.composing == 2 && t.selection && (this.composing = 3);
      }
      startUpdate() {
        ((this.debounceUpdate = -1), (this.pendingStart = !1));
        let { state: e } = this.view,
          t = e.field(KI);
        for (let e of t.active)
          e.isPending &&
            !this.running.some((t) => t.active.source == e.source) &&
            this.startQuery(e);
        this.running.length &&
          t.open &&
          t.open.disabled &&
          (this.debounceAccept = setTimeout(
            () => this.accept(),
            this.view.state.facet(CI).updateSyncTime,
          ));
      }
      startQuery(e) {
        let { state: t } = this.view,
          n = new sI(t, pI(t), e.explicit, this.view),
          r = new $I(e, n);
        (this.running.push(r),
          Promise.resolve(e.source(n)).then(
            (e) => {
              r.context.aborted || ((r.done = e || null), this.scheduleAccept());
            },
            (e) => {
              (this.view.dispatch({
                effects: bI.of(null),
              }),
                kt(this.view.state, e));
            },
          ));
      }
      scheduleAccept() {
        this.running.every((e) => e.done !== void 0)
          ? this.accept()
          : this.debounceAccept < 0 &&
            (this.debounceAccept = setTimeout(
              () => this.accept(),
              this.view.state.facet(CI).updateSyncTime,
            ));
      }
      accept() {
        (this.debounceAccept > -1 && clearTimeout(this.debounceAccept), (this.debounceAccept = -1));
        let e = [],
          t = this.view.state.facet(CI),
          n = this.view.state.field(KI);
        for (let r = 0; r < this.running.length; r++) {
          let i = this.running[r];
          if (i.done === void 0) continue;
          if ((this.running.splice(r--, 1), i.done)) {
            let n = pI(i.updates.length ? i.updates[0].startState : this.view.state),
              r = Math.min(n, i.done.from + +!i.active.explicit),
              a = new UI(
                i.active.source,
                i.active.explicit,
                r,
                i.done,
                i.done.from,
                i.done.to ?? n,
              );
            for (let e of i.updates) a = a.update(e, t);
            if (a.hasResult()) {
              e.push(a);
              continue;
            }
          }
          let a = n.active.find((e) => e.source == i.active.source);
          if (a && a.isPending)
            if (i.done == null) {
              let n = new HI(i.active.source, 0);
              for (let e of i.updates) n = n.update(e, t);
              n.isPending || e.push(n);
            } else this.startQuery(a);
        }
        (e.length || (n.open && n.open.disabled)) &&
          this.view.dispatch({
            effects: GI.of(e),
          });
      }
    },
    {
      eventHandlers: {
        blur(e) {
          let t = this.view.state.field(KI, !1);
          if (t && t.tooltip && this.view.state.facet(CI).closeOnBlur) {
            let n = t.open && Ot(this.view, t.open.tooltip);
            (!n || !n.dom.contains(e.relatedTarget)) &&
              setTimeout(
                () =>
                  this.view.dispatch({
                    effects: bI.of(null),
                  }),
                10,
              );
          }
        },
        compositionstart() {
          this.composing = 1;
        },
        compositionend() {
          (this.composing == 3 &&
            setTimeout(
              () =>
                this.view.dispatch({
                  effects: yI.of(!1),
                }),
              20,
            ),
            (this.composing = 0));
        },
      },
    },
  ),
  rL = typeof navigator == `object` && /Win/.test(navigator.platform),
  iL = sn.highest(
    Et.domEventHandlers({
      keydown(e, t) {
        let n = t.state.field(KI, !1);
        if (
          !n ||
          !n.open ||
          n.open.disabled ||
          n.open.selected < 0 ||
          e.key.length > 1 ||
          (e.ctrlKey && !(rL && e.altKey)) ||
          e.metaKey
        )
          return !1;
        let r = n.open.options[n.open.selected],
          i = n.active.find((e) => e.source == r.source),
          a = r.completion.commitCharacters || i.result.commitCharacters;
        return (a && a.indexOf(e.key) > -1 && qI(t, r), !1);
      },
    }),
  ),
  aL = Et.baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
      "& > ul": {
        fontFamily: `monospace`,
        whiteSpace: `nowrap`,
        overflow: `hidden auto`,
        maxWidth_fallback: `700px`,
        maxWidth: `min(700px, 95vw)`,
        minWidth: `250px`,
        maxHeight: `10em`,
        height: `100%`,
        listStyle: `none`,
        margin: 0,
        padding: 0,
        "& > li, & > completion-section": {
          padding: `1px 3px`,
          lineHeight: 1.2,
        },
        "& > li": {
          overflowX: `hidden`,
          textOverflow: `ellipsis`,
          cursor: `pointer`,
        },
        "& > completion-section": {
          display: `list-item`,
          borderBottom: `1px solid silver`,
          paddingLeft: `0.5em`,
          opacity: 0.7,
        },
      },
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
      background: `#17c`,
      color: `white`,
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
      background: `#777`,
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
      background: `#347`,
      color: `white`,
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
      background: `#444`,
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
      content: `"···"`,
      opacity: 0.5,
      display: `block`,
      textAlign: `center`,
      cursor: `pointer`,
    },
    ".cm-tooltip.cm-completionInfo": {
      position: `absolute`,
      padding: `3px 9px`,
      width: `max-content`,
      maxWidth: `400px`,
      boxSizing: `border-box`,
      whiteSpace: `pre-line`,
    },
    ".cm-completionInfo.cm-completionInfo-left": {
      right: `100%`,
    },
    ".cm-completionInfo.cm-completionInfo-right": {
      left: `100%`,
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
      right: `30px`,
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
      left: `30px`,
    },
    "&light .cm-snippetField": {
      backgroundColor: `#00000022`,
    },
    "&dark .cm-snippetField": {
      backgroundColor: `#ffffff22`,
    },
    ".cm-snippetFieldPosition": {
      verticalAlign: `text-top`,
      width: 0,
      height: `1.15em`,
      display: `inline-block`,
      margin: `0 -0.7px -.7em`,
      borderLeft: `1.4px dotted #888`,
    },
    ".cm-completionMatchedText": {
      textDecoration: `underline`,
    },
    ".cm-completionDetail": {
      marginLeft: `0.5em`,
      fontStyle: `italic`,
    },
    ".cm-completionIcon": {
      fontSize: `90%`,
      width: `.8em`,
      display: `inline-block`,
      textAlign: `center`,
      paddingRight: `.6em`,
      opacity: `0.6`,
      boxSizing: `content-box`,
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
      "&:after": {
        content: `'ƒ'`,
      },
    },
    ".cm-completionIcon-class": {
      "&:after": {
        content: `'○'`,
      },
    },
    ".cm-completionIcon-interface": {
      "&:after": {
        content: `'◌'`,
      },
    },
    ".cm-completionIcon-variable": {
      "&:after": {
        content: `'𝑥'`,
      },
    },
    ".cm-completionIcon-constant": {
      "&:after": {
        content: `'𝐶'`,
      },
    },
    ".cm-completionIcon-type": {
      "&:after": {
        content: `'𝑡'`,
      },
    },
    ".cm-completionIcon-enum": {
      "&:after": {
        content: `'∪'`,
      },
    },
    ".cm-completionIcon-property": {
      "&:after": {
        content: `'□'`,
      },
    },
    ".cm-completionIcon-keyword": {
      "&:after": {
        content: `'🔑︎'`,
      },
    },
    ".cm-completionIcon-namespace": {
      "&:after": {
        content: `'▢'`,
      },
    },
    ".cm-completionIcon-text": {
      "&:after": {
        content: `'abc'`,
        fontSize: `50%`,
        verticalAlign: `middle`,
      },
    },
  }),
  oL = class {
    constructor(e, t, n, r) {
      ((this.field = e), (this.line = t), (this.from = n), (this.to = r));
    }
  },
  sL = class e {
    constructor(e, t, n) {
      ((this.field = e), (this.from = t), (this.to = n));
    }
    map(t) {
      let n = t.mapPos(this.from, -1, Ht.TrackDel),
        r = t.mapPos(this.to, 1, Ht.TrackDel);
      return n == null || r == null ? null : new e(this.field, n, r);
    }
  },
  cL = class e {
    constructor(e, t) {
      ((this.lines = e), (this.fieldPositions = t));
    }
    instantiate(e, t) {
      let n = [],
        r = [t],
        i = e.doc.lineAt(t),
        a = /^\s*/.exec(i.text)[0];
      for (let i of this.lines) {
        if (n.length) {
          let n = a,
            o = /^\t*/.exec(i)[0].length;
          for (let t = 0; t < o; t++) n += e.facet(St);
          (r.push(t + n.length - o), (i = n + i.slice(o)));
        }
        (n.push(i), (t += i.length + 1));
      }
      return {
        text: n,
        ranges: this.fieldPositions.map(
          (e) => new sL(e.field, r[e.line] + e.from, r[e.line] + e.to),
        ),
      };
    }
    static parse(t) {
      let n = [],
        r = [],
        i = [],
        a;
      for (let e of t.split(/\r\n?|\n/)) {
        for (; (a = /[#$]\{(?:(\d+)(?::([^{}]*))?|((?:\\[{}]|[^{}])*))\}/.exec(e));) {
          let t = a[1] ? +a[1] : null,
            o = a[2] || a[3] || ``,
            s = -1;
          t === 0 && (t = 1e9);
          let c = o.replace(/\\[{}]/g, (e) => e[1]);
          for (let e = 0; e < n.length; e++)
            (t == null ? c && n[e].name == c : n[e].seq == t) && (s = e);
          if (s < 0) {
            let e = 0;
            for (; e < n.length && (t == null || (n[e].seq != null && n[e].seq < t));) e++;
            (n.splice(e, 0, {
              seq: t,
              name: c,
            }),
              (s = e));
            for (let e of i) e.field >= s && e.field++;
          }
          for (let e of i)
            if (e.line == r.length && e.from > a.index) {
              let t = a[2] ? 3 + (a[1] || ``).length : 2;
              ((e.from -= t), (e.to -= t));
            }
          (i.push(new oL(s, r.length, a.index, a.index + c.length)),
            (e = e.slice(0, a.index) + o + e.slice(a.index + a[0].length)));
        }
        ((e = e.replace(/\\([{}])/g, (e, t, n) => {
          for (let e of i) e.line == r.length && e.from > n && (e.from--, e.to--);
          return t;
        })),
          r.push(e));
      }
      return new e(r, i);
    }
  },
  lL = ut.widget({
    widget: new (class extends pt {
      toDOM() {
        let e = document.createElement(`span`);
        return ((e.className = `cm-snippetFieldPosition`), e);
      }
      ignoreEvent() {
        return !1;
      }
    })(),
  }),
  uL = ut.mark({
    class: `cm-snippetField`,
  }),
  dL = class e {
    constructor(e, t) {
      ((this.ranges = e),
        (this.active = t),
        (this.deco = ut.set(
          e.map((e) => (e.from == e.to ? lL : uL).range(e.from, e.to)),
          !0,
        )));
    }
    map(t) {
      let n = [];
      for (let e of this.ranges) {
        let r = e.map(t);
        if (!r) return null;
        n.push(r);
      }
      return new e(n, this.active);
    }
    selectionInsideField(e) {
      return e.ranges.every((e) =>
        this.ranges.some((t) => t.field == this.active && t.from <= e.from && t.to >= e.to),
      );
    }
  },
  fL = Wt.define({
    map(e, t) {
      return e && e.map(t);
    },
  }),
  pL = Wt.define(),
  mL = jt.define({
    create() {
      return null;
    },
    update(e, t) {
      for (let n of t.effects) {
        if (n.is(fL)) return n.value;
        if (n.is(pL) && e) return new dL(e.ranges, n.value);
      }
      return (
        e && t.docChanged && (e = e.map(t.changes)),
        e && t.selection && !e.selectionInsideField(t.selection) && (e = null),
        e
      );
    },
    provide: (e) => Et.decorations.from(e, (e) => (e ? e.deco : ut.none)),
  });
function hL(e, t) {
  return Qt.create(e.filter((e) => e.field == t).map((e) => Qt.range(e.from, e.to)));
}
function gL(e) {
  let t = cL.parse(e);
  return (e, n, r, i) => {
    let { text: a, ranges: o } = t.instantiate(e.state, r),
      { main: s } = e.state.selection,
      c = {
        changes: {
          from: r,
          to: i == s.from ? s.to : i,
          insert: vn.of(a),
        },
        scrollIntoView: !0,
        annotations: n ? [hI.of(n), wn.userEvent.of(`input.complete`)] : void 0,
      };
    if ((o.length && (c.selection = hL(o, 0)), o.some((e) => e.field > 0))) {
      let t = new dL(o, 0),
        n = (c.effects = [fL.of(t)]);
      e.state.field(mL, !1) === void 0 && n.push(Wt.appendConfig.of([mL, bL, SL, aL]));
    }
    e.dispatch(e.state.update(c));
  };
}
function _L(e) {
  return ({ state: t, dispatch: n }) => {
    let r = t.field(mL, !1);
    if (!r || (e < 0 && r.active == 0)) return !1;
    let i = r.active + e,
      a = e > 0 && !r.ranges.some((t) => t.field == i + e);
    return (
      n(
        t.update({
          selection: hL(r.ranges, i),
          effects: fL.of(a ? null : new dL(r.ranges, i)),
          scrollIntoView: !0,
        }),
      ),
      !0
    );
  };
}
var vL = [
    {
      key: `Tab`,
      run: _L(1),
      shift: _L(-1),
    },
    {
      key: `Escape`,
      run: ({ state: e, dispatch: t }) =>
        e.field(mL, !1)
          ? (t(
              e.update({
                effects: fL.of(null),
              }),
            ),
            !0)
          : !1,
    },
  ],
  yL = zt.define({
    combine(e) {
      return e.length ? e[0] : vL;
    },
  }),
  bL = sn.highest(Dt.compute([yL], (e) => e.facet(yL)));
function xL(e, t) {
  return {
    ...t,
    apply: gL(e),
  };
}
var SL = Et.domEventHandlers({
    mousedown(e, t) {
      let n = t.state.field(mL, !1),
        r;
      if (
        !n ||
        (r = t.posAtCoords({
          x: e.clientX,
          y: e.clientY,
        })) == null
      )
        return !1;
      let i = n.ranges.find((e) => e.from <= r && e.to >= r);
      return !i || i.field == n.active
        ? !1
        : (t.dispatch({
            selection: hL(n.ranges, i.field),
            effects: fL.of(
              n.ranges.some((e) => e.field > i.field) ? new dL(n.ranges, i.field) : null,
            ),
            scrollIntoView: !0,
          }),
          !0);
    },
  }),
  CL = new (class extends Kt {})();
((CL.startSide = 1), (CL.endSide = -1), typeof navigator == `object` && navigator.userAgent);
function wL(e = {}) {
  return [iL, KI, CI.of(e), nL, EL, aL];
}
var TL = [
    {
      key: `Ctrl-Space`,
      run: ZI,
    },
    {
      mac: "Alt-`",
      run: ZI,
    },
    {
      mac: `Alt-i`,
      run: ZI,
    },
    {
      key: `Escape`,
      run: QI,
    },
    {
      key: `ArrowDown`,
      run: YI(!0),
    },
    {
      key: `ArrowUp`,
      run: YI(!1),
    },
    {
      key: `PageDown`,
      run: YI(!0, `page`),
    },
    {
      key: `PageUp`,
      run: YI(!1, `page`),
    },
    {
      key: `Enter`,
      run: XI,
    },
  ],
  EL = sn.highest(Dt.computeN([CI], (e) => (e.facet(CI).defaultKeymap ? [TL] : []))),
  DL = class e {
    static create(t, n, r, i, a) {
      return new e(t, n, r, (i + (i << 8) + t + (n << 4)) | 0, a, [], []);
    }
    constructor(e, t, n, r, i, a, o) {
      ((this.type = e),
        (this.value = t),
        (this.from = n),
        (this.hash = r),
        (this.end = i),
        (this.children = a),
        (this.positions = o),
        (this.hashProp = [[ct.contextHash, r]]));
    }
    addChild(e, t) {
      (e.prop(ct.contextHash) != this.hash &&
        (e = new rt(e.type, e.children, e.positions, e.length, this.hashProp)),
        this.children.push(e),
        this.positions.push(t));
    }
    toTree(e, t = this.end) {
      let n = this.children.length - 1;
      return (
        n >= 0 && (t = Math.max(t, this.positions[n] + this.children[n].length + this.from)),
        new rt(e.types[this.type], this.children, this.positions, t - this.from).balance({
          makeTree: (e, t, n) => new rt(mt.none, e, t, n, this.hashProp),
        })
      );
    }
  },
  OL;
(function (e) {
  ((e[(e.Document = 1)] = `Document`),
    (e[(e.CodeBlock = 2)] = `CodeBlock`),
    (e[(e.FencedCode = 3)] = `FencedCode`),
    (e[(e.Blockquote = 4)] = `Blockquote`),
    (e[(e.HorizontalRule = 5)] = `HorizontalRule`),
    (e[(e.BulletList = 6)] = `BulletList`),
    (e[(e.OrderedList = 7)] = `OrderedList`),
    (e[(e.ListItem = 8)] = `ListItem`),
    (e[(e.ATXHeading1 = 9)] = `ATXHeading1`),
    (e[(e.ATXHeading2 = 10)] = `ATXHeading2`),
    (e[(e.ATXHeading3 = 11)] = `ATXHeading3`),
    (e[(e.ATXHeading4 = 12)] = `ATXHeading4`),
    (e[(e.ATXHeading5 = 13)] = `ATXHeading5`),
    (e[(e.ATXHeading6 = 14)] = `ATXHeading6`),
    (e[(e.SetextHeading1 = 15)] = `SetextHeading1`),
    (e[(e.SetextHeading2 = 16)] = `SetextHeading2`),
    (e[(e.HTMLBlock = 17)] = `HTMLBlock`),
    (e[(e.LinkReference = 18)] = `LinkReference`),
    (e[(e.Paragraph = 19)] = `Paragraph`),
    (e[(e.CommentBlock = 20)] = `CommentBlock`),
    (e[(e.ProcessingInstructionBlock = 21)] = `ProcessingInstructionBlock`),
    (e[(e.Escape = 22)] = `Escape`),
    (e[(e.Entity = 23)] = `Entity`),
    (e[(e.HardBreak = 24)] = `HardBreak`),
    (e[(e.Emphasis = 25)] = `Emphasis`),
    (e[(e.StrongEmphasis = 26)] = `StrongEmphasis`),
    (e[(e.Link = 27)] = `Link`),
    (e[(e.Image = 28)] = `Image`),
    (e[(e.InlineCode = 29)] = `InlineCode`),
    (e[(e.HTMLTag = 30)] = `HTMLTag`),
    (e[(e.Comment = 31)] = `Comment`),
    (e[(e.ProcessingInstruction = 32)] = `ProcessingInstruction`),
    (e[(e.Autolink = 33)] = `Autolink`),
    (e[(e.HeaderMark = 34)] = `HeaderMark`),
    (e[(e.QuoteMark = 35)] = `QuoteMark`),
    (e[(e.ListMark = 36)] = `ListMark`),
    (e[(e.LinkMark = 37)] = `LinkMark`),
    (e[(e.EmphasisMark = 38)] = `EmphasisMark`),
    (e[(e.CodeMark = 39)] = `CodeMark`),
    (e[(e.CodeText = 40)] = `CodeText`),
    (e[(e.CodeInfo = 41)] = `CodeInfo`),
    (e[(e.LinkTitle = 42)] = `LinkTitle`),
    (e[(e.LinkLabel = 43)] = `LinkLabel`),
    (e[(e.URL = 44)] = `URL`));
})((OL ||= {}));
var kL = class {
    constructor(e, t) {
      ((this.start = e), (this.content = t), (this.marks = []), (this.parsers = []));
    }
  },
  AL = class {
    constructor() {
      ((this.text = ``),
        (this.baseIndent = 0),
        (this.basePos = 0),
        (this.depth = 0),
        (this.markers = []),
        (this.pos = 0),
        (this.indent = 0),
        (this.next = -1));
    }
    forward() {
      this.basePos > this.pos && this.forwardInner();
    }
    forwardInner() {
      let e = this.skipSpace(this.basePos);
      ((this.indent = this.countIndent(e, this.pos, this.indent)),
        (this.pos = e),
        (this.next = e == this.text.length ? -1 : this.text.charCodeAt(e)));
    }
    skipSpace(e) {
      return PL(this.text, e);
    }
    reset(e) {
      for (
        this.text = e,
          this.baseIndent = this.basePos = this.pos = this.indent = 0,
          this.forwardInner(),
          this.depth = 1;
        this.markers.length;
      )
        this.markers.pop();
    }
    moveBase(e) {
      ((this.basePos = e), (this.baseIndent = this.countIndent(e, this.pos, this.indent)));
    }
    moveBaseColumn(e) {
      ((this.baseIndent = e), (this.basePos = this.findColumn(e)));
    }
    addMarker(e) {
      this.markers.push(e);
    }
    countIndent(e, t = 0, n = 0) {
      for (let r = t; r < e; r++) n += this.text.charCodeAt(r) == 9 ? 4 - (n % 4) : 1;
      return n;
    }
    findColumn(e) {
      let t = 0;
      for (let n = 0; t < this.text.length && n < e; t++)
        n += this.text.charCodeAt(t) == 9 ? 4 - (n % 4) : 1;
      return t;
    }
    scrub() {
      if (!this.baseIndent) return this.text;
      let e = ``;
      for (let t = 0; t < this.basePos; t++) e += ` `;
      return e + this.text.slice(this.basePos);
    }
  };
function jL(e, t, n) {
  if (
    n.pos == n.text.length ||
    (e != t.block && n.indent >= t.stack[n.depth + 1].value + n.baseIndent)
  )
    return !0;
  if (n.indent >= n.baseIndent + 4) return !1;
  let r = (e.type == OL.OrderedList ? VL : BL)(n, t, !1);
  return (
    r > 0 &&
    (e.type != OL.BulletList || RL(n, t, !1) < 0) &&
    n.text.charCodeAt(n.pos + r - 1) == e.value
  );
}
var ML = {
  [OL.Blockquote](e, t, n) {
    return n.next == 62
      ? (n.markers.push(hR(OL.QuoteMark, t.lineStart + n.pos, t.lineStart + n.pos + 1)),
        n.moveBase(n.pos + (NL(n.text.charCodeAt(n.pos + 1)) ? 2 : 1)),
        (e.end = t.lineStart + n.text.length),
        !0)
      : !1;
  },
  [OL.ListItem](e, t, n) {
    return n.indent < n.baseIndent + e.value && n.next > -1
      ? !1
      : (n.moveBaseColumn(n.baseIndent + e.value), !0);
  },
  [OL.OrderedList]: jL,
  [OL.BulletList]: jL,
  [OL.Document]() {
    return !0;
  },
};
function NL(e) {
  return e == 32 || e == 9 || e == 10 || e == 13;
}
function PL(e, t = 0) {
  for (; t < e.length && NL(e.charCodeAt(t));) t++;
  return t;
}
function FL(e, t, n) {
  for (; t > n && NL(e.charCodeAt(t - 1));) t--;
  return t;
}
function IL(e) {
  if (e.next != 96 && e.next != 126) return -1;
  let t = e.pos + 1;
  for (; t < e.text.length && e.text.charCodeAt(t) == e.next;) t++;
  if (t < e.pos + 3) return -1;
  if (e.next == 96) {
    for (let n = t; n < e.text.length; n++) if (e.text.charCodeAt(n) == 96) return -1;
  }
  return t;
}
function LL(e) {
  return e.next == 62 ? (e.text.charCodeAt(e.pos + 1) == 32 ? 2 : 1) : -1;
}
function RL(e, t, n) {
  if (e.next != 42 && e.next != 45 && e.next != 95) return -1;
  let r = 1;
  for (let t = e.pos + 1; t < e.text.length; t++) {
    let n = e.text.charCodeAt(t);
    if (n == e.next) r++;
    else if (!NL(n)) return -1;
  }
  return (n &&
    e.next == 45 &&
    UL(e) > -1 &&
    e.depth == t.stack.length &&
    t.parser.leafBlockParsers.indexOf(tR.SetextHeading) > -1) ||
    r < 3
    ? -1
    : 1;
}
function zL(e, t) {
  for (let n = e.stack.length - 1; n >= 0; n--) if (e.stack[n].type == t) return !0;
  return !1;
}
function BL(e, t, n) {
  return (e.next == 45 || e.next == 43 || e.next == 42) &&
    (e.pos == e.text.length - 1 || NL(e.text.charCodeAt(e.pos + 1))) &&
    (!n || zL(t, OL.BulletList) || e.skipSpace(e.pos + 2) < e.text.length)
    ? 1
    : -1;
}
function VL(e, t, n) {
  let r = e.pos,
    i = e.next;
  for (; i >= 48 && i <= 57;) {
    if ((r++, r == e.text.length)) return -1;
    i = e.text.charCodeAt(r);
  }
  return r == e.pos ||
    r > e.pos + 9 ||
    (i != 46 && i != 41) ||
    (r < e.text.length - 1 && !NL(e.text.charCodeAt(r + 1))) ||
    (n &&
      !zL(t, OL.OrderedList) &&
      (e.skipSpace(r + 1) == e.text.length || r > e.pos + 1 || e.next != 49))
    ? -1
    : r + 1 - e.pos;
}
function HL(e) {
  if (e.next != 35) return -1;
  let t = e.pos + 1;
  for (; t < e.text.length && e.text.charCodeAt(t) == 35;) t++;
  if (t < e.text.length && e.text.charCodeAt(t) != 32) return -1;
  let n = t - e.pos;
  return n > 6 ? -1 : n;
}
function UL(e) {
  if ((e.next != 45 && e.next != 61) || e.indent >= e.baseIndent + 4) return -1;
  let t = e.pos + 1;
  for (; t < e.text.length && e.text.charCodeAt(t) == e.next;) t++;
  let n = t;
  for (; t < e.text.length && NL(e.text.charCodeAt(t));) t++;
  return t == e.text.length ? n : -1;
}
var WL = /^[ \t]*$/,
  GL = /-->/,
  KL = /\?>/,
  qL = [
    [/^<(?:script|pre|style)(?:\s|>|$)/i, /<\/(?:script|pre|style)>/i],
    [/^\s*<!--/, GL],
    [/^\s*<\?/, KL],
    [/^\s*<![A-Z]/, />/],
    [/^\s*<!\[CDATA\[/, /\]\]>/],
    [
      /^\s*<\/?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|\/?>|$)/i,
      WL,
    ],
    [
      /^\s*(?:<\/[a-z][\w-]*\s*>|<[a-z][\w-]*(\s+[a-z:_][\w-.]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*>)\s*$/i,
      WL,
    ],
  ];
function JL(e, t, n) {
  if (e.next != 60) return -1;
  let r = e.text.slice(e.pos);
  for (let e = 0, t = qL.length - +!!n; e < t; e++) if (qL[e][0].test(r)) return e;
  return -1;
}
function YL(e, t) {
  let n = e.countIndent(t, e.pos, e.indent),
    r = e.countIndent(e.skipSpace(t), t, n);
  return r >= n + 5 ? n + 1 : r;
}
function XL(e, t, n) {
  let r = e.length - 1;
  r >= 0 && e[r].to == t && e[r].type == OL.CodeText
    ? (e[r].to = n)
    : e.push(hR(OL.CodeText, t, n));
}
var ZL = {
    LinkReference: void 0,
    IndentedCode(e, t) {
      let n = t.baseIndent + 4;
      if (t.indent < n) return !1;
      let r = t.findColumn(n),
        i = e.lineStart + r,
        a = e.lineStart + t.text.length,
        o = [],
        s = [];
      for (XL(o, i, a); e.nextLine() && t.depth >= e.stack.length;)
        if (t.pos == t.text.length) {
          XL(s, e.lineStart - 1, e.lineStart);
          for (let e of t.markers) s.push(e);
        } else if (t.indent < n) break;
        else {
          if (s.length) {
            for (let e of s) e.type == OL.CodeText ? XL(o, e.from, e.to) : o.push(e);
            s = [];
          }
          XL(o, e.lineStart - 1, e.lineStart);
          for (let e of t.markers) o.push(e);
          a = e.lineStart + t.text.length;
          let n = e.lineStart + t.findColumn(t.baseIndent + 4);
          n < a && XL(o, n, a);
        }
      return (
        s.length &&
          ((s = s.filter((e) => e.type != OL.CodeText)),
          s.length && (t.markers = s.concat(t.markers))),
        e.addNode(e.buffer.writeElements(o, -i).finish(OL.CodeBlock, a - i), i),
        !0
      );
    },
    FencedCode(e, t) {
      let n = IL(t);
      if (n < 0) return !1;
      let r = e.lineStart + t.pos,
        i = t.next,
        a = n - t.pos,
        o = t.skipSpace(n),
        s = FL(t.text, t.text.length, o),
        c = [hR(OL.CodeMark, r, r + a)];
      o < s && c.push(hR(OL.CodeInfo, e.lineStart + o, e.lineStart + s));
      for (let n = !0, r = !0, o = !1; e.nextLine() && t.depth >= e.stack.length; n = !1) {
        let s = t.pos;
        if (t.indent - t.baseIndent < 4)
          for (; s < t.text.length && t.text.charCodeAt(s) == i;) s++;
        if (s - t.pos >= a && t.skipSpace(s) == t.text.length) {
          for (let e of t.markers) c.push(e);
          (r && o && XL(c, e.lineStart - 1, e.lineStart),
            c.push(hR(OL.CodeMark, e.lineStart + t.pos, e.lineStart + s)),
            e.nextLine());
          break;
        } else {
          ((o = !0), n || (XL(c, e.lineStart - 1, e.lineStart), (r = !1)));
          for (let e of t.markers) c.push(e);
          let i = e.lineStart + t.basePos,
            a = e.lineStart + t.text.length;
          i < a && (XL(c, i, a), (r = !1));
        }
      }
      return (
        e.addNode(e.buffer.writeElements(c, -r).finish(OL.FencedCode, e.prevLineEnd() - r), r),
        !0
      );
    },
    Blockquote(e, t) {
      let n = LL(t);
      return n < 0
        ? !1
        : (e.startContext(OL.Blockquote, t.pos),
          e.addNode(OL.QuoteMark, e.lineStart + t.pos, e.lineStart + t.pos + 1),
          t.moveBase(t.pos + n),
          null);
    },
    HorizontalRule(e, t) {
      if (RL(t, e, !1) < 0) return !1;
      let n = e.lineStart + t.pos;
      return (e.nextLine(), e.addNode(OL.HorizontalRule, n), !0);
    },
    BulletList(e, t) {
      let n = BL(t, e, !1);
      if (n < 0) return !1;
      e.block.type != OL.BulletList && e.startContext(OL.BulletList, t.basePos, t.next);
      let r = YL(t, t.pos + 1);
      return (
        e.startContext(OL.ListItem, t.basePos, r - t.baseIndent),
        e.addNode(OL.ListMark, e.lineStart + t.pos, e.lineStart + t.pos + n),
        t.moveBaseColumn(r),
        null
      );
    },
    OrderedList(e, t) {
      let n = VL(t, e, !1);
      if (n < 0) return !1;
      e.block.type != OL.OrderedList &&
        e.startContext(OL.OrderedList, t.basePos, t.text.charCodeAt(t.pos + n - 1));
      let r = YL(t, t.pos + n);
      return (
        e.startContext(OL.ListItem, t.basePos, r - t.baseIndent),
        e.addNode(OL.ListMark, e.lineStart + t.pos, e.lineStart + t.pos + n),
        t.moveBaseColumn(r),
        null
      );
    },
    ATXHeading(e, t) {
      let n = HL(t);
      if (n < 0) return !1;
      let r = t.pos,
        i = e.lineStart + r,
        a = FL(t.text, t.text.length, r),
        o = a;
      for (; o > r && t.text.charCodeAt(o - 1) == t.next;) o--;
      (o == a || o == r || !NL(t.text.charCodeAt(o - 1))) && (o = t.text.length);
      let s = e.buffer
        .write(OL.HeaderMark, 0, n)
        .writeElements(e.parser.parseInline(t.text.slice(r + n + 1, o), i + n + 1), -i);
      o < t.text.length && s.write(OL.HeaderMark, o - r, a - r);
      let c = s.finish(OL.ATXHeading1 - 1 + n, t.text.length - r);
      return (e.nextLine(), e.addNode(c, i), !0);
    },
    HTMLBlock(e, t) {
      let n = JL(t, e, !1);
      if (n < 0) return !1;
      let r = e.lineStart + t.pos,
        i = qL[n][1],
        a = [],
        o = i != WL;
      for (; !i.test(t.text) && e.nextLine();) {
        if (t.depth < e.stack.length) {
          o = !1;
          break;
        }
        for (let e of t.markers) a.push(e);
      }
      o && e.nextLine();
      let s = i == GL ? OL.CommentBlock : i == KL ? OL.ProcessingInstructionBlock : OL.HTMLBlock,
        c = e.prevLineEnd();
      return (e.addNode(e.buffer.writeElements(a, -r).finish(s, c - r), r), !0);
    },
    SetextHeading: void 0,
  },
  QL = class {
    constructor(e) {
      ((this.stage = 0),
        (this.elts = []),
        (this.pos = 0),
        (this.start = e.start),
        this.advance(e.content));
    }
    nextLine(e, t, n) {
      if (this.stage == -1) return !1;
      let r =
          n.content +
          `
` +
          t.scrub(),
        i = this.advance(r);
      return i > -1 && i < r.length ? this.complete(e, n, i) : !1;
    }
    finish(e, t) {
      return (this.stage == 2 || this.stage == 3) && PL(t.content, this.pos) == t.content.length
        ? this.complete(e, t, t.content.length)
        : !1;
    }
    complete(e, t, n) {
      return (e.addLeafElement(t, hR(OL.LinkReference, this.start, this.start + n, this.elts)), !0);
    }
    nextStage(e) {
      return e
        ? ((this.pos = e.to - this.start), this.elts.push(e), this.stage++, !0)
        : (e === !1 && (this.stage = -1), !1);
    }
    advance(e) {
      for (;;)
        if (this.stage == -1) return -1;
        else if (this.stage == 0) {
          if (!this.nextStage(DR(e, this.pos, this.start, !0))) return -1;
          if (e.charCodeAt(this.pos) != 58) return (this.stage = -1);
          (this.elts.push(hR(OL.LinkMark, this.pos + this.start, this.pos + this.start + 1)),
            this.pos++);
        } else if (this.stage == 1) {
          if (!this.nextStage(TR(e, PL(e, this.pos), this.start))) return -1;
        } else if (this.stage == 2) {
          let t = PL(e, this.pos),
            n = 0;
          if (t > this.pos) {
            let r = ER(e, t, this.start);
            if (r) {
              let t = $L(e, r.to - this.start);
              t > 0 && (this.nextStage(r), (n = t));
            }
          }
          return ((n ||= $L(e, this.pos)), n > 0 && n < e.length ? n : -1);
        } else return $L(e, this.pos);
    }
  };
function $L(e, t) {
  for (; t < e.length; t++) {
    let n = e.charCodeAt(t);
    if (n == 10) break;
    if (!NL(n)) return -1;
  }
  return t;
}
var eR = class {
    nextLine(e, t, n) {
      let r = t.depth < e.stack.length ? -1 : UL(t),
        i = t.next;
      if (r < 0) return !1;
      let a = hR(OL.HeaderMark, e.lineStart + t.pos, e.lineStart + r);
      return (
        e.nextLine(),
        e.addLeafElement(
          n,
          hR(i == 61 ? OL.SetextHeading1 : OL.SetextHeading2, n.start, e.prevLineEnd(), [
            ...e.parser.parseInline(n.content, n.start),
            a,
          ]),
        ),
        !0
      );
    }
    finish() {
      return !1;
    }
  },
  tR = {
    LinkReference(e, t) {
      return t.content.charCodeAt(0) == 91 ? new QL(t) : null;
    },
    SetextHeading() {
      return new eR();
    },
  },
  nR = [
    (e, t) => HL(t) >= 0,
    (e, t) => IL(t) >= 0,
    (e, t) => LL(t) >= 0,
    (e, t) => BL(t, e, !0) >= 0,
    (e, t) => VL(t, e, !0) >= 0,
    (e, t) => RL(t, e, !0) >= 0,
    (e, t) => JL(t, e, !0) >= 0,
  ],
  rR = {
    text: ``,
    end: 0,
  },
  iR = class {
    constructor(e, t, n, r) {
      ((this.parser = e),
        (this.input = t),
        (this.ranges = r),
        (this.line = new AL()),
        (this.atEnd = !1),
        (this.reusePlaceholders = new Map()),
        (this.stoppedAt = null),
        (this.rangeI = 0),
        (this.to = r[r.length - 1].to),
        (this.lineStart = this.absoluteLineStart = this.absoluteLineEnd = r[0].from),
        (this.block = DL.create(OL.Document, 0, this.lineStart, 0, 0)),
        (this.stack = [this.block]),
        (this.fragments = n.length ? new jR(n, t) : null),
        this.readLine());
    }
    get parsedPos() {
      return this.absoluteLineStart;
    }
    advance() {
      if (this.stoppedAt != null && this.absoluteLineStart > this.stoppedAt) return this.finish();
      let { line: e } = this;
      for (;;) {
        for (let t = 0; ;) {
          let n = e.depth < this.stack.length ? this.stack[this.stack.length - 1] : null;
          for (; t < e.markers.length && (!n || e.markers[t].from < n.end);) {
            let n = e.markers[t++];
            this.addNode(n.type, n.from, n.to);
          }
          if (!n) break;
          this.finishContext();
        }
        if (e.pos < e.text.length) break;
        if (!this.nextLine()) return this.finish();
      }
      if (this.fragments && this.reuseFragment(e.basePos)) return null;
      start: for (;;) {
        for (let t of this.parser.blockParsers)
          if (t) {
            let n = t(this, e);
            if (n != 0) {
              if (n == 1) return null;
              e.forward();
              continue start;
            }
          }
        break;
      }
      let t = new kL(this.lineStart + e.pos, e.text.slice(e.pos));
      for (let e of this.parser.leafBlockParsers)
        if (e) {
          let n = e(this, t);
          n && t.parsers.push(n);
        }
      lines: for (; this.nextLine() && e.pos != e.text.length;) {
        if (e.indent < e.baseIndent + 4) {
          for (let n of this.parser.endLeafBlock) if (n(this, e, t)) break lines;
        }
        for (let n of t.parsers) if (n.nextLine(this, e, t)) return null;
        t.content +=
          `
` + e.scrub();
        for (let n of e.markers) t.marks.push(n);
      }
      return (this.finishLeaf(t), null);
    }
    stopAt(e) {
      if (this.stoppedAt != null && this.stoppedAt < e)
        throw RangeError(`Can't move stoppedAt forward`);
      this.stoppedAt = e;
    }
    reuseFragment(e) {
      if (
        !this.fragments.moveTo(this.absoluteLineStart + e, this.absoluteLineStart) ||
        !this.fragments.matches(this.block.hash)
      )
        return !1;
      let t = this.fragments.takeNodes(this);
      return t
        ? ((this.absoluteLineStart += t),
          (this.lineStart = MR(this.absoluteLineStart, this.ranges)),
          this.moveRangeI(),
          this.absoluteLineStart < this.to
            ? (this.lineStart++, this.absoluteLineStart++, this.readLine())
            : ((this.atEnd = !0), this.readLine()),
          !0)
        : !1;
    }
    get depth() {
      return this.stack.length;
    }
    parentType(e = this.depth - 1) {
      return this.parser.nodeSet.types[this.stack[e].type];
    }
    nextLine() {
      return (
        (this.lineStart += this.line.text.length),
        this.absoluteLineEnd >= this.to
          ? ((this.absoluteLineStart = this.absoluteLineEnd),
            (this.atEnd = !0),
            this.readLine(),
            !1)
          : (this.lineStart++,
            (this.absoluteLineStart = this.absoluteLineEnd + 1),
            this.moveRangeI(),
            this.readLine(),
            !0)
      );
    }
    peekLine() {
      return this.scanLine(this.absoluteLineEnd + 1).text;
    }
    moveRangeI() {
      for (
        ;
        this.rangeI < this.ranges.length - 1 &&
        this.absoluteLineStart >= this.ranges[this.rangeI].to;
      )
        (this.rangeI++,
          (this.absoluteLineStart = Math.max(
            this.absoluteLineStart,
            this.ranges[this.rangeI].from,
          )));
    }
    scanLine(e) {
      let t = rR;
      if (((t.end = e), e >= this.to)) t.text = ``;
      else if (((t.text = this.lineChunkAt(e)), (t.end += t.text.length), this.ranges.length > 1)) {
        let e = this.absoluteLineStart,
          n = this.rangeI;
        for (; this.ranges[n].to < t.end;) {
          n++;
          let r = this.ranges[n].from,
            i = this.lineChunkAt(r);
          ((t.end = r + i.length),
            (t.text = t.text.slice(0, this.ranges[n - 1].to - e) + i),
            (e = t.end - t.text.length));
        }
      }
      return t;
    }
    readLine() {
      let { line: e } = this,
        { text: t, end: n } = this.scanLine(this.absoluteLineStart);
      for (this.absoluteLineEnd = n, e.reset(t); e.depth < this.stack.length; e.depth++) {
        let t = this.stack[e.depth],
          n = this.parser.skipContextMarkup[t.type];
        if (!n) throw Error(`Unhandled block context ` + OL[t.type]);
        let r = this.line.markers.length;
        if (!n(t, this, e)) {
          (this.line.markers.length > r &&
            (t.end = this.line.markers[this.line.markers.length - 1].to),
            e.forward());
          break;
        }
        e.forward();
      }
    }
    lineChunkAt(e) {
      let t = this.input.chunk(e),
        n;
      if (this.input.lineChunks)
        n =
          t ==
          `
`
            ? ``
            : t;
      else {
        let e = t.indexOf(`
`);
        n = e < 0 ? t : t.slice(0, e);
      }
      return e + n.length > this.to ? n.slice(0, this.to - e) : n;
    }
    prevLineEnd() {
      return this.atEnd ? this.lineStart : this.lineStart - 1;
    }
    startContext(e, t, n = 0) {
      ((this.block = DL.create(
        e,
        n,
        this.lineStart + t,
        this.block.hash,
        this.lineStart + this.line.text.length,
      )),
        this.stack.push(this.block));
    }
    startComposite(e, t, n = 0) {
      this.startContext(this.parser.getNodeType(e), t, n);
    }
    addNode(e, t, n) {
      (typeof e == `number` &&
        (e = new rt(this.parser.nodeSet.types[e], dR, dR, (n ?? this.prevLineEnd()) - t)),
        this.block.addChild(e, t - this.block.from));
    }
    addElement(e) {
      this.block.addChild(e.toTree(this.parser.nodeSet), e.from - this.block.from);
    }
    addLeafElement(e, t) {
      this.addNode(
        this.buffer.writeElements(kR(t.children, e.marks), -t.from).finish(t.type, t.to - t.from),
        t.from,
      );
    }
    finishContext() {
      let e = this.stack.pop(),
        t = this.stack[this.stack.length - 1];
      (t.addChild(e.toTree(this.parser.nodeSet), e.from - t.from), (this.block = t));
    }
    finish() {
      for (; this.stack.length > 1;) this.finishContext();
      return this.addGaps(this.block.toTree(this.parser.nodeSet, this.lineStart));
    }
    addGaps(e) {
      return this.ranges.length > 1
        ? aR(this.ranges, 0, e.topNode, this.ranges[0].from, this.reusePlaceholders)
        : e;
    }
    finishLeaf(e) {
      for (let t of e.parsers) if (t.finish(this, e)) return;
      let t = kR(this.parser.parseInline(e.content, e.start), e.marks);
      this.addNode(
        this.buffer.writeElements(t, -e.start).finish(OL.Paragraph, e.content.length),
        e.start,
      );
    }
    elt(e, t, n, r) {
      return typeof e == `string` ? hR(this.parser.getNodeType(e), t, n, r) : new mR(e, t);
    }
    get buffer() {
      return new fR(this.parser.nodeSet);
    }
  };
function aR(e, t, n, r, i) {
  let a = e[t].to,
    o = [],
    s = [],
    c = n.from + r;
  function l(n, i) {
    for (; i ? n >= a : n > a;) {
      let i = e[t + 1].from - a;
      ((r += i), (n += i), t++, (a = e[t].to));
    }
  }
  for (let u = n.firstChild; u; u = u.nextSibling) {
    l(u.from + r, !0);
    let n = u.from + r,
      d,
      f = i.get(u.tree);
    (f ? (d = f) : u.to + r > a ? ((d = aR(e, t, u, r, i)), l(u.to + r, !1)) : (d = u.toTree()),
      o.push(d),
      s.push(n - c));
  }
  return (l(n.to + r, !1), new rt(n.type, o, s, n.to + r - c, n.tree ? n.tree.propValues : void 0));
}
var oR = class e extends Tn {
  constructor(e, t, n, r, i, a, o, s, c) {
    (super(),
      (this.nodeSet = e),
      (this.blockParsers = t),
      (this.leafBlockParsers = n),
      (this.blockNames = r),
      (this.endLeafBlock = i),
      (this.skipContextMarkup = a),
      (this.inlineParsers = o),
      (this.inlineNames = s),
      (this.wrappers = c),
      (this.nodeTypes = Object.create(null)));
    for (let t of e.types) this.nodeTypes[t.name] = t.id;
  }
  createParse(e, t, n) {
    let r = new iR(this, e, t, n);
    for (let i of this.wrappers) r = i(r, e, t, n);
    return r;
  }
  configure(t) {
    let n = cR(t);
    if (!n) return this;
    let { nodeSet: r, skipContextMarkup: i } = this,
      a = this.blockParsers.slice(),
      o = this.leafBlockParsers.slice(),
      s = this.blockNames.slice(),
      c = this.inlineParsers.slice(),
      l = this.inlineNames.slice(),
      u = this.endLeafBlock.slice(),
      d = this.wrappers;
    if (sR(n.defineNodes)) {
      i = Object.assign({}, i);
      let e = r.types.slice(),
        t;
      for (let r of n.defineNodes) {
        let {
          name: n,
          block: a,
          composite: o,
          style: s,
        } = typeof r == `string`
          ? {
              name: r,
            }
          : r;
        if (e.some((e) => e.name == n)) continue;
        o && (i[e.length] = (e, t, n) => o(t, n, e.value));
        let c = e.length,
          l = o
            ? [`Block`, `BlockContext`]
            : a
              ? c >= OL.ATXHeading1 && c <= OL.SetextHeading2
                ? [`Block`, `LeafBlock`, `Heading`]
                : [`Block`, `LeafBlock`]
              : void 0;
        (e.push(
          mt.define({
            id: c,
            name: n,
            props: l && [[ct.group, l]],
          }),
        ),
          s &&
            ((t ||= {}), Array.isArray(s) || s instanceof Yt ? (t[n] = s) : Object.assign(t, s)));
      }
      ((r = new dt(e)), t && (r = r.extend(ht(t))));
    }
    if ((sR(n.props) && (r = r.extend(...n.props)), sR(n.remove)))
      for (let e of n.remove) {
        let t = this.blockNames.indexOf(e),
          n = this.inlineNames.indexOf(e);
        (t > -1 && (a[t] = o[t] = void 0), n > -1 && (c[n] = void 0));
      }
    if (sR(n.parseBlock))
      for (let e of n.parseBlock) {
        let t = s.indexOf(e.name);
        if (t > -1) ((a[t] = e.parse), (o[t] = e.leaf));
        else {
          let t = e.before ? lR(s, e.before) : e.after ? lR(s, e.after) + 1 : s.length - 1;
          (a.splice(t, 0, e.parse), o.splice(t, 0, e.leaf), s.splice(t, 0, e.name));
        }
        e.endLeaf && u.push(e.endLeaf);
      }
    if (sR(n.parseInline))
      for (let e of n.parseInline) {
        let t = l.indexOf(e.name);
        if (t > -1) c[t] = e.parse;
        else {
          let t = e.before ? lR(l, e.before) : e.after ? lR(l, e.after) + 1 : l.length - 1;
          (c.splice(t, 0, e.parse), l.splice(t, 0, e.name));
        }
      }
    return (n.wrap && (d = d.concat(n.wrap)), new e(r, a, o, s, u, i, c, l, d));
  }
  getNodeType(e) {
    let t = this.nodeTypes[e];
    if (t == null) throw RangeError(`Unknown node type '${e}'`);
    return t;
  }
  parseInline(e, t) {
    let n = new OR(this, e, t);
    outer: for (let e = t; e < n.end;) {
      let t = n.char(e);
      for (let r of this.inlineParsers)
        if (r) {
          let i = r(n, t, e);
          if (i >= 0) {
            e = i;
            continue outer;
          }
        }
      e++;
    }
    return n.resolveMarkers(0);
  }
};
function sR(e) {
  return e != null && e.length > 0;
}
function cR(e) {
  if (!Array.isArray(e)) return e;
  if (e.length == 0) return null;
  let t = cR(e[0]);
  if (e.length == 1) return t;
  let n = cR(e.slice(1));
  if (!n || !t) return t || n;
  let r = (e, t) => (e || dR).concat(t || dR),
    i = t.wrap,
    a = n.wrap;
  return {
    props: r(t.props, n.props),
    defineNodes: r(t.defineNodes, n.defineNodes),
    parseBlock: r(t.parseBlock, n.parseBlock),
    parseInline: r(t.parseInline, n.parseInline),
    remove: r(t.remove, n.remove),
    wrap: i ? (a ? (e, t, n, r) => i(a(e, t, n, r), t, n, r) : i) : a,
  };
}
function lR(e, t) {
  let n = e.indexOf(t);
  if (n < 0) throw RangeError(`Position specified relative to unknown parser ${t}`);
  return n;
}
var uR = [mt.none];
for (let e = 1, t; (t = OL[e]); e++)
  uR[e] = mt.define({
    id: e,
    name: t,
    props:
      e >= OL.Escape
        ? []
        : [[ct.group, e in ML ? [`Block`, `BlockContext`] : [`Block`, `LeafBlock`]]],
    top: t == `Document`,
  });
var dR = [],
  fR = class {
    constructor(e) {
      ((this.nodeSet = e), (this.content = []), (this.nodes = []));
    }
    write(e, t, n, r = 0) {
      return (this.content.push(e, t, n, 4 + r * 4), this);
    }
    writeElements(e, t = 0) {
      for (let n of e) n.writeTo(this, t);
      return this;
    }
    finish(e, t) {
      return rt.build({
        buffer: this.content,
        nodeSet: this.nodeSet,
        reused: this.nodes,
        topID: e,
        length: t,
      });
    }
  },
  pR = class {
    constructor(e, t, n, r = dR) {
      ((this.type = e), (this.from = t), (this.to = n), (this.children = r));
    }
    writeTo(e, t) {
      let n = e.content.length;
      (e.writeElements(this.children, t),
        e.content.push(this.type, this.from + t, this.to + t, e.content.length + 4 - n));
    }
    toTree(e) {
      return new fR(e)
        .writeElements(this.children, -this.from)
        .finish(this.type, this.to - this.from);
    }
  },
  mR = class {
    constructor(e, t) {
      ((this.tree = e), (this.from = t));
    }
    get to() {
      return this.from + this.tree.length;
    }
    get type() {
      return this.tree.type.id;
    }
    get children() {
      return dR;
    }
    writeTo(e, t) {
      (e.nodes.push(this.tree), e.content.push(e.nodes.length - 1, this.from + t, this.to + t, -1));
    }
    toTree() {
      return this.tree;
    }
  };
function hR(e, t, n, r) {
  return new pR(e, t, n, r);
}
var gR = {
    resolve: `Emphasis`,
    mark: `EmphasisMark`,
  },
  _R = {
    resolve: `Emphasis`,
    mark: `EmphasisMark`,
  },
  vR = {},
  yR = {},
  bR = class {
    constructor(e, t, n, r) {
      ((this.type = e), (this.from = t), (this.to = n), (this.side = r));
    }
  },
  xR = `!"#$%&'()*+,-./:;<=>?@[\\]^_\`{|}~`,
  SR = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\u2010-\u2027]/;
try {
  SR = RegExp(`[\\p{S}|\\p{P}]`, `u`);
} catch {}
var CR = {
  Escape(e, t, n) {
    if (t != 92 || n == e.end - 1) return -1;
    let r = e.char(n + 1);
    for (let t = 0; t < 32; t++)
      if (xR.charCodeAt(t) == r) return e.append(hR(OL.Escape, n, n + 2));
    return -1;
  },
  Entity(e, t, n) {
    if (t != 38) return -1;
    let r = /^(?:#\d+|#x[a-f\d]+|\w+);/i.exec(e.slice(n + 1, n + 31));
    return r ? e.append(hR(OL.Entity, n, n + 1 + r[0].length)) : -1;
  },
  InlineCode(e, t, n) {
    if (t != 96 || (n && e.char(n - 1) == 96)) return -1;
    let r = n + 1;
    for (; r < e.end && e.char(r) == 96;) r++;
    let i = r - n,
      a = 0;
    for (; r < e.end; r++)
      if (e.char(r) == 96) {
        if ((a++, a == i && e.char(r + 1) != 96))
          return e.append(
            hR(OL.InlineCode, n, r + 1, [
              hR(OL.CodeMark, n, n + i),
              hR(OL.CodeMark, r + 1 - i, r + 1),
            ]),
          );
      } else a = 0;
    return -1;
  },
  HTMLTag(e, t, n) {
    if (t != 60 || n == e.end - 1) return -1;
    let r = e.slice(n + 1, e.end),
      i =
        /^(?:[a-z][-\w+.]+:[^\s>]+|[a-z\d.!#$%&'*+/=?^_`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*)>/i.exec(
          r,
        );
    if (i)
      return e.append(
        hR(OL.Autolink, n, n + 1 + i[0].length, [
          hR(OL.LinkMark, n, n + 1),
          hR(OL.URL, n + 1, n + i[0].length),
          hR(OL.LinkMark, n + i[0].length, n + 1 + i[0].length),
        ]),
      );
    let a = /^!--[^>](?:-[^-]|[^-])*?-->/i.exec(r);
    if (a) return e.append(hR(OL.Comment, n, n + 1 + a[0].length));
    let o = /^\?[^]*?\?>/.exec(r);
    if (o) return e.append(hR(OL.ProcessingInstruction, n, n + 1 + o[0].length));
    let s =
      /^(?:![A-Z][^]*?>|!\[CDATA\[[^]*?\]\]>|\/\s*[a-zA-Z][\w-]*\s*>|\s*[a-zA-Z][\w-]*(\s+[a-zA-Z:_][\w-.:]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*(\/\s*)?>)/.exec(
        r,
      );
    return s ? e.append(hR(OL.HTMLTag, n, n + 1 + s[0].length)) : -1;
  },
  Emphasis(e, t, n) {
    if (t != 95 && t != 42) return -1;
    let r = n + 1;
    for (; e.char(r) == t;) r++;
    let i = e.slice(n - 1, n),
      a = e.slice(r, r + 1),
      o = SR.test(i),
      s = SR.test(a),
      c = /\s|^$/.test(i),
      l = /\s|^$/.test(a),
      u = !l && (!s || c || o),
      d = !c && (!o || l || s),
      f = u && (t == 42 || !d || o),
      p = d && (t == 42 || !u || s);
    return e.append(new bR(t == 95 ? gR : _R, n, r, !!f | (p ? 2 : 0)));
  },
  HardBreak(e, t, n) {
    if (t == 92 && e.char(n + 1) == 10) return e.append(hR(OL.HardBreak, n, n + 2));
    if (t == 32) {
      let t = n + 1;
      for (; e.char(t) == 32;) t++;
      if (e.char(t) == 10 && t >= n + 2) return e.append(hR(OL.HardBreak, n, t + 1));
    }
    return -1;
  },
  Link(e, t, n) {
    return t == 91 ? e.append(new bR(vR, n, n + 1, 1)) : -1;
  },
  Image(e, t, n) {
    return t == 33 && e.char(n + 1) == 91 ? e.append(new bR(yR, n, n + 2, 1)) : -1;
  },
  LinkEnd(e, t, n) {
    if (t != 93) return -1;
    for (let t = e.parts.length - 1; t >= 0; t--) {
      let r = e.parts[t];
      if (r instanceof bR && (r.type == vR || r.type == yR)) {
        if (!r.side || (e.skipSpace(r.to) == n && !/[(\[]/.test(e.slice(n + 1, n + 2))))
          return ((e.parts[t] = null), -1);
        let i = e.takeContent(t),
          a = (e.parts[t] = wR(e, i, r.type == vR ? OL.Link : OL.Image, r.from, n + 1));
        if (r.type == vR)
          for (let n = 0; n < t; n++) {
            let t = e.parts[n];
            t instanceof bR && t.type == vR && (t.side = 0);
          }
        return a.to;
      }
    }
    return -1;
  },
};
function wR(e, t, n, r, i) {
  let { text: a } = e,
    o = e.char(i),
    s = i;
  if (
    (t.unshift(hR(OL.LinkMark, r, r + (n == OL.Image ? 2 : 1))),
    t.push(hR(OL.LinkMark, i - 1, i)),
    o == 40)
  ) {
    let n = e.skipSpace(i + 1),
      r = TR(a, n - e.offset, e.offset),
      o;
    (r &&
      ((n = e.skipSpace(r.to)),
      n != r.to && ((o = ER(a, n - e.offset, e.offset)), o && (n = e.skipSpace(o.to)))),
      e.char(n) == 41 &&
        (t.push(hR(OL.LinkMark, i, i + 1)),
        (s = n + 1),
        r && t.push(r),
        o && t.push(o),
        t.push(hR(OL.LinkMark, n, s))));
  } else if (o == 91) {
    let n = DR(a, i - e.offset, e.offset, !1);
    n && (t.push(n), (s = n.to));
  }
  return hR(n, r, s, t);
}
function TR(e, t, n) {
  if (e.charCodeAt(t) == 60) {
    for (let r = t + 1; r < e.length; r++) {
      let i = e.charCodeAt(r);
      if (i == 62) return hR(OL.URL, t + n, r + 1 + n);
      if (i == 60 || i == 10) return !1;
    }
    return null;
  } else {
    let r = 0,
      i = t;
    for (let t = !1; i < e.length; i++) {
      let n = e.charCodeAt(i);
      if (NL(n)) break;
      if (t) t = !1;
      else if (n == 40) r++;
      else if (n == 41) {
        if (!r) break;
        r--;
      } else n == 92 && (t = !0);
    }
    return i > t ? hR(OL.URL, t + n, i + n) : i == e.length ? null : !1;
  }
}
function ER(e, t, n) {
  let r = e.charCodeAt(t);
  if (r != 39 && r != 34 && r != 40) return !1;
  let i = r == 40 ? 41 : r;
  for (let r = t + 1, a = !1; r < e.length; r++) {
    let o = e.charCodeAt(r);
    if (a) a = !1;
    else if (o == i) return hR(OL.LinkTitle, t + n, r + 1 + n);
    else o == 92 && (a = !0);
  }
  return null;
}
function DR(e, t, n, r) {
  for (let i = !1, a = t + 1, o = Math.min(e.length, a + 999); a < o; a++) {
    let o = e.charCodeAt(a);
    if (i) i = !1;
    else if (o == 93) return r ? !1 : hR(OL.LinkLabel, t + n, a + 1 + n);
    else {
      if ((r && !NL(o) && (r = !1), o == 91)) return !1;
      o == 92 && (i = !0);
    }
  }
  return null;
}
var OR = class {
  constructor(e, t, n) {
    ((this.parser = e), (this.text = t), (this.offset = n), (this.parts = []));
  }
  char(e) {
    return e >= this.end ? -1 : this.text.charCodeAt(e - this.offset);
  }
  get end() {
    return this.offset + this.text.length;
  }
  slice(e, t) {
    return this.text.slice(e - this.offset, t - this.offset);
  }
  append(e) {
    return (this.parts.push(e), e.to);
  }
  addDelimiter(e, t, n, r, i) {
    return this.append(new bR(e, t, n, !!r | (i ? 2 : 0)));
  }
  get hasOpenLink() {
    for (let e = this.parts.length - 1; e >= 0; e--) {
      let t = this.parts[e];
      if (t instanceof bR && (t.type == vR || t.type == yR)) return !0;
    }
    return !1;
  }
  addElement(e) {
    return this.append(e);
  }
  resolveMarkers(e) {
    for (let t = e; t < this.parts.length; t++) {
      let n = this.parts[t];
      if (!(n instanceof bR && n.type.resolve && n.side & 2)) continue;
      let r = n.type == gR || n.type == _R,
        i = n.to - n.from,
        a,
        o = t - 1;
      for (; o >= e; o--) {
        let e = this.parts[o];
        if (
          e instanceof bR &&
          e.side & 1 &&
          e.type == n.type &&
          !(
            r &&
            (n.side & 1 || e.side & 2) &&
            (e.to - e.from + i) % 3 == 0 &&
            ((e.to - e.from) % 3 || i % 3)
          )
        ) {
          a = e;
          break;
        }
      }
      if (!a) continue;
      let s = n.type.resolve,
        c = [],
        l = a.from,
        u = n.to;
      if (r) {
        let e = Math.min(2, a.to - a.from, i);
        ((l = a.to - e), (u = n.from + e), (s = e == 1 ? `Emphasis` : `StrongEmphasis`));
      }
      a.type.mark && c.push(this.elt(a.type.mark, l, a.to));
      for (let e = o + 1; e < t; e++)
        (this.parts[e] instanceof pR && c.push(this.parts[e]), (this.parts[e] = null));
      n.type.mark && c.push(this.elt(n.type.mark, n.from, u));
      let d = this.elt(s, l, u, c);
      ((this.parts[o] = r && a.from != l ? new bR(a.type, a.from, l, a.side) : null),
        (this.parts[t] = r && n.to != u ? new bR(n.type, u, n.to, n.side) : null)
          ? this.parts.splice(t, 0, d)
          : (this.parts[t] = d));
    }
    let t = [];
    for (let n = e; n < this.parts.length; n++) {
      let e = this.parts[n];
      e instanceof pR && t.push(e);
    }
    return t;
  }
  findOpeningDelimiter(e) {
    for (let t = this.parts.length - 1; t >= 0; t--) {
      let n = this.parts[t];
      if (n instanceof bR && n.type == e && n.side & 1) return t;
    }
    return null;
  }
  takeContent(e) {
    let t = this.resolveMarkers(e);
    return ((this.parts.length = e), t);
  }
  getDelimiterAt(e) {
    let t = this.parts[e];
    return t instanceof bR ? t : null;
  }
  skipSpace(e) {
    return PL(this.text, e - this.offset) + this.offset;
  }
  elt(e, t, n, r) {
    return typeof e == `string` ? hR(this.parser.getNodeType(e), t, n, r) : new mR(e, t);
  }
};
((OR.linkStart = vR), (OR.imageStart = yR));
function kR(e, t) {
  if (!t.length) return e;
  if (!e.length) return t;
  let n = e.slice(),
    r = 0;
  for (let e of t) {
    for (; r < n.length && n[r].to < e.to;) r++;
    if (r < n.length && n[r].from < e.from) {
      let t = n[r];
      t instanceof pR && (n[r] = new pR(t.type, t.from, t.to, kR(t.children, [e])));
    } else n.splice(r++, 0, e);
  }
  return n;
}
var AR = [OL.CodeBlock, OL.ListItem, OL.OrderedList, OL.BulletList],
  jR = class {
    constructor(e, t) {
      ((this.fragments = e),
        (this.input = t),
        (this.i = 0),
        (this.fragment = null),
        (this.fragmentEnd = -1),
        (this.cursor = null),
        e.length && (this.fragment = e[this.i++]));
    }
    nextFragment() {
      ((this.fragment = this.i < this.fragments.length ? this.fragments[this.i++] : null),
        (this.cursor = null),
        (this.fragmentEnd = -1));
    }
    moveTo(e, t) {
      for (; this.fragment && this.fragment.to <= e;) this.nextFragment();
      if (!this.fragment || this.fragment.from > (e ? e - 1 : 0)) return !1;
      if (this.fragmentEnd < 0) {
        let e = this.fragment.to;
        for (
          ;
          e > 0 &&
          this.input.read(e - 1, e) !=
            `
`;
        )
          e--;
        this.fragmentEnd = e ? e - 1 : 0;
      }
      let n = this.cursor;
      n || ((n = this.cursor = this.fragment.tree.cursor()), n.firstChild());
      let r = e + this.fragment.offset;
      for (; n.to <= r;) if (!n.parent()) return !1;
      for (;;) {
        if (n.from >= r) return this.fragment.from <= t;
        if (!n.childAfter(r)) return !1;
      }
    }
    matches(e) {
      let t = this.cursor.tree;
      return t && t.prop(ct.contextHash) == e;
    }
    takeNodes(e) {
      let t = this.cursor,
        n = this.fragment.offset,
        r = this.fragmentEnd - +!!this.fragment.openEnd,
        i = e.absoluteLineStart,
        a = i,
        o = e.block.children.length,
        s = a,
        c = o;
      for (;;) {
        if (t.to - n > r) {
          if (t.type.isAnonymous && t.firstChild()) continue;
          break;
        }
        let i = MR(t.from - n, e.ranges);
        if (t.to - n <= e.ranges[e.rangeI].to) e.addNode(t.tree, i);
        else {
          let n = new rt(e.parser.nodeSet.types[OL.Paragraph], [], [], 0, e.block.hashProp);
          (e.reusePlaceholders.set(n, t.tree), e.addNode(n, i));
        }
        if (
          (t.type.is(`Block`) &&
            (AR.indexOf(t.type.id) < 0
              ? ((a = t.to - n), (o = e.block.children.length))
              : ((a = s), (o = c)),
            (s = t.to - n),
            (c = e.block.children.length)),
          !t.nextSibling())
        )
          break;
      }
      for (; e.block.children.length > o;) (e.block.children.pop(), e.block.positions.pop());
      return a - i;
    }
  };
function MR(e, t) {
  let n = e;
  for (let r = 1; r < t.length; r++) {
    let i = t[r - 1].to,
      a = t[r].from;
    i < e && (n -= a - i);
  }
  return n;
}
var NR = ht({
    "Blockquote/...": G.quote,
    HorizontalRule: G.contentSeparator,
    "ATXHeading1/... SetextHeading1/...": G.heading1,
    "ATXHeading2/... SetextHeading2/...": G.heading2,
    "ATXHeading3/...": G.heading3,
    "ATXHeading4/...": G.heading4,
    "ATXHeading5/...": G.heading5,
    "ATXHeading6/...": G.heading6,
    "Comment CommentBlock": G.comment,
    Escape: G.escape,
    Entity: G.character,
    "Emphasis/...": G.emphasis,
    "StrongEmphasis/...": G.strong,
    "Link/... Image/...": G.link,
    "OrderedList/... BulletList/...": G.list,
    "BlockQuote/...": G.quote,
    "InlineCode CodeText": G.monospace,
    "URL Autolink": G.url,
    "HeaderMark HardBreak QuoteMark ListMark LinkMark EmphasisMark CodeMark":
      G.processingInstruction,
    "CodeInfo LinkLabel": G.labelName,
    LinkTitle: G.string,
    Paragraph: G.content,
  }),
  PR = new oR(
    new dt(uR).extend(NR),
    Object.keys(ZL).map((e) => ZL[e]),
    Object.keys(ZL).map((e) => tR[e]),
    Object.keys(ZL),
    nR,
    ML,
    Object.keys(CR).map((e) => CR[e]),
    Object.keys(CR),
    [],
  );
function FR(e, t, n) {
  let r = [];
  for (let i = e.firstChild, a = t; ; i = i.nextSibling) {
    let e = i ? i.from : n;
    if (
      (e > a &&
        r.push({
          from: a,
          to: e,
        }),
      !i)
    )
      break;
    a = i.to;
  }
  return r;
}
function IR(e) {
  let { codeParser: t, htmlParser: n } = e;
  return {
    wrap: Tt((e, r) => {
      let i = e.type.id;
      if (t && (i == OL.CodeBlock || i == OL.FencedCode)) {
        let n = ``;
        if (i == OL.FencedCode) {
          let t = e.node.getChild(OL.CodeInfo);
          t && (n = r.read(t.from, t.to));
        }
        let a = t(n);
        if (a)
          return {
            parser: a,
            overlay: (e) => e.type.id == OL.CodeText,
            bracketed: i == OL.FencedCode,
          };
      } else if (n && (i == OL.HTMLBlock || i == OL.HTMLTag || i == OL.CommentBlock))
        return {
          parser: n,
          overlay: FR(e.node, e.from, e.to),
        };
      return null;
    }),
  };
}
var LR = {
    resolve: `Strikethrough`,
    mark: `StrikethroughMark`,
  },
  RR = {
    defineNodes: [
      {
        name: `Strikethrough`,
        style: {
          "Strikethrough/...": G.strikethrough,
        },
      },
      {
        name: `StrikethroughMark`,
        style: G.processingInstruction,
      },
    ],
    parseInline: [
      {
        name: `Strikethrough`,
        parse(e, t, n) {
          if (t != 126 || e.char(n + 1) != 126 || e.char(n + 2) == 126) return -1;
          let r = e.slice(n - 1, n),
            i = e.slice(n + 2, n + 3),
            a = /\s|^$/.test(r),
            o = /\s|^$/.test(i),
            s = SR.test(r),
            c = SR.test(i);
          return e.addDelimiter(LR, n, n + 2, !o && (!c || a || s), !a && (!s || o || c));
        },
        after: `Emphasis`,
      },
    ],
  };
function zR(e, t, n = 0, r, i = 0) {
  let a = 0,
    o = !0,
    s = -1,
    c = -1,
    l = !1,
    u = () => {
      r.push(e.elt(`TableCell`, i + s, i + c, e.parser.parseInline(t.slice(s, c), i + s)));
    };
  for (let d = n; d < t.length; d++) {
    let n = t.charCodeAt(d);
    (n == 124 && !l
      ? ((!o || s > -1) && a++,
        (o = !1),
        r && (s > -1 && u(), r.push(e.elt(`TableDelimiter`, d + i, d + i + 1))),
        (s = c = -1))
      : (l || (n != 32 && n != 9)) && (s < 0 && (s = d), (c = d + 1)),
      (l = !l && n == 92));
  }
  return (s > -1 && (a++, r && u()), a);
}
function BR(e, t) {
  for (let n = t; n < e.length; n++) {
    let t = e.charCodeAt(n);
    if (t == 124) return !0;
    t == 92 && n++;
  }
  return !1;
}
var VR = /^\|?(\s*:?-+:?\s*\|)+(\s*:?-+:?\s*)?$/,
  HR = class {
    constructor() {
      this.rows = null;
    }
    nextLine(e, t, n) {
      if (this.rows == null) {
        this.rows = !1;
        let r;
        if ((t.next == 45 || t.next == 58 || t.next == 124) && VR.test((r = t.text.slice(t.pos)))) {
          let i = [];
          zR(e, n.content, 0, i, n.start) == zR(e, r, 0) &&
            (this.rows = [
              e.elt(`TableHeader`, n.start, n.start + n.content.length, i),
              e.elt(`TableDelimiter`, e.lineStart + t.pos, e.lineStart + t.text.length),
            ]);
        }
      } else if (this.rows) {
        let n = [];
        (zR(e, t.text, t.pos, n, e.lineStart),
          this.rows.push(e.elt(`TableRow`, e.lineStart + t.pos, e.lineStart + t.text.length, n)));
      }
      return !1;
    }
    finish(e, t) {
      return this.rows
        ? (e.addLeafElement(t, e.elt(`Table`, t.start, t.start + t.content.length, this.rows)), !0)
        : !1;
    }
  },
  UR = {
    defineNodes: [
      {
        name: `Table`,
        block: !0,
      },
      {
        name: `TableHeader`,
        style: {
          "TableHeader/...": G.heading,
        },
      },
      `TableRow`,
      {
        name: `TableCell`,
        style: G.content,
      },
      {
        name: `TableDelimiter`,
        style: G.processingInstruction,
      },
    ],
    parseBlock: [
      {
        name: `Table`,
        leaf(e, t) {
          return BR(t.content, 0) ? new HR() : null;
        },
        endLeaf(e, t, n) {
          if (n.parsers.some((e) => e instanceof HR) || !BR(t.text, t.basePos)) return !1;
          let r = e.peekLine();
          return VR.test(r) && zR(e, t.text, t.basePos) == zR(e, r, t.basePos);
        },
        before: `SetextHeading`,
      },
    ],
  },
  WR = class {
    nextLine() {
      return !1;
    }
    finish(e, t) {
      return (
        e.addLeafElement(
          t,
          e.elt(`Task`, t.start, t.start + t.content.length, [
            e.elt(`TaskMarker`, t.start, t.start + 3),
            ...e.parser.parseInline(t.content.slice(3), t.start + 3),
          ]),
        ),
        !0
      );
    }
  },
  GR = {
    defineNodes: [
      {
        name: `Task`,
        block: !0,
        style: G.list,
      },
      {
        name: `TaskMarker`,
        style: G.atom,
      },
    ],
    parseBlock: [
      {
        name: `TaskList`,
        leaf(e, t) {
          return /^\[[ xX]\][ \t]/.test(t.content) && e.parentType().name == `ListItem`
            ? new WR()
            : null;
        },
        after: `SetextHeading`,
      },
    ],
  },
  KR = /(www\.)|(https?:\/\/)|([\w.+-]{1,100}@)|(mailto:|xmpp:)/gy,
  qR = /[\w-]+(\.[\w-]+)+(:\d+)?(\/[^\s<]*)?/gy,
  JR = /[\w-]+\.[\w-]+($|[/:])/,
  YR = /[\w.+-]+@[\w-]+(\.[\w.-]+)+/gy,
  XR = /\/[a-zA-Z\d@.]+/gy;
function ZR(e, t, n, r) {
  let i = 0;
  for (let a = t; a < n; a++) e[a] == r && i++;
  return i;
}
function QR(e, t) {
  qR.lastIndex = t;
  let n = qR.exec(e);
  if (!n || JR.exec(n[0])[0].indexOf(`_`) > -1) return -1;
  let r = t + n[0].length;
  for (;;) {
    let n = e[r - 1],
      i;
    if (/[?!.,:*_~]/.test(n) || (n == `)` && ZR(e, t, r, `)`) > ZR(e, t, r, `(`))) r--;
    else if (n == `;` && (i = /&(?:#\d+|#x[a-f\d]+|\w+);$/.exec(e.slice(t, r)))) r = t + i.index;
    else break;
  }
  return r;
}
function $R(e, t) {
  YR.lastIndex = t;
  let n = YR.exec(e);
  if (!n) return -1;
  let r = n[0][n[0].length - 1];
  return r == `_` || r == `-` ? -1 : t + n[0].length - +(r == `.`);
}
var ez = [
  UR,
  GR,
  RR,
  {
    parseInline: [
      {
        name: `Autolink`,
        parse(e, t, n) {
          let r = n - e.offset;
          if (r && /\w/.test(e.text[r - 1])) return -1;
          KR.lastIndex = r;
          let i = KR.exec(e.text),
            a = -1;
          return !i ||
            (i[1] || i[2]
              ? ((a = QR(e.text, r + i[0].length)),
                a > -1 &&
                  e.hasOpenLink &&
                  (a = r + /([^\[\]]|\[[^\]]*\])*/.exec(e.text.slice(r, a))[0].length))
              : i[3]
                ? (a = $R(e.text, r))
                : ((a = $R(e.text, r + i[0].length)),
                  a > -1 &&
                    i[0] == `xmpp:` &&
                    ((XR.lastIndex = a), (i = XR.exec(e.text)), i && (a = i.index + i[0].length))),
            a < 0)
            ? -1
            : (e.addElement(e.elt(`URL`, n, a + e.offset)), a + e.offset);
        },
      },
    ],
  },
];
function tz(e, t, n) {
  return (r, i, a) => {
    if (i != e || r.char(a + 1) == e) return -1;
    let o = [r.elt(n, a, a + 1)];
    for (let i = a + 1; i < r.end; i++) {
      let s = r.char(i);
      if (s == e) return r.addElement(r.elt(t, a, i + 1, o.concat(r.elt(n, i, i + 1))));
      if ((s == 92 && o.push(r.elt(`Escape`, i, i++ + 2)), NL(s))) break;
    }
    return -1;
  };
}
var nz = {
    defineNodes: [
      {
        name: `Superscript`,
        style: G.special(G.content),
      },
      {
        name: `SuperscriptMark`,
        style: G.processingInstruction,
      },
    ],
    parseInline: [
      {
        name: `Superscript`,
        parse: tz(94, `Superscript`, `SuperscriptMark`),
      },
    ],
  },
  rz = {
    defineNodes: [
      {
        name: `Subscript`,
        style: G.special(G.content),
      },
      {
        name: `SubscriptMark`,
        style: G.processingInstruction,
      },
    ],
    parseInline: [
      {
        name: `Subscript`,
        parse: tz(126, `Subscript`, `SubscriptMark`),
      },
    ],
  },
  iz = {
    defineNodes: [
      {
        name: `Emoji`,
        style: G.character,
      },
    ],
    parseInline: [
      {
        name: `Emoji`,
        parse(e, t, n) {
          let r;
          return t != 58 || !(r = /^[a-zA-Z_0-9]+:/.exec(e.slice(n + 1, e.end)))
            ? -1
            : e.addElement(e.elt(`Emoji`, n, n + 1 + r[0].length));
        },
      },
    ],
  },
  az = 55,
  oz = 1,
  sz = 56,
  cz = 2,
  lz = 57,
  uz = 3,
  dz = 4,
  fz = 5,
  pz = 6,
  mz = 7,
  hz = 8,
  gz = 9,
  _z = 10,
  vz = 11,
  yz = 12,
  bz = 13,
  xz = 58,
  Sz = 14,
  Cz = 15,
  wz = 59,
  Tz = 21,
  Ez = 23,
  Dz = 24,
  Oz = 25,
  kz = 27,
  Az = 28,
  jz = 29,
  Mz = 32,
  Nz = 35,
  Pz = 37,
  Fz = 38,
  Iz = 0,
  Lz = 1,
  Rz = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    command: !0,
    embed: !0,
    frame: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0,
    menuitem: !0,
  },
  zz = {
    dd: !0,
    li: !0,
    optgroup: !0,
    option: !0,
    p: !0,
    rp: !0,
    rt: !0,
    tbody: !0,
    td: !0,
    tfoot: !0,
    th: !0,
    tr: !0,
  },
  Bz = {
    dd: {
      dd: !0,
      dt: !0,
    },
    dt: {
      dd: !0,
      dt: !0,
    },
    li: {
      li: !0,
    },
    option: {
      option: !0,
      optgroup: !0,
    },
    optgroup: {
      optgroup: !0,
    },
    p: {
      address: !0,
      article: !0,
      aside: !0,
      blockquote: !0,
      dir: !0,
      div: !0,
      dl: !0,
      fieldset: !0,
      footer: !0,
      form: !0,
      h1: !0,
      h2: !0,
      h3: !0,
      h4: !0,
      h5: !0,
      h6: !0,
      header: !0,
      hgroup: !0,
      hr: !0,
      menu: !0,
      nav: !0,
      ol: !0,
      p: !0,
      pre: !0,
      section: !0,
      table: !0,
      ul: !0,
    },
    rp: {
      rp: !0,
      rt: !0,
    },
    rt: {
      rp: !0,
      rt: !0,
    },
    tbody: {
      tbody: !0,
      tfoot: !0,
    },
    td: {
      td: !0,
      th: !0,
    },
    tfoot: {
      tbody: !0,
    },
    th: {
      td: !0,
      th: !0,
    },
    thead: {
      tbody: !0,
      tfoot: !0,
    },
    tr: {
      tr: !0,
    },
  };
function Vz(e) {
  return (
    e == 45 ||
    e == 46 ||
    e == 58 ||
    (e >= 65 && e <= 90) ||
    e == 95 ||
    (e >= 97 && e <= 122) ||
    e >= 161
  );
}
var Hz = null,
  Uz = null,
  Wz = 0;
function Gz(e, t) {
  let n = e.pos + t;
  if (Wz == n && Uz == e) return Hz;
  let r = e.peek(t),
    i = ``;
  for (; Vz(r);) ((i += String.fromCharCode(r)), (r = e.peek(++t)));
  return ((Uz = e), (Wz = n), (Hz = i ? i.toLowerCase() : r == Yz || r == Xz ? void 0 : null));
}
var Kz = 60,
  qz = 62,
  Jz = 47,
  Yz = 63,
  Xz = 33,
  Zz = 45;
function Qz(e, t) {
  ((this.name = e), (this.parent = t));
}
var $z = [pz, _z, mz, hz, gz],
  eB = new pn({
    start: null,
    shift(e, t, n, r) {
      return $z.indexOf(t) > -1 ? new Qz(Gz(r, 1) || ``, e) : e;
    },
    reduce(e, t) {
      return t == Tz && e ? e.parent : e;
    },
    reuse(e, t, n, r) {
      let i = t.type.id;
      return i == pz || i == Pz ? new Qz(Gz(r, 1) || ``, e) : e;
    },
    strict: !1,
  }),
  tB = new tn(
    (e, t) => {
      if (e.next != Kz) {
        e.next < 0 && t.context && e.acceptToken(xz);
        return;
      }
      e.advance();
      let n = e.next == Jz;
      n && e.advance();
      let r = Gz(e, 0);
      if (r === void 0) return;
      if (!r) return e.acceptToken(n ? Cz : Sz);
      let i = t.context ? t.context.name : null;
      if (n) {
        if (r == i) return e.acceptToken(vz);
        if (i && zz[i]) return e.acceptToken(xz, -2);
        if (t.dialectEnabled(Iz)) return e.acceptToken(yz);
        for (let e = t.context; e; e = e.parent) if (e.name == r) return;
        e.acceptToken(bz);
      } else {
        if (r == `script`) return e.acceptToken(mz);
        if (r == `style`) return e.acceptToken(hz);
        if (r == `textarea`) return e.acceptToken(gz);
        if (Rz.hasOwnProperty(r)) return e.acceptToken(_z);
        i && Bz[i] && Bz[i][r] ? e.acceptToken(xz, -1) : e.acceptToken(pz);
      }
    },
    {
      contextual: !0,
    },
  ),
  nB = new tn((e) => {
    for (let t = 0, n = 0; ; n++) {
      if (e.next < 0) {
        n && e.acceptToken(wz);
        break;
      }
      if (e.next == Zz) t++;
      else if (e.next == qz && t >= 2) {
        n >= 3 && e.acceptToken(wz, -2);
        break;
      } else t = 0;
      e.advance();
    }
  });
function rB(e) {
  for (; e; e = e.parent) if (e.name == `svg` || e.name == `math`) return !0;
  return !1;
}
var iB = new tn((e, t) => {
  if (e.next == Jz && e.peek(1) == qz) {
    let n = t.dialectEnabled(Lz) || rB(t.context);
    e.acceptToken(n ? fz : dz, 2);
  } else e.next == qz && e.acceptToken(dz, 1);
});
function aB(e, t, n) {
  let r = 2 + e.length;
  return new tn((i) => {
    for (let a = 0, o = 0, s = 0; ; s++) {
      if (i.next < 0) {
        s && i.acceptToken(t);
        break;
      }
      if (
        (a == 0 && i.next == Kz) ||
        (a == 1 && i.next == Jz) ||
        (a >= 2 && a < r && i.next == e.charCodeAt(a - 2))
      )
        (a++, o++);
      else if (a == r && i.next == qz) {
        s > o ? i.acceptToken(t, -o) : i.acceptToken(n, -(o - 2));
        break;
      } else if ((i.next == 10 || i.next == 13) && s) {
        i.acceptToken(t, 1);
        break;
      } else a = o = 0;
      i.advance();
    }
  });
}
var oB = aB(`script`, az, oz),
  sB = aB(`style`, sz, cz),
  cB = aB(`textarea`, lz, uz),
  lB = ht({
    "Text RawText IncompleteTag IncompleteCloseTag": G.content,
    "StartTag StartCloseTag SelfClosingEndTag EndTag": G.angleBracket,
    TagName: G.tagName,
    "MismatchedCloseTag/TagName": [G.tagName, G.invalid],
    AttributeName: G.attributeName,
    "AttributeValue UnquotedAttributeValue": G.attributeValue,
    Is: G.definitionOperator,
    "EntityReference CharacterReference": G.character,
    Comment: G.blockComment,
    ProcessingInst: G.processingInstruction,
    DoctypeDecl: G.documentMeta,
  }),
  uB = ln.deserialize({
    version: 14,
    states:
      ",xOVO!rOOO!ZQ#tO'#CrO!`Q#tO'#C{O!eQ#tO'#DOO!jQ#tO'#DRO!oQ#tO'#DTO!tOaO'#CqO#PObO'#CqO#[OdO'#CqO$kO!rO'#CqOOO`'#Cq'#CqO$rO$fO'#DUO$zQ#tO'#DWO%PQ#tO'#DXOOO`'#Dl'#DlOOO`'#DZ'#DZQVO!rOOO%UQ&rO,59^O%aQ&rO,59gO%lQ&rO,59jO%wQ&rO,59mO&SQ&rO,59oOOOa'#D_'#D_O&_OaO'#CyO&jOaO,59]OOOb'#D`'#D`O&rObO'#C|O&}ObO,59]OOOd'#Da'#DaO'VOdO'#DPO'bOdO,59]OOO`'#Db'#DbO'jO!rO,59]O'qQ#tO'#DSOOO`,59],59]OOOp'#Dc'#DcO'vO$fO,59pOOO`,59p,59pO(OQ#|O,59rO(TQ#|O,59sOOO`-E7X-E7XO(YQ&rO'#CtOOQW'#D['#D[O(hQ&rO1G.xOOOa1G.x1G.xOOO`1G/Z1G/ZO(sQ&rO1G/ROOOb1G/R1G/RO)OQ&rO1G/UOOOd1G/U1G/UO)ZQ&rO1G/XOOO`1G/X1G/XO)fQ&rO1G/ZOOOa-E7]-E7]O)qQ#tO'#CzOOO`1G.w1G.wOOOb-E7^-E7^O)vQ#tO'#C}OOOd-E7_-E7_O){Q#tO'#DQOOO`-E7`-E7`O*QQ#|O,59nOOOp-E7a-E7aOOO`1G/[1G/[OOO`1G/^1G/^OOO`1G/_1G/_O*VQ,UO,59`OOQW-E7Y-E7YOOOa7+$d7+$dOOO`7+$u7+$uOOOb7+$m7+$mOOOd7+$p7+$pOOO`7+$s7+$sO*bQ#|O,59fO*gQ#|O,59iO*lQ#|O,59lOOO`1G/Y1G/YO*qO7[O'#CwO+SOMhO'#CwOOQW1G.z1G.zOOO`1G/Q1G/QOOO`1G/T1G/TOOO`1G/W1G/WOOOO'#D]'#D]O+eO7[O,59cOOQW,59c,59cOOOO'#D^'#D^O+vOMhO,59cOOOO-E7Z-E7ZOOQW1G.}1G.}OOOO-E7[-E7[",
    stateData: `,c~O!_OS~OUSOVPOWQOXROYTO[]O][O^^O_^Oa^Ob^Oc^Od^Oy^O|_O!eZO~OgaO~OgbO~OgcO~OgdO~OgeO~O!XfOPmP![mP~O!YiOQpP![pP~O!ZlORsP![sP~OUSOVPOWQOXROYTOZqO[]O][O^^O_^Oa^Ob^Oc^Od^Oy^O!eZO~O![rO~P#gO!]sO!fuO~OgvO~OgwO~OS|OT}OiyO~OS!POT}OiyO~OS!ROT}OiyO~OS!TOT}OiyO~OS}OT}OiyO~O!XfOPmX![mX~OP!WO![!XO~O!YiOQpX![pX~OQ!ZO![!XO~O!ZlORsX![sX~OR!]O![!XO~O![!XO~P#gOg!_O~O!]sO!f!aO~OS!bO~OS!cO~Oj!dOShXThXihX~OS!fOT!gOiyO~OS!hOT!gOiyO~OS!iOT!gOiyO~OS!jOT!gOiyO~OS!gOT!gOiyO~Og!kO~Og!lO~Og!mO~OS!nO~Ol!qO!a!oO!c!pO~OS!rO~OS!sO~OS!tO~Ob!uOc!uOd!uO!a!wO!b!uO~Ob!xOc!xOd!xO!c!wO!d!xO~Ob!uOc!uOd!uO!a!{O!b!uO~Ob!xOc!xOd!xO!c!{O!d!xO~OT~cbd!ey|!e~`,
    goto: "%q!aPPPPPPPPPPPPPPPPPPPPP!b!hP!nPP!zP!}#Q#T#Z#^#a#g#j#m#s#y!bP!b!bP$P$V$m$s$y%P%V%]%cPPPPPPPP%iX^OX`pXUOX`pezabcde{!O!Q!S!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ!ObQ!QcQ!SdQ!UeZ!e{!O!Q!S!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
    nodeNames: `⚠ StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl`,
    maxTerm: 68,
    context: eB,
    nodeProps: [
      [
        `closedBy`,
        -10,
        1,
        2,
        3,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        `EndTag`,
        6,
        `EndTag SelfClosingEndTag`,
        -4,
        22,
        31,
        34,
        37,
        `CloseTag`,
      ],
      [`openedBy`, 4, `StartTag StartCloseTag`, 5, `StartTag`, -4, 30, 33, 36, 38, `OpenTag`],
      [
        `group`,
        -10,
        14,
        15,
        18,
        19,
        20,
        21,
        40,
        41,
        42,
        43,
        `Entity`,
        17,
        `Entity TextContent`,
        -3,
        29,
        32,
        35,
        `TextContent Entity`,
      ],
      [`isolate`, -11, 22, 30, 31, 33, 34, 36, 37, 38, 39, 42, 43, `ltr`, -3, 27, 28, 40, ``],
    ],
    propSources: [lB],
    skippedNodes: [0],
    repeatNodeCount: 9,
    tokenData:
      "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|caPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bXaP!b`!dpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UVaP!dpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pTaPOv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!dpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({WaP!b`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!b`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!b`!dpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYlWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]`aP!b`!dp!_^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljiSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebiSlWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXiSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vciSaP!b`!dpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!ahaP!dpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WiiSlWd!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zblWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOb!R!R7tP;=`<%l7S!Z8OYlWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{iiSlWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbiSlWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QciSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXiSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhiSlWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TalWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOc!R!RAwP;=`<%lAY!ZBRYlWc!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhiSlWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbiSlWc!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbiSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXiSc!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!cxaP!b`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYliSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_kiSaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_XaP!b`!dp!fQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZiSgQaPlW!b`!dpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!b`!dpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!b`!dpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!b`!dpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!b`!dp!ePOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!b`!dpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!b`!dpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!b`!dpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!b`!dpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!b`!dpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!b`!dpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!b`!dpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!dpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO|PP!-nP;=`<%l!-Sq!-xS!dp|POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!b`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!b`|POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!b`!dp|POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!b`!dpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!b`!dpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!b`!dpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!b`!dpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!b`!dpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!b`!dpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!b`!dpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!dpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOyPP!7TP;=`<%l!6Vq!7]V!dpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!dpyPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!b`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!b`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!b`yPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!b`!dpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!b`!dpyPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXjSaP!b`!dpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
    tokenizers: [oB, sB, cB, iB, tB, nB, 0, 1, 2, 3, 4, 5],
    topRules: {
      Document: [0, 16],
    },
    dialects: {
      noMatch: 0,
      selfClosing: 515,
    },
    tokenPrec: 517,
  });
function dB(e, t) {
  let n = Object.create(null);
  for (let r of e.getChildren(Dz)) {
    let e = r.getChild(Oz),
      i = r.getChild(kz) || r.getChild(Az);
    e &&
      (n[t.read(e.from, e.to)] = i
        ? i.type.id == kz
          ? t.read(i.from + 1, i.to - 1)
          : t.read(i.from, i.to)
        : ``);
  }
  return n;
}
function fB(e, t) {
  let n = e.getChild(Ez);
  return n ? t.read(n.from, n.to) : ` `;
}
function pB(e, t, n) {
  let r;
  for (let i of n)
    if (!i.attrs || i.attrs((r ||= dB(e.node.parent.firstChild, t))))
      return {
        parser: i.parser,
        bracketed: !0,
      };
  return null;
}
function mB(e = [], t = []) {
  let n = [],
    r = [],
    i = [],
    a = [];
  for (let t of e)
    (t.tag == `script` ? n : t.tag == `style` ? r : t.tag == `textarea` ? i : a).push(t);
  let o = t.length ? Object.create(null) : null;
  for (let e of t) (o[e.name] || (o[e.name] = [])).push(e);
  return Tt((e, t) => {
    let s = e.type.id;
    if (s == jz) return pB(e, t, n);
    if (s == Mz) return pB(e, t, r);
    if (s == Nz) return pB(e, t, i);
    if (s == Tz && a.length) {
      let n = e.node,
        r = n.firstChild,
        i = r && fB(r, t),
        o;
      if (i) {
        for (let e of a)
          if (e.tag == i && (!e.attrs || e.attrs((o ||= dB(r, t))))) {
            let t = n.lastChild,
              i = t.type.id == Fz ? t.from : n.to;
            if (i > r.to)
              return {
                parser: e.parser,
                overlay: [
                  {
                    from: r.to,
                    to: i,
                  },
                ],
              };
          }
      }
    }
    if (o && s == Dz) {
      let n = e.node,
        r;
      if ((r = n.firstChild)) {
        let e = o[t.read(r.from, r.to)];
        if (e)
          for (let r of e) {
            if (r.tagName && r.tagName != fB(n.parent, t)) continue;
            let e = n.lastChild;
            if (e.type.id == kz) {
              let t = e.from + 1,
                n = e.lastChild,
                i = e.to - (n && n.isError ? 0 : 1);
              if (i > t)
                return {
                  parser: r.parser,
                  overlay: [
                    {
                      from: t,
                      to: i,
                    },
                  ],
                  bracketed: !0,
                };
            } else if (e.type.id == Az)
              return {
                parser: r.parser,
                overlay: [
                  {
                    from: e.from,
                    to: e.to,
                  },
                ],
              };
          }
      }
    }
    return null;
  });
}
var hB = 135,
  gB = 1,
  _B = 136,
  vB = 137,
  yB = 2,
  bB = 138,
  xB = 3,
  SB = 4,
  CB = [
    9, 10, 11, 12, 13, 32, 133, 160, 5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200,
    8201, 8202, 8232, 8233, 8239, 8287, 12288,
  ],
  wB = 58,
  TB = 40,
  EB = 95,
  DB = 91,
  OB = 45,
  kB = 46,
  AB = 35,
  jB = 37,
  MB = 38,
  NB = 92,
  PB = 10,
  FB = 42;
function IB(e) {
  return (e >= 65 && e <= 90) || (e >= 97 && e <= 122) || e >= 161;
}
function LB(e) {
  return e >= 48 && e <= 57;
}
function RB(e) {
  return LB(e) || (e >= 97 && e <= 102) || (e >= 65 && e <= 70);
}
var zB = (e, t, n) => (r, i) => {
    for (let a = !1, o = 0, s = 0; ; s++) {
      let { next: c } = r;
      if (IB(c) || c == OB || c == EB || (a && LB(c)))
        (!a && (c != OB || s > 0) && (a = !0), o === s && c == OB && o++, r.advance());
      else if (c == NB && r.peek(1) != PB) {
        if ((r.advance(), RB(r.next))) {
          do r.advance();
          while (RB(r.next));
          r.next == 32 && r.advance();
        } else r.next > -1 && r.advance();
        a = !0;
      } else {
        a && r.acceptToken(o == 2 && i.canShift(yB) ? t : c == TB ? n : e);
        break;
      }
    }
  },
  BB = new tn(zB(_B, yB, vB), {
    contextual: !0,
  }),
  VB = new tn(zB(bB, xB, SB), {
    contextual: !0,
  }),
  HB = new tn((e) => {
    if (CB.includes(e.peek(-1))) {
      let { next: t } = e;
      (IB(t) ||
        t == EB ||
        t == AB ||
        t == kB ||
        t == FB ||
        t == DB ||
        (t == wB && IB(e.peek(1))) ||
        t == OB ||
        t == MB) &&
        e.acceptToken(hB);
    }
  }),
  UB = new tn((e) => {
    if (!CB.includes(e.peek(-1))) {
      let { next: t } = e;
      if ((t == jB && (e.advance(), e.acceptToken(gB)), IB(t))) {
        do e.advance();
        while (IB(e.next) || LB(e.next));
        e.acceptToken(gB);
      }
    }
  }),
  WB = ht({
    "AtKeyword import charset namespace keyframes media supports font-feature-values":
      G.definitionKeyword,
    "from to selector scope MatchFlag": G.keyword,
    NamespaceName: G.namespace,
    KeyframeName: G.labelName,
    KeyframeRangeName: G.operatorKeyword,
    TagName: G.tagName,
    ClassName: G.className,
    PseudoClassName: G.constant(G.className),
    IdName: G.labelName,
    "FeatureName PropertyName": G.propertyName,
    AttributeName: G.attributeName,
    NumberLiteral: G.number,
    KeywordQuery: G.keyword,
    UnaryQueryOp: G.operatorKeyword,
    "CallTag ValueName FontName": G.atom,
    VariableName: G.variableName,
    Callee: G.operatorKeyword,
    Unit: G.unit,
    "UniversalSelector NestingSelector": G.definitionOperator,
    "MatchOp CompareOp": G.compareOperator,
    "ChildOp SiblingOp, LogicOp": G.logicOperator,
    BinOp: G.arithmeticOperator,
    Important: G.modifier,
    Comment: G.blockComment,
    ColorLiteral: G.color,
    "ParenthesizedContent StringLiteral": G.string,
    ":": G.punctuation,
    "PseudoOp #": G.derefOperator,
    "; , |": G.separator,
    "( )": G.paren,
    "[ ]": G.squareBracket,
    "{ }": G.brace,
  }),
  GB = {
    __proto__: null,
    lang: 44,
    "nth-child": 44,
    "nth-last-child": 44,
    "nth-of-type": 44,
    "nth-last-of-type": 44,
    dir: 44,
    "host-context": 44,
    if: 90,
    url: 132,
    "url-prefix": 132,
    domain: 132,
    regexp: 132,
  },
  KB = {
    __proto__: null,
    or: 104,
    and: 104,
    not: 112,
    only: 112,
    layer: 186,
  },
  qB = {
    __proto__: null,
    selector: 118,
    layer: 182,
  },
  JB = {
    __proto__: null,
    "@import": 178,
    "@media": 190,
    "@charset": 194,
    "@namespace": 198,
    "@keyframes": 204,
    "@supports": 216,
    "@scope": 220,
    "@font-feature-values": 226,
  },
  YB = {
    __proto__: null,
    to: 223,
  },
  XB = ln.deserialize({
    version: 14,
    states:
      "IpQYQdOOO#}QdOOP$UO`OOO%OQaO'#CfOOQP'#Ce'#CeO%VQdO'#CgO%[Q`O'#CgO%aQaO'#FdO&XQdO'#CkO&xQaO'#CcO'SQdO'#CnO'_QdO'#DtO'dQdO'#DvO'oQdO'#D}O'oQdO'#EQOOQP'#Fd'#FdO)OQhO'#EsOOQS'#Fc'#FcOOQS'#Ev'#EvQYQdOOO)VQdO'#EWO*cQhO'#E^O)VQdO'#E`O*jQdO'#EbO*uQdO'#EeO)zQhO'#EkO*}QdO'#EmO+YQdO'#EpO+_QaO'#CfO+fQ`O'#ETO+kQ`O'#FnO+vQdO'#FnQOQ`OOP,QO&jO'#CaPOOO)CAR)CAROOQP'#Ci'#CiOOQP,59R,59RO%VQdO,59ROOQP'#Cm'#CmOOQP,59V,59VO&XQdO,59VO,]QdO,59YO'_QdO,5:`O'dQdO,5:bO'oQdO,5:iO'oQdO,5:kO'oQdO,5:lO'oQdO'#E}O,hQ`O,58}O,pQdO'#ESOOQS,58},58}OOQP'#Cq'#CqOOQO'#Dr'#DrOOQP,59Y,59YO,wQ`O,59YO,|Q`O,59YOOQP'#Du'#DuOOQP,5:`,5:`O-RQpO'#DwO-^QdO'#DxO-cQ`O'#DxO-hQpO,5:bO.RQaO,5:iO.iQaO,5:lOOQW'#D^'#D^O/eQhO'#DgO/xQhO,5;_O)zQhO'#DeO0VQ`O'#DkO0[QhO'#DnOOQW'#Fj'#FjOOQS,5;_,5;_O0aQ`O'#DhOOQS-E8t-E8tOOQ['#Cv'#CvO0fQdO'#CwO0|QdO'#C}O1dQdO'#DQO1zQ!pO'#DSO4TQ!jO,5:rOOQO'#DX'#DXO,|Q`O'#DWO4eQ!nO'#FgO6hQ`O'#DYO6mQ`O'#DoOOQ['#Fg'#FgO6rQhO'#FqO7QQ`O,5:xO7VQ!bO,5:zOOQS'#Ed'#EdO7_Q`O,5:|O7dQdO,5:|OOQO'#Eg'#EgO7lQ`O,5;PO7qQhO,5;VO'oQdO'#DjOOQS,5;X,5;XO0aQ`O,5;XO7yQdO,5;XOOQS'#FU'#FUO8RQdO'#ErO7QQ`O,5;[O8ZQdO,5:oO8kQdO'#FPO8xQ`O,5<YO8xQ`O,5<YPOOO'#Eu'#EuP9TO&jO,58{POOO,58{,58{OOQP1G.m1G.mOOQP1G.q1G.qOOQP1G.t1G.tO,wQ`O1G.tO,|Q`O1G.tOOQP1G/z1G/zO9`QpO1G/|O9hQaO1G0TO:OQaO1G0VO:fQaO1G0WO:|QaO,5;iOOQO-E8{-E8{OOQS1G.i1G.iO;WQ`O,5:nO;]QdO'#DsO;dQdO'#CuOOQO'#Dz'#DzOOQO,5:d,5:dO-^QdO,5:dOOQP1G/|1G/|O)VQdO1G/|O;kQ!jO'#D^O;yQ!bO,59yO<RQhO,5:ROOQO'#Fk'#FkO;|Q!bO,59}O<ZQhO'#FVO)zQhO,59{O)zQhO'#FVO=OQhO1G0yOOQS1G0y1G0yO=YQhO,5:PO>QQhO'#DlOOQW,5:V,5:VOOQW,5:Y,5:YOOQW,5:S,5:SO>[Q!fO'#FhOOQS'#Fh'#FhOOQS'#Ex'#ExO?lQdO,59cOOQ[,59c,59cO@SQdO,59iOOQ[,59i,59iO@jQdO,59lOOQ[,59l,59lOOQ[,59n,59nO)VQdO,59pOAQQhO'#EYOOQW'#EY'#EYOAlQ`O1G0^O4^QhO1G0^OOQ[,59r,59rO)zQhO'#D[OOQ[,59t,59tOAqQ#tO,5:ZOA|QhO'#FROBZQ`O,5<]OOQS1G0d1G0dOOQS1G0f1G0fOOQS1G0h1G0hOBfQ`O1G0hOBkQdO'#EhOOQS1G0k1G0kOOQS1G0q1G0qOBvQaO,5:UO7QQ`O1G0sOOQS1G0s1G0sO0aQ`O1G0sOOQS-E9S-E9SOOQS1G0v1G0vOB}Q!fO1G0ZOCeQ`O'#EVOOQO1G0Z1G0ZOOQO,5;k,5;kOCjQdO,5;kOOQO-E8}-E8}OCwQ`O1G1tPOOO-E8s-E8sPOOO1G.g1G.gOOQP7+$`7+$`OOQP7+%h7+%hO)VQdO7+%hOOQS1G0Y1G0YODSQaO'#FmOD^Q`O,5:_ODcQ!fO'#EwOEaQdO'#FfOEkQ`O,59aOOQO1G0O1G0OOEpQ!bO7+%hO)VQdO1G/eOE{QhO1G/iOOQW1G/m1G/mOOQW1G/g1G/gOF^QhO,5;qOOQW-E9T-E9TOOQS7+&e7+&eOGRQhO'#D^OGaQhO'#FlOGlQ`O'#FlOGqQ`O,5:WOOQS-E8v-E8vOOQ[1G.}1G.}OOQ[1G/T1G/TOOQ[1G/W1G/WOOQ[1G/[1G/[OGvQdO,5:tOOQS7+%x7+%xOG{Q`O7+%xOHQQhO'#D]OHYQ`O,59vO)zQhO,59vOOQ[1G/u1G/uOHbQ`O1G/uOHgQhO,5;mOOQO-E9P-E9POOQS7+&S7+&SOHuQbO'#DSOOQO'#Ej'#EjOITQ`O'#EiOOQO'#Ei'#EiOI`Q`O'#FSOIhQdO,5;SOOQS,5;S,5;SOOQ[1G/p1G/pOOQS7+&_7+&_O7QQ`O7+&_OIsQ!fO'#FOO)VQdO'#FOOJzQdO7+%uOOQO7+%u7+%uOOQO,5:q,5:qOOQO1G1V1G1VOK_Q!bO<<ISOKjQdO'#E|OKtQ`O,5<XOOQP1G/y1G/yOOQS-E8u-E8uOK|QdO'#E{OLWQ`O,5<QOOQ]1G.{1G.{OOQP<<IS<<ISOL`Q`O<<ISOLeQdO7+%POOQO'#D`'#D`OLlQ!bO7+%TOLtQhO'#EzOMRQ`O,5<WO)VQdO,5<WOOQW1G/r1G/rOOQO'#E['#E[OMZQ`O1G0`OOQS<<Id<<IdO)VQdO,59wOMzQhO1G/bOOQ[1G/b1G/bONRQ`O1G/bOOQW-E8w-E8wOOQ[7+%a7+%aOOQO,5;T,5;TOBnQdO'#FTOI`Q`O,5;nOOQS,5;n,5;nOOQS-E9Q-E9QOOQS1G0n1G0nOOQS<<Iy<<IyONZQ!fO,5;jOOQS-E8|-E8|OOQO<<Ia<<IaOOQPAN>nAN>nO! bQ`OAN>nO! gQaO,5;hOOQO-E8z-E8zO! qQdO,5;gOOQO-E8y-E8yOOQW<<Hk<<HkOOQW<<Ho<<HoO! {QhO<<HoO!!^QhO,5;fO!!iQ`O,5;fOOQO-E8x-E8xO!!nQdO1G1rOGvQdO'#FQO!!xQ`O7+%zOOQW7+%z7+%zO!#QQ!bO1G/cOOQ[7+$|7+$|O!#]QhO7+$|P!#dQ`O'#EyOOQO,5;o,5;oOOQO-E9R-E9ROOQS1G1Y1G1YOOQPG24YG24YO!#iQ`OAN>ZO)VQdO1G1QO!#nQ`O7+'^OOQO,5;l,5;lOOQO-E9O-E9OOOQW<<If<<IfOOQ[<<Hh<<HhPOQW,5;e,5;eOOQWG23uG23uO!#vQdO7+&l",
    stateData:
      "!$Z~O$QOS$RQQ~OWVO^_O`WOcYOdYOl`OmZOp[O!r]O!u^O!{dO#ReO#TfO#VgO#YhO#`iO#bjO#ekO#|RO$XTO~OQmOWVO^_O`WOcYOdYOl`OmZOp[O!r]O!u^O!{dO#ReO#TfO#VgO#YhO#`iO#bjO#ekO#|lO$XTO~O#z$bP~P!jO$RqO~O`YXcYXdYXmYXpYXsYX!aYX!rYX!uYX#{YX$X[X~OgYX~P$ZO#|sO~O$XuO~O$XuO`$WXc$WXd$WXm$WXp$WXs$WX!a$WX!r$WX!u$WX#{$WXg$WX~O#|vO~O`xOcyOdyOmzOp{O!r|O!u!OO#{}O~Os!RO!a!PO~P&^Of!XO#|!TO#}!UO~O#|!YO~OW!^O#|![O$X!]O~OWVO^_O`WOcYOdYOmZOp[O!r]O!u^O#|RO$XTO~OS!fOc!gOd!gOh!cOs!RO!Y!eO!]!jO$O!bO~On!iO~P(dOQ!tOh!mOp!nOs!oOu!wOw!wO}!uO!d!vO#|!lO#}!rO$]!pO~OS!fOc!gOd!gOh!cO!Y!eO!]!jO$O!bO~Os$eP~P)zOw!|O!d!vO#|!{O~Ow#OO#|#OO~Oh#ROs!RO#c#TO~O#|#VO~Oc!xX~P$ZOc#YO~On#ZO#z$bXr$bX~O#z$bXr$bX~P!jO$S#^O$T#^O$U#`O~Of#eO#|!TO#}!UO~Os!RO!a!PO~Or$bP~P!jOh#oO~Oh#pO~Oo!kX!o!kX$X!mX~O#|#qO~O$X#sO~Oo#tO!o#uO~O`xOcyOdyOmzOp{O~Os!qa!a!qa!r!qa!u!qa#{!qag!qa~P-pOs!ta!a!ta!r!ta!u!ta#{!tag!ta~P-pOS!fOc!gOd!gOh!cO!Y!eO!]!jO~OR#yOu#yOw#yO$O#vO$]!pO~P/POn$PO!U#|O!a#}O~P(dOh$RO~O$O$TO~Oh#RO~O`$WOc$WOg$ZOl$WOm$WOn$WO~P)VO`$WOc$WOl$WOm$WOn$WOo$]O~P)VO`$WOc$WOl$WOm$WOn$WOr$_O~P)VOP$`OSvXcvXdvXhvXnvXyvX!YvX!]vX!}vX#PvX$OvX!WvXQvX`vXgvXlvXmvXpvXsvXuvXwvX}vX!dvX#|vX#}vX$]vXovXrvX!avX#zvX$dvX!pvX~Oy$aO!}$bO#P$cOn$eP~P)zOh#pOS$ZXc$ZXd$ZXn$ZXy$ZX!Y$ZX!]$ZX!}$ZX#P$ZX$O$ZXQ$ZX`$ZXg$ZXl$ZXm$ZXp$ZXs$ZXu$ZXw$ZX}$ZX!d$ZX#|$ZX#}$ZX$]$ZXo$ZXr$ZX!a$ZX#z$ZX$d$ZX!p$ZX~Oh$gO~Oh$iO~O!U#|O!a$jOs$eXn$eX~Os!RO~On$mOy$aO~On$nO~Ow$oO!d!vO~Os$pO~Os!RO!U#|O~Os!RO#c$vO~O#|#VOs#fX~O$d$zOn!wa#z!war!wa~P)VOn#sX#z#sXr#sX~P!jOn#ZO#z$bar$ba~O$S#^O$T#^O$U%RO~Oo%TO!o%UO~Os!qi!a!qi!r!qi!u!qi#{!qig!qi~P-pOs!si!a!si!r!si!u!si#{!sig!si~P-pOs!ti!a!ti!r!ti!u!ti#{!tig!ti~P-pOs#qa!a#qa~P&^Or%VO~Og$aP~P'oOg$YP~P)VOc!SXg!QX!U!QX!W!SX~Oc%_O!W%`O~Og%aO!U#|O~O!U#|OS#yXc#yXd#yXh#yXn#yXs#yX!Y#yX!]#yX!a#yX$O#yX~On%eO!a#}O~P(dO!U#|OS!Xac!Xad!Xah!Xan!Xas!Xa!Y!Xa!]!Xa!a!Xa$O!Xag!Xa~O$O%fOg$`P~P/POy$aOQ$[X`$[Xc$[Xg$[Xh$[Xl$[Xm$[Xn$[Xp$[Xs$[Xu$[Xw$[X}$[X!d$[X#|$[X#}$[X$]$[Xo$[Xr$[X~O`$WOc$WOg%kOl$WOm$WOn$WO~P)VO`$WOc$WOl$WOm$WOn$WOo%lO~P)VO`$WOc$WOl$WOm$WOn$WOr%mO~P)VOh%oOS!|Xc!|Xd!|Xn!|X!Y!|X!]!|X$O!|X~On%pO~Og%uOw%vO!e%vO~Os#uX!a#uXn#uX~P)zO!a$jOs$ean$ea~On%yO~Or&QO#|%{O$]%zO~Og&RO~P&^Oy$aO!a&VO$d$zOn!wi#z!wir!wi~P)VO$c&YO~On#sa#z#sar#sa~P!jOn#ZO#z$bir$bi~O!a&]Og$aX~P&^Og&_O~Oy$aOQ#kXg#kXh#kXp#kXs#kXu#kXw#kX}#kX!a#kX!d#kX#|#kX#}#kX$]#kX~O!a&aOg$YX~P)VOg&cO~Oo&dOy$aO!p&eO~OR#yOu#yOw#yO$O&gO$]!pO~O!U#|OS#yac#yad#yah#yan#yas#ya!Y#ya!]#ya!a#ya$O#ya~Oc!SXg!QX!U!QX!a!QX~O!U#|O!a&iOg$`X~Oc&kO~Og&lO~O#|&mO~On&oO~Oc&pO!U#|O~Og&rOn&qO~Og&uO~O!U#|Os#ua!a#uan#ua~OP$`OsvX!avXgvX~O$]%zOs#]X!a#]X~Os!RO!a&wO~Or&{O#|%{O$]%zO~Oy$aOQ#rXh#rXn#rXp#rXs#rXu#rXw#rX}#rX!a#rX!d#rX#z#rX#|#rX#}#rX$]#rX$d#rXr#rX~O!a&VO$d$zOn!wq#z!wqr!wq~P)VOo'QOy$aO!p'RO~Og#pX!a#pX~P'oO!a&]Og$aa~Og#oX!a#oX~P)VO!a&aOg$Ya~Oo'QO~Og'WO~P)VOg'XO!W'YO~O$O%fOg#nX!a#nX~P/PO!a&iOg$`a~O`'_Og'aO~OS#mac#mad#mah#ma!Y#ma!]#ma$O#ma~Og'cO~PMcOg'cOn'dO~Oy$aOQ#rah#ran#rap#ras#rau#raw#ra}#ra!a#ra!d#ra#z#ra#|#ra#}#ra$]#ra$d#rar#ra~Oo'iO~Og#pa!a#pa~P&^Og#oa!a#oa~P)VOR#yOu#yOw#yO$O&gO$]%zO~O!U#|Og#na!a#na~Oc'kO~O!a&iOg$`i~P)VO`'_Og'oO~Oy$aOg!Pin!Pi~Og'pO~PMcOn'qO~Og'rO~O!a&iOg$`q~Og#nq!a#nq~P)VO$Q!e$R$]`$]y!u~",
    goto: "4h$fPPPPP$gP$jP$s%V$s%i%{P$sP&R$sPP&XPPP&_&i&iPPPPP&iPP&iP'VP&iP&i(Q&iP(n(q(w(w)Z(wP(wP(wP(w(wP)j(w)vP(w)yPP*m*s$s*y$s+P+P+V+ZPP$sP$s$sP+a,],j,q$jP,zP,}P$jP$jP$jP-T$jP-W-Z-^-e$jP$jPP$jP-j$jP-m-s.S.j.x/O/Y/`/f/l/r/|0S0Y0`0f0lPPPPPPPPPPP0r0{P1q1t2vP3O3x4R4U4XPP4_RrQ_aOPco!R#Z$}q_OP]^co|}!O!P!R#R#Z#o$}&]qSOP]^co|}!O!P!R#R#Z#o$}&]qUOP]^co|}!O!P!R#R#Z#o$}&]QtTR#auQwWR#bxQ!VYR#cyQ#c!XS$f!s!tR%S#e!V!wdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k's!U!wdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k'sU#y!c%`'YU%}$p&P&wR&v%|!V!sdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k'sR$h!uQ%s$gR&s%tq!h`ei!c!d!e!q#|#}$O$R$e$g$j%t&iQ#w!cQ%h$RQ&h%`Q'[&iR'j'YQ#UjQ$U!jQ$t#TR&T$vR$S!f!U!wdf!m!n!o#Y#p#u$Y$[$^$a$y%U%Z%_&V&W&a&f&k&p'U'^'k'sQ!|gR$o!}Q!WYR#dyQ#c!WR%S#dQ!ZZR#fzQ!_[R#g{T!^[{Q#r!]R%]#sQ!SXQ!i`Q#SjQ#m!QQ$P!dQ$l!yQ$r#QQ$u#UQ$x#XQ%e$OQ&S$tQ&y&OQ&|&TR'h&xSnP!RQ#]oQ$|#ZR&Z$}ZmPo!R#Z$}Q${#YQ&X$yR'P&WR$e!qQ&n%oR'm'_R!}gR#PhR$q#PS&O$p&PR'f&wV%|$p&P&wR#XkQ#_qR%Q#_QcOSoP!RU!kco$}R$}#ZQ%Z#pY&`%Z&f'U'^'sQ&f%_Q'U&aQ'^&kR's'kQ$Y!mQ$[!nQ$^!oV%j$Y$[$^Q%t$gR&t%tQ&j%gS']&j'lR'l'^Q&b%ZR'V&bQ&^%WR'T&^Q!QXR#l!QQ&W$yR'O&WQ#[nS%O#[%PR%P#]Q'`&nR'n'`Q$k!xR%x$kQ&P$pR&z&PQ&x&OR'g&xQ#WkR$w#WQ$O!dR%d$O_bOPco!R#Z$}^XOPco!R#Z$}Q!`]Q!a^Q#h|Q#i}Q#j!OQ#k!PQ$s#RQ%W#oR'S&]R%[#pQ!qdQ!zf[$V!m!n!o$Y$[$^Q$y#Yd%Y#p%Z%_&a&f&k'U'^'k'sQ%^#uQ%n$aS&U$y&WQ&[%UQ&}&VR'b&p]$X!m!n!o$Y$[$^Q!d`U!xe!q$eQ#QiQ#x!cS#{!d$OQ$Q!eQ%b#|Q%c#}Q%g$RS%r$g%tQ%w$jR'Z&iQ#z!cQ&h%`R'j'YR%i$RR%X#oQpPR#n!RQ!yeQ$d!qR%q$e",
    nodeNames: `⚠ Unit VariableName VariableName QueryCallee Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NamespacedTagSelector NamespaceName TagName NestingSelector ClassSelector . ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue AtKeyword # ; ] [ BracketedValue } { BracedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee IfExpression if ArgList IfBranch KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp ComparisonQuery CompareOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector ParenthesizedSelector CallQuery ArgList , PseudoQuery CallLiteral CallTag ParenthesizedContent PseudoClassName ArgList IdSelector IdName AttributeSelector AttributeName NamespacedAttribute NamespaceName AttributeName MatchOp MatchFlag ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp Block Declaration PropertyName Important ImportStatement import Layer layer LayerName layer MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports ScopeStatement scope to FontFeatureStatement font-feature-values FontName AtRule Styles`,
    maxTerm: 159,
    nodeProps: [
      [`isolate`, -2, 5, 39, ``],
      [`openedBy`, 23, `(`, 31, `[`, 34, `{`],
      [`closedBy`, 24, `)`, 32, `]`, 35, `}`],
    ],
    propSources: [WB],
    skippedNodes: [0, 5, 117],
    repeatNodeCount: 17,
    tokenData:
      "K`~R!bOX%ZX^&R^p%Zpq&Rqr)ers)vst+jtu2Xuv%Zvw3Rwx3dxy5Ryz5dz{5i{|6S|}:u}!O;W!O!P;u!P!Q<^!Q![=V![!]>Q!]!^>|!^!_?_!_!`@Z!`!a@n!a!b%Z!b!cAo!c!k%Z!k!lC|!l!u%Z!u!vC|!v!}%Z!}#OD_#O#P%Z#P#QDp#Q#R2X#R#]%Z#]#^ER#^#g%Z#g#hC|#h#o%Z#o#pIf#p#qIw#q#rJ`#r#sJq#s#y%Z#y#z&R#z$f%Z$f$g&R$g#BY%Z#BY#BZ&R#BZ$IS%Z$IS$I_&R$I_$I|%Z$I|$JO&R$JO$JT%Z$JT$JU&R$JU$KV%Z$KV$KW&R$KW&FU%Z&FU&FV&R&FV;'S%Z;'S;=`KY<%lO%Z`%^SOy%jz;'S%j;'S;=`%{<%lO%j`%oS!e`Oy%jz;'S%j;'S;=`%{<%lO%j`&OP;=`<%l%j~&Wh$Q~OX%jX^'r^p%jpq'rqy%jz#y%j#y#z'r#z$f%j$f$g'r$g#BY%j#BY#BZ'r#BZ$IS%j$IS$I_'r$I_$I|%j$I|$JO'r$JO$JT%j$JT$JU'r$JU$KV%j$KV$KW'r$KW&FU%j&FU&FV'r&FV;'S%j;'S;=`%{<%lO%j~'yh$Q~!e`OX%jX^'r^p%jpq'rqy%jz#y%j#y#z'r#z$f%j$f$g'r$g#BY%j#BY#BZ'r#BZ$IS%j$IS$I_'r$I_$I|%j$I|$JO'r$JO$JT%j$JT$JU'r$JU$KV%j$KV$KW'r$KW&FU%j&FU&FV'r&FV;'S%j;'S;=`%{<%lO%jj)jS$dYOy%jz;'S%j;'S;=`%{<%lO%j~)yWOY)vZr)vrs*cs#O)v#O#P*h#P;'S)v;'S;=`+d<%lO)v~*hOw~~*kRO;'S)v;'S;=`*t;=`O)v~*wXOY)vZr)vrs*cs#O)v#O#P*h#P;'S)v;'S;=`+d;=`<%l)v<%lO)v~+gP;=`<%l)vj+oYmYOy%jz!Q%j!Q![,_![!c%j!c!i,_!i#T%j#T#Z,_#Z;'S%j;'S;=`%{<%lO%jj,dY!e`Oy%jz!Q%j!Q![-S![!c%j!c!i-S!i#T%j#T#Z-S#Z;'S%j;'S;=`%{<%lO%jj-XY!e`Oy%jz!Q%j!Q![-w![!c%j!c!i-w!i#T%j#T#Z-w#Z;'S%j;'S;=`%{<%lO%jj.OYuY!e`Oy%jz!Q%j!Q![.n![!c%j!c!i.n!i#T%j#T#Z.n#Z;'S%j;'S;=`%{<%lO%jj.uYuY!e`Oy%jz!Q%j!Q![/e![!c%j!c!i/e!i#T%j#T#Z/e#Z;'S%j;'S;=`%{<%lO%jj/jY!e`Oy%jz!Q%j!Q![0Y![!c%j!c!i0Y!i#T%j#T#Z0Y#Z;'S%j;'S;=`%{<%lO%jj0aYuY!e`Oy%jz!Q%j!Q![1P![!c%j!c!i1P!i#T%j#T#Z1P#Z;'S%j;'S;=`%{<%lO%jj1UY!e`Oy%jz!Q%j!Q![1t![!c%j!c!i1t!i#T%j#T#Z1t#Z;'S%j;'S;=`%{<%lO%jj1{SuY!e`Oy%jz;'S%j;'S;=`%{<%lO%jd2[UOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%jd2uS!oS!e`Oy%jz;'S%j;'S;=`%{<%lO%jb3WS^QOy%jz;'S%j;'S;=`%{<%lO%j~3gWOY3dZw3dwx*cx#O3d#O#P4P#P;'S3d;'S;=`4{<%lO3d~4SRO;'S3d;'S;=`4];=`O3d~4`XOY3dZw3dwx*cx#O3d#O#P4P#P;'S3d;'S;=`4{;=`<%l3d<%lO3d~5OP;=`<%l3dj5WShYOy%jz;'S%j;'S;=`%{<%lO%j~5iOg~n5pUWQyWOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%jj6ZWyW!uQOy%jz!O%j!O!P6s!P!Q%j!Q![9x![;'S%j;'S;=`%{<%lO%jj6xU!e`Oy%jz!Q%j!Q![7[![;'S%j;'S;=`%{<%lO%jj7cY!e`$]YOy%jz!Q%j!Q![7[![!g%j!g!h8R!h#X%j#X#Y8R#Y;'S%j;'S;=`%{<%lO%jj8WY!e`Oy%jz{%j{|8v|}%j}!O8v!O!Q%j!Q![9_![;'S%j;'S;=`%{<%lO%jj8{U!e`Oy%jz!Q%j!Q![9_![;'S%j;'S;=`%{<%lO%jj9fU!e`$]YOy%jz!Q%j!Q![9_![;'S%j;'S;=`%{<%lO%jj:P[!e`$]YOy%jz!O%j!O!P7[!P!Q%j!Q![9x![!g%j!g!h8R!h#X%j#X#Y8R#Y;'S%j;'S;=`%{<%lO%jj:zS!aYOy%jz;'S%j;'S;=`%{<%lO%jj;]WyWOy%jz!O%j!O!P6s!P!Q%j!Q![9x![;'S%j;'S;=`%{<%lO%jj;zU`YOy%jz!Q%j!Q![7[![;'S%j;'S;=`%{<%lO%j~<cTyWOy%jz{<r{;'S%j;'S;=`%{<%lO%j~<yS!e`$R~Oy%jz;'S%j;'S;=`%{<%lO%jj=[[$]YOy%jz!O%j!O!P7[!P!Q%j!Q![9x![!g%j!g!h8R!h#X%j#X#Y8R#Y;'S%j;'S;=`%{<%lO%jj>VUcYOy%jz![%j![!]>i!];'S%j;'S;=`%{<%lO%jj>pSdY!e`Oy%jz;'S%j;'S;=`%{<%lO%jj?RSnYOy%jz;'S%j;'S;=`%{<%lO%jh?dU!WWOy%jz!_%j!_!`?v!`;'S%j;'S;=`%{<%lO%jh?}S!WW!e`Oy%jz;'S%j;'S;=`%{<%lO%jl@bS!WW!oSOy%jz;'S%j;'S;=`%{<%lO%jj@uV!rQ!WWOy%jz!_%j!_!`?v!`!aA[!a;'S%j;'S;=`%{<%lO%jbAcS!rQ!e`Oy%jz;'S%j;'S;=`%{<%lO%jjArYOy%jz}%j}!OBb!O!c%j!c!}CP!}#T%j#T#oCP#o;'S%j;'S;=`%{<%lO%jjBgW!e`Oy%jz!c%j!c!}CP!}#T%j#T#oCP#o;'S%j;'S;=`%{<%lO%jjCW[lY!e`Oy%jz}%j}!OCP!O!Q%j!Q![CP![!c%j!c!}CP!}#T%j#T#oCP#o;'S%j;'S;=`%{<%lO%jhDRS!pWOy%jz;'S%j;'S;=`%{<%lO%jjDdSpYOy%jz;'S%j;'S;=`%{<%lO%jnDuSo^Oy%jz;'S%j;'S;=`%{<%lO%jjEWU!pWOy%jz#a%j#a#bEj#b;'S%j;'S;=`%{<%lO%jbEoU!e`Oy%jz#d%j#d#eFR#e;'S%j;'S;=`%{<%lO%jbFWU!e`Oy%jz#c%j#c#dFj#d;'S%j;'S;=`%{<%lO%jbFoU!e`Oy%jz#f%j#f#gGR#g;'S%j;'S;=`%{<%lO%jbGWU!e`Oy%jz#h%j#h#iGj#i;'S%j;'S;=`%{<%lO%jbGoU!e`Oy%jz#T%j#T#UHR#U;'S%j;'S;=`%{<%lO%jbHWU!e`Oy%jz#b%j#b#cHj#c;'S%j;'S;=`%{<%lO%jbHoU!e`Oy%jz#h%j#h#iIR#i;'S%j;'S;=`%{<%lO%jbIYS$cQ!e`Oy%jz;'S%j;'S;=`%{<%lO%jjIkSsYOy%jz;'S%j;'S;=`%{<%lO%jfI|U$XUOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%jjJeSrYOy%jz;'S%j;'S;=`%{<%lO%jfJvU!uQOy%jz!_%j!_!`2n!`;'S%j;'S;=`%{<%lO%j`K]P;=`<%l%Z",
    tokenizers: [HB, UB, BB, VB, 1, 2, 3, 4, new qt(`m~RRYZ[z{a~~g~aO$T~~dP!P!Qg~lO$U~~`, 28, 142)],
    topRules: {
      StyleSheet: [0, 6],
      Styles: [1, 116],
    },
    dynamicPrecedences: {
      84: 1,
    },
    specialized: [
      {
        term: 137,
        get: (e) => GB[e] || -1,
      },
      {
        term: 138,
        get: (e) => KB[e] || -1,
      },
      {
        term: 4,
        get: (e) => qB[e] || -1,
      },
      {
        term: 28,
        get: (e) => JB[e] || -1,
      },
      {
        term: 136,
        get: (e) => YB[e] || -1,
      },
    ],
    tokenPrec: 2256,
  }),
  ZB = i({
    css: () => mV,
    cssCompletionSource: () => fV,
    cssLanguage: () => pV,
    defineCSSCompletionSource: () => dV,
  }),
  QB = null;
function $B() {
  if (!QB && typeof document == `object` && document.body) {
    let { style: e } = document.body,
      t = [],
      n = new Set();
    for (let r in e)
      r != `cssText` &&
        r != `cssFloat` &&
        typeof e[r] == `string` &&
        (/[A-Z]/.test(r) && (r = r.replace(/[A-Z]/g, (e) => `-` + e.toLowerCase())),
        n.has(r) || (t.push(r), n.add(r)));
    QB = t.sort().map((e) => ({
      type: `property`,
      label: e,
      apply: e + `: `,
    }));
  }
  return QB || [];
}
var eV =
    `active.after.any-link.autofill.backdrop.before.checked.cue.default.defined.disabled.empty.enabled.file-selector-button.first.first-child.first-letter.first-line.first-of-type.focus.focus-visible.focus-within.fullscreen.has.host.host-context.hover.in-range.indeterminate.invalid.is.lang.last-child.last-of-type.left.link.marker.modal.not.nth-child.nth-last-child.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.part.placeholder.placeholder-shown.read-only.read-write.required.right.root.scope.selection.slotted.target.target-text.valid.visited.where`
      .split(`.`)
      .map((e) => ({
        type: `class`,
        label: e,
      })),
  tV =
    `above.absolute.activeborder.additive.activecaption.after-white-space.ahead.alias.all.all-scroll.alphabetic.alternate.always.antialiased.appworkspace.asterisks.attr.auto.auto-flow.avoid.avoid-column.avoid-page.avoid-region.axis-pan.background.backwards.baseline.below.bidi-override.blink.block.block-axis.bold.bolder.border.border-box.both.bottom.break.break-all.break-word.bullets.button.button-bevel.buttonface.buttonhighlight.buttonshadow.buttontext.calc.capitalize.caps-lock-indicator.caption.captiontext.caret.cell.center.checkbox.circle.cjk-decimal.clear.clip.close-quote.col-resize.collapse.color.color-burn.color-dodge.column.column-reverse.compact.condensed.contain.content.contents.content-box.context-menu.continuous.copy.counter.counters.cover.crop.cross.crosshair.currentcolor.cursive.cyclic.darken.dashed.decimal.decimal-leading-zero.default.default-button.dense.destination-atop.destination-in.destination-out.destination-over.difference.disc.discard.disclosure-closed.disclosure-open.document.dot-dash.dot-dot-dash.dotted.double.down.e-resize.ease.ease-in.ease-in-out.ease-out.element.ellipse.ellipsis.embed.end.ethiopic-abegede-gez.ethiopic-halehame-aa-er.ethiopic-halehame-gez.ew-resize.exclusion.expanded.extends.extra-condensed.extra-expanded.fantasy.fast.fill.fill-box.fixed.flat.flex.flex-end.flex-start.footnotes.forwards.from.geometricPrecision.graytext.grid.groove.hand.hard-light.help.hidden.hide.higher.highlight.highlighttext.horizontal.hsl.hsla.hue.icon.ignore.inactiveborder.inactivecaption.inactivecaptiontext.infinite.infobackground.infotext.inherit.initial.inline.inline-axis.inline-block.inline-flex.inline-grid.inline-table.inset.inside.intrinsic.invert.italic.justify.keep-all.landscape.large.larger.left.level.lighter.lighten.line-through.linear.linear-gradient.lines.list-item.listbox.listitem.local.logical.loud.lower.lower-hexadecimal.lower-latin.lower-norwegian.lowercase.ltr.luminosity.manipulation.match.matrix.matrix3d.medium.menu.menutext.message-box.middle.min-intrinsic.mix.monospace.move.multiple.multiple_mask_images.multiply.n-resize.narrower.ne-resize.nesw-resize.no-close-quote.no-drop.no-open-quote.no-repeat.none.normal.not-allowed.nowrap.ns-resize.numbers.numeric.nw-resize.nwse-resize.oblique.opacity.open-quote.optimizeLegibility.optimizeSpeed.outset.outside.outside-shape.overlay.overline.padding.padding-box.painted.page.paused.perspective.pinch-zoom.plus-darker.plus-lighter.pointer.polygon.portrait.pre.pre-line.pre-wrap.preserve-3d.progress.push-button.radial-gradient.radio.read-only.read-write.read-write-plaintext-only.rectangle.region.relative.repeat.repeating-linear-gradient.repeating-radial-gradient.repeat-x.repeat-y.reset.reverse.rgb.rgba.ridge.right.rotate.rotate3d.rotateX.rotateY.rotateZ.round.row.row-resize.row-reverse.rtl.run-in.running.s-resize.sans-serif.saturation.scale.scale3d.scaleX.scaleY.scaleZ.screen.scroll.scrollbar.scroll-position.se-resize.self-start.self-end.semi-condensed.semi-expanded.separate.serif.show.single.skew.skewX.skewY.skip-white-space.slide.slider-horizontal.slider-vertical.sliderthumb-horizontal.sliderthumb-vertical.slow.small.small-caps.small-caption.smaller.soft-light.solid.source-atop.source-in.source-out.source-over.space.space-around.space-between.space-evenly.spell-out.square.start.static.status-bar.stretch.stroke.stroke-box.sub.subpixel-antialiased.svg_masks.super.sw-resize.symbolic.symbols.system-ui.table.table-caption.table-cell.table-column.table-column-group.table-footer-group.table-header-group.table-row.table-row-group.text.text-bottom.text-top.textarea.textfield.thick.thin.threeddarkshadow.threedface.threedhighlight.threedlightshadow.threedshadow.to.top.transform.translate.translate3d.translateX.translateY.translateZ.transparent.ultra-condensed.ultra-expanded.underline.unidirectional-pan.unset.up.upper-latin.uppercase.url.var.vertical.vertical-text.view-box.visible.visibleFill.visiblePainted.visibleStroke.visual.w-resize.wait.wave.wider.window.windowframe.windowtext.words.wrap.wrap-reverse.x-large.x-small.xor.xx-large.xx-small`
      .split(`.`)
      .map((e) => ({
        type: `keyword`,
        label: e,
      }))
      .concat(
        `aliceblue.antiquewhite.aqua.aquamarine.azure.beige.bisque.black.blanchedalmond.blue.blueviolet.brown.burlywood.cadetblue.chartreuse.chocolate.coral.cornflowerblue.cornsilk.crimson.cyan.darkblue.darkcyan.darkgoldenrod.darkgray.darkgreen.darkkhaki.darkmagenta.darkolivegreen.darkorange.darkorchid.darkred.darksalmon.darkseagreen.darkslateblue.darkslategray.darkturquoise.darkviolet.deeppink.deepskyblue.dimgray.dodgerblue.firebrick.floralwhite.forestgreen.fuchsia.gainsboro.ghostwhite.gold.goldenrod.gray.grey.green.greenyellow.honeydew.hotpink.indianred.indigo.ivory.khaki.lavender.lavenderblush.lawngreen.lemonchiffon.lightblue.lightcoral.lightcyan.lightgoldenrodyellow.lightgray.lightgreen.lightpink.lightsalmon.lightseagreen.lightskyblue.lightslategray.lightsteelblue.lightyellow.lime.limegreen.linen.magenta.maroon.mediumaquamarine.mediumblue.mediumorchid.mediumpurple.mediumseagreen.mediumslateblue.mediumspringgreen.mediumturquoise.mediumvioletred.midnightblue.mintcream.mistyrose.moccasin.navajowhite.navy.oldlace.olive.olivedrab.orange.orangered.orchid.palegoldenrod.palegreen.paleturquoise.palevioletred.papayawhip.peachpuff.peru.pink.plum.powderblue.purple.rebeccapurple.red.rosybrown.royalblue.saddlebrown.salmon.sandybrown.seagreen.seashell.sienna.silver.skyblue.slateblue.slategray.snow.springgreen.steelblue.tan.teal.thistle.tomato.turquoise.violet.wheat.white.whitesmoke.yellow.yellowgreen`
          .split(`.`)
          .map((e) => ({
            type: `constant`,
            label: e,
          })),
      ),
  nV =
    `a.abbr.address.article.aside.b.bdi.bdo.blockquote.body.br.button.canvas.caption.cite.code.col.colgroup.dd.del.details.dfn.dialog.div.dl.dt.em.figcaption.figure.footer.form.header.hgroup.h1.h2.h3.h4.h5.h6.hr.html.i.iframe.img.input.ins.kbd.label.legend.li.main.meter.nav.ol.output.p.pre.ruby.section.select.small.source.span.strong.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.tr.u.ul`
      .split(`.`)
      .map((e) => ({
        type: `type`,
        label: e,
      })),
  rV = [
    `@charset`,
    `@color-profile`,
    `@container`,
    `@counter-style`,
    `@font-face`,
    `@font-feature-values`,
    `@font-palette-values`,
    `@import`,
    `@keyframes`,
    `@layer`,
    `@media`,
    `@namespace`,
    `@page`,
    `@position-try`,
    `@property`,
    `@scope`,
    `@starting-style`,
    `@supports`,
    `@view-transition`,
  ].map((e) => ({
    type: `keyword`,
    label: e,
  })),
  iV = /^(\w[\w-]*|-\w[\w-]*|)$/,
  aV = /^-(-[\w-]*)?$/;
function oV(e, t) {
  if (((e.name == `(` || e.type.isError) && (e = e.parent || e), e.name != `ArgList`)) return !1;
  let n = e.parent?.firstChild;
  return n?.name == `Callee` ? t.sliceString(n.from, n.to) == `var` : !1;
}
var sV = new yt(),
  cV = [`Declaration`];
function lV(e) {
  for (let t = e; ;) {
    if (t.type.isTop) return t;
    if (!(t = t.parent)) return e;
  }
}
function uV(e, t, n) {
  if (t.to - t.from > 4096) {
    let r = sV.get(t);
    if (r) return r;
    let i = [],
      a = new Set(),
      o = t.cursor(_t.IncludeAnonymous);
    if (o.firstChild())
      do for (let t of uV(e, o.node, n)) a.has(t.label) || (a.add(t.label), i.push(t));
      while (o.nextSibling());
    return (sV.set(t, i), i);
  } else {
    let r = [],
      i = new Set();
    return (
      t.cursor().iterate((t) => {
        if (n(t) && t.matchContext(cV) && t.node.nextSibling?.name == `:`) {
          let n = e.sliceString(t.from, t.to);
          i.has(n) ||
            (i.add(n),
            r.push({
              label: n,
              type: `variable`,
            }));
        }
      }),
      r
    );
  }
}
var dV = (e) => (t) => {
    let { state: n, pos: r } = t,
      i = nt(n).resolveInner(r, -1),
      a = i.type.isError && i.from == i.to - 1 && n.doc.sliceString(i.from, i.to) == `-`;
    if (
      i.name == `PropertyName` ||
      ((a || i.name == `TagName`) && /^(Block|Styles)$/.test(i.resolve(i.to).name))
    )
      return {
        from: i.from,
        options: $B(),
        validFor: iV,
      };
    if (i.name == `ValueName`)
      return {
        from: i.from,
        options: tV,
        validFor: iV,
      };
    if (i.name == `PseudoClassName`)
      return {
        from: i.from,
        options: eV,
        validFor: iV,
      };
    if (e(i) || ((t.explicit || a) && oV(i, n.doc)))
      return {
        from: e(i) || a ? i.from : r,
        options: uV(n.doc, lV(i), e),
        validFor: aV,
      };
    if (i.name == `TagName`) {
      for (let { parent: e } = i; e; e = e.parent)
        if (e.name == `Block`)
          return {
            from: i.from,
            options: $B(),
            validFor: iV,
          };
      return {
        from: i.from,
        options: nV,
        validFor: iV,
      };
    }
    if (i.name == `AtKeyword`)
      return {
        from: i.from,
        options: rV,
        validFor: iV,
      };
    if (!t.explicit) return null;
    let o = i.resolve(r),
      s = o.childBefore(r);
    return s && s.name == `:` && o.name == `PseudoClassSelector`
      ? {
          from: r,
          options: eV,
          validFor: iV,
        }
      : (s && s.name == `:` && o.name == `Declaration`) || o.name == `ArgList`
        ? {
            from: r,
            options: tV,
            validFor: iV,
          }
        : o.name == `Block` || o.name == `Styles`
          ? {
              from: r,
              options: $B(),
              validFor: iV,
            }
          : null;
  },
  fV = dV((e) => e.name == `VariableName`),
  pV = dn.define({
    name: `css`,
    parser: XB.configure({
      props: [
        it.add({
          Declaration: $t(),
        }),
        Cn.add({
          "Block KeyframeList": _n,
        }),
      ],
    }),
    languageData: {
      commentTokens: {
        block: {
          open: `/*`,
          close: `*/`,
        },
      },
      indentOnInput: /^\s*\}$/,
      wordChars: `-`,
    },
  });
function mV() {
  return new hn(
    pV,
    pV.data.of({
      autocomplete: fV,
    }),
  );
}
var hV = 316,
  gV = 317,
  _V = 1,
  vV = 2,
  yV = 3,
  bV = 4,
  xV = 318,
  SV = 320,
  CV = 321,
  wV = 5,
  TV = 6,
  EV = 0,
  DV = [
    9, 10, 11, 12, 13, 32, 133, 160, 5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200,
    8201, 8202, 8232, 8233, 8239, 8287, 12288,
  ],
  OV = 125,
  kV = 59,
  AV = 47,
  jV = 42,
  MV = 43,
  NV = 45,
  PV = 60,
  FV = 44,
  IV = 63,
  LV = 46,
  RV = 91,
  zV = new pn({
    start: !1,
    shift(e, t) {
      return t == wV || t == TV || t == SV ? e : t == CV;
    },
    strict: !1,
  }),
  BV = new tn(
    (e, t) => {
      let { next: n } = e;
      (n == OV || n == -1 || t.context) && e.acceptToken(xV);
    },
    {
      contextual: !0,
      fallback: !0,
    },
  ),
  VV = new tn(
    (e, t) => {
      let { next: n } = e,
        r;
      DV.indexOf(n) > -1 ||
        (n == AV && ((r = e.peek(1)) == AV || r == jV)) ||
        (n != OV && n != kV && n != -1 && !t.context && e.acceptToken(hV));
    },
    {
      contextual: !0,
    },
  ),
  HV = new tn(
    (e, t) => {
      e.next == RV && !t.context && e.acceptToken(gV);
    },
    {
      contextual: !0,
    },
  ),
  UV = new tn(
    (e, t) => {
      let { next: n } = e;
      if (n == MV || n == NV) {
        if ((e.advance(), n == e.next)) {
          e.advance();
          let n = !t.context && t.canShift(_V);
          e.acceptToken(n ? _V : vV);
        }
      } else
        n == IV &&
          e.peek(1) == LV &&
          (e.advance(), e.advance(), (e.next < 48 || e.next > 57) && e.acceptToken(yV));
    },
    {
      contextual: !0,
    },
  );
function WV(e, t) {
  return (
    (e >= 65 && e <= 90) ||
    (e >= 97 && e <= 122) ||
    e == 95 ||
    e >= 192 ||
    (!t && e >= 48 && e <= 57)
  );
}
var GV = new tn((e, t) => {
    if (e.next != PV || !t.dialectEnabled(EV) || (e.advance(), e.next == AV)) return;
    let n = 0;
    for (; DV.indexOf(e.next) > -1;) (e.advance(), n++);
    if (WV(e.next, !0)) {
      for (e.advance(), n++; WV(e.next, !1);) (e.advance(), n++);
      for (; DV.indexOf(e.next) > -1;) (e.advance(), n++);
      if (e.next == FV) return;
      for (let t = 0; ; t++) {
        if (t == 7) {
          if (!WV(e.next, !0)) return;
          break;
        }
        if (e.next != `extends`.charCodeAt(t)) break;
        (e.advance(), n++);
      }
    }
    e.acceptToken(bV, -n);
  }),
  KV = ht({
    "get set async static": G.modifier,
    "for while do if else switch try catch finally return throw break continue default case defer":
      G.controlKeyword,
    "in of await yield void typeof delete instanceof as satisfies": G.operatorKeyword,
    "let var const using function class extends": G.definitionKeyword,
    "import export from": G.moduleKeyword,
    "with debugger new": G.keyword,
    TemplateString: G.special(G.string),
    super: G.atom,
    BooleanLiteral: G.bool,
    this: G.self,
    null: G.null,
    Star: G.modifier,
    VariableName: G.variableName,
    "CallExpression/VariableName TaggedTemplateExpression/VariableName": G.function(G.variableName),
    VariableDefinition: G.definition(G.variableName),
    Label: G.labelName,
    PropertyName: G.propertyName,
    PrivatePropertyName: G.special(G.propertyName),
    "CallExpression/MemberExpression/PropertyName": G.function(G.propertyName),
    "FunctionDeclaration/VariableDefinition": G.function(G.definition(G.variableName)),
    "ClassDeclaration/VariableDefinition": G.definition(G.className),
    "NewExpression/VariableName": G.className,
    PropertyDefinition: G.definition(G.propertyName),
    PrivatePropertyDefinition: G.definition(G.special(G.propertyName)),
    UpdateOp: G.updateOperator,
    "LineComment Hashbang": G.lineComment,
    BlockComment: G.blockComment,
    Number: G.number,
    String: G.string,
    Escape: G.escape,
    ArithOp: G.arithmeticOperator,
    LogicOp: G.logicOperator,
    BitOp: G.bitwiseOperator,
    CompareOp: G.compareOperator,
    RegExp: G.regexp,
    Equals: G.definitionOperator,
    Arrow: G.function(G.punctuation),
    ": Spread": G.punctuation,
    "( )": G.paren,
    "[ ]": G.squareBracket,
    "{ }": G.brace,
    "InterpolationStart InterpolationEnd": G.special(G.brace),
    ".": G.derefOperator,
    ", ;": G.separator,
    "@": G.meta,
    TypeName: G.typeName,
    TypeDefinition: G.definition(G.typeName),
    "type enum interface implements namespace module declare": G.definitionKeyword,
    "abstract global Privacy readonly override": G.modifier,
    "is keyof unique infer asserts": G.operatorKeyword,
    JSXAttributeValue: G.attributeValue,
    JSXText: G.content,
    "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": G.angleBracket,
    "JSXIdentifier JSXNameSpacedName": G.tagName,
    "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": G.attributeName,
    "JSXBuiltin/JSXIdentifier": G.standard(G.tagName),
  }),
  qV = {
    __proto__: null,
    export: 20,
    as: 25,
    from: 33,
    default: 36,
    async: 41,
    function: 42,
    in: 52,
    out: 55,
    const: 56,
    extends: 60,
    this: 64,
    true: 72,
    false: 72,
    null: 84,
    void: 88,
    typeof: 92,
    super: 108,
    new: 142,
    delete: 154,
    yield: 163,
    await: 167,
    class: 172,
    public: 235,
    private: 235,
    protected: 235,
    readonly: 237,
    instanceof: 256,
    satisfies: 259,
    import: 292,
    keyof: 349,
    unique: 353,
    infer: 359,
    asserts: 395,
    is: 397,
    abstract: 417,
    implements: 419,
    type: 421,
    let: 424,
    var: 426,
    using: 429,
    interface: 435,
    enum: 439,
    namespace: 445,
    module: 447,
    declare: 451,
    global: 455,
    defer: 471,
    for: 476,
    of: 485,
    while: 488,
    with: 492,
    do: 496,
    if: 500,
    else: 502,
    switch: 506,
    case: 512,
    try: 518,
    catch: 522,
    finally: 526,
    return: 530,
    throw: 534,
    break: 538,
    continue: 542,
    debugger: 546,
  },
  JV = {
    __proto__: null,
    async: 129,
    get: 131,
    set: 133,
    declare: 195,
    public: 197,
    private: 197,
    protected: 197,
    static: 199,
    abstract: 201,
    override: 203,
    readonly: 209,
    accessor: 211,
    new: 401,
  },
  YV = {
    __proto__: null,
    "<": 193,
  },
  XV = ln.deserialize({
    version: 14,
    states:
      "$F|Q%TQlOOO%[QlOOO'_QpOOP(lO`OOO*zQ!0MxO'#CiO+RO#tO'#CjO+aO&jO'#CjO+oO#@ItO'#DaO.QQlO'#DgO.bQlO'#DrO%[QlO'#DzO0fQlO'#ESOOQ!0Lf'#E['#E[O1PQ`O'#EXOOQO'#Ep'#EpOOQO'#Il'#IlO1XQ`O'#GsO1dQ`O'#EoO1iQ`O'#EoO3hQ!0MxO'#JrO6[Q!0MxO'#JsO6uQ`O'#F]O6zQ,UO'#FtOOQ!0Lf'#Ff'#FfO7VO7dO'#FfO9XQMhO'#F|O9`Q`O'#F{OOQ!0Lf'#Js'#JsOOQ!0Lb'#Jr'#JrO9eQ`O'#GwOOQ['#K_'#K_O9pQ`O'#IYO9uQ!0LrO'#IZOOQ['#J`'#J`OOQ['#I_'#I_Q`QlOOQ`QlOOO9}Q!L^O'#DvO:UQlO'#EOO:]QlO'#EQO9kQ`O'#GsO:dQMhO'#CoO:rQ`O'#EnO:}Q`O'#EyO;hQMhO'#FeO;xQ`O'#GsOOQO'#K`'#K`O;}Q`O'#K`O<]Q`O'#G{O<]Q`O'#G|O<]Q`O'#HOO9kQ`O'#HRO=SQ`O'#HUO>kQ`O'#CeO>{Q`O'#HcO?TQ`O'#HiO?TQ`O'#HkO`QlO'#HmO?TQ`O'#HoO?TQ`O'#HrO?YQ`O'#HxO?_Q!0LsO'#IOO%[QlO'#IQO?jQ!0LsO'#ISO?uQ!0LsO'#IUO9uQ!0LrO'#IWO@QQ!0MxO'#CiOASQpO'#DlQOQ`OOO%[QlO'#EQOAjQ`O'#ETO:dQMhO'#EnOAuQ`O'#EnOBQQ!bO'#FeOOQ['#Cg'#CgOOQ!0Lb'#Dq'#DqOOQ!0Lb'#Jv'#JvO%[QlO'#JvOOQO'#Jy'#JyOOQO'#Ih'#IhOCQQpO'#EgOOQ!0Lb'#Ef'#EfOOQ!0Lb'#J}'#J}OC|Q!0MSO'#EgODWQpO'#EWOOQO'#Jx'#JxODlQpO'#JyOEyQpO'#EWODWQpO'#EgPFWO&2DjO'#CbPOOO)CD})CD}OOOO'#I`'#I`OFcO#tO,59UOOQ!0Lh,59U,59UOOOO'#Ia'#IaOFqO&jO,59UOGPQ!L^O'#DcOOOO'#Ic'#IcOGWO#@ItO,59{OOQ!0Lf,59{,59{OGfQlO'#IdOGyQ`O'#JtOIxQ!fO'#JtO+}QlO'#JtOJPQ`O,5:ROJgQ`O'#EpOJtQ`O'#KTOKPQ`O'#KSOKPQ`O'#KSOKXQ`O,5;^OK^Q`O'#KROOQ!0Ln,5:^,5:^OKeQlO,5:^OMcQ!0MxO,5:fONSQ`O,5:nONmQ!0LrO'#KQONtQ`O'#KPO9eQ`O'#KPO! YQ`O'#KPO! bQ`O,5;]O! gQ`O'#KPO!#lQ!fO'#JsOOQ!0Lh'#Ci'#CiO%[QlO'#ESO!$[Q!fO,5:sOOQS'#Jz'#JzOOQO-E<j-E<jO9kQ`O,5=_O!$rQ`O,5=_O!$wQlO,5;ZO!&zQMhO'#EkO!(eQ`O,5;ZO!(jQlO'#DyO!(tQpO,5;dO!(|QpO,5;dO%[QlO,5;dOOQ['#FT'#FTOOQ['#FV'#FVO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eOOQ['#FZ'#FZO!)[QlO,5;tOOQ!0Lf,5;y,5;yOOQ!0Lf,5;z,5;zOOQ!0Lf,5;|,5;|O%[QlO'#IpO!+_Q!0LrO,5<iO%[QlO,5;eO!&zQMhO,5;eO!+|QMhO,5;eO!-nQMhO'#E^O%[QlO,5;wOOQ!0Lf,5;{,5;{O!-uQ,UO'#FjO!.rQ,UO'#KXO!.^Q,UO'#KXO!.yQ,UO'#KXOOQO'#KX'#KXO!/_Q,UO,5<SOOOW,5<`,5<`O!/pQlO'#FvOOOW'#Io'#IoO7VO7dO,5<QO!/wQ,UO'#FxOOQ!0Lf,5<Q,5<QO!0hQ$IUO'#CyOOQ!0Lh'#C}'#C}O!0{O#@ItO'#DRO!1iQMjO,5<eO!1pQ`O,5<hO!3YQ(CWO'#GXO!3jQ`O'#GYO!3oQ`O'#GYO!5_Q(CWO'#G^O!6dQpO'#GbOOQO'#Gn'#GnO!,TQMhO'#GmOOQO'#Gp'#GpO!,TQMhO'#GoO!7VQ$IUO'#JlOOQ!0Lh'#Jl'#JlO!7aQ`O'#JkO!7oQ`O'#JjO!7wQ`O'#CuOOQ!0Lh'#C{'#C{O!8YQ`O'#C}OOQ!0Lh'#DV'#DVOOQ!0Lh'#DX'#DXO!8_Q`O,5<eO1SQ`O'#DZO!,TQMhO'#GPO!,TQMhO'#GRO!8gQ`O'#GTO!8lQ`O'#GUO!3oQ`O'#G[O!,TQMhO'#GaO<]Q`O'#JkO!8qQ`O'#EqO!9`Q`O,5<gOOQ!0Lb'#Cr'#CrO!9hQ`O'#ErO!:bQpO'#EsOOQ!0Lb'#KR'#KRO!:iQ!0LrO'#KaO9uQ!0LrO,5=cO`QlO,5>tOOQ['#Jh'#JhOOQ[,5>u,5>uOOQ[-E<]-E<]O!<hQ!0MxO,5:bO!:]QpO,5:`O!?RQ!0MxO,5:jO%[QlO,5:jO!AiQ!0MxO,5:lOOQO,5@z,5@zO!BYQMhO,5=_O!BhQ!0LrO'#JiO9`Q`O'#JiO!ByQ!0LrO,59ZO!CUQpO,59ZO!C^QMhO,59ZO:dQMhO,59ZO!CiQ`O,5;ZO!CqQ`O'#HbO!DVQ`O'#KdO%[QlO,5;}O!:]QpO,5<PO!D_Q`O,5=zO!DdQ`O,5=zO!DiQ`O,5=zO!DwQ`O,5=zO9uQ!0LrO,5=zO<]Q`O,5=jOOQO'#Cy'#CyO!EOQpO,5=gO!EWQMhO,5=hO!EcQ`O,5=jO!EhQ!bO,5=mO!EpQ`O'#K`O?YQ`O'#HWO9kQ`O'#HYO!EuQ`O'#HYO:dQMhO'#H[O!EzQ`O'#H[OOQ[,5=p,5=pO!FPQ`O'#H]O!FbQ`O'#CoO!FgQ`O,59PO!FqQ`O,59PO!HvQlO,59POOQ[,59P,59PO!IWQ!0LrO,59PO%[QlO,59PO!KcQlO'#HeOOQ['#Hf'#HfOOQ['#Hg'#HgO`QlO,5=}O!KyQ`O,5=}O`QlO,5>TO`QlO,5>VO!LOQ`O,5>XO`QlO,5>ZO!LTQ`O,5>^O!LYQlO,5>dOOQ[,5>j,5>jO%[QlO,5>jO9uQ!0LrO,5>lOOQ[,5>n,5>nO#!dQ`O,5>nOOQ[,5>p,5>pO#!dQ`O,5>pOOQ[,5>r,5>rO##QQpO'#D_O%[QlO'#JvO##sQpO'#JvO##}QpO'#DmO#$`QpO'#DmO#&qQlO'#DmO#&xQ`O'#JuO#'QQ`O,5:WO#'VQ`O'#EtO#'eQ`O'#KUO#'mQ`O,5;_O#'rQpO'#DmO#(PQpO'#EVOOQ!0Lf,5:o,5:oO%[QlO,5:oO#(WQ`O,5:oO?YQ`O,5;YO!CUQpO,5;YO!C^QMhO,5;YO:dQMhO,5;YO#(`Q`O,5@bO#(eQ07dO,5:sOOQO-E<f-E<fO#)kQ!0MSO,5;RODWQpO,5:rO#)uQpO,5:rODWQpO,5;RO!ByQ!0LrO,5:rOOQ!0Lb'#Ej'#EjOOQO,5;R,5;RO%[QlO,5;RO#*SQ!0LrO,5;RO#*_Q!0LrO,5;RO!CUQpO,5:rOOQO,5;X,5;XO#*mQ!0LrO,5;RPOOO'#I^'#I^P#+RO&2DjO,58|POOO,58|,58|OOOO-E<^-E<^OOQ!0Lh1G.p1G.pOOOO-E<_-E<_OOOO,59},59}O#+^Q!bO,59}OOOO-E<a-E<aOOQ!0Lf1G/g1G/gO#+cQ!fO,5?OO+}QlO,5?OOOQO,5?U,5?UO#+mQlO'#IdOOQO-E<b-E<bO#+zQ`O,5@`O#,SQ!fO,5@`O#,ZQ`O,5@nOOQ!0Lf1G/m1G/mO%[QlO,5@oO#,cQ`O'#IjOOQO-E<h-E<hO#,ZQ`O,5@nOOQ!0Lb1G0x1G0xOOQ!0Ln1G/x1G/xOOQ!0Ln1G0Y1G0YO%[QlO,5@lO#,wQ!0LrO,5@lO#-YQ!0LrO,5@lO#-aQ`O,5@kO9eQ`O,5@kO#-iQ`O,5@kO#-wQ`O'#ImO#-aQ`O,5@kOOQ!0Lb1G0w1G0wO!(tQpO,5:uO!)PQpO,5:uOOQS,5:w,5:wO#.iQdO,5:wO#.qQMhO1G2yO9kQ`O1G2yOOQ!0Lf1G0u1G0uO#/PQ!0MxO1G0uO#0UQ!0MvO,5;VOOQ!0Lh'#GW'#GWO#0rQ!0MzO'#JlO!$wQlO1G0uO#2}Q!fO'#JwO%[QlO'#JwO#3XQ`O,5:eOOQ!0Lh'#D_'#D_OOQ!0Lf1G1O1G1OO%[QlO1G1OOOQ!0Lf1G1f1G1fO#3^Q`O1G1OO#5rQ!0MxO1G1PO#5yQ!0MxO1G1PO#8aQ!0MxO1G1PO#8hQ!0MxO1G1PO#;OQ!0MxO1G1PO#=fQ!0MxO1G1PO#=mQ!0MxO1G1PO#=tQ!0MxO1G1PO#@[Q!0MxO1G1PO#@cQ!0MxO1G1PO#BpQ?MtO'#CiO#DkQ?MtO1G1`O#DrQ?MtO'#JsO#EVQ!0MxO,5?[OOQ!0Lb-E<n-E<nO#GdQ!0MxO1G1PO#HaQ!0MzO1G1POOQ!0Lf1G1P1G1PO#IdQMjO'#J|O#InQ`O,5:xO#IsQ!0MxO1G1cO#JgQ,UO,5<WO#JoQ,UO,5<XO#JwQ,UO'#FoO#K`Q`O'#FnOOQO'#KY'#KYOOQO'#In'#InO#KeQ,UO1G1nOOQ!0Lf1G1n1G1nOOOW1G1y1G1yO#KvQ?MtO'#JrO#LQQ`O,5<bO!)[QlO,5<bOOOW-E<m-E<mOOQ!0Lf1G1l1G1lO#LVQpO'#KXOOQ!0Lf,5<d,5<dO#L_QpO,5<dO#LdQMhO'#DTOOOO'#Ib'#IbO#LkO#@ItO,59mOOQ!0Lh,59m,59mO%[QlO1G2PO!8lQ`O'#IrO#LvQ`O,5<zOOQ!0Lh,5<w,5<wO!,TQMhO'#IuO#MdQMjO,5=XO!,TQMhO'#IwO#NVQMjO,5=ZO!&zQMhO,5=]OOQO1G2S1G2SO#NaQ!dO'#CrO#NtQ(CWO'#ErO$ |QpO'#GbO$!dQ!dO,5<sO$!kQ`O'#K[O9eQ`O'#K[O$!yQ`O,5<uO$#aQ!dO'#C{O!,TQMhO,5<tO$#kQ`O'#GZO$$PQ`O,5<tO$$UQ!dO'#GWO$$cQ!dO'#K]O$$mQ`O'#K]O!&zQMhO'#K]O$$rQ`O,5<xO$$wQlO'#JvO$%RQpO'#GcO#$`QpO'#GcO$%dQ`O'#GgO!3oQ`O'#GkO$%iQ!0LrO'#ItO$%tQpO,5<|OOQ!0Lp,5<|,5<|O$%{QpO'#GcO$&YQpO'#GdO$&kQpO'#GdO$&pQMjO,5=XO$'QQMjO,5=ZOOQ!0Lh,5=^,5=^O!,TQMhO,5@VO!,TQMhO,5@VO$'bQ`O'#IyO$'vQ`O,5@UO$(OQ`O,59aOOQ!0Lh,59i,59iO$(TQ`O,5@VO$)TQ$IYO,59uOOQ!0Lh'#Jp'#JpO$)vQMjO,5<kO$*iQMjO,5<mO@zQ`O,5<oOOQ!0Lh,5<p,5<pO$*sQ`O,5<vO$*xQMjO,5<{O$+YQ`O'#KPO!$wQlO1G2RO$+_Q`O1G2RO9eQ`O'#KSO9eQ`O'#EtO%[QlO'#EtO9eQ`O'#I{O$+dQ!0LrO,5@{OOQ[1G2}1G2}OOQ[1G4`1G4`OOQ!0Lf1G/|1G/|OOQ!0Lf1G/z1G/zO$-fQ!0MxO1G0UOOQ[1G2y1G2yO!&zQMhO1G2yO%[QlO1G2yO#.tQ`O1G2yO$/jQMhO'#EkOOQ!0Lb,5@T,5@TO$/wQ!0LrO,5@TOOQ[1G.u1G.uO!ByQ!0LrO1G.uO!CUQpO1G.uO!C^QMhO1G.uO$0YQ`O1G0uO$0_Q`O'#CiO$0jQ`O'#KeO$0rQ`O,5=|O$0wQ`O'#KeO$0|Q`O'#KeO$1[Q`O'#JRO$1jQ`O,5AOO$1rQ!fO1G1iOOQ!0Lf1G1k1G1kO9kQ`O1G3fO@zQ`O1G3fO$1yQ`O1G3fO$2OQ`O1G3fO!DiQ`O1G3fO9uQ!0LrO1G3fOOQ[1G3f1G3fO!EcQ`O1G3UO!&zQMhO1G3RO$2TQ`O1G3ROOQ[1G3S1G3SO!&zQMhO1G3SO$2YQ`O1G3SO$2bQpO'#HQOOQ[1G3U1G3UO!6_QpO'#I}O!EhQ!bO1G3XOOQ[1G3X1G3XOOQ[,5=r,5=rO$2jQMhO,5=tO9kQ`O,5=tO$%dQ`O,5=vO9`Q`O,5=vO!CUQpO,5=vO!C^QMhO,5=vO:dQMhO,5=vO$2xQ`O'#KcO$3TQ`O,5=wOOQ[1G.k1G.kO$3YQ!0LrO1G.kO@zQ`O1G.kO$3eQ`O1G.kO9uQ!0LrO1G.kO$5mQ!fO,5AQO$5zQ`O,5AQO9eQ`O,5AQO$6VQlO,5>PO$6^Q`O,5>POOQ[1G3i1G3iO`QlO1G3iOOQ[1G3o1G3oOOQ[1G3q1G3qO?TQ`O1G3sO$6cQlO1G3uO$:gQlO'#HtOOQ[1G3x1G3xO$:tQ`O'#HzO?YQ`O'#H|OOQ[1G4O1G4OO$:|QlO1G4OO9uQ!0LrO1G4UOOQ[1G4W1G4WOOQ!0Lb'#G_'#G_O9uQ!0LrO1G4YO9uQ!0LrO1G4[O$?TQ`O,5@bO!)[QlO,5;`O9eQ`O,5;`O?YQ`O,5:XO!)[QlO,5:XO!CUQpO,5:XO$?YQ?MtO,5:XOOQO,5;`,5;`O$?dQpO'#IeO$?zQ`O,5@aOOQ!0Lf1G/r1G/rO$@SQpO'#IkO$@^Q`O,5@pOOQ!0Lb1G0y1G0yO#$`QpO,5:XOOQO'#Ig'#IgO$@fQpO,5:qOOQ!0Ln,5:q,5:qO#(ZQ`O1G0ZOOQ!0Lf1G0Z1G0ZO%[QlO1G0ZOOQ!0Lf1G0t1G0tO?YQ`O1G0tO!CUQpO1G0tO!C^QMhO1G0tOOQ!0Lb1G5|1G5|O!ByQ!0LrO1G0^OOQO1G0m1G0mO%[QlO1G0mO$@mQ!0LrO1G0mO$@xQ!0LrO1G0mO!CUQpO1G0^ODWQpO1G0^O$AWQ!0LrO1G0mOOQO1G0^1G0^O$AlQ!0MxO1G0mPOOO-E<[-E<[POOO1G.h1G.hOOOO1G/i1G/iO$AvQ!bO,5<iO$BOQ!fO1G4jOOQO1G4p1G4pO%[QlO,5?OO$BYQ`O1G5zO$BbQ`O1G6YO$BjQ!fO1G6ZO9eQ`O,5?UO$BtQ!0MxO1G6WO%[QlO1G6WO$CUQ!0LrO1G6WO$CgQ`O1G6VO$CgQ`O1G6VO9eQ`O1G6VO$CoQ`O,5?XO9eQ`O,5?XOOQO,5?X,5?XO$DTQ`O,5?XO$+YQ`O,5?XOOQO-E<k-E<kOOQS1G0a1G0aOOQS1G0c1G0cO#.lQ`O1G0cOOQ[7+(e7+(eO!&zQMhO7+(eO%[QlO7+(eO$DcQ`O7+(eO$DnQMhO7+(eO$D|Q!0MzO,5=XO$GXQ!0MzO,5=ZO$IdQ!0MzO,5=XO$KuQ!0MzO,5=ZO$NWQ!0MzO,59uO%!]Q!0MzO,5<kO%$hQ!0MzO,5<mO%&sQ!0MzO,5<{OOQ!0Lf7+&a7+&aO%)UQ!0MxO7+&aO%)xQlO'#IfO%*VQ`O,5@cO%*_Q!fO,5@cOOQ!0Lf1G0P1G0PO%*iQ`O7+&jOOQ!0Lf7+&j7+&jO%*nQ?MtO,5:fO%[QlO7+&zO%*xQ?MtO,5:bO%+VQ?MtO,5:jO%+aQ?MtO,5:lO%+kQMhO'#IiO%+uQ`O,5@hOOQ!0Lh1G0d1G0dOOQO1G1r1G1rOOQO1G1s1G1sO%+}Q!jO,5<ZO!)[QlO,5<YOOQO-E<l-E<lOOQ!0Lf7+'Y7+'YOOOW7+'e7+'eOOOW1G1|1G1|O%,YQ`O1G1|OOQ!0Lf1G2O1G2OOOOO,59o,59oO%,_Q!dO,59oOOOO-E<`-E<`OOQ!0Lh1G/X1G/XO%,fQ!0MxO7+'kOOQ!0Lh,5?^,5?^O%-YQMhO1G2fP%-aQ`O'#IrPOQ!0Lh-E<p-E<pO%-}QMjO,5?aOOQ!0Lh-E<s-E<sO%.pQMjO,5?cOOQ!0Lh-E<u-E<uO%.zQ!dO1G2wO%/RQ!dO'#CrO%/iQMhO'#KSO$$wQlO'#JvOOQ!0Lh1G2_1G2_O%/sQ`O'#IqO%0[Q`O,5@vO%0[Q`O,5@vO%0dQ`O,5@vO%0oQ`O,5@vOOQO1G2a1G2aO%0}QMjO1G2`O$+YQ`O'#K[O!,TQMhO1G2`O%1_Q(CWO'#IsO%1lQ`O,5@wO!&zQMhO,5@wO%1tQ!dO,5@wOOQ!0Lh1G2d1G2dO%4UQ!fO'#CiO%4`Q`O,5=POOQ!0Lb,5<},5<}O%4hQpO,5<}OOQ!0Lb,5=O,5=OOCwQ`O,5<}O%4sQpO,5<}OOQ!0Lb,5=R,5=RO$+YQ`O,5=VOOQO,5?`,5?`OOQO-E<r-E<rOOQ!0Lp1G2h1G2hO#$`QpO,5<}O$$wQlO,5=PO%5RQ`O,5=OO%5^QpO,5=OO!,TQMhO'#IuO%6WQMjO1G2sO!,TQMhO'#IwO%6yQMjO1G2uO%7TQMjO1G5qO%7_QMjO1G5qOOQO,5?e,5?eOOQO-E<w-E<wOOQO1G.{1G.{O!,TQMhO1G5qO!,TQMhO1G5qO!:]QpO,59wO%[QlO,59wOOQ!0Lh,5<j,5<jO%7lQ`O1G2ZO!,TQMhO1G2bO%7qQ!0MxO7+'mOOQ!0Lf7+'m7+'mO!$wQlO7+'mO%8eQ`O,5;`OOQ!0Lb,5?g,5?gOOQ!0Lb-E<y-E<yO%8jQ!dO'#K^O#(ZQ`O7+(eO4UQ!fO7+(eO$DfQ`O7+(eO%8tQ!0MvO'#CiO%9XQ!0MvO,5=SO%9lQ`O,5=SO%9tQ`O,5=SOOQ!0Lb1G5o1G5oOOQ[7+$a7+$aO!ByQ!0LrO7+$aO!CUQpO7+$aO!$wQlO7+&aO%9yQ`O'#JQO%:bQ`O,5APOOQO1G3h1G3hO9kQ`O,5APO%:bQ`O,5APO%:jQ`O,5APOOQO,5?m,5?mOOQO-E=P-E=POOQ!0Lf7+'T7+'TO%:oQ`O7+)QO9uQ!0LrO7+)QO9kQ`O7+)QO@zQ`O7+)QO%:tQ`O7+)QOOQ[7+)Q7+)QOOQ[7+(p7+(pO%:yQ!0MvO7+(mO!&zQMhO7+(mO!E^Q`O7+(nOOQ[7+(n7+(nO!&zQMhO7+(nO%;TQ`O'#KbO%;`Q`O,5=lOOQO,5?i,5?iOOQO-E<{-E<{OOQ[7+(s7+(sO%<rQpO'#HZOOQ[1G3`1G3`O!&zQMhO1G3`O%[QlO1G3`O%<yQ`O1G3`O%=UQMhO1G3`O9uQ!0LrO1G3bO$%dQ`O1G3bO9`Q`O1G3bO!CUQpO1G3bO!C^QMhO1G3bO%=dQ`O'#JPO%=xQ`O,5@}O%>QQpO,5@}OOQ!0Lb1G3c1G3cOOQ[7+$V7+$VO@zQ`O7+$VO9uQ!0LrO7+$VO%>]Q`O7+$VO%[QlO1G6lO%[QlO1G6mO%>bQ!0LrO1G6lO%>lQlO1G3kO%>sQ`O1G3kO%>xQlO1G3kOOQ[7+)T7+)TO9uQ!0LrO7+)_O`QlO7+)aOOQ['#Kh'#KhOOQ['#JS'#JSO%?PQlO,5>`OOQ[,5>`,5>`O%[QlO'#HuO%?^Q`O'#HwOOQ[,5>f,5>fO9eQ`O,5>fOOQ[,5>h,5>hOOQ[7+)j7+)jOOQ[7+)p7+)pOOQ[7+)t7+)tOOQ[7+)v7+)vO%?cQpO1G5|O%?}Q?MtO1G0zO%@XQ`O1G0zOOQO1G/s1G/sO%@dQ?MtO1G/sO?YQ`O1G/sO!)[QlO'#DmOOQO,5?P,5?POOQO-E<c-E<cOOQO,5?V,5?VOOQO-E<i-E<iO!CUQpO1G/sOOQO-E<e-E<eOOQ!0Ln1G0]1G0]OOQ!0Lf7+%u7+%uO#(ZQ`O7+%uOOQ!0Lf7+&`7+&`O?YQ`O7+&`O!CUQpO7+&`OOQO7+%x7+%xO$AlQ!0MxO7+&XOOQO7+&X7+&XO%[QlO7+&XO%@nQ!0LrO7+&XO!ByQ!0LrO7+%xO!CUQpO7+%xO%@yQ!0LrO7+&XO%AXQ!0MxO7++rO%[QlO7++rO%AiQ`O7++qO%AiQ`O7++qOOQO1G4s1G4sO9eQ`O1G4sO%AqQ`O1G4sOOQS7+%}7+%}O#(ZQ`O<<LPO4UQ!fO<<LPO%BPQ`O<<LPOOQ[<<LP<<LPO!&zQMhO<<LPO%[QlO<<LPO%BXQ`O<<LPO%BdQ!0MzO,5?aO%DoQ!0MzO,5?cO%FzQ!0MzO1G2`O%I]Q!0MzO1G2sO%KhQ!0MzO1G2uO%MsQ!fO,5?QO%[QlO,5?QOOQO-E<d-E<dO%M}Q`O1G5}OOQ!0Lf<<JU<<JUO%NVQ?MtO1G0uO&!^Q?MtO1G1PO&!eQ?MtO1G1PO&$fQ?MtO1G1PO&$mQ?MtO1G1PO&&nQ?MtO1G1PO&(oQ?MtO1G1PO&(vQ?MtO1G1PO&(}Q?MtO1G1PO&+OQ?MtO1G1PO&+VQ?MtO1G1PO&+^Q!0MxO<<JfO&-UQ?MtO1G1PO&.RQ?MvO1G1PO&/UQ?MvO'#JlO&1[Q?MtO1G1cO&1iQ?MtO1G0UO&1sQMjO,5?TOOQO-E<g-E<gO!)[QlO'#FqOOQO'#KZ'#KZOOQO1G1u1G1uO&1}Q`O1G1tO&2SQ?MtO,5?[OOOW7+'h7+'hOOOO1G/Z1G/ZO&2^Q!dO1G4xOOQ!0Lh7+(Q7+(QP!&zQMhO,5?^O!,TQMhO7+(cO&2eQ`O,5?]O9eQ`O,5?]O$+YQ`O,5?]OOQO-E<o-E<oO&2sQ`O1G6bO&2sQ`O1G6bO&2{Q`O1G6bO&3WQMjO7+'zO&3hQ!dO,5?_O&3rQ`O,5?_O!&zQMhO,5?_OOQO-E<q-E<qO&3wQ!dO1G6cO&4RQ`O1G6cO&4ZQ`O1G2kO!&zQMhO1G2kOOQ!0Lb1G2i1G2iOOQ!0Lb1G2j1G2jO%4hQpO1G2iO!CUQpO1G2iOCwQ`O1G2iOOQ!0Lb1G2q1G2qO&4`QpO1G2iO&4nQ`O1G2kO$+YQ`O1G2jOCwQ`O1G2jO$$wQlO1G2kO&4vQ`O1G2jO&5jQMjO,5?aOOQ!0Lh-E<t-E<tO&6]QMjO,5?cOOQ!0Lh-E<v-E<vO!,TQMhO7++]O&6gQMjO7++]O&6qQMjO7++]OOQ!0Lh1G/c1G/cO&7OQ`O1G/cOOQ!0Lh7+'u7+'uO&7TQMjO7+'|O&7eQ!0MxO<<KXOOQ!0Lf<<KX<<KXO&8XQ`O1G0zO!&zQMhO'#IzO&8^Q`O,5@xO&:`Q!fO<<LPO!&zQMhO1G2nO&:gQ!0LrO1G2nOOQ[<<G{<<G{O!ByQ!0LrO<<G{O&:xQ!0MxO<<I{OOQ!0Lf<<I{<<I{OOQO,5?l,5?lO&;lQ`O,5?lO&;qQ`O,5?lOOQO-E=O-E=OO&<PQ`O1G6kO&<PQ`O1G6kO9kQ`O1G6kO@zQ`O<<LlOOQ[<<Ll<<LlO&<XQ`O<<LlO9uQ!0LrO<<LlO9kQ`O<<LlOOQ[<<LX<<LXO%:yQ!0MvO<<LXOOQ[<<LY<<LYO!E^Q`O<<LYO&<^QpO'#I|O&<iQ`O,5@|O!)[QlO,5@|OOQ[1G3W1G3WOOQO'#JO'#JOO9uQ!0LrO'#JOO&<qQpO,5=uOOQ[,5=u,5=uO&<xQpO'#EgO&=PQpO'#GeO&=UQ`O7+(zO&=ZQ`O7+(zOOQ[7+(z7+(zO!&zQMhO7+(zO%[QlO7+(zO&=cQ`O7+(zOOQ[7+(|7+(|O9uQ!0LrO7+(|O$%dQ`O7+(|O9`Q`O7+(|O!CUQpO7+(|O&=nQ`O,5?kOOQO-E<}-E<}OOQO'#H^'#H^O&=yQ`O1G6iO9uQ!0LrO<<GqOOQ[<<Gq<<GqO@zQ`O<<GqO&>RQ`O7+,WO&>WQ`O7+,XO%[QlO7+,WO%[QlO7+,XOOQ[7+)V7+)VO&>]Q`O7+)VO&>bQlO7+)VO&>iQ`O7+)VOOQ[<<Ly<<LyOOQ[<<L{<<L{OOQ[-E=Q-E=QOOQ[1G3z1G3zO&>nQ`O,5>aOOQ[,5>c,5>cO&>sQ`O1G4QO9eQ`O7+&fO!)[QlO7+&fOOQO7+%_7+%_O&>xQ?MtO1G6ZO?YQ`O7+%_OOQ!0Lf<<Ia<<IaOOQ!0Lf<<Iz<<IzO?YQ`O<<IzOOQO<<Is<<IsO$AlQ!0MxO<<IsO%[QlO<<IsOOQO<<Id<<IdO!ByQ!0LrO<<IdO&?SQ!0LrO<<IsO&?_Q!0MxO<= ^O&?oQ`O<= ]OOQO7+*_7+*_O9eQ`O7+*_OOQ[ANAkANAkO&?wQ!fOANAkO!&zQMhOANAkO#(ZQ`OANAkO4UQ!fOANAkO&@OQ`OANAkO%[QlOANAkO&@WQ!0MzO7+'zO&BiQ!0MzO,5?aO&DtQ!0MzO,5?cO&GPQ!0MzO7+'|O&IbQ!fO1G4lO&IlQ?MtO7+&aO&KpQ?MvO,5=XO&MwQ?MvO,5=ZO&NXQ?MvO,5=XO&NiQ?MvO,5=ZO&NyQ?MvO,59uO'#PQ?MvO,5<kO'%SQ?MvO,5<mO''hQ?MvO,5<{O')^Q?MtO7+'kO')kQ?MtO7+'mO')xQ`O,5<]OOQO7+'`7+'`OOQ!0Lh7+*d7+*dO')}QMjO<<K}OOQO1G4w1G4wO'*UQ`O1G4wO'*aQ`O1G4wO'*oQ`O7++|O'*oQ`O7++|O!&zQMhO1G4yO'*wQ!dO1G4yO'+RQ`O7++}O'+ZQ`O7+(VO'+fQ!dO7+(VOOQ!0Lb7+(T7+(TOOQ!0Lb7+(U7+(UO!CUQpO7+(TOCwQ`O7+(TO'+pQ`O7+(VO!&zQMhO7+(VO$+YQ`O7+(UO'+uQ`O7+(VOCwQ`O7+(UO'+}QMjO<<NwO!,TQMhO<<NwOOQ!0Lh7+$}7+$}O',XQ!dO,5?fOOQO-E<x-E<xO',cQ!0MvO7+(YO!&zQMhO7+(YOOQ[AN=gAN=gO9kQ`O1G5WOOQO1G5W1G5WO',sQ`O1G5WO',xQ`O7+,VO',xQ`O7+,VO9uQ!0LrOANBWO@zQ`OANBWOOQ[ANBWANBWO'-QQ`OANBWOOQ[ANAsANAsOOQ[ANAtANAtO'-VQ`O,5?hOOQO-E<z-E<zO'-bQ?MtO1G6hOOQO,5?j,5?jOOQO-E<|-E<|OOQ[1G3a1G3aO'-lQ`O,5=POOQ[<<Lf<<LfO!&zQMhO<<LfO&=UQ`O<<LfO'-qQ`O<<LfO%[QlO<<LfOOQ[<<Lh<<LhO9uQ!0LrO<<LhO$%dQ`O<<LhO9`Q`O<<LhO'-yQpO1G5VO'.UQ`O7+,TOOQ[AN=]AN=]O9uQ!0LrOAN=]OOQ[<= r<= rOOQ[<= s<= sO'.^Q`O<= rO'.cQ`O<= sOOQ[<<Lq<<LqO'.hQ`O<<LqO'.mQlO<<LqOOQ[1G3{1G3{O?YQ`O7+)lO'.tQ`O<<JQO'/PQ?MtO<<JQOOQO<<Hy<<HyOOQ!0LfAN?fAN?fOOQOAN?_AN?_O$AlQ!0MxOAN?_OOQOAN?OAN?OO%[QlOAN?_OOQO<<My<<MyOOQ[G27VG27VO!&zQMhOG27VO#(ZQ`OG27VO'/ZQ!fOG27VO4UQ!fOG27VO'/bQ`OG27VO'/jQ?MtO<<JfO'/wQ?MvO1G2`O'1mQ?MvO,5?aO'3pQ?MvO,5?cO'5sQ?MvO1G2sO'7vQ?MvO1G2uO'9yQ?MtO<<KXO':WQ?MtO<<I{OOQO1G1w1G1wO!,TQMhOANAiOOQO7+*c7+*cO':eQ`O7+*cO':pQ`O<= hO':xQ!dO7+*eOOQ!0Lb<<Kq<<KqO$+YQ`O<<KqOCwQ`O<<KqO';SQ`O<<KqO!&zQMhO<<KqOOQ!0Lb<<Ko<<KoO!CUQpO<<KoO';_Q!dO<<KqOOQ!0Lb<<Kp<<KpO';iQ`O<<KqO!&zQMhO<<KqO$+YQ`O<<KpO';nQMjOANDcO';xQ!0MvO<<KtOOQO7+*r7+*rO9kQ`O7+*rO'<YQ`O<= qOOQ[G27rG27rO9uQ!0LrOG27rO@zQ`OG27rO!)[QlO1G5SO'<bQ`O7+,SO'<jQ`O1G2kO&=UQ`OANBQOOQ[ANBQANBQO!&zQMhOANBQO'<oQ`OANBQOOQ[ANBSANBSO9uQ!0LrOANBSO$%dQ`OANBSOOQO'#H_'#H_OOQO7+*q7+*qOOQ[G22wG22wOOQ[ANE^ANE^OOQ[ANE_ANE_OOQ[ANB]ANB]O'<wQ`OANB]OOQ[<<MW<<MWO!)[QlOAN?lOOQOG24yG24yO$AlQ!0MxOG24yO#(ZQ`OLD,qOOQ[LD,qLD,qO!&zQMhOLD,qO'<|Q!fOLD,qO'=TQ?MvO7+'zO'>yQ?MvO,5?aO'@|Q?MvO,5?cO'CPQ?MvO7+'|O'DuQMjOG27TOOQO<<M}<<M}OOQ!0LbANA]ANA]O$+YQ`OANA]OCwQ`OANA]O'EVQ!dOANA]OOQ!0LbANAZANAZO'E^Q`OANA]O!&zQMhOANA]O'EiQ!dOANA]OOQ!0LbANA[ANA[OOQO<<N^<<N^OOQ[LD-^LD-^O9uQ!0LrOLD-^O'EsQ?MtO7+*nOOQO'#Gf'#GfOOQ[G27lG27lO&=UQ`OG27lO!&zQMhOG27lOOQ[G27nG27nO9uQ!0LrOG27nOOQ[G27wG27wO'E}Q?MtOG25WOOQOLD*eLD*eOOQ[!$(!]!$(!]O#(ZQ`O!$(!]O!&zQMhO!$(!]O'FXQ!0MzOG27TOOQ!0LbG26wG26wO$+YQ`OG26wO'HjQ`OG26wOCwQ`OG26wO'HuQ!dOG26wO!&zQMhOG26wOOQ[!$(!x!$(!xOOQ[LD-WLD-WO&=UQ`OLD-WOOQ[LD-YLD-YOOQ[!)9Ew!)9EwO#(ZQ`O!)9EwOOQ!0LbLD,cLD,cO$+YQ`OLD,cOCwQ`OLD,cO'H|Q`OLD,cO'IXQ!dOLD,cOOQ[!$(!r!$(!rOOQ[!.K;c!.K;cO'I`Q?MvOG27TOOQ!0Lb!$( }!$( }O$+YQ`O!$( }OCwQ`O!$( }O'KUQ`O!$( }OOQ!0Lb!)9Ei!)9EiO$+YQ`O!)9EiOCwQ`O!)9EiOOQ!0Lb!.K;T!.K;TO$+YQ`O!.K;TOOQ!0Lb!4/0o!4/0oO!)[QlO'#DzO1PQ`O'#EXO'KaQ!fO'#JrO'KhQ!L^O'#DvO'KoQlO'#EOO'KvQ!fO'#CiO'N^Q!fO'#CiO!)[QlO'#EQO'NnQlO,5;ZO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO'#IpO(!qQ`O,5<iO!)[QlO,5;eO(!yQMhO,5;eO($dQMhO,5;eO!)[QlO,5;wO!&zQMhO'#GmO(!yQMhO'#GmO!&zQMhO'#GoO(!yQMhO'#GoO1SQ`O'#DZO1SQ`O'#DZO!&zQMhO'#GPO(!yQMhO'#GPO!&zQMhO'#GRO(!yQMhO'#GRO!&zQMhO'#GaO(!yQMhO'#GaO!)[QlO,5:jO($kQpO'#D_O($uQpO'#JvO!)[QlO,5@oO'NnQlO1G0uO(%PQ?MtO'#CiO!)[QlO1G2PO!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO(%ZQ!dO'#CrO!&zQMhO,5<tO(!yQMhO,5<tO'NnQlO1G2RO!)[QlO7+&zO!&zQMhO1G2`O(!yQMhO1G2`O!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO!&zQMhO1G2bO(!yQMhO1G2bO'NnQlO7+'mO'NnQlO7+&aO!&zQMhOANAiO(!yQMhOANAiO(%nQ`O'#EoO(%sQ`O'#EoO(%{Q`O'#F]O(&QQ`O'#EyO(&VQ`O'#KTO(&bQ`O'#KRO(&mQ`O,5;ZO(&rQMjO,5<eO(&yQ`O'#GYO('OQ`O'#GYO('TQ`O,5<eO(']Q`O,5<gO('eQ`O,5;ZO('mQ?MtO1G1`O('tQ`O,5<tO('yQ`O,5<tO((OQ`O,5<vO((TQ`O,5<vO((YQ`O1G2RO((_Q`O1G0uO((dQMjO<<K}O((kQMjO<<K}O((rQMhO'#F|O9`Q`O'#F{OAuQ`O'#EnO!)[QlO,5;tO!3oQ`O'#GYO!3oQ`O'#GYO!3oQ`O'#G[O!3oQ`O'#G[O!,TQMhO7+(cO!,TQMhO7+(cO%.zQ!dO1G2wO%.zQ!dO1G2wO!&zQMhO,5=]O!&zQMhO,5=]",
    stateData:
      "()x~O'|OS'}OSTOS(ORQ~OPYOQYOSfOY!VOaqOdzOeyOl!POpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!uwO!xxO!|]O$W|O$niO%h}O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO&W!WO&^!XO&`!YO&b!ZO&d![O&g!]O&m!^O&s!_O&u!`O&w!aO&y!bO&{!cO(TSO(VTO(YUO(aVO(o[O~OWtO~P`OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa!wOs!nO!S!oO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!xO#W!pO#X!pO#[!zO#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O(O!{O~OP]XR]X[]Xa]Xj]Xr]X!Q]X!S]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X'z]X(a]X(r]X(y]X(z]X~O!g%RX~P(qO_!}O(V#PO(W!}O(X#PO~O_#QO(X#PO(Y#PO(Z#QO~Ox#SO!U#TO(b#TO(c#VO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T<ZO(VTO(YUO(aVO(o[O~O![#ZO!]#WO!Y(hP!Y(vP~P+}O!^#cO~P`OPYOQYOSfOd!jOe!iOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(VTO(YUO(aVO(o[O~Op#mO![#iO!|]O#i#lO#j#iO(T<[O!k(sP~P.iO!l#oO(T#nO~O!x#sO!|]O%h#tO~O#k#uO~O!g#vO#k#uO~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!]$_O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa(fX'z(fX'w(fX!k(fX!Y(fX!_(fX%i(fX!g(fX~P1qO#S$dO#`$eO$Q$eOP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX!_(gX%i(gX~Oa(gX'z(gX'w(gX!Y(gX!k(gXv(gX!g(gX~P4UO#`$eO~O$]$hO$_$gO$f$mO~OSfO!_$nO$i$oO$k$qO~Oh%VOj%dOk%dOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T$sO(VTO(YUO(a$uO(y$}O(z%POg(^P~Ol%[O~P7eO!l%eO~O!S%hO!_%iO(T%gO~O!g%mO~Oa%nO'z%nO~O!Q%rO~P%[O(U!lO~P%[O%n%vO~P%[Oh%VO!l%eO(T%gO(U!lO~Oe%}O!l%eO(T%gO~Oj$RO~O!_&PO(T%gO(U!lO(VTO(YUO`)WP~O!Q&SO!l&RO%j&VO&T&WO~P;SO!x#sO~O%s&YO!S)SX!_)SX(T)SX~O(T&ZO~Ol!PO!u&`O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO~Od&eOe&dO!x&bO%h&cO%{&aO~P<bOd&hOeyOl!PO!_&gO!u&`O!xxO!|]O%h}O%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO~Ob&kO#`&nO%j&iO(U!lO~P=gO!l&oO!u&sO~O!l#oO~O!_XO~Oa%nO'x&{O'z%nO~Oa%nO'x'OO'z%nO~Oa%nO'x'QO'z%nO~O'w]X!Y]Xv]X!k]X&[]X!_]X%i]X!g]X~P(qO!b'_O!c'WO!d'WO(U!lO(VTO(YUO~Os'UO!S'TO!['XO(e'SO!^(iP!^(xP~P@nOn'bO!_'`O(T%gO~Oe'gO!l%eO(T%gO~O!Q&SO!l&RO~Os!nO!S!oO!|<VO#T!pO#U!pO#W!pO#X!pO(U!lO(VTO(YUO(e!mO(o!sO~O!b'mO!c'lO!d'lO#V!pO#['nO#]'nO~PBYOa%nOh%VO!g#vO!l%eO'z%nO(r'pO~O!p'tO#`'rO~PChOs!nO!S!oO(VTO(YUO(e!mO(o!sO~O!_XOs(mX!S(mX!b(mX!c(mX!d(mX!|(mX#T(mX#U(mX#V(mX#W(mX#X(mX#[(mX#](mX(U(mX(V(mX(Y(mX(e(mX(o(mX~O!c'lO!d'lO(U!lO~PDWO(P'xO(Q'xO(R'zO~O_!}O(V'|O(W!}O(X'|O~O_#QO(X'|O(Y'|O(Z#QO~Ov(OO~P%[Ox#SO!U#TO(b#TO(c(RO~O![(TO!Y'WX!Y'^X!]'WX!]'^X~P+}O!](VO!Y(hX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!](VO!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~O!Y(hX~PHRO!Y([O~O!Y(uX!](uX!g(uX!k(uX(r(uX~O#`(uX#k#dX!^(uX~PJUO#`(]O!Y(wX!](wX~O!](^O!Y(vX~O!Y(aO~O#`$eO~PJUO!^(bO~P`OR#zO!Q#yO!S#{O!l#xO(aVOP!na[!naj!nar!na!]!na!p!na#R!na#n!na#o!na#p!na#q!na#r!na#s!na#t!na#u!na#v!na#x!na#z!na#{!na(r!na(y!na(z!na~Oa!na'z!na'w!na!Y!na!k!nav!na!_!na%i!na!g!na~PKlO!k(cO~O!g#vO#`(dO(r'pO!](tXa(tX'z(tX~O!k(tX~PNXO!S%hO!_%iO!|]O#i(iO#j(hO(T%gO~O!](jO!k(sX~O!k(lO~O!S%hO!_%iO#j(hO(T%gO~OP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~O!g#vO!k(gX~P! uOR(nO!Q(mO!l#xO#S$dO!|!{a!S!{a~O!x!{a%h!{a!_!{a#i!{a#j!{a(T!{a~P!#vO!x(rO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~O#k(xO~O![(zO!k(kP~P%[O(e(|O(o[O~O!S)OO!l#xO(e(|O(o[O~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]$_Oa$qa'z$qa'w$qa!k$qa!Y$qa!_$qa%i$qa!g$qa~Ol)dO~P!&zOh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Og(pP~P!,TO!Q)iO!g)hO!_$^X$Z$^X$]$^X$_$^X$f$^X~O!g)hO!_({X$Z({X$]({X$_({X$f({X~O!Q)iO~P!.^O!Q)iO!_({X$Z({X$]({X$_({X$f({X~O!_)kO$Z)oO$])jO$_)jO$f)pO~O![)sO~P!)[O$]$hO$_$gO$f)wO~On$zX!Q$zX#S$zX'y$zX(y$zX(z$zX~OgmXg$zXnmX!]mX#`mX~P!0SOx)yO(b)zO(c)|O~On*VO!Q*OO'y*PO(y$}O(z%PO~Og)}O~P!1WOg*WO~Oh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S*YO!_*ZO!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op*`O![*^O(T*XO!k)OP~P!1uO#k*aO~O!l*bO~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T*dO(VTO(YUO(a$uO(y$}O(z%PO~O![*gO!Y)PP~P!3tOr*sOs!nO!S*iO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO(e!mO~O!^*pO~P!5iO#S$dOn(`X!Q(`X'y(`X(y(`X(z(`X!](`X#`(`X~Og(`X$O(`X~P!6kOn*xO#`*wOg(_X!](_X~O!]*yOg(^X~Oj%dOk%dOl%dO(T&ZOg(^P~Os*|O~Og)}O(T&ZO~O!l+SO~O(T(vO~Op+WO!S%hO![#iO!_%iO!|]O#i#lO#j#iO(T%gO!k(sP~O!g#vO#k+XO~O!S%hO![+ZO!](^O!_%iO(T%gO!Y(vP~Os'[O!S+]O![+[O(VTO(YUO(e(|O~O!^(xP~P!9|O!]+^Oa)TX'z)TX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa!ja!]!ja'z!ja'w!ja!Y!ja!k!jav!ja!_!ja%i!ja!g!ja~P!:tOR#zO!Q#yO!S#{O!l#xO(aVOP!ra[!raj!rar!ra!]!ra!p!ra#R!ra#n!ra#o!ra#p!ra#q!ra#r!ra#s!ra#t!ra#u!ra#v!ra#x!ra#z!ra#{!ra(r!ra(y!ra(z!ra~Oa!ra'z!ra'w!ra!Y!ra!k!rav!ra!_!ra%i!ra!g!ra~P!=[OR#zO!Q#yO!S#{O!l#xO(aVOP!ta[!taj!tar!ta!]!ta!p!ta#R!ta#n!ta#o!ta#p!ta#q!ta#r!ta#s!ta#t!ta#u!ta#v!ta#x!ta#z!ta#{!ta(r!ta(y!ta(z!ta~Oa!ta'z!ta'w!ta!Y!ta!k!tav!ta!_!ta%i!ta!g!ta~P!?rOh%VOn+gO!_'`O%i+fO~O!g+iOa(]X!_(]X'z(]X!](]X~Oa%nO!_XO'z%nO~Oh%VO!l%eO~Oh%VO!l%eO(T%gO~O!g#vO#k(xO~Ob+tO%j+uO(T+qO(VTO(YUO!^)XP~O!]+vO`)WX~O[+zO~O`+{O~O!_&PO(T%gO(U!lO`)WP~O%j,OO~P;SOh%VO#`,SO~Oh%VOn,VO!_$|O~O!_,XO~O!Q,ZO!_XO~O%n%vO~O!x,`O~Oe,eO~Ob,fO(T#nO(VTO(YUO!^)VP~Oe%}O~O%j!QO(T&ZO~P=gO[,kO`,jO~OPYOQYOSfOdzOeyOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!iuO!lZO!oYO!pYO!qYO!svO!xxO!|]O$niO%h}O(VTO(YUO(aVO(o[O~O!_!eO!u!gO$W!kO(T!dO~P!FyO`,jOa%nO'z%nO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa,pOl!OO!uwO%l!OO%m!OO%n!OO~P!IcO!l&oO~O&^,vO~O!_,xO~O&o,zO&q,{OP&laQ&laS&laY&laa&lad&lae&lal&lap&lar&las&lat&laz&la|&la!O&la!S&la!W&la!X&la!_&la!i&la!l&la!o&la!p&la!q&la!s&la!u&la!x&la!|&la$W&la$n&la%h&la%j&la%l&la%m&la%n&la%q&la%s&la%v&la%w&la%y&la&W&la&^&la&`&la&b&la&d&la&g&la&m&la&s&la&u&la&w&la&y&la&{&la'w&la(T&la(V&la(Y&la(a&la(o&la!^&la&e&lab&la&j&la~O(T-QO~Oh!eX!]!RX!^!RX!g!RX!g!eX!l!eX#`!RX~O!]!eX!^!eX~P#!iO!g-VO#`-UOh(jX!]#hX!^#hX!g(jX!l(jX~O!](jX!^(jX~P##[Oh%VO!g-XO!l%eO!]!aX!^!aX~Os!nO!S!oO(VTO(YUO(e!mO~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(VTO(YUO(aVO(o[O~O(T=QO~P#$qO!]-]O!^(iX~O!^-_O~O!g-VO#`-UO!]#hX!^#hX~O!]-`O!^(xX~O!^-bO~O!c-cO!d-cO(U!lO~P#$`O!^-fO~P'_On-iO!_'`O~O!Y-nO~Os!{a!b!{a!c!{a!d!{a#T!{a#U!{a#V!{a#W!{a#X!{a#[!{a#]!{a(U!{a(V!{a(Y!{a(e!{a(o!{a~P!#vO!p-sO#`-qO~PChO!c-uO!d-uO(U!lO~PDWOa%nO#`-qO'z%nO~Oa%nO!g#vO#`-qO'z%nO~Oa%nO!g#vO!p-sO#`-qO'z%nO(r'pO~O(P'xO(Q'xO(R-zO~Ov-{O~O!Y'Wa!]'Wa~P!:tO![.PO!Y'WX!]'WX~P%[O!](VO!Y(ha~O!Y(ha~PHRO!](^O!Y(va~O!S%hO![.TO!_%iO(T%gO!Y'^X!]'^X~O#`.VO!](ta!k(taa(ta'z(ta~O!g#vO~P#,wO!](jO!k(sa~O!S%hO!_%iO#j.ZO(T%gO~Op.`O!S%hO![.]O!_%iO!|]O#i._O#j.]O(T%gO!]'aX!k'aX~OR.dO!l#xO~Oh%VOn.gO!_'`O%i.fO~Oa#ci!]#ci'z#ci'w#ci!Y#ci!k#civ#ci!_#ci%i#ci!g#ci~P!:tOn>]O!Q*OO'y*PO(y$}O(z%PO~O#k#_aa#_a#`#_a'z#_a!]#_a!k#_a!_#_a!Y#_a~P#/sO#k(`XP(`XR(`X[(`Xa(`Xj(`Xr(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X'z(`X(a(`X(r(`X!k(`X!Y(`X'w(`Xv(`X!_(`X%i(`X!g(`X~P!6kO!].tO!k(kX~P!:tO!k.wO~O!Y.yO~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mia#mij#mir#mi!]#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#n#mi~P#3cO#n$OO~P#3cOP$[OR#zOr$aO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO[#mia#mij#mi!]#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#r#mi~P#6QO#r$QO~P#6QOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO(aVOa#mi!]#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#v#mi~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO(aVO(z#}Oa#mi!]#mi#z#mi#{#mi'z#mi(r#mi(y#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#x$UO~P#;VO#x#mi~P#;VO#v$SO~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO(aVO(y#|O(z#}Oa#mi!]#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#z#mi~P#={O#z$WO~P#={OP]XR]X[]Xj]Xr]X!Q]X!S]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X!]]X!^]X~O$O]X~P#@jOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO#z<gO#{<hO(aVO(r$YO(y#|O(z#}O~O$O.{O~P#BwO#S$dO#`<nO$Q<nO$O(gX!^(gX~P! uOa'da!]'da'z'da'w'da!k'da!Y'dav'da!_'da%i'da!g'da~P!:tO[#mia#mij#mir#mi!]#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO(y#mi(z#mi~P#EyOn>]O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P#EyO!]/POg(pX~P!1WOg/RO~Oa$Pi!]$Pi'z$Pi'w$Pi!Y$Pi!k$Piv$Pi!_$Pi%i$Pi!g$Pi~P!:tO$]/SO$_/SO~O$]/TO$_/TO~O!g)hO#`/UO!_$cX$Z$cX$]$cX$_$cX$f$cX~O![/VO~O!_)kO$Z/XO$])jO$_)jO$f/YO~O!]<iO!^(fX~P#BwO!^/ZO~O!g)hO$f({X~O$f/]O~Ov/^O~P!&zOx)yO(b)zO(c/aO~O!S/dO~O(y$}On%aa!Q%aa'y%aa(z%aa!]%aa#`%aa~Og%aa$O%aa~P#L{O(z%POn%ca!Q%ca'y%ca(y%ca!]%ca#`%ca~Og%ca$O%ca~P#MnO!]fX!gfX!kfX!k$zX(rfX~P!0SOp%WO![/mO!](^O(T/lO!Y(vP!Y)PP~P!1uOr*sO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO~Os<}O!S/nO![+[O!^*pO(e<|O!^(xP~P$ [O!k/oO~P#/sO!]/pO!g#vO(r'pO!k)OX~O!k/uO~OnoX!QoX'yoX(yoX(zoX~O!g#vO!koX~P$#OOp/wO!S%hO![*^O!_%iO(T%gO!k)OP~O#k/xO~O!Y$zX!]$zX!g%RX~P!0SO!]/yO!Y)PX~P#/sO!g/{O~O!Y/}O~OpkO(T0OO~P.iOh%VOr0TO!g#vO!l%eO(r'pO~O!g+iO~Oa%nO!]0XO'z%nO~O!^0ZO~P!5iO!c0[O!d0[O(U!lO~P#$`Os!nO!S0]O(VTO(YUO(e!mO~O#[0_O~Og%aa!]%aa#`%aa$O%aa~P!1WOg%ca!]%ca#`%ca$O%ca~P!1WOj%dOk%dOl%dO(T&ZOg'mX!]'mX~O!]*yOg(^a~Og0hO~On0jO#`0iOg(_a!](_a~OR0kO!Q0kO!S0lO#S$dOn}a'y}a(y}a(z}a!]}a#`}a~Og}a$O}a~P$(cO!Q*OO'y*POn$sa(y$sa(z$sa!]$sa#`$sa~Og$sa$O$sa~P$)_O!Q*OO'y*POn$ua(y$ua(z$ua!]$ua#`$ua~Og$ua$O$ua~P$*QO#k0oO~Og%Ta!]%Ta#`%Ta$O%Ta~P!1WO!g#vO~O#k0rO~O!]+^Oa)Ta'z)Ta~OR#zO!Q#yO!S#{O!l#xO(aVOP!ri[!rij!rir!ri!]!ri!p!ri#R!ri#n!ri#o!ri#p!ri#q!ri#r!ri#s!ri#t!ri#u!ri#v!ri#x!ri#z!ri#{!ri(r!ri(y!ri(z!ri~Oa!ri'z!ri'w!ri!Y!ri!k!riv!ri!_!ri%i!ri!g!ri~P$+oOh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op0{O%]0|O(T0zO~P$.VO!g+iOa(]a!_(]a'z(]a!](]a~O#k1SO~O[]X!]fX!^fX~O!]1TO!^)XX~O!^1VO~O[1WO~Ob1YO(T+qO(VTO(YUO~O!_&PO(T%gO`'uX!]'uX~O!]+vO`)Wa~O!k1]O~P!:tO[1`O~O`1aO~O#`1fO~On1iO!_$|O~O(e(|O!^)UP~Oh%VOn1rO!_1oO%i1qO~O[1|O!]1zO!^)VX~O!^1}O~O`2POa%nO'z%nO~O(T#nO(VTO(YUO~O#S$dO#`$eO$Q$eOP(gXR(gX[(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~Oj2SO&[2TOa(gX~P$3pOj2SO#`$eO&[2TO~Oa2VO~P%[Oa2XO~O&e2[OP&ciQ&ciS&ciY&cia&cid&cie&cil&cip&cir&cis&cit&ciz&ci|&ci!O&ci!S&ci!W&ci!X&ci!_&ci!i&ci!l&ci!o&ci!p&ci!q&ci!s&ci!u&ci!x&ci!|&ci$W&ci$n&ci%h&ci%j&ci%l&ci%m&ci%n&ci%q&ci%s&ci%v&ci%w&ci%y&ci&W&ci&^&ci&`&ci&b&ci&d&ci&g&ci&m&ci&s&ci&u&ci&w&ci&y&ci&{&ci'w&ci(T&ci(V&ci(Y&ci(a&ci(o&ci!^&cib&ci&j&ci~Ob2bO!^2`O&j2aO~P`O!_XO!l2dO~O&q,{OP&liQ&liS&liY&lia&lid&lie&lil&lip&lir&lis&lit&liz&li|&li!O&li!S&li!W&li!X&li!_&li!i&li!l&li!o&li!p&li!q&li!s&li!u&li!x&li!|&li$W&li$n&li%h&li%j&li%l&li%m&li%n&li%q&li%s&li%v&li%w&li%y&li&W&li&^&li&`&li&b&li&d&li&g&li&m&li&s&li&u&li&w&li&y&li&{&li'w&li(T&li(V&li(Y&li(a&li(o&li!^&li&e&lib&li&j&li~O!Y2jO~O!]!aa!^!aa~P#BwOs!nO!S!oO![2pO(e!mO!]'XX!^'XX~P@nO!]-]O!^(ia~O!]'_X!^'_X~P!9|O!]-`O!^(xa~O!^2wO~P'_Oa%nO#`3QO'z%nO~Oa%nO!g#vO#`3QO'z%nO~Oa%nO!g#vO!p3UO#`3QO'z%nO(r'pO~Oa%nO'z%nO~P!:tO!]$_Ov$qa~O!Y'Wi!]'Wi~P!:tO!](VO!Y(hi~O!](^O!Y(vi~O!Y(wi!](wi~P!:tO!](ti!k(tia(ti'z(ti~P!:tO#`3WO!](ti!k(tia(ti'z(ti~O!](jO!k(si~O!S%hO!_%iO!|]O#i3]O#j3[O(T%gO~O!S%hO!_%iO#j3[O(T%gO~On3dO!_'`O%i3cO~Oh%VOn3dO!_'`O%i3cO~O#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aav%aa!_%aa%i%aa!g%aa~P#L{O#k%caP%caR%ca[%caa%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%cav%ca!_%ca%i%ca!g%ca~P#MnO#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!]%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aa#`%aav%aa!_%aa%i%aa!g%aa~P#/sO#k%caP%caR%ca[%caa%caj%car%ca!S%ca!]%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%ca#`%cav%ca!_%ca%i%ca!g%ca~P#/sO#k}aP}a[}aa}aj}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a'z}a(a}a(r}a!k}a!Y}a'w}av}a!_}a%i}a!g}a~P$(cO#k$saP$saR$sa[$saa$saj$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa'z$sa(a$sa(r$sa!k$sa!Y$sa'w$sav$sa!_$sa%i$sa!g$sa~P$)_O#k$uaP$uaR$ua[$uaa$uaj$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua'z$ua(a$ua(r$ua!k$ua!Y$ua'w$uav$ua!_$ua%i$ua!g$ua~P$*QO#k%TaP%TaR%Ta[%Taa%Taj%Tar%Ta!S%Ta!]%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta'z%Ta(a%Ta(r%Ta!k%Ta!Y%Ta'w%Ta#`%Tav%Ta!_%Ta%i%Ta!g%Ta~P#/sOa#cq!]#cq'z#cq'w#cq!Y#cq!k#cqv#cq!_#cq%i#cq!g#cq~P!:tO![3lO!]'YX!k'YX~P%[O!].tO!k(ka~O!].tO!k(ka~P!:tO!Y3oO~O$O!na!^!na~PKlO$O!ja!]!ja!^!ja~P#BwO$O!ra!^!ra~P!=[O$O!ta!^!ta~P!?rOg']X!]']X~P!,TO!]/POg(pa~OSfO!_4TO$d4UO~O!^4YO~Ov4ZO~P#/sOa$mq!]$mq'z$mq'w$mq!Y$mq!k$mqv$mq!_$mq%i$mq!g$mq~P!:tO!Y4]O~P!&zO!S4^O~O!Q*OO'y*PO(z%POn'ia(y'ia!]'ia#`'ia~Og'ia$O'ia~P%-fO!Q*OO'y*POn'ka(y'ka(z'ka!]'ka#`'ka~Og'ka$O'ka~P%.XO(r$YO~P#/sO!YfX!Y$zX!]fX!]$zX!g%RX#`fX~P!0SOp%WO(T=WO~P!1uOp4bO!S%hO![4aO!_%iO(T%gO!]'eX!k'eX~O!]/pO!k)Oa~O!]/pO!g#vO!k)Oa~O!]/pO!g#vO(r'pO!k)Oa~Og$|i!]$|i#`$|i$O$|i~P!1WO![4jO!Y'gX!]'gX~P!3tO!]/yO!Y)Pa~O!]/yO!Y)Pa~P#/sOP]XR]X[]Xj]Xr]X!Q]X!S]X!Y]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~Oj%YX!g%YX~P%2OOj4oO!g#vO~Oh%VO!g#vO!l%eO~Oh%VOr4tO!l%eO(r'pO~Or4yO!g#vO(r'pO~Os!nO!S4zO(VTO(YUO(e!mO~O(y$}On%ai!Q%ai'y%ai(z%ai!]%ai#`%ai~Og%ai$O%ai~P%5oO(z%POn%ci!Q%ci'y%ci(y%ci!]%ci#`%ci~Og%ci$O%ci~P%6bOg(_i!](_i~P!1WO#`5QOg(_i!](_i~P!1WO!k5VO~Oa$oq!]$oq'z$oq'w$oq!Y$oq!k$oqv$oq!_$oq%i$oq!g$oq~P!:tO!Y5ZO~O!]5[O!_)QX~P#/sOa$zX!_$zX%^]X'z$zX!]$zX~P!0SO%^5_OaoX!_oX'zoX!]oX~P$#OOp5`O(T#nO~O%^5_O~Ob5fO%j5gO(T+qO(VTO(YUO!]'tX!^'tX~O!]1TO!^)Xa~O[5kO~O`5lO~O[5pO~Oa%nO'z%nO~P#/sO!]5uO#`5wO!^)UX~O!^5xO~Or6OOs!nO!S*iO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!pO#W!pO#X!pO#[5}O#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O!^5|O~P%;eOn6TO!_1oO%i6SO~Oh%VOn6TO!_1oO%i6SO~Ob6[O(T#nO(VTO(YUO!]'sX!^'sX~O!]1zO!^)Va~O(VTO(YUO(e6^O~O`6bO~Oj6eO&[6fO~PNXO!k6gO~P%[Oa6iO~Oa6iO~P%[Ob2bO!^6nO&j2aO~P`O!g6pO~O!g6rOh(ji!](ji!^(ji!g(ji!l(jir(ji(r(ji~O!]#hi!^#hi~P#BwO#`6sO!]#hi!^#hi~O!]!ai!^!ai~P#BwOa%nO#`6|O'z%nO~Oa%nO!g#vO#`6|O'z%nO~O!](tq!k(tqa(tq'z(tq~P!:tO!](jO!k(sq~O!S%hO!_%iO#j7TO(T%gO~O!_'`O%i7WO~On7[O!_'`O%i7WO~O#k'iaP'iaR'ia['iaa'iaj'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia'z'ia(a'ia(r'ia!k'ia!Y'ia'w'iav'ia!_'ia%i'ia!g'ia~P%-fO#k'kaP'kaR'ka['kaa'kaj'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka'z'ka(a'ka(r'ka!k'ka!Y'ka'w'kav'ka!_'ka%i'ka!g'ka~P%.XO#k$|iP$|iR$|i[$|ia$|ij$|ir$|i!S$|i!]$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i'z$|i(a$|i(r$|i!k$|i!Y$|i'w$|i#`$|iv$|i!_$|i%i$|i!g$|i~P#/sO#k%aiP%aiR%ai[%aia%aij%air%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai'z%ai(a%ai(r%ai!k%ai!Y%ai'w%aiv%ai!_%ai%i%ai!g%ai~P%5oO#k%ciP%ciR%ci[%cia%cij%cir%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci'z%ci(a%ci(r%ci!k%ci!Y%ci'w%civ%ci!_%ci%i%ci!g%ci~P%6bO!]'Ya!k'Ya~P!:tO!].tO!k(ki~O$O#ci!]#ci!^#ci~P#BwOP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mij#mir#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#n#mi~P%NdO#n<_O~P%NdOP$[OR#zOr<kO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO[#mij#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#r#mi~P&!lO#r<aO~P&!lOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO(aVO#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#v#mi~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO(aVO(z#}O#z#mi#{#mi$O#mi(r#mi(y#mi!]#mi!^#mi~O#x<eO~P&&uO#x#mi~P&&uO#v<cO~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO(aVO(y#|O(z#}O#{#mi$O#mi(r#mi!]#mi!^#mi~O#z#mi~P&)UO#z<gO~P&)UOa#|y!]#|y'z#|y'w#|y!Y#|y!k#|yv#|y!_#|y%i#|y!g#|y~P!:tO[#mij#mir#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi!]#mi!^#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO(y#mi(z#mi~P&,QOn>^O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P&,QO#S$dOP(`XR(`X[(`Xj(`Xn(`Xr(`X!Q(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X$O(`X'y(`X(a(`X(r(`X(y(`X(z(`X!](`X!^(`X~O$O$Pi!]$Pi!^$Pi~P#BwO$O!ri!^!ri~P$+oOg']a!]']a~P!1WO!^7nO~O!]'da!^'da~P#BwO!Y7oO~P#/sO!g#vO(r'pO!]'ea!k'ea~O!]/pO!k)Oi~O!]/pO!g#vO!k)Oi~Og$|q!]$|q#`$|q$O$|q~P!1WO!Y'ga!]'ga~P#/sO!g7vO~O!]/yO!Y)Pi~P#/sO!]/yO!Y)Pi~O!Y7yO~Oh%VOr8OO!l%eO(r'pO~Oj8QO!g#vO~Or8TO!g#vO(r'pO~O!Q*OO'y*PO(z%POn'ja(y'ja!]'ja#`'ja~Og'ja$O'ja~P&5RO!Q*OO'y*POn'la(y'la(z'la!]'la#`'la~Og'la$O'la~P&5tOg(_q!](_q~P!1WO#`8VOg(_q!](_q~P!1WO!Y8WO~Og%Oq!]%Oq#`%Oq$O%Oq~P!1WOa$oy!]$oy'z$oy'w$oy!Y$oy!k$oyv$oy!_$oy%i$oy!g$oy~P!:tO!g6rO~O!]5[O!_)Qa~O!_'`OP$TaR$Ta[$Taj$Tar$Ta!Q$Ta!S$Ta!]$Ta!l$Ta!p$Ta#R$Ta#n$Ta#o$Ta#p$Ta#q$Ta#r$Ta#s$Ta#t$Ta#u$Ta#v$Ta#x$Ta#z$Ta#{$Ta(a$Ta(r$Ta(y$Ta(z$Ta~O%i7WO~P&8fO%^8[Oa%[i!_%[i'z%[i!]%[i~Oa#cy!]#cy'z#cy'w#cy!Y#cy!k#cyv#cy!_#cy%i#cy!g#cy~P!:tO[8^O~Ob8`O(T+qO(VTO(YUO~O!]1TO!^)Xi~O`8dO~O(e(|O!]'pX!^'pX~O!]5uO!^)Ua~O!^8nO~P%;eO(o!sO~P$&YO#[8oO~O!_1oO~O!_1oO%i8qO~On8tO!_1oO%i8qO~O[8yO!]'sa!^'sa~O!]1zO!^)Vi~O!k8}O~O!k9OO~O!k9RO~O!k9RO~P%[Oa9TO~O!g9UO~O!k9VO~O!](wi!^(wi~P#BwOa%nO#`9_O'z%nO~O!](ty!k(tya(ty'z(ty~P!:tO!](jO!k(sy~O%i9bO~P&8fO!_'`O%i9bO~O#k$|qP$|qR$|q[$|qa$|qj$|qr$|q!S$|q!]$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q'z$|q(a$|q(r$|q!k$|q!Y$|q'w$|q#`$|qv$|q!_$|q%i$|q!g$|q~P#/sO#k'jaP'jaR'ja['jaa'jaj'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja'z'ja(a'ja(r'ja!k'ja!Y'ja'w'jav'ja!_'ja%i'ja!g'ja~P&5RO#k'laP'laR'la['laa'laj'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la'z'la(a'la(r'la!k'la!Y'la'w'lav'la!_'la%i'la!g'la~P&5tO#k%OqP%OqR%Oq[%Oqa%Oqj%Oqr%Oq!S%Oq!]%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq'z%Oq(a%Oq(r%Oq!k%Oq!Y%Oq'w%Oq#`%Oqv%Oq!_%Oq%i%Oq!g%Oq~P#/sO!]'Yi!k'Yi~P!:tO$O#cq!]#cq!^#cq~P#BwO(y$}OP%aaR%aa[%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa$O%aa(a%aa(r%aa!]%aa!^%aa~On%aa!Q%aa'y%aa(z%aa~P&IyO(z%POP%caR%ca[%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca$O%ca(a%ca(r%ca!]%ca!^%ca~On%ca!Q%ca'y%ca(y%ca~P&LQOn>^O!Q*OO'y*PO(z%PO~P&IyOn>^O!Q*OO'y*PO(y$}O~P&LQOR0kO!Q0kO!S0lO#S$dOP}a[}aj}an}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a$O}a'y}a(a}a(r}a(y}a(z}a!]}a!^}a~O!Q*OO'y*POP$saR$sa[$saj$san$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa$O$sa(a$sa(r$sa(y$sa(z$sa!]$sa!^$sa~O!Q*OO'y*POP$uaR$ua[$uaj$uan$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua$O$ua(a$ua(r$ua(y$ua(z$ua!]$ua!^$ua~On>^O!Q*OO'y*PO(y$}O(z%PO~OP%TaR%Ta[%Taj%Tar%Ta!S%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta$O%Ta(a%Ta(r%Ta!]%Ta!^%Ta~P''VO$O$mq!]$mq!^$mq~P#BwO$O$oq!]$oq!^$oq~P#BwO!^9oO~O$O9pO~P!1WO!g#vO!]'ei!k'ei~O!g#vO(r'pO!]'ei!k'ei~O!]/pO!k)Oq~O!Y'gi!]'gi~P#/sO!]/yO!Y)Pq~Or9wO!g#vO(r'pO~O[9yO!Y9xO~P#/sO!Y9xO~Oj:PO!g#vO~Og(_y!](_y~P!1WO!]'na!_'na~P#/sOa%[q!_%[q'z%[q!]%[q~P#/sO[:UO~O!]1TO!^)Xq~O`:YO~O#`:ZO!]'pa!^'pa~O!]5uO!^)Ui~P#BwO!S:]O~O!_1oO%i:`O~O(VTO(YUO(e:eO~O!]1zO!^)Vq~O!k:hO~O!k:iO~O!k:jO~O!k:jO~P%[O#`:mO!]#hy!^#hy~O!]#hy!^#hy~P#BwO%i:rO~P&8fO!_'`O%i:rO~O$O#|y!]#|y!^#|y~P#BwOP$|iR$|i[$|ij$|ir$|i!S$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i$O$|i(a$|i(r$|i!]$|i!^$|i~P''VO!Q*OO'y*PO(z%POP'iaR'ia['iaj'ian'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia$O'ia(a'ia(r'ia(y'ia!]'ia!^'ia~O!Q*OO'y*POP'kaR'ka['kaj'kan'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka$O'ka(a'ka(r'ka(y'ka(z'ka!]'ka!^'ka~O(y$}OP%aiR%ai[%aij%ain%air%ai!Q%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai$O%ai'y%ai(a%ai(r%ai(z%ai!]%ai!^%ai~O(z%POP%ciR%ci[%cij%cin%cir%ci!Q%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci$O%ci'y%ci(a%ci(r%ci(y%ci!]%ci!^%ci~O$O$oy!]$oy!^$oy~P#BwO$O#cy!]#cy!^#cy~P#BwO!g#vO!]'eq!k'eq~O!]/pO!k)Oy~O!Y'gq!]'gq~P#/sOr:|O!g#vO(r'pO~O[;QO!Y;PO~P#/sO!Y;PO~Og(_!R!](_!R~P!1WOa%[y!_%[y'z%[y!]%[y~P#/sO!]1TO!^)Xy~O!]5uO!^)Uq~O(T;XO~O!_1oO%i;[O~O!k;_O~O%i;dO~P&8fOP$|qR$|q[$|qj$|qr$|q!S$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q$O$|q(a$|q(r$|q!]$|q!^$|q~P''VO!Q*OO'y*PO(z%POP'jaR'ja['jaj'jan'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja$O'ja(a'ja(r'ja(y'ja!]'ja!^'ja~O!Q*OO'y*POP'laR'la['laj'lan'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la$O'la(a'la(r'la(y'la(z'la!]'la!^'la~OP%OqR%Oq[%Oqj%Oqr%Oq!S%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq$O%Oq(a%Oq(r%Oq!]%Oq!^%Oq~P''VOg%e!Z!]%e!Z#`%e!Z$O%e!Z~P!1WO!Y;hO~P#/sOr;iO!g#vO(r'pO~O[;kO!Y;hO~P#/sO!]'pq!^'pq~P#BwO!]#h!Z!^#h!Z~P#BwO#k%e!ZP%e!ZR%e!Z[%e!Za%e!Zj%e!Zr%e!Z!S%e!Z!]%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z'z%e!Z(a%e!Z(r%e!Z!k%e!Z!Y%e!Z'w%e!Z#`%e!Zv%e!Z!_%e!Z%i%e!Z!g%e!Z~P#/sOr;tO!g#vO(r'pO~O!Y;uO~P#/sOr;|O!g#vO(r'pO~O!Y;}O~P#/sOP%e!ZR%e!Z[%e!Zj%e!Zr%e!Z!S%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z$O%e!Z(a%e!Z(r%e!Z!]%e!Z!^%e!Z~P''VOr<QO!g#vO(r'pO~Ov(fX~P1qO!Q%rO~P!)[O(U!lO~P!)[O!YfX!]fX#`fX~P%2OOP]XR]X[]Xj]Xr]X!Q]X!S]X!]]X!]fX!l]X!p]X#R]X#S]X#`]X#`fX#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~O!gfX!k]X!kfX(rfX~P'LTOP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_XO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]<iO!^$qa~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<tO!S${O!_$|O!i>WO!l$xO#j<zO$W%`O$t<vO$v<xO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Ol)dO~P(!yOr!eX(r!eX~P#!iOr(jX(r(jX~P##[O!^]X!^fX~P'LTO!YfX!Y$zX!]fX!]$zX#`fX~P!0SO#k<^O~O!g#vO#k<^O~O#`<nO~Oj<bO~O#`=OO!](wX!^(wX~O#`<nO!](uX!^(uX~O#k=PO~Og=RO~P!1WO#k=XO~O#k=YO~Og=RO(T&ZO~O!g#vO#k=ZO~O!g#vO#k=PO~O$O=[O~P#BwO#k=]O~O#k=^O~O#k=cO~O#k=dO~O#k=eO~O#k=fO~O$O=gO~P!1WO$O=hO~P!1WOl=sO~P7eOk#S#T#U#W#X#[#i#j#u$n$t$v$y%]%^%h%i%j%q%s%v%w%y%{~(OT#o!X'|(U#ps#n#qr!Q'}$]'}(T$_(e~",
    goto: "$9Y)]PPPPPP)^PP)aP)rP+W/]PPPP6mPP7TPP=QPPP@tPA^PA^PPPA^PCfPA^PA^PA^PCjPCoPD^PIWPPPI[PPPPI[L_PPPLeMVPI[PI[PP! eI[PPPI[PI[P!#lI[P!'S!(X!(bP!)U!)Y!)U!,gPPPPPPP!-W!(XPP!-h!/YP!2iI[I[!2n!5z!:h!:h!>gPPP!>oI[PPPPPPPPP!BOP!C]PPI[!DnPI[PI[I[I[I[I[PI[!FQP!I[P!LbP!Lf!Lp!Lt!LtP!IXP!Lx!LxP#!OP#!SI[PI[#!Y#%_CjA^PA^PA^A^P#&lA^A^#)OA^#+vA^#.SA^A^#.r#1W#1W#1]#1f#1W#1qPP#1WPA^#2ZA^#6YA^A^6mPPP#:_PPP#:x#:xP#:xP#;`#:xPP#;fP#;]P#;]#;y#;]#<e#<k#<n)aP#<q)aP#<z#<z#<zP)aP)aP)aP)aPP)aP#=Q#=TP#=T)aP#=XP#=[P)aP)aP)aP)aP)aP)a)aPP#=b#=h#=s#=y#>P#>V#>]#>k#>q#>{#?R#?]#?c#?s#?y#@k#@}#AT#AZ#Ai#BO#Cs#DR#DY#Et#FS#Gt#HS#HY#H`#Hf#Hp#Hv#H|#IW#Ij#IpPPPPPPPPPPP#IvPPPPPPP#Jk#Mx$ b$ i$ qPPP$']P$'f$*_$0x$0{$1O$1}$2Q$2X$2aP$2g$2jP$3W$3[$4S$5b$5g$5}PP$6S$6Y$6^$6a$6e$6i$7e$7|$8e$8i$8l$8o$8y$8|$9Q$9UR!|RoqOXst!Z#d%m&r&t&u&w,s,x2[2_Y!vQ'`-e1o5{Q%tvQ%|yQ&T|Q&j!VS'W!e-]Q'f!iS'l!r!yU*k$|*Z*oQ+o%}S+|&V&WQ,d&dQ-c'_Q-m'gQ-u'mQ0[*qQ1b,OQ1y,eR<{<Y%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_S#q]<V!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU+P%]<s<tQ+t&PQ,f&gQ,m&oQ0x+gQ0}+iQ1Y+uQ2R,kQ3`.gQ5`0|Q5f1TQ6[1zQ7Y3dQ8`5gR9e7['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S!S!nQ!r!v!y!z$|'W'_'`'l'm'n*k*o*q*r-]-c-e-u0[0_1o5{5}%[$ti#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q&X|Q'U!eS'[%i-`Q+t&PQ,P&WQ,f&gQ0n+SQ1Y+uQ1_+{Q2Q,jQ2R,kQ5f1TQ5o1aQ6[1zQ6_1|Q6`2PQ8`5gQ8c5lQ8|6bQ:X8dQ:f8yQ;V:YR<}*ZrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R,h&k&z^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'b'r(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>R>S[#]WZ#W#Z'X(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ%wxQ%{yW&Q|&V&W,OQ&_!TQ'c!hQ'e!iQ(q#sS+n%|%}Q+r&PQ,_&bQ,c&dS-l'f'gQ.i(rQ1R+oQ1X+uQ1Z+vQ1^+zQ1t,`S1x,d,eQ2|-mQ5e1TQ5i1WQ5n1`Q6Z1yQ8_5gQ8b5kQ8f5pQ:T8^R;T:U!U$zi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y!^%yy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{Q+h%wQ,T&[Q,W&]Q,b&dQ.h(qQ1s,_U1w,c,d,eQ3e.iQ6U1tS6Y1x1yQ8x6Z#f>T#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o>U<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hW%Ti%V*y>PS&[!Q&iQ&]!RQ&^!SU*}%[%d=sR,R&Y%]%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^T)z$u){V+P%]<s<tW'[!e%i*Z-`S(}#y#zQ+c%rQ+y&SS.b(m(nQ1j,XQ5T0kR8i5u'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S$i$^c#Y#e%q%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.|.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vT#TV#U'RkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ'Y!eR2q-]!W!nQ!e!r!v!y!z$|'W'_'`'l'm'n*Z*k*o*q*r-]-c-e-u0[0_1o5{5}R1l,ZnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&y!^Q'v!xS(s#u<^Q+l%zQ,]&_Q,^&aQ-j'dQ-w'oS.r(x=PS0q+X=ZQ1P+mQ1n,[Q2c,zQ2e,{Q2m-WQ2z-kQ2}-oS5Y0r=eQ5a1QS5d1S=fQ6t2oQ6x2{Q6}3SQ8]5bQ9Y6vQ9Z6yQ9^7OR:l9V$d$]c#Y#e%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vS(o#p'iQ)P#zS+b%q.|S.c(n(pR3^.d'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS#q]<VQ&t!XQ&u!YQ&w![Q&x!]R2Z,vQ'a!hQ+e%wQ-h'cS.e(q+hQ2x-gW3b.h.i0w0yQ6w2yW7U3_3a3e5^U9a7V7X7ZU:q9c9d9fS;b:p:sQ;p;cR;x;qU!wQ'`-eT5y1o5{!Q_OXZ`st!V!Z#d#h%e%m&i&k&r&t&u&w(j,s,x.[2[2_]!pQ!r'`-e1o5{T#q]<V%^{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S(}#y#zS.b(m(n!s=l$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU$fd)_,mS(p#p'iU*v%R(w4OU0m+O.n7gQ5^0xQ7V3`Q9d7YR:s9em!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}Q't!uS(f#g2US-s'k'wQ/s*]Q0R*jQ3U-vQ4f/tQ4r0TQ4s0UQ4x0^Q7r4`S7}4t4vS8R4y4{Q9r7sQ9v7yQ9{8OQ:Q8TS:{9w9xS;g:|;PS;s;h;iS;{;t;uS<P;|;}R<S<QQ#wbQ's!uS(e#g2US(g#m+WQ+Y%fQ+j%xQ+p&OU-r'k't'wQ.W(fU/r*]*`/wQ0S*jQ0V*lQ1O+kQ1u,aS3R-s-vQ3Z.`S4e/s/tQ4n0PS4q0R0^Q4u0WQ6W1vQ7P3US7q4`4bQ7u4fU7|4r4x4{Q8P4wQ8v6XS9q7r7sQ9u7yQ9}8RQ:O8SQ:c8wQ:y9rS:z9v9xQ;S:QQ;^:dS;f:{;PS;r;g;hS;z;s;uS<O;{;}Q<R<PQ<T<SQ=o=jQ={=tR=|=uV!wQ'`-e%^aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S#wz!j!r=i$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=o>R%^bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Q%fj!^%xy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{S&Oz!jQ+k%yQ,a&dW1v,b,c,d,eU6X1w1x1yS8w6Y6ZQ:d8x!r=j$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ=t>QR=u>R%QeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Y#bWZ#W#Z(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ,n&o!p=k$Z$n)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=n'XU']!e%i*ZR2s-`%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ,m&oQ0x+gQ3`.gQ7Y3dR9e7[!b$Tc#Y%q(S(Y(t(y)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!P<d)^)q-Z.|2k2n3p3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!f$Vc#Y%q(S(Y(t(y)W)X)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!T<f)^)q-Z.|2k2n3p3v3w3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!^$Zc#Y%q(S(Y(t(y)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<WQ4_/kz>S)^)q-Z.|2k2n3p4P4X6u7b7k7l8k9X9g9m9n;W;`=vQ>X>ZR>Y>['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS$oh$pR4U/U'XgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$kf$qQ$ifS)j$l)nR)v$qT$jf$qT)l$l)n'XhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$oh$pQ$rhR)u$p%^jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_!s>Q$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S#glOPXZst!Z!`!o#S#d#o#{$n%m&k&n&o&r&t&u&w&{'T'b)O)s*i+]+g,p,s,x-i.g/V/n0]0l1r2S2T2V2X2[2_2a3d4T4z6T6e6f6i7[8t9T!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^Q+T%aQ/c*Oo4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!U$yi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>YQ*c$zU*l$|*Z*oQ+U%bQ0W*m#f=q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n=r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hQ=w>TQ=x>UQ=y>VR=z>W!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hnoOXst!Z#d%m&r&t&u&w,s,x2[2_S*f${*YQ-R'OQ-S'QR4i/y%[%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q,U&]Q1h,WQ5s1gR8h5tV*n$|*Z*oU*n$|*Z*oT5z1o5{S0P*i/nQ4w0]T8S4z:]Q+j%xQ0V*lQ1O+kQ1u,aQ6W1vQ8v6XQ:c8wR;^:d!U%Oi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Yx*R$v)e*S*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>OS0`*t0a#f<o#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<p<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!d=S(u)c*[*e.j.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[`=T3}7c7f7j9h:t:w;yS=_.l3iT=`7e9k!U%Qi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y|*T$v)e*U*t+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>OS0b*u0c#f<q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!h=U(u)c*[*e.k.l.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[d=V3}7d7e7j9h9i:t:u:w;yS=a.m3jT=b7f9lrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q&f!UR,p&ornOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R&f!UQ,Y&^R1d,RsnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q1p,_S6R1s1tU8p6P6Q6US:_8r8sS;Y:^:aQ;m;ZR;w;nQ&m!VR,i&iR6_1|R:f8yW&Q|&V&W,OR1Z+vQ&r!WR,s&sR,y&xT2],x2_R,}&yQ,|&yR2f,}Q'y!{R-y'ySsOtQ#dXT%ps#dQ#OTR'{#OQ#RUR'}#RQ){$uR/`){Q#UVR(Q#UQ#XWU(W#X(X.QQ(X#YR.Q(YQ-^'YR2r-^Q.u(yS3m.u3nR3n.vQ-e'`R2v-eY!rQ'`-e1o5{R'j!rQ/Q)eR4S/QU#_W%h*YU(_#_(`.RQ(`#`R.R(ZQ-a']R2t-at`OXst!V!Z#d%m&i&k&r&t&u&w,s,x2[2_S#hZ%eU#r`#h.[R.[(jQ(k#jQ.X(gW.a(k.X3X7RQ3X.YR7R3YQ)n$lR/W)nQ$phR)t$pQ$`cU)a$`-|<jQ-|<WR<j)qQ/q*]W4c/q4d7t9sU4d/r/s/tS7t4e4fR9s7u$e*Q$v(u)c)e*[*e*t*u+Q+R+V.l.m.o.p.q/_/g/i/k/v/|0d0e0v1e3f3g3h3}4R4[4g4h4l4|5O5R5S5W5r7]7^7_7`7e7f7h7i7j7p7w7z8U8X8Z9h9i9j9t9|:R:S:t:u:v:w:x:};R;e;j;v;y=p=}>O>Z>[Q/z*eU4k/z4m7xQ4m/|R7x4lS*o$|*ZR0Y*ox*S$v)e*t*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>O!d.j(u)c*[*e.l.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/h*S.j7ca7c3}7e7f7j9h:t:w;yQ0a*tQ3i.lU4}0a3i9kR9k7e|*U$v)e*t*u+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>O!h.k(u)c*[*e.l.m.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/j*U.k7de7d3}7e7f7j9h9i:t:u:w;yQ0c*uQ3j.mU5P0c3j9lR9l7fQ*z%UR0g*zQ5]0vR8Y5]Q+_%kR0u+_Q5v1jS8j5v:[R:[8kQ,[&_R1m,[Q5{1oR8m5{Q1{,fS6]1{8zR8z6_Q1U+rW5h1U5j8a:VQ5j1XQ8a5iR:V8bQ+w&QR1[+wQ2_,xR6m2_YrOXst#dQ&v!ZQ+a%mQ,r&rQ,t&tQ,u&uQ,w&wQ2Y,sS2],x2_R6l2[Q%opQ&z!_Q&}!aQ'P!bQ'R!cQ'q!uQ+`%lQ+l%zQ,Q&XQ,h&mQ-P&|W-p'k's't'wQ-w'oQ0X*nQ1P+mQ1c,PS2O,i,lQ2g-OQ2h-RQ2i-SQ2}-oW3P-r-s-v-xQ5a1QQ5m1_Q5q1eQ6V1uQ6a2QQ6k2ZU6z3O3R3UQ6}3SQ8]5bQ8e5oQ8g5rQ8l5zQ8u6WQ8{6`S9[6{7PQ9^7OQ:W8cQ:b8vQ:g8|Q:n9]Q;U:XQ;]:cQ;a:oQ;l;VR;o;^Q%zyQ'd!iQ'o!uU+m%{%|%}Q-W'VU-k'e'f'gS-o'k'uQ0Q*jS1Q+n+oQ2o-YS2{-l-mQ3S-tS4p0R0UQ5b1RQ6v2uQ6y2|Q7O3TU7{4r4s4vQ9z7}R;O9{S$wi>PR*{%VU%Ui%V>PR0f*yQ$viS(u#v+iS)c$b$cQ)e$dQ*[$xS*e${*YQ*t%OQ*u%QQ+Q%^Q+R%_Q+V%cQ.l<oQ.m<qQ.o<uQ.p<wQ.q<yQ/_)yQ/g*RQ/i*TQ/k*VQ/v*aS/|*g/mQ0d*wQ0e*xl0v+f,V.f1i1q3c6S7W8q9b:`:r;[;dQ1e,SQ3f=SQ3g=UQ3h=XS3}<l<mQ4R/PS4[/d4^Q4g/xQ4h/yQ4l/{Q4|0`Q5O0bQ5R0iQ5S0jQ5W0oQ5r1fQ7]=]Q7^=_Q7_=aQ7`=cQ7e<pQ7f<rQ7h<vQ7i<xQ7j<zQ7p4_Q7w4jQ7z4oQ8U5QQ8X5[Q8Z5_Q9h=YQ9i=TQ9j=VQ9t7vQ9|8QQ:R8VQ:S8[Q:t=^Q:u=`Q:v=bQ:w=dQ:x9pQ:}9yQ;R:PQ;e=gQ;j;QQ;v;kQ;y=hQ=p>PQ=}>XQ>O>YQ>Z>]R>[>^Q+O%]Q.n<sR7g<tnpOXst!Z#d%m&r&t&u&w,s,x2[2_Q!fPS#fZ#oQ&|!`W'h!o*i0]4zQ(P#SQ)Q#{Q)r$nS,l&k&nQ,q&oQ-O&{S-T'T/nQ-g'bQ.x)OQ/[)sQ0s+]Q0y+gQ2W,pQ2y-iQ3a.gQ4W/VQ5U0lQ6Q1rQ6c2SQ6d2TQ6h2VQ6j2XQ6o2aQ7Z3dQ7m4TQ8s6TQ9P6eQ9Q6fQ9S6iQ9f7[Q:a8tR:k9T#[cOPXZst!Z!`!o#d#o#{%m&k&n&o&r&t&u&w&{'T'b)O*i+]+g,p,s,x-i.g/n0]0l1r2S2T2V2X2[2_2a3d4z6T6e6f6i7[8t9TQ#YWQ#eYQ%quQ%svS%uw!gS(S#W(VQ(Y#ZQ(t#uQ(y#xQ)R$OQ)S$PQ)T$QQ)U$RQ)V$SQ)W$TQ)X$UQ)Y$VQ)Z$WQ)[$XQ)^$ZQ)`$_Q)b$aQ)g$eW)q$n)s/V4TQ+d%tQ+x&RS-Z'X2pQ-x'rS-}(T.PQ.S(]Q.U(dQ.s(xQ.v(zQ.z<UQ.|<XQ.}<YQ/O<]Q/b)}Q0p+XQ2k-UQ2n-XQ3O-qQ3V.VQ3k.tQ3p<^Q3q<_Q3r<`Q3s<aQ3t<bQ3u<cQ3v<dQ3w<eQ3x<fQ3y<gQ3z<hQ3{.{Q3|<kQ4P<nQ4Q<{Q4X<iQ5X0rQ5c1SQ6u=OQ6{3QQ7Q3WQ7a3lQ7b=PQ7k=RQ7l=ZQ8k5wQ9X6sQ9]6|Q9g=[Q9m=eQ9n=fQ:o9_Q;W:ZQ;`:mQ<W#SR=v>SR#[WR'Z!el!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}S'V!e-]U*j$|*Z*oS-Y'W'_S0U*k*qQ0^*rQ2u-cQ4v0[R4{0_R({#xQ!fQT-d'`-e]!qQ!r'`-e1o5{Q#p]R'i<VR)f$dY!uQ'`-e1o5{Q'k!rS'u!v!yS'w!z5}S-t'l'mQ-v'nR3T-uT#kZ%eS#jZ%eS%km,oU(g#h#i#lS.Y(h(iQ.^(jQ0t+^Q3Y.ZU3Z.[.]._S7S3[3]R9`7Td#^W#W#Z%h(T(^*Y+Z.T/mr#gZm#h#i#l%e(h(i(j+^.Z.[.]._3[3]7TS*]$x*bQ/t*^Q2U,oQ2l-VQ4`/pQ6q2dQ7s4aQ9W6rT=m'X+[V#aW%h*YU#`W%h*YS(U#W(^U(Z#Z+Z/mS-['X+[T.O(T.TV'^!e%i*ZQ$lfR)x$qT)m$l)nR4V/UT*_$x*bT*h${*YQ0w+fQ1g,VQ3_.fQ5t1iQ6P1qQ7X3cQ8r6SQ9c7WQ:^8qQ:p9bQ;Z:`Q;c:rQ;n;[R;q;dnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&l!VR,h&itmOXst!U!V!Z#d%m&i&r&t&u&w,s,x2[2_R,o&oT%lm,oR1k,XR,g&gQ&U|S+}&V&WR1^,OR+s&PT&p!W&sT&q!W&sT2^,x2_",
    nodeNames: `⚠ ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList in out const TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast < ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate asserts is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration defer ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem`,
    maxTerm: 380,
    context: zV,
    nodeProps: [
      [`isolate`, -8, 5, 6, 14, 37, 39, 51, 53, 55, ``],
      [
        `group`,
        -26,
        9,
        17,
        19,
        68,
        207,
        211,
        215,
        216,
        218,
        221,
        224,
        234,
        237,
        243,
        245,
        247,
        249,
        252,
        258,
        264,
        266,
        268,
        270,
        272,
        274,
        275,
        `Statement`,
        -34,
        13,
        14,
        32,
        35,
        36,
        42,
        51,
        54,
        55,
        57,
        62,
        70,
        72,
        76,
        80,
        82,
        84,
        85,
        110,
        111,
        120,
        121,
        136,
        139,
        141,
        142,
        143,
        144,
        145,
        147,
        148,
        167,
        169,
        171,
        `Expression`,
        -23,
        31,
        33,
        37,
        41,
        43,
        45,
        173,
        175,
        177,
        178,
        180,
        181,
        182,
        184,
        185,
        186,
        188,
        189,
        190,
        201,
        203,
        205,
        206,
        `Type`,
        -3,
        88,
        103,
        109,
        `ClassItem`,
      ],
      [
        `openedBy`,
        23,
        `<`,
        38,
        `InterpolationStart`,
        56,
        `[`,
        60,
        `{`,
        73,
        `(`,
        160,
        `JSXStartCloseTag`,
      ],
      [
        `closedBy`,
        -2,
        24,
        168,
        `>`,
        40,
        `InterpolationEnd`,
        50,
        `]`,
        61,
        `}`,
        74,
        `)`,
        165,
        `JSXEndTag`,
      ],
    ],
    propSources: [KV],
    skippedNodes: [0, 5, 6, 278],
    repeatNodeCount: 37,
    tokenData:
      "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$i&j(Wp(Z!b'|0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(X#S$i&j'}0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$i&j(Wp(Z!b'}0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$i&j!p),Q(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(V':f$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$i&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$d`$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$d``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$d`$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(Z!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$d`(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$i&j(Wp(Z!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$i&j(Wp(Z!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$i&j(Z!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$i&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(Z!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$i&j(WpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(WpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Wp(Z!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$i&j(o%1l(Wp(Z!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$i&j(Wp(Z!b$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$i&j(Wp(Z!b$]#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$i&j(Wp(Z!b#p(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$i&j$Q(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(z+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$i&j#z(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(Y';W$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$i&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$d`$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(WpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$d`(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!l/.^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!k!Lf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$i&j(Wp(Z!b(U%&f#q(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$i&j(Wp(Z!b#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$i&j(Wp(Z!br+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!]+Jf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$i&j(Wp(Z!b!Q.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_![!L^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$i&j(Wp(Z!b#o(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$i&j(Z!b!X7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$i&j!X7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$i&j!X7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!X7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!X7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$i&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$i&j(Z!b!X7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(Z!b!X7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(Z!b!X7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(Z!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$i&j(Z!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$i&j(Wp!X7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$i&j(Wp!X7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Wp!X7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Wp!X7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(WpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$i&j(WpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$i&j(Wp(Z!b!X7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Wp(Z!b!X7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Wp(Z!b!X7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Wp(Z!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$i&j(Wp(Z!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$i&j(Wp(Z!b(O0/l!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$i&j(Wp(Z!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$i&j(Z!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$i&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(Z!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$i&j(WpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(WpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Wp(Z!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$i&j$Q(Ch(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Z#t$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!g$b$i&j$O)Lv(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#R-<U(Wp(Z!b$n7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$k&j(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#r(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$Q(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#s(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#`*!Y$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#k(Cl$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#s(Ch$f#|$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#s(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(r(Ct$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$i&j#{(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!|$Ip$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!S0,v$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$i&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$i&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$i&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$i&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$i&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!Y#)l$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#x(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$i&j(Wp(Z!b(a+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$i&j(Wp(Z!b(T,2j$_#t(e$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$i&j(Wp(Z!b$_#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X!_#Hb(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(y+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z)>v$?V_!^(CdvBr$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!q7`$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$i&j(Wp(Z!b'|0/l$]#t(T,2j(e$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$i&j(Wp(Z!b'}0/l$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
    tokenizers: [
      VV,
      HV,
      UV,
      GV,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      BV,
      new qt(
        "$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOx~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!U~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(c~~",
        141,
        340,
      ),
      new qt(`j~RQYZXz{^~^O(Q~~aP!P!Qd~iO(R~~`, 25, 323),
    ],
    topRules: {
      Script: [0, 7],
      SingleExpression: [1, 276],
      SingleClassItem: [2, 277],
    },
    dialects: {
      jsx: 0,
      ts: 15175,
    },
    dynamicPrecedences: {
      80: 1,
      82: 1,
      94: 1,
      169: 1,
      199: 1,
    },
    specialized: [
      {
        term: 327,
        get: (e) => qV[e] || -1,
      },
      {
        term: 343,
        get: (e) => JV[e] || -1,
      },
      {
        term: 95,
        get: (e) => YV[e] || -1,
      },
    ],
    tokenPrec: 15201,
  }),
  ZV = i({
    autoCloseTags: () => xH,
    javascript: () => _H,
    javascriptLanguage: () => lH,
    jsxLanguage: () => fH,
    localCompletionSource: () => cH,
    snippets: () => QV,
    tsxLanguage: () => pH,
    typescriptLanguage: () => dH,
    typescriptSnippets: () => $V,
  }),
  QV = [
    xL("function ${name}(${params}) {\n	${}\n}", {
      label: `function`,
      detail: `definition`,
      type: `keyword`,
    }),
    xL("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
      label: `for`,
      detail: `loop`,
      type: `keyword`,
    }),
    xL("for (let ${name} of ${collection}) {\n	${}\n}", {
      label: `for`,
      detail: `of loop`,
      type: `keyword`,
    }),
    xL(
      `do {
	\${}
} while (\${})`,
      {
        label: `do`,
        detail: `loop`,
        type: `keyword`,
      },
    ),
    xL(
      `while (\${}) {
	\${}
}`,
      {
        label: `while`,
        detail: `loop`,
        type: `keyword`,
      },
    ),
    xL(
      `try {
	\${}
} catch (\${error}) {
	\${}
}`,
      {
        label: `try`,
        detail: `/ catch block`,
        type: `keyword`,
      },
    ),
    xL(
      `if (\${}) {
	\${}
}`,
      {
        label: `if`,
        detail: `block`,
        type: `keyword`,
      },
    ),
    xL(
      `if (\${}) {
	\${}
} else {
	\${}
}`,
      {
        label: `if`,
        detail: `/ else block`,
        type: `keyword`,
      },
    ),
    xL(
      `class \${name} {
	constructor(\${params}) {
		\${}
	}
}`,
      {
        label: `class`,
        detail: `definition`,
        type: `keyword`,
      },
    ),
    xL('import {${names}} from "${module}"\n${}', {
      label: `import`,
      detail: `named`,
      type: `keyword`,
    }),
    xL('import ${name} from "${module}"\n${}', {
      label: `import`,
      detail: `default`,
      type: `keyword`,
    }),
  ],
  $V = QV.concat([
    xL(
      `interface \${name} {
	\${}
}`,
      {
        label: `interface`,
        detail: `definition`,
        type: `keyword`,
      },
    ),
    xL("type ${name} = ${type}", {
      label: `type`,
      detail: `definition`,
      type: `keyword`,
    }),
    xL(
      `enum \${name} {
	\${}
}`,
      {
        label: `enum`,
        detail: `definition`,
        type: `keyword`,
      },
    ),
  ]),
  eH = new yt(),
  tH = new Set([
    `Script`,
    `Block`,
    `FunctionExpression`,
    `FunctionDeclaration`,
    `ArrowFunction`,
    `MethodDeclaration`,
    `ForStatement`,
  ]);
function nH(e) {
  return (t, n) => {
    let r = t.node.getChild(`VariableDefinition`);
    return (r && n(r, e), !0);
  };
}
var rH = [`FunctionDeclaration`],
  iH = {
    FunctionDeclaration: nH(`function`),
    ClassDeclaration: nH(`class`),
    ClassExpression: () => !0,
    EnumDeclaration: nH(`constant`),
    TypeAliasDeclaration: nH(`type`),
    NamespaceDeclaration: nH(`namespace`),
    VariableDefinition(e, t) {
      e.matchContext(rH) || t(e, `variable`);
    },
    TypeDefinition(e, t) {
      t(e, `type`);
    },
    __proto__: null,
  };
function aH(e, t) {
  let n = eH.get(t);
  if (n) return n;
  let r = [],
    i = !0;
  function a(t, n) {
    let i = e.sliceString(t.from, t.to);
    r.push({
      label: i,
      type: n,
    });
  }
  return (
    t.cursor(_t.IncludeAnonymous).iterate((t) => {
      if (i) i = !1;
      else if (t.name) {
        let e = iH[t.name];
        if ((e && e(t, a)) || tH.has(t.name)) return !1;
      } else if (t.to - t.from > 8192) {
        for (let n of aH(e, t.node)) r.push(n);
        return !1;
      }
    }),
    eH.set(t, r),
    r
  );
}
var oH = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/,
  sH = [
    `TemplateString`,
    `String`,
    `RegExp`,
    `LineComment`,
    `BlockComment`,
    `VariableDefinition`,
    `TypeDefinition`,
    `Label`,
    `PropertyDefinition`,
    `PropertyName`,
    `PrivatePropertyDefinition`,
    `PrivatePropertyName`,
    `JSXText`,
    `JSXAttributeValue`,
    `JSXOpenTag`,
    `JSXCloseTag`,
    `JSXSelfClosingTag`,
    `.`,
    `?.`,
  ];
function cH(e) {
  let t = nt(e.state).resolveInner(e.pos, -1);
  if (sH.indexOf(t.name) > -1) return null;
  let n =
    t.name == `VariableName` || (t.to - t.from < 20 && oH.test(e.state.sliceDoc(t.from, t.to)));
  if (!n && !e.explicit) return null;
  let r = [];
  for (let n = t; n; n = n.parent) tH.has(n.name) && (r = r.concat(aH(e.state.doc, n)));
  return {
    options: r,
    from: n ? t.from : e.pos,
    validFor: oH,
  };
}
var lH = dn.define({
    name: `javascript`,
    parser: XV.configure({
      props: [
        it.add({
          IfStatement: $t({
            except: /^\s*({|else\b)/,
          }),
          TryStatement: $t({
            except: /^\s*({|catch\b|finally\b)/,
          }),
          LabeledStatement: At,
          SwitchBody: (e) => {
            let t = e.textAfter,
              n = /^\s*\}/.test(t),
              r = /^\s*(case|default)\b/.test(t);
            return e.baseIndent + (n ? 0 : r ? 1 : 2) * e.unit;
          },
          Block: Ut({
            closing: `}`,
          }),
          ArrowFunction: (e) => e.baseIndent + e.unit,
          "TemplateString BlockComment": () => null,
          "Statement Property": $t({
            except: /^\s*{/,
          }),
          JSXElement(e) {
            let t = /^\s*<\//.test(e.textAfter);
            return e.lineIndent(e.node.from) + (t ? 0 : e.unit);
          },
          JSXEscape(e) {
            let t = /\s*\}/.test(e.textAfter);
            return e.lineIndent(e.node.from) + (t ? 0 : e.unit);
          },
          "JSXOpenTag JSXSelfClosingTag"(e) {
            return e.column(e.node.from) + e.unit;
          },
        }),
        Cn.add({
          "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": _n,
          BlockComment(e) {
            return {
              from: e.from + 2,
              to: e.to - 2,
            };
          },
          JSXElement(e) {
            let t = e.firstChild;
            if (!t || t.name == `JSXSelfClosingTag`) return null;
            let n = e.lastChild;
            return {
              from: t.to,
              to: n.type.isError ? e.to : n.from,
            };
          },
          "JSXSelfClosingTag JSXOpenTag"(e) {
            let t = e.firstChild?.nextSibling,
              n = e.lastChild;
            return !t || t.type.isError
              ? null
              : {
                  from: t.to,
                  to: n.type.isError ? e.to : n.from,
                };
          },
        }),
      ],
    }),
    languageData: {
      closeBrackets: {
        brackets: [`(`, `[`, `{`, `'`, `"`, "`"],
      },
      commentTokens: {
        line: `//`,
        block: {
          open: `/*`,
          close: `*/`,
        },
      },
      indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
      wordChars: `$`,
    },
  }),
  uH = {
    test: (e) => /^JSX/.test(e.name),
    facet: Gt({
      commentTokens: {
        block: {
          open: `{/*`,
          close: `*/}`,
        },
      },
    }),
  },
  dH = lH.configure(
    {
      dialect: `ts`,
    },
    `typescript`,
  ),
  fH = lH.configure({
    dialect: `jsx`,
    props: [gt.add((e) => (e.isTop ? [uH] : void 0))],
  }),
  pH = lH.configure(
    {
      dialect: `jsx ts`,
      props: [gt.add((e) => (e.isTop ? [uH] : void 0))],
    },
    `typescript`,
  ),
  mH = (e) => ({
    label: e,
    type: `keyword`,
  }),
  hH =
    `break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield`
      .split(` `)
      .map(mH),
  gH = hH.concat([`declare`, `implements`, `private`, `protected`, `public`].map(mH));
function _H(e = {}) {
  let t = e.jsx ? (e.typescript ? pH : fH) : e.typescript ? dH : lH,
    n = e.typescript ? $V.concat(gH) : QV.concat(hH);
  return new hn(t, [
    lH.data.of({
      autocomplete: dI(sH, uI(n)),
    }),
    lH.data.of({
      autocomplete: cH,
    }),
    e.jsx ? xH : [],
  ]);
}
function vH(e) {
  for (;;) {
    if (e.name == `JSXOpenTag` || e.name == `JSXSelfClosingTag` || e.name == `JSXFragmentTag`)
      return e;
    if (e.name == `JSXEscape` || !e.parent) return null;
    e = e.parent;
  }
}
function yH(e, t, n = e.length) {
  for (let r = t?.firstChild; r; r = r.nextSibling)
    if (
      r.name == `JSXIdentifier` ||
      r.name == `JSXBuiltin` ||
      r.name == `JSXNamespacedName` ||
      r.name == `JSXMemberExpression`
    )
      return e.sliceString(r.from, Math.min(r.to, n));
  return ``;
}
var bH = typeof navigator == `object` && /Android\b/.test(navigator.userAgent),
  xH = Et.inputHandler.of((e, t, n, r, i) => {
    if (
      (bH ? e.composing : e.compositionStarted) ||
      e.state.readOnly ||
      t != n ||
      (r != `>` && r != `/`) ||
      !lH.isActiveAt(e.state, t, -1)
    )
      return !1;
    let a = i(),
      { state: o } = a,
      s = o.changeByRange((e) => {
        let { head: t } = e,
          n = nt(o).resolveInner(t - 1, -1),
          i;
        if (
          (n.name == `JSXStartTag` && (n = n.parent),
          !(o.doc.sliceString(t - 1, t) != r || (n.name == `JSXAttributeValue` && n.to > t)))
        ) {
          if (r == `>` && n.name == `JSXFragmentTag`)
            return {
              range: e,
              changes: {
                from: t,
                insert: `</>`,
              },
            };
          if (r == `/` && n.name == `JSXStartCloseTag`) {
            let e = n.parent,
              r = e.parent;
            if (
              r &&
              e.from == t - 2 &&
              ((i = yH(o.doc, r.firstChild, t)) || r.firstChild?.name == `JSXFragmentTag`)
            ) {
              let e = `${i}>`;
              return {
                range: Qt.cursor(t + e.length, -1),
                changes: {
                  from: t,
                  insert: e,
                },
              };
            }
          } else if (r == `>`) {
            let r = vH(n);
            if (
              r &&
              r.name == `JSXOpenTag` &&
              !/^\/?>|^<\//.test(o.doc.sliceString(t, t + 2)) &&
              (i = yH(o.doc, r, t))
            )
              return {
                range: e,
                changes: {
                  from: t,
                  insert: `</${i}>`,
                },
              };
          }
        }
        return {
          range: e,
        };
      });
    return s.changes.empty
      ? !1
      : (e.dispatch([
          a,
          o.update(s, {
            userEvent: `input.complete`,
            scrollIntoView: !0,
          }),
        ]),
        !0);
  }),
  SH = i({
    autoCloseTags: () => $H,
    html: () => ZH,
    htmlCompletionSource: () => WH,
    htmlCompletionSourceWith: () => GH,
    htmlLanguage: () => XH,
  }),
  CH = [`_blank`, `_self`, `_top`, `_parent`],
  wH = [`ascii`, `utf-8`, `utf-16`, `latin1`, `latin1`],
  TH = [`get`, `post`, `put`, `delete`],
  EH = [`application/x-www-form-urlencoded`, `multipart/form-data`, `text/plain`],
  DH = [`true`, `false`],
  OH = {},
  kH = {
    a: {
      attrs: {
        href: null,
        ping: null,
        type: null,
        media: null,
        target: CH,
        hreflang: null,
      },
    },
    abbr: OH,
    address: OH,
    area: {
      attrs: {
        alt: null,
        coords: null,
        href: null,
        target: null,
        ping: null,
        media: null,
        hreflang: null,
        type: null,
        shape: [`default`, `rect`, `circle`, `poly`],
      },
    },
    article: OH,
    aside: OH,
    audio: {
      attrs: {
        src: null,
        mediagroup: null,
        crossorigin: [`anonymous`, `use-credentials`],
        preload: [`none`, `metadata`, `auto`],
        autoplay: [`autoplay`],
        loop: [`loop`],
        controls: [`controls`],
      },
    },
    b: OH,
    base: {
      attrs: {
        href: null,
        target: CH,
      },
    },
    bdi: OH,
    bdo: OH,
    blockquote: {
      attrs: {
        cite: null,
      },
    },
    body: OH,
    br: OH,
    button: {
      attrs: {
        form: null,
        formaction: null,
        name: null,
        value: null,
        autofocus: [`autofocus`],
        disabled: [`autofocus`],
        formenctype: EH,
        formmethod: TH,
        formnovalidate: [`novalidate`],
        formtarget: CH,
        type: [`submit`, `reset`, `button`],
      },
    },
    canvas: {
      attrs: {
        width: null,
        height: null,
      },
    },
    caption: OH,
    center: OH,
    cite: OH,
    code: OH,
    col: {
      attrs: {
        span: null,
      },
    },
    colgroup: {
      attrs: {
        span: null,
      },
    },
    command: {
      attrs: {
        type: [`command`, `checkbox`, `radio`],
        label: null,
        icon: null,
        radiogroup: null,
        command: null,
        title: null,
        disabled: [`disabled`],
        checked: [`checked`],
      },
    },
    data: {
      attrs: {
        value: null,
      },
    },
    datagrid: {
      attrs: {
        disabled: [`disabled`],
        multiple: [`multiple`],
      },
    },
    datalist: {
      attrs: {
        data: null,
      },
    },
    dd: OH,
    del: {
      attrs: {
        cite: null,
        datetime: null,
      },
    },
    details: {
      attrs: {
        open: [`open`],
      },
    },
    dfn: OH,
    div: OH,
    dl: OH,
    dt: OH,
    em: OH,
    embed: {
      attrs: {
        src: null,
        type: null,
        width: null,
        height: null,
      },
    },
    eventsource: {
      attrs: {
        src: null,
      },
    },
    fieldset: {
      attrs: {
        disabled: [`disabled`],
        form: null,
        name: null,
      },
    },
    figcaption: OH,
    figure: OH,
    footer: OH,
    form: {
      attrs: {
        action: null,
        name: null,
        "accept-charset": wH,
        autocomplete: [`on`, `off`],
        enctype: EH,
        method: TH,
        novalidate: [`novalidate`],
        target: CH,
      },
    },
    h1: OH,
    h2: OH,
    h3: OH,
    h4: OH,
    h5: OH,
    h6: OH,
    head: {
      children: [`title`, `base`, `link`, `style`, `meta`, `script`, `noscript`, `command`],
    },
    header: OH,
    hgroup: OH,
    hr: OH,
    html: {
      attrs: {
        manifest: null,
      },
    },
    i: OH,
    iframe: {
      attrs: {
        src: null,
        srcdoc: null,
        name: null,
        width: null,
        height: null,
        sandbox: [`allow-top-navigation`, `allow-same-origin`, `allow-forms`, `allow-scripts`],
        seamless: [`seamless`],
      },
    },
    img: {
      attrs: {
        alt: null,
        src: null,
        ismap: null,
        usemap: null,
        width: null,
        height: null,
        crossorigin: [`anonymous`, `use-credentials`],
      },
    },
    input: {
      attrs: {
        alt: null,
        dirname: null,
        form: null,
        formaction: null,
        height: null,
        list: null,
        max: null,
        maxlength: null,
        min: null,
        name: null,
        pattern: null,
        placeholder: null,
        size: null,
        src: null,
        step: null,
        value: null,
        width: null,
        accept: [`audio/*`, `video/*`, `image/*`],
        autocomplete: [`on`, `off`],
        autofocus: [`autofocus`],
        checked: [`checked`],
        disabled: [`disabled`],
        formenctype: EH,
        formmethod: TH,
        formnovalidate: [`novalidate`],
        formtarget: CH,
        multiple: [`multiple`],
        readonly: [`readonly`],
        required: [`required`],
        type: [
          `hidden`,
          `text`,
          `search`,
          `tel`,
          `url`,
          `email`,
          `password`,
          `datetime`,
          `date`,
          `month`,
          `week`,
          `time`,
          `datetime-local`,
          `number`,
          `range`,
          `color`,
          `checkbox`,
          `radio`,
          `file`,
          `submit`,
          `image`,
          `reset`,
          `button`,
        ],
      },
    },
    ins: {
      attrs: {
        cite: null,
        datetime: null,
      },
    },
    kbd: OH,
    keygen: {
      attrs: {
        challenge: null,
        form: null,
        name: null,
        autofocus: [`autofocus`],
        disabled: [`disabled`],
        keytype: [`RSA`],
      },
    },
    label: {
      attrs: {
        for: null,
        form: null,
      },
    },
    legend: OH,
    li: {
      attrs: {
        value: null,
      },
    },
    link: {
      attrs: {
        href: null,
        type: null,
        hreflang: null,
        media: null,
        sizes: [`all`, `16x16`, `16x16 32x32`, `16x16 32x32 64x64`],
      },
    },
    map: {
      attrs: {
        name: null,
      },
    },
    mark: OH,
    menu: {
      attrs: {
        label: null,
        type: [`list`, `context`, `toolbar`],
      },
    },
    meta: {
      attrs: {
        content: null,
        charset: wH,
        name: [`viewport`, `application-name`, `author`, `description`, `generator`, `keywords`],
        "http-equiv": [`content-language`, `content-type`, `default-style`, `refresh`],
      },
    },
    meter: {
      attrs: {
        value: null,
        min: null,
        low: null,
        high: null,
        max: null,
        optimum: null,
      },
    },
    nav: OH,
    noscript: OH,
    object: {
      attrs: {
        data: null,
        type: null,
        name: null,
        usemap: null,
        form: null,
        width: null,
        height: null,
        typemustmatch: [`typemustmatch`],
      },
    },
    ol: {
      attrs: {
        reversed: [`reversed`],
        start: null,
        type: [`1`, `a`, `A`, `i`, `I`],
      },
      children: [`li`, `script`, `template`, `ul`, `ol`],
    },
    optgroup: {
      attrs: {
        disabled: [`disabled`],
        label: null,
      },
    },
    option: {
      attrs: {
        disabled: [`disabled`],
        label: null,
        selected: [`selected`],
        value: null,
      },
    },
    output: {
      attrs: {
        for: null,
        form: null,
        name: null,
      },
    },
    p: OH,
    param: {
      attrs: {
        name: null,
        value: null,
      },
    },
    pre: OH,
    progress: {
      attrs: {
        value: null,
        max: null,
      },
    },
    q: {
      attrs: {
        cite: null,
      },
    },
    rp: OH,
    rt: OH,
    ruby: OH,
    samp: OH,
    script: {
      attrs: {
        type: [`text/javascript`],
        src: null,
        async: [`async`],
        defer: [`defer`],
        charset: wH,
      },
    },
    section: OH,
    select: {
      attrs: {
        form: null,
        name: null,
        size: null,
        autofocus: [`autofocus`],
        disabled: [`disabled`],
        multiple: [`multiple`],
      },
    },
    slot: {
      attrs: {
        name: null,
      },
    },
    small: OH,
    source: {
      attrs: {
        src: null,
        type: null,
        media: null,
      },
    },
    span: OH,
    strong: OH,
    style: {
      attrs: {
        type: [`text/css`],
        media: null,
        scoped: null,
      },
    },
    sub: OH,
    summary: OH,
    sup: OH,
    table: OH,
    tbody: OH,
    td: {
      attrs: {
        colspan: null,
        rowspan: null,
        headers: null,
      },
    },
    template: OH,
    textarea: {
      attrs: {
        dirname: null,
        form: null,
        maxlength: null,
        name: null,
        placeholder: null,
        rows: null,
        cols: null,
        autofocus: [`autofocus`],
        disabled: [`disabled`],
        readonly: [`readonly`],
        required: [`required`],
        wrap: [`soft`, `hard`],
      },
    },
    tfoot: OH,
    th: {
      attrs: {
        colspan: null,
        rowspan: null,
        headers: null,
        scope: [`row`, `col`, `rowgroup`, `colgroup`],
      },
    },
    thead: OH,
    time: {
      attrs: {
        datetime: null,
      },
    },
    title: OH,
    tr: OH,
    track: {
      attrs: {
        src: null,
        label: null,
        default: null,
        kind: [`subtitles`, `captions`, `descriptions`, `chapters`, `metadata`],
        srclang: null,
      },
    },
    ul: {
      children: [`li`, `script`, `template`, `ul`, `ol`],
    },
    var: OH,
    video: {
      attrs: {
        src: null,
        poster: null,
        width: null,
        height: null,
        crossorigin: [`anonymous`, `use-credentials`],
        preload: [`auto`, `metadata`, `none`],
        autoplay: [`autoplay`],
        mediagroup: [`movie`],
        muted: [`muted`],
        controls: [`controls`],
      },
    },
    wbr: OH,
  },
  AH = {
    accesskey: null,
    class: null,
    contenteditable: DH,
    contextmenu: null,
    dir: [`ltr`, `rtl`, `auto`],
    draggable: [`true`, `false`, `auto`],
    dropzone: [`copy`, `move`, `link`, `string:`, `file:`],
    hidden: [`hidden`],
    id: null,
    inert: [`inert`],
    itemid: null,
    itemprop: null,
    itemref: null,
    itemscope: [`itemscope`],
    itemtype: null,
    lang: [
      `ar`,
      `bn`,
      `de`,
      `en-GB`,
      `en-US`,
      `es`,
      `fr`,
      `hi`,
      `id`,
      `ja`,
      `pa`,
      `pt`,
      `ru`,
      `tr`,
      `zh`,
    ],
    spellcheck: DH,
    autocorrect: DH,
    autocapitalize: DH,
    style: null,
    tabindex: null,
    title: null,
    translate: [`yes`, `no`],
    rel: [
      `stylesheet`,
      `alternate`,
      `author`,
      `bookmark`,
      `help`,
      `license`,
      `next`,
      `nofollow`,
      `noreferrer`,
      `prefetch`,
      `prev`,
      `search`,
      `tag`,
    ],
    role: `alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer`.split(
      ` `,
    ),
    "aria-activedescendant": null,
    "aria-atomic": DH,
    "aria-autocomplete": [`inline`, `list`, `both`, `none`],
    "aria-busy": DH,
    "aria-checked": [`true`, `false`, `mixed`, `undefined`],
    "aria-controls": null,
    "aria-describedby": null,
    "aria-disabled": DH,
    "aria-dropeffect": null,
    "aria-expanded": [`true`, `false`, `undefined`],
    "aria-flowto": null,
    "aria-grabbed": [`true`, `false`, `undefined`],
    "aria-haspopup": DH,
    "aria-hidden": DH,
    "aria-invalid": [`true`, `false`, `grammar`, `spelling`],
    "aria-label": null,
    "aria-labelledby": null,
    "aria-level": null,
    "aria-live": [`off`, `polite`, `assertive`],
    "aria-multiline": DH,
    "aria-multiselectable": DH,
    "aria-owns": null,
    "aria-posinset": null,
    "aria-pressed": [`true`, `false`, `mixed`, `undefined`],
    "aria-readonly": DH,
    "aria-relevant": null,
    "aria-required": DH,
    "aria-selected": [`true`, `false`, `undefined`],
    "aria-setsize": null,
    "aria-sort": [`ascending`, `descending`, `none`, `other`],
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
  },
  jH =
    `beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload`
      .split(` `)
      .map((e) => `on` + e);
for (let e of jH) AH[e] = null;
var MH = class {
  constructor(e, t) {
    ((this.tags = {
      ...kH,
      ...e,
    }),
      (this.globalAttrs = {
        ...AH,
        ...t,
      }),
      (this.allTags = Object.keys(this.tags)),
      (this.globalAttrNames = Object.keys(this.globalAttrs)));
  }
};
MH.default = new MH();
function NH(e, t, n = e.length) {
  if (!t) return ``;
  let r = t.firstChild,
    i = r && r.getChild(`TagName`);
  return i ? e.sliceString(i.from, Math.min(i.to, n)) : ``;
}
function PH(e, t = !1) {
  for (; e; e = e.parent)
    if (e.name == `Element`)
      if (t) t = !1;
      else return e;
  return null;
}
function FH(e, t, n) {
  return n.tags[NH(e, PH(t))]?.children || n.allTags;
}
function IH(e, t) {
  let n = [];
  for (let r = PH(t); r && !r.type.isTop; r = PH(r.parent)) {
    let i = NH(e, r);
    if (i && r.lastChild.name == `CloseTag`) break;
    i && n.indexOf(i) < 0 && (t.name == `EndTag` || t.from >= r.firstChild.to) && n.push(i);
  }
  return n;
}
var LH = /^[:\-\.\w\u00b7-\uffff]*$/;
function RH(e, t, n, r, i) {
  let a = /\s*>/.test(e.sliceDoc(i, i + 5)) ? `` : `>`,
    o = PH(n, n.name == `StartTag` || n.name == `TagName`);
  return {
    from: r,
    to: i,
    options: FH(e.doc, o, t)
      .map((e) => ({
        label: e,
        type: `type`,
      }))
      .concat(
        IH(e.doc, n).map((e, t) => ({
          label: `/` + e,
          apply: `/` + e + a,
          type: `type`,
          boost: 99 - t,
        })),
      ),
    validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/,
  };
}
function zH(e, t, n, r) {
  let i = /\s*>/.test(e.sliceDoc(r, r + 5)) ? `` : `>`;
  return {
    from: n,
    to: r,
    options: IH(e.doc, t).map((e, t) => ({
      label: e,
      apply: e + i,
      type: `type`,
      boost: 99 - t,
    })),
    validFor: LH,
  };
}
function BH(e, t, n, r) {
  let i = [],
    a = 0;
  for (let r of FH(e.doc, n, t))
    i.push({
      label: `<` + r,
      type: `type`,
    });
  for (let t of IH(e.doc, n))
    i.push({
      label: `</` + t + `>`,
      type: `type`,
      boost: 99 - a++,
    });
  return {
    from: r,
    to: r,
    options: i,
    validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/,
  };
}
function VH(e, t, n, r, i) {
  let a = PH(n),
    o = a ? t.tags[NH(e.doc, a)] : null,
    s = o && o.attrs ? Object.keys(o.attrs) : [];
  return {
    from: r,
    to: i,
    options: (o && o.globalAttrs === !1
      ? s
      : s.length
        ? s.concat(t.globalAttrNames)
        : t.globalAttrNames
    ).map((e) => ({
      label: e,
      type: `property`,
    })),
    validFor: LH,
  };
}
function HH(e, t, n, r, i) {
  let a = n.parent?.getChild(`AttributeName`),
    o = [],
    s;
  if (a) {
    let c = e.sliceDoc(a.from, a.to),
      l = t.globalAttrs[c];
    if (!l) {
      let r = PH(n),
        i = r ? t.tags[NH(e.doc, r)] : null;
      l = i?.attrs && i.attrs[c];
    }
    if (l) {
      let t = e.sliceDoc(r, i).toLowerCase(),
        n = `"`,
        a = `"`;
      /^['"]/.test(t)
        ? ((s = t[0] == `"` ? /^[^"]*$/ : /^[^']*$/),
          (n = ``),
          (a = e.sliceDoc(i, i + 1) == t[0] ? `` : t[0]),
          (t = t.slice(1)),
          r++)
        : (s = /^[^\s<>='"]*$/);
      for (let e of l)
        o.push({
          label: e,
          apply: n + e + a,
          type: `constant`,
        });
    }
  }
  return {
    from: r,
    to: i,
    options: o,
    validFor: s,
  };
}
function UH(e, t) {
  let { state: n, pos: r } = t,
    i = nt(n).resolveInner(r, -1),
    a = i.resolve(r);
  for (let e = r, t; a == i && (t = i.childBefore(e));) {
    let n = t.lastChild;
    if (!n || !n.type.isError || n.from < n.to) break;
    ((a = i = t), (e = n.from));
  }
  return i.name == `TagName`
    ? i.parent && /CloseTag$/.test(i.parent.name)
      ? zH(n, i, i.from, r)
      : RH(n, e, i, i.from, r)
    : i.name == `StartTag` || i.name == `IncompleteTag`
      ? RH(n, e, i, r, r)
      : i.name == `StartCloseTag` || i.name == `IncompleteCloseTag`
        ? zH(n, i, r, r)
        : i.name == `OpenTag` || i.name == `SelfClosingTag` || i.name == `AttributeName`
          ? VH(n, e, i, i.name == `AttributeName` ? i.from : r, r)
          : i.name == `Is` || i.name == `AttributeValue` || i.name == `UnquotedAttributeValue`
            ? HH(n, e, i, i.name == `Is` ? r : i.from, r)
            : t.explicit && (a.name == `Element` || a.name == `Text` || a.name == `Document`)
              ? BH(n, e, i, r)
              : null;
}
function WH(e) {
  return UH(MH.default, e);
}
function GH(e) {
  let { extraTags: t, extraGlobalAttributes: n } = e,
    r = n || t ? new MH(t, n) : MH.default;
  return (e) => UH(r, e);
}
var KH = lH.parser.configure({
    top: `SingleExpression`,
  }),
  qH = [
    {
      tag: `script`,
      attrs: (e) => e.type == `text/typescript` || e.lang == `ts`,
      parser: dH.parser,
    },
    {
      tag: `script`,
      attrs: (e) => e.type == `text/babel` || e.type == `text/jsx`,
      parser: fH.parser,
    },
    {
      tag: `script`,
      attrs: (e) => e.type == `text/typescript-jsx`,
      parser: pH.parser,
    },
    {
      tag: `script`,
      attrs(e) {
        return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(e.type);
      },
      parser: KH,
    },
    {
      tag: `script`,
      attrs(e) {
        return (
          !e.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(e.type)
        );
      },
      parser: lH.parser,
    },
    {
      tag: `style`,
      attrs(e) {
        return (
          (!e.lang || e.lang == `css`) &&
          (!e.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(e.type))
        );
      },
      parser: pV.parser,
    },
  ],
  JH = [
    {
      name: `style`,
      parser: pV.parser.configure({
        top: `Styles`,
      }),
    },
  ].concat(
    jH.map((e) => ({
      name: e,
      parser: lH.parser,
    })),
  ),
  YH = dn.define({
    name: `html`,
    parser: uB.configure({
      props: [
        it.add({
          Element(e) {
            let t = /^(\s*)(<\/)?/.exec(e.textAfter);
            return e.node.to <= e.pos + t[0].length
              ? e.continue()
              : e.lineIndent(e.node.from) + (t[2] ? 0 : e.unit);
          },
          "OpenTag CloseTag SelfClosingTag"(e) {
            return e.column(e.node.from) + e.unit;
          },
          Document(e) {
            if (e.pos + /\s*/.exec(e.textAfter)[0].length < e.node.to) return e.continue();
            let t = null,
              n;
            for (let n = e.node; ;) {
              let e = n.lastChild;
              if (!e || e.name != `Element` || e.to != n.to) break;
              t = n = e;
            }
            return t && !((n = t.lastChild) && (n.name == `CloseTag` || n.name == `SelfClosingTag`))
              ? e.lineIndent(t.from) + e.unit
              : null;
          },
        }),
        Cn.add({
          Element(e) {
            let t = e.firstChild,
              n = e.lastChild;
            return !t || t.name != `OpenTag`
              ? null
              : {
                  from: t.to,
                  to: n.name == `CloseTag` ? n.from : e.to,
                };
          },
        }),
        on.add({
          "OpenTag CloseTag": (e) => e.getChild(`TagName`),
        }),
      ],
    }),
    languageData: {
      commentTokens: {
        block: {
          open: `<!--`,
          close: `-->`,
        },
      },
      indentOnInput: /^\s*<\/\w+\W$/,
      wordChars: `-_`,
    },
  }),
  XH = YH.configure({
    wrap: mB(qH, JH),
  });
function ZH(e = {}) {
  let t = ``,
    n;
  return (
    e.matchClosingTags === !1 && (t = `noMatch`),
    e.selfClosingTags === !0 && (t = (t ? t + ` ` : ``) + `selfClosing`),
    ((e.nestedLanguages && e.nestedLanguages.length) ||
      (e.nestedAttributes && e.nestedAttributes.length)) &&
      (n = mB((e.nestedLanguages || []).concat(qH), (e.nestedAttributes || []).concat(JH))),
    new hn(
      n
        ? YH.configure({
            wrap: n,
            dialect: t,
          })
        : t
          ? XH.configure({
              dialect: t,
            })
          : XH,
      [
        XH.data.of({
          autocomplete: GH(e),
        }),
        e.autoCloseTags === !1 ? [] : $H,
        _H().support,
        mV().support,
      ],
    )
  );
}
var QH = new Set(
    `area base br col command embed frame hr img input keygen link meta param source track wbr menuitem`.split(
      ` `,
    ),
  ),
  $H = Et.inputHandler.of((e, t, n, r, i) => {
    if (
      e.composing ||
      e.state.readOnly ||
      t != n ||
      (r != `>` && r != `/`) ||
      !XH.isActiveAt(e.state, t, -1)
    )
      return !1;
    let a = i(),
      { state: o } = a,
      s = o.changeByRange((e) => {
        let t = o.doc.sliceString(e.from - 1, e.to) == r,
          { head: n } = e,
          i = nt(o).resolveInner(n, -1),
          a;
        if (t && r == `>` && i.name == `EndTag`) {
          let t = i.parent;
          if (t.parent?.lastChild?.name != `CloseTag` && (a = NH(o.doc, t.parent, n)) && !QH.has(a))
            return {
              range: e,
              changes: {
                from: n,
                to: n + +(o.doc.sliceString(n, n + 1) === `>`),
                insert: `</${a}>`,
              },
            };
        } else if (t && r == `/` && i.name == `IncompleteCloseTag`) {
          let e = i.parent;
          if (
            i.from == n - 2 &&
            e.lastChild?.name != `CloseTag` &&
            (a = NH(o.doc, e, n)) &&
            !QH.has(a)
          ) {
            let e = n + +(o.doc.sliceString(n, n + 1) === `>`),
              t = `${a}>`;
            return {
              range: Qt.cursor(n + t.length, -1),
              changes: {
                from: n,
                to: e,
                insert: t,
              },
            };
          }
        }
        return {
          range: e,
        };
      });
    return s.changes.empty
      ? !1
      : (e.dispatch([
          a,
          o.update(s, {
            userEvent: `input.complete`,
            scrollIntoView: !0,
          }),
        ]),
        !0);
  }),
  eU = i({
    commonmarkLanguage: () => lU,
    deleteMarkupBackward: () => CU,
    insertNewlineContinueMarkup: () => vU,
    insertNewlineContinueMarkupCommand: () => _U,
    markdown: () => EU,
    markdownKeymap: () => wU,
    markdownLanguage: () => uU,
    pasteURLAsLink: () => jU,
  }),
  tU = Gt({
    commentTokens: {
      block: {
        open: `<!--`,
        close: `-->`,
      },
    },
  }),
  nU = new ct(),
  rU = PR.configure({
    props: [
      Cn.add((e) =>
        !e.is(`Block`) || e.is(`Document`) || iU(e) != null || aU(e)
          ? void 0
          : (e, t) => ({
              from: t.doc.lineAt(e.from).to,
              to: e.to,
            }),
      ),
      nU.add(iU),
      it.add({
        Document: () => null,
      }),
      st.add({
        Document: tU,
      }),
    ],
  });
function iU(e) {
  let t = /^(?:ATX|Setext)Heading(\d)$/.exec(e.name);
  return t ? +t[1] : void 0;
}
function aU(e) {
  return e.name == `OrderedList` || e.name == `BulletList`;
}
function oU(e, t) {
  let n = e;
  for (;;) {
    let e = n.nextSibling,
      r;
    if (!e || ((r = iU(e.type)) != null && r <= t)) break;
    n = e;
  }
  return n.to;
}
var sU = Pt.of((e, t, n) => {
  for (let r = nt(e).resolveInner(n, -1); r && !(r.from < t); r = r.parent) {
    let e = r.type.prop(nU);
    if (e == null) continue;
    let t = oU(r, e);
    if (t > n)
      return {
        from: n,
        to: t,
      };
  }
  return null;
});
function cU(e) {
  return new It(tU, e, [], `markdown`);
}
var lU = cU(rU),
  uU = cU(
    rU.configure([
      ez,
      rz,
      nz,
      iz,
      {
        props: [
          Cn.add({
            Table: (e, t) => ({
              from: t.doc.lineAt(e.from).to,
              to: e.to,
            }),
          }),
        ],
      },
    ]),
  );
function dU(e, t) {
  return (n) => {
    if (n && e) {
      let t = null;
      if (
        ((n = /\S*/.exec(n)[0]),
        (t = typeof e == `function` ? e(n) : Zt.matchLanguageName(e, n, !0)),
        t instanceof Zt)
      )
        return t.support ? t.support.language.parser : Rt.getSkippingParser(t.load());
      if (t) return t.parser;
    }
    return t ? t.parser : null;
  };
}
var fU = class {
  constructor(e, t, n, r, i, a, o) {
    ((this.node = e),
      (this.from = t),
      (this.to = n),
      (this.spaceBefore = r),
      (this.spaceAfter = i),
      (this.type = a),
      (this.item = o));
  }
  blank(e, t = !0) {
    let n = this.spaceBefore + (this.node.name == `Blockquote` ? `>` : ``);
    if (e != null) {
      for (; n.length < e;) n += ` `;
      return n;
    } else {
      for (let e = this.to - this.from - n.length - this.spaceAfter.length; e > 0; e--) n += ` `;
      return n + (t ? this.spaceAfter : ``);
    }
  }
  marker(e, t) {
    let n = this.node.name == `OrderedList` ? String(+mU(this.item, e)[2] + t) : ``;
    return this.spaceBefore + n + this.type + this.spaceAfter;
  }
};
function pU(e, t) {
  let n = [],
    r = [];
  for (let t = e; t; t = t.parent) {
    if (t.name == `FencedCode`) return r;
    (t.name == `ListItem` || t.name == `Blockquote`) && n.push(t);
  }
  for (let e = n.length - 1; e >= 0; e--) {
    let i = n[e],
      a,
      o = t.lineAt(i.from),
      s = i.from - o.from;
    if (i.name == `Blockquote` && (a = /^ *>( ?)/.exec(o.text.slice(s))))
      r.push(new fU(i, s, s + a[0].length, ``, a[1], `>`, null));
    else if (
      i.name == `ListItem` &&
      i.parent.name == `OrderedList` &&
      (a = /^( *)\d+([.)])( *)/.exec(o.text.slice(s)))
    ) {
      let e = a[3],
        t = a[0].length;
      (e.length >= 4 && ((e = e.slice(0, e.length - 4)), (t -= 4)),
        r.push(new fU(i.parent, s, s + t, a[1], e, a[2], i)));
    } else if (
      i.name == `ListItem` &&
      i.parent.name == `BulletList` &&
      (a = /^( *)([-+*])( {1,4}\[[ xX]\])?( +)/.exec(o.text.slice(s)))
    ) {
      let e = a[4],
        t = a[0].length;
      e.length > 4 && ((e = e.slice(0, e.length - 4)), (t -= 4));
      let n = a[2];
      (a[3] && (n += a[3].replace(/[xX]/, ` `)), r.push(new fU(i.parent, s, s + t, a[1], e, n, i)));
    }
  }
  return r;
}
function mU(e, t) {
  return /^(\s*)(\d+)(?=[.)])/.exec(t.sliceString(e.from, e.from + 10));
}
function hU(e, t, n, r = 0) {
  for (let i = -1, a = e; ;) {
    if (a.name == `ListItem`) {
      let e = mU(a, t),
        o = +e[2];
      if (i >= 0) {
        if (o != i + 1) return;
        n.push({
          from: a.from + e[1].length,
          to: a.from + e[0].length,
          insert: String(i + 2 + r),
        });
      }
      i = o;
    }
    let e = a.nextSibling;
    if (!e) break;
    a = e;
  }
}
function gU(e, t) {
  let n = /^[ \t]*/.exec(e)[0].length;
  if (!n || t.facet(St) != `	`) return e;
  let r = at(e, 4, n),
    i = ``;
  for (let e = r; e > 0;) e >= 4 ? ((i += `	`), (e -= 4)) : ((i += ` `), e--);
  return i + e.slice(n);
}
var _U =
    (e = {}) =>
    ({ state: t, dispatch: n }) => {
      let r = nt(t),
        { doc: i } = t,
        a = null,
        o = t.changeByRange((n) => {
          if (!n.empty || (!uU.isActiveAt(t, n.from, -1) && !uU.isActiveAt(t, n.from, 1)))
            return (a = {
              range: n,
            });
          let o = n.from,
            s = i.lineAt(o),
            c = pU(r.resolveInner(o, -1), i);
          for (; c.length && c[c.length - 1].from > o - s.from;) c.pop();
          if (!c.length)
            return (a = {
              range: n,
            });
          let l = c[c.length - 1];
          if (l.to - l.spaceAfter.length > o - s.from)
            return (a = {
              range: n,
            });
          let u = o >= l.to - l.spaceAfter.length && !/\S/.test(s.text.slice(l.to));
          if (l.item && u) {
            let n = l.node.firstChild,
              r = l.node.getChild(`ListItem`, `ListItem`);
            if (
              n.to >= o ||
              (r && r.to < o) ||
              (s.from > 0 && !/[^\s>]/.test(i.lineAt(s.from - 1).text)) ||
              e.nonTightLists === !1
            ) {
              let e = c.length > 1 ? c[c.length - 2] : null,
                t,
                n = ``;
              e && e.item
                ? ((t = s.from + e.from), (n = e.marker(i, 1)))
                : (t = s.from + (e ? e.to : 0));
              let r = [
                {
                  from: t,
                  to: o,
                  insert: n,
                },
              ];
              return (
                l.node.name == `OrderedList` && hU(l.item, i, r, -2),
                e && e.node.name == `OrderedList` && hU(e.item, i, r),
                {
                  range: Qt.cursor(t + n.length),
                  changes: r,
                }
              );
            } else {
              let e = xU(c, t, s);
              return {
                range: Qt.cursor(o + e.length + 1),
                changes: {
                  from: s.from,
                  insert: e + t.lineBreak,
                },
              };
            }
          }
          if (l.node.name == `Blockquote` && u && s.from) {
            let e = i.lineAt(s.from - 1),
              r = />\s*$/.exec(e.text);
            if (r && r.index == l.from) {
              let i = t.changes([
                {
                  from: e.from + r.index,
                  to: e.to,
                },
                {
                  from: s.from + l.from,
                  to: s.to,
                },
              ]);
              return {
                range: n.map(i),
                changes: i,
              };
            }
          }
          let d = [];
          l.node.name == `OrderedList` && hU(l.item, i, d);
          let f = l.item && l.item.from < s.from,
            p = ``;
          if (!f || /^[\s\d.)\-+*>]*/.exec(s.text)[0].length >= l.to)
            for (let e = 0, t = c.length - 1; e <= t; e++)
              p +=
                e == t && !f
                  ? c[e].marker(i, 1)
                  : c[e].blank(e < t ? at(s.text, 4, c[e + 1].from) - p.length : null);
          let m = o;
          for (; m > s.from && /\s/.test(s.text.charAt(m - s.from - 1));) m--;
          return (
            (p = gU(p, t)),
            bU(l.node, t.doc) && (p = xU(c, t, s) + t.lineBreak + p),
            d.push({
              from: m,
              to: o,
              insert: t.lineBreak + p,
            }),
            {
              range: Qt.cursor(m + p.length + 1),
              changes: d,
            }
          );
        });
      return a
        ? !1
        : (n(
            t.update(o, {
              scrollIntoView: !0,
              userEvent: `input`,
            }),
          ),
          !0);
    },
  vU = _U();
function yU(e) {
  return e.name == `QuoteMark` || e.name == `ListMark`;
}
function bU(e, t) {
  if (e.name != `OrderedList` && e.name != `BulletList`) return !1;
  let n = e.firstChild,
    r = e.getChild(`ListItem`, `ListItem`);
  if (!r) return !1;
  let i = t.lineAt(n.to),
    a = t.lineAt(r.from),
    o = /^[\s>]*$/.test(i.text);
  return i.number + +!o < a.number;
}
function xU(e, t, n) {
  let r = ``;
  for (let t = 0, i = e.length - 2; t <= i; t++)
    r += e[t].blank(t < i ? at(n.text, 4, e[t + 1].from) - r.length : null, t < i);
  return gU(r, t);
}
function SU(e, t) {
  let n = e.resolveInner(t, -1),
    r = t;
  yU(n) && ((r = n.from), (n = n.parent));
  for (let e; (e = n.childBefore(r));)
    if (yU(e)) r = e.from;
    else if (e.name == `OrderedList` || e.name == `BulletList`) ((n = e.lastChild), (r = n.to));
    else break;
  return n;
}
var CU = ({ state: e, dispatch: t }) => {
    let n = nt(e),
      r = null,
      i = e.changeByRange((t) => {
        let i = t.from,
          { doc: a } = e;
        if (t.empty && uU.isActiveAt(e, t.from)) {
          let t = a.lineAt(i),
            r = pU(SU(n, i), a);
          if (r.length) {
            let n = r[r.length - 1],
              a = n.to - n.spaceAfter.length + +!!n.spaceAfter;
            if (i - t.from > a && !/\S/.test(t.text.slice(a, i - t.from)))
              return {
                range: Qt.cursor(t.from + a),
                changes: {
                  from: t.from + a,
                  to: i,
                },
              };
            if (
              i - t.from == a &&
              (!n.item || t.from <= n.item.from || !/\S/.test(t.text.slice(0, n.to)))
            ) {
              let r = t.from + n.from;
              if (n.item && n.node.from < n.item.from && /\S/.test(t.text.slice(n.from, n.to))) {
                let i = n.blank(at(t.text, 4, n.to) - at(t.text, 4, n.from));
                return (
                  r == t.from && (i = gU(i, e)),
                  {
                    range: Qt.cursor(r + i.length),
                    changes: {
                      from: r,
                      to: t.from + n.to,
                      insert: i,
                    },
                  }
                );
              }
              if (r < i)
                return {
                  range: Qt.cursor(r),
                  changes: {
                    from: r,
                    to: i,
                  },
                };
            }
          }
        }
        return (r = {
          range: t,
        });
      });
    return r
      ? !1
      : (t(
          e.update(i, {
            scrollIntoView: !0,
            userEvent: `delete`,
          }),
        ),
        !0);
  },
  wU = [
    {
      key: `Enter`,
      run: vU,
    },
    {
      key: `Backspace`,
      run: CU,
    },
  ],
  TU = ZH({
    matchClosingTags: !1,
  });
function EU(e = {}) {
  let {
    codeLanguages: t,
    defaultCodeLanguage: n,
    addKeymap: r = !0,
    base: { parser: i } = lU,
    completeHTMLTags: a = !0,
    pasteURLAsLink: o = !0,
    htmlTagLanguage: s = TU,
  } = e;
  if (!(i instanceof oR))
    throw RangeError("Base parser provided to `markdown` should be a Markdown parser");
  let c = e.extensions ? [e.extensions] : [],
    l = [s.support, sU],
    u;
  (o && l.push(jU), n instanceof hn ? (l.push(n.support), (u = n.language)) : n && (u = n));
  let d = t || u ? dU(t, u) : void 0;
  (c.push(
    IR({
      codeParser: d,
      htmlParser: s.language.parser,
    }),
  ),
    r && l.push(sn.high(Dt.of(wU))));
  let f = cU(i.configure(c));
  return (
    a &&
      l.push(
        f.data.of({
          autocomplete: DU,
        }),
      ),
    new hn(f, l)
  );
}
function DU(e) {
  let { state: t, pos: n } = e,
    r = /<[:\-\.\w\u00b7-\uffff]*$/.exec(t.sliceDoc(n - 25, n));
  if (!r) return null;
  let i = nt(t).resolveInner(n, -1);
  for (; i && !i.type.isTop;) {
    if (
      i.name == `CodeBlock` ||
      i.name == `FencedCode` ||
      i.name == `ProcessingInstructionBlock` ||
      i.name == `CommentBlock` ||
      i.name == `Link` ||
      i.name == `Image`
    )
      return null;
    i = i.parent;
  }
  return {
    from: n - r[0].length,
    to: n,
    options: kU(),
    validFor: /^<[:\-\.\w\u00b7-\uffff]*$/,
  };
}
var OU = null;
function kU() {
  if (OU) return OU;
  let e = WH(
    new sI(
      gn.create({
        extensions: TU,
      }),
      0,
      !0,
    ),
  );
  return (OU = e ? e.options : []);
}
var AU = /code|horizontalrule|html|link|comment|processing|escape|entity|image|mark|url/i,
  jU = Et.domEventHandlers({
    paste: (e, t) => {
      let { main: n } = t.state.selection;
      if (n.empty) return !1;
      let r = e.clipboardData?.getData(`text/plain`);
      if (
        !r ||
        !/^(https?:\/\/|mailto:|xmpp:|www\.)/.test(r) ||
        (/^www\./.test(r) && (r = `https://` + r), !uU.isActiveAt(t.state, n.from, 1))
      )
        return !1;
      let i = nt(t.state),
        a = !1;
      return (
        i.iterate({
          from: n.from,
          to: n.to,
          enter: (e) => {
            (e.from > n.from || AU.test(e.name)) && (a = !0);
          },
          leave: (e) => {
            e.to < n.to && (a = !0);
          },
        }),
        a
          ? !1
          : (t.dispatch({
              changes: [
                {
                  from: n.from,
                  insert: `[`,
                },
                {
                  from: n.to,
                  insert: `](${r})`,
                },
              ],
              userEvent: `input.paste`,
              scrollIntoView: !0,
            }),
            !0)
      );
    },
  });
function MU(e) {
  return new hn(Vt.define(e));
}
function NU(e) {
  return b(
    () =>
      import(`../recovered/app/assets/dist-BHTm9mRt.js`).then((t) =>
        t.sql({
          dialect: t[e],
        }),
      ),
    __vite__mapDeps([2, 3]),
  );
}
var PU = [
    Zt.of({
      name: `C`,
      extensions: [`c`, `h`, `ino`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-C7NILHbe.js`).then((e) => e.cpp()),
          __vite__mapDeps([4, 3]),
        );
      },
    }),
    Zt.of({
      name: `C++`,
      alias: [`cpp`],
      extensions: [`cpp`, `c++`, `cc`, `cxx`, `hpp`, `h++`, `hh`, `hxx`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-C7NILHbe.js`).then((e) => e.cpp()),
          __vite__mapDeps([4, 3]),
        );
      },
    }),
    Zt.of({
      name: `CQL`,
      alias: [`cassandra`],
      extensions: [`cql`],
      load() {
        return NU(`Cassandra`);
      },
    }),
    Zt.of({
      name: `CSS`,
      extensions: [`css`],
      load() {
        return b(
          () =>
            Promise.resolve()
              .then(() => ZB)
              .then((e) => e.css()),
          void 0,
        );
      },
    }),
    Zt.of({
      name: `Go`,
      extensions: [`go`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-BCGhswWy.js`).then((e) => e.go()),
          __vite__mapDeps([5, 3]),
        );
      },
    }),
    Zt.of({
      name: `HTML`,
      alias: [`xhtml`],
      extensions: [`html`, `htm`, `handlebars`, `hbs`],
      load() {
        return b(
          () =>
            Promise.resolve()
              .then(() => SH)
              .then((e) => e.html()),
          void 0,
        );
      },
    }),
    Zt.of({
      name: `Java`,
      extensions: [`java`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-CgR59kzp.js`).then((e) => e.java()),
          __vite__mapDeps([6, 3]),
        );
      },
    }),
    Zt.of({
      name: `JavaScript`,
      alias: [`ecmascript`, `js`, `node`],
      extensions: [`js`, `mjs`, `cjs`],
      load() {
        return b(
          () =>
            Promise.resolve()
              .then(() => ZV)
              .then((e) => e.javascript()),
          void 0,
        );
      },
    }),
    Zt.of({
      name: `Jinja`,
      extensions: [`j2`, `jinja`, `jinja2`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-BnExsOzA.js`).then((e) => e.jinja()),
          __vite__mapDeps([7, 3]),
        );
      },
    }),
    Zt.of({
      name: `JSON`,
      alias: [`json5`],
      extensions: [`json`, `map`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-BPgSlZZh.js`).then((e) => e.json()),
          __vite__mapDeps([8, 3]),
        );
      },
    }),
    Zt.of({
      name: `JSX`,
      extensions: [`jsx`],
      load() {
        return b(
          () =>
            Promise.resolve()
              .then(() => ZV)
              .then((e) =>
                e.javascript({
                  jsx: !0,
                }),
              ),
          void 0,
        );
      },
    }),
    Zt.of({
      name: `LESS`,
      extensions: [`less`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-zKP_9Fpk.js`).then((e) => e.less()),
          __vite__mapDeps([9, 3]),
        );
      },
    }),
    Zt.of({
      name: `Liquid`,
      extensions: [`liquid`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-C8ah73Ed.js`).then((e) => e.liquid()),
          __vite__mapDeps([10, 3]),
        );
      },
    }),
    Zt.of({
      name: `MariaDB SQL`,
      load() {
        return NU(`MariaSQL`);
      },
    }),
    Zt.of({
      name: `Markdown`,
      extensions: [`md`, `markdown`, `mkd`],
      load() {
        return b(
          () =>
            Promise.resolve()
              .then(() => eU)
              .then((e) => e.markdown()),
          void 0,
        );
      },
    }),
    Zt.of({
      name: `MS SQL`,
      load() {
        return NU(`MSSQL`);
      },
    }),
    Zt.of({
      name: `MySQL`,
      load() {
        return NU(`MySQL`);
      },
    }),
    Zt.of({
      name: `PHP`,
      extensions: [`php`, `php3`, `php4`, `php5`, `php7`, `phtml`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-DUBj8vdQ.js`).then((e) => e.php()),
          __vite__mapDeps([11, 3]),
        );
      },
    }),
    Zt.of({
      name: `PLSQL`,
      extensions: [`pls`],
      load() {
        return NU(`PLSQL`);
      },
    }),
    Zt.of({
      name: `PostgreSQL`,
      load() {
        return NU(`PostgreSQL`);
      },
    }),
    Zt.of({
      name: `Python`,
      extensions: [`BUILD`, `bzl`, `py`, `pyw`],
      filename: /^(BUCK|BUILD)$/,
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-Dog7Phzw.js`).then((e) => e.python()),
          __vite__mapDeps([12, 3]),
        );
      },
    }),
    Zt.of({
      name: `Rust`,
      extensions: [`rs`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-DFZKKcvO.js`).then((e) => e.rust()),
          __vite__mapDeps([13, 3]),
        );
      },
    }),
    Zt.of({
      name: `Sass`,
      extensions: [`sass`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/dist-Cgaq9sOu.js`).then((e) =>
              e.sass({
                indented: !0,
              }),
            ),
          __vite__mapDeps([14, 3]),
        );
      },
    }),
    Zt.of({
      name: `SCSS`,
      extensions: [`scss`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-Cgaq9sOu.js`).then((e) => e.sass()),
          __vite__mapDeps([14, 3]),
        );
      },
    }),
    Zt.of({
      name: `SQL`,
      extensions: [`sql`],
      load() {
        return NU(`StandardSQL`);
      },
    }),
    Zt.of({
      name: `SQLite`,
      load() {
        return NU(`SQLite`);
      },
    }),
    Zt.of({
      name: `TSX`,
      extensions: [`tsx`],
      load() {
        return b(
          () =>
            Promise.resolve()
              .then(() => ZV)
              .then((e) =>
                e.javascript({
                  jsx: !0,
                  typescript: !0,
                }),
              ),
          void 0,
        );
      },
    }),
    Zt.of({
      name: `TypeScript`,
      alias: [`ts`],
      extensions: [`ts`, `mts`, `cts`],
      load() {
        return b(
          () =>
            Promise.resolve()
              .then(() => ZV)
              .then((e) =>
                e.javascript({
                  typescript: !0,
                }),
              ),
          void 0,
        );
      },
    }),
    Zt.of({
      name: `WebAssembly`,
      extensions: [`wat`, `wast`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-DwP782HL.js`).then((e) => e.wast()),
          __vite__mapDeps([15, 3]),
        );
      },
    }),
    Zt.of({
      name: `XML`,
      alias: [`rss`, `wsdl`, `xsd`],
      extensions: [`xml`, `xsl`, `xsd`, `svg`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-DZAkyC3_.js`).then((e) => e.xml()),
          __vite__mapDeps([16, 3]),
        );
      },
    }),
    Zt.of({
      name: `YAML`,
      alias: [`yml`],
      extensions: [`yaml`, `yml`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-DolrrU4k.js`).then((e) => e.yaml()),
          __vite__mapDeps([17, 3]),
        );
      },
    }),
    Zt.of({
      name: `APL`,
      extensions: [`dyalog`, `apl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/apl-CnwPGSsG.js`).then((e) => MU(e.apl)),
          [],
        );
      },
    }),
    Zt.of({
      name: `PGP`,
      alias: [`asciiarmor`],
      extensions: [`asc`, `pgp`, `sig`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/asciiarmor-qTkVPQu6.js`).then((e) => MU(e.asciiArmor)),
          [],
        );
      },
    }),
    Zt.of({
      name: `ASN.1`,
      extensions: [`asn`, `asn1`],
      load() {
        return b(
          () => import(`../recovered/app/assets/asn1-Dr8qZg38.js`).then((e) => MU(e.asn1({}))),
          [],
        );
      },
    }),
    Zt.of({
      name: `Asterisk`,
      filename: /^extensions\.conf$/i,
      load() {
        return b(
          () => import(`../recovered/app/assets/asterisk-Bja0s6e1.js`).then((e) => MU(e.asterisk)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Brainfuck`,
      extensions: [`b`, `bf`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/brainfuck-D5EjA2JK.js`).then((e) => MU(e.brainfuck)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Cobol`,
      extensions: [`cob`, `cpy`],
      load() {
        return b(
          () => import(`../recovered/app/assets/cobol-B_OZ4V-R.js`).then((e) => MU(e.cobol)),
          [],
        );
      },
    }),
    Zt.of({
      name: `C#`,
      alias: [`csharp`, `cs`],
      extensions: [`cs`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clike-DHH8Ad3s.js`).then((e) => MU(e.csharp)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Clojure`,
      extensions: [`clj`, `cljc`, `cljx`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clojure-BflJGmDX.js`).then((e) => MU(e.clojure)),
          [],
        );
      },
    }),
    Zt.of({
      name: `ClojureScript`,
      extensions: [`cljs`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clojure-BflJGmDX.js`).then((e) => MU(e.clojure)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Closure Stylesheets (GSS)`,
      extensions: [`gss`],
      load() {
        return b(
          () => import(`../recovered/app/assets/css-CYpP4FRV.js`).then((e) => MU(e.gss)),
          [],
        );
      },
    }),
    Zt.of({
      name: `CMake`,
      extensions: [`cmake`, `cmake.in`],
      filename: /^CMakeLists\.txt$/,
      load() {
        return b(
          () => import(`../recovered/app/assets/cmake-CyVbuzPu.js`).then((e) => MU(e.cmake)),
          [],
        );
      },
    }),
    Zt.of({
      name: `CoffeeScript`,
      alias: [`coffee`, `coffee-script`],
      extensions: [`coffee`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/coffeescript-B2pKbFk8.js`).then((e) =>
              MU(e.coffeeScript),
            ),
          [],
        );
      },
    }),
    Zt.of({
      name: `Common Lisp`,
      alias: [`lisp`],
      extensions: [`cl`, `lisp`, `el`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/commonlisp-CcllspGY.js`).then((e) => MU(e.commonLisp)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Cypher`,
      extensions: [`cyp`, `cypher`],
      load() {
        return b(
          () => import(`../recovered/app/assets/cypher-p9eYesGn.js`).then((e) => MU(e.cypher)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Cython`,
      extensions: [`pyx`, `pxd`, `pxi`],
      load() {
        return b(
          () => import(`../recovered/app/assets/python-BqYw9LYJ.js`).then((e) => MU(e.cython)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Crystal`,
      extensions: [`cr`],
      load() {
        return b(
          () => import(`../recovered/app/assets/crystal-M5-qzICs.js`).then((e) => MU(e.crystal)),
          [],
        );
      },
    }),
    Zt.of({
      name: `D`,
      extensions: [`d`],
      load() {
        return b(() => import(`../recovered/app/assets/d-BhMjBjQP.js`).then((e) => MU(e.d)), []);
      },
    }),
    Zt.of({
      name: `Dart`,
      extensions: [`dart`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clike-DHH8Ad3s.js`).then((e) => MU(e.dart)),
          [],
        );
      },
    }),
    Zt.of({
      name: `diff`,
      extensions: [`diff`, `patch`],
      load() {
        return b(
          () => import(`../recovered/app/assets/diff-ChtP43wD.js`).then((e) => MU(e.diff)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Dockerfile`,
      filename: /^Dockerfile$/,
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/dockerfile-BLkNEvjs.js`).then((e) => MU(e.dockerFile)),
          __vite__mapDeps([18, 19]),
        );
      },
    }),
    Zt.of({
      name: `DTD`,
      extensions: [`dtd`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dtd-DTF72YNO.js`).then((e) => MU(e.dtd)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Dylan`,
      extensions: [`dylan`, `dyl`, `intr`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dylan-C6jEEEk-.js`).then((e) => MU(e.dylan)),
          [],
        );
      },
    }),
    Zt.of({
      name: `EBNF`,
      load() {
        return b(
          () => import(`../recovered/app/assets/ebnf-D4c0_ac3.js`).then((e) => MU(e.ebnf)),
          [],
        );
      },
    }),
    Zt.of({
      name: `ECL`,
      extensions: [`ecl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/ecl-BSZaIHnp.js`).then((e) => MU(e.ecl)),
          [],
        );
      },
    }),
    Zt.of({
      name: `edn`,
      extensions: [`edn`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clojure-BflJGmDX.js`).then((e) => MU(e.clojure)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Eiffel`,
      extensions: [`e`],
      load() {
        return b(
          () => import(`../recovered/app/assets/eiffel-BEjRio4Q.js`).then((e) => MU(e.eiffel)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Elm`,
      extensions: [`elm`],
      load() {
        return b(
          () => import(`../recovered/app/assets/elm-Cshzl8qu.js`).then((e) => MU(e.elm)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Erlang`,
      extensions: [`erl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/erlang-DaB2Rkuy.js`).then((e) => MU(e.erlang)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Esper`,
      load() {
        return b(
          () => import(`../recovered/app/assets/sql-DcCJ9jop.js`).then((e) => MU(e.esper)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Factor`,
      extensions: [`factor`],
      load() {
        return b(
          () => import(`../recovered/app/assets/factor-D7LVTn2l.js`).then((e) => MU(e.factor)),
          __vite__mapDeps([20, 19]),
        );
      },
    }),
    Zt.of({
      name: `FCL`,
      load() {
        return b(
          () => import(`../recovered/app/assets/fcl-ClOhbFR7.js`).then((e) => MU(e.fcl)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Forth`,
      extensions: [`forth`, `fth`, `4th`],
      load() {
        return b(
          () => import(`../recovered/app/assets/forth-Cezjo90N.js`).then((e) => MU(e.forth)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Fortran`,
      extensions: [`f`, `for`, `f77`, `f90`, `f95`],
      load() {
        return b(
          () => import(`../recovered/app/assets/fortran-Bt6PBEDR.js`).then((e) => MU(e.fortran)),
          [],
        );
      },
    }),
    Zt.of({
      name: `F#`,
      alias: [`fsharp`],
      extensions: [`fs`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mllike-B45xgp2S.js`).then((e) => MU(e.fSharp)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Gas`,
      extensions: [`s`],
      load() {
        return b(
          () => import(`../recovered/app/assets/gas-BHEdbvp9.js`).then((e) => MU(e.gas)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Gherkin`,
      extensions: [`feature`],
      load() {
        return b(
          () => import(`../recovered/app/assets/gherkin-oBAE_ms0.js`).then((e) => MU(e.gherkin)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Groovy`,
      extensions: [`groovy`, `gradle`],
      filename: /^Jenkinsfile$/,
      load() {
        return b(
          () => import(`../recovered/app/assets/groovy-BC3IOsC8.js`).then((e) => MU(e.groovy)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Haskell`,
      extensions: [`hs`],
      load() {
        return b(
          () => import(`../recovered/app/assets/haskell-BRsoo5mP.js`).then((e) => MU(e.haskell)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Haxe`,
      extensions: [`hx`],
      load() {
        return b(
          () => import(`../recovered/app/assets/haxe-DjVOVvNP.js`).then((e) => MU(e.haxe)),
          [],
        );
      },
    }),
    Zt.of({
      name: `HXML`,
      extensions: [`hxml`],
      load() {
        return b(
          () => import(`../recovered/app/assets/haxe-DjVOVvNP.js`).then((e) => MU(e.hxml)),
          [],
        );
      },
    }),
    Zt.of({
      name: `HTTP`,
      load() {
        return b(
          () => import(`../recovered/app/assets/http-CLVgA2GD.js`).then((e) => MU(e.http)),
          [],
        );
      },
    }),
    Zt.of({
      name: `IDL`,
      extensions: [`pro`],
      load() {
        return b(
          () => import(`../recovered/app/assets/idl-BUZw3wgd.js`).then((e) => MU(e.idl)),
          [],
        );
      },
    }),
    Zt.of({
      name: `JSON-LD`,
      alias: [`jsonld`],
      extensions: [`jsonld`],
      load() {
        return b(
          () => import(`../recovered/app/assets/javascript-8HiN0ThV.js`).then((e) => MU(e.jsonld)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Julia`,
      extensions: [`jl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/julia-CQfgDRfP.js`).then((e) => MU(e.julia)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Kotlin`,
      extensions: [`kt`, `kts`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clike-DHH8Ad3s.js`).then((e) => MU(e.kotlin)),
          [],
        );
      },
    }),
    Zt.of({
      name: `LiveScript`,
      alias: [`ls`],
      extensions: [`ls`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/livescript-BXxG0Yva.js`).then((e) => MU(e.liveScript)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Lua`,
      extensions: [`lua`],
      load() {
        return b(
          () => import(`../recovered/app/assets/lua-CiA1ziua.js`).then((e) => MU(e.lua)),
          [],
        );
      },
    }),
    Zt.of({
      name: `mIRC`,
      extensions: [`mrc`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mirc-C9zpzAZU.js`).then((e) => MU(e.mirc)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Mathematica`,
      extensions: [`m`, `nb`, `wl`, `wls`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/mathematica-u8YMmbU0.js`).then((e) =>
              MU(e.mathematica),
            ),
          [],
        );
      },
    }),
    Zt.of({
      name: `Modelica`,
      extensions: [`mo`],
      load() {
        return b(
          () => import(`../recovered/app/assets/modelica-CqHI_q-D.js`).then((e) => MU(e.modelica)),
          [],
        );
      },
    }),
    Zt.of({
      name: `MUMPS`,
      extensions: [`mps`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mumps-CW_TBmxz.js`).then((e) => MU(e.mumps)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Mbox`,
      extensions: [`mbox`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mbox-BEMVcqjs.js`).then((e) => MU(e.mbox)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Nginx`,
      filename: /nginx.*\.conf$/i,
      load() {
        return b(
          () => import(`../recovered/app/assets/nginx-BMaDbqW3.js`).then((e) => MU(e.nginx)),
          [],
        );
      },
    }),
    Zt.of({
      name: `NSIS`,
      extensions: [`nsh`, `nsi`],
      load() {
        return b(
          () => import(`../recovered/app/assets/nsis-AQ_alPln.js`).then((e) => MU(e.nsis)),
          __vite__mapDeps([21, 19]),
        );
      },
    }),
    Zt.of({
      name: `NTriples`,
      extensions: [`nt`, `nq`],
      load() {
        return b(
          () => import(`../recovered/app/assets/ntriples-d28e9m0E.js`).then((e) => MU(e.ntriples)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Objective-C`,
      alias: [`objective-c`, `objc`],
      extensions: [`m`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clike-DHH8Ad3s.js`).then((e) => MU(e.objectiveC)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Objective-C++`,
      alias: [`objective-c++`, `objc++`],
      extensions: [`mm`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clike-DHH8Ad3s.js`).then((e) => MU(e.objectiveCpp)),
          [],
        );
      },
    }),
    Zt.of({
      name: `OCaml`,
      extensions: [`ml`, `mli`, `mll`, `mly`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mllike-B45xgp2S.js`).then((e) => MU(e.oCaml)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Octave`,
      extensions: [`m`],
      load() {
        return b(
          () => import(`../recovered/app/assets/octave-D2Q8cUp1.js`).then((e) => MU(e.octave)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Oz`,
      extensions: [`oz`],
      load() {
        return b(() => import(`../recovered/app/assets/oz-BwTct_5T.js`).then((e) => MU(e.oz)), []);
      },
    }),
    Zt.of({
      name: `Pascal`,
      extensions: [`p`, `pas`],
      load() {
        return b(
          () => import(`../recovered/app/assets/pascal-Dp_KdFgX.js`).then((e) => MU(e.pascal)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Perl`,
      extensions: [`pl`, `pm`],
      load() {
        return b(
          () => import(`../recovered/app/assets/perl-CdEHsPfU.js`).then((e) => MU(e.perl)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Pig`,
      extensions: [`pig`],
      load() {
        return b(
          () => import(`../recovered/app/assets/pig-AF4Hwhju.js`).then((e) => MU(e.pig)),
          [],
        );
      },
    }),
    Zt.of({
      name: `PowerShell`,
      extensions: [`ps1`, `psd1`, `psm1`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/powershell-CzG71I4L.js`).then((e) => MU(e.powerShell)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Properties files`,
      alias: [`ini`, `properties`],
      extensions: [`properties`, `ini`, `in`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/properties-C357ku5U.js`).then((e) => MU(e.properties)),
          [],
        );
      },
    }),
    Zt.of({
      name: `ProtoBuf`,
      extensions: [`proto`],
      load() {
        return b(
          () => import(`../recovered/app/assets/protobuf-D1ij_kNL.js`).then((e) => MU(e.protobuf)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Pug`,
      alias: [`jade`],
      extensions: [`pug`, `jade`],
      load() {
        return b(
          () => import(`../recovered/app/assets/pug-DyBTKFx8.js`).then((e) => MU(e.pug)),
          __vite__mapDeps([22, 23]),
        );
      },
    }),
    Zt.of({
      name: `Puppet`,
      extensions: [`pp`],
      load() {
        return b(
          () => import(`../recovered/app/assets/puppet-B4hC2X4m.js`).then((e) => MU(e.puppet)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Q`,
      extensions: [`q`],
      load() {
        return b(() => import(`../recovered/app/assets/q-B9NhS7L_.js`).then((e) => MU(e.q)), []);
      },
    }),
    Zt.of({
      name: `R`,
      alias: [`rscript`],
      extensions: [`r`, `R`],
      load() {
        return b(() => import(`../recovered/app/assets/r-DADKenSm.js`).then((e) => MU(e.r)), []);
      },
    }),
    Zt.of({
      name: `RPM Changes`,
      load() {
        return b(
          () => import(`../recovered/app/assets/rpm-gpDK5sbt.js`).then((e) => MU(e.rpmChanges)),
          [],
        );
      },
    }),
    Zt.of({
      name: `RPM Spec`,
      extensions: [`spec`],
      load() {
        return b(
          () => import(`../recovered/app/assets/rpm-gpDK5sbt.js`).then((e) => MU(e.rpmSpec)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Ruby`,
      alias: [`jruby`, `macruby`, `rake`, `rb`, `rbx`],
      extensions: [`rb`],
      filename: /^(Gemfile|Rakefile)$/,
      load() {
        return b(
          () => import(`../recovered/app/assets/ruby-DsYpTuWg.js`).then((e) => MU(e.ruby)),
          [],
        );
      },
    }),
    Zt.of({
      name: `SAS`,
      extensions: [`sas`],
      load() {
        return b(
          () => import(`../recovered/app/assets/sas-C2OyD2Y6.js`).then((e) => MU(e.sas)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Scala`,
      extensions: [`scala`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clike-DHH8Ad3s.js`).then((e) => MU(e.scala)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Scheme`,
      extensions: [`scm`, `ss`],
      load() {
        return b(
          () => import(`../recovered/app/assets/scheme-CyDdOh7e.js`).then((e) => MU(e.scheme)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Shell`,
      alias: [`bash`, `sh`, `zsh`],
      extensions: [`sh`, `ksh`, `bash`],
      filename: /^PKGBUILD$/,
      load() {
        return b(
          () => import(`../recovered/app/assets/shell-Du5Qg9im.js`).then((e) => MU(e.shell)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Sieve`,
      extensions: [`siv`, `sieve`],
      load() {
        return b(
          () => import(`../recovered/app/assets/sieve-BAxa3IjF.js`).then((e) => MU(e.sieve)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Smalltalk`,
      extensions: [`st`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/smalltalk-BLp5-jwC.js`).then((e) => MU(e.smalltalk)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Solr`,
      load() {
        return b(
          () => import(`../recovered/app/assets/solr-BBopId9w.js`).then((e) => MU(e.solr)),
          [],
        );
      },
    }),
    Zt.of({
      name: `SML`,
      extensions: [`sml`, `sig`, `fun`, `smackspec`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mllike-B45xgp2S.js`).then((e) => MU(e.sml)),
          [],
        );
      },
    }),
    Zt.of({
      name: `SPARQL`,
      alias: [`sparul`],
      extensions: [`rq`, `sparql`],
      load() {
        return b(
          () => import(`../recovered/app/assets/sparql-Dz-mlCAC.js`).then((e) => MU(e.sparql)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Spreadsheet`,
      alias: [`excel`, `formula`],
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/spreadsheet-CTIncYxj.js`).then((e) =>
              MU(e.spreadsheet),
            ),
          [],
        );
      },
    }),
    Zt.of({
      name: `Squirrel`,
      extensions: [`nut`],
      load() {
        return b(
          () => import(`../recovered/app/assets/clike-DHH8Ad3s.js`).then((e) => MU(e.squirrel)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Stylus`,
      extensions: [`styl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/stylus-DLLZ8dgm.js`).then((e) => MU(e.stylus)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Swift`,
      extensions: [`swift`],
      load() {
        return b(
          () => import(`../recovered/app/assets/swift-DKB6_1j6.js`).then((e) => MU(e.swift)),
          [],
        );
      },
    }),
    Zt.of({
      name: `sTeX`,
      load() {
        return b(
          () => import(`../recovered/app/assets/stex-sDrdk2BW.js`).then((e) => MU(e.stex)),
          [],
        );
      },
    }),
    Zt.of({
      name: `LaTeX`,
      alias: [`tex`],
      extensions: [`text`, `ltx`, `tex`],
      load() {
        return b(
          () => import(`../recovered/app/assets/stex-sDrdk2BW.js`).then((e) => MU(e.stex)),
          [],
        );
      },
    }),
    Zt.of({
      name: `SystemVerilog`,
      extensions: [`v`, `sv`, `svh`],
      load() {
        return b(
          () => import(`../recovered/app/assets/verilog-D-x6ne0Z.js`).then((e) => MU(e.verilog)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Tcl`,
      extensions: [`tcl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/tcl-BGfruO1u.js`).then((e) => MU(e.tcl)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Textile`,
      extensions: [`textile`],
      load() {
        return b(
          () => import(`../recovered/app/assets/textile-DWBqthVk.js`).then((e) => MU(e.textile)),
          [],
        );
      },
    }),
    Zt.of({
      name: `TiddlyWiki`,
      load() {
        return b(
          () =>
            import(`../recovered/app/assets/tiddlywiki-VlUiK86J.js`).then((e) => MU(e.tiddlyWiki)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Tiki wiki`,
      load() {
        return b(
          () => import(`../recovered/app/assets/tiki-CxVlf5KZ.js`).then((e) => MU(e.tiki)),
          [],
        );
      },
    }),
    Zt.of({
      name: `TOML`,
      extensions: [`toml`],
      load() {
        return b(
          () => import(`../recovered/app/assets/toml-LvoKBwCs.js`).then((e) => MU(e.toml)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Troff`,
      extensions: [`1`, `2`, `3`, `4`, `5`, `6`, `7`, `8`, `9`],
      load() {
        return b(
          () => import(`../recovered/app/assets/troff-C2dAgh7P.js`).then((e) => MU(e.troff)),
          [],
        );
      },
    }),
    Zt.of({
      name: `TTCN`,
      extensions: [`ttcn`, `ttcn3`, `ttcnpp`],
      load() {
        return b(
          () => import(`../recovered/app/assets/ttcn-BePYh-hG.js`).then((e) => MU(e.ttcn)),
          [],
        );
      },
    }),
    Zt.of({
      name: `TTCN_CFG`,
      extensions: [`cfg`],
      load() {
        return b(
          () => import(`../recovered/app/assets/ttcn-cfg-CY0aot7Q.js`).then((e) => MU(e.ttcnCfg)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Turtle`,
      extensions: [`ttl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/turtle-Cx3rYX2g.js`).then((e) => MU(e.turtle)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Web IDL`,
      extensions: [`webidl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/webidl-D5jiJvOU.js`).then((e) => MU(e.webIDL)),
          [],
        );
      },
    }),
    Zt.of({
      name: `VB.NET`,
      extensions: [`vb`],
      load() {
        return b(() => import(`../recovered/app/assets/vb-BthdM_4N.js`).then((e) => MU(e.vb)), []);
      },
    }),
    Zt.of({
      name: `VBScript`,
      extensions: [`vbs`],
      load() {
        return b(
          () => import(`../recovered/app/assets/vbscript-D9f6rSsU.js`).then((e) => MU(e.vbScript)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Velocity`,
      extensions: [`vtl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/velocity-CqftRsjg.js`).then((e) => MU(e.velocity)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Verilog`,
      extensions: [`v`],
      load() {
        return b(
          () => import(`../recovered/app/assets/verilog-D-x6ne0Z.js`).then((e) => MU(e.verilog)),
          [],
        );
      },
    }),
    Zt.of({
      name: `VHDL`,
      extensions: [`vhd`, `vhdl`],
      load() {
        return b(
          () => import(`../recovered/app/assets/vhdl-CMrOq2q1.js`).then((e) => MU(e.vhdl)),
          [],
        );
      },
    }),
    Zt.of({
      name: `XQuery`,
      extensions: [`xy`, `xquery`, `xq`, `xqm`, `xqy`],
      load() {
        return b(
          () => import(`../recovered/app/assets/xquery-fj_R-kMw.js`).then((e) => MU(e.xQuery)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Yacas`,
      extensions: [`ys`],
      load() {
        return b(
          () => import(`../recovered/app/assets/yacas-CXXgtw0p.js`).then((e) => MU(e.yacas)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Z80`,
      extensions: [`z80`],
      load() {
        return b(
          () => import(`../recovered/app/assets/z80-CL1naaMV.js`).then((e) => MU(e.z80)),
          [],
        );
      },
    }),
    Zt.of({
      name: `MscGen`,
      extensions: [`mscgen`, `mscin`, `msc`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mscgen-qgSLujhx.js`).then((e) => MU(e.mscgen)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Xù`,
      extensions: [`xu`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mscgen-qgSLujhx.js`).then((e) => MU(e.xu)),
          [],
        );
      },
    }),
    Zt.of({
      name: `MsGenny`,
      extensions: [`msgenny`],
      load() {
        return b(
          () => import(`../recovered/app/assets/mscgen-qgSLujhx.js`).then((e) => MU(e.msgenny)),
          [],
        );
      },
    }),
    Zt.of({
      name: `Vue`,
      extensions: [`vue`],
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-d0Z8CVh5.js`).then((e) => e.vue()),
          __vite__mapDeps([24, 3]),
        );
      },
    }),
    Zt.of({
      name: `Angular Template`,
      load() {
        return b(
          () => import(`../recovered/app/assets/dist-DC_FRNuJ.js`).then((e) => e.angular()),
          __vite__mapDeps([25, 3]),
        );
      },
    }),
  ],
  FU = typeof String.prototype.normalize == `function` ? (e) => e.normalize(`NFKD`) : (e) => e,
  IU = class {
    constructor(e, t, n = 0, r = e.length, i, a) {
      ((this.test = a),
        (this.value = {
          from: 0,
          to: 0,
          precise: !1,
        }),
        (this.done = !1),
        (this.matches = []),
        (this.buffer = ``),
        (this.bufferPos = 0),
        (this.iter = e.iterRange(n, r)),
        (this.bufferStart = n),
        (this.normalize = i ? (e) => i(FU(e)) : FU),
        (this.query = this.normalize(t)));
    }
    peek() {
      if (this.bufferPos == this.buffer.length) {
        if (((this.bufferStart += this.buffer.length), this.iter.next(), this.iter.done)) return -1;
        ((this.bufferPos = 0), (this.buffer = this.iter.value));
      }
      return Ft(this.buffer, this.bufferPos);
    }
    next() {
      for (; this.matches.length;) this.matches.pop();
      return this.nextOverlapping();
    }
    nextOverlapping() {
      for (;;) {
        let e = this.peek();
        if (e < 0) return ((this.done = !0), this);
        let t = Ct(e),
          n = this.bufferStart + this.bufferPos;
        this.bufferPos += Sn(e);
        let r = this.normalize(t);
        if (r.length)
          for (let e = 0, i = n, a = !0; ; e++) {
            let n = r.charCodeAt(e),
              o = this.match(n, i, a, this.bufferPos + this.bufferStart, e == r.length - 1);
            if (o) return ((this.value = o), this);
            if (e == r.length - 1) break;
            a && e < t.length && t.charCodeAt(e) == n ? i++ : (a = !1);
          }
      }
    }
    match(e, t, n, r, i) {
      let a = null;
      for (let t = 0; t < this.matches.length;) {
        let n = this.matches[t],
          o = !1;
        (this.query.charCodeAt(n.index) == e &&
          (n.index == this.query.length - 1
            ? (a = {
                from: n.from,
                to: r,
                precise: i && n.precise,
              })
            : (n.index++, (o = !0))),
          o ? t++ : this.matches.splice(t, 1));
      }
      return (
        this.query.charCodeAt(0) == e &&
          (this.query.length == 1
            ? (a = {
                from: t,
                to: r,
                precise: n && i,
              })
            : this.matches.push({
                from: t,
                index: 1,
                precise: n,
              })),
        a && this.test && !this.test(a.from, a.to, this.buffer, this.bufferStart) && (a = null),
        a
      );
    }
  };
typeof Symbol < `u` &&
  (IU.prototype[Symbol.iterator] = function () {
    return this;
  });
var LU = {
    from: -1,
    to: -1,
    match: /.*/.exec(``),
    precise: !0,
  },
  RU = `gm` + (/x/.unicode == null ? `` : `u`),
  zU = class {
    constructor(e, t, n, r = 0, i = e.length) {
      if (
        ((this.text = e),
        (this.to = i),
        (this.curLine = ``),
        (this.done = !1),
        (this.value = LU),
        /\\[sWDnr]|\n|\r|\[\^/.test(t))
      )
        return new HU(e, t, n, r, i);
      ((this.re = new RegExp(t, RU + (n?.ignoreCase ? `i` : ``))),
        (this.test = n?.test),
        (this.iter = e.iter()));
      let a = e.lineAt(r);
      ((this.curLineStart = a.from), (this.matchPos = WU(e, r)), this.getLine(this.curLineStart));
    }
    getLine(e) {
      (this.iter.next(e),
        this.iter.lineBreak
          ? (this.curLine = ``)
          : ((this.curLine = this.iter.value),
            this.curLineStart + this.curLine.length > this.to &&
              (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)),
            this.iter.next()));
    }
    nextLine() {
      ((this.curLineStart = this.curLineStart + this.curLine.length + 1),
        this.curLineStart > this.to ? (this.curLine = ``) : this.getLine(0));
    }
    next() {
      for (let e = this.matchPos - this.curLineStart; ;) {
        this.re.lastIndex = e;
        let t = this.matchPos <= this.to && this.re.exec(this.curLine);
        if (t) {
          let n = this.curLineStart + t.index,
            r = n + t[0].length;
          if (
            ((this.matchPos = WU(this.text, r + +(n == r))),
            n == this.curLineStart + this.curLine.length && this.nextLine(),
            (n < r || n > this.value.to) && (!this.test || this.test(n, r, t)))
          )
            return (
              (this.value = {
                from: n,
                to: r,
                precise: !0,
                match: t,
              }),
              this
            );
          e = this.matchPos - this.curLineStart;
        } else if (this.curLineStart + this.curLine.length < this.to) (this.nextLine(), (e = 0));
        else return ((this.done = !0), this);
      }
    }
  },
  BU = new WeakMap(),
  VU = class e {
    constructor(e, t) {
      ((this.from = e), (this.text = t));
    }
    get to() {
      return this.from + this.text.length;
    }
    static get(t, n, r) {
      let i = BU.get(t);
      if (!i || i.from >= r || i.to <= n) {
        let i = new e(n, t.sliceString(n, r));
        return (BU.set(t, i), i);
      }
      if (i.from == n && i.to == r) return i;
      let { text: a, from: o } = i;
      return (
        o > n && ((a = t.sliceString(n, o) + a), (o = n)),
        i.to < r && (a += t.sliceString(i.to, r)),
        BU.set(t, new e(o, a)),
        new e(n, a.slice(n - o, r - o))
      );
    }
  },
  HU = class {
    constructor(e, t, n, r, i) {
      ((this.text = e),
        (this.to = i),
        (this.done = !1),
        (this.value = LU),
        (this.matchPos = WU(e, r)),
        (this.re = new RegExp(t, RU + (n?.ignoreCase ? `i` : ``))),
        (this.test = n?.test),
        (this.flat = VU.get(e, r, this.chunkEnd(r + 5e3))));
    }
    chunkEnd(e) {
      return e >= this.to ? this.to : this.text.lineAt(e).to;
    }
    next() {
      for (;;) {
        let e = (this.re.lastIndex = this.matchPos - this.flat.from),
          t = this.re.exec(this.flat.text);
        if (
          (t &&
            !t[0] &&
            t.index == e &&
            ((this.re.lastIndex = e + 1), (t = this.re.exec(this.flat.text))),
          t)
        ) {
          let e = this.flat.from + t.index,
            n = e + t[0].length;
          if (
            (this.flat.to >= this.to || t.index + t[0].length <= this.flat.text.length - 10) &&
            (!this.test || this.test(e, n, t))
          )
            return (
              (this.value = {
                from: e,
                to: n,
                precise: !0,
                match: t,
              }),
              (this.matchPos = WU(this.text, n + +(e == n))),
              this
            );
        }
        if (this.flat.to == this.to) return ((this.done = !0), this);
        this.flat = VU.get(
          this.text,
          this.flat.from,
          this.chunkEnd(this.flat.from + this.flat.text.length * 2),
        );
      }
    }
  };
typeof Symbol < `u` &&
  (zU.prototype[Symbol.iterator] = HU.prototype[Symbol.iterator] =
    function () {
      return this;
    });
function UU(e) {
  try {
    return (new RegExp(e, RU), !0);
  } catch {
    return !1;
  }
}
function WU(e, t) {
  if (t >= e.length) return t;
  let n = e.lineAt(t),
    r;
  for (; t < n.to && (r = n.text.charCodeAt(t - n.from)) >= 56320 && r < 57344;) t++;
  return t;
}
var GU = (e) => {
    let { state: t } = e,
      n = String(t.doc.lineAt(e.state.selection.main.head).number),
      { close: r, result: i } = Bt(e, {
        label: t.phrase(`Go to line`),
        input: {
          type: `text`,
          name: `line`,
          value: n,
        },
        focus: !0,
        submitLabel: t.phrase(`go`),
      });
    return (
      i.then((n) => {
        let i = n && /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.elements.line.value);
        if (!i) {
          e.dispatch({
            effects: r,
          });
          return;
        }
        let a = t.doc.lineAt(t.selection.main.head),
          [, o, s, c, l] = i,
          u = c ? +c.slice(1) : 0,
          d = s ? +s : a.number;
        if (s && l) {
          let e = d / 100;
          (o && (e = e * (o == `-` ? -1 : 1) + a.number / t.doc.lines),
            (d = Math.round(t.doc.lines * e)));
        } else s && o && (d = d * (o == `-` ? -1 : 1) + a.number);
        let f = t.doc.line(Math.max(1, Math.min(t.doc.lines, d))),
          p = Qt.cursor(f.from + Math.max(0, Math.min(u, f.length)));
        e.dispatch({
          effects: [
            r,
            Et.scrollIntoView(p.from, {
              y: `center`,
            }),
          ],
          selection: p,
        });
      }),
      !0
    );
  },
  KU = ({ state: e, dispatch: t }) => {
    let { selection: n } = e,
      r = Qt.create(
        n.ranges.map((t) => e.wordAt(t.head) || Qt.cursor(t.head)),
        n.mainIndex,
      );
    return r.eq(n)
      ? !1
      : (t(
          e.update({
            selection: r,
          }),
        ),
        !0);
  };
function qU(e, t) {
  let { main: n, ranges: r } = e.selection,
    i = e.wordAt(n.head),
    a = i && i.from == n.from && i.to == n.to;
  for (let n = !1, i = new IU(e.doc, t, r[r.length - 1].to); ;)
    if ((i.next(), i.done)) {
      if (n) return null;
      ((i = new IU(e.doc, t, 0, Math.max(0, r[r.length - 1].from - 1))), (n = !0));
    } else {
      if (n && r.some((e) => e.from == i.value.from)) continue;
      if (a) {
        let t = e.wordAt(i.value.from);
        if (!t || t.from != i.value.from || t.to != i.value.to) continue;
      }
      return i.value;
    }
}
var JU = ({ state: e, dispatch: t }) => {
    let { ranges: n } = e.selection;
    if (n.some((e) => e.from === e.to))
      return KU({
        state: e,
        dispatch: t,
      });
    let r = e.sliceDoc(n[0].from, n[0].to);
    if (e.selection.ranges.some((t) => e.sliceDoc(t.from, t.to) != r)) return !1;
    let i = qU(e, r);
    return i
      ? (t(
          e.update({
            selection: e.selection.addRange(Qt.range(i.from, i.to), !1),
            effects: Et.scrollIntoView(i.to),
          }),
        ),
        !0)
      : !1;
  },
  YU = zt.define({
    combine(e) {
      return xt(e, {
        top: !1,
        caseSensitive: !1,
        literal: !1,
        regexp: !1,
        wholeWord: !1,
        createPanel: (e) => new kW(e),
        scrollToMatch: (e) => Et.scrollIntoView(e),
      });
    },
  }),
  XU = class {
    constructor(e) {
      ((this.search = e.search),
        (this.caseSensitive = !!e.caseSensitive),
        (this.literal = !!e.literal),
        (this.regexp = !!e.regexp),
        (this.replace = e.replace || ``),
        (this.valid = !!this.search && (!this.regexp || UU(this.search))),
        (this.unquoted = this.unquote(this.search)),
        (this.wholeWord = !!e.wholeWord),
        (this.test = e.test));
    }
    unquote(e) {
      return this.literal
        ? e
        : e.replace(/\\([nrt\\])/g, (e, t) =>
            t == `n`
              ? `
`
              : t == `r`
                ? `\r`
                : t == `t`
                  ? `	`
                  : `\\`,
          );
    }
    eq(e) {
      return (
        this.search == e.search &&
        this.replace == e.replace &&
        this.caseSensitive == e.caseSensitive &&
        this.regexp == e.regexp &&
        this.wholeWord == e.wholeWord &&
        this.test == e.test
      );
    }
    create() {
      return this.regexp ? new sW(this) : new tW(this);
    }
    getCursor(e, t = 0, n) {
      let r = e.doc
        ? e
        : gn.create({
            doc: e,
          });
      return ((n ??= r.doc.length), this.regexp ? rW(this, r, t, n) : $U(this, r, t, n));
    }
  },
  ZU = class {
    constructor(e) {
      this.spec = e;
    }
  };
function QU(e, t, n) {
  return (r, i, a, o) =>
    n && !n(r, i, a, o)
      ? !1
      : e(r >= o && i <= o + a.length ? a.slice(r - o, i - o) : t.doc.sliceString(r, i), t, r, i);
}
function $U(e, t, n, r) {
  let i;
  return (
    e.wholeWord && (i = eW(t.doc, t.charCategorizer(t.selection.main.head))),
    e.test && (i = QU(e.test, t, i)),
    new IU(t.doc, e.unquoted, n, r, e.caseSensitive ? void 0 : (e) => e.toLowerCase(), i)
  );
}
function eW(e, t) {
  return (n, r, i, a) => (
    (a > n || a + i.length < r) &&
      ((a = Math.max(0, n - 2)), (i = e.sliceString(a, Math.min(e.length, r + 2)))),
    (t(iW(i, n - a)) != fn.Word || t(aW(i, n - a)) != fn.Word) &&
      (t(aW(i, r - a)) != fn.Word || t(iW(i, r - a)) != fn.Word)
  );
}
var tW = class extends ZU {
  constructor(e) {
    super(e);
  }
  nextMatch(e, t, n) {
    let r = $U(this.spec, e, n, e.doc.length).nextOverlapping();
    if (r.done) {
      let n = Math.min(e.doc.length, t + this.spec.unquoted.length);
      r = $U(this.spec, e, 0, n).nextOverlapping();
    }
    return r.done || (r.value.from == t && r.value.to == n) ? null : r.value;
  }
  prevMatchInRange(e, t, n) {
    for (let r = n; ;) {
      let n = Math.max(t, r - 1e4 - this.spec.unquoted.length),
        i = $U(this.spec, e, n, r),
        a = null;
      for (; !i.nextOverlapping().done;) a = i.value;
      if (a) return a;
      if (n == t) return null;
      r -= 1e4;
    }
  }
  prevMatch(e, t, n) {
    let r = this.prevMatchInRange(e, 0, t);
    return (
      (r ||= this.prevMatchInRange(e, Math.max(0, n - this.spec.unquoted.length), e.doc.length)),
      r && (r.from != t || r.to != n) ? r : null
    );
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e, t) {
    let n = $U(this.spec, e, 0, e.doc.length),
      r = [];
    for (; !n.next().done;) {
      if (r.length >= t) return null;
      r.push(n.value);
    }
    return r;
  }
  highlight(e, t, n, r) {
    let i = $U(
      this.spec,
      e,
      Math.max(0, t - this.spec.unquoted.length),
      Math.min(n + this.spec.unquoted.length, e.doc.length),
    );
    for (; !i.next().done;) r(i.value.from, i.value.to);
  }
};
function nW(e, t, n) {
  return (r, i, a) => (!n || n(r, i, a)) && e(a[0], t, r, i);
}
function rW(e, t, n, r) {
  let i;
  return (
    e.wholeWord && (i = oW(t.charCategorizer(t.selection.main.head))),
    e.test && (i = nW(e.test, t, i)),
    new zU(
      t.doc,
      e.search,
      {
        ignoreCase: !e.caseSensitive,
        test: i,
      },
      n,
      r,
    )
  );
}
function iW(e, t) {
  return e.slice(bn(e, t, !1), t);
}
function aW(e, t) {
  return e.slice(t, bn(e, t));
}
function oW(e) {
  return (t, n, r) =>
    !r[0].length ||
    ((e(iW(r.input, r.index)) != fn.Word || e(aW(r.input, r.index)) != fn.Word) &&
      (e(aW(r.input, r.index + r[0].length)) != fn.Word ||
        e(iW(r.input, r.index + r[0].length)) != fn.Word));
}
var sW = class extends ZU {
    nextMatch(e, t, n) {
      let r = rW(this.spec, e, n, e.doc.length).next();
      return (r.done && (r = rW(this.spec, e, 0, t).next()), r.done ? null : r.value);
    }
    prevMatchInRange(e, t, n) {
      for (let r = 1; ; r++) {
        let i = Math.max(t, n - r * 1e4),
          a = rW(this.spec, e, i, n),
          o = null;
        for (; !a.next().done;) o = a.value;
        if (o && (i == t || o.from > i + 10)) return o;
        if (i == t) return null;
      }
    }
    prevMatch(e, t, n) {
      return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, n, e.doc.length);
    }
    getReplacement(e) {
      return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (t, n) => {
        if (n == `&`) return e.match[0];
        if (n == `$`) return `$`;
        for (let t = n.length; t > 0; t--) {
          let r = +n.slice(0, t);
          if (r > 0 && r < e.match.length) return e.match[r] + n.slice(t);
        }
        return t;
      });
    }
    matchAll(e, t) {
      let n = rW(this.spec, e, 0, e.doc.length),
        r = [];
      for (; !n.next().done;) {
        if (r.length >= t) return null;
        r.push(n.value);
      }
      return r;
    }
    highlight(e, t, n, r) {
      let i = rW(this.spec, e, Math.max(0, t - 250), Math.min(n + 250, e.doc.length));
      for (; !i.next().done;) r(i.value.from, i.value.to);
    }
  },
  cW = Wt.define(),
  lW = Wt.define(),
  uW = jt.define({
    create(e) {
      return new dW(CW(e).create(), null);
    },
    update(e, t) {
      for (let n of t.effects)
        n.is(cW)
          ? (e = new dW(n.value.create(), e.panel))
          : n.is(lW) && (e = new dW(e.query, n.value ? SW : null));
      return e;
    },
    provide: (e) => mn.from(e, (e) => e.panel),
  }),
  dW = class {
    constructor(e, t) {
      ((this.query = e), (this.panel = t));
    }
  },
  fW = ut.mark({
    class: `cm-searchMatch`,
  }),
  pW = ut.mark({
    class: `cm-searchMatch cm-searchMatch-selected`,
  }),
  mW = lt.fromClass(
    class {
      constructor(e) {
        ((this.view = e), (this.decorations = this.highlight(e.state.field(uW))));
      }
      update(e) {
        let t = e.state.field(uW);
        (t != e.startState.field(uW) || e.docChanged || e.selectionSet || e.viewportChanged) &&
          (this.decorations = this.highlight(t));
      }
      highlight({ query: e, panel: t }) {
        if (!t || !e.spec.valid) return ut.none;
        let { view: n } = this,
          r = new en();
        for (let t = 0, i = n.visibleRanges, a = i.length; t < a; t++) {
          let { from: o, to: s } = i[t];
          for (; t < a - 1 && s > i[t + 1].from - 500;) s = i[++t].to;
          e.highlight(n.state, o, s, (e, t) => {
            let i = n.state.selection.ranges.some((n) => n.from == e && n.to == t);
            r.add(e, t, i ? pW : fW);
          });
        }
        return r.finish();
      }
    },
    {
      decorations: (e) => e.decorations,
    },
  );
function hW(e) {
  return (t) => {
    let n = t.state.field(uW, !1);
    return n && n.query.spec.valid ? e(t, n) : EW(t);
  };
}
var gW = hW((e, { query: t }) => {
    let { to: n } = e.state.selection.main,
      r = t.nextMatch(e.state, n, n);
    if (!r) return !1;
    let i = Qt.single(r.from, r.to),
      a = e.state.facet(YU);
    return (
      e.dispatch({
        selection: i,
        effects: [NW(e, r), a.scrollToMatch(i.main, e)],
        userEvent: `select.search`,
      }),
      TW(e),
      !0
    );
  }),
  _W = hW((e, { query: t }) => {
    let { state: n } = e,
      { from: r } = n.selection.main,
      i = t.prevMatch(n, r, r);
    if (!i) return !1;
    let a = Qt.single(i.from, i.to),
      o = e.state.facet(YU);
    return (
      e.dispatch({
        selection: a,
        effects: [NW(e, i), o.scrollToMatch(a.main, e)],
        userEvent: `select.search`,
      }),
      TW(e),
      !0
    );
  }),
  vW = hW((e, { query: t }) => {
    let n = t.matchAll(e.state, 1e3);
    return !n || !n.length
      ? !1
      : (e.dispatch({
          selection: Qt.create(n.map((e) => Qt.range(e.from, e.to))),
          userEvent: `select.search.matches`,
        }),
        !0);
  }),
  yW = ({ state: e, dispatch: t }) => {
    let n = e.selection;
    if (n.ranges.length > 1 || n.main.empty) return !1;
    let { from: r, to: i } = n.main,
      a = [],
      o = 0;
    for (let t = new IU(e.doc, e.sliceDoc(r, i)); !t.next().done;) {
      if (a.length > 1e3) return !1;
      (t.value.from == r && (o = a.length), a.push(Qt.range(t.value.from, t.value.to)));
    }
    return (
      t(
        e.update({
          selection: Qt.create(a, o),
          userEvent: `select.search.matches`,
        }),
      ),
      !0
    );
  },
  bW = hW((e, { query: t }) => {
    let { state: n } = e,
      { from: r, to: i } = n.selection.main;
    if (n.readOnly) return !1;
    let a = t.nextMatch(n, r, r);
    if (!a) return !1;
    let o = a,
      s = [],
      c,
      l,
      u = [];
    o.precise
      ? o.from == r &&
        o.to == i &&
        ((l = n.toText(t.getReplacement(o))),
        s.push({
          from: o.from,
          to: o.to,
          insert: l,
        }),
        u.push(Et.announce.of(n.phrase(`replaced match on line $`, n.doc.lineAt(r).number) + `.`)))
      : (o = t.nextMatch(n, o.from, o.to));
    let d = e.state.changes(s);
    return (
      o &&
        ((c = Qt.single(o.from, o.to).map(d)),
        u.push(NW(e, o)),
        u.push(n.facet(YU).scrollToMatch(c.main, e))),
      e.dispatch({
        changes: d,
        selection: c,
        effects: u,
        userEvent: `input.replace`,
      }),
      !0
    );
  }),
  xW = hW((e, { query: t }) => {
    if (e.state.readOnly) return !1;
    let n = [];
    for (let r of t.matchAll(e.state, 1e9)) {
      let { from: e, to: i, precise: a } = r;
      a &&
        n.push({
          from: e,
          to: i,
          insert: t.getReplacement(r),
        });
    }
    if (!n.length) return !1;
    let r = e.state.phrase(`replaced $ matches`, n.length) + `.`;
    return (
      e.dispatch({
        changes: n,
        effects: Et.announce.of(r),
        userEvent: `input.replace.all`,
      }),
      !0
    );
  });
function SW(e) {
  return e.state.facet(YU).createPanel(e);
}
function CW(e, t) {
  let n = e.selection.main,
    r = n.empty || n.to > n.from + 100 ? `` : e.sliceDoc(n.from, n.to);
  if (t && !r) return t;
  let i = e.facet(YU);
  return new XU({
    search: (t?.literal ?? i.literal) ? r : r.replace(/\n/g, `\\n`),
    caseSensitive: t?.caseSensitive ?? i.caseSensitive,
    literal: t?.literal ?? i.literal,
    regexp: t?.regexp ?? i.regexp,
    wholeWord: t?.wholeWord ?? i.wholeWord,
  });
}
function wW(e) {
  let t = ft(e, SW);
  return t && t.dom.querySelector(`[main-field]`);
}
function TW(e) {
  let t = wW(e);
  t && t == e.root.activeElement && t.select();
}
var EW = (e) => {
    let t = e.state.field(uW, !1);
    if (t && t.panel) {
      let n = wW(e);
      if (n && n != e.root.activeElement) {
        let r = CW(e.state, t.query.spec);
        (r.valid &&
          e.dispatch({
            effects: cW.of(r),
          }),
          n.focus(),
          n.select());
      }
    } else
      e.dispatch({
        effects: [lW.of(!0), t ? cW.of(CW(e.state, t.query.spec)) : Wt.appendConfig.of(FW)],
      });
    return !0;
  },
  DW = (e) => {
    let t = e.state.field(uW, !1);
    if (!t || !t.panel) return !1;
    let n = ft(e, SW);
    return (
      n && n.dom.contains(e.root.activeElement) && e.focus(),
      e.dispatch({
        effects: lW.of(!1),
      }),
      !0
    );
  },
  OW = [
    {
      key: `Mod-f`,
      run: EW,
      scope: `editor search-panel`,
    },
    {
      key: `F3`,
      run: gW,
      shift: _W,
      scope: `editor search-panel`,
      preventDefault: !0,
    },
    {
      key: `Mod-g`,
      run: gW,
      shift: _W,
      scope: `editor search-panel`,
      preventDefault: !0,
    },
    {
      key: `Escape`,
      run: DW,
      scope: `editor search-panel`,
    },
    {
      key: `Mod-Shift-l`,
      run: yW,
    },
    {
      key: `Mod-Alt-g`,
      run: GU,
    },
    {
      key: `Mod-d`,
      run: JU,
      preventDefault: !0,
    },
  ],
  kW = class {
    constructor(e) {
      this.view = e;
      let t = (this.query = e.state.field(uW).query.spec);
      ((this.commit = this.commit.bind(this)),
        (this.searchField = un(`input`, {
          value: t.search,
          placeholder: AW(e, `Find`),
          "aria-label": AW(e, `Find`),
          class: `cm-textfield`,
          name: `search`,
          form: ``,
          "main-field": `true`,
          onchange: this.commit,
          onkeyup: this.commit,
        })),
        (this.replaceField = un(`input`, {
          value: t.replace,
          placeholder: AW(e, `Replace`),
          "aria-label": AW(e, `Replace`),
          class: `cm-textfield`,
          name: `replace`,
          form: ``,
          onchange: this.commit,
          onkeyup: this.commit,
        })),
        (this.caseField = un(`input`, {
          type: `checkbox`,
          name: `case`,
          form: ``,
          checked: t.caseSensitive,
          onchange: this.commit,
        })),
        (this.reField = un(`input`, {
          type: `checkbox`,
          name: `re`,
          form: ``,
          checked: t.regexp,
          onchange: this.commit,
        })),
        (this.wordField = un(`input`, {
          type: `checkbox`,
          name: `word`,
          form: ``,
          checked: t.wholeWord,
          onchange: this.commit,
        })));
      function n(e, t, n) {
        return un(
          `button`,
          {
            class: `cm-button`,
            name: e,
            onclick: t,
            type: `button`,
          },
          n,
        );
      }
      this.dom = un(
        `div`,
        {
          onkeydown: (e) => this.keydown(e),
          class: `cm-search`,
        },
        [
          this.searchField,
          n(`next`, () => gW(e), [AW(e, `next`)]),
          n(`prev`, () => _W(e), [AW(e, `previous`)]),
          n(`select`, () => vW(e), [AW(e, `all`)]),
          un(`label`, null, [this.caseField, AW(e, `match case`)]),
          un(`label`, null, [this.reField, AW(e, `regexp`)]),
          un(`label`, null, [this.wordField, AW(e, `by word`)]),
          ...(e.state.readOnly
            ? []
            : [
                un(`br`),
                this.replaceField,
                n(`replace`, () => bW(e), [AW(e, `replace`)]),
                n(`replaceAll`, () => xW(e), [AW(e, `replace all`)]),
              ]),
          un(
            `button`,
            {
              name: `close`,
              onclick: () => DW(e),
              "aria-label": AW(e, `close`),
              type: `button`,
            },
            [`×`],
          ),
        ],
      );
    }
    commit() {
      let e = new XU({
        search: this.searchField.value,
        caseSensitive: this.caseField.checked,
        regexp: this.reField.checked,
        wholeWord: this.wordField.checked,
        replace: this.replaceField.value,
      });
      e.eq(this.query) ||
        ((this.query = e),
        this.view.dispatch({
          effects: cW.of(e),
        }));
    }
    keydown(e) {
      tt(this.view, e, `search-panel`)
        ? e.preventDefault()
        : e.keyCode == 13 && e.target == this.searchField
          ? (e.preventDefault(), (e.shiftKey ? _W : gW)(this.view))
          : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), bW(this.view));
    }
    update(e) {
      for (let t of e.transactions)
        for (let e of t.effects) e.is(cW) && !e.value.eq(this.query) && this.setQuery(e.value);
    }
    setQuery(e) {
      ((this.query = e),
        (this.searchField.value = e.search),
        (this.replaceField.value = e.replace),
        (this.caseField.checked = e.caseSensitive),
        (this.reField.checked = e.regexp),
        (this.wordField.checked = e.wholeWord));
    }
    mount() {
      this.searchField.select();
    }
    get pos() {
      return 80;
    }
    get top() {
      return this.view.state.facet(YU).top;
    }
  };
function AW(e, t) {
  return e.state.phrase(t);
}
var jW = 30,
  MW = /[\s\.,:;?!]/;
function NW(e, { from: t, to: n }) {
  let r = e.state.doc.lineAt(t),
    i = e.state.doc.lineAt(n).to,
    a = Math.max(r.from, t - jW),
    o = Math.min(i, n + jW),
    s = e.state.sliceDoc(a, o);
  if (a != r.from) {
    for (let e = 0; e < jW; e++)
      if (!MW.test(s[e + 1]) && MW.test(s[e])) {
        s = s.slice(e);
        break;
      }
  }
  if (o != i) {
    for (let e = s.length - 1; e > s.length - jW; e--)
      if (!MW.test(s[e - 1]) && MW.test(s[e])) {
        s = s.slice(0, e);
        break;
      }
  }
  return Et.announce.of(
    `${e.state.phrase(`current match`)}. ${s} ${e.state.phrase(`on line`)} ${r.number}.`,
  );
}
var PW = Et.baseTheme({
    ".cm-panel.cm-search": {
      padding: `2px 6px 4px`,
      position: `relative`,
      "& [name=close]": {
        position: `absolute`,
        top: `0`,
        right: `4px`,
        backgroundColor: `inherit`,
        border: `none`,
        font: `inherit`,
        padding: 0,
        margin: 0,
      },
      "& input, & button, & label": {
        margin: `.2em .6em .2em 0`,
      },
      "& input[type=checkbox]": {
        marginRight: `.2em`,
      },
      "& label": {
        fontSize: `80%`,
        whiteSpace: `pre`,
      },
    },
    "&light .cm-searchMatch": {
      backgroundColor: `#ffff0054`,
    },
    "&dark .cm-searchMatch": {
      backgroundColor: `#00ffff8a`,
    },
    "&light .cm-searchMatch-selected": {
      backgroundColor: `#ff6a0054`,
    },
    "&dark .cm-searchMatch-selected": {
      backgroundColor: `#ff00ff8a`,
    },
  }),
  FW = [uW, sn.low(mW), PW];
B();
var IW = (e, t, n) => {
    let r = R(`editorId`),
      i = R(`setting`),
      a = () => {},
      o = () => {},
      s = () => {
        a();
        let t = n.value?.view.contentDOM.getRootNode(),
          i = t?.querySelector(`#${r} .cm-scroller`),
          s = t?.querySelector(`[id="${r}-preview-wrapper"]`),
          c = t?.querySelector(`[id="${r}-html-wrapper"]`);
        (s || c) && (([o, a] = (s ? Jae : qae)(i, s || c, n.value)), e.scrollAuto && o());
      };
    (He([t, i], () => {
      de(s);
    }),
      He(
        () => e.scrollAuto,
        (e) => {
          e ? o() : a();
        },
      ),
      He(
        () => i.value.previewOnly,
        (e) => {
          e ? a() : o();
        },
      ),
      Qe(s));
  },
  LW = async (e, t, n) => {
    if (/^h[1-6]$/.test(e)) return RW(e, t);
    if (e === `prettier`) return await zW(t, n);
    switch (e) {
      case `bold`:
      case `underline`:
      case `italic`:
      case `strikeThrough`:
      case `sub`:
      case `sup`:
      case `codeRow`:
      case `katexInline`:
      case `katexBlock`:
        return VW(e, t);
      case `quote`:
      case `orderedList`:
      case `unorderedList`:
      case `task`:
        return UW(e, t);
      case `code`:
        return WW(n, t);
      case `table`:
        return qW(n);
      case `link`: {
        let e = t.getSelectedText(),
          { desc: r = e, url: i = `` } = n,
          a = `[${r}](${i})`;
        return {
          text: a,
          options: {
            select: i === ``,
            deviationStart: a.length - i.length - 1,
            deviationEnd: -1,
          },
        };
      }
      case `image`:
        return KW(n, t);
      case `flow`:
      case `sequence`:
      case `gantt`:
      case `class`:
      case `state`:
      case `pie`:
      case `relationship`:
      case `journey`:
        return GW(e);
      case `universal`:
        return JW(t.getSelectedText(), n);
      default:
        return {
          text: ``,
          options: {},
        };
    }
  },
  RW = (e, t) => {
    let n = e.slice(1),
      r = `#`.repeat(Number(n)),
      [i, a, o] = YW(t, {
        wholeLine: !0,
      });
    return {
      text: `${r} ${i}`,
      options: {
        deviationStart: r.length + 1,
        replaceStart: a,
        replaceEnd: o,
      },
    };
  },
  zW = async (e, t) => {
    let n = window.prettier || AD.editorExtensions.prettier?.prettierInstance,
      r = [
        window.prettierPlugins?.markdown || AD.editorExtensions.prettier?.parserMarkdownInstance,
      ];
    return !n || !r[0]
      ? (nO.emit(t.editorId, WD, {
          name: `prettier`,
          message: `prettier is undefined`,
        }),
        {
          text: e.getValue(),
          options: {
            select: !1,
            replaceAll: !0,
          },
        })
      : {
          text: await n.format(e.getValue(), {
            parser: `markdown`,
            plugins: r,
          }),
          options: {
            select: !1,
            replaceAll: !0,
          },
        };
  },
  BW = {
    bold: [`**`, `**`, 2, -2],
    underline: [`<u>`, `</u>`, 3, -4],
    italic: [`*`, `*`, 1, -1],
    strikeThrough: [`~~`, `~~`, 2, -2],
    sub: [`~`, `~`, 1, -1],
    sup: [`^`, `^`, 1, -1],
    codeRow: ["`", "`", 1, -1],
    katexInline: [`$`, `$`, 1, -1],
    katexBlock: [
      `
$$
`,
      `
$$
`,
      4,
      -4,
    ],
  },
  VW = (e, t) => {
    let n = t.getSelectedText(),
      [r, i, a, o] = BW[e];
    return {
      text: `${r}${n}${i}`,
      options: {
        deviationStart: a,
        deviationEnd: o,
      },
    };
  },
  HW = {
    quote: `> `,
    unorderedList: `- `,
    orderedList: 1,
    task: `- [ ] `,
  },
  UW = (e, t) => {
    let [n, r, i] = YW(t, {
        wholeLine: !0,
      }),
      a = n.split(`
`),
      o = HW[e],
      s = e === `orderedList` ? a.map((e, t) => `${o + t}. ${e}`) : a.map((e) => `${o}${e}`),
      c = e === `orderedList` ? `1. ` : o.toString(),
      l = a.length === 1 ? c.length : 0;
    return {
      text: s.join(`
`),
      options: {
        deviationStart: l,
        replaceStart: r,
        replaceEnd: i,
      },
    };
  },
  WW = (e, t) => {
    let [n, r, i] = YW(t),
      a = e.mode || `language`,
      o = `
\`\`\`${a}
${e.text || n || ``}
\`\`\`
`;
    return {
      text: o,
      options: {
        deviationStart: 4,
        deviationEnd: 4 + a.length - o.length,
        replaceStart: r,
        replaceEnd: i,
      },
    };
  },
  GW = (e) => ({
    text: `
\`\`\`mermaid
${
  {
    flow: `flowchart TD 
  Start --> Stop`,
    sequence: `sequenceDiagram
  A->>B: hello!
  B-->>A: hi!`,
    gantt: `gantt
title Gantt Chart
dateFormat  YYYY-MM-DD`,
    class: `classDiagram
  class Animal`,
    state: `stateDiagram-v2
  s1 --> s2`,
    pie: `pie
  "Dogs" : 386
  "Cats" : 85
  "Rats" : 15`,
    relationship: `erDiagram
  CAR ||--o{ NAMED-DRIVER : allows`,
    journey: `journey
  title My Journey`,
    ...AD.editorConfig.mermaidTemplate,
  }[e]
}
\`\`\`
`,
    options: {
      deviationStart: 12,
      deviationEnd: -5,
    },
  }),
  KW = (e, t) => {
    let n = t.getSelectedText(),
      { desc: r = n, url: i = ``, urls: a } = e,
      o = ``,
      s = i === `` && (!a || (a instanceof Array && a.length === 0));
    return (
      (o =
        a instanceof Array
          ? a.reduce((e, t) => {
              let {
                url: n = ``,
                alt: r = ``,
                title: i = ``,
              } = typeof t == `object`
                ? t
                : {
                    url: t,
                  };
              return (
                e +
                `![${r}](${n}${i ? ` '` + i + `'` : ``})
`
              );
            }, ``)
          : `![${r}](${i})
`),
      {
        text: o,
        options: {
          select: i === ``,
          deviationStart: s ? o.length - i.length - 2 : o.length,
          deviationEnd: s ? -2 : 0,
        },
      }
    );
  },
  qW = (e) => {
    let {
        selectedShape: t = {
          x: 1,
          y: 1,
        },
      } = e,
      { x: n, y: r } = t,
      i = `
| Column`;
    for (let e = 0; e <= r; e++) i += ` |`;
    i += `
|`;
    for (let e = 0; e <= r; e++) i += ` - |`;
    for (let e = 0; e <= n; e++) {
      i += `
|`;
      for (let e = 0; e <= r; e++) i += ` |`;
    }
    return (
      (i += `
`),
      {
        text: i,
        options: {
          deviationStart: 3,
          deviationEnd: 10 - i.length,
        },
      }
    );
  },
  JW = (e, t) => {
    let { generate: n } = t,
      r = n(e);
    return {
      text: r.targetValue,
      options: {
        select: r.select ?? !0,
        deviationStart: r.deviationStart || 0,
        deviationEnd: r.deviationEnd || 0,
      },
    };
  },
  YW = (
    e,
    t = {
      wholeLine: !1,
    },
  ) => {
    let n = e.view.state,
      r = n.selection.main;
    if (r.empty) {
      let e = n.doc.lineAt(r.from);
      return [n.doc.lineAt(r.from).text, e.from, e.to];
    } else if (t.wholeLine) {
      let e = n.doc.lineAt(r.from),
        t = n.doc.lineAt(r.to);
      return [n.doc.sliceString(e.from, t.to), e.from, t.to];
    }
    return [n.doc.sliceString(r.from, r.to), r.from, r.to];
  },
  XW = (e) => {
    let t = new Lt();
    return (n) => (
      t.get(e.state)
        ? e.dispatch({
            effects: t.reconfigure(n),
          })
        : e.dispatch({
            effects: Wt.appendConfig.of(t.of(n)),
          }),
      !0
    );
  },
  ZW = class {
    view;
    maxLength = 2 ** 53 - 1;
    toggleTabSize;
    togglePlaceholder;
    setExtensions;
    toggleDisabled;
    toggleReadOnly;
    toggleMaxlength;
    getValue() {
      return this.view.state.doc.toString();
    }
    setValue(e, t = 0, n = this.view.state.doc.length) {
      this.view.dispatch({
        changes: {
          from: t,
          to: n,
          insert: e,
        },
      });
    }
    getSelectedText() {
      let { from: e, to: t } = this.view.state.selection.main;
      return this.view.state.sliceDoc(e, t);
    }
    replaceSelectedText(e, t, n) {
      let r = {
        select: !0,
        deviationStart: 0,
        deviationEnd: 0,
        replaceAll: !1,
        replaceStart: -1,
        replaceEnd: -1,
        ...t,
      };
      try {
        if (r.replaceAll) {
          if ((this.setValue(e), e.length > this.maxLength))
            throw Error(`The input text is too long`);
          return;
        }
        if (this.view.state.doc.length - this.getSelectedText().length + e.length > this.maxLength)
          throw Error(`The input text is too long`);
        let { from: t } = this.view.state.selection.main;
        (r.replaceStart === -1
          ? this.view.dispatch(this.view.state.replaceSelection(e))
          : this.view.dispatch({
              changes: {
                from: r.replaceStart,
                to: r.replaceEnd,
                insert: e,
              },
            }),
          r.select &&
            this.view.dispatch({
              selection: {
                anchor:
                  r.replaceStart === -1 ? t + r.deviationStart : r.replaceStart + r.deviationStart,
                head:
                  r.replaceStart === -1
                    ? t + e.length + r.deviationEnd
                    : r.replaceStart + e.length + r.deviationEnd,
              },
            }),
          this.view.focus());
      } catch (t) {
        if (t.message === `The input text is too long`)
          nO.emit(n, WD, {
            name: `overlength`,
            message: t.message,
            data: e,
          });
        else throw t;
      }
    }
    constructor(e) {
      ((this.view = e),
        (this.toggleTabSize = XW(this.view)),
        (this.togglePlaceholder = XW(this.view)),
        (this.setExtensions = XW(this.view)),
        (this.toggleDisabled = XW(this.view)),
        (this.toggleReadOnly = XW(this.view)),
        (this.toggleMaxlength = XW(this.view)));
    }
    setTabSize(e) {
      this.toggleTabSize([gn.tabSize.of(e), St.of(` `.repeat(e))]);
    }
    setPlaceholder(e) {
      this.togglePlaceholder(vt(e));
    }
    focus(e) {
      if ((this.view.focus(), !e)) return;
      let t = 0,
        n = 0,
        r = 0;
      switch (e) {
        case `start`:
          break;
        case `end`:
          t = n = r = this.getValue().length;
          break;
        default:
          ((t = e.rangeAnchor || e.cursorPos), (n = e.rangeHead || e.cursorPos), (r = e.cursorPos));
      }
      this.view.dispatch({
        scrollIntoView: !0,
        selection: Qt.create([Qt.range(t, n), Qt.cursor(r)], 1),
      });
    }
    setDisabled(e) {
      this.toggleDisabled([Et.editable.of(!e)]);
    }
    setReadOnly(e) {
      this.toggleReadOnly([gn.readOnly.of(e)]);
    }
    setMaxLength(e) {
      ((this.maxLength = e),
        this.toggleMaxlength([gn.changeFilter.of((t) => t.newDoc.length <= e)]));
    }
  },
  QW = (e, t) => {
    if (e === t) return !0;
    if (e.length !== t.length) return !1;
    for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
    return !0;
  },
  $W = (e, t) => {
    let n = F(t.value);
    He([t], () => {
      (!n.value || !QW(n.value, t.value)) && ((n.value = t.value), e());
    });
  },
  eG = (e, t, n, r, i) => (a, o, s, c) => {
    let l = `${e}${t}${n}${r}`,
      u = s + o.label.length + (i === `title` ? n.length : 0);
    (a.dispatch({
      changes: {
        from: s,
        to: c,
        insert: l,
      },
      selection: Qt.create(
        [Qt.range(s + o.label.length + (i === `title` ? 1 : -t.length), u), Qt.cursor(u)],
        1,
      ),
    }),
      a.focus());
  },
  tG = (e) => (t, n, r, i) => {
    let a = e.slice(i - r);
    t.dispatch(t.state.replaceSelection(`${a} `));
  },
  nG = (e) => {
    let t = (e) => {
      let t = e.matchBefore(/^#+|^-\s*\[*\s*\]*|`+|\[|!\[*|^\|\s?\|?|\$\$?|!+\s*\w*/);
      return t === null || (t.from == t.to && e.explicit)
        ? null
        : {
            from: t.from,
            options: [
              ...[`h2`, `h3`, `h4`, `h5`, `h6`].map((e, t) => {
                let n = Array(t + 2)
                  .fill(`#`)
                  .join(``);
                return {
                  label: n,
                  type: `text`,
                  apply: tG(n),
                };
              }),
              ...[`unchecked`, `checked`].map((e) => {
                let t = e === `checked` ? `- [x]` : `- [ ]`;
                return {
                  label: t,
                  type: `text`,
                  apply: tG(t),
                };
              }),
              ...[
                ["`", ``],
                ["```", `language`],
                ["```mermaid\n", ``],
                ["```echarts\n", ``],
              ].map((e) => ({
                label: `${e[0]}${e[1]}`,
                type: `text`,
                apply: eG(e[0], e[1], ``, e[0] === "`" ? "`" : "\n```", `type`),
              })),
              {
                label: `[]()`,
                type: `text`,
              },
              {
                label: `![]()`,
                type: `text`,
              },
              {
                label: `| |`,
                type: `text`,
                detail: `table`,
                apply: `| col | col | col |
| - | - | - |
| content | content | content |
| content | content | content |`,
              },
              {
                label: `$`,
                type: `text`,
                apply: eG(`$`, ``, ``, `$`, `type`),
              },
              {
                label: `$$`,
                type: `text`,
                apply: eG(
                  `$$`,
                  ``,
                  `
`,
                  `
$$`,
                  `title`,
                ),
              },
              ...[
                `note`,
                `abstract`,
                `info`,
                `tip`,
                `success`,
                `question`,
                `warning`,
                `failure`,
                `danger`,
                `bug`,
                `example`,
                `quote`,
                `hint`,
                `caution`,
                `error`,
                `attention`,
              ].map((e) => ({
                label: `!!! ${e}`,
                type: `text`,
                apply: eG(
                  `!!!`,
                  ` ${e}`,
                  ` Title`,
                  `

!!!`,
                  `title`,
                ),
              })),
            ],
          };
    };
    return wL({
      override: e ? [t, ...e] : [t],
    });
  },
  rG = k({
    name: `${$}-divider`,
    setup() {
      return () =>
        N(
          `div`,
          {
            class: `${$}-divider`,
          },
          null,
        );
    },
  }),
  iG = k({
    name: `ToolbarBold`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.bold,
            "aria-label": t.value.toolbarTips?.bold,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `bold`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `bold`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.bold],
              ),
          ],
        );
    },
  }),
  aG = k({
    name: `ToolbarCatalog`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`),
        i = R(`catalogVisible`);
      return () =>
        N(
          `button`,
          {
            class: [
              `${$}-toolbar-item`,
              i.value && `md-editor-toolbar-active`,
              n?.value && `md-editor-disabled`,
            ],
            title: t.value.toolbarTips?.catalog,
            "aria-label": t.value.toolbarTips?.catalog,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, FD);
            },
            key: `bar-catalog`,
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `catalog`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.catalog],
              ),
          ],
        );
    },
  }),
  oG = k({
    name: `ToolbarCode`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.code,
            "aria-label": t.value.toolbarTips?.code,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `code`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `code`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.code],
              ),
          ],
        );
    },
  }),
  sG = k({
    name: `ToolbarCodeRow`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.codeRow,
            "aria-label": t.value.toolbarTips?.codeRow,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `codeRow`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `code-row`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.codeRow],
              ),
          ],
        );
    },
  }),
  cG = k({
    name: `ToolbarFullscreen`,
    setup() {
      let e = R(`usedLanguageText`),
        t = R(`disabled`),
        n = R(`showToolbarName`),
        r = R(`setting`),
        { fullscreenHandler: i } = zG();
      return () =>
        N(
          `button`,
          {
            class: [
              `${$}-toolbar-item`,
              r.value.fullscreen && `md-editor-toolbar-active`,
              t?.value && `md-editor-disabled`,
            ],
            title: e.value.toolbarTips?.fullscreen,
            "aria-label": e.value.toolbarTips?.fullscreen,
            disabled: t?.value,
            onClick: () => {
              i();
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: r.value.fullscreen ? `fullscreen-exit` : `fullscreen`,
              },
              null,
            ),
            n?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [e.value.toolbarTips?.fullscreen],
              ),
          ],
        );
    },
  }),
  lG = k({
    name: `ToolbarGithub`,
    setup() {
      let e = R(`usedLanguageText`),
        t = R(`disabled`),
        n = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, t?.value && `md-editor-disabled`],
            title: e.value.toolbarTips?.github,
            "aria-label": e.value.toolbarTips?.github,
            disabled: t?.value,
            onClick: () => {
              kae(`https://github.com/imzbf/md-editor-v3`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `github`,
              },
              null,
            ),
            n?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [e.value.toolbarTips?.github],
              ),
          ],
        );
    },
  }),
  uG = k({
    name: `ToolbarHtmlPreview`,
    setup() {
      let e = R(`usedLanguageText`),
        t = R(`disabled`),
        n = R(`showToolbarName`),
        r = R(`setting`),
        i = R(`updateSetting`);
      return () =>
        N(
          `button`,
          {
            class: [
              `${$}-toolbar-item`,
              r.value.htmlPreview && `md-editor-toolbar-active`,
              t?.value && `md-editor-disabled`,
            ],
            title: e.value.toolbarTips?.htmlPreview,
            "aria-label": e.value.toolbarTips?.htmlPreview,
            disabled: t?.value,
            onClick: () => {
              i(`htmlPreview`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `preview-html`,
              },
              null,
            ),
            n?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [e.value.toolbarTips?.htmlPreview],
              ),
          ],
        );
    },
  }),
  dG = k({
    name: `ToolbarImage`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.image,
            "aria-label": t.value.toolbarTips?.image,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `image`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `image`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.image],
              ),
          ],
        );
    },
  }),
  fG = {
    visible: {
      type: Boolean,
      default: !1,
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
    onOk: {
      type: Function,
      default: () => {},
    },
  },
  pG = k({
    name: `${$}-modal-clip`,
    props: fG,
    setup(e) {
      let t = R(`usedLanguageText`),
        n = R(`editorId`),
        r = R(`rootRef`),
        i = AD.editorExtensions.cropper.instance,
        a = F(),
        o = F(),
        s = F(),
        c = Ae({
          cropperInited: !1,
          imgSelected: !1,
          imgSrc: ``,
          isFullscreen: !1,
        }),
        l = null;
      (He(
        () => e.visible,
        () => {
          e.visible &&
            !c.cropperInited &&
            ((i ||= window.Cropper),
            (a.value.onchange = () => {
              if (!i) {
                nO.emit(n, `errorCatcher`, {
                  name: `Cropper`,
                  message: `Cropper is undefined`,
                });
                return;
              }
              let e = a.value.files || [];
              if (((c.imgSelected = !0), e?.length > 0)) {
                let t = new FileReader();
                ((t.onload = (e) => {
                  c.imgSrc = e.target.result;
                }),
                  t.readAsDataURL(e[0]));
              }
            }));
        },
      ),
        He(
          () => [c.imgSelected],
          () => {
            s.value.style = ``;
          },
        ),
        He([me(() => c.isFullscreen), me(() => c.imgSrc)], () => {
          c.imgSrc &&
            de(() => {
              (l?.destroy(),
                (s.value.style = ``),
                o.value &&
                  (l = new i(o.value, {
                    viewMode: 2,
                    preview: r.value.getRootNode().querySelector(`.md-editor-clip-preview-target`),
                  })));
            });
        }));
      let u = () => {
          (l.clear(),
            l.destroy(),
            (l = null),
            (a.value.value = ``),
            (c.imgSelected = !1),
            (c.imgSrc = ``));
        },
        d = (e) => {
          c.isFullscreen = e;
        };
      return () =>
        N(
          MN,
          {
            class: `${$}-modal-clip`,
            title: t.value.clipModalTips?.title,
            visible: e.visible,
            onClose: e.onCancel,
            showAdjust: !0,
            isFullscreen: c.isFullscreen,
            onAdjust: d,
            width: `668px`,
            height: `421px`,
          },
          {
            default: () => [
              N(
                `div`,
                {
                  class: `${$}-form-item ${$}-clip`,
                },
                [
                  N(
                    `div`,
                    {
                      class: `${$}-clip-main`,
                    },
                    [
                      c.imgSelected
                        ? N(
                            `div`,
                            {
                              class: `${$}-clip-cropper`,
                            },
                            [
                              N(
                                `img`,
                                {
                                  src: c.imgSrc,
                                  ref: o,
                                  style: {
                                    display: `none`,
                                  },
                                  alt: ``,
                                },
                                null,
                              ),
                              N(
                                `div`,
                                {
                                  class: `${$}-clip-delete`,
                                  onClick: u,
                                },
                                [
                                  N(
                                    jN,
                                    {
                                      name: `delete`,
                                    },
                                    null,
                                  ),
                                ],
                              ),
                            ],
                          )
                        : N(
                            `div`,
                            {
                              class: `${$}-clip-upload`,
                              onClick: () => {
                                a.value.click();
                              },
                              role: `button`,
                              tabindex: `0`,
                              "aria-label": t.value.imgTitleItem?.upload,
                            },
                            [
                              N(
                                jN,
                                {
                                  name: `upload`,
                                },
                                null,
                              ),
                            ],
                          ),
                    ],
                  ),
                  N(
                    `div`,
                    {
                      class: `${$}-clip-preview`,
                    },
                    [
                      N(
                        `div`,
                        {
                          class: `${$}-clip-preview-target`,
                          ref: s,
                        },
                        null,
                      ),
                    ],
                  ),
                ],
              ),
              N(
                `div`,
                {
                  class: `${$}-form-item`,
                },
                [
                  N(
                    `button`,
                    {
                      class: `${$}-btn`,
                      type: `button`,
                      onClick: () => {
                        if (l) {
                          let t = l.getCroppedCanvas();
                          (nO.emit(n, KD, [Uae(t.toDataURL(`image/png`))], e.onOk), u());
                        }
                      },
                    },
                    [t.value.clipModalTips?.buttonUpload || t.value.linkModalTips?.buttonOK],
                  ),
                ],
              ),
              N(
                `input`,
                {
                  ref: a,
                  accept: `image/*`,
                  type: `file`,
                  multiple: !1,
                  style: {
                    display: `none`,
                  },
                  "aria-hidden": `true`,
                },
                null,
              ),
            ],
          },
        );
    },
  }),
  mG = {
    clipVisible: {
      type: Boolean,
      default: !1,
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
    onOk: {
      type: Function,
      default: () => {},
    },
  },
  hG = k({
    name: `${$}-modals`,
    props: mG,
    setup(e) {
      return () =>
        N(
          pG,
          {
            visible: e.clipVisible,
            onOk: e.onOk,
            onCancel: e.onCancel,
          },
          null,
        );
    },
  }),
  gG = k({
    name: `ToolbarImageDropdown`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`),
        i = `${e}-toolbar-wrapper`,
        a = F(!1),
        o = F(!1),
        s = F(),
        c = () => {
          (nO.emit(e, KD, Array.from(s.value.files || [])), (s.value.value = ``));
        },
        l = (t, r) => {
          n?.value || nO.emit(e, `replace`, t, r);
        };
      Qe(() => {
        s.value.addEventListener(`change`, c);
      });
      let u = (e) => {
          a.value = e;
        },
        d = () => {
          o.value = !1;
        },
        f = (e) => {
          (e &&
            l(`image`, {
              desc: e.desc,
              url: e.url,
              transform: !0,
            }),
            (o.value = !1));
        },
        p = V(() =>
          N(
            `ul`,
            {
              class: `${$}-menu`,
              onClick: () => {
                a.value = !1;
              },
              role: `menu`,
            },
            [
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-image`,
                  onClick: () => {
                    l(`image`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.imgTitleItem?.link],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-image`,
                  onClick: () => {
                    s.value.click();
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.imgTitleItem?.upload],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-image`,
                  onClick: () => {
                    o.value = !0;
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.imgTitleItem?.clip2upload],
              ),
            ],
          ),
        );
      return () =>
        N(ke, null, [
          N(
            `label`,
            {
              for: `${i}_label`,
              style: {
                display: `none`,
              },
              "aria-label": t.value.imgTitleItem?.upload,
            },
            null,
          ),
          N(
            `input`,
            {
              id: `${i}_label`,
              ref: s,
              accept: `image/*`,
              type: `file`,
              multiple: !0,
              style: {
                display: `none`,
              },
            },
            null,
          ),
          N(
            MD,
            {
              relative: `#${i}`,
              visible: a.value,
              onChange: u,
              disabled: n?.value,
              overlay: p.value,
            },
            {
              default: () => [
                N(
                  `button`,
                  {
                    class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
                    title: t.value.toolbarTips?.image,
                    "aria-label": t.value.toolbarTips?.image,
                    disabled: n?.value,
                    type: `button`,
                  },
                  [
                    N(
                      jN,
                      {
                        name: `image`,
                      },
                      null,
                    ),
                    r?.value &&
                      N(
                        `div`,
                        {
                          class: `md-editor-toolbar-item-name`,
                        },
                        [t.value.toolbarTips?.image],
                      ),
                  ],
                ),
              ],
            },
          ),
          N(
            hG,
            {
              clipVisible: o.value,
              onCancel: d,
              onOk: f,
            },
            null,
          ),
        ]);
    },
  }),
  _G = k({
    name: `ToolbarItalic`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.italic,
            "aria-label": t.value.toolbarTips?.italic,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `italic`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `italic`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.italic],
              ),
          ],
        );
    },
  }),
  vG = k({
    name: `ToolbarKatex`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`),
        i = `${e}-toolbar-wrapper`,
        a = F(!1),
        o = (t) => {
          n?.value || nO.emit(e, `replace`, t);
        },
        s = (e) => {
          a.value = e;
        },
        c = V(() =>
          N(
            `ul`,
            {
              class: `${$}-menu`,
              onClick: () => {
                a.value = !1;
              },
              role: `menu`,
            },
            [
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-katex`,
                  onClick: () => {
                    o(`katexInline`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.katex?.inline],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-katex`,
                  onClick: () => {
                    o(`katexBlock`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.katex?.block],
              ),
            ],
          ),
        );
      return () =>
        N(
          MD,
          {
            relative: `#${i}`,
            visible: a.value,
            onChange: s,
            disabled: n?.value,
            overlay: c.value,
            key: `bar-katex`,
          },
          {
            default: () => [
              N(
                `button`,
                {
                  class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
                  title: t.value.toolbarTips?.katex,
                  "aria-label": t.value.toolbarTips?.katex,
                  disabled: n?.value,
                  type: `button`,
                },
                [
                  N(
                    jN,
                    {
                      name: `formula`,
                    },
                    null,
                  ),
                  r?.value &&
                    N(
                      `div`,
                      {
                        class: `md-editor-toolbar-item-name`,
                      },
                      [t.value.toolbarTips?.katex],
                    ),
                ],
              ),
            ],
          },
        );
    },
  }),
  yG = k({
    name: `ToolbarLink`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.link,
            "aria-label": t.value.toolbarTips?.link,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `link`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `link`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.link],
              ),
          ],
        );
    },
  }),
  bG = k({
    name: `ToolbarMermaid`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`),
        i = `${e}-toolbar-wrapper`,
        a = F(!1),
        o = (t) => {
          n?.value || nO.emit(e, `replace`, t);
        },
        s = (e) => {
          a.value = e;
        },
        c = V(() =>
          N(
            `ul`,
            {
              class: `${$}-menu`,
              onClick: () => {
                a.value = !1;
              },
              role: `menu`,
            },
            [
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`flow`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.flow],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`sequence`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.sequence],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`gantt`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.gantt],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`class`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.class],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`state`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.state],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`pie`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.pie],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`relationship`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.relationship],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-mermaid`,
                  onClick: () => {
                    o(`journey`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.mermaid?.journey],
              ),
            ],
          ),
        );
      return () =>
        N(
          MD,
          {
            relative: `#${i}`,
            visible: a.value,
            onChange: s,
            disabled: n?.value,
            overlay: c.value,
            key: `bar-mermaid`,
          },
          {
            default: () => [
              N(
                `button`,
                {
                  class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
                  title: t.value.toolbarTips?.mermaid,
                  "aria-label": t.value.toolbarTips?.mermaid,
                  disabled: n?.value,
                  type: `button`,
                },
                [
                  N(
                    jN,
                    {
                      name: `mermaid`,
                    },
                    null,
                  ),
                  r?.value &&
                    N(
                      `div`,
                      {
                        class: `md-editor-toolbar-item-name`,
                      },
                      [t.value.toolbarTips?.mermaid],
                    ),
                ],
              ),
            ],
          },
        );
    },
  }),
  xG = k({
    name: `ToolbarNext`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.next,
            "aria-label": t.value.toolbarTips?.next,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, JD);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `next`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.next],
              ),
          ],
        );
    },
  }),
  SG = k({
    name: `ToolbarOrderedList`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.orderedList,
            "aria-label": t.value.toolbarTips?.orderedList,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `orderedList`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `ordered-list`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.orderedList],
              ),
          ],
        );
    },
  }),
  CG = k({
    name: `ToolbarPageFullscreen`,
    setup() {
      let e = R(`usedLanguageText`),
        t = R(`disabled`),
        n = R(`showToolbarName`),
        r = R(`setting`),
        i = R(`updateSetting`);
      return () =>
        N(
          `button`,
          {
            class: [
              `${$}-toolbar-item`,
              r.value.pageFullscreen && `md-editor-toolbar-active`,
              t?.value && `md-editor-disabled`,
            ],
            title: e.value.toolbarTips?.pageFullscreen,
            "aria-label": e.value.toolbarTips?.pageFullscreen,
            disabled: t?.value,
            onClick: () => {
              i(`pageFullscreen`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: r.value.pageFullscreen ? `minimize` : `maximize`,
              },
              null,
            ),
            n?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [e.value.toolbarTips?.pageFullscreen],
              ),
          ],
        );
    },
  }),
  wG = k({
    name: `ToolbarPrettier`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.prettier,
            "aria-label": t.value.toolbarTips?.prettier,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `prettier`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `prettier`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.prettier],
              ),
          ],
        );
    },
  }),
  TG = k({
    name: `ToolbarPreview`,
    setup() {
      let e = R(`usedLanguageText`),
        t = R(`disabled`),
        n = R(`showToolbarName`),
        r = R(`setting`),
        i = R(`updateSetting`);
      return () =>
        N(
          `button`,
          {
            class: [
              `${$}-toolbar-item`,
              r.value.preview && `md-editor-toolbar-active`,
              t?.value && `md-editor-disabled`,
            ],
            title: e.value.toolbarTips?.preview,
            "aria-label": e.value.toolbarTips?.preview,
            disabled: t?.value,
            onClick: () => {
              i(`preview`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `preview`,
              },
              null,
            ),
            n?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [e.value.toolbarTips?.preview],
              ),
          ],
        );
    },
  }),
  EG = k({
    name: `ToolbarPreviewOnly`,
    setup() {
      let e = R(`usedLanguageText`),
        t = R(`disabled`),
        n = R(`showToolbarName`),
        r = R(`setting`),
        i = R(`updateSetting`);
      return () =>
        N(
          `button`,
          {
            class: [
              `${$}-toolbar-item`,
              r.value.previewOnly && `md-editor-toolbar-active`,
              t?.value && `md-editor-disabled`,
            ],
            title: e.value.toolbarTips?.previewOnly,
            "aria-label": e.value.toolbarTips?.previewOnly,
            disabled: t?.value,
            onClick: () => {
              i(`previewOnly`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `preview-only`,
              },
              null,
            ),
            n?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [e.value.toolbarTips?.previewOnly],
              ),
          ],
        );
    },
  }),
  DG = k({
    name: `ToolbarQuote`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.quote,
            "aria-label": t.value.toolbarTips?.quote,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `quote`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `quote`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.quote],
              ),
          ],
        );
    },
  }),
  OG = k({
    name: `ToolbarRevoke`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.revoke,
            "aria-label": t.value.toolbarTips?.revoke,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, qD);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `revoke`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.revoke],
              ),
          ],
        );
    },
  }),
  kG = k({
    name: `ToolbarSave`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.save,
            "aria-label": t.value.toolbarTips?.save,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, PD);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `save`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.save],
              ),
          ],
        );
    },
  }),
  AG = k({
    name: `ToolbarStrikeThrough`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.strikeThrough,
            "aria-label": t.value.toolbarTips?.strikeThrough,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `strikeThrough`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `strike-through`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.strikeThrough],
              ),
          ],
        );
    },
  }),
  jG = k({
    name: `ToolbarSub`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.sub,
            "aria-label": t.value.toolbarTips?.sub,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `sub`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `sub`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.sub],
              ),
          ],
        );
    },
  }),
  MG = k({
    name: `ToolbarSup`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.sup,
            "aria-label": t.value.toolbarTips?.sup,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `sup`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `sup`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.sup],
              ),
          ],
        );
    },
  }),
  NG = k({
    name: `TableShape`,
    props: {
      tableShape: {
        type: Array,
        default: () => [6, 4],
      },
      onSelected: {
        type: Function,
        default: () => {},
      },
    },
    setup(e) {
      let t = Ae({
          x: -1,
          y: -1,
        }),
        n = V(() => JSON.stringify(e.tableShape)),
        r = () => {
          let e = [...JSON.parse(n.value)];
          return (
            (!e[2] || e[2] < e[0]) && (e[2] = e[0]),
            (!e[3] || e[3] < e[3]) && (e[3] = e[1]),
            e
          );
        },
        i = F(r());
      return (
        He([n], () => {
          i.value = r();
        }),
        () =>
          N(
            `div`,
            {
              class: `${$}-table-shape`,
              onMouseleave: () => {
                ((i.value = r()), (t.x = -1), (t.y = -1));
              },
            },
            [
              Array(i.value[1])
                .fill(``)
                .map((n, r) =>
                  N(
                    `div`,
                    {
                      class: `${$}-table-shape-row`,
                      key: `table-shape-row-${r}`,
                    },
                    [
                      Array(i.value[0])
                        .fill(``)
                        .map((n, a) =>
                          N(
                            `div`,
                            {
                              class: `${$}-table-shape-col`,
                              key: `table-shape-col-${a}`,
                              onMouseenter: () => {
                                ((t.x = r),
                                  (t.y = a),
                                  a + 1 === i.value[0] && a + 1 < i.value[2]
                                    ? i.value[0]++
                                    : a + 2 < i.value[0] &&
                                      i.value[0] > e.tableShape[0] &&
                                      i.value[0]--,
                                  r + 1 === i.value[1] && r + 1 < i.value[3]
                                    ? i.value[1]++
                                    : r + 2 < i.value[1] &&
                                      i.value[1] > e.tableShape[1] &&
                                      i.value[1]--);
                              },
                              onClick: () => {
                                e.onSelected(t);
                              },
                            },
                            [
                              N(
                                `div`,
                                {
                                  class: [
                                    `${$}-table-shape-col-default`,
                                    r <= t.x && a <= t.y && `md-editor-table-shape-col-include`,
                                  ],
                                },
                                null,
                              ),
                            ],
                          ),
                        ),
                    ],
                  ),
                ),
            ],
          )
      );
    },
  }),
  PG = k({
    name: `ToolbarTable`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`),
        i = R(`tableShape`),
        a = `${e}-toolbar-wrapper`,
        o = F(!1),
        s = (e) => {
          o.value = e;
        },
        c = (t) => {
          n?.value ||
            nO.emit(e, `replace`, `table`, {
              selectedShape: t,
            });
        },
        l = V(() =>
          N(
            NG,
            {
              tableShape: i.value,
              onSelected: c,
            },
            null,
          ),
        );
      return () =>
        N(
          MD,
          {
            relative: `#${a}`,
            visible: o.value,
            onChange: s,
            disabled: n?.value,
            key: `bar-table`,
            overlay: l.value,
          },
          {
            default: () => [
              N(
                `button`,
                {
                  class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
                  title: t.value.toolbarTips?.table,
                  "aria-label": t.value.toolbarTips?.table,
                  disabled: n?.value,
                  type: `button`,
                },
                [
                  N(
                    jN,
                    {
                      name: `table`,
                    },
                    null,
                  ),
                  r?.value &&
                    N(
                      `div`,
                      {
                        class: `md-editor-toolbar-item-name`,
                      },
                      [t.value.toolbarTips?.table],
                    ),
                ],
              ),
            ],
          },
        );
    },
  }),
  FG = k({
    name: `ToolbarTask`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.task,
            "aria-label": t.value.toolbarTips?.task,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `task`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `task`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.task],
              ),
          ],
        );
    },
  }),
  IG = k({
    name: `ToolbarTitle`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`),
        i = `${e}-toolbar-wrapper`,
        a = F(!1),
        o = (t) => {
          n?.value || nO.emit(e, `replace`, t);
        },
        s = (e) => {
          a.value = e;
        },
        c = V(() =>
          N(
            `ul`,
            {
              class: `${$}-menu`,
              onClick: () => {
                a.value = !1;
              },
              role: `menu`,
            },
            [
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-title`,
                  onClick: () => {
                    o(`h1`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.titleItem?.h1],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-title`,
                  onClick: () => {
                    o(`h2`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.titleItem?.h2],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-title`,
                  onClick: () => {
                    o(`h3`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.titleItem?.h3],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-title`,
                  onClick: () => {
                    o(`h4`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.titleItem?.h4],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-title`,
                  onClick: () => {
                    o(`h5`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.titleItem?.h5],
              ),
              N(
                `li`,
                {
                  class: `${$}-menu-item ${$}-menu-item-title`,
                  onClick: () => {
                    o(`h6`);
                  },
                  role: `menuitem`,
                  tabindex: `0`,
                },
                [t.value.titleItem?.h6],
              ),
            ],
          ),
        );
      return () =>
        N(
          MD,
          {
            relative: `#${i}`,
            visible: a.value,
            onChange: s,
            disabled: n?.value,
            overlay: c.value,
          },
          {
            default: () => [
              N(
                `button`,
                {
                  class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
                  disabled: n?.value,
                  title: t.value.toolbarTips?.title,
                  "aria-label": t.value.toolbarTips?.title,
                  type: `button`,
                },
                [
                  N(
                    jN,
                    {
                      name: `title`,
                    },
                    null,
                  ),
                  r?.value &&
                    N(
                      `div`,
                      {
                        class: `md-editor-toolbar-item-name`,
                      },
                      [t.value.toolbarTips?.title],
                    ),
                ],
              ),
            ],
          },
        );
    },
  }),
  LG = k({
    name: `ToolbarUnderline`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.underline,
            "aria-label": t.value.toolbarTips?.underline,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `underline`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `underline`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.underline],
              ),
          ],
        );
    },
  }),
  RG = k({
    name: `ToolbarUnorderedList`,
    setup() {
      let e = R(`editorId`),
        t = R(`usedLanguageText`),
        n = R(`disabled`),
        r = R(`showToolbarName`);
      return () =>
        N(
          `button`,
          {
            class: [`${$}-toolbar-item`, n?.value && `md-editor-disabled`],
            title: t.value.toolbarTips?.unorderedList,
            "aria-label": t.value.toolbarTips?.unorderedList,
            disabled: n?.value,
            onClick: () => {
              nO.emit(e, GD, `unorderedList`);
            },
            type: `button`,
          },
          [
            N(
              jN,
              {
                name: `unordered-list`,
              },
              null,
            ),
            r?.value &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-item-name`,
                },
                [t.value.toolbarTips?.unorderedList],
              ),
          ],
        );
    },
  }),
  zG = () => {
    let e = R(`editorId`),
      t = R(`setting`),
      n = R(`updateSetting`),
      { editorExtensions: r, editorExtensionsAttrs: i } = AD,
      a = r.screenfull.instance,
      o = F(!1),
      s = (t) => {
        if (!a) {
          nO.emit(e, WD, {
            name: `fullscreen`,
            message: `fullscreen is undefined`,
          });
          return;
        }
        a.isEnabled
          ? ((o.value = !0), (t === void 0 ? !a.isFullscreen : t) ? a.request() : a.exit())
          : console.error(`browser does not support screenfull!`);
      },
      c = () => {
        a &&
          a.isEnabled &&
          a.on(`change`, () => {
            (o.value || t.value.fullscreen) && ((o.value = !1), n(`fullscreen`));
          });
      },
      l = () => {
        ((a = window.screenfull), c());
      };
    return (
      Qe(() => {
        (c(),
          a ||
            uO(
              `script`,
              {
                ...i.screenfull?.js,
                src: r.screenfull.js,
                id: Rj.screenfull,
                onload: l,
              },
              `screenfull`,
            ));
      }),
      Qe(() => {
        nO.on(e, {
          name: ID,
          callback: s,
        });
      }),
      {
        fullscreenHandler: s,
      }
    );
  },
  BG = 0,
  VG = () => {
    let e = R(`editorId`),
      t = R(`theme`),
      n = R(`previewTheme`),
      r = R(`language`),
      i = R(`disabled`),
      a = R(`noUploadImg`),
      o = R(`noPrettier`),
      s = R(`codeTheme`),
      c = R(`showToolbarName`),
      l = R(`setting`),
      u = R(`defToolbars`);
    return {
      barRender: (d) => {
        if (DD.includes(d))
          switch (d) {
            case `-`:
              return N(
                rG,
                {
                  key: `bar-${BG++}`,
                },
                null,
              );
            case `bold`:
              return N(
                iG,
                {
                  key: `bar-bold`,
                },
                null,
              );
            case `underline`:
              return N(
                LG,
                {
                  key: `bar-unorderline`,
                },
                null,
              );
            case `italic`:
              return N(
                _G,
                {
                  key: `bar-italic`,
                },
                null,
              );
            case `strikeThrough`:
              return N(
                AG,
                {
                  key: `bar-strikeThrough`,
                },
                null,
              );
            case `title`:
              return N(
                IG,
                {
                  key: `bar-title`,
                },
                null,
              );
            case `sub`:
              return N(
                jG,
                {
                  key: `bar-sub`,
                },
                null,
              );
            case `sup`:
              return N(
                MG,
                {
                  key: `bar-sup`,
                },
                null,
              );
            case `quote`:
              return N(
                DG,
                {
                  key: `bar-quote`,
                },
                null,
              );
            case `unorderedList`:
              return N(
                RG,
                {
                  key: `bar-unorderedList`,
                },
                null,
              );
            case `orderedList`:
              return N(
                SG,
                {
                  key: `bar-orderedList`,
                },
                null,
              );
            case `task`:
              return N(
                FG,
                {
                  key: `bar-task`,
                },
                null,
              );
            case `codeRow`:
              return N(
                sG,
                {
                  key: `bar-codeRow`,
                },
                null,
              );
            case `code`:
              return N(
                oG,
                {
                  key: `bar-code`,
                },
                null,
              );
            case `link`:
              return N(
                yG,
                {
                  key: `bar-link`,
                },
                null,
              );
            case `image`:
              return a
                ? N(
                    dG,
                    {
                      key: `bar-image`,
                    },
                    null,
                  )
                : N(
                    gG,
                    {
                      key: `bar-imageDropdown`,
                    },
                    null,
                  );
            case `table`:
              return N(
                PG,
                {
                  key: `bar-table`,
                },
                null,
              );
            case `revoke`:
              return N(
                OG,
                {
                  key: `bar-revoke`,
                },
                null,
              );
            case `next`:
              return N(
                xG,
                {
                  key: `bar-next`,
                },
                null,
              );
            case `save`:
              return N(
                kG,
                {
                  key: `bar-save`,
                },
                null,
              );
            case `prettier`:
              return (
                !o &&
                N(
                  wG,
                  {
                    key: `bar-prettier`,
                  },
                  null,
                )
              );
            case `pageFullscreen`:
              return (
                !l.value.fullscreen &&
                N(
                  CG,
                  {
                    key: `bar-pageFullscreen`,
                  },
                  null,
                )
              );
            case `fullscreen`:
              return N(
                cG,
                {
                  key: `bar-fullscreen`,
                },
                null,
              );
            case `catalog`:
              return N(
                aG,
                {
                  key: `bar-catalog`,
                },
                null,
              );
            case `preview`:
              return N(
                TG,
                {
                  key: `bar-preview`,
                },
                null,
              );
            case `previewOnly`:
              return N(
                EG,
                {
                  key: `bar-previewOnly`,
                },
                null,
              );
            case `htmlPreview`:
              return N(
                uG,
                {
                  key: `bar-htmlPreview`,
                },
                null,
              );
            case `github`:
              return N(
                lG,
                {
                  key: `bar-github`,
                },
                null,
              );
            case `mermaid`:
              return N(
                bG,
                {
                  key: `bar-mermaid`,
                },
                null,
              );
            case `katex`:
              return N(
                vG,
                {
                  key: `bar-katex`,
                },
                null,
              );
          }
        else if (u.value instanceof Array) {
          let a = u.value[d];
          return a
            ? ye(a, {
                theme: a.props?.theme || t.value,
                previewTheme: a.props?.theme || n.value,
                language: a.props?.theme || r.value,
                codeTheme: a.props?.codeTheme || s.value,
                disabled: a.props?.disabled || i.value,
                showToolbarName: a.props?.showToolbarName || c.value,
                insert(t) {
                  nO.emit(e, GD, `universal`, {
                    generate: t,
                  });
                },
              })
            : ``;
        } else if (u.value?.children instanceof Array) {
          let a = u.value.children[d];
          return a
            ? ye(a, {
                theme: a.props?.theme || t.value,
                previewTheme: a.props?.theme || n.value,
                language: a.props?.theme || r.value,
                codeTheme: a.props?.codeTheme || s.value,
                disabled: a.props?.disabled || i.value,
                showToolbarName: a.props?.showToolbarName || c.value,
                insert(t) {
                  nO.emit(e, GD, `universal`, {
                    generate: t,
                  });
                },
              })
            : ``;
        } else return ``;
      },
    };
  },
  HG = k({
    name: `FloatingToolbar`,
    setup() {
      let e = R(`floatingToolbars`),
        { barRender: t } = VG();
      return () =>
        N(
          `div`,
          {
            class: `${$}-floating-toolbar`,
          },
          [e.value.map((e) => t(e))],
        );
    },
  }),
  UG = Wt.define(),
  WG = jt.define({
    create() {
      return null;
    },
    update(e, t) {
      for (let n of t.effects) n.is(UG) && (e = n.value);
      return e;
    },
    provide: (e) => nn.from(e),
  }),
  GG = (e) => {
    let t = null,
      n = (n, r) => {
        (t && t.kind === r.kind && t.pos === r.pos) ||
          ((t = r),
          n.dispatch({
            effects: UG.of({
              pos: r.pos,
              above: !0,
              arrow: !0,
              create: () => {
                let t = document.createElement(`div`);
                (t.classList.add(`md-editor-floating-toolbar-container`),
                  (t.dataset.state = `hidden`),
                  requestAnimationFrame(() => {
                    t.dataset.state = `visible`;
                  }));
                let n = document.createElement(`div`);
                t.appendChild(n);
                let r = be(HG);
                return (
                  e.privide(r),
                  r.mount(t),
                  {
                    dom: t,
                    destroy: () => r.unmount(),
                  }
                );
              },
            }),
          }));
      },
      r = (e) => {
        t &&
          ((t = null),
          e.dispatch({
            effects: UG.of(null),
          }));
      };
    return [
      WG,
      Et.updateListener.of((e) => {
        if (e.selectionSet || e.docChanged) {
          let t = e.state,
            i = t.selection.main;
          if (!i.empty)
            n(e.view, {
              kind: `selection`,
              pos: i.anchor,
            });
          else {
            let a = i.head,
              o = t.doc.lineAt(a);
            /^\s*$/.test(o.text)
              ? n(e.view, {
                  kind: `emptyLine`,
                  pos: a,
                })
              : r(e.view);
          }
        }
      }),
    ];
  },
  KG = `#e5c07b`,
  qG = `var(--md-color)`,
  JG = `#56b6c2`,
  YG = `#fff`,
  XG = `#3f4a54`,
  ZG = `#2d8cf0`,
  QG = `#2d8cf0`,
  $G = `#3f4a54`,
  eK = `#d19a66`,
  tK = `#c678dd`,
  nK = `#f6f6f6`,
  rK = `#ceedfa33`,
  iK = `var(--md-bk-color)`,
  aK = `var(--md-bk-color)`,
  oK = `#bad5fa`,
  sK = `#3f4a54`,
  cK = [
    Et.theme({
      "&": {
        color: XG,
        backgroundColor: iK,
      },
      ".cm-content": {
        caretColor: sK,
      },
      ".cm-cursor, .cm-dropCursor": {
        borderLeftColor: sK,
      },
      "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection":
        {
          backgroundColor: oK,
        },
      ".cm-panels": {
        backgroundColor: nK,
        color: XG,
      },
      ".cm-panels.cm-panels-top": {
        borderBottom: `1px solid var(--md-border-color)`,
      },
      ".cm-panels.cm-panels-bottom": {
        borderTop: `1px solid var(--md-border-color)`,
      },
      ".cm-searchMatch": {
        backgroundColor: `#72a1ff59`,
        outline: `1px solid #457dff`,
      },
      ".cm-searchMatch.cm-searchMatch-selected": {
        backgroundColor: `#6199ff2f`,
      },
      ".cm-activeLine": {
        backgroundColor: `#ceedfa33`,
      },
      ".cm-selectionMatch": {
        backgroundColor: `#aafe661a`,
      },
      "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: `#bad0f847`,
      },
      ".cm-gutters": {
        backgroundColor: iK,
        color: XG,
        borderRight: `1px solid`,
        borderColor: `var(--md-border-color)`,
      },
      ".cm-activeLineGutter": {
        backgroundColor: rK,
      },
      ".cm-foldPlaceholder": {
        backgroundColor: `transparent`,
        border: `none`,
        color: `#ddd`,
      },
      ".cm-tooltip": {
        border: `1px solid var(--md-border-color)`,
        backgroundColor: aK,
      },
      ".cm-tooltip .cm-tooltip-arrow:before": {
        borderTopColor: `var(--md-border-color)`,
        borderBottomColor: `var(--md-border-color)`,
      },
      ".cm-tooltip .cm-tooltip-arrow:after": {
        borderTopColor: aK,
        borderBottomColor: aK,
      },
      ".cm-tooltip-autocomplete": {
        "& > ul > li[aria-selected]": {
          color: XG,
        },
      },
    }),
    Xt(
      Mt.define([
        {
          tag: G.keyword,
          color: tK,
        },
        {
          tag: [G.name, G.deleted, G.character, G.propertyName, G.macroName],
          color: qG,
        },
        {
          tag: [G.function(G.variableName), G.labelName],
          color: QG,
        },
        {
          tag: [G.color, G.constant(G.name), G.standard(G.name)],
          color: eK,
        },
        {
          tag: [G.definition(G.name), G.separator],
          color: XG,
        },
        {
          tag: [
            G.typeName,
            G.className,
            G.number,
            G.changed,
            G.annotation,
            G.modifier,
            G.self,
            G.namespace,
          ],
          color: KG,
        },
        {
          tag: [
            G.operator,
            G.operatorKeyword,
            G.url,
            G.escape,
            G.regexp,
            G.link,
            G.special(G.string),
          ],
          color: JG,
        },
        {
          tag: [G.meta, G.comment],
          color: ZG,
        },
        {
          tag: G.strong,
          fontWeight: `bold`,
        },
        {
          tag: G.emphasis,
          fontStyle: `italic`,
        },
        {
          tag: G.strikethrough,
          textDecoration: `line-through`,
        },
        {
          tag: G.link,
          color: ZG,
          textDecoration: `underline`,
        },
        {
          tag: G.heading,
          fontWeight: `bold`,
          color: qG,
        },
        {
          tag: [G.atom, G.bool, G.special(G.variableName)],
          color: eK,
        },
        {
          tag: [G.processingInstruction, G.string, G.inserted],
          color: $G,
        },
        {
          tag: G.invalid,
          color: YG,
        },
      ]),
    ),
  ],
  lK = `#e5c07b`,
  uK = `var(--md-color)`,
  dK = `#56b6c2`,
  fK = `#ffffff`,
  pK = `var(--md-color)`,
  mK = `#e5c07b`,
  hK = `#e5c07b`,
  gK = `var(--md-color)`,
  _K = `#d19a66`,
  vK = `#c678dd`,
  yK = `#21252b`,
  bK = `#2c313a`,
  xK = `var(--md-bk-color)`,
  SK = `var(--md-bk-color)`,
  CK = `#ceedfa33`,
  wK = `#528bff`,
  TK = [
    Et.theme(
      {
        "&": {
          color: pK,
          backgroundColor: xK,
        },
        ".cm-content": {
          caretColor: wK,
        },
        ".cm-cursor, .cm-dropCursor": {
          borderLeftColor: wK,
        },
        "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection":
          {
            backgroundColor: CK,
          },
        ".cm-panels": {
          backgroundColor: yK,
          color: pK,
        },
        ".cm-panels.cm-panels-top": {
          borderBottom: `1px solid var(--md-border-color)`,
        },
        ".cm-panels.cm-panels-bottom": {
          borderTop: `1px solid var(--md-border-color)`,
        },
        ".cm-searchMatch": {
          backgroundColor: `#72a1ff59`,
          outline: `1px solid #457dff`,
        },
        ".cm-searchMatch.cm-searchMatch-selected": {
          backgroundColor: `#6199ff2f`,
        },
        ".cm-activeLine": {
          backgroundColor: `#ceedfa33`,
        },
        ".cm-selectionMatch": {
          backgroundColor: `#aafe661a`,
        },
        "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
          backgroundColor: `#bad0f847`,
        },
        ".cm-gutters": {
          backgroundColor: xK,
          color: pK,
          borderRight: `1px solid`,
          borderColor: `var(--md-border-color)`,
        },
        ".cm-activeLineGutter": {
          backgroundColor: bK,
        },
        ".cm-foldPlaceholder": {
          backgroundColor: `transparent`,
          border: `none`,
          color: `#ddd`,
        },
        ".cm-tooltip": {
          border: `1px solid var(--md-border-color)`,
          backgroundColor: SK,
        },
        ".cm-tooltip .cm-tooltip-arrow:before": {
          borderTopColor: `var(--md-border-color)`,
          borderBottomColor: `var(--md-border-color)`,
        },
        ".cm-tooltip .cm-tooltip-arrow:after": {
          borderTopColor: SK,
          borderBottomColor: SK,
        },
        ".cm-tooltip-autocomplete": {
          "& > ul > li[aria-selected]": {
            color: pK,
          },
        },
      },
      {
        dark: !0,
      },
    ),
    Xt(
      Mt.define([
        {
          tag: G.keyword,
          color: vK,
        },
        {
          tag: [G.name, G.deleted, G.character, G.propertyName, G.macroName],
          color: uK,
        },
        {
          tag: [G.function(G.variableName), G.labelName],
          color: hK,
        },
        {
          tag: [G.color, G.constant(G.name), G.standard(G.name)],
          color: _K,
        },
        {
          tag: [G.definition(G.name), G.separator],
          color: pK,
        },
        {
          tag: [
            G.typeName,
            G.className,
            G.number,
            G.changed,
            G.annotation,
            G.modifier,
            G.self,
            G.namespace,
          ],
          color: lK,
        },
        {
          tag: [
            G.operator,
            G.operatorKeyword,
            G.url,
            G.escape,
            G.regexp,
            G.link,
            G.special(G.string),
          ],
          color: dK,
        },
        {
          tag: [G.meta, G.comment],
          color: mK,
        },
        {
          tag: G.strong,
          fontWeight: `bold`,
        },
        {
          tag: G.emphasis,
          fontStyle: `italic`,
        },
        {
          tag: G.strikethrough,
          textDecoration: `line-through`,
        },
        {
          tag: G.link,
          color: mK,
          textDecoration: `underline`,
        },
        {
          tag: G.heading,
          fontWeight: `bold`,
          color: uK,
        },
        {
          tag: [G.atom, G.bool, G.special(G.variableName)],
          color: _K,
        },
        {
          tag: [G.processingInstruction, G.string, G.inserted],
          color: gK,
        },
        {
          tag: G.invalid,
          color: fK,
        },
      ]),
    ),
  ],
  EK = (e, t) => {
    let n = R(`editorId`),
      r = (e) => {
        e instanceof Promise
          ? e
              .then((e) => {
                nO.emit(n, GD, `universal`, {
                  generate() {
                    return {
                      targetValue: e,
                    };
                  },
                });
              })
              .catch((e) => {
                console.error(e);
              })
          : nO.emit(n, GD, `universal`, {
              generate() {
                return {
                  targetValue: e,
                };
              },
            });
      };
    return (i) => {
      if (!i.clipboardData) return;
      if (i.clipboardData.files.length > 0) {
        let { files: e } = i.clipboardData;
        (nO.emit(
          n,
          KD,
          Array.from(e).filter((e) => /image\/.*/.test(e.type)),
        ),
          i.preventDefault());
        return;
      }
      let a = i.clipboardData.getData(`text/plain`),
        o = t.value?.view.state.selection.main.to || 0,
        s = t.value?.view.state.doc.lineAt(o).from || 0,
        c = t.value?.view.state.doc.sliceString(s, o) || ``,
        l = /!\[.*\]\(\s*$/.test(c),
        u = /!\[.*\]\((.*)\s?.*\)/.test(a);
      if (l) {
        (r(e.transformImgUrl(a)), i.preventDefault());
        return;
      } else if (u) {
        let t = a.match(RegExp(`(?<=!\\[.*\\]\\()([^)\\s]+)(?=\\s?["']?.*["']?\\))`, `g`));
        (t
          ? Promise.all(t.map((t) => e.transformImgUrl(t)))
              .then((e) => {
                r(e.reduce((e, n, r) => e.replace(t[r], n), a));
              })
              .catch((e) => {
                console.error(e);
              })
          : r(a),
          i.preventDefault());
        return;
      }
      if (e.autoDetectCode && i.clipboardData.types.includes(`vscode-editor-data`)) {
        let e = JSON.parse(i.clipboardData.getData(`vscode-editor-data`));
        (nO.emit(n, GD, `code`, {
          mode: e.mode,
          text: i.clipboardData.getData(`text/plain`),
        }),
          i.preventDefault());
        return;
      }
      e.maxlength &&
        a.length + e.modelValue.length > e.maxlength &&
        nO.emit(n, `errorCatcher`, {
          name: `overlength`,
          message: `The input text is too long`,
          data: a,
        });
    };
  },
  DK = (e, t) => [
    {
      key: `Ctrl-b`,
      mac: `Cmd-b`,
      run: () => (nO.emit(e, GD, `bold`), !0),
    },
    {
      key: `Ctrl-d`,
      mac: `Cmd-d`,
      run: qF,
      preventDefault: !0,
    },
    {
      key: `Ctrl-s`,
      mac: `Cmd-s`,
      run: (t) => (nO.emit(e, PD, t.state.doc.toString()), !0),
      shift: () => (nO.emit(e, GD, `strikeThrough`), !0),
    },
    {
      key: `Ctrl-u`,
      mac: `Cmd-u`,
      preventDefault: !0,
      run: () => (nO.emit(e, GD, `underline`), !0),
      shift: () => (nO.emit(e, GD, `unorderedList`), !0),
    },
    {
      key: `Ctrl-i`,
      mac: `Cmd-i`,
      preventDefault: !0,
      run: () => (nO.emit(e, GD, `italic`), !0),
      shift: () => (nO.emit(e, GD, `image`), !0),
    },
    {
      key: `Ctrl-1`,
      mac: `Cmd-1`,
      run: () => (nO.emit(e, GD, `h1`), !0),
    },
    {
      key: `Ctrl-2`,
      mac: `Cmd-2`,
      run: () => (nO.emit(e, GD, `h2`), !0),
    },
    {
      key: `Ctrl-3`,
      mac: `Cmd-3`,
      run: () => (nO.emit(e, GD, `h3`), !0),
    },
    {
      key: `Ctrl-4`,
      mac: `Cmd-4`,
      run: () => (nO.emit(e, GD, `h4`), !0),
    },
    {
      key: `Ctrl-5`,
      mac: `Cmd-5`,
      run: () => (nO.emit(e, GD, `h5`), !0),
    },
    {
      key: `Ctrl-6`,
      mac: `Cmd-6`,
      run: () => (nO.emit(e, GD, `h6`), !0),
    },
    {
      key: `Ctrl-ArrowUp`,
      mac: `Cmd-ArrowUp`,
      run: () => (nO.emit(e, GD, `sup`), !0),
    },
    {
      key: `Ctrl-ArrowDown`,
      mac: `Cmd-ArrowDown`,
      run: () => (nO.emit(e, GD, `sub`), !0),
    },
    {
      key: `Ctrl-o`,
      mac: `Cmd-o`,
      run: () => (nO.emit(e, GD, `orderedList`), !0),
    },
    {
      key: `Ctrl-c`,
      mac: `Cmd-c`,
      shift: () => (nO.emit(e, GD, `code`), !0),
      any(t, n) {
        return (n.ctrlKey || n.metaKey) && n.altKey && n.code === `KeyC`
          ? (nO.emit(e, GD, `codeRow`), !0)
          : !1;
      },
    },
    {
      key: `Ctrl-l`,
      mac: `Cmd-l`,
      run: () => (nO.emit(e, GD, `link`), !0),
    },
    {
      key: `Ctrl-f`,
      mac: `Cmd-f`,
      shift: () => (t.noPrettier ? !1 : (nO.emit(e, GD, `prettier`), !0)),
    },
    {
      any: (t, n) =>
        (n.ctrlKey || n.metaKey) && n.altKey && n.shiftKey && n.code === `KeyT`
          ? (nO.emit(e, GD, `table`), !0)
          : !1,
    },
    ...OW,
  ],
  OK = RegExp(
    `([a-z][a-z0-9.+-]*:\\/\\/[^\\s<>"'\`()]+(?:\\([^\\s<>"'\`]*\\)[^\\s<>"'\`]*)*|\\/\\/[^\\s<>"'\`()]+|data:[a-z]+\\/[a-z0-9.+-]+(?:;base64)?,[a-z0-9+/=%]+|\\/(?!\\/)[^\\s<>"'\`()]+)`,
    `gi`,
  ),
  kK = /[a-z0-9.+-]/i,
  AK = (e) => {
    let t = [];
    OK.lastIndex = 0;
    let n;
    for (; (n = OK.exec(e));) {
      let r = n.index ?? 0,
        i = r > 0 ? e[r - 1] : ``;
      if ((i && kK.test(i)) || (i === `<` && e[r] === `/`)) continue;
      let a = r + n[0].length;
      t.push([r, a]);
    }
    return t;
  },
  jK = (e, t, n) => e.some((e) => e.from === t && e.to === n),
  MK = (e) => {
    let t = e.shortenText || (() => `...`),
      n = Wt.define(),
      r = Wt.define(),
      i = (n, r) => {
        let i = new en(),
          o = [];
        for (let s = 1; s <= n.doc.lines; s++) {
          let c = n.doc.line(s),
            l = c.text;
          OK.lastIndex = 0;
          let u =
            e.findTexts?.({
              state: n,
              lineText: l,
              lineNumber: c.number,
              lineFrom: c.from,
              lineTo: c.to,
              defaultTextRegex: OK,
            }) ?? AK(l);
          for (let n of u) {
            if (!n) continue;
            let [s, u] = n;
            if (
              typeof s != `number` ||
              typeof u != `number` ||
              s < 0 ||
              u <= s ||
              s >= l.length ||
              u > l.length
            )
              continue;
            let d = l.slice(s, u);
            if (!d || d.length <= e.maxLength) continue;
            let f = c.from + s,
              p = c.from + u;
            if (jK(r, f, p)) {
              o.push({
                from: f,
                to: p,
              });
              continue;
            }
            let m = t(d);
            i.add(
              f,
              p,
              ut.replace({
                widget: new a(m, d, f, p),
              }),
            );
          }
        }
        return {
          deco: i.finish(),
          expanded: o,
        };
      };
    class a extends pt {
      constructor(e, t, n, r) {
        (super(), (this.short = e), (this.raw = t), (this.from = n), (this.to = r));
      }
      toDOM(e) {
        let t = document.createElement(`span`);
        return (
          (t.textContent = this.short),
          (t.className = `cm-short-text`),
          (t.title = this.raw),
          (t.style.display = `inline`),
          (t.style.textDecoration = `underline`),
          t.addEventListener(`mousedown`, (t) => {
            (t.preventDefault(),
              t.stopPropagation(),
              e.dispatch({
                selection: Qt.cursor(this.from),
                effects: n.of({
                  from: this.from,
                  to: this.to,
                  expand: !0,
                }),
              }),
              e.focus());
          }),
          t.addEventListener(`click`, (e) => {
            e.preventDefault();
          }),
          t
        );
      }
      ignoreEvent() {
        return !1;
      }
      eq(e) {
        return (
          this.short === e.short && this.raw === e.raw && this.from === e.from && this.to === e.to
        );
      }
    }
    let o = jt.define({
      create(e) {
        return i(e, []);
      },
      update(e, t) {
        let a = e.expanded;
        t.docChanged &&
          a.length &&
          (a = a
            .map(({ from: e, to: n }) => ({
              from: t.changes.mapPos(e, 1),
              to: t.changes.mapPos(n, -1),
            }))
            .filter(({ from: e, to: t }) => e < t));
        let o = a !== e.expanded;
        for (let e of t.effects)
          e.is(n)
            ? (a = e.value.expand
                ? [
                    {
                      from: e.value.from,
                      to: e.value.to,
                    },
                  ]
                : a.filter(({ from: t, to: n }) => t !== e.value.from || n !== e.value.to))
            : e.is(r) && a.length > 0 && (a = []);
        return (!o && a !== e.expanded && (o = !0), t.docChanged || o ? i(t.state, a) : e);
      },
      provide: (e) => Et.decorations.compute([e], (t) => t.field(e).deco),
    });
    return [
      o,
      Et.domEventHandlers({
        mousedown(e, t) {
          let n = t.state.field(o, !1);
          if (!n || n.expanded.length === 0) return !1;
          let i = e.target;
          if (i && t.dom.contains(i)) {
            let e = t.posAtDOM(i, 0);
            if (e != null && e !== -1 && n.expanded.some(({ from: t, to: n }) => e >= t && e <= n))
              return !1;
          }
          return (
            t.dispatch({
              effects: r.of(void 0),
            }),
            !1
          );
        },
      }),
    ];
  };
Et.EDIT_CONTEXT = !1;
var NK = (e) => (e.extension instanceof Function ? e.extension(e.options) : e.extension),
  PK = (e) => {
    let t = NK(e);
    return e.compartment ? e.compartment.of(t) : t;
  },
  FK = (e) => {
    let t = R(`tabWidth`),
      n = R(`editorId`),
      r = R(`theme`),
      i = R(`previewTheme`),
      a = R(`language`),
      o = R(`usedLanguageText`),
      s = R(`disabled`),
      c = R(`showToolbarName`),
      l = R(`customIcon`),
      u = R(`noUploadImg`),
      d = R(`tableShape`),
      f = R(`noPrettier`),
      p = R(`codeTheme`),
      m = R(`setting`),
      h = R(`updateSetting`),
      g = R(`catalogVisible`),
      v = R(`defToolbars`),
      y = R(`floatingToolbars`),
      b = R(`rootRef`),
      x = F(),
      S = xe(),
      C = F(!1),
      w = new Lt(),
      T = new Lt(),
      E = new Lt(),
      D = new Lt(),
      ee = new Lt(),
      te = DK(n, {
        noPrettier: f,
      }),
      O = () => [...te, ...aI, ..._P, oI],
      k = {
        paste: EK(e, S),
        blur: e.onBlur,
        focus: e.onFocus,
        drop: e.onDrop,
        compositionstart: () => {
          C.value = !0;
        },
        compositionend: (t, n) => {
          ((C.value = !1), e.updateModelValue(n.state.doc.toString()));
        },
        input: (t) => {
          e.onInput && e.onInput(t);
          let { data: r } = t;
          e.maxlength &&
            e.modelValue.length + r.length > e.maxlength &&
            nO.emit(n, `errorCatcher`, {
              name: `overlength`,
              message: `The input text is too long`,
              data: r,
            });
        },
      },
      ne = GG({
        privide(e) {
          (e.provide(`editorId`, n),
            e.provide(`theme`, r),
            e.provide(`previewTheme`, i),
            e.provide(`language`, a),
            e.provide(`disabled`, s),
            e.provide(`noUploadImg`, u),
            e.provide(`tableShape`, d),
            e.provide(`noPrettier`, f),
            e.provide(`codeTheme`, p),
            e.provide(`showToolbarName`, c),
            e.provide(`setting`, m),
            e.provide(`updateSetting`, h),
            e.provide(`usedLanguageText`, o),
            e.provide(`catalogVisible`, g),
            e.provide(`defToolbars`, v),
            e.provide(`tabWidth`, t),
            e.provide(`customIcon`, l),
            e.provide(`floatingToolbars`, y),
            e.provide(`rootRef`, b));
        },
      }),
      re = [
        {
          type: `theme`,
          extension: ({ theme: e }) => (e.value === `light` ? cK : TK),
          compartment: w,
          options: {
            theme: r,
          },
        },
        {
          type: `updateListener`,
          extension: Et.updateListener.of((t) => {
            t.docChanged &&
              (e.onChange(t.state.doc.toString()),
              C.value || e.updateModelValue(t.state.doc.toString()));
          }),
        },
        {
          type: `domEventHandlers`,
          extension: Et.domEventHandlers(k),
          compartment: D,
        },
        {
          type: `completions`,
          extension: nG(e.completions),
          compartment: T,
        },
        {
          type: `history`,
          extension: QN(),
          compartment: E,
        },
      ],
      A = AD.codeMirrorExtensions(
        [
          {
            type: `lineWrapping`,
            extension: Et.lineWrapping,
          },
          {
            type: `keymap`,
            extension: Dt.of(O()),
          },
          {
            type: `drawSelection`,
            extension: cn(),
          },
          {
            type: `markdown`,
            extension: EU({
              codeLanguages: PU,
            }),
          },
          {
            type: `linkShortener`,
            extension: (e) => MK(e),
            options: {
              maxLength: 30,
            },
          },
          {
            type: `floatingToolbar`,
            extension: y.value.length > 0 ? ne : [],
            compartment: ee,
          },
        ],
        {
          editorId: n,
          theme: r.value,
          keyBindings: O(),
        },
      ),
      ie = () => [...re, ...A].map(PK);
    return (
      Qe(() => {
        let r = new Et({
            doc: e.modelValue,
            parent: x.value,
            extensions: ie(),
          }),
          i = new ZW(r);
        ((S.value = i),
          setTimeout(() => {
            (i.setTabSize(t),
              i.setDisabled(s.value),
              i.setReadOnly(e.readonly),
              e.placeholder && i.setPlaceholder(e.placeholder),
              typeof e.maxlength == `number` && i.setMaxLength(e.maxlength),
              e.autofocus && r.focus());
          }, 0),
          nO.on(n, {
            name: qD,
            callback() {
              eP(r);
            },
          }),
          nO.on(n, {
            name: JD,
            callback() {
              tP(r);
            },
          }),
          nO.on(n, {
            name: GD,
            async callback(t, r = {}) {
              if (t === `image` && r.transform) {
                let i = e.transformImgUrl(r.url);
                if (i instanceof Promise)
                  i.then(async (e) => {
                    let { text: i, options: a } = await LW(t, S.value, {
                      ...r,
                      url: e,
                    });
                    S.value?.replaceSelectedText(i, a, n);
                  }).catch((e) => {
                    console.error(e);
                  });
                else {
                  let { text: e, options: a } = await LW(t, S.value, {
                    ...r,
                    url: i,
                  });
                  S.value?.replaceSelectedText(e, a, n);
                }
              } else {
                let { text: e, options: i } = await LW(t, S.value, r);
                S.value?.replaceSelectedText(e, i, n);
              }
            },
          }),
          nO.on(n, {
            name: QD,
            callback: Aae((e) => {
              let t = {
                  ...k,
                },
                n = Object.keys(k);
              for (let r in e) {
                let i = r;
                n.includes(i)
                  ? (t[i] = (t, n) => {
                      (e[i](t, n), t.defaultPrevented || k[i](t, n));
                    })
                  : (t[i] = e[i]);
              }
              S.value?.view.dispatch({
                effects: D.reconfigure(Et.domEventHandlers(t)),
              });
            }),
          }),
          nO.on(n, {
            name: $D,
            callback: (e, t) => {
              let n = r.state.doc.line(e);
              r.dispatch(
                r.state.update({
                  changes: {
                    from: n.from,
                    to: n.to,
                    insert: t,
                  },
                }),
              );
            },
          }),
          nO.on(n, {
            name: eO,
            callback() {
              nO.emit(n, tO, r);
            },
          }),
          nO.emit(n, tO, r));
      }),
      He(
        r,
        () => {
          S.value?.view.dispatch({
            effects: w.reconfigure(r.value === `light` ? cK : TK),
          });
        },
        {
          deep: !0,
        },
      ),
      He(
        () => e.completions,
        () => {
          S.value?.view.dispatch({
            effects: T.reconfigure(nG(e.completions)),
          });
        },
        {
          deep: !0,
        },
      ),
      He(
        () => e.modelValue,
        () => {
          S.value?.getValue() !== e.modelValue && S.value?.setValue(e.modelValue);
        },
      ),
      He(
        () => e.placeholder,
        () => {
          S.value?.setPlaceholder(e.placeholder);
        },
      ),
      He([s], () => {
        S.value?.setDisabled(s.value);
      }),
      He(
        () => e.readonly,
        () => {
          S.value?.setDisabled(e.readonly);
        },
      ),
      He(
        () => e.maxlength,
        () => {
          e.maxlength && S.value?.setMaxLength(e.maxlength);
        },
      ),
      $W(() => {
        let e = A.find((e) => e.type === `floatingToolbar`);
        e?.compartment &&
          (y.value.length > 0
            ? S.value?.view.dispatch({
                effects: e.compartment.reconfigure(NK(e)),
              })
            : S.value?.view.dispatch({
                effects: e.compartment.reconfigure([]),
              }));
      }, y),
      {
        inputWrapperRef: x,
        codeMirrorUt: S,
        resetHistory() {
          (S.value?.view.dispatch({
            effects: E.reconfigure([]),
          }),
            S.value?.view.dispatch({
              effects: E.reconfigure(QN()),
            }));
        },
      }
    );
  },
  IK = (e, t, n) => {
    let r = R(`setting`),
      i = V(() => (/px$/.test(`${e.inputBoxWidth}`) ? `50%` : e.inputBoxWidth)),
      a = Ae({
        resizedWidth: i.value,
      }),
      o = Ae({
        width: i.value,
      }),
      s = Ae({
        insetInlineStart: i.value,
        display: `initial`,
      }),
      c = (n) => {
        let r = t.value?.offsetWidth || 0,
          i = t.value?.getBoundingClientRect().x || 0,
          c = n.x - i;
        c / r < 0.1 ? (c = r * Vae) : c > r - r * 0.1 && (c = r - r * 0.1);
        let l = `${(c / r) * 100}%`;
        ((o.width = l),
          (s.insetInlineStart = l),
          (a.resizedWidth = l),
          e.oninputBoxWidthChange?.(l));
      },
      l = (e) => {
        e.target === n.value && document.addEventListener(`mousemove`, c);
      },
      u = () => {
        document.removeEventListener(`mousemove`, c);
      };
    return (
      He([n], () => {
        (document.removeEventListener(`mousedown`, l),
          document.removeEventListener(`mouseup`, u),
          document.addEventListener(`mousedown`, l),
          document.addEventListener(`mouseup`, u));
      }),
      Qe(() => {
        (document.addEventListener(`mousedown`, l), document.addEventListener(`mouseup`, u));
      }),
      oe(() => {
        (document.removeEventListener(`mousedown`, l), document.removeEventListener(`mouseup`, u));
      }),
      He([i], ([e]) => {
        ((a.resizedWidth = e), (o.width = e), (s.insetInlineStart = e));
      }),
      He(
        [() => r.value.htmlPreview, () => r.value.preview, () => r.value.previewOnly],
        () => {
          r.value.previewOnly
            ? ((o.width = `0%`), (s.display = `none`))
            : !r.value.htmlPreview && !r.value.preview
              ? ((o.width = `100%`), (s.display = `none`))
              : ((o.width = a.resizedWidth), (s.display = `initial`));
        },
        {
          immediate: !0,
        },
      ),
      {
        inputWrapperStyle: o,
        resizeOperateStyle: s,
      }
    );
  },
  LK = () => {
    let e = R(`editorId`),
      t = F(!0),
      n = yD();
    return {
      onCatalogActive: (r, i) => {
        let a = document.querySelector(`#${e} .${$}-catalog-editor`);
        if (!i || !t.value || !a) return;
        let o = i.offsetTop - a.scrollTop;
        (o > 100 || o < 100) && n(a, i.offsetTop - 100);
      },
      onMouseenter: () => (t.value = !1),
      onMouseleave: () => (t.value = !0),
    };
  },
  RK = k({
    name: `${Pae}CustomScrollbar`,
    props: {
      id: {
        type: String,
        default: void 0,
      },
      class: {
        type: [String, Array],
        default: void 0,
      },
      scrollTarget: {
        type: String,
        default: void 0,
      },
      alwaysShowTrack: {
        type: Boolean,
        default: !1,
      },
      onMouseenter: {
        type: Function,
        default: () => {},
      },
      onMouseleave: {
        type: Function,
        default: () => {},
      },
    },
    setup(e, { slots: t }) {
      let n = F(null),
        r = F(null),
        i = F(null),
        a = F(null),
        o = null,
        s = null,
        c = !1,
        l = 0,
        u = 0,
        d = () => {
          if (!r.value || !n.value || !i.value || !a.value) return;
          let t = n.value.clientHeight,
            o = r.value.scrollHeight,
            s = r.value.scrollTop;
          if (o <= t) {
            ((i.value.style.display = `none`),
              e.alwaysShowTrack || (a.value.style.display = `none`));
            return;
          } else ((i.value.style.display = `block`), (a.value.style.display = `block`));
          let c = t / o,
            l = Math.max(t * c, 20),
            u = t - l,
            d = Math.min(s * c, u);
          ((i.value.style.height = `${l}px`), (i.value.style.top = `${d}px`));
        },
        f = () => d(),
        p = (e) => {
          ((c = !0),
            (l = e.clientY),
            (u = r.value.scrollTop),
            (document.body.style.userSelect = `none`));
        },
        m = (e) => {
          if (!c || !r.value || !n.value) return;
          let t = e.clientY - l,
            i = r.value.scrollHeight / n.value.clientHeight;
          r.value.scrollTop = u + t * i;
        },
        h = () => {
          ((c = !1), (document.body.style.userSelect = ``));
        },
        g = (t) => {
          (r.value && r.value.removeEventListener(`scroll`, f),
            (r.value = t),
            r.value
              ? (r.value.addEventListener(`scroll`, f), d())
              : a.value && !e.alwaysShowTrack && (a.value.style.display = `none`));
        },
        v = () => {
          n.value &&
            g(e.scrollTarget ? n.value.querySelector(e.scrollTarget) : n.value.firstElementChild);
        };
      return (
        Qe(async () => {
          (await de(),
            v(),
            (o = new MutationObserver(() => {
              (s && cancelAnimationFrame(s),
                (s = requestAnimationFrame(() => {
                  v();
                })));
            })),
            o.observe(n.value, {
              childList: !0,
              subtree: !0,
            }),
            window.addEventListener(`resize`, d),
            i.value?.addEventListener(`mousedown`, p),
            document.addEventListener(`mousemove`, m),
            document.addEventListener(`mouseup`, h));
        }),
        oe(() => {
          (o?.disconnect(),
            r.value && r.value.removeEventListener(`scroll`, f),
            window.removeEventListener(`resize`, d),
            i.value?.removeEventListener(`mousedown`, p),
            document.removeEventListener(`mousemove`, m),
            document.removeEventListener(`mouseup`, h));
        }),
        () =>
          N(
            `div`,
            {
              id: e.id,
              class: [`${$}-custom-scrollbar`, e.class],
              ref: n,
              onMouseenter: e.onMouseenter,
              onMouseleave: e.onMouseleave,
            },
            [
              t.default?.(),
              N(
                `div`,
                {
                  class: `${$}-custom-scrollbar__track`,
                  ref: a,
                },
                [
                  N(
                    `div`,
                    {
                      class: `${$}-custom-scrollbar__thumb`,
                      ref: i,
                    },
                    null,
                  ),
                ],
              ),
            ],
          )
      );
    },
  }),
  zK = yD(),
  BK = {
    flex: 1,
  },
  VK = k({
    name: `MDEditorContent`,
    props: AM,
    setup(e, t) {
      let n = R(`editorId`),
        r = R(`catalogVisible`),
        i = R(`theme`),
        a = R(`setting`),
        o = F(``),
        s = F(),
        c = F(),
        { inputWrapperRef: l, codeMirrorUt: u, resetHistory: d } = FK(e),
        { inputWrapperStyle: f, resizeOperateStyle: p } = IK(e, s, c);
      IW(e, o, u);
      let { onCatalogActive: m, onMouseenter: h, onMouseleave: g } = LK(),
        v = (e, t) => {
          if (!a.value.preview && t.line !== void 0) {
            e.preventDefault();
            let n = u.value?.view;
            if (n) {
              let e = n.state.doc.line(t.line + 1),
                r = n.lineBlockAt(e.from)?.top,
                i = n.scrollDOM;
              zK(i, r);
            }
          }
        },
        y = V(() => (a.value.preview ? `preview` : `editor`)),
        b = (t) => {
          ((o.value = t), e.onHtmlChanged(t));
        };
      return (
        t.expose({
          getSelectedText() {
            return u.value?.getSelectedText();
          },
          focus(e) {
            u.value?.focus(e);
          },
          resetHistory: d,
          getEditorView() {
            return u.value?.view;
          },
        }),
        () =>
          N(
            `div`,
            {
              class: `${$}-content`,
            },
            [
              N(
                `div`,
                {
                  class: `${$}-content-wrapper`,
                  ref: s,
                },
                [
                  N(
                    RK,
                    {
                      alwaysShowTrack: !0,
                      scrollTarget: `#${n} .cm-scroller`,
                      style: f,
                    },
                    {
                      default: () => [
                        N(
                          `div`,
                          {
                            class: `${$}-input-wrapper`,
                            ref: l,
                          },
                          null,
                        ),
                      ],
                    },
                  ),
                  (a.value.htmlPreview || a.value.preview) &&
                    N(
                      `div`,
                      {
                        class: `md-editor-resize-operate`,
                        style: p,
                        ref: c,
                      },
                      null,
                    ),
                  N(
                    RK,
                    {
                      style: BK,
                    },
                    {
                      default: () => [
                        N(
                          PM,
                          {
                            modelValue: e.modelValue,
                            onChange: e.onChange,
                            onHtmlChanged: b,
                            onGetCatalog: e.onGetCatalog,
                            mdHeadingId: e.mdHeadingId,
                            noMermaid: e.noMermaid,
                            sanitize: e.sanitize,
                            noKatex: e.noKatex,
                            formatCopiedText: e.formatCopiedText,
                            noHighlight: e.noHighlight,
                            noImgZoomIn: e.noImgZoomIn,
                            sanitizeMermaid: e.sanitizeMermaid,
                            codeFoldable: e.codeFoldable,
                            autoFoldThreshold: e.autoFoldThreshold,
                            onRemount: e.onRemount,
                            previewComponent: e.previewComponent,
                            noEcharts: e.noEcharts,
                          },
                          null,
                        ),
                      ],
                    },
                  ),
                ],
              ),
              r.value &&
                N(
                  RK,
                  {
                    class: `md-editor-catalog-${e.catalogLayout}`,
                    onMouseenter: h,
                    onMouseleave: g,
                  },
                  {
                    default: () => [
                      N(
                        oO,
                        {
                          theme: i.value,
                          class: `md-editor-catalog-editor`,
                          editorId: n,
                          mdHeadingId: e.mdHeadingId,
                          key: `internal-catalog`,
                          scrollElementOffsetTop: 2,
                          syncWith: y.value,
                          onClick: v,
                          catalogMaxDepth: e.catalogMaxDepth,
                          onActive: m,
                        },
                        null,
                      ),
                    ],
                  },
                ),
            ],
          )
      );
    },
  }),
  HK = k({
    props: {
      modelValue: {
        type: String,
        default: ``,
      },
    },
    setup(e) {
      let t = R(`usedLanguageText`);
      return () =>
        N(
          `div`,
          {
            class: `${$}-footer-item`,
          },
          [
            N(
              `label`,
              {
                class: `${$}-footer-label`,
              },
              [`${t.value.footer?.markdownTotal}:`],
            ),
            N(`span`, null, [e.modelValue?.length || 0]),
          ],
        );
    },
  }),
  UK = {
    checked: {
      type: Boolean,
      default: !1,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: void 0,
    },
  },
  WK = k({
    name: `${$}-checkbox`,
    props: UK,
    setup(e) {
      return () =>
        N(
          `div`,
          {
            class: [
              `${$}-checkbox`,
              e.checked && `md-editor-checkbox-checked`,
              e.disabled && `md-editor-disabled`,
            ],
            onClick: () => {
              e.disabled || e.onChange(!e.checked);
            },
          },
          null,
        );
    },
  }),
  GK = k({
    props: {
      scrollAuto: {
        type: Boolean,
      },
      onScrollAutoChange: {
        type: Function,
        default: () => {},
      },
    },
    setup(e) {
      let t = R(`usedLanguageText`),
        n = R(`disabled`);
      return () =>
        N(
          `div`,
          {
            class: [`${$}-footer-item`, n?.value && `md-editor-disabled`],
          },
          [
            N(
              `label`,
              {
                class: `${$}-footer-label`,
                onClick: () => {
                  n?.value || e.onScrollAutoChange(!e.scrollAuto);
                },
              },
              [t?.value.footer?.scrollAuto],
            ),
            N(
              WK,
              {
                checked: e.scrollAuto,
                onChange: e.onScrollAutoChange,
                disabled: n?.value,
              },
              null,
            ),
          ],
        );
    },
  }),
  KK = k({
    name: `MDEditorFooter`,
    props: {
      modelValue: {
        type: String,
        default: ``,
      },
      footers: {
        type: Array,
        default: [],
      },
      scrollAuto: {
        type: Boolean,
      },
      noScrollAuto: {
        type: Boolean,
      },
      onScrollAutoChange: {
        type: Function,
        default: () => {},
      },
      defFooters: {
        type: Object,
      },
    },
    setup(e) {
      let t = R(`theme`),
        n = R(`language`),
        r = R(`disabled`),
        i = V(() => {
          let t = e.footers.indexOf(`=`);
          return [
            t === -1 ? e.footers : e.footers.slice(0, t),
            t === -1 ? [] : e.footers.slice(t, 2 ** 53 - 1),
          ];
        }),
        a = (i) => {
          if (OD.includes(i))
            switch (i) {
              case `markdownTotal`:
                return N(
                  HK,
                  {
                    modelValue: e.modelValue,
                  },
                  null,
                );
              case `scrollSwitch`:
                return (
                  !e.noScrollAuto &&
                  N(
                    GK,
                    {
                      scrollAuto: e.scrollAuto,
                      onScrollAutoChange: e.onScrollAutoChange,
                    },
                    null,
                  )
                );
            }
          else if (e.defFooters instanceof Array) {
            let a = e.defFooters[i];
            return a
              ? ye(a, {
                  theme: a.props?.theme || t.value,
                  language: a.props?.language || n.value,
                  disabled: a.props?.disabled || r?.value,
                })
              : ``;
          } else if (e.defFooters && e.defFooters.children instanceof Array) {
            let a = e.defFooters.children[i];
            return a
              ? ye(a, {
                  theme: a.props?.theme || t.value,
                  language: a.props?.language || n.value,
                  disabled: a.props?.disabled || r?.value,
                })
              : ``;
          } else return ``;
        };
      return () => {
        let e = i.value[0].map((e) => a(e)),
          t = i.value[1].map((e) => a(e));
        return N(
          `div`,
          {
            class: `${$}-footer`,
          },
          [
            N(
              `div`,
              {
                class: `${$}-footer-left`,
              },
              [e],
            ),
            N(
              `div`,
              {
                class: `${$}-footer-right`,
              },
              [t],
            ),
          ],
        );
      };
    },
  }),
  qK = k({
    name: `MDEditorToolbar`,
    props: {
      toolbars: {
        type: Array,
        default: () => [],
      },
      toolbarsExclude: {
        type: Array,
        default: () => [],
      },
    },
    setup(e) {
      let t = R(`editorId`),
        n = R(`showToolbarName`),
        r = `${t}-toolbar-wrapper`,
        i = F(),
        a = F(),
        { barRender: o } = VG(),
        s = V(() => {
          let t = e.toolbars.filter((t) => !e.toolbarsExclude.includes(t)),
            n = t.indexOf(`=`);
          return [n === -1 ? t : t.slice(0, n + 1), n === -1 ? [] : t.slice(n, 2 ** 53 - 1)];
        });
      return (
        He(
          () => e.toolbars,
          () => {
            de(() => {
              i.value && jae(i.value);
            });
          },
          {
            immediate: !0,
          },
        ),
        () => {
          let t = s.value[0].map((e) => o(e)),
            c = s.value[1].map((e) => o(e));
          return N(ke, null, [
            e.toolbars.length > 0 &&
              N(
                `div`,
                {
                  class: `md-editor-toolbar-wrapper`,
                  ref: i,
                  id: r,
                },
                [
                  N(
                    `div`,
                    {
                      class: [`md-editor-toolbar`, n.value && `md-editor-stn`],
                    },
                    [
                      N(
                        `div`,
                        {
                          class: `md-editor-toolbar-left`,
                          ref: a,
                        },
                        [t],
                      ),
                      N(
                        `div`,
                        {
                          class: `md-editor-toolbar-right`,
                        },
                        [c],
                      ),
                    ],
                  ),
                ],
              ),
          ]);
        }
      );
    },
  }),
  JK = k({
    name: `MdEditorV3`,
    props: IM,
    emits: RM,
    setup(e, t) {
      let { noKatex: n, noMermaid: r, noHighlight: i } = e,
        a = Ae({
          scrollAuto: e.scrollAuto,
        }),
        o = F(),
        s = F(),
        c = V(() =>
          jD(
            {
              props: e,
              ctx: t,
            },
            `defToolbars`,
          ),
        ),
        l = V(() =>
          jD(
            {
              props: e,
              ctx: t,
            },
            `defFooters`,
          ),
        ),
        u = qj(e),
        [d, f] = Wj(e, t, {
          editorId: u,
        }),
        p = Gj(e, {
          editorId: u,
        });
      (zj(e, t, {
        editorId: u,
      }),
        Hj(e),
        Uj(e, t, {
          editorId: u,
        }),
        Kj(e, t, {
          editorId: u,
          catalogVisible: p,
          setting: d,
          updateSetting: f,
          codeRef: s,
        }),
        Vj(e, {
          rootRef: o,
          editorId: u,
          setting: d,
          updateSetting: f,
          catalogVisible: p,
          defToolbars: c,
        }),
        oe(() => {
          nO.clear(u);
        }));
      let m = (e) => {
          t.emit(`update:modelValue`, e);
        },
        h = (n) => {
          (e.onChange?.(n), t.emit(`onChange`, n));
        },
        g = (n) => {
          (e.onHtmlChanged?.(n), t.emit(`onHtmlChanged`, n));
        },
        v = (n) => {
          (e.onGetCatalog?.(n), t.emit(`onGetCatalog`, n));
        },
        y = (n) => {
          (e.onBlur?.(n), t.emit(`onBlur`, n));
        },
        b = (n) => {
          (e.onFocus?.(n), t.emit(`onFocus`, n));
        },
        x = (n) => {
          (e.onInput?.(n), t.emit(`onInput`, n));
        },
        S = (n) => {
          (e.onDrop?.(n), t.emit(`onDrop`, n));
        },
        C = (n) => {
          (e.oninputBoxWidthChange?.(n), t.emit(`oninputBoxWidthChange`, n));
        },
        w = () => {
          (e.onRemount?.(), t.emit(`onRemount`));
        },
        T = (e) => {
          a.scrollAuto = e;
        };
      return () =>
        N(
          `div`,
          {
            id: u,
            class: [
              $,
              e.class,
              e.theme === `dark` && `md-editor-dark`,
              d.fullscreen || d.pageFullscreen ? `${$}-fullscreen` : ``,
            ],
            style: e.style,
            ref: o,
          },
          [
            e.toolbars.length > 0 &&
              N(
                qK,
                {
                  toolbars: e.toolbars,
                  toolbarsExclude: e.toolbarsExclude,
                },
                null,
              ),
            N(
              VK,
              {
                ref: s,
                modelValue: e.modelValue,
                mdHeadingId: e.mdHeadingId,
                noMermaid: r,
                sanitize: e.sanitize,
                placeholder: e.placeholder,
                noKatex: n,
                scrollAuto: a.scrollAuto,
                formatCopiedText: e.formatCopiedText,
                autofocus: e.autoFocus,
                readonly: e.readOnly,
                maxlength: e.maxLength,
                autoDetectCode: e.autoDetectCode,
                noHighlight: i,
                updateModelValue: m,
                onChange: h,
                onHtmlChanged: g,
                onGetCatalog: v,
                onBlur: y,
                onFocus: b,
                onInput: x,
                completions: e.completions,
                noImgZoomIn: e.noImgZoomIn,
                onDrop: S,
                inputBoxWidth: e.inputBoxWidth,
                oninputBoxWidthChange: C,
                sanitizeMermaid: e.sanitizeMermaid,
                transformImgUrl: e.transformImgUrl,
                codeFoldable: e.codeFoldable,
                autoFoldThreshold: e.autoFoldThreshold,
                onRemount: w,
                catalogLayout: e.catalogLayout,
                catalogMaxDepth: e.catalogMaxDepth,
                noEcharts: e.noEcharts,
                previewComponent: e.previewComponent,
              },
              null,
            ),
            e.footers.length > 0 &&
              N(
                KK,
                {
                  modelValue: e.modelValue,
                  footers: e.footers,
                  defFooters: l.value,
                  noScrollAuto: (!d.preview && !d.htmlPreview) || d.previewOnly,
                  scrollAuto: a.scrollAuto,
                  onScrollAutoChange: T,
                },
                null,
              ),
          ],
        );
    },
  });
JK.install = (e) => (e.component(JK.name, JK), e.use(FN).use(ND).use(PN).use(oO).use(BM), e);
var YK = i({
  default: () => XK,
});
B();
var XK = {
    __name: `MdEditor`,
    props: {
      modelValue: {
        type: [String, Number],
        default: ``,
      },
      error: {
        type: String,
        default: ``,
      },
      placeholder: {
        type: String,
        default: ``,
      },
      toolbar: {
        type: String,
        default: `full`,
      },
    },
    emits: [`update:modelValue`, `update:error`],
    setup(e, { emit: t }) {
      let n = $e(),
        r = t,
        i = e,
        a = Hh(`preference.layout.display`),
        o = V(() => {
          if (i.toolbar == `full`)
            return [
              `bold`,
              `underline`,
              `italic`,
              `-`,
              `title`,
              `strikeThrough`,
              `sub`,
              `sup`,
              `quote`,
              `unorderedList`,
              `orderedList`,
              `-`,
              `codeRow`,
              `code`,
              `link`,
              `image`,
              `table`,
              `-`,
              `revoke`,
              `next`,
              `katex`,
              `=`,
              `preview`,
              `fullscreen`,
            ];
          if (i.toolbar == `mini`)
            return [
              `bold`,
              `underline`,
              `italic`,
              `-`,
              `title`,
              `strikeThrough`,
              `unorderedList`,
              `orderedList`,
              `link`,
            ];
        }),
        s = F(null),
        c = Ae({
          uniqueId: ``,
          input: i.modelValue,
        }),
        l = (e) => {
          (r(`update:modelValue`, e), r(`update:error`, ``));
        },
        u = async (e, t) => {
          let r = new FormData();
          (r.append(`image`, e[0]),
            await n
              .dispatch(`image/upload`, {
                path: `images/upload`,
                data: r,
              })
              .then((e) => {
                t([e.url]);
              })
              .catch((e) => {}));
        };
      return (
        He(
          () => i.modelValue,
          (e) => {
            c.input = e;
          },
        ),
        Qe(async () => {
          c.uniqueId = i.id || Math.random().toString(16).slice(2);
        }),
        (t, n) => {
          let r = j(`FormError`);
          return (
            A(),
            M(
              ke,
              null,
              [
                N(
                  P(JK),
                  {
                    ref_key: `mdeditor`,
                    ref: s,
                    placeholder: e.placeholder,
                    modelValue: c.input,
                    "onUpdate:modelValue": (n[0] ||= (e) => (c.input = e)),
                    onChange: l,
                    language: `en-US`,
                    theme: P(a) === `dark` ? `dark` : `light`,
                    htmlPreview: !1,
                    preview: !1,
                    showCodeRowNumber: !0,
                    footers: [],
                    toolbars: o.value,
                    onOnUploadImg: u,
                  },
                  null,
                  8,
                  [`placeholder`, `modelValue`, `theme`, `toolbars`],
                ),
                N(
                  r,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ],
              64,
            )
          );
        }
      );
    },
  },
  ZK = [];
for (let e = 0; e < 256; ++e) ZK.push((e + 256).toString(16).slice(1));
function QK(e, t = 0) {
  return (
    ZK[e[t + 0]] +
    ZK[e[t + 1]] +
    ZK[e[t + 2]] +
    ZK[e[t + 3]] +
    `-` +
    ZK[e[t + 4]] +
    ZK[e[t + 5]] +
    `-` +
    ZK[e[t + 6]] +
    ZK[e[t + 7]] +
    `-` +
    ZK[e[t + 8]] +
    ZK[e[t + 9]] +
    `-` +
    ZK[e[t + 10]] +
    ZK[e[t + 11]] +
    ZK[e[t + 12]] +
    ZK[e[t + 13]] +
    ZK[e[t + 14]] +
    ZK[e[t + 15]]
  ).toLowerCase();
}
var $K = new Uint8Array(16);
function eq() {
  return crypto.getRandomValues($K);
}
function tq(e, t, n) {
  return !t && !e && crypto.randomUUID ? crypto.randomUUID() : nq(e, t, n);
}
function nq(e, t, n) {
  e ||= {};
  let r = e.random ?? e.rng?.() ?? eq();
  if (r.length < 16) throw Error(`Random bytes length must be >= 16`);
  if (((r[6] = (r[6] & 15) | 64), (r[8] = (r[8] & 63) | 128), t)) {
    if (((n ||= 0), n < 0 || n + 16 > t.length))
      throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
    for (let e = 0; e < 16; ++e) t[n + e] = r[e];
    return t;
  }
  return QK(r);
}
var rq = i({
  default: () => _q,
});
B();
var iq = {
    class: `mt-4 space-y-4`,
  },
  aq = {
    key: 0,
    class: `space-y-2 rounded-lg border border-gray-200 p-4 dark:border-gray-700`,
  },
  oq = {
    class: `flex justify-between text-sm text-gray-800 dark:text-gray-400`,
  },
  sq = {
    class: `mr-2`,
  },
  cq = {
    key: 0,
  },
  lq = {
    key: 1,
  },
  uq = {
    key: 2,
  },
  dq = {
    class: `space-x-4`,
  },
  fq = [`onClick`],
  pq = [`onClick`],
  mq = {
    key: 0,
    class: `h-1 w-full bg-gray-200`,
  },
  hq = {
    class: `flex`,
  },
  gq = [`multiple`, `name`, `id`],
  _q = Object.assign(
    {
      name: `MediaUpload`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        module: {
          type: String,
          required: !0,
        },
        section: {
          type: String,
          default: ``,
        },
        multiple: {
          type: Boolean,
          default: !1,
        },
        media: {
          type: Array,
          default: [],
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
        mediaToken: {
          type: String,
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
        guest: {
          type: Boolean,
          default: !1,
        },
        isRequired: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`setToken`, `setHash`, `uploaded`, `update:error`, `isUpdated`],
      setup(e, { emit: t }) {
        let n = $e(),
          r = u(),
          i = R(`$trans`),
          a = R(`emitter`),
          o = t,
          c = e,
          l = V(() => n.getters[`config/config`](`system.postMaxSize`)),
          d = Ae({
            initURL: `/app/`,
            token: ``,
            hash: ``,
            uniqueId: ``,
            media: [],
            progress: 0,
          }),
          f = F(null),
          p = (e) => {
            if (typeof f.value?.files != `object`) {
              r.error(i(`general.errors.invalid_action`));
              return;
            }
            for (let e = 0; e < f.value.files.length; e++)
              f.value.files[e].size > l.value
                ? r.error(i(`general.errors.file_too_large`))
                : d.media.push({
                    uuid: null,
                    file: f.value.files[e],
                    status: `waiting`,
                    msg: ``,
                    progress: 0,
                  });
            h();
          },
          h = async () => {
            let e = s.CancelToken;
            d.media.forEach((t, n) => {
              if (t.status === `waiting`) {
                let r = new FormData();
                (r.append(`file`, t.file),
                  r.append(`module`, c.module),
                  r.append(`section`, c.section),
                  r.append(`token`, d.token),
                  r.append(`hash`, d.hash),
                  v({
                    url: d.initURL + (c.guest ? `guest/` : ``) + `medias`,
                    method: `POST`,
                    data: r,
                    upload: !0,
                    onUploadProgress: (e) => {
                      t.progress = Math.round((e.loaded * 100) / e.total);
                    },
                    cancelToken: new e((e) => {
                      t.cancel = e;
                    }),
                  })
                    .then((e) => {
                      ((t.status = `uploaded`),
                        (t.uuid = e.uuid),
                        (t.icon = e.icon),
                        (t.size = e.size),
                        o(`update:error`, ``),
                        o(`isUpdated`, !0));
                    })
                    .catch((e) => {
                      if (e === void 0) d.media.splice(n, 1);
                      else {
                        let n = m(e);
                        ((t.status = `error`), (t.msg = n.message));
                      }
                    }));
              }
            });
          },
          g = async (e, t) => {
            if (e.status === `error` || !e.uuid) {
              d.media.splice(t, 1);
              return;
            }
            (await ub()) &&
              v({
                url: d.initURL + (c.guest ? `guest/` : ``) + `medias/` + e.uuid + `?hash=` + d.hash,
                method: `DELETE`,
              })
                .then((e) => {
                  (d.media.splice(t, 1), o(`update:error`, ``), o(`isUpdated`, !0));
                })
                .catch((e) => {});
          };
        return (
          He(
            () => [c.mediaToken, c.media],
            (e) => {
              (e[0] && ((d.token = e[0]), o(`setToken`, e[0])), e[1].length && (d.media = e[1]));
            },
          ),
          Qe(() => {
            ((d.media = c.media || []),
              (d.token = c.mediaToken || tq()),
              (d.hash = Ap(8)),
              o(`setHash`, d.hash),
              c.mediaToken || o(`setToken`, d.token),
              a.on(`resetFiles`, () => {
                ((f.value = null),
                  (d.media = []),
                  (d.token = tq()),
                  (d.hash = Ap(8)),
                  o(`setHash`, d.hash));
              }),
              a.on(`setMediaToken`, (e) => {
                d.token = e;
              }),
              (d.uniqueId = c.id || Math.random().toString(16).slice(2)));
          }),
          oe(() => {
            (a.all.delete(`resetFiles`), a.all.delete(`setMediaToken`));
          }),
          (t, n) => {
            let r = j(`IsRequired`),
              a = j(`BaseButton`),
              o = j(`FormError`),
              s = ve(`tooltip`);
            return (
              A(),
              M(`div`, iq, [
                d.media.length > 0
                  ? (A(),
                    M(`div`, aq, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          d.media,
                          (e, t) => (
                            A(),
                            M(
                              ke,
                              null,
                              [
                                W(`div`, oq, [
                                  W(`div`, null, [
                                    W(`span`, sq, [
                                      e.status == `waiting`
                                        ? Re(
                                            (A(),
                                            M(`span`, cq, [
                                              ...(n[0] ||= [
                                                W(
                                                  `i`,
                                                  {
                                                    class: `fas fa-upload`,
                                                  },
                                                  null,
                                                  -1,
                                                ),
                                              ]),
                                            ])),
                                            [
                                              [
                                                s,
                                                P(i)(`global.uploading`, {
                                                  attribute: e.progress + `%`,
                                                }),
                                              ],
                                            ],
                                          )
                                        : U(``, !0),
                                      e.status == `uploaded`
                                        ? (A(),
                                          M(`span`, lq, [
                                            ...(n[1] ||= [
                                              W(
                                                `i`,
                                                {
                                                  class: `fas fa-check-circle text-success`,
                                                },
                                                null,
                                                -1,
                                              ),
                                            ]),
                                          ]))
                                        : U(``, !0),
                                      e.status == `error`
                                        ? Re(
                                            (A(),
                                            M(`span`, uq, [
                                              ...(n[2] ||= [
                                                W(
                                                  `i`,
                                                  {
                                                    class: `fas fa-exclamation-circle text-danger`,
                                                  },
                                                  null,
                                                  -1,
                                                ),
                                              ]),
                                            ])),
                                            [[s, e.msg]],
                                          )
                                        : U(``, !0),
                                    ]),
                                    W(`span`, null, T(e.file.name), 1),
                                  ]),
                                  W(`div`, dq, [
                                    W(`span`, null, [
                                      H(T(e.size) + ` `, 1),
                                      W(
                                        `i`,
                                        {
                                          class: O([`fas`, e.icon]),
                                        },
                                        null,
                                        2,
                                      ),
                                    ]),
                                    e.status == `waiting`
                                      ? Re(
                                          (A(),
                                          M(
                                            `span`,
                                            {
                                              key: 0,
                                              class: `cursor-pointer`,
                                              onClick: e.cancel,
                                            },
                                            [
                                              ...(n[3] ||= [
                                                W(
                                                  `i`,
                                                  {
                                                    class: `fas fa-times text-danger`,
                                                  },
                                                  null,
                                                  -1,
                                                ),
                                              ]),
                                            ],
                                            8,
                                            fq,
                                          )),
                                          [[s, P(i)(`general.cancel`)]],
                                        )
                                      : Re(
                                          (A(),
                                          M(
                                            `span`,
                                            {
                                              key: 1,
                                              class: `cursor-pointer`,
                                              onClick: (n) => g(e, t),
                                            },
                                            [
                                              ...(n[4] ||= [
                                                W(
                                                  `i`,
                                                  {
                                                    class: `fas fa-times-circle text-danger`,
                                                  },
                                                  null,
                                                  -1,
                                                ),
                                              ]),
                                            ],
                                            8,
                                            pq,
                                          )),
                                          [
                                            [
                                              s,
                                              P(i)(`global.delete`, {
                                                attribute: P(i)(`general.file`),
                                              }),
                                            ],
                                          ],
                                        ),
                                  ]),
                                ]),
                                e.status == `waiting`
                                  ? (A(),
                                    M(`div`, mq, [
                                      W(
                                        `div`,
                                        {
                                          class: O([
                                            `h-1`,
                                            {
                                              "bg-info": e.progress < 100,
                                              "bg-success": e.progress == 100,
                                            },
                                          ]),
                                          style: Pe({
                                            width: e.progress + `%`,
                                          }),
                                        },
                                        null,
                                        6,
                                      ),
                                    ]))
                                  : U(``, !0),
                              ],
                              64,
                            )
                          ),
                        ),
                        256,
                      )),
                    ]))
                  : U(``, !0),
                Re(
                  W(
                    `div`,
                    hq,
                    [
                      N(
                        a,
                        {
                          as: `label`,
                        },
                        {
                          default: I(() => [
                            (n[5] ||= W(
                              `i`,
                              {
                                class: `fas fa-upload mr-2`,
                              },
                              null,
                              -1,
                            )),
                            H(
                              ` ` +
                                T(
                                  e.label
                                    ? P(i)(`global.upload`, {
                                        attribute: e.label,
                                      })
                                    : P(i)(`general.upload`),
                                ) +
                                ` `,
                              1,
                            ),
                            N(
                              r,
                              {
                                "is-required": e.isRequired,
                              },
                              null,
                              8,
                              [`is-required`],
                            ),
                            (A(),
                            M(
                              `input`,
                              {
                                ref_key: `file`,
                                ref: f,
                                type: `file`,
                                onInput: p,
                                key: d.token,
                                multiple: e.multiple,
                                name: d.uniqueId,
                                id: d.uniqueId,
                                class: `hidden`,
                              },
                              null,
                              40,
                              gq,
                            )),
                          ]),
                          _: 1,
                        },
                      ),
                    ],
                    512,
                  ),
                  [[Ee, !e.disabled]],
                ),
                N(
                  o,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ])
            );
          }
        );
      },
    },
  ),
  vq = i({
    default: () => xq,
  });
B();
var yq = {
    class: `w-full`,
  },
  bq = [`id`, `placeholder`, `rows`, `value`],
  xq = Object.assign(
    {
      name: `MintTextarea`,
      inheritAttrs: !1,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        rows: {
          type: Number,
          default: 3,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        placeholder: {
          type: String,
          default: ``,
        },
        modelValue: {
          type: [String, Number],
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
      },
      emits: [`update:modelValue`, `update:error`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = F(null),
          a = Ae({
            uniqueId: ``,
          }),
          o = (e) => {
            (s(), n(`update:modelValue`, e.target.value), n(`update:error`, ``));
          },
          s = () => {
            i.value &&
              ((i.value.style.height = `20px`),
              (i.value.style.height = i.value.scrollHeight + `px`));
          };
        return (
          Qe(() => {
            ((a.uniqueId = r.id || Math.random().toString(16).slice(2)), de(s));
          }),
          He(
            () => r.modelValue,
            () => de(s),
          ),
          (t, n) => {
            let r = j(`FormError`);
            return (
              A(),
              M(`div`, yq, [
                W(
                  `textarea`,
                  ce(
                    {
                      ref_key: `textarea`,
                      ref: i,
                      id: a.uniqueId,
                    },
                    t.$attrs,
                    {
                      placeholder: e.placeholder || e.label,
                      rows: e.rows,
                      class: `w-full p-4 bg-white dark:bg-dark-body border-2 dark:text-gray-400 border-primary dark:border-gray-300 rounded-lg text-base resize-none transition duration-200 focus:outline-none focus:border-primary dark:focus:border-gray-300 focus:ring-1 focus:ring-primary dark:focus:ring-gray-300`,
                      onInput: o,
                      value: e.modelValue,
                    },
                  ),
                  null,
                  16,
                  bq,
                ),
                N(
                  r,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ])
            );
          }
        );
      },
    },
  ),
  Sq = i({
    default: () => Eq,
  });
B();
var Cq = {
    class: `flex items-center gap-0.5 px-2 py-1.5 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-dark-body`,
  },
  wq = [`onMousedown`, `title`],
  Tq = [`data-placeholder`],
  Eq = tu(
    Object.assign(
      {
        name: `NoteEditor`,
        inheritAttrs: !1,
      },
      {
        props: {
          label: {
            type: String,
            default: ``,
          },
          placeholder: {
            type: String,
            default: `Write a note...`,
          },
          modelValue: {
            type: String,
            default: ``,
          },
          error: {
            type: String,
            default: ``,
          },
          minHeight: {
            type: String,
            default: `120px`,
          },
        },
        emits: [`update:modelValue`, `update:error`],
        setup(e, { emit: t }) {
          let n = t,
            r = e,
            i = F(null),
            a = F(!1),
            o = [
              {
                command: `bold`,
                icon: `fas fa-bold`,
                title: `Bold`,
              },
              {
                command: `italic`,
                icon: `fas fa-italic`,
                title: `Italic`,
              },
              {
                command: `insertUnorderedList`,
                icon: `fas fa-list-ul`,
                title: `Bullet list`,
              },
              {
                command: `insertOrderedList`,
                icon: `fas fa-list-ol`,
                title: `Numbered list`,
              },
            ],
            s = Ae({
              bold: !1,
              italic: !1,
              insertUnorderedList: !1,
              insertOrderedList: !1,
            }),
            c = () => {
              ((s.bold = document.queryCommandState(`bold`)),
                (s.italic = document.queryCommandState(`italic`)),
                (s.insertUnorderedList = document.queryCommandState(`insertUnorderedList`)),
                (s.insertOrderedList = document.queryCommandState(`insertOrderedList`)));
            },
            l = (e) => {
              (i.value?.focus(), document.execCommand(e, !1, null), c(), u());
            },
            u = () => {
              let e = i.value?.innerHTML ?? ``;
              (n(`update:modelValue`, e === `` || e === `<br>` || e === `<div><br></div>` ? `` : e),
                n(`update:error`, ``));
            },
            d = (e) => {
              e.key === `Enter` && (e.ctrlKey || e.metaKey) && (e.preventDefault(), n(`submit`));
            },
            f = (e) => {
              i.value && i.value.innerHTML !== e && (i.value.innerHTML = e || ``);
            };
          return (
            He(
              () => r.modelValue,
              (e) => {
                a.value || f(e);
              },
            ),
            Qe(() => {
              f(r.modelValue);
            }),
            (t, n) => {
              let r = j(`BaseLabel`),
                f = j(`FormError`);
              return (
                A(),
                M(`div`, null, [
                  e.label
                    ? (A(),
                      L(
                        r,
                        {
                          key: 0,
                        },
                        {
                          default: I(() => [H(T(e.label), 1)]),
                          _: 1,
                        },
                      ))
                    : U(``, !0),
                  W(
                    `div`,
                    {
                      class: O([
                        `mt-1 rounded-lg border overflow-hidden transition-colors`,
                        a.value
                          ? `border-primary ring-1 ring-primary`
                          : `border-gray-300 dark:border-gray-700`,
                      ]),
                    },
                    [
                      W(`div`, Cq, [
                        (A(),
                        M(
                          ke,
                          null,
                          ae(o, (e) =>
                            W(
                              `button`,
                              {
                                key: e.command,
                                type: `button`,
                                onMousedown: Fe((t) => l(e.command), [`prevent`]),
                                title: e.title,
                                class: O([
                                  `h-7 w-7 flex items-center justify-center rounded text-xs transition-colors`,
                                  s[e.command]
                                    ? `bg-primary/10 text-primary`
                                    : `text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700`,
                                ]),
                              },
                              [
                                W(
                                  `i`,
                                  {
                                    class: O(e.icon),
                                  },
                                  null,
                                  2,
                                ),
                              ],
                              42,
                              wq,
                            ),
                          ),
                          64,
                        )),
                      ]),
                      W(
                        `div`,
                        {
                          ref_key: `editorEl`,
                          ref: i,
                          contenteditable: `true`,
                          "data-placeholder": e.placeholder,
                          onFocus: (n[0] ||= (e) => (a.value = !0)),
                          onBlur: (n[1] ||= (e) => (a.value = !1)),
                          onInput: u,
                          onKeydown: d,
                          onKeyup: c,
                          onMouseup: c,
                          style: Pe({
                            minHeight: e.minHeight,
                          }),
                          class: `note-editor-content px-3 py-2.5 text-sm text-gray-900 dark:text-gray-100 dark:bg-dark-header focus:outline-none overflow-y-auto`,
                        },
                        null,
                        44,
                        Tq,
                      ),
                    ],
                    2,
                  ),
                  N(
                    f,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ])
              );
            }
          );
        },
      },
    ),
    [[`__scopeId`, `data-v-dfde7496`]],
  ),
  Dq = i({
    default: () => Mq,
  });
B();
var Oq = {
    class: `flex justify-between`,
  },
  kq = {
    key: 0,
    class: `ltr:ml-2 rtl:mr-2`,
  },
  Aq = {
    class: `mt-1 flex justify-center gap-2 sm:gap-3`,
    dir: `ltr`,
  },
  jq = [`id`, `onUpdate:modelValue`, `onInput`, `onKeydown`, `autofocus`, `disabled`],
  Mq = tu(
    Object.assign(
      {
        name: `OtpInput`,
      },
      {
        props: {
          label: {
            type: String,
            default: ``,
          },
          labelHint: {
            type: String,
            default: ``,
          },
          modelValue: {
            type: String,
            default: ``,
          },
          error: {
            type: String,
            default: ``,
          },
          length: {
            type: Number,
            default: 6,
          },
          isRequired: {
            type: Boolean,
            default: !1,
          },
          autofocus: {
            type: Boolean,
            default: !1,
          },
          disabled: {
            type: Boolean,
            default: !1,
          },
        },
        emits: [`update:modelValue`, `update:error`, `change`, `complete`],
        setup(e, { emit: t }) {
          let n = e,
            r = t,
            i = Ae({
              uniqueId: ``,
              digits: Array(n.length).fill(``),
              inputRefs: [],
              focused: !1,
            }),
            a = (e, t) => {
              let r = t.target.value;
              if (!/^\d*$/.test(r)) {
                t.target.value = i.digits[e];
                return;
              }
              ((i.digits[e] = r), r && e < n.length - 1 && i.inputRefs[e + 1]?.focus(), c());
            },
            o = (e, t) => {
              t.key === `Backspace`
                ? !i.digits[e] && e > 0
                  ? i.inputRefs[e - 1]?.focus()
                  : ((i.digits[e] = ``), c())
                : t.key === `ArrowLeft` && e > 0
                  ? (t.preventDefault(), i.inputRefs[e - 1]?.focus())
                  : t.key === `ArrowRight` &&
                    e < n.length - 1 &&
                    (t.preventDefault(), i.inputRefs[e + 1]?.focus());
            },
            s = (e) => {
              e.preventDefault();
              let t = e.clipboardData.getData(`text/plain`).trim();
              if (!/^\d+$/.test(t)) return;
              let r = t.split(``).slice(0, n.length);
              r.forEach((e, t) => {
                i.digits[t] = e;
              });
              let a = Math.min(r.length - 1, n.length - 1);
              (i.inputRefs[a]?.focus(), c());
            },
            c = () => {
              let e = i.digits.join(``);
              (r(`update:modelValue`, e),
                r(`change`, e),
                r(`update:error`, ``),
                e.length === n.length && r(`complete`, e));
            };
          return (
            He(
              () => n.modelValue,
              (e) => {
                if (e !== i.digits.join(``)) {
                  let t = (e || ``).split(``).slice(0, n.length);
                  i.digits = [...t, ...Array(n.length - t.length).fill(``)];
                }
              },
            ),
            Qe(() => {
              if (((i.uniqueId = Math.random().toString(16).slice(2)), n.modelValue)) {
                let e = n.modelValue.split(``).slice(0, n.length);
                i.digits = [...e, ...Array(n.length - e.length).fill(``)];
              }
            }),
            (t, n) => {
              let r = j(`IsRequired`),
                c = j(`BaseLabel`),
                l = j(`FormError`),
                u = ve(`tooltip`);
              return (
                A(),
                M(`div`, null, [
                  W(`div`, Oq, [
                    e.label
                      ? (A(),
                        L(
                          c,
                          {
                            key: 0,
                            for: `${i.uniqueId}-0`,
                          },
                          {
                            default: I(() => [
                              W(`span`, null, [
                                H(T(e.label) + ` `, 1),
                                N(
                                  r,
                                  {
                                    "is-required": e.isRequired,
                                  },
                                  null,
                                  8,
                                  [`is-required`],
                                ),
                              ]),
                              e.labelHint
                                ? Re(
                                    (A(),
                                    M(`span`, kq, [
                                      ...(n[2] ||= [
                                        W(
                                          `i`,
                                          {
                                            class: `fas fa-question-circle`,
                                          },
                                          null,
                                          -1,
                                        ),
                                      ]),
                                    ])),
                                    [[u, e.labelHint]],
                                  )
                                : U(``, !0),
                            ]),
                            _: 1,
                          },
                          8,
                          [`for`],
                        ))
                      : U(``, !0),
                    z(t.$slots, `additional-label`, {}, void 0, !0),
                  ]),
                  W(`div`, Aq, [
                    (A(!0),
                    M(
                      ke,
                      null,
                      ae(i.digits, (t, r) =>
                        Re(
                          (A(),
                          M(
                            `input`,
                            {
                              key: r,
                              id: `${i.uniqueId}-${r}`,
                              ref_for: !0,
                              ref: (e) => (i.inputRefs[r] = e),
                              "onUpdate:modelValue": (e) => (i.digits[r] = e),
                              type: `text`,
                              inputmode: `numeric`,
                              maxlength: `1`,
                              class: O([
                                `focus:border-primary block w-12 h-12 sm:w-14 sm:h-14 border-2 border-gray-300 bg-inherit text-center text-xl sm:text-2xl font-semibold focus:ring-0 disabled:bg-gray-200 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-200 dark:disabled:bg-gray-700 rounded-md`,
                                {
                                  "border-red-500 dark:border-red-500": e.error,
                                },
                              ]),
                              onInput: (e) => a(r, e),
                              onKeydown: (e) => o(r, e),
                              onPaste: s,
                              onFocus: (n[0] ||= (e) => (i.focused = !0)),
                              onBlur: (n[1] ||= (e) => (i.focused = !1)),
                              autofocus: r === 0 && e.autofocus,
                              disabled: e.disabled,
                            },
                            null,
                            42,
                            jq,
                          )),
                          [[we, i.digits[r]]],
                        ),
                      ),
                      128,
                    )),
                  ]),
                  N(
                    l,
                    {
                      error: e.error,
                    },
                    null,
                    8,
                    [`error`],
                  ),
                ])
              );
            }
          );
        },
      },
    ),
    [[`__scopeId`, `data-v-ae2c6e3a`]],
  ),
  Nq = i({
    default: () => Rq,
  });
B();
var Pq = {
    class: `flex space-x-2 mt-2`,
  },
  Fq = [`title`],
  Iq = [`title`],
  Lq = [`title`],
  Rq = {
    __name: `RowCopyButtons`,
    props: {
      fieldLabel: {
        type: String,
        required: !0,
      },
      currentIndex: {
        type: Number,
        required: !0,
      },
      totalRows: {
        type: Number,
        required: !0,
      },
      onCopyToAll: {
        type: Function,
        required: !0,
      },
      onCopyToAbove: {
        type: Function,
        required: !0,
      },
      onCopyToBelow: {
        type: Function,
        required: !0,
      },
    },
    setup(e) {
      let t = e,
        n = V(() => t.currentIndex === 0),
        r = V(() => t.currentIndex === t.totalRows - 1),
        i = () => {
          (!n.value || !r.value) && t.onCopyToAll();
        },
        a = () => {
          n.value || t.onCopyToAbove();
        },
        o = () => {
          r.value || t.onCopyToBelow();
        };
      return (t, s) => (
        A(),
        M(`div`, Pq, [
          W(
            `span`,
            {
              class: `text-xs cursor-pointer text-gray-600 hover:text-gray-400`,
              onClick: i,
              title: `Copy ${e.fieldLabel} to all rows`,
            },
            [
              (s[0] ||= W(
                `i`,
                {
                  class: `fas fa-copy`,
                },
                null,
                -1,
              )),
              H(` ` + T(t.$trans(`general.all`)), 1),
            ],
            8,
            Fq,
          ),
          W(
            `span`,
            {
              class: O([
                `text-xs cursor-pointer text-gray-600 hover:text-gray-400`,
                {
                  "opacity-50 cursor-not-allowed": n.value,
                },
              ]),
              onClick: a,
              title: `Copy ${e.fieldLabel} to rows above`,
            },
            [
              ...(s[1] ||= [
                W(
                  `i`,
                  {
                    class: `fas fa-arrow-up`,
                  },
                  null,
                  -1,
                ),
              ]),
            ],
            10,
            Iq,
          ),
          W(
            `span`,
            {
              class: O([
                `text-xs cursor-pointer text-gray-600 hover:text-gray-400`,
                {
                  "opacity-50 cursor-not-allowed": r.value,
                },
              ]),
              onClick: o,
              title: `Copy ${e.fieldLabel} to rows below`,
            },
            [
              ...(s[2] ||= [
                W(
                  `i`,
                  {
                    class: `fas fa-arrow-down`,
                  },
                  null,
                  -1,
                ),
              ]),
            ],
            10,
            Lq,
          ),
        ])
      );
    },
  },
  zq = i({
    default: () => Wq,
  });
B();
var Bq = {
    class: `flex justify-between`,
  },
  Vq = {
    key: 0,
    class: `ml-2`,
  },
  Hq = {
    class: `mt-1 flex flex-wrap items-center`,
  },
  Uq = [`onClick`],
  Wq = Object.assign(
    {
      name: `SelectedColorPicker`,
    },
    {
      props: {
        id: {
          type: String,
          default: ``,
        },
        colors: {
          type: Array,
          default: [
            `#fda4af`,
            `#db2777`,
            `#c084fc`,
            `#581c87`,
            `#4f46e5`,
            `#312e81`,
            `#0369a1`,
            `#22d3ee`,
            `#5eead4`,
            `#10b981`,
            `#15803d`,
            `#14532d`,
            `#fef08a`,
            `#facc15`,
            `#d97706`,
            `#9a3412`,
            `#7f1d1d`,
            `#78716c`,
            `#3f3f46`,
            `#4b5563`,
            `#94a3b8`,
          ],
        },
        modelValue: {
          type: String,
          default: ``,
        },
        label: {
          type: String,
          default: ``,
        },
        labelHint: {
          type: String,
          default: ``,
        },
        error: {
          type: String,
          default: ``,
        },
      },
      emits: [`update:modelValue`, `update:error`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = Ae({
            uniqueId: ``,
            selectedColor: r.modelValue,
          }),
          a = (e) => {
            ((i.selectedColor = e), n(`update:modelValue`, e), n(`update:error`, ``));
          };
        return (
          Qe(() => {
            ((i.uniqueId = r.id || Math.random().toString(16).slice(2)),
              (i.selectedColor = r.modelValue));
          }),
          He(
            () => r.modelValue,
            (e) => {
              i.selectedColor = e;
            },
          ),
          (t, n) => {
            let r = j(`BaseLabel`),
              o = j(`FormError`),
              s = ve(`tooltip`);
            return (
              A(),
              M(`div`, null, [
                W(`div`, Bq, [
                  e.label
                    ? (A(),
                      L(
                        r,
                        {
                          key: 0,
                          for: i.uniqueId,
                        },
                        {
                          default: I(() => [
                            H(T(e.label) + ` `, 1),
                            e.labelHint
                              ? Re(
                                  (A(),
                                  M(`span`, Vq, [
                                    ...(n[0] ||= [
                                      W(
                                        `i`,
                                        {
                                          class: `fas fa-question-circle`,
                                        },
                                        null,
                                        -1,
                                      ),
                                    ]),
                                  ])),
                                  [[s, e.labelHint]],
                                )
                              : U(``, !0),
                          ]),
                          _: 1,
                        },
                        8,
                        [`for`],
                      ))
                    : U(``, !0),
                  z(t.$slots, `additional-label`),
                ]),
                W(`div`, Hq, [
                  (A(!0),
                  M(
                    ke,
                    null,
                    ae(
                      e.colors,
                      (e) => (
                        A(),
                        M(
                          `span`,
                          {
                            key: e,
                            class: O([
                              `mr-1 mt-1 h-6 w-6 cursor-pointer rounded-full`,
                              {
                                "h-8 w-8": i.selectedColor === e,
                              },
                            ]),
                            style: Pe(`background-color:${e}`),
                            onClick: (t) => a(e),
                          },
                          ` \xA0 `,
                          14,
                          Uq,
                        )
                      ),
                    ),
                    128,
                  )),
                ]),
                N(
                  o,
                  {
                    error: e.error,
                  },
                  null,
                  8,
                  [`error`],
                ),
              ])
            );
          }
        );
      },
    },
  ),
  Gq = i({
    default: () => Kq,
  });
B();
var Kq = Object.assign(
    {
      name: `TabContent`,
    },
    {
      props: {
        title: {
          type: String,
          required: !1,
        },
        description: {
          type: String,
          default: ``,
        },
        step: {
          type: String,
        },
        isSelected: Boolean,
        beforeChange: {
          type: Function,
          default() {
            return !0;
          },
        },
        afterChange: {
          type: Function,
          default() {
            return !0;
          },
        },
      },
      setup(e) {
        let t = F(0),
          n = F(!1),
          r = R(`TabsProvider`);
        return (
          He(
            () => r.selectedIndex,
            () => {
              n.value = t.value === r.selectedIndex;
            },
          ),
          ie(() => {
            ((t.value = r.count), r.count++, (n.value = t.value === r.selectedIndex));
          }),
          (e, t) => Re((A(), M(`div`, null, [z(e.$slots, `default`)], 512)), [[Ee, n.value]])
        );
      },
    },
  ),
  qq = i({
    default: () => Zq,
  });
B();
var Jq = {
    name: `TextContent`,
  },
  Yq = {
    class: `text-label block truncate text-sm font-medium dark:text-gray-400`,
  };
function Xq(e, t, n, r, i, a) {
  return (A(), M(`div`, Yq, [z(e.$slots, `default`)]));
}
var Zq = tu(Jq, [[`render`, Xq]]),
  Qq = i({
    default: () => nJ,
  });
B();
var $q = {
    name: `BaseHeader`,
  },
  eJ = {
    class: `py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400 sm:px-2 xl:px-4`,
  };
function tJ(e, t, n, r, i, a) {
  return (A(), M(`th`, eJ, [z(e.$slots, `default`)]));
}
var nJ = tu($q, [[`render`, tJ]]),
  rJ = i({
    default: () => uJ,
  });
B();
var iJ = {
    class: `flex flex-col`,
  },
  aJ = {
    class: `-my-2 overflow-x-auto sm:-mx-6`,
  },
  oJ = {
    class: `inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8`,
  },
  sJ = {
    class: `overflow-hidden border-b border-gray-200 shadow dark:border-gray-700 sm:rounded-lg`,
  },
  cJ = {
    class: `min-w-full divide-y divide-gray-200 dark:divide-gray-700`,
  },
  lJ = {
    class: `bg-gray-50 dark:bg-dark-subheader`,
  },
  uJ = Object.assign(
    {
      name: `BaseTable`,
    },
    {
      setup(e) {
        return (
          ge(`Header`, []),
          ge(`SubHeader`, []),
          ge(`VerticalAlign`, []),
          (e, t) => (
            A(),
            M(`div`, iJ, [
              W(`div`, aJ, [
                W(`div`, oJ, [
                  W(`div`, sJ, [
                    W(`table`, cJ, [
                      W(`thead`, lJ, [W(`tr`, null, [z(e.$slots, `header`)])]),
                      W(`tbody`, null, [z(e.$slots, `default`)]),
                    ]),
                  ]),
                ]),
              ]),
            ])
          )
        );
      },
    },
  ),
  dJ = i({
    default: () => pJ,
  });
B();
var fJ = [`valign`, `colspan`],
  pJ = Object.assign(
    {
      name: `DataCell`,
    },
    {
      props: {
        name: {
          type: String,
          default: ``,
        },
        label: {
          type: String,
          default: ``,
        },
        hasLabel: {
          type: Boolean,
          default: !1,
        },
        noResponsive: {
          type: Boolean,
          default: !1,
        },
        colspan: {
          type: Number,
          default: 1,
        },
        table: {
          type: Boolean,
          default: !1,
        },
        isHeading: {
          type: Boolean,
          default: !1,
        },
        stickyColumn: {
          type: Boolean,
          default: !1,
        },
        isFooter: {
          type: Boolean,
          default: !1,
        },
        align: {
          type: String,
          default: `left`,
        },
        verticalAlign: {
          type: String,
          default: `top`,
          validator(e) {
            return [`top`, `bottom`, `middle`].includes(e);
          },
        },
        bordered: {
          type: Boolean,
          default: !1,
        },
        noPadding: {
          type: Boolean,
          default: !1,
        },
        leftPadding: {
          type: Boolean,
          default: !1,
        },
        streched: {
          type: Boolean,
          default: !1,
        },
        empty: {
          type: Boolean,
          default: !1,
        },
        clickable: {
          type: Boolean,
          default: !1,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`click`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = R(`Header`),
          a = R(`SubHeader`),
          o = R(`VerticalAlign`),
          s = R(`TextColor`),
          c = V(() => (o ? o.value : r.verticalAlign)),
          l = (e) => {
            let t = {
              key: ``,
              label: ``,
              visibility: !0,
            };
            if (!e) return t;
            let n = i.value.findIndex((t) => t.key == e);
            return n >= 0
              ? i.value[n]
              : a?.value && ((n = a.value.findIndex((t) => t.key == e)), n >= 0)
                ? a.value[n]
                : t;
          },
          u = (e) => {
            let t = l(e);
            return [`action`, `selectAll`].includes(t.key) ? !0 : t.visibility;
          },
          d = (e) => l(e).label;
        return (t, r) =>
          e.hasLabel || u(e.name)
            ? (A(),
              M(
                ke,
                {
                  key: 0,
                },
                [
                  W(
                    `td`,
                    {
                      valign: c.value,
                      colspan: e.colspan,
                      class: O([
                        `dark:bg-dark-header`,
                        {
                          "sticky-column bg-white dark:bg-dark-body": e.stickyColumn,
                          "bg-gray-100 dark:bg-gray-800": e.disabled,
                          "py-2 sm:px-2 xl:px-4": !e.noPadding && !e.leftPadding,
                          "py-3": e.isFooter,
                          "border border-gray-200 dark:border-gray-700": e.bordered || e.isFooter,
                          "hidden md:table-cell": !e.noResponsive,
                          "ltr:text-right rtl:text-left": e.align == `right`,
                          "text-center": e.align == `first-letter:` || e.align == `center`,
                          "cursor-pointer": e.clickable,
                        },
                      ]),
                      onClick: (r[0] ||= (e) => n(`click`)),
                    },
                    [
                      W(
                        `div`,
                        {
                          class: O([
                            `text-sm`,
                            {
                              "text-md font-semibold dark:text-gray-300": e.isHeading,
                              "text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400":
                                e.isFooter,
                              "text-gray-900 dark:text-gray-400":
                                !e.isHeading && !e.isFooter && !P(s),
                              "text-danger !important": P(s) == `danger`,
                              "text-success !important": P(s) == `success`,
                              "text-warning !important": P(s) == `warning`,
                              "text-info !important": P(s) == `info`,
                            },
                          ]),
                        },
                        [z(t.$slots, `default`)],
                        2,
                      ),
                    ],
                    10,
                    fJ,
                  ),
                  !e.noResponsive && !e.empty
                    ? (A(),
                      M(
                        `div`,
                        {
                          key: 0,
                          class: O([
                            `text-sm text-gray-900 dark:text-gray-400 md:hidden`,
                            {
                              flex: !e.streched,
                              "mx-4": e.streched,
                              "items-center": c.value == `middle`,
                              "items-start": c.value == `top`,
                              "items-end": c.value == `bottom`,
                              "border border-gray-200 dark:border-gray-700": e.bordered,
                              "mb-2": !e.bordered,
                              "px-2 py-2": !e.noPadding && !e.leftPadding,
                              "py-0 ltr:pl-2 rtl:pr-2": e.leftPadding,
                              "justify-between": !e.table && (e.label || d(e.name)),
                              "justify-end": !d(e.name),
                            },
                          ]),
                        },
                        [
                          !e.table && (e.label || d(e.name))
                            ? (A(),
                              M(
                                `span`,
                                {
                                  key: 0,
                                  class: O([
                                    `ltr:mr-6 rtl:ml-6 text-sm font-medium`,
                                    {
                                      "text-md font-semibold": e.isHeading,
                                    },
                                  ]),
                                },
                                T(e.label || d(e.name)),
                                3,
                              ))
                            : U(``, !0),
                          W(
                            `div`,
                            {
                              class: O([
                                `text-right`,
                                {
                                  "text-danger !important": P(s) == `danger`,
                                  "text-success !important": P(s) == `success`,
                                  "text-warning !important": P(s) == `warning`,
                                  "text-info !important": P(s) == `info`,
                                },
                              ]),
                            },
                            [z(t.$slots, `default`)],
                            2,
                          ),
                        ],
                        2,
                      ))
                    : U(``, !0),
                ],
                64,
              ))
            : U(``, !0);
      },
    },
  ),
  mJ = i({
    default: () => hJ,
  });
B();
var hJ = Object.assign(
    {
      name: `DataHead`,
    },
    {
      props: {
        align: {
          type: String,
          default: `left`,
        },
        bordered: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `th`,
            {
              scope: `col`,
              class: O([
                `py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400 sm:px-2 xl:px-4`,
                {
                  "border border-gray-200 dark:border-gray-600": e.bordered,
                  "text-right": e.align == `right`,
                  "text-center": e.align == `center`,
                },
              ]),
            },
            [z(t.$slots, `default`)],
            2,
          )
        );
      },
    },
  ),
  gJ = i({
    default: () => _J,
  });
B();
var _J = Object.assign(
    {
      name: `DataRow`,
    },
    {
      props: {
        noResponsive: {
          type: Boolean,
          default: !1,
        },
        isHeading: {
          type: Boolean,
          default: !1,
        },
        spacing: {
          type: Boolean,
          default: !0,
        },
        textColor: {
          type: String,
          default: ``,
        },
      },
      emits: [`doubleClick`],
      setup(e) {
        let t = e;
        return (
          ge(
            `TextColor`,
            V(() => t.textColor),
          ),
          (t, n) => (
            A(),
            M(
              ke,
              null,
              [
                W(
                  `tr`,
                  {
                    class: O([
                      `dark:hover:bg-dark-body hover:bg-gray-100`,
                      {
                        "hidden md:table-row": !e.noResponsive,
                        "bg-gray-100 font-semibold dark:bg-neutral-600": e.isHeading,
                      },
                    ]),
                    onDblclick: (n[0] ||= (e) => t.$emit(`doubleClick`)),
                  },
                  [z(t.$slots, `default`)],
                  34,
                ),
                e.noResponsive
                  ? U(``, !0)
                  : (A(),
                    M(
                      `div`,
                      {
                        key: 0,
                        class: O([
                          `dark:bg-dark-header dark:hover:bg-dark-body table-row hover:bg-gray-100 md:hidden`,
                          {
                            "space-y-2": e.spacing,
                            "bg-gray-100 font-semibold dark:bg-neutral-600": e.isHeading,
                          },
                        ]),
                        onDblclick: (n[1] ||= (e) => t.$emit(`doubleClick`)),
                      },
                      [z(t.$slots, `default`)],
                      34,
                    )),
              ],
              64,
            )
          )
        );
      },
    },
  ),
  vJ = i({
    default: () => JJ,
  });
B();
var yJ = {
    class: `rounded-table hidden min-w-full divide-y divide-gray-200 dark:divide-gray-700 md:table`,
  },
  bJ = {
    class: `bg-gray-50 dark:bg-dark-subheader`,
  },
  xJ = [`onClick`],
  SJ = {
    key: 0,
  },
  CJ = {
    key: 1,
    class: `hidden xl:inline-block`,
  },
  wJ = {
    key: 0,
    class: `fas fa-sort-amount-down-alt`,
  },
  TJ = {
    key: 1,
    class: `fas fa-sort-amount-up-alt`,
  },
  EJ = {
    key: 1,
    class: `fas fa-arrows-alt-v`,
  },
  DJ = {
    class: `divide-y divide-gray-200 bg-white dark:divide-gray-700`,
  },
  OJ = {
    class: `text-center`,
  },
  kJ = {
    key: 0,
  },
  AJ = {
    key: 1,
  },
  jJ = {
    key: 1,
  },
  MJ = {
    colspan: `100`,
    class: `dark:bg-dark-header py-2 text-center text-sm text-gray-500 dark:text-gray-400`,
  },
  NJ = {
    key: 0,
    class: `bg-gray-50 dark:bg-dark-subheader`,
  },
  PJ = {
    class: `min-w-full divide-y divide-gray-200 dark:divide-gray-700 md:hidden`,
  },
  FJ = {
    class: `divide-y divide-gray-200 bg-white dark:divide-gray-700`,
  },
  IJ = {
    key: 0,
  },
  LJ = {
    colspan: `100`,
  },
  RJ = {
    class: `text-center`,
  },
  zJ = {
    key: 0,
  },
  BJ = {
    key: 1,
  },
  VJ = {
    key: 1,
  },
  HJ = {
    colspan: `100`,
    class: `py-2 text-center text-sm text-gray-500`,
  },
  UJ = {
    key: 0,
    class: `flex flex-col items-center justify-center space-y-4 py-10 text-gray-500`,
  },
  WJ = {
    class: `text-lg`,
  },
  GJ = {
    key: 0,
    class: `text-2xl text-gray-400 dark:text-gray-600`,
  },
  KJ = {
    key: 1,
    class: `text-gray-400 dark:text-gray-600`,
  },
  qJ = {
    key: 1,
  },
  JJ = Object.assign(
    {
      name: `DataTable`,
    },
    {
      props: {
        header: {
          type: Array,
          default: [],
        },
        footer: {
          type: Array,
          default: [],
        },
        stickyColumns: {
          type: Array,
          default: [],
        },
        meta: {
          type: Object,
          default: {
            hasFooter: !1,
            total: 0,
          },
        },
        module: {
          type: String,
          default: ``,
        },
        moduleTransParams: {
          type: Object,
          default: () => ({}),
        },
        scroll: {
          type: Boolean,
          default: !0,
        },
        selected: {
          type: Object,
          default: {
            pageItems: [],
            items: [],
            all: !1,
            global: !1,
          },
        },
        verticalAlign: {
          type: String,
          default: `top`,
          validator(e) {
            return [`top`, `bottom`, `middle`].includes(e);
          },
        },
      },
      emits: [`refresh`, `toggleSelectAll`, `toggleGlobalSelect`],
      setup(e, { emit: t }) {
        let n = Dc(),
          r = Ec();
        Te();
        let i = t,
          a = e,
          o = F(null),
          s = F(null);
        (ge(
          `Header`,
          V(() => a.header),
        ),
          ge(`SubHeader`, []),
          ge(
            `VerticalAlign`,
            V(() => a.verticalAlign),
          ),
          Qe(() => {
            ((o.value = n.query.sort ?? null), (s.value = n.query.order ?? null));
          }));
        let l = (e) => {
            i(`toggleSelectAll`, e.target.checked);
          },
          u = () => {
            i(`toggleGlobalSelect`);
          },
          d = (e, t = `label`) => {
            let n = a.footer.find((t) => t.key == e);
            if (n !== void 0) return n.hasOwnProperty(t) ? n[t] : ``;
          },
          f = (e) =>
            [`action`, `selectAll`].includes(e.key)
              ? !0
              : e.hasOwnProperty(`printable`) && e.printable === !0
                ? !1
                : e.visibility,
          p = (e) => {
            let t = a.header.find((t) => t.key == e);
            t !== void 0 &&
              (!t.hasOwnProperty(`sortable`) ||
                t.sortable !== !0 ||
                ((o.value = e),
                n.query.sort == e
                  ? n.query.order === void 0 || n.query.order == `desc`
                    ? ((s.value = `asc`),
                      m({
                        sort: e,
                        order: `asc`,
                      }))
                    : ((s.value = `desc`),
                      m({
                        sort: e,
                        order: `desc`,
                      }))
                  : ((s.value = `asc`),
                    m({
                      sort: e,
                      order: `asc`,
                    }))));
          },
          m = async (e) => {
            (await r.push({
              name: n.name,
              query: {
                ...n.query,
                ...e,
              },
            }),
              i(`refresh`));
          };
        return (t, n) => {
          let r = j(`BaseCheckbox`),
            m = j(`DataCell`),
            h = j(`DataRow`),
            g = j(`Pagination`),
            v = j(`BaseCard`);
          return (
            A(),
            M(
              ke,
              null,
              [
                e.meta.total
                  ? (A(),
                    L(
                      v,
                      {
                        key: 0,
                        "no-padding": ``,
                        "no-content-padding": ``,
                      },
                      {
                        default: I(() => [
                          W(
                            `div`,
                            {
                              class: O({
                                "scroller-thin-x": e.scroll,
                              }),
                            },
                            [
                              W(`table`, yJ, [
                                W(`thead`, bJ, [
                                  W(`tr`, null, [
                                    (A(!0),
                                    M(
                                      ke,
                                      null,
                                      ae(
                                        e.header,
                                        (t) => (
                                          A(),
                                          M(
                                            ke,
                                            null,
                                            [
                                              f(t)
                                                ? (A(),
                                                  M(
                                                    `th`,
                                                    {
                                                      key: 0,
                                                      scope: `col`,
                                                      class: O([
                                                        `py-3 ltr:text-left rtl:text-right text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400 sm:px-2 xl:px-4`,
                                                        {
                                                          "sticky-column bg-gray-50 dark:bg-dark-subheader":
                                                            e.stickyColumns.includes(t.key),
                                                          "ltr:text-right rtl:text-left":
                                                            t.align == `right`,
                                                          "text-center": t.align == `center`,
                                                          "cursor-pointer": t.sortable,
                                                        },
                                                      ]),
                                                      onClick: (e) => p(t.key),
                                                    },
                                                    [
                                                      t.key == `selectAll` && !e.selected.global
                                                        ? (A(),
                                                          M(`span`, SJ, [
                                                            N(
                                                              r,
                                                              {
                                                                name: `selectAll`,
                                                                modelValue: e.selected.all,
                                                                "onUpdate:modelValue": (n[0] ||= (
                                                                  t,
                                                                ) => (e.selected.all = t)),
                                                                onChange: l,
                                                              },
                                                              null,
                                                              8,
                                                              [`modelValue`],
                                                            ),
                                                          ]))
                                                        : U(``, !0),
                                                      H(` ` + T(t.label) + ` `, 1),
                                                      t.sortable
                                                        ? (A(),
                                                          M(`span`, CJ, [
                                                            o.value == t.key
                                                              ? (A(),
                                                                M(
                                                                  ke,
                                                                  {
                                                                    key: 0,
                                                                  },
                                                                  [
                                                                    !s.value || s.value == `asc`
                                                                      ? (A(), M(`i`, wJ))
                                                                      : U(``, !0),
                                                                    s.value == `desc`
                                                                      ? (A(), M(`i`, TJ))
                                                                      : U(``, !0),
                                                                  ],
                                                                  64,
                                                                ))
                                                              : (A(), M(`i`, EJ)),
                                                          ]))
                                                        : U(``, !0),
                                                    ],
                                                    10,
                                                    xJ,
                                                  ))
                                                : U(``, !0),
                                            ],
                                            64,
                                          )
                                        ),
                                      ),
                                      256,
                                    )),
                                  ]),
                                ]),
                                W(`tbody`, DJ, [
                                  e.selected.global || e.selected.items.length > 0
                                    ? (A(),
                                      L(
                                        h,
                                        {
                                          key: 0,
                                        },
                                        {
                                          default: I(() => [
                                            N(
                                              m,
                                              {
                                                name: `selectAll`,
                                                colspan: 100,
                                              },
                                              {
                                                default: I(() => [
                                                  W(`div`, OJ, [
                                                    H(
                                                      T(
                                                        t.$trans(`global.record_selected`, {
                                                          attribute: e.selected.global
                                                            ? e.meta.total
                                                            : e.selected.items.length,
                                                        }),
                                                      ) + ` `,
                                                      1,
                                                    ),
                                                    W(
                                                      `span`,
                                                      {
                                                        class: `cursor-pointer underline`,
                                                        onClick: u,
                                                      },
                                                      [
                                                        e.selected.global
                                                          ? (A(),
                                                            M(
                                                              `span`,
                                                              AJ,
                                                              T(
                                                                t.$trans(
                                                                  `general.unselect_all_records`,
                                                                ),
                                                              ),
                                                              1,
                                                            ))
                                                          : (A(),
                                                            M(
                                                              `span`,
                                                              kJ,
                                                              T(
                                                                t.$trans(
                                                                  `global.select_all_records`,
                                                                  {
                                                                    attribute: e.meta.total,
                                                                  },
                                                                ),
                                                              ),
                                                              1,
                                                            )),
                                                      ],
                                                    ),
                                                  ]),
                                                ]),
                                                _: 1,
                                              },
                                            ),
                                          ]),
                                          _: 1,
                                        },
                                      ))
                                    : U(``, !0),
                                  z(t.$slots, `default`),
                                  e.meta.from === null || e.meta.to === null
                                    ? (A(),
                                      M(`tr`, jJ, [
                                        W(
                                          `td`,
                                          MJ,
                                          T(t.$trans(`general.errors.record_not_found`)),
                                          1,
                                        ),
                                      ]))
                                    : U(``, !0),
                                ]),
                                e.meta.hasFooter
                                  ? (A(),
                                    M(`tfoot`, NJ, [
                                      W(`tr`, null, [
                                        (A(!0),
                                        M(
                                          ke,
                                          null,
                                          ae(
                                            e.header,
                                            (e) => (
                                              A(),
                                              M(
                                                ke,
                                                null,
                                                [
                                                  f(e)
                                                    ? (A(),
                                                      M(
                                                        `td`,
                                                        {
                                                          key: 0,
                                                          class: O([
                                                            `dark:bg-dark-header py-3 text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400 sm:px-2 xl:px-4`,
                                                            {
                                                              "text-right":
                                                                d(e.key, `align`) == `right`,
                                                              "text-center":
                                                                d(e.key, `align`) == `center`,
                                                            },
                                                          ]),
                                                        },
                                                        T(d(e.key)),
                                                        3,
                                                      ))
                                                    : U(``, !0),
                                                ],
                                                64,
                                              )
                                            ),
                                          ),
                                          256,
                                        )),
                                      ]),
                                    ]))
                                  : U(``, !0),
                              ]),
                            ],
                            2,
                          ),
                          W(`table`, PJ, [
                            W(`tbody`, FJ, [
                              e.selected.global || e.selected.items.length > 0
                                ? (A(),
                                  M(`tr`, IJ, [
                                    W(`td`, LJ, [
                                      W(`div`, RJ, [
                                        H(
                                          T(
                                            t.$trans(`global.record_selected`, {
                                              attribute: e.selected.global
                                                ? e.meta.total
                                                : e.selected.items.length,
                                            }),
                                          ) + ` `,
                                          1,
                                        ),
                                        W(
                                          `span`,
                                          {
                                            class: `cursor-pointer underline`,
                                            onClick: u,
                                          },
                                          [
                                            e.selected.global
                                              ? (A(),
                                                M(
                                                  `span`,
                                                  BJ,
                                                  T(t.$trans(`general.unselect_all_records`)),
                                                  1,
                                                ))
                                              : (A(),
                                                M(
                                                  `span`,
                                                  zJ,
                                                  T(
                                                    t.$trans(`global.select_all_records`, {
                                                      attribute: e.meta.total,
                                                    }),
                                                  ),
                                                  1,
                                                )),
                                          ],
                                        ),
                                      ]),
                                    ]),
                                  ]))
                                : U(``, !0),
                              z(t.$slots, `default`),
                              e.meta.from === null || e.meta.to === null
                                ? (A(),
                                  M(`tr`, VJ, [
                                    W(`td`, HJ, T(t.$trans(`general.errors.record_not_found`)), 1),
                                  ]))
                                : U(``, !0),
                            ]),
                          ]),
                          z(t.$slots, `actions`),
                          N(
                            g,
                            {
                              meta: e.meta,
                              onRefresh: (n[1] ||= (e) => i(`refresh`)),
                            },
                            null,
                            8,
                            [`meta`],
                          ),
                        ]),
                        _: 3,
                      },
                    ))
                  : U(``, !0),
                e.meta.total === 0
                  ? (A(),
                    L(
                      v,
                      {
                        key: 1,
                      },
                      {
                        default: I(() => [
                          e.module
                            ? (A(),
                              M(`div`, UJ, [
                                (n[2] ||= W(
                                  `i`,
                                  {
                                    class: `fas fa-list fa-4x`,
                                  },
                                  null,
                                  -1,
                                )),
                                W(
                                  `p`,
                                  WJ,
                                  T(t.$trans(e.module + `.module_title`, a.moduleTransParams)),
                                  1,
                                ),
                                P(c)(e.module + `.module_quote`)
                                  ? (A(),
                                    M(
                                      `p`,
                                      GJ,
                                      T(t.$trans(e.module + `.module_quote`, a.moduleTransParams)),
                                      1,
                                    ))
                                  : U(``, !0),
                                W(
                                  `p`,
                                  null,
                                  T(
                                    t.$trans(e.module + `.module_description`, a.moduleTransParams),
                                  ),
                                  1,
                                ),
                                P(c)(e.module + `.module_example`)
                                  ? (A(),
                                    M(
                                      `p`,
                                      KJ,
                                      T(
                                        t.$trans(e.module + `.module_example`, a.moduleTransParams),
                                      ),
                                      1,
                                    ))
                                  : U(``, !0),
                                W(`div`, null, [z(t.$slots, `actionButton`)]),
                              ]))
                            : (A(), M(`div`, qJ, [z(t.$slots, `alert`)])),
                        ]),
                        _: 3,
                      },
                    ))
                  : U(``, !0),
              ],
              64,
            )
          );
        };
      },
    },
  ),
  YJ = i({
    default: () => XJ,
  });
B();
var XJ = Object.assign(
    {
      name: `ListItem`,
    },
    {
      props: {
        initUrl: {
          type: String,
          default: ``,
          required: !0,
        },
        uuid: {
          type: String,
          default: ``,
        },
        preRequisites: {
          type: [Boolean, String],
          default: !1,
        },
        additionalQuery: {
          type: Object,
          default: () => ({}),
        },
        spacing: {
          type: Boolean,
          default: !0,
        },
        refresh: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`setPreRequisites`, `setItems`, `resetSelected`, `refreshed`, `preRequisiteFailed`],
      setup(e, { emit: t }) {
        let n = Dc(),
          r = $e(),
          i = R(`emitter`),
          a = t,
          o = e,
          s = F(!1),
          c = () => {
            let e = {};
            (n.params.uuid &&
              (e = {
                uuid: n.params.uuid,
              }),
              (s.value = !0),
              r
                .dispatch(o.initUrl + `preRequisite`, {
                  ...e,
                  routeParams: n.params,
                })
                .then((e) => {
                  ((s.value = !1), a(`setPreRequisites`, e), l());
                })
                .catch((e) => {
                  ((s.value = !1), a(`preRequisiteFailed`, e));
                }));
          },
          l = () => {
            let e = n.query;
            (o.additionalQuery &&
              (e = {
                ...e,
                ...o.additionalQuery,
              }),
              (s.value = !0),
              r
                .dispatch(o.initUrl + `list`, {
                  uuid: o.uuid,
                  params: e,
                  queryType: n.meta.queryType,
                  routeParams: n.params,
                })
                .then((e) => {
                  ((s.value = !1), a(`setItems`, e));
                })
                .catch((e) => {
                  s.value = !1;
                }));
          },
          u = async (e) => {
            (e.force ? await db() : await lb()) &&
              ((s.value = !0),
              await r
                .dispatch(o.initUrl + `delete`, {
                  uuid: o.uuid || e.uuid,
                  moduleUuid: e.moduleUuid,
                  queryType: n.meta.queryType,
                  force: e.force || !1,
                  routeParams: n.params,
                })
                .then(() => {
                  ((s.value = !1), l());
                })
                .catch((e) => {
                  s.value = !1;
                }));
          },
          d = async (e) => {
            (await lb()) &&
              ((s.value = !0),
              await r
                .dispatch(o.initUrl + `deleteItems`, {
                  moduleUuid: o.moduleUuid,
                  global: e.global,
                  uuids: e.uuids,
                  params: n.query,
                  queryType: n.meta.queryType,
                  routeParams: n.params,
                })
                .then(() => {
                  ((s.value = !1), a(`resetSelected`), l());
                })
                .catch((e) => {
                  s.value = !1;
                }));
          },
          f = async (e) => {
            ((s.value = !0),
              await r
                .dispatch(o.initUrl + e.action, {
                  uuid: e.uuid,
                  moduleUuid: e.moduleUuid,
                  data: e.data,
                  routeParams: n.params,
                })
                .then(() => {
                  ((s.value = !1), l(), i.emit(`actionPerformed`));
                })
                .catch((e) => {
                  s.value = !1;
                }));
          },
          p = async (e) => {
            ((s.value = !0),
              await r
                .dispatch(o.initUrl + e.action, {
                  moduleUuid: o.moduleUuid,
                  global: e.global,
                  uuids: e.uuids,
                  params: n.query,
                  queryType: n.meta.queryType,
                  routeParams: n.params,
                })
                .then(() => {
                  ((s.value = !1), l(), i.emit(`actionPerformed`));
                })
                .catch((e) => {
                  s.value = !1;
                }));
          };
        return (
          Qe(async () => {
            (i.on(`listItems`, () => {
              l();
            }),
              i.on(`deleteItem`, (e) => {
                u(e);
              }),
              i.on(`deleteItems`, (e) => {
                d(e);
              }),
              i.on(`actionItem`, async (e) => {
                e.confirmation
                  ? (await ub()) && f(e)
                  : e.confirmationWithPassword
                    ? (await db()) && f(e)
                    : f(e);
              }),
              i.on(`actionItems`, async (e) => {
                e.confirmation ? (await ub()) && p(e) : p(e);
              }),
              o.preRequisites ? c() : l());
          }),
          oe(() => {
            (i.all.delete(`listItems`),
              i.all.delete(`deleteItem`),
              i.all.delete(`deleteItems`),
              i.all.delete(`actionItem`));
          }),
          He(
            () => o.refresh,
            (e) => {
              e && (l(), a(`refreshed`));
            },
          ),
          (t, n) => {
            let r = j(`BaseLoader`);
            return (
              A(),
              M(
                `div`,
                {
                  class: O({
                    "space-y-4": e.spacing,
                  }),
                },
                [
                  W(`div`, null, [z(t.$slots, `header`)]),
                  W(`div`, null, [z(t.$slots, `after-header`)]),
                  W(`div`, null, [z(t.$slots, `import`)]),
                  W(`div`, null, [z(t.$slots, `before-filter`)]),
                  W(`div`, null, [z(t.$slots, `filter`)]),
                  W(`div`, null, [z(t.$slots, `after-filter`)]),
                  N(
                    r,
                    {
                      "is-loading": s.value,
                    },
                    {
                      default: I(() => [z(t.$slots, `default`)]),
                      _: 3,
                    },
                    8,
                    [`is-loading`],
                  ),
                ],
                2,
              )
            );
          }
        );
      },
    },
  ),
  ZJ = i({
    default: () => fY,
  });
B();
var QJ = {
    key: 0,
    class: `flex flex-1 justify-between text-gray-700 dark:text-gray-400 sm:hidden`,
  },
  $J = {
    key: 0,
    class: `dark:bg-dark-body relative inline-flex items-center rounded-md border border-gray-300 bg-gray-200 px-4 py-2 text-sm font-medium dark:border-gray-700`,
  },
  eY = {
    key: 0,
    class: `dark:bg-dark-body relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-gray-200 px-4 py-2 text-sm font-medium dark:border-gray-700`,
  },
  tY = {
    class: `hidden text-gray-700 dark:text-gray-400 sm:flex sm:flex-1 sm:items-center sm:justify-between`,
  },
  nY = {
    key: 0,
    class: `text-sm`,
  },
  rY = {
    class: `flex items-center justify-between space-x-4`,
  },
  iY = {
    key: 1,
  },
  aY = {
    class: `relative z-0 inline-flex -space-x-px rounded-md shadow-xs`,
    "aria-label": `Pagination`,
  },
  oY = {
    class: `sr-only`,
  },
  sY = {
    class: `sr-only`,
  },
  cY = [`onClick`],
  lY = {
    key: 1,
    "aria-current": `page`,
    class: `dark:bg-dark-header relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 dark:border-gray-700`,
  },
  uY = {
    class: `sr-only`,
  },
  dY = {
    class: `sr-only`,
  },
  fY = {
    __name: `Pagination`,
    props: {
      meta: {
        type: Object,
        default: {},
      },
      limit: {
        type: Number,
        default: 1,
      },
      cardView: {
        type: Boolean,
        default: !1,
      },
      transparent: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [`refresh`],
    setup(e, { emit: t }) {
      let n = Dc(),
        r = Ec(),
        i = $e(),
        { isRtl: a } = Kh(),
        o = t,
        s = e,
        c = V(() => i.getters[`config/config`](`system.paginations`) ?? []),
        l = V(() => i.getters[`config/config`](`system.perPage`) ?? []),
        u = V(() => n.query.currentPage ?? 1),
        d = V(() => n.query.perPage ?? l.value),
        f = V(() => {
          if (s.limit === -1) return 0;
          if (s.limit === 0) return s.meta.lastPage;
          for (
            var e = u.value,
              t = s.meta.lastPage,
              n = s.limit,
              r = e - n,
              i = Number(e) + Number(n) + 1,
              a = [],
              o = [],
              c,
              l = 1;
            l <= t;
            l++
          )
            (l === 1 || l === t || (l >= r && l < i)) && a.push(l);
          return (
            a.forEach(function (e) {
              (c && (e - c === 2 ? o.push(c + 1) : e - c !== 1 && o.push(`...`)),
                o.push(e),
                (c = e));
            }),
            o
          );
        }),
        p = (e) => {
          e !== `...` &&
            (e > s.meta.lastPage ||
              e < 1 ||
              h({
                currentPage: e,
              }));
        },
        m = (e) => {
          h({
            perPage: e,
            currentPage: 1,
          });
        },
        h = async (e) => {
          (await r.push({
            name: n.name,
            query: {
              ...n.query,
              ...e,
            },
          }),
            o(`refresh`));
        };
      return (t, n) => {
        let r = j(`DropdownItem`),
          i = j(`DropdownButton`);
        return e.meta.from && e.meta.to
          ? (A(),
            M(
              `div`,
              {
                key: 0,
                class: O([
                  `flex items-center justify-between px-2 py-3 sm:rounded-bl-lg sm:rounded-br-lg`,
                  {
                    "bg-white dark:bg-dark-subheader border-t border-gray-200 dark:border-gray-700 ":
                      !e.transparent,
                  },
                ]),
              },
              [
                e.meta.lastPage >= 1
                  ? (A(),
                    M(`div`, QJ, [
                      W(`div`, null, [
                        u.value <= 1
                          ? (A(), M(`span`, $J, T(t.$trans(`pagination.previous`)), 1))
                          : (A(),
                            M(
                              `a`,
                              {
                                key: 1,
                                onClick: (n[0] ||= (e) => p(u.value - 1)),
                                href: `#`,
                                class: `dark:bg-dark-body relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium hover:bg-gray-50 dark:border-gray-700`,
                              },
                              T(t.$trans(`pagination.previous`)),
                              1,
                            )),
                      ]),
                      W(`div`, null, [
                        u.value >= e.meta.lastPage
                          ? (A(), M(`span`, eY, T(t.$trans(`pagination.next`)), 1))
                          : (A(),
                            M(
                              `a`,
                              {
                                key: 1,
                                onClick: (n[1] ||= (e) => p(+u.value + 1)),
                                href: `#`,
                                class: `dark:bg-dark-body relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium hover:bg-gray-50 dark:border-gray-700`,
                              },
                              T(t.$trans(`pagination.next`)),
                              1,
                            )),
                      ]),
                    ]))
                  : U(``, !0),
                W(`div`, tY, [
                  W(`div`, null, [
                    e.meta.from && e.meta.to
                      ? (A(),
                        M(
                          `p`,
                          nY,
                          T(
                            t.$trans(`pagination.showing_result`, {
                              from: e.meta.from,
                              to: e.meta.to,
                              total: e.meta.total,
                            }),
                          ),
                          1,
                        ))
                      : U(``, !0),
                  ]),
                  W(`div`, rY, [
                    c.value.length && !e.cardView
                      ? (A(),
                        L(
                          i,
                          {
                            key: 0,
                            direction: `up`,
                            label: t.$trans(`pagination.list_per_page`, {
                              attribute: d.value,
                            }),
                          },
                          {
                            default: I(() => [
                              (A(!0),
                              M(
                                ke,
                                null,
                                ae(
                                  c.value,
                                  (e) => (
                                    A(),
                                    M(
                                      `div`,
                                      {
                                        key: e,
                                      },
                                      [
                                        e == d.value
                                          ? U(``, !0)
                                          : (A(),
                                            L(
                                              r,
                                              {
                                                key: 0,
                                                as: `span`,
                                                onClick: (t) => m(e),
                                              },
                                              {
                                                default: I(() => [
                                                  H(
                                                    T(
                                                      t.$trans(`pagination.list_per_page`, {
                                                        attribute: e,
                                                      }),
                                                    ),
                                                    1,
                                                  ),
                                                ]),
                                                _: 2,
                                              },
                                              1032,
                                              [`onClick`],
                                            )),
                                      ],
                                    )
                                  ),
                                ),
                                128,
                              )),
                            ]),
                            _: 1,
                          },
                          8,
                          [`label`],
                        ))
                      : U(``, !0),
                    e.meta.lastPage >= 1
                      ? (A(),
                        M(`div`, iY, [
                          W(`nav`, aY, [
                            u.value <= 1
                              ? (A(),
                                M(
                                  `span`,
                                  {
                                    key: 0,
                                    class: O([
                                      `dark:bg-dark-header relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 dark:border-gray-700`,
                                      P(a) ? `rounded-r-md` : `rounded-l-md`,
                                    ]),
                                  },
                                  [
                                    W(`span`, oY, T(t.$trans(`pagination.previous`)), 1),
                                    P(a)
                                      ? (A(),
                                        L(P(Vy), {
                                          key: 0,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        }))
                                      : (A(),
                                        L(P(By), {
                                          key: 1,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        })),
                                  ],
                                  2,
                                ))
                              : (A(),
                                M(
                                  `a`,
                                  {
                                    key: 1,
                                    onClick: (n[2] ||= (e) => p(u.value - 1)),
                                    href: `#`,
                                    class: O([
                                      `dark:bg-dark-header relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 dark:border-gray-700`,
                                      P(a) ? `rounded-r-md` : `rounded-l-md`,
                                    ]),
                                  },
                                  [
                                    W(`span`, sY, T(t.$trans(`pagination.previous`)), 1),
                                    P(a)
                                      ? (A(),
                                        L(P(Vy), {
                                          key: 0,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        }))
                                      : (A(),
                                        L(P(By), {
                                          key: 1,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        })),
                                  ],
                                  2,
                                )),
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                f.value,
                                (e, t) => (
                                  A(),
                                  M(
                                    ke,
                                    null,
                                    [
                                      e == `...`
                                        ? (A(), M(`span`, lY, T(e), 1))
                                        : (A(),
                                          M(
                                            `a`,
                                            {
                                              key: 0,
                                              href: `#`,
                                              onClick: (t) => p(e),
                                              "aria-current": `page`,
                                              class: O([
                                                `relative inline-flex items-center border px-4 py-2 text-sm font-medium`,
                                                {
                                                  "bg-primary dark:bg-dark-body border-primary text-secondary z-10 dark:border-gray-700":
                                                    e == u.value,
                                                  "dark:bg-dark-header dark:hover:bg-dark-body border-gray-300 bg-white text-gray-500 hover:bg-gray-50 dark:border-gray-700":
                                                    e != u.value,
                                                },
                                              ]),
                                            },
                                            T(e),
                                            11,
                                            cY,
                                          )),
                                    ],
                                    64,
                                  )
                                ),
                              ),
                              256,
                            )),
                            u.value >= e.meta.lastPage
                              ? (A(),
                                M(
                                  `span`,
                                  {
                                    key: 2,
                                    class: O([
                                      `dark:bg-dark-header relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 dark:border-gray-700`,
                                      P(a) ? `rounded-l-md` : `rounded-r-md`,
                                    ]),
                                  },
                                  [
                                    W(`span`, uY, T(t.$trans(`pagination.next`)), 1),
                                    P(a)
                                      ? (A(),
                                        L(P(By), {
                                          key: 0,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        }))
                                      : (A(),
                                        L(P(Vy), {
                                          key: 1,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        })),
                                  ],
                                  2,
                                ))
                              : (A(),
                                M(
                                  `a`,
                                  {
                                    key: 3,
                                    onClick: (n[3] ||= (e) => p(+u.value + 1)),
                                    href: `#`,
                                    class: O([
                                      `dark:bg-dark-header relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 dark:border-gray-700`,
                                      P(a) ? `rounded-l-md` : `rounded-r-md`,
                                    ]),
                                  },
                                  [
                                    W(`span`, dY, T(t.$trans(`pagination.next`)), 1),
                                    P(a)
                                      ? (A(),
                                        L(P(By), {
                                          key: 0,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        }))
                                      : (A(),
                                        L(P(Vy), {
                                          key: 1,
                                          class: `h-5 w-5`,
                                          "aria-hidden": `true`,
                                        })),
                                  ],
                                  2,
                                )),
                          ]),
                        ]))
                      : U(``, !0),
                  ]),
                ]),
              ],
              2,
            ))
          : U(``, !0);
      };
    },
  },
  pY = i({
    default: () => gY,
  });
B();
var mY = {
    class: `py-1`,
  },
  hY = {
    class: `py-1`,
  },
  gY = Object.assign(
    {
      name: `RowAction`,
    },
    {
      setup(e) {
        return (e, t) => (
          A(),
          L(
            P(Xm),
            {
              as: `div`,
              class: `relative flex items-center justify-end`,
            },
            {
              default: I(() => [
                N(
                  P(Zm),
                  {
                    class: `inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2`,
                  },
                  {
                    default: I(() => [
                      (t[0] ||= W(
                        `span`,
                        {
                          class: `sr-only`,
                        },
                        `Open options`,
                        -1,
                      )),
                      N(P(Wy), {
                        class: `h-5 w-5`,
                        "aria-hidden": `true`,
                      }),
                    ]),
                    _: 1,
                  },
                ),
                N(
                  Ve,
                  {
                    "enter-active-class": `transition duration-100 ease-out`,
                    "enter-from-class": `transform scale-95 opacity-0`,
                    "enter-to-class": `transform scale-100 opacity-100`,
                    "leave-active-class": `transition duration-75 ease-in`,
                    "leave-from-class": `transform scale-100 opacity-100`,
                    "leave-to-class": `transform scale-95 opacity-0`,
                  },
                  {
                    default: I(() => [
                      N(
                        P(Qm),
                        {
                          class: `absolute right-7 top-0 z-10 mx-3 mt-1 w-48 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-black/5 focus:outline-none`,
                        },
                        {
                          default: I(() => [
                            W(`div`, mY, [
                              N(P($m), null, {
                                default: I(({ active: e }) => [
                                  W(
                                    `a`,
                                    {
                                      href: `#`,
                                      class: O([
                                        e ? `bg-gray-100 text-gray-900` : `text-gray-700`,
                                        `group flex items-center px-4 py-2 text-sm`,
                                      ]),
                                    },
                                    [
                                      N(P(qy), {
                                        class: `mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500`,
                                        "aria-hidden": `true`,
                                      }),
                                      (t[1] ||= H(` Edit `, -1)),
                                    ],
                                    2,
                                  ),
                                ]),
                                _: 1,
                              }),
                              N(P($m), null, {
                                default: I(({ active: e }) => [
                                  W(
                                    `a`,
                                    {
                                      href: `#`,
                                      class: O([
                                        e ? `bg-gray-100 text-gray-900` : `text-gray-700`,
                                        `group flex items-center px-4 py-2 text-sm`,
                                      ]),
                                    },
                                    [
                                      N(P(Jy), {
                                        class: `mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500`,
                                        "aria-hidden": `true`,
                                      }),
                                      (t[2] ||= H(` Duplicate `, -1)),
                                    ],
                                    2,
                                  ),
                                ]),
                                _: 1,
                              }),
                              N(P($m), null, {
                                default: I(({ active: e }) => [
                                  W(
                                    `a`,
                                    {
                                      href: `#`,
                                      class: O([
                                        e ? `bg-gray-100 text-gray-900` : `text-gray-700`,
                                        `group flex items-center px-4 py-2 text-sm`,
                                      ]),
                                    },
                                    [
                                      N(P(Xy), {
                                        class: `mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500`,
                                        "aria-hidden": `true`,
                                      }),
                                      (t[3] ||= H(` Share `, -1)),
                                    ],
                                    2,
                                  ),
                                ]),
                                _: 1,
                              }),
                            ]),
                            W(`div`, hY, [
                              N(P($m), null, {
                                default: I(({ active: e }) => [
                                  W(
                                    `a`,
                                    {
                                      href: `#`,
                                      class: O([
                                        e ? `bg-gray-100 text-gray-900` : `text-gray-700`,
                                        `group flex items-center px-4 py-2 text-sm`,
                                      ]),
                                    },
                                    [
                                      N(P(Yy), {
                                        class: `mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500`,
                                        "aria-hidden": `true`,
                                      }),
                                      (t[4] ||= H(` Delete `, -1)),
                                    ],
                                    2,
                                  ),
                                ]),
                                _: 1,
                              }),
                            ]),
                          ]),
                          _: 1,
                        },
                      ),
                    ]),
                    _: 1,
                  },
                ),
              ]),
              _: 1,
            },
          )
        );
      },
    },
  ),
  _Y = i({
    default: () => yY,
  });
B();
var vY = {
    class: `space-y-4`,
  },
  yY = Object.assign(
    {
      name: `ShowItem`,
    },
    {
      props: {
        initUrl: {
          type: String,
          default: ``,
          required: !0,
        },
        uuid: {
          type: String,
          default: ``,
          required: !0,
        },
        moduleUuid: {
          type: String,
          default: ``,
        },
        preRequisites: {
          type: [Boolean, String, Object],
          default: !1,
        },
        preRequisiteUrl: {
          type: String,
          default: ``,
        },
        preRequisiteCustomUrl: {
          type: String,
          default: ``,
        },
        preRequisiteHasAdditionalParams: {
          type: Boolean,
          default: !1,
        },
        preRequisiteAdditionalParams: {
          type: Object,
          default: () => ({}),
        },
        redirect: {
          type: [String, Object],
          default: ``,
        },
        refresh: {
          type: Boolean,
          default: !1,
        },
        additionalQuery: {
          type: Object,
          default: () => ({}),
        },
      },
      emits: [`setItem`, `redirectTo`, `refreshed`, `setPreRequisites`, `preRequisiteFailed`],
      setup(e, { emit: t }) {
        let n = Dc(),
          r = Ec(),
          i = $e(),
          a = R(`emitter`),
          o = t,
          s = e,
          c = F(!1),
          l = async () => {
            c.value = !0;
            let e = s.preRequisites;
            (typeof s.preRequisites == `string`
              ? (e = {
                  data: s.preRequisites,
                })
              : typeof s.preRequisites == `boolean` && s.preRequisiteHasAdditionalParams
                ? (e = {
                    data: s.preRequisiteAdditionalParams,
                  })
                : n.params.uuid &&
                  (e =
                    typeof s.preRequisites == `object`
                      ? {
                          ...s.preRequisites,
                          uuid: n.params.uuid,
                        }
                      : {
                          uuid: n.params.uuid,
                        }),
              await i
                .dispatch(
                  (s.preRequisiteUrl || s.initUrl) + (s.preRequisiteCustomUrl || `preRequisite`),
                  {
                    ...e,
                    routeParams: n.params,
                  },
                )
                .then((e) => ((c.value = !1), o(`setPreRequisites`, e), !0))
                .catch((e) => ((c.value = !1), o(`preRequisiteFailed`, e), !1)));
          },
          u = async () => {
            ((c.value = !0),
              await i
                .dispatch(s.initUrl + `get`, {
                  uuid: s.uuid,
                  moduleUuid: s.moduleUuid,
                  params: s.additionalQuery,
                  routeParams: n.params,
                })
                .then((e) => {
                  ((c.value = !1), o(`setItem`, e));
                })
                .catch((e) => {
                  ((c.value = !1), p());
                }));
          },
          d = async (e) => {
            (await lb()) &&
              ((c.value = !0),
              await i
                .dispatch(s.initUrl + `delete`, {
                  uuid: e.uuid,
                  routeParams: n.params,
                })
                .then(() => {
                  ((c.value = !1), p());
                })
                .catch((e) => {
                  c.value = !1;
                }));
          },
          f = async (e) => {
            ((c.value = !0),
              await i
                .dispatch(s.initUrl + e.action, {
                  uuid: e.uuid,
                  moduleUuid: e.moduleUuid,
                  data: e.data,
                  routeParams: n.params,
                })
                .then(() => {
                  ((c.value = !1), u(), a.emit(`showActionPerformed`));
                })
                .catch((e) => {
                  c.value = !1;
                }));
          },
          p = () => {
            s.redirect && typeof s.redirect == `string`
              ? r.push({
                  name: s.redirect,
                })
              : s.redirect && typeof s.redirect == `object`
                ? r.push(s.redirect)
                : o(`redirectTo`);
          };
        return (
          He(
            () => s.refresh,
            (e) => {
              e && (u(), o(`refreshed`));
            },
          ),
          Qe(async () => {
            (a.on(`showDeleteItem`, (e) => {
              d(e);
            }),
              a.on(`showActionItem`, async (e) => {
                e.confirmation ? (await ub()) && f(e) : f(e);
              }),
              a.on(`refreshItem`, (e) => {
                u();
              }));
            let e = !0;
            (s.preRequisites && (e = await l()), e && u());
          }),
          oe(() => {
            (a.all.delete(`showDeleteItem`),
              a.all.delete(`showActionItem`),
              a.all.delete(`refreshItem`));
          }),
          (e, t) => {
            let n = j(`BaseLoader`);
            return (
              A(),
              L(
                n,
                {
                  "is-loading": c.value,
                },
                {
                  default: I(() => [W(`div`, vY, [z(e.$slots, `default`)])]),
                  _: 3,
                },
                8,
                [`is-loading`],
              )
            );
          }
        );
      },
    },
  ),
  bY = i({
    default: () => TY,
  });
B();
var xY = {
    class: `bg-gray-50 dark:bg-dark-subheader`,
  },
  SY = {
    class: `divide-y divide-gray-200 bg-white dark:divide-gray-700`,
  },
  CY = {
    key: 0,
    class: `bg-gray-50 dark:bg-dark-subheader`,
  },
  wY = {
    key: 0,
  },
  TY = Object.assign(
    {
      name: `SimpleTable`,
    },
    {
      props: {
        header: {
          type: Array,
          default: [],
        },
        subHeader: {
          type: Array,
          default: [],
        },
        footer: {
          type: Array,
          default: [],
        },
        bordered: {
          type: Boolean,
          default: !1,
        },
        scroll: {
          type: Boolean,
          default: !0,
        },
        corner: {
          type: String,
          default: `rounded`,
        },
        verticalAlign: {
          type: String,
          default: `top`,
          validator(e) {
            return [`top`, `bottom`, `middle`].includes(e);
          },
        },
      },
      emits: [`refresh`],
      setup(e, { emit: t }) {
        (Dc(), Ec(), Te());
        let n = e;
        return (
          ge(
            `Header`,
            V(() => n.header),
          ),
          ge(
            `SubHeader`,
            V(() => n.subHeader),
          ),
          ge(
            `VerticalAlign`,
            V(() => n.verticalAlign),
          ),
          ge(`TextColor`, ``),
          (t, n) => (
            A(),
            M(
              `div`,
              {
                class: O({
                  "scroller-thin-x": e.scroll,
                }),
              },
              [
                W(
                  `table`,
                  {
                    class: O([
                      `hidden min-w-full divide-y divide-gray-200 dark:divide-gray-700 md:table`,
                      {
                        "rounded-table": e.corner == `rounded`,
                      },
                    ]),
                  },
                  [
                    W(`thead`, xY, [
                      W(`tr`, null, [
                        (A(!0),
                        M(
                          ke,
                          null,
                          ae(
                            e.header,
                            (t) => (
                              A(),
                              M(
                                `th`,
                                {
                                  key: t.key,
                                  scope: `col`,
                                  class: O([
                                    `py-3 ltr:text-left rtl:text-right text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400 sm:px-2 xl:px-4`,
                                    {
                                      "border border-gray-200 dark:border-gray-600": e.bordered,
                                      "ltr:text-right rtl:text-left": t.align == `right`,
                                      "text-center": t.align == `center`,
                                    },
                                  ]),
                                },
                                T(t.label),
                                3,
                              )
                            ),
                          ),
                          128,
                        )),
                        z(t.$slots, `header`),
                      ]),
                    ]),
                    W(`tbody`, SY, [z(t.$slots, `default`)]),
                    t.$slots.footer
                      ? (A(), M(`tfoot`, CY, [W(`tr`, null, [z(t.$slots, `footer`)])]))
                      : U(``, !0),
                  ],
                  2,
                ),
                W(
                  `table`,
                  {
                    class: O([
                      `min-w-full md:hidden`,
                      {
                        "divide-y divide-gray-200 dark:divide-gray-700": !e.bordered,
                      },
                    ]),
                  },
                  [
                    W(
                      `tbody`,
                      {
                        class: O([
                          `bg-white`,
                          {
                            "divide-y divide-gray-200 dark:divide-gray-700": !e.bordered,
                          },
                        ]),
                      },
                      [z(t.$slots, `default`)],
                      2,
                    ),
                    t.$slots.footer ? (A(), M(`tfoot`, wY, [z(t.$slots, `footer`)])) : U(``, !0),
                  ],
                  2,
                ),
              ],
              2,
            )
          )
        );
      },
    },
  ),
  EY = i({
    default: () => IY,
  });
B();
var DY = {
    class: `space-y-4`,
  },
  OY = {
    class: `flex-shrink-0`,
  },
  kY = [`src`, `alt`],
  AY = {
    class: `flex-1`,
  },
  jY = {
    class: `bg-gray-50 dark:bg-dark-body rounded-lg p-4`,
  },
  MY = {
    class: `flex items-center justify-between text-xs mb-2`,
  },
  NY = {
    class: `font-medium text-gray-900 dark:text-gray-400`,
  },
  PY = {
    class: `text-gray-500 dark:text-gray-400`,
  },
  FY = {
    class: `text-gray-700 dark:text-gray-400 text-sm`,
  },
  IY = Object.assign(
    {
      name: `ActivityLog`,
    },
    {
      props: {
        type: {
          type: String,
          required: !0,
        },
        uuid: {
          type: String,
          required: !0,
        },
        moduleType: {
          type: String,
          required: !1,
        },
        moduleUuid: {
          type: String,
          required: !1,
        },
        activities: {
          type: Array,
          required: !1,
        },
      },
      setup(e) {
        (Dc(), $e());
        let t = e;
        (Bh(`activity/`),
          F(!1),
          Ae({
            body: ``,
          }));
        let n = Ae({
          activities: [],
        });
        return (
          He(
            () => t.activities,
            (e) => {
              n.activities = e;
            },
            {
              immediate: !0,
            },
          ),
          (e, t) => (
            A(),
            M(`div`, DY, [
              (A(!0),
              M(
                ke,
                null,
                ae(
                  n.activities,
                  (e) => (
                    A(),
                    M(
                      `div`,
                      {
                        key: e.uuid,
                        class: `flex space-x-4`,
                      },
                      [
                        W(`div`, OY, [
                          W(
                            `img`,
                            {
                              src: e.user?.avatar,
                              alt: e.user?.profile?.name,
                              class: `h-10 w-10 rounded-full object-cover`,
                            },
                            null,
                            8,
                            kY,
                          ),
                        ]),
                        W(`div`, AY, [
                          W(`div`, jY, [
                            W(`div`, MY, [
                              W(`span`, NY, T(e.user?.profile?.name), 1),
                              W(`span`, PY, T(e.createdAt.formatted), 1),
                            ]),
                            W(`p`, FY, T(e.description), 1),
                          ]),
                        ]),
                      ],
                    )
                  ),
                ),
                128,
              )),
            ])
          )
        );
      },
    },
  ),
  LY = i({
    default: () => BY,
  });
B();
var RY = [`aria-expanded`],
  zY = {
    class: `text-left flex-1 dark:text-gray-400`,
  },
  BY = {
    __name: `BaseAccordion`,
    props: {
      index: Number,
    },
    setup(e) {
      let t = e,
        n = R(`accordionGroup`, null),
        r = F(!1),
        i = F(0),
        a = F(null),
        o = null,
        s = V(() => (n && t.index !== void 0 ? n.openIndex.value === t.index : r.value));
      function c() {
        (n && t.index !== void 0 ? n.setOpenIndex(t.index) : (r.value = !r.value), de(l));
      }
      function l() {
        a.value && (i.value = s.value ? a.value.scrollHeight : 0);
      }
      (Qe(l),
        He(s, () => {
          de(l);
        }),
        Qe(() => {
          typeof ResizeObserver > `u` ||
            !a.value ||
            ((o = new ResizeObserver(() => {
              s.value && l();
            })),
            o.observe(a.value));
        }),
        oe(() => {
          o &&= (o.disconnect(), null);
        }));
      let u = V(() => ({
        maxHeight: s.value ? i.value + `px` : `0`,
      }));
      return (e, t) => (
        A(),
        M(
          `div`,
          {
            class: O([
              `rounded-lg bg-white border border-gray-200 shadow-sm dark:bg-dark-header dark:border-gray-700`,
              (s.value, ``),
            ]),
          },
          [
            W(
              `button`,
              {
                class: `w-full flex items-center justify-between px-4 py-3 text-base font-medium cursor-pointer transition-colors hover:bg-gray-50 dark:hover:bg-gray-800 hover:rounded-lg focus:outline-none`,
                onClick: c,
                "aria-expanded": s.value,
              },
              [
                W(`span`, zY, [z(e.$slots, `header`)]),
                W(
                  `span`,
                  {
                    class: O([
                      `transition-transform duration-300 flex items-center dark:text-gray-400`,
                      s.value ? `rotate-180` : ``,
                    ]),
                  },
                  [
                    ...(t[0] ||= [
                      W(
                        `svg`,
                        {
                          width: `20`,
                          height: `20`,
                          viewBox: `0 0 20 20`,
                        },
                        [
                          W(`path`, {
                            d: `M6 8l4 4 4-4`,
                            stroke: `currentColor`,
                            "stroke-width": `2`,
                            fill: `none`,
                            "stroke-linecap": `round`,
                          }),
                        ],
                        -1,
                      ),
                    ]),
                  ],
                  2,
                ),
              ],
              8,
              RY,
            ),
            W(
              `div`,
              {
                class: `overflow-hidden transition-[max-height] duration-300 ease-in-out`,
                style: Pe(u.value),
              },
              [
                W(
                  `div`,
                  {
                    ref_key: `contentRef`,
                    ref: a,
                    class: `px-4 py-3 border-t border-gray-200 text-gray-700 dark:border-gray-700 dark:text-gray-200 dark:bg-dark-header`,
                  },
                  [z(e.$slots, `default`)],
                  512,
                ),
              ],
              4,
            ),
          ],
          2,
        )
      );
    },
  },
  VY = i({
    default: () => UY,
  });
B();
var HY = {
    class: `flex flex-col gap-2 dark:bg-transparent`,
  },
  UY = {
    __name: `BaseAccordionGroup`,
    setup(e) {
      let t = F(null);
      function n(e) {
        t.value = t.value === e ? null : e;
      }
      return (
        ge(`accordionGroup`, {
          openIndex: t,
          setOpenIndex: n,
        }),
        (e, t) => (A(), M(`div`, HY, [z(e.$slots, `default`)]))
      );
    },
  },
  WY = i({
    default: () => GY,
  });
B();
var GY = Object.assign(
    {
      name: `BaseBadge`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        size: {
          type: String,
          validator(e) {
            return [`sm`, `md`, `lg`].includes(e);
          },
          default: `sm`,
        },
        roundedFull: Boolean,
        design: {
          type: String,
          validator(e) {
            return [
              `primary`,
              `secondary`,
              `info`,
              `success`,
              `warning`,
              `danger`,
              `error`,
              `custom`,
              `outline`,
            ].includes(e);
          },
          default: `primary`,
        },
        color: {
          type: String,
          default: ``,
        },
        block: {
          type: Boolean,
          default: !1,
        },
        clickable: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = e;
        return (
          V(() => !!(t.design === `custom` && _.isEmpty(t.color))),
          (t, n) =>
            e.design != `custom` || (e.design == `custom` && e.color)
              ? (A(),
                M(
                  `span`,
                  {
                    key: 0,
                    class: O([
                      `items-center font-medium`,
                      {
                        "cursor-pointer": e.clickable,
                        "mt-1 block": e.block,
                        "inline-flex": !e.block,
                        "px-2.5 py-0.5 text-xs leading-4": e.size === `sm`,
                        "px-3 py-0.5 text-sm": e.size === `md`,
                        "px-4 py-1 text-base": e.size === `lg`,
                        "rounded-full": e.roundedFull,
                        "rounded-md": !e.roundedFull,
                        "bg-primary text-secondary dark:bg-gray-700 dark:text-gray-200":
                          e.design === `primary`,
                        "bg-secondary text-primary": e.design === `secondary`,
                        "bg-success text-secondary": e.design === `success`,
                        "bg-info text-secondary": e.design === `info`,
                        "bg-warning text-secondary": e.design === `warning`,
                        "bg-danger text-secondary": e.design === `danger` || e.design === `error`,
                        "border border-current bg-transparent text-primary": e.design === `outline`,
                      },
                    ]),
                    style: Pe(
                      e.design === `custom` ? `background-color: ${e.color}; color: #fff;` : ``,
                    ),
                  },
                  [H(T(e.label) + ` `, 1), z(t.$slots, `default`)],
                  6,
                ))
              : (A(),
                M(
                  ke,
                  {
                    key: 1,
                  },
                  [H(T(e.label) + ` `, 1), z(t.$slots, `default`)],
                  64,
                ))
        );
      },
    },
  ),
  KY = i({
    default: () => OX,
  });
B();
var qY = {
    class: `lg:flex lg:h-full lg:flex-col`,
  },
  JY = {
    class: `flex items-center justify-between border-b border-gray-200 dark:border-gray-700 px-6 py-4 lg:flex-none`,
  },
  YY = {
    class: `text-base font-semibold leading-6 text-gray-900 dark:text-gray-300`,
  },
  XY = {
    datetime: `2022-01`,
  },
  ZY = {
    class: `flex items-center`,
  },
  QY = {
    class: `relative flex items-center rounded-md bg-white dark:bg-dark-header shadow-xs md:items-stretch`,
  },
  $Y = {
    class: `sr-only`,
  },
  eX = {
    class: `sr-only`,
  },
  tX = {
    class: `hidden md:ml-4 md:flex md:items-center`,
  },
  nX = {
    class: `lg:flex lg:flex-auto lg:flex-col`,
  },
  rX = {
    class: `grid grid-cols-7 gap-px border-b border-gray-300 dark:border-gray-600 bg-gray-200 dark:bg-gray-700 text-center text-xs font-semibold leading-6 text-gray-700 dark:text-gray-400 lg:flex-none`,
  },
  iX = {
    class: `bg-white dark:bg-dark-body py-2`,
  },
  aX = {
    class: `bg-white dark:bg-dark-body py-2`,
  },
  oX = {
    class: `bg-white dark:bg-dark-body py-2`,
  },
  sX = {
    class: `bg-white dark:bg-dark-body py-2`,
  },
  cX = {
    class: `bg-white dark:bg-dark-body py-2`,
  },
  lX = {
    class: `bg-white dark:bg-dark-body py-2`,
  },
  uX = {
    class: `bg-white dark:bg-dark-body py-2`,
  },
  dX = {
    class: `flex bg-gray-200 dark:bg-gray-700 text-xs leading-6 text-gray-700 dark:text-gray-400 lg:flex-auto`,
  },
  fX = [`datetime`],
  pX = {
    key: 0,
    class: `mt-2`,
  },
  mX = [`href`],
  hX = {
    class: `flex-auto truncate font-medium text-gray-900 dark:text-gray-400 group-hover:text-gray-300`,
  },
  gX = [`datetime`],
  _X = {
    key: 0,
    class: `text-gray-500`,
  },
  vX = [`datetime`],
  yX = {
    class: `sr-only`,
  },
  bX = {
    key: 0,
    class: `-mx-0.5 mt-auto flex flex-wrap-reverse`,
  },
  xX = {
    key: 0,
    class: `px-4 py-10 sm:px-6 lg:hidden`,
  },
  SX = {
    class: `divide-y divide-gray-100 overflow-hidden rounded-lg bg-white text-sm shadow ring-1 ring-black ring-black/5`,
  },
  CX = {
    class: `flex-auto`,
  },
  wX = {
    class: `font-semibold text-gray-900`,
  },
  TX = [`datetime`],
  EX = [`href`],
  DX = {
    class: `sr-only`,
  },
  OX = Object.assign(
    {
      name: `BaseCalendar`,
    },
    {
      props: {
        calendar: {
          type: Object,
          required: !0,
        },
      },
      emits: [`previousMonth`, `nextMonth`],
      setup(e, { emit: t }) {
        let n = t,
          r = e.calendar.days.find((e) => e.isSelected);
        return (t, i) => {
          let a = ve(`tooltip`);
          return (
            A(),
            M(`div`, qY, [
              W(`header`, JY, [
                W(`h1`, YY, [W(`time`, XY, T(e.calendar.month), 1)]),
                W(`div`, ZY, [
                  W(`div`, QY, [
                    W(
                      `span`,
                      {
                        class: `cursor-pointer flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-gray-300 dark:border-gray-500 pr-1 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50 dark:md:hover:bg-black`,
                        onClick: (i[0] ||= (e) => n(`previousMonth`)),
                      },
                      [
                        W(`span`, $Y, T(t.$trans(`pagination.previous`)), 1),
                        N(P(By), {
                          class: `h-5 w-5`,
                          "aria-hidden": `true`,
                        }),
                      ],
                    ),
                    (i[2] ||= W(
                      `span`,
                      {
                        class: `relative -mx-px h-5 w-px bg-gray-300 md:hidden`,
                      },
                      null,
                      -1,
                    )),
                    W(
                      `span`,
                      {
                        class: `cursor-pointer flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-gray-300 dark:border-gray-500 pl-1 text-gray-400 dark:text-gray-500 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50 dark:md:hover:bg-black`,
                        onClick: (i[1] ||= (e) => n(`nextMonth`)),
                      },
                      [
                        W(`span`, eX, T(t.$trans(`pagination.next`)), 1),
                        N(P(Vy), {
                          class: `h-5 w-5`,
                          "aria-hidden": `true`,
                        }),
                      ],
                    ),
                  ]),
                  W(`div`, tX, [z(t.$slots, `action`)]),
                ]),
              ]),
              W(`div`, nX, [
                W(`div`, rX, [
                  W(`div`, iX, T(t.$trans(`list.days_short.monday`)), 1),
                  W(`div`, aX, T(t.$trans(`list.days_short.tuesday`)), 1),
                  W(`div`, oX, T(t.$trans(`list.days_short.wednesday`)), 1),
                  W(`div`, sX, T(t.$trans(`list.days_short.thursday`)), 1),
                  W(`div`, cX, T(t.$trans(`list.days_short.friday`)), 1),
                  W(`div`, lX, T(t.$trans(`list.days_short.saturday`)), 1),
                  W(`div`, uX, T(t.$trans(`list.days_short.sunday`)), 1),
                ]),
                W(`div`, dX, [
                  W(
                    `div`,
                    {
                      class: O([
                        `hidden w-full lg:grid lg:grid-cols-7 lg:gap-px`,
                        {
                          "lg:grid-rows-4": e.calendar.days.length <= 28,
                          "lg:grid-rows-5":
                            e.calendar.days.length > 28 && e.calendar.days.length <= 35,
                          "lg:grid-rows-6": e.calendar.days.length > 35,
                        },
                      ]),
                    },
                    [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          e.calendar.days,
                          (e) => (
                            A(),
                            M(
                              `div`,
                              {
                                key: e.date,
                                class: O([
                                  e.isCurrentMonth
                                    ? `bg-white dark:bg-dark-header`
                                    : `bg-gray-50 dark:bg-dark-body text-gray-500`,
                                  `relative px-3 py-2`,
                                ]),
                              },
                              [
                                W(
                                  `time`,
                                  {
                                    datetime: e.date,
                                    class: O(
                                      e.isToday
                                        ? `flex h-6 w-6 items-center justify-center rounded-full bg-primary dark:bg-dark-primary font-semibold text-white`
                                        : void 0,
                                    ),
                                  },
                                  T(e.date.split(`-`).pop().replace(/^0/, ``)),
                                  11,
                                  fX,
                                ),
                                e.events.length > 0
                                  ? (A(),
                                    M(`ol`, pX, [
                                      (A(!0),
                                      M(
                                        ke,
                                        null,
                                        ae(
                                          e.events.slice(0, 2),
                                          (e) => (
                                            A(),
                                            M(
                                              `li`,
                                              {
                                                key: e.id,
                                              },
                                              [
                                                W(
                                                  `a`,
                                                  {
                                                    href: e.href,
                                                    class: `group flex`,
                                                  },
                                                  [
                                                    Re((A(), M(`p`, hX, [H(T(e.name), 1)])), [
                                                      [a, e.name],
                                                    ]),
                                                    W(
                                                      `time`,
                                                      {
                                                        datetime: e.datetime,
                                                        class: `ml-3 hidden flex-none text-gray-500 group-hover:text-gray-300 xl:block`,
                                                      },
                                                      T(e.time),
                                                      9,
                                                      gX,
                                                    ),
                                                  ],
                                                  8,
                                                  mX,
                                                ),
                                              ],
                                            )
                                          ),
                                        ),
                                        128,
                                      )),
                                      e.events.length > 2
                                        ? (A(),
                                          M(
                                            `li`,
                                            _X,
                                            ` + ` +
                                              T(e.events.length - 2) +
                                              ` ` +
                                              T(t.$trans(`general.more`)),
                                            1,
                                          ))
                                        : U(``, !0),
                                    ]))
                                  : U(``, !0),
                              ],
                              2,
                            )
                          ),
                        ),
                        128,
                      )),
                    ],
                    2,
                  ),
                  W(
                    `div`,
                    {
                      class: O([
                        `isolate grid w-full grid-cols-7 gap-px lg:hidden`,
                        {
                          "lg:grid-rows-4": e.calendar.days.length <= 28,
                          "lg:grid-rows-5":
                            e.calendar.days.length > 28 && e.calendar.days.length <= 35,
                          "lg:grid-rows-6": e.calendar.days.length > 35,
                        },
                      ]),
                    },
                    [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          e.calendar.days,
                          (e) => (
                            A(),
                            M(
                              `button`,
                              {
                                key: e.date,
                                type: `button`,
                                class: O([
                                  e.isCurrentMonth ? `bg-white` : `bg-gray-50`,
                                  (e.isSelected || e.isToday) && `font-semibold`,
                                  e.isSelected && `text-white`,
                                  !e.isSelected && e.isToday && `text-primary`,
                                  !e.isSelected &&
                                    e.isCurrentMonth &&
                                    !e.isToday &&
                                    `text-gray-900`,
                                  !e.isSelected &&
                                    !e.isCurrentMonth &&
                                    !e.isToday &&
                                    `text-gray-500`,
                                  `flex h-14 flex-col px-3 py-2 hover:bg-gray-100 focus:z-10`,
                                ]),
                              },
                              [
                                W(
                                  `time`,
                                  {
                                    datetime: e.date,
                                    class: O([
                                      e.isSelected &&
                                        `flex h-6 w-6 items-center justify-center rounded-full`,
                                      e.isSelected &&
                                        e.isToday &&
                                        `bg-primary dark:bg-dark-primary`,
                                      e.isSelected && !e.isToday && `bg-gray-900`,
                                      `ml-auto`,
                                    ]),
                                  },
                                  T(e.date.split(`-`).pop().replace(/^0/, ``)),
                                  11,
                                  vX,
                                ),
                                W(
                                  `span`,
                                  yX,
                                  T(e.events.length) + ` ` + T(t.$trans(`general.events`)),
                                  1,
                                ),
                                e.events.length > 0
                                  ? (A(),
                                    M(`span`, bX, [
                                      (A(!0),
                                      M(
                                        ke,
                                        null,
                                        ae(
                                          e.events,
                                          (e) => (
                                            A(),
                                            M(`span`, {
                                              key: e.id,
                                              class: `mx-0.5 mb-1 h-1.5 w-1.5 rounded-full bg-gray-400`,
                                            })
                                          ),
                                        ),
                                        128,
                                      )),
                                    ]))
                                  : U(``, !0),
                              ],
                              2,
                            )
                          ),
                        ),
                        128,
                      )),
                    ],
                    2,
                  ),
                ]),
              ]),
              P(r)?.events.length > 0
                ? (A(),
                  M(`div`, xX, [
                    W(`ol`, SX, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          P(r).events,
                          (e) => (
                            A(),
                            M(
                              `li`,
                              {
                                key: e.id,
                                class: `group flex p-4 pr-6 focus-within:bg-gray-50 hover:bg-gray-50`,
                              },
                              [
                                W(`div`, CX, [
                                  W(`p`, wX, T(e.name), 1),
                                  W(
                                    `time`,
                                    {
                                      datetime: e.datetime,
                                      class: `mt-2 flex items-center text-gray-700`,
                                    },
                                    [
                                      N(P(Uy), {
                                        class: `mr-2 h-5 w-5 text-gray-400`,
                                        "aria-hidden": `true`,
                                      }),
                                      H(` ` + T(e.time), 1),
                                    ],
                                    8,
                                    TX,
                                  ),
                                ]),
                                W(
                                  `a`,
                                  {
                                    href: e.href,
                                    class: `ml-6 flex-none self-center rounded-md bg-white px-3 py-2 font-semibold text-gray-900 opacity-0 shadow-xs ring-1 ring-inset ring-gray-300 hover:ring-gray-400 focus:opacity-100 group-hover:opacity-100`,
                                  },
                                  [(i[3] ||= H(`Edit`, -1)), W(`span`, DX, `, ` + T(e.name), 1)],
                                  8,
                                  EX,
                                ),
                              ],
                            )
                          ),
                        ),
                        128,
                      )),
                    ]),
                  ]))
                : U(``, !0),
            ])
          );
        };
      },
    },
  ),
  kX = a((t, n) => {
    (function (r, i) {
      typeof t == `object` && typeof n == `object`
        ? (n.exports = i((B(), e(Le))))
        : typeof define == `function` && define.amd
          ? define(`VueLoading`, [`vue`], i)
          : typeof t == `object`
            ? (t.VueLoading = i((B(), e(Le))))
            : (r.VueLoading = i(r.Vue));
    })(t, (e) =>
      (() => {
        var t = {
            597: (e, t) => {
              (Object.defineProperty(t, "__esModule", {
                value: !0,
              }),
                (t.default = (e, t) => {
                  let n = e.__vccOpts || e;
                  for (let [e, r] of t) n[e] = r;
                  return n;
                }));
            },
            594: (t) => {
              t.exports = e;
            },
          },
          n = {};
        function r(e) {
          var i = n[e];
          if (i !== void 0) return i.exports;
          var a = (n[e] = {
            exports: {},
          });
          return (t[e](a, a.exports, r), a.exports);
        }
        ((r.d = (e, t) => {
          for (var n in t)
            r.o(t, n) &&
              !r.o(e, n) &&
              Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n],
              });
        }),
          (r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
          (r.r = (e) => {
            (typeof Symbol < `u` &&
              Symbol.toStringTag &&
              Object.defineProperty(e, Symbol.toStringTag, {
                value: `Module`,
              }),
              Object.defineProperty(e, "__esModule", {
                value: !0,
              }));
          }));
        var i = {};
        (r.r(i),
          r.d(i, {
            Component: () => te,
            LoadingPlugin: () => k,
            default: () => ne,
            useLoading: () => O,
          }));
        var a = r(594);
        function o(e) {
          e.remove === void 0 ? e.parentNode?.removeChild(e) : e.remove();
        }
        function s(e, t, n) {
          let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {},
            i = (0, a.h)(e, t, r),
            o = document.createElement(`div`);
          return (
            o.classList.add(`vld-container`),
            n.appendChild(o),
            (0, a.render)(i, o),
            i.component
          );
        }
        function c() {
          return typeof window < `u`;
        }
        let l = c() ? window.HTMLElement : Object,
          u = [`aria-busy`],
          d = {
            class: `vl-icon`,
          };
        function f(e, t, n, r, i, o) {
          return (
            (0, a.openBlock)(),
            (0, a.createBlock)(
              a.Transition,
              {
                name: e.transition,
              },
              {
                default: (0, a.withCtx)(() => [
                  (0, a.withDirectives)(
                    (0, a.createElementVNode)(
                      `div`,
                      {
                        tabindex: `0`,
                        class: (0, a.normalizeClass)([
                          `vl-overlay vl-active`,
                          {
                            "vl-full-page": e.isFullPage,
                          },
                        ]),
                        "aria-busy": e.isActive,
                        "aria-label": `Loading`,
                        style: (0, a.normalizeStyle)({
                          zIndex: e.zIndex,
                        }),
                      },
                      [
                        (0, a.createElementVNode)(
                          `div`,
                          {
                            class: `vl-background`,
                            onClick: (t[0] ||= (0, a.withModifiers)(
                              function () {
                                return e.cancel && e.cancel(...arguments);
                              },
                              [`prevent`],
                            )),
                            style: (0, a.normalizeStyle)(e.bgStyle),
                          },
                          null,
                          4,
                        ),
                        (0, a.createElementVNode)(`div`, d, [
                          (0, a.renderSlot)(e.$slots, `before`),
                          (0, a.renderSlot)(e.$slots, `default`, {}, () => [
                            ((0, a.openBlock)(),
                            (0, a.createBlock)(
                              (0, a.resolveDynamicComponent)(e.loader),
                              {
                                color: e.color,
                                width: e.width,
                                height: e.height,
                              },
                              null,
                              8,
                              [`color`, `width`, `height`],
                            )),
                          ]),
                          (0, a.renderSlot)(e.$slots, `after`),
                        ]),
                      ],
                      14,
                      u,
                    ),
                    [[a.vShow, e.isActive]],
                  ),
                ]),
                _: 3,
              },
              8,
              [`name`],
            )
          );
        }
        let p = {
            mounted() {
              this.enforceFocus && document.addEventListener(`focusin`, this.focusIn);
            },
            methods: {
              focusIn(e) {
                if (!this.isActive || e.target === this.$el || this.$el.contains(e.target)) return;
                let t = this.container
                  ? this.container
                  : this.isFullPage
                    ? null
                    : this.$el.parentElement;
                (this.isFullPage || (t && t.contains(e.target))) &&
                  (e.preventDefault(), this.$el.focus());
              },
            },
            beforeUnmount() {
              document.removeEventListener(`focusin`, this.focusIn);
            },
          },
          m = [`width`, `height`, `stroke`];
        function h(e, t, n, r, i, o) {
          return (
            (0, a.openBlock)(),
            (0, a.createElementBlock)(
              `svg`,
              {
                viewBox: `0 0 38 38`,
                xmlns: `http://www.w3.org/2000/svg`,
                width: e.width,
                height: e.height,
                stroke: e.color,
              },
              (t[0] ||= [
                (0, a.createStaticVNode)(
                  `<g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.8s" repeatCount="indefinite"></animateTransform></path></g></g>`,
                  1,
                ),
              ]),
              8,
              m,
            )
          );
        }
        let g = (0, a.defineComponent)({
          name: `spinner`,
          props: {
            color: {
              type: String,
              default: `#000`,
            },
            height: {
              type: Number,
              default: 64,
            },
            width: {
              type: Number,
              default: 64,
            },
          },
        });
        var v = r(597);
        let y = (0, v.default)(g, [[`render`, h]]),
          b = [`fill`, `width`, `height`];
        function x(e, t, n, r, i, o) {
          return (
            (0, a.openBlock)(),
            (0, a.createElementBlock)(
              `svg`,
              {
                viewBox: `0 0 120 30`,
                xmlns: `http://www.w3.org/2000/svg`,
                fill: e.color,
                width: e.width,
                height: e.height,
              },
              (t[0] ||= [
                (0, a.createStaticVNode)(
                  `<circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity="0.3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle>`,
                  3,
                ),
              ]),
              8,
              b,
            )
          );
        }
        let S = (0, a.defineComponent)({
            name: `dots`,
            props: {
              color: {
                type: String,
                default: `#000`,
              },
              height: {
                type: Number,
                default: 240,
              },
              width: {
                type: Number,
                default: 60,
              },
            },
          }),
          C = (0, v.default)(S, [[`render`, x]]),
          w = [`height`, `width`, `fill`];
        function T(e, t, n, r, i, o) {
          return (
            (0, a.openBlock)(),
            (0, a.createElementBlock)(
              `svg`,
              {
                xmlns: `http://www.w3.org/2000/svg`,
                viewBox: `0 0 30 30`,
                height: e.height,
                width: e.width,
                fill: e.color,
              },
              (t[0] ||= [
                (0, a.createStaticVNode)(
                  `<rect x="0" y="13" width="4" height="5"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect><rect x="10" y="13" width="4" height="5"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect><rect x="20" y="13" width="4" height="5"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect>`,
                  3,
                ),
              ]),
              8,
              w,
            )
          );
        }
        let E = (0, a.defineComponent)({
            name: `bars`,
            props: {
              color: {
                type: String,
                default: `#000`,
              },
              height: {
                type: Number,
                default: 40,
              },
              width: {
                type: Number,
                default: 40,
              },
            },
          }),
          D = {
            Spinner: y,
            Dots: C,
            Bars: (0, v.default)(E, [[`render`, T]]),
          },
          ee = (0, a.defineComponent)({
            name: `VueLoading`,
            mixins: [p],
            props: {
              active: Boolean,
              programmatic: Boolean,
              container: [Object, Function, l],
              isFullPage: {
                type: Boolean,
                default: !0,
              },
              enforceFocus: {
                type: Boolean,
                default: !0,
              },
              lockScroll: Boolean,
              transition: {
                type: String,
                default: `fade`,
              },
              canCancel: Boolean,
              onCancel: {
                type: Function,
                default: () => {},
              },
              color: String,
              backgroundColor: String,
              opacity: Number,
              width: Number,
              height: Number,
              zIndex: Number,
              loader: {
                type: String,
                default: `spinner`,
              },
            },
            components: D,
            emits: [`hide`, `update:active`],
            data() {
              return {
                isActive: this.active,
              };
            },
            mounted() {
              document.addEventListener(`keyup`, this.keyPress);
            },
            methods: {
              cancel() {
                !this.canCancel ||
                  !this.isActive ||
                  (this.hide(), this.onCancel.apply(null, arguments));
              },
              hide() {
                (this.$emit(`hide`),
                  this.$emit(`update:active`, !1),
                  this.programmatic &&
                    ((this.isActive = !1),
                    setTimeout(() => {
                      let e = this.$el.parentElement;
                      ((0, a.render)(null, e), o(e));
                    }, 150)));
              },
              disableScroll() {
                this.isFullPage && this.lockScroll && document.body.classList.add(`vl-shown`);
              },
              enableScroll() {
                this.isFullPage && this.lockScroll && document.body.classList.remove(`vl-shown`);
              },
              keyPress(e) {
                e.keyCode === 27 && this.cancel();
              },
            },
            watch: {
              active(e) {
                this.isActive = e;
              },
              isActive: {
                handler(e) {
                  e ? this.disableScroll() : this.enableScroll();
                },
                immediate: !0,
              },
            },
            computed: {
              bgStyle() {
                return {
                  background: this.backgroundColor,
                  opacity: this.opacity,
                };
              },
            },
            beforeUnmount() {
              document.removeEventListener(`keyup`, this.keyPress);
            },
          }),
          te = (0, v.default)(ee, [[`render`, f]]);
        function O() {
          let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
            t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return {
            show() {
              let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e,
                r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t,
                i = {
                  programmatic: !0,
                  lockScroll: !0,
                  isFullPage: !1,
                  active: !0,
                },
                a = {
                  ...e,
                  ...n,
                  ...i,
                },
                o = a.container;
              a.container || ((o = document.body), (a.isFullPage = !0));
              let c = {
                ...t,
                ...r,
              };
              return {
                hide: s(te, a, o, c).ctx.hide,
              };
            },
          };
        }
        let k = function (e) {
            let t = O(
              arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
            );
            ((e.config.globalProperties.$loading = t), e.provide(`$loading`, t));
          },
          ne = te;
        return i;
      })(),
    );
  }),
  AX = kX(),
  jX = i({
    default: () => RX,
  });
B();
var MX = {
    key: 0,
    class: `text-base font-semibold leading-7 text-gray-800 dark:text-gray-400 sm:truncate sm:text-lg`,
  },
  NX = {
    class: `flex gap-2`,
  },
  PX = {
    key: 0,
    class: `flex items-center text-right`,
  },
  FX = {
    key: 1,
    class: `flex items-center text-right`,
  },
  IX = {
    key: 1,
    class: `dark:bg-dark-header bg-white px-4 py-3 text-right sm:rounded-bl-lg sm:rounded-br-lg sm:px-6`,
  },
  LX = {
    key: 2,
    class: `dark:bg-dark-header bg-white text-right sm:rounded-bl-lg sm:rounded-br-lg`,
  },
  RX = Object.assign(
    {
      name: `BaseCard`,
    },
    {
      props: {
        noBorder: {
          type: Boolean,
          default: !1,
        },
        lessPadding: {
          type: Boolean,
          default: !1,
        },
        noPadding: {
          type: Boolean,
          default: !1,
        },
        noContentPadding: {
          type: Boolean,
          default: !1,
        },
        bottomContentPadding: {
          type: Boolean,
          default: !1,
        },
        topContentPadding: {
          type: Boolean,
          default: !1,
        },
        isLoading: {
          type: Boolean,
          default: !1,
        },
        isContentVisible: {
          type: Boolean,
          default: !0,
        },
        foldable: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        Te();
        let t = (0, AX.useLoading)({}),
          n = e,
          r = F(!1),
          i = null,
          a = V(() => n.isLoading),
          o = F(n.isContentVisible),
          s = () => {
            o.value = !o.value;
          };
        return (
          He(a, (e, n) => {
            e
              ? (i = t.show({
                  container: r.value,
                }))
              : i && i.hide();
          }),
          (t, n) => (
            A(),
            M(
              `div`,
              {
                class: O([
                  `relative space-y-6 lg:col-span-9 lg:px-0`,
                  {
                    "": !e.noContentPadding,
                  },
                ]),
                ref_key: `loadingContainer`,
                ref: r,
              },
              [
                W(
                  `div`,
                  {
                    class: O([`relative dark:border dark:border-gray-700 sm:rounded-lg`, {}]),
                  },
                  [
                    t.$slots.title || t.$slots.action || e.foldable
                      ? (A(),
                        M(
                          `div`,
                          {
                            key: 0,
                            class: O([
                              `dark:bg-dark-header flex justify-between border-b border-gray-200 bg-white px-4 py-2 dark:border-gray-700`,
                              {
                                "sm:rounded-tl-lg sm:rounded-tr-lg": !0,
                                "sm:rounded-bl-lg sm:rounded-br-lg": !o.value,
                              },
                            ]),
                          },
                          [
                            t.$slots.title
                              ? (A(), M(`div`, MX, [z(t.$slots, `title`)]))
                              : U(``, !0),
                            W(`div`, NX, [
                              t.$slots.action
                                ? (A(), M(`div`, PX, [z(t.$slots, `action`)]))
                                : U(``, !0),
                              e.foldable
                                ? (A(),
                                  M(`div`, FX, [
                                    W(
                                      `span`,
                                      {
                                        class: `cursor-pointer dark:text-gray-400`,
                                        onClick: s,
                                      },
                                      [
                                        W(
                                          `i`,
                                          {
                                            class: O([
                                              `fas`,
                                              o.value ? `fa-chevron-up` : `fa-chevron-down`,
                                            ]),
                                          },
                                          null,
                                          2,
                                        ),
                                      ],
                                    ),
                                  ]))
                                : U(``, !0),
                            ]),
                          ],
                          2,
                        ))
                      : U(``, !0),
                    N(
                      Ve,
                      {
                        name: `slide`,
                      },
                      {
                        default: I(() => [
                          o.value
                            ? (A(),
                              M(
                                `div`,
                                {
                                  key: 0,
                                  class: O([
                                    `dark:bg-dark-header bg-white`,
                                    {
                                      "px-2 sm:p-2": e.lessPadding,
                                      "px-4 sm:p-6": !e.lessPadding && !e.noPadding,
                                      "py-6": !e.noContentPadding,
                                      "pb-6": e.bottomContentPadding,
                                      "pt-6": e.topContentPadding,
                                      "sm:rounded-tl-lg sm:rounded-tr-lg":
                                        !t.$slots.title && !t.$slots.action,
                                      "sm:rounded-bl-lg sm:rounded-br-lg":
                                        !t.$slots.footer && !t.$slots.progress,
                                    },
                                  ]),
                                },
                                [z(t.$slots, `default`)],
                                2,
                              ))
                            : U(``, !0),
                        ]),
                        _: 3,
                      },
                    ),
                    t.$slots.footer && o.value
                      ? (A(), M(`div`, IX, [z(t.$slots, `footer`)]))
                      : U(``, !0),
                    t.$slots.progress ? (A(), M(`div`, LX, [z(t.$slots, `progress`)])) : U(``, !0),
                  ],
                ),
              ],
              2,
            )
          )
        );
      },
    },
  ),
  zX = i({
    default: () => ZX,
  });
B();
var BX = {
    key: 0,
  },
  VX = {
    class: `mt-2 flex justify-end`,
  },
  HX = {
    class: `space-y-4 mt-6`,
  },
  UX = {
    class: `shrink-0`,
  },
  WX = [`src`, `alt`],
  GX = {
    class: `flex-1`,
  },
  KX = {
    class: `bg-gray-50 dark:bg-dark-body rounded-lg p-4`,
  },
  qX = {
    class: `flex items-center justify-between text-xs mb-2`,
  },
  JX = {
    class: `font-medium text-gray-900 dark:text-gray-400`,
  },
  YX = {
    class: `text-gray-500 dark:text-gray-400`,
  },
  XX = {
    class: `text-gray-700 dark:text-gray-400 text-sm`,
  },
  ZX = Object.assign(
    {
      name: `BaseComment`,
    },
    {
      props: {
        type: {
          type: String,
          required: !0,
        },
        uuid: {
          type: String,
          required: !0,
        },
        moduleType: {
          type: String,
          required: !1,
        },
        moduleUuid: {
          type: String,
          required: !1,
        },
        comments: {
          type: Array,
          required: !1,
        },
        canComment: {
          type: Boolean,
          default: !0,
        },
      },
      setup(e) {
        Dc();
        let t = $e(),
          n = e,
          r = {
            body: ``,
          },
          i = Bh(`comment/`),
          a = F(!1),
          o = Ae({
            ...r,
          }),
          s = Ae({
            comments: [],
          }),
          c = async () => {
            ((a.value = !0),
              await t
                .dispatch(`comment/store`, {
                  type: n.type,
                  uuid: n.uuid,
                  moduleType: n.moduleType,
                  moduleUuid: n.moduleUuid,
                  body: o.body,
                })
                .then((e) => {
                  (s.comments.unshift(e.comment), (o.body = ``), (a.value = !1));
                })
                .catch((e) => {
                  a.value = !1;
                }));
          };
        return (
          He(
            () => n.comments,
            (e) => {
              s.comments = e;
            },
            {
              immediate: !0,
            },
          ),
          (t, n) => {
            let r = j(`BaseTextarea`),
              a = j(`BaseButton`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  e.canComment
                    ? (A(),
                      M(`div`, BX, [
                        N(
                          r,
                          {
                            rows: 1,
                            modelValue: o.body,
                            "onUpdate:modelValue": (n[0] ||= (e) => (o.body = e)),
                            name: `body`,
                            placeholder: t.$trans(`comment.props.body`),
                            error: P(i).body,
                            "onUpdate:error": (n[1] ||= (e) => (P(i).body = e)),
                          },
                          null,
                          8,
                          [`modelValue`, `placeholder`, `error`],
                        ),
                        W(`div`, VX, [
                          N(
                            a,
                            {
                              design: `primary`,
                              size: `xs`,
                              onClick: c,
                            },
                            {
                              default: I(() => [H(T(t.$trans(`general.save`)), 1)]),
                              _: 1,
                            },
                          ),
                        ]),
                      ]))
                    : U(``, !0),
                  W(`div`, HX, [
                    (A(!0),
                    M(
                      ke,
                      null,
                      ae(
                        s.comments,
                        (e) => (
                          A(),
                          M(
                            `div`,
                            {
                              key: e.uuid,
                              class: `flex space-x-4`,
                            },
                            [
                              W(`div`, UX, [
                                W(
                                  `img`,
                                  {
                                    src: e.user?.avatar,
                                    alt: e.user?.profile?.name,
                                    class: `h-10 w-10 rounded-full object-cover`,
                                  },
                                  null,
                                  8,
                                  WX,
                                ),
                              ]),
                              W(`div`, GX, [
                                W(`div`, KX, [
                                  W(`div`, qX, [
                                    W(`span`, JX, T(e.user?.profile?.name), 1),
                                    W(`span`, YX, T(e.createdAt.formatted), 1),
                                  ]),
                                  W(`p`, XX, T(e.body), 1),
                                ]),
                              ]),
                            ],
                          )
                        ),
                      ),
                      128,
                    )),
                  ]),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  QX = i({
    default: () => $X,
  });
B();
var $X = Object.assign(
    {
      name: `BaseDataDef`,
    },
    {
      props: {
        revert: {
          type: Boolean,
          default: !1,
        },
        fontSize: {
          type: String,
          validator(e) {
            return [`xs`, `sm`].includes(e);
          },
          default: `sm`,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `dt`,
            {
              class: O([
                `mt-1`,
                {
                  "text-sm": e.fontSize == `sm`,
                  "text-xs": e.fontSize == `xs`,
                  "text-gray-500 dark:text-gray-400": e.revert,
                  "text-gray-900 dark:text-gray-300": !e.revert,
                },
              ]),
            },
            [z(t.$slots, `default`)],
            2,
          )
        );
      },
    },
  ),
  eZ = i({
    default: () => tZ,
  });
B();
var tZ = Object.assign(
    {
      name: `BaseDataList`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        revert: {
          type: Boolean,
          default: !1,
        },
        fontSize: {
          type: String,
          validator(e) {
            return [`xs`, `sm`].includes(e);
          },
          default: `sm`,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `dt`,
            {
              class: O([
                `font-medium`,
                {
                  "text-sm": e.fontSize == `sm`,
                  "text-xs": e.fontSize == `xs`,
                  "text-gray-500 dark:text-gray-400": !e.revert,
                  "text-gray-900 dark:text-gray-300": e.revert,
                },
              ]),
            },
            [z(t.$slots, `default`, {}, () => [H(T(e.label), 1)])],
            2,
          )
        );
      },
    },
  ),
  nZ = i({
    default: () => aZ,
  });
B();
var rZ = [`innerHTML`],
  iZ = [`innerHTML`],
  aZ = Object.assign(
    {
      name: `BaseDataView`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        class: {
          type: String,
          default: `sm:col-span-1`,
        },
        revert: {
          type: Boolean,
          default: !1,
        },
        fontSize: {
          type: String,
          validator(e) {
            return [`xs`, `sm`].includes(e);
          },
          default: `sm`,
        },
        html: {
          type: Boolean,
          default: !1,
        },
        paragraph: {
          type: Boolean,
          default: !1,
        },
        dynamic: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = Te(),
          n = (e) => (typeof e == `string` ? e.replace(/(\r\n|\n|\r)/gm, `<br>`) : ``);
        return (r, i) => {
          let a = j(`BaseDataList`),
            o = j(`BaseDataDef`);
          return (
            A(),
            M(
              `div`,
              {
                class: O(e.class),
              },
              [
                N(
                  a,
                  {
                    label: e.label,
                    revert: e.revert,
                    "font-size": e.fontSize,
                  },
                  {
                    default: I(() => [z(r.$slots, `label`, {}, () => [H(T(e.label), 1)])]),
                    _: 3,
                  },
                  8,
                  [`label`, `revert`, `font-size`],
                ),
                e.html
                  ? (A(),
                    L(
                      o,
                      {
                        key: 0,
                        revert: e.revert,
                        "font-size": e.fontSize,
                      },
                      {
                        default: I(() => [
                          W(
                            `div`,
                            {
                              innerHTML: P(t).default?.()?.[0]?.children,
                            },
                            null,
                            8,
                            rZ,
                          ),
                        ]),
                        _: 1,
                      },
                      8,
                      [`revert`, `font-size`],
                    ))
                  : e.paragraph
                    ? (A(),
                      L(
                        o,
                        {
                          key: 1,
                          revert: e.revert,
                          "font-size": e.fontSize,
                        },
                        {
                          default: I(() => [
                            W(
                              `span`,
                              {
                                innerHTML: n(P(t).default?.()?.[0]?.children || ``),
                              },
                              null,
                              8,
                              iZ,
                            ),
                          ]),
                          _: 1,
                        },
                        8,
                        [`revert`, `font-size`],
                      ))
                    : e.dynamic
                      ? (A(),
                        L(
                          o,
                          {
                            key: 2,
                            revert: e.revert,
                            "font-size": e.fontSize,
                          },
                          {
                            default: I(() => [z(r.$slots, `default`)]),
                            _: 3,
                          },
                          8,
                          [`revert`, `font-size`],
                        ))
                      : (A(),
                        L(
                          o,
                          {
                            key: 3,
                            revert: e.revert,
                            "font-size": e.fontSize,
                          },
                          {
                            default: I(() => [z(r.$slots, `default`)]),
                            _: 3,
                          },
                          8,
                          [`revert`, `font-size`],
                        )),
              ],
              2,
            )
          );
        };
      },
    },
  ),
  oZ = i({
    default: () => cZ,
  });
B();
var sZ = {
    class: `ml-2 rounded border border-gray-300 p-2 text-sm font-semibold text-gray-800 dark:border-gray-700 dark:text-gray-300`,
  },
  cZ = Object.assign(
    {
      name: `BaseFieldset`,
    },
    {
      props: {
        noPadding: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `fieldset`,
            {
              class: O([
                `rounded-md border border-solid border-gray-300 py-3 dark:border-gray-700`,
                {
                  "px-3": !e.noPadding,
                  "px-0": e.noPadding,
                },
              ]),
            },
            [W(`legend`, sZ, [z(t.$slots, `legend`)]), z(t.$slots, `default`)],
            2,
          )
        );
      },
    },
  ),
  lZ = i({
    default: () => pZ,
  });
B();
var uZ = {
    key: 0,
    class: `dark:bg-dark-header flex justify-between border-b border-gray-200 bg-white px-4 py-2 dark:border-gray-700 sm:rounded-tl-lg sm:rounded-tr-lg`,
  },
  dZ = {
    key: 0,
    class: `text-base font-semibold leading-7 text-gray-800 dark:text-gray-400 sm:truncate sm:text-lg`,
  },
  fZ = {
    key: 1,
    class: `flex items-center text-right`,
  },
  pZ = Object.assign(
    {
      name: `BaseFlexCard`,
    },
    {
      props: {
        isLoading: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        Te();
        let t = (0, AX.useLoading)({}),
          n = e,
          r = F(!1),
          i = null;
        return (
          He(
            V(() => n.isLoading),
            (e, n) => {
              e
                ? (i = t.show({
                    container: r.value,
                  }))
                : i && i.hide();
            },
          ),
          (e, t) => (
            A(),
            M(
              `div`,
              {
                class: `relative w-full bg-white dark:bg-dark-header dark:border dark:border-gray-700 rounded-lg`,
                ref_key: `loadingContainer`,
                ref: r,
              },
              [
                e.$slots.title || e.$slots.action
                  ? (A(),
                    M(`div`, uZ, [
                      e.$slots.title ? (A(), M(`div`, dZ, [z(e.$slots, `title`)])) : U(``, !0),
                      e.$slots.action ? (A(), M(`div`, fZ, [z(e.$slots, `action`)])) : U(``, !0),
                    ]))
                  : U(``, !0),
                z(e.$slots, `default`),
              ],
              512,
            )
          )
        );
      },
    },
  ),
  mZ = i({
    default: () => vZ,
  });
B();
var hZ = {
    name: `BaseFlexContainer`,
  },
  gZ = {
    class: `flex flex-col space-y-4 md:space-y-0 md:flex-row md:space-x-4`,
  };
function _Z(e, t, n, r, i, a) {
  return (A(), M(`div`, gZ, [z(e.$slots, `default`)]));
}
var vZ = tu(hZ, [[`render`, _Z]]),
  yZ = i({
    default: () => CZ,
  });
B();
var bZ = {
    name: `BaseHeading`,
  },
  xZ = {
    class: `mb-2 text-lg font-medium leading-6 text-gray-900 dark:text-gray-300`,
  };
function SZ(e, t, n, r, i, a) {
  return (A(), M(`h3`, xZ, [z(e.$slots, `default`)]));
}
var CZ = tu(bZ, [[`render`, SZ]]),
  wZ = i({
    default: () => FZ,
  });
B();
var TZ = {
    class: `space-y-4`,
  },
  EZ = {
    class: `flex items-center justify-center`,
  },
  DZ = [`name`, `id`],
  OZ = {
    class: `flex justify-between`,
  },
  kZ = {
    class: `flex space-x-4`,
  },
  AZ = {
    class: `space-x-4`,
  },
  jZ = {
    key: 0,
  },
  MZ = {
    key: 1,
    class: `px-4 py-2`,
  },
  NZ = {
    class: `scroller-thin-y scroller-hidden max-h-96`,
  },
  PZ = {
    class: `mt-4 flex`,
  },
  FZ = Object.assign(
    {
      name: `BaseImport`,
    },
    {
      props: {
        path: {
          type: String,
          default: ``,
        },
        historyPath: {
          type: String,
          default: ``,
        },
        option: {
          type: Object,
          default() {
            return {};
          },
        },
        additionalOption: {
          type: Object,
          default() {
            return {};
          },
        },
        hasValidation: {
          type: Boolean,
          default: !0,
        },
        allowedExtensions: {
          type: Array,
          default: [`xls`, `csv`, `xlsx`],
        },
        validateExtension: {
          type: Boolean,
          default: !0,
        },
      },
      emits: [`cancelled`, `hide`, `completed`],
      setup(e, { emit: t }) {
        let n = $e(),
          r = u(),
          i = R(`$trans`),
          a = t,
          o = e,
          c = V(() => n.getters[`config/config`](`system.postMaxSize`)),
          l = Ae({
            validate: !1,
            uniqueId: ``,
            isFileSelected: !1,
            errorCount: 0,
            errorHeader: [],
            errorItems: [],
            historyLoaded: !1,
            history: [],
          }),
          d = [
            {
              key: `count`,
              label: i(`general.count`),
              visibility: !0,
            },
            {
              key: `importedAt`,
              label: i(`general.imported_at`),
              visibility: !0,
            },
            {
              key: `action`,
              label: ``,
              visibility: !0,
            },
          ],
          f = F(!1),
          p = F(null),
          m = F(null),
          h = F(null),
          g = F(0),
          y = (e) => {
            let t = e.target.files || e.dataTransfer.files;
            if (
              !RegExp(`\\.(${o.allowedExtensions.join(`|`)})$`, `i`).exec(t[0].name) &&
              o.validateExtension
            ) {
              r.error(i(`general.errors.file_not_supported`));
              return;
            }
            t.length && ((p.value = e), (m.value = t), (l.isFileSelected = !0));
          },
          b = () => {
            ((p.value.target.value = null), (m.value = null), (l.isFileSelected = !1));
          },
          x = async () => {
            ((h.value = !0),
              n
                .dispatch(`moduleImport/history`, {
                  path: o.historyPath,
                })
                .then((e) => {
                  ((l.historyLoaded = !0), (l.history = e));
                })
                .catch((e) => {})
                .finally(() => {
                  h.value = !1;
                }));
          },
          S = async (e) => {
            (await ub()) &&
              ((h.value = !0),
              n
                .dispatch(`moduleImport/deleteHistory`, {
                  path: o.historyPath,
                  uuid: e,
                })
                .then(async () => {
                  await x();
                })
                .catch((e) => {})
                .finally(() => {
                  h.value = !1;
                }));
          },
          C = async () => {
            if (m.value[0] > c.value) {
              r.error(i(`general.errors.file_too_large`));
              return;
            }
            h.value = !0;
            let e = new FormData();
            (e.append(`file`, m.value[0]), e.append(`validate`, l.validate));
            for (let [t, n] of Object.entries(o.option)) e.append(t, n);
            for (let [t, n] of Object.entries(o.additionalOption)) e.append(t, n);
            if (!o.validateExtension) {
              let e = s.CancelToken,
                t = new FormData();
              (t.append(`file`, m.value[0]), t.append(`validate`, l.validate));
              for (let [e, n] of Object.entries(o.option)) t.append(e, n);
              for (let [e, n] of Object.entries(o.additionalOption)) t.append(e, n);
              v({
                url: `/app/` + o.path,
                method: `POST`,
                data: t,
                upload: !0,
                onUploadProgress: (e) => {
                  g.value = Math.round((e.loaded * 100) / e.total);
                },
                cancelToken: new e((e) => {}),
              })
                .then((e) => {
                  r.success(e.message);
                })
                .catch((e) => {
                  r.error(e.message);
                })
                .finally(() => {
                  ((g.value = 0), (h.value = !1));
                });
              return;
            }
            await n
              .dispatch(`moduleImport/upload`, {
                path: o.path,
                data: e,
              })
              .then((e) => {
                ((h.value = !1), b(), e.imported && a(`completed`));
              })
              .catch((e) => {
                ((h.value = !1),
                  e.showLog &&
                    ((f.value = !0),
                    (l.errorCount = e.count),
                    (l.errorHeader = e.items.shift()),
                    (l.errorItems = e.items)),
                  b());
              });
          };
        return (
          Qe(() => {
            l.uniqueId = Math.random().toString(16).slice(2);
          }),
          (t, n) => {
            let r = j(`BaseButton`),
              a = j(`ProgressBar`),
              o = j(`BaseCheckbox`),
              s = j(`BaseCard`),
              c = j(`DataCell`),
              u = j(`DataRow`),
              p = j(`SimpleTable`),
              m = j(`BaseAlert`),
              v = j(`BaseHeader`),
              b = j(`BaseTable`),
              w = j(`BaseModal`),
              E = ve(`tooltip`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  N(
                    s,
                    {
                      "is-loading": h.value,
                    },
                    {
                      title: I(() => [
                        z(t.$slots, `title`, {}, () => [H(T(P(i)(`general.import`)), 1)]),
                      ]),
                      action: I(() => [
                        e.historyPath && !l.historyLoaded
                          ? (A(),
                            L(
                              r,
                              {
                                key: 0,
                                onClick: x,
                                size: `xs`,
                              },
                              {
                                default: I(() => [H(T(P(i)(`general.history`)), 1)]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                      ]),
                      footer: I(() => [
                        W(`div`, OZ, [
                          W(`div`, kZ, [
                            e.hasValidation
                              ? (A(),
                                L(
                                  o,
                                  {
                                    key: 0,
                                    modelValue: l.validate,
                                    "onUpdate:modelValue": (n[0] ||= (e) => (l.validate = e)),
                                    name: `validate`,
                                    label: P(i)(`global.validate`, {
                                      attribute: P(i)(`general.file`),
                                    }),
                                  },
                                  null,
                                  8,
                                  [`modelValue`, `label`],
                                ))
                              : U(``, !0),
                            z(t.$slots, `option`),
                          ]),
                          W(`div`, AZ, [
                            N(
                              r,
                              {
                                design: `error`,
                                onClick: (n[1] ||= (e) => t.$emit(`cancelled`)),
                              },
                              {
                                default: I(() => [H(T(P(i)(`general.cancel`)), 1)]),
                                _: 1,
                              },
                            ),
                            l.isFileSelected
                              ? (A(),
                                L(
                                  r,
                                  {
                                    key: 0,
                                    design: `primary`,
                                    onClick: C,
                                  },
                                  {
                                    default: I(() => [H(T(P(i)(`general.import`)), 1)]),
                                    _: 1,
                                  },
                                ))
                              : U(``, !0),
                          ]),
                        ]),
                      ]),
                      default: I(() => [
                        W(`div`, TZ, [
                          W(`div`, null, [z(t.$slots, `header`)]),
                          W(`div`, EZ, [
                            N(
                              r,
                              {
                                as: `label`,
                              },
                              {
                                default: I(() => [
                                  (n[4] ||= W(
                                    `i`,
                                    {
                                      class: `fas fa-upload mr-2`,
                                    },
                                    null,
                                    -1,
                                  )),
                                  H(
                                    ` ` +
                                      T(
                                        P(i)(`global.upload`, {
                                          attribute: P(i)(`general.file`),
                                        }),
                                      ) +
                                      ` `,
                                    1,
                                  ),
                                  W(
                                    `input`,
                                    {
                                      type: `file`,
                                      onChange: y,
                                      name: l.uniqueId,
                                      id: l.uniqueId,
                                      class: `hidden`,
                                    },
                                    null,
                                    40,
                                    DZ,
                                  ),
                                ]),
                                _: 1,
                              },
                            ),
                          ]),
                          !e.validateExtension && g.value > 0
                            ? (A(),
                              L(
                                a,
                                {
                                  key: 0,
                                  percent: g.value,
                                  value: g.value,
                                  max: 100,
                                  color: `bg-primary`,
                                },
                                null,
                                8,
                                [`percent`, `value`],
                              ))
                            : U(``, !0),
                          W(`div`, null, [z(t.$slots, `footer`)]),
                        ]),
                      ]),
                      _: 3,
                    },
                    8,
                    [`is-loading`],
                  ),
                  l.historyLoaded
                    ? (A(),
                      L(
                        s,
                        {
                          key: 0,
                          "no-padding": ``,
                          "no-content-padding": ``,
                          class: `mt-4`,
                          "is-loading": h.value,
                        },
                        {
                          title: I(() => [H(T(P(i)(`general.history`)), 1)]),
                          default: I(() => [
                            l.historyLoaded && l.history.length
                              ? (A(),
                                M(`div`, jZ, [
                                  N(
                                    p,
                                    {
                                      header: d,
                                    },
                                    {
                                      default: I(() => [
                                        (A(!0),
                                        M(
                                          ke,
                                          null,
                                          ae(
                                            l.history,
                                            (e) => (
                                              A(),
                                              L(
                                                u,
                                                {
                                                  key: e.uuid,
                                                },
                                                {
                                                  default: I(() => [
                                                    N(
                                                      c,
                                                      {
                                                        name: `count`,
                                                      },
                                                      {
                                                        default: I(() => [H(T(e.count), 1)]),
                                                        _: 2,
                                                      },
                                                      1024,
                                                    ),
                                                    N(
                                                      c,
                                                      {
                                                        name: `importedAt`,
                                                      },
                                                      {
                                                        default: I(() => [
                                                          H(T(e.importedAt.formatted), 1),
                                                        ]),
                                                        _: 2,
                                                      },
                                                      1024,
                                                    ),
                                                    N(
                                                      c,
                                                      {
                                                        name: `action`,
                                                      },
                                                      {
                                                        default: I(() => [
                                                          P(Gh)(`admin`)
                                                            ? Re(
                                                                (A(),
                                                                L(
                                                                  r,
                                                                  {
                                                                    key: 0,
                                                                    size: `xs`,
                                                                    design: `error`,
                                                                    onClick: (t) => S(e.uuid),
                                                                  },
                                                                  {
                                                                    default: I(() => [
                                                                      ...(n[5] ||= [
                                                                        W(
                                                                          `i`,
                                                                          {
                                                                            class: `fas fa-trash`,
                                                                          },
                                                                          null,
                                                                          -1,
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                    _: 1,
                                                                  },
                                                                  8,
                                                                  [`onClick`],
                                                                )),
                                                                [[E, P(i)(`general.delete`)]],
                                                              )
                                                            : U(``, !0),
                                                        ]),
                                                        _: 2,
                                                      },
                                                      1024,
                                                    ),
                                                  ]),
                                                  _: 2,
                                                },
                                                1024,
                                              )
                                            ),
                                          ),
                                          128,
                                        )),
                                      ]),
                                      _: 1,
                                    },
                                  ),
                                ]))
                              : l.historyLoaded && !l.history.length
                                ? (A(),
                                  M(`div`, MZ, [
                                    N(
                                      m,
                                      {
                                        size: `xs`,
                                        design: `info`,
                                      },
                                      {
                                        default: I(() => [
                                          H(T(P(i)(`general.errors.record_not_found`)), 1),
                                        ]),
                                        _: 1,
                                      },
                                    ),
                                  ]))
                                : U(``, !0),
                          ]),
                          _: 1,
                        },
                        8,
                        [`is-loading`],
                      ))
                    : U(``, !0),
                  N(
                    w,
                    {
                      show: f.value,
                      onClose: (n[3] ||= (e) => (f.value = !1)),
                    },
                    {
                      title: I(() => [
                        (n[6] ||= W(
                          `i`,
                          {
                            class: `fas fa-times-circle`,
                          },
                          null,
                          -1,
                        )),
                        H(
                          ` ` +
                            T(
                              P(i)(`general.import_error`, {
                                attribute: l.errorCount,
                              }),
                            ),
                          1,
                        ),
                      ]),
                      default: I(() => [
                        W(`div`, NZ, [
                          N(b, null, {
                            header: I(() => [
                              (A(!0),
                              M(
                                ke,
                                null,
                                ae(
                                  l.errorHeader,
                                  (e) => (
                                    A(),
                                    L(
                                      v,
                                      null,
                                      {
                                        default: I(() => [H(T(e), 1)]),
                                        _: 2,
                                      },
                                      1024,
                                    )
                                  ),
                                ),
                                256,
                              )),
                            ]),
                            default: I(() => [
                              (A(!0),
                              M(
                                ke,
                                null,
                                ae(
                                  l.errorItems,
                                  (e) => (
                                    A(),
                                    L(
                                      u,
                                      {
                                        "no-responsive": ``,
                                      },
                                      {
                                        default: I(() => [
                                          (A(!0),
                                          M(
                                            ke,
                                            null,
                                            ae(
                                              e,
                                              (e) => (
                                                A(),
                                                L(
                                                  c,
                                                  {
                                                    "no-responsive": ``,
                                                    name: ``,
                                                  },
                                                  {
                                                    default: I(() => [H(T(e), 1)]),
                                                    _: 2,
                                                  },
                                                  1024,
                                                )
                                              ),
                                            ),
                                            256,
                                          )),
                                        ]),
                                        _: 2,
                                      },
                                      1024,
                                    )
                                  ),
                                ),
                                256,
                              )),
                            ]),
                            _: 1,
                          }),
                        ]),
                        W(`div`, PZ, [
                          N(
                            r,
                            {
                              type: `primary`,
                              onClick: (n[2] ||= (e) => (f.value = !1)),
                            },
                            {
                              default: I(() => [H(T(P(i)(`general.ok`)), 1)]),
                              _: 1,
                            },
                          ),
                        ]),
                      ]),
                      _: 1,
                    },
                    8,
                    [`show`],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  IZ = i({
    default: () => LZ,
  });
B();
var LZ = Object.assign(
    {
      name: `BaseLoader`,
    },
    {
      props: {
        isLoading: {
          type: Boolean,
          default: !1,
        },
        minHeight: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = (0, AX.useLoading)({}),
          n = e,
          r = F(!1),
          i = null;
        return (
          He(
            V(() => n.isLoading),
            (e, n) => {
              e
                ? (i = t.show({
                    container: r.value,
                  }))
                : i && i.hide();
            },
          ),
          (t, n) => (
            A(),
            M(
              `div`,
              {
                class: O([
                  `relative`,
                  {
                    "h-20": e.minHeight,
                  },
                ]),
                ref_key: `loadingContainer`,
                ref: r,
              },
              [z(t.$slots, `default`)],
              2,
            )
          )
        );
      },
    },
  ),
  RZ = i({
    default: () => GZ,
  });
B();
var zZ = {
    class: `relative inline-block min-w-sm w-full transform rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-auto sm:max-w-5xl sm:align-middle dark:bg-dark-body border border-gray-200 dark:border-gray-700`,
  },
  BZ = {
    class: `flex items-center justify-between border-b border-gray-200 p-4 text-lg font-medium leading-6 text-gray-900 dark:border-gray-700 dark:text-gray-100`,
  },
  VZ = {
    class: `flex items-center gap-2`,
  },
  HZ = {
    key: 0,
    class: `mt-2 px-4`,
  },
  UZ = {
    class: `text-sm text-gray-500 dark:text-gray-400`,
  },
  WZ = {
    class: `p-4 scroller-thin-y scroller-hidden max-h-[calc(100vh-12rem)]`,
  },
  GZ = Object.assign(
    {
      name: `BaseModal`,
    },
    {
      props: {
        visibility: {
          type: Boolean,
          default: !1,
        },
        isLoading: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`close`],
      setup(e, { emit: t }) {
        Te();
        let n = (0, AX.useLoading)({}),
          r = t,
          i = e,
          a = F(!1),
          o = null;
        return (
          He(
            V(() => i.isLoading),
            (e, t) => {
              e
                ? (o = n.show({
                    container: a.value,
                  }))
                : o && o.hide();
            },
          ),
          Qe(() => {
            window.addEventListener(`keydown`, (e) => {
              e.key === `Escape` && r(`close`);
            });
          }),
          (t, n) => (
            A(),
            L(
              P(xh),
              {
                as: `template`,
                show: e.visibility,
              },
              {
                default: I(() => [
                  W(
                    `div`,
                    {
                      class: `fixed inset-0 z-50 overflow-y-auto`,
                      onClose: (n[1] ||= (e) => r(`close`)),
                    },
                    [
                      W(
                        `div`,
                        {
                          class: `flex min-h-screen items-center justify-center p-4 text-center sm:block sm:p-0`,
                          ref_key: `loadingContainer`,
                          ref: a,
                        },
                        [
                          N(
                            P(bh),
                            {
                              as: `template`,
                              enter: `ease-out duration-300`,
                              "enter-from": `opacity-0`,
                              "enter-to": `opacity-100`,
                              leave: `ease-in duration-200`,
                              "leave-from": `opacity-100`,
                              "leave-to": `opacity-0`,
                            },
                            {
                              default: I(() => [
                                ...(n[2] ||= [
                                  W(
                                    `div`,
                                    {
                                      class: `fixed inset-0 bg-black/75 transition-opacity`,
                                    },
                                    null,
                                    -1,
                                  ),
                                ]),
                              ]),
                              _: 1,
                            },
                          ),
                          (n[4] ||= W(
                            `span`,
                            {
                              class: `hidden sm:inline-block sm:h-screen sm:align-middle`,
                              "aria-hidden": `true`,
                            },
                            `​`,
                            -1,
                          )),
                          N(
                            P(bh),
                            {
                              as: `template`,
                              enter: `ease-out duration-300`,
                              "enter-from": `opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95`,
                              "enter-to": `opacity-100 translate-y-0 sm:scale-100`,
                              leave: `ease-in duration-200`,
                              "leave-from": `opacity-100 translate-y-0 sm:scale-100`,
                              "leave-to": `opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95`,
                            },
                            {
                              default: I(() => [
                                W(`div`, zZ, [
                                  W(`div`, null, [
                                    W(`h3`, BZ, [
                                      W(`div`, null, [z(t.$slots, `title`)]),
                                      W(`div`, VZ, [
                                        z(t.$slots, `action`),
                                        W(
                                          `button`,
                                          {
                                            type: `button`,
                                            class: `rounded-md p-1 text-gray-400 hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700`,
                                            onClick: (n[0] ||= (e) => r(`close`)),
                                          },
                                          [
                                            ...(n[3] ||= [
                                              W(
                                                `i`,
                                                {
                                                  class: `fas fa-times`,
                                                },
                                                null,
                                                -1,
                                              ),
                                            ]),
                                          ],
                                        ),
                                      ]),
                                    ]),
                                    t.$slots.description
                                      ? (A(),
                                        M(`div`, HZ, [W(`p`, UZ, [z(t.$slots, `description`)])]))
                                      : U(``, !0),
                                    W(`div`, WZ, [z(t.$slots, `default`)]),
                                  ]),
                                ]),
                              ]),
                              _: 3,
                            },
                          ),
                        ],
                        512,
                      ),
                    ],
                    32,
                  ),
                ]),
                _: 3,
              },
              8,
              [`show`],
            )
          )
        );
      },
    },
  );
B();
function KZ(e, t) {
  return (
    A(),
    M(
      `svg`,
      {
        xmlns: `http://www.w3.org/2000/svg`,
        fill: `none`,
        viewBox: `0 0 24 24`,
        "stroke-width": `1.5`,
        stroke: `currentColor`,
        "aria-hidden": `true`,
        "data-slot": `icon`,
      },
      [
        W(`path`, {
          "stroke-linecap": `round`,
          "stroke-linejoin": `round`,
          d: `M6 18 18 6M6 6l12 12`,
        }),
      ],
    )
  );
}
var qZ = i({
  default: () => oQ,
});
B();
var JZ = {
    class: `absolute inset-0 overflow-hidden`,
  },
  YZ = {
    class: `lg:max-w-1/2 max-w-3/4 fixed inset-y-0 right-0 flex pl-16`,
  },
  XZ = {
    class: `w-screen`,
  },
  ZZ = {
    class: `dark:bg-dark-body flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl dark:divide-gray-700`,
  },
  QZ = {
    class: `h-0 flex-1 overflow-y-auto`,
  },
  $Z = {
    class: `bg-primary mt-16 px-4 py-6 dark:bg-black sm:px-6`,
  },
  eQ = {
    class: `flex items-center justify-between`,
  },
  tQ = {
    class: `text-lg font-medium text-white`,
  },
  nQ = {
    class: `ml-3 flex h-7 items-center`,
  },
  rQ = {
    key: 0,
    class: `mt-1`,
  },
  iQ = {
    class: `text-sm text-indigo-300`,
  },
  aQ = {
    class: `scroller-thin-y scroller-hidden flex flex-1 flex-col justify-between overflow-x-hidden p-4`,
  },
  oQ = {
    __name: `BaseSideover`,
    props: {
      visibility: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [`close`],
    setup(e, { emit: t }) {
      Te();
      let n = t;
      return (t, r) => (
        A(),
        L(
          P(xh),
          {
            as: `template`,
            show: e.visibility,
          },
          {
            default: I(() => [
              W(
                `div`,
                {
                  class: `fixed inset-0 z-20 overflow-hidden`,
                  onClose: (r[1] ||= (e) => n(`close`)),
                },
                [
                  W(`div`, JZ, [
                    (r[4] ||= W(
                      `div`,
                      {
                        class: `absolute inset-0`,
                      },
                      null,
                      -1,
                    )),
                    W(`div`, YZ, [
                      N(
                        P(bh),
                        {
                          as: `template`,
                          enter: `transform transition ease-in-out duration-500 sm:duration-700`,
                          "enter-from": `translate-x-full`,
                          "enter-to": `translate-x-0`,
                          leave: `transform transition ease-in-out duration-500 sm:duration-700`,
                          "leave-from": `translate-x-0`,
                          "leave-to": `translate-x-full`,
                        },
                        {
                          default: I(() => [
                            W(`div`, XZ, [
                              W(`div`, ZZ, [
                                W(`div`, QZ, [
                                  W(`div`, $Z, [
                                    W(`div`, eQ, [
                                      W(`div`, tQ, [z(t.$slots, `title`)]),
                                      W(`div`, nQ, [
                                        W(
                                          `span`,
                                          {
                                            class: `cursor-pointer text-gray-200 hover:text-white`,
                                            onClick: (r[0] ||= (e) => n(`close`)),
                                          },
                                          [
                                            (r[2] ||= W(
                                              `span`,
                                              {
                                                class: `sr-only`,
                                              },
                                              `Close panel`,
                                              -1,
                                            )),
                                            N(P(KZ), {
                                              class: `h-6 w-6`,
                                              "aria-hidden": `true`,
                                            }),
                                          ],
                                        ),
                                      ]),
                                    ]),
                                    t.$slots.description
                                      ? (A(),
                                        M(`div`, rQ, [W(`p`, iQ, [z(t.$slots, `description`)])]))
                                      : U(``, !0),
                                  ]),
                                  W(`div`, aQ, [z(t.$slots, `default`)]),
                                ]),
                                (r[3] ||= W(
                                  `div`,
                                  {
                                    class: `flex shrink-0 justify-end px-4 py-4`,
                                  },
                                  null,
                                  -1,
                                )),
                              ]),
                            ]),
                          ]),
                          _: 3,
                        },
                      ),
                    ]),
                  ]),
                ],
                32,
              ),
            ]),
            _: 3,
          },
          8,
          [`show`],
        )
      );
    },
  },
  sQ = i({
    default: () => uQ,
  });
B();
var cQ = {
    class: `flex items-start justify-between gap-3`,
  },
  lQ = {
    key: 0,
    class: `ml-1 text-sm font-medium`,
  },
  uQ = Object.assign(
    {
      name: `BaseStatBox`,
    },
    {
      props: {
        title: {
          type: String,
          default: ``,
        },
        value: {
          type: [Number, String],
          default: 0,
        },
        valueSuffix: {
          type: String,
          default: ``,
        },
        secondaryTitle: {
          type: String,
          default: ``,
        },
        secondaryValue: {
          type: [Number, String],
          default: null,
        },
        icon: {
          type: String,
          default: ``,
        },
        background: {
          type: String,
          default: ``,
        },
        customBackground: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        let t = e,
          n = {
            primary: {
              darkText: !1,
            },
            secondary: {
              darkText: !1,
            },
            success: {
              darkText: !1,
            },
            info: {
              darkText: !1,
            },
            danger: {
              darkText: !1,
            },
            warning: {
              darkText: !0,
            },
          },
          r = V(
            () => (t.secondaryTitle && t.secondaryTitle.trim() !== ``) || t.secondaryValue !== null,
          ),
          i = V(() => (t.background || ``).toLowerCase().trim()),
          a = (e) => {
            let t = (e || ``).trim();
            if (!t) return null;
            let n = t.startsWith(`#`) ? t : `#${t}`;
            return /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(n) ? n : null;
          },
          o = (e) => {
            let t = e.replace(`#`, ``),
              n =
                t.length === 3
                  ? t
                      .split(``)
                      .map((e) => e + e)
                      .join(``)
                  : t,
              r = parseInt(n.substring(0, 2), 16),
              i = parseInt(n.substring(2, 4), 16),
              a = parseInt(n.substring(4, 6), 16);
            return (0.299 * r + 0.587 * i + 0.114 * a) / 255 < 0.55;
          },
          s = V(() => a(t.customBackground)),
          c = V(() => !!s.value),
          l = V(() => !!i.value && !!n[i.value]),
          u = V(() =>
            c.value
              ? {
                  backgroundColor: s.value,
                }
              : null,
          ),
          d = V(() => (c.value ? !o(s.value) : !1)),
          f = V(() => (c.value ? d.value : l.value ? n[i.value].darkText : !1)),
          p = V(() => (c.value ? !d.value : l.value ? !n[i.value].darkText : !1)),
          m = V(() => !c.value && !l.value),
          h = V(() => f.value),
          g = V(() => p.value),
          v = V(() => m.value),
          y = V(() => f.value),
          b = V(() => p.value),
          x = V(() => m.value),
          S = V(() => f.value),
          C = V(() => p.value),
          w = V(() => m.value);
        return (t, n) => (
          A(),
          M(
            `div`,
            {
              class: O([
                `rounded-lg p-4 shadow-sm`,
                [
                  !l.value && !c.value ? `dark:bg-dark-header bg-white` : ``,
                  i.value === `primary` ? `bg-primary` : ``,
                  i.value === `secondary` ? `bg-secondary` : ``,
                  i.value === `success` ? `bg-success` : ``,
                  i.value === `info` ? `bg-info` : ``,
                  i.value === `danger` ? `bg-danger` : ``,
                  i.value === `warning` ? `bg-warning` : ``,
                ],
              ]),
              style: Pe(u.value),
            },
            [
              W(`div`, cQ, [
                W(
                  `h3`,
                  {
                    class: O([
                      `text-base font-normal uppercase`,
                      [
                        f.value ? `text-gray-800/85` : ``,
                        p.value ? `text-white/85` : ``,
                        m.value ? `text-gray-500` : ``,
                      ],
                    ]),
                  },
                  T(e.title),
                  3,
                ),
                e.icon
                  ? (A(),
                    M(
                      `div`,
                      {
                        key: 0,
                        class: O([
                          `flex h-9 w-9 shrink-0 items-center justify-center rounded-full`,
                          [
                            S.value ? `bg-black/10 text-gray-900` : ``,
                            C.value ? `bg-white/20 text-white` : ``,
                            w.value ? `bg-gray-100 text-gray-600` : ``,
                          ],
                        ]),
                      },
                      [
                        W(
                          `i`,
                          {
                            class: O(e.icon),
                          },
                          null,
                          2,
                        ),
                      ],
                      2,
                    ))
                  : U(``, !0),
              ]),
              W(
                `p`,
                {
                  class: O([
                    `text-2xl font-semibold leading-none sm:text-3xl`,
                    [
                      h.value ? `text-gray-900` : ``,
                      g.value ? `text-white` : ``,
                      v.value ? `text-gray-900 dark:text-gray-400` : ``,
                    ],
                  ]),
                },
                [
                  H(T(e.value) + ` `, 1),
                  e.valueSuffix ? (A(), M(`span`, lQ, T(e.valueSuffix), 1)) : U(``, !0),
                ],
                2,
              ),
              r.value
                ? (A(),
                  M(
                    `h6`,
                    {
                      key: 0,
                      class: O([
                        `mt-2 text-xs font-normal uppercase`,
                        [
                          y.value ? `text-gray-800/85` : ``,
                          b.value ? `text-white/85` : ``,
                          x.value ? `text-gray-700` : ``,
                        ],
                      ]),
                    },
                    T(e.secondaryValue) + ` ` + T(e.secondaryTitle),
                    3,
                  ))
                : U(``, !0),
            ],
            6,
          )
        );
      },
    },
  ),
  dQ = i({
    default: () => gQ,
  });
B();
var fQ = {
    class: `scroller-thin-x overflow-x-auto scroll-smooth`,
  },
  pQ = {
    class: `flex min-w-max flex-row items-center space-x-8 px-4 -mb-px whitespace-nowrap`,
    "aria-label": `Tabs`,
  },
  mQ = {
    key: 0,
    class: `ml-1`,
  },
  hQ = {
    class: `text-sm text-gray-700 bg-white dark:bg-dark-header sm:rounded-bl-lg sm:rounded-br-lg dark:text-gray-300`,
  },
  gQ = Object.assign(
    {
      name: `BaseTab`,
    },
    {
      props: {
        tabs: {
          type: Array,
          default: [],
        },
      },
      setup(e) {
        let t = Dc();
        return (n, r) => {
          let i = j(`router-link`),
            a = j(`BaseCard`);
          return (
            A(),
            L(
              a,
              {
                "no-padding": ``,
                "no-content-padding": ``,
              },
              {
                default: I(() => [
                  W(`div`, fQ, [
                    W(`nav`, pQ, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          e.tabs,
                          (e) => (
                            A(),
                            L(
                              i,
                              {
                                key: e.name,
                                to: {
                                  name: e.path,
                                },
                                class: O([
                                  P(t).name === e.path
                                    ? `border-primary dark:border-secondary text-primary dark:text-secondary`
                                    : `border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-400 hover:border-gray-300`,
                                  `group inline-flex items-center py-3 px-1 border-b-2 font-medium text-sm`,
                                ]),
                              },
                              {
                                default: I(() => [
                                  W(`span`, null, [
                                    e.icon
                                      ? (A(),
                                        M(
                                          `i`,
                                          {
                                            key: 0,
                                            class: O([
                                              e.icon,
                                              P(t).name === e.path
                                                ? `text-primary dark:text-secondary`
                                                : `text-gray-400 group-hover:text-gray-500 dark:group-hover:text-gray-300`,
                                              `-ml-0.5 mr-2 h-5 w-5`,
                                            ]),
                                          },
                                          null,
                                          2,
                                        ))
                                      : U(``, !0),
                                  ]),
                                  W(`span`, null, T(e.label), 1),
                                  e.count
                                    ? (A(), M(`span`, mQ, `(` + T(e.count) + `)`, 1))
                                    : U(``, !0),
                                ]),
                                _: 2,
                              },
                              1032,
                              [`to`, `class`],
                            )
                          ),
                        ),
                        128,
                      )),
                    ]),
                  ]),
                  W(`div`, hQ, [z(n.$slots, `default`)]),
                ]),
                _: 3,
              },
            )
          );
        };
      },
    },
  ),
  _Q = i({
    default: () => wQ,
  });
B();
var vQ = {
    class: `flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4 shadow-sm dark:border-gray-700 dark:bg-dark-header`,
  },
  yQ = {
    class: `flex items-center gap-3`,
  },
  bQ = {
    class: `flex h-9 w-9 items-center justify-center rounded-lg bg-indigo-50 dark:bg-indigo-900/40`,
  },
  xQ = {
    class: `text-base font-semibold leading-tight text-gray-800 dark:text-gray-100`,
  },
  SQ = {
    key: 0,
    class: `mt-0.5 text-xs text-gray-400 dark:text-gray-500`,
  },
  CQ = {
    class: `min-h-0 flex-1 overflow-y-auto p-4 sm:p-6`,
  },
  wQ = Object.assign(
    {
      name: `BaseTreeView`,
    },
    {
      props: {
        visibility: {
          type: Boolean,
          default: !1,
        },
        isLoading: {
          type: Boolean,
          default: !1,
        },
        title: {
          type: String,
          default: ``,
        },
        description: {
          type: String,
          default: ``,
        },
        icon: {
          type: String,
          default: `fa-sitemap`,
        },
        items: {
          type: Array,
          default: () => [],
        },
        config: {
          type: Object,
          default: () => ({}),
        },
        itemLabel: {
          type: String,
          default: `item`,
        },
        itemsLabel: {
          type: String,
          default: `items`,
        },
      },
      emits: [`close`],
      setup(e, { emit: t }) {
        let n = e,
          r = t;
        function i(e) {
          e.key === `Escape` && n.visibility && r(`close`);
        }
        return (
          Qe(() => window.addEventListener(`keydown`, i)),
          E(() => window.removeEventListener(`keydown`, i)),
          (t, n) => {
            let i = j(`BaseTreeViewPanel`);
            return (
              A(),
              L(
                P(xh),
                {
                  as: `template`,
                  show: e.visibility,
                },
                {
                  default: I(() => [
                    N(
                      P(bh),
                      {
                        as: `div`,
                        class: `fixed inset-0 z-50 flex flex-col bg-gray-50 dark:bg-dark-body`,
                        enter: `transition-opacity ease-out duration-200`,
                        "enter-from": `opacity-0`,
                        "enter-to": `opacity-100`,
                        leave: `transition-opacity ease-in duration-150`,
                        "leave-from": `opacity-100`,
                        "leave-to": `opacity-0`,
                      },
                      {
                        default: I(() => [
                          W(`div`, vQ, [
                            W(`div`, yQ, [
                              W(`div`, bQ, [
                                W(
                                  `i`,
                                  {
                                    class: O(`fas ${e.icon} text-indigo-500 dark:text-indigo-400`),
                                  },
                                  null,
                                  2,
                                ),
                              ]),
                              W(`div`, null, [
                                W(`h2`, xQ, T(e.title), 1),
                                e.description ? (A(), M(`p`, SQ, T(e.description), 1)) : U(``, !0),
                              ]),
                            ]),
                            W(
                              `button`,
                              {
                                class: `rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-500 dark:hover:bg-gray-700`,
                                onClick: (n[0] ||= (e) => r(`close`)),
                              },
                              [
                                ...(n[1] ||= [
                                  W(
                                    `i`,
                                    {
                                      class: `fas fa-times`,
                                    },
                                    null,
                                    -1,
                                  ),
                                ]),
                              ],
                            ),
                          ]),
                          W(`div`, CQ, [
                            N(
                              i,
                              {
                                "is-loading": e.isLoading,
                                items: e.items,
                                config: e.config,
                                "item-label": e.itemLabel,
                                "items-label": e.itemsLabel,
                              },
                              null,
                              8,
                              [`is-loading`, `items`, `config`, `item-label`, `items-label`],
                            ),
                          ]),
                        ]),
                        _: 1,
                      },
                    ),
                  ]),
                  _: 1,
                },
                8,
                [`show`],
              )
            );
          }
        );
      },
    },
  ),
  TQ = i({
    default: () => RQ,
  });
B();
var EQ = {
    class: `flex flex-col gap-1`,
  },
  DQ = [`onClick`],
  OQ = {
    class: `w-4 h-4 shrink-0 flex items-center justify-center mt-0.5`,
  },
  kQ = {
    key: 1,
    class: `block w-1 h-1 rounded-full bg-gray-300 dark:bg-gray-600`,
  },
  AQ = {
    class: `flex-1 min-w-0`,
  },
  jQ = [`title`],
  MQ = {
    key: 0,
    class: `text-xs text-gray-400 dark:text-gray-500 font-mono truncate mt-0.5`,
  },
  NQ = {
    key: 1,
    class: `flex flex-wrap items-center gap-1 mt-1.5`,
  },
  PQ = {
    key: 0,
    class: `text-xs text-gray-400 dark:text-gray-500 font-medium`,
  },
  FQ = {
    key: 2,
    class: `flex flex-wrap items-center gap-x-3 gap-y-1 mt-1`,
  },
  IQ = {
    key: 0,
    class: `shrink-0 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded-full bg-gray-100 dark:bg-gray-700 text-xs font-medium text-gray-500 dark:text-gray-400 mt-0.5`,
  },
  LQ = {
    key: 0,
    class: `ml-3 mt-1 mb-1 pl-3 border-l-2 border-gray-200 dark:border-gray-700 flex flex-col gap-1`,
  },
  RQ = Object.assign(
    {
      name: `BaseTreeViewList`,
    },
    {
      props: {
        nodes: {
          type: Array,
          required: !0,
        },
        config: {
          type: Object,
          default: () => ({}),
        },
        depth: {
          type: Number,
          default: 0,
        },
      },
      setup(e) {
        let t = e,
          n = {
            indigo: `bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 border-indigo-200 dark:border-indigo-700`,
            violet: `bg-violet-50 dark:bg-violet-900/40 text-violet-600 dark:text-violet-300 border-violet-200 dark:border-violet-700`,
            blue: `bg-blue-50 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 border-blue-200 dark:border-blue-700`,
            sky: `bg-sky-50 dark:bg-sky-900/40 text-sky-600 dark:text-sky-300 border-sky-200 dark:border-sky-700`,
            cyan: `bg-cyan-50 dark:bg-cyan-900/40 text-cyan-600 dark:text-cyan-300 border-cyan-200 dark:border-cyan-700`,
            teal: `bg-teal-50 dark:bg-teal-900/40 text-teal-600 dark:text-teal-300 border-teal-200 dark:border-teal-700`,
            green: `bg-green-50 dark:bg-green-900/40 text-green-600 dark:text-green-300 border-green-200 dark:border-green-700`,
            emerald: `bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-300 border-emerald-200 dark:border-emerald-700`,
            lime: `bg-lime-50 dark:bg-lime-900/40 text-lime-600 dark:text-lime-300 border-lime-200 dark:border-lime-700`,
            amber: `bg-amber-50 dark:bg-amber-900/40 text-amber-600 dark:text-amber-300 border-amber-200 dark:border-amber-700`,
            orange: `bg-orange-50 dark:bg-orange-900/40 text-orange-600 dark:text-orange-300 border-orange-200 dark:border-orange-700`,
            rose: `bg-rose-50 dark:bg-rose-900/40 text-rose-600 dark:text-rose-300 border-rose-200 dark:border-rose-700`,
            pink: `bg-pink-50 dark:bg-pink-900/40 text-pink-600 dark:text-pink-300 border-pink-200 dark:border-pink-700`,
            gray: `bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-600`,
          },
          r = {
            amber: {
              dot: `bg-amber-400`,
              text: `text-amber-600 dark:text-amber-400`,
            },
            yellow: {
              dot: `bg-yellow-400`,
              text: `text-yellow-600 dark:text-yellow-400`,
            },
            emerald: {
              dot: `bg-emerald-500`,
              text: `text-emerald-600 dark:text-emerald-400`,
            },
            green: {
              dot: `bg-green-500`,
              text: `text-green-600 dark:text-green-400`,
            },
            rose: {
              dot: `bg-rose-500`,
              text: `text-rose-500 dark:text-rose-400`,
            },
            red: {
              dot: `bg-red-500`,
              text: `text-red-600 dark:text-red-400`,
            },
            blue: {
              dot: `bg-blue-500`,
              text: `text-blue-600 dark:text-blue-400`,
            },
            indigo: {
              dot: `bg-indigo-500`,
              text: `text-indigo-600 dark:text-indigo-400`,
            },
            violet: {
              dot: `bg-violet-500`,
              text: `text-violet-600 dark:text-violet-400`,
            },
            sky: {
              dot: `bg-sky-500`,
              text: `text-sky-600 dark:text-sky-400`,
            },
            teal: {
              dot: `bg-teal-500`,
              text: `text-teal-600 dark:text-teal-400`,
            },
            cyan: {
              dot: `bg-cyan-500`,
              text: `text-cyan-600 dark:text-cyan-400`,
            },
            orange: {
              dot: `bg-orange-500`,
              text: `text-orange-600 dark:text-orange-400`,
            },
            pink: {
              dot: `bg-pink-500`,
              text: `text-pink-600 dark:text-pink-400`,
            },
            gray: {
              dot: `bg-gray-400`,
              text: `text-gray-500 dark:text-gray-400`,
            },
          },
          i = Ae({});
        function a(e) {
          return l(e, t.config.id ?? `uuid`) ?? Math.random();
        }
        function o(e) {
          return Array.isArray(e.children) && e.children.length > 0;
        }
        function s(e) {
          return i[e] !== !1;
        }
        function c(e) {
          i[e] = !s(e);
        }
        function l(e, t) {
          if (t) return t.split(`.`).reduce((e, t) => e?.[t], e);
        }
        function u(e) {
          return String(l(e, t.config.label ?? `name`) ?? ``);
        }
        function d(e) {
          if (!t.config.subLabel) return null;
          let n = l(e, t.config.subLabel);
          return n == null ? null : String(n);
        }
        function f(e) {
          return t.config.meta ? (l(e, t.config.meta) ?? null) : null;
        }
        function p(e) {
          return (t.config.chips ?? [])
            .map((t, r) => {
              let i = l(e, t.field);
              if (i == null || i === ``) return null;
              let a = t.labelKey ? i[t.labelKey] : i;
              return a
                ? {
                    id: r,
                    label: String(a),
                    classes: n[t.color ?? `gray`] ?? n.gray,
                  }
                : null;
            })
            .filter(Boolean);
        }
        function m(e) {
          return (t.config.indicators ?? [])
            .map((t, n) => {
              let i = !!l(e, t.field);
              if (!i && !t.falseLabel) return null;
              let a = i ? t.trueLabel : t.falseLabel,
                o = r[i ? (t.color ?? `gray`) : (t.falseColor ?? `rose`)] ?? r.gray;
              return {
                id: n,
                label: String(a),
                dotClass: o.dot,
                textClass: o.text,
              };
            })
            .filter(Boolean);
        }
        return (t, n) => {
          let r = j(`BaseTreeViewList`, !0);
          return (
            A(),
            M(`div`, EQ, [
              (A(!0),
              M(
                ke,
                null,
                ae(
                  e.nodes,
                  (t) => (
                    A(),
                    M(
                      `div`,
                      {
                        key: a(t),
                      },
                      [
                        W(
                          `div`,
                          {
                            class: O([
                              `flex items-start gap-2 px-3 py-2.5 rounded-lg bg-white dark:bg-dark-header border border-gray-200 dark:border-gray-700 select-none transition-colors hover:border-gray-300 dark:hover:border-gray-500`,
                              {
                                "cursor-pointer": o(t),
                              },
                            ]),
                            onClick: (e) => o(t) && c(a(t)),
                          },
                          [
                            W(`div`, OQ, [
                              o(t)
                                ? (A(),
                                  M(
                                    `i`,
                                    {
                                      key: 0,
                                      class: O([
                                        `fas fa-chevron-right text-xs text-gray-400 transition-transform duration-200`,
                                        {
                                          "rotate-90": s(a(t)),
                                        },
                                      ]),
                                    },
                                    null,
                                    2,
                                  ))
                                : (A(), M(`span`, kQ)),
                            ]),
                            W(`div`, AQ, [
                              W(
                                `div`,
                                {
                                  class: `font-semibold text-sm text-gray-800 dark:text-gray-100 truncate`,
                                  title: u(t),
                                },
                                T(u(t) || `—`),
                                9,
                                jQ,
                              ),
                              d(t) === null ? U(``, !0) : (A(), M(`div`, MQ, T(d(t)), 1)),
                              f(t) !== null || p(t).length
                                ? (A(),
                                  M(`div`, NQ, [
                                    f(t) === null
                                      ? U(``, !0)
                                      : (A(), M(`span`, PQ, ` #` + T(f(t)), 1)),
                                    (A(!0),
                                    M(
                                      ke,
                                      null,
                                      ae(
                                        p(t),
                                        (e) => (
                                          A(),
                                          M(
                                            `span`,
                                            {
                                              key: e.id,
                                              class: O([
                                                `inline-flex items-center px-1.5 py-0.5 rounded-md text-xs font-medium border`,
                                                e.classes,
                                              ]),
                                            },
                                            T(e.label),
                                            3,
                                          )
                                        ),
                                      ),
                                      128,
                                    )),
                                  ]))
                                : U(``, !0),
                              m(t).length
                                ? (A(),
                                  M(`div`, FQ, [
                                    (A(!0),
                                    M(
                                      ke,
                                      null,
                                      ae(
                                        m(t),
                                        (e) => (
                                          A(),
                                          M(
                                            `span`,
                                            {
                                              key: e.id,
                                              class: O([
                                                `inline-flex items-center gap-1 text-xs font-medium`,
                                                e.textClass,
                                              ]),
                                            },
                                            [
                                              W(
                                                `span`,
                                                {
                                                  class: O([
                                                    `inline-block w-1.5 h-1.5 rounded-full shrink-0`,
                                                    e.dotClass,
                                                  ]),
                                                },
                                                null,
                                                2,
                                              ),
                                              H(` ` + T(e.label), 1),
                                            ],
                                            2,
                                          )
                                        ),
                                      ),
                                      128,
                                    )),
                                  ]))
                                : U(``, !0),
                            ]),
                            o(t) ? (A(), M(`span`, IQ, T(t.children.length), 1)) : U(``, !0),
                          ],
                          10,
                          DQ,
                        ),
                        o(t) && s(a(t))
                          ? (A(),
                            M(`div`, LQ, [
                              N(
                                r,
                                {
                                  nodes: t.children,
                                  config: e.config,
                                  depth: e.depth + 1,
                                },
                                null,
                                8,
                                [`nodes`, `config`, `depth`],
                              ),
                            ]))
                          : U(``, !0),
                      ],
                    )
                  ),
                ),
                128,
              )),
            ])
          );
        };
      },
    },
  ),
  zQ = i({
    default: () => ZQ,
  });
B();
var BQ = {
    class: `flex flex-col items-center`,
  },
  VQ = {
    class: `w-fit max-w-56 rounded-lg border border-gray-200 bg-white px-3 py-2.5 shadow-sm transition-all duration-150 hover:border-gray-300 hover:shadow-md dark:border-gray-700 dark:bg-dark-header dark:hover:border-gray-500 cursor-default select-none`,
  },
  HQ = [`title`],
  UQ = [`title`],
  WQ = {
    key: 1,
    class: `text-xs text-gray-400 dark:text-gray-500 mt-0.5 font-medium`,
  },
  GQ = {
    key: 2,
    class: `flex flex-wrap gap-1 mt-2`,
  },
  KQ = {
    key: 3,
    class: `flex flex-wrap items-center gap-x-3 gap-y-1 mt-2`,
  },
  qQ = {
    key: 0,
    class: `w-px bg-gray-200 dark:bg-gray-600 shrink-0`,
    style: {
      height: `1.25rem`,
    },
  },
  JQ = {
    key: 1,
    class: `flex items-start justify-center`,
  },
  YQ = {
    key: 0,
    class: `absolute top-0 h-px bg-gray-200 dark:bg-gray-600`,
    style: {
      left: `0`,
      right: `50%`,
    },
  },
  XQ = {
    key: 1,
    class: `absolute top-0 h-px bg-gray-200 dark:bg-gray-600`,
    style: {
      left: `50%`,
      right: `0`,
    },
  },
  ZQ = Object.assign(
    {
      name: `BaseTreeViewNode`,
    },
    {
      props: {
        node: {
          type: Object,
          required: !0,
        },
        config: {
          type: Object,
          default: () => ({}),
        },
      },
      setup(e) {
        let t = e,
          n = {
            indigo: `bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 border-indigo-200 dark:border-indigo-700`,
            violet: `bg-violet-50 dark:bg-violet-900/40 text-violet-600 dark:text-violet-300 border-violet-200 dark:border-violet-700`,
            blue: `bg-blue-50 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 border-blue-200 dark:border-blue-700`,
            sky: `bg-sky-50 dark:bg-sky-900/40 text-sky-600 dark:text-sky-300 border-sky-200 dark:border-sky-700`,
            cyan: `bg-cyan-50 dark:bg-cyan-900/40 text-cyan-600 dark:text-cyan-300 border-cyan-200 dark:border-cyan-700`,
            teal: `bg-teal-50 dark:bg-teal-900/40 text-teal-600 dark:text-teal-300 border-teal-200 dark:border-teal-700`,
            green: `bg-green-50 dark:bg-green-900/40 text-green-600 dark:text-green-300 border-green-200 dark:border-green-700`,
            emerald: `bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-300 border-emerald-200 dark:border-emerald-700`,
            lime: `bg-lime-50 dark:bg-lime-900/40 text-lime-600 dark:text-lime-300 border-lime-200 dark:border-lime-700`,
            amber: `bg-amber-50 dark:bg-amber-900/40 text-amber-600 dark:text-amber-300 border-amber-200 dark:border-amber-700`,
            orange: `bg-orange-50 dark:bg-orange-900/40 text-orange-600 dark:text-orange-300 border-orange-200 dark:border-orange-700`,
            rose: `bg-rose-50 dark:bg-rose-900/40 text-rose-600 dark:text-rose-300 border-rose-200 dark:border-rose-700`,
            pink: `bg-pink-50 dark:bg-pink-900/40 text-pink-600 dark:text-pink-300 border-pink-200 dark:border-pink-700`,
            gray: `bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-600`,
          },
          r = {
            amber: {
              dot: `bg-amber-400`,
              text: `text-amber-600 dark:text-amber-400`,
            },
            yellow: {
              dot: `bg-yellow-400`,
              text: `text-yellow-600 dark:text-yellow-400`,
            },
            emerald: {
              dot: `bg-emerald-500`,
              text: `text-emerald-600 dark:text-emerald-400`,
            },
            green: {
              dot: `bg-green-500`,
              text: `text-green-600 dark:text-green-400`,
            },
            rose: {
              dot: `bg-rose-500`,
              text: `text-rose-500 dark:text-rose-400`,
            },
            red: {
              dot: `bg-red-500`,
              text: `text-red-600 dark:text-red-400`,
            },
            blue: {
              dot: `bg-blue-500`,
              text: `text-blue-600 dark:text-blue-400`,
            },
            indigo: {
              dot: `bg-indigo-500`,
              text: `text-indigo-600 dark:text-indigo-400`,
            },
            violet: {
              dot: `bg-violet-500`,
              text: `text-violet-600 dark:text-violet-400`,
            },
            sky: {
              dot: `bg-sky-500`,
              text: `text-sky-600 dark:text-sky-400`,
            },
            teal: {
              dot: `bg-teal-500`,
              text: `text-teal-600 dark:text-teal-400`,
            },
            cyan: {
              dot: `bg-cyan-500`,
              text: `text-cyan-600 dark:text-cyan-400`,
            },
            orange: {
              dot: `bg-orange-500`,
              text: `text-orange-600 dark:text-orange-400`,
            },
            pink: {
              dot: `bg-pink-500`,
              text: `text-pink-600 dark:text-pink-400`,
            },
            gray: {
              dot: `bg-gray-400`,
              text: `text-gray-500 dark:text-gray-400`,
            },
          };
        function i(e, t) {
          if (t) return t.split(`.`).reduce((e, t) => e?.[t], e);
        }
        let a = V(() => t.config.id ?? `uuid`);
        function o(e) {
          return i(e, a.value) ?? Math.random();
        }
        let s = V(() => String(i(t.node, t.config.label ?? `name`) ?? ``)),
          c = V(() => {
            if (!t.config.subLabel) return null;
            let e = i(t.node, t.config.subLabel);
            return e == null ? null : String(e);
          }),
          l = V(() => (t.config.meta ? (i(t.node, t.config.meta) ?? null) : null)),
          u = V(() =>
            (t.config.chips ?? [])
              .map((e, r) => {
                let a = i(t.node, e.field);
                if (a == null || a === ``) return null;
                let o = e.labelKey ? a[e.labelKey] : a;
                if (!o) return null;
                let s = e.color ?? `gray`;
                return {
                  id: r,
                  label: String(o),
                  classes: n[s] ?? n.gray,
                };
              })
              .filter(Boolean),
          ),
          d = V(() =>
            (t.config.indicators ?? [])
              .map((e, n) => {
                let a = !!i(t.node, e.field);
                if (!a && !e.falseLabel) return null;
                let o = a ? e.trueLabel : e.falseLabel,
                  s = r[a ? (e.color ?? `gray`) : (e.falseColor ?? `rose`)] ?? r.gray;
                return {
                  id: n,
                  label: String(o),
                  dotClass: s.dot,
                  textClass: s.text,
                };
              })
              .filter(Boolean),
          );
        return (t, n) => {
          let r = j(`BaseTreeViewNode`, !0);
          return (
            A(),
            M(`div`, BQ, [
              W(`div`, VQ, [
                W(
                  `div`,
                  {
                    class: `font-semibold text-sm text-gray-800 dark:text-gray-100 leading-tight truncate`,
                    title: s.value,
                  },
                  T(s.value || `—`),
                  9,
                  HQ,
                ),
                c.value === null
                  ? U(``, !0)
                  : (A(),
                    M(
                      `div`,
                      {
                        key: 0,
                        class: `text-xs text-gray-400 dark:text-gray-500 mt-0.5 font-mono truncate`,
                        title: String(c.value),
                      },
                      T(c.value),
                      9,
                      UQ,
                    )),
                l.value === null ? U(``, !0) : (A(), M(`div`, WQ, ` #` + T(l.value), 1)),
                u.value.length
                  ? (A(),
                    M(`div`, GQ, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          u.value,
                          (e) => (
                            A(),
                            M(
                              `span`,
                              {
                                key: e.id,
                                class: O([
                                  `inline-flex items-center px-1.5 py-0.5 rounded-md text-xs font-medium border`,
                                  e.classes,
                                ]),
                              },
                              T(e.label),
                              3,
                            )
                          ),
                        ),
                        128,
                      )),
                    ]))
                  : U(``, !0),
                d.value.length
                  ? (A(),
                    M(`div`, KQ, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          d.value,
                          (e) => (
                            A(),
                            M(
                              `span`,
                              {
                                key: e.id,
                                class: O([
                                  `inline-flex items-center gap-1 text-xs font-medium`,
                                  e.textClass,
                                ]),
                              },
                              [
                                W(
                                  `span`,
                                  {
                                    class: O([
                                      `inline-block w-1.5 h-1.5 rounded-full shrink-0`,
                                      e.dotClass,
                                    ]),
                                  },
                                  null,
                                  2,
                                ),
                                H(` ` + T(e.label), 1),
                              ],
                              2,
                            )
                          ),
                        ),
                        128,
                      )),
                    ]))
                  : U(``, !0),
              ]),
              e.node.children && e.node.children.length ? (A(), M(`div`, qQ)) : U(``, !0),
              e.node.children && e.node.children.length
                ? (A(),
                  M(`div`, JQ, [
                    (A(!0),
                    M(
                      ke,
                      null,
                      ae(
                        e.node.children,
                        (t, i) => (
                          A(),
                          M(
                            `div`,
                            {
                              key: o(t),
                              class: `flex flex-col items-center relative`,
                              style: {
                                padding: `0 0.75rem`,
                                "padding-top": `1.25rem`,
                              },
                            },
                            [
                              i > 0 ? (A(), M(`div`, YQ)) : U(``, !0),
                              i < e.node.children.length - 1 ? (A(), M(`div`, XQ)) : U(``, !0),
                              (n[0] ||= W(
                                `div`,
                                {
                                  class: `absolute top-0 w-px bg-gray-200 dark:bg-gray-600`,
                                  style: {
                                    left: `50%`,
                                    transform: `translateX(-50%)`,
                                    height: `1.25rem`,
                                  },
                                },
                                null,
                                -1,
                              )),
                              N(
                                r,
                                {
                                  node: t,
                                  config: e.config,
                                },
                                null,
                                8,
                                [`node`, `config`],
                              ),
                            ],
                          )
                        ),
                      ),
                      128,
                    )),
                  ]))
                : U(``, !0),
            ])
          );
        };
      },
    },
  ),
  QQ = i({
    default: () => h$,
  });
B();
var $Q = {
    class: `space-y-5`,
  },
  e$ = {
    key: 0,
    class: `flex items-center justify-center rounded-xl border border-dashed border-gray-200 bg-gray-50/80 px-6 py-16 dark:border-gray-700 dark:bg-dark-body/40`,
  },
  t$ = {
    class: `flex flex-col items-center gap-3 text-center`,
  },
  n$ = {
    class: `text-sm text-gray-500 dark:text-gray-400`,
  },
  r$ = {
    key: 1,
    class: `flex items-center justify-center rounded-xl border border-dashed border-gray-200 bg-gray-50/80 px-6 py-16 dark:border-gray-700 dark:bg-dark-body/40`,
  },
  i$ = {
    class: `text-center`,
  },
  a$ = {
    class: `text-sm font-medium text-gray-500 dark:text-gray-400`,
  },
  o$ = {
    class: `flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between`,
  },
  s$ = {
    class: `flex flex-wrap items-center gap-x-4 gap-y-2`,
  },
  c$ = {
    key: 0,
    class: `text-xs font-semibold uppercase tracking-[0.18em] text-gray-400 dark:text-gray-500`,
  },
  l$ = {
    class: `text-sm font-medium text-gray-500 dark:text-gray-400 lg:text-right`,
  },
  u$ = {
    class: `rounded-xl border border-gray-200 bg-gray-50/80 p-3 shadow-inner shadow-gray-100/60 dark:border-gray-700 dark:bg-dark-body/30 dark:shadow-none sm:p-4`,
  },
  d$ = {
    class: `lg:hidden`,
  },
  f$ = {
    class: `hidden overflow-x-auto lg:block`,
  },
  p$ = {
    class: `flex w-full justify-center px-1 py-3`,
  },
  m$ = {
    class: `flex w-max items-start justify-center gap-6 xl:gap-8`,
  },
  h$ = Object.assign(
    {
      name: `BaseTreeViewPanel`,
    },
    {
      props: {
        isLoading: {
          type: Boolean,
          default: !1,
        },
        items: {
          type: Array,
          default: () => [],
        },
        config: {
          type: Object,
          default: () => ({}),
        },
        itemLabel: {
          type: String,
          default: `item`,
        },
        itemsLabel: {
          type: String,
          default: `items`,
        },
        emptyLabel: {
          type: String,
          default: `No items found`,
        },
        loadingLabel: {
          type: String,
          default: `Loading...`,
        },
      },
      setup(e) {
        let t = e,
          n = {
            amber: {
              dot: `bg-amber-400`,
              text: `text-amber-600 dark:text-amber-400`,
            },
            yellow: {
              dot: `bg-yellow-400`,
              text: `text-yellow-600 dark:text-yellow-400`,
            },
            emerald: {
              dot: `bg-emerald-500`,
              text: `text-emerald-600 dark:text-emerald-400`,
            },
            green: {
              dot: `bg-green-500`,
              text: `text-green-600 dark:text-green-400`,
            },
            rose: {
              dot: `bg-rose-500`,
              text: `text-rose-500 dark:text-rose-400`,
            },
            red: {
              dot: `bg-red-500`,
              text: `text-red-600 dark:text-red-400`,
            },
            blue: {
              dot: `bg-blue-500`,
              text: `text-blue-600 dark:text-blue-400`,
            },
            indigo: {
              dot: `bg-indigo-500`,
              text: `text-indigo-600 dark:text-indigo-400`,
            },
            violet: {
              dot: `bg-violet-500`,
              text: `text-violet-600 dark:text-violet-400`,
            },
            sky: {
              dot: `bg-sky-500`,
              text: `text-sky-600 dark:text-sky-400`,
            },
            teal: {
              dot: `bg-teal-500`,
              text: `text-teal-600 dark:text-teal-400`,
            },
            cyan: {
              dot: `bg-cyan-500`,
              text: `text-cyan-600 dark:text-cyan-400`,
            },
            orange: {
              dot: `bg-orange-500`,
              text: `text-orange-600 dark:text-orange-400`,
            },
            pink: {
              dot: `bg-pink-500`,
              text: `text-pink-600 dark:text-pink-400`,
            },
            gray: {
              dot: `bg-gray-400`,
              text: `text-gray-500 dark:text-gray-400`,
            },
          },
          r = {
            indigo: {
              bg: `bg-indigo-50 dark:bg-indigo-900/40 border-indigo-200 dark:border-indigo-700`,
              text: `text-indigo-500 dark:text-indigo-400`,
            },
            violet: {
              bg: `bg-violet-50 dark:bg-violet-900/40 border-violet-200 dark:border-violet-700`,
              text: `text-violet-500 dark:text-violet-400`,
            },
            blue: {
              bg: `bg-blue-50 dark:bg-blue-900/40 border-blue-200 dark:border-blue-700`,
              text: `text-blue-500 dark:text-blue-400`,
            },
            sky: {
              bg: `bg-sky-50 dark:bg-sky-900/40 border-sky-200 dark:border-sky-700`,
              text: `text-sky-500 dark:text-sky-400`,
            },
            cyan: {
              bg: `bg-cyan-50 dark:bg-cyan-900/40 border-cyan-200 dark:border-cyan-700`,
              text: `text-cyan-500 dark:text-cyan-400`,
            },
            teal: {
              bg: `bg-teal-50 dark:bg-teal-900/40 border-teal-200 dark:border-teal-700`,
              text: `text-teal-500 dark:text-teal-400`,
            },
            green: {
              bg: `bg-green-50 dark:bg-green-900/40 border-green-200 dark:border-green-700`,
              text: `text-green-500 dark:text-green-400`,
            },
            emerald: {
              bg: `bg-emerald-50 dark:bg-emerald-900/40 border-emerald-200 dark:border-emerald-700`,
              text: `text-emerald-500 dark:text-emerald-400`,
            },
            lime: {
              bg: `bg-lime-50 dark:bg-lime-900/40 border-lime-200 dark:border-lime-700`,
              text: `text-lime-500 dark:text-lime-400`,
            },
            amber: {
              bg: `bg-amber-50 dark:bg-amber-900/40 border-amber-200 dark:border-amber-700`,
              text: `text-amber-500 dark:text-amber-400`,
            },
            orange: {
              bg: `bg-orange-50 dark:bg-orange-900/40 border-orange-200 dark:border-orange-700`,
              text: `text-orange-500 dark:text-orange-400`,
            },
            rose: {
              bg: `bg-rose-50 dark:bg-rose-900/40 border-rose-200 dark:border-rose-700`,
              text: `text-rose-500 dark:text-rose-400`,
            },
            pink: {
              bg: `bg-pink-50 dark:bg-pink-900/40 border-pink-200 dark:border-pink-700`,
              text: `text-pink-500 dark:text-pink-400`,
            },
            gray: {
              bg: `bg-gray-100 dark:bg-gray-800 border-gray-200 dark:border-gray-600`,
              text: `text-gray-500 dark:text-gray-400`,
            },
          };
        function i(e, t) {
          if (t) return t.split(`.`).reduce((e, t) => e?.[t], e);
        }
        let a = V(() => {
            let e = t.config.id ?? `uuid`,
              n = t.config.parentId ?? `parent.uuid`,
              r = t.config.sortField ?? `position`,
              a = {};
            t.items.forEach((t) => {
              let n = i(t, e);
              n != null &&
                (a[n] = {
                  ...t,
                  children: [],
                });
            });
            let o = [];
            t.items.forEach((t) => {
              let r = i(t, e),
                s = i(t, n);
              if (!a[r]) return;
              let c = a[r];
              s && a[s] ? a[s].children.push(c) : o.push(c);
            });
            let s = (e) => {
              (e.sort((e, t) => (i(e, r) ?? 0) - (i(t, r) ?? 0)), e.forEach((e) => s(e.children)));
            };
            return (s(o), o);
          }),
          o = V(() => t.items.length);
        function s(e) {
          return i(e, t.config.id ?? `uuid`) ?? Math.random();
        }
        let c = V(() => {
          let e = [],
            i = 0;
          for (let r of t.config.indicators ?? []) {
            let t = n[r.color ?? `gray`] ?? n.gray;
            if (
              (e.push({
                id: i++,
                shape: `dot`,
                label: r.trueLabel,
                colorClass: t.dot,
                textClass: t.text,
              }),
              r.falseLabel)
            ) {
              let t = n[r.falseColor ?? `rose`] ?? n.rose;
              e.push({
                id: i++,
                shape: `dot`,
                label: r.falseLabel,
                colorClass: t.dot,
                textClass: t.text,
              });
            }
          }
          for (let n of t.config.chips ?? []) {
            if (!n.legendLabel) continue;
            let t = r[n.color ?? `gray`] ?? r.gray;
            e.push({
              id: i++,
              shape: `swatch`,
              label: n.legendLabel,
              colorClass: t.bg,
              textClass: t.text,
            });
          }
          return e;
        });
        return (t, n) => {
          let r = j(`BaseTreeViewList`),
            i = j(`BaseTreeViewNode`);
          return (
            A(),
            M(`div`, $Q, [
              e.isLoading
                ? (A(),
                  M(`div`, e$, [
                    W(`div`, t$, [
                      (n[0] ||= W(
                        `div`,
                        {
                          class: `h-11 w-11 animate-spin rounded-full border-4 border-indigo-100 border-t-indigo-500 dark:border-indigo-950 dark:border-t-indigo-400`,
                        },
                        null,
                        -1,
                      )),
                      W(`p`, n$, T(e.loadingLabel), 1),
                    ]),
                  ]))
                : a.value.length
                  ? (A(),
                    M(
                      ke,
                      {
                        key: 2,
                      },
                      [
                        W(`div`, o$, [
                          W(`div`, s$, [
                            c.value.length ? (A(), M(`span`, c$, ` Legend `)) : U(``, !0),
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                c.value,
                                (e) => (
                                  A(),
                                  M(
                                    `span`,
                                    {
                                      key: e.id,
                                      class: O([
                                        `inline-flex items-center gap-1.5 text-xs font-medium`,
                                        e.textClass,
                                      ]),
                                    },
                                    [
                                      e.shape === `dot`
                                        ? (A(),
                                          M(
                                            `span`,
                                            {
                                              key: 0,
                                              class: O([
                                                `inline-block h-2 w-2 shrink-0 rounded-full`,
                                                e.colorClass,
                                              ]),
                                            },
                                            null,
                                            2,
                                          ))
                                        : (A(),
                                          M(
                                            `span`,
                                            {
                                              key: 1,
                                              class: O([
                                                `inline-block h-4 w-4 shrink-0 rounded-md border`,
                                                e.colorClass,
                                              ]),
                                            },
                                            null,
                                            2,
                                          )),
                                      H(` ` + T(e.label), 1),
                                    ],
                                    2,
                                  )
                                ),
                              ),
                              128,
                            )),
                          ]),
                          W(
                            `div`,
                            l$,
                            T(o.value) + ` ` + T(o.value === 1 ? e.itemLabel : e.itemsLabel),
                            1,
                          ),
                        ]),
                        W(`div`, u$, [
                          W(`div`, d$, [
                            N(
                              r,
                              {
                                nodes: a.value,
                                config: e.config,
                              },
                              null,
                              8,
                              [`nodes`, `config`],
                            ),
                          ]),
                          W(`div`, f$, [
                            W(`div`, p$, [
                              W(`div`, m$, [
                                (A(!0),
                                M(
                                  ke,
                                  null,
                                  ae(
                                    a.value,
                                    (t) => (
                                      A(),
                                      M(
                                        `div`,
                                        {
                                          key: s(t),
                                        },
                                        [
                                          N(
                                            i,
                                            {
                                              node: t,
                                              config: e.config,
                                            },
                                            null,
                                            8,
                                            [`node`, `config`],
                                          ),
                                        ],
                                      )
                                    ),
                                  ),
                                  128,
                                )),
                              ]),
                            ]),
                          ]),
                        ]),
                      ],
                      64,
                    ))
                  : (A(),
                    M(`div`, r$, [
                      W(`div`, i$, [
                        (n[1] ||= W(
                          `div`,
                          {
                            class: `mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white text-gray-300 shadow-sm ring-1 ring-gray-200 dark:bg-dark-header dark:text-gray-600 dark:ring-gray-700`,
                          },
                          [
                            W(`i`, {
                              class: `fas fa-diagram-project text-xl`,
                            }),
                          ],
                          -1,
                        )),
                        W(`p`, a$, T(e.emptyLabel), 1),
                      ]),
                    ])),
            ])
          );
        };
      },
    },
  ),
  g$ = i({
    default: () => b$,
  });
B();
var _$ = {
    class: `isolate inline-flex rounded-md shadow-sm`,
  },
  v$ = [`onClick`],
  y$ = [`href`],
  b$ = {
    __name: `ButtonGroup`,
    props: {
      options: {
        type: Array,
        required: !0,
        validator: (e) =>
          e.every(
            (e) =>
              typeof e.label == `string` &&
              (typeof e.onClick == `function` || typeof e.href == `string`),
          ),
      },
      size: {
        type: String,
        validator(e) {
          return [`xs`, `sm`, `md`, `lg`, `xl`].includes(e);
        },
        default: `md`,
      },
      design: {
        type: String,
        validator(e) {
          return [
            `primary`,
            `secondary`,
            `info`,
            `success`,
            `warning`,
            `danger`,
            `error`,
            `white`,
            `facebook`,
          ].includes(e);
        },
        default: `primary`,
      },
    },
    setup(e) {
      return (t, n) => (
        A(),
        M(`span`, _$, [
          (A(!0),
          M(
            ke,
            null,
            ae(
              e.options,
              (t, n) => (
                A(),
                M(
                  ke,
                  {
                    key: n,
                  },
                  [
                    t.href
                      ? (A(),
                        M(
                          `a`,
                          {
                            key: 1,
                            href: t.href,
                            class: O([
                              `relative inline-flex items-center font-medium transition-all duration-300`,
                              e.size === `xs` ? `px-2.5 py-1.5 text-xs` : ``,
                              e.size === `sm` ? `px-3 py-2 text-sm leading-4` : ``,
                              e.size === `md` ? `px-4 py-2 text-sm` : ``,
                              e.size === `lg` ? `px-4 py-2 text-base` : ``,
                              e.size === `xl` ? `px-6 py-3 text-base` : ``,
                              e.design === `white`
                                ? `bg-white hover:bg-gray-100 dark:bg-dark-header dark:hover:bg-dark-body text-gray-600 dark:text-gray-400`
                                : ``,
                              t.isActive ? `!bg-primary text-white dark:bg-dark-primary` : ``,
                              `ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:z-10`,
                              n === 0 ? `rounded-l-md` : ``,
                              n === e.options.length - 1 ? `rounded-r-md` : ``,
                              n === 0 ? `` : `-ml-px`,
                            ]),
                          },
                          T(t.label),
                          11,
                          y$,
                        ))
                      : (A(),
                        M(
                          `button`,
                          {
                            key: 0,
                            type: `button`,
                            class: O([
                              `relative inline-flex items-center font-medium transition-all duration-300 dark:text-gray-400`,
                              e.size === `xs` ? `px-2.5 py-1.5 text-xs` : ``,
                              e.size === `sm` ? `px-3 py-2 text-sm leading-4` : ``,
                              e.size === `md` ? `px-4 py-2 text-sm` : ``,
                              e.size === `lg` ? `px-4 py-2 text-base` : ``,
                              e.size === `xl` ? `px-6 py-3 text-base` : ``,
                              e.design === `white`
                                ? `bg-white hover:bg-gray-100 dark:bg-dark-header dark:hover:bg-dark-body text-gray-600 dark:text-gray-400`
                                : ``,
                              t.isActive ? `!bg-primary text-white dark:bg-dark-primary` : ``,
                              `ring-1 ring-inset ring-gray-300 dark:ring-gray-700 focus:z-10`,
                              n === 0 ? `rounded-l-md` : ``,
                              n === e.options.length - 1 ? `rounded-r-md` : ``,
                              n === 0 ? `` : `-ml-px`,
                            ]),
                            onClick: t.onClick,
                          },
                          T(t.label),
                          11,
                          v$,
                        )),
                  ],
                  64,
                )
              ),
            ),
            128,
          )),
        ])
      );
    },
  },
  x$ = i({
    default: () => D$,
  });
B();
var S$ = {
    class: `space-y-4`,
  },
  C$ = {
    class: `flex flex-col items-center justify-center space-y-4 py-10 text-gray-500`,
  },
  w$ = {
    class: `text-lg`,
  },
  T$ = {
    key: 0,
    class: `text-2xl text-gray-400 dark:text-gray-600`,
  },
  E$ = {
    key: 1,
    class: `text-gray-400 dark:text-gray-600`,
  },
  D$ = Object.assign(
    {
      name: `CardList`,
    },
    {
      props: {
        header: {
          type: Array,
          default: [],
        },
        footer: {
          type: Array,
          default: [],
        },
        meta: {
          type: Object,
          default: {
            hasFooter: !1,
            total: 0,
          },
        },
        module: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`BaseCard`);
          return (
            A(),
            M(
              ke,
              null,
              [
                e.meta.total
                  ? (A(),
                    L(
                      r,
                      {
                        key: 0,
                        "no-padding": ``,
                        "no-content-padding": ``,
                      },
                      {
                        default: I(() => [W(`div`, S$, [z(t.$slots, `default`)])]),
                        _: 3,
                      },
                    ))
                  : U(``, !0),
                e.meta.total === 0
                  ? (A(),
                    L(
                      r,
                      {
                        key: 1,
                      },
                      {
                        default: I(() => [
                          W(`div`, C$, [
                            (n[0] ||= W(
                              `i`,
                              {
                                class: `fas fa-list fa-4x`,
                              },
                              null,
                              -1,
                            )),
                            z(t.$slots, `content`),
                            W(`p`, w$, T(t.$trans(e.module + `.module_title`)), 1),
                            P(c)(e.module + `.module_quote`)
                              ? (A(), M(`p`, T$, T(t.$trans(e.module + `.module_quote`)), 1))
                              : U(``, !0),
                            W(`p`, null, T(t.$trans(e.module + `.module_description`)), 1),
                            P(c)(e.module + `.module_example`)
                              ? (A(), M(`p`, E$, T(t.$trans(e.module + `.module_example`)), 1))
                              : U(``, !0),
                            W(`div`, null, [z(t.$slots, `actionButton`)]),
                          ]),
                        ]),
                        _: 3,
                      },
                    ))
                  : U(``, !0),
              ],
              64,
            )
          );
        };
      },
    },
  ),
  O$ = i({
    default: () => F$,
  });
B();
var k$ = [`src`],
  A$ = {
    class: `flex justify-center items-center`,
  },
  j$ = {
    class: `min-w-0 flex-1`,
  },
  M$ = {
    class: `space-y-1 focus:outline-none`,
  },
  N$ = {
    class: `flex items-start justify-between`,
  },
  P$ = {
    class: `absolute right-2 top-2`,
  },
  F$ = Object.assign(
    {
      name: `CardView`,
    },
    {
      props: {
        imgSrc: {
          type: String,
          default: ``,
        },
        path: {
          type: Object,
          default() {
            return {};
          },
        },
        roundedBottom: {
          type: Boolean,
          default: !1,
        },
        roundedTop: {
          type: Boolean,
          default: !1,
        },
        noPadding: {
          type: Boolean,
          default: !1,
        },
        additionalBadge: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        let t = Ec(),
          n = e,
          r = () => {
            n.path && t.push(n.path);
          };
        return (t, n) => (
          A(),
          M(
            `div`,
            {
              class: O([
                `dark:bg-dark-header relative overflow-hidden border border-gray-300 bg-white shadow-lg focus-within:ring-2 focus-within:ring-offset-2 hover:border-gray-400 dark:border-gray-600`,
                {
                  "rounded-bl-lg rounded-br-lg": e.roundedBottom,
                  "rounded-tl-lg rounded-tr-lg": e.roundedTop,
                  "rounded-lg": !e.roundedBottom && !e.roundedTop,
                },
              ]),
            },
            [
              W(
                `div`,
                {
                  class: O([
                    `flex items-center space-x-3`,
                    {
                      "px-4 py-3": !e.noPadding,
                    },
                  ]),
                },
                [
                  e.imgSrc
                    ? (A(),
                      M(
                        `div`,
                        {
                          key: 0,
                          class: O([
                            `shrink-0`,
                            {
                              "cursor-pointer": e.path.name,
                            },
                          ]),
                          onClick: (n[0] ||= (e) => r()),
                        },
                        [
                          W(
                            `img`,
                            {
                              class: `h-16 w-16 rounded-full`,
                              src: e.imgSrc,
                              alt: ``,
                            },
                            null,
                            8,
                            k$,
                          ),
                          W(`span`, A$, [z(t.$slots, `additionalBadge`)]),
                        ],
                        2,
                      ))
                    : U(``, !0),
                  W(`div`, j$, [
                    W(`div`, M$, [
                      W(`div`, N$, [
                        W(
                          `p`,
                          {
                            class: O([
                              `text-sm font-medium text-gray-900 dark:text-gray-400`,
                              {
                                "cursor-pointer": e.path.name,
                              },
                            ]),
                            onClick: (n[1] ||= (e) => r()),
                          },
                          [z(t.$slots, `title`)],
                          2,
                        ),
                        W(`div`, P$, [z(t.$slots, `action`)]),
                      ]),
                      z(t.$slots, `default`),
                    ]),
                  ]),
                ],
                2,
              ),
              W(`div`, null, [z(t.$slots, `progress`)]),
            ],
            2,
          )
        );
      },
    },
  ),
  I$ = i({
    default: () => R$,
  });
B();
var L$ = [`href`],
  R$ = {
    __name: `ContactField`,
    props: {
      contactNumber: {
        type: String,
        required: !0,
      },
    },
    setup(e) {
      return (t, n) => (
        A(),
        M(
          `a`,
          {
            href: `tel:${e.contactNumber}`,
            class: `text-inherit`,
          },
          [
            (n[0] ||= W(
              `i`,
              {
                class: `fas fa-phone`,
              },
              null,
              -1,
            )),
            H(` ` + T(e.contactNumber), 1),
          ],
          8,
          L$,
        )
      );
    },
  },
  z$ = i({
    default: () => H$,
  });
B();
var B$ = {
    key: 0,
    "data-content": ``,
  },
  V$ = {
    key: 0,
    class: `absolute left-1/2 -translate-x-1/2 top-full mt-1 bg-gray-800 text-white px-3 py-1 rounded text-sm whitespace-nowrap dark:border dark:border-gray-700`,
  },
  H$ = {
    __name: `CopyContent`,
    props: {
      content: {
        type: String,
        default: ``,
      },
    },
    setup(e) {
      let t = e,
        n = F(null),
        r = F(!1),
        i = V(() => t.content && t.content.trim().length > 0),
        a = V(() =>
          i.value
            ? !0
            : (n.value?.querySelector(`[data-content]`)?.textContent || ``).trim().length > 0,
        ),
        o = () => {
          let e = t.content;
          ((!e || e.trim().length === 0) &&
            (e = n.value.querySelector(`[data-content]`)?.textContent || ``),
            navigator.clipboard.writeText(e).then(() => {
              ((r.value = !0),
                setTimeout(() => {
                  r.value = !1;
                }, 2e3));
            }));
        };
      return (e, t) => {
        let s = ve(`tooltip`);
        return (
          A(),
          M(
            `div`,
            {
              class: `flex items-center gap-2 relative`,
              ref_key: `container`,
              ref: n,
            },
            [
              i.value ? U(``, !0) : (A(), M(`div`, B$, [z(e.$slots, `default`)])),
              a.value
                ? Re(
                    (A(),
                    M(
                      `button`,
                      {
                        key: 1,
                        onClick: o,
                        class: `text-gray-500 hover:text-gray-700 cursor-pointer relative`,
                      },
                      [
                        (t[0] ||= W(
                          `i`,
                          {
                            class: `fa-solid fa-copy`,
                          },
                          null,
                          -1,
                        )),
                        r.value ? (A(), M(`div`, V$, T(e.$trans(`general.copied`)), 1)) : U(``, !0),
                      ],
                    )),
                    [[s, e.$trans(`general.copy`)]],
                  )
                : U(``, !0),
            ],
            512,
          )
        );
      };
    },
  },
  U$ = i({
    default: () => W$,
  });
B();
var W$ = {
    __name: `CountDownTimer`,
    props: {
      expiryDate: {
        type: [String, Date],
        required: !0,
      },
      showHours: {
        type: Boolean,
        default: !1,
      },
      dangerThreshold: {
        type: Number,
        default: 300,
      },
    },
    emits: [`expired`],
    setup(e, { emit: t }) {
      let n = t,
        r = e,
        i = F(new Date()),
        a = F(null),
        o = F(!1),
        s = V(() => {
          let e = new Date(r.expiryDate) - i.value;
          return Math.max(0, Math.floor(e / 1e3));
        }),
        c = V(() => s.value <= 0),
        l = V(() => s.value <= r.dangerThreshold && s.value > 0),
        u = V(() =>
          c.value ? `text-danger` : l.value ? `text-warning` : `text-gray-500 dark:text-gray-400`,
        ),
        d = V(() => {
          if (c.value) return `00:00`;
          let e = s.value,
            t = Math.floor(e / 3600),
            n = Math.floor((e % 3600) / 60),
            i = e % 60,
            a = n.toString().padStart(2, `0`),
            o = i.toString().padStart(2, `0`);
          return r.showHours && t > 0 ? `${t.toString().padStart(2, `0`)}:${a}:${o}` : `${a}:${o}`;
        });
      return (
        He(c, (e) => {
          e && !o.value && ((o.value = !0), n(`expired`));
        }),
        Qe(() => {
          a.value = setInterval(() => {
            i.value = new Date();
          }, 1e3);
        }),
        E(() => {
          a.value && clearInterval(a.value);
        }),
        (e, t) => (
          A(),
          M(
            `span`,
            {
              class: O([`text-sm font-semibold`, u.value]),
            },
            T(d.value),
            3,
          )
        )
      );
    },
  },
  G$ = i({
    default: () => X$,
  });
B();
var K$ = {
    class: `mx-auto mt-8 grid max-w-full grid-cols-1 gap-6 lg:grid-flow-col-dense lg:grid-cols-3`,
  },
  q$ = {
    class: `flex flex-col space-y-6 lg:col-span-2 lg:col-start-1`,
  },
  J$ = {
    class: `flex-1 space-y-4`,
  },
  Y$ = {
    class: `flex flex-col space-y-4 lg:col-span-1 lg:col-start-3`,
  },
  X$ = Object.assign(
    {
      name: `DetailLayoutVertical`,
    },
    {
      props: {},
      setup(e) {
        return (
          Te(),
          (e, t) => (
            A(),
            M(`div`, K$, [
              W(`div`, q$, [W(`section`, J$, [z(e.$slots, `default`)])]),
              W(`section`, Y$, [z(e.$slots, `detail`)]),
            ])
          )
        );
      },
    },
  ),
  Z$ = i({
    default: () => $$,
  });
B();
var Q$ = {
    class: `relative z-10 inline-flex rounded-md shadow-xs`,
  },
  $$ = {
    __name: `DropdownButton`,
    props: {
      direction: {
        type: String,
        default: `down`,
      },
      label: {
        type: String,
        default: ``,
      },
      as: {
        type: String,
        default: `span`,
      },
    },
    setup(e) {
      let { isRtl: t } = Kh();
      return (n, r) => (
        A(),
        M(`span`, Q$, [
          e.as === `span`
            ? (A(),
              M(
                `span`,
                {
                  key: 0,
                  class: O([
                    `dark:bg-dark-header relative inline-flex items-center truncate border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-0 dark:border-gray-700 dark:text-gray-400`,
                    P(t) ? `rounded-r-md border-l-0` : `rounded-l-md border-r-0`,
                  ]),
                },
                T(e.label),
                3,
              ))
            : U(``, !0),
          e.as === `button`
            ? (A(),
              M(
                `button`,
                {
                  key: 1,
                  type: `button`,
                  class: O([
                    `dark:bg-dark-header relative inline-flex items-center truncate border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-0 dark:border-gray-700 dark:text-gray-400`,
                    P(t) ? `rounded-r-md border-l-0` : `rounded-l-md border-r-0`,
                  ]),
                },
                T(e.label),
                3,
              ))
            : U(``, !0),
          N(
            P(Xm),
            {
              as: `span`,
              class: O([`relative block`, P(t) ? `-mr-px` : `-ml-px`]),
            },
            {
              default: I(() => [
                N(
                  P(Zm),
                  {
                    class: O([
                      `dark:bg-dark-header relative inline-flex items-center border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-0 dark:border-gray-700`,
                      P(t) ? `rounded-l-md border-r-0` : `rounded-r-md border-l-0`,
                    ]),
                  },
                  {
                    default: I(() => [
                      (r[0] ||= W(
                        `span`,
                        {
                          class: `sr-only`,
                        },
                        `Open options`,
                        -1,
                      )),
                      e.direction === `up`
                        ? (A(),
                          L(P(Hy), {
                            key: 0,
                            class: `h-5 w-5`,
                            "aria-hidden": `true`,
                          }))
                        : U(``, !0),
                      e.direction === `down`
                        ? (A(),
                          L(P(zy), {
                            key: 1,
                            class: `h-5 w-5`,
                            "aria-hidden": `true`,
                          }))
                        : U(``, !0),
                    ]),
                    _: 1,
                  },
                  8,
                  [`class`],
                ),
                N(
                  Ve,
                  {
                    "enter-active-class": `transition duration-100 ease-out`,
                    "enter-from-class": `transform scale-95 opacity-0`,
                    "enter-to-class": `transform scale-100 opacity-100`,
                    "leave-active-class": `transition duration-75 ease-in`,
                    "leave-from-class": `transform scale-100 opacity-100`,
                    "leave-to-class": `transform scale-95 opacity-0`,
                  },
                  {
                    default: I(() => [
                      N(
                        P(Qm),
                        {
                          class: O([
                            `dark:bg-dark-header absolute mt-2 w-56 rounded-md bg-white shadow-lg ring-1 ring-black ring-black/5 focus:outline-none`,
                            P(t) ? `left-0 -ml-1` : `right-0 -mr-1`,
                            {
                              "bottom-10": e.direction === `up`,
                              "origin-bottom-right": e.direction === `up` && !P(t),
                              "origin-bottom-left": e.direction === `up` && P(t),
                              "origin-top-right": e.direction === `down` && !P(t),
                              "origin-top-left": e.direction === `down` && P(t),
                            },
                          ]),
                        },
                        {
                          default: I(() => [z(n.$slots, `default`)]),
                          _: 3,
                        },
                        8,
                        [`class`],
                      ),
                    ]),
                    _: 3,
                  },
                ),
              ]),
              _: 3,
            },
            8,
            [`class`],
          ),
        ])
      );
    },
  },
  e1 = i({
    default: () => t1,
  });
B();
var t1 = Object.assign(
    {
      name: `DropdownItem`,
    },
    {
      props: {
        separator: {
          type: Boolean,
          default: !1,
        },
        icon: {
          type: String,
          default: ``,
        },
        as: {
          type: String,
          default: `span`,
        },
        href: {
          type: String,
          default: `#`,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = e,
          n = V(() => (t.as === `route` ? `router-link` : t.as === `link` ? `a` : `span`));
        return (t, r) => (
          A(),
          M(
            `div`,
            {
              class: O({
                "py-1": e.separator,
              }),
            },
            [
              N(
                P($m),
                {
                  disabled: e.disabled,
                },
                {
                  default: I(({ active: r }) => [
                    (A(),
                    L(
                      _e(n.value),
                      {
                        href: e.href,
                        target: t.$attrs.target,
                        class: O([
                          `group flex items-center px-4 py-2 text-sm`,
                          {
                            "dark:bg-dark-body bg-gray-100 text-gray-900 dark:text-gray-400": r,
                            "text-gray-700 dark:text-gray-300": !r,
                            "cursor-pointer": e.as === `span`,
                          },
                        ]),
                      },
                      {
                        default: I(() => [
                          e.icon
                            ? (A(),
                              M(
                                `i`,
                                {
                                  key: 0,
                                  class: O([
                                    e.icon,
                                    `ltr:mr-3 rtl:ml-3 text-gray-400 group-hover:text-gray-500`,
                                  ]),
                                  "aria-hidden": `true`,
                                },
                                null,
                                2,
                              ))
                            : U(``, !0),
                          z(t.$slots, `default`),
                        ]),
                        _: 3,
                      },
                      8,
                      [`href`, `target`, `class`],
                    )),
                  ]),
                  _: 3,
                },
                8,
                [`disabled`],
              ),
            ],
            2,
          )
        );
      },
    },
  ),
  n1 = i({
    default: () => r1,
  });
B();
var r1 = Object.assign(
    {
      name: `DropdownMenu`,
    },
    {
      props: {
        slim: {
          type: Boolean,
          default: !1,
        },
        noWidth: {
          type: Boolean,
          default: !1,
        },
        topMargin: {
          type: Boolean,
          default: !1,
        },
        doubleTopMargin: {
          type: Boolean,
          default: !1,
        },
        rightMargin: {
          type: Boolean,
          default: !0,
        },
        direction: {
          type: String,
          default: `left`,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`EllipsisVerticalIcon`);
          return (
            A(),
            L(
              P(Xm),
              {
                as: `div`,
                class: `relative flex items-center justify-end`,
              },
              {
                default: I(() => [
                  N(
                    P(Zm),
                    {
                      class: O([
                        `dark:bg-dark-header inline-flex items-center justify-center rounded-full bg-transparent text-gray-400 hover:text-gray-500`,
                        {
                          "h-5 w-5": e.slim,
                          "h-8": !e.slim,
                          "w-8": !e.noWidth,
                        },
                      ]),
                    },
                    {
                      default: I(() => [
                        (n[0] ||= W(
                          `span`,
                          {
                            class: `sr-only`,
                          },
                          `Open options`,
                          -1,
                        )),
                        z(t.$slots, `clickable`, {}, () => [
                          N(r, {
                            class: `h-5 w-5`,
                            "aria-hidden": `true`,
                          }),
                        ]),
                      ]),
                      _: 3,
                    },
                    8,
                    [`class`],
                  ),
                  N(
                    Ve,
                    {
                      "enter-active-class": `transition duration-100 ease-out`,
                      "enter-from-class": `transform scale-95 opacity-0`,
                      "enter-to-class": `transform scale-100 opacity-100`,
                      "leave-active-class": `transition duration-75 ease-in`,
                      "leave-from-class": `transform scale-100 opacity-100`,
                      "leave-to-class": `transform scale-95 opacity-0`,
                    },
                    {
                      default: I(() => [
                        N(
                          P(Qm),
                          {
                            class: O([
                              `dark:bg-dark-header absolute z-20 mt-1 w-48 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-black/5 focus:outline-none dark:divide-gray-600 dark:border dark:border-gray-700`,
                              {
                                "top-0": !e.topMargin && !e.doubleTopMargin,
                                "top-6": e.topMargin,
                                "top-10": e.doubleTopMargin,
                                "right-7": e.direction == `left` && e.rightMargin,
                                "right-0": e.direction == `left` && !e.rightMargin,
                                "left-0": e.direction == `right`,
                              },
                            ]),
                          },
                          {
                            default: I(() => [z(t.$slots, `default`)]),
                            _: 3,
                          },
                          8,
                          [`class`],
                        ),
                      ]),
                      _: 3,
                    },
                  ),
                ]),
                _: 3,
              },
            )
          );
        };
      },
    },
  ),
  i1 = i({
    default: () => c1,
  });
B();
var a1 = {
    class: `py-1`,
  },
  o1 = [`disabled`, `onClick`],
  s1 = {
    key: 0,
    class: `fas fa-check text-xs`,
  },
  c1 = Object.assign(
    {
      name: `DropdownUpdateBadge`,
    },
    {
      props: {
        options: {
          type: Array,
          default() {
            return [];
          },
        },
        value: {
          type: String,
          default: ``,
        },
        label: {
          type: String,
          default: ``,
        },
        design: {
          type: String,
          default: `primary`,
        },
        editable: {
          type: Boolean,
          default: !1,
        },
        placeholder: {
          type: String,
          default: `-`,
        },
        labelProp: {
          type: String,
          default: `label`,
        },
        valueProp: {
          type: String,
          default: `value`,
        },
        direction: {
          type: String,
          default: `right`,
        },
        rightMargin: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`select`],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = (e) => {
            e !== r.value && n(`select`, e);
          };
        return (t, n) => {
          let r = j(`BaseBadge`),
            a = j(`DropdownMenu`);
          return e.editable
            ? (A(),
              L(
                a,
                {
                  key: 0,
                  class: `inline-flex justify-start`,
                  slim: ``,
                  "no-width": ``,
                  direction: e.direction,
                  "right-margin": e.rightMargin,
                },
                {
                  clickable: I(() => [
                    N(
                      r,
                      {
                        clickable: ``,
                        design: e.design,
                      },
                      {
                        default: I(() => [H(T(e.label || e.placeholder), 1)]),
                        _: 1,
                      },
                      8,
                      [`design`],
                    ),
                  ]),
                  default: I(() => [
                    W(`div`, a1, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          e.options,
                          (t) => (
                            A(),
                            L(
                              P($m),
                              {
                                key: t[e.valueProp],
                                as: `template`,
                              },
                              {
                                default: I(({ active: n }) => [
                                  W(
                                    `button`,
                                    {
                                      type: `button`,
                                      class: O([
                                        `flex w-full items-center justify-between px-4 py-2 text-left text-sm`,
                                        [
                                          n
                                            ? `bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-gray-100`
                                            : `text-gray-700 dark:text-gray-200`,
                                          t[e.valueProp] === e.value
                                            ? `cursor-default font-medium`
                                            : ``,
                                        ],
                                      ]),
                                      disabled: t[e.valueProp] === e.value,
                                      onClick: (n) => i(t[e.valueProp]),
                                    },
                                    [
                                      W(`span`, null, T(t[e.labelProp] || e.placeholder), 1),
                                      t[e.valueProp] === e.value ? (A(), M(`i`, s1)) : U(``, !0),
                                    ],
                                    10,
                                    o1,
                                  ),
                                ]),
                                _: 2,
                              },
                              1024,
                            )
                          ),
                        ),
                        128,
                      )),
                    ]),
                  ]),
                  _: 1,
                },
                8,
                [`direction`, `right-margin`],
              ))
            : (A(),
              L(
                r,
                {
                  key: 1,
                  design: e.design,
                },
                {
                  default: I(() => [H(T(e.label || e.placeholder), 1)]),
                  _: 1,
                },
                8,
                [`design`],
              ));
        };
      },
    },
  ),
  l1 = i({
    default: () => f1,
  });
B();
var u1 = {
    class: `flex flex-col items-center justify-center space-y-4 py-10 text-gray-500`,
  },
  d1 = {
    class: `text-xl font-semibold`,
  },
  f1 = {
    __name: `EmptyCard`,
    props: {
      total: {
        type: Number,
        default: 0,
      },
    },
    setup(e) {
      return (t, n) => {
        let r = j(`BaseCard`);
        return e.total === 0
          ? (A(),
            L(
              r,
              {
                key: 0,
              },
              {
                default: I(() => [
                  W(`div`, u1, [
                    (n[0] ||= W(
                      `i`,
                      {
                        class: `fas fa-list fa-4x`,
                      },
                      null,
                      -1,
                    )),
                    W(`div`, d1, T(t.$trans(`dashboard.nothing_to_show`)), 1),
                  ]),
                ]),
                _: 1,
              },
            ))
          : U(``, !0);
      };
    },
  },
  p1 = i({
    default: () => v1,
  });
B();
var m1 = {
    class: `pointer-events-none fixed inset-x-0 bottom-0 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8`,
  },
  h1 = {
    class: `text-sm leading-6 text-white`,
  },
  g1 = {
    class: `font-semibold`,
  },
  _1 = {
    key: 0,
    class: `text-xs text-white`,
  },
  v1 = {
    __name: `FloatingBottom`,
    props: {
      title: {
        type: String,
        default: null,
      },
      subTitle: {
        type: String,
        default: null,
      },
      description: {
        type: String,
        default: null,
      },
      link: {
        type: String,
        default: null,
      },
      design: {
        type: String,
        default: `default`,
      },
    },
    setup(e) {
      let t = e,
        n = () => {
          t.link && window.open(t.link, `_blank`, `noopener`);
        };
      return (t, r) => (
        A(),
        M(`div`, m1, [
          W(
            `div`,
            {
              class: O([
                `pointer-events-auto flex items-center justify-between gap-x-6 px-6 py-2.5 sm:rounded-xl sm:py-3 sm:pl-4 sm:pr-3.5`,
                {
                  "bg-gray-900": e.design == "default",
                  "bg-success": e.design == `success`,
                  "bg-danger": e.design == `danger` || e.design == `error`,
                  "bg-warning": e.design == `warning`,
                  "bg-info": e.design == `info`,
                },
              ]),
            },
            [
              W(`p`, h1, [
                W(
                  `span`,
                  {
                    onClick: n,
                    class: O({
                      "cursor-pointer": e.link,
                    }),
                  },
                  [
                    W(`strong`, g1, T(e.title), 1),
                    (r[0] ||= W(
                      `svg`,
                      {
                        viewBox: `0 0 2 2`,
                        class: `mx-2 inline h-0.5 w-0.5 fill-current`,
                        "aria-hidden": `true`,
                      },
                      [
                        W(`circle`, {
                          cx: `1`,
                          cy: `1`,
                          r: `1`,
                        }),
                      ],
                      -1,
                    )),
                    H(` ` + T(e.description), 1),
                    (r[1] ||= W(
                      `span`,
                      {
                        "aria-hidden": `true`,
                      },
                      `→`,
                      -1,
                    )),
                    e.subTitle ? (A(), M(`div`, _1, T(e.subTitle), 1)) : U(``, !0),
                  ],
                  2,
                ),
              ]),
            ],
            2,
          ),
        ])
      );
    },
  },
  y1 = i({
    default: () => S1,
  });
B();
var b1 = {
    class: `relative flex items-center justify-end`,
  },
  x1 = {
    class: `divide-y divide-gray-200 bg-white dark:divide-gray-600 dark:border dark:border-gray-700 dark:bg-neutral-800`,
  },
  S1 = Object.assign(
    {
      name: `FloatingMenu`,
    },
    {
      props: {
        slim: {
          type: Boolean,
          default: !1,
        },
        noWidth: {
          type: Boolean,
          default: !1,
        },
        topMargin: {
          type: Boolean,
          default: !1,
        },
        doubleTopMargin: {
          type: Boolean,
          default: !1,
        },
        rightMargin: {
          type: Boolean,
          default: !0,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`EllipsisVerticalIcon`),
            i = j(`VMenu`);
          return (
            A(),
            M(`div`, b1, [
              N(
                i,
                {
                  placement: `left-end`,
                  triggers: [`hover`, `focus`, `click`],
                  autoHide: !0,
                },
                {
                  popper: I(() => [W(`div`, x1, [z(t.$slots, `default`)])]),
                  default: I(() => [
                    W(
                      `div`,
                      {
                        class: O([
                          `dark:bg-dark-header inline-flex items-center justify-center rounded-full bg-transparent text-gray-400 hover:text-gray-500`,
                          {
                            "h-5 w-5": e.slim,
                            "h-8": !e.slim,
                            "w-8": !e.noWidth,
                          },
                        ]),
                      },
                      [
                        N(r, {
                          class: `h-5 w-5`,
                        }),
                      ],
                      2,
                    ),
                  ]),
                  _: 3,
                },
              ),
            ])
          );
        };
      },
    },
  ),
  C1 = i({
    default: () => w1,
  });
B();
var w1 = Object.assign(
    {
      name: `FloatingMenuItem`,
    },
    {
      props: {
        separator: {
          type: Boolean,
          default: !1,
        },
        icon: {
          type: String,
          default: ``,
        },
        as: {
          type: String,
          default: `span`,
        },
        href: {
          type: String,
          default: `#`,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
        active: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = e,
          n = V(() => (t.as === `route` ? `router-link` : t.as === `link` ? `a` : `span`));
        return (t, r) => (
          A(),
          M(
            `div`,
            {
              class: O({
                "py-1": e.separator,
              }),
            },
            [
              (A(),
              L(
                _e(n.value),
                {
                  href: e.href,
                  target: t.$attrs.target,
                  class: O([
                    `group flex items-center px-4 py-2 text-sm`,
                    {
                      "dark:bg-dark-body bg-gray-100 text-gray-900 dark:text-gray-400": e.active,
                      "text-gray-700 dark:text-gray-300": !e.active,
                      "cursor-pointer": e.as === `span`,
                    },
                  ]),
                },
                {
                  default: I(() => [
                    e.icon
                      ? (A(),
                        M(
                          `i`,
                          {
                            key: 0,
                            class: O([
                              e.icon,
                              `ltr:mr-3 rtl:ml-3 text-gray-400 group-hover:text-gray-500`,
                            ]),
                            "aria-hidden": `true`,
                          },
                          null,
                          2,
                        ))
                      : U(``, !0),
                    z(t.$slots, `default`),
                  ]),
                  _: 3,
                },
                8,
                [`href`, `target`, `class`],
              )),
            ],
            2,
          )
        );
      },
    },
  ),
  T1 = i({
    default: () => O1,
  });
B();
var E1 = {
    class: `overflow-hidden shadow-lg ring-1 ring-black ring-black/5`,
  },
  D1 = {
    class: `relative grid gap-4 bg-white dark:bg-dark-header dark:border dark:border-gray-700 dark:text-gray-400 hover:text-gray-800 hover:dark:text-gray-300 px-5 py-2 sm:gap-4 sm:p-2`,
  },
  O1 = Object.assign(
    {
      name: `FlyoutMenu`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          L(
            P(ah),
            {
              class: `relative`,
            },
            {
              default: I(({ open: n }) => [
                N(
                  P(zre),
                  {
                    class: `inline-flex focus:outline-none focus:ring-0 ring-0 items-center text-base font-medium text-white`,
                  },
                  {
                    default: I(() => [
                      W(`span`, null, T(e.label), 1),
                      N(P(zy), {
                        class: O([`text-white`, `ml-1 h-5 w-5`]),
                        "aria-hidden": `true`,
                      }),
                    ]),
                    _: 1,
                  },
                ),
                N(
                  Ve,
                  {
                    "enter-active-class": `transition duration-200 ease-out`,
                    "enter-from-class": `translate-y-1 opacity-0`,
                    "enter-to-class": `translate-y-0 opacity-100`,
                    "leave-active-class": `transition duration-150 ease-in`,
                    "leave-from-class": `translate-y-0 opacity-100`,
                    "leave-to-class": `translate-y-1 opacity-0`,
                  },
                  {
                    default: I(() => [
                      N(
                        P(Bre),
                        {
                          class: `absolute right-0 z-10 mt-3 w-48 max-w-xs transform px-2 sm:px-0`,
                        },
                        {
                          default: I(() => [
                            W(`div`, E1, [W(`div`, D1, [z(t.$slots, `default`)])]),
                          ]),
                          _: 3,
                        },
                      ),
                    ]),
                    _: 3,
                  },
                ),
              ]),
              _: 3,
            },
          )
        );
      },
    },
  ),
  k1 = i({
    default: () => A1,
  });
B();
var A1 = Object.assign(
    {
      name: `HelperText`,
    },
    {
      props: {
        cursor: {
          type: Boolean,
          default: !1,
        },
        textRight: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `div`,
            {
              class: O([
                `mt-1 text-xs flex dark:text-gray-400`,
                {
                  "cursor-pointer": e.cursor,
                  "justify-end": e.textRight,
                },
              ]),
            },
            [z(t.$slots, `default`)],
            2,
          )
        );
      },
    },
  ),
  j1 = i({
    default: () => F1,
  });
B();
var M1 = {},
  N1 = {
    class: `space-y-1`,
  };
function P1(e, t) {
  return (A(), M(`div`, N1, [z(e.$slots, `default`)]));
}
var F1 = tu(M1, [[`render`, P1]]),
  I1 = i({
    default: () => B1,
  });
B();
var L1 = {
    key: 0,
    class: `flex items-center`,
  },
  R1 = {
    class: `text-gray-700 dark:text-gray-500 text-sm font-medium w-3/4 sm:w-1/2 lg:w-1/3`,
  },
  z1 = {
    class: `text-gray-500 dark:text-gray-300`,
  },
  B1 = {
    __name: `HorizontalListItem`,
    props: {
      label: {
        type: String,
        default: ``,
      },
      value: {
        type: String,
        default: ``,
      },
    },
    setup(e) {
      return (t, n) =>
        e.value
          ? (A(), M(`div`, L1, [W(`span`, R1, T(e.label), 1), W(`div`, z1, T(e.value), 1)]))
          : U(``, !0);
    },
  },
  V1 = i({
    default: () => U1,
  });
B();
var H1 = {
    key: 0,
    class: `ml-2`,
  },
  U1 = Object.assign(
    {
      name: `ImageLabel`,
    },
    {
      props: {
        label: {
          type: String,
          required: !0,
        },
        size: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`BaseLabel`);
          return (
            A(),
            L(
              r,
              {
                class: `my-2`,
              },
              {
                default: I(() => [
                  W(`div`, null, [
                    W(`strong`, null, T(e.label), 1),
                    e.size
                      ? (A(),
                        M(
                          `span`,
                          H1,
                          T(
                            t.$trans(`global.recommended_size`, {
                              attribute: e.size,
                            }),
                          ),
                          1,
                        ))
                      : U(``, !0),
                  ]),
                ]),
                _: 1,
              },
            )
          );
        };
      },
    },
  ),
  W1 = i({
    default: () => X1,
  });
B();
var G1 = {
    class: `scroller-thin-x`,
  },
  K1 = {
    class: `flex space-x-2`,
  },
  q1 = {
    key: 0,
    class: `flex w-80 shrink-0 flex-col rounded-md bg-gray-100 p-3 dark:bg-neutral-800`,
  },
  J1 = {
    class: `mb-3 text-sm font-medium text-gray-900 dark:text-gray-300`,
  },
  Y1 = {
    class: `text-gray-600 dark:text-gray-500`,
  },
  X1 = Object.assign(
    {
      name: `KanBanView`,
    },
    {
      props: {
        addList: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(`div`, G1, [
            W(`div`, K1, [
              z(t.$slots, `default`),
              e.addList
                ? (A(),
                  M(`div`, q1, [
                    W(`h3`, J1, [W(`span`, Y1, [z(t.$slots, `addListTitle`)])]),
                    z(t.$slots, `addListForm`),
                  ]))
                : U(``, !0),
            ]),
          ])
        );
      },
    },
  ),
  Z1 = i({
    default: () => $1,
  });
B();
var Q1 = {
    class: `sm:divide-y sm:divide-gray-200 dark:sm:divide-gray-700`,
  },
  $1 = Object.assign(
    {
      name: `ListContainerVertical`,
    },
    {
      props: {},
      setup(e) {
        return (Te(), (e, t) => (A(), M(`dl`, Q1, [z(e.$slots, `default`)])));
      },
    },
  ),
  e0 = i({
    default: () => a0,
  });
B();
var t0 = {
    class: `px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4`,
  },
  n0 = {
    key: 0,
    class: `text-sm font-medium text-gray-500`,
  },
  r0 = [`innerHTML`],
  i0 = [`innerHTML`],
  a0 = Object.assign(
    {
      name: `ListItemView`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
        align: {
          type: String,
          default: `left`,
        },
        truncate: {
          type: Boolean,
          default: !0,
        },
        html: {
          type: Boolean,
          default: !1,
        },
        dynamic: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = Te(),
          n = (e) => (typeof e == `string` ? e.replace(/(\r\n|\n|\r)/gm, `<br>`) : ``);
        return (r, i) => (
          A(),
          M(`div`, t0, [
            e.label ? (A(), M(`dt`, n0, T(e.label), 1)) : U(``, !0),
            e.html
              ? (A(),
                M(
                  `dd`,
                  {
                    key: 1,
                    class: O([
                      `mt-1 text-sm text-gray-900 dark:text-gray-400 sm:col-span-2 sm:mt-0`,
                      {
                        "text-right": e.align == `right`,
                        truncate: e.truncate,
                      },
                    ]),
                  },
                  [
                    W(
                      `div`,
                      {
                        innerHTML: P(t).default?.()?.[0]?.children,
                      },
                      null,
                      8,
                      r0,
                    ),
                  ],
                  2,
                ))
              : U(``, !0),
            e.dynamic
              ? (A(),
                M(
                  `dd`,
                  {
                    key: 2,
                    class: O([
                      `mt-1 text-sm text-gray-900 dark:text-gray-400 sm:col-span-2 sm:mt-0`,
                      {
                        "text-right": e.align == `right`,
                        truncate: e.truncate,
                      },
                    ]),
                  },
                  [z(r.$slots, `default`)],
                  2,
                ))
              : (A(),
                M(
                  `dd`,
                  {
                    key: 3,
                    class: O([
                      `mt-1 text-sm text-gray-900 dark:text-gray-400 sm:col-span-2 sm:mt-0`,
                      {
                        "text-right": e.align == `right`,
                        truncate: e.truncate,
                      },
                    ]),
                  },
                  [
                    W(
                      `span`,
                      {
                        innerHTML: n(P(t).default?.()?.[0]?.children || ``),
                      },
                      null,
                      8,
                      i0,
                    ),
                  ],
                  2,
                )),
          ])
        );
      },
    },
  ),
  o0 = {};
((o0.d = (e, t) => {
  for (var n in t)
    o0.o(t, n) &&
      !o0.o(e, n) &&
      Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n],
      });
}),
  (o0.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)));
var s0 =
    typeof process == `object` &&
    process + `` == `[object process]` &&
    !process.versions.nw &&
    !(process.versions.electron && process.type && process.type !== `browser`),
  c0 = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
  l0 = new Float32Array(c0),
  u0 = [0.001, 0, 0, 0.001, 0, 0],
  d0 = 1.35,
  f0 = {
    ANY: 1,
    DISPLAY: 2,
    PRINT: 4,
    SAVE: 8,
    ANNOTATIONS_FORMS: 16,
    ANNOTATIONS_STORAGE: 32,
    ANNOTATIONS_DISABLE: 64,
    IS_EDITING: 128,
    OPLIST: 256,
  },
  p0 = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3,
  },
  m0 = `pdfjs_internal_editor_`,
  h0 = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15,
    POPUP: 16,
    SIGNATURE: 101,
    COMMENT: 102,
  },
  g0 = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    INK_COLOR_AND_OPACITY: 24,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_THICKNESS: 32,
    HIGHLIGHT_FREE: 33,
    HIGHLIGHT_SHOW_ALL: 34,
    DRAW_STEP: 41,
  },
  _0 = {
    PRINT: 4,
    MODIFY_CONTENTS: 8,
    COPY: 16,
    MODIFY_ANNOTATIONS: 32,
    FILL_INTERACTIVE_FORMS: 256,
    COPY_FOR_ACCESSIBILITY: 512,
    ASSEMBLE: 1024,
    PRINT_HIGH_QUALITY: 2048,
  },
  v0 = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4,
  },
  y0 = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3,
  },
  b0 = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26,
  },
  x0 = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5,
  },
  S0 = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5,
  },
  C0 = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91,
    setStrokeTransparent: 92,
    setFillTransparent: 93,
    rawFillPath: 94,
  },
  w0 = {
    moveTo: 0,
    lineTo: 1,
    curveTo: 2,
    quadraticCurveTo: 3,
    closePath: 4,
  },
  T0 = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2,
  },
  E0 = S0.WARNINGS;
function D0(e) {
  Number.isInteger(e) && (E0 = e);
}
function O0() {
  return E0;
}
function k0(e) {
  E0 >= S0.INFOS && console.info(`Info: ${e}`);
}
function A0(e) {
  E0 >= S0.WARNINGS && console.warn(`Warning: ${e}`);
}
function j0(e) {
  throw Error(e);
}
function M0(e, t) {
  e || j0(t);
}
function N0(e) {
  switch (e?.protocol) {
    case `http:`:
    case `https:`:
    case `ftp:`:
    case `mailto:`:
    case `tel:`:
      return !0;
    default:
      return !1;
  }
}
function P0(e, t = null, n = null) {
  if (!e) return null;
  if (
    n &&
    typeof e == `string` &&
    (n.addDefaultProtocol &&
      e.startsWith(`www.`) &&
      e.match(/\./g)?.length >= 2 &&
      (e = `http://${e}`),
    n.tryConvertEncoding)
  )
    try {
      e = X0(e);
    } catch {}
  let r = t ? URL.parse(e, t) : URL.parse(e);
  return N0(r) ? r : null;
}
function F0(e, t, n = !1) {
  let r = URL.parse(e);
  return r
    ? ((r.hash = t), r.href)
    : n && P0(e, `http://example.com`)
      ? e.split(`#`, 1)[0] + `${t ? `#${t}` : ``}`
      : ``;
}
function I0(e) {
  return e.substring(e.lastIndexOf(`/`) + 1);
}
function L0(e, t, n, r = !1) {
  return (
    Object.defineProperty(e, t, {
      value: n,
      enumerable: !r,
      configurable: !0,
      writable: !1,
    }),
    n
  );
}
var R0 = (function () {
    function e(e, t) {
      ((this.message = e), (this.name = t));
    }
    return ((e.prototype = Error()), (e.constructor = e), e);
  })(),
  z0 = class extends R0 {
    constructor(e, t) {
      (super(e, `PasswordException`), (this.code = t));
    }
  },
  B0 = class extends R0 {
    constructor(e, t) {
      (super(e, `UnknownErrorException`), (this.details = t));
    }
  },
  V0 = class extends R0 {
    constructor(e) {
      super(e, `InvalidPDFException`);
    }
  },
  H0 = class extends R0 {
    constructor(e, t, n) {
      (super(e, `ResponseException`), (this.status = t), (this.missing = n));
    }
  },
  U0 = class extends R0 {
    constructor(e) {
      super(e, `FormatError`);
    }
  },
  W0 = class extends R0 {
    constructor(e) {
      super(e, `AbortException`);
    }
  };
function G0(e) {
  (typeof e != `object` || e?.length === void 0) && j0(`Invalid argument for bytesToString`);
  let t = e.length,
    n = 8192;
  if (t < n) return String.fromCharCode.apply(null, e);
  let r = [];
  for (let i = 0; i < t; i += n) {
    let a = Math.min(i + n, t),
      o = e.subarray(i, a);
    r.push(String.fromCharCode.apply(null, o));
  }
  return r.join(``);
}
function K0(e) {
  typeof e != `string` && j0(`Invalid argument for stringToBytes`);
  let t = e.length,
    n = new Uint8Array(t);
  for (let r = 0; r < t; ++r) n[r] = e.charCodeAt(r) & 255;
  return n;
}
function q0() {
  let e = new Uint8Array(4);
  return ((e[0] = 1), new Uint32Array(e.buffer, 0, 1)[0] === 1);
}
var J0 = class {
    static get isLittleEndian() {
      return L0(this, `isLittleEndian`, q0());
    }
    static get isOffscreenCanvasSupported() {
      return L0(this, `isOffscreenCanvasSupported`, typeof OffscreenCanvas < `u`);
    }
    static get isImageDecoderSupported() {
      return L0(this, `isImageDecoderSupported`, typeof ImageDecoder < `u`);
    }
    static get isFloat16ArraySupported() {
      return L0(this, `isFloat16ArraySupported`, typeof Float16Array < `u`);
    }
    static get isSanitizerSupported() {
      return L0(this, `isSanitizerSupported`, typeof Sanitizer < `u`);
    }
    static get platform() {
      let { platform: e, userAgent: t } = navigator;
      return L0(this, `platform`, {
        isAndroid: t.includes(`Android`),
        isLinux: e.includes(`Linux`),
        isMac: e.includes(`Mac`),
        isWindows: e.includes(`Win`),
        isFirefox: t.includes(`Firefox`),
      });
    }
    static get isCSSRoundSupported() {
      return L0(
        this,
        `isCSSRoundSupported`,
        globalThis.CSS?.supports?.(`width: round(1.5px, 1px)`),
      );
    }
    static get isAlphaColorInputSupported() {
      return L0(
        this,
        `isAlphaColorInputSupported`,
        (() => {
          if (typeof document > `u`) return !1;
          let e = document.createElement(`input`);
          return (
            (e.type = `color`),
            e.setAttribute(`alpha`, ``),
            (e.value = `#ff000080`),
            e.value !== `#ff0000`
          );
        })(),
      );
    }
  },
  Y0 = class {
    static get hexNums() {
      return L0(
        this,
        `hexNums`,
        Array.from(Array(256).keys(), (e) => e.toString(16).padStart(2, `0`)),
      );
    }
    static makeHexColor(e, t, n) {
      return `#${this.hexNums[e]}${this.hexNums[t]}${this.hexNums[n]}`;
    }
    static domMatrixToTransform(e) {
      return [e.a, e.b, e.c, e.d, e.e, e.f];
    }
    static scaleMinMax(e, t) {
      let n;
      (e[0]
        ? (e[0] < 0 && ((n = t[0]), (t[0] = t[2]), (t[2] = n)),
          (t[0] *= e[0]),
          (t[2] *= e[0]),
          e[3] < 0 && ((n = t[1]), (t[1] = t[3]), (t[3] = n)),
          (t[1] *= e[3]),
          (t[3] *= e[3]))
        : ((n = t[0]),
          (t[0] = t[1]),
          (t[1] = n),
          (n = t[2]),
          (t[2] = t[3]),
          (t[3] = n),
          e[1] < 0 && ((n = t[1]), (t[1] = t[3]), (t[3] = n)),
          (t[1] *= e[1]),
          (t[3] *= e[1]),
          e[2] < 0 && ((n = t[0]), (t[0] = t[2]), (t[2] = n)),
          (t[0] *= e[2]),
          (t[2] *= e[2])),
        (t[0] += e[4]),
        (t[1] += e[5]),
        (t[2] += e[4]),
        (t[3] += e[5]));
    }
    static transform(e, t) {
      return [
        e[0] * t[0] + e[2] * t[1],
        e[1] * t[0] + e[3] * t[1],
        e[0] * t[2] + e[2] * t[3],
        e[1] * t[2] + e[3] * t[3],
        e[0] * t[4] + e[2] * t[5] + e[4],
        e[1] * t[4] + e[3] * t[5] + e[5],
      ];
    }
    static multiplyByDOMMatrix(e, t) {
      return [
        e[0] * t.a + e[2] * t.b,
        e[1] * t.a + e[3] * t.b,
        e[0] * t.c + e[2] * t.d,
        e[1] * t.c + e[3] * t.d,
        e[0] * t.e + e[2] * t.f + e[4],
        e[1] * t.e + e[3] * t.f + e[5],
      ];
    }
    static applyTransform(e, t, n = 0) {
      let r = e[n],
        i = e[n + 1];
      ((e[n] = r * t[0] + i * t[2] + t[4]), (e[n + 1] = r * t[1] + i * t[3] + t[5]));
    }
    static applyTransformToBezier(e, t, n = 0) {
      let r = t[0],
        i = t[1],
        a = t[2],
        o = t[3],
        s = t[4],
        c = t[5];
      for (let t = 0; t < 6; t += 2) {
        let l = e[n + t],
          u = e[n + t + 1];
        ((e[n + t] = l * r + u * a + s), (e[n + t + 1] = l * i + u * o + c));
      }
    }
    static applyInverseTransform(e, t) {
      let n = e[0],
        r = e[1],
        i = t[0] * t[3] - t[1] * t[2];
      ((e[0] = (n * t[3] - r * t[2] + t[2] * t[5] - t[4] * t[3]) / i),
        (e[1] = (-n * t[1] + r * t[0] + t[4] * t[1] - t[5] * t[0]) / i));
    }
    static axialAlignedBoundingBox(e, t, n) {
      let r = t[0],
        i = t[1],
        a = t[2],
        o = t[3],
        s = t[4],
        c = t[5],
        l = e[0],
        u = e[1],
        d = e[2],
        f = e[3],
        p = r * l + s,
        m = p,
        h = r * d + s,
        g = h,
        v = o * u + c,
        y = v,
        b = o * f + c,
        x = b;
      if (i !== 0 || a !== 0) {
        let e = i * l,
          t = i * d,
          n = a * u,
          r = a * f;
        ((p += n), (g += n), (h += r), (m += r), (v += e), (x += e), (b += t), (y += t));
      }
      ((n[0] = Math.min(n[0], p, h, m, g)),
        (n[1] = Math.min(n[1], v, b, y, x)),
        (n[2] = Math.max(n[2], p, h, m, g)),
        (n[3] = Math.max(n[3], v, b, y, x)));
    }
    static inverseTransform(e) {
      let t = e[0] * e[3] - e[1] * e[2];
      return [
        e[3] / t,
        -e[1] / t,
        -e[2] / t,
        e[0] / t,
        (e[2] * e[5] - e[4] * e[3]) / t,
        (e[4] * e[1] - e[5] * e[0]) / t,
      ];
    }
    static singularValueDecompose2dScale(e, t) {
      let n = e[0],
        r = e[1],
        i = e[2],
        a = e[3],
        o = n ** 2 + r ** 2,
        s = n * i + r * a,
        c = i ** 2 + a ** 2,
        l = (o + c) / 2,
        u = Math.sqrt(l ** 2 - (o * c - s ** 2));
      ((t[0] = Math.sqrt(l + u || 1)), (t[1] = Math.sqrt(l - u || 1)));
    }
    static normalizeRect(e) {
      let t = e.slice(0);
      return (
        e[0] > e[2] && ((t[0] = e[2]), (t[2] = e[0])),
        e[1] > e[3] && ((t[1] = e[3]), (t[3] = e[1])),
        t
      );
    }
    static intersect(e, t) {
      let n = Math.max(Math.min(e[0], e[2]), Math.min(t[0], t[2])),
        r = Math.min(Math.max(e[0], e[2]), Math.max(t[0], t[2]));
      if (n > r) return null;
      let i = Math.max(Math.min(e[1], e[3]), Math.min(t[1], t[3])),
        a = Math.min(Math.max(e[1], e[3]), Math.max(t[1], t[3]));
      return i > a ? null : [n, i, r, a];
    }
    static pointBoundingBox(e, t, n) {
      ((n[0] = Math.min(n[0], e)),
        (n[1] = Math.min(n[1], t)),
        (n[2] = Math.max(n[2], e)),
        (n[3] = Math.max(n[3], t)));
    }
    static rectBoundingBox(e, t, n, r, i) {
      ((i[0] = Math.min(i[0], e, n)),
        (i[1] = Math.min(i[1], t, r)),
        (i[2] = Math.max(i[2], e, n)),
        (i[3] = Math.max(i[3], t, r)));
    }
    static #e(e, t, n, r, i, a, o, s, c, l) {
      if (c <= 0 || c >= 1) return;
      let u = 1 - c,
        d = c * c,
        f = d * c,
        p = u * (u * (u * e + 3 * c * t) + 3 * d * n) + f * r,
        m = u * (u * (u * i + 3 * c * a) + 3 * d * o) + f * s;
      ((l[0] = Math.min(l[0], p)),
        (l[1] = Math.min(l[1], m)),
        (l[2] = Math.max(l[2], p)),
        (l[3] = Math.max(l[3], m)));
    }
    static #t(e, t, n, r, i, a, o, s, c, l, u, d) {
      if (Math.abs(c) < 1e-12) {
        Math.abs(l) >= 1e-12 && this.#e(e, t, n, r, i, a, o, s, -u / l, d);
        return;
      }
      let f = l ** 2 - 4 * u * c;
      if (f < 0) return;
      let p = Math.sqrt(f),
        m = 2 * c;
      (this.#e(e, t, n, r, i, a, o, s, (-l + p) / m, d),
        this.#e(e, t, n, r, i, a, o, s, (-l - p) / m, d));
    }
    static bezierBoundingBox(e, t, n, r, i, a, o, s, c) {
      ((c[0] = Math.min(c[0], e, o)),
        (c[1] = Math.min(c[1], t, s)),
        (c[2] = Math.max(c[2], e, o)),
        (c[3] = Math.max(c[3], t, s)),
        this.#t(
          e,
          n,
          i,
          o,
          t,
          r,
          a,
          s,
          3 * (-e + 3 * (n - i) + o),
          6 * (e - 2 * n + i),
          3 * (n - e),
          c,
        ),
        this.#t(
          e,
          n,
          i,
          o,
          t,
          r,
          a,
          s,
          3 * (-t + 3 * (r - a) + s),
          6 * (t - 2 * r + a),
          3 * (r - t),
          c,
        ));
    }
  };
function X0(e) {
  return decodeURIComponent(escape(e));
}
var Z0 = null,
  Q0 = null;
function $0(e) {
  return (
    Z0 ||
      ((Z0 =
        /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu),
      (Q0 = new Map([[`ﬅ`, `ſt`]]))),
    e.replaceAll(Z0, (e, t, n) => (t ? t.normalize(`NFKC`) : Q0.get(n)))
  );
}
function e2() {
  if (typeof crypto.randomUUID == `function`) return crypto.randomUUID();
  let e = new Uint8Array(32);
  return (crypto.getRandomValues(e), G0(e));
}
var t2 = `pdfjs_internal_id_`;
function n2(e, t, n) {
  if (!Array.isArray(n) || n.length < 2) return !1;
  let [r, i, ...a] = n;
  if ((!e(r) && !Number.isInteger(r)) || !t(i)) return !1;
  let o = a.length,
    s = !0;
  switch (i.name) {
    case `XYZ`:
      if (o < 2 || o > 3) return !1;
      break;
    case `Fit`:
    case `FitB`:
      return o === 0;
    case `FitH`:
    case `FitBH`:
    case `FitV`:
    case `FitBV`:
      if (o > 1) return !1;
      break;
    case `FitR`:
      if (o !== 4) return !1;
      s = !1;
      break;
    default:
      return !1;
  }
  for (let e of a) if (!(typeof e == `number` || (s && e === null))) return !1;
  return !0;
}
var r2 = () => [],
  i2 = () => new Map(),
  a2 = () => Object.create(null);
function o2(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
var s2 = class e {
    static textContent(t) {
      let n = [],
        r = {
          items: n,
          styles: Object.create(null),
        };
      function i(t) {
        if (!t) return;
        let r = null,
          a = t.name;
        if (a === `#text`) r = t.value;
        else if (e.shouldBuildText(a))
          t?.attributes?.textContent ? (r = t.attributes.textContent) : t.value && (r = t.value);
        else return;
        if (
          (r !== null &&
            n.push({
              str: r,
            }),
          t.children)
        )
          for (let e of t.children) i(e);
      }
      return (i(t), r);
    }
    static shouldBuildText(e) {
      return !(e === `textarea` || e === `input` || e === `option` || e === `select`);
    }
  },
  c2 = class {
    static setupStorage(e, t, n, r, i) {
      let a = r.getValue(t, {
        value: null,
      });
      switch (n.name) {
        case `textarea`:
          if ((a.value !== null && (e.textContent = a.value), i === `print`)) break;
          e.addEventListener(`input`, (e) => {
            r.setValue(t, {
              value: e.target.value,
            });
          });
          break;
        case `input`:
          if (n.attributes.type === `radio` || n.attributes.type === `checkbox`) {
            if (
              (a.value === n.attributes.xfaOn
                ? e.setAttribute(`checked`, !0)
                : a.value === n.attributes.xfaOff && e.removeAttribute(`checked`),
              i === `print`)
            )
              break;
            e.addEventListener(`change`, (e) => {
              r.setValue(t, {
                value: e.target.checked
                  ? e.target.getAttribute(`xfaOn`)
                  : e.target.getAttribute(`xfaOff`),
              });
            });
          } else {
            if ((a.value !== null && e.setAttribute(`value`, a.value), i === `print`)) break;
            e.addEventListener(`input`, (e) => {
              r.setValue(t, {
                value: e.target.value,
              });
            });
          }
          break;
        case `select`:
          if (a.value !== null) {
            e.setAttribute(`value`, a.value);
            for (let e of n.children)
              e.attributes.value === a.value
                ? (e.attributes.selected = !0)
                : Object.hasOwn(e.attributes, `selected`) && delete e.attributes.selected;
          }
          e.addEventListener(`input`, (e) => {
            let n = e.target.options,
              i = n.selectedIndex === -1 ? `` : n[n.selectedIndex].value;
            r.setValue(t, {
              value: i,
            });
          });
          break;
      }
    }
    static setAttributes({ html: e, element: t, storage: n = null, intent: r, linkService: i }) {
      let { attributes: a } = t,
        o = e instanceof HTMLAnchorElement;
      a.type === `radio` && (a.name = `${a.name}-${r}`);
      for (let [t, n] of Object.entries(a))
        if (n != null)
          switch (t) {
            case `class`:
              n.length && e.setAttribute(t, n.join(` `));
              break;
            case `dataId`:
              break;
            case `id`:
              e.setAttribute(`data-element-id`, n);
              break;
            case `style`:
              Object.assign(e.style, n);
              break;
            case `textContent`:
              e.textContent = n;
              break;
            default:
              (!o || (t !== `href` && t !== `newWindow`)) && e.setAttribute(t, n);
          }
      (o && i.addLinkAttributes(e, a.href, a.newWindow),
        n && a.dataId && this.setupStorage(e, a.dataId, t, n));
    }
    static render(e) {
      let t = e.annotationStorage,
        n = e.linkService,
        r = e.xfaHtml,
        i = e.intent || `display`,
        a = document.createElement(r.name);
      r.attributes &&
        this.setAttributes({
          html: a,
          element: r,
          intent: i,
          linkService: n,
        });
      let o = i !== `richText`,
        s = e.div;
      if ((s.append(a), e.viewport)) {
        let t = `matrix(${e.viewport.transform.join(`,`)})`;
        s.style.transform = t;
      }
      o && s.setAttribute(`class`, `xfaLayer xfaFont`);
      let c = [];
      if (r.children.length === 0) {
        if (r.value) {
          let e = document.createTextNode(r.value);
          (a.append(e), o && s2.shouldBuildText(r.name) && c.push(e));
        }
        return {
          textDivs: c,
        };
      }
      let l = [[r, -1, a]];
      for (; l.length > 0;) {
        let [e, r, a] = l.at(-1);
        if (r + 1 === e.children.length) {
          l.pop();
          continue;
        }
        let s = e.children[++l.at(-1)[1]];
        if (s === null) continue;
        let { name: u } = s;
        if (u === `#text`) {
          let e = document.createTextNode(s.value);
          (c.push(e), a.append(e));
          continue;
        }
        let d = s?.attributes?.xmlns
          ? document.createElementNS(s.attributes.xmlns, u)
          : document.createElement(u);
        if (
          (a.append(d),
          s.attributes &&
            this.setAttributes({
              html: d,
              element: s,
              storage: t,
              intent: i,
              linkService: n,
            }),
          s.children?.length > 0)
        )
          l.push([s, -1, d]);
        else if (s.value) {
          let e = document.createTextNode(s.value);
          (o && s2.shouldBuildText(u) && c.push(e), d.append(e));
        }
      }
      for (let e of s.querySelectorAll(`.xfaNonInteractive input, .xfaNonInteractive textarea`))
        e.setAttribute(`readOnly`, !0);
      return {
        textDivs: c,
      };
    }
    static update(e) {
      let t = `matrix(${e.viewport.transform.join(`,`)})`;
      ((e.div.style.transform = t), (e.div.hidden = !1));
    }
  },
  l2 = `http://www.w3.org/2000/svg`,
  u2 = class {
    static CSS = 96;
    static PDF = 72;
    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
  };
async function d2(e, t = `text`) {
  if (y2(e, document.baseURI)) {
    let n = await fetch(e);
    if (!n.ok) throw Error(n.statusText);
    switch (t) {
      case `blob`:
        return n.blob();
      case `bytes`:
        return n.bytes();
      case `json`:
        return n.json();
    }
    return n.text();
  }
  return new Promise((n, r) => {
    let i = new XMLHttpRequest();
    (i.open(`GET`, e, !0),
      (i.responseType = t === `bytes` ? `arraybuffer` : t),
      (i.onreadystatechange = () => {
        if (i.readyState === XMLHttpRequest.DONE) {
          if (i.status === 200 || i.status === 0) {
            switch (t) {
              case `bytes`:
                n(new Uint8Array(i.response));
                return;
              case `blob`:
              case `json`:
                n(i.response);
                return;
            }
            n(i.responseText);
            return;
          }
          r(Error(i.statusText));
        }
      }),
      i.send(null));
  });
}
var f2 = class e {
    constructor({
      viewBox: e,
      userUnit: t,
      scale: n,
      rotation: r,
      offsetX: i = 0,
      offsetY: a = 0,
      dontFlip: o = !1,
    }) {
      ((this.viewBox = e),
        (this.userUnit = t),
        (this.scale = n),
        (this.rotation = r),
        (this.offsetX = i),
        (this.offsetY = a),
        (n *= t));
      let s = (e[2] + e[0]) / 2,
        c = (e[3] + e[1]) / 2,
        l,
        u,
        d,
        f;
      switch (((r %= 360), r < 0 && (r += 360), r)) {
        case 180:
          ((l = -1), (u = 0), (d = 0), (f = 1));
          break;
        case 90:
          ((l = 0), (u = 1), (d = 1), (f = 0));
          break;
        case 270:
          ((l = 0), (u = -1), (d = -1), (f = 0));
          break;
        case 0:
          ((l = 1), (u = 0), (d = 0), (f = -1));
          break;
        default:
          throw Error(`PageViewport: Invalid rotation, must be a multiple of 90 degrees.`);
      }
      o && ((d = -d), (f = -f));
      let p, m, h, g;
      (l === 0
        ? ((p = Math.abs(c - e[1]) * n + i),
          (m = Math.abs(s - e[0]) * n + a),
          (h = (e[3] - e[1]) * n),
          (g = (e[2] - e[0]) * n))
        : ((p = Math.abs(s - e[0]) * n + i),
          (m = Math.abs(c - e[1]) * n + a),
          (h = (e[2] - e[0]) * n),
          (g = (e[3] - e[1]) * n)),
        (this.transform = [
          l * n,
          u * n,
          d * n,
          f * n,
          p - l * n * s - d * n * c,
          m - u * n * s - f * n * c,
        ]),
        (this.width = h),
        (this.height = g));
    }
    get rawDims() {
      let e = this.viewBox;
      return L0(this, `rawDims`, {
        pageWidth: e[2] - e[0],
        pageHeight: e[3] - e[1],
        pageX: e[0],
        pageY: e[1],
      });
    }
    clone({
      scale: t = this.scale,
      rotation: n = this.rotation,
      offsetX: r = this.offsetX,
      offsetY: i = this.offsetY,
      dontFlip: a = !1,
    } = {}) {
      return new e({
        viewBox: this.viewBox.slice(),
        userUnit: this.userUnit,
        scale: t,
        rotation: n,
        offsetX: r,
        offsetY: i,
        dontFlip: a,
      });
    }
    convertToViewportPoint(e, t) {
      let n = [e, t];
      return (Y0.applyTransform(n, this.transform), n);
    }
    convertToViewportRectangle(e) {
      let t = [e[0], e[1]];
      Y0.applyTransform(t, this.transform);
      let n = [e[2], e[3]];
      return (Y0.applyTransform(n, this.transform), [t[0], t[1], n[0], n[1]]);
    }
    convertToPdfPoint(e, t) {
      let n = [e, t];
      return (Y0.applyInverseTransform(n, this.transform), n);
    }
  },
  p2 = class extends R0 {
    constructor(e, t = 0) {
      (super(e, `RenderingCancelledException`), (this.extraDelay = t));
    }
  };
function m2(e) {
  let t = e.length,
    n = 0;
  for (; n < t && e[n].trim() === ``;) n++;
  return e.substring(n, n + 5).toLowerCase() === `data:`;
}
function h2(e) {
  return typeof e == `string` && /\.pdf$/i.test(e);
}
function g2(e) {
  return (([e] = e.split(/[#?]/, 1)), I0(e));
}
function _2(e, t = `document.pdf`) {
  if (typeof e != `string`) return t;
  if (m2(e)) return (A0(`getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.`), t);
  let n = ((e) => {
    try {
      return new URL(e);
    } catch {
      try {
        return new URL(decodeURIComponent(e));
      } catch {
        try {
          return new URL(e, `https://foo.bar`);
        } catch {
          try {
            return new URL(decodeURIComponent(e), `https://foo.bar`);
          } catch {
            return null;
          }
        }
      }
    }
  })(e);
  if (!n) return t;
  let r = (e) => {
      try {
        let t = decodeURIComponent(e);
        return t.includes(`/`) && ((t = I0(t)), /^\.pdf$/i.test(t)) ? e : t;
      } catch {
        return e;
      }
    },
    i = /\.pdf$/i,
    a = I0(n.pathname);
  if (i.test(a)) return r(a);
  if (n.searchParams.size > 0) {
    let e = (e) => [...e].findLast((e) => i.test(e)),
      t = e(n.searchParams.values()) ?? e(n.searchParams.keys());
    if (t) return r(t);
  }
  if (n.hash) {
    let e = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i.exec(n.hash);
    if (e) return r(e[0]);
  }
  return t;
}
var v2 = class {
  #e = new Map();
  times = [];
  time(e) {
    (this.#e.has(e) && A0(`Timer is already running for ${e}`), this.#e.set(e, Date.now()));
  }
  timeEnd(e) {
    (this.#e.has(e) || A0(`Timer has not been started for ${e}`),
      this.times.push({
        name: e,
        start: this.#e.get(e),
        end: Date.now(),
      }),
      this.#e.delete(e));
  }
  toString() {
    let e = Math.max(...this.times.map((e) => e.name.length));
    return this.times.map((t) => `${t.name.padEnd(e)} ${t.end - t.start}ms\n`).join(``);
  }
};
function y2(e, t) {
  let n = t ? URL.parse(e, t) : URL.parse(e);
  return /https?:/.test(n?.protocol ?? ``);
}
function b2(e) {
  e.preventDefault();
}
function x2(e) {
  (e.preventDefault(), e.stopPropagation());
}
function S2(e) {
  console.log(`Deprecated API usage: ` + e);
}
var C2 = class {
  static #e;
  static toDateObject(e) {
    if (e instanceof Date) return e;
    if (!e || typeof e != `string`) return null;
    this.#e ||= RegExp(
      `^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?`,
    );
    let t = this.#e.exec(e);
    if (!t) return null;
    let n = parseInt(t[1], 10),
      r = parseInt(t[2], 10);
    r = r >= 1 && r <= 12 ? r - 1 : 0;
    let i = parseInt(t[3], 10);
    i = i >= 1 && i <= 31 ? i : 1;
    let a = parseInt(t[4], 10);
    a = a >= 0 && a <= 23 ? a : 0;
    let o = parseInt(t[5], 10);
    o = o >= 0 && o <= 59 ? o : 0;
    let s = parseInt(t[6], 10);
    s = s >= 0 && s <= 59 ? s : 0;
    let c = t[7] || `Z`,
      l = parseInt(t[8], 10);
    l = l >= 0 && l <= 23 ? l : 0;
    let u = parseInt(t[9], 10) || 0;
    return (
      (u = u >= 0 && u <= 59 ? u : 0),
      c === `-` ? ((a += l), (o += u)) : c === `+` && ((a -= l), (o -= u)),
      new Date(Date.UTC(n, r, i, a, o, s))
    );
  }
};
function w2(e, { scale: t = 1, rotation: n = 0 }) {
  let { width: r, height: i } = e.attributes.style;
  return new f2({
    viewBox: [0, 0, parseInt(r, 10), parseInt(i, 10)],
    userUnit: 1,
    scale: t,
    rotation: n,
  });
}
function T2(e) {
  if (e.startsWith(`#`)) {
    let t = e.slice(1);
    return [
      parseInt(t.slice(0, 2), 16),
      parseInt(t.slice(2, 4), 16),
      parseInt(t.slice(4, 6), 16),
      t.length >= 8 ? parseInt(t.slice(6, 8), 16) / 255 : 1,
    ];
  }
  if (e.startsWith(`rgb(`)) {
    let [t, n, r] = e
      .slice(4, -1)
      .split(`,`)
      .map((e) => parseInt(e, 10));
    return [t, n, r, 1];
  }
  if (e.startsWith(`rgba(`)) {
    let t = e.slice(5, -1).split(`,`);
    return [parseInt(t[0], 10), parseInt(t[1], 10), parseInt(t[2], 10), parseFloat(t[3])];
  }
  let t = e.match(/^color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)(?:\s*\/\s*([\d.]+|none))?\)$/);
  return t
    ? [
        Math.round(parseFloat(t[1]) * 255),
        Math.round(parseFloat(t[2]) * 255),
        Math.round(parseFloat(t[3]) * 255),
        t[4] !== void 0 && t[4] !== `none` ? parseFloat(t[4]) : 1,
      ]
    : null;
}
function E2(e) {
  let t = T2(e);
  return t ? t.slice(0, 3) : (A0(`Not a valid color format: "${e}"`), [0, 0, 0]);
}
function D2(e) {
  let t = document.createElement(`span`);
  ((t.style.visibility = `hidden`), (t.style.colorScheme = `only light`), document.body.append(t));
  for (let n of e.keys()) {
    t.style.color = n;
    let r = window.getComputedStyle(t).color;
    e.set(n, E2(r));
  }
  t.remove();
}
function O2(e) {
  let { a: t, b: n, c: r, d: i, e: a, f: o } = e.getTransform();
  return [t, n, r, i, a, o];
}
function k2(e) {
  let { a: t, b: n, c: r, d: i, e: a, f: o } = e.getTransform().invertSelf();
  return [t, n, r, i, a, o];
}
function A2(e, t, n = !1, r = !0) {
  if (t instanceof f2) {
    let { pageWidth: r, pageHeight: i } = t.rawDims,
      { style: a } = e,
      o = J0.isCSSRoundSupported,
      s = `var(--total-scale-factor) * ${r}px`,
      c = `var(--total-scale-factor) * ${i}px`,
      l = o ? `round(down, ${s}, var(--scale-round-x))` : `calc(${s})`,
      u = o ? `round(down, ${c}, var(--scale-round-y))` : `calc(${c})`;
    !n || t.rotation % 180 == 0 ? ((a.width = l), (a.height = u)) : ((a.width = u), (a.height = l));
  }
  r && e.setAttribute(`data-main-rotation`, t.rotation);
}
var j2 = class e {
    constructor() {
      let { pixelRatio: t } = e;
      ((this.sx = t), (this.sy = t));
    }
    get scaled() {
      return this.sx !== 1 || this.sy !== 1;
    }
    get symmetric() {
      return this.sx === this.sy;
    }
    limitCanvas(t, n, r, i, a = -1) {
      let o = 1 / 0,
        s = 1 / 0,
        c = 1 / 0;
      ((r = e.capPixels(r, a)),
        r > 0 && (o = Math.sqrt(r / (t * n))),
        i !== -1 && ((s = i / t), (c = i / n)));
      let l = Math.min(o, s, c);
      return this.sx > l || this.sy > l ? ((this.sx = l), (this.sy = l), !0) : !1;
    }
    static get pixelRatio() {
      return globalThis.devicePixelRatio || 1;
    }
    static capPixels(e, t) {
      if (t >= 0) {
        let n = Math.ceil(
          window.screen.availWidth *
            window.screen.availHeight *
            this.pixelRatio ** 2 *
            (1 + t / 100),
        );
        return e > 0 ? Math.min(e, n) : n;
      }
      return e;
    }
  },
  M2 = [
    `image/apng`,
    `image/avif`,
    `image/bmp`,
    `image/gif`,
    `image/jpeg`,
    `image/png`,
    `image/svg+xml`,
    `image/webp`,
    `image/x-icon`,
  ],
  N2 = class {
    static get isDarkMode() {
      return L0(this, `isDarkMode`, !!window?.matchMedia?.(`(prefers-color-scheme: dark)`).matches);
    }
  },
  P2 = class {
    static get commentForegroundColor() {
      let e = document.createElement(`span`);
      e.classList.add(`comment`, `sidebar`);
      let { style: t } = e;
      ((t.width = t.height = `0`),
        (t.display = `none`),
        (t.color = `var(--comment-fg-color)`),
        document.body.append(e));
      let { color: n } = window.getComputedStyle(e);
      return (e.remove(), L0(this, `commentForegroundColor`, E2(n)));
    }
  };
function F2(e, t) {
  t = o2(t ?? 1, 0, 1);
  let n = 255 * (1 - t);
  return e.map((e) => Math.round(e * t + n));
}
function I2(e, t) {
  let n = e[0] / 255,
    r = e[1] / 255,
    i = e[2] / 255,
    a = Math.max(n, r, i),
    o = Math.min(n, r, i),
    s = (a + o) / 2;
  if (a === o) t[0] = t[1] = 0;
  else {
    let e = a - o;
    switch (((t[1] = s < 0.5 ? e / (a + o) : e / (2 - a - o)), a)) {
      case n:
        t[0] = ((r - i) / e + (r < i ? 6 : 0)) * 60;
        break;
      case r:
        t[0] = ((i - n) / e + 2) * 60;
        break;
      case i:
        t[0] = ((n - r) / e + 4) * 60;
        break;
    }
  }
  t[2] = s;
}
function L2(e, t) {
  let n = e[0],
    r = e[1],
    i = e[2],
    a = (1 - Math.abs(2 * i - 1)) * r,
    o = a * (1 - Math.abs(((n / 60) % 2) - 1)),
    s = i - a / 2;
  switch (Math.floor(n / 60)) {
    case 0:
      ((t[0] = a + s), (t[1] = o + s), (t[2] = s));
      break;
    case 1:
      ((t[0] = o + s), (t[1] = a + s), (t[2] = s));
      break;
    case 2:
      ((t[0] = s), (t[1] = a + s), (t[2] = o + s));
      break;
    case 3:
      ((t[0] = s), (t[1] = o + s), (t[2] = a + s));
      break;
    case 4:
      ((t[0] = o + s), (t[1] = s), (t[2] = a + s));
      break;
    case 5:
    case 6:
      ((t[0] = a + s), (t[1] = s), (t[2] = o + s));
      break;
  }
}
function R2(e) {
  return e <= 0.03928 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
}
function z2(e, t, n) {
  (L2(e, n), n.map(R2));
  let r = 0.2126 * n[0] + 0.7152 * n[1] + 0.0722 * n[2];
  (L2(t, n), n.map(R2));
  let i = 0.2126 * n[0] + 0.7152 * n[1] + 0.0722 * n[2];
  return r > i ? (r + 0.05) / (i + 0.05) : (i + 0.05) / (r + 0.05);
}
var B2 = new Map();
function V2(e, t) {
  let n =
      e[0] + e[1] * 256 + e[2] * 65536 + t[0] * 16777216 + t[1] * 4294967296 + t[2] * 1099511627776,
    r = B2.get(n);
  if (r) return r;
  let i = new Float32Array(9),
    a = i.subarray(0, 3),
    o = i.subarray(3, 6);
  I2(e, o);
  let s = i.subarray(6, 9);
  I2(t, s);
  let c = s[2] < 0.5,
    l = c ? 12 : 4.5;
  if (((o[2] = c ? Math.sqrt(o[2]) : 1 - Math.sqrt(1 - o[2])), z2(o, s, a) < l)) {
    let e, t;
    for (c ? ((e = o[2]), (t = 1)) : ((e = 0), (t = o[2])); t - e > 0.005;) {
      let n = (o[2] = (e + t) / 2);
      c === z2(o, s, a) < l ? (e = n) : (t = n);
    }
    o[2] = c ? t : e;
  }
  return (
    L2(o, a),
    (r = Y0.makeHexColor(Math.round(a[0] * 255), Math.round(a[1] * 255), Math.round(a[2] * 255))),
    B2.set(n, r),
    r
  );
}
function H2({ html: e, dir: t, className: n }, r) {
  let i = document.createDocumentFragment();
  if (typeof e == `string`) {
    let n = document.createElement(`p`);
    n.dir = t || `auto`;
    let r = e.split(/(?:\r\n?|\n)/);
    for (let e = 0, t = r.length; e < t; ++e) {
      let i = r[e];
      (n.append(document.createTextNode(i)), e < t - 1 && n.append(document.createElement(`br`)));
    }
    i.append(n);
  } else
    c2.render({
      xfaHtml: e,
      div: i,
      intent: `richText`,
    });
  (i.firstElementChild.classList.add(`richText`, n), r.append(i));
}
function U2(e) {
  let t = new Path2D();
  if (!e) return t;
  for (let n = 0, r = e.length; n < r;)
    switch (e[n++]) {
      case w0.moveTo:
        t.moveTo(e[n++], e[n++]);
        break;
      case w0.lineTo:
        t.lineTo(e[n++], e[n++]);
        break;
      case w0.curveTo:
        t.bezierCurveTo(e[n++], e[n++], e[n++], e[n++], e[n++], e[n++]);
        break;
      case w0.quadraticCurveTo:
        t.quadraticCurveTo(e[n++], e[n++], e[n++], e[n++]);
        break;
      case w0.closePath:
        t.closePath();
        break;
      default:
        A0(`Unrecognized drawing path operator: ${e[n - 1]}`);
        break;
    }
  return t;
}
var W2 = class e {
    #e = null;
    #t = null;
    #n;
    #r = null;
    #i = null;
    #a = null;
    #o = null;
    #s = null;
    static #c = null;
    constructor(t) {
      ((this.#n = t),
        (e.#c ||= Object.freeze({
          freetext: `pdfjs-editor-remove-freetext-button`,
          highlight: `pdfjs-editor-remove-highlight-button`,
          ink: `pdfjs-editor-remove-ink-button`,
          stamp: `pdfjs-editor-remove-stamp-button`,
          signature: `pdfjs-editor-remove-signature-button`,
        })));
    }
    render() {
      let t = (this.#e = document.createElement(`div`));
      (t.classList.add(`editToolbar`, `hidden`), t.setAttribute(`role`, `toolbar`));
      let n = this.#n._uiManager._signal;
      n instanceof AbortSignal &&
        !n.aborted &&
        (t.addEventListener(`contextmenu`, b2, {
          signal: n,
        }),
        t.addEventListener(`pointerdown`, e.#l, {
          signal: n,
        }));
      let r = (this.#r = document.createElement(`div`));
      ((r.className = `buttons`), t.append(r));
      let i = this.#n.toolbarPosition;
      if (i) {
        let { style: e } = t;
        ((e.insetInlineEnd = `${100 * (this.#n._uiManager.direction === `ltr` ? 1 - i[0] : i[0])}%`),
          (e.top = `calc(${100 * i[1]}% + var(--editor-toolbar-vert-offset))`));
      }
      return t;
    }
    get div() {
      return this.#e;
    }
    static #l(e) {
      e.stopPropagation();
    }
    #u(e) {
      ((this.#n._focusEventsAllowed = !1), x2(e));
    }
    #d(e) {
      ((this.#n._focusEventsAllowed = !0), x2(e));
    }
    #f(e) {
      let t = this.#n._uiManager._signal;
      return !(t instanceof AbortSignal) || t.aborted
        ? !1
        : (e.addEventListener(`focusin`, this.#u.bind(this), {
            capture: !0,
            signal: t,
          }),
          e.addEventListener(`focusout`, this.#d.bind(this), {
            capture: !0,
            signal: t,
          }),
          e.addEventListener(`contextmenu`, b2, {
            signal: t,
          }),
          !0);
    }
    hide() {
      (this.#e.classList.add(`hidden`), this.#t?.hideDropdown());
    }
    show() {
      (this.#e.classList.remove(`hidden`), this.#i?.shown(), this.#a?.shown());
    }
    addDeleteButton() {
      let { editorType: t, _uiManager: n } = this.#n,
        r = document.createElement(`button`);
      (r.classList.add(`basic`, `deleteButton`),
        (r.tabIndex = 0),
        r.setAttribute(`data-l10n-id`, e.#c[t]),
        this.#f(r) &&
          r.addEventListener(
            `click`,
            (e) => {
              n.delete();
            },
            {
              signal: n._signal,
            },
          ),
        this.#r.append(r));
    }
    get #p() {
      let e = document.createElement(`div`);
      return ((e.className = `divider`), e);
    }
    async addAltText(e) {
      let t = await e.render();
      (this.#f(t), this.#r.append(t, this.#p), (this.#i = e));
    }
    addComment(e, t = null) {
      if (this.#a) return;
      let n = e.renderForToolbar();
      if (!n) return;
      this.#f(n);
      let r = (this.#o = this.#p);
      (t ? (this.#r.insertBefore(n, t), this.#r.insertBefore(r, t)) : this.#r.append(n, r),
        (this.#a = e),
        (e.toolbar = this));
    }
    addColorPicker(e) {
      if (this.#t) return;
      this.#t = e;
      let t = e.renderButton();
      (this.#f(t), this.#r.append(t, this.#p));
    }
    async addEditSignatureButton(e) {
      let t = (this.#s = await e.renderEditButton(this.#n));
      (this.#f(t), this.#r.append(t, this.#p));
    }
    removeButton(e) {
      switch (e) {
        case `comment`:
          (this.#a?.removeToolbarCommentButton(),
            (this.#a = null),
            this.#o?.remove(),
            (this.#o = null));
          break;
      }
    }
    async addButton(e, t) {
      switch (e) {
        case `colorPicker`:
          t && this.addColorPicker(t);
          break;
        case `altText`:
          t && (await this.addAltText(t));
          break;
        case `editSignature`:
          t && (await this.addEditSignatureButton(t));
          break;
        case `delete`:
          this.addDeleteButton();
          break;
        case `comment`:
          t && this.addComment(t);
          break;
      }
    }
    async addButtonBefore(e, t, n) {
      if (!t && e === `comment`) return;
      let r = this.#r.querySelector(n);
      r && e === `comment` && this.addComment(t, r);
    }
    updateEditSignatureButton(e) {
      this.#s && (this.#s.title = e);
    }
    remove() {
      (this.#e.remove(), this.#t?.destroy(), (this.#t = null));
    }
  },
  G2 = class {
    #e = null;
    #t = null;
    #n;
    constructor(e) {
      this.#n = e;
    }
    #r() {
      let e = (this.#t = document.createElement(`div`));
      ((e.className = `editToolbar`), e.setAttribute(`role`, `toolbar`));
      let t = this.#n._signal;
      t instanceof AbortSignal &&
        !t.aborted &&
        e.addEventListener(`contextmenu`, b2, {
          signal: t,
        });
      let n = (this.#e = document.createElement(`div`));
      return (
        (n.className = `buttons`),
        e.append(n),
        this.#n.hasCommentManager() &&
          this.#a(
            `commentButton`,
            `pdfjs-comment-floating-button`,
            `pdfjs-comment-floating-button-label`,
            () => {
              this.#n.commentSelection(`floating_button`);
            },
          ),
        this.#a(
          `highlightButton`,
          `pdfjs-highlight-floating-button1`,
          `pdfjs-highlight-floating-button-label`,
          () => {
            this.#n.highlightSelection(`floating_button`);
          },
        ),
        e
      );
    }
    #i(e, t) {
      let n = 0,
        r = 0;
      for (let i of e) {
        let e = i.y + i.height;
        if (e < n) continue;
        let a = i.x + (t ? i.width : 0);
        if (e > n) {
          ((r = a), (n = e));
          continue;
        }
        t ? a > r && (r = a) : a < r && (r = a);
      }
      return [t ? 1 - r : r, n];
    }
    show(e, t, n) {
      let [r, i] = this.#i(t, n),
        { style: a } = (this.#t ||= this.#r());
      (e.append(this.#t),
        (a.insetInlineEnd = `${100 * r}%`),
        (a.top = `calc(${100 * i}% + var(--editor-toolbar-vert-offset))`));
    }
    hide() {
      this.#t.remove();
    }
    #a(e, t, n, r) {
      let i = document.createElement(`button`);
      (i.classList.add(`basic`, e), (i.tabIndex = 0), i.setAttribute(`data-l10n-id`, t));
      let a = document.createElement(`span`);
      (i.append(a), (a.className = `visuallyHidden`), a.setAttribute(`data-l10n-id`, n));
      let o = this.#n._signal;
      (o instanceof AbortSignal &&
        !o.aborted &&
        (i.addEventListener(`contextmenu`, b2, {
          signal: o,
        }),
        i.addEventListener(`click`, r, {
          signal: o,
        })),
        this.#e.append(i));
    }
  };
function K2(e, t, n) {
  for (let r of n) t.addEventListener(r, e[r].bind(e));
}
var q2 = class e {
    static #e = NaN;
    static #t = null;
    static #n = NaN;
    static #r = null;
    static initializeAndAddPointerId(t) {
      (e.#t ||= new Set()).add(t);
    }
    static setPointer(t, n) {
      ((e.#e ||= n), (e.#r ??= t));
    }
    static setTimeStamp(t) {
      e.#n = t;
    }
    static isSamePointerId(t) {
      return e.#e === t;
    }
    static isSamePointerIdOrRemove(t) {
      return e.#e === t ? !0 : (e.#t?.delete(t), !1);
    }
    static isSamePointerType(t) {
      return e.#r === t;
    }
    static isInitializedAndDifferentPointerType(t) {
      return e.#r !== null && !e.isSamePointerType(t);
    }
    static isSameTimeStamp(t) {
      return e.#n === t;
    }
    static isUsingMultiplePointers() {
      return e.#t?.size >= 1;
    }
    static clearPointerType() {
      e.#r = null;
    }
    static clearPointerIds() {
      ((e.#e = NaN), (e.#t = null));
    }
    static clearTimeStamp() {
      e.#n = NaN;
    }
  },
  J2 = class {
    #e = 0;
    get id() {
      return `${m0}${this.#e++}`;
    }
  },
  Y2 = class e {
    #e = e2();
    #t = 0;
    #n = null;
    static get _isSVGFittingCanvas() {
      let e = new OffscreenCanvas(1, 3).getContext(`2d`, {
          willReadFrequently: !0,
        }),
        t = new Image();
      t.src = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
      let n = t
        .decode()
        .then(
          () => (
            e.drawImage(t, 0, 0, 1, 1, 0, 0, 1, 3),
            new Uint32Array(e.getImageData(0, 0, 1, 1).data.buffer)[0] === 0
          ),
        );
      return L0(this, `_isSVGFittingCanvas`, n);
    }
    async #r(t, n) {
      this.#n ||= new Map();
      let r = this.#n.get(t);
      if (r === null) return null;
      if (r?.bitmap) return ((r.refCounter += 1), r);
      try {
        r ||= {
          bitmap: null,
          id: `image_${this.#e}_${this.#t++}`,
          refCounter: 0,
          isSvg: !1,
        };
        let t;
        if (
          (typeof n == `string`
            ? ((r.url = n), (t = await d2(n, `blob`)))
            : n instanceof File
              ? (t = r.file = n)
              : n instanceof Blob && (t = n),
          t.type === `image/svg+xml`)
        ) {
          let n = e._isSVGFittingCanvas,
            i = new FileReader(),
            a = new Image(),
            o = new Promise((e, t) => {
              ((a.onload = () => {
                ((r.bitmap = a), (r.isSvg = !0), e());
              }),
                (i.onload = async () => {
                  let e = (r.svgUrl = i.result);
                  a.src = (await n) ? `${e}#svgView(preserveAspectRatio(none))` : e;
                }),
                (a.onerror = i.onerror = t));
            });
          (i.readAsDataURL(t), await o);
        } else r.bitmap = await createImageBitmap(t);
        r.refCounter = 1;
      } catch (e) {
        (A0(e), (r = null));
      }
      return (this.#n.set(t, r), r && this.#n.set(r.id, r), r);
    }
    async getFromFile(e) {
      let { lastModified: t, name: n, size: r, type: i } = e;
      return this.#r(`${t}_${n}_${r}_${i}`, e);
    }
    async getFromUrl(e) {
      return this.#r(e, e);
    }
    async getFromBlob(e, t) {
      let n = await t;
      return this.#r(e, n);
    }
    async getFromId(e) {
      this.#n ||= new Map();
      let t = this.#n.get(e);
      if (!t) return null;
      if (t.bitmap) return ((t.refCounter += 1), t);
      if (t.file) return this.getFromFile(t.file);
      if (t.blobPromise) {
        let { blobPromise: e } = t;
        return (delete t.blobPromise, this.getFromBlob(t.id, e));
      }
      return this.getFromUrl(t.url);
    }
    getFromCanvas(e, t) {
      this.#n ||= new Map();
      let n = this.#n.get(e);
      if (n?.bitmap) return ((n.refCounter += 1), n);
      let r = new OffscreenCanvas(t.width, t.height);
      return (
        r.getContext(`2d`).drawImage(t, 0, 0),
        (n = {
          bitmap: r.transferToImageBitmap(),
          id: `image_${this.#e}_${this.#t++}`,
          refCounter: 1,
          isSvg: !1,
        }),
        this.#n.set(e, n),
        this.#n.set(n.id, n),
        n
      );
    }
    getSvgUrl(e) {
      let t = this.#n.get(e);
      return t?.isSvg ? t.svgUrl : null;
    }
    deleteId(e) {
      this.#n ||= new Map();
      let t = this.#n.get(e);
      if (!t || (--t.refCounter, t.refCounter !== 0)) return;
      let { bitmap: n } = t;
      if (!t.url && !t.file) {
        let e = new OffscreenCanvas(n.width, n.height);
        (e.getContext(`bitmaprenderer`).transferFromImageBitmap(n),
          (t.blobPromise = e.convertToBlob()));
      }
      (n.close?.(), (t.bitmap = null));
    }
    isValidId(e) {
      return e.startsWith(`image_${this.#e}_`);
    }
  },
  X2 = class {
    #e = [];
    #t = !1;
    #n;
    #r = -1;
    constructor(e = 128) {
      this.#n = e;
    }
    add({
      cmd: e,
      undo: t,
      post: n,
      mustExec: r,
      type: i = NaN,
      overwriteIfSameType: a = !1,
      keepUndo: o = !1,
    }) {
      if ((r && e(), this.#t)) return;
      let s = {
        cmd: e,
        undo: t,
        post: n,
        type: i,
      };
      if (this.#r === -1) {
        (this.#e.length > 0 && (this.#e.length = 0), (this.#r = 0), this.#e.push(s));
        return;
      }
      if (a && this.#e[this.#r].type === i) {
        (o && (s.undo = this.#e[this.#r].undo), (this.#e[this.#r] = s));
        return;
      }
      let c = this.#r + 1;
      (c === this.#n
        ? this.#e.splice(0, 1)
        : ((this.#r = c), c < this.#e.length && this.#e.splice(c)),
        this.#e.push(s));
    }
    undo() {
      if (this.#r === -1) return;
      this.#t = !0;
      let { undo: e, post: t } = this.#e[this.#r];
      (e(), t?.(), (this.#t = !1), --this.#r);
    }
    redo() {
      if (this.#r < this.#e.length - 1) {
        ((this.#r += 1), (this.#t = !0));
        let { cmd: e, post: t } = this.#e[this.#r];
        (e(), t?.(), (this.#t = !1));
      }
    }
    hasSomethingToUndo() {
      return this.#r !== -1;
    }
    hasSomethingToRedo() {
      return this.#r < this.#e.length - 1;
    }
    cleanType(e) {
      if (this.#r !== -1) {
        for (let t = this.#r; t >= 0; t--)
          if (this.#e[t].type !== e) {
            (this.#e.splice(t + 1, this.#r - t), (this.#r = t));
            return;
          }
        ((this.#e.length = 0), (this.#r = -1));
      }
    }
    destroy() {
      this.#e = null;
    }
  },
  Z2 = class {
    constructor(e) {
      ((this.buffer = []), (this.callbacks = new Map()), (this.allKeys = new Set()));
      let { isMac: t } = J0.platform;
      for (let [n, r, i = {}] of e)
        for (let e of n) {
          let n = e.startsWith(`mac+`);
          t && n
            ? (this.callbacks.set(e.slice(4), {
                callback: r,
                options: i,
              }),
              this.allKeys.add(e.split(`+`).at(-1)))
            : !t &&
              !n &&
              (this.callbacks.set(e, {
                callback: r,
                options: i,
              }),
              this.allKeys.add(e.split(`+`).at(-1)));
        }
    }
    #e(e) {
      (e.altKey && this.buffer.push(`alt`),
        e.ctrlKey && this.buffer.push(`ctrl`),
        e.metaKey && this.buffer.push(`meta`),
        e.shiftKey && this.buffer.push(`shift`),
        this.buffer.push(e.key));
      let t = this.buffer.join(`+`);
      return ((this.buffer.length = 0), t);
    }
    exec(e, t) {
      if (!this.allKeys.has(t.key)) return;
      let n = this.callbacks.get(this.#e(t));
      if (!n) return;
      let {
        callback: r,
        options: { bubbles: i = !1, args: a = [], checker: o = null },
      } = n;
      (o && !o(e, t)) || (r.bind(e, ...a, t)(), i || x2(t));
    }
  },
  ise = class e {
    static _colorsMapping = new Map([
      [`CanvasText`, [0, 0, 0]],
      [`Canvas`, [255, 255, 255]],
    ]);
    get _colors() {
      let e = new Map([
        [`CanvasText`, null],
        [`Canvas`, null],
      ]);
      return (D2(e), L0(this, `_colors`, e));
    }
    convert(t) {
      let n = E2(t);
      if (!window.matchMedia(`(forced-colors: active)`).matches) return n;
      for (let [t, r] of this._colors)
        if (r.every((e, t) => e === n[t])) return e._colorsMapping.get(t);
      return n;
    }
    getHexCode(e) {
      let t = this._colors.get(e);
      return t ? Y0.makeHexColor(...t) : e;
    }
  },
  Q2 = class e {
    #e = new AbortController();
    #t = null;
    #n = null;
    #r = new Map();
    #i = new Map();
    #a = null;
    #o = null;
    #s = null;
    #c = null;
    #l = new X2();
    #u = null;
    #d = null;
    #f = null;
    #p = 0;
    #m = new Set();
    #h = null;
    #g = null;
    #_ = new Set();
    _editorUndoBar = null;
    #v = !1;
    #y = !1;
    #b = !1;
    #x = null;
    #S = null;
    #C = null;
    #w = null;
    #T = !1;
    #E = null;
    #D = new J2();
    #O = !1;
    #k = !1;
    #A = !1;
    #j = null;
    #M = null;
    #N = null;
    #P = null;
    #F = null;
    #I = h0.NONE;
    #L = new Set();
    #R = null;
    #z = null;
    #B = null;
    #V = null;
    #H = null;
    #U = {
      isEditing: !1,
      isEmpty: !0,
      hasSomethingToUndo: !1,
      hasSomethingToRedo: !1,
      hasSelectedEditor: !1,
      hasSelectedText: !1,
    };
    #W = [0, 0];
    #G = null;
    #K = null;
    #q = null;
    #J = null;
    #Y = null;
    static TRANSLATE_SMALL = 1;
    static TRANSLATE_BIG = 10;
    static get _keyboardManager() {
      let t = e.prototype,
        n = (e) =>
          e.#K.contains(document.activeElement) &&
          document.activeElement.tagName !== `BUTTON` &&
          e.hasSomethingToControl(),
        r = (e, { target: t }) => {
          if (t instanceof HTMLInputElement) {
            let { type: e } = t;
            return e !== `text` && e !== `number`;
          }
          return !0;
        },
        i = this.TRANSLATE_SMALL,
        a = this.TRANSLATE_BIG;
      return L0(
        this,
        `_keyboardManager`,
        new Z2([
          [
            [`ctrl+a`, `mac+meta+a`],
            t.selectAll,
            {
              checker: r,
            },
          ],
          [
            [`ctrl+z`, `mac+meta+z`],
            t.undo,
            {
              checker: r,
            },
          ],
          [
            [`ctrl+y`, `ctrl+shift+z`, `mac+meta+shift+z`, `ctrl+shift+Z`, `mac+meta+shift+Z`],
            t.redo,
            {
              checker: r,
            },
          ],
          [
            [
              `Backspace`,
              `alt+Backspace`,
              `ctrl+Backspace`,
              `shift+Backspace`,
              `mac+Backspace`,
              `mac+alt+Backspace`,
              `mac+ctrl+Backspace`,
              `Delete`,
              `ctrl+Delete`,
              `shift+Delete`,
              `mac+Delete`,
            ],
            t.delete,
            {
              checker: r,
            },
          ],
          [
            [`Enter`, `mac+Enter`],
            t.addNewEditorFromKeyboard,
            {
              checker: (e, { target: t }) =>
                !(t instanceof HTMLButtonElement) && e.#K.contains(t) && !e.isEnterHandled,
            },
          ],
          [
            [` `, `mac+ `],
            t.addNewEditorFromKeyboard,
            {
              checker: (e, { target: t }) =>
                !(t instanceof HTMLButtonElement) && e.#K.contains(document.activeElement),
            },
          ],
          [[`Escape`, `mac+Escape`], t.unselectAll],
          [
            [`ArrowLeft`, `mac+ArrowLeft`],
            t.translateSelectedEditors,
            {
              args: [-i, 0],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowLeft`, `mac+shift+ArrowLeft`],
            t.translateSelectedEditors,
            {
              args: [-a, 0],
              checker: n,
            },
          ],
          [
            [`ArrowRight`, `mac+ArrowRight`],
            t.translateSelectedEditors,
            {
              args: [i, 0],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowRight`, `mac+shift+ArrowRight`],
            t.translateSelectedEditors,
            {
              args: [a, 0],
              checker: n,
            },
          ],
          [
            [`ArrowUp`, `mac+ArrowUp`],
            t.translateSelectedEditors,
            {
              args: [0, -i],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowUp`, `mac+shift+ArrowUp`],
            t.translateSelectedEditors,
            {
              args: [0, -a],
              checker: n,
            },
          ],
          [
            [`ArrowDown`, `mac+ArrowDown`],
            t.translateSelectedEditors,
            {
              args: [0, i],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowDown`, `mac+shift+ArrowDown`],
            t.translateSelectedEditors,
            {
              args: [0, a],
              checker: n,
            },
          ],
        ]),
      );
    }
    constructor(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h) {
      let g = (this._signal = this.#e.signal);
      ((this.#K = e),
        (this.#q = t),
        (this.#J = n),
        (this.#o = r),
        (this.#u = i),
        (this.#z = a),
        (this.#H = s),
        (this._eventBus = o),
        o._on(`editingaction`, this.onEditingAction.bind(this), {
          signal: g,
        }),
        o._on(`pagechanging`, this.onPageChanging.bind(this), {
          signal: g,
        }),
        o._on(`scalechanging`, this.onScaleChanging.bind(this), {
          signal: g,
        }),
        o._on(`rotationchanging`, this.onRotationChanging.bind(this), {
          signal: g,
        }),
        o._on(`setpreference`, this.onSetPreference.bind(this), {
          signal: g,
        }),
        o._on(`switchannotationeditorparams`, (e) => this.updateParams(e.type, e.value), {
          signal: g,
        }),
        window.addEventListener(
          `pointerdown`,
          () => {
            this.#k = !0;
          },
          {
            capture: !0,
            signal: g,
          },
        ),
        window.addEventListener(
          `pointerup`,
          () => {
            this.#k = !1;
          },
          {
            capture: !0,
            signal: g,
          },
        ),
        window.addEventListener(`beforeunload`, this.#Q.bind(this), {
          capture: !0,
          signal: g,
        }),
        this.#ne(),
        this.#le(),
        this.#ae(),
        (this.#s = s.annotationStorage),
        (this.#x = s.filterFactory),
        (this.#B = c),
        (this.#w = l || null),
        (this.#v = u),
        (this.#y = d),
        (this.#b = f),
        (this.#F = p || null),
        (this.viewParameters = {
          realScale: u2.PDF_TO_CSS_UNITS,
          rotation: 0,
        }),
        (this.isShiftKeyDown = !1),
        (this._editorUndoBar = m || null),
        (this._supportsPinchToZoom = h !== !1),
        i?.setSidebarUiManager(this));
    }
    destroy() {
      (this.#Y?.resolve(),
        (this.#Y = null),
        this.#e?.abort(),
        (this.#e = null),
        (this._signal = null));
      for (let e of this.#i.values()) e.destroy();
      (this.#i.clear(),
        this.#r.clear(),
        this.#_.clear(),
        this.#P?.clear(),
        (this.#t = null),
        this.#L.clear(),
        this.#l.destroy(),
        this.#o?.destroy(),
        this.#u?.destroy(),
        this.#z?.destroy(),
        this.#E?.hide(),
        (this.#E = null),
        this.#N?.destroy(),
        (this.#N = null),
        (this.#n = null),
        (this.#S &&= (clearTimeout(this.#S), null)),
        (this.#G &&= (clearTimeout(this.#G), null)),
        this._editorUndoBar?.destroy(),
        (this.#H = null));
    }
    combinedSignal(e) {
      return AbortSignal.any([this._signal, e.signal]);
    }
    get mlManager() {
      return this.#F;
    }
    get useNewAltTextFlow() {
      return this.#y;
    }
    get useNewAltTextWhenAddingImage() {
      return this.#b;
    }
    get hcmFilter() {
      return L0(
        this,
        `hcmFilter`,
        this.#B ? this.#x.addHCMFilter(this.#B.foreground, this.#B.background) : `none`,
      );
    }
    get direction() {
      return L0(this, `direction`, getComputedStyle(this.#K).direction);
    }
    get _highlightColors() {
      return L0(
        this,
        `_highlightColors`,
        this.#w
          ? new Map(
              this.#w
                .split(`,`)
                .map(
                  (e) => ((e = e.split(`=`).map((e) => e.trim())), (e[1] = e[1].toUpperCase()), e),
                ),
            )
          : null,
      );
    }
    get highlightColors() {
      let { _highlightColors: e } = this;
      if (!e) return L0(this, `highlightColors`, null);
      let t = new Map(),
        n = !!this.#B;
      for (let [r, i] of e) {
        let e = r.endsWith(`_HCM`);
        if (n && e) {
          t.set(r.replace(`_HCM`, ``), i);
          continue;
        }
        !n && !e && t.set(r, i);
      }
      return L0(this, `highlightColors`, t);
    }
    get highlightColorNames() {
      return L0(
        this,
        `highlightColorNames`,
        this.highlightColors ? new Map(Array.from(this.highlightColors, (e) => e.reverse())) : null,
      );
    }
    getNonHCMColor(e) {
      if (!this._highlightColors) return e;
      let t = this.highlightColorNames.get(e);
      return this._highlightColors.get(t) || e;
    }
    getNonHCMColorName(e) {
      return this.highlightColorNames.get(e) || e;
    }
    setCurrentDrawingSession(e) {
      (e ? (this.unselectAll(), this.disableUserSelect(!0)) : this.disableUserSelect(!1),
        (this.#f = e));
    }
    setMainHighlightColorPicker(e) {
      this.#N = e;
    }
    editAltText(e, t = !1) {
      this.#o?.editAltText(this, e, t);
    }
    hasCommentManager() {
      return !!this.#u;
    }
    editComment(e, t, n, r) {
      this.#u?.showDialog(this, e, t, n, r);
    }
    selectComment(e, t) {
      this.#i.get(e)?.getEditorByUID(t)?.toggleComment(!0, !0);
    }
    updateComment(e) {
      this.#u?.updateComment(e.getData());
    }
    updatePopupColor(e) {
      this.#u?.updatePopupColor(e);
    }
    removeComment(e) {
      this.#u?.removeComments([e.uid]);
    }
    deleteComment(e, t) {
      let n = () => {
        e.comment = t;
      };
      this.addCommands({
        cmd: () => {
          (this._editorUndoBar?.show(n, `comment`), this.toggleComment(null), (e.comment = null));
        },
        undo: n,
        mustExec: !0,
      });
    }
    toggleComment(e, t, n = void 0) {
      this.#u?.toggleCommentPopup(e, t, n);
    }
    makeCommentColor(e, t) {
      return (e && this.#u?.makeCommentColor(e, t)) || null;
    }
    getCommentDialogElement() {
      return this.#u?.dialogElement || null;
    }
    async waitForEditorsRendered(e) {
      if (this.#i.has(e - 1)) return;
      let { resolve: t, promise: n } = Promise.withResolvers(),
        r = (n) => {
          n.pageNumber === e && (this._eventBus._off(`editorsrendered`, r), t());
        };
      (this._eventBus.on(`editorsrendered`, r), await n);
    }
    getSignature(e) {
      this.#z?.getSignature({
        uiManager: this,
        editor: e,
      });
    }
    get signatureManager() {
      return this.#z;
    }
    switchToMode(e, t) {
      (this._eventBus.on(`annotationeditormodechanged`, t, {
        once: !0,
        signal: this._signal,
      }),
        this._eventBus.dispatch(`showannotationeditorui`, {
          source: this,
          mode: e,
        }));
    }
    setPreference(e, t) {
      this._eventBus.dispatch(`setpreference`, {
        source: this,
        name: e,
        value: t,
      });
    }
    onSetPreference({ name: e, value: t }) {
      switch (e) {
        case `enableNewAltTextWhenAddingImage`:
          this.#b = t;
          break;
      }
    }
    onPageChanging({ pageNumber: e }) {
      this.#p = e - 1;
    }
    deletePage(e) {
      for (let t of this.getEditors(e)) t.remove();
      (this.#i.delete(e), this.#p === e && (this.#p = 0));
    }
    focusMainContainer() {
      this.#K.focus();
    }
    findParent(e, t) {
      for (let n of this.#i.values()) {
        let { x: r, y: i, width: a, height: o } = n.div.getBoundingClientRect();
        if (e >= r && e <= r + a && t >= i && t <= i + o) return n;
      }
      return null;
    }
    disableUserSelect(e = !1) {
      this.#q.classList.toggle(`noUserSelect`, e);
    }
    addShouldRescale(e) {
      this.#_.add(e);
    }
    removeShouldRescale(e) {
      this.#_.delete(e);
    }
    onScaleChanging({ scale: e }) {
      (this.commitOrRemove(), (this.viewParameters.realScale = e * u2.PDF_TO_CSS_UNITS));
      for (let e of this.#_) e.onScaleChanging();
      this.#f?.onScaleChanging();
    }
    onRotationChanging({ pagesRotation: e }) {
      (this.commitOrRemove(), (this.viewParameters.rotation = e));
    }
    #X({ anchorNode: e }) {
      return e.nodeType === Node.TEXT_NODE ? e.parentElement : e;
    }
    #Z(e) {
      let { currentLayer: t } = this;
      if (t.hasTextLayer(e)) return t;
      for (let t of this.#i.values()) if (t.hasTextLayer(e)) return t;
      return null;
    }
    highlightSelection(e = ``, t = !1) {
      let n = document.getSelection();
      if (!n || n.isCollapsed) return;
      let { anchorNode: r, anchorOffset: i, focusNode: a, focusOffset: o } = n,
        s = n.toString(),
        c = this.#X(n).closest(`.textLayer`),
        l = this.getSelectionBoxes(c);
      if (!l) return;
      n.empty();
      let u = this.#Z(c),
        d = this.#I === h0.NONE,
        f = () => {
          let n = u?.createAndAddNewEditor(
            {
              x: 0,
              y: 0,
            },
            !1,
            {
              methodOfCreation: e,
              boxes: l,
              anchorNode: r,
              anchorOffset: i,
              focusNode: a,
              focusOffset: o,
              text: s,
            },
          );
          (d && this.showAllEditors(`highlight`, !0, !0), t && n?.editComment());
        };
      if (d) {
        this.switchToMode(h0.HIGHLIGHT, f);
        return;
      }
      f();
    }
    commentSelection(e = ``) {
      this.highlightSelection(e, !0);
    }
    #Q(e) {
      (this.commitOrRemove(), this.currentLayer?.endDrawingSession(!1));
    }
    #$() {
      let e = document.getSelection();
      if (!e || e.isCollapsed) return;
      let t = this.#X(e).closest(`.textLayer`),
        n = this.getSelectionBoxes(t);
      n && ((this.#E ||= new G2(this)), this.#E.show(t, n, this.direction === `ltr`));
    }
    getAndRemoveDataFromAnnotationStorage(e) {
      if (!this.#s) return null;
      let t = `${m0}${e}`,
        n = this.#s.getRawValue(t);
      return (n && this.#s.remove(t), n);
    }
    addToAnnotationStorage(e) {
      !e.isEmpty() && this.#s && !this.#s.has(e.id) && this.#s.setValue(e.id, e);
    }
    a11yAlert(e, t = null) {
      let n = this.#J;
      n &&
        (n.setAttribute(`data-l10n-id`, e),
        t
          ? n.setAttribute(`data-l10n-args`, JSON.stringify(t))
          : n.removeAttribute(`data-l10n-args`));
    }
    #ee() {
      let e = document.getSelection();
      if (!e || e.isCollapsed) {
        this.#R &&
          (this.#E?.hide(),
          (this.#R = null),
          this.#ue({
            hasSelectedText: !1,
          }));
        return;
      }
      let { anchorNode: t } = e;
      if (t === this.#R) return;
      let n = this.#X(e).closest(`.textLayer`);
      if (!n) {
        this.#R &&
          (this.#E?.hide(),
          (this.#R = null),
          this.#ue({
            hasSelectedText: !1,
          }));
        return;
      }
      if (
        (this.#E?.hide(),
        (this.#R = t),
        this.#ue({
          hasSelectedText: !0,
        }),
        !(this.#I !== h0.HIGHLIGHT && this.#I !== h0.NONE) &&
          (this.#I === h0.HIGHLIGHT && this.showAllEditors(`highlight`, !0, !0),
          (this.#T = this.isShiftKeyDown),
          !this.isShiftKeyDown))
      ) {
        let e = this.#I === h0.HIGHLIGHT ? this.#Z(n) : null;
        if ((e?.toggleDrawing(), this.#k)) {
          let t = new AbortController(),
            n = this.combinedSignal(t),
            r = (n) => {
              (n.type === `pointerup` && n.button !== 0) ||
                (t.abort(),
                e?.toggleDrawing(!0),
                n.type === `pointerup` && this.#te(`main_toolbar`));
            };
          (window.addEventListener(`pointerup`, r, {
            signal: n,
          }),
            window.addEventListener(`blur`, r, {
              signal: n,
            }));
        } else (e?.toggleDrawing(!0), this.#te(`main_toolbar`));
      }
    }
    #te(e = ``) {
      this.#I === h0.HIGHLIGHT ? this.highlightSelection(e) : this.#v && this.#$();
    }
    #ne() {
      document.addEventListener(`selectionchange`, this.#ee.bind(this), {
        signal: this._signal,
      });
    }
    #re() {
      if (this.#C) return;
      this.#C = new AbortController();
      let e = this.combinedSignal(this.#C);
      (window.addEventListener(`focus`, this.focus.bind(this), {
        signal: e,
      }),
        window.addEventListener(`blur`, this.blur.bind(this), {
          signal: e,
        }));
    }
    #ie() {
      (this.#C?.abort(), (this.#C = null));
    }
    blur() {
      if (
        ((this.isShiftKeyDown = !1),
        this.#T && ((this.#T = !1), this.#te(`main_toolbar`)),
        !this.hasSelection)
      )
        return;
      let { activeElement: e } = document;
      for (let t of this.#L)
        if (t.div.contains(e)) {
          ((this.#M = [t, e]), (t._focusEventsAllowed = !1));
          break;
        }
    }
    focus() {
      if (!this.#M) return;
      let [e, t] = this.#M;
      ((this.#M = null),
        t.addEventListener(
          `focusin`,
          () => {
            e._focusEventsAllowed = !0;
          },
          {
            once: !0,
            signal: this._signal,
          },
        ),
        t.focus());
    }
    #ae() {
      if (this.#j) return;
      this.#j = new AbortController();
      let e = this.combinedSignal(this.#j);
      (window.addEventListener(`keydown`, this.keydown.bind(this), {
        signal: e,
      }),
        window.addEventListener(`keyup`, this.keyup.bind(this), {
          signal: e,
        }));
    }
    #oe() {
      (this.#j?.abort(), (this.#j = null));
    }
    #se() {
      if (this.#d) return;
      this.#d = new AbortController();
      let e = this.combinedSignal(this.#d);
      (document.addEventListener(`copy`, this.copy.bind(this), {
        signal: e,
      }),
        document.addEventListener(`cut`, this.cut.bind(this), {
          signal: e,
        }),
        document.addEventListener(`paste`, this.paste.bind(this), {
          signal: e,
        }));
    }
    #ce() {
      (this.#d?.abort(), (this.#d = null));
    }
    #le() {
      let e = this._signal;
      (document.addEventListener(`dragover`, this.dragOver.bind(this), {
        signal: e,
      }),
        document.addEventListener(`drop`, this.drop.bind(this), {
          signal: e,
        }));
    }
    addEditListeners() {
      (this.#ae(), this.setEditingState(!0));
    }
    removeEditListeners() {
      (this.#oe(), this.setEditingState(!1));
    }
    dragOver(e) {
      for (let { type: t } of e.dataTransfer.items)
        for (let n of this.#g)
          if (n.isHandlingMimeForPasting(t)) {
            ((e.dataTransfer.dropEffect = `copy`), e.preventDefault());
            return;
          }
    }
    drop(e) {
      for (let t of e.dataTransfer.items)
        for (let n of this.#g)
          if (n.isHandlingMimeForPasting(t.type)) {
            (n.paste(t, this.currentLayer), e.preventDefault());
            return;
          }
    }
    copy(e) {
      if ((e.preventDefault(), this.#t?.commitOrRemove(), !this.hasSelection)) return;
      let t = [];
      for (let e of this.#L) {
        let n = e.serialize(!0);
        n && t.push(n);
      }
      t.length !== 0 && e.clipboardData.setData(`application/pdfjs`, JSON.stringify(t));
    }
    cut(e) {
      (this.copy(e), this.delete());
    }
    async paste(e) {
      e.preventDefault();
      let { clipboardData: t } = e;
      for (let e of t.items)
        for (let t of this.#g)
          if (t.isHandlingMimeForPasting(e.type)) {
            t.paste(e, this.currentLayer);
            return;
          }
      let n = t.getData(`application/pdfjs`);
      if (!n) return;
      try {
        n = JSON.parse(n);
      } catch (e) {
        A0(`paste: "${e.message}".`);
        return;
      }
      if (!Array.isArray(n)) return;
      this.unselectAll();
      let r = this.currentLayer;
      try {
        let e = [];
        for (let t of n) {
          let n = await r.deserialize(t);
          if (!n) return;
          e.push(n);
        }
        this.addCommands({
          cmd: () => {
            for (let t of e) this.#me(t);
            this.#_e(e);
          },
          undo: () => {
            for (let t of e) t.remove();
          },
          mustExec: !0,
        });
      } catch (e) {
        A0(`paste: "${e.message}".`);
      }
    }
    keydown(t) {
      (!this.isShiftKeyDown && t.key === `Shift` && (this.isShiftKeyDown = !0),
        this.#I !== h0.NONE && !this.isEditorHandlingKeyboard && e._keyboardManager.exec(this, t));
    }
    keyup(e) {
      this.isShiftKeyDown &&
        e.key === `Shift` &&
        ((this.isShiftKeyDown = !1), this.#T && ((this.#T = !1), this.#te(`main_toolbar`)));
    }
    onEditingAction({ name: e }) {
      switch (e) {
        case `undo`:
        case `redo`:
        case `delete`:
        case `selectAll`:
          this[e]();
          break;
        case `highlightSelection`:
          this.highlightSelection(`context_menu`);
          break;
        case `commentSelection`:
          this.commentSelection(`context_menu`);
          break;
      }
    }
    updatePageIndex(e, t) {
      for (let n of this.getEditors(e)) n.pageIndex = t;
      let n = this.#a.get(e);
      n && ((n.pageIndex = t), this.#i.set(t, n), this.#O ? n.enable() : n.disable());
    }
    startUpdatePages() {
      ((this.#a = new Map(this.#i)), this.#i.clear());
    }
    endUpdatePages() {
      this.#a = null;
    }
    clonePage(e, t) {
      for (let n of this.getEditors(e)) {
        let e = n.serialize(n.mode !== h0.HIGHLIGHT);
        e &&
          ((e.pageIndex = t),
          (e.id = this.getId()),
          (e.isClone = !0),
          delete e.popupRef,
          this.#s.setValue(e.id, e));
      }
    }
    findClonesForPage(e) {
      let t = [],
        { pageIndex: n } = e;
      for (let [r, i] of this.#s)
        i.pageIndex === n &&
          i.isClone &&
          (this.#s.remove(r),
          t.push(
            e.deserialize(i).then((t) => {
              t && ((t.isClone = !0), e.addOrRebuild(t));
            }),
          ));
      return Promise.all(t);
    }
    #ue(e) {
      Object.entries(e).some(([e, t]) => this.#U[e] !== t) &&
        (this._eventBus.dispatch(`editingstateschanged`, {
          source: this,
          details: Object.assign(this.#U, e),
        }),
        this.#I === h0.HIGHLIGHT &&
          e.hasSelectedEditor === !1 &&
          this.#de([[g0.HIGHLIGHT_FREE, !0]]));
    }
    #de(e) {
      this._eventBus.dispatch(`annotationeditorparamschanged`, {
        source: this,
        details: e,
      });
    }
    setEditingState(e) {
      e
        ? (this.#re(),
          this.#se(),
          this.#ue({
            isEditing: this.#I !== h0.NONE,
            isEmpty: this.#ge(),
            hasSomethingToUndo: this.#l.hasSomethingToUndo(),
            hasSomethingToRedo: this.#l.hasSomethingToRedo(),
            hasSelectedEditor: !1,
          }))
        : (this.#ie(),
          this.#ce(),
          this.#ue({
            isEditing: !1,
          }),
          this.disableUserSelect(!1));
    }
    registerEditorTypes(e) {
      if (!this.#g) {
        this.#g = e;
        for (let e of this.#g) this.#de(e.defaultPropertiesToUpdate);
      }
    }
    getId() {
      return this.#D.id;
    }
    get currentLayer() {
      return this.#i.get(this.#p);
    }
    getLayer(e) {
      return this.#i.get(e);
    }
    get currentPageIndex() {
      return this.#p;
    }
    addLayer(e) {
      (this.#i.set(e.pageIndex, e), this.#O ? e.enable() : e.disable());
    }
    removeLayer(e) {
      this.#i.delete(e.pageIndex);
    }
    async updateMode(e, t = null, n = !1, r = !1, i = !1, a = !1) {
      if (this.#I !== e && !(this.#Y && (await this.#Y.promise, !this.#Y))) {
        if (
          ((this.#Y = Promise.withResolvers()),
          this.#f?.commitOrRemove(),
          this.#I === h0.POPUP && this.#u?.hideSidebar(),
          this.#u?.destroyPopup(),
          (this.#I = e),
          e === h0.NONE)
        ) {
          (this.setEditingState(!1), this.#pe());
          for (let e of this.#r.values()) e.hideStandaloneCommentButton();
          (this._editorUndoBar?.hide(), this.toggleComment(null), this.#Y.resolve());
          return;
        }
        for (let e of this.#r.values()) e.addStandaloneCommentButton();
        (e === h0.SIGNATURE && (await this.#z?.loadSignatures()),
          n && q2.clearPointerType(),
          this.setEditingState(!0),
          await this.#fe(),
          this.unselectAll());
        for (let t of this.#i.values()) t.updateMode(e);
        if (e === h0.POPUP) {
          this.#n ||= await this.#H.getAnnotationsByType(
            new Set(this.#g.map((e) => e._editorType)),
          );
          let e = new Set(),
            t = [];
          for (let n of this.#r.values()) {
            let { annotationElementId: r, hasComment: i, deleted: a } = n;
            (r && e.add(r), i && !a && t.push(n.getData()));
          }
          for (let n of this.#n) {
            let { id: r, popupRef: i, contentsObj: a } = n;
            i && a?.str && !e.has(r) && !this.#m.has(r) && t.push(n);
          }
          this.#u?.showSidebar(t);
        }
        if (!t) {
          (r && this.addNewEditorFromKeyboard(), this.#Y.resolve());
          return;
        }
        for (let e of this.#r.values())
          e.uid === t
            ? (this.setSelected(e), a ? e.editComment() : i ? e.enterInEditMode() : e.focus())
            : e.unselect();
        this.#Y.resolve();
      }
    }
    addNewEditorFromKeyboard() {
      this.currentLayer.canCreateNewEmptyEditor() && this.currentLayer.addNewEditor();
    }
    updateToolbar(e) {
      e.mode !== this.#I &&
        this._eventBus.dispatch(`switchannotationeditormode`, {
          source: this,
          ...e,
        });
    }
    updateParams(e, t) {
      if (this.#g) {
        switch (e) {
          case g0.CREATE:
            this.currentLayer.addNewEditor(t);
            return;
          case g0.HIGHLIGHT_SHOW_ALL:
            (this._eventBus.dispatch(`reporttelemetry`, {
              source: this,
              details: {
                type: `editing`,
                data: {
                  type: `highlight`,
                  action: `toggle_visibility`,
                },
              },
            }),
              (this.#V ||= new Map()).set(e, t),
              this.showAllEditors(`highlight`, t));
            break;
        }
        if (this.hasSelection) for (let n of this.#L) n.updateParams(e, t);
        else for (let n of this.#g) n.updateDefaultParams(e, t);
      }
    }
    showAllEditors(e, t, n = !1) {
      for (let n of this.#r.values()) n.editorType === e && n.show(t);
      (this.#V?.get(g0.HIGHLIGHT_SHOW_ALL) ?? !0) !== t && this.#de([[g0.HIGHLIGHT_SHOW_ALL, t]]);
    }
    enableWaiting(e = !1) {
      if (this.#A !== e) {
        this.#A = e;
        for (let t of this.#i.values())
          (e ? t.disableClick() : t.enableClick(), t.div.classList.toggle(`waiting`, e));
      }
    }
    async #fe() {
      if (!this.#O) {
        this.#O = !0;
        let e = [];
        for (let t of this.#i.values()) e.push(t.enable());
        await Promise.all(e);
        for (let e of this.#r.values()) e.enable();
      }
    }
    #pe() {
      if ((this.unselectAll(), this.#O)) {
        this.#O = !1;
        for (let e of this.#i.values()) e.disable();
        for (let e of this.#r.values()) e.disable();
      }
    }
    *getEditors(e) {
      for (let t of this.#r.values()) t.pageIndex === e && (yield t);
    }
    getEditor(e) {
      return this.#r.get(e);
    }
    addEditor(e) {
      this.#r.set(e.id, e);
    }
    removeEditor(e) {
      (e.div.contains(document.activeElement) &&
        (this.#S && clearTimeout(this.#S),
        (this.#S = setTimeout(() => {
          (this.focusMainContainer(), (this.#S = null));
        }, 0))),
        this.#r.delete(e.id),
        e.annotationElementId && this.#P?.delete(e.annotationElementId),
        this.unselect(e),
        (!e.annotationElementId || !this.#m.has(e.annotationElementId)) && this.#s?.remove(e.id));
    }
    addDeletedAnnotationElement(e) {
      (this.#m.add(e.annotationElementId), this.addChangedExistingAnnotation(e), (e.deleted = !0));
    }
    isDeletedAnnotationElement(e) {
      return this.#m.has(e);
    }
    removeDeletedAnnotationElement(e) {
      (this.#m.delete(e.annotationElementId),
        this.removeChangedExistingAnnotation(e),
        (e.deleted = !1));
    }
    #me(e) {
      let t = this.#i.get(e.pageIndex);
      t ? t.addOrRebuild(e) : (this.addEditor(e), this.addToAnnotationStorage(e));
    }
    setActiveEditor(e) {
      this.#t !== e && ((this.#t = e), e && this.#de(e.propertiesToUpdate));
    }
    get #he() {
      let e = null;
      for (e of this.#L);
      return e;
    }
    updateUI(e) {
      this.#he === e && this.#de(e.propertiesToUpdate);
    }
    updateUIForDefaultProperties(e) {
      this.#de(e.defaultPropertiesToUpdate);
    }
    toggleSelected(e) {
      if (this.#L.has(e)) {
        (this.#L.delete(e),
          e.unselect(),
          this.#ue({
            hasSelectedEditor: this.hasSelection,
          }));
        return;
      }
      (this.#L.add(e),
        e.select(),
        this.#de(e.propertiesToUpdate),
        this.#ue({
          hasSelectedEditor: !0,
        }));
    }
    setSelected(e) {
      (this.updateToolbar({
        mode: e.mode,
        editId: e.uid,
      }),
        this.#f?.commitOrRemove());
      for (let t of this.#L) t !== e && t.unselect();
      (this.#u?.destroyPopup(),
        this.#L.clear(),
        this.#L.add(e),
        e.select(),
        this.#de(e.propertiesToUpdate),
        this.#ue({
          hasSelectedEditor: !0,
        }));
    }
    isSelected(e) {
      return this.#L.has(e);
    }
    get firstSelectedEditor() {
      return this.#L.values().next().value;
    }
    unselect(e) {
      (e.unselect(),
        this.#L.delete(e),
        this.#ue({
          hasSelectedEditor: this.hasSelection,
        }));
    }
    get hasSelection() {
      return this.#L.size !== 0;
    }
    get isEnterHandled() {
      return this.#L.size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
    undo() {
      (this.#l.undo(),
        this.#ue({
          hasSomethingToUndo: this.#l.hasSomethingToUndo(),
          hasSomethingToRedo: !0,
          isEmpty: this.#ge(),
        }),
        this._editorUndoBar?.hide());
    }
    redo() {
      (this.#l.redo(),
        this.#ue({
          hasSomethingToUndo: !0,
          hasSomethingToRedo: this.#l.hasSomethingToRedo(),
          isEmpty: this.#ge(),
        }));
    }
    addCommands(e) {
      (this.#l.add(e),
        this.#ue({
          hasSomethingToUndo: !0,
          hasSomethingToRedo: !1,
          isEmpty: this.#ge(),
        }));
    }
    cleanUndoStack(e) {
      this.#l.cleanType(e);
    }
    #ge() {
      if (this.#r.size === 0) return !0;
      if (this.#r.size === 1) for (let e of this.#r.values()) return e.isEmpty();
      return !1;
    }
    delete() {
      this.commitOrRemove();
      let e = this.currentLayer?.endDrawingSession(!0);
      if (!this.hasSelection && !e) return;
      let t = e ? [e] : [...this.#L],
        n = () => {
          this._editorUndoBar?.show(r, t.length === 1 ? t[0].editorType : t.length);
          for (let e of t) e.remove();
        },
        r = () => {
          for (let e of t) this.#me(e);
        };
      this.addCommands({
        cmd: n,
        undo: r,
        mustExec: !0,
      });
    }
    commitOrRemove() {
      this.#t?.commitOrRemove();
    }
    hasSomethingToControl() {
      return this.#t || this.hasSelection;
    }
    #_e(e) {
      for (let e of this.#L) e.unselect();
      this.#L.clear();
      for (let t of e) t.isEmpty() || (this.#L.add(t), t.select());
      this.#ue({
        hasSelectedEditor: this.hasSelection,
      });
    }
    selectAll() {
      for (let e of this.#L) e.commit();
      this.#_e(this.#r.values());
    }
    unselectAll() {
      if (
        !(this.#t && (this.#t.commitOrRemove(), this.#I !== h0.NONE)) &&
        !this.#f?.commitOrRemove() &&
        (this.#u?.destroyPopup(), this.hasSelection)
      ) {
        for (let e of this.#L) e.unselect();
        (this.#L.clear(),
          this.#ue({
            hasSelectedEditor: !1,
          }));
      }
    }
    translateSelectedEditors(e, t, n = !1) {
      if ((n || this.commitOrRemove(), !this.hasSelection)) return;
      ((this.#W[0] += e), (this.#W[1] += t));
      let [r, i] = this.#W,
        a = [...this.#L];
      (this.#G && clearTimeout(this.#G),
        (this.#G = setTimeout(() => {
          ((this.#G = null),
            (this.#W[0] = this.#W[1] = 0),
            this.addCommands({
              cmd: () => {
                for (let e of a)
                  this.#r.has(e.id) && (e.translateInPage(r, i), e.translationDone());
              },
              undo: () => {
                for (let e of a)
                  this.#r.has(e.id) && (e.translateInPage(-r, -i), e.translationDone());
              },
              mustExec: !1,
            }));
        }, 1e3)));
      for (let n of a) (n.translateInPage(e, t), n.translationDone());
    }
    setUpDragSession() {
      if (this.hasSelection) {
        (this.disableUserSelect(!0), (this.#h = new Map()));
        for (let e of this.#L)
          this.#h.set(e, {
            savedX: e.x,
            savedY: e.y,
            savedPageIndex: e.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1,
          });
      }
    }
    endDragSession() {
      if (!this.#h) return !1;
      this.disableUserSelect(!1);
      let e = this.#h;
      this.#h = null;
      let t = !1;
      for (let [{ x: n, y: r, pageIndex: i }, a] of e)
        ((a.newX = n),
          (a.newY = r),
          (a.newPageIndex = i),
          (t ||= n !== a.savedX || r !== a.savedY || i !== a.savedPageIndex));
      if (!t) return !1;
      let n = (e, t, n, r) => {
        if (this.#r.has(e.id)) {
          let i = this.#i.get(r);
          i ? e._setParentAndPosition(i, t, n) : ((e.pageIndex = r), (e.x = t), (e.y = n));
        }
      };
      return (
        this.addCommands({
          cmd: () => {
            for (let [t, { newX: r, newY: i, newPageIndex: a }] of e) n(t, r, i, a);
          },
          undo: () => {
            for (let [t, { savedX: r, savedY: i, savedPageIndex: a }] of e) n(t, r, i, a);
          },
          mustExec: !0,
        }),
        !0
      );
    }
    dragSelectedEditors(e, t) {
      if (this.#h) for (let n of this.#h.keys()) n.drag(e, t);
    }
    rebuild(e) {
      if (e.parent === null) {
        let t = this.getLayer(e.pageIndex);
        t
          ? (t.changeParent(e), t.addOrRebuild(e))
          : (this.addEditor(e), this.addToAnnotationStorage(e), e.rebuild());
      } else e.parent.addOrRebuild(e);
    }
    get isEditorHandlingKeyboard() {
      return (
        this.getActive()?.shouldGetKeyboardEvents() ||
        (this.#L.size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents())
      );
    }
    isActive(e) {
      return this.#t === e;
    }
    getActive() {
      return this.#t;
    }
    getMode() {
      return this.#I;
    }
    isEditingMode() {
      return this.#I !== h0.NONE;
    }
    get imageManager() {
      return L0(this, `imageManager`, new Y2());
    }
    getSelectionBoxes(e) {
      if (!e) return null;
      let t = document.getSelection();
      for (let n = 0, r = t.rangeCount; n < r; n++)
        if (!e.contains(t.getRangeAt(n).commonAncestorContainer)) return null;
      let { x: n, y: r, width: i, height: a } = e.getBoundingClientRect(),
        o;
      switch (e.getAttribute(`data-main-rotation`)) {
        case `90`:
          o = (e, t, o, s) => ({
            x: (t - r) / a,
            y: 1 - (e + o - n) / i,
            width: s / a,
            height: o / i,
          });
          break;
        case `180`:
          o = (e, t, o, s) => ({
            x: 1 - (e + o - n) / i,
            y: 1 - (t + s - r) / a,
            width: o / i,
            height: s / a,
          });
          break;
        case `270`:
          o = (e, t, o, s) => ({
            x: 1 - (t + s - r) / a,
            y: (e - n) / i,
            width: s / a,
            height: o / i,
          });
          break;
        default:
          o = (e, t, o, s) => ({
            x: (e - n) / i,
            y: (t - r) / a,
            width: o / i,
            height: s / a,
          });
          break;
      }
      let s = [];
      for (let e = 0, n = t.rangeCount; e < n; e++) {
        let n = t.getRangeAt(e);
        if (!n.collapsed)
          for (let { x: e, y: t, width: r, height: i } of n.getClientRects())
            r === 0 || i === 0 || s.push(o(e, t, r, i));
      }
      return s.length === 0 ? null : s;
    }
    addChangedExistingAnnotation({ annotationElementId: e, id: t }) {
      (this.#c ||= new Map()).set(e, t);
    }
    removeChangedExistingAnnotation({ annotationElementId: e }) {
      this.#c?.delete(e);
    }
    renderAnnotationElement(e) {
      let t = this.#c?.get(e.data.id);
      if (!t) return;
      let n = this.#s.getRawValue(t);
      n && ((this.#I === h0.NONE && !n.hasBeenModified) || n.renderAnnotationElement(e));
    }
    setMissingCanvas(e, t, n) {
      let r = this.#P?.get(e);
      r && (r.setCanvas(t, n), this.#P.delete(e));
    }
    addMissingCanvas(e, t) {
      (this.#P ||= new Map()).set(e, t);
    }
  },
  $2 = class e {
    #e = null;
    #t = !1;
    #n = null;
    #r = null;
    #i = null;
    #a = null;
    #o = !1;
    #s = null;
    #c = null;
    #l = null;
    #u = null;
    #d = !1;
    static #f = null;
    static _l10n = null;
    constructor(t) {
      ((this.#c = t),
        (this.#d = t._uiManager.useNewAltTextFlow),
        (e.#f ||= Object.freeze({
          added: `pdfjs-editor-new-alt-text-added-button`,
          "added-label": `pdfjs-editor-new-alt-text-added-button-label`,
          missing: `pdfjs-editor-new-alt-text-missing-button`,
          "missing-label": `pdfjs-editor-new-alt-text-missing-button-label`,
          review: `pdfjs-editor-new-alt-text-to-review-button`,
          "review-label": `pdfjs-editor-new-alt-text-to-review-button-label`,
        })));
    }
    static initialize(t) {
      e._l10n ??= t;
    }
    async render() {
      let t = (this.#n = document.createElement(`button`));
      ((t.className = `altText`), (t.tabIndex = `0`));
      let n = (this.#r = document.createElement(`span`));
      (t.append(n),
        this.#d
          ? (t.classList.add(`new`),
            t.setAttribute(`data-l10n-id`, e.#f.missing),
            n.setAttribute(`data-l10n-id`, e.#f[`missing-label`]))
          : (t.setAttribute(`data-l10n-id`, `pdfjs-editor-alt-text-button`),
            n.setAttribute(`data-l10n-id`, `pdfjs-editor-alt-text-button-label`)));
      let r = this.#c._uiManager._signal;
      (t.addEventListener(`contextmenu`, b2, {
        signal: r,
      }),
        t.addEventListener(`pointerdown`, (e) => e.stopPropagation(), {
          signal: r,
        }));
      let i = (e) => {
        (e.preventDefault(),
          this.#c._uiManager.editAltText(this.#c),
          this.#d &&
            this.#c._reportTelemetry({
              action: `pdfjs.image.alt_text.image_status_label_clicked`,
              data: {
                label: this.#p,
              },
            }));
      };
      return (
        t.addEventListener(`click`, i, {
          capture: !0,
          signal: r,
        }),
        t.addEventListener(
          `keydown`,
          (e) => {
            e.target === t && e.key === `Enter` && ((this.#o = !0), i(e));
          },
          {
            signal: r,
          },
        ),
        await this.#m(),
        t
      );
    }
    get #p() {
      return (
        (this.#e && `added`) || (this.#e === null && this.guessedText && `review`) || `missing`
      );
    }
    finish() {
      this.#n &&
        (this.#n.focus({
          focusVisible: this.#o,
        }),
        (this.#o = !1));
    }
    isEmpty() {
      return this.#d ? this.#e === null : !this.#e && !this.#t;
    }
    hasData() {
      return this.#d ? this.#e !== null || !!this.#l : this.isEmpty();
    }
    get guessedText() {
      return this.#l;
    }
    async setGuessedText(t) {
      this.#e === null &&
        ((this.#l = t),
        (this.#u = await e._l10n.get(
          `pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer`,
          {
            generatedAltText: t,
          },
        )),
        this.#m());
    }
    toggleAltTextBadge(e = !1) {
      if (!this.#d || this.#e) {
        (this.#s?.remove(), (this.#s = null));
        return;
      }
      if (!this.#s) {
        let e = (this.#s = document.createElement(`div`));
        ((e.className = `noAltTextBadge`), this.#c.div.append(e));
      }
      this.#s.classList.toggle(`hidden`, !e);
    }
    serialize(e) {
      let t = this.#e;
      return (
        !e && this.#l === t && (t = this.#u),
        {
          altText: t,
          decorative: this.#t,
          guessedText: this.#l,
          textWithDisclaimer: this.#u,
        }
      );
    }
    get data() {
      return {
        altText: this.#e,
        decorative: this.#t,
      };
    }
    set data({ altText: e, decorative: t, guessedText: n, textWithDisclaimer: r, cancel: i = !1 }) {
      (n && ((this.#l = n), (this.#u = r)),
        !(this.#e === e && this.#t === t) && (i || ((this.#e = e), (this.#t = t)), this.#m()));
    }
    toggle(e = !1) {
      this.#n &&
        (!e && this.#a && (clearTimeout(this.#a), (this.#a = null)), (this.#n.disabled = !e));
    }
    shown() {
      this.#c._reportTelemetry({
        action: `pdfjs.image.alt_text.image_status_label_displayed`,
        data: {
          label: this.#p,
        },
      });
    }
    destroy() {
      (this.#n?.remove(),
        (this.#n = null),
        (this.#r = null),
        (this.#i = null),
        this.#s?.remove(),
        (this.#s = null));
    }
    async #m() {
      let t = this.#n;
      if (!t) return;
      if (this.#d) {
        if (
          (t.classList.toggle(`done`, !!this.#e),
          t.setAttribute(`data-l10n-id`, e.#f[this.#p]),
          this.#r?.setAttribute(`data-l10n-id`, e.#f[`${this.#p}-label`]),
          !this.#e)
        ) {
          this.#i?.remove();
          return;
        }
      } else {
        if (!this.#e && !this.#t) {
          (t.classList.remove(`done`), this.#i?.remove());
          return;
        }
        (t.classList.add(`done`),
          t.setAttribute(`data-l10n-id`, `pdfjs-editor-alt-text-edit-button`));
      }
      let n = this.#i;
      if (!n) {
        ((this.#i = n = document.createElement(`span`)),
          (n.className = `tooltip`),
          n.setAttribute(`role`, `tooltip`),
          (n.id = `alt-text-tooltip-${this.#c.id}`));
        let e = this.#c._uiManager._signal;
        (e.addEventListener(
          `abort`,
          () => {
            (clearTimeout(this.#a), (this.#a = null));
          },
          {
            once: !0,
          },
        ),
          t.addEventListener(
            `mouseenter`,
            () => {
              this.#a = setTimeout(() => {
                ((this.#a = null),
                  this.#i.classList.add(`show`),
                  this.#c._reportTelemetry({
                    action: `alt_text_tooltip`,
                  }));
              }, 100);
            },
            {
              signal: e,
            },
          ),
          t.addEventListener(
            `mouseleave`,
            () => {
              ((this.#a &&= (clearTimeout(this.#a), null)), this.#i?.classList.remove(`show`));
            },
            {
              signal: e,
            },
          ));
      }
      (this.#t
        ? n.setAttribute(`data-l10n-id`, `pdfjs-editor-alt-text-decorative-tooltip`)
        : (n.removeAttribute(`data-l10n-id`), (n.textContent = this.#e)),
        n.parentNode || t.append(n),
        this.#c.getElementForAltText()?.setAttribute(`aria-describedby`, n.id));
    }
  },
  e4 = class {
    #e = null;
    #t = null;
    #n = !1;
    #r = null;
    #i = null;
    #a = null;
    #o = null;
    #s = null;
    #c = !1;
    #l = null;
    constructor(e) {
      this.#r = e;
    }
    renderForToolbar() {
      let e = (this.#t = document.createElement(`button`));
      return ((e.className = `comment`), this.#u(e, !1));
    }
    renderForStandalone() {
      let e = (this.#e = document.createElement(`button`));
      e.className = `annotationCommentButton`;
      let t = this.#r.commentButtonPosition;
      if (t) {
        let { style: n } = e;
        ((n.insetInlineEnd = `calc(${100 * (this.#r._uiManager.direction === `ltr` ? 1 - t[0] : t[0])}% - var(--comment-button-dim))`),
          (n.top = `calc(${100 * t[1]}% - var(--comment-button-dim))`));
        let r = this.#r.commentButtonColor;
        r && (n.backgroundColor = r);
      }
      return this.#u(e, !0);
    }
    focusButton() {
      setTimeout(() => {
        (this.#e ?? this.#t)?.focus();
      }, 0);
    }
    onUpdatedColor() {
      if (!this.#e) return;
      let e = this.#r.commentButtonColor;
      (e && (this.#e.style.backgroundColor = e), this.#r._uiManager.updatePopupColor(this.#r));
    }
    get commentButtonWidth() {
      return (
        (this.#e?.getBoundingClientRect().width ?? 0) / this.#r.parent.boundingClientRect.width
      );
    }
    get commentPopupPositionInLayer() {
      if (this.#l) return this.#l;
      if (!this.#e) return null;
      let { x: e, y: t, height: n } = this.#e.getBoundingClientRect(),
        { x: r, y: i, width: a, height: o } = this.#r.parent.boundingClientRect;
      return [(e - r) / a, (t + n - i) / o];
    }
    set commentPopupPositionInLayer(e) {
      this.#l = e;
    }
    hasDefaultPopupPosition() {
      return this.#l === null;
    }
    removeStandaloneCommentButton() {
      (this.#e?.remove(), (this.#e = null));
    }
    removeToolbarCommentButton() {
      (this.#t?.remove(), (this.#t = null));
    }
    setCommentButtonStates({ selected: e, hasPopup: t }) {
      this.#e && (this.#e.classList.toggle(`selected`, e), (this.#e.ariaExpanded = t));
    }
    #u(e, t) {
      if (!this.#r._uiManager.hasCommentManager()) return null;
      ((e.tabIndex = `0`),
        (e.ariaHasPopup = `dialog`),
        t
          ? ((e.ariaControls = `commentPopup`),
            e.setAttribute(`data-l10n-id`, `pdfjs-show-comment-button`))
          : ((e.ariaControlsElements = [this.#r._uiManager.getCommentDialogElement()]),
            e.setAttribute(`data-l10n-id`, `pdfjs-editor-add-comment-button`)));
      let n = this.#r._uiManager._signal;
      if (!(n instanceof AbortSignal) || n.aborted) return e;
      (e.addEventListener(`contextmenu`, b2, {
        signal: n,
      }),
        t &&
          (e.addEventListener(
            `focusin`,
            (e) => {
              ((this.#r._focusEventsAllowed = !1), x2(e));
            },
            {
              capture: !0,
              signal: n,
            },
          ),
          e.addEventListener(
            `focusout`,
            (e) => {
              ((this.#r._focusEventsAllowed = !0), x2(e));
            },
            {
              capture: !0,
              signal: n,
            },
          )),
        e.addEventListener(`pointerdown`, (e) => e.stopPropagation(), {
          signal: n,
        }));
      let r = (t) => {
        (t.preventDefault(), e === this.#t ? this.edit() : this.#r.toggleComment(!0));
      };
      return (
        e.addEventListener(`click`, r, {
          capture: !0,
          signal: n,
        }),
        e.addEventListener(
          `keydown`,
          (t) => {
            t.target === e && t.key === `Enter` && ((this.#n = !0), r(t));
          },
          {
            signal: n,
          },
        ),
        e.addEventListener(
          `pointerenter`,
          () => {
            this.#r.toggleComment(!1, !0);
          },
          {
            signal: n,
          },
        ),
        e.addEventListener(
          `pointerleave`,
          () => {
            this.#r.toggleComment(!1, !1);
          },
          {
            signal: n,
          },
        ),
        e
      );
    }
    edit(e) {
      let t = this.commentPopupPositionInLayer,
        n,
        r;
      if (t) [n, r] = t;
      else {
        [n, r] = this.#r.commentButtonPosition;
        let { width: e, height: t, x: i, y: a } = this.#r;
        ((n = i + n * e), (r = a + r * t));
      }
      let i = this.#r.parent.boundingClientRect,
        { x: a, y: o, width: s, height: c } = i;
      this.#r._uiManager.editComment(this.#r, a + n * s, o + r * c, {
        ...e,
        parentDimensions: i,
      });
    }
    finish() {
      this.#t &&
        (this.#t.focus({
          focusVisible: this.#n,
        }),
        (this.#n = !1));
    }
    isDeleted() {
      return this.#c || this.#o === ``;
    }
    isEmpty() {
      return this.#o === null;
    }
    hasBeenEdited() {
      return this.isDeleted() || this.#o !== this.#i;
    }
    serialize() {
      return this.data;
    }
    get data() {
      return {
        text: this.#o,
        richText: this.#a,
        date: this.#s,
        deleted: this.isDeleted(),
      };
    }
    set data(e) {
      if ((e !== this.#o && (this.#a = null), e === null)) {
        ((this.#o = ``), (this.#c = !0));
        return;
      }
      ((this.#o = e), (this.#s = new Date()), (this.#c = !1));
    }
    restoreData({ text: e, richText: t, date: n }) {
      ((this.#o = e), (this.#a = t), (this.#s = n), (this.#c = !1));
    }
    setInitialText(e, t = null) {
      ((this.#i = e), (this.data = e), (this.#s = null), (this.#a = t));
    }
    shown() {}
    destroy() {
      (this.#t?.remove(),
        (this.#t = null),
        this.#e?.remove(),
        (this.#e = null),
        (this.#o = ``),
        (this.#a = null),
        (this.#s = null),
        (this.#r = null),
        (this.#n = !1),
        (this.#c = !1));
    }
  },
  t4 = class e {
    #e;
    #t = !1;
    #n = null;
    #r;
    #i;
    #a;
    #o;
    #s = null;
    #c;
    #l = null;
    #u;
    #d = null;
    constructor({
      container: e,
      isPinchingDisabled: t = null,
      isPinchingStopped: n = null,
      onPinchStart: r = null,
      onPinching: i = null,
      onPinchEnd: a = null,
      signal: o,
    }) {
      ((this.#e = e),
        (this.#n = n),
        (this.#r = t),
        (this.#i = r),
        (this.#a = i),
        (this.#o = a),
        (this.#u = new AbortController()),
        (this.#c = AbortSignal.any([o, this.#u.signal])),
        e.addEventListener(`touchstart`, this.#f.bind(this), {
          passive: !1,
          signal: this.#c,
        }));
    }
    get MIN_TOUCH_DISTANCE_TO_PINCH() {
      return 35 / j2.pixelRatio;
    }
    #f(e) {
      if (this.#r?.()) return;
      if (e.touches.length === 1) {
        if (this.#s) return;
        let e = (this.#s = new AbortController()),
          t = AbortSignal.any([this.#c, e.signal]),
          n = this.#e,
          r = {
            capture: !0,
            signal: t,
            passive: !1,
          },
          i = (e) => {
            e.pointerType === `touch` && (this.#s?.abort(), (this.#s = null));
          };
        (n.addEventListener(
          `pointerdown`,
          (e) => {
            e.pointerType === `touch` && (x2(e), i(e));
          },
          r,
        ),
          n.addEventListener(`pointerup`, i, r),
          n.addEventListener(`pointercancel`, i, r));
        return;
      }
      if (!this.#d) {
        this.#d = new AbortController();
        let e = AbortSignal.any([this.#c, this.#d.signal]),
          t = this.#e,
          n = {
            signal: e,
            capture: !1,
            passive: !1,
          };
        t.addEventListener(`touchmove`, this.#p.bind(this), n);
        let r = this.#m.bind(this);
        (t.addEventListener(`touchend`, r, n),
          t.addEventListener(`touchcancel`, r, n),
          (n.capture = !0),
          t.addEventListener(`pointerdown`, x2, n),
          t.addEventListener(`pointermove`, x2, n),
          t.addEventListener(`pointercancel`, x2, n),
          t.addEventListener(`pointerup`, x2, n),
          this.#i?.());
      }
      if ((x2(e), e.touches.length !== 2 || this.#n?.())) {
        this.#l = null;
        return;
      }
      let [t, n] = e.touches;
      (t.identifier > n.identifier && ([t, n] = [n, t]),
        (this.#l = {
          touch0X: t.screenX,
          touch0Y: t.screenY,
          touch1X: n.screenX,
          touch1Y: n.screenY,
        }));
    }
    #p(t) {
      if (!this.#l || t.touches.length !== 2) return;
      x2(t);
      let [n, r] = t.touches;
      n.identifier > r.identifier && ([n, r] = [r, n]);
      let { screenX: i, screenY: a } = n,
        { screenX: o, screenY: s } = r,
        c = this.#l,
        { touch0X: l, touch0Y: u, touch1X: d, touch1Y: f } = c,
        p = d - l,
        m = f - u,
        h = o - i,
        g = s - a,
        v = Math.hypot(h, g) || 1,
        y = Math.hypot(p, m) || 1;
      if (!this.#t && Math.abs(y - v) <= e.MIN_TOUCH_DISTANCE_TO_PINCH) return;
      if (((c.touch0X = i), (c.touch0Y = a), (c.touch1X = o), (c.touch1Y = s), !this.#t)) {
        this.#t = !0;
        return;
      }
      let b = [(i + o) / 2, (a + s) / 2];
      this.#a?.(b, y, v);
    }
    #m(e) {
      e.touches.length >= 2 ||
        (this.#d && (this.#d.abort(), (this.#d = null), this.#o?.()),
        this.#l && (x2(e), (this.#l = null), (this.#t = !1)));
    }
    destroy() {
      (this.#u?.abort(), (this.#u = null), this.#s?.abort(), (this.#s = null));
    }
  },
  n4 = class e {
    #e = null;
    #t = null;
    #n = null;
    #r = null;
    #i = null;
    #a = !1;
    #o = null;
    #s = ``;
    #c = null;
    #l = null;
    #u = null;
    #d = null;
    #f = null;
    #p = ``;
    #m = !1;
    #h = null;
    #g = !1;
    #_ = !1;
    #v = !1;
    #y = null;
    #b = 0;
    #x = 0;
    #S = null;
    #C = null;
    isSelected = !1;
    _isCopy = !1;
    _editToolbar = null;
    _initialOptions = Object.create(null);
    _initialData = null;
    _isVisible = !0;
    _uiManager = null;
    _focusEventsAllowed = !0;
    static _l10n = null;
    static _l10nResizer = null;
    #w = !1;
    #T = e._zIndex++;
    static _borderLineWidth = -1;
    static _colorManager = new ise();
    static _zIndex = 1;
    static _telemetryTimeout = 1e3;
    static get _resizerKeyboardManager() {
      let t = e.prototype._resizeWithKeyboard,
        n = Q2.TRANSLATE_SMALL,
        r = Q2.TRANSLATE_BIG;
      return L0(
        this,
        `_resizerKeyboardManager`,
        new Z2([
          [
            [`ArrowLeft`, `mac+ArrowLeft`],
            t,
            {
              args: [-n, 0],
            },
          ],
          [
            [`ctrl+ArrowLeft`, `mac+shift+ArrowLeft`],
            t,
            {
              args: [-r, 0],
            },
          ],
          [
            [`ArrowRight`, `mac+ArrowRight`],
            t,
            {
              args: [n, 0],
            },
          ],
          [
            [`ctrl+ArrowRight`, `mac+shift+ArrowRight`],
            t,
            {
              args: [r, 0],
            },
          ],
          [
            [`ArrowUp`, `mac+ArrowUp`],
            t,
            {
              args: [0, -n],
            },
          ],
          [
            [`ctrl+ArrowUp`, `mac+shift+ArrowUp`],
            t,
            {
              args: [0, -r],
            },
          ],
          [
            [`ArrowDown`, `mac+ArrowDown`],
            t,
            {
              args: [0, n],
            },
          ],
          [
            [`ctrl+ArrowDown`, `mac+shift+ArrowDown`],
            t,
            {
              args: [0, r],
            },
          ],
          [[`Escape`, `mac+Escape`], e.prototype._stopResizingWithKeyboard],
        ]),
      );
    }
    constructor(e) {
      ((this.parent = e.parent),
        (this.id = e.id),
        (this.width = this.height = null),
        (this.pageIndex = e.parent.pageIndex),
        (this.name = e.name),
        (this.div = null),
        (this._uiManager = e.uiManager),
        (this.annotationElementId = null),
        (this._willKeepAspectRatio = !1),
        (this._initialOptions.isCentered = e.isCentered),
        (this._structTreeParentId = null),
        (this.annotationElementId = e.annotationElementId || null),
        (this.creationDate = e.creationDate || new Date()),
        (this.modificationDate = e.modificationDate || null),
        (this.canAddComment = !0));
      let {
        rotation: t,
        rawDims: { pageWidth: n, pageHeight: r, pageX: i, pageY: a },
      } = this.parent.viewport;
      ((this.rotation = t),
        (this.pageRotation = (360 + t - this._uiManager.viewParameters.rotation) % 360),
        (this.pageDimensions = [n, r]),
        (this.pageTranslation = [i, a]));
      let [o, s] = this.parentDimensions;
      ((this.x = e.x / o), (this.y = e.y / s), (this.isAttachedToDOM = !1), (this.deleted = !1));
    }
    updatePageIndex(e) {
      this.pageIndex = e;
    }
    get editorType() {
      return Object.getPrototypeOf(this).constructor._type;
    }
    get mode() {
      return Object.getPrototypeOf(this).constructor._editorType;
    }
    static get isDrawer() {
      return !1;
    }
    static get _defaultLineColor() {
      return L0(this, `_defaultLineColor`, this._colorManager.getHexCode(`CanvasText`));
    }
    static deleteAnnotationElement(e) {
      let t = new ase({
        id: e._uiManager.getId(),
        parent: e.parent,
        uiManager: e._uiManager,
      });
      ((t.annotationElementId = e.annotationElementId),
        (t.deleted = !0),
        t._uiManager.addToAnnotationStorage(t));
    }
    static initialize(t, n) {
      if (
        ((e._l10n ??= t),
        (e._l10nResizer ||= Object.freeze({
          topLeft: `pdfjs-editor-resizer-top-left`,
          topMiddle: `pdfjs-editor-resizer-top-middle`,
          topRight: `pdfjs-editor-resizer-top-right`,
          middleRight: `pdfjs-editor-resizer-middle-right`,
          bottomRight: `pdfjs-editor-resizer-bottom-right`,
          bottomMiddle: `pdfjs-editor-resizer-bottom-middle`,
          bottomLeft: `pdfjs-editor-resizer-bottom-left`,
          middleLeft: `pdfjs-editor-resizer-middle-left`,
        })),
        e._borderLineWidth !== -1)
      )
        return;
      let r = getComputedStyle(document.documentElement);
      e._borderLineWidth = parseFloat(r.getPropertyValue(`--outline-width`)) || 0;
    }
    static updateDefaultParams(e, t) {}
    static get defaultPropertiesToUpdate() {
      return [];
    }
    static isHandlingMimeForPasting(e) {
      return !1;
    }
    static paste(e, t) {
      j0(`Not implemented`);
    }
    get propertiesToUpdate() {
      return [];
    }
    get _isDraggable() {
      return this.#w;
    }
    set _isDraggable(e) {
      ((this.#w = e), this.div?.classList.toggle(`draggable`, e));
    }
    get uid() {
      return this.annotationElementId || this.id;
    }
    get isEnterHandled() {
      return !0;
    }
    center() {
      let [e, t] = this.pageDimensions;
      switch (this.parentRotation) {
        case 90:
          ((this.x -= (this.height * t) / (e * 2)), (this.y += (this.width * e) / (t * 2)));
          break;
        case 180:
          ((this.x += this.width / 2), (this.y += this.height / 2));
          break;
        case 270:
          ((this.x += (this.height * t) / (e * 2)), (this.y -= (this.width * e) / (t * 2)));
          break;
        default:
          ((this.x -= this.width / 2), (this.y -= this.height / 2));
          break;
      }
      this.fixAndSetPosition();
    }
    addCommands(e) {
      this._uiManager.addCommands(e);
    }
    get currentLayer() {
      return this._uiManager.currentLayer;
    }
    setInBackground() {
      this.div.style.zIndex = 0;
    }
    setInForeground() {
      this.div.style.zIndex = this.#T;
    }
    setParent(e) {
      (e === null
        ? (this.#W(), this.#d?.remove(), (this.#d = null))
        : ((this.pageIndex = e.pageIndex), (this.pageDimensions = e.pageDimensions)),
        (this.parent = e));
    }
    focusin(e) {
      this._focusEventsAllowed && (this.#m ? (this.#m = !1) : this.parent.setSelected(this));
    }
    focusout(e) {
      this._focusEventsAllowed &&
        this.isAttachedToDOM &&
        (e.relatedTarget?.closest(`#${this.id}`) ||
          (e.preventDefault(), this.parent?.isMultipleSelection || this.commitOrRemove()));
    }
    commitOrRemove() {
      this.isEmpty() ? this.remove() : this.commit();
    }
    commit() {
      this.isInEditMode() && this.addToAnnotationStorage();
    }
    addToAnnotationStorage() {
      this._uiManager.addToAnnotationStorage(this);
    }
    setAt(e, t, n, r) {
      let [i, a] = this.parentDimensions;
      (([n, r] = this.screenToPageTranslation(n, r)),
        (this.x = (e + n) / i),
        (this.y = (t + r) / a),
        this.fixAndSetPosition());
    }
    _moveAfterPaste(e, t) {
      if (this.isClone) {
        delete this.isClone;
        return;
      }
      let [n, r] = this.parentDimensions;
      (this.setAt(e * n, t * r, this.width * n, this.height * r), this._onTranslated());
    }
    #E([e, t], n, r) {
      (([n, r] = this.screenToPageTranslation(n, r)),
        (this.x += n / e),
        (this.y += r / t),
        this._onTranslating(this.x, this.y),
        this.fixAndSetPosition());
    }
    translate(e, t) {
      this.#E(this.parentDimensions, e, t);
    }
    translateInPage(e, t) {
      ((this.#h ||= [this.x, this.y, this.width, this.height]),
        this.#E(this.pageDimensions, e, t),
        this.div.scrollIntoView({
          block: `nearest`,
        }));
    }
    translationDone() {
      this._onTranslated(this.x, this.y);
    }
    drag(e, t) {
      this.#h ||= [this.x, this.y, this.width, this.height];
      let {
        div: n,
        parentDimensions: [r, i],
      } = this;
      if (
        ((this.x += e / r),
        (this.y += t / i),
        this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1))
      ) {
        let { x: e, y: t } = this.div.getBoundingClientRect();
        this.parent.findNewParent(this, e, t) &&
          ((this.x -= Math.floor(this.x)), (this.y -= Math.floor(this.y)));
      }
      let { x: a, y: o } = this,
        [s, c] = this.getBaseTranslation();
      ((a += s), (o += c));
      let { style: l } = n;
      ((l.left = `${(100 * a).toFixed(2)}%`),
        (l.top = `${(100 * o).toFixed(2)}%`),
        this._onTranslating(a, o),
        n.scrollIntoView({
          block: `nearest`,
        }));
    }
    _onTranslating(e, t) {}
    _onTranslated(e, t) {}
    get _hasBeenMoved() {
      return !!this.#h && (this.#h[0] !== this.x || this.#h[1] !== this.y);
    }
    get _hasBeenResized() {
      return !!this.#h && (this.#h[2] !== this.width || this.#h[3] !== this.height);
    }
    getBaseTranslation() {
      let [t, n] = this.parentDimensions,
        { _borderLineWidth: r } = e,
        i = r / t,
        a = r / n;
      switch (this.rotation) {
        case 90:
          return [-i, a];
        case 180:
          return [i, a];
        case 270:
          return [i, -a];
        default:
          return [-i, -a];
      }
    }
    get _mustFixPosition() {
      return !0;
    }
    fixAndSetPosition(e = this.rotation) {
      let {
          div: { style: t },
          pageDimensions: [n, r],
        } = this,
        { x: i, y: a, width: o, height: s } = this;
      if (((o *= n), (s *= r), (i *= n), (a *= r), this._mustFixPosition))
        switch (e) {
          case 0:
            ((i = o2(i, 0, n - o)), (a = o2(a, 0, r - s)));
            break;
          case 90:
            ((i = o2(i, 0, n - s)), (a = o2(a, o, r)));
            break;
          case 180:
            ((i = o2(i, o, n)), (a = o2(a, s, r)));
            break;
          case 270:
            ((i = o2(i, s, n)), (a = o2(a, 0, r - o)));
            break;
        }
      ((this.x = i /= n), (this.y = a /= r));
      let [c, l] = this.getBaseTranslation();
      ((i += c),
        (a += l),
        (t.left = `${(100 * i).toFixed(2)}%`),
        (t.top = `${(100 * a).toFixed(2)}%`),
        this.moveInDOM());
    }
    static #D(e, t, n) {
      switch (n) {
        case 90:
          return [t, -e];
        case 180:
          return [-e, -t];
        case 270:
          return [-t, e];
        default:
          return [e, t];
      }
    }
    screenToPageTranslation(t, n) {
      return e.#D(t, n, this.parentRotation);
    }
    pageTranslationToScreen(t, n) {
      return e.#D(t, n, 360 - this.parentRotation);
    }
    #O(e) {
      switch (e) {
        case 90: {
          let [e, t] = this.pageDimensions;
          return [0, -e / t, t / e, 0];
        }
        case 180:
          return [-1, 0, 0, -1];
        case 270: {
          let [e, t] = this.pageDimensions;
          return [0, e / t, -t / e, 0];
        }
        default:
          return [1, 0, 0, 1];
      }
    }
    get parentScale() {
      return this._uiManager.viewParameters.realScale;
    }
    get parentRotation() {
      return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
    get parentDimensions() {
      let {
        parentScale: e,
        pageDimensions: [t, n],
      } = this;
      return [t * e, n * e];
    }
    setDims() {
      let {
        div: { style: e },
        width: t,
        height: n,
      } = this;
      ((e.width = `${(100 * t).toFixed(2)}%`), (e.height = `${(100 * n).toFixed(2)}%`));
    }
    getInitialTranslation() {
      return [0, 0];
    }
    #k() {
      if (this.#c) return;
      ((this.#c = document.createElement(`div`)), this.#c.classList.add(`resizers`));
      let e = this._willKeepAspectRatio
          ? [`topLeft`, `topRight`, `bottomRight`, `bottomLeft`]
          : [
              `topLeft`,
              `topMiddle`,
              `topRight`,
              `middleRight`,
              `bottomRight`,
              `bottomMiddle`,
              `bottomLeft`,
              `middleLeft`,
            ],
        t = this._uiManager._signal;
      for (let n of e) {
        let e = document.createElement(`div`);
        (this.#c.append(e),
          e.classList.add(`resizer`, n),
          e.setAttribute(`data-resizer-name`, n),
          e.addEventListener(`pointerdown`, this.#A.bind(this, n), {
            signal: t,
          }),
          e.addEventListener(`contextmenu`, b2, {
            signal: t,
          }),
          (e.tabIndex = -1));
      }
      this.div.prepend(this.#c);
    }
    #A(e, t) {
      t.preventDefault();
      let { isMac: n } = J0.platform;
      if (t.button !== 0 || (t.ctrlKey && n)) return;
      this.#n?.toggle(!1);
      let r = this._isDraggable;
      ((this._isDraggable = !1), (this.#l = [t.screenX, t.screenY]));
      let i = new AbortController(),
        a = this._uiManager.combinedSignal(i);
      (this.parent.togglePointerEvents(!1),
        window.addEventListener(`pointermove`, this.#N.bind(this, e), {
          passive: !0,
          capture: !0,
          signal: a,
        }),
        window.addEventListener(`touchmove`, x2, {
          passive: !1,
          signal: a,
        }),
        window.addEventListener(`contextmenu`, b2, {
          signal: a,
        }),
        (this.#u = {
          savedX: this.x,
          savedY: this.y,
          savedWidth: this.width,
          savedHeight: this.height,
        }));
      let o = this.parent.div.style.cursor,
        s = this.div.style.cursor;
      this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(
        t.target,
      ).cursor;
      let c = () => {
        (i.abort(),
          this.parent.togglePointerEvents(!0),
          this.#n?.toggle(!0),
          (this._isDraggable = r),
          (this.parent.div.style.cursor = o),
          (this.div.style.cursor = s),
          this.#M());
      };
      (window.addEventListener(`pointerup`, c, {
        signal: a,
      }),
        window.addEventListener(`blur`, c, {
          signal: a,
        }));
    }
    #j(e, t, n, r) {
      ((this.width = n),
        (this.height = r),
        (this.x = e),
        (this.y = t),
        this.setDims(),
        this.fixAndSetPosition(),
        this._onResized());
    }
    _onResized() {}
    #M() {
      if (!this.#u) return;
      let { savedX: e, savedY: t, savedWidth: n, savedHeight: r } = this.#u;
      this.#u = null;
      let i = this.x,
        a = this.y,
        o = this.width,
        s = this.height;
      (i === e && a === t && o === n && s === r) ||
        this.addCommands({
          cmd: this.#j.bind(this, i, a, o, s),
          undo: this.#j.bind(this, e, t, n, r),
          mustExec: !0,
        });
    }
    static _round(e) {
      return Math.round(e * 1e4) / 1e4;
    }
    #N(t, n) {
      let [r, i] = this.parentDimensions,
        a = this.x,
        o = this.y,
        s = this.width,
        c = this.height,
        l = e.MIN_SIZE / r,
        u = e.MIN_SIZE / i,
        d = this.#O(this.rotation),
        f = (e, t) => [d[0] * e + d[2] * t, d[1] * e + d[3] * t],
        p = this.#O(360 - this.rotation),
        m = (e, t) => [p[0] * e + p[2] * t, p[1] * e + p[3] * t],
        h,
        g,
        v = !1,
        y = !1;
      switch (t) {
        case `topLeft`:
          ((v = !0), (h = (e, t) => [0, 0]), (g = (e, t) => [e, t]));
          break;
        case `topMiddle`:
          ((h = (e, t) => [e / 2, 0]), (g = (e, t) => [e / 2, t]));
          break;
        case `topRight`:
          ((v = !0), (h = (e, t) => [e, 0]), (g = (e, t) => [0, t]));
          break;
        case `middleRight`:
          ((y = !0), (h = (e, t) => [e, t / 2]), (g = (e, t) => [0, t / 2]));
          break;
        case `bottomRight`:
          ((v = !0), (h = (e, t) => [e, t]), (g = (e, t) => [0, 0]));
          break;
        case `bottomMiddle`:
          ((h = (e, t) => [e / 2, t]), (g = (e, t) => [e / 2, 0]));
          break;
        case `bottomLeft`:
          ((v = !0), (h = (e, t) => [0, t]), (g = (e, t) => [e, 0]));
          break;
        case `middleLeft`:
          ((y = !0), (h = (e, t) => [0, t / 2]), (g = (e, t) => [e, t / 2]));
          break;
      }
      let b = h(s, c),
        x = g(s, c),
        S = f(...x),
        C = e._round(a + S[0]),
        w = e._round(o + S[1]),
        T = 1,
        E = 1,
        D,
        ee;
      if (n.fromKeyboard) ({ deltaX: D, deltaY: ee } = n);
      else {
        let { screenX: e, screenY: t } = n,
          [r, i] = this.#l;
        (([D, ee] = this.screenToPageTranslation(e - r, t - i)),
          (this.#l[0] = e),
          (this.#l[1] = t));
      }
      if ((([D, ee] = m(D / r, ee / i)), v)) {
        let e = Math.hypot(s, c);
        T = E = Math.max(
          Math.min(Math.hypot(x[0] - b[0] - D, x[1] - b[1] - ee) / e, 1 / s, 1 / c),
          l / s,
          u / c,
        );
      } else
        y
          ? (T = o2(Math.abs(x[0] - b[0] - D), l, 1) / s)
          : (E = o2(Math.abs(x[1] - b[1] - ee), u, 1) / c);
      let te = e._round(s * T),
        O = e._round(c * E);
      S = f(...g(te, O));
      let k = C - S[0],
        ne = w - S[1];
      ((this.#h ||= [this.x, this.y, this.width, this.height]),
        (this.width = te),
        (this.height = O),
        (this.x = k),
        (this.y = ne),
        this.setDims(),
        this.fixAndSetPosition(),
        this._onResizing());
    }
    _onResizing() {}
    altTextFinish() {
      this.#n?.finish();
    }
    get toolbarButtons() {
      return null;
    }
    async addEditToolbar() {
      if (this._editToolbar || this.#_) return this._editToolbar;
      ((this._editToolbar = new W2(this)), this.div.append(this._editToolbar.render()));
      let { toolbarButtons: e } = this;
      if (e) for (let [t, n] of e) await this._editToolbar.addButton(t, n);
      return (
        this.hasComment || this._editToolbar.addButton(`comment`, this.addCommentButton()),
        this._editToolbar.addButton(`delete`),
        this._editToolbar
      );
    }
    addCommentButtonInToolbar() {
      this._editToolbar?.addButtonBefore(`comment`, this.addCommentButton(), `.deleteButton`);
    }
    removeCommentButtonFromToolbar() {
      this._editToolbar?.removeButton(`comment`);
    }
    removeEditToolbar() {
      (this._editToolbar?.remove(), (this._editToolbar = null), this.#n?.destroy());
    }
    addContainer(e) {
      let t = this._editToolbar?.div;
      t ? t.before(e) : this.div.append(e);
    }
    getClientDimensions() {
      return this.div.getBoundingClientRect();
    }
    createAltText() {
      return (
        this.#n ||
          ($2.initialize(e._l10n),
          (this.#n = new $2(this)),
          (this.#e &&= ((this.#n.data = this.#e), null))),
        this.#n
      );
    }
    get altTextData() {
      return this.#n?.data;
    }
    set altTextData(e) {
      this.#n && (this.#n.data = e);
    }
    get guessedAltText() {
      return this.#n?.guessedText;
    }
    async setGuessedAltText(e) {
      await this.#n?.setGuessedText(e);
    }
    serializeAltText(e) {
      return this.#n?.serialize(e);
    }
    hasAltText() {
      return !!this.#n && !this.#n.isEmpty();
    }
    hasAltTextData() {
      return this.#n?.hasData() ?? !1;
    }
    focusCommentButton() {
      this.#r?.focusButton();
    }
    addCommentButton() {
      return this.canAddComment ? (this.#r ||= new e4(this)) : null;
    }
    addStandaloneCommentButton() {
      if (this._uiManager.hasCommentManager()) {
        if (this.#i) {
          this._uiManager.isEditingMode() && this.#i.classList.remove(`hidden`);
          return;
        }
        this.hasComment && ((this.#i = this.#r.renderForStandalone()), this.div.append(this.#i));
      }
    }
    removeStandaloneCommentButton() {
      (this.#r.removeStandaloneCommentButton(), (this.#i = null));
    }
    hideStandaloneCommentButton() {
      this.#i?.classList.add(`hidden`);
    }
    get comment() {
      if (!this.#r) return null;
      let {
        data: { richText: e, text: t, date: n, deleted: r },
      } = this.#r;
      return {
        text: t,
        richText: e,
        date: n,
        deleted: r,
        color: this.getNonHCMColor(),
        opacity: this.opacity ?? 1,
      };
    }
    set comment(e) {
      ((this.#r ||= new e4(this)),
        typeof e == `object` && e ? this.#r.restoreData(e) : (this.#r.data = e),
        this.hasComment
          ? (this.removeCommentButtonFromToolbar(),
            this.addStandaloneCommentButton(),
            this._uiManager.updateComment(this))
          : (this.addCommentButtonInToolbar(),
            this.removeStandaloneCommentButton(),
            this._uiManager.removeComment(this)));
    }
    setCommentData({ comment: e, popupRef: t, richText: n }) {
      if (
        !t ||
        ((this.#r ||= new e4(this)), this.#r.setInitialText(e, n), !this.annotationElementId)
      )
        return;
      let r = this._uiManager.getAndRemoveDataFromAnnotationStorage(this.annotationElementId);
      r && this.updateFromAnnotationLayer(r);
    }
    get hasEditedComment() {
      return this.#r?.hasBeenEdited();
    }
    get hasDeletedComment() {
      return this.#r?.isDeleted();
    }
    get hasComment() {
      return !!this.#r && !this.#r.isEmpty() && !this.#r.isDeleted();
    }
    async editComment(e) {
      ((this.#r ||= new e4(this)), this.#r.edit(e));
    }
    toggleComment(e, t = void 0) {
      this.hasComment && this._uiManager.toggleComment(this, e, t);
    }
    setSelectedCommentButton(e) {
      this.#r.setSelectedButton(e);
    }
    addComment(e) {
      if (this.hasEditedComment) {
        let [, , , t] = e.rect,
          [n] = this.pageDimensions,
          [r] = this.pageTranslation,
          i = r + n + 1,
          a = t - 100,
          o = i + 180;
        e.popup = {
          contents: this.comment.text,
          deleted: this.comment.deleted,
          rect: [i, a, o, t],
        };
      }
    }
    updateFromAnnotationLayer({ popup: { contents: e, deleted: t } }) {
      this.#r.data = t ? null : e;
    }
    get parentBoundingClientRect() {
      return this.parent.boundingClientRect;
    }
    render() {
      let e = (this.div = document.createElement(`div`));
      (e.setAttribute(`data-editor-rotation`, (360 - this.rotation) % 360),
        (e.className = this.name),
        e.setAttribute(`id`, this.id),
        (e.tabIndex = this.#a ? -1 : 0),
        e.setAttribute(`role`, `application`),
        this.defaultL10nId && e.setAttribute(`data-l10n-id`, this.defaultL10nId),
        this._isVisible || e.classList.add(`hidden`),
        this.setInForeground(),
        this.#z());
      let [t, n] = this.parentDimensions;
      this.parentRotation % 180 != 0 &&
        ((e.style.maxWidth = `${((100 * n) / t).toFixed(2)}%`),
        (e.style.maxHeight = `${((100 * t) / n).toFixed(2)}%`));
      let [r, i] = this.getInitialTranslation();
      return (
        this.translate(r, i),
        K2(this, e, [`keydown`, `pointerdown`, `dblclick`]),
        this.isResizable &&
          this._uiManager._supportsPinchToZoom &&
          (this.#C ||= new t4({
            container: e,
            isPinchingDisabled: () => !this.isSelected,
            onPinchStart: this.#P.bind(this),
            onPinching: this.#F.bind(this),
            onPinchEnd: this.#I.bind(this),
            signal: this._uiManager._signal,
          })),
        this.addStandaloneCommentButton(),
        this._uiManager._editorUndoBar?.hide(),
        e
      );
    }
    #P() {
      ((this.#u = {
        savedX: this.x,
        savedY: this.y,
        savedWidth: this.width,
        savedHeight: this.height,
      }),
        this.#n?.toggle(!1),
        this.parent.togglePointerEvents(!1));
    }
    #F(t, n, r) {
      let i = 0.7,
        a = (r / n) * i + 1 - i;
      if (a === 1) return;
      let o = this.#O(this.rotation),
        s = (e, t) => [o[0] * e + o[2] * t, o[1] * e + o[3] * t],
        [c, l] = this.parentDimensions,
        u = this.x,
        d = this.y,
        f = this.width,
        p = this.height,
        m = e.MIN_SIZE / c,
        h = e.MIN_SIZE / l;
      a = Math.max(Math.min(a, 1 / f, 1 / p), m / f, h / p);
      let g = e._round(f * a),
        v = e._round(p * a);
      if (g === f && v === p) return;
      this.#h ||= [u, d, f, p];
      let y = s(f / 2, p / 2),
        b = e._round(u + y[0]),
        x = e._round(d + y[1]),
        S = s(g / 2, v / 2);
      ((this.x = b - S[0]),
        (this.y = x - S[1]),
        (this.width = g),
        (this.height = v),
        this.setDims(),
        this.fixAndSetPosition(),
        this._onResizing());
    }
    #I() {
      (this.#n?.toggle(!0), this.parent.togglePointerEvents(!0), this.#M());
    }
    pointerdown(e) {
      let { isMac: t } = J0.platform;
      if (e.button !== 0 || (e.ctrlKey && t)) {
        e.preventDefault();
        return;
      }
      if (((this.#m = !0), this._isDraggable)) {
        this.#R(e);
        return;
      }
      this.#L(e);
    }
    #L(e) {
      let { isMac: t } = J0.platform;
      (e.ctrlKey && !t) || e.shiftKey || (e.metaKey && t)
        ? this.parent.toggleSelected(this)
        : this.parent.setSelected(this);
    }
    #R(e) {
      let { isSelected: t } = this;
      this._uiManager.setUpDragSession();
      let n = !1,
        r = new AbortController(),
        i = this._uiManager.combinedSignal(r),
        a = {
          capture: !0,
          passive: !1,
          signal: i,
        },
        o = (e) => {
          (r.abort(),
            (this.#o = null),
            (this.#m = !1),
            this._uiManager.endDragSession() || this.#L(e),
            n && this._onStopDragging());
        };
      t &&
        ((this.#b = e.clientX),
        (this.#x = e.clientY),
        (this.#o = e.pointerId),
        (this.#s = e.pointerType),
        window.addEventListener(
          `pointermove`,
          (e) => {
            n || ((n = !0), this._uiManager.toggleComment(this, !0, !1), this._onStartDragging());
            let { clientX: t, clientY: r, pointerId: i } = e;
            if (i !== this.#o) {
              x2(e);
              return;
            }
            let [a, o] = this.screenToPageTranslation(t - this.#b, r - this.#x);
            ((this.#b = t), (this.#x = r), this._uiManager.dragSelectedEditors(a, o));
          },
          a,
        ),
        window.addEventListener(`touchmove`, x2, a),
        window.addEventListener(
          `pointerdown`,
          (e) => {
            (e.pointerType === this.#s && (this.#C || e.isPrimary) && o(e), x2(e));
          },
          a,
        ));
      let s = (e) => {
        if (!this.#o || this.#o === e.pointerId) {
          o(e);
          return;
        }
        x2(e);
      };
      (window.addEventListener(`pointerup`, s, {
        signal: i,
      }),
        window.addEventListener(`blur`, s, {
          signal: i,
        }));
    }
    _onStartDragging() {}
    _onStopDragging() {}
    moveInDOM() {
      (this.#y && clearTimeout(this.#y),
        (this.#y = setTimeout(() => {
          ((this.#y = null), this.parent?.moveEditorInDOM(this));
        }, 0)));
    }
    _setParentAndPosition(e, t, n) {
      (e.changeParent(this),
        (this.x = t),
        (this.y = n),
        this.fixAndSetPosition(),
        this._onTranslated());
    }
    getRect(e, t, n = this.rotation) {
      let r = this.parentScale,
        [i, a] = this.pageDimensions,
        [o, s] = this.pageTranslation,
        c = e / r,
        l = t / r,
        u = this.x * i,
        d = this.y * a,
        f = this.width * i,
        p = this.height * a;
      switch (n) {
        case 0:
          return [u + c + o, a - d - l - p + s, u + c + f + o, a - d - l + s];
        case 90:
          return [u + l + o, a - d + c + s, u + l + p + o, a - d + c + f + s];
        case 180:
          return [u - c - f + o, a - d + l + s, u - c + o, a - d + l + p + s];
        case 270:
          return [u - l - p + o, a - d - c - f + s, u - l + o, a - d - c + s];
        default:
          throw Error(`Invalid rotation`);
      }
    }
    getRectInCurrentCoords(e, t) {
      let [n, r, i, a] = e,
        o = i - n,
        s = a - r;
      switch (this.rotation) {
        case 0:
          return [n, t - a, o, s];
        case 90:
          return [n, t - r, s, o];
        case 180:
          return [i, t - r, o, s];
        case 270:
          return [i, t - a, s, o];
        default:
          throw Error(`Invalid rotation`);
      }
    }
    getPDFRect() {
      return this.getRect(0, 0);
    }
    getNonHCMColor() {
      return this.color && e._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
    }
    onUpdatedColor() {
      this.#r?.onUpdatedColor();
    }
    getData() {
      let {
        comment: { text: e, color: t, date: n, opacity: r, deleted: i, richText: a },
        uid: o,
        pageIndex: s,
        creationDate: c,
        modificationDate: l,
      } = this;
      return {
        id: o,
        pageIndex: s,
        rect: this.getPDFRect(),
        richText: a,
        contentsObj: {
          str: e,
        },
        creationDate: c,
        modificationDate: n || l,
        popupRef: !i,
        color: t,
        opacity: r,
      };
    }
    onceAdded(e) {}
    isEmpty() {
      return !1;
    }
    enableEditMode() {
      return this.isInEditMode() ? !1 : (this.parent.setEditingState(!1), (this.#_ = !0), !0);
    }
    disableEditMode() {
      return this.isInEditMode() ? (this.parent.setEditingState(!0), (this.#_ = !1), !0) : !1;
    }
    isInEditMode() {
      return this.#_;
    }
    shouldGetKeyboardEvents() {
      return this.#v;
    }
    needsToBeRebuilt() {
      return this.div && !this.isAttachedToDOM;
    }
    get isOnScreen() {
      let { top: e, left: t, bottom: n, right: r } = this.getClientDimensions(),
        { innerHeight: i, innerWidth: a } = window;
      return t < a && r > 0 && e < i && n > 0;
    }
    #z() {
      if (this.#f || !this.div) return;
      this.#f = new AbortController();
      let e = this._uiManager.combinedSignal(this.#f);
      (this.div.addEventListener(`focusin`, this.focusin.bind(this), {
        signal: e,
      }),
        this.div.addEventListener(`focusout`, this.focusout.bind(this), {
          signal: e,
        }));
    }
    rebuild() {
      this.#z();
    }
    rotate(e) {}
    resize() {}
    serializeDeleted() {
      return {
        id: this.annotationElementId,
        deleted: !0,
        pageIndex: this.pageIndex,
        popupRef: this._initialData?.popupRef || ``,
      };
    }
    serialize(e = !1, t = null) {
      return {
        annotationType: this.mode,
        pageIndex: this.pageIndex,
        rect: this.getPDFRect(),
        rotation: this.rotation,
        structTreeParentId: this._structTreeParentId,
        popupRef: this._initialData?.popupRef || ``,
      };
    }
    static async deserialize(e, t, n) {
      let r = new this.prototype.constructor({
        parent: t,
        id: n.getId(),
        uiManager: n,
        annotationElementId: e.annotationElementId,
        creationDate: e.creationDate,
        modificationDate: e.modificationDate,
      });
      ((r.rotation = e.rotation), (r.#e = e.accessibilityData), (r._isCopy = e.isCopy || !1));
      let [i, a] = r.pageDimensions,
        [o, s, c, l] = r.getRectInCurrentCoords(e.rect, a);
      return ((r.x = o / i), (r.y = s / a), (r.width = c / i), (r.height = l / a), r);
    }
    get hasBeenModified() {
      return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
    remove() {
      if (
        (this.#f?.abort(),
        (this.#f = null),
        this.isEmpty() || this.commit(),
        this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this),
        this.hideCommentPopup(),
        (this.#y &&= (clearTimeout(this.#y), null)),
        this.#W(),
        this.removeEditToolbar(),
        this.#S)
      ) {
        for (let e of this.#S.values()) clearTimeout(e);
        this.#S = null;
      }
      ((this.parent = null),
        this.#C?.destroy(),
        (this.#C = null),
        this.#d?.remove(),
        (this.#d = null));
    }
    get isResizable() {
      return !1;
    }
    makeResizable() {
      this.isResizable && (this.#k(), this.#c.classList.remove(`hidden`));
    }
    get toolbarPosition() {
      return null;
    }
    get commentButtonPosition() {
      return this._uiManager.direction === `ltr` ? [1, 0] : [0, 0];
    }
    get commentButtonPositionInPage() {
      let {
          commentButtonPosition: [t, n],
        } = this,
        [r, i, a, o] = this.getPDFRect();
      return [e._round(r + (a - r) * t), e._round(i + (o - i) * (1 - n))];
    }
    get commentButtonColor() {
      return this._uiManager.makeCommentColor(this.getNonHCMColor(), this.opacity);
    }
    get commentPopupPosition() {
      return this.#r.commentPopupPositionInLayer;
    }
    set commentPopupPosition(e) {
      this.#r.commentPopupPositionInLayer = e;
    }
    hasDefaultPopupPosition() {
      return this.#r.hasDefaultPopupPosition();
    }
    get commentButtonWidth() {
      return this.#r.commentButtonWidth;
    }
    get elementBeforePopup() {
      return this.div;
    }
    setCommentButtonStates(e) {
      this.#r?.setCommentButtonStates(e);
    }
    keydown(t) {
      if (!this.isResizable || t.target !== this.div || t.key !== `Enter`) return;
      (this._uiManager.setSelected(this),
        (this.#u = {
          savedX: this.x,
          savedY: this.y,
          savedWidth: this.width,
          savedHeight: this.height,
        }));
      let n = this.#c.children;
      if (!this.#t) {
        this.#t = Array.from(n);
        let t = this.#B.bind(this),
          r = this.#V.bind(this),
          i = this._uiManager._signal;
        for (let n of this.#t) {
          let a = n.getAttribute(`data-resizer-name`);
          (n.setAttribute(`role`, `spinbutton`),
            n.addEventListener(`keydown`, t, {
              signal: i,
            }),
            n.addEventListener(`blur`, r, {
              signal: i,
            }),
            n.addEventListener(`focus`, this.#H.bind(this, a), {
              signal: i,
            }),
            n.setAttribute(`data-l10n-id`, e._l10nResizer[a]));
        }
      }
      let r = this.#t[0],
        i = 0;
      for (let e of n) {
        if (e === r) break;
        i++;
      }
      let a = (((360 - this.rotation + this.parentRotation) % 360) / 90) * (this.#t.length / 4);
      if (a !== i) {
        if (a < i) for (let e = 0; e < i - a; e++) this.#c.append(this.#c.firstElementChild);
        else if (a > i)
          for (let e = 0; e < a - i; e++)
            this.#c.firstElementChild.before(this.#c.lastElementChild);
        let t = 0;
        for (let r of n) {
          let n = this.#t[t++].getAttribute(`data-resizer-name`);
          r.setAttribute(`data-l10n-id`, e._l10nResizer[n]);
        }
      }
      (this.#U(0),
        (this.#v = !0),
        this.#c.firstElementChild.focus({
          focusVisible: !0,
        }),
        t.preventDefault(),
        t.stopImmediatePropagation());
    }
    #B(t) {
      e._resizerKeyboardManager.exec(this, t);
    }
    #V(e) {
      this.#v && e.relatedTarget?.parentNode !== this.#c && this.#W();
    }
    #H(e) {
      this.#p = this.#v ? e : ``;
    }
    #U(e) {
      if (this.#t) for (let t of this.#t) t.tabIndex = e;
    }
    _resizeWithKeyboard(e, t) {
      this.#v &&
        this.#N(this.#p, {
          deltaX: e,
          deltaY: t,
          fromKeyboard: !0,
        });
    }
    #W() {
      ((this.#v = !1), this.#U(-1), this.#M());
    }
    _stopResizingWithKeyboard() {
      (this.#W(), this.div.focus());
    }
    select() {
      if (this.isSelected && this._editToolbar) {
        this._editToolbar.show();
        return;
      }
      if (
        ((this.isSelected = !0),
        this.makeResizable(),
        this.div?.classList.add(`selectedEditor`),
        !this._editToolbar)
      ) {
        this.addEditToolbar().then(() => {
          this.div?.classList.contains(`selectedEditor`) && this._editToolbar?.show();
        });
        return;
      }
      (this._editToolbar?.show(), this.#n?.toggleAltTextBadge(!1));
    }
    focus() {
      this.div &&
        !this.div.contains(document.activeElement) &&
        setTimeout(
          () =>
            this.div?.focus({
              preventScroll: !0,
            }),
          0,
        );
    }
    unselect() {
      this.isSelected &&
        ((this.isSelected = !1),
        this.#c?.classList.add(`hidden`),
        this.div?.classList.remove(`selectedEditor`),
        this.div?.contains(document.activeElement) &&
          this._uiManager.currentLayer.div.focus({
            preventScroll: !0,
          }),
        this._editToolbar?.hide(),
        this.#n?.toggleAltTextBadge(!0),
        this.hideCommentPopup());
    }
    hideCommentPopup() {
      this.hasComment && this._uiManager.toggleComment(null);
    }
    updateParams(e, t) {}
    disableEditing() {}
    enableEditing() {}
    get canChangeContent() {
      return !1;
    }
    enterInEditMode() {
      this.canChangeContent && (this.enableEditMode(), this.div.focus());
    }
    dblclick(e) {
      e.target.nodeName !== `BUTTON` &&
        (this.enterInEditMode(),
        this.parent.updateToolbar({
          mode: this.constructor._editorType,
          editId: this.uid,
        }));
    }
    getElementForAltText() {
      return this.div;
    }
    get contentDiv() {
      return this.div;
    }
    get isEditing() {
      return this.#g;
    }
    set isEditing(e) {
      ((this.#g = e),
        this.parent &&
          (e
            ? (this.parent.setSelected(this), this.parent.setActiveEditor(this))
            : this.parent.setActiveEditor(null)));
    }
    static get MIN_SIZE() {
      return 16;
    }
    static canCreateNewEmptyEditor() {
      return !0;
    }
    get telemetryInitialData() {
      return {
        action: `added`,
      };
    }
    get telemetryFinalData() {
      return null;
    }
    _reportTelemetry(t, n = !1) {
      if (n) {
        this.#S ||= new Map();
        let { action: n } = t,
          r = this.#S.get(n);
        (r && clearTimeout(r),
          (r = setTimeout(() => {
            (this._reportTelemetry(t), this.#S.delete(n), this.#S.size === 0 && (this.#S = null));
          }, e._telemetryTimeout)),
          this.#S.set(n, r));
        return;
      }
      ((t.type ||= this.editorType),
        this._uiManager._eventBus.dispatch(`reporttelemetry`, {
          source: this,
          details: {
            type: `editing`,
            data: t,
          },
        }));
    }
    show(e = this._isVisible) {
      (this.div.classList.toggle(`hidden`, !e), (this._isVisible = e));
    }
    enable() {
      (this.div && (this.div.tabIndex = 0), (this.#a = !1));
    }
    disable() {
      (this.div && (this.div.tabIndex = -1), (this.#a = !0));
    }
    updateFakeAnnotationElement(e) {
      if (!this.#d && !this.deleted) {
        this.#d = e.addFakeAnnotation(this);
        return;
      }
      if (this.deleted) {
        (this.#d.remove(), (this.#d = null));
        return;
      }
      (this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized) &&
        this.#d.updateEdited({
          rect: this.getPDFRect(),
          popup: this.comment,
        });
    }
    renderAnnotationElement(e) {
      if (this.deleted) return (e.hide(), null);
      let t = e.container.querySelector(`.annotationContent`);
      if (!t)
        ((t = document.createElement(`div`)),
          t.classList.add(`annotationContent`, this.editorType),
          e.container.prepend(t));
      else if (t.nodeName === `CANVAS`) {
        let e = t;
        ((t = document.createElement(`div`)),
          t.classList.add(`annotationContent`, this.editorType),
          e.before(t));
      }
      return t;
    }
    resetAnnotationElement(e) {
      let { firstElementChild: t } = e.container;
      t?.nodeName === `DIV` && t.classList.contains(`annotationContent`) && t.remove();
    }
  },
  ase = class extends n4 {
    constructor(e) {
      (super(e), (this.annotationElementId = e.annotationElementId), (this.deleted = !0));
    }
    serialize() {
      return this.serializeDeleted();
    }
  },
  r4 = 3285377520,
  i4 = 4294901760,
  a4 = 65535,
  o4 = class {
    constructor(e) {
      ((this.h1 = e ? e & 4294967295 : r4), (this.h2 = e ? e & 4294967295 : r4));
    }
    update(e) {
      let t, n;
      if (typeof e == `string`) {
        ((t = new Uint8Array(e.length * 2)), (n = 0));
        for (let r = 0, i = e.length; r < i; r++) {
          let i = e.charCodeAt(r);
          i <= 255 ? (t[n++] = i) : ((t[n++] = i >>> 8), (t[n++] = i & 255));
        }
      } else if (ArrayBuffer.isView(e)) ((t = e.slice()), (n = t.byteLength));
      else throw Error(`Invalid data format, must be a string or TypedArray.`);
      let r = n >> 2,
        i = n - r * 4,
        a = new Uint32Array(t.buffer, 0, r),
        o = 0,
        s = 0,
        c = this.h1,
        l = this.h2,
        u = 3432918353,
        d = 461845907,
        f = 11601,
        p = 13715;
      for (let e = 0; e < r; e++)
        e & 1
          ? ((o = a[e]),
            (o = ((o * u) & i4) | ((o * f) & a4)),
            (o = (o << 15) | (o >>> 17)),
            (o = ((o * d) & i4) | ((o * p) & a4)),
            (c ^= o),
            (c = (c << 13) | (c >>> 19)),
            (c = c * 5 + 3864292196))
          : ((s = a[e]),
            (s = ((s * u) & i4) | ((s * f) & a4)),
            (s = (s << 15) | (s >>> 17)),
            (s = ((s * d) & i4) | ((s * p) & a4)),
            (l ^= s),
            (l = (l << 13) | (l >>> 19)),
            (l = l * 5 + 3864292196));
      switch (((o = 0), i)) {
        case 3:
          o ^= t[r * 4 + 2] << 16;
        case 2:
          o ^= t[r * 4 + 1] << 8;
        case 1:
          ((o ^= t[r * 4]),
            (o = ((o * u) & i4) | ((o * f) & a4)),
            (o = (o << 15) | (o >>> 17)),
            (o = ((o * d) & i4) | ((o * p) & a4)),
            r & 1 ? (c ^= o) : (l ^= o));
      }
      ((this.h1 = c), (this.h2 = l));
    }
    hexdigest() {
      let e = this.h1,
        t = this.h2;
      return (
        (e ^= t >>> 1),
        (e = ((e * 3981806797) & i4) | ((e * 36045) & a4)),
        (t = ((t * 4283543511) & i4) | (((((t << 16) | (e >>> 16)) * 2950163797) & i4) >>> 16)),
        (e ^= t >>> 1),
        (e = ((e * 444984403) & i4) | ((e * 60499) & a4)),
        (t = ((t * 3301882366) & i4) | (((((t << 16) | (e >>> 16)) * 3120437893) & i4) >>> 16)),
        (e ^= t >>> 1),
        (e >>> 0).toString(16).padStart(8, `0`) + (t >>> 0).toString(16).padStart(8, `0`)
      );
    }
  },
  s4 = Object.freeze({
    map: null,
    hash: ``,
    transfer: void 0,
  }),
  c4 = class {
    #e = !1;
    #t = null;
    #n = null;
    #r = new Map();
    onSetModified = null;
    onResetModified = null;
    onAnnotationEditor = null;
    getValue(e, t) {
      let n = this.#r.get(e);
      return n === void 0 ? t : Object.assign(t, n);
    }
    getRawValue(e) {
      return this.#r.get(e);
    }
    remove(e) {
      let t = this.#r.get(e);
      t !== void 0 &&
        (t instanceof n4 && this.#n.delete(t.annotationElementId),
        this.#r.delete(e),
        this.#r.size === 0 && this.resetModified(),
        !this.#r.values().some((e) => e instanceof n4) && this.onAnnotationEditor?.(null));
    }
    setValue(e, t) {
      let n = this.#r.get(e),
        r = !1;
      if (n !== void 0) for (let [e, i] of Object.entries(t)) n[e] !== i && ((r = !0), (n[e] = i));
      else ((r = !0), this.#r.set(e, t));
      (r && this.#i(),
        t instanceof n4 &&
          ((this.#n ||= new Map()).set(t.annotationElementId, t),
          this.onAnnotationEditor?.(t.constructor._type)));
    }
    has(e) {
      return this.#r.has(e);
    }
    get size() {
      return this.#r.size;
    }
    #i() {
      this.#e || ((this.#e = !0), this.onSetModified?.());
    }
    resetModified() {
      this.#e && ((this.#e = !1), this.onResetModified?.());
    }
    get print() {
      return new l4(this);
    }
    get serializable() {
      if (this.#r.size === 0) return s4;
      let e = new Map(),
        t = new o4(),
        n = [],
        r = Object.create(null),
        i = !1;
      for (let [n, a] of this.#r) {
        let o = a instanceof n4 ? a.serialize(!1, r) : a;
        (a.page && ((a.pageIndex = a.page._pageIndex), delete a.page),
          o && (e.set(n, o), t.update(`${n}:${JSON.stringify(o)}`), (i ||= !!o.bitmap)));
      }
      if (i) for (let t of e.values()) t.bitmap && n.push(t.bitmap);
      return e.size > 0
        ? {
            map: e,
            hash: t.hexdigest(),
            transfer: n,
          }
        : s4;
    }
    get editorStats() {
      let e = null,
        t = new Map(),
        n = 0,
        r = 0;
      for (let i of this.#r.values()) {
        if (!(i instanceof n4)) {
          i.popup && (i.popup.deleted ? (r += 1) : (n += 1));
          continue;
        }
        i.isCommentDeleted ? (r += 1) : i.hasEditedComment && (n += 1);
        let a = i.telemetryFinalData;
        if (!a) continue;
        let { type: o } = a;
        (t.has(o) || t.set(o, Object.getPrototypeOf(i).constructor), (e ||= Object.create(null)));
        let s = (e[o] ||= new Map());
        for (let [e, t] of Object.entries(a)) {
          if (e === `type`) continue;
          let n = s.getOrInsertComputed(e, i2);
          n.set(t, (n.get(t) ?? 0) + 1);
        }
      }
      if (
        ((r > 0 || n > 0) &&
          ((e ||= Object.create(null)),
          (e.comments = {
            deleted: r,
            edited: n,
          })),
        !e)
      )
        return null;
      for (let [n, r] of t) e[n] = r.computeTelemetryFinalData(e[n]);
      return e;
    }
    resetModifiedIds() {
      this.#t = null;
    }
    updateEditor(e, t) {
      let n = this.#n?.get(e);
      return n ? (n.updateFromAnnotationLayer(t), !0) : !1;
    }
    getEditor(e) {
      return this.#n?.get(e) || null;
    }
    get modifiedIds() {
      if (this.#t) return this.#t;
      let e = [];
      if (this.#n) for (let t of this.#n.values()) t.serialize() && e.push(t.annotationElementId);
      let t = ``;
      if (e.length) {
        let n = new o4();
        (n.update(e.join(`,`)), (t = n.hexdigest()));
      }
      return (this.#t = {
        ids: new Set(e),
        hash: t,
      });
    }
    [Symbol.iterator]() {
      return this.#r.entries();
    }
  },
  l4 = class extends c4 {
    #e = s4;
    constructor(e) {
      super();
      let { serializable: t } = e;
      if (t === s4) return;
      let { map: n, hash: r, transfer: i } = t,
        a = structuredClone(
          n,
          i
            ? {
                transfer: i,
              }
            : null,
        );
      this.#e = {
        map: a,
        hash: r,
        transfer: [],
      };
    }
    get print() {
      j0(`Should not call PrintAnnotationStorage.print`);
    }
    get serializable() {
      return this.#e;
    }
    get modifiedIds() {
      return L0(this, `modifiedIds`, {
        ids: new Set(),
        hash: ``,
      });
    }
  },
  u4 = `__forcedDependency`,
  { floor: d4, ceil: f4 } = Math;
function p4(e, t, n, r, i, a) {
  ((e[t * 4 + 0] = Math.min(e[t * 4 + 0], n)),
    (e[t * 4 + 1] = Math.min(e[t * 4 + 1], r)),
    (e[t * 4 + 2] = Math.max(e[t * 4 + 2], i)),
    (e[t * 4 + 3] = Math.max(e[t * 4 + 3], a)));
}
var m4 = new Uint32Array(new Uint8Array([255, 255, 0, 0]).buffer)[0],
  ose = class {
    #e;
    #t;
    constructor(e, t) {
      ((this.#e = e), (this.#t = t));
    }
    get length() {
      return this.#e.length;
    }
    isEmpty(e) {
      return this.#e[e] === m4;
    }
    minX(e) {
      return this.#t[e * 4 + 0] / 256;
    }
    minY(e) {
      return this.#t[e * 4 + 1] / 256;
    }
    maxX(e) {
      return (this.#t[e * 4 + 2] + 1) / 256;
    }
    maxY(e) {
      return (this.#t[e * 4 + 3] + 1) / 256;
    }
  },
  h4 = (e, t) =>
    e?.getOrInsertComputed(t, () => ({
      dependencies: new Set(),
      isRenderingOperation: !1,
    })),
  sse = class {
    #e = [[1, 0, 0, 1, 0, 0]];
    #t = [-1 / 0, -1 / 0, 1 / 0, 1 / 0];
    #n = new Float64Array(c0);
    _pendingBBoxIdx = -1;
    #r;
    #i;
    #a;
    #o;
    _savesStack = [];
    _markedContentStack = [];
    constructor(e, t) {
      ((this.#r = e.width), (this.#i = e.height), this.#s(t));
    }
    growOperationsCount(e) {
      e >= this.#o.length && this.#s(e, this.#o);
    }
    #s(e, t) {
      let n = new ArrayBuffer(e * 4);
      ((this.#a = new Uint8ClampedArray(n)),
        (this.#o = new Uint32Array(n)),
        t && t.length > 0 ? (this.#o.set(t), this.#o.fill(m4, t.length)) : this.#o.fill(m4));
    }
    get clipBox() {
      return this.#t;
    }
    save(e) {
      return (
        (this.#t = {
          __proto__: this.#t,
        }),
        this._savesStack.push(e),
        this
      );
    }
    restore(e, t) {
      let n = Object.getPrototypeOf(this.#t);
      if (n === null) return this;
      this.#t = n;
      let r = this._savesStack.pop();
      return (r !== void 0 && (t?.(r, e), (this.#o[e] = this.#o[r])), this);
    }
    recordOpenMarker(e) {
      return (this._savesStack.push(e), this);
    }
    getOpenMarker() {
      return this._savesStack.length === 0 ? null : this._savesStack.at(-1);
    }
    recordCloseMarker(e, t) {
      let n = this._savesStack.pop();
      return (n !== void 0 && (t?.(n, e), (this.#o[e] = this.#o[n])), this);
    }
    beginMarkedContent(e) {
      return (this._markedContentStack.push(e), this);
    }
    endMarkedContent(e, t) {
      let n = this._markedContentStack.pop();
      return (n !== void 0 && (t?.(n, e), (this.#o[e] = this.#o[n])), this);
    }
    pushBaseTransform(e) {
      return (this.#e.push(Y0.multiplyByDOMMatrix(this.#e.at(-1), e.getTransform())), this);
    }
    popBaseTransform() {
      return (this.#e.length > 1 && this.#e.pop(), this);
    }
    resetBBox(e) {
      return (this._pendingBBoxIdx !== e && ((this._pendingBBoxIdx = e), this.#n.set(c0, 0)), this);
    }
    recordClipBox(e, t, n, r, i, a) {
      let o = Y0.multiplyByDOMMatrix(this.#e.at(-1), t.getTransform()),
        s = c0.slice();
      Y0.axialAlignedBoundingBox([n, i, r, a], o, s);
      let c = Y0.intersect(this.#t, s);
      return (
        c
          ? ((this.#t[0] = c[0]), (this.#t[1] = c[1]), (this.#t[2] = c[2]), (this.#t[3] = c[3]))
          : ((this.#t[0] = this.#t[1] = 1 / 0), (this.#t[2] = this.#t[3] = -1 / 0)),
        this
      );
    }
    recordBBox(e, t, n, r, i, a) {
      let o = this.#t;
      if (o[0] === 1 / 0) return this;
      let s = Y0.multiplyByDOMMatrix(this.#e.at(-1), t.getTransform());
      if (o[0] === -1 / 0) return (Y0.axialAlignedBoundingBox([n, i, r, a], s, this.#n), this);
      let c = c0.slice();
      return (
        Y0.axialAlignedBoundingBox([n, i, r, a], s, c),
        (this.#n[0] = o2(c[0], o[0], this.#n[0])),
        (this.#n[1] = o2(c[1], o[1], this.#n[1])),
        (this.#n[2] = o2(c[2], this.#n[2], o[2])),
        (this.#n[3] = o2(c[3], this.#n[3], o[3])),
        this
      );
    }
    recordFullPageBBox(e) {
      return (
        (this.#n[0] = Math.max(0, this.#t[0])),
        (this.#n[1] = Math.max(0, this.#t[1])),
        (this.#n[2] = Math.min(this.#r, this.#t[2])),
        (this.#n[3] = Math.min(this.#i, this.#t[3])),
        this
      );
    }
    recordOperation(e, t = !1, n) {
      if (this._pendingBBoxIdx !== e) return this;
      let r = d4((this.#n[0] * 256) / this.#r),
        i = d4((this.#n[1] * 256) / this.#i),
        a = f4((this.#n[2] * 256) / this.#r),
        o = f4((this.#n[3] * 256) / this.#i);
      if ((p4(this.#a, e, r, i, a, o), n))
        for (let t of n) for (let n of t) n !== e && p4(this.#a, n, r, i, a, o);
      return (t || (this._pendingBBoxIdx = -1), this);
    }
    bboxToClipBoxDropOperation(e) {
      return (
        this._pendingBBoxIdx === e &&
          ((this._pendingBBoxIdx = -1),
          (this.#t[0] = Math.max(this.#t[0], this.#n[0])),
          (this.#t[1] = Math.max(this.#t[1], this.#n[1])),
          (this.#t[2] = Math.min(this.#t[2], this.#n[2])),
          (this.#t[3] = Math.min(this.#t[3], this.#n[3]))),
        this
      );
    }
    take() {
      return new ose(this.#o, this.#a);
    }
    takeDebugMetadata() {
      throw Error(`Unreachable`);
    }
    recordSimpleData(e, t) {
      return this;
    }
    recordIncrementalData(e, t) {
      return this;
    }
    resetIncrementalData(e, t) {
      return this;
    }
    recordNamedData(e, t) {
      return this;
    }
    recordSimpleDataFromNamed(e, t, n) {
      return this;
    }
    recordFutureForcedDependency(e, t) {
      return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(e) {
      return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
      return this;
    }
    recordCharacterBBox(e, t, n, r = 1, i = 0, a = 0, o) {
      return this;
    }
    getSimpleIndex(e) {}
    recordDependencies(e, t) {
      return this;
    }
    recordNamedDependency(e, t) {
      return this;
    }
    recordShowTextOperation(e, t = !1) {
      return this;
    }
  },
  cse = class {
    #e = {
      __proto__: null,
    };
    #t = {
      __proto__: null,
      transform: [],
      moveText: [],
      sameLineText: [],
      [u4]: [],
    };
    #n = new Map();
    #r = new Set();
    #i = new Map();
    #a;
    #o;
    #s;
    constructor(e, t = !1) {
      ((this.#s = e),
        t &&
          ((this.#a = new Map()),
          (this.#o = (e, t) => {
            h4(this.#a, t).dependencies.add(e);
          })));
    }
    get clipBox() {
      return this.#s.clipBox;
    }
    growOperationsCount(e) {
      this.#s.growOperationsCount(e);
    }
    save(e) {
      return (
        (this.#e = {
          __proto__: this.#e,
        }),
        (this.#t = {
          __proto__: this.#t,
          transform: {
            __proto__: this.#t.transform,
          },
          moveText: {
            __proto__: this.#t.moveText,
          },
          sameLineText: {
            __proto__: this.#t.sameLineText,
          },
          [u4]: {
            __proto__: this.#t[u4],
          },
        }),
        this.#s.save(e),
        this
      );
    }
    restore(e) {
      this.#s.restore(e, this.#o);
      let t = Object.getPrototypeOf(this.#e);
      return t === null ? this : ((this.#e = t), (this.#t = Object.getPrototypeOf(this.#t)), this);
    }
    recordOpenMarker(e) {
      return (this.#s.recordOpenMarker(e, this.#o), this);
    }
    getOpenMarker() {
      return this.#s.getOpenMarker();
    }
    recordCloseMarker(e) {
      return (this.#s.recordCloseMarker(e, this.#o), this);
    }
    beginMarkedContent(e) {
      return (this.#s.beginMarkedContent(e), this);
    }
    endMarkedContent(e) {
      return (this.#s.endMarkedContent(e, this.#o), this);
    }
    pushBaseTransform(e) {
      return (this.#s.pushBaseTransform(e), this);
    }
    popBaseTransform() {
      return (this.#s.popBaseTransform(), this);
    }
    recordSimpleData(e, t) {
      return ((this.#e[e] = t), this);
    }
    recordIncrementalData(e, t) {
      return (this.#t[e].push(t), this);
    }
    resetIncrementalData(e, t) {
      return ((this.#t[e].length = 0), this);
    }
    recordNamedData(e, t) {
      return (this.#n.set(e, t), this);
    }
    recordSimpleDataFromNamed(e, t, n) {
      this.#e[e] = this.#n.get(t) ?? n;
    }
    recordFutureForcedDependency(e, t) {
      return (this.recordIncrementalData(u4, t), this);
    }
    inheritSimpleDataAsFutureForcedDependencies(e) {
      for (let t of e) t in this.#e && this.recordFutureForcedDependency(t, this.#e[t]);
      return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
      for (let e of this.#r) this.recordFutureForcedDependency(u4, e);
      return this;
    }
    resetBBox(e) {
      return (this.#s.resetBBox(e), this);
    }
    recordClipBox(e, t, n, r, i, a) {
      return (this.#s.recordClipBox(e, t, n, r, i, a), this);
    }
    recordBBox(e, t, n, r, i, a) {
      return (this.#s.recordBBox(e, t, n, r, i, a), this);
    }
    recordCharacterBBox(e, t, n, r = 1, i = 0, a = 0, o) {
      let s = n.bbox,
        c,
        l;
      if (
        s &&
        ((c = s[2] !== s[0] && s[3] !== s[1] && this.#i.get(n)),
        c !== !1 &&
          ((l = [0, 0, 0, 0]),
          Y0.axialAlignedBoundingBox(s, n.fontMatrix, l),
          (r !== 1 || i !== 0 || a !== 0) && Y0.scaleMinMax([r, 0, 0, -r, i, a], l),
          c))
      )
        return this.recordBBox(e, t, l[0], l[2], l[1], l[3]);
      if (!o) return this.recordFullPageBBox(e);
      let u = o();
      return s &&
        l &&
        c === void 0 &&
        ((c =
          l[0] <= i - u.actualBoundingBoxLeft &&
          l[2] >= i + u.actualBoundingBoxRight &&
          l[1] <= a - u.actualBoundingBoxAscent &&
          l[3] >= a + u.actualBoundingBoxDescent),
        this.#i.set(n, c),
        c)
        ? this.recordBBox(e, t, l[0], l[2], l[1], l[3])
        : this.recordBBox(
            e,
            t,
            i - u.actualBoundingBoxLeft,
            i + u.actualBoundingBoxRight,
            a - u.actualBoundingBoxAscent,
            a + u.actualBoundingBoxDescent,
          );
    }
    recordFullPageBBox(e) {
      return (this.#s.recordFullPageBBox(e), this);
    }
    getSimpleIndex(e) {
      return this.#e[e];
    }
    recordDependencies(e, t) {
      let n = this.#r,
        r = this.#e,
        i = this.#t;
      for (let e of t) e in this.#e ? n.add(r[e]) : e in i && i[e].forEach(n.add, n);
      return this;
    }
    recordNamedDependency(e, t) {
      return (this.#n.has(t) && this.#r.add(this.#n.get(t)), this);
    }
    recordOperation(e, t = !1) {
      if ((this.recordDependencies(e, [u4]), this.#a)) {
        let t = h4(this.#a, e),
          { dependencies: n } = t;
        (this.#r.forEach(n.add, n),
          this.#s._savesStack.forEach(n.add, n),
          this.#s._markedContentStack.forEach(n.add, n),
          n.delete(e),
          (t.isRenderingOperation = !0));
      }
      let n = !t && e === this.#s._pendingBBoxIdx;
      return (
        this.#s.recordOperation(e, t, [this.#r, this.#s._savesStack, this.#s._markedContentStack]),
        n && this.#r.clear(),
        this
      );
    }
    recordShowTextOperation(e, t = !1) {
      let n = Array.from(this.#r);
      (this.recordOperation(e, t), this.recordIncrementalData(`sameLineText`, e));
      for (let e of n) this.recordIncrementalData(`sameLineText`, e);
      return this;
    }
    bboxToClipBoxDropOperation(e, t = !1) {
      let n = !t && e === this.#s._pendingBBoxIdx;
      return (this.#s.bboxToClipBoxDropOperation(e), n && this.#r.clear(), this);
    }
    take() {
      return (this.#i.clear(), this.#s.take());
    }
    takeDebugMetadata() {
      return this.#a;
    }
  },
  g4 = class e {
    #e;
    #t;
    #n;
    #r = 0;
    #i = 0;
    constructor(t, n, r) {
      if (t instanceof e && t.#n === !!r) return t;
      ((this.#e = t), (this.#t = n), (this.#n = !!r));
    }
    get clipBox() {
      return this.#e.clipBox;
    }
    growOperationsCount() {
      throw Error(`Unreachable`);
    }
    save(e) {
      return (this.#i++, this.#e.save(this.#t), this);
    }
    restore(e) {
      return (this.#i > 0 && (this.#e.restore(this.#t), this.#i--), this);
    }
    recordOpenMarker(e) {
      return (this.#r++, this);
    }
    getOpenMarker() {
      return this.#r > 0 ? this.#t : this.#e.getOpenMarker();
    }
    recordCloseMarker(e) {
      return (this.#r--, this);
    }
    beginMarkedContent(e) {
      return this;
    }
    endMarkedContent(e) {
      return this;
    }
    pushBaseTransform(e) {
      return (this.#e.pushBaseTransform(e), this);
    }
    popBaseTransform() {
      return (this.#e.popBaseTransform(), this);
    }
    recordSimpleData(e, t) {
      return (this.#e.recordSimpleData(e, this.#t), this);
    }
    recordIncrementalData(e, t) {
      return (this.#e.recordIncrementalData(e, this.#t), this);
    }
    resetIncrementalData(e, t) {
      return (this.#e.resetIncrementalData(e, this.#t), this);
    }
    recordNamedData(e, t) {
      return this;
    }
    recordSimpleDataFromNamed(e, t, n) {
      return (this.#e.recordSimpleDataFromNamed(e, t, this.#t), this);
    }
    recordFutureForcedDependency(e, t) {
      return (this.#e.recordFutureForcedDependency(e, this.#t), this);
    }
    inheritSimpleDataAsFutureForcedDependencies(e) {
      return (this.#e.inheritSimpleDataAsFutureForcedDependencies(e), this);
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
      return (this.#e.inheritPendingDependenciesAsFutureForcedDependencies(), this);
    }
    resetBBox(e) {
      return (this.#n || this.#e.resetBBox(this.#t), this);
    }
    recordClipBox(e, t, n, r, i, a) {
      return (this.#n || this.#e.recordClipBox(this.#t, t, n, r, i, a), this);
    }
    recordBBox(e, t, n, r, i, a) {
      return (this.#n || this.#e.recordBBox(this.#t, t, n, r, i, a), this);
    }
    recordCharacterBBox(e, t, n, r, i, a, o) {
      return (this.#n || this.#e.recordCharacterBBox(this.#t, t, n, r, i, a, o), this);
    }
    recordFullPageBBox(e) {
      return (this.#n || this.#e.recordFullPageBBox(this.#t), this);
    }
    getSimpleIndex(e) {
      return this.#e.getSimpleIndex(e);
    }
    recordDependencies(e, t) {
      return (this.#e.recordDependencies(this.#t, t), this);
    }
    recordNamedDependency(e, t) {
      return (this.#e.recordNamedDependency(this.#t, t), this);
    }
    recordOperation(e) {
      return (this.#e.recordOperation(this.#t, !0), this);
    }
    recordShowTextOperation(e) {
      return (this.#e.recordShowTextOperation(this.#t, !0), this);
    }
    bboxToClipBoxDropOperation(e) {
      return (this.#n || this.#e.bboxToClipBoxDropOperation(this.#t, !0), this);
    }
    take() {
      throw Error(`Unreachable`);
    }
    takeDebugMetadata() {
      throw Error(`Unreachable`);
    }
  },
  _4 = {
    stroke: [
      `path`,
      `transform`,
      `filter`,
      `strokeColor`,
      `strokeAlpha`,
      `lineWidth`,
      `lineCap`,
      `lineJoin`,
      `miterLimit`,
      `dash`,
    ],
    fill: [
      `path`,
      `transform`,
      `filter`,
      `fillColor`,
      `fillAlpha`,
      `globalCompositeOperation`,
      `SMask`,
    ],
    imageXObject: [
      `transform`,
      `SMask`,
      `filter`,
      `fillAlpha`,
      `strokeAlpha`,
      `globalCompositeOperation`,
    ],
    rawFillPath: [`filter`, `fillColor`, `fillAlpha`],
    showText: [
      `transform`,
      `leading`,
      `charSpacing`,
      `wordSpacing`,
      `hScale`,
      `textRise`,
      `moveText`,
      `textMatrix`,
      `font`,
      `fontObj`,
      `filter`,
      `fillColor`,
      `textRenderingMode`,
      `SMask`,
      `fillAlpha`,
      `strokeAlpha`,
      `globalCompositeOperation`,
      `sameLineText`,
    ],
    transform: [`transform`],
    transformAndFill: [`transform`, `fillColor`],
  },
  lse = class e {
    #e;
    #t;
    #n = 4;
    #r = 0;
    #i = new e.#a(this.#n * 6);
    static #a = J0.isFloat16ArraySupported ? Float16Array : Float32Array;
    constructor(e) {
      ((this.#e = e.width), (this.#t = e.height));
    }
    record(t, n, r, i) {
      if (this.#r === this.#n) {
        this.#n *= 2;
        let t = new e.#a(this.#n * 6);
        (t.set(this.#i), (this.#i = t));
      }
      let a = Y0.domMatrixToTransform(t.getTransform()),
        o;
      if (i[0] !== 1 / 0) {
        let e = c0.slice();
        Y0.axialAlignedBoundingBox([0, -r, n, 0], a, e);
        let t = Y0.intersect(i, e);
        if (!t) return;
        let [s, c, l, u] = t;
        if (s !== e[0] || c !== e[1] || l !== e[2] || u !== e[3]) {
          let e = Math.atan2(a[1], a[0]),
            t = Math.abs(Math.sin(e)),
            n = Math.abs(Math.cos(e));
          if (t < 1e-6 || n < 1e-6 || Math.abs(t - n) < 1e-6) o = [s, c, s, u, l, c];
          else {
            let e = l - s,
              r = u - c,
              i = t * t,
              a = n * n,
              d = n * t,
              f = a - i,
              p = (r * a - e * d) / f;
            o = [s + (r * d - e * i) / f, c, s, c + p, l, u - p];
          }
        }
      }
      (o ||
        ((o = [0, -r, 0, 0, n, -r]),
        Y0.applyTransform(o, a, 0),
        Y0.applyTransform(o, a, 2),
        Y0.applyTransform(o, a, 4)),
        (o[0] /= this.#e),
        (o[1] /= this.#t),
        (o[2] /= this.#e),
        (o[3] /= this.#t),
        (o[4] /= this.#e),
        (o[5] /= this.#t),
        this.#i.set(o, this.#r * 6),
        this.#r++);
    }
    take() {
      return this.#i.subarray(0, this.#r * 6);
    }
  },
  use = class {
    #e = new Set();
    constructor({ ownerDocument: e = globalThis.document, styleElement: t = null }) {
      ((this._document = e),
        (this.nativeFontFaces = new Set()),
        (this.styleElement = null),
        (this.loadingRequests = []),
        (this.loadTestFontId = 0));
    }
    addNativeFontFace(e) {
      (this.nativeFontFaces.add(e), this._document.fonts.add(e));
    }
    removeNativeFontFace(e) {
      (this.nativeFontFaces.delete(e), this._document.fonts.delete(e));
    }
    insertRule(e) {
      this.styleElement ||
        ((this.styleElement = this._document.createElement(`style`)),
        this._document.documentElement.getElementsByTagName(`head`)[0].append(this.styleElement));
      let t = this.styleElement.sheet;
      t.insertRule(e, t.cssRules.length);
    }
    clear() {
      for (let e of this.nativeFontFaces) this._document.fonts.delete(e);
      (this.nativeFontFaces.clear(),
        this.#e.clear(),
        (this.styleElement &&= (this.styleElement.remove(), null)));
    }
    async loadSystemFont({ systemFontInfo: e, disableFontFace: t, _inspectFont: n }) {
      if (!(!e || this.#e.has(e.loadedName))) {
        if (
          (M0(!t, "loadSystemFont shouldn't be called when `disableFontFace` is set."),
          this.isFontLoadingAPISupported)
        ) {
          let { loadedName: t, src: r, style: i } = e,
            a = new FontFace(t, r, i);
          this.addNativeFontFace(a);
          try {
            (await a.load(), this.#e.add(t), n?.(e));
          } catch {
            (A0(
              `Cannot load system font: ${e.baseFontName}, installing it could help to improve PDF rendering.`,
            ),
              this.removeNativeFontFace(a));
          }
          return;
        }
        j0(`Not implemented: loadSystemFont without the Font Loading API.`);
      }
    }
    async bind(e) {
      if (e.attached || (e.missingFile && !e.systemFontInfo)) return;
      if (((e.attached = !0), e.systemFontInfo)) {
        await this.loadSystemFont(e);
        return;
      }
      if (this.isFontLoadingAPISupported) {
        let t = e.createNativeFontFace();
        if (t) {
          this.addNativeFontFace(t);
          try {
            await t.loaded;
          } catch (n) {
            throw (A0(`Failed to load font '${t.family}': '${n}'.`), (e.disableFontFace = !0), n);
          }
        }
        return;
      }
      let t = e.createFontFaceRule();
      if (t) {
        if ((this.insertRule(t), this.isSyncFontLoadingSupported)) return;
        await new Promise((t) => {
          let n = this._queueLoadingCallback(t);
          this._prepareFontLoadEvent(e, n);
        });
      }
    }
    get isFontLoadingAPISupported() {
      let e = !!this._document?.fonts;
      return L0(this, `isFontLoadingAPISupported`, e);
    }
    get isSyncFontLoadingSupported() {
      return L0(this, `isSyncFontLoadingSupported`, s0 || J0.platform.isFirefox);
    }
    _queueLoadingCallback(e) {
      function t() {
        for (
          M0(!r.done, `completeRequest() cannot be called twice.`), r.done = !0;
          n.length > 0 && n[0].done;
        ) {
          let e = n.shift();
          setTimeout(e.callback, 0);
        }
      }
      let { loadingRequests: n } = this,
        r = {
          done: !1,
          complete: t,
          callback: e,
        };
      return (n.push(r), r);
    }
    get _loadTestFont() {
      let e = atob(
        `T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==`,
      );
      return L0(this, `_loadTestFont`, e);
    }
    _prepareFontLoadEvent(e, t) {
      function n(e, t) {
        return (
          (e.charCodeAt(t) << 24) |
          (e.charCodeAt(t + 1) << 16) |
          (e.charCodeAt(t + 2) << 8) |
          (e.charCodeAt(t + 3) & 255)
        );
      }
      function r(e) {
        return String.fromCharCode((e >> 24) & 255, (e >> 16) & 255, (e >> 8) & 255, e & 255);
      }
      function i(e, t, n, r) {
        let i = e.substring(0, t),
          a = e.substring(t + n);
        return i + r + a;
      }
      let a,
        o,
        s = this._document.createElement(`canvas`);
      ((s.width = 1), (s.height = 1));
      let c = s.getContext(`2d`),
        l = 0;
      function u(e, t) {
        if (++l > 30) {
          (A0(`Load test font never loaded.`), t());
          return;
        }
        if (
          ((c.font = `30px ` + e), c.fillText(`.`, 0, 20), c.getImageData(0, 0, 1, 1).data[3] > 0)
        ) {
          t();
          return;
        }
        setTimeout(u.bind(null, e, t));
      }
      let d = `lt${Date.now()}${this.loadTestFontId++}`,
        f = this._loadTestFont;
      f = i(f, 976, d.length, d);
      let p = 1482184792,
        m = n(f, 16);
      for (a = 0, o = d.length - 3; a < o; a += 4) m = (m - p + n(d, a)) | 0;
      (a < d.length && (m = (m - p + n(d + `XXX`, a)) | 0), (f = i(f, 16, 4, r(m))));
      let h = `@font-face {font-family:"${d}";src:${`url(data:font/opentype;base64,${btoa(f)});`}}`;
      this.insertRule(h);
      let g = this._document.createElement(`div`);
      ((g.style.visibility = `hidden`),
        (g.style.width = g.style.height = `10px`),
        (g.style.position = `absolute`),
        (g.style.top = g.style.left = `0px`));
      for (let t of [e.loadedName, d]) {
        let e = this._document.createElement(`span`);
        ((e.textContent = `Hi`), (e.style.fontFamily = t), g.append(e));
      }
      (this._document.body.append(g),
        u(d, () => {
          (g.remove(), t.complete());
        }));
    }
  },
  dse = class {
    compiledGlyphs = Object.create(null);
    #e;
    constructor(e, t = null, n, r) {
      ((this.#e = e),
        (this._inspectFont = t),
        n && (this.charProcOperatorList = n),
        r && Object.assign(this, r));
    }
    createNativeFontFace() {
      if (!this.data || this.disableFontFace) return null;
      let e;
      if (!this.cssFontInfo) e = new FontFace(this.loadedName, this.data, {});
      else {
        let t = {
          weight: this.cssFontInfo.fontWeight,
        };
        (this.cssFontInfo.italicAngle && (t.style = `oblique ${this.cssFontInfo.italicAngle}deg`),
          (e = new FontFace(this.cssFontInfo.fontFamily, this.data, t)));
      }
      return (this._inspectFont?.(this), e);
    }
    createFontFaceRule() {
      if (!this.data || this.disableFontFace) return null;
      let e = `url(data:${this.mimetype};base64,${this.data.toBase64()});`,
        t;
      if (!this.cssFontInfo) t = `@font-face {font-family:"${this.loadedName}";src:${e}}`;
      else {
        let n = `font-weight: ${this.cssFontInfo.fontWeight};`;
        (this.cssFontInfo.italicAngle &&
          (n += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`),
          (t = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${n}src:${e}}`));
      }
      return (this._inspectFont?.(this, e), t);
    }
    getPathGenerator(e, t) {
      if (this.compiledGlyphs[t] !== void 0) return this.compiledGlyphs[t];
      let n = this.loadedName + `_path_` + t,
        r;
      try {
        r = e.get(n);
      } catch (e) {
        A0(`getPathGenerator - ignoring character: "${e}".`);
      }
      let i = U2(r?.path);
      return (this.fontExtraProperties || e.delete(n), (this.compiledGlyphs[t] = i));
    }
    get black() {
      return this.#e.black;
    }
    get bold() {
      return this.#e.bold;
    }
    get disableFontFace() {
      return this.#e.disableFontFace;
    }
    set disableFontFace(e) {
      L0(this, `disableFontFace`, !!e);
    }
    get fontExtraProperties() {
      return this.#e.fontExtraProperties;
    }
    get isInvalidPDFjsFont() {
      return this.#e.isInvalidPDFjsFont;
    }
    get isType3Font() {
      return this.#e.isType3Font;
    }
    get italic() {
      return this.#e.italic;
    }
    get missingFile() {
      return this.#e.missingFile;
    }
    get remeasure() {
      return this.#e.remeasure;
    }
    get vertical() {
      return this.#e.vertical;
    }
    get ascent() {
      return this.#e.ascent;
    }
    get defaultWidth() {
      return this.#e.defaultWidth;
    }
    get descent() {
      return this.#e.descent;
    }
    get bbox() {
      return this.#e.bbox;
    }
    get fontMatrix() {
      return this.#e.fontMatrix;
    }
    get fallbackName() {
      return this.#e.fallbackName;
    }
    get loadedName() {
      return this.#e.loadedName;
    }
    get mimetype() {
      return this.#e.mimetype;
    }
    get name() {
      return this.#e.name;
    }
    get data() {
      return this.#e.data;
    }
    clearData() {
      this.#e.clearData();
    }
    get cssFontInfo() {
      return this.#e.cssFontInfo;
    }
    get systemFontInfo() {
      return this.#e.systemFontInfo;
    }
    get defaultVMetrics() {
      return this.#e.defaultVMetrics;
    }
  },
  fse = class {
    static strings = [`fontFamily`, `fontWeight`, `italicAngle`];
  },
  pse = class {
    static strings = [`css`, `loadedName`, `baseFontName`, `src`];
  },
  v4 = class {
    static bools = [
      `black`,
      `bold`,
      `disableFontFace`,
      `fontExtraProperties`,
      `isInvalidPDFjsFont`,
      `isType3Font`,
      `italic`,
      `missingFile`,
      `remeasure`,
      `vertical`,
    ];
    static numbers = [`ascent`, `defaultWidth`, `descent`];
    static strings = [`fallbackName`, `loadedName`, `mimetype`, `name`];
    static OFFSET_NUMBERS = Math.ceil((this.bools.length * 2) / 8);
    static OFFSET_BBOX = this.OFFSET_NUMBERS + this.numbers.length * 8;
    static OFFSET_FONT_MATRIX = this.OFFSET_BBOX + 1 + 8;
    static OFFSET_DEFAULT_VMETRICS = this.OFFSET_FONT_MATRIX + 1 + 48;
    static OFFSET_STRINGS = this.OFFSET_DEFAULT_VMETRICS + 1 + 6;
  },
  y4 = class {
    static KIND = 0;
    static HAS_BBOX = 1;
    static HAS_BACKGROUND = 2;
    static SHADING_TYPE = 3;
    static N_COORD = 4;
    static N_COLOR = 8;
    static N_STOP = 12;
    static N_FIGURES = 16;
  },
  mse = class {
    #e;
    #t = new TextDecoder();
    #n;
    constructor(e) {
      ((this.#e = e), (this.#n = new DataView(e)));
    }
    #r(e) {
      M0(e < fse.strings.length, `Invalid string index`);
      let t = 0;
      for (let n = 0; n < e; n++) t += this.#n.getUint32(t) + 4;
      let n = this.#n.getUint32(t);
      return this.#t.decode(new Uint8Array(this.#e, t + 4, n));
    }
    get fontFamily() {
      return this.#r(0);
    }
    get fontWeight() {
      return this.#r(1);
    }
    get italicAngle() {
      return this.#r(2);
    }
  },
  hse = class {
    #e;
    #t = new TextDecoder();
    #n;
    constructor(e) {
      ((this.#e = e), (this.#n = new DataView(e)));
    }
    get guessFallback() {
      return this.#n.getUint8(0) !== 0;
    }
    #r(e) {
      M0(e < pse.strings.length, `Invalid string index`);
      let t = 5;
      for (let n = 0; n < e; n++) t += this.#n.getUint32(t) + 4;
      let n = this.#n.getUint32(t);
      return this.#t.decode(new Uint8Array(this.#e, t + 4, n));
    }
    get css() {
      return this.#r(0);
    }
    get loadedName() {
      return this.#r(1);
    }
    get baseFontName() {
      return this.#r(2);
    }
    get src() {
      return this.#r(3);
    }
    get style() {
      let e = 1;
      e += 4 + this.#n.getUint32(e);
      let t = this.#n.getUint32(e),
        n = this.#t.decode(new Uint8Array(this.#e, e + 4, t));
      e += 4 + t;
      let r = this.#n.getUint32(e);
      return {
        style: n,
        weight: this.#t.decode(new Uint8Array(this.#e, e + 4, r)),
      };
    }
  },
  gse = class {
    #e;
    #t = new TextDecoder();
    #n;
    constructor({ buffer: e, extra: t }) {
      ((this.#e = e), (this.#n = new DataView(e)), t && Object.assign(this, t));
    }
    #r(e) {
      M0(e < v4.bools.length, `Invalid boolean index`);
      let t = Math.floor(e / 4),
        n = (e * 2) % 8,
        r = (this.#n.getUint8(t) >> n) & 3;
      return r === 0 ? void 0 : r === 2;
    }
    get black() {
      return this.#r(0);
    }
    get bold() {
      return this.#r(1);
    }
    get disableFontFace() {
      return this.#r(2);
    }
    get fontExtraProperties() {
      return this.#r(3);
    }
    get isInvalidPDFjsFont() {
      return this.#r(4);
    }
    get isType3Font() {
      return this.#r(5);
    }
    get italic() {
      return this.#r(6);
    }
    get missingFile() {
      return this.#r(7);
    }
    get remeasure() {
      return this.#r(8);
    }
    get vertical() {
      return this.#r(9);
    }
    #i(e) {
      return (
        M0(e < v4.numbers.length, `Invalid number index`),
        this.#n.getFloat64(v4.OFFSET_NUMBERS + e * 8)
      );
    }
    get ascent() {
      return this.#i(0);
    }
    get defaultWidth() {
      return this.#i(1);
    }
    get descent() {
      return this.#i(2);
    }
    #a(e, t, n, r) {
      let i = this.#n.getUint8(e);
      if (i === 0) return;
      (M0(i === t, `Invalid array length.`), (e += 1));
      let a = Array(i);
      for (let t = 0; t < i; t++) ((a[t] = this.#n[n](e, !0)), (e += r));
      return a;
    }
    get bbox() {
      return this.#a(v4.OFFSET_BBOX, 4, `getInt16`, 2);
    }
    get fontMatrix() {
      return this.#a(v4.OFFSET_FONT_MATRIX, 6, `getFloat64`, 8);
    }
    get defaultVMetrics() {
      return this.#a(v4.OFFSET_DEFAULT_VMETRICS, 3, `getInt16`, 2);
    }
    #o(e) {
      M0(e < v4.strings.length, `Invalid string index`);
      let t = v4.OFFSET_STRINGS + 4;
      for (let n = 0; n < e; n++) t += this.#n.getUint32(t) + 4;
      let n = this.#n.getUint32(t);
      return this.#t.decode(new Uint8Array(this.#e, t + 4, n));
    }
    get fallbackName() {
      return this.#o(0);
    }
    get loadedName() {
      return this.#o(1);
    }
    get mimetype() {
      return this.#o(2);
    }
    get name() {
      return this.#o(3);
    }
    #s() {
      let e = v4.OFFSET_STRINGS,
        t = this.#n.getUint32(e);
      e += 4 + t;
      let n = this.#n.getUint32(e);
      e += 4 + n;
      let r = this.#n.getUint32(e);
      e += 4 + r;
      let i = this.#n.getUint32(e);
      return {
        offset: e,
        length: i,
      };
    }
    get data() {
      let { offset: e, length: t } = this.#s();
      return t === 0 ? void 0 : new Uint8Array(this.#e, e + 4, t);
    }
    clearData() {
      let { offset: e, length: t } = this.#s();
      t !== 0 &&
        (this.#n.setUint32(e, 0),
        (this.#e = new Uint8Array(this.#e, 0, e + 4).slice().buffer),
        (this.#n = new DataView(this.#e)));
    }
    get cssFontInfo() {
      let e = v4.OFFSET_STRINGS,
        t = this.#n.getUint32(e);
      e += 4 + t;
      let n = this.#n.getUint32(e);
      e += 4 + n;
      let r = this.#n.getUint32(e);
      if (r === 0) return null;
      let i = new Uint8Array(r);
      return (i.set(new Uint8Array(this.#e, e + 4, r)), new mse(i.buffer));
    }
    get systemFontInfo() {
      let e = v4.OFFSET_STRINGS,
        t = this.#n.getUint32(e);
      e += 4 + t;
      let n = this.#n.getUint32(e);
      if (n === 0) return null;
      let r = new Uint8Array(n);
      return (r.set(new Uint8Array(this.#e, e + 4, n)), new hse(r.buffer));
    }
  },
  _se = class {
    constructor(e) {
      ((this.buffer = e), (this.view = new DataView(e)), (this.data = new Uint8Array(e)));
    }
    getIR() {
      let e = this.view,
        t = this.data[y4.KIND],
        n = !!this.data[y4.HAS_BBOX],
        r = !!this.data[y4.HAS_BACKGROUND],
        i = e.getUint32(y4.N_COORD, !0),
        a = e.getUint32(y4.N_COLOR, !0),
        o = e.getUint32(y4.N_STOP, !0),
        s = 20,
        c = new Float32Array(this.buffer, s, i * 2);
      s += i * 8;
      let l = new Uint8Array(this.buffer, s, a * 4);
      s += a * 4;
      let u = [];
      for (let t = 0; t < o; ++t) {
        let t = e.getFloat32(s, !0);
        s += 4;
        let n = e.getUint32(s, !0);
        ((s += 4), u.push([t, `#${n.toString(16).padStart(6, `0`)}`]));
      }
      let d = null;
      if (n) {
        d = [];
        for (let t = 0; t < 4; ++t) (d.push(e.getFloat32(s, !0)), (s += 4));
      }
      let f = null;
      if ((r && ((f = new Uint8Array(this.buffer, s, 3)), (s += 3)), t === 1))
        return [
          `RadialAxial`,
          `axial`,
          d,
          u,
          Array.from(c.slice(0, 2)),
          Array.from(c.slice(2, 4)),
          null,
          null,
        ];
      if (t === 2) return [`RadialAxial`, `radial`, d, u, [c[0], c[1]], [c[3], c[4]], c[2], c[5]];
      if (t === 3) {
        let e = this.data[y4.SHADING_TYPE],
          t = null;
        if (c.length > 0) {
          t = c0.slice();
          for (let e = 0, n = c.length; e < n; e += 2) Y0.pointBoundingBox(c[e], c[e + 1], t);
        }
        return [`Mesh`, e, c, l, i, t, d, f];
      }
      throw Error(`Unsupported pattern kind: ${t}`);
    }
  },
  vse = class {
    #e;
    constructor(e) {
      this.#e = e;
    }
    get path() {
      return J0.isFloat16ArraySupported ? new Float16Array(this.#e) : new Float32Array(this.#e);
    }
  };
function yse(e) {
  if (e instanceof URL) return e;
  if (typeof e == `string`) {
    if (s0) {
      if (/^[a-z][a-z0-9\-+.]+:/i.test(e)) return new URL(e);
      let t = process.getBuiltinModule(`url`);
      return new URL(t.pathToFileURL(e));
    }
    let t = URL.parse(e, window.location);
    if (t) return t;
  }
  throw Error(`Invalid PDF url data: either string or URL-object is expected in the url property.`);
}
function bse(e) {
  if (s0 && typeof Buffer < `u` && e instanceof Buffer)
    throw Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
  if (e instanceof Uint8Array && e.byteLength === e.buffer.byteLength) return e;
  if (typeof e == `string`) return K0(e);
  if (
    e instanceof ArrayBuffer ||
    ArrayBuffer.isView(e) ||
    (typeof e == `object` && !isNaN(e?.length))
  )
    return new Uint8Array(e);
  throw Error(
    `Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.`,
  );
}
function b4(e) {
  if (typeof e != `string`) return null;
  if (e.endsWith(`/`)) return e;
  throw Error(`Invalid factory url: "${e}" must include trailing slash.`);
}
var x4 = (e) =>
    typeof e == `object` &&
    Number.isInteger(e?.num) &&
    e.num >= 0 &&
    Number.isInteger(e?.gen) &&
    e.gen >= 0,
  xse = n2.bind(null, x4, (e) => typeof e == `object` && typeof e?.name == `string`),
  Sse = class {
    #e = new Map();
    #t = Promise.resolve();
    postMessage(e, t) {
      let n = {
        data: structuredClone(
          e,
          t
            ? {
                transfer: t,
              }
            : null,
        ),
      };
      this.#t.then(() => {
        for (let [e] of this.#e) e.call(this, n);
      });
    }
    addEventListener(e, t, n = null) {
      let r = null;
      if (n?.signal instanceof AbortSignal) {
        let { signal: i } = n;
        if (i.aborted) {
          A0("LoopbackPort - cannot use an `aborted` signal.");
          return;
        }
        let a = () => this.removeEventListener(e, t);
        ((r = () => i.removeEventListener(`abort`, a)), i.addEventListener(`abort`, a));
      }
      this.#e.set(t, r);
    }
    removeEventListener(e, t) {
      (this.#e.get(t)?.(), this.#e.delete(t));
    }
    terminate() {
      for (let [, e] of this.#e) e?.();
      this.#e.clear();
    }
  },
  S4 = {
    DATA: 1,
    ERROR: 2,
  },
  C4 = {
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8,
  };
function w4() {}
function T4(e) {
  if (e instanceof W0 || e instanceof V0 || e instanceof z0 || e instanceof H0 || e instanceof B0)
    return e;
  switch (
    (e instanceof Error ||
      (typeof e == `object` && e) ||
      j0(`wrapReason: Expected "reason" to be a (possibly cloned) Error.`),
    e.name)
  ) {
    case `AbortException`:
      return new W0(e.message);
    case `InvalidPDFException`:
      return new V0(e.message);
    case `PasswordException`:
      return new z0(e.message, e.code);
    case `ResponseException`:
      return new H0(e.message, e.status, e.missing);
    case `UnknownErrorException`:
      return new B0(e.message, e.details);
  }
  return new B0(e.message, e.toString());
}
var E4 = class {
    #e = new AbortController();
    constructor(e, t, n) {
      ((this.sourceName = e),
        (this.targetName = t),
        (this.comObj = n),
        (this.callbackId = 1),
        (this.streamId = 1),
        (this.streamSinks = Object.create(null)),
        (this.streamControllers = Object.create(null)),
        (this.callbackCapabilities = Object.create(null)),
        (this.actionHandler = Object.create(null)),
        n.addEventListener(`message`, this.#t.bind(this), {
          signal: this.#e.signal,
        }));
    }
    #t({ data: e }) {
      if (e.targetName !== this.sourceName) return;
      if (e.stream) {
        this.#r(e);
        return;
      }
      if (e.callback) {
        let t = e.callbackId,
          n = this.callbackCapabilities[t];
        if (!n) throw Error(`Cannot resolve callback ${t}`);
        if ((delete this.callbackCapabilities[t], e.callback === S4.DATA)) n.resolve(e.data);
        else if (e.callback === S4.ERROR) n.reject(T4(e.reason));
        else throw Error(`Unexpected callback case`);
        return;
      }
      let t = this.actionHandler[e.action];
      if (!t) throw Error(`Unknown action from worker: ${e.action}`);
      if (e.callbackId) {
        let n = this.sourceName,
          r = e.sourceName,
          i = this.comObj;
        Promise.try(t, e.data).then(
          function (t) {
            i.postMessage({
              sourceName: n,
              targetName: r,
              callback: S4.DATA,
              callbackId: e.callbackId,
              data: t,
            });
          },
          function (t) {
            i.postMessage({
              sourceName: n,
              targetName: r,
              callback: S4.ERROR,
              callbackId: e.callbackId,
              reason: T4(t),
            });
          },
        );
        return;
      }
      if (e.streamId) {
        this.#n(e);
        return;
      }
      t(e.data);
    }
    on(e, t) {
      let n = this.actionHandler;
      if (n[e]) throw Error(`There is already an actionName called "${e}"`);
      n[e] = t;
    }
    send(e, t, n) {
      this.comObj.postMessage(
        {
          sourceName: this.sourceName,
          targetName: this.targetName,
          action: e,
          data: t,
        },
        n,
      );
    }
    sendWithPromise(e, t, n) {
      let r = this.callbackId++,
        i = Promise.withResolvers();
      this.callbackCapabilities[r] = i;
      try {
        this.comObj.postMessage(
          {
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: e,
            callbackId: r,
            data: t,
          },
          n,
        );
      } catch (e) {
        i.reject(e);
      }
      return i.promise;
    }
    sendWithStream(e, t, n, r) {
      let i = this.streamId++,
        a = this.sourceName,
        o = this.targetName,
        s = this.comObj;
      return new ReadableStream(
        {
          start: (n) => {
            let c = Promise.withResolvers();
            return (
              (this.streamControllers[i] = {
                controller: n,
                startCall: c,
                pullCall: null,
                cancelCall: null,
                isClosed: !1,
              }),
              s.postMessage(
                {
                  sourceName: a,
                  targetName: o,
                  action: e,
                  streamId: i,
                  data: t,
                  desiredSize: n.desiredSize,
                },
                r,
              ),
              c.promise
            );
          },
          pull: (e) => {
            let t = Promise.withResolvers();
            return (
              (this.streamControllers[i].pullCall = t),
              s.postMessage({
                sourceName: a,
                targetName: o,
                stream: C4.PULL,
                streamId: i,
                desiredSize: e.desiredSize,
              }),
              t.promise
            );
          },
          cancel: (e) => {
            M0(e instanceof Error, `cancel must have a valid reason`);
            let t = Promise.withResolvers();
            return (
              (this.streamControllers[i].cancelCall = t),
              (this.streamControllers[i].isClosed = !0),
              s.postMessage({
                sourceName: a,
                targetName: o,
                stream: C4.CANCEL,
                streamId: i,
                reason: T4(e),
              }),
              t.promise
            );
          },
        },
        n,
      );
    }
    #n(e) {
      let t = e.streamId,
        n = this.sourceName,
        r = e.sourceName,
        i = this.comObj,
        a = this,
        o = this.actionHandler[e.action],
        s = {
          enqueue(e, a = 1, o) {
            if (this.isCancelled) return;
            let s = this.desiredSize;
            ((this.desiredSize -= a),
              s > 0 &&
                this.desiredSize <= 0 &&
                ((this.sinkCapability = Promise.withResolvers()),
                (this.ready = this.sinkCapability.promise)),
              i.postMessage(
                {
                  sourceName: n,
                  targetName: r,
                  stream: C4.ENQUEUE,
                  streamId: t,
                  chunk: e,
                },
                o,
              ));
          },
          close() {
            this.isCancelled ||
              ((this.isCancelled = !0),
              i.postMessage({
                sourceName: n,
                targetName: r,
                stream: C4.CLOSE,
                streamId: t,
              }),
              delete a.streamSinks[t]);
          },
          error(e) {
            (M0(e instanceof Error, `error must have a valid reason`),
              !this.isCancelled &&
                ((this.isCancelled = !0),
                i.postMessage({
                  sourceName: n,
                  targetName: r,
                  stream: C4.ERROR,
                  streamId: t,
                  reason: T4(e),
                })));
          },
          sinkCapability: Promise.withResolvers(),
          onPull: null,
          onCancel: null,
          isCancelled: !1,
          desiredSize: e.desiredSize,
          ready: null,
        };
      (s.sinkCapability.resolve(),
        (s.ready = s.sinkCapability.promise),
        (this.streamSinks[t] = s),
        Promise.try(o, e.data, s).then(
          function () {
            i.postMessage({
              sourceName: n,
              targetName: r,
              stream: C4.START_COMPLETE,
              streamId: t,
              success: !0,
            });
          },
          function (e) {
            i.postMessage({
              sourceName: n,
              targetName: r,
              stream: C4.START_COMPLETE,
              streamId: t,
              reason: T4(e),
            });
          },
        ));
    }
    #r(e) {
      let t = e.streamId,
        n = this.sourceName,
        r = e.sourceName,
        i = this.comObj,
        a = this.streamControllers[t],
        o = this.streamSinks[t];
      switch (e.stream) {
        case C4.START_COMPLETE:
          e.success ? a.startCall.resolve() : a.startCall.reject(T4(e.reason));
          break;
        case C4.PULL_COMPLETE:
          e.success ? a.pullCall.resolve() : a.pullCall.reject(T4(e.reason));
          break;
        case C4.PULL:
          if (!o) {
            i.postMessage({
              sourceName: n,
              targetName: r,
              stream: C4.PULL_COMPLETE,
              streamId: t,
              success: !0,
            });
            break;
          }
          (o.desiredSize <= 0 && e.desiredSize > 0 && o.sinkCapability.resolve(),
            (o.desiredSize = e.desiredSize),
            Promise.try(o.onPull || w4).then(
              function () {
                i.postMessage({
                  sourceName: n,
                  targetName: r,
                  stream: C4.PULL_COMPLETE,
                  streamId: t,
                  success: !0,
                });
              },
              function (e) {
                i.postMessage({
                  sourceName: n,
                  targetName: r,
                  stream: C4.PULL_COMPLETE,
                  streamId: t,
                  reason: T4(e),
                });
              },
            ));
          break;
        case C4.ENQUEUE:
          if ((M0(a, `enqueue should have stream controller`), a.isClosed)) break;
          a.controller.enqueue(e.chunk);
          break;
        case C4.CLOSE:
          if ((M0(a, `close should have stream controller`), a.isClosed)) break;
          ((a.isClosed = !0), a.controller.close(), this.#i(a, t));
          break;
        case C4.ERROR:
          (M0(a, `error should have stream controller`),
            a.controller.error(T4(e.reason)),
            this.#i(a, t));
          break;
        case C4.CANCEL_COMPLETE:
          (e.success ? a.cancelCall.resolve() : a.cancelCall.reject(T4(e.reason)), this.#i(a, t));
          break;
        case C4.CANCEL:
          if (!o) break;
          let s = T4(e.reason);
          (Promise.try(o.onCancel || w4, s).then(
            function () {
              i.postMessage({
                sourceName: n,
                targetName: r,
                stream: C4.CANCEL_COMPLETE,
                streamId: t,
                success: !0,
              });
            },
            function (e) {
              i.postMessage({
                sourceName: n,
                targetName: r,
                stream: C4.CANCEL_COMPLETE,
                streamId: t,
                reason: T4(e),
              });
            },
          ),
            o.sinkCapability.reject(s),
            (o.isCancelled = !0),
            delete this.streamSinks[t]);
          break;
        default:
          throw Error(`Unexpected stream case`);
      }
    }
    async #i(e, t) {
      (await Promise.allSettled([e.startCall?.promise, e.pullCall?.promise, e.cancelCall?.promise]),
        delete this.streamControllers[t]);
    }
    destroy() {
      (this.#e?.abort(), (this.#e = null));
    }
  },
  D4 = class {
    #e = Object.freeze({
      cMapUrl: `CMap`,
      standardFontDataUrl: `font`,
      wasmUrl: `wasm`,
    });
    constructor({ cMapUrl: e = null, standardFontDataUrl: t = null, wasmUrl: n = null }) {
      ((this.cMapUrl = e), (this.standardFontDataUrl = t), (this.wasmUrl = n));
    }
    async fetch({ kind: e, filename: t }) {
      switch (e) {
        case `cMapUrl`:
        case `standardFontDataUrl`:
        case `wasmUrl`:
          break;
        default:
          j0(`Not implemented: ${e}`);
      }
      let n = this[e];
      if (!n) throw Error(`Ensure that the \`${e}\` API parameter is provided.`);
      let r = `${n}${t}`;
      return this._fetch(r, e).catch((t) => {
        throw Error(`Unable to load ${this.#e[e]} data at: ${r}`);
      });
    }
    async _fetch(e, t) {
      j0("Abstract method `_fetch` called.");
    }
  },
  O4 = class extends D4 {
    async _fetch(e, t) {
      let n = await d2(e, t === `cMapUrl` && !e.endsWith(`.bcmap`) ? `text` : `bytes`);
      return n instanceof Uint8Array ? n : K0(n);
    }
  },
  k4 = class {
    #e = !1;
    constructor({ enableHWA: e = !1 }) {
      this.#e = e;
    }
    create(e, t) {
      if (e <= 0 || t <= 0) throw Error(`Invalid canvas size`);
      let n = this._createCanvas(e, t);
      return {
        canvas: n,
        context: n.getContext(`2d`, {
          willReadFrequently: !this.#e,
        }),
      };
    }
    reset({ canvas: e }, t, n) {
      if (!e) throw Error(`Canvas is not specified`);
      if (t <= 0 || n <= 0) throw Error(`Invalid canvas size`);
      ((e.width = t), (e.height = n));
    }
    destroy(e) {
      let { canvas: t } = e;
      if (!t) throw Error(`Canvas is not specified`);
      ((t.width = t.height = 0), (e.canvas = null), (e.context = null));
    }
    _createCanvas(e, t) {
      j0("Abstract method `_createCanvas` called.");
    }
  },
  Cse = class extends k4 {
    constructor({ ownerDocument: e = globalThis.document, enableHWA: t = !1 }) {
      (super({
        enableHWA: t,
      }),
        (this._document = e));
    }
    _createCanvas(e, t) {
      let n = this._document.createElement(`canvas`);
      return ((n.width = e), (n.height = t), n);
    }
  },
  A4 = class {
    addFilter(e) {
      return `none`;
    }
    addHCMFilter(e, t) {
      return `none`;
    }
    addAlphaFilter(e) {
      return `none`;
    }
    addLuminosityFilter(e) {
      return `none`;
    }
    addHighlightHCMFilter(e, t, n, r, i) {
      return `none`;
    }
    destroy(e = !1) {}
  },
  wse = class extends A4 {
    #e;
    #t;
    #n;
    #r;
    #i;
    #a;
    #o = 0;
    constructor({ docId: e, ownerDocument: t = globalThis.document }) {
      (super(), (this.#r = e), (this.#i = t));
    }
    get #s() {
      return (this.#t ||= new Map());
    }
    get #c() {
      return (this.#a ||= new Map());
    }
    get #l() {
      if (!this.#n) {
        let e = this.#i.createElement(`div`),
          { style: t } = e;
        ((t.visibility = `hidden`),
          (t.contain = `strict`),
          (t.width = t.height = 0),
          (t.position = `absolute`),
          (t.top = t.left = 0),
          (t.zIndex = -1));
        let n = this.#i.createElementNS(l2, `svg`);
        (n.setAttribute(`width`, 0),
          n.setAttribute(`height`, 0),
          (this.#n = this.#i.createElementNS(l2, `defs`)),
          e.append(n),
          n.append(this.#n),
          this.#i.body.append(e));
      }
      return this.#n;
    }
    #u(e) {
      if (e.length === 1) {
        let t = e[0],
          n = Array(256);
        for (let e = 0; e < 256; e++) n[e] = t[e] / 255;
        let r = n.join(`,`);
        return [r, r, r];
      }
      let [t, n, r] = e,
        i = Array(256),
        a = Array(256),
        o = Array(256);
      for (let e = 0; e < 256; e++) ((i[e] = t[e] / 255), (a[e] = n[e] / 255), (o[e] = r[e] / 255));
      return [i.join(`,`), a.join(`,`), o.join(`,`)];
    }
    #d(e) {
      if (this.#e === void 0) {
        this.#e = ``;
        let e = this.#i.URL;
        e !== this.#i.baseURI &&
          (m2(e)
            ? A0(`#createUrl: ignore "data:"-URL for performance reasons.`)
            : (this.#e = F0(e, ``)));
      }
      return `url(${this.#e}#${e})`;
    }
    addFilter(e) {
      if (!e) return `none`;
      let t = this.#s.get(e);
      if (t) return t;
      let [n, r, i] = this.#u(e),
        a = e.length === 1 ? n : `${n}${r}${i}`;
      if (((t = this.#s.get(a)), t)) return (this.#s.set(e, t), t);
      let o = `g_${this.#r}_transfer_map_${this.#o++}`,
        s = this.#d(o);
      (this.#s.set(e, s), this.#s.set(a, s));
      let c = this.#m(o);
      return (this.#g(n, r, i, c), s);
    }
    addHCMFilter(e, t) {
      let n = `${e}-${t}`,
        r = `base`,
        i = this.#c.get(r);
      if (
        i?.key === n ||
        (i
          ? (i.filter?.remove(), (i.key = n), (i.url = `none`), (i.filter = null))
          : ((i = {
              key: n,
              url: `none`,
              filter: null,
            }),
            this.#c.set(r, i)),
        !e || !t)
      )
        return i.url;
      let a = this.#v(e);
      e = Y0.makeHexColor(...a);
      let o = this.#v(t);
      if (
        ((t = Y0.makeHexColor(...o)),
        (this.#l.style.color = ``),
        (e === `#000000` && t === `#ffffff`) || e === t)
      )
        return i.url;
      let s = Array(256);
      for (let e = 0; e <= 255; e++) {
        let t = e / 255;
        s[e] = t <= 0.03928 ? t / 12.92 : ((t + 0.055) / 1.055) ** 2.4;
      }
      let c = s.join(`,`),
        l = `g_${this.#r}_hcm_filter`,
        u = (i.filter = this.#m(l));
      (this.#g(c, c, c, u), this.#p(u));
      let d = (e, t) => {
        let n = a[e] / 255,
          r = o[e] / 255,
          i = Array(t + 1);
        for (let e = 0; e <= t; e++) i[e] = n + (e / t) * (r - n);
        return i.join(`,`);
      };
      return (this.#g(d(0, 5), d(1, 5), d(2, 5), u), (i.url = this.#d(l)), i.url);
    }
    addAlphaFilter(e) {
      let t = this.#s.get(e);
      if (t) return t;
      let [n] = this.#u([e]),
        r = `alpha_${n}`;
      if (((t = this.#s.get(r)), t)) return (this.#s.set(e, t), t);
      let i = `g_${this.#r}_alpha_map_${this.#o++}`,
        a = this.#d(i);
      (this.#s.set(e, a), this.#s.set(r, a));
      let o = this.#m(i);
      return (this.#_(n, o), a);
    }
    addLuminosityFilter(e) {
      let t = this.#s.get(e || `luminosity`);
      if (t) return t;
      let n, r;
      if (
        (e ? (([n] = this.#u([e])), (r = `luminosity_${n}`)) : (r = `luminosity`),
        (t = this.#s.get(r)),
        t)
      )
        return (this.#s.set(e, t), t);
      let i = `g_${this.#r}_luminosity_map_${this.#o++}`,
        a = this.#d(i);
      (this.#s.set(e, a), this.#s.set(r, a));
      let o = this.#m(i);
      return (this.#f(o), e && this.#_(n, o), a);
    }
    addHighlightHCMFilter(e, t, n, r, i) {
      let a = `${t}-${n}-${r}-${i}`,
        o = this.#c.get(e);
      if (
        o?.key === a ||
        (o
          ? (o.filter?.remove(), (o.key = a), (o.url = `none`), (o.filter = null))
          : ((o = {
              key: a,
              url: `none`,
              filter: null,
            }),
            this.#c.set(e, o)),
        !t || !n)
      )
        return o.url;
      let [s, c] = [t, n].map(this.#v.bind(this)),
        l = Math.round(0.2126 * s[0] + 0.7152 * s[1] + 0.0722 * s[2]),
        u = Math.round(0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]),
        [d, f] = [r, i].map(this.#v.bind(this));
      (u < l && ([l, u, d, f] = [u, l, f, d]), (this.#l.style.color = ``));
      let p = (e, t, n) => {
          let r = Array(256),
            i = (u - l) / n,
            a = e / 255,
            o = (t - e) / (255 * n),
            s = 0;
          for (let e = 0; e <= n; e++) {
            let t = Math.round(l + e * i),
              n = a + e * o;
            for (let e = s; e <= t; e++) r[e] = n;
            s = t + 1;
          }
          for (let e = s; e < 256; e++) r[e] = r[s - 1];
          return r.join(`,`);
        },
        m = `g_${this.#r}_hcm_${e}_filter`,
        h = (o.filter = this.#m(m));
      return (
        this.#p(h),
        this.#g(p(d[0], f[0], 5), p(d[1], f[1], 5), p(d[2], f[2], 5), h),
        (o.url = this.#d(m)),
        o.url
      );
    }
    destroy(e = !1) {
      (e && this.#a?.size) ||
        (this.#n?.parentNode.parentNode.remove(),
        (this.#n = null),
        this.#t?.clear(),
        (this.#t = null),
        this.#a?.clear(),
        (this.#a = null),
        (this.#o = 0));
    }
    #f(e) {
      let t = this.#i.createElementNS(l2, `feColorMatrix`);
      (t.setAttribute(`type`, `matrix`),
        t.setAttribute(`values`, `0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0`),
        e.append(t));
    }
    #p(e) {
      let t = this.#i.createElementNS(l2, `feColorMatrix`);
      (t.setAttribute(`type`, `matrix`),
        t.setAttribute(
          `values`,
          `0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0`,
        ),
        e.append(t));
    }
    #m(e) {
      let t = this.#i.createElementNS(l2, `filter`);
      return (
        t.setAttribute(`color-interpolation-filters`, `sRGB`),
        t.setAttribute(`id`, e),
        this.#l.append(t),
        t
      );
    }
    #h(e, t, n) {
      let r = this.#i.createElementNS(l2, t);
      (r.setAttribute(`type`, `discrete`), r.setAttribute(`tableValues`, n), e.append(r));
    }
    #g(e, t, n, r) {
      let i = this.#i.createElementNS(l2, `feComponentTransfer`);
      (r.append(i), this.#h(i, `feFuncR`, e), this.#h(i, `feFuncG`, t), this.#h(i, `feFuncB`, n));
    }
    #_(e, t) {
      let n = this.#i.createElementNS(l2, `feComponentTransfer`);
      (t.append(n), this.#h(n, `feFuncA`, e));
    }
    #v(e) {
      return ((this.#l.style.color = e), E2(getComputedStyle(this.#l).getPropertyValue(`color`)));
    }
  };
s0 && A0("Please use the `legacy` build in Node.js environments.");
async function Tse(e) {
  let t = await process.getBuiltinModule(`fs/promises`).readFile(e);
  return new Uint8Array(t);
}
var Ese = class extends A4 {},
  Dse = class extends k4 {
    _createCanvas(e, t) {
      return process
        .getBuiltinModule(`module`)
        .createRequire(import.meta.url)(`@napi-rs/canvas`)
        .createCanvas(e, t);
    }
  },
  Ose = class extends D4 {
    async _fetch(e, t) {
      return Tse(e);
    }
  },
  kse = `
struct Uniforms {
  offsetX      : f32,
  offsetY      : f32,
  scaleX       : f32,
  scaleY       : f32,
  paddedWidth  : f32,
  paddedHeight : f32,
  borderSize   : f32,
  _pad         : f32,
};

@group(0) @binding(0) var<uniform> u : Uniforms;

struct VertexInput {
  @location(0) position : vec2<f32>,
  @location(1) color    : vec4<f32>,
};

struct VertexOutput {
  @builtin(position) position : vec4<f32>,
  @location(0)       color    : vec3<f32>,
};

@vertex
fn vs_main(in : VertexInput) -> VertexOutput {
  var out : VertexOutput;
  let cx = (in.position.x + u.offsetX) * u.scaleX;
  let cy = (in.position.y + u.offsetY) * u.scaleY;
  out.position = vec4<f32>(
    ((cx + u.borderSize) / u.paddedWidth) * 2.0 - 1.0,
    1.0 - ((cy + u.borderSize) / u.paddedHeight) * 2.0,
    0.0,
    1.0
  );
  out.color = in.color.rgb;
  return out;
}

@fragment
fn fs_main(in : VertexOutput) -> @location(0) vec4<f32> {
  return vec4<f32>(in.color, 1.0);
}
`,
  j4 = new (class {
    #e = null;
    #t = null;
    #n = null;
    #r = null;
    async #i() {
      if (!globalThis.navigator?.gpu) return !1;
      try {
        let e = await navigator.gpu.requestAdapter();
        return e
          ? ((this.#r = navigator.gpu.getPreferredCanvasFormat()),
            (this.#t = await e.requestDevice()),
            !0)
          : !1;
      } catch {
        return !1;
      }
    }
    init() {
      return (this.#e ||= this.#i());
    }
    get isReady() {
      return this.#t !== null;
    }
    loadMeshShader() {
      if (!this.#t || this.#n) return;
      let e = this.#t.createShaderModule({
        code: kse,
      });
      this.#n = this.#t.createRenderPipeline({
        layout: `auto`,
        vertex: {
          module: e,
          entryPoint: `vs_main`,
          buffers: [
            {
              arrayStride: 8,
              attributes: [
                {
                  shaderLocation: 0,
                  offset: 0,
                  format: `float32x2`,
                },
              ],
            },
            {
              arrayStride: 4,
              attributes: [
                {
                  shaderLocation: 1,
                  offset: 0,
                  format: `unorm8x4`,
                },
              ],
            },
          ],
        },
        fragment: {
          module: e,
          entryPoint: `fs_main`,
          targets: [
            {
              format: this.#r,
            },
          ],
        },
        primitive: {
          topology: `triangle-list`,
        },
      });
    }
    draw(e, t, n, r, i, a, o, s) {
      this.loadMeshShader();
      let c = this.#t,
        { offsetX: l, offsetY: u, scaleX: d, scaleY: f } = r,
        p = c.createBuffer({
          size: Math.max(e.byteLength, 4),
          usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
        });
      e.byteLength > 0 && c.queue.writeBuffer(p, 0, e);
      let m = c.createBuffer({
        size: Math.max(t.byteLength, 4),
        usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
      });
      t.byteLength > 0 && c.queue.writeBuffer(m, 0, t);
      let h = c.createBuffer({
        size: 32,
        usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
      });
      c.queue.writeBuffer(h, 0, new Float32Array([l, u, d, f, a, o, s, 0]));
      let g = c.createBindGroup({
          layout: this.#n.getBindGroupLayout(0),
          entries: [
            {
              binding: 0,
              resource: {
                buffer: h,
              },
            },
          ],
        }),
        v = new OffscreenCanvas(a, o),
        y = v.getContext(`webgpu`);
      y.configure({
        device: c,
        format: this.#r,
        alphaMode: i ? `opaque` : `premultiplied`,
      });
      let b = i
          ? {
              r: i[0] / 255,
              g: i[1] / 255,
              b: i[2] / 255,
              a: 1,
            }
          : {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
            },
        x = c.createCommandEncoder(),
        S = x.beginRenderPass({
          colorAttachments: [
            {
              view: y.getCurrentTexture().createView(),
              clearValue: b,
              loadOp: `clear`,
              storeOp: `store`,
            },
          ],
        });
      return (
        n > 0 &&
          (S.setPipeline(this.#n),
          S.setBindGroup(0, g),
          S.setVertexBuffer(0, p),
          S.setVertexBuffer(1, m),
          S.draw(n)),
        S.end(),
        c.queue.submit([x.finish()]),
        p.destroy(),
        m.destroy(),
        h.destroy(),
        v.transferToImageBitmap()
      );
    }
  })();
function Ase() {
  return j4.init();
}
function jse() {
  return j4.isReady;
}
function Mse() {
  j4.loadMeshShader();
}
function Nse(e, t, n, r, i, a, o, s) {
  return j4.draw(e, t, n, r, i, a, o, s);
}
var M4 = {
  FILL: `Fill`,
  STROKE: `Stroke`,
  SHADING: `Shading`,
};
function N4(e, t) {
  if (!t) return;
  let n = t[2] - t[0],
    r = t[3] - t[1],
    i = new Path2D();
  (i.rect(t[0], t[1], n, r), e.clip(i));
}
var P4 = class {
    isModifyingCurrentTransform() {
      return !1;
    }
    getPattern() {
      j0("Abstract method `getPattern` called.");
    }
  },
  Pse = class extends P4 {
    constructor(e) {
      (super(),
        (this._type = e[1]),
        (this._bbox = e[2]),
        (this._colorStops = e[3]),
        (this._p0 = e[4]),
        (this._p1 = e[5]),
        (this._r0 = e[6]),
        (this._r1 = e[7]),
        (this.matrix = null));
    }
    isOriginBased() {
      return (
        this._p0[0] === 0 &&
        this._p0[1] === 0 &&
        (!this.isRadial() || (this._p1[0] === 0 && this._p1[1] === 0))
      );
    }
    isRadial() {
      return this._type === `radial`;
    }
    areConic() {
      if (!this.isRadial()) return !1;
      let e = Math.hypot(this._p0[0] - this._p1[0], this._p0[1] - this._p1[1]);
      return e + this._r1 > this._r0 && e + this._r0 > this._r1;
    }
    _createGradient(e, t = null) {
      let n,
        r = this._p0,
        i = this._p1;
      if (
        (t && ((r = r.slice()), (i = i.slice()), Y0.applyTransform(r, t), Y0.applyTransform(i, t)),
        this._type === `axial`)
      )
        n = e.createLinearGradient(r[0], r[1], i[0], i[1]);
      else if (this._type === `radial`) {
        let a = this._r0,
          o = this._r1;
        if (t) {
          let e = new Float32Array(2);
          (Y0.singularValueDecompose2dScale(t, e), (a *= e[0]), (o *= e[0]));
        }
        n = e.createRadialGradient(r[0], r[1], a, i[0], i[1], o);
      }
      for (let e of this._colorStops) n.addColorStop(e[0], e[1]);
      return n;
    }
    _createReversedGradient(e, t = null) {
      let n = this._p1,
        r = this._p0;
      t && ((n = n.slice()), (r = r.slice()), Y0.applyTransform(n, t), Y0.applyTransform(r, t));
      let i = this._r1,
        a = this._r0;
      if (t) {
        let e = new Float32Array(2);
        (Y0.singularValueDecompose2dScale(t, e), (i *= e[0]), (a *= e[0]));
      }
      let o = e.createRadialGradient(n[0], n[1], i, r[0], r[1], a),
        s = this._colorStops.map(([e, t]) => [1 - e, t]).reverse();
      for (let [e, t] of s) o.addColorStop(e, t);
      return o;
    }
    getPattern(e, t, n, r) {
      let i;
      if (r === M4.STROKE || r === M4.FILL) {
        if (this.isOriginBased()) {
          let r = Y0.transform(n, t.baseTransform);
          this.matrix && (r = Y0.transform(r, this.matrix));
          let i = 0.001,
            a = Math.hypot(r[0], r[1]),
            o = Math.hypot(r[2], r[3]),
            s = (r[0] * r[2] + r[1] * r[3]) / (a * o);
          if (Math.abs(s) < i)
            if (this.isRadial()) {
              if (Math.abs(a - o) < i) return this._createGradient(e, r);
            } else return this._createGradient(e, r);
        }
        let a = t.current.getClippedPathBoundingBox(r, O2(e)) || [0, 0, 0, 0],
          o = Math.ceil(a[2] - a[0]) || 1,
          s = Math.ceil(a[3] - a[1]) || 1,
          c = t.canvasFactory.create(o, s),
          l = c.context;
        (l.clearRect(0, 0, l.canvas.width, l.canvas.height),
          l.beginPath(),
          l.rect(0, 0, l.canvas.width, l.canvas.height),
          l.translate(-a[0], -a[1]),
          (n = Y0.transform(n, [1, 0, 0, 1, a[0], a[1]])),
          l.transform(...t.baseTransform),
          this.matrix && l.transform(...this.matrix),
          N4(l, this._bbox),
          this.areConic() && ((l.fillStyle = this._createReversedGradient(l)), l.fill()),
          (l.fillStyle = this._createGradient(l)),
          l.fill(),
          (i = e.createPattern(c.canvas, `no-repeat`)),
          t.canvasFactory.destroy(c));
        let u = new DOMMatrix(n);
        i.setTransform(u);
      } else
        (this.areConic() &&
          (e.save(),
          N4(e, this._bbox),
          (e.fillStyle = this._createReversedGradient(e)),
          e.fillRect(-1e10, -1e10, 2e10, 2e10),
          e.restore()),
          N4(e, this._bbox),
          (i = this._createGradient(e)));
      return i;
    }
  };
function Fse(e, t, n, r, i, a, o, s) {
  let c = t.coords,
    l = t.colors,
    u = e.data,
    d = e.width * 4,
    f;
  (c[n * 2 + 1] > c[r * 2 + 1] && ((f = n), (n = r), (r = f), (f = a), (a = o), (o = f)),
    c[r * 2 + 1] > c[i * 2 + 1] && ((f = r), (r = i), (i = f), (f = o), (o = s), (s = f)),
    c[n * 2 + 1] > c[r * 2 + 1] && ((f = n), (n = r), (r = f), (f = a), (a = o), (o = f)));
  let p = (c[n * 2] + t.offsetX) * t.scaleX,
    m = (c[n * 2 + 1] + t.offsetY) * t.scaleY,
    h = (c[r * 2] + t.offsetX) * t.scaleX,
    g = (c[r * 2 + 1] + t.offsetY) * t.scaleY,
    v = (c[i * 2] + t.offsetX) * t.scaleX,
    y = (c[i * 2 + 1] + t.offsetY) * t.scaleY;
  if (m >= y) return;
  let b = l[a * 4],
    x = l[a * 4 + 1],
    S = l[a * 4 + 2],
    C = l[o * 4],
    w = l[o * 4 + 1],
    T = l[o * 4 + 2],
    E = l[s * 4],
    D = l[s * 4 + 1],
    ee = l[s * 4 + 2],
    te = Math.round(m),
    O = Math.round(y),
    k,
    ne,
    re,
    A,
    ie,
    j,
    ae,
    oe;
  for (let e = te; e <= O; e++) {
    if (e < g) {
      let t = e < m ? 0 : (m - e) / (m - g);
      ((k = p - (p - h) * t),
        (ne = b - (b - C) * t),
        (re = x - (x - w) * t),
        (A = S - (S - T) * t));
    } else {
      let t;
      ((t = e > y ? 1 : g === y ? 0 : (g - e) / (g - y)),
        (k = h - (h - v) * t),
        (ne = C - (C - E) * t),
        (re = w - (w - D) * t),
        (A = T - (T - ee) * t));
    }
    let t;
    ((t = e < m ? 0 : e > y ? 1 : (m - e) / (m - y)),
      (ie = p - (p - v) * t),
      (j = b - (b - E) * t),
      (ae = x - (x - D) * t),
      (oe = S - (S - ee) * t));
    let n = Math.round(Math.min(k, ie)),
      r = Math.round(Math.max(k, ie)),
      i = d * e + n * 4;
    for (let e = n; e <= r; e++)
      ((t = (k - e) / (k - ie)),
        t < 0 ? (t = 0) : t > 1 && (t = 1),
        (u[i++] = (ne - (ne - j) * t) | 0),
        (u[i++] = (re - (re - ae) * t) | 0),
        (u[i++] = (A - (A - oe) * t) | 0),
        (u[i++] = 255));
  }
}
var Ise = class extends P4 {
    constructor(e) {
      (super(),
        (this._posData = e[2]),
        (this._colData = e[3]),
        (this._vertexCount = e[4]),
        (this._bounds = e[5]),
        (this._bbox = e[6]),
        (this._background = e[7]),
        (this.matrix = null),
        Mse());
    }
    _createMeshCanvas(e, t, n) {
      let r = 1.1,
        i = 3e3,
        a = Math.floor(this._bounds[0]),
        o = Math.floor(this._bounds[1]),
        s = Math.ceil(this._bounds[2]) - a,
        c = Math.ceil(this._bounds[3]) - o,
        l = Math.min(Math.ceil(Math.abs(s * e[0] * r)), i) || 1,
        u = Math.min(Math.ceil(Math.abs(c * e[1] * r)), i) || 1,
        d = s ? s / l : 1,
        f = c ? c / u : 1,
        p = {
          coords: this._posData,
          colors: this._colData,
          offsetX: -a,
          offsetY: -o,
          scaleX: 1 / d,
          scaleY: 1 / f,
        },
        m = l + 4,
        h = u + 4,
        g = n.create(m, h);
      if (jse() && this._vertexCount > 48)
        g.context.drawImage(
          Nse(this._posData, this._colData, this._vertexCount, p, t, m, h, 2),
          0,
          0,
        );
      else {
        let e = g.context.createImageData(l, u);
        if (t) {
          let n = e.data;
          for (let e = 0, r = n.length; e < r; e += 4)
            ((n[e] = t[0]), (n[e + 1] = t[1]), (n[e + 2] = t[2]), (n[e + 3] = 255));
        }
        for (let t = 0, n = this._vertexCount; t < n; t += 3)
          Fse(e, p, t, t + 1, t + 2, t, t + 1, t + 2);
        g.context.putImageData(e, 2, 2);
      }
      return {
        canvas: g.canvas,
        offsetX: a - 2 * d,
        offsetY: o - 2 * f,
        scaleX: d,
        scaleY: f,
      };
    }
    isModifyingCurrentTransform() {
      return !0;
    }
    getPattern(e, t, n, r) {
      N4(e, this._bbox);
      let i = new Float32Array(2);
      if (r === M4.SHADING) Y0.singularValueDecompose2dScale(O2(e), i);
      else if (this.matrix) {
        Y0.singularValueDecompose2dScale(this.matrix, i);
        let [e, n] = i;
        (Y0.singularValueDecompose2dScale(t.baseTransform, i), (i[0] *= e), (i[1] *= n));
      } else Y0.singularValueDecompose2dScale(t.baseTransform, i);
      let a = this._createMeshCanvas(
        i,
        r === M4.SHADING ? null : this._background,
        t.canvasFactory,
      );
      (r !== M4.SHADING &&
        (e.setTransform(...t.baseTransform), this.matrix && e.transform(...this.matrix)),
        e.translate(a.offsetX, a.offsetY),
        e.scale(a.scaleX, a.scaleY));
      let o = e.createPattern(a.canvas, `no-repeat`);
      return (t.canvasFactory.destroy(a), o);
    }
  },
  Lse = class extends P4 {
    getPattern() {
      return `hotpink`;
    }
  };
function Rse(e) {
  switch (e[0]) {
    case `RadialAxial`:
      return new Pse(e);
    case `Mesh`:
      return new Ise(e);
    case `Dummy`:
      return new Lse();
  }
  throw Error(`Unknown IR type: ${e[0]}`);
}
var F4 = {
    COLORED: 1,
    UNCOLORED: 2,
  },
  I4 = class e {
    static MAX_PATTERN_SIZE = 3e3;
    constructor(e, t, n, r) {
      ((this.color = e[1]),
        (this.operatorList = e[2]),
        (this.matrix = e[3]),
        (this.bbox = e[4]),
        (this.xstep = e[5]),
        (this.ystep = e[6]),
        (this.paintType = e[7]),
        (this.tilingType = e[8]),
        (this.needsIsolation = e[9] ?? !0),
        (this.ctx = t),
        (this.canvasGraphicsFactory = n),
        (this.baseTransform = r),
        (this.patternBaseMatrix = this.matrix ? Y0.transform(r, this.matrix) : r));
    }
    canSkipPatternCanvas([e, t, n, r]) {
      let [i, a, o, s] = this.bbox,
        c = Math.abs(this.xstep),
        l = Math.abs(this.ystep);
      if (e > c + 1e-6 || t > l + 1e-6) return null;
      let u = Math.floor((n - o) / c) + 1,
        d = Math.ceil((n + e - i) / c) - 1,
        f = Math.floor((r - s) / l) + 1,
        p = Math.ceil((r + t - a) / l) - 1;
      return d <= u && p <= f ? [u, f] : null;
    }
    updatePatternDims(e, t) {
      let n = Y0.inverseTransform(this.patternBaseMatrix),
        r = [e[0], e[1]],
        i = [e[2], e[3]];
      (Y0.applyTransform(r, n),
        Y0.applyTransform(i, n),
        (t[0] = Math.abs(i[0] - r[0])),
        (t[1] = Math.abs(i[1] - r[1])),
        (t[2] = Math.min(r[0], i[0])),
        (t[3] = Math.min(r[1], i[1])));
    }
    _renderTileCanvas(e, t, n, r) {
      let [i, a, o, s] = this.bbox,
        c = e.canvasFactory.create(n.size, r.size),
        l = c.context,
        u = this.canvasGraphicsFactory.createCanvasGraphics(l, t);
      return (
        (u.groupLevel = e.groupLevel),
        this.setFillAndStrokeStyleToContext(u, this.paintType, this.color),
        l.translate(-n.scale * i, -r.scale * a),
        u.transform(0, n.scale, 0, 0, r.scale, 0, 0),
        l.save(),
        u.dependencyTracker?.save(),
        this.clipBbox(u, i, a, o, s),
        (u.baseTransform = O2(u.ctx)),
        u.executeOperatorList(this.operatorList),
        u.endDrawing(),
        u.dependencyTracker?.restore(),
        l.restore(),
        c
      );
    }
    _getCombinedScales() {
      let e = new Float32Array(2);
      Y0.singularValueDecompose2dScale(this.matrix, e);
      let [t, n] = e;
      return (Y0.singularValueDecompose2dScale(this.baseTransform, e), [t * e[0], n * e[1]]);
    }
    drawPattern(e, t, n = !1, [r, i], a) {
      let [o, s, c, l] = this.bbox,
        u = e.dependencyTracker;
      if (
        (u && (e.dependencyTracker = new g4(u, a)),
        e.save(),
        n ? e.ctx.clip(t, `evenodd`) : e.ctx.clip(t),
        e.ctx.setTransform(...this.patternBaseMatrix),
        e.ctx.translate(r * this.xstep, i * this.ystep),
        this.needsIsolation ||
          e.ctx.globalAlpha !== 1 ||
          e.ctx.globalCompositeOperation !== `source-over` ||
          e.inSMaskMode)
      ) {
        let t = c - o,
          n = l - s,
          [r, i] = this._getCombinedScales(),
          u = this.getSizeAndScale(t, this.ctx.canvas.width, r),
          d = this.getSizeAndScale(n, this.ctx.canvas.height, i),
          f = this._renderTileCanvas(e, a, u, d);
        (e.ctx.drawImage(f.canvas, o, s, t, n), e.canvasFactory.destroy(f));
      } else
        (this.setFillAndStrokeStyleToContext(e, this.paintType, this.color),
          this.clipBbox(e, o, s, c, l),
          e.baseTransformStack.push(e.baseTransform),
          (e.baseTransform = O2(e.ctx)),
          e.executeOperatorList(this.operatorList),
          (e.baseTransform = e.baseTransformStack.pop()));
      (e.restore(), u && (e.dependencyTracker = u));
    }
    createPatternCanvas(e, t) {
      let [n, r, i, a] = this.bbox,
        o = i - n,
        s = a - r,
        { xstep: c, ystep: l } = this;
      ((c = Math.abs(c)), (l = Math.abs(l)), k0(`TilingType: ` + this.tilingType));
      let [u, d] = this._getCombinedScales(),
        f = o,
        p = s,
        m = !1,
        h = !1;
      (Math.ceil(c * u) >= Math.ceil(o * u) ? (f = c) : (m = !0),
        Math.ceil(l * d) >= Math.ceil(s * d) ? (p = l) : (h = !0));
      let g = this.getSizeAndScale(f, this.ctx.canvas.width, u),
        v = this.getSizeAndScale(p, this.ctx.canvas.height, d),
        y = this._renderTileCanvas(e, t, g, v);
      if (m || h) {
        let t = y.canvas;
        (m && (f = c), h && (p = l));
        let i = this.getSizeAndScale(f, this.ctx.canvas.width, u),
          a = this.getSizeAndScale(p, this.ctx.canvas.height, d),
          g = i.size,
          v = a.size,
          b = e.canvasFactory.create(g, v),
          x = b.context,
          S = m ? Math.floor(o / c) : 0,
          C = h ? Math.floor(s / l) : 0;
        for (let e = 0; e <= S; e++)
          for (let n = 0; n <= C; n++) x.drawImage(t, g * e, v * n, g, v, 0, 0, g, v);
        return (
          e.canvasFactory.destroy(y),
          {
            canvas: b.canvas,
            canvasEntry: b,
            scaleX: i.scale,
            scaleY: a.scale,
            offsetX: n,
            offsetY: r,
          }
        );
      }
      return {
        canvas: y.canvas,
        canvasEntry: y,
        scaleX: g.scale,
        scaleY: v.scale,
        offsetX: n,
        offsetY: r,
      };
    }
    getSizeAndScale(t, n, r) {
      let i = Math.max(e.MAX_PATTERN_SIZE, n),
        a = Math.ceil(t * r);
      return (
        a >= i ? (a = i) : (r = a / t),
        {
          scale: r,
          size: a,
        }
      );
    }
    clipBbox(e, t, n, r, i) {
      let a = r - t,
        o = i - n,
        s = new Path2D();
      (s.rect(t, n, a, o),
        Y0.axialAlignedBoundingBox([t, n, r, i], O2(e.ctx), e.current.minMax),
        e.ctx.clip(s),
        e.current.updateClipFromPath());
    }
    setFillAndStrokeStyleToContext(e, t, n) {
      let r = e.ctx,
        i = e.current;
      switch (((i.patternFill = i.patternStroke = !1), t)) {
        case F4.COLORED:
          let { fillStyle: e, strokeStyle: a } = this.ctx;
          ((r.fillStyle = i.fillColor = e), (r.strokeStyle = i.strokeColor = a));
          break;
        case F4.UNCOLORED:
          ((r.fillStyle = r.strokeStyle = n), (i.fillColor = i.strokeColor = n));
          break;
        default:
          throw new U0(`Unsupported paint type: ${t}`);
      }
    }
    isModifyingCurrentTransform() {
      return !1;
    }
    getPattern(e, t, n, r, i) {
      let a = r === M4.SHADING ? n : Y0.transform(n, this.patternBaseMatrix),
        o = this.createPatternCanvas(t, i),
        s = new DOMMatrix(a);
      ((s = s.translate(o.offsetX, o.offsetY)), (s = s.scale(1 / o.scaleX, 1 / o.scaleY)));
      let c = e.createPattern(o.canvas, `repeat`);
      return (t.canvasFactory.destroy(o.canvasEntry), c.setTransform(s), c);
    }
  };
function zse({
  src: e,
  srcPos: t = 0,
  dest: n,
  width: r,
  height: i,
  nonBlackColor: a = 4294967295,
  inverseDecode: o = !1,
}) {
  let s = J0.isLittleEndian ? 4278190080 : 255,
    [c, l] = o ? [a, s] : [s, a],
    u = r >> 3,
    d = r & 7,
    f = c ^ l,
    p = e.length;
  n = new Uint32Array(n.buffer);
  let m = 0;
  for (let r = 0; r < i; ++r) {
    for (let r = t + u; t < r; ++t, m += 8) {
      let r = e[t];
      ((n[m] = c ^ (-((r >> 7) & 1) & f)),
        (n[m + 1] = c ^ (-((r >> 6) & 1) & f)),
        (n[m + 2] = c ^ (-((r >> 5) & 1) & f)),
        (n[m + 3] = c ^ (-((r >> 4) & 1) & f)),
        (n[m + 4] = c ^ (-((r >> 3) & 1) & f)),
        (n[m + 5] = c ^ (-((r >> 2) & 1) & f)),
        (n[m + 6] = c ^ (-((r >> 1) & 1) & f)),
        (n[m + 7] = c ^ (-(r & 1) & f)));
    }
    if (d === 0) continue;
    let r = t < p ? e[t++] : 255;
    for (let e = 0; e < d; ++e, ++m) n[m] = c ^ (-((r >> (7 - e)) & 1) & f);
  }
  return {
    srcPos: t,
    destPos: m,
  };
}
var L4 = 16,
  R4 = 100,
  Bse = 15,
  z4 = 10,
  B4 = 16,
  V4 = new DOMMatrix(),
  H4 = new Float32Array(2);
function Vse(e, t) {
  if (e._removeMirroring) throw Error(`Context is already forwarding operations.`);
  ((e.__originalSave = e.save),
    (e.__originalRestore = e.restore),
    (e.__originalRotate = e.rotate),
    (e.__originalScale = e.scale),
    (e.__originalTranslate = e.translate),
    (e.__originalTransform = e.transform),
    (e.__originalSetTransform = e.setTransform),
    (e.__originalResetTransform = e.resetTransform),
    (e.__originalClip = e.clip),
    (e.__originalMoveTo = e.moveTo),
    (e.__originalLineTo = e.lineTo),
    (e.__originalBezierCurveTo = e.bezierCurveTo),
    (e.__originalRect = e.rect),
    (e.__originalClosePath = e.closePath),
    (e.__originalBeginPath = e.beginPath),
    (e._removeMirroring = () => {
      ((e.save = e.__originalSave),
        (e.restore = e.__originalRestore),
        (e.rotate = e.__originalRotate),
        (e.scale = e.__originalScale),
        (e.translate = e.__originalTranslate),
        (e.transform = e.__originalTransform),
        (e.setTransform = e.__originalSetTransform),
        (e.resetTransform = e.__originalResetTransform),
        (e.clip = e.__originalClip),
        (e.moveTo = e.__originalMoveTo),
        (e.lineTo = e.__originalLineTo),
        (e.bezierCurveTo = e.__originalBezierCurveTo),
        (e.rect = e.__originalRect),
        (e.closePath = e.__originalClosePath),
        (e.beginPath = e.__originalBeginPath),
        delete e._removeMirroring);
    }),
    (e.save = function () {
      (t.save(), this.__originalSave());
    }),
    (e.restore = function () {
      (t.restore(), this.__originalRestore());
    }),
    (e.translate = function (e, n) {
      (t.translate(e, n), this.__originalTranslate(e, n));
    }),
    (e.scale = function (e, n) {
      (t.scale(e, n), this.__originalScale(e, n));
    }),
    (e.transform = function (e, n, r, i, a, o) {
      (t.transform(e, n, r, i, a, o), this.__originalTransform(e, n, r, i, a, o));
    }),
    (e.setTransform = function (e, n, r, i, a, o) {
      n === void 0
        ? (t.setTransform(e), this.__originalSetTransform(e))
        : (t.setTransform(e, n, r, i, a, o), this.__originalSetTransform(e, n, r, i, a, o));
    }),
    (e.resetTransform = function () {
      (t.resetTransform(), this.__originalResetTransform());
    }),
    (e.rotate = function (e) {
      (t.rotate(e), this.__originalRotate(e));
    }),
    (e.clip = function (e) {
      (t.clip(e), this.__originalClip(e));
    }),
    (e.moveTo = function (e, n) {
      (t.moveTo(e, n), this.__originalMoveTo(e, n));
    }),
    (e.lineTo = function (e, n) {
      (t.lineTo(e, n), this.__originalLineTo(e, n));
    }),
    (e.bezierCurveTo = function (e, n, r, i, a, o) {
      (t.bezierCurveTo(e, n, r, i, a, o), this.__originalBezierCurveTo(e, n, r, i, a, o));
    }),
    (e.rect = function (e, n, r, i) {
      (t.rect(e, n, r, i), this.__originalRect(e, n, r, i));
    }),
    (e.closePath = function () {
      (t.closePath(), this.__originalClosePath());
    }),
    (e.beginPath = function () {
      (t.beginPath(), this.__originalBeginPath());
    }));
}
function U4(e, t, n, r, i, a, o, s, c, l) {
  let [u, d, f, p, m, h] = O2(e);
  if (d === 0 && f === 0) {
    let g = o * u + m,
      v = Math.round(g),
      y = s * p + h,
      b = Math.round(y),
      x = (o + c) * u + m,
      S = Math.abs(Math.round(x) - v) || 1,
      C = (s + l) * p + h,
      w = Math.abs(Math.round(C) - b) || 1;
    return (
      e.setTransform(Math.sign(u), 0, 0, Math.sign(p), v, b),
      e.drawImage(t, n, r, i, a, 0, 0, S, w),
      e.setTransform(u, d, f, p, m, h),
      [S, w]
    );
  }
  if (u === 0 && p === 0) {
    let g = s * f + m,
      v = Math.round(g),
      y = o * d + h,
      b = Math.round(y),
      x = (s + l) * f + m,
      S = Math.abs(Math.round(x) - v) || 1,
      C = (o + c) * d + h,
      w = Math.abs(Math.round(C) - b) || 1;
    return (
      e.setTransform(0, Math.sign(d), Math.sign(f), 0, v, b),
      e.drawImage(t, n, r, i, a, 0, 0, w, S),
      e.setTransform(u, d, f, p, m, h),
      [w, S]
    );
  }
  e.drawImage(t, n, r, i, a, o, s, c, l);
  let g = Math.hypot(u, d),
    v = Math.hypot(f, p);
  return [g * c, v * l];
}
var W4 = class {
  alphaIsShape = !1;
  fontSize = 0;
  fontSizeScale = 1;
  textMatrix = null;
  textMatrixScale = 1;
  fontMatrix = u0;
  leading = 0;
  x = 0;
  y = 0;
  lineX = 0;
  lineY = 0;
  charSpacing = 0;
  wordSpacing = 0;
  textHScale = 1;
  textRenderingMode = v0.FILL;
  textRise = 0;
  fillColor = `#000000`;
  strokeColor = `#000000`;
  tilingPatternDims = null;
  patternFill = !1;
  patternStroke = !1;
  fillAlpha = 1;
  strokeAlpha = 1;
  lineWidth = 1;
  activeSMask = null;
  transferMaps = `none`;
  minMax = l0.slice();
  constructor(e, t) {
    this.clipBox = new Float32Array([0, 0, e, t]);
  }
  clone() {
    let e = Object.create(this);
    return (
      (e.clipBox = this.clipBox.slice()),
      (e.minMax = this.minMax.slice()),
      (e.tilingPatternDims = this.tilingPatternDims?.slice()),
      e
    );
  }
  getPathBoundingBox(e = M4.FILL, t = null) {
    let n = this.minMax.slice();
    if (e === M4.STROKE) {
      (t || j0(`Stroke bounding box must include transform.`),
        Y0.singularValueDecompose2dScale(t, H4));
      let e = (H4[0] * this.lineWidth) / 2,
        r = (H4[1] * this.lineWidth) / 2;
      ((n[0] -= e), (n[1] -= r), (n[2] += e), (n[3] += r));
    }
    return n;
  }
  updateClipFromPath() {
    let e = Y0.intersect(this.clipBox, this.getPathBoundingBox());
    this.startNewPathAndClipBox(e || [0, 0, 0, 0]);
  }
  isEmptyClip() {
    return this.minMax[0] === 1 / 0;
  }
  startNewPathAndClipBox(e) {
    (this.clipBox.set(e, 0), this.minMax.set(l0, 0));
  }
  getClippedPathBoundingBox(e = M4.FILL, t = null) {
    return Y0.intersect(this.clipBox, this.getPathBoundingBox(e, t));
  }
};
function G4(e, t) {
  if (t instanceof ImageData) {
    e.putImageData(t, 0, 0);
    return;
  }
  let n = t.height,
    r = t.width,
    i = n % B4,
    a = (n - i) / B4,
    o = i === 0 ? a : a + 1,
    s = e.createImageData(r, B4),
    c = 0,
    l,
    u = t.data,
    d = s.data,
    f,
    p,
    m,
    h;
  if (t.kind === y0.GRAYSCALE_1BPP) {
    let t = u.byteLength,
      n = new Uint32Array(d.buffer, 0, d.byteLength >> 2),
      h = n.length,
      g = (r + 7) >> 3,
      v = 4294967295,
      y = J0.isLittleEndian ? 4278190080 : 255;
    for (f = 0; f < o; f++) {
      for (m = f < a ? B4 : i, l = 0, p = 0; p < m; p++) {
        let e = t - c,
          i = 0,
          a = e > g ? r : e * 8 - 7,
          o = a & -8,
          s = 0,
          d = 0;
        for (; i < o; i += 8)
          ((d = u[c++]),
            (n[l++] = d & 128 ? v : y),
            (n[l++] = d & 64 ? v : y),
            (n[l++] = d & 32 ? v : y),
            (n[l++] = d & 16 ? v : y),
            (n[l++] = d & 8 ? v : y),
            (n[l++] = d & 4 ? v : y),
            (n[l++] = d & 2 ? v : y),
            (n[l++] = d & 1 ? v : y));
        for (; i < a; i++)
          (s === 0 && ((d = u[c++]), (s = 128)), (n[l++] = d & s ? v : y), (s >>= 1));
      }
      for (; l < h;) n[l++] = 0;
      e.putImageData(s, 0, f * B4);
    }
  } else if (t.kind === y0.RGBA_32BPP) {
    for (p = 0, h = r * B4 * 4, f = 0; f < a; f++)
      (d.set(u.subarray(c, c + h)), (c += h), e.putImageData(s, 0, p), (p += B4));
    f < o && ((h = r * i * 4), d.set(u.subarray(c, c + h)), e.putImageData(s, 0, p));
  } else if (t.kind === y0.RGB_24BPP)
    for (m = B4, h = r * m, f = 0; f < o; f++) {
      for (f >= a && ((m = i), (h = r * m)), l = 0, p = h; p--;)
        ((d[l++] = u[c++]), (d[l++] = u[c++]), (d[l++] = u[c++]), (d[l++] = 255));
      e.putImageData(s, 0, f * B4);
    }
  else throw Error(`bad image kind: ${t.kind}`);
}
function K4(e, t) {
  if (t.bitmap) {
    e.drawImage(t.bitmap, 0, 0);
    return;
  }
  let n = t.height,
    r = t.width,
    i = n % B4,
    a = (n - i) / B4,
    o = i === 0 ? a : a + 1,
    s = e.createImageData(r, B4),
    c = 0,
    l = t.data,
    u = s.data;
  for (let t = 0; t < o; t++) {
    let n = t < a ? B4 : i;
    (({ srcPos: c } = zse({
      src: l,
      srcPos: c,
      dest: u,
      width: r,
      height: n,
      nonBlackColor: 0,
    })),
      e.putImageData(s, 0, t * B4));
  }
}
function q4(e, t) {
  for (let n of [
    `strokeStyle`,
    `fillStyle`,
    `fillRule`,
    `globalAlpha`,
    `lineWidth`,
    `lineCap`,
    `lineJoin`,
    `miterLimit`,
    `globalCompositeOperation`,
    `font`,
    `filter`,
  ])
    e[n] !== void 0 && (t[n] = e[n]);
  e.setLineDash !== void 0 &&
    (t.setLineDash(e.getLineDash()), (t.lineDashOffset = e.lineDashOffset));
}
function J4(e) {
  ((e.strokeStyle = e.fillStyle = `#000000`),
    (e.fillRule = `nonzero`),
    (e.globalAlpha = 1),
    (e.lineWidth = 1),
    (e.lineCap = `butt`),
    (e.lineJoin = `miter`),
    (e.miterLimit = 10),
    (e.globalCompositeOperation = `source-over`),
    (e.font = `10px sans-serif`),
    e.setLineDash !== void 0 && (e.setLineDash([]), (e.lineDashOffset = 0)));
  let { filter: t } = e;
  t !== `none` && t !== `` && (e.filter = `none`);
}
function Y4(e, t) {
  if (t) return !0;
  Y0.singularValueDecompose2dScale(e, H4);
  let n = Math.fround(j2.pixelRatio * u2.PDF_TO_CSS_UNITS);
  return H4[0] <= n && H4[1] <= n;
}
var Hse = [`butt`, `round`, `square`],
  Use = [`miter`, `round`, `bevel`],
  Wse = {},
  X4 = {},
  Z4 = class e {
    constructor(
      e,
      t,
      n,
      r,
      i,
      { optionalContentConfig: a, markedContentStack: o = null },
      s,
      c,
      l,
      u,
    ) {
      ((this.ctx = e),
        (this.current = new W4(this.ctx.canvas.width, this.ctx.canvas.height)),
        (this.stateStack = []),
        (this.pendingClip = null),
        (this.pendingEOFill = !1),
        (this.commonObjs = t),
        (this.objs = n),
        (this.canvasFactory = r),
        (this.filterFactory = i),
        (this.groupStack = []),
        (this.baseTransform = null),
        (this.baseTransformStack = []),
        (this.groupLevel = 0),
        (this.smaskStack = []),
        (this.tempSMask = null),
        (this.smaskGroupCanvases = []),
        (this.smaskPreparedEntry = null),
        (this.smaskPreparedFor = null),
        (this.smaskPreparedOffsetX = 0),
        (this.smaskPreparedOffsetY = 0),
        (this.suspendedCtx = null),
        (this.contentVisible = !0),
        (this.markedContentStack = o || []),
        (this.optionalContentConfig = a),
        (this.cachedPatterns = new Map()),
        (this.annotationCanvasMap = s),
        (this.viewportScale = 1),
        (this.outputScaleX = 1),
        (this.outputScaleY = 1),
        (this.pageColors = c),
        (this._cachedScaleForStroking = [-1, 0]),
        (this._cachedGetSinglePixelWidth = null),
        (this._cachedBitmapsMap = new Map()),
        (this.dependencyTracker = l ?? null),
        (this.imagesTracker = u ?? null));
    }
    getObject(e, t, n = null) {
      return typeof t == `string`
        ? (this.dependencyTracker?.recordNamedDependency(e, t),
          t.startsWith(`g_`) ? this.commonObjs.get(t) : this.objs.get(t))
        : n;
    }
    beginDrawing({ transform: e, viewport: t, transparency: n = !1, background: r = null }) {
      let i = this.ctx.canvas.width,
        a = this.ctx.canvas.height,
        o = this.ctx.fillStyle;
      if (
        ((this.ctx.fillStyle = r || `#ffffff`),
        this.ctx.fillRect(0, 0, i, a),
        (this.ctx.fillStyle = o),
        n)
      ) {
        let e = (this.transparentCanvasEntry = this.canvasFactory.create(i, a));
        ((this.compositeCtx = this.ctx),
          ({ canvas: this.transparentCanvas, context: this.ctx } = e),
          this.ctx.save(),
          this.ctx.transform(...O2(this.compositeCtx)));
      }
      (this.ctx.save(),
        J4(this.ctx),
        e && (this.ctx.transform(...e), (this.outputScaleX = e[0]), (this.outputScaleY = e[3])),
        this.ctx.transform(...t.transform),
        (this.viewportScale = t.scale),
        (this.baseTransform = O2(this.ctx)));
    }
    executeOperatorList(e, t, n, r, i) {
      let a = e.argsArray,
        o = e.fnArray,
        s = t || 0,
        c = a.length;
      if (c === s) return s;
      let l = c - s > z4 && typeof n == `function`,
        u = l ? Date.now() + Bse : 0,
        d = 0,
        f = this.commonObjs,
        p = this.objs,
        m,
        h;
      for (;;) {
        if (r !== void 0) {
          if (s === r.nextBreakPoint) return (r.breakIt(s, n), s);
          if (r.shouldSkip(s)) {
            if (++s === c) return s;
            continue;
          }
        }
        if (!i || i(s))
          if (((m = o[s]), (h = a[s] ?? null), m !== C0.dependency))
            h === null ? this[m](s) : this[m](s, ...h);
          else
            for (let e of h) {
              this.dependencyTracker?.recordNamedData(e, s);
              let t = e.startsWith(`g_`) ? f : p;
              if (!t.has(e)) return (t.get(e, n), s);
            }
        if ((s++, s === c)) return s;
        if (l && ++d > z4) {
          if (Date.now() > u) return (n(), s);
          d = 0;
        }
      }
    }
    #e() {
      for (; this.stateStack.length || this.inSMaskMode;) this.restore();
      ((this.current.activeSMask = null),
        this.ctx.restore(),
        this.transparentCanvas &&
          ((this.ctx = this.compositeCtx),
          this.ctx.save(),
          this.ctx.setTransform(1, 0, 0, 1, 0, 0),
          this.ctx.drawImage(this.transparentCanvas, 0, 0),
          this.ctx.restore(),
          this.canvasFactory.destroy(this.transparentCanvasEntry),
          (this.transparentCanvas = null),
          (this.transparentCanvasEntry = null)));
    }
    endDrawing() {
      this.#e();
      for (let e of this.smaskGroupCanvases) this.canvasFactory.destroy(e);
      ((this.smaskGroupCanvases.length = 0),
        this._clearPreparedSMask(),
        (this.tempSMask = null),
        (this.smaskStack.length = 0),
        this.cachedPatterns.clear());
      for (let e of this._cachedBitmapsMap.values()) {
        for (let t of e.values())
          typeof HTMLCanvasElement < `u` &&
            t instanceof HTMLCanvasElement &&
            (t.width = t.height = 0);
        e.clear();
      }
      (this._cachedBitmapsMap.clear(), this.#t());
    }
    #t() {
      if (this.pageColors) {
        let e = this.filterFactory.addHCMFilter(
          this.pageColors.foreground,
          this.pageColors.background,
        );
        if (e !== `none`) {
          let t = this.ctx.filter;
          ((this.ctx.filter = e), this.ctx.drawImage(this.ctx.canvas, 0, 0), (this.ctx.filter = t));
        }
      }
    }
    _scaleImage(e, t) {
      let n = e.width ?? e.displayWidth,
        r = e.height ?? e.displayHeight,
        i = Math.max(Math.hypot(t[0], t[1]), 1),
        a = Math.max(Math.hypot(t[2], t[3]), 1),
        o = [],
        s = i,
        c = a,
        l = n,
        u = r;
      for (; (s > 2 && l > 1) || (c > 2 && u > 1);) {
        let e = l,
          t = u;
        (s > 2 && l > 1 && ((e = Math.ceil(l / 2)), (s /= l / e)),
          c > 2 && u > 1 && ((t = Math.ceil(u / 2)), (c /= u / t)),
          o.push({
            newWidth: e,
            newHeight: t,
          }),
          (l = e),
          (u = t));
      }
      if (o.length === 0)
        return {
          img: e,
          paintWidth: n,
          paintHeight: r,
          tmpCanvas: null,
        };
      if (o.length === 1) {
        let { newWidth: t, newHeight: i } = o[0],
          a = this.canvasFactory.create(t, i);
        return (
          a.context.drawImage(e, 0, 0, n, r, 0, 0, t, i),
          {
            img: a.canvas,
            paintWidth: t,
            paintHeight: i,
            tmpCanvas: a,
          }
        );
      }
      let d = this.canvasFactory.create(1, 1),
        f = this.canvasFactory.create(1, 1),
        p = n,
        m = r,
        h = e;
      for (let { newWidth: e, newHeight: t } of o)
        (this.canvasFactory.reset(f, e, t),
          f.context.drawImage(h, 0, 0, p, m, 0, 0, e, t),
          ([d, f] = [f, d]),
          (h = d.canvas),
          (p = e),
          (m = t));
      return (
        this.canvasFactory.destroy(f),
        {
          img: d.canvas,
          paintWidth: p,
          paintHeight: m,
          tmpCanvas: d,
        }
      );
    }
    _createMaskCanvas(e, t) {
      let n = this.ctx,
        { width: r, height: i } = t,
        a = this.current.fillColor,
        o = this.current.patternFill,
        s = O2(n),
        c,
        l,
        u,
        d;
      if ((t.bitmap || t.data) && t.count > 1) {
        let n = t.bitmap || t.data.buffer;
        ((l = JSON.stringify(o ? s : [s.slice(0, 4), a])),
          (c = this._cachedBitmapsMap.getOrInsertComputed(n, i2)));
        let r = c.get(l);
        if (r && !o) {
          let t = Math.round(Math.min(s[0], s[2]) + s[4]),
            n = Math.round(Math.min(s[1], s[3]) + s[5]);
          return (
            this.dependencyTracker?.recordDependencies(e, _4.transformAndFill),
            {
              canvas: r,
              offsetX: t,
              offsetY: n,
            }
          );
        }
        u = r;
      }
      u || ((d = this.canvasFactory.create(r, i)), K4(d.context, t));
      let f = Y0.transform(s, [1 / r, 0, 0, -1 / i, 0, 0]);
      f = Y0.transform(f, [1, 0, 0, 1, 0, -i]);
      let p = l0.slice();
      Y0.axialAlignedBoundingBox([0, 0, r, i], f, p);
      let [m, h, g, v] = p,
        y = Math.round(g - m) || 1,
        b = Math.round(v - h) || 1,
        x = this.canvasFactory.create(y, b),
        S = x.context,
        C = m,
        w = h;
      (S.translate(-C, -w), S.transform(...f));
      let T = null;
      if (!u) {
        let e = this._scaleImage(d.canvas, k2(S));
        ((u = e.img),
          (T = e.tmpCanvas),
          u !== d.canvas && (this.canvasFactory.destroy(d), (d = null)),
          c && o && (c.set(l, u), (T = null), (d = null)));
      }
      ((S.imageSmoothingEnabled = Y4(O2(S), t.interpolate)),
        U4(S, u, 0, 0, u.width, u.height, 0, 0, r, i),
        T && this.canvasFactory.destroy(T),
        d && this.canvasFactory.destroy(d),
        (S.globalCompositeOperation = `source-in`));
      let E = Y0.transform(k2(S), [1, 0, 0, 1, -C, -w]);
      return (
        (S.fillStyle = o ? a.getPattern(n, this, E, M4.FILL, e) : a),
        S.fillRect(0, 0, r, i),
        c && !o && c.set(l, x.canvas),
        this.dependencyTracker?.recordDependencies(e, _4.transformAndFill),
        {
          canvas: x.canvas,
          canvasEntry: c && !o ? null : x,
          offsetX: Math.round(C),
          offsetY: Math.round(w),
        }
      );
    }
    setLineWidth(e, t) {
      (this.dependencyTracker?.recordSimpleData(`lineWidth`, e),
        t !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1),
        (this.current.lineWidth = t),
        (this.ctx.lineWidth = t));
    }
    setLineCap(e, t) {
      (this.dependencyTracker?.recordSimpleData(`lineCap`, e), (this.ctx.lineCap = Hse[t]));
    }
    setLineJoin(e, t) {
      (this.dependencyTracker?.recordSimpleData(`lineJoin`, e), (this.ctx.lineJoin = Use[t]));
    }
    setMiterLimit(e, t) {
      (this.dependencyTracker?.recordSimpleData(`miterLimit`, e), (this.ctx.miterLimit = t));
    }
    setDash(e, t, n) {
      this.dependencyTracker?.recordSimpleData(`dash`, e);
      let r = this.ctx;
      r.setLineDash !== void 0 && (r.setLineDash(t), (r.lineDashOffset = n));
    }
    setRenderingIntent(e, t) {}
    setFlatness(e, t) {}
    setGState(e, t) {
      for (let [n, r] of t)
        switch (n) {
          case `LW`:
            this.setLineWidth(e, r);
            break;
          case `LC`:
            this.setLineCap(e, r);
            break;
          case `LJ`:
            this.setLineJoin(e, r);
            break;
          case `ML`:
            this.setMiterLimit(e, r);
            break;
          case `D`:
            this.setDash(e, r[0], r[1]);
            break;
          case `RI`:
            this.setRenderingIntent(e, r);
            break;
          case `FL`:
            this.setFlatness(e, r);
            break;
          case `Font`:
            this.setFont(e, r[0], r[1]);
            break;
          case `CA`:
            (this.dependencyTracker?.recordSimpleData(`strokeAlpha`, e),
              (this.current.strokeAlpha = r));
            break;
          case `ca`:
            (this.dependencyTracker?.recordSimpleData(`fillAlpha`, e),
              (this.ctx.globalAlpha = this.current.fillAlpha = r));
            break;
          case `BM`:
            (this.dependencyTracker?.recordSimpleData(`globalCompositeOperation`, e),
              (this.ctx.globalCompositeOperation = r));
            break;
          case `SMask`:
            (this.dependencyTracker?.recordSimpleData(`SMask`, e),
              (this.current.activeSMask = r ? this.tempSMask : null),
              this.current.activeSMask &&
                (this.current.activeSMask.blendMode = this.ctx.globalCompositeOperation),
              (this.tempSMask = null),
              this.checkSMaskState(e));
            break;
          case `TR`:
            (this.dependencyTracker?.recordSimpleData(`filter`, e),
              (this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(r)));
            break;
        }
    }
    get inSMaskMode() {
      return !!this.suspendedCtx;
    }
    _clearPreparedSMask() {
      ((this.smaskPreparedEntry &&= (this.canvasFactory.destroy(this.smaskPreparedEntry), null)),
        (this.smaskPreparedFor = null),
        (this.smaskPreparedOffsetX = 0),
        (this.smaskPreparedOffsetY = 0));
    }
    _ensurePreparedSMask(e, t, n) {
      e !== this.smaskPreparedFor &&
        (this._clearPreparedSMask(), this._prepareSMaskCanvas(e, t, n));
    }
    checkSMaskState(e) {
      let t = this.inSMaskMode;
      this.current.activeSMask && !t
        ? this.beginSMaskMode(e)
        : !this.current.activeSMask && t
          ? this.endSMaskMode()
          : this.current.activeSMask &&
            t &&
            this._ensurePreparedSMask(
              this.current.activeSMask,
              this.ctx.canvas.width,
              this.ctx.canvas.height,
            );
    }
    _prepareSMaskCanvas(e, t, n) {
      let { canvas: r, subtype: i, backdrop: a, transferMap: o } = e,
        s = i === `Luminosity` || (i === `Alpha` && o);
      if (!a && !s) {
        this.smaskPreparedFor = e;
        return;
      }
      let c, l, u;
      if (a && s) {
        let s = this.canvasFactory.create(t, n),
          d = s.context;
        (d.drawImage(r, e.offsetX, e.offsetY),
          (d.globalCompositeOperation = `destination-atop`),
          (d.fillStyle = a),
          d.fillRect(0, 0, t, n),
          (d.globalCompositeOperation = `source-over`),
          (c = this.canvasFactory.create(t, n)));
        let f = c.context;
        ((f.filter =
          i === `Alpha`
            ? this.filterFactory.addAlphaFilter(o)
            : this.filterFactory.addLuminosityFilter(o)),
          f.drawImage(s.canvas, 0, 0),
          (f.filter = `none`),
          this.canvasFactory.destroy(s),
          (l = u = 0));
      } else if (s) {
        c = this.canvasFactory.create(r.width, r.height);
        let t = c.context;
        ((t.filter =
          i === `Alpha`
            ? this.filterFactory.addAlphaFilter(o)
            : this.filterFactory.addLuminosityFilter(o)),
          t.drawImage(r, 0, 0),
          (t.filter = `none`),
          ({ offsetX: l, offsetY: u } = e));
      } else {
        c = this.canvasFactory.create(t, n);
        let i = c.context;
        (i.drawImage(r, e.offsetX, e.offsetY),
          (i.globalCompositeOperation = `destination-atop`),
          (i.fillStyle = a),
          i.fillRect(0, 0, t, n),
          (i.globalCompositeOperation = `source-over`),
          (l = u = 0));
      }
      ((this.smaskPreparedEntry = c),
        (this.smaskPreparedFor = e),
        (this.smaskPreparedOffsetX = l),
        (this.smaskPreparedOffsetY = u));
    }
    beginSMaskMode(e) {
      if (this.inSMaskMode) throw Error(`beginSMaskMode called while already in smask mode`);
      let { width: t, height: n } = this.ctx.canvas,
        r = this.canvasFactory.create(t, n);
      ((this.smaskScratchCanvas = r), (this.suspendedCtx = this.ctx));
      let i = (this.ctx = r.context);
      (i.setTransform(this.suspendedCtx.getTransform()),
        q4(this.suspendedCtx, i),
        Vse(i, this.suspendedCtx),
        this._ensurePreparedSMask(this.current.activeSMask, t, n),
        this.setGState(e, [[`BM`, `source-over`]]));
    }
    endSMaskMode() {
      if (!this.inSMaskMode) throw Error(`endSMaskMode called while not in smask mode`);
      (this.ctx._removeMirroring(),
        q4(this.ctx, this.suspendedCtx),
        (this.ctx = this.suspendedCtx),
        (this.suspendedCtx = null),
        this.canvasFactory.destroy(this.smaskScratchCanvas),
        (this.smaskScratchCanvas = null),
        this._clearPreparedSMask());
    }
    compose(e) {
      if (!this.current.activeSMask) return;
      e
        ? ((e[0] = Math.floor(e[0])),
          (e[1] = Math.floor(e[1])),
          (e[2] = Math.ceil(e[2])),
          (e[3] = Math.ceil(e[3])))
        : (e = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height]);
      let t = this.current.activeSMask,
        n = this.suspendedCtx;
      (this.composeSMask(n, t, this.ctx, e),
        this.ctx.save(),
        this.ctx.setTransform(1, 0, 0, 1, 0, 0),
        this.ctx.clearRect(e[0], e[1], e[2] - e[0], e[3] - e[1]),
        this.ctx.restore());
    }
    composeSMask(e, t, n, r) {
      let i = r[0],
        a = r[1],
        o = r[2] - i,
        s = r[3] - a;
      if (o === 0 || s === 0) return;
      let c = this.smaskPreparedEntry;
      if (c) {
        let e = i - this.smaskPreparedOffsetX,
          t = a - this.smaskPreparedOffsetY;
        (n.save(), (n.globalAlpha = 1), n.setTransform(1, 0, 0, 1, 0, 0));
        let r = new Path2D();
        (r.rect(i, a, o, s),
          n.clip(r),
          (n.globalCompositeOperation = `destination-in`),
          n.drawImage(c.canvas, e, t, o, s, i, a, o, s),
          n.restore());
      } else this.genericComposeSMask(t.context, n, o, s, i, a, t.offsetX, t.offsetY);
      (e.save(),
        (e.globalAlpha = 1),
        (e.globalCompositeOperation = t.blendMode || `source-over`),
        e.setTransform(1, 0, 0, 1, 0, 0),
        e.drawImage(n.canvas, i, a, o, s, i, a, o, s),
        e.restore());
    }
    genericComposeSMask(e, t, n, r, i, a, o, s) {
      let c = e.canvas,
        l = i - o,
        u = a - s;
      (t.save(), (t.globalAlpha = 1), t.setTransform(1, 0, 0, 1, 0, 0));
      let d = new Path2D();
      (d.rect(i, a, n, r),
        t.clip(d),
        (t.globalCompositeOperation = `destination-in`),
        t.drawImage(c, l, u, n, r, i, a, n, r),
        t.restore());
    }
    save(e) {
      (this.inSMaskMode && q4(this.ctx, this.suspendedCtx), this.ctx.save());
      let t = this.current;
      (this.stateStack.push(t), (this.current = t.clone()), this.dependencyTracker?.save(e));
    }
    restore(e) {
      if ((this.dependencyTracker?.restore(e), this.stateStack.length === 0)) {
        this.inSMaskMode && this.endSMaskMode();
        return;
      }
      ((this.current = this.stateStack.pop()),
        this.ctx.restore(),
        this.inSMaskMode &&
          (q4(this.suspendedCtx, this.ctx),
          this.ctx.setTransform(this.suspendedCtx.getTransform())),
        this.checkSMaskState(e),
        (this.pendingClip = null),
        (this._cachedScaleForStroking[0] = -1),
        (this._cachedGetSinglePixelWidth = null));
    }
    transform(e, t, n, r, i, a, o) {
      (this.dependencyTracker?.recordIncrementalData(`transform`, e),
        this.ctx.transform(t, n, r, i, a, o),
        (this._cachedScaleForStroking[0] = -1),
        (this._cachedGetSinglePixelWidth = null));
    }
    constructPath(e, t, n, r) {
      let [i] = n;
      if (!r) {
        ((i ||= n[0] = new Path2D()),
          t !== C0.stroke && t !== C0.closeStroke && (this.current.tilingPatternDims = null),
          this[t](e, i));
        return;
      }
      if (this.dependencyTracker !== null) {
        let n = t === C0.stroke ? this.current.lineWidth / 2 : 0;
        this.dependencyTracker
          .resetBBox(e)
          .recordBBox(e, this.ctx, r[0] - n, r[2] + n, r[1] - n, r[3] + n)
          .recordDependencies(e, [`transform`]);
      }
      (i instanceof Path2D || (i = n[0] = U2(i)),
        Y0.axialAlignedBoundingBox(r, O2(this.ctx), this.current.minMax));
      let a = this.current.tilingPatternDims;
      if (a && t !== C0.stroke && t !== C0.closeStroke && this.current.fillColor instanceof I4) {
        let e = Y0.intersect(this.current.clipBox, this.current.minMax);
        e
          ? this.current.fillColor.updatePatternDims(e, a)
          : (this.current.tilingPatternDims = null);
      }
      (this[t](e, i), (this._pathStartIdx = e));
    }
    closePath(e) {
      this.ctx.closePath();
    }
    stroke(e, t, n = !0) {
      let r = this.ctx,
        i = this.current.strokeColor;
      if (((r.globalAlpha = this.current.strokeAlpha), this.contentVisible))
        if (typeof i == `object` && i?.getPattern) {
          let n = i.isModifyingCurrentTransform() ? r.getTransform() : null;
          if ((r.save(), (r.strokeStyle = i.getPattern(r, this, k2(r), M4.STROKE, e)), n)) {
            let e = new Path2D();
            (e.addPath(t, r.getTransform().invertSelf().multiplySelf(n)), (t = e));
          }
          (this.rescaleAndStroke(t, !1), r.restore());
        } else this.rescaleAndStroke(t, !0);
      (this.dependencyTracker?.recordDependencies(e, _4.stroke),
        n &&
          this.consumePath(e, t, this.current.getClippedPathBoundingBox(M4.STROKE, O2(this.ctx))),
        (r.globalAlpha = this.current.fillAlpha));
    }
    closeStroke(e, t) {
      this.stroke(e, t);
    }
    fill(e, t, n = !0) {
      let r = this.ctx,
        i = this.current.fillColor,
        a = this.current.patternFill,
        o = !1,
        s = this.current.getClippedPathBoundingBox();
      if ((this.dependencyTracker?.recordDependencies(e, _4.fill), a)) {
        let a = this.current.tilingPatternDims,
          c = a && i.canSkipPatternCanvas(a);
        if (c) {
          (i.drawPattern(this, t, this.pendingEOFill, c, e),
            (this.pendingEOFill = !1),
            n && this.consumePath(e, t, s),
            (this.current.tilingPatternDims = null));
          return;
        }
        let l = i.isModifyingCurrentTransform() ? r.getTransform() : null;
        if (
          (this.dependencyTracker?.save(e),
          r.save(),
          (r.fillStyle = i.getPattern(r, this, k2(r), M4.FILL, e)),
          l)
        ) {
          let e = new Path2D();
          (e.addPath(t, r.getTransform().invertSelf().multiplySelf(l)), (t = e));
        }
        o = !0;
      }
      (this.contentVisible &&
        s !== null &&
        (this.pendingEOFill ? (r.fill(t, `evenodd`), (this.pendingEOFill = !1)) : r.fill(t)),
        o && (r.restore(), this.dependencyTracker?.restore(e)),
        n && this.consumePath(e, t, s));
    }
    eoFill(e, t) {
      ((this.pendingEOFill = !0), this.fill(e, t));
    }
    fillStroke(e, t) {
      (this.fill(e, t, !1), this.stroke(e, t, !1), this.consumePath(e, t));
    }
    eoFillStroke(e, t) {
      ((this.pendingEOFill = !0), this.fillStroke(e, t));
    }
    closeFillStroke(e, t) {
      this.fillStroke(e, t);
    }
    closeEOFillStroke(e, t) {
      ((this.pendingEOFill = !0), this.fillStroke(e, t));
    }
    endPath(e, t) {
      this.consumePath(e, t);
    }
    rawFillPath(e, t) {
      (this.ctx.fill(t),
        this.dependencyTracker?.recordDependencies(e, _4.rawFillPath).recordOperation(e));
    }
    clip(e) {
      (this.dependencyTracker?.recordFutureForcedDependency(`clipMode`, e),
        (this.pendingClip = Wse));
    }
    eoClip(e) {
      (this.dependencyTracker?.recordFutureForcedDependency(`clipMode`, e),
        (this.pendingClip = X4));
    }
    beginText(e) {
      ((this.current.textMatrix = null),
        (this.current.textMatrixScale = 1),
        (this.current.x = this.current.lineX = 0),
        (this.current.y = this.current.lineY = 0),
        this.dependencyTracker
          ?.recordOpenMarker(e)
          .resetIncrementalData(`sameLineText`)
          .resetIncrementalData(`moveText`, e));
    }
    endText(e) {
      let t = this.pendingTextPaths,
        n = this.ctx;
      if (this.dependencyTracker) {
        let { dependencyTracker: n } = this;
        (t !== void 0 &&
          n
            .recordFutureForcedDependency(`textClip`, n.getOpenMarker())
            .recordFutureForcedDependency(`textClip`, e),
          n.recordCloseMarker(e));
      }
      if (t !== void 0) {
        let e = new Path2D(),
          r = n.getTransform().invertSelf();
        for (let { transform: n, x: i, y: a, fontSize: o, path: s } of t)
          s && e.addPath(s, new DOMMatrix(n).preMultiplySelf(r).translate(i, a).scale(o, -o));
        n.clip(e);
      }
      delete this.pendingTextPaths;
    }
    setCharSpacing(e, t) {
      (this.dependencyTracker?.recordSimpleData(`charSpacing`, e), (this.current.charSpacing = t));
    }
    setWordSpacing(e, t) {
      (this.dependencyTracker?.recordSimpleData(`wordSpacing`, e), (this.current.wordSpacing = t));
    }
    setHScale(e, t) {
      (this.dependencyTracker?.recordSimpleData(`hScale`, e), (this.current.textHScale = t / 100));
    }
    setLeading(e, t) {
      (this.dependencyTracker?.recordSimpleData(`leading`, e), (this.current.leading = -t));
    }
    setFont(e, t, n) {
      this.dependencyTracker
        ?.recordSimpleData(`font`, e)
        .recordSimpleDataFromNamed(`fontObj`, t, e);
      let r = this.commonObjs.get(t),
        i = this.current;
      if (!r) throw Error(`Can't find font for ${t}`);
      if (
        ((i.fontMatrix = r.fontMatrix || u0),
        (i.fontMatrix[0] === 0 || i.fontMatrix[3] === 0) && A0(`Invalid font matrix for font ` + t),
        n < 0 ? ((n = -n), (i.fontDirection = -1)) : (i.fontDirection = 1),
        (this.current.font = r),
        (this.current.fontSize = n),
        r.isType3Font)
      )
        return;
      let a = r.loadedName || `sans-serif`,
        o = r.systemFontInfo?.css || `"${a}", ${r.fallbackName}`,
        s = `normal`;
      r.black ? (s = `900`) : r.bold && (s = `bold`);
      let c = r.italic ? `italic` : `normal`,
        l = n;
      (n < L4 ? (l = L4) : n > R4 && (l = R4),
        (this.current.fontSizeScale = n / l),
        (this.ctx.font = `${c} ${s} ${l}px ${o}`));
    }
    setTextRenderingMode(e, t) {
      (this.dependencyTracker?.recordSimpleData(`textRenderingMode`, e),
        (this.current.textRenderingMode = t));
    }
    setTextRise(e, t) {
      (this.dependencyTracker?.recordSimpleData(`textRise`, e), (this.current.textRise = t));
    }
    moveText(e, t, n) {
      (this.dependencyTracker
        ?.resetIncrementalData(`sameLineText`)
        .recordIncrementalData(`moveText`, e),
        (this.current.x = this.current.lineX += t),
        (this.current.y = this.current.lineY += n));
    }
    setLeadingMoveText(e, t, n) {
      (this.setLeading(e, -n), this.moveText(e, t, n));
    }
    setTextMatrix(e, t) {
      this.dependencyTracker
        ?.resetIncrementalData(`sameLineText`)
        .recordSimpleData(`textMatrix`, e);
      let { current: n } = this;
      ((n.textMatrix = t),
        (n.textMatrixScale = Math.hypot(t[0], t[1])),
        (n.x = n.lineX = 0),
        (n.y = n.lineY = 0));
    }
    nextLine(e) {
      (this.moveText(e, 0, this.current.leading),
        this.dependencyTracker?.recordIncrementalData(
          `moveText`,
          this.dependencyTracker.getSimpleIndex(`leading`) ?? e,
        ));
    }
    #n(e, t, n) {
      let r = new Path2D();
      return (r.addPath(e, new DOMMatrix(n).invertSelf().multiplySelf(t)), r);
    }
    paintChar(e, t, n, r, i, a) {
      let o = this.ctx,
        s = this.current,
        c = s.font,
        l = s.textRenderingMode,
        u = s.fontSize / s.fontSizeScale,
        d = l & v0.FILL_STROKE_MASK,
        f = !!(l & v0.ADD_TO_PATH_FLAG),
        p = s.patternFill && !c.missingFile,
        m = s.patternStroke && !c.missingFile,
        h;
      if (
        ((c.disableFontFace || f || p || m) &&
          !c.missingFile &&
          (h = c.getPathGenerator(this.commonObjs, t)),
        h && (c.disableFontFace || p || m))
      ) {
        (o.save(),
          o.translate(n, r),
          o.scale(u, -u),
          this.dependencyTracker?.recordCharacterBBox(e, o, c));
        let t;
        if (d === v0.FILL || d === v0.FILL_STROKE)
          if (i) {
            ((t = o.getTransform()), o.setTransform(...i));
            let e = this.#n(h, t, i);
            o.fill(e);
          } else o.fill(h);
        if (d === v0.STROKE || d === v0.FILL_STROKE)
          if (a) {
            ((t ||= o.getTransform()), o.setTransform(...a));
            let { a: e, b: n, c: r, d: i } = t,
              s = Y0.inverseTransform(a),
              c = Y0.transform([e, n, r, i, 0, 0], s);
            (Y0.singularValueDecompose2dScale(c, H4),
              (o.lineWidth *= Math.max(H4[0], H4[1]) / u),
              o.stroke(this.#n(h, t, a)));
          } else ((o.lineWidth /= u), o.stroke(h));
        o.restore();
      } else
        ((d === v0.FILL || d === v0.FILL_STROKE) &&
          (o.fillText(t, n, r),
          this.dependencyTracker?.recordCharacterBBox(e, o, c, u, n, r, () => o.measureText(t))),
          (d === v0.STROKE || d === v0.FILL_STROKE) &&
            (this.dependencyTracker &&
              this.dependencyTracker
                ?.recordCharacterBBox(e, o, c, u, n, r, () => o.measureText(t))
                .recordDependencies(e, _4.stroke),
            o.strokeText(t, n, r)));
      f &&
        ((this.pendingTextPaths ||= []).push({
          transform: O2(o),
          x: n,
          y: r,
          fontSize: u,
          path: h,
        }),
        this.dependencyTracker?.recordCharacterBBox(e, o, c, u, n, r));
    }
    get isFontSubpixelAAEnabled() {
      let e = this.canvasFactory.create(10, 10),
        t = e.context;
      (t.scale(1.5, 1), t.fillText(`I`, 0, 10));
      let n = t.getImageData(0, 0, 10, 10).data;
      this.canvasFactory.destroy(e);
      let r = !1;
      for (let e = 3; e < n.length; e += 4)
        if (n[e] > 0 && n[e] < 255) {
          r = !0;
          break;
        }
      return L0(this, `isFontSubpixelAAEnabled`, r);
    }
    showText(e, t) {
      this.dependencyTracker &&
        (this.dependencyTracker.recordDependencies(e, _4.showText).resetBBox(e),
        this.current.textRenderingMode & v0.ADD_TO_PATH_FLAG &&
          this.dependencyTracker
            .recordFutureForcedDependency(`textClip`, e)
            .inheritPendingDependenciesAsFutureForcedDependencies());
      let n = this.current,
        r = n.font;
      if (r.isType3Font) {
        (this.showType3Text(e, t), this.dependencyTracker?.recordShowTextOperation(e));
        return;
      }
      let i = n.fontSize;
      if (i === 0) {
        this.dependencyTracker?.recordOperation(e);
        return;
      }
      let a = this.ctx,
        o = n.fontSizeScale,
        s = n.charSpacing,
        c = n.wordSpacing,
        l = n.fontDirection,
        u = n.textHScale * l,
        d = t.length,
        f = r.vertical,
        p = f ? 1 : -1,
        m = r.defaultVMetrics,
        h = i * n.fontMatrix[0],
        g = n.textRenderingMode === v0.FILL && !r.disableFontFace && !n.patternFill;
      (a.save(),
        n.textMatrix && a.transform(...n.textMatrix),
        a.translate(n.x, n.y + n.textRise),
        l > 0 ? a.scale(u, -1) : a.scale(u, 1));
      let v,
        y,
        b = n.textRenderingMode & v0.FILL_STROKE_MASK,
        x = b === v0.FILL || b === v0.FILL_STROKE,
        S = b === v0.STROKE || b === v0.FILL_STROKE,
        C = n.lineWidth,
        w = n.textMatrixScale;
      if (
        (w === 0 || C === 0 ? S && (C = this.getSinglePixelWidth()) : (C /= w),
        o !== 1 && (a.scale(o, o), (C /= o)),
        (a.lineWidth = C),
        x && n.patternFill)
      ) {
        a.save();
        let t = n.fillColor.getPattern(a, this, k2(a), M4.FILL, e);
        ((v = O2(a)), a.restore(), (a.fillStyle = t));
      }
      if (S && n.patternStroke) {
        a.save();
        let t = n.strokeColor.getPattern(a, this, k2(a), M4.STROKE, e);
        ((y = O2(a)), a.restore(), (a.strokeStyle = t));
      }
      if (r.isInvalidPDFjsFont) {
        let r = [],
          i = 0;
        for (let e of t) (r.push(e.unicode), (i += e.width));
        let o = r.join(``);
        if ((a.fillText(o, 0, 0), this.dependencyTracker !== null)) {
          let t = a.measureText(o);
          this.dependencyTracker
            .recordBBox(
              e,
              this.ctx,
              -t.actualBoundingBoxLeft,
              t.actualBoundingBoxRight,
              -t.actualBoundingBoxAscent,
              t.actualBoundingBoxDescent,
            )
            .recordShowTextOperation(e);
        }
        ((n.x += i * h * u), a.restore(), this.compose());
        return;
      }
      let T = 0,
        E;
      for (E = 0; E < d; ++E) {
        let n = t[E];
        if (typeof n == `number`) {
          T += (p * n * i) / 1e3;
          continue;
        }
        let u = !1,
          d = (n.isSpace ? c : 0) + s,
          b = n.fontChar,
          x = n.accent,
          S,
          C,
          w = n.width;
        if (f) {
          let e = n.vmetric || m,
            t = -(n.vmetric ? e[1] : w * 0.5) * h,
            r = e[2] * h;
          ((w = e ? -e[0] : w), (S = t / o), (C = (T + r) / o));
        } else ((S = T / o), (C = 0));
        let D;
        if (r.remeasure && w > 0) {
          D = a.measureText(b);
          let e = ((D.width * 1e3) / i) * o;
          if (w < e && this.isFontSubpixelAAEnabled) {
            let t = w / e;
            ((u = !0), a.save(), a.scale(t, 1), (S /= t));
          } else w !== e && (S += (((w - e) / 2e3) * i) / o);
        }
        if (this.contentVisible && (n.isInFont || r.missingFile)) {
          if (g && !x)
            (a.fillText(b, S, C),
              this.dependencyTracker?.recordCharacterBBox(
                e,
                a,
                D
                  ? {
                      bbox: null,
                    }
                  : r,
                i / o,
                S,
                C,
                () => D ?? a.measureText(b),
              ));
          else if ((this.paintChar(e, b, S, C, v, y), x)) {
            let t = S + (i * x.offset.x) / o,
              n = C - (i * x.offset.y) / o;
            this.paintChar(e, x.fontChar, t, n, v, y);
          }
        }
        let ee = f ? w * h - d * l : w * h + d * l;
        ((T += ee), u && a.restore());
      }
      (f ? (n.y -= T) : (n.x += T * u),
        a.restore(),
        this.compose(),
        this.dependencyTracker?.recordShowTextOperation(e));
    }
    showType3Text(e, t) {
      let n = this.ctx,
        r = this.current,
        i = r.font,
        a = r.fontSize,
        o = r.fontDirection,
        s = i.vertical ? 1 : -1,
        c = r.charSpacing,
        l = r.wordSpacing,
        u = r.textHScale * o,
        d = r.fontMatrix || u0,
        f = t.length,
        p = r.textRenderingMode === v0.INVISIBLE,
        m,
        h,
        g,
        v;
      if (p || a === 0) return;
      ((this._cachedScaleForStroking[0] = -1),
        (this._cachedGetSinglePixelWidth = null),
        n.save(),
        r.textMatrix && n.transform(...r.textMatrix),
        n.translate(r.x, r.y + r.textRise),
        n.scale(u, o));
      let y = this.dependencyTracker;
      for (this.dependencyTracker = y ? new g4(y, e) : null, m = 0; m < f; ++m) {
        if (((h = t[m]), typeof h == `number`)) {
          ((v = (s * h * a) / 1e3), this.ctx.translate(v, 0), (r.x += v * u));
          continue;
        }
        let e = (h.isSpace ? l : 0) + c,
          o = i.charProcOperatorList[h.operatorListId];
        o
          ? this.contentVisible &&
            (this.save(),
            n.scale(a, a),
            n.transform(...d),
            this.executeOperatorList(o),
            this.restore())
          : A0(`Type3 character "${h.operatorListId}" is not available.`);
        let f = [h.width, 0];
        (Y0.applyTransform(f, d), (g = f[0] * a + e), n.translate(g, 0), (r.x += g * u));
      }
      (n.restore(), y && (this.dependencyTracker = y));
    }
    setCharWidth(e, t, n) {}
    setCharWidthAndBounds(e, t, n, r, i, a, o) {
      let s = new Path2D();
      (s.rect(r, i, a - r, o - i),
        this.ctx.clip(s),
        this.dependencyTracker
          ?.recordBBox(e, this.ctx, r, a, i, o)
          .recordClipBox(e, this.ctx, r, a, i, o),
        this.endPath(e));
    }
    getColorN_Pattern(t, n) {
      let r;
      if (n[0] === `TilingPattern`) {
        let t = this.baseTransform || O2(this.ctx);
        r = new I4(
          n,
          this.ctx,
          {
            createCanvasGraphics: (t, n) =>
              new e(
                t,
                this.commonObjs,
                this.objs,
                this.canvasFactory,
                this.filterFactory,
                {
                  optionalContentConfig: this.optionalContentConfig,
                  markedContentStack: this.markedContentStack,
                },
                void 0,
                void 0,
                this.dependencyTracker ? new g4(this.dependencyTracker, n, !0) : null,
              ),
          },
          t,
        );
      } else r = this._getPattern(t, n[1], n[2]);
      return r;
    }
    setStrokeColorN(e, ...t) {
      (this.dependencyTracker?.recordSimpleData(`strokeColor`, e),
        (this.current.strokeColor = this.getColorN_Pattern(e, t)),
        (this.current.patternStroke = !0));
    }
    setFillColorN(e, ...t) {
      this.dependencyTracker?.recordSimpleData(`fillColor`, e);
      let n = (this.current.fillColor = this.getColorN_Pattern(e, t));
      ((this.current.patternFill = !0),
        (this.current.tilingPatternDims = n instanceof I4 ? [0, 0, 0, 0] : null));
    }
    setStrokeRGBColor(e, t) {
      (this.dependencyTracker?.recordSimpleData(`strokeColor`, e),
        (this.ctx.strokeStyle = this.current.strokeColor = t),
        (this.current.patternStroke = !1));
    }
    setStrokeTransparent(e) {
      (this.dependencyTracker?.recordSimpleData(`strokeColor`, e),
        (this.ctx.strokeStyle = this.current.strokeColor = `transparent`),
        (this.current.patternStroke = !1));
    }
    setFillRGBColor(e, t) {
      (this.dependencyTracker?.recordSimpleData(`fillColor`, e),
        (this.ctx.fillStyle = this.current.fillColor = t),
        (this.current.patternFill = !1),
        (this.current.tilingPatternDims = null));
    }
    setFillTransparent(e) {
      (this.dependencyTracker?.recordSimpleData(`fillColor`, e),
        (this.ctx.fillStyle = this.current.fillColor = `transparent`),
        (this.current.patternFill = !1),
        (this.current.tilingPatternDims = null));
    }
    _getPattern(e, t, n = null) {
      let r;
      return (
        this.cachedPatterns.has(t)
          ? (r = this.cachedPatterns.get(t))
          : ((r = Rse(this.getObject(e, t))), this.cachedPatterns.set(t, r)),
        n && (r.matrix = n),
        r
      );
    }
    shadingFill(e, t) {
      if (!this.contentVisible) return;
      let n = this.ctx;
      (this.save(e),
        (n.fillStyle = this._getPattern(e, t).getPattern(n, this, k2(n), M4.SHADING, e)));
      let r = k2(n);
      if (r) {
        let { width: e, height: t } = n.canvas,
          i = l0.slice();
        Y0.axialAlignedBoundingBox([0, 0, e, t], r, i);
        let [a, o, s, c] = i;
        this.ctx.fillRect(a, o, s - a, c - o);
      } else this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      (this.dependencyTracker
        ?.resetBBox(e)
        .recordFullPageBBox(e)
        .recordDependencies(e, _4.transform)
        .recordDependencies(e, _4.fill)
        .recordOperation(e),
        this.compose(this.current.getClippedPathBoundingBox()),
        this.restore(e));
    }
    beginInlineImage() {
      j0(`Should not call beginInlineImage`);
    }
    beginImageData() {
      j0(`Should not call beginImageData`);
    }
    paintFormXObjectBegin(e, t, n) {
      if (
        this.contentVisible &&
        (this.save(e),
        this.baseTransformStack.push(this.baseTransform),
        t && this.transform(e, ...t),
        (this.baseTransform = O2(this.ctx)),
        n)
      ) {
        Y0.axialAlignedBoundingBox(n, this.baseTransform, this.current.minMax);
        let [t, r, i, a] = n,
          o = new Path2D();
        (o.rect(t, r, i - t, a - r),
          this.ctx.clip(o),
          this.dependencyTracker?.recordClipBox(e, this.ctx, t, i, r, a),
          this.endPath(e));
      }
    }
    paintFormXObjectEnd(e) {
      this.contentVisible &&
        (this.restore(e), (this.baseTransform = this.baseTransformStack.pop()));
    }
    beginGroup(e, t) {
      if (!this.contentVisible) return;
      this.save(e);
      let { inSMaskMode: n } = this;
      n && (this.endSMaskMode(), (this.current.activeSMask = null));
      let r = this.ctx;
      if (
        (t.isolated || k0(`TODO: Support non-isolated groups.`),
        t.knockout && A0(`Knockout groups not supported.`),
        !t.needsIsolation &&
          r.globalAlpha === 1 &&
          r.globalCompositeOperation === `source-over` &&
          !n)
      ) {
        if (t.bbox) {
          let e = new Path2D(),
            [n, i, a, o] = t.bbox;
          if ((e.rect(n, i, a - n, o - i), t.matrix)) {
            let n = new Path2D();
            (n.addPath(e, new DOMMatrix(t.matrix)), (e = n));
          }
          r.clip(e);
        }
        (this.groupStack.push(null), this.groupLevel++);
        return;
      }
      let i = O2(r);
      t.matrix && r.transform(...t.matrix);
      let a = [0, 0, r.canvas.width, r.canvas.height],
        o;
      t.bbox
        ? ((o = l0.slice()),
          Y0.axialAlignedBoundingBox(t.bbox, O2(r), o),
          (o = Y0.intersect(o, a) || [0, 0, 0, 0]))
        : (o = a);
      let s = Math.floor(o[0]),
        c = Math.floor(o[1]),
        l = Math.max(Math.ceil(o[2]) - s, 1),
        u = Math.max(Math.ceil(o[3]) - c, 1);
      this.current.startNewPathAndClipBox([0, 0, l, u]);
      let d = this.canvasFactory.create(l, u);
      t.smask && this.smaskGroupCanvases.push(d);
      let f = d.context;
      if (
        (f.translate(-s, -c),
        f.transform(...i),
        !t.isolated &&
          !t.smask &&
          n &&
          t.needsIsolation &&
          (f.save(), f.setTransform(1, 0, 0, 1, 0, 0), f.drawImage(r.canvas, -s, -c), f.restore()),
        t.bbox)
      ) {
        let e = new Path2D(),
          [n, r, i, a] = t.bbox;
        if ((e.rect(n, r, i - n, a - r), t.matrix)) {
          let n = new Path2D();
          (n.addPath(e, new DOMMatrix(t.matrix)), (e = n));
        }
        f.clip(e);
      }
      (t.smask &&
        this.smaskStack.push({
          canvas: d.canvas,
          context: f,
          offsetX: s,
          offsetY: c,
          subtype: t.smask.subtype,
          backdrop: t.smask.backdrop,
          transferMap: t.smask.transferMap || null,
        }),
        (!t.smask || this.dependencyTracker) &&
          (r.setTransform(1, 0, 0, 1, 0, 0), r.translate(s, c), r.save()),
        q4(r, f),
        (this.ctx = f),
        this.dependencyTracker
          ?.inheritSimpleDataAsFutureForcedDependencies([
            `fillAlpha`,
            `strokeAlpha`,
            `globalCompositeOperation`,
          ])
          .pushBaseTransform(r),
        this.setGState(e, [
          [`BM`, `source-over`],
          [`ca`, 1],
          [`CA`, 1],
          [`TR`, null],
        ]),
        this.groupStack.push(r),
        this.groupLevel++);
    }
    endGroup(e, t) {
      if (!this.contentVisible) return;
      this.groupLevel--;
      let n = this.ctx,
        r = this.groupStack.pop();
      if (r === null) {
        this.restore(e);
        return;
      }
      if (
        ((this.ctx = r),
        (this.ctx.imageSmoothingEnabled = !1),
        this.dependencyTracker?.popBaseTransform(),
        t.smask)
      )
        ((this.tempSMask = this.smaskStack.pop()),
          this.restore(e),
          this.dependencyTracker &&
            (this.ctx.restore(),
            this.inSMaskMode && this.ctx.setTransform(this.suspendedCtx.getTransform())));
      else {
        this.ctx.restore();
        let t = O2(this.ctx);
        (this.restore(e), this.ctx.save(), this.ctx.setTransform(...t));
        let r = l0.slice();
        (Y0.axialAlignedBoundingBox([0, 0, n.canvas.width, n.canvas.height], t, r),
          this.ctx.drawImage(n.canvas, 0, 0),
          this.ctx.restore(),
          this.canvasFactory.destroy({
            canvas: n.canvas,
            context: n,
          }),
          this.compose(r));
      }
    }
    beginAnnotation(e, t, n, r, i, a) {
      if (
        (this.#e(),
        J4(this.ctx),
        this.ctx.save(),
        this.save(e),
        this.baseTransform && this.ctx.setTransform(...this.baseTransform),
        n)
      ) {
        let i = n[2] - n[0],
          o = n[3] - n[1];
        if (a && this.annotationCanvasMap) {
          ((r = r.slice()),
            (r[4] -= n[0]),
            (r[5] -= n[1]),
            (n = n.slice()),
            (n[0] = n[1] = 0),
            (n[2] = i),
            (n[3] = o),
            Y0.singularValueDecompose2dScale(O2(this.ctx), H4));
          let { viewportScale: e } = this,
            a = Math.ceil(i * this.outputScaleX * e),
            s = Math.ceil(o * this.outputScaleY * e);
          this.annotationCanvas = this.canvasFactory.create(a, s);
          let { canvas: c, context: l } = this.annotationCanvas;
          (this.annotationCanvasMap.set(t, c),
            (this.annotationCanvas.savedCtx = this.ctx),
            (this.ctx = l),
            this.ctx.save(),
            this.ctx.setTransform(H4[0], 0, 0, -H4[1], 0, o * H4[1]),
            J4(this.ctx));
        } else {
          (J4(this.ctx), this.endPath(e));
          let t = new Path2D();
          (t.rect(n[0], n[1], i, o), this.ctx.clip(t));
        }
      }
      ((this.current = new W4(this.ctx.canvas.width, this.ctx.canvas.height)),
        this.baseTransformStack.push(this.baseTransform),
        this.transform(e, ...r),
        this.transform(e, ...i),
        (this.baseTransform = O2(this.ctx)));
    }
    endAnnotation(e) {
      (this.annotationCanvas &&
        (this.ctx.restore(),
        this.#t(),
        (this.ctx = this.annotationCanvas.savedCtx),
        delete this.annotationCanvas.savedCtx,
        delete this.annotationCanvas),
        (this.baseTransform = this.baseTransformStack.pop()));
    }
    paintImageMaskXObject(e, t) {
      if (!this.contentVisible) return;
      let n = t.count;
      ((t = this.getObject(e, t.data, t)), (t.count = n));
      let r = this.ctx,
        i = this._createMaskCanvas(e, t),
        a = i.canvas;
      (r.save(),
        r.setTransform(1, 0, 0, 1, 0, 0),
        r.drawImage(a, i.offsetX, i.offsetY),
        this.dependencyTracker
          ?.resetBBox(e)
          .recordBBox(e, this.ctx, i.offsetX, i.offsetX + a.width, i.offsetY, i.offsetY + a.height)
          .recordOperation(e),
        r.restore(),
        i.canvasEntry && this.canvasFactory.destroy(i.canvasEntry),
        this.compose());
    }
    paintImageMaskXObjectRepeat(e, t, n, r = 0, i = 0, a, o) {
      if (!this.contentVisible) return;
      t = this.getObject(e, t.data, t);
      let s = this.ctx;
      s.save();
      let c = O2(s);
      s.transform(n, r, i, a, 0, 0);
      let l = this._createMaskCanvas(e, t);
      (s.setTransform(1, 0, 0, 1, l.offsetX - c[4], l.offsetY - c[5]),
        this.dependencyTracker?.resetBBox(e));
      for (let t = 0, u = o.length; t < u; t += 2) {
        let u = Y0.transform(c, [n, r, i, a, o[t], o[t + 1]]);
        (s.drawImage(l.canvas, u[4], u[5]),
          this.dependencyTracker?.recordBBox(
            e,
            this.ctx,
            u[4],
            u[4] + l.canvas.width,
            u[5],
            u[5] + l.canvas.height,
          ));
      }
      (s.restore(),
        l.canvasEntry && this.canvasFactory.destroy(l.canvasEntry),
        this.compose(),
        this.dependencyTracker?.recordOperation(e));
    }
    paintImageMaskXObjectGroup(e, t) {
      if (!this.contentVisible) return;
      let n = this.ctx,
        r = this.current.fillColor,
        i = this.current.patternFill;
      this.dependencyTracker?.resetBBox(e).recordDependencies(e, _4.transformAndFill);
      for (let a of t) {
        let { data: t, width: o, height: s, transform: c } = a,
          l = this.canvasFactory.create(o, s),
          u = l.context;
        (u.save(),
          K4(u, this.getObject(e, t, a)),
          (u.globalCompositeOperation = `source-in`),
          (u.fillStyle = i ? r.getPattern(u, this, k2(n), M4.FILL, e) : r),
          u.fillRect(0, 0, o, s),
          u.restore(),
          n.save(),
          n.transform(...c),
          n.scale(1, -1),
          U4(n, l.canvas, 0, 0, o, s, 0, -1, 1, 1),
          this.canvasFactory.destroy(l),
          this.dependencyTracker?.recordBBox(e, n, 0, o, 0, s),
          n.restore());
      }
      (this.compose(), this.dependencyTracker?.recordOperation(e));
    }
    paintImageXObject(e, t) {
      if (!this.contentVisible) return;
      let n = this.getObject(e, t);
      if (!n) {
        A0(`Dependent image isn't ready yet`);
        return;
      }
      this.paintInlineImageXObject(e, n);
    }
    paintImageXObjectRepeat(e, t, n, r, i) {
      if (!this.contentVisible) return;
      let a = this.getObject(e, t);
      if (!a) {
        A0(`Dependent image isn't ready yet`);
        return;
      }
      let o = a.width,
        s = a.height,
        c = [];
      for (let e = 0, t = i.length; e < t; e += 2)
        c.push({
          transform: [n, 0, 0, r, i[e], i[e + 1]],
          x: 0,
          y: 0,
          w: o,
          h: s,
        });
      this.paintInlineImageXObjectGroup(e, a, c);
    }
    applyTransferMapsToCanvas(e) {
      return (
        this.current.transferMaps !== `none` &&
          ((e.filter = this.current.transferMaps),
          e.drawImage(e.canvas, 0, 0),
          (e.filter = `none`)),
        e.canvas
      );
    }
    applyTransferMapsToBitmap(e) {
      if (this.current.transferMaps === `none`)
        return {
          img: e.bitmap,
          canvasEntry: null,
        };
      let { bitmap: t, width: n, height: r } = e,
        i = this.canvasFactory.create(n, r),
        a = i.context;
      return (
        (a.filter = this.current.transferMaps),
        a.drawImage(t, 0, 0),
        (a.filter = `none`),
        {
          img: i.canvas,
          canvasEntry: i,
        }
      );
    }
    paintInlineImageXObject(e, t) {
      if (!this.contentVisible) return;
      let n = t.width,
        r = t.height,
        i = this.ctx;
      this.save(e);
      let { filter: a } = i;
      (a !== `none` && a !== `` && (i.filter = `none`), i.scale(1 / n, -1 / r));
      let o,
        s = null;
      if (t.bitmap) {
        let e = this.applyTransferMapsToBitmap(t);
        ((o = e.img), (s = e.canvasEntry));
      } else if ((typeof HTMLElement == `function` && t instanceof HTMLElement) || !t.data) o = t;
      else {
        let e = this.canvasFactory.create(n, r);
        (G4(e.context, t), (o = this.applyTransferMapsToCanvas(e.context)), (s = e));
      }
      let c = this._scaleImage(o, k2(i));
      ((i.imageSmoothingEnabled = Y4(O2(i), t.interpolate)),
        this.dependencyTracker &&
          (this.dependencyTracker
            .resetBBox(e)
            .recordBBox(e, i, 0, n, -r, 0)
            .recordDependencies(e, _4.imageXObject)
            .recordOperation(e),
          this.imagesTracker?.record(i, n, r, this.dependencyTracker.clipBox)),
        U4(i, c.img, 0, 0, c.paintWidth, c.paintHeight, 0, -r, n, r),
        c.tmpCanvas && this.canvasFactory.destroy(c.tmpCanvas),
        s && this.canvasFactory.destroy(s),
        this.compose(),
        this.restore(e));
    }
    paintInlineImageXObjectGroup(e, t, n) {
      if (!this.contentVisible) return;
      let r = this.ctx,
        i,
        a = null;
      if (t.bitmap) i = t.bitmap;
      else {
        let e = t.width,
          n = t.height,
          r = this.canvasFactory.create(e, n);
        (G4(r.context, t), (i = this.applyTransferMapsToCanvas(r.context)), (a = r));
      }
      this.dependencyTracker?.resetBBox(e);
      for (let t of n)
        (r.save(),
          r.transform(...t.transform),
          r.scale(1, -1),
          U4(r, i, t.x, t.y, t.w, t.h, 0, -1, 1, 1),
          this.dependencyTracker?.recordBBox(e, r, 0, 1, -1, 0),
          r.restore());
      (a && this.canvasFactory.destroy(a),
        this.dependencyTracker?.recordOperation(e),
        this.compose());
    }
    paintSolidColorImageMask(e) {
      this.contentVisible &&
        (this.dependencyTracker
          ?.resetBBox(e)
          .recordBBox(e, this.ctx, 0, 1, 0, 1)
          .recordDependencies(e, _4.fill)
          .recordOperation(e),
        this.ctx.fillRect(0, 0, 1, 1),
        this.compose());
    }
    markPoint(e, t) {}
    markPointProps(e, t, n) {}
    beginMarkedContent(e, t) {
      (this.dependencyTracker?.beginMarkedContent(e),
        this.markedContentStack.push({
          visible: !0,
        }));
    }
    beginMarkedContentProps(e, t, n) {
      (this.dependencyTracker?.beginMarkedContent(e),
        t === `OC`
          ? this.markedContentStack.push({
              visible: this.optionalContentConfig.isVisible(n),
            })
          : this.markedContentStack.push({
              visible: !0,
            }),
        (this.contentVisible = this.isContentVisible()));
    }
    endMarkedContent(e) {
      (this.dependencyTracker?.endMarkedContent(e),
        this.markedContentStack.pop(),
        (this.contentVisible = this.isContentVisible()));
    }
    beginCompat(e) {}
    endCompat(e) {}
    consumePath(e, t, n) {
      let r = this.current.isEmptyClip();
      (this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(n));
      let i = this.ctx;
      (this.pendingClip
        ? (r || (this.pendingClip === X4 ? i.clip(t, `evenodd`) : i.clip(t)),
          (this.pendingClip = null),
          this.dependencyTracker
            ?.bboxToClipBoxDropOperation(e)
            .recordFutureForcedDependency(`clipPath`, e))
        : this.dependencyTracker?.recordOperation(e),
        this.current.startNewPathAndClipBox(this.current.clipBox));
    }
    getSinglePixelWidth() {
      if (!this._cachedGetSinglePixelWidth) {
        let e = O2(this.ctx);
        if (e[1] === 0 && e[2] === 0)
          this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(e[0]), Math.abs(e[3]));
        else {
          let t = Math.abs(e[0] * e[3] - e[2] * e[1]),
            n = Math.hypot(e[0], e[2]),
            r = Math.hypot(e[1], e[3]);
          this._cachedGetSinglePixelWidth = Math.max(n, r) / t;
        }
      }
      return this._cachedGetSinglePixelWidth;
    }
    getScaleForStroking() {
      if (this._cachedScaleForStroking[0] === -1) {
        let { lineWidth: e } = this.current,
          { a: t, b: n, c: r, d: i } = this.ctx.getTransform(),
          a,
          o;
        if (n === 0 && r === 0) {
          let n = Math.abs(t),
            r = Math.abs(i);
          if (n === r) {
            if (e === 0) a = o = 1 / n;
            else {
              let t = n * e;
              a = o = t < 1 ? 1 / t : 1;
            }
          } else if (e === 0) ((a = 1 / n), (o = 1 / r));
          else {
            let t = n * e,
              i = r * e;
            ((a = t < 1 ? 1 / t : 1), (o = i < 1 ? 1 / i : 1));
          }
        } else {
          let s = Math.abs(t * i - n * r),
            c = Math.hypot(t, n),
            l = Math.hypot(r, i);
          if (e === 0) ((a = l / s), (o = c / s));
          else {
            let t = e * s;
            ((a = l > t ? l / t : 1), (o = c > t ? c / t : 1));
          }
        }
        ((this._cachedScaleForStroking[0] = a), (this._cachedScaleForStroking[1] = o));
      }
      return this._cachedScaleForStroking;
    }
    rescaleAndStroke(e, t) {
      let {
          ctx: n,
          current: { lineWidth: r },
        } = this,
        [i, a] = this.getScaleForStroking();
      if (i === a) {
        ((n.lineWidth = (r || 1) * i), n.stroke(e));
        return;
      }
      let o = n.getLineDash();
      (t && n.save(), n.scale(i, a), (V4.a = 1 / i), (V4.d = 1 / a));
      let s = new Path2D();
      if ((s.addPath(e, V4), o.length > 0)) {
        let e = Math.max(i, a);
        (n.setLineDash(o.map((t) => t / e)), (n.lineDashOffset /= e));
      }
      ((n.lineWidth = r || 1), n.stroke(s), t && n.restore());
    }
    isContentVisible() {
      for (let e = this.markedContentStack.length - 1; e >= 0; e--)
        if (!this.markedContentStack[e].visible) return !1;
      return !0;
    }
  };
for (let e in C0) Z4.prototype[e] !== void 0 && (Z4.prototype[C0[e]] = Z4.prototype[e]);
var Q4 = class {
    #e = null;
    #t = null;
    _fullReader = null;
    _rangeReaders = new Set();
    _source = null;
    constructor(e, t, n) {
      ((this._source = e), (this.#e = t), (this.#t = n));
    }
    get _progressiveDataLength() {
      return this._fullReader?._loaded ?? 0;
    }
    getFullReader() {
      return (
        M0(!this._fullReader, `BasePDFStream.getFullReader can only be called once.`),
        (this._fullReader = new this.#e(this))
      );
    }
    getRangeReader(e, t) {
      if (t <= this._progressiveDataLength) return null;
      let n = new this.#t(this, e, t);
      return (this._rangeReaders.add(n), n);
    }
    cancelAllRequests(e) {
      this._fullReader?.cancel(e);
      for (let t of new Set(this._rangeReaders)) t.cancel(e);
    }
  },
  $4 = class {
    onProgress = null;
    _contentLength = 0;
    _filename = null;
    _headersCapability = Promise.withResolvers();
    _isRangeSupported = !1;
    _isStreamingSupported = !1;
    _loaded = 0;
    _stream = null;
    constructor(e) {
      this._stream = e;
    }
    _callOnProgress() {
      this.onProgress?.({
        loaded: this._loaded,
        total: this._contentLength,
      });
    }
    get headersReady() {
      return this._headersCapability.promise;
    }
    get filename() {
      return this._filename;
    }
    get contentLength() {
      return this._contentLength;
    }
    get isRangeSupported() {
      return this._isRangeSupported;
    }
    get isStreamingSupported() {
      return this._isStreamingSupported;
    }
    async read() {
      j0("Abstract method `read` called");
    }
    cancel(e) {
      j0("Abstract method `cancel` called");
    }
  },
  e3 = class {
    _stream = null;
    constructor(e, t, n) {
      this._stream = e;
    }
    async read() {
      j0("Abstract method `read` called");
    }
    cancel(e) {
      j0("Abstract method `cancel` called");
    }
  };
function Gse(e) {
  let t = !0,
    n = r(`filename\\*`, `i`).exec(e);
  if (n) {
    n = n[1];
    let e = s(n);
    return ((e = unescape(e)), (e = c(e)), (e = l(e)), a(e));
  }
  if (((n = o(e)), n)) return a(l(n));
  if (((n = r(`filename`, `i`).exec(e)), n)) {
    n = n[1];
    let e = s(n);
    return ((e = l(e)), a(e));
  }
  function r(e, t) {
    return RegExp(`(?:^|;)\\s*` + e + `\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)`, t);
  }
  function i(e, n) {
    if (e) {
      if (!/^[\x00-\xFF]+$/.test(n)) return n;
      try {
        let r = new TextDecoder(e, {
            fatal: !0,
          }),
          i = K0(n);
        ((n = r.decode(i)), (t = !1));
      } catch {}
    }
    return n;
  }
  function a(e) {
    return (t && /[\x80-\xff]/.test(e) && ((e = i(`utf-8`, e)), t && (e = i(`iso-8859-1`, e))), e);
  }
  function o(e) {
    let t = [],
      n,
      i = r(`filename\\*((?!0\\d)\\d+)(\\*?)`, `ig`);
    for (; (n = i.exec(e)) !== null;) {
      let [, e, r, i] = n;
      if (((e = parseInt(e, 10)), e in t)) {
        if (e === 0) break;
        continue;
      }
      t[e] = [r, i];
    }
    let a = [];
    for (let e = 0; e < t.length && e in t; ++e) {
      let [n, r] = t[e];
      ((r = s(r)), n && ((r = unescape(r)), e === 0 && (r = c(r))), a.push(r));
    }
    return a.join(``);
  }
  function s(e) {
    if (e.startsWith(`"`)) {
      let t = e.slice(1).split(`\\"`);
      for (let e = 0; e < t.length; ++e) {
        let n = t[e].indexOf(`"`);
        (n !== -1 && ((t[e] = t[e].slice(0, n)), (t.length = e + 1)),
          (t[e] = t[e].replaceAll(/\\(.)/g, `$1`)));
      }
      e = t.join(`"`);
    }
    return e;
  }
  function c(e) {
    let t = e.indexOf(`'`);
    return t === -1 ? e : i(e.slice(0, t), e.slice(t + 1).replace(/^[^']*'/, ``));
  }
  function l(e) {
    return !e.startsWith(`=?`) || /[\x00-\x19\x80-\xff]/.test(e)
      ? e
      : e.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (e, t, n, r) {
          if (n === `q` || n === `Q`)
            return (
              (r = r.replaceAll(`_`, ` `)),
              (r = r.replaceAll(/=([0-9a-fA-F]{2})/g, function (e, t) {
                return String.fromCharCode(parseInt(t, 16));
              })),
              i(t, r)
            );
          try {
            r = atob(r);
          } catch {}
          return i(t, r);
        });
  }
  return ``;
}
function t3(e, t) {
  let n = new Headers();
  if (!e || !t || typeof t != `object`) return n;
  for (let e in t) {
    let r = t[e];
    r !== void 0 && n.append(e, r);
  }
  return n;
}
function n3(e) {
  return URL.parse(e)?.origin ?? null;
}
function r3({ responseHeaders: e, isHttp: t, rangeChunkSize: n, disableRange: r }) {
  let i = {
      contentLength: 0,
      isRangeSupported: !1,
    },
    a = parseInt(e.get(`Content-Length`), 10);
  return (
    !Number.isInteger(a) ||
      ((i.contentLength = a), a <= 2 * n) ||
      r ||
      !t ||
      e.get(`Accept-Ranges`) !== `bytes` ||
      ((e.get(`Content-Encoding`) || `identity`) === `identity` && (i.isRangeSupported = !0)),
    i
  );
}
function i3(e) {
  let t = e.get(`Content-Disposition`);
  if (t) {
    let e = Gse(t);
    if (e.includes(`%`))
      try {
        e = decodeURIComponent(e);
      } catch {}
    if (h2(e)) return e;
  }
  return null;
}
function a3(e, t) {
  return new H0(
    `Unexpected server response (${e}) while retrieving PDF "${t.href}".`,
    e,
    e === 404 || (e === 0 && t.protocol === `file:`),
  );
}
function o3(e, t) {
  if (e !== t) throw Error(`Expected range response-origin "${e}" to match "${t}".`);
}
function s3(e, t, n, r) {
  return fetch(e, {
    method: `GET`,
    headers: t,
    signal: r.signal,
    mode: `cors`,
    credentials: n ? `include` : `same-origin`,
    redirect: `follow`,
  });
}
function c3(e, t) {
  if (e !== 200 && e !== 206) throw a3(e, t);
}
function l3(e) {
  if (e instanceof Uint8Array) return e.buffer;
  if (e instanceof ArrayBuffer) return e;
  throw Error(`getArrayBuffer - unexpected data: ${e}`);
}
var Kse = class extends Q4 {
    _responseOrigin = null;
    constructor(e) {
      super(e, qse, Jse);
      let { httpHeaders: t, url: n } = e;
      (M0(/https?:/.test(n.protocol), `PDFFetchStream only supports http(s):// URLs.`),
        (this.headers = t3(!0, t)));
    }
  },
  qse = class extends $4 {
    _abortController = new AbortController();
    _reader = null;
    constructor(e) {
      super(e);
      let {
        disableRange: t,
        disableStream: n,
        rangeChunkSize: r,
        url: i,
        withCredentials: a,
      } = e._source;
      ((this._isStreamingSupported = !n),
        s3(i, new Headers(e.headers), a, this._abortController)
          .then((n) => {
            ((e._responseOrigin = n3(n.url)), c3(n.status, i), (this._reader = n.body.getReader()));
            let a = n.headers,
              { contentLength: o, isRangeSupported: s } = r3({
                responseHeaders: a,
                isHttp: !0,
                rangeChunkSize: r,
                disableRange: t,
              });
            ((this._contentLength = o),
              (this._isRangeSupported = s),
              (this._filename = i3(a)),
              !this._isStreamingSupported &&
                this._isRangeSupported &&
                this.cancel(new W0(`Streaming is disabled.`)),
              this._headersCapability.resolve());
          })
          .catch(this._headersCapability.reject));
    }
    async read() {
      await this._headersCapability.promise;
      let { value: e, done: t } = await this._reader.read();
      return t
        ? {
            value: e,
            done: t,
          }
        : ((this._loaded += e.byteLength),
          this._callOnProgress(),
          {
            value: l3(e),
            done: !1,
          });
    }
    cancel(e) {
      (this._reader?.cancel(e), this._abortController.abort());
    }
  },
  Jse = class extends e3 {
    _abortController = new AbortController();
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(e, t, n) {
      super(e, t, n);
      let { url: r, withCredentials: i } = e._source,
        a = new Headers(e.headers);
      (a.append(`Range`, `bytes=${t}-${n - 1}`),
        s3(r, a, i, this._abortController)
          .then((t) => {
            (o3(n3(t.url), e._responseOrigin),
              c3(t.status, r),
              (this._reader = t.body.getReader()),
              this._readCapability.resolve());
          })
          .catch(this._readCapability.reject));
    }
    async read() {
      await this._readCapability.promise;
      let { value: e, done: t } = await this._reader.read();
      return t
        ? {
            value: e,
            done: t,
          }
        : {
            value: l3(e),
            done: !1,
          };
    }
    cancel(e) {
      (this._reader?.cancel(e), this._abortController.abort());
    }
  };
function u3(e) {
  return e instanceof Uint8Array && e.byteLength === e.buffer.byteLength
    ? e.buffer
    : new Uint8Array(e).buffer;
}
function d3() {
  for (let e of this._requests)
    e.resolve({
      value: void 0,
      done: !0,
    });
  this._requests.length = 0;
}
var Yse = class extends Q4 {
    _progressiveDone = !1;
    _queuedChunks = [];
    constructor(e) {
      super(e, Xse, Zse);
      let { pdfDataRangeTransport: t } = e,
        { initialData: n, progressiveDone: r } = t;
      if (n?.length > 0) {
        let e = u3(n);
        this._queuedChunks.push(e);
      }
      ((this._progressiveDone = r),
        t.transportReady((e) => {
          switch (e.type) {
            case `range`:
            case `progressiveRead`:
              this.#e(e.begin, e.chunk);
              break;
            case `progressiveDone`:
              (this._fullReader?.progressiveDone(), (this._progressiveDone = !0));
              break;
          }
        }));
    }
    #e(e, t) {
      let n = u3(t);
      if (e === void 0)
        this._fullReader ? this._fullReader._enqueue(n) : this._queuedChunks.push(n);
      else {
        let t = this._rangeReaders.keys().find((t) => t._begin === e);
        (M0(t, "#onReceiveData - no `PDFDataTransportStreamRangeReader` instance found."),
          t._enqueue(n));
      }
    }
    getFullReader() {
      let e = super.getFullReader();
      return ((this._queuedChunks = null), e);
    }
    getRangeReader(e, t) {
      let n = super.getRangeReader(e, t);
      return (
        n &&
          ((n.onDone = () => this._rangeReaders.delete(n)),
          this._source.pdfDataRangeTransport.requestDataRange(e, t)),
        n
      );
    }
    cancelAllRequests(e) {
      (super.cancelAllRequests(e), this._source.pdfDataRangeTransport.abort());
    }
  },
  Xse = class extends $4 {
    #e = d3.bind(this);
    _done = !1;
    _queuedChunks = null;
    _requests = [];
    constructor(e) {
      super(e);
      let { pdfDataRangeTransport: t, disableRange: n, disableStream: r } = e._source,
        { length: i, contentDispositionFilename: a } = t;
      this._queuedChunks = e._queuedChunks || [];
      for (let e of this._queuedChunks) this._loaded += e.byteLength;
      ((this._done = e._progressiveDone),
        (this._contentLength = i),
        (this._isStreamingSupported = !r),
        (this._isRangeSupported = !n),
        h2(a) && (this._filename = a),
        this._headersCapability.resolve());
      let o = this._loaded;
      Promise.resolve().then(() => {
        o > 0 && this._loaded === o && this._callOnProgress();
      });
    }
    _enqueue(e) {
      this._done ||
        (this._requests.length > 0
          ? this._requests.shift().resolve({
              value: e,
              done: !1,
            })
          : this._queuedChunks.push(e),
        (this._loaded += e.byteLength),
        this._callOnProgress());
    }
    async read() {
      if (this._queuedChunks.length > 0)
        return {
          value: this._queuedChunks.shift(),
          done: !1,
        };
      if (this._done)
        return {
          value: void 0,
          done: !0,
        };
      let e = Promise.withResolvers();
      return (this._requests.push(e), e.promise);
    }
    cancel(e) {
      ((this._done = !0), this.#e());
    }
    progressiveDone() {
      ((this._done ||= !0), this._queuedChunks.length === 0 && this.#e());
    }
  },
  Zse = class extends e3 {
    #e = d3.bind(this);
    onDone = null;
    _begin = -1;
    _done = !1;
    _queuedChunk = null;
    _requests = [];
    constructor(e, t, n) {
      (super(e, t, n), (this._begin = t));
    }
    _enqueue(e) {
      this._done ||
        (this._requests.length === 0
          ? (this._queuedChunk = e)
          : (this._requests.shift().resolve({
              value: e,
              done: !1,
            }),
            this.#e()),
        (this._done = !0),
        this.onDone?.());
    }
    async read() {
      if (this._queuedChunk) {
        let e = this._queuedChunk;
        return (
          (this._queuedChunk = null),
          {
            value: e,
            done: !1,
          }
        );
      }
      if (this._done)
        return {
          value: void 0,
          done: !0,
        };
      let e = Promise.withResolvers();
      return (this._requests.push(e), e.promise);
    }
    cancel(e) {
      ((this._done = !0), this.#e(), this.onDone?.());
    }
  },
  f3 = 200,
  p3 = 206;
function Qse(e) {
  return typeof e == `string` ? K0(e).buffer : e;
}
var $se = class extends Q4 {
    #e = new WeakMap();
    _responseOrigin = null;
    constructor(e) {
      super(e, ece, tce);
      let { httpHeaders: t, url: n } = e;
      ((this.url = n),
        (this.isHttp = /https?:/.test(n.protocol)),
        (this.headers = t3(this.isHttp, t)));
    }
    _request(e) {
      let t = new XMLHttpRequest(),
        n = {
          validateStatus: null,
          onHeadersReceived: e.onHeadersReceived,
          onDone: e.onDone,
          onError: e.onError,
          onProgress: e.onProgress,
        };
      (this.#e.set(t, n),
        t.open(`GET`, this.url),
        (t.withCredentials = this._source.withCredentials));
      for (let [e, n] of this.headers) t.setRequestHeader(e, n);
      return (
        this.isHttp && `begin` in e && `end` in e
          ? (t.setRequestHeader(`Range`, `bytes=${e.begin}-${e.end - 1}`),
            (n.validateStatus = (e) => e === p3 || e === f3))
          : (n.validateStatus = (e) => e === f3),
        (t.responseType = `arraybuffer`),
        M0(e.onError, "Expected `onError` callback to be provided."),
        (t.onerror = () => e.onError(t.status)),
        (t.onreadystatechange = this.#n.bind(this, t)),
        (t.onprogress = this.#t.bind(this, t)),
        t.send(null),
        t
      );
    }
    #t(e, t) {
      this.#e.get(e)?.onProgress?.(t);
    }
    #n(e, t) {
      let n = this.#e.get(e);
      if (
        !n ||
        (e.readyState >= 2 &&
          n.onHeadersReceived &&
          (n.onHeadersReceived(), delete n.onHeadersReceived),
        e.readyState !== 4) ||
        !this.#e.has(e)
      )
        return;
      if ((this.#e.delete(e), e.status === 0 && this.isHttp)) {
        n.onError(e.status);
        return;
      }
      let r = e.status || f3;
      if (!n.validateStatus(r)) {
        n.onError(e.status);
        return;
      }
      let i = Qse(e.response);
      if (r === p3) {
        let t = e.getResponseHeader(`Content-Range`);
        /bytes (\d+)-(\d+)\/(\d+)/.test(t)
          ? n.onDone(i)
          : (A0(`Missing or invalid "Content-Range" header.`), n.onError(0));
      } else i ? n.onDone(i) : n.onError(e.status);
    }
    _abortRequest(e) {
      this.#e.has(e) && (this.#e.delete(e), e.abort());
    }
    getRangeReader(e, t) {
      let n = super.getRangeReader(e, t);
      return (n && (n.onClosed = () => this._rangeReaders.delete(n)), n);
    }
  },
  ece = class extends $4 {
    #e = d3.bind(this);
    _cachedChunks = [];
    _done = !1;
    _requests = [];
    _storedError = null;
    constructor(e) {
      (super(e),
        (this._fullRequestXhr = e._request({
          onHeadersReceived: this.#t.bind(this),
          onDone: this.#n.bind(this),
          onError: this.#r.bind(this),
          onProgress: this.#i.bind(this),
        })));
    }
    #t() {
      let e = this._stream,
        { disableRange: t, rangeChunkSize: n } = e._source,
        r = this._fullRequestXhr;
      e._responseOrigin = n3(r.responseURL);
      let i = r.getAllResponseHeaders(),
        a = new Headers(
          i
            ? i
                .trimStart()
                .replace(/[^\S ]+$/, ``)
                .split(/[\r\n]+/)
                .map((e) => {
                  let [t, ...n] = e.split(`: `);
                  return [t, n.join(`: `)];
                })
            : [],
        ),
        { contentLength: o, isRangeSupported: s } = r3({
          responseHeaders: a,
          isHttp: e.isHttp,
          rangeChunkSize: n,
          disableRange: t,
        });
      ((this._contentLength = o),
        (this._isRangeSupported = s),
        (this._filename = i3(a)),
        this._isRangeSupported && e._abortRequest(r),
        this._headersCapability.resolve());
    }
    #n(e) {
      (this._requests.length > 0
        ? this._requests.shift().resolve({
            value: e,
            done: !1,
          })
        : this._cachedChunks.push(e),
        (this._done = !0),
        this._cachedChunks.length === 0 && this.#e());
    }
    #r(e) {
      ((this._storedError = a3(e, this._stream.url)),
        this._headersCapability.reject(this._storedError));
      for (let e of this._requests) e.reject(this._storedError);
      ((this._requests.length = 0), (this._cachedChunks.length = 0));
    }
    #i(e) {
      this.onProgress?.({
        loaded: e.loaded,
        total: e.lengthComputable ? e.total : this._contentLength,
      });
    }
    async read() {
      if ((await this._headersCapability.promise, this._storedError)) throw this._storedError;
      if (this._cachedChunks.length > 0)
        return {
          value: this._cachedChunks.shift(),
          done: !1,
        };
      if (this._done)
        return {
          value: void 0,
          done: !0,
        };
      let e = Promise.withResolvers();
      return (this._requests.push(e), e.promise);
    }
    cancel(e) {
      ((this._done = !0),
        this._headersCapability.reject(e),
        this.#e(),
        this._stream._abortRequest(this._fullRequestXhr),
        (this._fullRequestXhr = null));
    }
  },
  tce = class extends e3 {
    #e = d3.bind(this);
    onClosed = null;
    _done = !1;
    _queuedChunk = null;
    _requests = [];
    _storedError = null;
    constructor(e, t, n) {
      (super(e, t, n),
        (this._requestXhr = e._request({
          begin: t,
          end: n,
          onHeadersReceived: this.#t.bind(this),
          onDone: this.#n.bind(this),
          onError: this.#r.bind(this),
          onProgress: null,
        })));
    }
    #t() {
      let e = n3(this._requestXhr?.responseURL);
      try {
        o3(e, this._stream._responseOrigin);
      } catch (e) {
        ((this._storedError = e), this.#r(0));
      }
    }
    #n(e) {
      (this._requests.length > 0
        ? this._requests.shift().resolve({
            value: e,
            done: !1,
          })
        : (this._queuedChunk = e),
        (this._done = !0),
        this.#e(),
        this.onClosed?.());
    }
    #r(e) {
      this._storedError ??= a3(e, this._stream.url);
      for (let e of this._requests) e.reject(this._storedError);
      ((this._requests.length = 0), (this._queuedChunk = null));
    }
    async read() {
      if (this._storedError) throw this._storedError;
      if (this._queuedChunk !== null) {
        let e = this._queuedChunk;
        return (
          (this._queuedChunk = null),
          {
            value: e,
            done: !1,
          }
        );
      }
      if (this._done)
        return {
          value: void 0,
          done: !0,
        };
      let e = Promise.withResolvers();
      return (this._requests.push(e), e.promise);
    }
    cancel(e) {
      ((this._done = !0),
        this.#e(),
        this._stream._abortRequest(this._requestXhr),
        this.onClosed?.());
    }
  };
function m3(e, t = null) {
  let n = process.getBuiltinModule(`fs`),
    { Readable: r } = process.getBuiltinModule(`stream`),
    i = n.createReadStream(e, t);
  return r.toWeb(i);
}
var nce = class extends Q4 {
    constructor(e) {
      super(e, rce, ice);
      let { url: t } = e;
      M0(t.protocol === `file:`, `PDFNodeStream only supports file:// URLs.`);
    }
  },
  rce = class extends $4 {
    _reader = null;
    constructor(e) {
      super(e);
      let { disableRange: t, disableStream: n, rangeChunkSize: r, url: i } = e._source;
      ((this._isStreamingSupported = !n),
        process
          .getBuiltinModule(`fs/promises`)
          .lstat(i)
          .then((e) => {
            let n = m3(i);
            this._reader = n.getReader();
            let { size: a } = e;
            ((this._contentLength = a),
              (this._isRangeSupported = !t && a > 2 * r),
              !this._isStreamingSupported &&
                this._isRangeSupported &&
                this.cancel(new W0(`Streaming is disabled.`)),
              this._headersCapability.resolve());
          })
          .catch((e) => {
            (e.code === `ENOENT` && (e = a3(0, i)), this._headersCapability.reject(e));
          }));
    }
    async read() {
      await this._headersCapability.promise;
      let { value: e, done: t } = await this._reader.read();
      return t
        ? {
            value: e,
            done: t,
          }
        : ((this._loaded += e.byteLength),
          this._callOnProgress(),
          {
            value: l3(e),
            done: !1,
          });
    }
    cancel(e) {
      this._reader?.cancel(e);
    }
  },
  ice = class extends e3 {
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(e, t, n) {
      super(e, t, n);
      let { url: r } = e._source;
      try {
        let e = m3(r, {
          start: t,
          end: n - 1,
        });
        ((this._reader = e.getReader()), this._readCapability.resolve());
      } catch (e) {
        this._readCapability.reject(e);
      }
    }
    async read() {
      await this._readCapability.promise;
      let { value: e, done: t } = await this._reader.read();
      return t
        ? {
            value: e,
            done: t,
          }
        : {
            value: l3(e),
            done: !1,
          };
    }
    cancel(e) {
      this._reader?.cancel(e);
    }
  };
function ace(e) {
  return y2(e) ? Kse : s0 ? nce : $se;
}
var h3 = class {
    static #e = null;
    static #t = ``;
    static get workerPort() {
      return this.#e;
    }
    static set workerPort(e) {
      if (!(typeof Worker < `u` && e instanceof Worker) && e !== null)
        throw Error("Invalid `workerPort` type.");
      this.#e = e;
    }
    static get workerSrc() {
      return this.#t;
    }
    static set workerSrc(e) {
      if (typeof e != `string`) throw Error("Invalid `workerSrc` type.");
      this.#t = e;
    }
  },
  oce = class {
    #e;
    #t;
    constructor({ parsedData: e, rawData: t }) {
      ((this.#e = e), (this.#t = t));
    }
    getRaw() {
      return this.#t;
    }
    get(e) {
      return this.#e.get(e) ?? null;
    }
    [Symbol.iterator]() {
      return this.#e.entries();
    }
  },
  g3 = Symbol(`INTERNAL`),
  sce = class {
    #e = !1;
    #t = !1;
    #n = !1;
    #r = !0;
    constructor(e, { name: t, intent: n, usage: r, rbGroups: i }) {
      ((this.#e = !!(e & f0.DISPLAY)),
        (this.#t = !!(e & f0.PRINT)),
        (this.name = t),
        (this.intent = n),
        (this.usage = r),
        (this.rbGroups = i));
    }
    get visible() {
      if (this.#n) return this.#r;
      if (!this.#r) return !1;
      let { print: e, view: t } = this.usage;
      return this.#e ? t?.viewState !== `OFF` : this.#t ? e?.printState !== `OFF` : !0;
    }
    _setVisible(e, t, n = !1) {
      (e !== g3 && j0("Internal method `_setVisible` called."), (this.#n = n), (this.#r = t));
    }
  },
  cce = class {
    #e = null;
    #t = new Map();
    #n = null;
    #r = null;
    constructor(e, t = f0.DISPLAY) {
      if (((this.renderingIntent = t), (this.name = null), (this.creator = null), e !== null)) {
        ((this.name = e.name), (this.creator = e.creator), (this.#r = e.order));
        for (let n of e.groups) this.#t.set(n.id, new sce(t, n));
        if (e.baseState === `OFF`) for (let e of this.#t.values()) e._setVisible(g3, !1);
        for (let t of e.on) this.#t.get(t)._setVisible(g3, !0);
        for (let t of e.off) this.#t.get(t)._setVisible(g3, !1);
        this.#n = this.getHash();
      }
    }
    #i(e) {
      let t = e.length;
      if (t < 2) return !0;
      let n = e[0];
      for (let r = 1; r < t; r++) {
        let t = e[r],
          i;
        if (Array.isArray(t)) i = this.#i(t);
        else if (this.#t.has(t)) i = this.#t.get(t).visible;
        else return (A0(`Optional content group not found: ${t}`), !0);
        switch (n) {
          case `And`:
            if (!i) return !1;
            break;
          case `Or`:
            if (i) return !0;
            break;
          case `Not`:
            return !i;
          default:
            return !0;
        }
      }
      return n === `And`;
    }
    isVisible(e) {
      if (this.#t.size === 0) return !0;
      if (!e) return (k0(`Optional content group not defined.`), !0);
      if (e.type === `OCG`)
        return this.#t.has(e.id)
          ? this.#t.get(e.id).visible
          : (A0(`Optional content group not found: ${e.id}`), !0);
      if (e.type === `OCMD`) {
        if (e.expression) return this.#i(e.expression);
        if (!e.policy || e.policy === `AnyOn`) {
          for (let t of e.ids) {
            if (!this.#t.has(t)) return (A0(`Optional content group not found: ${t}`), !0);
            if (this.#t.get(t).visible) return !0;
          }
          return !1;
        } else if (e.policy === `AllOn`) {
          for (let t of e.ids) {
            if (!this.#t.has(t)) return (A0(`Optional content group not found: ${t}`), !0);
            if (!this.#t.get(t).visible) return !1;
          }
          return !0;
        } else if (e.policy === `AnyOff`) {
          for (let t of e.ids) {
            if (!this.#t.has(t)) return (A0(`Optional content group not found: ${t}`), !0);
            if (!this.#t.get(t).visible) return !0;
          }
          return !1;
        } else if (e.policy === `AllOff`) {
          for (let t of e.ids) {
            if (!this.#t.has(t)) return (A0(`Optional content group not found: ${t}`), !0);
            if (this.#t.get(t).visible) return !1;
          }
          return !0;
        }
        return (A0(`Unknown optional content policy ${e.policy}.`), !0);
      }
      return (A0(`Unknown group type ${e.type}.`), !0);
    }
    setVisibility(e, t = !0, n = !0) {
      let r = this.#t.get(e);
      if (!r) {
        A0(`Optional content group not found: ${e}`);
        return;
      }
      if (n && t && r.rbGroups.length)
        for (let t of r.rbGroups)
          for (let n of t) n !== e && this.#t.get(n)?._setVisible(g3, !1, !0);
      (r._setVisible(g3, !!t, !0), (this.#e = null));
    }
    setOCGState({ state: e, preserveRB: t }) {
      let n;
      for (let r of e) {
        switch (r) {
          case `ON`:
          case `OFF`:
          case `Toggle`:
            n = r;
            continue;
        }
        let e = this.#t.get(r);
        if (e)
          switch (n) {
            case `ON`:
              this.setVisibility(r, !0, t);
              break;
            case `OFF`:
              this.setVisibility(r, !1, t);
              break;
            case `Toggle`:
              this.setVisibility(r, !e.visible, t);
              break;
          }
      }
      this.#e = null;
    }
    get hasInitialVisibility() {
      return this.#n === null || this.getHash() === this.#n;
    }
    getOrder() {
      return this.#t.size ? (this.#r ? this.#r.slice() : [...this.#t.keys()]) : null;
    }
    getGroup(e) {
      return this.#t.get(e) || null;
    }
    getHash() {
      if (this.#e !== null) return this.#e;
      let e = new o4();
      for (let [t, n] of this.#t) e.update(`${t}:${n.visible}`);
      return (this.#e = e.hexdigest());
    }
    [Symbol.iterator]() {
      return this.#t.entries();
    }
  },
  lce = class {
    #e = null;
    #t = null;
    #n = 0;
    #r = null;
    #i = null;
    get pagesNumber() {
      return this.#n;
    }
    set pagesNumber(e) {
      this.#n !== e && ((this.#n = e), (this.#e = null), (this.#t = null));
    }
    #a() {
      if (this.#e) return;
      let e = this.#n,
        t = (this.#e = new Uint32Array(e));
      for (let n = 0; n < e; n++) t[n] = n + 1;
      this.#t = new Int32Array(t);
    }
    #o() {
      let e = new Map(),
        t = this.#e;
      for (let n = 0, r = this.#n; n < r; n++) {
        let r = t[n],
          i = e.get(r);
        i ? i.push(n + 1) : e.set(r, [n + 1]);
      }
      return e;
    }
    movePages(e, t, n) {
      this.#a();
      let r = this.#e,
        i = this.#o(),
        a = t.length,
        o = new Uint32Array(a),
        s = 0;
      for (let e = 0; e < a; e++) {
        let i = t[e] - 1;
        ((o[e] = r[i]), i < n && s++);
      }
      let c = this.#n,
        l = c - a,
        u = o2(n - s, 0, l);
      for (let t = 0, n = 0; t < c; t++) e.has(t + 1) || (r[n++] = r[t]);
      (r.copyWithin(u + a, u, l),
        r.set(o, u),
        this.#s(i),
        r.every((e, t) => e === t + 1) && (this.#e = null));
    }
    deletePages(e) {
      this.#a();
      let t = this.#e,
        n = this.#o();
      this.#i = {
        pageNumberToId: t.slice(),
        pagesNumber: this.#n,
        prevPageNumbers: this.#t.slice(),
      };
      let r = this.#n - e.length;
      this.#n = r;
      let i = (this.#e = new Uint32Array(r));
      this.#t = new Int32Array(r);
      let a = 0,
        o = 0;
      for (let n of e) {
        let e = n - 1;
        (e !== a && (i.set(t.subarray(a, e), o), (o += e - a)), (a = e + 1));
      }
      (a < t.length && i.set(t.subarray(a), o), this.#s(n, new Set(e)));
    }
    cancelDelete() {
      this.#i &&=
        ((this.#e = this.#i.pageNumberToId),
        (this.#n = this.#i.pagesNumber),
        (this.#t = this.#i.prevPageNumbers),
        null);
    }
    cleanSavedData() {
      this.#i = null;
    }
    copyPages(e) {
      (this.#a(),
        (this.#r = {
          pageNumbers: e,
          pageIds: e.map((e) => this.#e[e - 1]),
        }));
    }
    cancelCopy() {
      this.#r = null;
    }
    pastePages(e) {
      this.#a();
      let t = this.#e,
        n = this.#o(),
        { pageNumbers: r, pageIds: i } = this.#r,
        a = this.#n + r.length;
      this.#n = a;
      let o = (this.#e = new Uint32Array(a));
      ((this.#t = new Int32Array(a)),
        o.set(t.subarray(0, e), 0),
        o.set(i, e),
        o.set(t.subarray(e), e + r.length),
        this.#s(n, null, e, r),
        (this.#r = null));
    }
    #s(e, t = null, n = -1, r = null) {
      let i = this.#t,
        a = this.#e,
        o = n + (r?.length ?? 0),
        s = new Map();
      for (let c = 0, l = this.#n; c < l; c++) {
        if (c >= n && c < o) {
          i[c] = -r[c - n];
          continue;
        }
        let l = a[c],
          u = e.get(l),
          d = s.get(l) || 0;
        if (t && u) for (; d < u.length && t.has(u[d]);) d++;
        ((i[c] = u?.[d]), s.set(l, d + 1));
      }
    }
    hasBeenAltered() {
      return this.#e !== null;
    }
    getPageMappingForSaving(e = null) {
      e ??= this.#o();
      let t = 0;
      for (let n of e.values()) t = Math.max(t, n.length);
      let n = Array(t);
      for (let e = 0; e < t; e++)
        n[e] = {
          document: null,
          pageIndices: [],
          includePages: [],
        };
      for (let [t, r] of e)
        for (let e = 0, i = r.length; e < i; e++) n[e].includePages.push([t - 1, r[e] - 1]);
      for (let { includePages: e, pageIndices: t } of n) {
        e.sort((e, t) => e[0] - t[0]);
        for (let n = 0, r = e.length; n < r; n++) (t.push(e[n][1]), (e[n] = e[n][0]));
      }
      return n;
    }
    extractPages(e) {
      e = Array.from(e).sort((e, t) => e - t);
      let t = new Map();
      for (let n = 0, r = e.length; n < r; n++) {
        let r = this.getPageId(e[n]);
        t.getOrInsertComputed(r, r2).push(n + 1);
      }
      return this.getPageMappingForSaving(t);
    }
    getPrevPageNumber(e) {
      return this.#t?.[e - 1] ?? 0;
    }
    getPageNumber(e) {
      if (!this.#e) return e;
      let t = this.#e;
      for (let n = 0, r = this.#n; n < r; n++) if (t[n] === e) return n + 1;
      return 0;
    }
    getPageId(e) {
      return this.#e?.[e - 1] ?? e;
    }
    getMapping() {
      return this.#e?.subarray(0, this.pagesNumber);
    }
  },
  _3 = Symbol(`INITIAL_DATA`),
  v3 = () => ({
    ...Promise.withResolvers(),
    data: _3,
  }),
  y3 = class {
    #e = new Map();
    get(e, t = null) {
      if (t) {
        let n = this.#e.getOrInsertComputed(e, v3);
        return (n.promise.then(() => t(n.data)), null);
      }
      let n = this.#e.get(e);
      if (!n || n.data === _3) throw Error(`Requesting object that isn't resolved yet ${e}.`);
      return n.data;
    }
    has(e) {
      let t = this.#e.get(e);
      return !!t && t.data !== _3;
    }
    delete(e) {
      let t = this.#e.get(e);
      return !t || t.data === _3 ? !1 : (this.#e.delete(e), !0);
    }
    resolve(e, t = null) {
      let n = this.#e.getOrInsertComputed(e, v3);
      if (n.data !== _3) throw Error(`Object already resolved ${e}.`);
      ((n.data = t), n.resolve());
    }
    clear() {
      for (let { data: e } of this.#e.values()) e?.bitmap?.close();
      this.#e.clear();
    }
    *[Symbol.iterator]() {
      for (let [e, { data: t }] of this.#e) t !== _3 && (yield [e, t]);
    }
  },
  uce = 1e5,
  b3 = 30,
  x3 = class e {
    #e = Promise.withResolvers();
    #t = null;
    #n = !1;
    #r = !!globalThis.FontInspector?.enabled;
    #i = null;
    #a = null;
    #o = null;
    #s = 0;
    #c = 0;
    #l = null;
    #u = null;
    #d = 0;
    #f = 0;
    #p = Object.create(null);
    #m = [];
    #h = null;
    #g = [];
    #_ = new WeakMap();
    #v = null;
    static #y = new Map();
    static #b = new Map();
    static #x = new WeakMap();
    static #S = null;
    static #C = new Set();
    constructor({ textContentSource: t, images: n, container: r, viewport: i }) {
      if (t instanceof ReadableStream) this.#h = t;
      else if (typeof t == `object`)
        this.#h = new ReadableStream({
          start(e) {
            (e.enqueue(t), e.close());
          },
        });
      else throw Error(`No "textContentSource" parameter specified.`);
      ((this.#t = this.#u = r),
        (this.#i = n),
        (this.#f = i.scale * j2.pixelRatio),
        (this.#d = i.rotation),
        (this.#o = {
          div: null,
          properties: null,
          ctx: null,
        }));
      let { pageWidth: a, pageHeight: o, pageX: s, pageY: c } = i.rawDims;
      ((this.#v = [1, 0, 0, -1, -s, c + o]),
        (this.#c = a),
        (this.#s = o),
        e.#k(),
        r.style.setProperty(`--min-font-size`, e.#S),
        A2(r, i),
        this.#e.promise
          .finally(() => {
            (e.#C.delete(this), (this.#o = null), (this.#p = null));
          })
          .catch(() => {}));
    }
    static get fontFamilyMap() {
      let { isWindows: e, isFirefox: t } = J0.platform;
      return L0(
        this,
        `fontFamilyMap`,
        new Map([
          [`sans-serif`, `${e && t ? `Calibri, ` : ``}sans-serif`],
          [`monospace`, `${e && t ? `Lucida Console, ` : ``}monospace`],
        ]),
      );
    }
    render() {
      this.#i && this.#t.append(this.#i.render());
      let t = () => {
        this.#l.read().then(({ value: e, done: n }) => {
          if (n) {
            this.#e.resolve();
            return;
          }
          ((this.#a ??= e.lang), Object.assign(this.#p, e.styles), this.#w(e.items), t());
        }, this.#e.reject);
      };
      return ((this.#l = this.#h.getReader()), e.#C.add(this), t(), this.#e.promise);
    }
    update({ viewport: t, onBefore: n = null }) {
      let r = t.scale * j2.pixelRatio,
        i = t.rotation;
      if (
        (i !== this.#d &&
          (n?.(),
          (this.#d = i),
          A2(this.#u, {
            rotation: i,
          })),
        r !== this.#f)
      ) {
        (n?.(), (this.#f = r));
        let t = {
          div: null,
          properties: null,
          ctx: e.#D(this.#a),
        };
        for (let e of this.#g) ((t.properties = this.#_.get(e)), (t.div = e), this.#E(t));
      }
    }
    cancel() {
      let e = new W0(`TextLayer task cancelled.`);
      (this.#l?.cancel(e).catch(() => {}), (this.#l = null), this.#e.reject(e));
    }
    get textDivs() {
      return this.#g;
    }
    get textContentItemsStr() {
      return this.#m;
    }
    #w(t) {
      if (this.#n) return;
      this.#o.ctx ??= e.#D(this.#a);
      let n = this.#g,
        r = this.#m;
      for (let e of t) {
        if (n.length > uce) {
          (A0(`Ignoring additional textDivs for performance reasons.`), (this.#n = !0));
          return;
        }
        if (e.str === void 0) {
          if (e.type === `beginMarkedContentProps` || e.type === `beginMarkedContent`) {
            let t = this.#t;
            ((this.#t = document.createElement(`span`)),
              this.#t.classList.add(`markedContent`),
              e.id && this.#t.setAttribute(`id`, `${e.id}`),
              e.tag === `Artifact` && (this.#t.ariaHidden = !0),
              t.append(this.#t));
          } else e.type === `endMarkedContent` && (this.#t = this.#t.parentNode);
          continue;
        }
        (r.push(e.str), this.#T(e));
      }
    }
    #T(t) {
      let n = document.createElement(`span`),
        r = {
          angle: 0,
          canvasWidth: 0,
          hasText: t.str !== ``,
          hasEOL: t.hasEOL,
          fontSize: 0,
        };
      this.#g.push(n);
      let i = Y0.transform(this.#v, t.transform),
        a = Math.atan2(i[1], i[0]),
        o = this.#p[t.fontName];
      o.vertical && (a += Math.PI / 2);
      let s = (this.#r && o.fontSubstitution) || o.fontFamily;
      s = e.fontFamilyMap.get(s) || s;
      let c = Math.hypot(i[2], i[3]),
        l = c * e.#A(s, o, this.#a),
        u,
        d;
      a === 0
        ? ((u = i[4]), (d = i[5] - l))
        : ((u = i[4] + l * Math.sin(a)), (d = i[5] - l * Math.cos(a)));
      let f = n.style;
      ((f.left = `${((100 * u) / this.#c).toFixed(2)}%`),
        (f.top = `${((100 * d) / this.#s).toFixed(2)}%`),
        f.setProperty(`--font-height`, `${c.toFixed(2)}px`),
        (f.fontFamily = s),
        (r.fontSize = c),
        n.setAttribute(`role`, `presentation`),
        (n.textContent = t.str),
        (n.dir = t.dir),
        this.#r && (n.dataset.fontName = o.fontSubstitutionLoadedName || t.fontName),
        a !== 0 && (r.angle = (180 / Math.PI) * a));
      let p = !1;
      if (t.str.length > 1) p = !0;
      else if (t.str !== ` ` && t.transform[0] !== t.transform[3]) {
        let e = Math.abs(t.transform[0]),
          n = Math.abs(t.transform[3]);
        e !== n && Math.max(e, n) / Math.min(e, n) > 1.5 && (p = !0);
      }
      if (
        (p && (r.canvasWidth = o.vertical ? t.height : t.width),
        this.#_.set(n, r),
        (this.#o.div = n),
        (this.#o.properties = r),
        this.#E(this.#o),
        r.hasText && this.#t.append(n),
        r.hasEOL)
      ) {
        let e = document.createElement(`br`);
        (e.setAttribute(`role`, `presentation`), this.#t.append(e));
      }
    }
    #E(t) {
      let { div: n, properties: r, ctx: i } = t,
        { style: a } = n;
      if (r.canvasWidth !== 0 && r.hasText) {
        let { fontFamily: t } = a,
          { canvasWidth: o, fontSize: s } = r;
        e.#O(i, s * this.#f, t);
        let { width: c } = i.measureText(n.textContent);
        c > 0 && a.setProperty(`--scale-x`, (o * this.#f) / c);
      }
      r.angle !== 0 && a.setProperty(`--rotate`, `${r.angle}deg`);
    }
    static cleanup() {
      if (!(this.#C.size > 0)) {
        this.#y.clear();
        for (let { canvas: e } of this.#b.values()) e.remove();
        this.#b.clear();
      }
    }
    static #D(e = null) {
      let t = this.#b.get((e ||= ``));
      if (!t) {
        let n = document.createElement(`canvas`);
        ((n.className = `hiddenCanvasElement`),
          (n.lang = e),
          document.body.append(n),
          (t = n.getContext(`2d`, {
            alpha: !1,
            willReadFrequently: !0,
          })),
          this.#b.set(e, t),
          this.#x.set(t, {
            size: 0,
            family: ``,
          }));
      }
      return t;
    }
    static #O(e, t, n) {
      let r = this.#x.get(e);
      (t === r.size && n === r.family) || ((e.font = `${t}px ${n}`), (r.size = t), (r.family = n));
    }
    static #k() {
      if (this.#S !== null) return;
      let e = document.createElement(`div`);
      ((e.style.opacity = 0),
        (e.style.lineHeight = 1),
        (e.style.fontSize = `1px`),
        (e.style.position = `absolute`),
        (e.textContent = `X`),
        document.body.append(e),
        (this.#S = e.getBoundingClientRect().height),
        e.remove());
    }
    static #A(e, t, n) {
      let r = this.#y.get(e);
      if (r) return r;
      let i = this.#D(n);
      ((i.canvas.width = i.canvas.height = b3), this.#O(i, b3, e));
      let a = i.measureText(``),
        o = a.fontBoundingBoxAscent,
        s = Math.abs(a.fontBoundingBoxDescent);
      i.canvas.width = i.canvas.height = 0;
      let c = 0.8;
      return (
        o
          ? (c = o / (o + s))
          : (J0.platform.isFirefox &&
              A0(
                "Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering.",
              ),
            t.ascent ? (c = t.ascent) : t.descent && (c = 1 + t.descent)),
        this.#y.set(e, c),
        c
      );
    }
  },
  dce = 100;
function S3(e = {}) {
  typeof e == `string` || e instanceof URL
    ? (e = {
        url: e,
      })
    : (e instanceof ArrayBuffer || ArrayBuffer.isView(e)) &&
      (e = {
        data: e,
      });
  let t = new fce(),
    { docId: n } = t,
    r = e.url ? yse(e.url) : null,
    i = e.data ? bse(e.data) : null,
    a = e.httpHeaders || null,
    o = e.withCredentials === !0,
    s = e.password ?? null,
    c = e.range instanceof C3 ? e.range : null,
    l = Number.isInteger(e.rangeChunkSize) && e.rangeChunkSize > 0 ? e.rangeChunkSize : 2 ** 16,
    u = e.worker instanceof w3 ? e.worker : null,
    d = e.verbosity,
    f = typeof e.docBaseUrl == `string` && !m2(e.docBaseUrl) ? e.docBaseUrl : null,
    p = b4(e.cMapUrl),
    m = e.cMapPacked !== !1,
    h = b4(e.iccUrl),
    g = b4(e.standardFontDataUrl),
    v = b4(e.wasmUrl),
    y = e.stopAtErrors !== !0,
    b = Number.isInteger(e.maxImageSize) && e.maxImageSize > -1 ? e.maxImageSize : -1,
    x = typeof e.isOffscreenCanvasSupported == `boolean` ? e.isOffscreenCanvasSupported : !s0,
    S =
      typeof e.isImageDecoderSupported == `boolean`
        ? e.isImageDecoderSupported
        : !s0 && (J0.platform.isFirefox || !globalThis.chrome),
    C = Number.isInteger(e.canvasMaxAreaInBytes) ? e.canvasMaxAreaInBytes : -1,
    w = typeof e.disableFontFace == `boolean` ? e.disableFontFace : s0,
    T = e.fontExtraProperties === !0,
    E = e.enableXfa === !0,
    D = e.ownerDocument || globalThis.document,
    ee = e.disableRange === !0,
    te = e.disableStream === !0,
    O = e.disableAutoFetch === !0,
    k = e.pdfBug === !0,
    ne = e.CanvasFactory || (s0 ? Dse : Cse),
    re = e.FilterFactory || (s0 ? Ese : wse),
    A = e.BinaryDataFactory || (s0 ? Ose : O4),
    ie = e.enableHWA === !0,
    j = e.enableWebGPU === !0 ? Ase() : Promise.resolve(!1),
    ae = e.useWasm !== !1,
    oe = e.pagesMapper || new lce(),
    se = typeof e.useSystemFonts == `boolean` ? e.useSystemFonts : !s0 && !w,
    ce =
      typeof e.useWorkerFetch == `boolean`
        ? e.useWorkerFetch
        : !!(
            A === O4 &&
            p &&
            m &&
            g &&
            v &&
            y2(p, document.baseURI) &&
            y2(g, document.baseURI) &&
            y2(v, document.baseURI)
          );
  D0(d);
  let le = {
    canvasFactory: new ne({
      ownerDocument: D,
      enableHWA: ie,
    }),
    filterFactory: new re({
      docId: n,
      ownerDocument: D,
    }),
    binaryDataFactory: ce
      ? null
      : new A({
          cMapUrl: p,
          standardFontDataUrl: g,
          wasmUrl: v,
        }),
  };
  u ||
    ((u = w3.create({
      verbosity: d,
      port: h3.workerPort,
    })),
    (t._worker = u));
  let ue = {
      docId: n,
      apiVersion: `5.7.284`,
      data: i,
      password: s,
      disableAutoFetch: O,
      rangeChunkSize: l,
      docBaseUrl: f,
      enableXfa: E,
      evaluatorOptions: {
        maxImageSize: b,
        disableFontFace: w,
        ignoreErrors: y,
        isOffscreenCanvasSupported: x,
        isImageDecoderSupported: S,
        canvasMaxAreaInBytes: C,
        fontExtraProperties: T,
        useSystemFonts: se,
        useWasm: ae,
        useWorkerFetch: ce,
        cMapUrl: p,
        cMapPacked: m,
        iccUrl: h,
        standardFontDataUrl: g,
        wasmUrl: v,
        hasGPU: !1,
      },
    },
    de = {
      ownerDocument: D,
      pdfBug: k,
      styleElement: null,
      enableHWA: ie,
      loadingParams: {
        disableAutoFetch: O,
        enableXfa: E,
      },
    };
  return (
    Promise.all([u.promise, j])
      .then(function ([, e]) {
        if (t.destroyed) throw Error(`Loading aborted`);
        if (u.destroyed) throw Error(`Worker was destroyed`);
        ue.evaluatorOptions.hasGPU = e;
        let s = u.messageHandler.sendWithPromise(`GetDocRequest`, ue, i ? [i.buffer] : null),
          d;
        if (!i)
          if (c)
            d = new Yse({
              pdfDataRangeTransport: c,
              disableRange: ee,
              disableStream: te,
            });
          else if (r)
            d = new (ace(r))({
              url: r,
              httpHeaders: a,
              withCredentials: o,
              rangeChunkSize: l,
              disableRange: ee,
              disableStream: te,
            });
          else throw Error("getDocument - expected either `data`, `range`, or `url` parameter.");
        return s.then((e) => {
          if (t.destroyed) throw Error(`Loading aborted`);
          if (u.destroyed) throw Error(`Worker was destroyed`);
          let r = new E4(n, e, u.port);
          ((t._transport = new hce(r, t, d, de, le, oe)), r.send(`Ready`, null));
        });
      })
      .catch(t._capability.reject),
    t
  );
}
var fce = class e {
    static #e = 0;
    _capability = Promise.withResolvers();
    _transport = null;
    _worker = null;
    docId = `d${e.#e++}`;
    destroyed = !1;
    onPassword = null;
    onProgress = null;
    get promise() {
      return this._capability.promise;
    }
    async destroy() {
      this.destroyed = !0;
      try {
        (this._worker?.port && (this._worker._pendingDestroy = !0),
          await this._transport?.destroy());
      } catch (e) {
        throw (this._worker?.port && delete this._worker._pendingDestroy, e);
      }
      ((this._transport = null), this._worker?.destroy(), (this._worker = null));
    }
    async getData() {
      return this._transport.getData();
    }
  },
  C3 = class {
    #e = Promise.withResolvers();
    #t = null;
    constructor(e, t, n = !1, r = null) {
      ((this.length = e),
        (this.initialData = t),
        (this.progressiveDone = n),
        (this.contentDispositionFilename = r),
        Object.defineProperty(this, "onDataProgress", {
          value: () => {
            S2(
              "`PDFDataRangeTransport.prototype.onDataProgress` - method was removed, since loading progress is now reported automatically through the `PDFDataTransportStream` class (and related code).",
            );
          },
        }));
    }
    onDataRange(e, t) {
      this.#t({
        type: `range`,
        begin: e,
        chunk: t,
      });
    }
    onDataProgressiveRead(e) {
      this.#e.promise.then(() => {
        this.#t({
          type: `progressiveRead`,
          chunk: e,
        });
      });
    }
    onDataProgressiveDone() {
      this.#e.promise.then(() => {
        this.#t({
          type: `progressiveDone`,
        });
      });
    }
    transportReady(e) {
      ((this.#t = e), this.#e.resolve());
    }
    requestDataRange(e, t) {
      j0(`Abstract method PDFDataRangeTransport.requestDataRange`);
    }
    abort() {}
  },
  pce = class {
    constructor(e, t) {
      ((this._pdfInfo = e), (this._transport = t));
    }
    get pagesMapper() {
      return this._transport.pagesMapper;
    }
    get annotationStorage() {
      return this._transport.annotationStorage;
    }
    get canvasFactory() {
      return this._transport.canvasFactory;
    }
    get filterFactory() {
      return this._transport.filterFactory;
    }
    get numPages() {
      return this._pdfInfo.numPages;
    }
    get fingerprints() {
      return this._pdfInfo.fingerprints;
    }
    get isPureXfa() {
      return L0(this, `isPureXfa`, !!this._transport._htmlForXfa);
    }
    get allXfaHtml() {
      return this._transport._htmlForXfa;
    }
    getPage(e) {
      return this._transport.getPage(e);
    }
    getPageIndex(e) {
      return this._transport.getPageIndex(e);
    }
    getDestinations() {
      return this._transport.getDestinations();
    }
    getDestination(e) {
      return this._transport.getDestination(e);
    }
    getPageLabels() {
      return this._transport.getPageLabels();
    }
    getPageLayout() {
      return this._transport.getPageLayout();
    }
    getPageMode() {
      return this._transport.getPageMode();
    }
    getViewerPreferences() {
      return this._transport.getViewerPreferences();
    }
    getOpenAction() {
      return this._transport.getOpenAction();
    }
    getAttachments() {
      return this._transport.getAttachments();
    }
    getAnnotationsByType(e, t) {
      return this._transport.getAnnotationsByType(e, t);
    }
    getJSActions() {
      return this._transport.getDocJSActions();
    }
    getOutline() {
      return this._transport.getOutline();
    }
    getOptionalContentConfig({ intent: e = `display` } = {}) {
      let { renderingIntent: t } = this._transport.getRenderingIntent(e);
      return this._transport.getOptionalContentConfig(t);
    }
    getPermissions() {
      return this._transport.getPermissions();
    }
    getMetadata() {
      return this._transport.getMetadata();
    }
    getMarkInfo() {
      return this._transport.getMarkInfo();
    }
    getData() {
      return this._transport.getData();
    }
    saveDocument() {
      return this._transport.saveDocument();
    }
    extractPages(e) {
      return this._transport.extractPages(e);
    }
    getDownloadInfo() {
      return this._transport.downloadInfoCapability.promise;
    }
    getRawData(e) {
      return this._transport.getRawData(e);
    }
    cleanup(e = !1) {
      return this._transport.startCleanup(e || this.isPureXfa);
    }
    destroy() {
      return this.loadingTask.destroy();
    }
    cachedPageNumber(e) {
      return this._transport.cachedPageNumber(e);
    }
    get loadingParams() {
      return this._transport.loadingParams;
    }
    get loadingTask() {
      return this._transport.loadingTask;
    }
    getFieldObjects() {
      return this._transport.getFieldObjects();
    }
    hasJSActions() {
      return this._transport.hasJSActions();
    }
    getCalculationOrderIds() {
      return this._transport.getCalculationOrderIds();
    }
  },
  mce = class e {
    #e = !1;
    #t = null;
    constructor(e, t, n, r, i = !1) {
      ((this._pageIndex = e),
        (this._pageInfo = t),
        (this._transport = n),
        (this._stats = i ? new v2() : null),
        (this._pdfBug = i),
        (this.commonObjs = n.commonObjs),
        (this.objs = new y3()),
        (this._intentStates = new Map()),
        (this.destroyed = !1),
        (this.recordedBBoxes = null),
        (this.#t = r),
        (this.imageCoordinates = null));
    }
    clone(t) {
      let n = new e(t, this._pageInfo, this._transport, this.#t, this._pdfBug);
      return (
        (n.clonedFromIndex = this.clonedFromIndex ?? this._pageIndex),
        this._transport.updatePage(n),
        n
      );
    }
    get pageNumber() {
      return this._pageIndex + 1;
    }
    set pageNumber(e) {
      ((this._pageIndex = e - 1), this._transport.updatePage(this));
    }
    get rotate() {
      return this._pageInfo.rotate;
    }
    get ref() {
      return this._pageInfo.ref;
    }
    get userUnit() {
      return this._pageInfo.userUnit;
    }
    get view() {
      return this._pageInfo.view;
    }
    getViewport({
      scale: e,
      rotation: t = this.rotate,
      offsetX: n = 0,
      offsetY: r = 0,
      dontFlip: i = !1,
    } = {}) {
      return new f2({
        viewBox: this.view,
        userUnit: this.userUnit,
        scale: e,
        rotation: t,
        offsetX: n,
        offsetY: r,
        dontFlip: i,
      });
    }
    getAnnotations({ intent: e = `display` } = {}) {
      let { renderingIntent: t } = this._transport.getRenderingIntent(e);
      return this._transport.getAnnotations(this._pageIndex, t);
    }
    getJSActions() {
      return this._transport.getPageJSActions(this._pageIndex);
    }
    get filterFactory() {
      return this._transport.filterFactory;
    }
    get isPureXfa() {
      return L0(this, `isPureXfa`, !!this._transport._htmlForXfa);
    }
    async getXfa() {
      return this._transport._htmlForXfa?.children[this._pageIndex] || null;
    }
    render({
      canvasContext: e,
      canvas: t = e.canvas,
      viewport: n,
      intent: r = `display`,
      annotationMode: i = p0.ENABLE,
      transform: a = null,
      background: o = null,
      optionalContentConfigPromise: s = null,
      annotationCanvasMap: c = null,
      pageColors: l = null,
      printAnnotationStorage: u = null,
      isEditing: d = !1,
      recordImages: f = !1,
      recordOperations: p = !1,
      operationsFilter: m = null,
    }) {
      this._stats?.time(`Overall`);
      let h = this._transport.getRenderingIntent(r, i, u, d),
        { renderingIntent: g, cacheKey: v } = h;
      ((this.#e = !1), (s ||= this._transport.getOptionalContentConfig(g)));
      let y = this._intentStates.getOrInsertComputed(v, a2);
      y.streamReaderCancelTimeout &&= (clearTimeout(y.streamReaderCancelTimeout), null);
      let b = !!(g & f0.PRINT);
      y.displayReadyCapability ||
        ((y.displayReadyCapability = Promise.withResolvers()),
        (y.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: !1,
          separateAnnots: null,
        }),
        this._stats?.time(`Page Request`),
        this._pumpOperatorList(h));
      let x = !!(this._pdfBug && globalThis.StepperManager?.enabled),
        S = !!t && !this.recordedBBoxes && (p || x),
        C = !!t && !this.imageCoordinates && f,
        w = (e) => {
          if ((y.renderTasks.delete(D), S)) {
            let e = D.gfx?.dependencyTracker.take();
            e &&
              (D.stepper?.setOperatorBBoxes(e, D.gfx.dependencyTracker.takeDebugMetadata()),
              p && (this.recordedBBoxes = e));
          }
          (C && !e && (this.imageCoordinates = D.gfx?.imagesTracker.take()),
            b && (this.#e = !0),
            this.#n(),
            e
              ? (D.capability.reject(e),
                this._abortOperatorList({
                  intentState: y,
                  reason: e instanceof Error ? e : Error(e),
                }))
              : D.capability.resolve(),
            this._stats &&
              (this._stats.timeEnd(`Rendering`),
              this._stats.timeEnd(`Overall`),
              globalThis.Stats?.enabled && globalThis.Stats.add(this.pageNumber, this._stats)));
        },
        T = null,
        E = null;
      ((S || C) && (E = new sse(t, y.operatorList.length)), S && (T = new cse(E, x)));
      let D = new _ce({
        callback: w,
        params: {
          canvas: t,
          canvasContext: e,
          dependencyTracker: T ?? E,
          imagesTracker: C ? new lse(t) : null,
          viewport: n,
          transform: a,
          background: o,
        },
        objs: this.objs,
        commonObjs: this.commonObjs,
        annotationCanvasMap: c,
        operatorList: y.operatorList,
        pageIndex: this._pageIndex,
        canvasFactory: this._transport.canvasFactory,
        filterFactory: this._transport.filterFactory,
        useRequestAnimationFrame: !b,
        pdfBug: this._pdfBug,
        pageColors: l,
        enableHWA: this._transport.enableHWA,
        operationsFilter: m,
      });
      (y.renderTasks ||= new Set()).add(D);
      let ee = D.task;
      return (
        Promise.all([y.displayReadyCapability.promise, s])
          .then(([e, t]) => {
            if (this.destroyed) {
              w();
              return;
            }
            if ((this._stats?.time(`Rendering`), !(t.renderingIntent & g)))
              throw Error(
                "Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.",
              );
            (D.initializeGraphics({
              transparency: e,
              optionalContentConfig: t,
            }),
              D.operatorListChanged());
          })
          .catch(w),
        ee
      );
    }
    getOperatorList({
      intent: e = `display`,
      annotationMode: t = p0.ENABLE,
      printAnnotationStorage: n = null,
      isEditing: r = !1,
    } = {}) {
      function i() {
        o.operatorList.lastChunk &&
          (o.opListReadCapability.resolve(o.operatorList), o.renderTasks.delete(s));
      }
      let a = this._transport.getRenderingIntent(e, t, n, r, !0),
        o = this._intentStates.getOrInsertComputed(a.cacheKey, a2),
        s;
      return (
        o.opListReadCapability ||
          ((s = Object.create(null)),
          (s.operatorListChanged = i),
          (o.opListReadCapability = Promise.withResolvers()),
          (o.renderTasks ||= new Set()).add(s),
          (o.operatorList = {
            fnArray: [],
            argsArray: [],
            lastChunk: !1,
            separateAnnots: null,
          }),
          this._stats?.time(`Page Request`),
          this._pumpOperatorList(a)),
        o.opListReadCapability.promise
      );
    }
    streamTextContent({ includeMarkedContent: e = !1, disableNormalization: t = !1 } = {}) {
      return this._transport.messageHandler.sendWithStream(
        `GetTextContent`,
        {
          pageId: this.#t.getPageId(this._pageIndex + 1) - 1,
          pageIndex: this._pageIndex,
          includeMarkedContent: e === !0,
          disableNormalization: t === !0,
        },
        {
          highWaterMark: 100,
          size(e) {
            return e.items.length;
          },
        },
      );
    }
    async getTextContent(e = {}) {
      if (this._transport._htmlForXfa) return this.getXfa().then((e) => s2.textContent(e));
      let t = this.streamTextContent(e),
        n = {
          items: [],
          styles: Object.create(null),
          lang: null,
        };
      for await (let e of t)
        ((n.lang ??= e.lang), Object.assign(n.styles, e.styles), n.items.push(...e.items));
      return n;
    }
    getStructTree() {
      return this._transport.getStructTree(this._pageIndex);
    }
    _destroy() {
      this.destroyed = !0;
      let e = [];
      for (let t of this._intentStates.values())
        if (
          (this._abortOperatorList({
            intentState: t,
            reason: Error(`Page was destroyed.`),
            force: !0,
          }),
          !t.opListReadCapability)
        )
          for (let n of t.renderTasks) (e.push(n.completed), n.cancel());
      return (this.objs.clear(), (this.#e = !1), Promise.all(e));
    }
    cleanup(e = !1) {
      this.#e = !0;
      let t = this.#n();
      return (e && t && (this._stats &&= new v2()), t);
    }
    #n() {
      if (!this.#e || this.destroyed) return !1;
      for (let { renderTasks: e, operatorList: t } of this._intentStates.values())
        if (e.size > 0 || !t.lastChunk) return !1;
      return (this._intentStates.clear(), this.objs.clear(), (this.#e = !1), !0);
    }
    _startRenderPage(e, t) {
      let n = this._intentStates.get(t);
      n && (this._stats?.timeEnd(`Page Request`), n.displayReadyCapability?.resolve(e));
    }
    _renderPageChunk(e, t) {
      for (let n = 0, r = e.length; n < r; n++)
        (t.operatorList.fnArray.push(e.fnArray[n]), t.operatorList.argsArray.push(e.argsArray[n]));
      ((t.operatorList.lastChunk = e.lastChunk),
        (t.operatorList.separateAnnots = e.separateAnnots));
      for (let e of t.renderTasks) e.operatorListChanged();
      e.lastChunk && this.#n();
    }
    _pumpOperatorList({
      renderingIntent: e,
      cacheKey: t,
      annotationStorageSerializable: n,
      modifiedIds: r,
    }) {
      let { map: i, transfer: a } = n,
        o = this._transport.messageHandler
          .sendWithStream(
            `GetOperatorList`,
            {
              pageId: this.#t.getPageId(this._pageIndex + 1) - 1,
              pageIndex: this._pageIndex,
              intent: e,
              cacheKey: t,
              annotationStorage: i,
              modifiedIds: r,
            },
            void 0,
            a,
          )
          .getReader(),
        s = this._intentStates.get(t);
      s.streamReader = o;
      let c = () => {
        o.read().then(
          ({ value: e, done: t }) => {
            if (t) {
              s.streamReader = null;
              return;
            }
            this._transport.destroyed || (this._renderPageChunk(e, s), c());
          },
          (e) => {
            if (((s.streamReader = null), !this._transport.destroyed)) {
              if (s.operatorList) {
                s.operatorList.lastChunk = !0;
                for (let e of s.renderTasks) e.operatorListChanged();
                this.#n();
              }
              if (s.displayReadyCapability) s.displayReadyCapability.reject(e);
              else if (s.opListReadCapability) s.opListReadCapability.reject(e);
              else throw e;
            }
          },
        );
      };
      c();
    }
    _abortOperatorList({ intentState: e, reason: t, force: n = !1 }) {
      if (e.streamReader) {
        if (
          ((e.streamReaderCancelTimeout &&= (clearTimeout(e.streamReaderCancelTimeout), null)), !n)
        ) {
          if (e.renderTasks.size > 0) return;
          if (t instanceof p2) {
            let n = dce;
            (t.extraDelay > 0 && t.extraDelay < 1e3 && (n += t.extraDelay),
              (e.streamReaderCancelTimeout = setTimeout(() => {
                ((e.streamReaderCancelTimeout = null),
                  this._abortOperatorList({
                    intentState: e,
                    reason: t,
                    force: !0,
                  }));
              }, n)));
            return;
          }
        }
        if (
          (e.streamReader.cancel(new W0(t.message)).catch(() => {}),
          (e.streamReader = null),
          !this._transport.destroyed)
        ) {
          for (let [t, n] of this._intentStates)
            if (n === e) {
              this._intentStates.delete(t);
              break;
            }
          this.cleanup();
        }
      }
    }
    get stats() {
      return this._stats;
    }
  },
  w3 = class e {
    #e = Promise.withResolvers();
    #t = null;
    #n = null;
    #r = null;
    static #i = 0;
    static #a = !1;
    static #o = new WeakMap();
    static {
      (s0 && ((this.#a = !0), (h3.workerSrc ||= `./pdf.worker.mjs`)),
        (this._isSameOrigin = (e, t) => {
          let n = URL.parse(e);
          if (!n?.origin || n.origin === `null`) return !1;
          let r = new URL(t, n);
          return n.origin === r.origin;
        }),
        (this._createCDNWrapper = (e) => {
          let t = `await import("${e}");`;
          return URL.createObjectURL(
            new Blob([t], {
              type: `text/javascript`,
            }),
          );
        }));
    }
    constructor({ name: t = null, port: n = null, verbosity: r = O0() } = {}) {
      if (((this.name = t), (this.destroyed = !1), (this.verbosity = r), n)) {
        if (e.#o.has(n)) throw Error(`Cannot use more than one PDFWorker per port.`);
        (e.#o.set(n, this), this.#c(n));
      } else this.#l();
    }
    get promise() {
      return this.#e.promise;
    }
    #s() {
      (this.#e.resolve(),
        this.#t.send(`configure`, {
          verbosity: this.verbosity,
        }));
    }
    get port() {
      return this.#n;
    }
    get messageHandler() {
      return this.#t;
    }
    #c(e) {
      ((this.#n = e),
        (this.#t = new E4(`main`, `worker`, e)),
        this.#t.on(`ready`, () => {}),
        this.#s());
    }
    #l() {
      if (e.#a || e.#d) {
        this.#u();
        return;
      }
      let { workerSrc: t } = e;
      try {
        e._isSameOrigin(window.location, t) ||
          (t = e._createCDNWrapper(new URL(t, window.location).href));
        let n = new Worker(t, {
            type: `module`,
          }),
          r = new E4(`main`, `worker`, n),
          i = () => {
            (a.abort(),
              r.destroy(),
              n.terminate(),
              this.destroyed ? this.#e.reject(Error(`Worker was destroyed`)) : this.#u());
          },
          a = new AbortController();
        (n.addEventListener(
          `error`,
          () => {
            this.#r || i();
          },
          {
            signal: a.signal,
          },
        ),
          r.on(`test`, (e) => {
            if ((a.abort(), this.destroyed || !e)) {
              i();
              return;
            }
            ((this.#t = r), (this.#n = n), (this.#r = n), this.#s());
          }),
          r.on(`ready`, (e) => {
            if ((a.abort(), this.destroyed)) {
              i();
              return;
            }
            try {
              o();
            } catch {
              this.#u();
            }
          }));
        let o = () => {
          let e = new Uint8Array();
          r.send(`test`, e, [e.buffer]);
        };
        o();
        return;
      } catch {
        k0(`The worker has been disabled.`);
      }
      this.#u();
    }
    #u() {
      ((e.#a ||= (A0(`Setting up fake worker.`), !0)),
        e._setupFakeWorkerGlobal
          .then((t) => {
            if (this.destroyed) {
              this.#e.reject(Error(`Worker was destroyed`));
              return;
            }
            let n = new Sse();
            this.#n = n;
            let r = `fake${e.#i++}`,
              i = new E4(r + `_worker`, r, n);
            (t.setup(i, n), (this.#t = new E4(r, r + `_worker`, n)), this.#s());
          })
          .catch((e) => {
            this.#e.reject(Error(`Setting up fake worker failed: "${e.message}".`));
          }));
    }
    destroy() {
      ((this.destroyed = !0),
        this.#r?.terminate(),
        (this.#r = null),
        e.#o.delete(this.#n),
        (this.#n = null),
        this.#t?.destroy(),
        (this.#t = null));
    }
    static create(t) {
      let n = this.#o.get(t?.port);
      if (n) {
        if (n._pendingDestroy)
          throw Error(
            "PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.",
          );
        return n;
      }
      return new e(t);
    }
    static get workerSrc() {
      if (h3.workerSrc) return h3.workerSrc;
      throw Error(`No "GlobalWorkerOptions.workerSrc" specified.`);
    }
    static get #d() {
      try {
        return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
      } catch {
        return null;
      }
    }
    static get _setupFakeWorkerGlobal() {
      return L0(
        this,
        `_setupFakeWorkerGlobal`,
        (async () =>
          this.#d ? this.#d : (await b(() => import(this.workerSrc), [])).WorkerMessageHandler)(),
      );
    }
  },
  hce = class {
    downloadInfoCapability = Promise.withResolvers();
    #e = null;
    #t = new Map();
    #n = null;
    #r = new Map();
    #i = new Map();
    #a = new Map();
    #o = null;
    constructor(e, t, n, r, i, a) {
      ((this.messageHandler = e),
        (this.loadingTask = t),
        (this.#n = n),
        (this.commonObjs = new y3()),
        (this.fontLoader = new use({
          ownerDocument: r.ownerDocument,
          styleElement: r.styleElement,
        })),
        (this.enableHWA = r.enableHWA),
        (this.loadingParams = r.loadingParams),
        (this._params = r),
        (this.canvasFactory = i.canvasFactory),
        (this.filterFactory = i.filterFactory),
        (this.binaryDataFactory = i.binaryDataFactory),
        (this.pagesMapper = a),
        (this.destroyed = !1),
        (this.destroyCapability = null),
        this.setupMessageHandler());
    }
    updatePage(e) {
      let { _pageIndex: t } = e;
      (this.#r.set(t, e), this.#i.set(t, Promise.resolve(e)));
    }
    #s(e, t = null) {
      return this.#t.getOrInsertComputed(e, () => this.messageHandler.sendWithPromise(e, t));
    }
    #c({ loaded: e, total: t }) {
      this.loadingTask.onProgress?.({
        loaded: e,
        total: t,
        percent: t ? o2(Math.round((e / t) * 100), 0, 100) : NaN,
      });
    }
    get annotationStorage() {
      return L0(this, `annotationStorage`, new c4());
    }
    getRenderingIntent(e, t = p0.ENABLE, n = null, r = !1, i = !1) {
      let a = f0.DISPLAY,
        o = s4;
      switch (e) {
        case `any`:
          a = f0.ANY;
          break;
        case `display`:
          break;
        case `print`:
          a = f0.PRINT;
          break;
        default:
          A0(`getRenderingIntent - invalid intent: ${e}`);
      }
      let s = a & f0.PRINT && n instanceof l4 ? n : this.annotationStorage;
      switch (t) {
        case p0.DISABLE:
          a += f0.ANNOTATIONS_DISABLE;
          break;
        case p0.ENABLE:
          break;
        case p0.ENABLE_FORMS:
          a += f0.ANNOTATIONS_FORMS;
          break;
        case p0.ENABLE_STORAGE:
          ((a += f0.ANNOTATIONS_STORAGE), (o = s.serializable));
          break;
        default:
          A0(`getRenderingIntent - invalid annotationMode: ${t}`);
      }
      (r && (a += f0.IS_EDITING), i && (a += f0.OPLIST));
      let { ids: c, hash: l } = s.modifiedIds,
        u = [a, o.hash, l];
      return {
        renderingIntent: a,
        cacheKey: u.join(`_`),
        annotationStorageSerializable: o,
        modifiedIds: c,
      };
    }
    destroy() {
      if (this.destroyCapability) return this.destroyCapability.promise;
      ((this.destroyed = !0),
        (this.destroyCapability = Promise.withResolvers()),
        this.#o?.reject(Error(`Worker was destroyed during onPassword callback`)));
      let e = [];
      for (let t of this.#r.values()) e.push(t._destroy());
      (this.#r.clear(),
        this.#i.clear(),
        this.#a.clear(),
        Object.hasOwn(this, `annotationStorage`) && this.annotationStorage.resetModified());
      let t = this.messageHandler.sendWithPromise(`Terminate`, null);
      return (
        e.push(t),
        Promise.all(e).then(() => {
          (this.commonObjs.clear(),
            this.fontLoader.clear(),
            this.#t.clear(),
            this.filterFactory.destroy(),
            x3.cleanup(),
            this.#n?.cancelAllRequests(new W0(`Worker was terminated.`)),
            this.messageHandler?.destroy(),
            (this.messageHandler = null),
            this.destroyCapability.resolve());
        }, this.destroyCapability.reject),
        this.destroyCapability.promise
      );
    }
    setupMessageHandler() {
      let { messageHandler: e, loadingTask: t } = this;
      (e.on(`GetReader`, (e, t) => {
        (M0(this.#n, "GetReader - no `BasePDFStream` instance available."),
          (this.#e = this.#n.getFullReader()),
          (this.#e.onProgress = (e) => this.#c(e)),
          (t.onPull = () => {
            this.#e
              .read()
              .then(function ({ value: e, done: n }) {
                if (n) {
                  t.close();
                  return;
                }
                (M0(e instanceof ArrayBuffer, `GetReader - expected an ArrayBuffer.`),
                  t.enqueue(new Uint8Array(e), 1, [e]));
              })
              .catch((e) => {
                t.error(e);
              });
          }),
          (t.onCancel = (e) => {
            (this.#e.cancel(e),
              t.ready.catch((e) => {
                if (!this.destroyed) throw e;
              }));
          }));
      }),
        e.on(`ReaderHeadersReady`, async (e) => {
          await this.#e.headersReady;
          let { isStreamingSupported: t, isRangeSupported: n, contentLength: r } = this.#e;
          return (
            t && n && (this.#e.onProgress = null),
            {
              isStreamingSupported: t,
              isRangeSupported: n,
              contentLength: r,
            }
          );
        }),
        e.on(`GetRangeReader`, (e, t) => {
          M0(this.#n, "GetRangeReader - no `BasePDFStream` instance available.");
          let n = this.#n.getRangeReader(e.begin, e.end);
          if (!n) {
            t.close();
            return;
          }
          ((t.onPull = () => {
            n.read()
              .then(function ({ value: e, done: n }) {
                if (n) {
                  t.close();
                  return;
                }
                (M0(e instanceof ArrayBuffer, `GetRangeReader - expected an ArrayBuffer.`),
                  t.enqueue(new Uint8Array(e), 1, [e]));
              })
              .catch((e) => {
                t.error(e);
              });
          }),
            (t.onCancel = (e) => {
              (n.cancel(e),
                t.ready.catch((e) => {
                  if (!this.destroyed) throw e;
                }));
            }));
        }),
        e.on(`GetDoc`, ({ pdfInfo: e }) => {
          ((this.pagesMapper.pagesNumber = e.numPages),
            (this._numPages = e.numPages),
            (this._htmlForXfa = e.htmlForXfa),
            delete e.htmlForXfa,
            t._capability.resolve(new pce(e, this)));
        }),
        e.on(`DocException`, (e) => {
          t._capability.reject(T4(e));
        }),
        e.on(`PasswordRequest`, (e) => {
          this.#o = Promise.withResolvers();
          try {
            if (!t.onPassword) throw T4(e);
            t.onPassword((e) => {
              e instanceof Error
                ? this.#o.reject(e)
                : this.#o.resolve({
                    password: e,
                  });
            }, e.code);
          } catch (e) {
            this.#o.reject(e);
          }
          return this.#o.promise;
        }),
        e.on(`DataLoaded`, (e) => {
          (this.#c({
            loaded: e.length,
            total: e.length,
          }),
            this.downloadInfoCapability.resolve(e));
        }),
        e.on(`StartRenderPage`, (e) => {
          this.destroyed || this.#r.get(e.pageIndex)._startRenderPage(e.transparency, e.cacheKey);
        }),
        e.on(`commonobj`, ([t, n, r]) => {
          if (this.destroyed || this.commonObjs.has(t)) return null;
          switch (n) {
            case `Font`:
              if (`error` in r) {
                let e = r.error;
                (A0(`Error during font loading: ${e}`), this.commonObjs.resolve(t, e));
                break;
              }
              let i = new dse(
                new gse(r),
                this._params.pdfBug && globalThis.FontInspector?.enabled
                  ? (e, t) => globalThis.FontInspector.fontAdded(e, t)
                  : null,
                r.charProcOperatorList,
                r.extra,
              );
              this.fontLoader
                .bind(i)
                .catch(() =>
                  e.sendWithPromise(`FontFallback`, {
                    id: t,
                  }),
                )
                .finally(() => {
                  (i.fontExtraProperties || i.clearData(), this.commonObjs.resolve(t, i));
                });
              break;
            case `CopyLocalImage`:
              let { imageRef: a } = r;
              M0(a, `The imageRef must be defined.`);
              for (let e of this.#r.values())
                for (let [, n] of e.objs) {
                  if (n?.ref !== a) continue;
                  if (!n.dataLen) return null;
                  let e = structuredClone(n);
                  return (this.commonObjs.resolve(t, e), n.dataLen);
                }
              break;
            case `FontPath`:
              this.commonObjs.resolve(t, new vse(r));
              break;
            case `Image`:
              this.commonObjs.resolve(t, r);
              break;
            case `Pattern`:
              let o = new _se(r);
              this.commonObjs.resolve(t, o.getIR());
              break;
            default:
              throw Error(`Got unknown common object type ${n}`);
          }
          return null;
        }),
        e.on(`obj`, ([e, t, n, r]) => {
          if (this.destroyed) return;
          let i = this.#r.get(t);
          if (!i.objs.has(e)) {
            if (i._intentStates.size === 0) {
              r?.bitmap?.close();
              return;
            }
            switch (n) {
              case `Image`:
              case `Pattern`:
                i.objs.resolve(e, r);
                break;
              default:
                throw Error(`Got unknown object type ${n}`);
            }
          }
        }),
        e.on(`DocProgress`, (e) => {
          this.destroyed || this.#c(e);
        }),
        e.on(`FetchBinaryData`, async (e) => {
          if (this.destroyed) throw Error(`Worker was destroyed.`);
          if (!this.binaryDataFactory)
            throw Error("`BinaryDataFactory` not initialized, see the `useWorkerFetch` parameter.");
          return this.binaryDataFactory.fetch(e);
        }));
    }
    getData() {
      return this.messageHandler.sendWithPromise(`GetData`, null);
    }
    saveDocument() {
      this.annotationStorage.size <= 0 &&
        A0(
          "saveDocument called while `annotationStorage` is empty, please use the getData-method instead.",
        );
      let { map: e, transfer: t } = this.annotationStorage.serializable;
      return this.messageHandler
        .sendWithPromise(
          `SaveDocument`,
          {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: e,
            filename: this.#e?.filename ?? null,
          },
          t,
        )
        .finally(() => {
          this.annotationStorage.resetModified();
        });
    }
    extractPages(e) {
      let t = {
          pageInfos: e,
        },
        n;
      if (this.annotationStorage.size > 0) {
        let { map: e, transfer: r } = this.annotationStorage.serializable;
        ((t.annotationStorage = e), (n = r));
      }
      return this.messageHandler.sendWithPromise(`ExtractPages`, t, n).finally(() => {
        this.annotationStorage.resetModified();
      });
    }
    getPage(e) {
      if (!Number.isInteger(e) || e <= 0 || e > this.pagesMapper.pagesNumber)
        return Promise.reject(Error(`Invalid page request.`));
      let t = e - 1,
        n = this.pagesMapper.getPageId(e) - 1,
        r = this.#i.get(t);
      if (r) return r;
      let i = this.messageHandler
        .sendWithPromise(`GetPage`, {
          pageIndex: n,
        })
        .then((e) => {
          if (this.destroyed) throw Error(`Transport destroyed`);
          e.refStr && this.#a.set(e.refStr, n);
          let r = new mce(t, e, this, this.pagesMapper, this._params.pdfBug);
          return (this.#r.set(t, r), r);
        });
      return (this.#i.set(t, i), i);
    }
    async getPageIndex(e) {
      if (!x4(e)) throw Error(`Invalid pageIndex request.`);
      let t = await this.messageHandler.sendWithPromise(`GetPageIndex`, {
          num: e.num,
          gen: e.gen,
        }),
        n = this.pagesMapper.getPageNumber(t + 1);
      if (n === 0) throw Error(`GetPageIndex: page has been removed.`);
      return n - 1;
    }
    getAnnotations(e, t) {
      return this.messageHandler.sendWithPromise(`GetAnnotations`, {
        pageIndex: this.pagesMapper.getPageId(e + 1) - 1,
        intent: t,
      });
    }
    getFieldObjects() {
      return this.#s(`GetFieldObjects`);
    }
    hasJSActions() {
      return this.#s(`HasJSActions`);
    }
    getCalculationOrderIds() {
      return this.messageHandler.sendWithPromise(`GetCalculationOrderIds`, null);
    }
    getDestinations() {
      return this.messageHandler.sendWithPromise(`GetDestinations`, null);
    }
    getDestination(e) {
      return typeof e == `string`
        ? this.messageHandler.sendWithPromise(`GetDestination`, {
            id: e,
          })
        : Promise.reject(Error(`Invalid destination request.`));
    }
    getPageLabels() {
      return this.messageHandler.sendWithPromise(`GetPageLabels`, null);
    }
    getPageLayout() {
      return this.messageHandler.sendWithPromise(`GetPageLayout`, null);
    }
    getPageMode() {
      return this.messageHandler.sendWithPromise(`GetPageMode`, null);
    }
    getViewerPreferences() {
      return this.messageHandler.sendWithPromise(`GetViewerPreferences`, null);
    }
    getOpenAction() {
      return this.messageHandler.sendWithPromise(`GetOpenAction`, null);
    }
    getAttachments() {
      return this.messageHandler.sendWithPromise(`GetAttachments`, null);
    }
    getAnnotationsByType(e, t) {
      return this.messageHandler.sendWithPromise(`GetAnnotationsByType`, {
        types: e,
        pageIndexesToSkip: t,
      });
    }
    getDocJSActions() {
      return this.#s(`GetDocJSActions`);
    }
    getPageJSActions(e) {
      return this.messageHandler.sendWithPromise(`GetPageJSActions`, {
        pageIndex: this.pagesMapper.getPageId(e + 1) - 1,
      });
    }
    getStructTree(e) {
      return this.messageHandler.sendWithPromise(`GetStructTree`, {
        pageIndex: this.pagesMapper.getPageId(e + 1) - 1,
      });
    }
    getOutline() {
      return this.messageHandler.sendWithPromise(`GetOutline`, null);
    }
    getOptionalContentConfig(e) {
      return this.#s(`GetOptionalContentConfig`).then((t) => new cce(t, e));
    }
    getPermissions() {
      return this.messageHandler.sendWithPromise(`GetPermissions`, null);
    }
    getMetadata() {
      let e = `GetMetadata`;
      return this.#t.getOrInsertComputed(e, () =>
        this.messageHandler.sendWithPromise(e, null).then((e) => ({
          info: e[0],
          metadata: e[1] ? new oce(e[1]) : null,
          contentDispositionFilename: this.#e?.filename ?? null,
          contentLength: this.#e?.contentLength ?? null,
          hasStructTree: e[2],
        })),
      );
    }
    getMarkInfo() {
      return this.messageHandler.sendWithPromise(`GetMarkInfo`, null);
    }
    getRawData(e) {
      return this.messageHandler.sendWithPromise(`GetRawData`, e);
    }
    async startCleanup(e = !1) {
      if (!this.destroyed) {
        await this.messageHandler.sendWithPromise(`Cleanup`, null);
        for (let e of this.#r.values())
          if (!e.cleanup())
            throw Error(`startCleanup: Page ${e.pageNumber} is currently rendering.`);
        (this.commonObjs.clear(),
          e || this.fontLoader.clear(),
          this.#t.clear(),
          this.filterFactory.destroy(!0),
          x3.cleanup());
      }
    }
    cachedPageNumber(e) {
      if (!x4(e)) return null;
      let t = e.gen === 0 ? `${e.num}R` : `${e.num}R${e.gen}`,
        n = this.#a.get(t);
      if (n >= 0) {
        let e = this.pagesMapper.getPageNumber(n + 1);
        if (e !== 0) return e;
      }
      return null;
    }
  },
  gce = class {
    _internalRenderTask = null;
    onContinue = null;
    onError = null;
    constructor(e) {
      this._internalRenderTask = e;
    }
    get promise() {
      return this._internalRenderTask.capability.promise;
    }
    cancel(e = 0) {
      this._internalRenderTask.cancel(null, e);
    }
    get separateAnnots() {
      let { separateAnnots: e } = this._internalRenderTask.operatorList;
      if (!e) return !1;
      let { annotationCanvasMap: t } = this._internalRenderTask;
      return e.form || (e.canvas && t?.size > 0);
    }
    get imageCoordinates() {
      return this._internalRenderTask.imageCoordinates || null;
    }
  },
  _ce = class e {
    #e = null;
    static #t = new WeakSet();
    constructor({
      callback: e,
      params: t,
      objs: n,
      commonObjs: r,
      annotationCanvasMap: i,
      operatorList: a,
      pageIndex: o,
      canvasFactory: s,
      filterFactory: c,
      useRequestAnimationFrame: l = !1,
      pdfBug: u = !1,
      pageColors: d = null,
      enableHWA: f = !1,
      operationsFilter: p = null,
    }) {
      ((this.callback = e),
        (this.params = t),
        (this.objs = n),
        (this.commonObjs = r),
        (this.annotationCanvasMap = i),
        (this.operatorListIdx = null),
        (this.operatorList = a),
        (this._pageIndex = o),
        (this.canvasFactory = s),
        (this.filterFactory = c),
        (this._pdfBug = u),
        (this.pageColors = d),
        (this.running = !1),
        (this.graphicsReadyCallback = null),
        (this.graphicsReady = !1),
        (this._useRequestAnimationFrame = l === !0 && typeof window < `u`),
        (this.cancelled = !1),
        (this.capability = Promise.withResolvers()),
        (this.task = new gce(this)),
        (this._cancelBound = this.cancel.bind(this)),
        (this._continueBound = this._continue.bind(this)),
        (this._scheduleNextBound = this._scheduleNext.bind(this)),
        (this._nextBound = this._next.bind(this)),
        (this._canvas = t.canvas),
        (this._canvasContext = t.canvas ? null : t.canvasContext),
        (this._enableHWA = f),
        (this._dependencyTracker = t.dependencyTracker),
        (this._imagesTracker = t.imagesTracker),
        (this._operationsFilter = p));
    }
    get completed() {
      return this.capability.promise.catch(function () {});
    }
    initializeGraphics({ transparency: t = !1, optionalContentConfig: n }) {
      if (this.cancelled) return;
      if (this._canvas) {
        if (e.#t.has(this._canvas))
          throw Error(
            `Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.`,
          );
        e.#t.add(this._canvas);
      }
      this._pdfBug &&
        globalThis.StepperManager?.enabled &&
        ((this.stepper = globalThis.StepperManager.create(this._pageIndex)),
        this.stepper.init(this.operatorList),
        (this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint()));
      let {
          viewport: r,
          transform: i,
          background: a,
          dependencyTracker: o,
          imagesTracker: s,
        } = this.params,
        c =
          this._canvasContext ||
          this._canvas.getContext(`2d`, {
            alpha: !1,
            willReadFrequently: !this._enableHWA,
          });
      ((this.gfx = new Z4(
        c,
        this.commonObjs,
        this.objs,
        this.canvasFactory,
        this.filterFactory,
        {
          optionalContentConfig: n,
        },
        this.annotationCanvasMap,
        this.pageColors,
        o,
        s,
      )),
        this.gfx.beginDrawing({
          transform: i,
          viewport: r,
          transparency: t,
          background: a,
        }),
        (this.operatorListIdx = 0),
        (this.graphicsReady = !0),
        this.graphicsReadyCallback?.());
    }
    cancel(t = null, n = 0) {
      ((this.running = !1),
        (this.cancelled = !0),
        this.gfx?.endDrawing(),
        (this.#e &&= (window.cancelAnimationFrame(this.#e), null)),
        e.#t.delete(this._canvas),
        (t ||= new p2(`Rendering cancelled, page ${this._pageIndex + 1}`, n)),
        this.callback(t),
        this.task.onError?.(t));
    }
    operatorListChanged() {
      if (!this.graphicsReady) {
        this.graphicsReadyCallback ||= this._continueBound;
        return;
      }
      (this.gfx.dependencyTracker?.growOperationsCount(this.operatorList.fnArray.length),
        this.stepper?.updateOperatorList(this.operatorList),
        !this.running && this._continue());
    }
    _continue() {
      ((this.running = !0),
        !this.cancelled &&
          (this.task.onContinue
            ? this.task.onContinue(this._scheduleNextBound)
            : this._scheduleNext()));
    }
    _scheduleNext() {
      this._useRequestAnimationFrame
        ? (this.#e = window.requestAnimationFrame(() => {
            ((this.#e = null), this._nextBound().catch(this._cancelBound));
          }))
        : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
    async _next() {
      this.cancelled ||
        ((this.operatorListIdx = this.gfx.executeOperatorList(
          this.operatorList,
          this.operatorListIdx,
          this._continueBound,
          this.stepper,
          this._operationsFilter,
        )),
        this.operatorListIdx === this.operatorList.argsArray.length &&
          ((this.running = !1),
          this.operatorList.lastChunk &&
            (this.gfx.endDrawing(), e.#t.delete(this._canvas), this.callback())));
    }
  },
  vce = `5.7.284`,
  yce = `7e5b36c2d`,
  T3 = class e {
    #e = null;
    #t = null;
    #n;
    #r = null;
    #i = !1;
    #a = !1;
    #o = null;
    #s;
    #c = null;
    #l = null;
    static #u = null;
    static get _keyboardManager() {
      return L0(
        this,
        `_keyboardManager`,
        new Z2([
          [[`Escape`, `mac+Escape`], e.prototype._hideDropdownFromKeyboard],
          [[` `, `mac+ `], e.prototype._colorSelectFromKeyboard],
          [[`ArrowDown`, `ArrowRight`, `mac+ArrowDown`, `mac+ArrowRight`], e.prototype._moveToNext],
          [[`ArrowUp`, `ArrowLeft`, `mac+ArrowUp`, `mac+ArrowLeft`], e.prototype._moveToPrevious],
          [[`Home`, `mac+Home`], e.prototype._moveToBeginning],
          [[`End`, `mac+End`], e.prototype._moveToEnd],
        ]),
      );
    }
    constructor({ editor: t = null, uiManager: n = null }) {
      (t ? ((this.#a = !1), (this.#o = t)) : (this.#a = !0),
        (this.#l = t?._uiManager || n),
        (this.#s = this.#l._eventBus),
        (this.#n =
          t?.color?.toUpperCase() || this.#l?.highlightColors.values().next().value || `#FFFF98`),
        (e.#u ||= Object.freeze({
          blue: `pdfjs-editor-colorpicker-blue`,
          green: `pdfjs-editor-colorpicker-green`,
          pink: `pdfjs-editor-colorpicker-pink`,
          red: `pdfjs-editor-colorpicker-red`,
          yellow: `pdfjs-editor-colorpicker-yellow`,
        })));
    }
    renderButton() {
      let e = (this.#e = document.createElement(`button`));
      ((e.className = `colorPicker`),
        (e.tabIndex = `0`),
        e.setAttribute(`data-l10n-id`, `pdfjs-editor-colorpicker-button`),
        (e.ariaHasPopup = `true`),
        this.#o && (e.ariaControls = `${this.#o.id}_colorpicker_dropdown`));
      let t = this.#l._signal;
      (e.addEventListener(`click`, this.#m.bind(this), {
        signal: t,
      }),
        e.addEventListener(`keydown`, this.#p.bind(this), {
          signal: t,
        }));
      let n = (this.#t = document.createElement(`span`));
      return (
        (n.className = `swatch`),
        (n.ariaHidden = `true`),
        (n.style.backgroundColor = this.#n),
        e.append(n),
        e
      );
    }
    renderMainDropdown() {
      let e = (this.#r = this.#d());
      return (
        (e.ariaOrientation = `horizontal`),
        (e.ariaLabelledBy = `highlightColorPickerLabel`),
        e
      );
    }
    #d() {
      let t = document.createElement(`div`),
        n = this.#l._signal;
      (t.addEventListener(`contextmenu`, b2, {
        signal: n,
      }),
        (t.className = `dropdown`),
        (t.role = `listbox`),
        (t.ariaMultiSelectable = `false`),
        (t.ariaOrientation = `vertical`),
        t.setAttribute(`data-l10n-id`, `pdfjs-editor-colorpicker-dropdown`),
        this.#o && (t.id = `${this.#o.id}_colorpicker_dropdown`));
      for (let [r, i] of this.#l.highlightColors) {
        let a = document.createElement(`button`);
        ((a.tabIndex = `0`),
          (a.role = `option`),
          a.setAttribute(`data-color`, i),
          (a.title = r),
          a.setAttribute(`data-l10n-id`, e.#u[r]));
        let o = document.createElement(`span`);
        (a.append(o),
          (o.className = `swatch`),
          (o.style.backgroundColor = i),
          (a.ariaSelected = i === this.#n),
          a.addEventListener(`click`, this.#f.bind(this, i), {
            signal: n,
          }),
          t.append(a));
      }
      return (
        t.addEventListener(`keydown`, this.#p.bind(this), {
          signal: n,
        }),
        t
      );
    }
    #f(e, t) {
      (t.stopPropagation(),
        this.#s.dispatch(`switchannotationeditorparams`, {
          source: this,
          type: g0.HIGHLIGHT_COLOR,
          value: e,
        }),
        this.updateColor(e));
    }
    _colorSelectFromKeyboard(e) {
      if (e.target === this.#e) {
        this.#m(e);
        return;
      }
      let t = e.target.getAttribute(`data-color`);
      t && this.#f(t, e);
    }
    _moveToNext(e) {
      if (!this.#g) {
        this.#m(e);
        return;
      }
      if (e.target === this.#e) {
        this.#r.firstElementChild?.focus();
        return;
      }
      e.target.nextSibling?.focus();
    }
    _moveToPrevious(e) {
      if (e.target === this.#r?.firstElementChild || e.target === this.#e) {
        this.#g && this._hideDropdownFromKeyboard();
        return;
      }
      (this.#g || this.#m(e), e.target.previousSibling?.focus());
    }
    _moveToBeginning(e) {
      if (!this.#g) {
        this.#m(e);
        return;
      }
      this.#r.firstElementChild?.focus();
    }
    _moveToEnd(e) {
      if (!this.#g) {
        this.#m(e);
        return;
      }
      this.#r.lastElementChild?.focus();
    }
    #p(t) {
      e._keyboardManager.exec(this, t);
    }
    #m(e) {
      if (this.#g) {
        this.hideDropdown();
        return;
      }
      if (
        ((this.#i = e.detail === 0),
        this.#c ||
          ((this.#c = new AbortController()),
          window.addEventListener(`pointerdown`, this.#h.bind(this), {
            signal: this.#l.combinedSignal(this.#c),
          })),
        (this.#e.ariaExpanded = `true`),
        this.#r)
      ) {
        this.#r.classList.remove(`hidden`);
        return;
      }
      let t = (this.#r = this.#d());
      this.#e.append(t);
    }
    #h(e) {
      this.#r?.contains(e.target) || this.hideDropdown();
    }
    hideDropdown() {
      (this.#r?.classList.add(`hidden`),
        (this.#e.ariaExpanded = `false`),
        this.#c?.abort(),
        (this.#c = null));
    }
    get #g() {
      return this.#r && !this.#r.classList.contains(`hidden`);
    }
    _hideDropdownFromKeyboard() {
      if (!this.#a) {
        if (!this.#g) {
          this.#o?.unselect();
          return;
        }
        (this.hideDropdown(),
          this.#e.focus({
            preventScroll: !0,
            focusVisible: this.#i,
          }));
      }
    }
    updateColor(e) {
      if ((this.#t && (this.#t.style.backgroundColor = e), !this.#r)) return;
      let t = this.#l.highlightColors.values();
      for (let n of this.#r.children) n.ariaSelected = t.next().value === e.toUpperCase();
    }
    destroy() {
      (this.#e?.remove(), (this.#e = null), (this.#t = null), this.#r?.remove(), (this.#r = null));
    }
  },
  E3 = class e {
    #e = null;
    #t = !1;
    #n = null;
    #r = null;
    static #i = null;
    constructor(t) {
      ((this.#n = t),
        (this.#r = t._uiManager),
        (e.#i ||= Object.freeze({
          freetext: `pdfjs-editor-color-picker-free-text-input`,
          ink: `pdfjs-editor-color-picker-ink-input`,
        })));
    }
    renderButton() {
      if (this.#e) return this.#e;
      let {
          editorType: t,
          colorType: n,
          colorAndOpacityType: r,
          opacityType: i,
          color: a,
          opacity: o,
        } = this.#n,
        s = (this.#t = J0.isAlphaColorInputSupported && i !== void 0),
        c = (this.#e = document.createElement(`input`));
      if (((c.type = `color`), s)) {
        c.setAttribute(`alpha`, ``);
        let e = Y0.hexNums[Math.round((o ?? 1) * 255)];
        c.value = (a || `#000000`) + e;
      } else c.value = a || `#000000`;
      return (
        (c.className = `basicColorPicker`),
        (c.tabIndex = 0),
        c.setAttribute(`data-l10n-id`, e.#i[t]),
        c.addEventListener(
          `input`,
          () => {
            if (s) {
              let e = T2(c.value);
              if (!e) return;
              let [t, a, o, s] = e,
                l = Y0.makeHexColor(t, a, o);
              r === void 0
                ? (this.#r.updateParams(n, l), this.#r.updateParams(i, s))
                : this.#r.updateParams(r, {
                    color: l,
                    opacity: s,
                  });
            } else this.#r.updateParams(n, c.value);
          },
          {
            signal: this.#r._signal,
          },
        ),
        c
      );
    }
    update(e) {
      if (this.#e)
        if (this.#t) {
          let t = Y0.hexNums[Math.round(this.#n.opacity * 255)];
          this.#e.value = e + t;
        } else this.#e.value = e;
    }
    updateOpacity(e) {
      if (!this.#e || !this.#t) return;
      let t = Y0.hexNums[Math.round(e * 255)];
      this.#e.value = this.#n.color + t;
    }
    destroy() {
      (this.#e?.remove(), (this.#e = null));
    }
    hideDropdown() {}
  };
function D3(e) {
  return Math.floor(o2(e, 0, 1) * 255)
    .toString(16)
    .padStart(2, `0`);
}
function O3(e) {
  return o2(e, 0, 1) * 255;
}
var k3 = class {
    static CMYK_G([e, t, n, r]) {
      return [`G`, 1 - Math.min(1, 0.3 * e + 0.59 * n + 0.11 * t + r)];
    }
    static G_CMYK([e]) {
      return [`CMYK`, 0, 0, 0, 1 - e];
    }
    static G_RGB([e]) {
      return [`RGB`, e, e, e];
    }
    static G_rgb([e]) {
      return ((e = O3(e)), [e, e, e]);
    }
    static G_HTML([e]) {
      let t = D3(e);
      return `#${t}${t}${t}`;
    }
    static RGB_G([e, t, n]) {
      return [`G`, 0.3 * e + 0.59 * t + 0.11 * n];
    }
    static RGB_rgb(e) {
      return e.map(O3);
    }
    static RGB_HTML(e) {
      return `#${e.map(D3).join(``)}`;
    }
    static T_HTML() {
      return `#00000000`;
    }
    static T_rgb() {
      return [null];
    }
    static CMYK_RGB([e, t, n, r]) {
      return [`RGB`, 1 - Math.min(1, e + r), 1 - Math.min(1, n + r), 1 - Math.min(1, t + r)];
    }
    static CMYK_rgb([e, t, n, r]) {
      return [O3(1 - Math.min(1, e + r)), O3(1 - Math.min(1, n + r)), O3(1 - Math.min(1, t + r))];
    }
    static CMYK_HTML(e) {
      let t = this.CMYK_RGB(e).slice(1);
      return this.RGB_HTML(t);
    }
    static RGB_CMYK([e, t, n]) {
      let r = 1 - e,
        i = 1 - t,
        a = 1 - n;
      return [`CMYK`, r, i, a, Math.min(r, i, a)];
    }
  },
  bce = class {
    create(e, t, n = !1) {
      if (e <= 0 || t <= 0) throw Error(`Invalid SVG dimensions`);
      let r = this._createSVG(`svg:svg`);
      return (
        r.setAttribute(`version`, `1.1`),
        n || (r.setAttribute(`width`, `${e}px`), r.setAttribute(`height`, `${t}px`)),
        r.setAttribute(`preserveAspectRatio`, `none`),
        r.setAttribute(`viewBox`, `0 0 ${e} ${t}`),
        r
      );
    }
    createElement(e) {
      if (typeof e != `string`) throw Error(`Invalid SVG element type`);
      return this._createSVG(e);
    }
    _createSVG(e) {
      j0("Abstract method `_createSVG` called.");
    }
  },
  A3 = class extends bce {
    _createSVG(e) {
      return document.createElementNS(l2, e);
    }
  },
  xce = 9,
  j3 = new WeakSet(),
  Sce = new Date().getTimezoneOffset() * 60 * 1e3,
  M3 = class {
    static create(e) {
      switch (e.data.annotationType) {
        case b0.LINK:
          return new P3(e);
        case b0.TEXT:
          return new wce(e);
        case b0.WIDGET:
          switch (e.data.fieldType) {
            case `Tx`:
              return new Tce(e);
            case `Btn`:
              return e.data.radioButton ? new I3(e) : e.data.checkBox ? new Dce(e) : new Oce(e);
            case `Ch`:
              return new kce(e);
            case `Sig`:
              return new Ece(e);
          }
          return new F3(e);
        case b0.POPUP:
          return new L3(e);
        case b0.FREETEXT:
          return new R3(e);
        case b0.LINE:
          return new jce(e);
        case b0.SQUARE:
          return new Mce(e);
        case b0.CIRCLE:
          return new Nce(e);
        case b0.POLYLINE:
          return new z3(e);
        case b0.CARET:
          return new Fce(e);
        case b0.INK:
          return new B3(e);
        case b0.POLYGON:
          return new Pce(e);
        case b0.HIGHLIGHT:
          return new V3(e);
        case b0.UNDERLINE:
          return new Ice(e);
        case b0.SQUIGGLY:
          return new Lce(e);
        case b0.STRIKEOUT:
          return new Rce(e);
        case b0.STAMP:
          return new H3(e);
        case b0.FILEATTACHMENT:
          return new zce(e);
        default:
          return new N3(e);
      }
    }
  },
  N3 = class e {
    #e = null;
    #t = !1;
    #n = null;
    constructor(
      e,
      { isRenderable: t = !1, ignoreBorder: n = !1, createQuadrilaterals: r = !1 } = {},
    ) {
      ((this.isRenderable = t),
        (this.data = e.data),
        (this.layer = e.layer),
        (this.linkService = e.linkService),
        (this.downloadManager = e.downloadManager),
        (this.imageResourcesPath = e.imageResourcesPath),
        (this.renderForms = e.renderForms),
        (this.svgFactory = e.svgFactory),
        (this.annotationStorage = e.annotationStorage),
        (this.enableComment = e.enableComment),
        (this.enableScripting = e.enableScripting),
        (this.hasJSActions = e.hasJSActions),
        (this._fieldObjects = e.fieldObjects),
        (this.parent = e.parent),
        (this.hasOwnCommentButton = !1),
        t && (this.contentElement = this.container = this._createContainer(n)),
        r && this._createQuadrilaterals());
    }
    static _hasPopupData({ contentsObj: e, richText: t }) {
      return !!(e?.str || t?.str);
    }
    get _isEditable() {
      return this.data.isEditable;
    }
    get hasPopupData() {
      return e._hasPopupData(this.data) || (this.enableComment && !!this.commentText);
    }
    get commentData() {
      let { data: e } = this,
        t = this.annotationStorage?.getEditor(e.id);
      return t ? t.getData() : e;
    }
    get hasCommentButton() {
      return this.enableComment && this.hasPopupElement;
    }
    get commentButtonPosition() {
      let e = this.annotationStorage?.getEditor(this.data.id);
      if (e) return e.commentButtonPositionInPage;
      let { quadPoints: t, inkLists: n, rect: r } = this.data,
        i = -1 / 0,
        a = -1 / 0;
      if (t?.length >= 8) {
        for (let e = 0; e < t.length; e += 8)
          t[e + 1] > a
            ? ((a = t[e + 1]), (i = t[e + 2]))
            : t[e + 1] === a && (i = Math.max(i, t[e + 2]));
        return [i, a];
      }
      if (n?.length >= 1) {
        for (let e of n)
          for (let t = 0, n = e.length; t < n; t += 2)
            e[t + 1] > a ? ((a = e[t + 1]), (i = e[t])) : e[t + 1] === a && (i = Math.max(i, e[t]));
        if (i !== 1 / 0) return [i, a];
      }
      return r ? [r[2], r[3]] : null;
    }
    _normalizePoint(e) {
      let {
        page: { view: t },
        viewport: {
          rawDims: { pageWidth: n, pageHeight: r, pageX: i, pageY: a },
        },
      } = this.parent;
      return (
        (e[1] = t[3] - e[1] + t[1]),
        (e[0] = (100 * (e[0] - i)) / n),
        (e[1] = (100 * (e[1] - a)) / r),
        e
      );
    }
    get commentText() {
      let { data: e } = this;
      return (
        this.annotationStorage.getRawValue(`${m0}${e.id}`)?.popup?.contents ||
        e.contentsObj?.str ||
        ``
      );
    }
    set commentText(e) {
      let { data: t } = this,
        n = {
          deleted: !e,
          contents: e || ``,
        };
      (this.annotationStorage.updateEditor(t.id, {
        popup: n,
      }) ||
        this.annotationStorage.setValue(`${m0}${t.id}`, {
          id: t.id,
          annotationType: t.annotationType,
          page: this.parent.page,
          popup: n,
          popupRef: t.popupRef,
          modificationDate: new Date(),
        }),
        e || this.removePopup());
    }
    removePopup() {
      ((this.#n?.popup || this.popup)?.remove(), (this.#n = this.popup = null));
    }
    updateEdited(e) {
      if (!this.container) return;
      e.rect &&
        (this.#e ||= {
          rect: this.data.rect.slice(0),
        });
      let { rect: t, popup: n } = e;
      t && this.#r(t);
      let r = this.#n?.popup || this.popup;
      (!r && n?.text && (this._createPopup(n), (r = this.#n.popup)),
        r &&
          (r.updateEdited(e), n?.deleted && (r.remove(), (this.#n = null), (this.popup = null))));
    }
    resetEdited() {
      this.#e &&= (this.#r(this.#e.rect), this.#n?.popup.resetEdited(), null);
    }
    #r(e) {
      let {
        container: { style: t },
        data: { rect: n, rotation: r },
        parent: {
          viewport: {
            rawDims: { pageWidth: i, pageHeight: a, pageX: o, pageY: s },
          },
        },
      } = this;
      (n?.splice(0, 4, ...e),
        (t.left = `${(100 * (e[0] - o)) / i}%`),
        (t.top = `${(100 * (a - e[3] + s)) / a}%`),
        r === 0
          ? ((t.width = `${(100 * (e[2] - e[0])) / i}%`),
            (t.height = `${(100 * (e[3] - e[1])) / a}%`))
          : this.setRotation(r));
    }
    _createContainer(e) {
      let {
          data: t,
          parent: { page: n, viewport: r },
        } = this,
        i = document.createElement(`section`);
      (i.setAttribute(`data-annotation-id`, t.id),
        !(this instanceof F3) && !(this instanceof P3) && (i.tabIndex = 0));
      let { style: a } = i;
      if (
        ((a.zIndex = this.parent.zIndex),
        (this.parent.zIndex += 2),
        t.alternativeText && (i.title = t.alternativeText),
        t.noRotate && i.classList.add(`norotate`),
        !t.rect || this instanceof L3)
      ) {
        let { rotation: e } = t;
        return (!t.hasOwnCanvas && e !== 0 && this.setRotation(e, i), i);
      }
      let { width: o, height: s } = this;
      if (!e && t.borderStyle.width > 0) {
        a.borderWidth = `${t.borderStyle.width}px`;
        let e = t.borderStyle.horizontalCornerRadius,
          n = t.borderStyle.verticalCornerRadius;
        switch (
          (e > 0 || n > 0
            ? (a.borderRadius = `calc(${e}px * var(--total-scale-factor)) / calc(${n}px * var(--total-scale-factor))`)
            : this instanceof I3 &&
              (a.borderRadius = `calc(${o}px * var(--total-scale-factor)) / calc(${s}px * var(--total-scale-factor))`),
          t.borderStyle.style)
        ) {
          case x0.SOLID:
            a.borderStyle = `solid`;
            break;
          case x0.DASHED:
            a.borderStyle = `dashed`;
            break;
          case x0.BEVELED:
            A0(`Unimplemented border style: beveled`);
            break;
          case x0.INSET:
            A0(`Unimplemented border style: inset`);
            break;
          case x0.UNDERLINE:
            a.borderBottomStyle = `solid`;
            break;
          default:
            break;
        }
        let r = t.borderColor || null;
        r ? ((this.#t = !0), (a.borderColor = Y0.makeHexColor(...r))) : (a.borderWidth = 0);
      }
      let c = Y0.normalizeRect([
          t.rect[0],
          n.view[3] - t.rect[1] + n.view[1],
          t.rect[2],
          n.view[3] - t.rect[3] + n.view[1],
        ]),
        { pageWidth: l, pageHeight: u, pageX: d, pageY: f } = r.rawDims;
      ((a.left = `${(100 * (c[0] - d)) / l}%`), (a.top = `${(100 * (c[1] - f)) / u}%`));
      let { rotation: p } = t;
      return (
        t.hasOwnCanvas || p === 0
          ? ((a.width = `${(100 * o) / l}%`), (a.height = `${(100 * s) / u}%`))
          : this.setRotation(p, i),
        i
      );
    }
    setRotation(e, t = this.container) {
      if (!this.data.rect) return;
      let { pageWidth: n, pageHeight: r } = this.parent.viewport.rawDims,
        { width: i, height: a } = this;
      (e % 180 != 0 && ([i, a] = [a, i]),
        (t.style.width = `${(100 * i) / n}%`),
        (t.style.height = `${(100 * a) / r}%`),
        t.setAttribute(`data-main-rotation`, (360 - e) % 360));
    }
    get _commonActions() {
      let e = (e, t, n) => {
        let r = n.detail[e],
          i = r[0],
          a = r.slice(1);
        ((n.target.style[t] = k3[`${i}_HTML`](a)),
          this.annotationStorage.setValue(this.data.id, {
            [t]: k3[`${i}_rgb`](a),
          }));
      };
      return L0(this, `_commonActions`, {
        display: (e) => {
          let { display: t } = e.detail,
            n = t % 2 == 1;
          ((this.container.style.visibility = n ? `hidden` : `visible`),
            this.annotationStorage.setValue(this.data.id, {
              noView: n,
              noPrint: t === 1 || t === 2,
            }));
        },
        print: (e) => {
          this.annotationStorage.setValue(this.data.id, {
            noPrint: !e.detail.print,
          });
        },
        hidden: (e) => {
          let { hidden: t } = e.detail;
          ((this.container.style.visibility = t ? `hidden` : `visible`),
            this.annotationStorage.setValue(this.data.id, {
              noPrint: t,
              noView: t,
            }));
        },
        focus: (e) => {
          setTimeout(
            () =>
              e.target.focus({
                preventScroll: !1,
              }),
            0,
          );
        },
        userName: (e) => {
          e.target.title = e.detail.userName;
        },
        readonly: (e) => {
          e.target.disabled = e.detail.readonly;
        },
        required: (e) => {
          this._setRequired(e.target, e.detail.required);
        },
        bgColor: (t) => {
          e(`bgColor`, `backgroundColor`, t);
        },
        fillColor: (t) => {
          e(`fillColor`, `backgroundColor`, t);
        },
        fgColor: (t) => {
          e(`fgColor`, `color`, t);
        },
        textColor: (t) => {
          e(`textColor`, `color`, t);
        },
        borderColor: (t) => {
          e(`borderColor`, `borderColor`, t);
        },
        strokeColor: (t) => {
          e(`strokeColor`, `borderColor`, t);
        },
        rotation: (e) => {
          let t = e.detail.rotation;
          (this.setRotation(t),
            this.annotationStorage.setValue(this.data.id, {
              rotation: t,
            }));
        },
      });
    }
    _dispatchEventFromSandbox(e, t) {
      let n = this._commonActions;
      for (let r of Object.keys(t.detail)) (e[r] || n[r])?.(t);
    }
    _setDefaultPropertiesFromJS(e) {
      if (!this.enableScripting) return;
      let t = this.annotationStorage.getRawValue(this.data.id);
      if (!t) return;
      let n = this._commonActions;
      for (let [r, i] of Object.entries(t)) {
        let a = n[r];
        a &&
          (a({
            detail: {
              [r]: i,
            },
            target: e,
          }),
          delete t[r]);
      }
    }
    _createQuadrilaterals() {
      if (!this.container) return;
      let { quadPoints: e } = this.data;
      if (!e) return;
      let [t, n, r, i] = this.data.rect.map((e) => Math.fround(e));
      if (e.length === 8) {
        let [a, o, s, c] = e.subarray(2, 6);
        if (r === a && i === o && t === s && n === c) return;
      }
      let { style: a } = this.container,
        o;
      if (this.#t) {
        let { borderColor: e, borderWidth: t } = a;
        ((a.borderWidth = 0),
          (o = [
            `url('data:image/svg+xml;utf8,`,
            `<svg xmlns="http://www.w3.org/2000/svg"`,
            ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
            `<g fill="transparent" stroke="${e}" stroke-width="${t}">`,
          ]),
          this.container.classList.add(`hasBorder`));
      }
      let s = r - t,
        c = i - n,
        { svgFactory: l } = this,
        u = l.createElement(`svg`);
      (u.classList.add(`quadrilateralsContainer`),
        u.setAttribute(`width`, 0),
        u.setAttribute(`height`, 0),
        (u.role = `none`));
      let d = l.createElement(`defs`);
      u.append(d);
      let f = l.createElement(`clipPath`),
        p = `clippath_${this.data.id}`;
      (f.setAttribute(`id`, p), f.setAttribute(`clipPathUnits`, `objectBoundingBox`), d.append(f));
      for (let n = 2, r = e.length; n < r; n += 8) {
        let r = e[n],
          a = e[n + 1],
          u = e[n + 2],
          d = e[n + 3],
          p = l.createElement(`rect`),
          m = (u - t) / s,
          h = (i - a) / c,
          g = (r - u) / s,
          v = (a - d) / c;
        (p.setAttribute(`x`, m),
          p.setAttribute(`y`, h),
          p.setAttribute(`width`, g),
          p.setAttribute(`height`, v),
          f.append(p),
          o?.push(
            `<rect vector-effect="non-scaling-stroke" x="${m}" y="${h}" width="${g}" height="${v}"/>`,
          ));
      }
      (this.#t && (o.push(`</g></svg>')`), (a.backgroundImage = o.join(``))),
        this.container.append(u),
        (this.container.style.clipPath = `url(#${p})`));
    }
    _createPopup(e = null) {
      let { data: t } = this,
        n,
        r;
      (e
        ? ((n = {
            str: e.text,
          }),
          (r = e.date))
        : ((n = t.contentsObj), (r = t.modificationDate)),
        (this.#n = new L3({
          data: {
            color: t.color,
            titleObj: t.titleObj,
            modificationDate: r,
            contentsObj: n,
            richText: t.richText,
            parentRect: t.rect,
            borderStyle: 0,
            id: `popup_${t.id}`,
            rotation: t.rotation,
            noRotate: !0,
          },
          linkService: this.linkService,
          parent: this.parent,
          elements: [this],
        })));
    }
    get hasPopupElement() {
      return !!(this.#n || this.popup || this.data.popupRef);
    }
    get extraPopupElement() {
      return this.#n;
    }
    render() {
      j0("Abstract method `AnnotationElement.render` called");
    }
    _getElementsByName(e, t = null) {
      let n = [];
      if (this._fieldObjects) {
        let r = this._fieldObjects[e];
        if (r)
          for (let { page: e, id: i, exportValues: a } of r) {
            if (e === -1 || i === t) continue;
            let r = typeof a == `string` ? a : null,
              o = document.querySelector(`[data-element-id="${i}"]`);
            if (o && !j3.has(o)) {
              A0(`_getElementsByName - element not allowed: ${i}`);
              continue;
            }
            n.push({
              id: i,
              exportValue: r,
              domElement: o,
            });
          }
        return n;
      }
      for (let r of document.getElementsByName(e)) {
        let { exportValue: e } = r,
          i = r.getAttribute(`data-element-id`);
        i !== t &&
          j3.has(r) &&
          n.push({
            id: i,
            exportValue: e,
            domElement: r,
          });
      }
      return n;
    }
    show() {
      (this.container && (this.container.hidden = !1), this.popup?.maybeShow());
    }
    hide() {
      (this.container && (this.container.hidden = !0), this.popup?.forceHide());
    }
    getElementsToTriggerPopup() {
      return this.container;
    }
    addHighlightArea() {
      let e = this.getElementsToTriggerPopup();
      if (Array.isArray(e)) for (let t of e) t.classList.add(`highlightArea`);
      else e.classList.add(`highlightArea`);
    }
    _editOnDoubleClick() {
      if (!this._isEditable) return;
      let {
        annotationEditorType: e,
        data: { id: t },
      } = this;
      this.container.addEventListener(`dblclick`, () => {
        this.linkService.eventBus?.dispatch(`switchannotationeditormode`, {
          source: this,
          mode: e,
          editId: t,
          mustEnterInEditMode: !0,
        });
      });
    }
    get width() {
      return this.data.rect[2] - this.data.rect[0];
    }
    get height() {
      return this.data.rect[3] - this.data.rect[1];
    }
  },
  Cce = class extends N3 {
    constructor(e) {
      (super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      }),
        (this.editor = e.editor));
    }
    render() {
      return ((this.container.className = `editorAnnotation`), this.container);
    }
    createOrUpdatePopup() {
      let { editor: e } = this;
      e.hasComment && this._createPopup(e.comment);
    }
    get hasCommentButton() {
      return this.enableComment && this.editor.hasComment;
    }
    get commentButtonPosition() {
      return this.editor.commentButtonPositionInPage;
    }
    get commentText() {
      return this.editor.comment.text;
    }
    set commentText(e) {
      ((this.editor.comment = e), e || this.removePopup());
    }
    get commentData() {
      return this.editor.getData();
    }
    remove() {
      (this.parent.removeAnnotation(this.data.id),
        this.container.remove(),
        (this.container = null),
        this.removePopup());
    }
  },
  P3 = class extends N3 {
    constructor(e, t = null) {
      (super(e, {
        isRenderable: !0,
        ignoreBorder: !!t?.ignoreBorder,
        createQuadrilaterals: !0,
      }),
        (this.isTooltipOnly = e.data.isTooltipOnly));
    }
    render() {
      let { data: e, linkService: t } = this,
        n = document.createElement(`a`);
      n.setAttribute(`data-element-id`, e.id);
      let r = !1;
      return (
        e.url
          ? (t.addLinkAttributes(n, e.url, e.newWindow), (r = !0))
          : e.action
            ? (this._bindNamedAction(n, e.action, e.overlaidText), (r = !0))
            : e.attachment
              ? (this.#t(n, e.attachment, e.overlaidText, e.attachmentDest), (r = !0))
              : e.setOCGState
                ? (this.#n(n, e.setOCGState, e.overlaidText), (r = !0))
                : e.dest
                  ? (this._bindLink(n, e.dest, e.overlaidText), (r = !0))
                  : (e.actions &&
                      (e.actions.Action || e.actions[`Mouse Up`] || e.actions[`Mouse Down`]) &&
                      this.enableScripting &&
                      this.hasJSActions &&
                      (this._bindJSAction(n, e), (r = !0)),
                    e.resetForm
                      ? (this._bindResetFormAction(n, e.resetForm), (r = !0))
                      : this.isTooltipOnly && !r && (this._bindLink(n, ``), (r = !0))),
        this.container.classList.add(`linkAnnotation`),
        r && ((this.contentElement = n), this.container.append(n)),
        this.container
      );
    }
    #e() {
      this.container.setAttribute(`data-internal-link`, ``);
    }
    _bindLink(e, t, n = ``) {
      ((e.href = this.linkService.getDestinationHash(t)),
        (e.onclick = () => (t && this.linkService.goToDestination(t), !1)),
        (t || t === ``) && this.#e(),
        n && (e.title = n));
    }
    _bindNamedAction(e, t, n = ``) {
      ((e.href = this.linkService.getAnchorUrl(``)),
        (e.onclick = () => (this.linkService.executeNamedAction(t), !1)),
        n && (e.title = n),
        this.#e());
    }
    #t(e, t, n = ``, r = null) {
      ((e.href = this.linkService.getAnchorUrl(``)),
        t.description ? (e.title = t.description) : n && (e.title = n),
        (e.onclick = () => (
          this.downloadManager?.openOrDownloadData(t.content, t.filename, r),
          !1
        )),
        this.#e());
    }
    #n(e, t, n = ``) {
      ((e.href = this.linkService.getAnchorUrl(``)),
        (e.onclick = () => (this.linkService.executeSetOCGState(t), !1)),
        n && (e.title = n),
        this.#e());
    }
    _bindJSAction(e, t) {
      e.href = this.linkService.getAnchorUrl(``);
      let n = new Map([
        [`Action`, `onclick`],
        [`Mouse Up`, `onmouseup`],
        [`Mouse Down`, `onmousedown`],
      ]);
      for (let r of Object.keys(t.actions)) {
        let i = n.get(r);
        i &&
          (e[i] = () => (
            this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
              source: this,
              detail: {
                id: t.id,
                name: r,
              },
            }),
            !1
          ));
      }
      (t.overlaidText && (e.title = t.overlaidText), (e.onclick ||= () => !1), this.#e());
    }
    _bindResetFormAction(e, t) {
      let n = e.onclick;
      if ((n || (e.href = this.linkService.getAnchorUrl(``)), this.#e(), !this._fieldObjects)) {
        (A0(
          '_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.',
        ),
          n || (e.onclick = () => !1));
        return;
      }
      e.onclick = () => {
        n?.();
        let { fields: e, refs: r, include: i } = t,
          a = [];
        if (e.length !== 0 || r.length !== 0) {
          let t = new Set(r);
          for (let n of e) {
            let e = this._fieldObjects[n] || [];
            for (let { id: n } of e) t.add(n);
          }
          for (let e of Object.values(this._fieldObjects))
            for (let n of e) t.has(n.id) === i && a.push(n);
        } else for (let e of Object.values(this._fieldObjects)) a.push(...e);
        let o = this.annotationStorage,
          s = [];
        for (let e of a) {
          let { id: t } = e;
          switch ((s.push(t), e.type)) {
            case `text`: {
              let n = e.defaultValue || ``;
              o.setValue(t, {
                value: n,
              });
              break;
            }
            case `checkbox`:
            case `radiobutton`: {
              let n = e.defaultValue === e.exportValues;
              o.setValue(t, {
                value: n,
              });
              break;
            }
            case `combobox`:
            case `listbox`: {
              let n = e.defaultValue || ``;
              o.setValue(t, {
                value: n,
              });
              break;
            }
            default:
              continue;
          }
          let n = document.querySelector(`[data-element-id="${t}"]`);
          if (n) {
            if (!j3.has(n)) {
              A0(`_bindResetFormAction - element not allowed: ${t}`);
              continue;
            }
            n.dispatchEvent(new Event(`resetform`));
          }
        }
        return (
          this.enableScripting &&
            this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
              source: this,
              detail: {
                id: `app`,
                ids: s,
                name: `ResetForm`,
              },
            }),
          !1
        );
      };
    }
  },
  wce = class extends N3 {
    constructor(e) {
      super(e, {
        isRenderable: !0,
      });
    }
    render() {
      this.container.classList.add(`textAnnotation`);
      let e = document.createElement(`img`);
      return (
        (e.src = this.imageResourcesPath + `annotation-` + this.data.name.toLowerCase() + `.svg`),
        e.setAttribute(`data-l10n-id`, `pdfjs-text-annotation-type`),
        e.setAttribute(
          `data-l10n-args`,
          JSON.stringify({
            type: this.data.name,
          }),
        ),
        !this.data.popupRef &&
          this.hasPopupData &&
          ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container.append(e),
        this.container
      );
    }
  },
  F3 = class extends N3 {
    render() {
      return this.container;
    }
    showElementAndHideCanvas(e) {
      this.data.hasOwnCanvas &&
        (e.previousSibling?.nodeName === `CANVAS` && (e.previousSibling.hidden = !0),
        (e.hidden = !1));
    }
    _getKeyModifier(e) {
      return J0.platform.isMac ? e.metaKey : e.ctrlKey;
    }
    _setEventListener(e, t, n, r, i) {
      n.includes(`mouse`)
        ? e.addEventListener(n, (e) => {
            this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
              source: this,
              detail: {
                id: this.data.id,
                name: r,
                value: i(e),
                shift: e.shiftKey,
                modifier: this._getKeyModifier(e),
              },
            });
          })
        : e.addEventListener(n, (e) => {
            if (n === `blur`) {
              if (!t.focused || !e.relatedTarget) return;
              t.focused = !1;
            } else if (n === `focus`) {
              if (t.focused) return;
              t.focused = !0;
            }
            i &&
              this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
                source: this,
                detail: {
                  id: this.data.id,
                  name: r,
                  value: i(e),
                },
              });
          });
    }
    _setEventListeners(e, t, n, r) {
      for (let [i, a] of n)
        (a === `Action` || this.data.actions?.[a]) &&
          ((a === `Focus` || a === `Blur`) &&
            (t ||= {
              focused: !1,
            }),
          this._setEventListener(e, t, i, a, r),
          a === `Focus` && !this.data.actions?.Blur
            ? this._setEventListener(e, t, `blur`, `Blur`, null)
            : a === `Blur` &&
              !this.data.actions?.Focus &&
              this._setEventListener(e, t, `focus`, `Focus`, null));
    }
    _setBackgroundColor(e) {
      let t = this.data.backgroundColor || null;
      e.style.backgroundColor = t === null ? `transparent` : Y0.makeHexColor(...t);
    }
    _setTextStyle(e) {
      let t = [`left`, `center`, `right`],
        { fontColor: n } = this.data.defaultAppearanceData,
        r = this.data.defaultAppearanceData.fontSize || xce,
        i = e.style,
        a,
        o = (e) => Math.round(10 * e) / 10;
      if (this.data.multiLine) {
        let e = Math.abs(this.data.rect[3] - this.data.rect[1] - 2),
          t = e / (Math.round(e / (d0 * r)) || 1);
        a = Math.min(r, o(t / d0));
      } else {
        let e = Math.abs(this.data.rect[3] - this.data.rect[1] - 2);
        a = Math.min(r, o(e / d0));
      }
      ((i.fontSize = `calc(${a}px * var(--total-scale-factor))`),
        (i.color = Y0.makeHexColor(...n)),
        this.data.textAlignment !== null && (i.textAlign = t[this.data.textAlignment]));
    }
    _setRequired(e, t) {
      (t ? e.setAttribute(`required`, !0) : e.removeAttribute(`required`),
        e.setAttribute(`aria-required`, t));
    }
  },
  Tce = class extends F3 {
    constructor(e) {
      let t =
        e.renderForms || e.data.hasOwnCanvas || (!e.data.hasAppearance && !!e.data.fieldValue);
      super(e, {
        isRenderable: t,
      });
    }
    setPropertyOnSiblings(e, t, n, r) {
      let i = this.annotationStorage;
      for (let a of this._getElementsByName(e.name, e.id))
        (a.domElement && (a.domElement[t] = n),
          i.setValue(a.id, {
            [r]: n,
          }));
    }
    render() {
      let e = this.annotationStorage,
        t = this.data.id;
      this.container.classList.add(`textWidgetAnnotation`);
      let n = null;
      if (this.renderForms) {
        let r = e.getValue(t, {
            value: this.data.fieldValue,
          }),
          i = r.value || ``,
          a = e.getValue(t, {
            charLimit: this.data.maxLen,
          }).charLimit;
        a && i.length > a && (i = i.slice(0, a));
        let o =
          r.formattedValue ||
          this.data.textContent?.join(`
`) ||
          null;
        o && this.data.comb && (o = o.replaceAll(/\s+/g, ``));
        let s = {
          userValue: i,
          formattedValue: o,
          lastCommittedValue: null,
          commitKey: 1,
          focused: !1,
        };
        (this.data.multiLine
          ? ((n = document.createElement(`textarea`)),
            (n.textContent = o ?? i),
            this.data.doNotScroll && (n.style.overflowY = `hidden`))
          : ((n = document.createElement(`input`)),
            (n.type = this.data.password ? `password` : `text`),
            n.setAttribute(`value`, o ?? i),
            this.data.doNotScroll && (n.style.overflowX = `hidden`)),
          this.data.hasOwnCanvas && (n.hidden = !0),
          j3.add(n),
          (this.contentElement = n),
          n.setAttribute(`data-element-id`, t),
          (n.disabled = this.data.readOnly),
          (n.name = this.data.fieldName),
          (n.tabIndex = 0));
        let { datetimeFormat: c, datetimeType: l, timeStep: u } = this.data,
          d = !!l && this.enableScripting;
        (c && (n.title = c),
          this._setRequired(n, this.data.required),
          a && (n.maxLength = a),
          n.addEventListener(`input`, (r) => {
            (e.setValue(t, {
              value: r.target.value,
            }),
              this.setPropertyOnSiblings(n, `value`, r.target.value, `value`),
              (s.formattedValue = null));
          }),
          n.addEventListener(`resetform`, (e) => {
            let t = this.data.defaultFieldValue ?? ``;
            ((n.value = s.userValue = t), (s.formattedValue = null));
          }));
        let f = (e) => {
          let { formattedValue: t } = s;
          (t != null && (e.target.value = t), (e.target.scrollLeft = 0));
        };
        if (this.enableScripting && this.hasJSActions) {
          (n.addEventListener(`focus`, (e) => {
            if (s.focused) return;
            let { target: t } = e;
            if ((d && ((t.type = l), u && (t.step = u)), s.userValue)) {
              let e = s.userValue;
              if (d) {
                if (l === `time`) {
                  let n = new Date(e);
                  t.value = [n.getHours(), n.getMinutes(), n.getSeconds()]
                    .map((e) => e.toString().padStart(2, `0`))
                    .join(`:`);
                } else
                  t.value = new Date(e - Sce).toISOString().split(l === `date` ? `T` : `.`, 1)[0];
              } else t.value = e;
            }
            ((s.lastCommittedValue = t.value),
              (s.commitKey = 1),
              this.data.actions?.Focus || (s.focused = !0));
          }),
            n.addEventListener(`updatefromsandbox`, (n) => {
              (this.showElementAndHideCanvas(n.target),
                this._dispatchEventFromSandbox(
                  {
                    value(n) {
                      ((s.userValue = n.detail.value ?? ``),
                        d ||
                          e.setValue(t, {
                            value: s.userValue.toString(),
                          }),
                        (n.target.value = s.userValue));
                    },
                    formattedValue(n) {
                      let { formattedValue: r } = n.detail;
                      ((s.formattedValue = r),
                        r != null && n.target !== document.activeElement && (n.target.value = r));
                      let i = {
                        formattedValue: r,
                      };
                      (d && (i.value = r), e.setValue(t, i));
                    },
                    selRange(e) {
                      e.target.setSelectionRange(...e.detail.selRange);
                    },
                    charLimit: (n) => {
                      let { charLimit: r } = n.detail,
                        { target: i } = n;
                      if (r === 0) {
                        i.removeAttribute(`maxLength`);
                        return;
                      }
                      i.setAttribute(`maxLength`, r);
                      let a = s.userValue;
                      !a ||
                        a.length <= r ||
                        ((a = a.slice(0, r)),
                        (i.value = s.userValue = a),
                        e.setValue(t, {
                          value: a,
                        }),
                        this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
                          source: this,
                          detail: {
                            id: t,
                            name: `Keystroke`,
                            value: a,
                            willCommit: !0,
                            commitKey: 1,
                            selStart: i.selectionStart,
                            selEnd: i.selectionEnd,
                          },
                        }));
                    },
                  },
                  n,
                ));
            }),
            n.addEventListener(`keydown`, (e) => {
              s.commitKey = 1;
              let n = -1;
              if (
                (e.key === `Escape`
                  ? (n = 0)
                  : e.key === `Enter` && !this.data.multiLine
                    ? (n = 2)
                    : e.key === `Tab` && (s.commitKey = 3),
                n === -1)
              )
                return;
              let { value: r } = e.target;
              s.lastCommittedValue !== r &&
                ((s.lastCommittedValue = r),
                (s.userValue = r),
                this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
                  source: this,
                  detail: {
                    id: t,
                    name: `Keystroke`,
                    value: r,
                    willCommit: !0,
                    commitKey: n,
                    selStart: e.target.selectionStart,
                    selEnd: e.target.selectionEnd,
                  },
                }));
            }));
          let r = f;
          ((f = null),
            n.addEventListener(`blur`, (e) => {
              if (!s.focused || !e.relatedTarget) return;
              this.data.actions?.Blur || (s.focused = !1);
              let { target: n } = e,
                { value: i } = n;
              if (d) {
                if (i && l === `time`) {
                  let e = i.split(`:`).map((e) => parseInt(e, 10));
                  ((i = new Date(2e3, 0, 1, e[0], e[1], e[2] || 0).valueOf()), (n.step = ``));
                } else (i.includes(`T`) || (i = `${i}T00:00`), (i = new Date(i).valueOf()));
                n.type = `text`;
              }
              ((s.userValue = i),
                s.lastCommittedValue !== i &&
                  this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
                    source: this,
                    detail: {
                      id: t,
                      name: `Keystroke`,
                      value: i,
                      willCommit: !0,
                      commitKey: s.commitKey,
                      selStart: e.target.selectionStart,
                      selEnd: e.target.selectionEnd,
                    },
                  }),
                r(e));
            }),
            this.data.actions?.Keystroke &&
              n.addEventListener(`beforeinput`, (e) => {
                s.lastCommittedValue = null;
                let { data: n, target: r } = e,
                  { value: i, selectionStart: a, selectionEnd: o } = r,
                  c = a,
                  l = o;
                switch (e.inputType) {
                  case `deleteWordBackward`: {
                    let e = i.substring(0, a).match(/\w*[^\w]*$/);
                    e && (c -= e[0].length);
                    break;
                  }
                  case `deleteWordForward`: {
                    let e = i.substring(a).match(/^[^\w]*\w*/);
                    e && (l += e[0].length);
                    break;
                  }
                  case `deleteContentBackward`:
                    a === o && --c;
                    break;
                  case `deleteContentForward`:
                    a === o && (l += 1);
                    break;
                }
                (e.preventDefault(),
                  this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
                    source: this,
                    detail: {
                      id: t,
                      name: `Keystroke`,
                      value: i,
                      change: n || ``,
                      willCommit: !1,
                      selStart: c,
                      selEnd: l,
                    },
                  }));
              }),
            this._setEventListeners(
              n,
              s,
              [
                [`focus`, `Focus`],
                [`blur`, `Blur`],
                [`mousedown`, `Mouse Down`],
                [`mouseenter`, `Mouse Enter`],
                [`mouseleave`, `Mouse Exit`],
                [`mouseup`, `Mouse Up`],
              ],
              (e) => e.target.value,
            ));
        }
        if ((f && n.addEventListener(`blur`, f), this.data.comb)) {
          let e = (this.data.rect[2] - this.data.rect[0]) / a;
          (n.classList.add(`comb`),
            (n.style.letterSpacing = `calc(${e}px * var(--total-scale-factor) - 1ch)`));
        }
      } else
        ((n = document.createElement(`div`)),
          (n.textContent = this.data.fieldValue),
          (n.style.verticalAlign = `middle`),
          (n.style.display = `table-cell`),
          this.data.hasOwnCanvas && (n.hidden = !0));
      return (
        this._setTextStyle(n),
        this._setBackgroundColor(n),
        this._setDefaultPropertiesFromJS(n),
        this.container.append(n),
        this.container
      );
    }
  },
  Ece = class extends F3 {
    constructor(e) {
      super(e, {
        isRenderable: !!e.data.hasOwnCanvas,
      });
    }
  },
  Dce = class extends F3 {
    constructor(e) {
      super(e, {
        isRenderable: e.renderForms,
      });
    }
    render() {
      let e = this.annotationStorage,
        t = this.data,
        n = t.id,
        r = e.getValue(n, {
          value: t.exportValue === t.fieldValue,
        }).value;
      (typeof r == `string` &&
        ((r = r !== `Off`),
        e.setValue(n, {
          value: r,
        })),
        this.container.classList.add(`buttonWidgetAnnotation`, `checkBox`));
      let i = document.createElement(`input`);
      return (
        j3.add(i),
        i.setAttribute(`data-element-id`, n),
        (i.disabled = t.readOnly),
        this._setRequired(i, this.data.required),
        (i.type = `checkbox`),
        (i.name = t.fieldName),
        r && i.setAttribute(`checked`, !0),
        i.setAttribute(`exportValue`, t.exportValue),
        (i.tabIndex = 0),
        i.addEventListener(`change`, (r) => {
          let { name: i, checked: a } = r.target;
          for (let r of this._getElementsByName(i, n)) {
            let n = a && r.exportValue === t.exportValue;
            (r.domElement && (r.domElement.checked = n),
              e.setValue(r.id, {
                value: n,
              }));
          }
          e.setValue(n, {
            value: a,
          });
        }),
        i.addEventListener(`resetform`, (e) => {
          let n = t.defaultFieldValue || `Off`;
          e.target.checked = n === t.exportValue;
        }),
        this.enableScripting &&
          this.hasJSActions &&
          (i.addEventListener(`updatefromsandbox`, (t) => {
            this._dispatchEventFromSandbox(
              {
                value(t) {
                  ((t.target.checked = t.detail.value !== `Off`),
                    e.setValue(n, {
                      value: t.target.checked,
                    }));
                },
              },
              t,
            );
          }),
          this._setEventListeners(
            i,
            null,
            [
              [`change`, `Validate`],
              [`change`, `Action`],
              [`focus`, `Focus`],
              [`blur`, `Blur`],
              [`mousedown`, `Mouse Down`],
              [`mouseenter`, `Mouse Enter`],
              [`mouseleave`, `Mouse Exit`],
              [`mouseup`, `Mouse Up`],
            ],
            (e) => e.target.checked,
          )),
        this._setBackgroundColor(i),
        this._setDefaultPropertiesFromJS(i),
        this.container.append(i),
        this.container
      );
    }
  },
  I3 = class extends F3 {
    constructor(e) {
      super(e, {
        isRenderable: e.renderForms,
      });
    }
    render() {
      this.container.classList.add(`buttonWidgetAnnotation`, `radioButton`);
      let e = this.annotationStorage,
        t = this.data,
        n = t.id,
        r = e.getValue(n, {
          value: t.fieldValue === t.buttonValue,
        }).value;
      if (
        (typeof r == `string` &&
          ((r = r !== t.buttonValue),
          e.setValue(n, {
            value: r,
          })),
        r)
      )
        for (let r of this._getElementsByName(t.fieldName, n))
          e.setValue(r.id, {
            value: !1,
          });
      let i = document.createElement(`input`);
      if (
        (j3.add(i),
        i.setAttribute(`data-element-id`, n),
        (i.disabled = t.readOnly),
        this._setRequired(i, this.data.required),
        (i.type = `radio`),
        (i.name = t.fieldName),
        r && i.setAttribute(`checked`, !0),
        (i.tabIndex = 0),
        i.addEventListener(`change`, (t) => {
          let { name: r, checked: i } = t.target;
          for (let t of this._getElementsByName(r, n))
            e.setValue(t.id, {
              value: !1,
            });
          e.setValue(n, {
            value: i,
          });
        }),
        i.addEventListener(`resetform`, (e) => {
          let n = t.defaultFieldValue;
          e.target.checked = n != null && n === t.buttonValue;
        }),
        this.enableScripting && this.hasJSActions)
      ) {
        let r = t.buttonValue;
        (i.addEventListener(`updatefromsandbox`, (t) => {
          this._dispatchEventFromSandbox(
            {
              value: (t) => {
                let i = r === t.detail.value;
                for (let r of this._getElementsByName(t.target.name)) {
                  let t = i && r.id === n;
                  (r.domElement && (r.domElement.checked = t),
                    e.setValue(r.id, {
                      value: t,
                    }));
                }
              },
            },
            t,
          );
        }),
          this._setEventListeners(
            i,
            null,
            [
              [`change`, `Validate`],
              [`change`, `Action`],
              [`focus`, `Focus`],
              [`blur`, `Blur`],
              [`mousedown`, `Mouse Down`],
              [`mouseenter`, `Mouse Enter`],
              [`mouseleave`, `Mouse Exit`],
              [`mouseup`, `Mouse Up`],
            ],
            (e) => e.target.checked,
          ));
      }
      return (
        this._setBackgroundColor(i),
        this._setDefaultPropertiesFromJS(i),
        this.container.append(i),
        this.container
      );
    }
  },
  Oce = class extends P3 {
    constructor(e) {
      super(e, {
        ignoreBorder: e.data.hasAppearance,
      });
    }
    render() {
      let e = super.render();
      e.classList.add(`buttonWidgetAnnotation`, `pushButton`);
      let t = e.lastChild;
      return (
        this.enableScripting &&
          this.hasJSActions &&
          t &&
          (this._setDefaultPropertiesFromJS(t),
          t.addEventListener(`updatefromsandbox`, (e) => {
            this._dispatchEventFromSandbox({}, e);
          })),
        e
      );
    }
  },
  kce = class extends F3 {
    constructor(e) {
      super(e, {
        isRenderable: e.renderForms,
      });
    }
    render() {
      this.container.classList.add(`choiceWidgetAnnotation`);
      let e = this.annotationStorage,
        t = this.data.id,
        n = e.getValue(t, {
          value: this.data.fieldValue,
        }),
        r = document.createElement(`select`);
      (j3.add(r),
        r.setAttribute(`data-element-id`, t),
        (r.disabled = this.data.readOnly),
        this._setRequired(r, this.data.required),
        (r.name = this.data.fieldName),
        (r.tabIndex = 0));
      let i = this.data.combo && this.data.options.length > 0;
      (this.data.combo ||
        ((r.size = this.data.options.length), this.data.multiSelect && (r.multiple = !0)),
        r.addEventListener(`resetform`, (e) => {
          let t = this.data.defaultFieldValue;
          for (let e of r.options) e.selected = e.value === t;
        }));
      let a = (e, t) => {
        let n = t.replaceAll(` `, `\xA0`);
        ((e.textContent = n), n !== t && e.setAttribute(`display-value`, t));
      };
      for (let e of this.data.options) {
        let t = document.createElement(`option`);
        (a(t, e.displayValue),
          (t.value = e.exportValue),
          n.value.includes(e.exportValue) && (t.setAttribute(`selected`, !0), (i = !1)),
          r.append(t));
      }
      let o = null;
      if (i) {
        let e = document.createElement(`option`);
        ((e.value = ` `),
          e.setAttribute(`hidden`, !0),
          e.setAttribute(`selected`, !0),
          r.prepend(e),
          (o = () => {
            (e.remove(), r.removeEventListener(`input`, o), (o = null));
          }),
          r.addEventListener(`input`, o));
      }
      let s = (e) => {
          let t = e ? `value` : `textContent`,
            { options: n, multiple: i } = r;
          return i
            ? Array.prototype.filter.call(n, (e) => e.selected).map((e) => e[t])
            : n.selectedIndex === -1
              ? null
              : n[n.selectedIndex][t];
        },
        c = s(!1),
        l = (e) => {
          let t = e.target.options;
          return Array.prototype.map.call(t, (e) => ({
            displayValue: e.getAttribute(`display-value`) || e.textContent,
            exportValue: e.value,
          }));
        };
      return (
        this.enableScripting && this.hasJSActions
          ? (r.addEventListener(`updatefromsandbox`, (n) => {
              this._dispatchEventFromSandbox(
                {
                  value(n) {
                    o?.();
                    let i = n.detail.value,
                      a = new Set(Array.isArray(i) ? i : [i]);
                    for (let e of r.options) e.selected = a.has(e.value);
                    (e.setValue(t, {
                      value: s(!0),
                    }),
                      (c = s(!1)));
                  },
                  multipleSelection(e) {
                    r.multiple = !0;
                  },
                  remove(n) {
                    let i = r.options,
                      a = n.detail.remove;
                    ((i[a].selected = !1),
                      r.remove(a),
                      i.length > 0 &&
                        Array.prototype.findIndex.call(i, (e) => e.selected) === -1 &&
                        (i[0].selected = !0),
                      e.setValue(t, {
                        value: s(!0),
                        items: l(n),
                      }),
                      (c = s(!1)));
                  },
                  clear(n) {
                    for (; r.length !== 0;) r.remove(0);
                    (e.setValue(t, {
                      value: null,
                      items: [],
                    }),
                      (c = s(!1)));
                  },
                  insert(n) {
                    let { index: i, displayValue: o, exportValue: u } = n.detail.insert,
                      d = r.children[i],
                      f = document.createElement(`option`);
                    (a(f, o),
                      (f.value = u),
                      d ? d.before(f) : r.append(f),
                      e.setValue(t, {
                        value: s(!0),
                        items: l(n),
                      }),
                      (c = s(!1)));
                  },
                  items(n) {
                    let { items: i } = n.detail;
                    for (; r.length !== 0;) r.remove(0);
                    for (let e of i) {
                      let { displayValue: t, exportValue: n } = e,
                        i = document.createElement(`option`);
                      (a(i, t), (i.value = n), r.append(i));
                    }
                    (r.options.length > 0 && (r.options[0].selected = !0),
                      e.setValue(t, {
                        value: s(!0),
                        items: l(n),
                      }),
                      (c = s(!1)));
                  },
                  indices(n) {
                    let r = new Set(n.detail.indices);
                    for (let e of n.target.options) e.selected = r.has(e.index);
                    (e.setValue(t, {
                      value: s(!0),
                    }),
                      (c = s(!1)));
                  },
                  editable(e) {
                    e.target.disabled = !e.detail.editable;
                  },
                },
                n,
              );
            }),
            r.addEventListener(`input`, (n) => {
              let r = s(!0),
                i = s(!1);
              (e.setValue(t, {
                value: r,
              }),
                n.preventDefault(),
                this.linkService.eventBus?.dispatch(`dispatcheventinsandbox`, {
                  source: this,
                  detail: {
                    id: t,
                    name: `Keystroke`,
                    value: c,
                    change: i,
                    changeEx: r,
                    willCommit: !1,
                    commitKey: 1,
                    keyDown: !1,
                  },
                }));
            }),
            this._setEventListeners(
              r,
              null,
              [
                [`focus`, `Focus`],
                [`blur`, `Blur`],
                [`mousedown`, `Mouse Down`],
                [`mouseenter`, `Mouse Enter`],
                [`mouseleave`, `Mouse Exit`],
                [`mouseup`, `Mouse Up`],
                [`input`, `Action`],
                [`input`, `Validate`],
              ],
              (e) => e.target.value,
            ))
          : r.addEventListener(`input`, function (n) {
              e.setValue(t, {
                value: s(!0),
              });
            }),
        this.data.combo && this._setTextStyle(r),
        this._setBackgroundColor(r),
        this._setDefaultPropertiesFromJS(r),
        this.container.append(r),
        this.container
      );
    }
  },
  L3 = class extends N3 {
    constructor(e) {
      let { data: t, elements: n, parent: r } = e,
        i = !!r._commentManager;
      if (
        (super(e, {
          isRenderable: !i && N3._hasPopupData(t),
        }),
        (this.elements = n),
        i && N3._hasPopupData(t))
      ) {
        let e = (this.popup = this.#e());
        for (let t of n) t.popup = e;
      } else this.popup = null;
    }
    #e() {
      return new Ace({
        container: this.container,
        color: this.data.color,
        titleObj: this.data.titleObj,
        modificationDate: this.data.modificationDate || this.data.creationDate,
        contentsObj: this.data.contentsObj,
        richText: this.data.richText,
        rect: this.data.rect,
        parentRect: this.data.parentRect || null,
        parent: this.parent,
        elements: this.elements,
        open: this.data.open,
        commentManager: this.parent._commentManager,
      });
    }
    render() {
      let { container: e } = this;
      (e.classList.add(`popupAnnotation`), (e.role = `comment`));
      let t = (this.popup = this.#e()),
        n = [];
      for (let e of this.elements)
        ((e.popup = t),
          (e.container.ariaHasPopup = `dialog`),
          n.push(e.data.id),
          e.addHighlightArea());
      return (
        this.container.setAttribute(`aria-controls`, n.map((e) => `${t2}${e}`).join(`,`)),
        this.container
      );
    }
  },
  Ace = class {
    #e = null;
    #t = this.#P.bind(this);
    #n = this.#R.bind(this);
    #r = this.#L.bind(this);
    #i = this.#I.bind(this);
    #a = null;
    #o = null;
    #s = null;
    #c = null;
    #l = null;
    #u = null;
    #d = null;
    #f = !1;
    #p = null;
    #m = null;
    #h = null;
    #g = null;
    #_ = null;
    #v = null;
    #y = null;
    #b = null;
    #x = null;
    #S = null;
    #C = !1;
    #w = null;
    #T = null;
    constructor({
      container: e,
      color: t,
      elements: n,
      titleObj: r,
      modificationDate: i,
      contentsObj: a,
      richText: o,
      parent: s,
      rect: c,
      parentRect: l,
      open: u,
      commentManager: d = null,
    }) {
      ((this.#o = e),
        (this.#x = r),
        (this.#s = a),
        (this.#b = o),
        (this.#u = s),
        (this.#a = t),
        (this.#y = c),
        (this.#d = l),
        (this.#l = n),
        (this.#e = d),
        (this.#w = n[0]),
        (this.#c = C2.toDateObject(i)),
        (this.trigger = n.flatMap((e) => e.getElementsToTriggerPopup())),
        d || (this.#E(), (this.#o.hidden = !0), u && this.#I()));
    }
    #E() {
      if (this.#m) return;
      this.#m = new AbortController();
      let { signal: e } = this.#m;
      for (let t of this.trigger)
        (t.addEventListener(`click`, this.#i, {
          signal: e,
        }),
          t.addEventListener(`pointerenter`, this.#r, {
            signal: e,
          }),
          t.addEventListener(`pointerleave`, this.#n, {
            signal: e,
          }),
          t.classList.add(`popupTriggerArea`));
      for (let t of this.#l)
        t.container?.addEventListener(`keydown`, this.#t, {
          signal: e,
        });
    }
    #D() {
      let e = this.#l.find((e) => e.hasCommentButton);
      e && (this.#_ = e._normalizePoint(e.commentButtonPosition));
    }
    renderCommentButton() {
      if (this.#g) {
        this.#g.parentNode || this.#w.container.after(this.#g);
        return;
      }
      if ((this.#_ || this.#D(), !this.#_)) return;
      let { signal: e } = (this.#m = new AbortController()),
        t = this.#w.hasOwnCommentButton,
        n = () => {
          this.#e.toggleCommentPopup(this, !0, void 0, !t);
        },
        r = () => {
          this.#e.toggleCommentPopup(this, !1, !0, !t);
        },
        i = () => {
          this.#e.toggleCommentPopup(this, !1, !1);
        };
      if (t) {
        this.#g = this.#w.container;
        for (let t of this.trigger)
          ((t.ariaHasPopup = `dialog`),
            (t.ariaControls = `commentPopup`),
            t.addEventListener(`keydown`, this.#t, {
              signal: e,
            }),
            t.addEventListener(`click`, n, {
              signal: e,
            }),
            t.addEventListener(`pointerenter`, r, {
              signal: e,
            }),
            t.addEventListener(`pointerleave`, i, {
              signal: e,
            }),
            t.classList.add(`popupTriggerArea`));
      } else {
        let t = (this.#g = document.createElement(`button`));
        t.className = `annotationCommentButton`;
        let a = this.#w.container;
        ((t.style.zIndex = parseInt(a.style.zIndex, 10) + 1),
          (t.tabIndex = 0),
          (t.ariaHasPopup = `dialog`),
          (t.ariaControls = `commentPopup`),
          t.setAttribute(`data-l10n-id`, `pdfjs-show-comment-button`),
          this.#k(),
          this.#O(),
          t.addEventListener(`keydown`, this.#t, {
            signal: e,
          }),
          t.addEventListener(`click`, n, {
            signal: e,
          }),
          t.addEventListener(`pointerenter`, r, {
            signal: e,
          }),
          t.addEventListener(`pointerleave`, i, {
            signal: e,
          }),
          a.after(t));
      }
    }
    #O() {
      if (this.#w.extraPopupElement && !this.#w.editor) return;
      this.#g || this.renderCommentButton();
      let [e, t] = this.#_,
        { style: n } = this.#g;
      ((n.left = `calc(${e}%)`), (n.top = `calc(${t}% - var(--comment-button-dim))`));
    }
    #k() {
      this.#w.extraPopupElement ||
        (this.#g || this.renderCommentButton(),
        (this.#g.style.backgroundColor = this.commentButtonColor || ``));
    }
    get commentButtonColor() {
      let { color: e, opacity: t } = this.#w.commentData;
      return e ? this.#u._commentManager.makeCommentColor(e, t) : null;
    }
    focusCommentButton() {
      setTimeout(() => {
        this.#g?.focus();
      }, 0);
    }
    getData() {
      let {
        richText: e,
        color: t,
        opacity: n,
        creationDate: r,
        modificationDate: i,
      } = this.#w.commentData;
      return {
        contentsObj: {
          str: this.comment,
        },
        richText: e,
        color: t,
        opacity: n,
        creationDate: r,
        modificationDate: i,
      };
    }
    get elementBeforePopup() {
      return this.#g;
    }
    get comment() {
      return ((this.#T ||= this.#w.commentText), this.#T);
    }
    set comment(e) {
      e !== this.comment && (this.#w.commentText = this.#T = e);
    }
    focus() {
      this.#w.container?.focus();
    }
    get parentBoundingClientRect() {
      return this.#w.layer.getBoundingClientRect();
    }
    setCommentButtonStates({ selected: e, hasPopup: t }) {
      this.#g && (this.#g.classList.toggle(`selected`, e), (this.#g.ariaExpanded = t));
    }
    setSelectedCommentButton(e) {
      this.#g.classList.toggle(`selected`, e);
    }
    get commentPopupPosition() {
      if (this.#v) return this.#v;
      let { x: e, y: t, height: n } = this.#g.getBoundingClientRect(),
        { x: r, y: i, width: a, height: o } = this.#w.layer.getBoundingClientRect();
      return [(e - r) / a, (t + n - i) / o];
    }
    set commentPopupPosition(e) {
      this.#v = e;
    }
    hasDefaultPopupPosition() {
      return this.#v === null;
    }
    get commentButtonPosition() {
      return this.#_;
    }
    get commentButtonWidth() {
      return this.#g.getBoundingClientRect().width / this.parentBoundingClientRect.width;
    }
    editComment(e) {
      let [t, n] = this.#v || this.commentButtonPosition.map((e) => e / 100),
        r = this.parentBoundingClientRect,
        { x: i, y: a, width: o, height: s } = r;
      this.#e.showDialog(null, this, i + t * o, a + n * s, {
        ...e,
        parentDimensions: r,
      });
    }
    render() {
      if (this.#p) return;
      let e = (this.#p = document.createElement(`div`));
      if (((e.className = `popup`), this.#a)) {
        let t = (e.style.outlineColor = Y0.makeHexColor(...this.#a));
        e.style.backgroundColor = `color-mix(in srgb, ${t} 30%, white)`;
      }
      let t = document.createElement(`span`);
      if (((t.className = `header`), this.#x?.str)) {
        let e = document.createElement(`span`);
        ((e.className = `title`), t.append(e), ({ dir: e.dir, str: e.textContent } = this.#x));
      }
      if ((e.append(t), this.#c)) {
        let e = document.createElement(`time`);
        ((e.className = `popupDate`),
          e.setAttribute(`data-l10n-id`, `pdfjs-annotation-date-time-string`),
          e.setAttribute(
            `data-l10n-args`,
            JSON.stringify({
              dateObj: this.#c.valueOf(),
            }),
          ),
          (e.dateTime = this.#c.toISOString()),
          t.append(e));
      }
      (H2(
        {
          html: this.#A || this.#s.str,
          dir: this.#s?.dir,
          className: `popupContent`,
        },
        e,
      ),
        this.#o.append(e));
    }
    get #A() {
      let e = this.#b,
        t = this.#s;
      return (e?.str && (!t?.str || t.str === e.str) && this.#b.html) || null;
    }
    get #j() {
      return this.#A?.attributes?.style?.fontSize || 0;
    }
    get #M() {
      return this.#A?.attributes?.style?.color || null;
    }
    #N(e) {
      let t = [],
        n = {
          str: e,
          html: {
            name: `div`,
            attributes: {
              dir: `auto`,
            },
            children: [
              {
                name: `p`,
                children: t,
              },
            ],
          },
        },
        r = {
          style: {
            color: this.#M,
            fontSize: this.#j ? `calc(${this.#j}px * var(--total-scale-factor))` : ``,
          },
        };
      for (let n of e.split(`
`))
        t.push({
          name: `span`,
          value: n,
          attributes: r,
        });
      return n;
    }
    #P(e) {
      e.altKey ||
        e.shiftKey ||
        e.ctrlKey ||
        e.metaKey ||
        ((e.key === `Enter` || (e.key === `Escape` && this.#f)) && this.#I());
    }
    updateEdited({ rect: e, popup: t, deleted: n }) {
      if (this.#e) {
        (n
          ? (this.remove(), (this.#T = null))
          : t && (t.deleted ? this.remove() : (this.#k(), (this.#T = t.text))),
          e && ((this.#_ = null), this.#D(), this.#O()));
        return;
      }
      if (n || t?.deleted) {
        this.remove();
        return;
      }
      (this.#E(),
        (this.#S ||= {
          contentsObj: this.#s,
          richText: this.#b,
        }),
        e && (this.#h = null),
        t &&
          t.text &&
          ((this.#b = this.#N(t.text)), (this.#c = C2.toDateObject(t.date)), (this.#s = null)),
        this.#p?.remove(),
        (this.#p = null));
    }
    resetEdited() {
      this.#S &&
        (({ contentsObj: this.#s, richText: this.#b } = this.#S),
        (this.#S = null),
        this.#p?.remove(),
        (this.#p = null),
        (this.#h = null));
    }
    remove() {
      if (
        (this.#m?.abort(),
        (this.#m = null),
        this.#p?.remove(),
        (this.#p = null),
        (this.#C = !1),
        (this.#f = !1),
        this.#g?.remove(),
        (this.#g = null),
        this.trigger)
      )
        for (let e of this.trigger) e.classList.remove(`popupTriggerArea`);
    }
    #F() {
      if (this.#h !== null) return;
      let {
          page: { view: e },
          viewport: {
            rawDims: { pageWidth: t, pageHeight: n, pageX: r, pageY: i },
          },
        } = this.#u,
        a = !!this.#d,
        o = a ? this.#d : this.#y;
      for (let e of this.#l)
        if (!o || Y0.intersect(e.data.rect, o) !== null) {
          ((o = e.data.rect), (a = !0));
          break;
        }
      let s = Y0.normalizeRect([o[0], e[3] - o[1] + e[1], o[2], e[3] - o[3] + e[1]]),
        c = a ? o[2] - o[0] + 5 : 0,
        l = s[0] + c,
        u = s[1];
      this.#h = [(100 * (l - r)) / t, (100 * (u - i)) / n];
      let { style: d } = this.#o;
      ((d.left = `${this.#h[0]}%`), (d.top = `${this.#h[1]}%`));
    }
    #I() {
      if (this.#e) {
        this.#e.toggleCommentPopup(this, !1);
        return;
      }
      ((this.#f = !this.#f),
        this.#f
          ? (this.#L(),
            this.#o.addEventListener(`click`, this.#i),
            this.#o.addEventListener(`keydown`, this.#t))
          : (this.#R(),
            this.#o.removeEventListener(`click`, this.#i),
            this.#o.removeEventListener(`keydown`, this.#t)));
    }
    #L() {
      (this.#p || this.render(),
        this.isVisible
          ? this.#f && this.#o.classList.add(`focused`)
          : (this.#F(),
            (this.#o.hidden = !1),
            (this.#o.style.zIndex = parseInt(this.#o.style.zIndex, 10) + 1e3)));
    }
    #R() {
      (this.#o.classList.remove(`focused`),
        !(this.#f || !this.isVisible) &&
          ((this.#o.hidden = !0),
          (this.#o.style.zIndex = parseInt(this.#o.style.zIndex, 10) - 1e3)));
    }
    forceHide() {
      ((this.#C = this.isVisible), this.#C && (this.#o.hidden = !0));
    }
    maybeShow() {
      this.#e ||
        (this.#E(), this.#C && (this.#p || this.#L(), (this.#C = !1), (this.#o.hidden = !1)));
    }
    get isVisible() {
      return this.#e ? !1 : this.#o.hidden === !1;
    }
  },
  R3 = class extends N3 {
    constructor(e) {
      (super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      }),
        (this.textContent = e.data.textContent),
        (this.textPosition = e.data.textPosition),
        (this.annotationEditorType = h0.FREETEXT));
    }
    render() {
      if ((this.container.classList.add(`freeTextAnnotation`), this.textContent)) {
        let e = (this.contentElement = document.createElement(`div`));
        (e.classList.add(`annotationTextContent`), e.setAttribute(`role`, `comment`));
        for (let t of this.textContent) {
          let n = document.createElement(`span`);
          ((n.textContent = t), e.append(n));
        }
        this.container.append(e);
      }
      return (
        !this.data.popupRef &&
          this.hasPopupData &&
          ((this.hasOwnCommentButton = !0), this._createPopup()),
        this._editOnDoubleClick(),
        this.container
      );
    }
  },
  jce = class extends N3 {
    #e = null;
    constructor(e) {
      super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      });
    }
    render() {
      this.container.classList.add(`lineAnnotation`);
      let { data: e, width: t, height: n } = this,
        r = this.svgFactory.create(t, n, !0),
        i = (this.#e = this.svgFactory.createElement(`svg:line`));
      return (
        i.setAttribute(`x1`, e.rect[2] - e.lineCoordinates[0]),
        i.setAttribute(`y1`, e.rect[3] - e.lineCoordinates[1]),
        i.setAttribute(`x2`, e.rect[2] - e.lineCoordinates[2]),
        i.setAttribute(`y2`, e.rect[3] - e.lineCoordinates[3]),
        i.setAttribute(`stroke-width`, e.borderStyle.width || 1),
        i.setAttribute(`stroke`, `transparent`),
        i.setAttribute(`fill`, `transparent`),
        r.append(i),
        this.container.append(r),
        !e.popupRef && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container
      );
    }
    getElementsToTriggerPopup() {
      return this.#e;
    }
    addHighlightArea() {
      this.container.classList.add(`highlightArea`);
    }
  },
  Mce = class extends N3 {
    #e = null;
    constructor(e) {
      super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      });
    }
    render() {
      this.container.classList.add(`squareAnnotation`);
      let { data: e, width: t, height: n } = this,
        r = this.svgFactory.create(t, n, !0),
        i = e.borderStyle.width,
        a = (this.#e = this.svgFactory.createElement(`svg:rect`));
      return (
        a.setAttribute(`x`, i / 2),
        a.setAttribute(`y`, i / 2),
        a.setAttribute(`width`, t - i),
        a.setAttribute(`height`, n - i),
        a.setAttribute(`stroke-width`, i || 1),
        a.setAttribute(`stroke`, `transparent`),
        a.setAttribute(`fill`, `transparent`),
        r.append(a),
        this.container.append(r),
        !e.popupRef && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container
      );
    }
    getElementsToTriggerPopup() {
      return this.#e;
    }
    addHighlightArea() {
      this.container.classList.add(`highlightArea`);
    }
  },
  Nce = class extends N3 {
    #e = null;
    constructor(e) {
      super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      });
    }
    render() {
      this.container.classList.add(`circleAnnotation`);
      let { data: e, width: t, height: n } = this,
        r = this.svgFactory.create(t, n, !0),
        i = e.borderStyle.width,
        a = (this.#e = this.svgFactory.createElement(`svg:ellipse`));
      return (
        a.setAttribute(`cx`, t / 2),
        a.setAttribute(`cy`, n / 2),
        a.setAttribute(`rx`, t / 2 - i / 2),
        a.setAttribute(`ry`, n / 2 - i / 2),
        a.setAttribute(`stroke-width`, i || 1),
        a.setAttribute(`stroke`, `transparent`),
        a.setAttribute(`fill`, `transparent`),
        r.append(a),
        this.container.append(r),
        !e.popupRef && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container
      );
    }
    getElementsToTriggerPopup() {
      return this.#e;
    }
    addHighlightArea() {
      this.container.classList.add(`highlightArea`);
    }
  },
  z3 = class extends N3 {
    #e = null;
    constructor(e) {
      (super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      }),
        (this.containerClassName = `polylineAnnotation`),
        (this.svgElementName = `svg:polyline`));
    }
    render() {
      this.container.classList.add(this.containerClassName);
      let {
        data: { rect: e, vertices: t, borderStyle: n, popupRef: r },
        width: i,
        height: a,
      } = this;
      if (!t) return this.container;
      let o = this.svgFactory.create(i, a, !0),
        s = [];
      for (let n = 0, r = t.length; n < r; n += 2) {
        let r = t[n] - e[0],
          i = e[3] - t[n + 1];
        s.push(`${r},${i}`);
      }
      s = s.join(` `);
      let c = (this.#e = this.svgFactory.createElement(this.svgElementName));
      return (
        c.setAttribute(`points`, s),
        c.setAttribute(`stroke-width`, n.width || 1),
        c.setAttribute(`stroke`, `transparent`),
        c.setAttribute(`fill`, `transparent`),
        o.append(c),
        this.container.append(o),
        !r && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container
      );
    }
    getElementsToTriggerPopup() {
      return this.#e;
    }
    addHighlightArea() {
      this.container.classList.add(`highlightArea`);
    }
  },
  Pce = class extends z3 {
    constructor(e) {
      (super(e),
        (this.containerClassName = `polygonAnnotation`),
        (this.svgElementName = `svg:polygon`));
    }
  },
  Fce = class extends N3 {
    constructor(e) {
      super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      });
    }
    render() {
      return (
        this.container.classList.add(`caretAnnotation`),
        !this.data.popupRef &&
          this.hasPopupData &&
          ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container
      );
    }
  },
  B3 = class extends N3 {
    #e = null;
    #t = [];
    constructor(e) {
      (super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      }),
        (this.containerClassName = `inkAnnotation`),
        (this.svgElementName = `svg:polyline`),
        (this.annotationEditorType = this.data.it === `InkHighlight` ? h0.HIGHLIGHT : h0.INK));
    }
    #n(e, t) {
      switch (e) {
        case 90:
          return {
            transform: `rotate(90) translate(${-t[0]},${t[1]}) scale(1,-1)`,
            width: t[3] - t[1],
            height: t[2] - t[0],
          };
        case 180:
          return {
            transform: `rotate(180) translate(${-t[2]},${t[1]}) scale(1,-1)`,
            width: t[2] - t[0],
            height: t[3] - t[1],
          };
        case 270:
          return {
            transform: `rotate(270) translate(${-t[2]},${t[3]}) scale(1,-1)`,
            width: t[3] - t[1],
            height: t[2] - t[0],
          };
        default:
          return {
            transform: `translate(${-t[0]},${t[3]}) scale(1,-1)`,
            width: t[2] - t[0],
            height: t[3] - t[1],
          };
      }
    }
    render() {
      this.container.classList.add(this.containerClassName);
      let {
          data: { rect: e, rotation: t, inkLists: n, borderStyle: r, popupRef: i },
        } = this,
        { transform: a, width: o, height: s } = this.#n(t, e),
        c = this.svgFactory.create(o, s, !0),
        l = (this.#e = this.svgFactory.createElement(`svg:g`));
      (c.append(l),
        l.setAttribute(`stroke-width`, r.width || 1),
        l.setAttribute(`stroke-linecap`, `round`),
        l.setAttribute(`stroke-linejoin`, `round`),
        l.setAttribute(`stroke-miterlimit`, 10),
        l.setAttribute(`stroke`, `transparent`),
        l.setAttribute(`fill`, `transparent`),
        l.setAttribute(`transform`, a));
      for (let e = 0, t = n.length; e < t; e++) {
        let t = this.svgFactory.createElement(this.svgElementName);
        (this.#t.push(t), t.setAttribute(`points`, n[e].join(`,`)), l.append(t));
      }
      return (
        !i && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container.append(c),
        this._editOnDoubleClick(),
        this.container
      );
    }
    updateEdited(e) {
      super.updateEdited(e);
      let { thickness: t, points: n, rect: r } = e,
        i = this.#e;
      if ((t >= 0 && i.setAttribute(`stroke-width`, t || 1), n))
        for (let e = 0, t = this.#t.length; e < t; e++)
          this.#t[e].setAttribute(`points`, n[e].join(`,`));
      if (r) {
        let { transform: e, width: t, height: n } = this.#n(this.data.rotation, r);
        (i.parentElement.setAttribute(`viewBox`, `0 0 ${t} ${n}`), i.setAttribute(`transform`, e));
      }
    }
    getElementsToTriggerPopup() {
      return this.#t;
    }
    addHighlightArea() {
      this.container.classList.add(`highlightArea`);
    }
  },
  V3 = class extends N3 {
    constructor(e) {
      (super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
        createQuadrilaterals: !0,
      }),
        (this.annotationEditorType = h0.HIGHLIGHT));
    }
    render() {
      let {
        data: { overlaidText: e, popupRef: t },
      } = this;
      if (
        (!t && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container.classList.add(`highlightAnnotation`),
        this._editOnDoubleClick(),
        e)
      ) {
        let t = document.createElement(`mark`);
        (t.classList.add(`overlaidText`), (t.textContent = e), this.container.append(t));
      }
      return this.container;
    }
  },
  Ice = class extends N3 {
    constructor(e) {
      super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
        createQuadrilaterals: !0,
      });
    }
    render() {
      let {
        data: { overlaidText: e, popupRef: t },
      } = this;
      if (
        (!t && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container.classList.add(`underlineAnnotation`),
        e)
      ) {
        let t = document.createElement(`u`);
        (t.classList.add(`overlaidText`), (t.textContent = e), this.container.append(t));
      }
      return this.container;
    }
  },
  Lce = class extends N3 {
    constructor(e) {
      super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
        createQuadrilaterals: !0,
      });
    }
    render() {
      let {
        data: { overlaidText: e, popupRef: t },
      } = this;
      if (
        (!t && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container.classList.add(`squigglyAnnotation`),
        e)
      ) {
        let t = document.createElement(`u`);
        (t.classList.add(`overlaidText`), (t.textContent = e), this.container.append(t));
      }
      return this.container;
    }
  },
  Rce = class extends N3 {
    constructor(e) {
      super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
        createQuadrilaterals: !0,
      });
    }
    render() {
      let {
        data: { overlaidText: e, popupRef: t },
      } = this;
      if (
        (!t && this.hasPopupData && ((this.hasOwnCommentButton = !0), this._createPopup()),
        this.container.classList.add(`strikeoutAnnotation`),
        e)
      ) {
        let t = document.createElement(`s`);
        (t.classList.add(`overlaidText`), (t.textContent = e), this.container.append(t));
      }
      return this.container;
    }
  },
  H3 = class extends N3 {
    constructor(e) {
      (super(e, {
        isRenderable: !0,
        ignoreBorder: !0,
      }),
        (this.annotationEditorType = h0.STAMP));
    }
    render() {
      return (
        this.container.classList.add(`stampAnnotation`),
        this.container.setAttribute(`role`, `img`),
        !this.data.popupRef &&
          this.hasPopupData &&
          ((this.hasOwnCommentButton = !0), this._createPopup()),
        this._editOnDoubleClick(),
        this.container
      );
    }
  },
  zce = class extends N3 {
    #e = null;
    constructor(e) {
      super(e, {
        isRenderable: !0,
      });
      let { file: t } = this.data;
      ((this.filename = t.filename),
        (this.content = t.content),
        this.linkService.eventBus?.dispatch(`fileattachmentannotation`, {
          source: this,
          ...t,
        }));
    }
    render() {
      this.container.classList.add(`fileAttachmentAnnotation`);
      let { container: e, data: t } = this,
        n;
      (t.hasAppearance || t.fillAlpha === 0
        ? (n = document.createElement(`div`))
        : ((n = document.createElement(`img`)),
          (n.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(t.name) ? `paperclip` : `pushpin`}.svg`),
          t.fillAlpha &&
            t.fillAlpha < 1 &&
            (n.style = `filter: opacity(${Math.round(t.fillAlpha * 100)}%);`)),
        n.addEventListener(`dblclick`, this.#t.bind(this)),
        (this.#e = n));
      let { isMac: r } = J0.platform;
      return (
        e.addEventListener(`keydown`, (e) => {
          e.key === `Enter` && (r ? e.metaKey : e.ctrlKey) && this.#t();
        }),
        !t.popupRef && this.hasPopupData
          ? ((this.hasOwnCommentButton = !0), this._createPopup())
          : n.classList.add(`popupTriggerArea`),
        e.append(n),
        e
      );
    }
    getElementsToTriggerPopup() {
      return this.#e;
    }
    addHighlightArea() {
      this.container.classList.add(`highlightArea`);
    }
    #t() {
      this.downloadManager?.openOrDownloadData(this.content, this.filename);
    }
  },
  U3 = class e {
    #e = null;
    #t = null;
    #n = null;
    #r = new Map();
    #i = null;
    #a = null;
    #o = [];
    #s = !1;
    zIndex = 0;
    constructor({
      div: e,
      accessibilityManager: t,
      annotationCanvasMap: n,
      annotationEditorUIManager: r,
      page: i,
      viewport: a,
      structTreeLayer: o,
      commentManager: s,
      linkService: c,
      annotationStorage: l,
    }) {
      ((this.div = e),
        (this.#e = t),
        (this.#t = n),
        (this.#i = o || null),
        (this.#a = c || null),
        (this.#n = l || new c4()),
        (this.page = i),
        (this.viewport = a),
        (this._annotationEditorUIManager = r),
        (this._commentManager = s || null));
    }
    hasEditableAnnotations() {
      return this.#r.size > 0;
    }
    async render(e) {
      let { annotations: t } = e,
        n = this.div;
      A2(n, this.viewport);
      let r = new Map(),
        i = [],
        a = {
          data: null,
          layer: n,
          linkService: this.#a,
          downloadManager: e.downloadManager,
          imageResourcesPath: e.imageResourcesPath || ``,
          renderForms: e.renderForms !== !1,
          svgFactory: new A3(),
          annotationStorage: this.#n,
          enableComment: e.enableComment === !0,
          enableScripting: e.enableScripting === !0,
          hasJSActions: e.hasJSActions,
          fieldObjects: e.fieldObjects,
          parent: this,
          elements: null,
        };
      for (let e of t) {
        if (e.noHTML) continue;
        let t = e.annotationType === b0.POPUP;
        if (t) {
          let t = r.get(e.id);
          if (!t) continue;
          if (!this._commentManager) {
            i.push(e);
            continue;
          }
          a.elements = t;
        } else if (e.rect[2] === e.rect[0] || e.rect[3] === e.rect[1]) continue;
        a.data = e;
        let n = M3.create(a);
        if (!n.isRenderable) continue;
        t || (this.#o.push(n), e.popupRef && r.getOrInsertComputed(e.popupRef, r2).push(n));
        let o = n.render();
        (e.hidden && (o.style.visibility = `hidden`),
          n._isEditable &&
            (this.#r.set(n.data.id, n),
            this._annotationEditorUIManager?.renderAnnotationElement(n)));
      }
      await this.#c();
      for (let e of i) {
        let t = (a.elements = r.get(e.id));
        a.data = e;
        let n = M3.create(a);
        if (!n.isRenderable) continue;
        let i = n.render();
        ((n.contentElement.id = `${t2}${e.id}`),
          e.hidden && (i.style.visibility = `hidden`),
          t.at(-1).container.after(i));
      }
      this.#l();
    }
    async #c() {
      if (this.#o.length === 0) return;
      this.div.replaceChildren();
      let e = [];
      if (!this.#s) {
        this.#s = !0;
        for (let {
          contentElement: t,
          data: { id: n },
        } of this.#o) {
          let r = (t.id = `${t2}${n}`);
          e.push(
            this.#i?.getAriaAttributes(r).then((e) => {
              if (e) for (let [n, r] of e) t.setAttribute(n, r);
            }),
          );
        }
      }
      this.#o.sort(
        (
          {
            data: {
              rect: [e, t, n, r],
            },
          },
          {
            data: {
              rect: [i, a, o, s],
            },
          },
        ) => {
          if (e === n && t === r) return 1;
          if (i === o && a === s) return -1;
          let c = r,
            l = t,
            u = (t + r) / 2,
            d = s,
            f = a,
            p = (a + s) / 2;
          return u >= d && p <= l ? -1 : p >= c && u <= f ? 1 : (e + n) / 2 - (i + o) / 2;
        },
      );
      let t = document.createDocumentFragment();
      for (let e of this.#o)
        (t.append(e.container),
          this._commentManager
            ? (e.extraPopupElement?.popup || e.popup)?.renderCommentButton()
            : e.extraPopupElement && t.append(e.extraPopupElement.render()));
      if ((this.div.append(t), await Promise.all(e), this.#e))
        for (let e of this.#o) this.#e.addPointerInTextLayer(e.contentElement, !1);
    }
    async addLinkAnnotations(t) {
      let n = {
        data: null,
        layer: this.div,
        linkService: this.#a,
        svgFactory: new A3(),
        parent: this,
      };
      for (let r of t) {
        ((r.borderStyle ||= e._defaultBorderStyle), (n.data = r));
        let t = M3.create(n);
        t.isRenderable && (t.render(), (t.contentElement.id = `${t2}${r.id}`), this.#o.push(t));
      }
      await this.#c();
    }
    update({ viewport: e }) {
      let t = this.div;
      ((this.viewport = e),
        A2(t, {
          rotation: e.rotation,
        }),
        this.#l(),
        (t.hidden = !1));
    }
    #l() {
      if (!this.#t) return;
      let e = this.div;
      for (let [t, n] of this.#t) {
        let r = e.querySelector(`[data-annotation-id="${t}"]`);
        if (!r) continue;
        n.className = `annotationContent`;
        let { firstChild: i } = r;
        i
          ? i.nodeName === `CANVAS`
            ? i.replaceWith(n)
            : i.classList.contains(`annotationContent`)
              ? i.after(n)
              : i.before(n)
          : r.append(n);
        let a = this.#r.get(t);
        a &&
          (a._hasNoCanvas
            ? (this._annotationEditorUIManager?.setMissingCanvas(t, r.id, n), (a._hasNoCanvas = !1))
            : (a.canvas = n));
      }
      this.#t.clear();
    }
    getEditableAnnotations() {
      return this.#r.values();
    }
    getEditableAnnotation(e) {
      return this.#r.get(e);
    }
    addFakeAnnotation(e) {
      let { div: t } = this,
        { id: n, rotation: r } = e,
        i = new Cce({
          data: {
            id: n,
            rect: e.getPDFRect(),
            rotation: r,
          },
          editor: e,
          layer: t,
          parent: this,
          enableComment: !!this._commentManager,
          linkService: this.#a,
          annotationStorage: this.#n,
        });
      return (
        i.render(),
        (i.contentElement.id = `${t2}${n}`),
        i.createOrUpdatePopup(),
        this.#o.push(i),
        i
      );
    }
    removeAnnotation(e) {
      let t = this.#o.findIndex((t) => t.data.id === e);
      if (t < 0) return;
      let [n] = this.#o.splice(t, 1);
      this.#e?.removePointerInTextLayer(n.contentElement);
    }
    updateFakeAnnotations(e) {
      if (e.length !== 0) {
        for (let t of e) t.updateFakeAnnotationElement(this);
        this.#c();
      }
    }
    togglePointerEvents(e = !1) {
      this.div.classList.toggle(`disabled`, !e);
    }
    static get _defaultBorderStyle() {
      return L0(
        this,
        `_defaultBorderStyle`,
        Object.freeze({
          width: 1,
          rawWidth: 1,
          style: x0.SOLID,
          dashArray: [3],
          horizontalCornerRadius: 0,
          verticalCornerRadius: 0,
        }),
      );
    }
  },
  W3 = /\r\n?|\n/g,
  Bce = class e extends n4 {
    #e = ``;
    #t = `${this.id}-editor`;
    #n = null;
    #r;
    _colorPicker = null;
    static _freeTextDefaultContent = ``;
    static _internalPadding = 0;
    static _defaultColor = null;
    static _defaultFontSize = 10;
    static get _keyboardManager() {
      let t = e.prototype,
        n = (e) => e.isEmpty(),
        r = Q2.TRANSLATE_SMALL,
        i = Q2.TRANSLATE_BIG;
      return L0(
        this,
        `_keyboardManager`,
        new Z2([
          [
            [`ctrl+s`, `mac+meta+s`, `ctrl+p`, `mac+meta+p`],
            t.commitOrRemove,
            {
              bubbles: !0,
            },
          ],
          [[`ctrl+Enter`, `mac+meta+Enter`, `Escape`, `mac+Escape`], t.commitOrRemove],
          [
            [`ArrowLeft`, `mac+ArrowLeft`],
            t._translateEmpty,
            {
              args: [-r, 0],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowLeft`, `mac+shift+ArrowLeft`],
            t._translateEmpty,
            {
              args: [-i, 0],
              checker: n,
            },
          ],
          [
            [`ArrowRight`, `mac+ArrowRight`],
            t._translateEmpty,
            {
              args: [r, 0],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowRight`, `mac+shift+ArrowRight`],
            t._translateEmpty,
            {
              args: [i, 0],
              checker: n,
            },
          ],
          [
            [`ArrowUp`, `mac+ArrowUp`],
            t._translateEmpty,
            {
              args: [0, -r],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowUp`, `mac+shift+ArrowUp`],
            t._translateEmpty,
            {
              args: [0, -i],
              checker: n,
            },
          ],
          [
            [`ArrowDown`, `mac+ArrowDown`],
            t._translateEmpty,
            {
              args: [0, r],
              checker: n,
            },
          ],
          [
            [`ctrl+ArrowDown`, `mac+shift+ArrowDown`],
            t._translateEmpty,
            {
              args: [0, i],
              checker: n,
            },
          ],
        ]),
      );
    }
    static _type = `freetext`;
    static _editorType = h0.FREETEXT;
    constructor(t) {
      (super({
        ...t,
        name: `freeTextEditor`,
      }),
        (this.color = t.color || e._defaultColor || n4._defaultLineColor),
        (this.#r = t.fontSize || e._defaultFontSize),
        this.annotationElementId || this._uiManager.a11yAlert(`pdfjs-editor-freetext-added-alert`),
        (this.canAddComment = !1));
    }
    static initialize(e, t) {
      n4.initialize(e, t);
      let n = getComputedStyle(document.documentElement);
      this._internalPadding = parseFloat(n.getPropertyValue(`--freetext-padding`));
    }
    static updateDefaultParams(t, n) {
      switch (t) {
        case g0.FREETEXT_SIZE:
          e._defaultFontSize = n;
          break;
        case g0.FREETEXT_COLOR:
          e._defaultColor = n;
          break;
      }
    }
    updateParams(e, t) {
      switch (e) {
        case g0.FREETEXT_SIZE:
          this.#i(t);
          break;
        case g0.FREETEXT_COLOR:
          this.#a(t);
          break;
      }
    }
    static get defaultPropertiesToUpdate() {
      return [
        [g0.FREETEXT_SIZE, e._defaultFontSize],
        [g0.FREETEXT_COLOR, e._defaultColor || n4._defaultLineColor],
      ];
    }
    get propertiesToUpdate() {
      return [
        [g0.FREETEXT_SIZE, this.#r],
        [g0.FREETEXT_COLOR, this.color],
      ];
    }
    get toolbarButtons() {
      return ((this._colorPicker ||= new E3(this)), [[`colorPicker`, this._colorPicker]]);
    }
    get colorType() {
      return g0.FREETEXT_COLOR;
    }
    #i(e) {
      let t = (e) => {
          ((this.editorDiv.style.fontSize = `calc(${e}px * var(--total-scale-factor))`),
            this.translate(0, -(e - this.#r) * this.parentScale),
            (this.#r = e),
            this.#s());
        },
        n = this.#r;
      this.addCommands({
        cmd: t.bind(this, e),
        undo: t.bind(this, n),
        post: this._uiManager.updateUI.bind(this._uiManager, this),
        mustExec: !0,
        type: g0.FREETEXT_SIZE,
        overwriteIfSameType: !0,
        keepUndo: !0,
      });
    }
    onUpdatedColor() {
      ((this.editorDiv.style.color = this.color),
        this._colorPicker?.update(this.color),
        super.onUpdatedColor());
    }
    #a(e) {
      let t = (e) => {
          ((this.color = e), this.onUpdatedColor());
        },
        n = this.color;
      this.addCommands({
        cmd: t.bind(this, e),
        undo: t.bind(this, n),
        post: this._uiManager.updateUI.bind(this._uiManager, this),
        mustExec: !0,
        type: g0.FREETEXT_COLOR,
        overwriteIfSameType: !0,
        keepUndo: !0,
      });
    }
    _translateEmpty(e, t) {
      this._uiManager.translateSelectedEditors(e, t, !0);
    }
    getInitialTranslation() {
      let t = this.parentScale;
      return [-e._internalPadding * t, -(e._internalPadding + this.#r) * t];
    }
    rebuild() {
      this.parent &&
        (super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this)));
    }
    enableEditMode() {
      if (!super.enableEditMode()) return !1;
      (this.overlayDiv.classList.remove(`enabled`),
        (this.editorDiv.contentEditable = !0),
        (this._isDraggable = !1),
        this.div.removeAttribute(`aria-activedescendant`),
        (this.#n = new AbortController()));
      let e = this._uiManager.combinedSignal(this.#n);
      return (
        this.editorDiv.addEventListener(`keydown`, this.editorDivKeydown.bind(this), {
          signal: e,
        }),
        this.editorDiv.addEventListener(`focus`, this.editorDivFocus.bind(this), {
          signal: e,
        }),
        this.editorDiv.addEventListener(`blur`, this.editorDivBlur.bind(this), {
          signal: e,
        }),
        this.editorDiv.addEventListener(`input`, this.editorDivInput.bind(this), {
          signal: e,
        }),
        this.editorDiv.addEventListener(`paste`, this.editorDivPaste.bind(this), {
          signal: e,
        }),
        !0
      );
    }
    disableEditMode() {
      return super.disableEditMode()
        ? (this.overlayDiv.classList.add(`enabled`),
          (this.editorDiv.contentEditable = !1),
          this.div.setAttribute(`aria-activedescendant`, this.#t),
          (this._isDraggable = !0),
          this.#n?.abort(),
          (this.#n = null),
          this.div.focus({
            preventScroll: !0,
          }),
          (this.isEditing = !1),
          this.parent.div.classList.add(`freetextEditing`),
          !0)
        : !1;
    }
    focusin(e) {
      this._focusEventsAllowed &&
        (super.focusin(e), e.target !== this.editorDiv && this.editorDiv.focus());
    }
    onceAdded(e) {
      this.width ||
        (this.enableEditMode(),
        e && this.editorDiv.focus(),
        this._initialOptions?.isCentered && this.center(),
        (this._initialOptions = null));
    }
    isEmpty() {
      return !this.editorDiv || this.editorDiv.innerText.trim() === ``;
    }
    remove() {
      ((this.isEditing = !1),
        this.parent &&
          (this.parent.setEditingState(!0), this.parent.div.classList.add(`freetextEditing`)),
        super.remove());
    }
    #o() {
      let t = [];
      this.editorDiv.normalize();
      let n = null;
      for (let r of this.editorDiv.childNodes)
        (n?.nodeType === Node.TEXT_NODE && r.nodeName === `BR`) || (t.push(e.#c(r)), (n = r));
      return t.join(`
`);
    }
    #s() {
      let [e, t] = this.parentDimensions,
        n;
      if (this.isAttachedToDOM) n = this.div.getBoundingClientRect();
      else {
        let { currentLayer: e, div: t } = this,
          r = t.style.display,
          i = t.classList.contains(`hidden`);
        (t.classList.remove(`hidden`),
          (t.style.display = `hidden`),
          e.div.append(this.div),
          (n = t.getBoundingClientRect()),
          t.remove(),
          (t.style.display = r),
          t.classList.toggle(`hidden`, i));
      }
      (this.rotation % 180 == this.parentRotation % 180
        ? ((this.width = n.width / e), (this.height = n.height / t))
        : ((this.width = n.height / e), (this.height = n.width / t)),
        this.fixAndSetPosition());
    }
    commit() {
      if (!this.isInEditMode()) return;
      (super.commit(), this.disableEditMode());
      let e = this.#e,
        t = (this.#e = this.#o().trimEnd());
      if (e === t) return;
      let n = (e) => {
        if (((this.#e = e), !e)) {
          this.remove();
          return;
        }
        (this.#l(), this._uiManager.rebuild(this), this.#s());
      };
      (this.addCommands({
        cmd: () => {
          n(t);
        },
        undo: () => {
          n(e);
        },
        mustExec: !1,
      }),
        this.#s());
    }
    shouldGetKeyboardEvents() {
      return this.isInEditMode();
    }
    enterInEditMode() {
      (this.enableEditMode(), this.editorDiv.focus());
    }
    keydown(e) {
      e.target === this.div && e.key === `Enter` && (this.enterInEditMode(), e.preventDefault());
    }
    editorDivKeydown(t) {
      e._keyboardManager.exec(this, t);
    }
    editorDivFocus(e) {
      this.isEditing = !0;
    }
    editorDivBlur(e) {
      this.isEditing = !1;
    }
    editorDivInput(e) {
      this.parent.div.classList.toggle(`freetextEditing`, this.isEmpty());
    }
    disableEditing() {
      (this.editorDiv.setAttribute(`role`, `comment`),
        this.editorDiv.removeAttribute(`aria-multiline`));
    }
    enableEditing() {
      (this.editorDiv.setAttribute(`role`, `textbox`),
        this.editorDiv.setAttribute(`aria-multiline`, !0));
    }
    get canChangeContent() {
      return !0;
    }
    render() {
      if (this.div) return this.div;
      let e, t;
      ((this._isCopy || this.annotationElementId) && ((e = this.x), (t = this.y)),
        super.render(),
        (this.editorDiv = document.createElement(`div`)),
        (this.editorDiv.className = `internal`),
        this.editorDiv.setAttribute(`id`, this.#t),
        this.editorDiv.setAttribute(`data-l10n-id`, `pdfjs-free-text2`),
        this.editorDiv.setAttribute(`data-l10n-attrs`, `default-content`),
        this.enableEditing(),
        (this.editorDiv.contentEditable = !0));
      let { style: n } = this.editorDiv;
      if (
        ((n.fontSize = `calc(${this.#r}px * var(--total-scale-factor))`),
        (n.color = this.color),
        this.div.append(this.editorDiv),
        (this.overlayDiv = document.createElement(`div`)),
        this.overlayDiv.classList.add(`overlay`, `enabled`),
        this.div.append(this.overlayDiv),
        this._isCopy || this.annotationElementId)
      ) {
        let [n, r] = this.parentDimensions;
        if (this.annotationElementId) {
          let { position: i } = this._initialData,
            [a, o] = this.getInitialTranslation();
          [a, o] = this.pageTranslationToScreen(a, o);
          let [s, c] = this.pageDimensions,
            [l, u] = this.pageTranslation,
            d,
            f;
          switch (this.rotation) {
            case 0:
              ((d = e + (i[0] - l) / s), (f = t + this.height - (i[1] - u) / c));
              break;
            case 90:
              ((d = e + (i[0] - l) / s), (f = t - (i[1] - u) / c), ([a, o] = [o, -a]));
              break;
            case 180:
              ((d = e - this.width + (i[0] - l) / s),
                (f = t - (i[1] - u) / c),
                ([a, o] = [-a, -o]));
              break;
            case 270:
              ((d = e + (i[0] - l - this.height * c) / s),
                (f = t + (i[1] - u - this.width * s) / c),
                ([a, o] = [-o, a]));
              break;
          }
          this.setAt(d * n, f * r, a, o);
        } else this._moveAfterPaste(e, t);
        (this.#l(), (this._isDraggable = !0), (this.editorDiv.contentEditable = !1));
      } else ((this._isDraggable = !1), (this.editorDiv.contentEditable = !0));
      return this.div;
    }
    static #c(e) {
      return (e.nodeType === Node.TEXT_NODE ? e.nodeValue : e.innerText).replaceAll(W3, ``);
    }
    editorDivPaste(t) {
      let n = t.clipboardData || window.clipboardData,
        { types: r } = n;
      if (r.length === 1 && r[0] === `text/plain`) return;
      t.preventDefault();
      let i = e.#d(n.getData(`text`) || ``).replaceAll(
        W3,
        `
`,
      );
      if (!i) return;
      let a = window.getSelection();
      if (!a.rangeCount) return;
      (this.editorDiv.normalize(), a.deleteFromDocument());
      let o = a.getRangeAt(0);
      if (
        !i.includes(`
`)
      ) {
        (o.insertNode(document.createTextNode(i)), this.editorDiv.normalize(), a.collapseToStart());
        return;
      }
      let { startContainer: s, startOffset: c } = o,
        l = [],
        u = [];
      if (s.nodeType === Node.TEXT_NODE) {
        let t = s.parentElement;
        if ((u.push(s.nodeValue.slice(c).replaceAll(W3, ``)), t !== this.editorDiv)) {
          let n = l;
          for (let r of this.editorDiv.childNodes) {
            if (r === t) {
              n = u;
              continue;
            }
            n.push(e.#c(r));
          }
        }
        l.push(s.nodeValue.slice(0, c).replaceAll(W3, ``));
      } else if (s === this.editorDiv) {
        let t = l,
          n = 0;
        for (let r of this.editorDiv.childNodes) (n++ === c && (t = u), t.push(e.#c(r)));
      }
      ((this.#e = `${l.join(`
`)}${i}${u.join(`
`)}`),
        this.#l());
      let d = new Range(),
        f = Math.sumPrecise(l.map((e) => e.length));
      for (let { firstChild: e } of this.editorDiv.childNodes)
        if (e.nodeType === Node.TEXT_NODE) {
          let t = e.nodeValue.length;
          if (f <= t) {
            (d.setStart(e, f), d.setEnd(e, f));
            break;
          }
          f -= t;
        }
      (a.removeAllRanges(), a.addRange(d));
    }
    #l() {
      if ((this.editorDiv.replaceChildren(), this.#e))
        for (let e of this.#e.split(`
`)) {
          let t = document.createElement(`div`);
          (t.append(e ? document.createTextNode(e) : document.createElement(`br`)),
            this.editorDiv.append(t));
        }
    }
    #u() {
      return this.#e.replaceAll(`\xA0`, ` `);
    }
    static #d(e) {
      return e.replaceAll(` `, `\xA0`);
    }
    get contentDiv() {
      return this.editorDiv;
    }
    getPDFRect() {
      let t = e._internalPadding * this.parentScale;
      return this.getRect(t, t);
    }
    static async deserialize(t, n, r) {
      let i = null;
      if (t instanceof R3) {
        let {
          data: {
            defaultAppearanceData: { fontSize: e, fontColor: n },
            rect: r,
            rotation: a,
            id: o,
            popupRef: s,
            richText: c,
            contentsObj: l,
            creationDate: u,
            modificationDate: d,
          },
          textContent: f,
          textPosition: p,
          parent: {
            page: { pageNumber: m },
          },
        } = t;
        if (!f || f.length === 0) return null;
        i = t = {
          annotationType: h0.FREETEXT,
          color: Array.from(n),
          fontSize: e,
          value: f.join(`
`),
          position: p,
          pageIndex: m - 1,
          rect: r.slice(0),
          rotation: a,
          annotationElementId: o,
          id: o,
          deleted: !1,
          popupRef: s,
          comment: l?.str || null,
          richText: c,
          creationDate: u,
          modificationDate: d,
        };
      }
      let a = await super.deserialize(t, n, r);
      return (
        (a.#r = t.fontSize),
        (a.color = Y0.makeHexColor(...t.color)),
        (a.#e = e.#d(t.value)),
        (a._initialData = i),
        t.comment && a.setCommentData(t),
        a
      );
    }
    serialize(e = !1) {
      if (this.isEmpty()) return null;
      if (this.deleted) return this.serializeDeleted();
      let t = n4._colorManager.convert(
          this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.color,
        ),
        n = Object.assign(super.serialize(e), {
          color: t,
          fontSize: this.#r,
          value: this.#u(),
        });
      return (
        this.addComment(n),
        e
          ? ((n.isCopy = !0), n)
          : this.annotationElementId && !this.#f(n)
            ? null
            : ((n.id = this.annotationElementId), n)
      );
    }
    #f(e) {
      let { value: t, fontSize: n, color: r, pageIndex: i } = this._initialData;
      return (
        this.hasEditedComment ||
        this._hasBeenMoved ||
        e.value !== t ||
        e.fontSize !== n ||
        e.color.some((e, t) => e !== r[t]) ||
        e.pageIndex !== i
      );
    }
    renderAnnotationElement(e) {
      let t = super.renderAnnotationElement(e);
      if (!t) return null;
      let { style: n } = t;
      ((n.fontSize = `calc(${this.#r}px * var(--total-scale-factor))`),
        (n.color = this.color),
        t.replaceChildren());
      for (let e of this.#e.split(`
`)) {
        let n = document.createElement(`div`);
        (n.append(e ? document.createTextNode(e) : document.createElement(`br`)), t.append(n));
      }
      return (
        e.updateEdited({
          rect: this.getPDFRect(),
          popup:
            this._uiManager.hasCommentManager() || this.hasEditedComment
              ? this.comment
              : {
                  text: this.#e,
                },
        }),
        t
      );
    }
    resetAnnotationElement(e) {
      (super.resetAnnotationElement(e), e.resetEdited());
    }
  },
  G3 = class {
    static PRECISION = 1e-4;
    toSVGPath() {
      j0("Abstract method `toSVGPath` must be implemented.");
    }
    get box() {
      j0("Abstract getter `box` must be implemented.");
    }
    serialize(e, t) {
      j0("Abstract method `serialize` must be implemented.");
    }
    static _rescale(e, t, n, r, i, a) {
      a ||= new Float32Array(e.length);
      for (let o = 0, s = e.length; o < s; o += 2)
        ((a[o] = t + e[o] * r), (a[o + 1] = n + e[o + 1] * i));
      return a;
    }
    static _rescaleAndSwap(e, t, n, r, i, a) {
      a ||= new Float32Array(e.length);
      for (let o = 0, s = e.length; o < s; o += 2)
        ((a[o] = t + e[o + 1] * r), (a[o + 1] = n + e[o] * i));
      return a;
    }
    static _translate(e, t, n, r) {
      r ||= new Float32Array(e.length);
      for (let i = 0, a = e.length; i < a; i += 2) ((r[i] = t + e[i]), (r[i + 1] = n + e[i + 1]));
      return r;
    }
    static svgRound(e) {
      return Math.round(e * 1e4);
    }
    static _normalizePoint(e, t, n, r, i) {
      switch (i) {
        case 90:
          return [1 - t / n, e / r];
        case 180:
          return [1 - e / n, 1 - t / r];
        case 270:
          return [t / n, 1 - e / r];
        default:
          return [e / n, t / r];
      }
    }
    static _normalizePagePoint(e, t, n) {
      switch (n) {
        case 90:
          return [1 - t, e];
        case 180:
          return [1 - e, 1 - t];
        case 270:
          return [t, 1 - e];
        default:
          return [e, t];
      }
    }
    static createBezierPoints(e, t, n, r, i, a) {
      return [
        (e + 5 * n) / 6,
        (t + 5 * r) / 6,
        (5 * n + i) / 6,
        (5 * r + a) / 6,
        (n + i) / 2,
        (r + a) / 2,
      ];
    }
  },
  K3 = class e {
    #e;
    #t = [];
    #n;
    #r;
    #i = [];
    #a = new Float32Array(18);
    #o;
    #s;
    #c;
    #l;
    #u;
    #d;
    #f = [];
    static #p = 8;
    static #m = 2;
    static #h = e.#p + e.#m;
    constructor({ x: t, y: n }, r, i, a, o, s = 0) {
      ((this.#e = r),
        (this.#d = a * i),
        (this.#r = o),
        this.#a.set([NaN, NaN, NaN, NaN, t, n], 6),
        (this.#n = s),
        (this.#l = e.#p * i),
        (this.#c = e.#h * i),
        (this.#u = i),
        this.#f.push(t, n));
    }
    isEmpty() {
      return isNaN(this.#a[8]);
    }
    #g() {
      let e = this.#a.subarray(4, 6),
        t = this.#a.subarray(16, 18),
        [n, r, i, a] = this.#e;
      return [
        (this.#o + (e[0] - t[0]) / 2 - n) / i,
        (this.#s + (e[1] - t[1]) / 2 - r) / a,
        (this.#o + (t[0] - e[0]) / 2 - n) / i,
        (this.#s + (t[1] - e[1]) / 2 - r) / a,
      ];
    }
    add({ x: e, y: t }) {
      ((this.#o = e), (this.#s = t));
      let [n, r, i, a] = this.#e,
        [o, s, c, l] = this.#a.subarray(8, 12),
        u = e - c,
        d = t - l,
        f = Math.hypot(u, d);
      if (f < this.#c) return !1;
      let p = f - this.#l,
        m = p / f,
        h = m * u,
        g = m * d,
        v = o,
        y = s;
      ((o = c), (s = l), (c += h), (l += g), this.#f?.push(e, t));
      let b = -g / p,
        x = h / p,
        S = b * this.#d,
        C = x * this.#d;
      return (
        this.#a.set(this.#a.subarray(2, 8), 0),
        this.#a.set([c + S, l + C], 4),
        this.#a.set(this.#a.subarray(14, 18), 12),
        this.#a.set([c - S, l - C], 16),
        isNaN(this.#a[6])
          ? (this.#i.length === 0 &&
              (this.#a.set([o + S, s + C], 2),
              this.#i.push(NaN, NaN, NaN, NaN, (o + S - n) / i, (s + C - r) / a),
              this.#a.set([o - S, s - C], 14),
              this.#t.push(NaN, NaN, NaN, NaN, (o - S - n) / i, (s - C - r) / a)),
            this.#a.set([v, y, o, s, c, l], 6),
            !this.isEmpty())
          : (this.#a.set([v, y, o, s, c, l], 6),
            Math.abs(Math.atan2(y - s, v - o) - Math.atan2(g, h)) < Math.PI / 2
              ? (([o, s, c, l] = this.#a.subarray(2, 6)),
                this.#i.push(NaN, NaN, NaN, NaN, ((o + c) / 2 - n) / i, ((s + l) / 2 - r) / a),
                ([o, s, v, y] = this.#a.subarray(14, 18)),
                this.#t.push(NaN, NaN, NaN, NaN, ((v + o) / 2 - n) / i, ((y + s) / 2 - r) / a),
                !0)
              : (([v, y, o, s, c, l] = this.#a.subarray(0, 6)),
                this.#i.push(
                  ((v + 5 * o) / 6 - n) / i,
                  ((y + 5 * s) / 6 - r) / a,
                  ((5 * o + c) / 6 - n) / i,
                  ((5 * s + l) / 6 - r) / a,
                  ((o + c) / 2 - n) / i,
                  ((s + l) / 2 - r) / a,
                ),
                ([c, l, o, s, v, y] = this.#a.subarray(12, 18)),
                this.#t.push(
                  ((v + 5 * o) / 6 - n) / i,
                  ((y + 5 * s) / 6 - r) / a,
                  ((5 * o + c) / 6 - n) / i,
                  ((5 * s + l) / 6 - r) / a,
                  ((o + c) / 2 - n) / i,
                  ((s + l) / 2 - r) / a,
                ),
                !0))
      );
    }
    toSVGPath() {
      if (this.isEmpty()) return ``;
      let e = this.#i,
        t = this.#t;
      if (isNaN(this.#a[6]) && !this.isEmpty()) return this.#_();
      let n = [];
      n.push(`M${e[4]} ${e[5]}`);
      for (let t = 6; t < e.length; t += 6)
        isNaN(e[t])
          ? n.push(`L${e[t + 4]} ${e[t + 5]}`)
          : n.push(`C${e[t]} ${e[t + 1]} ${e[t + 2]} ${e[t + 3]} ${e[t + 4]} ${e[t + 5]}`);
      this.#y(n);
      for (let e = t.length - 6; e >= 6; e -= 6)
        isNaN(t[e])
          ? n.push(`L${t[e + 4]} ${t[e + 5]}`)
          : n.push(`C${t[e]} ${t[e + 1]} ${t[e + 2]} ${t[e + 3]} ${t[e + 4]} ${t[e + 5]}`);
      return (this.#v(n), n.join(` `));
    }
    #_() {
      let [e, t, n, r] = this.#e,
        [i, a, o, s] = this.#g();
      return `M${(this.#a[2] - e) / n} ${(this.#a[3] - t) / r} L${(this.#a[4] - e) / n} ${(this.#a[5] - t) / r} L${i} ${a} L${o} ${s} L${(this.#a[16] - e) / n} ${(this.#a[17] - t) / r} L${(this.#a[14] - e) / n} ${(this.#a[15] - t) / r} Z`;
    }
    #v(e) {
      let t = this.#t;
      e.push(`L${t[4]} ${t[5]} Z`);
    }
    #y(e) {
      let [t, n, r, i] = this.#e,
        a = this.#a.subarray(4, 6),
        o = this.#a.subarray(16, 18),
        [s, c, l, u] = this.#g();
      e.push(
        `L${(a[0] - t) / r} ${(a[1] - n) / i} L${s} ${c} L${l} ${u} L${(o[0] - t) / r} ${(o[1] - n) / i}`,
      );
    }
    newFreeDrawOutline(e, t, n, r, i, a) {
      return new q3(e, t, n, r, i, a);
    }
    getOutlines() {
      let e = this.#i,
        t = this.#t,
        n = this.#a,
        [r, i, a, o] = this.#e,
        s = new Float32Array((this.#f?.length ?? 0) + 2);
      for (let e = 0, t = s.length - 2; e < t; e += 2)
        ((s[e] = (this.#f[e] - r) / a), (s[e + 1] = (this.#f[e + 1] - i) / o));
      if (
        ((s[s.length - 2] = (this.#o - r) / a),
        (s[s.length - 1] = (this.#s - i) / o),
        isNaN(n[6]) && !this.isEmpty())
      )
        return this.#b(s);
      let c = new Float32Array(this.#i.length + 24 + this.#t.length),
        l = e.length;
      for (let t = 0; t < l; t += 2) {
        if (isNaN(e[t])) {
          c[t] = c[t + 1] = NaN;
          continue;
        }
        ((c[t] = e[t]), (c[t + 1] = e[t + 1]));
      }
      l = this.#S(c, l);
      for (let e = t.length - 6; e >= 6; e -= 6)
        for (let n = 0; n < 6; n += 2) {
          if (isNaN(t[e + n])) {
            ((c[l] = c[l + 1] = NaN), (l += 2));
            continue;
          }
          ((c[l] = t[e + n]), (c[l + 1] = t[e + n + 1]), (l += 2));
        }
      return (this.#x(c, l), this.newFreeDrawOutline(c, s, this.#e, this.#u, this.#n, this.#r));
    }
    #b(e) {
      let t = this.#a,
        [n, r, i, a] = this.#e,
        [o, s, c, l] = this.#g(),
        u = new Float32Array(36);
      return (
        u.set(
          [
            NaN,
            NaN,
            NaN,
            NaN,
            (t[2] - n) / i,
            (t[3] - r) / a,
            NaN,
            NaN,
            NaN,
            NaN,
            (t[4] - n) / i,
            (t[5] - r) / a,
            NaN,
            NaN,
            NaN,
            NaN,
            o,
            s,
            NaN,
            NaN,
            NaN,
            NaN,
            c,
            l,
            NaN,
            NaN,
            NaN,
            NaN,
            (t[16] - n) / i,
            (t[17] - r) / a,
            NaN,
            NaN,
            NaN,
            NaN,
            (t[14] - n) / i,
            (t[15] - r) / a,
          ],
          0,
        ),
        this.newFreeDrawOutline(u, e, this.#e, this.#u, this.#n, this.#r)
      );
    }
    #x(e, t) {
      let n = this.#t;
      return (e.set([NaN, NaN, NaN, NaN, n[4], n[5]], t), (t += 6));
    }
    #S(e, t) {
      let n = this.#a.subarray(4, 6),
        r = this.#a.subarray(16, 18),
        [i, a, o, s] = this.#e,
        [c, l, u, d] = this.#g();
      return (
        e.set(
          [
            NaN,
            NaN,
            NaN,
            NaN,
            (n[0] - i) / o,
            (n[1] - a) / s,
            NaN,
            NaN,
            NaN,
            NaN,
            c,
            l,
            NaN,
            NaN,
            NaN,
            NaN,
            u,
            d,
            NaN,
            NaN,
            NaN,
            NaN,
            (r[0] - i) / o,
            (r[1] - a) / s,
          ],
          t,
        ),
        (t += 24)
      );
    }
  },
  q3 = class extends G3 {
    #e;
    #t = new Float32Array(4);
    #n;
    #r;
    #i;
    #a;
    #o;
    constructor(e, t, n, r, i, a) {
      (super(),
        (this.#o = e),
        (this.#i = t),
        (this.#e = n),
        (this.#a = r),
        (this.#n = i),
        (this.#r = a),
        (this.firstPoint = [NaN, NaN]),
        (this.lastPoint = [NaN, NaN]),
        this.#s(a));
      let [o, s, c, l] = this.#t;
      for (let t = 0, n = e.length; t < n; t += 2)
        ((e[t] = (e[t] - o) / c), (e[t + 1] = (e[t + 1] - s) / l));
      for (let e = 0, n = t.length; e < n; e += 2)
        ((t[e] = (t[e] - o) / c), (t[e + 1] = (t[e + 1] - s) / l));
    }
    toSVGPath() {
      let e = [`M${this.#o[4]} ${this.#o[5]}`];
      for (let t = 6, n = this.#o.length; t < n; t += 6) {
        if (isNaN(this.#o[t])) {
          e.push(`L${this.#o[t + 4]} ${this.#o[t + 5]}`);
          continue;
        }
        e.push(
          `C${this.#o[t]} ${this.#o[t + 1]} ${this.#o[t + 2]} ${this.#o[t + 3]} ${this.#o[t + 4]} ${this.#o[t + 5]}`,
        );
      }
      return (e.push(`Z`), e.join(` `));
    }
    serialize([e, t, n, r], i) {
      let a = n - e,
        o = r - t,
        s,
        c;
      switch (i) {
        case 0:
          ((s = G3._rescale(this.#o, e, r, a, -o)), (c = G3._rescale(this.#i, e, r, a, -o)));
          break;
        case 90:
          ((s = G3._rescaleAndSwap(this.#o, e, t, a, o)),
            (c = G3._rescaleAndSwap(this.#i, e, t, a, o)));
          break;
        case 180:
          ((s = G3._rescale(this.#o, n, t, -a, o)), (c = G3._rescale(this.#i, n, t, -a, o)));
          break;
        case 270:
          ((s = G3._rescaleAndSwap(this.#o, n, r, -a, -o)),
            (c = G3._rescaleAndSwap(this.#i, n, r, -a, -o)));
          break;
      }
      return {
        outline: Array.from(s),
        points: [Array.from(c)],
      };
    }
    #s(e) {
      let t = this.#o,
        n = t[4],
        r = t[5],
        i = [n, r, n, r],
        a = n,
        o = r,
        s = n,
        c = r,
        l = e ? Math.max : Math.min,
        u = new Float32Array(4);
      for (let e = 6, d = t.length; e < d; e += 6) {
        let d = t[e + 4],
          f = t[e + 5];
        (isNaN(t[e])
          ? (Y0.pointBoundingBox(d, f, i),
            o > f ? ((a = d), (o = f)) : o === f && (a = l(a, d)),
            c < f ? ((s = d), (c = f)) : c === f && (s = l(s, d)))
          : (u.set(c0, 0),
            Y0.bezierBoundingBox(n, r, ...t.slice(e, e + 6), u),
            Y0.rectBoundingBox(...u, i),
            o > u[1] ? ((a = u[0]), (o = u[1])) : o === u[1] && (a = l(a, u[0])),
            c < u[3] ? ((s = u[2]), (c = u[3])) : c === u[3] && (s = l(s, u[2]))),
          (n = d),
          (r = f));
      }
      let d = this.#t;
      ((d[0] = i[0] - this.#n),
        (d[1] = i[1] - this.#n),
        (d[2] = i[2] - i[0] + 2 * this.#n),
        (d[3] = i[3] - i[1] + 2 * this.#n),
        (this.firstPoint = [a, o]),
        (this.lastPoint = [s, c]));
    }
    get box() {
      return this.#t;
    }
    newOutliner(e, t, n, r, i, a = 0) {
      return new K3(e, t, n, r, i, a);
    }
    getNewOutline(e, t) {
      let [n, r, i, a] = this.#t,
        [o, s, c, l] = this.#e,
        u = i * c,
        d = a * l,
        f = n * c + o,
        p = r * l + s,
        m = this.newOutliner(
          {
            x: this.#i[0] * u + f,
            y: this.#i[1] * d + p,
          },
          this.#e,
          this.#a,
          e,
          this.#r,
          t ?? this.#n,
        );
      for (let e = 2; e < this.#i.length; e += 2)
        m.add({
          x: this.#i[e] * u + f,
          y: this.#i[e + 1] * d + p,
        });
      return m.getOutlines();
    }
  },
  J3 = class {
    #e;
    #t;
    #n;
    #r = [];
    #i = [];
    constructor(e, t = 0, n = 0, r = !0) {
      let i = c0.slice(),
        a = 10 ** -4;
      for (let { x: n, y: r, width: o, height: s } of e) {
        let e = Math.floor((n - t) / a) * a,
          c = Math.ceil((n + o + t) / a) * a,
          l = Math.floor((r - t) / a) * a,
          u = Math.ceil((r + s + t) / a) * a,
          d = [e, l, u, !0],
          f = [c, l, u, !1];
        (this.#r.push(d, f), Y0.rectBoundingBox(e, l, c, u, i));
      }
      let o = i[2] - i[0] + 2 * n,
        s = i[3] - i[1] + 2 * n,
        c = i[0] - n,
        l = i[1] - n,
        u = r ? -1 / 0 : 1 / 0,
        d = 1 / 0,
        f = this.#r.at(r ? -1 : -2),
        p = [f[0], f[2]];
      for (let e of this.#r) {
        let [t, n, i, a] = e;
        (!a && r
          ? n < d
            ? ((d = n), (u = t))
            : n === d && (u = Math.max(u, t))
          : a && !r && (n < d ? ((d = n), (u = t)) : n === d && (u = Math.min(u, t))),
          (e[0] = (t - c) / o),
          (e[1] = (n - l) / s),
          (e[2] = (i - l) / s));
      }
      ((this.#e = new Float32Array([c, l, o, s])), (this.#t = [u, d]), (this.#n = p));
    }
    getOutlines() {
      this.#r.sort((e, t) => e[0] - t[0] || e[1] - t[1] || e[2] - t[2]);
      let e = [];
      for (let t of this.#r)
        t[3] ? (e.push(...this.#l(t)), this.#s(t)) : (this.#c(t), e.push(...this.#l(t)));
      return this.#a(e);
    }
    #a(e) {
      let t = [],
        n = new Set();
      for (let n of e) {
        let [e, r, i] = n;
        t.push([e, r, n], [e, i, n]);
      }
      t.sort((e, t) => e[1] - t[1] || e[0] - t[0]);
      for (let e = 0, r = t.length; e < r; e += 2) {
        let r = t[e][2],
          i = t[e + 1][2];
        (r.push(i), i.push(r), n.add(r), n.add(i));
      }
      let r = [],
        i;
      for (; n.size > 0;) {
        let e = n.values().next().value,
          [t, a, o, s, c] = e;
        n.delete(e);
        let l = t,
          u = a;
        for (i = [t, o], r.push(i); ;) {
          let e;
          if (n.has(s)) e = s;
          else if (n.has(c)) e = c;
          else break;
          (n.delete(e),
            ([t, a, o, s, c] = e),
            l !== t && (i.push(l, u, t, u === a ? a : o), (l = t)),
            (u = u === a ? o : a));
        }
        i.push(l, u);
      }
      return new Vce(r, this.#e, this.#t, this.#n);
    }
    #o(e) {
      let t = this.#i,
        n = 0,
        r = t.length - 1;
      for (; n <= r;) {
        let i = (n + r) >> 1,
          a = t[i][0];
        if (a === e) return i;
        a < e ? (n = i + 1) : (r = i - 1);
      }
      return r + 1;
    }
    #s([, e, t]) {
      let n = this.#o(e);
      this.#i.splice(n, 0, [e, t]);
    }
    #c([, e, t]) {
      let n = this.#o(e);
      for (let r = n; r < this.#i.length; r++) {
        let [n, i] = this.#i[r];
        if (n !== e) break;
        if (n === e && i === t) {
          this.#i.splice(r, 1);
          return;
        }
      }
      for (let r = n - 1; r >= 0; r--) {
        let [n, i] = this.#i[r];
        if (n !== e) break;
        if (n === e && i === t) {
          this.#i.splice(r, 1);
          return;
        }
      }
    }
    #l(e) {
      let [t, n, r] = e,
        i = [[t, n, r]],
        a = this.#o(r);
      for (let e = 0; e < a; e++) {
        let [n, r] = this.#i[e];
        for (let e = 0, a = i.length; e < a; e++) {
          let [, o, s] = i[e];
          if (!(r <= o || s <= n)) {
            if (o >= n) {
              if (s > r) i[e][1] = r;
              else {
                if (a === 1) return [];
                (i.splice(e, 1), e--, a--);
              }
              continue;
            }
            ((i[e][2] = n), s > r && i.push([t, r, s]));
          }
        }
      }
      return i;
    }
  },
  Vce = class extends G3 {
    #e;
    #t;
    constructor(e, t, n, r) {
      (super(), (this.#t = e), (this.#e = t), (this.firstPoint = n), (this.lastPoint = r));
    }
    toSVGPath() {
      let e = [];
      for (let t of this.#t) {
        let [n, r] = t;
        e.push(`M${n} ${r}`);
        for (let i = 2; i < t.length; i += 2) {
          let a = t[i],
            o = t[i + 1];
          a === n ? (e.push(`V${o}`), (r = o)) : o === r && (e.push(`H${a}`), (n = a));
        }
        e.push(`Z`);
      }
      return e.join(` `);
    }
    serialize([e, t, n, r], i) {
      let a = [],
        o = n - e,
        s = r - t;
      for (let t of this.#t) {
        let n = Array(t.length);
        for (let i = 0; i < t.length; i += 2)
          ((n[i] = e + t[i] * o), (n[i + 1] = r - t[i + 1] * s));
        a.push(n);
      }
      return a;
    }
    get box() {
      return this.#e;
    }
    get classNamesForOutlining() {
      return [`highlightOutline`];
    }
  },
  Y3 = class extends K3 {
    newFreeDrawOutline(e, t, n, r, i, a) {
      return new Hce(e, t, n, r, i, a);
    }
  },
  Hce = class extends q3 {
    newOutliner(e, t, n, r, i, a = 0) {
      return new Y3(e, t, n, r, i, a);
    }
  },
  X3 = class e extends n4 {
    #e = null;
    #t = 0;
    #n;
    #r = null;
    #i = null;
    #a = null;
    #o = null;
    #s = 0;
    #c = null;
    #l = null;
    #u = null;
    #d = !1;
    #f = null;
    #p = null;
    #m = null;
    #h = ``;
    #g;
    #_ = ``;
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 12;
    static _type = `highlight`;
    static _editorType = h0.HIGHLIGHT;
    static _freeHighlightId = -1;
    static _freeHighlight = null;
    static _freeHighlightClipId = ``;
    static get _keyboardManager() {
      let t = e.prototype;
      return L0(
        this,
        `_keyboardManager`,
        new Z2([
          [
            [`ArrowLeft`, `mac+ArrowLeft`],
            t._moveCaret,
            {
              args: [0],
            },
          ],
          [
            [`ArrowRight`, `mac+ArrowRight`],
            t._moveCaret,
            {
              args: [1],
            },
          ],
          [
            [`ArrowUp`, `mac+ArrowUp`],
            t._moveCaret,
            {
              args: [2],
            },
          ],
          [
            [`ArrowDown`, `mac+ArrowDown`],
            t._moveCaret,
            {
              args: [3],
            },
          ],
        ]),
      );
    }
    constructor(t) {
      (super({
        ...t,
        name: `highlightEditor`,
      }),
        (this.color = t.color || e._defaultColor),
        (this.#g = t.thickness || e._defaultThickness),
        (this.opacity = t.opacity || e._defaultOpacity),
        (this.#n = t.boxes || null),
        (this.#_ = t.methodOfCreation || ``),
        (this.#h = t.text || ``),
        (this._isDraggable = !1),
        (this.defaultL10nId = `pdfjs-editor-highlight-editor`),
        t.highlightId > -1
          ? ((this.#d = !0), this.#y(t), this.#w())
          : this.#n &&
            ((this.#e = t.anchorNode),
            (this.#t = t.anchorOffset),
            (this.#o = t.focusNode),
            (this.#s = t.focusOffset),
            this.#v(),
            this.#w(),
            this.rotate(this.rotation)),
        this.annotationElementId ||
          this._uiManager.a11yAlert(`pdfjs-editor-highlight-added-alert`));
    }
    get telemetryInitialData() {
      return {
        action: `added`,
        type: this.#d ? `free_highlight` : `highlight`,
        color: this._uiManager.getNonHCMColorName(this.color),
        thickness: this.#g,
        methodOfCreation: this.#_,
      };
    }
    get telemetryFinalData() {
      return {
        type: `highlight`,
        color: this._uiManager.getNonHCMColorName(this.color),
      };
    }
    static computeTelemetryFinalData(e) {
      return {
        numberOfColors: e.get(`color`).size,
      };
    }
    #v() {
      let e = new J3(this.#n, 0.001);
      ((this.#l = e.getOutlines()), ([this.x, this.y, this.width, this.height] = this.#l.box));
      let t = new J3(this.#n, 0.0025, 0.001, this._uiManager.direction === `ltr`);
      this.#a = t.getOutlines();
      let { firstPoint: n } = this.#l;
      this.#f = [(n[0] - this.x) / this.width, (n[1] - this.y) / this.height];
      let { lastPoint: r } = this.#a;
      this.#p = [(r[0] - this.x) / this.width, (r[1] - this.y) / this.height];
    }
    #y({ highlightOutlines: t, highlightId: n, clipPathId: r }) {
      if (((this.#l = t), (this.#a = t.getNewOutline(this.#g / 2 + 1.5, 0.0025)), n >= 0))
        ((this.#u = n),
          (this.#r = r),
          this.parent.drawLayer.finalizeDraw(n, {
            bbox: t.box,
            path: {
              d: t.toSVGPath(),
            },
          }),
          (this.#m = this.parent.drawLayer.drawOutline(
            {
              rootClass: {
                highlightOutline: !0,
                free: !0,
              },
              bbox: this.#a.box,
              path: {
                d: this.#a.toSVGPath(),
              },
            },
            !0,
          )));
      else if (this.parent) {
        let n = this.parent.viewport.rotation;
        (this.parent.drawLayer.updateProperties(this.#u, {
          bbox: e.#T(this.#l.box, (n - this.rotation + 360) % 360),
          path: {
            d: t.toSVGPath(),
          },
        }),
          this.parent.drawLayer.updateProperties(this.#m, {
            bbox: e.#T(this.#a.box, n),
            path: {
              d: this.#a.toSVGPath(),
            },
          }));
      }
      let [i, a, o, s] = t.box;
      switch (this.rotation) {
        case 0:
          ((this.x = i), (this.y = a), (this.width = o), (this.height = s));
          break;
        case 90: {
          let [e, t] = this.parentDimensions;
          ((this.x = a), (this.y = 1 - i), (this.width = (o * t) / e), (this.height = (s * e) / t));
          break;
        }
        case 180:
          ((this.x = 1 - i), (this.y = 1 - a), (this.width = o), (this.height = s));
          break;
        case 270: {
          let [e, t] = this.parentDimensions;
          ((this.x = 1 - a), (this.y = i), (this.width = (o * t) / e), (this.height = (s * e) / t));
          break;
        }
      }
      let { firstPoint: c } = t;
      this.#f = [(c[0] - i) / o, (c[1] - a) / s];
      let { lastPoint: l } = this.#a;
      this.#p = [(l[0] - i) / o, (l[1] - a) / s];
    }
    static initialize(t, n) {
      (n4.initialize(t, n),
        (e._defaultColor ||= n.highlightColors?.values().next().value || `#fff066`));
    }
    static updateDefaultParams(t, n) {
      switch (t) {
        case g0.HIGHLIGHT_COLOR:
          e._defaultColor = n;
          break;
        case g0.HIGHLIGHT_THICKNESS:
          e._defaultThickness = n;
          break;
      }
    }
    translateInPage(e, t) {}
    get toolbarPosition() {
      return this.#p;
    }
    get commentButtonPosition() {
      return this.#f;
    }
    updateParams(e, t) {
      switch (e) {
        case g0.HIGHLIGHT_COLOR:
          this.#b(t);
          break;
        case g0.HIGHLIGHT_THICKNESS:
          this.#x(t);
          break;
      }
    }
    static get defaultPropertiesToUpdate() {
      return [
        [g0.HIGHLIGHT_COLOR, e._defaultColor],
        [g0.HIGHLIGHT_THICKNESS, e._defaultThickness],
      ];
    }
    get propertiesToUpdate() {
      return [
        [g0.HIGHLIGHT_COLOR, this.color || e._defaultColor],
        [g0.HIGHLIGHT_THICKNESS, this.#g || e._defaultThickness],
        [g0.HIGHLIGHT_FREE, this.#d],
      ];
    }
    onUpdatedColor() {
      (this.parent?.drawLayer.updateProperties(this.#u, {
        root: {
          fill: this.color,
          "fill-opacity": this.opacity,
        },
      }),
        this.#i?.updateColor(this.color),
        super.onUpdatedColor());
    }
    #b(t) {
      let n = (e, t) => {
          ((this.color = e), (this.opacity = t), this.onUpdatedColor());
        },
        r = this.color,
        i = this.opacity;
      (this.addCommands({
        cmd: n.bind(this, t, e._defaultOpacity),
        undo: n.bind(this, r, i),
        post: this._uiManager.updateUI.bind(this._uiManager, this),
        mustExec: !0,
        type: g0.HIGHLIGHT_COLOR,
        overwriteIfSameType: !0,
        keepUndo: !0,
      }),
        this._reportTelemetry(
          {
            action: `color_changed`,
            color: this._uiManager.getNonHCMColorName(t),
          },
          !0,
        ));
    }
    #x(e) {
      let t = this.#g,
        n = (e) => {
          ((this.#g = e), this.#S(e));
        };
      (this.addCommands({
        cmd: n.bind(this, e),
        undo: n.bind(this, t),
        post: this._uiManager.updateUI.bind(this._uiManager, this),
        mustExec: !0,
        type: g0.INK_THICKNESS,
        overwriteIfSameType: !0,
        keepUndo: !0,
      }),
        this._reportTelemetry(
          {
            action: `thickness_changed`,
            thickness: e,
          },
          !0,
        ));
    }
    get toolbarButtons() {
      return this._uiManager.highlightColors
        ? [
            [
              `colorPicker`,
              (this.#i = new T3({
                editor: this,
              })),
            ],
          ]
        : super.toolbarButtons;
    }
    disableEditing() {
      (super.disableEditing(), this.div.classList.toggle(`disabled`, !0));
    }
    enableEditing() {
      (super.enableEditing(), this.div.classList.toggle(`disabled`, !1));
    }
    fixAndSetPosition() {
      return super.fixAndSetPosition(this.#O());
    }
    getBaseTranslation() {
      return [0, 0];
    }
    getRect(e, t) {
      return super.getRect(e, t, this.#O());
    }
    onceAdded(e) {
      (this.annotationElementId || this.parent.addUndoableEditor(this), e && this.div.focus());
    }
    remove() {
      (this.#C(),
        this._reportTelemetry({
          action: `deleted`,
        }),
        super.remove());
    }
    rebuild() {
      this.parent &&
        (super.rebuild(),
        this.div !== null && (this.#w(), this.isAttachedToDOM || this.parent.add(this)));
    }
    setParent(e) {
      let t = !1;
      (this.parent && !e
        ? this.#C()
        : e && (this.#w(e), (t = !this.parent && this.div?.classList.contains(`selectedEditor`))),
        super.setParent(e),
        this.show(this._isVisible),
        t && this.select());
    }
    #S(e) {
      this.#d &&
        (this.#y({
          highlightOutlines: this.#l.getNewOutline(e / 2),
        }),
        this.fixAndSetPosition(),
        this.setDims());
    }
    #C() {
      this.#u === null ||
        !this.parent ||
        (this.parent.drawLayer.remove(this.#u),
        (this.#u = null),
        this.parent.drawLayer.remove(this.#m),
        (this.#m = null));
    }
    #w(e = this.parent) {
      this.#u === null &&
        (({ id: this.#u, clipPathId: this.#r } = e.drawLayer.draw(
          {
            bbox: this.#l.box,
            root: {
              viewBox: `0 0 1 1`,
              fill: this.color,
              "fill-opacity": this.opacity,
            },
            rootClass: {
              highlight: !0,
              free: this.#d,
            },
            path: {
              d: this.#l.toSVGPath(),
            },
          },
          !1,
          !0,
        )),
        (this.#m = e.drawLayer.drawOutline(
          {
            rootClass: {
              highlightOutline: !0,
              free: this.#d,
            },
            bbox: this.#a.box,
            path: {
              d: this.#a.toSVGPath(),
            },
          },
          this.#d,
        )),
        this.#c && (this.#c.style.clipPath = this.#r));
    }
    static #T([e, t, n, r], i) {
      switch (i) {
        case 90:
          return [1 - t - r, e, r, n];
        case 180:
          return [1 - e - n, 1 - t - r, n, r];
        case 270:
          return [t, 1 - e - n, r, n];
      }
      return [e, t, n, r];
    }
    rotate(t) {
      let { drawLayer: n } = this.parent,
        r;
      (this.#d
        ? ((t = (t - this.rotation + 360) % 360), (r = e.#T(this.#l.box, t)))
        : (r = e.#T([this.x, this.y, this.width, this.height], t)),
        n.updateProperties(this.#u, {
          bbox: r,
          root: {
            "data-main-rotation": t,
          },
        }),
        n.updateProperties(this.#m, {
          bbox: e.#T(this.#a.box, t),
          root: {
            "data-main-rotation": t,
          },
        }));
    }
    render() {
      if (this.div) return this.div;
      let e = super.render();
      (this.#h && (e.setAttribute(`aria-label`, this.#h), e.setAttribute(`role`, `mark`)),
        this.#d
          ? e.classList.add(`free`)
          : this.div.addEventListener(`keydown`, this.#E.bind(this), {
              signal: this._uiManager._signal,
            }));
      let t = (this.#c = document.createElement(`div`));
      return (
        e.append(t),
        t.setAttribute(`aria-hidden`, `true`),
        (t.className = `internal`),
        (t.style.clipPath = this.#r),
        this.setDims(),
        K2(this, this.#c, [`pointerover`, `pointerleave`]),
        this.enableEditing(),
        e
      );
    }
    pointerover() {
      this.isSelected ||
        this.parent?.drawLayer.updateProperties(this.#m, {
          rootClass: {
            hovered: !0,
          },
        });
    }
    pointerleave() {
      this.isSelected ||
        this.parent?.drawLayer.updateProperties(this.#m, {
          rootClass: {
            hovered: !1,
          },
        });
    }
    #E(t) {
      e._keyboardManager.exec(this, t);
    }
    _moveCaret(e) {
      switch ((this.parent.unselect(this), e)) {
        case 0:
        case 2:
          this.#D(!0);
          break;
        case 1:
        case 3:
          this.#D(!1);
          break;
      }
    }
    #D(e) {
      if (!this.#e) return;
      let t = window.getSelection();
      e ? t.setPosition(this.#e, this.#t) : t.setPosition(this.#o, this.#s);
    }
    select() {
      (super.select(),
        this.#m &&
          this.parent?.drawLayer.updateProperties(this.#m, {
            rootClass: {
              hovered: !1,
              selected: !0,
            },
          }));
    }
    unselect() {
      (super.unselect(),
        this.#m &&
          (this.parent?.drawLayer.updateProperties(this.#m, {
            rootClass: {
              selected: !1,
            },
          }),
          this.#d || this.#D(!1)));
    }
    get _mustFixPosition() {
      return !this.#d;
    }
    show(e = this._isVisible) {
      (super.show(e),
        this.parent &&
          (this.parent.drawLayer.updateProperties(this.#u, {
            rootClass: {
              hidden: !e,
            },
          }),
          this.parent.drawLayer.updateProperties(this.#m, {
            rootClass: {
              hidden: !e,
            },
          })));
    }
    #O() {
      return this.#d ? this.rotation : 0;
    }
    #k() {
      if (this.#d) return null;
      let [e, t] = this.pageDimensions,
        [n, r] = this.pageTranslation,
        i = this.#n,
        a = new Float32Array(i.length * 8),
        o = 0;
      for (let { x: s, y: c, width: l, height: u } of i) {
        let i = s * e + n,
          d = (1 - c) * t + r;
        ((a[o] = a[o + 4] = i),
          (a[o + 1] = a[o + 3] = d),
          (a[o + 2] = a[o + 6] = i + l * e),
          (a[o + 5] = a[o + 7] = d - u * t),
          (o += 8));
      }
      return a;
    }
    #A(e) {
      return this.#l.serialize(e, this.#O());
    }
    static startHighlighting(e, t, { target: n, x: r, y: i }) {
      let { x: a, y: o, width: s, height: c } = n.getBoundingClientRect(),
        l = new AbortController(),
        u = e.combinedSignal(l),
        d = (t) => {
          (l.abort(), this.#M(e, t));
        };
      (window.addEventListener(`blur`, d, {
        signal: u,
      }),
        window.addEventListener(`pointerup`, d, {
          signal: u,
        }),
        window.addEventListener(`pointerdown`, x2, {
          capture: !0,
          passive: !1,
          signal: u,
        }),
        window.addEventListener(`contextmenu`, b2, {
          signal: u,
        }),
        n.addEventListener(`pointermove`, this.#j.bind(this, e), {
          signal: u,
        }),
        (this._freeHighlight = new Y3(
          {
            x: r,
            y: i,
          },
          [a, o, s, c],
          e.scale,
          this._defaultThickness / 2,
          t,
          0.001,
        )),
        ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } = e.drawLayer.draw(
          {
            bbox: [0, 0, 1, 1],
            root: {
              viewBox: `0 0 1 1`,
              fill: this._defaultColor,
              "fill-opacity": this._defaultOpacity,
            },
            rootClass: {
              highlight: !0,
              free: !0,
            },
            path: {
              d: this._freeHighlight.toSVGPath(),
            },
          },
          !0,
          !0,
        )));
    }
    static #j(e, t) {
      this._freeHighlight.add(t) &&
        e.drawLayer.updateProperties(this._freeHighlightId, {
          path: {
            d: this._freeHighlight.toSVGPath(),
          },
        });
    }
    static #M(e, t) {
      (this._freeHighlight.isEmpty()
        ? e.drawLayer.remove(this._freeHighlightId)
        : e.createAndAddNewEditor(t, !1, {
            highlightId: this._freeHighlightId,
            highlightOutlines: this._freeHighlight.getOutlines(),
            clipPathId: this._freeHighlightClipId,
            methodOfCreation: `main_toolbar`,
          }),
        (this._freeHighlightId = -1),
        (this._freeHighlight = null),
        (this._freeHighlightClipId = ``));
    }
    static async deserialize(e, t, n) {
      let r = null;
      if (e instanceof V3) {
        let {
          data: {
            quadPoints: t,
            rect: n,
            rotation: i,
            id: a,
            color: o,
            opacity: s,
            popupRef: c,
            richText: l,
            contentsObj: u,
            creationDate: d,
            modificationDate: f,
          },
          parent: {
            page: { pageNumber: p },
          },
        } = e;
        r = e = {
          annotationType: h0.HIGHLIGHT,
          color: Array.from(o),
          opacity: s,
          quadPoints: t,
          boxes: null,
          pageIndex: p - 1,
          rect: n.slice(0),
          rotation: i,
          annotationElementId: a,
          id: a,
          deleted: !1,
          popupRef: c,
          richText: l,
          comment: u?.str || null,
          creationDate: d,
          modificationDate: f,
        };
      } else if (e instanceof B3) {
        let {
          data: {
            inkLists: t,
            rect: n,
            rotation: i,
            id: a,
            color: o,
            borderStyle: { rawWidth: s },
            popupRef: c,
            richText: l,
            contentsObj: u,
            creationDate: d,
            modificationDate: f,
          },
          parent: {
            page: { pageNumber: p },
          },
        } = e;
        r = e = {
          annotationType: h0.HIGHLIGHT,
          color: Array.from(o),
          thickness: s,
          inkLists: t,
          boxes: null,
          pageIndex: p - 1,
          rect: n.slice(0),
          rotation: i,
          annotationElementId: a,
          id: a,
          deleted: !1,
          popupRef: c,
          richText: l,
          comment: u?.str || null,
          creationDate: d,
          modificationDate: f,
        };
      }
      let { color: i, quadPoints: a, inkLists: o, outlines: s, opacity: c } = e,
        l = await super.deserialize(e, t, n);
      ((l.color = Y0.makeHexColor(...i)),
        (l.opacity = c || 1),
        o && (l.#g = e.thickness),
        (l._initialData = r),
        e.comment && l.setCommentData(e));
      let [u, d] = l.pageDimensions,
        [f, p] = l.pageTranslation;
      if (a) {
        let e = (l.#n = []);
        for (let t = 0; t < a.length; t += 8)
          e.push({
            x: (a[t] - f) / u,
            y: 1 - (a[t + 1] - p) / d,
            width: (a[t + 2] - a[t]) / u,
            height: (a[t + 1] - a[t + 5]) / d,
          });
        (l.#v(), l.#w(), l.rotate(l.rotation));
      } else if (o || s) {
        l.#d = !0;
        let e = (o || s.points)[0],
          n = {
            x: e[0] - f,
            y: d - (e[1] - p),
          },
          r = new Y3(n, [0, 0, u, d], 1, l.#g / 2, !0, 0.001);
        for (let t = 0, i = e.length; t < i; t += 2)
          ((n.x = e[t] - f), (n.y = d - (e[t + 1] - p)), r.add(n));
        let { id: i, clipPathId: a } = t.drawLayer.draw(
          {
            bbox: [0, 0, 1, 1],
            root: {
              viewBox: `0 0 1 1`,
              fill: l.color,
              "fill-opacity": l._defaultOpacity,
            },
            rootClass: {
              highlight: !0,
              free: !0,
            },
            path: {
              d: r.toSVGPath(),
            },
          },
          !0,
          !0,
        );
        (l.#y({
          highlightOutlines: r.getOutlines(),
          highlightId: i,
          clipPathId: a,
        }),
          l.#w(),
          l.rotate(l.parentRotation));
      }
      return l;
    }
    serialize(e = !1) {
      if (this.isEmpty() || e) return null;
      if (this.deleted) return this.serializeDeleted();
      let t = n4._colorManager.convert(this._uiManager.getNonHCMColor(this.color)),
        n = super.serialize(e);
      return (
        Object.assign(n, {
          color: t,
          opacity: this.opacity,
          thickness: this.#g,
          quadPoints: this.#k(),
          outlines: this.#A(n.rect),
        }),
        this.addComment(n),
        this.annotationElementId && !this.#N(n) ? null : ((n.id = this.annotationElementId), n)
      );
    }
    #N(e) {
      let { color: t } = this._initialData;
      return this.hasEditedComment || e.color.some((e, n) => e !== t[n]);
    }
    renderAnnotationElement(e) {
      return this.deleted
        ? (e.hide(), null)
        : (e.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment,
          }),
          null);
    }
    static canCreateNewEmptyEditor() {
      return !1;
    }
  },
  Z3 = class {
    #e = Object.create(null);
    updateProperty(e, t) {
      ((this[e] = t), this.updateSVGProperty(e, t));
    }
    updateProperties(e) {
      if (e) for (let [t, n] of Object.entries(e)) t.startsWith(`_`) || this.updateProperty(t, n);
    }
    updateSVGProperty(e, t) {
      this.#e[e] = t;
    }
    toSVGProperties() {
      let e = this.#e;
      return (
        (this.#e = Object.create(null)),
        {
          root: e,
        }
      );
    }
    reset() {
      this.#e = Object.create(null);
    }
    updateAll(e = this) {
      this.updateProperties(e);
    }
    clone() {
      j0(`Not implemented`);
    }
  },
  Q3 = class e extends n4 {
    #e = null;
    #t;
    _colorPicker = null;
    _drawId = null;
    static _currentDrawId = -1;
    static _currentParent = null;
    static #n = null;
    static #r = null;
    static #i = null;
    static _INNER_MARGIN = 3;
    constructor(e) {
      (super(e), (this.#t = e.mustBeCommitted || !1), this._addOutlines(e));
    }
    onUpdatedColor() {
      (this._colorPicker?.update(this.color), super.onUpdatedColor());
    }
    onUpdatedOpacity() {
      this._colorPicker?.updateOpacity?.(this.opacity);
    }
    _addOutlines(e) {
      e.drawOutlines && (this.#a(e), this.#c());
    }
    #a({ drawOutlines: e, drawId: t, drawingOptions: n }) {
      ((this.#e = e),
        (this._drawingOptions ||= n),
        this.annotationElementId ||
          this._uiManager.a11yAlert(`pdfjs-editor-${this.editorType}-added-alert`),
        t >= 0
          ? ((this._drawId = t), this.parent.drawLayer.finalizeDraw(t, e.defaultProperties))
          : (this._drawId = this.#o(e, this.parent)),
        this.#d(e.box));
    }
    #o(t, n) {
      let { id: r } = n.drawLayer.draw(
        e._mergeSVGProperties(this._drawingOptions.toSVGProperties(), t.defaultSVGProperties),
        !1,
        !1,
      );
      return r;
    }
    static _mergeSVGProperties(e, t) {
      let n = new Set(Object.keys(e));
      for (let [r, i] of Object.entries(t)) n.has(r) ? Object.assign(e[r], i) : (e[r] = i);
      return e;
    }
    static getDefaultDrawingOptions(e) {
      j0(`Not implemented`);
    }
    static get typesMap() {
      j0(`Not implemented`);
    }
    static get isDrawer() {
      return !0;
    }
    static get supportMultipleDrawings() {
      return !1;
    }
    static updateDefaultParams(t, n) {
      let r = this.typesMap.get(t);
      (r && this._defaultDrawingOptions.updateProperty(r, n),
        this._currentParent &&
          (e.#n.updateProperty(r, n),
          this._currentParent.drawLayer.updateProperties(
            this._currentDrawId,
            this._defaultDrawingOptions.toSVGProperties(),
          )));
    }
    updateParams(e, t) {
      let n = this.constructor.typesMap.get(e);
      n && this._updateProperty(e, n, t);
    }
    static get defaultPropertiesToUpdate() {
      let e = [],
        t = this._defaultDrawingOptions;
      for (let [n, r] of this.typesMap) e.push([n, t[r]]);
      return e;
    }
    get propertiesToUpdate() {
      let e = [],
        { _drawingOptions: t } = this;
      for (let [n, r] of this.constructor.typesMap) e.push([n, t[r]]);
      return e;
    }
    _updateProperty(e, t, n) {
      let r = this._drawingOptions,
        i = r[t],
        a = (n) => {
          r.updateProperty(t, n);
          let i = this.#e.updateProperty(t, n);
          (i && this.#d(i),
            this.parent?.drawLayer.updateProperties(this._drawId, r.toSVGProperties()),
            e === this.colorType
              ? this.onUpdatedColor()
              : e === this.opacityType && this.onUpdatedOpacity());
        };
      this.addCommands({
        cmd: a.bind(this, n),
        undo: a.bind(this, i),
        post: this._uiManager.updateUI.bind(this._uiManager, this),
        mustExec: !0,
        type: e,
        overwriteIfSameType: !0,
        keepUndo: !0,
      });
    }
    _updateColorAndOpacity(e, t) {
      let n = this.constructor.typesMap.get(this.colorType),
        r = this.constructor.typesMap.get(this.opacityType),
        i = this._drawingOptions,
        a = i[n],
        o = i[r],
        s = (e, t) => {
          (i.updateProperty(n, e),
            i.updateProperty(r, t),
            this.#e.updateProperty(n, e),
            this.#e.updateProperty(r, t),
            this.parent?.drawLayer.updateProperties(this._drawId, i.toSVGProperties()),
            this.onUpdatedColor(),
            this.onUpdatedOpacity());
        };
      this.addCommands({
        cmd: s.bind(this, e, t),
        undo: s.bind(this, a, o),
        post: this._uiManager.updateUI.bind(this._uiManager, this),
        mustExec: !0,
        type: g0.INK_COLOR_AND_OPACITY,
        overwriteIfSameType: !0,
        keepUndo: !0,
      });
    }
    _onResizing() {
      this.parent?.drawLayer.updateProperties(
        this._drawId,
        e._mergeSVGProperties(this.#e.getPathResizingSVGProperties(this.#u()), {
          bbox: this.#f(),
        }),
      );
    }
    _onResized() {
      this.parent?.drawLayer.updateProperties(
        this._drawId,
        e._mergeSVGProperties(this.#e.getPathResizedSVGProperties(this.#u()), {
          bbox: this.#f(),
        }),
      );
    }
    _onTranslating(e, t) {
      this.parent?.drawLayer.updateProperties(this._drawId, {
        bbox: this.#f(),
      });
    }
    _onTranslated() {
      this.parent?.drawLayer.updateProperties(
        this._drawId,
        e._mergeSVGProperties(
          this.#e.getPathTranslatedSVGProperties(this.#u(), this.parentDimensions),
          {
            bbox: this.#f(),
          },
        ),
      );
    }
    _onStartDragging() {
      this.parent?.drawLayer.updateProperties(this._drawId, {
        rootClass: {
          moving: !0,
        },
      });
    }
    _onStopDragging() {
      this.parent?.drawLayer.updateProperties(this._drawId, {
        rootClass: {
          moving: !1,
        },
      });
    }
    commit() {
      (super.commit(), this.disableEditMode(), this.disableEditing());
    }
    disableEditing() {
      (super.disableEditing(), this.div.classList.toggle(`disabled`, !0));
    }
    enableEditing() {
      (super.enableEditing(), this.div.classList.toggle(`disabled`, !1));
    }
    getBaseTranslation() {
      return [0, 0];
    }
    get isResizable() {
      return !0;
    }
    onceAdded(e) {
      (this.annotationElementId || this.parent.addUndoableEditor(this),
        (this._isDraggable = !0),
        this.#t &&
          ((this.#t = !1),
          this.commit(),
          this.parent.setSelected(this),
          e && this.isOnScreen && this.div.focus()));
    }
    remove() {
      (this.#s(), super.remove());
    }
    rebuild() {
      this.parent &&
        (super.rebuild(),
        this.div !== null &&
          (this.#c(), this.#d(this.#e.box), this.isAttachedToDOM || this.parent.add(this)));
    }
    setParent(e) {
      let t = !1;
      (this.parent && !e
        ? (this._uiManager.removeShouldRescale(this), this.#s())
        : e &&
          (this._uiManager.addShouldRescale(this),
          this.#c(e),
          (t = !this.parent && this.div?.classList.contains(`selectedEditor`))),
        super.setParent(e),
        t && this.select());
    }
    #s() {
      this._drawId === null ||
        !this.parent ||
        (this.parent.drawLayer.remove(this._drawId),
        (this._drawId = null),
        this._drawingOptions.reset());
    }
    #c(e = this.parent) {
      if (!(this._drawId !== null && this.parent === e)) {
        if (this._drawId !== null) {
          this.parent.drawLayer.updateParent(this._drawId, e.drawLayer);
          return;
        }
        (this._drawingOptions.updateAll(), (this._drawId = this.#o(this.#e, e)));
      }
    }
    #l([e, t, n, r]) {
      let {
        parentDimensions: [i, a],
        rotation: o,
      } = this;
      switch (o) {
        case 90:
          return [t, 1 - e, (a / i) * n, (i / a) * r];
        case 180:
          return [1 - e, 1 - t, n, r];
        case 270:
          return [1 - t, e, (a / i) * n, (i / a) * r];
        default:
          return [e, t, n, r];
      }
    }
    #u() {
      let {
        x: e,
        y: t,
        width: n,
        height: r,
        parentDimensions: [i, a],
        rotation: o,
      } = this;
      switch (o) {
        case 90:
          return [1 - t, e, (i / a) * n, (a / i) * r];
        case 180:
          return [1 - e, 1 - t, n, r];
        case 270:
          return [t, 1 - e, (i / a) * n, (a / i) * r];
        default:
          return [e, t, n, r];
      }
    }
    #d(e) {
      (([this.x, this.y, this.width, this.height] = this.#l(e)),
        this.div && (this.fixAndSetPosition(), this.setDims()),
        this._onResized());
    }
    #f() {
      let {
        x: e,
        y: t,
        width: n,
        height: r,
        rotation: i,
        parentRotation: a,
        parentDimensions: [o, s],
      } = this;
      switch ((i * 4 + a) / 90) {
        case 1:
          return [1 - t - r, e, r, n];
        case 2:
          return [1 - e - n, 1 - t - r, n, r];
        case 3:
          return [t, 1 - e - n, r, n];
        case 4:
          return [e, t - (o / s) * n, (s / o) * r, (o / s) * n];
        case 5:
          return [1 - t, e, (o / s) * n, (s / o) * r];
        case 6:
          return [1 - e - (s / o) * r, 1 - t, (s / o) * r, (o / s) * n];
        case 7:
          return [t - (o / s) * n, 1 - e - (s / o) * r, (o / s) * n, (s / o) * r];
        case 8:
          return [e - n, t - r, n, r];
        case 9:
          return [1 - t, e - n, r, n];
        case 10:
          return [1 - e, 1 - t, n, r];
        case 11:
          return [t - r, 1 - e, r, n];
        case 12:
          return [e - (s / o) * r, t, (s / o) * r, (o / s) * n];
        case 13:
          return [1 - t - (o / s) * n, e - (s / o) * r, (o / s) * n, (s / o) * r];
        case 14:
          return [1 - e, 1 - t - (o / s) * n, (s / o) * r, (o / s) * n];
        case 15:
          return [t, 1 - e, (o / s) * n, (s / o) * r];
        default:
          return [e, t, n, r];
      }
    }
    rotate() {
      this.parent &&
        this.parent.drawLayer.updateProperties(
          this._drawId,
          e._mergeSVGProperties(
            {
              bbox: this.#f(),
            },
            this.#e.updateRotation((this.parentRotation - this.rotation + 360) % 360),
          ),
        );
    }
    onScaleChanging() {
      this.parent &&
        this.#d(this.#e.updateParentDimensions(this.parentDimensions, this.parent.scale));
    }
    static onScaleChangingWhenDrawing() {}
    render() {
      if (this.div) return this.div;
      let e, t;
      this._isCopy && ((e = this.x), (t = this.y));
      let n = super.render();
      n.classList.add(`draw`);
      let r = document.createElement(`div`);
      return (
        n.append(r),
        r.setAttribute(`aria-hidden`, `true`),
        (r.className = `internal`),
        this.setDims(),
        this._uiManager.addShouldRescale(this),
        this.disableEditing(),
        this._isCopy && this._moveAfterPaste(e, t),
        n
      );
    }
    static createDrawerInstance(e, t, n, r, i) {
      j0(`Not implemented`);
    }
    static startDrawing(t, n, r, i) {
      let { target: a, offsetX: o, offsetY: s, pointerId: c, pointerType: l } = i;
      if (q2.isInitializedAndDifferentPointerType(l)) return;
      let {
          viewport: { rotation: u },
        } = t,
        { width: d, height: f } = a.getBoundingClientRect(),
        p = (e.#r = new AbortController()),
        m = t.combinedSignal(p);
      if (
        (q2.setPointer(l, c),
        window.addEventListener(
          `pointerup`,
          (e) => {
            q2.isSamePointerIdOrRemove(e.pointerId) && this._endDraw(e);
          },
          {
            signal: m,
          },
        ),
        window.addEventListener(
          `pointercancel`,
          (e) => {
            q2.isSamePointerIdOrRemove(e.pointerId) && this._currentParent.endDrawingSession();
          },
          {
            signal: m,
          },
        ),
        window.addEventListener(
          `pointerdown`,
          (t) => {
            q2.isSamePointerType(t.pointerType) &&
              (q2.initializeAndAddPointerId(t.pointerId),
              e.#n.isCancellable() &&
                (e.#n.removeLastElement(),
                e.#n.isEmpty() ? this._currentParent.endDrawingSession(!0) : this._endDraw(null)));
          },
          {
            capture: !0,
            passive: !1,
            signal: m,
          },
        ),
        window.addEventListener(`contextmenu`, b2, {
          signal: m,
        }),
        a.addEventListener(`pointermove`, this._drawMove.bind(this), {
          signal: m,
        }),
        a.addEventListener(
          `touchmove`,
          (e) => {
            q2.isSameTimeStamp(e.timeStamp) && x2(e);
          },
          {
            signal: m,
          },
        ),
        t.toggleDrawing(),
        n._editorUndoBar?.hide(),
        e.#n)
      ) {
        t.drawLayer.updateProperties(this._currentDrawId, e.#n.startNew(o, s, d, f, u));
        return;
      }
      (n.updateUIForDefaultProperties(this),
        (e.#n = this.createDrawerInstance(o, s, d, f, u)),
        (e.#i = this.getDefaultDrawingOptions()),
        (this._currentParent = t),
        ({ id: this._currentDrawId } = t.drawLayer.draw(
          this._mergeSVGProperties(e.#i.toSVGProperties(), e.#n.defaultSVGProperties),
          !0,
          !1,
        )));
    }
    static _drawMove(t) {
      if ((q2.isSameTimeStamp(t.timeStamp), !e.#n)) return;
      let { offsetX: n, offsetY: r, pointerId: i } = t;
      if (q2.isSamePointerId(i)) {
        if (q2.isUsingMultiplePointers()) {
          this._endDraw(t);
          return;
        }
        (this._currentParent.drawLayer.updateProperties(this._currentDrawId, e.#n.add(n, r)),
          q2.setTimeStamp(t.timeStamp),
          x2(t));
      }
    }
    static _cleanup(t) {
      (t &&
        ((this._currentDrawId = -1),
        (this._currentParent = null),
        (e.#n = null),
        (e.#i = null),
        q2.clearTimeStamp()),
        e.#r && (e.#r.abort(), (e.#r = null), q2.clearPointerIds()));
    }
    static _endDraw(t) {
      let n = this._currentParent;
      if (n) {
        if (
          (n.toggleDrawing(!0),
          this._cleanup(!1),
          t?.target === n.div &&
            n.drawLayer.updateProperties(this._currentDrawId, e.#n.end(t.offsetX, t.offsetY)),
          this.supportMultipleDrawings)
        ) {
          let t = e.#n,
            r = this._currentDrawId,
            i = t.getLastElement();
          n.addCommands({
            cmd: () => {
              n.drawLayer.updateProperties(r, t.setLastElement(i));
            },
            undo: () => {
              n.drawLayer.updateProperties(r, t.removeLastElement());
            },
            mustExec: !1,
            type: g0.DRAW_STEP,
          });
          return;
        }
        this.endDrawing(!1);
      }
    }
    static endDrawing(t) {
      let n = this._currentParent;
      if (!n) return null;
      if ((n.toggleDrawing(!0), n.cleanUndoStack(g0.DRAW_STEP), !e.#n.isEmpty())) {
        let {
            pageDimensions: [r, i],
            scale: a,
          } = n,
          o = n.createAndAddNewEditor(
            {
              offsetX: 0,
              offsetY: 0,
            },
            !1,
            {
              drawId: this._currentDrawId,
              drawOutlines: e.#n.getOutlines(r * a, i * a, a, this._INNER_MARGIN),
              drawingOptions: e.#i,
              mustBeCommitted: !t,
            },
          );
        return (this._cleanup(!0), o);
      }
      return (n.drawLayer.remove(this._currentDrawId), this._cleanup(!0), null);
    }
    createDrawingOptions(e) {}
    static deserializeDraw(e, t, n, r, i, a) {
      j0(`Not implemented`);
    }
    static async deserialize(e, t, n) {
      let {
          rawDims: { pageWidth: r, pageHeight: i, pageX: a, pageY: o },
        } = t.viewport,
        s = this.deserializeDraw(a, o, r, i, this._INNER_MARGIN, e),
        c = await super.deserialize(e, t, n);
      return (
        c.createDrawingOptions(e),
        c.#a({
          drawOutlines: s,
        }),
        c.#c(),
        c.onScaleChanging(),
        c.rotate(),
        c
      );
    }
    serializeDraw(e) {
      let [t, n] = this.pageTranslation,
        [r, i] = this.pageDimensions;
      return this.#e.serialize([t, n, r, i], e);
    }
    renderAnnotationElement(e) {
      return (
        e.updateEdited({
          rect: this.getPDFRect(),
        }),
        null
      );
    }
    static canCreateNewEmptyEditor() {
      return !1;
    }
  },
  Uce = class {
    #e = new Float64Array(6);
    #t;
    #n;
    #r;
    #i;
    #a;
    #o = ``;
    #s = 0;
    #c = new $3();
    #l;
    #u;
    constructor(e, t, n, r, i, a) {
      ((this.#l = n), (this.#u = r), (this.#r = i), (this.#i = a), ([e, t] = this.#d(e, t)));
      let o = (this.#t = [NaN, NaN, NaN, NaN, e, t]);
      ((this.#a = [e, t]),
        (this.#n = [
          {
            line: o,
            points: this.#a,
          },
        ]),
        this.#e.set(o, 0));
    }
    updateProperty(e, t) {
      e === `stroke-width` && (this.#i = t);
    }
    #d(e, t) {
      return G3._normalizePoint(e, t, this.#l, this.#u, this.#r);
    }
    isEmpty() {
      return !this.#n || this.#n.length === 0;
    }
    isCancellable() {
      return this.#a.length <= 10;
    }
    add(e, t) {
      [e, t] = this.#d(e, t);
      let [n, r, i, a] = this.#e.subarray(2, 6),
        o = e - i,
        s = t - a;
      return Math.hypot(this.#l * o, this.#u * s) <= 2
        ? null
        : (this.#a.push(e, t),
          isNaN(n)
            ? (this.#e.set([i, a, e, t], 2),
              this.#t.push(NaN, NaN, NaN, NaN, e, t),
              {
                path: {
                  d: this.toSVGPath(),
                },
              })
            : (isNaN(this.#e[0]) && this.#t.splice(6, 6),
              this.#e.set([n, r, i, a, e, t], 0),
              this.#t.push(...G3.createBezierPoints(n, r, i, a, e, t)),
              {
                path: {
                  d: this.toSVGPath(),
                },
              }));
    }
    end(e, t) {
      return (
        this.add(e, t) ||
        (this.#a.length === 2
          ? {
              path: {
                d: this.toSVGPath(),
              },
            }
          : null)
      );
    }
    startNew(e, t, n, r, i) {
      ((this.#l = n), (this.#u = r), (this.#r = i), ([e, t] = this.#d(e, t)));
      let a = (this.#t = [NaN, NaN, NaN, NaN, e, t]);
      this.#a = [e, t];
      let o = this.#n.at(-1);
      return (
        o && ((o.line = new Float32Array(o.line)), (o.points = new Float32Array(o.points))),
        this.#n.push({
          line: a,
          points: this.#a,
        }),
        this.#e.set(a, 0),
        (this.#s = 0),
        this.toSVGPath(),
        null
      );
    }
    getLastElement() {
      return this.#n.at(-1);
    }
    setLastElement(e) {
      return this.#n
        ? (this.#n.push(e),
          (this.#t = e.line),
          (this.#a = e.points),
          (this.#s = 0),
          {
            path: {
              d: this.toSVGPath(),
            },
          })
        : this.#c.setLastElement(e);
    }
    removeLastElement() {
      if (!this.#n) return this.#c.removeLastElement();
      (this.#n.pop(), (this.#o = ``));
      for (let e = 0, t = this.#n.length; e < t; e++) {
        let { line: t, points: n } = this.#n[e];
        ((this.#t = t), (this.#a = n), (this.#s = 0), this.toSVGPath());
      }
      return {
        path: {
          d: this.#o,
        },
      };
    }
    toSVGPath() {
      let e = G3.svgRound(this.#t[4]),
        t = G3.svgRound(this.#t[5]);
      if (this.#a.length === 2) return ((this.#o = `${this.#o} M ${e} ${t} Z`), this.#o);
      if (this.#a.length <= 6) {
        let n = this.#o.lastIndexOf(`M`);
        ((this.#o = `${this.#o.slice(0, n)} M ${e} ${t}`), (this.#s = 6));
      }
      if (this.#a.length === 4) {
        let e = G3.svgRound(this.#t[10]),
          t = G3.svgRound(this.#t[11]);
        return ((this.#o = `${this.#o} L ${e} ${t}`), (this.#s = 12), this.#o);
      }
      let n = [];
      this.#s === 0 && (n.push(`M ${e} ${t}`), (this.#s = 6));
      for (let e = this.#s, t = this.#t.length; e < t; e += 6) {
        let [t, r, i, a, o, s] = this.#t.slice(e, e + 6).map(G3.svgRound);
        n.push(`C${t} ${r} ${i} ${a} ${o} ${s}`);
      }
      return ((this.#o += n.join(` `)), (this.#s = this.#t.length), this.#o);
    }
    getOutlines(e, t, n, r) {
      let i = this.#n.at(-1);
      return (
        (i.line = new Float32Array(i.line)),
        (i.points = new Float32Array(i.points)),
        this.#c.build(this.#n, e, t, n, this.#r, this.#i, r),
        (this.#e = null),
        (this.#t = null),
        (this.#n = null),
        (this.#o = null),
        this.#c
      );
    }
    get defaultSVGProperties() {
      return {
        root: {
          viewBox: `0 0 10000 10000`,
        },
        rootClass: {
          draw: !0,
        },
        bbox: [0, 0, 1, 1],
      };
    }
  },
  $3 = class extends G3 {
    #e;
    #t = 0;
    #n;
    #r;
    #i;
    #a;
    #o;
    #s;
    #c;
    build(e, t, n, r, i, a, o) {
      ((this.#i = t),
        (this.#a = n),
        (this.#o = r),
        (this.#s = i),
        (this.#c = a),
        (this.#n = o ?? 0),
        (this.#r = e),
        this.#d());
    }
    get thickness() {
      return this.#c;
    }
    setLastElement(e) {
      return (
        this.#r.push(e),
        {
          path: {
            d: this.toSVGPath(),
          },
        }
      );
    }
    removeLastElement() {
      return (
        this.#r.pop(),
        {
          path: {
            d: this.toSVGPath(),
          },
        }
      );
    }
    toSVGPath() {
      let e = [];
      for (let { line: t } of this.#r) {
        if ((e.push(`M${G3.svgRound(t[4])} ${G3.svgRound(t[5])}`), t.length === 6)) {
          e.push(`Z`);
          continue;
        }
        if (t.length === 12 && isNaN(t[6])) {
          e.push(`L${G3.svgRound(t[10])} ${G3.svgRound(t[11])}`);
          continue;
        }
        for (let n = 6, r = t.length; n < r; n += 6) {
          let [r, i, a, o, s, c] = t.subarray(n, n + 6).map(G3.svgRound);
          e.push(`C${r} ${i} ${a} ${o} ${s} ${c}`);
        }
      }
      return e.join(``);
    }
    serialize([e, t, n, r], i) {
      let a = [],
        o = [],
        [s, c, l, u] = this.#u(),
        d,
        f,
        p,
        m,
        h,
        g,
        v,
        y,
        b;
      switch (this.#s) {
        case 0:
          ((b = G3._rescale),
            (d = e),
            (f = t + r),
            (p = n),
            (m = -r),
            (h = e + s * n),
            (g = t + (1 - c - u) * r),
            (v = e + (s + l) * n),
            (y = t + (1 - c) * r));
          break;
        case 90:
          ((b = G3._rescaleAndSwap),
            (d = e),
            (f = t),
            (p = n),
            (m = r),
            (h = e + c * n),
            (g = t + s * r),
            (v = e + (c + u) * n),
            (y = t + (s + l) * r));
          break;
        case 180:
          ((b = G3._rescale),
            (d = e + n),
            (f = t),
            (p = -n),
            (m = r),
            (h = e + (1 - s - l) * n),
            (g = t + c * r),
            (v = e + (1 - s) * n),
            (y = t + (c + u) * r));
          break;
        case 270:
          ((b = G3._rescaleAndSwap),
            (d = e + n),
            (f = t + r),
            (p = -n),
            (m = -r),
            (h = e + (1 - c - u) * n),
            (g = t + (1 - s - l) * r),
            (v = e + (1 - c) * n),
            (y = t + (1 - s) * r));
          break;
      }
      for (let { line: e, points: t } of this.#r)
        (a.push(b(e, d, f, p, m, i ? Array(e.length) : null)),
          o.push(b(t, d, f, p, m, i ? Array(t.length) : null)));
      return {
        lines: a,
        points: o,
        rect: [h, g, v, y],
      };
    }
    static deserialize(
      e,
      t,
      n,
      r,
      i,
      { paths: { lines: a, points: o }, rotation: s, thickness: c },
    ) {
      let l = [],
        u,
        d,
        f,
        p,
        m;
      switch (s) {
        case 0:
          ((m = G3._rescale), (u = -e / n), (d = t / r + 1), (f = 1 / n), (p = -1 / r));
          break;
        case 90:
          ((m = G3._rescaleAndSwap), (u = -t / r), (d = -e / n), (f = 1 / r), (p = 1 / n));
          break;
        case 180:
          ((m = G3._rescale), (u = e / n + 1), (d = -t / r), (f = -1 / n), (p = 1 / r));
          break;
        case 270:
          ((m = G3._rescaleAndSwap), (u = t / r + 1), (d = e / n + 1), (f = -1 / r), (p = -1 / n));
          break;
      }
      if (!a) {
        a = [];
        for (let e of o) {
          let t = e.length;
          if (t === 2) {
            a.push(new Float32Array([NaN, NaN, NaN, NaN, e[0], e[1]]));
            continue;
          }
          if (t === 4) {
            a.push(
              new Float32Array([NaN, NaN, NaN, NaN, e[0], e[1], NaN, NaN, NaN, NaN, e[2], e[3]]),
            );
            continue;
          }
          let n = new Float32Array(3 * (t - 2));
          a.push(n);
          let [r, i, o, s] = e.subarray(0, 4);
          n.set([NaN, NaN, NaN, NaN, r, i], 0);
          for (let a = 4; a < t; a += 2) {
            let t = e[a],
              c = e[a + 1];
            (n.set(G3.createBezierPoints(r, i, o, s, t, c), (a - 2) * 3),
              ([r, i, o, s] = [o, s, t, c]));
          }
        }
      }
      for (let e = 0, t = a.length; e < t; e++)
        l.push({
          line: m(
            a[e].map((e) => e ?? NaN),
            u,
            d,
            f,
            p,
          ),
          points: m(
            o[e].map((e) => e ?? NaN),
            u,
            d,
            f,
            p,
          ),
        });
      let h = new this.prototype.constructor();
      return (h.build(l, n, r, 1, s, c, i), h);
    }
    #l(e = this.#c) {
      let t = this.#n + (e / 2) * this.#o;
      return this.#s % 180 == 0 ? [t / this.#i, t / this.#a] : [t / this.#a, t / this.#i];
    }
    #u() {
      let [e, t, n, r] = this.#e,
        [i, a] = this.#l(0);
      return [e + i, t + a, n - 2 * i, r - 2 * a];
    }
    #d() {
      let e = (this.#e = l0.slice());
      for (let { line: t } of this.#r) {
        if (t.length <= 12) {
          for (let n = 4, r = t.length; n < r; n += 6) Y0.pointBoundingBox(t[n], t[n + 1], e);
          continue;
        }
        let n = t[4],
          r = t[5];
        for (let i = 6, a = t.length; i < a; i += 6) {
          let [a, o, s, c, l, u] = t.subarray(i, i + 6);
          (Y0.bezierBoundingBox(n, r, a, o, s, c, l, u, e), (n = l), (r = u));
        }
      }
      let [t, n] = this.#l();
      ((e[0] = o2(e[0] - t, 0, 1)),
        (e[1] = o2(e[1] - n, 0, 1)),
        (e[2] = o2(e[2] + t, 0, 1)),
        (e[3] = o2(e[3] + n, 0, 1)),
        (e[2] -= e[0]),
        (e[3] -= e[1]));
    }
    get box() {
      return this.#e;
    }
    updateProperty(e, t) {
      return e === `stroke-width` ? this.#f(t) : null;
    }
    #f(e) {
      let [t, n] = this.#l();
      this.#c = e;
      let [r, i] = this.#l(),
        [a, o] = [r - t, i - n],
        s = this.#e;
      return ((s[0] -= a), (s[1] -= o), (s[2] += 2 * a), (s[3] += 2 * o), s);
    }
    updateParentDimensions([e, t], n) {
      let [r, i] = this.#l();
      ((this.#i = e), (this.#a = t), (this.#o = n));
      let [a, o] = this.#l(),
        s = a - r,
        c = o - i,
        l = this.#e;
      return ((l[0] -= s), (l[1] -= c), (l[2] += 2 * s), (l[3] += 2 * c), l);
    }
    updateRotation(e) {
      return (
        (this.#t = e),
        {
          path: {
            transform: this.rotationTransform,
          },
        }
      );
    }
    get viewBox() {
      return this.#e.map(G3.svgRound).join(` `);
    }
    get defaultProperties() {
      let [e, t] = this.#e;
      return {
        root: {
          viewBox: this.viewBox,
        },
        path: {
          "transform-origin": `${G3.svgRound(e)} ${G3.svgRound(t)}`,
        },
      };
    }
    get rotationTransform() {
      let [, , e, t] = this.#e,
        n = 0,
        r = 0,
        i = 0,
        a = 0,
        o = 0,
        s = 0;
      switch (this.#t) {
        case 90:
          ((r = t / e), (i = -e / t), (o = e));
          break;
        case 180:
          ((n = -1), (a = -1), (o = e), (s = t));
          break;
        case 270:
          ((r = -t / e), (i = e / t), (s = t));
          break;
        default:
          return ``;
      }
      return `matrix(${n} ${r} ${i} ${a} ${G3.svgRound(o)} ${G3.svgRound(s)})`;
    }
    getPathResizingSVGProperties([e, t, n, r]) {
      let [i, a] = this.#l(),
        [o, s, c, l] = this.#e;
      if (Math.abs(c - i) <= G3.PRECISION || Math.abs(l - a) <= G3.PRECISION) {
        let i = e + n / 2 - (o + c / 2),
          a = t + r / 2 - (s + l / 2);
        return {
          path: {
            "transform-origin": `${G3.svgRound(e)} ${G3.svgRound(t)}`,
            transform: `${this.rotationTransform} translate(${i} ${a})`,
          },
        };
      }
      let u = (n - 2 * i) / (c - 2 * i),
        d = (r - 2 * a) / (l - 2 * a),
        f = c / n,
        p = l / r;
      return {
        path: {
          "transform-origin": `${G3.svgRound(o)} ${G3.svgRound(s)}`,
          transform: `${this.rotationTransform} scale(${f} ${p}) translate(${G3.svgRound(i)} ${G3.svgRound(a)}) scale(${u} ${d}) translate(${G3.svgRound(-i)} ${G3.svgRound(-a)})`,
        },
      };
    }
    getPathResizedSVGProperties([e, t, n, r]) {
      let [i, a] = this.#l(),
        o = this.#e,
        [s, c, l, u] = o;
      if (
        ((o[0] = e),
        (o[1] = t),
        (o[2] = n),
        (o[3] = r),
        Math.abs(l - i) <= G3.PRECISION || Math.abs(u - a) <= G3.PRECISION)
      ) {
        let i = e + n / 2 - (s + l / 2),
          a = t + r / 2 - (c + u / 2);
        for (let { line: e, points: t } of this.#r)
          (G3._translate(e, i, a, e), G3._translate(t, i, a, t));
        return {
          root: {
            viewBox: this.viewBox,
          },
          path: {
            "transform-origin": `${G3.svgRound(e)} ${G3.svgRound(t)}`,
            transform: this.rotationTransform || null,
            d: this.toSVGPath(),
          },
        };
      }
      let d = (n - 2 * i) / (l - 2 * i),
        f = (r - 2 * a) / (u - 2 * a),
        p = -d * (s + i) + e + i,
        m = -f * (c + a) + t + a;
      if (d !== 1 || f !== 1 || p !== 0 || m !== 0)
        for (let { line: e, points: t } of this.#r)
          (G3._rescale(e, p, m, d, f, e), G3._rescale(t, p, m, d, f, t));
      return {
        root: {
          viewBox: this.viewBox,
        },
        path: {
          "transform-origin": `${G3.svgRound(e)} ${G3.svgRound(t)}`,
          transform: this.rotationTransform || null,
          d: this.toSVGPath(),
        },
      };
    }
    getPathTranslatedSVGProperties([e, t], n) {
      let [r, i] = n,
        a = this.#e,
        o = e - a[0],
        s = t - a[1];
      if (this.#i === r && this.#a === i)
        for (let { line: e, points: t } of this.#r)
          (G3._translate(e, o, s, e), G3._translate(t, o, s, t));
      else {
        let e = this.#i / r,
          t = this.#a / i;
        ((this.#i = r), (this.#a = i));
        for (let { line: n, points: r } of this.#r)
          (G3._rescale(n, o, s, e, t, n), G3._rescale(r, o, s, e, t, r));
        ((a[2] *= e), (a[3] *= t));
      }
      return (
        (a[0] = e),
        (a[1] = t),
        {
          root: {
            viewBox: this.viewBox,
          },
          path: {
            d: this.toSVGPath(),
            "transform-origin": `${G3.svgRound(e)} ${G3.svgRound(t)}`,
          },
        }
      );
    }
    get defaultSVGProperties() {
      let e = this.#e;
      return {
        root: {
          viewBox: this.viewBox,
        },
        rootClass: {
          draw: !0,
        },
        path: {
          d: this.toSVGPath(),
          "transform-origin": `${G3.svgRound(e[0])} ${G3.svgRound(e[1])}`,
          transform: this.rotationTransform || null,
        },
        bbox: e,
      };
    }
  },
  e6 = class e extends Z3 {
    constructor(e) {
      (super(),
        (this._viewParameters = e),
        super.updateProperties({
          fill: `none`,
          stroke: n4._defaultLineColor,
          "stroke-opacity": 1,
          "stroke-width": 1,
          "stroke-linecap": `round`,
          "stroke-linejoin": `round`,
          "stroke-miterlimit": 10,
        }));
    }
    updateSVGProperty(e, t) {
      (e === `stroke-width` &&
        ((t ??= this[`stroke-width`]), (t *= this._viewParameters.realScale)),
        super.updateSVGProperty(e, t));
    }
    clone() {
      let t = new e(this._viewParameters);
      return (t.updateAll(this), t);
    }
  },
  Wce = class e extends Q3 {
    static _type = `ink`;
    static _editorType = h0.INK;
    static _defaultDrawingOptions = null;
    constructor(e) {
      (super({
        ...e,
        name: `inkEditor`,
      }),
        (this._willKeepAspectRatio = !0),
        (this.defaultL10nId = `pdfjs-editor-ink-editor`));
    }
    static initialize(e, t) {
      (n4.initialize(e, t), (this._defaultDrawingOptions = new e6(t.viewParameters)));
    }
    static getDefaultDrawingOptions(e) {
      let t = this._defaultDrawingOptions.clone();
      return (t.updateProperties(e), t);
    }
    static get supportMultipleDrawings() {
      return !0;
    }
    static get typesMap() {
      return L0(
        this,
        `typesMap`,
        new Map([
          [g0.INK_THICKNESS, `stroke-width`],
          [g0.INK_COLOR, `stroke`],
          [g0.INK_OPACITY, `stroke-opacity`],
        ]),
      );
    }
    static createDrawerInstance(e, t, n, r, i) {
      return new Uce(e, t, n, r, i, this._defaultDrawingOptions[`stroke-width`]);
    }
    static deserializeDraw(e, t, n, r, i, a) {
      return $3.deserialize(e, t, n, r, i, a);
    }
    static async deserialize(e, t, n) {
      let r = null;
      if (e instanceof B3) {
        let {
          data: {
            inkLists: t,
            rect: n,
            rotation: i,
            id: a,
            color: o,
            opacity: s,
            borderStyle: { rawWidth: c },
            popupRef: l,
            richText: u,
            contentsObj: d,
            creationDate: f,
            modificationDate: p,
          },
          parent: {
            page: { pageNumber: m },
          },
        } = e;
        r = e = {
          annotationType: h0.INK,
          color: Array.from(o),
          thickness: c,
          opacity: s,
          paths: {
            points: t,
          },
          boxes: null,
          pageIndex: m - 1,
          rect: n.slice(0),
          rotation: i,
          annotationElementId: a,
          id: a,
          deleted: !1,
          popupRef: l,
          richText: u,
          comment: d?.str || null,
          creationDate: f,
          modificationDate: p,
        };
      }
      let i = await super.deserialize(e, t, n);
      return ((i._initialData = r), e.comment && i.setCommentData(e), i);
    }
    get toolbarButtons() {
      return ((this._colorPicker ||= new E3(this)), [[`colorPicker`, this._colorPicker]]);
    }
    get colorType() {
      return g0.INK_COLOR;
    }
    get colorAndOpacityType() {
      return g0.INK_COLOR_AND_OPACITY;
    }
    get opacityType() {
      return g0.INK_OPACITY;
    }
    updateParams(e, t) {
      if (e === g0.INK_COLOR_AND_OPACITY) {
        this._updateColorAndOpacity(t.color, t.opacity);
        return;
      }
      super.updateParams(e, t);
    }
    static updateDefaultParams(e, t) {
      if (e === g0.INK_COLOR_AND_OPACITY) {
        (super.updateDefaultParams(g0.INK_COLOR, t.color),
          super.updateDefaultParams(g0.INK_OPACITY, t.opacity));
        return;
      }
      super.updateDefaultParams(e, t);
    }
    get color() {
      return this._drawingOptions.stroke;
    }
    get opacity() {
      return this._drawingOptions[`stroke-opacity`];
    }
    onScaleChanging() {
      if (!this.parent) return;
      super.onScaleChanging();
      let { _drawId: e, _drawingOptions: t, parent: n } = this;
      (t.updateSVGProperty(`stroke-width`), n.drawLayer.updateProperties(e, t.toSVGProperties()));
    }
    static onScaleChangingWhenDrawing() {
      let e = this._currentParent;
      e &&
        (super.onScaleChangingWhenDrawing(),
        this._defaultDrawingOptions.updateSVGProperty(`stroke-width`),
        e.drawLayer.updateProperties(
          this._currentDrawId,
          this._defaultDrawingOptions.toSVGProperties(),
        ));
    }
    createDrawingOptions({ color: t, thickness: n, opacity: r }) {
      this._drawingOptions = e.getDefaultDrawingOptions({
        stroke: Y0.makeHexColor(...t),
        "stroke-width": n,
        "stroke-opacity": r,
      });
    }
    serialize(e = !1) {
      if (this.isEmpty()) return null;
      if (this.deleted) return this.serializeDeleted();
      let { lines: t, points: n } = this.serializeDraw(e),
        {
          _drawingOptions: { stroke: r, "stroke-opacity": i, "stroke-width": a },
        } = this,
        o = Object.assign(super.serialize(e), {
          color: n4._colorManager.convert(r),
          opacity: i,
          thickness: a,
          paths: {
            lines: t,
            points: n,
          },
        });
      return (
        this.addComment(o),
        e
          ? ((o.isCopy = !0), o)
          : this.annotationElementId && !this.#e(o)
            ? null
            : ((o.id = this.annotationElementId), o)
      );
    }
    #e(e) {
      let { color: t, thickness: n, opacity: r, pageIndex: i } = this._initialData;
      return (
        this.hasEditedComment ||
        this._hasBeenMoved ||
        this._hasBeenResized ||
        e.color.some((e, n) => e !== t[n]) ||
        e.thickness !== n ||
        e.opacity !== r ||
        e.pageIndex !== i
      );
    }
    renderAnnotationElement(e) {
      if (this.deleted) return (e.hide(), null);
      let { points: t, rect: n } = this.serializeDraw(!1);
      return (
        e.updateEdited({
          rect: n,
          thickness: this._drawingOptions[`stroke-width`],
          points: t,
          popup: this.comment,
        }),
        null
      );
    }
  },
  t6 = class extends $3 {
    toSVGPath() {
      let e = super.toSVGPath();
      return (e.endsWith(`Z`) || (e += `Z`), e);
    }
  },
  n6 = 8,
  r6 = 3,
  i6 = class {
    static #e = {
      maxDim: 512,
      sigmaSFactor: 0.02,
      sigmaR: 25,
      kernelSize: 16,
    };
    static #t(e, t, n, r) {
      return ((n -= e), (r -= t), n === 0 ? (r > 0 ? 0 : 4) : n === 1 ? r + 6 : 2 - r);
    }
    static #n = new Int32Array([0, 1, -1, 1, -1, 0, -1, -1, 0, -1, 1, -1, 1, 0, 1, 1]);
    static #r(e, t, n, r, i, a, o) {
      let s = this.#t(n, r, i, a);
      for (let i = 0; i < 8; i++) {
        let a = (-i + s - o + 16) % 8,
          c = this.#n[2 * a],
          l = this.#n[2 * a + 1];
        if (e[(n + c) * t + (r + l)] !== 0) return a;
      }
      return -1;
    }
    static #i(e, t, n, r, i, a, o) {
      let s = this.#t(n, r, i, a);
      for (let i = 0; i < 8; i++) {
        let a = (i + s + o + 16) % 8,
          c = this.#n[2 * a],
          l = this.#n[2 * a + 1];
        if (e[(n + c) * t + (r + l)] !== 0) return a;
      }
      return -1;
    }
    static #a(e, t, n, r) {
      let i = e.length,
        a = new Int32Array(i);
      for (let t = 0; t < i; t++) a[t] = +(e[t] <= r);
      for (let e = 1; e < n - 1; e++) a[e * t] = a[e * t + t - 1] = 0;
      for (let e = 0; e < t; e++) a[e] = a[t * n - 1 - e] = 0;
      let o = 1,
        s,
        c = [];
      for (let e = 1; e < n - 1; e++) {
        s = 1;
        for (let n = 1; n < t - 1; n++) {
          let r = e * t + n,
            i = a[r];
          if (i === 0) continue;
          let l = e,
            u = n;
          if (i === 1 && a[r - 1] === 0) ((o += 1), --u);
          else if (i >= 1 && a[r + 1] === 0) ((o += 1), (u += 1), i > 1 && (s = i));
          else {
            i !== 1 && (s = Math.abs(i));
            continue;
          }
          let d = [n, e],
            f = u === n + 1,
            p = {
              isHole: f,
              points: d,
              id: o,
              parent: 0,
            };
          c.push(p);
          let m;
          for (let e of c)
            if (e.id === s) {
              m = e;
              break;
            }
          m
            ? m.isHole
              ? (p.parent = f ? m.parent : s)
              : (p.parent = f ? s : m.parent)
            : (p.parent = f ? s : 0);
          let h = this.#r(a, t, e, n, l, u, 0);
          if (h === -1) {
            ((a[r] = -o), a[r] !== 1 && (s = Math.abs(a[r])));
            continue;
          }
          let g = this.#n[2 * h],
            v = this.#n[2 * h + 1],
            y = e + g,
            b = n + v;
          ((l = y), (u = b));
          let x = e,
            S = n;
          for (;;) {
            let i = this.#i(a, t, x, S, l, u, 1);
            ((g = this.#n[2 * i]), (v = this.#n[2 * i + 1]));
            let c = x + g,
              f = S + v;
            d.push(f, c);
            let p = x * t + S;
            if (
              (a[p + 1] === 0 ? (a[p] = -o) : a[p] === 1 && (a[p] = o),
              c === e && f === n && x === y && S === b)
            ) {
              a[r] !== 1 && (s = Math.abs(a[r]));
              break;
            } else ((l = x), (u = S), (x = c), (S = f));
          }
        }
      }
      return c;
    }
    static #o(e, t, n, r) {
      if (n - t <= 4) {
        for (let i = t; i < n - 2; i += 2) r.push(e[i], e[i + 1]);
        return;
      }
      let i = e[t],
        a = e[t + 1],
        o = e[n - 4] - i,
        s = e[n - 3] - a,
        c = Math.hypot(o, s),
        l = o / c,
        u = s / c,
        d = l * a - u * i,
        f = s / o,
        p = 1 / c,
        m = Math.atan(f),
        h = Math.cos(m),
        g = Math.sin(m),
        v = p * (Math.abs(h) + Math.abs(g)),
        y = p * (1 - v + v ** 2),
        b = Math.max(Math.atan(Math.abs(g + h) * y), Math.atan(Math.abs(g - h) * y)),
        x = 0,
        S = t;
      for (let r = t + 2; r < n - 2; r += 2) {
        let t = Math.abs(d - l * e[r + 1] + u * e[r]);
        t > x && ((S = r), (x = t));
      }
      x > (c * b) ** 2 ? (this.#o(e, t, S + 2, r), this.#o(e, S, n, r)) : r.push(i, a);
    }
    static #s(e) {
      let t = [],
        n = e.length;
      return (this.#o(e, 0, n, t), t.push(e[n - 2], e[n - 1]), t.length <= 4 ? null : t);
    }
    static #c(e, t, n, r, i, a) {
      let o = new Float32Array(a ** 2),
        s = -2 * r ** 2,
        c = a >> 1;
      for (let e = 0; e < a; e++) {
        let t = (e - c) ** 2;
        for (let n = 0; n < a; n++) o[e * a + n] = Math.exp((t + (n - c) ** 2) / s);
      }
      let l = new Float32Array(256),
        u = -2 * i ** 2;
      for (let e = 0; e < 256; e++) l[e] = Math.exp(e ** 2 / u);
      let d = e.length,
        f = new Uint8Array(d),
        p = new Uint32Array(256);
      for (let r = 0; r < n; r++)
        for (let i = 0; i < t; i++) {
          let s = r * t + i,
            u = e[s],
            d = 0,
            m = 0;
          for (let s = 0; s < a; s++) {
            let f = r + s - c;
            if (!(f < 0 || f >= n))
              for (let n = 0; n < a; n++) {
                let r = i + n - c;
                if (r < 0 || r >= t) continue;
                let p = e[f * t + r],
                  h = o[s * a + n] * l[Math.abs(p - u)];
                ((d += p * h), (m += h));
              }
          }
          let h = (f[s] = Math.round(d / m));
          p[h]++;
        }
      return [f, p];
    }
    static #l(e) {
      let t = new Uint32Array(256);
      for (let n of e) t[n]++;
      return t;
    }
    static #u(e) {
      let t = e.length,
        n = new Uint8ClampedArray(t >> 2),
        r = -1 / 0,
        i = 1 / 0;
      for (let t = 0, a = n.length; t < a; t++) {
        let a = (n[t] = e[t << 2]);
        ((r = Math.max(r, a)), (i = Math.min(i, a)));
      }
      let a = 255 / (r - i);
      for (let e = 0, t = n.length; e < t; e++) n[e] = (n[e] - i) * a;
      return n;
    }
    static #d(e) {
      let t,
        n = -1 / 0,
        r = -1 / 0,
        i = e.findIndex((e) => e !== 0),
        a = i,
        o = i;
      for (t = i; t < 256; t++) {
        let i = e[t];
        i > n && (t - a > r && ((r = t - a), (o = t - 1)), (n = i), (a = t));
      }
      for (t = o - 1; t >= 0 && !(e[t] > e[t + 1]); t--);
      return t;
    }
    static #f(e) {
      let t = e,
        { width: n, height: r } = e,
        { maxDim: i } = this.#e,
        a = n,
        o = r;
      if (n > i || r > i) {
        let s = n,
          c = r,
          l = Math.log2(Math.max(n, r) / i),
          u = Math.floor(l);
        l = l === u ? u - 1 : u;
        for (let n = 0; n < l; n++) {
          ((a = Math.ceil(s / 2)), (o = Math.ceil(c / 2)));
          let n = new OffscreenCanvas(a, o);
          (n.getContext(`2d`).drawImage(e, 0, 0, s, c, 0, 0, a, o),
            (s = a),
            (c = o),
            e !== t && e.close(),
            (e = n.transferToImageBitmap()));
        }
        let d = Math.min(i / a, i / o);
        ((a = Math.round(a * d)), (o = Math.round(o * d)));
      }
      let s = new OffscreenCanvas(a, o).getContext(`2d`, {
        willReadFrequently: !0,
      });
      ((s.fillStyle = `white`),
        s.fillRect(0, 0, a, o),
        (s.filter = `grayscale(1)`),
        s.drawImage(e, 0, 0, e.width, e.height, 0, 0, a, o));
      let c = s.getImageData(0, 0, a, o).data;
      return [this.#u(c), a, o];
    }
    static extractContoursFromText(e, { fontFamily: t, fontStyle: n, fontWeight: r }, i, a, o, s) {
      let c = new OffscreenCanvas(1, 1),
        l = c.getContext(`2d`, {
          alpha: !1,
        }),
        u = (l.font = `${n} ${r} 200px ${t}`),
        {
          actualBoundingBoxLeft: d,
          actualBoundingBoxRight: f,
          actualBoundingBoxAscent: p,
          actualBoundingBoxDescent: m,
          fontBoundingBoxAscent: h,
          fontBoundingBoxDescent: g,
          width: v,
        } = l.measureText(e),
        y = 1.5,
        b = Math.ceil(Math.max(Math.abs(d) + Math.abs(f) || 0, v) * y),
        x = Math.ceil(
          Math.max(Math.abs(p) + Math.abs(m) || 200, Math.abs(h) + Math.abs(g) || 200) * y,
        );
      ((c = new OffscreenCanvas(b, x)),
        (l = c.getContext(`2d`, {
          alpha: !0,
          willReadFrequently: !0,
        })),
        (l.font = u),
        (l.filter = `grayscale(1)`),
        (l.fillStyle = `white`),
        l.fillRect(0, 0, b, x),
        (l.fillStyle = `black`),
        l.fillText(e, (b * (y - 1)) / 2, (x * (3 - y)) / 2));
      let S = this.#u(l.getImageData(0, 0, b, x).data),
        C = this.#l(S),
        w = this.#d(C),
        T = this.#a(S, b, x, w);
      return this.processDrawnLines({
        lines: {
          curves: T,
          width: b,
          height: x,
        },
        pageWidth: i,
        pageHeight: a,
        rotation: o,
        innerMargin: s,
        mustSmooth: !0,
        areContours: !0,
      });
    }
    static process(e, t, n, r, i) {
      let [a, o, s] = this.#f(e),
        [c, l] = this.#c(
          a,
          o,
          s,
          Math.hypot(o, s) * this.#e.sigmaSFactor,
          this.#e.sigmaR,
          this.#e.kernelSize,
        ),
        u = this.#d(l),
        d = this.#a(c, o, s, u);
      return this.processDrawnLines({
        lines: {
          curves: d,
          width: o,
          height: s,
        },
        pageWidth: t,
        pageHeight: n,
        rotation: r,
        innerMargin: i,
        mustSmooth: !0,
        areContours: !0,
      });
    }
    static processDrawnLines({
      lines: e,
      pageWidth: t,
      pageHeight: n,
      rotation: r,
      innerMargin: i,
      mustSmooth: a,
      areContours: o,
    }) {
      r % 180 != 0 && ([t, n] = [n, t]);
      let { curves: s, width: c, height: l } = e,
        u = e.thickness ?? 0,
        d = [],
        f = Math.min(t / c, n / l),
        p = f / t,
        m = f / n,
        h = [];
      for (let { points: e } of s) {
        let t = a ? this.#s(e) : e;
        if (!t) continue;
        h.push(t);
        let n = t.length,
          r = new Float32Array(n),
          i = new Float32Array(3 * (n === 2 ? 2 : n - 2));
        if (
          (d.push({
            line: i,
            points: r,
          }),
          n === 2)
        ) {
          ((r[0] = t[0] * p), (r[1] = t[1] * m), i.set([NaN, NaN, NaN, NaN, r[0], r[1]], 0));
          continue;
        }
        let [o, s, c, l] = t;
        ((o *= p),
          (s *= m),
          (c *= p),
          (l *= m),
          r.set([o, s, c, l], 0),
          i.set([NaN, NaN, NaN, NaN, o, s], 0));
        for (let e = 4; e < n; e += 2) {
          let n = (r[e] = t[e] * p),
            a = (r[e + 1] = t[e + 1] * m);
          (i.set(G3.createBezierPoints(o, s, c, l, n, a), (e - 2) * 3),
            ([o, s, c, l] = [c, l, n, a]));
        }
      }
      if (d.length === 0) return null;
      let g = o ? new t6() : new $3();
      return (
        g.build(d, t, n, 1, r, o ? 0 : u, i),
        {
          outline: g,
          newCurves: h,
          areContours: o,
          thickness: u,
          width: c,
          height: l,
        }
      );
    }
    static async compressSignature({
      outlines: e,
      areContours: t,
      thickness: n,
      width: r,
      height: i,
    }) {
      let a = 1 / 0,
        o = -1 / 0,
        s = 0;
      for (let t of e) {
        s += t.length;
        for (let e = 2, n = t.length; e < n; e++) {
          let n = t[e] - t[e - 2];
          ((a = Math.min(a, n)), (o = Math.max(o, n)));
        }
      }
      let c;
      c = a >= -128 && o <= 127 ? Int8Array : a >= -32768 && o <= 32767 ? Int16Array : Int32Array;
      let l = e.length,
        u = n6 + r6 * l,
        d = new Uint32Array(u),
        f = 0;
      ((d[f++] = u * Uint32Array.BYTES_PER_ELEMENT + (s - 2 * l) * c.BYTES_PER_ELEMENT),
        (d[f++] = 0),
        (d[f++] = r),
        (d[f++] = i),
        (d[f++] = +!t),
        (d[f++] = Math.max(0, Math.floor(n ?? 0))),
        (d[f++] = l),
        (d[f++] = c.BYTES_PER_ELEMENT));
      for (let t of e) ((d[f++] = t.length - 2), (d[f++] = t[0]), (d[f++] = t[1]));
      let p = new CompressionStream(`deflate-raw`),
        m = p.writable.getWriter();
      (await m.ready, m.write(d));
      let h = c.prototype.constructor;
      for (let t of e) {
        let e = new h(t.length - 2);
        for (let n = 2, r = t.length; n < r; n++) e[n - 2] = t[n] - t[n - 2];
        m.write(e);
      }
      return (m.close(), (await new Response(p.readable).bytes()).toBase64());
    }
    static async decompressSignature(e) {
      try {
        let t = Uint8Array.fromBase64(e),
          { readable: n, writable: r } = new DecompressionStream(`deflate-raw`),
          i = r.getWriter();
        (await i.ready,
          i
            .write(t)
            .then(async () => {
              (await i.ready, await i.close());
            })
            .catch(() => {}));
        let a = null,
          o = 0;
        for await (let e of n)
          ((a ||= new Uint8Array(new Uint32Array(e.buffer, 0, 4)[0])),
            a.set(e, o),
            (o += e.length));
        let s = new Uint32Array(a.buffer, 0, a.length >> 2),
          c = s[1];
        if (c !== 0) throw Error(`Invalid version: ${c}`);
        let l = s[2],
          u = s[3],
          d = s[4] === 0,
          f = s[5],
          p = s[6],
          m = s[7],
          h = [],
          g = (n6 + r6 * p) * Uint32Array.BYTES_PER_ELEMENT,
          v;
        switch (m) {
          case Int8Array.BYTES_PER_ELEMENT:
            v = new Int8Array(a.buffer, g);
            break;
          case Int16Array.BYTES_PER_ELEMENT:
            v = new Int16Array(a.buffer, g);
            break;
          case Int32Array.BYTES_PER_ELEMENT:
            v = new Int32Array(a.buffer, g);
            break;
        }
        o = 0;
        for (let e = 0; e < p; e++) {
          let t = s[r6 * e + n6],
            n = new Float32Array(t + 2);
          h.push(n);
          for (let t = 0; t < r6 - 1; t++) n[t] = s[r6 * e + n6 + t + 1];
          for (let e = 0; e < t; e++) n[e + 2] = n[e] + v[o++];
        }
        return {
          areContours: d,
          thickness: f,
          outlines: h,
          width: l,
          height: u,
        };
      } catch (e) {
        return (A0(`decompressSignature: ${e}`), null);
      }
    }
  },
  Gce = class e extends Z3 {
    constructor() {
      (super(),
        super.updateProperties({
          fill: n4._defaultLineColor,
          "stroke-width": 0,
        }));
    }
    clone() {
      let t = new e();
      return (t.updateAll(this), t);
    }
  },
  Kce = class e extends e6 {
    constructor(e) {
      (super(e),
        super.updateProperties({
          stroke: n4._defaultLineColor,
          "stroke-width": 1,
        }));
    }
    clone() {
      let t = new e(this._viewParameters);
      return (t.updateAll(this), t);
    }
  },
  qce = class e extends Q3 {
    #e = !1;
    #t = null;
    #n = null;
    #r = null;
    static _type = `signature`;
    static _editorType = h0.SIGNATURE;
    static _defaultDrawingOptions = null;
    constructor(e) {
      (super({
        ...e,
        mustBeCommitted: !0,
        name: `signatureEditor`,
      }),
        (this._willKeepAspectRatio = !0),
        (this.#n = e.signatureData || null),
        (this.#t = null),
        (this.defaultL10nId = `pdfjs-editor-signature-editor1`));
    }
    static initialize(e, t) {
      (n4.initialize(e, t),
        (this._defaultDrawingOptions = new Gce()),
        (this._defaultDrawnSignatureOptions = new Kce(t.viewParameters)));
    }
    static getDefaultDrawingOptions(e) {
      let t = this._defaultDrawingOptions.clone();
      return (t.updateProperties(e), t);
    }
    static get supportMultipleDrawings() {
      return !1;
    }
    static get typesMap() {
      return L0(this, `typesMap`, new Map());
    }
    static get isDrawer() {
      return !1;
    }
    get telemetryFinalData() {
      return {
        type: `signature`,
        hasDescription: !!this.#t,
      };
    }
    static computeTelemetryFinalData(e) {
      let t = e.get(`hasDescription`);
      return {
        hasAltText: t.get(!0) ?? 0,
        hasNoAltText: t.get(!1) ?? 0,
      };
    }
    get isResizable() {
      return !0;
    }
    onScaleChanging() {
      this._drawId !== null && super.onScaleChanging();
    }
    render() {
      if (this.div) return this.div;
      let t,
        n,
        { _isCopy: r } = this;
      if (
        (r && ((this._isCopy = !1), (t = this.x), (n = this.y)),
        super.render(),
        this._drawId === null)
      ) {
        if (this.#n) {
          let {
              lines: t,
              mustSmooth: n,
              areContours: r,
              description: i,
              uuid: a,
              heightInPage: o,
            } = this.#n,
            {
              rawDims: { pageWidth: s, pageHeight: c },
              rotation: l,
            } = this.parent.viewport,
            u = i6.processDrawnLines({
              lines: t,
              pageWidth: s,
              pageHeight: c,
              rotation: l,
              innerMargin: e._INNER_MARGIN,
              mustSmooth: n,
              areContours: r,
            });
          this.addSignature(u, o, i, a);
        } else
          (this.div.setAttribute(
            `data-l10n-args`,
            JSON.stringify({
              description: ``,
            }),
          ),
            (this.div.hidden = !0),
            this._uiManager.getSignature(this));
      } else
        this.div.setAttribute(
          `data-l10n-args`,
          JSON.stringify({
            description: this.#t || ``,
          }),
        );
      return (r && ((this._isCopy = !0), this._moveAfterPaste(t, n)), this.div);
    }
    setUuid(e) {
      ((this.#r = e), this.addEditToolbar());
    }
    getUuid() {
      return this.#r;
    }
    get description() {
      return this.#t;
    }
    set description(e) {
      ((this.#t = e),
        this.div &&
          (this.div.setAttribute(
            `data-l10n-args`,
            JSON.stringify({
              description: e,
            }),
          ),
          super.addEditToolbar().then((t) => {
            t?.updateEditSignatureButton(e);
          })));
    }
    getSignaturePreview() {
      let { newCurves: e, areContours: t, thickness: n, width: r, height: i } = this.#n,
        a = Math.max(r, i);
      return {
        areContours: t,
        outline: i6.processDrawnLines({
          lines: {
            curves: e.map((e) => ({
              points: e,
            })),
            thickness: n,
            width: r,
            height: i,
          },
          pageWidth: a,
          pageHeight: a,
          rotation: 0,
          innerMargin: 0,
          mustSmooth: !1,
          areContours: t,
        }).outline,
      };
    }
    get toolbarButtons() {
      return this._uiManager.signatureManager
        ? [[`editSignature`, this._uiManager.signatureManager]]
        : super.toolbarButtons;
    }
    addSignature(t, n, r, i) {
      let { x: a, y: o } = this,
        { outline: s } = (this.#n = t);
      ((this.#e = s instanceof t6), (this.description = r));
      let c;
      (this.#e
        ? (c = e.getDefaultDrawingOptions())
        : ((c = e._defaultDrawnSignatureOptions.clone()),
          c.updateProperties({
            "stroke-width": s.thickness,
          })),
        this._addOutlines({
          drawOutlines: s,
          drawingOptions: c,
        }));
      let [, l] = this.pageDimensions,
        u = n / l;
      ((u = u >= 1 ? 0.5 : u),
        (this.width *= u / this.height),
        this.width >= 1 && ((u *= 0.9 / this.width), (this.width = 0.9)),
        (this.height = u),
        this.setDims(),
        (this.x = a),
        (this.y = o),
        this.center(),
        this._onResized(),
        this.onScaleChanging(),
        this.rotate(),
        this._uiManager.addToAnnotationStorage(this),
        this.setUuid(i),
        this._reportTelemetry({
          action: `pdfjs.signature.inserted`,
          data: {
            hasBeenSaved: !!i,
            hasDescription: !!r,
          },
        }),
        (this.div.hidden = !1));
    }
    getFromImage(t) {
      let {
        rawDims: { pageWidth: n, pageHeight: r },
        rotation: i,
      } = this.parent.viewport;
      return i6.process(t, n, r, i, e._INNER_MARGIN);
    }
    getFromText(t, n) {
      let {
        rawDims: { pageWidth: r, pageHeight: i },
        rotation: a,
      } = this.parent.viewport;
      return i6.extractContoursFromText(t, n, r, i, a, e._INNER_MARGIN);
    }
    getDrawnSignature(t) {
      let {
        rawDims: { pageWidth: n, pageHeight: r },
        rotation: i,
      } = this.parent.viewport;
      return i6.processDrawnLines({
        lines: t,
        pageWidth: n,
        pageHeight: r,
        rotation: i,
        innerMargin: e._INNER_MARGIN,
        mustSmooth: !1,
        areContours: !1,
      });
    }
    createDrawingOptions({ areContours: t, thickness: n }) {
      t
        ? (this._drawingOptions = e.getDefaultDrawingOptions())
        : ((this._drawingOptions = e._defaultDrawnSignatureOptions.clone()),
          this._drawingOptions.updateProperties({
            "stroke-width": n,
          }));
    }
    serialize(e = !1) {
      if (this.isEmpty()) return null;
      let { lines: t, points: n } = this.serializeDraw(e),
        {
          _drawingOptions: { "stroke-width": r },
        } = this,
        i = Object.assign(super.serialize(e), {
          isSignature: !0,
          areContours: this.#e,
          color: [0, 0, 0],
          thickness: this.#e ? 0 : r,
        });
      return (
        this.addComment(i),
        e
          ? ((i.paths = {
              lines: t,
              points: n,
            }),
            (i.uuid = this.#r),
            (i.isCopy = !0))
          : (i.lines = t),
        this.#t &&
          (i.accessibilityData = {
            type: `Figure`,
            alt: this.#t,
          }),
        i
      );
    }
    static deserializeDraw(e, t, n, r, i, a) {
      return a.areContours ? t6.deserialize(e, t, n, r, i, a) : $3.deserialize(e, t, n, r, i, a);
    }
    static async deserialize(e, t, n) {
      let r = await super.deserialize(e, t, n);
      return (
        (r.#e = e.areContours),
        (r.description = e.accessibilityData?.alt || ``),
        (r.#r = e.uuid),
        r
      );
    }
  },
  Jce = class extends n4 {
    #e = null;
    #t = null;
    #n = null;
    #r = null;
    #i = null;
    #a = ``;
    #o = null;
    #s = !1;
    #c = null;
    #l = !1;
    #u = !1;
    static _type = `stamp`;
    static _editorType = h0.STAMP;
    constructor(e) {
      (super({
        ...e,
        name: `stampEditor`,
      }),
        (this.#r = e.bitmapUrl),
        (this.#i = e.bitmapFile),
        (this.defaultL10nId = `pdfjs-editor-stamp-editor`));
    }
    static initialize(e, t) {
      n4.initialize(e, t);
    }
    static isHandlingMimeForPasting(e) {
      return M2.includes(e);
    }
    static paste(e, t) {
      t.pasteEditor(
        {
          mode: h0.STAMP,
        },
        {
          bitmapFile: e.getAsFile(),
        },
      );
    }
    altTextFinish() {
      (this._uiManager.useNewAltTextFlow && (this.div.hidden = !1), super.altTextFinish());
    }
    get telemetryFinalData() {
      return {
        type: `stamp`,
        hasAltText: !!this.altTextData?.altText,
      };
    }
    static computeTelemetryFinalData(e) {
      let t = e.get(`hasAltText`);
      return {
        hasAltText: t.get(!0) ?? 0,
        hasNoAltText: t.get(!1) ?? 0,
      };
    }
    #d(e, t = !1) {
      if (!e) {
        this.remove();
        return;
      }
      ((this.#e = e.bitmap),
        t || ((this.#t = e.id), (this.#l = e.isSvg)),
        e.file && (this.#a = e.file.name),
        this.#m());
    }
    #f() {
      if (((this.#n = null), this._uiManager.enableWaiting(!1), this.#o)) {
        if (
          this._uiManager.useNewAltTextWhenAddingImage &&
          this._uiManager.useNewAltTextFlow &&
          this.#e
        ) {
          this.addEditToolbar().then(() => {
            (this._editToolbar.hide(), this._uiManager.editAltText(this, !0));
          });
          return;
        }
        if (
          !this._uiManager.useNewAltTextWhenAddingImage &&
          this._uiManager.useNewAltTextFlow &&
          this.#e
        ) {
          this._reportTelemetry({
            action: `pdfjs.image.image_added`,
            data: {
              alt_text_modal: !1,
              alt_text_type: `empty`,
            },
          });
          try {
            this.mlGuessAltText();
          } catch {}
        }
        this.div.focus();
      }
    }
    async mlGuessAltText(e = null, t = !0) {
      if (this.hasAltTextData()) return null;
      let { mlManager: n } = this._uiManager;
      if (!n) throw Error(`No ML.`);
      if (!(await n.isEnabledFor(`altText`))) throw Error(`ML isn't enabled for alt text.`);
      let { data: r, width: i, height: a } = e || this.copyCanvas(null, null, !0).imageData,
        o = await n.guess({
          name: `altText`,
          request: {
            data: r,
            width: i,
            height: a,
            channels: r.length / (i * a),
          },
        });
      if (!o) throw Error(`No response from the AI service.`);
      if (o.error) throw Error(`Error from the AI service.`);
      if (o.cancel) return null;
      if (!o.output) throw Error(`No valid response from the AI service.`);
      let s = o.output;
      return (
        await this.setGuessedAltText(s),
        t &&
          !this.hasAltTextData() &&
          (this.altTextData = {
            alt: s,
            decorative: !1,
          }),
        s
      );
    }
    #p() {
      if (this.#t) {
        (this._uiManager.enableWaiting(!0),
          this._uiManager.imageManager
            .getFromId(this.#t)
            .then((e) => this.#d(e, !0))
            .finally(() => this.#f()));
        return;
      }
      if (this.#r) {
        let e = this.#r;
        ((this.#r = null),
          this._uiManager.enableWaiting(!0),
          (this.#n = this._uiManager.imageManager
            .getFromUrl(e)
            .then((e) => this.#d(e))
            .finally(() => this.#f())));
        return;
      }
      if (this.#i) {
        let e = this.#i;
        ((this.#i = null),
          this._uiManager.enableWaiting(!0),
          (this.#n = this._uiManager.imageManager
            .getFromFile(e)
            .then((e) => this.#d(e))
            .finally(() => this.#f())));
        return;
      }
      let e = document.createElement(`input`);
      ((e.type = `file`), (e.accept = M2.join(`,`)));
      let t = this._uiManager._signal;
      ((this.#n = new Promise((n) => {
        (e.addEventListener(
          `change`,
          async () => {
            if (!e.files || e.files.length === 0) this.remove();
            else {
              this._uiManager.enableWaiting(!0);
              let t = await this._uiManager.imageManager.getFromFile(e.files[0]);
              (this._reportTelemetry({
                action: `pdfjs.image.image_selected`,
                data: {
                  alt_text_modal: this._uiManager.useNewAltTextFlow,
                },
              }),
                this.#d(t));
            }
            n();
          },
          {
            signal: t,
          },
        ),
          e.addEventListener(
            `cancel`,
            () => {
              (this.remove(), n());
            },
            {
              signal: t,
            },
          ));
      }).finally(() => this.#f())),
        e.click());
    }
    remove() {
      (this.#t &&
        ((this.#e = null),
        this._uiManager.imageManager.deleteId(this.#t),
        this.#o?.remove(),
        (this.#o = null),
        (this.#c &&= (clearTimeout(this.#c), null))),
        super.remove());
    }
    rebuild() {
      if (!this.parent) {
        this.#t && this.#p();
        return;
      }
      (super.rebuild(),
        this.div !== null &&
          (this.#t && this.#o === null && this.#p(),
          this.isAttachedToDOM || this.parent.add(this)));
    }
    onceAdded(e) {
      ((this._isDraggable = !0), e && this.div.focus());
    }
    isEmpty() {
      return !(this.#n || this.#e || this.#r || this.#i || this.#t || this.#s);
    }
    get toolbarButtons() {
      return [[`altText`, this.createAltText()]];
    }
    get isResizable() {
      return !0;
    }
    render() {
      if (this.div) return this.div;
      let e, t;
      return (
        this._isCopy && ((e = this.x), (t = this.y)),
        super.render(),
        (this.div.hidden = !0),
        this.createAltText(),
        this.#s || (this.#e ? this.#m() : this.#p()),
        this._isCopy && this._moveAfterPaste(e, t),
        this._uiManager.addShouldRescale(this),
        this.div
      );
    }
    setCanvas(e, t) {
      let { id: n, bitmap: r } = this._uiManager.imageManager.getFromCanvas(e, t);
      (t.remove(),
        n &&
          this._uiManager.imageManager.isValidId(n) &&
          ((this.#t = n), r && (this.#e = r), (this.#s = !1), this.#m()));
    }
    _onResized() {
      this.onScaleChanging();
    }
    onScaleChanging() {
      this.parent &&
        (this.#c !== null && clearTimeout(this.#c),
        (this.#c = setTimeout(() => {
          ((this.#c = null), this.#g());
        }, 200)));
    }
    #m() {
      let { div: e } = this,
        { width: t, height: n } = this.#e,
        [r, i] = this.pageDimensions,
        a = 0.75;
      if (this.width) ((t = this.width * r), (n = this.height * i));
      else if (t > a * r || n > a * i) {
        let e = Math.min((a * r) / t, (a * i) / n);
        ((t *= e), (n *= e));
      }
      this._uiManager.enableWaiting(!1);
      let o = (this.#o = document.createElement(`canvas`));
      (o.setAttribute(`role`, `img`),
        this.addContainer(o),
        (this.width = t / r),
        (this.height = n / i),
        this.setDims(),
        this._initialOptions?.isCentered ? this.center() : this.fixAndSetPosition(),
        (this._initialOptions = null),
        (!this._uiManager.useNewAltTextWhenAddingImage ||
          !this._uiManager.useNewAltTextFlow ||
          this.annotationElementId) &&
          (e.hidden = !1),
        this.#g(),
        (this.#u ||= (this.parent.addUndoableEditor(this), !0)),
        this._reportTelemetry({
          action: `inserted_image`,
        }),
        this.#a && this.div.setAttribute(`aria-description`, this.#a),
        this.annotationElementId || this._uiManager.a11yAlert(`pdfjs-editor-stamp-added-alert`));
    }
    copyCanvas(e, t, n = !1) {
      e ||= 224;
      let { width: r, height: i } = this.#e,
        a = new j2(),
        o = this.#e,
        s = r,
        c = i,
        l = null;
      if (t) {
        if (r > t || i > t) {
          let e = Math.min(t / r, t / i);
          ((s = Math.floor(r * e)), (c = Math.floor(i * e)));
        }
        l = document.createElement(`canvas`);
        let e = (l.width = Math.ceil(s * a.sx)),
          n = (l.height = Math.ceil(c * a.sy));
        this.#l || (o = this.#h(e, n));
        let u = l.getContext(`2d`);
        u.filter = this._uiManager.hcmFilter;
        let d = `white`,
          f = `#cfcfd8`;
        this._uiManager.hcmFilter === `none`
          ? N2.isDarkMode && ((d = `#8f8f9d`), (f = `#42414d`))
          : (f = `black`);
        let p = 15 * a.sx,
          m = 15 * a.sy,
          h = new OffscreenCanvas(p * 2, m * 2),
          g = h.getContext(`2d`);
        ((g.fillStyle = d),
          g.fillRect(0, 0, p * 2, m * 2),
          (g.fillStyle = f),
          g.fillRect(0, 0, p, m),
          g.fillRect(p, m, p, m),
          (u.fillStyle = u.createPattern(h, `repeat`)),
          u.fillRect(0, 0, e, n),
          u.drawImage(o, 0, 0, o.width, o.height, 0, 0, e, n));
      }
      let u = null;
      if (n) {
        let t, n;
        if (a.symmetric && o.width < e && o.height < e) ((t = o.width), (n = o.height));
        else if (((o = this.#e), r > e || i > e)) {
          let a = Math.min(e / r, e / i);
          ((t = Math.floor(r * a)), (n = Math.floor(i * a)), this.#l || (o = this.#h(t, n)));
        }
        let s = new OffscreenCanvas(t, n).getContext(`2d`, {
          willReadFrequently: !0,
        });
        (s.drawImage(o, 0, 0, o.width, o.height, 0, 0, t, n),
          (u = {
            width: t,
            height: n,
            data: s.getImageData(0, 0, t, n).data,
          }));
      }
      return {
        canvas: l,
        width: s,
        height: c,
        imageData: u,
      };
    }
    #h(e, t) {
      let { width: n, height: r } = this.#e,
        i = n,
        a = r,
        o = this.#e;
      for (; i > 2 * e || a > 2 * t;) {
        let n = i,
          r = a;
        (i > 2 * e && (i = Math.ceil(i / 2)), a > 2 * t && (a = Math.ceil(a / 2)));
        let s = new OffscreenCanvas(i, a);
        (s.getContext(`2d`).drawImage(o, 0, 0, n, r, 0, 0, i, a), (o = s.transferToImageBitmap()));
      }
      return o;
    }
    #g() {
      let [e, t] = this.parentDimensions,
        { width: n, height: r } = this,
        i = new j2(),
        a = Math.ceil(n * e * i.sx),
        o = Math.ceil(r * t * i.sy),
        s = this.#o;
      if (!s || (s.width === a && s.height === o)) return;
      ((s.width = a), (s.height = o));
      let c = this.#l ? this.#e : this.#h(a, o),
        l = s.getContext(`2d`);
      ((l.filter = this._uiManager.hcmFilter), l.drawImage(c, 0, 0, c.width, c.height, 0, 0, a, o));
    }
    #_(e) {
      if (e) {
        if (this.#l) {
          let e = this._uiManager.imageManager.getSvgUrl(this.#t);
          if (e) return e;
        }
        let e = document.createElement(`canvas`);
        return (
          ({ width: e.width, height: e.height } = this.#e),
          e.getContext(`2d`).drawImage(this.#e, 0, 0),
          e.toDataURL()
        );
      }
      if (this.#l) {
        let [e, t] = this.pageDimensions,
          n = Math.round(this.width * e * u2.PDF_TO_CSS_UNITS),
          r = Math.round(this.height * t * u2.PDF_TO_CSS_UNITS),
          i = new OffscreenCanvas(n, r);
        return (
          i.getContext(`2d`).drawImage(this.#e, 0, 0, this.#e.width, this.#e.height, 0, 0, n, r),
          i.transferToImageBitmap()
        );
      }
      return structuredClone(this.#e);
    }
    static async deserialize(e, t, n) {
      let r = null,
        i = !1;
      if (e instanceof H3) {
        let {
            data: {
              rect: a,
              rotation: o,
              id: s,
              structParent: c,
              popupRef: l,
              richText: u,
              contentsObj: d,
              creationDate: f,
              modificationDate: p,
            },
            container: m,
            parent: {
              page: { pageNumber: h },
            },
            canvas: g,
          } = e,
          v,
          y;
        g
          ? (delete e.canvas,
            ({ id: v, bitmap: y } = n.imageManager.getFromCanvas(m.id, g)),
            g.remove())
          : ((i = !0), (e._hasNoCanvas = !0));
        let b = (await t._structTree.getAriaAttributes(`${t2}${s}`))?.get(`aria-label`) || ``;
        r = e = {
          annotationType: h0.STAMP,
          bitmapId: v,
          bitmap: y,
          pageIndex: h - 1,
          rect: a.slice(0),
          rotation: o,
          annotationElementId: s,
          id: s,
          deleted: !1,
          accessibilityData: {
            decorative: !1,
            altText: b,
          },
          isSvg: !1,
          structParent: c,
          popupRef: l,
          richText: u,
          comment: d?.str || null,
          creationDate: f,
          modificationDate: p,
        };
      }
      let a = await super.deserialize(e, t, n),
        { rect: o, bitmap: s, bitmapUrl: c, bitmapId: l, isSvg: u, accessibilityData: d } = e;
      (i
        ? (n.addMissingCanvas(e.id, a), (a.#s = !0))
        : l && n.imageManager.isValidId(l)
          ? ((a.#t = l), s && (a.#e = s))
          : (a.#r = c),
        (a.#l = u));
      let [f, p] = a.pageDimensions;
      return (
        (a.width = (o[2] - o[0]) / f),
        (a.height = (o[3] - o[1]) / p),
        d && (a.altTextData = d),
        (a._initialData = r),
        e.comment && a.setCommentData(e),
        (a.#u = !!r),
        a
      );
    }
    serialize(e = !1, t = null) {
      if (this.isEmpty()) return null;
      if (this.deleted) return this.serializeDeleted();
      let n = Object.assign(super.serialize(e), {
        bitmapId: this.#t,
        isSvg: this.#l,
      });
      if ((this.addComment(n), e))
        return (
          (n.bitmapUrl = this.#_(!0)),
          (n.accessibilityData = this.serializeAltText(!0)),
          (n.isCopy = !0),
          n
        );
      let { decorative: r, altText: i } = this.serializeAltText(!1);
      if (
        (!r &&
          i &&
          (n.accessibilityData = {
            type: `Figure`,
            alt: i,
          }),
        this.annotationElementId)
      ) {
        let e = this.#v(n);
        return e.isSame
          ? null
          : (e.isSameAltText
              ? delete n.accessibilityData
              : (n.accessibilityData.structParent = this._initialData.structParent ?? -1),
            (n.id = this.annotationElementId),
            delete n.bitmapId,
            n);
      }
      if (t === null) return n;
      t.stamps ||= new Map();
      let a = this.#l ? (n.rect[2] - n.rect[0]) * (n.rect[3] - n.rect[1]) : null;
      if (!t.stamps.has(this.#t))
        (t.stamps.set(this.#t, {
          area: a,
          serialized: n,
        }),
          (n.bitmap = this.#_(!1)));
      else if (this.#l) {
        let e = t.stamps.get(this.#t);
        a > e.area &&
          ((e.area = a), e.serialized.bitmap.close(), (e.serialized.bitmap = this.#_(!1)));
      }
      return n;
    }
    #v(e) {
      let {
          pageIndex: t,
          accessibilityData: { altText: n },
        } = this._initialData,
        r = e.pageIndex === t,
        i = (e.accessibilityData?.alt || ``) === n;
      return {
        isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && r && i,
        isSameAltText: i,
      };
    }
    renderAnnotationElement(e) {
      return this.deleted
        ? (e.hide(), null)
        : (e.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment,
          }),
          null);
    }
  },
  a6 = class e {
    #e;
    #t = !1;
    #n = null;
    #r = null;
    #i = null;
    #a = new Map();
    #o = !1;
    #s = !1;
    #c = !1;
    #l = null;
    #u = null;
    #d = null;
    #f = null;
    #p = null;
    #m = -1;
    #h;
    static _initialized = !1;
    static #g = new Map([Bce, Wce, Jce, X3, qce].map((e) => [e._editorType, e]));
    constructor({
      uiManager: t,
      pageIndex: n,
      div: r,
      structTreeLayer: i,
      accessibilityManager: a,
      annotationLayer: o,
      drawLayer: s,
      textLayer: c,
      viewport: l,
      l10n: u,
    }) {
      let d = [...e.#g.values()];
      if (!e._initialized) {
        e._initialized = !0;
        for (let e of d) e.initialize(u, t);
      }
      (t.registerEditorTypes(d),
        (this.#h = t),
        (this.pageIndex = n),
        (this.div = r),
        (this.#e = a),
        (this.#n = o),
        (this.viewport = l),
        (this.#d = c),
        (this.drawLayer = s),
        (this._structTree = i),
        this.#h.addLayer(this));
    }
    get isEmpty() {
      return this.#a.size === 0;
    }
    get isInvisible() {
      return this.isEmpty && this.#h.getMode() === h0.NONE;
    }
    updateToolbar(e) {
      this.#h.updateToolbar(e);
    }
    updateMode(t = this.#h.getMode()) {
      switch ((this.#S(), t)) {
        case h0.NONE:
          (this.div.classList.toggle(`nonEditing`, !0),
            this.disableTextSelection(),
            this.togglePointerEvents(!1),
            this.toggleAnnotationLayerPointerEvents(!0),
            this.disableClick());
          return;
        case h0.INK:
          (this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick());
          break;
        case h0.HIGHLIGHT:
          (this.enableTextSelection(), this.togglePointerEvents(!1), this.disableClick());
          break;
        default:
          (this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick());
      }
      this.toggleAnnotationLayerPointerEvents(!1);
      let { classList: n } = this.div;
      if ((n.toggle(`nonEditing`, !1), t === h0.POPUP)) n.toggle(`commentEditing`, !0);
      else {
        n.toggle(`commentEditing`, !1);
        for (let r of e.#g.values()) n.toggle(`${r._type}Editing`, t === r._editorType);
      }
      this.div.hidden = !1;
    }
    hasTextLayer(e) {
      return e === this.#d?.div;
    }
    setEditingState(e) {
      this.#h.setEditingState(e);
    }
    addCommands(e) {
      this.#h.addCommands(e);
    }
    cleanUndoStack(e) {
      this.#h.cleanUndoStack(e);
    }
    toggleDrawing(e = !1) {
      this.div.classList.toggle(`drawing`, !e);
    }
    togglePointerEvents(e = !1) {
      this.div.classList.toggle(`disabled`, !e);
    }
    toggleAnnotationLayerPointerEvents(e = !1) {
      this.#n?.togglePointerEvents(e);
    }
    get #_() {
      return this.#a.size === 0 ? this.#h.getEditors(this.pageIndex) : this.#a.values();
    }
    async enable() {
      ((this.#c = !0),
        (this.div.tabIndex = 0),
        this.togglePointerEvents(!0),
        this.div.classList.toggle(`nonEditing`, !1),
        this.#p?.abort(),
        (this.#p = null));
      let e = new Set();
      for (let t of this.#_)
        (t.enableEditing(),
          t.show(!0),
          t.annotationElementId &&
            (this.#h.removeChangedExistingAnnotation(t), e.add(t.annotationElementId)));
      let t = this.#n;
      if (t)
        for (let n of t.getEditableAnnotations()) {
          if ((n.hide(), this.#h.isDeletedAnnotationElement(n.data.id) || e.has(n.data.id)))
            continue;
          let t = await this.deserialize(n);
          t && (this.addOrRebuild(t), t.enableEditing());
        }
      ((this.#c = !1),
        this.#h._eventBus.dispatch(`editorsrendered`, {
          source: this,
          pageNumber: this.pageIndex + 1,
        }));
    }
    disable() {
      if (
        ((this.#s = !0),
        (this.div.tabIndex = -1),
        this.togglePointerEvents(!1),
        this.div.classList.toggle(`nonEditing`, !0),
        this.#d && !this.#p)
      ) {
        this.#p = new AbortController();
        let e = this.#h.combinedSignal(this.#p);
        this.#d.div.addEventListener(
          `pointerdown`,
          (e) => {
            let { clientX: t, clientY: n, timeStamp: r } = e;
            if (r - this.#m > 500) {
              this.#m = r;
              return;
            }
            this.#m = -1;
            let { classList: i } = this.div;
            i.toggle(`getElements`, !0);
            let a = document.elementsFromPoint(t, n);
            if ((i.toggle(`getElements`, !1), !this.div.contains(a[0]))) return;
            let o,
              s = RegExp(`^${m0}[0-9]+$`);
            for (let e of a)
              if (s.test(e.id)) {
                o = e.id;
                break;
              }
            if (!o) return;
            let c = this.#a.get(o);
            c?.annotationElementId === null && (x2(e), c.dblclick(e));
          },
          {
            signal: e,
            capture: !0,
          },
        );
      }
      let t = this.#n,
        n = [];
      if (t) {
        let e = new Map(),
          r = new Map();
        for (let t of this.#_) {
          if ((t.disableEditing(), !t.annotationElementId)) {
            n.push(t);
            continue;
          }
          if (t.serialize() !== null) {
            e.set(t.annotationElementId, t);
            continue;
          } else r.set(t.annotationElementId, t);
          (this.getEditableAnnotation(t.annotationElementId)?.show(), t.remove());
        }
        for (let n of t.getEditableAnnotations()) {
          let { id: t } = n.data;
          if (this.#h.isDeletedAnnotationElement(t)) {
            n.updateEdited({
              deleted: !0,
            });
            continue;
          }
          let i = r.get(t);
          if (i) {
            (i.resetAnnotationElement(n), i.show(!1), n.show());
            continue;
          }
          ((i = e.get(t)),
            i &&
              (this.#h.addChangedExistingAnnotation(i), i.renderAnnotationElement(n) && i.show(!1)),
            n.show());
        }
      }
      (this.#S(), this.isEmpty && (this.div.hidden = !0));
      let { classList: r } = this.div;
      for (let t of e.#g.values()) r.remove(`${t._type}Editing`);
      (this.disableTextSelection(),
        this.toggleAnnotationLayerPointerEvents(!0),
        t?.updateFakeAnnotations(n),
        (this.#s = !1));
    }
    getEditableAnnotation(e) {
      return this.#n?.getEditableAnnotation(e) || null;
    }
    setActiveEditor(e) {
      this.#h.getActive() !== e && this.#h.setActiveEditor(e);
    }
    enableTextSelection() {
      if (((this.div.tabIndex = -1), this.#d?.div && !this.#f)) {
        this.#f = new AbortController();
        let e = this.#h.combinedSignal(this.#f);
        (this.#d.div.addEventListener(`pointerdown`, this.#v.bind(this), {
          signal: e,
        }),
          this.#d.div.classList.add(`highlighting`));
      }
    }
    disableTextSelection() {
      ((this.div.tabIndex = 0),
        this.#d?.div &&
          this.#f &&
          (this.#f.abort(), (this.#f = null), this.#d.div.classList.remove(`highlighting`)));
    }
    #v(e) {
      this.#h.unselectAll();
      let { target: t } = e;
      if (
        t === this.#d.div ||
        ((t.getAttribute(`role`) === `img` ||
          t.classList.contains(`endOfContent`) ||
          t.classList.contains(`textLayerImagePlaceholder`)) &&
          this.#d.div.contains(t))
      ) {
        let { isMac: t } = J0.platform;
        if (e.button !== 0 || (e.ctrlKey && t)) return;
        (this.#h.showAllEditors(`highlight`, !0, !0),
          this.#d.div.classList.add(`free`),
          this.toggleDrawing(),
          X3.startHighlighting(this, this.#h.direction === `ltr`, {
            target: this.#d.div,
            x: e.x,
            y: e.y,
          }),
          this.#d.div.addEventListener(
            `pointerup`,
            () => {
              (this.#d.div.classList.remove(`free`), this.toggleDrawing(!0));
            },
            {
              once: !0,
              signal: this.#h._signal,
            },
          ),
          e.preventDefault());
      }
    }
    enableClick() {
      if (this.#r) return;
      this.#r = new AbortController();
      let e = this.#h.combinedSignal(this.#r);
      this.div.addEventListener(`pointerdown`, this.pointerdown.bind(this), {
        signal: e,
      });
      let t = this.pointerup.bind(this);
      (this.div.addEventListener(`pointerup`, t, {
        signal: e,
      }),
        this.div.addEventListener(`pointercancel`, t, {
          signal: e,
        }));
    }
    disableClick() {
      (this.#r?.abort(), (this.#r = null));
    }
    attach(e) {
      this.#a.set(e.id, e);
      let { annotationElementId: t } = e;
      t && this.#h.isDeletedAnnotationElement(t) && this.#h.removeDeletedAnnotationElement(e);
    }
    detach(e) {
      (this.#a.delete(e.id),
        this.#e?.removePointerInTextLayer(e.contentDiv),
        !this.#s && e.annotationElementId && this.#h.addDeletedAnnotationElement(e));
    }
    remove(e) {
      (this.detach(e), this.#h.removeEditor(e), e.div.remove(), (e.isAttachedToDOM = !1));
    }
    changeParent(e) {
      e.parent !== this &&
        (e.parent &&
          e.annotationElementId &&
          (this.#h.addDeletedAnnotationElement(e),
          n4.deleteAnnotationElement(e),
          (e.annotationElementId = null)),
        this.attach(e),
        e.parent?.detach(e),
        e.setParent(this),
        e.div && e.isAttachedToDOM && (e.div.remove(), this.div.append(e.div)));
    }
    add(e) {
      if (!(e.parent === this && e.isAttachedToDOM)) {
        if ((this.changeParent(e), this.#h.addEditor(e), this.attach(e), !e.isAttachedToDOM)) {
          let t = e.render();
          (this.div.append(t), (e.isAttachedToDOM = !0));
        }
        (e.fixAndSetPosition(),
          e.onceAdded(!this.#c),
          this.#h.addToAnnotationStorage(e),
          e._reportTelemetry(e.telemetryInitialData));
      }
    }
    moveEditorInDOM(e) {
      if (!e.isAttachedToDOM) return;
      let { activeElement: t } = document;
      (e.div.contains(t) &&
        !this.#i &&
        ((e._focusEventsAllowed = !1),
        (this.#i = setTimeout(() => {
          ((this.#i = null),
            e.div.contains(document.activeElement)
              ? (e._focusEventsAllowed = !0)
              : (e.div.addEventListener(
                  `focusin`,
                  () => {
                    e._focusEventsAllowed = !0;
                  },
                  {
                    once: !0,
                    signal: this.#h._signal,
                  },
                ),
                t.focus()));
        }, 0))),
        (e._structTreeParentId = this.#e?.moveElementInDOM(this.div, e.div, e.contentDiv, !0)));
    }
    addOrRebuild(e) {
      e.needsToBeRebuilt() ? ((e.parent ||= this), e.rebuild(), e.show()) : this.add(e);
    }
    addUndoableEditor(e) {
      this.addCommands({
        cmd: () => e._uiManager.rebuild(e),
        undo: () => {
          e.remove();
        },
        mustExec: !1,
      });
    }
    getEditorByUID(e) {
      for (let t of this.#a.values()) if (t.uid === e) return t;
      return null;
    }
    get #y() {
      return e.#g.get(this.#h.getMode());
    }
    combinedSignal(e) {
      return this.#h.combinedSignal(e);
    }
    #b(e) {
      let t = this.#y;
      return t ? new t.prototype.constructor(e) : null;
    }
    canCreateNewEmptyEditor() {
      return this.#y?.canCreateNewEmptyEditor();
    }
    async pasteEditor(e, t) {
      (this.updateToolbar(e), await this.#h.updateMode(e.mode));
      let { offsetX: n, offsetY: r } = this.#x(),
        i = this.#h.getId(),
        a = this.#b({
          parent: this,
          id: i,
          x: n,
          y: r,
          uiManager: this.#h,
          isCentered: !0,
          ...t,
        });
      a && this.add(a);
    }
    async deserialize(t) {
      return (
        (await e.#g
          .get(t.annotationType ?? t.annotationEditorType)
          ?.deserialize(t, this, this.#h)) || null
      );
    }
    createAndAddNewEditor(e, t, n = {}) {
      let r = this.#h.getId(),
        i = this.#b({
          parent: this,
          id: r,
          x: e.offsetX,
          y: e.offsetY,
          uiManager: this.#h,
          isCentered: t,
          ...n,
        });
      return (i && this.add(i), i);
    }
    get boundingClientRect() {
      return this.div.getBoundingClientRect();
    }
    #x() {
      let { x: e, y: t, width: n, height: r } = this.boundingClientRect,
        i = Math.max(0, e),
        a = Math.max(0, t),
        o = Math.min(window.innerWidth, e + n),
        s = Math.min(window.innerHeight, t + r),
        c = (i + o) / 2 - e,
        l = (a + s) / 2 - t,
        [u, d] = this.viewport.rotation % 180 == 0 ? [c, l] : [l, c];
      return {
        offsetX: u,
        offsetY: d,
      };
    }
    addNewEditor(e = {}) {
      this.createAndAddNewEditor(this.#x(), !0, e);
    }
    setSelected(e) {
      this.#h.setSelected(e);
    }
    toggleSelected(e) {
      this.#h.toggleSelected(e);
    }
    unselect(e) {
      this.#h.unselect(e);
    }
    pointerup(e) {
      let { isMac: t } = J0.platform;
      if (
        e.button !== 0 ||
        (e.ctrlKey && t) ||
        e.target !== this.div ||
        !this.#o ||
        ((this.#o = !1), this.#y?.isDrawer && this.#y.supportMultipleDrawings)
      )
        return;
      if (!this.#t) {
        this.#t = !0;
        return;
      }
      let n = this.#h.getMode();
      if (n === h0.STAMP || n === h0.POPUP || n === h0.SIGNATURE) {
        this.#h.unselectAll();
        return;
      }
      this.createAndAddNewEditor(e, !1);
    }
    pointerdown(e) {
      if ((this.#h.getMode() === h0.HIGHLIGHT && this.enableTextSelection(), this.#o)) {
        this.#o = !1;
        return;
      }
      let { isMac: t } = J0.platform;
      if (e.button !== 0 || (e.ctrlKey && t) || e.target !== this.div) return;
      if (((this.#o = !0), this.#y?.isDrawer)) {
        this.startDrawingSession(e);
        return;
      }
      let n = this.#h.getActive();
      this.#t = !n || n.isEmpty();
    }
    startDrawingSession(e) {
      if (
        (this.div.focus({
          preventScroll: !0,
        }),
        this.#l)
      ) {
        this.#y.startDrawing(this, this.#h, !1, e);
        return;
      }
      (this.#h.setCurrentDrawingSession(this), (this.#l = new AbortController()));
      let t = this.#h.combinedSignal(this.#l);
      (this.div.addEventListener(
        `blur`,
        ({ relatedTarget: e }) => {
          e && !this.div.contains(e) && ((this.#u = null), this.commitOrRemove());
        },
        {
          signal: t,
        },
      ),
        this.#y.startDrawing(this, this.#h, !1, e));
    }
    pause(e) {
      if (e) {
        let { activeElement: e } = document;
        this.div.contains(e) && (this.#u = e);
        return;
      }
      this.#u &&
        setTimeout(() => {
          (this.#u?.focus(), (this.#u = null));
        }, 0);
    }
    endDrawingSession(e = !1) {
      return this.#l
        ? (this.#h.setCurrentDrawingSession(null),
          this.#l.abort(),
          (this.#l = null),
          (this.#u = null),
          this.#y.endDrawing(e))
        : null;
    }
    findNewParent(e, t, n) {
      let r = this.#h.findParent(t, n);
      return r === null || r === this ? !1 : (r.changeParent(e), !0);
    }
    commitOrRemove() {
      return this.#l ? (this.endDrawingSession(), !0) : !1;
    }
    onScaleChanging() {
      this.#l && this.#y.onScaleChangingWhenDrawing(this);
    }
    destroy() {
      (this.commitOrRemove(),
        this.#h.getActive()?.parent === this &&
          (this.#h.commitOrRemove(), this.#h.setActiveEditor(null)),
        (this.#i &&= (clearTimeout(this.#i), null)));
      for (let e of this.#a.values())
        (this.#e?.removePointerInTextLayer(e.contentDiv),
          e.setParent(null),
          (e.isAttachedToDOM = !1),
          e.div.remove());
      ((this.div = null), this.#a.clear(), this.#h.removeLayer(this));
    }
    #S() {
      for (let e of this.#a.values()) e.isEmpty() && e.remove();
    }
    async render({ viewport: e }) {
      ((this.viewport = e), A2(this.div, e));
      for (let e of this.#h.getEditors(this.pageIndex)) (this.add(e), e.rebuild());
      (await this.#h.findClonesForPage(this), (this.div.hidden = this.isEmpty), this.updateMode());
    }
    update({ viewport: e }) {
      (this.#h.commitOrRemove(), this.#S());
      let t = this.viewport.rotation,
        n = e.rotation;
      if (
        ((this.viewport = e),
        A2(this.div, {
          rotation: n,
        }),
        t !== n)
      )
        for (let e of this.#a.values()) e.rotate(n);
    }
    get pageDimensions() {
      let { pageWidth: e, pageHeight: t } = this.viewport.rawDims;
      return [e, t];
    }
    get scale() {
      return this.#h.viewParameters.realScale;
    }
  },
  o6 = class e {
    #e = null;
    #t = new Map();
    #n = new Map();
    static #r = 0;
    setParent(e) {
      if (!this.#e) {
        this.#e = e;
        return;
      }
      if (this.#e !== e) {
        if (this.#t.size > 0) for (let t of this.#t.values()) (t.remove(), e.append(t));
        this.#e = e;
      }
    }
    static get _svgFactory() {
      return L0(this, `_svgFactory`, new A3());
    }
    static #i(e, [t, n, r, i]) {
      let { style: a } = e;
      ((a.top = `${100 * n}%`),
        (a.left = `${100 * t}%`),
        (a.width = `${100 * r}%`),
        (a.height = `${100 * i}%`));
    }
    #a() {
      let t = e._svgFactory.create(1, 1, !0);
      return (this.#e.append(t), t.setAttribute(`aria-hidden`, !0), t);
    }
    #o(t, n) {
      let r = e._svgFactory.createElement(`clipPath`);
      t.append(r);
      let i = `clip_${n}`;
      (r.setAttribute(`id`, i), r.setAttribute(`clipPathUnits`, `objectBoundingBox`));
      let a = e._svgFactory.createElement(`use`);
      return (r.append(a), a.setAttribute(`href`, `#${n}`), a.classList.add(`clip`), i);
    }
    #s(e, t) {
      for (let [n, r] of Object.entries(t))
        r === null ? e.removeAttribute(n) : e.setAttribute(n, r);
    }
    draw(t, n = !1, r = !1) {
      let i = e.#r++,
        a = this.#a(),
        o = e._svgFactory.createElement(`defs`);
      a.append(o);
      let s = e._svgFactory.createElement(`path`);
      o.append(s);
      let c = `path_${i}`;
      (s.setAttribute(`id`, c),
        s.setAttribute(`vector-effect`, `non-scaling-stroke`),
        n && this.#n.set(i, s));
      let l = r ? this.#o(o, c) : null,
        u = e._svgFactory.createElement(`use`);
      return (
        a.append(u),
        u.setAttribute(`href`, `#${c}`),
        this.updateProperties(a, t),
        this.#t.set(i, a),
        {
          id: i,
          clipPathId: `url(#${l})`,
        }
      );
    }
    drawOutline(t, n) {
      let r = e.#r++,
        i = this.#a(),
        a = e._svgFactory.createElement(`defs`);
      i.append(a);
      let o = e._svgFactory.createElement(`path`);
      a.append(o);
      let s = `path_${r}`;
      (o.setAttribute(`id`, s), o.setAttribute(`vector-effect`, `non-scaling-stroke`));
      let c;
      if (n) {
        let t = e._svgFactory.createElement(`mask`);
        (a.append(t),
          (c = `mask_${r}`),
          t.setAttribute(`id`, c),
          t.setAttribute(`maskUnits`, `objectBoundingBox`));
        let n = e._svgFactory.createElement(`rect`);
        (t.append(n),
          n.setAttribute(`width`, `1`),
          n.setAttribute(`height`, `1`),
          n.setAttribute(`fill`, `white`));
        let i = e._svgFactory.createElement(`use`);
        (t.append(i),
          i.setAttribute(`href`, `#${s}`),
          i.setAttribute(`stroke`, `none`),
          i.setAttribute(`fill`, `black`),
          i.setAttribute(`fill-rule`, `nonzero`),
          i.classList.add(`mask`));
      }
      let l = e._svgFactory.createElement(`use`);
      (i.append(l), l.setAttribute(`href`, `#${s}`), c && l.setAttribute(`mask`, `url(#${c})`));
      let u = l.cloneNode();
      return (
        i.append(u),
        l.classList.add(`mainOutline`),
        u.classList.add(`secondaryOutline`),
        this.updateProperties(i, t),
        this.#t.set(r, i),
        r
      );
    }
    finalizeDraw(e, t) {
      (this.#n.delete(e), this.updateProperties(e, t));
    }
    updateProperties(t, n) {
      if (!n) return;
      let { root: r, bbox: i, rootClass: a, path: o } = n,
        s = typeof t == `number` ? this.#t.get(t) : t;
      if (s) {
        if ((r && this.#s(s, r), i && e.#i(s, i), a)) {
          let { classList: e } = s;
          for (let [t, n] of Object.entries(a)) e.toggle(t, n);
        }
        if (o) {
          let e = s.firstElementChild.firstElementChild;
          this.#s(e, o);
        }
      }
    }
    updateParent(e, t) {
      if (t === this) return;
      let n = this.#t.get(e);
      n && (t.#e.append(n), this.#t.delete(e), t.#t.set(e, n));
    }
    remove(e) {
      (this.#n.delete(e), this.#e !== null && (this.#t.get(e).remove(), this.#t.delete(e)));
    }
    destroy() {
      this.#e = null;
      for (let e of this.#t.values()) e.remove();
      (this.#t.clear(), this.#n.clear());
    }
  };
function s6(e) {
  return `${(e * 100).toFixed(2)}%`;
}
var Yce = class e {
  #e = [];
  #t = new Map();
  #n = null;
  #r = 0;
  #i = 0;
  #a = 0;
  static #o = null;
  constructor(e, t, n, r) {
    ((this.#r = e),
      (this.#e = t),
      (this.#i = n.rawDims.pageWidth),
      (this.#a = n.rawDims.pageHeight),
      (this.#n = r));
  }
  render() {
    let t = document.createElement(`div`);
    t.className = `textLayerImages`;
    for (let e = 0; e < this.#e.length; e += 6) {
      let n = this.#s(this.#e.subarray(e, e + 6));
      n && t.append(n);
    }
    return (
      t.addEventListener(`contextmenu`, (t) => {
        if (!(t.target instanceof HTMLCanvasElement)) return;
        let n = t.target,
          r = this.#t.get(n);
        if (!r) return;
        let i = e.#o?.deref();
        if (i === n) return;
        (i && ((i.width = 0), (i.height = 0)), (e.#o = new WeakRef(n)));
        let { inverseTransform: a, x1: o, y1: s, width: c, height: l } = r,
          u = this.#n(),
          d = Math.ceil(o * u.width),
          f = Math.ceil(s * u.height),
          p = Math.floor((o + c / this.#i) * u.width),
          m = Math.floor((s + l / this.#a) * u.height);
        ((n.width = p - d), (n.height = m - f));
        let h = n.getContext(`2d`);
        (h.setTransform(...a), h.translate(-d, -f), h.drawImage(u, 0, 0));
      }),
      t
    );
  }
  #s([e, t, n, r, i, a]) {
    let o = Math.hypot((i - e) * this.#i, (a - t) * this.#a),
      s = Math.hypot((n - e) * this.#i, (r - t) * this.#a);
    if (o < this.#r || s < this.#r) return null;
    let c = [
        ((i - e) * this.#i) / o,
        ((a - t) * this.#a) / o,
        ((n - e) * this.#i) / s,
        ((r - t) * this.#a) / s,
        0,
        0,
      ],
      l = Y0.inverseTransform(c),
      u = document.createElement(`canvas`);
    return (
      (u.className = `textLayerImagePlaceholder`),
      (u.width = 0),
      (u.height = 0),
      Object.assign(u.style, {
        opacity: 0,
        position: `absolute`,
        left: s6(e),
        top: s6(t),
        width: s6(o / this.#i),
        height: s6(s / this.#a),
        transformOrigin: `0% 0%`,
        transform: `matrix(${c.join(`,`)})`,
      }),
      this.#t.set(u, {
        inverseTransform: l,
        width: o,
        height: s,
        x1: e,
        y1: t,
      }),
      u
    );
  }
};
((globalThis._pdfjsTestingUtils = {
  HighlightOutliner: J3,
}),
  (globalThis.pdfjsLib = {
    AbortException: W0,
    AnnotationEditorLayer: a6,
    AnnotationEditorParamsType: g0,
    AnnotationEditorType: h0,
    AnnotationEditorUIManager: Q2,
    AnnotationLayer: U3,
    AnnotationMode: p0,
    AnnotationType: b0,
    applyOpacity: F2,
    build: yce,
    ColorPicker: T3,
    createValidAbsoluteUrl: P0,
    CSSConstants: P2,
    DOMSVGFactory: A3,
    DrawLayer: o6,
    FeatureTest: J0,
    fetchData: d2,
    findContrastColor: V2,
    getDocument: S3,
    getFilenameFromUrl: g2,
    getPdfFilenameFromUrl: _2,
    getRGB: E2,
    getRGBA: T2,
    getUuid: e2,
    getXfaPageViewport: w2,
    GlobalWorkerOptions: h3,
    ImageKind: y0,
    InvalidPDFException: V0,
    isDataScheme: m2,
    isPdfFile: h2,
    isValidExplicitDest: xse,
    makeArr: r2,
    makeMap: i2,
    makeObj: a2,
    MathClamp: o2,
    noContextMenu: b2,
    normalizeUnicode: $0,
    OPS: C0,
    OutputScale: j2,
    PasswordResponses: T0,
    PDFDataRangeTransport: C3,
    PDFDateString: C2,
    PDFWorker: w3,
    PermissionFlag: _0,
    PixelsPerInch: u2,
    RenderingCancelledException: p2,
    renderRichText: H2,
    ResponseException: H0,
    setLayerDimensions: A2,
    shadow: L0,
    SignatureExtractor: i6,
    stopEvent: x2,
    SupportedImageMimeTypes: M2,
    TextLayer: x3,
    TextLayerImages: Yce,
    TouchManager: t4,
    updateUrlHash: F0,
    Util: Y0,
    VerbosityLevel: S0,
    version: vce,
    XfaLayer: c2,
  }),
  B());
var Xce = `data:text/javascript;base64,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`,
  Zce = `file-attachment`,
  Qce = `form-text`,
  $ce = `form-select`,
  ele = `form-checkbox`,
  tle = `form-radio`,
  nle = `form-button`,
  c6 = [`click`, `dblclick`, `mouseover`, `input`, `change`];
function l6(e, t, n) {
  let r = [];
  if (n) for (let i of n) i[e] === t && r.push(i);
  return r;
}
function u6(e, t) {
  return {
    type: e,
    data: t,
  };
}
function d6(e, t) {
  switch (e.type) {
    case `textarea`:
    case `text`:
      return u6(Qce, {
        fieldName: e.name,
        value: e.value,
      });
    case `select-one`:
    case `select-multiple`:
      let n = [];
      for (let t of e.options)
        n.push({
          value: t.value,
          label: t.label,
        });
      let r = [];
      for (let t of e.selectedOptions)
        r.push({
          value: t.value,
          label: t.label,
        });
      return u6($ce, {
        fieldName: e.name,
        value: r,
        options: n,
      });
    case `checkbox`:
      return u6(ele, {
        fieldName: e.name,
        checked: e.checked,
      });
    case `radio`:
      return u6(tle, {
        fieldName: e.name,
        ...t,
      });
    case `button`:
      return u6(nle, {
        fieldName: e.name,
        ...t,
      });
  }
}
function rle(e) {
  return u6(Zce, e.file);
}
function f6(e) {
  for (let t of e.getElementsByTagName(`span`)) {
    let e = t.textContent,
      n = JSON.parse(t.dataset.l10nArgs ?? `{}`);
    if (e) for (let t in n) e = e.replace(`{{${t}}}`, n[t]);
    t.textContent = e;
  }
}
function ile(e, t, n) {
  let r = e.target;
  if (
    (r.tagName !== `SECTION` && (r = r.parentNode),
    r.className.includes(`popupAnnotation`) || r.className.includes(`textAnnotation`))
  )
    f6(r);
  else if (r.className.includes(`fileAttachmentAnnotation`)) {
    f6(r);
    let t = r.dataset.annotationId;
    if (t && e.type === `dblclick`) return rle(l6(`id`, t, n)[0]);
  } else if (r.className.includes(`textWidgetAnnotation`) && e.type === `input`) {
    let e = r.getElementsByTagName(`input`)[0];
    return ((e ||= r.getElementsByTagName(`textarea`)[0]), d6(e));
  } else {
    if (r.className.includes(`choiceWidgetAnnotation`) && e.type === `input`)
      return d6(r.getElementsByTagName(`select`)[0]);
    if (r.className.includes(`buttonWidgetAnnotation checkBox`) && e.type === `change`)
      return d6(r.getElementsByTagName(`input`)[0]);
    if (r.className.includes(`buttonWidgetAnnotation radioButton`) && e.type === `change`) {
      let e = r.dataset.annotationId;
      if (e) {
        let t = l6(`id`, e, n)[0],
          i = [];
        for (let e of l6(`fieldName`, t.fieldName, n)) e.buttonValue && i.push(e.buttonValue);
        return d6(r.getElementsByTagName(`input`)[0], {
          value: t.buttonValue,
          defaultValue: t.fieldValue,
          options: i,
        });
      }
    } else if (r.className.includes(`buttonWidgetAnnotation pushButton`) && e.type === `click`) {
      let e = r.dataset.annotationId;
      if (e) {
        let t = l6(`id`, e, n)[0];
        return t.resetForm
          ? d6(
              {
                name: t.fieldName,
                type: `button`,
              },
              {
                actions: t.actions,
                reset: !0,
              },
            )
          : d6(
              {
                name: t.fieldName,
                type: `button`,
              },
              {
                actions: t.actions,
                reset: !1,
              },
            );
      }
    }
  }
}
var p6 = Symbol(),
  m6 = Symbol(),
  h6 = Symbol(),
  ale = Symbol(),
  ole = Symbol(),
  sle = Symbol(),
  cle = Symbol(),
  lle = Symbol();
function g6(e, t, n = 0) {
  let r = n,
    i = e.length - 1;
  for (; r < i;) {
    let n = (r + i) >> 1;
    t(e[n]) ? (i = n) : (r = n + 1);
  }
  return r;
}
function ule(e, t, n) {
  if (!e) return [t, n];
  let [r, i] = e,
    a = t,
    o = t + n - 1,
    s = g6(r, (e) => e >= a);
  r[s] > a && --s;
  let c = g6(r, (e) => e >= o, s);
  r[c] > o && --c;
  let l = a + i[s];
  return [l, o + i[c] + 1 - l];
}
function dle(e) {
  let t = e.items,
    n = [0],
    r = 0;
  for (let e of t) ((r += e.str.length), e.hasEOL && (r += 1), n.push(r));
  return n;
}
function _6(e, t, n) {
  let r = t.items,
    i = 0,
    a = r.length - 1;
  for (; i < a;) {
    let t = (i + a + 1) >> 1;
    n[t] <= e ? (i = t) : (a = t - 1);
  }
  let o = i,
    s = e - n[o],
    c = r[o];
  return {
    idx: o,
    offset: Math.min(s, c ? c.str.length : 0),
  };
}
function v6(e, t, n) {
  let r = t.items;
  if (r.length === 0) return [];
  let i = dle(t),
    a = [];
  for (let o of e) {
    let e = o[0],
      s = o[1],
      c = o[2],
      [l, u] = n ? ule(n, e, s) : [e, s],
      d = l + u - 1,
      f = _6(l, t, i),
      p = _6(d, t, i),
      m = r[p.idx],
      h = Math.min(p.offset + 1, m ? m.str.length : 0);
    a.push({
      start: f,
      end: {
        idx: p.idx,
        offset: h,
      },
      str: c,
      oindex: e,
    });
  }
  return a;
}
function y6(e) {
  let t = e.items,
    n = [];
  for (let e of t)
    (n.push(e.str),
      e.hasEOL &&
        n.push(`
`));
  let r = n.join(``);
  if (r.length === 0) return [``, null];
  let i = [0, 0],
    a = 0,
    o = r.replace(
      /([\p{Ideographic}\u3040-\u30FF])\n([\p{Ideographic}\u3040-\u30FF])|(\S)-\n|(\n)/gmu,
      (e, t, n, r, o, s) => {
        if (t && n) {
          let e = s + t.length;
          return (i.push(e - a, a + 1), (a += 1), t + n);
        }
        if (r) {
          let e = s + r.length;
          return (i.push(e - a, a + 2), (a += 2), r);
        }
        return o ? ` ` : e;
      },
    );
  i.push(o.length, a);
  let s = new Uint32Array(i.length >> 1),
    c = new Int32Array(i.length >> 1);
  for (let e = 0, t = i.length; e < t; e += 2) ((s[e >> 1] = i[e]), (c[e >> 1] = i[e + 1]));
  return [o, [s, c]];
}
function b6({ width: e, height: t, left: n, top: r }, i, a) {
  if (e === 0 || t === 0) return null;
  let o = a.getBoundingClientRect(),
    s = i.convertToPdfPoint(n - o.left, r - o.top),
    c = i.convertToPdfPoint(n - o.left + e, r - o.top + t);
  return Y0.normalizeRect([s[0], s[1], c[0], c[1]]);
}
function fle(e, t, n) {
  let r = e.getClientRects();
  if (r.length === 1)
    return {
      rect: b6(r[0], t, n),
    };
  let i = [1 / 0, 1 / 0, -1 / 0, -1 / 0],
    a = [],
    o = 0;
  for (let e of r) {
    let r = b6(e, t, n);
    r !== null &&
      ((a[o] = a[o + 4] = r[0]),
      (a[o + 1] = a[o + 3] = r[3]),
      (a[o + 2] = a[o + 6] = r[2]),
      (a[o + 5] = a[o + 7] = r[1]),
      Y0.rectBoundingBox(...r, i),
      (o += 8));
  }
  return {
    quadPoints: new Float32Array(a),
    rect: i,
  };
}
function x6(e, t) {
  let n = e;
  do {
    if (n.nodeType === Node.TEXT_NODE) {
      let e = n.textContent.length;
      if (t <= e) return [n, t];
      t -= e;
    } else if (n.firstChild) {
      n = n.firstChild;
      continue;
    }
    for (; !n.nextSibling && n !== e;) n = n.parentNode;
    n !== e && (n = n.nextSibling);
  } while (n !== e);
  throw Error(`Offset is bigger than container's contents length.`);
}
function ple(e, t, n, r, i, a) {
  let { start: o, end: s } = e,
    c = r[o.idx],
    l = r[s.idx];
  if (!c || !l) return null;
  let u = new Range(),
    [d, f] = x6(c, o.offset),
    [p, m] = x6(l, s.offset);
  return (
    u.setStart(d, f),
    u.setEnd(p, m),
    {
      id: `inferred_link_${a}`,
      unsafeUrl: t,
      url: t,
      annotationType: b0.LINK,
      rotation: 0,
      ...fle(u, n, i),
      borderStyle: null,
    }
  );
}
function mle(e) {
  let t = RegExp(
    `\\b(?:https?:\\/\\/|mailto:|www\\.)(?:[\\S--[\\p{P}<>]]|\\/|[\\S--[\\[\\]]]+[\\S--[\\p{P}<>]])+|(?=\\p{L})[\\S--[@\\p{Ps}\\p{Pe}<>]]+@([\\S--[[\\p{P}--\\-]<>]]+(?:\\.[\\S--[[\\p{P}--\\-]<>]]+)+)`,
    `gmv`,
  );
  t.lastIndex = 0;
  let n = [],
    r;
  for (; (r = t.exec(e)) !== null;) {
    let [e, t] = r,
      i;
    if (e.startsWith(`www.`) || e.startsWith(`http://`) || e.startsWith(`https://`)) i = e;
    else if (t) {
      let e = URL.parse(`http://${t}`)?.hostname;
      if (!e || /\.\d+$/.test(e)) continue;
    }
    i ??= e.startsWith(`mailto:`) ? e : `mailto:${e}`;
    let a = P0(i, void 0, {
      addDefaultProtocol: !0,
    });
    a &&
      n.push({
        url: a.href,
        index: r.index,
        length: e.length,
      });
  }
  return n;
}
async function hle(e, t, n) {
  let r = await e.getTextContent({
      disableNormalization: !0,
      includeMarkedContent: !0,
    }),
    [i, a] = y6(r),
    o = mle(i),
    s = v6(
      o.map((e) => [e.index, e.length, e.url]),
      r,
      a,
    ),
    c = [];
  if (s.length > 0) {
    let r = document.createElement(`div`);
    ((r.style.visibility = `hidden`), (r.className = `textLayer`), t.parentElement?.appendChild(r));
    let i = new x3({
      textContentSource: e.streamTextContent(),
      container: r,
      viewport: n,
    });
    await i.render();
    let a = i.textDivs;
    for (let t = 0; t < s.length; t++) {
      let i = s[t],
        l = o[t].url,
        u = ple(i, l, n, a, r, e._pageIndex * 100 + t);
      u && c.push(u);
    }
    t.parentElement?.removeChild(r);
  }
  return c;
}
var gle = k({
    __name: `AnnotationLayer`,
    props: {
      page: {},
      viewport: {},
      document: {},
      annotationsFilter: {},
      annotationsMap: {},
      imageResourcesPath: {},
      hideForms: {
        type: Boolean,
      },
      enableScripting: {
        type: Boolean,
      },
      intent: {},
      externalLinkEnabled: {
        type: Boolean,
      },
      externalLinkTarget: {},
    },
    emits: [`annotation`, `annotationLoaded`],
    setup(e, { emit: t }) {
      let n = e,
        r = t,
        i = Ge(`layer`),
        a = F(),
        o = R(h6),
        s = R(p6);
      function c(e) {
        let t = ile(e, n.document, a.value);
        Promise.resolve(t).then((e) => {
          e && r(`annotation`, e);
        });
      }
      async function l() {
        return await Xe(n.document)?.getFieldObjects();
      }
      async function u() {
        return await Xe(n.document)?.hasJSActions();
      }
      async function d() {
        let e = await n.page?.getAnnotations({
          intent: n.intent,
        });
        if (n.annotationsFilter) {
          let t = n.annotationsFilter;
          e = e.filter((e) => {
            let n = e.subtype,
              r = e.fieldType ? `${n}.${e.fieldType}` : null;
            return t?.includes(n) || (r !== null && t?.includes(r));
          });
        }
        return e;
      }
      async function f() {
        i.value.replaceChildren?.();
        for (let e of c6) i.value.removeEventListener(e, c);
        let e = Xe(n.document),
          t = n.page,
          f = n.viewport;
        a.value = await d();
        let p = new Map([]);
        for (let e of a.value)
          if (e.subtype === `Widget` && e.fieldType === `Btn` && e.pushButton) {
            let t = e.rect[2] - e.rect[0],
              n = e.rect[3] - e.rect[1],
              r = document.createElement(`canvas`);
            (r.setAttribute(`width`, (t * f.scale).toString()),
              r.setAttribute(`height`, (n * f.scale).toString()),
              p.set(e.id, r));
          }
        let m = e.annotationStorage;
        if (n.annotationsMap) for (let [e, t] of Object.entries(n.annotationsMap)) m.setValue(e, t);
        let h = o.linkService;
        (h.setExternalLinkEnabled(n.externalLinkEnabled ?? !0),
          h.setExternalLinkTarget(n.externalLinkTarget ?? `_blank`));
        let g = {
            accessibilityManager: void 0,
            annotationCanvasMap: p,
            div: i.value,
            page: t,
            viewport: f.clone({
              dontFlip: !0,
            }),
            annotationEditorUIManager: null,
            l10n: null,
            annotationStorage: m,
            linkService: h,
            commentManager: null,
            structTreeLayer: null,
          },
          v = {
            annotations: a.value,
            viewport: f.clone({
              dontFlip: !0,
            }),
            linkService: h,
            annotationCanvasMap: p,
            div: i.value,
            annotationStorage: m,
            renderForms: !n.hideForms,
            page: t,
            enableScripting: !1,
            hasJSActions: await u(),
            fieldObjects: await l(),
            downloadManager: null,
            imageResourcesPath: n.imageResourcesPath,
          },
          y = new U3(g);
        y.render(v).then(async () => {
          s.resolve(y);
          let e = await hle(t, i.value, f.clone());
          (y.addLinkAnnotations(e), r(`annotationLoaded`, await d()));
        });
        for (let e of c6) i.value.addEventListener(e, c);
      }
      return (
        He(
          () => n.viewport,
          () => {
            n.page && n.viewport && i.value && f();
          },
        ),
        Qe(() => {
          n.page && n.viewport && i.value && f();
        }),
        (e, t) => (
          A(),
          M(
            `div`,
            {
              ref_key: `layer`,
              ref: i,
              class: `annotationLayer`,
              style: {
                display: `block`,
              },
            },
            null,
            512,
          )
        )
      );
    },
  }),
  _le = class {
    uiManager;
    constructor(e) {
      this.uiManager = e;
    }
    setUiManager(e) {
      this.uiManager = e;
    }
    _on(e, t) {}
    on(e, t) {
      this._on(e, t);
    }
    dispatch(e, t) {
      if (this.uiManager)
        switch (e) {
          case `switchannotationeditorparams`:
            this.uiManager.updateParams(t.type, t.value);
            break;
        }
    }
  },
  vle = class {
    commentPopup = null;
    dialogElement;
    constructor(e) {
      ((this.dialogElement = document.createElement(`div`)), (this.commentPopup = e));
    }
    setSidebarUiManager(e) {}
    showSidebar(e) {}
    hideSidebar() {}
    removeComments(e) {}
    selectComment(e) {}
    addComment(e) {}
    updateComment(e) {}
    makeCommentColor(e, t) {}
    destroyPopup() {}
    destroy() {}
    updatePopupColor(e) {}
    static _makeCommentColor(e, t) {
      return `transparent`;
    }
    toggleCommentPopup(e, t, n, r) {
      this.commentPopup.fn(e, t, n, r);
    }
    showDialog(e, t, n, r, i) {
      this.commentPopup.request(t, (e) => {
        ((t.comment = e), t.focusCommentButton());
      });
    }
  },
  S6 = class e extends Q2 {
    editorsAvailable = [];
    #e = [];
    #t;
    #n;
    #r;
    #i = [];
    static LAYER_EMITTER_ID = 1e4;
    constructor(e, t, n, r, i, a, o = []) {
      let s = new _le(),
        c = [];
      for (let e in r) {
        let t = r[e];
        c.push(`${e}=${t[0]},${e}_HCM=${t[1]}`);
      }
      (super(
        null,
        null,
        null,
        null,
        t.fn ? new vle(t) : null,
        null,
        s,
        e,
        null,
        c.join(`,`),
        null,
        null,
        null,
        null,
        null,
        !1,
      ),
        (this._supportsPinchToZoom = !1),
        s.setUiManager(this),
        (this._eventBus = s),
        (this.#e = o),
        (this.#t = n),
        (this.#n = i),
        (this.#r = a));
    }
    get direction() {
      return `ltr`;
    }
    static get _keyboardManager() {
      return null;
    }
    get isEditorHandlingKeyboard() {
      return !1;
    }
    get isEnterHandled() {
      return !1;
    }
    get selectedEditors() {
      let e = [];
      for (let t of this.getEditors(this.currentPageIndex)) t.isSelected && e.push(t);
      return e;
    }
    editAltText(e) {
      this.#t.request &&
        this.#t.request(e, (t) => {
          e.altTextData = {
            altText: t,
            decorative: null,
          };
        });
    }
    getSignature() {}
    get signatureManager() {
      return null;
    }
    setMainHighlightColorPicker() {}
    keydown() {}
    keyup() {}
    undo() {}
    redo() {}
    dragOver() {}
    drop() {}
    copy() {}
    cut() {}
    async paste() {}
    addNewEditorFromKeyboard() {}
    focusMainContainer() {
      this.#n.focus();
    }
    disableUserSelect(e) {}
    a11yAlert(e, t = null) {}
    addEditListeners() {}
    removeEditListeners() {}
    setSelected(t) {
      if ((super.setSelected(t), t.isSelected)) {
        let n = this.#r[e.LAYER_EMITTER_ID];
        n &&
          n(`editorSelected`, {
            editor: t,
          });
      }
    }
    addEditor(t) {
      if (
        (super.addEditor(t),
        t.mode === h0.STAMP &&
          (t._onResizing = () => {
            this.sizeSelectedEditors(t);
          }),
        t.mode === h0.INK)
      ) {
        let e = t._onResizing;
        t._onResizing = () => {
          (e.call(t), this.sizeSelectedEditors(t));
        };
      }
      let n = this.#r[e.LAYER_EMITTER_ID];
      n &&
        n(`editorAdded`, {
          editor: t,
        });
    }
    removeEditor(t) {
      super.removeEditor(t);
      let n = this.#r[e.LAYER_EMITTER_ID];
      n &&
        n(`editorRemoved`, {
          editor: t,
        });
    }
    highlightSelection(e = ``, t = !1) {
      let n = document.getSelection();
      if (!n || n.isCollapsed) return;
      let { anchorNode: r } = n,
        i = (r.nodeType === Node.TEXT_NODE ? r.parentElement : r).closest(`.textLayer`);
      this.currentLayer.hasTextLayer(i) && super.highlightSelection(e, t);
    }
    addLayer(e) {
      super.addLayer(e);
      for (let e of this.#e) e(this.updateParams.bind(this));
    }
    removeLayer(e) {
      super.removeLayer(e);
    }
    getMode() {
      return super.getMode();
    }
    updateParams(e, t, n = !1) {
      if ((super.updateParams(e, t), !n)) {
        let n = [g0.FREETEXT_COLOR, g0.HIGHLIGHT_COLOR, g0.INK_COLOR];
        this.hasSelection &&
          n.includes(e) &&
          this.selectedEditors.forEach((e) => {
            let n = this.#r[e.mode];
            n &&
              n(`colorChanged`, {
                editor: e,
                color: t,
              });
          });
      }
    }
    getId() {
      let e = Math.floor(Math.random() * 100);
      return super.getId() + e;
    }
    get currentLayer() {
      return super.currentLayer;
    }
    setUpDragSession() {
      (super.setUpDragSession(),
        this.hasSelection &&
          ((this.#i = []),
          this.selectedEditors.forEach((e) => {
            e.isSelected && this.#i.push(e);
          })));
    }
    endDragSession() {
      let e = super.endDragSession();
      return (e && (this.#i = []), e);
    }
    dragSelectedEditors(e, t) {
      (super.dragSelectedEditors(e, t),
        this.#i.forEach((e) => {
          let t = this.#r[e.mode];
          t &&
            t(`dragging`, {
              editor: e,
              ...this.#a(e),
            });
        }));
    }
    sizeSelectedEditors(e) {
      let t = this.#r[e.mode];
      t &&
        t(`resizing`, {
          editor: e,
          ...this.#o(e),
        });
    }
    #a(e) {
      return {
        x: e.x * e.pageDimensions[0],
        y: e.y * e.pageDimensions[1],
      };
    }
    #o(e) {
      return {
        width: e.width * e.pageDimensions[0],
        height: e.height * e.pageDimensions[1],
        x: e.x * e.pageDimensions[0],
        y: e.y * e.pageDimensions[1],
      };
    }
  },
  yle = k({
    __name: `AnnotationEditorLayer`,
    props: {
      page: {},
      viewport: {},
      document: {},
      intent: {},
      editorType: {},
      editorLayer: {
        type: Boolean,
      },
    },
    emits: [`editorAdded`, `editorRemoved`, `editorSelected`, `editorLoaded`],
    setup(e, { expose: t, emit: n }) {
      let r = {
          yellow: [`#FFEB3B`, `#FFFFCC`],
          green: [`#8BC34A`, `#53FFBC`],
          pink: [`#FFCBE6`, `#F6B8FF`],
          red: [`#F44336`, `#FF4F5F`],
          blue: [`#2196F3`, `#80EBFF`],
        },
        i = e,
        a = n,
        o = Ge(`layer`),
        s = null,
        c = {
          fn: null,
          request: null,
        },
        l = {
          params: null,
          emit: null,
        },
        u = {
          fn: null,
          params: null,
          emit: null,
        },
        d = {
          params: null,
          emit: null,
        },
        f = {
          fn: (e) => {
            if (i.editorType !== h0.STAMP) {
              console.warn(`[vue-pdf] Cannot add stamp when editor type is not STAMP.`);
              return;
            }
            typeof e == `string`
              ? s?.addNewEditor({
                  bitmapUrl: e,
                })
              : e
                ? s?.addNewEditor({
                    bitmapFile: e,
                  })
                : s?.addNewEditor();
          },
          request: null,
          emit: null,
        };
      (ge(lle, l), ge(ale, u), ge(ole, c), ge(sle, f), ge(cle, d));
      let p = R(m6),
        m = R(p6),
        h = R(h6);
      async function g() {
        if (!h.uiManager && !i.editorLayer) return;
        let e = i.page,
          t = i.viewport;
        if (!h.uiManager) {
          let e = [l.params, u.params, d.params].filter((e) => e !== null),
            t = {
              [h0.FREETEXT]: l.emit,
              [h0.INK]: d.emit,
              [h0.STAMP]: f.emit,
              [h0.HIGHLIGHT]: u.emit,
              [S6.LAYER_EMITTER_ID]: a,
            };
          h.uiManager = new S6(i.document, c, f, u.fn?.() ?? r, h.wrapper.value, t, e);
        }
        let [n, g] = await Promise.all([p.promise, m.promise]);
        s && s.pageIndex !== e._pageIndex && (s.destroy(), (s = null));
        let v = t.clone({
          dontFlip: !0,
        });
        if (s) {
          (s.pause(!0),
            s.update({
              viewport: v,
            }),
            h.uiManager?.onRotationChanging({
              pagesRotation: v.rotation,
            }),
            h.uiManager?.onScaleChanging({
              scale: v.scale,
            }),
            h.uiManager?.onPageChanging({
              pageNumber: e.pageNumber,
            }),
            s.pause(!1),
            h.uiManager?.updateMode(i.editorType));
          return;
        }
        let y = new o6();
        (y.setParent(h.wrapper.value),
          (s = new a6({
            uiManager: h.uiManager,
            div: o.value,
            viewport: t.clone({
              dontFlip: !0,
            }),
            enabled: !0,
            pageIndex: e.pageNumber - 1,
            l10n: null,
            textLayer: n
              ? {
                  div: n,
                }
              : void 0,
            drawLayer: y,
            mode: i.editorType,
            structTreeLayer: null,
            accessibilityManager: void 0,
            annotationLayer: g,
          })),
          (s.toggleDrawing = (e) => {
            o.value?.classList.toggle(`drawing`, !e);
          }),
          (s.hasTextLayer = (t) => {
            let n = t.getAttribute(`data-main-page`);
            return n ? parseInt(n) === e._pageIndex : !1;
          }),
          s.render({
            viewport: t.clone({
              dontFlip: !0,
            }),
          }),
          s.enable(),
          h.uiManager?.onRotationChanging({
            pagesRotation: v.rotation,
          }),
          h.uiManager?.onScaleChanging({
            scale: v.scale,
          }),
          h.uiManager?.onPageChanging({
            pageNumber: e.pageNumber,
          }),
          h.uiManager?.updateMode(i.editorType),
          a(`editorLoaded`));
      }
      function v() {
        [h0.FREETEXT, h0.HIGHLIGHT, h0.INK, h0.STAMP, h0.NONE, h0.DISABLE].includes(i.editorType)
          ? g()
          : console.warn(`[vue-pdf] Unsupported editor type: ${i.editorType}.`);
      }
      function y() {
        h.uiManager?.unselectAll();
      }
      return (
        He(
          () => [i.editorLayer],
          ([e]) => {
            e && !h.uiManager
              ? i.page && i.viewport && o.value && v()
              : h.wrapper.value?.querySelectorAll(`svg`)?.forEach((t) => {
                  e
                    ? t.classList.remove(`svg-editor-hidden`)
                    : t.classList.add(`svg-editor-hidden`);
                });
          },
        ),
        He(
          () => [i.viewport, i.editorType],
          () => {
            i.page && i.viewport && o.value && v();
          },
        ),
        Qe(() => {
          i.page && i.viewport && o.value && v();
        }),
        t({
          unselectAll: y,
        }),
        (t, n) => (
          A(),
          M(
            ke,
            null,
            [
              Re(
                W(
                  `div`,
                  {
                    ref_key: `layer`,
                    ref: o,
                    class: `annotationEditorLayer`,
                    id: `annotationEditorLayer`,
                  },
                  null,
                  512,
                ),
                [[Ee, e.editorLayer]],
              ),
              z(t.$slots, `default`),
            ],
            64,
          )
        )
      );
    },
  });
function ble(e, t, n) {
  let [r, i] = y6(e),
    a = [`g`];
  n.ignoreCase && a.push(`i`);
  let o = t.trim().replace(/[.*+?^${}()|[\]\\]/g, `\\$&`);
  n.completeWords && (o = `\\b${o}\\b`);
  let s = new RegExp(o, a.join(``)),
    c = [],
    l;
  for (; (l = s.exec(r)) !== null;) c.push([l.index, l[0].length, l[0]]);
  return [c, i];
}
function xle(e, t, n) {
  function r(e, r = -1, i = -1) {
    let a = t.items[e],
      o = [],
      s = ``,
      c = ``,
      l = ``,
      u = n[e];
    if (!u) return;
    if (u.nodeType === Node.TEXT_NODE) {
      let t = document.createElement(`span`);
      (u.before(t), t.append(u), (n[e] = t), (u = t));
    }
    r >= 0 && i >= 0
      ? (s = a.str.substring(r, i))
      : r < 0 && i < 0
        ? (s = a.str)
        : r >= 0
          ? (s = a.str.substring(r))
          : i >= 0 && (s = a.str.substring(0, i));
    let d = document.createTextNode(s),
      f = document.createElement(`span`);
    if (((f.className = `highlight appended`), f.append(d), o.push(f), r > 0))
      if (u.childNodes.length === 1 && u.childNodes[0].nodeType === Node.TEXT_NODE) {
        c = a.str.substring(0, r);
        let e = document.createTextNode(c);
        o.unshift(e);
      } else {
        let e = 0,
          t = [];
        for (let n of u.childNodes) {
          let a = n.nodeType === Node.TEXT_NODE ? n.nodeValue : n.firstChild.nodeValue;
          ((e += a.length),
            e <= r
              ? t.push(n)
              : r >= e - a.length &&
                i <= e &&
                t.push(document.createTextNode(a.substring(0, r - (e - a.length)))));
        }
        o.unshift(...t);
      }
    if (i > 0) {
      l = a.str.substring(i);
      let e = document.createTextNode(l);
      o.push(e);
    }
    u.replaceChildren(...o);
  }
  for (let t of e.sort((e, t) => e.oindex - t.oindex))
    if (t.start.idx === t.end.idx) r(t.start.idx, t.start.offset, t.end.offset);
    else
      for (let e = t.start.idx, n = t.end.idx; e <= n; e++)
        e === t.start.idx ? r(e, t.start.offset) : e === t.end.idx ? r(e, -1, t.end.offset) : r(e);
}
function Sle(e, t) {
  let n = e.items.map((e) => e.str);
  for (let e = 0; e < t.length; e++) {
    let r = t[e];
    if (r && r.nodeType !== Node.TEXT_NODE) {
      let t = document.createTextNode(n[e]);
      r.replaceChildren(t);
    }
  }
}
function Cle(e, t, n) {
  let r = [];
  for (let i of e) {
    let [e, a] = ble(t, i, n);
    r.push(...v6(e, t, a));
  }
  return r;
}
var wle = [`data-main-page`],
  Tle = k({
    __name: `TextLayer`,
    props: {
      page: {},
      viewport: {},
      highlightText: {},
      highlightOptions: {},
      highlightPages: {},
    },
    emits: [`highlight`, `textLoaded`],
    setup(e, { emit: t }) {
      let n = e,
        r = t,
        i = Ge(`layer`),
        a = F(),
        o = [],
        s,
        c = R(m6);
      function l() {
        return Object.assign(
          {},
          {
            ignoreCase: !0,
            completeWords: !1,
          },
          n.highlightOptions,
        );
      }
      async function u(e = !1) {
        let t = n.page,
          i = await t?.getTextContent();
        if (
          i &&
          (e && Sle(i, o),
          n.highlightText && (!n.highlightPages || n.highlightPages.includes(t.pageNumber)))
        ) {
          let e = Cle(
            typeof n.highlightText == `string` ? [n.highlightText] : n.highlightText,
            i,
            l(),
          );
          (xle(e, i, o),
            r(`highlight`, {
              matches: e,
              textContent: i,
              textDivs: o,
              page: t?.pageNumber || 1,
            }));
        }
      }
      async function d() {
        (s?.cancel(), i.value.replaceChildren?.());
        let e = n.page,
          t = n.viewport,
          a = e?.streamTextContent({
            includeMarkedContent: !0,
            disableNormalization: !0,
          }),
          l = new x3({
            container: i.value,
            textContentSource: a,
            viewport: t,
          });
        s = l;
        try {
          (await l.render(), (o = l.textDivs));
          let t = await e?.getTextContent();
          (r(`textLoaded`, {
            textDivs: o,
            textContent: t,
          }),
            f(),
            u(),
            c.resolve(i.value));
        } catch {}
      }
      function f() {
        let e = document.createElement(`div`);
        ((e.className = `endOfContent`), i.value?.appendChild(e), (a.value = e));
      }
      function p() {
        a.value && a.value.classList.add(`active`);
      }
      function m() {
        a.value && a.value.classList.remove(`active`);
      }
      return (
        He(
          () => n.viewport,
          (e) => {
            n.page && n.viewport && i.value && d();
          },
        ),
        He(
          () => [n.highlightText, n.highlightOptions],
          (e) => {
            u(!0);
          },
          {
            deep: !0,
          },
        ),
        Qe(() => {
          n.page && n.viewport && i.value && d();
        }),
        (t, n) => (
          A(),
          M(
            `div`,
            {
              ref_key: `layer`,
              ref: i,
              class: `textLayer`,
              "data-main-page": e.page?._pageIndex,
              onMousedown: p,
              onMouseup: m,
            },
            null,
            40,
            wle,
          )
        )
      );
    },
  }),
  Ele = k({
    __name: `XFALayer`,
    props: {
      page: {},
      document: {},
      viewport: {},
    },
    emits: [`xfaLoaded`],
    setup(e, { emit: t }) {
      let n = e,
        r = t,
        i = Ge(`layer`),
        a = R(h6);
      async function o() {
        i.value.replaceChildren?.();
        let e = Xe(n.document),
          t = n.page,
          o = n.viewport;
        if (e.isPureXfa) {
          let n = await t.getXfa(),
            s = {
              div: i.value,
              viewport: o.clone({
                dontFlip: !0,
              }),
              linkService: a.linkService,
              annotationStorage: e?.annotationStorage,
              xfaHtml: n,
            };
          (c2.render(s), r(`xfaLoaded`));
        }
      }
      return (
        He(
          () => n.viewport,
          (e) => {
            n.page && n.viewport && i.value && o();
          },
        ),
        Qe(() => {
          n.page && n.viewport && i.value && o();
        }),
        (e, t) => (
          A(),
          M(
            `div`,
            {
              ref_key: `layer`,
              ref: i,
              style: {
                display: `block`,
              },
            },
            null,
            512,
          )
        )
      );
    },
  }),
  Dle = `link`,
  Ole = `internal-link`,
  kle = class {
    targets = [`_blank`, `_self`, `_parent`, `_top`];
    externalLinkEnabled;
    externalLinkTarget;
    externalLinkRel;
    #e = null;
    #t = null;
    eventBus = null;
    baseUrl;
    _ignoreDestinationZoom = !1;
    pdfDocument;
    pdfHistory;
    pdfViewer;
    constructor(e) {
      ((this.externalLinkEnabled = !0),
        (this.externalLinkTarget = this.targets.indexOf(`_blank`)),
        (this.externalLinkRel = `noopener noreferrer`),
        (this.#t = e));
    }
    setHistory(e) {
      this.pdfHistory = e;
    }
    setViewer(e) {
      this.pdfViewer = e;
    }
    setDocument(e) {
      this.#e = e;
    }
    setRootEmit(e) {
      this.#t = e;
    }
    get pagesCount() {
      return this.#e?.numPages || 0;
    }
    get page() {
      return 0;
    }
    set page(e) {}
    set rotation(e) {}
    get rotation() {
      return 0;
    }
    get isInPresentationMode() {
      return !1;
    }
    async goToDestination(e) {
      if (!this.#e) return;
      let t, n;
      if (
        ((t = typeof e == `string` ? await this.#e.getDestination(e) : await e), !Array.isArray(t))
      ) {
        console.error(`goToDestination: "${t}" is not a valid destination array, for dest="${e}".`);
        return;
      }
      let [r] = t;
      if (r && typeof r == `object`) {
        if (((n = this.#e.cachedPageNumber(r)), !n))
          try {
            n = (await this.#e.getPageIndex(r)) + 1;
          } catch {
            console.error(
              `goToDestination: "${r}" is not a valid page reference, for dest="${e}".`,
            );
            return;
          }
      } else Number.isInteger(r) && (n = r + 1);
      if (!n || n < 1 || n > this.pagesCount) {
        console.error(`goToDestination: "${n}" is not a valid page number, for dest="${e}".`);
        return;
      }
      let i = {
        left: 0,
        bottom: 0,
      };
      switch (t[1].name) {
        case `XYZ`:
        case `FitR`:
          ((i.left = t[2]), (i.bottom = t[3]));
          break;
        case `FitV`:
        case `FitBV`:
          i.left = t[2];
          break;
        case `FitH`:
        case `FitBH`:
          ((i.bottom = t[2]),
            (i.bottom === null || typeof i.bottom != `number` || i.bottom < 0) && (i.bottom = 0));
          break;
      }
      this.#t(`annotation`, {
        type: Ole,
        data: {
          referencedPage: n,
          offset: i,
        },
      });
    }
    addLinkAttributes(e, t, n = !1) {
      e.style.cursor = `pointer`;
      let r = typeof window < `u` && window.location ? window.location.href : `about:blank`,
        i;
      try {
        i = new URL(t, r);
      } catch {
        return;
      }
      if (
        (e.addEventListener(`click`, (e) => {
          this.#t(`annotation`, {
            type: Dle,
            data: {
              url: i,
              unsafeUrl: t,
            },
          });
        }),
        !this.externalLinkEnabled)
      )
        return;
      let a = i.protocol.toLowerCase();
      if (!(a === `http:` || a === `https:` || a === `mailto:` || a === `tel:`)) return;
      ((e.href = i.toString()),
        n
          ? (e.target = `_blank`)
          : this.externalLinkTarget === -1
            ? e.removeAttribute(`target`)
            : (e.target = this.targets[this.externalLinkTarget]));
      let o = this.externalLinkRel;
      e.rel = o.includes(`noopener`) ? o : `noopener ${o}`.trim();
    }
    getDestinationHash(e) {
      return `#`;
    }
    getAnchorUrl(e) {
      return `#`;
    }
    setExternalLinkTarget(e) {
      this.externalLinkTarget = this.targets.indexOf(e);
    }
    setExternalLinkRel(e) {
      this.externalLinkRel = e;
    }
    setExternalLinkEnabled(e) {
      this.externalLinkEnabled = e;
    }
    setHash(e) {}
    executeNamedAction(e) {}
    executeSetOCGState(e) {
      return new Promise(() => {});
    }
    cachePageRef(e, t) {}
    goToPage(e) {}
    goToXY(e, t, n) {}
  },
  Ale = ((e, t) => {
    let n = e.__vccOpts || e;
    for (let [e, r] of t) n[e] = r;
    return n;
  })(
    k({
      __name: `VuePDF`,
      props: {
        pdf: {},
        page: {
          default: 1,
        },
        scale: {
          default: 1,
        },
        rotation: {},
        fitParent: {
          type: Boolean,
        },
        width: {},
        height: {},
        textLayer: {
          type: Boolean,
        },
        autoDestroy: {
          type: Boolean,
          default: !1,
        },
        imageResourcesPath: {},
        hideForms: {
          type: Boolean,
        },
        intent: {
          default: `display`,
        },
        annotationLayer: {
          type: Boolean,
        },
        annotationsFilter: {},
        annotationsMap: {},
        watermarkText: {},
        watermarkOptions: {},
        highlightText: {},
        highlightOptions: {},
        highlightPages: {},
        editorLayer: {
          type: Boolean,
        },
        editorType: {
          default: 0,
        },
        externalLinkEnabled: {
          type: Boolean,
          default: !0,
        },
        externalLinkTarget: {
          default: `_blank`,
        },
      },
      emits: [
        `annotation`,
        `highlight`,
        `loaded`,
        `textLoaded`,
        `annotationLoaded`,
        `xfaLoaded`,
        `editorLoaded`,
        `editorAdded`,
        `editorRemoved`,
        `editorSelected`,
      ],
      setup(e, { expose: t, emit: n }) {
        let r = e,
          i = n,
          a = Ge(`container`),
          o = Ge(`canvasWrapper`),
          s = Ge(`loadingLayer`),
          c = F(!1),
          l,
          u = V(() => ({
            viewport: void 0,
            document: void 0,
            page: void 0,
          })),
          d = V(() => ({
            annotationsMap: r.annotationsMap,
            annotationsFilter: r.annotationsFilter,
            externalLinkEnabled: r.externalLinkEnabled,
            externalLinkTarget: r.externalLinkTarget,
            imageResourcesPath: r.imageResourcesPath,
            hideForms: r.hideForms,
            intent: r.intent,
          })),
          f = V(() => ({
            highlightText: r.highlightText,
            highlightOptions: r.highlightOptions,
            highlightPages: r.highlightPages,
          })),
          p = V(() => ({
            editorLayer: r.editorLayer,
            editorType: r.editorType,
            intent: r.intent,
          })),
          m,
          h;
        (ge(p6, {
          promise: new Promise((e) => {
            m = e;
          }),
          resolve: (e) => m(e),
        }),
          ge(m6, {
            promise: new Promise((e) => {
              h = e;
            }),
            resolve: (e) => h(e),
          }));
        let g = {
          wrapper: o,
          container: a,
          uiManager: null,
          linkService: new kle(i),
        };
        ge(h6, g);
        function v() {
          return Object.assign(
            {},
            {
              columns: 4,
              rows: 4,
              rotation: 45,
              fontSize: 18,
              color: `rgba(211, 210, 211, 0.4)`,
            },
            r.watermarkOptions,
          );
        }
        function y(e) {
          if (!(typeof e == `number` && e % 90 == 0)) return 0;
          let t = e / 90;
          return t > 4 ? y(e - 360) : t < 0 ? y(e + 360) : e;
        }
        function b(e) {
          let t = r.scale;
          if (r.fitParent)
            t =
              o.value.parentNode.clientWidth /
              e.getViewport({
                scale: 1,
              }).width;
          else if (r.width) {
            let n = e.getViewport({
              scale: 1,
            }).width;
            t = r.width / n;
          } else if (r.height) {
            let n = e.getViewport({
              scale: 1,
            }).height;
            t = r.height / n;
          }
          return t;
        }
        function x(e = 1) {
          if (!r.watermarkText) return;
          let t = S();
          if (!t) return;
          let n = t.getContext(`2d`);
          if (!n) return;
          let i = v(),
            a = r.watermarkText,
            o = i.columns,
            s = i.rows,
            c = o * s,
            l = i.rotation,
            u = i.fontSize * e;
          ((n.font = `${u}px Trebuchet MS`), (n.fillStyle = i.color));
          for (let e = 0; e < c; e++) {
            let r = (e % o) * (t.width / o) + t.width / (o * 2),
              i = Math.floor(e / o) * (t.height / s) + t.height / (s * 2),
              c = n.measureText(a).width;
            (n.save(),
              n.translate(r, i),
              n.rotate(-l * (Math.PI / 180)),
              n.fillText(a, -c / 2, u / 2),
              n.restore());
          }
        }
        function S() {
          let e = null;
          return (
            o.value?.childNodes.forEach((t) => {
              t.tagName === `CANVAS` && (e = t);
            }),
            e
          );
        }
        function C(e) {
          let t,
            n = S();
          n && n?.getAttribute(`role`) === `main`
            ? (t = n)
            : ((t = document.createElement(`canvas`)),
              (t.style.display = `block`),
              t.setAttribute(`dir`, `ltr`));
          let r = window.devicePixelRatio || 1;
          return (
            (t.width = Math.floor(e.width * r)),
            (t.height = Math.floor(e.height * r)),
            (t.style.width = `${Math.floor(e.width)}px`),
            (t.style.height = `${Math.floor(e.height)}px`),
            a.value?.style.setProperty(`--scale-factor`, `${e.scale}`),
            a.value?.style.setProperty(`--user-unit`, `${e.userUnit}`),
            a.value?.style.setProperty(`--scale-round-y`, `1px`),
            a.value?.style.setProperty(`--scale-round-x`, `1px`),
            a.value?.style.setProperty(
              `--total-scale-factor`,
              `calc(var(--scale-factor) * var(--user-unit))`,
            ),
            (s.value.style.width = `${Math.floor(e.width)}px`),
            (s.value.style.height = `${Math.floor(e.height)}px`),
            (s.value.style.top = `0`),
            (s.value.style.left = `0`),
            (c.value = !0),
            t
          );
        }
        function w() {
          l && l.cancel();
        }
        function T(e) {
          Xe(u.value.document)
            ?.getPage(e)
            .then((e) => {
              w();
              let t = e.getViewport(),
                n = {
                  scale: b(e),
                  rotation: y((r.rotation || 0) + t.rotation),
                },
                a = e.getViewport(n),
                s = S(),
                d = C(a),
                f = window.devicePixelRatio || 1,
                p = f === 1 ? void 0 : [f, 0, 0, f, 0, 0],
                m = {
                  canvas: d,
                  viewport: a,
                  annotationMode: r.hideForms ? p0.ENABLE : p0.ENABLE_FORMS,
                  transform: p,
                  intent: r.intent,
                };
              (d?.getAttribute(`role`) === `main`
                ? d.removeAttribute(`role`)
                : s && o.value?.replaceChild(d, s),
                g.linkService.setDocument(u.value.document),
                (u.value.page = e),
                (u.value.viewport = a),
                (l = e.render(m)),
                l.promise
                  .then(() => {
                    ((c.value = !1), x(a.scale), i(`loaded`, u.value.viewport));
                  })
                  .catch(() => {}));
            });
        }
        function D(e) {
          e.promise.then(async (e) => {
            ((u.value.document = e), T(r.page));
          });
        }
        (He(
          () => r.pdf,
          (e, t) => {
            (w(), t && t !== e && !r.autoDestroy && t.destroy(), e !== void 0 && D(e));
          },
        ),
          He(
            () => [r.scale, r.width, r.height, r.rotation, r.page, r.hideForms, r.intent],
            () => {
              T(r.page);
            },
          ),
          Qe(() => {
            r.pdf !== void 0 && D(r.pdf);
          }),
          E(() => {
            r.autoDestroy && r.pdf?.destroy();
          }));
        function ee() {
          r.pdf?.destroy();
        }
        function te() {
          T(r.page);
        }
        function O() {
          w();
        }
        return (
          t({
            reload: te,
            cancel: O,
            destroy: ee,
          }),
          (t, n) => (
            A(),
            M(
              `div`,
              {
                ref_key: `container`,
                ref: a,
                class: `page`,
                style: {
                  position: `relative`,
                  "background-clip": `content-box`,
                },
              },
              [
                W(
                  `div`,
                  {
                    ref_key: `canvasWrapper`,
                    ref: o,
                    class: `canvasWrapper`,
                  },
                  [
                    ...(n[9] ||= [
                      W(
                        `canvas`,
                        {
                          dir: `ltr`,
                          role: `main`,
                        },
                        null,
                        -1,
                      ),
                    ]),
                  ],
                  512,
                ),
                e.textLayer
                  ? (A(),
                    L(
                      Tle,
                      ce(
                        {
                          key: 0,
                        },
                        {
                          ...u.value,
                          ...f.value,
                        },
                        {
                          onHighlight: (n[0] ||= (e) => i(`highlight`, e)),
                          onTextLoaded: (n[1] ||= (e) => i(`textLoaded`, e)),
                        },
                      ),
                      null,
                      16,
                    ))
                  : U(``, !0),
                e.annotationLayer
                  ? (A(),
                    L(
                      gle,
                      ce(
                        {
                          key: 1,
                        },
                        {
                          ...u.value,
                          ...d.value,
                        },
                        {
                          onAnnotation: (n[2] ||= (e) => i(`annotation`, e)),
                          onAnnotationLoaded: (n[3] ||= (e) => i(`annotationLoaded`, e)),
                        },
                      ),
                      null,
                      16,
                    ))
                  : U(``, !0),
                N(
                  yle,
                  ce(
                    {
                      ...u.value,
                      ...p.value,
                    },
                    {
                      onEditorAdded: (n[4] ||= (e) => i(`editorAdded`, e)),
                      onEditorRemoved: (n[5] ||= (e) => i(`editorRemoved`, e)),
                      onEditorSelected: (n[6] ||= (e) => i(`editorSelected`, e)),
                      onEditorLoaded: (n[7] ||= (e) => i(`editorLoaded`)),
                    },
                  ),
                  {
                    default: I(() => [z(t.$slots, `editors`, {}, void 0, !0)]),
                    _: 3,
                  },
                  16,
                ),
                N(
                  Ele,
                  ce(
                    {
                      ...u.value,
                    },
                    {
                      onXfaLoaded: (n[8] ||= (e) => i(`xfaLoaded`)),
                    },
                  ),
                  null,
                  16,
                ),
                Re(
                  W(
                    `div`,
                    {
                      ref_key: `loadingLayer`,
                      ref: s,
                      style: {
                        position: `absolute`,
                      },
                    },
                    [z(t.$slots, `default`, {}, void 0, !0)],
                    512,
                  ),
                  [[Ee, c.value]],
                ),
                z(
                  t.$slots,
                  `overlay`,
                  {
                    width: u.value.viewport?.width,
                    height: u.value.viewport?.height,
                  },
                  void 0,
                  !0,
                ),
              ],
              512,
            )
          )
        );
      },
    }),
    [[`__scopeId`, `data-v-f567e772`]],
  );
function jle(e) {
  return !!(typeof e == `object` && e && `gen` in e && `num` in e);
}
async function Mle(e, t) {
  return typeof t == `string` ? e.getDestination(t) : t;
}
async function Nle(e, t) {
  return t && jle(t[0]) ? t[0] : null;
}
var Ple = (e) => e.type === `XYZ` && e.spec.length === 3,
  Fle = (e) => e.type === `Fit` && e.spec.length === 0,
  Ile = (e) => e.type === `FitH` && e.spec.length === 1,
  Lle = (e) => e.type === `FitV` && e.spec.length === 1,
  Rle = (e) => e.type === `FitR` && e.spec.length === 4,
  zle = (e) => e.type === `FitB` && e.spec.length === 0,
  Ble = (e) => e.type === `FitBH` && e.spec.length === 1,
  Vle = (e) => e.type === `FitBV` && e.spec.length === 1;
function Hle(e, t) {
  let n = {
    type: e,
    spec: t,
  };
  return Ple(n) || Fle(n) || Ile(n) || Lle(n) || Rle(n) || zle(n) || Ble(n) || Vle(n)
    ? n
    : (console.warn(`no location type found for `, e, t), null);
}
var Ule = (e) => e && e.every((e) => !isNaN(e));
async function Wle() {
  return new Promise((e, t) => {
    let n = document.createElement(`iframe`);
    ((n.width = `0px`),
      (n.height = `0px`),
      (n.style.cssText = `position: absolute; top:0; left:0`),
      (n.style.display = `none`),
      (n.onload = function () {
        e(n);
      }),
      document.body.appendChild(n));
  });
}
function Gle(e, t, n) {
  let r = e.document.createElement(`style`);
  ((r.textContent = `
    @page {
      margin: 0;
      size: ${t}pt ${n}pt;
    }
    body {
      margin: 0;
      width: 100%;
    }
    canvas {
      page-break-after: always;
      page-break-before: avoid;
      page-break-inside: avoid;
    }
  `),
    e.document.head.appendChild(r));
}
function Kle(
  e,
  t = {
    onProgress: void 0,
    onPassword: void 0,
    onError: void 0,
    password: ``,
  },
) {
  let n = xe(),
    r = xe(),
    i = xe(0),
    a = xe({});
  function o(e) {
    (n.value && n.value.destroy(), r.value && r.value.destroy());
    let o = S3(e);
    (t.onProgress && (o.onProgress = t.onProgress),
      t.onPassword
        ? (o.onPassword = t.onPassword)
        : t.password &&
          (o.onPassword = (e, n) => {
            e(t.password ?? ``);
          }),
      o.promise.then(
        async (e) => {
          ((r.value = e),
            (n.value = e.loadingTask),
            (i.value = e.numPages),
            (a.value = {
              metadata: await e.getMetadata(),
              attachments: await e.getAttachments(),
              javascript: await e.getJSActions(),
              outline: await e.getOutline(),
            }));
        },
        (e) => {
          typeof t.onError == `function` && t.onError(e);
        },
      ));
  }
  async function s(e) {
    let t = await n.value?.promise;
    if (!t) return null;
    let r = await Mle(t, e),
      i = await Nle(t, r);
    if (!i || !r) return null;
    let a = await t.getPageIndex(i),
      o = r[1].name,
      s = r.slice(2);
    return {
      pageIndex: a,
      location: (Ule(s) ? Hle(o, s) : null) ?? {
        type: `Fit`,
        spec: [],
      },
    };
  }
  async function c() {
    if (!r.value) throw Error(`Current PDFDocumentProxy have not loaded yet`);
    try {
      return await r.value.saveDocument();
    } catch (e) {
      return (console.error(`Error saving PDF document:`, e), await r.value.getData());
    }
  }
  async function l(e = `filename`) {
    let t = await c(),
      n = new Blob([t], {
        type: `application/pdf`,
      }),
      r = URL.createObjectURL(n),
      i = document.createElement(`a`);
    (document.body.appendChild(i),
      (i.href = r),
      (i.download = e),
      (i.style.display = `none`),
      i.click(),
      setTimeout(() => {
        (URL.revokeObjectURL(r), document.body.removeChild(i));
      }, 10));
  }
  async function u(e = 150, t = `filename`) {
    if (!n.value) throw Error(`Current PDFDocumentLoadingTask have not loaded yet`);
    let r = await n.value.promise,
      i = e / 72,
      a = 96 / 72,
      o = await Wle(),
      s = o.contentWindow;
    s.document.title = t;
    let c = [...Array(r.numPages).keys()].map((e) => e + 1);
    for (let e of c) {
      let t = await r.getPage(e),
        n = t.getViewport({
          scale: 1,
        });
      e === 1 && Gle(s, (n.width * i) / a, (n.height * i) / a);
      let o = document.createElement(`canvas`);
      ((o.width = n.width * i), (o.height = n.height * i));
      let c = o.cloneNode();
      (s?.document.body.appendChild(c),
        await t?.render({
          canvas: o,
          intent: `print`,
          transform: [i, 0, 0, i, 0, 0],
          viewport: n,
        }).promise,
        c.getContext(`2d`)?.drawImage(o, 0, 0));
    }
    (s?.focus(), s?.print(), document.body.removeChild(o));
  }
  return (
    Be(e)
      ? (e.value && o(e.value),
        He(e, () => {
          e.value && o(e.value);
        }))
      : e && o(e),
    {
      pdf: n,
      pages: i,
      info: a,
      print: u,
      download: l,
      getPDFDestination: s,
    }
  );
}
function qle(e) {
  h3.workerSrc = e;
}
h3?.workerSrc || qle(Xce);
var Jle = i({
  default: () => fue,
});
B();
var Yle = {
    class: `space-y-4 text-gray-800 dark:text-gray-400`,
  },
  Xle = {
    key: 0,
    class: `font-semibold`,
  },
  Zle = [`onClick`],
  Qle = {
    class: `flex items-start justify-between`,
  },
  $le = {
    class: `flex cursor-pointer`,
  },
  eue = {
    class: `mr-4`,
  },
  tue = {
    class: `flex flex-col`,
  },
  nue = {
    key: 0,
    class: `px-4 py-2`,
  },
  rue = [`onClick`],
  iue = {
    class: `mr-4`,
  },
  aue = {
    class: `flex flex-col`,
  },
  oue = {
    key: 0,
    class: `flex items-center justify-center`,
  },
  sue = {
    key: 0,
    class: `flex justify-center space-x-2`,
  },
  cue = {
    class: `scroller-thin-x`,
  },
  lue = {
    key: 1,
    class: `absolute inset-0 flex items-center justify-center`,
  },
  uue = {
    key: 1,
    class: `flex items-center justify-center`,
  },
  due = [`src`],
  fue = Object.assign(
    {
      name: `ListMedia`,
    },
    {
      props: {
        module: {
          type: Object,
          default: {},
        },
        media: {
          type: Array,
          default: [],
        },
        section: {
          type: String,
          default: ``,
        },
        url: {
          type: String,
          default: `/`,
        },
        grid: {
          type: Number,
          default: 4,
        },
        showNoMediaAlert: {
          type: Boolean,
          default: !0,
        },
        showPreview: {
          type: Boolean,
          default: !0,
        },
        additionalQueryParams: {
          type: Object,
          default: {},
        },
        layout: {
          type: String,
          default: `list`,
        },
        showDeleteAction: {
          type: Boolean,
          default: !1,
        },
        deleteUrl: {
          type: String,
          default: ``,
        },
      },
      emits: [`refresh`],
      setup(e, { emit: t }) {
        let n = $e(),
          r = t,
          i = e,
          a = R(`$trans`),
          o = V(() => n.getters[`config/config`](`system.url`)),
          s = V(() => Object.keys(c.value).length),
          c = V(() => {
            let e = i.media;
            return (
              i.section && (e = e.filter((e) => e.section == i.section)),
              e.reduce(
                (e, t) => (
                  t.sectionName
                    ? (e[t.sectionName] || (e[t.sectionName] = []), e[t.sectionName].push(t))
                    : ((e.default ||= []), e.default.push(t)),
                  e
                ),
                {},
              )
            );
          }),
          l = F(1),
          u = F(``),
          d = Ae({
            selectedItem: {},
            showPreview: !1,
            isLoading: !1,
          }),
          { pdf: f, pages: p } = Kle(u),
          m = (e) => {
            e.isPreviewable && i.showPreview
              ? ((d.selectedItem = e),
                (d.isLoading = !0),
                e.mime == `application/pdf` && (l.value = 1),
                (u.value = o.value + i.url + `media/` + e.uuid),
                (d.showPreview = !0))
              : ((d.selectedItem = {}), h(e.uuid));
          },
          h = (e) => {
            let t = {
                action: `download`,
                ...i.additionalQueryParams,
              },
              n = o.value + i.url + `media/` + e;
            window.open(et(n, t));
          },
          g = async (e) => {
            (await lb()) &&
              ((d.isLoading = !0),
              await n
                .dispatch(i.deleteUrl, {
                  uuid: i.module.uuid,
                  moduleUuid: e.uuid,
                })
                .then(() => {
                  ((d.isLoading = !1), r(`refresh`));
                })
                .catch((e) => {
                  d.isLoading = !1;
                }));
          },
          v = [
            {
              key: `name`,
              label: a(`general.file`),
              visibility: !0,
            },
            {
              key: `user`,
              label: a(`user.user`),
              visibility: !0,
            },
            {
              key: `createdAt`,
              label: a(`general.created_at`),
              visibility: !0,
            },
            {
              key: `action`,
              label: ``,
              visibility: !0,
            },
          ];
        return (t, n) => {
          let r = j(`BaseAlert`),
            i = j(`DataCell`),
            o = j(`FloatingMenuItem`),
            y = j(`FloatingMenu`),
            b = j(`DataRow`),
            x = j(`SimpleTable`),
            S = j(`BaseButton`),
            C = j(`BaseModal`);
          return (
            A(),
            M(
              ke,
              null,
              [
                e.layout == `list`
                  ? (A(),
                    M(
                      ke,
                      {
                        key: 0,
                      },
                      [
                        W(`div`, Yle, [
                          (A(!0),
                          M(
                            ke,
                            null,
                            ae(
                              c.value,
                              (n, r) => (
                                A(),
                                M(`div`, null, [
                                  s.value > 1 ? (A(), M(`h4`, Xle, T(r), 1)) : U(``, !0),
                                  W(
                                    `div`,
                                    {
                                      class: O([
                                        `mt-2 grid gap-2`,
                                        {
                                          "grid-cols-4": e.grid === 4,
                                          "grid-cols-3": e.grid === 3,
                                          "grid-cols-2": e.grid === 2,
                                          "grid-cols-1": e.grid === 1,
                                        },
                                      ]),
                                    },
                                    [
                                      (A(!0),
                                      M(
                                        ke,
                                        null,
                                        ae(
                                          n,
                                          (n) => (
                                            A(),
                                            M(
                                              `div`,
                                              {
                                                onClick: (e) => m(n),
                                                class: O([
                                                  `sm:col-span-1`,
                                                  {
                                                    "col-span-4": e.grid === 4,
                                                    "col-span-3": e.grid === 3,
                                                    "col-span-2": e.grid === 2,
                                                    "col-span-1": e.grid === 1,
                                                  },
                                                ]),
                                              },
                                              [
                                                W(`div`, Qle, [
                                                  W(`div`, $le, [
                                                    W(`span`, eue, [
                                                      W(
                                                        `i`,
                                                        {
                                                          class: O([`fas text-4xl`, n.icon]),
                                                        },
                                                        null,
                                                        2,
                                                      ),
                                                    ]),
                                                    W(`div`, tue, [
                                                      W(`span`, null, T(n.name), 1),
                                                      W(`span`, null, T(n.size), 1),
                                                    ]),
                                                  ]),
                                                  W(`div`, null, [z(t.$slots, `default`)]),
                                                ]),
                                              ],
                                              10,
                                              Zle,
                                            )
                                          ),
                                        ),
                                        256,
                                      )),
                                    ],
                                    2,
                                  ),
                                ])
                              ),
                            ),
                            256,
                          )),
                        ]),
                        e.media.length === 0 && e.showNoMediaAlert
                          ? (A(),
                            L(
                              r,
                              {
                                key: 0,
                                design: `info`,
                                size: `xs`,
                              },
                              {
                                default: I(() => [
                                  H(T(P(a)(`general.errors.attachment_not_found`)), 1),
                                ]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                      ],
                      64,
                    ))
                  : U(``, !0),
                e.layout == `table`
                  ? (A(),
                    M(
                      ke,
                      {
                        key: 1,
                      },
                      [
                        e.media.length == 0
                          ? (A(),
                            M(`div`, nue, [
                              N(
                                r,
                                {
                                  size: `xs`,
                                  design: `info`,
                                },
                                {
                                  default: I(() => [
                                    H(T(P(a)(`general.errors.attachment_not_found`)), 1),
                                  ]),
                                  _: 1,
                                },
                              ),
                            ]))
                          : U(``, !0),
                        e.media.length > 0
                          ? (A(),
                            L(
                              x,
                              {
                                key: 1,
                                header: v,
                              },
                              {
                                default: I(() => [
                                  (A(!0),
                                  M(
                                    ke,
                                    null,
                                    ae(
                                      e.media,
                                      (t) => (
                                        A(),
                                        L(
                                          b,
                                          {
                                            key: e.media.uuid,
                                          },
                                          {
                                            default: I(() => [
                                              N(
                                                i,
                                                {
                                                  name: `name`,
                                                },
                                                {
                                                  default: I(() => [
                                                    W(
                                                      `div`,
                                                      {
                                                        class: `flex cursor-pointer`,
                                                        onClick: (e) => m(t),
                                                      },
                                                      [
                                                        W(`span`, iue, [
                                                          W(
                                                            `i`,
                                                            {
                                                              class: O([`fas text-4xl`, t.icon]),
                                                            },
                                                            null,
                                                            2,
                                                          ),
                                                        ]),
                                                        W(`div`, aue, [
                                                          W(`span`, null, T(t.name), 1),
                                                          W(`span`, null, T(t.size), 1),
                                                        ]),
                                                      ],
                                                      8,
                                                      rue,
                                                    ),
                                                  ]),
                                                  _: 2,
                                                },
                                                1024,
                                              ),
                                              N(
                                                i,
                                                {
                                                  name: `user`,
                                                },
                                                {
                                                  default: I(() => [
                                                    H(T(t.user?.profile?.name), 1),
                                                  ]),
                                                  _: 2,
                                                },
                                                1024,
                                              ),
                                              N(
                                                i,
                                                {
                                                  name: `createdAt`,
                                                },
                                                {
                                                  default: I(() => [
                                                    H(T(t.createdAt.formatted), 1),
                                                  ]),
                                                  _: 2,
                                                },
                                                1024,
                                              ),
                                              N(
                                                i,
                                                {
                                                  name: `action`,
                                                },
                                                {
                                                  default: I(() => [
                                                    e.showDeleteAction
                                                      ? (A(),
                                                        L(
                                                          y,
                                                          {
                                                            key: 0,
                                                          },
                                                          {
                                                            default: I(() => [
                                                              N(
                                                                o,
                                                                {
                                                                  icon: `fas fa-trash`,
                                                                  onClick: (e) => g(t),
                                                                },
                                                                {
                                                                  default: I(() => [
                                                                    H(T(P(a)(`general.delete`)), 1),
                                                                  ]),
                                                                  _: 1,
                                                                },
                                                                8,
                                                                [`onClick`],
                                                              ),
                                                            ]),
                                                            _: 2,
                                                          },
                                                          1024,
                                                        ))
                                                      : U(``, !0),
                                                  ]),
                                                  _: 2,
                                                },
                                                1024,
                                              ),
                                            ]),
                                            _: 2,
                                          },
                                          1024,
                                        )
                                      ),
                                    ),
                                    128,
                                  )),
                                ]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                      ],
                      64,
                    ))
                  : U(``, !0),
                N(
                  C,
                  {
                    show: d.showPreview,
                    onClose: (n[4] ||= (e) => (d.showPreview = !1)),
                  },
                  {
                    title: I(() => [
                      H(T(d.selectedItem.name) + ` `, 1),
                      N(
                        S,
                        {
                          size: `xs`,
                          onClick: (n[0] ||= (e) => h(d.selectedItem.uuid)),
                        },
                        {
                          default: I(() => [
                            H(T(P(a)(`general.download`)) + ` `, 1),
                            (n[5] ||= W(
                              `i`,
                              {
                                class: `ml-2 fas fa-download`,
                              },
                              null,
                              -1,
                            )),
                          ]),
                          _: 1,
                        },
                      ),
                    ]),
                    default: I(() => [
                      d.selectedItem.mime == `application/pdf`
                        ? (A(),
                          M(`div`, oue, [
                            W(`div`, null, [
                              d.isLoading
                                ? U(``, !0)
                                : (A(),
                                  M(`div`, sue, [
                                    W(
                                      `button`,
                                      {
                                        onClick: (n[1] ||= (e) =>
                                          (l.value = l.value > 1 ? l.value - 1 : l.value)),
                                      },
                                      T(P(a)(`pagination.previous`)),
                                      1,
                                    ),
                                    W(`span`, null, T(l.value) + ` / ` + T(P(p)), 1),
                                    W(
                                      `button`,
                                      {
                                        onClick: (n[2] ||= (e) =>
                                          (l.value = l.value < P(p) ? l.value + 1 : l.value)),
                                      },
                                      T(P(a)(`pagination.next`)),
                                      1,
                                    ),
                                  ])),
                              W(`div`, cue, [
                                N(
                                  P(Ale),
                                  {
                                    pdf: P(f),
                                    page: l.value,
                                    onLoaded: (n[3] ||= (e) => (d.isLoading = !1)),
                                    style: {
                                      overflow: `visible`,
                                    },
                                  },
                                  null,
                                  8,
                                  [`pdf`, `page`],
                                ),
                              ]),
                              d.isLoading
                                ? (A(), M(`div`, lue, T(P(a)(`general.loading`)), 1))
                                : U(``, !0),
                            ]),
                          ]))
                        : U(``, !0),
                      d.selectedItem.isImage
                        ? (A(),
                          M(`div`, uue, [
                            W(
                              `img`,
                              {
                                src: u.value,
                                alt: ``,
                              },
                              null,
                              8,
                              due,
                            ),
                          ]))
                        : U(``, !0),
                    ]),
                    _: 1,
                  },
                  8,
                  [`show`],
                ),
              ],
              64,
            )
          );
        };
      },
    },
  ),
  pue = i({
    default: () => gue,
  });
B();
var mue = {
    key: 0,
    class: `sticky top-0 border-b border-b-gray-900 bg-black px-6 py-2 text-gray-300`,
  },
  hue = [`innerHTML`],
  gue = Object.assign(
    {
      name: `NotificationBar`,
    },
    {
      props: {
        type: {
          type: String,
          required: !0,
        },
      },
      setup(e) {
        let t = e,
          n = F(!1),
          r = F(null);
        return (
          t.type == `guest`
            ? ((n.value = Vh(`notification.enableGuestNotificationBar`).value),
              (r.value = Vh(`notification.guestNotificationMessage`).value))
            : t.type == `app` &&
              ((n.value = Vh(`notification.enableAppNotificationBar`).value),
              (r.value = Vh(`notification.appNotificationMessage`).value)),
          (e, t) => {
            let i = j(`Vue3Marquee`);
            return n.value
              ? (A(),
                M(`div`, mue, [
                  N(i, null, {
                    default: I(() => [
                      W(
                        `div`,
                        {
                          class: `px-4`,
                          innerHTML: r.value,
                        },
                        null,
                        8,
                        hue,
                      ),
                    ]),
                    _: 1,
                  }),
                ]))
              : U(``, !0);
          }
        );
      },
    },
  ),
  _ue = i({
    default: () => yue,
  });
B();
var vue = {
    key: 0,
    class: `mt-1 text-xs`,
  },
  yue = Object.assign(
    {
      name: `ProgressBar`,
    },
    {
      props: {
        percent: {
          type: Number,
          default: 100,
        },
        value: {
          type: [Number, String],
          default: ``,
        },
        max: {
          type: [Number, String],
          default: ``,
        },
        color: {
          type: String,
          default: `default`,
        },
        bgColor: {
          type: String,
          default: ``,
        },
        showLabel: {
          type: Boolean,
          default: !1,
        },
        space: {
          type: Boolean,
          default: !1,
        },
        rounded: {
          type: Boolean,
          default: !1,
        },
        height: {
          type: String,
          validator(e) {
            return [`h-1`, `h-2`, `h-3`, `h-4`, `h-5`].includes(e);
          },
          default: `h-1`,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `div`,
            {
              class: O([
                `w-full`,
                [
                  e.space ? `my-2` : ``,
                  e.rounded ? `rounded-full` : ``,
                  e.bgColor == `transparent` ? `bg-transparent` : `dark:bg-dark-body bg-gray-200`,
                  e.height,
                ],
              ]),
            },
            [
              W(
                `div`,
                {
                  class: O([e.color, e.height, e.rounded ? `rounded-full` : ``]),
                  style: Pe(`width: ${e.percent}%`),
                },
                null,
                6,
              ),
              e.showLabel && e.max
                ? (A(), M(`div`, vue, T(e.value) + ` / ` + T(e.max), 1))
                : U(``, !0),
            ],
            2,
          )
        );
      },
    },
  ),
  bue = i({
    default: () => Tue,
  });
B();
var xue = {
    class: `flex items-center space-x-1`,
  },
  Sue = {
    class: `fa-stack`,
    style: {
      width: `1em`,
    },
  },
  Cue = {
    key: 0,
    class: `fas fa-star fa-lg fa-stack-1x text-yellow-500`,
  },
  wue = {
    key: 1,
    class: `fas fa-star-half fa-lg fa-stack-1x text-yellow-500`,
  },
  Tue = Object.assign(
    {
      name: `RatingStar`,
    },
    {
      props: {
        rating: {
          type: Array,
          default: [],
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(`div`, xue, [
            (A(!0),
            M(
              ke,
              null,
              ae(
                e.rating,
                (e) => (
                  A(),
                  M(`span`, Sue, [
                    (n[0] ||= W(
                      `i`,
                      {
                        class: `far fa-star fa-lg fa-stack-1x text-yellow-500`,
                      },
                      null,
                      -1,
                    )),
                    e == `full` ? (A(), M(`i`, Cue)) : e == `half` ? (A(), M(`i`, wue)) : U(``, !0),
                  ])
                ),
              ),
              256,
            )),
          ])
        );
      },
    },
  ),
  Eue = i({
    default: () => jue,
  });
B();
var Due = {},
  Oue = {
    class: `scroller-thin-x overflow-x-auto`,
  },
  kue = {
    class: `isolate inline-flex divide-x divide-gray-200 dark:divide-gray-700 rounded-lg shadow min-w-full`,
    "aria-label": `Tabs`,
  };
function Aue(e, t) {
  return (A(), M(`div`, Oue, [W(`nav`, kue, [z(e.$slots, `default`)])]));
}
var jue = tu(Due, [[`render`, Aue]]),
  Mue = i({
    default: () => Nue,
  });
B();
var Nue = {
    __name: `ScrollableTabItem`,
    props: {
      label: {
        type: String,
        required: !0,
      },
      first: {
        type: Boolean,
        default: !1,
      },
      last: {
        type: Boolean,
        default: !1,
      },
      isActive: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [`click`],
    setup(e, { emit: t }) {
      return (t, n) => (
        A(),
        M(
          `div`,
          {
            class: O([
              `cursor-pointer group relative whitespace-nowrap overflow-hidden bg-white dark:bg-dark-body py-2 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10`,
              {
                "text-gray-900 dark:text-gray-400 rounded-none": e.first,
                "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover-text-gray-600":
                  !e.first && !e.last,
                "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover-text-gray-600 rounded-none":
                  e.last,
              },
            ]),
            onClick: (n[0] ||= (e) => t.$emit(`click`)),
          },
          [
            W(`span`, null, T(e.label), 1),
            W(
              `span`,
              {
                "aria-hidden": `true`,
                class: O([
                  `absolute inset-x-0 bottom-0 h-0.5`,
                  {
                    "bg-transparent": !e.isActive,
                    "bg-primary dark:bg-gray-400": e.isActive,
                  },
                ]),
              },
              null,
              2,
            ),
          ],
          2,
        )
      );
    },
  },
  Pue = i({
    default: () => Fue,
  });
B();
var Fue = Object.assign(
    {
      name: `ShowDateTime`,
    },
    {
      props: {
        value: {
          type: String,
          default: ``,
        },
        as: {
          type: String,
          default: `date`,
        },
        convert: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = R(`$cal`),
          n = e;
        $e();
        let r = V(() => (n.convert ? t.toUserTimezone(n.value, n.as) : n.value));
        return (e, t) => (A(), M(`span`, null, T(r.value), 1));
      },
    },
  ),
  Iue = i({
    default: () => Bue,
  });
B();
var Lue = {},
  Rue = {
    class: `isolate flex divide-x divide-gray-200 dark:divide-gray-700 rounded-lg shadow`,
    "aria-label": `Tabs`,
  };
function zue(e, t) {
  return (A(), M(`nav`, Rue, [z(e.$slots, `default`)]));
}
var Bue = tu(Lue, [[`render`, zue]]),
  Hue = i({
    default: () => Uue,
  });
B();
var Uue = {
    __name: `TabItem`,
    props: {
      label: {
        type: String,
        required: !0,
      },
      first: {
        type: Boolean,
        default: !1,
      },
      last: {
        type: Boolean,
        default: !1,
      },
      isActive: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [`click`],
    setup(e, { emit: t }) {
      return (t, n) => (
        A(),
        M(
          `div`,
          {
            class: O([
              `cursor-pointer`,
              {
                "text-gray-900 dark:text-gray-400 rounded-none group relative min-w-0 flex-1 overflow-hidden bg-white dark:bg-dark-body py-2 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10":
                  e.first,
                "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover-text-gray-600 group relative min-w-0 flex-1 overflow-hidden bg-white dark:bg-dark-body py-2 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10":
                  !e.first && !e.last,
                "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover-text-gray-600 rounded-none group relative min-w-0 flex-1 overflow-hidden bg-white dark:bg-dark-body py-2 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10":
                  e.last,
              },
            ]),
            onClick: (n[0] ||= (e) => t.$emit(`click`)),
          },
          [
            W(`span`, null, T(e.label), 1),
            W(
              `span`,
              {
                "aria-hidden": `true`,
                class: O([
                  `absolute inset-x-0 bottom-0 h-0.5`,
                  {
                    "bg-transparent": !e.isActive,
                    "bg-primary dark:bg-gray-400": e.isActive,
                  },
                ]),
              },
              null,
              2,
            ),
          ],
          2,
        )
      );
    },
  },
  Wue = i({
    default: () => Kue,
  });
B();
var Gue = {
    class: `flex flex-wrap`,
  },
  Kue = Object.assign(
    {
      name: `TagList`,
    },
    {
      props: {
        tags: {
          type: Array,
          required: !0,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`BaseBadge`);
          return (
            A(),
            M(`div`, Gue, [
              (A(!0),
              M(
                ke,
                null,
                ae(
                  e.tags,
                  (e) => (
                    A(),
                    L(
                      r,
                      {
                        class: `ml-2 mt-1`,
                        design: `primary`,
                      },
                      {
                        default: I(() => [H(T(e.name), 1)]),
                        _: 2,
                      },
                      1024,
                    )
                  ),
                ),
                256,
              )),
            ])
          );
        };
      },
    },
  ),
  que = i({
    default: () => Yue,
  });
B();
var Jue = {
    class: `space-x-1 space-y-1`,
  },
  Yue = Object.assign(
    {
      name: `TagSummary`,
    },
    {
      props: {
        summary: {
          type: Object,
          required: !0,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`BaseBadge`);
          return (
            A(),
            M(`div`, Jue, [
              e.summary.count
                ? (A(!0),
                  M(
                    ke,
                    {
                      key: 0,
                    },
                    ae(
                      e.summary.tagsDisplay.split(`,`),
                      (e) => (
                        A(),
                        L(
                          r,
                          {
                            design: `primary`,
                          },
                          {
                            default: I(() => [H(T(e), 1)]),
                            _: 2,
                          },
                          1024,
                        )
                      ),
                    ),
                    256,
                  ))
                : U(``, !0),
              e.summary.additionalTagCount > 0
                ? (A(),
                  L(
                    r,
                    {
                      key: 1,
                      design: `success`,
                    },
                    {
                      default: I(() => [
                        H(
                          T(
                            t.$trans(`global.and_others`, {
                              attribute: e.summary.additionalTagCount,
                            }),
                          ),
                          1,
                        ),
                      ]),
                      _: 1,
                    },
                  ))
                : U(``, !0),
            ])
          );
        };
      },
    },
  ),
  Xue = i({
    default: () => Zue,
  });
B();
var Zue = Object.assign(
    {
      name: `TextMuted`,
    },
    {
      props: {
        block: {
          type: Boolean,
          default: !1,
        },
        black: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `span`,
            {
              class: O([
                `text-xs text-gray-600 dark:text-gray-400`,
                {
                  block: e.block,
                  "!text-gray-200": e.black,
                },
              ]),
            },
            [z(t.$slots, `default`)],
            2,
          )
        );
      },
    },
  ),
  Que = class {
    constructor(e, t = `user`, n = null, r = null) {
      ((this._webcamElement = e),
        (this._webcamElement.width = this._webcamElement.width || 640),
        (this._webcamElement.height = this._webcamElement.height || 360),
        (this._facingMode = t),
        (this._webcamList = []),
        (this._streamList = []),
        (this._selectedDeviceId = ``),
        (this._canvasElement = n),
        (this._snapSoundElement = r));
    }
    get facingMode() {
      return this._facingMode;
    }
    set facingMode(e) {
      this._facingMode = e;
    }
    get webcamList() {
      return this._webcamList;
    }
    get webcamCount() {
      return this._webcamList.length;
    }
    get selectedDeviceId() {
      return this._selectedDeviceId;
    }
    getVideoInputs(e) {
      return (
        (this._webcamList = []),
        e.forEach((e) => {
          e.kind === `videoinput` && this._webcamList.push(e);
        }),
        this._webcamList.length == 1 && (this._facingMode = `user`),
        this._webcamList
      );
    }
    getMediaConstraints() {
      var e = {};
      return (
        this._selectedDeviceId == ``
          ? (e.facingMode = this._facingMode)
          : (e.deviceId = {
              exact: this._selectedDeviceId,
            }),
        (e.width = {
          exact: this._webcamElement.width,
        }),
        (e.height = {
          exact: this._webcamElement.height,
        }),
        {
          video: e,
          audio: !1,
        }
      );
    }
    selectCamera() {
      for (let e of this._webcamList)
        if (
          (this._facingMode == `user` && e.label.toLowerCase().includes(`front`)) ||
          (this._facingMode == `enviroment` && e.label.toLowerCase().includes(`back`))
        ) {
          this._selectedDeviceId = e.deviceId;
          break;
        }
    }
    flip() {
      ((this._facingMode = this._facingMode == `user` ? `enviroment` : `user`),
        (this._webcamElement.style.transform = ``),
        this.selectCamera());
    }
    async start(e = !0) {
      return new Promise((t, n) => {
        (this.stop(),
          navigator.mediaDevices
            .getUserMedia(this.getMediaConstraints())
            .then((r) => {
              (this._streamList.push(r),
                this.info()
                  .then((r) => {
                    (this.selectCamera(),
                      e
                        ? this.stream()
                            .then((e) => {
                              t(this._facingMode);
                            })
                            .catch((e) => {
                              n(e);
                            })
                        : t(this._selectedDeviceId));
                  })
                  .catch((e) => {
                    n(e);
                  }));
            })
            .catch((e) => {
              n(e);
            }));
      });
    }
    async info() {
      return new Promise((e, t) => {
        navigator.mediaDevices
          .enumerateDevices()
          .then((t) => {
            (this.getVideoInputs(t), e(this._webcamList));
          })
          .catch((e) => {
            t(e);
          });
      });
    }
    async stream() {
      return new Promise((e, t) => {
        navigator.mediaDevices
          .getUserMedia(this.getMediaConstraints())
          .then((t) => {
            (this._streamList.push(t),
              (this._webcamElement.srcObject = t),
              this._facingMode == `user` && (this._webcamElement.style.transform = `scale(-1,1)`),
              this._webcamElement.play(),
              e(this._facingMode));
          })
          .catch((e) => {
            (console.log(e), t(e));
          });
      });
    }
    stop() {
      this._streamList.forEach((e) => {
        e.getTracks().forEach((e) => {
          e.stop();
        });
      });
    }
    snap() {
      if (this._canvasElement != null) {
        (this._snapSoundElement != null && this._snapSoundElement.play(),
          (this._canvasElement.height = this._webcamElement.scrollHeight),
          (this._canvasElement.width = this._webcamElement.scrollWidth));
        let e = this._canvasElement.getContext(`2d`);
        return (
          this._facingMode == `user` && (e.translate(this._canvasElement.width, 0), e.scale(-1, 1)),
          e.clearRect(0, 0, this._canvasElement.width, this._canvasElement.height),
          e.drawImage(
            this._webcamElement,
            0,
            0,
            this._canvasElement.width,
            this._canvasElement.height,
          ),
          this._canvasElement.toDataURL(`image/png`)
        );
      } else throw `canvas element is missing`;
    }
  },
  $ue = i({
    default: () => C6,
  });
B();
var ede = {
    class: `flex flex-col items-center justify-center gap-4`,
  },
  tde = {
    id: `webcam`,
    autoplay: ``,
    muted: ``,
    playsinline: ``,
    width: `640`,
    height: `480`,
  },
  nde = {
    class: `flex space-x-4`,
  },
  rde = {
    class: `absolute bottom-0 right-0 z-10`,
  },
  ide = [`onClick`],
  ade = [`src`],
  C6 = Object.assign(
    {
      name: `WebcamCapture`,
    },
    {
      props: {
        maxImages: {
          type: Number,
          default: 5,
        },
        autoStart: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`completed`],
      setup(e, { emit: t }) {
        let n = e,
          r = t,
          i = Ae({
            showWebcam: !1,
            webcam: null,
            capturedImages: [],
          }),
          a = () => {
            ((i.showWebcam = !0),
              (i.webcam = new Que(
                document.getElementById(`webcam`),
                `user`,
                document.getElementById(`canvas`),
              )),
              i.webcam.start());
          },
          o = () => {
            if (i.webcam && i.capturedImages.length < n.maxImages) {
              let e = i.webcam.snap();
              (n.maxImages === 1 && (i.capturedImages = []),
                i.capturedImages.push({
                  id: i.capturedImages.length + 1,
                  image: e,
                }),
                n.maxImages === 1 &&
                  (r(`completed`, i.capturedImages), i.webcam && i.webcam.stop()));
            }
          },
          s = (e) => {
            (i.capturedImages.splice(e, 1),
              n.maxImages === 1 &&
                i.capturedImages.length === 0 &&
                (r(`completed`, []), i.webcam && i.webcam.start()));
          },
          c = () => {
            (r(`completed`, i.capturedImages),
              (i.showWebcam = !1),
              (i.capturedImages = []),
              i.webcam && i.webcam.stop());
          };
        return (
          Qe(() => {
            n.autoStart && a();
          }),
          E(() => {
            i.webcam && i.webcam.stop();
          }),
          (t, n) => {
            let r = j(`BaseButton`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  i.showWebcam
                    ? U(``, !0)
                    : (A(),
                      L(
                        r,
                        {
                          key: 0,
                          onClick: a,
                        },
                        {
                          default: I(() => [H(T(t.$trans(`general.start_camera`)), 1)]),
                          _: 1,
                        },
                      )),
                  Re(
                    W(
                      `div`,
                      ede,
                      [
                        Re(W(`video`, tde, null, 512), [
                          [Ee, !(e.maxImages === 1 && i.capturedImages.length >= 1)],
                        ]),
                        Re(
                          N(
                            r,
                            {
                              design: `success`,
                              onClick: o,
                              disabled: i.capturedImages.length >= e.maxImages,
                            },
                            {
                              default: I(() => [
                                H(
                                  T(t.$trans(`general.capture_image`)) +
                                    ` (` +
                                    T(i.capturedImages.length) +
                                    `/` +
                                    T(e.maxImages) +
                                    `) `,
                                  1,
                                ),
                              ]),
                              _: 1,
                            },
                            8,
                            [`disabled`],
                          ),
                          [[Ee, !(e.maxImages === 1 && i.capturedImages.length >= 1)]],
                        ),
                        (n[1] ||= W(
                          `canvas`,
                          {
                            id: `canvas`,
                            class: `hidden`,
                          },
                          null,
                          -1,
                        )),
                        i.capturedImages.length
                          ? (A(),
                            M(
                              ke,
                              {
                                key: 0,
                              },
                              [
                                W(`div`, nde, [
                                  (A(!0),
                                  M(
                                    ke,
                                    null,
                                    ae(
                                      i.capturedImages,
                                      (e) => (
                                        A(),
                                        M(
                                          `div`,
                                          {
                                            class: `relative`,
                                            key: e.id,
                                          },
                                          [
                                            W(`div`, rde, [
                                              W(
                                                `i`,
                                                {
                                                  class: `fas fa-times-circle text-red-500 cursor-pointer`,
                                                  onClick: (t) => s(e.id - 1),
                                                },
                                                null,
                                                8,
                                                ide,
                                              ),
                                            ]),
                                            W(
                                              `img`,
                                              {
                                                src: e.image,
                                              },
                                              null,
                                              8,
                                              ade,
                                            ),
                                          ],
                                        )
                                      ),
                                    ),
                                    128,
                                  )),
                                ]),
                                e.maxImages === 1
                                  ? U(``, !0)
                                  : (A(),
                                    L(
                                      r,
                                      {
                                        key: 0,
                                        design: `success`,
                                        onClick: c,
                                      },
                                      {
                                        default: I(() => [...(n[0] ||= [H(`Done`, -1)])]),
                                        _: 1,
                                      },
                                    )),
                              ],
                              64,
                            ))
                          : U(``, !0),
                      ],
                      512,
                    ),
                    [[Ee, i.showWebcam]],
                  ),
                ],
                64,
              )
            );
          }
        );
      },
    },
  ),
  ode = i({
    default: () => dde,
  });
B();
var sde = {
    class: `flex`,
  },
  cde = {
    class: `shrink-0`,
  },
  lde = {
    class: `ltr:ml-3 rtl:mr-3`,
  },
  ude = {
    key: 0,
    class: `ltr:ml-auto rtl:mr-auto ltr:pl-3 rtl:pr-3`,
  },
  dde = Object.assign(
    {
      name: `BaseAlert`,
      computed: {
        getIcon() {
          if (this.design === `success`) return `CheckCircleIcon`;
          if (this.design === `warning`) return `ExclamationCircleIcon`;
          if (this.design === `error` || this.design === `danger`) return `XCircleIcon`;
          if (this.design === `info`) return `InformationCircleIcon`;
        },
      },
    },
    {
      props: {
        design: {
          type: String,
          validator(e) {
            return [
              `primary`,
              `secondary`,
              `info`,
              `success`,
              `warning`,
              `error`,
              `danger`,
            ].includes(e);
          },
          default: `success`,
        },
        close: {
          type: Boolean,
          default: !1,
        },
        icon: {
          type: Boolean,
          default: !0,
        },
        size: {
          type: String,
          validator(e) {
            return [`xs`, `sm`].includes(e);
          },
          default: `sm`,
        },
        clickable: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = F(!0);
        return (n, r) => {
          let i = j(`XMarkIcon`);
          return t.value
            ? (A(),
              M(
                `div`,
                {
                  key: 0,
                  class: O([
                    `rounded-md`,
                    {
                      "cursor-pointer": e.clickable,
                      "p-4": e.size === `sm`,
                      "p-2": e.size === `xs`,
                      "bg-success": e.design === `success`,
                      "bg-warning": e.design === `warning`,
                      "bg-danger": e.design === `error`,
                      "bg-info": e.design === `info`,
                    },
                  ]),
                },
                [
                  W(`div`, sde, [
                    W(`div`, cde, [
                      e.icon
                        ? (A(),
                          L(_e(n.getIcon), {
                            key: 0,
                            class: `text-success-label h-5 w-5`,
                            "aria-hidden": `true`,
                          }))
                        : U(``, !0),
                    ]),
                    W(`div`, lde, [
                      W(
                        `div`,
                        {
                          class: O([
                            `text-sm font-normal`,
                            {
                              "text-success-label": e.design === `success`,
                              "text-warning-label": e.design === `warning`,
                              "text-danger-label": e.design === `error` || e.design === `danger`,
                              "text-info-label": e.design === `info`,
                            },
                          ]),
                        },
                        [z(n.$slots, `default`)],
                        2,
                      ),
                    ]),
                    e.close
                      ? (A(),
                        M(`div`, ude, [
                          N(i, {
                            class: `text-success-label h-5 w-5 cursor-pointer`,
                            onClick: (r[0] ||= (e) => (t.value = !1)),
                            "aria-hidden": `true`,
                          }),
                        ]))
                      : U(``, !0),
                  ]),
                ],
                2,
              ))
            : U(``, !0);
        };
      },
    },
  ),
  fde = i({
    default: () => hde,
  });
B();
var pde = {
    class: `text-sm`,
  },
  mde = [`href`],
  hde = {
    __name: `BaseLink`,
    props: {
      href: {
        type: String,
        default: `#`,
      },
      to: {
        type: String,
        default: null,
      },
      route: {
        type: Object,
        default: {},
      },
    },
    setup(e) {
      let t = Ec();
      return (n, r) => (
        A(),
        M(`div`, pde, [
          e.to
            ? (A(),
              M(
                `a`,
                {
                  key: 0,
                  onClick: (r[0] ||= (n) =>
                    P(t).push({
                      name: e.to,
                    })),
                  class: `text-primary hover:text-dark-primary cursor-pointer font-medium dark:text-gray-400 dark:focus:text-gray-300`,
                },
                [z(n.$slots, `default`)],
              ))
            : e.route
              ? (A(),
                M(
                  `a`,
                  {
                    key: 1,
                    onClick: (r[1] ||= (n) => P(t).push(e.route)),
                    class: `text-primary hover:text-dark-primary cursor-pointer font-medium dark:text-gray-400 dark:focus:text-gray-300`,
                  },
                  [z(n.$slots, `default`)],
                ))
              : e.href
                ? (A(),
                  M(
                    `a`,
                    {
                      key: 2,
                      href: e.href,
                      class: `text-primary hover:text-dark-primary font-medium dark:text-gray-400 dark:focus:text-gray-300`,
                    },
                    [z(n.$slots, `default`)],
                    8,
                    mde,
                  ))
                : U(``, !0),
        ])
      );
    },
  },
  gde = i({
    default: () => bde,
  });
B();
var _de = {
    name: `Tooltip`,
    props: {
      tooltipText: {
        type: String,
        default: `Tooltip text`,
      },
      position: {
        default: `top`,
        type: String,
      },
    },
  },
  vde = [`tooltip`, `position`];
function yde(e, t, n, r, i, a) {
  return (
    A(),
    M(
      `span`,
      {
        tooltip: n.tooltipText,
        position: n.position,
      },
      [z(e.$slots, `default`)],
      8,
      vde,
    )
  );
}
var bde = tu(_de, [[`render`, yde]]);
function xde(e) {
  return {
    all: (e ||= new Map()),
    on: function (t, n) {
      var r = e.get(t);
      r ? r.push(n) : e.set(t, [n]);
    },
    off: function (t, n) {
      var r = e.get(t);
      r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
    },
    emit: function (t, n) {
      var r = e.get(t);
      (r &&
        r.slice().map(function (e) {
          e(n);
        }),
        (r = e.get(`*`)) &&
          r.slice().map(function (e) {
            e(t, n);
          }));
    },
  };
}
var w6 = xde(),
  Sde = a((t, n) => {
    (function (t, r) {
      typeof n == `object` && n.exports
        ? (n.exports = r((gD(), e(ux))))
        : typeof define == `function` && define.amd
          ? define([`moment`], r)
          : r(t.moment);
    })(t, function (e) {
      e.version === void 0 && e.default && (e = e.default);
      var t = `0.6.2`,
        n = {},
        r = {},
        i = {},
        a = {},
        o = {},
        s;
      (!e || typeof e.version != `string`) &&
        ue(
          `Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/`,
        );
      var c = e.version.split(`.`),
        l = +c[0],
        u = +c[1];
      (l < 2 || (l === 2 && u < 6)) &&
        ue(
          `Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ` +
            e.version +
            `. See momentjs.com`,
        );
      function d(e) {
        return e > 96 ? e - 87 : e > 64 ? e - 29 : e - 48;
      }
      function f(e) {
        var t = 0,
          n = e.split(`.`),
          r = n[0],
          i = n[1] || ``,
          a = 1,
          o,
          s = 0,
          c = 1;
        for (e.charCodeAt(0) === 45 && ((t = 1), (c = -1)); t < r.length; t++)
          ((o = d(r.charCodeAt(t))), (s = 60 * s + o));
        for (t = 0; t < i.length; t++) ((a /= 60), (o = d(i.charCodeAt(t))), (s += o * a));
        return s * c;
      }
      function p(e) {
        for (var t = 0; t < e.length; t++) e[t] = f(e[t]);
      }
      function m(e, t) {
        for (var n = 0; n < t; n++) e[n] = Math.round((e[n - 1] || 0) + e[n] * 6e4);
        e[t - 1] = 1 / 0;
      }
      function h(e, t) {
        var n = [],
          r;
        for (r = 0; r < t.length; r++) n[r] = e[t[r]];
        return n;
      }
      function g(e) {
        var t = e.split(`|`),
          n = t[2].split(` `),
          r = t[3].split(``),
          i = t[4].split(` `);
        return (
          p(n),
          p(r),
          p(i),
          m(i, r.length),
          {
            name: t[0],
            abbrs: h(t[1].split(` `), r),
            offsets: h(n, r),
            untils: i,
            population: t[5] | 0,
          }
        );
      }
      function v(e) {
        e && this._set(g(e));
      }
      function y(e, t) {
        var n = t.length;
        if (e < t[0]) return 0;
        if (n > 1 && t[n - 1] === 1 / 0 && e >= t[n - 2]) return n - 1;
        if (e >= t[n - 1]) return -1;
        for (var r, i = 0, a = n - 1; a - i > 1;)
          ((r = Math.floor((i + a) / 2)), t[r] <= e ? (i = r) : (a = r));
        return a;
      }
      v.prototype = {
        _set: function (e) {
          ((this.name = e.name),
            (this.abbrs = e.abbrs),
            (this.untils = e.untils),
            (this.offsets = e.offsets),
            (this.population = e.population));
        },
        _index: function (e) {
          var t = +e,
            n = this.untils,
            r = y(t, n);
          if (r >= 0) return r;
        },
        countries: function () {
          var e = this.name;
          return Object.keys(i).filter(function (t) {
            return i[t].zones.indexOf(e) !== -1;
          });
        },
        parse: function (e) {
          var t = +e,
            n = this.offsets,
            r = this.untils,
            i = r.length - 1,
            a,
            o,
            s,
            c;
          for (c = 0; c < i; c++)
            if (
              ((a = n[c]),
              (o = n[c + 1]),
              (s = n[c && c - 1]),
              a < o && de.moveAmbiguousForward
                ? (a = o)
                : a > s && de.moveInvalidForward && (a = s),
              t < r[c] - a * 6e4)
            )
              return n[c];
          return n[i];
        },
        abbr: function (e) {
          return this.abbrs[this._index(e)];
        },
        offset: function (e) {
          return (
            ue(`zone.offset has been deprecated in favor of zone.utcOffset`),
            this.offsets[this._index(e)]
          );
        },
        utcOffset: function (e) {
          return this.offsets[this._index(e)];
        },
      };
      function b(e, t) {
        ((this.name = e), (this.zones = t));
      }
      function x(e) {
        var t = e.toTimeString(),
          n = t.match(/\([a-z ]+\)/i);
        (n && n[0]
          ? ((n = n[0].match(/[A-Z]/g)), (n = n ? n.join(``) : void 0))
          : ((n = t.match(/[A-Z]{3,5}/g)), (n = n ? n[0] : void 0)),
          n === `GMT` && (n = void 0),
          (this.at = +e),
          (this.abbr = n),
          (this.offset = e.getTimezoneOffset()));
      }
      function S(e) {
        ((this.zone = e), (this.offsetScore = 0), (this.abbrScore = 0));
      }
      S.prototype.scoreOffsetAt = function (e) {
        ((this.offsetScore += Math.abs(this.zone.utcOffset(e.at) - e.offset)),
          this.zone.abbr(e.at).replace(/[^A-Z]/g, ``) !== e.abbr && this.abbrScore++);
      };
      function C(e, t) {
        for (var n, r; (r = (((t.at - e.at) / 12e4) | 0) * 6e4);)
          ((n = new x(new Date(e.at + r))), n.offset === e.offset ? (e = n) : (t = n));
        return e;
      }
      function w() {
        var e = new Date().getFullYear() - 2,
          t = new x(new Date(e, 0, 1)),
          n = t.offset,
          r = [t],
          i,
          a,
          o,
          s;
        for (s = 1; s < 48; s++)
          ((o = new Date(e, s, 1).getTimezoneOffset()),
            o !== n &&
              ((a = new x(new Date(e, s, 1))),
              (i = C(t, a)),
              r.push(i),
              r.push(new x(new Date(i.at + 6e4))),
              (t = a),
              (n = o)));
        for (s = 0; s < 4; s++)
          (r.push(new x(new Date(e + s, 0, 1))), r.push(new x(new Date(e + s, 6, 1))));
        return r;
      }
      function T(e, t) {
        return e.offsetScore === t.offsetScore
          ? e.abbrScore === t.abbrScore
            ? e.zone.population === t.zone.population
              ? t.zone.name.localeCompare(e.zone.name)
              : t.zone.population - e.zone.population
            : e.abbrScore - t.abbrScore
          : e.offsetScore - t.offsetScore;
      }
      function E(e, t) {
        var n, r;
        for (p(t), n = 0; n < t.length; n++) ((r = t[n]), (o[r] = o[r] || {}), (o[r][e] = !0));
      }
      function D(e) {
        var t = e.length,
          n = {},
          r = [],
          i = {},
          s,
          c,
          l,
          u;
        for (s = 0; s < t; s++)
          if (((l = e[s].offset), !i.hasOwnProperty(l))) {
            for (c in ((u = o[l] || {}), u)) u.hasOwnProperty(c) && (n[c] = !0);
            i[l] = !0;
          }
        for (s in n) n.hasOwnProperty(s) && r.push(a[s]);
        return r;
      }
      function ee() {
        try {
          var e = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (e && e.length > 3) {
            var t = a[O(e)];
            if (t) return t;
            ue(
              `Moment Timezone found ` +
                e +
                ` from the Intl api, but did not have that data loaded.`,
            );
          }
        } catch {}
        var n = w(),
          r = n.length,
          i = D(n),
          o = [],
          s,
          c,
          l;
        for (c = 0; c < i.length; c++) {
          for (s = new S(ne(i[c]), r), l = 0; l < r; l++) s.scoreOffsetAt(n[l]);
          o.push(s);
        }
        return (o.sort(T), o.length > 0 ? o[0].zone.name : void 0);
      }
      function te(e) {
        return ((!s || e) && (s = ee()), s);
      }
      function O(e) {
        return (e || ``).toLowerCase().replace(/\//g, `_`);
      }
      function k(e) {
        var t, r, i, o;
        for (typeof e == `string` && (e = [e]), t = 0; t < e.length; t++)
          ((i = e[t].split(`|`)),
            (r = i[0]),
            (o = O(r)),
            (n[o] = e[t]),
            (a[o] = r),
            E(o, i[2].split(` `)));
      }
      function ne(e, t) {
        e = O(e);
        var i = n[e],
          o;
        return i instanceof v
          ? i
          : typeof i == `string`
            ? ((i = new v(i)), (n[e] = i), i)
            : r[e] && t !== ne && (o = ne(r[e], ne))
              ? ((i = n[e] = new v()), i._set(o), (i.name = a[e]), i)
              : null;
      }
      function re() {
        var e,
          t = [];
        for (e in a) a.hasOwnProperty(e) && (n[e] || n[r[e]]) && a[e] && t.push(a[e]);
        return t.sort();
      }
      function A() {
        return Object.keys(i);
      }
      function ie(e) {
        var t, n, i, o;
        for (typeof e == `string` && (e = [e]), t = 0; t < e.length; t++)
          ((n = e[t].split(`|`)),
            (i = O(n[0])),
            (o = O(n[1])),
            (r[i] = o),
            (a[i] = n[0]),
            (r[o] = i),
            (a[o] = n[1]));
      }
      function j(e) {
        var t, n, r, a;
        if (!(!e || !e.length))
          for (t = 0; t < e.length; t++)
            ((a = e[t].split(`|`)),
              (n = a[0].toUpperCase()),
              (r = a[1].split(` `)),
              (i[n] = new b(n, r)));
      }
      function ae(e) {
        return ((e = e.toUpperCase()), i[e] || null);
      }
      function oe(e, t) {
        if (((e = ae(e)), !e)) return null;
        var n = e.zones.sort();
        return t
          ? n.map(function (e) {
              return {
                name: e,
                offset: ne(e).utcOffset(new Date()),
              };
            })
          : n;
      }
      function se(e) {
        (k(e.zones), ie(e.links), j(e.countries), (de.dataVersion = e.version));
      }
      function ce(e) {
        return (
          ce.didShowError ||
            ((ce.didShowError = !0),
            ue(
              `moment.tz.zoneExists('` +
                e +
                `') has been deprecated in favor of !moment.tz.zone('` +
                e +
                `')`,
            )),
          !!ne(e)
        );
      }
      function le(e) {
        var t = e._f === `X` || e._f === `x`;
        return !!(e._a && e._tzm === void 0 && !t);
      }
      function ue(e) {
        typeof console < `u` && typeof console.error == `function` && console.error(e);
      }
      function de(t) {
        var n = Array.prototype.slice.call(arguments, 0, -1),
          r = arguments[arguments.length - 1],
          i = e.utc.apply(null, n),
          a;
        return (!e.isMoment(t) && le(i) && (a = ne(r)) && i.add(a.parse(i), `minutes`), i.tz(r), i);
      }
      ((de.version = t),
        (de.dataVersion = ``),
        (de._zones = n),
        (de._links = r),
        (de._names = a),
        (de._countries = i),
        (de.add = k),
        (de.link = ie),
        (de.load = se),
        (de.zone = ne),
        (de.zoneExists = ce),
        (de.guess = te),
        (de.names = re),
        (de.Zone = v),
        (de.unpack = g),
        (de.unpackBase60 = f),
        (de.needsOffset = le),
        (de.moveInvalidForward = !0),
        (de.moveAmbiguousForward = !1),
        (de.countries = A),
        (de.zonesForCountry = oe));
      var fe = e.fn;
      ((e.tz = de),
        (e.defaultZone = null),
        (e.updateOffset = function (t, n) {
          var r = e.defaultZone,
            i;
          if (
            (t._z === void 0 &&
              (r &&
                le(t) &&
                !t._isUTC &&
                t.isValid() &&
                ((t._d = e.utc(t._a)._d), t.utc().add(r.parse(t), `minutes`)),
              (t._z = r)),
            t._z)
          )
            if (((i = t._z.utcOffset(t)), Math.abs(i) < 16 && (i /= 60), t.utcOffset !== void 0)) {
              var a = t._z;
              (t.utcOffset(-i, n), (t._z = a));
            } else t.zone(i, n);
        }),
        (fe.tz = function (t, n) {
          if (t) {
            if (typeof t != `string`)
              throw Error(`Time zone name must be a string, got ` + t + ` [` + typeof t + `]`);
            return (
              (this._z = ne(t)),
              this._z
                ? e.updateOffset(this, n)
                : ue(
                    `Moment Timezone has no data for ` +
                      t +
                      `. See http://momentjs.com/timezone/docs/#/data-loading/.`,
                  ),
              this
            );
          }
          if (this._z) return this._z.name;
        }));
      function pe(e) {
        return function () {
          return this._z ? this._z.abbr(this) : e.call(this);
        };
      }
      function M(e) {
        return function () {
          return ((this._z = null), e.apply(this, arguments));
        };
      }
      function me(e) {
        return function () {
          return (arguments.length > 0 && (this._z = null), e.apply(this, arguments));
        };
      }
      ((fe.zoneName = pe(fe.zoneName)),
        (fe.zoneAbbr = pe(fe.zoneAbbr)),
        (fe.utc = M(fe.utc)),
        (fe.local = M(fe.local)),
        (fe.utcOffset = me(fe.utcOffset)),
        (e.tz.setDefault = function (t) {
          return (
            (l < 2 || (l === 2 && u < 9)) &&
              ue(
                `Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ` +
                  e.version +
                  `.`,
              ),
            (e.defaultZone = t ? ne(t) : null),
            e
          );
        }));
      var N = e.momentProperties;
      return (
        Object.prototype.toString.call(N) === `[object Array]`
          ? (N.push(`_z`), N.push(`_a`))
          : N && (N._z = null),
        e
      );
    });
  }),
  Cde = i({
    countries: () => O6,
    default: () => k6,
    links: () => D6,
    version: () => T6,
    zones: () => E6,
  }),
  T6,
  E6,
  D6,
  O6,
  k6,
  wde = n(() => {
    ((T6 = `2026b`),
      (E6 =
        `Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5,Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5,Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5,Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6,Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4,Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5,Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6,Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5,Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3,Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4,Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5,Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|,Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5,Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5,Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5,Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|,Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5,Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5,Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4,America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326,America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4,America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5,America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4,America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|,America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|,America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|,America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|,America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|,America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|,America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|,America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|,America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|,America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|,America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|,America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|,America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5,America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5,America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3,America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5,America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4,America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5,America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3,America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2,America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5,America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4,America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2,America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4,America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4,America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5,America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3,America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5,America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4,America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5,America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|,America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5,America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4,America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8,America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3,America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2,America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5,America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5,America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5,America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3,America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5,America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|01212324523232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5,America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2,America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5,America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3,America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3,America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2,America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2,America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5,America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5,America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4,America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4,America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5,America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4,America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2,America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2,America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4,America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3,America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5,America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6,America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6,America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4,America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5,America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5,America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4,America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4,America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4,America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2,America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5,America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2,America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6,America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2,America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3,America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5,America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5,America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5,America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6,America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2,America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2,America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|,America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3,America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4,America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5,America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4,America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4,America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|,America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4,America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2,America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5,America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4,America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229,America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4,America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5,America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5,America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6,America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452,America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2,America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4,America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3,America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5,America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656,America/Vancouver|LMT PST PDT PWT PPT MST|8c.s 80 70 70 70 70|0121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212125|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5,America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3,America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642,Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10,Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70,Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4,Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1,Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60,Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5,Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40,Antarctica/Rothera|-00 -03|0 30|01|gOo0|130,Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5,Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40,Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25,Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5,Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5,Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5,Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3,Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4,Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4,Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4,Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|,Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5,Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4,Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5,Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6,Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|,Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5,Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4,Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4,Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6,Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4,Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5,Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6,Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5,Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6,Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5,Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4,Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5,Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4,Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|,Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5,Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4,Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5,Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5,Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3,Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4,Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6,Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6,Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4,Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4,Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5,Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4,Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6,Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5,Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5,Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2,Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5,Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5,Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4,Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3,Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5,Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6,Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4,Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4,Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5,Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5,Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4,Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4,Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5,Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|,Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4,Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5,Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4,Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4,Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6,Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2,Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5,Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5,Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5,Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6,Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3,Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6,Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5,Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2,Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4,Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4,Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5,Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5,Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4,Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3,Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4,Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4,Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3,Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4,Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30,Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2,Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5,Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5,Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5,Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3,Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4,Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4,Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368,Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347,Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10,Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5,Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5,Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5,Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2,Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5,Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5,Etc/GMT-0|GMT|0|0||,Etc/GMT-1|+01|-10|0||,Etc/GMT-10|+10|-a0|0||,Etc/GMT-11|+11|-b0|0||,Etc/GMT-12|+12|-c0|0||,Etc/GMT-13|+13|-d0|0||,Etc/GMT-14|+14|-e0|0||,Etc/GMT-2|+02|-20|0||,Etc/GMT-3|+03|-30|0||,Etc/GMT-4|+04|-40|0||,Etc/GMT-5|+05|-50|0||,Etc/GMT-6|+06|-60|0||,Etc/GMT-7|+07|-70|0||,Etc/GMT-8|+08|-80|0||,Etc/GMT-9|+09|-90|0||,Etc/GMT+1|-01|10|0||,Etc/GMT+10|-10|a0|0||,Etc/GMT+11|-11|b0|0||,Etc/GMT+12|-12|c0|0||,Etc/GMT+2|-02|20|0||,Etc/GMT+3|-03|30|0||,Etc/GMT+4|-04|40|0||,Etc/GMT+5|-05|50|0||,Etc/GMT+6|-06|60|0||,Etc/GMT+7|-07|70|0||,Etc/GMT+8|-08|80|0||,Etc/GMT+9|-09|90|0||,Etc/UTC|UTC|0|0||,Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3,Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5,Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6,Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5,Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5,Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5,Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5,Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4,Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WN0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4,Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3,Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5,Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4,Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5,Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4,Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5,Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5,Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4,Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5,Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6,Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6,Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4,Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5,Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5,Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|,Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4,Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5,Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4,Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4,Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5,Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5,Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4,Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5,Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5,Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4,Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2,Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4,Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4,Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3,Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600,Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3,Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4,Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3,Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1,Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483,Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4,Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3,Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3,Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125,Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4,Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4,Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2,Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2,Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2,Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2,Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3,Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2,Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4,Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3,Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3,Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56,Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3,Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4,Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3`.split(
          `,`,
        )),
      (D6 =
        `Africa/Abidjan|Africa/Accra.Africa/Abidjan|Africa/Bamako.Africa/Abidjan|Africa/Banjul.Africa/Abidjan|Africa/Conakry.Africa/Abidjan|Africa/Dakar.Africa/Abidjan|Africa/Freetown.Africa/Abidjan|Africa/Lome.Africa/Abidjan|Africa/Nouakchott.Africa/Abidjan|Africa/Ouagadougou.Africa/Abidjan|Africa/Timbuktu.Africa/Abidjan|Atlantic/Reykjavik.Africa/Abidjan|Atlantic/St_Helena.Africa/Abidjan|Iceland.Africa/Cairo|Egypt.Africa/Johannesburg|Africa/Maseru.Africa/Johannesburg|Africa/Mbabane.Africa/Lagos|Africa/Bangui.Africa/Lagos|Africa/Brazzaville.Africa/Lagos|Africa/Douala.Africa/Lagos|Africa/Kinshasa.Africa/Lagos|Africa/Libreville.Africa/Lagos|Africa/Luanda.Africa/Lagos|Africa/Malabo.Africa/Lagos|Africa/Niamey.Africa/Lagos|Africa/Porto-Novo.Africa/Maputo|Africa/Blantyre.Africa/Maputo|Africa/Bujumbura.Africa/Maputo|Africa/Gaborone.Africa/Maputo|Africa/Harare.Africa/Maputo|Africa/Kigali.Africa/Maputo|Africa/Lubumbashi.Africa/Maputo|Africa/Lusaka.Africa/Nairobi|Africa/Addis_Ababa.Africa/Nairobi|Africa/Asmara.Africa/Nairobi|Africa/Asmera.Africa/Nairobi|Africa/Dar_es_Salaam.Africa/Nairobi|Africa/Djibouti.Africa/Nairobi|Africa/Kampala.Africa/Nairobi|Africa/Mogadishu.Africa/Nairobi|Indian/Antananarivo.Africa/Nairobi|Indian/Comoro.Africa/Nairobi|Indian/Mayotte.Africa/Tripoli|Libya.America/Adak|America/Atka.America/Adak|US/Aleutian.America/Anchorage|US/Alaska.America/Argentina/Buenos_Aires|America/Buenos_Aires.America/Argentina/Catamarca|America/Argentina/ComodRivadavia.America/Argentina/Catamarca|America/Catamarca.America/Argentina/Cordoba|America/Cordoba.America/Argentina/Cordoba|America/Rosario.America/Argentina/Jujuy|America/Jujuy.America/Argentina/Mendoza|America/Mendoza.America/Chicago|CST6CDT.America/Chicago|US/Central.America/Denver|America/Shiprock.America/Denver|MST7MDT.America/Denver|Navajo.America/Denver|US/Mountain.America/Detroit|US/Michigan.America/Edmonton|America/Yellowknife.America/Edmonton|Canada/Mountain.America/Fort_Wayne|America/Indiana/Indianapolis.America/Fort_Wayne|America/Indianapolis.America/Fort_Wayne|US/East-Indiana.America/Godthab|America/Nuuk.America/Halifax|Canada/Atlantic.America/Havana|Cuba.America/Indiana/Knox|America/Knox_IN.America/Indiana/Knox|US/Indiana-Starke.America/Iqaluit|America/Pangnirtung.America/Jamaica|Jamaica.America/Kentucky/Louisville|America/Louisville.America/Los_Angeles|PST8PDT.America/Los_Angeles|US/Pacific.America/Manaus|Brazil/West.America/Mazatlan|Mexico/BajaSur.America/Mexico_City|Mexico/General.America/New_York|EST5EDT.America/New_York|US/Eastern.America/Noronha|Brazil/DeNoronha.America/Panama|America/Atikokan.America/Panama|America/Cayman.America/Panama|America/Coral_Harbour.America/Panama|EST.America/Phoenix|America/Creston.America/Phoenix|MST.America/Phoenix|US/Arizona.America/Puerto_Rico|America/Anguilla.America/Puerto_Rico|America/Antigua.America/Puerto_Rico|America/Aruba.America/Puerto_Rico|America/Blanc-Sablon.America/Puerto_Rico|America/Curacao.America/Puerto_Rico|America/Dominica.America/Puerto_Rico|America/Grenada.America/Puerto_Rico|America/Guadeloupe.America/Puerto_Rico|America/Kralendijk.America/Puerto_Rico|America/Lower_Princes.America/Puerto_Rico|America/Marigot.America/Puerto_Rico|America/Montserrat.America/Puerto_Rico|America/Port_of_Spain.America/Puerto_Rico|America/St_Barthelemy.America/Puerto_Rico|America/St_Kitts.America/Puerto_Rico|America/St_Lucia.America/Puerto_Rico|America/St_Thomas.America/Puerto_Rico|America/St_Vincent.America/Puerto_Rico|America/Tortola.America/Puerto_Rico|America/Virgin.America/Regina|Canada/Saskatchewan.America/Rio_Branco|America/Porto_Acre.America/Rio_Branco|Brazil/Acre.America/Santiago|Chile/Continental.America/Sao_Paulo|Brazil/East.America/St_Johns|Canada/Newfoundland.America/Tijuana|America/Ensenada.America/Tijuana|America/Santa_Isabel.America/Tijuana|Mexico/BajaNorte.America/Toronto|America/Montreal.America/Toronto|America/Nassau.America/Toronto|America/Nipigon.America/Toronto|America/Thunder_Bay.America/Toronto|Canada/Eastern.America/Vancouver|Canada/Pacific.America/Whitehorse|Canada/Yukon.America/Winnipeg|America/Rainy_River.America/Winnipeg|Canada/Central.Asia/Ashgabat|Asia/Ashkhabad.Asia/Bangkok|Asia/Phnom_Penh.Asia/Bangkok|Asia/Vientiane.Asia/Bangkok|Indian/Christmas.Asia/Brunei|Asia/Kuching.Asia/Dhaka|Asia/Dacca.Asia/Dubai|Asia/Muscat.Asia/Dubai|Indian/Mahe.Asia/Dubai|Indian/Reunion.Asia/Ho_Chi_Minh|Asia/Saigon.Asia/Hong_Kong|Hongkong.Asia/Jerusalem|Asia/Tel_Aviv.Asia/Jerusalem|Israel.Asia/Kathmandu|Asia/Katmandu.Asia/Kolkata|Asia/Calcutta.Asia/Kuala_Lumpur|Asia/Singapore.Asia/Kuala_Lumpur|Singapore.Asia/Macau|Asia/Macao.Asia/Makassar|Asia/Ujung_Pandang.Asia/Nicosia|Europe/Nicosia.Asia/Qatar|Asia/Bahrain.Asia/Rangoon|Asia/Yangon.Asia/Rangoon|Indian/Cocos.Asia/Riyadh|Antarctica/Syowa.Asia/Riyadh|Asia/Aden.Asia/Riyadh|Asia/Kuwait.Asia/Seoul|ROK.Asia/Shanghai|Asia/Chongqing.Asia/Shanghai|Asia/Chungking.Asia/Shanghai|Asia/Harbin.Asia/Shanghai|PRC.Asia/Taipei|ROC.Asia/Tehran|Iran.Asia/Thimphu|Asia/Thimbu.Asia/Tokyo|Japan.Asia/Ulaanbaatar|Asia/Choibalsan.Asia/Ulaanbaatar|Asia/Ulan_Bator.Asia/Urumqi|Asia/Kashgar.Atlantic/Faroe|Atlantic/Faeroe.Australia/Adelaide|Australia/South.Australia/Brisbane|Australia/Queensland.Australia/Broken_Hill|Australia/Yancowinna.Australia/Darwin|Australia/North.Australia/Hobart|Australia/Currie.Australia/Hobart|Australia/Tasmania.Australia/Lord_Howe|Australia/LHI.Australia/Melbourne|Australia/Victoria.Australia/Perth|Australia/West.Australia/Sydney|Australia/ACT.Australia/Sydney|Australia/Canberra.Australia/Sydney|Australia/NSW.Etc/GMT-0|Etc/GMT.Etc/GMT-0|Etc/GMT+0.Etc/GMT-0|Etc/GMT0.Etc/GMT-0|Etc/Greenwich.Etc/GMT-0|GMT.Etc/GMT-0|GMT+0.Etc/GMT-0|GMT-0.Etc/GMT-0|GMT0.Etc/GMT-0|Greenwich.Etc/UTC|Etc/UCT.Etc/UTC|Etc/Universal.Etc/UTC|Etc/Zulu.Etc/UTC|UCT.Etc/UTC|UTC.Etc/UTC|Universal.Etc/UTC|Zulu.Europe/Athens|EET.Europe/Belgrade|Europe/Ljubljana.Europe/Belgrade|Europe/Podgorica.Europe/Belgrade|Europe/Sarajevo.Europe/Belgrade|Europe/Skopje.Europe/Belgrade|Europe/Zagreb.Europe/Berlin|Arctic/Longyearbyen.Europe/Berlin|Atlantic/Jan_Mayen.Europe/Berlin|Europe/Copenhagen.Europe/Berlin|Europe/Oslo.Europe/Berlin|Europe/Stockholm.Europe/Brussels|CET.Europe/Brussels|Europe/Amsterdam.Europe/Brussels|Europe/Luxembourg.Europe/Brussels|MET.Europe/Chisinau|Europe/Tiraspol.Europe/Dublin|Eire.Europe/Helsinki|Europe/Mariehamn.Europe/Istanbul|Asia/Istanbul.Europe/Istanbul|Turkey.Europe/Kiev|Europe/Kyiv.Europe/Kiev|Europe/Uzhgorod.Europe/Kiev|Europe/Zaporozhye.Europe/Lisbon|Portugal.Europe/Lisbon|WET.Europe/London|Europe/Belfast.Europe/London|Europe/Guernsey.Europe/London|Europe/Isle_of_Man.Europe/London|Europe/Jersey.Europe/London|GB.Europe/London|GB-Eire.Europe/Moscow|W-SU.Europe/Paris|Europe/Monaco.Europe/Prague|Europe/Bratislava.Europe/Rome|Europe/San_Marino.Europe/Rome|Europe/Vatican.Europe/Warsaw|Poland.Europe/Zurich|Europe/Busingen.Europe/Zurich|Europe/Vaduz.Indian/Maldives|Indian/Kerguelen.Pacific/Auckland|Antarctica/McMurdo.Pacific/Auckland|Antarctica/South_Pole.Pacific/Auckland|NZ.Pacific/Chatham|NZ-CHAT.Pacific/Easter|Chile/EasterIsland.Pacific/Enderbury|Pacific/Kanton.Pacific/Guadalcanal|Pacific/Pohnpei.Pacific/Guadalcanal|Pacific/Ponape.Pacific/Guam|Pacific/Saipan.Pacific/Honolulu|HST.Pacific/Honolulu|Pacific/Johnston.Pacific/Honolulu|US/Hawaii.Pacific/Kwajalein|Kwajalein.Pacific/Pago_Pago|Pacific/Midway.Pacific/Pago_Pago|Pacific/Samoa.Pacific/Pago_Pago|US/Samoa.Pacific/Port_Moresby|Antarctica/DumontDUrville.Pacific/Port_Moresby|Pacific/Chuuk.Pacific/Port_Moresby|Pacific/Truk.Pacific/Port_Moresby|Pacific/Yap.Pacific/Tarawa|Pacific/Funafuti.Pacific/Tarawa|Pacific/Majuro.Pacific/Tarawa|Pacific/Wake.Pacific/Tarawa|Pacific/Wallis`.split(
          `.`,
        )),
      (O6 =
        `AD|Europe/Andorra.AE|Asia/Dubai.AF|Asia/Kabul.AG|America/Puerto_Rico America/Antigua.AI|America/Puerto_Rico America/Anguilla.AL|Europe/Tirane.AM|Asia/Yerevan.AO|Africa/Lagos Africa/Luanda.AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa.AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia.AS|Pacific/Pago_Pago.AT|Europe/Vienna.AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo.AW|America/Puerto_Rico America/Aruba.AX|Europe/Helsinki Europe/Mariehamn.AZ|Asia/Baku.BA|Europe/Belgrade Europe/Sarajevo.BB|America/Barbados.BD|Asia/Dhaka.BE|Europe/Brussels.BF|Africa/Abidjan Africa/Ouagadougou.BG|Europe/Sofia.BH|Asia/Qatar Asia/Bahrain.BI|Africa/Maputo Africa/Bujumbura.BJ|Africa/Lagos Africa/Porto-Novo.BL|America/Puerto_Rico America/St_Barthelemy.BM|Atlantic/Bermuda.BN|Asia/Kuching Asia/Brunei.BO|America/La_Paz.BQ|America/Puerto_Rico America/Kralendijk.BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco.BS|America/Toronto America/Nassau.BT|Asia/Thimphu.BW|Africa/Maputo Africa/Gaborone.BY|Europe/Minsk.BZ|America/Belize.CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Vancouver America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston.CC|Asia/Yangon Indian/Cocos.CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi.CF|Africa/Lagos Africa/Bangui.CG|Africa/Lagos Africa/Brazzaville.CH|Europe/Zurich.CI|Africa/Abidjan.CK|Pacific/Rarotonga.CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter.CM|Africa/Lagos Africa/Douala.CN|Asia/Shanghai Asia/Urumqi.CO|America/Bogota.CR|America/Costa_Rica.CU|America/Havana.CV|Atlantic/Cape_Verde.CW|America/Puerto_Rico America/Curacao.CX|Asia/Bangkok Indian/Christmas.CY|Asia/Nicosia Asia/Famagusta.CZ|Europe/Prague.DE|Europe/Zurich Europe/Berlin Europe/Busingen.DJ|Africa/Nairobi Africa/Djibouti.DK|Europe/Berlin Europe/Copenhagen.DM|America/Puerto_Rico America/Dominica.DO|America/Santo_Domingo.DZ|Africa/Algiers.EC|America/Guayaquil Pacific/Galapagos.EE|Europe/Tallinn.EG|Africa/Cairo.EH|Africa/El_Aaiun.ER|Africa/Nairobi Africa/Asmara.ES|Europe/Madrid Africa/Ceuta Atlantic/Canary.ET|Africa/Nairobi Africa/Addis_Ababa.FI|Europe/Helsinki.FJ|Pacific/Fiji.FK|Atlantic/Stanley.FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei.FO|Atlantic/Faroe.FR|Europe/Paris.GA|Africa/Lagos Africa/Libreville.GB|Europe/London.GD|America/Puerto_Rico America/Grenada.GE|Asia/Tbilisi.GF|America/Cayenne.GG|Europe/London Europe/Guernsey.GH|Africa/Abidjan Africa/Accra.GI|Europe/Gibraltar.GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule.GM|Africa/Abidjan Africa/Banjul.GN|Africa/Abidjan Africa/Conakry.GP|America/Puerto_Rico America/Guadeloupe.GQ|Africa/Lagos Africa/Malabo.GR|Europe/Athens.GS|Atlantic/South_Georgia.GT|America/Guatemala.GU|Pacific/Guam.GW|Africa/Bissau.GY|America/Guyana.HK|Asia/Hong_Kong.HN|America/Tegucigalpa.HR|Europe/Belgrade Europe/Zagreb.HT|America/Port-au-Prince.HU|Europe/Budapest.ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura.IE|Europe/Dublin.IL|Asia/Jerusalem.IM|Europe/London Europe/Isle_of_Man.IN|Asia/Kolkata.IO|Indian/Chagos.IQ|Asia/Baghdad.IR|Asia/Tehran.IS|Africa/Abidjan Atlantic/Reykjavik.IT|Europe/Rome.JE|Europe/London Europe/Jersey.JM|America/Jamaica.JO|Asia/Amman.JP|Asia/Tokyo.KE|Africa/Nairobi.KG|Asia/Bishkek.KH|Asia/Bangkok Asia/Phnom_Penh.KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati.KM|Africa/Nairobi Indian/Comoro.KN|America/Puerto_Rico America/St_Kitts.KP|Asia/Pyongyang.KR|Asia/Seoul.KW|Asia/Riyadh Asia/Kuwait.KY|America/Panama America/Cayman.KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral.LA|Asia/Bangkok Asia/Vientiane.LB|Asia/Beirut.LC|America/Puerto_Rico America/St_Lucia.LI|Europe/Zurich Europe/Vaduz.LK|Asia/Colombo.LR|Africa/Monrovia.LS|Africa/Johannesburg Africa/Maseru.LT|Europe/Vilnius.LU|Europe/Brussels Europe/Luxembourg.LV|Europe/Riga.LY|Africa/Tripoli.MA|Africa/Casablanca.MC|Europe/Paris Europe/Monaco.MD|Europe/Chisinau.ME|Europe/Belgrade Europe/Podgorica.MF|America/Puerto_Rico America/Marigot.MG|Africa/Nairobi Indian/Antananarivo.MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro.MK|Europe/Belgrade Europe/Skopje.ML|Africa/Abidjan Africa/Bamako.MM|Asia/Yangon.MN|Asia/Ulaanbaatar Asia/Hovd.MO|Asia/Macau.MP|Pacific/Guam Pacific/Saipan.MQ|America/Martinique.MR|Africa/Abidjan Africa/Nouakchott.MS|America/Puerto_Rico America/Montserrat.MT|Europe/Malta.MU|Indian/Mauritius.MV|Indian/Maldives.MW|Africa/Maputo Africa/Blantyre.MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana.MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur.MZ|Africa/Maputo.NA|Africa/Windhoek.NC|Pacific/Noumea.NE|Africa/Lagos Africa/Niamey.NF|Pacific/Norfolk.NG|Africa/Lagos.NI|America/Managua.NL|Europe/Brussels Europe/Amsterdam.NO|Europe/Berlin Europe/Oslo.NP|Asia/Kathmandu.NR|Pacific/Nauru.NU|Pacific/Niue.NZ|Pacific/Auckland Pacific/Chatham.OM|Asia/Dubai Asia/Muscat.PA|America/Panama.PE|America/Lima.PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier.PG|Pacific/Port_Moresby Pacific/Bougainville.PH|Asia/Manila.PK|Asia/Karachi.PL|Europe/Warsaw.PM|America/Miquelon.PN|Pacific/Pitcairn.PR|America/Puerto_Rico.PS|Asia/Gaza Asia/Hebron.PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores.PW|Pacific/Palau.PY|America/Asuncion.QA|Asia/Qatar.RE|Asia/Dubai Indian/Reunion.RO|Europe/Bucharest.RS|Europe/Belgrade.RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr.RW|Africa/Maputo Africa/Kigali.SA|Asia/Riyadh.SB|Pacific/Guadalcanal.SC|Asia/Dubai Indian/Mahe.SD|Africa/Khartoum.SE|Europe/Berlin Europe/Stockholm.SG|Asia/Singapore.SH|Africa/Abidjan Atlantic/St_Helena.SI|Europe/Belgrade Europe/Ljubljana.SJ|Europe/Berlin Arctic/Longyearbyen.SK|Europe/Prague Europe/Bratislava.SL|Africa/Abidjan Africa/Freetown.SM|Europe/Rome Europe/San_Marino.SN|Africa/Abidjan Africa/Dakar.SO|Africa/Nairobi Africa/Mogadishu.SR|America/Paramaribo.SS|Africa/Juba.ST|Africa/Sao_Tome.SV|America/El_Salvador.SX|America/Puerto_Rico America/Lower_Princes.SY|Asia/Damascus.SZ|Africa/Johannesburg Africa/Mbabane.TC|America/Grand_Turk.TD|Africa/Ndjamena.TF|Asia/Dubai Indian/Maldives Indian/Kerguelen.TG|Africa/Abidjan Africa/Lome.TH|Asia/Bangkok.TJ|Asia/Dushanbe.TK|Pacific/Fakaofo.TL|Asia/Dili.TM|Asia/Ashgabat.TN|Africa/Tunis.TO|Pacific/Tongatapu.TR|Europe/Istanbul.TT|America/Puerto_Rico America/Port_of_Spain.TV|Pacific/Tarawa Pacific/Funafuti.TW|Asia/Taipei.TZ|Africa/Nairobi Africa/Dar_es_Salaam.UA|Europe/Simferopol Europe/Kyiv.UG|Africa/Nairobi Africa/Kampala.UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake.US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu.UY|America/Montevideo.UZ|Asia/Samarkand Asia/Tashkent.VA|Europe/Rome Europe/Vatican.VC|America/Puerto_Rico America/St_Vincent.VE|America/Caracas.VG|America/Puerto_Rico America/Tortola.VI|America/Puerto_Rico America/St_Thomas.VN|Asia/Bangkok Asia/Ho_Chi_Minh.VU|Pacific/Efate.WF|Pacific/Tarawa Pacific/Wallis.WS|Pacific/Apia.YE|Asia/Riyadh Asia/Aden.YT|Africa/Nairobi Indian/Mayotte.ZA|Africa/Johannesburg.ZM|Africa/Maputo Africa/Lusaka.ZW|Africa/Maputo Africa/Harare`.split(
          `.`,
        )),
      (k6 = {
        version: T6,
        zones: E6,
        links: D6,
        countries: O6,
      }));
  }),
  Tde = a((t, n) => {
    (n.exports = Sde()).tz.load((wde(), e(Cde).default));
  }),
  A6 = i({
    toUserTimezone: () => Ede,
  }),
  j6 = r(Tde(), 1);
function Ede(e, t = `date`) {
  if (!e) return;
  let n = x.getters[`config/config`](`system`),
    r = x.getters[`auth/user/user`](`preference.system`),
    i = r.timezone || n.timezone,
    a = r.dateFormat || n.dateFormat,
    o = r.timeFormat || n.timeFormat;
  if (t === `date`) return j6.default.utc(e).tz(i).format(a);
  if (t === `time`) return j6.default.utc(e).tz(i).format(o);
  if (t === `datetime`)
    return j6.default
      .utc(e)
      .tz(i)
      .format(a + ` ` + o);
}
var M6 = [
    `onChange`,
    `onClose`,
    `onDayCreate`,
    `onDestroy`,
    `onKeyDown`,
    `onMonthChange`,
    `onOpen`,
    `onParseConfig`,
    `onReady`,
    `onValueUpdate`,
    `onYearChange`,
    `onPreCalendarPosition`,
  ],
  N6 = {
    _disable: [],
    allowInput: !1,
    allowInvalidPreload: !1,
    altFormat: `F j, Y`,
    altInput: !1,
    altInputClass: `form-control input`,
    animate: typeof window == `object` && window.navigator.userAgent.indexOf(`MSIE`) === -1,
    ariaDateFormat: `F j, Y`,
    autoFillDefaultTime: !0,
    clickOpens: !0,
    closeOnSelect: !0,
    conjunction: `, `,
    dateFormat: `Y-m-d`,
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: !1,
    enableSeconds: !1,
    enableTime: !1,
    errorHandler: function (e) {
      return typeof console < `u` && console.warn(e);
    },
    getWeek: function (e) {
      var t = new Date(e.getTime());
      (t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - ((t.getDay() + 6) % 7)));
      var n = new Date(t.getFullYear(), 0, 4);
      return 1 + Math.round(((t.getTime() - n.getTime()) / 864e5 - 3 + ((n.getDay() + 6) % 7)) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: !1,
    locale: `default`,
    minuteIncrement: 5,
    mode: `single`,
    monthSelectorType: `dropdown`,
    nextArrow: `<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>`,
    noCalendar: !1,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: `auto`,
    positionElement: void 0,
    prevArrow: `<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>`,
    shorthandCurrentMonth: !1,
    showMonths: 1,
    static: !1,
    time_24hr: !1,
    weekNumbers: !1,
    wrap: !1,
  },
  P6 = {
    weekdays: {
      shorthand: [`Sun`, `Mon`, `Tue`, `Wed`, `Thu`, `Fri`, `Sat`],
      longhand: [`Sunday`, `Monday`, `Tuesday`, `Wednesday`, `Thursday`, `Friday`, `Saturday`],
    },
    months: {
      shorthand: [
        `Jan`,
        `Feb`,
        `Mar`,
        `Apr`,
        `May`,
        `Jun`,
        `Jul`,
        `Aug`,
        `Sep`,
        `Oct`,
        `Nov`,
        `Dec`,
      ],
      longhand: [
        `January`,
        `February`,
        `March`,
        `April`,
        `May`,
        `June`,
        `July`,
        `August`,
        `September`,
        `October`,
        `November`,
        `December`,
      ],
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: function (e) {
      var t = e % 100;
      if (t > 3 && t < 21) return `th`;
      switch (t % 10) {
        case 1:
          return `st`;
        case 2:
          return `nd`;
        case 3:
          return `rd`;
        default:
          return `th`;
      }
    },
    rangeSeparator: ` to `,
    weekAbbreviation: `Wk`,
    scrollTitle: `Scroll to increment`,
    toggleTitle: `Click to toggle`,
    amPM: [`AM`, `PM`],
    yearAriaLabel: `Year`,
    monthAriaLabel: `Month`,
    hourAriaLabel: `Hour`,
    minuteAriaLabel: `Minute`,
    time_24hr: !1,
  },
  F6 = function (e, t) {
    return (t === void 0 && (t = 2), (`000` + e).slice(t * -1));
  },
  I6 = function (e) {
    return +(e === !0);
  };
function L6(e, t) {
  var n;
  return function () {
    var r = this,
      i = arguments;
    (clearTimeout(n),
      (n = setTimeout(function () {
        return e.apply(r, i);
      }, t)));
  };
}
var R6 = function (e) {
  return e instanceof Array ? e : [e];
};
function z6(e, t, n) {
  if (n === !0) return e.classList.add(t);
  e.classList.remove(t);
}
function B6(e, t, n) {
  var r = window.document.createElement(e);
  return ((t ||= ``), (n ||= ``), (r.className = t), n !== void 0 && (r.textContent = n), r);
}
function V6(e) {
  for (; e.firstChild;) e.removeChild(e.firstChild);
}
function H6(e, t) {
  if (t(e)) return e;
  if (e.parentNode) return H6(e.parentNode, t);
}
function U6(e, t) {
  var n = B6(`div`, `numInputWrapper`),
    r = B6(`input`, `numInput ` + e),
    i = B6(`span`, `arrowUp`),
    a = B6(`span`, `arrowDown`);
  if (
    (navigator.userAgent.indexOf(`MSIE 9.0`) === -1
      ? (r.type = `number`)
      : ((r.type = `text`), (r.pattern = `\\d*`)),
    t !== void 0)
  )
    for (var o in t) r.setAttribute(o, t[o]);
  return (n.appendChild(r), n.appendChild(i), n.appendChild(a), n);
}
function W6(e) {
  try {
    return typeof e.composedPath == `function` ? e.composedPath()[0] : e.target;
  } catch {
    return e.target;
  }
}
var G6 = function () {},
  K6 = function (e, t, n) {
    return n.months[t ? `shorthand` : `longhand`][e];
  },
  Dde = {
    D: G6,
    F: function (e, t, n) {
      e.setMonth(n.months.longhand.indexOf(t));
    },
    G: function (e, t) {
      e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
    },
    H: function (e, t) {
      e.setHours(parseFloat(t));
    },
    J: function (e, t) {
      e.setDate(parseFloat(t));
    },
    K: function (e, t, n) {
      e.setHours((e.getHours() % 12) + 12 * I6(new RegExp(n.amPM[1], `i`).test(t)));
    },
    M: function (e, t, n) {
      e.setMonth(n.months.shorthand.indexOf(t));
    },
    S: function (e, t) {
      e.setSeconds(parseFloat(t));
    },
    U: function (e, t) {
      return new Date(parseFloat(t) * 1e3);
    },
    W: function (e, t, n) {
      var r = parseInt(t),
        i = new Date(e.getFullYear(), 0, 2 + (r - 1) * 7, 0, 0, 0, 0);
      return (i.setDate(i.getDate() - i.getDay() + n.firstDayOfWeek), i);
    },
    Y: function (e, t) {
      e.setFullYear(parseFloat(t));
    },
    Z: function (e, t) {
      return new Date(t);
    },
    d: function (e, t) {
      e.setDate(parseFloat(t));
    },
    h: function (e, t) {
      e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
    },
    i: function (e, t) {
      e.setMinutes(parseFloat(t));
    },
    j: function (e, t) {
      e.setDate(parseFloat(t));
    },
    l: G6,
    m: function (e, t) {
      e.setMonth(parseFloat(t) - 1);
    },
    n: function (e, t) {
      e.setMonth(parseFloat(t) - 1);
    },
    s: function (e, t) {
      e.setSeconds(parseFloat(t));
    },
    u: function (e, t) {
      return new Date(parseFloat(t));
    },
    w: G6,
    y: function (e, t) {
      e.setFullYear(2e3 + parseFloat(t));
    },
  },
  q6 = {
    D: ``,
    F: ``,
    G: `(\\d\\d|\\d)`,
    H: `(\\d\\d|\\d)`,
    J: `(\\d\\d|\\d)\\w+`,
    K: ``,
    M: ``,
    S: `(\\d\\d|\\d)`,
    U: `(.+)`,
    W: `(\\d\\d|\\d)`,
    Y: `(\\d{4})`,
    Z: `(.+)`,
    d: `(\\d\\d|\\d)`,
    h: `(\\d\\d|\\d)`,
    i: `(\\d\\d|\\d)`,
    j: `(\\d\\d|\\d)`,
    l: ``,
    m: `(\\d\\d|\\d)`,
    n: `(\\d\\d|\\d)`,
    s: `(\\d\\d|\\d)`,
    u: `(.+)`,
    w: `(\\d\\d|\\d)`,
    y: `(\\d{2})`,
  },
  J6 = {
    Z: function (e) {
      return e.toISOString();
    },
    D: function (e, t, n) {
      return t.weekdays.shorthand[J6.w(e, t, n)];
    },
    F: function (e, t, n) {
      return K6(J6.n(e, t, n) - 1, !1, t);
    },
    G: function (e, t, n) {
      return F6(J6.h(e, t, n));
    },
    H: function (e) {
      return F6(e.getHours());
    },
    J: function (e, t) {
      return t.ordinal === void 0 ? e.getDate() : e.getDate() + t.ordinal(e.getDate());
    },
    K: function (e, t) {
      return t.amPM[I6(e.getHours() > 11)];
    },
    M: function (e, t) {
      return K6(e.getMonth(), !0, t);
    },
    S: function (e) {
      return F6(e.getSeconds());
    },
    U: function (e) {
      return e.getTime() / 1e3;
    },
    W: function (e, t, n) {
      return n.getWeek(e);
    },
    Y: function (e) {
      return F6(e.getFullYear(), 4);
    },
    d: function (e) {
      return F6(e.getDate());
    },
    h: function (e) {
      return e.getHours() % 12 ? e.getHours() % 12 : 12;
    },
    i: function (e) {
      return F6(e.getMinutes());
    },
    j: function (e) {
      return e.getDate();
    },
    l: function (e, t) {
      return t.weekdays.longhand[e.getDay()];
    },
    m: function (e) {
      return F6(e.getMonth() + 1);
    },
    n: function (e) {
      return e.getMonth() + 1;
    },
    s: function (e) {
      return e.getSeconds();
    },
    u: function (e) {
      return e.getTime();
    },
    w: function (e) {
      return e.getDay();
    },
    y: function (e) {
      return String(e.getFullYear()).substring(2);
    },
  },
  Y6 = function (e) {
    var t = e.config,
      n = t === void 0 ? N6 : t,
      r = e.l10n,
      i = r === void 0 ? P6 : r,
      a = e.isMobile,
      o = a === void 0 ? !1 : a;
    return function (e, t, r) {
      var a = r || i;
      return n.formatDate !== void 0 && !o
        ? n.formatDate(e, t, a)
        : t
            .split(``)
            .map(function (t, r, i) {
              return J6[t] && i[r - 1] !== `\\` ? J6[t](e, a, n) : t === `\\` ? `` : t;
            })
            .join(``);
    };
  },
  X6 = function (e) {
    var t = e.config,
      n = t === void 0 ? N6 : t,
      r = e.l10n,
      i = r === void 0 ? P6 : r;
    return function (e, t, r, a) {
      if (!(e !== 0 && !e)) {
        var o = a || i,
          s,
          c = e;
        if (e instanceof Date) s = new Date(e.getTime());
        else if (typeof e != `string` && e.toFixed !== void 0) s = new Date(e);
        else if (typeof e == `string`) {
          var l = t || (n || N6).dateFormat,
            u = String(e).trim();
          if (u === `today`) ((s = new Date()), (r = !0));
          else if (n && n.parseDate) s = n.parseDate(e, l);
          else if (/Z$/.test(u) || /GMT$/.test(u)) s = new Date(e);
          else {
            for (var d = void 0, f = [], p = 0, m = 0, h = ``; p < l.length; p++) {
              var g = l[p],
                v = g === `\\`,
                y = l[p - 1] === `\\` || v;
              if (q6[g] && !y) {
                h += q6[g];
                var b = new RegExp(h).exec(e);
                b &&
                  (d = !0) &&
                  f[g === `Y` ? `unshift` : `push`]({
                    fn: Dde[g],
                    val: b[++m],
                  });
              } else v || (h += `.`);
            }
            ((s =
              !n || !n.noCalendar
                ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
                : new Date(new Date().setHours(0, 0, 0, 0))),
              f.forEach(function (e) {
                var t = e.fn,
                  n = e.val;
                return (s = t(s, n, o) || s);
              }),
              (s = d ? s : void 0));
          }
        }
        if (!(s instanceof Date && !isNaN(s.getTime()))) {
          n.errorHandler(Error(`Invalid date provided: ` + c));
          return;
        }
        return (r === !0 && s.setHours(0, 0, 0, 0), s);
      }
    };
  };
function Z6(e, t, n) {
  return (
    n === void 0 && (n = !0),
    n === !1
      ? e.getTime() - t.getTime()
      : new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0)
  );
}
var Ode = function (e, t, n) {
    return e > Math.min(t, n) && e < Math.max(t, n);
  },
  Q6 = function (e, t, n) {
    return e * 3600 + t * 60 + n;
  },
  kde = function (e) {
    var t = Math.floor(e / 3600),
      n = (e - t * 3600) / 60;
    return [t, n, e - t * 3600 - n * 60];
  },
  Ade = {
    DAY: 864e5,
  };
function $6(e) {
  var t = e.defaultHour,
    n = e.defaultMinute,
    r = e.defaultSeconds;
  if (e.minDate !== void 0) {
    var i = e.minDate.getHours(),
      a = e.minDate.getMinutes(),
      o = e.minDate.getSeconds();
    (t < i && (t = i),
      t === i && n < a && (n = a),
      t === i && n === a && r < o && (r = e.minDate.getSeconds()));
  }
  if (e.maxDate !== void 0) {
    var s = e.maxDate.getHours(),
      c = e.maxDate.getMinutes();
    ((t = Math.min(t, s)),
      t === s && (n = Math.min(c, n)),
      t === s && n === c && (r = e.maxDate.getSeconds()));
  }
  return {
    hours: t,
    minutes: n,
    seconds: r,
  };
}
typeof Object.assign != `function` &&
  (Object.assign = function (e) {
    var t = [...arguments].slice(1);
    if (!e) throw TypeError(`Cannot convert undefined or null to object`);
    for (
      var n = function (t) {
          t &&
            Object.keys(t).forEach(function (n) {
              return (e[n] = t[n]);
            });
        },
        r = 0,
        i = t;
      r < i.length;
      r++
    ) {
      var a = i[r];
      n(a);
    }
    return e;
  });
var e8 = function () {
    return (
      (e8 =
        Object.assign ||
        function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++)
            for (var i in ((t = arguments[n]), t))
              Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }),
      e8.apply(this, arguments)
    );
  },
  t8 = function () {
    for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
    for (var r = Array(e), i = 0, t = 0; t < n; t++)
      for (var a = arguments[t], o = 0, s = a.length; o < s; o++, i++) r[i] = a[o];
    return r;
  },
  jde = 300;
function Mde(e, t) {
  var n = {
    config: e8(e8({}, N6), r8.defaultConfig),
    l10n: P6,
  };
  ((n.parseDate = X6({
    config: n.config,
    l10n: n.l10n,
  })),
    (n._handlers = []),
    (n.pluginElements = []),
    (n.loadedPlugins = []),
    (n._bind = h),
    (n._setHoursFromDate = f),
    (n._positionCalendar = be),
    (n.changeMonth = oe),
    (n.changeYear = fe),
    (n.clear = se),
    (n.close = ce),
    (n.onMouseOver = P),
    (n._createElement = B6),
    (n.createDay = C),
    (n.destroy = le),
    (n.isEnabled = pe),
    (n.jumpToDate = y),
    (n.updateValue = ze),
    (n.open = ge),
    (n.redraw = xe),
    (n.set = Te),
    (n.setDate = De),
    (n.toggle = R));
  function r() {
    n.utils = {
      getDaysInMonth: function (e, t) {
        return (
          e === void 0 && (e = n.currentMonth),
          t === void 0 && (t = n.currentYear),
          e === 1 && ((t % 4 == 0 && t % 100 != 0) || t % 400 == 0) ? 29 : n.l10n.daysInMonth[e]
        );
      },
    };
  }
  function i() {
    ((n.element = n.input = e),
      (n.isOpen = !1),
      ve(),
      F(),
      Ae(),
      ke(),
      r(),
      n.isMobile || S(),
      v(),
      (n.selectedDates.length || n.config.noCalendar) &&
        (n.config.enableTime && f(n.config.noCalendar ? n.latestSelectedDateObj : void 0), ze(!1)),
      s());
    var t = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    (!n.isMobile && t && be(), Ne(`onReady`));
  }
  function a() {
    return (n.calendarContainer?.getRootNode()).activeElement || document.activeElement;
  }
  function o(e) {
    return e.bind(n);
  }
  function s() {
    var e = n.config;
    (e.weekNumbers === !1 && e.showMonths === 1) ||
      (e.noCalendar !== !0 &&
        window.requestAnimationFrame(function () {
          if (
            (n.calendarContainer !== void 0 &&
              ((n.calendarContainer.style.visibility = `hidden`),
              (n.calendarContainer.style.display = `block`)),
            n.daysContainer !== void 0)
          ) {
            var t = (n.days.offsetWidth + 1) * e.showMonths;
            ((n.daysContainer.style.width = t + `px`),
              (n.calendarContainer.style.width =
                t + (n.weekWrapper === void 0 ? 0 : n.weekWrapper.offsetWidth) + `px`),
              n.calendarContainer.style.removeProperty(`visibility`),
              n.calendarContainer.style.removeProperty(`display`));
          }
        }));
  }
  function c(e) {
    if (n.selectedDates.length === 0) {
      var t =
          n.config.minDate === void 0 || Z6(new Date(), n.config.minDate) >= 0
            ? new Date()
            : new Date(n.config.minDate.getTime()),
        r = $6(n.config);
      (t.setHours(r.hours, r.minutes, r.seconds, t.getMilliseconds()),
        (n.selectedDates = [t]),
        (n.latestSelectedDateObj = t));
    }
    e !== void 0 && e.type !== `blur` && z(e);
    var i = n._input.value;
    (d(), ze(), n._input.value !== i && n._debouncedChange());
  }
  function l(e, t) {
    return (e % 12) + 12 * I6(t === n.l10n.amPM[1]);
  }
  function u(e) {
    switch (e % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return e % 12;
    }
  }
  function d() {
    if (!(n.hourElement === void 0 || n.minuteElement === void 0)) {
      var e = (parseInt(n.hourElement.value.slice(-2), 10) || 0) % 24,
        t = (parseInt(n.minuteElement.value, 10) || 0) % 60,
        r = n.secondElement === void 0 ? 0 : (parseInt(n.secondElement.value, 10) || 0) % 60;
      n.amPM !== void 0 && (e = l(e, n.amPM.textContent));
      var i =
          n.config.minTime !== void 0 ||
          (n.config.minDate &&
            n.minDateHasTime &&
            n.latestSelectedDateObj &&
            Z6(n.latestSelectedDateObj, n.config.minDate, !0) === 0),
        a =
          n.config.maxTime !== void 0 ||
          (n.config.maxDate &&
            n.maxDateHasTime &&
            n.latestSelectedDateObj &&
            Z6(n.latestSelectedDateObj, n.config.maxDate, !0) === 0);
      if (
        n.config.maxTime !== void 0 &&
        n.config.minTime !== void 0 &&
        n.config.minTime > n.config.maxTime
      ) {
        var o = Q6(
            n.config.minTime.getHours(),
            n.config.minTime.getMinutes(),
            n.config.minTime.getSeconds(),
          ),
          s = Q6(
            n.config.maxTime.getHours(),
            n.config.maxTime.getMinutes(),
            n.config.maxTime.getSeconds(),
          ),
          c = Q6(e, t, r);
        if (c > s && c < o) {
          var u = kde(o);
          ((e = u[0]), (t = u[1]), (r = u[2]));
        }
      } else {
        if (a) {
          var d = n.config.maxTime === void 0 ? n.config.maxDate : n.config.maxTime;
          ((e = Math.min(e, d.getHours())),
            e === d.getHours() && (t = Math.min(t, d.getMinutes())),
            t === d.getMinutes() && (r = Math.min(r, d.getSeconds())));
        }
        if (i) {
          var f = n.config.minTime === void 0 ? n.config.minDate : n.config.minTime;
          ((e = Math.max(e, f.getHours())),
            e === f.getHours() && t < f.getMinutes() && (t = f.getMinutes()),
            t === f.getMinutes() && (r = Math.max(r, f.getSeconds())));
        }
      }
      p(e, t, r);
    }
  }
  function f(e) {
    var t = e || n.latestSelectedDateObj;
    t && t instanceof Date && p(t.getHours(), t.getMinutes(), t.getSeconds());
  }
  function p(e, t, r) {
    (n.latestSelectedDateObj !== void 0 && n.latestSelectedDateObj.setHours(e % 24, t, r || 0, 0),
      !(!n.hourElement || !n.minuteElement || n.isMobile) &&
        ((n.hourElement.value = F6(
          n.config.time_24hr ? e : ((12 + e) % 12) + 12 * I6(e % 12 == 0),
        )),
        (n.minuteElement.value = F6(t)),
        n.amPM !== void 0 && (n.amPM.textContent = n.l10n.amPM[I6(e >= 12)]),
        n.secondElement !== void 0 && (n.secondElement.value = F6(r))));
  }
  function m(e) {
    var t = W6(e),
      n = parseInt(t.value) + (e.delta || 0);
    (n / 1e3 > 1 || (e.key === `Enter` && !/[^\d]/.test(n.toString()))) && fe(n);
  }
  function h(e, t, r, i) {
    if (t instanceof Array)
      return t.forEach(function (t) {
        return h(e, t, r, i);
      });
    if (e instanceof Array)
      return e.forEach(function (e) {
        return h(e, t, r, i);
      });
    (e.addEventListener(t, r, i),
      n._handlers.push({
        remove: function () {
          return e.removeEventListener(t, r, i);
        },
      }));
  }
  function g() {
    Ne(`onChange`);
  }
  function v() {
    if (
      (n.config.wrap &&
        [`open`, `close`, `toggle`, `clear`].forEach(function (e) {
          Array.prototype.forEach.call(
            n.element.querySelectorAll(`[data-` + e + `]`),
            function (t) {
              return h(t, `click`, n[e]);
            },
          );
        }),
      n.isMobile)
    ) {
      Me();
      return;
    }
    var e = L6(he, 50);
    ((n._debouncedChange = L6(g, jde)),
      n.daysContainer &&
        !/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
        h(n.daysContainer, `mouseover`, function (e) {
          n.config.mode === `range` && P(W6(e));
        }),
      h(n._input, `keydown`, N),
      n.calendarContainer !== void 0 && h(n.calendarContainer, `keydown`, N),
      !n.config.inline && !n.config.static && h(window, `resize`, e),
      window.ontouchstart === void 0
        ? h(window.document, `mousedown`, de)
        : h(window.document, `touchstart`, de),
      h(window.document, `focus`, de, {
        capture: !0,
      }),
      n.config.clickOpens === !0 && (h(n._input, `focus`, n.open), h(n._input, `click`, n.open)),
      n.daysContainer !== void 0 &&
        (h(n.monthNav, `click`, Be),
        h(n.monthNav, [`keyup`, `increment`], m),
        h(n.daysContainer, `click`, Ce)),
      n.timeContainer !== void 0 &&
        n.minuteElement !== void 0 &&
        n.hourElement !== void 0 &&
        (h(n.timeContainer, [`increment`], c),
        h(n.timeContainer, `blur`, c, {
          capture: !0,
        }),
        h(n.timeContainer, `click`, b),
        h([n.hourElement, n.minuteElement], [`focus`, `click`], function (e) {
          return W6(e).select();
        }),
        n.secondElement !== void 0 &&
          h(n.secondElement, `focus`, function () {
            return n.secondElement && n.secondElement.select();
          }),
        n.amPM !== void 0 &&
          h(n.amPM, `click`, function (e) {
            c(e);
          })),
      n.config.allowInput && h(n._input, `blur`, me));
  }
  function y(e, t) {
    var r =
        e === void 0
          ? n.latestSelectedDateObj ||
            (n.config.minDate && n.config.minDate > n.now
              ? n.config.minDate
              : n.config.maxDate && n.config.maxDate < n.now
                ? n.config.maxDate
                : n.now)
          : n.parseDate(e),
      i = n.currentYear,
      a = n.currentMonth;
    try {
      r !== void 0 && ((n.currentYear = r.getFullYear()), (n.currentMonth = r.getMonth()));
    } catch (e) {
      ((e.message = `Invalid date supplied: ` + r), n.config.errorHandler(e));
    }
    (t && n.currentYear !== i && (Ne(`onYearChange`), O()),
      t && (n.currentYear !== i || n.currentMonth !== a) && Ne(`onMonthChange`),
      n.redraw());
  }
  function b(e) {
    var t = W6(e);
    ~t.className.indexOf(`arrow`) && x(e, t.classList.contains(`arrowUp`) ? 1 : -1);
  }
  function x(e, t, n) {
    var r = e && W6(e),
      i = n || (r && r.parentNode && r.parentNode.firstChild),
      a = Pe(`increment`);
    ((a.delta = t), i && i.dispatchEvent(a));
  }
  function S() {
    var e = window.document.createDocumentFragment();
    if (
      ((n.calendarContainer = B6(`div`, `flatpickr-calendar`)),
      (n.calendarContainer.tabIndex = -1),
      !n.config.noCalendar)
    ) {
      if (
        (e.appendChild(re()),
        (n.innerContainer = B6(`div`, `flatpickr-innerContainer`)),
        n.config.weekNumbers)
      ) {
        var t = ae(),
          r = t.weekWrapper,
          i = t.weekNumbers;
        (n.innerContainer.appendChild(r), (n.weekNumbers = i), (n.weekWrapper = r));
      }
      ((n.rContainer = B6(`div`, `flatpickr-rContainer`)),
        n.rContainer.appendChild(ie()),
        n.daysContainer ||
          ((n.daysContainer = B6(`div`, `flatpickr-days`)), (n.daysContainer.tabIndex = -1)),
        te(),
        n.rContainer.appendChild(n.daysContainer),
        n.innerContainer.appendChild(n.rContainer),
        e.appendChild(n.innerContainer));
    }
    (n.config.enableTime && e.appendChild(A()),
      z6(n.calendarContainer, `rangeMode`, n.config.mode === `range`),
      z6(n.calendarContainer, `animate`, n.config.animate === !0),
      z6(n.calendarContainer, `multiMonth`, n.config.showMonths > 1),
      n.calendarContainer.appendChild(e));
    var a = n.config.appendTo !== void 0 && n.config.appendTo.nodeType !== void 0;
    if (
      (n.config.inline || n.config.static) &&
      (n.calendarContainer.classList.add(n.config.inline ? `inline` : `static`),
      n.config.inline &&
        (!a && n.element.parentNode
          ? n.element.parentNode.insertBefore(n.calendarContainer, n._input.nextSibling)
          : n.config.appendTo !== void 0 && n.config.appendTo.appendChild(n.calendarContainer)),
      n.config.static)
    ) {
      var o = B6(`div`, `flatpickr-wrapper`);
      (n.element.parentNode && n.element.parentNode.insertBefore(o, n.element),
        o.appendChild(n.element),
        n.altInput && o.appendChild(n.altInput),
        o.appendChild(n.calendarContainer));
    }
    !n.config.static &&
      !n.config.inline &&
      (n.config.appendTo === void 0 ? window.document.body : n.config.appendTo).appendChild(
        n.calendarContainer,
      );
  }
  function C(e, t, r, i) {
    var a = pe(t, !0),
      o = B6(`span`, e, t.getDate().toString());
    return (
      (o.dateObj = t),
      (o.$i = i),
      o.setAttribute(`aria-label`, n.formatDate(t, n.config.ariaDateFormat)),
      e.indexOf(`hidden`) === -1 &&
        Z6(t, n.now) === 0 &&
        ((n.todayDateElem = o), o.classList.add(`today`), o.setAttribute(`aria-current`, `date`)),
      a
        ? ((o.tabIndex = -1),
          Fe(t) &&
            (o.classList.add(`selected`),
            (n.selectedDateElem = o),
            n.config.mode === `range` &&
              (z6(o, `startRange`, n.selectedDates[0] && Z6(t, n.selectedDates[0], !0) === 0),
              z6(o, `endRange`, n.selectedDates[1] && Z6(t, n.selectedDates[1], !0) === 0),
              e === `nextMonthDay` && o.classList.add(`inRange`))))
        : o.classList.add(`flatpickr-disabled`),
      n.config.mode === `range` && Ie(t) && !Fe(t) && o.classList.add(`inRange`),
      n.weekNumbers &&
        n.config.showMonths === 1 &&
        e !== `prevMonthDay` &&
        i % 7 == 6 &&
        n.weekNumbers.insertAdjacentHTML(
          `beforeend`,
          `<span class='flatpickr-day'>` + n.config.getWeek(t) + `</span>`,
        ),
      Ne(`onDayCreate`, o),
      o
    );
  }
  function w(e) {
    (e.focus(), n.config.mode === `range` && P(e));
  }
  function T(e) {
    for (
      var t = e > 0 ? 0 : n.config.showMonths - 1, r = e > 0 ? n.config.showMonths : -1, i = t;
      i != r;
      i += e
    )
      for (
        var a = n.daysContainer.children[i],
          o = e > 0 ? 0 : a.children.length - 1,
          s = e > 0 ? a.children.length : -1,
          c = o;
        c != s;
        c += e
      ) {
        var l = a.children[c];
        if (l.className.indexOf(`hidden`) === -1 && pe(l.dateObj)) return l;
      }
  }
  function E(e, t) {
    for (
      var r = e.className.indexOf(`Month`) === -1 ? e.dateObj.getMonth() : n.currentMonth,
        i = t > 0 ? n.config.showMonths : -1,
        a = t > 0 ? 1 : -1,
        o = r - n.currentMonth;
      o != i;
      o += a
    )
      for (
        var s = n.daysContainer.children[o],
          c = r - n.currentMonth === o ? e.$i + t : t < 0 ? s.children.length - 1 : 0,
          l = s.children.length,
          u = c;
        u >= 0 && u < l && u != (t > 0 ? l : -1);
        u += a
      ) {
        var d = s.children[u];
        if (
          d.className.indexOf(`hidden`) === -1 &&
          pe(d.dateObj) &&
          Math.abs(e.$i - u) >= Math.abs(t)
        )
          return w(d);
      }
    (n.changeMonth(a), D(T(a), 0));
  }
  function D(e, t) {
    var r = a(),
      i = M(r || document.body),
      o =
        e === void 0
          ? i
            ? r
            : n.selectedDateElem !== void 0 && M(n.selectedDateElem)
              ? n.selectedDateElem
              : n.todayDateElem !== void 0 && M(n.todayDateElem)
                ? n.todayDateElem
                : T(t > 0 ? 1 : -1)
          : e;
    o === void 0 ? n._input.focus() : i ? E(o, t) : w(o);
  }
  function ee(e, t) {
    for (
      var r = (new Date(e, t, 1).getDay() - n.l10n.firstDayOfWeek + 7) % 7,
        i = n.utils.getDaysInMonth((t - 1 + 12) % 12, e),
        a = n.utils.getDaysInMonth(t, e),
        o = window.document.createDocumentFragment(),
        s = n.config.showMonths > 1,
        c = s ? `prevMonthDay hidden` : `prevMonthDay`,
        l = s ? `nextMonthDay hidden` : `nextMonthDay`,
        u = i + 1 - r,
        d = 0;
      u <= i;
      u++, d++
    )
      o.appendChild(C(`flatpickr-day ` + c, new Date(e, t - 1, u), u, d));
    for (u = 1; u <= a; u++, d++) o.appendChild(C(`flatpickr-day`, new Date(e, t, u), u, d));
    for (var f = a + 1; f <= 42 - r && (n.config.showMonths === 1 || d % 7 != 0); f++, d++)
      o.appendChild(C(`flatpickr-day ` + l, new Date(e, t + 1, f % a), f, d));
    var p = B6(`div`, `dayContainer`);
    return (p.appendChild(o), p);
  }
  function te() {
    if (n.daysContainer !== void 0) {
      (V6(n.daysContainer), n.weekNumbers && V6(n.weekNumbers));
      for (var e = document.createDocumentFragment(), t = 0; t < n.config.showMonths; t++) {
        var r = new Date(n.currentYear, n.currentMonth, 1);
        (r.setMonth(n.currentMonth + t), e.appendChild(ee(r.getFullYear(), r.getMonth())));
      }
      (n.daysContainer.appendChild(e),
        (n.days = n.daysContainer.firstChild),
        n.config.mode === `range` && n.selectedDates.length === 1 && P());
    }
  }
  function O() {
    if (!(n.config.showMonths > 1 || n.config.monthSelectorType !== `dropdown`)) {
      var e = function (e) {
        return n.config.minDate !== void 0 &&
          n.currentYear === n.config.minDate.getFullYear() &&
          e < n.config.minDate.getMonth()
          ? !1
          : !(
              n.config.maxDate !== void 0 &&
              n.currentYear === n.config.maxDate.getFullYear() &&
              e > n.config.maxDate.getMonth()
            );
      };
      ((n.monthsDropdownContainer.tabIndex = -1), (n.monthsDropdownContainer.innerHTML = ``));
      for (var t = 0; t < 12; t++)
        if (e(t)) {
          var r = B6(`option`, `flatpickr-monthDropdown-month`);
          ((r.value = new Date(n.currentYear, t).getMonth().toString()),
            (r.textContent = K6(t, n.config.shorthandCurrentMonth, n.l10n)),
            (r.tabIndex = -1),
            n.currentMonth === t && (r.selected = !0),
            n.monthsDropdownContainer.appendChild(r));
        }
    }
  }
  function k() {
    var e = B6(`div`, `flatpickr-month`),
      t = window.document.createDocumentFragment(),
      r;
    n.config.showMonths > 1 || n.config.monthSelectorType === `static`
      ? (r = B6(`span`, `cur-month`))
      : ((n.monthsDropdownContainer = B6(`select`, `flatpickr-monthDropdown-months`)),
        n.monthsDropdownContainer.setAttribute(`aria-label`, n.l10n.monthAriaLabel),
        h(n.monthsDropdownContainer, `change`, function (e) {
          var t = W6(e),
            r = parseInt(t.value, 10);
          (n.changeMonth(r - n.currentMonth), Ne(`onMonthChange`));
        }),
        O(),
        (r = n.monthsDropdownContainer));
    var i = U6(`cur-year`, {
        tabindex: `-1`,
      }),
      a = i.getElementsByTagName(`input`)[0];
    (a.setAttribute(`aria-label`, n.l10n.yearAriaLabel),
      n.config.minDate && a.setAttribute(`min`, n.config.minDate.getFullYear().toString()),
      n.config.maxDate &&
        (a.setAttribute(`max`, n.config.maxDate.getFullYear().toString()),
        (a.disabled =
          !!n.config.minDate &&
          n.config.minDate.getFullYear() === n.config.maxDate.getFullYear())));
    var o = B6(`div`, `flatpickr-current-month`);
    return (
      o.appendChild(r),
      o.appendChild(i),
      t.appendChild(o),
      e.appendChild(t),
      {
        container: e,
        yearElement: a,
        monthElement: r,
      }
    );
  }
  function ne() {
    (V6(n.monthNav),
      n.monthNav.appendChild(n.prevMonthNav),
      n.config.showMonths && ((n.yearElements = []), (n.monthElements = [])));
    for (var e = n.config.showMonths; e--;) {
      var t = k();
      (n.yearElements.push(t.yearElement),
        n.monthElements.push(t.monthElement),
        n.monthNav.appendChild(t.container));
    }
    n.monthNav.appendChild(n.nextMonthNav);
  }
  function re() {
    return (
      (n.monthNav = B6(`div`, `flatpickr-months`)),
      (n.yearElements = []),
      (n.monthElements = []),
      (n.prevMonthNav = B6(`span`, `flatpickr-prev-month`)),
      (n.prevMonthNav.innerHTML = n.config.prevArrow),
      (n.nextMonthNav = B6(`span`, `flatpickr-next-month`)),
      (n.nextMonthNav.innerHTML = n.config.nextArrow),
      ne(),
      Object.defineProperty(n, "_hidePrevMonthArrow", {
        get: function () {
          return n.__hidePrevMonthArrow;
        },
        set: function (e) {
          n.__hidePrevMonthArrow !== e &&
            (z6(n.prevMonthNav, `flatpickr-disabled`, e), (n.__hidePrevMonthArrow = e));
        },
      }),
      Object.defineProperty(n, "_hideNextMonthArrow", {
        get: function () {
          return n.__hideNextMonthArrow;
        },
        set: function (e) {
          n.__hideNextMonthArrow !== e &&
            (z6(n.nextMonthNav, `flatpickr-disabled`, e), (n.__hideNextMonthArrow = e));
        },
      }),
      (n.currentYearElement = n.yearElements[0]),
      Le(),
      n.monthNav
    );
  }
  function A() {
    (n.calendarContainer.classList.add(`hasTime`),
      n.config.noCalendar && n.calendarContainer.classList.add(`noCalendar`));
    var e = $6(n.config);
    ((n.timeContainer = B6(`div`, `flatpickr-time`)), (n.timeContainer.tabIndex = -1));
    var t = B6(`span`, `flatpickr-time-separator`, `:`),
      r = U6(`flatpickr-hour`, {
        "aria-label": n.l10n.hourAriaLabel,
      });
    n.hourElement = r.getElementsByTagName(`input`)[0];
    var i = U6(`flatpickr-minute`, {
      "aria-label": n.l10n.minuteAriaLabel,
    });
    if (
      ((n.minuteElement = i.getElementsByTagName(`input`)[0]),
      (n.hourElement.tabIndex = n.minuteElement.tabIndex = -1),
      (n.hourElement.value = F6(
        n.latestSelectedDateObj
          ? n.latestSelectedDateObj.getHours()
          : n.config.time_24hr
            ? e.hours
            : u(e.hours),
      )),
      (n.minuteElement.value = F6(
        n.latestSelectedDateObj ? n.latestSelectedDateObj.getMinutes() : e.minutes,
      )),
      n.hourElement.setAttribute(`step`, n.config.hourIncrement.toString()),
      n.minuteElement.setAttribute(`step`, n.config.minuteIncrement.toString()),
      n.hourElement.setAttribute(`min`, n.config.time_24hr ? `0` : `1`),
      n.hourElement.setAttribute(`max`, n.config.time_24hr ? `23` : `12`),
      n.hourElement.setAttribute(`maxlength`, `2`),
      n.minuteElement.setAttribute(`min`, `0`),
      n.minuteElement.setAttribute(`max`, `59`),
      n.minuteElement.setAttribute(`maxlength`, `2`),
      n.timeContainer.appendChild(r),
      n.timeContainer.appendChild(t),
      n.timeContainer.appendChild(i),
      n.config.time_24hr && n.timeContainer.classList.add(`time24hr`),
      n.config.enableSeconds)
    ) {
      n.timeContainer.classList.add(`hasSeconds`);
      var a = U6(`flatpickr-second`);
      ((n.secondElement = a.getElementsByTagName(`input`)[0]),
        (n.secondElement.value = F6(
          n.latestSelectedDateObj ? n.latestSelectedDateObj.getSeconds() : e.seconds,
        )),
        n.secondElement.setAttribute(`step`, n.minuteElement.getAttribute(`step`)),
        n.secondElement.setAttribute(`min`, `0`),
        n.secondElement.setAttribute(`max`, `59`),
        n.secondElement.setAttribute(`maxlength`, `2`),
        n.timeContainer.appendChild(B6(`span`, `flatpickr-time-separator`, `:`)),
        n.timeContainer.appendChild(a));
    }
    return (
      n.config.time_24hr ||
        ((n.amPM = B6(
          `span`,
          `flatpickr-am-pm`,
          n.l10n.amPM[
            I6((n.latestSelectedDateObj ? n.hourElement.value : n.config.defaultHour) > 11)
          ],
        )),
        (n.amPM.title = n.l10n.toggleTitle),
        (n.amPM.tabIndex = -1),
        n.timeContainer.appendChild(n.amPM)),
      n.timeContainer
    );
  }
  function ie() {
    n.weekdayContainer
      ? V6(n.weekdayContainer)
      : (n.weekdayContainer = B6(`div`, `flatpickr-weekdays`));
    for (var e = n.config.showMonths; e--;) {
      var t = B6(`div`, `flatpickr-weekdaycontainer`);
      n.weekdayContainer.appendChild(t);
    }
    return (j(), n.weekdayContainer);
  }
  function j() {
    if (n.weekdayContainer) {
      var e = n.l10n.firstDayOfWeek,
        t = t8(n.l10n.weekdays.shorthand);
      e > 0 && e < t.length && (t = t8(t.splice(e, t.length), t.splice(0, e)));
      for (var r = n.config.showMonths; r--;)
        n.weekdayContainer.children[r].innerHTML =
          `
      <span class='flatpickr-weekday'>
        ` +
          t.join(`</span><span class='flatpickr-weekday'>`) +
          `
      </span>
      `;
    }
  }
  function ae() {
    n.calendarContainer.classList.add(`hasWeeks`);
    var e = B6(`div`, `flatpickr-weekwrapper`);
    e.appendChild(B6(`span`, `flatpickr-weekday`, n.l10n.weekAbbreviation));
    var t = B6(`div`, `flatpickr-weeks`);
    return (
      e.appendChild(t),
      {
        weekWrapper: e,
        weekNumbers: t,
      }
    );
  }
  function oe(e, t) {
    t === void 0 && (t = !0);
    var r = t ? e : e - n.currentMonth;
    (r < 0 && n._hidePrevMonthArrow === !0) ||
      (r > 0 && n._hideNextMonthArrow === !0) ||
      ((n.currentMonth += r),
      (n.currentMonth < 0 || n.currentMonth > 11) &&
        ((n.currentYear += n.currentMonth > 11 ? 1 : -1),
        (n.currentMonth = (n.currentMonth + 12) % 12),
        Ne(`onYearChange`),
        O()),
      te(),
      Ne(`onMonthChange`),
      Le());
  }
  function se(e, t) {
    if (
      (e === void 0 && (e = !0),
      t === void 0 && (t = !0),
      (n.input.value = ``),
      n.altInput !== void 0 && (n.altInput.value = ``),
      n.mobileInput !== void 0 && (n.mobileInput.value = ``),
      (n.selectedDates = []),
      (n.latestSelectedDateObj = void 0),
      t === !0 &&
        ((n.currentYear = n._initialDate.getFullYear()),
        (n.currentMonth = n._initialDate.getMonth())),
      n.config.enableTime === !0)
    ) {
      var r = $6(n.config),
        i = r.hours,
        a = r.minutes,
        o = r.seconds;
      p(i, a, o);
    }
    (n.redraw(), e && Ne(`onChange`));
  }
  function ce() {
    ((n.isOpen = !1),
      n.isMobile ||
        (n.calendarContainer !== void 0 && n.calendarContainer.classList.remove(`open`),
        n._input !== void 0 && n._input.classList.remove(`active`)),
      Ne(`onClose`));
  }
  function le() {
    n.config !== void 0 && Ne(`onDestroy`);
    for (var e = n._handlers.length; e--;) n._handlers[e].remove();
    if (((n._handlers = []), n.mobileInput))
      (n.mobileInput.parentNode && n.mobileInput.parentNode.removeChild(n.mobileInput),
        (n.mobileInput = void 0));
    else if (n.calendarContainer && n.calendarContainer.parentNode)
      if (n.config.static && n.calendarContainer.parentNode) {
        var t = n.calendarContainer.parentNode;
        if ((t.lastChild && t.removeChild(t.lastChild), t.parentNode)) {
          for (; t.firstChild;) t.parentNode.insertBefore(t.firstChild, t);
          t.parentNode.removeChild(t);
        }
      } else n.calendarContainer.parentNode.removeChild(n.calendarContainer);
    (n.altInput &&
      ((n.input.type = `text`),
      n.altInput.parentNode && n.altInput.parentNode.removeChild(n.altInput),
      delete n.altInput),
      n.input &&
        ((n.input.type = n.input._type),
        n.input.classList.remove(`flatpickr-input`),
        n.input.removeAttribute(`readonly`)),
      `_showTimeInput.latestSelectedDateObj._hideNextMonthArrow._hidePrevMonthArrow.__hideNextMonthArrow.__hidePrevMonthArrow.isMobile.isOpen.selectedDateElem.minDateHasTime.maxDateHasTime.days.daysContainer._input._positionElement.innerContainer.rContainer.monthNav.todayDateElem.calendarContainer.weekdayContainer.prevMonthNav.nextMonthNav.monthsDropdownContainer.currentMonthElement.currentYearElement.navigationCurrentMonth.selectedDateElem.config`
        .split(`.`)
        .forEach(function (e) {
          try {
            delete n[e];
          } catch {}
        }));
  }
  function ue(e) {
    return n.calendarContainer.contains(e);
  }
  function de(e) {
    if (n.isOpen && !n.config.inline) {
      var t = W6(e),
        r = ue(t),
        i =
          !(
            t === n.input ||
            t === n.altInput ||
            n.element.contains(t) ||
            (e.path && e.path.indexOf && (~e.path.indexOf(n.input) || ~e.path.indexOf(n.altInput)))
          ) &&
          !r &&
          !ue(e.relatedTarget),
        a = !n.config.ignoredFocusElements.some(function (e) {
          return e.contains(t);
        });
      i &&
        a &&
        (n.config.allowInput &&
          n.setDate(
            n._input.value,
            !1,
            n.config.altInput ? n.config.altFormat : n.config.dateFormat,
          ),
        n.timeContainer !== void 0 &&
          n.minuteElement !== void 0 &&
          n.hourElement !== void 0 &&
          n.input.value !== `` &&
          n.input.value !== void 0 &&
          c(),
        n.close(),
        n.config && n.config.mode === `range` && n.selectedDates.length === 1 && n.clear(!1));
    }
  }
  function fe(e) {
    if (!(
      !e ||
      (n.config.minDate && e < n.config.minDate.getFullYear()) ||
      (n.config.maxDate && e > n.config.maxDate.getFullYear())
    )) {
      var t = e,
        r = n.currentYear !== t;
      ((n.currentYear = t || n.currentYear),
        n.config.maxDate && n.currentYear === n.config.maxDate.getFullYear()
          ? (n.currentMonth = Math.min(n.config.maxDate.getMonth(), n.currentMonth))
          : n.config.minDate &&
            n.currentYear === n.config.minDate.getFullYear() &&
            (n.currentMonth = Math.max(n.config.minDate.getMonth(), n.currentMonth)),
        r && (n.redraw(), Ne(`onYearChange`), O()));
    }
  }
  function pe(e, t) {
    t === void 0 && (t = !0);
    var r = n.parseDate(e, void 0, t);
    if (
      (n.config.minDate &&
        r &&
        Z6(r, n.config.minDate, t === void 0 ? !n.minDateHasTime : t) < 0) ||
      (n.config.maxDate && r && Z6(r, n.config.maxDate, t === void 0 ? !n.maxDateHasTime : t) > 0)
    )
      return !1;
    if (!n.config.enable && n.config.disable.length === 0) return !0;
    if (r === void 0) return !1;
    for (
      var i = !!n.config.enable, a = n.config.enable ?? n.config.disable, o = 0, s = void 0;
      o < a.length;
      o++
    ) {
      if (
        ((s = a[o]),
        (typeof s == `function` && s(r)) ||
          (s instanceof Date && r !== void 0 && s.getTime() === r.getTime()))
      )
        return i;
      if (typeof s == `string`) {
        var c = n.parseDate(s, void 0, !0);
        return c && c.getTime() === r.getTime() ? i : !i;
      } else if (
        typeof s == `object` &&
        r !== void 0 &&
        s.from &&
        s.to &&
        r.getTime() >= s.from.getTime() &&
        r.getTime() <= s.to.getTime()
      )
        return i;
    }
    return !i;
  }
  function M(e) {
    return n.daysContainer === void 0
      ? !1
      : e.className.indexOf(`hidden`) === -1 &&
          e.className.indexOf(`flatpickr-disabled`) === -1 &&
          n.daysContainer.contains(e);
  }
  function me(e) {
    var t = e.target === n._input,
      r = n._input.value.trimEnd() !== Re();
    t &&
      r &&
      !(e.relatedTarget && ue(e.relatedTarget)) &&
      n.setDate(
        n._input.value,
        !0,
        e.target === n.altInput ? n.config.altFormat : n.config.dateFormat,
      );
  }
  function N(t) {
    var r = W6(t),
      i = n.config.wrap ? e.contains(r) : r === n._input,
      o = n.config.allowInput,
      s = n.isOpen && (!o || !i),
      l = n.config.inline && i && !o;
    if (t.keyCode === 13 && i) {
      if (o)
        return (
          n.setDate(
            n._input.value,
            !0,
            r === n.altInput ? n.config.altFormat : n.config.dateFormat,
          ),
          n.close(),
          r.blur()
        );
      n.open();
    } else if (ue(r) || s || l) {
      var u = !!n.timeContainer && n.timeContainer.contains(r);
      switch (t.keyCode) {
        case 13:
          u ? (t.preventDefault(), c(), Se()) : Ce(t);
          break;
        case 27:
          (t.preventDefault(), Se());
          break;
        case 8:
        case 46:
          i && !n.config.allowInput && (t.preventDefault(), n.clear());
          break;
        case 37:
        case 39:
          if (!u && !i) {
            t.preventDefault();
            var f = a();
            if (n.daysContainer !== void 0 && (o === !1 || (f && M(f)))) {
              var p = t.keyCode === 39 ? 1 : -1;
              t.ctrlKey ? (t.stopPropagation(), oe(p), D(T(1), 0)) : D(void 0, p);
            }
          } else n.hourElement && n.hourElement.focus();
          break;
        case 38:
        case 40:
          t.preventDefault();
          var m = t.keyCode === 40 ? 1 : -1;
          (n.daysContainer && r.$i !== void 0) || r === n.input || r === n.altInput
            ? t.ctrlKey
              ? (t.stopPropagation(), fe(n.currentYear - m), D(T(1), 0))
              : u || D(void 0, m * 7)
            : r === n.currentYearElement
              ? fe(n.currentYear - m)
              : n.config.enableTime &&
                (!u && n.hourElement && n.hourElement.focus(), c(t), n._debouncedChange());
          break;
        case 9:
          if (u) {
            var h = [n.hourElement, n.minuteElement, n.secondElement, n.amPM]
                .concat(n.pluginElements)
                .filter(function (e) {
                  return e;
                }),
              g = h.indexOf(r);
            if (g !== -1) {
              var v = h[g + (t.shiftKey ? -1 : 1)];
              (t.preventDefault(), (v || n._input).focus());
            }
          } else
            !n.config.noCalendar &&
              n.daysContainer &&
              n.daysContainer.contains(r) &&
              t.shiftKey &&
              (t.preventDefault(), n._input.focus());
          break;
        default:
          break;
      }
    }
    if (n.amPM !== void 0 && r === n.amPM)
      switch (t.key) {
        case n.l10n.amPM[0].charAt(0):
        case n.l10n.amPM[0].charAt(0).toLowerCase():
          ((n.amPM.textContent = n.l10n.amPM[0]), d(), ze());
          break;
        case n.l10n.amPM[1].charAt(0):
        case n.l10n.amPM[1].charAt(0).toLowerCase():
          ((n.amPM.textContent = n.l10n.amPM[1]), d(), ze());
          break;
      }
    (i || ue(r)) && Ne(`onKeyDown`, t);
  }
  function P(e, t) {
    if (
      (t === void 0 && (t = `flatpickr-day`),
      !(
        n.selectedDates.length !== 1 ||
        (e && (!e.classList.contains(t) || e.classList.contains(`flatpickr-disabled`)))
      ))
    ) {
      for (
        var r = e ? e.dateObj.getTime() : n.days.firstElementChild.dateObj.getTime(),
          i = n.parseDate(n.selectedDates[0], void 0, !0).getTime(),
          a = Math.min(r, n.selectedDates[0].getTime()),
          o = Math.max(r, n.selectedDates[0].getTime()),
          s = !1,
          c = 0,
          l = 0,
          u = a;
        u < o;
        u += Ade.DAY
      )
        pe(new Date(u), !0) ||
          ((s ||= u > a && u < o),
          u < i && (!c || u > c) ? (c = u) : u > i && (!l || u < l) && (l = u));
      Array.from(
        n.rContainer.querySelectorAll(`*:nth-child(-n+` + n.config.showMonths + `) > .` + t),
      ).forEach(function (t) {
        var a = t.dateObj.getTime(),
          o = (c > 0 && a < c) || (l > 0 && a > l);
        if (o) {
          (t.classList.add(`notAllowed`),
            [`inRange`, `startRange`, `endRange`].forEach(function (e) {
              t.classList.remove(e);
            }));
          return;
        } else if (s && !o) return;
        ([`startRange`, `inRange`, `endRange`, `notAllowed`].forEach(function (e) {
          t.classList.remove(e);
        }),
          e !== void 0 &&
            (e.classList.add(r <= n.selectedDates[0].getTime() ? `startRange` : `endRange`),
            i < r && a === i
              ? t.classList.add(`startRange`)
              : i > r && a === i && t.classList.add(`endRange`),
            a >= c && (l === 0 || a <= l) && Ode(a, i, r) && t.classList.add(`inRange`)));
      });
    }
  }
  function he() {
    n.isOpen && !n.config.static && !n.config.inline && be();
  }
  function ge(e, t) {
    if ((t === void 0 && (t = n._positionElement), n.isMobile === !0)) {
      if (e) {
        e.preventDefault();
        var r = W6(e);
        r && r.blur();
      }
      (n.mobileInput !== void 0 && (n.mobileInput.focus(), n.mobileInput.click()), Ne(`onOpen`));
      return;
    } else if (n._input.disabled || n.config.inline) return;
    var i = n.isOpen;
    ((n.isOpen = !0),
      i ||
        (n.calendarContainer.classList.add(`open`),
        n._input.classList.add(`active`),
        Ne(`onOpen`),
        be(t)),
      n.config.enableTime === !0 &&
        n.config.noCalendar === !0 &&
        n.config.allowInput === !1 &&
        (e === void 0 || !n.timeContainer.contains(e.relatedTarget)) &&
        setTimeout(function () {
          return n.hourElement.select();
        }, 50));
  }
  function _e(e) {
    return function (t) {
      var r = (n.config[`_` + e + `Date`] = n.parseDate(t, n.config.dateFormat)),
        i = n.config[`_` + (e === `min` ? `max` : `min`) + `Date`];
      (r !== void 0 &&
        (n[e === `min` ? `minDateHasTime` : `maxDateHasTime`] =
          r.getHours() > 0 || r.getMinutes() > 0 || r.getSeconds() > 0),
        n.selectedDates &&
          ((n.selectedDates = n.selectedDates.filter(function (e) {
            return pe(e);
          })),
          !n.selectedDates.length && e === `min` && f(r),
          ze()),
        n.daysContainer &&
          (xe(),
          r === void 0
            ? n.currentYearElement.removeAttribute(e)
            : (n.currentYearElement[e] = r.getFullYear().toString()),
          (n.currentYearElement.disabled =
            !!i && r !== void 0 && i.getFullYear() === r.getFullYear())));
    };
  }
  function ve() {
    var r = [
        `wrap`,
        `weekNumbers`,
        `allowInput`,
        `allowInvalidPreload`,
        `clickOpens`,
        `time_24hr`,
        `enableTime`,
        `noCalendar`,
        `altInput`,
        `shorthandCurrentMonth`,
        `inline`,
        `static`,
        `enableSeconds`,
        `disableMobile`,
      ],
      i = e8(e8({}, JSON.parse(JSON.stringify(e.dataset || {}))), t),
      a = {};
    ((n.config.parseDate = i.parseDate),
      (n.config.formatDate = i.formatDate),
      Object.defineProperty(n.config, "enable", {
        get: function () {
          return n.config._enable;
        },
        set: function (e) {
          n.config._enable = Oe(e);
        },
      }),
      Object.defineProperty(n.config, "disable", {
        get: function () {
          return n.config._disable;
        },
        set: function (e) {
          n.config._disable = Oe(e);
        },
      }));
    var s = i.mode === `time`;
    if (!i.dateFormat && (i.enableTime || s)) {
      var c = r8.defaultConfig.dateFormat || N6.dateFormat;
      a.dateFormat =
        i.noCalendar || s
          ? `H:i` + (i.enableSeconds ? `:S` : ``)
          : c + ` H:i` + (i.enableSeconds ? `:S` : ``);
    }
    if (i.altInput && (i.enableTime || s) && !i.altFormat) {
      var l = r8.defaultConfig.altFormat || N6.altFormat;
      a.altFormat =
        i.noCalendar || s
          ? `h:i` + (i.enableSeconds ? `:S K` : ` K`)
          : l + (` h:i` + (i.enableSeconds ? `:S` : ``) + ` K`);
    }
    (Object.defineProperty(n.config, "minDate", {
      get: function () {
        return n.config._minDate;
      },
      set: _e(`min`),
    }),
      Object.defineProperty(n.config, "maxDate", {
        get: function () {
          return n.config._maxDate;
        },
        set: _e(`max`),
      }));
    var u = function (e) {
      return function (t) {
        n.config[e === `min` ? `_minTime` : `_maxTime`] = n.parseDate(t, `H:i:S`);
      };
    };
    (Object.defineProperty(n.config, "minTime", {
      get: function () {
        return n.config._minTime;
      },
      set: u(`min`),
    }),
      Object.defineProperty(n.config, "maxTime", {
        get: function () {
          return n.config._maxTime;
        },
        set: u(`max`),
      }),
      i.mode === `time` && ((n.config.noCalendar = !0), (n.config.enableTime = !0)),
      Object.assign(n.config, a, i));
    for (var d = 0; d < r.length; d++)
      n.config[r[d]] = n.config[r[d]] === !0 || n.config[r[d]] === `true`;
    (M6.filter(function (e) {
      return n.config[e] !== void 0;
    }).forEach(function (e) {
      n.config[e] = R6(n.config[e] || []).map(o);
    }),
      (n.isMobile =
        !n.config.disableMobile &&
        !n.config.inline &&
        n.config.mode === `single` &&
        !n.config.disable.length &&
        !n.config.enable &&
        !n.config.weekNumbers &&
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )));
    for (var d = 0; d < n.config.plugins.length; d++) {
      var f = n.config.plugins[d](n) || {};
      for (var p in f)
        M6.indexOf(p) > -1
          ? (n.config[p] = R6(f[p]).map(o).concat(n.config[p]))
          : i[p] === void 0 && (n.config[p] = f[p]);
    }
    (i.altInputClass || (n.config.altInputClass = ye().className + ` ` + n.config.altInputClass),
      Ne(`onParseConfig`));
  }
  function ye() {
    return n.config.wrap ? e.querySelector(`[data-input]`) : e;
  }
  function F() {
    (typeof n.config.locale != `object` &&
      r8.l10ns[n.config.locale] === void 0 &&
      n.config.errorHandler(Error(`flatpickr: invalid locale ` + n.config.locale)),
      (n.l10n = e8(
        e8({}, r8.l10ns.default),
        typeof n.config.locale == `object`
          ? n.config.locale
          : n.config.locale === "default"
            ? void 0
            : r8.l10ns[n.config.locale],
      )),
      (q6.D = `(` + n.l10n.weekdays.shorthand.join(`|`) + `)`),
      (q6.l = `(` + n.l10n.weekdays.longhand.join(`|`) + `)`),
      (q6.M = `(` + n.l10n.months.shorthand.join(`|`) + `)`),
      (q6.F = `(` + n.l10n.months.longhand.join(`|`) + `)`),
      (q6.K =
        `(` +
        n.l10n.amPM[0] +
        `|` +
        n.l10n.amPM[1] +
        `|` +
        n.l10n.amPM[0].toLowerCase() +
        `|` +
        n.l10n.amPM[1].toLowerCase() +
        `)`),
      e8(e8({}, t), JSON.parse(JSON.stringify(e.dataset || {}))).time_24hr === void 0 &&
        r8.defaultConfig.time_24hr === void 0 &&
        (n.config.time_24hr = n.l10n.time_24hr),
      (n.formatDate = Y6(n)),
      (n.parseDate = X6({
        config: n.config,
        l10n: n.l10n,
      })));
  }
  function be(e) {
    if (typeof n.config.position == `function`) {
      n.config.position(n, e);
      return;
    }
    if (n.calendarContainer !== void 0) {
      Ne(`onPreCalendarPosition`);
      var t = e || n._positionElement,
        r = Array.prototype.reduce.call(
          n.calendarContainer.children,
          function (e, t) {
            return e + t.offsetHeight;
          },
          0,
        ),
        i = n.calendarContainer.offsetWidth,
        a = n.config.position.split(` `),
        o = a[0],
        s = a.length > 1 ? a[1] : null,
        c = t.getBoundingClientRect(),
        l = window.innerHeight - c.bottom,
        u = o === `above` || (o !== `below` && l < r && c.top > r),
        d = window.pageYOffset + c.top + (u ? -r - 2 : t.offsetHeight + 2);
      if (
        (z6(n.calendarContainer, `arrowTop`, !u),
        z6(n.calendarContainer, `arrowBottom`, u),
        !n.config.inline)
      ) {
        var f = window.pageXOffset + c.left,
          p = !1,
          m = !1;
        (s === `center`
          ? ((f -= (i - c.width) / 2), (p = !0))
          : s === `right` && ((f -= i - c.width), (m = !0)),
          z6(n.calendarContainer, `arrowLeft`, !p && !m),
          z6(n.calendarContainer, `arrowCenter`, p),
          z6(n.calendarContainer, `arrowRight`, m));
        var h = window.document.body.offsetWidth - (window.pageXOffset + c.right),
          g = f + i > window.document.body.offsetWidth,
          v = h + i > window.document.body.offsetWidth;
        if ((z6(n.calendarContainer, `rightMost`, g), !n.config.static))
          if (((n.calendarContainer.style.top = d + `px`), !g))
            ((n.calendarContainer.style.left = f + `px`),
              (n.calendarContainer.style.right = `auto`));
          else if (!v)
            ((n.calendarContainer.style.left = `auto`),
              (n.calendarContainer.style.right = h + `px`));
          else {
            var y = I();
            if (y === void 0) return;
            var b = window.document.body.offsetWidth,
              x = Math.max(0, b / 2 - i / 2),
              S = `.flatpickr-calendar.centerMost:before`,
              C = `.flatpickr-calendar.centerMost:after`,
              w = y.cssRules.length,
              T = `{left:` + c.left + `px;right:auto;}`;
            (z6(n.calendarContainer, `rightMost`, !1),
              z6(n.calendarContainer, `centerMost`, !0),
              y.insertRule(S + `,` + C + T, w),
              (n.calendarContainer.style.left = x + `px`),
              (n.calendarContainer.style.right = `auto`));
          }
      }
    }
  }
  function I() {
    for (var e = null, t = 0; t < document.styleSheets.length; t++) {
      var n = document.styleSheets[t];
      if (n.cssRules) {
        try {
          n.cssRules;
        } catch {
          continue;
        }
        e = n;
        break;
      }
    }
    return e ?? L();
  }
  function L() {
    var e = document.createElement(`style`);
    return (document.head.appendChild(e), e.sheet);
  }
  function xe() {
    n.config.noCalendar || n.isMobile || (O(), Le(), te());
  }
  function Se() {
    (n._input.focus(),
      window.navigator.userAgent.indexOf(`MSIE`) !== -1 || navigator.msMaxTouchPoints !== void 0
        ? setTimeout(n.close, 0)
        : n.close());
  }
  function Ce(e) {
    (e.preventDefault(), e.stopPropagation());
    var t = H6(W6(e), function (e) {
      return (
        e.classList &&
        e.classList.contains(`flatpickr-day`) &&
        !e.classList.contains(`flatpickr-disabled`) &&
        !e.classList.contains(`notAllowed`)
      );
    });
    if (t !== void 0) {
      var r = t,
        i = (n.latestSelectedDateObj = new Date(r.dateObj.getTime())),
        a =
          (i.getMonth() < n.currentMonth ||
            i.getMonth() > n.currentMonth + n.config.showMonths - 1) &&
          n.config.mode !== `range`;
      if (((n.selectedDateElem = r), n.config.mode === `single`)) n.selectedDates = [i];
      else if (n.config.mode === `multiple`) {
        var o = Fe(i);
        o ? n.selectedDates.splice(parseInt(o), 1) : n.selectedDates.push(i);
      } else
        n.config.mode === `range` &&
          (n.selectedDates.length === 2 && n.clear(!1, !1),
          (n.latestSelectedDateObj = i),
          n.selectedDates.push(i),
          Z6(i, n.selectedDates[0], !0) !== 0 &&
            n.selectedDates.sort(function (e, t) {
              return e.getTime() - t.getTime();
            }));
      if ((d(), a)) {
        var s = n.currentYear !== i.getFullYear();
        ((n.currentYear = i.getFullYear()),
          (n.currentMonth = i.getMonth()),
          s && (Ne(`onYearChange`), O()),
          Ne(`onMonthChange`));
      }
      if (
        (Le(),
        te(),
        ze(),
        !a && n.config.mode !== `range` && n.config.showMonths === 1
          ? w(r)
          : n.selectedDateElem !== void 0 &&
            n.hourElement === void 0 &&
            n.selectedDateElem &&
            n.selectedDateElem.focus(),
        n.hourElement !== void 0 && n.hourElement !== void 0 && n.hourElement.focus(),
        n.config.closeOnSelect)
      ) {
        var c = n.config.mode === `single` && !n.config.enableTime,
          l = n.config.mode === `range` && n.selectedDates.length === 2 && !n.config.enableTime;
        (c || l) && Se();
      }
      g();
    }
  }
  var we = {
    locale: [F, j],
    showMonths: [ne, s, ie],
    minDate: [y],
    maxDate: [y],
    positionElement: [je],
    clickOpens: [
      function () {
        n.config.clickOpens === !0
          ? (h(n._input, `focus`, n.open), h(n._input, `click`, n.open))
          : (n._input.removeEventListener(`focus`, n.open),
            n._input.removeEventListener(`click`, n.open));
      },
    ],
  };
  function Te(e, t) {
    if (typeof e == `object` && e)
      for (var r in (Object.assign(n.config, e), e))
        we[r] !== void 0 &&
          we[r].forEach(function (e) {
            return e();
          });
    else
      ((n.config[e] = t),
        we[e] === void 0
          ? M6.indexOf(e) > -1 && (n.config[e] = R6(t))
          : we[e].forEach(function (e) {
              return e();
            }));
    (n.redraw(), ze(!0));
  }
  function Ee(e, t) {
    var r = [];
    if (e instanceof Array)
      r = e.map(function (e) {
        return n.parseDate(e, t);
      });
    else if (e instanceof Date || typeof e == `number`) r = [n.parseDate(e, t)];
    else if (typeof e == `string`)
      switch (n.config.mode) {
        case `single`:
        case `time`:
          r = [n.parseDate(e, t)];
          break;
        case `multiple`:
          r = e.split(n.config.conjunction).map(function (e) {
            return n.parseDate(e, t);
          });
          break;
        case `range`:
          r = e.split(n.l10n.rangeSeparator).map(function (e) {
            return n.parseDate(e, t);
          });
          break;
        default:
          break;
      }
    else n.config.errorHandler(Error(`Invalid date supplied: ` + JSON.stringify(e)));
    ((n.selectedDates = n.config.allowInvalidPreload
      ? r
      : r.filter(function (e) {
          return e instanceof Date && pe(e, !1);
        })),
      n.config.mode === `range` &&
        n.selectedDates.sort(function (e, t) {
          return e.getTime() - t.getTime();
        }));
  }
  function De(e, t, r) {
    if (
      (t === void 0 && (t = !1),
      r === void 0 && (r = n.config.dateFormat),
      (e !== 0 && !e) || (e instanceof Array && e.length === 0))
    )
      return n.clear(t);
    (Ee(e, r),
      (n.latestSelectedDateObj = n.selectedDates[n.selectedDates.length - 1]),
      n.redraw(),
      y(void 0, t),
      f(),
      n.selectedDates.length === 0 && n.clear(!1),
      ze(t),
      t && Ne(`onChange`));
  }
  function Oe(e) {
    return e
      .slice()
      .map(function (e) {
        return typeof e == `string` || typeof e == `number` || e instanceof Date
          ? n.parseDate(e, void 0, !0)
          : e && typeof e == `object` && e.from && e.to
            ? {
                from: n.parseDate(e.from, void 0),
                to: n.parseDate(e.to, void 0),
              }
            : e;
      })
      .filter(function (e) {
        return e;
      });
  }
  function ke() {
    ((n.selectedDates = []), (n.now = n.parseDate(n.config.now) || new Date()));
    var e =
      n.config.defaultDate ||
      ((n.input.nodeName === `INPUT` || n.input.nodeName === `TEXTAREA`) &&
      n.input.placeholder &&
      n.input.value === n.input.placeholder
        ? null
        : n.input.value);
    (e && Ee(e, n.config.dateFormat),
      (n._initialDate =
        n.selectedDates.length > 0
          ? n.selectedDates[0]
          : n.config.minDate && n.config.minDate.getTime() > n.now.getTime()
            ? n.config.minDate
            : n.config.maxDate && n.config.maxDate.getTime() < n.now.getTime()
              ? n.config.maxDate
              : n.now),
      (n.currentYear = n._initialDate.getFullYear()),
      (n.currentMonth = n._initialDate.getMonth()),
      n.selectedDates.length > 0 && (n.latestSelectedDateObj = n.selectedDates[0]),
      n.config.minTime !== void 0 && (n.config.minTime = n.parseDate(n.config.minTime, `H:i`)),
      n.config.maxTime !== void 0 && (n.config.maxTime = n.parseDate(n.config.maxTime, `H:i`)),
      (n.minDateHasTime =
        !!n.config.minDate &&
        (n.config.minDate.getHours() > 0 ||
          n.config.minDate.getMinutes() > 0 ||
          n.config.minDate.getSeconds() > 0)),
      (n.maxDateHasTime =
        !!n.config.maxDate &&
        (n.config.maxDate.getHours() > 0 ||
          n.config.maxDate.getMinutes() > 0 ||
          n.config.maxDate.getSeconds() > 0)));
  }
  function Ae() {
    if (((n.input = ye()), !n.input)) {
      n.config.errorHandler(Error(`Invalid input element specified`));
      return;
    }
    ((n.input._type = n.input.type),
      (n.input.type = `text`),
      n.input.classList.add(`flatpickr-input`),
      (n._input = n.input),
      n.config.altInput &&
        ((n.altInput = B6(n.input.nodeName, n.config.altInputClass)),
        (n._input = n.altInput),
        (n.altInput.placeholder = n.input.placeholder),
        (n.altInput.disabled = n.input.disabled),
        (n.altInput.required = n.input.required),
        (n.altInput.tabIndex = n.input.tabIndex),
        (n.altInput.type = `text`),
        n.input.setAttribute(`type`, `hidden`),
        !n.config.static &&
          n.input.parentNode &&
          n.input.parentNode.insertBefore(n.altInput, n.input.nextSibling)),
      n.config.allowInput || n._input.setAttribute(`readonly`, `readonly`),
      je());
  }
  function je() {
    n._positionElement = n.config.positionElement || n._input;
  }
  function Me() {
    var e = n.config.enableTime ? (n.config.noCalendar ? `time` : `datetime-local`) : `date`;
    ((n.mobileInput = B6(`input`, n.input.className + ` flatpickr-mobile`)),
      (n.mobileInput.tabIndex = 1),
      (n.mobileInput.type = e),
      (n.mobileInput.disabled = n.input.disabled),
      (n.mobileInput.required = n.input.required),
      (n.mobileInput.placeholder = n.input.placeholder),
      (n.mobileFormatStr =
        e === `datetime-local` ? `Y-m-d\\TH:i:S` : e === `date` ? `Y-m-d` : `H:i:S`),
      n.selectedDates.length > 0 &&
        (n.mobileInput.defaultValue = n.mobileInput.value =
          n.formatDate(n.selectedDates[0], n.mobileFormatStr)),
      n.config.minDate && (n.mobileInput.min = n.formatDate(n.config.minDate, `Y-m-d`)),
      n.config.maxDate && (n.mobileInput.max = n.formatDate(n.config.maxDate, `Y-m-d`)),
      n.input.getAttribute(`step`) && (n.mobileInput.step = String(n.input.getAttribute(`step`))),
      (n.input.type = `hidden`),
      n.altInput !== void 0 && (n.altInput.type = `hidden`));
    try {
      n.input.parentNode && n.input.parentNode.insertBefore(n.mobileInput, n.input.nextSibling);
    } catch {}
    h(n.mobileInput, `change`, function (e) {
      (n.setDate(W6(e).value, !1, n.mobileFormatStr), Ne(`onChange`), Ne(`onClose`));
    });
  }
  function R(e) {
    if (n.isOpen === !0) return n.close();
    n.open(e);
  }
  function Ne(e, t) {
    if (n.config !== void 0) {
      var r = n.config[e];
      if (r !== void 0 && r.length > 0)
        for (var i = 0; r[i] && i < r.length; i++) r[i](n.selectedDates, n.input.value, n, t);
      e === `onChange` && (n.input.dispatchEvent(Pe(`change`)), n.input.dispatchEvent(Pe(`input`)));
    }
  }
  function Pe(e) {
    var t = document.createEvent(`Event`);
    return (t.initEvent(e, !0, !0), t);
  }
  function Fe(e) {
    for (var t = 0; t < n.selectedDates.length; t++) {
      var r = n.selectedDates[t];
      if (r instanceof Date && Z6(r, e) === 0) return `` + t;
    }
    return !1;
  }
  function Ie(e) {
    return n.config.mode !== `range` || n.selectedDates.length < 2
      ? !1
      : Z6(e, n.selectedDates[0]) >= 0 && Z6(e, n.selectedDates[1]) <= 0;
  }
  function Le() {
    n.config.noCalendar ||
      n.isMobile ||
      !n.monthNav ||
      (n.yearElements.forEach(function (e, t) {
        var r = new Date(n.currentYear, n.currentMonth, 1);
        (r.setMonth(n.currentMonth + t),
          n.config.showMonths > 1 || n.config.monthSelectorType === `static`
            ? (n.monthElements[t].textContent =
                K6(r.getMonth(), n.config.shorthandCurrentMonth, n.l10n) + ` `)
            : (n.monthsDropdownContainer.value = r.getMonth().toString()),
          (e.value = r.getFullYear().toString()));
      }),
      (n._hidePrevMonthArrow =
        n.config.minDate !== void 0 &&
        (n.currentYear === n.config.minDate.getFullYear()
          ? n.currentMonth <= n.config.minDate.getMonth()
          : n.currentYear < n.config.minDate.getFullYear())),
      (n._hideNextMonthArrow =
        n.config.maxDate !== void 0 &&
        (n.currentYear === n.config.maxDate.getFullYear()
          ? n.currentMonth + 1 > n.config.maxDate.getMonth()
          : n.currentYear > n.config.maxDate.getFullYear())));
  }
  function Re(e) {
    var t = e || (n.config.altInput ? n.config.altFormat : n.config.dateFormat);
    return n.selectedDates
      .map(function (e) {
        return n.formatDate(e, t);
      })
      .filter(function (e, t, r) {
        return n.config.mode !== `range` || n.config.enableTime || r.indexOf(e) === t;
      })
      .join(n.config.mode === `range` ? n.l10n.rangeSeparator : n.config.conjunction);
  }
  function ze(e) {
    (e === void 0 && (e = !0),
      n.mobileInput !== void 0 &&
        n.mobileFormatStr &&
        (n.mobileInput.value =
          n.latestSelectedDateObj === void 0
            ? ``
            : n.formatDate(n.latestSelectedDateObj, n.mobileFormatStr)),
      (n.input.value = Re(n.config.dateFormat)),
      n.altInput !== void 0 && (n.altInput.value = Re(n.config.altFormat)),
      e !== !1 && Ne(`onValueUpdate`));
  }
  function Be(e) {
    var t = W6(e),
      r = n.prevMonthNav.contains(t),
      i = n.nextMonthNav.contains(t);
    r || i
      ? oe(r ? -1 : 1)
      : n.yearElements.indexOf(t) >= 0
        ? t.select()
        : t.classList.contains(`arrowUp`)
          ? n.changeYear(n.currentYear + 1)
          : t.classList.contains(`arrowDown`) && n.changeYear(n.currentYear - 1);
  }
  function z(e) {
    e.preventDefault();
    var t = e.type === `keydown`,
      r = W6(e),
      i = r;
    n.amPM !== void 0 &&
      r === n.amPM &&
      (n.amPM.textContent = n.l10n.amPM[I6(n.amPM.textContent === n.l10n.amPM[0])]);
    var a = parseFloat(i.getAttribute(`min`)),
      o = parseFloat(i.getAttribute(`max`)),
      s = parseFloat(i.getAttribute(`step`)),
      c = parseInt(i.value, 10),
      l = c + s * (e.delta || (t ? (e.which === 38 ? 1 : -1) : 0));
    if (i.value !== void 0 && i.value.length === 2) {
      var u = i === n.hourElement,
        d = i === n.minuteElement;
      (l < a
        ? ((l = o + l + I6(!u) + (I6(u) && I6(!n.amPM))), d && x(void 0, -1, n.hourElement))
        : l > o &&
          ((l = i === n.hourElement ? l - o - I6(!n.amPM) : a), d && x(void 0, 1, n.hourElement)),
        n.amPM &&
          u &&
          (s === 1 ? l + c === 23 : Math.abs(l - c) > s) &&
          (n.amPM.textContent = n.l10n.amPM[I6(n.amPM.textContent === n.l10n.amPM[0])]),
        (i.value = F6(l)));
    }
  }
  return (i(), n);
}
function n8(e, t) {
  for (
    var n = Array.prototype.slice.call(e).filter(function (e) {
        return e instanceof HTMLElement;
      }),
      r = [],
      i = 0;
    i < n.length;
    i++
  ) {
    var a = n[i];
    try {
      if (a.getAttribute(`data-fp-omit`) !== null) continue;
      (a._flatpickr !== void 0 && (a._flatpickr.destroy(), (a._flatpickr = void 0)),
        (a._flatpickr = Mde(a, t || {})),
        r.push(a._flatpickr));
    } catch (e) {
      console.error(e);
    }
  }
  return r.length === 1 ? r[0] : r;
}
typeof HTMLElement < `u` &&
  typeof HTMLCollection < `u` &&
  typeof NodeList < `u` &&
  ((HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr =
    function (e) {
      return n8(this, e);
    }),
  (HTMLElement.prototype.flatpickr = function (e) {
    return n8([this], e);
  }));
var r8 = function (e, t) {
  return typeof e == `string`
    ? n8(window.document.querySelectorAll(e), t)
    : e instanceof Node
      ? n8([e], t)
      : n8(e, t);
};
((r8.defaultConfig = {}),
  (r8.l10ns = {
    en: e8({}, P6),
    default: e8({}, P6),
  }),
  (r8.localize = function (e) {
    r8.l10ns.default = e8(e8({}, r8.l10ns.default), e);
  }),
  (r8.setDefaults = function (e) {
    r8.defaultConfig = e8(e8({}, r8.defaultConfig), e);
  }),
  (r8.parseDate = X6({})),
  (r8.formatDate = Y6({})),
  (r8.compareDates = Z6),
  typeof jQuery < `u` &&
    jQuery.fn !== void 0 &&
    (jQuery.fn.flatpickr = function (e) {
      return n8(this, e);
    }),
  (Date.prototype.fp_incr = function (e) {
    return new Date(
      this.getFullYear(),
      this.getMonth(),
      this.getDate() + (typeof e == `string` ? parseInt(e, 10) : e),
    );
  }),
  typeof window < `u` && (window.flatpickr = r8));
var i8 = [`onChange`, `onClose`, `onDestroy`, `onMonthChange`, `onOpen`, `onYearChange`],
  Nde = [
    `onValueUpdate`,
    `onDayCreate`,
    `onParseConfig`,
    `onReady`,
    `onPreCalendarPosition`,
    `onKeyDown`,
  ];
function a8(e) {
  return e.replace(/([a-z])([A-Z])/g, `$1-$2`).toLowerCase();
}
function o8(e) {
  return e instanceof Array ? e : [e];
}
function s8(e) {
  return e && e.length ? e : null;
}
B();
var c8 = [...i8, ...Nde],
  Pde = [`locale`, `showMonths`],
  Fde = k({
    name: `FlatPickr`,
    compatConfig: {
      MODE: 3,
    },
    render() {
      return Ne(`input`, {
        type: `text`,
        "data-input": !0,
        disabled: this.disabled,
        onInput: this.onInput,
      });
    },
    emits: [`blur`, `update:modelValue`, ...c8.map(a8)],
    props: {
      modelValue: {
        type: [String, Number, Date, Array, null],
        required: !0,
      },
      config: {
        type: Object,
        default: () => ({
          defaultDate: null,
          wrap: !1,
        }),
      },
      events: {
        type: Array,
        default: () => i8,
      },
      disabled: {
        type: Boolean,
        default: !1,
      },
    },
    data() {
      return {
        fp: null,
      };
    },
    mounted() {
      this.fp ||
        ((this.fp = r8(this.getElem(), this.prepareConfig())),
        this.fpInput().addEventListener(`blur`, this.onBlur),
        this.$watch(`disabled`, this.watchDisabled, {
          immediate: !0,
        }));
    },
    methods: {
      prepareConfig() {
        let e = Object.assign({}, this.config);
        this.events.forEach((t) => {
          let n = r8.defaultConfig[t] || [];
          e[t] = o8(e[t] || []).concat(n, (...e) => {
            this.$emit(a8(t), ...e);
          });
        });
        let t = this.onClose.bind(this);
        return (
          (e.onClose = o8(e.onClose || []).concat(t)),
          (e.defaultDate = this.modelValue || e.defaultDate),
          e
        );
      },
      getElem() {
        return this.config.wrap ? this.$el.parentNode : this.$el;
      },
      onInput(e) {
        let t = e.target;
        de().then(() => {
          this.$emit(`update:modelValue`, s8(t.value));
        });
      },
      fpInput() {
        return this.fp.altInput || this.fp.input;
      },
      onBlur(e) {
        this.$emit(`blur`, s8(e.target.value));
      },
      onClose(e, t) {
        this.$emit(`update:modelValue`, t);
      },
      watchDisabled(e) {
        e
          ? this.fpInput().setAttribute(`disabled`, ``)
          : this.fpInput().removeAttribute(`disabled`);
      },
    },
    watch: {
      config: {
        deep: !0,
        handler(e) {
          if (!this.fp) return;
          let t = Object.assign({}, e);
          (c8.forEach((e) => {
            delete t[e];
          }),
            this.fp.set(t),
            Pde.forEach((e) => {
              t[e] !== void 0 && this.fp.set(e, t[e]);
            }));
        },
      },
      modelValue(e) {
        var t;
        !this.$el || e === s8(this.$el.value) || (t = this.fp) == null || t.setDate(e, !0);
      },
    },
    beforeUnmount() {
      this.fp &&=
        (this.fpInput().removeEventListener(`blur`, this.onBlur), this.fp.destroy(), null);
    },
  });
(B(),
  (function () {
    try {
      if (typeof document < `u`) {
        var e = document.createElement(`style`);
        (e.appendChild(
          document.createTextNode(
            `.vue3-marquee{display:flex!important;position:relative}.vue3-marquee.horizontal{overflow-x:hidden!important;flex-direction:row!important;width:100%;height:max-content}.vue3-marquee.vertical{overflow-y:hidden!important;flex-direction:column!important;height:100%;width:max-content}.vue3-marquee:hover>.marquee{animation-play-state:var(--pauseOnHover)}.vue3-marquee:active>.marquee{animation-play-state:var(--pauseOnClick)}.vue3-marquee>.marquee{flex:0 0 auto;min-width:var(--min-width);min-height:var(--min-height);z-index:1;animation:var(--orientation) var(--duration) linear var(--delay) var(--loops);animation-play-state:var(--pauseAnimation);animation-direction:var(--direction)}.vue3-marquee.horizontal>.marquee{display:flex;flex-direction:row;align-items:center}.vue3-marquee.vertical>.marquee{display:flex;flex-direction:column;align-items:center}@keyframes scrollX{0%{transform:translate(0)}to{transform:translate(-100%)}}@keyframes scrollY{0%{transform:translateY(0)}to{transform:translateY(-100%)}}.vue3-marquee>.overlay{position:absolute;width:100%;height:100%}.vue3-marquee>.transparent-overlay{position:absolute;width:100%;height:100%}.vue3-marquee>.overlay:before,.vue3-marquee>.overlay:after{content:"";position:absolute;z-index:2}.vue3-marquee.horizontal>.overlay:before,.vue3-marquee.horizontal>.overlay:after{background:linear-gradient(to right,var(--gradient-color));height:100%;width:var(--gradient-length)}.vue3-marquee.vertical>.overlay:before,.vue3-marquee.vertical>.overlay:after{background:linear-gradient(to bottom,var(--gradient-color));height:var(--gradient-length);width:100%}.vue3-marquee.horizontal>.overlay:after{transform:rotate(180deg)}.vue3-marquee.vertical>.overlay:after{transform:rotate(-180deg)}.vue3-marquee>.overlay:before{left:0;top:0}.vue3-marquee.horizontal>.overlay:after{right:0;top:0}.vue3-marquee.vertical>.overlay:after{left:0;bottom:0}`,
          ),
        ),
          document.head.appendChild(e));
      }
    } catch (e) {
      console.error(`vite-plugin-css-injected-by-js`, e);
    }
  })());
var Ide = Object.defineProperty,
  l8 = Object.getOwnPropertySymbols,
  Lde = Object.prototype.hasOwnProperty,
  Rde = Object.prototype.propertyIsEnumerable,
  u8 = (e, t, n) =>
    t in e
      ? Ide(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: n,
        })
      : (e[t] = n),
  d8 = (e, t) => {
    for (var n in (t ||= {})) Lde.call(t, n) && u8(e, n, t[n]);
    if (l8) for (var n of l8(t)) Rde.call(t, n) && u8(e, n, t[n]);
    return e;
  },
  zde = (e, t) => {
    let n = e.__vccOpts || e;
    for (let [e, r] of t) n[e] = r;
    return n;
  },
  Bde = k({
    props: {
      vertical: {
        type: Boolean,
        default: !1,
      },
      direction: {
        type: String,
        default: `normal`,
      },
      duration: {
        type: Number,
        default: 20,
      },
      delay: {
        type: Number,
        default: 0,
      },
      loop: {
        type: Number,
        default: 0,
      },
      clone: {
        type: Boolean,
        default: !1,
      },
      gradient: {
        type: Boolean,
        default: !1,
      },
      gradientColor: {
        type: Array,
        default: [255, 255, 255],
      },
      gradientWidth: {
        type: String,
      },
      gradientLength: {
        type: String,
      },
      pauseOnHover: {
        type: Boolean,
        default: !1,
      },
      pauseOnClick: {
        type: Boolean,
        default: !1,
      },
      pause: {
        type: Boolean,
        default: !1,
      },
      animateOnOverflowOnly: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [
      `onComplete`,
      `onLoopComplete`,
      `onPause`,
      `onResume`,
      `onOverflowDetected`,
      `onOverflowCleared`,
    ],
    setup(e, { emit: t }) {
      let n = F(0),
        r = F(`100%`),
        i = F(`100%`),
        a = F(0),
        o = F(!1),
        s = F(!0),
        c = F(0),
        l = F(0),
        u = F(0),
        d = F(0),
        f = F(!1),
        p = F(!1),
        m = F(0),
        h = F(null),
        g = F(`200px`),
        v = F(!1),
        y = F(null),
        b = F(null),
        x = async () => {
          (await S(), a.value++);
        },
        S = async () => {
          (e.vertical && (o.value = !0),
            setInterval(() => {
              if (
                ((r.value = `0%`),
                (i.value = `0%`),
                y.value !== null && b.value !== null && y.value && b.value)
              ) {
                if (e.vertical && `clientHeight` in y.value && `clientHeight` in b.value) {
                  ((d.value = y.value.clientHeight), (u.value = b.value.clientHeight));
                  let t = Math.ceil(u.value / d.value);
                  return (
                    (n.value = e.animateOnOverflowOnly ? 0 : isFinite(t) ? t : 0),
                    (o.value = !1),
                    n.value
                  );
                } else if (!e.vertical && `clientWidth` in y.value && `clientWidth` in b.value) {
                  if (
                    ((l.value = y.value.clientWidth),
                    (c.value = b.value.clientWidth),
                    e.animateOnOverflowOnly && v.value)
                  )
                    return (
                      l.value <= c.value
                        ? ((s.value = !0), t(`onOverflowCleared`))
                        : ((s.value = !1), t(`onOverflowDetected`)),
                      0
                    );
                  let r = Math.ceil(c.value / l.value);
                  return ((n.value = isFinite(r) ? r : 0), n.value);
                } else return ((r.value = `100%`), (i.value = `100%`), 0);
              } else return ((r.value = `100%`), (i.value = `100%`), 0);
            }, 100));
        };
      (He(l, async () => {
        e.clone && x();
      }),
        He(c, async () => {
          (e.clone || e.animateOnOverflowOnly) && x();
        }),
        He(
          () => e.pause,
          (e, n) => {
            e !== n && t(e ? `onResume` : `onPause`);
          },
        ));
      let C = () => {
          e.pauseOnHover && (t(`onPause`), (f.value = !0));
        },
        w = () => {
          e.pauseOnHover && (t(`onResume`), (f.value = !1));
        },
        T = () => {
          e.pauseOnClick && (t(`onPause`), (p.value = !0));
        },
        E = () => {
          e.pauseOnClick && (t(`onResume`), (p.value = !1));
        },
        D = V(() =>
          e.pause || (e.vertical && o.value) || (e.animateOnOverflowOnly && s.value)
            ? `paused`
            : `running`,
        ),
        ee = V(() =>
          (e.pauseOnHover && (f.value || p.value)) || (!e.pauseOnHover && D.value === `paused`)
            ? `paused`
            : `running`,
        ),
        te = V(() =>
          (e.pauseOnHover && f.value) ||
          (e.pauseOnClick && p.value) ||
          (!e.pauseOnHover && D.value === `paused`)
            ? `paused`
            : `running`,
        ),
        O = V(() => {
          let t = {
              "--duration": `${e.duration}s`,
              "--delay": `${e.delay}s`,
              "--direction": `${e.direction}`,
              "--pauseOnHover": `${ee.value}`,
              "--pauseOnClick": `${te.value}`,
              "--pauseAnimation": `${D.value}`,
              "--loops": `${e.loop === 0 ? `infinite` : e.loop}`,
              "--gradient-color": `rgba(${e.gradientColor[0]}, ${e.gradientColor[1]}, ${e.gradientColor[2]}, 1), rgba(${e.gradientColor[0]}, ${e.gradientColor[1]}, ${e.gradientColor[2]}, 0)`,
              "--gradient-length": `${g.value}`,
              "--min-width": `${r.value}`,
              "--min-height": `${i.value}`,
            },
            n = {
              "--orientation": `scrollX`,
              orientation: `horizontal`,
            };
          return (e.vertical && (n[`--orientation`] = `scrollY`), d8(d8({}, t), n));
        }),
        k = V(() => !!e.gradient),
        ne = async () => {
          (e.vertical
            ? ((i.value = `100%`),
              (r.value = `auto`),
              e.animateOnOverflowOnly &&
                console.warn(
                  "The `animateOnOverflowOnly` prop is not supported for vertical marquees.",
                ))
            : ((i.value = `auto`),
              e.animateOnOverflowOnly ? (r.value = `auto`) : (r.value = `100%`)),
            e.gradient &&
              (e.gradientWidth
                ? (console.warn(
                    "The `gradientWidth` prop has been deprecated and will be removed in a future release. Please use `gradientLength` instead.",
                  ),
                  (g.value = e.gradientWidth))
                : e.gradientLength && (g.value = e.gradientLength)),
            e.clone || e.animateOnOverflowOnly ? (await S(), x(), (v.value = !0)) : (v.value = !0));
        };
      return (
        Qe(async () => {
          (ne(),
            (h.value = setInterval(() => {
              (m.value++,
                e.loop !== 0 && m.value === e.loop && (t(`onComplete`), clearInterval(h.value)),
                t(`onLoopComplete`));
            }, e.duration * 1e3)));
        }),
        oe(() => {
          clearInterval(h.value);
        }),
        {
          ready: v,
          contentWidth: l,
          containerWidth: c,
          contentHeight: d,
          containerHeight: u,
          loopCounter: m,
          loopInterval: h,
          mouseOverMarquee: f,
          mouseDownMarquee: p,
          minWidth: r,
          minHeight: i,
          animateOnOverflowPause: s,
          marqueeContent: y,
          marqueeOverlayContainer: b,
          componentKey: a,
          showGradient: k,
          cloneAmount: n,
          ForcesUpdate: x,
          checkForClone: S,
          setupMarquee: ne,
          getCurrentStyle: O,
          hoverStarted: C,
          hoverEnded: w,
          mouseDown: T,
          mouseUp: E,
        }
      );
    },
  }),
  Vde = {
    class: `transparent-overlay`,
    ref: `marqueeOverlayContainer`,
    "aria-hidden": !0,
  },
  Hde = {
    class: `marquee`,
    ref: `marqueeContent`,
  },
  Ude = {
    key: 1,
    "aria-hidden": !0,
    class: `marquee`,
  };
function Wde(e, t, n, r, i, a) {
  return e.ready
    ? (A(),
      M(
        `div`,
        {
          class: O([
            `vue3-marquee`,
            {
              vertical: e.vertical,
              horizontal: !e.vertical,
            },
          ]),
          style: Pe(e.getCurrentStyle),
          key: e.componentKey,
          onMouseenter: (t[0] ||= (...t) => e.hoverStarted && e.hoverStarted(...t)),
          onMouseleave: (t[1] ||= (...t) => e.hoverEnded && e.hoverEnded(...t)),
          onMousedown: (t[2] ||= (...t) => e.mouseDown && e.mouseDown(...t)),
          onMouseup: (t[3] ||= (...t) => e.mouseUp && e.mouseUp(...t)),
        },
        [
          W(`div`, Vde, null, 512),
          e.showGradient
            ? (A(),
              M(
                `div`,
                {
                  key: 0,
                  "aria-hidden": !0,
                  class: O([
                    `overlay`,
                    {
                      vertical: e.vertical,
                      horizontal: !e.vertical,
                    },
                  ]),
                },
                null,
                2,
              ))
            : U(``, !0),
          W(`div`, Hde, [z(e.$slots, `default`)], 512),
          !e.animateOnOverflowOnly || (e.animateOnOverflowOnly && !e.animateOnOverflowPause)
            ? (A(), M(`div`, Ude, [z(e.$slots, `default`)]))
            : U(``, !0),
          (A(!0),
          M(
            ke,
            null,
            ae(
              e.cloneAmount,
              (t) => (
                A(),
                M(
                  `div`,
                  {
                    "aria-hidden": !0,
                    class: `marquee cloned`,
                    key: t,
                  },
                  [z(e.$slots, `default`)],
                )
              ),
            ),
            128,
          )),
        ],
        38,
      ))
    : U(``, !0);
}
var Gde = zde(Bde, [[`render`, Wde]]),
  Kde = {
    install(e, t) {
      let n = t?.name ?? `Vue3Marquee`;
      e.component(n, Gde);
    },
  },
  qde = [`top`, `right`, `bottom`, `left`],
  f8 = [`start`, `end`],
  p8 = qde.reduce((e, t) => e.concat(t, t + `-` + f8[0], t + `-` + f8[1]), []),
  m8 = Math.min,
  h8 = Math.max,
  Jde = {
    left: `right`,
    right: `left`,
    bottom: `top`,
    top: `bottom`,
  };
function g8(e, t, n) {
  return h8(e, m8(t, n));
}
function _8(e, t) {
  return typeof e == `function` ? e(t) : e;
}
function v8(e) {
  return e.split(`-`)[0];
}
function y8(e) {
  return e.split(`-`)[1];
}
function b8(e) {
  return e === `x` ? `y` : `x`;
}
function x8(e) {
  return e === `y` ? `height` : `width`;
}
function S8(e) {
  let t = e[0];
  return t === `t` || t === `b` ? `y` : `x`;
}
function C8(e) {
  return b8(S8(e));
}
function w8(e, t, n) {
  n === void 0 && (n = !1);
  let r = y8(e),
    i = C8(e),
    a = x8(i),
    o =
      i === `x`
        ? r === (n ? `end` : `start`)
          ? `right`
          : `left`
        : r === `start`
          ? `bottom`
          : `top`;
  return (t.reference[a] > t.floating[a] && (o = O8(o)), [o, O8(o)]);
}
function Yde(e) {
  let t = O8(e);
  return [T8(e), t, T8(t)];
}
function T8(e) {
  return e.includes(`start`) ? e.replace(`start`, `end`) : e.replace(`end`, `start`);
}
var E8 = [`left`, `right`],
  D8 = [`right`, `left`],
  Xde = [`top`, `bottom`],
  Zde = [`bottom`, `top`];
function Qde(e, t, n) {
  switch (e) {
    case `top`:
    case `bottom`:
      return n ? (t ? D8 : E8) : t ? E8 : D8;
    case `left`:
    case `right`:
      return t ? Xde : Zde;
    default:
      return [];
  }
}
function $de(e, t, n, r) {
  let i = y8(e),
    a = Qde(v8(e), n === `start`, r);
  return (i && ((a = a.map((e) => e + `-` + i)), t && (a = a.concat(a.map(T8)))), a);
}
function O8(e) {
  let t = v8(e);
  return Jde[t] + e.slice(t.length);
}
function efe(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e,
  };
}
function k8(e) {
  return typeof e == `number`
    ? {
        top: e,
        right: e,
        bottom: e,
        left: e,
      }
    : efe(e);
}
function A8(e) {
  let { x: t, y: n, width: r, height: i } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n,
  };
}
function j8(e, t, n) {
  let { reference: r, floating: i } = e,
    a = S8(t),
    o = C8(t),
    s = x8(o),
    c = v8(t),
    l = a === `y`,
    u = r.x + r.width / 2 - i.width / 2,
    d = r.y + r.height / 2 - i.height / 2,
    f = r[s] / 2 - i[s] / 2,
    p;
  switch (c) {
    case `top`:
      p = {
        x: u,
        y: r.y - i.height,
      };
      break;
    case `bottom`:
      p = {
        x: u,
        y: r.y + r.height,
      };
      break;
    case `right`:
      p = {
        x: r.x + r.width,
        y: d,
      };
      break;
    case `left`:
      p = {
        x: r.x - i.width,
        y: d,
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y,
      };
  }
  switch (y8(t)) {
    case `start`:
      p[o] -= f * (n && l ? -1 : 1);
      break;
    case `end`:
      p[o] += f * (n && l ? -1 : 1);
      break;
  }
  return p;
}
async function tfe(e, t) {
  t === void 0 && (t = {});
  let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e,
    {
      boundary: c = `clippingAncestors`,
      rootBoundary: l = `viewport`,
      elementContext: u = `floating`,
      altBoundary: d = !1,
      padding: f = 0,
    } = _8(t, e),
    p = k8(f),
    m = o[d ? (u === `floating` ? `reference` : `floating`) : u],
    h = A8(
      await i.getClippingRect({
        element:
          ((await (i.isElement == null ? void 0 : i.isElement(m))) ?? !0)
            ? m
            : m.contextElement ||
              (await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating))),
        boundary: c,
        rootBoundary: l,
        strategy: s,
      }),
    ),
    g =
      u === `floating`
        ? {
            x: n,
            y: r,
            width: a.floating.width,
            height: a.floating.height,
          }
        : a.reference,
    v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)),
    y = ((await (i.isElement == null ? void 0 : i.isElement(v))) &&
      (await (i.getScale == null ? void 0 : i.getScale(v)))) || {
      x: 1,
      y: 1,
    },
    b = A8(
      i.convertOffsetParentRelativeRectToViewportRelativeRect
        ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: o,
            rect: g,
            offsetParent: v,
            strategy: s,
          })
        : g,
    );
  return {
    top: (h.top - b.top + p.top) / y.y,
    bottom: (b.bottom - h.bottom + p.bottom) / y.y,
    left: (h.left - b.left + p.left) / y.x,
    right: (b.right - h.right + p.right) / y.x,
  };
}
var nfe = 50,
  rfe = async (e, t, n) => {
    let { placement: r = `bottom`, strategy: i = `absolute`, middleware: a = [], platform: o } = n,
      s = o.detectOverflow
        ? o
        : {
            ...o,
            detectOverflow: tfe,
          },
      c = await (o.isRTL == null ? void 0 : o.isRTL(t)),
      l = await o.getElementRects({
        reference: e,
        floating: t,
        strategy: i,
      }),
      { x: u, y: d } = j8(l, r, c),
      f = r,
      p = 0,
      m = {};
    for (let n = 0; n < a.length; n++) {
      let h = a[n];
      if (!h) continue;
      let { name: g, fn: v } = h,
        {
          x: y,
          y: b,
          data: x,
          reset: S,
        } = await v({
          x: u,
          y: d,
          initialPlacement: r,
          placement: f,
          strategy: i,
          middlewareData: m,
          rects: l,
          platform: s,
          elements: {
            reference: e,
            floating: t,
          },
        });
      ((u = y ?? u),
        (d = b ?? d),
        (m[g] = {
          ...m[g],
          ...x,
        }),
        S &&
          p < nfe &&
          (p++,
          typeof S == `object` &&
            (S.placement && (f = S.placement),
            S.rects &&
              (l =
                S.rects === !0
                  ? await o.getElementRects({
                      reference: e,
                      floating: t,
                      strategy: i,
                    })
                  : S.rects),
            ({ x: u, y: d } = j8(l, f, c))),
          (n = -1)));
    }
    return {
      x: u,
      y: d,
      placement: f,
      strategy: i,
      middlewareData: m,
    };
  },
  ife = (e) => ({
    name: `arrow`,
    options: e,
    async fn(t) {
      let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t,
        { element: l, padding: u = 0 } = _8(e, t) || {};
      if (l == null) return {};
      let d = k8(u),
        f = {
          x: n,
          y: r,
        },
        p = C8(i),
        m = x8(p),
        h = await o.getDimensions(l),
        g = p === `y`,
        v = g ? `top` : `left`,
        y = g ? `bottom` : `right`,
        b = g ? `clientHeight` : `clientWidth`,
        x = a.reference[m] + a.reference[p] - f[p] - a.floating[m],
        S = f[p] - a.reference[p],
        C = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)),
        w = C ? C[b] : 0;
      (!w || !(await (o.isElement == null ? void 0 : o.isElement(C)))) &&
        (w = s.floating[b] || a.floating[m]);
      let T = x / 2 - S / 2,
        E = w / 2 - h[m] / 2 - 1,
        D = m8(d[v], E),
        ee = m8(d[y], E),
        te = D,
        O = w - h[m] - ee,
        k = w / 2 - h[m] / 2 + T,
        ne = g8(te, k, O),
        re =
          !c.arrow &&
          y8(i) != null &&
          k !== ne &&
          a.reference[m] / 2 - (k < te ? D : ee) - h[m] / 2 < 0,
        A = re ? (k < te ? k - te : k - O) : 0;
      return {
        [p]: f[p] + A,
        data: {
          [p]: ne,
          centerOffset: k - ne - A,
          ...(re && {
            alignmentOffset: A,
          }),
        },
        reset: re,
      };
    },
  });
function afe(e, t, n) {
  return (
    e
      ? [...n.filter((t) => y8(t) === e), ...n.filter((t) => y8(t) !== e)]
      : n.filter((e) => v8(e) === e)
  ).filter((n) => (e ? y8(n) === e || (t ? T8(n) !== n : !1) : !0));
}
var ofe = function (e) {
    return (
      e === void 0 && (e = {}),
      {
        name: `autoPlacement`,
        options: e,
        async fn(t) {
          let { rects: n, middlewareData: r, placement: i, platform: a, elements: o } = t,
            {
              crossAxis: s = !1,
              alignment: c,
              allowedPlacements: l = p8,
              autoAlignment: u = !0,
              ...d
            } = _8(e, t),
            f = c !== void 0 || l === p8 ? afe(c || null, u, l) : l,
            p = await a.detectOverflow(t, d),
            m = r.autoPlacement?.index || 0,
            h = f[m];
          if (h == null) return {};
          let g = w8(h, n, await (a.isRTL == null ? void 0 : a.isRTL(o.floating)));
          if (i !== h)
            return {
              reset: {
                placement: f[0],
              },
            };
          let v = [p[v8(h)], p[g[0]], p[g[1]]],
            y = [
              ...(r.autoPlacement?.overflows || []),
              {
                placement: h,
                overflows: v,
              },
            ],
            b = f[m + 1];
          if (b)
            return {
              data: {
                index: m + 1,
                overflows: y,
              },
              reset: {
                placement: b,
              },
            };
          let x = y
              .map((e) => {
                let t = y8(e.placement);
                return [
                  e.placement,
                  t && s ? e.overflows.slice(0, 2).reduce((e, t) => e + t, 0) : e.overflows[0],
                  e.overflows,
                ];
              })
              .sort((e, t) => e[1] - t[1]),
            S =
              x.filter((e) => e[2].slice(0, y8(e[0]) ? 2 : 3).every((e) => e <= 0))[0]?.[0] ||
              x[0][0];
          return S === i
            ? {}
            : {
                data: {
                  index: m + 1,
                  overflows: y,
                },
                reset: {
                  placement: S,
                },
              };
        },
      }
    );
  },
  sfe = function (e) {
    return (
      e === void 0 && (e = {}),
      {
        name: `flip`,
        options: e,
        async fn(t) {
          var n;
          let {
              placement: r,
              middlewareData: i,
              rects: a,
              initialPlacement: o,
              platform: s,
              elements: c,
            } = t,
            {
              mainAxis: l = !0,
              crossAxis: u = !0,
              fallbackPlacements: d,
              fallbackStrategy: f = `bestFit`,
              fallbackAxisSideDirection: p = `none`,
              flipAlignment: m = !0,
              ...h
            } = _8(e, t);
          if ((n = i.arrow) != null && n.alignmentOffset) return {};
          let g = v8(r),
            v = S8(o),
            y = v8(o) === o,
            b = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)),
            x = d || (y || !m ? [O8(o)] : Yde(o)),
            S = p !== `none`;
          !d && S && x.push(...$de(o, m, p, b));
          let C = [o, ...x],
            w = await s.detectOverflow(t, h),
            T = [],
            E = i.flip?.overflows || [];
          if ((l && T.push(w[g]), u)) {
            let e = w8(r, a, b);
            T.push(w[e[0]], w[e[1]]);
          }
          if (
            ((E = [
              ...E,
              {
                placement: r,
                overflows: T,
              },
            ]),
            !T.every((e) => e <= 0))
          ) {
            let e = (i.flip?.index || 0) + 1,
              t = C[e];
            if (
              t &&
              (!(u === `alignment` && v !== S8(t)) ||
                E.every((e) => (S8(e.placement) === v ? e.overflows[0] > 0 : !0)))
            )
              return {
                data: {
                  index: e,
                  overflows: E,
                },
                reset: {
                  placement: t,
                },
              };
            let n = E.filter((e) => e.overflows[0] <= 0).sort(
              (e, t) => e.overflows[1] - t.overflows[1],
            )[0]?.placement;
            if (!n)
              switch (f) {
                case `bestFit`: {
                  let e = E.filter((e) => {
                    if (S) {
                      let t = S8(e.placement);
                      return t === v || t === `y`;
                    }
                    return !0;
                  })
                    .map((e) => [
                      e.placement,
                      e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0),
                    ])
                    .sort((e, t) => e[1] - t[1])[0]?.[0];
                  e && (n = e);
                  break;
                }
                case `initialPlacement`:
                  n = o;
                  break;
              }
            if (r !== n)
              return {
                reset: {
                  placement: n,
                },
              };
          }
          return {};
        },
      }
    );
  },
  cfe = new Set([`left`, `top`]);
async function lfe(e, t) {
  let { placement: n, platform: r, elements: i } = e,
    a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)),
    o = v8(n),
    s = y8(n),
    c = S8(n) === `y`,
    l = cfe.has(o) ? -1 : 1,
    u = a && c ? -1 : 1,
    d = _8(t, e),
    {
      mainAxis: f,
      crossAxis: p,
      alignmentAxis: m,
    } = typeof d == `number`
      ? {
          mainAxis: d,
          crossAxis: 0,
          alignmentAxis: null,
        }
      : {
          mainAxis: d.mainAxis || 0,
          crossAxis: d.crossAxis || 0,
          alignmentAxis: d.alignmentAxis,
        };
  return (
    s && typeof m == `number` && (p = s === `end` ? m * -1 : m),
    c
      ? {
          x: p * u,
          y: f * l,
        }
      : {
          x: f * l,
          y: p * u,
        }
  );
}
var ufe = function (e) {
    return (
      e === void 0 && (e = 0),
      {
        name: `offset`,
        options: e,
        async fn(t) {
          var n;
          let { x: r, y: i, placement: a, middlewareData: o } = t,
            s = await lfe(t, e);
          return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset
            ? {}
            : {
                x: r + s.x,
                y: i + s.y,
                data: {
                  ...s,
                  placement: a,
                },
              };
        },
      }
    );
  },
  dfe = function (e) {
    return (
      e === void 0 && (e = {}),
      {
        name: `shift`,
        options: e,
        async fn(t) {
          let { x: n, y: r, placement: i, platform: a } = t,
            {
              mainAxis: o = !0,
              crossAxis: s = !1,
              limiter: c = {
                fn: (e) => {
                  let { x: t, y: n } = e;
                  return {
                    x: t,
                    y: n,
                  };
                },
              },
              ...l
            } = _8(e, t),
            u = {
              x: n,
              y: r,
            },
            d = await a.detectOverflow(t, l),
            f = S8(v8(i)),
            p = b8(f),
            m = u[p],
            h = u[f];
          if (o) {
            let e = p === `y` ? `top` : `left`,
              t = p === `y` ? `bottom` : `right`,
              n = m + d[e],
              r = m - d[t];
            m = g8(n, m, r);
          }
          if (s) {
            let e = f === `y` ? `top` : `left`,
              t = f === `y` ? `bottom` : `right`,
              n = h + d[e],
              r = h - d[t];
            h = g8(n, h, r);
          }
          let g = c.fn({
            ...t,
            [p]: m,
            [f]: h,
          });
          return {
            ...g,
            data: {
              x: g.x - n,
              y: g.y - r,
              enabled: {
                [p]: o,
                [f]: s,
              },
            },
          };
        },
      }
    );
  },
  ffe = function (e) {
    return (
      e === void 0 && (e = {}),
      {
        name: `size`,
        options: e,
        async fn(t) {
          var n, r;
          let { placement: i, rects: a, platform: o, elements: s } = t,
            { apply: c = () => {}, ...l } = _8(e, t),
            u = await o.detectOverflow(t, l),
            d = v8(i),
            f = y8(i),
            p = S8(i) === `y`,
            { width: m, height: h } = a.floating,
            g,
            v;
          d === `top` || d === `bottom`
            ? ((g = d),
              (v =
                f === ((await (o.isRTL == null ? void 0 : o.isRTL(s.floating))) ? `start` : `end`)
                  ? `left`
                  : `right`))
            : ((v = d), (g = f === `end` ? `top` : `bottom`));
          let y = h - u.top - u.bottom,
            b = m - u.left - u.right,
            x = m8(h - u[g], y),
            S = m8(m - u[v], b),
            C = !t.middlewareData.shift,
            w = x,
            T = S;
          if (
            ((n = t.middlewareData.shift) != null && n.enabled.x && (T = b),
            (r = t.middlewareData.shift) != null && r.enabled.y && (w = y),
            C && !f)
          ) {
            let e = h8(u.left, 0),
              t = h8(u.right, 0),
              n = h8(u.top, 0),
              r = h8(u.bottom, 0);
            p
              ? (T = m - 2 * (e !== 0 || t !== 0 ? e + t : h8(u.left, u.right)))
              : (w = h - 2 * (n !== 0 || r !== 0 ? n + r : h8(u.top, u.bottom)));
          }
          await c({
            ...t,
            availableWidth: T,
            availableHeight: w,
          });
          let E = await o.getDimensions(s.floating);
          return m !== E.width || h !== E.height
            ? {
                reset: {
                  rects: !0,
                },
              }
            : {};
        },
      }
    );
  };
function M8(e) {
  return e.ownerDocument?.defaultView || window;
}
function N8(e) {
  return M8(e).getComputedStyle(e);
}
var P8 = Math.min,
  F8 = Math.max,
  I8 = Math.round;
function L8(e) {
  let t = N8(e),
    n = parseFloat(t.width),
    r = parseFloat(t.height),
    i = e.offsetWidth,
    a = e.offsetHeight,
    o = I8(n) !== i || I8(r) !== a;
  return (
    o && ((n = i), (r = a)),
    {
      width: n,
      height: r,
      fallback: o,
    }
  );
}
function R8(e) {
  return U8(e) ? (e.nodeName || ``).toLowerCase() : ``;
}
var z8;
function B8() {
  if (z8) return z8;
  let e = navigator.userAgentData;
  return e && Array.isArray(e.brands)
    ? ((z8 = e.brands.map((e) => e.brand + `/` + e.version).join(` `)), z8)
    : navigator.userAgent;
}
function V8(e) {
  return e instanceof M8(e).HTMLElement;
}
function H8(e) {
  return e instanceof M8(e).Element;
}
function U8(e) {
  return e instanceof M8(e).Node;
}
function W8(e) {
  return typeof ShadowRoot > `u` ? !1 : e instanceof M8(e).ShadowRoot || e instanceof ShadowRoot;
}
function G8(e) {
  let { overflow: t, overflowX: n, overflowY: r, display: i } = N8(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && ![`inline`, `contents`].includes(i);
}
function pfe(e) {
  return [`table`, `td`, `th`].includes(R8(e));
}
function K8(e) {
  let t = /firefox/i.test(B8()),
    n = N8(e),
    r = n.backdropFilter || n.WebkitBackdropFilter;
  return (
    n.transform !== `none` ||
    n.perspective !== `none` ||
    (!!r && r !== `none`) ||
    (t && n.willChange === `filter`) ||
    (t && !!n.filter && n.filter !== `none`) ||
    [`transform`, `perspective`].some((e) => n.willChange.includes(e)) ||
    [`paint`, `layout`, `strict`, `content`].some((e) => {
      let t = n.contain;
      return t != null && t.includes(e);
    })
  );
}
function q8() {
  return !/^((?!chrome|android).)*safari/i.test(B8());
}
function J8(e) {
  return [`html`, `body`, `#document`].includes(R8(e));
}
function Y8(e) {
  return H8(e) ? e : e.contextElement;
}
var X8 = {
  x: 1,
  y: 1,
};
function Z8(e) {
  let t = Y8(e);
  if (!V8(t)) return X8;
  let n = t.getBoundingClientRect(),
    { width: r, height: i, fallback: a } = L8(t),
    o = (a ? I8(n.width) : n.width) / r,
    s = (a ? I8(n.height) : n.height) / i;
  return (
    (o && Number.isFinite(o)) || (o = 1),
    (s && Number.isFinite(s)) || (s = 1),
    {
      x: o,
      y: s,
    }
  );
}
function Q8(e, t, n, r) {
  (t === void 0 && (t = !1), n === void 0 && (n = !1));
  let i = e.getBoundingClientRect(),
    a = Y8(e),
    o = X8;
  t && (r ? H8(r) && (o = Z8(r)) : (o = Z8(e)));
  let s = a ? M8(a) : window,
    c = !q8() && n,
    l = (i.left + ((c && s.visualViewport?.offsetLeft) || 0)) / o.x,
    u = (i.top + ((c && s.visualViewport?.offsetTop) || 0)) / o.y,
    d = i.width / o.x,
    f = i.height / o.y;
  if (a) {
    let e = M8(a),
      t = r && H8(r) ? M8(r) : r,
      n = e.frameElement;
    for (; n && r && t !== e;) {
      let e = Z8(n),
        t = n.getBoundingClientRect(),
        r = getComputedStyle(n);
      ((t.x += (n.clientLeft + parseFloat(r.paddingLeft)) * e.x),
        (t.y += (n.clientTop + parseFloat(r.paddingTop)) * e.y),
        (l *= e.x),
        (u *= e.y),
        (d *= e.x),
        (f *= e.y),
        (l += t.x),
        (u += t.y),
        (n = M8(n).frameElement));
    }
  }
  return {
    width: d,
    height: f,
    top: u,
    right: l + d,
    bottom: u + f,
    left: l,
    x: l,
    y: u,
  };
}
function $8(e) {
  return ((U8(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function e5(e) {
  return H8(e)
    ? {
        scrollLeft: e.scrollLeft,
        scrollTop: e.scrollTop,
      }
    : {
        scrollLeft: e.pageXOffset,
        scrollTop: e.pageYOffset,
      };
}
function t5(e) {
  return Q8($8(e)).left + e5(e).scrollLeft;
}
function n5(e) {
  if (R8(e) === `html`) return e;
  let t = e.assignedSlot || e.parentNode || (W8(e) && e.host) || $8(e);
  return W8(t) ? t.host : t;
}
function r5(e) {
  let t = n5(e);
  return J8(t) ? t.ownerDocument.body : V8(t) && G8(t) ? t : r5(t);
}
function i5(e, t) {
  t === void 0 && (t = []);
  let n = r5(e),
    r = n === e.ownerDocument?.body,
    i = M8(n);
  return r ? t.concat(i, i.visualViewport || [], G8(n) ? n : []) : t.concat(n, i5(n));
}
function a5(e, t, n) {
  return t === `viewport`
    ? A8(
        (function (e, t) {
          let n = M8(e),
            r = $8(e),
            i = n.visualViewport,
            a = r.clientWidth,
            o = r.clientHeight,
            s = 0,
            c = 0;
          if (i) {
            ((a = i.width), (o = i.height));
            let e = q8();
            (e || (!e && t === `fixed`)) && ((s = i.offsetLeft), (c = i.offsetTop));
          }
          return {
            width: a,
            height: o,
            x: s,
            y: c,
          };
        })(e, n),
      )
    : H8(t)
      ? A8(
          (function (e, t) {
            let n = Q8(e, !0, t === `fixed`),
              r = n.top + e.clientTop,
              i = n.left + e.clientLeft,
              a = V8(e)
                ? Z8(e)
                : {
                    x: 1,
                    y: 1,
                  };
            return {
              width: e.clientWidth * a.x,
              height: e.clientHeight * a.y,
              x: i * a.x,
              y: r * a.y,
            };
          })(t, n),
        )
      : A8(
          (function (e) {
            let t = $8(e),
              n = e5(e),
              r = e.ownerDocument.body,
              i = F8(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth),
              a = F8(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight),
              o = -n.scrollLeft + t5(e),
              s = -n.scrollTop;
            return (
              N8(r).direction === `rtl` && (o += F8(t.clientWidth, r.clientWidth) - i),
              {
                width: i,
                height: a,
                x: o,
                y: s,
              }
            );
          })($8(e)),
        );
}
function o5(e) {
  return V8(e) && N8(e).position !== `fixed` ? e.offsetParent : null;
}
function s5(e) {
  let t = M8(e),
    n = o5(e);
  for (; n && pfe(n) && N8(n).position === `static`;) n = o5(n);
  return n && (R8(n) === `html` || (R8(n) === `body` && N8(n).position === `static` && !K8(n)))
    ? t
    : n ||
        (function (e) {
          let t = n5(e);
          for (; V8(t) && !J8(t);) {
            if (K8(t)) return t;
            t = n5(t);
          }
          return null;
        })(e) ||
        t;
}
function mfe(e, t, n) {
  let r = V8(t),
    i = $8(t),
    a = Q8(e, !0, n === `fixed`, t),
    o = {
      scrollLeft: 0,
      scrollTop: 0,
    },
    s = {
      x: 0,
      y: 0,
    };
  if (r || (!r && n !== `fixed`))
    if (((R8(t) !== `body` || G8(i)) && (o = e5(t)), V8(t))) {
      let e = Q8(t, !0);
      ((s.x = e.x + t.clientLeft), (s.y = e.y + t.clientTop));
    } else i && (s.x = t5(i));
  return {
    x: a.left + o.scrollLeft - s.x,
    y: a.top + o.scrollTop - s.y,
    width: a.width,
    height: a.height,
  };
}
var hfe = {
    getClippingRect: function (e) {
      let { element: t, boundary: n, rootBoundary: r, strategy: i } = e,
        a = [
          ...(n === `clippingAncestors`
            ? (function (e, t) {
                let n = t.get(e);
                if (n) return n;
                let r = i5(e).filter((e) => H8(e) && R8(e) !== `body`),
                  i = null,
                  a = N8(e).position === `fixed`,
                  o = a ? n5(e) : e;
                for (; H8(o) && !J8(o);) {
                  let e = N8(o),
                    t = K8(o);
                  ((
                    a
                      ? t || i
                      : t ||
                        e.position !== `static` ||
                        !i ||
                        ![`absolute`, `fixed`].includes(i.position)
                  )
                    ? (i = e)
                    : (r = r.filter((e) => e !== o)),
                    (o = n5(o)));
                }
                return (t.set(e, r), r);
              })(t, this._c)
            : [].concat(n)),
          r,
        ],
        o = a[0],
        s = a.reduce(
          (e, n) => {
            let r = a5(t, n, i);
            return (
              (e.top = F8(r.top, e.top)),
              (e.right = P8(r.right, e.right)),
              (e.bottom = P8(r.bottom, e.bottom)),
              (e.left = F8(r.left, e.left)),
              e
            );
          },
          a5(t, o, i),
        );
      return {
        width: s.right - s.left,
        height: s.bottom - s.top,
        x: s.left,
        y: s.top,
      };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
      let { rect: t, offsetParent: n, strategy: r } = e,
        i = V8(n),
        a = $8(n);
      if (n === a) return t;
      let o = {
          scrollLeft: 0,
          scrollTop: 0,
        },
        s = {
          x: 1,
          y: 1,
        },
        c = {
          x: 0,
          y: 0,
        };
      if ((i || (!i && r !== `fixed`)) && ((R8(n) !== `body` || G8(a)) && (o = e5(n)), V8(n))) {
        let e = Q8(n);
        ((s = Z8(n)), (c.x = e.x + n.clientLeft), (c.y = e.y + n.clientTop));
      }
      return {
        width: t.width * s.x,
        height: t.height * s.y,
        x: t.x * s.x - o.scrollLeft * s.x + c.x,
        y: t.y * s.y - o.scrollTop * s.y + c.y,
      };
    },
    isElement: H8,
    getDimensions: function (e) {
      return V8(e) ? L8(e) : e.getBoundingClientRect();
    },
    getOffsetParent: s5,
    getDocumentElement: $8,
    getScale: Z8,
    async getElementRects(e) {
      let { reference: t, floating: n, strategy: r } = e,
        i = this.getOffsetParent || s5,
        a = this.getDimensions;
      return {
        reference: mfe(t, await i(n), r),
        floating: {
          x: 0,
          y: 0,
          ...(await a(n)),
        },
      };
    },
    getClientRects: (e) => Array.from(e.getClientRects()),
    isRTL: (e) => N8(e).direction === `rtl`,
  },
  gfe = (e, t, n) => {
    let r = new Map(),
      i = {
        platform: hfe,
        ...n,
      },
      a = {
        ...i.platform,
        _c: r,
      };
    return rfe(e, t, {
      ...i,
      platform: a,
    });
  };
B();
var c5 = {
  disabled: !1,
  distance: 5,
  skidding: 0,
  container: `body`,
  boundary: void 0,
  instantMove: !1,
  disposeTimeout: 150,
  popperTriggers: [],
  strategy: `absolute`,
  preventOverflow: !0,
  flip: !0,
  shift: !0,
  overflowPadding: 0,
  arrowPadding: 0,
  arrowOverflow: !0,
  autoHideOnMousedown: !1,
  themes: {
    tooltip: {
      placement: `top`,
      triggers: [`hover`, `focus`, `touch`],
      hideTriggers: (e) => [...e, `click`],
      delay: {
        show: 200,
        hide: 0,
      },
      handleResize: !1,
      html: !1,
      loadingContent: `...`,
    },
    dropdown: {
      placement: `bottom`,
      triggers: [`click`],
      delay: 0,
      handleResize: !0,
      autoHide: !0,
    },
    menu: {
      $extend: `dropdown`,
      triggers: [`hover`, `focus`],
      popperTriggers: [`hover`],
      delay: {
        show: 0,
        hide: 400,
      },
    },
  },
};
function l5(e, t) {
  let n = c5.themes[e] || {},
    r;
  do
    ((r = n[t]),
      typeof r > `u`
        ? n.$extend
          ? (n = c5.themes[n.$extend] || {})
          : ((n = null), (r = c5[t]))
        : (n = null));
  while (n);
  return r;
}
function _fe(e) {
  let t = [e],
    n = c5.themes[e] || {};
  do n.$extend && !n.$resetCss ? (t.push(n.$extend), (n = c5.themes[n.$extend] || {})) : (n = null);
  while (n);
  return t.map((e) => `v-popper--theme-${e}`);
}
function u5(e) {
  let t = [e],
    n = c5.themes[e] || {};
  do n.$extend ? (t.push(n.$extend), (n = c5.themes[n.$extend] || {})) : (n = null);
  while (n);
  return t;
}
var d5 = !1;
if (typeof window < `u`) {
  d5 = !1;
  try {
    let e = Object.defineProperty({}, "passive", {
      get() {
        d5 = !0;
      },
    });
    window.addEventListener(`test`, null, e);
  } catch {}
}
var f5 = !1;
typeof window < `u` &&
  typeof navigator < `u` &&
  (f5 = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
var p5 = [`auto`, `top`, `bottom`, `left`, `right`].reduce(
    (e, t) => e.concat([t, `${t}-start`, `${t}-end`]),
    [],
  ),
  m5 = {
    hover: `mouseenter`,
    focus: `focus`,
    click: `click`,
    touch: `touchstart`,
    pointer: `pointerdown`,
  },
  h5 = {
    hover: `mouseleave`,
    focus: `blur`,
    click: `click`,
    touch: `touchend`,
    pointer: `pointerup`,
  };
function g5(e, t) {
  let n = e.indexOf(t);
  n !== -1 && e.splice(n, 1);
}
function _5() {
  return new Promise((e) =>
    requestAnimationFrame(() => {
      requestAnimationFrame(e);
    }),
  );
}
var v5 = [],
  y5 = null,
  b5 = {};
function x5(e) {
  let t = b5[e];
  return ((t ||= b5[e] = []), t);
}
var S5 = function () {};
typeof window < `u` && (S5 = window.Element);
function C5(e) {
  return function (t) {
    return l5(t.theme, e);
  };
}
var w5 = `__floating-vue__popper`,
  T5 = () =>
    k({
      name: `VPopper`,
      provide() {
        return {
          [w5]: {
            parentPopper: this,
          },
        };
      },
      inject: {
        [w5]: {
          default: null,
        },
      },
      props: {
        theme: {
          type: String,
          required: !0,
        },
        targetNodes: {
          type: Function,
          required: !0,
        },
        referenceNode: {
          type: Function,
          default: null,
        },
        popperNode: {
          type: Function,
          required: !0,
        },
        shown: {
          type: Boolean,
          default: !1,
        },
        showGroup: {
          type: String,
          default: null,
        },
        ariaId: {
          default: null,
        },
        disabled: {
          type: Boolean,
          default: C5(`disabled`),
        },
        positioningDisabled: {
          type: Boolean,
          default: C5(`positioningDisabled`),
        },
        placement: {
          type: String,
          default: C5(`placement`),
          validator: (e) => p5.includes(e),
        },
        delay: {
          type: [String, Number, Object],
          default: C5(`delay`),
        },
        distance: {
          type: [Number, String],
          default: C5(`distance`),
        },
        skidding: {
          type: [Number, String],
          default: C5(`skidding`),
        },
        triggers: {
          type: Array,
          default: C5(`triggers`),
        },
        showTriggers: {
          type: [Array, Function],
          default: C5(`showTriggers`),
        },
        hideTriggers: {
          type: [Array, Function],
          default: C5(`hideTriggers`),
        },
        popperTriggers: {
          type: Array,
          default: C5(`popperTriggers`),
        },
        popperShowTriggers: {
          type: [Array, Function],
          default: C5(`popperShowTriggers`),
        },
        popperHideTriggers: {
          type: [Array, Function],
          default: C5(`popperHideTriggers`),
        },
        container: {
          type: [String, Object, S5, Boolean],
          default: C5(`container`),
        },
        boundary: {
          type: [String, S5],
          default: C5(`boundary`),
        },
        strategy: {
          type: String,
          validator: (e) => [`absolute`, `fixed`].includes(e),
          default: C5(`strategy`),
        },
        autoHide: {
          type: [Boolean, Function],
          default: C5(`autoHide`),
        },
        handleResize: {
          type: Boolean,
          default: C5(`handleResize`),
        },
        instantMove: {
          type: Boolean,
          default: C5(`instantMove`),
        },
        eagerMount: {
          type: Boolean,
          default: C5(`eagerMount`),
        },
        popperClass: {
          type: [String, Array, Object],
          default: C5(`popperClass`),
        },
        computeTransformOrigin: {
          type: Boolean,
          default: C5(`computeTransformOrigin`),
        },
        autoMinSize: {
          type: Boolean,
          default: C5(`autoMinSize`),
        },
        autoSize: {
          type: [Boolean, String],
          default: C5(`autoSize`),
        },
        autoMaxSize: {
          type: Boolean,
          default: C5(`autoMaxSize`),
        },
        autoBoundaryMaxSize: {
          type: Boolean,
          default: C5(`autoBoundaryMaxSize`),
        },
        preventOverflow: {
          type: Boolean,
          default: C5(`preventOverflow`),
        },
        overflowPadding: {
          type: [Number, String],
          default: C5(`overflowPadding`),
        },
        arrowPadding: {
          type: [Number, String],
          default: C5(`arrowPadding`),
        },
        arrowOverflow: {
          type: Boolean,
          default: C5(`arrowOverflow`),
        },
        flip: {
          type: Boolean,
          default: C5(`flip`),
        },
        shift: {
          type: Boolean,
          default: C5(`shift`),
        },
        shiftCrossAxis: {
          type: Boolean,
          default: C5(`shiftCrossAxis`),
        },
        noAutoFocus: {
          type: Boolean,
          default: C5(`noAutoFocus`),
        },
        disposeTimeout: {
          type: Number,
          default: C5(`disposeTimeout`),
        },
      },
      emits: {
        show: () => !0,
        hide: () => !0,
        "update:shown": (e) => !0,
        "apply-show": () => !0,
        "apply-hide": () => !0,
        "close-group": () => !0,
        "close-directive": () => !0,
        "auto-hide": () => !0,
        resize: () => !0,
      },
      data() {
        return {
          isShown: !1,
          isMounted: !1,
          skipTransition: !1,
          classes: {
            showFrom: !1,
            showTo: !1,
            hideFrom: !1,
            hideTo: !0,
          },
          result: {
            x: 0,
            y: 0,
            placement: ``,
            strategy: this.strategy,
            arrow: {
              x: 0,
              y: 0,
              centerOffset: 0,
            },
            transformOrigin: null,
          },
          randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join(`_`)}`,
          shownChildren: new Set(),
          lastAutoHide: !0,
          pendingHide: !1,
          containsGlobalTarget: !1,
          isDisposed: !0,
          mouseDownContains: !1,
        };
      },
      computed: {
        popperId() {
          return this.ariaId == null ? this.randomId : this.ariaId;
        },
        shouldMountContent() {
          return this.eagerMount || this.isMounted;
        },
        slotData() {
          return {
            popperId: this.popperId,
            isShown: this.isShown,
            shouldMountContent: this.shouldMountContent,
            skipTransition: this.skipTransition,
            autoHide: typeof this.autoHide == `function` ? this.lastAutoHide : this.autoHide,
            show: this.show,
            hide: this.hide,
            handleResize: this.handleResize,
            onResize: this.onResize,
            classes: {
              ...this.classes,
              popperClass: this.popperClass,
            },
            result: this.positioningDisabled ? null : this.result,
            attrs: this.$attrs,
          };
        },
        parentPopper() {
          return this[w5]?.parentPopper;
        },
        hasPopperShowTriggerHover() {
          return (
            this.popperTriggers?.includes(`hover`) || this.popperShowTriggers?.includes(`hover`)
          );
        },
      },
      watch: {
        shown: `$_autoShowHide`,
        disabled(e) {
          e ? this.dispose() : this.init();
        },
        async container() {
          this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
        },
        triggers: {
          handler: `$_refreshListeners`,
          deep: !0,
        },
        positioningDisabled: `$_refreshListeners`,
        ...[
          `placement`,
          `distance`,
          `skidding`,
          `boundary`,
          `strategy`,
          `overflowPadding`,
          `arrowPadding`,
          `preventOverflow`,
          `shift`,
          `shiftCrossAxis`,
          `flip`,
        ].reduce((e, t) => ((e[t] = `$_computePosition`), e), {}),
      },
      created() {
        (this.autoMinSize &&
          console.warn(
            '[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.',
          ),
          this.autoMaxSize &&
            console.warn(
              "[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.",
            ));
      },
      mounted() {
        (this.init(), this.$_detachPopperNode());
      },
      activated() {
        this.$_autoShowHide();
      },
      deactivated() {
        this.hide();
      },
      beforeUnmount() {
        this.dispose();
      },
      methods: {
        show({ event: e = null, skipDelay: t = !1, force: n = !1 } = {}) {
          var r;
          ((r = this.parentPopper) != null &&
            r.lockedChild &&
            this.parentPopper.lockedChild !== this) ||
            ((this.pendingHide = !1),
            (n || !this.disabled) &&
              (this.parentPopper?.lockedChild === this && (this.parentPopper.lockedChild = null),
              this.$_scheduleShow(e, t),
              this.$emit(`show`),
              (this.$_showFrameLocked = !0),
              requestAnimationFrame(() => {
                this.$_showFrameLocked = !1;
              })),
            this.$emit(`update:shown`, !0));
        },
        hide({ event: e = null, skipDelay: t = !1 } = {}) {
          if (!this.$_hideInProgress) {
            if (this.shownChildren.size > 0) {
              this.pendingHide = !0;
              return;
            }
            if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
              this.parentPopper &&
                ((this.parentPopper.lockedChild = this),
                clearTimeout(this.parentPopper.lockedChildTimer),
                (this.parentPopper.lockedChildTimer = setTimeout(() => {
                  this.parentPopper.lockedChild === this &&
                    (this.parentPopper.lockedChild.hide({
                      skipDelay: t,
                    }),
                    (this.parentPopper.lockedChild = null));
                }, 1e3)));
              return;
            }
            (this.parentPopper?.lockedChild === this && (this.parentPopper.lockedChild = null),
              (this.pendingHide = !1),
              this.$_scheduleHide(e, t),
              this.$emit(`hide`),
              this.$emit(`update:shown`, !1));
          }
        },
        init() {
          this.isDisposed &&
            ((this.isDisposed = !1),
            (this.isMounted = !1),
            (this.$_events = []),
            (this.$_preventShow = !1),
            (this.$_referenceNode = this.referenceNode?.call(this) ?? this.$el),
            (this.$_targetNodes = this.targetNodes().filter((e) => e.nodeType === e.ELEMENT_NODE)),
            (this.$_popperNode = this.popperNode()),
            (this.$_innerNode = this.$_popperNode.querySelector(`.v-popper__inner`)),
            (this.$_arrowNode = this.$_popperNode.querySelector(`.v-popper__arrow-container`)),
            this.$_swapTargetAttrs(`title`, `data-original-title`),
            this.$_detachPopperNode(),
            this.triggers.length && this.$_addEventListeners(),
            this.shown && this.show());
        },
        dispose() {
          this.isDisposed ||
            ((this.isDisposed = !0),
            this.$_removeEventListeners(),
            this.hide({
              skipDelay: !0,
            }),
            this.$_detachPopperNode(),
            (this.isMounted = !1),
            (this.isShown = !1),
            this.$_updateParentShownChildren(!1),
            this.$_swapTargetAttrs(`data-original-title`, `title`));
        },
        async onResize() {
          this.isShown && (await this.$_computePosition(), this.$emit(`resize`));
        },
        async $_computePosition() {
          if (this.isDisposed || this.positioningDisabled) return;
          let e = {
            strategy: this.strategy,
            middleware: [],
          };
          (this.distance || this.skidding) &&
            e.middleware.push(
              ufe({
                mainAxis: this.distance,
                crossAxis: this.skidding,
              }),
            );
          let t = this.placement.startsWith(`auto`);
          if (
            (t
              ? e.middleware.push(
                  ofe({
                    alignment: this.placement.split(`-`)[1] ?? ``,
                  }),
                )
              : (e.placement = this.placement),
            this.preventOverflow &&
              (this.shift &&
                e.middleware.push(
                  dfe({
                    padding: this.overflowPadding,
                    boundary: this.boundary,
                    crossAxis: this.shiftCrossAxis,
                  }),
                ),
              !t &&
                this.flip &&
                e.middleware.push(
                  sfe({
                    padding: this.overflowPadding,
                    boundary: this.boundary,
                  }),
                )),
            e.middleware.push(
              ife({
                element: this.$_arrowNode,
                padding: this.arrowPadding,
              }),
            ),
            this.arrowOverflow &&
              e.middleware.push({
                name: `arrowOverflow`,
                fn: ({ placement: e, rects: t, middlewareData: n }) => {
                  let r,
                    { centerOffset: i } = n.arrow;
                  return (
                    (r =
                      e.startsWith(`top`) || e.startsWith(`bottom`)
                        ? Math.abs(i) > t.reference.width / 2
                        : Math.abs(i) > t.reference.height / 2),
                    {
                      data: {
                        overflow: r,
                      },
                    }
                  );
                },
              }),
            this.autoMinSize || this.autoSize)
          ) {
            let t = this.autoSize ? this.autoSize : this.autoMinSize ? `min` : null;
            e.middleware.push({
              name: `autoSize`,
              fn: ({ rects: e, placement: n, middlewareData: r }) => {
                var i;
                if ((i = r.autoSize) != null && i.skip) return {};
                let a, o;
                return (
                  n.startsWith(`top`) || n.startsWith(`bottom`)
                    ? (a = e.reference.width)
                    : (o = e.reference.height),
                  (this.$_innerNode.style[
                    t === `min` ? `minWidth` : t === `max` ? `maxWidth` : `width`
                  ] = a == null ? null : `${a}px`),
                  (this.$_innerNode.style[
                    t === `min` ? `minHeight` : t === `max` ? `maxHeight` : `height`
                  ] = o == null ? null : `${o}px`),
                  {
                    data: {
                      skip: !0,
                    },
                    reset: {
                      rects: !0,
                    },
                  }
                );
              },
            });
          }
          (this.autoMaxSize || this.autoBoundaryMaxSize) &&
            ((this.$_innerNode.style.maxWidth = null),
            (this.$_innerNode.style.maxHeight = null),
            e.middleware.push(
              ffe({
                boundary: this.boundary,
                padding: this.overflowPadding,
                apply: ({ availableWidth: e, availableHeight: t }) => {
                  ((this.$_innerNode.style.maxWidth = e == null ? null : `${e}px`),
                    (this.$_innerNode.style.maxHeight = t == null ? null : `${t}px`));
                },
              }),
            ));
          let n = await gfe(this.$_referenceNode, this.$_popperNode, e);
          Object.assign(this.result, {
            x: n.x,
            y: n.y,
            placement: n.placement,
            strategy: n.strategy,
            arrow: {
              ...n.middlewareData.arrow,
              ...n.middlewareData.arrowOverflow,
            },
          });
        },
        $_scheduleShow(e, t = !1) {
          if (
            (this.$_updateParentShownChildren(!0),
            (this.$_hideInProgress = !1),
            clearTimeout(this.$_scheduleTimer),
            y5 && this.instantMove && y5.instantMove && y5 !== this.parentPopper)
          ) {
            (y5.$_applyHide(!0), this.$_applyShow(!0));
            return;
          }
          t
            ? this.$_applyShow()
            : (this.$_scheduleTimer = setTimeout(
                this.$_applyShow.bind(this),
                this.$_computeDelay(`show`),
              ));
        },
        $_scheduleHide(e, t = !1) {
          if (this.shownChildren.size > 0) {
            this.pendingHide = !0;
            return;
          }
          (this.$_updateParentShownChildren(!1),
            (this.$_hideInProgress = !0),
            clearTimeout(this.$_scheduleTimer),
            this.isShown && (y5 = this),
            t
              ? this.$_applyHide()
              : (this.$_scheduleTimer = setTimeout(
                  this.$_applyHide.bind(this),
                  this.$_computeDelay(`hide`),
                )));
        },
        $_computeDelay(e) {
          let t = this.delay;
          return parseInt((t && t[e]) || t || 0);
        },
        async $_applyShow(e = !1) {
          (clearTimeout(this.$_disposeTimer),
            clearTimeout(this.$_scheduleTimer),
            (this.skipTransition = e),
            !this.isShown &&
              (this.$_ensureTeleport(),
              await _5(),
              await this.$_computePosition(),
              await this.$_applyShowEffect(),
              this.positioningDisabled ||
                this.$_registerEventListeners(
                  [...i5(this.$_referenceNode), ...i5(this.$_popperNode)],
                  `scroll`,
                  () => {
                    this.$_computePosition();
                  },
                )));
        },
        async $_applyShowEffect() {
          if (this.$_hideInProgress) return;
          if (this.computeTransformOrigin) {
            let e = this.$_referenceNode.getBoundingClientRect(),
              t = this.$_popperNode.querySelector(`.v-popper__wrapper`),
              n = t.parentNode.getBoundingClientRect(),
              r = e.x + e.width / 2 - (n.left + t.offsetLeft),
              i = e.y + e.height / 2 - (n.top + t.offsetTop);
            this.result.transformOrigin = `${r}px ${i}px`;
          }
          ((this.isShown = !0),
            this.$_applyAttrsToTarget({
              "aria-describedby": this.popperId,
              "data-popper-shown": ``,
            }));
          let e = this.showGroup;
          if (e) {
            let t;
            for (let n = 0; n < v5.length; n++)
              ((t = v5[n]), t.showGroup !== e && (t.hide(), t.$emit(`close-group`)));
          }
          (v5.push(this), document.body.classList.add(`v-popper--some-open`));
          for (let e of u5(this.theme))
            (x5(e).push(this), document.body.classList.add(`v-popper--some-open--${e}`));
          (this.$emit(`apply-show`),
            (this.classes.showFrom = !0),
            (this.classes.showTo = !1),
            (this.classes.hideFrom = !1),
            (this.classes.hideTo = !1),
            await _5(),
            (this.classes.showFrom = !1),
            (this.classes.showTo = !0),
            this.noAutoFocus || this.$_popperNode.focus());
        },
        async $_applyHide(e = !1) {
          if (this.shownChildren.size > 0) {
            ((this.pendingHide = !0), (this.$_hideInProgress = !1));
            return;
          }
          if ((clearTimeout(this.$_scheduleTimer), !this.isShown)) return;
          ((this.skipTransition = e),
            g5(v5, this),
            v5.length === 0 && document.body.classList.remove(`v-popper--some-open`));
          for (let e of u5(this.theme)) {
            let t = x5(e);
            (g5(t, this),
              t.length === 0 && document.body.classList.remove(`v-popper--some-open--${e}`));
          }
          (y5 === this && (y5 = null),
            (this.isShown = !1),
            this.$_applyAttrsToTarget({
              "aria-describedby": void 0,
              "data-popper-shown": void 0,
            }),
            clearTimeout(this.$_disposeTimer));
          let t = this.disposeTimeout;
          (t !== null &&
            (this.$_disposeTimer = setTimeout(() => {
              this.$_popperNode && (this.$_detachPopperNode(), (this.isMounted = !1));
            }, t)),
            this.$_removeEventListeners(`scroll`),
            this.$emit(`apply-hide`),
            (this.classes.showFrom = !1),
            (this.classes.showTo = !1),
            (this.classes.hideFrom = !0),
            (this.classes.hideTo = !1),
            await _5(),
            (this.classes.hideFrom = !1),
            (this.classes.hideTo = !0));
        },
        $_autoShowHide() {
          this.shown ? this.show() : this.hide();
        },
        $_ensureTeleport() {
          if (this.isDisposed) return;
          let e = this.container;
          if (
            (typeof e == `string`
              ? (e = window.document.querySelector(e))
              : e === !1 && (e = this.$_targetNodes[0].parentNode),
            !e)
          )
            throw Error(`No container for popover: ` + this.container);
          (e.appendChild(this.$_popperNode), (this.isMounted = !0));
        },
        $_addEventListeners() {
          let e = (e) => {
            (this.isShown && !this.$_hideInProgress) ||
              ((e.usedByTooltip = !0),
              !this.$_preventShow &&
                this.show({
                  event: e,
                }));
          };
          (this.$_registerTriggerListeners(
            this.$_targetNodes,
            m5,
            this.triggers,
            this.showTriggers,
            e,
          ),
            this.$_registerTriggerListeners(
              [this.$_popperNode],
              m5,
              this.popperTriggers,
              this.popperShowTriggers,
              e,
            ));
          let t = (e) => {
            e.usedByTooltip ||
              this.hide({
                event: e,
              });
          };
          (this.$_registerTriggerListeners(
            this.$_targetNodes,
            h5,
            this.triggers,
            this.hideTriggers,
            t,
          ),
            this.$_registerTriggerListeners(
              [this.$_popperNode],
              h5,
              this.popperTriggers,
              this.popperHideTriggers,
              t,
            ));
        },
        $_registerEventListeners(e, t, n) {
          (this.$_events.push({
            targetNodes: e,
            eventType: t,
            handler: n,
          }),
            e.forEach((e) =>
              e.addEventListener(
                t,
                n,
                d5
                  ? {
                      passive: !0,
                    }
                  : void 0,
              ),
            ));
        },
        $_registerTriggerListeners(e, t, n, r, i) {
          let a = n;
          (r != null && (a = typeof r == `function` ? r(a) : r),
            a.forEach((n) => {
              let r = t[n];
              r && this.$_registerEventListeners(e, r, i);
            }));
        },
        $_removeEventListeners(e) {
          let t = [];
          (this.$_events.forEach((n) => {
            let { targetNodes: r, eventType: i, handler: a } = n;
            !e || e === i ? r.forEach((e) => e.removeEventListener(i, a)) : t.push(n);
          }),
            (this.$_events = t));
        },
        $_refreshListeners() {
          this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
        },
        $_handleGlobalClose(e, t = !1) {
          this.$_showFrameLocked ||
            (this.hide({
              event: e,
            }),
            e.closePopover ? this.$emit(`close-directive`) : this.$emit(`auto-hide`),
            t &&
              ((this.$_preventShow = !0),
              setTimeout(() => {
                this.$_preventShow = !1;
              }, 300)));
        },
        $_detachPopperNode() {
          this.$_popperNode.parentNode &&
            this.$_popperNode.parentNode.removeChild(this.$_popperNode);
        },
        $_swapTargetAttrs(e, t) {
          for (let n of this.$_targetNodes) {
            let r = n.getAttribute(e);
            r && (n.removeAttribute(e), n.setAttribute(t, r));
          }
        },
        $_applyAttrsToTarget(e) {
          for (let t of this.$_targetNodes)
            for (let n in e) {
              let r = e[n];
              r == null ? t.removeAttribute(n) : t.setAttribute(n, r);
            }
        },
        $_updateParentShownChildren(e) {
          let t = this.parentPopper;
          for (; t;)
            (e
              ? t.shownChildren.add(this.randomId)
              : (t.shownChildren.delete(this.randomId), t.pendingHide && t.hide()),
              (t = t.parentPopper));
        },
        $_isAimingPopper() {
          let e = this.$_referenceNode.getBoundingClientRect();
          if (M5 >= e.left && M5 <= e.right && N5 >= e.top && N5 <= e.bottom) {
            let e = this.$_popperNode.getBoundingClientRect(),
              t = M5 - A5,
              n = N5 - j5,
              r = e.left + e.width / 2 - A5 + (e.top + e.height / 2) - j5 + e.width + e.height,
              i = A5 + t * r,
              a = j5 + n * r;
            return (
              P5(A5, j5, i, a, e.left, e.top, e.left, e.bottom) ||
              P5(A5, j5, i, a, e.left, e.top, e.right, e.top) ||
              P5(A5, j5, i, a, e.right, e.top, e.right, e.bottom) ||
              P5(A5, j5, i, a, e.left, e.bottom, e.right, e.bottom)
            );
          }
          return !1;
        },
      },
      render() {
        return this.$slots.default(this.slotData);
      },
    });
if (typeof document < `u` && typeof window < `u`) {
  if (f5) {
    let e = d5
      ? {
          passive: !0,
          capture: !0,
        }
      : !0;
    (document.addEventListener(`touchstart`, (e) => E5(e, !0), e),
      document.addEventListener(`touchend`, (e) => D5(e, !0), e));
  } else
    (window.addEventListener(`mousedown`, (e) => E5(e, !1), !0),
      window.addEventListener(`click`, (e) => D5(e, !1), !0));
  window.addEventListener(`resize`, yfe);
}
function E5(e, t) {
  if (c5.autoHideOnMousedown) O5(e, t);
  else
    for (let t = 0; t < v5.length; t++) {
      let n = v5[t];
      try {
        n.mouseDownContains = n.popperNode().contains(e.target);
      } catch {}
    }
}
function D5(e, t) {
  c5.autoHideOnMousedown || O5(e, t);
}
function O5(e, t) {
  let n = {};
  for (let r = v5.length - 1; r >= 0; r--) {
    let i = v5[r];
    try {
      let r = (i.containsGlobalTarget = i.mouseDownContains || i.popperNode().contains(e.target));
      ((i.pendingHide = !1),
        requestAnimationFrame(() => {
          if (((i.pendingHide = !1), !n[i.randomId] && k5(i, r, e))) {
            if ((i.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && r)) {
              let e = i.parentPopper;
              for (; e;) ((n[e.randomId] = !0), (e = e.parentPopper));
              return;
            }
            let a = i.parentPopper;
            for (; a && k5(a, a.containsGlobalTarget, e);)
              (a.$_handleGlobalClose(e, t), (a = a.parentPopper));
          }
        }));
    } catch {}
  }
}
function k5(e, t, n) {
  return n.closeAllPopover || (n.closePopover && t) || (vfe(e, n) && !t);
}
function vfe(e, t) {
  if (typeof e.autoHide == `function`) {
    let n = e.autoHide(t);
    return ((e.lastAutoHide = n), n);
  }
  return e.autoHide;
}
function yfe() {
  for (let e = 0; e < v5.length; e++) v5[e].$_computePosition();
}
var A5 = 0,
  j5 = 0,
  M5 = 0,
  N5 = 0;
typeof window < `u` &&
  window.addEventListener(
    `mousemove`,
    (e) => {
      ((A5 = M5), (j5 = N5), (M5 = e.clientX), (N5 = e.clientY));
    },
    d5
      ? {
          passive: !0,
        }
      : void 0,
  );
function P5(e, t, n, r, i, a, o, s) {
  let c = ((o - i) * (t - a) - (s - a) * (e - i)) / ((s - a) * (n - e) - (o - i) * (r - t)),
    l = ((n - e) * (t - a) - (r - t) * (e - i)) / ((s - a) * (n - e) - (o - i) * (r - t));
  return c >= 0 && c <= 1 && l >= 0 && l <= 1;
}
var bfe = {
    extends: T5(),
  },
  F5 = (e, t) => {
    let n = e.__vccOpts || e;
    for (let [e, r] of t) n[e] = r;
    return n;
  };
function xfe(e, t, n, r, i, a) {
  return (
    A(),
    M(
      `div`,
      {
        ref: `reference`,
        class: O([
          `v-popper`,
          {
            "v-popper--shown": e.slotData.isShown,
          },
        ]),
      },
      [z(e.$slots, `default`, ue(le(e.slotData)))],
      2,
    )
  );
}
var Sfe = F5(bfe, [[`render`, xfe]]);
function Cfe() {
  var e = window.navigator.userAgent,
    t = e.indexOf(`MSIE `);
  if (t > 0) return parseInt(e.substring(t + 5, e.indexOf(`.`, t)), 10);
  if (e.indexOf(`Trident/`) > 0) {
    var n = e.indexOf(`rv:`);
    return parseInt(e.substring(n + 3, e.indexOf(`.`, n)), 10);
  }
  var r = e.indexOf(`Edge/`);
  return r > 0 ? parseInt(e.substring(r + 5, e.indexOf(`.`, r)), 10) : -1;
}
var I5;
function L5() {
  L5.init || ((L5.init = !0), (I5 = Cfe() !== -1));
}
var R5 = {
    name: `ResizeObserver`,
    props: {
      emitOnMount: {
        type: Boolean,
        default: !1,
      },
      ignoreWidth: {
        type: Boolean,
        default: !1,
      },
      ignoreHeight: {
        type: Boolean,
        default: !1,
      },
    },
    emits: [`notify`],
    mounted() {
      (L5(),
        de(() => {
          ((this._w = this.$el.offsetWidth),
            (this._h = this.$el.offsetHeight),
            this.emitOnMount && this.emitSize());
        }));
      let e = document.createElement(`object`);
      ((this._resizeObject = e),
        e.setAttribute(`aria-hidden`, `true`),
        e.setAttribute(`tabindex`, -1),
        (e.onload = this.addResizeHandlers),
        (e.type = `text/html`),
        I5 && this.$el.appendChild(e),
        (e.data = `about:blank`),
        I5 || this.$el.appendChild(e));
    },
    beforeUnmount() {
      this.removeResizeHandlers();
    },
    methods: {
      compareAndNotify() {
        ((!this.ignoreWidth && this._w !== this.$el.offsetWidth) ||
          (!this.ignoreHeight && this._h !== this.$el.offsetHeight)) &&
          ((this._w = this.$el.offsetWidth), (this._h = this.$el.offsetHeight), this.emitSize());
      },
      emitSize() {
        this.$emit(`notify`, {
          width: this._w,
          height: this._h,
        });
      },
      addResizeHandlers() {
        (this._resizeObject.contentDocument.defaultView.addEventListener(
          `resize`,
          this.compareAndNotify,
        ),
          this.compareAndNotify());
      },
      removeResizeHandlers() {
        this._resizeObject &&
          this._resizeObject.onload &&
          (!I5 &&
            this._resizeObject.contentDocument &&
            this._resizeObject.contentDocument.defaultView.removeEventListener(
              `resize`,
              this.compareAndNotify,
            ),
          this.$el.removeChild(this._resizeObject),
          (this._resizeObject.onload = null),
          (this._resizeObject = null));
      },
    },
  },
  wfe = We(`data-v-b329ee4c`);
re(`data-v-b329ee4c`);
var Tfe = {
  class: `resize-observer`,
  tabindex: `-1`,
};
(he(),
  (R5.render = wfe((e, t, n, r, i, a) => (A(), L(`div`, Tfe)))),
  (R5.__scopeId = `data-v-b329ee4c`),
  (R5.__file = `src/components/ResizeObserver.vue`));
var z5 = (e = `theme`) => ({
    computed: {
      themeClass() {
        return _fe(this[e]);
      },
    },
  }),
  Efe = k({
    name: `VPopperContent`,
    components: {
      ResizeObserver: R5,
    },
    mixins: [z5()],
    props: {
      popperId: String,
      theme: String,
      shown: Boolean,
      mounted: Boolean,
      skipTransition: Boolean,
      autoHide: Boolean,
      handleResize: Boolean,
      classes: Object,
      result: Object,
    },
    emits: [`hide`, `resize`],
    methods: {
      toPx(e) {
        return e != null && !isNaN(e) ? `${e}px` : null;
      },
    },
  }),
  Dfe = [`id`, `aria-hidden`, `tabindex`, `data-popper-placement`],
  Ofe = {
    ref: `inner`,
    class: `v-popper__inner`,
  },
  kfe = [
    W(
      `div`,
      {
        class: `v-popper__arrow-outer`,
      },
      null,
      -1,
    ),
    W(
      `div`,
      {
        class: `v-popper__arrow-inner`,
      },
      null,
      -1,
    ),
  ];
function Afe(e, t, n, r, i, a) {
  let o = j(`ResizeObserver`);
  return (
    A(),
    M(
      `div`,
      {
        id: e.popperId,
        ref: `popover`,
        class: O([
          `v-popper__popper`,
          [
            e.themeClass,
            e.classes.popperClass,
            {
              "v-popper__popper--shown": e.shown,
              "v-popper__popper--hidden": !e.shown,
              "v-popper__popper--show-from": e.classes.showFrom,
              "v-popper__popper--show-to": e.classes.showTo,
              "v-popper__popper--hide-from": e.classes.hideFrom,
              "v-popper__popper--hide-to": e.classes.hideTo,
              "v-popper__popper--skip-transition": e.skipTransition,
              "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
              "v-popper__popper--no-positioning": !e.result,
            },
          ],
        ]),
        style: Pe(
          e.result
            ? {
                position: e.result.strategy,
                transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`,
              }
            : void 0,
        ),
        "aria-hidden": e.shown ? `false` : `true`,
        tabindex: e.autoHide ? 0 : void 0,
        "data-popper-placement": e.result ? e.result.placement : void 0,
        onKeyup: (t[2] ||= ze((t) => e.autoHide && e.$emit(`hide`), [`esc`])),
      },
      [
        W(`div`, {
          class: `v-popper__backdrop`,
          onClick: (t[0] ||= (t) => e.autoHide && e.$emit(`hide`)),
        }),
        W(
          `div`,
          {
            class: `v-popper__wrapper`,
            style: Pe(
              e.result
                ? {
                    transformOrigin: e.result.transformOrigin,
                  }
                : void 0,
            ),
          },
          [
            W(
              `div`,
              Ofe,
              [
                e.mounted
                  ? (A(),
                    M(
                      ke,
                      {
                        key: 0,
                      },
                      [
                        W(`div`, null, [z(e.$slots, `default`)]),
                        e.handleResize
                          ? (A(),
                            L(o, {
                              key: 0,
                              onNotify: (t[1] ||= (t) => e.$emit(`resize`, t)),
                            }))
                          : U(``, !0),
                      ],
                      64,
                    ))
                  : U(``, !0),
              ],
              512,
            ),
            W(
              `div`,
              {
                ref: `arrow`,
                class: `v-popper__arrow-container`,
                style: Pe(
                  e.result
                    ? {
                        left: e.toPx(e.result.arrow.x),
                        top: e.toPx(e.result.arrow.y),
                      }
                    : void 0,
                ),
              },
              kfe,
              4,
            ),
          ],
          4,
        ),
      ],
      46,
      Dfe,
    )
  );
}
var B5 = F5(Efe, [[`render`, Afe]]),
  V5 = {
    methods: {
      show(...e) {
        return this.$refs.popper.show(...e);
      },
      hide(...e) {
        return this.$refs.popper.hide(...e);
      },
      dispose(...e) {
        return this.$refs.popper.dispose(...e);
      },
      onResize(...e) {
        return this.$refs.popper.onResize(...e);
      },
    },
  },
  H5 = function () {};
typeof window < `u` && (H5 = window.Element);
var jfe = k({
  name: `VPopperWrapper`,
  components: {
    Popper: Sfe,
    PopperContent: B5,
  },
  mixins: [V5, z5(`finalTheme`)],
  props: {
    theme: {
      type: String,
      default: null,
    },
    referenceNode: {
      type: Function,
      default: null,
    },
    shown: {
      type: Boolean,
      default: !1,
    },
    showGroup: {
      type: String,
      default: null,
    },
    ariaId: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: void 0,
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0,
    },
    placement: {
      type: String,
      default: void 0,
    },
    delay: {
      type: [String, Number, Object],
      default: void 0,
    },
    distance: {
      type: [Number, String],
      default: void 0,
    },
    skidding: {
      type: [Number, String],
      default: void 0,
    },
    triggers: {
      type: Array,
      default: void 0,
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0,
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0,
    },
    popperTriggers: {
      type: Array,
      default: void 0,
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0,
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0,
    },
    container: {
      type: [String, Object, H5, Boolean],
      default: void 0,
    },
    boundary: {
      type: [String, H5],
      default: void 0,
    },
    strategy: {
      type: String,
      default: void 0,
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0,
    },
    handleResize: {
      type: Boolean,
      default: void 0,
    },
    instantMove: {
      type: Boolean,
      default: void 0,
    },
    eagerMount: {
      type: Boolean,
      default: void 0,
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0,
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0,
    },
    autoMinSize: {
      type: Boolean,
      default: void 0,
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0,
    },
    autoMaxSize: {
      type: Boolean,
      default: void 0,
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0,
    },
    preventOverflow: {
      type: Boolean,
      default: void 0,
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0,
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0,
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0,
    },
    flip: {
      type: Boolean,
      default: void 0,
    },
    shift: {
      type: Boolean,
      default: void 0,
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0,
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0,
    },
    disposeTimeout: {
      type: Number,
      default: void 0,
    },
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0,
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    },
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    },
  },
});
function Mfe(e, t, n, r, i, a) {
  let o = j(`PopperContent`),
    s = j(`Popper`);
  return (
    A(),
    L(
      s,
      ce(
        {
          ref: `popper`,
        },
        e.$props,
        {
          theme: e.finalTheme,
          "target-nodes": e.getTargetNodes,
          "popper-node": () => e.$refs.popperContent.$el,
          class: [e.themeClass],
          onShow: (t[0] ||= () => e.$emit(`show`)),
          onHide: (t[1] ||= () => e.$emit(`hide`)),
          "onUpdate:shown": (t[2] ||= (t) => e.$emit(`update:shown`, t)),
          onApplyShow: (t[3] ||= () => e.$emit(`apply-show`)),
          onApplyHide: (t[4] ||= () => e.$emit(`apply-hide`)),
          onCloseGroup: (t[5] ||= () => e.$emit(`close-group`)),
          onCloseDirective: (t[6] ||= () => e.$emit(`close-directive`)),
          onAutoHide: (t[7] ||= () => e.$emit(`auto-hide`)),
          onResize: (t[8] ||= () => e.$emit(`resize`)),
        },
      ),
      {
        default: I(
          ({
            popperId: t,
            isShown: n,
            shouldMountContent: r,
            skipTransition: i,
            autoHide: a,
            show: s,
            hide: c,
            handleResize: l,
            onResize: u,
            classes: d,
            result: f,
          }) => [
            z(e.$slots, `default`, {
              shown: n,
              show: s,
              hide: c,
            }),
            N(
              o,
              {
                ref: `popperContent`,
                "popper-id": t,
                theme: e.finalTheme,
                shown: n,
                mounted: r,
                "skip-transition": i,
                "auto-hide": a,
                "handle-resize": l,
                classes: d,
                result: f,
                onHide: c,
                onResize: u,
              },
              {
                default: I(() => [
                  z(e.$slots, `popper`, {
                    shown: n,
                    hide: c,
                  }),
                ]),
                _: 2,
              },
              1032,
              [
                `popper-id`,
                `theme`,
                `shown`,
                `mounted`,
                `skip-transition`,
                `auto-hide`,
                `handle-resize`,
                `classes`,
                `result`,
                `onHide`,
                `onResize`,
              ],
            ),
          ],
        ),
        _: 3,
      },
      16,
      [`theme`, `target-nodes`, `popper-node`, `class`],
    )
  );
}
var U5 = F5(jfe, [[`render`, Mfe]]),
  Nfe = {
    ...U5,
    name: `VDropdown`,
    vPopperTheme: `dropdown`,
  },
  Pfe = {
    ...U5,
    name: `VMenu`,
    vPopperTheme: `menu`,
  };
({
  ...U5,
});
var Ffe = k({
    name: `VTooltipDirective`,
    components: {
      Popper: T5(),
      PopperContent: B5,
    },
    mixins: [V5],
    inheritAttrs: !1,
    props: {
      theme: {
        type: String,
        default: `tooltip`,
      },
      html: {
        type: Boolean,
        default: (e) => l5(e.theme, `html`),
      },
      content: {
        type: [String, Number, Function],
        default: null,
      },
      loadingContent: {
        type: String,
        default: (e) => l5(e.theme, `loadingContent`),
      },
      targetNodes: {
        type: Function,
        required: !0,
      },
    },
    data() {
      return {
        asyncContent: null,
      };
    },
    computed: {
      isContentAsync() {
        return typeof this.content == `function`;
      },
      loading() {
        return this.isContentAsync && this.asyncContent == null;
      },
      finalContent() {
        return this.isContentAsync
          ? this.loading
            ? this.loadingContent
            : this.asyncContent
          : this.content;
      },
    },
    watch: {
      content: {
        handler() {
          this.fetchContent(!0);
        },
        immediate: !0,
      },
      async finalContent() {
        (await this.$nextTick(), this.$refs.popper.onResize());
      },
    },
    created() {
      this.$_fetchId = 0;
    },
    methods: {
      fetchContent(e) {
        if (
          typeof this.content == `function` &&
          this.$_isShown &&
          (e || (!this.$_loading && this.asyncContent == null))
        ) {
          ((this.asyncContent = null), (this.$_loading = !0));
          let e = ++this.$_fetchId,
            t = this.content(this);
          t.then ? t.then((t) => this.onResult(e, t)) : this.onResult(e, t);
        }
      },
      onResult(e, t) {
        e === this.$_fetchId && ((this.$_loading = !1), (this.asyncContent = t));
      },
      onShow() {
        ((this.$_isShown = !0), this.fetchContent());
      },
      onHide() {
        this.$_isShown = !1;
      },
    },
  }),
  Ife = [`innerHTML`],
  Lfe = [`textContent`];
function Rfe(e, t, n, r, i, a) {
  let o = j(`PopperContent`),
    s = j(`Popper`);
  return (
    A(),
    L(
      s,
      ce(
        {
          ref: `popper`,
        },
        e.$attrs,
        {
          theme: e.theme,
          "target-nodes": e.targetNodes,
          "popper-node": () => e.$refs.popperContent.$el,
          onApplyShow: e.onShow,
          onApplyHide: e.onHide,
        },
      ),
      {
        default: I(
          ({
            popperId: t,
            isShown: n,
            shouldMountContent: r,
            skipTransition: i,
            autoHide: a,
            hide: s,
            handleResize: c,
            onResize: l,
            classes: u,
            result: d,
          }) => [
            N(
              o,
              {
                ref: `popperContent`,
                class: O({
                  "v-popper--tooltip-loading": e.loading,
                }),
                "popper-id": t,
                theme: e.theme,
                shown: n,
                mounted: r,
                "skip-transition": i,
                "auto-hide": a,
                "handle-resize": c,
                classes: u,
                result: d,
                onHide: s,
                onResize: l,
              },
              {
                default: I(() => [
                  e.html
                    ? (A(),
                      M(
                        `div`,
                        {
                          key: 0,
                          innerHTML: e.finalContent,
                        },
                        null,
                        8,
                        Ife,
                      ))
                    : (A(),
                      M(
                        `div`,
                        {
                          key: 1,
                          textContent: T(e.finalContent),
                        },
                        null,
                        8,
                        Lfe,
                      )),
                ]),
                _: 2,
              },
              1032,
              [
                `class`,
                `popper-id`,
                `theme`,
                `shown`,
                `mounted`,
                `skip-transition`,
                `auto-hide`,
                `handle-resize`,
                `classes`,
                `result`,
                `onHide`,
                `onResize`,
              ],
            ),
          ],
        ),
        _: 1,
      },
      16,
      [`theme`, `target-nodes`, `popper-node`, `onApplyShow`, `onApplyHide`],
    )
  );
}
var zfe = F5(Ffe, [[`render`, Rfe]]),
  W5 = `v-popper--has-tooltip`;
function Bfe(e, t) {
  let n = e.placement;
  if (!n && t) for (let e of p5) t[e] && (n = e);
  return ((n ||= l5(e.theme || `tooltip`, `placement`)), n);
}
function G5(e, t, n) {
  let r,
    i = typeof t;
  return (
    (r =
      i === `string`
        ? {
            content: t,
          }
        : t && i === `object`
          ? t
          : {
              content: !1,
            }),
    (r.placement = Bfe(r, n)),
    (r.targetNodes = () => [e]),
    (r.referenceNode = () => e),
    r
  );
}
var K5,
  q5,
  Vfe = 0;
function Hfe() {
  if (K5) return;
  ((q5 = F([])),
    (K5 = be({
      name: `VTooltipDirectiveApp`,
      setup() {
        return {
          directives: q5,
        };
      },
      render() {
        return this.directives.map((e) =>
          Ne(zfe, {
            ...e.options,
            shown: e.shown || e.options.shown,
            key: e.id,
          }),
        );
      },
      devtools: {
        hide: !0,
      },
    })));
  let e = document.createElement(`div`);
  (document.body.appendChild(e), K5.mount(e));
}
function Ufe(e, t, n) {
  Hfe();
  let r = F(G5(e, t, n)),
    i = F(!1),
    a = {
      id: Vfe++,
      options: r,
      shown: i,
    };
  return (
    q5.value.push(a),
    e.classList && e.classList.add(W5),
    (e.$_popper = {
      options: r,
      item: a,
      show() {
        i.value = !0;
      },
      hide() {
        i.value = !1;
      },
    })
  );
}
function J5(e) {
  if (e.$_popper) {
    let t = q5.value.indexOf(e.$_popper.item);
    (t !== -1 && q5.value.splice(t, 1),
      delete e.$_popper,
      delete e.$_popperOldShown,
      delete e.$_popperMountTarget);
  }
  e.classList && e.classList.remove(W5);
}
function Y5(e, { value: t, modifiers: n }) {
  let r = G5(e, t, n);
  if (!r.content || l5(r.theme || `tooltip`, `disabled`)) J5(e);
  else {
    let i;
    (e.$_popper ? ((i = e.$_popper), (i.options.value = r)) : (i = Ufe(e, t, n)),
      typeof t.shown < `u` &&
        t.shown !== e.$_popperOldShown &&
        ((e.$_popperOldShown = t.shown), t.shown ? i.show() : i.hide()));
  }
}
var Wfe = {
    beforeMount: Y5,
    updated: Y5,
    beforeUnmount(e) {
      J5(e);
    },
  },
  Gfe = Nfe,
  Kfe = Pfe;
B();
var qfe = [
  [`Afghanistan (‫افغانستان‬‎)`, `af`, `93`],
  [`Albania (Shqipëri)`, `al`, `355`],
  [`Algeria (‫الجزائر‬‎)`, `dz`, `213`],
  [`American Samoa`, `as`, `1`, 5, [`684`]],
  [`Andorra`, `ad`, `376`],
  [`Angola`, `ao`, `244`],
  [`Anguilla`, `ai`, `1`, 6, [`264`]],
  [`Antigua and Barbuda`, `ag`, `1`, 7, [`268`]],
  [`Argentina`, `ar`, `54`],
  [`Armenia (Հայաստան)`, `am`, `374`],
  [`Aruba`, `aw`, `297`],
  [`Ascension Island`, `ac`, `247`],
  [`Australia`, `au`, `61`, 0],
  [`Austria (Österreich)`, `at`, `43`],
  [`Azerbaijan (Azərbaycan)`, `az`, `994`],
  [`Bahamas`, `bs`, `1`, 8, [`242`]],
  [`Bahrain (‫البحرين‬‎)`, `bh`, `973`],
  [`Bangladesh (বাংলাদেশ)`, `bd`, `880`],
  [`Barbados`, `bb`, `1`, 9, [`246`]],
  [`Belarus (Беларусь)`, `by`, `375`],
  [`Belgium (België)`, `be`, `32`],
  [`Belize`, `bz`, `501`],
  [`Benin (Bénin)`, `bj`, `229`],
  [`Bermuda`, `bm`, `1`, 10, [`441`]],
  [`Bhutan (འབྲུག)`, `bt`, `975`],
  [`Bolivia`, `bo`, `591`],
  [`Bosnia and Herzegovina (Босна и Херцеговина)`, `ba`, `387`],
  [`Botswana`, `bw`, `267`],
  [`Brazil (Brasil)`, `br`, `55`],
  [`British Indian Ocean Territory`, `io`, `246`],
  [`British Virgin Islands`, `vg`, `1`, 11, [`284`]],
  [`Brunei`, `bn`, `673`],
  [`Bulgaria (България)`, `bg`, `359`],
  [`Burkina Faso`, `bf`, `226`],
  [`Burundi (Uburundi)`, `bi`, `257`],
  [`Cambodia (កម្ពុជា)`, `kh`, `855`],
  [`Cameroon (Cameroun)`, `cm`, `237`],
  [
    `Canada`,
    `ca`,
    `1`,
    1,
    `204.226.236.249.250.263.289.306.343.354.365.367.368.382.387.403.416.418.428.431.437.438.450.584.468.474.506.514.519.548.579.581.584.587.604.613.639.647.672.683.705.709.742.753.778.780.782.807.819.825.867.873.902.905`.split(
      `.`,
    ),
  ],
  [`Cape Verde (Kabu Verdi)`, `cv`, `238`],
  [`Caribbean Netherlands`, `bq`, `599`, 1, [`3`, `4`, `7`]],
  [`Cayman Islands`, `ky`, `1`, 12, [`345`]],
  [`Central African Republic (République centrafricaine)`, `cf`, `236`],
  [`Chad (Tchad)`, `td`, `235`],
  [`Chile`, `cl`, `56`],
  [`China (中国)`, `cn`, `86`],
  [`Christmas Island`, `cx`, `61`, 2, [`89164`]],
  [`Cocos (Keeling) Islands`, `cc`, `61`, 1, [`89162`]],
  [`Colombia`, `co`, `57`],
  [`Comoros (‫جزر القمر‬‎)`, `km`, `269`],
  [`Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)`, `cd`, `243`],
  [`Congo (Republic) (Congo-Brazzaville)`, `cg`, `242`],
  [`Cook Islands`, `ck`, `682`],
  [`Costa Rica`, `cr`, `506`],
  [`Côte d’Ivoire`, `ci`, `225`],
  [`Croatia (Hrvatska)`, `hr`, `385`],
  [`Cuba`, `cu`, `53`],
  [`Curaçao`, `cw`, `599`, 0],
  [`Cyprus (Κύπρος)`, `cy`, `357`],
  [`Czech Republic (Česká republika)`, `cz`, `420`],
  [`Denmark (Danmark)`, `dk`, `45`],
  [`Djibouti`, `dj`, `253`],
  [`Dominica`, `dm`, `1`, 13, [`767`]],
  [`Dominican Republic (República Dominicana)`, `do`, `1`, 2, [`809`, `829`, `849`]],
  [`Ecuador`, `ec`, `593`],
  [`Egypt (‫مصر‬‎)`, `eg`, `20`],
  [`El Salvador`, `sv`, `503`],
  [`Equatorial Guinea (Guinea Ecuatorial)`, `gq`, `240`],
  [`Eritrea`, `er`, `291`],
  [`Estonia (Eesti)`, `ee`, `372`],
  [`Eswatini`, `sz`, `268`],
  [`Ethiopia`, `et`, `251`],
  [`Falkland Islands (Islas Malvinas)`, `fk`, `500`],
  [`Faroe Islands (Føroyar)`, `fo`, `298`],
  [`Fiji`, `fj`, `679`],
  [`Finland (Suomi)`, `fi`, `358`, 0],
  [`France`, `fr`, `33`],
  [`French Guiana (Guyane française)`, `gf`, `594`],
  [`French Polynesia (Polynésie française)`, `pf`, `689`],
  [`Gabon`, `ga`, `241`],
  [`Gambia`, `gm`, `220`],
  [`Georgia (საქართველო)`, `ge`, `995`],
  [`Germany (Deutschland)`, `de`, `49`],
  [`Ghana (Gaana)`, `gh`, `233`],
  [`Gibraltar`, `gi`, `350`],
  [`Greece (Ελλάδα)`, `gr`, `30`],
  [`Greenland (Kalaallit Nunaat)`, `gl`, `299`],
  [`Grenada`, `gd`, `1`, 14, [`473`]],
  [`Guadeloupe`, `gp`, `590`, 0],
  [`Guam`, `gu`, `1`, 15, [`671`]],
  [`Guatemala`, `gt`, `502`],
  [`Guernsey`, `gg`, `44`, 1, [`1481`, `7781`, `7839`, `7911`]],
  [`Guinea (Guinée)`, `gn`, `224`],
  [`Guinea-Bissau (Guiné Bissau)`, `gw`, `245`],
  [`Guyana`, `gy`, `592`],
  [`Haiti`, `ht`, `509`],
  [`Honduras`, `hn`, `504`],
  [`Hong Kong (香港)`, `hk`, `852`],
  [`Hungary (Magyarország)`, `hu`, `36`],
  [`Iceland (Ísland)`, `is`, `354`],
  [`India (भारत)`, `in`, `91`],
  [`Indonesia`, `id`, `62`],
  [`Iran (‫ایران‬‎)`, `ir`, `98`],
  [`Iraq (‫العراق‬‎)`, `iq`, `964`],
  [`Ireland`, `ie`, `353`],
  [`Isle of Man`, `im`, `44`, 2, [`1624`, `74576`, `7524`, `7924`, `7624`]],
  [`Israel (‫ישראל‬‎)`, `il`, `972`],
  [`Italy (Italia)`, `it`, `39`, 0],
  [`Jamaica`, `jm`, `1`, 4, [`876`, `658`]],
  [`Japan (日本)`, `jp`, `81`],
  [`Jersey`, `je`, `44`, 3, [`1534`, `7509`, `7700`, `7797`, `7829`, `7937`]],
  [`Jordan (‫الأردن‬‎)`, `jo`, `962`],
  [`Kazakhstan (Казахстан)`, `kz`, `7`, 1, [`33`, `7`]],
  [`Kenya`, `ke`, `254`],
  [`Kiribati`, `ki`, `686`],
  [`Kosovo`, `xk`, `383`],
  [`Kuwait (‫الكويت‬‎)`, `kw`, `965`],
  [`Kyrgyzstan (Кыргызстан)`, `kg`, `996`],
  [`Laos (ລາວ)`, `la`, `856`],
  [`Latvia (Latvija)`, `lv`, `371`],
  [`Lebanon (‫لبنان‬‎)`, `lb`, `961`],
  [`Lesotho`, `ls`, `266`],
  [`Liberia`, `lr`, `231`],
  [`Libya (‫ليبيا‬‎)`, `ly`, `218`],
  [`Liechtenstein`, `li`, `423`],
  [`Lithuania (Lietuva)`, `lt`, `370`],
  [`Luxembourg`, `lu`, `352`],
  [`Macau (澳門)`, `mo`, `853`],
  [`Madagascar (Madagasikara)`, `mg`, `261`],
  [`Malawi`, `mw`, `265`],
  [`Malaysia`, `my`, `60`],
  [`Maldives`, `mv`, `960`],
  [`Mali`, `ml`, `223`],
  [`Malta`, `mt`, `356`],
  [`Marshall Islands`, `mh`, `692`],
  [`Martinique`, `mq`, `596`],
  [`Mauritania (‫موريتانيا‬‎)`, `mr`, `222`],
  [`Mauritius (Moris)`, `mu`, `230`],
  [`Mayotte`, `yt`, `262`, 1, [`269`, `639`]],
  [`Mexico (México)`, `mx`, `52`],
  [`Micronesia`, `fm`, `691`],
  [`Moldova (Republica Moldova)`, `md`, `373`],
  [`Monaco`, `mc`, `377`],
  [`Mongolia (Монгол)`, `mn`, `976`],
  [`Montenegro (Crna Gora)`, `me`, `382`],
  [`Montserrat`, `ms`, `1`, 16, [`664`]],
  [`Morocco (‫المغرب‬‎)`, `ma`, `212`, 0],
  [`Mozambique (Moçambique)`, `mz`, `258`],
  [`Myanmar (Burma) (မြန်မာ)`, `mm`, `95`],
  [`Namibia (Namibië)`, `na`, `264`],
  [`Nauru`, `nr`, `674`],
  [`Nepal (नेपाल)`, `np`, `977`],
  [`Netherlands (Nederland)`, `nl`, `31`],
  [`New Caledonia (Nouvelle-Calédonie)`, `nc`, `687`],
  [`New Zealand`, `nz`, `64`],
  [`Nicaragua`, `ni`, `505`],
  [`Niger (Nijar)`, `ne`, `227`],
  [`Nigeria`, `ng`, `234`],
  [`Niue`, `nu`, `683`],
  [`Norfolk Island`, `nf`, `672`],
  [`North Korea (조선 민주주의 인민 공화국)`, `kp`, `850`],
  [`North Macedonia (Северна Македонија)`, `mk`, `389`],
  [`Northern Mariana Islands`, `mp`, `1`, 17, [`670`]],
  [`Norway (Norge)`, `no`, `47`, 0],
  [`Oman (‫عُمان‬‎)`, `om`, `968`],
  [`Pakistan (‫پاکستان‬‎)`, `pk`, `92`],
  [`Palau`, `pw`, `680`],
  [`Palestine (‫فلسطين‬‎)`, `ps`, `970`],
  [`Panama (Panamá)`, `pa`, `507`],
  [`Papua New Guinea`, `pg`, `675`],
  [`Paraguay`, `py`, `595`],
  [`Peru (Perú)`, `pe`, `51`],
  [`Philippines`, `ph`, `63`],
  [`Poland (Polska)`, `pl`, `48`],
  [`Portugal`, `pt`, `351`],
  [`Puerto Rico`, `pr`, `1`, 3, [`787`, `939`]],
  [`Qatar (‫قطر‬‎)`, `qa`, `974`],
  [`Réunion (La Réunion)`, `re`, `262`, 0],
  [`Romania (România)`, `ro`, `40`],
  [`Russia (Россия)`, `ru`, `7`, 0],
  [`Rwanda`, `rw`, `250`],
  [`Saint Barthélemy`, `bl`, `590`, 1],
  [`Saint Helena`, `sh`, `290`],
  [`Saint Kitts and Nevis`, `kn`, `1`, 18, [`869`]],
  [`Saint Lucia`, `lc`, `1`, 19, [`758`]],
  [`Saint Martin (Saint-Martin (partie française))`, `mf`, `590`, 2],
  [`Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)`, `pm`, `508`],
  [`Saint Vincent and the Grenadines`, `vc`, `1`, 20, [`784`]],
  [`Samoa`, `ws`, `685`],
  [`San Marino`, `sm`, `378`],
  [`São Tomé and Príncipe (São Tomé e Príncipe)`, `st`, `239`],
  [`Saudi Arabia (‫المملكة العربية السعودية‬‎)`, `sa`, `966`],
  [`Senegal (Sénégal)`, `sn`, `221`],
  [`Serbia (Србија)`, `rs`, `381`],
  [`Seychelles`, `sc`, `248`],
  [`Sierra Leone`, `sl`, `232`],
  [`Singapore`, `sg`, `65`],
  [`Sint Maarten`, `sx`, `1`, 21, [`721`]],
  [`Slovakia (Slovensko)`, `sk`, `421`],
  [`Slovenia (Slovenija)`, `si`, `386`],
  [`Solomon Islands`, `sb`, `677`],
  [`Somalia (Soomaaliya)`, `so`, `252`],
  [`South Africa`, `za`, `27`],
  [`South Korea (대한민국)`, `kr`, `82`],
  [`South Sudan (‫جنوب السودان‬‎)`, `ss`, `211`],
  [`Spain (España)`, `es`, `34`],
  [`Sri Lanka (ශ්‍රී ලංකාව)`, `lk`, `94`],
  [`Sudan (‫السودان‬‎)`, `sd`, `249`],
  [`Suriname`, `sr`, `597`],
  [`Svalbard and Jan Mayen`, `sj`, `47`, 1, [`79`]],
  [`Sweden (Sverige)`, `se`, `46`],
  [`Switzerland (Schweiz)`, `ch`, `41`],
  [`Syria (‫سوريا‬‎)`, `sy`, `963`],
  [`Taiwan (台灣)`, `tw`, `886`],
  [`Tajikistan`, `tj`, `992`],
  [`Tanzania`, `tz`, `255`],
  [`Thailand (ไทย)`, `th`, `66`],
  [`Timor-Leste`, `tl`, `670`],
  [`Togo`, `tg`, `228`],
  [`Tokelau`, `tk`, `690`],
  [`Tonga`, `to`, `676`],
  [`Trinidad and Tobago`, `tt`, `1`, 22, [`868`]],
  [`Tunisia (‫تونس‬‎)`, `tn`, `216`],
  [`Turkey (Türkiye)`, `tr`, `90`],
  [`Turkmenistan`, `tm`, `993`],
  [`Turks and Caicos Islands`, `tc`, `1`, 23, [`649`]],
  [`Tuvalu`, `tv`, `688`],
  [`U.S. Virgin Islands`, `vi`, `1`, 24, [`340`]],
  [`Uganda`, `ug`, `256`],
  [`Ukraine (Україна)`, `ua`, `380`],
  [`United Arab Emirates (‫الإمارات العربية المتحدة‬‎)`, `ae`, `971`],
  [`United Kingdom`, `gb`, `44`, 0],
  [`United States`, `us`, `1`, 0],
  [`Uruguay`, `uy`, `598`],
  [`Uzbekistan (Oʻzbekiston)`, `uz`, `998`],
  [`Vanuatu`, `vu`, `678`],
  [`Vatican City (Città del Vaticano)`, `va`, `39`, 1, [`06698`]],
  [`Venezuela`, `ve`, `58`],
  [`Vietnam (Việt Nam)`, `vn`, `84`],
  [`Wallis and Futuna (Wallis-et-Futuna)`, `wf`, `681`],
  [`Western Sahara (‫الصحراء الغربية‬‎)`, `eh`, `212`, 1, [`5288`, `5289`]],
  [`Yemen (‫اليمن‬‎)`, `ye`, `967`],
  [`Zambia`, `zm`, `260`],
  [`Zimbabwe`, `zw`, `263`],
  [`Åland Islands`, `ax`, `358`, 1, [`18`]],
].map(([e, t, n, r = 0, i = null]) => ({
  name: e,
  iso2: t.toUpperCase(),
  dialCode: n,
  priority: r,
  areaCodes: i,
}));
function Jfe() {
  return fetch(`https://ip2c.org/s`)
    .then((e) => e.text())
    .then((e) => {
      let t = (e || ``).toString();
      if (!t || t[0] !== `1`) throw Error(`unable to fetch the country`);
      return t.substr(2, 2);
    });
}
function Yfe(e, t) {
  if (e.setSelectionRange) (e.focus(), e.setSelectionRange(t, t));
  else if (e.createTextRange) {
    let n = e.createTextRange();
    (n.collapse(!0), n.moveEnd(`character`, t), n.moveStart(`character`, t), n.select());
  }
}
var X5 = [
    {
      name: `allCountries`,
      type: Array,
      default: qfe,
      description: `All countries that are used in <code>libphonenumber-js</code>, can be overridden by this prop`,
      inDemo: !1,
    },
    {
      name: `autoFormat`,
      type: Boolean,
      default: !0,
      description: `Auto update the input to the formatted phone number when it's valid`,
      inDemo: !0,
    },
    {
      name: `customValidate`,
      type: [Boolean, RegExp],
      default: !1,
      description: `Custom validation RegExp for input`,
      inDemo: !1,
    },
    {
      name: `defaultCountry`,
      default: ``,
      type: [String, Number],
      description: `Default country (by iso2 or dialCode), will override the country fetched from IP address of user`,
      inDemo: !1,
    },
    {
      name: `disabled`,
      default: !1,
      type: Boolean,
      description: `Disable <code>vue-tel-input</code>, including the input & flag dropdown`,
      inDemo: !1,
    },
    {
      name: `autoDefaultCountry`,
      default: !0,
      type: Boolean,
      description: `To fetch default country based on IP address of user`,
      inDemo: !1,
    },
    {
      name: `dropdownOptions`,
      type: Object,
      description: `Options for dropdown, see below`,
      inDemo: !1,
    },
    {
      name: `dropdownOptions.disabled`,
      default: !1,
      type: Boolean,
      description: `Disable dropdown`,
      inDemo: !1,
    },
    {
      name: `dropdownOptions.showDialCodeInList`,
      default: !0,
      type: Boolean,
      description: `Show dial code in the dropdown list`,
      inDemo: !0,
    },
    {
      name: `dropdownOptions.showDialCodeInSelection`,
      default: !1,
      type: Boolean,
      description: `Show dial code in the dropdown selection`,
      inDemo: !0,
    },
    {
      name: `dropdownOptions.showFlags`,
      default: !0,
      type: Boolean,
      description: `Show flags in the dropdown selection and list`,
      inDemo: !0,
    },
    {
      name: `dropdownOptions.showSearchBox`,
      default: !1,
      type: Boolean,
      description: `Show country search box`,
      inDemo: !0,
    },
    {
      name: `dropdownOptions.tabindex`,
      default: 0,
      type: Number,
      description: `Native dropdown <code>tabindex</code> attribute`,
      inDemo: !1,
    },
    {
      name: `ignoredCountries`,
      default: [],
      type: Array,
      description: `List of countries will NOT be shown on the dropdown`,
      inDemo: !1,
    },
    {
      name: `inputOptions`,
      type: Object,
      description: `Options for input, see below`,
      inDemo: !1,
    },
    {
      name: `inputOptions.autocomplete`,
      type: String,
      default: `on`,
      description: `Native input <code>autocomplete</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.autofocus`,
      type: Boolean,
      default: !1,
      description: `Native input <code>autofocus</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.aria-describedby`,
      default: ``,
      type: String,
      description: `Native input <code>aria-describedby</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.id`,
      default: ``,
      type: String,
      description: `Native input <code>id</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.maxlength`,
      default: 25,
      type: Number,
      description: `Native input <code>maxlength</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.name`,
      default: `telephone`,
      type: String,
      description: `Native input <code>name</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.showDialCode`,
      default: !1,
      type: Boolean,
      description: `Show dial code in input`,
      inDemo: !1,
    },
    {
      name: `inputOptions.placeholder`,
      default: `Enter a phone number`,
      type: String,
      description: `Placeholder for the input`,
      inDemo: !1,
    },
    {
      name: `inputOptions.readonly`,
      default: !1,
      type: Boolean,
      description: `Native input <code>readonly</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.required`,
      default: !1,
      type: Boolean,
      description: `Native input <code>required</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.tabindex`,
      default: 0,
      type: Number,
      description: `Native input <code>tabindex</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.type`,
      default: `tel`,
      type: String,
      description: `Native input <code>type</code> attribute`,
      inDemo: !1,
    },
    {
      name: `inputOptions.styleClasses`,
      default: ``,
      type: [String, Array, Object],
      description: `Custom classes for the <code>input</code>`,
      inDemo: !1,
    },
    {
      name: `invalidMsg`,
      default: ``,
      type: String,
      description: ``,
      inDemo: !1,
    },
    {
      name: `mode`,
      default: `auto`,
      type: String,
      description: `Allowed values: <code>'auto'</code> (Default set by phone),  <code>'international'</code> (Format number with the dial code i.e. + 61), <code>'national'</code> (Format number without dial code i.e. 0321232)`,
      inDemo: !0,
      options: [`auto`, `national`, `international`],
    },
    {
      name: `onlyCountries`,
      default: [],
      type: Array,
      description: `List of countries will be shown on the dropdown`,
      inDemo: !1,
    },
    {
      name: `preferredCountries`,
      default: [],
      type: Array,
      description: `Preferred countries list, will be on top of the dropdown`,
      inDemo: !1,
    },
    {
      name: `styleClasses`,
      default: ``,
      type: [String, Array, Object],
      description: `Custom classes for the wrapper`,
      inDemo: !1,
    },
    {
      name: `validCharactersOnly`,
      default: !1,
      type: Boolean,
      description: `Only allow valid characters in a phone number (will also verify in <code>mounted</code>, so phone number with invalid characters will be shown as an empty string)`,
      inDemo: !1,
    },
  ].reduce((e, t) => {
    if (t.name.includes(`.`)) {
      let [n, r] = t.name.split(`.`);
      e[n]
        ? Object.assign(e[n], {
            [r]: t.default,
          })
        : Object.assign(e, {
            [n]: {
              [r]: t.default,
            },
          });
    } else
      Object.assign(e, {
        [t.name]: t.default,
      });
    return e;
  }, {}),
  Z5 = {
    options: {
      ...X5,
    },
  },
  Xfe = {
    version: 4,
    country_calling_codes: {
      1: [
        `US`,
        `AG`,
        `AI`,
        `AS`,
        `BB`,
        `BM`,
        `BS`,
        `CA`,
        `DM`,
        `DO`,
        `GD`,
        `GU`,
        `JM`,
        `KN`,
        `KY`,
        `LC`,
        `MP`,
        `MS`,
        `PR`,
        `SX`,
        `TC`,
        `TT`,
        `VC`,
        `VG`,
        `VI`,
      ],
      7: [`RU`, `KZ`],
      20: [`EG`],
      27: [`ZA`],
      30: [`GR`],
      31: [`NL`],
      32: [`BE`],
      33: [`FR`],
      34: [`ES`],
      36: [`HU`],
      39: [`IT`, `VA`],
      40: [`RO`],
      41: [`CH`],
      43: [`AT`],
      44: [`GB`, `GG`, `IM`, `JE`],
      45: [`DK`],
      46: [`SE`],
      47: [`NO`, `SJ`],
      48: [`PL`],
      49: [`DE`],
      51: [`PE`],
      52: [`MX`],
      53: [`CU`],
      54: [`AR`],
      55: [`BR`],
      56: [`CL`],
      57: [`CO`],
      58: [`VE`],
      60: [`MY`],
      61: [`AU`, `CC`, `CX`],
      62: [`ID`],
      63: [`PH`],
      64: [`NZ`],
      65: [`SG`],
      66: [`TH`],
      81: [`JP`],
      82: [`KR`],
      84: [`VN`],
      86: [`CN`],
      90: [`TR`],
      91: [`IN`],
      92: [`PK`],
      93: [`AF`],
      94: [`LK`],
      95: [`MM`],
      98: [`IR`],
      211: [`SS`],
      212: [`MA`, `EH`],
      213: [`DZ`],
      216: [`TN`],
      218: [`LY`],
      220: [`GM`],
      221: [`SN`],
      222: [`MR`],
      223: [`ML`],
      224: [`GN`],
      225: [`CI`],
      226: [`BF`],
      227: [`NE`],
      228: [`TG`],
      229: [`BJ`],
      230: [`MU`],
      231: [`LR`],
      232: [`SL`],
      233: [`GH`],
      234: [`NG`],
      235: [`TD`],
      236: [`CF`],
      237: [`CM`],
      238: [`CV`],
      239: [`ST`],
      240: [`GQ`],
      241: [`GA`],
      242: [`CG`],
      243: [`CD`],
      244: [`AO`],
      245: [`GW`],
      246: [`IO`],
      247: [`AC`],
      248: [`SC`],
      249: [`SD`],
      250: [`RW`],
      251: [`ET`],
      252: [`SO`],
      253: [`DJ`],
      254: [`KE`],
      255: [`TZ`],
      256: [`UG`],
      257: [`BI`],
      258: [`MZ`],
      260: [`ZM`],
      261: [`MG`],
      262: [`RE`, `YT`],
      263: [`ZW`],
      264: [`NA`],
      265: [`MW`],
      266: [`LS`],
      267: [`BW`],
      268: [`SZ`],
      269: [`KM`],
      290: [`SH`, `TA`],
      291: [`ER`],
      297: [`AW`],
      298: [`FO`],
      299: [`GL`],
      350: [`GI`],
      351: [`PT`],
      352: [`LU`],
      353: [`IE`],
      354: [`IS`],
      355: [`AL`],
      356: [`MT`],
      357: [`CY`],
      358: [`FI`, `AX`],
      359: [`BG`],
      370: [`LT`],
      371: [`LV`],
      372: [`EE`],
      373: [`MD`],
      374: [`AM`],
      375: [`BY`],
      376: [`AD`],
      377: [`MC`],
      378: [`SM`],
      380: [`UA`],
      381: [`RS`],
      382: [`ME`],
      383: [`XK`],
      385: [`HR`],
      386: [`SI`],
      387: [`BA`],
      389: [`MK`],
      420: [`CZ`],
      421: [`SK`],
      423: [`LI`],
      500: [`FK`],
      501: [`BZ`],
      502: [`GT`],
      503: [`SV`],
      504: [`HN`],
      505: [`NI`],
      506: [`CR`],
      507: [`PA`],
      508: [`PM`],
      509: [`HT`],
      590: [`GP`, `BL`, `MF`],
      591: [`BO`],
      592: [`GY`],
      593: [`EC`],
      594: [`GF`],
      595: [`PY`],
      596: [`MQ`],
      597: [`SR`],
      598: [`UY`],
      599: [`CW`, `BQ`],
      670: [`TL`],
      672: [`NF`],
      673: [`BN`],
      674: [`NR`],
      675: [`PG`],
      676: [`TO`],
      677: [`SB`],
      678: [`VU`],
      679: [`FJ`],
      680: [`PW`],
      681: [`WF`],
      682: [`CK`],
      683: [`NU`],
      685: [`WS`],
      686: [`KI`],
      687: [`NC`],
      688: [`TV`],
      689: [`PF`],
      690: [`TK`],
      691: [`FM`],
      692: [`MH`],
      850: [`KP`],
      852: [`HK`],
      853: [`MO`],
      855: [`KH`],
      856: [`LA`],
      880: [`BD`],
      886: [`TW`],
      960: [`MV`],
      961: [`LB`],
      962: [`JO`],
      963: [`SY`],
      964: [`IQ`],
      965: [`KW`],
      966: [`SA`],
      967: [`YE`],
      968: [`OM`],
      970: [`PS`],
      971: [`AE`],
      972: [`IL`],
      973: [`BH`],
      974: [`QA`],
      975: [`BT`],
      976: [`MN`],
      977: [`NP`],
      992: [`TJ`],
      993: [`TM`],
      994: [`AZ`],
      995: [`GE`],
      996: [`KG`],
      998: [`UZ`],
    },
    countries: {
      AC: [`247`, `00`, `(?:[01589]\\d|[46])\\d{4}`, [5, 6]],
      AD: [
        `376`,
        `00`,
        `(?:1|6\\d)\\d{7}|[135-9]\\d{5}`,
        [6, 8, 9],
        [
          [`(\\d{3})(\\d{3})`, `$1 $2`, [`[135-9]`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`1`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6`]],
        ],
      ],
      AE: [
        `971`,
        `00`,
        `(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}`,
        [5, 6, 7, 8, 9, 10, 11, 12],
        [
          [`(\\d{3})(\\d{2,9})`, `$1 $2`, [`60|8`]],
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[236]|[479][2-8]`], `0$1`],
          [`(\\d{3})(\\d)(\\d{5})`, `$1 $2 $3`, [`[479]`]],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`5`], `0$1`],
        ],
        `0`,
      ],
      AF: [
        `93`,
        `00`,
        `[2-7]\\d{8}`,
        [9],
        [[`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-7]`], `0$1`]],
        `0`,
      ],
      AG: [
        `1`,
        `011`,
        `(?:268|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([457]\\d{6})$|1`,
        `268$1`,
        0,
        `268`,
      ],
      AI: [
        `1`,
        `011`,
        `(?:264|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2457]\\d{6})$|1`,
        `264$1`,
        0,
        `264`,
      ],
      AL: [
        `355`,
        `00`,
        `(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}`,
        [6, 7, 8, 9],
        [
          [`(\\d{3})(\\d{3,4})`, `$1 $2`, [`80|9`], `0$1`],
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`4[2-6]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2358][2-5]|4`], `0$1`],
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`[23578]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`6`], `0$1`],
        ],
        `0`,
      ],
      AM: [
        `374`,
        `00`,
        `(?:[1-489]\\d|55|60|77)\\d{6}`,
        [8],
        [
          [`(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`[89]0`], `0 $1`],
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`2|3[12]`], `(0$1)`],
          [`(\\d{2})(\\d{6})`, `$1 $2`, [`1|47`], `(0$1)`],
          [`(\\d{2})(\\d{6})`, `$1 $2`, [`[3-9]`], `0$1`],
        ],
        `0`,
      ],
      AO: [`244`, `00`, `[29]\\d{8}`, [9], [[`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[29]`]]]],
      AR: [
        `54`,
        `00`,
        `(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}`,
        [10, 11],
        [
          [
            `(\\d{4})(\\d{2})(\\d{4})`,
            `$1 $2-$3`,
            [
              `2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])`,
              `2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)`,
              `2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]`,
              `2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]`,
            ],
            `0$1`,
            1,
          ],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1 $2-$3`, [`1`], `0$1`, 1],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[68]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2-$3`, [`[23]`], `0$1`, 1],
          [
            `(\\d)(\\d{4})(\\d{2})(\\d{4})`,
            `$2 15-$3-$4`,
            [
              `9(?:2[2-469]|3[3-578])`,
              `9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))`,
              `9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)`,
              `9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]`,
              `9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]`,
            ],
            `0$1`,
            0,
            `$1 $2 $3-$4`,
          ],
          [`(\\d)(\\d{2})(\\d{4})(\\d{4})`, `$2 15-$3-$4`, [`91`], `0$1`, 0, `$1 $2 $3-$4`],
          [`(\\d{3})(\\d{3})(\\d{5})`, `$1-$2-$3`, [`8`], `0$1`],
          [`(\\d)(\\d{3})(\\d{3})(\\d{4})`, `$2 15-$3-$4`, [`9`], `0$1`, 0, `$1 $2 $3-$4`],
        ],
        `0`,
        0,
        `0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?`,
        `9$1`,
      ],
      AS: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|684|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([267]\\d{6})$|1`,
        `684$1`,
        0,
        `684`,
      ],
      AT: [
        `43`,
        `00`,
        `1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}`,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        [
          [`(\\d)(\\d{3,12})`, `$1 $2`, [`1(?:11|[2-9])`], `0$1`],
          [`(\\d{3})(\\d{2})`, `$1 $2`, [`517`], `0$1`],
          [`(\\d{2})(\\d{3,5})`, `$1 $2`, [`5[079]`], `0$1`],
          [
            `(\\d{3})(\\d{3,10})`,
            `$1 $2`,
            [`(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]`],
            `0$1`,
          ],
          [`(\\d{4})(\\d{3,9})`, `$1 $2`, [`[2-467]|5[2-6]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`5`], `0$1`],
          [`(\\d{2})(\\d{4})(\\d{4,7})`, `$1 $2 $3`, [`5`], `0$1`],
        ],
        `0`,
      ],
      AU: [
        `61`,
        `001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011`,
        `1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}`,
        [5, 6, 7, 8, 9, 10, 12],
        [
          [`(\\d{2})(\\d{3,4})`, `$1 $2`, [`16`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{2,4})`, `$1 $2 $3`, [`16`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`14|4`], `0$1`],
          [`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[2378]`], `(0$1)`],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1(?:30|[89])`]],
        ],
        `0`,
        0,
        `(183[12])|0`,
        0,
        0,
        0,
        [
          [
            `(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}`,
            [9],
          ],
          [
            `4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}`,
            [9],
          ],
          [`180(?:0\\d{3}|2)\\d{3}`, [7, 10]],
          [`190[0-26]\\d{6}`, [10]],
          0,
          0,
          0,
          [`163\\d{2,6}`, [5, 6, 7, 8, 9]],
          [`14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}`, [9]],
          [`13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}`, [6, 8, 10, 12]],
        ],
        `0011`,
      ],
      AW: [
        `297`,
        `00`,
        `(?:[25-79]\\d\\d|800)\\d{4}`,
        [7],
        [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[25-9]`]]],
      ],
      AX: [
        `358`,
        `00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))`,
        `2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}`,
        [5, 6, 7, 8, 9, 10, 11, 12],
        0,
        `0`,
        0,
        0,
        0,
        0,
        `18`,
        0,
        `00`,
      ],
      AZ: [
        `994`,
        `00`,
        `365\\d{6}|(?:[124579]\\d|60|88)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`90`], `0$1`],
          [
            `(\\d{2})(\\d{3})(\\d{2})(\\d{2})`,
            `$1 $2 $3 $4`,
            [`1[28]|2|365|46`, `1[28]|2|365[45]|46`, `1[28]|2|365(?:4|5[02])|46`],
            `(0$1)`,
          ],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[13-9]`], `0$1`],
        ],
        `0`,
      ],
      BA: [
        `387`,
        `00`,
        `6\\d{8}|(?:[35689]\\d|49|70)\\d{6}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6[1-3]|[7-9]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2-$3`, [`[3-5]|6[56]`], `0$1`],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`6`], `0$1`],
        ],
        `0`,
      ],
      BB: [
        `1`,
        `011`,
        `(?:246|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-9]\\d{6})$|1`,
        `246$1`,
        0,
        `246`,
      ],
      BD: [
        `880`,
        `00`,
        `[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}`,
        [6, 7, 8, 9, 10],
        [
          [`(\\d{2})(\\d{4,6})`, `$1-$2`, [`31[5-8]|[459]1`], `0$1`],
          [
            `(\\d{3})(\\d{3,7})`,
            `$1-$2`,
            [
              `3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]`,
            ],
            `0$1`,
          ],
          [`(\\d{4})(\\d{3,6})`, `$1-$2`, [`[13-9]|22`], `0$1`],
          [`(\\d)(\\d{7,8})`, `$1-$2`, [`2`], `0$1`],
        ],
        `0`,
      ],
      BE: [
        `32`,
        `00`,
        `4\\d{8}|[1-9]\\d{7}`,
        [8, 9],
        [
          [`(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`(?:80|9)0`], `0$1`],
          [`(\\d)(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[239]|4[23]`], `0$1`],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[15-8]`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`4`], `0$1`],
        ],
        `0`,
      ],
      BF: [
        `226`,
        `00`,
        `[025-7]\\d{7}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[025-7]`]]],
      ],
      BG: [
        `359`,
        `00`,
        `00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}`,
        [6, 7, 8, 9, 12],
        [
          [`(\\d)(\\d)(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`2`], `0$1`],
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`43[1-6]|70[1-9]`], `0$1`],
          [`(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2`], `0$1`],
          [
            `(\\d{2})(\\d{3})(\\d{2,3})`,
            `$1 $2 $3`,
            [`[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]`],
            `0$1`,
          ],
          [`(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`(?:70|8)0`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{2})`, `$1 $2 $3`, [`43[1-7]|7`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[48]|9[08]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`], `0$1`],
        ],
        `0`,
      ],
      BH: [
        `973`,
        `00`,
        `[136-9]\\d{7}`,
        [8],
        [[`(\\d{4})(\\d{4})`, `$1 $2`, [`[13679]|8[02-4679]`]]],
      ],
      BI: [
        `257`,
        `00`,
        `(?:[267]\\d|31)\\d{6}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2367]`]]],
      ],
      BJ: [
        `229`,
        `00`,
        `[24-689]\\d{7}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24-689]`]]],
      ],
      BL: [
        `590`,
        `00`,
        `590\\d{6}|(?:69|80|9\\d)\\d{7}`,
        [9],
        0,
        `0`,
        0,
        0,
        0,
        0,
        0,
        [
          [`590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}`],
          [`69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}`],
          [`80[0-5]\\d{6}`],
          0,
          0,
          0,
          0,
          0,
          [`9(?:(?:395|76[018])\\d|475[0-5])\\d{4}`],
        ],
      ],
      BM: [
        `1`,
        `011`,
        `(?:441|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-9]\\d{6})$|1`,
        `441$1`,
        0,
        `441`,
      ],
      BN: [`673`, `00`, `[2-578]\\d{6}`, [7], [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[2-578]`]]]],
      BO: [
        `591`,
        `00(?:1\\d)?`,
        `(?:[2-467]\\d\\d|8001)\\d{5}`,
        [8, 9],
        [
          [`(\\d)(\\d{7})`, `$1 $2`, [`[23]|4[46]`]],
          [`(\\d{8})`, `$1`, [`[67]`]],
          [`(\\d{3})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`8`]],
        ],
        `0`,
        0,
        `0(1\\d)?`,
      ],
      BQ: [`599`, `00`, `(?:[34]1|7\\d)\\d{5}`, [7], 0, 0, 0, 0, 0, 0, `[347]`],
      BR: [
        `55`,
        `00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)`,
        `(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}`,
        [8, 9, 10, 11],
        [
          [`(\\d{4})(\\d{4})`, `$1-$2`, [`300|4(?:0[02]|37)`, `4(?:02|37)0|[34]00`]],
          [`(\\d{3})(\\d{2,3})(\\d{4})`, `$1 $2 $3`, [`(?:[358]|90)0`], `0$1`],
          [
            `(\\d{2})(\\d{4})(\\d{4})`,
            `$1 $2-$3`,
            [`(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]`],
            `($1)`,
          ],
          [`(\\d{2})(\\d{5})(\\d{4})`, `$1 $2-$3`, [`[16][1-9]|[2-57-9]`], `($1)`],
        ],
        `0`,
        0,
        `(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?`,
        `$2`,
      ],
      BS: [
        `1`,
        `011`,
        `(?:242|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([3-8]\\d{6})$|1`,
        `242$1`,
        0,
        `242`,
      ],
      BT: [
        `975`,
        `00`,
        `[17]\\d{7}|[2-8]\\d{6}`,
        [7, 8],
        [
          [`(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-68]|7[246]`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[67]|7`]],
        ],
      ],
      BW: [
        `267`,
        `00`,
        `(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}`,
        [7, 8, 10],
        [
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`90`]],
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[24-6]|3[15-9]`]],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[37]`]],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`0`]],
          [`(\\d{3})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`8`]],
        ],
      ],
      BY: [
        `375`,
        `810`,
        `(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}`,
        [6, 7, 8, 9, 10, 11],
        [
          [`(\\d{3})(\\d{3})`, `$1 $2`, [`800`], `8 $1`],
          [`(\\d{3})(\\d{2})(\\d{2,4})`, `$1 $2 $3`, [`800`], `8 $1`],
          [
            `(\\d{4})(\\d{2})(\\d{3})`,
            `$1 $2-$3`,
            [
              `1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])`,
              `1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])`,
            ],
            `8 0$1`,
          ],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`1(?:[56]|7[467])|2[1-3]`], `8 0$1`],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`[1-4]`], `8 0$1`],
          [`(\\d{3})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`[89]`], `8 $1`],
        ],
        `8`,
        0,
        `0|80?`,
        0,
        0,
        0,
        0,
        `8~10`,
      ],
      BZ: [
        `501`,
        `00`,
        `(?:0800\\d|[2-8])\\d{6}`,
        [7, 11],
        [
          [`(\\d{3})(\\d{4})`, `$1-$2`, [`[2-8]`]],
          [`(\\d)(\\d{3})(\\d{4})(\\d{3})`, `$1-$2-$3-$4`, [`0`]],
        ],
      ],
      CA: [
        `1`,
        `011`,
        `(?:[2-8]\\d|90)\\d{8}|3\\d{6}`,
        [7, 10],
        0,
        `1`,
        0,
        0,
        0,
        0,
        0,
        [
          [
            `(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}`,
            [10],
          ],
          [``, [10]],
          [`8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`, [10]],
          [`900[2-9]\\d{6}`, [10]],
          [
            `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}`,
            [10],
          ],
          0,
          [`310\\d{4}`, [7]],
          0,
          [`600[2-9]\\d{6}`, [10]],
        ],
      ],
      CC: [
        `61`,
        `001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011`,
        `1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}`,
        [6, 7, 8, 9, 10, 12],
        0,
        `0`,
        0,
        `([59]\\d{7})$|0`,
        `8$1`,
        0,
        0,
        [
          [
            `8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}`,
            [9],
          ],
          [
            `4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}`,
            [9],
          ],
          [`180(?:0\\d{3}|2)\\d{3}`, [7, 10]],
          [`190[0-26]\\d{6}`, [10]],
          0,
          0,
          0,
          0,
          [`14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}`, [9]],
          [`13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}`, [6, 8, 10, 12]],
        ],
        `0011`,
      ],
      CD: [
        `243`,
        `00`,
        `[189]\\d{8}|[1-68]\\d{6}`,
        [7, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`88`], `0$1`],
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`[1-6]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[89]`], `0$1`],
        ],
        `0`,
      ],
      CF: [
        `236`,
        `00`,
        `(?:[27]\\d{3}|8776)\\d{4}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[278]`]]],
      ],
      CG: [
        `242`,
        `00`,
        `222\\d{6}|(?:0\\d|80)\\d{7}`,
        [9],
        [
          [`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`8`]],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[02]`]],
        ],
      ],
      CH: [
        `41`,
        `00`,
        `8\\d{11}|[2-9]\\d{8}`,
        [9],
        [
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8[047]|90`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-79]|81`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`8`], `0$1`],
        ],
        `0`,
      ],
      CI: [
        `225`,
        `00`,
        `[02]\\d{9}`,
        [10],
        [
          [`(\\d{2})(\\d{2})(\\d)(\\d{5})`, `$1 $2 $3 $4`, [`2`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3 $4`, [`0`]],
        ],
      ],
      CK: [`682`, `00`, `[2-578]\\d{4}`, [5], [[`(\\d{2})(\\d{3})`, `$1 $2`, [`[2-578]`]]]],
      CL: [
        `56`,
        `(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0`,
        `12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}`,
        [9, 10, 11],
        [
          [`(\\d{5})(\\d{4})`, `$1 $2`, [`219`, `2196`], `($1)`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`44`]],
          [`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2[1-36]`], `($1)`],
          [`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`9[2-9]`]],
          [
            `(\\d{2})(\\d{3})(\\d{4})`,
            `$1 $2 $3`,
            [`3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])`],
            `($1)`,
          ],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`60|8`]],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]],
          [`(\\d{3})(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`60`]],
        ],
      ],
      CM: [
        `237`,
        `00`,
        `[26]\\d{8}|88\\d{6,7}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`88`]],
          [`(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`[26]|88`]],
        ],
      ],
      CN: [
        `86`,
        `00|1(?:[12]\\d|79)\\d\\d00`,
        `1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}`,
        [7, 8, 9, 10, 11, 12],
        [
          [
            `(\\d{2})(\\d{5,6})`,
            `$1 $2`,
            [
              `(?:10|2[0-57-9])[19]`,
              `(?:10|2[0-57-9])(?:10|9[56])`,
              `10(?:10|9[56])|2[0-57-9](?:100|9[56])`,
            ],
            `0$1`,
          ],
          [
            `(\\d{3})(\\d{5,6})`,
            `$1 $2`,
            [
              `3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]`,
              `(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]`,
              `85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])`,
              `85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])`,
            ],
            `0$1`,
          ],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`(?:4|80)0`]],
          [
            `(\\d{2})(\\d{4})(\\d{4})`,
            `$1 $2 $3`,
            [
              `10|2(?:[02-57-9]|1[1-9])`,
              `10|2(?:[02-57-9]|1[1-9])`,
              `10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])`,
            ],
            `0$1`,
            1,
          ],
          [
            `(\\d{3})(\\d{3})(\\d{4})`,
            `$1 $2 $3`,
            [
              `3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]`,
            ],
            `0$1`,
            1,
          ],
          [`(\\d{3})(\\d{7,8})`, `$1 $2`, [`9`]],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`80`], `0$1`, 1],
          [`(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[3-578]`], `0$1`, 1],
          [`(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`1[3-9]`]],
          [`(\\d{2})(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`[12]`], `0$1`, 1],
        ],
        `0`,
        0,
        `(1(?:[12]\\d|79)\\d\\d)|0`,
        0,
        0,
        0,
        0,
        `00`,
      ],
      CO: [
        `57`,
        `00(?:4(?:[14]4|56)|[579])`,
        `(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}`,
        [10, 11],
        [
          [`(\\d{3})(\\d{7})`, `$1 $2`, [`6`], `($1)`],
          [`(\\d{3})(\\d{7})`, `$1 $2`, [`3[0-357]|91`]],
          [`(\\d)(\\d{3})(\\d{7})`, `$1-$2-$3`, [`1`], `0$1`, 0, `$1 $2 $3`],
        ],
        `0`,
        0,
        `0([3579]|4(?:[14]4|56))?`,
      ],
      CR: [
        `506`,
        `00`,
        `(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}`,
        [8, 10],
        [
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[2-7]|8[3-9]`]],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[89]`]],
        ],
        0,
        0,
        `(19(?:0[0-2468]|1[09]|20|66|77|99))`,
      ],
      CU: [
        `53`,
        `119`,
        `[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}`,
        [6, 7, 8, 10],
        [
          [`(\\d{2})(\\d{4,6})`, `$1 $2`, [`2[1-4]|[34]`], `(0$1)`],
          [`(\\d)(\\d{6,7})`, `$1 $2`, [`7`], `(0$1)`],
          [`(\\d)(\\d{7})`, `$1 $2`, [`[56]`], `0$1`],
          [`(\\d{3})(\\d{7})`, `$1 $2`, [`8`], `0$1`],
        ],
        `0`,
      ],
      CV: [
        `238`,
        `0`,
        `(?:[2-59]\\d\\d|800)\\d{4}`,
        [7],
        [[`(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[2-589]`]]],
      ],
      CW: [
        `599`,
        `00`,
        `(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}`,
        [7, 8],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[3467]`]],
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`9[4-8]`]],
        ],
        0,
        0,
        0,
        0,
        0,
        `[69]`,
      ],
      CX: [
        `61`,
        `001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011`,
        `1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}`,
        [6, 7, 8, 9, 10, 12],
        0,
        `0`,
        0,
        `([59]\\d{7})$|0`,
        `8$1`,
        0,
        0,
        [
          [
            `8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}`,
            [9],
          ],
          [
            `4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}`,
            [9],
          ],
          [`180(?:0\\d{3}|2)\\d{3}`, [7, 10]],
          [`190[0-26]\\d{6}`, [10]],
          0,
          0,
          0,
          0,
          [`14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}`, [9]],
          [`13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}`, [6, 8, 10, 12]],
        ],
        `0011`,
      ],
      CY: [
        `357`,
        `00`,
        `(?:[279]\\d|[58]0)\\d{6}`,
        [8],
        [[`(\\d{2})(\\d{6})`, `$1 $2`, [`[257-9]`]]],
      ],
      CZ: [
        `420`,
        `00`,
        `(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}`,
        [9],
        [
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-8]|9[015-7]`]],
          [`(\\d{2})(\\d{3})(\\d{3})(\\d{2})`, `$1 $2 $3 $4`, [`96`]],
          [`(\\d{2})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`9`]],
          [`(\\d{3})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`9`]],
        ],
      ],
      DE: [
        `49`,
        `00`,
        `[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}`,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [
          [`(\\d{2})(\\d{3,13})`, `$1 $2`, [`3[02]|40|[68]9`], `0$1`],
          [
            `(\\d{3})(\\d{3,12})`,
            `$1 $2`,
            [
              `2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1`,
              `2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1`,
            ],
            `0$1`,
          ],
          [
            `(\\d{4})(\\d{2,11})`,
            `$1 $2`,
            [
              `[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]`,
              `[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]`,
            ],
            `0$1`,
          ],
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`138`], `0$1`],
          [`(\\d{5})(\\d{2,10})`, `$1 $2`, [`3`], `0$1`],
          [`(\\d{3})(\\d{5,11})`, `$1 $2`, [`181`], `0$1`],
          [`(\\d{3})(\\d)(\\d{4,10})`, `$1 $2 $3`, [`1(?:3|80)|9`], `0$1`],
          [`(\\d{3})(\\d{7,8})`, `$1 $2`, [`1[67]`], `0$1`],
          [`(\\d{3})(\\d{7,12})`, `$1 $2`, [`8`], `0$1`],
          [`(\\d{5})(\\d{6})`, `$1 $2`, [`185`, `1850`, `18500`], `0$1`],
          [`(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`],
          [`(\\d{4})(\\d{7})`, `$1 $2`, [`18[68]`], `0$1`],
          [`(\\d{5})(\\d{6})`, `$1 $2`, [`15[0568]`], `0$1`],
          [`(\\d{4})(\\d{7})`, `$1 $2`, [`15[1279]`], `0$1`],
          [`(\\d{3})(\\d{8})`, `$1 $2`, [`18`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{7,8})`, `$1 $2 $3`, [`1(?:6[023]|7)`], `0$1`],
          [`(\\d{4})(\\d{2})(\\d{7})`, `$1 $2 $3`, [`15[279]`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{8})`, `$1 $2 $3`, [`15`], `0$1`],
        ],
        `0`,
      ],
      DJ: [
        `253`,
        `00`,
        `(?:2\\d|77)\\d{6}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[27]`]]],
      ],
      DK: [
        `45`,
        `00`,
        `[2-9]\\d{7}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-9]`]]],
      ],
      DM: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|767|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-7]\\d{6})$|1`,
        `767$1`,
        0,
        `767`,
      ],
      DO: [`1`, `011`, `(?:[58]\\d\\d|900)\\d{7}`, [10], 0, `1`, 0, 0, 0, 0, `8001|8[024]9`],
      DZ: [
        `213`,
        `00`,
        `(?:[1-4]|[5-79]\\d|80)\\d{7}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[1-4]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`9`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-8]`], `0$1`],
        ],
        `0`,
      ],
      EC: [
        `593`,
        `00`,
        `1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}`,
        [8, 9, 10, 11],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2-$3`, [`[2-7]`], `(0$1)`, 0, `$1-$2-$3`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`9`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`1`]],
        ],
        `0`,
      ],
      EE: [
        `372`,
        `00`,
        `8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}`,
        [7, 8, 10],
        [
          [
            `(\\d{3})(\\d{4})`,
            `$1 $2`,
            [
              `[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88`,
              `[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88`,
            ],
          ],
          [`(\\d{4})(\\d{3,4})`, `$1 $2`, [`[45]|8(?:00|[1-49])`, `[45]|8(?:00[1-9]|[1-49])`]],
          [`(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`7`]],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]],
        ],
      ],
      EG: [
        `20`,
        `00`,
        `[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}`,
        [8, 9, 10],
        [
          [`(\\d)(\\d{7,8})`, `$1 $2`, [`[23]`], `0$1`],
          [`(\\d{2})(\\d{6,7})`, `$1 $2`, [`1[35]|[4-6]|8[2468]|9[235-7]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[89]`], `0$1`],
          [`(\\d{2})(\\d{8})`, `$1 $2`, [`1`], `0$1`],
        ],
        `0`,
      ],
      EH: [`212`, `00`, `[5-8]\\d{8}`, [9], 0, `0`, 0, 0, 0, 0, `528[89]`],
      ER: [
        `291`,
        `00`,
        `[178]\\d{6}`,
        [7],
        [[`(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[178]`], `0$1`]],
        `0`,
      ],
      ES: [
        `34`,
        `00`,
        `[5-9]\\d{8}`,
        [9],
        [
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[89]00`]],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-9]`]],
        ],
      ],
      ET: [
        `251`,
        `00`,
        `(?:11|[2-579]\\d)\\d{7}`,
        [9],
        [[`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1-579]`], `0$1`]],
        `0`,
      ],
      FI: [
        `358`,
        `00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))`,
        `[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}`,
        [5, 6, 7, 8, 9, 10, 11, 12],
        [
          [`(\\d)(\\d{4,9})`, `$1 $2`, [`[2568][1-8]|3(?:0[1-9]|[1-9])|9`], `0$1`],
          [`(\\d{3})(\\d{3,7})`, `$1 $2`, [`[12]00|[368]|70[07-9]`], `0$1`],
          [`(\\d{2})(\\d{4,8})`, `$1 $2`, [`[1245]|7[135]`], `0$1`],
          [`(\\d{2})(\\d{6,10})`, `$1 $2`, [`7`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        `1[03-79]|[2-9]`,
        0,
        `00`,
      ],
      FJ: [
        `679`,
        `0(?:0|52)`,
        `45\\d{5}|(?:0800\\d|[235-9])\\d{6}`,
        [7, 11],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[235-9]|45`]],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`0`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      FK: [`500`, `00`, `[2-7]\\d{4}`, [5]],
      FM: [
        `691`,
        `00`,
        `(?:[39]\\d\\d|820)\\d{4}`,
        [7],
        [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[389]`]]],
      ],
      FO: [
        `298`,
        `00`,
        `[2-9]\\d{5}`,
        [6],
        [[`(\\d{6})`, `$1`, [`[2-9]`]]],
        0,
        0,
        `(10(?:01|[12]0|88))`,
      ],
      FR: [
        `33`,
        `00`,
        `[1-9]\\d{8}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0 $1`],
          [`(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`[1-79]`], `0$1`],
        ],
        `0`,
      ],
      GA: [
        `241`,
        `00`,
        `(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}`,
        [7, 8],
        [
          [`(\\d)(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-7]`], `0$1`],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`0`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`11|[67]`], `0$1`],
        ],
        0,
        0,
        `0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})`,
        `$1`,
      ],
      GB: [
        `44`,
        `00`,
        `[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}`,
        [7, 9, 10],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`800`, `8001`, `80011`, `800111`, `8001111`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`845`, `8454`, `84546`, `845464`], `0$1`],
          [`(\\d{3})(\\d{6})`, `$1 $2`, [`800`], `0$1`],
          [
            `(\\d{5})(\\d{4,5})`,
            `$1 $2`,
            [
              `1(?:38|5[23]|69|76|94)`,
              `1(?:(?:38|69)7|5(?:24|39)|768|946)`,
              `1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)`,
            ],
            `0$1`,
          ],
          [`(\\d{4})(\\d{5,6})`, `$1 $2`, [`1(?:[2-69][02-9]|[78])`], `0$1`],
          [
            `(\\d{2})(\\d{4})(\\d{4})`,
            `$1 $2 $3`,
            [`[25]|7(?:0|6[02-9])`, `[25]|7(?:0|6(?:[03-9]|2[356]))`],
            `0$1`,
          ],
          [`(\\d{4})(\\d{6})`, `$1 $2`, [`7`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1389]`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        [
          [
            `(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}`,
            [9, 10],
          ],
          [
            `7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}`,
            [10],
          ],
          [`80[08]\\d{7}|800\\d{6}|8001111`],
          [`(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d`, [7, 10]],
          [`70\\d{8}`, [10]],
          0,
          [`(?:3[0347]|55)\\d{8}`, [10]],
          [
            `76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}`,
            [10],
          ],
          [`56\\d{8}`, [10]],
        ],
        0,
        ` x`,
      ],
      GD: [
        `1`,
        `011`,
        `(?:473|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-9]\\d{6})$|1`,
        `473$1`,
        0,
        `473`,
      ],
      GE: [
        `995`,
        `00`,
        `(?:[3-57]\\d\\d|800)\\d{6}`,
        [9],
        [
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`70`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`32`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[57]`]],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[348]`], `0$1`],
        ],
        `0`,
      ],
      GF: [
        `594`,
        `00`,
        `[56]94\\d{6}|(?:80|9\\d)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[56]|9[47]`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[89]`], `0$1`],
        ],
        `0`,
      ],
      GG: [
        `44`,
        `00`,
        `(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?`,
        [7, 9, 10],
        0,
        `0`,
        0,
        `([25-9]\\d{5})$|0`,
        `1481$1`,
        0,
        0,
        [
          [`1481[25-9]\\d{5}`, [10]],
          [`7(?:(?:781|839)\\d|911[17])\\d{5}`, [10]],
          [`80[08]\\d{7}|800\\d{6}|8001111`],
          [`(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d`, [7, 10]],
          [`70\\d{8}`, [10]],
          0,
          [`(?:3[0347]|55)\\d{8}`, [10]],
          [
            `76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}`,
            [10],
          ],
          [`56\\d{8}`, [10]],
        ],
      ],
      GH: [
        `233`,
        `00`,
        `(?:[235]\\d{3}|800)\\d{5}`,
        [8, 9],
        [
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`8`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[235]`], `0$1`],
        ],
        `0`,
      ],
      GI: [`350`, `00`, `(?:[25]\\d|60)\\d{6}`, [8], [[`(\\d{3})(\\d{5})`, `$1 $2`, [`2`]]]],
      GL: [
        `299`,
        `00`,
        `(?:19|[2-689]\\d|70)\\d{4}`,
        [6],
        [[`(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`19|[2-9]`]]],
      ],
      GM: [`220`, `00`, `[2-9]\\d{6}`, [7], [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[2-9]`]]]],
      GN: [
        `224`,
        `00`,
        `722\\d{6}|(?:3|6\\d)\\d{7}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`3`]],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[67]`]],
        ],
      ],
      GP: [
        `590`,
        `00`,
        `590\\d{6}|(?:69|80|9\\d)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[569]`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        [
          [`590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}`],
          [`69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}`],
          [`80[0-5]\\d{6}`],
          0,
          0,
          0,
          0,
          0,
          [`9(?:(?:395|76[018])\\d|475[0-5])\\d{4}`],
        ],
      ],
      GQ: [
        `240`,
        `00`,
        `222\\d{6}|(?:3\\d|55|[89]0)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[235]`]],
          [`(\\d{3})(\\d{6})`, `$1 $2`, [`[89]`]],
        ],
      ],
      GR: [
        `30`,
        `00`,
        `5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}`,
        [10, 11, 12],
        [
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`21|7`]],
          [
            `(\\d{4})(\\d{6})`,
            `$1 $2`,
            [`2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5`],
          ],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2689]`]],
          [`(\\d{3})(\\d{3,4})(\\d{5})`, `$1 $2 $3`, [`8`]],
        ],
      ],
      GT: [
        `502`,
        `00`,
        `80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}`,
        [8, 11],
        [
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[2-8]`]],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]],
        ],
      ],
      GU: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|671|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-9]\\d{6})$|1`,
        `671$1`,
        0,
        `671`,
      ],
      GW: [
        `245`,
        `00`,
        `[49]\\d{8}|4\\d{6}`,
        [7, 9],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`40`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[49]`]],
        ],
      ],
      GY: [
        `592`,
        `001`,
        `(?:[2-8]\\d{3}|9008)\\d{3}`,
        [7],
        [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[2-9]`]]],
      ],
      HK: [
        `852`,
        `00(?:30|5[09]|[126-9]?)`,
        `8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}`,
        [5, 6, 7, 8, 9, 11],
        [
          [`(\\d{3})(\\d{2,5})`, `$1 $2`, [`900`, `9003`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[2-7]|8[1-4]|9(?:0[1-9]|[1-8])`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]],
          [`(\\d{3})(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`9`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      HN: [
        `504`,
        `00`,
        `8\\d{10}|[237-9]\\d{7}`,
        [8, 11],
        [[`(\\d{4})(\\d{4})`, `$1-$2`, [`[237-9]`]]],
      ],
      HR: [
        `385`,
        `00`,
        `(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}`,
        [6, 7, 8, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`6[01]`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`8`], `0$1`],
          [`(\\d)(\\d{4})(\\d{3})`, `$1 $2 $3`, [`1`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[67]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`9`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-5]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`], `0$1`],
        ],
        `0`,
      ],
      HT: [
        `509`,
        `00`,
        `(?:[2-489]\\d|55)\\d{6}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`[2-589]`]]],
      ],
      HU: [
        `36`,
        `00`,
        `[235-7]\\d{8}|[1-9]\\d{7}`,
        [8, 9],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `(06 $1)`],
          [
            `(\\d{2})(\\d{3})(\\d{3})`,
            `$1 $2 $3`,
            [`[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]`],
            `(06 $1)`,
          ],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-9]`], `06 $1`],
        ],
        `06`,
      ],
      ID: [
        `62`,
        `00[89]`,
        `(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}`,
        [7, 8, 9, 10, 11, 12, 13],
        [
          [`(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`15`]],
          [`(\\d{2})(\\d{5,9})`, `$1 $2`, [`2[124]|[36]1`], `(0$1)`],
          [`(\\d{3})(\\d{5,7})`, `$1 $2`, [`800`], `0$1`],
          [`(\\d{3})(\\d{5,8})`, `$1 $2`, [`[2-79]`], `(0$1)`],
          [`(\\d{3})(\\d{3,4})(\\d{3})`, `$1-$2-$3`, [`8[1-35-9]`], `0$1`],
          [`(\\d{3})(\\d{6,8})`, `$1 $2`, [`1`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`804`], `0$1`],
          [`(\\d{3})(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`80`], `0$1`],
          [`(\\d{3})(\\d{4})(\\d{4,5})`, `$1-$2-$3`, [`8`], `0$1`],
        ],
        `0`,
      ],
      IE: [
        `353`,
        `00`,
        `(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}`,
        [7, 8, 9, 10],
        [
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`2[24-9]|47|58|6[237-9]|9[35-9]`], `(0$1)`],
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`[45]0`], `(0$1)`],
          [`(\\d)(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`1`], `(0$1)`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2569]|4[1-69]|7[14]`], `(0$1)`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`70`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`81`], `(0$1)`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[78]`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`4`], `(0$1)`],
          [`(\\d{2})(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`8`], `0$1`],
        ],
        `0`,
      ],
      IL: [
        `972`,
        `0(?:0|1[2-9])`,
        `1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}`,
        [7, 8, 9, 10, 11, 12],
        [
          [`(\\d{4})(\\d{3})`, `$1-$2`, [`125`]],
          [`(\\d{4})(\\d{2})(\\d{2})`, `$1-$2-$3`, [`121`]],
          [`(\\d)(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[2-489]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`[57]`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1-$2-$3`, [`12`]],
          [`(\\d{4})(\\d{6})`, `$1-$2`, [`159`]],
          [`(\\d)(\\d{3})(\\d{3})(\\d{3})`, `$1-$2-$3-$4`, [`1[7-9]`]],
          [`(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})`, `$1-$2 $3-$4`, [`15`]],
        ],
        `0`,
      ],
      IM: [
        `44`,
        `00`,
        `1624\\d{6}|(?:[3578]\\d|90)\\d{8}`,
        [10],
        0,
        `0`,
        0,
        `([25-8]\\d{5})$|0`,
        `1624$1`,
        0,
        `74576|(?:16|7[56])24`,
      ],
      IN: [
        `91`,
        `00`,
        `(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}`,
        [8, 9, 10, 11, 12, 13],
        [
          [
            `(\\d{8})`,
            `$1`,
            [
              `5(?:0|2[23]|3[03]|[67]1|88)`,
              `5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)`,
              `5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)`,
            ],
            0,
            1,
          ],
          [`(\\d{4})(\\d{4,5})`, `$1 $2`, [`180`, `1800`], 0, 1],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`140`], 0, 1],
          [
            `(\\d{2})(\\d{4})(\\d{4})`,
            `$1 $2 $3`,
            [
              `11|2[02]|33|4[04]|79[1-7]|80[2-46]`,
              `11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])`,
              `11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])`,
            ],
            `0$1`,
            1,
          ],
          [
            `(\\d{3})(\\d{3})(\\d{4})`,
            `$1 $2 $3`,
            [
              `1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]`,
              `1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]`,
              `1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]`,
            ],
            `0$1`,
            1,
          ],
          [
            `(\\d{4})(\\d{3})(\\d{3})`,
            `$1 $2 $3`,
            [
              `1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807`,
              `1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]`,
              `1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]`,
            ],
            `0$1`,
            1,
          ],
          [`(\\d{5})(\\d{5})`, `$1 $2`, [`[6-9]`], `0$1`, 1],
          [`(\\d{4})(\\d{2,4})(\\d{4})`, `$1 $2 $3`, [`1(?:6|8[06])`, `1(?:6|8[06]0)`], 0, 1],
          [`(\\d{4})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`18`], 0, 1],
        ],
        `0`,
      ],
      IO: [`246`, `00`, `3\\d{6}`, [7], [[`(\\d{3})(\\d{4})`, `$1 $2`, [`3`]]]],
      IQ: [
        `964`,
        `00`,
        `(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}`,
        [8, 9, 10],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-6]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`],
        ],
        `0`,
      ],
      IR: [
        `98`,
        `00`,
        `[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}`,
        [4, 5, 6, 7, 10],
        [
          [`(\\d{4,5})`, `$1`, [`96`], `0$1`],
          [
            `(\\d{2})(\\d{4,5})`,
            `$1 $2`,
            [`(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]`],
            `0$1`,
          ],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`9`], `0$1`],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[1-8]`], `0$1`],
        ],
        `0`,
      ],
      IS: [
        `354`,
        `00|1(?:0(?:01|[12]0)|100)`,
        `(?:38\\d|[4-9])\\d{6}`,
        [7, 9],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[4-9]`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`3`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      IT: [
        `39`,
        `00`,
        `0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?`,
        [6, 7, 8, 9, 10, 11],
        [
          [`(\\d{2})(\\d{4,6})`, `$1 $2`, [`0[26]`]],
          [
            `(\\d{3})(\\d{3,6})`,
            `$1 $2`,
            [
              `0[13-57-9][0159]|8(?:03|4[17]|9[2-5])`,
              `0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))`,
            ],
          ],
          [`(\\d{4})(\\d{2,6})`, `$1 $2`, [`0(?:[13-579][2-46-8]|8[236-8])`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`894`]],
          [`(\\d{2})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`0[26]|5`]],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`1(?:44|[679])|[378]`]],
          [`(\\d{3})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`0[13-57-9][0159]|14`]],
          [`(\\d{2})(\\d{4})(\\d{5})`, `$1 $2 $3`, [`0[26]`]],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`0`]],
          [`(\\d{3})(\\d{4})(\\d{4,5})`, `$1 $2 $3`, [`3`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        [
          [
            `0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}`,
          ],
          [`3[1-9]\\d{8}|3[2-9]\\d{7}`, [9, 10]],
          [`80(?:0\\d{3}|3)\\d{3}`, [6, 9]],
          [
            `(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}`,
            [6, 8, 9, 10],
          ],
          [`1(?:78\\d|99)\\d{6}`, [9, 10]],
          0,
          0,
          0,
          [`55\\d{8}`, [10]],
          [`84(?:[08]\\d{3}|[17])\\d{3}`, [6, 9]],
        ],
      ],
      JE: [
        `44`,
        `00`,
        `1534\\d{6}|(?:[3578]\\d|90)\\d{8}`,
        [10],
        0,
        `0`,
        0,
        `([0-24-8]\\d{5})$|0`,
        `1534$1`,
        0,
        0,
        [
          [`1534[0-24-8]\\d{5}`],
          [`7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}`],
          [`80(?:07(?:35|81)|8901)\\d{4}`],
          [
            `(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}`,
          ],
          [`701511\\d{4}`],
          0,
          [
            `(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}`,
          ],
          [
            `76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}`,
          ],
          [`56\\d{8}`],
        ],
      ],
      JM: [`1`, `011`, `(?:[58]\\d\\d|658|900)\\d{7}`, [10], 0, `1`, 0, 0, 0, 0, `658|876`],
      JO: [
        `962`,
        `00`,
        `(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}`,
        [8, 9],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2356]|87`], `(0$1)`],
          [`(\\d{3})(\\d{5,6})`, `$1 $2`, [`[89]`], `0$1`],
          [`(\\d{2})(\\d{7})`, `$1 $2`, [`70`], `0$1`],
          [`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`],
        ],
        `0`,
      ],
      JP: [
        `81`,
        `010`,
        `00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}`,
        [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
        [
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1-$2-$3`, [`(?:12|57|99)0`], `0$1`],
          [
            `(\\d{4})(\\d)(\\d{4})`,
            `$1-$2-$3`,
            [
              `1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])`,
              `1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]`,
              `1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]`,
            ],
            `0$1`,
          ],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`60`], `0$1`],
          [
            `(\\d)(\\d{4})(\\d{4})`,
            `$1-$2-$3`,
            [`[36]|4(?:2[09]|7[01])`, `[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))`],
            `0$1`,
          ],
          [
            `(\\d{2})(\\d{3})(\\d{4})`,
            `$1-$2-$3`,
            [
              `1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])`,
              `1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]`,
              `1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]`,
            ],
            `0$1`,
          ],
          [`(\\d{3})(\\d{2})(\\d{4})`, `$1-$2-$3`, [`[14]|[289][2-9]|5[3-9]|7[2-4679]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`800`], `0$1`],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[257-9]`], `0$1`],
        ],
        `0`,
        0,
        `(000[259]\\d{6})$|(?:(?:003768)0?)|0`,
        `$1`,
      ],
      KE: [
        `254`,
        `000`,
        `(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}`,
        [7, 8, 9, 10],
        [
          [`(\\d{2})(\\d{5,7})`, `$1 $2`, [`[24-6]`], `0$1`],
          [`(\\d{3})(\\d{6})`, `$1 $2`, [`[17]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[89]`], `0$1`],
        ],
        `0`,
      ],
      KG: [
        `996`,
        `00`,
        `8\\d{9}|[235-9]\\d{8}`,
        [9, 10],
        [
          [`(\\d{4})(\\d{5})`, `$1 $2`, [`3(?:1[346]|[24-79])`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[235-79]|88`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d)(\\d{2,3})`, `$1 $2 $3 $4`, [`8`], `0$1`],
        ],
        `0`,
      ],
      KH: [
        `855`,
        `00[14-9]`,
        `1\\d{9}|[1-9]\\d{7,8}`,
        [8, 9, 10],
        [
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[1-9]`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]],
        ],
        `0`,
      ],
      KI: [`686`, `00`, `(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}`, [5, 8], 0, `0`],
      KM: [
        `269`,
        `00`,
        `[3478]\\d{6}`,
        [7],
        [[`(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[3478]`]]],
      ],
      KN: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-7]\\d{6})$|1`,
        `869$1`,
        0,
        `869`,
      ],
      KP: [
        `850`,
        `00|99`,
        `85\\d{6}|(?:19\\d|[2-7])\\d{7}`,
        [8, 10],
        [
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`], `0$1`],
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-7]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`],
        ],
        `0`,
      ],
      KR: [
        `82`,
        `00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))`,
        `00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}`,
        [5, 6, 8, 9, 10, 11, 12, 13, 14],
        [
          [`(\\d{2})(\\d{3,4})`, `$1-$2`, [`(?:3[1-3]|[46][1-4]|5[1-5])1`], `0$1`],
          [`(\\d{4})(\\d{4})`, `$1-$2`, [`1`]],
          [`(\\d)(\\d{3,4})(\\d{4})`, `$1-$2-$3`, [`2`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1-$2-$3`, [`60|8`], `0$1`],
          [`(\\d{2})(\\d{3,4})(\\d{4})`, `$1-$2-$3`, [`[1346]|5[1-5]`], `0$1`],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1-$2-$3`, [`[57]`], `0$1`],
          [`(\\d{2})(\\d{5})(\\d{4})`, `$1-$2-$3`, [`5`], `0$1`],
        ],
        `0`,
        0,
        `0(8(?:[1-46-8]|5\\d\\d))?`,
      ],
      KW: [
        `965`,
        `00`,
        `18\\d{5}|(?:[2569]\\d|41)\\d{6}`,
        [7, 8],
        [
          [`(\\d{4})(\\d{3,4})`, `$1 $2`, [`[169]|2(?:[235]|4[1-35-9])|52`]],
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`[245]`]],
        ],
      ],
      KY: [
        `1`,
        `011`,
        `(?:345|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-9]\\d{6})$|1`,
        `345$1`,
        0,
        `345`,
      ],
      KZ: [
        `7`,
        `810`,
        `(?:33622|8\\d{8})\\d{5}|[78]\\d{9}`,
        [10, 14],
        0,
        `8`,
        0,
        0,
        0,
        0,
        `33|7`,
        0,
        `8~10`,
      ],
      LA: [
        `856`,
        `00`,
        `[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}`,
        [8, 9, 10],
        [
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2[13]|3[14]|[4-8]`], `0$1`],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`30[013-9]`], `0$1`],
          [`(\\d{2})(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`[23]`], `0$1`],
        ],
        `0`,
      ],
      LB: [
        `961`,
        `00`,
        `[27-9]\\d{7}|[13-9]\\d{6}`,
        [7, 8],
        [
          [
            `(\\d)(\\d{3})(\\d{3})`,
            `$1 $2 $3`,
            [`[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]`],
            `0$1`,
          ],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[27-9]`]],
        ],
        `0`,
      ],
      LC: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|758|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-8]\\d{6})$|1`,
        `758$1`,
        0,
        `758`,
      ],
      LI: [
        `423`,
        `00`,
        `[68]\\d{8}|(?:[2378]\\d|90)\\d{5}`,
        [7, 9],
        [
          [
            `(\\d{3})(\\d{2})(\\d{2})`,
            `$1 $2 $3`,
            [`[2379]|8(?:0[09]|7)`, `[2379]|8(?:0(?:02|9)|7)`],
          ],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`69`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6`]],
        ],
        `0`,
        0,
        `(1001)|0`,
      ],
      LK: [
        `94`,
        `00`,
        `[1-9]\\d{8}`,
        [9],
        [
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[1-689]`], `0$1`],
        ],
        `0`,
      ],
      LR: [
        `231`,
        `00`,
        `(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}`,
        [7, 8, 9],
        [
          [`(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[4-6]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[23578]`], `0$1`],
        ],
        `0`,
      ],
      LS: [
        `266`,
        `00`,
        `(?:[256]\\d\\d|800)\\d{5}`,
        [8],
        [[`(\\d{4})(\\d{4})`, `$1 $2`, [`[2568]`]]],
      ],
      LT: [
        `370`,
        `00`,
        `(?:[3469]\\d|52|[78]0)\\d{6}`,
        [8],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`52[0-7]`], `(8-$1)`, 1],
          [`(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`[7-9]`], `8 $1`, 1],
          [`(\\d{2})(\\d{6})`, `$1 $2`, [`37|4(?:[15]|6[1-8])`], `(8-$1)`, 1],
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`[3-6]`], `(8-$1)`, 1],
        ],
        `8`,
        0,
        `[08]`,
      ],
      LU: [
        `352`,
        `00`,
        `35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}`,
        [4, 5, 6, 7, 8, 9, 10, 11],
        [
          [
            `(\\d{2})(\\d{3})`,
            `$1 $2`,
            [`2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])`],
          ],
          [
            `(\\d{2})(\\d{2})(\\d{2})`,
            `$1 $2 $3`,
            [`2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])`],
          ],
          [`(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`20[2-689]`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})`, `$1 $2 $3 $4`, [`2(?:[0367]|4[3-8])`]],
          [`(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`80[01]|90[015]`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3 $4`, [`20`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`6`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})`, `$1 $2 $3 $4 $5`, [`2(?:[0367]|4[3-8])`]],
          [
            `(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})`,
            `$1 $2 $3 $4`,
            [`[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]`],
          ],
        ],
        0,
        0,
        `(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)`,
      ],
      LV: [
        `371`,
        `00`,
        `(?:[268]\\d|90)\\d{6}`,
        [8],
        [[`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[269]|8[01]`]]],
      ],
      LY: [`218`, `00`, `[2-9]\\d{8}`, [9], [[`(\\d{2})(\\d{7})`, `$1-$2`, [`[2-9]`], `0$1`]], `0`],
      MA: [
        `212`,
        `00`,
        `[5-8]\\d{8}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`5[45]`], `0$1`],
          [
            `(\\d{4})(\\d{5})`,
            `$1-$2`,
            [
              `5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)`,
              `5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)`,
            ],
            `0$1`,
          ],
          [`(\\d{2})(\\d{7})`, `$1-$2`, [`8`], `0$1`],
          [`(\\d{3})(\\d{6})`, `$1-$2`, [`[5-7]`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        [
          [
            `5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}`,
          ],
          [`(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}`],
          [`80[0-7]\\d{6}`],
          [`89\\d{7}`],
          0,
          0,
          0,
          0,
          [`(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}`],
        ],
      ],
      MC: [
        `377`,
        `00`,
        `(?:[3489]|6\\d)\\d{7}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`4`], `0$1`],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[389]`]],
          [`(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4 $5`, [`6`], `0$1`],
        ],
        `0`,
      ],
      MD: [
        `373`,
        `00`,
        `(?:[235-7]\\d|[89]0)\\d{6}`,
        [8],
        [
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`[89]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`22|3`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`[25-7]`], `0$1`],
        ],
        `0`,
      ],
      ME: [
        `382`,
        `00`,
        `(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}`,
        [8, 9],
        [[`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[2-9]`], `0$1`]],
        `0`,
      ],
      MF: [
        `590`,
        `00`,
        `590\\d{6}|(?:69|80|9\\d)\\d{7}`,
        [9],
        0,
        `0`,
        0,
        0,
        0,
        0,
        0,
        [
          [`590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}`],
          [`69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}`],
          [`80[0-5]\\d{6}`],
          0,
          0,
          0,
          0,
          0,
          [`9(?:(?:395|76[018])\\d|475[0-5])\\d{4}`],
        ],
      ],
      MG: [
        `261`,
        `00`,
        `[23]\\d{8}`,
        [9],
        [[`(\\d{2})(\\d{2})(\\d{3})(\\d{2})`, `$1 $2 $3 $4`, [`[23]`], `0$1`]],
        `0`,
        0,
        `([24-9]\\d{6})$|0`,
        `20$1`,
      ],
      MH: [
        `692`,
        `011`,
        `329\\d{4}|(?:[256]\\d|45)\\d{5}`,
        [7],
        [[`(\\d{3})(\\d{4})`, `$1-$2`, [`[2-6]`]]],
        `1`,
      ],
      MK: [
        `389`,
        `00`,
        `[2-578]\\d{7}`,
        [8],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`2|34[47]|4(?:[37]7|5[47]|64)`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[347]`], `0$1`],
          [`(\\d{3})(\\d)(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[58]`], `0$1`],
        ],
        `0`,
      ],
      ML: [
        `223`,
        `00`,
        `[24-9]\\d{7}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24-9]`]]],
      ],
      MM: [
        `95`,
        `00`,
        `1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}`,
        [6, 7, 8, 9, 10],
        [
          [`(\\d)(\\d{2})(\\d{3})`, `$1 $2 $3`, [`16|2`], `0$1`],
          [
            `(\\d{2})(\\d{2})(\\d{3})`,
            `$1 $2 $3`,
            [`[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]`],
            `0$1`,
          ],
          [`(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[12]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[4-7]|8[1-35]`], `0$1`],
          [`(\\d)(\\d{3})(\\d{4,6})`, `$1 $2 $3`, [`9(?:2[0-4]|[35-9]|4[137-9])`], `0$1`],
          [`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`], `0$1`],
          [`(\\d)(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`92`], `0$1`],
          [`(\\d)(\\d{5})(\\d{4})`, `$1 $2 $3`, [`9`], `0$1`],
        ],
        `0`,
      ],
      MN: [
        `976`,
        `001`,
        `[12]\\d{7,9}|[5-9]\\d{7}`,
        [8, 9, 10],
        [
          [`(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`[12]1`], `0$1`],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[5-9]`]],
          [`(\\d{3})(\\d{5,6})`, `$1 $2`, [`[12]2[1-3]`], `0$1`],
          [
            `(\\d{4})(\\d{5,6})`,
            `$1 $2`,
            [`[12](?:27|3[2-8]|4[2-68]|5[1-4689])`, `[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]`],
            `0$1`,
          ],
          [`(\\d{5})(\\d{4,5})`, `$1 $2`, [`[12]`], `0$1`],
        ],
        `0`,
      ],
      MO: [
        `853`,
        `00`,
        `0800\\d{3}|(?:28|[68]\\d)\\d{6}`,
        [7, 8],
        [
          [`(\\d{4})(\\d{3})`, `$1 $2`, [`0`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[268]`]],
        ],
      ],
      MP: [
        `1`,
        `011`,
        `[58]\\d{9}|(?:67|90)0\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-9]\\d{6})$|1`,
        `670$1`,
        0,
        `670`,
      ],
      MQ: [
        `596`,
        `00`,
        `596\\d{6}|(?:69|80|9\\d)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[569]`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0$1`],
        ],
        `0`,
      ],
      MR: [
        `222`,
        `00`,
        `(?:[2-4]\\d\\d|800)\\d{5}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-48]`]]],
      ],
      MS: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|664|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([34]\\d{6})$|1`,
        `664$1`,
        0,
        `664`,
      ],
      MT: [
        `356`,
        `00`,
        `3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}`,
        [8],
        [[`(\\d{4})(\\d{4})`, `$1 $2`, [`[2357-9]`]]],
      ],
      MU: [
        `230`,
        `0(?:0|[24-7]0|3[03])`,
        `(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}`,
        [7, 8, 10],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[2-46]|8[013]`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[57]`]],
          [`(\\d{5})(\\d{5})`, `$1 $2`, [`8`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `020`,
      ],
      MV: [
        `960`,
        `0(?:0|19)`,
        `(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}`,
        [7, 10],
        [
          [`(\\d{3})(\\d{4})`, `$1-$2`, [`[34679]`]],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[89]`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      MW: [
        `265`,
        `00`,
        `(?:[1289]\\d|31|77)\\d{7}|1\\d{6}`,
        [7, 9],
        [
          [`(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1[2-9]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2`], `0$1`],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[137-9]`], `0$1`],
        ],
        `0`,
      ],
      MX: [
        `52`,
        `0[09]`,
        `1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}`,
        [10, 11],
        [
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`33|5[56]|81`], 0, 1],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2-9]`], 0, 1],
          [`(\\d)(\\d{2})(\\d{4})(\\d{4})`, `$2 $3 $4`, [`1(?:33|5[56]|81)`], 0, 1],
          [`(\\d)(\\d{3})(\\d{3})(\\d{4})`, `$2 $3 $4`, [`1`], 0, 1],
        ],
        `01`,
        0,
        `0(?:[12]|4[45])|1`,
        0,
        0,
        0,
        0,
        `00`,
      ],
      MY: [
        `60`,
        `00`,
        `1\\d{8,9}|(?:3\\d|[4-9])\\d{7}`,
        [8, 9, 10],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1-$2 $3`, [`[4-79]`], `0$1`],
          [
            `(\\d{2})(\\d{3})(\\d{3,4})`,
            `$1-$2 $3`,
            [`1(?:[02469]|[378][1-9]|53)|8`, `1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8`],
            `0$1`,
          ],
          [`(\\d)(\\d{4})(\\d{4})`, `$1-$2 $3`, [`3`], `0$1`],
          [`(\\d)(\\d{3})(\\d{2})(\\d{4})`, `$1-$2-$3-$4`, [`1(?:[367]|80)`]],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1-$2 $3`, [`15`], `0$1`],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1-$2 $3`, [`1`], `0$1`],
        ],
        `0`,
      ],
      MZ: [
        `258`,
        `00`,
        `(?:2|8\\d)\\d{7}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2|8[2-79]`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`8`]],
        ],
      ],
      NA: [
        `264`,
        `00`,
        `[68]\\d{7,8}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`88`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`6`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`87`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`], `0$1`],
        ],
        `0`,
      ],
      NC: [
        `687`,
        `00`,
        `(?:050|[2-57-9]\\d\\d)\\d{3}`,
        [6],
        [[`(\\d{2})(\\d{2})(\\d{2})`, `$1.$2.$3`, [`[02-57-9]`]]],
      ],
      NE: [
        `227`,
        `00`,
        `[027-9]\\d{7}`,
        [8],
        [
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`08`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[089]|2[013]|7[047]`]],
        ],
      ],
      NF: [
        `672`,
        `00`,
        `[13]\\d{5}`,
        [6],
        [
          [`(\\d{2})(\\d{4})`, `$1 $2`, [`1[0-3]`]],
          [`(\\d)(\\d{5})`, `$1 $2`, [`[13]`]],
        ],
        0,
        0,
        `([0-258]\\d{4})$`,
        `3$1`,
      ],
      NG: [
        `234`,
        `009`,
        `(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}`,
        [7, 8, 10, 11, 12, 13, 14],
        [
          [`(\\d{2})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`78`], `0$1`],
          [`(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[12]|9(?:0[3-9]|[1-9])`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{2,3})`, `$1 $2 $3`, [`[3-7]|8[2-9]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[7-9]`], `0$1`],
          [`(\\d{3})(\\d{4})(\\d{4,5})`, `$1 $2 $3`, [`[78]`], `0$1`],
          [`(\\d{3})(\\d{5})(\\d{5,6})`, `$1 $2 $3`, [`[78]`], `0$1`],
        ],
        `0`,
      ],
      NI: [
        `505`,
        `00`,
        `(?:1800|[25-8]\\d{3})\\d{4}`,
        [8],
        [[`(\\d{4})(\\d{4})`, `$1 $2`, [`[125-8]`]]],
      ],
      NL: [
        `31`,
        `00`,
        `(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}`,
        [5, 6, 7, 8, 9, 10, 11],
        [
          [`(\\d{3})(\\d{4,7})`, `$1 $2`, [`[89]0`], `0$1`],
          [`(\\d{2})(\\d{7})`, `$1 $2`, [`66`], `0$1`],
          [`(\\d)(\\d{8})`, `$1 $2`, [`6`], `0$1`],
          [
            `(\\d{3})(\\d{3})(\\d{3})`,
            `$1 $2 $3`,
            [`1[16-8]|2[259]|3[124]|4[17-9]|5[124679]`],
            `0$1`,
          ],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1-578]|91`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{5})`, `$1 $2 $3`, [`9`], `0$1`],
        ],
        `0`,
      ],
      NO: [
        `47`,
        `00`,
        `(?:0|[2-9]\\d{3})\\d{4}`,
        [5, 8],
        [
          [`(\\d{3})(\\d{2})(\\d{3})`, `$1 $2 $3`, [`8`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2-79]`]],
        ],
        0,
        0,
        0,
        0,
        0,
        `[02-689]|7[0-8]`,
      ],
      NP: [
        `977`,
        `00`,
        `(?:1\\d|9)\\d{9}|[1-9]\\d{7}`,
        [8, 10, 11],
        [
          [`(\\d)(\\d{7})`, `$1-$2`, [`1[2-6]`], `0$1`],
          [`(\\d{2})(\\d{6})`, `$1-$2`, [`1[01]|[2-8]|9(?:[1-59]|[67][2-6])`], `0$1`],
          [`(\\d{3})(\\d{7})`, `$1-$2`, [`9`]],
        ],
        `0`,
      ],
      NR: [
        `674`,
        `00`,
        `(?:444|(?:55|8\\d)\\d|666)\\d{4}`,
        [7],
        [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[4-68]`]]],
      ],
      NU: [`683`, `00`, `(?:[4-7]|888\\d)\\d{3}`, [4, 7], [[`(\\d{3})(\\d{4})`, `$1 $2`, [`8`]]]],
      NZ: [
        `64`,
        `0(?:0|161)`,
        `[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}`,
        [5, 6, 7, 8, 9, 10],
        [
          [`(\\d{2})(\\d{3,8})`, `$1 $2`, [`8[1-79]`], `0$1`],
          [
            `(\\d{3})(\\d{2})(\\d{2,3})`,
            `$1 $2 $3`,
            [`50[036-8]|8|90`, `50(?:[0367]|88)|8|90`],
            `0$1`,
          ],
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`24|[346]|7[2-57-9]|9[2-9]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`2(?:10|74)|[589]`], `0$1`],
          [`(\\d{2})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`1|2[028]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,5})`, `$1 $2 $3`, [`2(?:[169]|7[0-35-9])|7`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      OM: [
        `968`,
        `00`,
        `(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}`,
        [7, 8, 9],
        [
          [`(\\d{3})(\\d{4,6})`, `$1 $2`, [`[58]`]],
          [`(\\d{2})(\\d{6})`, `$1 $2`, [`2`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[179]`]],
        ],
      ],
      PA: [
        `507`,
        `00`,
        `(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}`,
        [7, 8, 10, 11],
        [
          [`(\\d{3})(\\d{4})`, `$1-$2`, [`[1-57-9]`]],
          [`(\\d{4})(\\d{4})`, `$1-$2`, [`[68]`]],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`]],
        ],
      ],
      PE: [
        `51`,
        `00|19(?:1[124]|77|90)00`,
        `(?:[14-8]|9\\d)\\d{7}`,
        [8, 9],
        [
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`80`], `(0$1)`],
          [`(\\d)(\\d{7})`, `$1 $2`, [`1`], `(0$1)`],
          [`(\\d{2})(\\d{6})`, `$1 $2`, [`[4-8]`], `(0$1)`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`]],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
        ` Anexo `,
      ],
      PF: [
        `689`,
        `00`,
        `4\\d{5}(?:\\d{2})?|8\\d{7,8}`,
        [6, 8, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`44`]],
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`4|8[7-9]`]],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`]],
        ],
      ],
      PG: [
        `675`,
        `00|140[1-3]`,
        `(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}`,
        [7, 8],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`18|[2-69]|85`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[78]`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      PH: [
        `63`,
        `00`,
        `(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}`,
        [6, 8, 9, 10, 11, 12, 13],
        [
          [`(\\d)(\\d{5})`, `$1 $2`, [`2`], `(0$1)`],
          [
            `(\\d{4})(\\d{4,6})`,
            `$1 $2`,
            [
              `3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2`,
              `3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))`,
            ],
            `(0$1)`,
          ],
          [
            `(\\d{5})(\\d{4})`,
            `$1 $2`,
            [`346|4(?:27|9[35])|883`, `3469|4(?:279|9(?:30|56))|8834`],
            `(0$1)`,
          ],
          [`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2`], `(0$1)`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[3-7]|8[2-8]`], `(0$1)`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[89]`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]],
          [`(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})`, `$1 $2 $3 $4`, [`1`]],
        ],
        `0`,
      ],
      PK: [
        `92`,
        `00`,
        `122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}`,
        [8, 9, 10, 11, 12],
        [
          [`(\\d{3})(\\d{3})(\\d{2,7})`, `$1 $2 $3`, [`[89]0`], `0$1`],
          [`(\\d{4})(\\d{5})`, `$1 $2`, [`1`]],
          [
            `(\\d{3})(\\d{6,7})`,
            `$1 $2`,
            [
              `2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])`,
              `9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]`,
            ],
            `(0$1)`,
          ],
          [
            `(\\d{2})(\\d{7,8})`,
            `$1 $2`,
            [`(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]`],
            `(0$1)`,
          ],
          [`(\\d{5})(\\d{5})`, `$1 $2`, [`58`], `(0$1)`],
          [`(\\d{3})(\\d{7})`, `$1 $2`, [`3`], `0$1`],
          [
            `(\\d{2})(\\d{3})(\\d{3})(\\d{3})`,
            `$1 $2 $3 $4`,
            [`2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91`],
            `(0$1)`,
          ],
          [`(\\d{3})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`[24-9]`], `(0$1)`],
        ],
        `0`,
      ],
      PL: [
        `48`,
        `00`,
        `(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}`,
        [6, 7, 8, 9, 10],
        [
          [`(\\d{5})`, `$1`, [`19`]],
          [`(\\d{3})(\\d{3})`, `$1 $2`, [`11|20|64`]],
          [
            `(\\d{2})(\\d{2})(\\d{3})`,
            `$1 $2 $3`,
            [
              `(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1`,
              `(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19`,
            ],
          ],
          [`(\\d{3})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`64`]],
          [
            `(\\d{3})(\\d{3})(\\d{3})`,
            `$1 $2 $3`,
            [`21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)`],
          ],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`1[2-8]|[2-7]|8[1-79]|9[145]`]],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`8`]],
        ],
      ],
      PM: [
        `508`,
        `00`,
        `[45]\\d{5}|(?:708|80\\d)\\d{6}`,
        [6, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[45]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`7`]],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`], `0$1`],
        ],
        `0`,
      ],
      PR: [`1`, `011`, `(?:[589]\\d\\d|787)\\d{7}`, [10], 0, `1`, 0, 0, 0, 0, `787|939`],
      PS: [
        `970`,
        `00`,
        `[2489]2\\d{6}|(?:1\\d|5)\\d{8}`,
        [8, 9, 10],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[2489]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`5`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]],
        ],
        `0`,
      ],
      PT: [
        `351`,
        `00`,
        `1693\\d{5}|(?:[26-9]\\d|30)\\d{7}`,
        [9],
        [
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`2[12]`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`16|[236-9]`]],
        ],
      ],
      PW: [
        `680`,
        `01[12]`,
        `(?:[24-8]\\d\\d|345|900)\\d{4}`,
        [7],
        [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[2-9]`]]],
      ],
      PY: [
        `595`,
        `00`,
        `59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}`,
        [6, 7, 8, 9, 10, 11],
        [
          [`(\\d{3})(\\d{3,6})`, `$1 $2`, [`[2-9]0`], `0$1`],
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]`], `(0$1)`],
          [
            `(\\d{3})(\\d{4,5})`,
            `$1 $2`,
            [`2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85`],
            `(0$1)`,
          ],
          [
            `(\\d{2})(\\d{3})(\\d{3,4})`,
            `$1 $2 $3`,
            [`2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]`],
            `(0$1)`,
          ],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`87`]],
          [`(\\d{3})(\\d{6})`, `$1 $2`, [`9(?:[5-79]|8[1-6])`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-8]`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`9`]],
        ],
        `0`,
      ],
      QA: [
        `974`,
        `00`,
        `800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}`,
        [7, 8, 9, 11],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`2[16]|8`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[3-7]`]],
        ],
      ],
      RE: [
        `262`,
        `00`,
        `(?:26|[689]\\d)\\d{7}`,
        [9],
        [[`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2689]`], `0$1`]],
        `0`,
        0,
        0,
        0,
        0,
        0,
        [
          [`26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}`],
          [
            `69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}`,
          ],
          [`80\\d{7}`],
          [`89[1-37-9]\\d{6}`],
          0,
          0,
          0,
          0,
          [`9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}`],
          [`8(?:1[019]|2[0156]|84|90)\\d{6}`],
        ],
      ],
      RO: [
        `40`,
        `00`,
        `(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}`,
        [6, 9],
        [
          [`(\\d{3})(\\d{3})`, `$1 $2`, [`2[3-6]`, `2[3-6]\\d9`], `0$1`],
          [`(\\d{2})(\\d{4})`, `$1 $2`, [`219|31`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[23]1`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[236-9]`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        ` int `,
      ],
      RS: [
        `381`,
        `00`,
        `38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}`,
        [6, 7, 8, 9, 10, 11, 12],
        [
          [`(\\d{3})(\\d{3,9})`, `$1 $2`, [`(?:2[389]|39)0|[7-9]`], `0$1`],
          [`(\\d{2})(\\d{5,10})`, `$1 $2`, [`[1-36]`], `0$1`],
        ],
        `0`,
      ],
      RU: [
        `7`,
        `810`,
        `8\\d{13}|[347-9]\\d{9}`,
        [10, 14],
        [
          [
            `(\\d{4})(\\d{2})(\\d{2})(\\d{2})`,
            `$1 $2 $3 $4`,
            [
              `7(?:1[0-8]|2[1-9])`,
              `7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))`,
              `7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2`,
            ],
            `8 ($1)`,
            1,
          ],
          [
            `(\\d{5})(\\d)(\\d{2})(\\d{2})`,
            `$1 $2 $3 $4`,
            [
              `7(?:1[0-68]|2[1-9])`,
              `7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))`,
              `7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]`,
            ],
            `8 ($1)`,
            1,
          ],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `8 ($1)`, 1],
          [
            `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`,
            `$1 $2-$3-$4`,
            [`[349]|8(?:[02-7]|1[1-8])`],
            `8 ($1)`,
            1,
          ],
          [`(\\d{4})(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`8`], `8 ($1)`],
        ],
        `8`,
        0,
        0,
        0,
        0,
        `3[04-689]|[489]`,
        0,
        `8~10`,
      ],
      RW: [
        `250`,
        `00`,
        `(?:06|[27]\\d\\d|[89]00)\\d{6}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`0`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`2`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[7-9]`], `0$1`],
        ],
        `0`,
      ],
      SA: [
        `966`,
        `00`,
        `92\\d{7}|(?:[15]|8\\d)\\d{8}`,
        [9, 10],
        [
          [`(\\d{4})(\\d{5})`, `$1 $2`, [`9`]],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`5`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`81`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`]],
        ],
        `0`,
      ],
      SB: [
        `677`,
        `0[01]`,
        `(?:[1-6]|[7-9]\\d\\d)\\d{4}`,
        [5, 7],
        [[`(\\d{2})(\\d{5})`, `$1 $2`, [`7|8[4-9]|9(?:[1-8]|9[0-8])`]]],
      ],
      SC: [
        `248`,
        `010|0[0-2]`,
        `800\\d{4}|(?:[249]\\d|64)\\d{5}`,
        [7],
        [[`(\\d)(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[246]|9[57]`]]],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      SD: [
        `249`,
        `00`,
        `[19]\\d{8}`,
        [9],
        [[`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[19]`], `0$1`]],
        `0`,
      ],
      SE: [
        `46`,
        `00`,
        `(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}`,
        [6, 7, 8, 9, 10],
        [
          [`(\\d{2})(\\d{2,3})(\\d{2})`, `$1-$2 $3`, [`20`], `0$1`, 0, `$1 $2 $3`],
          [`(\\d{3})(\\d{4})`, `$1-$2`, [`9(?:00|39|44|9)`], `0$1`, 0, `$1 $2`],
          [
            `(\\d{2})(\\d{3})(\\d{2})`,
            `$1-$2 $3`,
            [`[12][136]|3[356]|4[0246]|6[03]|90[1-9]`],
            `0$1`,
            0,
            `$1 $2 $3`,
          ],
          [`(\\d)(\\d{2,3})(\\d{2})(\\d{2})`, `$1-$2 $3 $4`, [`8`], `0$1`, 0, `$1 $2 $3 $4`],
          [
            `(\\d{3})(\\d{2,3})(\\d{2})`,
            `$1-$2 $3`,
            [
              `1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])`,
            ],
            `0$1`,
            0,
            `$1 $2 $3`,
          ],
          [`(\\d{3})(\\d{2,3})(\\d{3})`, `$1-$2 $3`, [`9(?:00|39|44)`], `0$1`, 0, `$1 $2 $3`],
          [
            `(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})`,
            `$1-$2 $3 $4`,
            [`1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]`],
            `0$1`,
            0,
            `$1 $2 $3 $4`,
          ],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1-$2 $3 $4`, [`10|7`], `0$1`, 0, `$1 $2 $3 $4`],
          [`(\\d)(\\d{3})(\\d{3})(\\d{2})`, `$1-$2 $3 $4`, [`8`], `0$1`, 0, `$1 $2 $3 $4`],
          [
            `(\\d{3})(\\d{2})(\\d{2})(\\d{2})`,
            `$1-$2 $3 $4`,
            [`[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])`],
            `0$1`,
            0,
            `$1 $2 $3 $4`,
          ],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{3})`, `$1-$2 $3 $4`, [`9`], `0$1`, 0, `$1 $2 $3 $4`],
          [
            `(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})`,
            `$1-$2 $3 $4 $5`,
            [`[26]`],
            `0$1`,
            0,
            `$1 $2 $3 $4 $5`,
          ],
        ],
        `0`,
      ],
      SG: [
        `65`,
        `0[0-3]\\d`,
        `(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}`,
        [8, 10, 11],
        [
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[369]|8(?:0[1-8]|[1-9])`]],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`]],
          [`(\\d{4})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`7`]],
          [`(\\d{4})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`1`]],
        ],
      ],
      SH: [`290`, `00`, `(?:[256]\\d|8)\\d{3}`, [4, 5], 0, 0, 0, 0, 0, 0, `[256]`],
      SI: [
        `386`,
        `00|10(?:22|66|88|99)`,
        `[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}`,
        [5, 6, 7, 8],
        [
          [`(\\d{2})(\\d{3,6})`, `$1 $2`, [`8[09]|9`], `0$1`],
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`59|8`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[37][01]|4[0139]|51|6`], `0$1`],
          [`(\\d)(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[1-57]`], `(0$1)`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      SJ: [`47`, `00`, `0\\d{4}|(?:[489]\\d|79)\\d{6}`, [5, 8], 0, 0, 0, 0, 0, 0, `79`],
      SK: [
        `421`,
        `00`,
        `[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}`,
        [6, 7, 9],
        [
          [`(\\d)(\\d{2})(\\d{3,4})`, `$1 $2 $3`, [`21`], `0$1`],
          [`(\\d{2})(\\d{2})(\\d{2,3})`, `$1 $2 $3`, [`[3-5][1-8]1`, `[3-5][1-8]1[67]`], `0$1`],
          [`(\\d)(\\d{3})(\\d{3})(\\d{2})`, `$1/$2 $3 $4`, [`2`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[689]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1/$2 $3 $4`, [`[3-5]`], `0$1`],
        ],
        `0`,
      ],
      SL: [
        `232`,
        `00`,
        `(?:[237-9]\\d|66)\\d{6}`,
        [8],
        [[`(\\d{2})(\\d{6})`, `$1 $2`, [`[236-9]`], `(0$1)`]],
        `0`,
      ],
      SM: [
        `378`,
        `00`,
        `(?:0549|[5-7]\\d)\\d{6}`,
        [8, 10],
        [
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[5-7]`]],
          [`(\\d{4})(\\d{6})`, `$1 $2`, [`0`]],
        ],
        0,
        0,
        `([89]\\d{5})$`,
        `0549$1`,
      ],
      SN: [
        `221`,
        `00`,
        `(?:[378]\\d|93)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`]],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[379]`]],
        ],
      ],
      SO: [
        `252`,
        `00`,
        `[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}`,
        [6, 7, 8, 9],
        [
          [`(\\d{2})(\\d{4})`, `$1 $2`, [`8[125]`]],
          [`(\\d{6})`, `$1`, [`[134]`]],
          [`(\\d)(\\d{6})`, `$1 $2`, [`[15]|2[0-79]|3[0-46-8]|4[0-7]`]],
          [`(\\d)(\\d{7})`, `$1 $2`, [`(?:2|90)4|[67]`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[348]|64|79|90`]],
          [`(\\d{2})(\\d{5,7})`, `$1 $2`, [`1|28|6[0-35-9]|77|9[2-9]`]],
        ],
        `0`,
      ],
      SR: [
        `597`,
        `00`,
        `(?:[2-5]|68|[78]\\d)\\d{5}`,
        [6, 7],
        [
          [`(\\d{2})(\\d{2})(\\d{2})`, `$1-$2-$3`, [`56`]],
          [`(\\d{3})(\\d{3})`, `$1-$2`, [`[2-5]`]],
          [`(\\d{3})(\\d{4})`, `$1-$2`, [`[6-8]`]],
        ],
      ],
      SS: [
        `211`,
        `00`,
        `[19]\\d{8}`,
        [9],
        [[`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[19]`], `0$1`]],
        `0`,
      ],
      ST: [`239`, `00`, `(?:22|9\\d)\\d{5}`, [7], [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[29]`]]]],
      SV: [
        `503`,
        `00`,
        `[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?`,
        [7, 8, 11],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[89]`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[267]`]],
          [`(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[89]`]],
        ],
      ],
      SX: [
        `1`,
        `011`,
        `7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `(5\\d{6})$|1`,
        `721$1`,
        0,
        `721`,
      ],
      SY: [
        `963`,
        `00`,
        `[1-39]\\d{8}|[1-5]\\d{7}`,
        [8, 9],
        [
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[1-5]`], `0$1`, 1],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`], `0$1`, 1],
        ],
        `0`,
      ],
      SZ: [
        `268`,
        `00`,
        `0800\\d{4}|(?:[237]\\d|900)\\d{6}`,
        [8, 9],
        [
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[0237]`]],
          [`(\\d{5})(\\d{4})`, `$1 $2`, [`9`]],
        ],
      ],
      TA: [`290`, `00`, `8\\d{3}`, [4], 0, 0, 0, 0, 0, 0, `8`],
      TC: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|649|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-479]\\d{6})$|1`,
        `649$1`,
        0,
        `649`,
      ],
      TD: [
        `235`,
        `00|16`,
        `(?:22|[69]\\d|77)\\d{6}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[2679]`]]],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
      ],
      TG: [
        `228`,
        `00`,
        `[279]\\d{7}`,
        [8],
        [[`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[279]`]]],
      ],
      TH: [
        `66`,
        `00[1-9]`,
        `(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}`,
        [8, 9, 10, 13],
        [
          [`(\\d)(\\d{3})(\\d{4})`, `$1 $2 $3`, [`2`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[13-9]`], `0$1`],
          [`(\\d{4})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`1`]],
        ],
        `0`,
      ],
      TJ: [
        `992`,
        `810`,
        `[0-57-9]\\d{8}`,
        [9],
        [
          [`(\\d{6})(\\d)(\\d{2})`, `$1 $2 $3`, [`331`, `3317`]],
          [`(\\d{3})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`44[02-479]|[34]7`]],
          [`(\\d{4})(\\d)(\\d{4})`, `$1 $2 $3`, [`3[1-5]`]],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[0-57-9]`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `8~10`,
      ],
      TK: [`690`, `00`, `[2-47]\\d{3,6}`, [4, 5, 6, 7]],
      TL: [
        `670`,
        `00`,
        `7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}`,
        [7, 8],
        [
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[2-489]|70`]],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`7`]],
        ],
      ],
      TM: [
        `993`,
        `810`,
        `[1-6]\\d{7}`,
        [8],
        [
          [`(\\d{2})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`12`], `(8 $1)`],
          [`(\\d{3})(\\d)(\\d{2})(\\d{2})`, `$1 $2-$3-$4`, [`[1-5]`], `(8 $1)`],
          [`(\\d{2})(\\d{6})`, `$1 $2`, [`6`], `8 $1`],
        ],
        `8`,
        0,
        0,
        0,
        0,
        0,
        0,
        `8~10`,
      ],
      TN: [
        `216`,
        `00`,
        `[2-57-9]\\d{7}`,
        [8],
        [[`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-57-9]`]]],
      ],
      TO: [
        `676`,
        `00`,
        `(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}`,
        [5, 7],
        [
          [`(\\d{2})(\\d{3})`, `$1-$2`, [`[2-4]|50|6[09]|7[0-24-69]|8[05]`]],
          [`(\\d{4})(\\d{3})`, `$1 $2`, [`0`]],
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[5-9]`]],
        ],
      ],
      TR: [
        `90`,
        `00`,
        `4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}`,
        [7, 10, 12, 13],
        [
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`512|8[01589]|90`], `0$1`, 1],
          [
            `(\\d{3})(\\d{3})(\\d{2})(\\d{2})`,
            `$1 $2 $3 $4`,
            [`5(?:[0-59]|61)`, `5(?:[0-59]|61[06])`, `5(?:[0-59]|61[06]1)`],
            `0$1`,
            1,
          ],
          [`(\\d{3})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[24][1-8]|3[1-9]`], `(0$1)`, 1],
          [`(\\d{3})(\\d{3})(\\d{6,7})`, `$1 $2 $3`, [`80`], `0$1`, 1],
        ],
        `0`,
      ],
      TT: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-46-8]\\d{6})$|1`,
        `868$1`,
        0,
        `868`,
      ],
      TV: [
        `688`,
        `00`,
        `(?:2|7\\d\\d|90)\\d{4}`,
        [5, 6, 7],
        [
          [`(\\d{2})(\\d{3})`, `$1 $2`, [`2`]],
          [`(\\d{2})(\\d{4})`, `$1 $2`, [`90`]],
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`7`]],
        ],
      ],
      TW: [
        `886`,
        `0(?:0[25-79]|19)`,
        `[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}`,
        [7, 8, 9, 10, 11],
        [
          [`(\\d{2})(\\d)(\\d{4})`, `$1 $2 $3`, [`202`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[258]0`], `0$1`],
          [
            `(\\d)(\\d{3,4})(\\d{4})`,
            `$1 $2 $3`,
            [
              `[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]`,
              `[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]`,
            ],
            `0$1`,
          ],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[49]`], `0$1`],
          [`(\\d{2})(\\d{4})(\\d{4,5})`, `$1 $2 $3`, [`7`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        `#`,
      ],
      TZ: [
        `255`,
        `00[056]`,
        `(?:[25-8]\\d|41|90)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`[89]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[24]`], `0$1`],
          [`(\\d{2})(\\d{7})`, `$1 $2`, [`5`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[67]`], `0$1`],
        ],
        `0`,
      ],
      UA: [
        `380`,
        `00`,
        `[89]\\d{9}|[3-9]\\d{8}`,
        [9, 10],
        [
          [
            `(\\d{3})(\\d{3})(\\d{3})`,
            `$1 $2 $3`,
            [
              `6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]`,
              `6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]`,
            ],
            `0$1`,
          ],
          [
            `(\\d{4})(\\d{5})`,
            `$1 $2`,
            [
              `3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])`,
              `3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])`,
            ],
            `0$1`,
          ],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[3-7]|89|9[1-9]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[89]`], `0$1`],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        0,
        `0~0`,
      ],
      UG: [
        `256`,
        `00[057]`,
        `800\\d{6}|(?:[29]0|[347]\\d)\\d{7}`,
        [9],
        [
          [`(\\d{4})(\\d{5})`, `$1 $2`, [`202`, `2024`], `0$1`],
          [`(\\d{3})(\\d{6})`, `$1 $2`, [`[27-9]|4(?:6[45]|[7-9])`], `0$1`],
          [`(\\d{2})(\\d{7})`, `$1 $2`, [`[34]`], `0$1`],
        ],
        `0`,
      ],
      US: [
        `1`,
        `011`,
        `[2-9]\\d{9}|3\\d{6}`,
        [10],
        [
          [`(\\d{3})(\\d{4})`, `$1-$2`, [`310`], 0, 1],
          [`(\\d{3})(\\d{3})(\\d{4})`, `($1) $2-$3`, [`[2-9]`], 0, 1, `$1-$2-$3`],
        ],
        `1`,
        0,
        0,
        0,
        0,
        0,
        [
          [
            `(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}`,
          ],
          [``],
          [`8(?:00|33|44|55|66|77|88)[2-9]\\d{6}`],
          [`900[2-9]\\d{6}`],
          [
            `52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}`,
          ],
        ],
      ],
      UY: [
        `598`,
        `0(?:0|1[3-9]\\d)`,
        `0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}`,
        [6, 7, 8, 9, 10, 11, 12, 13],
        [
          [`(\\d{3})(\\d{3,4})`, `$1 $2`, [`0`]],
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`[49]0|8`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`9`], `0$1`],
          [`(\\d{4})(\\d{4})`, `$1 $2`, [`[124]`]],
          [`(\\d{3})(\\d{3})(\\d{2,4})`, `$1 $2 $3`, [`0`]],
          [`(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})`, `$1 $2 $3 $4`, [`0`]],
        ],
        `0`,
        0,
        0,
        0,
        0,
        0,
        0,
        `00`,
        ` int. `,
      ],
      UZ: [
        `998`,
        `810`,
        `(?:20|33|[5-79]\\d|88)\\d{7}`,
        [9],
        [[`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`[235-9]`], `8 $1`]],
        `8`,
        0,
        0,
        0,
        0,
        0,
        0,
        `8~10`,
      ],
      VA: [
        `39`,
        `00`,
        `0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}`,
        [6, 7, 8, 9, 10, 11],
        0,
        0,
        0,
        0,
        0,
        0,
        `06698`,
      ],
      VC: [
        `1`,
        `011`,
        `(?:[58]\\d\\d|784|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-7]\\d{6})$|1`,
        `784$1`,
        0,
        `784`,
      ],
      VE: [
        `58`,
        `00`,
        `[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}`,
        [10],
        [[`(\\d{3})(\\d{7})`, `$1-$2`, [`[24-689]`], `0$1`]],
        `0`,
      ],
      VG: [
        `1`,
        `011`,
        `(?:284|[58]\\d\\d|900)\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-578]\\d{6})$|1`,
        `284$1`,
        0,
        `284`,
      ],
      VI: [
        `1`,
        `011`,
        `[58]\\d{9}|(?:34|90)0\\d{7}`,
        [10],
        0,
        `1`,
        0,
        `([2-9]\\d{6})$|1`,
        `340$1`,
        0,
        `340`,
      ],
      VN: [
        `84`,
        `00`,
        `[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}`,
        [7, 8, 9, 10],
        [
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`80`], `0$1`, 1],
          [`(\\d{4})(\\d{4,6})`, `$1 $2`, [`1`], 0, 1],
          [`(\\d{2})(\\d{3})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`6`], `0$1`, 1],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[357-9]`], `0$1`, 1],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`2[48]`], `0$1`, 1],
          [`(\\d{3})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`2`], `0$1`, 1],
        ],
        `0`,
      ],
      VU: [
        `678`,
        `00`,
        `[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}`,
        [5, 7],
        [[`(\\d{3})(\\d{4})`, `$1 $2`, [`[57-9]`]]],
      ],
      WF: [
        `681`,
        `00`,
        `(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?`,
        [6, 9],
        [
          [`(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3`, [`[478]`]],
          [`(\\d{3})(\\d{2})(\\d{2})(\\d{2})`, `$1 $2 $3 $4`, [`8`]],
        ],
      ],
      WS: [
        `685`,
        `0`,
        `(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}`,
        [5, 6, 7, 10],
        [
          [`(\\d{5})`, `$1`, [`[2-5]|6[1-9]`]],
          [`(\\d{3})(\\d{3,7})`, `$1 $2`, [`[68]`]],
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`7`]],
        ],
      ],
      XK: [
        `383`,
        `00`,
        `[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}`,
        [8, 9],
        [
          [`(\\d{3})(\\d{5})`, `$1 $2`, [`[89]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[2-4]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[23]`], `0$1`],
        ],
        `0`,
      ],
      YE: [
        `967`,
        `00`,
        `(?:1|7\\d)\\d{7}|[1-7]\\d{6}`,
        [7, 8, 9],
        [
          [`(\\d)(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`[1-6]|7(?:[24-6]|8[0-7])`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`7`], `0$1`],
        ],
        `0`,
      ],
      YT: [
        `262`,
        `00`,
        `(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}`,
        [9],
        0,
        `0`,
        0,
        0,
        0,
        0,
        0,
        [
          [`269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}`],
          [`639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}`],
          [`80\\d{7}`],
          0,
          0,
          0,
          0,
          0,
          [`9(?:(?:39|47)8[01]|769\\d)\\d{4}`],
        ],
      ],
      ZA: [
        `27`,
        `00`,
        `[1-79]\\d{8}|8\\d{4,9}`,
        [5, 6, 7, 8, 9, 10],
        [
          [`(\\d{2})(\\d{3,4})`, `$1 $2`, [`8[1-4]`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{2,3})`, `$1 $2 $3`, [`8[1-4]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`860`], `0$1`],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`[1-9]`], `0$1`],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`8`], `0$1`],
        ],
        `0`,
      ],
      ZM: [
        `260`,
        `00`,
        `800\\d{6}|(?:21|63|[79]\\d)\\d{7}`,
        [9],
        [
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[28]`], `0$1`],
          [`(\\d{2})(\\d{7})`, `$1 $2`, [`[79]`], `0$1`],
        ],
        `0`,
      ],
      ZW: [
        `263`,
        `00`,
        `2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}`,
        [5, 6, 7, 8, 9, 10],
        [
          [
            `(\\d{3})(\\d{3,5})`,
            `$1 $2`,
            [
              `2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]`,
            ],
            `0$1`,
          ],
          [`(\\d)(\\d{3})(\\d{2,4})`, `$1 $2 $3`, [`[49]`], `0$1`],
          [`(\\d{3})(\\d{4})`, `$1 $2`, [`80`], `0$1`],
          [
            `(\\d{2})(\\d{7})`,
            `$1 $2`,
            [
              `24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2`,
              `2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]`,
            ],
            `(0$1)`,
          ],
          [`(\\d{2})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`7`], `0$1`],
          [
            `(\\d{3})(\\d{3})(\\d{3,4})`,
            `$1 $2 $3`,
            [
              `2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)`,
              `2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)`,
            ],
            `0$1`,
          ],
          [`(\\d{4})(\\d{6})`, `$1 $2`, [`8`], `0$1`],
          [
            `(\\d{2})(\\d{3,5})`,
            `$1 $2`,
            [
              `1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]`,
            ],
            `0$1`,
          ],
          [`(\\d{2})(\\d{3})(\\d{3,4})`, `$1 $2 $3`, [`29[013-9]|39|54`], `0$1`],
          [`(\\d{4})(\\d{3,5})`, `$1 $2`, [`(?:25|54)8`, `258|5483`], `0$1`],
        ],
        `0`,
      ],
    },
    nonGeographic: {
      800: [
        `800`,
        0,
        `(?:00|[1-9]\\d)\\d{6}`,
        [8],
        [[`(\\d{4})(\\d{4})`, `$1 $2`, [`\\d`]]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, [`(?:00|[1-9]\\d)\\d{6}`]],
      ],
      808: [
        `808`,
        0,
        `[1-9]\\d{7}`,
        [8],
        [[`(\\d{4})(\\d{4})`, `$1 $2`, [`[1-9]`]]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, 0, 0, 0, 0, 0, 0, [`[1-9]\\d{7}`]],
      ],
      870: [
        `870`,
        0,
        `7\\d{11}|[35-7]\\d{8}`,
        [9, 12],
        [[`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`[35-7]`]]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, [`(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}`]],
      ],
      878: [
        `878`,
        0,
        `10\\d{10}`,
        [12],
        [[`(\\d{2})(\\d{5})(\\d{5})`, `$1 $2 $3`, [`1`]]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, 0, 0, 0, 0, 0, [`10\\d{10}`]],
      ],
      881: [
        `881`,
        0,
        `6\\d{9}|[0-36-9]\\d{8}`,
        [9, 10],
        [
          [`(\\d)(\\d{3})(\\d{5})`, `$1 $2 $3`, [`[0-37-9]`]],
          [`(\\d)(\\d{3})(\\d{5,6})`, `$1 $2 $3`, [`6`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, [`6\\d{9}|[0-36-9]\\d{8}`]],
      ],
      882: [
        `882`,
        0,
        `[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?`,
        [7, 8, 9, 10, 11, 12],
        [
          [`(\\d{2})(\\d{5})`, `$1 $2`, [`16|342`]],
          [`(\\d{2})(\\d{6})`, `$1 $2`, [`49`]],
          [`(\\d{2})(\\d{2})(\\d{4})`, `$1 $2 $3`, [`1[36]|9`]],
          [`(\\d{2})(\\d{4})(\\d{3})`, `$1 $2 $3`, [`3[23]`]],
          [`(\\d{2})(\\d{3,4})(\\d{4})`, `$1 $2 $3`, [`16`]],
          [`(\\d{2})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`10|23|3(?:[15]|4[57])|4|51`]],
          [`(\\d{3})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`34`]],
          [`(\\d{2})(\\d{4,5})(\\d{5})`, `$1 $2 $3`, [`[1-35]`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        [
          0,
          [`342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}`, [7, 8, 9, 10, 12]],
          0,
          0,
          0,
          0,
          0,
          0,
          [
            `1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}`,
          ],
        ],
      ],
      883: [
        `883`,
        0,
        `(?:[1-4]\\d|51)\\d{6,10}`,
        [8, 9, 10, 11, 12],
        [
          [`(\\d{3})(\\d{3})(\\d{2,8})`, `$1 $2 $3`, [`[14]|2[24-689]|3[02-689]|51[24-9]`]],
          [`(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3`, [`510`]],
          [`(\\d{3})(\\d{3})(\\d{4})`, `$1 $2 $3`, [`21`]],
          [`(\\d{4})(\\d{4})(\\d{4})`, `$1 $2 $3`, [`51[13]`]],
          [`(\\d{3})(\\d{3})(\\d{3})(\\d{3})`, `$1 $2 $3 $4`, [`[235]`]],
        ],
        0,
        0,
        0,
        0,
        0,
        0,
        [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          [
            `(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}`,
          ],
        ],
      ],
      888: [
        `888`,
        0,
        `\\d{11}`,
        [11],
        [[`(\\d{3})(\\d{3})(\\d{5})`, `$1 $2 $3`]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, 0, 0, 0, [`\\d{11}`]],
      ],
      979: [
        `979`,
        0,
        `[1359]\\d{8}`,
        [9],
        [[`(\\d)(\\d{4})(\\d{4})`, `$1 $2 $3`, [`[1359]`]]],
        0,
        0,
        0,
        0,
        0,
        0,
        [0, 0, 0, [`[1359]\\d{8}`]],
      ],
    },
  };
function Zfe(e, t) {
  var n = Array.prototype.slice.call(t);
  return (n.push(Xfe), e.apply(this, n));
}
function Q5(e) {
  "@babel/helpers - typeof";

  return (
    (Q5 =
      typeof Symbol == `function` && typeof Symbol.iterator == `symbol`
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == `function` &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? `symbol`
              : typeof e;
          }),
    Q5(e)
  );
}
function $5(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    ((r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      `value` in r && (r.writable = !0),
      Object.defineProperty(e, r.key, r));
  }
}
function Qfe(e, t, n) {
  return (
    t && $5(e.prototype, t),
    n && $5(e, n),
    Object.defineProperty(e, "prototype", {
      writable: !1,
    }),
    e
  );
}
function $fe(e, t) {
  if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
}
function epe(e, t) {
  if (typeof t != `function` && t !== null)
    throw TypeError(`Super expression must either be null or a function`);
  ((e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0,
    },
  })),
    Object.defineProperty(e, "prototype", {
      writable: !1,
    }),
    t && i7(e, t));
}
function tpe(e) {
  var t = r7();
  return function () {
    var n = a7(e),
      r;
    if (t) {
      var i = a7(this).constructor;
      r = Reflect.construct(n, arguments, i);
    } else r = n.apply(this, arguments);
    return npe(this, r);
  };
}
function npe(e, t) {
  if (t && (Q5(t) === `object` || typeof t == `function`)) return t;
  if (t !== void 0) throw TypeError(`Derived constructors may only return object or undefined`);
  return e7(e);
}
function e7(e) {
  if (e === void 0)
    throw ReferenceError(`this hasn't been initialised - super() hasn't been called`);
  return e;
}
function t7(e) {
  var t = typeof Map == `function` ? new Map() : void 0;
  return (
    (t7 = function (e) {
      if (e === null || !rpe(e)) return e;
      if (typeof e != `function`)
        throw TypeError(`Super expression must either be null or a function`);
      if (typeof t < `u`) {
        if (t.has(e)) return t.get(e);
        t.set(e, n);
      }
      function n() {
        return n7(e, arguments, a7(this).constructor);
      }
      return (
        (n.prototype = Object.create(e.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
        i7(n, e)
      );
    }),
    t7(e)
  );
}
function n7(e, t, n) {
  return (
    (n7 = r7()
      ? Reflect.construct
      : function (e, t, n) {
          var r = [null];
          r.push.apply(r, t);
          var i = new (Function.bind.apply(e, r))();
          return (n && i7(i, n.prototype), i);
        }),
    n7.apply(null, arguments)
  );
}
function r7() {
  if (typeof Reflect > `u` || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == `function`) return !0;
  try {
    return (Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0);
  } catch {
    return !1;
  }
}
function rpe(e) {
  return Function.toString.call(e).indexOf(`[native code]`) !== -1;
}
function i7(e, t) {
  return (
    (i7 =
      Object.setPrototypeOf ||
      function (e, t) {
        return ((e.__proto__ = t), e);
      }),
    i7(e, t)
  );
}
function a7(e) {
  return (
    (a7 = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }),
    a7(e)
  );
}
var o7 = (function (e) {
    epe(n, e);
    var t = tpe(n);
    function n(e) {
      var r;
      return (
        $fe(this, n),
        (r = t.call(this, e)),
        Object.setPrototypeOf(e7(r), n.prototype),
        (r.name = r.constructor.name),
        r
      );
    }
    return Qfe(n);
  })(t7(Error)),
  s7 = 2,
  ipe = 17,
  ape = 3,
  c7 = `0-9０-９٠-٩۰-۹`,
  l7 = `-‐-―−ー－／/．. \xA0­​⁠　()（）［］\\[\\]~⁓∼～`,
  u7 = `+＋`;
function d7(e, t) {
  ((e = e.split(`-`)), (t = t.split(`-`)));
  for (var n = e[0].split(`.`), r = t[0].split(`.`), i = 0; i < 3; i++) {
    var a = Number(n[i]),
      o = Number(r[i]);
    if (a > o) return 1;
    if (o > a) return -1;
    if (!isNaN(a) && isNaN(o)) return 1;
    if (isNaN(a) && !isNaN(o)) return -1;
  }
  return e[1] && t[1]
    ? e[1] > t[1]
      ? 1
      : e[1] < t[1]
        ? -1
        : 0
    : !e[1] && t[1]
      ? 1
      : e[1] && !t[1]
        ? -1
        : 0;
}
var ope = {}.constructor;
function f7(e) {
  return e != null && e.constructor === ope;
}
function p7(e) {
  "@babel/helpers - typeof";

  return (
    (p7 =
      typeof Symbol == `function` && typeof Symbol.iterator == `symbol`
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == `function` &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? `symbol`
              : typeof e;
          }),
    p7(e)
  );
}
function m7(e, t) {
  if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
}
function h7(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    ((r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      `value` in r && (r.writable = !0),
      Object.defineProperty(e, r.key, r));
  }
}
function g7(e, t, n) {
  return (
    t && h7(e.prototype, t),
    n && h7(e, n),
    Object.defineProperty(e, "prototype", {
      writable: !1,
    }),
    e
  );
}
var spe = `1.2.0`,
  cpe = `1.7.35`,
  _7 = ` ext. `,
  lpe = /^\d+$/,
  v7 = (function () {
    function e(t) {
      (m7(this, e), ppe(t), (this.metadata = t), S7.call(this, t));
    }
    return (
      g7(e, [
        {
          key: `getCountries`,
          value: function () {
            return Object.keys(this.metadata.countries).filter(function (e) {
              return e !== `001`;
            });
          },
        },
        {
          key: `getCountryMetadata`,
          value: function (e) {
            return this.metadata.countries[e];
          },
        },
        {
          key: `nonGeographic`,
          value: function () {
            if (!(this.v1 || this.v2 || this.v3))
              return this.metadata.nonGeographic || this.metadata.nonGeographical;
          },
        },
        {
          key: `hasCountry`,
          value: function (e) {
            return this.getCountryMetadata(e) !== void 0;
          },
        },
        {
          key: `hasCallingCode`,
          value: function (e) {
            if (this.getCountryCodesForCallingCode(e)) return !0;
            if (this.nonGeographic()) {
              if (this.nonGeographic()[e]) return !0;
            } else {
              var t = this.countryCallingCodes()[e];
              if (t && t.length === 1 && t[0] === `001`) return !0;
            }
          },
        },
        {
          key: `isNonGeographicCallingCode`,
          value: function (e) {
            return this.nonGeographic()
              ? !!this.nonGeographic()[e]
              : !this.getCountryCodesForCallingCode(e);
          },
        },
        {
          key: `country`,
          value: function (e) {
            return this.selectNumberingPlan(e);
          },
        },
        {
          key: `selectNumberingPlan`,
          value: function (e, t) {
            if ((e && lpe.test(e) && ((t = e), (e = null)), e && e !== `001`)) {
              if (!this.hasCountry(e)) throw Error(`Unknown country: ${e}`);
              this.numberingPlan = new y7(this.getCountryMetadata(e), this);
            } else if (t) {
              if (!this.hasCallingCode(t)) throw Error(`Unknown calling code: ${t}`);
              this.numberingPlan = new y7(this.getNumberingPlanMetadata(t), this);
            } else this.numberingPlan = void 0;
            return this;
          },
        },
        {
          key: `getCountryCodesForCallingCode`,
          value: function (e) {
            var t = this.countryCallingCodes()[e];
            if (t) return t.length === 1 && t[0].length === 3 ? void 0 : t;
          },
        },
        {
          key: `getCountryCodeForCallingCode`,
          value: function (e) {
            var t = this.getCountryCodesForCallingCode(e);
            if (t) return t[0];
          },
        },
        {
          key: `getNumberingPlanMetadata`,
          value: function (e) {
            var t = this.getCountryCodeForCallingCode(e);
            if (t) return this.getCountryMetadata(t);
            if (this.nonGeographic()) {
              var n = this.nonGeographic()[e];
              if (n) return n;
            } else {
              var r = this.countryCallingCodes()[e];
              if (r && r.length === 1 && r[0] === `001`) return this.metadata.countries[`001`];
            }
          },
        },
        {
          key: `countryCallingCode`,
          value: function () {
            return this.numberingPlan.callingCode();
          },
        },
        {
          key: `IDDPrefix`,
          value: function () {
            return this.numberingPlan.IDDPrefix();
          },
        },
        {
          key: `defaultIDDPrefix`,
          value: function () {
            return this.numberingPlan.defaultIDDPrefix();
          },
        },
        {
          key: `nationalNumberPattern`,
          value: function () {
            return this.numberingPlan.nationalNumberPattern();
          },
        },
        {
          key: `possibleLengths`,
          value: function () {
            return this.numberingPlan.possibleLengths();
          },
        },
        {
          key: `formats`,
          value: function () {
            return this.numberingPlan.formats();
          },
        },
        {
          key: `nationalPrefixForParsing`,
          value: function () {
            return this.numberingPlan.nationalPrefixForParsing();
          },
        },
        {
          key: `nationalPrefixTransformRule`,
          value: function () {
            return this.numberingPlan.nationalPrefixTransformRule();
          },
        },
        {
          key: `leadingDigits`,
          value: function () {
            return this.numberingPlan.leadingDigits();
          },
        },
        {
          key: `hasTypes`,
          value: function () {
            return this.numberingPlan.hasTypes();
          },
        },
        {
          key: `type`,
          value: function (e) {
            return this.numberingPlan.type(e);
          },
        },
        {
          key: `ext`,
          value: function () {
            return this.numberingPlan.ext();
          },
        },
        {
          key: `countryCallingCodes`,
          value: function () {
            return this.v1
              ? this.metadata.country_phone_code_to_countries
              : this.metadata.country_calling_codes;
          },
        },
        {
          key: `chooseCountryByCountryCallingCode`,
          value: function (e) {
            return this.selectNumberingPlan(e);
          },
        },
        {
          key: `hasSelectedNumberingPlan`,
          value: function () {
            return this.numberingPlan !== void 0;
          },
        },
      ]),
      e
    );
  })(),
  y7 = (function () {
    function e(t, n) {
      (m7(this, e),
        (this.globalMetadataObject = n),
        (this.metadata = t),
        S7.call(this, n.metadata));
    }
    return (
      g7(e, [
        {
          key: `callingCode`,
          value: function () {
            return this.metadata[0];
          },
        },
        {
          key: `getDefaultCountryMetadataForRegion`,
          value: function () {
            return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
          },
        },
        {
          key: `IDDPrefix`,
          value: function () {
            if (!(this.v1 || this.v2)) return this.metadata[1];
          },
        },
        {
          key: `defaultIDDPrefix`,
          value: function () {
            if (!(this.v1 || this.v2)) return this.metadata[12];
          },
        },
        {
          key: `nationalNumberPattern`,
          value: function () {
            return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
          },
        },
        {
          key: `possibleLengths`,
          value: function () {
            if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
          },
        },
        {
          key: `_getFormats`,
          value: function (e) {
            return e[this.v1 ? 2 : this.v2 ? 3 : 4];
          },
        },
        {
          key: `formats`,
          value: function () {
            var e = this;
            return (
              this._getFormats(this.metadata) ||
              this._getFormats(this.getDefaultCountryMetadataForRegion()) ||
              []
            ).map(function (t) {
              return new upe(t, e);
            });
          },
        },
        {
          key: `nationalPrefix`,
          value: function () {
            return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
          },
        },
        {
          key: `_getNationalPrefixFormattingRule`,
          value: function (e) {
            return e[this.v1 ? 4 : this.v2 ? 5 : 6];
          },
        },
        {
          key: `nationalPrefixFormattingRule`,
          value: function () {
            return (
              this._getNationalPrefixFormattingRule(this.metadata) ||
              this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion())
            );
          },
        },
        {
          key: `_nationalPrefixForParsing`,
          value: function () {
            return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
          },
        },
        {
          key: `nationalPrefixForParsing`,
          value: function () {
            return this._nationalPrefixForParsing() || this.nationalPrefix();
          },
        },
        {
          key: `nationalPrefixTransformRule`,
          value: function () {
            return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
          },
        },
        {
          key: `_getNationalPrefixIsOptionalWhenFormatting`,
          value: function () {
            return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
          },
        },
        {
          key: `nationalPrefixIsOptionalWhenFormattingInNationalFormat`,
          value: function () {
            return (
              this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) ||
              this._getNationalPrefixIsOptionalWhenFormatting(
                this.getDefaultCountryMetadataForRegion(),
              )
            );
          },
        },
        {
          key: `leadingDigits`,
          value: function () {
            return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
          },
        },
        {
          key: `types`,
          value: function () {
            return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
          },
        },
        {
          key: `hasTypes`,
          value: function () {
            return this.types() && this.types().length === 0 ? !1 : !!this.types();
          },
        },
        {
          key: `type`,
          value: function (e) {
            if (this.hasTypes() && b7(this.types(), e)) return new fpe(b7(this.types(), e), this);
          },
        },
        {
          key: `ext`,
          value: function () {
            return this.v1 || this.v2 ? _7 : this.metadata[13] || _7;
          },
        },
      ]),
      e
    );
  })(),
  upe = (function () {
    function e(t, n) {
      (m7(this, e), (this._format = t), (this.metadata = n));
    }
    return (
      g7(e, [
        {
          key: `pattern`,
          value: function () {
            return this._format[0];
          },
        },
        {
          key: `format`,
          value: function () {
            return this._format[1];
          },
        },
        {
          key: `leadingDigitsPatterns`,
          value: function () {
            return this._format[2] || [];
          },
        },
        {
          key: `nationalPrefixFormattingRule`,
          value: function () {
            return this._format[3] || this.metadata.nationalPrefixFormattingRule();
          },
        },
        {
          key: `nationalPrefixIsOptionalWhenFormattingInNationalFormat`,
          value: function () {
            return (
              !!this._format[4] ||
              this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat()
            );
          },
        },
        {
          key: `nationalPrefixIsMandatoryWhenFormattingInNationalFormat`,
          value: function () {
            return (
              this.usesNationalPrefix() &&
              !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat()
            );
          },
        },
        {
          key: `usesNationalPrefix`,
          value: function () {
            return !!(
              this.nationalPrefixFormattingRule() && !dpe.test(this.nationalPrefixFormattingRule())
            );
          },
        },
        {
          key: `internationalFormat`,
          value: function () {
            return this._format[5] || this.format();
          },
        },
      ]),
      e
    );
  })(),
  dpe = /^\(?\$1\)?$/,
  fpe = (function () {
    function e(t, n) {
      (m7(this, e), (this.type = t), (this.metadata = n));
    }
    return (
      g7(e, [
        {
          key: `pattern`,
          value: function () {
            return this.metadata.v1 ? this.type : this.type[0];
          },
        },
        {
          key: `possibleLengths`,
          value: function () {
            if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
          },
        },
      ]),
      e
    );
  })();
function b7(e, t) {
  switch (t) {
    case `FIXED_LINE`:
      return e[0];
    case `MOBILE`:
      return e[1];
    case `TOLL_FREE`:
      return e[2];
    case `PREMIUM_RATE`:
      return e[3];
    case `PERSONAL_NUMBER`:
      return e[4];
    case `VOICEMAIL`:
      return e[5];
    case `UAN`:
      return e[6];
    case `PAGER`:
      return e[7];
    case `VOIP`:
      return e[8];
    case `SHARED_COST`:
      return e[9];
  }
}
function ppe(e) {
  if (!e) throw Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!f7(e) || !f7(e.countries))
    throw Error(
      `[libphonenumber-js] \`metadata\` argument was passed but it's not a valid metadata. Must be an object having \`.countries\` child object property. Got ${f7(e) ? `an object of shape: { ` + Object.keys(e).join(`, `) + ` }` : `a ` + mpe(e) + `: ` + e}.`,
    );
}
var mpe = function (e) {
  return p7(e);
};
function x7(e, t) {
  if (((t = new v7(t)), t.hasCountry(e))) return t.country(e).countryCallingCode();
  throw Error(`Unknown country: ${e}`);
}
function hpe(e, t) {
  return t.countries.hasOwnProperty(e);
}
function S7(e) {
  var t = e.version;
  typeof t == `number`
    ? ((this.v1 = t === 1), (this.v2 = t === 2), (this.v3 = t === 3), (this.v4 = t === 4))
    : t
      ? d7(t, spe) === -1
        ? (this.v2 = !0)
        : d7(t, cpe) === -1
          ? (this.v3 = !0)
          : (this.v4 = !0)
      : (this.v1 = !0);
}
var gpe = `;ext=`,
  C7 = function (e) {
    return `([${c7}]{1,${e}})`;
  };
function w7(e) {
  var t = `20`,
    n = `15`,
    r = `9`,
    i = `6`,
    a = `[ \xA0\\t,]*`,
    o = `[:\\.．]?[ \xA0\\t,-]*`,
    s = `#?`,
    c = `(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)`,
    l = `(?:[xｘ#＃~～]|int|ｉｎｔ)`,
    u = `[- ]+`,
    d = `[ \xA0\\t]*`,
    f = `(?:,{2}|;)`,
    p = gpe + C7(t),
    m = a + c + o + C7(t) + s,
    h = a + l + o + C7(r) + s,
    g = u + C7(i) + `#`,
    v = d + f + o + C7(n) + s,
    y = d + `(?:,)+` + o + C7(r) + s;
  return p + `|` + m + `|` + h + `|` + g + `|` + v + `|` + y;
}
var _pe = `[` + c7 + `]{` + s7 + `}`,
  vpe = `[` + u7 + `]{0,1}(?:[` + l7 + `]*[` + c7 + `]){3,}[` + l7 + c7 + `]*`,
  ype = RegExp(`^[` + u7 + `]{0,1}(?:[` + l7 + `]*[` + c7 + `]){1,2}$`, `i`),
  bpe = vpe + `(?:` + w7() + `)?`,
  xpe = RegExp(`^` + _pe + `$|^` + bpe + `$`, `i`);
function Spe(e) {
  return e.length >= s7 && xpe.test(e);
}
function Cpe(e) {
  return ype.test(e);
}
var T7 = RegExp(`(?:` + w7() + `)$`, `i`);
function wpe(e) {
  var t = e.search(T7);
  if (t < 0) return {};
  for (var n = e.slice(0, t), r = e.match(T7), i = 1; i < r.length;) {
    if (r[i])
      return {
        number: n,
        ext: r[i],
      };
    i++;
  }
}
var Tpe = {
  0: `0`,
  1: `1`,
  2: `2`,
  3: `3`,
  4: `4`,
  5: `5`,
  6: `6`,
  7: `7`,
  8: `8`,
  9: `9`,
  "０": `0`,
  "１": `1`,
  "２": `2`,
  "３": `3`,
  "４": `4`,
  "５": `5`,
  "６": `6`,
  "７": `7`,
  "８": `8`,
  "９": `9`,
  "٠": `0`,
  "١": `1`,
  "٢": `2`,
  "٣": `3`,
  "٤": `4`,
  "٥": `5`,
  "٦": `6`,
  "٧": `7`,
  "٨": `8`,
  "٩": `9`,
  "۰": `0`,
  "۱": `1`,
  "۲": `2`,
  "۳": `3`,
  "۴": `4`,
  "۵": `5`,
  "۶": `6`,
  "۷": `7`,
  "۸": `8`,
  "۹": `9`,
};
function Epe(e) {
  return Tpe[e];
}
function Dpe(e, t) {
  var n = (typeof Symbol < `u` && e[Symbol.iterator]) || e[`@@iterator`];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Ope(e)) || (t && e && typeof e.length == `number`)) {
    n && (e = n);
    var r = 0;
    return function () {
      return r >= e.length
        ? {
            done: !0,
          }
        : {
            done: !1,
            value: e[r++],
          };
    };
  }
  throw TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ope(e, t) {
  if (e) {
    if (typeof e == `string`) return E7(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if ((n === `Object` && e.constructor && (n = e.constructor.name), n === `Map` || n === `Set`))
      return Array.from(e);
    if (n === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return E7(e, t);
  }
}
function E7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function D7(e) {
  for (var t = ``, n = Dpe(e.split(``)), r; !(r = n()).done;) {
    var i = r.value;
    t += kpe(i, t) || ``;
  }
  return t;
}
function kpe(e, t) {
  return e === `+` ? (t ? void 0 : `+`) : Epe(e);
}
function Ape(e, t) {
  var n = (typeof Symbol < `u` && e[Symbol.iterator]) || e[`@@iterator`];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = jpe(e)) || (t && e && typeof e.length == `number`)) {
    n && (e = n);
    var r = 0;
    return function () {
      return r >= e.length
        ? {
            done: !0,
          }
        : {
            done: !1,
            value: e[r++],
          };
    };
  }
  throw TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jpe(e, t) {
  if (e) {
    if (typeof e == `string`) return O7(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if ((n === `Object` && e.constructor && (n = e.constructor.name), n === `Map` || n === `Set`))
      return Array.from(e);
    if (n === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return O7(e, t);
  }
}
function O7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Mpe(e, t) {
  for (var n = e.slice(), r = Ape(t), i; !(i = r()).done;) {
    var a = i.value;
    e.indexOf(a) < 0 && n.push(a);
  }
  return n.sort(function (e, t) {
    return e - t;
  });
}
function k7(e, t) {
  return A7(e, void 0, t);
}
function A7(e, t, n) {
  var r = n.type(t),
    i = (r && r.possibleLengths()) || n.possibleLengths();
  if (!i) return `IS_POSSIBLE`;
  if (t === `FIXED_LINE_OR_MOBILE`) {
    if (!n.type(`FIXED_LINE`)) return A7(e, `MOBILE`, n);
    var a = n.type(`MOBILE`);
    a && (i = Mpe(i, a.possibleLengths()));
  } else if (t && !r) return `INVALID_LENGTH`;
  var o = e.length,
    s = i[0];
  return s === o
    ? `IS_POSSIBLE`
    : s > o
      ? `TOO_SHORT`
      : i[i.length - 1] < o
        ? `TOO_LONG`
        : i.indexOf(o, 1) >= 0
          ? `IS_POSSIBLE`
          : `INVALID_LENGTH`;
}
function Npe(e, t, n) {
  if ((t === void 0 && (t = {}), (n = new v7(n)), t.v2)) {
    if (!e.countryCallingCode) throw Error(`Invalid phone number object passed`);
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone) return !1;
    if (e.country) {
      if (!n.hasCountry(e.country)) throw Error(`Unknown country: ${e.country}`);
      n.country(e.country);
    } else {
      if (!e.countryCallingCode) throw Error(`Invalid phone number object passed`);
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths()) return j7(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode)) return !0;
  throw Error(
    `Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.`,
  );
}
function j7(e, t) {
  switch (k7(e, t)) {
    case `IS_POSSIBLE`:
      return !0;
    default:
      return !1;
  }
}
function M7(e, t) {
  return ((e ||= ``), RegExp(`^(?:` + t + `)$`).test(e));
}
function Ppe(e, t) {
  var n = (typeof Symbol < `u` && e[Symbol.iterator]) || e[`@@iterator`];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Fpe(e)) || (t && e && typeof e.length == `number`)) {
    n && (e = n);
    var r = 0;
    return function () {
      return r >= e.length
        ? {
            done: !0,
          }
        : {
            done: !1,
            value: e[r++],
          };
    };
  }
  throw TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fpe(e, t) {
  if (e) {
    if (typeof e == `string`) return N7(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if ((n === `Object` && e.constructor && (n = e.constructor.name), n === `Map` || n === `Set`))
      return Array.from(e);
    if (n === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return N7(e, t);
  }
}
function N7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Ipe = [
  `MOBILE`,
  `PREMIUM_RATE`,
  `TOLL_FREE`,
  `SHARED_COST`,
  `VOIP`,
  `PERSONAL_NUMBER`,
  `PAGER`,
  `UAN`,
  `VOICEMAIL`,
];
function P7(e, t, n) {
  if (((t ||= {}), !(!e.country && !e.countryCallingCode))) {
    ((n = new v7(n)), n.selectNumberingPlan(e.country, e.countryCallingCode));
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (M7(r, n.nationalNumberPattern())) {
      if (F7(r, `FIXED_LINE`, n))
        return (n.type(`MOBILE`) && n.type(`MOBILE`).pattern() === ``) ||
          !n.type(`MOBILE`) ||
          F7(r, `MOBILE`, n)
          ? `FIXED_LINE_OR_MOBILE`
          : `FIXED_LINE`;
      for (var i = Ppe(Ipe), a; !(a = i()).done;) {
        var o = a.value;
        if (F7(r, o, n)) return o;
      }
    }
  }
}
function F7(e, t, n) {
  return (
    (t = n.type(t)),
    !t || !t.pattern() || (t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0)
      ? !1
      : M7(e, t.pattern())
  );
}
function Lpe(e, t, n) {
  return (
    (t ||= {}),
    (n = new v7(n)),
    n.selectNumberingPlan(e.country, e.countryCallingCode),
    n.hasTypes()
      ? P7(e, t, n.metadata) !== void 0
      : M7(t.v2 ? e.nationalNumber : e.phone, n.nationalNumberPattern())
  );
}
function Rpe(e, t, n) {
  var r = new v7(n).getCountryCodesForCallingCode(e);
  return r
    ? r.filter(function (e) {
        return zpe(t, e, n);
      })
    : [];
}
function zpe(e, t, n) {
  var r = new v7(n);
  return (r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0);
}
function Bpe(e) {
  return e.replace(RegExp(`[${l7}]+`, `g`), ` `).trim();
}
var Vpe = /(\$\d)/;
function Hpe(e, t, n) {
  var r = n.useInternationalFormat,
    i = n.withNationalPrefix;
  (n.carrierCode, n.metadata);
  var a = e.replace(
    new RegExp(t.pattern()),
    r
      ? t.internationalFormat()
      : i && t.nationalPrefixFormattingRule()
        ? t.format().replace(Vpe, t.nationalPrefixFormattingRule())
        : t.format(),
  );
  return r ? Bpe(a) : a;
}
var Upe = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Wpe(e, t, n) {
  var r = new v7(n);
  if ((r.selectNumberingPlan(e, t), r.defaultIDDPrefix())) return r.defaultIDDPrefix();
  if (Upe.test(r.IDDPrefix())) return r.IDDPrefix();
}
function Gpe(e) {
  var t = e.number,
    n = e.ext;
  if (!t) return ``;
  if (t[0] !== `+`) throw Error(`"formatRFC3966()" expects "number" to be in E.164 format.`);
  return `tel:${t}${n ? `;ext=` + n : ``}`;
}
function Kpe(e, t) {
  var n = (typeof Symbol < `u` && e[Symbol.iterator]) || e[`@@iterator`];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = qpe(e)) || (t && e && typeof e.length == `number`)) {
    n && (e = n);
    var r = 0;
    return function () {
      return r >= e.length
        ? {
            done: !0,
          }
        : {
            done: !1,
            value: e[r++],
          };
    };
  }
  throw TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qpe(e, t) {
  if (e) {
    if (typeof e == `string`) return I7(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if ((n === `Object` && e.constructor && (n = e.constructor.name), n === `Map` || n === `Set`))
      return Array.from(e);
    if (n === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return I7(e, t);
  }
}
function I7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function L7(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    (t &&
      (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      n.push.apply(n, r));
  }
  return n;
}
function R7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] == null ? {} : arguments[t];
    t % 2
      ? L7(Object(n), !0).forEach(function (t) {
          Jpe(e, t, n[t]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : L7(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
  }
  return e;
}
function Jpe(e, t, n) {
  return (
    t in e
      ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = n),
    e
  );
}
var z7 = {
  formatExtension: function (e, t, n) {
    return `${e}${n.ext()}${t}`;
  },
};
function Ype(e, t, n, r) {
  if (((n = n ? R7(R7({}, z7), n) : z7), (r = new v7(r)), e.country && e.country !== `001`)) {
    if (!r.hasCountry(e.country)) throw Error(`Unknown country: ${e.country}`);
    r.country(e.country);
  } else if (e.countryCallingCode) r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || ``;
  var i = r.countryCallingCode(),
    a = n.v2 ? e.nationalNumber : e.phone,
    o;
  switch (t) {
    case `NATIONAL`:
      return a
        ? ((o = B7(a, e.carrierCode, `NATIONAL`, r, n)), V7(o, e.ext, r, n.formatExtension))
        : ``;
    case `INTERNATIONAL`:
      return a
        ? ((o = B7(a, null, `INTERNATIONAL`, r, n)),
          (o = `+${i} ${o}`),
          V7(o, e.ext, r, n.formatExtension))
        : `+${i}`;
    case `E.164`:
      return `+${i}${a}`;
    case `RFC3966`:
      return Gpe({
        number: `+${i}${a}`,
        ext: e.ext,
      });
    case `IDD`:
      return n.fromCountry
        ? V7(Zpe(a, e.carrierCode, i, n.fromCountry, r), e.ext, r, n.formatExtension)
        : void 0;
    default:
      throw Error(`Unknown "format" argument passed to "formatNumber()": "${t}"`);
  }
}
function B7(e, t, n, r, i) {
  var a = Xpe(r.formats(), e);
  return a
    ? Hpe(e, a, {
        useInternationalFormat: n === `INTERNATIONAL`,
        withNationalPrefix: !(
          a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() &&
          i &&
          i.nationalPrefix === !1
        ),
        carrierCode: t,
        metadata: r,
      })
    : e;
}
function Xpe(e, t) {
  for (var n = Kpe(e), r; !(r = n()).done;) {
    var i = r.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var a = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0) continue;
    }
    if (M7(t, i.pattern())) return i;
  }
}
function V7(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function Zpe(e, t, n, r, i) {
  if (x7(r, i.metadata) === n) {
    var a = B7(e, t, `NATIONAL`, i);
    return n === `1` ? n + ` ` + a : a;
  }
  var o = Wpe(r, void 0, i.metadata);
  if (o) return `${o} ${n} ${B7(e, null, `INTERNATIONAL`, i)}`;
}
function H7(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    (t &&
      (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      n.push.apply(n, r));
  }
  return n;
}
function U7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] == null ? {} : arguments[t];
    t % 2
      ? H7(Object(n), !0).forEach(function (t) {
          Qpe(e, t, n[t]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : H7(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
  }
  return e;
}
function Qpe(e, t, n) {
  return (
    t in e
      ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = n),
    e
  );
}
function $pe(e, t) {
  if (!(e instanceof t)) throw TypeError(`Cannot call a class as a function`);
}
function W7(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    ((r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      `value` in r && (r.writable = !0),
      Object.defineProperty(e, r.key, r));
  }
}
function eme(e, t, n) {
  return (
    t && W7(e.prototype, t),
    n && W7(e, n),
    Object.defineProperty(e, "prototype", {
      writable: !1,
    }),
    e
  );
}
var tme = (function () {
    function e(t, n, r) {
      if (($pe(this, e), !t)) throw TypeError("`country` or `countryCallingCode` not passed");
      if (!n) throw TypeError("`nationalNumber` not passed");
      if (!r) throw TypeError("`metadata` not passed");
      var i = rme(t, r),
        a = i.country,
        o = i.countryCallingCode;
      ((this.country = a),
        (this.countryCallingCode = o),
        (this.nationalNumber = n),
        (this.number = `+` + this.countryCallingCode + this.nationalNumber),
        (this.getMetadata = function () {
          return r;
        }));
    }
    return (
      eme(e, [
        {
          key: `setExt`,
          value: function (e) {
            this.ext = e;
          },
        },
        {
          key: `getPossibleCountries`,
          value: function () {
            return this.country
              ? [this.country]
              : Rpe(this.countryCallingCode, this.nationalNumber, this.getMetadata());
          },
        },
        {
          key: `isPossible`,
          value: function () {
            return Npe(
              this,
              {
                v2: !0,
              },
              this.getMetadata(),
            );
          },
        },
        {
          key: `isValid`,
          value: function () {
            return Lpe(
              this,
              {
                v2: !0,
              },
              this.getMetadata(),
            );
          },
        },
        {
          key: `isNonGeographic`,
          value: function () {
            return new v7(this.getMetadata()).isNonGeographicCallingCode(this.countryCallingCode);
          },
        },
        {
          key: `isEqual`,
          value: function (e) {
            return this.number === e.number && this.ext === e.ext;
          },
        },
        {
          key: `getType`,
          value: function () {
            return P7(
              this,
              {
                v2: !0,
              },
              this.getMetadata(),
            );
          },
        },
        {
          key: `format`,
          value: function (e, t) {
            return Ype(
              this,
              e,
              t
                ? U7(
                    U7({}, t),
                    {},
                    {
                      v2: !0,
                    },
                  )
                : {
                    v2: !0,
                  },
              this.getMetadata(),
            );
          },
        },
        {
          key: `formatNational`,
          value: function (e) {
            return this.format(`NATIONAL`, e);
          },
        },
        {
          key: `formatInternational`,
          value: function (e) {
            return this.format(`INTERNATIONAL`, e);
          },
        },
        {
          key: `getURI`,
          value: function (e) {
            return this.format(`RFC3966`, e);
          },
        },
      ]),
      e
    );
  })(),
  nme = function (e) {
    return /^[A-Z]{2}$/.test(e);
  };
function rme(e, t) {
  var n,
    r,
    i = new v7(t);
  return (
    nme(e) ? ((n = e), i.selectNumberingPlan(n), (r = i.countryCallingCode())) : (r = e),
    {
      country: n,
      countryCallingCode: r,
    }
  );
}
var ime = RegExp(`([` + c7 + `])`);
function ame(e, t, n, r) {
  if (t) {
    var i = new v7(r);
    i.selectNumberingPlan(t, n);
    var a = new RegExp(i.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var o = e.match(ime);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === `0`)) return e;
    }
  }
}
function ome(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = RegExp(`^(?:` + t.numberingPlan.nationalPrefixForParsing() + `)`),
      r = n.exec(e);
    if (r) {
      var i,
        a,
        o = r.length - 1,
        s = o > 0 && r[o];
      if (t.nationalPrefixTransformRule() && s)
        ((i = e.replace(n, t.nationalPrefixTransformRule())), o > 1 && (a = r[1]));
      else {
        var c = r[0];
        ((i = e.slice(c.length)), s && (a = r[1]));
      }
      var l;
      if (s) {
        var u = e.indexOf(r[1]);
        e.slice(0, u) === t.numberingPlan.nationalPrefix() &&
          (l = t.numberingPlan.nationalPrefix());
      } else l = r[0];
      return {
        nationalNumber: i,
        nationalPrefix: l,
        carrierCode: a,
      };
    }
  }
  return {
    nationalNumber: e,
  };
}
function G7(e, t) {
  var n = ome(e, t),
    r = n.carrierCode,
    i = n.nationalNumber;
  return i !== e && (!sme(e, i, t) || (t.possibleLengths() && !cme(i, t)))
    ? {
        nationalNumber: e,
      }
    : {
        nationalNumber: i,
        carrierCode: r,
      };
}
function sme(e, t, n) {
  return !(M7(e, n.nationalNumberPattern()) && !M7(t, n.nationalNumberPattern()));
}
function cme(e, t) {
  switch (k7(e, t)) {
    case `TOO_SHORT`:
    case `INVALID_LENGTH`:
      return !1;
    default:
      return !0;
  }
}
function lme(e, t, n, r) {
  var i = t ? x7(t, r) : n;
  if (e.indexOf(i) === 0) {
    ((r = new v7(r)), r.selectNumberingPlan(t, n));
    var a = e.slice(i.length),
      o = G7(a, r).nationalNumber,
      s = G7(e, r).nationalNumber;
    if (
      (!M7(s, r.nationalNumberPattern()) && M7(o, r.nationalNumberPattern())) ||
      k7(s, r) === `TOO_LONG`
    )
      return {
        countryCallingCode: i,
        number: a,
      };
  }
  return {
    number: e,
  };
}
function ume(e, t, n, r) {
  if (!e) return {};
  var i;
  if (e[0] !== `+`) {
    var a = ame(e, t, n, r);
    if (a && a !== e) ((i = !0), (e = `+` + a));
    else {
      if (t || n) {
        var o = lme(e, t, n, r),
          s = o.countryCallingCode,
          c = o.number;
        if (s)
          return {
            countryCallingCodeSource: `FROM_NUMBER_WITHOUT_PLUS_SIGN`,
            countryCallingCode: s,
            number: c,
          };
      }
      return {
        number: e,
      };
    }
  }
  if (e[1] === `0`) return {};
  r = new v7(r);
  for (var l = 2; l - 1 <= ape && l <= e.length;) {
    var u = e.slice(1, l);
    if (r.hasCallingCode(u))
      return (
        r.selectNumberingPlan(u),
        {
          countryCallingCodeSource: i ? `FROM_NUMBER_WITH_IDD` : `FROM_NUMBER_WITH_PLUS_SIGN`,
          countryCallingCode: u,
          number: e.slice(l),
        }
      );
    l++;
  }
  return {};
}
function dme(e, t) {
  var n = (typeof Symbol < `u` && e[Symbol.iterator]) || e[`@@iterator`];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = fme(e)) || (t && e && typeof e.length == `number`)) {
    n && (e = n);
    var r = 0;
    return function () {
      return r >= e.length
        ? {
            done: !0,
          }
        : {
            done: !1,
            value: e[r++],
          };
    };
  }
  throw TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fme(e, t) {
  if (e) {
    if (typeof e == `string`) return K7(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if ((n === `Object` && e.constructor && (n = e.constructor.name), n === `Map` || n === `Set`))
      return Array.from(e);
    if (n === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return K7(e, t);
  }
}
function K7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function pme(e, t) {
  var n = t.countries,
    r = t.defaultCountry,
    i = t.metadata;
  i = new v7(i);
  for (var a = [], o = dme(n), s; !(s = o()).done;) {
    var c = s.value;
    if ((i.country(c), i.leadingDigits())) {
      if (e && e.search(i.leadingDigits()) === 0) return c;
    } else if (
      P7(
        {
          phone: e,
          country: c,
        },
        void 0,
        i.metadata,
      )
    )
      if (r) {
        if (c === r) return c;
        a.push(c);
      } else return c;
  }
  if (a.length > 0) return a[0];
}
var mme = !1;
function hme(e, t) {
  var n = t.nationalNumber,
    r = t.defaultCountry,
    i = t.metadata;
  if (mme && i.isNonGeographicCallingCode(e)) return `001`;
  var a = i.getCountryCodesForCallingCode(e);
  if (a)
    return a.length === 1
      ? a[0]
      : pme(n, {
          countries: a,
          defaultCountry: r,
          metadata: i.metadata,
        });
}
var q7 = `+`,
  J7 = `([` + c7 + `]|[\\-\\.\\(\\)]?)`,
  gme = `^\\` + q7 + J7 + `*[` + c7 + `]` + J7 + `*$`,
  _me = new RegExp(gme, `g`),
  Y7 = c7,
  vme = `[` + Y7 + `]+((\\-)*[` + Y7 + `])*`,
  yme = `[a-zA-Z]+((\\-)*[` + Y7 + `])*`,
  bme = `^(` + vme + `\\.)*` + yme + `\\.?$`,
  xme = new RegExp(bme, `g`),
  X7 = `tel:`,
  Z7 = `;phone-context=`,
  Sme = `;isub=`;
function Cme(e) {
  var t = e.indexOf(Z7);
  if (t < 0) return null;
  var n = t + Z7.length;
  if (n >= e.length) return ``;
  var r = e.indexOf(`;`, n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function wme(e) {
  return e === null ? !0 : e.length === 0 ? !1 : _me.test(e) || xme.test(e);
}
function Tme(e, t) {
  var n = t.extractFormattedPhoneNumber,
    r = Cme(e);
  if (!wme(r)) throw new o7(`NOT_A_NUMBER`);
  var i;
  if (r === null) i = n(e) || ``;
  else {
    ((i = ``), r.charAt(0) === q7 && (i += r));
    var a = e.indexOf(X7),
      o = a >= 0 ? a + X7.length : 0,
      s = e.indexOf(Z7);
    i += e.substring(o, s);
  }
  var c = i.indexOf(Sme);
  if ((c > 0 && (i = i.substring(0, c)), i !== ``)) return i;
}
var Eme = 250,
  Dme = RegExp(`[` + u7 + c7 + `]`),
  Ome = RegExp(`[^` + c7 + `#]+$`);
function kme(e, t, n) {
  if (((t ||= {}), (n = new v7(n)), t.defaultCountry && !n.hasCountry(t.defaultCountry)))
    throw t.v2 ? new o7(`INVALID_COUNTRY`) : Error(`Unknown country: ${t.defaultCountry}`);
  var r = jme(e, t.v2, t.extract),
    i = r.number,
    a = r.ext,
    o = r.error;
  if (!i) {
    if (t.v2) throw o === `TOO_SHORT` ? new o7(`TOO_SHORT`) : new o7(`NOT_A_NUMBER`);
    return {};
  }
  var s = Nme(i, t.defaultCountry, t.defaultCallingCode, n),
    c = s.country,
    l = s.nationalNumber,
    u = s.countryCallingCode,
    d = s.countryCallingCodeSource,
    f = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2) throw new o7(`INVALID_COUNTRY`);
    return {};
  }
  if (!l || l.length < s7) {
    if (t.v2) throw new o7(`TOO_SHORT`);
    return {};
  }
  if (l.length > ipe) {
    if (t.v2) throw new o7(`TOO_LONG`);
    return {};
  }
  if (t.v2) {
    var p = new tme(u, l, n.metadata);
    return (
      c && (p.country = c),
      f && (p.carrierCode = f),
      a && (p.ext = a),
      (p.__countryCallingCodeSource = d),
      p
    );
  }
  var m = (t.extended ? n.hasSelectedNumberingPlan() : c) ? M7(l, n.nationalNumberPattern()) : !1;
  return t.extended
    ? {
        country: c,
        countryCallingCode: u,
        carrierCode: f,
        valid: m,
        possible: m ? !0 : !!(t.extended === !0 && n.possibleLengths() && j7(l, n)),
        phone: l,
        ext: a,
      }
    : m
      ? Mme(c, l, a)
      : {};
}
function Ame(e, t, n) {
  if (e) {
    if (e.length > Eme) {
      if (n) throw new o7(`TOO_LONG`);
      return;
    }
    if (t === !1) return e;
    var r = e.search(Dme);
    if (!(r < 0)) return e.slice(r).replace(Ome, ``);
  }
}
function jme(e, t, n) {
  var r = Tme(e, {
    extractFormattedPhoneNumber: function (e) {
      return Ame(e, n, t);
    },
  });
  if (!r) return {};
  if (!Spe(r))
    return Cpe(r)
      ? {
          error: `TOO_SHORT`,
        }
      : {};
  var i = wpe(r);
  return i.ext
    ? i
    : {
        number: r,
      };
}
function Mme(e, t, n) {
  var r = {
    country: e,
    phone: t,
  };
  return (n && (r.ext = n), r);
}
function Nme(e, t, n, r) {
  var i = ume(D7(e), t, n, r.metadata),
    a = i.countryCallingCodeSource,
    o = i.countryCallingCode,
    s = i.number,
    c;
  if (o) r.selectNumberingPlan(o);
  else if (s && (t || n)) (r.selectNumberingPlan(t, n), t && (c = t), (o = n || x7(t, r.metadata)));
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: o,
    };
  var l = G7(D7(s), r),
    u = l.nationalNumber,
    d = l.carrierCode,
    f = hme(o, {
      nationalNumber: u,
      defaultCountry: t,
      metadata: r,
    });
  return (
    f && ((c = f), f === `001` || r.country(c)),
    {
      country: c,
      countryCallingCode: o,
      countryCallingCodeSource: a,
      nationalNumber: u,
      carrierCode: d,
    }
  );
}
function Q7(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    (t &&
      (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      n.push.apply(n, r));
  }
  return n;
}
function $7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] == null ? {} : arguments[t];
    t % 2
      ? Q7(Object(n), !0).forEach(function (t) {
          Pme(e, t, n[t]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : Q7(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
  }
  return e;
}
function Pme(e, t, n) {
  return (
    t in e
      ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = n),
    e
  );
}
function Fme(e, t, n) {
  return kme(
    e,
    $7(
      $7({}, t),
      {},
      {
        v2: !0,
      },
    ),
    n,
  );
}
function e9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    (t &&
      (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      n.push.apply(n, r));
  }
  return n;
}
function Ime(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] == null ? {} : arguments[t];
    t % 2
      ? e9(Object(n), !0).forEach(function (t) {
          Lme(e, t, n[t]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : e9(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
  }
  return e;
}
function Lme(e, t, n) {
  return (
    t in e
      ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = n),
    e
  );
}
function Rme(e, t) {
  return Hme(e) || Vme(e, t) || Bme(e, t) || zme();
}
function zme() {
  throw TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bme(e, t) {
  if (e) {
    if (typeof e == `string`) return t9(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if ((n === `Object` && e.constructor && (n = e.constructor.name), n === `Map` || n === `Set`))
      return Array.from(e);
    if (n === `Arguments` || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return t9(e, t);
  }
}
function t9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Vme(e, t) {
  var n = e == null ? null : (typeof Symbol < `u` && e[Symbol.iterator]) || e[`@@iterator`];
  if (n != null) {
    var r = [],
      i = !0,
      a = !1,
      o,
      s;
    try {
      for (
        n = n.call(e);
        !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t));
        i = !0
      );
    } catch (e) {
      ((a = !0), (s = e));
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function Hme(e) {
  if (Array.isArray(e)) return e;
}
function Ume(e) {
  var t = Rme(Array.prototype.slice.call(e), 4),
    n = t[0],
    r = t[1],
    i = t[2],
    a = t[3],
    o,
    s,
    c;
  if (typeof n == `string`) o = n;
  else throw TypeError(`A text for parsing must be a string.`);
  if (!r || typeof r == `string`)
    (a ? ((s = i), (c = a)) : ((s = void 0), (c = i)),
      r &&
        (s = Ime(
          {
            defaultCountry: r,
          },
          s,
        )));
  else if (f7(r)) i ? ((s = r), (c = i)) : (c = r);
  else throw Error(`Invalid second argument: ${r}`);
  return {
    text: o,
    options: s,
    metadata: c,
  };
}
function n9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    (t &&
      (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      n.push.apply(n, r));
  }
  return n;
}
function r9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] == null ? {} : arguments[t];
    t % 2
      ? n9(Object(n), !0).forEach(function (t) {
          Wme(e, t, n[t]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
        : n9(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
  }
  return e;
}
function Wme(e, t, n) {
  return (
    t in e
      ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = n),
    e
  );
}
function Gme(e, t, n) {
  t &&
    t.defaultCountry &&
    !hpe(t.defaultCountry, n) &&
    (t = r9(
      r9({}, t),
      {},
      {
        defaultCountry: void 0,
      },
    ));
  try {
    return Fme(e, t, n);
  } catch (e) {
    if (!(e instanceof o7)) throw e;
  }
}
function Kme() {
  var e = Ume(arguments),
    t = e.text,
    n = e.options,
    r = e.metadata;
  return Gme(t, n, r);
}
function i9() {
  return Zfe(Kme, arguments);
}
var qme = {
    beforeMount(e, t, n) {
      if (typeof t.value != `function`) {
        let e = n.context.name,
          r = `[Vue-click-outside:] provided expression ${t.expression} is not a function, but has to be`;
        (e && (r += `Found in component ${e}`), console.warn(r));
      }
      ((e.clickOutsideEvent = function (n) {
        let r = n.composedPath ? n.composedPath() : n.path;
        e === n.target || e.contains(n.target) || r.includes(e) || t.value(n, e);
      }),
        document.body.addEventListener(`click`, e.clickOutsideEvent));
    },
    unmounted(e) {
      document.body.removeEventListener(`click`, e.clickOutsideEvent);
    },
  },
  Jme = (e, t) => {
    let n = e.__vccOpts || e;
    for (let [e, r] of t) n[e] = r;
    return n;
  };
function a9(e) {
  let t = Z5.options[e];
  return typeof t > `u` ? Z5.options[e] : t;
}
var Yme = {
    name: `VueTelInput`,
    directives: {
      clickOutside: qme,
    },
    props: {
      modelValue: {
        type: String,
        default: ``,
      },
      allCountries: {
        type: Array,
        default: () => a9(`allCountries`),
      },
      autoFormat: {
        type: Boolean,
        default: () => a9(`autoFormat`),
      },
      customValidate: {
        type: [Boolean, RegExp],
        default: () => a9(`customValidate`),
      },
      defaultCountry: {
        type: [String, Number],
        default: () => a9(`defaultCountry`),
      },
      disabled: {
        type: Boolean,
        default: () => a9(`disabled`),
      },
      autoDefaultCountry: {
        type: Boolean,
        default: () => a9(`autoDefaultCountry`),
      },
      dropdownOptions: {
        type: Object,
        default: () => a9(`dropdownOptions`),
      },
      ignoredCountries: {
        type: Array,
        default: () => a9(`ignoredCountries`),
      },
      inputOptions: {
        type: Object,
        default: () => a9(`inputOptions`),
      },
      invalidMsg: {
        type: String,
        default: () => a9(`invalidMsg`),
      },
      mode: {
        type: String,
        default: () => a9(`mode`),
      },
      onlyCountries: {
        type: Array,
        default: () => a9(`onlyCountries`),
      },
      preferredCountries: {
        type: Array,
        default: () => a9(`preferredCountries`),
      },
      validCharactersOnly: {
        type: Boolean,
        default: () => a9(`validCharactersOnly`),
      },
      styleClasses: {
        type: [String, Array, Object],
        default: () => a9(`styleClasses`),
      },
    },
    data() {
      return {
        phone: ``,
        activeCountryCode: ``,
        open: !1,
        finishMounted: !1,
        selectedIndex: null,
        typeToFindInput: ``,
        typeToFindTimer: null,
        dropdownOpenDirection: `below`,
        parsedPlaceholder: this.inputOptions.placeholder,
        searchQuery: ``,
      };
    },
    computed: {
      activeCountry() {
        return this.findCountry(this.activeCountryCode);
      },
      parsedMode() {
        return this.mode === `auto`
          ? !this.phone || this.phone[0] !== `+`
            ? `national`
            : `international`
          : [`international`, `national`].includes(this.mode)
            ? this.mode
            : (console.error(`Invalid value of prop "mode"`), `international`);
      },
      filteredCountries() {
        return this.onlyCountries.length
          ? this.allCountries.filter(({ iso2: e }) =>
              this.onlyCountries.some((t) => t.toUpperCase() === e),
            )
          : this.ignoredCountries.length
            ? this.allCountries.filter(
                ({ iso2: e }) =>
                  !this.ignoredCountries.includes(e.toUpperCase()) &&
                  !this.ignoredCountries.includes(e.toLowerCase()),
              )
            : this.allCountries;
      },
      sortedCountries() {
        let e = [
          ...this.getCountries(this.preferredCountries).map((e) => ({
            ...e,
            preferred: !0,
          })),
          ...this.filteredCountries,
        ];
        if (!this.dropdownOptions.showSearchBox) return e;
        let t = this.searchQuery.replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>.,\/\\\?-_]/g, ``);
        return e.filter(
          (e) =>
            new RegExp(t, `i`).test(e.name) ||
            new RegExp(t, `i`).test(e.iso2) ||
            new RegExp(t, `i`).test(e.dialCode),
        );
      },
      phoneObject() {
        let e;
        e =
          this.phone?.[0] === `+`
            ? i9(this.phone) || {}
            : i9(this.phone, this.activeCountryCode) || {};
        let { metadata: t, ...n } = e,
          r = e.isValid?.call(e),
          i = this.phone;
        return (
          r && (i = e.format?.call(e, this.parsedMode.toUpperCase())),
          e.country &&
            (this.ignoredCountries.length || this.onlyCountries.length) &&
            (this.findCountry(e.country) ||
              ((r = !1),
              Object.assign(e, {
                country: null,
              }))),
          Object.assign(n, {
            countryCode: e.country,
            valid: r,
            country: this.activeCountry,
            formatted: i,
          }),
          n
        );
      },
    },
    watch: {
      activeCountry(e, t) {
        if (!e && t != null && t.iso2) {
          this.activeCountryCode = t.iso2;
          return;
        }
        e != null && e.iso2 && this.$emit(`country-changed`, e);
      },
      "phoneObject.countryCode": function (e) {
        this.activeCountryCode = e || ``;
      },
      "phoneObject.valid": function () {
        this.$emit(`validate`, this.phoneObject);
      },
      "phoneObject.formatted": function (e) {
        !this.autoFormat ||
          this.customValidate ||
          (this.emitInput(e),
          this.$nextTick(() => {
            e && !this.modelValue && (this.phone = e);
          }));
      },
      "inputOptions.placeholder": function () {
        this.resetPlaceholder();
      },
      modelValue(e, t) {
        this.testCharacters()
          ? (this.phone = e)
          : this.$nextTick(() => {
              ((this.phone = t), this.onInput());
            });
      },
      open(e) {
        e ? (this.setDropdownPosition(), this.$emit(`open`)) : this.$emit(`close`);
      },
    },
    mounted() {
      (this.modelValue && (this.phone = this.modelValue.trim()),
        this.cleanInvalidCharacters(),
        this.initializeCountry()
          .then(() => {
            var e;
            (!this.phone &&
              (e = this.inputOptions) != null &&
              e.showDialCode &&
              this.activeCountryCode &&
              (this.phone = `+${this.activeCountryCode}`),
              this.$emit(`validate`, this.phoneObject));
          })
          .catch(console.error)
          .then(() => {
            this.finishMounted = !0;
          }));
    },
    methods: {
      resetPlaceholder() {
        this.parsedPlaceholder = this.inputOptions.placeholder;
      },
      initializeCountry() {
        return new Promise((e) => {
          if (this.phone?.[0] === `+`) {
            e();
            return;
          }
          if (this.defaultCountry) {
            if (typeof this.defaultCountry == `string`) {
              (this.choose(this.defaultCountry), e());
              return;
            }
            if (typeof this.defaultCountry == `number`) {
              let t = this.findCountryByDialCode(this.defaultCountry);
              if (t) {
                (this.choose(t.iso2), e());
                return;
              }
            }
          }
          let t = this.preferredCountries[0] || this.filteredCountries[0];
          this.autoDefaultCountry
            ? Jfe()
                .then((e) => {
                  this.choose(e || this.activeCountryCode);
                })
                .catch((e) => {
                  (console.warn(e), this.choose(t));
                })
                .then(() => {
                  e();
                })
            : (this.choose(t), e());
        });
      },
      getCountries(e = []) {
        return e.map((e) => this.findCountry(e)).filter(Boolean);
      },
      findCountry(e = ``) {
        return this.filteredCountries.find((t) => t.iso2 === e.toUpperCase());
      },
      findCountryByDialCode(e) {
        return this.filteredCountries.find((t) => Number(t.dialCode) === e);
      },
      getItemClass(e, t) {
        return {
          highlighted: this.selectedIndex === e,
          "last-preferred": e === this.preferredCountries.length - 1,
          preferred: this.preferredCountries.some((e) => e.toUpperCase() === t),
        };
      },
      choose(e) {
        var t;
        let n = e;
        if ((typeof n == `string` && (n = this.findCountry(n)), n)) {
          if (this.phone?.[0] === `+` && n.iso2 && this.phoneObject.nationalNumber) {
            ((this.activeCountryCode = n.iso2),
              (this.phone = i9(this.phoneObject.nationalNumber, n.iso2).formatInternational()));
            return;
          }
          if ((t = this.inputOptions) != null && t.showDialCode && n) {
            ((this.phone = `+${n.dialCode}`), (this.activeCountryCode = n.iso2 || ``));
            return;
          }
          ((this.activeCountryCode = n.iso2 || ``), this.emitInput(this.phone));
        }
      },
      cleanInvalidCharacters() {
        let e = this.phone;
        if (this.validCharactersOnly) {
          let e = this.phone.match(/[()\-+0-9\s]*/g);
          this.phone = e.join(``);
        }
        if (this.customValidate && this.customValidate instanceof RegExp) {
          let e = this.phone.match(this.customValidate);
          this.phone = e.join(``);
        }
        e !== this.phone && this.emitInput(this.phone);
      },
      testCharacters() {
        return this.validCharactersOnly && !/^[()\-+0-9\s]*$/.test(this.phone)
          ? !1
          : this.customValidate
            ? this.testCustomValidate()
            : !0;
      },
      testCustomValidate() {
        return this.customValidate instanceof RegExp ? this.customValidate.test(this.phone) : !1;
      },
      onInput() {
        (this.$refs.input.setCustomValidity(this.phoneObject.valid ? `` : this.invalidMsg),
          this.emitInput(this.phone));
      },
      emitInput(e) {
        (this.$emit(`update:modelValue`, e),
          this.$emit(`on-input`, e, this.phoneObject, this.$refs.input));
      },
      onBlur() {
        this.$emit(`blur`);
      },
      onFocus() {
        (Yfe(this.$refs.input, this.phone.length), this.$emit(`focus`));
      },
      onEnter() {
        this.$emit(`enter`);
      },
      onSpace() {
        this.$emit(`space`);
      },
      focus() {
        this.$refs.input.focus();
      },
      toggleDropdown() {
        this.disabled ||
          this.dropdownOptions.disabled ||
          ((this.searchQuery = ``), (this.open = !this.open));
      },
      clickedOutside() {
        this.open = !1;
      },
      keyboardNav(e) {
        if (e.keyCode === 40) {
          (e.preventDefault(),
            (this.open = !0),
            this.selectedIndex === null
              ? (this.selectedIndex = 0)
              : (this.selectedIndex = Math.min(
                  this.sortedCountries.length - 1,
                  this.selectedIndex + 1,
                )));
          let t = this.$refs.list.children[this.selectedIndex];
          (t.focus(),
            t.offsetTop + t.clientHeight >
              this.$refs.list.scrollTop + this.$refs.list.clientHeight &&
              (this.$refs.list.scrollTop =
                t.offsetTop - this.$refs.list.clientHeight + t.clientHeight));
        } else if (e.keyCode === 38) {
          (e.preventDefault(),
            (this.open = !0),
            this.selectedIndex === null
              ? (this.selectedIndex = this.sortedCountries.length - 1)
              : (this.selectedIndex = Math.max(0, this.selectedIndex - 1)));
          let t = this.$refs.list.children[this.selectedIndex];
          (t.focus(),
            t.offsetTop < this.$refs.list.scrollTop && (this.$refs.list.scrollTop = t.offsetTop));
        } else if (e.keyCode === 13)
          (this.selectedIndex !== null && this.choose(this.sortedCountries[this.selectedIndex]),
            (this.open = !this.open));
        else {
          ((this.typeToFindInput += e.key),
            clearTimeout(this.typeToFindTimer),
            (this.typeToFindTimer = setTimeout(() => {
              this.typeToFindInput = ``;
            }, 700)));
          let t = this.sortedCountries
            .slice(this.preferredCountries.length)
            .findIndex((e) => e.name.toLowerCase().startsWith(this.typeToFindInput));
          if (t >= 0) {
            this.selectedIndex = this.preferredCountries.length + t;
            let e = this.$refs.list.children[this.selectedIndex],
              n = e.offsetTop < this.$refs.list.scrollTop,
              r =
                e.offsetTop + e.clientHeight >
                this.$refs.list.scrollTop + this.$refs.list.clientHeight;
            (n || r) &&
              (this.$refs.list.scrollTop = e.offsetTop - this.$refs.list.clientHeight / 2);
          }
        }
      },
      reset() {
        ((this.selectedIndex = this.sortedCountries
          .map((e) => e.iso2)
          .indexOf(this.activeCountryCode)),
          (this.open = !1));
      },
      setDropdownPosition() {
        window.innerHeight - this.$el.getBoundingClientRect().bottom > 200
          ? (this.dropdownOpenDirection = `below`)
          : (this.dropdownOpenDirection = `above`);
      },
    },
  },
  Xme = [`aria-expanded`, `tabindex`],
  Zme = {
    class: `vti__selection`,
  },
  Qme = {
    key: 1,
    class: `vti__country-code`,
  },
  $me = {
    class: `vti__dropdown-arrow`,
  },
  ehe = [`placeholder`],
  the = [`onClick`, `onMousemove`, `aria-selected`],
  nhe = {
    key: 1,
  },
  rhe = [
    `type`,
    `autocomplete`,
    `autofocus`,
    `disabled`,
    `id`,
    `maxlength`,
    `name`,
    `placeholder`,
    `readonly`,
    `required`,
    `tabindex`,
    `value`,
    `aria-describedby`,
  ];
function ihe(e, t, n, r, i, a) {
  let o = ve(`click-outside`);
  return (
    A(),
    M(
      `div`,
      {
        class: O([
          `vue-tel-input`,
          n.styleClasses,
          {
            disabled: n.disabled,
          },
        ]),
      },
      [
        Re(
          (A(),
          M(
            `div`,
            {
              "aria-label": `Country Code Selector`,
              "aria-haspopup": `listbox`,
              "aria-expanded": i.open,
              role: `button`,
              class: O([
                `vti__dropdown`,
                {
                  open: i.open,
                  disabled: n.dropdownOptions.disabled,
                },
              ]),
              tabindex: n.dropdownOptions.tabindex,
              onKeydown: [
                (t[2] ||= (...e) => a.keyboardNav && a.keyboardNav(...e)),
                (t[4] ||= ze((...e) => a.toggleDropdown && a.toggleDropdown(...e), [`space`])),
                (t[5] ||= ze((...e) => a.reset && a.reset(...e), [`esc`])),
                (t[6] ||= ze((...e) => a.reset && a.reset(...e), [`tab`])),
              ],
              onClick: (t[3] ||= (...e) => a.toggleDropdown && a.toggleDropdown(...e)),
            },
            [
              W(`span`, Zme, [
                n.dropdownOptions.showFlags
                  ? (A(),
                    M(
                      `span`,
                      {
                        key: 0,
                        class: O([`vti__flag`, i.activeCountryCode.toLowerCase()]),
                      },
                      null,
                      2,
                    ))
                  : U(``, !0),
                n.dropdownOptions.showDialCodeInSelection
                  ? (A(), M(`span`, Qme, ` +` + T(a.activeCountry && a.activeCountry.dialCode), 1))
                  : U(``, !0),
                z(
                  e.$slots,
                  `arrow-icon`,
                  {
                    open: i.open,
                  },
                  () => [W(`span`, $me, T(i.open ? `▲` : `▼`), 1)],
                ),
              ]),
              i.open
                ? (A(),
                  M(
                    `ul`,
                    {
                      key: 0,
                      ref: `list`,
                      class: O([`vti__dropdown-list`, i.dropdownOpenDirection]),
                      role: `listbox`,
                    },
                    [
                      n.dropdownOptions.showSearchBox
                        ? Re(
                            (A(),
                            M(
                              `input`,
                              {
                                key: 0,
                                class: `vti__input vti__search_box`,
                                "aria-label": `Search by country name or country code`,
                                placeholder: a.sortedCountries.length
                                  ? a.sortedCountries[0].name
                                  : ``,
                                type: `text`,
                                "onUpdate:modelValue": (t[0] ||= (e) => (i.searchQuery = e)),
                                onClick: (t[1] ||= Fe(() => {}, [`stop`])),
                              },
                              null,
                              8,
                              ehe,
                            )),
                            [[we, i.searchQuery]],
                          )
                        : U(``, !0),
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          a.sortedCountries,
                          (e, t) => (
                            A(),
                            M(
                              `li`,
                              {
                                role: `option`,
                                class: O([`vti__dropdown-item`, a.getItemClass(t, e.iso2)]),
                                key: e.iso2 + (e.preferred ? `-preferred` : ``),
                                tabindex: `-1`,
                                onClick: (t) => a.choose(e),
                                onMousemove: (e) => (i.selectedIndex = t),
                                "aria-selected": i.activeCountryCode === e.iso2 && !e.preferred,
                              },
                              [
                                n.dropdownOptions.showFlags
                                  ? (A(),
                                    M(
                                      `span`,
                                      {
                                        key: 0,
                                        class: O([`vti__flag`, e.iso2.toLowerCase()]),
                                      },
                                      null,
                                      2,
                                    ))
                                  : U(``, !0),
                                W(`strong`, null, T(e.name), 1),
                                n.dropdownOptions.showDialCodeInList
                                  ? (A(), M(`span`, nhe, ` +` + T(e.dialCode), 1))
                                  : U(``, !0),
                              ],
                              42,
                              the,
                            )
                          ),
                        ),
                        128,
                      )),
                    ],
                    2,
                  ))
                : U(``, !0),
            ],
            42,
            Xme,
          )),
          [[o, a.clickedOutside]],
        ),
        Re(
          W(
            `input`,
            {
              "onUpdate:modelValue": (t[7] ||= (e) => (i.phone = e)),
              ref: `input`,
              type: n.inputOptions.type,
              autocomplete: n.inputOptions.autocomplete,
              autofocus: n.inputOptions.autofocus,
              class: O([`vti__input`, n.inputOptions.styleClasses]),
              disabled: n.disabled,
              id: n.inputOptions.id,
              maxlength: n.inputOptions.maxlength,
              name: n.inputOptions.name,
              placeholder: i.parsedPlaceholder,
              readonly: n.inputOptions.readonly,
              required: n.inputOptions.required,
              tabindex: n.inputOptions.tabindex,
              value: n.modelValue,
              "aria-describedby": n.inputOptions[`aria-describedby`],
              onBlur: (t[8] ||= (...e) => a.onBlur && a.onBlur(...e)),
              onFocus: (t[9] ||= (...e) => a.onFocus && a.onFocus(...e)),
              onInput: (t[10] ||= (...e) => a.onInput && a.onInput(...e)),
              onKeyup: [
                (t[11] ||= ze((...e) => a.onEnter && a.onEnter(...e), [`enter`])),
                (t[12] ||= ze((...e) => a.onSpace && a.onSpace(...e), [`space`])),
              ],
            },
            null,
            42,
            rhe,
          ),
          [[Se, i.phone]],
        ),
        z(e.$slots, `icon-right`),
      ],
      2,
    )
  );
}
var ahe = Jme(Yme, [[`render`, ihe]]),
  ohe = {
    install(e, t = {}) {
      let { dropdownOptions: n, inputOptions: r, ...i } = t,
        { dropdownOptions: a, inputOptions: o, ...s } = X5;
      ((Z5.options = {
        inputOptions: {
          ...o,
          ...r,
        },
        dropdownOptions: {
          ...a,
          ...n,
        },
        ...s,
        ...i,
      }),
        e.component(`vue-tel-input`, ahe));
    },
  };
B();
var o9 = null;
function she() {
  return o9 !== null;
}
function che(e) {
  (o9 && c9(), (o9 = e));
}
function s9(e) {
  e === o9 && (o9 = null);
}
function c9() {
  o9 &&= (o9.closeMenu(), null);
}
var l9 = {
  defaultDirection: `br`,
  defaultMinWidth: 100,
  defaultMaxWidth: 600,
  defaultZindex: 100,
  defaultZoom: 1,
  defaultAdjustPadding: {
    x: 0,
    y: 10,
  },
};
function u9(e, t) {
  let n = e.offsetTop;
  return (
    e.offsetParent != null &&
      e.offsetParent != t &&
      ((n -= e.offsetParent.scrollTop), (n += u9(e.offsetParent, t))),
    n
  );
}
function d9(e, t) {
  let n = e.offsetLeft;
  return (
    e.offsetParent != null &&
      e.offsetParent != t &&
      ((n -= e.offsetParent.scrollLeft), (n += d9(e.offsetParent, t))),
    n
  );
}
function lhe(e, t, n, r) {
  return {
    x: d9(e, r) + t,
    y: u9(e, r) + n,
  };
}
var f9 = `mx-menu-default-container`,
  uhe = `mx-menu-container-`,
  dhe = 0;
function p9(e) {
  let { getContainer: t, zIndex: n } = e;
  if (t) {
    let e = typeof t == `function` ? t() : t;
    if (e) {
      let t = e.getAttribute(`id`);
      return (
        t || ((t = uhe + dhe++), e.setAttribute(`id`, t)),
        {
          eleId: t,
          container: e,
          isNew: !1,
        }
      );
    }
  }
  let r = document.getElementById(f9);
  return (
    r ||
      ((r = document.createElement(`div`)),
      r.setAttribute(`id`, f9),
      r.setAttribute(`class`, `mx-menu-ghost-host fullscreen`),
      document.body.appendChild(r)),
    (r.style.zIndex = n?.toString() || l9.defaultZindex.toString()),
    {
      eleId: f9,
      container: r,
      isNew: !0,
    }
  );
}
function fhe(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e.charCodeAt(n);
    ((t = (t << 5) - t + r), (t |= 0));
  }
  return t;
}
function m9(e) {
  return typeof e == `number` ? `${e}px` : e;
}
var h9 = k({
  props: {
    vnode: {
      type: null,
    },
    data: {
      type: null,
      default: null,
    },
  },
  setup(e) {
    let { vnode: t, data: n } = ee(e);
    return () => (typeof t.value == `function` ? t.value(n.value) : t.value);
  },
});
function phe(e, t) {
  let n = {
    ...e,
  };
  return (delete n[t], n);
}
var mhe = Object.defineProperty,
  hhe = (e, t, n) =>
    t in e
      ? mhe(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: n,
        })
      : (e[t] = n),
  g9 = (e, t, n) => hhe(e, typeof t == `symbol` ? t : t + ``, n),
  _9 = class {
    constructor(e, t) {
      (g9(this, `x`, 0), g9(this, `y`, 0), (this.x = e || 0), (this.y = t || 0));
    }
    set(e, t) {
      ((this.x = e), (this.y = t));
    }
    substract(e) {
      ((this.x -= e.x), (this.y -= e.y));
    }
  };
function v9(e) {
  let { onDown: t, onMove: n, onUp: r } = e,
    i = new _9(),
    a = new _9(),
    o;
  function s(e) {
    (e.stopPropagation(), a.set(e.x, e.y), a.substract(i), n(i, a, e, o));
  }
  function c(e) {
    (r(e, o),
      i.set(0, 0),
      document.removeEventListener(`mousemove`, s),
      document.removeEventListener(`mouseup`, c));
  }
  return (e, n) =>
    t(e, n)
      ? ((o = n),
        i.set(e.x, e.y),
        document.addEventListener(`mousemove`, s),
        document.addEventListener(`mouseup`, c),
        e.stopPropagation(),
        !0)
      : !1;
}
function ghe(e, t) {
  let n = 0;
  return {
    start() {
      (n > 0 && clearInterval(n),
        (n = setInterval(() => {
          ((n = 0), t());
        }, e)));
    },
    stop() {
      n > 0 && (clearInterval(n), (n = 0));
    },
  };
}
var y9 = [],
  b9 = ghe(100, () => {
    for (let e of y9) e();
  });
function _he(e, t, n, r) {
  let i = 0,
    a = 0;
  function o() {
    e.value &&
      (t && i !== e.value.offsetWidth && t(e.value.offsetWidth),
      n && a !== e.value.offsetHeight && n(e.value.offsetHeight),
      r &&
        (i !== e.value.offsetWidth || a !== e.value.offsetHeight) &&
        r(e.value.offsetWidth, e.value.offsetHeight),
      (i = e.value.offsetWidth),
      (a = e.value.offsetHeight));
  }
  return {
    startResizeChecker() {
      (b9.start(), y9.push(o));
    },
    stopResizeChecker() {
      let e = y9.indexOf(o);
      (e >= 0 && y9.splice(e, 1), y9.length === 0 && b9.stop());
    },
  };
}
var x9 = 140,
  vhe = 70,
  yhe = k({
    __name: `ScrollRect`,
    props: {
      scroll: {
        type: String,
        default: `both`,
      },
      scrollBarAlwaysShow: {
        type: Boolean,
        default: !1,
      },
      scrollBarBackgroundClickable: {
        type: Boolean,
        default: !1,
      },
      height: {
        type: Number,
        default: void 0,
      },
      width: {
        type: Number,
        default: void 0,
      },
      maxHeight: {
        type: Number,
        default: void 0,
      },
      maxWidth: {
        type: Number,
        default: void 0,
      },
      containerClass: {
        type: String,
        default: ``,
      },
      containerStyle: {
        type: null,
      },
    },
    emits: [`scroll`, `resized`],
    setup(e, { expose: t, emit: n }) {
      let r = e,
        i = n,
        a = F(),
        o = F(),
        s = F(),
        c = F(),
        l = F(),
        u = F(),
        d = F(!1),
        f = V(() => r.scroll === `horizontal` || r.scroll === `both`),
        p = V(() => r.scroll === `vertical` || r.scroll === `both`),
        m = Ae({
          show: !1,
          size: 0,
          sizeRaw: 0,
          pos: 0,
        }),
        h = Ae({
          show: !1,
          size: 0,
          sizeRaw: 0,
          pos: 0,
        }),
        g = 0,
        v = 0,
        y = 0,
        b = 0,
        x = null,
        S = {
          attributes: !0,
          childList: !0,
        };
      function C() {
        if (a.value) {
          if (m.show) {
            let e = a.value.offsetWidth / a.value.scrollWidth;
            ((m.sizeRaw = e * a.value.offsetWidth),
              (m.size = e * 100),
              (m.pos =
                (a.value.scrollLeft / (a.value.scrollWidth - a.value.offsetWidth)) *
                (100 - m.size)),
              e >= 1 && (m.show = !1));
          }
          if (h.show) {
            let e = a.value.offsetHeight / a.value.scrollHeight;
            ((h.sizeRaw = e * a.value.offsetHeight),
              (h.size = e * 100),
              (h.pos =
                (a.value.scrollTop / (a.value.scrollHeight - a.value.offsetHeight)) *
                (100 - h.size)),
              e >= 1 && (h.show = !1));
          }
          i(`scroll`, a.value.scrollLeft, a.value.scrollTop);
        }
      }
      function w(e = !1) {
        if (!a.value) return;
        let t = f.value,
          n = p.value,
          r = t && (g !== a.value.scrollWidth || y !== a.value.offsetWidth),
          o = p && (v !== a.value.scrollHeight || b !== a.value.offsetHeight);
        if (!e && !r && !o) return;
        let s = window.getComputedStyle(a.value);
        ((s.overflow === `hidden` || s.overflowX === `hidden`) && (t = !1),
          (s.overflow === `hidden` || s.overflowY === `hidden`) && (n = !1),
          (m.show = t),
          (h.show = n),
          C(),
          (y = a.value.offsetWidth),
          (b = a.value.offsetHeight),
          (g = a.value.scrollWidth),
          (v = a.value.scrollHeight),
          i(`resized`, g, v));
      }
      function T(e) {
        var t;
        r.scroll == `horizontal` &&
          (e.deltaMode == 0 &&
            ((t = a.value) == null ||
              t.scrollTo({
                left: a.value.scrollLeft + (e.deltaY > 0 ? x9 : -140),
                behavior: `smooth`,
              })),
          e.preventDefault(),
          e.stopPropagation());
      }
      function E(e) {
        var t;
        e.deltaMode == 0 &&
          ((t = a.value) == null ||
            t.scrollTo({
              left: a.value.scrollLeft + (e.deltaY > 0 ? x9 : -140),
              behavior: `smooth`,
            }),
          e.preventDefault(),
          e.stopPropagation());
      }
      function D(e) {
        var t;
        e.deltaMode == 0 &&
          ((t = a.value) == null ||
            t.scrollTo({
              top: a.value.scrollTop + (e.deltaY > 0 ? vhe : -70),
              behavior: `smooth`,
            }),
          e.preventDefault(),
          e.stopPropagation());
      }
      let ee = 0,
        te = 0,
        k = 0,
        ne = 0,
        re = v9({
          onDown(e) {
            return !s.value || !l.value
              ? !1
              : ((ee = e.offsetX),
                (te = e.x - e.offsetX - l.value.offsetLeft),
                e.preventDefault(),
                (d.value = !0),
                !0);
          },
          onMove(e, t, n) {
            a.value && s.value && (se(n.x - ee - te), n.preventDefault(), n.stopPropagation());
          },
          onUp() {
            d.value = !1;
          },
        }),
        ie = v9({
          onDown(e) {
            return !c.value || !u.value
              ? !1
              : ((k = e.offsetY),
                (ne = e.y - e.offsetY - u.value.offsetTop),
                e.preventDefault(),
                (d.value = !0),
                !0);
          },
          onMove(e, t, n) {
            a.value && c.value && (ce(n.y - k - ne), n.preventDefault(), n.stopPropagation());
          },
          onUp() {
            d.value = !1;
          },
        });
      function j(e) {
        a.value && (a.value.scrollLeft = (e / 100) * (a.value.scrollWidth - a.value.offsetWidth));
      }
      function ae(e) {
        a.value && (a.value.scrollLeft = (e / 100) * (a.value.scrollHeight - a.value.offsetHeight));
      }
      function se(e) {
        a.value &&
          (a.value.scrollLeft =
            (e / (a.value.offsetWidth - m.sizeRaw)) * (a.value.scrollWidth - a.value.offsetWidth));
      }
      function ce(e) {
        a.value &&
          (a.value.scrollTop =
            (e / (a.value.offsetHeight - h.sizeRaw)) *
            (a.value.scrollHeight - a.value.offsetHeight));
      }
      function le(e) {
        r.scrollBarBackgroundClickable && se(e.offsetX - m.sizeRaw / 2);
      }
      function ue(e) {
        r.scrollBarBackgroundClickable && ce(e.offsetY - h.sizeRaw / 2);
      }
      let { startResizeChecker: fe, stopResizeChecker: pe } = _he(
        a,
        () => w(),
        () => w(),
      );
      return (
        Qe(() => {
          de(() => {
            (setTimeout(() => w(!0), 200),
              w(!0),
              fe(),
              (x = new MutationObserver(() => w())),
              x.observe(a.value, S));
          });
        }),
        oe(() => {
          (pe(), (x &&= (x.disconnect(), null)));
        }),
        t({
          refreshScrollState() {
            w(!0);
          },
          getScrollContainer() {
            return a.value;
          },
          scrollTo(e, t) {
            var n;
            (n = a.value) == null || n.scrollTo(e, t);
          },
          scrollToTop() {
            var e;
            (e = a.value) == null || e.scrollTo(0, 0);
          },
          scrollToBottom() {
            var e;
            (e = a.value) == null || e.scrollTo(a.value.scrollWidth, a.value.scrollHeight);
          },
        }),
        (t, n) => (
          A(),
          M(
            `div`,
            {
              ref_key: `scrollrect`,
              ref: o,
              class: O([
                `vue-scroll-rect`,
                e.scrollBarAlwaysShow ? `always-show-scrollbar` : ``,
                e.scrollBarBackgroundClickable ? `background-clickable` : ``,
                d.value ? `dragging` : ``,
              ]),
              style: Pe({
                width: e.width ? `${e.width}px` : void 0,
                height: e.height ? `${e.height}px` : void 0,
              }),
              onWheel: T,
            },
            [
              W(
                `div`,
                {
                  ref_key: `container`,
                  ref: a,
                  class: O([`scroll-content`, e.scroll, e.containerClass]),
                  style: Pe({
                    maxWidth: e.maxWidth ? `${e.maxWidth}px` : void 0,
                    maxHeight: e.maxHeight ? `${e.maxHeight}px` : void 0,
                    ...e.containerStyle,
                  }),
                  onScroll: C,
                },
                [z(t.$slots, `default`)],
                38,
              ),
              m.show
                ? z(
                    t.$slots,
                    `scrollBarX`,
                    {
                      key: 0,
                      scrollBarValue: m,
                      onScroll: j,
                    },
                    () => [
                      W(
                        `div`,
                        {
                          ref_key: `scrollBarRefX`,
                          ref: s,
                          class: `scrollbar horizontal`,
                          onClick: le,
                          onWheel: E,
                        },
                        [
                          W(
                            `div`,
                            {
                              class: `thumb`,
                              ref_key: `scrollBarThumbRefX`,
                              ref: l,
                              style: Pe({
                                left: `${m.pos}%`,
                                width: `${m.size}%`,
                              }),
                              onMousedown: (n[0] ||= (...e) => P(re) && P(re)(...e)),
                              onWheel: E,
                            },
                            null,
                            36,
                          ),
                        ],
                        544,
                      ),
                    ],
                  )
                : U(``, !0),
              h.show
                ? z(
                    t.$slots,
                    `scrollBarY`,
                    {
                      key: 1,
                      scrollBarValue: h,
                      onScroll: ae,
                    },
                    () => [
                      h.show
                        ? (A(),
                          M(
                            `div`,
                            {
                              key: 0,
                              ref_key: `scrollBarRefY`,
                              ref: c,
                              class: `scrollbar vertical`,
                              onClick: ue,
                              onWheel: D,
                            },
                            [
                              W(
                                `div`,
                                {
                                  class: `thumb`,
                                  ref_key: `scrollBarThumbRefY`,
                                  ref: u,
                                  style: Pe({
                                    top: `${h.pos}%`,
                                    height: `${h.size}%`,
                                  }),
                                  onMousedown: (n[1] ||= (...e) => P(ie) && P(ie)(...e)),
                                  onWheel: D,
                                },
                                null,
                                36,
                              ),
                            ],
                            544,
                          ))
                        : U(``, !0),
                    ],
                  )
                : U(``, !0),
            ],
            38,
          )
        )
      );
    },
  }),
  S9 = (e, t) => {
    let n = e.__vccOpts || e;
    for (let [e, r] of t) n[e] = r;
    return n;
  },
  bhe = {},
  xhe = {
    class: `mx-checked-mark`,
    "aria-hidden": `true`,
    viewBox: `0 0 1024 1024`,
  },
  She = [
    W(
      `path`,
      {
        d: `M129.3,428.6L52,512l345,372.5l575-620.8l-69.5-75L400.4,718.2L129.3,428.6z`,
      },
      null,
      -1,
    ),
  ];
function Che(e, t) {
  return (A(), M(`svg`, xhe, She));
}
var whe = S9(bhe, [[`render`, Che]]),
  The = {},
  Ehe = {
    class: `mx-right-arrow`,
    "aria-hidden": `true`,
    viewBox: `0 0 1024 1024`,
  },
  Dhe = [
    W(
      `path`,
      {
        d: `M307.018 49.445c11.517 0 23.032 4.394 31.819 13.18L756.404 480.18c8.439 8.438 13.181 19.885 13.181 31.82s-4.741 23.38-13.181 31.82L338.838 961.376c-17.574 17.573-46.065 17.573-63.64-0.001-17.573-17.573-17.573-46.065 0.001-63.64L660.944 512 275.198 126.265c-17.574-17.573-17.574-46.066-0.001-63.64C283.985 53.839 295.501 49.445 307.018 49.445z`,
      },
      null,
      -1,
    ),
  ];
function Ohe(e, t) {
  return (A(), M(`svg`, Ehe, Dhe));
}
var khe = S9(The, [[`render`, Ohe]]),
  Ahe = {
    class: `mx-item-row`,
  },
  jhe = [`xlink:href`],
  Mhe = {
    key: 1,
    class: `label`,
  },
  Nhe = {
    class: `mx-item-row`,
  },
  Phe = {
    class: `mx-shortcut`,
  },
  C9 = k({
    __name: `ContextMenuItem`,
    props: {
      disabled: {
        type: Boolean,
        default: !1,
      },
      hidden: {
        type: Boolean,
        default: !1,
      },
      customRender: {
        type: Function,
        default: null,
      },
      customClass: {
        type: String,
        default: ``,
      },
      clickHandler: {
        type: Function,
        default: null,
      },
      label: {
        type: [String, Object, Function],
        default: ``,
      },
      icon: {
        type: [String, Object, Function],
        default: ``,
      },
      iconFontClass: {
        type: String,
        default: `iconfont`,
      },
      checked: {
        type: Boolean,
        default: !1,
      },
      shortcut: {
        type: String,
        default: ``,
      },
      svgIcon: {
        type: String,
        default: ``,
      },
      svgProps: {
        type: Object,
        default: null,
      },
      preserveIconWidth: {
        type: Boolean,
        default: !0,
      },
      showRightArrow: {
        type: Boolean,
        default: !1,
      },
      hasChildren: {
        type: Boolean,
        default: !1,
      },
      clickClose: {
        type: Boolean,
        default: !0,
      },
      clickableWhenHasChildren: {
        type: Boolean,
        default: !1,
      },
      rawMenuItem: {
        type: Object,
        default: void 0,
      },
    },
    emits: [`click`, `subMenuOpen`, `subMenuClose`],
    setup(e, { expose: t, emit: n }) {
      let r = e,
        i = n,
        {
          clickHandler: a,
          clickClose: o,
          clickableWhenHasChildren: s,
          disabled: c,
          hidden: l,
          label: u,
          icon: d,
          iconFontClass: f,
          showRightArrow: p,
          shortcut: m,
          hasChildren: h,
        } = ee(r),
        g = F(!1),
        v = F(!1),
        y = F(),
        b = R(`globalOptions`),
        x = R(`globalHasSlot`),
        S = R(`globalRenderSlot`),
        C = R(`globalCloseMenu`),
        w = R(`menuContext`);
      ge(
        `MenuItemName`,
        V(() =>
          typeof u.value == `string`
            ? u.value
            : typeof u.value == `function`
              ? fhe(u.value.toString())
              : `MenuItem[unknow]`,
        ),
      );
      let E = {
        getSubMenuInstance: () => {},
        showSubMenu: () =>
          g.value ? (w.markActiveMenuItem(E, !0), !0) : h.value ? (te(), !0) : !1,
        hideSubMenu: () => {
          w.closeOtherSubMenu();
        },
        isDisabledOrHidden: () => c.value || l.value,
        getElement: () => y.value,
        focus: () => (v.value = !0),
        blur: () => (v.value = !1),
        click: D,
      };
      (ge(`menuItemInstance`, E),
        Qe(() => {
          w.isMenuItemDataCollectedFlag()
            ? de(() => {
                let e = 0,
                  t = w.getElement();
                if (t) {
                  let n = 0;
                  for (let r = 0; r < t.children.length; r++) {
                    let i = t.children[r];
                    if (i.getAttribute(`data-type`) === `ContextMenuItem`) {
                      if (i === y.value) {
                        e = n;
                        break;
                      }
                      n++;
                    }
                  }
                }
                w.addChildMenuItem(E, e);
              })
            : w.addChildMenuItem(E);
        }),
        oe(() => {
          w.removeChildMenuItem(E);
        }));
      function D(e) {
        if (!c.value) {
          if (e) {
            let t = e.target;
            if (
              t.classList.contains(`mx-context-no-clickable`) ||
              (b.value.ignoreClickClassName && t.classList.contains(b.value.ignoreClickClassName))
            )
              return;
            if (b.value.clickCloseClassName && t.classList.contains(b.value.clickCloseClassName)) {
              (e.stopPropagation(), C(r.rawMenuItem));
              return;
            }
          }
          h.value
            ? s.value
              ? (typeof a.value == `function` && a.value(e), i(`click`, e))
              : g.value || te()
            : (typeof a.value == `function` && a.value(e),
              i(`click`, e),
              o.value && C(r.rawMenuItem));
        }
      }
      function te(e) {
        ((v.value = !1),
          w.checkCloseOtherSubMenuTimeOut() || w.closeOtherSubMenu(),
          c.value ||
            (w.markActiveMenuItem(E),
            h.value &&
              (e || w.markThisOpenedByKeyBoard(),
              w.addOpenedSubMenu(k),
              (g.value = !0),
              de(() => i(`subMenuOpen`, E)))));
      }
      function k() {
        ((v.value = !1), (g.value = !1), i(`subMenuClose`, E));
      }
      function ne() {
        return {
          disabled: c.value,
          label: u.value,
          icon: d.value,
          iconFontClass: f.value,
          showRightArrow: p.value,
          clickClose: o.value,
          clickableWhenHasChildren: s.value,
          shortcut: m.value,
          theme: b.value.theme,
          isOpen: g,
          hasChildren: h,
          onClick: D,
          onMouseEnter: te,
          closeMenu: C,
        };
      }
      return (
        t(E),
        (t, n) =>
          P(l)
            ? U(``, !0)
            : (A(),
              M(
                `div`,
                ce(
                  {
                    key: 0,
                    class: `mx-context-menu-item-wrapper`,
                    ref_key: `menuItemRef`,
                    ref: y,
                    "data-type": `ContextMenuItem`,
                  },
                  {
                    ...t.$attrs,
                    ...(e.rawMenuItem?.attrs || {}),
                  },
                ),
                [
                  P(x)(`itemRender`)
                    ? (A(),
                      L(
                        P(h9),
                        {
                          key: 0,
                          vnode: () => P(S)(`itemRender`, ne()),
                        },
                        null,
                        8,
                        [`vnode`],
                      ))
                    : e.customRender
                      ? (A(),
                        L(
                          P(h9),
                          {
                            key: 1,
                            vnode: e.customRender,
                            data: ne(),
                          },
                          null,
                          8,
                          [`vnode`, `data`],
                        ))
                      : (A(),
                        M(
                          `div`,
                          {
                            key: 2,
                            class: O([
                              `mx-context-menu-item`,
                              P(c) ? `disabled` : ``,
                              v.value ? `keyboard-focus` : ``,
                              e.customClass ? ` ` + e.customClass : ``,
                              g.value ? `open` : ``,
                            ]),
                            onClick: D,
                            onMouseenter: te,
                          },
                          [
                            z(t.$slots, `default`, {}, () => [
                              W(`div`, Ahe, [
                                W(
                                  `div`,
                                  {
                                    class: O([
                                      `mx-icon-placeholder`,
                                      e.preserveIconWidth ? `preserve-width` : ``,
                                    ]),
                                  },
                                  [
                                    z(t.$slots, `icon`, {}, () => [
                                      P(x)(`itemIconRender`)
                                        ? (A(),
                                          L(
                                            P(h9),
                                            {
                                              key: 0,
                                              vnode: () => P(S)(`itemIconRender`, ne()),
                                            },
                                            null,
                                            8,
                                            [`vnode`],
                                          ))
                                        : typeof e.svgIcon == `string` && e.svgIcon
                                          ? (A(),
                                            M(
                                              `svg`,
                                              ce(
                                                {
                                                  key: 1,
                                                  class: `icon svg`,
                                                },
                                                e.svgProps,
                                              ),
                                              [
                                                W(
                                                  `use`,
                                                  {
                                                    "xlink:href": e.svgIcon,
                                                  },
                                                  null,
                                                  8,
                                                  jhe,
                                                ),
                                              ],
                                              16,
                                            ))
                                          : typeof P(d) == `string`
                                            ? typeof P(d) == `string` && P(d) !== ``
                                              ? (A(),
                                                M(
                                                  `i`,
                                                  {
                                                    key: 3,
                                                    class: O(
                                                      P(d) +
                                                        ` icon ` +
                                                        P(f) +
                                                        ` ` +
                                                        P(b).iconFontClass,
                                                    ),
                                                  },
                                                  null,
                                                  2,
                                                ))
                                              : U(``, !0)
                                            : (A(),
                                              L(
                                                P(h9),
                                                {
                                                  key: 2,
                                                  vnode: P(d),
                                                  data: P(d),
                                                },
                                                null,
                                                8,
                                                [`vnode`, `data`],
                                              )),
                                    ]),
                                    e.checked
                                      ? z(
                                          t.$slots,
                                          `check`,
                                          {
                                            key: 0,
                                          },
                                          () => [
                                            P(x)(`itemCheckRender`)
                                              ? (A(),
                                                L(
                                                  P(h9),
                                                  {
                                                    key: 0,
                                                    vnode: () => P(S)(`itemCheckRender`, ne()),
                                                  },
                                                  null,
                                                  8,
                                                  [`vnode`],
                                                ))
                                              : U(``, !0),
                                            N(whe),
                                          ],
                                        )
                                      : U(``, !0),
                                  ],
                                  2,
                                ),
                                z(t.$slots, `label`, {}, () => [
                                  P(x)(`itemLabelRender`)
                                    ? (A(),
                                      L(
                                        P(h9),
                                        {
                                          key: 0,
                                          vnode: () => P(S)(`itemLabelRender`, ne()),
                                        },
                                        null,
                                        8,
                                        [`vnode`],
                                      ))
                                    : typeof P(u) == `string`
                                      ? (A(), M(`span`, Mhe, T(P(u)), 1))
                                      : (A(),
                                        L(
                                          P(h9),
                                          {
                                            key: 2,
                                            vnode: P(u),
                                            data: P(u),
                                          },
                                          null,
                                          8,
                                          [`vnode`, `data`],
                                        )),
                                ]),
                              ]),
                              W(`div`, Nhe, [
                                P(m) || t.$slots.shortcut
                                  ? z(
                                      t.$slots,
                                      `shortcut`,
                                      {
                                        key: 0,
                                      },
                                      () => [
                                        P(x)(`itemShortcutRender`)
                                          ? (A(),
                                            L(
                                              P(h9),
                                              {
                                                key: 0,
                                                vnode: () => P(S)(`itemShortcutRender`, ne()),
                                              },
                                              null,
                                              8,
                                              [`vnode`],
                                            ))
                                          : U(``, !0),
                                        W(`span`, Phe, T(P(m)), 1),
                                      ],
                                    )
                                  : U(``, !0),
                                P(p)
                                  ? z(
                                      t.$slots,
                                      `rightArrow`,
                                      {
                                        key: 1,
                                      },
                                      () => [
                                        P(x)(`itemRightArrowRender`)
                                          ? (A(),
                                            L(
                                              P(h9),
                                              {
                                                key: 0,
                                                vnode: () => P(S)(`itemRightArrowRender`, ne()),
                                              },
                                              null,
                                              8,
                                              [`vnode`],
                                            ))
                                          : U(``, !0),
                                        N(khe),
                                      ],
                                    )
                                  : U(``, !0),
                              ]),
                            ]),
                          ],
                          34,
                        )),
                  z(t.$slots, `submenu`, {
                    context: E,
                    show: g.value,
                  }),
                ],
                16,
              ))
      );
    },
  }),
  Fhe = k({
    name: `ContextMenuSperator`,
    components: {
      VNodeRender: h9,
    },
    setup() {
      return {
        globalHasSlot: R(`globalHasSlot`),
        globalRenderSlot: R(`globalRenderSlot`),
      };
    },
  }),
  Ihe = {
    key: 1,
    class: `mx-context-menu-item-sperator mx-context-no-clickable`,
  };
function Lhe(e, t, n, r, i, a) {
  let o = j(`VNodeRender`);
  return e.globalHasSlot(`separatorRender`)
    ? (A(),
      L(
        o,
        {
          key: 0,
          vnode: () => e.globalRenderSlot(`separatorRender`, {}),
        },
        null,
        8,
        [`vnode`],
      ))
    : (A(), M(`div`, Ihe));
}
var w9 = S9(Fhe, [[`render`, Lhe]]),
  T9 = k({
    __name: `ContextSubMenu`,
    props: {
      items: {
        type: Object,
        default: null,
      },
      show: {
        type: Boolean,
        default: !1,
      },
      destroyOnClose: {
        type: Boolean,
        default: !0,
      },
      maxHeight: {
        type: Number,
        default: 0,
      },
      maxWidth: {
        type: [String, Number],
        default: 0,
      },
      minWidth: {
        type: [String, Number],
        default: 0,
      },
      adjustPosition: {
        type: Boolean,
        default: !0,
      },
      direction: {
        type: String,
        default: `br`,
      },
      parentMenuItemContext: {
        type: Object,
        default: null,
      },
    },
    emits: [`closeAnimFinished`],
    setup(e, { expose: t, emit: n }) {
      let r = e,
        i = n,
        a = F(!1),
        o = R(`globalGetMenuHostId`, ``),
        s = R(`menuContext`),
        c = R(`globalOptions`);
      (R(`globalHasSlot`), R(`globalRenderSlot`));
      let l = R(`MenuItemName`, F(`UnknowOrRoot`)),
        { zIndex: u, getParentWidth: d, getParentHeight: f, getZoom: p } = s,
        { adjustPosition: m } = ee(r),
        h = F(),
        g = F(),
        v = F(),
        y = [],
        b = R(`globalSetCurrentSubMenu`),
        x = [],
        S = null,
        C = 0;
      function w() {
        S && S.blur();
      }
      function T(e, t) {
        if (e) {
          for (let e = t === void 0 ? 0 : t; e < x.length; e++)
            if (!x[e].isDisabledOrHidden()) {
              E(e);
              break;
            }
        } else
          for (let e = t === void 0 ? x.length - 1 : t; e >= 0; e--)
            if (!x[e].isDisabledOrHidden()) {
              E(e);
              break;
            }
      }
      function E(e) {
        if ((S && w(), e !== void 0 && (S = x[Math.max(0, Math.min(e, x.length - 1))]), !S)) return;
        S.focus();
        let t = S.getElement();
        t &&
          t.scrollIntoView({
            behavior: `auto`,
            block: `nearest`,
            inline: `nearest`,
          });
      }
      function te() {
        b(k);
      }
      let k = {
          el: v,
          name: l,
          isTopLevel: () => s.getParentContext() === null,
          closeSelfAndActiveParent: () => {
            let e = ie.getParentContext();
            if (e) {
              e.closeOtherSubMenu();
              let t = e.getSubMenuInstanceContext();
              if (t) return (t.focusCurrentItem(), !0);
            }
            return !1;
          },
          closeCurrentSubMenu: () => ie.getParentContext()?.closeOtherSubMenu(),
          moveCurrentItemFirst: () => T(!0),
          moveCurrentItemLast: () => T(!1),
          moveCurrentItemDown: () => T(!0, S ? x.indexOf(S) + 1 : 0),
          moveCurrentItemUp: () => T(!1, S ? x.indexOf(S) - 1 : 0),
          focusCurrentItem: () => E(),
          openCurrentItemSubMenu: () => (S ? S?.showSubMenu() : !1),
          triggerCurrentItemClick: (e) => S?.click(e),
        },
        ne = !1,
        re = !1,
        ie = {
          zIndex: u + 1,
          container: s.container,
          adjustPadding: c.value.adjustPadding || l9.defaultAdjustPadding,
          getParentWidth: () => v.value?.offsetWidth || 0,
          getParentHeight: () => v.value?.offsetHeight || 0,
          getPositon: () => [me.value.x, me.value.y],
          getZoom: () => c.value.zoom || l9.defaultZoom,
          addOpenedSubMenu(e) {
            y.push(e);
          },
          closeOtherSubMenu() {
            (y.forEach((e) => e()), y.splice(0, y.length), b(k));
          },
          checkCloseOtherSubMenuTimeOut() {
            return C ? (clearTimeout(C), (C = 0), !0) : !1;
          },
          closeOtherSubMenuWithTimeOut() {
            C = setTimeout(() => {
              ((C = 0), this.closeOtherSubMenu());
            }, 200);
          },
          addChildMenuItem: (e, t) => {
            t === void 0 ? x.push(e) : x.splice(t, 0, e);
          },
          removeChildMenuItem: (e) => {
            (x.splice(x.indexOf(e), 1), (e.getSubMenuInstance = () => {}));
          },
          markActiveMenuItem: (e, t = !1) => {
            (w(), (S = e), t && E());
          },
          markThisOpenedByKeyBoard: () => {
            ne = !0;
          },
          isOpenedByKeyBoardFlag: () => (ne ? ((ne = !1), !0) : !1),
          isMenuItemDataCollectedFlag: () => re,
          getElement: () => v.value || null,
          getParentContext: () => s,
          getSubMenuInstanceContext: () => k,
        };
      ge(`menuContext`, ie);
      let se = {
          getChildItem: (e) => x[e],
          getMenuDimensions: () =>
            g.value
              ? {
                  width: g.value.offsetWidth,
                  height: g.value.offsetHeight,
                }
              : {
                  width: 0,
                  height: 0,
                },
          getSubmenuRoot: () => g.value,
          getMenu: () => v.value,
          getScrollValue: () => h.value?.getScrollContainer()?.scrollTop || 0,
          setScrollValue: (e) => h.value?.scrollTo(0, e),
          getScrollHeight: () => ue.value,
          adjustPosition: () => {
            he();
          },
          getMaxHeight: () => fe.value,
          getPosition: () => me.value,
          setPosition: (e, t) => {
            ((me.value.x = e), (me.value.y = t));
          },
        },
        le = R(`menuItemInstance`, void 0);
      le && (le.getSubMenuInstance = () => se);
      let ue = F(0),
        fe = F(0),
        pe = F(!1),
        me = F({
          x: 0,
          y: 0,
        });
      function he() {
        de(() => {
          let e = v.value,
            t = g.value;
          if (e && t && h.value) {
            let { container: n } = s,
              i = d?.() ?? 0,
              a = f?.() ?? 0,
              o = getComputedStyle(t),
              c = parseFloat(o.paddingLeft),
              l = parseFloat(o.paddingTop),
              u = a > 0 ? l : 0,
              g = document.documentElement.scrollHeight / p(),
              v = document.documentElement.scrollWidth / p(),
              y = Math.min(v, n.offsetWidth),
              b = Math.min(g, n.offsetHeight),
              x = d9(e, n),
              S = u9(e, n);
            if (
              (r.direction.includes(`l`)
                ? (me.value.x -= e.offsetWidth + c)
                : r.direction.includes(`r`)
                  ? (me.value.x += i + c)
                  : ((me.value.x += i / 2), (me.value.x -= (e.offsetWidth + c) / 2)),
              r.direction.includes(`t`))
            ) {
              let t = r.parentMenuItemContext?.getElement();
              (t && (me.value.y += t.offsetHeight), (me.value.y -= (e.offsetHeight + l) / p()));
            } else
              r.direction.includes(`b`)
                ? (me.value.y -= l / p())
                : (me.value.y -= e.offsetHeight / 2 / p());
            de(() => {
              ((x = d9(e, n)), (S = u9(e, n)));
              let t = h.value?.getScrollContainer()?.scrollHeight || 0,
                a = r.maxHeight;
              ue.value = r.maxHeight ? Math.min(t, r.maxHeight) : t;
              let o = x + e.offsetWidth - y,
                s = S + ue.value + u * 2 - b;
              if (((pe.value = s > 0), m.value && o > 0)) {
                let t = i + e.offsetWidth - c,
                  n = x;
                t > n ? (me.value.x -= n) : (me.value.x -= t);
              }
              if (pe.value) {
                if (m.value) {
                  let e = s,
                    t = S;
                  e > t ? (me.value.y -= t - u) : (me.value.y -= e - u);
                }
                fe.value = b - (me.value.y + l);
              } else fe.value = a || 0;
            });
          }
        });
      }
      function _e() {
        let e = r.parentMenuItemContext?.getElement();
        if (e) {
          let t = d9(e, s.container),
            n = u9(e, s.container);
          ((me.value.x = t), (me.value.y = n));
        } else {
          let [e, t] = s.getPositon();
          ((me.value.x = e), (me.value.y = t));
        }
        (de(() => {
          var e;
          (b(k),
            (e = v.value) == null ||
              e.focus({
                preventScroll: !0,
              }),
            s.isOpenedByKeyBoardFlag() && de(() => T(!0)),
            (re = !0));
        }),
          he());
      }
      return (
        He(
          () => r.show,
          (e) => {
            e && _e();
          },
        ),
        Qe(() => {
          ((a.value = !0), r.show ? _e() : he());
        }),
        oe(() => {
          ((a.value = !1), le && (le.getSubMenuInstance = () => {}));
        }),
        t(se),
        (t, n) => {
          let r = j(`ContextSubMenu`, !0);
          return a.value
            ? (A(),
              L(
                De,
                {
                  key: 0,
                  to: `#${P(o)}`,
                },
                [
                  N(
                    Ve,
                    ce(
                      {
                        appear: ``,
                      },
                      P(c).menuTransitionProps || {
                        duration: 10,
                      },
                      {
                        onAfterLeave: (n[0] ||= (e) => i(`closeAnimFinished`)),
                      },
                    ),
                    {
                      default: I(() => [
                        !e.destroyOnClose || e.show
                          ? Re(
                              (A(),
                              M(
                                `div`,
                                ce(
                                  {
                                    key: 0,
                                    ref_key: `submenuRoot`,
                                    ref: g,
                                  },
                                  t.$attrs,
                                  {
                                    class: [
                                      `mx-context-menu`,
                                      P(c).customClass ? P(c).customClass : ``,
                                      P(c).theme ?? ``,
                                    ],
                                    style: {
                                      maxWidth: e.maxWidth
                                        ? P(m9)(e.maxWidth)
                                        : `${P(l9).defaultMaxWidth}px`,
                                      minWidth: e.minWidth
                                        ? P(m9)(e.minWidth)
                                        : `${P(l9).defaultMinWidth}px`,
                                      zIndex: P(u),
                                      left: `${me.value.x}px`,
                                      top: `${me.value.y}px`,
                                    },
                                    "data-type": `ContextSubMenu`,
                                    onClick: te,
                                  },
                                ),
                                [
                                  N(
                                    P(yhe),
                                    {
                                      ref_key: `scrollRectRef`,
                                      ref: h,
                                      scroll: `vertical`,
                                      maxHeight: fe.value,
                                      containerClass: `mx-context-menu-scroll`,
                                    },
                                    {
                                      default: I(() => [
                                        W(
                                          `div`,
                                          {
                                            class: O([`mx-context-menu-items`]),
                                            ref_key: `menu`,
                                            ref: v,
                                          },
                                          [
                                            z(t.$slots, `default`, {}, () => [
                                              (A(!0),
                                              M(
                                                ke,
                                                null,
                                                ae(
                                                  e.items,
                                                  (t, n) => (
                                                    A(),
                                                    M(
                                                      ke,
                                                      {
                                                        key: n,
                                                      },
                                                      [
                                                        t.hidden !== !0 && t.divided === `up`
                                                          ? (A(),
                                                            L(w9, {
                                                              key: 0,
                                                            }))
                                                          : U(``, !0),
                                                        t.hidden !== !0 && t.divided === `self`
                                                          ? (A(),
                                                            L(w9, {
                                                              key: 1,
                                                            }))
                                                          : (A(),
                                                            L(
                                                              C9,
                                                              {
                                                                key: 2,
                                                                clickHandler: t.onClick
                                                                  ? (e) => t.onClick(e)
                                                                  : void 0,
                                                                disabled:
                                                                  typeof t.disabled == `object`
                                                                    ? t.disabled.value
                                                                    : t.disabled,
                                                                hidden:
                                                                  typeof t.hidden == `object`
                                                                    ? t.hidden.value
                                                                    : t.hidden,
                                                                icon: t.icon,
                                                                iconFontClass: t.iconFontClass,
                                                                svgIcon: t.svgIcon,
                                                                svgProps: t.svgProps,
                                                                label: t.label,
                                                                customRender: t.customRender,
                                                                customClass: t.customClass,
                                                                checked:
                                                                  typeof t.checked == `object`
                                                                    ? t.checked.value
                                                                    : t.checked,
                                                                shortcut: t.shortcut,
                                                                clickClose: t.clickClose,
                                                                clickableWhenHasChildren:
                                                                  t.clickableWhenHasChildren,
                                                                preserveIconWidth:
                                                                  t.preserveIconWidth === void 0
                                                                    ? P(c).preserveIconWidth
                                                                    : t.preserveIconWidth,
                                                                showRightArrow:
                                                                  t.children &&
                                                                  t.children.length > 0,
                                                                hasChildren:
                                                                  t.children &&
                                                                  t.children.length > 0,
                                                                rawMenuItem: t,
                                                                onSubMenuOpen: (e) =>
                                                                  t.onSubMenuOpen?.call(t, e),
                                                                onSubMenuClose: (e) =>
                                                                  t.onSubMenuClose?.call(t, e),
                                                              },
                                                              D(
                                                                {
                                                                  _: 2,
                                                                },
                                                                [
                                                                  t.children &&
                                                                  t.children.length > 0
                                                                    ? {
                                                                        name: `submenu`,
                                                                        fn: I(
                                                                          ({
                                                                            context: n,
                                                                            show: i,
                                                                          }) => [
                                                                            N(
                                                                              r,
                                                                              {
                                                                                show: i,
                                                                                destroyOnClose:
                                                                                  e.destroyOnClose,
                                                                                parentMenuItemContext:
                                                                                  n,
                                                                                items: t.children,
                                                                                maxWidth:
                                                                                  t.maxWidth,
                                                                                minWidth:
                                                                                  t.minWidth,
                                                                                maxHeight:
                                                                                  t.maxHeight,
                                                                                adjustPosition:
                                                                                  t.adjustSubMenuPosition ===
                                                                                  void 0
                                                                                    ? P(c)
                                                                                        .adjustPosition
                                                                                    : t.adjustSubMenuPosition,
                                                                                direction:
                                                                                  t.direction ===
                                                                                  void 0
                                                                                    ? P(c).direction
                                                                                    : t.direction,
                                                                              },
                                                                              null,
                                                                              8,
                                                                              [
                                                                                `show`,
                                                                                `destroyOnClose`,
                                                                                `parentMenuItemContext`,
                                                                                `items`,
                                                                                `maxWidth`,
                                                                                `minWidth`,
                                                                                `maxHeight`,
                                                                                `adjustPosition`,
                                                                                `direction`,
                                                                              ],
                                                                            ),
                                                                          ],
                                                                        ),
                                                                        key: `0`,
                                                                      }
                                                                    : void 0,
                                                                ],
                                                              ),
                                                              1032,
                                                              [
                                                                `clickHandler`,
                                                                `disabled`,
                                                                `hidden`,
                                                                `icon`,
                                                                `iconFontClass`,
                                                                `svgIcon`,
                                                                `svgProps`,
                                                                `label`,
                                                                `customRender`,
                                                                `customClass`,
                                                                `checked`,
                                                                `shortcut`,
                                                                `clickClose`,
                                                                `clickableWhenHasChildren`,
                                                                `preserveIconWidth`,
                                                                `showRightArrow`,
                                                                `hasChildren`,
                                                                `rawMenuItem`,
                                                                `onSubMenuOpen`,
                                                                `onSubMenuClose`,
                                                              ],
                                                            )),
                                                        t.hidden !== !0 &&
                                                        (t.divided === `down` || t.divided === !0)
                                                          ? (A(),
                                                            L(w9, {
                                                              key: 3,
                                                            }))
                                                          : U(``, !0),
                                                      ],
                                                      64,
                                                    )
                                                  ),
                                                ),
                                                128,
                                              )),
                                            ]),
                                          ],
                                          512,
                                        ),
                                      ]),
                                      _: 3,
                                    },
                                    8,
                                    [`maxHeight`],
                                  ),
                                ],
                                16,
                              )),
                              [[Ee, e.show]],
                            )
                          : U(``, !0),
                      ]),
                      _: 3,
                    },
                    16,
                  ),
                ],
                8,
                [`to`],
              ))
            : U(``, !0);
        }
      );
    },
  }),
  E9 = k({
    __name: `ContextSubMenuWrapper`,
    props: {
      options: {
        type: Object,
        default: null,
      },
      show: {
        type: null,
        default: null,
      },
      destroyOnClose: {
        type: Boolean,
        default: !0,
      },
      container: {
        type: Object,
        default: null,
      },
      isFullScreenContainer: {
        type: Boolean,
        default: !0,
      },
    },
    emits: [`close`, `closeAnimFinished`],
    setup(e, { expose: t, emit: n }) {
      let r = e,
        i = n,
        a = Te(),
        o = F(),
        { options: s, show: c, destroyOnClose: l, container: u } = ee(r);
      (Qe(() => {
        c.value && p();
      }),
        oe(() => {
          v();
        }),
        He(c, (e) => {
          e ? p() : (s9(d), v());
        }));
      let d = {
          closeMenu: m,
          isClosed: h,
          getMenuRef: () => o.value,
          getMenuDimensions: () =>
            o.value?.getMenuDimensions() ?? {
              width: 0,
              height: 0,
            },
        },
        f = !1;
      function p() {
        (g(), che(d));
      }
      function m(e) {
        ((f = !0), i(`close`, e), s.value.menuTransitionProps || i(`closeAnimFinished`), s9(d));
      }
      function h() {
        return f;
      }
      function g() {
        setTimeout(() => {
          (document.addEventListener(`click`, S, !0),
            document.addEventListener(`contextmenu`, S, !0),
            document.addEventListener(`scroll`, x, !0),
            !r.isFullScreenContainer && u.value && u.value.addEventListener(`scroll`, x, !0),
            s.value.keyboardControl !== !1 && document.addEventListener(`keydown`, b, !0));
        }, 50);
      }
      function v() {
        (document.removeEventListener(`contextmenu`, S, !0),
          document.removeEventListener(`click`, S, !0),
          document.removeEventListener(`scroll`, x, !0),
          !r.isFullScreenContainer && u.value && u.value.removeEventListener(`scroll`, x, !0),
          s.value.keyboardControl !== !1 && document.removeEventListener(`keydown`, b, !0));
      }
      let y = F();
      (ge(`globalSetCurrentSubMenu`, (e) => (y.value = e)), ge(`globalGetMenuHostId`, u.value.id));
      function b(e) {
        var t, n, r, i, a, o, c, l, u, d, f, p;
        let h = !0;
        switch (e.key) {
          case `Escape`:
            y.value?.isTopLevel() === !1 ? (t = y.value) == null || t.closeCurrentSubMenu() : m();
            break;
          case `ArrowDown`:
            (n = y.value) == null || n.moveCurrentItemDown();
            break;
          case `ArrowUp`:
            (r = y.value) == null || r.moveCurrentItemUp();
            break;
          case `Home`:
            (i = y.value) == null || i.moveCurrentItemFirst();
            break;
          case `End`:
            (a = y.value) == null || a.moveCurrentItemLast();
            break;
          case `ArrowLeft`:
            ((o = y.value) != null && o.closeSelfAndActiveParent()) ||
              (l = (c = s.value).onKeyFocusMoveLeft) == null ||
              l.call(c);
            break;
          case `ArrowRight`:
            ((u = y.value) != null && u.openCurrentItemSubMenu()) ||
              (f = (d = s.value).onKeyFocusMoveRight) == null ||
              f.call(d);
            break;
          case `Enter`:
            (p = y.value) == null || p.triggerCurrentItemClick(e);
            break;
          default:
            h = !1;
            break;
        }
        h && y.value && (e.stopPropagation(), e.preventDefault());
      }
      function x(e) {
        s.value.closeWhenScroll !== !1 && C(e.target, null);
      }
      function S(e) {
        C(e.target, e);
      }
      function C(e, t) {
        for (var n, r; e;) {
          if (e.classList && e.classList.contains(`mx-context-menu`)) return;
          e = e.parentNode;
        }
        t && s.value.clickCloseOnOutside === !1
          ? (r = (n = s.value).onClickOnOutside) == null || r.call(n, t)
          : (v(), m());
      }
      return (
        ge(`globalOptions`, s),
        ge(`globalCloseMenu`, m),
        ge(`globalIsFullScreenContainer`, r.isFullScreenContainer),
        ge(`globalHasSlot`, (e) => a[e] !== void 0),
        ge(`globalRenderSlot`, (e, t) =>
          z(
            a,
            e,
            {
              ...t,
            },
            () => [Ne(`span`, `Render slot failed`)],
            !1,
          ),
        ),
        ge(`menuContext`, {
          zIndex: s.value.zIndex || l9.defaultZindex,
          container: u.value,
          adjustPadding: {
            x: 0,
            y: 0,
          },
          getZoom: () => s.value.zoom || l9.defaultZoom,
          getParentWidth: () => 0,
          getParentHeight: () => 0,
          getPositon: () => [s.value.x, s.value.y],
          closeOtherSubMenuWithTimeOut: () => {},
          checkCloseOtherSubMenuTimeOut: () => !1,
          addOpenedSubMenu: () => {},
          closeOtherSubMenu: () => {},
          getParentContext: () => null,
          getSubMenuInstanceContext: () => null,
          getElement: () => null,
          addChildMenuItem: () => {},
          removeChildMenuItem: () => {},
          markActiveMenuItem: () => {},
          markThisOpenedByKeyBoard: () => {},
          isOpenedByKeyBoardFlag: () => !1,
          isMenuItemDataCollectedFlag: () => !1,
        }),
        t(d),
        (e, t) => (
          A(),
          L(
            T9,
            {
              ref_key: `submenuInstance`,
              ref: o,
              show: P(c),
              destroyOnClose: P(l),
              items: P(s).items,
              adjustPosition: P(s).adjustPosition,
              maxWidth: P(s).maxWidth || P(l9).defaultMaxWidth,
              minWidth: P(s).minWidth || P(l9).defaultMinWidth,
              maxHeight: P(s).maxHeight,
              direction: P(s).direction || P(l9).defaultDirection,
              onCloseAnimFinished: (t[0] ||= (e) => i(`closeAnimFinished`)),
            },
            {
              default: I(() => [z(e.$slots, `default`)]),
              _: 3,
            },
            8,
            [
              `show`,
              `destroyOnClose`,
              `items`,
              `adjustPosition`,
              `maxWidth`,
              `minWidth`,
              `maxHeight`,
              `direction`,
            ],
          )
        )
      );
    },
  }),
  Rhe = k({
    __name: `ContextMenu`,
    props: {
      options: {
        type: Object,
        default: null,
      },
      show: {
        type: Boolean,
        default: !1,
      },
      destroyOnClose: {
        type: Boolean,
        default: !0,
      },
    },
    emits: [`update:show`, `close`],
    setup(e, { expose: t, emit: n }) {
      let r = n,
        { options: i, show: a, destroyOnClose: o } = ee(e),
        { isNew: s, container: c, eleId: l } = p9(i.value),
        u = F(null),
        d = Te();
      function f(e) {
        var t, n;
        (r(`update:show`, !1), r(`close`), (n = (t = i.value).onClose) == null || n.call(t, e));
      }
      return (
        t({
          closeMenu: () => r(`update:show`, !1),
          isClosed: () => !a.value,
          getMenuRef: () => u.value?.getMenuRef(),
          getMenuDimensions: () =>
            u.value?.getMenuDimensions() ?? {
              width: 0,
              height: 0,
            },
        }),
        (e, t) => (
          A(),
          L(
            De,
            {
              to: `#${P(l)}`,
            },
            [
              N(
                E9,
                {
                  ref_key: `menuRef`,
                  ref: u,
                  options: P(i),
                  show: P(a),
                  destroyOnClose: P(o),
                  container: P(c),
                  isFullScreenContainer: !P(s),
                  onClose: f,
                },
                D(
                  {
                    _: 2,
                  },
                  [
                    ae(P(d), (t, n) => ({
                      name: n,
                      fn: I((t) => [z(e.$slots, n, ue(le(t)))]),
                    })),
                  ],
                ),
                1032,
                [`options`, `show`, `destroyOnClose`, `container`, `isFullScreenContainer`],
              ),
            ],
            8,
            [`to`],
          )
        )
      );
    },
  }),
  zhe = k({
    name: `ContextMenuGroup`,
    props: {
      disabled: {
        type: Boolean,
        default: !1,
      },
      hidden: {
        type: Boolean,
        default: !1,
      },
      clickHandler: {
        type: Function,
        default: null,
      },
      label: {
        type: String,
        default: ``,
      },
      icon: {
        type: String,
        default: ``,
      },
      iconFontClass: {
        type: String,
        default: `iconfont`,
      },
      checked: {
        type: Boolean,
        default: !1,
      },
      shortcut: {
        type: String,
        default: ``,
      },
      svgIcon: {
        type: String,
        default: ``,
      },
      svgProps: {
        type: Object,
        default: null,
      },
      preserveIconWidth: {
        type: Boolean,
        default: !0,
      },
      showRightArrow: {
        type: Boolean,
        default: !1,
      },
      clickClose: {
        type: Boolean,
        default: !0,
      },
      adjustSubMenuPosition: {
        type: Boolean,
        default: void 0,
      },
      maxHeight: {
        type: [String, Number],
        default: 0,
      },
      maxWidth: {
        type: [String, Number],
        default: 0,
      },
      minWidth: {
        type: [String, Number],
        default: 0,
      },
    },
    setup(e, t) {
      let n = R(`globalOptions`),
        { adjustSubMenuPosition: r, maxWidth: i, minWidth: a, maxHeight: o } = ee(e),
        s = typeof r.value < `u` ? r.value : n.value.adjustPosition,
        c = F(),
        l = F();
      return (
        t.expose({
          getSubMenuRef: () => c.value,
          getMenuItemRef: () => l.value,
        }),
        () =>
          Ne(
            C9,
            {
              ...e,
              ref: l,
              showRightArrow: !0,
              maxWidth: void 0,
              minWidth: void 0,
              maxHeight: void 0,
              adjustSubMenuPosition: void 0,
              hasChildren: !0,
            },
            t.slots.default
              ? {
                  submenu: (e) =>
                    Ne(
                      T9,
                      {
                        ref: c,
                        show: e.show,
                        maxWidth: i.value,
                        minWidth: a.value,
                        maxHeight: o.value,
                        adjustPosition: s,
                        parentMenuItemContext: e.context,
                      },
                      {
                        default: t.slots.default,
                      },
                    ),
                  ...phe(t.slots, `default`),
                }
              : t.slots,
          )
      );
    },
  });
function Bhe(e, t, n, r) {
  let i = F(!0),
    a = Ne(
      E9,
      {
        options: e,
        show: i,
        container: t,
        isFullScreenContainer: !n,
        onCloseAnimFinished: () => {
          Ue(null, t);
        },
        onClose: (t) => {
          var n;
          ((n = e.onClose) == null || n.call(e, t), (i.value = !1));
        },
      },
      r,
    );
  return (Ue(a, t), a.component);
}
function D9(e, t) {
  let n = p9(e);
  return Bhe(e, n.container, n.isNew, t).exposed;
}
var Vhe = {
  install(e) {
    ((e.config.globalProperties.$contextmenu = D9),
      e.component(`ContextMenu`, Rhe),
      e.component(`ContextMenuItem`, C9),
      e.component(`ContextMenuGroup`, zhe),
      e.component(`ContextMenuSperator`, w9),
      e.component(`ContextMenuSeparator`, w9),
      e.component(`ContextSubMenu`, T9));
  },
  showContextMenu(e, t) {
    return D9(e, t);
  },
  isAnyContextMenuOpen() {
    return she();
  },
  closeContextMenu: c9,
  transformMenuPosition: lhe,
};
gD();
var Hhe = Object.assign({
    "/resources/js/core/components/Forms/AutoSuggest.vue": bte,
    "/resources/js/core/components/Forms/BaseArrayCheckbox.vue": kte,
    "/resources/js/core/components/Forms/BaseButton.vue": Ite,
    "/resources/js/core/components/Forms/BaseCheckbox.vue": Rte,
    "/resources/js/core/components/Forms/BaseColorInput.vue": Gte,
    "/resources/js/core/components/Forms/BaseEditor.vue": Gu,
    "/resources/js/core/components/Forms/BaseInput.vue": Yu,
    "/resources/js/core/components/Forms/BaseLabel.vue": sd,
    "/resources/js/core/components/Forms/BaseMultiCheckbox.vue": ud,
    "/resources/js/core/components/Forms/BaseRadio.vue": _d,
    "/resources/js/core/components/Forms/BaseRadioGroup.vue": wd,
    "/resources/js/core/components/Forms/BaseRangeInput.vue": Nd,
    "/resources/js/core/components/Forms/BaseSelect.vue": Mne,
    "/resources/js/core/components/Forms/BaseSelectSearch.vue": Lne,
    "/resources/js/core/components/Forms/BaseSwitch.vue": $re,
    "/resources/js/core/components/Forms/BaseTextarea.vue": rie,
    "/resources/js/core/components/Forms/CustomCheckbox.vue": uie,
    "/resources/js/core/components/Forms/CustomDropdown.vue": Oh,
    "/resources/js/core/components/Forms/DatePicker.vue": qh,
    "/resources/js/core/components/Forms/EmojiPicker.vue": Py,
    "/resources/js/core/components/Forms/FilterButton.vue": $y,
    "/resources/js/core/components/Forms/FilterForm.vue": ab,
    "/resources/js/core/components/Forms/FormAction.vue": mb,
    "/resources/js/core/components/Forms/FormError.vue": gb,
    "/resources/js/core/components/Forms/FormInfo.vue": yb,
    "/resources/js/core/components/Forms/FormWizard.vue": Sb,
    "/resources/js/core/components/Forms/ImageUpload.vue": Zb,
    "/resources/js/core/components/Forms/InputDatePicker.vue": bae,
    "/resources/js/core/components/Forms/IsRequired.vue": wae,
    "/resources/js/core/components/Forms/MdEditor.vue": YK,
    "/resources/js/core/components/Forms/MediaUpload.vue": rq,
    "/resources/js/core/components/Forms/MintEditor.vue": vq,
    "/resources/js/core/components/Forms/NoteEditor.vue": Sq,
    "/resources/js/core/components/Forms/OtpInput.vue": Dq,
    "/resources/js/core/components/Forms/RowCopyButtons.vue": Nq,
    "/resources/js/core/components/Forms/SelectedColorPicker.vue": zq,
    "/resources/js/core/components/Forms/TabContent.vue": Gq,
    "/resources/js/core/components/Forms/TextContent.vue": qq,
    "/resources/js/core/components/Table/BaseHeader.vue": Qq,
    "/resources/js/core/components/Table/BaseTable.vue": rJ,
    "/resources/js/core/components/Table/DataCell.vue": dJ,
    "/resources/js/core/components/Table/DataHead.vue": mJ,
    "/resources/js/core/components/Table/DataRow.vue": gJ,
    "/resources/js/core/components/Table/DataTable.vue": vJ,
    "/resources/js/core/components/Table/ListItem.vue": YJ,
    "/resources/js/core/components/Table/Pagination.vue": ZJ,
    "/resources/js/core/components/Table/RowAction.vue": pY,
    "/resources/js/core/components/Table/ShowItem.vue": _Y,
    "/resources/js/core/components/Table/SimpleTable.vue": bY,
    "/resources/js/core/components/Ui/ActivityLog.vue": EY,
    "/resources/js/core/components/Ui/BaseAccordion.vue": LY,
    "/resources/js/core/components/Ui/BaseAccordionGroup.vue": VY,
    "/resources/js/core/components/Ui/BaseBadge.vue": WY,
    "/resources/js/core/components/Ui/BaseCalendar.vue": KY,
    "/resources/js/core/components/Ui/BaseCard.vue": jX,
    "/resources/js/core/components/Ui/BaseComment.vue": zX,
    "/resources/js/core/components/Ui/BaseDataDef.vue": QX,
    "/resources/js/core/components/Ui/BaseDataList.vue": eZ,
    "/resources/js/core/components/Ui/BaseDataView.vue": nZ,
    "/resources/js/core/components/Ui/BaseFieldset.vue": oZ,
    "/resources/js/core/components/Ui/BaseFlexCard.vue": lZ,
    "/resources/js/core/components/Ui/BaseFlexContainer.vue": mZ,
    "/resources/js/core/components/Ui/BaseHeading.vue": yZ,
    "/resources/js/core/components/Ui/BaseImport.vue": wZ,
    "/resources/js/core/components/Ui/BaseLoader.vue": IZ,
    "/resources/js/core/components/Ui/BaseModal.vue": RZ,
    "/resources/js/core/components/Ui/BaseSideover.vue": qZ,
    "/resources/js/core/components/Ui/BaseStatBox.vue": sQ,
    "/resources/js/core/components/Ui/BaseTab.vue": dQ,
    "/resources/js/core/components/Ui/BaseTreeView.vue": _Q,
    "/resources/js/core/components/Ui/BaseTreeViewList.vue": TQ,
    "/resources/js/core/components/Ui/BaseTreeViewNode.vue": zQ,
    "/resources/js/core/components/Ui/BaseTreeViewPanel.vue": QQ,
    "/resources/js/core/components/Ui/ButtonGroup.vue": g$,
    "/resources/js/core/components/Ui/CardList.vue": x$,
    "/resources/js/core/components/Ui/CardView.vue": O$,
    "/resources/js/core/components/Ui/ContactField.vue": I$,
    "/resources/js/core/components/Ui/CopyContent.vue": z$,
    "/resources/js/core/components/Ui/CountDownTimer.vue": U$,
    "/resources/js/core/components/Ui/DetailLayoutVertical.vue": G$,
    "/resources/js/core/components/Ui/DropdownButton.vue": Z$,
    "/resources/js/core/components/Ui/DropdownItem.vue": e1,
    "/resources/js/core/components/Ui/DropdownMenu.vue": n1,
    "/resources/js/core/components/Ui/DropdownUpdateBadge.vue": i1,
    "/resources/js/core/components/Ui/EmptyCard.vue": l1,
    "/resources/js/core/components/Ui/FloatingBottom.vue": p1,
    "/resources/js/core/components/Ui/FloatingMenu.vue": y1,
    "/resources/js/core/components/Ui/FloatingMenuItem.vue": C1,
    "/resources/js/core/components/Ui/FlyoutMenu.vue": T1,
    "/resources/js/core/components/Ui/HelperText.vue": k1,
    "/resources/js/core/components/Ui/HorizontalList.vue": j1,
    "/resources/js/core/components/Ui/HorizontalListItem.vue": I1,
    "/resources/js/core/components/Ui/ImageLabel.vue": V1,
    "/resources/js/core/components/Ui/KanBanView.vue": W1,
    "/resources/js/core/components/Ui/ListContainerVertical.vue": Z1,
    "/resources/js/core/components/Ui/ListItemView.vue": e0,
    "/resources/js/core/components/Ui/ListMedia.vue": Jle,
    "/resources/js/core/components/Ui/NotificationBar.vue": pue,
    "/resources/js/core/components/Ui/ProgressBar.vue": _ue,
    "/resources/js/core/components/Ui/RatingStar.vue": bue,
    "/resources/js/core/components/Ui/ScrollableTabGroup.vue": Eue,
    "/resources/js/core/components/Ui/ScrollableTabItem.vue": Mue,
    "/resources/js/core/components/Ui/ShowDateTime.vue": Pue,
    "/resources/js/core/components/Ui/TabGroup.vue": Iue,
    "/resources/js/core/components/Ui/TabItem.vue": Hue,
    "/resources/js/core/components/Ui/TagList.vue": Wue,
    "/resources/js/core/components/Ui/TagSummary.vue": que,
    "/resources/js/core/components/Ui/TextMuted.vue": Xue,
    "/resources/js/core/components/Ui/WebcamCapture.vue": $ue,
    "/resources/js/core/components/Utility/BaseAlert.vue": ode,
    "/resources/js/core/components/Utility/BaseLink.vue": fde,
    "/resources/js/core/components/Utility/Tooltip.vue": gde,
  }),
  Uhe = (e) => {
    (e.provide(`$http`, d),
      e.provide(`$form`, l),
      e.provide(`$cal`, A6),
      e.provide(`$trans`, g),
      e.provide(`$swal`, cb.default),
      e.provide(`moment`, dx),
      e.provide(`momentz`, j6.default),
      e.provide(`emitter`, w6),
      (e.config.globalProperties.$http = d),
      (e.config.globalProperties.$form = l),
      (e.config.globalProperties.$cal = A6),
      (e.config.globalProperties.$trans = g),
      (e.config.globalProperties.$swal = cb.default),
      (e.config.globalProperties.moment = dx),
      (e.config.globalProperties.emitter = w6),
      e.use(S, {
        position: `bottom-right`,
        timeout: 5e3,
        closeOnClick: !0,
        pauseOnFocusLoss: !0,
        pauseOnHover: !0,
        draggable: !0,
        draggablePercent: 0.6,
        showCloseButtonOnHover: !1,
        hideProgressBar: !0,
        closeButton: `button`,
        icon: !0,
        rtl: !1,
      }),
      e.use(Kde),
      e.use(ohe),
      e.use(Vhe),
      e.directive(`tooltip`, Wfe),
      e.directive(`click-outside`, {
        mounted(e, t) {
          ((e.clickOutsideEvent = (n) => {
            e === n.target || e.contains(n.target) || t.value(n);
          }),
            setTimeout(() => {
              document.addEventListener(`click`, e.clickOutsideEvent, !0);
            }, 0));
        },
        unmounted(e) {
          document.removeEventListener(`click`, e.clickOutsideEvent, !0);
        },
      }),
      Object.entries(Hhe).forEach(([t, n]) => {
        let r = t
          .split(`/`)
          .pop()
          .replace(/\.\w+$/, ``);
        e.component(r, n.default);
      }),
      e.component(`VMenu`, Kfe),
      e.component(`VDropdown`, Gfe),
      e.component(`flat-pickr`, Fde),
      e.component(`CheckCircleIcon`, Ly),
      e.component(`ExclamationCircleIcon`, Gy),
      e.component(`XCircleIcon`, Zy),
      e.component(`InformationCircleIcon`, Ky),
      e.component(`XMarkIcon`, Qy),
      e.component(`EllipsisVerticalIcon`, Wy));
  };
B();
var Whe = {
    class: `mb-10 text-center`,
  },
  Ghe = {
    key: 0,
    class: `text-3xl font-extrabold text-gray-900 dark:text-gray-400`,
  },
  Khe = Object.assign(
    {
      name: `GuestHeader`,
    },
    {
      props: {
        label: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`ParentTransition`);
          return (
            A(),
            L(
              r,
              {
                appear: ``,
                direction: `ltr`,
                visibility: !0,
              },
              {
                default: I(() => [
                  W(`div`, Whe, [
                    e.label ? (A(), M(`h2`, Ghe, T(e.label), 1)) : U(``, !0),
                    z(t.$slots, `default`),
                  ]),
                ]),
                _: 3,
              },
            )
          );
        };
      },
    },
  );
B();
var qhe = {
    class: `px-4 sm:px-6 lg:px-0`,
  },
  Jhe = {
    key: 0,
  },
  Yhe = {
    class: `sm:hidden`,
    "aria-label": `Back`,
  },
  Xhe = {
    class: `flex items-center text-sm font-medium text-gray-400 hover:text-gray-200`,
  },
  Zhe = {
    class: `hidden sm:flex`,
    "aria-label": `Breadcrumb`,
  },
  Qhe = {
    role: `list`,
    class: `flex items-center space-x-4`,
  },
  $he = {
    class: `flex`,
  },
  ege = {
    class: `flex items-center`,
  },
  tge = {
    class: `flex items-center`,
  },
  nge = {
    "aria-current": `page`,
    class: `text-sm font-medium text-gray-400`,
  },
  rge = {
    class: `mt-2 md:flex md:items-center md:justify-between`,
  },
  ige = {
    class: `min-w-0 flex-1 dark:text-gray-400`,
  },
  age = {
    class: `text-xl font-bold leading-7 sm:truncate sm:text-2xl`,
  },
  oge = {
    key: 0,
  },
  sge = {
    class: `mt-4 flex shrink-0 md:ml-4 md:mt-0 justify-end`,
  },
  cge = Object.assign(
    {
      name: `PageHeader`,
    },
    {
      props: {
        title: {
          type: String,
          default: ``,
        },
        subTitle: {
          type: String,
          default: ``,
        },
        navs: {
          type: Array,
          default: [],
        },
        noBreadcrumb: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = Ec(),
          { direction: n, isRtl: r, isLtr: i } = Kh(),
          a = (e) =>
            typeof e.path == `string`
              ? {
                  name: e.path,
                }
              : e.path;
        return (n, o) => {
          let s = j(`router-link`),
            c = j(`ParentTransition`);
          return (
            A(),
            L(
              c,
              {
                appear: ``,
                direction: `ltr`,
                visibility: !0,
              },
              {
                default: I(() => [
                  W(`div`, qhe, [
                    e.noBreadcrumb
                      ? U(``, !0)
                      : (A(),
                        M(`div`, Jhe, [
                          W(`nav`, Yhe, [
                            W(`div`, Xhe, [
                              W(
                                `div`,
                                {
                                  class: `cursor-pointer`,
                                  onClick: (o[0] ||= (e) => P(t).go(-1)),
                                },
                                [
                                  (o[1] ||= W(
                                    `i`,
                                    {
                                      class: `fas fa-chevron-left -ml-1 mr-1 h-5 w-5 shrink-0 text-gray-500`,
                                      "aria-hidden": `true`,
                                    },
                                    null,
                                    -1,
                                  )),
                                  H(` ` + T(n.$trans(`general.back`)), 1),
                                ],
                              ),
                            ]),
                          ]),
                          W(`nav`, Zhe, [
                            W(`ol`, Qhe, [
                              W(`li`, null, [
                                W(`div`, $he, [
                                  N(
                                    s,
                                    {
                                      to: {
                                        name: `Dashboard`,
                                      },
                                      class: `text-sm font-medium text-gray-400 hover:text-gray-600`,
                                    },
                                    {
                                      default: I(() => [
                                        (o[2] ||= W(
                                          `i`,
                                          {
                                            class: `fas fa-home mr-2`,
                                          },
                                          null,
                                          -1,
                                        )),
                                        H(` ` + T(n.$trans(`dashboard.dashboard`)), 1),
                                      ]),
                                      _: 1,
                                    },
                                  ),
                                ]),
                              ]),
                              (A(!0),
                              M(
                                ke,
                                null,
                                ae(
                                  e.navs,
                                  (e) => (
                                    A(),
                                    M(`li`, null, [
                                      W(`div`, ege, [
                                        W(
                                          `i`,
                                          {
                                            class: O([
                                              `fas fa-sm ltr:mr-2 rtl:ml-2 w-5 shrink-0 text-gray-500`,
                                              {
                                                "fa-chevron-right": P(i),
                                                "fa-chevron-left": P(r),
                                              },
                                            ]),
                                            "aria-hidden": `true`,
                                          },
                                          null,
                                          2,
                                        ),
                                        N(
                                          s,
                                          {
                                            to: a(e),
                                            class: `text-sm font-medium text-gray-400 hover:text-gray-600`,
                                          },
                                          {
                                            default: I(() => [H(T(e.label), 1)]),
                                            _: 2,
                                          },
                                          1032,
                                          [`to`],
                                        ),
                                      ]),
                                    ])
                                  ),
                                ),
                                256,
                              )),
                              W(`li`, null, [
                                W(`div`, tge, [
                                  W(
                                    `i`,
                                    {
                                      class: O([
                                        `fas fa-sm ltr:mr-2 rtl:ml-2 w-5 shrink-0 text-gray-500`,
                                        {
                                          "fa-chevron-right": P(i),
                                          "fa-chevron-left": P(r),
                                        },
                                      ]),
                                      "aria-hidden": `true`,
                                    },
                                    null,
                                    2,
                                  ),
                                  W(`span`, nge, T(e.title), 1),
                                ]),
                              ]),
                            ]),
                          ]),
                        ])),
                    W(`div`, rge, [
                      W(`div`, ige, [
                        W(`h2`, age, T(e.title), 1),
                        e.subTitle ? (A(), M(`h6`, oge, T(e.subTitle), 1)) : U(``, !0),
                      ]),
                      W(`div`, sge, [z(n.$slots, `default`)]),
                    ]),
                  ]),
                ]),
                _: 3,
              },
            )
          );
        };
      },
    },
  );
function O9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n) r !== `__proto__` && (e[r] = n[r]);
  }
  return e;
}
var lge = {
  read: function (e) {
    return (
      e[0] === `"` && (e = e.slice(1, -1)),
      e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    );
  },
  write: function (e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent,
    );
  },
};
function k9(e, t) {
  function n(n, r, i) {
    if (!(typeof document > `u`)) {
      ((i = O9({}, t, i)),
        typeof i.expires == `number` && (i.expires = new Date(Date.now() + i.expires * 864e5)),
        (i.expires &&= i.expires.toUTCString()),
        (n = encodeURIComponent(n)
          .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
          .replace(/[()]/g, escape)));
      var a = ``;
      for (var o in i) i[o] && ((a += `; ` + o), i[o] !== !0 && (a += `=` + i[o].split(`;`)[0]));
      return (document.cookie = n + `=` + e.write(r, n) + a);
    }
  }
  function r(t) {
    if (!(typeof document > `u` || (arguments.length && !t))) {
      for (
        var n = document.cookie ? document.cookie.split(`; `) : [], r = {}, i = 0;
        i < n.length;
        i++
      ) {
        var a = n[i].split(`=`),
          o = a.slice(1).join(`=`);
        try {
          var s = decodeURIComponent(a[0]);
          if ((s in r || (r[s] = e.read(o, s)), t === s)) break;
        } catch {}
      }
      return t ? r[t] : r;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function (e, t) {
        n(
          e,
          ``,
          O9({}, t, {
            expires: -1,
          }),
        );
      },
      withAttributes: function (e) {
        return k9(this.converter, O9({}, this.attributes, e));
      },
      withConverter: function (e) {
        return k9(O9({}, this.converter, e), this.attributes);
      },
    },
    {
      attributes: {
        value: Object.freeze(t),
      },
      converter: {
        value: Object.freeze(e),
      },
    },
  );
}
var A9 = k9(lge, {
  path: `/`,
});
B();
var uge = {
    class: `flex space-x-2`,
  },
  dge = {
    class: `flex`,
  },
  fge = {
    class: `flex gap-2 text-xs py-2 px-4`,
  },
  pge = {
    class: `divide-y divide-gray-200 dark:divide-gray-600 max-h-96 scroller-thin-y scroller-hidden`,
  },
  mge = Object.assign(
    {
      name: `PageHeaderAction`,
    },
    {
      props: {
        name: {
          type: String,
          default: ``,
        },
        url: {
          type: String,
          default: ``,
        },
        title: {
          type: String,
          default: ``,
        },
        moduleDropdownDirection: {
          type: String,
          default: null,
          validator: (e) => [null, `left`, `right`].includes(e),
        },
        configPath: {
          type: String,
          default: ``,
        },
        actions: {
          type: Array,
          default: [],
        },
        dropdownActions: {
          type: Array,
          default: [],
        },
        additionalDropdownActionsQuery: {
          type: Object,
          default: () => ({}),
        },
        additionalActions: {
          type: Array,
          default: [],
        },
        showBulkAction: {
          type: Boolean,
          default: !1,
        },
        bulkActions: {
          type: Array,
          default: [],
        },
        headers: {
          type: Array,
          default: [],
        },
      },
      emits: [`toggleFilter`, `toggleImport`, `onBulkAction`, `refresh`],
      setup(e, { emit: t }) {
        Te();
        let n = Dc(),
          r = Ec(),
          { isRtl: i } = Kh(),
          a = R(`emitter`),
          o = t,
          s = e,
          c = V(() => s.actions.includes(`view`)),
          l = V(() => s.actions.includes(`create`)),
          u = V(() => s.actions.includes(`new`)),
          d = V(() => s.actions.includes(`config`)),
          f = V(() => s.actions.includes(`filter`)),
          p = V(() => s.actions.includes(`list`)),
          m = V(() => s.dropdownActions.includes(`import`)),
          h = V(() => s.dropdownActions.includes(`print`)),
          g = V(() => s.dropdownActions.includes(`pdf`)),
          v = V(() => s.dropdownActions.includes(`excel`)),
          y = V(() => s.dropdownActions.includes(`export_all_excel`)),
          b = V(() => s.name + `Create`),
          x = V(() => s.name + `New`),
          S = V(() => (s.configPath ? s.configPath : s.name + `Config`)),
          C = V(() => s.name + `List`),
          w = V(() => s.headers.filter((e) => e.label)),
          E = `${s.name}_columns`,
          D = (e, t = null) => {
            let r = `/app/` + s.url + `export`,
              i = {
                ...n.query,
                ...s.additionalDropdownActionsQuery,
                columns: w.value
                  .filter((e) => e.visibility)
                  .map((e) => e.key)
                  .join(`,`),
                output: e,
              };
            (e === `pdf` && (t?.cmdKey || t?.metaKey ? (i.download = !0) : delete i.download),
              e == `export_all_excel` && ((i.action = `excel`), delete i.page, delete i.perPage),
              window.open(et(r, i), `_blank`).focus());
          },
          ee = async (e) => {
            (await r.push({
              name: n.name,
              query: {
                ...n.query,
                ...e,
              },
            }),
              o(`refresh`));
          },
          te = () => {
            w.value.forEach((e) => {
              e.visibility = !0;
            });
          },
          k = () => {
            w.value.forEach((e, t) => {
              t !== 0 && (e.visibility = !1);
            });
          },
          ne = (e) => {
            let t = e.filter((e) => e.visibility).map((e) => e.key);
            A9.set(E, JSON.stringify(t), {
              expires: 1,
            });
          };
        return (t, o) => {
          let s = j(`BaseButton`),
            E = j(`DropdownMenu`),
            re = j(`DropdownItem`),
            ie = j(`BaseCheckbox`),
            oe = j(`EllipsisVerticalIcon`),
            se = ve(`tooltip`);
          return (
            A(),
            M(`div`, uge, [
              t.$slots.moduleOption
                ? (A(),
                  L(
                    E,
                    {
                      key: 0,
                      "double-top-margin": ``,
                      "right-margin": !1,
                      "no-width": ``,
                      direction: e.moduleDropdownDirection
                        ? e.moduleDropdownDirection
                        : P(i)
                          ? `right`
                          : `left`,
                    },
                    {
                      clickable: I(() => [
                        N(
                          s,
                          {
                            design: `white`,
                          },
                          {
                            default: I(() => [
                              W(`span`, dge, [
                                z(t.$slots, `moduleOptionLabel`, {}, () => [
                                  H(T(t.$trans(`general.more`)), 1),
                                ]),
                                N(P(zy), {
                                  class: O([`ml-1 h-5 w-5`]),
                                  "aria-hidden": `true`,
                                }),
                              ]),
                            ]),
                            _: 3,
                          },
                        ),
                      ]),
                      default: I(() => [z(t.$slots, `moduleOption`)]),
                      _: 3,
                    },
                    8,
                    [`direction`],
                  ))
                : U(``, !0),
              z(t.$slots, `default`),
              (A(!0),
              M(
                ke,
                null,
                ae(
                  e.additionalActions,
                  (e) => (
                    A(),
                    L(
                      s,
                      {
                        design: `white`,
                        onClick: (t) => P(r).push(e.path),
                      },
                      {
                        default: I(() => [H(T(e.label), 1)]),
                        _: 2,
                      },
                      1032,
                      [`onClick`],
                    )
                  ),
                ),
                256,
              )),
              l.value
                ? (A(),
                  L(
                    s,
                    {
                      key: 1,
                      design: `white`,
                      onClick: (o[0] ||= (e) =>
                        P(r).push({
                          name: b.value,
                          params: P(n).params,
                        })),
                    },
                    {
                      default: I(() => [
                        H(
                          T(
                            t.$trans(`global.add`, {
                              attribute: e.title,
                            }),
                          ),
                          1,
                        ),
                      ]),
                      _: 1,
                    },
                  ))
                : U(``, !0),
              u.value
                ? (A(),
                  L(
                    s,
                    {
                      key: 2,
                      design: `white`,
                      onClick: (o[1] ||= (e) =>
                        P(r).push({
                          name: x.value,
                          params: P(n).params,
                        })),
                    },
                    {
                      default: I(() => [
                        H(
                          T(
                            t.$trans(`global.new`, {
                              attribute: e.title,
                            }),
                          ),
                          1,
                        ),
                      ]),
                      _: 1,
                    },
                  ))
                : U(``, !0),
              e.showBulkAction && e.bulkActions.length
                ? (A(),
                  L(
                    E,
                    {
                      key: 3,
                      "no-width": ``,
                      "top-margin": ``,
                      direction: P(i) ? `right` : `left`,
                    },
                    {
                      clickable: I(() => [
                        N(
                          s,
                          {
                            design: `white`,
                          },
                          {
                            default: I(() => [
                              H(T(t.$trans(`general.bulk_action`)) + ` `, 1),
                              (o[14] ||= W(
                                `i`,
                                {
                                  class: `fas fa-chevron-down ltr:ml-2 rtl:mr-2`,
                                },
                                null,
                                -1,
                              )),
                            ]),
                            _: 1,
                          },
                        ),
                      ]),
                      default: I(() => [
                        (A(!0),
                        M(
                          ke,
                          null,
                          ae(
                            e.bulkActions,
                            (e) => (
                              A(),
                              L(
                                re,
                                {
                                  icon: e.icon,
                                  key: e.name,
                                  onClick: (n) => t.$emit(`onBulkAction`, e.name),
                                },
                                {
                                  default: I(() => [H(T(e.label), 1)]),
                                  _: 2,
                                },
                                1032,
                                [`icon`, `onClick`],
                              )
                            ),
                          ),
                          128,
                        )),
                      ]),
                      _: 1,
                    },
                    8,
                    [`direction`],
                  ))
                : U(``, !0),
              f.value
                ? (A(),
                  L(
                    s,
                    {
                      key: 4,
                      design: `white`,
                      onClick: (o[2] ||= (e) => t.$emit(`toggleFilter`)),
                    },
                    {
                      default: I(() => [
                        ...(o[15] ||= [
                          W(
                            `i`,
                            {
                              class: `fas fa-filter`,
                            },
                            null,
                            -1,
                          ),
                        ]),
                      ]),
                      _: 1,
                    },
                  ))
                : U(``, !0),
              d.value
                ? (A(),
                  L(
                    s,
                    {
                      key: 5,
                      design: `white`,
                      onClick: (o[3] ||= (e) =>
                        P(r).push({
                          name: S.value,
                        })),
                    },
                    {
                      default: I(() => [
                        ...(o[16] ||= [
                          W(
                            `i`,
                            {
                              class: `fas fa-cog`,
                            },
                            null,
                            -1,
                          ),
                        ]),
                      ]),
                      _: 1,
                    },
                  ))
                : U(``, !0),
              p.value
                ? (A(),
                  L(
                    s,
                    {
                      key: 6,
                      onClick: (o[4] ||= (e) =>
                        P(r).push({
                          name: C.value,
                          params: P(n).params,
                        })),
                    },
                    {
                      default: I(() => [
                        H(
                          T(
                            t.$trans(`global.list_all`, {
                              attribute: e.title,
                            }),
                          ),
                          1,
                        ),
                      ]),
                      _: 1,
                    },
                  ))
                : U(``, !0),
              c.value && P(n).query.view != `list`
                ? Re(
                    (A(),
                    L(
                      s,
                      {
                        key: 7,
                        design: `white`,
                        onClick: (o[5] ||= (e) =>
                          ee({
                            view: `list`,
                          })),
                      },
                      {
                        default: I(() => [
                          ...(o[17] ||= [
                            W(
                              `i`,
                              {
                                class: `fas fa-list`,
                              },
                              null,
                              -1,
                            ),
                          ]),
                        ]),
                        _: 1,
                      },
                    )),
                    [
                      [
                        se,
                        t.$trans(`global._view`, {
                          attribute: t.$trans(`general.list`),
                        }),
                      ],
                    ],
                  )
                : U(``, !0),
              c.value && P(n).query.view == `list`
                ? Re(
                    (A(),
                    L(
                      s,
                      {
                        key: 8,
                        design: `white`,
                        onClick: (o[6] ||= (e) =>
                          ee({
                            view: `card`,
                          })),
                      },
                      {
                        default: I(() => [
                          ...(o[18] ||= [
                            W(
                              `i`,
                              {
                                class: `fas fa-th-large`,
                              },
                              null,
                              -1,
                            ),
                          ]),
                        ]),
                        _: 1,
                      },
                    )),
                    [
                      [
                        se,
                        t.$trans(`global._view`, {
                          attribute: t.$trans(`general.card`),
                        }),
                      ],
                    ],
                  )
                : U(``, !0),
              z(t.$slots, `after`),
              P(n).query.view != `board` && w.value.length
                ? Re(
                    (A(),
                    L(
                      E,
                      {
                        key: 9,
                        "double-top-margin": ``,
                        "right-margin": !1,
                        "no-width": ``,
                        direction: P(i) ? `right` : `left`,
                      },
                      {
                        clickable: I(() => [
                          N(
                            s,
                            {
                              design: `white`,
                            },
                            {
                              default: I(() => [
                                ...(o[19] ||= [
                                  W(
                                    `i`,
                                    {
                                      class: `fas fa-table-columns`,
                                    },
                                    null,
                                    -1,
                                  ),
                                ]),
                              ]),
                              _: 1,
                            },
                          ),
                        ]),
                        default: I(() => [
                          W(`div`, fge, [
                            W(
                              `span`,
                              {
                                onClick: te,
                                class: `cursor-pointer text-gray-400`,
                              },
                              T(t.$trans(`general.select_all`)),
                              1,
                            ),
                            W(
                              `span`,
                              {
                                onClick: k,
                                class: `cursor-pointer text-gray-400`,
                              },
                              T(t.$trans(`general.unselect_all`)),
                              1,
                            ),
                          ]),
                          W(`div`, pge, [
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                w.value,
                                (e, t) => (
                                  A(),
                                  M(
                                    `div`,
                                    {
                                      key: e.key,
                                      class: `flex px-4 py-2 text-sm`,
                                    },
                                    [
                                      N(
                                        ie,
                                        {
                                          modelValue: e.visibility,
                                          "onUpdate:modelValue": [
                                            (t) => (e.visibility = t),
                                            (o[7] ||= (e) => ne(w.value)),
                                          ],
                                          disabled: t === 0,
                                          label: e.label,
                                        },
                                        null,
                                        8,
                                        [`modelValue`, `onUpdate:modelValue`, `disabled`, `label`],
                                      ),
                                    ],
                                  )
                                ),
                              ),
                              128,
                            )),
                          ]),
                        ]),
                        _: 1,
                      },
                      8,
                      [`direction`],
                    )),
                    [
                      [
                        se,
                        t.$trans(`global.select`, {
                          attribute: t.$trans(`general.column`),
                        }),
                      ],
                    ],
                  )
                : U(``, !0),
              e.dropdownActions.length || t.$slots.dropdown
                ? (A(),
                  L(
                    E,
                    {
                      key: 10,
                      "double-top-margin": ``,
                      "right-margin": !1,
                      "no-width": ``,
                      direction: P(i) ? `right` : `left`,
                    },
                    {
                      clickable: I(() => [
                        N(
                          s,
                          {
                            design: `white`,
                          },
                          {
                            default: I(() => [
                              N(oe, {
                                class: `h-5 w-5`,
                                "aria-hidden": `true`,
                              }),
                            ]),
                            _: 1,
                          },
                        ),
                      ]),
                      default: I(() => [
                        m.value
                          ? (A(),
                            L(
                              re,
                              {
                                key: 0,
                                icon: `fas fa-download`,
                                onClick: (o[8] ||= (e) => t.$emit(`toggleImport`)),
                              },
                              {
                                default: I(() => [H(T(t.$trans(`general.import`)), 1)]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                        N(
                          re,
                          {
                            icon: `fas fa-sync`,
                            onClick: (o[9] ||= (e) => P(a).emit(`listItems`)),
                          },
                          {
                            default: I(() => [H(T(t.$trans(`general.refresh`)), 1)]),
                            _: 1,
                          },
                        ),
                        h.value
                          ? (A(),
                            L(
                              re,
                              {
                                key: 1,
                                icon: `fas fa-print`,
                                onClick: (o[10] ||= (e) => D(`print`)),
                              },
                              {
                                default: I(() => [H(T(t.$trans(`general.print`)), 1)]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                        g.value
                          ? (A(),
                            L(
                              re,
                              {
                                key: 2,
                                icon: `fas fa-file-pdf`,
                                onClick: (o[11] ||= (e) => D(`pdf`, e)),
                              },
                              {
                                default: I(() => [H(T(t.$trans(`general.pdf`)), 1)]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                        v.value
                          ? (A(),
                            L(
                              re,
                              {
                                key: 3,
                                icon: `fas fa-file-excel`,
                                onClick: (o[12] ||= (e) => D(`excel`)),
                              },
                              {
                                default: I(() => [H(T(t.$trans(`general.excel`)), 1)]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                        y.value
                          ? (A(),
                            L(
                              re,
                              {
                                key: 4,
                                icon: `fas fa-file-excel`,
                                onClick: (o[13] ||= (e) => D(`export_all_excel`)),
                              },
                              {
                                default: I(() => [H(T(t.$trans(`general.export_all_excel`)), 1)]),
                                _: 1,
                              },
                            ))
                          : U(``, !0),
                        z(t.$slots, `dropdown`),
                      ]),
                      _: 3,
                    },
                    8,
                    [`direction`],
                  ))
                : U(``, !0),
            ])
          );
        };
      },
    },
  );
B();
var j9 = {
  small: 768,
  medium: 992,
  large: 1200,
  extraLarge: 1440,
};
function M9() {
  let e = F({
      small: window.innerWidth <= j9.small,
      medium: window.innerWidth > j9.small && window.innerWidth <= j9.medium,
      large: window.innerWidth > j9.medium && window.innerWidth <= j9.large,
      extraLarge: window.innerWidth > j9.large,
    }),
    t = () => {
      let t = window.innerWidth;
      e.value = {
        small: t <= j9.small,
        medium: t > j9.small && t <= j9.medium,
        large: t > j9.medium && t <= j9.large,
        extraLarge: t > j9.large,
      };
    };
  return (
    Me(
      () => (
        window.addEventListener(`resize`, t),
        t(),
        () => {
          window.removeEventListener(`resize`, t);
        }
      ),
    ),
    {
      screenSize: e,
    }
  );
}
B();
var hge = [`src`],
  gge = {
    class: `py-1`,
  },
  _ge = {
    class: `px-4 py-2 text-sm text-gray-700 dark:text-gray-300`,
  },
  vge = {
    class: `font-medium`,
  },
  yge = {
    class: `block text-xs`,
  },
  bge = {
    key: 0,
    class: `block text-xs`,
  },
  xge = {
    class: `py-1 max-h-64 scroller-thin-y scroller-hidden`,
  },
  Sge = {
    key: 0,
    class: `flex justify-between`,
  },
  Cge = {
    key: 1,
    class: `flex justify-between`,
  },
  wge = {
    key: 0,
    class: `py-1`,
  },
  Tge = {
    class: `flex items-center justify-between`,
  },
  Ege = {
    key: 0,
    class: `fas fa-check text-green-500 ltr:ml-3 rtl:mr-3`,
  },
  Dge = {
    class: `py-1`,
  },
  Oge = Object.assign(
    {
      name: `ProfileDropdown`,
    },
    {
      setup(e) {
        let { screenSize: t } = M9(),
          n = $e(),
          r = Dc(),
          i = Ec(),
          a = (0, AX.useLoading)({}),
          { isRtl: o } = Kh(),
          s = Hh(`avatar`),
          c = Hh(`profile.name`),
          l = Hh(`email`),
          u = Hh(`preference.layout.display`),
          d = Vh(`system.enableAuthorSupport`),
          f = Vh(`teams`);
        Uh();
        let p = Hh(`currentTeamId`),
          m = V(() => f.value.find((e) => e.id == p.value)),
          h = Vh(`system.qrCodeAttendanceEnabled`).value,
          g = V(() => f.value.find((e) => e.id == p.value)),
          v = async () => {
            let e = a.show();
            await n
              .dispatch(`auth/user/logout`, {})
              .then(() => {
                (e.hide(),
                  i.push({
                    name: `Login`,
                  }));
              })
              .catch((t) => {
                e.hide();
              });
          },
          y = (e) => {
            n.dispatch(`layout/setUserLayout`, e);
          },
          b = () => {
            y({
              display: u.value == `light` ? `dark` : `light`,
            });
          },
          x = V(() => n.getters[`auth/user/hasMixedRoles`]),
          S = V(() => n.getters[`auth/user/activeRole`]),
          C = [`student`, `guardian`],
          w = V(() => {
            let e = n.getters[`auth/user/getUser`].roles ?? [],
              t = [],
              r = e.some((e) => C.includes(e)),
              i = e.some((e) => !C.includes(e));
            if (r) {
              let n = e.find((e) => C.includes(e));
              t.push({
                value: n,
                label: n.charAt(0).toUpperCase() + n.slice(1),
              });
            }
            if (i) {
              let n = e.find((e) => !C.includes(e));
              t.push({
                value: n,
                label: n.charAt(0).toUpperCase() + n.slice(1),
              });
            }
            return t;
          }),
          E = F(!1),
          D = async (e) => {
            if (!(E.value || S.value === e)) {
              E.value = !0;
              try {
                (await n.dispatch(`auth/user/switchRole`, e),
                  i.push({
                    name: `Dashboard`,
                  }));
              } finally {
                E.value = !1;
              }
            }
          };
        return (e, n) => {
          let a = j(`DropdownItem`),
            f = j(`DropdownMenu`);
          return (
            A(),
            L(
              f,
              {
                "double-top-margin": ``,
                "right-margin": !1,
                direction: P(o) ? `right` : `left`,
              },
              {
                clickable: I(() => [
                  W(
                    `img`,
                    {
                      class: O([
                        `rounded-full`,
                        {
                          "h-8 w-8": !P(t).small,
                          "h-6 w-6": P(t).small,
                        },
                      ]),
                      src: P(s),
                      alt: ``,
                    },
                    null,
                    10,
                    hge,
                  ),
                ]),
                default: I(() => [
                  W(`div`, gge, [
                    W(`div`, _ge, [
                      W(
                        `span`,
                        vge,
                        T(
                          e.$trans(`general.greeting_message`, {
                            name: P(c),
                          }),
                        ),
                        1,
                      ),
                      W(`span`, yge, T(P(l)), 1),
                      g.value?.id ? (A(), M(`span`, bge, T(g.value?.name), 1)) : U(``, !0),
                    ]),
                  ]),
                  W(`div`, xge, [
                    P(Wh)(`config:store`) && P(t).small
                      ? (A(),
                        L(
                          a,
                          {
                            key: 0,
                            disabled: P(r).name === `ConfigGeneral`,
                            onClick: (n[0] ||= (e) =>
                              P(i).push({
                                name: `Config`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`config.config`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    N(
                      a,
                      {
                        onClick: (n[1] ||= (e) => b()),
                      },
                      {
                        default: I(() => [
                          P(u) == `dark`
                            ? (A(),
                              M(`div`, Sge, [
                                W(
                                  `span`,
                                  null,
                                  T(
                                    e.$trans(`global.choose`, {
                                      attribute: e.$trans(`general.light_mode`),
                                    }),
                                  ),
                                  1,
                                ),
                                (n[13] ||= W(
                                  `span`,
                                  {
                                    class: `ltr:ml-4 rtl:mr-4`,
                                  },
                                  [
                                    W(`i`, {
                                      class: `fas fa-sun`,
                                    }),
                                  ],
                                  -1,
                                )),
                              ]))
                            : U(``, !0),
                          P(u) == `light`
                            ? (A(),
                              M(`div`, Cge, [
                                W(
                                  `span`,
                                  null,
                                  T(
                                    e.$trans(`global.choose`, {
                                      attribute: e.$trans(`general.dark_mode`),
                                    }),
                                  ),
                                  1,
                                ),
                                (n[14] ||= W(
                                  `span`,
                                  {
                                    class: `ltr:ml-4 rtl:mr-4`,
                                  },
                                  [
                                    W(`i`, {
                                      class: `fas fa-moon`,
                                    }),
                                  ],
                                  -1,
                                )),
                              ]))
                            : U(``, !0),
                        ]),
                        _: 1,
                      },
                    ),
                    P(Wh)(`subscription:manage`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 1,
                            disabled: P(r).name === `SubscriptionList`,
                            onClick: (n[2] ||= (e) =>
                              P(i).push({
                                name: `Subscription`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`saas.subscription.subscription`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    P(Wh)(`organization:manage`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 2,
                            disabled: P(r).name === `OrganizationList`,
                            onClick: (n[3] ||= (e) =>
                              P(i).push({
                                name: `Organization`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`organization.organization`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    P(Wh)(`team:manage`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 3,
                            disabled: P(r).name === `TeamList`,
                            onClick: (n[4] ||= (e) =>
                              P(i).push({
                                name: `Team`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`team.team`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    P(Wh)(`team:manage`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 4,
                            disabled: P(r).name === `TeamConfigRole`,
                            onClick: (n[5] ||= (e) =>
                              P(i).push({
                                name: `TeamConfigRole`,
                                params: {
                                  uuid: m.value.uuid,
                                },
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`config.role_and_permission`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    P(Wh)(`access:reports`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 5,
                            as: `link`,
                            href: `/reports`,
                          },
                          {
                            default: I(() => [H(T(e.$trans(`general.report`)), 1)]),
                            _: 1,
                          },
                        ))
                      : U(``, !0),
                    P(Gh)(`admin`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 6,
                            disabled: P(r).name === `DeviceList`,
                            onClick: (n[6] ||= (e) =>
                              P(i).push({
                                name: `DeviceList`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`device.device`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    P(h)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 7,
                            disabled: P(r).name === `AttendanceQrCode`,
                            onClick: (n[7] ||= (e) =>
                              P(i).push({
                                name: `AttendanceQrCode`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`attendance.qr_code`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    N(
                      a,
                      {
                        disabled: P(r).name === `UserProfile`,
                        onClick: (n[8] ||= (e) =>
                          P(i).push({
                            name: `UserProfile`,
                          })),
                      },
                      {
                        default: I(() => [H(T(e.$trans(`user.profile.profile`)), 1)]),
                        _: 1,
                      },
                      8,
                      [`disabled`],
                    ),
                    N(
                      a,
                      {
                        disabled: P(r).name === `UserPreference`,
                        onClick: (n[9] ||= (e) =>
                          P(i).push({
                            name: `UserPreference`,
                          })),
                      },
                      {
                        default: I(() => [H(T(e.$trans(`user.preference.preference`)), 1)]),
                        _: 1,
                      },
                      8,
                      [`disabled`],
                    ),
                    N(
                      a,
                      {
                        disabled: P(r).name === `UserPassword`,
                        onClick: (n[10] ||= (e) =>
                          P(i).push({
                            name: `UserPassword`,
                          })),
                      },
                      {
                        default: I(() => [H(T(e.$trans(`auth.password.change_password`)), 1)]),
                        _: 1,
                      },
                      8,
                      [`disabled`],
                    ),
                  ]),
                  x.value
                    ? (A(),
                      M(`div`, wge, [
                        (A(!0),
                        M(
                          ke,
                          null,
                          ae(
                            w.value,
                            (t) => (
                              A(),
                              L(
                                a,
                                {
                                  key: t.value,
                                  disabled: E.value,
                                  onClick: (e) => D(t.value),
                                },
                                {
                                  default: I(() => [
                                    W(`div`, Tge, [
                                      W(
                                        `span`,
                                        null,
                                        T(
                                          e.$trans(`global.switch_to`, {
                                            attribute: t.label,
                                          }),
                                        ),
                                        1,
                                      ),
                                      S.value === t.value ? (A(), M(`i`, Ege)) : U(``, !0),
                                    ]),
                                  ]),
                                  _: 2,
                                },
                                1032,
                                [`disabled`, `onClick`],
                              )
                            ),
                          ),
                          128,
                        )),
                      ]))
                    : U(``, !0),
                  W(`div`, Dge, [
                    P(Gh)(`admin`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 0,
                            disabled: P(r).name === `FailedLoginAttempt`,
                            onClick: (n[11] ||= (e) =>
                              P(i).push({
                                name: `FailedLoginAttempt`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`auth.failed_login_attempt`)), 1)]),
                            _: 1,
                          },
                          8,
                          [`disabled`],
                        ))
                      : U(``, !0),
                    P(Gh)(`admin`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 1,
                            as: `link`,
                            target: `_blank`,
                            href: `/cmd/clear-cache`,
                          },
                          {
                            default: I(() => [...(n[15] ||= [H(` Clear Cache `, -1)])]),
                            _: 1,
                          },
                        ))
                      : U(``, !0),
                    P(Gh)(`admin`)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 2,
                            as: `link`,
                            href: `/download/formats`,
                          },
                          {
                            default: I(() => [H(T(e.$trans(`general.download_format`)), 1)]),
                            _: 1,
                          },
                        ))
                      : U(``, !0),
                    P(Uh) && P(d)
                      ? (A(),
                        L(
                          a,
                          {
                            key: 3,
                            onClick: (n[12] ||= (e) =>
                              P(i).push({
                                name: `Support`,
                              })),
                          },
                          {
                            default: I(() => [H(T(e.$trans(`general.support`)), 1)]),
                            _: 1,
                          },
                        ))
                      : U(``, !0),
                    N(
                      a,
                      {
                        disabled: P(r).name === `UserPassword`,
                        onClick: v,
                      },
                      {
                        default: I(() => [H(T(e.$trans(`auth.login.logout`)), 1)]),
                        _: 1,
                      },
                      8,
                      [`disabled`],
                    ),
                  ]),
                ]),
                _: 1,
              },
              8,
              [`direction`],
            )
          );
        };
      },
    },
  );
B();
var kge = {
    class: `space-y-0`,
  },
  Age = {
    key: 0,
    class: `flex px-5 py-3 uppercase text-white`,
  },
  jge = {
    class: `text-sm`,
  },
  Mge = {
    key: 0,
  },
  Nge = {
    key: 1,
    class: `fas fa-chevron-down ltr:mr-3 rtl:ml-3 w-6 shrink-0`,
  },
  Pge = {
    class: O({}),
  },
  Fge = {
    class: `flex px-8 py-2`,
  },
  Ige = Object.assign(
    {
      name: `AppSidebar`,
    },
    {
      props: {
        mobile: {
          type: Boolean,
          deafult: !1,
        },
      },
      emits: [`hideSidebar`],
      setup(e, { emit: t }) {
        let n = $e(),
          r = Dc();
        Ec();
        let { isRtl: i } = Kh(),
          a = t,
          o = e,
          s = Ae({
            openedMenu: ``,
            activeMenu: r.name,
            activeSubMenu: ``,
          }),
          c = V(() => n.getters[`layout/getSidebarType`]),
          l = V(() => n.getters[`navigation/navigations`]),
          u = V(() => n.getters[`navigation/mainCategories`]),
          d = V(() => u.value.length > 1),
          f = V(() => n.getters[`layout/selectedMainCategory`]),
          p = V(() =>
            !d.value || !f.value
              ? l.value
              : l.value.map((e) => ({
                  ...e,
                  children: (e.children || []).filter(
                    (e) =>
                      (e.meta && e.meta.mainCategory ? e.meta.mainCategory.key : `core`) ===
                      f.value,
                  ),
                })),
          ),
          m = V(() => c.value === `full`),
          h = V(() => c.value === `pinned`),
          g = V(() => o.mobile || m.value || h.value),
          v = (e) =>
            e.meta.isHiddenNav ? !1 : e.hasOwnProperty(`children`) ? e.children.length !== 0 : !0,
          y = (e) =>
            e.hasOwnProperty(`children`) ? e.children.length > 0 && !e.meta.hideChildren : !1,
          b = (e) => !y(e),
          x = (e) => {
            y(e)
              ? s.openedMenu == e.name
                ? (s.openedMenu = ``)
                : (s.openedMenu = e.name)
              : o.mobile && a(`hideSidebar`);
          },
          S = () => {
            o.mobile && a(`hideSidebar`);
          },
          C = (e) => {
            let t = e.redirect && e.redirect.name ? e.redirect.name : ``;
            return e.children && e.children.length && e.children.some((e) => C(e))
              ? !0
              : s.activeMenu === e.name || (t && s.activeMenu === t);
          };
        return (
          He(
            () => r.name,
            (e) => {
              s.activeMenu = e;
            },
          ),
          (e, t) => {
            let n = j(`router-link`),
              r = j(`MenuParentTransition`);
            return (
              A(!0),
              M(
                ke,
                null,
                ae(
                  p.value,
                  (t) => (
                    A(),
                    M(`div`, kge, [
                      t.meta.label
                        ? Re(
                            (A(),
                            M(`h3`, Age, [W(`span`, null, T(e.$trans(t.meta.label)), 1)], 512)),
                            [[Ee, g.value]],
                          )
                        : U(``, !0),
                      W(`ul`, jge, [
                        (A(!0),
                        M(
                          ke,
                          null,
                          ae(
                            t.children,
                            (t) => (
                              A(),
                              M(
                                `li`,
                                {
                                  class: O([
                                    `text-secondary hover:text-dark-secondary hover:bg-dark-primary dark:hover:bg-dark-body`,
                                    {
                                      "bg-dark-primary dark:bg-dark-body": C(t),
                                    },
                                  ]),
                                  key: t.name,
                                },
                                [
                                  v(t)
                                    ? (A(),
                                      M(
                                        ke,
                                        {
                                          key: 0,
                                        },
                                        [
                                          (A(),
                                          L(
                                            _e(b(t) ? `router-link` : `div`),
                                            {
                                              to: b(t)
                                                ? {
                                                    name: t.name,
                                                  }
                                                : ``,
                                              class: `cursor-pointer`,
                                              onClick: (e) => x(t),
                                            },
                                            {
                                              default: I(() => [
                                                W(
                                                  `div`,
                                                  {
                                                    class: O([
                                                      `flex py-3 ltr:pl-6 rtl:pr-6 ltr:pr-2 rtl:pl-2`,
                                                      {
                                                        "justify-between": y(t),
                                                      },
                                                    ]),
                                                  },
                                                  [
                                                    W(`div`, null, [
                                                      W(`span`, null, [
                                                        W(
                                                          `i`,
                                                          {
                                                            class: O([
                                                              `ltr:mr-3 rtl:ml-3 w-6 shrink-0`,
                                                              t.meta.icon,
                                                            ]),
                                                          },
                                                          null,
                                                          2,
                                                        ),
                                                      ]),
                                                      Re(
                                                        W(
                                                          `span`,
                                                          null,
                                                          T(e.$trans(t.meta.label)),
                                                          513,
                                                        ),
                                                        [[Ee, g.value]],
                                                      ),
                                                    ]),
                                                    y(t) && g.value
                                                      ? (A(),
                                                        M(`span`, Mge, [
                                                          s.openedMenu == t.name
                                                            ? (A(), M(`i`, Nge))
                                                            : (A(),
                                                              M(
                                                                `i`,
                                                                {
                                                                  key: 0,
                                                                  class: O([
                                                                    `fas ltr:mr-3 rtl:ml-3 w-6 shrink-0`,
                                                                    {
                                                                      "fa-chevron-right": !P(i),
                                                                      "fa-chevron-left": P(i),
                                                                    },
                                                                  ]),
                                                                },
                                                                null,
                                                                2,
                                                              )),
                                                        ]))
                                                      : U(``, !0),
                                                  ],
                                                  2,
                                                ),
                                              ]),
                                              _: 2,
                                            },
                                            1032,
                                            [`to`, `onClick`],
                                          )),
                                          N(
                                            r,
                                            {
                                              direction: `down`,
                                              show: y(t) && s.openedMenu == t.name,
                                            },
                                            {
                                              default: I(() => [
                                                Re(
                                                  W(
                                                    `ul`,
                                                    Pge,
                                                    [
                                                      (A(!0),
                                                      M(
                                                        ke,
                                                        null,
                                                        ae(
                                                          t.children,
                                                          (t) => (
                                                            A(),
                                                            M(
                                                              `li`,
                                                              {
                                                                class: O([
                                                                  `text-secondary hover:text-darken-secondary hover:bg-darken-primary cursor-pointer dark:hover:bg-black`,
                                                                  {
                                                                    "bg-darken-primary dark:bg-dark-body":
                                                                      C(t),
                                                                  },
                                                                ]),
                                                                key: t.name,
                                                              },
                                                              [
                                                                N(
                                                                  n,
                                                                  {
                                                                    to: {
                                                                      name: t.name,
                                                                    },
                                                                    onClick: S,
                                                                  },
                                                                  {
                                                                    default: I(() => [
                                                                      W(`div`, Fge, [
                                                                        W(`span`, null, [
                                                                          W(
                                                                            `i`,
                                                                            {
                                                                              class: O([
                                                                                `ltr:mr-3 rtl:ml-3 w-5`,
                                                                                t.meta.icon ||
                                                                                  e.menu
                                                                                    .defaultChildrenIcon,
                                                                              ]),
                                                                            },
                                                                            null,
                                                                            2,
                                                                          ),
                                                                        ]),
                                                                        W(
                                                                          `span`,
                                                                          null,
                                                                          T(e.$trans(t.meta.label)),
                                                                          1,
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                    _: 2,
                                                                  },
                                                                  1032,
                                                                  [`to`],
                                                                ),
                                                              ],
                                                              2,
                                                            )
                                                          ),
                                                        ),
                                                        128,
                                                      )),
                                                    ],
                                                    512,
                                                  ),
                                                  [[Ee, g.value]],
                                                ),
                                              ]),
                                              _: 2,
                                            },
                                            1032,
                                            [`show`],
                                          ),
                                        ],
                                        64,
                                      ))
                                    : U(``, !0),
                                ],
                                2,
                              )
                            ),
                          ),
                          128,
                        )),
                      ]),
                    ])
                  ),
                ),
                256,
              )
            );
          }
        );
      },
    },
  );
B();
var Lge = {
    class: `max-w-64 relative flex w-full flex-1 flex-col bg-white dark:!bg-black pb-4 pt-5 dark:text-gray-400`,
  },
  Rge = {
    class: `flex items-center px-4`,
  },
  zge = [`src`],
  Bge = {
    key: 0,
    class: `mx-4 mt-3 pb-3 border-b-2 border-gray-200 dark:border-gray-700`,
  },
  Vge = {
    class: `flex flex-wrap gap-2`,
  },
  Hge = [`onClick`, `title`],
  Uge = {
    class: `text-[9px] leading-tight mt-0.5 max-w-full text-center truncate px-0.5`,
  },
  Wge = {
    class: `mt-3 h-0 flex-1 overflow-y-auto`,
  },
  Gge = {
    class: `space-y-1`,
  },
  Kge = {
    __name: `MobileSidebar`,
    props: {
      navigation: {
        type: Array,
        default: [],
      },
    },
    setup(e) {
      let t = $e(),
        { isRtl: n } = Kh(),
        r = Vh(`layout.display`),
        i = Vh(`assets.logo`),
        a = Vh(`assets.logoLight`),
        o = V(() => (r.value === `dark` ? a.value : i.value)),
        s = V(() => t.getters[`layout/mobileSidebar`]),
        c = V(() => t.getters[`navigation/mainCategories`]),
        l = V(() => c.value.length > 1),
        u = V(() => t.getters[`layout/selectedMainCategory`]),
        d = (e) => {
          t.dispatch(`layout/setMobileSidebar`, e);
        },
        f = (e) => {
          let n = u.value === e ? null : e;
          t.dispatch(`layout/setSelectedMainCategory`, n);
        };
      return (e, t) => {
        let r = j(`AppNavigation`);
        return (
          A(),
          L(
            P(xh),
            {
              as: `template`,
              show: s.value,
            },
            {
              default: I(() => [
                N(
                  P(Are),
                  {
                    as: `div`,
                    class: `fixed inset-0 z-40 flex lg:hidden`,
                    onClose: (t[2] ||= (e) => d(!1)),
                  },
                  {
                    default: I(() => [
                      N(
                        P(bh),
                        {
                          as: `template`,
                          enter: `transition-opacity ease-linear duration-300`,
                          "enter-from": `opacity-0`,
                          "enter-to": `opacity-100`,
                          leave: `transition-opacity ease-linear duration-300`,
                          "leave-from": `opacity-100`,
                          "leave-to": `opacity-0`,
                        },
                        {
                          default: I(() => [
                            N(P(jre), {
                              class: `fixed inset-0 bg-black/75`,
                            }),
                          ]),
                          _: 1,
                        },
                      ),
                      N(
                        P(bh),
                        {
                          as: `template`,
                          enter: `transition ease-in-out duration-300 transform`,
                          "enter-from": P(n) ? `translate-x-full` : `-translate-x-full`,
                          "enter-to": `translate-x-0`,
                          leave: `transition ease-in-out duration-300 transform`,
                          "leave-from": `translate-x-0`,
                          "leave-to": P(n) ? `translate-x-full` : `-translate-x-full`,
                        },
                        {
                          default: I(() => [
                            W(`div`, Lge, [
                              N(
                                P(bh),
                                {
                                  as: `template`,
                                  enter: `ease-in-out duration-300`,
                                  "enter-from": `opacity-0`,
                                  "enter-to": `opacity-100`,
                                  leave: `ease-in-out duration-300`,
                                  "leave-from": `opacity-100`,
                                  "leave-to": `opacity-0`,
                                },
                                {
                                  default: I(() => [
                                    W(
                                      `div`,
                                      {
                                        class: O([
                                          `absolute top-0 pt-2`,
                                          P(n) ? `left-0 -ml-12` : `right-0 -mr-12`,
                                        ]),
                                      },
                                      [
                                        W(
                                          `button`,
                                          {
                                            type: `button`,
                                            class: O([
                                              `flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`,
                                              P(n) ? `mr-1` : `ml-1`,
                                            ]),
                                            onClick: (t[0] ||= (e) => d(!1)),
                                          },
                                          [
                                            (t[3] ||= W(
                                              `span`,
                                              {
                                                class: `sr-only`,
                                              },
                                              `Close sidebar`,
                                              -1,
                                            )),
                                            N(P(KZ), {
                                              class: `h-6 w-6 text-white`,
                                              "aria-hidden": `true`,
                                            }),
                                          ],
                                          2,
                                        ),
                                      ],
                                      2,
                                    ),
                                  ]),
                                  _: 1,
                                },
                              ),
                              W(`div`, Rge, [
                                W(
                                  `img`,
                                  {
                                    class: `h-12 w-auto`,
                                    src: o.value,
                                    alt: `logo`,
                                  },
                                  null,
                                  8,
                                  zge,
                                ),
                              ]),
                              l.value
                                ? (A(),
                                  M(`div`, Bge, [
                                    W(`div`, Vge, [
                                      (A(!0),
                                      M(
                                        ke,
                                        null,
                                        ae(
                                          c.value,
                                          (t) => (
                                            A(),
                                            M(
                                              `button`,
                                              {
                                                key: t.key,
                                                onClick: (e) => f(t.key),
                                                title: e.$trans(t.label),
                                                class: O([
                                                  `flex flex-col items-center justify-center w-10 h-10 rounded-lg transition-all duration-150`,
                                                  u.value === t.key
                                                    ? `bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 shadow-sm`
                                                    : `text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-700 dark:hover:text-gray-200`,
                                                ]),
                                              },
                                              [
                                                W(
                                                  `i`,
                                                  {
                                                    class: O([t.icon, `text-base leading-none`]),
                                                  },
                                                  null,
                                                  2,
                                                ),
                                                W(`span`, Uge, T(e.$trans(t.label)), 1),
                                              ],
                                              10,
                                              Hge,
                                            )
                                          ),
                                        ),
                                        128,
                                      )),
                                    ]),
                                  ]))
                                : U(``, !0),
                              W(`div`, Wge, [
                                W(`nav`, null, [
                                  W(`div`, Gge, [
                                    N(r, {
                                      mobile: ``,
                                      onHideSidebar: (t[1] ||= (e) => d(!1)),
                                    }),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                          _: 1,
                        },
                        8,
                        [`enter-from`, `leave-to`],
                      ),
                      (t[4] ||= W(
                        `div`,
                        {
                          class: `w-32`,
                          "aria-hidden": `true`,
                        },
                        null,
                        -1,
                      )),
                    ]),
                    _: 1,
                  },
                ),
              ]),
              _: 1,
            },
            8,
            [`show`],
          )
        );
      };
    },
  };
B();
var qge = {
    class: `my-4`,
  },
  Jge = {
    key: 0,
    class: `flex items-center justify-center gap-2 text-center text-sm dark:text-gray-400`,
  },
  Yge = {
    key: 0,
  },
  Xge = {
    key: 1,
  },
  Zge = Object.assign(
    {
      name: `FooterCredit`,
    },
    {
      setup(e) {
        let t = Vh(`system.version`),
          n = Vh(`system.showVersionNumber`),
          r = Vh(`system.footerCredit`);
        return (e, i) => (
          A(),
          M(`div`, qge, [
            P(n) || P(r)
              ? (A(),
                M(`p`, Jge, [
                  P(n)
                    ? (A(),
                      M(
                        `span`,
                        Yge,
                        T(
                          e.$trans(`general.version_info`, {
                            attribute: P(t),
                          }),
                        ),
                        1,
                      ))
                    : U(``, !0),
                  P(r) ? (A(), M(`span`, Xge, T(P(r)), 1)) : U(``, !0),
                ]))
              : U(``, !0),
          ])
        );
      },
    },
  );
B();
var Qge = {
    class: `mx-auto w-full pb-6 lg:pb-16`,
  },
  $ge = {
    class: ``,
  },
  e_e = {
    class: `space-x-2 divide-y divide-gray-200 dark:divide-gray-700 sm:grid sm:grid-cols-12 sm:divide-x sm:divide-y-0`,
  },
  t_e = Object.assign(
    {
      name: `ConfigPage`,
    },
    {
      props: {
        noBackground: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = Dc();
        return (n, r) => {
          let i = j(`PageHeader`),
            a = j(`ConfigSidebar`),
            o = j(`ChildTransition`),
            s = j(`ParentTransition`);
          return (
            A(),
            M(
              ke,
              null,
              [
                N(
                  i,
                  {
                    title: n.$trans(P(t).meta.label),
                    navs: [
                      {
                        label: n.$trans(`config.config`),
                        path: `Config`,
                      },
                    ],
                  },
                  {
                    default: I(() => [z(n.$slots, `action`)]),
                    _: 3,
                  },
                  8,
                  [`title`, `navs`],
                ),
                N(
                  s,
                  {
                    appear: ``,
                    visibility: !0,
                  },
                  {
                    default: I(() => [
                      W(`div`, Qge, [
                        W(`div`, $ge, [
                          W(`div`, e_e, [
                            N(a),
                            W(
                              `div`,
                              {
                                class: O([
                                  `sm:col-span-9 lg:col-span-10`,
                                  {
                                    "dark:bg-dark-header rounded-lg bg-white p-4": !e.noBackground,
                                  },
                                ]),
                              },
                              [
                                N(
                                  o,
                                  {
                                    appear: ``,
                                    visibility: !0,
                                    direction: `ltr`,
                                  },
                                  {
                                    default: I(() => [z(n.$slots, `default`)]),
                                    _: 3,
                                  },
                                ),
                              ],
                              2,
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _: 3,
                  },
                ),
              ],
              64,
            )
          );
        };
      },
    },
  );
B();
var n_e = {
    class: `rounded-lg bg-black py-6 sm:col-span-3 lg:col-span-2`,
  },
  r_e = {
    class: `md:space-y-3 flex flex-wrap md:inline-block`,
  },
  i_e = {
    class: `truncate`,
  },
  a_e = Object.assign(
    {
      name: `ConfigSidebar`,
    },
    {
      setup(e) {
        let t = Dc(),
          n = $e(),
          r = V(() => n.getters[`navigation/configNavigations`]);
        return (e, n) => {
          let i = j(`router-link`);
          return (
            A(),
            M(`aside`, n_e, [
              W(`nav`, r_e, [
                (A(!0),
                M(
                  ke,
                  null,
                  ae(
                    r.value,
                    (n) => (
                      A(),
                      L(
                        i,
                        {
                          key: n.name,
                          to: {
                            name: n.name,
                          },
                          class: O([
                            `hover:text-darken-secondary group flex items-center px-3 py-2 text-sm font-medium w-1/3 md:w-full`,
                            {
                              "text-darken-secondary": P(t).name === n.name,
                              "text-light-secondary": P(t).name !== n.name,
                            },
                          ]),
                          "aria-current": P(t).name === n.name ? `page` : void 0,
                        },
                        {
                          default: I(() => [
                            W(
                              `span`,
                              {
                                class: O([`ml-2 mr-3 w-6 shrink-0`, [n.meta.icon]]),
                                "aria-hidden": `true`,
                              },
                              null,
                              2,
                            ),
                            W(`span`, i_e, T(e.$trans(n.meta.label)), 1),
                          ]),
                          _: 2,
                        },
                        1032,
                        [`to`, `class`, `aria-current`],
                      )
                    ),
                  ),
                  128,
                )),
              ]),
            ])
          );
        };
      },
    },
  );
B();
var o_e = {
    class: `mx-auto w-full pb-6 lg:pb-16`,
  },
  s_e = {
    class: `space-y-4 md:grid md:grid-cols-12 md:space-x-4 md:space-y-0`,
  },
  c_e = {
    key: 0,
    class: `rounded-lg bg-black py-3 md:col-span-3 lg:col-span-2`,
  },
  l_e = {
    class: `space-y-4`,
  },
  u_e = Object.assign(
    {
      name: `ModuleConfig`,
    },
    {
      props: {
        navigations: {
          type: Array,
          default: [],
        },
        useUuid: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`ModuleConfigSidebar`),
            i = j(`ChildTransition`),
            a = j(`ParentTransition`);
          return (
            A(),
            L(
              a,
              {
                appear: ``,
                visibility: !0,
              },
              {
                default: I(() => [
                  W(`div`, o_e, [
                    W(`div`, s_e, [
                      e.navigations.length > 1
                        ? (A(),
                          M(`aside`, c_e, [
                            z(t.$slots, `header`),
                            N(
                              r,
                              {
                                navigations: e.navigations,
                                "use-uuid": ``,
                              },
                              null,
                              8,
                              [`navigations`],
                            ),
                          ]))
                        : U(``, !0),
                      W(
                        `div`,
                        {
                          class: O({
                            "md:col-span-9 lg:col-span-10": e.navigations.length > 1,
                            "col-span-12": e.navigations.length === 1,
                          }),
                        },
                        [
                          N(
                            i,
                            {
                              appear: ``,
                              visibility: !0,
                              direction: `ltr`,
                            },
                            {
                              default: I(() => [W(`div`, l_e, [z(t.$slots, `default`)])]),
                              _: 3,
                            },
                          ),
                        ],
                        2,
                      ),
                    ]),
                  ]),
                ]),
                _: 3,
              },
            )
          );
        };
      },
    },
  );
B();
var d_e = {
    class: `md:space-y-3 flex flex-wrap md:inline-block`,
  },
  f_e = {
    class: `truncate`,
  },
  p_e = Object.assign(
    {
      name: `ModuleConfigSidebar`,
    },
    {
      props: {
        navigations: {
          type: Array,
          default: [],
        },
        useUuid: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = Dc(),
          n = R(`$trans`),
          r = e,
          i = (e) =>
            r.useUuid && t.params.uuid
              ? {
                  name: e.name,
                  params: {
                    uuid: t.params.uuid,
                  },
                }
              : {
                  name: e.name,
                };
        return (r, a) => {
          let o = j(`router-link`);
          return (
            A(),
            M(`nav`, d_e, [
              (A(!0),
              M(
                ke,
                null,
                ae(
                  e.navigations,
                  (e) => (
                    A(),
                    L(
                      o,
                      {
                        key: e.name,
                        to: i(e),
                        class: O([
                          `hover:text-darken-secondary group flex items-center px-3 py-2 text-sm font-medium w-1/3 md:w-full`,
                          {
                            "text-darken-secondary": P(t).name === e.name,
                            "text-light-secondary": P(t).name !== e.name,
                          },
                        ]),
                        "aria-current": P(t).name === e.name ? `page` : void 0,
                      },
                      {
                        default: I(() => [
                          W(
                            `span`,
                            {
                              class: O([`ml-2 mr-3 w-6 shrink-0`, [e.icon]]),
                              "aria-hidden": `true`,
                            },
                            null,
                            2,
                          ),
                          W(`span`, f_e, T(P(n)(e.label)), 1),
                        ]),
                        _: 2,
                      },
                      1032,
                      [`to`, `class`, `aria-current`],
                    )
                  ),
                ),
                128,
              )),
            ])
          );
        };
      },
    },
  );
B();
var m_e = {
    key: 0,
  },
  h_e = {
    key: 1,
  },
  g_e = Object.assign(
    {
      name: `FormActionButton`,
    },
    {
      props: {
        sideover: {
          type: Boolean,
          default: !1,
        },
        action: {
          type: String,
          defaut: ``,
        },
        redirect: {
          type: [String, Object],
          default: ``,
        },
        cancelAction: {
          type: Boolean,
          default: !1,
        },
        padding: {
          type: Boolean,
          default: !1,
        },
        buttonPadding: {
          type: Boolean,
          default: !1,
        },
        topMargin: {
          type: Boolean,
          default: !1,
        },
        keepAdding: {
          type: Boolean,
          default: !0,
        },
        disabled: {
          type: Boolean,
          default: !1,
        },
        submitText: {
          type: String,
          default: ``,
        },
        isModal: {
          type: Boolean,
          default: !1,
        },
      },
      emits: [`reset`, `cancelled`],
      setup(e, { emit: t }) {
        let n = Dc();
        Ec();
        let r = R(`emitter`),
          i = e,
          a = V(() => i.action || n?.meta?.type),
          o = V(() => a.value === `edit` || a.value === `update`),
          s = V(
            () =>
              !!(
                (typeof i.redirect == `string` && i.redirect) ||
                (typeof i.redirect == `object` && i.redirect)
              ),
          ),
          c = Ae({
            keepAdding: !1,
          }),
          l = async () => {
            (await fb()) && r.emit(`resetForm`);
          };
        return (
          He(
            () => c.keepAdding,
            (e) => {
              r.emit(`keepAdding`, e);
            },
          ),
          (t, n) => {
            let a = j(`BaseButton`),
              u = j(`BaseCheckbox`);
            return (
              A(),
              M(
                `div`,
                {
                  class: O([
                    `flex justify-between`,
                    {
                      "mt-4": e.topMargin,
                      "bg-white px-2 pt-6": e.padding,
                    },
                  ]),
                },
                [
                  W(
                    `div`,
                    {
                      class: O([
                        `flex space-x-2 sm:space-x-4`,
                        {
                          "px-4 py-2": e.buttonPadding,
                        },
                      ]),
                    },
                    [
                      N(
                        a,
                        {
                          disabled: i.disabled,
                          class: `hidden sm:block`,
                          design: `secondary`,
                          onClick: l,
                        },
                        {
                          default: I(() => [H(T(t.$trans(`general.reset`)), 1)]),
                          _: 1,
                        },
                        8,
                        [`disabled`],
                      ),
                      !o.value && e.keepAdding
                        ? (A(),
                          L(
                            u,
                            {
                              key: 0,
                              modelValue: c.keepAdding,
                              "onUpdate:modelValue": (n[0] ||= (e) => (c.keepAdding = e)),
                              name: `keepAdding`,
                              label: t.$trans(`general.keep_adding`),
                            },
                            null,
                            8,
                            [`modelValue`, `label`],
                          ))
                        : U(``, !0),
                    ],
                    2,
                  ),
                  W(
                    `div`,
                    {
                      class: O([
                        `space-x-2 sm:space-x-4`,
                        {
                          "px-4 py-2": e.buttonPadding,
                        },
                      ]),
                    },
                    [
                      z(t.$slots, `default`),
                      e.isModal || e.sideover || e.cancelAction
                        ? (A(),
                          L(
                            a,
                            {
                              key: 0,
                              design: `error`,
                              onClick: (n[1] ||= (e) => t.$emit(`cancelled`)),
                            },
                            {
                              default: I(() => [H(T(t.$trans(`general.cancel`)), 1)]),
                              _: 1,
                            },
                          ))
                        : U(``, !0),
                      !e.isModal && !e.sideover && s.value
                        ? (A(),
                          L(
                            a,
                            {
                              key: 1,
                              design: `error`,
                              onClick: (n[2] ||= (e) => P(r).emit(`redirect`)),
                            },
                            {
                              default: I(() => [H(T(t.$trans(`general.cancel`)), 1)]),
                              _: 1,
                            },
                          ))
                        : U(``, !0),
                      e.submitText
                        ? U(``, !0)
                        : (A(),
                          L(
                            a,
                            {
                              key: 2,
                              disabled: i.disabled,
                              design: `primary`,
                              type: `submit`,
                            },
                            {
                              default: I(() => [
                                o.value
                                  ? (A(), M(`span`, m_e, T(t.$trans(`general.update`)), 1))
                                  : (A(), M(`span`, h_e, T(t.$trans(`general.save`)), 1)),
                              ]),
                              _: 1,
                            },
                            8,
                            [`disabled`],
                          )),
                      e.submitText
                        ? (A(),
                          L(
                            a,
                            {
                              key: 3,
                              disabled: i.disabled,
                              design: `primary`,
                              type: `submit`,
                            },
                            {
                              default: I(() => [H(T(e.submitText), 1)]),
                              _: 1,
                            },
                            8,
                            [`disabled`],
                          ))
                        : U(``, !0),
                    ],
                    2,
                  ),
                ],
                2,
              )
            );
          }
        );
      },
    },
  );
B();
var __e = {
    class: `space-x-4`,
  },
  v_e = {
    class: `space-x-4`,
  },
  y_e = Object.assign(
    {
      name: `ShowButton`,
    },
    {
      props: {
        padding: {
          type: Boolean,
          default: !1,
        },
        topMargin: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        let t = Ec();
        return (n, r) => {
          let i = j(`BaseButton`);
          return (
            A(),
            M(
              `div`,
              {
                class: O([
                  `flex justify-between`,
                  {
                    "mt-4": e.topMargin,
                    "bg-white px-2 pt-6": e.padding,
                  },
                ]),
              },
              [
                W(`div`, __e, [
                  N(
                    i,
                    {
                      design: `secondary`,
                      onClick: (r[0] ||= (e) => P(t).go(-1)),
                    },
                    {
                      default: I(() => [H(T(n.$trans(`general.back`)), 1)]),
                      _: 1,
                    },
                  ),
                ]),
                W(`div`, v_e, [z(n.$slots, `default`)]),
              ],
              2,
            )
          );
        };
      },
    },
  );
B();
var b_e = {
    key: 0,
    class: `text-lg font-medium leading-6 text-gray-900 dark:text-gray-400`,
  },
  x_e = {
    key: 1,
    class: `mt-1 text-sm text-gray-500`,
  },
  S_e = Object.assign(
    {
      name: `CardHeader`,
    },
    {
      props: {
        title: {
          type: String,
          default: ``,
        },
        description: {
          type: String,
          default: ``,
        },
        first: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e) {
        return (t, n) => (
          A(),
          M(
            `div`,
            {
              class: O([
                {
                  "mb-6": e.first,
                  "my-6": !e.first,
                },
                `flex items-center justify-between gap-4`,
              ]),
            },
            [
              W(`div`, null, [
                e.title ? (A(), M(`h2`, b_e, T(e.title), 1)) : U(``, !0),
                e.description ? (A(), M(`p`, x_e, T(e.description), 1)) : U(``, !0),
              ]),
              z(t.$slots, `default`),
            ],
            2,
          )
        );
      },
    },
  );
B();
var C_e = {
    class: `text-primary text-4xl font-extrabold sm:text-5xl`,
  },
  w_e = {
    class: `sm:ml-6`,
  },
  T_e = {
    class: `sm:border-l sm:border-gray-200 sm:pl-6`,
  },
  E_e = {
    class: `text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl`,
  },
  D_e = {
    class: `mt-1 text-base text-gray-500`,
  },
  O_e = {
    class: `mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6`,
  },
  k_e = {
    __name: `ErrorPage`,
    props: {
      type: {
        type: String,
        default: ``,
      },
      title: {
        type: String,
        default: ``,
      },
      description: {
        type: String,
        default: ``,
      },
    },
    setup(e) {
      return (t, n) => (
        A(),
        M(
          ke,
          null,
          [
            W(`p`, C_e, T(e.type), 1),
            W(`div`, w_e, [
              W(`div`, T_e, [W(`h1`, E_e, T(e.title), 1), W(`p`, D_e, T(e.description), 1)]),
              W(`div`, O_e, [z(t.$slots, `default`)]),
            ]),
          ],
          64,
        )
      );
    },
  };
B();
var A_e = {
    class: `space-y-6`,
  },
  j_e = Object.assign(
    {
      name: `ReLogin`,
    },
    {
      setup(e) {
        ($e(), Dc());
        let t = R(`emitter`),
          n = `auth/user/`,
          r = Bh(n),
          i = {
            password: ``,
          },
          a = F(!1),
          o = Ae({
            ...i,
          }),
          s = () => {
            a.value = !1;
          },
          c = () => {};
        return (
          Qe(async () => {
            t.on(`sessionExpire`, async () => {});
          }),
          oe(() => {
            t.all.delete(`sessionExpire`);
          }),
          (e, t) => {
            let l = j(`BaseInput`),
              u = j(`BaseButton`),
              d = j(`FormAction`),
              f = j(`BaseModal`);
            return (
              A(),
              L(
                f,
                {
                  show: a.value,
                  onClose: s,
                },
                {
                  title: I(() => [...(t[2] ||= [H(` Session Expire `, -1)])]),
                  default: I(() => [
                    N(
                      d,
                      {
                        "no-card": ``,
                        "no-action-button": ``,
                        "init-url": n,
                        "init-form": i,
                        form: o,
                        action: `login`,
                        "after-submit": c,
                      },
                      {
                        default: I(() => [
                          W(`div`, A_e, [
                            N(
                              l,
                              {
                                type: `password`,
                                "leading-icon": `fas fa-key`,
                                modelValue: o.password,
                                "onUpdate:modelValue": (t[0] ||= (e) => (o.password = e)),
                                name: `password`,
                                label: e.$trans(`auth.login.props.password`),
                                error: P(r).password,
                                "onUpdate:error": (t[1] ||= (e) => (P(r).password = e)),
                              },
                              null,
                              8,
                              [`modelValue`, `label`, `error`],
                            ),
                            N(
                              u,
                              {
                                type: `submit`,
                              },
                              {
                                default: I(() => [H(T(e.$trans(`auth.login.login`)), 1)]),
                                _: 1,
                              },
                            ),
                          ]),
                        ]),
                        _: 1,
                      },
                      8,
                      [`form`],
                    ),
                  ]),
                  _: 1,
                },
                8,
                [`show`],
              )
            );
          }
        );
      },
    },
  );
B();
var M_e = {
    key: 0,
    class: `fixed inset-0 bg-gray-100 dark:bg-dark-body z-50 w-full h-full overflow-hidden`,
  },
  N_e = {
    class: `px-2 py-4 sm:p-4 md:p-8 lg:p-12`,
  },
  P_e = {
    class: `flex items-center mb-4 sm:hidden`,
  },
  F_e = [`placeholder`],
  I_e = {
    class: `flex justify-between items-center`,
  },
  L_e = {
    class: `text-2xl dark:text-gray-300 text-gray-800`,
  },
  R_e = {
    key: 0,
  },
  z_e = {
    key: 1,
  },
  B_e = {
    key: 2,
  },
  V_e = {
    class: `mt-4`,
  },
  H_e = {
    key: 0,
    class: `sm:flex gap-6`,
  },
  U_e = {
    key: 0,
    class: `w-full sm:w-1/2`,
  },
  W_e = {
    key: 0,
    class: `space-y-2`,
  },
  G_e = {
    key: 0,
    class: ``,
  },
  K_e = [`onClick`],
  q_e = {
    class: `text-xs text-gray-500`,
  },
  J_e = {
    class: `truncate text-sm text-gray-500`,
  },
  Y_e = {
    class: `text-sm text-gray-500`,
  },
  X_e = [`onClick`],
  Z_e = {
    class: `flex space-x-2`,
  },
  Q_e = {
    key: 1,
    class: `w-full sm:w-1/2`,
  },
  $_e = {
    key: 0,
    class: `space-y-2`,
  },
  eve = {
    class: ``,
  },
  tve = [`onClick`],
  nve = {
    class: `text-xs text-gray-500`,
  },
  rve = [`onClick`],
  ive = {
    class: `truncate text-sm text-gray-500`,
  },
  ave = {
    class: `flex space-x-2`,
  },
  ove = {
    key: 1,
    class: `w-full`,
  },
  sve = {
    class: `grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4`,
  },
  cve = {
    key: 2,
    class: `w-full`,
  },
  lve = {
    class: `grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4`,
  },
  uve = {
    key: 0,
    class: `mr-2`,
  },
  dve = Object.assign(
    {
      name: `KeySearch`,
    },
    {
      setup(e, { expose: t }) {
        let n = Ec(),
          r = $e(),
          i = R(`$trans`),
          a = F(!1),
          o = F(!1),
          s = Ae({
            search: ``,
            searchType: `person`,
            students: [],
            employees: [],
            matchedRoutes: [],
            teams: [],
          }),
          c = Vh(`teams`),
          l = V(() => r.getters[`auth/user/currentTeamId`]),
          u = V(() => {
            let e = (t) =>
              t.reduce(
                (t, n) => (
                  t.push({
                    name: n.name,
                    keySearch: n.meta?.keySearch,
                    label: i(n.meta?.keySearchLabel) || i(n.meta?.label) || n.name,
                  }),
                  n.children && t.push(...e(n.children)),
                  t
                ),
                [],
              );
            return e(r.getters[`navigation/navigations`]);
          }),
          d = () => {
            ((o.value = !0),
              de(() => {
                document.getElementById(`search-input`).focus();
              }));
          },
          f = () => {
            ((s.search = ``),
              (s.searchType = `person`),
              (s.students = []),
              (s.employees = []),
              (s.matchedRoutes = []),
              (s.teams = []),
              (o.value = !1),
              (g.type = null),
              (g.index = -1),
              (g.button = null));
          },
          p = _.debounce(async () => {
            if (s.search.startsWith(`.`)) {
              y();
              return;
            }
            if (s.search.startsWith(`/`) && c.value.length > 1) {
              b();
              return;
            }
            s.search.length < 1 ||
              ((a.value = !0),
              await r
                .dispatch(`dashboard/search/search`, {
                  search: s.search,
                })
                .then((e) => {
                  ((a.value = !1),
                    (s.students = e.students),
                    (s.employees = e.employees),
                    (s.matchedRoutes = []),
                    (s.teams = []));
                })
                .catch((e) => {
                  a.value = !1;
                }));
          }, 300),
          m = (e) => {
            (f(),
              typeof e == `string`
                ? n.push(e)
                : e.name &&
                  n.push({
                    name: e.name,
                    params: e.params,
                  }));
          },
          h = async (e) => {
            await r
              .dispatch(`auth/user/impersonate`, {
                uuid: e,
              })
              .then((e) => {
                window.location.href = `/app`;
              })
              .catch((e) => {});
          },
          g = Ae({
            type: null,
            index: -1,
            button: null,
          }),
          v = (e) => {
            if (!o.value) return;
            let { key: t } = e,
              { type: n, index: r, button: i } = g;
            if (t === `ArrowDown` || t === `ArrowUp` || t === `Tab`) {
              e.preventDefault();
              let i = t === `ArrowUp` ? -1 : 1;
              if (n === null)
                (s.students.length
                  ? (g.type = `student`)
                  : s.employees.length
                    ? (g.type = `employee`)
                    : s.matchedRoutes.length
                      ? (g.type = `route`)
                      : s.teams.length && (g.type = `team`),
                  (g.index = 0));
              else {
                let e = {
                  student: s.students.length - 1,
                  employee: s.employees.length - 1,
                  route: s.matchedRoutes.length - 1,
                  team: s.teams.length - 1,
                }[n];
                if (r === -1 || (r === 0 && i === -1) || (r === e && i === 1)) {
                  let t = [`student`, `employee`, `route`, `team`].filter(
                    (e) =>
                      (e === `student` && s.students.length) ||
                      (e === `employee` && s.employees.length) ||
                      (e === `route` && s.matchedRoutes.length) ||
                      (e === `team` && s.teams.length),
                  );
                  ((g.type = t[(t.indexOf(n) + i + t.length) % t.length]),
                    (g.index = i === 1 ? 0 : e));
                } else g.index += i;
              }
              g.button = null;
            } else if (t === `ArrowLeft` || t === `ArrowRight`) {
              if ((e.preventDefault(), n === `route` || n === `team`)) return;
              i === null
                ? (g.button = `view`)
                : i === `view` && n === `student`
                  ? (g.button = `fee`)
                  : (g.button = `view`);
            } else if (t === `Enter` && (e.preventDefault(), n && r !== -1))
              if (n === `route`)
                m({
                  name: s.matchedRoutes[r].name,
                });
              else if (n === `team`) x(s.teams[r]);
              else {
                let e = n === `student` ? s.students[r] : s.employees[r];
                m({
                  name:
                    n === `student`
                      ? i === `view`
                        ? `StudentShow`
                        : `StudentShowFee`
                      : `EmployeeShow`,
                  params: {
                    uuid: e.uuid,
                  },
                });
              }
          },
          y = () => {
            s.searchType = `route`;
            let e = s.search.slice(1).toLowerCase();
            ((s.matchedRoutes = u.value.filter(
              (t) => t.keySearch && t.label.toLowerCase().includes(e),
            )),
              (s.students = []),
              (s.employees = []),
              (s.teams = []));
          },
          b = () => {
            s.searchType = `team`;
            let e = s.search.slice(1).toLowerCase();
            ((s.teams = c.value.filter((t) => t.name.toLowerCase().includes(e))),
              (s.students = []),
              (s.employees = []),
              (s.matchedRoutes = []));
          },
          x = async (e) => {
            e.id != l.value &&
              (await r
                .dispatch(`team/select`, {
                  uuid: e.uuid,
                })
                .then(async (e) => {
                  (await r.dispatch(`auth/user/fetch`), location.reload());
                })
                .catch((e) => {}));
          };
        Qe(() => {
          (window.addEventListener(`keydown`, (e) => {
            if (
              (e.target.localName === `body` || e.target.localName === `document`) &&
              !(e.metaKey || e.ctrlKey || e.altKey)
            ) {
              if (e.key === `Backspace`) {
                s.search = s.search.slice(0, -1);
                return;
              }
              (/^[a-zA-Z0-9 .\/]$/.test(e.key) &&
                ((s.search += e.key),
                (o.value = !0),
                s.search.startsWith(`/`)
                  ? y()
                  : s.search.startsWith(`/`) && c.value.length > 1
                    ? b()
                    : ((s.teams = []), (s.matchedRoutes = []), p())),
                e.key === `Escape` && f());
            }
          }),
            window.addEventListener(`keydown`, v));
        });
        let S = (e) => {
            window.open(`/app/students/${e}`, `_blank`);
          },
          C = (e) => {
            window.open(`/app/employees/${e}`, `_blank`);
          };
        return (
          oe(() => {
            window.removeEventListener(`keydown`, v);
          }),
          He(
            () => s.search,
            (e) => {
              e && p();
            },
          ),
          t({
            openSearch: d,
            closeSearch: f,
          }),
          (e, t) => {
            let n = j(`BaseHeading`),
              r = j(`BaseAlert`),
              a = j(`BaseBadge`),
              c = j(`BaseButton`),
              u = j(`CardView`),
              d = ve(`tooltip`);
            return o.value
              ? (A(),
                M(`div`, M_e, [
                  W(`div`, N_e, [
                    W(`div`, P_e, [
                      Re(
                        W(
                          `input`,
                          {
                            id: `search-input`,
                            "onUpdate:modelValue": (t[0] ||= (e) => (s.search = e)),
                            class: `mr-2 px-2 py-1 border border-gray-500 dark:border-gray-700 bg-gray-100 dark:bg-dark-header dark:text-gray-100 rounded w-full ring-0 focus:ring-0`,
                            placeholder: P(i)(`general.search`),
                          },
                          null,
                          8,
                          F_e,
                        ),
                        [[we, s.search]],
                      ),
                      W(
                        `span`,
                        {
                          class: `cursor-pointer text-gray-700 dark:text-gray-400`,
                          onClick: (t[1] ||= (e) => f()),
                        },
                        [
                          ...(t[2] ||= [
                            W(
                              `i`,
                              {
                                class: `fas fa-times`,
                              },
                              null,
                              -1,
                            ),
                          ]),
                        ],
                      ),
                    ]),
                    W(`div`, I_e, [
                      W(`div`, L_e, [
                        s.searchType == `person` ||
                        s.searchType == `student` ||
                        s.searchType == `employee`
                          ? (A(),
                            M(
                              `span`,
                              R_e,
                              T(
                                P(i)(`global.anykey_search_result`, {
                                  attribute: s.search,
                                }),
                              ),
                              1,
                            ))
                          : s.searchType == `team`
                            ? (A(),
                              M(
                                `span`,
                                z_e,
                                T(
                                  P(i)(`global.select`, {
                                    attribute: s.search,
                                  }),
                                ),
                                1,
                              ))
                            : (A(),
                              M(
                                `span`,
                                B_e,
                                T(
                                  P(i)(`global.go_to`, {
                                    attribute: s.search,
                                  }),
                                ),
                                1,
                              )),
                      ]),
                    ]),
                    W(`div`, V_e, [
                      !s.search.startsWith(`.`) && !s.search.startsWith(`/`)
                        ? (A(),
                          M(`div`, H_e, [
                            s.search.startsWith(`.`)
                              ? U(``, !0)
                              : (A(),
                                M(`div`, U_e, [
                                  N(n, null, {
                                    default: I(() => [H(T(P(i)(`student.student`)), 1)]),
                                    _: 1,
                                  }),
                                  s.students.length
                                    ? U(``, !0)
                                    : (A(),
                                      L(
                                        r,
                                        {
                                          key: 0,
                                          design: `info`,
                                          size: `xs`,
                                        },
                                        {
                                          default: I(() => [
                                            H(T(P(i)(`general.select_no_result_text`)), 1),
                                          ]),
                                          _: 1,
                                        },
                                      )),
                                  W(
                                    `div`,
                                    {
                                      class: O([
                                        `scroller-thin-y scroller-hidden overflow-x-hidden`,
                                        {
                                          "h-[calc(100vh_-_350px)] sm:h-[calc(100vh_-_150px)]":
                                            s.students.length > 1,
                                        },
                                      ]),
                                    },
                                    [
                                      s.students.length
                                        ? (A(),
                                          M(`div`, W_e, [
                                            (A(!0),
                                            M(
                                              ke,
                                              null,
                                              ae(
                                                s.students,
                                                (e, t) => (
                                                  A(),
                                                  M(
                                                    `div`,
                                                    {
                                                      key: e.uuid,
                                                    },
                                                    [
                                                      N(
                                                        u,
                                                        {
                                                          "img-src": e.photo,
                                                          class: O({
                                                            "border-2 border-primary":
                                                              g.type === `student` && g.index === t,
                                                          }),
                                                        },
                                                        {
                                                          title: I(() => [
                                                            H(T(e.name) + ` `, 1),
                                                            e.codeNumber
                                                              ? (A(),
                                                                M(
                                                                  `span`,
                                                                  G_e,
                                                                  `(` + T(e.codeNumber) + `)`,
                                                                  1,
                                                                ))
                                                              : U(``, !0),
                                                            W(
                                                              `i`,
                                                              {
                                                                class: `fas fa-up-right-from-square ltr:ml-2 rtl:mr-2 cursor-pointer`,
                                                                onClick: (t) => S(e.uuid),
                                                              },
                                                              null,
                                                              8,
                                                              K_e,
                                                            ),
                                                          ]),
                                                          default: I(() => [
                                                            W(`p`, q_e, T(e.age?.short), 1),
                                                            W(`p`, J_e, [
                                                              H(
                                                                T(
                                                                  e.courseName + ` ` + e.batchName,
                                                                ) + ` `,
                                                                1,
                                                              ),
                                                              e.isTransferred
                                                                ? (A(),
                                                                  L(
                                                                    a,
                                                                    {
                                                                      key: 0,
                                                                      design: `danger`,
                                                                    },
                                                                    {
                                                                      default: I(() => [
                                                                        H(
                                                                          T(
                                                                            P(i)(
                                                                              `student.statuses.transferred`,
                                                                            ),
                                                                          ),
                                                                          1,
                                                                        ),
                                                                      ]),
                                                                      _: 1,
                                                                    },
                                                                  ))
                                                                : U(``, !0),
                                                              e.cancelledAt.value
                                                                ? (A(),
                                                                  L(
                                                                    a,
                                                                    {
                                                                      key: 1,
                                                                      design: `danger`,
                                                                    },
                                                                    {
                                                                      default: I(() => [
                                                                        H(
                                                                          T(
                                                                            P(i)(
                                                                              `student.statuses.cancelled`,
                                                                            ),
                                                                          ),
                                                                          1,
                                                                        ),
                                                                      ]),
                                                                      _: 1,
                                                                    },
                                                                  ))
                                                                : U(``, !0),
                                                            ]),
                                                            W(`p`, Y_e, [
                                                              H(
                                                                T(e.fatherName) +
                                                                  ` ` +
                                                                  T(e.contactNumber) +
                                                                  ` `,
                                                                1,
                                                              ),
                                                              e.userUuid &&
                                                              P(Wh)(`user:impersonate`)
                                                                ? Re(
                                                                    (A(),
                                                                    M(
                                                                      `i`,
                                                                      {
                                                                        key: 0,
                                                                        class: `ltr:ml-2 rtl:mr-2 fas fa-sign-in cursor-pointer text-primary dark:text-gray-400`,
                                                                        onClick: (t) =>
                                                                          h(e.userUuid),
                                                                      },
                                                                      null,
                                                                      8,
                                                                      X_e,
                                                                    )),
                                                                    [[d, P(i)(`user.impersonate`)]],
                                                                  )
                                                                : U(``, !0),
                                                            ]),
                                                            W(`div`, Z_e, [
                                                              N(
                                                                c,
                                                                {
                                                                  size: `xs`,
                                                                  onClick: (t) =>
                                                                    m({
                                                                      name: `StudentShow`,
                                                                      params: {
                                                                        uuid: e.uuid,
                                                                      },
                                                                    }),
                                                                  class: O({
                                                                    "ring-2 ring-primary":
                                                                      g.type === `student` &&
                                                                      g.index === t &&
                                                                      g.button === `view`,
                                                                  }),
                                                                  ref_for: !0,
                                                                  ref: `studentViewButtons`,
                                                                },
                                                                {
                                                                  default: I(() => [
                                                                    H(T(P(i)(`general.view`)), 1),
                                                                  ]),
                                                                  _: 1,
                                                                },
                                                                8,
                                                                [`onClick`, `class`],
                                                              ),
                                                              N(
                                                                c,
                                                                {
                                                                  size: `xs`,
                                                                  design: `success`,
                                                                  onClick: (t) =>
                                                                    m({
                                                                      name: `StudentShowFee`,
                                                                      params: {
                                                                        uuid: e.uuid,
                                                                      },
                                                                    }),
                                                                  class: O({
                                                                    "ring-2 ring-primary":
                                                                      g.type === `student` &&
                                                                      g.index === t &&
                                                                      g.button === `fee`,
                                                                  }),
                                                                  ref_for: !0,
                                                                  ref: `studentFeeButtons`,
                                                                },
                                                                {
                                                                  default: I(() => [
                                                                    H(
                                                                      T(
                                                                        P(i)(`global.view`, {
                                                                          attribute:
                                                                            P(i)(`student.fee.fee`),
                                                                        }),
                                                                      ),
                                                                      1,
                                                                    ),
                                                                  ]),
                                                                  _: 1,
                                                                },
                                                                8,
                                                                [`onClick`, `class`],
                                                              ),
                                                            ]),
                                                          ]),
                                                          _: 2,
                                                        },
                                                        1032,
                                                        [`img-src`, `class`],
                                                      ),
                                                    ],
                                                  )
                                                ),
                                              ),
                                              128,
                                            )),
                                          ]))
                                        : U(``, !0),
                                    ],
                                    2,
                                  ),
                                ])),
                            s.search.startsWith(`.`)
                              ? U(``, !0)
                              : (A(),
                                M(`div`, Q_e, [
                                  N(n, null, {
                                    default: I(() => [H(T(P(i)(`employee.employee`)), 1)]),
                                    _: 1,
                                  }),
                                  s.employees.length
                                    ? U(``, !0)
                                    : (A(),
                                      L(
                                        r,
                                        {
                                          key: 0,
                                          design: `info`,
                                          size: `xs`,
                                        },
                                        {
                                          default: I(() => [
                                            H(T(P(i)(`general.select_no_result_text`)), 1),
                                          ]),
                                          _: 1,
                                        },
                                      )),
                                  W(
                                    `div`,
                                    {
                                      class: O([
                                        `scroller-thin-y scroller-hidden overflow-x-hidden`,
                                        {
                                          "h-[calc(100vh_-_350px)] sm:h-[calc(100vh_-_150px)]":
                                            s.employees.length > 1,
                                        },
                                      ]),
                                    },
                                    [
                                      s.employees.length
                                        ? (A(),
                                          M(`div`, $_e, [
                                            (A(!0),
                                            M(
                                              ke,
                                              null,
                                              ae(
                                                s.employees,
                                                (e, t) => (
                                                  A(),
                                                  M(
                                                    `div`,
                                                    {
                                                      key: e.uuid,
                                                    },
                                                    [
                                                      N(
                                                        u,
                                                        {
                                                          "img-src": e.photo,
                                                          class: O({
                                                            "border-2 border-primary":
                                                              g.type === `employee` &&
                                                              g.index === t,
                                                          }),
                                                        },
                                                        {
                                                          title: I(() => [
                                                            H(T(e.name) + ` `, 1),
                                                            W(
                                                              `span`,
                                                              eve,
                                                              `(` + T(e.codeNumber) + `)`,
                                                              1,
                                                            ),
                                                            W(
                                                              `i`,
                                                              {
                                                                class: `fas fa-up-right-from-square ltr:ml-2 rtl:mr-2 cursor-pointer`,
                                                                onClick: (t) => C(e.uuid),
                                                              },
                                                              null,
                                                              8,
                                                              tve,
                                                            ),
                                                          ]),
                                                          default: I(() => [
                                                            W(`p`, nve, [
                                                              H(T(e.age?.short) + ` `, 1),
                                                              e.userUuid &&
                                                              P(Wh)(`user:impersonate`)
                                                                ? Re(
                                                                    (A(),
                                                                    M(
                                                                      `i`,
                                                                      {
                                                                        key: 0,
                                                                        class: `ltr:ml-2 rtl:mr-2 fas fa-sign-in cursor-pointer text-primary dark:text-gray-400`,
                                                                        onClick: (t) =>
                                                                          h(e.userUuid),
                                                                      },
                                                                      null,
                                                                      8,
                                                                      rve,
                                                                    )),
                                                                    [[d, P(i)(`user.impersonate`)]],
                                                                  )
                                                                : U(``, !0),
                                                            ]),
                                                            W(
                                                              `p`,
                                                              ive,
                                                              T(e.designation) + ` ` + T(e.period),
                                                              1,
                                                            ),
                                                            W(`div`, ave, [
                                                              N(
                                                                c,
                                                                {
                                                                  size: `xs`,
                                                                  onClick: (t) =>
                                                                    m({
                                                                      name: `EmployeeShow`,
                                                                      params: {
                                                                        uuid: e.uuid,
                                                                      },
                                                                    }),
                                                                  class: O({
                                                                    "ring-2 ring-primary":
                                                                      g.type === `employee` &&
                                                                      g.index === t &&
                                                                      g.button === `view`,
                                                                  }),
                                                                  ref_for: !0,
                                                                  ref: `employeeViewButtons`,
                                                                },
                                                                {
                                                                  default: I(() => [
                                                                    H(T(P(i)(`general.view`)), 1),
                                                                  ]),
                                                                  _: 1,
                                                                },
                                                                8,
                                                                [`onClick`, `class`],
                                                              ),
                                                            ]),
                                                          ]),
                                                          _: 2,
                                                        },
                                                        1032,
                                                        [`img-src`, `class`],
                                                      ),
                                                    ],
                                                  )
                                                ),
                                              ),
                                              128,
                                            )),
                                          ]))
                                        : U(``, !0),
                                    ],
                                    2,
                                  ),
                                ])),
                          ]))
                        : U(``, !0),
                      s.matchedRoutes.length
                        ? (A(),
                          M(`div`, ove, [
                            N(n, null, {
                              default: I(() => [H(T(P(i)(`general.matched_routes`)), 1)]),
                              _: 1,
                            }),
                            W(
                              `div`,
                              {
                                class: O([
                                  `scroller-thin-y scroller-hidden overflow-x-hidden`,
                                  {
                                    "h-[calc(100vh_-_200px)]": s.matchedRoutes.length > 4,
                                  },
                                ]),
                              },
                              [
                                W(`div`, sve, [
                                  (A(!0),
                                  M(
                                    ke,
                                    null,
                                    ae(
                                      s.matchedRoutes,
                                      (e, t) => (
                                        A(),
                                        M(
                                          `div`,
                                          {
                                            key: e.name,
                                          },
                                          [
                                            N(
                                              u,
                                              {
                                                onClick: (t) =>
                                                  m({
                                                    name: e.name,
                                                  }),
                                                class: O([
                                                  `cursor-pointer`,
                                                  {
                                                    "border-2 border-primary":
                                                      g.type === `route` && g.index === t,
                                                  },
                                                ]),
                                              },
                                              {
                                                title: I(() => [H(T(e.label), 1)]),
                                                _: 2,
                                              },
                                              1032,
                                              [`onClick`, `class`],
                                            ),
                                          ],
                                        )
                                      ),
                                    ),
                                    128,
                                  )),
                                ]),
                              ],
                              2,
                            ),
                          ]))
                        : U(``, !0),
                      s.teams.length
                        ? (A(),
                          M(`div`, cve, [
                            N(n, null, {
                              default: I(() => [H(T(P(i)(`team.teams`)), 1)]),
                              _: 1,
                            }),
                            W(
                              `div`,
                              {
                                class: O([
                                  `scroller-thin-y scroller-hidden overflow-x-hidden`,
                                  {
                                    "h-[calc(100vh_-_200px)]": s.teams.length > 4,
                                  },
                                ]),
                              },
                              [
                                W(`div`, lve, [
                                  (A(!0),
                                  M(
                                    ke,
                                    null,
                                    ae(
                                      s.teams,
                                      (e, n) => (
                                        A(),
                                        M(
                                          `div`,
                                          {
                                            key: e.uuid,
                                          },
                                          [
                                            N(
                                              u,
                                              {
                                                onClick: (t) => x(e),
                                                class: O([
                                                  `cursor-pointer`,
                                                  {
                                                    "border-2 border-primary":
                                                      g.type === `team` && g.index === n,
                                                  },
                                                ]),
                                              },
                                              {
                                                title: I(() => [
                                                  e.id === l.value
                                                    ? (A(),
                                                      M(`span`, uve, [
                                                        ...(t[3] ||= [
                                                          W(
                                                            `i`,
                                                            {
                                                              class: `far fa-check-circle text-success fa-lg`,
                                                            },
                                                            null,
                                                            -1,
                                                          ),
                                                        ]),
                                                      ]))
                                                    : U(``, !0),
                                                  H(` ` + T(e.name), 1),
                                                ]),
                                                _: 2,
                                              },
                                              1032,
                                              [`onClick`, `class`],
                                            ),
                                          ],
                                        )
                                      ),
                                    ),
                                    128,
                                  )),
                                ]),
                              ],
                              2,
                            ),
                          ]))
                        : U(``, !0),
                    ]),
                  ]),
                ]))
              : U(``, !0);
          }
        );
      },
    },
  );
B();
function N9(e, t) {
  return qe() ? (Ie(e, t), !0) : !1;
}
var P9 = typeof window < `u` && typeof document < `u`;
typeof WorkerGlobalScope < `u` && globalThis instanceof WorkerGlobalScope;
function F9(e, t = 1e3, n = {}) {
  let { immediate: r = !0, immediateCallback: i = !1 } = n,
    a = null,
    o = xe(!1);
  function s() {
    a &&= (clearInterval(a), null);
  }
  function c() {
    ((o.value = !1), s());
  }
  function l() {
    let n = Ye(t);
    n <= 0 || ((o.value = !0), i && e(), s(), o.value && (a = setInterval(e, n)));
  }
  return (
    r && P9 && l(),
    (Be(t) || typeof t == `function`) &&
      N9(
        He(t, () => {
          o.value && P9 && l();
        }),
      ),
    N9(c),
    {
      isActive: Ze(o),
      pause: c,
      resume: l,
    }
  );
}
B();
var fve = P9 ? window : void 0;
(P9 && window.document, P9 && window.navigator, P9 && window.location);
function I9(e, t = {}) {
  let { immediate: n = !0, fpsLimit: r = null, window: i = fve, once: a = !1 } = t,
    o = xe(!1),
    s = V(() => {
      let e = Ye(r);
      return e ? 1e3 / e : null;
    }),
    c = 0,
    l = null;
  function u(t) {
    if (!o.value || !i) return;
    c ||= t;
    let n = t - c;
    if (s.value && n < s.value) {
      l = i.requestAnimationFrame(u);
      return;
    }
    if (
      ((c = t),
      e({
        delta: n,
        timestamp: t,
      }),
      a)
    ) {
      ((o.value = !1), (l = null));
      return;
    }
    l = i.requestAnimationFrame(u);
  }
  function d() {
    !o.value && i && ((o.value = !0), (c = 0), (l = i.requestAnimationFrame(u)));
  }
  function f() {
    ((o.value = !1), l != null && i && (i.cancelAnimationFrame(l), (l = null)));
  }
  return (
    n && d(),
    N9(f),
    {
      isActive: Ze(o),
      pause: f,
      resume: d,
    }
  );
}
function pve(e) {
  if (`interval` in e || `immediate` in e) {
    let { interval: t = `requestAnimationFrame`, immediate: n = !0 } = e;
    return t === `requestAnimationFrame`
      ? (e) =>
          I9(e, {
            immediate: n,
          })
      : (n) => F9(n, t, e);
  }
  return I9;
}
function mve(e = {}) {
  let { controls: t = !1, scheduler: n = pve(e) } = e,
    r = xe(new Date()),
    i = n(() => (r.value = new Date()));
  return t
    ? {
        now: r,
        ...i,
      }
    : r;
}
var hve = [
    {
      max: 6e4,
      value: 1e3,
      name: `second`,
    },
    {
      max: 276e4,
      value: 6e4,
      name: `minute`,
    },
    {
      max: 72e6,
      value: 36e5,
      name: `hour`,
    },
    {
      max: 5184e5,
      value: 864e5,
      name: `day`,
    },
    {
      max: 24192e5,
      value: 6048e5,
      name: `week`,
    },
    {
      max: 28512e6,
      value: 2592e6,
      name: `month`,
    },
    {
      max: 1 / 0,
      value: 31536e6,
      name: `year`,
    },
  ],
  gve = {
    justNow: `just now`,
    past: (e) => (/\d/.test(e) ? `${e} ago` : e),
    future: (e) => (/\d/.test(e) ? `in ${e}` : e),
    month: (e, t) =>
      e === 1 ? (t ? `last month` : `next month`) : `${e} month${e > 1 ? `s` : ``}`,
    year: (e, t) => (e === 1 ? (t ? `last year` : `next year`) : `${e} year${e > 1 ? `s` : ``}`),
    day: (e, t) => (e === 1 ? (t ? `yesterday` : `tomorrow`) : `${e} day${e > 1 ? `s` : ``}`),
    week: (e, t) => (e === 1 ? (t ? `last week` : `next week`) : `${e} week${e > 1 ? `s` : ``}`),
    hour: (e) => `${e} hour${e > 1 ? `s` : ``}`,
    minute: (e) => `${e} minute${e > 1 ? `s` : ``}`,
    second: (e) => `${e} second${e > 1 ? `s` : ``}`,
    invalid: ``,
  };
function _ve(e) {
  return e.toISOString().slice(0, 10);
}
function vve(e) {
  if (`updateInterval` in e) {
    let { updateInterval: t = 3e4 } = e;
    return (e) => F9(e, t);
  }
  return (e) => F9(e, 3e4);
}
function L9(e, t = {}) {
  let { controls: n = !1, scheduler: r = vve(t) } = t,
    { now: i, ...a } = mve({
      scheduler: r,
      controls: !0,
    }),
    o = V(() => yve(new Date(Ye(e)), t, Ye(i)));
  return n
    ? {
        timeAgo: o,
        ...a,
      }
    : o;
}
function yve(e, t = {}, n = Date.now()) {
  let {
      max: r,
      messages: i = gve,
      fullDateFormatter: a = _ve,
      units: o = hve,
      showSecond: s = !1,
      rounding: c = `round`,
    } = t,
    l = typeof c == `number` ? (e) => +e.toFixed(c) : Math[c],
    u = n - +e,
    d = Math.abs(u);
  function f(e, t) {
    return l(Math.abs(e) / t.value);
  }
  function p(e, t) {
    let n = f(e, t),
      r = e > 0,
      i = m(t.name, n, r);
    return m(r ? `past` : `future`, i, r);
  }
  function m(e, t, n) {
    let r = i[e];
    return typeof r == `function` ? r(t, n) : r.replace(`{0}`, t.toString());
  }
  if (d < 6e4 && !s) return i.justNow;
  if (typeof r == `number` && d > r) return a(new Date(e));
  if (typeof r == `string`) {
    let t = o.find((e) => e.name === r)?.max;
    if (t && d > t) return a(new Date(e));
  }
  for (let [e, t] of o.entries()) {
    if (f(u, t) <= 0 && o[e - 1]) return p(u, o[e - 1]);
    if (d < t.max) return p(u, t);
  }
  return i.invalid;
}
B();
var bve = {
    class: `relative notification-dropdown`,
  },
  xve = {
    key: 0,
    class: `absolute -top-1 ltr:-right-3 rtl:-left-3 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center`,
  },
  Sve = {
    key: 0,
    class: `z-50 md:absolute ltr:md:right-0 rtl:md:left-0 md:mt-2 md:w-80 md:rounded-lg md:top-auto ltr:md:left-auto rtl:md:right-auto md:h-auto fixed ltr:left-0 rtl:right-0 top-20 w-full h-[calc(100vh-4rem)] rounded-none bg-white dark:bg-dark-body shadow-lg border border-gray-200 dark:border-gray-700 flex flex-col transition-all`,
  },
  Cve = {
    class: `px-4 py-2 border-b border-gray-200 dark:border-gray-700 flex-shrink-0 bg-white dark:bg-dark-body`,
  },
  wve = {
    class: `flex items-center justify-between w-full`,
  },
  Tve = {
    class: `text-lg font-semibold text-gray-800 dark:text-gray-300`,
  },
  Eve = {
    key: 0,
  },
  Dve = {
    class: `px-4 py-2 text-sm text-gray-700 dark:text-gray-400`,
  },
  Ove = {
    class: `flex-1 bg-white dark:bg-dark-body max-h-96 scroller-thin-y scroller-hidden`,
  },
  kve = [`onClick`],
  Ave = {
    class: `flex items-start space-x-3`,
  },
  jve = [`src`, `alt`],
  Mve = {
    class: `flex-1`,
  },
  Nve = {
    class: `text-sm text-gray-800 dark:text-gray-300`,
  },
  Pve = {
    class: `flex items-center align-middle justify-between space-x-2 mt-1`,
  },
  Fve = {
    class: `text-xs text-gray-500 dark:text-gray-400`,
  },
  Ive = {
    class: `text-xs dark:text-gray-400`,
  },
  Lve = {
    key: 1,
    class: `p-4 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-dark-body flex-shrink-0`,
  },
  Rve = {
    __name: `NotificationList`,
    setup(e) {
      let t = Dc(),
        n = Ec(),
        r = $e(),
        { isRtl: i } = Kh(),
        a = F(!1),
        o = Ae({
          isLoading: !1,
          unreadCount: 0,
        }),
        s = V(() => r.getters[`notification/unreadCount`]),
        c = V(() => r.getters[`notification/notifications`]),
        l = async () => {
          o.isLoading ||
            ((o.isLoading = !0),
            await r
              .dispatch(`notification/list`, {
                params: {
                  lastest: !0,
                },
              })
              .then((e) => {})
              .catch((e) => {
                console.error(`Error loading notifications:`, e);
              })
              .finally(() => {
                o.isLoading = !1;
              }));
        },
        u = () => {
          a.value = !a.value;
        },
        d = () => {
          ((a.value = !1),
            n.push({
              name: `Notification`,
            }));
        },
        f = (e) => {
          let t = document.querySelector(`.notification-dropdown`);
          t && !t.contains(e.target) && (a.value = !1);
        },
        p = (e) => L9(new Date(e.replace(` `, `T`))),
        m = (e) => {
          e.link.isClickable && e.link.route && n.push(e.link.route);
        },
        h = async (e) => {
          if (((a.value = !1), e.isRead)) {
            m(e);
            return;
          }
          await r
            .dispatch(`notification/markAsRead`, {
              uuid: e.uuid,
            })
            .then(() => {
              ((e.isRead = !0), (o.unreadCount = o.unreadCount > 0 ? o.unreadCount - 1 : 0), m(e));
            })
            .catch((e) => {
              console.error(`Error marking notification as read:`, e);
            });
        };
      return (
        Qe(() => {
          (l(), document.addEventListener(`click`, f));
        }),
        E(() => {
          document.removeEventListener(`click`, f);
        }),
        (e, n) => (
          A(),
          M(`div`, bve, [
            W(
              `button`,
              {
                onClick: u,
                class: `relative text-gray-600 hover:text-gray-800 focus:outline-none`,
              },
              [
                (n[0] ||= W(
                  `i`,
                  {
                    class: `far fa-bell text-lg text-white`,
                  },
                  null,
                  -1,
                )),
                s.value > 0
                  ? (A(), M(`span`, xve, T(s.value > 99 ? `99+` : s.value), 1))
                  : U(``, !0),
              ],
            ),
            a.value
              ? (A(),
                M(`div`, Sve, [
                  W(`div`, Cve, [
                    W(`div`, wve, [
                      W(`h3`, Tve, T(e.$trans(`notification.notifications`)), 1),
                      c.value.data.length == 0 && P(t).name != `Notification`
                        ? (A(),
                          M(
                            `span`,
                            {
                              key: 0,
                              onClick: d,
                              class: `text-xs text-gray-500 dark:text-gray-400 cursor-pointer`,
                            },
                            [
                              W(
                                `i`,
                                {
                                  class: O([
                                    `fas`,
                                    {
                                      "fa-chevron-right": !P(i),
                                      "fa-chevron-left": P(i),
                                    },
                                  ]),
                                },
                                null,
                                2,
                              ),
                            ],
                          ))
                        : U(``, !0),
                    ]),
                  ]),
                  c.value.data.length === 0
                    ? (A(),
                      M(`div`, Eve, [
                        W(`div`, Dve, T(e.$trans(`notification.no_notification_found`)), 1),
                      ]))
                    : U(``, !0),
                  W(`div`, Ove, [
                    (A(!0),
                    M(
                      ke,
                      null,
                      ae(
                        c.value.data,
                        (e) => (
                          A(),
                          M(
                            `div`,
                            {
                              key: e.uuid,
                              class: O([
                                `p-4 hover:bg-gray-100 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-700 cursor-pointer`,
                                {
                                  "bg-blue-50 dark:bg-dark-header": !e.isRead,
                                },
                              ]),
                              onClick: (t) => h(e),
                            },
                            [
                              W(`div`, Ave, [
                                W(
                                  `img`,
                                  {
                                    src: e.sender?.avatar,
                                    alt: e.sender?.name,
                                    class: `w-10 h-10 rounded-full`,
                                  },
                                  null,
                                  8,
                                  jve,
                                ),
                                W(`div`, Mve, [
                                  W(`p`, Nve, T(e.content), 1),
                                  W(`div`, Pve, [
                                    W(`span`, Fve, T(p(e.createdAt.at)), 1),
                                    W(`span`, Ive, T(e.sender?.name), 1),
                                  ]),
                                ]),
                              ]),
                            ],
                            10,
                            kve,
                          )
                        ),
                      ),
                      128,
                    )),
                  ]),
                  c.value.data.length > 0
                    ? (A(),
                      M(`div`, Lve, [
                        W(
                          `button`,
                          {
                            onClick: d,
                            class: `w-full py-2 px-4 bg-gray-200 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-md text-sm font-medium transition-colors`,
                          },
                          T(
                            e.$trans(`global.view_all`, {
                              attribute: e.$trans(`notification.notifications`),
                            }),
                          ),
                          1,
                        ),
                      ]))
                    : U(``, !0),
                ]))
              : U(``, !0),
          ])
        )
      );
    },
  };
B();
var zve = {
    key: 0,
    class: `fixed inset-0 bg-white dark:bg-dark-body z-50 w-full h-full overflow-hidden`,
  },
  Bve = {
    class: `px-2 py-4 sm:p-4 md:p-8 lg:p-12`,
  },
  Vve = {
    class: `flex justify-between items-center mb-6`,
  },
  Hve = {
    class: `text-2xl font-medium text-gray-900 dark:text-white`,
  },
  Uve = {
    class: `mt-4`,
  },
  Wve = {
    class: `grid grid-cols-1 gap-6 max-w-2xl`,
  },
  Gve = {
    class: `col-span-1`,
  },
  Kve = {
    key: 0,
    class: `col-span-1`,
  },
  qve = {
    key: 1,
    class: `col-span-1`,
  },
  R9 = `auth/user/`,
  Jve = {
    __name: `UserScope`,
    setup(e, { expose: t }) {
      let n = Bh(R9),
        r = F(!1),
        i = Vh(`teams`),
        a = Vh(`organizations`),
        o = Vh(`userScopes`),
        s = {
          scope: ``,
          organization: ``,
          teams: [],
        },
        c = Ae({
          ...s,
        }),
        l = () => {
          r.value = !0;
        },
        u = () => {
          ((r.value = !1), Object.assign(c, s));
        },
        d = () => {
          (u(), window.location.reload());
        },
        f = (e) => {
          ((e.ctrlKey || e.metaKey) && e.key === `/` && (e.preventDefault(), l()),
            e.key === `Escape` && r.value && u());
        };
      return (
        Qe(() => {
          (window.addEventListener(`keydown`, f),
            (s.scope = Hh(`scope`).value),
            (s.organization =
              Hh(`scope`).value == `organization_wise` ? Hh(`scopeDetail.organization`).value : ``),
            (s.teams = Hh(`scope`).value == `multiple_teams` ? Hh(`scopeDetail.teams`).value : []),
            Object.assign(c, s));
        }),
        E(() => {
          window.removeEventListener(`keydown`, f);
        }),
        t({
          openModal: l,
        }),
        (e, t) => {
          let l = j(`CustomCheckbox`),
            f = j(`FormAction`);
          return r.value
            ? (A(),
              M(`div`, zve, [
                W(`div`, Bve, [
                  W(`div`, Vve, [
                    W(
                      `div`,
                      Hve,
                      T(
                        e.$trans(`global.choose`, {
                          attribute: e.$trans(`user.props.scope`),
                        }),
                      ),
                      1,
                    ),
                    W(
                      `span`,
                      {
                        class: `cursor-pointer text-gray-700 dark:text-gray-400`,
                        onClick: u,
                      },
                      [
                        ...(t[6] ||= [
                          W(
                            `i`,
                            {
                              class: `fas fa-times`,
                            },
                            null,
                            -1,
                          ),
                        ]),
                      ],
                    ),
                  ]),
                  W(`div`, Uve, [
                    N(
                      f,
                      {
                        "no-card": ``,
                        "init-url": R9,
                        "init-form": s,
                        form: c,
                        action: `updateScope`,
                        "keep-adding": !1,
                        "after-submit": d,
                      },
                      {
                        default: I(() => [
                          W(`div`, Wve, [
                            W(`div`, Gve, [
                              N(
                                l,
                                {
                                  options: P(o),
                                  modelValue: c.scope,
                                  "onUpdate:modelValue": (t[0] ||= (e) => (c.scope = e)),
                                  error: P(n).scope,
                                  "onUpdate:error": (t[1] ||= (e) => (P(n).scope = e)),
                                },
                                null,
                                8,
                                [`options`, `modelValue`, `error`],
                              ),
                            ]),
                            c.scope == `organization_wise`
                              ? (A(),
                                M(`div`, Kve, [
                                  N(
                                    l,
                                    {
                                      size: `xs`,
                                      design: `success`,
                                      options: P(a).map((e) => ({
                                        label: e.name,
                                        value: e.id,
                                      })),
                                      modelValue: c.organization,
                                      "onUpdate:modelValue": (t[2] ||= (e) => (c.organization = e)),
                                      error: P(n).organization,
                                      "onUpdate:error": (t[3] ||= (e) => (P(n).organization = e)),
                                    },
                                    null,
                                    8,
                                    [`options`, `modelValue`, `error`],
                                  ),
                                ]))
                              : U(``, !0),
                            c.scope == `multiple_teams`
                              ? (A(),
                                M(`div`, qve, [
                                  N(
                                    l,
                                    {
                                      size: `xs`,
                                      design: `success`,
                                      options: P(i).map((e) => ({
                                        label: e.name,
                                        value: e.id,
                                      })),
                                      limit: 10,
                                      modelValue: c.teams,
                                      "onUpdate:modelValue": (t[4] ||= (e) => (c.teams = e)),
                                      error: P(n).teams,
                                      "onUpdate:error": (t[5] ||= (e) => (P(n).teams = e)),
                                    },
                                    null,
                                    8,
                                    [`options`, `modelValue`, `error`],
                                  ),
                                ]))
                              : U(``, !0),
                          ]),
                        ]),
                        _: 1,
                      },
                      8,
                      [`form`],
                    ),
                  ]),
                ]),
              ]))
            : U(``, !0);
        }
      );
    },
  };
B();
var Yve = Object.assign(
  {
    name: `ParentTransition`,
  },
  {
    props: {
      visibility: {
        type: Boolean,
        default: !1,
      },
      appear: {
        type: Boolean,
        default: !1,
      },
      as: {
        type: String,
        default: `div`,
      },
      direction: {
        type: String,
        default: `rtl`,
      },
      duration: {
        type: Number,
        default: 500,
      },
    },
    setup(e) {
      let t = e,
        n = V(() =>
          t.direction === `rtl` ? `translate-x-4 opacity-0` : `-translate-x-4 opacity-0`,
        ),
        r = V(() =>
          t.direction === `rtl` ? `translate-x-4 opacity-0` : `-translate-x-4 opacity-0`,
        );
      return (t, i) => (
        A(),
        L(
          P(xh),
          {
            as: e.as,
            appear: e.appear,
            show: e.visibility,
            enter: `transition transform duration-500 ease-out`,
            "enter-from": n.value,
            "enter-to": `translate-x-0 opacity-100`,
            leave: `transition transform duration-500 ease-in`,
            "leave-from": `translate-x-0 opacity-100`,
            "leave-to": r.value,
          },
          {
            default: I(() => [z(t.$slots, `default`)]),
            _: 3,
          },
          8,
          [`as`, `appear`, `show`, `enter-from`, `leave-to`],
        )
      );
    },
  },
);
B();
var Xve = Object.assign(
  {
    name: `ChildTransition`,
  },
  {
    props: {
      visibility: {
        type: Boolean,
        default: !1,
      },
      appear: {
        type: Boolean,
        default: !1,
      },
      as: {
        type: String,
        default: `div`,
      },
      direction: {
        type: String,
        default: `rtl`,
      },
    },
    setup(e) {
      let t = e,
        n = V(() =>
          t.direction === `rtl` ? `translate-x-10 opacity-0` : `-translate-x-10 opacity-0`,
        ),
        r = V(() =>
          t.direction === `rtl` ? `translate-x-10 opacity-0` : `-translate-x-10 opacity-0`,
        );
      return (t, i) => (
        A(),
        L(
          P(bh),
          {
            as: e.as,
            appear: e.appear,
            show: e.visibility,
            enter: `transition transform duration-500 ease-out`,
            "enter-from": n.value,
            "enter-to": `translate-x-0 opacity-100`,
            leave: `transition transform duration-500 ease-in`,
            "leave-from": `translate-x-0 opacity-100`,
            "leave-to": r.value,
          },
          {
            default: I(() => [z(t.$slots, `default`)]),
            _: 3,
          },
          8,
          [`as`, `appear`, `show`, `enter-from`, `leave-to`],
        )
      );
    },
  },
);
B();
var Zve = Object.assign(
  {
    name: `MenuParentTransition`,
  },
  {
    props: {
      visibility: {
        type: Boolean,
        default: !1,
      },
      appear: {
        type: Boolean,
        default: !1,
      },
      as: {
        type: String,
        default: `div`,
      },
      direction: {
        type: String,
        default: `up`,
      },
      duration: {
        type: Number,
        default: 200,
      },
    },
    setup(e) {
      let t = e,
        n = V(() =>
          t.direction === `up` ? `translate-y-4 opacity-0` : `-translate-y-4 opacity-0`,
        ),
        r = V(() =>
          t.direction === `up` ? `translate-y-4 opacity-0` : `-translate-y-4 opacity-0`,
        );
      return (t, i) => (
        A(),
        L(
          P(xh),
          {
            as: e.as,
            appear: e.appear,
            show: e.visibility,
            enter: `transition transform duration-200 ease-out`,
            "enter-from": n.value,
            "enter-to": `translate-y-0 opacity-100`,
            leave: `transition transform duration-200 ease-in`,
            "leave-from": `translate-y-0 opacity-100`,
            "leave-to": r.value,
          },
          {
            default: I(() => [z(t.$slots, `default`)]),
            _: 3,
          },
          8,
          [`as`, `appear`, `show`, `enter-from`, `leave-to`],
        )
      );
    },
  },
);
B();
var Qve = {
    key: 0,
    class: `mt-4 grid grid-cols-3 gap-6`,
  },
  $ve = {
    class: `col-span-3 sm:col-span-1`,
  },
  eye = {
    __name: `CustomField`,
    props: {
      customFields: {
        type: Array,
        required: !0,
      },
      formErrors: {
        type: Object,
        required: !0,
      },
    },
    setup(e) {
      let t = V(
        () => (e) =>
          e == `date_picker`
            ? `date`
            : e == `month_picker`
              ? `month`
              : e == `time_picker`
                ? `time`
                : `datetime`,
      );
      return (n, r) => {
        let i = j(`BaseInput`),
          a = j(`DatePicker`),
          o = j(`BaseTextarea`),
          s = j(`BaseSelect`),
          c = j(`BaseMultiCheckbox`),
          l = j(`BaseRadioGroup`);
        return e.customFields.length > 0
          ? (A(),
            M(`div`, Qve, [
              (A(!0),
              M(
                ke,
                null,
                ae(
                  e.customFields,
                  (n, r) => (
                    A(),
                    M(`div`, $ve, [
                      n.type.value == `text_input` ||
                      n.type.value == `email_input` ||
                      n.type.value == `currency_input`
                        ? (A(),
                          L(
                            i,
                            {
                              key: 0,
                              type: `text`,
                              currency: n.type.value == `currency_input`,
                              modelValue: n.value,
                              "onUpdate:modelValue": (e) => (n.value = e),
                              name: `customFields.${n.name}`,
                              label: n.label,
                              error: e.formErrors[`customFields.${r}.${n.name}`],
                              "onUpdate:error": (t) =>
                                (e.formErrors[`customFields.${r}.${n.name}`] = t),
                            },
                            null,
                            8,
                            [
                              `currency`,
                              `modelValue`,
                              `onUpdate:modelValue`,
                              `name`,
                              `label`,
                              `error`,
                              `onUpdate:error`,
                            ],
                          ))
                        : U(``, !0),
                      n.type.value == `number_input`
                        ? (A(),
                          L(
                            i,
                            {
                              key: 1,
                              type: `number`,
                              modelValue: n.value,
                              "onUpdate:modelValue": (e) => (n.value = e),
                              name: `customFields.${n.name}`,
                              label: n.label,
                              error: e.formErrors[`customFields.${r}.${n.name}`],
                              "onUpdate:error": (t) =>
                                (e.formErrors[`customFields.${r}.${n.name}`] = t),
                            },
                            null,
                            8,
                            [
                              `modelValue`,
                              `onUpdate:modelValue`,
                              `name`,
                              `label`,
                              `error`,
                              `onUpdate:error`,
                            ],
                          ))
                        : U(``, !0),
                      n.type.value == `date_picker` ||
                      n.type.value == `month_picker` ||
                      n.type.value == `time_picker` ||
                      n.type.value == `date_time_picker`
                        ? (A(),
                          L(
                            a,
                            {
                              key: 2,
                              as: t.value(n.type.value),
                              modelValue: n.value,
                              "onUpdate:modelValue": (e) => (n.value = e),
                              name: `customFields.${n.name}`,
                              label: n.label,
                              "no-clear": !!n.isRequired,
                              error: e.formErrors[`customFields.${r}.${n.name}`],
                              "onUpdate:error": (t) =>
                                (e.formErrors[`customFields.${r}.${n.name}`] = t),
                            },
                            null,
                            8,
                            [
                              `as`,
                              `modelValue`,
                              `onUpdate:modelValue`,
                              `name`,
                              `label`,
                              `no-clear`,
                              `error`,
                              `onUpdate:error`,
                            ],
                          ))
                        : U(``, !0),
                      n.type.value == `multi_line_text_input` || n.type.value == `markdown`
                        ? (A(),
                          L(
                            o,
                            {
                              key: 3,
                              modelValue: n.value,
                              "onUpdate:modelValue": (e) => (n.value = e),
                              name: `customFields.${n.name}`,
                              label: n.label,
                              error: e.formErrors[`customFields.${r}.${n.name}`],
                              "onUpdate:error": (t) =>
                                (e.formErrors[`customFields.${r}.${n.name}`] = t),
                            },
                            null,
                            8,
                            [
                              `modelValue`,
                              `onUpdate:modelValue`,
                              `name`,
                              `label`,
                              `error`,
                              `onUpdate:error`,
                            ],
                          ))
                        : U(``, !0),
                      n.type.value == `select_input` || n.type.value == `multi_select_input`
                        ? (A(),
                          L(
                            s,
                            {
                              key: 4,
                              multiple: n.type.value == `multi_select_input`,
                              modelValue: n.value,
                              "onUpdate:modelValue": (e) => (n.value = e),
                              options: n.optionArray,
                              name: `customFields.${n.name}`,
                              label: n.label,
                              error: e.formErrors[`customFields.${r}.${n.name}`],
                              "onUpdate:error": (t) =>
                                (e.formErrors[`customFields.${r}.${n.name}`] = t),
                            },
                            null,
                            8,
                            [
                              `multiple`,
                              `modelValue`,
                              `onUpdate:modelValue`,
                              `options`,
                              `name`,
                              `label`,
                              `error`,
                              `onUpdate:error`,
                            ],
                          ))
                        : U(``, !0),
                      n.type.value == `checkbox_input`
                        ? (A(),
                          L(
                            c,
                            {
                              key: 5,
                              horizontal: ``,
                              options: n.optionArray,
                              modelValue: n.value,
                              "onUpdate:modelValue": (e) => (n.value = e),
                              name: `customFields.${n.name}`,
                              label: n.label,
                              error: e.formErrors[`customFields.${r}.${n.name}`],
                              "onUpdate:error": (t) =>
                                (e.formErrors[`customFields.${r}.${n.name}`] = t),
                            },
                            null,
                            8,
                            [
                              `options`,
                              `modelValue`,
                              `onUpdate:modelValue`,
                              `name`,
                              `label`,
                              `error`,
                              `onUpdate:error`,
                            ],
                          ))
                        : U(``, !0),
                      n.type.value == `radio_input`
                        ? (A(),
                          L(
                            l,
                            {
                              key: 6,
                              "top-margin": ``,
                              options: n.optionArray,
                              modelValue: n.value,
                              "onUpdate:modelValue": (e) => (n.value = e),
                              name: `customFields.${n.name}`,
                              label: n.label,
                              error: e.formErrors[`customFields.${r}.${n.name}`],
                              "onUpdate:error": (t) =>
                                (e.formErrors[`customFields.${r}.${n.name}`] = t),
                              horizontal: ``,
                            },
                            null,
                            8,
                            [
                              `options`,
                              `modelValue`,
                              `onUpdate:modelValue`,
                              `name`,
                              `label`,
                              `error`,
                              `onUpdate:error`,
                            ],
                          ))
                        : U(``, !0),
                    ])
                  ),
                ),
                256,
              )),
            ]))
          : U(``, !0);
      };
    },
  };
B();
var tye = {
    class: `grid grid-cols-3 gap-6`,
  },
  nye = {
    class: `col-span-3 sm:col-span-1`,
  },
  rye = {
    class: `col-span-3 sm:col-span-1`,
  },
  iye = {
    class: `col-span-3 sm:col-span-1`,
  },
  aye = {
    class: `col-span-3`,
  },
  oye = Object.assign(
    {
      name: `ReminderInput`,
    },
    {
      props: {
        modelValue: {
          type: Object,
          default: () => ({
            date: ``,
            notifyBefore: ``,
            users: [],
            note: ``,
          }),
        },
        showReminder: {
          type: Boolean,
          default: !1,
        },
        errors: {
          type: Object,
          default: () => ({}),
        },
        isLoaded: {
          type: Boolean,
          default: !0,
        },
        initReminderUsers: {
          type: Array,
          default: () => [],
        },
      },
      emits: [`update:modelValue`],
      setup(e, { emit: t }) {
        let n = e,
          r = t,
          i = V({
            get: () => n.modelValue,
            set: (e) => r(`update:modelValue`, e),
          });
        return (
          He(
            () => i.value,
            (e) => {
              r(`update:modelValue`, e);
            },
            {
              deep: !0,
            },
          ),
          (t, n) => {
            let r = j(`DatePicker`),
              a = j(`BaseInput`),
              o = j(`BaseSelectSearch`),
              s = j(`BaseTextarea`),
              c = j(`BaseFieldset`);
            return e.showReminder
              ? (A(),
                L(
                  c,
                  {
                    key: 0,
                    class: `mt-4`,
                  },
                  {
                    legend: I(() => [H(T(t.$trans(`reminder.reminder`)), 1)]),
                    default: I(() => [
                      W(`div`, tye, [
                        W(`div`, nye, [
                          N(
                            r,
                            {
                              modelValue: i.value.date,
                              "onUpdate:modelValue": (n[0] ||= (e) => (i.value.date = e)),
                              name: `reminderDate`,
                              label: t.$trans(`reminder.props.date`),
                              error: e.errors[`reminder.date`],
                              "onUpdate:error": (n[1] ||= (t) => (e.errors[`reminder.date`] = t)),
                            },
                            null,
                            8,
                            [`modelValue`, `label`, `error`],
                          ),
                        ]),
                        i.value.date
                          ? (A(),
                            M(
                              ke,
                              {
                                key: 0,
                              },
                              [
                                W(`div`, rye, [
                                  N(
                                    a,
                                    {
                                      type: `number`,
                                      modelValue: i.value.notifyBefore,
                                      "onUpdate:modelValue": (n[2] ||= (e) =>
                                        (i.value.notifyBefore = e)),
                                      name: `reminderNotifyBefore`,
                                      label: t.$trans(`reminder.props.notify_before`),
                                      error: e.errors[`reminder.notifyBefore`],
                                      "onUpdate:error": (n[3] ||= (t) =>
                                        (e.errors[`reminder.notifyBefore`] = t)),
                                    },
                                    null,
                                    8,
                                    [`modelValue`, `label`, `error`],
                                  ),
                                ]),
                                W(`div`, iye, [
                                  e.isLoaded
                                    ? (A(),
                                      L(
                                        o,
                                        {
                                          key: 0,
                                          multiple: ``,
                                          name: `reminderUsers`,
                                          label: t.$trans(`reminder.props.users`),
                                          placeholder: t.$trans(`global.select`, {
                                            attribute: t.$trans(`employee.employee`),
                                          }),
                                          modelValue: i.value.users,
                                          "onUpdate:modelValue": (n[4] ||= (e) =>
                                            (i.value.users = e)),
                                          error: e.errors[`reminder.users`],
                                          "onUpdate:error": (n[5] ||= (t) =>
                                            (e.errors[`reminder.users`] = t)),
                                          "value-prop": `uuid`,
                                          "init-search": e.initReminderUsers,
                                          "search-key": `name`,
                                          "search-action": `employee/summary`,
                                        },
                                        {
                                          selectedOption: I((e) => [
                                            H(
                                              T(e.value.name) +
                                                ` (` +
                                                T(e.value.designation) +
                                                `) `,
                                              1,
                                            ),
                                          ]),
                                          listOption: I((e) => [
                                            H(
                                              T(e.option.name) +
                                                ` (` +
                                                T(e.option.designation) +
                                                `) `,
                                              1,
                                            ),
                                          ]),
                                          _: 1,
                                        },
                                        8,
                                        [
                                          `label`,
                                          `placeholder`,
                                          `modelValue`,
                                          `error`,
                                          `init-search`,
                                        ],
                                      ))
                                    : U(``, !0),
                                ]),
                                W(`div`, aye, [
                                  N(
                                    s,
                                    {
                                      rows: 1,
                                      modelValue: i.value.note,
                                      "onUpdate:modelValue": (n[6] ||= (e) => (i.value.note = e)),
                                      name: `reminderNote`,
                                      label: t.$trans(`reminder.props.note`),
                                      error: e.errors[`reminder.note`],
                                      "onUpdate:error": (n[7] ||= (t) =>
                                        (e.errors[`reminder.note`] = t)),
                                    },
                                    null,
                                    8,
                                    [`modelValue`, `label`, `error`],
                                  ),
                                ]),
                              ],
                              64,
                            ))
                          : U(``, !0),
                      ]),
                    ]),
                    _: 1,
                  },
                ))
              : U(``, !0);
          }
        );
      },
    },
  );
B();
var sye = {
    key: 0,
    class: `text-gray-50`,
  },
  cye = {
    key: 1,
    class: `text-gray-50`,
  },
  lye = {
    class: `py-1 max-h-96 scroller-thin-y scroller-hidden`,
  },
  uye = {
    class: `w-full flex justify-between items-center`,
  },
  dye = Object.assign(
    {
      name: `TeamSelectionFlyoutMenu`,
    },
    {
      setup(e) {
        let t = $e(),
          { screenSize: n } = M9(),
          { isRtl: r } = Kh(),
          i = Vh(`teams`),
          a = V(() => t.getters[`auth/user/currentTeamId`]),
          o = V(() => i.value.find((e) => e.id == a.value)),
          s = async (e) => {
            e.id != a.value &&
              (await t
                .dispatch(`team/select`, {
                  uuid: e.uuid,
                })
                .then(async (e) => {
                  (await t.dispatch(`auth/user/fetch`), location.reload());
                })
                .catch((e) => {}));
          };
        return (e, t) => {
          let c = j(`DropdownItem`),
            l = j(`DropdownMenu`);
          return P(i).length > 1
            ? (A(),
              L(
                l,
                {
                  key: 0,
                  "double-top-margin": ``,
                  "no-width": ``,
                  "right-margin": !1,
                  direction: P(r) ? `right` : `left`,
                },
                {
                  clickable: I(() => [
                    P(n).small
                      ? (A(), M(`span`, cye, T(o.value?.code || e.$trans(`team.team`)), 1))
                      : (A(), M(`span`, sye, T(o.value?.name || e.$trans(`team.team`)), 1)),
                  ]),
                  default: I(() => [
                    W(`div`, lye, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          P(i),
                          (e) => (
                            A(),
                            M(
                              ke,
                              null,
                              [
                                e.id == o.value.id
                                  ? U(``, !0)
                                  : (A(),
                                    L(
                                      c,
                                      {
                                        key: 0,
                                        onClick: (t) => s(e),
                                      },
                                      {
                                        default: I(() => [H(T(e.name), 1)]),
                                        _: 2,
                                      },
                                      1032,
                                      [`onClick`],
                                    )),
                                e.id == a.value
                                  ? (A(),
                                    L(
                                      c,
                                      {
                                        key: 1,
                                      },
                                      {
                                        default: I(() => [
                                          W(`div`, uye, [
                                            H(T(e.name) + ` `, 1),
                                            (t[0] ||= W(
                                              `i`,
                                              {
                                                class: `far fa-xl text-success fa-check-circle`,
                                              },
                                              null,
                                              -1,
                                            )),
                                          ]),
                                        ]),
                                        _: 2,
                                      },
                                      1024,
                                    ))
                                  : U(``, !0),
                              ],
                              64,
                            )
                          ),
                        ),
                        256,
                      )),
                    ]),
                  ]),
                  _: 1,
                },
                8,
                [`direction`],
              ))
            : U(``, !0);
        };
      },
    },
  );
B();
var fye = {
    key: 0,
    class: `inline-flex items-center text-base font-medium text-white`,
  },
  pye = {
    key: 0,
  },
  mye = {
    class: `text-gray-50`,
  },
  hye = {
    key: 0,
  },
  gye = {
    class: `py-1 max-h-96 scroller-thin-y scroller-hidden`,
  },
  _ye = {
    class: `w-full flex justify-between items-center`,
  },
  vye = Object.assign(
    {
      name: `PeriodSelectionFlyoutMenu`,
    },
    {
      setup(e) {
        let t = $e(),
          { screenSize: n } = M9(),
          { isRtl: r } = Kh(),
          i = Vh(`periods`),
          a = V(() => Wh(`period:change`)),
          o = V(() => t.getters[`auth/user/currentPeriodId`]),
          s = V(() => i.value.find((e) => e.id == o.value)),
          c = async (e) => {
            e.id != o.value &&
              (await t
                .dispatch(`academic/period/select`, {
                  uuid: e.uuid,
                })
                .then(async (e) => {
                  (await t.dispatch(`auth/user/fetch`), location.reload());
                })
                .catch((e) => {}));
          };
        return (e, t) => {
          let n = j(`DropdownItem`),
            l = j(`DropdownMenu`);
          return (
            A(),
            M(
              ke,
              null,
              [
                P(i).length == 1 || !a.value
                  ? (A(),
                    M(`span`, fye, [
                      W(`span`, null, [
                        H(T(s.value?.code || s.value?.name || ``) + ` `, 1),
                        s.value?.sessionCode || s.value?.sessionName
                          ? (A(),
                            M(
                              `span`,
                              pye,
                              `(` + T(s.value?.sessionCode || s.value?.sessionName) + `)`,
                              1,
                            ))
                          : U(``, !0),
                      ]),
                    ]))
                  : U(``, !0),
                P(i).length > 1 && a.value
                  ? (A(),
                    L(
                      l,
                      {
                        key: 1,
                        "double-top-margin": ``,
                        "no-width": ``,
                        "right-margin": !1,
                        direction: P(r) ? `right` : `left`,
                      },
                      {
                        clickable: I(() => [
                          W(`span`, mye, [
                            H(
                              T(
                                s.value?.code ||
                                  s.value?.name ||
                                  e.$trans(`academic.period.period`),
                              ) + ` `,
                              1,
                            ),
                            s.value?.sessionCode || s.value?.sessionName
                              ? (A(),
                                M(
                                  `span`,
                                  hye,
                                  `(` + T(s.value?.sessionCode || s.value?.sessionName) + `)`,
                                  1,
                                ))
                              : U(``, !0),
                          ]),
                        ]),
                        default: I(() => [
                          W(`div`, gye, [
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                P(i).filter((e) => !e.isArchived),
                                (e) => (
                                  A(),
                                  M(
                                    ke,
                                    null,
                                    [
                                      e.id == o.value
                                        ? U(``, !0)
                                        : (A(),
                                          L(
                                            n,
                                            {
                                              key: 0,
                                              onClick: (t) => c(e),
                                            },
                                            {
                                              default: I(() => [H(T(e.name), 1)]),
                                              _: 2,
                                            },
                                            1032,
                                            [`onClick`],
                                          )),
                                      e.id == o.value
                                        ? (A(),
                                          L(
                                            n,
                                            {
                                              key: 1,
                                            },
                                            {
                                              default: I(() => [
                                                W(`div`, _ye, [
                                                  H(T(e.name) + ` `, 1),
                                                  (t[0] ||= W(
                                                    `i`,
                                                    {
                                                      class: `far fa-xl text-success fa-check-circle`,
                                                    },
                                                    null,
                                                    -1,
                                                  )),
                                                ]),
                                              ]),
                                              _: 2,
                                            },
                                            1024,
                                          ))
                                        : U(``, !0),
                                    ],
                                    64,
                                  )
                                ),
                              ),
                              256,
                            )),
                          ]),
                        ]),
                        _: 1,
                      },
                      8,
                      [`direction`],
                    ))
                  : U(``, !0),
              ],
              64,
            )
          );
        };
      },
    },
  );
B();
var z9 = {
    key: 0,
    class: `inline-flex items-center text-base font-medium text-white`,
  },
  yye = {
    key: 0,
    class: `ml-1`,
  },
  bye = {
    class: `text-gray-50`,
  },
  xye = {
    key: 0,
  },
  Sye = {
    class: `py-1 max-h-96 scroller-thin-y scroller-hidden`,
  },
  Cye = [`onClick`],
  wye = {
    class: `flex justify-between items-center w-full`,
  },
  Tye = {
    key: 0,
    class: `far fa-xl text-success fa-check-circle`,
  },
  Eye = Object.assign(
    {
      name: `PeriodSelectionFlyoutMenu`,
    },
    {
      setup(e) {
        let t = $e(),
          { screenSize: n } = M9(),
          { isRtl: r } = Kh(),
          i = Vh(`periods`),
          a = V(() => Wh(`period:change`)),
          o = V(() => t.getters[`auth/user/currentPeriodId`]),
          s = V(() => i.value.find((e) => e.id == o.value)),
          c = () => {
            let e = [];
            return (
              i.value.forEach((t) => {
                e.includes(t.sessionName) || e.push(t.sessionName);
              }),
              e.map((e) => ({
                sessionName: e,
                periods: i.value
                  .filter((t) => t.sessionName == e)
                  .sort((e, t) => new Date(e.startDate.value) - new Date(t.startDate.value)),
              }))
            );
          },
          l = F(null),
          u = async (e) => {
            e.id != o.value &&
              (await t
                .dispatch(`academic/period/select`, {
                  uuid: e.uuid,
                })
                .then(async (e) => {
                  (await t.dispatch(`auth/user/fetch`), location.reload());
                })
                .catch((e) => {}));
          };
        return (e, t) => {
          let n = j(`DropdownItem`),
            d = j(`DropdownMenu`);
          return (
            A(),
            M(
              ke,
              null,
              [
                P(i).length == 1 || !a.value
                  ? (A(),
                    M(`span`, z9, [
                      H(T(s.value?.code || s.value?.name || ``) + ` `, 1),
                      s.value?.sessionCode || s.value?.sessionName
                        ? (A(),
                          M(
                            `span`,
                            yye,
                            `(` + T(s.value?.sessionCode || s.value?.sessionName) + `)`,
                            1,
                          ))
                        : U(``, !0),
                    ]))
                  : U(``, !0),
                P(i).length > 1 && a.value
                  ? (A(),
                    L(
                      d,
                      {
                        key: 1,
                        "double-top-margin": ``,
                        "no-width": ``,
                        "right-margin": !1,
                        direction: P(r) ? `right` : `left`,
                      },
                      {
                        clickable: I(() => [
                          W(`span`, bye, [
                            H(
                              T(
                                s.value?.code ||
                                  s.value?.name ||
                                  e.$trans(`academic.period.period`),
                              ) + ` `,
                              1,
                            ),
                            s.value?.sessionCode || s.value?.sessionName
                              ? (A(),
                                M(
                                  `span`,
                                  xye,
                                  `(` + T(s.value?.sessionCode || s.value?.sessionName) + `)`,
                                  1,
                                ))
                              : U(``, !0),
                          ]),
                        ]),
                        default: I(() => [
                          W(`div`, Sye, [
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                c(),
                                (e) => (
                                  A(),
                                  M(
                                    ke,
                                    null,
                                    [
                                      W(
                                        `div`,
                                        {
                                          onClick: (t) => (l.value = e.sessionName),
                                          class: `cursor-pointer ml-2 group flex items-center py-2 text-sm font-medium text-gray-900 dark:text-gray-400`,
                                        },
                                        T(e.sessionName),
                                        9,
                                        Cye,
                                      ),
                                      l.value == e.sessionName
                                        ? (A(!0),
                                          M(
                                            ke,
                                            {
                                              key: 0,
                                            },
                                            ae(
                                              e.periods,
                                              (e) => (
                                                A(),
                                                L(
                                                  n,
                                                  {
                                                    class: `ml-2`,
                                                    onClick: (t) => u(e),
                                                  },
                                                  {
                                                    default: I(() => [
                                                      W(`span`, wye, [
                                                        H(T(e.name) + ` `, 1),
                                                        e.id == o.value
                                                          ? (A(), M(`i`, Tye))
                                                          : U(``, !0),
                                                      ]),
                                                    ]),
                                                    _: 2,
                                                  },
                                                  1032,
                                                  [`onClick`],
                                                )
                                              ),
                                            ),
                                            256,
                                          ))
                                        : U(``, !0),
                                    ],
                                    64,
                                  )
                                ),
                              ),
                              256,
                            )),
                          ]),
                        ]),
                        _: 1,
                      },
                      8,
                      [`direction`],
                    ))
                  : U(``, !0),
              ],
              64,
            )
          );
        };
      },
    },
  );
B();
var Dye = {
    key: 0,
    class: `isolate inline-flex rounded-md shadow-sm`,
  },
  Oye = [`disabled`],
  kye = {
    class: `space-x-2`,
  },
  Aye = {
    key: 0,
  },
  jye = {
    key: 1,
  },
  Mye = {
    key: 2,
  },
  Nye = {
    key: 3,
  },
  Pye = {
    class: `dark:bg-dark-body w-64 divide-y divide-gray-200 text-sm dark:divide-gray-700 dark:text-gray-300`,
  },
  Fye = {
    class: `flex justify-between px-4 py-2`,
  },
  Iye = {
    class: `text-success`,
  },
  Lye = {
    class: `ml-2 text-xs text-gray-400`,
  },
  Rye = {
    key: 0,
    class: `text-danger`,
  },
  zye = {
    __name: `TimesheetClock`,
    setup(e) {
      let t = $e(),
        n = R(`$trans`),
        { screenSize: r } = M9(),
        i = Hh(`currentPeriodId`),
        a = V(() => Vh(`employee.allowEmployeeClockInOut`).value),
        o = V(() => Vh(`employee.enableGeolocationTimesheet`).value),
        s = F(!1),
        c = Ae({
          hasTimesheet: !1,
          timesheet: {},
          timesheets: [],
        }),
        l = async () => {
          Gh([`student`, `guardian`], `any`) ||
            (i.value &&
              a.value &&
              (await t
                .dispatch(`employee/attendance/timesheet/check`)
                .then((e) => {
                  e.hasTimesheet &&
                    ((c.hasTimesheet = !0),
                    (c.timesheet = e.timesheet),
                    (c.timesheets = e.timesheets || 0));
                })
                .catch((e) => {})));
        },
        u = async () => {
          if (((s.value = !0), !o.value)) {
            (await d(), (s.value = !1));
            return;
          }
          `geolocation` in navigator
            ? navigator.geolocation.getCurrentPosition(f, p, {
                maximumAge: Vh(`employee.cacheGeolocationData`).value,
              })
            : (pb(n(`employee.attendance.timesheet.geolocation_not_supported`)), (s.value = !1));
        },
        d = async (e = {}) => {
          await t
            .dispatch(`employee/attendance/timesheet/clock`, {
              type: c.timesheet?.clockIn ? `in` : `out`,
              location: e,
            })
            .then((e) => {
              ((c.timesheet = e.timesheet), (c.timesheets = e.timesheets || 0), (s.value = !1));
            })
            .catch((e) => {
              s.value = !1;
            });
        },
        f = async (e) => {
          let t = e.coords.latitude,
            n = e.coords.longitude;
          await d({
            latitude: t,
            longitude: n,
          });
        },
        p = (e) => {
          (pb(n(`employee.attendance.timesheet.unable_to_detect_geolocation`)), (s.value = !1));
        };
      return (
        Qe(async () => {
          await l();
        }),
        (e, t) => {
          let i = j(`VDropdown`);
          return a.value && c.hasTimesheet
            ? (A(),
              M(`span`, Dye, [
                W(
                  `button`,
                  {
                    type: `button`,
                    disabled: s.value,
                    onClick: u,
                    class: O([
                      `relative inline-flex items-center border px-2 py-1 sm:px-4 sm:py-2 text-sm font-medium`,
                      {
                        "bg-info border-info text-secondary hover:bg-dark-info":
                          c.timesheet?.clockIn,
                        "bg-danger border-danger text-secondary hover:bg-dark-danger":
                          c.timesheet?.clockOut,
                        "rounded-l-md": c.timesheets.length,
                        "rounded-md": c.timesheets.length === 0,
                      },
                    ]),
                  },
                  [
                    W(`div`, kye, [
                      s.value
                        ? (A(),
                          M(`span`, Aye, [
                            ...(t[0] ||= [
                              W(
                                `i`,
                                {
                                  class: `fas fa-spinner fa-spin`,
                                },
                                null,
                                -1,
                              ),
                            ]),
                          ]))
                        : U(``, !0),
                      o.value
                        ? (A(),
                          M(`span`, jye, [
                            ...(t[1] ||= [
                              W(
                                `i`,
                                {
                                  class: `fas fa-location-dot`,
                                },
                                null,
                                -1,
                              ),
                            ]),
                          ]))
                        : U(``, !0),
                      P(r).small
                        ? (A(),
                          M(`span`, Nye, [
                            ...(t[2] ||= [
                              W(
                                `i`,
                                {
                                  class: `fas fa-clock`,
                                },
                                null,
                                -1,
                              ),
                            ]),
                          ]))
                        : (A(),
                          M(
                            `span`,
                            Mye,
                            T(
                              c.timesheet?.clockIn
                                ? P(n)(`employee.attendance.timesheet.props.clock_in`)
                                : P(n)(`employee.attendance.timesheet.props.clock_out`),
                            ),
                            1,
                          )),
                    ]),
                  ],
                  10,
                  Oye,
                ),
                c.timesheets.length
                  ? (A(),
                    L(
                      i,
                      {
                        key: 0,
                        distance: 6,
                        placement: `bottom-end`,
                      },
                      {
                        popper: I(() => [
                          W(`div`, Pye, [
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                c.timesheets,
                                (e) => (
                                  A(),
                                  M(`div`, Fye, [
                                    W(`div`, Iye, [
                                      (t[3] ||= W(
                                        `i`,
                                        {
                                          class: `fas fa-circle-arrow-down text-green-400`,
                                        },
                                        null,
                                        -1,
                                      )),
                                      H(` ` + T(e.inAtTime.formatted) + ` `, 1),
                                      W(`span`, Lye, T(e.duration), 1),
                                    ]),
                                    e.outAt
                                      ? (A(),
                                        M(`div`, Rye, [
                                          H(T(e.outAtTime.formatted) + ` `, 1),
                                          (t[4] ||= W(
                                            `i`,
                                            {
                                              class: `fas fa-circle-arrow-up text-red-400`,
                                            },
                                            null,
                                            -1,
                                          )),
                                        ]))
                                      : U(``, !0),
                                  ])
                                ),
                              ),
                              256,
                            )),
                          ]),
                        ]),
                        default: I(() => [
                          W(
                            `button`,
                            {
                              type: `button`,
                              class: O([
                                `relative -ml-px inline-flex items-center rounded-r-md border px-3 py-2 text-sm font-medium`,
                                {
                                  "bg-info border-light-info text-secondary hover:bg-dark-info":
                                    c.timesheet?.clockIn,
                                  "bg-danger border-light-danger text-secondary hover:bg-dark-danger":
                                    c.timesheet?.clockOut,
                                },
                              ]),
                            },
                            T(c.timesheets.length),
                            3,
                          ),
                        ]),
                        _: 1,
                      },
                    ))
                  : U(``, !0),
              ]))
            : U(``, !0);
        }
      );
    },
  };
B();
var Bye = {
    key: 0,
    class: `isolate inline-flex rounded-md shadow-sm`,
  },
  Vye = [`disabled`],
  Hye = {
    class: `space-x-2`,
  },
  Uye = {
    key: 0,
  },
  Wye = {
    key: 1,
  },
  Gye = {
    key: 2,
  },
  Kye = {
    class: `dark:bg-dark-body w-64 divide-y divide-gray-200 text-sm dark:divide-gray-700 dark:text-gray-300`,
  },
  qye = {
    class: `flex justify-between px-4 py-2`,
  },
  Jye = {
    class: `text-success`,
  },
  Yye = {
    class: `ml-2 text-xs text-gray-400`,
  },
  Xye = {
    key: 0,
    class: `text-danger`,
  },
  Zye = {
    __name: `StudentTimesheetClock`,
    setup(e) {
      let t = $e(),
        n = R(`$trans`),
        { screenSize: r } = M9(),
        i = Hh(`currentPeriodId`),
        a = Vh(`student.enableTimesheet`),
        o = Vh(`student.allowStudentClockInOut`),
        s = F(!1),
        c = Ae({
          hasTimesheet: !1,
          timesheet: {},
          timesheets: [],
        }),
        l = V(() => c.timesheets.length > 0 && c.timesheet.clockIn === !0),
        u = async () => {
          Gh(`student`) &&
            i.value &&
            a.value &&
            o.value &&
            (await t
              .dispatch(`student/timesheet/check`)
              .then((e) => {
                e.hasTimesheet &&
                  ((c.hasTimesheet = !0),
                  (c.timesheet = e.timesheet),
                  (c.timesheets = e.timesheets || 0));
              })
              .catch((e) => {}));
        },
        d = async () => {
          ((s.value = !0), await f(), (s.value = !1));
        },
        f = async () => {
          await t
            .dispatch(`student/timesheet/clock`, {
              type: c.timesheet?.clockIn ? `in` : `out`,
            })
            .then((e) => {
              ((c.timesheet = e.timesheet), (c.timesheets = e.timesheets || 0), (s.value = !1));
            })
            .catch((e) => {
              s.value = !1;
            });
        };
      return (
        Qe(async () => {
          await u();
        }),
        (e, t) => {
          let i = j(`VDropdown`);
          return P(a) && P(o) && c.hasTimesheet
            ? (A(),
              M(`span`, Bye, [
                W(
                  `button`,
                  {
                    type: `button`,
                    disabled: s.value || l.value,
                    onClick: d,
                    class: O([
                      `relative inline-flex items-center border px-2 py-1 sm:px-4 sm:py-2 text-sm font-medium`,
                      {
                        "bg-info border-info text-secondary hover:bg-dark-info":
                          c.timesheet?.clockIn,
                        "bg-danger border-danger text-secondary hover:bg-dark-danger":
                          c.timesheet?.clockOut,
                        "rounded-l-md": c.timesheets.length,
                        "rounded-md": c.timesheets.length === 0,
                      },
                    ]),
                  },
                  [
                    W(`div`, Hye, [
                      s.value
                        ? (A(),
                          M(`span`, Uye, [
                            ...(t[0] ||= [
                              W(
                                `i`,
                                {
                                  class: `fas fa-spinner fa-spin`,
                                },
                                null,
                                -1,
                              ),
                            ]),
                          ]))
                        : U(``, !0),
                      P(r).small
                        ? (A(),
                          M(`span`, Gye, [
                            ...(t[1] ||= [
                              W(
                                `i`,
                                {
                                  class: `fas fa-clock`,
                                },
                                null,
                                -1,
                              ),
                            ]),
                          ]))
                        : (A(),
                          M(
                            `span`,
                            Wye,
                            T(
                              c.timesheet?.clockIn
                                ? P(n)(`student.timesheet.props.clock_in`)
                                : P(n)(`student.timesheet.props.clock_out`),
                            ),
                            1,
                          )),
                    ]),
                  ],
                  10,
                  Vye,
                ),
                c.timesheets.length
                  ? (A(),
                    L(
                      i,
                      {
                        key: 0,
                        distance: 6,
                        placement: `bottom-end`,
                      },
                      {
                        popper: I(() => [
                          W(`div`, Kye, [
                            (A(!0),
                            M(
                              ke,
                              null,
                              ae(
                                c.timesheets,
                                (e) => (
                                  A(),
                                  M(`div`, qye, [
                                    W(`div`, Jye, [
                                      (t[2] ||= W(
                                        `i`,
                                        {
                                          class: `fas fa-circle-arrow-down text-green-400`,
                                        },
                                        null,
                                        -1,
                                      )),
                                      H(` ` + T(e.inAtTime.formatted) + ` `, 1),
                                      W(`span`, Yye, T(e.duration), 1),
                                    ]),
                                    e.outAt
                                      ? (A(),
                                        M(`div`, Xye, [
                                          H(T(e.outAtTime.formatted) + ` `, 1),
                                          (t[3] ||= W(
                                            `i`,
                                            {
                                              class: `fas fa-circle-arrow-up text-red-400`,
                                            },
                                            null,
                                            -1,
                                          )),
                                        ]))
                                      : U(``, !0),
                                  ])
                                ),
                              ),
                              256,
                            )),
                          ]),
                        ]),
                        default: I(() => [
                          W(
                            `button`,
                            {
                              type: `button`,
                              class: O([
                                `relative -ml-px inline-flex items-center rounded-r-md border px-3 py-2 text-sm font-medium`,
                                {
                                  "bg-info border-light-info text-secondary hover:bg-dark-info":
                                    c.timesheet?.clockIn,
                                  "bg-danger border-light-danger text-secondary hover:bg-dark-danger":
                                    c.timesheet?.clockOut,
                                },
                              ]),
                            },
                            T(c.timesheets.length),
                            3,
                          ),
                        ]),
                        _: 1,
                      },
                    ))
                  : U(``, !0),
              ]))
            : U(``, !0);
        }
      );
    },
  };
B();
var Qye = Object.assign(
  {
    name: `NameInput`,
  },
  {
    props: {
      firstName: {
        type: String,
        default: ``,
      },
      middleName: {
        type: String,
        default: ``,
      },
      thirdName: {
        type: String,
        default: ``,
      },
      lastName: {
        type: String,
        default: ``,
      },
      formErrors: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    setup(e) {
      let t = $e(),
        n = e,
        r = Ae({
          firstName: ``,
          middleName: ``,
          thirdName: ``,
          lastName: ``,
        }),
        i = V(() => t.getters[`config/config`](`contact.enableMiddleNameField`)),
        a = V(() => t.getters[`config/config`](`contact.enableThirdNameField`));
      return (
        Qe(() => {
          ((r.firstName = n.firstName),
            (r.middleName = n.middleName),
            (r.thirdName = n.thirdName),
            (r.lastName = n.lastName));
        }),
        He(
          () => [n.firstName, n.middleName, n.thirdName, n.lastName],
          (e) => {
            ((r.firstName = e[0]),
              (r.middleName = e[1]),
              (r.thirdName = e[2]),
              (r.lastName = e[3]));
          },
        ),
        (t, n) => {
          let o = j(`BaseInput`);
          return (
            A(),
            M(
              ke,
              null,
              [
                N(
                  o,
                  {
                    type: `text`,
                    modelValue: r.firstName,
                    "onUpdate:modelValue": (n[0] ||= (e) => (r.firstName = e)),
                    name: `firstName`,
                    placeholder: t.$trans(`contact.props.first_name`),
                    error: e.formErrors.firstName,
                    "onUpdate:error": (n[1] ||= (t) => (e.formErrors.firstName = t)),
                    "adjacent-left": ``,
                    onInput: (n[2] ||= (e) => t.$emit(`update:firstName`, e.target.value)),
                  },
                  null,
                  8,
                  [`modelValue`, `placeholder`, `error`],
                ),
                i.value
                  ? (A(),
                    L(
                      o,
                      {
                        key: 0,
                        type: `text`,
                        modelValue: r.middleName,
                        "onUpdate:modelValue": (n[3] ||= (e) => (r.middleName = e)),
                        name: `middleName`,
                        placeholder: t.$trans(`contact.props.middle_name`),
                        error: e.formErrors.middleName,
                        "onUpdate:error": (n[4] ||= (t) => (e.formErrors.middleName = t)),
                        "adjacent-center": ``,
                        onInput: (n[5] ||= (e) => t.$emit(`update:middleName`, e.target.value)),
                      },
                      null,
                      8,
                      [`modelValue`, `placeholder`, `error`],
                    ))
                  : U(``, !0),
                a.value
                  ? (A(),
                    L(
                      o,
                      {
                        key: 1,
                        type: `text`,
                        modelValue: r.thirdName,
                        "onUpdate:modelValue": (n[6] ||= (e) => (r.thirdName = e)),
                        name: `thirdName`,
                        placeholder: t.$trans(`contact.props.third_name`),
                        error: e.formErrors.thirdName,
                        "onUpdate:error": (n[7] ||= (t) => (e.formErrors.thirdName = t)),
                        "adjacent-center": ``,
                        onInput: (n[8] ||= (e) => t.$emit(`update:thirdName`, e.target.value)),
                      },
                      null,
                      8,
                      [`modelValue`, `placeholder`, `error`],
                    ))
                  : U(``, !0),
                N(
                  o,
                  {
                    type: `text`,
                    modelValue: r.lastName,
                    "onUpdate:modelValue": (n[9] ||= (e) => (r.lastName = e)),
                    name: `lastName`,
                    placeholder: t.$trans(`contact.props.last_name`),
                    error: e.formErrors.lastName,
                    "onUpdate:error": (n[10] ||= (t) => (e.formErrors.lastName = t)),
                    "adjacent-right": ``,
                    onInput: (n[11] ||= (e) => t.$emit(`update:lastName`, e.target.value)),
                  },
                  null,
                  8,
                  [`modelValue`, `placeholder`, `error`],
                ),
              ],
              64,
            )
          );
        }
      );
    },
  },
);
B();
var $ye = {
    class: `col-span-3 sm:col-span-1`,
  },
  ebe = {
    class: `col-span-3 sm:col-span-1`,
  },
  tbe = {
    class: `col-span-3 sm:col-span-1`,
  },
  nbe = {
    class: `col-span-3 sm:col-span-1`,
  },
  rbe = {
    class: `col-span-3 sm:col-span-1`,
  },
  ibe = {
    key: 0,
    class: `col-span-3 sm:col-span-1`,
  },
  abe = {
    key: 1,
    class: `col-span-3 sm:col-span-1`,
  },
  obe = Object.assign(
    {
      name: `AddressInput`,
    },
    {
      props: {
        addressLine1: {
          type: String,
          default: ``,
        },
        addressLine2: {
          type: String,
          default: ``,
        },
        prefix: {
          type: String,
          default: ``,
        },
        namePrefix: {
          type: String,
          default: ``,
        },
        city: {
          type: String,
          default: ``,
        },
        state: {
          type: String,
          default: ``,
        },
        zipcode: {
          type: String,
          default: ``,
        },
        country: {
          type: String,
          default: ``,
        },
        countries: {
          type: Array,
          default() {
            return [];
          },
        },
        formErrors: {
          type: Object,
          default() {
            return {};
          },
        },
      },
      emits: [
        `update:addressLine1`,
        `update:addressLine2`,
        `update:city`,
        `update:state`,
        `update:zipcode`,
        `update:country`,
      ],
      setup(e, { emit: t }) {
        let n = t,
          r = e,
          i = Ae({
            addressLine1: ``,
            addressLine2: ``,
            city: ``,
            state: ``,
            zipcode: ``,
            country: ``,
          }),
          a = (e) =>
            r.namePrefix
              ? `${r.namePrefix}.${e}`
              : r.prefix
                ? r.prefix + e[0].toUpperCase() + e.slice(1)
                : e,
          o = (e) => {
            n(`update:country`, e.name);
          },
          s = () => {
            n(`update:country`, ``);
          };
        return (
          Qe(() => {
            ((i.addressLine1 = r.addressLine1),
              (i.addressLine2 = r.addressLine2),
              (i.city = r.city),
              (i.state = r.state),
              (i.zipcode = r.zipcode),
              (i.country = r.country));
          }),
          He(
            () => [r.addressLine1, r.addressLine2, r.city, r.state, r.zipcode, r.country],
            (e) => {
              ((i.addressLine1 = e[0]),
                (i.addressLine2 = e[1]),
                (i.city = e[2]),
                (i.state = e[3]),
                (i.zipcode = e[4]),
                (i.country = e[5]));
            },
          ),
          (t, n) => {
            let r = j(`BaseInput`),
              c = j(`AutoSuggest`),
              l = j(`BaseSelect`);
            return (
              A(),
              M(
                ke,
                null,
                [
                  W(`div`, $ye, [
                    N(
                      r,
                      {
                        type: `text`,
                        modelValue: i.addressLine1,
                        "onUpdate:modelValue": (n[0] ||= (e) => (i.addressLine1 = e)),
                        name: a(`addressLine1`),
                        label: t.$trans(`contact.props.address.address_line1`),
                        error: e.formErrors[a(`addressLine1`)],
                        "onUpdate:error": (n[1] ||= (t) => (e.formErrors[a(`addressLine1`)] = t)),
                        onInput: (n[2] ||= (e) => t.$emit(`update:addressLine1`, e.target.value)),
                      },
                      null,
                      8,
                      [`modelValue`, `name`, `label`, `error`],
                    ),
                  ]),
                  W(`div`, ebe, [
                    N(
                      r,
                      {
                        type: `text`,
                        modelValue: i.addressLine2,
                        "onUpdate:modelValue": (n[3] ||= (e) => (i.addressLine2 = e)),
                        name: a(`addressLine2`),
                        label: t.$trans(`contact.props.address.address_line2`),
                        error: e.formErrors[a(`addressLine2`)],
                        "onUpdate:error": (n[4] ||= (t) => (e.formErrors[a(`addressLine2`)] = t)),
                        onInput: (n[5] ||= (e) => t.$emit(`update:addressLine2`, e.target.value)),
                      },
                      null,
                      8,
                      [`modelValue`, `name`, `label`, `error`],
                    ),
                  ]),
                  W(`div`, tbe, [
                    N(
                      c,
                      {
                        type: `text`,
                        url: `/app/suggestions/address/cities`,
                        modelValue: i.city,
                        "onUpdate:modelValue": (n[6] ||= (e) => (i.city = e)),
                        name: a(`city`),
                        label: t.$trans(`contact.props.address.city`),
                        error: e.formErrors[a(`city`)],
                        "onUpdate:error": (n[7] ||= (t) => (e.formErrors[a(`city`)] = t)),
                        onChange: (n[8] ||= (e) => t.$emit(`update:city`, e)),
                      },
                      null,
                      8,
                      [`modelValue`, `name`, `label`, `error`],
                    ),
                  ]),
                  W(`div`, nbe, [
                    N(
                      c,
                      {
                        type: `text`,
                        url: `/app/suggestions/address/states`,
                        modelValue: i.state,
                        "onUpdate:modelValue": (n[9] ||= (e) => (i.state = e)),
                        name: a(`state`),
                        label: t.$trans(`contact.props.address.state`),
                        error: e.formErrors[a(`state`)],
                        "onUpdate:error": (n[10] ||= (t) => (e.formErrors[a(`state`)] = t)),
                        onChange: (n[11] ||= (e) => t.$emit(`update:state`, e)),
                      },
                      null,
                      8,
                      [`modelValue`, `name`, `label`, `error`],
                    ),
                  ]),
                  W(`div`, rbe, [
                    N(
                      c,
                      {
                        type: `text`,
                        url: `/app/suggestions/address/zipcodes`,
                        modelValue: i.zipcode,
                        "onUpdate:modelValue": (n[12] ||= (e) => (i.zipcode = e)),
                        name: a(`zipcode`),
                        label: t.$trans(`contact.props.address.zipcode`),
                        error: e.formErrors[a(`zipcode`)],
                        "onUpdate:error": (n[13] ||= (t) => (e.formErrors[a(`zipcode`)] = t)),
                        onChange: (n[14] ||= (e) => t.$emit(`update:zipcode`, e)),
                      },
                      null,
                      8,
                      [`modelValue`, `name`, `label`, `error`],
                    ),
                  ]),
                  e.countries.length
                    ? (A(),
                      M(`div`, ibe, [
                        N(
                          l,
                          {
                            modelValue: i.country,
                            "onUpdate:modelValue": (n[15] ||= (e) => (i.country = e)),
                            name: `country`,
                            label: t.$trans(`contact.props.address.country`),
                            options: e.countries,
                            "label-prop": `name`,
                            "value-prop": `name`,
                            error: e.formErrors[a(`country`)],
                            "onUpdate:error": (n[16] ||= (t) => (e.formErrors[a(`country`)] = t)),
                            onSelected: o,
                            onRemoved: s,
                          },
                          null,
                          8,
                          [`modelValue`, `label`, `options`, `error`],
                        ),
                      ]))
                    : (A(),
                      M(`div`, abe, [
                        N(
                          c,
                          {
                            type: `text`,
                            url: `/app/suggestions/address/countries`,
                            modelValue: i.country,
                            "onUpdate:modelValue": (n[17] ||= (e) => (i.country = e)),
                            name: a(`country`),
                            label: t.$trans(`contact.props.address.country`),
                            error: e.formErrors[a(`country`)],
                            "onUpdate:error": (n[18] ||= (t) => (e.formErrors[a(`country`)] = t)),
                            onChange: (n[19] ||= (e) => t.$emit(`update:country`, e)),
                          },
                          null,
                          8,
                          [`modelValue`, `name`, `label`, `error`],
                        ),
                      ])),
                ],
                64,
              )
            );
          }
        );
      },
    },
  );
B();
var sbe = {
    key: 0,
    class: `col-span-4 sm:col-span-1`,
  },
  cbe = {
    key: 1,
    class: `col-span-4 sm:col-span-1`,
  },
  lbe = {
    key: 2,
    class: `col-span-4 sm:col-span-1`,
  },
  ube = {
    key: 3,
    class: `col-span-4 sm:col-span-1`,
  },
  dbe = {
    key: 4,
    class: `col-span-4 sm:col-span-1`,
  },
  fbe = {
    key: 5,
    class: `col-span-4 sm:col-span-1`,
  },
  pbe = {
    key: 6,
    class: `col-span-4 sm:col-span-1`,
  },
  mbe = Object.assign(
    {
      name: `PaymentMethodInput`,
    },
    {
      props: {
        selectedPaymentMethod: {
          type: Object,
          default() {
            return {};
          },
        },
        instrumentNumber: {
          type: String,
          default: ``,
        },
        instrumentDate: {
          type: String,
          default: ``,
        },
        clearingDate: {
          type: String,
          default: ``,
        },
        bankDetail: {
          type: String,
          default: ``,
        },
        branchDetail: {
          type: String,
          default: ``,
        },
        referenceNumber: {
          type: String,
          default: ``,
        },
        cardProvider: {
          type: String,
          default: ``,
        },
        formErrors: {
          type: Object,
          default() {
            return {};
          },
        },
        bankNames: {
          type: Array,
          default() {
            return [];
          },
        },
        cardProviders: {
          type: Array,
          default() {
            return [];
          },
        },
      },
      emits: [
        `update:bankDetail`,
        `update:cardProvider`,
        `update:referenceNumber`,
        `update:instrumentNumber`,
        `update:instrumentDate`,
        `update:clearingDate`,
      ],
      setup(e, { emit: t }) {
        $e();
        let n = t,
          r = e,
          i = Ae({
            instrumentNumber: ``,
            instrumentDate: ``,
            clearingDate: ``,
            bankDetail: ``,
            branchDetail: ``,
            referenceNumber: ``,
            cardProvider: ``,
          }),
          a = (e) => {
            n(`update:bankDetail`, e);
          },
          o = (e) => {
            n(`update:cardProvider`, e);
          };
        return (
          Qe(() => {
            ((i.instrumentNumber = r.instrumentNumber),
              (i.instrumentDate = r.instrumentDate),
              (i.clearingDate = r.clearingDate),
              (i.bankDetail = r.bankDetail),
              (i.branchDetail = r.branchDetail),
              (i.referenceNumber = r.referenceNumber),
              (i.cardProvider = r.cardProvider));
          }),
          He(
            () => [
              r.instrumentNumber,
              r.instrumentDate,
              r.clearingDate,
              r.bankDetail,
              r.branchDetail,
              r.referenceNumber,
              r.cardProvider,
            ],
            (e) => {
              ((i.instrumentNumber = e[0]),
                (i.instrumentDate = e[1]),
                (i.clearingDate = e[2]),
                (i.bankDetail = e[3]),
                (i.branchDetail = e[4]),
                (i.referenceNumber = e[5]),
                (i.cardProvider = e[6]));
            },
          ),
          (t, n) => {
            let r = j(`BaseInput`),
              s = j(`DatePicker`),
              c = j(`BaseSelect`);
            return e.selectedPaymentMethod.uuid
              ? (A(),
                M(
                  ke,
                  {
                    key: 0,
                  },
                  [
                    e.selectedPaymentMethod.hasInstrumentNumber
                      ? (A(),
                        M(`div`, sbe, [
                          N(
                            r,
                            {
                              type: `text`,
                              modelValue: i.instrumentNumber,
                              "onUpdate:modelValue": (n[0] ||= (e) => (i.instrumentNumber = e)),
                              name: `instrumentNumber`,
                              label: t.$trans(`finance.transaction.props.instrument_number`),
                              error: e.formErrors.instrumentNumber,
                              "onUpdate:error": (n[1] ||= (t) =>
                                (e.formErrors.instrumentNumber = t)),
                              onInput: (n[2] ||= (e) =>
                                t.$emit(`update:instrumentNumber`, e.target.value)),
                            },
                            null,
                            8,
                            [`modelValue`, `label`, `error`],
                          ),
                        ]))
                      : U(``, !0),
                    e.selectedPaymentMethod.hasInstrumentDate
                      ? (A(),
                        M(`div`, cbe, [
                          N(
                            s,
                            {
                              modelValue: i.instrumentDate,
                              "onUpdate:modelValue": (n[3] ||= (e) => (i.instrumentDate = e)),
                              name: `instrumentDate`,
                              label: t.$trans(`finance.transaction.props.instrument_date`),
                              error: e.formErrors.instrumentDate,
                              "onUpdate:error": (n[4] ||= (t) => (e.formErrors.instrumentDate = t)),
                              onInput: (n[5] ||= (e) =>
                                t.$emit(`update:instrumentDate`, e.target.value)),
                            },
                            null,
                            8,
                            [`modelValue`, `label`, `error`],
                          ),
                        ]))
                      : U(``, !0),
                    e.selectedPaymentMethod.hasClearingDate
                      ? (A(),
                        M(`div`, lbe, [
                          N(
                            s,
                            {
                              modelValue: i.clearingDate,
                              "onUpdate:modelValue": (n[6] ||= (e) => (i.clearingDate = e)),
                              name: `clearingDate`,
                              label: t.$trans(`finance.transaction.props.clearing_date`),
                              error: e.formErrors.clearingDate,
                              "onUpdate:error": (n[7] ||= (t) => (e.formErrors.clearingDate = t)),
                              onInput: (n[8] ||= (e) =>
                                t.$emit(`update:clearingDate`, e.target.value)),
                            },
                            null,
                            8,
                            [`modelValue`, `label`, `error`],
                          ),
                        ]))
                      : U(``, !0),
                    e.selectedPaymentMethod.hasBankDetail
                      ? (A(),
                        M(`div`, ube, [
                          e.bankNames.length > 0
                            ? (A(),
                              L(
                                c,
                                {
                                  key: 0,
                                  modelValue: i.bankDetail,
                                  "onUpdate:modelValue": (n[9] ||= (e) => (i.bankDetail = e)),
                                  name: `bankDetail`,
                                  label: t.$trans(`finance.transaction.props.bank_detail`),
                                  error: e.formErrors.bankDetail,
                                  "onUpdate:error": (n[10] ||= (t) =>
                                    (e.formErrors.bankDetail = t)),
                                  options: e.bankNames,
                                  onChange: a,
                                },
                                null,
                                8,
                                [`modelValue`, `label`, `error`, `options`],
                              ))
                            : (A(),
                              L(
                                r,
                                {
                                  key: 1,
                                  type: `text`,
                                  modelValue: i.bankDetail,
                                  "onUpdate:modelValue": (n[11] ||= (e) => (i.bankDetail = e)),
                                  name: `bankDetail`,
                                  label: t.$trans(`finance.transaction.props.bank_detail`),
                                  error: e.formErrors.bankDetail,
                                  "onUpdate:error": (n[12] ||= (t) =>
                                    (e.formErrors.bankDetail = t)),
                                  onInput: (n[13] ||= (e) =>
                                    t.$emit(`update:bankDetail`, e.target.value)),
                                },
                                null,
                                8,
                                [`modelValue`, `label`, `error`],
                              )),
                        ]))
                      : U(``, !0),
                    e.selectedPaymentMethod.hasBranchDetail
                      ? (A(),
                        M(`div`, dbe, [
                          N(
                            r,
                            {
                              type: `text`,
                              modelValue: i.branchDetail,
                              "onUpdate:modelValue": (n[14] ||= (e) => (i.branchDetail = e)),
                              name: `branchDetail`,
                              label: t.$trans(`finance.transaction.props.branch_detail`),
                              error: e.formErrors.branchDetail,
                              "onUpdate:error": (n[15] ||= (t) => (e.formErrors.branchDetail = t)),
                              onInput: (n[16] ||= (e) =>
                                t.$emit(`update:branchDetail`, e.target.value)),
                            },
                            null,
                            8,
                            [`modelValue`, `label`, `error`],
                          ),
                        ]))
                      : U(``, !0),
                    e.selectedPaymentMethod.hasReferenceNumber
                      ? (A(),
                        M(`div`, fbe, [
                          N(
                            r,
                            {
                              type: `text`,
                              modelValue: i.referenceNumber,
                              "onUpdate:modelValue": (n[17] ||= (e) => (i.referenceNumber = e)),
                              name: `referenceNumber`,
                              label: t.$trans(`finance.transaction.props.reference_number`),
                              error: e.formErrors.referenceNumber,
                              "onUpdate:error": (n[18] ||= (t) =>
                                (e.formErrors.referenceNumber = t)),
                              onInput: (n[19] ||= (e) =>
                                t.$emit(`update:referenceNumber`, e.target.value)),
                            },
                            null,
                            8,
                            [`modelValue`, `label`, `error`],
                          ),
                        ]))
                      : U(``, !0),
                    e.selectedPaymentMethod.hasCardProvider
                      ? (A(),
                        M(`div`, pbe, [
                          e.cardProviders.length > 0
                            ? (A(),
                              L(
                                c,
                                {
                                  key: 0,
                                  modelValue: i.cardProvider,
                                  "onUpdate:modelValue": (n[20] ||= (e) => (i.cardProvider = e)),
                                  name: `cardProvider`,
                                  label: t.$trans(`finance.transaction.props.card_provider`),
                                  error: e.formErrors.cardProvider,
                                  "onUpdate:error": (n[21] ||= (t) =>
                                    (e.formErrors.cardProvider = t)),
                                  options: e.cardProviders,
                                  onChange: o,
                                },
                                null,
                                8,
                                [`modelValue`, `label`, `error`, `options`],
                              ))
                            : (A(),
                              L(
                                r,
                                {
                                  key: 1,
                                  type: `text`,
                                  modelValue: i.cardProvider,
                                  "onUpdate:modelValue": (n[22] ||= (e) => (i.cardProvider = e)),
                                  name: `cardProvider`,
                                  label: t.$trans(`finance.transaction.props.card_provider`),
                                  error: e.formErrors.cardProvider,
                                  "onUpdate:error": (n[23] ||= (t) =>
                                    (e.formErrors.cardProvider = t)),
                                  onInput: (n[24] ||= (e) =>
                                    t.$emit(`update:cardProvider`, e.target.value)),
                                },
                                null,
                                8,
                                [`modelValue`, `label`, `error`],
                              )),
                        ]))
                      : U(``, !0),
                  ],
                  64,
                ))
              : U(``, !0);
          }
        );
      },
    },
  );
B();
var hbe = {
    key: 0,
    class: `dark:text-gray-400 text-sm`,
  },
  gbe = {
    class: `flex space-x-2`,
  },
  _be = {
    key: 0,
    class: `font-bold`,
  },
  vbe = {
    class: `font-semibold`,
  },
  ybe = {
    key: 0,
  },
  bbe = {
    key: 1,
  },
  xbe = {
    key: 2,
  },
  Sbe = {
    key: 3,
  },
  Cbe = {
    key: 4,
  },
  wbe = {
    key: 5,
  },
  Tbe = {
    key: 6,
  },
  Ebe = Object.assign(
    {
      name: `PaymentMethodDetail`,
    },
    {
      props: {
        isWallet: {
          type: Boolean,
          default: !1,
        },
        payments: {
          type: Array,
          required: !0,
        },
        showLedger: {
          type: Boolean,
          default: !0,
        },
      },
      setup(e) {
        return (t, n) => {
          let r = j(`TextMuted`);
          return (
            A(),
            M(
              ke,
              null,
              [
                e.isWallet
                  ? (A(), M(`div`, hbe, T(t.$trans(`student.fee.wallet_payment`)), 1))
                  : U(``, !0),
                (A(!0),
                M(
                  ke,
                  null,
                  ae(
                    e.payments,
                    (n) => (
                      A(),
                      M(`div`, null, [
                        W(`div`, gbe, [
                          e.showLedger && n.ledger
                            ? (A(), M(`span`, _be, T(n.ledger?.name), 1))
                            : U(``, !0),
                          W(`span`, vbe, T(n.methodName), 1),
                          W(`span`, null, T(n.amount.formatted), 1),
                        ]),
                        N(
                          r,
                          {
                            block: ``,
                          },
                          {
                            default: I(() => [
                              n.hasInstrumentNumber && n.instrumentNumber
                                ? (A(),
                                  M(
                                    `div`,
                                    ybe,
                                    T(
                                      t.$trans(`finance.transaction.props.instrument_number`) +
                                        `: ` +
                                        n.instrumentNumber,
                                    ),
                                    1,
                                  ))
                                : U(``, !0),
                              n.hasInstrumentDate && n.instrumentDate.value
                                ? (A(),
                                  M(
                                    `div`,
                                    bbe,
                                    T(
                                      t.$trans(`finance.transaction.props.instrument_date`) +
                                        `: ` +
                                        n.instrumentDate.formatted,
                                    ),
                                    1,
                                  ))
                                : U(``, !0),
                              n.hasClearingDate && n.clearingDate.value
                                ? (A(),
                                  M(
                                    `div`,
                                    xbe,
                                    T(
                                      t.$trans(`finance.transaction.props.clearing_date`) +
                                        `: ` +
                                        n.clearingDate.formatted,
                                    ),
                                    1,
                                  ))
                                : U(``, !0),
                              n.hasBankDetail && n.bankDetail
                                ? (A(),
                                  M(
                                    `div`,
                                    Sbe,
                                    T(
                                      t.$trans(`finance.transaction.props.bank_detail`) +
                                        `: ` +
                                        n.bankDetail,
                                    ),
                                    1,
                                  ))
                                : U(``, !0),
                              n.hasBranchDetail && n.branchDetail
                                ? (A(),
                                  M(
                                    `div`,
                                    Cbe,
                                    T(
                                      t.$trans(`finance.transaction.props.branch_detail`) +
                                        `: ` +
                                        n.branchDetail,
                                    ),
                                    1,
                                  ))
                                : U(``, !0),
                              n.referenceNumber
                                ? (A(),
                                  M(
                                    `div`,
                                    wbe,
                                    T(
                                      t.$trans(`finance.transaction.props.reference_number`) +
                                        `: ` +
                                        n.referenceNumber,
                                    ),
                                    1,
                                  ))
                                : U(``, !0),
                              n.hasCardProvider && n.cardProvider
                                ? (A(),
                                  M(
                                    `div`,
                                    Tbe,
                                    T(
                                      t.$trans(`finance.transaction.props.card_provider`) +
                                        `: ` +
                                        n.cardProvider,
                                    ),
                                    1,
                                  ))
                                : U(``, !0),
                            ]),
                            _: 2,
                          },
                          1024,
                        ),
                      ])
                    ),
                  ),
                  256,
                )),
              ],
              64,
            )
          );
        };
      },
    },
  );
B();
var Dbe = {
    key: 0,
  },
  Obe = {
    key: 1,
  },
  kbe = Object.assign(
    {
      name: `LedgerBalance`,
    },
    {
      props: {
        ledger: {
          type: Object,
          default() {
            return {};
          },
        },
        show: {
          type: Boolean,
          default: !0,
        },
        highlight: {
          type: Boolean,
          default: !1,
        },
        label: {
          type: Boolean,
          default: null,
        },
      },
      setup(e) {
        return (t, n) =>
          e.show && e.ledger?.uuid
            ? (A(),
              M(
                `span`,
                {
                  key: 0,
                  class: O([
                    `mt-1`,
                    {
                      "text-sm": !0,
                      "font-semibold": e.highlight,
                      "text-success": e.ledger.balanceColor == `success`,
                      "text-danger": e.ledger.balanceColor == `danger`,
                      "dark:text-gray-400": !e.ledger.balanceColor,
                    },
                  ]),
                },
                [
                  e.label
                    ? (A(),
                      M(
                        `span`,
                        Dbe,
                        T(
                          t.$trans(`finance.ledger.props.balance`, {
                            attribute: e.ledger.balance.formatted,
                          }),
                        ),
                        1,
                      ))
                    : (A(), M(`span`, Obe, T(e.ledger.balance.formatted), 1)),
                ],
                2,
              ))
            : U(``, !0);
      },
    },
  );
B();
var Abe = {
    class: `mt-4 grid grid-cols-4 gap-6`,
  },
  jbe = {
    key: 0,
    class: `col-span-4 sm:col-span-1`,
  },
  Mbe = {
    key: 1,
    class: `col-span-4 sm:col-span-1`,
  },
  Nbe = {
    key: 2,
    class: `col-span-4 sm:col-span-1`,
  },
  Pbe = {
    key: 3,
    class: `col-span-4 sm:col-span-1`,
  },
  Fbe = {
    key: 4,
    class: `col-span-4 sm:col-span-1`,
  },
  Ibe = {
    key: 5,
    class: `col-span-4 sm:col-span-1`,
  },
  Lbe = {
    key: 6,
    class: `col-span-4 sm:col-span-1`,
  },
  Rbe = Object.assign(
    {
      name: `AudienceInput`,
    },
    {
      props: {
        preRequisites: {
          type: Object,
          default() {
            return {
              studentAudienceTypes: [],
              employeeAudienceTypes: [],
            };
          },
        },
        studentAudienceType: {
          type: String,
          default: ``,
        },
        employeeAudienceType: {
          type: String,
          default: ``,
        },
        studentAudiences: {
          type: Array,
          default: [],
        },
        employeeAudiences: {
          type: Array,
          default: [],
        },
        formErrors: {
          type: Object,
          default() {
            return {};
          },
        },
      },
      emits: [
        `update:studentAudienceType`,
        `update:employeeAudienceType`,
        `update:studentAudiences`,
        `update:employeeAudiences`,
      ],
      setup(e, { emit: t }) {
        $e();
        let n = t,
          r = e,
          i = Ae({
            studentAudienceType: ``,
            employeeAudienceType: ``,
            studentAudiences: ``,
            employeeAudiences: ``,
          }),
          a = (e) => {
            n(`update:studentAudienceType`, e);
          },
          o = (e) => {
            n(`update:employeeAudienceType`, e);
          },
          s = (e) => {
            n(`update:studentAudiences`, e);
          },
          c = (e) => {
            n(`update:employeeAudiences`, e);
          };
        return (
          Qe(() => {
            ((i.studentAudienceType = r.studentAudienceType),
              (i.employeeAudienceType = r.employeeAudienceType),
              (i.studentAudiences = r.studentAudiences),
              (i.employeeAudiences = r.employeeAudiences));
          }),
          He(
            () => [
              r.studentAudienceType,
              r.employeeAudienceType,
              r.studentAudiences,
              r.employeeAudiences,
            ],
            (e) => {
              ((i.studentAudienceType = e[0]),
                (i.employeeAudienceType = e[1]),
                (i.studentAudiences = e[2]),
                (i.employeeAudiences = e[3]));
            },
          ),
          (t, n) => {
            let r = j(`BaseSelect`),
              l = j(`BaseSelectSearch`);
            return (
              A(),
              M(`div`, Abe, [
                e.preRequisites.studentAudienceTypes?.length > 0
                  ? (A(),
                    M(`div`, jbe, [
                      N(
                        r,
                        {
                          modelValue: i.studentAudienceType,
                          "onUpdate:modelValue": (n[0] ||= (e) => (i.studentAudienceType = e)),
                          name: `studentAudienceType`,
                          label: t.$trans(`student.student`),
                          options: e.preRequisites.studentAudienceTypes,
                          error: e.formErrors.studentAudienceType,
                          "onUpdate:error": (n[1] ||= (t) =>
                            (e.formErrors.studentAudienceType = t)),
                          onChange: a,
                        },
                        null,
                        8,
                        [`modelValue`, `label`, `options`, `error`],
                      ),
                    ]))
                  : U(``, !0),
                i.studentAudienceType == `division_wise`
                  ? (A(),
                    M(`div`, Mbe, [
                      N(
                        l,
                        {
                          multiple: ``,
                          name: `studentAudiences`,
                          label: t.$trans(`academic.division.division`),
                          modelValue: i.studentAudiences,
                          "onUpdate:modelValue": (n[2] ||= (e) => (i.studentAudiences = e)),
                          error: e.formErrors.studentAudiences,
                          "onUpdate:error": (n[3] ||= (t) => (e.formErrors.studentAudiences = t)),
                          "value-prop": `uuid`,
                          "init-search": i.studentAudiences,
                          "search-action": `academic/division/list`,
                          onChange: s,
                        },
                        {
                          selectedOption: I((e) => [H(T(e.value.name), 1)]),
                          listOption: I((e) => [H(T(e.option.name), 1)]),
                          _: 1,
                        },
                        8,
                        [`label`, `modelValue`, `error`, `init-search`],
                      ),
                    ]))
                  : U(``, !0),
                i.studentAudienceType == `course_wise`
                  ? (A(),
                    M(`div`, Nbe, [
                      N(
                        l,
                        {
                          multiple: ``,
                          name: `studentAudiences`,
                          label: t.$trans(`academic.course.course`),
                          modelValue: i.studentAudiences,
                          "onUpdate:modelValue": (n[4] ||= (e) => (i.studentAudiences = e)),
                          error: e.formErrors.studentAudiences,
                          "onUpdate:error": (n[5] ||= (t) => (e.formErrors.studentAudiences = t)),
                          "value-prop": `uuid`,
                          "init-search": i.studentAudiences,
                          "search-action": `academic/course/list`,
                          onChange: s,
                        },
                        {
                          selectedOption: I((e) => [H(T(e.value.name), 1)]),
                          listOption: I((e) => [H(T(e.option.name), 1)]),
                          _: 1,
                        },
                        8,
                        [`label`, `modelValue`, `error`, `init-search`],
                      ),
                    ]))
                  : U(``, !0),
                i.studentAudienceType == `batch_wise`
                  ? (A(),
                    M(`div`, Pbe, [
                      N(
                        l,
                        {
                          multiple: ``,
                          name: `studentAudiences`,
                          label: t.$trans(`academic.batch.batch`),
                          modelValue: i.studentAudiences,
                          "onUpdate:modelValue": (n[6] ||= (e) => (i.studentAudiences = e)),
                          error: e.formErrors.studentAudiences,
                          "onUpdate:error": (n[7] ||= (t) => (e.formErrors.studentAudiences = t)),
                          "value-prop": `uuid`,
                          "init-search": i.studentAudiences,
                          "search-key": `course_batch`,
                          "search-action": `academic/batch/list`,
                          onChange: s,
                        },
                        {
                          selectedOption: I((e) => [
                            H(T(e.value.course.name) + ` - ` + T(e.value.name), 1),
                          ]),
                          listOption: I((e) => [
                            H(T(e.option.course.nameWithTerm) + ` - ` + T(e.option.name), 1),
                          ]),
                          _: 1,
                        },
                        8,
                        [`label`, `modelValue`, `error`, `init-search`],
                      ),
                    ]))
                  : U(``, !0),
                e.preRequisites.employeeAudienceTypes?.length > 0
                  ? (A(),
                    M(`div`, Fbe, [
                      N(
                        r,
                        {
                          modelValue: i.employeeAudienceType,
                          "onUpdate:modelValue": (n[8] ||= (e) => (i.employeeAudienceType = e)),
                          name: `employeeAudienceType`,
                          label: t.$trans(`employee.employee`),
                          options: e.preRequisites.employeeAudienceTypes,
                          error: e.formErrors.employeeAudienceType,
                          "onUpdate:error": (n[9] ||= (t) =>
                            (e.formErrors.employeeAudienceType = t)),
                          onChange: o,
                        },
                        null,
                        8,
                        [`modelValue`, `label`, `options`, `error`],
                      ),
                    ]))
                  : U(``, !0),
                i.employeeAudienceType == `department_wise`
                  ? (A(),
                    M(`div`, Ibe, [
                      N(
                        l,
                        {
                          multiple: ``,
                          name: `employeeAudiences`,
                          label: t.$trans(`employee.department.department`),
                          modelValue: i.employeeAudiences,
                          "onUpdate:modelValue": (n[10] ||= (e) => (i.employeeAudiences = e)),
                          error: e.formErrors.employeeAudiences,
                          "onUpdate:error": (n[11] ||= (t) => (e.formErrors.employeeAudiences = t)),
                          "value-prop": `uuid`,
                          "init-search": i.employeeAudiences,
                          "search-action": `employee/department/list`,
                          onChange: c,
                        },
                        {
                          selectedOption: I((e) => [H(T(e.value.name), 1)]),
                          listOption: I((e) => [H(T(e.option.name), 1)]),
                          _: 1,
                        },
                        8,
                        [`label`, `modelValue`, `error`, `init-search`],
                      ),
                    ]))
                  : U(``, !0),
                i.employeeAudienceType == `designation_wise`
                  ? (A(),
                    M(`div`, Lbe, [
                      N(
                        l,
                        {
                          multiple: ``,
                          name: `employeeAudiences`,
                          label: t.$trans(`employee.designation.designation`),
                          modelValue: i.employeeAudiences,
                          "onUpdate:modelValue": (n[12] ||= (e) => (i.employeeAudiences = e)),
                          error: e.formErrors.employeeAudiences,
                          "onUpdate:error": (n[13] ||= (t) => (e.formErrors.employeeAudiences = t)),
                          "value-prop": `uuid`,
                          "init-search": i.employeeAudiences,
                          "search-action": `employee/designation/list`,
                          onChange: c,
                        },
                        {
                          selectedOption: I((e) => [H(T(e.value.name), 1)]),
                          listOption: I((e) => [H(T(e.option.name), 1)]),
                          _: 1,
                        },
                        8,
                        [`label`, `modelValue`, `error`, `init-search`],
                      ),
                    ]))
                  : U(``, !0),
              ])
            );
          }
        );
      },
    },
  ),
  B9 = r(
    a((e, t) => {
      function n(e) {
        return (
          e instanceof Map
            ? (e.clear =
                e.delete =
                e.set =
                  function () {
                    throw Error(`map is read-only`);
                  })
            : e instanceof Set &&
              (e.add =
                e.clear =
                e.delete =
                  function () {
                    throw Error(`set is read-only`);
                  }),
          Object.freeze(e),
          Object.getOwnPropertyNames(e).forEach((t) => {
            let r = e[t],
              i = typeof r;
            (i === `object` || i === `function`) && !Object.isFrozen(r) && n(r);
          }),
          e
        );
      }
      var r = class {
        constructor(e) {
          (e.data === void 0 && (e.data = {}), (this.data = e.data), (this.isMatchIgnored = !1));
        }
        ignoreMatch() {
          this.isMatchIgnored = !0;
        }
      };
      function i(e) {
        return e
          .replace(/&/g, `&amp;`)
          .replace(/</g, `&lt;`)
          .replace(/>/g, `&gt;`)
          .replace(/"/g, `&quot;`)
          .replace(/'/g, `&#x27;`);
      }
      function a(e, ...t) {
        let n = Object.create(null);
        for (let t in e) n[t] = e[t];
        return (
          t.forEach(function (e) {
            for (let t in e) n[t] = e[t];
          }),
          n
        );
      }
      var o = `</span>`,
        s = (e) => !!e.scope,
        c = (e, { prefix: t }) => {
          if (e.startsWith(`language:`)) return e.replace(`language:`, `language-`);
          if (e.includes(`.`)) {
            let n = e.split(`.`);
            return [`${t}${n.shift()}`, ...n.map((e, t) => `${e}${`_`.repeat(t + 1)}`)].join(` `);
          }
          return `${t}${e}`;
        },
        l = class {
          constructor(e, t) {
            ((this.buffer = ``), (this.classPrefix = t.classPrefix), e.walk(this));
          }
          addText(e) {
            this.buffer += i(e);
          }
          openNode(e) {
            if (!s(e)) return;
            let t = c(e.scope, {
              prefix: this.classPrefix,
            });
            this.span(t);
          }
          closeNode(e) {
            s(e) && (this.buffer += o);
          }
          value() {
            return this.buffer;
          }
          span(e) {
            this.buffer += `<span class="${e}">`;
          }
        },
        u = (e = {}) => {
          let t = {
            children: [],
          };
          return (Object.assign(t, e), t);
        },
        d = class e {
          constructor() {
            ((this.rootNode = u()), (this.stack = [this.rootNode]));
          }
          get top() {
            return this.stack[this.stack.length - 1];
          }
          get root() {
            return this.rootNode;
          }
          add(e) {
            this.top.children.push(e);
          }
          openNode(e) {
            let t = u({
              scope: e,
            });
            (this.add(t), this.stack.push(t));
          }
          closeNode() {
            if (this.stack.length > 1) return this.stack.pop();
          }
          closeAllNodes() {
            for (; this.closeNode(););
          }
          toJSON() {
            return JSON.stringify(this.rootNode, null, 4);
          }
          walk(e) {
            return this.constructor._walk(e, this.rootNode);
          }
          static _walk(e, t) {
            return (
              typeof t == `string`
                ? e.addText(t)
                : t.children &&
                  (e.openNode(t), t.children.forEach((t) => this._walk(e, t)), e.closeNode(t)),
              e
            );
          }
          static _collapse(t) {
            typeof t != `string` &&
              t.children &&
              (t.children.every((e) => typeof e == `string`)
                ? (t.children = [t.children.join(``)])
                : t.children.forEach((t) => {
                    e._collapse(t);
                  }));
          }
        },
        f = class extends d {
          constructor(e) {
            (super(), (this.options = e));
          }
          addText(e) {
            e !== `` && this.add(e);
          }
          startScope(e) {
            this.openNode(e);
          }
          endScope() {
            this.closeNode();
          }
          __addSublanguage(e, t) {
            let n = e.root;
            (t && (n.scope = `language:${t}`), this.add(n));
          }
          toHTML() {
            return new l(this, this.options).value();
          }
          finalize() {
            return (this.closeAllNodes(), !0);
          }
        };
      function p(e) {
        return e ? (typeof e == `string` ? e : e.source) : null;
      }
      function m(e) {
        return v(`(?=`, e, `)`);
      }
      function h(e) {
        return v(`(?:`, e, `)*`);
      }
      function g(e) {
        return v(`(?:`, e, `)?`);
      }
      function v(...e) {
        return e.map((e) => p(e)).join(``);
      }
      function y(e) {
        let t = e[e.length - 1];
        return typeof t == `object` && t.constructor === Object
          ? (e.splice(e.length - 1, 1), t)
          : {};
      }
      function b(...e) {
        return `(` + (y(e).capture ? `` : `?:`) + e.map((e) => p(e)).join(`|`) + `)`;
      }
      function x(e) {
        return RegExp(e.toString() + `|`).exec(``).length - 1;
      }
      function S(e, t) {
        let n = e && e.exec(t);
        return n && n.index === 0;
      }
      var C = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
      function w(e, { joinWith: t }) {
        let n = 0;
        return e
          .map((e) => {
            n += 1;
            let t = n,
              r = p(e),
              i = ``;
            for (; r.length > 0;) {
              let e = C.exec(r);
              if (!e) {
                i += r;
                break;
              }
              ((i += r.substring(0, e.index)),
                (r = r.substring(e.index + e[0].length)),
                e[0][0] === `\\` && e[1]
                  ? (i += `\\` + String(Number(e[1]) + t))
                  : ((i += e[0]), e[0] === `(` && n++));
            }
            return i;
          })
          .map((e) => `(${e})`)
          .join(t);
      }
      var T = /\b\B/,
        E = `[a-zA-Z]\\w*`,
        D = `[a-zA-Z_]\\w*`,
        ee = `\\b\\d+(\\.\\d+)?`,
        te = `(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)`,
        O = `\\b(0b[01]+)`,
        k = `!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~`,
        ne = (e = {}) => {
          let t = /^#![ ]*\//;
          return (
            e.binary && (e.begin = v(t, /.*\b/, e.binary, /\b.*/)),
            a(
              {
                scope: `meta`,
                begin: t,
                end: /$/,
                relevance: 0,
                "on:begin": (e, t) => {
                  e.index !== 0 && t.ignoreMatch();
                },
              },
              e,
            )
          );
        },
        re = {
          begin: `\\\\[\\s\\S]`,
          relevance: 0,
        },
        A = {
          scope: `string`,
          begin: `'`,
          end: `'`,
          illegal: `\\n`,
          contains: [re],
        },
        ie = {
          scope: `string`,
          begin: `"`,
          end: `"`,
          illegal: `\\n`,
          contains: [re],
        },
        j = {
          begin:
            /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/,
        },
        ae = function (e, t, n = {}) {
          let r = a(
            {
              scope: `comment`,
              begin: e,
              end: t,
              contains: [],
            },
            n,
          );
          r.contains.push({
            scope: `doctag`,
            begin: `[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)`,
            end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
            excludeBegin: !0,
            relevance: 0,
          });
          let i = b(
            `I`,
            `a`,
            `is`,
            `so`,
            `us`,
            `to`,
            `at`,
            `if`,
            `in`,
            `it`,
            `on`,
            /[A-Za-z]+['](d|ve|re|ll|t|s|n)/,
            /[A-Za-z]+[-][a-z]+/,
            /[A-Za-z][a-z]{2,}/,
          );
          return (
            r.contains.push({
              begin: v(/[ ]+/, `(`, i, /[.]?[:]?([.][ ]|[ ])/, `){3}`),
            }),
            r
          );
        },
        oe = ae(`//`, `$`),
        se = ae(`/\\*`, `\\*/`),
        ce = ae(`#`, `$`),
        le = Object.freeze({
          __proto__: null,
          APOS_STRING_MODE: A,
          BACKSLASH_ESCAPE: re,
          BINARY_NUMBER_MODE: {
            scope: `number`,
            begin: O,
            relevance: 0,
          },
          BINARY_NUMBER_RE: O,
          COMMENT: ae,
          C_BLOCK_COMMENT_MODE: se,
          C_LINE_COMMENT_MODE: oe,
          C_NUMBER_MODE: {
            scope: `number`,
            begin: te,
            relevance: 0,
          },
          C_NUMBER_RE: te,
          END_SAME_AS_BEGIN: function (e) {
            return Object.assign(e, {
              "on:begin": (e, t) => {
                t.data._beginMatch = e[1];
              },
              "on:end": (e, t) => {
                t.data._beginMatch !== e[1] && t.ignoreMatch();
              },
            });
          },
          HASH_COMMENT_MODE: ce,
          IDENT_RE: E,
          MATCH_NOTHING_RE: T,
          METHOD_GUARD: {
            begin: `\\.\\s*[a-zA-Z_]\\w*`,
            relevance: 0,
          },
          NUMBER_MODE: {
            scope: `number`,
            begin: ee,
            relevance: 0,
          },
          NUMBER_RE: ee,
          PHRASAL_WORDS_MODE: j,
          QUOTE_STRING_MODE: ie,
          REGEXP_MODE: {
            scope: `regexp`,
            begin: /\/(?=[^/\n]*\/)/,
            end: /\/[gimuy]*/,
            contains: [
              re,
              {
                begin: /\[/,
                end: /\]/,
                relevance: 0,
                contains: [re],
              },
            ],
          },
          RE_STARTERS_RE: k,
          SHEBANG: ne,
          TITLE_MODE: {
            scope: `title`,
            begin: E,
            relevance: 0,
          },
          UNDERSCORE_IDENT_RE: D,
          UNDERSCORE_TITLE_MODE: {
            scope: `title`,
            begin: D,
            relevance: 0,
          },
        });
      function ue(e, t) {
        e.input[e.index - 1] === `.` && t.ignoreMatch();
      }
      function de(e, t) {
        e.className !== void 0 && ((e.scope = e.className), delete e.className);
      }
      function fe(e, t) {
        t &&
          e.beginKeywords &&
          ((e.begin = `\\b(` + e.beginKeywords.split(` `).join(`|`) + `)(?!\\.)(?=\\b|\\s)`),
          (e.__beforeBegin = ue),
          (e.keywords = e.keywords || e.beginKeywords),
          delete e.beginKeywords,
          e.relevance === void 0 && (e.relevance = 0));
      }
      function pe(e, t) {
        Array.isArray(e.illegal) && (e.illegal = b(...e.illegal));
      }
      function M(e, t) {
        if (e.match) {
          if (e.begin || e.end) throw Error(`begin & end are not supported with match`);
          ((e.begin = e.match), delete e.match);
        }
      }
      function me(e, t) {
        e.relevance === void 0 && (e.relevance = 1);
      }
      var N = (e, t) => {
          if (!e.beforeMatch) return;
          if (e.starts) throw Error(`beforeMatch cannot be used with starts`);
          let n = Object.assign({}, e);
          (Object.keys(e).forEach((t) => {
            delete e[t];
          }),
            (e.keywords = n.keywords),
            (e.begin = v(n.beforeMatch, m(n.begin))),
            (e.starts = {
              relevance: 0,
              contains: [
                Object.assign(n, {
                  endsParent: !0,
                }),
              ],
            }),
            (e.relevance = 0),
            delete n.beforeMatch);
        },
        P = [`of`, `and`, `for`, `in`, `not`, `or`, `if`, `then`, `parent`, `list`, `value`],
        he = `keyword`;
      function ge(e, t, n = he) {
        let r = Object.create(null);
        return (
          typeof e == `string`
            ? i(n, e.split(` `))
            : Array.isArray(e)
              ? i(n, e)
              : Object.keys(e).forEach(function (n) {
                  Object.assign(r, ge(e[n], t, n));
                }),
          r
        );
        function i(e, n) {
          (t && (n = n.map((e) => e.toLowerCase())),
            n.forEach(function (t) {
              let n = t.split(`|`);
              r[n[0]] = [e, _e(n[0], n[1])];
            }));
        }
      }
      function _e(e, t) {
        return t ? Number(t) : +!ve(e);
      }
      function ve(e) {
        return P.includes(e.toLowerCase());
      }
      var ye = {},
        F = (e) => {
          console.error(e);
        },
        be = (e, ...t) => {
          console.log(`WARN: ${e}`, ...t);
        },
        I = (e, t) => {
          ye[`${e}/${t}`] || (console.log(`Deprecated as of ${e}. ${t}`), (ye[`${e}/${t}`] = !0));
        },
        L = Error();
      function xe(e, t, { key: n }) {
        let r = 0,
          i = e[n],
          a = {},
          o = {};
        for (let e = 1; e <= t.length; e++)
          ((o[e + r] = i[e]), (a[e + r] = !0), (r += x(t[e - 1])));
        ((e[n] = o), (e[n]._emit = a), (e[n]._multi = !0));
      }
      function Se(e) {
        if (Array.isArray(e.begin)) {
          if (e.skip || e.excludeBegin || e.returnBegin)
            throw (F(`skip, excludeBegin, returnBegin not compatible with beginScope: {}`), L);
          if (typeof e.beginScope != `object` || e.beginScope === null)
            throw (F(`beginScope must be object`), L);
          (xe(e, e.begin, {
            key: `beginScope`,
          }),
            (e.begin = w(e.begin, {
              joinWith: ``,
            })));
        }
      }
      function Ce(e) {
        if (Array.isArray(e.end)) {
          if (e.skip || e.excludeEnd || e.returnEnd)
            throw (F(`skip, excludeEnd, returnEnd not compatible with endScope: {}`), L);
          if (typeof e.endScope != `object` || e.endScope === null)
            throw (F(`endScope must be object`), L);
          (xe(e, e.end, {
            key: `endScope`,
          }),
            (e.end = w(e.end, {
              joinWith: ``,
            })));
        }
      }
      function we(e) {
        e.scope &&
          typeof e.scope == `object` &&
          e.scope !== null &&
          ((e.beginScope = e.scope), delete e.scope);
      }
      function Te(e) {
        (we(e),
          typeof e.beginScope == `string` &&
            (e.beginScope = {
              _wrap: e.beginScope,
            }),
          typeof e.endScope == `string` &&
            (e.endScope = {
              _wrap: e.endScope,
            }),
          Se(e),
          Ce(e));
      }
      function Ee(e) {
        function t(t, n) {
          return new RegExp(
            p(t),
            `m` + (e.case_insensitive ? `i` : ``) + (e.unicodeRegex ? `u` : ``) + (n ? `g` : ``),
          );
        }
        class n {
          constructor() {
            ((this.matchIndexes = {}),
              (this.regexes = []),
              (this.matchAt = 1),
              (this.position = 0));
          }
          addRule(e, t) {
            ((t.position = this.position++),
              (this.matchIndexes[this.matchAt] = t),
              this.regexes.push([t, e]),
              (this.matchAt += x(e) + 1));
          }
          compile() {
            this.regexes.length === 0 && (this.exec = () => null);
            let e = this.regexes.map((e) => e[1]);
            ((this.matcherRe = t(
              w(e, {
                joinWith: `|`,
              }),
              !0,
            )),
              (this.lastIndex = 0));
          }
          exec(e) {
            this.matcherRe.lastIndex = this.lastIndex;
            let t = this.matcherRe.exec(e);
            if (!t) return null;
            let n = t.findIndex((e, t) => t > 0 && e !== void 0),
              r = this.matchIndexes[n];
            return (t.splice(0, n), Object.assign(t, r));
          }
        }
        class r {
          constructor() {
            ((this.rules = []),
              (this.multiRegexes = []),
              (this.count = 0),
              (this.lastIndex = 0),
              (this.regexIndex = 0));
          }
          getMatcher(e) {
            if (this.multiRegexes[e]) return this.multiRegexes[e];
            let t = new n();
            return (
              this.rules.slice(e).forEach(([e, n]) => t.addRule(e, n)),
              t.compile(),
              (this.multiRegexes[e] = t),
              t
            );
          }
          resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
          }
          considerAll() {
            this.regexIndex = 0;
          }
          addRule(e, t) {
            (this.rules.push([e, t]), t.type === `begin` && this.count++);
          }
          exec(e) {
            let t = this.getMatcher(this.regexIndex);
            t.lastIndex = this.lastIndex;
            let n = t.exec(e);
            if (this.resumingScanAtSamePosition() && !(n && n.index === this.lastIndex)) {
              let t = this.getMatcher(0);
              ((t.lastIndex = this.lastIndex + 1), (n = t.exec(e)));
            }
            return (
              n &&
                ((this.regexIndex += n.position + 1),
                this.regexIndex === this.count && this.considerAll()),
              n
            );
          }
        }
        function i(e) {
          let t = new r();
          return (
            e.contains.forEach((e) =>
              t.addRule(e.begin, {
                rule: e,
                type: `begin`,
              }),
            ),
            e.terminatorEnd &&
              t.addRule(e.terminatorEnd, {
                type: `end`,
              }),
            e.illegal &&
              t.addRule(e.illegal, {
                type: `illegal`,
              }),
            t
          );
        }
        function o(n, r) {
          let a = n;
          if (n.isCompiled) return a;
          ([de, M, Te, N].forEach((e) => e(n, r)),
            e.compilerExtensions.forEach((e) => e(n, r)),
            (n.__beforeBegin = null),
            [fe, pe, me].forEach((e) => e(n, r)),
            (n.isCompiled = !0));
          let s = null;
          return (
            typeof n.keywords == `object` &&
              n.keywords.$pattern &&
              ((n.keywords = Object.assign({}, n.keywords)),
              (s = n.keywords.$pattern),
              delete n.keywords.$pattern),
            (s ||= /\w+/),
            (n.keywords &&= ge(n.keywords, e.case_insensitive)),
            (a.keywordPatternRe = t(s, !0)),
            r &&
              ((n.begin ||= /\B|\b/),
              (a.beginRe = t(a.begin)),
              !n.end && !n.endsWithParent && (n.end = /\B|\b/),
              n.end && (a.endRe = t(a.end)),
              (a.terminatorEnd = p(a.end) || ``),
              n.endsWithParent &&
                r.terminatorEnd &&
                (a.terminatorEnd += (n.end ? `|` : ``) + r.terminatorEnd)),
            n.illegal && (a.illegalRe = t(n.illegal)),
            (n.contains ||= []),
            (n.contains = [].concat(
              ...n.contains.map(function (e) {
                return Oe(e === `self` ? n : e);
              }),
            )),
            n.contains.forEach(function (e) {
              o(e, a);
            }),
            n.starts && o(n.starts, r),
            (a.matcher = i(a)),
            a
          );
        }
        if (((e.compilerExtensions ||= []), e.contains && e.contains.includes(`self`)))
          throw Error(
            "ERR: contains `self` is not supported at the top-level of a language.  See documentation.",
          );
        return ((e.classNameAliases = a(e.classNameAliases || {})), o(e));
      }
      function De(e) {
        return e ? e.endsWithParent || De(e.starts) : !1;
      }
      function Oe(e) {
        return (
          e.variants &&
            !e.cachedVariants &&
            (e.cachedVariants = e.variants.map(function (t) {
              return a(
                e,
                {
                  variants: null,
                },
                t,
              );
            })),
          e.cachedVariants
            ? e.cachedVariants
            : De(e)
              ? a(e, {
                  starts: e.starts ? a(e.starts) : null,
                })
              : Object.isFrozen(e)
                ? a(e)
                : e
        );
      }
      var ke = `11.11.1`,
        Ae = class extends Error {
          constructor(e, t) {
            (super(e), (this.name = `HTMLInjectionError`), (this.html = t));
          }
        },
        je = i,
        Me = a,
        R = Symbol(`nomatch`),
        Ne = 7,
        Pe = function (e) {
          let t = Object.create(null),
            i = Object.create(null),
            a = [],
            o = !0,
            s = `Could not find the language '{}', did you forget to load/include a language module?`,
            c = {
              disableAutodetect: !0,
              name: `Plain text`,
              contains: [],
            },
            l = {
              ignoreUnescapedHTML: !1,
              throwUnescapedHTML: !1,
              noHighlightRe: /^(no-?highlight)$/i,
              languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
              classPrefix: `hljs-`,
              cssSelector: `pre code`,
              languages: null,
              __emitter: f,
            };
          function u(e) {
            return l.noHighlightRe.test(e);
          }
          function d(e) {
            let t = e.className + ` `;
            t += e.parentNode ? e.parentNode.className : ``;
            let n = l.languageDetectRe.exec(t);
            if (n) {
              let t = A(n[1]);
              return (
                t ||
                  (be(s.replace(`{}`, n[1])),
                  be(`Falling back to no-highlight mode for this block.`, e)),
                t ? n[1] : `no-highlight`
              );
            }
            return t.split(/\s+/).find((e) => u(e) || A(e));
          }
          function p(e, t, n) {
            let r = ``,
              i = ``;
            (typeof t == `object`
              ? ((r = e), (n = t.ignoreIllegals), (i = t.language))
              : (I(`10.7.0`, `highlight(lang, code, ...args) has been deprecated.`),
                I(
                  `10.7.0`,
                  `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`,
                ),
                (i = e),
                (r = t)),
              n === void 0 && (n = !0));
            let a = {
              code: r,
              language: i,
            };
            ce(`before:highlight`, a);
            let o = a.result ? a.result : y(a.language, a.code, n);
            return ((o.code = a.code), ce(`after:highlight`, o), o);
          }
          function y(e, n, i, a) {
            let c = Object.create(null);
            function u(e, t) {
              return e.keywords[t];
            }
            function d() {
              if (!k.keywords) {
                re.addText(ie);
                return;
              }
              let e = 0;
              k.keywordPatternRe.lastIndex = 0;
              let t = k.keywordPatternRe.exec(ie),
                n = ``;
              for (; t;) {
                n += ie.substring(e, t.index);
                let r = ee.case_insensitive ? t[0].toLowerCase() : t[0],
                  i = u(k, r);
                if (i) {
                  let [e, a] = i;
                  if (
                    (re.addText(n),
                    (n = ``),
                    (c[r] = (c[r] || 0) + 1),
                    c[r] <= Ne && (j += a),
                    e.startsWith(`_`))
                  )
                    n += t[0];
                  else {
                    let n = ee.classNameAliases[e] || e;
                    m(t[0], n);
                  }
                } else n += t[0];
                ((e = k.keywordPatternRe.lastIndex), (t = k.keywordPatternRe.exec(ie)));
              }
              ((n += ie.substring(e)), re.addText(n));
            }
            function f() {
              if (ie === ``) return;
              let e = null;
              if (typeof k.subLanguage == `string`) {
                if (!t[k.subLanguage]) {
                  re.addText(ie);
                  return;
                }
                ((e = y(k.subLanguage, ie, !0, ne[k.subLanguage])), (ne[k.subLanguage] = e._top));
              } else e = C(ie, k.subLanguage.length ? k.subLanguage : null);
              (k.relevance > 0 && (j += e.relevance), re.__addSublanguage(e._emitter, e.language));
            }
            function p() {
              (k.subLanguage == null ? d() : f(), (ie = ``));
            }
            function m(e, t) {
              e !== `` && (re.startScope(t), re.addText(e), re.endScope());
            }
            function h(e, t) {
              let n = 1,
                r = t.length - 1;
              for (; n <= r;) {
                if (!e._emit[n]) {
                  n++;
                  continue;
                }
                let r = ee.classNameAliases[e[n]] || e[n],
                  i = t[n];
                (r ? m(i, r) : ((ie = i), d(), (ie = ``)), n++);
              }
            }
            function g(e, t) {
              return (
                e.scope &&
                  typeof e.scope == `string` &&
                  re.openNode(ee.classNameAliases[e.scope] || e.scope),
                e.beginScope &&
                  (e.beginScope._wrap
                    ? (m(ie, ee.classNameAliases[e.beginScope._wrap] || e.beginScope._wrap),
                      (ie = ``))
                    : e.beginScope._multi && (h(e.beginScope, t), (ie = ``))),
                (k = Object.create(e, {
                  parent: {
                    value: k,
                  },
                })),
                k
              );
            }
            function v(e, t, n) {
              let i = S(e.endRe, n);
              if (i) {
                if (e[`on:end`]) {
                  let n = new r(e);
                  (e[`on:end`](t, n), n.isMatchIgnored && (i = !1));
                }
                if (i) {
                  for (; e.endsParent && e.parent;) e = e.parent;
                  return e;
                }
              }
              if (e.endsWithParent) return v(e.parent, t, n);
            }
            function b(e) {
              return k.matcher.regexIndex === 0 ? ((ie += e[0]), 1) : ((se = !0), 0);
            }
            function x(e) {
              let t = e[0],
                n = e.rule,
                i = new r(n),
                a = [n.__beforeBegin, n[`on:begin`]];
              for (let n of a) if (n && (n(e, i), i.isMatchIgnored)) return b(t);
              return (
                n.skip
                  ? (ie += t)
                  : (n.excludeBegin && (ie += t),
                    p(),
                    !n.returnBegin && !n.excludeBegin && (ie = t)),
                g(n, e),
                n.returnBegin ? 0 : t.length
              );
            }
            function w(e) {
              let t = e[0],
                r = n.substring(e.index),
                i = v(k, e, r);
              if (!i) return R;
              let a = k;
              k.endScope && k.endScope._wrap
                ? (p(), m(t, k.endScope._wrap))
                : k.endScope && k.endScope._multi
                  ? (p(), h(k.endScope, e))
                  : a.skip
                    ? (ie += t)
                    : (a.returnEnd || a.excludeEnd || (ie += t), p(), a.excludeEnd && (ie = t));
              do
                (k.scope && re.closeNode(),
                  !k.skip && !k.subLanguage && (j += k.relevance),
                  (k = k.parent));
              while (k !== i.parent);
              return (i.starts && g(i.starts, e), a.returnEnd ? 0 : t.length);
            }
            function T() {
              let e = [];
              for (let t = k; t !== ee; t = t.parent) t.scope && e.unshift(t.scope);
              e.forEach((e) => re.openNode(e));
            }
            let E = {};
            function D(t, r) {
              let a = r && r[0];
              if (((ie += t), a == null)) return (p(), 0);
              if (E.type === `begin` && r.type === `end` && E.index === r.index && a === ``) {
                if (((ie += n.slice(r.index, r.index + 1)), !o)) {
                  let t = Error(`0 width match regex (${e})`);
                  throw ((t.languageName = e), (t.badRule = E.rule), t);
                }
                return 1;
              }
              if (((E = r), r.type === `begin`)) return x(r);
              if (r.type === `illegal` && !i) {
                let e = Error(
                  `Illegal lexeme "` + a + `" for mode "` + (k.scope || `<unnamed>`) + `"`,
                );
                throw ((e.mode = k), e);
              } else if (r.type === `end`) {
                let e = w(r);
                if (e !== R) return e;
              }
              if (r.type === `illegal` && a === ``)
                return (
                  (ie += `
`),
                  1
                );
              if (oe > 1e5 && oe > r.index * 3)
                throw Error(`potential infinite loop, way more iterations than matches`);
              return ((ie += a), a.length);
            }
            let ee = A(e);
            if (!ee) throw (F(s.replace(`{}`, e)), Error(`Unknown language: "` + e + `"`));
            let te = Ee(ee),
              O = ``,
              k = a || te,
              ne = {},
              re = new l.__emitter(l);
            T();
            let ie = ``,
              j = 0,
              ae = 0,
              oe = 0,
              se = !1;
            try {
              if (ee.__emitTokens) ee.__emitTokens(n, re);
              else {
                for (k.matcher.considerAll(); ;) {
                  (oe++, se ? (se = !1) : k.matcher.considerAll(), (k.matcher.lastIndex = ae));
                  let e = k.matcher.exec(n);
                  if (!e) break;
                  let t = D(n.substring(ae, e.index), e);
                  ae = e.index + t;
                }
                D(n.substring(ae));
              }
              return (
                re.finalize(),
                (O = re.toHTML()),
                {
                  language: e,
                  value: O,
                  relevance: j,
                  illegal: !1,
                  _emitter: re,
                  _top: k,
                }
              );
            } catch (t) {
              if (t.message && t.message.includes(`Illegal`))
                return {
                  language: e,
                  value: je(n),
                  illegal: !0,
                  relevance: 0,
                  _illegalBy: {
                    message: t.message,
                    index: ae,
                    context: n.slice(ae - 100, ae + 100),
                    mode: t.mode,
                    resultSoFar: O,
                  },
                  _emitter: re,
                };
              if (o)
                return {
                  language: e,
                  value: je(n),
                  illegal: !1,
                  relevance: 0,
                  errorRaised: t,
                  _emitter: re,
                  _top: k,
                };
              throw t;
            }
          }
          function x(e) {
            let t = {
              value: je(e),
              illegal: !1,
              relevance: 0,
              _top: c,
              _emitter: new l.__emitter(l),
            };
            return (t._emitter.addText(e), t);
          }
          function C(e, n) {
            n = n || l.languages || Object.keys(t);
            let r = x(e),
              i = n
                .filter(A)
                .filter(j)
                .map((t) => y(t, e, !1));
            i.unshift(r);
            let [a, o] = i.sort((e, t) => {
                if (e.relevance !== t.relevance) return t.relevance - e.relevance;
                if (e.language && t.language) {
                  if (A(e.language).supersetOf === t.language) return 1;
                  if (A(t.language).supersetOf === e.language) return -1;
                }
                return 0;
              }),
              s = a;
            return ((s.secondBest = o), s);
          }
          function w(e, t, n) {
            let r = (t && i[t]) || n;
            (e.classList.add(`hljs`), e.classList.add(`language-${r}`));
          }
          function T(e) {
            let t = null,
              n = d(e);
            if (u(n)) return;
            if (
              (ce(`before:highlightElement`, {
                el: e,
                language: n,
              }),
              e.dataset.highlighted)
            ) {
              console.log(
                "Element previously highlighted. To highlight again, first unset `dataset.highlighted`.",
                e,
              );
              return;
            }
            if (
              e.children.length > 0 &&
              (l.ignoreUnescapedHTML ||
                (console.warn(
                  `One of your code blocks includes unescaped HTML. This is a potentially serious security risk.`,
                ),
                console.warn(`https://github.com/highlightjs/highlight.js/wiki/security`),
                console.warn(`The element with unescaped HTML:`),
                console.warn(e)),
              l.throwUnescapedHTML)
            )
              throw new Ae(`One of your code blocks includes unescaped HTML.`, e.innerHTML);
            t = e;
            let r = t.textContent,
              i = n
                ? p(r, {
                    language: n,
                    ignoreIllegals: !0,
                  })
                : C(r);
            ((e.innerHTML = i.value),
              (e.dataset.highlighted = `yes`),
              w(e, n, i.language),
              (e.result = {
                language: i.language,
                re: i.relevance,
                relevance: i.relevance,
              }),
              i.secondBest &&
                (e.secondBest = {
                  language: i.secondBest.language,
                  relevance: i.secondBest.relevance,
                }),
              ce(`after:highlightElement`, {
                el: e,
                result: i,
                text: r,
              }));
          }
          function E(e) {
            l = Me(l, e);
          }
          let D = () => {
            (O(), I(`10.6.0`, `initHighlighting() deprecated.  Use highlightAll() now.`));
          };
          function ee() {
            (O(), I(`10.6.0`, `initHighlightingOnLoad() deprecated.  Use highlightAll() now.`));
          }
          let te = !1;
          function O() {
            function e() {
              O();
            }
            if (document.readyState === `loading`) {
              (te || window.addEventListener(`DOMContentLoaded`, e, !1), (te = !0));
              return;
            }
            document.querySelectorAll(l.cssSelector).forEach(T);
          }
          function k(n, r) {
            let i = null;
            try {
              i = r(e);
            } catch (e) {
              if ((F(`Language definition for '{}' could not be registered.`.replace(`{}`, n)), o))
                F(e);
              else throw e;
              i = c;
            }
            ((i.name ||= n),
              (t[n] = i),
              (i.rawDefinition = r.bind(null, e)),
              i.aliases &&
                ie(i.aliases, {
                  languageName: n,
                }));
          }
          function ne(e) {
            delete t[e];
            for (let t of Object.keys(i)) i[t] === e && delete i[t];
          }
          function re() {
            return Object.keys(t);
          }
          function A(e) {
            return ((e = (e || ``).toLowerCase()), t[e] || t[i[e]]);
          }
          function ie(e, { languageName: t }) {
            (typeof e == `string` && (e = [e]),
              e.forEach((e) => {
                i[e.toLowerCase()] = t;
              }));
          }
          function j(e) {
            let t = A(e);
            return t && !t.disableAutodetect;
          }
          function ae(e) {
            (e[`before:highlightBlock`] &&
              !e[`before:highlightElement`] &&
              (e[`before:highlightElement`] = (t) => {
                e[`before:highlightBlock`](
                  Object.assign(
                    {
                      block: t.el,
                    },
                    t,
                  ),
                );
              }),
              e[`after:highlightBlock`] &&
                !e[`after:highlightElement`] &&
                (e[`after:highlightElement`] = (t) => {
                  e[`after:highlightBlock`](
                    Object.assign(
                      {
                        block: t.el,
                      },
                      t,
                    ),
                  );
                }));
          }
          function oe(e) {
            (ae(e), a.push(e));
          }
          function se(e) {
            let t = a.indexOf(e);
            t !== -1 && a.splice(t, 1);
          }
          function ce(e, t) {
            let n = e;
            a.forEach(function (e) {
              e[n] && e[n](t);
            });
          }
          function ue(e) {
            return (
              I(`10.7.0`, `highlightBlock will be removed entirely in v12.0`),
              I(`10.7.0`, `Please use highlightElement now.`),
              T(e)
            );
          }
          (Object.assign(e, {
            highlight: p,
            highlightAuto: C,
            highlightAll: O,
            highlightElement: T,
            highlightBlock: ue,
            configure: E,
            initHighlighting: D,
            initHighlightingOnLoad: ee,
            registerLanguage: k,
            unregisterLanguage: ne,
            listLanguages: re,
            getLanguage: A,
            registerAliases: ie,
            autoDetection: j,
            inherit: Me,
            addPlugin: oe,
            removePlugin: se,
          }),
            (e.debugMode = function () {
              o = !1;
            }),
            (e.safeMode = function () {
              o = !0;
            }),
            (e.versionString = ke),
            (e.regex = {
              concat: v,
              lookahead: m,
              either: b,
              optional: g,
              anyNumberOfTimes: h,
            }));
          for (let e in le) typeof le[e] == `object` && n(le[e]);
          return (Object.assign(e, le), e);
        },
        Fe = Pe({});
      ((Fe.newInstance = () => Pe({})), (t.exports = Fe), (Fe.HighlightJS = Fe), (Fe.default = Fe));
    })(),
  ).default;
function zbe(e) {
  let t = e.regex,
    n = {},
    r = {
      begin: /\$\{/,
      end: /\}/,
      contains: [
        `self`,
        {
          begin: /:-/,
          contains: [n],
        },
      ],
    };
  Object.assign(n, {
    className: `variable`,
    variants: [
      {
        begin: t.concat(/\$[\w\d#@][\w\d_]*/, `(?![\\w\\d])(?![$])`),
      },
      r,
    ],
  });
  let i = {
      className: `subst`,
      begin: /\$\(/,
      end: /\)/,
      contains: [e.BACKSLASH_ESCAPE],
    },
    a = e.inherit(e.COMMENT(), {
      match: [/(^|\s)/, /#.*$/],
      scope: {
        2: `comment`,
      },
    }),
    o = {
      begin: /<<-?\s*(?=\w+)/,
      starts: {
        contains: [
          e.END_SAME_AS_BEGIN({
            begin: /(\w+)/,
            end: /(\w+)/,
            className: `string`,
          }),
        ],
      },
    },
    s = {
      className: `string`,
      begin: /"/,
      end: /"/,
      contains: [e.BACKSLASH_ESCAPE, n, i],
    };
  i.contains.push(s);
  let c = {
      match: /\\"/,
    },
    l = {
      className: `string`,
      begin: /'/,
      end: /'/,
    },
    u = {
      match: /\\'/,
    },
    d = {
      begin: /\$?\(\(/,
      end: /\)\)/,
      contains: [
        {
          begin: /\d+#[0-9a-f]+/,
          className: `number`,
        },
        e.NUMBER_MODE,
        n,
      ],
    },
    f = e.SHEBANG({
      binary: `(${[`fish`, `bash`, `zsh`, `sh`, `csh`, `ksh`, `tcsh`, `dash`, `scsh`].join(`|`)})`,
      relevance: 10,
    }),
    p = {
      className: `function`,
      begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
      returnBegin: !0,
      contains: [
        e.inherit(e.TITLE_MODE, {
          begin: /\w[\w\d_]*/,
        }),
      ],
      relevance: 0,
    },
    m = [
      `if`,
      `then`,
      `else`,
      `elif`,
      `fi`,
      `time`,
      `for`,
      `while`,
      `until`,
      `in`,
      `do`,
      `done`,
      `case`,
      `esac`,
      `coproc`,
      `function`,
      `select`,
    ],
    h = [`true`, `false`],
    g = {
      match: /(\/[a-z._-]+)+/,
    },
    v = [
      `break`,
      `cd`,
      `continue`,
      `eval`,
      `exec`,
      `exit`,
      `export`,
      `getopts`,
      `hash`,
      `pwd`,
      `readonly`,
      `return`,
      `shift`,
      `test`,
      `times`,
      `trap`,
      `umask`,
      `unset`,
    ],
    y = [
      `alias`,
      `bind`,
      `builtin`,
      `caller`,
      `command`,
      `declare`,
      `echo`,
      `enable`,
      `help`,
      `let`,
      `local`,
      `logout`,
      `mapfile`,
      `printf`,
      `read`,
      `readarray`,
      `source`,
      `sudo`,
      `type`,
      `typeset`,
      `ulimit`,
      `unalias`,
    ],
    b =
      `autoload.bg.bindkey.bye.cap.chdir.clone.comparguments.compcall.compctl.compdescribe.compfiles.compgroups.compquote.comptags.comptry.compvalues.dirs.disable.disown.echotc.echoti.emulate.fc.fg.float.functions.getcap.getln.history.integer.jobs.kill.limit.log.noglob.popd.print.pushd.pushln.rehash.sched.setcap.setopt.stat.suspend.ttyctl.unfunction.unhash.unlimit.unsetopt.vared.wait.whence.where.which.zcompile.zformat.zftp.zle.zmodload.zparseopts.zprof.zpty.zregexparse.zsocket.zstyle.ztcp`.split(
        `.`,
      ),
    x =
      `chcon.chgrp.chown.chmod.cp.dd.df.dir.dircolors.ln.ls.mkdir.mkfifo.mknod.mktemp.mv.realpath.rm.rmdir.shred.sync.touch.truncate.vdir.b2sum.base32.base64.cat.cksum.comm.csplit.cut.expand.fmt.fold.head.join.md5sum.nl.numfmt.od.paste.ptx.pr.sha1sum.sha224sum.sha256sum.sha384sum.sha512sum.shuf.sort.split.sum.tac.tail.tr.tsort.unexpand.uniq.wc.arch.basename.chroot.date.dirname.du.echo.env.expr.factor.groups.hostid.id.link.logname.nice.nohup.nproc.pathchk.pinky.printenv.printf.pwd.readlink.runcon.seq.sleep.stat.stdbuf.stty.tee.test.timeout.tty.uname.unlink.uptime.users.who.whoami.yes`.split(
        `.`,
      );
  return {
    name: `Bash`,
    aliases: [`sh`, `zsh`],
    keywords: {
      $pattern: /\b[a-z][a-z0-9._-]+\b/,
      keyword: m,
      literal: h,
      built_in: [...v, ...y, `set`, `shopt`, ...b, ...x],
    },
    contains: [f, e.SHEBANG(), p, d, a, o, g, s, c, l, u, n],
  };
}
var Bbe = (e) => ({
    IMPORTANT: {
      scope: `meta`,
      begin: `!important`,
    },
    BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
    HEXCOLOR: {
      scope: `number`,
      begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/,
    },
    FUNCTION_DISPATCH: {
      className: `built_in`,
      begin: /[\w-]+(?=\()/,
    },
    ATTRIBUTE_SELECTOR_MODE: {
      scope: `selector-attr`,
      begin: /\[/,
      end: /\]/,
      illegal: `$`,
      contains: [e.APOS_STRING_MODE, e.QUOTE_STRING_MODE],
    },
    CSS_NUMBER_MODE: {
      scope: `number`,
      begin:
        e.NUMBER_RE +
        `(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?`,
      relevance: 0,
    },
    CSS_VARIABLE: {
      className: `attr`,
      begin: /--[A-Za-z_][A-Za-z0-9_-]*/,
    },
  }),
  Vbe =
    `a.abbr.address.article.aside.audio.b.blockquote.body.button.canvas.caption.cite.code.dd.del.details.dfn.div.dl.dt.em.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.header.hgroup.html.i.iframe.img.input.ins.kbd.label.legend.li.main.mark.menu.nav.object.ol.optgroup.option.p.picture.q.quote.samp.section.select.source.span.strong.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.tr.ul.var.video`.split(
      `.`,
    ),
  Hbe =
    `defs.g.marker.mask.pattern.svg.switch.symbol.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feFlood.feGaussianBlur.feImage.feMerge.feMorphology.feOffset.feSpecularLighting.feTile.feTurbulence.linearGradient.radialGradient.stop.circle.ellipse.image.line.path.polygon.polyline.rect.text.use.textPath.tspan.foreignObject.clipPath`.split(
      `.`,
    ),
  Ube = [...Vbe, ...Hbe],
  Wbe =
    `any-hover.any-pointer.aspect-ratio.color.color-gamut.color-index.device-aspect-ratio.device-height.device-width.display-mode.forced-colors.grid.height.hover.inverted-colors.monochrome.orientation.overflow-block.overflow-inline.pointer.prefers-color-scheme.prefers-contrast.prefers-reduced-motion.prefers-reduced-transparency.resolution.scan.scripting.update.width.min-width.max-width.min-height.max-height`
      .split(`.`)
      .sort()
      .reverse(),
  Gbe =
    `active.any-link.blank.checked.current.default.defined.dir.disabled.drop.empty.enabled.first.first-child.first-of-type.fullscreen.future.focus.focus-visible.focus-within.has.host.host-context.hover.indeterminate.in-range.invalid.is.lang.last-child.last-of-type.left.link.local-link.not.nth-child.nth-col.nth-last-child.nth-last-col.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.past.placeholder-shown.read-only.read-write.required.right.root.scope.target.target-within.user-invalid.valid.visited.where`
      .split(`.`)
      .sort()
      .reverse(),
  Kbe = [
    `after`,
    `backdrop`,
    `before`,
    `cue`,
    `cue-region`,
    `first-letter`,
    `first-line`,
    `grammar-error`,
    `marker`,
    `part`,
    `placeholder`,
    `selection`,
    `slotted`,
    `spelling-error`,
  ]
    .sort()
    .reverse(),
  qbe =
    `accent-color.align-content.align-items.align-self.alignment-baseline.all.anchor-name.animation.animation-composition.animation-delay.animation-direction.animation-duration.animation-fill-mode.animation-iteration-count.animation-name.animation-play-state.animation-range.animation-range-end.animation-range-start.animation-timeline.animation-timing-function.appearance.aspect-ratio.backdrop-filter.backface-visibility.background.background-attachment.background-blend-mode.background-clip.background-color.background-image.background-origin.background-position.background-position-x.background-position-y.background-repeat.background-size.baseline-shift.block-size.border.border-block.border-block-color.border-block-end.border-block-end-color.border-block-end-style.border-block-end-width.border-block-start.border-block-start-color.border-block-start-style.border-block-start-width.border-block-style.border-block-width.border-bottom.border-bottom-color.border-bottom-left-radius.border-bottom-right-radius.border-bottom-style.border-bottom-width.border-collapse.border-color.border-end-end-radius.border-end-start-radius.border-image.border-image-outset.border-image-repeat.border-image-slice.border-image-source.border-image-width.border-inline.border-inline-color.border-inline-end.border-inline-end-color.border-inline-end-style.border-inline-end-width.border-inline-start.border-inline-start-color.border-inline-start-style.border-inline-start-width.border-inline-style.border-inline-width.border-left.border-left-color.border-left-style.border-left-width.border-radius.border-right.border-right-color.border-right-style.border-right-width.border-spacing.border-start-end-radius.border-start-start-radius.border-style.border-top.border-top-color.border-top-left-radius.border-top-right-radius.border-top-style.border-top-width.border-width.bottom.box-align.box-decoration-break.box-direction.box-flex.box-flex-group.box-lines.box-ordinal-group.box-orient.box-pack.box-shadow.box-sizing.break-after.break-before.break-inside.caption-side.caret-color.clear.clip.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.color-scheme.column-count.column-fill.column-gap.column-rule.column-rule-color.column-rule-style.column-rule-width.column-span.column-width.columns.contain.contain-intrinsic-block-size.contain-intrinsic-height.contain-intrinsic-inline-size.contain-intrinsic-size.contain-intrinsic-width.container.container-name.container-type.content.content-visibility.counter-increment.counter-reset.counter-set.cue.cue-after.cue-before.cursor.cx.cy.direction.display.dominant-baseline.empty-cells.enable-background.field-sizing.fill.fill-opacity.fill-rule.filter.flex.flex-basis.flex-direction.flex-flow.flex-grow.flex-shrink.flex-wrap.float.flood-color.flood-opacity.flow.font.font-display.font-family.font-feature-settings.font-kerning.font-language-override.font-optical-sizing.font-palette.font-size.font-size-adjust.font-smooth.font-smoothing.font-stretch.font-style.font-synthesis.font-synthesis-position.font-synthesis-small-caps.font-synthesis-style.font-synthesis-weight.font-variant.font-variant-alternates.font-variant-caps.font-variant-east-asian.font-variant-emoji.font-variant-ligatures.font-variant-numeric.font-variant-position.font-variation-settings.font-weight.forced-color-adjust.gap.glyph-orientation-horizontal.glyph-orientation-vertical.grid.grid-area.grid-auto-columns.grid-auto-flow.grid-auto-rows.grid-column.grid-column-end.grid-column-start.grid-gap.grid-row.grid-row-end.grid-row-start.grid-template.grid-template-areas.grid-template-columns.grid-template-rows.hanging-punctuation.height.hyphenate-character.hyphenate-limit-chars.hyphens.icon.image-orientation.image-rendering.image-resolution.ime-mode.initial-letter.initial-letter-align.inline-size.inset.inset-area.inset-block.inset-block-end.inset-block-start.inset-inline.inset-inline-end.inset-inline-start.isolation.justify-content.justify-items.justify-self.kerning.left.letter-spacing.lighting-color.line-break.line-height.line-height-step.list-style.list-style-image.list-style-position.list-style-type.margin.margin-block.margin-block-end.margin-block-start.margin-bottom.margin-inline.margin-inline-end.margin-inline-start.margin-left.margin-right.margin-top.margin-trim.marker.marker-end.marker-mid.marker-start.marks.mask.mask-border.mask-border-mode.mask-border-outset.mask-border-repeat.mask-border-slice.mask-border-source.mask-border-width.mask-clip.mask-composite.mask-image.mask-mode.mask-origin.mask-position.mask-repeat.mask-size.mask-type.masonry-auto-flow.math-depth.math-shift.math-style.max-block-size.max-height.max-inline-size.max-width.min-block-size.min-height.min-inline-size.min-width.mix-blend-mode.nav-down.nav-index.nav-left.nav-right.nav-up.none.normal.object-fit.object-position.offset.offset-anchor.offset-distance.offset-path.offset-position.offset-rotate.opacity.order.orphans.outline.outline-color.outline-offset.outline-style.outline-width.overflow.overflow-anchor.overflow-block.overflow-clip-margin.overflow-inline.overflow-wrap.overflow-x.overflow-y.overlay.overscroll-behavior.overscroll-behavior-block.overscroll-behavior-inline.overscroll-behavior-x.overscroll-behavior-y.padding.padding-block.padding-block-end.padding-block-start.padding-bottom.padding-inline.padding-inline-end.padding-inline-start.padding-left.padding-right.padding-top.page.page-break-after.page-break-before.page-break-inside.paint-order.pause.pause-after.pause-before.perspective.perspective-origin.place-content.place-items.place-self.pointer-events.position.position-anchor.position-visibility.print-color-adjust.quotes.r.resize.rest.rest-after.rest-before.right.rotate.row-gap.ruby-align.ruby-position.scale.scroll-behavior.scroll-margin.scroll-margin-block.scroll-margin-block-end.scroll-margin-block-start.scroll-margin-bottom.scroll-margin-inline.scroll-margin-inline-end.scroll-margin-inline-start.scroll-margin-left.scroll-margin-right.scroll-margin-top.scroll-padding.scroll-padding-block.scroll-padding-block-end.scroll-padding-block-start.scroll-padding-bottom.scroll-padding-inline.scroll-padding-inline-end.scroll-padding-inline-start.scroll-padding-left.scroll-padding-right.scroll-padding-top.scroll-snap-align.scroll-snap-stop.scroll-snap-type.scroll-timeline.scroll-timeline-axis.scroll-timeline-name.scrollbar-color.scrollbar-gutter.scrollbar-width.shape-image-threshold.shape-margin.shape-outside.shape-rendering.speak.speak-as.src.stop-color.stop-opacity.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.tab-size.table-layout.text-align.text-align-all.text-align-last.text-anchor.text-combine-upright.text-decoration.text-decoration-color.text-decoration-line.text-decoration-skip.text-decoration-skip-ink.text-decoration-style.text-decoration-thickness.text-emphasis.text-emphasis-color.text-emphasis-position.text-emphasis-style.text-indent.text-justify.text-orientation.text-overflow.text-rendering.text-shadow.text-size-adjust.text-transform.text-underline-offset.text-underline-position.text-wrap.text-wrap-mode.text-wrap-style.timeline-scope.top.touch-action.transform.transform-box.transform-origin.transform-style.transition.transition-behavior.transition-delay.transition-duration.transition-property.transition-timing-function.translate.unicode-bidi.user-modify.user-select.vector-effect.vertical-align.view-timeline.view-timeline-axis.view-timeline-inset.view-timeline-name.view-transition-name.visibility.voice-balance.voice-duration.voice-family.voice-pitch.voice-range.voice-rate.voice-stress.voice-volume.white-space.white-space-collapse.widows.width.will-change.word-break.word-spacing.word-wrap.writing-mode.x.y.z-index.zoom`
      .split(`.`)
      .sort()
      .reverse();
function Jbe(e) {
  let t = e.regex,
    n = Bbe(e),
    r = {
      begin: /-(webkit|moz|ms|o)-(?=[a-z])/,
    },
    i = /@-?\w[\w]*(-\w+)*/,
    a = [e.APOS_STRING_MODE, e.QUOTE_STRING_MODE];
  return {
    name: `CSS`,
    case_insensitive: !0,
    illegal: /[=|'\$]/,
    keywords: {
      keyframePosition: `from to`,
    },
    classNameAliases: {
      keyframePosition: `selector-tag`,
    },
    contains: [
      n.BLOCK_COMMENT,
      r,
      n.CSS_NUMBER_MODE,
      {
        className: `selector-id`,
        begin: /#[A-Za-z0-9_-]+/,
        relevance: 0,
      },
      {
        className: `selector-class`,
        begin: `\\.[a-zA-Z-][a-zA-Z0-9_-]*`,
        relevance: 0,
      },
      n.ATTRIBUTE_SELECTOR_MODE,
      {
        className: `selector-pseudo`,
        variants: [
          {
            begin: `:(` + Gbe.join(`|`) + `)`,
          },
          {
            begin: `:(:)?(` + Kbe.join(`|`) + `)`,
          },
        ],
      },
      n.CSS_VARIABLE,
      {
        className: `attribute`,
        begin: `\\b(` + qbe.join(`|`) + `)\\b`,
      },
      {
        begin: /:/,
        end: /[;}{]/,
        contains: [
          n.BLOCK_COMMENT,
          n.HEXCOLOR,
          n.IMPORTANT,
          n.CSS_NUMBER_MODE,
          ...a,
          {
            begin: /(url|data-uri)\(/,
            end: /\)/,
            relevance: 0,
            keywords: {
              built_in: `url data-uri`,
            },
            contains: [
              ...a,
              {
                className: `string`,
                begin: /[^)]/,
                endsWithParent: !0,
                excludeEnd: !0,
              },
            ],
          },
          n.FUNCTION_DISPATCH,
        ],
      },
      {
        begin: t.lookahead(/@/),
        end: `[{;]`,
        relevance: 0,
        illegal: /:/,
        contains: [
          {
            className: `keyword`,
            begin: i,
          },
          {
            begin: /\s/,
            endsWithParent: !0,
            excludeEnd: !0,
            relevance: 0,
            keywords: {
              $pattern: /[a-z-]+/,
              keyword: `and or not only`,
              attribute: Wbe.join(` `),
            },
            contains: [
              {
                begin: /[a-z-]+(?=:)/,
                className: `attribute`,
              },
              ...a,
              n.CSS_NUMBER_MODE,
            ],
          },
        ],
      },
      {
        className: `selector-tag`,
        begin: `\\b(` + Ube.join(`|`) + `)\\b`,
      },
    ],
  };
}
function Ybe(e) {
  let t = {
      className: `subst`,
      variants: [
        {
          begin: `\\$[A-Za-z0-9_]+`,
        },
      ],
    },
    n = {
      className: `subst`,
      variants: [
        {
          begin: /\$\{/,
          end: /\}/,
        },
      ],
      keywords: `true false null this is new super`,
    },
    r = {
      className: `number`,
      relevance: 0,
      variants: [
        {
          match: /\b[0-9][0-9_]*(\.[0-9][0-9_]*)?([eE][+-]?[0-9][0-9_]*)?\b/,
        },
        {
          match: /\b0[xX][0-9A-Fa-f][0-9A-Fa-f_]*\b/,
        },
      ],
    },
    i = {
      className: `string`,
      variants: [
        {
          begin: `r'''`,
          end: `'''`,
        },
        {
          begin: `r"""`,
          end: `"""`,
        },
        {
          begin: `r'`,
          end: `'`,
          illegal: `\\n`,
        },
        {
          begin: `r"`,
          end: `"`,
          illegal: `\\n`,
        },
        {
          begin: `'''`,
          end: `'''`,
          contains: [e.BACKSLASH_ESCAPE, t, n],
        },
        {
          begin: `"""`,
          end: `"""`,
          contains: [e.BACKSLASH_ESCAPE, t, n],
        },
        {
          begin: `'`,
          end: `'`,
          illegal: `\\n`,
          contains: [e.BACKSLASH_ESCAPE, t, n],
        },
        {
          begin: `"`,
          end: `"`,
          illegal: `\\n`,
          contains: [e.BACKSLASH_ESCAPE, t, n],
        },
      ],
    };
  n.contains = [r, i];
  let a =
      `Comparable.DateTime.Duration.Function.Iterable.Iterator.List.Map.Match.Object.Pattern.RegExp.Set.Stopwatch.String.StringBuffer.StringSink.Symbol.Type.Uri.bool.double.int.num.Element.ElementList`.split(
        `.`,
      ),
    o = a.map((e) => `${e}?`);
  return {
    name: `Dart`,
    keywords: {
      keyword:
        `abstract.as.assert.async.await.base.break.case.catch.class.const.continue.covariant.default.deferred.do.dynamic.else.enum.export.extends.extension.external.factory.false.final.finally.for.Function.get.hide.if.implements.import.in.interface.is.late.library.mixin.new.null.on.operator.part.required.rethrow.return.sealed.set.show.static.super.switch.sync.this.throw.true.try.typedef.var.void.when.while.with.yield`.split(
          `.`,
        ),
      built_in: a
        .concat(o)
        .concat([
          `Never`,
          `Null`,
          `dynamic`,
          `print`,
          `document`,
          `querySelector`,
          `querySelectorAll`,
          `window`,
        ]),
      $pattern: /[A-Za-z][A-Za-z0-9_]*\??/,
    },
    contains: [
      i,
      e.COMMENT(/\/\*\*(?!\/)/, /\*\//, {
        subLanguage: `markdown`,
        relevance: 0,
      }),
      e.COMMENT(/\/{3,} ?/, /$/, {
        contains: [
          {
            subLanguage: `markdown`,
            begin: `.`,
            end: `$`,
            relevance: 0,
          },
        ],
      }),
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      {
        className: `class`,
        beginKeywords: `class interface`,
        end: /\{/,
        excludeEnd: !0,
        contains: [
          {
            beginKeywords: `extends implements`,
          },
          e.UNDERSCORE_TITLE_MODE,
        ],
      },
      r,
      {
        className: `meta`,
        begin: `@[A-Za-z]+`,
      },
      {
        begin: `=>`,
      },
    ],
  };
}
function Xbe(e) {
  let t = e.regex;
  return {
    name: `Diff`,
    aliases: [`patch`],
    contains: [
      {
        className: `meta`,
        relevance: 10,
        match: t.either(
          /^@@ +-\d+,\d+ +\+\d+,\d+ +@@/,
          /^\*\*\* +\d+,\d+ +\*\*\*\*$/,
          /^--- +\d+,\d+ +----$/,
        ),
      },
      {
        className: `comment`,
        variants: [
          {
            begin: t.either(
              /Index: /,
              /^index/,
              /={3,}/,
              /^-{3}/,
              /^\*{3} /,
              /^\+{3}/,
              /^diff --git/,
            ),
            end: /$/,
          },
          {
            match: /^\*{15}$/,
          },
        ],
      },
      {
        className: `addition`,
        begin: /^\+/,
        end: /$/,
      },
      {
        className: `deletion`,
        begin: /^-/,
        end: /$/,
      },
      {
        className: `addition`,
        begin: /^!/,
        end: /$/,
      },
    ],
  };
}
function Zbe(e) {
  return {
    name: `DNS Zone`,
    aliases: [`bind`, `zone`],
    keywords:
      `IN.A.AAAA.AFSDB.APL.CAA.CDNSKEY.CDS.CERT.CNAME.DHCID.DLV.DNAME.DNSKEY.DS.HIP.IPSECKEY.KEY.KX.LOC.MX.NAPTR.NS.NSEC.NSEC3.NSEC3PARAM.PTR.RRSIG.RP.SIG.SOA.SRV.SSHFP.TA.TKEY.TLSA.TSIG.TXT`.split(
        `.`,
      ),
    contains: [
      e.COMMENT(`;`, `$`, {
        relevance: 0,
      }),
      {
        className: `meta`,
        begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/,
      },
      {
        className: `number`,
        begin: `((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b`,
      },
      {
        className: `number`,
        begin: `((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b`,
      },
      e.inherit(e.NUMBER_MODE, {
        begin: /\b\d+[dhwm]?/,
      }),
    ],
  };
}
function Qbe(e) {
  return {
    name: `Dockerfile`,
    aliases: [`docker`],
    case_insensitive: !0,
    keywords: [`from`, `maintainer`, `expose`, `env`, `arg`, `user`, `onbuild`, `stopsignal`],
    contains: [
      e.HASH_COMMENT_MODE,
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      e.NUMBER_MODE,
      {
        beginKeywords: `run cmd entrypoint volume add copy workdir label healthcheck shell`,
        starts: {
          end: /[^\\]$/,
          subLanguage: `bash`,
        },
      },
    ],
    illegal: `</`,
  };
}
function $be(e) {
  return {
    name: `Excel formulae`,
    aliases: [`xlsx`, `xls`],
    case_insensitive: !0,
    keywords: {
      $pattern: /[a-zA-Z][\w\.]*/,
      built_in:
        `ABS,ACCRINT,ACCRINTM,ACOS,ACOSH,ACOT,ACOTH,AGGREGATE,ADDRESS,AMORDEGRC,AMORLINC,AND,ARABIC,AREAS,ARRAYTOTEXT,ASC,ASIN,ASINH,ATAN,ATAN2,ATANH,AVEDEV,AVERAGE,AVERAGEA,AVERAGEIF,AVERAGEIFS,BAHTTEXT,BASE,BESSELI,BESSELJ,BESSELK,BESSELY,BETADIST,BETA.DIST,BETAINV,BETA.INV,BIN2DEC,BIN2HEX,BIN2OCT,BINOMDIST,BINOM.DIST,BINOM.DIST.RANGE,BINOM.INV,BITAND,BITLSHIFT,BITOR,BITRSHIFT,BITXOR,BYCOL,BYROW,CALL,CEILING,CEILING.MATH,CEILING.PRECISE,CELL,CHAR,CHIDIST,CHIINV,CHITEST,CHISQ.DIST,CHISQ.DIST.RT,CHISQ.INV,CHISQ.INV.RT,CHISQ.TEST,CHOOSE,CHOOSECOLS,CHOOSEROWS,CLEAN,CODE,COLUMN,COLUMNS,COMBIN,COMBINA,COMPLEX,CONCAT,CONCATENATE,CONFIDENCE,CONFIDENCE.NORM,CONFIDENCE.T,CONVERT,CORREL,COS,COSH,COT,COTH,COUNT,COUNTA,COUNTBLANK,COUNTIF,COUNTIFS,COUPDAYBS,COUPDAYS,COUPDAYSNC,COUPNCD,COUPNUM,COUPPCD,COVAR,COVARIANCE.P,COVARIANCE.S,CRITBINOM,CSC,CSCH,CUBEKPIMEMBER,CUBEMEMBER,CUBEMEMBERPROPERTY,CUBERANKEDMEMBER,CUBESET,CUBESETCOUNT,CUBEVALUE,CUMIPMT,CUMPRINC,DATE,DATEDIF,DATEVALUE,DAVERAGE,DAY,DAYS,DAYS360,DB,DBCS,DCOUNT,DCOUNTA,DDB,DEC2BIN,DEC2HEX,DEC2OCT,DECIMAL,DEGREES,DELTA,DEVSQ,DGET,DISC,DMAX,DMIN,DOLLAR,DOLLARDE,DOLLARFR,DPRODUCT,DROP,DSTDEV,DSTDEVP,DSUM,DURATION,DVAR,DVARP,EDATE,EFFECT,ENCODEURL,EOMONTH,ERF,ERF.PRECISE,ERFC,ERFC.PRECISE,ERROR.TYPE,EUROCONVERT,EVEN,EXACT,EXP,EXPAND,EXPON.DIST,EXPONDIST,FACT,FACTDOUBLE,FALSE,F.DIST,FDIST,F.DIST.RT,FILTER,FILTERXML,FIND,FINDB,F.INV,F.INV.RT,FINV,FISHER,FISHERINV,FIXED,FLOOR,FLOOR.MATH,FLOOR.PRECISE,FORECAST,FORECAST.ETS,FORECAST.ETS.CONFINT,FORECAST.ETS.SEASONALITY,FORECAST.ETS.STAT,FORECAST.LINEAR,FORMULATEXT,FREQUENCY,F.TEST,FTEST,FV,FVSCHEDULE,GAMMA,GAMMA.DIST,GAMMADIST,GAMMA.INV,GAMMAINV,GAMMALN,GAMMALN.PRECISE,GAUSS,GCD,GEOMEAN,GESTEP,GETPIVOTDATA,GROWTH,HARMEAN,HEX2BIN,HEX2DEC,HEX2OCT,HLOOKUP,HOUR,HSTACK,HYPERLINK,HYPGEOM.DIST,HYPGEOMDIST,IF,IFERROR,IFNA,IFS,IMABS,IMAGE,IMAGINARY,IMARGUMENT,IMCONJUGATE,IMCOS,IMCOSH,IMCOT,IMCSC,IMCSCH,IMDIV,IMEXP,IMLN,IMLOG10,IMLOG2,IMPOWER,IMPRODUCT,IMREAL,IMSEC,IMSECH,IMSIN,IMSINH,IMSQRT,IMSUB,IMSUM,IMTAN,INDEX,INDIRECT,INFO,INT,INTERCEPT,INTRATE,IPMT,IRR,ISBLANK,ISERR,ISERROR,ISEVEN,ISFORMULA,ISLOGICAL,ISNA,ISNONTEXT,ISNUMBER,ISODD,ISOMITTED,ISREF,ISTEXT,ISO.CEILING,ISOWEEKNUM,ISPMT,JIS,KURT,LAMBDA,LARGE,LCM,LEFT,LEFTB,LEN,LENB,LET,LINEST,LN,LOG,LOG10,LOGEST,LOGINV,LOGNORM.DIST,LOGNORMDIST,LOGNORM.INV,LOOKUP,LOWER,MAKEARRAY,MAP,MATCH,MAX,MAXA,MAXIFS,MDETERM,MDURATION,MEDIAN,MID,MIDB,MIN,MINIFS,MINA,MINUTE,MINVERSE,MIRR,MMULT,MOD,MODE,MODE.MULT,MODE.SNGL,MONTH,MROUND,MULTINOMIAL,MUNIT,N,NA,NEGBINOM.DIST,NEGBINOMDIST,NETWORKDAYS,NETWORKDAYS.INTL,NOMINAL,NORM.DIST,NORMDIST,NORMINV,NORM.INV,NORM.S.DIST,NORMSDIST,NORM.S.INV,NORMSINV,NOT,NOW,NPER,NPV,NUMBERVALUE,OCT2BIN,OCT2DEC,OCT2HEX,ODD,ODDFPRICE,ODDFYIELD,ODDLPRICE,ODDLYIELD,OFFSET,OR,PDURATION,PEARSON,PERCENTILE.EXC,PERCENTILE.INC,PERCENTILE,PERCENTRANK.EXC,PERCENTRANK.INC,PERCENTRANK,PERMUT,PERMUTATIONA,PHI,PHONETIC,PI,PMT,POISSON.DIST,POISSON,POWER,PPMT,PRICE,PRICEDISC,PRICEMAT,PROB,PRODUCT,PROPER,PV,QUARTILE,QUARTILE.EXC,QUARTILE.INC,QUOTIENT,RADIANS,RAND,RANDARRAY,RANDBETWEEN,RANK.AVG,RANK.EQ,RANK,RATE,RECEIVED,REDUCE,REGISTER.ID,REPLACE,REPLACEB,REPT,RIGHT,RIGHTB,ROMAN,ROUND,ROUNDDOWN,ROUNDUP,ROW,ROWS,RRI,RSQ,RTD,SCAN,SEARCH,SEARCHB,SEC,SECH,SECOND,SEQUENCE,SERIESSUM,SHEET,SHEETS,SIGN,SIN,SINH,SKEW,SKEW.P,SLN,SLOPE,SMALL,SORT,SORTBY,SQRT,SQRTPI,SQL.REQUEST,STANDARDIZE,STOCKHISTORY,STDEV,STDEV.P,STDEV.S,STDEVA,STDEVP,STDEVPA,STEYX,SUBSTITUTE,SUBTOTAL,SUM,SUMIF,SUMIFS,SUMPRODUCT,SUMSQ,SUMX2MY2,SUMX2PY2,SUMXMY2,SWITCH,SYD,T,TAN,TANH,TAKE,TBILLEQ,TBILLPRICE,TBILLYIELD,T.DIST,T.DIST.2T,T.DIST.RT,TDIST,TEXT,TEXTAFTER,TEXTBEFORE,TEXTJOIN,TEXTSPLIT,TIME,TIMEVALUE,T.INV,T.INV.2T,TINV,TOCOL,TOROW,TODAY,TRANSPOSE,TREND,TRIM,TRIMMEAN,TRUE,TRUNC,T.TEST,TTEST,TYPE,UNICHAR,UNICODE,UNIQUE,UPPER,VALUE,VALUETOTEXT,VAR,VAR.P,VAR.S,VARA,VARP,VARPA,VDB,VLOOKUP,VSTACK,WEBSERVICE,WEEKDAY,WEEKNUM,WEIBULL,WEIBULL.DIST,WORKDAY,WORKDAY.INTL,WRAPCOLS,WRAPROWS,XIRR,XLOOKUP,XMATCH,XNPV,XOR,YEAR,YEARFRAC,YIELD,YIELDDISC,YIELDMAT,Z.TEST,ZTEST`.split(
          `,`,
        ),
    },
    contains: [
      {
        begin: /^=/,
        end: /[^=]/,
        returnEnd: !0,
        illegal: /=/,
        relevance: 10,
      },
      {
        className: `symbol`,
        begin: /\b[A-Z]{1,2}\d+\b/,
        end: /[^\d]/,
        excludeEnd: !0,
        relevance: 0,
      },
      {
        className: `symbol`,
        begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
        relevance: 0,
      },
      e.BACKSLASH_ESCAPE,
      e.QUOTE_STRING_MODE,
      {
        className: `number`,
        begin: e.NUMBER_RE + `(%)?`,
        relevance: 0,
      },
      e.COMMENT(/\bN\(/, /\)/, {
        excludeBegin: !0,
        excludeEnd: !0,
        illegal: /\n/,
      }),
    ],
  };
}
function exe(e) {
  let t = e.regex,
    n = `HTTP/([32]|1\\.[01])`,
    r = {
      className: `attribute`,
      begin: t.concat(`^`, /[A-Za-z][A-Za-z0-9-]*/, `(?=\\:\\s)`),
      starts: {
        contains: [
          {
            className: `punctuation`,
            begin: /: /,
            relevance: 0,
            starts: {
              end: `$`,
              relevance: 0,
            },
          },
        ],
      },
    },
    i = [
      r,
      {
        begin: `\\n\\n`,
        starts: {
          subLanguage: [],
          endsWithParent: !0,
        },
      },
    ];
  return {
    name: `HTTP`,
    aliases: [`https`],
    illegal: /\S/,
    contains: [
      {
        begin: `^(?=HTTP/([32]|1\\.[01]) \\d{3})`,
        end: /$/,
        contains: [
          {
            className: `meta`,
            begin: n,
          },
          {
            className: `number`,
            begin: `\\b\\d{3}\\b`,
          },
        ],
        starts: {
          end: /\b\B/,
          illegal: /\S/,
          contains: i,
        },
      },
      {
        begin: `(?=^[A-Z]+ (.*?) HTTP/([32]|1\\.[01])$)`,
        end: /$/,
        contains: [
          {
            className: `string`,
            begin: ` `,
            end: ` `,
            excludeBegin: !0,
            excludeEnd: !0,
          },
          {
            className: `meta`,
            begin: n,
          },
          {
            className: `keyword`,
            begin: `[A-Z]+`,
          },
        ],
        starts: {
          end: /\b\B/,
          illegal: /\S/,
          contains: i,
        },
      },
      e.inherit(r, {
        relevance: 0,
      }),
    ],
  };
}
function txe(e) {
  let t = e.regex,
    n = {
      $pattern: /[\w.\/]+/,
      built_in:
        `action.bindattr.collection.component.concat.debugger.each.each-in.get.hash.if.in.input.link-to.loc.log.lookup.mut.outlet.partial.query-params.render.template.textarea.unbound.unless.view.with.yield`.split(
          `.`,
        ),
    },
    r = {
      $pattern: /[\w.\/]+/,
      literal: [`true`, `false`, `undefined`, `null`],
    },
    i = /""|"[^"]+"/,
    a = /''|'[^']+'/,
    o = /\[\]|\[[^\]]+\]/,
    s = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/,
    c = /(\.|\/)/,
    l = t.either(i, a, o, s),
    u = t.concat(t.optional(/\.|\.\/|\//), l, t.anyNumberOfTimes(t.concat(c, l))),
    d = t.concat(`(`, o, `|`, s, `)(?==)`),
    f = {
      begin: u,
    },
    p = e.inherit(f, {
      keywords: r,
    }),
    m = {
      begin: /\(/,
      end: /\)/,
    },
    h = {
      className: `attr`,
      begin: d,
      relevance: 0,
      starts: {
        begin: /=/,
        end: /=/,
        starts: {
          contains: [e.NUMBER_MODE, e.QUOTE_STRING_MODE, e.APOS_STRING_MODE, p, m],
        },
      },
    },
    g = {
      contains: [
        e.NUMBER_MODE,
        e.QUOTE_STRING_MODE,
        e.APOS_STRING_MODE,
        {
          begin: /as\s+\|/,
          keywords: {
            keyword: `as`,
          },
          end: /\|/,
          contains: [
            {
              begin: /\w+/,
            },
          ],
        },
        h,
        p,
        m,
      ],
      returnEnd: !0,
    };
  m.contains = [
    e.inherit(f, {
      className: `name`,
      keywords: n,
      starts: e.inherit(g, {
        end: /\)/,
      }),
    }),
  ];
  let v = e.inherit(f, {
      keywords: n,
      className: `name`,
      starts: e.inherit(g, {
        end: /\}\}/,
      }),
    }),
    y = e.inherit(f, {
      keywords: n,
      className: `name`,
    }),
    b = e.inherit(f, {
      className: `name`,
      keywords: n,
      starts: e.inherit(g, {
        end: /\}\}/,
      }),
    });
  return {
    name: `Handlebars`,
    aliases: [`hbs`, `html.hbs`, `html.handlebars`, `htmlbars`],
    case_insensitive: !0,
    subLanguage: `xml`,
    contains: [
      {
        begin: /\\\{\{/,
        skip: !0,
      },
      {
        begin: /\\\\(?=\{\{)/,
        skip: !0,
      },
      e.COMMENT(/\{\{!--/, /--\}\}/),
      e.COMMENT(/\{\{!/, /\}\}/),
      {
        className: `template-tag`,
        begin: /\{\{\{\{(?!\/)/,
        end: /\}\}\}\}/,
        contains: [v],
        starts: {
          end: /\{\{\{\{\//,
          returnEnd: !0,
          subLanguage: `xml`,
        },
      },
      {
        className: `template-tag`,
        begin: /\{\{\{\{\//,
        end: /\}\}\}\}/,
        contains: [y],
      },
      {
        className: `template-tag`,
        begin: /\{\{#/,
        end: /\}\}/,
        contains: [v],
      },
      {
        className: `template-tag`,
        begin: /\{\{(?=else\}\})/,
        end: /\}\}/,
        keywords: `else`,
      },
      {
        className: `template-tag`,
        begin: /\{\{(?=else if)/,
        end: /\}\}/,
        keywords: `else if`,
      },
      {
        className: `template-tag`,
        begin: /\{\{\//,
        end: /\}\}/,
        contains: [y],
      },
      {
        className: `template-variable`,
        begin: /\{\{\{/,
        end: /\}\}\}/,
        contains: [b],
      },
      {
        className: `template-variable`,
        begin: /\{\{/,
        end: /\}\}/,
        contains: [b],
      },
    ],
  };
}
function nxe(e) {
  let t = {
      className: `attr`,
      begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
      relevance: 1.01,
    },
    n = {
      match: /[{}[\],:]/,
      className: `punctuation`,
      relevance: 0,
    },
    r = [`true`, `false`, `null`],
    i = {
      scope: `literal`,
      beginKeywords: r.join(` `),
    };
  return {
    name: `JSON`,
    aliases: [`jsonc`],
    keywords: {
      literal: r,
    },
    contains: [
      t,
      n,
      e.QUOTE_STRING_MODE,
      i,
      e.C_NUMBER_MODE,
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
    ],
    illegal: `\\S`,
  };
}
var V9 = `[A-Za-z$_][0-9A-Za-z$_]*`,
  rxe =
    `as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using`.split(
      `.`,
    ),
  ixe = [`true`, `false`, `null`, `undefined`, `NaN`, `Infinity`],
  H9 =
    `Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly`.split(
      `.`,
    ),
  U9 = [
    `Error`,
    `EvalError`,
    `InternalError`,
    `RangeError`,
    `ReferenceError`,
    `SyntaxError`,
    `TypeError`,
    `URIError`,
  ],
  W9 = [
    `setInterval`,
    `setTimeout`,
    `clearInterval`,
    `clearTimeout`,
    `require`,
    `exports`,
    `eval`,
    `isFinite`,
    `isNaN`,
    `parseFloat`,
    `parseInt`,
    `decodeURI`,
    `decodeURIComponent`,
    `encodeURI`,
    `encodeURIComponent`,
    `escape`,
    `unescape`,
  ],
  axe = [
    `arguments`,
    `this`,
    `super`,
    `console`,
    `window`,
    `document`,
    `localStorage`,
    `sessionStorage`,
    `module`,
    `global`,
  ],
  oxe = [].concat(W9, H9, U9);
function sxe(e) {
  let t = e.regex,
    n = (e, { after: t }) => {
      let n = `</` + e[0].slice(1);
      return e.input.indexOf(n, t) !== -1;
    },
    r = V9,
    i = {
      begin: `<>`,
      end: `</>`,
    },
    a = /<[A-Za-z0-9\\._:-]+\s*\/>/,
    o = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      isTrulyOpeningTag: (e, t) => {
        let r = e[0].length + e.index,
          i = e.input[r];
        if (i === `<` || i === `,`) {
          t.ignoreMatch();
          return;
        }
        i === `>` &&
          (n(e, {
            after: r,
          }) ||
            t.ignoreMatch());
        let a,
          o = e.input.substring(r);
        if ((a = o.match(/^\s*=/))) {
          t.ignoreMatch();
          return;
        }
        if ((a = o.match(/^\s+extends\s+/)) && a.index === 0) {
          t.ignoreMatch();
          return;
        }
      },
    },
    s = {
      $pattern: V9,
      keyword: rxe,
      literal: ixe,
      built_in: oxe,
      "variable.language": axe,
    },
    c = `[0-9](_?[0-9])*`,
    l = `\\.(${c})`,
    u = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`,
    d = {
      className: `number`,
      variants: [
        {
          begin: `(\\b(${u})((${l})|\\.)?|(${l}))[eE][+-]?(${c})\\b`,
        },
        {
          begin: `\\b(${u})\\b((${l})\\b|\\.)?|(${l})\\b`,
        },
        {
          begin: `\\b(0|[1-9](_?[0-9])*)n\\b`,
        },
        {
          begin: `\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b`,
        },
        {
          begin: `\\b0[bB][0-1](_?[0-1])*n?\\b`,
        },
        {
          begin: `\\b0[oO][0-7](_?[0-7])*n?\\b`,
        },
        {
          begin: `\\b0[0-7]+n?\\b`,
        },
      ],
      relevance: 0,
    },
    f = {
      className: `subst`,
      begin: `\\$\\{`,
      end: `\\}`,
      keywords: s,
      contains: [],
    },
    p = {
      begin: ".?html`",
      end: ``,
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [e.BACKSLASH_ESCAPE, f],
        subLanguage: `xml`,
      },
    },
    m = {
      begin: ".?css`",
      end: ``,
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [e.BACKSLASH_ESCAPE, f],
        subLanguage: `css`,
      },
    },
    h = {
      begin: ".?gql`",
      end: ``,
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [e.BACKSLASH_ESCAPE, f],
        subLanguage: `graphql`,
      },
    },
    g = {
      className: `string`,
      begin: "`",
      end: "`",
      contains: [e.BACKSLASH_ESCAPE, f],
    },
    v = {
      className: `comment`,
      variants: [
        e.COMMENT(/\/\*\*(?!\/)/, `\\*/`, {
          relevance: 0,
          contains: [
            {
              begin: `(?=@[A-Za-z]+)`,
              relevance: 0,
              contains: [
                {
                  className: `doctag`,
                  begin: `@[A-Za-z]+`,
                },
                {
                  className: `type`,
                  begin: `\\{`,
                  end: `\\}`,
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0,
                },
                {
                  className: `variable`,
                  begin: `[A-Za-z$_][0-9A-Za-z$_]*(?=\\s*(-)|$)`,
                  endsParent: !0,
                  relevance: 0,
                },
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0,
                },
              ],
            },
          ],
        }),
        e.C_BLOCK_COMMENT_MODE,
        e.C_LINE_COMMENT_MODE,
      ],
    },
    y = [
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      p,
      m,
      h,
      g,
      {
        match: /\$\d+/,
      },
      d,
    ];
  f.contains = y.concat({
    begin: /\{/,
    end: /\}/,
    keywords: s,
    contains: [`self`].concat(y),
  });
  let b = [].concat(v, f.contains),
    x = b.concat([
      {
        begin: /(\s*)\(/,
        end: /\)/,
        keywords: s,
        contains: [`self`].concat(b),
      },
    ]),
    S = {
      className: `params`,
      begin: /(\s*)\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      keywords: s,
      contains: x,
    },
    C = {
      variants: [
        {
          match: [
            /class/,
            /\s+/,
            r,
            /\s+/,
            /extends/,
            /\s+/,
            t.concat(r, `(`, t.concat(/\./, r), `)*`),
          ],
          scope: {
            1: `keyword`,
            3: `title.class`,
            5: `keyword`,
            7: `title.class.inherited`,
          },
        },
        {
          match: [/class/, /\s+/, r],
          scope: {
            1: `keyword`,
            3: `title.class`,
          },
        },
      ],
    },
    w = {
      relevance: 0,
      match: t.either(
        /\bJSON/,
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/,
      ),
      className: `title.class`,
      keywords: {
        _: [...H9, ...U9],
      },
    },
    T = {
      label: `use_strict`,
      className: `meta`,
      relevance: 10,
      begin: /^\s*['"]use (strict|asm)['"]/,
    },
    E = {
      variants: [
        {
          match: [/function/, /\s+/, r, /(?=\s*\()/],
        },
        {
          match: [/function/, /\s*(?=\()/],
        },
      ],
      className: {
        1: `keyword`,
        3: `title.function`,
      },
      label: `func.def`,
      contains: [S],
      illegal: /%/,
    },
    D = {
      relevance: 0,
      match: /\b[A-Z][A-Z_0-9]+\b/,
      className: `variable.constant`,
    };
  function ee(e) {
    return t.concat(`(?!`, e.join(`|`), `)`);
  }
  let te = {
      match: t.concat(
        /\b/,
        ee([...W9, `super`, `import`].map((e) => `${e}\\s*\\(`)),
        r,
        t.lookahead(/\s*\(/),
      ),
      className: `title.function`,
      relevance: 0,
    },
    O = {
      begin: t.concat(/\./, t.lookahead(t.concat(r, /(?![0-9A-Za-z$_(])/))),
      end: r,
      excludeBegin: !0,
      keywords: `prototype`,
      className: `property`,
      relevance: 0,
    },
    k = {
      match: [/get|set/, /\s+/, r, /(?=\()/],
      className: {
        1: `keyword`,
        3: `title.function`,
      },
      contains: [
        {
          begin: /\(\)/,
        },
        S,
      ],
    },
    ne =
      `(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|` +
      e.UNDERSCORE_IDENT_RE +
      `)\\s*=>`,
    re = {
      match: [/const|var|let/, /\s+/, r, /\s*/, /=\s*/, /(async\s*)?/, t.lookahead(ne)],
      keywords: `async`,
      className: {
        1: `keyword`,
        3: `title.function`,
      },
      contains: [S],
    };
  return {
    name: `JavaScript`,
    aliases: [`js`, `jsx`, `mjs`, `cjs`],
    keywords: s,
    exports: {
      PARAMS_CONTAINS: x,
      CLASS_REFERENCE: w,
    },
    illegal: /#(?![$_A-z])/,
    contains: [
      e.SHEBANG({
        label: `shebang`,
        binary: `node`,
        relevance: 5,
      }),
      T,
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      p,
      m,
      h,
      g,
      v,
      {
        match: /\$\d+/,
      },
      d,
      w,
      {
        scope: `attr`,
        match: r + t.lookahead(`:`),
        relevance: 0,
      },
      re,
      {
        begin: `(` + e.RE_STARTERS_RE + `|\\b(case|return|throw)\\b)\\s*`,
        keywords: `return throw case`,
        relevance: 0,
        contains: [
          v,
          e.REGEXP_MODE,
          {
            className: `function`,
            begin: ne,
            returnBegin: !0,
            end: `\\s*=>`,
            contains: [
              {
                className: `params`,
                variants: [
                  {
                    begin: e.UNDERSCORE_IDENT_RE,
                    relevance: 0,
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0,
                  },
                  {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: s,
                    contains: x,
                  },
                ],
              },
            ],
          },
          {
            begin: /,/,
            relevance: 0,
          },
          {
            match: /\s+/,
            relevance: 0,
          },
          {
            variants: [
              {
                begin: i.begin,
                end: i.end,
              },
              {
                match: a,
              },
              {
                begin: o.begin,
                "on:begin": o.isTrulyOpeningTag,
                end: o.end,
              },
            ],
            subLanguage: `xml`,
            contains: [
              {
                begin: o.begin,
                end: o.end,
                skip: !0,
                contains: [`self`],
              },
            ],
          },
        ],
      },
      E,
      {
        beginKeywords: `while if switch catch for`,
      },
      {
        begin:
          `\\b(?!function)` +
          e.UNDERSCORE_IDENT_RE +
          `\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{`,
        returnBegin: !0,
        label: `func.def`,
        contains: [
          S,
          e.inherit(e.TITLE_MODE, {
            begin: r,
            className: `title.function`,
          }),
        ],
      },
      {
        match: /\.\.\./,
        relevance: 0,
      },
      O,
      {
        match: `\\$[A-Za-z$_][0-9A-Za-z$_]*`,
        relevance: 0,
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: {
          1: `title.function`,
        },
        contains: [S],
      },
      te,
      D,
      C,
      k,
      {
        match: /\$[(.]/,
      },
    ],
  };
}
function cxe(e) {
  let t = e.regex,
    n = {
      begin: /<\/?[A-Za-z_]/,
      end: `>`,
      subLanguage: `xml`,
      relevance: 0,
    },
    r = {
      begin: `^[-\\*]{3,}`,
      end: `$`,
    },
    i = {
      className: `code`,
      variants: [
        {
          begin: "(`{3,})[^`](.|\\n)*?\\1`*[ ]*",
        },
        {
          begin: `(~{3,})[^~](.|\\n)*?\\1~*[ ]*`,
        },
        {
          begin: "```",
          end: "```+[ ]*$",
        },
        {
          begin: `~~~`,
          end: `~~~+[ ]*$`,
        },
        {
          begin: "`.+?`",
        },
        {
          begin: `(?=^( {4}|\\t))`,
          contains: [
            {
              begin: `^( {4}|\\t)`,
              end: `(\\n)$`,
            },
          ],
          relevance: 0,
        },
      ],
    },
    a = {
      className: `bullet`,
      begin: `^[ 	]*([*+-]|(\\d+\\.))(?=\\s+)`,
      end: `\\s+`,
      excludeEnd: !0,
    },
    o = {
      begin: /^\[[^\n]+\]:/,
      returnBegin: !0,
      contains: [
        {
          className: `symbol`,
          begin: /\[/,
          end: /\]/,
          excludeBegin: !0,
          excludeEnd: !0,
        },
        {
          className: `link`,
          begin: /:\s*/,
          end: /$/,
          excludeBegin: !0,
        },
      ],
    },
    s = {
      variants: [
        {
          begin: /\[.+?\]\[.*?\]/,
          relevance: 0,
        },
        {
          begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
          relevance: 2,
        },
        {
          begin: t.concat(/\[.+?\]\(/, /[A-Za-z][A-Za-z0-9+.-]*/, /:\/\/.*?\)/),
          relevance: 2,
        },
        {
          begin: /\[.+?\]\([./?&#].*?\)/,
          relevance: 1,
        },
        {
          begin: /\[.*?\]\(.*?\)/,
          relevance: 0,
        },
      ],
      returnBegin: !0,
      contains: [
        {
          match: /\[(?=\])/,
        },
        {
          className: `string`,
          relevance: 0,
          begin: `\\[`,
          end: `\\]`,
          excludeBegin: !0,
          returnEnd: !0,
        },
        {
          className: `link`,
          relevance: 0,
          begin: `\\]\\(`,
          end: `\\)`,
          excludeBegin: !0,
          excludeEnd: !0,
        },
        {
          className: `symbol`,
          relevance: 0,
          begin: `\\]\\[`,
          end: `\\]`,
          excludeBegin: !0,
          excludeEnd: !0,
        },
      ],
    },
    c = {
      className: `strong`,
      contains: [],
      variants: [
        {
          begin: /_{2}(?!\s)/,
          end: /_{2}/,
        },
        {
          begin: /\*{2}(?!\s)/,
          end: /\*{2}/,
        },
      ],
    },
    l = {
      className: `emphasis`,
      contains: [],
      variants: [
        {
          begin: /\*(?![*\s])/,
          end: /\*/,
        },
        {
          begin: /_(?![_\s])/,
          end: /_/,
          relevance: 0,
        },
      ],
    },
    u = e.inherit(c, {
      contains: [],
    }),
    d = e.inherit(l, {
      contains: [],
    });
  (c.contains.push(d), l.contains.push(u));
  let f = [n, s];
  return (
    [c, l, u, d].forEach((e) => {
      e.contains = e.contains.concat(f);
    }),
    (f = f.concat(c, l)),
    {
      name: `Markdown`,
      aliases: [`md`, `mkdown`, `mkd`],
      contains: [
        {
          className: `section`,
          variants: [
            {
              begin: `^#{1,6}`,
              end: `$`,
              contains: f,
            },
            {
              begin: `(?=^.+?\\n[=-]{2,}$)`,
              contains: [
                {
                  begin: `^[=-]*$`,
                },
                {
                  begin: `^`,
                  end: `\\n`,
                  contains: f,
                },
              ],
            },
          ],
        },
        n,
        a,
        c,
        l,
        {
          className: `quote`,
          begin: `^>\\s+`,
          contains: f,
          end: `$`,
        },
        i,
        r,
        s,
        o,
        {
          scope: `literal`,
          match: /&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/,
        },
      ],
    }
  );
}
function lxe(e) {
  let t = e.regex,
    n = {
      className: `variable`,
      variants: [
        {
          begin: /\$\d+/,
        },
        {
          begin: /\$\{\w+\}/,
        },
        {
          begin: t.concat(/[$@]/, e.UNDERSCORE_IDENT_RE),
        },
      ],
    },
    r = {
      endsWithParent: !0,
      keywords: {
        $pattern: /[a-z_]{2,}|\/dev\/poll/,
        literal: [
          `on`,
          `off`,
          `yes`,
          `no`,
          `true`,
          `false`,
          `none`,
          `blocked`,
          `debug`,
          `info`,
          `notice`,
          `warn`,
          `error`,
          `crit`,
          `select`,
          `break`,
          `last`,
          `permanent`,
          `redirect`,
          `kqueue`,
          `rtsig`,
          `epoll`,
          `poll`,
          `/dev/poll`,
        ],
      },
      relevance: 0,
      illegal: `=>`,
      contains: [
        e.HASH_COMMENT_MODE,
        {
          className: `string`,
          contains: [e.BACKSLASH_ESCAPE, n],
          variants: [
            {
              begin: /"/,
              end: /"/,
            },
            {
              begin: /'/,
              end: /'/,
            },
          ],
        },
        {
          begin: `([a-z]+):/`,
          end: `\\s`,
          endsWithParent: !0,
          excludeEnd: !0,
          contains: [n],
        },
        {
          className: `regexp`,
          contains: [e.BACKSLASH_ESCAPE, n],
          variants: [
            {
              begin: `\\s\\^`,
              end: `\\s|\\{|;`,
              returnEnd: !0,
            },
            {
              begin: `~\\*?\\s+`,
              end: `\\s|\\{|;`,
              returnEnd: !0,
            },
            {
              begin: `\\*(\\.[a-z\\-]+)+`,
            },
            {
              begin: `([a-z\\-]+\\.)+\\*`,
            },
          ],
        },
        {
          className: `number`,
          begin: `\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b`,
        },
        {
          className: `number`,
          begin: `\\b\\d+[kKmMgGdshdwy]?\\b`,
          relevance: 0,
        },
        n,
      ],
    };
  return {
    name: `Nginx config`,
    aliases: [`nginxconf`],
    contains: [
      e.HASH_COMMENT_MODE,
      {
        beginKeywords: `upstream location`,
        end: /;|\{/,
        contains: r.contains,
        keywords: {
          section: `upstream location`,
        },
      },
      {
        className: `section`,
        begin: t.concat(e.UNDERSCORE_IDENT_RE + t.lookahead(/\s+\{/)),
        relevance: 0,
      },
      {
        begin: t.lookahead(e.UNDERSCORE_IDENT_RE + `\\s`),
        end: `;|\\{`,
        contains: [
          {
            className: `attribute`,
            begin: e.UNDERSCORE_IDENT_RE,
            starts: r,
          },
        ],
        relevance: 0,
      },
    ],
    illegal: `[^\\s\\}\\{]`,
  };
}
function uxe(e) {
  let t = e.regex,
    n = /(?![A-Za-z0-9])(?![$])/,
    r = t.concat(/[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/, n),
    i = t.concat(/(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/, n),
    a = t.concat(/[A-Z]+/, n),
    o = {
      scope: `variable`,
      match: `\\$+` + r,
    },
    s = {
      scope: `meta`,
      variants: [
        {
          begin: /<\?php/,
          relevance: 10,
        },
        {
          begin: /<\?=/,
        },
        {
          begin: /<\?/,
          relevance: 0.1,
        },
        {
          begin: /\?>/,
        },
      ],
    },
    c = {
      scope: `subst`,
      variants: [
        {
          begin: /\$\w+/,
        },
        {
          begin: /\{\$/,
          end: /\}/,
        },
      ],
    },
    l = e.inherit(e.APOS_STRING_MODE, {
      illegal: null,
    }),
    u = e.inherit(e.QUOTE_STRING_MODE, {
      illegal: null,
      contains: e.QUOTE_STRING_MODE.contains.concat(c),
    }),
    d = {
      begin: /<<<[ \t]*(?:(\w+)|"(\w+)")\n/,
      end: /[ \t]*(\w+)\b/,
      contains: e.QUOTE_STRING_MODE.contains.concat(c),
      "on:begin": (e, t) => {
        t.data._beginMatch = e[1] || e[2];
      },
      "on:end": (e, t) => {
        t.data._beginMatch !== e[1] && t.ignoreMatch();
      },
    },
    f = e.END_SAME_AS_BEGIN({
      begin: /<<<[ \t]*'(\w+)'\n/,
      end: /[ \t]*(\w+)\b/,
    }),
    p = `[ 	
]`,
    m = {
      scope: `string`,
      variants: [u, l, d, f],
    },
    h = {
      scope: `number`,
      variants: [
        {
          begin: `\\b0[bB][01]+(?:_[01]+)*\\b`,
        },
        {
          begin: `\\b0[oO][0-7]+(?:_[0-7]+)*\\b`,
        },
        {
          begin: `\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b`,
        },
        {
          begin: `(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?`,
        },
      ],
      relevance: 0,
    },
    g = [`false`, `null`, `true`],
    v =
      `__CLASS__.__DIR__.__FILE__.__FUNCTION__.__COMPILER_HALT_OFFSET__.__LINE__.__METHOD__.__NAMESPACE__.__TRAIT__.die.echo.exit.include.include_once.print.require.require_once.array.abstract.and.as.binary.bool.boolean.break.callable.case.catch.class.clone.const.continue.declare.default.do.double.else.elseif.empty.enddeclare.endfor.endforeach.endif.endswitch.endwhile.enum.eval.extends.final.finally.float.for.foreach.from.global.goto.if.implements.instanceof.insteadof.int.integer.interface.isset.iterable.list.match|0.mixed.new.never.object.or.private.protected.public.readonly.real.return.string.switch.throw.trait.try.unset.use.var.void.while.xor.yield`.split(
        `.`,
      ),
    y =
      `Error|0.AppendIterator.ArgumentCountError.ArithmeticError.ArrayIterator.ArrayObject.AssertionError.BadFunctionCallException.BadMethodCallException.CachingIterator.CallbackFilterIterator.CompileError.Countable.DirectoryIterator.DivisionByZeroError.DomainException.EmptyIterator.ErrorException.Exception.FilesystemIterator.FilterIterator.GlobIterator.InfiniteIterator.InvalidArgumentException.IteratorIterator.LengthException.LimitIterator.LogicException.MultipleIterator.NoRewindIterator.OutOfBoundsException.OutOfRangeException.OuterIterator.OverflowException.ParentIterator.ParseError.RangeException.RecursiveArrayIterator.RecursiveCachingIterator.RecursiveCallbackFilterIterator.RecursiveDirectoryIterator.RecursiveFilterIterator.RecursiveIterator.RecursiveIteratorIterator.RecursiveRegexIterator.RecursiveTreeIterator.RegexIterator.RuntimeException.SeekableIterator.SplDoublyLinkedList.SplFileInfo.SplFileObject.SplFixedArray.SplHeap.SplMaxHeap.SplMinHeap.SplObjectStorage.SplObserver.SplPriorityQueue.SplQueue.SplStack.SplSubject.SplTempFileObject.TypeError.UnderflowException.UnexpectedValueException.UnhandledMatchError.ArrayAccess.BackedEnum.Closure.Fiber.Generator.Iterator.IteratorAggregate.Serializable.Stringable.Throwable.Traversable.UnitEnum.WeakReference.WeakMap.Directory.__PHP_Incomplete_Class.parent.php_user_filter.self.static.stdClass`.split(
        `.`,
      ),
    b = {
      keyword: v,
      literal: ((e) => {
        let t = [];
        return (
          e.forEach((e) => {
            (t.push(e), e.toLowerCase() === e ? t.push(e.toUpperCase()) : t.push(e.toLowerCase()));
          }),
          t
        );
      })(g),
      built_in: y,
    },
    x = (e) => e.map((e) => e.replace(/\|\d+$/, ``)),
    S = {
      variants: [
        {
          match: [/new/, t.concat(p, `+`), t.concat(`(?!`, x(y).join(`\\b|`), `\\b)`), i],
          scope: {
            1: `keyword`,
            4: `title.class`,
          },
        },
      ],
    },
    C = t.concat(r, `\\b(?!\\()`),
    w = {
      variants: [
        {
          match: [t.concat(/::/, t.lookahead(/(?!class\b)/)), C],
          scope: {
            2: `variable.constant`,
          },
        },
        {
          match: [/::/, /class/],
          scope: {
            2: `variable.language`,
          },
        },
        {
          match: [i, t.concat(/::/, t.lookahead(/(?!class\b)/)), C],
          scope: {
            1: `title.class`,
            3: `variable.constant`,
          },
        },
        {
          match: [i, t.concat(`::`, t.lookahead(/(?!class\b)/))],
          scope: {
            1: `title.class`,
          },
        },
        {
          match: [i, /::/, /class/],
          scope: {
            1: `title.class`,
            3: `variable.language`,
          },
        },
      ],
    },
    T = {
      scope: `attr`,
      match: t.concat(r, t.lookahead(`:`), t.lookahead(/(?!::)/)),
    },
    E = {
      relevance: 0,
      begin: /\(/,
      end: /\)/,
      keywords: b,
      contains: [T, o, w, e.C_BLOCK_COMMENT_MODE, m, h, S],
    },
    D = {
      relevance: 0,
      match: [
        /\b/,
        t.concat(`(?!fn\\b|function\\b|`, x(v).join(`\\b|`), `|`, x(y).join(`\\b|`), `\\b)`),
        r,
        t.concat(p, `*`),
        t.lookahead(/(?=\()/),
      ],
      scope: {
        3: `title.function.invoke`,
      },
      contains: [E],
    };
  E.contains.push(D);
  let ee = [T, w, e.C_BLOCK_COMMENT_MODE, m, h, S],
    te = {
      begin: t.concat(/#\[\s*\\?/, t.either(i, a)),
      beginScope: `meta`,
      end: /]/,
      endScope: `meta`,
      keywords: {
        literal: g,
        keyword: [`new`, `array`],
      },
      contains: [
        {
          begin: /\[/,
          end: /]/,
          keywords: {
            literal: g,
            keyword: [`new`, `array`],
          },
          contains: [`self`, ...ee],
        },
        ...ee,
        {
          scope: `meta`,
          variants: [
            {
              match: i,
            },
            {
              match: a,
            },
          ],
        },
      ],
    };
  return {
    case_insensitive: !1,
    keywords: b,
    contains: [
      te,
      e.HASH_COMMENT_MODE,
      e.COMMENT(`//`, `$`),
      e.COMMENT(`/\\*`, `\\*/`, {
        contains: [
          {
            scope: `doctag`,
            match: `@[A-Za-z]+`,
          },
        ],
      }),
      {
        match: /__halt_compiler\(\);/,
        keywords: `__halt_compiler`,
        starts: {
          scope: `comment`,
          end: e.MATCH_NOTHING_RE,
          contains: [
            {
              match: /\?>/,
              scope: `meta`,
              endsParent: !0,
            },
          ],
        },
      },
      s,
      {
        scope: `variable.language`,
        match: /\$this\b/,
      },
      o,
      D,
      w,
      {
        match: [/const/, /\s/, r],
        scope: {
          1: `keyword`,
          3: `variable.constant`,
        },
      },
      S,
      {
        scope: `function`,
        relevance: 0,
        beginKeywords: `fn function`,
        end: /[;{]/,
        excludeEnd: !0,
        illegal: `[$%\\[]`,
        contains: [
          {
            beginKeywords: `use`,
          },
          e.UNDERSCORE_TITLE_MODE,
          {
            begin: `=>`,
            endsParent: !0,
          },
          {
            scope: `params`,
            begin: `\\(`,
            end: `\\)`,
            excludeBegin: !0,
            excludeEnd: !0,
            keywords: b,
            contains: [`self`, te, o, w, e.C_BLOCK_COMMENT_MODE, m, h],
          },
        ],
      },
      {
        scope: `class`,
        variants: [
          {
            beginKeywords: `enum`,
            illegal: /[($"]/,
          },
          {
            beginKeywords: `class interface trait`,
            illegal: /[:($"]/,
          },
        ],
        relevance: 0,
        end: /\{/,
        excludeEnd: !0,
        contains: [
          {
            beginKeywords: `extends implements`,
          },
          e.UNDERSCORE_TITLE_MODE,
        ],
      },
      {
        beginKeywords: `namespace`,
        relevance: 0,
        end: `;`,
        illegal: /[.']/,
        contains: [
          e.inherit(e.UNDERSCORE_TITLE_MODE, {
            scope: `title.class`,
          }),
        ],
      },
      {
        beginKeywords: `use`,
        relevance: 0,
        end: `;`,
        contains: [
          {
            match: /\b(as|const|function)\b/,
            scope: `keyword`,
          },
          e.UNDERSCORE_TITLE_MODE,
        ],
      },
      m,
      h,
    ],
  };
}
function dxe(e) {
  let t = e.regex,
    n = /[\p{XID_Start}_]\p{XID_Continue}*/u,
    r =
      `and.as.assert.async.await.break.case.class.continue.def.del.elif.else.except.finally.for.from.global.if.import.in.is.lambda.match.nonlocal|10.not.or.pass.raise.return.try.while.with.yield`.split(
        `.`,
      ),
    i = {
      $pattern: /[A-Za-z]\w+|__\w+__/,
      keyword: r,
      built_in:
        `__import__.abs.all.any.ascii.bin.bool.breakpoint.bytearray.bytes.callable.chr.classmethod.compile.complex.delattr.dict.dir.divmod.enumerate.eval.exec.filter.float.format.frozenset.getattr.globals.hasattr.hash.help.hex.id.input.int.isinstance.issubclass.iter.len.list.locals.map.max.memoryview.min.next.object.oct.open.ord.pow.print.property.range.repr.reversed.round.set.setattr.slice.sorted.staticmethod.str.sum.super.tuple.type.vars.zip`.split(
          `.`,
        ),
      literal: [`__debug__`, `Ellipsis`, `False`, `None`, `NotImplemented`, `True`],
      type: [
        `Any`,
        `Callable`,
        `Coroutine`,
        `Dict`,
        `List`,
        `Literal`,
        `Generic`,
        `Optional`,
        `Sequence`,
        `Set`,
        `Tuple`,
        `Type`,
        `Union`,
      ],
    },
    a = {
      className: `meta`,
      begin: /^(>>>|\.\.\.) /,
    },
    o = {
      className: `subst`,
      begin: /\{/,
      end: /\}/,
      keywords: i,
      illegal: /#/,
    },
    s = {
      begin: /\{\{/,
      relevance: 0,
    },
    c = {
      className: `string`,
      contains: [e.BACKSLASH_ESCAPE],
      variants: [
        {
          begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
          end: /'''/,
          contains: [e.BACKSLASH_ESCAPE, a],
          relevance: 10,
        },
        {
          begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
          end: /"""/,
          contains: [e.BACKSLASH_ESCAPE, a],
          relevance: 10,
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])'''/,
          end: /'''/,
          contains: [e.BACKSLASH_ESCAPE, a, s, o],
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])"""/,
          end: /"""/,
          contains: [e.BACKSLASH_ESCAPE, a, s, o],
        },
        {
          begin: /([uU]|[rR])'/,
          end: /'/,
          relevance: 10,
        },
        {
          begin: /([uU]|[rR])"/,
          end: /"/,
          relevance: 10,
        },
        {
          begin: /([bB]|[bB][rR]|[rR][bB])'/,
          end: /'/,
        },
        {
          begin: /([bB]|[bB][rR]|[rR][bB])"/,
          end: /"/,
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])'/,
          end: /'/,
          contains: [e.BACKSLASH_ESCAPE, s, o],
        },
        {
          begin: /([fF][rR]|[rR][fF]|[fF])"/,
          end: /"/,
          contains: [e.BACKSLASH_ESCAPE, s, o],
        },
        e.APOS_STRING_MODE,
        e.QUOTE_STRING_MODE,
      ],
    },
    l = `[0-9](_?[0-9])*`,
    u = `(\\b(${l}))?\\.(${l})|\\b(${l})\\.`,
    d = `\\b|${r.join(`|`)}`,
    f = {
      className: `number`,
      relevance: 0,
      variants: [
        {
          begin: `(\\b(${l})|(${u}))[eE][+-]?(${l})[jJ]?(?=${d})`,
        },
        {
          begin: `(${u})[jJ]?`,
        },
        {
          begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${d})`,
        },
        {
          begin: `\\b0[bB](_?[01])+[lL]?(?=${d})`,
        },
        {
          begin: `\\b0[oO](_?[0-7])+[lL]?(?=${d})`,
        },
        {
          begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${d})`,
        },
        {
          begin: `\\b(${l})[jJ](?=${d})`,
        },
      ],
    },
    p = {
      className: `comment`,
      begin: t.lookahead(/# type:/),
      end: /$/,
      keywords: i,
      contains: [
        {
          begin: /# type:/,
        },
        {
          begin: /#/,
          end: /\b\B/,
          endsWithParent: !0,
        },
      ],
    },
    m = {
      className: `params`,
      variants: [
        {
          className: ``,
          begin: /\(\s*\)/,
          skip: !0,
        },
        {
          begin: /\(/,
          end: /\)/,
          excludeBegin: !0,
          excludeEnd: !0,
          keywords: i,
          contains: [`self`, a, f, c, e.HASH_COMMENT_MODE],
        },
      ],
    };
  return (
    (o.contains = [c, f, a]),
    {
      name: `Python`,
      aliases: [`py`, `gyp`, `ipython`],
      unicodeRegex: !0,
      keywords: i,
      illegal: /(<\/|\?)|=>/,
      contains: [
        a,
        f,
        {
          scope: `variable.language`,
          match: /\bself\b/,
        },
        {
          beginKeywords: `if`,
          relevance: 0,
        },
        {
          match: /\bor\b/,
          scope: `keyword`,
        },
        c,
        p,
        e.HASH_COMMENT_MODE,
        {
          match: [/\bdef/, /\s+/, n],
          scope: {
            1: `keyword`,
            3: `title.function`,
          },
          contains: [m],
        },
        {
          variants: [
            {
              match: [/\bclass/, /\s+/, n, /\s*/, /\(\s*/, n, /\s*\)/],
            },
            {
              match: [/\bclass/, /\s+/, n],
            },
          ],
          scope: {
            1: `keyword`,
            3: `title.class`,
            6: `title.class.inherited`,
          },
        },
        {
          className: `meta`,
          begin: /^[\t ]*@/,
          end: /(?=#)|$/,
          contains: [f, m, c],
        },
      ],
    }
  );
}
var fxe = (e) => ({
    IMPORTANT: {
      scope: `meta`,
      begin: `!important`,
    },
    BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
    HEXCOLOR: {
      scope: `number`,
      begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/,
    },
    FUNCTION_DISPATCH: {
      className: `built_in`,
      begin: /[\w-]+(?=\()/,
    },
    ATTRIBUTE_SELECTOR_MODE: {
      scope: `selector-attr`,
      begin: /\[/,
      end: /\]/,
      illegal: `$`,
      contains: [e.APOS_STRING_MODE, e.QUOTE_STRING_MODE],
    },
    CSS_NUMBER_MODE: {
      scope: `number`,
      begin:
        e.NUMBER_RE +
        `(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?`,
      relevance: 0,
    },
    CSS_VARIABLE: {
      className: `attr`,
      begin: /--[A-Za-z_][A-Za-z0-9_-]*/,
    },
  }),
  pxe =
    `a.abbr.address.article.aside.audio.b.blockquote.body.button.canvas.caption.cite.code.dd.del.details.dfn.div.dl.dt.em.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.header.hgroup.html.i.iframe.img.input.ins.kbd.label.legend.li.main.mark.menu.nav.object.ol.optgroup.option.p.picture.q.quote.samp.section.select.source.span.strong.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.tr.ul.var.video`.split(
      `.`,
    ),
  mxe =
    `defs.g.marker.mask.pattern.svg.switch.symbol.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feFlood.feGaussianBlur.feImage.feMerge.feMorphology.feOffset.feSpecularLighting.feTile.feTurbulence.linearGradient.radialGradient.stop.circle.ellipse.image.line.path.polygon.polyline.rect.text.use.textPath.tspan.foreignObject.clipPath`.split(
      `.`,
    ),
  hxe = [...pxe, ...mxe],
  gxe =
    `any-hover.any-pointer.aspect-ratio.color.color-gamut.color-index.device-aspect-ratio.device-height.device-width.display-mode.forced-colors.grid.height.hover.inverted-colors.monochrome.orientation.overflow-block.overflow-inline.pointer.prefers-color-scheme.prefers-contrast.prefers-reduced-motion.prefers-reduced-transparency.resolution.scan.scripting.update.width.min-width.max-width.min-height.max-height`
      .split(`.`)
      .sort()
      .reverse(),
  _xe =
    `active.any-link.blank.checked.current.default.defined.dir.disabled.drop.empty.enabled.first.first-child.first-of-type.fullscreen.future.focus.focus-visible.focus-within.has.host.host-context.hover.indeterminate.in-range.invalid.is.lang.last-child.last-of-type.left.link.local-link.not.nth-child.nth-col.nth-last-child.nth-last-col.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.past.placeholder-shown.read-only.read-write.required.right.root.scope.target.target-within.user-invalid.valid.visited.where`
      .split(`.`)
      .sort()
      .reverse(),
  vxe = [
    `after`,
    `backdrop`,
    `before`,
    `cue`,
    `cue-region`,
    `first-letter`,
    `first-line`,
    `grammar-error`,
    `marker`,
    `part`,
    `placeholder`,
    `selection`,
    `slotted`,
    `spelling-error`,
  ]
    .sort()
    .reverse(),
  yxe =
    `accent-color.align-content.align-items.align-self.alignment-baseline.all.anchor-name.animation.animation-composition.animation-delay.animation-direction.animation-duration.animation-fill-mode.animation-iteration-count.animation-name.animation-play-state.animation-range.animation-range-end.animation-range-start.animation-timeline.animation-timing-function.appearance.aspect-ratio.backdrop-filter.backface-visibility.background.background-attachment.background-blend-mode.background-clip.background-color.background-image.background-origin.background-position.background-position-x.background-position-y.background-repeat.background-size.baseline-shift.block-size.border.border-block.border-block-color.border-block-end.border-block-end-color.border-block-end-style.border-block-end-width.border-block-start.border-block-start-color.border-block-start-style.border-block-start-width.border-block-style.border-block-width.border-bottom.border-bottom-color.border-bottom-left-radius.border-bottom-right-radius.border-bottom-style.border-bottom-width.border-collapse.border-color.border-end-end-radius.border-end-start-radius.border-image.border-image-outset.border-image-repeat.border-image-slice.border-image-source.border-image-width.border-inline.border-inline-color.border-inline-end.border-inline-end-color.border-inline-end-style.border-inline-end-width.border-inline-start.border-inline-start-color.border-inline-start-style.border-inline-start-width.border-inline-style.border-inline-width.border-left.border-left-color.border-left-style.border-left-width.border-radius.border-right.border-right-color.border-right-style.border-right-width.border-spacing.border-start-end-radius.border-start-start-radius.border-style.border-top.border-top-color.border-top-left-radius.border-top-right-radius.border-top-style.border-top-width.border-width.bottom.box-align.box-decoration-break.box-direction.box-flex.box-flex-group.box-lines.box-ordinal-group.box-orient.box-pack.box-shadow.box-sizing.break-after.break-before.break-inside.caption-side.caret-color.clear.clip.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.color-scheme.column-count.column-fill.column-gap.column-rule.column-rule-color.column-rule-style.column-rule-width.column-span.column-width.columns.contain.contain-intrinsic-block-size.contain-intrinsic-height.contain-intrinsic-inline-size.contain-intrinsic-size.contain-intrinsic-width.container.container-name.container-type.content.content-visibility.counter-increment.counter-reset.counter-set.cue.cue-after.cue-before.cursor.cx.cy.direction.display.dominant-baseline.empty-cells.enable-background.field-sizing.fill.fill-opacity.fill-rule.filter.flex.flex-basis.flex-direction.flex-flow.flex-grow.flex-shrink.flex-wrap.float.flood-color.flood-opacity.flow.font.font-display.font-family.font-feature-settings.font-kerning.font-language-override.font-optical-sizing.font-palette.font-size.font-size-adjust.font-smooth.font-smoothing.font-stretch.font-style.font-synthesis.font-synthesis-position.font-synthesis-small-caps.font-synthesis-style.font-synthesis-weight.font-variant.font-variant-alternates.font-variant-caps.font-variant-east-asian.font-variant-emoji.font-variant-ligatures.font-variant-numeric.font-variant-position.font-variation-settings.font-weight.forced-color-adjust.gap.glyph-orientation-horizontal.glyph-orientation-vertical.grid.grid-area.grid-auto-columns.grid-auto-flow.grid-auto-rows.grid-column.grid-column-end.grid-column-start.grid-gap.grid-row.grid-row-end.grid-row-start.grid-template.grid-template-areas.grid-template-columns.grid-template-rows.hanging-punctuation.height.hyphenate-character.hyphenate-limit-chars.hyphens.icon.image-orientation.image-rendering.image-resolution.ime-mode.initial-letter.initial-letter-align.inline-size.inset.inset-area.inset-block.inset-block-end.inset-block-start.inset-inline.inset-inline-end.inset-inline-start.isolation.justify-content.justify-items.justify-self.kerning.left.letter-spacing.lighting-color.line-break.line-height.line-height-step.list-style.list-style-image.list-style-position.list-style-type.margin.margin-block.margin-block-end.margin-block-start.margin-bottom.margin-inline.margin-inline-end.margin-inline-start.margin-left.margin-right.margin-top.margin-trim.marker.marker-end.marker-mid.marker-start.marks.mask.mask-border.mask-border-mode.mask-border-outset.mask-border-repeat.mask-border-slice.mask-border-source.mask-border-width.mask-clip.mask-composite.mask-image.mask-mode.mask-origin.mask-position.mask-repeat.mask-size.mask-type.masonry-auto-flow.math-depth.math-shift.math-style.max-block-size.max-height.max-inline-size.max-width.min-block-size.min-height.min-inline-size.min-width.mix-blend-mode.nav-down.nav-index.nav-left.nav-right.nav-up.none.normal.object-fit.object-position.offset.offset-anchor.offset-distance.offset-path.offset-position.offset-rotate.opacity.order.orphans.outline.outline-color.outline-offset.outline-style.outline-width.overflow.overflow-anchor.overflow-block.overflow-clip-margin.overflow-inline.overflow-wrap.overflow-x.overflow-y.overlay.overscroll-behavior.overscroll-behavior-block.overscroll-behavior-inline.overscroll-behavior-x.overscroll-behavior-y.padding.padding-block.padding-block-end.padding-block-start.padding-bottom.padding-inline.padding-inline-end.padding-inline-start.padding-left.padding-right.padding-top.page.page-break-after.page-break-before.page-break-inside.paint-order.pause.pause-after.pause-before.perspective.perspective-origin.place-content.place-items.place-self.pointer-events.position.position-anchor.position-visibility.print-color-adjust.quotes.r.resize.rest.rest-after.rest-before.right.rotate.row-gap.ruby-align.ruby-position.scale.scroll-behavior.scroll-margin.scroll-margin-block.scroll-margin-block-end.scroll-margin-block-start.scroll-margin-bottom.scroll-margin-inline.scroll-margin-inline-end.scroll-margin-inline-start.scroll-margin-left.scroll-margin-right.scroll-margin-top.scroll-padding.scroll-padding-block.scroll-padding-block-end.scroll-padding-block-start.scroll-padding-bottom.scroll-padding-inline.scroll-padding-inline-end.scroll-padding-inline-start.scroll-padding-left.scroll-padding-right.scroll-padding-top.scroll-snap-align.scroll-snap-stop.scroll-snap-type.scroll-timeline.scroll-timeline-axis.scroll-timeline-name.scrollbar-color.scrollbar-gutter.scrollbar-width.shape-image-threshold.shape-margin.shape-outside.shape-rendering.speak.speak-as.src.stop-color.stop-opacity.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.tab-size.table-layout.text-align.text-align-all.text-align-last.text-anchor.text-combine-upright.text-decoration.text-decoration-color.text-decoration-line.text-decoration-skip.text-decoration-skip-ink.text-decoration-style.text-decoration-thickness.text-emphasis.text-emphasis-color.text-emphasis-position.text-emphasis-style.text-indent.text-justify.text-orientation.text-overflow.text-rendering.text-shadow.text-size-adjust.text-transform.text-underline-offset.text-underline-position.text-wrap.text-wrap-mode.text-wrap-style.timeline-scope.top.touch-action.transform.transform-box.transform-origin.transform-style.transition.transition-behavior.transition-delay.transition-duration.transition-property.transition-timing-function.translate.unicode-bidi.user-modify.user-select.vector-effect.vertical-align.view-timeline.view-timeline-axis.view-timeline-inset.view-timeline-name.view-transition-name.visibility.voice-balance.voice-duration.voice-family.voice-pitch.voice-range.voice-rate.voice-stress.voice-volume.white-space.white-space-collapse.widows.width.will-change.word-break.word-spacing.word-wrap.writing-mode.x.y.z-index.zoom`
      .split(`.`)
      .sort()
      .reverse();
function bxe(e) {
  let t = fxe(e),
    n = vxe,
    r = _xe,
    i = `@[a-z-]+`,
    a = {
      className: `variable`,
      begin: `(\\$[a-zA-Z-][a-zA-Z0-9_-]*)\\b`,
      relevance: 0,
    };
  return {
    name: `SCSS`,
    case_insensitive: !0,
    illegal: `[=/|']`,
    contains: [
      e.C_LINE_COMMENT_MODE,
      e.C_BLOCK_COMMENT_MODE,
      t.CSS_NUMBER_MODE,
      {
        className: `selector-id`,
        begin: `#[A-Za-z0-9_-]+`,
        relevance: 0,
      },
      {
        className: `selector-class`,
        begin: `\\.[A-Za-z0-9_-]+`,
        relevance: 0,
      },
      t.ATTRIBUTE_SELECTOR_MODE,
      {
        className: `selector-tag`,
        begin: `\\b(` + hxe.join(`|`) + `)\\b`,
        relevance: 0,
      },
      {
        className: `selector-pseudo`,
        begin: `:(` + r.join(`|`) + `)`,
      },
      {
        className: `selector-pseudo`,
        begin: `:(:)?(` + n.join(`|`) + `)`,
      },
      a,
      {
        begin: /\(/,
        end: /\)/,
        contains: [t.CSS_NUMBER_MODE],
      },
      t.CSS_VARIABLE,
      {
        className: `attribute`,
        begin: `\\b(` + yxe.join(`|`) + `)\\b`,
      },
      {
        begin: `\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b`,
      },
      {
        begin: /:/,
        end: /[;}{]/,
        relevance: 0,
        contains: [
          t.BLOCK_COMMENT,
          a,
          t.HEXCOLOR,
          t.CSS_NUMBER_MODE,
          e.QUOTE_STRING_MODE,
          e.APOS_STRING_MODE,
          t.IMPORTANT,
          t.FUNCTION_DISPATCH,
        ],
      },
      {
        begin: `@(page|font-face)`,
        keywords: {
          $pattern: i,
          keyword: `@page @font-face`,
        },
      },
      {
        begin: `@`,
        end: `[{;]`,
        returnBegin: !0,
        keywords: {
          $pattern: /[a-z-]+/,
          keyword: `and or not only`,
          attribute: gxe.join(` `),
        },
        contains: [
          {
            begin: i,
            className: `keyword`,
          },
          {
            begin: /[a-z-]+(?=:)/,
            className: `attribute`,
          },
          a,
          e.QUOTE_STRING_MODE,
          e.APOS_STRING_MODE,
          t.HEXCOLOR,
          t.CSS_NUMBER_MODE,
        ],
      },
      t.FUNCTION_DISPATCH,
    ],
  };
}
function xxe(e) {
  let t = e.regex,
    n = e.COMMENT(`--`, `$`),
    r = {
      scope: `string`,
      variants: [
        {
          begin: /'/,
          end: /'/,
          contains: [
            {
              match: /''/,
            },
          ],
        },
      ],
    },
    i = {
      begin: /"/,
      end: /"/,
      contains: [
        {
          match: /""/,
        },
      ],
    },
    a = [`true`, `false`, `unknown`],
    o = [`double precision`, `large object`, `with timezone`, `without timezone`],
    s =
      `bigint.binary.blob.boolean.char.character.clob.date.dec.decfloat.decimal.float.int.integer.interval.nchar.nclob.national.numeric.real.row.smallint.time.timestamp.varchar.varying.varbinary`.split(
        `.`,
      ),
    c = [`add`, `asc`, `collation`, `desc`, `final`, `first`, `last`, `view`],
    l =
      `abs.acos.all.allocate.alter.and.any.are.array.array_agg.array_max_cardinality.as.asensitive.asin.asymmetric.at.atan.atomic.authorization.avg.begin.begin_frame.begin_partition.between.bigint.binary.blob.boolean.both.by.call.called.cardinality.cascaded.case.cast.ceil.ceiling.char.char_length.character.character_length.check.classifier.clob.close.coalesce.collate.collect.column.commit.condition.connect.constraint.contains.convert.copy.corr.corresponding.cos.cosh.count.covar_pop.covar_samp.create.cross.cube.cume_dist.current.current_catalog.current_date.current_default_transform_group.current_path.current_role.current_row.current_schema.current_time.current_timestamp.current_path.current_role.current_transform_group_for_type.current_user.cursor.cycle.date.day.deallocate.dec.decimal.decfloat.declare.default.define.delete.dense_rank.deref.describe.deterministic.disconnect.distinct.double.drop.dynamic.each.element.else.empty.end.end_frame.end_partition.end-exec.equals.escape.every.except.exec.execute.exists.exp.external.extract.false.fetch.filter.first_value.float.floor.for.foreign.frame_row.free.from.full.function.fusion.get.global.grant.group.grouping.groups.having.hold.hour.identity.in.indicator.initial.inner.inout.insensitive.insert.int.integer.intersect.intersection.interval.into.is.join.json_array.json_arrayagg.json_exists.json_object.json_objectagg.json_query.json_table.json_table_primitive.json_value.lag.language.large.last_value.lateral.lead.leading.left.like.like_regex.listagg.ln.local.localtime.localtimestamp.log.log10.lower.match.match_number.match_recognize.matches.max.member.merge.method.min.minute.mod.modifies.module.month.multiset.national.natural.nchar.nclob.new.no.none.normalize.not.nth_value.ntile.null.nullif.numeric.octet_length.occurrences_regex.of.offset.old.omit.on.one.only.open.or.order.out.outer.over.overlaps.overlay.parameter.partition.pattern.per.percent.percent_rank.percentile_cont.percentile_disc.period.portion.position.position_regex.power.precedes.precision.prepare.primary.procedure.ptf.range.rank.reads.real.recursive.ref.references.referencing.regr_avgx.regr_avgy.regr_count.regr_intercept.regr_r2.regr_slope.regr_sxx.regr_sxy.regr_syy.release.result.return.returns.revoke.right.rollback.rollup.row.row_number.rows.running.savepoint.scope.scroll.search.second.seek.select.sensitive.session_user.set.show.similar.sin.sinh.skip.smallint.some.specific.specifictype.sql.sqlexception.sqlstate.sqlwarning.sqrt.start.static.stddev_pop.stddev_samp.submultiset.subset.substring.substring_regex.succeeds.sum.symmetric.system.system_time.system_user.table.tablesample.tan.tanh.then.time.timestamp.timezone_hour.timezone_minute.to.trailing.translate.translate_regex.translation.treat.trigger.trim.trim_array.true.truncate.uescape.union.unique.unknown.unnest.update.upper.user.using.value.values.value_of.var_pop.var_samp.varbinary.varchar.varying.versioning.when.whenever.where.width_bucket.window.with.within.without.year`.split(
        `.`,
      ),
    u =
      `abs.acos.array_agg.asin.atan.avg.cast.ceil.ceiling.coalesce.corr.cos.cosh.count.covar_pop.covar_samp.cume_dist.dense_rank.deref.element.exp.extract.first_value.floor.json_array.json_arrayagg.json_exists.json_object.json_objectagg.json_query.json_table.json_table_primitive.json_value.lag.last_value.lead.listagg.ln.log.log10.lower.max.min.mod.nth_value.ntile.nullif.percent_rank.percentile_cont.percentile_disc.position.position_regex.power.rank.regr_avgx.regr_avgy.regr_count.regr_intercept.regr_r2.regr_slope.regr_sxx.regr_sxy.regr_syy.row_number.sin.sinh.sqrt.stddev_pop.stddev_samp.substring.substring_regex.sum.tan.tanh.translate.translate_regex.treat.trim.trim_array.unnest.upper.value_of.var_pop.var_samp.width_bucket`.split(
        `.`,
      ),
    d = [
      `current_catalog`,
      `current_date`,
      `current_default_transform_group`,
      `current_path`,
      `current_role`,
      `current_schema`,
      `current_transform_group_for_type`,
      `current_user`,
      `session_user`,
      `system_time`,
      `system_user`,
      `current_time`,
      `localtime`,
      `current_timestamp`,
      `localtimestamp`,
    ],
    f = [
      `create table`,
      `insert into`,
      `primary key`,
      `foreign key`,
      `not null`,
      `alter table`,
      `add constraint`,
      `grouping sets`,
      `on overflow`,
      `character set`,
      `respect nulls`,
      `ignore nulls`,
      `nulls first`,
      `nulls last`,
      `depth first`,
      `breadth first`,
    ],
    p = u,
    m = [...l, ...c].filter((e) => !u.includes(e)),
    h = {
      scope: `variable`,
      match: /@[a-z0-9][a-z0-9_]*/,
    },
    g = {
      scope: `operator`,
      match: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
      relevance: 0,
    },
    v = {
      match: t.concat(/\b/, t.either(...p), /\s*\(/),
      relevance: 0,
      keywords: {
        built_in: p,
      },
    };
  function y(e) {
    return t.concat(/\b/, t.either(...e.map((e) => e.replace(/\s+/, `\\s+`))), /\b/);
  }
  let b = {
    scope: `keyword`,
    match: y(f),
    relevance: 0,
  };
  function x(e, { exceptions: t, when: n } = {}) {
    let r = n;
    return (
      (t ||= []),
      e.map((e) => (e.match(/\|\d+$/) || t.includes(e) ? e : r(e) ? `${e}|0` : e))
    );
  }
  return {
    name: `SQL`,
    case_insensitive: !0,
    illegal: /[{}]|<\//,
    keywords: {
      $pattern: /\b[\w\.]+/,
      keyword: x(m, {
        when: (e) => e.length < 3,
      }),
      literal: a,
      type: s,
      built_in: d,
    },
    contains: [
      {
        scope: `type`,
        match: y(o),
      },
      b,
      v,
      h,
      r,
      i,
      e.C_NUMBER_MODE,
      e.C_BLOCK_COMMENT_MODE,
      n,
      g,
    ],
  };
}
function Sxe(e) {
  return {
    name: `Shell Session`,
    aliases: [`console`, `shellsession`],
    contains: [
      {
        className: `meta.prompt`,
        begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
        starts: {
          end: /[^\\](?=\s*$)/,
          subLanguage: `bash`,
        },
      },
    ],
  };
}
var G9 = `[A-Za-z$_][0-9A-Za-z$_]*`,
  K9 =
    `as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using`.split(
      `.`,
    ),
  q9 = [`true`, `false`, `null`, `undefined`, `NaN`, `Infinity`],
  J9 =
    `Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly`.split(
      `.`,
    ),
  Y9 = [
    `Error`,
    `EvalError`,
    `InternalError`,
    `RangeError`,
    `ReferenceError`,
    `SyntaxError`,
    `TypeError`,
    `URIError`,
  ],
  X9 = [
    `setInterval`,
    `setTimeout`,
    `clearInterval`,
    `clearTimeout`,
    `require`,
    `exports`,
    `eval`,
    `isFinite`,
    `isNaN`,
    `parseFloat`,
    `parseInt`,
    `decodeURI`,
    `decodeURIComponent`,
    `encodeURI`,
    `encodeURIComponent`,
    `escape`,
    `unescape`,
  ],
  Z9 = [
    `arguments`,
    `this`,
    `super`,
    `console`,
    `window`,
    `document`,
    `localStorage`,
    `sessionStorage`,
    `module`,
    `global`,
  ],
  Q9 = [].concat(X9, J9, Y9);
function Cxe(e) {
  let t = e.regex,
    n = (e, { after: t }) => {
      let n = `</` + e[0].slice(1);
      return e.input.indexOf(n, t) !== -1;
    },
    r = G9,
    i = {
      begin: `<>`,
      end: `</>`,
    },
    a = /<[A-Za-z0-9\\._:-]+\s*\/>/,
    o = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      isTrulyOpeningTag: (e, t) => {
        let r = e[0].length + e.index,
          i = e.input[r];
        if (i === `<` || i === `,`) {
          t.ignoreMatch();
          return;
        }
        i === `>` &&
          (n(e, {
            after: r,
          }) ||
            t.ignoreMatch());
        let a,
          o = e.input.substring(r);
        if ((a = o.match(/^\s*=/))) {
          t.ignoreMatch();
          return;
        }
        if ((a = o.match(/^\s+extends\s+/)) && a.index === 0) {
          t.ignoreMatch();
          return;
        }
      },
    },
    s = {
      $pattern: G9,
      keyword: K9,
      literal: q9,
      built_in: Q9,
      "variable.language": Z9,
    },
    c = `[0-9](_?[0-9])*`,
    l = `\\.(${c})`,
    u = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`,
    d = {
      className: `number`,
      variants: [
        {
          begin: `(\\b(${u})((${l})|\\.)?|(${l}))[eE][+-]?(${c})\\b`,
        },
        {
          begin: `\\b(${u})\\b((${l})\\b|\\.)?|(${l})\\b`,
        },
        {
          begin: `\\b(0|[1-9](_?[0-9])*)n\\b`,
        },
        {
          begin: `\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b`,
        },
        {
          begin: `\\b0[bB][0-1](_?[0-1])*n?\\b`,
        },
        {
          begin: `\\b0[oO][0-7](_?[0-7])*n?\\b`,
        },
        {
          begin: `\\b0[0-7]+n?\\b`,
        },
      ],
      relevance: 0,
    },
    f = {
      className: `subst`,
      begin: `\\$\\{`,
      end: `\\}`,
      keywords: s,
      contains: [],
    },
    p = {
      begin: ".?html`",
      end: ``,
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [e.BACKSLASH_ESCAPE, f],
        subLanguage: `xml`,
      },
    },
    m = {
      begin: ".?css`",
      end: ``,
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [e.BACKSLASH_ESCAPE, f],
        subLanguage: `css`,
      },
    },
    h = {
      begin: ".?gql`",
      end: ``,
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [e.BACKSLASH_ESCAPE, f],
        subLanguage: `graphql`,
      },
    },
    g = {
      className: `string`,
      begin: "`",
      end: "`",
      contains: [e.BACKSLASH_ESCAPE, f],
    },
    v = {
      className: `comment`,
      variants: [
        e.COMMENT(/\/\*\*(?!\/)/, `\\*/`, {
          relevance: 0,
          contains: [
            {
              begin: `(?=@[A-Za-z]+)`,
              relevance: 0,
              contains: [
                {
                  className: `doctag`,
                  begin: `@[A-Za-z]+`,
                },
                {
                  className: `type`,
                  begin: `\\{`,
                  end: `\\}`,
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0,
                },
                {
                  className: `variable`,
                  begin: `[A-Za-z$_][0-9A-Za-z$_]*(?=\\s*(-)|$)`,
                  endsParent: !0,
                  relevance: 0,
                },
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0,
                },
              ],
            },
          ],
        }),
        e.C_BLOCK_COMMENT_MODE,
        e.C_LINE_COMMENT_MODE,
      ],
    },
    y = [
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      p,
      m,
      h,
      g,
      {
        match: /\$\d+/,
      },
      d,
    ];
  f.contains = y.concat({
    begin: /\{/,
    end: /\}/,
    keywords: s,
    contains: [`self`].concat(y),
  });
  let b = [].concat(v, f.contains),
    x = b.concat([
      {
        begin: /(\s*)\(/,
        end: /\)/,
        keywords: s,
        contains: [`self`].concat(b),
      },
    ]),
    S = {
      className: `params`,
      begin: /(\s*)\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      keywords: s,
      contains: x,
    },
    C = {
      variants: [
        {
          match: [
            /class/,
            /\s+/,
            r,
            /\s+/,
            /extends/,
            /\s+/,
            t.concat(r, `(`, t.concat(/\./, r), `)*`),
          ],
          scope: {
            1: `keyword`,
            3: `title.class`,
            5: `keyword`,
            7: `title.class.inherited`,
          },
        },
        {
          match: [/class/, /\s+/, r],
          scope: {
            1: `keyword`,
            3: `title.class`,
          },
        },
      ],
    },
    w = {
      relevance: 0,
      match: t.either(
        /\bJSON/,
        /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
        /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
        /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/,
      ),
      className: `title.class`,
      keywords: {
        _: [...J9, ...Y9],
      },
    },
    T = {
      label: `use_strict`,
      className: `meta`,
      relevance: 10,
      begin: /^\s*['"]use (strict|asm)['"]/,
    },
    E = {
      variants: [
        {
          match: [/function/, /\s+/, r, /(?=\s*\()/],
        },
        {
          match: [/function/, /\s*(?=\()/],
        },
      ],
      className: {
        1: `keyword`,
        3: `title.function`,
      },
      label: `func.def`,
      contains: [S],
      illegal: /%/,
    },
    D = {
      relevance: 0,
      match: /\b[A-Z][A-Z_0-9]+\b/,
      className: `variable.constant`,
    };
  function ee(e) {
    return t.concat(`(?!`, e.join(`|`), `)`);
  }
  let te = {
      match: t.concat(
        /\b/,
        ee([...X9, `super`, `import`].map((e) => `${e}\\s*\\(`)),
        r,
        t.lookahead(/\s*\(/),
      ),
      className: `title.function`,
      relevance: 0,
    },
    O = {
      begin: t.concat(/\./, t.lookahead(t.concat(r, /(?![0-9A-Za-z$_(])/))),
      end: r,
      excludeBegin: !0,
      keywords: `prototype`,
      className: `property`,
      relevance: 0,
    },
    k = {
      match: [/get|set/, /\s+/, r, /(?=\()/],
      className: {
        1: `keyword`,
        3: `title.function`,
      },
      contains: [
        {
          begin: /\(\)/,
        },
        S,
      ],
    },
    ne =
      `(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|` +
      e.UNDERSCORE_IDENT_RE +
      `)\\s*=>`,
    re = {
      match: [/const|var|let/, /\s+/, r, /\s*/, /=\s*/, /(async\s*)?/, t.lookahead(ne)],
      keywords: `async`,
      className: {
        1: `keyword`,
        3: `title.function`,
      },
      contains: [S],
    };
  return {
    name: `JavaScript`,
    aliases: [`js`, `jsx`, `mjs`, `cjs`],
    keywords: s,
    exports: {
      PARAMS_CONTAINS: x,
      CLASS_REFERENCE: w,
    },
    illegal: /#(?![$_A-z])/,
    contains: [
      e.SHEBANG({
        label: `shebang`,
        binary: `node`,
        relevance: 5,
      }),
      T,
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      p,
      m,
      h,
      g,
      v,
      {
        match: /\$\d+/,
      },
      d,
      w,
      {
        scope: `attr`,
        match: r + t.lookahead(`:`),
        relevance: 0,
      },
      re,
      {
        begin: `(` + e.RE_STARTERS_RE + `|\\b(case|return|throw)\\b)\\s*`,
        keywords: `return throw case`,
        relevance: 0,
        contains: [
          v,
          e.REGEXP_MODE,
          {
            className: `function`,
            begin: ne,
            returnBegin: !0,
            end: `\\s*=>`,
            contains: [
              {
                className: `params`,
                variants: [
                  {
                    begin: e.UNDERSCORE_IDENT_RE,
                    relevance: 0,
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0,
                  },
                  {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: s,
                    contains: x,
                  },
                ],
              },
            ],
          },
          {
            begin: /,/,
            relevance: 0,
          },
          {
            match: /\s+/,
            relevance: 0,
          },
          {
            variants: [
              {
                begin: i.begin,
                end: i.end,
              },
              {
                match: a,
              },
              {
                begin: o.begin,
                "on:begin": o.isTrulyOpeningTag,
                end: o.end,
              },
            ],
            subLanguage: `xml`,
            contains: [
              {
                begin: o.begin,
                end: o.end,
                skip: !0,
                contains: [`self`],
              },
            ],
          },
        ],
      },
      E,
      {
        beginKeywords: `while if switch catch for`,
      },
      {
        begin:
          `\\b(?!function)` +
          e.UNDERSCORE_IDENT_RE +
          `\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{`,
        returnBegin: !0,
        label: `func.def`,
        contains: [
          S,
          e.inherit(e.TITLE_MODE, {
            begin: r,
            className: `title.function`,
          }),
        ],
      },
      {
        match: /\.\.\./,
        relevance: 0,
      },
      O,
      {
        match: `\\$[A-Za-z$_][0-9A-Za-z$_]*`,
        relevance: 0,
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: {
          1: `title.function`,
        },
        contains: [S],
      },
      te,
      D,
      C,
      k,
      {
        match: /\$[(.]/,
      },
    ],
  };
}
function wxe(e) {
  let t = e.regex,
    n = Cxe(e),
    r = G9,
    i = [
      `any`,
      `void`,
      `number`,
      `boolean`,
      `string`,
      `object`,
      `never`,
      `symbol`,
      `bigint`,
      `unknown`,
    ],
    a = {
      begin: [/namespace/, /\s+/, e.IDENT_RE],
      beginScope: {
        1: `keyword`,
        3: `title.class`,
      },
    },
    o = {
      beginKeywords: `interface`,
      end: /\{/,
      excludeEnd: !0,
      keywords: {
        keyword: `interface extends`,
        built_in: i,
      },
      contains: [n.exports.CLASS_REFERENCE],
    },
    s = {
      className: `meta`,
      relevance: 10,
      begin: /^\s*['"]use strict['"]/,
    },
    c = {
      $pattern: G9,
      keyword: K9.concat([
        `type`,
        `interface`,
        `public`,
        `private`,
        `protected`,
        `implements`,
        `declare`,
        `abstract`,
        `readonly`,
        `enum`,
        `override`,
        `satisfies`,
      ]),
      literal: q9,
      built_in: Q9.concat(i),
      "variable.language": Z9,
    },
    l = {
      className: `meta`,
      begin: `@[A-Za-z$_][0-9A-Za-z$_]*`,
    },
    u = (e, t, n) => {
      let r = e.contains.findIndex((e) => e.label === t);
      if (r === -1) throw Error(`can not find mode to replace`);
      e.contains.splice(r, 1, n);
    };
  (Object.assign(n.keywords, c), n.exports.PARAMS_CONTAINS.push(l));
  let d = n.contains.find((e) => e.scope === `attr`),
    f = Object.assign({}, d, {
      match: t.concat(r, t.lookahead(/\s*\?:/)),
    });
  (n.exports.PARAMS_CONTAINS.push([n.exports.CLASS_REFERENCE, d, f]),
    (n.contains = n.contains.concat([l, a, o, f])),
    u(n, `shebang`, e.SHEBANG()),
    u(n, `use_strict`, s));
  let p = n.contains.find((e) => e.label === `func.def`);
  return (
    (p.relevance = 0),
    Object.assign(n, {
      name: `TypeScript`,
      aliases: [`ts`, `tsx`, `mts`, `cts`],
    }),
    n
  );
}
function Txe(e) {
  let t = e.regex,
    n = t.concat(/[\p{L}_]/u, t.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u),
    r = /[\p{L}0-9._:-]+/u,
    i = {
      className: `symbol`,
      begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/,
    },
    a = {
      begin: /\s/,
      contains: [
        {
          className: `keyword`,
          begin: /#?[a-z_][a-z1-9_-]+/,
          illegal: /\n/,
        },
      ],
    },
    o = e.inherit(a, {
      begin: /\(/,
      end: /\)/,
    }),
    s = e.inherit(e.APOS_STRING_MODE, {
      className: `string`,
    }),
    c = e.inherit(e.QUOTE_STRING_MODE, {
      className: `string`,
    }),
    l = {
      endsWithParent: !0,
      illegal: /</,
      relevance: 0,
      contains: [
        {
          className: `attr`,
          begin: r,
          relevance: 0,
        },
        {
          begin: /=\s*/,
          relevance: 0,
          contains: [
            {
              className: `string`,
              endsParent: !0,
              variants: [
                {
                  begin: /"/,
                  end: /"/,
                  contains: [i],
                },
                {
                  begin: /'/,
                  end: /'/,
                  contains: [i],
                },
                {
                  begin: /[^\s"'=<>`]+/,
                },
              ],
            },
          ],
        },
      ],
    };
  return {
    name: `HTML, XML`,
    aliases: [`html`, `xhtml`, `rss`, `atom`, `xjb`, `xsd`, `xsl`, `plist`, `wsf`, `svg`],
    case_insensitive: !0,
    unicodeRegex: !0,
    contains: [
      {
        className: `meta`,
        begin: /<![a-z]/,
        end: />/,
        relevance: 10,
        contains: [
          a,
          c,
          s,
          o,
          {
            begin: /\[/,
            end: /\]/,
            contains: [
              {
                className: `meta`,
                begin: /<![a-z]/,
                end: />/,
                contains: [a, o, c, s],
              },
            ],
          },
        ],
      },
      e.COMMENT(/<!--/, /-->/, {
        relevance: 10,
      }),
      {
        begin: /<!\[CDATA\[/,
        end: /\]\]>/,
        relevance: 10,
      },
      i,
      {
        className: `meta`,
        end: /\?>/,
        variants: [
          {
            begin: /<\?xml/,
            relevance: 10,
            contains: [c],
          },
          {
            begin: /<\?[a-z][a-z0-9]+/,
          },
        ],
      },
      {
        className: `tag`,
        begin: /<style(?=\s|>)/,
        end: />/,
        keywords: {
          name: `style`,
        },
        contains: [l],
        starts: {
          end: /<\/style>/,
          returnEnd: !0,
          subLanguage: [`css`, `xml`],
        },
      },
      {
        className: `tag`,
        begin: /<script(?=\s|>)/,
        end: />/,
        keywords: {
          name: `script`,
        },
        contains: [l],
        starts: {
          end: /<\/script>/,
          returnEnd: !0,
          subLanguage: [`javascript`, `handlebars`, `xml`],
        },
      },
      {
        className: `tag`,
        begin: /<>|<\/>/,
      },
      {
        className: `tag`,
        begin: t.concat(/</, t.lookahead(t.concat(n, t.either(/\/>/, />/, /\s/)))),
        end: /\/?>/,
        contains: [
          {
            className: `name`,
            begin: n,
            relevance: 0,
            starts: l,
          },
        ],
      },
      {
        className: `tag`,
        begin: t.concat(/<\//, t.lookahead(t.concat(n, />/))),
        contains: [
          {
            className: `name`,
            begin: n,
            relevance: 0,
          },
          {
            begin: />/,
            relevance: 0,
            endsParent: !0,
          },
        ],
      },
    ],
  };
}
(B9.registerLanguage(`bash`, zbe),
  B9.registerLanguage(`css`, Jbe),
  B9.registerLanguage(`dart`, Ybe),
  B9.registerLanguage(`diff`, Xbe),
  B9.registerLanguage(`dns`, Zbe),
  B9.registerLanguage(`docker`, Qbe),
  B9.registerLanguage(`excel`, $be),
  B9.registerLanguage(`http`, exe),
  B9.registerLanguage(`handlebars`, txe),
  B9.registerLanguage(`json`, nxe),
  B9.registerLanguage(`javascript`, sxe),
  B9.registerLanguage(`markdown`, cxe),
  B9.registerLanguage(`nginx`, lxe),
  B9.registerLanguage(`php`, uxe),
  B9.registerLanguage(`python`, dxe),
  B9.registerLanguage(`scss`, bxe),
  B9.registerLanguage(`sql`, xxe),
  B9.registerLanguage(`shell`, Sxe),
  B9.registerLanguage(`typescript`, wxe),
  B9.registerLanguage(`xml`, Txe),
  (window.hljs = B9));
var Exe = B9;
B();
var Dxe = [`innerHTML`],
  Oxe = Object.assign(
    {
      name: `MarkdownContent`,
    },
    {
      props: {
        content: {
          type: String,
          default: ``,
        },
      },
      setup(e) {
        return (
          Qe(() => {
            te().parent.subTree.el.addEventListener(`DOMContentLoaded`, Exe.highlightAll());
          }),
          (t, n) => (
            A(),
            M(
              `div`,
              {
                class: `md-content`,
                innerHTML: e.content,
              },
              null,
              8,
              Dxe,
            )
          )
        );
      },
    },
  );
B();
var kxe = {
    class: `mt-4 border-t pt-3`,
  },
  Axe = {
    class: `flex items-center justify-between`,
  },
  jxe = {
    class: `flex items-center space-x-2`,
  },
  Mxe = {
    key: 0,
    class: `flex -space-x-1`,
  },
  Nxe = {
    key: 1,
    class: `text-sm text-gray-500`,
  },
  Pxe = {
    class: `flex items-center mt-2 space-x-2`,
  },
  Fxe = [`onClick`],
  Ixe = {
    __name: `Reactions`,
    props: {
      postId: {
        type: String,
        required: !0,
      },
      initialReactions: {
        type: Array,
        default: () => [],
      },
    },
    setup(e, { expose: t }) {
      let n = $e(),
        r = e,
        i = [`👍`, `❤️`, `😂`, `😮`, `😢`, `😡`],
        a = F(r.initialReactions || []),
        o = V(() => a.value.reduce((e, t) => ((e[t.emoji] = (e[t.emoji] || 0) + 1), e), {})),
        s = (e) => a.value.some((t) => t.emoji === e && t.userId === n.state.auth.user.uuid),
        c = async (e) => {
          try {
            (await n.dispatch(`post/react`, {
              postId: r.postId,
              emoji: e,
            }),
              s(e)
                ? (a.value = a.value.filter(
                    (t) => !(t.emoji === e && t.userId === n.state.auth.user.uuid),
                  ))
                : a.value.push({
                    emoji: e,
                    userId: n.state.auth.user.uuid,
                  }));
          } catch (e) {
            console.error(`Error reacting to post:`, e);
          }
        };
      return (
        t({
          updateReactions: (e) => {
            a.value = e;
          },
        }),
        (e, t) => (
          A(),
          M(`div`, kxe, [
            W(`div`, Axe, [
              W(`div`, jxe, [
                a.value.length > 0
                  ? (A(),
                    M(`div`, Mxe, [
                      (A(!0),
                      M(
                        ke,
                        null,
                        ae(
                          o.value,
                          (e, t) => (
                            A(),
                            M(
                              `span`,
                              {
                                key: t,
                                class: `inline-flex items-center px-2 py-1 rounded-full text-xs bg-gray-100 dark:bg-gray-700`,
                              },
                              T(t) + ` ` + T(e),
                              1,
                            )
                          ),
                        ),
                        128,
                      )),
                    ]))
                  : (A(), M(`span`, Nxe, `No reactions yet`)),
              ]),
            ]),
            W(`div`, Pxe, [
              (A(),
              M(
                ke,
                null,
                ae(i, (e) =>
                  W(
                    `button`,
                    {
                      key: e,
                      onClick: (t) => c(e),
                      class: O([
                        `hover:bg-gray-100 dark:hover:bg-gray-700 p-1.5 rounded-full transition-colors`,
                        {
                          "bg-gray-100 dark:bg-gray-700": s(e),
                        },
                      ]),
                    },
                    T(e),
                    11,
                    Fxe,
                  ),
                ),
                64,
              )),
            ]),
          ])
        )
      );
    },
  };
B();
var Lxe = {
    class: `text-sm font-medium`,
  },
  Rxe = {
    class: `text-xs text-gray-500`,
  },
  zxe = {
    key: 0,
    class: `mt-2`,
  },
  Bxe = {
    class: `space-y-4`,
  },
  Vxe = {
    class: `flex items-center justify-end`,
  },
  Hxe = {
    value: `recent`,
  },
  Uxe = {
    value: `name`,
  },
  Wxe = {
    key: 2,
    class: `flex justify-center`,
  },
  Gxe = Object.assign(
    {
      name: `ViewLog`,
    },
    {
      props: {
        viewLogs: {
          type: Array,
          default: () => [],
        },
        viewLogsTotal: {
          type: Number,
          default: 0,
        },
        fetchAction: {
          type: String,
          default: ``,
        },
        moduleUuid: {
          type: String,
          default: ``,
        },
        perPage: {
          type: Number,
          default: 10,
        },
        initialSort: {
          type: String,
          default: `recent`,
        },
      },
      setup(e) {
        let t = $e(),
          n = R(`$trans`),
          r = e,
          i = [
            {
              key: `name`,
              label: n(`general.name`),
              visibility: !0,
            },
            {
              key: `lastViewedAt`,
              label: n(`general.datetime`),
              visibility: !0,
            },
            {
              key: `count`,
              label: n(`general.count`),
              visibility: !0,
            },
          ],
          a = Ae({
            showModal: !1,
            logs: [],
            nextCursor: null,
            isLoading: !1,
            hasFetched: !1,
            sort: r.initialSort,
          }),
          o = V(() => r.viewLogs.slice(0, 5)),
          s = V(() => !!(r.fetchAction && r.moduleUuid)),
          c = V(() => Math.max((r.viewLogsTotal || 0) - o.value.length, 0)),
          l = (e) =>
            typeof e.totalViews == `number`
              ? e.totalViews
              : Array.isArray(e.details)
                ? e.details.length
                : 0,
          u = async (e = null) => {
            !s.value ||
              a.isLoading ||
              ((a.isLoading = !0),
              await t
                .dispatch(r.fetchAction, {
                  uuid: r.moduleUuid,
                  params: {
                    cursor: e,
                    sort: a.sort,
                    per_page: r.perPage,
                  },
                })
                .then((t) => {
                  (e ? (a.logs = [...a.logs, ...t.data]) : (a.logs = t.data),
                    (a.nextCursor = t.meta?.nextCursor || null),
                    (a.hasFetched = !0));
                })
                .catch(() => {
                  a.nextCursor = null;
                })
                .finally(() => {
                  a.isLoading = !1;
                }));
          },
          d = () => {
            ((a.showModal = !0), a.hasFetched || u());
          },
          f = () => {
            ((a.logs = []), (a.nextCursor = null), u());
          },
          p = () => {
            a.showModal = !1;
          };
        return (e, t) => {
          let r = j(`BaseHeading`),
            m = j(`DataCell`),
            h = j(`DataRow`),
            g = j(`SimpleTable`),
            v = j(`BaseAlert`),
            y = j(`BaseModal`);
          return (
            A(),
            M(`div`, null, [
              N(r, null, {
                default: I(() => [H(T(P(n)(`general.view_log`)), 1)]),
                _: 1,
              }),
              (A(!0),
              M(
                ke,
                null,
                ae(
                  o.value,
                  (e) => (
                    A(),
                    M(
                      `div`,
                      {
                        class: `flex items-end gap-2`,
                        key: e.userId || e.id,
                      },
                      [
                        W(`div`, Lxe, T(e.name), 1),
                        W(
                          `div`,
                          Rxe,
                          T(e.lastViewedAt?.formatted || `-`) +
                            ` - ` +
                            T(
                              P(n)(`general.times`, {
                                attribute: l(e),
                              }),
                            ),
                          1,
                        ),
                      ],
                    )
                  ),
                ),
                128,
              )),
              c.value > 0 && s.value
                ? (A(),
                  M(`div`, zxe, [
                    W(
                      `span`,
                      {
                        class: `text-xs border border-gray-300 dark:border-gray-600 rounded-full px-3 py-1 cursor-pointer`,
                        onClick: d,
                      },
                      T(c.value) + ` ` + T(P(n)(`general.more`)),
                      1,
                    ),
                  ]))
                : U(``, !0),
              N(
                y,
                {
                  visibility: a.showModal,
                  onClose: p,
                },
                {
                  title: I(() => [H(T(P(n)(`general.view_log`)), 1)]),
                  default: I(() => [
                    W(`div`, Bxe, [
                      W(`div`, Vxe, [
                        Re(
                          W(
                            `select`,
                            {
                              "onUpdate:modelValue": (t[0] ||= (e) => (a.sort = e)),
                              class: `text-xs border border-gray-300 dark:border-gray-600 rounded-md px-2 py-1 bg-white dark:bg-dark-body`,
                              onChange: f,
                            },
                            [
                              W(`option`, Hxe, T(P(n)(`general.recent`)), 1),
                              W(`option`, Uxe, T(P(n)(`student.props.name`)), 1),
                            ],
                            544,
                          ),
                          [[Ke, a.sort]],
                        ),
                      ]),
                      a.logs.length
                        ? (A(),
                          L(
                            g,
                            {
                              key: 0,
                              header: i,
                            },
                            {
                              default: I(() => [
                                (A(!0),
                                M(
                                  ke,
                                  null,
                                  ae(
                                    a.logs,
                                    (e) => (
                                      A(),
                                      L(
                                        h,
                                        {
                                          key: `${e.userId}-${e.lastViewedAt?.at || ``}`,
                                        },
                                        {
                                          default: I(() => [
                                            N(
                                              m,
                                              {
                                                name: `name`,
                                              },
                                              {
                                                default: I(() => [H(T(e.name), 1)]),
                                                _: 2,
                                              },
                                              1024,
                                            ),
                                            N(
                                              m,
                                              {
                                                name: `lastViewedAt`,
                                              },
                                              {
                                                default: I(() => [
                                                  H(T(e.lastViewedAt?.formatted || `-`), 1),
                                                ]),
                                                _: 2,
                                              },
                                              1024,
                                            ),
                                            N(
                                              m,
                                              {
                                                name: `count`,
                                              },
                                              {
                                                default: I(() => [H(T(l(e)), 1)]),
                                                _: 2,
                                              },
                                              1024,
                                            ),
                                          ]),
                                          _: 2,
                                        },
                                        1024,
                                      )
                                    ),
                                  ),
                                  128,
                                )),
                              ]),
                              _: 1,
                            },
                          ))
                        : (A(),
                          L(
                            v,
                            {
                              key: 1,
                              design: `info`,
                              size: `xs`,
                            },
                            {
                              default: I(() => [H(T(P(n)(`general.errors.record_not_found`)), 1)]),
                              _: 1,
                            },
                          )),
                      a.nextCursor
                        ? (A(),
                          M(`div`, Wxe, [
                            W(
                              `span`,
                              {
                                class: `text-xs border border-gray-300 dark:border-gray-600 rounded-full px-4 py-2 cursor-pointer`,
                                onClick: (t[1] ||= (e) => u(a.nextCursor)),
                              },
                              T(P(n)(`general.show_more`)),
                              1,
                            ),
                          ]))
                        : U(``, !0),
                    ]),
                  ]),
                  _: 1,
                },
                8,
                [`visibility`],
              ),
            ])
          );
        };
      },
    },
  );
B();
var Kxe = {
    key: 0,
    class: `flex-shrink-0`,
  },
  qxe = [`src`],
  Jxe = {
    class: `flex-1 min-w-0`,
  },
  Yxe = {
    class: `focus:outline-none space-y-1`,
  },
  Xxe = {
    class: `text-sm font-medium text-gray-900 dark:text-gray-400`,
  },
  Zxe = {
    class: ``,
  },
  Qxe = {
    class: `text-sm text-gray-500 truncate`,
  },
  $xe = Object.assign(
    {
      name: `EmployeeSummary`,
    },
    {
      props: {
        employee: {
          type: Object,
          default() {
            return {};
          },
        },
      },
      setup(e) {
        let t = Ec();
        return (n, r) => (
          A(),
          M(
            `div`,
            {
              class: `relative rounded-lg cursor-pointer dark:bg-dark-header bg-white flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 overflow-hidden`,
              onClick: (r[0] ||= (n) =>
                P(t).push({
                  name: `EmployeeShow`,
                  params: {
                    uuid: e.employee.uuid,
                  },
                })),
            },
            [
              e.employee.photo
                ? (A(),
                  M(`div`, Kxe, [
                    W(
                      `img`,
                      {
                        class: `h-16 w-16 rounded-full`,
                        src: e.employee.photo,
                        alt: ``,
                      },
                      null,
                      8,
                      qxe,
                    ),
                  ]))
                : U(``, !0),
              W(`div`, Jxe, [
                W(`div`, Yxe, [
                  (r[1] ||= W(
                    `span`,
                    {
                      class: `absolute inset-0`,
                      "aria-hidden": `true`,
                    },
                    null,
                    -1,
                  )),
                  W(`p`, Xxe, [
                    H(T(e.employee.name) + ` `, 1),
                    W(`span`, Zxe, `(` + T(e.employee.codeNumber) + `)`, 1),
                  ]),
                  W(`p`, Qxe, T(e.employee.designation) + ` @ ` + T(e.employee.branch), 1),
                ]),
              ]),
            ],
          )
        );
      },
    },
  );
B();
var eSe = {
    key: 0,
    class: `min-h-screen bg-gray-50 dark:bg-dark-header`,
  },
  tSe = {
    class: `bg-white dark:bg-dark-header border-b border-gray-200 dark:border-gray-700 px-4 py-2`,
  },
  nSe = {
    class: `flex items-center justify-between`,
  },
  rSe = {
    class: `text-2xl font-bold text-gray-900 dark:text-gray-300`,
  },
  iSe = {
    class: `flex items-center gap-4`,
  },
  aSe = {
    key: 0,
    class: `w-64`,
  },
  oSe = {
    class: `flex h-[calc(100vh-100px)]`,
  },
  sSe = {
    class: `flex-1 bg-white dark:bg-dark-header border-r border-gray-200 dark:border-gray-700 scroller-thin-y`,
  },
  cSe = {
    class: `px-4 py-2`,
  },
  lSe = {
    class: `mb-2 flex justify-between items-center`,
  },
  uSe = {
    class: `text-lg font-semibold text-gray-900 dark:text-gray-300 mb-2`,
  },
  dSe = {
    key: 0,
  },
  fSe = {
    class: `text-sm text-gray-600 dark:text-gray-400`,
  },
  pSe = {
    class: `mb-6`,
  },
  mSe = {
    class: `relative`,
  },
  hSe = [`placeholder`],
  gSe = [`title`],
  _Se = {
    key: 0,
    class: `space-y-4`,
  },
  vSe = {
    class: `p-4 flex justify-between gap-4`,
  },
  ySe = {
    class: `w-1/2 space-y-4`,
  },
  bSe = {
    key: 0,
    class: `mb-4`,
  },
  xSe = {
    class: `text-sm font-medium text-gray-700 dark:text-gray-400 mb-2 flex items-center gap-2`,
  },
  SSe = {
    class: `space-y-2`,
  },
  CSe = {
    class: `flex items-center gap-3`,
  },
  wSe = {
    class: `w-10 h-10 rounded-full overflow-hidden bg-green-500 flex items-center justify-center`,
  },
  TSe = [`src`, `alt`],
  ESe = {
    key: 1,
    class: `w-full h-full bg-green-500 flex items-center justify-center text-white text-sm font-medium`,
  },
  DSe = {
    class: `flex-1`,
  },
  OSe = {
    class: `font-medium text-green-900 dark:text-green-400`,
  },
  kSe = {
    class: `text-green-600 dark:text-green-400 font-normal`,
  },
  ASe = {
    key: 0,
    class: `text-xs text-green-600`,
  },
  jSe = {
    key: 0,
    class: `text-danger`,
  },
  MSe = {
    class: `text-xs text-green-500`,
  },
  NSe = [`onClick`],
  PSe = {
    key: 1,
    class: `mb-4`,
  },
  FSe = {
    class: `text-sm font-medium text-gray-700 dark:text-gray-400 mb-2 flex items-center gap-2`,
  },
  ISe = {
    class: `space-y-2`,
  },
  LSe = {
    class: `flex items-center gap-3`,
  },
  RSe = {
    class: `w-10 h-10 rounded-full overflow-hidden bg-blue-500 flex items-center justify-center`,
  },
  zSe = [`src`, `alt`],
  BSe = {
    key: 1,
    class: `w-full h-full bg-blue-500 flex items-center justify-center text-white text-sm font-medium`,
  },
  VSe = {
    class: `flex-1`,
  },
  HSe = {
    class: `font-medium text-blue-900 dark:text-blue-400`,
  },
  USe = {
    class: `text-blue-600 dark:text-blue-400 font-normal`,
  },
  WSe = {
    class: `text-xs text-blue-500`,
  },
  GSe = [`onClick`],
  KSe = [`onDragenter`, `onDragleave`, `onDrop`],
  qSe = {
    class: `text-center`,
  },
  JSe = [`d`],
  YSe = {
    class: `text-xs text-gray-400 mt-1`,
  },
  XSe = {
    class: `w-80 bg-white dark:bg-dark-header scroller-thin-y`,
  },
  ZSe = {
    class: `px-4 py-2`,
  },
  QSe = {
    class: `mb-2 flex justify-between items-center`,
  },
  $Se = {
    class: `text-lg font-semibold text-gray-900 dark:text-gray-300 mb-1`,
  },
  eCe = {
    class: `text-sm text-gray-600 dark:text-gray-400`,
  },
  tCe = {
    class: `mb-4`,
  },
  nCe = {
    class: `relative`,
  },
  rCe = [`placeholder`],
  iCe = [`title`],
  aCe = {
    class: `space-y-2`,
  },
  oCe = [`onDragstart`],
  sCe = {
    class: `flex items-center gap-3`,
  },
  cCe = {
    class: `w-12 h-12 rounded-full overflow-hidden bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center relative`,
  },
  lCe = [`src`, `alt`],
  uCe = {
    key: 1,
    class: `w-full h-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold`,
  },
  dCe = {
    class: `flex-1`,
  },
  fCe = {
    class: `font-medium text-gray-900 dark:text-gray-300 group-hover:text-primary dark:group-hover:text-gray-500`,
  },
  pCe = {
    class: `text-gray-600 dark:text-gray-400 group-hover:text-dark-primary dark:group-hover:text-dark-600 font-normal`,
  },
  mCe = {
    class: `text-sm text-gray-600 dark:text-gray-400 group-hover:text-dark-primary dark:group-hover:text-dark-600`,
  },
  hCe = {
    class: `flex items-center gap-2`,
  },
  gCe = {
    key: 0,
    class: `bg-orange-100 text-orange-800 text-xs font-medium px-2 py-1 rounded-full`,
  },
  _Ce = {
    class: `mt-6 pt-4 border-t border-gray-200 dark:border-gray-700`,
  },
  vCe = {
    class: `space-y-2 text-xs text-gray-600 dark:text-gray-400`,
  },
  yCe = {
    class: `flex items-center gap-2`,
  },
  bCe = {
    class: `flex items-center gap-2`,
  },
  xCe = {
    class: `flex items-center gap-2`,
  },
  SCe = {
    key: 1,
    class: `px-4`,
  },
  CCe = tu(
    {
      __name: `AssignIncharge`,
      props: {
        config: {
          type: Object,
          required: !0,
          validator: (e) =>
            [
              `entityName`,
              `responseKey`,
              `assignTitle`,
              `entityLabel`,
              `inchargeLabel`,
              `apiActions`,
              `entityNameField`,
            ].every((t) => e.hasOwnProperty(t)),
        },
        batchInput: {
          type: Boolean,
          default: !1,
        },
      },
      setup(e, { expose: t }) {
        let n = e,
          r = Dc(),
          i = Ec(),
          a = $e(),
          o = u(),
          s = R(`$trans`),
          c = R(`moment`),
          { screenSize: l } = M9(),
          d = Ae({
            entities: [],
            employees: [],
            date: null,
            batch: ``,
            selectedBatch: null,
          }),
          f = F([]),
          p = F([]),
          m = F(!1),
          h = F(!1),
          g = F(!0),
          v = F(null),
          y = F(null),
          b = F(0),
          x = F(``),
          S = F(``),
          C = V(() => {
            let e = d.entities;
            if (x.value.trim()) {
              let t = x.value.toLowerCase();
              e = e.filter((e) => E(e).toLowerCase().includes(t));
            }
            return (
              m.value &&
                (e = e.filter((e) => {
                  let t = (e.incharges?.length || 0) > 0,
                    n = D(e.uuid).length > 0;
                  return !t && !n;
                })),
              e
            );
          }),
          w = V(() => {
            let e = d.employees;
            if (S.value.trim()) {
              let t = S.value.toLowerCase();
              e = e.filter(
                (e) =>
                  e.name.toLowerCase().includes(t) ||
                  e.codeNumber.toLowerCase().includes(t) ||
                  (e.departmentName && e.departmentName.toLowerCase().includes(t)) ||
                  (e.designationName && e.designationName.toLowerCase().includes(t)),
              );
            }
            return (h.value && (e = e.filter((e) => ee(e.uuid) === 0)), e);
          }),
          E = (e) => e[n.config.entityNameField] || e.name || `Unknown`,
          D = (e) => f.value.filter((t) => t.entityUuid === e),
          ee = (e) =>
            d.entities.reduce(
              (t, n) =>
                t + (n.incharges || []).filter((t) => t.employee && t.employee.uuid === e).length,
              0,
            ) + f.value.filter((t) => t.employee && t.employee.uuid === e).length,
          te = () => {
            m.value = !m.value;
          },
          k = () => {
            h.value = !h.value;
          },
          ne = (e) => {
            ((d.batch = e.uuid), le());
          },
          re = () => {
            (console.log(`Batch removed`), (d.batch = ``), le());
          },
          ie = () => {
            (console.log(`Batch cleared`), (d.batch = ``), le());
          },
          oe = async () => {
            (i.push({
              name: r.name,
              query: {
                date: d.date,
              },
            }),
              le());
          },
          se = async () => {
            if (!(await ub())) return;
            let e = {
              form: {
                ...(n.config.showDatePicker && {
                  date: d.date,
                  batch: d.batch,
                }),
                newIncharge: f.value,
                removedIncharge: p.value,
              },
            };
            await a
              .dispatch(n.config.apiActions.assign, e)
              .then(async () => {
                ((g.value = !1), await le(), (f.value = []), (p.value = []));
              })
              .catch(() => {
                g.value = !1;
              });
          },
          ce = async () => {
            (await ub()) && (await le(), (f.value = []), (p.value = []));
          },
          le = async () => {
            await a
              .dispatch(n.config.apiActions.fetchData, {
                date: d.date,
                batch: d.batch,
              })
              .then((e) => {
                ((g.value = !1),
                  (d.entities = e[n.config.responseKey] || []),
                  (d.employees = e.employees),
                  (d.date = e.date));
              })
              .catch(() => {
                g.value = !1;
              });
          },
          ue = (e, t) => {
            ((v.value = t),
              (e.dataTransfer.effectAllowed = `copy`),
              e.dataTransfer.setData(`employee`, JSON.stringify(t)));
          },
          de = () => {
            ((v.value = null), (y.value = null), (b.value = 0));
          },
          fe = (e) => {
            (e.preventDefault(), (e.dataTransfer.dropEffect = `copy`));
          },
          pe = (e, t) => {
            (e.preventDefault(), b.value++, (y.value = t));
          },
          me = () => {
            (b.value--, b.value === 0 && (y.value = null));
          },
          he = (e, t) => {
            (e.preventDefault(), (b.value = 0), (y.value = null));
            let n = JSON.parse(e.dataTransfer.getData(`employee`));
            if (!n) return;
            t.incharges ||= [];
            let r = t.incharges.some((e) => e.employee && e.employee.uuid === n.uuid),
              i = f.value.some((e) => e.entityUuid === t.uuid && e.employee.uuid === n.uuid);
            if (r || i) {
              o.error(s(`incharge.already_assigned`));
              return;
            }
            (f.value.push({
              uuid: tq(),
              entityUuid: t.uuid,
              employee: {
                uuid: n.uuid,
                name: n.name,
                codeNumber: n.codeNumber,
                photo: n.photo,
                departmentName: n.departmentName,
                designationName: n.designationName,
              },
            }),
              (v.value = null));
          },
          ge = async (e, t) => {
            if ((await ub()) && e.incharges && Array.isArray(e.incharges)) {
              let n = e.incharges.find((e) => e.uuid === t);
              ((e.incharges = e.incharges.filter((e) => e.uuid !== t)),
                p.value.push({
                  uuid: t,
                  employee: {
                    uuid: n?.employee?.uuid,
                  },
                  entityUuid: e.uuid,
                }));
            }
          },
          _e = async (e) => {
            (await ub()) && (f.value = f.value.filter((t) => t.uuid !== e));
          },
          ye = (e) => {
            e.target.style.display = `none`;
            let t = e.target.nextElementSibling;
            t && (t.style.display = `flex`);
          },
          be = () => {
            x.value = ``;
          },
          xe = () => {
            S.value = ``;
          };
        return (
          Qe(async () => {
            d.date = c().format(`YYYY-MM-DD`);
          }),
          t({
            newIncharges: f,
            removedIncharges: p,
            state: d,
          }),
          (t, n) => {
            let r = j(`BaseSelectSearch`),
              i = j(`DatePicker`),
              a = j(`BaseButton`),
              o = j(`BaseFieldset`),
              c = j(`BaseAlert`),
              u = j(`BaseLoader`),
              f = ve(`tooltip`);
            return (
              A(),
              L(
                u,
                {
                  "is-loading": g.value,
                },
                {
                  default: I(() => [
                    P(l).small
                      ? (A(),
                        M(`div`, SCe, [
                          N(
                            c,
                            {
                              size: `xs`,
                              design: `error`,
                            },
                            {
                              default: I(() => [
                                H(T(P(s)(`academic.incharge.unsupported_screen_size`)), 1),
                              ]),
                              _: 1,
                            },
                          ),
                        ]))
                      : (A(),
                        M(`div`, eSe, [
                          W(`div`, tSe, [
                            W(`div`, nSe, [
                              W(`div`, null, [W(`h1`, rSe, T(e.config.assignTitle), 1)]),
                              W(`div`, iSe, [
                                e.batchInput
                                  ? (A(),
                                    M(`div`, aSe, [
                                      N(
                                        r,
                                        {
                                          name: `batch`,
                                          placeholder: P(s)(`academic.batch.batch`),
                                          modelValue: d.selectedBatch,
                                          "onUpdate:modelValue": (n[0] ||= (e) =>
                                            (d.selectedBatch = e)),
                                          "value-prop": `uuid`,
                                          "object-prop": !0,
                                          "search-key": `course_batch`,
                                          "search-action": `academic/batch/list`,
                                          onSelected: ne,
                                          onRemoved: re,
                                          onCleared: ie,
                                        },
                                        {
                                          selectedOption: I((e) => [
                                            H(T(e.value.course.name) + ` - ` + T(e.value.name), 1),
                                          ]),
                                          listOption: I((e) => [
                                            H(
                                              T(e.option.course.nameWithTerm) +
                                                ` - ` +
                                                T(e.option.name),
                                              1,
                                            ),
                                          ]),
                                          _: 1,
                                        },
                                        8,
                                        [`placeholder`, `modelValue`],
                                      ),
                                    ]))
                                  : U(``, !0),
                                e.config.showDatePicker
                                  ? (A(),
                                    L(
                                      i,
                                      {
                                        key: 1,
                                        slim: ``,
                                        modelValue: d.date,
                                        "onUpdate:modelValue": (n[1] ||= (e) => (d.date = e)),
                                        name: `date`,
                                        "no-clear": ``,
                                        onChange: oe,
                                      },
                                      null,
                                      8,
                                      [`modelValue`],
                                    ))
                                  : U(``, !0),
                                N(
                                  a,
                                  {
                                    design: `success`,
                                    onClick: se,
                                  },
                                  {
                                    default: I(() => [H(T(P(s)(`general.assign`)), 1)]),
                                    _: 1,
                                  },
                                ),
                                N(
                                  a,
                                  {
                                    design: `danger`,
                                    onClick: ce,
                                  },
                                  {
                                    default: I(() => [H(T(P(s)(`general.reset`)), 1)]),
                                    _: 1,
                                  },
                                ),
                              ]),
                            ]),
                          ]),
                          W(`div`, oSe, [
                            W(`div`, sSe, [
                              W(`div`, cSe, [
                                W(`div`, lSe, [
                                  W(`div`, null, [
                                    W(`h2`, uSe, [
                                      H(T(e.config.entityLabel) + ` `, 1),
                                      d.selectedBatch?.uuid
                                        ? (A(),
                                          M(
                                            `span`,
                                            dSe,
                                            T(d.selectedBatch.course.name) +
                                              ` - ` +
                                              T(d.selectedBatch.name),
                                            1,
                                          ))
                                        : U(``, !0),
                                    ]),
                                    W(`p`, fSe, T(e.config.dragDropInfo), 1),
                                  ]),
                                  W(`div`, null, [
                                    W(
                                      `span`,
                                      {
                                        onClick: te,
                                        class: `cursor-pointer`,
                                      },
                                      [
                                        Re(
                                          W(
                                            `i`,
                                            {
                                              class: O([
                                                `fas dark:text-gray-400`,
                                                m.value ? `fa-eye-slash` : `fa-eye`,
                                              ]),
                                            },
                                            null,
                                            2,
                                          ),
                                          [
                                            [
                                              f,
                                              P(s)(
                                                m.value
                                                  ? `incharge.without_incharge`
                                                  : `incharge.with_incharge`,
                                                {
                                                  attribute: e.config.entityLabel,
                                                },
                                              ),
                                            ],
                                          ],
                                        ),
                                      ],
                                    ),
                                  ]),
                                ]),
                                W(`div`, pSe, [
                                  W(`div`, mSe, [
                                    (n[7] ||= W(
                                      `i`,
                                      {
                                        class: `fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400`,
                                      },
                                      null,
                                      -1,
                                    )),
                                    Re(
                                      W(
                                        `input`,
                                        {
                                          "onUpdate:modelValue": (n[2] ||= (e) => (x.value = e)),
                                          type: `text`,
                                          placeholder: P(s)(`global.search`, {
                                            attribute: e.config.entityLabel,
                                          }),
                                          class: `w-full pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-700 rounded-lg bg-inherit focus:ring-2 focus:ring-primary dark:focus:ring-gray-500 dark:text-gray-200`,
                                        },
                                        null,
                                        8,
                                        hSe,
                                      ),
                                      [[we, x.value]],
                                    ),
                                    x.value
                                      ? (A(),
                                        M(
                                          `button`,
                                          {
                                            key: 0,
                                            onClick: be,
                                            class: `absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors`,
                                            title: P(s)(`global.clear`, {
                                              attribute: e.config.entityLabel,
                                            }),
                                          },
                                          [
                                            ...(n[6] ||= [
                                              W(
                                                `i`,
                                                {
                                                  class: `fas fa-times`,
                                                },
                                                null,
                                                -1,
                                              ),
                                            ]),
                                          ],
                                          8,
                                          gSe,
                                        ))
                                      : U(``, !0),
                                  ]),
                                ]),
                                C.value.length
                                  ? (A(),
                                    M(`div`, _Se, [
                                      (A(!0),
                                      M(
                                        ke,
                                        null,
                                        ae(
                                          C.value,
                                          (t) => (
                                            A(),
                                            L(
                                              o,
                                              {
                                                key: t.uuid,
                                                class: `border border-gray-200 rounded-lg bg-gray-50 dark:bg-dark-body`,
                                              },
                                              {
                                                legend: I(() => [H(T(E(t)), 1)]),
                                                default: I(() => [
                                                  W(`div`, vSe, [
                                                    W(`div`, ySe, [
                                                      (t.incharges?.length || 0) > 0
                                                        ? (A(),
                                                          M(`div`, bSe, [
                                                            W(`h4`, xSe, [
                                                              (n[8] ||= W(
                                                                `span`,
                                                                {
                                                                  class: `w-2 h-2 bg-green-500 rounded-full`,
                                                                },
                                                                null,
                                                                -1,
                                                              )),
                                                              H(
                                                                ` ` +
                                                                  T(
                                                                    P(s)(`global.current`, {
                                                                      attribute:
                                                                        e.config.inchargeLabel,
                                                                    }),
                                                                  ),
                                                                1,
                                                              ),
                                                            ]),
                                                            W(`div`, SSe, [
                                                              N(
                                                                je,
                                                                {
                                                                  name: `slide`,
                                                                  tag: `div`,
                                                                },
                                                                {
                                                                  default: I(() => [
                                                                    (A(!0),
                                                                    M(
                                                                      ke,
                                                                      null,
                                                                      ae(
                                                                        t.incharges || [],
                                                                        (r) => (
                                                                          A(),
                                                                          M(
                                                                            `div`,
                                                                            {
                                                                              key: r.uuid,
                                                                              class: `bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-900 rounded-lg p-3 flex items-center justify-between group`,
                                                                            },
                                                                            [
                                                                              W(`div`, CSe, [
                                                                                W(`div`, wSe, [
                                                                                  r.employee?.photo
                                                                                    ? (A(),
                                                                                      M(
                                                                                        `img`,
                                                                                        {
                                                                                          key: 0,
                                                                                          src: r
                                                                                            .employee
                                                                                            .photo,
                                                                                          alt:
                                                                                            r
                                                                                              .employee
                                                                                              ?.name ||
                                                                                            `Employee`,
                                                                                          class: `w-full h-full object-cover`,
                                                                                          onError:
                                                                                            (n[3] ||=
                                                                                              (
                                                                                                ...e
                                                                                              ) =>
                                                                                                ye &&
                                                                                                ye(
                                                                                                  ...e,
                                                                                                )),
                                                                                        },
                                                                                        null,
                                                                                        40,
                                                                                        TSe,
                                                                                      ))
                                                                                    : (A(),
                                                                                      M(
                                                                                        `div`,
                                                                                        ESe,
                                                                                        T(
                                                                                          (
                                                                                            r
                                                                                              .employee
                                                                                              ?.name ||
                                                                                            `U`
                                                                                          ).charAt(
                                                                                            0,
                                                                                          ),
                                                                                        ),
                                                                                        1,
                                                                                      )),
                                                                                ]),
                                                                                W(`div`, DSe, [
                                                                                  W(`div`, OSe, [
                                                                                    H(
                                                                                      T(
                                                                                        r.employee
                                                                                          ?.name ||
                                                                                          `Unknown`,
                                                                                      ) + ` `,
                                                                                      1,
                                                                                    ),
                                                                                    W(
                                                                                      `span`,
                                                                                      kSe,
                                                                                      ` (` +
                                                                                        T(
                                                                                          r.employee
                                                                                            ?.codeNumber ||
                                                                                            `N/A`,
                                                                                        ) +
                                                                                        `) `,
                                                                                      1,
                                                                                    ),
                                                                                  ]),
                                                                                  e.config
                                                                                    .showDatePicker
                                                                                    ? (A(),
                                                                                      M(
                                                                                        `div`,
                                                                                        ASe,
                                                                                        [
                                                                                          H(
                                                                                            T(
                                                                                              r.date
                                                                                                ?.formatted ||
                                                                                                `No date`,
                                                                                            ) + ` `,
                                                                                            1,
                                                                                          ),
                                                                                          r.endDate
                                                                                            .value
                                                                                            ? (A(),
                                                                                              M(
                                                                                                `span`,
                                                                                                jSe,
                                                                                                ` - ` +
                                                                                                  T(
                                                                                                    r
                                                                                                      .endDate
                                                                                                      .formatted,
                                                                                                  ),
                                                                                                1,
                                                                                              ))
                                                                                            : U(
                                                                                                ``,
                                                                                                !0,
                                                                                              ),
                                                                                        ],
                                                                                      ))
                                                                                    : U(``, !0),
                                                                                  W(
                                                                                    `div`,
                                                                                    MSe,
                                                                                    T(
                                                                                      r.employee
                                                                                        ?.departmentName ||
                                                                                        `N/A`,
                                                                                    ) +
                                                                                      ` - ` +
                                                                                      T(
                                                                                        r.employee
                                                                                          ?.designationName ||
                                                                                          `N/A`,
                                                                                      ),
                                                                                    1,
                                                                                  ),
                                                                                ]),
                                                                              ]),
                                                                              W(
                                                                                `button`,
                                                                                {
                                                                                  onClick: (e) =>
                                                                                    ge(t, r.uuid),
                                                                                  class: `cursor-pointer opacity-0 group-hover:opacity-100 transition-all`,
                                                                                },
                                                                                [
                                                                                  ...(n[9] ||= [
                                                                                    W(
                                                                                      `i`,
                                                                                      {
                                                                                        class: `fas fa-trash text-danger`,
                                                                                      },
                                                                                      null,
                                                                                      -1,
                                                                                    ),
                                                                                  ]),
                                                                                ],
                                                                                8,
                                                                                NSe,
                                                                              ),
                                                                            ],
                                                                          )
                                                                        ),
                                                                      ),
                                                                      128,
                                                                    )),
                                                                  ]),
                                                                  _: 2,
                                                                },
                                                                1024,
                                                              ),
                                                            ]),
                                                          ]))
                                                        : U(``, !0),
                                                      D(t.uuid).length > 0
                                                        ? (A(),
                                                          M(`div`, PSe, [
                                                            W(`h4`, FSe, [
                                                              (n[10] ||= W(
                                                                `span`,
                                                                {
                                                                  class: `w-2 h-2 bg-blue-500 rounded-full animate-pulse`,
                                                                },
                                                                null,
                                                                -1,
                                                              )),
                                                              H(
                                                                ` ` +
                                                                  T(
                                                                    P(s)(`global.new`, {
                                                                      attribute:
                                                                        e.config.inchargeLabel,
                                                                    }),
                                                                  ),
                                                                1,
                                                              ),
                                                            ]),
                                                            W(`div`, ISe, [
                                                              N(
                                                                je,
                                                                {
                                                                  name: `slide`,
                                                                  tag: `div`,
                                                                },
                                                                {
                                                                  default: I(() => [
                                                                    (A(!0),
                                                                    M(
                                                                      ke,
                                                                      null,
                                                                      ae(
                                                                        D(t.uuid),
                                                                        (e) => (
                                                                          A(),
                                                                          M(
                                                                            `div`,
                                                                            {
                                                                              key: e.uuid,
                                                                              class: `bg-blue-50 dark:bg-blue-950 border border-blue-200 dark:border-blue-900 rounded-lg p-3 flex items-center justify-between group`,
                                                                            },
                                                                            [
                                                                              W(`div`, LSe, [
                                                                                W(`div`, RSe, [
                                                                                  e.employee?.photo
                                                                                    ? (A(),
                                                                                      M(
                                                                                        `img`,
                                                                                        {
                                                                                          key: 0,
                                                                                          src: e
                                                                                            .employee
                                                                                            .photo,
                                                                                          alt:
                                                                                            e
                                                                                              .employee
                                                                                              ?.name ||
                                                                                            `Employee`,
                                                                                          class: `w-full h-full object-cover`,
                                                                                          onError:
                                                                                            (n[4] ||=
                                                                                              (
                                                                                                ...e
                                                                                              ) =>
                                                                                                ye &&
                                                                                                ye(
                                                                                                  ...e,
                                                                                                )),
                                                                                        },
                                                                                        null,
                                                                                        40,
                                                                                        zSe,
                                                                                      ))
                                                                                    : (A(),
                                                                                      M(
                                                                                        `div`,
                                                                                        BSe,
                                                                                        T(
                                                                                          e.employee.name.charAt(
                                                                                            0,
                                                                                          ),
                                                                                        ),
                                                                                        1,
                                                                                      )),
                                                                                ]),
                                                                                W(`div`, VSe, [
                                                                                  W(`div`, HSe, [
                                                                                    H(
                                                                                      T(
                                                                                        e.employee
                                                                                          .name,
                                                                                      ) + ` `,
                                                                                      1,
                                                                                    ),
                                                                                    W(
                                                                                      `span`,
                                                                                      USe,
                                                                                      ` (` +
                                                                                        T(
                                                                                          e.employee
                                                                                            .codeNumber,
                                                                                        ) +
                                                                                        `) `,
                                                                                      1,
                                                                                    ),
                                                                                  ]),
                                                                                  W(
                                                                                    `div`,
                                                                                    WSe,
                                                                                    T(
                                                                                      e.employee
                                                                                        ?.departmentName ||
                                                                                        `N/A`,
                                                                                    ) +
                                                                                      ` - ` +
                                                                                      T(
                                                                                        e.employee
                                                                                          ?.designationName ||
                                                                                          `N/A`,
                                                                                      ),
                                                                                    1,
                                                                                  ),
                                                                                ]),
                                                                              ]),
                                                                              W(
                                                                                `button`,
                                                                                {
                                                                                  onClick: (t) =>
                                                                                    _e(e.uuid),
                                                                                  class: `cursor-pointer opacity-0 group-hover:opacity-100 transition-all`,
                                                                                },
                                                                                [
                                                                                  ...(n[11] ||= [
                                                                                    W(
                                                                                      `i`,
                                                                                      {
                                                                                        class: `fas fa-trash text-danger`,
                                                                                      },
                                                                                      null,
                                                                                      -1,
                                                                                    ),
                                                                                  ]),
                                                                                ],
                                                                                8,
                                                                                GSe,
                                                                              ),
                                                                            ],
                                                                          )
                                                                        ),
                                                                      ),
                                                                      128,
                                                                    )),
                                                                  ]),
                                                                  _: 2,
                                                                },
                                                                1024,
                                                              ),
                                                            ]),
                                                          ]))
                                                        : U(``, !0),
                                                    ]),
                                                    W(
                                                      `div`,
                                                      {
                                                        onDragover: fe,
                                                        onDragenter: (e) => pe(e, t.uuid),
                                                        onDragleave: (e) => me(e, t.uuid),
                                                        onDrop: (e) => he(e, t),
                                                        class: O([
                                                          `min-h-[100px] border-2 border-dashed rounded-lg flex items-center justify-center transition-all duration-200 w-1/2`,
                                                          y.value === t.uuid && v.value
                                                            ? `border-blue-400 dark:border-blue-600 bg-blue-50 dark:bg-blue-950 shadow-inner`
                                                            : `border-gray-300 dark:border-gray-700 bg-white dark:bg-dark-body hover:border-gray-400 hover:bg-gray-50`,
                                                        ]),
                                                      },
                                                      [
                                                        W(`div`, qSe, [
                                                          (A(),
                                                          M(
                                                            `svg`,
                                                            {
                                                              class: O([
                                                                `w-8 h-8 mx-auto mb-2`,
                                                                y.value === t.uuid && v.value
                                                                  ? `text-blue-500`
                                                                  : `text-gray-400`,
                                                              ]),
                                                              fill: `none`,
                                                              stroke: `currentColor`,
                                                              viewBox: `0 0 24 24`,
                                                            },
                                                            [
                                                              W(
                                                                `path`,
                                                                {
                                                                  "stroke-linecap": `round`,
                                                                  "stroke-linejoin": `round`,
                                                                  "stroke-width": `2`,
                                                                  d:
                                                                    y.value === t.uuid && v.value
                                                                      ? `M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z`
                                                                      : `M12 6v6m0 0v6m0-6h6m-6 0H6`,
                                                                },
                                                                null,
                                                                8,
                                                                JSe,
                                                              ),
                                                            ],
                                                            2,
                                                          )),
                                                          W(
                                                            `p`,
                                                            {
                                                              class: O([
                                                                `text-sm font-medium`,
                                                                y.value === t.uuid && v.value
                                                                  ? `text-blue-600`
                                                                  : `text-gray-500`,
                                                              ]),
                                                            },
                                                            T(
                                                              y.value === t.uuid && v.value
                                                                ? e.config.releaseInfo
                                                                : e.config.dropInfo,
                                                            ),
                                                            3,
                                                          ),
                                                          W(`p`, YSe, T(e.config.dragFromInfo), 1),
                                                        ]),
                                                      ],
                                                      42,
                                                      KSe,
                                                    ),
                                                  ]),
                                                ]),
                                                _: 2,
                                              },
                                              1024,
                                            )
                                          ),
                                        ),
                                        128,
                                      )),
                                    ]))
                                  : U(``, !0),
                                C.value.length == 0
                                  ? (A(),
                                    L(
                                      c,
                                      {
                                        key: 1,
                                        class: `mt-4`,
                                        size: `xs`,
                                        design: `info`,
                                      },
                                      {
                                        default: I(() => [
                                          H(T(P(s)(`general.errors.record_not_found`)), 1),
                                        ]),
                                        _: 1,
                                      },
                                    ))
                                  : U(``, !0),
                              ]),
                            ]),
                            W(`div`, XSe, [
                              W(`div`, ZSe, [
                                W(`div`, QSe, [
                                  W(`div`, null, [
                                    W(`h2`, $Se, T(P(s)(`employee.employee`)), 1),
                                    W(`p`, eCe, T(e.config.employeeDragInfo), 1),
                                  ]),
                                  W(`div`, null, [
                                    W(
                                      `span`,
                                      {
                                        onClick: k,
                                        class: `cursor-pointer`,
                                      },
                                      [
                                        Re(
                                          W(
                                            `i`,
                                            {
                                              class: O([
                                                `fas dark:text-gray-400`,
                                                h.value ? `fa-eye-slash` : `fa-eye`,
                                              ]),
                                            },
                                            null,
                                            2,
                                          ),
                                          [
                                            [
                                              f,
                                              P(s)(
                                                h.value
                                                  ? `incharge.without_incharge`
                                                  : `incharge.with_incharge`,
                                                {
                                                  attribute: P(s)(`employee.employee`),
                                                },
                                              ),
                                            ],
                                          ],
                                        ),
                                      ],
                                    ),
                                  ]),
                                ]),
                                W(`div`, tCe, [
                                  W(`div`, nCe, [
                                    (n[13] ||= W(
                                      `i`,
                                      {
                                        class: `fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400`,
                                      },
                                      null,
                                      -1,
                                    )),
                                    Re(
                                      W(
                                        `input`,
                                        {
                                          "onUpdate:modelValue": (n[5] ||= (e) => (S.value = e)),
                                          type: `text`,
                                          placeholder: P(s)(`global.search`, {
                                            attribute: P(s)(`employee.employee`),
                                          }),
                                          class: `w-full pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-700 rounded-lg bg-inherit focus:ring-2 focus:ring-primary dark:focus:ring-gray-500 dark:text-gray-200`,
                                        },
                                        null,
                                        8,
                                        rCe,
                                      ),
                                      [[we, S.value]],
                                    ),
                                    S.value
                                      ? (A(),
                                        M(
                                          `button`,
                                          {
                                            key: 0,
                                            onClick: xe,
                                            class: `absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors`,
                                            title: P(s)(`global.clear`, {
                                              attribute: P(s)(`employee.employee`),
                                            }),
                                          },
                                          [
                                            ...(n[12] ||= [
                                              W(
                                                `i`,
                                                {
                                                  class: `fas fa-times`,
                                                },
                                                null,
                                                -1,
                                              ),
                                            ]),
                                          ],
                                          8,
                                          iCe,
                                        ))
                                      : U(``, !0),
                                  ]),
                                ]),
                                W(`div`, aCe, [
                                  (A(!0),
                                  M(
                                    ke,
                                    null,
                                    ae(
                                      w.value,
                                      (e) => (
                                        A(),
                                        M(
                                          `div`,
                                          {
                                            key: e.uuid,
                                            draggable: !0,
                                            onDragstart: (t) => ue(t, e),
                                            onDragend: de,
                                            class: O([
                                              `bg-gray-50 dark:bg-dark-body border border-gray-200 dark:border-gray-700 rounded-lg p-3 cursor-grab hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 group`,
                                              {
                                                "opacity-60 scale-95": v.value?.uuid === e.uuid,
                                              },
                                            ]),
                                          },
                                          [
                                            W(`div`, sCe, [
                                              W(`div`, cCe, [
                                                e.photo
                                                  ? (A(),
                                                    M(
                                                      `img`,
                                                      {
                                                        key: 0,
                                                        src: e.photo,
                                                        alt: e.name,
                                                        class: `w-full h-full object-cover`,
                                                        onError: ye,
                                                      },
                                                      null,
                                                      40,
                                                      lCe,
                                                    ))
                                                  : (A(), M(`div`, uCe, T(e.name.charAt(0)), 1)),
                                              ]),
                                              W(`div`, dCe, [
                                                W(`div`, fCe, [
                                                  H(T(e.name) + ` `, 1),
                                                  W(`span`, pCe, ` (` + T(e.codeNumber) + `) `, 1),
                                                ]),
                                                W(
                                                  `div`,
                                                  mCe,
                                                  T(e.departmentName || `N/A`) +
                                                    ` - ` +
                                                    T(e.designationName || `N/A`),
                                                  1,
                                                ),
                                              ]),
                                              W(`div`, hCe, [
                                                ee(e.uuid) > 0
                                                  ? (A(), M(`span`, gCe, T(ee(e.uuid)), 1))
                                                  : U(``, !0),
                                                (n[14] ||= W(
                                                  `svg`,
                                                  {
                                                    class: `w-4 h-4 text-gray-400 group-hover:text-blue-500`,
                                                    fill: `none`,
                                                    stroke: `currentColor`,
                                                    viewBox: `0 0 24 24`,
                                                  },
                                                  [
                                                    W(`path`, {
                                                      "stroke-linecap": `round`,
                                                      "stroke-linejoin": `round`,
                                                      "stroke-width": `2`,
                                                      d: `M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4`,
                                                    }),
                                                  ],
                                                  -1,
                                                )),
                                              ]),
                                            ]),
                                          ],
                                          42,
                                          oCe,
                                        )
                                      ),
                                    ),
                                    128,
                                  )),
                                ]),
                                W(`div`, _Ce, [
                                  W(`div`, vCe, [
                                    W(`div`, yCe, [
                                      (n[15] ||= W(
                                        `span`,
                                        {
                                          class: `w-2 h-2 bg-green-500 rounded-full`,
                                        },
                                        null,
                                        -1,
                                      )),
                                      W(
                                        `span`,
                                        null,
                                        T(
                                          P(s)(`global.current`, {
                                            attribute: e.config.inchargeLabel,
                                          }),
                                        ),
                                        1,
                                      ),
                                    ]),
                                    W(`div`, bCe, [
                                      (n[16] ||= W(
                                        `span`,
                                        {
                                          class: `w-2 h-2 bg-blue-500 rounded-full`,
                                        },
                                        null,
                                        -1,
                                      )),
                                      W(
                                        `span`,
                                        null,
                                        T(
                                          P(s)(`global.new`, {
                                            attribute: e.config.inchargeLabel,
                                          }),
                                        ),
                                        1,
                                      ),
                                    ]),
                                    W(`div`, xCe, [
                                      (n[17] ||= W(
                                        `span`,
                                        {
                                          class: `bg-orange-100 text-orange-800 px-2 py-0.5 rounded-full font-medium`,
                                        },
                                        `2`,
                                        -1,
                                      )),
                                      W(
                                        `span`,
                                        null,
                                        T(
                                          P(s)(`global.count`, {
                                            attribute: e.config.inchargeLabel,
                                          }),
                                        ),
                                        1,
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                        ])),
                  ]),
                  _: 1,
                },
                8,
                [`is-loading`],
              )
            );
          }
        );
      },
    },
    [[`__scopeId`, `data-v-07aa72ee`]],
  ),
  wCe = (e) => {
    (e.component(`GuestHeader`, Khe),
      e.component(`PageHeader`, cge),
      e.component(`PageHeaderAction`, mge),
      e.component(`ProfileDropdown`, Oge),
      e.component(`AppNavigation`, Ige),
      e.component(`MobileSidebar`, Kge),
      e.component(`FooterCredit`, Zge),
      e.component(`ConfigPage`, t_e),
      e.component(`ConfigSidebar`, a_e),
      e.component(`ModuleConfig`, u_e),
      e.component(`ModuleConfigSidebar`, p_e),
      e.component(`FormActionButton`, g_e),
      e.component(`ShowButton`, y_e),
      e.component(`CardHeader`, S_e),
      e.component(`ErrorPage`, k_e),
      e.component(`ReLogin`, j_e),
      e.component(`KeySearch`, dve),
      e.component(`NotificationList`, Rve),
      e.component(`UserScope`, Jve),
      e.component(`ParentTransition`, Yve),
      e.component(`ChildTransition`, Xve),
      e.component(`MenuParentTransition`, Zve),
      e.component(`CustomField`, eye),
      e.component(`ReminderInput`, oye),
      e.component(`TeamSelection`, dye),
      e.component(`PeriodSelection`, vye),
      e.component(`SessionWisePeriodSelection`, Eye),
      e.component(`TimesheetClock`, zye),
      e.component(`StudentTimesheetClock`, Zye),
      e.component(`NameInput`, Qye),
      e.component(`AddressInput`, obe),
      e.component(`PaymentMethodInput`, mbe),
      e.component(`PaymentMethodDetail`, Ebe),
      e.component(`LedgerBalance`, kbe),
      e.component(`AudienceInput`, Rbe),
      e.component(`MarkdownContent`, Oxe),
      e.component(`PostReactions`, Ixe),
      e.component(`ViewLog`, Gxe),
      e.component(`EmployeeSummary`, $xe),
      e.component(`AssignIncharge`, CCe));
  };
B();
var $9 = be({});
($9.use(Ql), $9.use(x), Uhe($9), wCe($9), $9.mount(`#root`), yte());
export {
  $m as A,
  Hh as C,
  Wh as D,
  Uh as E,
  jp as F,
  Su as I,
  tu as L,
  Vne as M,
  zne as N,
  Qm as O,
  Bne as P,
  Dc as R,
  Gh as S,
  Bh as T,
  Uy as _,
  kX as a,
  zy as b,
  ZH as c,
  uI as d,
  dI as f,
  lb as g,
  db as h,
  C6 as i,
  Xm as j,
  Zm as k,
  lH as l,
  ub as m,
  M9 as n,
  Mq as o,
  xL as p,
  A9 as r,
  tq as s,
  L9 as t,
  dV as u,
  Vy as v,
  Vh as w,
  Kh as x,
  By as y,
  Ec as z,
};
